
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8050"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8050"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ir3O", function(module, exports) {
'use strict';

module.exports = (parcelRequire("heqtV"));

});
parcelRegister("heqtV", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $c8b8492f08d9e80d$export$ffb0004e005737fa, (v) => $c8b8492f08d9e80d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $c8b8492f08d9e80d$export$34b9dba7ce09269b, (v) => $c8b8492f08d9e80d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $c8b8492f08d9e80d$export$25062201e9e25d76, (v) => $c8b8492f08d9e80d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c8b8492f08d9e80d$export$ffb0004e005737fa;
var $c8b8492f08d9e80d$export$34b9dba7ce09269b;
var $c8b8492f08d9e80d$export$25062201e9e25d76;
'use strict';

var $2NacA = parcelRequire("2NacA");
var $c8b8492f08d9e80d$var$k = Symbol.for("react.element"), $c8b8492f08d9e80d$var$l = Symbol.for("react.fragment"), $c8b8492f08d9e80d$var$m = Object.prototype.hasOwnProperty, $c8b8492f08d9e80d$var$n = $2NacA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c8b8492f08d9e80d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c8b8492f08d9e80d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c8b8492f08d9e80d$var$m.call(a, b) && !$c8b8492f08d9e80d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c8b8492f08d9e80d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c8b8492f08d9e80d$var$n.current
    };
}
$c8b8492f08d9e80d$export$ffb0004e005737fa = $c8b8492f08d9e80d$var$l;
$c8b8492f08d9e80d$export$34b9dba7ce09269b = $c8b8492f08d9e80d$var$q;
$c8b8492f08d9e80d$export$25062201e9e25d76 = $c8b8492f08d9e80d$var$q;

});
parcelRegister("2NacA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lQPXJ"));

});
parcelRegister("lQPXJ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $fe86c2f75e9f8995$export$dca3b0875bd9a954, (v) => $fe86c2f75e9f8995$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $fe86c2f75e9f8995$export$16fa2f45be04daa8, (v) => $fe86c2f75e9f8995$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $fe86c2f75e9f8995$export$ffb0004e005737fa, (v) => $fe86c2f75e9f8995$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $fe86c2f75e9f8995$export$e2c29f18771995cb, (v) => $fe86c2f75e9f8995$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $fe86c2f75e9f8995$export$221d75b3f55bb0bd, (v) => $fe86c2f75e9f8995$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $fe86c2f75e9f8995$export$5f8d39834fd61797, (v) => $fe86c2f75e9f8995$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $fe86c2f75e9f8995$export$74bf444e3cd11ea5, (v) => $fe86c2f75e9f8995$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $fe86c2f75e9f8995$export$ae55be85d98224ed, (v) => $fe86c2f75e9f8995$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $fe86c2f75e9f8995$export$3ba232387fd5d6dd, (v) => $fe86c2f75e9f8995$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $fe86c2f75e9f8995$export$e530037191fcd5d7, (v) => $fe86c2f75e9f8995$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $fe86c2f75e9f8995$export$fd42f52fd3ae1109, (v) => $fe86c2f75e9f8995$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $fe86c2f75e9f8995$export$c8a8987d4410bf2d, (v) => $fe86c2f75e9f8995$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $fe86c2f75e9f8995$export$d38cd72104c1f0e9, (v) => $fe86c2f75e9f8995$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $fe86c2f75e9f8995$export$7d1e3a5e95ceca43, (v) => $fe86c2f75e9f8995$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $fe86c2f75e9f8995$export$257a8862b851cb5b, (v) => $fe86c2f75e9f8995$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $fe86c2f75e9f8995$export$a8257692ac88316c, (v) => $fe86c2f75e9f8995$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $fe86c2f75e9f8995$export$488013bae63b21da, (v) => $fe86c2f75e9f8995$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $fe86c2f75e9f8995$export$7c73462e0d25e514, (v) => $fe86c2f75e9f8995$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $fe86c2f75e9f8995$export$7568632d0d33d16d, (v) => $fe86c2f75e9f8995$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $fe86c2f75e9f8995$export$88948ce120ea2619, (v) => $fe86c2f75e9f8995$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $fe86c2f75e9f8995$export$35808ee640e87ca7, (v) => $fe86c2f75e9f8995$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $fe86c2f75e9f8995$export$fae74005e78b1a27, (v) => $fe86c2f75e9f8995$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $fe86c2f75e9f8995$export$dc8fbce3eb94dc1e, (v) => $fe86c2f75e9f8995$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $fe86c2f75e9f8995$export$6a7bc4e911dc01cf, (v) => $fe86c2f75e9f8995$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $fe86c2f75e9f8995$export$6d9c69b0de29b591, (v) => $fe86c2f75e9f8995$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $fe86c2f75e9f8995$export$f680877a34711e37, (v) => $fe86c2f75e9f8995$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $fe86c2f75e9f8995$export$d5a552a76deda3c2, (v) => $fe86c2f75e9f8995$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $fe86c2f75e9f8995$export$aaabe4eda9ed9969, (v) => $fe86c2f75e9f8995$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $fe86c2f75e9f8995$export$e5c5a5f917a5871c, (v) => $fe86c2f75e9f8995$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $fe86c2f75e9f8995$export$1538c33de8887b59, (v) => $fe86c2f75e9f8995$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $fe86c2f75e9f8995$export$13e3392192263954, (v) => $fe86c2f75e9f8995$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $fe86c2f75e9f8995$export$b8f5890fc79d6aca, (v) => $fe86c2f75e9f8995$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $fe86c2f75e9f8995$export$60241385465d0a34, (v) => $fe86c2f75e9f8995$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $fe86c2f75e9f8995$export$306c0aa65ff9ec16, (v) => $fe86c2f75e9f8995$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $fe86c2f75e9f8995$export$7b286972b8d8ccbf, (v) => $fe86c2f75e9f8995$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $fe86c2f75e9f8995$export$83d89fbfd8236492, (v) => $fe86c2f75e9f8995$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fe86c2f75e9f8995$export$dca3b0875bd9a954;
var $fe86c2f75e9f8995$export$16fa2f45be04daa8;
var $fe86c2f75e9f8995$export$ffb0004e005737fa;
var $fe86c2f75e9f8995$export$e2c29f18771995cb;
var $fe86c2f75e9f8995$export$221d75b3f55bb0bd;
var $fe86c2f75e9f8995$export$5f8d39834fd61797;
var $fe86c2f75e9f8995$export$74bf444e3cd11ea5;
var $fe86c2f75e9f8995$export$ae55be85d98224ed;
var $fe86c2f75e9f8995$export$3ba232387fd5d6dd;
var $fe86c2f75e9f8995$export$e530037191fcd5d7;
var $fe86c2f75e9f8995$export$fd42f52fd3ae1109;
var $fe86c2f75e9f8995$export$c8a8987d4410bf2d;
var $fe86c2f75e9f8995$export$d38cd72104c1f0e9;
var $fe86c2f75e9f8995$export$7d1e3a5e95ceca43;
var $fe86c2f75e9f8995$export$257a8862b851cb5b;
var $fe86c2f75e9f8995$export$a8257692ac88316c;
var $fe86c2f75e9f8995$export$488013bae63b21da;
var $fe86c2f75e9f8995$export$7c73462e0d25e514;
var $fe86c2f75e9f8995$export$7568632d0d33d16d;
var $fe86c2f75e9f8995$export$88948ce120ea2619;
var $fe86c2f75e9f8995$export$35808ee640e87ca7;
var $fe86c2f75e9f8995$export$fae74005e78b1a27;
var $fe86c2f75e9f8995$export$dc8fbce3eb94dc1e;
var $fe86c2f75e9f8995$export$6a7bc4e911dc01cf;
var $fe86c2f75e9f8995$export$6d9c69b0de29b591;
var $fe86c2f75e9f8995$export$f680877a34711e37;
var $fe86c2f75e9f8995$export$d5a552a76deda3c2;
var $fe86c2f75e9f8995$export$aaabe4eda9ed9969;
var $fe86c2f75e9f8995$export$e5c5a5f917a5871c;
var $fe86c2f75e9f8995$export$1538c33de8887b59;
var $fe86c2f75e9f8995$export$13e3392192263954;
var $fe86c2f75e9f8995$export$b8f5890fc79d6aca;
var $fe86c2f75e9f8995$export$60241385465d0a34;
var $fe86c2f75e9f8995$export$306c0aa65ff9ec16;
var $fe86c2f75e9f8995$export$7b286972b8d8ccbf;
var $fe86c2f75e9f8995$export$83d89fbfd8236492;
'use strict';
var $fe86c2f75e9f8995$var$l = Symbol.for("react.element"), $fe86c2f75e9f8995$var$n = Symbol.for("react.portal"), $fe86c2f75e9f8995$var$p = Symbol.for("react.fragment"), $fe86c2f75e9f8995$var$q = Symbol.for("react.strict_mode"), $fe86c2f75e9f8995$var$r = Symbol.for("react.profiler"), $fe86c2f75e9f8995$var$t = Symbol.for("react.provider"), $fe86c2f75e9f8995$var$u = Symbol.for("react.context"), $fe86c2f75e9f8995$var$v = Symbol.for("react.forward_ref"), $fe86c2f75e9f8995$var$w = Symbol.for("react.suspense"), $fe86c2f75e9f8995$var$x = Symbol.for("react.memo"), $fe86c2f75e9f8995$var$y = Symbol.for("react.lazy"), $fe86c2f75e9f8995$var$z = Symbol.iterator;
function $fe86c2f75e9f8995$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fe86c2f75e9f8995$var$z && a[$fe86c2f75e9f8995$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fe86c2f75e9f8995$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $fe86c2f75e9f8995$var$C = Object.assign, $fe86c2f75e9f8995$var$D = {};
function $fe86c2f75e9f8995$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fe86c2f75e9f8995$var$D;
    this.updater = e || $fe86c2f75e9f8995$var$B;
}
$fe86c2f75e9f8995$var$E.prototype.isReactComponent = {};
$fe86c2f75e9f8995$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$fe86c2f75e9f8995$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $fe86c2f75e9f8995$var$F() {}
$fe86c2f75e9f8995$var$F.prototype = $fe86c2f75e9f8995$var$E.prototype;
function $fe86c2f75e9f8995$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fe86c2f75e9f8995$var$D;
    this.updater = e || $fe86c2f75e9f8995$var$B;
}
var $fe86c2f75e9f8995$var$H = $fe86c2f75e9f8995$var$G.prototype = new $fe86c2f75e9f8995$var$F;
$fe86c2f75e9f8995$var$H.constructor = $fe86c2f75e9f8995$var$G;
$fe86c2f75e9f8995$var$C($fe86c2f75e9f8995$var$H, $fe86c2f75e9f8995$var$E.prototype);
$fe86c2f75e9f8995$var$H.isPureReactComponent = !0;
var $fe86c2f75e9f8995$var$I = Array.isArray, $fe86c2f75e9f8995$var$J = Object.prototype.hasOwnProperty, $fe86c2f75e9f8995$var$K = {
    current: null
}, $fe86c2f75e9f8995$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fe86c2f75e9f8995$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$fe86c2f75e9f8995$var$J.call(b, d) && !$fe86c2f75e9f8995$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $fe86c2f75e9f8995$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $fe86c2f75e9f8995$var$K.current
    };
}
function $fe86c2f75e9f8995$var$N(a, b) {
    return {
        $$typeof: $fe86c2f75e9f8995$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $fe86c2f75e9f8995$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fe86c2f75e9f8995$var$l;
}
function $fe86c2f75e9f8995$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $fe86c2f75e9f8995$var$P = /\/+/g;
function $fe86c2f75e9f8995$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $fe86c2f75e9f8995$var$escape("" + a.key) : b.toString(36);
}
function $fe86c2f75e9f8995$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $fe86c2f75e9f8995$var$l:
                case $fe86c2f75e9f8995$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $fe86c2f75e9f8995$var$Q(h, 0) : d, $fe86c2f75e9f8995$var$I(c) ? (e = "", null != a && (e = a.replace($fe86c2f75e9f8995$var$P, "$&/") + "/"), $fe86c2f75e9f8995$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($fe86c2f75e9f8995$var$O(c) && (c = $fe86c2f75e9f8995$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($fe86c2f75e9f8995$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($fe86c2f75e9f8995$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $fe86c2f75e9f8995$var$Q(k, g);
        h += $fe86c2f75e9f8995$var$R(k, b, e, f, c);
    }
    else if (f = $fe86c2f75e9f8995$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $fe86c2f75e9f8995$var$Q(k, g++), h += $fe86c2f75e9f8995$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $fe86c2f75e9f8995$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $fe86c2f75e9f8995$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $fe86c2f75e9f8995$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $fe86c2f75e9f8995$var$U = {
    current: null
}, $fe86c2f75e9f8995$var$V = {
    transition: null
}, $fe86c2f75e9f8995$var$W = {
    ReactCurrentDispatcher: $fe86c2f75e9f8995$var$U,
    ReactCurrentBatchConfig: $fe86c2f75e9f8995$var$V,
    ReactCurrentOwner: $fe86c2f75e9f8995$var$K
};
function $fe86c2f75e9f8995$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$fe86c2f75e9f8995$export$dca3b0875bd9a954 = {
    map: $fe86c2f75e9f8995$var$S,
    forEach: function(a, b, e) {
        $fe86c2f75e9f8995$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $fe86c2f75e9f8995$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $fe86c2f75e9f8995$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$fe86c2f75e9f8995$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$fe86c2f75e9f8995$export$16fa2f45be04daa8 = $fe86c2f75e9f8995$var$E;
$fe86c2f75e9f8995$export$ffb0004e005737fa = $fe86c2f75e9f8995$var$p;
$fe86c2f75e9f8995$export$e2c29f18771995cb = $fe86c2f75e9f8995$var$r;
$fe86c2f75e9f8995$export$221d75b3f55bb0bd = $fe86c2f75e9f8995$var$G;
$fe86c2f75e9f8995$export$5f8d39834fd61797 = $fe86c2f75e9f8995$var$q;
$fe86c2f75e9f8995$export$74bf444e3cd11ea5 = $fe86c2f75e9f8995$var$w;
$fe86c2f75e9f8995$export$ae55be85d98224ed = $fe86c2f75e9f8995$var$W;
$fe86c2f75e9f8995$export$3ba232387fd5d6dd = $fe86c2f75e9f8995$var$X;
$fe86c2f75e9f8995$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $fe86c2f75e9f8995$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $fe86c2f75e9f8995$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$fe86c2f75e9f8995$var$J.call(b, f) && !$fe86c2f75e9f8995$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $fe86c2f75e9f8995$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$fe86c2f75e9f8995$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $fe86c2f75e9f8995$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $fe86c2f75e9f8995$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$fe86c2f75e9f8995$export$c8a8987d4410bf2d = $fe86c2f75e9f8995$var$M;
$fe86c2f75e9f8995$export$d38cd72104c1f0e9 = function(a) {
    var b = $fe86c2f75e9f8995$var$M.bind(null, a);
    b.type = a;
    return b;
};
$fe86c2f75e9f8995$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$fe86c2f75e9f8995$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $fe86c2f75e9f8995$var$v,
        render: a
    };
};
$fe86c2f75e9f8995$export$a8257692ac88316c = $fe86c2f75e9f8995$var$O;
$fe86c2f75e9f8995$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $fe86c2f75e9f8995$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $fe86c2f75e9f8995$var$T
    };
};
$fe86c2f75e9f8995$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $fe86c2f75e9f8995$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$fe86c2f75e9f8995$export$7568632d0d33d16d = function(a) {
    var b = $fe86c2f75e9f8995$var$V.transition;
    $fe86c2f75e9f8995$var$V.transition = {};
    try {
        a();
    } finally{
        $fe86c2f75e9f8995$var$V.transition = b;
    }
};
$fe86c2f75e9f8995$export$88948ce120ea2619 = $fe86c2f75e9f8995$var$X;
$fe86c2f75e9f8995$export$35808ee640e87ca7 = function(a, b) {
    return $fe86c2f75e9f8995$var$U.current.useCallback(a, b);
};
$fe86c2f75e9f8995$export$fae74005e78b1a27 = function(a) {
    return $fe86c2f75e9f8995$var$U.current.useContext(a);
};
$fe86c2f75e9f8995$export$dc8fbce3eb94dc1e = function() {};
$fe86c2f75e9f8995$export$6a7bc4e911dc01cf = function(a) {
    return $fe86c2f75e9f8995$var$U.current.useDeferredValue(a);
};
$fe86c2f75e9f8995$export$6d9c69b0de29b591 = function(a, b) {
    return $fe86c2f75e9f8995$var$U.current.useEffect(a, b);
};
$fe86c2f75e9f8995$export$f680877a34711e37 = function() {
    return $fe86c2f75e9f8995$var$U.current.useId();
};
$fe86c2f75e9f8995$export$d5a552a76deda3c2 = function(a, b, e) {
    return $fe86c2f75e9f8995$var$U.current.useImperativeHandle(a, b, e);
};
$fe86c2f75e9f8995$export$aaabe4eda9ed9969 = function(a, b) {
    return $fe86c2f75e9f8995$var$U.current.useInsertionEffect(a, b);
};
$fe86c2f75e9f8995$export$e5c5a5f917a5871c = function(a, b) {
    return $fe86c2f75e9f8995$var$U.current.useLayoutEffect(a, b);
};
$fe86c2f75e9f8995$export$1538c33de8887b59 = function(a, b) {
    return $fe86c2f75e9f8995$var$U.current.useMemo(a, b);
};
$fe86c2f75e9f8995$export$13e3392192263954 = function(a, b, e) {
    return $fe86c2f75e9f8995$var$U.current.useReducer(a, b, e);
};
$fe86c2f75e9f8995$export$b8f5890fc79d6aca = function(a) {
    return $fe86c2f75e9f8995$var$U.current.useRef(a);
};
$fe86c2f75e9f8995$export$60241385465d0a34 = function(a) {
    return $fe86c2f75e9f8995$var$U.current.useState(a);
};
$fe86c2f75e9f8995$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $fe86c2f75e9f8995$var$U.current.useSyncExternalStore(a, b, e);
};
$fe86c2f75e9f8995$export$7b286972b8d8ccbf = function() {
    return $fe86c2f75e9f8995$var$U.current.useTransition();
};
$fe86c2f75e9f8995$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("f5efw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isStyledComponent", () => $afb260464bf584fe$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "version", () => $afb260464bf584fe$export$83d89fbfd8236492);
$parcel$export(module.exports, "StyleSheetContext", () => $afb260464bf584fe$export$8c190ef828af4c86);
$parcel$export(module.exports, "StyleSheetConsumer", () => $afb260464bf584fe$export$91317688fc694efa);
$parcel$export(module.exports, "StyleSheetManager", () => $afb260464bf584fe$export$a473771da2f0ff7c);
$parcel$export(module.exports, "css", () => $afb260464bf584fe$export$dbf350e5966cf602);
$parcel$export(module.exports, "ThemeContext", () => $afb260464bf584fe$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeConsumer", () => $afb260464bf584fe$export$b631efc24e9d5e2f);
$parcel$export(module.exports, "ThemeProvider", () => $afb260464bf584fe$export$d8964aec282183a3);
$parcel$export(module.exports, "createGlobalStyle", () => $afb260464bf584fe$export$f0f03736edb61697);
$parcel$export(module.exports, "keyframes", () => $afb260464bf584fe$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ServerStyleSheet", () => $afb260464bf584fe$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "withTheme", () => $afb260464bf584fe$export$e8748c6a27b910dc);
$parcel$export(module.exports, "useTheme", () => $afb260464bf584fe$export$93d4e7f90805808f);
$parcel$export(module.exports, "__PRIVATE__", () => $afb260464bf584fe$export$5c87cfe6c475f500);
$parcel$export(module.exports, "default", () => $afb260464bf584fe$export$2e2bcd8739ae039);

var $fzBYV = parcelRequire("fzBYV");

var $2NacA = parcelRequire("2NacA");

var $6Lq9d = parcelRequire("6Lq9d");

var $ikWeS = parcelRequire("ikWeS");

var $a59m4 = parcelRequire("a59m4");

var $5h15o = parcelRequire("5h15o");

var $6906h = parcelRequire("6906h");
function $afb260464bf584fe$var$v() {
    return ($afb260464bf584fe$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $afb260464bf584fe$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $afb260464bf584fe$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $fzBYV.typeOf)(t);
}, $afb260464bf584fe$var$w = Object.freeze([]), $afb260464bf584fe$var$E = Object.freeze({});
function $afb260464bf584fe$var$b(e) {
    return "function" == typeof e;
}
function $afb260464bf584fe$var$_(e) {
    return e.displayName || e.name || "Component";
}
function $afb260464bf584fe$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $afb260464bf584fe$var$A = "data-styled", $afb260464bf584fe$export$83d89fbfd8236492 = "5.3.10", $afb260464bf584fe$var$I = "undefined" != typeof window && "HTMLElement" in window, $afb260464bf584fe$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $afb260464bf584fe$var$O = {}, $afb260464bf584fe$var$R = {};
function $afb260464bf584fe$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $afb260464bf584fe$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $afb260464bf584fe$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $afb260464bf584fe$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $afb260464bf584fe$var$x = new Map, $afb260464bf584fe$var$k = new Map, $afb260464bf584fe$var$V = 1, $afb260464bf584fe$var$B = function(e) {
    if ($afb260464bf584fe$var$x.has(e)) return $afb260464bf584fe$var$x.get(e);
    for(; $afb260464bf584fe$var$k.has($afb260464bf584fe$var$V);)$afb260464bf584fe$var$V++;
    var t = $afb260464bf584fe$var$V++;
    return $afb260464bf584fe$var$x.set(e, t), $afb260464bf584fe$var$k.set(t, e), t;
}, $afb260464bf584fe$var$z = function(e) {
    return $afb260464bf584fe$var$k.get(e);
}, $afb260464bf584fe$var$M = function(e, t) {
    t >= $afb260464bf584fe$var$V && ($afb260464bf584fe$var$V = t + 1), $afb260464bf584fe$var$x.set(e, t), $afb260464bf584fe$var$k.set(t, e);
}, $afb260464bf584fe$var$G = "style[" + $afb260464bf584fe$var$A + '][data-styled-version="5.3.10"]', $afb260464bf584fe$var$L = new RegExp("^" + $afb260464bf584fe$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $afb260464bf584fe$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $afb260464bf584fe$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($afb260464bf584fe$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($afb260464bf584fe$var$M(u, c), $afb260464bf584fe$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $afb260464bf584fe$var$q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $afb260464bf584fe$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($afb260464bf584fe$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($afb260464bf584fe$var$A, "active"), r.setAttribute("data-styled-version", "5.3.10");
    var i = $afb260464bf584fe$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $afb260464bf584fe$var$$ = function() {
    function e(e) {
        var t = this.element = $afb260464bf584fe$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $afb260464bf584fe$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $afb260464bf584fe$var$W = function() {
    function e(e) {
        var t = this.element = $afb260464bf584fe$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $afb260464bf584fe$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $afb260464bf584fe$var$J = $afb260464bf584fe$var$I, $afb260464bf584fe$var$X = {
    isServer: !$afb260464bf584fe$var$I,
    useCSSOMInjection: !$afb260464bf584fe$var$P
}, $afb260464bf584fe$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $afb260464bf584fe$var$E), void 0 === t && (t = {}), this.options = $afb260464bf584fe$var$v({}, $afb260464bf584fe$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $afb260464bf584fe$var$I && $afb260464bf584fe$var$J && ($afb260464bf584fe$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($afb260464bf584fe$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($afb260464bf584fe$var$A) && ($afb260464bf584fe$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $afb260464bf584fe$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($afb260464bf584fe$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $afb260464bf584fe$var$U(o) : r ? new $afb260464bf584fe$var$$(o) : new $afb260464bf584fe$var$W(o), new $afb260464bf584fe$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($afb260464bf584fe$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($afb260464bf584fe$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($afb260464bf584fe$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $afb260464bf584fe$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $afb260464bf584fe$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $afb260464bf584fe$var$K = /(a)(d)/gi, $afb260464bf584fe$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $afb260464bf584fe$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $afb260464bf584fe$var$Q(t % 52) + n;
    return ($afb260464bf584fe$var$Q(t % 52) + n).replace($afb260464bf584fe$var$K, "$1-$2");
}
var $afb260464bf584fe$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $afb260464bf584fe$var$ne = function(e) {
    return $afb260464bf584fe$var$te(5381, e);
};
function $afb260464bf584fe$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($afb260464bf584fe$var$b(n) && !$afb260464bf584fe$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $afb260464bf584fe$var$oe = $afb260464bf584fe$var$ne("5.3.10"), $afb260464bf584fe$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $afb260464bf584fe$var$re(e), this.componentId = t, this.baseHash = $afb260464bf584fe$var$te($afb260464bf584fe$var$oe, t), this.baseStyle = n, $afb260464bf584fe$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $afb260464bf584fe$var$Ne(this.rules, e, t, n).join(""), i = $afb260464bf584fe$var$ee($afb260464bf584fe$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $afb260464bf584fe$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $afb260464bf584fe$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $afb260464bf584fe$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $afb260464bf584fe$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $afb260464bf584fe$var$ie = /^\s*\/\/.*$/gm, $afb260464bf584fe$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $afb260464bf584fe$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $afb260464bf584fe$var$E : e, i = s.options, a = void 0 === i ? $afb260464bf584fe$var$E : i, c = s.plugins, u = void 0 === c ? $afb260464bf584fe$var$w : c, l = new (0, $ikWeS.default)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $afb260464bf584fe$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($afb260464bf584fe$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $afb260464bf584fe$var$j(15), $afb260464bf584fe$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $afb260464bf584fe$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(), $afb260464bf584fe$export$91317688fc694efa = $afb260464bf584fe$export$8c190ef828af4c86.Consumer, $afb260464bf584fe$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(), $afb260464bf584fe$var$he = ($afb260464bf584fe$var$de.Consumer, new $afb260464bf584fe$var$Z), $afb260464bf584fe$var$pe = $afb260464bf584fe$var$ce();
function $afb260464bf584fe$var$fe() {
    return (0, $2NacA.useContext)($afb260464bf584fe$export$8c190ef828af4c86) || $afb260464bf584fe$var$he;
}
function $afb260464bf584fe$var$me() {
    return (0, $2NacA.useContext)($afb260464bf584fe$var$de) || $afb260464bf584fe$var$pe;
}
function $afb260464bf584fe$export$a473771da2f0ff7c(e) {
    var t = (0, $2NacA.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $afb260464bf584fe$var$fe(), u = (0, $2NacA.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $2NacA.useMemo)(function() {
        return $afb260464bf584fe$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $2NacA.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6Lq9d)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($afb260464bf584fe$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($afb260464bf584fe$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $afb260464bf584fe$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $afb260464bf584fe$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $afb260464bf584fe$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $afb260464bf584fe$var$pe), this.name + e.hash;
    }, e;
}(), $afb260464bf584fe$var$ge = /([A-Z])/, $afb260464bf584fe$var$Se = /([A-Z])/g, $afb260464bf584fe$var$we = /^ms-/, $afb260464bf584fe$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $afb260464bf584fe$var$be(e) {
    return $afb260464bf584fe$var$ge.test(e) ? e.replace($afb260464bf584fe$var$Se, $afb260464bf584fe$var$Ee).replace($afb260464bf584fe$var$we, "-ms-") : e;
}
var $afb260464bf584fe$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $afb260464bf584fe$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $afb260464bf584fe$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($afb260464bf584fe$var$_e(e)) return "";
    if ($afb260464bf584fe$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($afb260464bf584fe$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $afb260464bf584fe$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $afb260464bf584fe$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $afb260464bf584fe$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$afb260464bf584fe$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $afb260464bf584fe$var$b(t[i]) ? s.push($afb260464bf584fe$var$be(i) + ":", t[i], ";") : $afb260464bf584fe$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($afb260464bf584fe$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $a59m4.default) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $afb260464bf584fe$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $afb260464bf584fe$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $afb260464bf584fe$var$b(e) || $afb260464bf584fe$var$S(e) ? $afb260464bf584fe$var$Ae($afb260464bf584fe$var$Ne($afb260464bf584fe$var$g($afb260464bf584fe$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $afb260464bf584fe$var$Ae($afb260464bf584fe$var$Ne($afb260464bf584fe$var$g(e, n)));
}
var $afb260464bf584fe$var$Ie = /invalid hook call/i, $afb260464bf584fe$var$Pe = new Set, $afb260464bf584fe$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $afb260464bf584fe$var$Re = function(e, t, n) {
    return void 0 === n && (n = $afb260464bf584fe$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $afb260464bf584fe$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $afb260464bf584fe$var$je = /(^-|-$)/g;
function $afb260464bf584fe$var$Te(e) {
    return e.replace($afb260464bf584fe$var$De, "-").replace($afb260464bf584fe$var$je, "");
}
var $afb260464bf584fe$var$xe = function(e) {
    return $afb260464bf584fe$var$ee($afb260464bf584fe$var$ne(e) >>> 0);
};
function $afb260464bf584fe$var$ke(e) {
    return "string" == typeof e && true;
}
var $afb260464bf584fe$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $afb260464bf584fe$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $afb260464bf584fe$var$ze(e, t, n) {
    var r = e[n];
    $afb260464bf584fe$var$Ve(t) && $afb260464bf584fe$var$Ve(r) ? $afb260464bf584fe$var$Me(r, t) : e[n] = t;
}
function $afb260464bf584fe$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($afb260464bf584fe$var$Ve(i)) for(var a in i)$afb260464bf584fe$var$Be(a) && $afb260464bf584fe$var$ze(e, i[a], a);
    }
    return e;
}
var $afb260464bf584fe$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(), $afb260464bf584fe$export$b631efc24e9d5e2f = $afb260464bf584fe$export$2c657da244d00bd6.Consumer;
function $afb260464bf584fe$export$d8964aec282183a3(e) {
    var t = (0, $2NacA.useContext)($afb260464bf584fe$export$2c657da244d00bd6), n = (0, $2NacA.useMemo)(function() {
        return function(e, t) {
            if (!e) return $afb260464bf584fe$var$j(14);
            if ($afb260464bf584fe$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $afb260464bf584fe$var$j(8) : t ? $afb260464bf584fe$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($afb260464bf584fe$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $afb260464bf584fe$var$Ye = {};
function $afb260464bf584fe$var$qe(e, t, n) {
    var o = $afb260464bf584fe$export$7ba318d8d2f06c76(e), i = !$afb260464bf584fe$var$ke(e), a = t.attrs, c = void 0 === a ? $afb260464bf584fe$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $afb260464bf584fe$var$Te(e);
        $afb260464bf584fe$var$Ye[n] = ($afb260464bf584fe$var$Ye[n] || 0) + 1;
        var r = n + "-" + $afb260464bf584fe$var$xe("5.3.10" + n + $afb260464bf584fe$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $afb260464bf584fe$var$ke(e) ? "styled." + e : "Styled(" + $afb260464bf584fe$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $afb260464bf584fe$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $afb260464bf584fe$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $afb260464bf584fe$var$E);
                var r = $afb260464bf584fe$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $afb260464bf584fe$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($afb260464bf584fe$var$Re(t, (0, $2NacA.useContext)($afb260464bf584fe$export$2c657da244d00bd6), a) || $afb260464bf584fe$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $afb260464bf584fe$var$fe(), s = $afb260464bf584fe$var$me(), i = t ? e.generateAndInjectStyles($afb260464bf584fe$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $afb260464bf584fe$var$ke(_), A = g !== t ? $afb260464bf584fe$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $5h15o.default), _) : !N || (0, $5h15o.default)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $afb260464bf584fe$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $2NacA.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $afb260464bf584fe$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($afb260464bf584fe$var$ke(e) ? e : $afb260464bf584fe$var$Te($afb260464bf584fe$var$_(e)));
        return $afb260464bf584fe$var$qe(e, $afb260464bf584fe$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $afb260464bf584fe$var$Me({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(C, "toString", {
        value: function() {
            return "." + C.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($6906h)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $afb260464bf584fe$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $afb260464bf584fe$var$E), !(0, $fzBYV.isValidElementType)(r)) return $afb260464bf584fe$var$j(1, String(r));
        var s = function() {
            return t(r, o, $afb260464bf584fe$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $afb260464bf584fe$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $afb260464bf584fe$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($afb260464bf584fe$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $afb260464bf584fe$var$He[e] = $afb260464bf584fe$var$He(e);
});
var $afb260464bf584fe$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $afb260464bf584fe$var$re(e), $afb260464bf584fe$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($afb260464bf584fe$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $afb260464bf584fe$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $afb260464bf584fe$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $afb260464bf584fe$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $afb260464bf584fe$var$xe(JSON.stringify(i)), u = new $afb260464bf584fe$var$$e(i, a);
    function l(e) {
        var t = $afb260464bf584fe$var$fe(), n = $afb260464bf584fe$var$me(), o = (0, $2NacA.useContext)($afb260464bf584fe$export$2c657da244d00bd6), l = (0, $2NacA.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $2NacA.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $afb260464bf584fe$var$O, n, o);
        else {
            var s = $afb260464bf584fe$var$v({}, t, {
                theme: $afb260464bf584fe$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).memo(l);
}
function $afb260464bf584fe$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $afb260464bf584fe$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $afb260464bf584fe$var$xe(o);
    return new $afb260464bf584fe$var$ve(s, o);
}
var $afb260464bf584fe$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $afb260464bf584fe$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $afb260464bf584fe$var$A + '="true"',
                'data-styled-version="5.3.10"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $afb260464bf584fe$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $afb260464bf584fe$var$j(2);
            var n = ((t = {})[$afb260464bf584fe$var$A] = "", t["data-styled-version"] = "5.3.10", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $afb260464bf584fe$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("style", $afb260464bf584fe$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $afb260464bf584fe$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $afb260464bf584fe$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($afb260464bf584fe$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $afb260464bf584fe$var$j(3);
    }, e;
}(), $afb260464bf584fe$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).forwardRef(function(t, n) {
        var o = (0, $2NacA.useContext)($afb260464bf584fe$export$2c657da244d00bd6), i = e.defaultProps, a = $afb260464bf584fe$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(e, $afb260464bf584fe$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($6906h)))(t, e), t.displayName = "WithTheme(" + $afb260464bf584fe$var$_(e) + ")", t;
}, $afb260464bf584fe$export$93d4e7f90805808f = function() {
    return (0, $2NacA.useContext)($afb260464bf584fe$export$2c657da244d00bd6);
}, $afb260464bf584fe$export$5c87cfe6c475f500 = {
    StyleSheet: $afb260464bf584fe$var$Z,
    masterSheet: $afb260464bf584fe$var$he
};
var $afb260464bf584fe$export$2e2bcd8739ae039 = $afb260464bf584fe$var$He;

});
parcelRegister("fzBYV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8zikw"));

});
parcelRegister("8zikw", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $63cfcf8d4c32fb7d$export$a7c73072b1a182ae, (v) => $63cfcf8d4c32fb7d$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $63cfcf8d4c32fb7d$export$9f27bc3417b4524d, (v) => $63cfcf8d4c32fb7d$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $63cfcf8d4c32fb7d$export$db77ccec0bb4ccac, (v) => $63cfcf8d4c32fb7d$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $63cfcf8d4c32fb7d$export$8392c0c9d3dcbd35, (v) => $63cfcf8d4c32fb7d$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $63cfcf8d4c32fb7d$export$ffb0004e005737fa, (v) => $63cfcf8d4c32fb7d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $63cfcf8d4c32fb7d$export$b624eff549462981, (v) => $63cfcf8d4c32fb7d$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $63cfcf8d4c32fb7d$export$7897aa7841a5380c, (v) => $63cfcf8d4c32fb7d$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $63cfcf8d4c32fb7d$export$602eac185826482c, (v) => $63cfcf8d4c32fb7d$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $63cfcf8d4c32fb7d$export$e2c29f18771995cb, (v) => $63cfcf8d4c32fb7d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $63cfcf8d4c32fb7d$export$5f8d39834fd61797, (v) => $63cfcf8d4c32fb7d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $63cfcf8d4c32fb7d$export$74bf444e3cd11ea5, (v) => $63cfcf8d4c32fb7d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $63cfcf8d4c32fb7d$export$998bcd577473dd93, (v) => $63cfcf8d4c32fb7d$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $63cfcf8d4c32fb7d$export$92387174baf9b227, (v) => $63cfcf8d4c32fb7d$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $63cfcf8d4c32fb7d$export$ec112efeb987d9c6, (v) => $63cfcf8d4c32fb7d$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $63cfcf8d4c32fb7d$export$b706b080d889d2c9, (v) => $63cfcf8d4c32fb7d$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $63cfcf8d4c32fb7d$export$5be5a87408f70ddc, (v) => $63cfcf8d4c32fb7d$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $63cfcf8d4c32fb7d$export$45a5e7f76e0caa8d, (v) => $63cfcf8d4c32fb7d$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $63cfcf8d4c32fb7d$export$455c2e768291efa6, (v) => $63cfcf8d4c32fb7d$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $63cfcf8d4c32fb7d$export$9522e17588c12572, (v) => $63cfcf8d4c32fb7d$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $63cfcf8d4c32fb7d$export$2110ac352bb060b9, (v) => $63cfcf8d4c32fb7d$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $63cfcf8d4c32fb7d$export$56885ab8b9c456ab, (v) => $63cfcf8d4c32fb7d$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $63cfcf8d4c32fb7d$export$d927fcb6adf8f9de, (v) => $63cfcf8d4c32fb7d$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $63cfcf8d4c32fb7d$export$b82d16f27459e05a, (v) => $63cfcf8d4c32fb7d$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $63cfcf8d4c32fb7d$export$522c17b4f5e123e8, (v) => $63cfcf8d4c32fb7d$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $63cfcf8d4c32fb7d$export$1aabd8a0274ecfd6, (v) => $63cfcf8d4c32fb7d$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $63cfcf8d4c32fb7d$export$3d6c20d97e46b957, (v) => $63cfcf8d4c32fb7d$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $63cfcf8d4c32fb7d$export$9b621391a187a31a, (v) => $63cfcf8d4c32fb7d$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $63cfcf8d4c32fb7d$export$f5bbd400c2f4426f, (v) => $63cfcf8d4c32fb7d$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $63cfcf8d4c32fb7d$export$a7c73072b1a182ae;
var $63cfcf8d4c32fb7d$export$9f27bc3417b4524d;
var $63cfcf8d4c32fb7d$export$db77ccec0bb4ccac;
var $63cfcf8d4c32fb7d$export$8392c0c9d3dcbd35;
var $63cfcf8d4c32fb7d$export$ffb0004e005737fa;
var $63cfcf8d4c32fb7d$export$b624eff549462981;
var $63cfcf8d4c32fb7d$export$7897aa7841a5380c;
var $63cfcf8d4c32fb7d$export$602eac185826482c;
var $63cfcf8d4c32fb7d$export$e2c29f18771995cb;
var $63cfcf8d4c32fb7d$export$5f8d39834fd61797;
var $63cfcf8d4c32fb7d$export$74bf444e3cd11ea5;
var $63cfcf8d4c32fb7d$export$998bcd577473dd93;
var $63cfcf8d4c32fb7d$export$92387174baf9b227;
var $63cfcf8d4c32fb7d$export$ec112efeb987d9c6;
var $63cfcf8d4c32fb7d$export$b706b080d889d2c9;
var $63cfcf8d4c32fb7d$export$5be5a87408f70ddc;
var $63cfcf8d4c32fb7d$export$45a5e7f76e0caa8d;
var $63cfcf8d4c32fb7d$export$455c2e768291efa6;
var $63cfcf8d4c32fb7d$export$9522e17588c12572;
var $63cfcf8d4c32fb7d$export$2110ac352bb060b9;
var $63cfcf8d4c32fb7d$export$56885ab8b9c456ab;
var $63cfcf8d4c32fb7d$export$d927fcb6adf8f9de;
var $63cfcf8d4c32fb7d$export$b82d16f27459e05a;
var $63cfcf8d4c32fb7d$export$522c17b4f5e123e8;
var $63cfcf8d4c32fb7d$export$1aabd8a0274ecfd6;
var $63cfcf8d4c32fb7d$export$3d6c20d97e46b957;
var $63cfcf8d4c32fb7d$export$9b621391a187a31a;
var $63cfcf8d4c32fb7d$export$f5bbd400c2f4426f;
'use strict';
var $63cfcf8d4c32fb7d$var$b = Symbol.for("react.element"), $63cfcf8d4c32fb7d$var$c = Symbol.for("react.portal"), $63cfcf8d4c32fb7d$var$d = Symbol.for("react.fragment"), $63cfcf8d4c32fb7d$var$e = Symbol.for("react.strict_mode"), $63cfcf8d4c32fb7d$var$f = Symbol.for("react.profiler"), $63cfcf8d4c32fb7d$var$g = Symbol.for("react.provider"), $63cfcf8d4c32fb7d$var$h = Symbol.for("react.context"), $63cfcf8d4c32fb7d$var$k = Symbol.for("react.server_context"), $63cfcf8d4c32fb7d$var$l = Symbol.for("react.forward_ref"), $63cfcf8d4c32fb7d$var$m = Symbol.for("react.suspense"), $63cfcf8d4c32fb7d$var$n = Symbol.for("react.suspense_list"), $63cfcf8d4c32fb7d$var$p = Symbol.for("react.memo"), $63cfcf8d4c32fb7d$var$q = Symbol.for("react.lazy"), $63cfcf8d4c32fb7d$var$t = Symbol.for("react.offscreen"), $63cfcf8d4c32fb7d$var$u;
$63cfcf8d4c32fb7d$var$u = Symbol.for("react.module.reference");
function $63cfcf8d4c32fb7d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $63cfcf8d4c32fb7d$var$b:
                switch(a = a.type, a){
                    case $63cfcf8d4c32fb7d$var$d:
                    case $63cfcf8d4c32fb7d$var$f:
                    case $63cfcf8d4c32fb7d$var$e:
                    case $63cfcf8d4c32fb7d$var$m:
                    case $63cfcf8d4c32fb7d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $63cfcf8d4c32fb7d$var$k:
                            case $63cfcf8d4c32fb7d$var$h:
                            case $63cfcf8d4c32fb7d$var$l:
                            case $63cfcf8d4c32fb7d$var$q:
                            case $63cfcf8d4c32fb7d$var$p:
                            case $63cfcf8d4c32fb7d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $63cfcf8d4c32fb7d$var$c:
                return r;
        }
    }
}
$63cfcf8d4c32fb7d$export$a7c73072b1a182ae = $63cfcf8d4c32fb7d$var$h;
$63cfcf8d4c32fb7d$export$9f27bc3417b4524d = $63cfcf8d4c32fb7d$var$g;
$63cfcf8d4c32fb7d$export$db77ccec0bb4ccac = $63cfcf8d4c32fb7d$var$b;
$63cfcf8d4c32fb7d$export$8392c0c9d3dcbd35 = $63cfcf8d4c32fb7d$var$l;
$63cfcf8d4c32fb7d$export$ffb0004e005737fa = $63cfcf8d4c32fb7d$var$d;
$63cfcf8d4c32fb7d$export$b624eff549462981 = $63cfcf8d4c32fb7d$var$q;
$63cfcf8d4c32fb7d$export$7897aa7841a5380c = $63cfcf8d4c32fb7d$var$p;
$63cfcf8d4c32fb7d$export$602eac185826482c = $63cfcf8d4c32fb7d$var$c;
$63cfcf8d4c32fb7d$export$e2c29f18771995cb = $63cfcf8d4c32fb7d$var$f;
$63cfcf8d4c32fb7d$export$5f8d39834fd61797 = $63cfcf8d4c32fb7d$var$e;
$63cfcf8d4c32fb7d$export$74bf444e3cd11ea5 = $63cfcf8d4c32fb7d$var$m;
$63cfcf8d4c32fb7d$export$998bcd577473dd93 = $63cfcf8d4c32fb7d$var$n;
$63cfcf8d4c32fb7d$export$92387174baf9b227 = function() {
    return !1;
};
$63cfcf8d4c32fb7d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$63cfcf8d4c32fb7d$export$b706b080d889d2c9 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$h;
};
$63cfcf8d4c32fb7d$export$5be5a87408f70ddc = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$g;
};
$63cfcf8d4c32fb7d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $63cfcf8d4c32fb7d$var$b;
};
$63cfcf8d4c32fb7d$export$455c2e768291efa6 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$l;
};
$63cfcf8d4c32fb7d$export$9522e17588c12572 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$d;
};
$63cfcf8d4c32fb7d$export$2110ac352bb060b9 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$q;
};
$63cfcf8d4c32fb7d$export$56885ab8b9c456ab = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$p;
};
$63cfcf8d4c32fb7d$export$d927fcb6adf8f9de = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$c;
};
$63cfcf8d4c32fb7d$export$b82d16f27459e05a = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$f;
};
$63cfcf8d4c32fb7d$export$522c17b4f5e123e8 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$e;
};
$63cfcf8d4c32fb7d$export$1aabd8a0274ecfd6 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$m;
};
$63cfcf8d4c32fb7d$export$3d6c20d97e46b957 = function(a) {
    return $63cfcf8d4c32fb7d$var$v(a) === $63cfcf8d4c32fb7d$var$n;
};
$63cfcf8d4c32fb7d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $63cfcf8d4c32fb7d$var$d || a === $63cfcf8d4c32fb7d$var$f || a === $63cfcf8d4c32fb7d$var$e || a === $63cfcf8d4c32fb7d$var$m || a === $63cfcf8d4c32fb7d$var$n || a === $63cfcf8d4c32fb7d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $63cfcf8d4c32fb7d$var$q || a.$$typeof === $63cfcf8d4c32fb7d$var$p || a.$$typeof === $63cfcf8d4c32fb7d$var$g || a.$$typeof === $63cfcf8d4c32fb7d$var$h || a.$$typeof === $63cfcf8d4c32fb7d$var$l || a.$$typeof === $63cfcf8d4c32fb7d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$63cfcf8d4c32fb7d$export$f5bbd400c2f4426f = $63cfcf8d4c32fb7d$var$v;

});


parcelRegister("6Lq9d", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("ikWeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d597454dd2a8687c$export$2e2bcd8739ae039);
function $d597454dd2a8687c$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $d597454dd2a8687c$export$2e2bcd8739ae039 = $d597454dd2a8687c$var$stylis_min;

});

parcelRegister("a59m4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7571a0b946bbca80$export$2e2bcd8739ae039);
var $7571a0b946bbca80$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $7571a0b946bbca80$export$2e2bcd8739ae039 = $7571a0b946bbca80$var$unitlessKeys;

});

parcelRegister("5h15o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3d6f61ebafab8247$export$2e2bcd8739ae039);

var $2HDvK = parcelRequire("2HDvK");
// eslint-disable-next-line no-undef
var $3d6f61ebafab8247$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3d6f61ebafab8247$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $2HDvK.default)(function(prop) {
    return $3d6f61ebafab8247$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("2HDvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7e3f026dc236a5$export$2e2bcd8739ae039);
function $1f7e3f026dc236a5$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("6906h", function(module, exports) {
'use strict';

var $lmN3f = parcelRequire("lmN3f");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4793a93faeb00e6c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4793a93faeb00e6c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4793a93faeb00e6c$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4793a93faeb00e6c$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4793a93faeb00e6c$var$TYPE_STATICS = {};
$4793a93faeb00e6c$var$TYPE_STATICS[$lmN3f.ForwardRef] = $4793a93faeb00e6c$var$FORWARD_REF_STATICS;
$4793a93faeb00e6c$var$TYPE_STATICS[$lmN3f.Memo] = $4793a93faeb00e6c$var$MEMO_STATICS;
function $4793a93faeb00e6c$var$getStatics(component) {
    // React v16.11 and below
    if ($lmN3f.isMemo(component)) return $4793a93faeb00e6c$var$MEMO_STATICS;
     // React v16.12 and above
    return $4793a93faeb00e6c$var$TYPE_STATICS[component['$$typeof']] || $4793a93faeb00e6c$var$REACT_STATICS;
}
var $4793a93faeb00e6c$var$defineProperty = Object.defineProperty;
var $4793a93faeb00e6c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4793a93faeb00e6c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4793a93faeb00e6c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4793a93faeb00e6c$var$getPrototypeOf = Object.getPrototypeOf;
var $4793a93faeb00e6c$var$objectPrototype = Object.prototype;
function $4793a93faeb00e6c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($4793a93faeb00e6c$var$objectPrototype) {
            var inheritedComponent = $4793a93faeb00e6c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4793a93faeb00e6c$var$objectPrototype) $4793a93faeb00e6c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4793a93faeb00e6c$var$getOwnPropertyNames(sourceComponent);
        if ($4793a93faeb00e6c$var$getOwnPropertySymbols) keys = keys.concat($4793a93faeb00e6c$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $4793a93faeb00e6c$var$getStatics(targetComponent);
        var sourceStatics = $4793a93faeb00e6c$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4793a93faeb00e6c$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $4793a93faeb00e6c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $4793a93faeb00e6c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $4793a93faeb00e6c$var$hoistNonReactStatics;

});
parcelRegister("lmN3f", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g0o1z"));

});
parcelRegister("g0o1z", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $ba6f4825340b5823$export$2b8d127b894957b9, (v) => $ba6f4825340b5823$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $ba6f4825340b5823$export$cea3a54a6425200c, (v) => $ba6f4825340b5823$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $ba6f4825340b5823$export$a7c73072b1a182ae, (v) => $ba6f4825340b5823$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ba6f4825340b5823$export$9f27bc3417b4524d, (v) => $ba6f4825340b5823$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ba6f4825340b5823$export$db77ccec0bb4ccac, (v) => $ba6f4825340b5823$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ba6f4825340b5823$export$8392c0c9d3dcbd35, (v) => $ba6f4825340b5823$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ba6f4825340b5823$export$ffb0004e005737fa, (v) => $ba6f4825340b5823$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ba6f4825340b5823$export$b624eff549462981, (v) => $ba6f4825340b5823$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ba6f4825340b5823$export$7897aa7841a5380c, (v) => $ba6f4825340b5823$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ba6f4825340b5823$export$602eac185826482c, (v) => $ba6f4825340b5823$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ba6f4825340b5823$export$e2c29f18771995cb, (v) => $ba6f4825340b5823$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ba6f4825340b5823$export$5f8d39834fd61797, (v) => $ba6f4825340b5823$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ba6f4825340b5823$export$74bf444e3cd11ea5, (v) => $ba6f4825340b5823$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ba6f4825340b5823$export$92387174baf9b227, (v) => $ba6f4825340b5823$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ba6f4825340b5823$export$ec112efeb987d9c6, (v) => $ba6f4825340b5823$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ba6f4825340b5823$export$b706b080d889d2c9, (v) => $ba6f4825340b5823$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ba6f4825340b5823$export$5be5a87408f70ddc, (v) => $ba6f4825340b5823$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ba6f4825340b5823$export$45a5e7f76e0caa8d, (v) => $ba6f4825340b5823$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ba6f4825340b5823$export$455c2e768291efa6, (v) => $ba6f4825340b5823$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ba6f4825340b5823$export$9522e17588c12572, (v) => $ba6f4825340b5823$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ba6f4825340b5823$export$2110ac352bb060b9, (v) => $ba6f4825340b5823$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ba6f4825340b5823$export$56885ab8b9c456ab, (v) => $ba6f4825340b5823$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ba6f4825340b5823$export$d927fcb6adf8f9de, (v) => $ba6f4825340b5823$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ba6f4825340b5823$export$b82d16f27459e05a, (v) => $ba6f4825340b5823$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ba6f4825340b5823$export$522c17b4f5e123e8, (v) => $ba6f4825340b5823$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ba6f4825340b5823$export$1aabd8a0274ecfd6, (v) => $ba6f4825340b5823$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ba6f4825340b5823$export$9b621391a187a31a, (v) => $ba6f4825340b5823$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ba6f4825340b5823$export$f5bbd400c2f4426f, (v) => $ba6f4825340b5823$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba6f4825340b5823$export$2b8d127b894957b9;
var $ba6f4825340b5823$export$cea3a54a6425200c;
var $ba6f4825340b5823$export$a7c73072b1a182ae;
var $ba6f4825340b5823$export$9f27bc3417b4524d;
var $ba6f4825340b5823$export$db77ccec0bb4ccac;
var $ba6f4825340b5823$export$8392c0c9d3dcbd35;
var $ba6f4825340b5823$export$ffb0004e005737fa;
var $ba6f4825340b5823$export$b624eff549462981;
var $ba6f4825340b5823$export$7897aa7841a5380c;
var $ba6f4825340b5823$export$602eac185826482c;
var $ba6f4825340b5823$export$e2c29f18771995cb;
var $ba6f4825340b5823$export$5f8d39834fd61797;
var $ba6f4825340b5823$export$74bf444e3cd11ea5;
var $ba6f4825340b5823$export$92387174baf9b227;
var $ba6f4825340b5823$export$ec112efeb987d9c6;
var $ba6f4825340b5823$export$b706b080d889d2c9;
var $ba6f4825340b5823$export$5be5a87408f70ddc;
var $ba6f4825340b5823$export$45a5e7f76e0caa8d;
var $ba6f4825340b5823$export$455c2e768291efa6;
var $ba6f4825340b5823$export$9522e17588c12572;
var $ba6f4825340b5823$export$2110ac352bb060b9;
var $ba6f4825340b5823$export$56885ab8b9c456ab;
var $ba6f4825340b5823$export$d927fcb6adf8f9de;
var $ba6f4825340b5823$export$b82d16f27459e05a;
var $ba6f4825340b5823$export$522c17b4f5e123e8;
var $ba6f4825340b5823$export$1aabd8a0274ecfd6;
var $ba6f4825340b5823$export$9b621391a187a31a;
var $ba6f4825340b5823$export$f5bbd400c2f4426f;
'use strict';
var $ba6f4825340b5823$var$b = "function" === typeof Symbol && Symbol.for, $ba6f4825340b5823$var$c = $ba6f4825340b5823$var$b ? Symbol.for("react.element") : 60103, $ba6f4825340b5823$var$d = $ba6f4825340b5823$var$b ? Symbol.for("react.portal") : 60106, $ba6f4825340b5823$var$e = $ba6f4825340b5823$var$b ? Symbol.for("react.fragment") : 60107, $ba6f4825340b5823$var$f = $ba6f4825340b5823$var$b ? Symbol.for("react.strict_mode") : 60108, $ba6f4825340b5823$var$g = $ba6f4825340b5823$var$b ? Symbol.for("react.profiler") : 60114, $ba6f4825340b5823$var$h = $ba6f4825340b5823$var$b ? Symbol.for("react.provider") : 60109, $ba6f4825340b5823$var$k = $ba6f4825340b5823$var$b ? Symbol.for("react.context") : 60110, $ba6f4825340b5823$var$l = $ba6f4825340b5823$var$b ? Symbol.for("react.async_mode") : 60111, $ba6f4825340b5823$var$m = $ba6f4825340b5823$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ba6f4825340b5823$var$n = $ba6f4825340b5823$var$b ? Symbol.for("react.forward_ref") : 60112, $ba6f4825340b5823$var$p = $ba6f4825340b5823$var$b ? Symbol.for("react.suspense") : 60113, $ba6f4825340b5823$var$q = $ba6f4825340b5823$var$b ? Symbol.for("react.suspense_list") : 60120, $ba6f4825340b5823$var$r = $ba6f4825340b5823$var$b ? Symbol.for("react.memo") : 60115, $ba6f4825340b5823$var$t = $ba6f4825340b5823$var$b ? Symbol.for("react.lazy") : 60116, $ba6f4825340b5823$var$v = $ba6f4825340b5823$var$b ? Symbol.for("react.block") : 60121, $ba6f4825340b5823$var$w = $ba6f4825340b5823$var$b ? Symbol.for("react.fundamental") : 60117, $ba6f4825340b5823$var$x = $ba6f4825340b5823$var$b ? Symbol.for("react.responder") : 60118, $ba6f4825340b5823$var$y = $ba6f4825340b5823$var$b ? Symbol.for("react.scope") : 60119;
function $ba6f4825340b5823$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ba6f4825340b5823$var$c:
                switch(a = a.type, a){
                    case $ba6f4825340b5823$var$l:
                    case $ba6f4825340b5823$var$m:
                    case $ba6f4825340b5823$var$e:
                    case $ba6f4825340b5823$var$g:
                    case $ba6f4825340b5823$var$f:
                    case $ba6f4825340b5823$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ba6f4825340b5823$var$k:
                            case $ba6f4825340b5823$var$n:
                            case $ba6f4825340b5823$var$t:
                            case $ba6f4825340b5823$var$r:
                            case $ba6f4825340b5823$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ba6f4825340b5823$var$d:
                return u;
        }
    }
}
function $ba6f4825340b5823$var$A(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$m;
}
$ba6f4825340b5823$export$2b8d127b894957b9 = $ba6f4825340b5823$var$l;
$ba6f4825340b5823$export$cea3a54a6425200c = $ba6f4825340b5823$var$m;
$ba6f4825340b5823$export$a7c73072b1a182ae = $ba6f4825340b5823$var$k;
$ba6f4825340b5823$export$9f27bc3417b4524d = $ba6f4825340b5823$var$h;
$ba6f4825340b5823$export$db77ccec0bb4ccac = $ba6f4825340b5823$var$c;
$ba6f4825340b5823$export$8392c0c9d3dcbd35 = $ba6f4825340b5823$var$n;
$ba6f4825340b5823$export$ffb0004e005737fa = $ba6f4825340b5823$var$e;
$ba6f4825340b5823$export$b624eff549462981 = $ba6f4825340b5823$var$t;
$ba6f4825340b5823$export$7897aa7841a5380c = $ba6f4825340b5823$var$r;
$ba6f4825340b5823$export$602eac185826482c = $ba6f4825340b5823$var$d;
$ba6f4825340b5823$export$e2c29f18771995cb = $ba6f4825340b5823$var$g;
$ba6f4825340b5823$export$5f8d39834fd61797 = $ba6f4825340b5823$var$f;
$ba6f4825340b5823$export$74bf444e3cd11ea5 = $ba6f4825340b5823$var$p;
$ba6f4825340b5823$export$92387174baf9b227 = function(a) {
    return $ba6f4825340b5823$var$A(a) || $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$l;
};
$ba6f4825340b5823$export$ec112efeb987d9c6 = $ba6f4825340b5823$var$A;
$ba6f4825340b5823$export$b706b080d889d2c9 = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$k;
};
$ba6f4825340b5823$export$5be5a87408f70ddc = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$h;
};
$ba6f4825340b5823$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ba6f4825340b5823$var$c;
};
$ba6f4825340b5823$export$455c2e768291efa6 = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$n;
};
$ba6f4825340b5823$export$9522e17588c12572 = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$e;
};
$ba6f4825340b5823$export$2110ac352bb060b9 = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$t;
};
$ba6f4825340b5823$export$56885ab8b9c456ab = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$r;
};
$ba6f4825340b5823$export$d927fcb6adf8f9de = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$d;
};
$ba6f4825340b5823$export$b82d16f27459e05a = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$g;
};
$ba6f4825340b5823$export$522c17b4f5e123e8 = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$f;
};
$ba6f4825340b5823$export$1aabd8a0274ecfd6 = function(a) {
    return $ba6f4825340b5823$var$z(a) === $ba6f4825340b5823$var$p;
};
$ba6f4825340b5823$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ba6f4825340b5823$var$e || a === $ba6f4825340b5823$var$m || a === $ba6f4825340b5823$var$g || a === $ba6f4825340b5823$var$f || a === $ba6f4825340b5823$var$p || a === $ba6f4825340b5823$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ba6f4825340b5823$var$t || a.$$typeof === $ba6f4825340b5823$var$r || a.$$typeof === $ba6f4825340b5823$var$h || a.$$typeof === $ba6f4825340b5823$var$k || a.$$typeof === $ba6f4825340b5823$var$n || a.$$typeof === $ba6f4825340b5823$var$w || a.$$typeof === $ba6f4825340b5823$var$x || a.$$typeof === $ba6f4825340b5823$var$y || a.$$typeof === $ba6f4825340b5823$var$v);
};
$ba6f4825340b5823$export$f5bbd400c2f4426f = $ba6f4825340b5823$var$z;

});




parcelRegister("4zRSZ", function(module, exports) {

$parcel$export(module.exports, "ResponsiveContext", () => $35543ae81eee5eb8$export$51e389dae84ec233);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $eD00G = parcelRequire("eD00G");
var $35543ae81eee5eb8$export$51e389dae84ec233 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(undefined);
$35543ae81eee5eb8$export$51e389dae84ec233.propTypes = (0, $eD00G.ResponsiveContextPropTypes);

});
parcelRegister("eD00G", function(module, exports) {

$parcel$export(module.exports, "ResponsiveContextPropTypes", () => $aa64b72ff69bb218$export$4c170dc5df56b17c);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $aa64b72ff69bb218$var$PropType = {};
var $aa64b72ff69bb218$export$4c170dc5df56b17c = $aa64b72ff69bb218$var$PropType;

});


parcelRegister("lwlwr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $faad47fe9cc01e06$var$ReactIs, $faad47fe9cc01e06$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("9fDHK"))();

});
parcelRegister("9fDHK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $aeAL9 = parcelRequire("aeAL9");
function $6bc4504672ace98c$var$emptyFunction() {}
function $6bc4504672ace98c$var$emptyFunctionWithReset() {}
$6bc4504672ace98c$var$emptyFunctionWithReset.resetWarningCache = $6bc4504672ace98c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aeAL9) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6bc4504672ace98c$var$emptyFunctionWithReset,
        resetWarningCache: $6bc4504672ace98c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aeAL9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7737b9d7954b0d24$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $7737b9d7954b0d24$var$ReactPropTypesSecret;

});



parcelRegister("jQHd2", function(module, exports) {

$parcel$export(module.exports, "normalizeBackground", () => $e7346422736d4a15$export$7b802385d70a5af9);
$parcel$export(module.exports, "backgroundIsDark", () => $e7346422736d4a15$export$d285dc898c6a4d11);
$parcel$export(module.exports, "backgroundAndTextColors", () => $e7346422736d4a15$export$51f19bd17c18b682);
$parcel$export(module.exports, "backgroundStyle", () => $e7346422736d4a15$export$e43a4f0de05cb7e9);
$parcel$export(module.exports, "activeStyle", () => $e7346422736d4a15$export$d51670144e8c59cf);
$parcel$export(module.exports, "selectedStyle", () => $e7346422736d4a15$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "getHoverIndicatorStyle", () => $e7346422736d4a15$export$172ca055ee2bcc62);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $d2fh4 = parcelRequire("d2fh4");
// evalStyle() converts a styled-components item into a string
var $e7346422736d4a15$var$evalStyle = function evalStyle(arg, theme) {
    if (arg && Array.isArray(arg) && typeof arg[0] === 'function') return arg[0]({
        theme: theme
    });
    return arg;
};
var $e7346422736d4a15$export$7b802385d70a5af9 = function normalizeBackground(backgroundArg, theme) {
    var _theme$global$backgro;
    var background = ((_theme$global$backgro = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro[backgroundArg]) || backgroundArg;
    var result = background;
    // If the background has a light or dark object, use that
    if (background) {
        if (theme.dark && background.dark && typeof background.dark !== 'boolean') result = background.dark;
        else if (!theme.dark && background.light && typeof background.light !== 'boolean') result = background.light;
        result = $e7346422736d4a15$var$evalStyle(result, theme);
    }
    return result;
};
var $e7346422736d4a15$var$normalizeBackgroundColor = function normalizeBackgroundColor(backgroundArg, theme) {
    var _theme$global$backgro2;
    var background = backgroundArg.color || backgroundArg;
    var result = (0, $d2fh4.normalizeColor)(// Background color may be defined by theme.global.backgrounds or
    // theme.global.colors.
    ((_theme$global$backgro2 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro2[background]) || background, theme, backgroundArg.dark);
    return result;
};
var $e7346422736d4a15$var$_normalizeBackgroundImage = function normalizeBackgroundImage(background, theme) {
    var result;
    if (background.image) {
        var _theme$global$backgro3, _theme$global$backgro4;
        result = $e7346422736d4a15$export$7b802385d70a5af9(background.dark ? (_theme$global$backgro3 = theme.global.backgrounds) == null || (_theme$global$backgro3 = _theme$global$backgro3[background.image]) == null ? void 0 : _theme$global$backgro3.dark : (_theme$global$backgro4 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro4[background.image], theme) || background.image;
    } else {
        var _theme$global$backgro5;
        var normalized = $e7346422736d4a15$export$7b802385d70a5af9((_theme$global$backgro5 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro5[background], theme);
        result = typeof normalized === 'object' ? $e7346422736d4a15$var$_normalizeBackgroundImage(normalized, theme) : normalized;
    }
    return result;
};
var $e7346422736d4a15$var$rotateBackground = function rotateBackground(background, theme) {
    var backgroundImage = $e7346422736d4a15$var$_normalizeBackgroundImage(background, theme);
    var result = backgroundImage;
    if (backgroundImage.lastIndexOf('linear-gradient', 0) === 0) {
        var regex = /\d{1,}deg\b,/gm; // Contains rotation specified in degrees. Only targets 'deg' string with a trailing comma. Do not match 'deg' string for hsl, etc..
        result = backgroundImage.lastIndexOf('deg,') >= 0 ? backgroundImage.replace(regex, background.rotate + "deg,") : backgroundImage.replace('linear-gradient(', "linear-gradient(" + background.rotate + "deg, ");
    } else console.warn("'background.rotate' property only supports 'background.image' containing a linear-gradient string.");
    return result;
};
var $e7346422736d4a15$export$d285dc898c6a4d11 = function backgroundIsDark(backgroundArg, theme) {
    var background = $e7346422736d4a15$export$7b802385d70a5af9(backgroundArg, theme);
    var result;
    if (background) {
        if (typeof background === 'object') {
            var color = background.color, dark = background.dark, opacity = background.opacity;
            if (typeof dark === 'boolean') result = dark;
            else if (color && // weak opacity means we keep the existing darkness
            (!opacity || opacity !== 'weak')) {
                var backgroundColor = (0, $d2fh4.normalizeColor)(background.color, theme);
                if (backgroundColor) result = (0, $d2fh4.colorIsDark)(backgroundColor);
            }
        } else {
            var _color = (0, $d2fh4.normalizeColor)(background, theme);
            if (_color) result = (0, $d2fh4.colorIsDark)(_color);
        }
    }
    return result;
};
var $e7346422736d4a15$var$darkContext = function darkContext(backgroundColor) {
    var isDark = (0, $d2fh4.colorIsDark)(backgroundColor);
    if (isDark === undefined) return undefined;
    return isDark ? 'dark' : 'light';
};
var $e7346422736d4a15$export$51f19bd17c18b682 = function backgroundAndTextColors(backgroundArg, textArg, theme) {
    if (!backgroundArg) return [
        undefined,
        textArg
    ];
    var global = theme.global;
    var background = $e7346422736d4a15$export$7b802385d70a5af9(backgroundArg, theme);
    var text = textArg || global.colors.text;
    var backgroundColor;
    var textColor;
    if (typeof background === 'object') {
        if (background.dark === false) textColor = text.light || text;
        else if (background.dark) textColor = text.dark || text;
        if (background.color) {
            var color = $e7346422736d4a15$var$normalizeBackgroundColor(background, theme);
            var opacity = background.opacity === true ? global.opacity.medium : global.opacity[background.opacity] || background.opacity;
            backgroundColor = (0, $d2fh4.getRGBA)(color, opacity) || color;
            // If we don't have a textColor already, and we aren't too translucent,
            // set the textColor to have the best contrast against the background
            // color.
            if (!textColor && (opacity === undefined || opacity > 0.3)) {
                var shade = $e7346422736d4a15$var$darkContext(backgroundColor, theme);
                textColor = (0, $d2fh4.normalizeColor)(shade && text[shade] || text, theme);
            }
        }
    } else {
        backgroundColor = $e7346422736d4a15$var$normalizeBackgroundColor(background, theme);
        var _shade = $e7346422736d4a15$var$darkContext(backgroundColor, theme);
        var transparent;
        if (backgroundColor && (0, $d2fh4.canExtractRGBArray)(backgroundColor)) {
            var colorArray = (0, $d2fh4.getRGBArray)(backgroundColor);
            // check if the alpha value is less than 0.5
            if (colorArray[3] < 0.5) transparent = true;
        }
        if (_shade) textColor = (0, $d2fh4.normalizeColor)(text[_shade] || text, theme, _shade === 'dark');
        else if (transparent && text) textColor = (0, $d2fh4.normalizeColor)(text, theme);
        else {
            // If we can't determine the shade, we assume this isn't a simple color.
            // It could be a gradient. backgroundStyle() will take care of that case.
            if (backgroundColor !== 'transparent') backgroundColor = undefined;
            if (text) textColor = (0, $d2fh4.normalizeColor)(text, theme);
        }
    }
    // if textArg is false, we don't want the textColor, used for Button hover
    if (textArg === false) textColor = undefined;
    return [
        backgroundColor,
        textColor
    ];
};
var $e7346422736d4a15$export$e43a4f0de05cb7e9 = function backgroundStyle(backgroundArg, theme, textColorArg) {
    // for Grommet component, if the background isn't defined, don't set it
    if (backgroundArg === undefined) return undefined;
    var background = $e7346422736d4a15$export$7b802385d70a5af9(backgroundArg, theme);
    var _backgroundAndTextCol = $e7346422736d4a15$export$51f19bd17c18b682(background, textColorArg, theme), backgroundColor = _backgroundAndTextCol[0], textColor = _backgroundAndTextCol[1];
    var backgroundImage = background.rotate ? $e7346422736d4a15$var$rotateBackground(background, theme) : $e7346422736d4a15$var$_normalizeBackgroundImage(background, theme);
    var backgroundClipStyle = '';
    if (background.clip) backgroundClipStyle = background.clip === 'text' ? "-webkit-text-fill-color: transparent; \n           -webkit-background-clip: text; \n           background-clip: text;" : "background-clip: " + background.clip + ";";
    if (typeof background === 'string' && background.lastIndexOf('url', 0) === 0) return (0, $f5efw.css)([
        "background:",
        " no-repeat center center;background-size:cover;"
    ], background);
    if (backgroundImage) {
        var backgroundStyles = "\n      " + (backgroundColor ? "background-color: " + backgroundColor + ";" : '') + "\n      background-image: " + backgroundImage + ";\n      background-repeat: " + (typeof background === 'object' && background.repeat || 'no-repeat') + ";\n      background-position: " + (background.position || 'center center') + ";\n      background-size: " + (background.size || 'cover') + ";\n      " + backgroundClipStyle + "\n    ";
        // allow both background color and image, in case the image doesn't fill
        // when image and opacity are used together, we need to use pseudo :before
        // to ensure that only image and background color are affected by opacity
        // but not the container contents
        return (0, $f5efw.css)([
            "",
            " ",
            ""
        ], textColor ? "color: " + textColor + ";" : '', !background.opacity ? backgroundStyles : "position: relative;\n        z-index: 0;\n        &:before {\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          left: 0;\n          bottom: 0;\n          z-index: -1;\n          border-radius: inherit;\n          " + backgroundStyles + "\n          opacity: " + (background.opacity === true ? theme.global.opacity.medium : theme.global.opacity[background.opacity] || background.opacity) + ";\n        }");
    }
    if (backgroundColor) return (0, $f5efw.css)([
        "background-color:",
        ";",
        ""
    ], backgroundColor, textColor ? "color: " + textColor + ";" : '');
    if (typeof background === 'string') // This case takes care of gradients
    // or theme colors that use CSS names like 'crimson' that we don't parse
    return (0, $f5efw.css)([
        "background:",
        ";"
    ], (0, $d2fh4.normalizeColor)(background, theme));
    return undefined;
};
var $e7346422736d4a15$export$d51670144e8c59cf = (0, $f5efw.css)([
    "",
    ""
], function(props) {
    return $e7346422736d4a15$export$e43a4f0de05cb7e9((0, $d2fh4.normalizeColor)(props.theme.global.active.background, props.theme), props.theme, props.theme.global.active.color);
});
var $e7346422736d4a15$export$a7abb1b3dc25813f = (0, $f5efw.css)([
    "",
    ""
], function(props) {
    return $e7346422736d4a15$export$e43a4f0de05cb7e9((0, $d2fh4.normalizeColor)(props.theme.global.selected.background, props.theme), props.theme, props.theme.global.selected.color);
});
var $e7346422736d4a15$export$172ca055ee2bcc62 = function getHoverIndicatorStyle(hoverIndicator, theme) {
    var background;
    var elevation;
    if (hoverIndicator === true || hoverIndicator === 'background') background = theme.global.hover.background;
    else if (typeof hoverIndicator === 'object') {
        if (hoverIndicator.elevation || hoverIndicator.background) {
            elevation = hoverIndicator.elevation;
            background = hoverIndicator.background;
        } else background = hoverIndicator;
    } else background = hoverIndicator;
    return (0, $f5efw.css)([
        "",
        " ",
        ""
    ], $e7346422736d4a15$export$e43a4f0de05cb7e9(background, theme, theme.global.hover.color), elevation && "box-shadow: " + theme.global.elevation[theme.dark ? 'dark' : 'light'][elevation] + ";");
};

});
parcelRegister("d2fh4", function(module, exports) {

$parcel$export(module.exports, "normalizeColor", () => $97d74f6ac49bbf5b$export$4cde5df63f53f473);
$parcel$export(module.exports, "canExtractRGBArray", () => $97d74f6ac49bbf5b$export$6d62a0650580a0ff);
$parcel$export(module.exports, "getRGBArray", () => $97d74f6ac49bbf5b$export$5bcd173cc9a0dca);
$parcel$export(module.exports, "colorIsDark", () => $97d74f6ac49bbf5b$export$76249e090d1c76db);
$parcel$export(module.exports, "getRGBA", () => $97d74f6ac49bbf5b$export$c24a0a5c5129b2e1);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
// Track which deprecated colors have already been warned about
var $97d74f6ac49bbf5b$var$warnedColors = new Set();
var $97d74f6ac49bbf5b$var$checkColorDeprecation = function checkColorDeprecation(color, theme, dark) {
    var _theme$global$depreca;
    (_theme$global$depreca = theme.global.deprecated) != null && _theme$global$depreca.colors;
    var colorKey, deprecatedColor;
};
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $97d74f6ac49bbf5b$export$4cde5df63f53f473 = function normalizeColor(color, theme, dark) {
    $97d74f6ac49bbf5b$var$checkColorDeprecation(color, theme, dark);
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = $97d74f6ac49bbf5b$export$4cde5df63f53f473(result, theme, dark);
    return result;
};
var $97d74f6ac49bbf5b$var$parseHexToRGB = function parseHexToRGB(color) {
    return color.length < 7 // 7 is what's needed for '#RRGGBB'
     ? color.match(/[A-Za-z0-9]{1}/g).map(function(v) {
        return parseInt("" + v + v, 16);
    }) : // https://stackoverflow.com/a/42429333
    color.match(/[A-Za-z0-9]{2}/g).map(function(v) {
        return parseInt(v, 16);
    });
};
// From: https://stackoverflow.com/a/9493060/8513067
// Converts an HSL color value to RGB. Conversion formula
// adapted from http://en.wikipedia.org/wiki/HSL_color_space.
// Assumes h, s, and l are contained in the set [0, 1] and
// returns r, g, and b in the set [0, 255].
var $97d74f6ac49bbf5b$var$hslToRGB = function hslToRGB(h, s, l) {
    var r;
    var g;
    var b;
    if (s === 0 || s === '0') {
        // achromatic
        r = l;
        g = l;
        b = l;
    } else {
        var hue2rgb = function hue2rgb(p, q, inT) {
            var t = inT;
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 0.16666667) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 0.66666667) return p + (q - p) * (0.66666667 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 0.33333333);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 0.33333333);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255)
    ];
};
// allow for alpha: #RGB, #RGBA, #RRGGBB, or #RRGGBBAA
var $97d74f6ac49bbf5b$var$hexExp = /^#[A-Za-z0-9]{3,4}$|^#[A-Za-z0-9]{6,8}$/;
var $97d74f6ac49bbf5b$var$rgbExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?\)/;
var $97d74f6ac49bbf5b$var$rgbaExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([.0-9]*)\s?\)/;
// e.g. hsl(240, 60%, 50%)
var $97d74f6ac49bbf5b$var$hslExp = /^hsla?\(\s?([0-9]*)\s?,\s?([0-9]*)%?\s?,\s?([0-9]*)%?\s?.*?\)/;
var $97d74f6ac49bbf5b$export$6d62a0650580a0ff = function canExtractRGBArray(color) {
    return $97d74f6ac49bbf5b$var$hexExp.test(color) || $97d74f6ac49bbf5b$var$rgbExp.test(color) || $97d74f6ac49bbf5b$var$rgbaExp.test(color) || $97d74f6ac49bbf5b$var$hslExp.test(color);
};
var $97d74f6ac49bbf5b$export$5bcd173cc9a0dca = function getRGBArray(color) {
    if ($97d74f6ac49bbf5b$var$hexExp.test(color)) {
        var _parseHexToRGB = $97d74f6ac49bbf5b$var$parseHexToRGB(color), red = _parseHexToRGB[0], green = _parseHexToRGB[1], blue = _parseHexToRGB[2], alpha = _parseHexToRGB[3];
        return [
            red,
            green,
            blue,
            alpha !== undefined ? alpha / 255.0 : undefined
        ];
    }
    var match = color.match($97d74f6ac49bbf5b$var$rgbExp);
    if (match) return match.splice(1).map(function(v) {
        return parseInt(v, 10);
    });
    match = color.match($97d74f6ac49bbf5b$var$rgbaExp);
    if (match) return match.splice(1).map(function(v) {
        return parseFloat(v, 10);
    });
    match = color.match($97d74f6ac49bbf5b$var$hslExp);
    if (match) {
        var _match$splice$map = match.splice(1).map(function(v) {
            return parseInt(v, 10);
        }), h = _match$splice$map[0], s = _match$splice$map[1], l = _match$splice$map[2];
        return $97d74f6ac49bbf5b$var$hslToRGB(h / 360.0, s / 100.0, l / 100.0);
    }
    return color;
};
var $97d74f6ac49bbf5b$export$76249e090d1c76db = function colorIsDark(color) {
    if (color && $97d74f6ac49bbf5b$export$6d62a0650580a0ff(color)) {
        var _getRGBArray = $97d74f6ac49bbf5b$export$5bcd173cc9a0dca(color), red = _getRGBArray[0], green = _getRGBArray[1], blue = _getRGBArray[2], alpha = _getRGBArray[3];
        // if there is an alpha and it's greater than 50%, we can't really tell
        if (alpha < 0.5) return undefined;
        var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
        // From: http://www.had2know.com/technology/color-contrast-calculator-web-design.html
        // Above domain is no longer registered.
        return brightness < 125;
    }
    return undefined;
};
var $97d74f6ac49bbf5b$export$c24a0a5c5129b2e1 = function getRGBA(color, opacity) {
    if (color && $97d74f6ac49bbf5b$export$6d62a0650580a0ff(color)) {
        var _getRGBArray2 = $97d74f6ac49bbf5b$export$5bcd173cc9a0dca(color), red = _getRGBArray2[0], green = _getRGBArray2[1], blue = _getRGBArray2[2], alpha = _getRGBArray2[3];
        var normalizedAlpha;
        if (opacity !== undefined) normalizedAlpha = opacity;
        else if (alpha !== undefined) normalizedAlpha = alpha;
        else normalizedAlpha = 1;
        return "rgba(" + red + ", " + green + ", " + blue + ", " + normalizedAlpha + ")";
    }
    return undefined;
};

});


parcelRegister("dOlbm", function(module, exports) {

$parcel$export(module.exports, "useForwardedRef", () => $a0e0603bdad85e8a$export$61dc559f8a0b9bcf);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $a0e0603bdad85e8a$export$61dc559f8a0b9bcf = function useForwardedRef(ref) {
    var innerRef = (0, $2NacA.useRef)(null);
    (0, $2NacA.useImperativeHandle)(ref, function() {
        return innerRef.current;
    }, [
        innerRef
    ]);
    return innerRef;
};

});

parcelRegister("xazbe", function(module, exports) {

$parcel$export(module.exports, "StyledIcon", () => $063b477408816c4c$export$7c8f159da0dc916, (v) => $063b477408816c4c$export$7c8f159da0dc916 = v);
var $063b477408816c4c$export$1e511d4a378977f5;
var $063b477408816c4c$export$7c8f159da0dc916;
"use strict";
$063b477408816c4c$export$1e511d4a378977f5 = true;
$063b477408816c4c$export$7c8f159da0dc916 = void 0;

var $063b477408816c4c$var$_react = $063b477408816c4c$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $063b477408816c4c$var$_styledComponents = $063b477408816c4c$var$_interopRequireWildcard((parcelRequire("f5efw")));

var $bXAnV = parcelRequire("bXAnV");

var $jvU3m = parcelRequire("jvU3m");
var $063b477408816c4c$var$_excluded = [
    "a11yTitle",
    "color",
    "size",
    "theme"
];
function $063b477408816c4c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($063b477408816c4c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $063b477408816c4c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $063b477408816c4c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $063b477408816c4c$var$_extends() {
    return $063b477408816c4c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $063b477408816c4c$var$_extends.apply(null, arguments);
}
function $063b477408816c4c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $063b477408816c4c$var$normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = normalizeColor(result, theme, dark);
    return result;
};
var $063b477408816c4c$var$colorStyle = function colorStyle(name, value, theme, required) {
    return (0, $063b477408816c4c$var$_styledComponents.css)([
        "",
        ":",
        ";"
    ], name, $063b477408816c4c$var$normalizeColor(value, theme, required));
};
var $063b477408816c4c$var$colorCss = (0, $063b477408816c4c$var$_styledComponents.css)([
    "",
    " ",
    " g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:inherit;stroke:none;}"
], function(props) {
    return $063b477408816c4c$var$colorStyle('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function(props) {
    return $063b477408816c4c$var$colorStyle('stroke', props.color || props.theme.global.colors.icon, props.theme);
});
var $063b477408816c4c$var$IconInner = /*#__PURE__*/ (0, $063b477408816c4c$var$_react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, color = _ref.color, size = _ref.size, theme = _ref.theme, rest = $063b477408816c4c$var$_objectWithoutPropertiesLoose(_ref, $063b477408816c4c$var$_excluded);
    return /*#__PURE__*/ $063b477408816c4c$var$_react["default"].createElement("svg", $063b477408816c4c$var$_extends({
        ref: ref,
        "aria-label": a11yTitle
    }, rest));
});
$063b477408816c4c$var$IconInner.displayName = 'Icon';
var $063b477408816c4c$var$StyledIcon = $063b477408816c4c$export$7c8f159da0dc916 = (0, $063b477408816c4c$var$_styledComponents["default"])($063b477408816c4c$var$IconInner).withConfig({
    // don't let height attribute leak to DOM
    // https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function shouldForwardProp(prop) {
        return ![
            'height',
            'width'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-ofa7kd-0"
})([
    "display:inline-block;flex:0 0 auto;",
    " ",
    " ",
    " ",
    ""
], function(_ref2) {
    var _size$match;
    var _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? 'medium' : _ref2$size, theme = _ref2.theme, viewBox = _ref2.viewBox;
    var _split = (viewBox || '0 0 24 24').split(' '), w = _split[2], h = _split[3];
    var scale = w / h;
    var size = theme.icon.size[sizeProp] || sizeProp;
    var dimension = (0, $jvU3m.parseMetricToNum)(size);
    // grab rem, em, px value from resolved size value
    var unit = ((_size$match = size.match(/[a-z]+$/)) == null ? void 0 : _size$match[0]) || 'px';
    if (w < h) return "\n      width: " + dimension + unit + ";\n      height: " + dimension / scale + unit + ";\n    ";
    if (h < w) return "\n      width: " + dimension * scale + unit + ";\n      height: " + dimension + unit + ";\n    ";
    return "\n      width: " + dimension + unit + ";\n      height: " + dimension + unit + ";\n    ";
}, function(_ref3) {
    var color = _ref3.color;
    return color !== 'plain' && $063b477408816c4c$var$colorCss;
}, function(props) {
    return (props.height || props.width) && (0, $jvU3m.iconPad)(props);
}, function(_ref4) {
    var theme = _ref4.theme;
    return theme && theme.icon.extend;
});
$063b477408816c4c$var$StyledIcon.defaultProps = {};
Object.setPrototypeOf($063b477408816c4c$var$StyledIcon.defaultProps, $bXAnV.defaultProps);

});
parcelRegister("bXAnV", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $8b516db467d45267$export$9c21a3269931e1e6, (v) => $8b516db467d45267$export$9c21a3269931e1e6 = v);
var $8b516db467d45267$export$1e511d4a378977f5;
var $8b516db467d45267$export$582fa4e2a9b13dde;
var $8b516db467d45267$export$9c21a3269931e1e6;
"use strict";
$8b516db467d45267$export$1e511d4a378977f5 = true;
$8b516db467d45267$export$582fa4e2a9b13dde = $8b516db467d45267$export$9c21a3269931e1e6 = void 0;

var $jvU3m = parcelRequire("jvU3m");

var $7xtb2 = parcelRequire("7xtb2");
var $8b516db467d45267$var$defaultProps = $8b516db467d45267$export$9c21a3269931e1e6 = {
    theme: $7xtb2.base
};
var $8b516db467d45267$var$extendDefaultTheme = $8b516db467d45267$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $8b516db467d45267$var$defaultProps.theme = (0, $jvU3m.deepMerge)($7xtb2.base, theme);
};

});
parcelRegister("jvU3m", function(module, exports) {

$parcel$export(module.exports, "deepMerge", () => $e34c6497a7c391c8$export$6969335ea1e4e77c, (v) => $e34c6497a7c391c8$export$6969335ea1e4e77c = v);
$parcel$export(module.exports, "iconPad", () => $e34c6497a7c391c8$export$bce3b4bc0d2e7a0e, (v) => $e34c6497a7c391c8$export$bce3b4bc0d2e7a0e = v);
$parcel$export(module.exports, "parseMetricToNum", () => $e34c6497a7c391c8$export$333c2219d71d27ce, (v) => $e34c6497a7c391c8$export$333c2219d71d27ce = v);
$parcel$export(module.exports, "useScaleProps", () => $e34c6497a7c391c8$export$56a2e46cd4a7c217, (v) => $e34c6497a7c391c8$export$56a2e46cd4a7c217 = v);
var $e34c6497a7c391c8$export$1e511d4a378977f5;
var $e34c6497a7c391c8$export$6969335ea1e4e77c;
var $e34c6497a7c391c8$export$3794798abb123ff6;
var $e34c6497a7c391c8$export$2e2bcd8739ae039;
var $e34c6497a7c391c8$export$bce3b4bc0d2e7a0e;
var $e34c6497a7c391c8$export$a6cdc56e425d0d0a;
var $e34c6497a7c391c8$export$333c2219d71d27ce;
var $e34c6497a7c391c8$export$56a2e46cd4a7c217;
"use strict";
$e34c6497a7c391c8$export$1e511d4a378977f5 = true;
$e34c6497a7c391c8$export$6969335ea1e4e77c = $e34c6497a7c391c8$var$deepMerge;
$e34c6497a7c391c8$export$3794798abb123ff6 = $e34c6497a7c391c8$export$2e2bcd8739ae039 = void 0;
$e34c6497a7c391c8$export$bce3b4bc0d2e7a0e = $e34c6497a7c391c8$var$iconPad;
$e34c6497a7c391c8$export$a6cdc56e425d0d0a = $e34c6497a7c391c8$var$isObject;
$e34c6497a7c391c8$export$333c2219d71d27ce = void 0;
$e34c6497a7c391c8$export$56a2e46cd4a7c217 = $e34c6497a7c391c8$var$useScaleProps;

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");
function $e34c6497a7c391c8$var$_extends() {
    return $e34c6497a7c391c8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e34c6497a7c391c8$var$_extends.apply(null, arguments);
}
function $e34c6497a7c391c8$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $e34c6497a7c391c8$var$deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $e34c6497a7c391c8$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($e34c6497a7c391c8$var$isObject(source)) Object.keys(source).forEach(function(key) {
            if ($e34c6497a7c391c8$var$isObject(source[key])) {
                if (!output[key]) output[key] = $e34c6497a7c391c8$var$_extends({}, source[key]);
                else output[key] = $e34c6497a7c391c8$var$deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
}
var $e34c6497a7c391c8$var$parseMetricToNum = $e34c6497a7c391c8$export$333c2219d71d27ce = function parseMetricToNum(string) {
    if (string === void 0) string = '';
    return parseFloat(string.match(/\d+(\.\d+)?/), 10);
};
// scaleProps sets path properties to prevent scaling the stroke
// when the theme doesn't want it for small sizes.
function $e34c6497a7c391c8$var$useScaleProps(props) {
    var _theme$icon;
    var theme = (0, $2NacA.useContext)($f5efw.ThemeContext);
    var size = props.size;
    var result = {};
    if (theme != null && (_theme$icon = theme.icon) != null && _theme$icon.disableScaleDown) {
        var dimension = $e34c6497a7c391c8$var$parseMetricToNum(theme.icon.size[size] || size);
        if (dimension < 24) result.vectorEffect = 'non-scaling-stroke';
    }
    return result;
}
var $e34c6497a7c391c8$var$calculatePad = function calculatePad(value, iconDimension) {
    return (value - iconDimension) / 2 + "px";
};
// iconPad applies padding to icon to ensure it aligns
// with text line-height or desired width
function $e34c6497a7c391c8$var$iconPad(props) {
    var _theme$icon2, _theme$text, _theme$text2;
    var height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, width = props.width;
    var theme = (0, $2NacA.useContext)($f5efw.ThemeContext);
    var iconDimension = $e34c6497a7c391c8$var$parseMetricToNum((theme == null || (_theme$icon2 = theme.icon) == null || (_theme$icon2 = _theme$icon2.size) == null ? void 0 : _theme$icon2[size]) || size);
    var style = '';
    // browser default is 16px, but accommodate if app has modified
    // include fallback in case window is undefined
    var FALLBACK = '16px';
    var rootFontSize = $e34c6497a7c391c8$var$parseMetricToNum(FALLBACK);
    if (typeof window !== 'undefined') {
        var _window;
        rootFontSize = $e34c6497a7c391c8$var$parseMetricToNum(((_window = window) == null ? void 0 : _window.getComputedStyle(document.body).getPropertyValue('font-size')) || FALLBACK);
    }
    if (height && theme != null && (_theme$text = theme.text) != null && (_theme$text = _theme$text[height]) != null && _theme$text.height) {
        // the unit on theme text
        var _theme$text$height$he = theme.text[height].height.match(/(px|rem)/), unit = _theme$text$height$he[0];
        var lineHeight = $e34c6497a7c391c8$var$parseMetricToNum(theme.text[height].height);
        if (unit === 'rem') lineHeight *= rootFontSize;
        if (lineHeight > iconDimension) {
            var pad = $e34c6497a7c391c8$var$calculatePad(lineHeight, iconDimension);
            style += "padding-top: " + pad + "; padding-bottom: " + pad + ";";
        }
    }
    if (width && theme != null && (_theme$text2 = theme.text) != null && (_theme$text2 = _theme$text2[width]) != null && _theme$text2.height) {
        // the unit on theme text
        var _theme$text$width$hei = theme.text[width].height.match(/(px|rem)/), _unit = _theme$text$width$hei[0];
        var desiredWidth = $e34c6497a7c391c8$var$parseMetricToNum(theme.text[width].height);
        if (_unit === 'rem') desiredWidth *= rootFontSize;
        if (desiredWidth > iconDimension) {
            var _pad = $e34c6497a7c391c8$var$calculatePad(desiredWidth, iconDimension);
            style += "padding-left: " + _pad + "; padding-right: " + _pad + ";";
        }
    }
    return style;
}
// ensure icons that rely on urls don't have id collision
// Date.now + Math.random is unique enough for icon use cases
var $e34c6497a7c391c8$var$generatePrefix = $e34c6497a7c391c8$export$3794798abb123ff6 = function generatePrefix(name) {
    return "_grommeticons-" + name + "-" + (Date.now() + Math.random());
};
var $e34c6497a7c391c8$var$_default = $e34c6497a7c391c8$export$2e2bcd8739ae039 = {
    deepMerge: $e34c6497a7c391c8$var$deepMerge,
    isObject: $e34c6497a7c391c8$var$isObject,
    parseMetricToNum: $e34c6497a7c391c8$var$parseMetricToNum,
    iconPad: $e34c6497a7c391c8$var$iconPad,
    useScaleProps: $e34c6497a7c391c8$var$useScaleProps
};

});

parcelRegister("7xtb2", function(module, exports) {

$parcel$export(module.exports, "base", () => $57d23f6b2f5bdd03$export$e2253033e6e1df16, (v) => $57d23f6b2f5bdd03$export$e2253033e6e1df16 = v);
var $57d23f6b2f5bdd03$export$1e511d4a378977f5;
var $57d23f6b2f5bdd03$export$e2253033e6e1df16;
"use strict";
$57d23f6b2f5bdd03$export$1e511d4a378977f5 = true;
$57d23f6b2f5bdd03$export$e2253033e6e1df16 = void 0;

var $aSiTx = parcelRequire("aSiTx");
$57d23f6b2f5bdd03$export$e2253033e6e1df16 = $aSiTx.base;

});
parcelRegister("aSiTx", function(module, exports) {

$parcel$export(module.exports, "base", () => $7ead9a9db026217d$export$e2253033e6e1df16, (v) => $7ead9a9db026217d$export$e2253033e6e1df16 = v);
var $7ead9a9db026217d$export$1e511d4a378977f5;
var $7ead9a9db026217d$export$e2253033e6e1df16;
"use strict";
$7ead9a9db026217d$export$1e511d4a378977f5 = true;
$7ead9a9db026217d$export$e2253033e6e1df16 = void 0;
var $7ead9a9db026217d$var$base = $7ead9a9db026217d$export$e2253033e6e1df16 = {
    global: {
        colors: {
            icon: '#666666'
        }
    },
    icon: {
        size: {
            small: '12px',
            medium: '24px',
            large: '48px',
            xlarge: '96px'
        }
    }
};

});




parcelRegister("gpz6W", function(module, exports) {

$parcel$export(module.exports, "FormClose", () => $bf2a37735bfe02dd$export$fe20cfcdd41aa0ef, (v) => $bf2a37735bfe02dd$export$fe20cfcdd41aa0ef = v);
var $bf2a37735bfe02dd$export$1e511d4a378977f5;
var $bf2a37735bfe02dd$export$fe20cfcdd41aa0ef;
"use strict";
$bf2a37735bfe02dd$export$1e511d4a378977f5 = true;
$bf2a37735bfe02dd$export$fe20cfcdd41aa0ef = void 0;

var $bf2a37735bfe02dd$var$_react = $bf2a37735bfe02dd$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $bf2a37735bfe02dd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bf2a37735bfe02dd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bf2a37735bfe02dd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $bf2a37735bfe02dd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $bf2a37735bfe02dd$var$_extends() {
    return $bf2a37735bfe02dd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bf2a37735bfe02dd$var$_extends.apply(null, arguments);
}
var $bf2a37735bfe02dd$var$FormClose = $bf2a37735bfe02dd$export$fe20cfcdd41aa0ef = /*#__PURE__*/ (0, $bf2a37735bfe02dd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $bf2a37735bfe02dd$var$_react["default"].createElement($xazbe.StyledIcon, $bf2a37735bfe02dd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormClose"
    }, props), /*#__PURE__*/ $bf2a37735bfe02dd$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 7 10 10M7 17 17 7"
    }));
});
$bf2a37735bfe02dd$var$FormClose.displayName = 'FormClose';

});

parcelRegister("054Ni", function(module, exports) {

$parcel$export(module.exports, "Subtract", () => $00f42fc457fd4030$export$8bc67ae85ef4b74f, (v) => $00f42fc457fd4030$export$8bc67ae85ef4b74f = v);
var $00f42fc457fd4030$export$1e511d4a378977f5;
var $00f42fc457fd4030$export$8bc67ae85ef4b74f;
"use strict";
$00f42fc457fd4030$export$1e511d4a378977f5 = true;
$00f42fc457fd4030$export$8bc67ae85ef4b74f = void 0;

var $00f42fc457fd4030$var$_react = $00f42fc457fd4030$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $00f42fc457fd4030$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($00f42fc457fd4030$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $00f42fc457fd4030$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $00f42fc457fd4030$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $00f42fc457fd4030$var$_extends() {
    return $00f42fc457fd4030$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00f42fc457fd4030$var$_extends.apply(null, arguments);
}
var $00f42fc457fd4030$var$Subtract = $00f42fc457fd4030$export$8bc67ae85ef4b74f = /*#__PURE__*/ (0, $00f42fc457fd4030$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $00f42fc457fd4030$var$_react["default"].createElement($xazbe.StyledIcon, $00f42fc457fd4030$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Subtract"
    }, props), /*#__PURE__*/ $00f42fc457fd4030$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20"
    }));
});
$00f42fc457fd4030$var$Subtract.displayName = 'Subtract';

});

parcelRegister("fzxBh", function(module, exports) {

$parcel$export(module.exports, "parseMetricToNum", () => $b5643032252e2300$export$333c2219d71d27ce);
$parcel$export(module.exports, "breakpointStyle", () => $b5643032252e2300$export$2180d12f0a299a89);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");
var $b5643032252e2300$export$333c2219d71d27ce = function parseMetricToNum(metric) {
    if (typeof metric === 'number') return metric;
    metric.match(/\s/);
    return parseFloat(metric.match(/\d+(\.\d+)?/), 10);
};
var $b5643032252e2300$export$d3510c15440bd3f3 = function edgeToNum(size, theme) {
    return size ? $b5643032252e2300$export$333c2219d71d27ce(theme.global.edgeSize[size] || size) : 0;
};
var $b5643032252e2300$export$85e3c3ca0c6fb93 = function fontSize(size, lineHeight) {
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], function(props) {
        return $b5643032252e2300$export$333c2219d71d27ce(size) / $b5643032252e2300$export$333c2219d71d27ce(props.theme.global.font.size) * 1 + "rem";
    }, function(props) {
        return lineHeight || Math.ceil($b5643032252e2300$export$333c2219d71d27ce(size) / $b5643032252e2300$export$333c2219d71d27ce(props.theme.global.lineHeight)) * ($b5643032252e2300$export$333c2219d71d27ce(props.theme.global.lineHeight) / $b5643032252e2300$export$333c2219d71d27ce(size)) + "px";
    });
};
var $b5643032252e2300$export$2180d12f0a299a89 = function breakpointStyle(breakpoint, content, responsive) {
    var px = typeof (breakpoint == null ? void 0 : breakpoint.value) === 'string' && breakpoint.value.endsWith('px') ? '' : 'px';
    var st = responsive === 'container' ? (0, $f5efw.css)([
        "@container ",
        "{",
        ";}"
    ], breakpoint.value && "(max-width: " + breakpoint.value + px + ")", content) : (0, $f5efw.css)([
        "@media only screen ",
        "{",
        ";}"
    ], breakpoint.value && "and (max-width: " + breakpoint.value + px + ")", content);
    return st;
};
var $b5643032252e2300$export$fdd5e64c0e8495bb = function findAllByType(component, type) {
    var matches = [];
    if (component.type === type) matches.push(component);
    if (component.children) component.children.forEach(function(child) {
        matches = matches.concat($b5643032252e2300$export$fdd5e64c0e8495bb(child, type));
    });
    return matches;
};
var $b5643032252e2300$export$319d1f43f7cd3019 = function getAvailableAtBadge(availableAt, componentType) {
    return [
        {
            url: "https://storybook.grommet.io/?selectedKind=" + componentType + "-" + availableAt + "&full=0&stories=1&panelRight=0",
            badge: 'https://cdn-images-1.medium.com/fit/c/120/120/1*TD1P0HtIH9zF0UEH28zYtw.png',
            label: 'Storybook'
        },
        {
            url: "https://codesandbox.io/s/github/grommet/grommet-sandbox?initialpath=/" + availableAt.toLowerCase() + "&module=%2Fsrc%2F" + availableAt + ".js",
            badge: 'https://codesandbox.io/static/img/play-codesandbox.svg',
            label: 'CodeSandbox'
        }
    ];
};

});

parcelRegister("2O6LY", function(module, exports) {

$parcel$export(module.exports, "styledComponentsConfig", () => $20b581352a126449$export$373e75d802fd707);
$parcel$export(module.exports, "baseStyle", () => $20b581352a126449$export$360b744af11007ac);
$parcel$export(module.exports, "controlBorderStyle", () => $20b581352a126449$export$717407de81592eca);
$parcel$export(module.exports, "getInputIconPad", () => $20b581352a126449$export$633dd676a1e7a50a);
$parcel$export(module.exports, "edgeStyle", () => $20b581352a126449$export$944a9710f9445eee);
$parcel$export(module.exports, "fillStyle", () => $20b581352a126449$export$7d12e60b29024244);
$parcel$export(module.exports, "focusStyle", () => $20b581352a126449$export$efbff472cb39d8b);
$parcel$export(module.exports, "unfocusStyle", () => $20b581352a126449$export$525440aaa2c64805);
$parcel$export(module.exports, "getInputPadBySide", () => $20b581352a126449$export$c98305b6d8dc560);
$parcel$export(module.exports, "inputStyle", () => $20b581352a126449$export$533edcdef9a0af13);
$parcel$export(module.exports, "inputPadForIcon", () => $20b581352a126449$export$cd595fd57f72dbc4);
$parcel$export(module.exports, "overflowStyle", () => $20b581352a126449$export$5938e7adc3ab8d08);
$parcel$export(module.exports, "genericStyles", () => $20b581352a126449$export$a157b298d219a801);
$parcel$export(module.exports, "disabledStyle", () => $20b581352a126449$export$adf3fcef8e5e1347);
$parcel$export(module.exports, "sizeStyle", () => $20b581352a126449$export$cb60038e9cf9f581);
$parcel$export(module.exports, "plainInputStyle", () => $20b581352a126449$export$f9510e7ca63c26e5);
$parcel$export(module.exports, "elevationStyle", () => $20b581352a126449$export$b4ff7c828301ce9f);
$parcel$export(module.exports, "kindPartStyles", () => $20b581352a126449$export$73d7bd5e5b0271ce);
$parcel$export(module.exports, "roundStyle", () => $20b581352a126449$export$98483643daf52539);
$parcel$export(module.exports, "textAlignStyle", () => $20b581352a126449$export$4fc8e4871b69e1d6);
$parcel$export(module.exports, "alignStyle", () => $20b581352a126449$export$f530b7ab00e4c68d);
$parcel$export(module.exports, "alignContentStyle", () => $20b581352a126449$export$93b5fb4351939c1c);
$parcel$export(module.exports, "widthStyle", () => $20b581352a126449$export$c12f8e3e33f3bef7);
$parcel$export(module.exports, "heightStyle", () => $20b581352a126449$export$9f8046d1e2885811);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5h15o = parcelRequire("5h15o");

var $jQHd2 = parcelRequire("jQHd2");

var $d2fh4 = parcelRequire("d2fh4");

var $hRaYF = parcelRequire("hRaYF");

var $fzxBh = parcelRequire("fzxBh");
var $20b581352a126449$export$373e75d802fd707 = {
    shouldForwardProp: (0, $5h15o.default)
};
var $20b581352a126449$export$360b744af11007ac = (0, $f5efw.css)([
    "font-family:",
    ";font-size:",
    ";line-height:",
    ";font-weight:",
    ";",
    " ",
    " box-sizing:border-box;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"
], function(props) {
    return props.theme.global.font.family;
}, function(props) {
    return props.theme.global.font.size;
}, function(props) {
    return props.theme.global.font.height;
}, function(props) {
    return props.theme.global.font.weight;
}, function(props) {
    return props.theme.global.font.variant && "\n    font-variant:" + props.theme.global.font.variant + ";\n  ";
}, function(props) {
    return !props.plain && (0, $jQHd2.backgroundStyle)(props.theme.baseBackground, props.theme);
});
var $20b581352a126449$export$717407de81592eca = (0, $f5efw.css)([
    "border:",
    " solid ",
    ";border-radius:",
    ";"
], function(props) {
    return props.theme.global.control.border.width;
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.global.control.border.color || 'border', props.theme);
}, function(props) {
    return props.theme.global.control.border.radius;
});
var $20b581352a126449$export$633dd676a1e7a50a = function getInputIconPad(props) {
    var _props$theme, _props$theme2;
    var matchedIconSize = (_props$theme = props.theme) == null || (_props$theme = _props$theme.icon) == null || (_props$theme = _props$theme.size) == null ? void 0 : _props$theme[(props == null ? void 0 : props.size) || 'medium'];
    if ((_props$theme2 = props.theme) != null && (_props$theme2 = _props$theme2.icon) != null && _props$theme2.matchSize && matchedIconSize) return (0, $fzxBh.parseMetricToNum)(matchedIconSize) + (0, $fzxBh.parseMetricToNum)(props.theme.global.edgeSize.medium) + "px";
    return props.theme.global.edgeSize.large;
};
var $20b581352a126449$export$944a9710f9445eee = function edgeStyle(kind, data, responsive, responsiveBreakpoint, theme) {
    var breakpoint = (0, $hRaYF.getBreakpointStyle)(theme, responsiveBreakpoint);
    if (typeof data === 'string') {
        var value = theme.global.edgeSize[data] || data;
        var responsiveValue = responsive && breakpoint && breakpoint.edgeSize[data];
        return (0, $f5efw.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, value, responsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n        " + kind + ": " + responsiveValue + ";\n      ", responsive) : '');
    }
    var result = [];
    var horizontal = data.horizontal, vertical = data.vertical, top = data.top, bottom = data.bottom, left = data.left, right = data.right;
    // if horizontal and vertical are equal OR all sides are equal,
    // we can just return a single css value such as padding: 12px
    // instead of breaking out by sides.
    var horizontalVerticalEqual = horizontal && vertical && horizontal === vertical;
    var allSidesEqual = top && bottom && left && right && top === bottom === left === right;
    if (horizontalVerticalEqual || allSidesEqual) {
        // since the values will be the same between vertical & horizontal OR
        // left, right, top, & bottom, we can just choose one
        var allSidesValue = horizontalVerticalEqual ? horizontal : top;
        var allSidesResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[allSidesValue];
        return (0, $f5efw.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, theme.global.edgeSize[allSidesValue] || allSidesValue, allSidesResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n        " + kind + ": " + allSidesResponsiveValue + ";\n      ", responsive) : '');
    }
    if (horizontal) {
        var horizontalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[horizontal];
        result.push((0, $f5efw.css)([
            "",
            "-left:",
            ";",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[horizontal] || horizontal, kind, theme.global.edgeSize[horizontal] || horizontal, horizontalResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-left: " + horizontalResponsiveValue + ";\n          " + kind + "-right: " + horizontalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (vertical) {
        var verticalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[vertical];
        result.push((0, $f5efw.css)([
            "",
            "-top:",
            ";",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[vertical] || vertical, kind, theme.global.edgeSize[vertical] || vertical, verticalResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-top: " + verticalResponsiveValue + ";\n          " + kind + "-bottom: " + verticalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (top) {
        var topResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[top];
        result.push((0, $f5efw.css)([
            "",
            "-top:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[top] || top, topResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-top: " + topResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (bottom) {
        var bottomResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[bottom];
        result.push((0, $f5efw.css)([
            "",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[bottom] || bottom, bottomResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-bottom: " + bottomResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (left) {
        var leftResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[left];
        result.push((0, $f5efw.css)([
            "",
            "-left:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[left] || left, leftResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-left: " + leftResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (right) {
        var rightResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[right];
        result.push((0, $f5efw.css)([
            "",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[right] || right, rightResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-right: " + rightResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.start) {
        var startResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.start];
        result.push((0, $f5efw.css)([
            "",
            "-inline-start:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.start] || data.start, startResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-inline-start: " + startResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.end) {
        var endResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.end];
        result.push((0, $f5efw.css)([
            "",
            "-inline-end:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.end] || data.end, endResponsiveValue ? (0, $fzxBh.breakpointStyle)(breakpoint, "\n          " + kind + "-inline-end: " + endResponsiveValue + ";\n        ", responsive) : ''));
    }
    return result;
};
var $20b581352a126449$export$7d12e60b29024244 = function fillStyle(fillProp) {
    if (fillProp === 'horizontal') return 'width: 100%;';
    if (fillProp === 'vertical') return 'height: 100%;';
    if (fillProp) return "\n      width: 100%;\n      height: 100%;\n    ";
    return undefined;
};
var $20b581352a126449$var$focusStyles = function focusStyles(props, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, forceOutline = _ref.forceOutline, justBorder = _ref.justBorder, insetFocus = _ref.inset;
    var generateFocusStyle = function generateFocusStyle(focus) {
        var compoundFocusStyle = '';
        if (!focus || forceOutline && !focus.outline) {
            var color = (0, $d2fh4.normalizeColor)('focus', props.theme);
            if (color) return "outline: 2px solid " + color + ";";
            return ''; // native
        }
        if (focus.outline && (!focus.border || !justBorder)) {
            if (typeof focus.outline === 'object') {
                var _color = (0, $d2fh4.normalizeColor)(focus.outline.color || 'focus', props.theme);
                var size = focus.outline.size || '2px';
                var offset = focus.outline.offset || '0px';
                var outlineStyle = "\n        outline-offset: " + offset + ";\n        outline: " + size + " solid " + _color + ";\n      ";
                compoundFocusStyle += outlineStyle;
                if (!focus.twoColor) return outlineStyle;
            } else {
                var _outlineStyle = "outline: " + focus.outline + ";";
                compoundFocusStyle += _outlineStyle;
                if (!focus.twoColor) return _outlineStyle;
            }
        }
        if (focus.shadow && (!focus.border || !justBorder)) {
            if (typeof focus.shadow === 'object') {
                var _color2 = (0, $d2fh4.normalizeColor)(// If there is a focus.border.color, use that for shadow too.
                // This is for backwards compatibility in v2.
                focus.border && focus.border.color || focus.shadow.color || 'focus', props.theme);
                var _size = focus.shadow.size || '2px'; // backwards compatible default
                var blur = focus.shadow.blur || _size; // backwards compatible default
                var inset = focus.shadow.inset ? 'inset ' : '';
                var shadowStyle = "box-shadow: 0 0 " + blur + " " + _size + " " + _color2 + (inset ? " " + inset : '') + ";";
                compoundFocusStyle += shadowStyle;
                if (!focus.twoColor) return "\n        outline: none;\n      " + shadowStyle;
            } else {
                var _shadowStyle = "box-shadow: " + focus.shadow + ";";
                compoundFocusStyle += _shadowStyle;
                if (!focus.twoColor) return "outline: none; " + _shadowStyle;
            }
        }
        if (focus.border) {
            var _color3 = (0, $d2fh4.normalizeColor)(focus.border.color || 'focus', props.theme);
            var borderStyle = "border-color: " + _color3 + ";";
            compoundFocusStyle += borderStyle;
            if (!focus.twoColor) return "outline: none; " + borderStyle;
        }
        if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
        return ''; // defensive
    };
    if (insetFocus && props.theme.global.focus.inset) return generateFocusStyle(props.theme.global.focus.inset);
    return generateFocusStyle(props.theme.global.focus);
};
var $20b581352a126449$var$unfocusStyles = function unfocusStyles(props, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, forceOutline = _ref2.forceOutline, justBorder = _ref2.justBorder;
    var focus = props.theme.global.focus;
    var compoundFocusStyle = '';
    if (!focus || forceOutline && !focus.outline) {
        var color = (0, $d2fh4.normalizeColor)('focus', props.theme);
        if (color) return "outline: none;";
        return ''; // native
    }
    if (focus.outline && (!focus.border || !justBorder)) {
        if (typeof focus.outline === 'object') {
            var outlineStyle = "\n        outline-offset: 0px;\n        outline: none;\n      ";
            compoundFocusStyle += outlineStyle;
            if (!focus.twoColor) return "\n        outline-offset: 0px;\n        outline: none;\n      ";
        } else {
            var _outlineStyle2 = "outline: none;";
            compoundFocusStyle += _outlineStyle2;
            if (!focus.twoColor) return _outlineStyle2;
        }
    }
    if (focus.shadow && (!focus.border || !justBorder)) {
        if (typeof focus.shadow === 'object') {
            var shadowStyle = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += shadowStyle;
            if (!focus.twoColor) return shadowStyle;
        } else {
            var _shadowStyle2 = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += _shadowStyle2;
            if (!focus.twoColor) return _shadowStyle2;
        }
    }
    if (focus.border) {
        var borderStyle = "\n      outline: none;\n      border-color: none;\n    ";
        compoundFocusStyle += borderStyle;
        if (!focus.twoColor) return borderStyle;
    }
    if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
    return ''; // defensive
};
var $20b581352a126449$export$efbff472cb39d8b = function focusStyle(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, forceOutline = _ref3.forceOutline, inset = _ref3.inset, justBorder = _ref3.justBorder, skipSvgChildren = _ref3.skipSvgChildren;
    return (0, $f5efw.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $20b581352a126449$var$focusStyles(props) + "\n  }";
    }, function(props) {
        return $20b581352a126449$var$focusStyles(props, {
            forceOutline: forceOutline,
            inset: inset,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
var $20b581352a126449$export$525440aaa2c64805 = function unfocusStyle(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4, forceOutline = _ref4.forceOutline, justBorder = _ref4.justBorder, skipSvgChildren = _ref4.skipSvgChildren;
    return (0, $f5efw.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $20b581352a126449$var$unfocusStyles(props) + "\n  }";
    }, function(props) {
        return $20b581352a126449$var$unfocusStyles(props, {
            forceOutline: forceOutline,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// For backwards compatibility we need to add back the control border width.
// Based on how grommet was functioning prior to https://github.com/grommet/grommet/pull/3939,
// the padding was subtracting the border width from the theme value, but the
// placeholder was not. Because we're now placing the subtraction into the
// theme itself, we have to add back in the border width here.
// This is used for placeholder/icon in TextInput and MaskedInput.
var $20b581352a126449$var$adjustPad = function adjustPad(props, value) {
    return (0, $fzxBh.parseMetricToNum)((props.theme.global.edgeSize[value] || value) + "px") + (0, $fzxBh.parseMetricToNum)(props.theme.global.control.border.width + "px") + "px";
};
var $20b581352a126449$export$c98305b6d8dc560 = function getInputPadBySide(props, side) {
    if (typeof props.theme.global.input.padding !== 'object') {
        var _adjustedPad = $20b581352a126449$var$adjustPad(props, props.theme.global.input.padding);
        return _adjustedPad;
    }
    var orientation;
    if (side === 'left' || side === 'right') orientation = 'horizontal';
    else if (side === 'top' || side === 'bottom') orientation = 'vertical';
    else orientation = undefined;
    // if individual side isn't available, fallback to the
    // orientation if possible
    var pad = props.theme.global.input.padding[side] || props.theme.global.input.padding[orientation];
    var adjustedPad = $20b581352a126449$var$adjustPad(props, pad);
    return adjustedPad;
};
var $20b581352a126449$var$placeholderColor = (0, $f5efw.css)([
    "color:",
    ";"
], function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.global.colors.placeholder, props.theme);
});
var $20b581352a126449$var$placeholderStyle = (0, $f5efw.css)([
    "&::-webkit-input-placeholder{",
    ";}&::-moz-placeholder{",
    ";}&:-ms-input-placeholder{",
    ";}"
], $20b581352a126449$var$placeholderColor, $20b581352a126449$var$placeholderColor, $20b581352a126449$var$placeholderColor);
var $20b581352a126449$var$inputSizeStyle = function inputSizeStyle(props) {
    var data = props.theme.text[props.size];
    if (!data) return (0, $f5efw.css)([
        "font-size:",
        ";"
    ], props.size);
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $20b581352a126449$export$533edcdef9a0af13 = (0, $f5efw.css)([
    "box-sizing:border-box;",
    " font-family:inherit;border:none;-webkit-appearance:none;background:transparent;color:inherit;width:100%;",
    " ",
    " ",
    " margin:0;",
    " &:focus{",
    ";}",
    " ",
    " ::-webkit-search-decoration{-webkit-appearance:none;}&::-moz-focus-inner{border:none;outline:none;}&:-moz-placeholder,&::-moz-placeholder{opacity:1;}",
    ""
], function(props) {
    var _props$theme$text$pro;
    return "font-size: " + (props.theme.global.input.font.size ? ((_props$theme$text$pro = props.theme.text[props.theme.global.input.font.size]) == null ? void 0 : _props$theme$text$pro.size) || props.theme.global.input.font.size : 'inherit') + ";";
}, function(props) {
    return props.theme.global.input.font.height && "line-height: " + props.theme.global.input.font.height + ";";
}, function(props) {
    return props.theme.global.input.padding && typeof props.theme.global.input.padding !== 'object' ? // just the edgeStyle could remain. Currently, this is needed for
    // backwards compatibility since we are placing the calculation in
    // base.js
    "padding: " + ((0, $fzxBh.parseMetricToNum)(props.theme.global.edgeSize[props.theme.global.input.padding] || props.theme.global.input.padding) - (0, $fzxBh.parseMetricToNum)(props.theme.global.control.border.width)) + "px;" : $20b581352a126449$export$944a9710f9445eee('padding', props.theme.global.input.padding, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return(// for backwards compatibility, check if props.theme.global.input.weight
    (props.theme.global.input.weight || props.theme.global.input.font.weight) && (0, $f5efw.css)([
        "font-weight:",
        ";"
    ], props.theme.global.input.weight || props.theme.global.input.font.weight));
}, function(props) {
    return props.size && $20b581352a126449$var$inputSizeStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && $20b581352a126449$export$efbff472cb39d8b();
}, $20b581352a126449$export$717407de81592eca, $20b581352a126449$var$placeholderStyle, function(props) {
    return props.theme.global.input.extend;
});
var $20b581352a126449$export$cd595fd57f72dbc4 = (0, $f5efw.css)([
    "",
    ""
], function(props) {
    var pad = $20b581352a126449$export$633dd676a1e7a50a(props);
    return props.reverse ? "padding-right: " + pad + ";" : "padding-left: " + pad + ";";
});
var $20b581352a126449$export$5938e7adc3ab8d08 = function overflowStyle(overflowProp) {
    if (typeof overflowProp === 'string') return (0, $f5efw.css)([
        "overflow:",
        ";"
    ], overflowProp);
    return (0, $f5efw.css)([
        "",
        " ",
        ";"
    ], overflowProp.horizontal && "overflow-x: " + overflowProp.horizontal + ";", overflowProp.vertical && "overflow-y: " + overflowProp.vertical + ";");
};
var $20b581352a126449$var$ALIGN_SELF_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
    baseline: 'baseline'
};
var $20b581352a126449$export$a157b298d219a801 = (0, $f5efw.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.alignSelf && "align-self: " + $20b581352a126449$var$ALIGN_SELF_MAP[props.alignSelf] + ";";
}, function(props) {
    return props.gridArea && "grid-area: " + props.gridArea + ";";
}, function(props) {
    return props.margin && props.theme.global && $20b581352a126449$export$944a9710f9445eee('margin', props.margin, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var $20b581352a126449$export$adf3fcef8e5e1347 = function disabledStyle(componentStyle) {
    return (0, $f5efw.css)([
        "opacity:",
        ";cursor:default;"
    ], function(props) {
        return componentStyle || props.theme.global.control.disabled.opacity;
    });
};
var $20b581352a126449$export$cb60038e9cf9f581 = function sizeStyle(name, value, theme) {
    return (0, $f5efw.css)([
        "",
        ":",
        ";"
    ], name, theme.global.size[value] || value);
};
var $20b581352a126449$export$f9510e7ca63c26e5 = (0, $f5efw.css)([
    "outline:none;border:none;"
]);
var $20b581352a126449$export$b4ff7c828301ce9f = function elevationStyle(elevation) {
    return (0, $f5efw.css)([
        "box-shadow:",
        ";"
    ], function(props) {
        return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][elevation];
    });
};
var $20b581352a126449$export$73d7bd5e5b0271ce = function kindPartStyles(obj, theme, colorValue) {
    var styles = [];
    if (obj.padding || obj.pad) {
        // button uses `padding` but other components use Grommet `pad`
        var pad = obj.padding || obj.pad;
        if (pad.vertical || pad.horizontal) styles.push("padding: " + (theme.global.edgeSize[pad.vertical] || pad.vertical || 0) + " " + (theme.global.edgeSize[pad.horizontal] || pad.horizontal || 0) + ";");
        else styles.push("padding: " + (theme.global.edgeSize[pad] || pad || 0) + ";");
    }
    if (obj.background) styles.push((0, $jQHd2.backgroundStyle)(colorValue || obj.background, theme, obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined)));
    else if (obj.color) styles.push("color: " + (0, $d2fh4.normalizeColor)(obj.color, theme) + ";");
    if (obj.border) {
        if (obj.border.width) styles.push((0, $f5efw.css)([
            "border-style:solid;border-width:",
            ";"
        ], obj.border.width));
        if (obj.border.color) styles.push((0, $f5efw.css)([
            "border-color:",
            ";"
        ], (0, $d2fh4.normalizeColor)(!obj.background && colorValue || obj.border.color || 'border', theme)));
        if (obj.border.radius) styles.push((0, $f5efw.css)([
            "border-radius:",
            ";"
        ], obj.border.radius));
    } else if (obj.border === false) styles.push('border: none;');
    if (colorValue && !obj.border && !obj.background) styles.push("color: " + (0, $d2fh4.normalizeColor)(colorValue, theme) + ";");
    if (obj.font) {
        if (obj.font.size) styles.push("font-size: " + (theme.text[obj.font.size].size || obj.font.size) + ";");
        if (obj.font.height) styles.push("line-height: " + obj.font.height + ";");
        if (obj.font.weight) styles.push("font-weight: " + obj.font.weight + ";");
    }
    if (obj.opacity) {
        var opacity = obj.opacity === true ? theme.global.opacity.medium : theme.global.opacity[obj.opacity] || obj.opacity;
        styles.push("opacity: " + opacity + ";");
    }
    if (obj.elevation) styles.push($20b581352a126449$export$b4ff7c828301ce9f(obj.elevation));
    if (obj.extend) styles.push(obj.extend);
    return styles;
};
var $20b581352a126449$var$ROUND_MAP = {
    full: '100%'
};
var $20b581352a126449$export$98483643daf52539 = function roundStyle(data, responsive, theme) {
    var breakpoint = (0, $hRaYF.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    // fallback to edgeSize for backwards compatibility
    var radius = theme.global.radius ? 'radius' : 'edgeSize';
    var styles = [];
    if (typeof data === 'object') {
        var _breakpoint$radius;
        var size = $20b581352a126449$var$ROUND_MAP[data.size] || theme.global[radius][data.size || 'medium'] || data.size;
        var responsiveSize = responsive && breakpoint && ((_breakpoint$radius = breakpoint[radius]) == null ? void 0 : _breakpoint$radius[data.size]) && (breakpoint[radius][data.size] || data.size);
        if (data.corner === 'top') {
            styles.push((0, $f5efw.css)([
                "border-top-left-radius:",
                ";border-top-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-top-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'bottom') {
            styles.push((0, $f5efw.css)([
                "border-bottom-left-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          border-bottom-left-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'left') {
            styles.push((0, $f5efw.css)([
                "border-top-left-radius:",
                ";border-bottom-left-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-bottom-left-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'right') {
            styles.push((0, $f5efw.css)([
                "border-top-right-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          border-top-right-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner) {
            styles.push((0, $f5efw.css)([
                "border-",
                "-radius:",
                ";"
            ], data.corner, size));
            if (responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          border-" + data.corner + "-radius: " + responsiveSize + ";\n        ", responsive));
        } else {
            styles.push((0, $f5efw.css)([
                "border-radius:",
                ";"
            ], size));
            if (responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          border-radius: " + responsiveSize + ";\n        ", responsive));
        }
    } else {
        var _theme$global$radius, _breakpoint$radius2;
        var _size2 = data === true ? 'medium' : data;
        styles.push((0, $f5efw.css)([
            "border-radius:",
            ";"
        ], $20b581352a126449$var$ROUND_MAP[_size2] || ((_theme$global$radius = theme.global[radius]) == null ? void 0 : _theme$global$radius[_size2]) || _size2));
        var _responsiveSize = responsive && breakpoint && ((_breakpoint$radius2 = breakpoint[radius]) == null ? void 0 : _breakpoint$radius2[_size2]);
        if (_responsiveSize) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n        border-radius: " + _responsiveSize + ";\n      ", responsive));
    }
    return styles;
};
var $20b581352a126449$var$TEXT_ALIGN_MAP = {
    center: 'center',
    end: 'right',
    justify: 'justify',
    start: 'left'
};
var $20b581352a126449$export$4fc8e4871b69e1d6 = (0, $f5efw.css)([
    "text-align:",
    ";"
], function(props) {
    return $20b581352a126449$var$TEXT_ALIGN_MAP[props.textAlign];
});
var $20b581352a126449$var$ALIGN_ITEMS_MAP = {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $20b581352a126449$export$f530b7ab00e4c68d = (0, $f5efw.css)([
    "align-items:",
    ";"
], function(props) {
    var _ALIGN_ITEMS_MAP$prop;
    return (_ALIGN_ITEMS_MAP$prop = $20b581352a126449$var$ALIGN_ITEMS_MAP[props.align]) != null ? _ALIGN_ITEMS_MAP$prop : props.align;
});
var $20b581352a126449$var$ALIGN_CONTENT_MAP = {
    around: 'space-around',
    baseline: 'baseline',
    between: 'space-between',
    center: 'center',
    evenly: 'space-evenly',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $20b581352a126449$export$93b5fb4351939c1c = (0, $f5efw.css)([
    "align-content:",
    ";"
], function(props) {
    var _ALIGN_CONTENT_MAP$pr;
    return (_ALIGN_CONTENT_MAP$pr = $20b581352a126449$var$ALIGN_CONTENT_MAP[props.alignContent]) != null ? _ALIGN_CONTENT_MAP$pr : props.alignContent;
});
var $20b581352a126449$var$getSize = function getSize(theme, size) {
    return theme.global.size[size] || size;
};
var $20b581352a126449$var$widthObjectStyle = function widthObjectStyle(width, theme) {
    var result = [];
    if (width.max) result.push((0, $f5efw.css)([
        "max-width:",
        ";"
    ], $20b581352a126449$var$getSize(theme, width.max)));
    if (width.min) result.push((0, $f5efw.css)([
        "min-width:",
        ";"
    ], $20b581352a126449$var$getSize(theme, width.min)));
    if (width.width) result.push((0, $f5efw.css)([
        "width:",
        ";"
    ], $20b581352a126449$var$getSize(theme, width.width)));
    return result;
};
var $20b581352a126449$var$widthStringStyle = function widthStringStyle(width, theme) {
    return (0, $f5efw.css)([
        "width:",
        ";"
    ], $20b581352a126449$var$getSize(theme, width));
};
var $20b581352a126449$export$c12f8e3e33f3bef7 = function widthStyle(width, theme) {
    return typeof width === 'object' ? $20b581352a126449$var$widthObjectStyle(width, theme) : $20b581352a126449$var$widthStringStyle(width, theme);
};
var $20b581352a126449$var$heightObjectStyle = function heightObjectStyle(height, theme) {
    var result = [];
    if (height.max) result.push((0, $f5efw.css)([
        "max-height:",
        ";"
    ], $20b581352a126449$var$getSize(theme, height.max)));
    if (height.min) result.push((0, $f5efw.css)([
        "min-height:",
        ";"
    ], $20b581352a126449$var$getSize(theme, height.min)));
    // backwards compatibile
    if (height.width) result.push((0, $f5efw.css)([
        "height:",
        ";"
    ], $20b581352a126449$var$getSize(theme, height.height)));
    if (height.height) result.push((0, $f5efw.css)([
        "height:",
        ";"
    ], $20b581352a126449$var$getSize(theme, height.height)));
    return result;
};
var $20b581352a126449$var$heightStringStyle = function heightStringStyle(height, theme) {
    return (0, $f5efw.css)([
        "height:",
        ";"
    ], $20b581352a126449$var$getSize(theme, height));
};
var $20b581352a126449$export$9f8046d1e2885811 = function heightStyle(height, theme) {
    return typeof height === 'object' ? $20b581352a126449$var$heightObjectStyle(height, theme) : $20b581352a126449$var$heightStringStyle(height, theme);
};

});
parcelRegister("hRaYF", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $cfffe6d39e2b8160$export$1eb095b00b926404);
$parcel$export(module.exports, "getBreakpointStyle", () => $cfffe6d39e2b8160$export$56780e7bbaff61f9);
$parcel$export(module.exports, "deviceResponsive", () => $cfffe6d39e2b8160$export$f207ad4bd0549009);
$parcel$export(module.exports, "supportsContainerQueries", () => $cfffe6d39e2b8160$export$6fa2a3092624a8f5);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");
var $cfffe6d39e2b8160$export$1eb095b00b926404 = function getBreakpoint(viewportWidth, theme) {
    var sortedBreakpoints = Object.keys(theme.global.breakpoints).sort(function(a, b) {
        var first = theme.global.breakpoints[a];
        var second = theme.global.breakpoints[b];
        if (!first) return 1;
        if (!second) return -1;
        if (!first.value) return 1;
        if (!second.value) return -1;
        return first.value - second.value;
    });
    // the last breakpoint on the sorted array should have
    // no windowWidth boundaries
    var lastBreakpoint = sortedBreakpoints[sortedBreakpoints.length - 1];
    var result = sortedBreakpoints.find(function(name) {
        var breakpoint = theme.global.breakpoints[name];
        return !breakpoint.value || breakpoint.value >= viewportWidth ? name : false;
    });
    return result || lastBreakpoint;
};
var $cfffe6d39e2b8160$export$4244a62ea87934e9 = function getDeviceBreakpoint(type, theme) {
    return theme.global.deviceBreakpoints[type];
};
var $cfffe6d39e2b8160$export$56780e7bbaff61f9 = function getBreakpointStyle(theme, breakpointSize) {
    var breakpoint = breakpointSize && theme.global.breakpoints[breakpointSize] || {};
    if (!breakpoint.edgeSize) breakpoint.edgeSize = theme.global.edgeSize;
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    if (!breakpoint.radius) breakpoint.radius = theme.global.radius;
    if (!breakpoint.size) breakpoint.size = theme.global.size;
    return breakpoint;
};
var $cfffe6d39e2b8160$export$813595e92b2e7a6f = function isSmall(size) {
    return [
        'xsmall',
        'small'
    ].includes(size);
};
var $cfffe6d39e2b8160$export$f207ad4bd0549009 = function deviceResponsive(userAgent, theme) {
    // log('--deviceResponsive', userAgent, theme);
    /*
   * Regexes provided for mobile and tablet detection are meant to replace
   * a full-featured specific library due to contributing a considerable size
   * into the bundle.
   *
   * User agents found https://deviceatlas.com/blog/list-of-user-agent-strings
   */ if (userAgent) {
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent)) return $cfffe6d39e2b8160$export$4244a62ea87934e9('tablet', theme);
        if (/Mobile|iPhone|Android/.test(userAgent)) return $cfffe6d39e2b8160$export$4244a62ea87934e9('phone', theme);
        return $cfffe6d39e2b8160$export$4244a62ea87934e9('computer', theme);
    }
    return undefined;
};
// styled-components v6 and later do not have a withComponent
// method. We need v6 or later to support container queries.
var $cfffe6d39e2b8160$var$testComp = (0, $f5efw.default).div.withConfig({
    displayName: "responsive__testComp",
    componentId: "sc-336m7y-0"
})([
    "display:flex;"
]);
var $cfffe6d39e2b8160$export$6fa2a3092624a8f5 = function supportsContainerQueries() {
    var isPreV6 = typeof $cfffe6d39e2b8160$var$testComp.withComponent === 'function';
    return !isPreV6;
};

});


parcelRegister("2M0UK", function(module, exports) {

$parcel$export(module.exports, "format", () => $2050c6032e2bbf54$export$d9468344d3651243);
$parcel$export(module.exports, "MessageContext", () => $2050c6032e2bbf54$export$b060d577040138d8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $7JXYc = parcelRequire("7JXYc");
// options:
//   id: message id
//   messages: (optional) an object of message overrides
//   values: (optional) currently unused but in the future
//     will be an object with substitution values for
//     positional variables in the message text.
//   defaultMessage: (optional) default message to use if
//     the message isn't found elsewhere.
var $2050c6032e2bbf54$export$d9468344d3651243 = function format(options, messages) {
    var _options$id;
    // Message id's are hierarchical. For the component-specific
    // message objects passed as options.messages, just use the last
    // component in the id for backwards compatibility.
    //
    // For overall messages passed to grommet, use the hierarchical
    // id. For that messages object, the messages are in an object
    // hierarchy by component, similar to how the theme works.
    //
    // Applications that typically keep their messages in flat
    // objects with a single key string per message can override
    // this format function to get the grommet messages from
    // their bundles that way and don't need to pass the messages
    // themselves in this property, just the format function.
    var idParts = ((_options$id = options.id) == null ? void 0 : _options$id.split('.')) || [];
    // eslint-disable-next-line no-unsafe-optional-chaining
    var baseId = idParts[(idParts == null ? void 0 : idParts.length) - 1];
    var messageObj = messages;
    idParts.forEach(function(idPart) {
        if (typeof messageObj === 'object') messageObj = messageObj[idPart];
    });
    var message = (options.messages ? options.messages[baseId] : undefined) || messageObj || options.defaultMessage;
    var values = options.values;
    var newMessage = message;
    var tokens = message == null ? void 0 : message.match(/\{(.+?)\}/g);
    tokens == null || tokens.forEach(function(token) {
        var names = token.substr(1, token.length - 2);
        var value = values[names];
        newMessage = newMessage.replace(token, value);
    });
    return values ? newMessage : message;
};
var $2050c6032e2bbf54$var$defaultValue = {
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($7JXYc))),
    format: function format(options) {
        return $2050c6032e2bbf54$export$d9468344d3651243(options, (0, (/*@__PURE__*/$parcel$interopDefault($7JXYc))));
    }
};
var $2050c6032e2bbf54$export$b060d577040138d8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext($2050c6032e2bbf54$var$defaultValue);

});
parcelRegister("7JXYc", function(module, exports) {
module.exports = JSON.parse("{\"button\":{\"busy\":\"button is in a busy state\",\"success\":\"button action succeeded\"},\"calendar\":{\"previousMove\":\"Moved to {date}\",\"previous\":\"Go to {date}\",\"nextMove\":\"Moved to {date}\",\"next\":\"Go to {date}\"},\"cards\":{\"moved\":\"Card moved to position {source} of {target}\",\"reorderHint\":\"Use arrow keys to reorder cards. Changes are applied immediately.\",\"description\":\"sortable card\"},\"carousel\":{\"previous\":\"Go to slide {slide}\",\"next\":\"Go to slide {slide}\",\"jump\":\"Jump to slide {slide}\"},\"dateInput\":{\"openCalendar\":\"Press space to open calendar\",\"enterCalendar\":\"Calendar is open, use arrow keys and enter to select a date.\",\"exitCalendar\":\"Exited calendar dialog\",\"outOfBounds\":\"Date is out of the allowed range. Enter a date between {start} and {end}.\"},\"dateTimeInput\":{\"inputLabel\":\"Date and time input\",\"chooseDateTime\":\"Open date and time picker\",\"openDrop\":\"Press space to open date and time picker\",\"invalidDateTime\":\"Invalid date or time value\",\"activeSection\":\"{section} selected\",\"activeSectionValue\":\"{value}\",\"sectionDay\":\"day\",\"sectionMonth\":\"month\",\"sectionYear\":\"year\",\"sectionHours\":\"hours\",\"sectionMinutes\":\"minutes\",\"sectionSeconds\":\"seconds\",\"sectionMeridiem\":\"meridiem\"},\"dataChart\":{\"detailTitle\":\"Data chart\",\"detailFocus\":\"Use the left and right arrow keys to navigate the chart data.\"},\"dataFilters\":{\"clear\":\"Clear filters\",\"heading\":\"Filters\",\"open\":\"Open filters\",\"openSet\":{\"singular\":\"Open filters, {number} filter applied\",\"plural\":\"Open filters, {number} filters applied\"}},\"dataForm\":{\"submit\":\"Apply filters\"},\"dataSearch\":{\"label\":\"Search\",\"open\":\"Open search\"},\"dataSort\":{\"ascending\":\"Ascending\",\"by\":\"Sort by\",\"descending\":\"Descending\",\"direction\":\"Sort direction\",\"open\":\"Open sort\"},\"dataSummary\":{\"filtered\":\"{filteredTotal} results of {total} {items}\",\"filteredSingle\":\"{filteredTotal} result of {total} {items}\",\"items\":\"items\",\"itemsSingle\":\"item\",\"selected\":\"{selected} selected\",\"total\":\"{total} {items}\",\"totalSingle\":\"{total} {items}\"},\"dataTable\":{\"ascending\":\"sorted ascending, activate to sort descending\",\"collapse\":\"collapse {label}\",\"collapseAll\":\"collapse all\",\"decrease\":\"Decrease {headerText} column width\",\"descending\":\"sorted descending, activate to sort ascending\",\"increase\":\"Increase {headerText} column width\",\"expand\":\"expand {label}\",\"expandAll\":\"expand all\",\"resizerAria\":\"Resize {headerText} column\",\"rows\":\"rows\",\"rowsChanged\":\"Number of rows changed\",\"rowsSingle\":\"row\",\"searchBy\":\"Open search by {property}\",\"sortable\":\"sortable, activate to sort ascending\",\"total\":\"{total} {rows}\",\"totalSingle\":\"{total} {rows}\"},\"dataTableColumns\":{\"open\":\"Open column selector\",\"order\":\"Order columns\",\"pinned\":\"Column locked, order cannot be changed.\",\"select\":\"Select columns\",\"tip\":\"Manage columns\",\"selectAria\":\"Select which columns to show in the data table\",\"orderAria\":\"Reorder the visible columns in the data table\"},\"dataTableGroupBy\":{\"clear\":\"Clear group\",\"label\":\"Group by\"},\"dataView\":{\"label\":\"View\"},\"fileInput\":{\"alert\":{\"maxFile\":\"Error, {fileName} exceeds {maxFile} files limit.\",\"maxSize\":\"Error, {fileName} exceeds {maxSize} limit.\"},\"browse\":\"browse\",\"dropPrompt\":\"Drop file here or\",\"dropPromptMultiple\":\"Drop files here or\",\"files\":\"files\",\"maxFile\":\"Attach a maximum of {max} files only.\",\"maxSizeSingle\":\"The file is too large. Select a file no larger than {maxSize}.\",\"maxSizeMultiple\":{\"singular\":\"{fileName} file is too large. Select files which are no larger than {maxSize}.\",\"plural\":\"{numOfFiles} files are too large. Select files which are no larger than {maxSize}.\"},\"remove\":\"remove {fileName}\",\"removeAll\":\"remove all\"},\"form\":{\"invalid\":\"invalid\",\"required\":\"required\"},\"formField\":{\"maxCharacters\":{\"remaining\":{\"singular\":\"{number} character left\",\"plural\":\"{number} characters left\"},\"overLimit\":{\"singular\":\"{number} character over limit\",\"plural\":\"{number} characters over limit\"}}},\"input\":{\"readOnlyCopy\":{\"prompt\":\"Copy to clipboard\",\"validation\":\"Copied\"}},\"list\":{\"pinned\":\"Item pinned, order cannot be changed.\"},\"menu\":{\"openMenu\":\"Open Menu\",\"closeMenu\":\"Close Menu\"},\"meter\":{\"bar\":{\"singular\":\"Bar meter with value {meterValue} out of {max}\",\"plural\":\"Bar meter with values {meterValue} out of {max}\"},\"circle\":{\"singular\":\"Circle meter with value {meterValue} out of {max}\",\"plural\":\"Circle meter with values {meterValue} out of {max}\"},\"pie\":{\"singular\":\"Pie meter with value {meterValue} out of {max}\",\"plural\":\"Pie meter with values {meterValue} out of {max}\"},\"semicircle\":{\"singular\":\"Semicircle meter with value {meterValue} out of {max}\",\"plural\":\"Semicircle meter with values {meterValue} out of {max}\"}},\"notification\":{\"close\":\"Dismiss notification\"},\"pagination\":{\"stepLabel\":\"Items per page\",\"summary\":\"Showing {start}-{end} of {total}\",\"summaryNoItems\":\"0 items\"},\"rangeSelector\":{\"lower\":\"Lower Bounds\",\"upper\":\"Upper Bounds\"},\"select\":{\"optionsA11y\":\"list of options\",\"multiple\":\"multiple\",\"searchA11y\":\"Search options\",\"selected\":\"; Selected: {currentSelectedValue}\"},\"selectMultiple\":{\"clearAll\":\"Clear All\",\"clearAllA11y\":\"{selected} options selected. Clear all?\",\"open\":\"Open drop\",\"optionNotSelected\":\"{optionLabel} not selected\",\"optionsA11y\":\"list of options\",\"optionSelected\":\"{optionLabel} selected\",\"search\":\"Search to filter options\",\"selectAll\":\"Select All\",\"selectAllA11y\":\"Select all {total} options\",\"selectDrop\":\"Select dropdown\",\"selected\":\"{selected} selected\",\"selectedOfTotal\":\"{selected} selected of {total}\",\"selectedOptions\":\"Selected options\",\"showMore\":\"+ {remaining} more\",\"summarizedValue\":\"{selected} selected\"},\"skipLinks\":{\"skipTo\":\"Skip To:\"},\"stepper\":{\"progress\":\"Progress\",\"step\":\"Step {step} of {total}: {title}\"},\"tabs\":{\"nextTab\":\"Next Tab\",\"previousTab\":\"Previous Tab\",\"tabContents\":\"Tab Contents\"},\"tag\":{\"removeLabel\":{\"nameAndValue\":\"Remove {name}: {value}\",\"valueOnly\":\"Remove {value}\"}},\"textInput\":{\"enterSelect\":\"(Press Enter to Select)\",\"hidePassword\":\"Hide password\",\"showPassword\":\"Show password\",\"suggestionsCount\":\"suggestions available\",\"suggestionsExist\":\"This input has suggestions use arrow keys to navigate\",\"suggestionIsOpen\":\"Suggestions drop is open, continue to use arrow keys to navigate\"},\"timeInput\":{\"inputLabel\":\"Time input\",\"chooseTime\":\"Choose time\",\"currentValue\":\"Current time {hour}:{minute}:{second}{period}\",\"activeSection\":\"{section} selected\",\"activeSectionValue\":\"{value} {section}\",\"activePeriodValue\":\"{period} period\",\"openDrop\":\"Press space to open time picker\",\"invalidTime\":\"Invalid time value\",\"sectionHours\":\"hours\",\"sectionMinutes\":\"minutes\",\"sectionSeconds\":\"seconds\",\"sectionMeridiem\":\"meridiem\"},\"video\":{\"audioDescriptions\":\"video audio description\",\"captions\":\"closed captions\",\"closeMenu\":\"close menu\",\"description\":\"video audio description\",\"fullScreen\":\"full screen\",\"progressMeter\":\"video progress\",\"scrubber\":\"scrubber\",\"openMenu\":\"open menu\",\"pauseButton\":\"pause\",\"playButton\":\"play\",\"volumeDown\":\"volume down\",\"volumeUp\":\"volume up\"},\"wizard\":{\"previous\":\"Previous\",\"next\":\"Next\",\"skip\":\"Skip\",\"cancel\":\"Cancel\",\"close\":\"Close\",\"complete\":\"Complete\",\"stepHeader\":{\"counter\":\"Step {step} of {total}\"},\"progress\":\"Wizard progress\",\"validationError\":\"Please complete required fields.\"}}");

});


parcelRegister("2p9yA", function(module, exports) {

$parcel$export(module.exports, "genericProps", () => $1c055456029b0355$export$ffe37ff34eeb9e21);
$parcel$export(module.exports, "OVERFLOW_VALUES", () => $1c055456029b0355$export$5b49d53be3c37c69);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $lwlwr = parcelRequire("lwlwr");
var $1c055456029b0355$export$eb55925152858bde = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string;
var $1c055456029b0355$export$5dd51d61a30477bc = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'baseline',
        'center',
        'end',
        'start',
        'stretch'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
]);
var $1c055456029b0355$var$ANIMATION_TYPE = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
    'fadeIn',
    'fadeOut',
    'jiggle',
    'pulse',
    'rotateLeft',
    'rotateRight',
    'slideUp',
    'slideDown',
    'slideLeft',
    'slideRight',
    'zoomIn',
    'zoomOut'
]);
var $1c055456029b0355$var$ANIMATION_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
    type: $1c055456029b0355$var$ANIMATION_TYPE,
    delay: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ])
});
var $1c055456029b0355$export$6054792fa1afa765 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    $1c055456029b0355$var$ANIMATION_TYPE,
    $1c055456029b0355$var$ANIMATION_SHAPE,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        $1c055456029b0355$var$ANIMATION_TYPE,
        $1c055456029b0355$var$ANIMATION_SHAPE
    ]))
]);
var $1c055456029b0355$export$fc4c368d97afb623 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        light: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    })
]);
var $1c055456029b0355$export$f8a44c6979fe9fe5 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        clip: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
                'text'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        color: $1c055456029b0355$export$fc4c368d97afb623,
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        position: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        opacity: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
                'weak',
                'medium',
                'strong'
            ])
        ]),
        repeat: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
                'no-repeat',
                'repeat'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        rotate: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        size: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
                'cover',
                'contain'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        light: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    })
]);
var $1c055456029b0355$export$aa372966d47f02af = $1c055456029b0355$export$f8a44c6979fe9fe5;
var $1c055456029b0355$export$7d9f2aeb8f1f7c3f = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $1c055456029b0355$export$7ece648387045365 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'none'
    ].concat($1c055456029b0355$export$7d9f2aeb8f1f7c3f)),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        start: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$export$7d9f2aeb8f1f7c3f),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ])
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
]);
var $1c055456029b0355$var$PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $1c055456029b0355$export$b91a2ef62736aae3 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'none'
    ].concat($1c055456029b0355$var$PAD_SIZES)),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        end: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        start: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        top: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($1c055456029b0355$var$PAD_SIZES),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ])
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
]);
var $1c055456029b0355$export$ffe37ff34eeb9e21 = {
    a11yTitle: $1c055456029b0355$export$eb55925152858bde,
    alignSelf: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'start',
        'center',
        'end',
        'stretch',
        'baseline'
    ]),
    gridArea: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    margin: $1c055456029b0355$export$7ece648387045365
};
var $1c055456029b0355$export$d9c9382fb5d26cc7 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'none',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
]);
var $1c055456029b0355$export$e4126213490fff97 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'background'
    ]),
    $1c055456029b0355$export$f8a44c6979fe9fe5,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        background: $1c055456029b0355$export$f8a44c6979fe9fe5,
        elevation: $1c055456029b0355$export$d9c9382fb5d26cc7
    })
]);
var $1c055456029b0355$export$fe1f7946fa764688 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
    'circle',
    'diamond',
    'square',
    'star',
    'triangle',
    'triangleDown'
]);
var $1c055456029b0355$export$4be843ac40f484c6 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
    'squares',
    'circles',
    'stripesHorizontal',
    'stripesVertical',
    'stripesDiagonalDown',
    'stripesDiagonalUp'
]);
var $1c055456029b0355$export$fcb8c87299e05542 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'full'
    ]),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        corner: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right'
        ]),
        size: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
                'xsmall',
                'small',
                'medium',
                'large',
                'xlarge'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ])
    })
]);
var $1c055456029b0355$export$d3e0bc3700258305 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string),
    light: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string)
});
var $1c055456029b0355$export$2f3082f340019e9a = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        animation: $1c055456029b0355$export$6054792fa1afa765,
        colors: $1c055456029b0355$export$d3e0bc3700258305,
        depth: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
        message: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
                start: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
                end: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
            })
        ])
    })
]);
var $1c055456029b0355$var$dimSizeType = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
]);
var $1c055456029b0355$export$674efdc47ecf99e9 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    $1c055456029b0355$var$dimSizeType,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        height: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            $1c055456029b0355$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        min: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            $1c055456029b0355$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            $1c055456029b0355$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ])
    })
]);
var $1c055456029b0355$export$7d45d0e6b7abd5e2 = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    $1c055456029b0355$var$dimSizeType,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        width: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            $1c055456029b0355$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        min: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            $1c055456029b0355$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        max: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            $1c055456029b0355$var$dimSizeType,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ])
    })
]);
var $1c055456029b0355$export$5b49d53be3c37c69 = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];

});

parcelRegister("6yQ9k", function(module, exports) {

$parcel$export(module.exports, "PostHogProvider", () => $4c6e5ed87c7f0ab6$export$4d1dc63dbef5194f);
$parcel$export(module.exports, "usePostHog", () => $4c6e5ed87c7f0ab6$export$ba1c575d7c165008);

var $7C6ui = parcelRequire("7C6ui");

var $2NacA = parcelRequire("2NacA");
var $4c6e5ed87c7f0ab6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4c6e5ed87c7f0ab6$var$__assign = undefined && undefined.__assign || function() {
    $4c6e5ed87c7f0ab6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4c6e5ed87c7f0ab6$var$__assign.apply(this, arguments);
};
var $4c6e5ed87c7f0ab6$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $4c6e5ed87c7f0ab6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4c6e5ed87c7f0ab6$var$_a;
var $4c6e5ed87c7f0ab6$var$GLOBAL_KEY = "__POSTHOG_REACT_SHARED_STATE__";
var $4c6e5ed87c7f0ab6$var$globalObject = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : {};
var $4c6e5ed87c7f0ab6$var$statesByReact;
try {
    $4c6e5ed87c7f0ab6$var$statesByReact = $4c6e5ed87c7f0ab6$var$globalObject[$4c6e5ed87c7f0ab6$var$GLOBAL_KEY] = $4c6e5ed87c7f0ab6$var$globalObject[$4c6e5ed87c7f0ab6$var$GLOBAL_KEY] || new WeakMap();
} catch (_b) {
    $4c6e5ed87c7f0ab6$var$statesByReact = new WeakMap();
}
if (!$4c6e5ed87c7f0ab6$var$statesByReact.has((0, $2NacA.createContext))) $4c6e5ed87c7f0ab6$var$statesByReact.set((0, $2NacA.createContext), {});
var $4c6e5ed87c7f0ab6$var$sharedState = $4c6e5ed87c7f0ab6$var$statesByReact.get((0, $2NacA.createContext));
var $4c6e5ed87c7f0ab6$var$defaultPostHogInstance;
function $4c6e5ed87c7f0ab6$var$setDefaultPostHogInstance(instance) {
    if (!$4c6e5ed87c7f0ab6$var$sharedState.defaultPostHogInstance || $4c6e5ed87c7f0ab6$var$sharedState.defaultPostHogInstance === $4c6e5ed87c7f0ab6$var$defaultPostHogInstance) $4c6e5ed87c7f0ab6$var$sharedState.defaultPostHogInstance = instance;
    $4c6e5ed87c7f0ab6$var$defaultPostHogInstance = instance;
}
function $4c6e5ed87c7f0ab6$var$getDefaultPostHogInstance() {
    return $4c6e5ed87c7f0ab6$var$defaultPostHogInstance;
}
if (!$4c6e5ed87c7f0ab6$var$sharedState.context) $4c6e5ed87c7f0ab6$var$sharedState.context = (0, $2NacA.createContext)({
    get client () {
        return $4c6e5ed87c7f0ab6$var$getDefaultPostHogInstance() || $4c6e5ed87c7f0ab6$var$sharedState.defaultPostHogInstance;
    },
    bootstrap: void 0
});
var $4c6e5ed87c7f0ab6$export$ef76d7336c7309f5 = $4c6e5ed87c7f0ab6$var$sharedState.context;
function $4c6e5ed87c7f0ab6$var$isDeepEqual(obj1, obj2, visited) {
    if (visited === void 0) visited = new WeakMap();
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) return false;
    if (visited.has(obj1) && visited.get(obj1) === obj2) return true;
    visited.set(obj1, obj2);
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for(var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++){
        var key = keys1_1[_i];
        if (!keys2.includes(key)) return false;
        if (!$4c6e5ed87c7f0ab6$var$isDeepEqual(obj1[key], obj2[key], visited)) return false;
    }
    return true;
}
function $4c6e5ed87c7f0ab6$export$4d1dc63dbef5194f(_b) {
    var _c, _d;
    var children = _b.children, client = _b.client, apiKey = _b.apiKey, options = _b.options;
    var previousInitializationRef = (0, $2NacA.useRef)(null);
    var posthog = (0, $2NacA.useMemo)(function() {
        if (client) {
            if (apiKey) console.warn("[PostHog.js] You have provided both `client` and `apiKey` to `PostHogProvider`. `apiKey` will be ignored in favour of `client`.");
            if (options) console.warn("[PostHog.js] You have provided both `client` and `options` to `PostHogProvider`. `options` will be ignored in favour of `client`.");
            return client;
        }
        var defaultInstance = $4c6e5ed87c7f0ab6$var$getDefaultPostHogInstance();
        if (apiKey) return defaultInstance;
        console.warn("[PostHog.js] No `apiKey` or `client` were provided to `PostHogProvider`. Using default global `window.posthog` instance. You must initialize it manually. This is not recommended behavior.");
        return defaultInstance;
    }, [
        client,
        apiKey,
        JSON.stringify(options)
    ]);
    (0, $2NacA.useEffect)(function() {
        if (client || !apiKey) return;
        var defaultInstance = $4c6e5ed87c7f0ab6$var$getDefaultPostHogInstance();
        var previousInitialization = previousInitializationRef.current;
        if (!previousInitialization) {
            if (defaultInstance.__loaded) console.warn("[PostHog.js] `posthog` was already loaded elsewhere. This may cause issues.");
            defaultInstance.init(apiKey, options);
            previousInitializationRef.current = {
                apiKey: apiKey,
                options: options !== null && options !== void 0 ? options : {}
            };
        } else {
            if (apiKey !== previousInitialization.apiKey) console.warn("[PostHog.js] You have provided a different `apiKey` to `PostHogProvider` than the one that was already initialized. This is not supported by our provider and we'll keep using the previous key. If you need to toggle between API Keys you need to control the `client` yourself and pass it in as a prop rather than an `apiKey` prop.");
            if (options && !$4c6e5ed87c7f0ab6$var$isDeepEqual(options, previousInitialization.options)) defaultInstance.set_config(options);
            previousInitializationRef.current = {
                apiKey: apiKey,
                options: options !== null && options !== void 0 ? options : {}
            };
        }
    }, [
        client,
        apiKey,
        JSON.stringify(options)
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5.Provider, {
        value: {
            client: posthog,
            bootstrap: (_c = options === null || options === void 0 ? void 0 : options.bootstrap) !== null && _c !== void 0 ? _c : (_d = client === null || client === void 0 ? void 0 : client.config) === null || _d === void 0 ? void 0 : _d.bootstrap
        }
    }, children);
}
var $4c6e5ed87c7f0ab6$var$isFunction = function(f) {
    return typeof f === "function";
};
var $4c6e5ed87c7f0ab6$var$isUndefined = function(x) {
    return x === void 0;
};
var $4c6e5ed87c7f0ab6$var$isNull = function(x) {
    return x === null;
};
function $4c6e5ed87c7f0ab6$export$e9beec7734875ebd(flag, defaultValue) {
    var _b, _c;
    var _d = (0, $2NacA.useContext)($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5), client = _d.client, bootstrap = _d.bootstrap;
    var _e = (0, $2NacA.useState)(function() {
        return client.isFeatureEnabled(flag);
    }), featureEnabled = _e[0], setFeatureEnabled = _e[1];
    (0, $2NacA.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureEnabled(client.isFeatureEnabled(flag));
        });
    }, [
        client,
        flag
    ]);
    var bootstrapped = (_b = bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags) === null || _b === void 0 ? void 0 : _b[flag];
    if (!((_c = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _c === void 0 ? void 0 : _c.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) return $4c6e5ed87c7f0ab6$var$isUndefined(bootstrapped) ? defaultValue : !!bootstrapped;
    return $4c6e5ed87c7f0ab6$var$isUndefined(featureEnabled) ? defaultValue : featureEnabled;
}
function $4c6e5ed87c7f0ab6$export$21b3a717c06e8b6d(flag) {
    var _b;
    var _c = (0, $2NacA.useContext)($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5), client = _c.client, bootstrap = _c.bootstrap;
    var _d = (0, $2NacA.useState)(function() {
        var _b;
        return (_b = client.getFeatureFlagResult(flag, {
            send_event: false
        })) === null || _b === void 0 ? void 0 : _b.payload;
    }), featureFlagPayload = _d[0], setFeatureFlagPayload = _d[1];
    (0, $2NacA.useEffect)(function() {
        return client.onFeatureFlags(function() {
            var _b;
            setFeatureFlagPayload((_b = client.getFeatureFlagResult(flag, {
                send_event: false
            })) === null || _b === void 0 ? void 0 : _b.payload);
        });
    }, [
        client,
        flag
    ]);
    if (!((_b = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _b === void 0 ? void 0 : _b.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlagPayloads)) return bootstrap.featureFlagPayloads[flag];
    return featureFlagPayload;
}
function $4c6e5ed87c7f0ab6$export$c11c930e7ba4738(flag) {
    var _b, _c;
    var _d = (0, $2NacA.useContext)($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5), client = _d.client, bootstrap = _d.bootstrap;
    var _e = (0, $2NacA.useState)(function() {
        return client.getFeatureFlagResult(flag);
    }), result = _e[0], setResult = _e[1];
    (0, $2NacA.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setResult(client.getFeatureFlagResult(flag));
        });
    }, [
        client,
        flag
    ]);
    if (!((_b = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _b === void 0 ? void 0 : _b.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) {
        var bootstrappedValue = bootstrap.featureFlags[flag];
        if ($4c6e5ed87c7f0ab6$var$isUndefined(bootstrappedValue)) return;
        return {
            key: flag,
            enabled: typeof bootstrappedValue === "string" ? true : !!bootstrappedValue,
            variant: typeof bootstrappedValue === "string" ? bootstrappedValue : void 0,
            payload: (_c = bootstrap.featureFlagPayloads) === null || _c === void 0 ? void 0 : _c[flag]
        };
    }
    return result;
}
function $4c6e5ed87c7f0ab6$export$31a96876dff98722() {
    var _b;
    var _c = (0, $2NacA.useContext)($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5), client = _c.client, bootstrap = _c.bootstrap;
    var _d = (0, $2NacA.useState)(function() {
        return client.featureFlags.getFlags();
    }), featureFlags = _d[0], setFeatureFlags = _d[1];
    (0, $2NacA.useEffect)(function() {
        return client.onFeatureFlags(function(flags) {
            setFeatureFlags(flags);
        });
    }, [
        client
    ]);
    if (!((_b = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _b === void 0 ? void 0 : _b.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) return Object.entries(bootstrap.featureFlags).filter(function(_b) {
        var value = _b[1];
        return value;
    }).map(function(_b) {
        var key = _b[0];
        return key;
    });
    return featureFlags;
}
function $4c6e5ed87c7f0ab6$export$446efd8c49462bdd(flag) {
    var _b;
    var _c = (0, $2NacA.useContext)($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5), client = _c.client, bootstrap = _c.bootstrap;
    var _d = (0, $2NacA.useState)(function() {
        return client.getFeatureFlag(flag);
    }), featureFlagVariantKey = _d[0], setFeatureFlagVariantKey = _d[1];
    (0, $2NacA.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureFlagVariantKey(client.getFeatureFlag(flag));
        });
    }, [
        client,
        flag
    ]);
    if (!((_b = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _b === void 0 ? void 0 : _b.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) return bootstrap.featureFlags[flag];
    return featureFlagVariantKey;
}
var $4c6e5ed87c7f0ab6$export$ba1c575d7c165008 = function() {
    var client = (0, $2NacA.useContext)($4c6e5ed87c7f0ab6$export$ef76d7336c7309f5).client;
    return client;
};
function $4c6e5ed87c7f0ab6$var$VisibilityAndClickTracker(_b) {
    var children = _b.children, onIntersect = _b.onIntersect, onClick = _b.onClick, trackView = _b.trackView, options = _b.options, props = $4c6e5ed87c7f0ab6$var$__rest(_b, [
        "children",
        "onIntersect",
        "onClick",
        "trackView",
        "options"
    ]);
    var ref = (0, $2NacA.useRef)(null);
    var observerOptions = (0, $2NacA.useMemo)(function() {
        return $4c6e5ed87c7f0ab6$var$__assign({
            threshold: .1
        }, options);
    }, [
        options === null || options === void 0 ? void 0 : options.threshold,
        options === null || options === void 0 ? void 0 : options.root,
        options === null || options === void 0 ? void 0 : options.rootMargin
    ]);
    (0, $2NacA.useEffect)(function() {
        if ($4c6e5ed87c7f0ab6$var$isNull(ref.current) || !trackView) return;
        var observer = new IntersectionObserver(function(_b) {
            var entry = _b[0];
            return onIntersect(entry);
        }, observerOptions);
        observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        observerOptions,
        trackView,
        onIntersect
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", $4c6e5ed87c7f0ab6$var$__assign($4c6e5ed87c7f0ab6$var$__assign({
        ref: ref
    }, props), {
        onClick: onClick
    }), children);
}
function $4c6e5ed87c7f0ab6$var$VisibilityAndClickTrackers(_b) {
    var children = _b.children, trackInteraction = _b.trackInteraction, trackView = _b.trackView, options = _b.options, onInteract = _b.onInteract, onView = _b.onView, props = $4c6e5ed87c7f0ab6$var$__rest(_b, [
        "children",
        "trackInteraction",
        "trackView",
        "options",
        "onInteract",
        "onView"
    ]);
    var clickTrackedRef = (0, $2NacA.useRef)(false);
    var visibilityTrackedRef = (0, $2NacA.useRef)(false);
    var cachedOnClick = (0, $2NacA.useCallback)(function() {
        if (!clickTrackedRef.current && trackInteraction && onInteract) {
            onInteract();
            clickTrackedRef.current = true;
        }
    }, [
        trackInteraction,
        onInteract
    ]);
    var onIntersect = function(entry) {
        if (!visibilityTrackedRef.current && entry.isIntersecting && onView) {
            onView();
            visibilityTrackedRef.current = true;
        }
    };
    var trackedChildren = (0, $2NacA.Children).map(children, function(child) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($4c6e5ed87c7f0ab6$var$VisibilityAndClickTracker, $4c6e5ed87c7f0ab6$var$__assign({
            onClick: cachedOnClick,
            onIntersect: onIntersect,
            trackView: trackView,
            options: options
        }, props), child);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, trackedChildren);
}
function $4c6e5ed87c7f0ab6$export$3d3d20183fb62861(_b) {
    var flag = _b.flag, match = _b.match, children = _b.children, fallback = _b.fallback, visibilityObserverOptions = _b.visibilityObserverOptions, trackInteraction = _b.trackInteraction, trackView = _b.trackView, props = $4c6e5ed87c7f0ab6$var$__rest(_b, [
        "flag",
        "match",
        "children",
        "fallback",
        "visibilityObserverOptions",
        "trackInteraction",
        "trackView"
    ]);
    var payload = $4c6e5ed87c7f0ab6$export$21b3a717c06e8b6d(flag);
    var variant = $4c6e5ed87c7f0ab6$export$446efd8c49462bdd(flag);
    var posthog = $4c6e5ed87c7f0ab6$export$ba1c575d7c165008();
    var shouldTrackInteraction = trackInteraction !== null && trackInteraction !== void 0 ? trackInteraction : true;
    var shouldTrackView = trackView !== null && trackView !== void 0 ? trackView : true;
    if (!$4c6e5ed87c7f0ab6$var$isUndefined(variant)) {
        if ($4c6e5ed87c7f0ab6$var$isUndefined(match) || variant === match) {
            var childNode = $4c6e5ed87c7f0ab6$var$isFunction(children) ? children(payload) : children;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($4c6e5ed87c7f0ab6$var$VisibilityAndClickTrackers, $4c6e5ed87c7f0ab6$var$__assign({
                flag: flag,
                options: visibilityObserverOptions,
                trackInteraction: shouldTrackInteraction,
                trackView: shouldTrackView,
                onInteract: function() {
                    return $4c6e5ed87c7f0ab6$export$ba6bf30fc5e87e6b({
                        flag: flag,
                        posthog: posthog,
                        flagVariant: variant
                    });
                },
                onView: function() {
                    return $4c6e5ed87c7f0ab6$export$6b51b07da624385a({
                        flag: flag,
                        posthog: posthog,
                        flagVariant: variant
                    });
                }
            }, props), childNode);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, fallback);
}
function $4c6e5ed87c7f0ab6$var$captureFeatureEvent(event, _b) {
    var _c;
    var flag = _b.flag, posthog = _b.posthog, flagVariant = _b.flagVariant;
    var properties = {
        feature_flag: flag,
        $set: (_c = {}, _c["".concat(event, "/").concat(flag)] = flagVariant !== null && flagVariant !== void 0 ? flagVariant : true, _c)
    };
    if (typeof flagVariant === "string") properties.feature_flag_variant = flagVariant;
    posthog.capture(event, properties);
}
function $4c6e5ed87c7f0ab6$export$ba6bf30fc5e87e6b(options) {
    $4c6e5ed87c7f0ab6$var$captureFeatureEvent("$feature_interaction", options);
}
function $4c6e5ed87c7f0ab6$export$6b51b07da624385a(options) {
    $4c6e5ed87c7f0ab6$var$captureFeatureEvent("$feature_view", options);
}
function $4c6e5ed87c7f0ab6$var$TrackedChild(_b) {
    var child = _b.child, index = _b.index, name = _b.name, properties = _b.properties, observerOptions = _b.observerOptions;
    var trackedRef = (0, $2NacA.useRef)(false);
    var posthog = $4c6e5ed87c7f0ab6$export$ba1c575d7c165008();
    var onIntersect = (0, $2NacA.useCallback)(function(entry) {
        if (entry.isIntersecting && !trackedRef.current) {
            posthog.capture("$element_viewed", $4c6e5ed87c7f0ab6$var$__assign({
                element_name: name,
                child_index: index
            }, properties));
            trackedRef.current = true;
        }
    }, [
        posthog,
        name,
        index,
        properties
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($4c6e5ed87c7f0ab6$var$VisibilityAndClickTracker, {
        onIntersect: onIntersect,
        trackView: true,
        options: observerOptions
    }, child);
}
function $4c6e5ed87c7f0ab6$export$d71f98ecbc156fe3(_b) {
    var name = _b.name, properties = _b.properties, observerOptions = _b.observerOptions, trackAllChildren = _b.trackAllChildren, children = _b.children, props = $4c6e5ed87c7f0ab6$var$__rest(_b, [
        "name",
        "properties",
        "observerOptions",
        "trackAllChildren",
        "children"
    ]);
    var trackedRef = (0, $2NacA.useRef)(false);
    var posthog = $4c6e5ed87c7f0ab6$export$ba1c575d7c165008();
    var onIntersect = (0, $2NacA.useCallback)(function(entry) {
        if (entry.isIntersecting && !trackedRef.current) {
            posthog.capture("$element_viewed", $4c6e5ed87c7f0ab6$var$__assign({
                element_name: name
            }, properties));
            trackedRef.current = true;
        }
    }, [
        posthog,
        name,
        properties
    ]);
    if (trackAllChildren) {
        var trackedChildren = (0, $2NacA.Children).map(children, function(child, index) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($4c6e5ed87c7f0ab6$var$TrackedChild, {
                key: index,
                child: child,
                index: index,
                name: name,
                properties: properties,
                observerOptions: observerOptions
            });
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", props, trackedChildren);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($4c6e5ed87c7f0ab6$var$VisibilityAndClickTracker, $4c6e5ed87c7f0ab6$var$__assign({
        onIntersect: onIntersect,
        trackView: true,
        options: observerOptions
    }, props), children);
}
var $4c6e5ed87c7f0ab6$var$isError = function(value) {
    var tag = Object.prototype.toString.call(value);
    return value instanceof Error || tag === "[object Error]" || tag === "[object Exception]" || tag === "[object DOMException]" || tag === "[object DOMError]";
};
var $4c6e5ed87c7f0ab6$var$defineErrorName = function(error, name) {
    try {
        Object.defineProperty(error, "name", {
            value: name,
            writable: true,
            enumerable: true,
            configurable: true
        });
    } catch (_b) {}
};
var $4c6e5ed87c7f0ab6$var$setCause = function(error, cause) {
    var seenErrors = new WeakSet();
    var currentError = error;
    while(!seenErrors.has(currentError)){
        seenErrors.add(currentError);
        if (!$4c6e5ed87c7f0ab6$var$isError(currentError.cause)) {
            if (!$4c6e5ed87c7f0ab6$var$isUndefined(currentError.cause)) cause.cause = currentError.cause;
            currentError.cause = cause;
            return;
        }
        currentError = currentError.cause;
    }
};
var $4c6e5ed87c7f0ab6$var$addReactComponentStack = function(error, componentStack) {
    if (!componentStack) return error;
    var componentStackError = new Error($4c6e5ed87c7f0ab6$var$isError(error) ? error.message : "Primitive value captured as exception: ".concat(String(error)));
    $4c6e5ed87c7f0ab6$var$defineErrorName(componentStackError, "React ErrorBoundary ".concat($4c6e5ed87c7f0ab6$var$isError(error) ? error.name : "Error"));
    componentStackError.stack = componentStack;
    if ($4c6e5ed87c7f0ab6$var$isError(error)) {
        $4c6e5ed87c7f0ab6$var$setCause(error, componentStackError);
        return error;
    }
    return componentStackError;
};
var $4c6e5ed87c7f0ab6$var$INITIAL_STATE = {
    componentStack: null,
    exceptionEvent: null,
    error: null
};
var $4c6e5ed87c7f0ab6$var$__POSTHOG_ERROR_MESSAGES = {
    INVALID_FALLBACK: "[PostHog.js][PostHogErrorBoundary] Invalid fallback prop, provide a valid React element or a function that returns a valid React element."
};
var $4c6e5ed87c7f0ab6$export$2413edf479be8fff = ($4c6e5ed87c7f0ab6$var$_a = function(_super) {
    $4c6e5ed87c7f0ab6$var$__extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this._resetError = function() {
            _this.setState($4c6e5ed87c7f0ab6$var$INITIAL_STATE);
        };
        _this.state = $4c6e5ed87c7f0ab6$var$INITIAL_STATE;
        return _this;
    }
    class_1.prototype.componentDidCatch = function(error, errorInfo) {
        var additionalProperties = this.props.additionalProperties;
        var currentProperties;
        if ($4c6e5ed87c7f0ab6$var$isFunction(additionalProperties)) currentProperties = additionalProperties(error, errorInfo);
        else if (typeof additionalProperties === "object") currentProperties = additionalProperties;
        var client = this.context.client;
        var componentStack = errorInfo.componentStack;
        var exceptionEvent = client.captureException($4c6e5ed87c7f0ab6$var$addReactComponentStack(error, componentStack), currentProperties);
        this.setState({
            error: error,
            componentStack: componentStack !== null && componentStack !== void 0 ? componentStack : null,
            exceptionEvent: exceptionEvent
        });
    };
    class_1.prototype.render = function() {
        var _b = this.props, children = _b.children, fallback = _b.fallback;
        var state = this.state;
        if (state.componentStack == null) return $4c6e5ed87c7f0ab6$var$isFunction(children) ? children() : children;
        var element = $4c6e5ed87c7f0ab6$var$isFunction(fallback) ? (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            exceptionEvent: state.exceptionEvent,
            resetError: this._resetError
        }) : fallback;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).isValidElement(element)) return element;
        console.warn($4c6e5ed87c7f0ab6$var$__POSTHOG_ERROR_MESSAGES.INVALID_FALLBACK);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null);
    };
    return class_1;
}((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Component), $4c6e5ed87c7f0ab6$var$__setFunctionName($4c6e5ed87c7f0ab6$var$_a, "PostHogErrorBoundary"), function() {
    $4c6e5ed87c7f0ab6$var$_a.contextType = $4c6e5ed87c7f0ab6$export$ef76d7336c7309f5;
}(), $4c6e5ed87c7f0ab6$var$_a);
var $4c6e5ed87c7f0ab6$export$700501ebbde1ec89 = function(client, callback) {
    return function(error, errorInfo) {
        var event = client.captureException($4c6e5ed87c7f0ab6$var$addReactComponentStack(error, errorInfo.componentStack));
        if (callback) callback(event, error, errorInfo);
    };
};
$4c6e5ed87c7f0ab6$var$setDefaultPostHogInstance((0, $7C6ui.default));

});
parcelRegister("7C6ui", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ae5e4a12de151f5$export$2e2bcd8739ae039);
const $9ae5e4a12de151f5$var$t = "u" > typeof window ? window : void 0, $9ae5e4a12de151f5$var$i = "u" > typeof globalThis ? globalThis : $9ae5e4a12de151f5$var$t, $9ae5e4a12de151f5$var$e = null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.navigator, $9ae5e4a12de151f5$var$s = null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.document, $9ae5e4a12de151f5$var$n = null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.location, $9ae5e4a12de151f5$var$r = null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.fetch, $9ae5e4a12de151f5$var$o = (null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.XMLHttpRequest) && "withCredentials" in new $9ae5e4a12de151f5$var$i.XMLHttpRequest ? $9ae5e4a12de151f5$var$i.XMLHttpRequest : void 0, $9ae5e4a12de151f5$var$l = null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.AbortController, $9ae5e4a12de151f5$var$a = null == $9ae5e4a12de151f5$var$i ? void 0 : $9ae5e4a12de151f5$var$i.CompressionStream, $9ae5e4a12de151f5$var$u = null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.userAgent;
function $9ae5e4a12de151f5$var$h() {
    return !(!$9ae5e4a12de151f5$var$t || !1 === $9ae5e4a12de151f5$var$t.navigator.onLine);
}
const $9ae5e4a12de151f5$var$d = "undefined" != typeof globalThis ? globalThis : $9ae5e4a12de151f5$var$t;
$9ae5e4a12de151f5$var$d && "undefined" == typeof self && ($9ae5e4a12de151f5$var$d.self = $9ae5e4a12de151f5$var$d), $9ae5e4a12de151f5$var$d && "undefined" == typeof File && ($9ae5e4a12de151f5$var$d.File = function() {});
const $9ae5e4a12de151f5$var$c = null != $9ae5e4a12de151f5$var$t ? $9ae5e4a12de151f5$var$t : {}, $9ae5e4a12de151f5$var$v = "0.9.0", $9ae5e4a12de151f5$var$f = {
    DEBUG: !1,
    LIB_VERSION: $9ae5e4a12de151f5$var$v,
    LIB_NAME: "browser-common",
    JS_SDK_VERSION: $9ae5e4a12de151f5$var$v
};
var $9ae5e4a12de151f5$var$p = function(t) {
    return t.AnonymousId = "anonymous_id", t.DistinctId = "distinct_id", t.Props = "props", t.EnablePersonProcessing = "enable_person_processing", t.PersonMode = "person_mode", t.FeatureFlagDetails = "feature_flag_details", t.FeatureFlags = "feature_flags", t.FeatureFlagPayloads = "feature_flag_payloads", t.BootstrapFeatureFlagDetails = "bootstrap_feature_flag_details", t.BootstrapFeatureFlags = "bootstrap_feature_flags", t.BootstrapFeatureFlagPayloads = "bootstrap_feature_flag_payloads", t.OverrideFeatureFlags = "override_feature_flags", t.Queue = "queue", t.AiQueue = "ai_queue", t.AiCaptureQueue = "ai_capture_queue", t.LogsQueue = "logs_queue", t.OptedOut = "opted_out", t.SessionId = "session_id", t.SessionStartTimestamp = "session_start_timestamp", t.SessionLastTimestamp = "session_timestamp", t.PersonProperties = "person_properties", t.GroupProperties = "group_properties", t.InstalledAppBuild = "installed_app_build", t.InstalledAppVersion = "installed_app_version", t.SessionReplay = "session_replay", t.PushRegistered = "push_registered", t.SessionReplayEventTriggerActivatedSession = "session_replay_event_trigger_activated_session", t.SurveyLastSeenDate = "survey_last_seen_date", t.SurveysInProgress = "surveys_in_progress", t.SurveysSeen = "surveys_seen", t.Surveys = "surveys", t.RemoteConfig = "remote_config", t.FlagsEndpointWasHit = "flags_endpoint_was_hit", t.DeviceId = "device_id", t;
}({}), $9ae5e4a12de151f5$var$_ = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({});
const $9ae5e4a12de151f5$var$g = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $9ae5e4a12de151f5$var$m = [
    "token"
];
function $9ae5e4a12de151f5$var$b(t, i) {
    return -1 !== t.indexOf(i);
}
const $9ae5e4a12de151f5$var$y = function(t) {
    return t.trim();
}, $9ae5e4a12de151f5$var$w = function(t) {
    return t.replace(/^\$/, "");
};
function $9ae5e4a12de151f5$var$S(t) {
    var i;
    const e = [];
    return null !== (i = JSON.stringify(t, function(t, i) {
        if ("bigint" == typeof i) return i.toString();
        if ("function" != typeof i && "symbol" != typeof i) {
            if (i instanceof Error) return {
                name: i.name,
                message: i.message,
                stack: i.stack
            };
            if (i && "object" == typeof i) {
                for(; e.length > 0 && e[e.length - 1] !== this;)e.pop();
                if (e.includes(i)) return "[Circular]";
                e.push(i);
            }
            return i;
        }
    })) && void 0 !== i ? i : "null";
}
const $9ae5e4a12de151f5$var$x = Object.prototype, $9ae5e4a12de151f5$var$E = $9ae5e4a12de151f5$var$x.hasOwnProperty, $9ae5e4a12de151f5$var$k = $9ae5e4a12de151f5$var$x.toString, $9ae5e4a12de151f5$var$T = Array.isArray || function(t) {
    return "[object Array]" === $9ae5e4a12de151f5$var$k.call(t);
}, $9ae5e4a12de151f5$var$P = (t)=>"function" == typeof t, $9ae5e4a12de151f5$var$C = (t)=>t === Object(t) && !$9ae5e4a12de151f5$var$T(t), $9ae5e4a12de151f5$var$O = (t)=>{
    if ($9ae5e4a12de151f5$var$C(t)) {
        for(const i in t)if ($9ae5e4a12de151f5$var$E.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $9ae5e4a12de151f5$var$R = (t)=>void 0 === t, $9ae5e4a12de151f5$var$I = (t)=>"[object String]" == $9ae5e4a12de151f5$var$k.call(t), $9ae5e4a12de151f5$var$A = (t)=>$9ae5e4a12de151f5$var$I(t) && 0 === t.trim().length, $9ae5e4a12de151f5$var$M = (t)=>null === t, $9ae5e4a12de151f5$var$F = (t)=>$9ae5e4a12de151f5$var$R(t) || $9ae5e4a12de151f5$var$M(t), $9ae5e4a12de151f5$var$D = (t)=>"[object Number]" == $9ae5e4a12de151f5$var$k.call(t) && t == t, $9ae5e4a12de151f5$var$N = (t)=>$9ae5e4a12de151f5$var$D(t) && t > 0, $9ae5e4a12de151f5$var$j = (t)=>"[object Boolean]" === $9ae5e4a12de151f5$var$k.call(t), $9ae5e4a12de151f5$var$L = (t)=>$9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$g, t), $9ae5e4a12de151f5$var$B = (t)=>$9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$m, t);
function $9ae5e4a12de151f5$var$U(t) {
    return null === t || "object" != typeof t;
}
function $9ae5e4a12de151f5$var$z(t, i) {
    return ({}).toString.call(t) === `[object ${i}]`;
}
function $9ae5e4a12de151f5$var$H(t) {
    switch(({}).toString.call(t)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object DOMError]":
        case "[object WebAssembly.Exception]":
            return !0;
        default:
            return $9ae5e4a12de151f5$var$V(t, Error);
    }
}
function $9ae5e4a12de151f5$var$q(t) {
    return "u" > typeof Event && $9ae5e4a12de151f5$var$V(t, Event);
}
function $9ae5e4a12de151f5$var$V(t, i) {
    try {
        return t instanceof i;
    } catch (t) {
        return !1;
    }
}
const $9ae5e4a12de151f5$var$W = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $9ae5e4a12de151f5$var$G = (t)=>$9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$W, t), $9ae5e4a12de151f5$var$K = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $9ae5e4a12de151f5$var$J(t, i, e, s, n, r, o) {
    try {
        var l = t[r](o), a = l.value;
    } catch (t) {
        return void e(t);
    }
    l.done ? i(a) : Promise.resolve(a).then(s, n);
}
function $9ae5e4a12de151f5$var$Y(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(s, n) {
            var r = t.apply(i, e);
            function o(t) {
                $9ae5e4a12de151f5$var$J(r, s, n, o, l, "next", t);
            }
            function l(t) {
                $9ae5e4a12de151f5$var$J(r, s, n, o, l, "throw", t);
            }
            o(void 0);
        });
    };
}
const $9ae5e4a12de151f5$var$X = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterestbot",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $9ae5e4a12de151f5$var$Q = function(t, i = []) {
    if (!t) return !1;
    const e = t.toLowerCase();
    return $9ae5e4a12de151f5$var$X.concat(i).some((t)=>{
        const i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
};
function $9ae5e4a12de151f5$var$Z(t, i, e, s, n) {
    return i > e && (s.warn("min cannot be greater than max."), i = e), $9ae5e4a12de151f5$var$D(t) ? t > e ? (s.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : i > t ? (s.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (s.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + n), $9ae5e4a12de151f5$var$Z(null != n ? n : e, i, e, s));
}
var $9ae5e4a12de151f5$var$tt = class {
    constructor(t){
        this.C = {}, this.I = t.I, this.R = $9ae5e4a12de151f5$var$Z(t.bucketSize, 0, 100, t.$), this.A = $9ae5e4a12de151f5$var$Z(t.refillRate, 0, this.R, t.$), this.O = $9ae5e4a12de151f5$var$Z(t.refillInterval, 0, 864e5, t.$);
    }
    F(t, i) {
        const e = Math.floor((i - t.lastAccess) / this.O);
        e > 0 && (t.tokens = Math.min(t.tokens + e * this.A, this.R), t.lastAccess = t.lastAccess + e * this.O);
    }
    consumeRateLimit(t) {
        var i;
        const e = Date.now(), s = String(t);
        let n = this.C[s];
        return n ? this.F(n, e) : (n = {
            tokens: this.R,
            lastAccess: e
        }, this.C[s] = n), 0 === n.tokens || (n.tokens--, 0 === n.tokens && (null === (i = this.I) || void 0 === i || i.call(this, t)), 0 === n.tokens);
    }
    stop() {
        this.C = {};
    }
};
const $9ae5e4a12de151f5$var$it = "Mobile", $9ae5e4a12de151f5$var$et = "Android", $9ae5e4a12de151f5$var$st = "Tablet", $9ae5e4a12de151f5$var$nt = "Android Tablet", $9ae5e4a12de151f5$var$rt = "iPad", $9ae5e4a12de151f5$var$ot = "Apple Watch", $9ae5e4a12de151f5$var$lt = "Safari", $9ae5e4a12de151f5$var$at = "BlackBerry", $9ae5e4a12de151f5$var$ut = "Samsung Internet", $9ae5e4a12de151f5$var$ht = "Chrome", $9ae5e4a12de151f5$var$dt = "Chrome iOS", $9ae5e4a12de151f5$var$ct = "Internet Explorer", $9ae5e4a12de151f5$var$vt = "Internet Explorer Mobile", $9ae5e4a12de151f5$var$ft = "Opera", $9ae5e4a12de151f5$var$pt = "Microsoft Edge", $9ae5e4a12de151f5$var$_t = "Firefox", $9ae5e4a12de151f5$var$gt = "Firefox iOS", $9ae5e4a12de151f5$var$mt = "Nintendo", $9ae5e4a12de151f5$var$bt = "PlayStation", $9ae5e4a12de151f5$var$yt = "Xbox", $9ae5e4a12de151f5$var$wt = "Android Mobile", $9ae5e4a12de151f5$var$$t = "Mobile Safari", $9ae5e4a12de151f5$var$St = "Windows", $9ae5e4a12de151f5$var$xt = "Windows Phone", $9ae5e4a12de151f5$var$Et = "Nokia", $9ae5e4a12de151f5$var$kt = "Ouya", $9ae5e4a12de151f5$var$Tt = "Generic " + $9ae5e4a12de151f5$var$it.toLowerCase(), $9ae5e4a12de151f5$var$Pt = "Generic " + $9ae5e4a12de151f5$var$st.toLowerCase(), $9ae5e4a12de151f5$var$Ct = "Konqueror", $9ae5e4a12de151f5$var$Ot = "Oculus Browser", $9ae5e4a12de151f5$var$Rt = "Vivaldi", $9ae5e4a12de151f5$var$It = "Yandex", $9ae5e4a12de151f5$var$At = "Whale", $9ae5e4a12de151f5$var$Mt = "DuckDuckGo", $9ae5e4a12de151f5$var$Ft = "Pale Moon", $9ae5e4a12de151f5$var$Dt = "Waterfox", $9ae5e4a12de151f5$var$Nt = "Brave", $9ae5e4a12de151f5$var$jt = "Claude", $9ae5e4a12de151f5$var$Lt = "Codex", $9ae5e4a12de151f5$var$Bt = "ChatGPT", $9ae5e4a12de151f5$var$Ut = "Google Search App", $9ae5e4a12de151f5$var$zt = new RegExp("Version/(\\d+(\\.\\d+)?)"), $9ae5e4a12de151f5$var$Ht = new RegExp("(Claude|Codex|ChatGPT)\\/(\\d+(\\.\\d+)?)"), $9ae5e4a12de151f5$var$qt = new RegExp($9ae5e4a12de151f5$var$yt, "i"), $9ae5e4a12de151f5$var$Vt = new RegExp("PlayStation \\w+", "i"), $9ae5e4a12de151f5$var$Wt = new RegExp("Nintendo \\w+", "i"), $9ae5e4a12de151f5$var$Gt = new RegExp("BlackBerry|PlayBook|BB10", "i"), $9ae5e4a12de151f5$var$Kt = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
}, $9ae5e4a12de151f5$var$Jt = function(t, i, e, s) {
    i = i || "";
    const n = function(t) {
        return (null == t ? void 0 : t.brave) ? $9ae5e4a12de151f5$var$Nt : null;
    }(e);
    return n || ((null == s ? void 0 : s.detectGoogleSearchApp) && $9ae5e4a12de151f5$var$b(t, "GSA/") ? $9ae5e4a12de151f5$var$Ut : $9ae5e4a12de151f5$var$b(t, " OPR/") && $9ae5e4a12de151f5$var$b(t, "Mini") ? "Opera Mini" : $9ae5e4a12de151f5$var$b(t, " OPR/") ? $9ae5e4a12de151f5$var$ft : $9ae5e4a12de151f5$var$Gt.test(t) ? $9ae5e4a12de151f5$var$at : $9ae5e4a12de151f5$var$b(t, "IEMobile") || $9ae5e4a12de151f5$var$b(t, "WPDesktop") ? $9ae5e4a12de151f5$var$vt : $9ae5e4a12de151f5$var$b(t, "OculusBrowser") ? $9ae5e4a12de151f5$var$Ot : $9ae5e4a12de151f5$var$b(t, "SamsungBrowser") ? $9ae5e4a12de151f5$var$ut : $9ae5e4a12de151f5$var$b(t, "Edge") || $9ae5e4a12de151f5$var$b(t, "Edg/") ? $9ae5e4a12de151f5$var$pt : $9ae5e4a12de151f5$var$b(t, "Vivaldi/") ? $9ae5e4a12de151f5$var$Rt : $9ae5e4a12de151f5$var$b(t, "YaBrowser/") ? $9ae5e4a12de151f5$var$It : $9ae5e4a12de151f5$var$b(t, "Whale/") ? $9ae5e4a12de151f5$var$At : $9ae5e4a12de151f5$var$b(t, "DuckDuckGo/") || $9ae5e4a12de151f5$var$b(t, "Ddg/") ? $9ae5e4a12de151f5$var$Mt : $9ae5e4a12de151f5$var$b(t, "Claude/") ? $9ae5e4a12de151f5$var$jt : $9ae5e4a12de151f5$var$b(t, "Codex/") ? $9ae5e4a12de151f5$var$Lt : $9ae5e4a12de151f5$var$b(t, "ChatGPT/") ? $9ae5e4a12de151f5$var$Bt : $9ae5e4a12de151f5$var$b(t, "FBIOS") ? "Facebook Mobile" : $9ae5e4a12de151f5$var$b(t, "UCWEB") || $9ae5e4a12de151f5$var$b(t, "UCBrowser") ? "UC Browser" : $9ae5e4a12de151f5$var$b(t, "CriOS") ? $9ae5e4a12de151f5$var$dt : $9ae5e4a12de151f5$var$b(t, "CrMo") || $9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$ht) ? $9ae5e4a12de151f5$var$ht : $9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$et) && $9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$lt) ? $9ae5e4a12de151f5$var$wt : $9ae5e4a12de151f5$var$b(t, "FxiOS") ? $9ae5e4a12de151f5$var$gt : $9ae5e4a12de151f5$var$b(t.toLowerCase(), $9ae5e4a12de151f5$var$Ct.toLowerCase()) ? $9ae5e4a12de151f5$var$Ct : $9ae5e4a12de151f5$var$b(t, "Brave/") ? $9ae5e4a12de151f5$var$Nt : ((t, i)=>i && $9ae5e4a12de151f5$var$b(i, "Apple") || function(t) {
            return $9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$lt) && !$9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$ht) && !$9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$et);
        }(t))(t, i) ? $9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$it) ? $9ae5e4a12de151f5$var$$t : $9ae5e4a12de151f5$var$lt : $9ae5e4a12de151f5$var$b(t, "PaleMoon/") ? $9ae5e4a12de151f5$var$Ft : $9ae5e4a12de151f5$var$b(t, "Waterfox/") ? $9ae5e4a12de151f5$var$Dt : $9ae5e4a12de151f5$var$b(t, $9ae5e4a12de151f5$var$_t) ? $9ae5e4a12de151f5$var$_t : $9ae5e4a12de151f5$var$b(t, "MSIE") || $9ae5e4a12de151f5$var$b(t, "Trident/") ? $9ae5e4a12de151f5$var$ct : $9ae5e4a12de151f5$var$b(t, "Gecko") ? $9ae5e4a12de151f5$var$_t : "");
}, $9ae5e4a12de151f5$var$Yt = {
    [$9ae5e4a12de151f5$var$vt]: [
        new RegExp("rv:(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$pt]: [
        new RegExp("Edge?\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$ht]: [
        new RegExp("(Chrome|CrMo)\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$dt]: [
        new RegExp("CriOS\\/(\\d+(\\.\\d+)?)")
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$lt]: [
        $9ae5e4a12de151f5$var$zt
    ],
    [$9ae5e4a12de151f5$var$$t]: [
        $9ae5e4a12de151f5$var$zt
    ],
    [$9ae5e4a12de151f5$var$ft]: [
        new RegExp("(Opera|OPR)\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$_t]: [
        new RegExp("Firefox\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$gt]: [
        new RegExp("FxiOS\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Ct]: [
        new RegExp("Konqueror[:/]?(\\d+(\\.\\d+)?)", "i")
    ],
    [$9ae5e4a12de151f5$var$at]: [
        new RegExp("BlackBerry (\\d+(\\.\\d+)?)"),
        $9ae5e4a12de151f5$var$zt
    ],
    [$9ae5e4a12de151f5$var$wt]: [
        new RegExp("android\\s(\\d+(\\.\\d+)?)", "i")
    ],
    [$9ae5e4a12de151f5$var$ut]: [
        new RegExp("SamsungBrowser\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Ot]: [
        new RegExp("OculusBrowser\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Rt]: [
        new RegExp("Vivaldi\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$It]: [
        new RegExp("YaBrowser\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$At]: [
        new RegExp("Whale\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Nt]: [
        new RegExp("Brave\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$jt]: [
        $9ae5e4a12de151f5$var$Ht
    ],
    [$9ae5e4a12de151f5$var$Lt]: [
        $9ae5e4a12de151f5$var$Ht
    ],
    [$9ae5e4a12de151f5$var$Bt]: [
        $9ae5e4a12de151f5$var$Ht
    ],
    [$9ae5e4a12de151f5$var$Mt]: [
        new RegExp("(DuckDuckGo|Ddg)\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Ft]: [
        new RegExp("PaleMoon\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Dt]: [
        new RegExp("Waterfox\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$Ut]: [
        new RegExp("GSA\\/(\\d+(\\.\\d+)?)")
    ],
    [$9ae5e4a12de151f5$var$ct]: [
        new RegExp("(rv:|MSIE )(\\d+(\\.\\d+)?)")
    ],
    Mozilla: [
        new RegExp("rv:(\\d+(\\.\\d+)?)")
    ]
}, $9ae5e4a12de151f5$var$Xt = function(t, i, e, s) {
    const n = $9ae5e4a12de151f5$var$Jt(t, i, e, s), r = $9ae5e4a12de151f5$var$Yt[n];
    if ($9ae5e4a12de151f5$var$R(r)) return null;
    for(let i = 0; r.length > i; i++){
        const e = t.match(r[i]);
        if (e) return parseFloat(e[e.length - 2]);
    }
    return null;
}, $9ae5e4a12de151f5$var$Qt = [
    [
        new RegExp("Xbox; Xbox (.*?)[);]", "i"),
        (t)=>[
                $9ae5e4a12de151f5$var$yt,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($9ae5e4a12de151f5$var$mt, "i"),
        [
            $9ae5e4a12de151f5$var$mt,
            ""
        ]
    ],
    [
        new RegExp($9ae5e4a12de151f5$var$bt, "i"),
        [
            $9ae5e4a12de151f5$var$bt,
            ""
        ]
    ],
    [
        $9ae5e4a12de151f5$var$Gt,
        [
            $9ae5e4a12de151f5$var$at,
            ""
        ]
    ],
    [
        new RegExp($9ae5e4a12de151f5$var$St, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $9ae5e4a12de151f5$var$xt,
                ""
            ];
            if (new RegExp($9ae5e4a12de151f5$var$it).test(i) && !/IEMobile\b/.test(i)) return [
                "Windows Mobile",
                ""
            ];
            const e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                let t = $9ae5e4a12de151f5$var$Kt[e[1]] || "";
                return /arm/i.test(i) && (t = "RT"), [
                    $9ae5e4a12de151f5$var$St,
                    t
                ];
            }
            return [
                $9ae5e4a12de151f5$var$St,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>t && t[3] ? [
                "iOS",
                [
                    t[3],
                    t[4],
                    t[5] || "0"
                ].join(".")
            ] : [
                "iOS",
                ""
            ]
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            let i = "";
            return t && t.length >= 3 && (i = $9ae5e4a12de151f5$var$R(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(Android (\\d+)\\.(\\d+)\\.?(\\d+)?|Android)", "i"),
        (t)=>t && t[2] ? [
                $9ae5e4a12de151f5$var$et,
                [
                    t[2],
                    t[3],
                    t[4] || "0"
                ].join(".")
            ] : [
                $9ae5e4a12de151f5$var$et,
                ""
            ]
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            const i = [
                "Mac OS X",
                ""
            ];
            return t && t[1] && (i[1] = [
                t[1],
                t[2],
                t[3] || "0"
            ].join(".")), i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            "Chrome OS",
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $9ae5e4a12de151f5$var$Zt = function(t) {
    for(let i = 0; $9ae5e4a12de151f5$var$Qt.length > i; i++){
        const [e, s] = $9ae5e4a12de151f5$var$Qt[i], n = e.exec(t), r = n && ($9ae5e4a12de151f5$var$P(s) ? s(n, t) : s);
        if (r) return r;
    }
    return [
        "",
        ""
    ];
}, $9ae5e4a12de151f5$var$ti = function(t) {
    return $9ae5e4a12de151f5$var$Wt.test(t) ? $9ae5e4a12de151f5$var$mt : $9ae5e4a12de151f5$var$Vt.test(t) ? $9ae5e4a12de151f5$var$bt : $9ae5e4a12de151f5$var$qt.test(t) ? $9ae5e4a12de151f5$var$yt : new RegExp($9ae5e4a12de151f5$var$kt, "i").test(t) ? $9ae5e4a12de151f5$var$kt : new RegExp("(Windows Phone|WPDesktop)", "i").test(t) ? $9ae5e4a12de151f5$var$xt : /iPad/.test(t) ? $9ae5e4a12de151f5$var$rt : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $9ae5e4a12de151f5$var$ot : $9ae5e4a12de151f5$var$Gt.test(t) ? $9ae5e4a12de151f5$var$at : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($9ae5e4a12de151f5$var$Et, "i").test(t) ? $9ae5e4a12de151f5$var$Et : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($9ae5e4a12de151f5$var$it).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $9ae5e4a12de151f5$var$et : $9ae5e4a12de151f5$var$nt : new RegExp("(pda|Mobile)", "i").test(t) ? $9ae5e4a12de151f5$var$Tt : new RegExp($9ae5e4a12de151f5$var$st, "i").test(t) && !new RegExp("Tablet pc", "i").test(t) ? $9ae5e4a12de151f5$var$Pt : "";
}, $9ae5e4a12de151f5$var$ii = function(t, i) {
    var e;
    const s = $9ae5e4a12de151f5$var$ti(t);
    var n, r, o;
    return s === $9ae5e4a12de151f5$var$rt || s === $9ae5e4a12de151f5$var$nt || "Kobo" === s || "Kindle Fire" === s || s === $9ae5e4a12de151f5$var$Pt ? $9ae5e4a12de151f5$var$st : s === $9ae5e4a12de151f5$var$mt || s === $9ae5e4a12de151f5$var$yt || s === $9ae5e4a12de151f5$var$bt || s === $9ae5e4a12de151f5$var$kt ? "Console" : s === $9ae5e4a12de151f5$var$ot ? "Wearable" : s ? $9ae5e4a12de151f5$var$it : "Android" === (null == i ? void 0 : i.userAgentDataPlatform) && (null !== (e = null == i ? void 0 : i.maxTouchPoints) && void 0 !== e ? e : 0) > 0 ? 600 > Math.min(null !== (n = null == i ? void 0 : i.screenWidth) && void 0 !== n ? n : 0, null !== (r = null == i ? void 0 : i.screenHeight) && void 0 !== r ? r : 0) / (null !== (o = null == i ? void 0 : i.devicePixelRatio) && void 0 !== o ? o : 1) ? $9ae5e4a12de151f5$var$it : $9ae5e4a12de151f5$var$st : "Desktop";
}, $9ae5e4a12de151f5$var$ei = /\bFBAV\/(\d+(?:\.\d+)*)/i, $9ae5e4a12de151f5$var$si = [
    [
        /\bInstagram(?:[ /](\d+(?:\.\d+)*))?\b/i,
        "Instagram"
    ],
    [
        /\bBarcelona[ /](\d+(?:\.\d+)*)?/i,
        "Threads"
    ],
    [
        /\b(?:MessengerForiOS|(?:FBAN|FB_IAB)\/Orca-Android)\b/i,
        "Messenger",
        $9ae5e4a12de151f5$var$ei
    ],
    [
        /\bFBAN\/EMA\b/i,
        "Facebook Lite",
        $9ae5e4a12de151f5$var$ei
    ],
    [
        /\b(?:FBIOS|(?:FBAN|FB_IAB)\/(?:FB4A|FBIOS))\b/i,
        "Facebook",
        $9ae5e4a12de151f5$var$ei
    ],
    [
        /\bLinkedInApp(?:\]?\/(\d+(?:\.\d+)*))?\b/i,
        "LinkedIn"
    ],
    [
        /\bTwitter(?:Android| for (?:iPhone|iPad|Android))(?:\/(\d+(?:\.\d+)*))?\b/i,
        "Twitter"
    ],
    [
        /\b(?:musical_ly|trill)(?:[_/](\d+\.\d+(?:\.\d+)*))?(?=\b|_)/i,
        "TikTok",
        /\bapp_version\/(\d+(?:\.\d+)*)/i
    ],
    [
        /\b(?:MicroMessenger|WeChat)\/(\d+(?:\.\d+)*)?/i,
        "WeChat"
    ],
    [
        /\bLine\/(\d+(?:\.\d+)*)?/i,
        "Line"
    ],
    [
        /\bGSA\/(\d+(?:\.\d+)*)?/i,
        "Google"
    ],
    [
        /\[Pinterest\/(?:iOS|Android)\b|\bPinterest(?: for (?:Android(?: Tablet)?|iOS))?\/(\d+(?:\.\d+)*)/i,
        "Pinterest"
    ],
    [
        /\b(?:WA4A|WAiOS)\/(\d+(?:\.\d+)*)?/i,
        "WhatsApp"
    ],
    [
        /\bSnapchat[ /](\d+(?:\.\d+)*)?/i,
        "Snapchat"
    ],
    [
        /\bBing(?:Web|Sapphire)\/(\d+(?:\.\d+)*)?/i,
        "Bing"
    ],
    [
        /\bNAVER\(inapp; search;/i,
        "Naver",
        /\bNAVER\(inapp; search;[^;)]*; (\d+(?:\.\d+)*)/i
    ],
    [
        /\bKAKAOTALK[ /](\d+\.\d+(?:\.\d+)*)?/i,
        "KakaoTalk"
    ]
], $9ae5e4a12de151f5$var$ni = "[Truncated]", $9ae5e4a12de151f5$var$ri = "[Unserializable]";
function $9ae5e4a12de151f5$var$oi(t) {
    let i = "";
    for(let e = 0; t.length > e; e++){
        const s = t.charCodeAt(e);
        if (55296 > s || s > 56319) i += 56320 > s || s > 57343 ? t[e] : "\uFFFD";
        else {
            const s = t.charCodeAt(e + 1);
            56320 > s || s > 57343 ? i += "\uFFFD" : (i += t[e] + t[e + 1], e++);
        }
    }
    return i;
}
function $9ae5e4a12de151f5$var$li(t, i) {
    if (!i) return t;
    let e = [];
    try {
        e = Object.keys(i);
    } catch (t) {
        e = [];
    }
    for (const s of e){
        let e;
        try {
            e = i[s];
        } catch (t) {
            e = $9ae5e4a12de151f5$var$ri;
        }
        Object.defineProperty(t, s, {
            value: e,
            enumerable: !0,
            writable: !0,
            configurable: !0
        });
    }
    return t;
}
Date, Date;
const $9ae5e4a12de151f5$var$ai = 3e5;
var $9ae5e4a12de151f5$var$ui = class {
    record(t) {
        if ("too-large" === t.kind) return;
        if ("retry-later" !== t.kind) return void this.reset();
        if (!t.retryAfterMs) return;
        const i = this.isOpen(), e = Date.now(), s = Math.min(t.retryAfterMs, $9ae5e4a12de151f5$var$ai);
        if (!i) return this.ts = e, void (this.es = e + s);
        this.es = Math.max(this.es, Math.min(e + s, this.ts + $9ae5e4a12de151f5$var$ai));
    }
    remainingMs() {
        const t = Date.now();
        if (this.ts - 5e3 > t) return this.reset(), 0;
        const i = Math.min($9ae5e4a12de151f5$var$ai, Math.max(0, this.es - t));
        return 0 === i && this.reset(), i;
    }
    isOpen() {
        return this.remainingMs() > 0;
    }
    reset() {
        this.es = 0, this.ts = 0;
    }
    constructor(){
        this.es = 0, this.ts = 0;
    }
};
const $9ae5e4a12de151f5$var$hi = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function $9ae5e4a12de151f5$var$di(t, i) {
    var e;
    return "string" == typeof (e = t) && $9ae5e4a12de151f5$var$hi.test(e) ? t : i();
}
function $9ae5e4a12de151f5$var$ci(t, i) {
    const e = new Error(i);
    try {
        Object.defineProperty(e, "name", {
            value: t,
            writable: !0,
            enumerable: !0,
            configurable: !0
        });
    } catch (t) {}
    return e;
}
function $9ae5e4a12de151f5$var$vi(t) {
    return t ? t.split("#")[0] : t;
}
function $9ae5e4a12de151f5$var$fi(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}
function $9ae5e4a12de151f5$var$pi(t, i) {
    const e = setTimeout(t, i);
    return null != e && e.unref && (null == e || e.unref()), e;
}
function $9ae5e4a12de151f5$var$_i(t, i, e) {
    return $9ae5e4a12de151f5$var$gi.apply(this, arguments);
}
function $9ae5e4a12de151f5$var$gi() {
    return ($9ae5e4a12de151f5$var$gi = $9ae5e4a12de151f5$var$Y(function*(t, i, e) {
        let s;
        try {
            return yield Promise.race([
                t,
                new Promise((t, n)=>{
                    s = $9ae5e4a12de151f5$var$pi(()=>{
                        try {
                            null == e || e(), t();
                        } catch (t) {
                            n(t);
                        }
                    }, i);
                })
            ]);
        } finally{
            clearTimeout(s);
        }
    })).apply(this, arguments);
}
let $9ae5e4a12de151f5$var$mi, $9ae5e4a12de151f5$var$bi, $9ae5e4a12de151f5$var$yi;
function $9ae5e4a12de151f5$var$wi(t) {
    const i = globalThis._posthogChunkIds;
    if (!i) return;
    const e = Object.keys(i);
    return $9ae5e4a12de151f5$var$yi && e.length === $9ae5e4a12de151f5$var$bi || ($9ae5e4a12de151f5$var$bi = e.length, $9ae5e4a12de151f5$var$yi = e.reduce((e, s)=>{
        $9ae5e4a12de151f5$var$mi || ($9ae5e4a12de151f5$var$mi = {});
        const n = $9ae5e4a12de151f5$var$mi[s];
        if (n) e[n[0]] = n[1];
        else {
            const n = t(s);
            for(let t = n.length - 1; t >= 0; t--){
                const r = n[t], o = null == r ? void 0 : r.filename, l = i[s];
                if (o && l) {
                    e[o] = l, $9ae5e4a12de151f5$var$mi[s] = [
                        o,
                        l
                    ];
                    break;
                }
            }
        }
        return e;
    }, {})), $9ae5e4a12de151f5$var$yi;
}
function $9ae5e4a12de151f5$var$$i(t) {
    return $9ae5e4a12de151f5$var$$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $9ae5e4a12de151f5$var$$i(t);
}
function $9ae5e4a12de151f5$var$Si(t, i, e) {
    return (i = function(t) {
        var i = function(t) {
            if ("object" != $9ae5e4a12de151f5$var$$i(t) || !t) return t;
            var i = t[Symbol.toPrimitive];
            if (void 0 !== i) {
                var e = i.call(t, "string");
                if ("object" != $9ae5e4a12de151f5$var$$i(e)) return e;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(t);
        }(t);
        return "symbol" == $9ae5e4a12de151f5$var$$i(i) ? i : i + "";
    }(i)) in t ? Object.defineProperty(t, i, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[i] = e, t;
}
function $9ae5e4a12de151f5$var$xi(t, i) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(t);
        i && (s = s.filter(function(i) {
            return Object.getOwnPropertyDescriptor(t, i).enumerable;
        })), e.push.apply(e, s);
    }
    return e;
}
function $9ae5e4a12de151f5$var$Ei(t) {
    for(var i = 1; arguments.length > i; i++){
        var e = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9ae5e4a12de151f5$var$xi(Object(e), !0).forEach(function(i) {
            $9ae5e4a12de151f5$var$Si(t, i, e[i]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $9ae5e4a12de151f5$var$xi(Object(e)).forEach(function(i) {
            Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(e, i));
        });
    }
    return t;
}
var $9ae5e4a12de151f5$var$ki = class {
    constructor(t, i, e = []){
        this.coercers = t, this.stackParser = i, this.modifiers = e;
    }
    buildFromUnknown(t, i = {}) {
        const e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, s = this.buildCoercingContext(e, i, 0).apply(t), n = this.buildParsingContext(i), r = this.parseStacktrace(s, n);
        return {
            $exception_list: this.convertToExceptionList(r, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            for (const e of t)e.stacktrace && e.stacktrace.frames && $9ae5e4a12de151f5$var$T(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null === (i = t.syntheticException) || void 0 === i ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e;
        let s, n;
        if (null != t.cause && (s = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack) try {
            n = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? i.skipFirstLines : 0), i.chunkIdMap);
        } catch (t) {}
        return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            cause: s,
            stack: n,
            errors: null === (e = t.errors) || void 0 === e ? void 0 : e.map((t)=>this.parseStacktrace(t, i))
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (const e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            let e = t;
            for (const t of i.modifiers)e = yield t(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        const e = [], s = (t, n, r)=>{
            var o;
            const l = e.length, a = void 0 === n ? $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({
                type: "string" == typeof i.type && i.type.length > 0 ? i.type : "generic"
            }, "boolean" == typeof i.handled ? {
                handled: i.handled
            } : void 0 === i.handled ? {
                handled: !0
            } : {}), {}, {
                synthetic: "boolean" == typeof i.synthetic ? i.synthetic : t.synthetic,
                exception_id: l
            }) : {
                type: "chained",
                source: r,
                synthetic: t.synthetic,
                exception_id: l,
                parent_id: n
            }, u = {
                type: t.type,
                value: t.value,
                mechanism: a
            };
            t.stack && (u.stacktrace = {
                type: "raw",
                frames: t.stack
            }), e.push(u), t.cause && s(t.cause, l, "cause");
            for (const i of null !== (o = t.errors) && void 0 !== o ? o : [])s(i, l, "member");
        };
        return s(t), e;
    }
    buildParsingContext(t) {
        var i;
        return {
            chunkIdMap: $9ae5e4a12de151f5$var$wi(this.stackParser),
            skipFirstLines: null !== (i = t.skipFirstLines) && void 0 !== i ? i : 1
        };
    }
    getAggregateErrors(t) {
        try {
            if ($9ae5e4a12de151f5$var$H(t)) {
                let e = Object.getPrototypeOf(t);
                for(let s = 0; e && 100 > s; s++){
                    var i;
                    const s = null === (i = Object.getOwnPropertyDescriptor(e, "constructor")) || void 0 === i ? void 0 : i.value;
                    if ("function" == typeof s && "AggregateError" === s.name) {
                        const i = t.errors;
                        return $9ae5e4a12de151f5$var$T(i) ? i : void 0;
                    }
                    e = Object.getPrototypeOf(e);
                }
            }
        } catch (t) {}
    }
    buildCoercingContext(t, i, e = 0) {
        let s = 0, n = 0, r = !1;
        const o = new Set, l = [], a = {}, u = (t, i, e = 0)=>{
            const u = h(i, e), d = u.apply;
            if (u.apply = (i)=>{
                l.push(t);
                try {
                    return d(i);
                } finally{
                    l.pop();
                }
            }, e > 4 || e > 0 && -1 !== l.indexOf(t)) return this.coerceFallback(u);
            const c = "object" == typeof t && null !== t || "function" == typeof t;
            if (0 === e && s >= 50 || c && o.has(t)) return;
            c && o.add(t), 0 === e && s++;
            const v = this.getAggregateErrors(t);
            let f, p;
            r || (r = !!v);
            try {
                if (f = this.applyCoercers(t, u), !f) throw a;
            } catch (t) {
                if (t === a) return void (0 === e && s--);
                if (!r) throw t;
                f = this.coerceFallback(u);
            }
            if (!v || s >= 50) return f;
            try {
                p = v.length;
            } catch (t) {
                return f;
            }
            if (!Number.isInteger(p) || 0 > p || p > 4294967295) return f;
            const _ = [];
            for(let t = 0; 50 > s && 1e3 > n && p > t; t++){
                let e;
                n++;
                try {
                    e = u.next(v[t]);
                } catch (t) {
                    s++, e = this.coerceFallback(h(i + 1));
                }
                e && _.push(e);
            }
            return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, f), {}, {
                errors: _
            });
        }, h = (e, s = 0)=>$9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), {}, {
                syntheticException: 0 == e ? i.syntheticException : void 0,
                mechanism: 0 == e ? t : {},
                apply (t) {
                    const i = u(t, e, s + 1);
                    if (!i) throw a;
                    return i;
                },
                next: (t)=>u(t, e + 1)
            }), d = h(e);
        return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, d), {}, {
            apply: (t)=>{
                var i;
                return null !== (i = u(t, e)) && void 0 !== i ? i : this.coerceFallback(d);
            }
        });
    }
};
const $9ae5e4a12de151f5$var$Ti = /^([a-z][a-z0-9.+-]+):/i, $9ae5e4a12de151f5$var$Pi = [
    "http",
    "https",
    "file",
    "blob",
    "app",
    "capacitor",
    "ionic",
    "webpack",
    "webpack-internal",
    "ng"
];
function $9ae5e4a12de151f5$var$Ci(t) {
    if (!t || "<anonymous>" === t) return !1;
    const i = $9ae5e4a12de151f5$var$Ti.exec(t);
    return !i || $9ae5e4a12de151f5$var$Pi.includes(i[1].toLowerCase());
}
function $9ae5e4a12de151f5$var$Oi(t, i, e, s, n) {
    const r = {
        platform: t,
        filename: i,
        function: "<anonymous>" === e ? "?" : e,
        in_app: $9ae5e4a12de151f5$var$Ci(i)
    };
    return $9ae5e4a12de151f5$var$R(s) || (r.lineno = s), $9ae5e4a12de151f5$var$R(n) || (r.colno = n), r;
}
const $9ae5e4a12de151f5$var$Ri = (t, i)=>{
    const e = -1 !== t.indexOf("safari-extension"), s = -1 !== t.indexOf("safari-web-extension");
    return e || s ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : "?",
        e ? `safari-extension:${i}` : `safari-web-extension:${i}`
    ] : [
        t,
        i
    ];
}, $9ae5e4a12de151f5$var$Ii = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $9ae5e4a12de151f5$var$Ai = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $9ae5e4a12de151f5$var$Mi = /\((\S*)(?::(\d+))(?::(\d+))\)/, $9ae5e4a12de151f5$var$Fi = (t, i)=>{
    const e = $9ae5e4a12de151f5$var$Ii.exec(t);
    if (e) {
        const [, t, s, n] = e;
        return $9ae5e4a12de151f5$var$Oi(i, t, "?", +s, +n);
    }
    const s = $9ae5e4a12de151f5$var$Ai.exec(t);
    if (s) {
        if (s[2] && 0 === s[2].indexOf("eval")) {
            const t = $9ae5e4a12de151f5$var$Mi.exec(s[2]);
            t && (s[2] = t[1], s[3] = t[2], s[4] = t[3]);
        }
        const [t, e] = $9ae5e4a12de151f5$var$Ri(s[1] || "?", s[2]);
        return $9ae5e4a12de151f5$var$Oi(i, e, t, s[3] ? +s[3] : void 0, s[4] ? +s[4] : void 0);
    }
}, $9ae5e4a12de151f5$var$Di = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $9ae5e4a12de151f5$var$Ni = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $9ae5e4a12de151f5$var$ji = (t, i)=>{
    const e = $9ae5e4a12de151f5$var$Di.exec(t);
    if (e) {
        if (e[3] && e[3].indexOf(" > eval") > -1) {
            const t = $9ae5e4a12de151f5$var$Ni.exec(e[3]);
            t && (e[1] = e[1] || "eval", e[3] = t[1], e[4] = t[2], e[5] = "");
        }
        let t = e[3], s = e[1] || "?";
        return [s, t] = $9ae5e4a12de151f5$var$Ri(s, t), $9ae5e4a12de151f5$var$Oi(i, t, s, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0);
    }
}, $9ae5e4a12de151f5$var$Li = /\(error: (.*)\)/;
function $9ae5e4a12de151f5$var$Bi(t, i) {
    return t.filename === i.filename && t.function === i.function && t.module === i.module && t.lineno === i.lineno && t.colno === i.colno;
}
function $9ae5e4a12de151f5$var$Ui(t) {
    for(let i = 1; 10 >= i; i++){
        const e = t.length - 2 * i;
        if (0 > e) break;
        let s = !0;
        for(let n = 0; i > n; n++)if (!$9ae5e4a12de151f5$var$Bi(t[e + n], t[e + i + n])) {
            s = !1;
            break;
        }
        if (s) {
            for(let s = 0; i > s; s++)t[e + s] = t[e + i + s];
            return t.length = e + i, {
                start: e,
                length: i
            };
        }
    }
}
function $9ae5e4a12de151f5$var$zi(t, i) {
    const e = i.start + i.length, s = $9ae5e4a12de151f5$var$qi(t, i);
    s && t.splice(e + s === t.length ? e : i.start, s);
}
function $9ae5e4a12de151f5$var$Hi(t, i) {
    let e = i.start;
    for(; e > 0 && $9ae5e4a12de151f5$var$Bi(t[e - 1], t[e - 1 + i.length]);)e--;
    return i.start - e;
}
function $9ae5e4a12de151f5$var$qi(t, i) {
    const e = i.start + i.length;
    let s = e;
    for(; t.length > s && $9ae5e4a12de151f5$var$Bi(t[s], t[s - i.length]);)s++;
    return s - e;
}
function $9ae5e4a12de151f5$var$Vi(t, i) {
    const e = i[0];
    let s = t.length - (e ? $9ae5e4a12de151f5$var$Hi(t, e) : 0);
    for (const e of i)s -= $9ae5e4a12de151f5$var$qi(t, e);
    return s;
}
function $9ae5e4a12de151f5$var$Wi(t, i, e) {
    for(let s = 0; t.length > s; s++){
        const n = t[(i + s) % t.length], r = t[(e + s) % t.length];
        if (n !== r) return r > n;
    }
    return !1;
}
var $9ae5e4a12de151f5$var$Gi = class {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        const e = $9ae5e4a12de151f5$var$I(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        const i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? `${i}: ${t.message}` : i;
    }
    isDOMException(t) {
        return $9ae5e4a12de151f5$var$z(t, "DOMException");
    }
    isDOMError(t) {
        return $9ae5e4a12de151f5$var$z(t, "DOMError");
    }
}, $9ae5e4a12de151f5$var$Ki = class {
    match(t) {
        return $9ae5e4a12de151f5$var$H(t);
    }
    coerce(t, i) {
        var e;
        const s = this.getStack(t), n = void 0 === s ? null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack : void 0, r = !!n;
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: null != s ? s : n,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: r
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        const e = t.message;
        return String(e.error && "string" == typeof e.error.message ? e.error.message : e);
    }
    getStack(t) {
        try {
            const i = t.stacktrace;
            if ("string" == typeof i && i.length > 0) return i;
            const e = t.stack;
            return "string" == typeof e && e.length > 0 ? e : void 0;
        } catch (t) {
            return;
        }
    }
}, $9ae5e4a12de151f5$var$Ji = class {
    match(t) {
        return !!$9ae5e4a12de151f5$var$z(t, "ErrorEvent") && (null != t.error || this.ur(t));
    }
    coerce(t, i) {
        var e;
        if (null != t.error) return i.apply(t.error);
        const s = i.apply(t.message);
        return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), {}, {
            stack: null !== (e = this.cr(t)) && void 0 !== e ? e : s.stack,
            synthetic: !0
        });
    }
    ur(t) {
        return $9ae5e4a12de151f5$var$I(t.message) && t.message.length > 0;
    }
    cr(t) {
        var i, e;
        const s = t, n = null !== (i = s.lineno) && void 0 !== i ? i : 0, r = null !== (e = s.colno) && void 0 !== e ? e : 0;
        if ($9ae5e4a12de151f5$var$I(s.filename) && 0 !== s.filename.length && 0 !== n) return `Error\n    at ${s.filename}:${n}:${r}`;
    }
};
const $9ae5e4a12de151f5$var$Yi = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
var $9ae5e4a12de151f5$var$Xi = class {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e;
        const [s, n] = this.getInfos(t);
        return {
            type: null != s ? s : "Error",
            value: null != n ? n : t,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        let i = "Error", e = t;
        const s = t.match($9ae5e4a12de151f5$var$Yi);
        return s && (i = s[1], e = s[2]), [
            i,
            e
        ];
    }
};
const $9ae5e4a12de151f5$var$Qi = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $9ae5e4a12de151f5$var$Zi(t, i = 40) {
    const e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(let t = e.length; t > 0; t--){
        const s = e.slice(0, t).join(", ");
        if (i >= s.length) return t === e.length ? s : s.length > i ? `${s.slice(0, i)}...` : s;
    }
    return "";
}
var $9ae5e4a12de151f5$var$te = class {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, s;
        const n = this.getErrorPropertyFromObject(t);
        return n ? i.apply(n) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null !== (e = this.getStack(t)) && void 0 !== e ? e : null === (s = i.syntheticException) || void 0 === s ? void 0 : s.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        if ($9ae5e4a12de151f5$var$q(t)) return t.constructor.name;
        const i = "name" in t ? t.name : void 0;
        return $9ae5e4a12de151f5$var$I(i) && !$9ae5e4a12de151f5$var$A(i) ? i : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            let i = `'${t.name}' captured as exception`;
            return "message" in t && "string" == typeof t.message && (i += ` with message: '${t.message}'`), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        const i = this.getObjectClassName(t);
        return `${i && "Object" !== i ? `'${i}'` : "Object"} captured as exception with keys: ${$9ae5e4a12de151f5$var$Zi(t)}`;
    }
    isSeverityLevel(t) {
        return $9ae5e4a12de151f5$var$I(t) && !$9ae5e4a12de151f5$var$A(t) && $9ae5e4a12de151f5$var$Qi.indexOf(t) >= 0;
    }
    getStack(t) {
        try {
            return $9ae5e4a12de151f5$var$I(t.stacktrace) && t.stacktrace.length > 0 ? t.stacktrace : $9ae5e4a12de151f5$var$I(t.stack) && t.stack.length > 0 ? t.stack : void 0;
        } catch (t) {
            return;
        }
    }
    getErrorPropertyFromObject(t) {
        for(const i in t)if (({}).hasOwnProperty.call(t, i)) {
            const e = t[i];
            if ($9ae5e4a12de151f5$var$H(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            const i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}, $9ae5e4a12de151f5$var$ie = class {
    match(t) {
        return $9ae5e4a12de151f5$var$q(t);
    }
    coerce(t, i) {
        var e;
        const s = t.constructor.name;
        return {
            type: s,
            value: `${s} captured as exception with keys: ${$9ae5e4a12de151f5$var$Zi(t)}`,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        };
    }
}, $9ae5e4a12de151f5$var$ee = class {
    match(t) {
        return $9ae5e4a12de151f5$var$U(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: `Primitive value captured as exception: ${String(t)}`,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        };
    }
}, $9ae5e4a12de151f5$var$se = class {
    match(t) {
        return $9ae5e4a12de151f5$var$z(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
    }
    isCustomEventWrappingRejection(t) {
        if (!$9ae5e4a12de151f5$var$q(t)) return !1;
        try {
            const i = t.detail;
            return null != i && "object" == typeof i && "reason" in i;
        } catch (t) {
            return !1;
        }
    }
    coerce(t, i) {
        var e;
        const s = this.getUnhandledRejectionReason(t);
        return $9ae5e4a12de151f5$var$U(s) ? {
            type: "UnhandledRejection",
            value: `Non-Error promise rejection captured with value: ${String(s)}`,
            stack: null === (e = i.syntheticException) || void 0 === e ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(s);
    }
    getUnhandledRejectionReason(t) {
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && null != t.detail && "object" == typeof t.detail && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
};
const $9ae5e4a12de151f5$var$ne = "$message", $9ae5e4a12de151f5$var$re = "$timestamp", $9ae5e4a12de151f5$var$oe = new Set([
    $9ae5e4a12de151f5$var$ne,
    $9ae5e4a12de151f5$var$re
]), $9ae5e4a12de151f5$var$le = {
    enabled: !0,
    max_bytes: 32768
};
function $9ae5e4a12de151f5$var$ae(t) {
    var i;
    return t ? {
        enabled: null !== (i = t.enabled) && void 0 !== i ? i : $9ae5e4a12de151f5$var$le.enabled,
        max_bytes: $9ae5e4a12de151f5$var$he(t.max_bytes, $9ae5e4a12de151f5$var$le.max_bytes)
    } : $9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$le);
}
var $9ae5e4a12de151f5$var$ue = class {
    constructor(t){
        this.ns = [], this.ss = 0, this.Rr = $9ae5e4a12de151f5$var$ae(t);
    }
    setConfig(t) {
        this.Rr = $9ae5e4a12de151f5$var$ae(t), this.rs();
    }
    add(t) {
        const i = function(t) {
            let i;
            try {
                i = $9ae5e4a12de151f5$var$S(t);
            } catch (t) {
                return;
            }
            try {
                const t = JSON.parse(i);
                if (!$9ae5e4a12de151f5$var$C(t)) return;
                const e = t, s = e[$9ae5e4a12de151f5$var$ne], n = e[$9ae5e4a12de151f5$var$re];
                if (!$9ae5e4a12de151f5$var$I(s) || 0 === s.trim().length) return;
                if (!$9ae5e4a12de151f5$var$I(n) && !$9ae5e4a12de151f5$var$D(n)) return;
                return {
                    step: e,
                    json: i
                };
            } catch (t) {
                return;
            }
        }(t);
        if (!i) return;
        const e = function(t) {
            if ("u" > typeof TextEncoder) return (new TextEncoder).encode(t).length;
            const i = encodeURIComponent(t);
            let e = 0;
            for(let t = 0; i.length > t; t++)"%" === i[t] ? (e += 1, t += 2) : e += 1;
            return e;
        }(i.json);
        e > this.Rr.max_bytes || (this.ns.push({
            step: i.step,
            bytes: e
        }), this.ss += e, this.rs());
    }
    getAttachable() {
        return this.ns.map((t)=>t.step);
    }
    clear() {
        this.ns = [], this.ss = 0;
    }
    size() {
        return this.ns.length;
    }
    rs() {
        for(; this.ss > this.Rr.max_bytes && this.ns.length > 0;){
            const t = this.ns.shift();
            t && (this.ss -= t.bytes);
        }
    }
};
function $9ae5e4a12de151f5$var$he(t, i) {
    if (!$9ae5e4a12de151f5$var$D(t) || 1 / 0 === t || -1 / 0 === t) return i;
    const e = Math.floor(t);
    return 0 > e ? i : e;
}
const $9ae5e4a12de151f5$var$de = (t)=>{
    if ("string" != typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (i) {
        return t;
    }
};
function $9ae5e4a12de151f5$var$ce(t) {
    return "string" == typeof t || t;
}
function $9ae5e4a12de151f5$var$ve(t) {
    return "string" == typeof t ? t : void 0;
}
const $9ae5e4a12de151f5$var$fe = [
    "$feature_flag",
    "$feature_flag_response",
    "$feature_flag_has_experiment",
    "$feature_flag_id",
    "$feature_flag_version",
    "$feature_flag_reason",
    "$feature_flag_request_id",
    "$feature_flag_evaluated_at",
    "$feature_flag_error",
    "locally_evaluated",
    "$groups",
    "$process_person_profile",
    "$geoip_disable",
    "$current_url",
    "$pathname",
    "$referring_domain",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx",
    "$session_id",
    "$window_id",
    "$lib",
    "$lib_version",
    "$device_id",
    "$is_server"
], $9ae5e4a12de151f5$var$pe = "NativeGzipValidationError", $9ae5e4a12de151f5$var$_e = (t)=>t.length >= 2 && 31 === t[0] && 139 === t[1], $9ae5e4a12de151f5$var$ge = (t, i)=>t === $9ae5e4a12de151f5$var$_.GZipJS || i === $9ae5e4a12de151f5$var$_.GZipJS || "gzip" === i, $9ae5e4a12de151f5$var$me = (t)=>!(!t || "object" != typeof t) && "NotReadableError" === ("name" in t ? String(t.name) : "");
let $9ae5e4a12de151f5$var$be;
const $9ae5e4a12de151f5$var$ye = (t)=>{
    throw $9ae5e4a12de151f5$var$ci($9ae5e4a12de151f5$var$pe, `Native gzip produced invalid output: ${t}`);
}, $9ae5e4a12de151f5$var$we = ($9ae5e4a12de151f5$var$$e = $9ae5e4a12de151f5$var$Y(function*(t, i) {
    18 > t.size && $9ae5e4a12de151f5$var$ye("too-short");
    const e = new Uint8Array((yield t.slice(0, 10).arrayBuffer()));
    $9ae5e4a12de151f5$var$_e(e) && 8 === e[2] || $9ae5e4a12de151f5$var$ye("invalid-header");
    const s = new DataView((yield t.slice(t.size - 8).arrayBuffer()));
    s.getUint32(0, !0) !== ((t)=>{
        const i = (()=>{
            if ($9ae5e4a12de151f5$var$be) return $9ae5e4a12de151f5$var$be;
            $9ae5e4a12de151f5$var$be = [];
            for(let t = 0; 256 > t; t++){
                let i = t;
                for(let t = 0; 8 > t; t++)i = 1 & i ? 3988292384 ^ i >>> 1 : i >>> 1;
                $9ae5e4a12de151f5$var$be[t] = i >>> 0;
            }
            return $9ae5e4a12de151f5$var$be;
        })();
        let e = 4294967295;
        for(let s = 0; t.length > s; s++)e = i[255 & (e ^ t[s])] ^ e >>> 8;
        return (4294967295 ^ e) >>> 0;
    })(i) && $9ae5e4a12de151f5$var$ye("invalid-crc");
    const n = i.length >>> 0;
    s.getUint32(4, !0) !== n && $9ae5e4a12de151f5$var$ye("invalid-size");
}), function(t, i) {
    return $9ae5e4a12de151f5$var$$e.apply(this, arguments);
});
var $9ae5e4a12de151f5$var$$e;
function $9ae5e4a12de151f5$var$Se() {
    return $9ae5e4a12de151f5$var$Se = $9ae5e4a12de151f5$var$Y(function*(t, i = !0, e) {
        try {
            const i = (new TextEncoder).encode(t), e = new globalThis.CompressionStream("gzip"), n = e.writable.getWriter(), r = n.write(i).then(()=>n.close()).catch((s = $9ae5e4a12de151f5$var$Y(function*(t) {
                try {
                    yield n.abort(t);
                } catch (t) {}
                throw t;
            }), function(t) {
                return s.apply(this, arguments);
            })), o = new Response(e.readable).blob(), [l] = yield Promise.all([
                o,
                r
            ]);
            return yield $9ae5e4a12de151f5$var$we(l, i), l;
        } catch (t) {
            if (null == e ? void 0 : e.rethrow) throw t;
            return i && console.error("Failed to gzip compress data", t), null;
        }
        var s;
    }), $9ae5e4a12de151f5$var$Se.apply(this, arguments);
}
function $9ae5e4a12de151f5$var$xe(t, i) {
    if (null == t) return {};
    var e, s, n = function(t, i) {
        if (null == t) return {};
        var e = {};
        for(var s in t)if (({}).hasOwnProperty.call(t, s)) {
            if (i.includes(s)) continue;
            e[s] = t[s];
        }
        return e;
    }(t, i);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        for(s = 0; r.length > s; s++)i.includes(e = r[s]) || ({}).propertyIsEnumerable.call(t, e) && (n[e] = t[e]);
    }
    return n;
}
const $9ae5e4a12de151f5$var$Ee = {}.propertyIsEnumerable;
function $9ae5e4a12de151f5$var$ke(t, i) {
    try {
        return $9ae5e4a12de151f5$var$Ce(t, i, {
            ancestors: new WeakSet,
            remainingNodes: 1e4
        }, 0);
    } catch (t) {
        return [];
    }
}
function $9ae5e4a12de151f5$var$Te(t, i, e, s) {
    if (0 >= e.remainingNodes) return {
        stringValue: $9ae5e4a12de151f5$var$ni
    };
    if (e.remainingNodes--, $9ae5e4a12de151f5$var$j(t)) return {
        boolValue: t
    };
    if ("bigint" == typeof t) return function(t, i) {
        const e = t.toString(), s = BigInt("9223372036854775808");
        return t >= s || -s > t ? (null == i || i.debug(`Attribute ${e} is outside the int64 range; encoding it as a string`), {
            stringValue: e
        }) : {
            intValue: e
        };
    }(t, i);
    if ("number" == typeof t) {
        if (!Number.isFinite(t)) return {
            stringValue: String(t)
        };
        if (Number.isInteger(t)) {
            if (Number.isSafeInteger(t)) return {
                intValue: String(t)
            };
            if (typeof BigInt > "u") return {
                stringValue: String(t)
            };
            const e = BigInt(t).toString();
            return t >= 0x8000000000000000 || -9223372036854776000 > t ? (null == i || i.debug(`Attribute ${e} is outside the int64 range; encoding it as a string`), {
                stringValue: e
            }) : {
                intValue: e
            };
        }
        return {
            doubleValue: t
        };
    }
    if ("string" == typeof t) return {
        stringValue: $9ae5e4a12de151f5$var$oi(t)
    };
    if ("function" == typeof t) return {
        stringValue: "[Function]"
    };
    if ("symbol" == typeof t) return {
        stringValue: String(t)
    };
    if ("object" == typeof t && null !== t) {
        if (e.ancestors.has(t)) return {
            stringValue: "[Circular]"
        };
        if (s >= 20) return {
            stringValue: $9ae5e4a12de151f5$var$ni
        };
        if (t instanceof Date) {
            const i = t.getTime(), e = Number.isFinite(i) ? t.toISOString() : String(t);
            return {
                stringValue: "string" == typeof e ? $9ae5e4a12de151f5$var$oi(e) : String(e)
            };
        }
        e.ancestors.add(t);
        try {
            try {
                const n = t.toJSON;
                if ("function" == typeof n) return $9ae5e4a12de151f5$var$Te(n.call(t), i, e, s + 1);
            } catch (t) {}
            return $9ae5e4a12de151f5$var$T(t) ? {
                arrayValue: {
                    values: $9ae5e4a12de151f5$var$Pe(t, i, e, s + 1)
                }
            } : {
                kvlistValue: {
                    values: $9ae5e4a12de151f5$var$Ce(t, i, e, s + 1)
                }
            };
        } finally{
            e.ancestors.delete(t);
        }
    }
    return {
        stringValue: $9ae5e4a12de151f5$var$oi(String(t))
    };
}
function $9ae5e4a12de151f5$var$Pe(t, i, e, s) {
    const n = [], r = Math.min(t.length, 1e3);
    let o = 0;
    for(; r > o && e.remainingNodes > 0; o++)try {
        const r = o in t ? t[o] : void 0;
        if ($9ae5e4a12de151f5$var$F(r)) continue;
        n.push($9ae5e4a12de151f5$var$Te(r, i, e, s));
    } catch (t) {
        n.push({
            stringValue: $9ae5e4a12de151f5$var$ri
        });
    }
    return t.length > o && n.push({
        stringValue: $9ae5e4a12de151f5$var$ni
    }), n;
}
function $9ae5e4a12de151f5$var$Ce(t, i, e, s) {
    const n = [];
    for(const r in t)if ($9ae5e4a12de151f5$var$Ee.call(t, r)) {
        if (!r) {
            null == i || i.debug("Dropping an attribute with an empty key");
            continue;
        }
        if (n.length >= 1e3 || 0 >= e.remainingNodes) {
            null == i || i.debug("Attributes truncated: the value exceeds the OTLP encoder budget");
            break;
        }
        try {
            const o = t[r];
            if ($9ae5e4a12de151f5$var$M(o) || $9ae5e4a12de151f5$var$R(o)) continue;
            n.push({
                key: $9ae5e4a12de151f5$var$oi(r),
                value: $9ae5e4a12de151f5$var$Te(o, i, e, s)
            });
        } catch (t) {
            n.push({
                key: $9ae5e4a12de151f5$var$oi(r),
                value: {
                    stringValue: $9ae5e4a12de151f5$var$ri
                }
            });
        }
    }
    return n;
}
function $9ae5e4a12de151f5$var$Oe(t, i, e) {
    return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$li({}, t.resourceAttributes)), {}, {
        "service.name": t.serviceName || "unknown_service"
    }, t.environment && {
        "deployment.environment": t.environment
    }), t.serviceVersion && {
        "service.version": t.serviceVersion
    }), {}, {
        "telemetry.sdk.name": i,
        "telemetry.sdk.version": e
    });
}
const $9ae5e4a12de151f5$var$Re = [
    "service.name",
    "deployment.environment",
    "service.version",
    "telemetry.sdk.name",
    "telemetry.sdk.version"
];
function $9ae5e4a12de151f5$var$Ie(t, i) {
    const e = $9ae5e4a12de151f5$var$li({}, t), s = {};
    for (const t of $9ae5e4a12de151f5$var$Re)({}).hasOwnProperty.call(e, t) && (s[t] = e[t], delete e[t]);
    return [
        ...$9ae5e4a12de151f5$var$ke(e, i),
        ...$9ae5e4a12de151f5$var$ke(s, i)
    ];
}
const $9ae5e4a12de151f5$var$Ae = {
    darwin: "macOS",
    win32: "Windows",
    cygwin: "Windows",
    linux: "Linux",
    android: "Android",
    freebsd: "FreeBSD",
    openbsd: "OpenBSD",
    netbsd: "NetBSD",
    sunos: "SunOS",
    aix: "AIX",
    haiku: "Haiku",
    "Mac OS X": "macOS"
};
const $9ae5e4a12de151f5$var$Me = {
    trace: {
        text: "TRACE",
        number: 1
    },
    debug: {
        text: "DEBUG",
        number: 5
    },
    info: {
        text: "INFO",
        number: 9
    },
    warn: {
        text: "WARN",
        number: 13
    },
    error: {
        text: "ERROR",
        number: 17
    },
    fatal: {
        text: "FATAL",
        number: 21
    }
}, $9ae5e4a12de151f5$var$Fe = $9ae5e4a12de151f5$var$Me.info;
function $9ae5e4a12de151f5$var$De(t) {
    try {
        return $9ae5e4a12de151f5$var$oi(String(t));
    } catch (t) {
        return $9ae5e4a12de151f5$var$ri;
    }
}
function $9ae5e4a12de151f5$var$Ne(t, i, e, s) {
    const n = t.level || "info", { text: r, number: o } = $9ae5e4a12de151f5$var$Me[n] || $9ae5e4a12de151f5$var$Fe, l = function(t = Date.now()) {
        return String(t) + "000000";
    }($9ae5e4a12de151f5$var$D(s) ? s : void 0), a = {};
    i.distinctId && (a.posthogDistinctId = i.distinctId), i.sessionId && (a.sessionId = i.sessionId), i.windowId && (a["window.id"] = i.windowId), $9ae5e4a12de151f5$var$F(i.sessionStartTimestamp) || (a.sessionStartTimestamp = String(i.sessionStartTimestamp)), $9ae5e4a12de151f5$var$F(i.lastActivityTimestamp) || (a.lastActivityTimestamp = String(i.lastActivityTimestamp)), i.currentUrl && (a["url.full"] = i.currentUrl), i.screenName && (a["screen.name"] = i.screenName), i.appState && (a["app.state"] = i.appState), i.activeFeatureFlags && i.activeFeatureFlags.length > 0 && (a.feature_flags = i.activeFeatureFlags);
    const u = $9ae5e4a12de151f5$var$Ei({}, a), h = t.attributes;
    if (h) {
        let t = [];
        try {
            t = Object.keys(h);
        } catch (i) {
            t = [];
        }
        for (const i of t){
            let t;
            try {
                t = h[i];
            } catch (i) {
                t = $9ae5e4a12de151f5$var$ri;
            }
            Object.defineProperty(u, i, {
                value: t,
                enumerable: !0,
                writable: !0,
                configurable: !0
            });
        }
    }
    const d = {
        timeUnixNano: l,
        observedTimeUnixNano: l,
        severityNumber: o,
        severityText: r,
        body: {
            stringValue: $9ae5e4a12de151f5$var$De(t.body)
        },
        attributes: $9ae5e4a12de151f5$var$ke(u, e)
    };
    return t.trace_id && (d.traceId = t.trace_id), t.span_id && (d.spanId = t.span_id), $9ae5e4a12de151f5$var$R(t.trace_flags) || (d.flags = t.trace_flags), d;
}
function $9ae5e4a12de151f5$var$je(t, i, e) {
    return $9ae5e4a12de151f5$var$Oe(t, i, e);
}
function $9ae5e4a12de151f5$var$Le(t, i, e, s) {
    return {
        resourceLogs: [
            {
                resource: {
                    attributes: $9ae5e4a12de151f5$var$Ie(i)
                },
                scopeLogs: [
                    {
                        scope: {
                            name: e,
                            version: s
                        },
                        logRecords: t
                    }
                ]
            }
        ]
    };
}
var $9ae5e4a12de151f5$var$Be = class {
    constructor(t){
        this.ls = t, this.us = 0;
    }
    get pending() {
        return !!this.hs;
    }
    arm(t) {
        this.clear(), this.us = Date.now() + t, this.hs = $9ae5e4a12de151f5$var$pi(()=>{
            this.hs = void 0, this.ls();
        }, t);
    }
    armNoEarlierThan(t) {
        this.hs && Date.now() + t <= this.us || this.arm(t);
    }
    clear() {
        this.hs && (clearTimeout(this.hs), this.hs = void 0);
    }
};
function $9ae5e4a12de151f5$var$Ue() {
    return .75 + .5 * Math.random();
}
function $9ae5e4a12de151f5$var$ze(t, i, e, s) {
    const n = Math.min(Math.max(0, i - 1), 6), r = t * Math.pow(2, n);
    return Math.round((void 0 === s ? r : Math.min(r, Math.max(s, t))) * e);
}
var $9ae5e4a12de151f5$var$He = class {
    constructor(t, i, e, s, n, r = ()=>Promise.resolve(), o){
        var l;
        this._instance = t, this.Rr = i, this.$ = e, this.cs = s, this.ds = n, this.vs = r, this.fs = o, this.ps = new $9ae5e4a12de151f5$var$Be(()=>this.gs()), this.ys = null, this.bs = 0, this._s = 0, this.ws = new $9ae5e4a12de151f5$var$ui, this.ks = 0, this.Ss = 1, this.xs = 0, this.Cs = 0, this.$s = !1, this.Ts = i.maxBufferSize, this.Is = Math.max(null !== (l = i.maxQueueSize) && void 0 !== l ? l : i.maxBufferSize, i.maxBufferSize), this.Ms = i.flushIntervalMs, this.Es = i.maxBatchRecordsPerPost, this.Ps = i.rateCapWindowMs, this.Rs = i.maxLogsPerInterval;
    }
    clearQueue() {
        this._s++, this._instance.setPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue, []);
    }
    reset() {
        this.ps.clear(), this.xs = 0, this.Cs = 0, this.$s = !1, this.ks = 0, this.Ss = 1, this.ws.reset(), this.Es = this.Rr.maxBatchRecordsPerPost;
    }
    onReconnect() {
        this.ks = 0, this.Ss = 1, this.ws.isOpen() ? this.As() && this.Fs() : this.gs();
    }
    captureLog(t, i) {
        var e;
        if (this._instance.isDisabled) return;
        if (this._instance.optedOut) return;
        if (!(null == t ? void 0 : t.body)) return;
        const s = this.Os(t);
        if (null === s) return;
        if (!s.body) return void this.$.info("Log was rejected in beforeSend function");
        if (!this.Ds()) return;
        const n = {
            record: $9ae5e4a12de151f5$var$Ne(s, null !== (e = null == i ? void 0 : i.context) && void 0 !== e ? e : this.cs(), this.$, null == i ? void 0 : i.occurredAtMs)
        };
        this.ds(()=>this.Ls(n));
    }
    Os(t) {
        const i = this.Rr.beforeSend;
        if (!i) return t;
        const e = $9ae5e4a12de151f5$var$T(i) ? i : [
            i
        ];
        let s = t;
        for (const t of e)try {
            const i = t(s);
            if (!i) return this.$.info("Log was rejected in beforeSend function"), null;
            s = i;
        } catch (t) {
            return this.$.error("Error in beforeSend function for log:", t), null;
        }
        return s;
    }
    Ds() {
        if (void 0 === this.Rs) return !0;
        const t = Date.now(), i = t - this.xs;
        return this.Ps > i && i >= 0 || (this.xs = t, this.Cs = 0, this.$s = !1), this.Rs > this.Cs ? (this.Cs++, !0) : (this.$s || (this.$.warn(`captureLog dropping logs: exceeded ${this.Rs} logs per ${this.Ps}ms`), this.$s = !0), !1);
    }
    flush() {
        var t = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            if (!t._instance.isDisabled) return t.ys || (t.ys = t.Ns().finally(()=>{
                t.ys = null;
            })), t.ys;
        })();
    }
    Ns() {
        var t = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            var i;
            t.ps.clear();
            let e = null !== (i = t._instance.getPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue)) && void 0 !== i ? i : [];
            if (0 === e.length) return;
            const s = e.length;
            let n = 0;
            for(; e.length > 0 && s > n;){
                var r, o;
                const i = t._s;
                t.bs = 0;
                const s = Math.min(e.length, t.Es), l = e.slice(0, s), a = $9ae5e4a12de151f5$var$Le(l.map((t)=>t.record), t.qs(), null !== (r = t.fs) && void 0 !== r ? r : t._instance.getLibraryId(), t._instance.getLibraryVersion()), u = yield t._instance.js(a);
                if (t._s !== i) return;
                if ("too-large" === u.kind && l.length > 1) t.Es = Math.max(1, Math.floor(l.length / 2)), t.$.warn(`Logs batch of size ${l.length} was too large for the ingestion endpoint, reducing batch size to ${t.Es}`);
                else {
                    if (t.ws.record(u), t.ps.pending && t.ps.arm(Math.max(t.Ms, t.ws.remainingMs())), "retry-later" === u.kind) throw u.error;
                    if ("too-large" === u.kind ? t.$.warn("Dropping a single log record with batch size 1 \u2014 the record is larger than the server cap and cannot be split further.") : "ok" === u.kind && t.Rr.maxBatchRecordsPerPost > t.Es && (t.Es = Math.min(t.Rr.maxBatchRecordsPerPost, t.Es + 1)), yield t.Bs(l.length), e = null !== (o = t._instance.getPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue)) && void 0 !== o ? o : [], n += l.length, "fatal" === u.kind) throw u.error;
                }
            }
        })();
    }
    Bs(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            var e;
            const s = Math.max(0, t - i.bs), n = null !== (e = i._instance.getPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue)) && void 0 !== e ? e : [];
            i._instance.setPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue, n.slice(s)), yield i.vs();
        })();
    }
    qs() {
        return $9ae5e4a12de151f5$var$je(this.Rr, this._instance.getLibraryId(), this._instance.getLibraryVersion());
    }
    Ls(t) {
        var i;
        if (this._instance.optedOut) return;
        const e = null !== (i = this._instance.getPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue)) && void 0 !== i ? i : [];
        this.Is > e.length || (e.shift(), this.bs++, this.$.info("Logs queue is full, dropping oldest record.")), e.push(t), this._instance.setPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue, e), this.Ts > e.length || this.ws.isOpen() ? this.Fs() : this.gs();
    }
    Fs() {
        this.ps.pending || this.ps.arm(Math.max(this.Ms, this.ws.remainingMs()));
    }
    Hs() {
        return Math.max($9ae5e4a12de151f5$var$ze(this.Ms, this.ks, this.Ss, 3e4), this.ws.remainingMs());
    }
    As() {
        const t = this._instance.getPersistedProperty($9ae5e4a12de151f5$var$p.LogsQueue);
        return !!t && t.length > 0;
    }
    shutdown(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            i.ps.clear();
            const e = i.flush().catch(()=>{});
            void 0 !== t ? yield $9ae5e4a12de151f5$var$_i(e, t) : yield e;
        })();
    }
    flushWithTimeout(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            const e = i.flush();
            yield $9ae5e4a12de151f5$var$_i(e, t, ()=>{
                e.catch(()=>{});
            });
        })();
    }
    gs() {
        this.flush().then(()=>{
            this.ks = 0, this.Ss = 1;
        }, (t)=>{
            this.ks++, this.Ss = $9ae5e4a12de151f5$var$Ue(), this.$.error("PostHog logs flush failed:", t);
        }).finally(()=>{
            !this._instance.isDisabled && this.As() && this.ps.armNoEarlierThan(this.Hs());
        });
    }
};
const $9ae5e4a12de151f5$var$qe = [
    0,
    5,
    10,
    25,
    50,
    75,
    100,
    250,
    500,
    750,
    1e3,
    2500,
    5e3,
    7500,
    1e4
];
function $9ae5e4a12de151f5$var$Ve(t) {
    return String(t) + "000000";
}
function $9ae5e4a12de151f5$var$We(t, i, e, s) {
    let n = "";
    return s && (n = Object.keys(s).sort().map((t)=>`${JSON.stringify(t)}:${JSON.stringify(s[t])}`).join(",")), `${t}\0${i}\0${null != e ? e : ""}\0${n}`;
}
var $9ae5e4a12de151f5$var$Ge = class {
    constructor(t, i, e){
        this._instance = t, this.Rr = i, this.$ = e, this.zs = new Map, this.ps = new $9ae5e4a12de151f5$var$Be(()=>this.flush().catch((t)=>{
                this.$.error("Metrics flush failed:", t);
            })), this.ys = null, this.Us = !1, this.Ws = new Map, this.Vs = new Set, this.ws = new $9ae5e4a12de151f5$var$ui, this.ks = 0, this.Ss = 1, this.Gs = 0;
    }
    count(t, i = 1, e) {
        this.Zs({
            name: t,
            type: "count",
            value: i,
            unit: null == e ? void 0 : e.unit,
            attributes: null == e ? void 0 : e.attributes
        });
    }
    gauge(t, i, e) {
        this.Zs({
            name: t,
            type: "gauge",
            value: i,
            unit: null == e ? void 0 : e.unit,
            attributes: null == e ? void 0 : e.attributes
        });
    }
    histogram(t, i, e) {
        this.Zs({
            name: t,
            type: "histogram",
            value: i,
            unit: null == e ? void 0 : e.unit,
            attributes: null == e ? void 0 : e.attributes
        });
    }
    flush() {
        var t = this;
        const i = this.ys, e = (function() {
            var e = $9ae5e4a12de151f5$var$Y(function*() {
                i && (yield i.catch(()=>{})), yield t.Qs();
            });
            return function() {
                return e.apply(this, arguments);
            };
        })()().finally(()=>{
            this.ys === e && (this.ys = null);
        });
        return this.ys = e, e;
    }
    drainWindow() {
        if (0 === this.zs.size) return null;
        const t = this.zs;
        return this.zs = new Map, this.Us = !1, this.Ws = new Map, this.Vs = new Set, this.Js(t);
    }
    reset() {
        this.Gs++, this.ws.reset(), this.ks = 0, this.Ss = 1, this.ps.clear(), this.zs = new Map, this.ys = null, this.Us = !1, this.Ws = new Map, this.Vs = new Set;
    }
    Zs(t) {
        if (this._instance.isDisabled || this._instance.optedOut) return;
        const i = this.Os(t);
        if (null === i) return;
        if (!i.name || "string" != typeof i.name) return void this.$.warn("Dropping metric with empty name");
        if ("number" != typeof i.value || !Number.isFinite(i.value)) return void this.$.warn(`Dropping metric '${i.name}': value must be a finite number`);
        if ("count" === i.type && 0 > i.value) return void this.$.warn(`Dropping count '${i.name}': counters are monotonic, value must be >= 0`);
        let e, s;
        try {
            e = i.attributes ? $9ae5e4a12de151f5$var$Ei({}, i.attributes) : void 0, s = $9ae5e4a12de151f5$var$We(i.type, i.name, i.unit, e);
        } catch (t) {
            return void this.$.warn(`Dropping metric '${i.name}': attributes could not be serialized`, t);
        }
        let n = this.zs.get(s);
        if (!n) {
            if (!this.Ks()) return;
            n = {
                name: i.name,
                type: i.type,
                unit: i.unit,
                attributes: e,
                windowStartMs: Date.now()
            }, this.zs.set(s, n);
        }
        const r = this.Ws.get(i.name);
        void 0 === r ? this.Ws.set(i.name, i.type) : r === i.type || this.Vs.has(i.name) || (this.Vs.add(i.name), this.$.warn(`Metric name '${i.name}' is already used as a ${r}; recording it as a ${i.type} too will blend both series in charts. Use a distinct name.`)), this.Xs(n, i.value), this.Fs();
    }
    Ks() {
        return this.Rr.maxSeriesPerFlush > this.zs.size || (this.Us || (this.Us = !0, this.$.warn(`Metric series cap reached (${this.Rr.maxSeriesPerFlush} per flush window); dropping new series until the next flush. Reduce attribute cardinality.`)), !1);
    }
    Xs(t, i) {
        switch(t.type){
            case "count":
                var e;
                t.total = (null !== (e = t.total) && void 0 !== e ? e : 0) + i;
                break;
            case "gauge":
                t.last = i;
                break;
            case "histogram":
                {
                    t.hist || (t.hist = {
                        count: 0,
                        sum: 0,
                        min: i,
                        max: i,
                        bucketCounts: new Array($9ae5e4a12de151f5$var$qe.length + 1).fill(0)
                    });
                    const e = t.hist;
                    e.count += 1, e.sum += i, e.min = Math.min(e.min, i), e.max = Math.max(e.max, i), e.bucketCounts[function(t, i) {
                        for(let e = 0; i.length > e; e++)if (i[e] >= t) return e;
                        return i.length;
                    }(i, $9ae5e4a12de151f5$var$qe)] += 1;
                    break;
                }
        }
    }
    Os(t) {
        const i = this.Rr.beforeSend;
        if (!i) return t;
        const e = $9ae5e4a12de151f5$var$T(i) ? i : [
            i
        ];
        let s = t;
        for (const t of e)try {
            const i = t(s);
            if (!i) return this.$.info("Metric was rejected in beforeSend function"), null;
            s = i;
        } catch (t) {
            return this.$.error("Error in beforeSend function for metric:", t), null;
        }
        return s;
    }
    Fs() {
        this.ps.pending || this.ps.arm(this.Hs());
    }
    Hs() {
        return Math.max($9ae5e4a12de151f5$var$ze(this.Rr.flushIntervalMs, this.ks, this.Ss, 3e4), this.ws.remainingMs());
    }
    Qs() {
        var t = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            if (t.ps.clear(), 0 === t.zs.size) return;
            const i = t.zs;
            t.zs = new Map, t.Us = !1, t.Ws = new Map, t.Vs = new Set;
            const e = t.Gs, s = yield t._instance.Ys(t.Js(i));
            if (e === t.Gs) switch(t.ws.record(s), "retry-later" === s.kind ? (t.ks++, t.Ss = $9ae5e4a12de151f5$var$Ue()) : (t.ks = 0, t.Ss = 1), t.ps.pending && t.ps.arm(t.Hs()), s.kind){
                case "ok":
                    return;
                case "retry-later":
                    return t.ho(i), void t.ps.armNoEarlierThan(t.Hs());
                case "too-large":
                    return void t.$.warn("Metrics batch exceeded the server size limit and was dropped");
                case "fatal":
                    return void t.$.error("Failed to send metrics batch:", s.error);
            }
        })();
    }
    Js(t) {
        var i, e, s, n;
        return i = this.vo(t), e = function(t, i, e) {
            return $9ae5e4a12de151f5$var$Oe(t, i, e);
        }(this.Rr, this._instance.getLibraryId(), this._instance.getLibraryVersion()), s = this._instance.getLibraryId(), n = this._instance.getLibraryVersion(), {
            resourceMetrics: [
                {
                    resource: {
                        attributes: $9ae5e4a12de151f5$var$Ie(e)
                    },
                    scopeMetrics: [
                        {
                            scope: {
                                name: s,
                                version: n
                            },
                            metrics: i
                        }
                    ]
                }
            ]
        };
    }
    vo(t) {
        const i = $9ae5e4a12de151f5$var$Ve(Date.now()), e = new Map;
        for (const o of t.values()){
            var s;
            const t = $9ae5e4a12de151f5$var$We(o.type, o.name, o.unit, void 0);
            let l = e.get(t);
            l || (l = $9ae5e4a12de151f5$var$Ei({
                name: o.name
            }, o.unit && {
                unit: o.unit
            }), "count" === o.type ? l.sum = {
                aggregationTemporality: 1,
                isMonotonic: !0,
                dataPoints: []
            } : "gauge" === o.type ? l.gauge = {
                dataPoints: []
            } : l.histogram = {
                aggregationTemporality: 1,
                dataPoints: []
            }, e.set(t, l));
            const a = $9ae5e4a12de151f5$var$ke(null !== (s = o.attributes) && void 0 !== s ? s : {}, this.$), u = $9ae5e4a12de151f5$var$Ve(o.windowStartMs);
            if ("count" === o.type) {
                var n;
                const t = {
                    attributes: a,
                    startTimeUnixNano: u,
                    timeUnixNano: i,
                    asDouble: null !== (n = o.total) && void 0 !== n ? n : 0
                };
                l.sum.dataPoints.push(t);
            } else if ("gauge" === o.type) {
                var r;
                const t = {
                    attributes: a,
                    timeUnixNano: i,
                    asDouble: null !== (r = o.last) && void 0 !== r ? r : 0
                };
                l.gauge.dataPoints.push(t);
            } else o.hist && l.histogram.dataPoints.push({
                attributes: a,
                startTimeUnixNano: u,
                timeUnixNano: i,
                count: o.hist.count,
                sum: o.hist.sum,
                min: o.hist.min,
                max: o.hist.max,
                bucketCounts: o.hist.bucketCounts,
                explicitBounds: $9ae5e4a12de151f5$var$qe
            });
        }
        return Array.from(e.values());
    }
    ho(t) {
        for (const [s, n] of t){
            const t = this.zs.get(s);
            if (t) switch(t.windowStartMs = Math.min(t.windowStartMs, n.windowStartMs), t.type){
                case "count":
                    var i, e;
                    t.total = (null !== (i = t.total) && void 0 !== i ? i : 0) + (null !== (e = n.total) && void 0 !== e ? e : 0);
                    break;
                case "gauge":
                    break;
                case "histogram":
                    if (n.hist) {
                        if (t.hist) {
                            t.hist.count += n.hist.count, t.hist.sum += n.hist.sum, t.hist.min = Math.min(t.hist.min, n.hist.min), t.hist.max = Math.max(t.hist.max, n.hist.max);
                            for(let i = 0; t.hist.bucketCounts.length > i; i++)t.hist.bucketCounts[i] += n.hist.bucketCounts[i];
                        } else t.hist = n.hist;
                    }
            }
            else this.Ks() && this.zs.set(s, n);
        }
    }
};
const $9ae5e4a12de151f5$var$Ke = (i, { debugEnabled: e } = {})=>{
    const s = {
        N (s, ...n) {
            $9ae5e4a12de151f5$var$t && ($9ae5e4a12de151f5$var$f.DEBUG || $9ae5e4a12de151f5$var$t.POSTHOG_DEBUG || e) && !$9ae5e4a12de151f5$var$R($9ae5e4a12de151f5$var$t.console) && $9ae5e4a12de151f5$var$t.console && ("__rrweb_original__" in $9ae5e4a12de151f5$var$t.console[s] ? $9ae5e4a12de151f5$var$t.console[s].__rrweb_original__ : $9ae5e4a12de151f5$var$t.console[s])(i, ...n);
        },
        debug (...t) {
            s.N("debug", ...t);
        },
        info (...t) {
            s.N("log", ...t);
        },
        warn (...t) {
            s.N("warn", ...t);
        },
        error (...t) {
            s.N("error", ...t);
        },
        critical (...t) {
            console.error(i, ...t);
        },
        uninitializedWarning (t) {
            s.error(`You must initialize PostHog before calling ${t}`);
        },
        createLogger: (t, e)=>$9ae5e4a12de151f5$var$Ke(`${i} ${t}`, e)
    };
    return s;
}, $9ae5e4a12de151f5$var$Je = $9ae5e4a12de151f5$var$Ke("[PostHog.js]"), $9ae5e4a12de151f5$var$Ye = $9ae5e4a12de151f5$var$Je.createLogger, $9ae5e4a12de151f5$var$Xe = $9ae5e4a12de151f5$var$Ye("[ExternalScriptsLoader]"), $9ae5e4a12de151f5$var$Qe = (t)=>{
    const i = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.querySelectorAll("script");
    if (i) {
        for(let e = 0; i.length > e; e++)if (i[e].src === t || i[e].getAttribute("src") === t) return i[e];
    }
}, $9ae5e4a12de151f5$var$Ze = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $9ae5e4a12de151f5$var$Xe.warn(`${i} was requested but loading of external scripts is disabled.`), e("Loading of external scripts is disabled");
    const n = $9ae5e4a12de151f5$var$Qe(i);
    if (n) {
        if (n.__posthog_loading_callback_fired) return e();
        const t = n.__posthog_loading_error;
        return t ? e(t) : (n.addEventListener("load", (t)=>{
            n.__posthog_loading_callback_fired = !0, e(void 0, t);
        }), void n.addEventListener("error", (t)=>{
            n.__posthog_loading_error = t, e(t);
        }));
    }
    const r = ()=>{
        if (!$9ae5e4a12de151f5$var$s) return e("document not found");
        if ($9ae5e4a12de151f5$var$Qe(i)) return $9ae5e4a12de151f5$var$Ze(t, i, e);
        let n = $9ae5e4a12de151f5$var$s.createElement("script");
        if (n.type = "text/javascript", n.crossOrigin = "anonymous", n.src = i, n.onload = (t)=>{
            n.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, n.onerror = (t)=>{
            n.__posthog_loading_error = t, e(t);
        }, t.config.prepare_external_dependency_script && (n = t.config.prepare_external_dependency_script(n)), !n) return e("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $9ae5e4a12de151f5$var$s.head.appendChild(n);
        else {
            const t = $9ae5e4a12de151f5$var$s.querySelectorAll("body > script");
            var r;
            t.length > 0 ? null === (r = t[0].parentNode) || void 0 === r || r.insertBefore(n, t[0]) : $9ae5e4a12de151f5$var$s.body.appendChild(n);
        }
    };
    (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.body) ? r() : null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.addEventListener("DOMContentLoaded", r);
}, $9ae5e4a12de151f5$var$ts = {}, $9ae5e4a12de151f5$var$is = (t, i)=>{
    let e = `/static/${i}.js?v=${t.version}`;
    if ("toolbar" === i) {
        const t = 3e5;
        e = `${e}&t=${Math.floor(Date.now() / t) * t}`;
    }
    return t.requestRouter.endpointFor("assets", e);
};
$9ae5e4a12de151f5$var$c.__PosthogExtensions__ = $9ae5e4a12de151f5$var$c.__PosthogExtensions__ || {}, $9ae5e4a12de151f5$var$c.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    if ("remote-config" === i) {
        const i = t.requestRouter.endpointFor("assets", `/array/${t.config.token}/config.js`);
        return void $9ae5e4a12de151f5$var$Ze(t, i, e);
    }
    const s = t.config.strict_script_versioning;
    if (s) {
        const n = t.requestRouter.endpointFor("assets", `/static/${t.version}/${i}.js`), r = $9ae5e4a12de151f5$var$ts[n];
        if ("fallback" === s && r) {
            if ($9ae5e4a12de151f5$var$Qe(r)) return void $9ae5e4a12de151f5$var$Ze(t, r, e);
            delete $9ae5e4a12de151f5$var$ts[n];
        }
        return void $9ae5e4a12de151f5$var$Ze(t, n, "fallback" === s ? (s, r)=>{
            if (s) {
                if ("string" == typeof s) e(s);
                else {
                    var o;
                    const s = $9ae5e4a12de151f5$var$is(t, i);
                    $9ae5e4a12de151f5$var$ts[n] = s;
                    const r = $9ae5e4a12de151f5$var$Qe(n);
                    null == r || null === (o = r.parentNode) || void 0 === o || o.removeChild(r), $9ae5e4a12de151f5$var$Ze(t, s, e);
                }
            } else e(void 0, r);
        } : e);
    }
    $9ae5e4a12de151f5$var$Ze(t, $9ae5e4a12de151f5$var$is(t, i), e);
}, $9ae5e4a12de151f5$var$c.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    const s = t.requestRouter.endpointFor("api", i);
    $9ae5e4a12de151f5$var$Ze(t, s, e);
}, $9ae5e4a12de151f5$var$f.DEBUG = !1, $9ae5e4a12de151f5$var$f.LIB_VERSION = "1.434.14", $9ae5e4a12de151f5$var$f.LIB_NAME = "web";
var $9ae5e4a12de151f5$var$es = $9ae5e4a12de151f5$var$f;
const $9ae5e4a12de151f5$var$ss = "$people_distinct_id", $9ae5e4a12de151f5$var$ns = "distinct_id", $9ae5e4a12de151f5$var$rs = "$device_id", $9ae5e4a12de151f5$var$os = "$device_model", $9ae5e4a12de151f5$var$ls = "__alias", $9ae5e4a12de151f5$var$as = "__cmpns", $9ae5e4a12de151f5$var$us = "$fbc", $9ae5e4a12de151f5$var$hs = "$fbc_persistence", $9ae5e4a12de151f5$var$ds = "$fbp", $9ae5e4a12de151f5$var$cs = "$fbp_persistence", $9ae5e4a12de151f5$var$vs = "__timers", $9ae5e4a12de151f5$var$fs = "$autocapture_disabled_server_side", $9ae5e4a12de151f5$var$ps = "$heatmaps_enabled_server_side", $9ae5e4a12de151f5$var$_s = "$exception_capture_enabled_server_side", $9ae5e4a12de151f5$var$gs = "$error_tracking_suppression_rules", $9ae5e4a12de151f5$var$ms = "$error_tracking_capture_extension_exceptions", $9ae5e4a12de151f5$var$bs = "$web_vitals_enabled_server_side", $9ae5e4a12de151f5$var$ys = "$dead_clicks_enabled_server_side", $9ae5e4a12de151f5$var$ws = "$product_tours_enabled_server_side", $9ae5e4a12de151f5$var$$s = "$logs_capture_enabled_server_side", $9ae5e4a12de151f5$var$Ss = "$web_vitals_allowed_metrics", $9ae5e4a12de151f5$var$xs = "$session_recording_remote_config", $9ae5e4a12de151f5$var$Es = "$session_recording_enabled_server_side", $9ae5e4a12de151f5$var$ks = "$replay_sample_rate", $9ae5e4a12de151f5$var$Ts = "$replay_override_sampling", $9ae5e4a12de151f5$var$Ps = "$replay_override_linked_flag", $9ae5e4a12de151f5$var$Cs = "$replay_override_url_trigger", $9ae5e4a12de151f5$var$Os = "$replay_override_event_trigger", $9ae5e4a12de151f5$var$Rs = "$sesid", $9ae5e4a12de151f5$var$Is = "$session_is_sampled", $9ae5e4a12de151f5$var$As = "$session_past_minimum_duration", $9ae5e4a12de151f5$var$Ms = "$session_recording_url_trigger_activated_session", $9ae5e4a12de151f5$var$Fs = "$session_recording_event_trigger_activated_session", $9ae5e4a12de151f5$var$Ds = "$debug_first_full_snapshot_timestamp", $9ae5e4a12de151f5$var$Ns = "$sess_rec_flush_size", $9ae5e4a12de151f5$var$js = "$enabled_feature_flags", $9ae5e4a12de151f5$var$Ls = "$active_feature_flags", $9ae5e4a12de151f5$var$Bs = "$early_access_features", $9ae5e4a12de151f5$var$Us = "$feature_flag_details", $9ae5e4a12de151f5$var$zs = "$feature_flag_payloads", $9ae5e4a12de151f5$var$Hs = "$feature_flag_request_id", $9ae5e4a12de151f5$var$qs = "$minimal_flag_called_events", $9ae5e4a12de151f5$var$Vs = "$override_feature_flags", $9ae5e4a12de151f5$var$Ws = "$override_feature_flag_payloads", $9ae5e4a12de151f5$var$Gs = "$stored_person_properties", $9ae5e4a12de151f5$var$Ks = "$stored_group_properties", $9ae5e4a12de151f5$var$Js = "$groups", $9ae5e4a12de151f5$var$Ys = "$surveys", $9ae5e4a12de151f5$var$Xs = "$surveys_loaded_at", $9ae5e4a12de151f5$var$Qs = "$surveys_activated", $9ae5e4a12de151f5$var$Zs = "$surveys_activated_session", $9ae5e4a12de151f5$var$tn = "$surveys_activated_timestamps", $9ae5e4a12de151f5$var$en = "ph_product_tours", $9ae5e4a12de151f5$var$sn = "$product_tours_activated", $9ae5e4a12de151f5$var$nn = "$product_tours_activated_session", $9ae5e4a12de151f5$var$rn = "$conversations_widget_session_id", $9ae5e4a12de151f5$var$on = "$conversations_ticket_id", $9ae5e4a12de151f5$var$ln = "$conversations_widget_state", $9ae5e4a12de151f5$var$an = "$conversations_user_traits", $9ae5e4a12de151f5$var$un = "$flag_call_reported", $9ae5e4a12de151f5$var$hn = "$flag_call_reported_session_id", $9ae5e4a12de151f5$var$dn = "$feature_flag_errors", $9ae5e4a12de151f5$var$cn = "$feature_flag_evaluated_at", $9ae5e4a12de151f5$var$vn = "$user_state", $9ae5e4a12de151f5$var$fn = "$client_session_props", $9ae5e4a12de151f5$var$pn = "$capture_rate_limit", $9ae5e4a12de151f5$var$_n = "$initial_campaign_params", $9ae5e4a12de151f5$var$gn = "$initial_referrer_info", $9ae5e4a12de151f5$var$mn = "$initial_person_info", $9ae5e4a12de151f5$var$bn = "$epp", $9ae5e4a12de151f5$var$yn = "$posthog_cookieless", $9ae5e4a12de151f5$var$wn = "$cookieless_mode", $9ae5e4a12de151f5$var$$n = "$sdk_debug_extensions_init_method", $9ae5e4a12de151f5$var$Sn = "$sdk_debug_extensions_init_time_ms", $9ae5e4a12de151f5$var$xn = "$sdk_debug_recording_script_not_loaded", $9ae5e4a12de151f5$var$En = "$sdk_debug_replay_stale_config", $9ae5e4a12de151f5$var$kn = "$sdk_debug_replay_event_trigger_status", $9ae5e4a12de151f5$var$Tn = "$sdk_debug_replay_linked_flag_trigger_status", $9ae5e4a12de151f5$var$Pn = "$sdk_debug_replay_matched_recording_trigger_groups", $9ae5e4a12de151f5$var$Cn = "$sdk_debug_replay_pending_trigger_conditions", $9ae5e4a12de151f5$var$On = "$sdk_debug_replay_remote_trigger_matching_config", $9ae5e4a12de151f5$var$Rn = "$sdk_debug_replay_trigger_groups_count", $9ae5e4a12de151f5$var$In = "$sdk_debug_replay_url_trigger_status", $9ae5e4a12de151f5$var$An = "$session_recording_start_reason", $9ae5e4a12de151f5$var$Mn = "PostHog loadExternalDependency extension not found.", $9ae5e4a12de151f5$var$Fn = "anonymous", $9ae5e4a12de151f5$var$Dn = "identified", $9ae5e4a12de151f5$var$Nn = "identified_only", $9ae5e4a12de151f5$var$jn = "visibilitychange", $9ae5e4a12de151f5$var$Ln = "beforeunload", $9ae5e4a12de151f5$var$Bn = "$pageview", $9ae5e4a12de151f5$var$Un = "$pageleave", $9ae5e4a12de151f5$var$zn = "$identify", $9ae5e4a12de151f5$var$Hn = "$groupidentify";
function $9ae5e4a12de151f5$var$qn(t, i) {
    $9ae5e4a12de151f5$var$T(t) && t.forEach(i);
}
function $9ae5e4a12de151f5$var$Vn(t, i) {
    if (!$9ae5e4a12de151f5$var$F(t)) {
        if ($9ae5e4a12de151f5$var$T(t)) t.forEach(i);
        else if (((t)=>t instanceof FormData)(t)) t.forEach((t, e)=>i(t, e));
        else for(const e in t)$9ae5e4a12de151f5$var$E.call(t, e) && i(t[e], e);
    }
}
const $9ae5e4a12de151f5$var$Wn = function(t, ...i) {
    for (const e of i)for(const i in e)void 0 !== e[i] && (t[i] = e[i]);
    return t;
};
function $9ae5e4a12de151f5$var$Gn(t) {
    const i = Object.keys(t);
    let e = i.length;
    const s = new Array(e);
    for(; e--;)s[e] = [
        i[e],
        t[i[e]]
    ];
    return s;
}
const $9ae5e4a12de151f5$var$Kn = function(t) {
    return function(...i) {
        try {
            return t.apply(this, i);
        } catch (t) {
            $9ae5e4a12de151f5$var$Je.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $9ae5e4a12de151f5$var$Je.critical(t);
        }
    };
}, $9ae5e4a12de151f5$var$Jn = function(t) {
    const i = {};
    return $9ae5e4a12de151f5$var$Vn(t, function(t, e) {
        ($9ae5e4a12de151f5$var$I(t) && t.length > 0 || $9ae5e4a12de151f5$var$D(t)) && (i[e] = t);
    }), i;
};
function $9ae5e4a12de151f5$var$Yn(t) {
    const i = $9ae5e4a12de151f5$var$Ei({}, t);
    for (const e of [
        "name",
        "message",
        "stack",
        "cause",
        "errors"
    ])try {
        e in t && (i[e] = t[e]);
    } catch (t) {}
    return i;
}
const $9ae5e4a12de151f5$var$Xn = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $9ae5e4a12de151f5$var$Qn(t) {
    const i = null == t ? void 0 : t.hostname;
    if (!$9ae5e4a12de151f5$var$I(i)) return !1;
    const e = i.split(".").slice(-2).join(".");
    for (const t of $9ae5e4a12de151f5$var$Xn)if (e === t) return !1;
    return !0;
}
function $9ae5e4a12de151f5$var$Zn(t, i, e, s) {
    const { capture: n = !1, passive: r = !0 } = null != s ? s : {};
    null == t || t.addEventListener(i, e, {
        capture: n,
        passive: r
    });
}
function $9ae5e4a12de151f5$var$tr(t) {
    return "ph_toolbar_internal" === t.name;
}
const $9ae5e4a12de151f5$var$ir = (t)=>{
    if ($9ae5e4a12de151f5$var$s) {
        try {
            const i = t + "=", e = $9ae5e4a12de151f5$var$s.cookie.split(";").filter((t)=>t.length);
            for(let t = 0; e.length > t; t++){
                let s = e[t];
                for(; " " == s.charAt(0);)s = s.substring(1, s.length);
                if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
            }
        } catch (t) {}
        return null;
    }
};
Math.trunc || (Math.trunc = function(t) {
    return 0 > t ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $9ae5e4a12de151f5$var$D(t) && isFinite(t) && Math.floor(t) === t;
});
var $9ae5e4a12de151f5$var$er = class t {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(i, e, s, n) {
        if (!Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(s) || !Number.isInteger(n) || 0 > i || 0 > e || 0 > s || 0 > n || i > 0xffffffffffff || e > 4095 || s > 1073741823 || n > 4294967295) throw new RangeError("invalid field value");
        const r = new Uint8Array(16);
        return r[0] = i / Math.pow(2, 40), r[1] = i / Math.pow(2, 32), r[2] = i / Math.pow(2, 24), r[3] = i / Math.pow(2, 16), r[4] = i / 256, r[5] = i, r[6] = 112 | e >>> 8, r[7] = e, r[8] = 128 | s >>> 24, r[9] = s >>> 16, r[10] = s >>> 8, r[11] = s, r[12] = n >>> 24, r[13] = n >>> 16, r[14] = n >>> 8, r[15] = n, new t(r);
    }
    toString() {
        let t = "";
        for(let i = 0; this.bytes.length > i; i++)t = t + (this.bytes[i] >>> 4).toString(16) + (15 & this.bytes[i]).toString(16), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new t(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(let i = 0; 16 > i; i++){
            const e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}, $9ae5e4a12de151f5$var$sr = class {
    generate() {
        const t = this.generateOrAbort();
        if (!$9ae5e4a12de151f5$var$R(t)) return t;
        {
            this.Ct = 0;
            const t = this.generateOrAbort();
            if ($9ae5e4a12de151f5$var$R(t)) throw new Error("Could not generate UUID after timestamp reset");
            return t;
        }
    }
    generateOrAbort() {
        const t = (()=>{
            const t = Date.now();
            return $9ae5e4a12de151f5$var$D(t) && isFinite(t) ? Math.min(Math.max(Math.floor(t), 0), 0xffffffffffff) : 0;
        })();
        if (t > this.Ct) this.Ct = t, this.Mt();
        else {
            if (this.Ct >= t + 1e4) return;
            this.It++, this.It > 4398046511103 && (this.Ct++, this.Mt());
        }
        return $9ae5e4a12de151f5$var$er.fromFieldsV7(this.Ct, Math.trunc(this.It / Math.pow(2, 30)), this.It & Math.pow(2, 30) - 1, this.Tt.nextUint32());
    }
    Mt() {
        this.It = 1024 * this.Tt.nextUint32() + (1023 & this.Tt.nextUint32());
    }
    constructor(){
        this.Ct = 0, this.It = 0, this.Tt = new $9ae5e4a12de151f5$var$rr;
    }
};
let $9ae5e4a12de151f5$var$nr = (t)=>{
    if ("u" > typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(let i = 0; t.length > i; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$9ae5e4a12de151f5$var$t && !$9ae5e4a12de151f5$var$R($9ae5e4a12de151f5$var$t.crypto) && crypto.getRandomValues && ($9ae5e4a12de151f5$var$nr = (t)=>crypto.getRandomValues(t));
var $9ae5e4a12de151f5$var$rr = class {
    nextUint32() {
        return this.Rt.length > this.$t || ($9ae5e4a12de151f5$var$nr(this.Rt), this.$t = 0), this.Rt[this.$t++];
    }
    constructor(){
        this.Rt = new Uint32Array(8), this.$t = 1 / 0;
    }
};
let $9ae5e4a12de151f5$var$or;
const $9ae5e4a12de151f5$var$lr = ()=>$9ae5e4a12de151f5$var$ar().toString(), $9ae5e4a12de151f5$var$ar = ()=>($9ae5e4a12de151f5$var$or || ($9ae5e4a12de151f5$var$or = new $9ae5e4a12de151f5$var$sr)).generate();
let $9ae5e4a12de151f5$var$ur = "";
const $9ae5e4a12de151f5$var$hr = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
let $9ae5e4a12de151f5$var$dr = null;
const $9ae5e4a12de151f5$var$cr = {
    Et () {
        if (!$9ae5e4a12de151f5$var$M($9ae5e4a12de151f5$var$dr)) return $9ae5e4a12de151f5$var$dr;
        if ($9ae5e4a12de151f5$var$dr = !1, $9ae5e4a12de151f5$var$s) try {
            const t = `__ph_cookie_support_${$9ae5e4a12de151f5$var$lr()}`;
            $9ae5e4a12de151f5$var$cr.At(t, "xyz"), $9ae5e4a12de151f5$var$dr = '"xyz"' === $9ae5e4a12de151f5$var$ir(t), $9ae5e4a12de151f5$var$cr.Lt(t);
        } catch (t) {
            $9ae5e4a12de151f5$var$dr = !1;
        }
        return $9ae5e4a12de151f5$var$dr;
    },
    Pt (t) {
        $9ae5e4a12de151f5$var$Je.error("cookieStore error: " + t);
    },
    Ot: $9ae5e4a12de151f5$var$ir,
    Dt (t) {
        let i;
        try {
            i = JSON.parse($9ae5e4a12de151f5$var$cr.Ot(t)) || {};
        } catch (t) {}
        return i;
    },
    At (t, i, e, n, r) {
        if (!$9ae5e4a12de151f5$var$s) return !1;
        try {
            let o = "", l = "";
            const a = function(t, i) {
                if (i) {
                    let i = function(t, i = $9ae5e4a12de151f5$var$s) {
                        if ($9ae5e4a12de151f5$var$ur) return $9ae5e4a12de151f5$var$ur;
                        if (!i) return "";
                        if ([
                            "localhost",
                            "127.0.0.1"
                        ].includes(t)) return "";
                        const e = t.split(".");
                        let n = Math.min(e.length, 8);
                        const r = "dmn_chk_" + $9ae5e4a12de151f5$var$lr();
                        for(; !$9ae5e4a12de151f5$var$ur && n--;){
                            const t = e.slice(n).join("."), s = r + "=1;domain=." + t + ";path=/";
                            i.cookie = s + ";max-age=3", i.cookie.includes(r) && (i.cookie = s + ";max-age=0", $9ae5e4a12de151f5$var$ur = t);
                        }
                        return $9ae5e4a12de151f5$var$ur;
                    }(t);
                    if (!i) {
                        const e = ((t)=>{
                            const i = t.match($9ae5e4a12de151f5$var$hr);
                            return i ? i[0] : "";
                        })(t);
                        e !== i && $9ae5e4a12de151f5$var$Je.info("Warning: cookie subdomain discovery mismatch", e, i), i = e;
                    }
                    return i ? "; domain=." + i : "";
                }
                return "";
            }($9ae5e4a12de151f5$var$s.location.hostname, n);
            if (e) {
                const t = new Date;
                t.setTime(t.getTime() + 864e5 * e), o = "; expires=" + t.toUTCString();
            }
            r && (l = "; secure");
            const u = t + "=" + encodeURIComponent(JSON.stringify(i)) + o + "; SameSite=Lax; path=/" + a + l;
            return u.length > 3686.4 && $9ae5e4a12de151f5$var$Je.warn("cookieStore warning: large cookie, len=" + u.length), $9ae5e4a12de151f5$var$s.cookie = u, !0;
        } catch (t) {
            return !1;
        }
    },
    Lt (t, i) {
        if ((null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.cookie) && (!i || !$9ae5e4a12de151f5$var$M($9ae5e4a12de151f5$var$ir(t)))) try {
            $9ae5e4a12de151f5$var$cr.At(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
};
let $9ae5e4a12de151f5$var$vr = null;
const $9ae5e4a12de151f5$var$fr = {
    Et () {
        if (!$9ae5e4a12de151f5$var$M($9ae5e4a12de151f5$var$vr)) return $9ae5e4a12de151f5$var$vr;
        let i = !0;
        if ($9ae5e4a12de151f5$var$R($9ae5e4a12de151f5$var$t)) i = !1;
        else try {
            const t = "__mplssupport__";
            $9ae5e4a12de151f5$var$fr.At(t, "xyz"), '"xyz"' !== $9ae5e4a12de151f5$var$fr.Ot(t) && (i = !1), $9ae5e4a12de151f5$var$fr.Lt(t);
        } catch (t) {
            i = !1;
        }
        return i || $9ae5e4a12de151f5$var$Je.error("localStorage unsupported; falling back to cookie store"), $9ae5e4a12de151f5$var$vr = i, i;
    },
    Pt (t) {
        $9ae5e4a12de151f5$var$Je.error("localStorage error: " + t);
    },
    Ot (i) {
        try {
            return null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.localStorage.getItem(i);
        } catch (t) {
            $9ae5e4a12de151f5$var$fr.Pt(t);
        }
        return null;
    },
    Dt (t) {
        try {
            return JSON.parse($9ae5e4a12de151f5$var$fr.Ot(t)) || {};
        } catch (t) {}
        return null;
    },
    At (i, e) {
        try {
            return null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.localStorage.setItem(i, JSON.stringify(e)), !0;
        } catch (t) {
            $9ae5e4a12de151f5$var$fr.Pt(t);
        }
        return !1;
    },
    Lt (i) {
        try {
            null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.localStorage.removeItem(i);
        } catch (t) {
            $9ae5e4a12de151f5$var$fr.Pt(t);
        }
    }
}, $9ae5e4a12de151f5$var$pr = [
    $9ae5e4a12de151f5$var$Gs,
    $9ae5e4a12de151f5$var$Ls,
    $9ae5e4a12de151f5$var$js,
    $9ae5e4a12de151f5$var$Us,
    $9ae5e4a12de151f5$var$zs,
    $9ae5e4a12de151f5$var$Hs,
    $9ae5e4a12de151f5$var$cn,
    $9ae5e4a12de151f5$var$dn,
    $9ae5e4a12de151f5$var$un
], $9ae5e4a12de151f5$var$_r = [
    $9ae5e4a12de151f5$var$rs,
    $9ae5e4a12de151f5$var$ns,
    $9ae5e4a12de151f5$var$Rs,
    $9ae5e4a12de151f5$var$Is,
    $9ae5e4a12de151f5$var$bn,
    $9ae5e4a12de151f5$var$mn,
    $9ae5e4a12de151f5$var$hs,
    $9ae5e4a12de151f5$var$vn
], $9ae5e4a12de151f5$var$gr = (t)=>t + "_cpm", $9ae5e4a12de151f5$var$mr = [
    "__proto__",
    "constructor",
    "prototype"
], $9ae5e4a12de151f5$var$br = (t)=>{
    if (!$9ae5e4a12de151f5$var$C(t)) return {};
    const i = {};
    return Object.keys(t).forEach((e)=>{
        -1 === $9ae5e4a12de151f5$var$mr.indexOf(e) && (i[e] = t[e]);
    }), i;
}, $9ae5e4a12de151f5$var$yr = (t, i = [])=>{
    const e = {};
    return [
        ...$9ae5e4a12de151f5$var$_r,
        ...i
    ].forEach((i)=>{
        const s = t[i];
        $9ae5e4a12de151f5$var$R(s) || $9ae5e4a12de151f5$var$M(s) || "" === s || (e[i] = s);
    }), e;
}, $9ae5e4a12de151f5$var$wr = (t)=>{
    let i = 5381, e = 2166136261;
    for(let s = 0; t.length > s; s++){
        const n = t.charCodeAt(s);
        i = 33 * i ^ n, e = Math.imul(e ^ n, 16777619);
    }
    return t.length.toString(36) + "." + (i >>> 0).toString(36) + "." + (e >>> 0).toString(36);
}, $9ae5e4a12de151f5$var$$r = (t, i)=>({
        p: i,
        f: $9ae5e4a12de151f5$var$wr(JSON.stringify(t))
    }), $9ae5e4a12de151f5$var$Sr = (t, i)=>{
    if (!i) return {
        properties: [],
        isValid: !1
    };
    try {
        const e = $9ae5e4a12de151f5$var$cr.Dt($9ae5e4a12de151f5$var$gr(t)), s = (null == e ? void 0 : e.f) === $9ae5e4a12de151f5$var$wr(i) && $9ae5e4a12de151f5$var$T(e.p);
        return {
            properties: s ? e.p : [],
            isValid: s
        };
    } catch (t) {
        return {
            properties: [],
            isValid: !1
        };
    }
}, $9ae5e4a12de151f5$var$xr = (t, i)=>i + "|" + ($9ae5e4a12de151f5$var$cr.Ot($9ae5e4a12de151f5$var$gr(t)) || ""), $9ae5e4a12de151f5$var$Er = {}, $9ae5e4a12de151f5$var$kr = {
    Et: ()=>!0,
    Pt (t) {
        $9ae5e4a12de151f5$var$Je.error("memoryStorage error: " + t);
    },
    Ot: (t)=>t in $9ae5e4a12de151f5$var$Er ? $9ae5e4a12de151f5$var$Er[t] : null,
    Dt: (t)=>t in $9ae5e4a12de151f5$var$Er ? $9ae5e4a12de151f5$var$Er[t] : null,
    At: (t, i)=>($9ae5e4a12de151f5$var$Er[t] = i, !0),
    Lt (t) {
        delete $9ae5e4a12de151f5$var$Er[t];
    }
};
let $9ae5e4a12de151f5$var$Tr = null;
const $9ae5e4a12de151f5$var$Pr = {
    Et () {
        if (!$9ae5e4a12de151f5$var$M($9ae5e4a12de151f5$var$Tr)) return $9ae5e4a12de151f5$var$Tr;
        if ($9ae5e4a12de151f5$var$Tr = !0, $9ae5e4a12de151f5$var$R($9ae5e4a12de151f5$var$t)) $9ae5e4a12de151f5$var$Tr = !1;
        else try {
            const t = "__support__";
            $9ae5e4a12de151f5$var$Pr.At(t, "xyz"), '"xyz"' !== $9ae5e4a12de151f5$var$Pr.Ot(t) && ($9ae5e4a12de151f5$var$Tr = !1), $9ae5e4a12de151f5$var$Pr.Lt(t);
        } catch (t) {
            $9ae5e4a12de151f5$var$Tr = !1;
        }
        return $9ae5e4a12de151f5$var$Tr;
    },
    Pt (t) {
        $9ae5e4a12de151f5$var$Je.error("sessionStorage error: ", t);
    },
    Ot (i) {
        try {
            return null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $9ae5e4a12de151f5$var$Pr.Pt(t);
        }
        return null;
    },
    Dt (t) {
        try {
            return JSON.parse($9ae5e4a12de151f5$var$Pr.Ot(t)) || null;
        } catch (t) {}
        return null;
    },
    At (i, e) {
        try {
            return null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.sessionStorage.setItem(i, JSON.stringify(e)), !0;
        } catch (t) {
            $9ae5e4a12de151f5$var$Pr.Pt(t);
        }
        return !1;
    },
    Lt (i) {
        try {
            null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $9ae5e4a12de151f5$var$Pr.Pt(t);
        }
    }
};
var $9ae5e4a12de151f5$var$Cr = class {
    constructor(t){
        this._instance = t;
    }
    get Rr() {
        return this._instance.config;
    }
    get consent() {
        return this.Lo() ? 0 : this.No;
    }
    isOptedOut() {
        return "always" === this.Rr.cookieless_mode || this.isRejected() || -1 === this.consent && "on_reject" === this.Rr.cookieless_mode;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return 0 === this.consent;
    }
    isRejected() {
        return 0 === this.consent || -1 === this.consent && this.Rr.opt_out_capturing_by_default;
    }
    optInOut(t) {
        this.qo.At(this.jo, t ? 1 : 0, this.Rr.cookie_expiration, this.Rr.cross_subdomain_cookie, this.Rr.secure_cookie);
    }
    reset() {
        this.qo.Lt(this.jo, this.Rr.cross_subdomain_cookie);
    }
    get jo() {
        const { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get No() {
        const t = this.qo.Ot(this.jo);
        return $9ae5e4a12de151f5$var$G(t) ? 1 : $9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$K, t) ? 0 : -1;
    }
    get qo() {
        const t = this.Rr.opt_out_capturing_persistence_type, i = "localStorage" === t ? $9ae5e4a12de151f5$var$fr : $9ae5e4a12de151f5$var$cr, e = i.Et() ? i : $9ae5e4a12de151f5$var$kr;
        if (!this.Bo || this.Bo !== e) {
            this.Bo = e;
            const i = "localStorage" === t ? $9ae5e4a12de151f5$var$cr : $9ae5e4a12de151f5$var$fr;
            i.Ot(this.jo) && (this.Bo.Ot(this.jo) || this.optInOut($9ae5e4a12de151f5$var$G(i.Ot(this.jo))), i.Lt(this.jo, this.Rr.cross_subdomain_cookie));
        }
        return this.Bo;
    }
    Lo() {
        return !!this.Rr.respect_dnt && [
            null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.doNotTrack,
            null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.msDoNotTrack,
            $9ae5e4a12de151f5$var$c.doNotTrack,
            null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.globalPrivacyControl
        ].some((t)=>$9ae5e4a12de151f5$var$G(t));
    }
};
function $9ae5e4a12de151f5$var$Or(t, i) {
    var e;
    const s = null == t || null === (e = t.config) || void 0 === e ? void 0 : e.get_current_url;
    if (!$9ae5e4a12de151f5$var$P(s)) return i;
    try {
        const t = s(i);
        return $9ae5e4a12de151f5$var$I(t) && t ? t : i;
    } catch (t) {
        return $9ae5e4a12de151f5$var$Je.error("Error in get_current_url, falling back to window.location.href", t), i;
    }
}
function $9ae5e4a12de151f5$var$Rr(t) {
    var i;
    return t instanceof Element && ("__POSTHOG_TOOLBAR__" === t.id || !!(null === (i = t.closest) || void 0 === i ? void 0 : i.call(t, ".toolbar-global-fade-container")));
}
function $9ae5e4a12de151f5$var$Ir(t) {
    return !!t && 1 === t.nodeType;
}
function $9ae5e4a12de151f5$var$Ar(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $9ae5e4a12de151f5$var$Mr(t) {
    return !!t && 3 === t.nodeType;
}
function $9ae5e4a12de151f5$var$Fr(t) {
    return !!t && 11 === t.nodeType && $9ae5e4a12de151f5$var$Ir(t.host);
}
function $9ae5e4a12de151f5$var$Dr(t) {
    return t ? $9ae5e4a12de151f5$var$y(t).split(/\s+/) : [];
}
function $9ae5e4a12de151f5$var$Nr(i, e) {
    const s = function(i) {
        var e;
        const s = null == $9ae5e4a12de151f5$var$t || null === (e = $9ae5e4a12de151f5$var$t.location) || void 0 === e ? void 0 : e.href;
        return $9ae5e4a12de151f5$var$R(s) ? void 0 : $9ae5e4a12de151f5$var$Or(i, s);
    }(e);
    return !!(s && i && i.some((t)=>s.match(t)));
}
function $9ae5e4a12de151f5$var$jr(t) {
    let i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $9ae5e4a12de151f5$var$Dr(i);
}
function $9ae5e4a12de151f5$var$Lr(t) {
    return $9ae5e4a12de151f5$var$F(t) ? null : $9ae5e4a12de151f5$var$y(t).split(/(\s+)/).filter((t)=>$9ae5e4a12de151f5$var$ho(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $9ae5e4a12de151f5$var$Br(t) {
    let i = "";
    return $9ae5e4a12de151f5$var$io(t) && !$9ae5e4a12de151f5$var$eo(t) && t.childNodes && t.childNodes.length && $9ae5e4a12de151f5$var$Vn(t.childNodes, function(t) {
        var e;
        $9ae5e4a12de151f5$var$Mr(t) && t.textContent && (i += null !== (e = $9ae5e4a12de151f5$var$Lr(t.textContent)) && void 0 !== e ? e : "");
    }), $9ae5e4a12de151f5$var$y(i);
}
function $9ae5e4a12de151f5$var$Ur(t) {
    var i;
    return $9ae5e4a12de151f5$var$R(t.target) ? t.srcElement || null : (null === (i = t.target) || void 0 === i ? void 0 : i.shadowRoot) ? t.composedPath()[0] || null : t.target || null;
}
const $9ae5e4a12de151f5$var$zr = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $9ae5e4a12de151f5$var$Hr(t, i) {
    const e = t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector;
    try {
        return !!e && e.call(t, i);
    } catch (t) {
        return !1;
    }
}
function $9ae5e4a12de151f5$var$qr(t, i) {
    if ($9ae5e4a12de151f5$var$R(i)) return !0;
    for (const e of t)if (i.some((t)=>$9ae5e4a12de151f5$var$Hr(e, t))) return !0;
    return !1;
}
function $9ae5e4a12de151f5$var$Vr(t) {
    const i = t.parentNode;
    return !(!i || !$9ae5e4a12de151f5$var$Ir(i)) && i;
}
const $9ae5e4a12de151f5$var$Wr = [
    ".ph-no-autocapture",
    "[data-ph-no-autocapture]"
], $9ae5e4a12de151f5$var$Gr = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $9ae5e4a12de151f5$var$Kr = [
    ...$9ae5e4a12de151f5$var$Gr,
    "+",
    "-",
    "\u2212",
    "\u2013"
], $9ae5e4a12de151f5$var$Jr = (t, i)=>/[a-z0-9]/i.test(i) ? t.includes(i) : t === i, $9ae5e4a12de151f5$var$Yr = [
    ".ph-no-rageclick",
    ".ph-no-capture"
], $9ae5e4a12de151f5$var$Xr = [
    "",
    "text",
    "search",
    "email",
    "password",
    "url",
    "tel",
    "number"
];
function $9ae5e4a12de151f5$var$Qr(i, e) {
    if (!$9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$Zr(i)) return !1;
    let s, n, r;
    var o, l;
    if ($9ae5e4a12de151f5$var$j(e) ? (s = !!e && $9ae5e4a12de151f5$var$Yr, n = void 0, r = !1) : (s = null !== (o = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== o ? o : $9ae5e4a12de151f5$var$Yr, n = null == e ? void 0 : e.content_ignorelist, r = null !== (l = null == e ? void 0 : e.ignore_text_selection) && void 0 !== l && l), !1 === s) return !1;
    if (r && function(t) {
        return !(!t || !$9ae5e4a12de151f5$var$Ir(t)) && (!!$9ae5e4a12de151f5$var$Ar(t, "textarea") || ($9ae5e4a12de151f5$var$Ar(t, "input") ? $9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$Xr, (t.getAttribute("type") || "").toLowerCase()) : function(t) {
            var i;
            if (t.isContentEditable) return !0;
            const e = null === (i = t.getAttribute) || void 0 === i ? void 0 : i.call(t, "contenteditable");
            return "true" === e || "" === e;
        }(t)));
    }(i)) return !1;
    const { targetElementList: a } = $9ae5e4a12de151f5$var$to(i, !1);
    return !function(t, i) {
        if (!1 === t || $9ae5e4a12de151f5$var$R(t)) return !1;
        let e;
        if (!0 === t) e = $9ae5e4a12de151f5$var$Gr;
        else {
            if (!$9ae5e4a12de151f5$var$T(t)) return !1;
            if (t.length > 10) return $9ae5e4a12de151f5$var$Je.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
            e = t.map((t)=>t.toLowerCase());
        }
        return i.some(({ safeText: t, ariaLabel: i })=>e.some((e)=>$9ae5e4a12de151f5$var$Jr(t, e) || $9ae5e4a12de151f5$var$Jr(i, e)));
    }(n, a.map((t)=>{
        var i;
        return {
            safeText: $9ae5e4a12de151f5$var$Br(t).toLowerCase(),
            ariaLabel: (null === (i = t.getAttribute("aria-label")) || void 0 === i ? void 0 : i.toLowerCase().trim()) || ""
        };
    })) && !$9ae5e4a12de151f5$var$qr(a, s);
}
const $9ae5e4a12de151f5$var$Zr = (t)=>!t || $9ae5e4a12de151f5$var$Ar(t, "html") || !$9ae5e4a12de151f5$var$Ir(t), $9ae5e4a12de151f5$var$to = (i, e)=>{
    if (!$9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$Zr(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    let s = !1;
    const n = [
        i
    ];
    let r = i;
    for(; r.parentNode && !$9ae5e4a12de151f5$var$Ar(r, "body");){
        if ($9ae5e4a12de151f5$var$Fr(r.parentNode)) {
            n.push(r.parentNode.host), r = r.parentNode.host;
            continue;
        }
        const i = $9ae5e4a12de151f5$var$Vr(r);
        if (!i) break;
        if (e || $9ae5e4a12de151f5$var$zr.indexOf(i.tagName.toLowerCase()) > -1) s = !0;
        else try {
            const e = $9ae5e4a12de151f5$var$t.getComputedStyle(i);
            e && "pointer" === e.getPropertyValue("cursor") && (s = !0);
        } catch (t) {}
        n.push(i), r = i;
    }
    return {
        parentIsUsefulElement: s,
        targetElementList: n
    };
};
function $9ae5e4a12de151f5$var$io(t) {
    const i = new Set;
    let e = 0;
    for(let s = t; s.parentNode && !$9ae5e4a12de151f5$var$Ar(s, "body"); s = s.parentNode){
        if (e++ >= 1e3 || i.has(s)) return !1;
        i.add(s);
        const t = $9ae5e4a12de151f5$var$jr(s);
        if ($9ae5e4a12de151f5$var$b(t, "ph-sensitive") || $9ae5e4a12de151f5$var$b(t, "ph-no-capture")) return !1;
    }
    if ($9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$jr(t), "ph-include")) return !0;
    const s = t.type || "";
    if ($9ae5e4a12de151f5$var$I(s)) switch(s.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    const n = t.name || t.id || "";
    return !$9ae5e4a12de151f5$var$I(n) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(n.replace(/[^a-zA-Z0-9]/g, ""));
}
function $9ae5e4a12de151f5$var$eo(t) {
    return !!($9ae5e4a12de151f5$var$Ar(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $9ae5e4a12de151f5$var$Ar(t, "select") || $9ae5e4a12de151f5$var$Ar(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
const $9ae5e4a12de151f5$var$so = new RegExp("^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$"), $9ae5e4a12de151f5$var$no = /(^|[^0-9A-Za-z_])([0-9][0-9 -]*[0-9])(?=$|[^0-9A-Za-z_])/g, $9ae5e4a12de151f5$var$ro = [
    16,
    15,
    14,
    13
], $9ae5e4a12de151f5$var$oo = new RegExp("^(\\d{3}-?\\d{2}-?\\d{4})$"), $9ae5e4a12de151f5$var$lo = new RegExp("(^|[^0-9])((?!000|666)[0-9]{3}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4})(?=$|([^0-9]))", "g"), $9ae5e4a12de151f5$var$ao = /[0-9A-Za-z_]/;
function $9ae5e4a12de151f5$var$uo(t) {
    let i = 0, e = !1;
    for(let s = t.length - 1; s >= 0; s--){
        let n = t.charCodeAt(s) - 48;
        e && (n *= 2, n > 9 && (n -= 9)), i += n, e = !e;
    }
    return i % 10 == 0;
}
function $9ae5e4a12de151f5$var$ho(t, i = !0) {
    if ($9ae5e4a12de151f5$var$F(t)) return !1;
    if ($9ae5e4a12de151f5$var$I(t)) {
        if (t = $9ae5e4a12de151f5$var$y(t), i ? $9ae5e4a12de151f5$var$so.test((t || "").replace(/[- ]/g, "")) : function(t) {
            let i;
            for($9ae5e4a12de151f5$var$no.lastIndex = 0; i = $9ae5e4a12de151f5$var$no.exec(t);){
                const t = i[2];
                if (!t) continue;
                const e = t.replace(/[- ]/g, "");
                for(let t = 0; e.length > t; t++)for (const i of $9ae5e4a12de151f5$var$ro){
                    const s = t + i;
                    if (e.length >= s) {
                        const i = e.slice(t, s);
                        if ($9ae5e4a12de151f5$var$so.test(i) && $9ae5e4a12de151f5$var$uo(i)) return !0;
                    }
                }
            }
            return !1;
        }(t)) return !1;
        if (i ? $9ae5e4a12de151f5$var$oo.test(t) : function(t) {
            let i;
            for($9ae5e4a12de151f5$var$lo.lastIndex = 0; i = $9ae5e4a12de151f5$var$lo.exec(t);){
                const t = i[1], e = i[3];
                if (!(t && e && $9ae5e4a12de151f5$var$ao.test(t) && $9ae5e4a12de151f5$var$ao.test(e))) return !0;
            }
            return !1;
        }(t)) return !1;
    }
    return !0;
}
function $9ae5e4a12de151f5$var$co(t) {
    let i = $9ae5e4a12de151f5$var$Br(t);
    return i = `${i} ${$9ae5e4a12de151f5$var$vo(t)}`.trim(), $9ae5e4a12de151f5$var$ho(i) ? i : "";
}
function $9ae5e4a12de151f5$var$vo(t) {
    let i = "";
    return t && t.childNodes && t.childNodes.length && $9ae5e4a12de151f5$var$Vn(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null === (e = t.tagName) || void 0 === e ? void 0 : e.toLowerCase())) try {
            const e = $9ae5e4a12de151f5$var$Br(t);
            i = `${i} ${e}`.trim(), t.childNodes && t.childNodes.length && (i = `${i} ${$9ae5e4a12de151f5$var$vo(t)}`.trim());
        } catch (t) {
            $9ae5e4a12de151f5$var$Je.error("[AutoCapture]", t);
        }
    }), i;
}
function $9ae5e4a12de151f5$var$fo(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $9ae5e4a12de151f5$var$po(t) {
    const i = t.attr__class;
    if (i) return $9ae5e4a12de151f5$var$T(i) ? i : $9ae5e4a12de151f5$var$Dr(i);
}
const $9ae5e4a12de151f5$var$_o = $9ae5e4a12de151f5$var$Ye("[Dead Clicks]"), $9ae5e4a12de151f5$var$go = ()=>!0, $9ae5e4a12de151f5$var$mo = (t)=>{
    var i;
    const e = !!(null === (i = t.instance.persistence) || void 0 === i ? void 0 : i.get_property($9ae5e4a12de151f5$var$ys)), s = t.instance.config.capture_dead_clicks;
    return $9ae5e4a12de151f5$var$j(s) ? s : !!$9ae5e4a12de151f5$var$C(s) || e;
};
var $9ae5e4a12de151f5$var$bo = class {
    get lazyLoadedDeadClicksAutocapture() {
        return this.Ho;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        if (!t.ok) return;
        const i = t.config;
        "captureDeadClicks" in i && (this.instance.persistence && this.instance.persistence.register({
            [$9ae5e4a12de151f5$var$ys]: i.captureDeadClicks
        }), this.startIfEnabledOrStop());
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.zo(()=>{
            this.Uo();
        }) : this.stop();
    }
    zo(t) {
        var i, e, s;
        (null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.initDeadClicksAutocapture) ? t() : null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $9ae5e4a12de151f5$var$_o.error("failed to load script", i) : t();
        });
    }
    Uo() {
        var t;
        if ($9ae5e4a12de151f5$var$s) {
            if (!this.Ho && (null === (t = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === t ? void 0 : t.initDeadClicksAutocapture)) {
                const t = $9ae5e4a12de151f5$var$C(this.instance.config.capture_dead_clicks) ? $9ae5e4a12de151f5$var$Ei({}, this.instance.config.capture_dead_clicks) : {};
                t.__onCapture = this.onCapture, this.onCapture && (t.capture_dead_swipes = !1), this.Ho = $9ae5e4a12de151f5$var$c.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, t), this.Ho.start($9ae5e4a12de151f5$var$s), $9ae5e4a12de151f5$var$_o.info("starting...");
            }
        } else $9ae5e4a12de151f5$var$_o.error("`document` not found. Cannot start.");
    }
    stop() {
        this.Ho && (this.Ho.stop(), this.Ho = void 0, $9ae5e4a12de151f5$var$_o.info("stopping..."));
    }
};
const $9ae5e4a12de151f5$var$yo = $9ae5e4a12de151f5$var$Ye("[SegmentIntegration]");
function $9ae5e4a12de151f5$var$wo(t, i, e = !0) {
    const s = t.config.segment;
    if (!s) return i();
    const { analytics: n, filterProperties: r } = ((t)=>$9ae5e4a12de151f5$var$P(t.register))(o = s) ? {
        analytics: o
    } : o;
    var o;
    !function(t, i, e, s) {
        const n = (i)=>{
            const n = ()=>i.anonymousId() || $9ae5e4a12de151f5$var$lr();
            t.config.get_device_id = n, s && i.id() && (t.register({
                distinct_id: i.id(),
                $device_id: n()
            }), t.persistence.set_property($9ae5e4a12de151f5$var$vn, $9ae5e4a12de151f5$var$Dn)), e(s ? void 0 : i.anonymousId() || void 0);
        }, r = i.user();
        "then" in r && $9ae5e4a12de151f5$var$P(r.then) ? r.then(n) : n(r);
    }(t, n, (e)=>{
        n.register(((t, i, { filterProperties: e } = {})=>{
            "undefined" != typeof Promise && Promise.resolve || $9ae5e4a12de151f5$var$yo.warn("This browser does not have Promise support, and can not use the segment integration");
            const s = (s, n)=>{
                if (!n) return s;
                const r = !!i && s.event.anonymousId === i && !s.event.userId;
                r || s.event.userId || s.event.anonymousId === t.get_distinct_id() || ($9ae5e4a12de151f5$var$yo.info("No userId set, resetting PostHog"), t.reset()), r || (i = void 0), s.event.userId && s.event.userId !== t.get_distinct_id() && ($9ae5e4a12de151f5$var$yo.info("UserId set, identifying with PostHog"), t.identify(s.event.userId));
                let o = t.calculateEventProperties(n, s.event.properties);
                if (!$9ae5e4a12de151f5$var$F(e)) {
                    const t = s.event.properties || {}, i = {};
                    for (const e of Object.keys(o))$9ae5e4a12de151f5$var$E.call(t, e) || (i[e] = o[e]);
                    const n = ((t, i)=>{
                        const e = $9ae5e4a12de151f5$var$T(t) ? t : [
                            t
                        ];
                        let s = $9ae5e4a12de151f5$var$Ei({}, i);
                        for (const t of e)try {
                            if (s = t(s), $9ae5e4a12de151f5$var$F(s)) return null;
                        } catch (t) {
                            return $9ae5e4a12de151f5$var$yo.error("Error in Segment filterProperties:", t), null;
                        }
                        return s;
                    })(e, i);
                    if ($9ae5e4a12de151f5$var$F(n)) return s;
                    o = n;
                }
                return s.event.properties = Object.assign({}, o, s.event.properties), s;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded () {
                    return !0;
                },
                load () {
                    return Promise.resolve();
                },
                track (t) {
                    return s(t, t.event.event);
                },
                page (t) {
                    return s(t, $9ae5e4a12de151f5$var$Bn);
                },
                identify (t) {
                    return s(t, $9ae5e4a12de151f5$var$zn);
                },
                screen (t) {
                    return s(t, "$screen");
                }
            };
        })(t, e, {
            filterProperties: r
        })).then(()=>{
            i();
        }, (t)=>{
            $9ae5e4a12de151f5$var$yo.error("Failed to register the Segment integration", t), i();
        });
    }, e);
}
const $9ae5e4a12de151f5$var$$o = "posthog-js";
function $9ae5e4a12de151f5$var$So(t, { organization: i, projectId: e, prefix: s, severityAllowList: n = [
    "error"
], sendExceptionsToPostHog: r = !0 } = {}) {
    return (o)=>{
        var l, a, u, h, d;
        if ("*" !== n && !n.includes(o.level) || !t.__loaded) return o;
        o.tags || (o.tags = {});
        const c = t.requestRouter.endpointFor("ui", `/project/${t.config.token}/person/${t.get_distinct_id()}`);
        o.tags["PostHog Person URL"] = c, t.sessionRecordingStarted() && (o.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        const v = (null === (l = o.exception) || void 0 === l ? void 0 : l.values) || [], f = v.map((t)=>$9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                stacktrace: t.stacktrace ? $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t.stacktrace), {}, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null === (a = v[0]) || void 0 === a ? void 0 : a.value) || o.message,
            $exception_type: null === (u = v[0]) || void 0 === u ? void 0 : u.type,
            $exception_level: o.level,
            $exception_list: f,
            $sentry_event_id: o.event_id,
            $sentry_exception: o.exception,
            $sentry_exception_message: (null === (h = v[0]) || void 0 === h ? void 0 : h.value) || o.message,
            $sentry_exception_type: null === (d = v[0]) || void 0 === d ? void 0 : d.type,
            $sentry_tags: o.tags
        };
        var _;
        return i && e && (p.$sentry_url = (s || "https://sentry.io/organizations/") + i + "/issues/?project=" + e + "&query=" + o.event_id), r && (null === (_ = t.exceptions) || void 0 === _ || _.sendExceptionEvent(p)), o;
    };
}
var $9ae5e4a12de151f5$var$xo = class {
    constructor(t, i, e, s, n, r){
        this.name = $9ae5e4a12de151f5$var$$o, this.setupOnce = function(o) {
            o($9ae5e4a12de151f5$var$So(t, {
                organization: i,
                projectId: e,
                prefix: s,
                severityAllowList: n,
                sendExceptionsToPostHog: null == r || r
            }));
        };
    }
}, $9ae5e4a12de151f5$var$Eo = class {
    constructor(t){
        this.Wo = (t, i, e)=>{
            e && (e.noSessionId || e.activityTimeout || e.sessionPastMaximumLength || e.crossTabAdoption) && ($9ae5e4a12de151f5$var$Je.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: e
            }), this.Vo = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.Go();
    }
    Go() {
        var t;
        this.Zo = null === (t = this._instance.sessionManager) || void 0 === t ? void 0 : t.onSessionId(this.Wo);
    }
    destroy() {
        var t;
        null === (t = this.Zo) || void 0 === t || t.call(this), this.Zo = void 0;
    }
    doPageView(i, e) {
        var s;
        const n = this.Qo(i, e);
        return this.Vo = {
            pathname: null !== (s = null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.location.pathname) && void 0 !== s ? s : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), n;
    }
    doPageLeave(t) {
        var i;
        return this.Qo(t, null === (i = this.Vo) || void 0 === i ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null === (t = this.Vo) || void 0 === t ? void 0 : t.pageViewId
        };
    }
    Qo(t, i) {
        const e = this.Vo;
        if (!e) return {
            $pageview_id: i
        };
        let s = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        };
        const n = this._instance.scrollManager.getContext();
        if (n && !this._instance.config.disable_scroll_properties) {
            let { maxScrollHeight: t, lastScrollY: i, maxScrollY: e, maxContentHeight: r, lastContentY: o, maxContentY: l } = n;
            if (!($9ae5e4a12de151f5$var$R(t) || $9ae5e4a12de151f5$var$R(i) || $9ae5e4a12de151f5$var$R(e) || $9ae5e4a12de151f5$var$R(r) || $9ae5e4a12de151f5$var$R(o) || $9ae5e4a12de151f5$var$R(l))) {
                t = Math.ceil(t), i = Math.ceil(i), e = Math.ceil(e), r = Math.ceil(r), o = Math.ceil(o), l = Math.ceil(l);
                const n = t > 1 ? $9ae5e4a12de151f5$var$Z(i / t, 0, 1, $9ae5e4a12de151f5$var$Je) : 1, a = t > 1 ? $9ae5e4a12de151f5$var$Z(e / t, 0, 1, $9ae5e4a12de151f5$var$Je) : 1, u = r > 1 ? $9ae5e4a12de151f5$var$Z(o / r, 0, 1, $9ae5e4a12de151f5$var$Je) : 1, h = r > 1 ? $9ae5e4a12de151f5$var$Z(l / r, 0, 1, $9ae5e4a12de151f5$var$Je) : 1;
                s = $9ae5e4a12de151f5$var$Wn(s, {
                    $prev_pageview_last_scroll: i,
                    $prev_pageview_last_scroll_percentage: n,
                    $prev_pageview_max_scroll: e,
                    $prev_pageview_max_scroll_percentage: a,
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: u,
                    $prev_pageview_max_content: l,
                    $prev_pageview_max_content_percentage: h
                });
            }
        }
        return e.pathname && (s.$prev_pageview_pathname = e.pathname), e.timestamp && (s.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), s;
    }
};
const $9ae5e4a12de151f5$var$ko = [
    "flags",
    "surveys"
], $9ae5e4a12de151f5$var$To = {
    [$9ae5e4a12de151f5$var$ss]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$ls]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$as]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$vs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$hs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$cs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$fs]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$ps]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$$s]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$_s]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$gs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$ms]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$bs]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$ys]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$ws]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Ss]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$xs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Es]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Rs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Is]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$ks]: {
        exposure: "event",
        shouldSkipFromEventProperties: (t)=>$9ae5e4a12de151f5$var$M(t)
    },
    [$9ae5e4a12de151f5$var$As]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Ms]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Fs]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Ds]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Ns]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$js]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$9ae5e4a12de151f5$var$Ls]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$9ae5e4a12de151f5$var$Bs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Us]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$9ae5e4a12de151f5$var$zs]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$9ae5e4a12de151f5$var$Hs]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$9ae5e4a12de151f5$var$qs]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$9ae5e4a12de151f5$var$Vs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Ws]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Gs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Ks]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Ys]: {
        exposure: "hidden",
        storageGroup: "surveys"
    },
    [$9ae5e4a12de151f5$var$Xs]: {
        exposure: "hidden",
        storageGroup: "surveys",
        volatile: !0
    },
    [$9ae5e4a12de151f5$var$Qs]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Zs]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$tn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$en]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$sn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$nn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$rn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$on]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$ln]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$an]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$un]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$hn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Js]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$dn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$cn]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$9ae5e4a12de151f5$var$vn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$fn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$pn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$_n]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$gn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$mn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$bn]: {
        exposure: "hidden"
    },
    [$9ae5e4a12de151f5$var$Ts]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Ps]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Cs]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Os]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$$n]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Sn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$xn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$En]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$kn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Tn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Pn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Cn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$On]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$Rn]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$In]: {
        exposure: "event"
    },
    [$9ae5e4a12de151f5$var$An]: {
        exposure: "event"
    }
}, $9ae5e4a12de151f5$var$Po = [
    [
        "$posthog_sr_group_event_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_url_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_sampling_",
        {
            exposure: "hidden"
        }
    ]
], $9ae5e4a12de151f5$var$Co = (t)=>{
    const i = $9ae5e4a12de151f5$var$To[t];
    if (i) return i;
    for (const [i, e] of $9ae5e4a12de151f5$var$Po)if (0 === t.indexOf(i)) return e;
}, $9ae5e4a12de151f5$var$Oo = (t, i)=>{
    try {
        let e;
        return JSON.stringify(t, (t, i)=>{
            var s;
            return $9ae5e4a12de151f5$var$H(i) ? (null !== (s = e) && void 0 !== s || (e = new WeakMap), e.has(i) || e.set(i, $9ae5e4a12de151f5$var$Yn(i)), e.get(i)) : "bigint" == typeof i ? i.toString() : i;
        }, i);
    } catch (i) {
        return $9ae5e4a12de151f5$var$S(t);
    }
}, $9ae5e4a12de151f5$var$Ro = (t)=>{
    const i = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.createElement("a");
    return $9ae5e4a12de151f5$var$R(i) ? null : (i.href = t, i);
}, $9ae5e4a12de151f5$var$Io = function(t, i) {
    const e = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&");
    let s;
    for(let t = 0; e.length > t; t++){
        const n = e[t].split("=");
        if (n[0] === i) {
            s = n;
            break;
        }
    }
    if (!$9ae5e4a12de151f5$var$T(s) || 2 > s.length) return "";
    {
        let t = s[1];
        try {
            t = decodeURIComponent(t);
        } catch (i) {
            $9ae5e4a12de151f5$var$Je.error("Skipping decoding for malformed query param: " + t);
        }
        return t.replace(/\+/g, " ");
    }
}, $9ae5e4a12de151f5$var$Ao = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    const s = t.split("#"), n = s[1], r = (s[0] || "").split("?"), o = r[1], l = r[0], a = (o || "").split("&"), u = [];
    for(let t = 0; a.length > t; t++){
        const s = a[t].split("=");
        $9ae5e4a12de151f5$var$T(s) && (i.includes(s[0]) ? u.push(s[0] + "=" + e) : u.push(a[t]));
    }
    let h = l;
    return null != o && (h += "?" + u.join("&")), null != n && (h += "#" + n), h;
}, $9ae5e4a12de151f5$var$Mo = function(t, i) {
    const e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $9ae5e4a12de151f5$var$Fo = (t, i)=>t >= i && $9ae5e4a12de151f5$var$h(), $9ae5e4a12de151f5$var$Do = (t, i, e, s)=>{
    if (0 === t) {
        if ($9ae5e4a12de151f5$var$h()) {
            const t = i + 1;
            return t === e && s(), t;
        }
        return i;
    }
    return 0;
}, $9ae5e4a12de151f5$var$No = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $9ae5e4a12de151f5$var$jo = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    ...$9ae5e4a12de151f5$var$No
], $9ae5e4a12de151f5$var$Lo = "<masked>", $9ae5e4a12de151f5$var$Bo = [
    "li_fat_id"
];
function $9ae5e4a12de151f5$var$Uo(t, i, e) {
    if (!$9ae5e4a12de151f5$var$s) return {};
    const n = i ? [
        ...$9ae5e4a12de151f5$var$No,
        ...e || []
    ] : [], r = $9ae5e4a12de151f5$var$zo($9ae5e4a12de151f5$var$Ao($9ae5e4a12de151f5$var$s.URL, n, $9ae5e4a12de151f5$var$Lo), t), o = function() {
        const t = {};
        return $9ae5e4a12de151f5$var$Vn($9ae5e4a12de151f5$var$Bo, function(i) {
            const e = $9ae5e4a12de151f5$var$ir(i);
            t[i] = e || null;
        }), t;
    }();
    return $9ae5e4a12de151f5$var$Wn(o, r);
}
function $9ae5e4a12de151f5$var$zo(t, i) {
    const e = $9ae5e4a12de151f5$var$jo.concat(i || []), s = {};
    return $9ae5e4a12de151f5$var$Vn(e, function(i) {
        const e = $9ae5e4a12de151f5$var$Io(t, i);
        s[i] = e || null;
    }), s;
}
function $9ae5e4a12de151f5$var$Ho(t) {
    const i = function(t) {
        return t ? 0 === t.search("https?://(.*)google.([^/?]*)") ? "google" : 0 === t.search("https?://(.*)bing.com") ? "bing" : 0 === t.search("https?://(.*)yahoo.com") ? "yahoo" : 0 === t.search("https?://(.*)duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", n = {};
    if (!$9ae5e4a12de151f5$var$M(i)) {
        n.$search_engine = i;
        const t = $9ae5e4a12de151f5$var$s ? $9ae5e4a12de151f5$var$Io($9ae5e4a12de151f5$var$s.referrer, e) : "";
        t.length && (n.ph_keyword = t);
    }
    return n;
}
function $9ae5e4a12de151f5$var$qo() {
    return navigator.language || navigator.userLanguage;
}
function $9ae5e4a12de151f5$var$Vo() {
    const t = $9ae5e4a12de151f5$var$qo();
    return "string" == typeof t ? t.split("-")[0] : void 0;
}
const $9ae5e4a12de151f5$var$Wo = "$direct";
function $9ae5e4a12de151f5$var$Go() {
    return (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.referrer) || $9ae5e4a12de151f5$var$Wo;
}
function $9ae5e4a12de151f5$var$Ko(t, i, e = !1) {
    const s = t ? [
        ...$9ae5e4a12de151f5$var$No,
        ...i || []
    ] : [], r = e ? $9ae5e4a12de151f5$var$vi(null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.href) : null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.href, o = null == r ? void 0 : r.substring(0, 1e3);
    return {
        r: $9ae5e4a12de151f5$var$Go().substring(0, 1e3),
        u: o ? $9ae5e4a12de151f5$var$Ao(o, s, $9ae5e4a12de151f5$var$Lo) : void 0
    };
}
function $9ae5e4a12de151f5$var$Jo(t, i = !1) {
    var e;
    const { r: s, u: n } = t, r = i ? $9ae5e4a12de151f5$var$vi(n) : n, o = {
        $referrer: s,
        $referring_domain: null == s ? void 0 : s == $9ae5e4a12de151f5$var$Wo ? $9ae5e4a12de151f5$var$Wo : null === (e = $9ae5e4a12de151f5$var$Ro(s)) || void 0 === e ? void 0 : e.host
    };
    if (r) {
        o.$current_url = r;
        const t = $9ae5e4a12de151f5$var$Ro(r);
        o.$host = null == t ? void 0 : t.host, o.$pathname = null == t ? void 0 : t.pathname;
        const i = $9ae5e4a12de151f5$var$zo(r);
        $9ae5e4a12de151f5$var$Wn(o, i);
    }
    if (s) {
        const t = $9ae5e4a12de151f5$var$Ho(s);
        $9ae5e4a12de151f5$var$Wn(o, t);
    }
    return o;
}
function $9ae5e4a12de151f5$var$Yo() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $9ae5e4a12de151f5$var$Xo() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
const $9ae5e4a12de151f5$var$Qo = {
    flags: $9ae5e4a12de151f5$var$cn,
    surveys: $9ae5e4a12de151f5$var$Xs
}, $9ae5e4a12de151f5$var$Zo = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $9ae5e4a12de151f5$var$tl = (t)=>`${t}_cookie_identity_change_pending`, $9ae5e4a12de151f5$var$il = (t)=>{
    let i = "", e = 0;
    for (const s of t){
        const t = encodeURIComponent(JSON.stringify(s).slice(1, -1)).length;
        if (e + t > 1e3) break;
        i += s, e += t;
    }
    return i;
}, $9ae5e4a12de151f5$var$el = "main", $9ae5e4a12de151f5$var$sl = [
    $9ae5e4a12de151f5$var$js,
    $9ae5e4a12de151f5$var$Ls,
    $9ae5e4a12de151f5$var$Us,
    $9ae5e4a12de151f5$var$zs,
    $9ae5e4a12de151f5$var$Hs,
    $9ae5e4a12de151f5$var$cn,
    $9ae5e4a12de151f5$var$qs,
    $9ae5e4a12de151f5$var$Gs
], $9ae5e4a12de151f5$var$nl = (t)=>-1 !== $9ae5e4a12de151f5$var$sl.indexOf(t), $9ae5e4a12de151f5$var$rl = [
    $9ae5e4a12de151f5$var$hs,
    $9ae5e4a12de151f5$var$cs
], $9ae5e4a12de151f5$var$ol = (t)=>-1 !== $9ae5e4a12de151f5$var$rl.indexOf(t), $9ae5e4a12de151f5$var$ll = (t, i)=>{
    try {
        return JSON.stringify(t) === JSON.stringify(i);
    } catch (e) {
        return t === i;
    }
}, $9ae5e4a12de151f5$var$al = (t)=>{
    if (!t) return {};
    const i = JSON.parse(t);
    return $9ae5e4a12de151f5$var$C(i) ? i : {};
}, $9ae5e4a12de151f5$var$ul = (t, i)=>{
    $9ae5e4a12de151f5$var$Vn(t, (e, s)=>{
        const n = $9ae5e4a12de151f5$var$Co(s);
        n && "event" !== n.exposure || ({}).hasOwnProperty.call(i, s) || delete t[s];
    });
};
var $9ae5e4a12de151f5$var$hl = class {
    constructor(i, e, s = !0){
        if (this.Jo = {}, this.Ko = !1, this.Xo = !1, this.Yo = !1, this.ta = !1, this.ea = !1, this.ia = new Map, this.na = !1, this.sa = !1, this.ra = !1, this.oa = new Set, this.aa = new Set, this.Rr = i, this.la = s, this.props = {}, this.ua = void 0, this.ha = ((t)=>{
            let i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(i), this.qo = this.ca(i), this.Yo = this.da(i), this.load(), this.va(), i.debug && $9ae5e4a12de151f5$var$Je.info("Persistence loaded", i.persistence, $9ae5e4a12de151f5$var$Ei({}, this.props)), this.update_config(i, i, e), this.save(), $9ae5e4a12de151f5$var$t) {
            const i = ()=>this.flush();
            $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "beforeunload", i, {
                capture: !1
            }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "pagehide", i, {
                capture: !1
            }), this.fa = (i)=>{
                if (this.Ko && (!i.storageArea || i.storageArea === (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.localStorage)) && i.key) {
                    if (i.key !== this.ha) {
                        if (this.Yo) {
                            const t = $9ae5e4a12de151f5$var$ko.find((t)=>i.key === this.pa(t));
                            t && this.ga(i.key, t);
                        }
                    } else this.ga(i.key, $9ae5e4a12de151f5$var$el);
                }
            }, $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "storage", this.fa);
        }
    }
    markCrossTabFeatureFlagChanges(t) {
        Object.entries(t).forEach(([t, i])=>{
            const e = this.ia.get(t);
            if (!$9ae5e4a12de151f5$var$nl(t) || !0 === e) return;
            if (!0 === i) return void this.ma(t, !0);
            const s = new Set(e || []);
            i.forEach((t)=>s.add(t)), s.size && this.ma(t, s);
        });
    }
    onCrossTabFeatureFlagChange(t) {
        return this.aa.add(t), ()=>this.aa.delete(t);
    }
    destroy() {
        this.fa && $9ae5e4a12de151f5$var$t && ($9ae5e4a12de151f5$var$t.removeEventListener("storage", this.fa), this.fa = void 0), this.aa.clear();
    }
    ga(t, i, e = !0) {
        if (this.mi) return !1;
        let s, n;
        try {
            if (n = $9ae5e4a12de151f5$var$fr.Ot(t), $9ae5e4a12de151f5$var$M(n)) {
                const t = this.ya(i);
                return t.storageValue = null, i !== $9ae5e4a12de151f5$var$el && (t.persisted = !1), !1;
            }
            s = $9ae5e4a12de151f5$var$al(n);
        } catch (t) {
            return !1;
        }
        const r = i === $9ae5e4a12de151f5$var$el ? s : $9ae5e4a12de151f5$var$fr.Dt(this.ha);
        if (r && this.ba(r)) return !1;
        const o = this._a(s, i, e);
        return i === $9ae5e4a12de151f5$var$el && this.Yo && !$9ae5e4a12de151f5$var$ll(this.wa().main, s) || this.ka(s, i, !0, n), o;
    }
    ba(t) {
        const i = this.props[$9ae5e4a12de151f5$var$ns], e = t[$9ae5e4a12de151f5$var$ns];
        return !$9ae5e4a12de151f5$var$R(i) && !$9ae5e4a12de151f5$var$R(e) && i !== e;
    }
    ka(t, i, e, s) {
        const n = this.ya(i);
        n.storageValue = s, i !== $9ae5e4a12de151f5$var$el && (n.persisted = e);
        try {
            n.fingerprint = this.Sa(t, i);
        } catch (t) {
            n.fingerprint = void 0;
        }
    }
    _a(t, i, e) {
        let s = !1;
        return $9ae5e4a12de151f5$var$sl.forEach((e)=>{
            var n;
            const r = null === (n = $9ae5e4a12de151f5$var$Co(e)) || void 0 === n ? void 0 : n.storageGroup;
            if (i === $9ae5e4a12de151f5$var$el && this.Yo && r || i !== $9ae5e4a12de151f5$var$el && r !== i) return;
            const o = e in t, l = this.xa(e, o ? t[e] : void 0), a = this.ia.has(e) ? e in this.props : o;
            a === e in this.props && $9ae5e4a12de151f5$var$ll(l, this.props[e]) || (a ? this.Ca(e, l, !1) : this.$a(e, !1), s = !0);
        }), s && e && this.aa.forEach((t)=>t()), s;
    }
    Ta() {
        if (!this.Ko) return !1;
        try {
            this.ra = !1;
            const t = $9ae5e4a12de151f5$var$fr.Ot(this.ha), i = this.ya($9ae5e4a12de151f5$var$el);
            let e, s = !1, n = !1;
            if (t !== i.storageValue) {
                if ($9ae5e4a12de151f5$var$M(t)) i.storageValue = null;
                else {
                    if (e = $9ae5e4a12de151f5$var$al(t), this.ra = !this.sa && this.ba(e), this.ra) return !1;
                    n = this._a(e, $9ae5e4a12de151f5$var$el, !1), !this.Yo || $9ae5e4a12de151f5$var$ll(this.wa().main, e) ? this.ka(e, $9ae5e4a12de151f5$var$el, !0, t) : i.storageValue = t, s = !0;
                }
            }
            return this.Yo && $9ae5e4a12de151f5$var$ko.forEach((t)=>{
                const i = $9ae5e4a12de151f5$var$fr.Ot(this.pa(t)), r = this.ya(t), o = e || {}, l = s && $9ae5e4a12de151f5$var$sl.some((i)=>{
                    var e;
                    return (null === (e = $9ae5e4a12de151f5$var$Co(i)) || void 0 === e ? void 0 : e.storageGroup) === t && i in o;
                });
                if (i === r.storageValue && !l) return;
                if ($9ae5e4a12de151f5$var$M(i)) return r.storageValue = null, r.persisted = !1, void (l && (n = this._a(o, t, !1) || n));
                const a = $9ae5e4a12de151f5$var$al(i);
                n = this._a(a, t, !1) || n, this.ka(a, t, !0, i);
            }), n;
        } catch (t) {
            return !1;
        }
    }
    ma(t, i) {
        this.ia.set(t, i);
        const e = $9ae5e4a12de151f5$var$Co(t);
        (null == e ? void 0 : e.volatile) || (this.ya((this.Yo ? null == e ? void 0 : e.storageGroup : void 0) || $9ae5e4a12de151f5$var$el).fingerprint = void 0, this.Ia(t));
    }
    Ma() {
        $9ae5e4a12de151f5$var$sl.forEach((t)=>this.ia.set(t, !0));
    }
    va() {
        if (this.Ko) try {
            const t = $9ae5e4a12de151f5$var$fr.Ot(this.ha), i = $9ae5e4a12de151f5$var$al(t);
            this.ya($9ae5e4a12de151f5$var$el).storageValue = t, $9ae5e4a12de151f5$var$sl.forEach((t)=>{
                var e;
                const s = this.Yo ? null === (e = $9ae5e4a12de151f5$var$Co(t)) || void 0 === e ? void 0 : e.storageGroup : void 0, n = s ? $9ae5e4a12de151f5$var$fr.Ot(this.pa(s)) : null;
                if (s) {
                    const t = this.ya(s);
                    t.storageValue = n, t.persisted = !$9ae5e4a12de151f5$var$M(n);
                }
                const r = s && !$9ae5e4a12de151f5$var$M(n) ? $9ae5e4a12de151f5$var$al(n) : i;
                t in this.props ? this.Ea(t, r[t], this.props[t]) : t in r && this.ma(t, !0);
            });
        } catch (t) {}
    }
    xa(t, i) {
        const e = this.ia.get(t);
        if (!e) return i;
        if (!0 === e) return this.props[t];
        if ("$active_feature_flags" === t) {
            const s = new Set($9ae5e4a12de151f5$var$T(i) ? i : []), n = new Set($9ae5e4a12de151f5$var$T(this.props[t]) ? this.props[t] : []);
            return e.forEach((t)=>n.has(t) ? s.add(t) : s.delete(t)), Array.from(s);
        }
        const s = $9ae5e4a12de151f5$var$C(i) ? $9ae5e4a12de151f5$var$Ei({}, i) : {}, n = $9ae5e4a12de151f5$var$C(this.props[t]) ? this.props[t] : {};
        return e.forEach((t)=>{
            t in n ? s[t] = n[t] : delete s[t];
        }), s;
    }
    Ea(t, i, e) {
        if (!$9ae5e4a12de151f5$var$nl(t)) return;
        const s = this.ia.get(t);
        if (!0 === s) return;
        let n = i;
        if (this.Ko) try {
            var r;
            const i = this.Yo ? null === (r = $9ae5e4a12de151f5$var$Co(t)) || void 0 === r ? void 0 : r.storageGroup : void 0, e = i ? this.pa(i) : this.ha;
            n = $9ae5e4a12de151f5$var$al($9ae5e4a12de151f5$var$fr.Ot(e))[t];
        } catch (t) {}
        const o = new Set(s || []);
        if ("$active_feature_flags" === t) {
            if (!$9ae5e4a12de151f5$var$R(i) && !$9ae5e4a12de151f5$var$T(i) || !$9ae5e4a12de151f5$var$R(n) && !$9ae5e4a12de151f5$var$T(n) || !$9ae5e4a12de151f5$var$T(e)) return void this.ma(t, !0);
            const s = new Set(i || []), r = new Set(n || []), l = new Set(e);
            new Set([
                ...s,
                ...l
            ]).forEach((t)=>{
                s.has(t) !== l.has(t) && o.add(t);
            }), o.forEach((t)=>{
                r.has(t) === l.has(t) && o.delete(t);
            });
        } else {
            if (!$9ae5e4a12de151f5$var$C(e)) return void ($9ae5e4a12de151f5$var$ll(n, e) ? this.ia.delete(t) : this.ma(t, !0));
            {
                if (!$9ae5e4a12de151f5$var$R(i) && !$9ae5e4a12de151f5$var$C(i) || $9ae5e4a12de151f5$var$R(i) && $9ae5e4a12de151f5$var$O(e) && $9ae5e4a12de151f5$var$R(n)) return void this.ma(t, !0);
                const s = $9ae5e4a12de151f5$var$C(i) ? i : {}, r = $9ae5e4a12de151f5$var$C(n) ? n : {};
                new Set([
                    ...Object.keys(s),
                    ...Object.keys(e)
                ]).forEach((t)=>{
                    t in s == t in e && $9ae5e4a12de151f5$var$ll(s[t], e[t]) || o.add(t);
                }), o.forEach((t)=>{
                    t in r == t in e && $9ae5e4a12de151f5$var$ll(r[t], e[t]) && o.delete(t);
                });
            }
        }
        o.size ? this.ma(t, o) : this.ia.delete(t);
    }
    Pa() {
        var t;
        const i = null === (t = this.Rr) || void 0 === t ? void 0 : t.persistence_save_debounce_ms;
        return $9ae5e4a12de151f5$var$D(i) && i > 0 ? i : 0;
    }
    Ra(t) {
        if (this.Rr.cookieWinsOnConflict && "localstorage+cookie" === this.Rr.persistence.toLowerCase()) {
            if (t) try {
                const i = $9ae5e4a12de151f5$var$yr(t, this.Rr.cookie_persisted_properties || []), e = $9ae5e4a12de151f5$var$$r(i, this.Rr.cookie_persisted_properties || []), s = JSON.stringify(i) + "|" + JSON.stringify(e), n = $9ae5e4a12de151f5$var$cr.Ot(this.ha) || void 0;
                n && $9ae5e4a12de151f5$var$xr(this.ha, n) === s && (this.Aa = s, this.Fa = n);
            } catch (t) {}
            else try {
                const t = $9ae5e4a12de151f5$var$cr.Ot(this.ha) || void 0;
                this.Aa = t ? $9ae5e4a12de151f5$var$xr(this.ha, t) : void 0, this.Fa = t;
            } catch (t) {}
        }
    }
    syncCookieProperties() {
        return this.Oa(this.Rr);
    }
    Oa(t, i = !1) {
        if (this.mi && !i || this.ea || !t.cookieWinsOnConflict || "localstorage+cookie" !== t.persistence.toLowerCase()) return !1;
        let e;
        try {
            e = $9ae5e4a12de151f5$var$cr.Ot(this.ha) || void 0;
        } catch (t) {}
        if (!e || e === this.Fa) return !1;
        const s = $9ae5e4a12de151f5$var$xr(this.ha, e);
        let n;
        try {
            n = $9ae5e4a12de151f5$var$br(JSON.parse(e));
        } catch (t) {
            return !1;
        }
        if (($9ae5e4a12de151f5$var$cr.Ot(this.ha) || void 0) !== e) return !1;
        this.Aa = s, this.Fa = e;
        const r = $9ae5e4a12de151f5$var$Sr(this.ha, e), o = [
            ...$9ae5e4a12de151f5$var$_r,
            ...r.properties
        ], l = {};
        if (Object.keys(n).forEach((t)=>{
            const i = n[t];
            ($9ae5e4a12de151f5$var$R(i) || $9ae5e4a12de151f5$var$M(i) || "" === i || "$user_state" === t && "anonymous" !== i && "identified" !== i) && (l[t] = !0, delete n[t]);
        }), $9ae5e4a12de151f5$var$O(n)) return !1;
        const a = "distinct_id" in n || "anonymous" === n.$user_state || "identified" === n.$user_state, u = this.props, h = u[$9ae5e4a12de151f5$var$ns], d = u[$9ae5e4a12de151f5$var$vn], c = $9ae5e4a12de151f5$var$Wn({}, u);
        [
            ...$9ae5e4a12de151f5$var$_r,
            ...t.cookie_persisted_properties || []
        ].forEach((t)=>{
            if (-1 !== o.indexOf(t) && !(t in n) && !l[t] && (a || "distinct_id" !== t && "$user_state" !== t)) {
                const i = c[t];
                (r.isValid || -1 === $9ae5e4a12de151f5$var$_r.indexOf(t) || !1 !== i && 0 !== i) && delete c[t];
            }
        }), this.props = $9ae5e4a12de151f5$var$Wn(c, n), $9ae5e4a12de151f5$var$sl.forEach((t)=>{
            const i = t in this.props;
            t in u === i && $9ae5e4a12de151f5$var$ll(u[t], this.props[t]) || (i ? this.Ea(t, u[t], this.props[t]) : this.ma(t, !0));
        }), !a || "$user_state" in n || "$user_state" in this.props || this.Ca($9ae5e4a12de151f5$var$vn, $9ae5e4a12de151f5$var$Fn);
        const v = this.props[$9ae5e4a12de151f5$var$ns], f = this.props[$9ae5e4a12de151f5$var$vn];
        return !a || v === h && f === d || (this.sa = !0, this.ta = !0, $9ae5e4a12de151f5$var$Pr.At($9ae5e4a12de151f5$var$tl(this.ha), !0), this.$a($9ae5e4a12de151f5$var$Gs), this.$a($9ae5e4a12de151f5$var$Ls), this.$a($9ae5e4a12de151f5$var$js), this.$a($9ae5e4a12de151f5$var$Us), this.$a($9ae5e4a12de151f5$var$zs), this.$a($9ae5e4a12de151f5$var$Hs), this.$a($9ae5e4a12de151f5$var$cn), this.$a($9ae5e4a12de151f5$var$dn), this.$a($9ae5e4a12de151f5$var$un), "anonymous" !== f || "identified" !== d && "anonymous" !== n.$user_state && ($9ae5e4a12de151f5$var$R(h) || v === h) || ($9ae5e4a12de151f5$var$ul(this.props, n), this.$a($9ae5e4a12de151f5$var$Ks)), "identified" === f ? this.props.$user_id = v : delete this.props.$user_id, this.$a($9ae5e4a12de151f5$var$ls)), !0;
    }
    consumeCookieIdentityChange() {
        const t = $9ae5e4a12de151f5$var$tl(this.ha), i = this.ta || !!$9ae5e4a12de151f5$var$Pr.Ot(t);
        return this.ta = !1, i && $9ae5e4a12de151f5$var$Pr.Lt(t), i;
    }
    Da(t = !1) {
        return !(this.ea || this.mi && !t || !this.Rr.cookieWinsOnConflict || "localstorage+cookie" !== this.Rr.persistence.toLowerCase() || (this.ea = !0, 0));
    }
    La() {
        this.ea && ($9ae5e4a12de151f5$var$R(this.Na) || (clearTimeout(this.Na), this.Na = void 0), delete this.Jo[$9ae5e4a12de151f5$var$el], this.qa(!0));
    }
    ja(t = !0) {
        if (this.ea) try {
            t ? this.La() : $9ae5e4a12de151f5$var$R(this.Na) || (clearTimeout(this.Na), this.Na = void 0);
        } finally{
            this.ea = !1;
        }
    }
    isDisabled() {
        return !!this.mi;
    }
    ca(i) {
        -1 === $9ae5e4a12de151f5$var$Zo.indexOf(i.persistence.toLowerCase()) && ($9ae5e4a12de151f5$var$Je.critical("Unknown persistence type " + i.persistence + "; falling back to localStorage+cookie"), i.persistence = "localStorage+cookie");
        const e = ((i = [], e = !1)=>{
            const s = [
                ...$9ae5e4a12de151f5$var$_r,
                ...i
            ];
            return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$fr), {}, {
                Dt (t) {
                    try {
                        let n, r = {};
                        try {
                            n = $9ae5e4a12de151f5$var$cr.Ot(t) || void 0, r = n ? $9ae5e4a12de151f5$var$br(JSON.parse(n)) : {};
                        } catch (t) {}
                        const o = JSON.parse($9ae5e4a12de151f5$var$fr.Ot(t) || "{}");
                        let l;
                        if (e) {
                            const e = $9ae5e4a12de151f5$var$Sr(t, n), a = [
                                ...$9ae5e4a12de151f5$var$_r,
                                ...e.properties
                            ], u = {};
                            Object.keys(r).forEach((t)=>{
                                const i = r[t];
                                $9ae5e4a12de151f5$var$M(i) || "" === i || "$user_state" === t && "anonymous" !== i && "identified" !== i || (u[t] = i);
                            });
                            const h = "distinct_id" in u || "anonymous" === u.$user_state || "identified" === u.$user_state;
                            if (Object.keys(u).length > 0) {
                                var i;
                                const t = o[$9ae5e4a12de151f5$var$ns], n = null !== (i = o.$user_state) && void 0 !== i ? i : $9ae5e4a12de151f5$var$Fn;
                                s.forEach((t)=>{
                                    if (-1 !== a.indexOf(t) && !(t in r) && (h || "distinct_id" !== t && "$user_state" !== t)) {
                                        const i = o[t];
                                        (e.isValid || -1 === $9ae5e4a12de151f5$var$_r.indexOf(t) || !1 !== i && 0 !== i) && delete o[t];
                                    }
                                }), !h || "$user_state" in r || "$user_state" in o || (o[$9ae5e4a12de151f5$var$vn] = $9ae5e4a12de151f5$var$Fn), !h || ("distinct_id" in u ? u[$9ae5e4a12de151f5$var$ns] : o[$9ae5e4a12de151f5$var$ns]) === t && ("$user_state" in u ? u[$9ae5e4a12de151f5$var$vn] : o[$9ae5e4a12de151f5$var$vn]) === n || ($9ae5e4a12de151f5$var$pr.forEach((t)=>delete o[t]), "identified" === u.$user_state && "distinct_id" in u ? o.$user_id = u[$9ae5e4a12de151f5$var$ns] : delete o.$user_id, "identified" !== u.$user_state && (delete o[$9ae5e4a12de151f5$var$Js], delete o[$9ae5e4a12de151f5$var$Ks]), delete o.__alias);
                            }
                            l = $9ae5e4a12de151f5$var$Wn(o, u);
                        } else l = $9ae5e4a12de151f5$var$Wn(r, o);
                        return $9ae5e4a12de151f5$var$fr.At(t, l), l;
                    } catch (t) {}
                    return null;
                },
                At (t, s, n, r, o, l) {
                    const a = $9ae5e4a12de151f5$var$fr.At(t, s, void 0, void 0, l);
                    try {
                        const u = $9ae5e4a12de151f5$var$yr(s, i);
                        if (Object.keys(u).length) {
                            if (e) {
                                const e = $9ae5e4a12de151f5$var$gr(t), h = $9ae5e4a12de151f5$var$$r(u, i);
                                if ($9ae5e4a12de151f5$var$cr.At(e, h, n, r, o, l), $9ae5e4a12de151f5$var$cr.Ot(e) !== JSON.stringify(h)) {
                                    $9ae5e4a12de151f5$var$cr.Lt(e, r);
                                    const i = $9ae5e4a12de151f5$var$yr(s);
                                    return $9ae5e4a12de151f5$var$cr.At(t, i, n, r, o, l), a;
                                }
                            }
                            $9ae5e4a12de151f5$var$cr.At(t, u, n, r, o, l);
                        }
                    } catch (t) {
                        $9ae5e4a12de151f5$var$fr.Pt(t);
                    }
                    return a;
                },
                Lt (i, e) {
                    try {
                        null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.localStorage.removeItem(i), $9ae5e4a12de151f5$var$cr.Lt(i, e), $9ae5e4a12de151f5$var$cr.Lt($9ae5e4a12de151f5$var$gr(i), e);
                    } catch (t) {
                        $9ae5e4a12de151f5$var$fr.Pt(t);
                    }
                }
            });
        })(i.cookie_persisted_properties || [], i.cookieWinsOnConflict);
        let s, n = !1, r = !1;
        const o = i.persistence.toLowerCase();
        return "localstorage" === o && $9ae5e4a12de151f5$var$fr.Et() ? (s = $9ae5e4a12de151f5$var$fr, r = !0) : "localstorage+cookie" === o && e.Et() ? (s = e, r = !0, n = !0) : "sessionstorage" === o && $9ae5e4a12de151f5$var$Pr.Et() ? s = $9ae5e4a12de151f5$var$Pr : "memory" === o ? s = $9ae5e4a12de151f5$var$kr : "cookie" === o && $9ae5e4a12de151f5$var$cr.Et() ? (s = $9ae5e4a12de151f5$var$cr, n = !0) : e.Et() ? (s = e, r = !0, n = !0) : $9ae5e4a12de151f5$var$cr.Et() ? (s = $9ae5e4a12de151f5$var$cr, n = !0) : s = $9ae5e4a12de151f5$var$kr, this.Ko = r, this.Xo = n, s;
    }
    pa(t) {
        return `${this.ha}__${t}`;
    }
    da(t) {
        return this.Ko && !!t.split_storage;
    }
    properties() {
        const t = {};
        return $9ae5e4a12de151f5$var$Vn(this.props, (i, e)=>{
            const s = $9ae5e4a12de151f5$var$Co(e);
            if (!s || "event" === s.exposure) {
                var n;
                if (null == s || null === (n = s.shouldSkipFromEventProperties) || void 0 === n ? void 0 : n.call(s, i)) return;
                t[e] = i;
            }
        }), t;
    }
    load(t = !1) {
        if (this.mi && !t) return;
        const i = this.Rr.cookieWinsOnConflict && "localstorage+cookie" === this.Rr.persistence.toLowerCase(), e = i ? $9ae5e4a12de151f5$var$fr.Dt(this.ha) : null;
        let s = {};
        if (i) try {
            s = $9ae5e4a12de151f5$var$br($9ae5e4a12de151f5$var$cr.Dt(this.ha)), $9ae5e4a12de151f5$var$Vn(s, (t, i)=>{
                ($9ae5e4a12de151f5$var$R(t) || $9ae5e4a12de151f5$var$M(t) || "" === t) && delete s[i];
            });
        } catch (t) {}
        const n = this.qo.Dt(this.ha);
        if (n && (this.props = $9ae5e4a12de151f5$var$Wn({}, n)), this.Yo && this.Ba(), i && n) {
            var r, o;
            const t = null == e ? void 0 : e[$9ae5e4a12de151f5$var$ns], i = null !== (r = null == e ? void 0 : e.$user_state) && void 0 !== r ? r : $9ae5e4a12de151f5$var$Fn, l = n[$9ae5e4a12de151f5$var$ns], a = null !== (o = n.$user_state) && void 0 !== o ? o : $9ae5e4a12de151f5$var$Fn;
            if (l !== t || a !== i) {
                this.ta = !0, $9ae5e4a12de151f5$var$Pr.At($9ae5e4a12de151f5$var$tl(this.ha), !0);
                const e = $9ae5e4a12de151f5$var$Wn({}, this.props);
                $9ae5e4a12de151f5$var$pr.forEach((t)=>delete e[t]), "anonymous" !== a || "identified" !== i && "anonymous" !== s.$user_state && ($9ae5e4a12de151f5$var$R(t) || l === t) || ($9ae5e4a12de151f5$var$ul(e, s), delete e[$9ae5e4a12de151f5$var$Ks]), this.props = e;
                const n = new Set;
                $9ae5e4a12de151f5$var$pr.forEach((t)=>{
                    var i;
                    const e = null === (i = $9ae5e4a12de151f5$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup;
                    e && n.add(e);
                }), n.forEach((t)=>{
                    const i = {};
                    $9ae5e4a12de151f5$var$Vn(this.props, (e, s)=>{
                        var n;
                        (null === (n = $9ae5e4a12de151f5$var$Co(s)) || void 0 === n ? void 0 : n.storageGroup) === t && (i[s] = e);
                    }), $9ae5e4a12de151f5$var$O(i) ? ($9ae5e4a12de151f5$var$fr.Lt(this.pa(t)), this.Jo[t] = {}) : $9ae5e4a12de151f5$var$fr.At(this.pa(t), i) && (this.Jo[t] = {
                        persisted: !0,
                        fingerprint: this.Sa(i, t)
                    });
                });
            }
        }
        $9ae5e4a12de151f5$var$Pr.Ot($9ae5e4a12de151f5$var$tl(this.ha)) && (this.ta = !0);
    }
    Ba() {
        for (const t of $9ae5e4a12de151f5$var$ko){
            const i = $9ae5e4a12de151f5$var$fr.Dt(this.pa(t));
            if (i && !$9ae5e4a12de151f5$var$O(i)) {
                const e = this.ya(t);
                e.persisted = !0, this.Ha(t) || (e.fingerprint = this.Sa(i, t)), this.za(t, i) || $9ae5e4a12de151f5$var$Wn(this.props, i);
            }
        }
    }
    Ha(t) {
        return Object.keys(this.props).some((i)=>{
            var e;
            return (null === (e = $9ae5e4a12de151f5$var$Co(i)) || void 0 === e ? void 0 : e.storageGroup) === t;
        });
    }
    za(t, i) {
        const e = $9ae5e4a12de151f5$var$Qo[t];
        if (!e) return !1;
        const s = i[e], n = this.props[e];
        return $9ae5e4a12de151f5$var$D(s) && $9ae5e4a12de151f5$var$D(n) && n > s;
    }
    refreshKey(t) {
        var i;
        if (this.mi) return;
        if (this.oa.has(t)) return;
        const e = this.Yo ? null === (i = $9ae5e4a12de151f5$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup : void 0, s = e ? $9ae5e4a12de151f5$var$fr.Dt(this.pa(e)) : this.qo.Dt(this.ha);
        if (s && t in s) this.Ca(t, s[t], !1);
        else {
            if (e) {
                const i = this.qo.Dt(this.ha);
                if (i && t in i) return void this.Ca(t, i[t], !1);
            }
            this.$a(t, !1);
        }
    }
    save() {
        if (this.mi) return;
        const t = this.Pa();
        t > 0 ? $9ae5e4a12de151f5$var$R(this.Na) && (this.Na = setTimeout(()=>{
            this.Na = void 0, this.qa();
        }, t)) : this.qa();
    }
    flush() {
        $9ae5e4a12de151f5$var$R(this.Na) || (clearTimeout(this.Na), this.Na = void 0, this.qa());
    }
    qa(t = !1) {
        if (this.mi || this.ea && !t) return;
        t || (this.syncCookieProperties(), this.Rr.cookieWinsOnConflict && "localstorage+cookie" === this.Rr.persistence.toLowerCase() || $9ae5e4a12de151f5$var$rl.forEach((t)=>this.refreshKey(t)));
        const i = !t && !this.na;
        i || (this.ra = !1);
        const e = !!i && this.Ta();
        if (this.ra) return void (this.Rr.debug && $9ae5e4a12de151f5$var$Je.warn("skipping persistence write because storage belongs to a different distinct ID"));
        if (this.Yo) return this.Ua(), void (e && this.aa.forEach((t)=>t()));
        const s = this.Wa(this.qo, this.ha, this.props, $9ae5e4a12de151f5$var$el);
        "written" === s && this.Ra(this.props), "failed" !== s && (this.ia.clear(), this.sa = !1, this.oa.clear()), e && this.aa.forEach((t)=>t());
    }
    Ua() {
        const { main: t, groups: i } = this.wa(), e = this.Wa(this.qo, this.ha, t, $9ae5e4a12de151f5$var$el);
        "written" === e && this.Ra(t), "failed" !== e && (this.sa = !1, this.oa.clear(), $9ae5e4a12de151f5$var$sl.forEach((t)=>{
            var i;
            (null === (i = $9ae5e4a12de151f5$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup) || this.ia.delete(t);
        }));
        for (const t of $9ae5e4a12de151f5$var$ko){
            var s;
            const e = i[t];
            if ($9ae5e4a12de151f5$var$O(e) && !(null === (s = this.Jo[t]) || void 0 === s ? void 0 : s.persisted)) {
                $9ae5e4a12de151f5$var$sl.forEach((i)=>{
                    var e;
                    (null === (e = $9ae5e4a12de151f5$var$Co(i)) || void 0 === e ? void 0 : e.storageGroup) === t && this.ia.delete(i);
                });
                continue;
            }
            const n = this.Wa($9ae5e4a12de151f5$var$fr, this.pa(t), e, t);
            "failed" !== n && $9ae5e4a12de151f5$var$sl.forEach((i)=>{
                const e = $9ae5e4a12de151f5$var$Co(i);
                (null == e ? void 0 : e.storageGroup) !== t || "written" !== n && e.volatile || this.ia.delete(i);
            });
        }
    }
    wa() {
        const t = {}, i = {
            flags: {},
            surveys: {}
        };
        return $9ae5e4a12de151f5$var$Vn(this.props, (e, s)=>{
            var n;
            const r = null === (n = $9ae5e4a12de151f5$var$Co(s)) || void 0 === n ? void 0 : n.storageGroup;
            r ? i[r][s] = e : t[s] = e;
        }), {
            main: t,
            groups: i
        };
    }
    Sa(t, i) {
        if (i === $9ae5e4a12de151f5$var$el) return JSON.stringify(t) + "|" + this.Va + "|" + this.Ga + "|" + this.Za;
        const e = {};
        return $9ae5e4a12de151f5$var$Vn(t, (t, i)=>{
            var s;
            e[i] = (null === (s = $9ae5e4a12de151f5$var$Co(i)) || void 0 === s ? void 0 : s.volatile) ? "__volatile__" : t;
        }), JSON.stringify(e);
    }
    Wa(t, i, e, s) {
        const n = this.ya(s);
        if (s !== $9ae5e4a12de151f5$var$el && !n.dirty && !$9ae5e4a12de151f5$var$R(n.fingerprint)) return "skipped";
        let r;
        try {
            if (r = this.Sa(e, s), r === n.fingerprint) return n.dirty = !1, "skipped";
        } catch (t) {
            r = void 0;
        }
        return t.At(i, e, this.Va, this.Ga, this.Za, this.Rr.debug) ? (n.dirty = !1, s !== $9ae5e4a12de151f5$var$el && (n.persisted = !0), $9ae5e4a12de151f5$var$R(r) || (n.fingerprint = r), this.Ko && (n.storageValue = $9ae5e4a12de151f5$var$fr.Ot(i)), "written") : (this.Rr.debug && $9ae5e4a12de151f5$var$Je.warn(`failed to persist storage entry "${i}"; will retry on next save`), "failed");
    }
    remove({ keepGroupEntries: t = !1 } = {}) {
        if (this.Ma(), $9ae5e4a12de151f5$var$R(this.Na) || (clearTimeout(this.Na), this.Na = void 0), this.qo.Lt(this.ha, !1), this.qo.Lt(this.ha, !0), !t && this.la) for (const t of $9ae5e4a12de151f5$var$ko)$9ae5e4a12de151f5$var$fr.Lt(this.pa(t));
        t ? delete this.Jo[$9ae5e4a12de151f5$var$el] : this.Jo = {}, this.Aa = void 0, this.Fa = void 0;
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($9ae5e4a12de151f5$var$C(t)) {
            this.syncCookieProperties(), $9ae5e4a12de151f5$var$R(i) && (i = "None"), this.Va = $9ae5e4a12de151f5$var$R(e) ? this.Qa : e;
            let s = !1;
            if ($9ae5e4a12de151f5$var$Vn(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.Ca(e, t), s = !0);
            }), s) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($9ae5e4a12de151f5$var$C(t)) {
            this.syncCookieProperties(), this.Va = $9ae5e4a12de151f5$var$R(i) ? this.Qa : i;
            let e = !1;
            if ($9ae5e4a12de151f5$var$Vn(t, (i, s)=>{
                t.hasOwnProperty(s) && (this.props[s] !== i || $9ae5e4a12de151f5$var$C(i) || $9ae5e4a12de151f5$var$T(i)) && (this.Ca(s, i), e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        this.syncCookieProperties();
        const i = "string" == typeof t ? [
            t
        ] : t;
        let e = !1;
        for (const t of i)t in this.props && (this.$a(t), e = !0);
        e && this.save();
    }
    update_campaign_params() {
        const t = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.URL;
        if (t === this.ua) return;
        const i = $9ae5e4a12de151f5$var$Uo(this.Rr.custom_campaign_params, this.Rr.mask_personal_data_properties, this.Rr.custom_personal_data_properties), e = !$9ae5e4a12de151f5$var$O($9ae5e4a12de151f5$var$Jn(i));
        return e && this.register(i), this.ua = t, e ? i : void 0;
    }
    update_search_keyword() {
        this.register(function() {
            const t = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.referrer;
            return t ? $9ae5e4a12de151f5$var$Ho(t) : {};
        }());
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $9ae5e4a12de151f5$var$Go(),
            $referring_domain: (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.referrer) && (null === (t = $9ae5e4a12de151f5$var$Ro($9ae5e4a12de151f5$var$s.referrer)) || void 0 === t ? void 0 : t.host) || $9ae5e4a12de151f5$var$Wo
        }, void 0);
    }
    set_initial_person_info() {
        if (this.props.$initial_campaign_params || this.props.$initial_referrer_info) return;
        const t = $9ae5e4a12de151f5$var$Ko(this.Rr.mask_personal_data_properties, this.Rr.custom_personal_data_properties, this.Rr.disable_capture_url_hashes);
        this.register_once({
            [$9ae5e4a12de151f5$var$mn]: this.Xo ? {
                r: $9ae5e4a12de151f5$var$il(t.r),
                u: t.u ? $9ae5e4a12de151f5$var$il(t.u) : void 0
            } : t
        }, void 0);
    }
    get_initial_props() {
        const t = {};
        $9ae5e4a12de151f5$var$Vn([
            $9ae5e4a12de151f5$var$gn,
            $9ae5e4a12de151f5$var$_n
        ], (i)=>{
            const e = this.props[i];
            e && $9ae5e4a12de151f5$var$Vn(e, function(i, e) {
                t["$initial_" + $9ae5e4a12de151f5$var$w(e)] = i;
            });
        });
        const i = this.props[$9ae5e4a12de151f5$var$mn];
        if (i) {
            const e = function(t, i = !1) {
                const e = $9ae5e4a12de151f5$var$Jo(t, i), s = {};
                return $9ae5e4a12de151f5$var$Vn(e, function(t, i) {
                    s[`$initial_${$9ae5e4a12de151f5$var$w(i)}`] = t;
                }), s;
            }(i, this.Rr.disable_capture_url_hashes);
            $9ae5e4a12de151f5$var$Wn(t, e);
        }
        return t;
    }
    safe_merge(t) {
        return $9ae5e4a12de151f5$var$Vn(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        const s = t.persistence !== i.persistence, n = !((t, i)=>{
            if (t.length !== i.length) return !1;
            const e = [
                ...t
            ].sort(), s = [
                ...i
            ].sort();
            return e.every((t, i)=>t === s[i]);
        })(t.cookie_persisted_properties || [], i.cookie_persisted_properties || []), r = s || n, o = t.cookieWinsOnConflict !== i.cookieWinsOnConflict, l = t.disable_persistence || !!e, a = !!this.mi && !l;
        l || this.Oa(i, a), this.Rr = t, !l && (s || n || o) && (this.Aa = void 0, this.Fa = void 0, this.Oa($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            cookie_persisted_properties: i.cookie_persisted_properties
        }), a));
        const u = r || o ? this.ca(t) : this.qo;
        this.Ja();
        const h = this.da(t), d = r || h !== this.Yo, c = !l && (d || t.cross_subdomain_cookie !== this.Ga || t.secure_cookie !== this.Za) && this.Da(a);
        this.na = d;
        try {
            if (this.Qa = this.Va = t.cookie_expiration, this.set_disabled(l), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), d) {
                const t = this.props;
                this.clear(), this.qo = u, this.Yo = h, this.props = t, this.save();
            } else o && (this.qo = u, l || (delete this.Jo[$9ae5e4a12de151f5$var$el], this.qa()));
        } finally{
            this.na = !1, c && this.ja();
        }
    }
    Ja() {
        const t = this.props[$9ae5e4a12de151f5$var$mn];
        if (!this.Xo || !$9ae5e4a12de151f5$var$C(t) || "string" != typeof t.r) return;
        const i = $9ae5e4a12de151f5$var$il(t.r), e = "string" == typeof t.u ? $9ae5e4a12de151f5$var$il(t.u) : t.u;
        i === t.r && e === t.u || this.Ca($9ae5e4a12de151f5$var$mn, $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            r: i,
            u: e
        }));
    }
    set_disabled(t) {
        this.mi = t, this.mi ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Ga && (this.Ga = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_secure(t) {
        t !== this.Za && (this.Za = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_event_timer(t, i) {
        const e = this.props.__timers || {};
        e[t] = i, this.Ca($9ae5e4a12de151f5$var$vs, e), this.save();
    }
    remove_event_timer(t) {
        const i = this.props.__timers || {}, e = i[t];
        return $9ae5e4a12de151f5$var$R(e) || (delete i[t], this.Ca($9ae5e4a12de151f5$var$vs, i), this.save()), e;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.Ca(t, i), this.save();
    }
    Ca(t, i, e = !0) {
        var s;
        const n = this.props[t];
        this.props[t] = i, e && ("distinct_id" !== t && "$user_state" !== t || n === i || (this.sa = !0), $9ae5e4a12de151f5$var$ol(t) && !$9ae5e4a12de151f5$var$ll(n, i) && this.oa.add(t), this.Ea(t, n, i), (null === (s = $9ae5e4a12de151f5$var$Co(t)) || void 0 === s ? void 0 : s.volatile) || this.Ia(t));
    }
    $a(t, i = !0) {
        delete this.props[t], i && ($9ae5e4a12de151f5$var$nl(t) && this.ma(t, !0), $9ae5e4a12de151f5$var$ol(t) && this.oa.add(t), this.Ia(t));
    }
    Ia(t) {
        var i;
        const e = null === (i = $9ae5e4a12de151f5$var$Co(t)) || void 0 === i ? void 0 : i.storageGroup;
        e && (this.ya(e).dirty = !0);
    }
    ya(t) {
        return this.Jo[t] || (this.Jo[t] = {});
    }
};
const $9ae5e4a12de151f5$export$6a00d17b5aff0af = {
    GZipJS: "gzip-js",
    Base64: "base64"
}, $9ae5e4a12de151f5$export$352273f853caad57 = {
    Activation: "events",
    Cancellation: "cancelEvents"
}, $9ae5e4a12de151f5$export$87f1e68f1b904cbb = {
    Button: "button",
    Tab: "tab",
    Selector: "selector"
}, $9ae5e4a12de151f5$export$8c0ce98316e43193 = {
    TopLeft: "top_left",
    TopRight: "top_right",
    TopCenter: "top_center",
    MiddleLeft: "middle_left",
    MiddleRight: "middle_right",
    MiddleCenter: "middle_center",
    Left: "left",
    Center: "center",
    Right: "right",
    NextToTrigger: "next_to_trigger"
}, $9ae5e4a12de151f5$export$3693bed37a847924 = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom"
}, $9ae5e4a12de151f5$export$22779822dd24228f = {
    Popover: "popover",
    API: "api",
    Widget: "widget",
    ExternalSurvey: "external_survey"
}, $9ae5e4a12de151f5$export$9c2ac61661d417f8 = {
    Open: "open",
    MultipleChoice: "multiple_choice",
    SingleChoice: "single_choice",
    Rating: "rating",
    Link: "link"
}, $9ae5e4a12de151f5$export$bbed2da3bd3bb001 = {
    NextQuestion: "next_question",
    End: "end",
    ResponseBased: "response_based",
    SpecificQuestion: "specific_question"
}, $9ae5e4a12de151f5$export$407ee791fe918359 = {
    Once: "once",
    Recurring: "recurring",
    Always: "always"
}, $9ae5e4a12de151f5$export$9d7ec1793ca1658e = {
    SHOWN: "survey shown",
    DISMISSED: "survey dismissed",
    SENT: "survey sent",
    ABANDONED: "survey abandoned"
}, $9ae5e4a12de151f5$export$fe4c9af525341543 = {
    SURVEY_ID: "$survey_id",
    SURVEY_NAME: "$survey_name",
    SURVEY_RESPONSE: "$survey_response",
    SURVEY_ITERATION: "$survey_iteration",
    SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date",
    SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed",
    SURVEY_SUBMISSION_ID: "$survey_submission_id",
    SURVEY_QUESTIONS: "$survey_questions",
    SURVEY_COMPLETED: "$survey_completed",
    PRODUCT_TOUR_ID: "$product_tour_id",
    SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date",
    SURVEY_LANGUAGE: "$survey_language"
}, $9ae5e4a12de151f5$export$a8a66d9d1b857494 = {
    Popover: "popover",
    Inline: "inline"
};
function $9ae5e4a12de151f5$var$Sl(t) {
    let i = !0;
    return {
        dispose () {
            if (i) {
                i = !1;
                const e = t();
                e && $9ae5e4a12de151f5$var$P(e.then) && e.then(void 0, ()=>{});
            }
        }
    };
}
const $9ae5e4a12de151f5$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $9ae5e4a12de151f5$export$e5d0052c1e47bfda = {
    SHOWN: "product tour shown",
    DISMISSED: "product tour dismissed",
    COMPLETED: "product tour completed",
    STEP_SHOWN: "product tour step shown",
    STEP_COMPLETED: "product tour step completed",
    BUTTON_CLICKED: "product tour button clicked",
    STEP_SELECTOR_FAILED: "product tour step selector failed",
    BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed",
    BANNER_ACTION_CLICKED: "product tour banner action clicked"
}, $9ae5e4a12de151f5$export$eedf6d13bc23d767 = {
    TOUR_ID: "$product_tour_id",
    TOUR_NAME: "$product_tour_name",
    TOUR_ITERATION: "$product_tour_iteration",
    TOUR_RENDER_REASON: "$product_tour_render_reason",
    TOUR_STEP_ID: "$product_tour_step_id",
    TOUR_STEP_ORDER: "$product_tour_step_order",
    TOUR_STEP_TYPE: "$product_tour_step_type",
    TOUR_DISMISS_REASON: "$product_tour_dismiss_reason",
    TOUR_BUTTON_TEXT: "$product_tour_button_text",
    TOUR_BUTTON_ACTION: "$product_tour_button_action",
    TOUR_BUTTON_LINK: "$product_tour_button_link",
    TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id",
    TOUR_STEPS_COUNT: "$product_tour_steps_count",
    TOUR_STEP_SELECTOR: "$product_tour_step_selector",
    TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found",
    TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag",
    TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id",
    TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes",
    TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text",
    TOUR_ERROR: "$product_tour_error",
    TOUR_MATCHES_COUNT: "$product_tour_matches_count",
    TOUR_FAILURE_PHASE: "$product_tour_failure_phase",
    TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element",
    TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms",
    TOUR_BANNER_SELECTOR: "$product_tour_banner_selector",
    TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id",
    USE_MANUAL_SELECTOR: "$use_manual_selector",
    INFERENCE_DATA_PRESENT: "$inference_data_present",
    TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date",
    TOUR_TYPE: "$product_tour_type"
}, $9ae5e4a12de151f5$var$Tl = $9ae5e4a12de151f5$var$Ye("[RateLimiter]");
var $9ae5e4a12de151f5$var$Pl = class {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            const i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $9ae5e4a12de151f5$var$Tl.info(`${t || "events"} is quota limited.`), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $9ae5e4a12de151f5$var$Tl.warn(`could not rate limit - continuing. Error: "${null == t ? void 0 : t.message}"`, {
                    text: i
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null === (t = this.instance.config.rate_limiting) || void 0 === t ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null === (t = this.instance.config.rate_limiting) || void 0 === t ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t = !1) {
        var i, e, s;
        const { captureEventsBurstLimit: n, captureEventsPerSecond: r } = this, o = (new Date).getTime(), l = null !== (i = null === (e = this.instance.persistence) || void 0 === e ? void 0 : e.get_property("$capture_rate_limit")) && void 0 !== i ? i : {
            tokens: n,
            last: o
        };
        l.tokens += (o - l.last) / 1e3 * r, l.last = o, l.tokens > n && (l.tokens = n);
        const a = 1 > l.tokens;
        if (a || t || (l.tokens = Math.max(0, l.tokens - 1)), a && !t) {
            const t = ($9ae5e4a12de151f5$var$D(l.dropped) ? l.dropped : 0) + 1;
            l.dropped = t, !this.lastEventRateLimited && this.Ka(t) && (l.dropped = 0);
        }
        return this.lastEventRateLimited = a, null === (s = this.instance.persistence) || void 0 === s || s.set_property("$capture_rate_limit", l), {
            isRateLimited: a,
            remainingTokens: l.tokens
        };
    }
    Xa(t) {
        const i = this.instance.config.property_denylist;
        return !$9ae5e4a12de151f5$var$T(i) || !i.includes(t);
    }
    Ya() {
        var t;
        if (this.Xa("$current_url") && this.Xa("$pathname") && (null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.pathname)) return `${null !== (t = $9ae5e4a12de151f5$var$n.origin) && void 0 !== t ? t : ""}${$9ae5e4a12de151f5$var$n.pathname}`;
    }
    Ka(t) {
        var i, e;
        const { captureEventsBurstLimit: s, captureEventsPerSecond: n } = this, r = this.Ya(), o = this.Xa("$session_id") ? null === (i = (e = this.instance).get_session_id) || void 0 === i ? void 0 : i.call(e) : void 0, l = [
            `${t} event(s) dropped since the last warning`,
            r ? `triggered on ${r}` : void 0,
            o ? `session ${o}` : void 0
        ].filter(Boolean).join(", ");
        return !!this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: `posthog-js client rate limited: ${l}. Config is set to ${n} events per second and ${s} events burst limit.`
        }, {
            skip_client_rate_limiting: !0
        });
    }
    isServerRateLimited(t) {
        const i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
};
const $9ae5e4a12de151f5$var$Cl = $9ae5e4a12de151f5$var$Ye("[RemoteConfig]");
var $9ae5e4a12de151f5$var$Ol = class {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null === (t = $9ae5e4a12de151f5$var$c._POSTHOG_REMOTE_CONFIG) || void 0 === t || null === (t = t[this._instance.config.token]) || void 0 === t ? void 0 : t.config;
    }
    tl(t) {
        var i, e, s;
        (null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.loadExternalDependency) ? null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    el(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", `/array/${this._instance.config.token}/config`),
            callback: t
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $9ae5e4a12de151f5$var$Cl.info("Using preloaded remote config", this.remoteConfig), void this.il(this.remoteConfig);
            if (this._instance.nl()) return void $9ae5e4a12de151f5$var$Cl.warn("Remote config is disabled. Falling back to local config.");
            this.tl((t)=>{
                if (!t) return $9ae5e4a12de151f5$var$Cl.info("No config found after loading remote JS config. Falling back to JSON."), void this.el((t)=>{
                    this.il(t.json, t);
                });
                this.il(t);
            });
        } catch (t) {
            $9ae5e4a12de151f5$var$Cl.error("Error loading remote config", t), this.il();
        }
    }
    il(t, i) {
        !t && i && (0 === i.statusCode ? i.error || $9ae5e4a12de151f5$var$Cl.warn("Failed to fetch remote config from PostHog.") : $9ae5e4a12de151f5$var$Cl.error("Failed to fetch remote config from PostHog."));
        try {
            this._instance.il(t ? {
                ok: !0,
                config: t
            } : {
                ok: !1
            });
        } catch (t) {
            $9ae5e4a12de151f5$var$Cl.error("Error applying remote config", t);
        }
        if (!1 !== (null == t ? void 0 : t.hasFeatureFlags) && !this._instance.config.advanced_disable_feature_flags_on_first_load) try {
            var e;
            null === (e = this._instance.featureFlags) || void 0 === e || e.ensureFlagsLoaded();
        } catch (t) {
            $9ae5e4a12de151f5$var$Cl.error("Error loading feature flags", t);
        }
    }
};
const $9ae5e4a12de151f5$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
var $9ae5e4a12de151f5$var$Il = Uint8Array, $9ae5e4a12de151f5$var$Al = Uint16Array, $9ae5e4a12de151f5$var$Ml = Uint32Array, $9ae5e4a12de151f5$var$Fl = new $9ae5e4a12de151f5$var$Il([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $9ae5e4a12de151f5$var$Dl = new $9ae5e4a12de151f5$var$Il([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $9ae5e4a12de151f5$var$Nl = new $9ae5e4a12de151f5$var$Il([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $9ae5e4a12de151f5$var$jl = function(t, i) {
    for(var e = new $9ae5e4a12de151f5$var$Al(31), s = 0; 31 > s; ++s)e[s] = i += 1 << t[s - 1];
    var n = new $9ae5e4a12de151f5$var$Ml(e[30]);
    for(s = 1; 30 > s; ++s)for(var r = e[s]; e[s + 1] > r; ++r)n[r] = r - e[s] << 5 | s;
    return [
        e,
        n
    ];
}, $9ae5e4a12de151f5$var$Ll = $9ae5e4a12de151f5$var$jl($9ae5e4a12de151f5$var$Fl, 2), $9ae5e4a12de151f5$var$Bl = $9ae5e4a12de151f5$var$Ll[1];
$9ae5e4a12de151f5$var$Ll[0][28] = 258, $9ae5e4a12de151f5$var$Bl[258] = 28;
for(var $9ae5e4a12de151f5$var$Ul = $9ae5e4a12de151f5$var$jl($9ae5e4a12de151f5$var$Dl, 0)[1], $9ae5e4a12de151f5$var$zl = new $9ae5e4a12de151f5$var$Al(32768), $9ae5e4a12de151f5$var$Hl = 0; 32768 > $9ae5e4a12de151f5$var$Hl; ++$9ae5e4a12de151f5$var$Hl){
    var $9ae5e4a12de151f5$var$ql = (43690 & $9ae5e4a12de151f5$var$Hl) >>> 1 | (21845 & $9ae5e4a12de151f5$var$Hl) << 1;
    $9ae5e4a12de151f5$var$zl[$9ae5e4a12de151f5$var$Hl] = ((65280 & ($9ae5e4a12de151f5$var$ql = (61680 & ($9ae5e4a12de151f5$var$ql = (52428 & $9ae5e4a12de151f5$var$ql) >>> 2 | (13107 & $9ae5e4a12de151f5$var$ql) << 2)) >>> 4 | (3855 & $9ae5e4a12de151f5$var$ql) << 4)) >>> 8 | (255 & $9ae5e4a12de151f5$var$ql) << 8) >>> 1;
}
var $9ae5e4a12de151f5$var$Vl = function(t, i, e) {
    for(var s = t.length, n = 0, r = new $9ae5e4a12de151f5$var$Al(i); s > n; ++n)++r[t[n] - 1];
    var o, l = new $9ae5e4a12de151f5$var$Al(i);
    for(n = 0; i > n; ++n)l[n] = l[n - 1] + r[n - 1] << 1;
    if (e) {
        o = new $9ae5e4a12de151f5$var$Al(1 << i);
        var a = 15 - i;
        for(n = 0; s > n; ++n)if (t[n]) for(var u = n << 4 | t[n], h = i - t[n], d = l[t[n] - 1]++ << h, c = d | (1 << h) - 1; c >= d; ++d)o[$9ae5e4a12de151f5$var$zl[d] >>> a] = u;
    } else for(o = new $9ae5e4a12de151f5$var$Al(s), n = 0; s > n; ++n)o[n] = $9ae5e4a12de151f5$var$zl[l[t[n] - 1]++] >>> 15 - t[n];
    return o;
}, $9ae5e4a12de151f5$var$Wl = new $9ae5e4a12de151f5$var$Il(288);
for($9ae5e4a12de151f5$var$Hl = 0; 144 > $9ae5e4a12de151f5$var$Hl; ++$9ae5e4a12de151f5$var$Hl)$9ae5e4a12de151f5$var$Wl[$9ae5e4a12de151f5$var$Hl] = 8;
for($9ae5e4a12de151f5$var$Hl = 144; 256 > $9ae5e4a12de151f5$var$Hl; ++$9ae5e4a12de151f5$var$Hl)$9ae5e4a12de151f5$var$Wl[$9ae5e4a12de151f5$var$Hl] = 9;
for($9ae5e4a12de151f5$var$Hl = 256; 280 > $9ae5e4a12de151f5$var$Hl; ++$9ae5e4a12de151f5$var$Hl)$9ae5e4a12de151f5$var$Wl[$9ae5e4a12de151f5$var$Hl] = 7;
for($9ae5e4a12de151f5$var$Hl = 280; 288 > $9ae5e4a12de151f5$var$Hl; ++$9ae5e4a12de151f5$var$Hl)$9ae5e4a12de151f5$var$Wl[$9ae5e4a12de151f5$var$Hl] = 8;
var $9ae5e4a12de151f5$var$Gl = new $9ae5e4a12de151f5$var$Il(32);
for($9ae5e4a12de151f5$var$Hl = 0; 32 > $9ae5e4a12de151f5$var$Hl; ++$9ae5e4a12de151f5$var$Hl)$9ae5e4a12de151f5$var$Gl[$9ae5e4a12de151f5$var$Hl] = 5;
var $9ae5e4a12de151f5$var$Kl = $9ae5e4a12de151f5$var$Vl($9ae5e4a12de151f5$var$Wl, 9, 0), $9ae5e4a12de151f5$var$Jl = $9ae5e4a12de151f5$var$Vl($9ae5e4a12de151f5$var$Gl, 5, 0), $9ae5e4a12de151f5$var$Yl = function(t) {
    return (t / 8 | 0) + (7 & t && 1);
}, $9ae5e4a12de151f5$var$Xl = function(t, i, e) {
    (null == i || 0 > i) && (i = 0), (null == e || e > t.length) && (e = t.length);
    var s = new (t instanceof $9ae5e4a12de151f5$var$Al ? $9ae5e4a12de151f5$var$Al : t instanceof $9ae5e4a12de151f5$var$Ml ? $9ae5e4a12de151f5$var$Ml : $9ae5e4a12de151f5$var$Il)(e - i);
    return s.set(t.subarray(i, e)), s;
}, $9ae5e4a12de151f5$var$Ql = function(t, i, e) {
    var s = i / 8 | 0;
    t[s] |= e <<= 7 & i, t[s + 1] |= e >>> 8;
}, $9ae5e4a12de151f5$var$Zl = function(t, i, e) {
    var s = i / 8 | 0;
    t[s] |= e <<= 7 & i, t[s + 1] |= e >>> 8, t[s + 2] |= e >>> 16;
}, $9ae5e4a12de151f5$var$ta = function(t, i) {
    for(var e = [], s = 0; t.length > s; ++s)t[s] && e.push({
        s: s,
        f: t[s]
    });
    var n = e.length, r = e.slice();
    if (!n) return [
        new $9ae5e4a12de151f5$var$Il(0),
        0
    ];
    if (1 == n) {
        var o = new $9ae5e4a12de151f5$var$Il(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var l = e[0], a = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: l.f + a.f,
        l: l,
        r: a
    }; h != n - 1;)l = e[e[d].f > e[u].f ? u++ : d++], a = e[u != h && e[d].f > e[u].f ? u++ : d++], e[h++] = {
        s: -1,
        f: l.f + a.f,
        l: l,
        r: a
    };
    var c = r[0].s;
    for(s = 1; n > s; ++s)r[s].s > c && (c = r[s].s);
    var v = new $9ae5e4a12de151f5$var$Al(c + 1), f = $9ae5e4a12de151f5$var$ia(e[h - 1], v, 0);
    if (f > i) {
        s = 0;
        var p = 0, _ = f - i, g = 1 << _;
        for(r.sort(function(t, i) {
            return v[i.s] - v[t.s] || t.f - i.f;
        }); n > s; ++s){
            var m = r[s].s;
            if (i >= v[m]) break;
            p += g - (1 << f - v[m]), v[m] = i;
        }
        for(p >>>= _; p > 0;){
            var b = r[s].s;
            i > v[b] ? p -= 1 << i - v[b]++ - 1 : ++s;
        }
        for(; s >= 0 && p; --s){
            var y = r[s].s;
            v[y] == i && (--v[y], ++p);
        }
        f = i;
    }
    return [
        new $9ae5e4a12de151f5$var$Il(v),
        f
    ];
}, $9ae5e4a12de151f5$var$ia = function(t, i, e) {
    return -1 == t.s ? Math.max($9ae5e4a12de151f5$var$ia(t.l, i, e + 1), $9ae5e4a12de151f5$var$ia(t.r, i, e + 1)) : i[t.s] = e;
}, $9ae5e4a12de151f5$var$ea = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $9ae5e4a12de151f5$var$Al(++i), s = 0, n = t[0], r = 1, o = function(t) {
        e[s++] = t;
    }, l = 1; i >= l; ++l)if (t[l] == n && l != i) ++r;
    else {
        if (!n && r > 2) {
            for(; r > 138; r -= 138)o(32754);
            r > 2 && (o(r > 10 ? r - 11 << 5 | 28690 : r - 3 << 5 | 12305), r = 0);
        } else if (r > 3) {
            for(o(n), --r; r > 6; r -= 6)o(8304);
            r > 2 && (o(r - 3 << 5 | 8208), r = 0);
        }
        for(; r--;)o(n);
        r = 1, n = t[l];
    }
    return [
        e.subarray(0, s),
        i
    ];
}, $9ae5e4a12de151f5$var$sa = function(t, i) {
    for(var e = 0, s = 0; i.length > s; ++s)e += t[s] * i[s];
    return e;
}, $9ae5e4a12de151f5$var$na = function(t, i, e) {
    var s = e.length, n = $9ae5e4a12de151f5$var$Yl(i + 2);
    t[n] = 255 & s, t[n + 1] = s >>> 8, t[n + 2] = 255 ^ t[n], t[n + 3] = 255 ^ t[n + 1];
    for(var r = 0; s > r; ++r)t[n + r + 4] = e[r];
    return 8 * (n + 4 + s);
}, $9ae5e4a12de151f5$var$ra = function(t, i, e, s, n, r, o, l, a, u, h) {
    $9ae5e4a12de151f5$var$Ql(i, h++, e), ++n[256];
    for(var d = $9ae5e4a12de151f5$var$ta(n, 15), c = d[0], v = d[1], f = $9ae5e4a12de151f5$var$ta(r, 15), p = f[0], _ = f[1], g = $9ae5e4a12de151f5$var$ea(c), m = g[0], b = g[1], y = $9ae5e4a12de151f5$var$ea(p), w = y[0], S = y[1], x = new $9ae5e4a12de151f5$var$Al(19), E = 0; m.length > E; ++E)x[31 & m[E]]++;
    for(E = 0; w.length > E; ++E)x[31 & w[E]]++;
    for(var k = $9ae5e4a12de151f5$var$ta(x, 7), T = k[0], P = k[1], C = 19; C > 4 && !T[$9ae5e4a12de151f5$var$Nl[C - 1]]; --C);
    var O, R, I, A, M = u + 5 << 3, F = $9ae5e4a12de151f5$var$sa(n, $9ae5e4a12de151f5$var$Wl) + $9ae5e4a12de151f5$var$sa(r, $9ae5e4a12de151f5$var$Gl) + o, D = $9ae5e4a12de151f5$var$sa(n, c) + $9ae5e4a12de151f5$var$sa(r, p) + o + 14 + 3 * C + $9ae5e4a12de151f5$var$sa(x, T) + (2 * x[16] + 3 * x[17] + 7 * x[18]);
    if (F >= M && D >= M) return $9ae5e4a12de151f5$var$na(i, h, t.subarray(a, a + u));
    if ($9ae5e4a12de151f5$var$Ql(i, h, 1 + (F > D)), h += 2, F > D) {
        O = $9ae5e4a12de151f5$var$Vl(c, v, 0), R = c, I = $9ae5e4a12de151f5$var$Vl(p, _, 0), A = p;
        var N = $9ae5e4a12de151f5$var$Vl(T, P, 0);
        for($9ae5e4a12de151f5$var$Ql(i, h, b - 257), $9ae5e4a12de151f5$var$Ql(i, h + 5, S - 1), $9ae5e4a12de151f5$var$Ql(i, h + 10, C - 4), h += 14, E = 0; C > E; ++E)$9ae5e4a12de151f5$var$Ql(i, h + 3 * E, T[$9ae5e4a12de151f5$var$Nl[E]]);
        h += 3 * C;
        for(var j = [
            m,
            w
        ], L = 0; 2 > L; ++L){
            var B = j[L];
            for(E = 0; B.length > E; ++E)$9ae5e4a12de151f5$var$Ql(i, h, N[U = 31 & B[E]]), h += T[U], U > 15 && ($9ae5e4a12de151f5$var$Ql(i, h, B[E] >>> 5 & 127), h += B[E] >>> 12);
        }
    } else O = $9ae5e4a12de151f5$var$Kl, R = $9ae5e4a12de151f5$var$Wl, I = $9ae5e4a12de151f5$var$Jl, A = $9ae5e4a12de151f5$var$Gl;
    for(E = 0; l > E; ++E)if (s[E] > 255) {
        var U;
        $9ae5e4a12de151f5$var$Zl(i, h, O[257 + (U = s[E] >>> 18 & 31)]), h += R[U + 257], U > 7 && ($9ae5e4a12de151f5$var$Ql(i, h, s[E] >>> 23 & 31), h += $9ae5e4a12de151f5$var$Fl[U]);
        var z = 31 & s[E];
        $9ae5e4a12de151f5$var$Zl(i, h, I[z]), h += A[z], z > 3 && ($9ae5e4a12de151f5$var$Zl(i, h, s[E] >>> 5 & 8191), h += $9ae5e4a12de151f5$var$Dl[z]);
    } else $9ae5e4a12de151f5$var$Zl(i, h, O[s[E]]), h += R[s[E]];
    return $9ae5e4a12de151f5$var$Zl(i, h, O[256]), h + R[256];
}, $9ae5e4a12de151f5$var$oa = new $9ae5e4a12de151f5$var$Ml([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $9ae5e4a12de151f5$var$la = new $9ae5e4a12de151f5$var$Il(0), $9ae5e4a12de151f5$var$aa = function() {
    for(var t = new $9ae5e4a12de151f5$var$Ml(256), i = 0; 256 > i; ++i){
        for(var e = i, s = 9; --s;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $9ae5e4a12de151f5$var$ua = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function $9ae5e4a12de151f5$var$ha(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p (i) {
                for(var e = t, s = 0; i.length > s; ++s)e = $9ae5e4a12de151f5$var$aa[255 & e ^ i[s]] ^ e >>> 8;
                t = e;
            },
            d () {
                return 4294967295 ^ t;
            }
        };
    }(), s = t.length;
    e.p(t);
    var n, r, o, l, a, u, h = (l = 10 + ((n = i).filename && n.filename.length + 1 || 0), a = 8, function(t, i, e, s, n, r) {
        var o = t.length, l = new $9ae5e4a12de151f5$var$Il(s + o + 5 * (1 + Math.floor(o / 7e3)) + n), a = l.subarray(s, l.length - n), u = 0;
        if (!i || 8 > o) for(var h = 0; o >= h; h += 65535){
            var d = h + 65535;
            o > d ? u = $9ae5e4a12de151f5$var$na(a, u, t.subarray(h, d)) : (a[h] = r, u = $9ae5e4a12de151f5$var$na(a, u, t.subarray(h, o)));
        }
        else {
            for(var c = $9ae5e4a12de151f5$var$oa[i - 1], v = c >>> 13, f = 8191 & c, p = (1 << e) - 1, _ = new $9ae5e4a12de151f5$var$Al(32768), g = new $9ae5e4a12de151f5$var$Al(p + 1), m = Math.ceil(e / 3), b = 2 * m, y = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << b) & p;
            }, w = new $9ae5e4a12de151f5$var$Ml(25e3), S = new $9ae5e4a12de151f5$var$Al(288), x = new $9ae5e4a12de151f5$var$Al(32), E = 0, k = 0, T = (h = 0, 0), P = 0, C = 0; o > h; ++h){
                var O = y(h), R = 32767 & h, I = g[O];
                if (_[R] = I, g[O] = R, h >= P) {
                    var A = o - h;
                    if ((E > 7e3 || T > 24576) && A > 423) {
                        u = $9ae5e4a12de151f5$var$ra(t, a, 0, w, S, x, k, T, C, h - C, u), T = E = k = 0, C = h;
                        for(var M = 0; 286 > M; ++M)S[M] = 0;
                        for(M = 0; 30 > M; ++M)x[M] = 0;
                    }
                    var F = 2, D = 0, N = f, j = R - I & 32767;
                    if (A > 2 && O == y(h - j)) for(var L = Math.min(v, A) - 1, B = Math.min(32767, h), U = Math.min(258, A); B >= j && --N && R != I;){
                        if (t[h + F] == t[h + F - j]) {
                            for(var z = 0; U > z && t[h + z] == t[h + z - j]; ++z);
                            if (z > F) {
                                if (F = z, D = j, z > L) break;
                                var H = Math.min(j, z - 2), q = 0;
                                for(M = 0; H > M; ++M){
                                    var V = h - j + M + 32768 & 32767, W = V - _[V] + 32768 & 32767;
                                    W > q && (q = W, I = V);
                                }
                            }
                        }
                        j += (R = I) - (I = _[R]) + 32768 & 32767;
                    }
                    if (D) {
                        w[T++] = 268435456 | $9ae5e4a12de151f5$var$Bl[F] << 18 | $9ae5e4a12de151f5$var$Ul[D];
                        var G = 31 & $9ae5e4a12de151f5$var$Bl[F], K = 31 & $9ae5e4a12de151f5$var$Ul[D];
                        k += $9ae5e4a12de151f5$var$Fl[G] + $9ae5e4a12de151f5$var$Dl[K], ++S[257 + G], ++x[K], P = h + F, ++E;
                    } else w[T++] = t[h], ++S[t[h]];
                }
            }
            u = $9ae5e4a12de151f5$var$ra(t, a, r, w, S, x, k, T, C, h - C, u), r || (u = $9ae5e4a12de151f5$var$na(a, u, $9ae5e4a12de151f5$var$la));
        }
        return $9ae5e4a12de151f5$var$Xl(l, 0, s + $9ae5e4a12de151f5$var$Yl(u) + n);
    }(r = t, null == (o = i).level ? 6 : o.level, null == o.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(r.length)))) : 12 + o.mem, l, a, !u)), d = h.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = 2 > i.level ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $9ae5e4a12de151f5$var$ua(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var s = 0; e.length >= s; ++s)t[s + 10] = e.charCodeAt(s);
        }
    }(h, i), $9ae5e4a12de151f5$var$ua(h, d - 8, e.d()), $9ae5e4a12de151f5$var$ua(h, d - 4, s), h;
}
const $9ae5e4a12de151f5$var$da = !!$9ae5e4a12de151f5$var$o || !!$9ae5e4a12de151f5$var$r, $9ae5e4a12de151f5$var$ca = new WeakMap, $9ae5e4a12de151f5$var$va = "text/plain";
let $9ae5e4a12de151f5$var$fa = 0, $9ae5e4a12de151f5$var$pa = !1;
const $9ae5e4a12de151f5$var$_a = (t, i)=>{
    const [e, s] = t.split("#"), [n, r] = e.split("?");
    if (!r) return t;
    const o = r.split("&").filter((t)=>t.split("=")[0] !== i).join("&");
    return `${n}${o ? `?${o}` : ""}${s ? `#${s}` : ""}`;
}, $9ae5e4a12de151f5$var$ga = (t, i, e = !0)=>{
    var s;
    const [n, r] = t.split("?"), o = $9ae5e4a12de151f5$var$Ei({}, i), l = null !== (s = null == r ? void 0 : r.split("&").map((t)=>{
        var i;
        const [s, n] = t.split("="), r = e && null !== (i = o[s]) && void 0 !== i ? i : n;
        return delete o[s], `${s}=${r}`;
    })) && void 0 !== s ? s : [], a = function(t, i = "&") {
        let e, s;
        const n = [];
        return $9ae5e4a12de151f5$var$Vn(t, function(t, i) {
            $9ae5e4a12de151f5$var$R(t) || $9ae5e4a12de151f5$var$R(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), s = encodeURIComponent(i), n[n.length] = s + "=" + e);
        }), n.join(i);
    }(o);
    return a && l.push(a), l.length > 0 ? `${n}?${l.join("&")}` : n;
}, $9ae5e4a12de151f5$var$ma = (t)=>{
    if (t.sl) return t.sl;
    const { data: i, compression: e } = t;
    if (!i) return;
    if (e === $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS) {
        const t = $9ae5e4a12de151f5$var$ha(function(t) {
            var i = t.length;
            if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
            for(var e = new $9ae5e4a12de151f5$var$Il(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                e[s++] = t;
            }, r = 0; i > r; ++r){
                if (s + 5 > e.length) {
                    var o = new $9ae5e4a12de151f5$var$Il(s + 8 + (i - r << 1));
                    o.set(e), e = o;
                }
                var l = t.charCodeAt(r);
                128 > l ? n(l) : 2048 > l ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && 57344 > l ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++r)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
            }
            return $9ae5e4a12de151f5$var$Xl(e, 0, s);
        }($9ae5e4a12de151f5$var$Oo(i)), {
            mtime: 0
        });
        return {
            contentType: $9ae5e4a12de151f5$var$va,
            body: t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength),
            estimatedSize: t.byteLength
        };
    }
    if (e === $9ae5e4a12de151f5$export$6a00d17b5aff0af.Base64) {
        const t = function(t) {
            return t ? btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, (t, i)=>String.fromCharCode(parseInt(i, 16)))) : t;
        }($9ae5e4a12de151f5$var$Oo(i)), e = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $9ae5e4a12de151f5$var$Oo(t)))(t);
        return {
            contentType: "application/x-www-form-urlencoded",
            body: e,
            estimatedSize: new Blob([
                e
            ]).size
        };
    }
    const s = $9ae5e4a12de151f5$var$Oo(i);
    return {
        contentType: "application/json",
        body: s,
        estimatedSize: new Blob([
            s
        ]).size
    };
}, $9ae5e4a12de151f5$var$ba = (t)=>{
    const i = ()=>"sendBeacon" === t.transport ? {
            url: $9ae5e4a12de151f5$var$ga(t.url, {
                compression: $9ae5e4a12de151f5$export$6a00d17b5aff0af.Base64
            }),
            encodedBody: $9ae5e4a12de151f5$var$ma($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                compression: $9ae5e4a12de151f5$export$6a00d17b5aff0af.Base64,
                sl: void 0
            }))
        } : {
            url: $9ae5e4a12de151f5$var$_a(t.url, "compression"),
            encodedBody: $9ae5e4a12de151f5$var$ma($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                compression: void 0,
                sl: void 0
            }))
        };
    let e;
    try {
        e = $9ae5e4a12de151f5$var$ma(t);
    } catch (e) {
        if ($9ae5e4a12de151f5$var$ge(t.compression, $9ae5e4a12de151f5$var$Io(t.url, "compression"))) return $9ae5e4a12de151f5$var$Je.error("Failed to gzip request body, sending uncompressed payload", e), i();
        throw e;
    }
    var s;
    return e && $9ae5e4a12de151f5$var$ge(t.compression, $9ae5e4a12de151f5$var$Io(t.url, "compression")) && !((s = e.body) instanceof ArrayBuffer ? $9ae5e4a12de151f5$var$_e(new Uint8Array(s)) : ArrayBuffer.isView(s) && $9ae5e4a12de151f5$var$_e(new Uint8Array(s.buffer, s.byteOffset, s.byteLength))) ? ($9ae5e4a12de151f5$var$pa = !0, i()) : {
        url: t.url,
        encodedBody: e
    };
}, $9ae5e4a12de151f5$var$ya = (t)=>{
    try {
        return $9ae5e4a12de151f5$var$ba(t);
    } catch (e) {
        var i;
        return $9ae5e4a12de151f5$var$Je.error(e), void (null === (i = t.callback) || void 0 === i || i.call(t, {
            statusCode: 0,
            error: e
        }));
    }
}, $9ae5e4a12de151f5$var$wa = function() {
    var t = $9ae5e4a12de151f5$var$Y(function*(t) {
        const i = yield function(t) {
            return $9ae5e4a12de151f5$var$Se.apply(this, arguments);
        }($9ae5e4a12de151f5$var$Oo(t.data), $9ae5e4a12de151f5$var$es.DEBUG, {
            rethrow: !0
        });
        if (!i) return t;
        const e = yield i.arrayBuffer();
        return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            sl: {
                contentType: $9ae5e4a12de151f5$var$va,
                body: e,
                estimatedSize: e.byteLength
            }
        });
    });
    return function(i) {
        return t.apply(this, arguments);
    };
}(), $9ae5e4a12de151f5$var$$a = /Failed to fetch|NetworkError|Load failed/i, $9ae5e4a12de151f5$var$Sa = (t)=>"TypeError" === (null == t ? void 0 : t.name) && $9ae5e4a12de151f5$var$$a.test((null == t ? void 0 : t.message) || ""), $9ae5e4a12de151f5$var$xa = (t)=>{
    try {
        const i = function(t, i = Date.now()) {
            if ("string" != typeof t || !t) return;
            const e = t.trim(), s = /^\d+\s*,/.test(e) ? e.slice(0, e.indexOf(",")).trim() : e;
            if (/^\d+$/.test(s)) {
                const t = 1e3 * Math.min(Number(s), 300);
                return t > 0 ? t : void 0;
            }
            if (!/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun)[a-z]*[ ,]/.test(s)) return;
            const n = /^\w{3} \w{3} /.test(s) ? s + " GMT" : s, r = Date.parse(n) - i;
            return Number.isFinite(r) && r > 0 ? Math.min(r, $9ae5e4a12de151f5$var$ai) : void 0;
        }(t());
        return $9ae5e4a12de151f5$var$R(i) ? void 0 : Math.min(i, 3e4);
    } catch (t) {
        return;
    }
}, $9ae5e4a12de151f5$var$Ea = (t)=>{
    const i = $9ae5e4a12de151f5$var$ya(t);
    if (!i) return;
    const e = new $9ae5e4a12de151f5$var$o;
    $9ae5e4a12de151f5$var$ca.set(e, !0);
    const { url: s, encodedBody: n } = i;
    e.open(t.method || "GET", s, !0);
    const { contentType: r, body: l } = null != n ? n : {};
    $9ae5e4a12de151f5$var$Vn(t.headers, function(t, i) {
        e.setRequestHeader(i, t);
    }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), e.onreadystatechange = ()=>{
        if (4 === e.readyState) {
            var i;
            const s = {
                statusCode: e.status,
                text: e.responseText
            };
            if (200 === e.status) try {
                s.json = JSON.parse(e.responseText);
            } catch (t) {}
            null === (i = t.callback) || void 0 === i || i.call(t, s, $9ae5e4a12de151f5$var$xa(()=>e.getResponseHeader("Retry-After")));
        }
    }, e.send(l);
}, $9ae5e4a12de151f5$var$ka = (t)=>{
    const i = $9ae5e4a12de151f5$var$ya(t);
    if (!i) return;
    const { url: e, encodedBody: s } = i, { contentType: n, body: o, estimatedSize: a } = null != s ? s : {}, u = new Headers;
    $9ae5e4a12de151f5$var$Vn(t.headers, function(t, i) {
        u.append(i, t);
    }), n && u.append("Content-Type", n);
    let h = null, d = !1;
    if ($9ae5e4a12de151f5$var$l) {
        const i = new $9ae5e4a12de151f5$var$l;
        h = {
            signal: i.signal,
            timeout: setTimeout(()=>{
                d = !0;
                try {
                    i.abort($9ae5e4a12de151f5$var$ci("AbortError", "PostHog request timed out" + ((e = t.timeout) ? ` after ${e}ms` : "")));
                } catch (t) {
                    v(t);
                }
                var e;
            }, t.timeout)
        };
    }
    let c = !1;
    const v = (i)=>{
        var e;
        c || (c = !0, d && "AbortError" === (null == i ? void 0 : i.name) || $9ae5e4a12de151f5$var$Sa(i) ? $9ae5e4a12de151f5$var$Je.warn(i) : $9ae5e4a12de151f5$var$Je.error(i), null === (e = t.callback) || void 0 === e || e.call(t, {
            statusCode: 0,
            error: i
        }));
    };
    let f = 0;
    const p = ()=>{
        $9ae5e4a12de151f5$var$fa -= f, f = 0, h && clearTimeout(h.timeout);
    };
    try {
        const i = $9ae5e4a12de151f5$var$Ei({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: u,
            referrerPolicy: "strict-origin",
            body: o,
            signal: null == h ? void 0 : h.signal
        }, t.fetchOptions), s = null != a ? a : $9ae5e4a12de151f5$var$R(o) ? 0 : void 0;
        i.keepalive = "POST" === i.method && !t.rl && !1 !== i.keepalive && i.body === o && !$9ae5e4a12de151f5$var$R(s) && s >= 0 && 52428.8 > $9ae5e4a12de151f5$var$fa + s, i.keepalive && (f = s, $9ae5e4a12de151f5$var$fa += f), $9ae5e4a12de151f5$var$r(e, i).then((i)=>i.text().then((e)=>{
                var s;
                if (c) return;
                const n = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    n.json = JSON.parse(e);
                } catch (t) {
                    $9ae5e4a12de151f5$var$Je.error(t);
                }
                c = !0, p(), null === (s = t.callback) || void 0 === s || s.call(t, n, $9ae5e4a12de151f5$var$xa(()=>i.headers.get("Retry-After")));
            })).catch((t)=>{
            p(), v(t);
        }).finally(p);
    } catch (t) {
        p(), v(t);
    }
}, $9ae5e4a12de151f5$var$Ta = (t)=>{
    try {
        var i;
        const { url: s, encodedBody: n } = $9ae5e4a12de151f5$var$ba(t), { contentType: o, body: l, estimatedSize: a } = null != n ? n : {};
        if (!l) return;
        const u = l instanceof Blob ? l : new Blob([
            l
        ], {
            type: o
        });
        if ($9ae5e4a12de151f5$var$e.sendBeacon(s, u)) return;
        const h = $9ae5e4a12de151f5$var$T(t.data) ? t.data : null === (i = t.data) || void 0 === i ? void 0 : i.batch;
        if ($9ae5e4a12de151f5$var$T(h) && h.length > 1 && (null != a ? a : 0) > 16384) {
            const i = Math.ceil(h.length / 2), e = (i)=>$9ae5e4a12de151f5$var$T(t.data) ? i : $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t.data), {}, {
                    batch: i
                });
            return $9ae5e4a12de151f5$var$Ta($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                data: e(h.slice(0, i))
            })), void $9ae5e4a12de151f5$var$Ta($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                data: e(h.slice(i))
            }));
        }
        $9ae5e4a12de151f5$var$Je.warn(`Beacon of ~${null != a ? a : 0} bytes was rejected by the browser, falling back to ${$9ae5e4a12de151f5$var$r ? "fetch" : "XHR"}`), $9ae5e4a12de151f5$var$r ? $9ae5e4a12de151f5$var$ka($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            rl: !0
        })) : $9ae5e4a12de151f5$var$Ea(t);
    } catch (t) {
        $9ae5e4a12de151f5$var$Je.warn("Beacon send failed", t);
    }
}, $9ae5e4a12de151f5$var$Pa = (t, i, e, s)=>{
    const n = "query" === s ? "POST" === i ? "sent_at" : "_" : void 0;
    return $9ae5e4a12de151f5$var$ga(e === $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS ? $9ae5e4a12de151f5$var$_a(t, "compression") : t, $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, n ? {
        [n]: Date.now().toString()
    } : {}), e === $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS ? {} : {
        compression: e
    }));
}, $9ae5e4a12de151f5$var$Ca = (()=>{
    const t = [];
    return $9ae5e4a12de151f5$var$r && t.push({
        transport: "fetch",
        method: $9ae5e4a12de151f5$var$ka
    }), $9ae5e4a12de151f5$var$o && t.push({
        transport: "XHR",
        method: $9ae5e4a12de151f5$var$Ea
    }), (null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.sendBeacon) && t.push({
        transport: "sendBeacon",
        method: $9ae5e4a12de151f5$var$Ta
    }), t;
})();
let $9ae5e4a12de151f5$var$Oa = !$9ae5e4a12de151f5$var$da && -1 === (null == $9ae5e4a12de151f5$var$u ? void 0 : $9ae5e4a12de151f5$var$u.indexOf("MSIE")) && -1 === (null == $9ae5e4a12de151f5$var$u ? void 0 : $9ae5e4a12de151f5$var$u.indexOf("Mozilla"));
function $9ae5e4a12de151f5$var$Ra(t, i, e) {
    var s, n, r;
    e && (i = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), {}, {
        callback: (t)=>e(t)
    })), t.__loaded ? $9ae5e4a12de151f5$var$Oa ? t.__request_queue.push(i) : t.rateLimiter.isServerRateLimited(i.batchKey) ? i.fireCallbackOnDrop && (null === (n = i.callback) || void 0 === n || n.call(i, {
        statusCode: 429
    })) : (i.transport = i.transport || t.config.api_transport, i.headers = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t.config.request_headers), i.headers), i.compression = "best-available" === i.compression ? null !== (s = t.compression) && void 0 !== s ? s : i.compressionFallback : i.compression, ($9ae5e4a12de151f5$var$R(t.config.disable_beacon) ? t.config.__preview_disable_beacon : t.config.disable_beacon) && (i.disableTransport = [
        "sendBeacon"
    ]), i.fetchOptions = i.fetchOptions || t.config.fetch_options, ((t, i)=>{
        var e, s, n;
        const r = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            callback: null != i ? i : (i)=>{
                var e;
                return null === (e = t.callback) || void 0 === e ? void 0 : e.call(t, i);
            }
        });
        r.timeout = r.timeout || 6e4;
        const o = null !== (e = r.transport) && void 0 !== e ? e : "fetch";
        "sendBeacon" === o && $9ae5e4a12de151f5$var$R(r.compression) && r.data && (r.compression = $9ae5e4a12de151f5$export$6a00d17b5aff0af.Base64), "POST" === r.method && r.data && ("capture-body" === r.timestampMode ? r.data = ((t)=>{
            var i, e;
            const s = ($9ae5e4a12de151f5$var$T(t) ? t : [
                t
            ]).map((t)=>$9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), t.timestamp instanceof Date && !isNaN(t.timestamp.getTime()) ? {
                    timestamp: t.timestamp.toISOString()
                } : {})), n = s[0];
            return {
                api_key: null !== (i = null == n || null === (e = n.properties) || void 0 === e ? void 0 : e.token) && void 0 !== i ? i : null == n ? void 0 : n.token,
                batch: s,
                sent_at: (new Date).toISOString()
            };
        })(r.data) : "body" === r.timestampMode && (r.data = ((t, i = (new Date).toISOString())=>$9ae5e4a12de151f5$var$T(t) ? t.map((t)=>$9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                    sent_at: i
                })) : $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                sent_at: i
            }))(r.data))), r.url = $9ae5e4a12de151f5$var$Pa(r.url, r.method, r.compression, r.timestampMode);
        const l = $9ae5e4a12de151f5$var$Ca.filter((t)=>!r.disableTransport || !t.transport || !r.disableTransport.includes(t.transport)), u = null !== (s = null === (n = function(t, i) {
            for(let e = 0; t.length > e; e++)if (i(t[e])) return t[e];
        }(l, (t)=>t.transport === o)) || void 0 === n ? void 0 : n.method) && void 0 !== s ? s : l[0].method;
        if (!u) throw new Error("No available transport method");
        const h = (t)=>{
            try {
                u(t);
            } catch (t) {
                var i;
                $9ae5e4a12de151f5$var$Sa(t) ? $9ae5e4a12de151f5$var$Je.warn(t) : $9ae5e4a12de151f5$var$Je.error(t), null === (i = r.callback) || void 0 === i || i.call(r, {
                    statusCode: 0,
                    error: t
                });
            }
        };
        "sendBeacon" !== o && !r.preferSyncCompression && r.data && r.compression === $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS && $9ae5e4a12de151f5$var$a && "undefined" != typeof Promise && !$9ae5e4a12de151f5$var$pa ? $9ae5e4a12de151f5$var$wa(r).then((t)=>{
            h(t);
        }).catch((i)=>{
            if ($9ae5e4a12de151f5$var$me(i)) return $9ae5e4a12de151f5$var$pa = !0, void h($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, r), {}, {
                compression: void 0,
                url: $9ae5e4a12de151f5$var$Pa(t.url, t.method, void 0, t.timestampMode)
            }));
            ((t)=>{
                if (!t || "object" != typeof t) return !1;
                const i = "name" in t ? String(t.name) : "";
                return $9ae5e4a12de151f5$var$me(t) || i === $9ae5e4a12de151f5$var$pe;
            })(i) && ($9ae5e4a12de151f5$var$pa = !0), h(r);
        }) : h(r);
    })(i, (s, n)=>{
        var r, o, l;
        t.rateLimiter.checkForLimiting(s), 400 > s.statusCode || null === (r = (o = t.config).on_request_error) || void 0 === r || r.call(o, s), e ? e(s, n) : null === (l = i.callback) || void 0 === l || l.call(i, s);
    })) : i.fireCallbackOnDrop && (null === (r = i.callback) || void 0 === r || r.call(i, {
        statusCode: 0
    }));
}
var $9ae5e4a12de151f5$var$Ia = class {
    constructor(t, i){
        this.ol = !0, this.al = [], this.ll = $9ae5e4a12de151f5$var$Z((null == i ? void 0 : i.flush_interval_ms) || 3e3, 250, 5e3, $9ae5e4a12de151f5$var$Je.createLogger("flush interval"), 3e3), this.ul = t;
    }
    enqueue(t) {
        this.al.push(t), this.hl || this.cl();
    }
    unload() {
        this.dl();
        const t = this.al.length > 0 ? this.vl() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.fl(t, "sendBeacon");
        });
    }
    enable() {
        this.ol = !1, this.cl();
    }
    cl() {
        this.ol || (this.hl = setTimeout(()=>{
            if (this.dl(), this.al.length > 0) {
                const t = this.vl();
                for(const i in t)this.fl(t[i]);
            }
        }, this.ll));
    }
    fl(t, i) {
        try {
            this.ul(t, i);
        } catch (t) {
            $9ae5e4a12de151f5$var$Je.error(t);
        }
    }
    dl() {
        clearTimeout(this.hl), this.hl = void 0;
    }
    vl() {
        const t = {};
        return $9ae5e4a12de151f5$var$Vn(this.al, (i)=>{
            var e;
            const s = i, n = ((s ? s.batchKey : null) || s.url) + (s.batchGroup ? `:${s.batchGroup}` : "");
            $9ae5e4a12de151f5$var$R(t[n]) && (t[n] = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), {}, {
                data: []
            })), null === (e = t[n].data) || void 0 === e || e.push(s.data);
        }), this.al = [], t;
    }
};
const $9ae5e4a12de151f5$var$Aa = [
    "retriesPerformedSoFar"
];
var $9ae5e4a12de151f5$var$Ma = class {
    constructor(t){
        this._instance = t, this.pl = !1, this.gl = 3e3, this.al = [], this.al = [], this.ml = !0, this.resume();
    }
    resume() {
        if (!$9ae5e4a12de151f5$var$R($9ae5e4a12de151f5$var$t) && "onLine" in $9ae5e4a12de151f5$var$t.navigator) {
            if (this.ml = $9ae5e4a12de151f5$var$t.navigator.onLine, this.yl) return;
            this.yl = ()=>{
                this.ml = !0, this.bl();
            }, this._l = ()=>{
                this.ml = !1;
            }, $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "online", this.yl), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "offline", this._l);
        }
    }
    get length() {
        return this.al.length;
    }
    retriableRequest(t, i) {
        let { retriesPerformedSoFar: e } = t, s = $9ae5e4a12de151f5$var$xe(t, $9ae5e4a12de151f5$var$Aa);
        $9ae5e4a12de151f5$var$N(e) && (s.url = $9ae5e4a12de151f5$var$ga(s.url, {
            retry_count: e
        })), $9ae5e4a12de151f5$var$Ra(this._instance, i ? $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), {}, {
            transport: i
        }) : s, (t, i)=>{
            var n;
            if (200 !== t.statusCode && (400 > t.statusCode || t.statusCode >= 500)) {
                if ((0 === t.statusCode ? 3 : 10) > (null != e ? e : 0)) return void this.Ls($9ae5e4a12de151f5$var$Ei({
                    retriesPerformedSoFar: e
                }, s), i);
                0 === t.statusCode && $9ae5e4a12de151f5$var$Je.warn(`Request failed before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped retrying after ${null != e ? e : 0} retries.`);
            }
            null === (n = s.callback) || void 0 === n || n.call(s, t);
        });
    }
    Ls(t, i) {
        const e = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = e + 1;
        const s = Math.max(function(t) {
            const i = 3e3 * Math.pow(2, t), e = i / 2, s = Math.min(18e5, i), n = (Math.random() - .5) * (s - e);
            return Math.ceil(s + n);
        }(e), null != i ? i : 0), n = Date.now() + s;
        this.al.push({
            retryAt: n,
            requestOptions: t
        });
        let r = `Enqueued failed request for retry in ${s}`;
        navigator.onLine || (r += " (Browser is offline)"), $9ae5e4a12de151f5$var$Je.warn(r), this.pl || (this.pl = !0, this.wl());
    }
    wl() {
        if (this.kl && clearTimeout(this.kl), 0 === this.al.length) return this.pl = !1, void (this.kl = void 0);
        this.kl = setTimeout(()=>{
            this.ml && this.al.length > 0 && this.bl(), this.wl();
        }, this.gl);
    }
    bl() {
        const t = Date.now(), i = [], e = this.al.filter((e)=>t > e.retryAt || (i.push(e), !1));
        if (this.al = i, e.length > 0) for (const { requestOptions: t } of e)this.retriableRequest(t);
    }
    unload() {
        this.kl && (clearTimeout(this.kl), this.kl = void 0), this.pl = !1, $9ae5e4a12de151f5$var$R($9ae5e4a12de151f5$var$t) || (this.yl && ($9ae5e4a12de151f5$var$t.removeEventListener("online", this.yl), this.yl = void 0), this._l && ($9ae5e4a12de151f5$var$t.removeEventListener("offline", this._l), this._l = void 0));
        for (const { requestOptions: t } of this.al)try {
            this._instance._send_request($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $9ae5e4a12de151f5$var$Je.error(t);
        }
        this.al = [];
    }
}, $9ae5e4a12de151f5$var$Fa = class {
    constructor(t){
        this._instance = t, this.Sl = ()=>{
            var t, i, e, s;
            this.xl || (this.xl = {});
            const n = this.scrollElement(), r = this.scrollY(), o = n ? Math.max(0, n.scrollHeight - n.clientHeight) : 0, l = r + ((null == n ? void 0 : n.clientHeight) || 0), a = (null == n ? void 0 : n.scrollHeight) || 0;
            this.xl.lastScrollY = Math.ceil(r), this.xl.maxScrollY = Math.max(r, null !== (t = this.xl.maxScrollY) && void 0 !== t ? t : 0), this.xl.maxScrollHeight = Math.max(o, null !== (i = this.xl.maxScrollHeight) && void 0 !== i ? i : 0), this.xl.lastContentY = l, this.xl.maxContentY = Math.max(l, null !== (e = this.xl.maxContentY) && void 0 !== e ? e : 0), this.xl.maxContentHeight = Math.max(a, null !== (s = this.xl.maxContentHeight) && void 0 !== s ? s : 0);
        };
    }
    get Cl() {
        return this._instance.config.scroll_root_selector;
    }
    getContext() {
        return this.xl;
    }
    resetContext() {
        const t = this.xl;
        return this.xl = void 0, setTimeout(this.Sl, 0), t;
    }
    startMeasuringScrollPosition() {
        $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "scroll", this.Sl, {
            capture: !0
        }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "scrollend", this.Sl, {
            capture: !0
        }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "resize", this.Sl);
    }
    scrollElement() {
        if (this.Cl) {
            const e = $9ae5e4a12de151f5$var$T(this.Cl) ? this.Cl : [
                this.Cl
            ];
            for (const s of e){
                var i;
                const e = null == $9ae5e4a12de151f5$var$t || null === (i = $9ae5e4a12de151f5$var$t.document) || void 0 === i ? void 0 : i.querySelector(s);
                if (e) return e;
            }
            return;
        }
        var e;
        return null == $9ae5e4a12de151f5$var$t || null === (e = $9ae5e4a12de151f5$var$t.document) || void 0 === e ? void 0 : e.documentElement;
    }
    $l(i) {
        var e, s;
        const n = "y" === i ? "scrollTop" : "scrollLeft";
        if (this.Cl) {
            const t = this.scrollElement();
            return t && t[n] || 0;
        }
        return $9ae5e4a12de151f5$var$t ? "y" === i ? $9ae5e4a12de151f5$var$t.scrollY || $9ae5e4a12de151f5$var$t.pageYOffset || (null === (e = $9ae5e4a12de151f5$var$t.document) || void 0 === e || null === (e = e.documentElement) || void 0 === e ? void 0 : e.scrollTop) || 0 : $9ae5e4a12de151f5$var$t.scrollX || $9ae5e4a12de151f5$var$t.pageXOffset || (null === (s = $9ae5e4a12de151f5$var$t.document) || void 0 === s || null === (s = s.documentElement) || void 0 === s ? void 0 : s.scrollLeft) || 0 : 0;
    }
    scrollY() {
        return this.$l("y");
    }
    scrollX() {
        return this.$l("x");
    }
};
const $9ae5e4a12de151f5$var$Da = (t)=>$9ae5e4a12de151f5$var$Ko(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties, null == t ? void 0 : t.config.disable_capture_url_hashes);
var $9ae5e4a12de151f5$var$Na = class {
    constructor(t, i, e, s){
        this.Be = (t)=>{
            const i = this.Tl();
            if (i && i.sessionId === t) return;
            const e = {
                sessionId: t,
                props: this.Il(this._instance)
            };
            this.Ml.register({
                [$9ae5e4a12de151f5$var$fn]: e
            });
        }, this._instance = t, this.El = i, this.Ml = e, this.Il = s || $9ae5e4a12de151f5$var$Da, this.El.onSessionId(this.Be);
    }
    Tl() {
        return this.Ml.props[$9ae5e4a12de151f5$var$fn];
    }
    getSetOnceProps() {
        var t;
        const i = null === (t = this.Tl()) || void 0 === t ? void 0 : t.props;
        return i ? "r" in i ? $9ae5e4a12de151f5$var$Jo(i, this._instance.config.disable_capture_url_hashes) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        const t = {};
        return $9ae5e4a12de151f5$var$Vn($9ae5e4a12de151f5$var$Jn(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t[`$session_entry_${$9ae5e4a12de151f5$var$w(e)}`] = i;
        }), t;
    }
}, $9ae5e4a12de151f5$var$ja = class {
    on(t, i) {
        return this.Pl[t] || (this.Pl[t] = []), this.Pl[t].push(i), ()=>{
            this.Pl[t] = this.Pl[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (const e of this.Pl[t] || [])e(i);
        for (const e of this.Pl["*"] || [])e(t, i);
    }
    constructor(){
        this.Pl = {};
    }
};
const $9ae5e4a12de151f5$var$La = $9ae5e4a12de151f5$var$Ye("[SessionId]"), $9ae5e4a12de151f5$var$Ba = 864e5;
var $9ae5e4a12de151f5$var$Ua = class {
    on(t, i) {
        return this.Rl.on(t, i);
    }
    constructor(t, i, e){
        var s;
        if (this.Al = null, this.Fl = null, this.Ol = [], this.Dl = void 0, this.Ll = !1, this.Rl = new $9ae5e4a12de151f5$var$ja, this.Nl = (t, i)=>!(!$9ae5e4a12de151f5$var$N(t) || !$9ae5e4a12de151f5$var$N(i)) && Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.Rr = t.config, this.Ml = t.persistence, this.He = void 0, this.Xt = void 0, this._sessionStartTimestamp = null, this.ql = void 0, this._sessionActivityTimestamp = null, this.jl = i || $9ae5e4a12de151f5$var$lr, this.Bl = e || $9ae5e4a12de151f5$var$lr;
        const n = this.Rr.persistence_name || this.Rr.token;
        if (this._sessionTimeoutMs = 1e3 * $9ae5e4a12de151f5$var$Z(this.Rr.session_idle_timeout_seconds || 1800, 60, 36e3, $9ae5e4a12de151f5$var$La.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Hl(), this.zl = "ph_" + n + "_window_id", this.Ul = "ph_" + n + "_primary_window_exists", this.Wl()) {
            const t = $9ae5e4a12de151f5$var$Pr.Dt(this.zl), i = $9ae5e4a12de151f5$var$Pr.Dt(this.Ul);
            t && !i ? this.He = t : $9ae5e4a12de151f5$var$Pr.Lt(this.zl), $9ae5e4a12de151f5$var$Pr.At(this.Ul, !0);
        }
        (null === (s = this.Rr.bootstrap) || void 0 === s ? void 0 : s.sessionID) && this.setBootstrapSessionId(this.Rr.bootstrap.sessionID), this.Vl();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $9ae5e4a12de151f5$var$R(this.Ol) && (this.Ol = []), this.Ol.push(t), this.Xt && t(this.Xt, this.He), ()=>{
            this.Ol = this.Ol.filter((i)=>i !== t);
        };
    }
    Wl() {
        return "memory" !== this.Rr.persistence && !this.Ml.mi && $9ae5e4a12de151f5$var$Pr.Et();
    }
    Gl(t) {
        t !== this.He && (this.He = t, this.Wl() && $9ae5e4a12de151f5$var$Pr.At(this.zl, t));
    }
    Zl() {
        return this.He ? this.He : this.Wl() ? $9ae5e4a12de151f5$var$Pr.Dt(this.zl) : null;
    }
    Ql(t) {
        const i = this.Al;
        return !$9ae5e4a12de151f5$var$M(i) && !$9ae5e4a12de151f5$var$M(t) && 5e3 > Math.abs(t - i);
    }
    Jl(t, i, e) {
        const s = i !== this._sessionActivityTimestamp, n = !(t !== this.Xt || e !== this._sessionStartTimestamp);
        this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.Xt = t, n && !s || n && this.Ql(i) || (this.Al = i, this.Ml.register({
            [$9ae5e4a12de151f5$var$Rs]: [
                i,
                t,
                e
            ]
        }));
    }
    Kl() {
        var t;
        const i = null === (t = this.Rr) || void 0 === t ? void 0 : t.persistence_save_debounce_ms;
        return $9ae5e4a12de151f5$var$N(i) && i > 0;
    }
    Xl() {
        this.Kl() ? this.Ml.refreshKey($9ae5e4a12de151f5$var$Rs) : (this.Ml.flush(), this.Ml.load());
    }
    Yl() {
        var t;
        if ($9ae5e4a12de151f5$var$M(this._sessionActivityTimestamp) || this._sessionActivityTimestamp === this.Al) return;
        this.Xl();
        const [, i, e] = this.tu();
        i === this.Xt && e === this._sessionStartTimestamp && (this.Al = this._sessionActivityTimestamp, this.Ml.register({
            [$9ae5e4a12de151f5$var$Rs]: [
                this._sessionActivityTimestamp,
                null !== (t = this.Xt) && void 0 !== t ? t : null,
                this._sessionStartTimestamp
            ]
        }), this.Ml.flush());
    }
    eu() {
        const [t] = this.tu(), i = $9ae5e4a12de151f5$var$N(t) ? t : 0, e = $9ae5e4a12de151f5$var$N(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
        return Math.max(i, e);
    }
    iu(t) {
        return this.Xl(), this.Nl(t, this.eu());
    }
    tu() {
        const t = this.Ml.props[$9ae5e4a12de151f5$var$Rs];
        return $9ae5e4a12de151f5$var$T(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Al = null, this.ql = void 0, clearTimeout(this.nu), this.nu = void 0, this.Jl(null, null, null);
    }
    setBootstrapSessionId(t, i = !1) {
        const e = ((t, i = (new Date).getTime())=>{
            try {
                const e = ((t)=>{
                    const i = t.replace(/-/g, "");
                    if (32 !== i.length) throw new Error("Not a valid UUID");
                    if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                    return parseInt(i.substring(0, 12), 16);
                })(t);
                return e > i + 6e4 ? void $9ae5e4a12de151f5$var$La.error("Bootstrap sessionID cannot be in the future") : e;
            } catch (t) {
                return void $9ae5e4a12de151f5$var$La.error("Invalid sessionID in bootstrap", t);
            }
        })(t);
        return !$9ae5e4a12de151f5$var$R(e) && (i ? this.ql = {
            sessionId: t,
            sessionStartTimestamp: e
        } : this.Jl(t, (new Date).getTime(), e), !0);
    }
    destroy() {
        this.Ll = !0, this.Yl(), clearTimeout(this.nu), this.nu = void 0, this.Dl && $9ae5e4a12de151f5$var$t && ($9ae5e4a12de151f5$var$t.removeEventListener($9ae5e4a12de151f5$var$Ln, this.Dl, {
            capture: !1
        }), this.Dl = void 0), this.Ol = [];
    }
    Vl() {
        this.Dl = ()=>{
            this.Yl(), this.Wl() && $9ae5e4a12de151f5$var$Pr.Lt(this.Ul);
        }, $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, $9ae5e4a12de151f5$var$Ln, this.Dl, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t = !1, i = null, e = !1) {
        if ("always" === this.Rr.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        const s = i || (new Date).getTime(), n = this.Xt;
        if (e) this.Fl = s;
        else if ($9ae5e4a12de151f5$var$M(this.Fl) || this.Fl > s || s - this.Fl >= 1e3) {
            var r, o;
            null === (r = (o = this.Ml).syncCookieProperties) || void 0 === r || r.call(o), this.Fl = s;
        }
        let [, l, a] = this.tu();
        const u = !$9ae5e4a12de151f5$var$R(n) && l !== n, h = this.eu();
        let d = this.Zl();
        const c = this.ql, v = !!c && (c.sessionStartTimestamp > s + 6e4 || s - c.sessionStartTimestamp > $9ae5e4a12de151f5$var$Ba), f = c ? v : $9ae5e4a12de151f5$var$N(a) && Math.abs(s - a) > $9ae5e4a12de151f5$var$Ba;
        let p = !1, _ = u, g = !l || !!c;
        const m = l;
        let b = !g && !t && this.Nl(s, h);
        if (b && (b = this.iu(s), b || $9ae5e4a12de151f5$var$La.info("cross-tab refresh kept the session alive", {
            sessionId: l
        }), [, l, a] = this.tu(), b || (g = !l || !!c)), g || b || f) {
            _ = !1;
            const t = c && !v;
            l = t ? c.sessionId : this.jl(), d = this.Bl(), $9ae5e4a12de151f5$var$La.info("new session ID assigned", {
                sessionId: l,
                windowId: d,
                bootstrapped: !!t,
                changeReason: {
                    noSessionId: g,
                    activityTimeout: b,
                    sessionPastMaximumLength: f
                }
            }), a = t ? c.sessionStartTimestamp : s, this.ql = void 0, p = !0;
        } else d || (d = this.Bl(), p = !0), _ = _ || l !== m, _ && ($9ae5e4a12de151f5$var$La.info("adopted cross-tab session id", {
            sessionId: l,
            windowId: d
        }), p = !0);
        const y = $9ae5e4a12de151f5$var$N(h) && t && !f ? h : s, w = $9ae5e4a12de151f5$var$N(a) ? a : (new Date).getTime();
        this.Gl(d), this.Jl(l, y, w), t || this.Hl();
        const S = {
            noSessionId: g,
            activityTimeout: b,
            sessionPastMaximumLength: f,
            crossTabAdoption: _
        };
        return p && this.Ol.forEach((t)=>t(l, d, S)), {
            sessionId: l,
            windowId: d,
            sessionStartTimestamp: w,
            changeReason: p ? S : void 0,
            lastActivityTimestamp: h
        };
    }
    Hl() {
        this.Ll || (clearTimeout(this.nu), this.nu = setTimeout(()=>{
            if (!this.Ll) {
                if (this.iu((new Date).getTime())) {
                    const t = this.Xt;
                    this.resetSessionId(), this.Rl.emit("forcedIdleReset", {
                        idleSessionId: t
                    });
                } else this.Hl();
            }
        }, 1.1 * this.sessionTimeoutMs));
    }
};
const $9ae5e4a12de151f5$var$za = function(t, i) {
    if (!t) return !1;
    const e = t.userAgent;
    if (e && $9ae5e4a12de151f5$var$Q(e, i)) return !0;
    try {
        const e = null == t ? void 0 : t.userAgentData;
        if ((null == e ? void 0 : e.brands) && e.brands.some((t)=>$9ae5e4a12de151f5$var$Q(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
};
function $9ae5e4a12de151f5$var$Ha() {
    return ($9ae5e4a12de151f5$var$Ha = $9ae5e4a12de151f5$var$Y(function*() {
        const t = null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.userAgentData;
        if (null == t ? void 0 : t.getHighEntropyValues) try {
            const i = yield t.getHighEntropyValues([
                "model"
            ]), e = null == i ? void 0 : i.model;
            return $9ae5e4a12de151f5$var$I(e) && e.length > 0 ? e : void 0;
        } catch (t) {
            return void $9ae5e4a12de151f5$var$Je.info("Unable to resolve $device_model from userAgentData.getHighEntropyValues", t);
        }
    })).apply(this, arguments);
}
function $9ae5e4a12de151f5$var$qa(t, i) {
    let e = `$survey_${i}/${t.id}`;
    return t.current_iteration && t.current_iteration > 0 && (e = `$survey_${i}/${t.id}/${t.current_iteration}`), e;
}
function $9ae5e4a12de151f5$var$Va(t) {
    var i;
    return !!(null === (i = t.conditions) || void 0 === i || null === (i = i.events) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length);
}
const $9ae5e4a12de151f5$var$Wa = (t, i)=>{
    if (!((t)=>{
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    })(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
}, $9ae5e4a12de151f5$var$Ga = (t)=>t.toLowerCase(), $9ae5e4a12de151f5$var$Ka = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$9ae5e4a12de151f5$var$Wa(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$9ae5e4a12de151f5$var$Wa(i, t))),
    icontains: (t, i)=>i.map($9ae5e4a12de151f5$var$Ga).some((i)=>t.map($9ae5e4a12de151f5$var$Ga).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($9ae5e4a12de151f5$var$Ga).every((i)=>t.map($9ae5e4a12de151f5$var$Ga).every((t)=>!i.includes(t))),
    gt: (t, i)=>i.some((i)=>{
            const e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e > parseFloat(t));
        }),
    lt: (t, i)=>i.some((i)=>{
            const e = parseFloat(i);
            return !isNaN(e) && t.some((t)=>e < parseFloat(t));
        })
};
function $9ae5e4a12de151f5$var$Ja(t, i) {
    return !t || Object.entries(t).every(([t, e])=>{
        const s = null == i ? void 0 : i[t];
        if (null == s) return !1;
        const n = $9ae5e4a12de151f5$var$Ka[e.operator];
        return !!n && n(e.values.map(String), [
            String(s)
        ]);
    });
}
function $9ae5e4a12de151f5$var$Ya(t, i, e) {
    return $9ae5e4a12de151f5$var$Oo({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
const $9ae5e4a12de151f5$var$Xa = "custom", $9ae5e4a12de151f5$var$Qa = "i.posthog.com", $9ae5e4a12de151f5$var$Za = /^\/static\//, $9ae5e4a12de151f5$var$tu = [
    "/s/",
    "/e/",
    "/i/"
];
var $9ae5e4a12de151f5$var$iu = class {
    constructor(t){
        this.su = {}, this.instance = t;
    }
    get apiHost() {
        const t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        const t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t;
        let i = null === (t = this.instance.config.ui_host) || void 0 === t ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace(`.${$9ae5e4a12de151f5$var$Qa}`, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.su[this.apiHost] || (this.su[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : $9ae5e4a12de151f5$var$Xa), this.su[this.apiHost];
    }
    ru(t) {
        if (!$9ae5e4a12de151f5$var$Za.test(t)) return;
        const i = this.instance.config.asset_host;
        return "string" == typeof i && i.trim().replace(/\/$/, "") || void 0;
    }
    ou(t) {
        const i = $9ae5e4a12de151f5$var$Ro(t);
        return i ? i.protocol + "//" + i.host + i.pathname : void 0;
    }
    au(t, i, e) {
        if ("ui" === t) return e;
        let s = e;
        const n = this.instance.config.rewriteRequestPath;
        if (n) {
            var r;
            const t = (null === (r = $9ae5e4a12de151f5$var$Ro(e)) || void 0 === r ? void 0 : r.href) || e;
            s = n(new URL(t)).toString();
        }
        if (n && "api" === t && $9ae5e4a12de151f5$var$tu.some((t)=>0 === i.indexOf(t))) {
            const t = this.ou(s);
            if (t) {
                const i = this.apiHost;
                let e = this.lu;
                (null == e ? void 0 : e.apiHost) === i && e.rewriteRequestPath === n || (e = {
                    apiHost: i,
                    rewriteRequestPath: n,
                    urls: new Set
                }, this.lu = e), e.urls.add(t);
            }
        }
        return s;
    }
    isIngestionEndpoint(t) {
        const i = this.lu, e = this.ou(t);
        return (null == i ? void 0 : i.apiHost) === this.apiHost && i.rewriteRequestPath === this.instance.config.rewriteRequestPath && !!e && i.urls.has(e);
    }
    endpointFor(t, i = "") {
        if (i && (i = "/" === i[0] ? i : `/${i}`), "ui" === t) return this.au(t, i, this.uiHost + i);
        if ("flags" === t) return this.au(t, i, this.flagsApiHost + i);
        if ("assets" === t) {
            const e = this.ru(i);
            if (e) return this.au(t, i, `${e}${i}`);
        }
        if (this.region === $9ae5e4a12de151f5$var$Xa) return this.au(t, i, this.apiHost + i);
        const e = $9ae5e4a12de151f5$var$Qa + i;
        switch(t){
            case "assets":
                return this.au(t, i, `https://${this.region}-assets.${e}`);
            case "api":
                return this.au(t, i, `https://${this.region}.${e}`);
        }
    }
};
const $9ae5e4a12de151f5$var$eu = $9ae5e4a12de151f5$var$Ye("[Surveys]"), $9ae5e4a12de151f5$var$su = (t)=>{
    try {
        const i = ((t)=>((t, i)=>`seenSurvey_${function(t) {
                    return t.current_iteration && t.current_iteration > 0 ? `${t.id}_${t.current_iteration}` : t.id;
                }(i)}`)(0, t))(t);
        if (localStorage.getItem(i)) return;
        localStorage.setItem(i, "true");
    } catch (t) {
        $9ae5e4a12de151f5$var$eu.error("Failed to persist survey seen state", t);
    }
}, $9ae5e4a12de151f5$var$nu = [
    $9ae5e4a12de151f5$export$22779822dd24228f.Popover,
    $9ae5e4a12de151f5$export$22779822dd24228f.Widget,
    $9ae5e4a12de151f5$export$22779822dd24228f.API
], $9ae5e4a12de151f5$var$ru = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $9ae5e4a12de151f5$export$a8a66d9d1b857494.Popover
}, $9ae5e4a12de151f5$var$ou = $9ae5e4a12de151f5$var$Ye("[PostHog ExternalIntegrations]"), $9ae5e4a12de151f5$var$lu = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
var $9ae5e4a12de151f5$var$au = class {
    constructor(t){
        this._instance = t;
    }
    zo(t, i) {
        var e, s;
        null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, t, (t)=>{
            if (t) return $9ae5e4a12de151f5$var$ou.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t;
        for (const [n, r] of Object.entries(null !== (t = this._instance.config.integrations) && void 0 !== t ? t : {})){
            var i, e, s;
            r && !(null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i || null === (i = i.integrations) || void 0 === i ? void 0 : i[n]) && this.zo($9ae5e4a12de151f5$var$lu[n], ()=>{
                var t;
                null === (t = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === t || null === (t = t.integrations) || void 0 === t || null === (t = t[n]) || void 0 === t || t.start(this._instance);
            }), !r && (null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (e = e.integrations) || void 0 === e ? void 0 : e[n]) && (null === (s = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === s || null === (s = s.integrations) || void 0 === s || null === (s = s[n]) || void 0 === s || s.stop());
        }
    }
}, $9ae5e4a12de151f5$var$uu = class {
    constructor(t, i){
        this.$ = t, this.wo = i, this.uu = new Map, this.Io = !1;
    }
    add(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            if (i.Io) throw new Error("Cannot add an extension to a disposed ExtensionRuntime");
            if (i.uu.has(t.name)) throw new Error(`Browser extension "${t.name}" is already registered`);
            i.uu.set(t.name, t);
            try {
                const e = t.setup(i.wo);
                e && (yield e);
            } catch (e) {
                const s = i.uu.get(t.name) === t;
                s && i.uu.delete(t.name), i.$.error(`Failed to set up browser extension "${t.name}"`, e), s && i.hu(t);
            }
        })();
    }
    getExtension(t) {
        return this.uu.get(t);
    }
    dispose() {
        if (this.Io) return;
        this.Io = !0;
        const t = Array.from(this.uu.values()).reverse();
        this.uu.clear();
        for (const i of t)this.hu(i);
    }
    hu(t) {
        try {
            var i;
            const e = null === (i = t.dispose) || void 0 === i ? void 0 : i.call(t);
            e && $9ae5e4a12de151f5$var$P(e.then) && e.then(void 0, (i)=>{
                this.$.error(`Failed to dispose browser extension "${t.name}"`, i);
            });
        } catch (i) {
            this.$.error(`Failed to dispose browser extension "${t.name}"`, i);
        }
    }
}, $9ae5e4a12de151f5$var$hu = class {
    constructor(t){
        this._instance = t;
    }
    initialize() {}
    get(t) {
        const i = this._instance.persistence;
        if ("string" == typeof t) return null == i ? void 0 : i.get_property(t);
        const e = {};
        for (const s of t){
            const t = null == i ? void 0 : i.get_property(s);
            $9ae5e4a12de151f5$var$R(t) || (e[s] = t);
        }
        return e;
    }
    set(t, i) {
        var e;
        null === (e = this._instance.persistence) || void 0 === e || e.register("string" == typeof t ? {
            [t]: i
        } : t);
    }
    remove(t) {
        var i;
        null === (i = this._instance.persistence) || void 0 === i || i.unregister(t);
    }
};
const $9ae5e4a12de151f5$var$du = "extensionsRemoteConfig";
var $9ae5e4a12de151f5$var$cu = class {
    constructor(t){
        this.instance = t, this.Io = !1, this.$ = $9ae5e4a12de151f5$var$Je, this.cu = t.du, this.kv = new $9ae5e4a12de151f5$var$hu(t), this.onEvent = (t)=>$9ae5e4a12de151f5$var$Sl(this.instance.on("eventCaptured", (i)=>{
                try {
                    t({
                        event: i.event,
                        properties: i.properties
                    });
                } catch (t) {
                    this.$.error("Browser extension event listener failed", t);
                }
            })), this.onRemoteConfig = (t)=>{
            if (this.Io) return $9ae5e4a12de151f5$var$Sl(()=>{});
            const i = (i)=>{
                try {
                    t(i);
                } catch (t) {
                    this.$.error("Browser extension remote config listener failed", t);
                }
            }, e = this.instance.vu.on($9ae5e4a12de151f5$var$du, i);
            return this.cu && i(this.cu), $9ae5e4a12de151f5$var$Sl(e);
        }, this.fu = new $9ae5e4a12de151f5$var$uu($9ae5e4a12de151f5$var$Je.createLogger("[BrowserExtensions]"), this);
    }
    get logger() {
        return this.$;
    }
    get distinctId() {
        return this.instance.get_distinct_id();
    }
    get anonymousId() {
        var t;
        return null !== (t = this.instance.get_property("$device_id")) && void 0 !== t ? t : this.distinctId;
    }
    get deviceId() {
        const t = this.instance.get_property($9ae5e4a12de151f5$var$rs);
        return "string" == typeof t ? t : void 0;
    }
    get library() {
        return {
            name: $9ae5e4a12de151f5$var$es.LIB_NAME,
            version: $9ae5e4a12de151f5$var$es.LIB_VERSION
        };
    }
    get initialPersonProperties() {
        var t, i;
        return null !== (t = null === (i = this.instance.persistence) || void 0 === i ? void 0 : i.get_initial_props()) && void 0 !== t ? t : {};
    }
    get groups() {
        return this.instance.getGroups();
    }
    get session() {
        try {
            var t, i, e, s;
            const n = null === (t = this.instance.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0);
            return {
                sessionId: null !== (i = null == n ? void 0 : n.sessionId) && void 0 !== i ? i : "",
                windowId: null !== (e = null == n ? void 0 : n.windowId) && void 0 !== e ? e : "",
                sessionStartTimestamp: null !== (s = null == n ? void 0 : n.sessionStartTimestamp) && void 0 !== s ? s : 0
            };
        } catch (t) {
            return {
                sessionId: "",
                windowId: "",
                sessionStartTimestamp: 0
            };
        }
    }
    get canCapture() {
        return this.instance.is_capturing();
    }
    get projectToken() {
        return this.instance.config.token;
    }
    add(t) {
        return this.fu.add(t);
    }
    getExtension(t) {
        return this.fu.getExtension(t);
    }
    capture(t, i, e) {
        e ? this.instance.capture(t, i, {
            timestamp: e.timestamp,
            uuid: e.uuid,
            $set: e.set,
            $set_once: e.setOnce
        }) : this.instance.capture(t, i);
    }
    registerDynamicEventProperties(t) {
        return $9ae5e4a12de151f5$var$Sl(this.instance.pu(t));
    }
    handleRemoteConfig(t) {
        this.Io || (this.cu = t, this.instance.vu.emit($9ae5e4a12de151f5$var$du, t));
    }
    sendRequest(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*(t, e = {}) {
            var s;
            const n = i.instance.requestRouter.endpointFor(null !== (s = e.target) && void 0 !== s ? s : "api", t), r = {
                method: e.method,
                url: e.query ? $9ae5e4a12de151f5$var$ga(n, e.query) : n,
                data: e.body,
                headers: e.headers,
                timeout: e.timeoutMs,
                fireCallbackOnDrop: !0,
                transport: e.transport,
                compression: e.compression,
                compressionFallback: "flags" === e.target && "best-available" === e.compression ? $9ae5e4a12de151f5$var$_.Base64 : void 0,
                timestampMode: e.sentAt
            };
            return "sendBeacon" === e.transport ? (i.instance._send_request(r), {
                statusCode: 202
            }) : new Promise((t)=>{
                r.callback = t, i.instance._send_request(r);
            });
        }).apply(this, arguments);
    }
    dispose() {
        this.Io || (this.Io = !0, this.fu.dispose());
    }
};
const $9ae5e4a12de151f5$var$vu = {};
let $9ae5e4a12de151f5$var$fu = 0;
const $9ae5e4a12de151f5$var$pu = ()=>{}, $9ae5e4a12de151f5$var$_u = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', $9ae5e4a12de151f5$var$gu = "Surveys module not available", $9ae5e4a12de151f5$var$mu = "sanitize_properties is deprecated. Use before_send instead", $9ae5e4a12de151f5$var$bu = "Invalid value for property_denylist config: ", $9ae5e4a12de151f5$var$yu = /^[A-Za-z0-9_-]{1,400}$/, $9ae5e4a12de151f5$var$wu = /^fb\.[0-9]+\.[0-9]+\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)?$/, $9ae5e4a12de151f5$var$$u = /^fb\.[0-9]+\.[0-9]+\.[0-9]+$/, $9ae5e4a12de151f5$var$Su = [
    "token",
    "distinct_id",
    $9ae5e4a12de151f5$var$wn
], $9ae5e4a12de151f5$var$xu = "posthog", $9ae5e4a12de151f5$var$Eu = (t)=>{
    const i = {};
    return t && "unset" !== t ? ("2025-11-30" > t || (i.strictMinimumDuration = !0), "2026-05-30" > t || (i.canvasCapture = {
        resolutionScale: .6
    }), "2026-06-25" > t || (i.streamNetworkBody = !0), "2026-08-30" > t || (i.captureJsonLd = !0), i) : i;
}, $9ae5e4a12de151f5$var$ku = (i)=>{
    var e;
    return $9ae5e4a12de151f5$var$Ei({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        asset_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $9ae5e4a12de151f5$var$Qn(null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $9ae5e4a12de151f5$var$pu,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        __preview_deferred_init_extensions: !1,
        __preview_external_dependency_versioned_paths: !1,
        __preview_cookie_wins_on_conflict: !1,
        debug: $9ae5e4a12de151f5$var$n && $9ae5e4a12de151f5$var$I(null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.search) && -1 !== $9ae5e4a12de151f5$var$n.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disableDeviceModel: !1,
        reuseAnonymousId: !1,
        disable_external_dependency_loading: !1,
        strict_script_versioning: "fallback",
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $9ae5e4a12de151f5$var$t || null === (e = $9ae5e4a12de151f5$var$t.location) || void 0 === e ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_feature_flags_dedup_per_session: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        feature_flag_request_max_retries: 1,
        surveys_request_timeout_ms: 1e4,
        on_request_error (t) {
            $9ae5e4a12de151f5$var$Je.error("Bad HTTP status: " + t.statusCode + " " + t.text);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: $9ae5e4a12de151f5$var$Nn,
        before_send: void 0,
        get_current_url: void 0,
        request_queue_config: {
            flush_interval_ms: 3e3
        },
        error_tracking: {},
        _onCapture: $9ae5e4a12de151f5$var$pu
    }, ((t)=>({
            rageclick: t && t >= "2026-05-30" ? {
                content_ignorelist: $9ae5e4a12de151f5$var$Kr,
                ignore_text_selection: !0
            } : !t || "2025-11-30" > t || {
                content_ignorelist: !0
            },
            capture_pageview: !t || "2025-05-24" > t || "history_change",
            session_recording: $9ae5e4a12de151f5$var$Eu(t),
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0,
            persistence_save_debounce_ms: t && t >= "2026-05-30" ? 250 : 0,
            split_storage: !(!t || "2026-05-30" > t),
            detect_google_search_app: !(!t || "2026-05-30" > t),
            disable_capture_url_hashes: !(!t || "2026-06-25" > t),
            cookieWinsOnConflict: !(!t || "unset" === t || "2026-08-29" > t)
        }))(i));
}, $9ae5e4a12de151f5$var$Tu = [
    [
        "process_person",
        "person_profiles"
    ],
    [
        "xhr_headers",
        "request_headers"
    ],
    [
        "cookie_name",
        "persistence_name"
    ],
    [
        "disable_cookie",
        "disable_persistence"
    ],
    [
        "__preview_disable_beacon",
        "disable_beacon"
    ],
    [
        "store_google",
        "save_campaign_params"
    ],
    [
        "verbose",
        "debug"
    ],
    [
        "__preview_cookie_wins_on_conflict",
        "cookieWinsOnConflict"
    ]
], $9ae5e4a12de151f5$var$Pu = (t)=>{
    const i = {};
    for (const [e, s] of $9ae5e4a12de151f5$var$Tu)$9ae5e4a12de151f5$var$R(t[e]) || (i[s] = t[e]);
    const e = $9ae5e4a12de151f5$var$Wn({}, i, t), s = t.__preview_external_dependency_versioned_paths;
    return $9ae5e4a12de151f5$var$R(s) || ($9ae5e4a12de151f5$var$R(t.strict_script_versioning) && (e.strict_script_versioning = !!s), $9ae5e4a12de151f5$var$I(s) && $9ae5e4a12de151f5$var$R(t.asset_host) && (e.asset_host = s)), $9ae5e4a12de151f5$var$T(t.property_blacklist) && ($9ae5e4a12de151f5$var$R(t.property_denylist) ? e.property_denylist = t.property_blacklist : $9ae5e4a12de151f5$var$T(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $9ae5e4a12de151f5$var$Je.error($9ae5e4a12de151f5$var$bu + t.property_denylist)), e;
};
var $9ae5e4a12de151f5$var$Cu = class {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get gu() {
        return this.__forceAllowLocalhost;
    }
    set gu(t) {
        $9ae5e4a12de151f5$var$Je.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}, $9ae5e4a12de151f5$export$a9d6b9cbf49b8241 = class i {
    mu(t) {
        if (!t) return;
        const i = this.uu.indexOf(t);
        -1 !== i && this.uu.splice(i, 1);
    }
    yu(t, i) {
        var e;
        return this.mu(t), this.uu.push(i), null === (e = i.initialize) || void 0 === e || e.call(i), i;
    }
    bu() {
        return "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isRejected();
    }
    _u() {
        if (this.wu) return;
        if (this.config.reuseAnonymousId) return;
        if (this.config.segment) return;
        if (this.bu()) return;
        const t = "memory" === this.config.persistence || "sessionStorage" === this.config.persistence;
        if (!t && !this.config.disable_persistence) return;
        if (this.ku) return;
        let i, e, s;
        t ? (i = `persistence is set to '${this.config.persistence}'`, e = "memory" === this.config.persistence ? "on every page load" : "for every new browser tab or window", s = "Either set persistence to 'localStorage+cookie', keep this persistence and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId.") : (i = "persistence is disabled (disable_persistence is true)", e = "on every page load", s = "Either set disable_persistence to false, keep persistence disabled and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId."), this.wu = !0, console.warn("[PostHog.js]", `${i} but no bootstrap.distinctID was provided. PostHog will mint a new distinct ID ${e}, so calling identify() merges a new ID onto the person each time. A person can then pass the distinct-ID limit and its events stop appearing on person pages and the session tab. ${s}`);
    }
    Su() {
        if (this.bu() || "$posthog_cookieless" !== this.get_distinct_id()) return;
        const t = this.persistence;
        if (!t) return;
        this.xu() || t.load(!0);
        const i = this.get_distinct_id();
        if (!i || "$posthog_cookieless" === i) {
            const i = this.config.get_device_id($9ae5e4a12de151f5$var$lr());
            this.register({
                distinct_id: i,
                $device_id: i
            }), t.set_property($9ae5e4a12de151f5$var$vn, $9ae5e4a12de151f5$var$Fn);
        }
        this.Cu();
    }
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null === (i = this.featureFlags) || void 0 === i ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null === (i = this.featureFlags) || void 0 === i ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        var t;
        this.$u = !1, this.Tu = !1, this.webPerformance = new $9ae5e4a12de151f5$var$Cu, this.Iu = !1, this.version = $9ae5e4a12de151f5$var$es.LIB_VERSION, this.Mu = new Set, this.Eu = "", this.vu = new $9ae5e4a12de151f5$var$ja, this.uu = [], this.Pu = [], this.ku = !1, this.wu = !1, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $9ae5e4a12de151f5$var$ku(), this.SentryIntegration = $9ae5e4a12de151f5$var$xo, this.sentryIntegration = (t)=>(function(t, i) {
                const e = $9ae5e4a12de151f5$var$So(t, i);
                return {
                    name: $9ae5e4a12de151f5$var$$o,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Ru = !1, this.Au = null, this.Fu = null, this.Ou = null, this.scrollManager = new $9ae5e4a12de151f5$var$Fa(this), this.pageViewManager = new $9ae5e4a12de151f5$var$Eo(this), this.rateLimiter = new $9ae5e4a12de151f5$var$Pl(this), this.requestRouter = new $9ae5e4a12de151f5$var$iu(this), this.consent = new $9ae5e4a12de151f5$var$Cr(this), this.externalIntegrations = new $9ae5e4a12de151f5$var$au(this);
        const e = null !== (t = i.__defaultExtensionClasses) && void 0 !== t ? t : {};
        this.featureFlags = e.featureFlags && new e.featureFlags(this), this.toolbar = e.toolbar && new e.toolbar(this), this.surveys = e.surveys && new e.surveys(this), this.conversations = e.conversations && new e.conversations(this), this.logs = e.logs && new e.logs(this), this.metrics = e.metrics && new e.metrics(this), this.experiments = e.experiments && new e.experiments(this), this.exceptions = e.exceptions && new e.exceptions(this), this.people = {
            set: (t, i, e)=>{
                const s = $9ae5e4a12de151f5$var$I(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(s), null == e || e({});
            },
            set_once: (t, i, e)=>{
                const s = $9ae5e4a12de151f5$var$I(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, s), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$9ae5e4a12de151f5$var$Je.info(`send "${null == t ? void 0 : t.event}"`, t));
    }
    init(t, e, s) {
        if (s && s !== $9ae5e4a12de151f5$var$xu) {
            var n;
            const r = null !== (n = $9ae5e4a12de151f5$var$vu[s]) && void 0 !== n ? n : new i;
            return r._init(t, e, s), $9ae5e4a12de151f5$var$vu[s] = r, $9ae5e4a12de151f5$var$vu[$9ae5e4a12de151f5$var$xu][s] = r, r;
        }
        return this._init(t, e, s);
    }
    _init(i, e = {}, s) {
        var n, r, o;
        const l = $9ae5e4a12de151f5$var$I(i) ? i.trim() : "";
        if (!l) return $9ae5e4a12de151f5$var$Je.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        var a;
        if (this.__loaded) return l !== (null === (a = this.config) || void 0 === a ? void 0 : a.token) ? console.warn("[PostHog.js]", `You have already initialized PostHog with a different project token! Re-initializing is a no-op, so events will keep going to the project this instance was initialized with. To capture into a second project, load PostHog once, then initialize a named instance after the SDK has loaded, e.g. posthog.init('${l}', { ... }, 'project2')`) : console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = $9ae5e4a12de151f5$var$ku(e.defaults), e.debug = this.Du(e.debug), this.Lu = e, this.Nu = [], e.person_profiles ? this.Fu = e.person_profiles : e.process_person && (this.Fu = e.process_person);
        const u = $9ae5e4a12de151f5$var$ku(e.defaults), h = $9ae5e4a12de151f5$var$Pu(e), d = $9ae5e4a12de151f5$var$Wn({}, u, h, {
            name: s,
            token: l
        });
        $9ae5e4a12de151f5$var$C(u.rageclick) && $9ae5e4a12de151f5$var$C(h.rageclick) && (d.rageclick = $9ae5e4a12de151f5$var$Wn({}, u.rageclick, h.rageclick)), $9ae5e4a12de151f5$var$C(u.session_recording) && $9ae5e4a12de151f5$var$C(h.session_recording) && (d.session_recording = $9ae5e4a12de151f5$var$Wn({}, u.session_recording, h.session_recording)), this.set_config(d), this.config.on_xhr_error && $9ae5e4a12de151f5$var$Je.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS;
        const c = this.xu();
        if (this.persistence = new $9ae5e4a12de151f5$var$hl(this.config, c), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $9ae5e4a12de151f5$var$hl($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, this.config), {}, {
            persistence: "sessionStorage"
        }), c, !1), this.Eu = "ph_" + (this.config.persistence_name || this.config.token) + "_session_registered_properties", "memory" !== this.config.persistence && !c && $9ae5e4a12de151f5$var$Pr.Et()) {
            const t = $9ae5e4a12de151f5$var$Pr.Dt(this.Eu);
            $9ae5e4a12de151f5$var$T(t) && t.forEach((t)=>{
                $9ae5e4a12de151f5$var$I(t) && this.Mu.add(t);
            });
        } else $9ae5e4a12de151f5$var$Pr.Lt(this.Eu);
        const v = $9ae5e4a12de151f5$var$Ei({}, this.persistence.props), f = $9ae5e4a12de151f5$var$Ei({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.qu = new $9ae5e4a12de151f5$var$Ia((t, i)=>this.ju(t, i), this.config.request_queue_config), this.Bu = new $9ae5e4a12de151f5$var$Ma(this), this.__request_queue = [];
        const p = this.bu();
        p || (this.sessionManager = new $9ae5e4a12de151f5$var$Ua(this), this.sessionPropsManager = new $9ae5e4a12de151f5$var$Na(this, this.sessionManager, this.persistence), this.sessionManager.onSessionId((t, i, e)=>{
            ((null == e ? void 0 : e.activityTimeout) || (null == e ? void 0 : e.sessionPastMaximumLength) || (null == e ? void 0 : e.crossTabAdoption)) && this.Hu();
        })), this.zu(), this.config.__preview_deferred_init_extensions ? ($9ae5e4a12de151f5$var$Je.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.Uu(p);
        }, 0)) : ($9ae5e4a12de151f5$var$Je.info("Initializing extensions synchronously"), this.Uu(p)), $9ae5e4a12de151f5$var$es.DEBUG = $9ae5e4a12de151f5$var$es.DEBUG || this.config.debug, $9ae5e4a12de151f5$var$es.DEBUG && $9ae5e4a12de151f5$var$Je.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $9ae5e4a12de151f5$var$Ei({}, this.config),
            p: v,
            s: f
        }), this.config.identity_distinct_id && !(null === (n = e.bootstrap) || void 0 === n ? void 0 : n.distinctID) && (e.bootstrap = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e.bootstrap), {}, {
            distinctID: this.config.identity_distinct_id,
            isIdentifiedID: !0
        }));
        const _ = null === (r = e.bootstrap) || void 0 === r ? void 0 : r.distinctID;
        if (this.ku = !!_ && !$9ae5e4a12de151f5$var$A(_), null === (o = e.bootstrap) || void 0 === o ? void 0 : o.distinctID) {
            const t = e.bootstrap.distinctID, i = this.get_distinct_id(), s = this.persistence.get_property($9ae5e4a12de151f5$var$vn);
            if (e.bootstrap.isIdentifiedID && null != i && i !== t && "anonymous" === s) this.identify(t);
            else if (e.bootstrap.isIdentifiedID && null != i && i !== t && "identified" === s) $9ae5e4a12de151f5$var$Je.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
            else {
                const i = this.config.get_device_id($9ae5e4a12de151f5$var$lr()), s = e.bootstrap.isIdentifiedID ? i : t;
                this.persistence.set_property($9ae5e4a12de151f5$var$vn, e.bootstrap.isIdentifiedID ? $9ae5e4a12de151f5$var$Dn : $9ae5e4a12de151f5$var$Fn), this.register({
                    distinct_id: t,
                    $device_id: s
                });
            }
        }
        if (p) this.register_once({
            distinct_id: $9ae5e4a12de151f5$var$yn,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            const t = this.config.get_device_id($9ae5e4a12de151f5$var$lr());
            this.register_once({
                distinct_id: t,
                $device_id: t
            }, ""), this.persistence.set_property($9ae5e4a12de151f5$var$vn, $9ae5e4a12de151f5$var$Fn);
        }
        return $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "pageshow", ()=>{
            var t;
            this.$u = !1, this.Tu || null === (t = this.Bu) || void 0 === t || t.resume();
        }), e.segment ? $9ae5e4a12de151f5$var$wo(this, ()=>this.Wu()) : this.Wu(), $9ae5e4a12de151f5$var$P(this.config._onCapture) && this.config._onCapture !== $9ae5e4a12de151f5$var$pu && ($9ae5e4a12de151f5$var$Je.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $9ae5e4a12de151f5$var$Je.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this.config.disableDeviceModel || (function() {
            return $9ae5e4a12de151f5$var$Ha.apply(this, arguments);
        })().then((t)=>{
            t && this.register({
                [$9ae5e4a12de151f5$var$os]: t
            });
        }).catch($9ae5e4a12de151f5$var$pu), this;
    }
    Vu(t) {
        const i = t;
        return $9ae5e4a12de151f5$var$I(i.name) && $9ae5e4a12de151f5$var$P(i.setup);
    }
    Gu(t, i) {
        this.Vu(t) ? i.push(()=>{
            this.Zu().add(t).catch(()=>{
                var i;
                return null === (i = t.dispose) || void 0 === i ? void 0 : i.call(t);
            }).catch((i)=>{
                $9ae5e4a12de151f5$var$Je.error(`Failed to dispose browser extension "${t.name}"`, i);
            });
        }) : this.uu.push(t);
    }
    zu() {
        var t, e, s;
        const n = null !== (t = null === (e = this.config.__extensionClasses) || void 0 === e ? void 0 : e.featureFlags) && void 0 !== t ? t : null === (s = i.__defaultExtensionClasses) || void 0 === s ? void 0 : s.featureFlags;
        var r, o, l;
        n && (this.featureFlags && this.featureFlags instanceof n || (null === (r = this.Qu) || void 0 === r || r.call(this), this.Qu = void 0, this.featureFlags = new n(this)), $9ae5e4a12de151f5$var$P(this.featureFlags.onReloading) && $9ae5e4a12de151f5$var$P(this.featureFlags.setup) ? this.Qu || (this.Qu = this.featureFlags.onReloading(()=>{
            this.vu.emit("featureFlagsReloading", !0);
        }), this.Zu().add(this.featureFlags)) : null === (o = (l = this.featureFlags).initialize) || void 0 === o || o.call(l));
    }
    Uu(t) {
        const e = performance.now(), s = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i.__defaultExtensionClasses), this.config.__extensionClasses), n = [];
        var r, o, l, a, u, h, d;
        s.exceptions && this.uu.push(this.exceptions = null !== (r = this.exceptions) && void 0 !== r ? r : new s.exceptions(this)), s.historyAutocapture && this.uu.push(this.historyAutocapture = new s.historyAutocapture(this)), s.tracingHeaders && this.uu.push(this.tracingHeaders = new s.tracingHeaders(this)), s.siteApps && this.uu.push(this.siteApps = new s.siteApps(this)), s.sessionRecording && !t && this.uu.push(this.sessionRecording = new s.sessionRecording(this)), this.config.disable_scroll_properties || n.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), s.autocapture && this.Gu(this.autocapture = new s.autocapture(this), n), s.surveys && this.Gu(this.surveys = null !== (o = this.surveys) && void 0 !== o ? o : new s.surveys(this), n), s.logs && this.Gu(this.logs = null !== (l = this.logs) && void 0 !== l ? l : new s.logs(this), n), s.metrics && this.uu.push(this.metrics = null !== (a = this.metrics) && void 0 !== a ? a : new s.metrics(this)), s.conversations && this.uu.push(this.conversations = null !== (u = this.conversations) && void 0 !== u ? u : new s.conversations(this)), s.productTours && this.uu.push(this.productTours = new s.productTours(this)), s.heatmaps && this.uu.push(this.heatmaps = new s.heatmaps(this)), s.webVitalsAutocapture && this.uu.push(this.webVitalsAutocapture = new s.webVitalsAutocapture(this)), s.exceptionObserver && this.uu.push(this.exceptionObserver = new s.exceptionObserver(this)), s.deadClicksAutocapture && this.uu.push(this.deadClicksAutocapture = new s.deadClicksAutocapture(this, $9ae5e4a12de151f5$var$mo)), s.toolbar && this.uu.push(this.toolbar = null !== (h = this.toolbar) && void 0 !== h ? h : new s.toolbar(this)), s.experiments && this.uu.push(this.experiments = null !== (d = this.experiments) && void 0 !== d ? d : new s.experiments(this)), this.uu.forEach((t)=>{
            t.initialize && n.push(()=>{
                var i;
                null === (i = t.initialize) || void 0 === i || i.call(t);
            });
        }), n.push(()=>{
            if (this.Ju) {
                const t = this.Ju;
                this.Ju = void 0, this.uu.forEach((i)=>{
                    var e;
                    return null === (e = i.onRemoteConfig) || void 0 === e ? void 0 : e.call(i, t);
                });
            }
        }), this.Ku(n, e);
    }
    Ku(t, i) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions && performance.now() - i >= 30 && t.length > 0) return void setTimeout(()=>{
                this.Ku(t, i);
            }, 0);
            const e = t.shift();
            if (e) try {
                e();
            } catch (t) {
                $9ae5e4a12de151f5$var$Je.error("Error initializing extension:", t);
            }
        }
        const e = Math.round(performance.now() - i);
        this.register_for_session({
            [$9ae5e4a12de151f5$var$$n]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            [$9ae5e4a12de151f5$var$Sn]: e
        }), this.config.__preview_deferred_init_extensions && $9ae5e4a12de151f5$var$Je.info(`PostHog extensions initialized (${e}ms)`);
    }
    il(t) {
        var i;
        if (!$9ae5e4a12de151f5$var$s || !$9ae5e4a12de151f5$var$s.body) return $9ae5e4a12de151f5$var$Je.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.il(t);
        }, 500);
        if (this.config.__preview_deferred_init_extensions && (this.Ju = t), this.du = t, this.compression = void 0, t.ok) {
            var e;
            const i = t.config;
            i.supportedCompression && !this.config.disable_compression && (this.compression = $9ae5e4a12de151f5$var$b(i.supportedCompression, $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS) ? $9ae5e4a12de151f5$export$6a00d17b5aff0af.GZipJS : $9ae5e4a12de151f5$var$b(i.supportedCompression, $9ae5e4a12de151f5$export$6a00d17b5aff0af.Base64) ? $9ae5e4a12de151f5$export$6a00d17b5aff0af.Base64 : void 0), (null === (e = i.analytics) || void 0 === e ? void 0 : e.endpoint) && (this.analyticsDefaultEndpoint = i.analytics.endpoint);
        }
        this.set_config({
            person_profiles: this.Fu ? this.Fu : $9ae5e4a12de151f5$var$Nn
        }), null === (i = this.Xu) || void 0 === i || i.handleRemoteConfig(t), this.uu.forEach((i)=>{
            var e;
            return null === (e = i.onRemoteConfig) || void 0 === e ? void 0 : e.call(i, t);
        });
    }
    Wu() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $9ae5e4a12de151f5$var$Je.critical("`loaded` function failed", t);
        }
        if (this.Yu(), this.config.internal_or_test_user_hostname && (null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.hostname)) {
            const t = $9ae5e4a12de151f5$var$n.hostname, i = this.config.internal_or_test_user_hostname;
            ("string" == typeof i ? t === i : i.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || this.bu()) && this.th();
        }, 1), this.eh = new $9ae5e4a12de151f5$var$Ol(this), this.eh.load();
    }
    Yu() {
        var t;
        this.is_capturing() && this.config.request_batching && (null === (t = this.qu) || void 0 === t || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $9ae5e4a12de151f5$var$qn(this.__request_queue, (t)=>this.ju(t)), this.__request_queue = [], this.Yu();
    }
    _handle_unload() {
        var t, i, e, s, n, r;
        this.$u = !0, null === (t = this.surveys) || void 0 === t || null === (i = t.handlePageUnload) || void 0 === i || i.call(t), null === (e = this.metrics) || void 0 === e || e.flush("sendBeacon"), this.config.request_batching ? (this.ih() && this.capture($9ae5e4a12de151f5$var$Un), null === (s = this.logs) || void 0 === s || s.flushLogs("sendBeacon"), null === (n = this.qu) || void 0 === n || n.unload(), null === (r = this.Bu) || void 0 === r || r.unload()) : this.ih() && this.capture($9ae5e4a12de151f5$var$Un, null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        $9ae5e4a12de151f5$var$Ra(this, t);
    }
    ju(t, i) {
        this.Bu ? this.Bu.retriableRequest(t, i) : this._send_request(i ? $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
            transport: i
        }) : t);
    }
    _execute_array(t) {
        $9ae5e4a12de151f5$var$fu++;
        try {
            let i;
            const e = [], s = [], n = [];
            $9ae5e4a12de151f5$var$qn(t, (t)=>{
                if (t) {
                    if (i = t[0], $9ae5e4a12de151f5$var$T(i)) n.push(t);
                    else if ($9ae5e4a12de151f5$var$P(t)) try {
                        t.call(this);
                    } catch (i) {
                        $9ae5e4a12de151f5$var$Je.error("Error executing queued PostHog call", t, i);
                    }
                    else $9ae5e4a12de151f5$var$T(t) && "alias" === i ? e.push(t) : $9ae5e4a12de151f5$var$T(t) && -1 !== i.indexOf("capture") && $9ae5e4a12de151f5$var$P(this[i]) ? n.push(t) : s.push(t);
                }
            });
            const r = function(t, i) {
                $9ae5e4a12de151f5$var$qn(t, function(t) {
                    try {
                        if ($9ae5e4a12de151f5$var$T(t[0])) {
                            let e = i;
                            $9ae5e4a12de151f5$var$Vn(t, function(t) {
                                e = e[t[0]].apply(e, t.slice(1));
                            });
                        } else i[t[0]].apply(i, t.slice(1));
                    } catch (i) {
                        $9ae5e4a12de151f5$var$Je.error("Error executing queued PostHog call", t, i);
                    }
                });
            };
            r(e, this), r(s, this), r(n, this);
        } finally{
            $9ae5e4a12de151f5$var$fu--;
        }
    }
    push(t) {
        if ($9ae5e4a12de151f5$var$fu > 0 && $9ae5e4a12de151f5$var$T(t) && $9ae5e4a12de151f5$var$I(t[0])) {
            const e = i.prototype[t[0]];
            return void ($9ae5e4a12de151f5$var$P(e) && e.apply(this, t.slice(1)));
        }
        this._execute_array([
            t
        ]);
    }
    get nh() {
        return {
            property: $9ae5e4a12de151f5$var$us,
            persistenceKey: $9ae5e4a12de151f5$var$hs,
            cookieName: "_fbc",
            pattern: $9ae5e4a12de151f5$var$wu,
            register: (t, i)=>{
                var e;
                return null === (e = this.persistence) || void 0 === e ? void 0 : e.register({
                    [$9ae5e4a12de151f5$var$hs]: {
                        value: t,
                        delivered: i
                    }
                });
            },
            unregister: ()=>{
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.unregister($9ae5e4a12de151f5$var$hs);
            }
        };
    }
    get sh() {
        return {
            property: $9ae5e4a12de151f5$var$ds,
            persistenceKey: $9ae5e4a12de151f5$var$cs,
            cookieName: "_fbp",
            pattern: $9ae5e4a12de151f5$var$$u,
            register: (t, i)=>{
                var e;
                return null === (e = this.persistence) || void 0 === e ? void 0 : e.register({
                    [$9ae5e4a12de151f5$var$cs]: {
                        value: t,
                        delivered: i
                    }
                });
            },
            unregister: ()=>{
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.unregister($9ae5e4a12de151f5$var$cs);
            }
        };
    }
    rh(t) {
        var i;
        const e = null === (i = this.persistence) || void 0 === i ? void 0 : i.get_property(t.persistenceKey);
        return $9ae5e4a12de151f5$var$I(e) && t.pattern.test(e) ? {
            value: e,
            delivered: !1
        } : $9ae5e4a12de151f5$var$C(e) && $9ae5e4a12de151f5$var$I(e.value) && t.pattern.test(e.value) ? {
            value: e.value,
            delivered: !0 === e.delivered
        } : void 0;
    }
    oh(t, i, e) {
        return i === (null == e ? void 0 : e.value) ? {
            value: i,
            pending: !e.delivered
        } : (t.register(i, !1), {
            value: i,
            pending: !0
        });
    }
    ah(t) {
        if (!this.config.save_campaign_params || this.bu()) return;
        const i = $9ae5e4a12de151f5$var$ir(t.cookieName);
        return $9ae5e4a12de151f5$var$I(i) && t.pattern.test(i) ? i : void 0;
    }
    uh(t, i, e, s) {
        if (!this.persistence) return;
        const n = this.nh;
        this.persistence.refreshKey(n.persistenceKey);
        const r = this.rh(n);
        if (s) return void n.unregister();
        if (e) return $9ae5e4a12de151f5$var$I(i) && $9ae5e4a12de151f5$var$wu.test(i) ? this.oh(n, i, r) : void n.unregister();
        const o = $9ae5e4a12de151f5$var$I(t) && $9ae5e4a12de151f5$var$yu.test(t) ? t : void 0, l = this.ah(n);
        return l && ((t, i, e)=>{
            const s = t.split(".");
            if (i) return s[3] === i;
            if (!e) return !0;
            const n = e.value.split(".");
            return s[3] === n[3] || Number(s[2]) > Number(n[2]);
        })(l, o, r) ? this.oh(n, l, r) : o ? (null == r ? void 0 : r.value.split(".")[3]) === o ? {
            value: r.value,
            pending: !r.delivered
        } : this.oh(n, `fb.1.${Date.now()}.${o}`, r) : r ? {
            value: r.value,
            pending: !r.delivered
        } : void 0;
    }
    hh(t, i, e) {
        if (!this.persistence) return;
        const s = this.sh;
        this.persistence.refreshKey(s.persistenceKey);
        const n = this.rh(s);
        if (e) return void s.unregister();
        if (i) return $9ae5e4a12de151f5$var$I(t) && $9ae5e4a12de151f5$var$$u.test(t) ? this.oh(s, t, n) : void s.unregister();
        const r = this.ah(s);
        return r ? this.oh(s, r, n) : n ? {
            value: n.value,
            pending: !n.delivered
        } : void 0;
    }
    dh(t, i) {
        if (!this.persistence) return;
        this.persistence.refreshKey(t.persistenceKey);
        const e = this.rh(t);
        (null == e ? void 0 : e.value) !== i || e.delivered || t.register(i, !0);
    }
    capture(t, i, e) {
        var s, n;
        if (!(this.__loaded && this.persistence && this.sessionPersistence && this.qu)) return void $9ae5e4a12de151f5$var$Je.uninitializedWarning("posthog.capture");
        if (!this.is_capturing()) return;
        if ($9ae5e4a12de151f5$var$R(t) || !$9ae5e4a12de151f5$var$I(t)) return void $9ae5e4a12de151f5$var$Je.error("No event name provided to posthog.capture");
        this.Su();
        const r = !this.config.opt_out_useragent_filter && this._is_bot();
        if (r && !this.config.__preview_capture_bot_pageviews) return;
        const o = (null == e ? void 0 : e.skip_client_rate_limiting) ? void 0 : this.rateLimiter.clientRateLimitContext();
        if (null == o ? void 0 : o.isRateLimited) return void $9ae5e4a12de151f5$var$Je.critical("This capture call is ignored due to client rate limiting.");
        let l;
        (null == i ? void 0 : i.$current_url) && !$9ae5e4a12de151f5$var$I(null == i ? void 0 : i.$current_url) && ($9ae5e4a12de151f5$var$Je.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), "$exception" !== t || (null == e ? void 0 : e.fh) || $9ae5e4a12de151f5$var$Je.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && (l = this.sessionPersistence.update_campaign_params()), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
        const a = new Date, u = (null == e ? void 0 : e.timestamp) || a, h = $9ae5e4a12de151f5$var$di(null == e ? void 0 : e.uuid, $9ae5e4a12de151f5$var$lr);
        let d = {
            uuid: h,
            event: t,
            properties: this.calculateEventProperties(t, i || {}, u, h)
        };
        "$pageview" === t && this.config.__preview_capture_bot_pageviews && r && (d.event = "$bot_pageview", d.properties.$browser_type = "bot"), o && (d.properties.$lib_rate_limit_remaining_tokens = o.remainingTokens);
        const c = "$feature_flag_called" === t && !1 === d.properties.$feature_flag_has_experiment && !0 === this.get_property("$minimal_flag_called_events");
        (null == e ? void 0 : e.$set) && !c && (d.$set = null == e ? void 0 : e.$set);
        const v = $9ae5e4a12de151f5$var$C(null == i ? void 0 : i.$set) ? i.$set : void 0, f = $9ae5e4a12de151f5$var$T(null == i ? void 0 : i.$unset) ? i.$unset : [], p = (null == e ? void 0 : e.$unset) || [], _ = (t)=>{
            var i;
            const s = !!(null == e ? void 0 : e.$set) && t in e.$set;
            return {
                hasProvided: s || !!v && t in v,
                provided: s ? null == e || null === (i = e.$set) || void 0 === i ? void 0 : i[t] : null == v ? void 0 : v[t],
                unset: -1 !== f.indexOf(t) || -1 !== p.indexOf(t)
            };
        }, g = _($9ae5e4a12de151f5$var$us), m = _($9ae5e4a12de151f5$var$ds), b = [
            {
                channel: this.nh,
                hasProvided: g.hasProvided,
                update: this.uh(null == l ? void 0 : l.fbclid, g.provided, g.hasProvided, g.unset)
            },
            {
                channel: this.sh,
                hasProvided: m.hasProvided,
                update: this.hh(m.provided, m.hasProvided, m.unset)
            }
        ];
        for (const { channel: t, hasProvided: i, update: e } of b)e && !0 === d.properties.$process_person_profile && e.pending && !i && !c && (d.$set = $9ae5e4a12de151f5$var$Ei({
            [t.property]: e.value
        }, d.$set));
        const y = null == e ? void 0 : e.$unset;
        y && (d.$unset = y);
        const w = c ? void 0 : this.ph(null == e ? void 0 : e.$set_once, t !== $9ae5e4a12de151f5$var$Hn, t === $9ae5e4a12de151f5$var$zn);
        if (w && (d.$set_once = w), (null == e ? void 0 : e._noTruncate) || (S = this.config.properties_string_max_length, d = function(t, i) {
            const e = new Set;
            return function t(s, n) {
                if (s !== Object(s)) return i ? i(s) : s;
                if (e.has(s)) return;
                let r;
                if (e.add(s), $9ae5e4a12de151f5$var$T(s)) r = [], $9ae5e4a12de151f5$var$qn(s, (i)=>{
                    r.push(t(i));
                });
                else {
                    const i = {};
                    $9ae5e4a12de151f5$var$Vn($9ae5e4a12de151f5$var$H(s) ? $9ae5e4a12de151f5$var$Yn(s) : s, (s, n)=>{
                        e.has(s) || (i[n] = t(s, n));
                    }), r = i;
                }
                return r;
            }(t);
        }(d, (t)=>$9ae5e4a12de151f5$var$I(t) ? t.slice(0, S) : t)), d.timestamp = u, $9ae5e4a12de151f5$var$R(null == e ? void 0 : e.timestamp) || (d.properties.$event_time_override_provided = !0, d.properties.$event_time_override_system_time = a), c && (d.properties = ((t, i = [])=>{
            const e = {}, s = (i)=>{
                void 0 !== t[i] && (e[i] = t[i]);
            };
            return $9ae5e4a12de151f5$var$fe.forEach(s), i.forEach(s), e;
        })(d.properties, $9ae5e4a12de151f5$var$Su)), t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.DISMISSED || t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SENT) {
            const e = null == i ? void 0 : i[$9ae5e4a12de151f5$export$fe4c9af525341543.SURVEY_ID], s = null == i ? void 0 : i[$9ae5e4a12de151f5$export$fe4c9af525341543.SURVEY_ITERATION];
            $9ae5e4a12de151f5$var$su({
                id: e,
                current_iteration: s
            }), d.$set = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, d.$set), {}, {
                [$9ae5e4a12de151f5$var$qa({
                    id: e,
                    current_iteration: s
                }, t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
            });
        } else t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SHOWN && (d.$set = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, d.$set), {}, {
            [$9ae5e4a12de151f5$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
        }));
        var S;
        if (t === $9ae5e4a12de151f5$export$e5d0052c1e47bfda.SHOWN) {
            const t = null == i ? void 0 : i[$9ae5e4a12de151f5$export$eedf6d13bc23d767.TOUR_TYPE];
            t && (d.$set = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, d.$set), {}, {
                [`${$9ae5e4a12de151f5$export$eedf6d13bc23d767.TOUR_LAST_SEEN_DATE}/${t}`]: (new Date).toISOString()
            }));
        }
        const x = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, d.properties.$set), d.$set);
        if ($9ae5e4a12de151f5$var$O(x) || this.setPersonPropertiesForFlags(x), !$9ae5e4a12de151f5$var$F(this.config.before_send)) {
            const t = this.Os(d);
            if (!t) return;
            d = t, d.uuid = $9ae5e4a12de151f5$var$di(d.uuid, $9ae5e4a12de151f5$var$lr);
        }
        const E = b.filter(({ channel: t, update: i })=>{
            var e, s, n;
            const r = null !== (e = null === (s = d.$set) || void 0 === s ? void 0 : s[t.property]) && void 0 !== e ? e : $9ae5e4a12de151f5$var$C(null === (n = d.properties) || void 0 === n ? void 0 : n.$set) ? d.properties.$set[t.property] : void 0;
            return (null == i ? void 0 : i.pending) && r === i.value;
        });
        this.vu.emit("eventCaptured", d);
        const k = null !== (s = null == e ? void 0 : e._url) && void 0 !== s ? s : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), P = "recordings" === (null == e ? void 0 : e._batchKey) || /\/s\/(?:\?|$)/.test(k), A = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({
            method: "POST",
            url: k,
            data: d,
            compression: "best-available",
            preferSyncCompression: null == e ? void 0 : e.send_instantly,
            timestampMode: P ? "body" : "capture-body",
            batchKey: null == e ? void 0 : e._batchKey
        }, P && (null === (n = d.properties) || void 0 === n ? void 0 : n.$session_id) ? {
            batchGroup: d.properties.$session_id + (d.properties.$window_id ? `-${d.properties.$window_id}` : "")
        } : {}), (null == e ? void 0 : e.transport) ? {
            transport: e.transport
        } : {}), E.length ? {
            fireCallbackOnDrop: !0,
            callback: (t)=>{
                if (t.statusCode >= 200 && 300 > t.statusCode) for (const { channel: t, update: i } of E)this.dh(t, i.value);
            }
        } : {});
        if (!this.config.request_batching || e && !(null == e ? void 0 : e._batchKey) || (null == e ? void 0 : e.send_instantly) || E.length) {
            var M;
            let t;
            !A.transport && !A.callback && $9ae5e4a12de151f5$var$O(null !== (M = this.config.request_headers) && void 0 !== M ? M : {}) && this.$u && (t = "sendBeacon"), this.ju(A, t);
        } else this.qu.enqueue(A);
        return d;
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    getExtension(t) {
        var i;
        return null === (i = this.Xu) || void 0 === i ? void 0 : i.getExtension(t);
    }
    Zu() {
        var t;
        return null !== (t = this.Xu) && void 0 !== t ? t : this.Xu = new $9ae5e4a12de151f5$var$cu(this);
    }
    pu(t) {
        this.Pu.push(t);
        let i = !0;
        return ()=>{
            if (!i) return;
            i = !1;
            const e = this.Pu.indexOf(t);
            -1 !== e && this.Pu.splice(e, 1);
        };
    }
    gh(t = !0) {
        var i, e, s;
        return !!(null === (i = this.persistence) || void 0 === i ? void 0 : i.consumeCookieIdentityChange()) && (this.Ou = null, "anonymous" === this.persistence.get_property("$user_state") && (null === (s = this.sessionPersistence) || void 0 === s || s.clear(), this.Mu.clear(), this.mh()), null === (e = this.featureFlags) || void 0 === e || e.reset(), t && this.reloadFeatureFlags(), !0);
    }
    calculateEventProperties(i, e, r, o, l) {
        if (r = r || new Date, !this.persistence || !this.sessionPersistence) return e;
        this.persistence.syncCookieProperties(), this.gh();
        const a = l ? void 0 : this.persistence.remove_event_timer(i);
        let h = $9ae5e4a12de151f5$var$Ei({}, e);
        if (h.token = this.config.token, h.$config_defaults = this.config.defaults, this.bu() && (h[$9ae5e4a12de151f5$var$wn] = !0), "$snapshot" === i) {
            const t = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, this.persistence.properties()), this.sessionPersistence.properties());
            return h.distinct_id = t.distinct_id, (!$9ae5e4a12de151f5$var$I(h.distinct_id) && !$9ae5e4a12de151f5$var$D(h.distinct_id) || $9ae5e4a12de151f5$var$A(h.distinct_id)) && $9ae5e4a12de151f5$var$Je.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), h;
        }
        const d = function(i, e, s, r = !1) {
            var o, l, a, h;
            if (!$9ae5e4a12de151f5$var$u) return {};
            const d = i ? [
                ...$9ae5e4a12de151f5$var$No,
                ...e || []
            ] : [], [c, v] = $9ae5e4a12de151f5$var$Zt($9ae5e4a12de151f5$var$u), [p, _] = function(t) {
                for(let i = 0; $9ae5e4a12de151f5$var$si.length > i; i++){
                    const [e, s, n] = $9ae5e4a12de151f5$var$si[i], r = t.match(e);
                    if (r) {
                        const i = n && t.match(n) || r;
                        return [
                            s,
                            (null == i ? void 0 : i[1]) || ""
                        ];
                    }
                }
                return [
                    "",
                    ""
                ];
            }($9ae5e4a12de151f5$var$u), g = function() {
                const t = "u" > typeof navigator ? navigator : void 0;
                return (null == t ? void 0 : t.brave) ? {
                    brave: !0
                } : {};
            }(), m = {};
            $9ae5e4a12de151f5$var$R(s) || (m.detectGoogleSearchApp = s);
            const b = {}, y = null === (o = navigator) || void 0 === o || null === (o = o.userAgentData) || void 0 === o ? void 0 : o.platform, w = null === (l = navigator) || void 0 === l ? void 0 : l.maxTouchPoints, S = null == $9ae5e4a12de151f5$var$t || null === (a = $9ae5e4a12de151f5$var$t.screen) || void 0 === a ? void 0 : a.width, x = null == $9ae5e4a12de151f5$var$t || null === (h = $9ae5e4a12de151f5$var$t.screen) || void 0 === h ? void 0 : h.height, E = null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.devicePixelRatio;
            $9ae5e4a12de151f5$var$R(y) || (b.userAgentDataPlatform = y), $9ae5e4a12de151f5$var$R(w) || (b.maxTouchPoints = w), $9ae5e4a12de151f5$var$R(S) || (b.screenWidth = S), $9ae5e4a12de151f5$var$R(x) || (b.screenHeight = x), $9ae5e4a12de151f5$var$R(E) || (b.devicePixelRatio = E);
            const k = $9ae5e4a12de151f5$var$Wn($9ae5e4a12de151f5$var$Jn({
                $os: c,
                $os_version: v,
                $browser: $9ae5e4a12de151f5$var$Jt($9ae5e4a12de151f5$var$u, navigator.vendor, g, m),
                $webview_app: p,
                $webview_app_version: _,
                $device: $9ae5e4a12de151f5$var$ti($9ae5e4a12de151f5$var$u),
                $device_type: $9ae5e4a12de151f5$var$ii($9ae5e4a12de151f5$var$u, b),
                $timezone: $9ae5e4a12de151f5$var$Yo(),
                $timezone_offset: $9ae5e4a12de151f5$var$Xo()
            }), {
                $current_url: $9ae5e4a12de151f5$var$Ao(r ? $9ae5e4a12de151f5$var$vi(null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.href) : null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.href, d, $9ae5e4a12de151f5$var$Lo),
                $host: null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.host,
                $pathname: null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.pathname,
                $raw_user_agent: $9ae5e4a12de151f5$var$u.length > 1e3 ? $9ae5e4a12de151f5$var$u.substring(0, 997) + "..." : $9ae5e4a12de151f5$var$u,
                $browser_version: $9ae5e4a12de151f5$var$Xt($9ae5e4a12de151f5$var$u, navigator.vendor, g, m),
                $browser_language: $9ae5e4a12de151f5$var$qo(),
                $browser_language_prefix: $9ae5e4a12de151f5$var$Vo(),
                $screen_height: null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.screen.height,
                $screen_width: null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.screen.width,
                $viewport_height: null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.innerHeight,
                $viewport_width: null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.innerWidth,
                $lib: $9ae5e4a12de151f5$var$f.LIB_NAME,
                $lib_version: $9ae5e4a12de151f5$var$f.LIB_VERSION,
                $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
                $time: Date.now() / 1e3
            });
            return $9ae5e4a12de151f5$var$f.SDK_DIST_CHANNEL && (k.$sdk_dist_channel = $9ae5e4a12de151f5$var$f.SDK_DIST_CHANNEL), k;
        }(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app, this.config.disable_capture_url_hashes);
        if (this.sessionManager) {
            const { sessionId: t, windowId: i } = this.sessionManager.checkAndGetSessionAndWindowId(l, r.getTime(), !0);
            h.$session_id = t, h.$window_id = i;
        }
        this.sessionPropsManager && $9ae5e4a12de151f5$var$Wn(h, this.sessionPropsManager.getSessionProps());
        try {
            var c;
            this.sessionRecording && $9ae5e4a12de151f5$var$Wn(h, this.sessionRecording.sdkDebugProperties), h.$sdk_debug_retry_queue_size = null === (c = this.Bu) || void 0 === c ? void 0 : c.length;
        } catch (t) {
            h.$sdk_debug_error_capturing_properties = String(t);
        }
        let v;
        if (this.requestRouter.region === $9ae5e4a12de151f5$var$Xa && (h.$lib_custom_api_host = this.config.api_host), v = "$pageview" !== i || l ? "$pageleave" !== i || l ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(r) : this.pageViewManager.doPageView(r, o), h = $9ae5e4a12de151f5$var$Wn(h, v), "$pageview" === i && $9ae5e4a12de151f5$var$s && (h.title = $9ae5e4a12de151f5$var$s.title), !$9ae5e4a12de151f5$var$R(a)) {
            const t = r.getTime() - a;
            h.$duration = parseFloat((t / 1e3).toFixed(3));
        }
        $9ae5e4a12de151f5$var$u && this.config.opt_out_useragent_filter && (h.$browser_type = this._is_bot() ? "bot" : "browser");
        const p = this.persistence.properties(), _ = this.sessionPersistence.properties(), g = h.$groups, m = p.$groups;
        $9ae5e4a12de151f5$var$C(g) && !$9ae5e4a12de151f5$var$O(g) && (h.$groups = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$C(m) ? m : {}), g)), $9ae5e4a12de151f5$var$Vn([
            "$referrer",
            "$referring_domain"
        ], (t)=>{
            t in p && delete _[t];
        });
        const b = {};
        if (this.Pu.length > 0) for (const t of this.Pu.slice())try {
            $9ae5e4a12de151f5$var$Wn(b, t());
        } catch (t) {
            $9ae5e4a12de151f5$var$Je.error("Failed to produce browser extension event properties", t);
        }
        h = $9ae5e4a12de151f5$var$Wn({}, d, p, _, $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, b), h)), h.$is_identified = this._isIdentified(), $9ae5e4a12de151f5$var$T(this.config.property_denylist) ? $9ae5e4a12de151f5$var$Vn(this.config.property_denylist, function(t) {
            delete h[t];
        }) : $9ae5e4a12de151f5$var$Je.error($9ae5e4a12de151f5$var$bu + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        const y = this.config.sanitize_properties;
        y && ($9ae5e4a12de151f5$var$Je.error($9ae5e4a12de151f5$var$mu), h = y(h, i));
        const w = this.yh();
        return h.$process_person_profile = w, w && !l && this.bh("_calculate_event_properties"), h;
    }
    ph(t, i = !0, e = !1) {
        var s;
        if (!this.persistence || !this.yh()) return t;
        if (this.Iu && !e) return t;
        const n = this.persistence.get_initial_props(), r = null === (s = this.sessionPropsManager) || void 0 === s ? void 0 : s.getSetOnceProps();
        let o = $9ae5e4a12de151f5$var$Wn({}, n, r || {}, t || {});
        const l = this.config.sanitize_properties;
        return l && ($9ae5e4a12de151f5$var$Je.error($9ae5e4a12de151f5$var$mu), o = l(o, "$set_once")), i && (this.Iu = !0), $9ae5e4a12de151f5$var$O(o) ? void 0 : o;
    }
    register(t, i) {
        var e;
        null === (e = this.persistence) || void 0 === e || e.register(t, i);
    }
    register_once(t, i, e) {
        var s;
        null === (s = this.persistence) || void 0 === s || s.register_once(t, i, e);
    }
    register_for_session(t) {
        var i, e;
        null === (i = this.persistence) || void 0 === i || i.syncCookieProperties(), this.gh(), null === (e = this.sessionPersistence) || void 0 === e || e.register(t), Object.keys(t).forEach((t)=>this.Mu.add(t)), this.mh();
    }
    unregister(t) {
        var i;
        null === (i = this.persistence) || void 0 === i || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null === (i = this.sessionPersistence) || void 0 === i || i.unregister(t), this.Mu.delete(t), this.mh();
    }
    _h(t, i) {
        this.register({
            [t]: i
        });
    }
    Hu() {
        this.Mu.forEach((t)=>{
            var i;
            null === (i = this.sessionPersistence) || void 0 === i || i.unregister(t);
        }), this.Mu.clear(), this.mh();
    }
    mh() {
        var t;
        if (!this.Eu) return;
        if ("memory" === this.config.persistence || (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.mi) || !$9ae5e4a12de151f5$var$Pr.Et()) return void $9ae5e4a12de151f5$var$Pr.Lt(this.Eu);
        const i = [];
        this.Mu.forEach((t)=>i.push(t)), i.length > 0 ? $9ae5e4a12de151f5$var$Pr.At(this.Eu, i) : $9ae5e4a12de151f5$var$Pr.Lt(this.Eu);
    }
    getFeatureFlag(t, i) {
        var e;
        return null === (e = this.featureFlags) || void 0 === e ? void 0 : e.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i;
        return null === (i = this.featureFlags) || void 0 === i ? void 0 : i.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, i) {
        var e;
        return null === (e = this.featureFlags) || void 0 === e ? void 0 : e.getFeatureFlagResult(t, i);
    }
    getAllFeatureFlags() {
        var t, i;
        return null !== (t = null === (i = this.featureFlags) || void 0 === i ? void 0 : i.getAllFeatureFlags()) && void 0 !== t ? t : [];
    }
    isFeatureEnabled(t, i) {
        var e, s;
        return null !== (e = null === (s = this.featureFlags) || void 0 === s ? void 0 : s.isFeatureEnabled(t, i)) && void 0 !== e ? e : null == i ? void 0 : i.defaultValue;
    }
    reloadFeatureFlags() {
        var t;
        null === (t = this.featureFlags) || void 0 === t || t.reloadFeatureFlags();
    }
    updateFlags(t, i, e) {
        var s;
        null === (s = this.featureFlags) || void 0 === s || s.updateFlags(t, i, e);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var s;
        null === (s = this.featureFlags) || void 0 === s || s.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i = !1, e) {
        var s;
        return null === (s = this.featureFlags) || void 0 === s ? void 0 : s.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this.vu.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, {
            errorsLoading: !0
        }), ()=>{});
    }
    onSurveysLoaded(t) {
        return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], {
            isLoaded: !1,
            error: $9ae5e4a12de151f5$var$gu
        }), ()=>{});
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null === (e = this.sessionManager) || void 0 === e ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i = !1) {
        this.surveys ? this.surveys.getSurveys(t, i) : t([], {
            isLoaded: !1,
            error: $9ae5e4a12de151f5$var$gu
        });
    }
    getActiveMatchingSurveys(t, i = !1) {
        this.surveys ? this.surveys.getActiveMatchingSurveys(t, i) : t([], {
            isLoaded: !1,
            error: $9ae5e4a12de151f5$var$gu
        });
    }
    renderSurvey(t, i) {
        var e;
        null === (e = this.surveys) || void 0 === e || e.renderSurvey(t, i);
    }
    displaySurvey(t, i = $9ae5e4a12de151f5$var$ru) {
        var e;
        null === (e = this.surveys) || void 0 === e || e.displaySurvey(t, i);
    }
    cancelPendingSurvey(t) {
        var i;
        null === (i = this.surveys) || void 0 === i || i.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        var i, e;
        return null !== (i = null === (e = this.surveys) || void 0 === e ? void 0 : e.canRenderSurvey(t)) && void 0 !== i ? i : {
            visible: !1,
            disabledReason: $9ae5e4a12de151f5$var$gu
        };
    }
    canRenderSurveyAsync(t, i = !1) {
        var e, s;
        return null !== (e = null === (s = this.surveys) || void 0 === s ? void 0 : s.canRenderSurveyAsync(t, i)) && void 0 !== e ? e : Promise.resolve({
            visible: !1,
            disabledReason: $9ae5e4a12de151f5$var$gu
        });
    }
    wh(t) {
        return !t || $9ae5e4a12de151f5$var$A(t) ? ($9ae5e4a12de151f5$var$Je.critical("Unique user id has not been set in posthog.identify"), !1) : "$posthog_cookieless" === t ? ($9ae5e4a12de151f5$var$Je.critical(`The string "${t}" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.`), !1) : ![
            "distinct_id",
            "distinctid"
        ].includes(t.toLowerCase()) && ![
            "undefined",
            "null"
        ].includes(t.toLowerCase()) || ($9ae5e4a12de151f5$var$Je.critical(`The string "${t}" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.`), !1);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $9ae5e4a12de151f5$var$Je.uninitializedWarning("posthog.identify");
        if ($9ae5e4a12de151f5$var$D(t) && (t = t.toString(), $9ae5e4a12de151f5$var$Je.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), !this.wh(t)) return;
        if (!this.bh("posthog.identify")) return;
        this.Su();
        const s = this.get_distinct_id(), n = this.persistence.syncCookieProperties() && this.get_distinct_id() !== s, r = this.gh(!1), o = this.persistence.Da();
        let l = !1;
        try {
            const s = this.get_distinct_id();
            this.register({
                $user_id: t
            }), this.get_property("$device_id") || this.register_once({
                $had_persisted_distinct_id: !0,
                $device_id: s
            }, ""), t !== s && t !== this.get_property("__alias") && (this.unregister($9ae5e4a12de151f5$var$ls), this.register({
                distinct_id: t
            }));
            const o = (this.persistence.get_property("$user_state") || "anonymous") === $9ae5e4a12de151f5$var$Fn, u = t !== s, h = !u && o;
            if (u && o) {
                var a;
                const n = this.config.reuseAnonymousId ? {
                    distinct_id: t
                } : {
                    distinct_id: t,
                    $anon_distinct_id: s
                };
                this.persistence.set_property($9ae5e4a12de151f5$var$vn, $9ae5e4a12de151f5$var$Dn), this.setPersonPropertiesForFlags({
                    $set: i || {},
                    $set_once: e || {}
                }, !1), this.config.cookieWinsOnConflict && this.persistence.La(), this.capture("$identify", n, {
                    $set: i || {},
                    $set_once: e || {}
                }) && (this.Ou = $9ae5e4a12de151f5$var$Ya(t, i, e)), null === (a = this.featureFlags) || void 0 === a || a.setAnonymousDistinctId(this.config.reuseAnonymousId ? void 0 : s);
            } else if (h) {
                this.persistence.set_property($9ae5e4a12de151f5$var$vn, $9ae5e4a12de151f5$var$Dn);
                const s = i || {}, n = e || {};
                this.setPersonPropertiesForFlags({
                    $set: s,
                    $set_once: n
                }, !1), this.config.cookieWinsOnConflict && this.persistence.La(), this.capture("$set", {
                    $set: s,
                    $set_once: n
                }) && (this.Ou = $9ae5e4a12de151f5$var$Ya(t, i, e));
            } else (i || e) && this.setPersonProperties(i, e);
            u || n || r ? (this.reloadFeatureFlags(), this.featureFlags ? this.featureFlags.resetFlagCallReported() : this.unregister($9ae5e4a12de151f5$var$un)) : h && (i || e) && this.reloadFeatureFlags(), l = !0;
        } finally{
            o && this.persistence.ja(l);
        }
    }
    setPersonProperties(t, i) {
        if (!t && !i) return;
        if (!this.bh("posthog.setPersonProperties")) return;
        const e = $9ae5e4a12de151f5$var$Ya(this.get_distinct_id(), t, i);
        this.Ou !== e ? (this.setPersonPropertiesForFlags({
            $set: t || {},
            $set_once: i || {}
        }, !0), this.capture("$set", {
            $set: t || {},
            $set_once: i || {}
        }) && (this.Ou = e)) : $9ae5e4a12de151f5$var$Je.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
    }
    unsetPersonProperties(t) {
        var i;
        const e = ($9ae5e4a12de151f5$var$T(t) ? t : [
            t
        ]).filter((t)=>$9ae5e4a12de151f5$var$I(t) && t.length > 0);
        0 !== e.length && this.bh("posthog.unsetPersonProperties") && (null === (i = this.featureFlags) || void 0 === i || i.unsetPersonPropertiesForFlags(e, !0), this.capture("$set", {
            $unset: e
        }), this.Ou = null);
    }
    group(t, i, e) {
        var s;
        if (!t || !i) return void $9ae5e4a12de151f5$var$Je.error("posthog.group requires a group type and group key");
        null === (s = this.persistence) || void 0 === s || s.syncCookieProperties(), this.gh();
        const n = this.getGroups(), r = n[t] !== i;
        if (r && this.resetGroupPropertiesForFlags(t), this.register({
            $groups: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, n), {}, {
                [t]: i
            })
        }), (r || e) && this.yh()) {
            const s = {
                $group_type: t,
                $group_key: i
            };
            e && (s.$group_set = e), this.capture($9ae5e4a12de151f5$var$Hn, s);
        }
        e && this.setGroupPropertiesForFlags({
            [t]: e
        }), r && !e && this.reloadFeatureFlags();
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i = !0) {
        var e;
        null === (e = this.featureFlags) || void 0 === e || e.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags(t = !0) {
        var i;
        null === (i = this.featureFlags) || void 0 === i || i.resetPersonPropertiesForFlags(t);
    }
    setGroupPropertiesForFlags(t, i = !0) {
        var e;
        this.bh("posthog.setGroupPropertiesForFlags") && (null === (e = this.featureFlags) || void 0 === e || e.setGroupPropertiesForFlags(t, i));
    }
    resetGroupPropertiesForFlags(t) {
        var i;
        null === (i = this.featureFlags) || void 0 === i || i.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        const i = $9ae5e4a12de151f5$var$j(t) ? t : null == t ? void 0 : t.resetDeviceID, e = $9ae5e4a12de151f5$var$j(t) || null == t ? void 0 : t.bootstrap;
        this.kh(i, !1, e);
    }
    kh(t, i = !1, e) {
        var s, n, r, o, l, a;
        if ($9ae5e4a12de151f5$var$Je.info("reset"), !this.__loaded) return $9ae5e4a12de151f5$var$Je.uninitializedWarning("posthog.reset");
        const u = null == e ? void 0 : e.sessionID;
        this.config.bootstrap = e || (null === (s = this.Lu) || void 0 === s ? void 0 : s.bootstrap) || {}, null === (n = this.featureFlags) || void 0 === n || null === (r = n.updateConfig) || void 0 === r || r.call(n, this.config, this.nl());
        const h = this.get_property($9ae5e4a12de151f5$var$rs), d = this.get_property($9ae5e4a12de151f5$var$os), c = this.get_property($9ae5e4a12de151f5$var$xs);
        null === (o = this.sessionRecording) || void 0 === o || o.flushBeforeIdentityReset();
        const v = this.is_capturing();
        this.consent.reset(), i || !v || this.is_capturing() || console.warn("[PostHog.js]", "reset() cleared the stored consent, and capturing is now off because of `opt_out_capturing_by_default`. Call opt_in_capturing() again, and prefer calling reset() before opting in rather than after.");
        const f = null === (l = this.persistence) || void 0 === l || null === (a = l.Da) || void 0 === a ? void 0 : a.call(l);
        let p = !1;
        try {
            var _, g, m, b, y, w, S, x, E, k, T, P, C;
            if (null === (_ = this.persistence) || void 0 === _ || _.clear(), null === (g = this.sessionPersistence) || void 0 === g || g.clear(), this.Mu.clear(), this.mh(), $9ae5e4a12de151f5$var$R(c) || null === (k = this.persistence) || void 0 === k || k.register({
                $session_recording_remote_config: c
            }), null === (m = this.surveys) || void 0 === m || m.reset(), null === (b = this.featureFlags) || void 0 === b || b.reset(), null === (y = this.conversations) || void 0 === y || y.reset(), null === (w = this.logs) || void 0 === w || w.reset(), null === (S = this.metrics) || void 0 === S || S.reset(), null === (x = this.persistence) || void 0 === x || x.set_property("$user_state", "anonymous"), null === (E = this.sessionManager) || void 0 === E || E.resetSessionId(), this.Ou = null, "always" === this.config.cookieless_mode) this.register_once({
                distinct_id: $9ae5e4a12de151f5$var$yn,
                $device_id: null
            }, "");
            else {
                const i = this.config.get_device_id($9ae5e4a12de151f5$var$lr());
                this.register_once({
                    distinct_id: i,
                    $device_id: t ? i : h
                }, ""), t || $9ae5e4a12de151f5$var$R(d) || this.register({
                    [$9ae5e4a12de151f5$var$os]: d
                });
            }
            if (this.register({
                $last_posthog_reset: (new Date).toISOString()
            }, 1), e) {
                if (e.distinctID && !this.bu() && (null === (C = this.persistence) || void 0 === C || C.set_property("$user_state", e.isIdentifiedID ? "identified" : "anonymous"), this.register({
                    distinct_id: e.distinctID
                })), null === (T = this.featureFlags) || void 0 === T || T.initialize(), !$9ae5e4a12de151f5$var$F(u) && !(null === (P = this.sessionManager) || void 0 === P ? void 0 : P.setBootstrapSessionId(u, !0))) {
                    const t = $9ae5e4a12de151f5$var$Ei({}, e);
                    delete t.sessionID, this.config.bootstrap = t;
                }
            }
            delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, p = !0;
        } finally{
            var O, I;
            f && (null === (O = this.persistence) || void 0 === O || null === (I = O.ja) || void 0 === I || I.call(O, p));
        }
        this.reloadFeatureFlags();
    }
    shutdown(t) {
        var i = this;
        return $9ae5e4a12de151f5$var$Y(function*() {
            var t, e, s, n, r, o, l, a;
            if (i.__loaded) {
                i.Tu = !0, i.Zu().dispose(), null === (t = i.sessionRecording) || void 0 === t || t.dispose(), null === (e = i.logs) || void 0 === e || e.flushLogs("sendBeacon"), null === (s = i.metrics) || void 0 === s || s.flush("sendBeacon"), null === (n = i.metrics) || void 0 === n || n.dispose(), null === (r = i.qu) || void 0 === r || r.unload(), null === (o = i.Bu) || void 0 === o || o.unload();
                try {
                    var u;
                    null === (u = i.featureFlags) || void 0 === u || u.destroy();
                } catch (t) {
                    $9ae5e4a12de151f5$var$Je.error("Error while destroying feature flags", t);
                }
                null === (l = i.persistence) || void 0 === l || l.destroy(), null === (a = i.sessionPersistence) || void 0 === a || a.destroy();
            } else $9ae5e4a12de151f5$var$Je.uninitializedWarning("posthog.shutdown");
        })();
    }
    setIdentity(t, i) {
        var e;
        delete this.config.identity_claims, this.config.identity_distinct_id = t, this.config.identity_hash = i, this.alias(t), null === (e = this.conversations) || void 0 === e || e.Sh();
    }
    clearIdentity() {
        var t;
        delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, null === (t = this.conversations) || void 0 === t || t.xh();
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null === (i = this.sessionManager) || void 0 === i ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        const { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
        let s = this.requestRouter.endpointFor("ui", `/project/${this.config.token}/replay/${i}`);
        if ((null == t ? void 0 : t.withTimestamp) && e) {
            var n;
            const i = null !== (n = t.timestampLookBack) && void 0 !== n ? n : 10;
            if (!e) return s;
            s += `?t=${Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - i, 0)}`;
        }
        return s;
    }
    alias(t, i) {
        return t === this.get_property("$people_distinct_id") ? ($9ae5e4a12de151f5$var$Je.critical("Attempting to create alias for existing People user - aborting."), -2) : this.bh("posthog.alias") ? ($9ae5e4a12de151f5$var$R(i) && (i = this.get_distinct_id()), t !== i ? (this._h($9ae5e4a12de151f5$var$ls, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($9ae5e4a12de151f5$var$Je.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        const i = $9ae5e4a12de151f5$var$Ei({}, this.config);
        if ($9ae5e4a12de151f5$var$C(t)) {
            var e, s, n, r, o, l, a, u, h, d, c, v, f, p;
            $9ae5e4a12de151f5$var$Wn(this.config, $9ae5e4a12de151f5$var$Pu(t));
            const g = this.xu();
            null === (e = this.persistence) || void 0 === e || e.update_config(this.config, i, g), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $9ae5e4a12de151f5$var$hl($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, this.config), {}, {
                persistence: "sessionStorage"
            }), g, !1);
            const m = this.Du(this.config.debug);
            var _;
            $9ae5e4a12de151f5$var$j(m) && (this.config.debug = m), $9ae5e4a12de151f5$var$j(this.config.debug) && (this.config.debug ? ($9ae5e4a12de151f5$var$es.DEBUG = !0, $9ae5e4a12de151f5$var$fr.Et() && $9ae5e4a12de151f5$var$fr.At("ph_debug", !0), $9ae5e4a12de151f5$var$Je.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $9ae5e4a12de151f5$var$Ei({}, this.config)
            })) : ($9ae5e4a12de151f5$var$es.DEBUG = !1, $9ae5e4a12de151f5$var$fr.Et() && $9ae5e4a12de151f5$var$fr.Lt("ph_debug"))), null === (s = this.featureFlags) || void 0 === s || null === (n = s.updateConfig) || void 0 === n || n.call(s, this.config, this.nl()), null === (r = this.exceptionObserver) || void 0 === r || r.onConfigChange(), null === (o = this.exceptions) || void 0 === o || o.onConfigChange(), null === (l = this.metrics) || void 0 === l || l.onConfigChange(), null === (a = this.sessionRecording) || void 0 === a || a.startIfEnabledOrStop(), null === (u = this.tracingHeaders) || void 0 === u || u.startIfEnabledOrStop(), null === (h = this.autocapture) || void 0 === h || h.startIfEnabled(), null === (d = this.heatmaps) || void 0 === d || d.startIfEnabled(), ("capture_pageview" in t || "disable_capture_url_hashes" in t) && (null === (_ = this.historyAutocapture) || void 0 === _ || _.startIfEnabledOrStop()), null === (c = this.exceptionObserver) || void 0 === c || c.startIfEnabledOrStop(), null === (v = this.deadClicksAutocapture) || void 0 === v || v.startIfEnabledOrStop(), null === (f = this.surveys) || void 0 === f || f.loadIfEnabled(), this.Cu(), null === (p = this.externalIntegrations) || void 0 === p || p.startIfEnabledOrStop(), !i.segment && this.config.segment && this.persistence && $9ae5e4a12de151f5$var$wo(this, $9ae5e4a12de151f5$var$pu, !1);
        }
    }
    _overrideSDKInfo(t, i) {
        $9ae5e4a12de151f5$var$es.LIB_NAME = t, $9ae5e4a12de151f5$var$es.LIB_VERSION = i;
    }
    startSessionRecording(t) {
        const i = !0 === t, e = {
            sampling: i || !!(null == t ? void 0 : t.sampling),
            linked_flag: i || !!(null == t ? void 0 : t.linked_flag),
            url_trigger: i || !!(null == t ? void 0 : t.url_trigger),
            event_trigger: i || !!(null == t ? void 0 : t.event_trigger)
        };
        var s, n, r, o, l;
        Object.values(e).some(Boolean) && (null === (s = this.sessionManager) || void 0 === s || s.checkAndGetSessionAndWindowId(), e.sampling && (null === (n = this.sessionRecording) || void 0 === n || n.overrideSampling()), e.linked_flag && (null === (r = this.sessionRecording) || void 0 === r || r.overrideLinkedFlag()), e.url_trigger && (null === (o = this.sessionRecording) || void 0 === o || o.overrideTrigger("url")), e.event_trigger && (null === (l = this.sessionRecording) || void 0 === l || l.overrideTrigger("event")));
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !!(null === (t = this.sessionRecording) || void 0 === t ? void 0 : t.started);
    }
    captureException(t, i) {
        try {
            if (!this.exceptions) return;
            const e = this.exceptions.buildProperties(t, {
                handled: !0,
                syntheticException: new Error("PostHog syntheticException")
            });
            return this.exceptions.sendExceptionEvent($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e), i));
        } catch (t) {
            return;
        }
    }
    addExceptionStep(t, i) {
        var e;
        null === (e = this.exceptions) || void 0 === e || e.addExceptionStep(t, i);
    }
    captureLog(t) {
        var i;
        null === (i = this.logs) || void 0 === i || i.captureLog(t);
    }
    get logger() {
        var t, e;
        return null !== (t = null === (e = this.logs) || void 0 === e ? void 0 : e.logger) && void 0 !== t ? t : i.Ch;
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        var i, e;
        return null !== (i = null === (e = this.toolbar) || void 0 === e ? void 0 : e.loadToolbar(t)) && void 0 !== i && i;
    }
    get_property(t) {
        var i;
        return null === (i = this.persistence) || void 0 === i ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null === (i = this.sessionPersistence) || void 0 === i ? void 0 : i.props[t];
    }
    toString() {
        var t;
        let i = null !== (t = this.config.name) && void 0 !== t ? t : $9ae5e4a12de151f5$var$xu;
        return i !== $9ae5e4a12de151f5$var$xu && (i = "posthog." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null === (t = this.persistence) || void 0 === t ? void 0 : t.get_property("$user_state")) || "identified" === (null === (i = this.sessionPersistence) || void 0 === i ? void 0 : i.get_property("$user_state"));
    }
    yh() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $9ae5e4a12de151f5$var$O(this.getGroups()) && !(null === (t = this.persistence) || void 0 === t || null === (t = t.props) || void 0 === t ? void 0 : t.__alias) && !(null === (i = this.persistence) || void 0 === i || null === (i = i.props) || void 0 === i ? void 0 : i.$epp));
    }
    ih() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && !!this.config.capture_pageview;
    }
    createPersonProfile() {
        this.yh() || this.bh("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.bh("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    bh(t) {
        return "never" === this.config.person_profiles ? ($9ae5e4a12de151f5$var$Je.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._u(), this._h($9ae5e4a12de151f5$var$bn, !0), !0);
    }
    xu() {
        if ("always" === this.config.cookieless_mode) return !0;
        const t = this.consent.isOptedOut();
        return this.config.disable_persistence || t && !(!this.config.opt_out_persistence_by_default && "on_reject" !== this.config.cookieless_mode);
    }
    Cu() {
        var t, i;
        const e = this.xu();
        var s, n, r;
        return this.is_capturing() || null === (s = this.logs) || void 0 === s || s.$h(), (null === (t = this.persistence) || void 0 === t ? void 0 : t.mi) !== e && (null === (n = this.persistence) || void 0 === n || n.set_disabled(e)), (null === (i = this.sessionPersistence) || void 0 === i ? void 0 : i.mi) !== e && (null === (r = this.sessionPersistence) || void 0 === r || r.set_disabled(e)), e && (this.Mu.clear(), this.mh()), e;
    }
    opt_in_capturing(t) {
        var e;
        if ("always" !== this.config.cookieless_mode) {
            if (this.bu()) {
                var s, n, r, o, l, a;
                null === (s = this.sessionRecording) || void 0 === s || s.dispose({
                    discardBufferedEvents: !0
                }), this.kh(!0, !0), null === (n = this.sessionManager) || void 0 === n || n.destroy(), null === (r = this.pageViewManager) || void 0 === r || r.destroy(), this.sessionManager = new $9ae5e4a12de151f5$var$Ua(this), this.pageViewManager = new $9ae5e4a12de151f5$var$Eo(this), this.persistence && (this.sessionPropsManager = new $9ae5e4a12de151f5$var$Na(this, this.sessionManager, this.persistence));
                const t = null !== (o = null === (l = this.config.__extensionClasses) || void 0 === l ? void 0 : l.sessionRecording) && void 0 !== o ? o : null === (a = i.__defaultExtensionClasses) || void 0 === a ? void 0 : a.sessionRecording;
                var u, h;
                t && (this.sessionRecording = this.yu(this.sessionRecording, new t(this)), this.du && (null === (u = this.sessionRecording) || void 0 === u || null === (h = u.onRemoteConfig) || void 0 === h || h.call(u, this.du)));
            }
            var d, c;
            this.consent.optInOut(!0), this.Cu(), this.Yu(), null === (e = this.sessionRecording) || void 0 === e || e.startIfEnabledOrStop(), "on_reject" == this.config.cookieless_mode && (null === (d = this.surveys) || void 0 === d || d.loadIfEnabled()), ($9ae5e4a12de151f5$var$R(null == t ? void 0 : t.captureEventName) || (null == t ? void 0 : t.captureEventName)) && this.capture(null !== (c = null == t ? void 0 : t.captureEventName) && void 0 !== c ? c : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            }), this.config.capture_pageview && this.th();
        } else $9ae5e4a12de151f5$var$Je.warn($9ae5e4a12de151f5$var$_u);
    }
    opt_out_capturing() {
        if ("always" === this.config.cookieless_mode) return void $9ae5e4a12de151f5$var$Je.warn($9ae5e4a12de151f5$var$_u);
        const t = "on_reject" === this.config.cookieless_mode ? this.sessionRecording : void 0;
        var i, e;
        null == t || t.dispose({
            discardBufferedEvents: !0
        }), "on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.kh(!0, !0), this.consent.optInOut(!1), this.Cu(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: $9ae5e4a12de151f5$var$yn,
            $device_id: null
        }), this.mu(t), this.sessionRecording = void 0, null === (i = this.sessionManager) || void 0 === i || i.destroy(), null === (e = this.pageViewManager) || void 0 === e || e.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.th(), this.Yu());
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        const t = this.consent.consent;
        return 1 === t ? "granted" : 0 === t ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.Cu();
    }
    _is_bot() {
        return $9ae5e4a12de151f5$var$e ? $9ae5e4a12de151f5$var$za($9ae5e4a12de151f5$var$e, this.config.custom_blocked_useragents) : void 0;
    }
    th() {
        $9ae5e4a12de151f5$var$s && ("visible" === $9ae5e4a12de151f5$var$s.visibilityState ? this.Ru || (this.Ru = !0, this.capture($9ae5e4a12de151f5$var$Bn, {
            title: $9ae5e4a12de151f5$var$s.title
        }, {
            send_instantly: !0
        }), this.Au && ($9ae5e4a12de151f5$var$s.removeEventListener($9ae5e4a12de151f5$var$jn, this.Au), this.Au = null)) : this.Au || (this.Au = this.th.bind(this), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, $9ae5e4a12de151f5$var$jn, this.Au)));
    }
    debug(i) {
        !1 === i ? (null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    nl() {
        const t = this.Lu || {};
        return "advanced_disable_flags" in t ? !!t.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($9ae5e4a12de151f5$var$Je.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : function(t, i, e, s, n) {
            const r = i in t && !$9ae5e4a12de151f5$var$F(t[i]), o = e in t && !$9ae5e4a12de151f5$var$F(t[e]);
            return r ? t[i] : !!o && (n && n.warn(`Config field '${e}' is deprecated. Please use '${i}' instead. The old field will be removed in a future major version.`), t[e]);
        }(t, "advanced_disable_flags", "advanced_disable_decide", 0, $9ae5e4a12de151f5$var$Je);
    }
    Os(t) {
        var i;
        if ($9ae5e4a12de151f5$var$F(this.config.before_send)) return t;
        const e = Object.keys(null !== (i = t.properties) && void 0 !== i ? i : {}).filter($9ae5e4a12de151f5$var$B), s = $9ae5e4a12de151f5$var$T(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ];
        let n = t;
        for (const i of s)try {
            if (n = i(n), $9ae5e4a12de151f5$var$F(n)) {
                const i = `Event '${t.event}' was rejected in beforeSend function`;
                return $9ae5e4a12de151f5$var$L(t.event) ? $9ae5e4a12de151f5$var$Je.warn(`${i}. This can cause unexpected behavior.`) : $9ae5e4a12de151f5$var$Je.info(i), null;
            }
            n.properties && !$9ae5e4a12de151f5$var$O(n.properties) || $9ae5e4a12de151f5$var$Je.warn(`Event '${t.event}' has no properties after beforeSend function, this is likely an error.`);
        } catch (i) {
            return $9ae5e4a12de151f5$var$Je.error(`Error in beforeSend function for event '${t.event}':`, i), null;
        }
        for (const i of e)if (n.properties && $9ae5e4a12de151f5$var$F(n.properties[i])) return $9ae5e4a12de151f5$var$Je.warn(`Event '${t.event}' had its '${i}' property removed in a beforeSend function. This property is required for ingestion, so the event will be dropped.`), null;
        return n;
    }
    getPageViewId() {
        var t;
        return null === (t = this.pageViewManager.Vo) || void 0 === t ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    Du(t) {
        const i = $9ae5e4a12de151f5$var$j(t) && !t, e = $9ae5e4a12de151f5$var$fr.Et() && "true" === $9ae5e4a12de151f5$var$fr.Ot("ph_debug");
        return !i && (!!e || t);
    }
};
$9ae5e4a12de151f5$export$a9d6b9cbf49b8241.__defaultExtensionClasses = {}, $9ae5e4a12de151f5$export$a9d6b9cbf49b8241.Ch = (()=>{
    const t = ()=>{};
    return {
        trace: t,
        debug: t,
        info: t,
        warn: t,
        error: t,
        fatal: t
    };
})(), function(t, i) {
    for(let e = 0; i.length > e; e++)t.prototype[i[e]] = $9ae5e4a12de151f5$var$Kn(t.prototype[i[e]]);
}($9ae5e4a12de151f5$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $9ae5e4a12de151f5$var$Ru = class {
    constructor(t){
        this.disabled = !1 === t;
        const i = $9ae5e4a12de151f5$var$C(t) ? t : {};
        this.thresholdPx = i.threshold_px || 30, this.timeoutMs = i.timeout_ms || 1e3, this.clickCount = i.click_count || 3, this.clicks = [];
    }
    isRageClick(t, i, e) {
        if (this.disabled) return !1;
        const s = this.clicks[this.clicks.length - 1];
        if (s && Math.abs(t - s.x) + Math.abs(i - s.y) < this.thresholdPx && this.timeoutMs > e - s.timestamp) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
};
const $9ae5e4a12de151f5$var$Iu = "$copy_autocapture", $9ae5e4a12de151f5$var$Au = $9ae5e4a12de151f5$var$Ye("[AutoCapture]");
function $9ae5e4a12de151f5$var$Mu(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $9ae5e4a12de151f5$var$Fu(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    let i = t;
    do i = i.previousSibling;
    while (i && !$9ae5e4a12de151f5$var$Ir(i));
    return i;
}
function $9ae5e4a12de151f5$var$Du(i, { e: e, maskAllElementAttributes: s, maskAllText: n, elementAttributeIgnoreList: r, elementsChainAsString: o, disableCaptureUrlHashes: l }) {
    var a, u;
    if (!$9ae5e4a12de151f5$var$Ir(i)) return {
        props: {}
    };
    const h = [
        i
    ], d = new Set([
        i
    ]);
    let c = i;
    for(; c.parentNode && !$9ae5e4a12de151f5$var$Ar(c, "body") && 1e3 > h.length;){
        if ($9ae5e4a12de151f5$var$Fr(c.parentNode)) {
            const t = c.parentNode.host;
            if (d.has(t)) break;
            d.add(t), h.push(t), c = t;
            continue;
        }
        if (!$9ae5e4a12de151f5$var$Ir(c.parentNode)) break;
        if (d.has(c.parentNode)) break;
        d.add(c.parentNode), h.push(c.parentNode), c = c.parentNode;
    }
    const v = "click" === e.type && "http://www.w3.org/2000/svg" === i.namespaceURI ? h.findIndex((t)=>$9ae5e4a12de151f5$var$Ar(t, "button") || $9ae5e4a12de151f5$var$Ar(t, "a")) : -1;
    v > 0 && (n = n || h.slice(0, v + 1).some((t)=>!$9ae5e4a12de151f5$var$io(t) || $9ae5e4a12de151f5$var$eo(t)));
    const f = [], p = {};
    let _, g = !1, m = !1;
    if ($9ae5e4a12de151f5$var$Vn(h, (t)=>{
        const i = $9ae5e4a12de151f5$var$io(t);
        if ($9ae5e4a12de151f5$var$Ar(t, "a") && !s && !(null == r ? void 0 : r.includes("href"))) {
            const e = t.getAttribute("href");
            g = !!(i && e && $9ae5e4a12de151f5$var$ho(e)) && (l ? $9ae5e4a12de151f5$var$vi(e) : e);
        }
        $9ae5e4a12de151f5$var$b($9ae5e4a12de151f5$var$jr(t), "ph-no-capture") && (m = !0), f.push(function(t, i, e, s, n = !1) {
            const r = t.tagName.toLowerCase(), o = {
                tag_name: r
            };
            $9ae5e4a12de151f5$var$zr.indexOf(r) > -1 && !e && (o.$el_text = "a" === r.toLowerCase() || "button" === r.toLowerCase() ? $9ae5e4a12de151f5$var$Mu(1024, $9ae5e4a12de151f5$var$co(t)) : $9ae5e4a12de151f5$var$Mu(1024, $9ae5e4a12de151f5$var$Br(t)));
            const l = $9ae5e4a12de151f5$var$jr(t);
            i || (null == s ? void 0 : s.includes("class")) || 0 >= l.length || (o.classes = l.filter(function(t) {
                return "" !== t;
            })), $9ae5e4a12de151f5$var$Vn(t.attributes, function(e) {
                var r;
                if ((!$9ae5e4a12de151f5$var$eo(t) || -1 !== [
                    "name",
                    "id",
                    "class",
                    "aria-label"
                ].indexOf(e.name)) && !(null == s ? void 0 : s.includes(e.name)) && !i && $9ae5e4a12de151f5$var$ho(e.value) && (!$9ae5e4a12de151f5$var$I(r = e.name) || "_ngcontent" !== r.substring(0, 10) && "_nghost" !== r.substring(0, 7))) {
                    let t = e.value;
                    "class" === e.name && (t = $9ae5e4a12de151f5$var$Dr(t).join(" ")), o["attr__" + e.name] = $9ae5e4a12de151f5$var$Mu(1024, "href" === e.name && n ? $9ae5e4a12de151f5$var$vi(t) : t);
                }
            });
            let a = 1, u = 1, h = t;
            for(; h = $9ae5e4a12de151f5$var$Fu(h);)a++, h.tagName === t.tagName && u++;
            return o.nth_child = a, o.nth_of_type = u, o;
        }(t, s, n, r, l)), $9ae5e4a12de151f5$var$Vn(function(t) {
            if (!$9ae5e4a12de151f5$var$io(t)) return {};
            const i = {};
            return $9ae5e4a12de151f5$var$Vn(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    const e = t.name.replace("data-ph-capture-attribute-", ""), s = t.value;
                    e && s && $9ae5e4a12de151f5$var$ho(s) && (i[e] = s);
                }
            }), i;
        }(t), (t, i)=>{
            ({}).hasOwnProperty.call(p, i) || (p[i] = t);
        });
    }), m) return {
        props: {},
        explicitNoCapture: m
    };
    if (v > 0 && (i = h[v], f.splice(0, v)), n || (f[0].$el_text = $9ae5e4a12de151f5$var$Ar(i, "a") || $9ae5e4a12de151f5$var$Ar(i, "button") ? $9ae5e4a12de151f5$var$co(i) : $9ae5e4a12de151f5$var$Br(i)), g) {
        var y, w;
        f[0].attr__href = g;
        const i = null === (y = $9ae5e4a12de151f5$var$Ro(g)) || void 0 === y ? void 0 : y.host, e = null == $9ae5e4a12de151f5$var$t || null === (w = $9ae5e4a12de151f5$var$t.location) || void 0 === w ? void 0 : w.host;
        i && e && i !== e && (_ = g);
    }
    var S, x;
    return {
        props: $9ae5e4a12de151f5$var$Wn((x = e.type, {
            $event_type: x,
            $ce_version: 1
        }), o ? {} : {
            $elements: f
        }, {
            $elements_chain: (S = f, $9ae5e4a12de151f5$var$T(S) ? function(t) {
                return t.map((t)=>{
                    var i, e;
                    let s = "";
                    if (t.tag_name && (s += t.tag_name), t.attr_class) {
                        t.attr_class.sort();
                        for (const i of t.attr_class)s += `.${i.replace(/"/g, "")}`;
                    }
                    const n = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t.text ? {
                        text: t.text
                    } : {}), {}, {
                        "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                        "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
                    }, t.href ? {
                        href: t.href
                    } : {}), t.attr_id ? {
                        attr_id: t.attr_id
                    } : {}), t.attributes), r = {};
                    return $9ae5e4a12de151f5$var$Gn(n).sort(([t], [i])=>(function(t, i) {
                            return i > t ? -1 : t > i ? 1 : 0;
                        })(t, i)).forEach(([t, i])=>r[$9ae5e4a12de151f5$var$fo(t.toString())] = $9ae5e4a12de151f5$var$fo(i.toString())), s += ":", s += $9ae5e4a12de151f5$var$Gn(r).map(([t, i])=>`${t}="${i}"`).join(""), s;
                }).join(";");
            }(function(t) {
                return t.map((t)=>{
                    var i, e;
                    const s = {
                        text: null === (i = t.$el_text) || void 0 === i ? void 0 : i.slice(0, 400),
                        tag_name: t.tag_name,
                        href: null === (e = t.attr__href) || void 0 === e ? void 0 : e.slice(0, 2048),
                        attr_class: $9ae5e4a12de151f5$var$po(t),
                        attr_id: t.attr__id,
                        nth_child: t.nth_child,
                        nth_of_type: t.nth_of_type,
                        attributes: {}
                    };
                    return $9ae5e4a12de151f5$var$Gn(t).filter(([t])=>0 === t.indexOf("attr__")).forEach(([t, i])=>s.attributes[t] = i), s;
                });
            }(S)) : "")
        }, (null === (a = f[0]) || void 0 === a ? void 0 : a.$el_text) ? {
            $el_text: null === (u = f[0]) || void 0 === u ? void 0 : u.$el_text
        } : {}, _ && "click" === e.type ? {
            $external_click_url: _
        } : {}, p),
        target: i
    };
}
var $9ae5e4a12de151f5$var$Nu = class {
    fo() {
        this.po = void 0, clearTimeout(this.mo), this.mo = void 0;
    }
    yo(t) {
        var i;
        if (!$9ae5e4a12de151f5$var$io(t)) return !0;
        const e = null !== (i = this.bo().css_selector_ignorelist) && void 0 !== i ? i : $9ae5e4a12de151f5$var$Wr, s = new Set;
        let n = t;
        for(; n;){
            if (s.size >= 1e3 || s.has(n)) return !0;
            s.add(n);
            const t = n, i = $9ae5e4a12de151f5$var$jr(t);
            if ($9ae5e4a12de151f5$var$b(i, "ph-no-capture") || $9ae5e4a12de151f5$var$b(i, "ph-sensitive") || $9ae5e4a12de151f5$var$eo(t) || e.some((i)=>$9ae5e4a12de151f5$var$Hr(t, i))) return !0;
            const r = n.parentNode;
            n = $9ae5e4a12de151f5$var$Fr(r) ? r.host : r && $9ae5e4a12de151f5$var$Ir(r) ? r : null;
        }
        return !1;
    }
    _o(t) {
        if (!this.isEnabled || "pointercancel" === t.type) return void this.fo();
        if ("pointerdown" === t.type) {
            this.fo();
            const e = $9ae5e4a12de151f5$var$Ur(t);
            var i;
            return void (t.isPrimary && 0 === t.button && !t.ctrlKey && e && $9ae5e4a12de151f5$var$Ir(e) && (this.po = {
                target: e,
                excluded: this.yo(e),
                id: t.pointerId,
                x: t.clientX,
                y: t.clientY,
                released: !1,
                distinctId: null === (i = this.wo) || void 0 === i ? void 0 : i.distinctId
            }));
        }
        const e = this.po;
        e && (t.pointerId !== e.id || Math.abs(t.clientX - e.x) > 5 || Math.abs(t.clientY - e.y) > 5 ? this.fo() : "pointerup" === t.type && (e.released = !0, this.mo = setTimeout(()=>this.fo(), 0)));
    }
    ko(t) {
        var i;
        const e = this.po;
        this.fo();
        const n = $9ae5e4a12de151f5$var$Ur(t);
        if ((null == e ? void 0 : e.released) && e.target.isConnected && e.distinctId === (null === (i = this.wo) || void 0 === i ? void 0 : i.distinctId) && t.pointerId === e.id && (t.detail > 0 || "touch" === t.pointerType || "pen" === t.pointerType) && 0 === t.button && 5 >= Math.abs(t.clientX - e.x) && 5 >= Math.abs(t.clientY - e.y) && n && ($9ae5e4a12de151f5$var$Ar(n, "html") || $9ae5e4a12de151f5$var$Ar(n, "body"))) {
            var r;
            if (e.excluded) return null;
            const t = null !== (r = this.bo().css_selector_ignorelist) && void 0 !== r ? r : $9ae5e4a12de151f5$var$Wr;
            return [
                n,
                null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.documentElement,
                null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.body
            ].some((i)=>{
                if (!i) return !1;
                const e = $9ae5e4a12de151f5$var$jr(i);
                return $9ae5e4a12de151f5$var$b(e, "ph-no-capture") || $9ae5e4a12de151f5$var$b(e, "ph-sensitive") || !$9ae5e4a12de151f5$var$io(i) || $9ae5e4a12de151f5$var$eo(i) || t.some((t)=>$9ae5e4a12de151f5$var$Hr(i, t));
            }) ? null : e.target;
        }
    }
    constructor(t){
        this.So = t, this.name = "autocapture", this.xo = !1, this.Co = null, this.$o = !1, this.To = !1, this.Rr = {
            enabled: !1,
            rageclick: !1,
            maskAllElementAttributes: !1,
            maskAllText: !1,
            disableCaptureUrlHashes: !1,
            remoteRequestsDisabled: !1
        }, this.Io = !1, this.So.refresh(this.Rr), this.rageclicks = new $9ae5e4a12de151f5$var$Ru(this.Rr.rageclick), this.Mo = null;
    }
    setup(t) {
        this.Eo(), this.wo = t;
        const i = t.onRemoteConfig(this.onRemoteConfig.bind(this));
        this.Io ? i.dispose() : (this.Po = i, this.startIfEnabled());
    }
    dispose() {
        var t;
        this.Io || (this.Io = !0, this.wo = void 0, null === (t = this.Po) || void 0 === t || t.dispose(), this.Po = void 0, this.Ro());
    }
    bo() {
        return this.So.refresh(this.Rr), this.Rr;
    }
    Eo() {
        var t, i;
        return this.bo(), this.Rr.url_allowlist = null === (t = this.Rr.url_allowlist) || void 0 === t ? void 0 : t.map((t)=>new RegExp(t)), this.Rr.url_ignorelist = null === (i = this.Rr.url_ignorelist) || void 0 === i ? void 0 : i.map((t)=>new RegExp(t)), this.Rr;
    }
    Ao() {
        if (!this.isBrowserSupported()) return void $9ae5e4a12de151f5$var$Au.info("Disabling Automatic Event Collection because this browser is not supported");
        if (!$9ae5e4a12de151f5$var$t || !$9ae5e4a12de151f5$var$s) return;
        const i = this.Fo = (i)=>{
            i = i || (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.event);
            try {
                if ("blur" === i.type) return void this.fo();
                if (0 === i.type.indexOf("pointer")) return void this._o(i);
                const t = "click" === i.type ? this.ko(i) : void 0;
                if ($9ae5e4a12de151f5$var$M(t)) return;
                this.Oo(i, "$autocapture", t);
            } catch (t) {
                $9ae5e4a12de151f5$var$Au.error("Failed to capture event", t);
            }
        };
        if ($9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "blur", i), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "submit", i, {
            capture: !0
        }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "change", i, {
            capture: !0
        }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "click", i, {
            capture: !0
        }), $9ae5e4a12de151f5$var$Vn([
            "pointerdown",
            "pointermove",
            "pointerup",
            "pointercancel"
        ], (t)=>{
            $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, t, i, {
                capture: !0
            });
        }), this.bo().capture_copied_text) {
            const i = this.Do = (i)=>{
                i = i || (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.event);
                try {
                    this.Oo(i, $9ae5e4a12de151f5$var$Iu);
                } catch (t) {
                    $9ae5e4a12de151f5$var$Au.error("Failed to capture clipboard event", t);
                }
            };
            $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "copy", i, {
                capture: !0
            }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "cut", i, {
                capture: !0
            }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "paste", i, {
                capture: !0
            });
        }
    }
    Ro() {
        this.fo(), this.Fo && (null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.removeEventListener("blur", this.Fo), $9ae5e4a12de151f5$var$Vn([
            "pointerdown",
            "pointermove",
            "pointerup",
            "pointercancel"
        ], (t)=>{
            null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener(t, this.Fo, !0);
        }), null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener("submit", this.Fo, !0), null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener("change", this.Fo, !0), null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener("click", this.Fo, !0), this.Fo = void 0), this.Do && (null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener("copy", this.Do, !0), null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener("cut", this.Do, !0), null == $9ae5e4a12de151f5$var$s || $9ae5e4a12de151f5$var$s.removeEventListener("paste", this.Do, !0), this.Do = void 0), this.xo = !1;
    }
    startIfEnabled() {
        this.isEnabled || this.fo(), !this.Io && this.wo && this.isEnabled && !this.xo && (this.Ao(), this.xo = !0);
    }
    onRemoteConfig(t) {
        if (this.Io) return;
        if (this.$o = !0, !t.ok) return void this.startIfEnabled();
        const i = t.config;
        i.elementsChainAsString && (this.To = i.elementsChainAsString);
        const e = i.autocapture_opt_out;
        var s;
        $9ae5e4a12de151f5$var$j(e) && (null === (s = this.wo) || void 0 === s || s.kv.set("$autocapture_disabled_server_side", e), this.Co = e), this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.Mo = t;
    }
    getElementSelectors(t, i) {
        var e;
        const n = [];
        return null === (e = this.Mo) || void 0 === e || e.forEach((e)=>{
            const r = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.querySelectorAll(e);
            null == r || r.forEach((s)=>{
                t !== s && i !== s || $9ae5e4a12de151f5$var$b(n, e) || n.push(e);
            });
        }), n;
    }
    get isEnabled() {
        var t, i;
        if (this.Io) return !1;
        const e = null === (t = this.wo) || void 0 === t ? void 0 : t.kv.get($9ae5e4a12de151f5$var$fs), s = this.Co, n = this.bo();
        if (!n.remoteRequestsDisabled && !this.$o) return !1;
        const r = n.remoteRequestsDisabled && !this.$o;
        if ($9ae5e4a12de151f5$var$M(s) && !$9ae5e4a12de151f5$var$j(e) && !r) return !1;
        const o = null !== (i = this.Co) && void 0 !== i ? i : !!e;
        return !!n.enabled && !o;
    }
    Oo(i, e = "$autocapture", s) {
        if (!this.isEnabled) return void this.fo();
        let n = s || $9ae5e4a12de151f5$var$Ur(i);
        $9ae5e4a12de151f5$var$Mr(n) && (n = n.parentNode || null);
        const r = this.Eo();
        var o;
        "$autocapture" === e && "click" === i.type && i instanceof MouseEvent && r.rageclick && (null === (o = this.rageclicks) || void 0 === o ? void 0 : o.isRageClick(i.clientX, i.clientY, i.timeStamp || (new Date).getTime())) && $9ae5e4a12de151f5$var$Qr(n, r.rageclick) && this.Oo(i, "$rageclick", s);
        const l = e === $9ae5e4a12de151f5$var$Iu, a = l ? $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, r), {}, {
            dom_event_allowlist: void 0
        }) : r;
        if (n && function(i, e, s, n, r, o) {
            var l;
            if (!$9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$Zr(i)) return !1;
            if ((null == s ? void 0 : s.url_allowlist) && !$9ae5e4a12de151f5$var$Nr(s.url_allowlist, o)) return !1;
            if ((null == s ? void 0 : s.url_ignorelist) && $9ae5e4a12de151f5$var$Nr(s.url_ignorelist, o)) return !1;
            if (null == s ? void 0 : s.dom_event_allowlist) {
                const t = s.dom_event_allowlist;
                if (t && !t.some((t)=>e.type === t)) return !1;
            }
            const { parentIsUsefulElement: a, targetElementList: u } = $9ae5e4a12de151f5$var$to(i, n);
            if (!function(t, i) {
                const e = null == i ? void 0 : i.element_allowlist;
                if ($9ae5e4a12de151f5$var$R(e)) return !0;
                for (const i of t)if (e.some((t)=>i.tagName.toLowerCase() === t)) return !0;
                return !1;
            }(u, s)) return !1;
            if (!$9ae5e4a12de151f5$var$qr(u, null == s ? void 0 : s.css_selector_allowlist)) return !1;
            if ($9ae5e4a12de151f5$var$qr(u, null !== (l = null == s ? void 0 : s.css_selector_ignorelist) && void 0 !== l ? l : $9ae5e4a12de151f5$var$Wr)) return !1;
            try {
                const s = $9ae5e4a12de151f5$var$t.getComputedStyle(i);
                if (s && "pointer" === s.getPropertyValue("cursor") && "click" === e.type) return !0;
            } catch (t) {}
            const h = i.tagName.toLowerCase();
            switch(h){
                case "html":
                    return !1;
                case "form":
                    return (r || [
                        "submit"
                    ]).indexOf(e.type) >= 0;
                case "input":
                case "select":
                case "textarea":
                    return (r || [
                        "change",
                        "click"
                    ]).indexOf(e.type) >= 0;
                default:
                    return a ? (r || [
                        "click"
                    ]).indexOf(e.type) >= 0 : (r || [
                        "click"
                    ]).indexOf(e.type) >= 0 && ($9ae5e4a12de151f5$var$zr.indexOf(h) > -1 || "true" === i.getAttribute("contenteditable"));
            }
        }(n, i, a, l, l ? [
            "copy",
            "cut",
            "paste"
        ] : void 0, {
            config: {
                get_current_url: r.getCurrentUrl
            }
        })) {
            var u;
            const { props: s, explicitNoCapture: o, target: l } = $9ae5e4a12de151f5$var$Du(n, {
                e: i,
                maskAllElementAttributes: r.maskAllElementAttributes,
                maskAllText: r.maskAllText,
                elementAttributeIgnoreList: r.element_attribute_ignorelist,
                elementsChainAsString: this.To,
                disableCaptureUrlHashes: r.disableCaptureUrlHashes
            });
            if (o) return !1;
            const a = this.getElementSelectors(n, l);
            if (a && a.length > 0 && (s.$element_selectors = a), e === $9ae5e4a12de151f5$var$Iu) {
                const e = i.type || "clipboard";
                if ("paste" !== e) {
                    var h, d;
                    const i = null == $9ae5e4a12de151f5$var$t || null === (h = $9ae5e4a12de151f5$var$t.getSelection()) || void 0 === h ? void 0 : h.toString(), e = $9ae5e4a12de151f5$var$Lr(i);
                    if (!e) return !1;
                    s.$selected_content = e, s.$clipboard_text_length = null !== (d = null == i ? void 0 : i.length) && void 0 !== d ? d : 0;
                }
                s.$copy_type = e;
            }
            return null === (u = this.wo) || void 0 === u || u.capture(e, s), !0;
        }
    }
    isBrowserSupported() {
        return $9ae5e4a12de151f5$var$P(null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.querySelectorAll);
    }
}, $9ae5e4a12de151f5$var$ju = class {
    constructor(t){
        this._instance = t;
    }
    refresh(t) {
        const i = this._instance.config, e = $9ae5e4a12de151f5$var$C(i.autocapture) ? i.autocapture : void 0;
        t.enabled = !!i.autocapture, t.rageclick = i.rageclick, t.maskAllElementAttributes = i.mask_all_element_attributes, t.maskAllText = i.mask_all_text, t.disableCaptureUrlHashes = i.disable_capture_url_hashes, t.getCurrentUrl = i.get_current_url, t.remoteRequestsDisabled = this._instance.nl(), t.url_allowlist = null == e ? void 0 : e.url_allowlist, t.url_ignorelist = null == e ? void 0 : e.url_ignorelist, t.dom_event_allowlist = null == e ? void 0 : e.dom_event_allowlist, t.element_allowlist = null == e ? void 0 : e.element_allowlist, t.css_selector_allowlist = null == e ? void 0 : e.css_selector_allowlist, t.css_selector_ignorelist = null == e ? void 0 : e.css_selector_ignorelist, t.element_attribute_ignorelist = null == e ? void 0 : e.element_attribute_ignorelist, t.capture_copied_text = null == e ? void 0 : e.capture_copied_text;
    }
};
const $9ae5e4a12de151f5$var$Lu = $9ae5e4a12de151f5$var$Ye("[ExceptionAutocapture]"), $9ae5e4a12de151f5$var$Bu = ()=>{}, $9ae5e4a12de151f5$var$Uu = (t)=>{
    var i;
    if ($9ae5e4a12de151f5$var$P(t)) return null !== (i = t.__posthog_layer__) && void 0 !== i ? i : t.__rrweb_layer__;
};
function $9ae5e4a12de151f5$var$zu(t, i, e) {
    try {
        if (!(i in t)) return $9ae5e4a12de151f5$var$Bu;
        const s = {
            next: t[i]
        }, n = e(function(...t) {
            return s.next.apply(this, t);
        });
        return $9ae5e4a12de151f5$var$P(n) && (n.prototype = n.prototype || {}, Object.defineProperties(n, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            },
            __posthog_layer__: {
                enumerable: !1,
                value: s
            }
        })), t[i] = n, ()=>{
            if (t[i] === n) return void (t[i] = s.next);
            let e = t[i], r = $9ae5e4a12de151f5$var$Uu(e);
            for(; r;){
                if (r.next === n) return void (r.next = s.next);
                e = r.next, r = $9ae5e4a12de151f5$var$Uu(e);
            }
        };
    } catch (t) {
        return $9ae5e4a12de151f5$var$Bu;
    }
}
const $9ae5e4a12de151f5$var$Hu = $9ae5e4a12de151f5$var$Ye("[TracingHeaders]"), $9ae5e4a12de151f5$var$qu = $9ae5e4a12de151f5$var$Ye("[Web Vitals]"), $9ae5e4a12de151f5$var$Vu = 9e5, $9ae5e4a12de151f5$var$Wu = [
    "CLS",
    "FCP",
    "INP",
    "LCP"
], $9ae5e4a12de151f5$var$Gu = [
    "INP",
    "LCP"
], $9ae5e4a12de151f5$var$Ku = [
    "interactionTarget",
    "interactionType",
    "inputDelay",
    "processingDuration",
    "presentationDelay",
    "loadState",
    "target",
    "url",
    "timeToFirstByte",
    "resourceLoadDelay",
    "resourceLoadDuration",
    "elementRenderDelay",
    "largestShiftTarget",
    "largestShiftTime",
    "largestShiftValue",
    "firstByteToFCP"
], $9ae5e4a12de151f5$var$Ju = "disabled", $9ae5e4a12de151f5$var$Yu = "lazy_loading", $9ae5e4a12de151f5$var$Xu = $9ae5e4a12de151f5$var$Ye("[SessionRecording]"), $9ae5e4a12de151f5$var$Qu = $9ae5e4a12de151f5$var$Ye("[Heatmaps]");
function $9ae5e4a12de151f5$var$Zu(t) {
    return $9ae5e4a12de151f5$var$C(t) && "clientX" in t && "clientY" in t && $9ae5e4a12de151f5$var$D(t.clientX) && $9ae5e4a12de151f5$var$D(t.clientY);
}
const $9ae5e4a12de151f5$var$th = $9ae5e4a12de151f5$var$Ye("[Product Tours]"), $9ae5e4a12de151f5$var$ih = (t)=>{
    var i;
    return !t.config.disable_product_tours && !!(null === (i = t.persistence) || void 0 === i ? void 0 : i.get_property($9ae5e4a12de151f5$var$ws));
}, $9ae5e4a12de151f5$var$eh = [
    "$set_once",
    "$set"
], $9ae5e4a12de151f5$var$sh = $9ae5e4a12de151f5$var$Ye("[SiteApps]"), $9ae5e4a12de151f5$var$nh = "Error while initializing PostHog app with config id ", $9ae5e4a12de151f5$var$rh = (t, i)=>(null == t ? void 0 : t.then) ? t.then(i) : i(t), $9ae5e4a12de151f5$var$oh = "SDK is not enabled or survey functionality is not yet loaded", $9ae5e4a12de151f5$var$lh = "Disabled. Not loading surveys.";
var $9ae5e4a12de151f5$var$ah = class {
    constructor(t, i){
        this.So = t, this.Th = i, this.name = "surveys", this._surveyEventReceiver = null, this._surveyManager = null, this.Ih = !1, this.Mh = [], this.Eh = null, this.Ph = null, this.Io = !1, this.Rh = new Set, this.onRemoteConfig = (t)=>{
            if (this.Io) return;
            if (this.Rr.disableSurveys) return;
            if (!t.ok) return $9ae5e4a12de151f5$var$eu.warn("Remote config unavailable. Not loading surveys.");
            const i = t.config.surveys;
            if ($9ae5e4a12de151f5$var$F(i)) return $9ae5e4a12de151f5$var$eu.warn("Flags not loaded yet. Not loading surveys.");
            this.Ah = $9ae5e4a12de151f5$var$j(i) ? i : i.length > 0, $9ae5e4a12de151f5$var$eu.info(`flags response received, isSurveysEnabled: ${this.Ah}`), this.loadIfEnabled();
        };
    }
    setup(t) {
        if (!this.Io) return this.Fh = t, $9ae5e4a12de151f5$var$rh(t.kv.initialize(), ()=>{
            if (this.Fh !== t || this.Io) return;
            this.Fh = void 0, this.wo = t;
            const i = t.onRemoteConfig(this.onRemoteConfig);
            this.Io ? i.dispose() : (this.Po = i, this.loadIfEnabled());
        });
    }
    dispose() {
        var t, i, e, s;
        this.Io || (this.Io = !0, this.Fh = void 0, this.wo = void 0, null === (t = this.Po) || void 0 === t || t.dispose(), this.Po = void 0, null === (i = this._surveyEventReceiver) || void 0 === i || i.dispose(), this._surveyEventReceiver = null, null === (e = this._surveyManager) || void 0 === e || null === (s = e.dispose) || void 0 === s || s.call(e), this._surveyManager = null, this.Mh = [], this.Eh = null, this.Rh.forEach((t)=>clearTimeout(t)), this.Rh.clear());
    }
    get Rr() {
        return this.So.get();
    }
    initialize() {
        this.loadIfEnabled();
    }
    reset() {
        var t, i;
        null === (t = this._surveyManager) || void 0 === t || null === (i = t.clearInMemoryInProgressSurveyState) || void 0 === i || i.call(t);
        try {
            var e;
            null === (e = this._surveyEventReceiver) || void 0 === e || e.reset(), localStorage.removeItem("lastSeenSurveyDate");
            const t = [];
            for(let i = 0; i < localStorage.length; i++){
                const e = localStorage.key(i);
                ((null == e ? void 0 : e.startsWith("seenSurvey_")) || (null == e ? void 0 : e.startsWith("inProgressSurvey_"))) && t.push(e);
            }
            t.forEach((t)=>localStorage.removeItem(t));
        } catch (t) {}
    }
    loadIfEnabled() {
        if (this.Io || !this.wo) return;
        const t = this.Rr;
        if (this._surveyManager) return;
        if (this.Ih) return void $9ae5e4a12de151f5$var$eu.info("Already initializing surveys, skipping...");
        if (t.disableSurveys) return void $9ae5e4a12de151f5$var$eu.info($9ae5e4a12de151f5$var$lh);
        if (t.cookielessMode && this.So.isOptedOut()) return void $9ae5e4a12de151f5$var$eu.info("Not loading surveys in cookieless mode without consent.");
        const i = this.So.getExtensions();
        if (!i) return void $9ae5e4a12de151f5$var$eu.error("PostHog Extensions not found.");
        if ($9ae5e4a12de151f5$var$R(this.Ah) && !t.advancedEnableSurveys) return;
        const e = this.Ah || t.advancedEnableSurveys;
        this.Ih = !0;
        try {
            const t = i.generateSurveys;
            if (t) return this.Oh(t, e), void (this.Ih = !1);
            const s = i.loadExternalDependency;
            if (!s) return this.Dh($9ae5e4a12de151f5$var$Mn), void (this.Ih = !1);
            s((t)=>{
                try {
                    if (this.Io) return;
                    const i = this.So.getExtensions();
                    t || !(null == i ? void 0 : i.generateSurveys) ? this.Dh("Could not load surveys script", t) : this.Oh(i.generateSurveys, e);
                } finally{
                    this.Ih = !1;
                }
            });
        } catch (t) {
            throw this.Ih = !1, this.Dh("Error initializing surveys", t), t;
        }
    }
    Oh(t, i) {
        this.Io || (this._surveyManager = t(i), this._surveyEventReceiver = this.So.createEventReceiver(), $9ae5e4a12de151f5$var$eu.info("Surveys loaded successfully"), this.Lh({
            isLoaded: !0
        }));
    }
    Dh(t, i) {
        $9ae5e4a12de151f5$var$eu.error(t, i), this.Lh({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.Mh.push(t), this._surveyManager && this.Lh({
            isLoaded: !0
        }), ()=>{
            this.Mh = this.Mh.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i = !1) {
        var e;
        const s = null !== (e = this.wo) && void 0 !== e ? e : this.Th;
        if (!s || this.Io) return;
        if (this.Rr.disableSurveys) return $9ae5e4a12de151f5$var$eu.info($9ae5e4a12de151f5$var$lh), t([]);
        const n = s.kv.get($9ae5e4a12de151f5$var$Ys);
        if (n && !i) return t(n, {
            isLoaded: !0
        }), void (this.Nh() && this.getSurveys(()=>{}, !0));
        if (this.Eh) return void this.Eh.then(({ surveys: i, context: e })=>{
            this.Io || t(i, e);
        }).catch((t)=>$9ae5e4a12de151f5$var$eu.error("Error in survey callback", t));
        const r = this.qh("/api/surveys/", {
            method: "GET",
            query: {
                token: s.projectToken
            },
            sentAt: "query",
            timeoutMs: this.Rr.requestTimeoutMs
        }).then((t)=>{
            try {
                return this.jh(s, t);
            } catch (t) {
                return $9ae5e4a12de151f5$var$eu.error("Error processing surveys response", t), this.jh(s, {
                    statusCode: 0,
                    error: t
                });
            }
        }, (t)=>this.jh(s, {
                statusCode: 0,
                error: t
            }));
        this.Eh = r;
        const o = ()=>{
            this.Eh === r && (this.Eh = null);
        };
        r.then((i)=>{
            o(), this.Io || t(i.surveys, i.context);
        }, o).catch((t)=>$9ae5e4a12de151f5$var$eu.error("Error in survey callback", t));
    }
    qh(t, i) {
        const e = this.wo;
        return e ? e.sendRequest(t, i) : new Promise((t)=>t({
                statusCode: 0,
                error: new Error($9ae5e4a12de151f5$var$oh)
            }));
    }
    jh(t, i) {
        if (this.Io) return {
            surveys: [],
            context: {
                isLoaded: !1,
                error: $9ae5e4a12de151f5$var$oh
            }
        };
        const e = i.statusCode;
        if (200 !== e || !i.json) {
            const t = `Surveys API could not be loaded, status: ${e}`;
            return 0 !== e ? $9ae5e4a12de151f5$var$eu.error(t) : i.error || $9ae5e4a12de151f5$var$eu.warn(t), this.Ph = Date.now(), {
                surveys: [],
                context: {
                    isLoaded: !1,
                    error: t
                }
            };
        }
        this.Ph = null;
        const s = i.json.surveys || [], n = s.filter((t)=>(function(t) {
                return !(!t.start_date || t.end_date);
            })(t) && ($9ae5e4a12de151f5$var$Va(t) || function(t) {
                var i;
                return !!(null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length);
            }(t)));
        var r;
        return n.length > 0 && (null === (r = this._surveyEventReceiver) || void 0 === r || r.register(n)), t.kv.set({
            [$9ae5e4a12de151f5$var$Ys]: s,
            [$9ae5e4a12de151f5$var$Xs]: Date.now()
        }), {
            surveys: s,
            context: {
                isLoaded: !0
            }
        };
    }
    Nh() {
        return this.Bh() && !this.Eh && !this.Hh();
    }
    Bh() {
        var t, i;
        const e = null === (t = null !== (i = this.wo) && void 0 !== i ? i : this.Th) || void 0 === t ? void 0 : t.kv.get($9ae5e4a12de151f5$var$Xs);
        return $9ae5e4a12de151f5$var$D(e) && Date.now() - e > 3e5;
    }
    Hh() {
        return $9ae5e4a12de151f5$var$D(this.Ph) && 3e5 > Date.now() - this.Ph;
    }
    markSurveyAsSeen(t, i) {
        var e;
        const s = {
            id: t,
            current_iteration: null !== (e = null == i ? void 0 : i.iteration) && void 0 !== e ? e : null
        };
        $9ae5e4a12de151f5$var$su(s);
        try {
            localStorage.setItem("lastSeenSurveyDate", (new Date).toISOString());
        } catch (t) {}
    }
    Lh(t) {
        for (const i of this.Mh)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            $9ae5e4a12de151f5$var$eu.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i = !1) {
        if (!$9ae5e4a12de151f5$var$F(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        $9ae5e4a12de151f5$var$eu.warn("init was not called");
    }
    zh(t) {
        let i = null;
        return this.getSurveys((e)=>{
            var s;
            i = null !== (s = e.find((i)=>i.id === t)) && void 0 !== s ? s : null;
        }), i;
    }
    Uh(t) {
        if ($9ae5e4a12de151f5$var$F(this._surveyManager)) return {
            eligible: !1,
            reason: $9ae5e4a12de151f5$var$oh
        };
        const i = "string" == typeof t ? this.zh(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    Wh(t) {
        if (!this.So.isCapturing()) return {
            eligible: !1,
            reason: "PostHog is not capturing, so a survey response cannot be recorded"
        };
        if ($9ae5e4a12de151f5$var$F(this._surveyManager)) return {
            eligible: !1,
            reason: $9ae5e4a12de151f5$var$oh
        };
        const i = "string" == typeof t ? this.zh(t) : t;
        return i ? this._surveyManager.checkSurveyRenderability(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($9ae5e4a12de151f5$var$F(this._surveyManager)) return $9ae5e4a12de151f5$var$eu.warn("init was not called"), {
            visible: !1,
            disabledReason: $9ae5e4a12de151f5$var$oh
        };
        const i = this.Wh(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $9ae5e4a12de151f5$var$F(this._surveyManager) ? ($9ae5e4a12de151f5$var$eu.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: $9ae5e4a12de151f5$var$oh
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var s;
                const n = null !== (s = i.find((i)=>i.id === t)) && void 0 !== s ? s : null;
                if (n) {
                    const t = this.Wh(n);
                    e({
                        visible: t.eligible,
                        disabledReason: t.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i, e) {
        var n;
        if (!this.So.isCapturing()) return;
        if ($9ae5e4a12de151f5$var$F(this._surveyManager)) return void $9ae5e4a12de151f5$var$eu.warn("init was not called");
        const r = "string" == typeof t ? this.zh(t) : t;
        if (!(null == r ? void 0 : r.id)) return void $9ae5e4a12de151f5$var$eu.warn("Survey not found");
        if (!$9ae5e4a12de151f5$var$nu.includes(r.type)) return void $9ae5e4a12de151f5$var$eu.warn(`Surveys of type ${r.type} cannot be rendered in the app`);
        const o = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.querySelector(i);
        if (o) {
            if (null === (n = r.appearance) || void 0 === n ? void 0 : n.surveyPopupDelaySeconds) {
                $9ae5e4a12de151f5$var$eu.info(`Rendering survey ${r.id} with delay of ${r.appearance.surveyPopupDelaySeconds} seconds`);
                const t = setTimeout(()=>{
                    var i, s;
                    this.Rh.delete(t), !this.Io && this.So.isCapturing() && ($9ae5e4a12de151f5$var$eu.info(`Rendering survey ${r.id} with delay of ${null === (i = r.appearance) || void 0 === i ? void 0 : i.surveyPopupDelaySeconds} seconds`), null === (s = this._surveyManager) || void 0 === s || s.renderSurvey(r, o, e), $9ae5e4a12de151f5$var$eu.info(`Survey ${r.id} rendered`));
                }, 1e3 * r.appearance.surveyPopupDelaySeconds);
                return void this.Rh.add(t);
            }
            this._surveyManager.renderSurvey(r, o, e);
        } else $9ae5e4a12de151f5$var$eu.warn("Survey element not found");
    }
    displaySurvey(t, i) {
        var e;
        if (!this.So.isCapturing()) return;
        if ($9ae5e4a12de151f5$var$F(this._surveyManager)) return void $9ae5e4a12de151f5$var$eu.warn("init was not called");
        const s = this.zh(t);
        if (!s) return void $9ae5e4a12de151f5$var$eu.warn("Survey not found");
        let n = s;
        if ((null === (e = s.appearance) || void 0 === e ? void 0 : e.surveyPopupDelaySeconds) && i.ignoreDelay && (n = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), {}, {
            appearance: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s.appearance), {}, {
                surveyPopupDelaySeconds: 0
            })
        })), i.displayType !== $9ae5e4a12de151f5$export$a8a66d9d1b857494.Popover && i.initialResponses && $9ae5e4a12de151f5$var$eu.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === i.ignoreConditions) {
            const t = this.Uh(s);
            if (!t.eligible) return void $9ae5e4a12de151f5$var$eu.warn("Survey is not eligible to be displayed: ", t.reason);
        }
        i.displayType !== $9ae5e4a12de151f5$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(n, i) : this.renderSurvey(n, i.selector, i.properties);
    }
    cancelPendingSurvey(t) {
        $9ae5e4a12de151f5$var$F(this._surveyManager) ? $9ae5e4a12de151f5$var$eu.warn("init was not called") : this._surveyManager.cancelSurvey(t);
    }
    handlePageUnload() {
        var t, i;
        null === (t = this._surveyManager) || void 0 === t || null === (i = t.handlePageUnload) || void 0 === i || i.call(t);
    }
};
function $9ae5e4a12de151f5$var$uh(t, i, e) {
    if ($9ae5e4a12de151f5$var$F(t)) return !1;
    switch(e){
        case "exact":
            return t === i;
        case "contains":
            {
                const e = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
                return new RegExp(e, "i").test(t);
            }
        case "regex":
            try {
                return new RegExp(i).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
var $9ae5e4a12de151f5$var$hh = class {
    constructor(t){
        this._instance = t, this.Vh = new Set, this.Gh = new Set, this.Zh = new $9ae5e4a12de151f5$var$ja, this.Qh = (t, i)=>this.Jh(t, i) && this.Kh(t, i) && this.Xh(t, i) && this.Yh(t, i), this.Jh = (t, i)=>!(null == i ? void 0 : i.event) || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event);
    }
    init() {
        var t, i;
        $9ae5e4a12de151f5$var$R(null === (t = this._instance) || void 0 === t ? void 0 : t._addCaptureHook) || (this.tc = null === (i = this._instance) || void 0 === i ? void 0 : i._addCaptureHook((t, i)=>{
            this.on(t, i);
        }));
    }
    dispose() {
        var t;
        null === (t = this.tc) || void 0 === t || t.call(this), this.tc = void 0, this.Zh = new $9ae5e4a12de151f5$var$ja;
    }
    register(t) {
        var i, e;
        if (!$9ae5e4a12de151f5$var$R(null === (i = this._instance) || void 0 === i ? void 0 : i._addCaptureHook) && (t.forEach((t)=>{
            var i;
            this.Vh.add(t), null === (i = t.steps) || void 0 === i || i.forEach((t)=>{
                this.Gh.add((null == t ? void 0 : t.event) || "");
            });
        }), null === (e = this._instance) || void 0 === e ? void 0 : e.autocapture)) {
            const t = new Set;
            this.Vh.forEach((i)=>{
                var e;
                null === (e = i.steps) || void 0 === e || e.forEach((i)=>{
                    (null == i ? void 0 : i.selector) && t.add(i.selector);
                });
            }), this._instance.autocapture.setElementSelectors(t);
        }
    }
    replace(t) {
        this.Vh.clear(), this.Gh.clear(), this.register(t);
    }
    on(t, i) {
        null != i && 0 != t.length && (this.Gh.has(t) || this.Gh.has(i.event)) && this.Vh.forEach((t)=>{
            this.ec(i, t) && this.Zh.emit("actionCaptured", t.name);
        });
    }
    nc(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    ec(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (const e of i.steps)if (this.Qh(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Zh.on(t, i);
    }
    Kh(t, i) {
        if (null == i ? void 0 : i.url) {
            var e;
            const s = null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$current_url;
            if (!s || "string" != typeof s) return !1;
            if (!$9ae5e4a12de151f5$var$uh(s, i.url, i.url_matching || "contains")) return !1;
        }
        return !0;
    }
    Xh(t, i) {
        return !!this.sc(t, i) && !!this.rc(t, i) && !!this.oc(t, i);
    }
    sc(t, i) {
        var e;
        if (!(null == i ? void 0 : i.href)) return !0;
        const s = this.ac(t);
        if (s.length > 0) return s.some((t)=>$9ae5e4a12de151f5$var$uh(t.href, i.href, i.href_matching || "exact"));
        const n = (null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$elements_chain) || "";
        return !!n && $9ae5e4a12de151f5$var$uh(function(t) {
            const i = t.match(/(?::|")href="(.*?)"/);
            return i ? i[1] : "";
        }(n), i.href, i.href_matching || "exact");
    }
    rc(t, i) {
        var e;
        if (!(null == i ? void 0 : i.text)) return !0;
        const s = this.ac(t);
        if (s.length > 0) return s.some((t)=>$9ae5e4a12de151f5$var$uh(t.text, i.text, i.text_matching || "exact") || $9ae5e4a12de151f5$var$uh(t.$el_text, i.text, i.text_matching || "exact"));
        const n = (null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$elements_chain) || "";
        var r, o, l;
        return !!n && (r = function(t) {
            const i = [], e = /(?::|")text="(.*?)"/g;
            let s;
            for(; !$9ae5e4a12de151f5$var$F(s = e.exec(t));)i.includes(s[1]) || i.push(s[1]);
            return i;
        }(n), o = i.text, l = i.text_matching || "exact", r.some((t)=>$9ae5e4a12de151f5$var$uh(t, o, l)));
    }
    oc(t, i) {
        var e, s;
        if (!(null == i ? void 0 : i.selector)) return !0;
        const n = null == t || null === (e = t.properties) || void 0 === e ? void 0 : e.$element_selectors;
        if (null == n ? void 0 : n.includes(i.selector)) return !0;
        const r = (null == t || null === (s = t.properties) || void 0 === s ? void 0 : s.$elements_chain) || "";
        if (i.selector_regex && r) try {
            return new RegExp(i.selector_regex).test(r);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    ac(t) {
        var i;
        return null == (null == t || null === (i = t.properties) || void 0 === i ? void 0 : i.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    Yh(t, i) {
        return !(null == i ? void 0 : i.properties) || 0 === i.properties.length || $9ae5e4a12de151f5$var$Ja(i.properties.reduce((t, i)=>{
            const e = $9ae5e4a12de151f5$var$T(i.value) ? i.value.map(String) : null != i.value ? [
                String(i.value)
            ] : [];
            return t[i.key] = {
                values: e,
                operator: i.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}, $9ae5e4a12de151f5$var$dh = class {
    constructor(t){
        var i, e;
        this.lc = [], this._instance = t, this.uc = new Map, this.hc = new Map, this.cc = new Map, this.dc = null === (i = this._instance) || void 0 === i || null === (e = i.onSessionId) || void 0 === e ? void 0 : e.call(i, (t)=>this.vc(t));
    }
    fc(t) {
        return !1;
    }
    gc() {
        return null;
    }
    mc(t) {}
    yc() {}
    bc(t, i) {
        return !!t && $9ae5e4a12de151f5$var$Ja(t.propertyFilters, null == i ? void 0 : i.properties);
    }
    _c(t, i) {
        const e = new Map;
        return t.forEach((t)=>{
            var s;
            null === (s = t.conditions) || void 0 === s || null === (s = s[i]) || void 0 === s || null === (s = s.values) || void 0 === s || s.forEach((i)=>{
                if (null == i ? void 0 : i.name) {
                    const s = e.get(i.name) || [];
                    s.push(t.id), e.set(i.name, s);
                }
            });
        }), e;
    }
    wc(t, i, e) {
        const s = (e === $9ae5e4a12de151f5$export$352273f853caad57.Activation ? this.uc : this.hc).get(t);
        let n = [];
        return this.kc((t)=>{
            n = t.filter((t)=>null == s ? void 0 : s.includes(t.id));
        }), n.filter((s)=>{
            var n;
            const r = null === (n = s.conditions) || void 0 === n || null === (n = n[e]) || void 0 === n || null === (n = n.values) || void 0 === n ? void 0 : n.find((i)=>i.name === t);
            return this.bc(r, i);
        });
    }
    register(t) {
        this.Sc(t, !1);
    }
    replace(t) {
        this.Sc(t, !0);
    }
    Sc(t, i) {
        var e;
        $9ae5e4a12de151f5$var$R(null === (e = this._instance) || void 0 === e ? void 0 : e._addCaptureHook) || (this.xc(t, i), this.Cc(t, i));
    }
    Cc(t, i) {
        const e = t.filter((t)=>{
            var i;
            return null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || null === (i = i.values) || void 0 === i ? void 0 : i.length;
        });
        var s;
        if (i && this.cc.clear(), 0 === e.length) return void (i && (null === (s = this.$c) || void 0 === s || s.replace([])));
        this.$c || (this.$c = new $9ae5e4a12de151f5$var$hh(this._instance), this.$c.init(), this.$c.nc((t)=>this.onAction(t)));
        const n = [];
        e.forEach((t)=>{
            var i;
            null === (i = t.conditions) || void 0 === i || null === (i = i.actions) || void 0 === i || i.values.forEach((i)=>{
                if (n.push(i), i.name) {
                    var e;
                    const s = null !== (e = this.cc.get(i.name)) && void 0 !== e ? e : [];
                    s.includes(t.id) || s.push(t.id), this.cc.set(i.name, s);
                }
            });
        }), i ? this.$c.replace(n) : this.$c.register(n);
    }
    Tc(t, i) {
        i.forEach((i, e)=>{
            var s;
            const n = null !== (s = t.get(e)) && void 0 !== s ? s : [];
            i.forEach((t)=>{
                n.includes(t) || n.push(t);
            }), t.set(e, n);
        });
    }
    xc(t, i) {
        var e, s;
        const n = t.filter((t)=>{
            var i, e;
            return (null === (i = t.conditions) || void 0 === i ? void 0 : i.events) && (null === (e = t.conditions) || void 0 === e || null === (e = e.events) || void 0 === e || null === (e = e.values) || void 0 === e ? void 0 : e.length) > 0;
        }), r = t.filter((t)=>{
            var i, e;
            return (null === (i = t.conditions) || void 0 === i ? void 0 : i.cancelEvents) && (null === (e = t.conditions) || void 0 === e || null === (e = e.cancelEvents) || void 0 === e || null === (e = e.values) || void 0 === e ? void 0 : e.length) > 0;
        }), o = this._c(t, $9ae5e4a12de151f5$export$352273f853caad57.Activation), l = this._c(t, $9ae5e4a12de151f5$export$352273f853caad57.Cancellation);
        i ? (this.uc = o, this.hc = l) : (this.Tc(this.uc, o), this.Tc(this.hc, l)), (0 !== n.length || 0 !== r.length) && (null !== (e = this.tc) && void 0 !== e || (this.tc = null === (s = this._instance) || void 0 === s ? void 0 : s._addCaptureHook((t, i)=>{
            this.onEvent(t, i);
        })));
    }
    onEvent(t, i) {
        var e, s;
        const n = this.Ic(), r = (null == i || null === (e = i.properties) || void 0 === e ? void 0 : e.$survey_id) || (null == i || null === (s = i.properties) || void 0 === s ? void 0 : s.$product_tour_id);
        if (r && this.getActivatedIds().includes(r)) {
            const i = this.Mc(t, r);
            if ("consume" === i) return n.info("event consumed activated item, removing it", {
                event: t,
                itemId: r
            }), void this.Ec([
                r
            ]);
            if ("persist" === i) return n.info("shown item promoted to persisted activation", {
                event: t,
                itemId: r
            }), this.Pc(r), void this.Rc([
                r
            ]);
        }
        if (this.hc.has(t)) {
            const e = this.wc(t, i, $9ae5e4a12de151f5$export$352273f853caad57.Cancellation);
            e.length > 0 && (n.info("cancel event matched, cancelling items", {
                event: t,
                itemsToCancel: e.map((t)=>t.id)
            }), this.Ec(e.map((t)=>t.id)), e.forEach((t)=>this.Ac(t.id)));
        }
        if (!this.uc.has(t)) return;
        n.info("event name matched", {
            event: t,
            eventPayload: i,
            items: this.uc.get(t)
        });
        const o = this.wc(t, i, $9ae5e4a12de151f5$export$352273f853caad57.Activation);
        this.Fc(o.map((t)=>t.id));
    }
    onAction(t) {
        this.cc.has(t) && this.Fc(this.cc.get(t) || []);
    }
    Fc(t) {
        var i, e;
        if (0 === t.length) return;
        const s = !!(null === (i = this._instance) || void 0 === i || null === (e = i.get_session_id) || void 0 === e ? void 0 : e.call(i)), n = [];
        for (const i of t)s && this.fc(i) ? this.Pc(i) && this.Oc(i) : n.push(i);
        n.length > 0 && (this.lc = [
            ...new Set([
                ...this.lc,
                ...n
            ])
        ]), this.Ic().info("updating activated items", {
            activatedItems: this.getActivatedIds()
        });
    }
    Pc(t) {
        this.lc = this.lc.filter((i)=>i !== t);
        const i = this.Dc();
        return !i.includes(t) && (this.Lc([
            ...i,
            t
        ]), this.Nc(), !0);
    }
    Ec(t) {
        const i = new Set(t);
        this.lc = this.lc.filter((t)=>!i.has(t));
        const e = this.qc(), s = e.filter((t)=>!i.has(t));
        s.length !== e.length && (this.Lc(s), 0 === s.length && this.jc()), this.Rc(t);
    }
    Bc() {
        var t;
        const i = this.gc();
        if (!i) return {};
        const e = null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.props[i];
        return e && "object" == typeof e ? e : {};
    }
    Oc(t) {
        if (!this.gc()) return;
        const i = this.Bc();
        this.mc($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), {}, {
            [t]: Date.now()
        }));
    }
    Rc(t) {
        if (!this.gc()) return;
        const i = this.Bc(), e = {};
        let s = !1;
        for (const [n, r] of Object.entries(i))t.includes(n) ? s = !0 : e[n] = r;
        s && ($9ae5e4a12de151f5$var$O(e) ? this.yc() : this.mc(e));
    }
    Hc() {
        this.gc() && this.yc();
    }
    getActivationTimestamp(t) {
        if (!this.Dc().includes(t)) return;
        const i = this.Bc()[t];
        return $9ae5e4a12de151f5$var$D(i) ? i : void 0;
    }
    qc() {
        var t;
        const i = this.zc();
        return (null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.props[i]) || [];
    }
    Dc() {
        var t, i, e;
        const s = this.qc();
        if (0 === s.length) return [];
        const n = null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.props[this.Uc()], r = null === (i = this._instance) || void 0 === i || null === (e = i.get_session_id) || void 0 === e ? void 0 : e.call(i);
        return r && n === r ? s : [];
    }
    Nc() {
        var t, i;
        const e = null === (t = this._instance) || void 0 === t || null === (i = t.get_session_id) || void 0 === i ? void 0 : i.call(t);
        e && this.Wc(e);
    }
    jc() {
        this.Vc();
    }
    vc(t) {
        var i;
        const e = null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i ? void 0 : i.props[this.Uc()];
        if (e && e !== t) {
            const t = this.qc(), i = this.Bc();
            t.length > 0 && (this.Lc([]), t.filter((t)=>$9ae5e4a12de151f5$var$D(i[t])).forEach((t)=>this.Ac(t))), this.jc(), this.Hc();
        }
    }
    getActivatedIds() {
        return [
            ...new Set([
                ...this.Dc(),
                ...this.lc
            ])
        ].filter((t)=>!this.Gc(t));
    }
    dispose() {
        var t, i, e;
        null === (t = this.dc) || void 0 === t || t.call(this), this.dc = void 0, null === (i = this.tc) || void 0 === i || i.call(this), this.tc = void 0, null === (e = this.$c) || void 0 === e || e.dispose(), this.$c = void 0;
    }
    reset() {
        this.lc = [], this.qc().length > 0 && this.Lc([]), this.jc(), this.Hc();
    }
    getEventToItemsMap() {
        return this.uc;
    }
    Zc() {
        return this.$c;
    }
}, $9ae5e4a12de151f5$var$ch = class extends $9ae5e4a12de151f5$var$dh {
    constructor(t){
        super(t);
    }
    zc() {
        return $9ae5e4a12de151f5$var$Qs;
    }
    Uc() {
        return $9ae5e4a12de151f5$var$Zs;
    }
    gc() {
        return $9ae5e4a12de151f5$var$tn;
    }
    mc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i || i.register({
            $surveys_activated_timestamps: t
        });
    }
    yc() {
        var t;
        null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t || t.unregister("$surveys_activated_timestamps");
    }
    fc(t) {
        var i;
        let e;
        this.kc((i)=>{
            e = i.find((i)=>i.id === t);
        });
        const s = null == e || null === (i = e.appearance) || void 0 === i ? void 0 : i.surveyPopupDelaySeconds;
        return $9ae5e4a12de151f5$var$D(s) && s > 0;
    }
    Qc() {
        return $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SHOWN;
    }
    kc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || i.getSurveys(t);
    }
    Ac(t) {
        var i;
        null === (i = this._instance) || void 0 === i || i.cancelPendingSurvey(t);
    }
    Ic() {
        return $9ae5e4a12de151f5$var$eu;
    }
    Lc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i || i.register({
            $surveys_activated: t
        });
    }
    Wc(t) {
        var i;
        null === (i = this._instance) || void 0 === i || null === (i = i.persistence) || void 0 === i || i.register({
            $surveys_activated_session: t
        });
    }
    Vc() {
        var t;
        null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t || t.unregister("$surveys_activated_session");
    }
    Gc() {
        return !1;
    }
    Mc(t, i) {
        let e;
        return this.kc((t)=>{
            e = t.find((t)=>t.id === i);
        }), !e || function(t) {
            var i;
            return $9ae5e4a12de151f5$var$Va(t) && !!(null === (i = t.conditions) || void 0 === i || null === (i = i.events) || void 0 === i ? void 0 : i.repeatedActivation) || "always" === t.schedule;
        }(e) ? t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SHOWN ? "consume" : "ignore" : t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SHOWN ? "persist" : t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.DISMISSED || t === $9ae5e4a12de151f5$export$9d7ec1793ca1658e.SENT ? "consume" : "ignore";
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}, $9ae5e4a12de151f5$var$vh = class {
    constructor(t){
        this._instance = t;
    }
    initialize() {}
    get(t) {
        if ("string" == typeof t) return this._instance.get_property(t);
        const i = {};
        for (const e of t){
            const t = this._instance.get_property(e);
            $9ae5e4a12de151f5$var$R(t) || (i[e] = t);
        }
        return i;
    }
    set(t, i) {
        this._instance.register("string" == typeof t ? {
            [t]: i
        } : t);
    }
    remove(t) {
        "string" != typeof t ? t.forEach((t)=>this._instance.unregister(t)) : this._instance.unregister(t);
    }
}, $9ae5e4a12de151f5$var$fh = class {
    constructor(t){
        this._instance = t;
    }
    get() {
        const t = this._instance.config;
        return {
            disableSurveys: t.disable_surveys,
            cookielessMode: !!t.cookieless_mode,
            advancedEnableSurveys: t.advanced_enable_surveys,
            requestTimeoutMs: t.surveys_request_timeout_ms
        };
    }
    isOptedOut() {
        return this._instance.consent.isOptedOut();
    }
    isCapturing() {
        return this._instance.is_capturing();
    }
    getExtensions() {
        const t = null == $9ae5e4a12de151f5$var$c ? void 0 : $9ae5e4a12de151f5$var$c.__PosthogExtensions__;
        if (!t) return;
        const { generateSurveys: i, loadExternalDependency: e } = t;
        return {
            generateSurveys: i ? (t)=>i(this._instance, t) : void 0,
            loadExternalDependency: e ? (t)=>e(this._instance, "surveys", t) : void 0
        };
    }
    createEventReceiver() {
        return new $9ae5e4a12de151f5$var$ch(this._instance);
    }
};
const $9ae5e4a12de151f5$var$ph = (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.location) ? $9ae5e4a12de151f5$var$Mo($9ae5e4a12de151f5$var$t.location.hash, "__posthog") || $9ae5e4a12de151f5$var$Mo(location.hash, "state") : null, $9ae5e4a12de151f5$var$_h = "_postHogToolbarParams", $9ae5e4a12de151f5$var$gh = $9ae5e4a12de151f5$var$Ye("[Toolbar]"), $9ae5e4a12de151f5$var$mh = $9ae5e4a12de151f5$var$Ye("[FeatureFlags]");
var $9ae5e4a12de151f5$var$bh = class {
    constructor(t, i = !1){
        this.Jc = !1, this.update(t, i);
    }
    update(t, i) {
        this.Kc = ((t, i)=>{
            var e, s, n, r, o, l, a, u;
            return {
                bootstrap: {
                    featureFlags: null !== (e = null === (s = t.bootstrap) || void 0 === s ? void 0 : s.featureFlags) && void 0 !== e ? e : void 0,
                    featureFlagPayloads: null !== (n = null === (r = t.bootstrap) || void 0 === r ? void 0 : r.featureFlagPayloads) && void 0 !== n ? n : void 0
                },
                remoteRequestsDisabled: i,
                featureFlagsDisabled: !!t.advanced_disable_feature_flags,
                onlyEvaluateSurveyFeatureFlags: !!t.advanced_only_evaluate_survey_feature_flags,
                deduplicateCallsPerSession: !!t.advanced_feature_flags_dedup_per_session,
                cacheTtlMs: t.feature_flag_cache_ttl_ms,
                refreshIntervalMs: null !== (o = t.remote_config_refresh_interval_ms) && void 0 !== o ? o : 3e5,
                idleRefreshBackoff: $9ae5e4a12de151f5$var$R(t.remote_config_refresh_interval_ms),
                requestTimeoutMs: t.feature_flag_request_timeout_ms,
                requestMaxRetries: Math.max(0, null !== (l = t.feature_flag_request_max_retries) && void 0 !== l ? l : 1),
                compression: t.disable_compression ? void 0 : "best-available",
                evaluationContexts: null !== (a = null !== (u = t.evaluation_contexts) && void 0 !== u ? u : t.evaluation_environments) && void 0 !== a ? a : [],
                flagKeys: $9ae5e4a12de151f5$var$T(t.flag_keys) ? t.flag_keys : void 0
            };
        })(t, i), !t.evaluation_environments || t.evaluation_contexts || this.Jc || ($9ae5e4a12de151f5$var$mh.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Jc = !0), $9ae5e4a12de151f5$var$R(t.flag_keys) || $9ae5e4a12de151f5$var$T(t.flag_keys) || $9ae5e4a12de151f5$var$mh.error("Invalid flag_keys found:", t.flag_keys, "Expected array of non-empty strings");
    }
    get() {
        return this.Kc;
    }
};
const $9ae5e4a12de151f5$var$yh = $9ae5e4a12de151f5$var$Ye("[FeatureFlags]"), $9ae5e4a12de151f5$var$wh = $9ae5e4a12de151f5$var$Ye("[FeatureFlags]", {
    debugEnabled: !0
}), $9ae5e4a12de151f5$var$$h = "\" failed. Feature flags didn't load in time.", $9ae5e4a12de151f5$var$Sh = [
    502,
    504
], $9ae5e4a12de151f5$var$xh = [
    "click",
    "keydown",
    "wheel",
    "touchstart",
    "pointerdown"
], $9ae5e4a12de151f5$var$Eh = "connection_error", $9ae5e4a12de151f5$var$kh = (t)=>{
    const i = {};
    for(let e = 0; t.length > e; e++)i[t[e]] = !0;
    return i;
}, $9ae5e4a12de151f5$var$Th = (t)=>{
    const i = {};
    for (const [e, s] of $9ae5e4a12de151f5$var$Gn(t || {}))s && (i[e] = s);
    return i;
}, $9ae5e4a12de151f5$var$Ph = (t)=>$9ae5e4a12de151f5$var$H(t) && ("RangeError" === t.name && 0 === t.message.indexOf("Maximum call stack size exceeded") || "InternalError" === t.name && "too much recursion" === t.message), $9ae5e4a12de151f5$var$Ch = $9ae5e4a12de151f5$var$Ye("[Error tracking]"), $9ae5e4a12de151f5$var$Oh = "webkit-masked-url:", $9ae5e4a12de151f5$var$Rh = [
    {
        value: "isolatedAPI.contexts.topHostname",
        exact: !1
    },
    {
        value: "No response from target",
        exact: !0
    }
], $9ae5e4a12de151f5$var$Ih = [
    "chrome-extension://",
    "moz-extension://",
    "safari-extension:",
    "safari-web-extension:",
    $9ae5e4a12de151f5$var$Oh
], $9ae5e4a12de151f5$var$Ah = [
    "__firefox__",
    "__gCrWeb"
], $9ae5e4a12de151f5$var$Mh = "Refusing to render web experiment since the viewer is a likely bot", $9ae5e4a12de151f5$var$Fh = {
    icontains: (t, i)=>i.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t, i)=>-1 === i.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t, i)=>$9ae5e4a12de151f5$var$Wa(i, t),
    not_regex: (t, i)=>!$9ae5e4a12de151f5$var$Wa(i, t),
    exact: (t, i)=>i === t,
    is_not: (t, i)=>i !== t
}, $9ae5e4a12de151f5$var$Dh = $9ae5e4a12de151f5$var$Ye("[Conversations]"), $9ae5e4a12de151f5$var$Nh = "Conversations not available yet.";
function $9ae5e4a12de151f5$var$jh(t, i) {
    var s, n, r, o, l, a, u;
    const h = null !== (s = null == t ? void 0 : t.flushIntervalMs) && void 0 !== s ? s : 3e3, d = null !== (n = null == t ? void 0 : t.maxBufferSize) && void 0 !== n ? n : 100, c = (null == i ? void 0 : i.consoleCapture) ? void 0 : null !== (r = null == t ? void 0 : t.maxLogsPerInterval) && void 0 !== r ? r : 1e3, v = $9ae5e4a12de151f5$var$R(c) ? Math.max(d, 2048) : Math.max(d, c), f = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, function() {
        let t = "", i = "";
        try {
            const s = null == $9ae5e4a12de151f5$var$e ? void 0 : $9ae5e4a12de151f5$var$e.userAgent;
            s && ([t, i] = $9ae5e4a12de151f5$var$Zt(s));
        } catch (t) {}
        return function(t, i) {
            const e = function(t) {
                if (t) return ({}).hasOwnProperty.call($9ae5e4a12de151f5$var$Ae, t) ? $9ae5e4a12de151f5$var$Ae[t] : t;
            }(t);
            return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e ? {
                "os.name": e
            } : {}), i ? {
                "os.version": i
            } : {});
        }(t, i);
    }()), null == t ? void 0 : t.resourceAttributes);
    return {
        serviceName: null !== (o = null !== (l = null == f ? void 0 : f["service.name"]) && void 0 !== l ? l : null == t ? void 0 : t.serviceName) && void 0 !== o ? o : null == i ? void 0 : i.serviceNameDefault,
        serviceVersion: null !== (a = null == f ? void 0 : f["service.version"]) && void 0 !== a ? a : null == t ? void 0 : t.serviceVersion,
        environment: null !== (u = null == f ? void 0 : f["deployment.environment"]) && void 0 !== u ? u : null == t ? void 0 : t.environment,
        resourceAttributes: f,
        beforeSend: null == t ? void 0 : t.beforeSend,
        flushIntervalMs: h,
        maxBufferSize: d,
        maxQueueSize: v,
        maxBatchRecordsPerPost: 100,
        rateCapWindowMs: h,
        maxLogsPerInterval: c,
        backgroundFlushBudgetMs: 0,
        terminationFlushBudgetMs: 0
    };
}
const $9ae5e4a12de151f5$var$Lh = [
    "debug",
    "log",
    "warn",
    "error",
    "info"
], $9ae5e4a12de151f5$var$Bh = (t)=>{
    for(; null == t ? void 0 : t.__rrweb_original__;)t = t.__rrweb_original__;
    return t;
}, $9ae5e4a12de151f5$var$Uh = "console", $9ae5e4a12de151f5$var$zh = "__posthogHandledLogsRequestError", $9ae5e4a12de151f5$var$Hh = (t, i)=>{
    const e = t instanceof Error ? t : new Error(i);
    return e[$9ae5e4a12de151f5$var$zh] = !0, e;
}, $9ae5e4a12de151f5$var$qh = (t)=>!!t && "object" == typeof t && !0 === t[$9ae5e4a12de151f5$var$zh], $9ae5e4a12de151f5$var$Vh = $9ae5e4a12de151f5$var$Ye("[NetworkMetrics]"), $9ae5e4a12de151f5$var$Wh = ()=>{
    var i;
    return (null == $9ae5e4a12de151f5$var$t || null === (i = $9ae5e4a12de151f5$var$t.performance) || void 0 === i ? void 0 : i.now) ? $9ae5e4a12de151f5$var$t.performance.now() : Date.now();
}, $9ae5e4a12de151f5$var$Gh = {
    "http:": 80,
    "https:": 443
}, $9ae5e4a12de151f5$var$Kh = new Set([
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
]), $9ae5e4a12de151f5$var$Jh = (t, i)=>{
    var e;
    const s = String(i);
    return {
        method: String(t).toUpperCase(),
        url: (null === (e = $9ae5e4a12de151f5$var$Ro(s)) || void 0 === e ? void 0 : e.href) || s
    };
}, $9ae5e4a12de151f5$var$Yh = (t, i, e, s, n, r, o = !1)=>{
    try {
        var l, a;
        const u = n();
        if (!u) return;
        const h = e || void 0, d = $9ae5e4a12de151f5$var$Wh() - s, c = $9ae5e4a12de151f5$var$Ro(i.url);
        if (c && "http:" !== c.protocol && "https:" !== c.protocol) return;
        const v = {
            url: (null == c ? void 0 : c.href) || i.url,
            method: i.method
        }, f = $9ae5e4a12de151f5$var$P(u.name) ? u.name(v) : $9ae5e4a12de151f5$var$I(u.name) ? u.name : "http.client.request.duration";
        if (!f) return;
        const p = o && !h ? void 0 : ((t, i)=>t ? 400 > t ? void 0 : String(t) : (null == i ? void 0 : i.name) || "_OTHER")(h, r), _ = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, ((t)=>{
            const i = $9ae5e4a12de151f5$var$Kh.has(t) ? t : "_OTHER";
            return $9ae5e4a12de151f5$var$Ei({
                "http.request.method": i
            }, "_OTHER" === i && t !== i ? {
                "http.request.method_original": t
            } : {});
        })(v.method)), c ? ((t)=>{
            var i;
            return {
                "server.address": t.hostname.startsWith("[") && t.hostname.endsWith("]") ? t.hostname.slice(1, -1) : t.hostname,
                "server.port": Number(t.port) || $9ae5e4a12de151f5$var$Gh[t.protocol],
                "url.scheme": t.protocol.slice(0, -1),
                "url.template": (i = t.pathname, i.split("/").map((t)=>((t)=>/^\d+$/.test(t) || t.length >= 8 && /^[0-9a-f-]*\d[0-9a-f-]*$/i.test(t))(t) ? ":id" : t).join("/"))
            };
        })(c) : {}), h ? {
            "http.response.status_code": h
        } : {}), p ? {
            "error.type": p
        } : {}), null === (l = u.attributes) || void 0 === l ? void 0 : l.call(u, v, {
            status: h,
            durationMs: d
        }));
        null === (a = t.metrics) || void 0 === a || a.histogram(f, d, {
            unit: "ms",
            attributes: _
        });
    } catch (t) {
        $9ae5e4a12de151f5$var$Vh.error("Failed to record network metric", t);
    }
}, $9ae5e4a12de151f5$var$Xh = ()=>{}, $9ae5e4a12de151f5$var$Qh = (i, e)=>$9ae5e4a12de151f5$var$P(null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.fetch) ? $9ae5e4a12de151f5$var$zu($9ae5e4a12de151f5$var$t, "fetch", (t)=>function(...s) {
            const n = $9ae5e4a12de151f5$var$Wh(), r = t.apply(this, s);
            if (!e()) return r;
            try {
                var o, l, a;
                const [t, u] = s, h = $9ae5e4a12de151f5$var$Jh(null !== (o = null !== (l = null == u ? void 0 : u.method) && void 0 !== l ? l : null == t ? void 0 : t.method) && void 0 !== o ? o : "GET", null !== (a = null == t ? void 0 : t.url) && void 0 !== a ? a : t);
                return r.then((t)=>($9ae5e4a12de151f5$var$Yh(i, h, null == t ? void 0 : t.status, n, e, void 0, !0), t), (t)=>{
                    throw $9ae5e4a12de151f5$var$Yh(i, h, void 0, n, e, t), t;
                });
            } catch (t) {
                return $9ae5e4a12de151f5$var$Vh.error("Failed to observe fetch", t), r;
            }
        }) : $9ae5e4a12de151f5$var$Xh, $9ae5e4a12de151f5$var$Zh = (i, e)=>{
    var s;
    const n = null == $9ae5e4a12de151f5$var$t || null === (s = $9ae5e4a12de151f5$var$t.XMLHttpRequest) || void 0 === s ? void 0 : s.prototype;
    if (!n) return $9ae5e4a12de151f5$var$Xh;
    const r = new WeakMap, o = $9ae5e4a12de151f5$var$zu(n, "open", (t)=>function(...i) {
            try {
                (()=>$9ae5e4a12de151f5$var$ca.has(this))() || r.set(this, $9ae5e4a12de151f5$var$Jh(i[0], i[1]));
            } catch (t) {
                $9ae5e4a12de151f5$var$Vh.error("Failed to observe XHR open", t);
            }
            return t.apply(this, i);
        }), l = $9ae5e4a12de151f5$var$zu(n, "send", (t)=>function(...s) {
            let n;
            try {
                const t = r.get(this);
                if (t && e()) {
                    const s = $9ae5e4a12de151f5$var$Wh();
                    n = ()=>{
                        this.removeEventListener("loadend", n), $9ae5e4a12de151f5$var$Yh(i, t, this.status, s, e);
                    }, $9ae5e4a12de151f5$var$Zn(this, "loadend", n);
                }
            } catch (t) {
                $9ae5e4a12de151f5$var$Vh.error("Failed to observe XHR send", t);
            }
            try {
                return t.apply(this, s);
            } catch (t) {
                throw n && this.removeEventListener("loadend", n), t;
            }
        });
    return ()=>{
        o(), l();
    };
}, $9ae5e4a12de151f5$var$td = {
    featureFlags: class {
        constructor(t){
            this.name = "featureFlags", this.Xc = !1, this.featureFlagEventHandlers = [], this.$ = $9ae5e4a12de151f5$var$yh, this.Yc = {}, this.td = {}, this.ed = [], this.nd = !1, this.sd = !1, this.rd = 0, this.od = !1, this.ad = !1, this.ld = !1, this.ud = !1, this.hd = 0, this.dd = !1, this.an = ()=>{
                const t = this.vd();
                this.hd = 0, t && this.reloadFeatureFlags();
            }, this.fd = ()=>{
                var t, i;
                const e = this.pd, n = null !== (t = this.gd) && void 0 !== t ? t : e;
                $9ae5e4a12de151f5$var$R(e) || $9ae5e4a12de151f5$var$R(n) || this.Rr.remoteRequestsDisabled || !$9ae5e4a12de151f5$var$s || "hidden" === $9ae5e4a12de151f5$var$s.visibilityState || Date.now() - (null !== (i = this.md) && void 0 !== i ? i : 0) < n || (this.gd = this.dd || !this.Rr.idleRefreshBackoff ? e : Math.min(2 * n, 36e5), this.dd = !1, this.reloadFeatureFlags(), this.yd());
            }, this.bd = ()=>{
                this.dd && this.gd === this.pd || this._d();
            }, this.ln = ()=>{
                "visible" === (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.visibilityState) && this._d();
            }, "get" in t ? this.So = t : (this._instance = t, this.wd = new $9ae5e4a12de151f5$var$bh(t.config, t.nl()), this.So = this.wd);
        }
        updateConfig(t, i) {
            var e;
            null === (e = this.wd) || void 0 === e || e.update(t, i), this.wo && this.kd();
        }
        setup(t) {
            return this.Fh = t, this.$ = t.logger.createLogger("[FeatureFlags]"), $9ae5e4a12de151f5$var$rh(t.kv.initialize(), ()=>{
                this.Fh === t && (this.Fh = void 0, this.wo = t, this.Sd(t));
            });
        }
        Sd(i) {
            var e;
            if (this.wo === i) return $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "online", this.an), this.kd(), this.xd = i.registerDynamicEventProperties(()=>this.Cd() ? this.Yc : this.td), this.$d = null === (e = this._instance) || void 0 === e || null === (e = e.persistence) || void 0 === e ? void 0 : e.onCrossTabFeatureFlagChange(()=>{
                this.Td(), this.Id(), this.Md();
            }), this.Id(), this.initialize();
        }
        _d() {
            this.dd = !0, this.gd = this.pd, this.fd();
        }
        kd() {
            const t = this.Rr.refreshIntervalMs, i = !this.Rr.remoteRequestsDisabled && $9ae5e4a12de151f5$var$s && !$9ae5e4a12de151f5$var$R(t) && t > 0 ? t : void 0;
            this.Rr.idleRefreshBackoff || (this.gd = i), i !== this.pd && (this.Ed(), $9ae5e4a12de151f5$var$R(i) || (this.pd = i, this.gd = i, this.yd(), (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.addEventListener) && ($9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, $9ae5e4a12de151f5$var$jn, this.ln), $9ae5e4a12de151f5$var$qn($9ae5e4a12de151f5$var$xh, (t)=>{
                $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, t, this.bd, {
                    capture: !0
                });
            }))));
        }
        yd() {
            $9ae5e4a12de151f5$var$R(this.pd) || ($9ae5e4a12de151f5$var$R(this.Pd) || clearInterval(this.Pd), this.md = Date.now(), this.Pd = setInterval(this.fd, this.pd));
        }
        Ed() {
            var t;
            $9ae5e4a12de151f5$var$R(this.Pd) || (clearInterval(this.Pd), this.Pd = void 0, null == $9ae5e4a12de151f5$var$s || null === (t = $9ae5e4a12de151f5$var$s.removeEventListener) || void 0 === t || t.call($9ae5e4a12de151f5$var$s, "visibilitychange", this.ln), $9ae5e4a12de151f5$var$qn($9ae5e4a12de151f5$var$xh, (t)=>{
                var i;
                null == $9ae5e4a12de151f5$var$s || null === (i = $9ae5e4a12de151f5$var$s.removeEventListener) || void 0 === i || i.call($9ae5e4a12de151f5$var$s, t, this.bd, {
                    capture: !0
                });
            })), this.pd = void 0, this.gd = void 0, this.dd = !1, this.md = void 0;
        }
        destroy() {
            this.Rd();
        }
        dispose() {
            this.Rd();
        }
        Rd() {
            var i, e;
            this.Ed(), this.rd++, this.ad = !1, this.Fh = void 0, this.wo && (this.Ad(), null === (i = this.xd) || void 0 === i || i.dispose(), this.xd = void 0, null === (e = this.$d) || void 0 === e || e.call(this), this.$d = void 0, this.ed = [], null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.removeEventListener("online", this.an), this.wo = void 0);
        }
        get Rr() {
            return this.So.get();
        }
        Fd(t) {
            var i;
            return this.Od && t in this.Od ? this.Od[t] : null === (i = this.wo) || void 0 === i ? void 0 : i.kv.get(t);
        }
        Td() {
            return !!this.Od && (this.Od = void 0, !0);
        }
        Dd() {
            var t;
            return !$9ae5e4a12de151f5$var$R(null === (t = this.wo) || void 0 === t ? void 0 : t.kv.get("$enabled_feature_flags")) && this.Td();
        }
        At(t) {
            this.Ld(()=>{
                var i;
                return null === (i = this.wo) || void 0 === i ? void 0 : i.kv.set(t);
            });
        }
        Nd(t, i, e) {
            var s;
            if (!(null === (s = this._instance) || void 0 === s ? void 0 : s.persistence) || !t.$enabled_feature_flags) return;
            const n = this.Fd("$enabled_feature_flags") || {}, r = t.$enabled_feature_flags || {}, o = i.flags || i.featureFlags, l = i.flags ? Object.entries(i.flags).filter(([, t])=>!(null == t ? void 0 : t.failed)).map(([t])=>t) : [], a = !!i.errorsWhileComputingFlags && !!i.flags, u = a ? l : e && !$9ae5e4a12de151f5$var$T(o) ? Object.keys(o || {}) : Array.from(new Set([
                ...Object.keys(n),
                ...Object.keys(r)
            ])), h = this.Fd("$feature_flag_payloads") || {}, d = t.$feature_flag_payloads || {}, c = a || e ? u : Array.from(new Set([
                ...Object.keys(h),
                ...Object.keys(d)
            ])), v = !a && !e, f = !!v || u, p = !!v || c, _ = {
                [$9ae5e4a12de151f5$var$Ls]: f,
                [$9ae5e4a12de151f5$var$js]: f,
                [$9ae5e4a12de151f5$var$zs]: p
            };
            t.$feature_flag_details && (_[$9ae5e4a12de151f5$var$Us] = f);
            for (const i of [
                $9ae5e4a12de151f5$var$Hs,
                $9ae5e4a12de151f5$var$cn,
                $9ae5e4a12de151f5$var$qs
            ])$9ae5e4a12de151f5$var$R(t[i]) || (_[i] = !0);
            this._instance.persistence.markCrossTabFeatureFlagChanges(_);
        }
        Lt(t) {
            this.Ld(()=>{
                var i;
                return null === (i = this.wo) || void 0 === i ? void 0 : i.kv.remove(t);
            });
        }
        Ld(t) {
            try {
                t();
            } catch (t) {
                this.$.error("Failed to update feature flag persistence", t);
            }
        }
        Id() {
            const t = {};
            for (const i of [
                $9ae5e4a12de151f5$var$Ls,
                $9ae5e4a12de151f5$var$zs,
                $9ae5e4a12de151f5$var$Hs,
                $9ae5e4a12de151f5$var$Vs
            ]){
                const e = this.Fd(i);
                $9ae5e4a12de151f5$var$R(e) || (t[i] = e);
            }
            this.Yc = t;
            const i = $9ae5e4a12de151f5$var$Ei({}, t), e = this.Fd($9ae5e4a12de151f5$var$js);
            if (e) for (const [t, s] of Object.entries(e))i[`$feature/${t}`] = s;
            this.td = i;
        }
        Cd() {
            const t = this.Rr.cacheTtlMs;
            if (!t || 0 >= t) return !1;
            const i = this.Fd($9ae5e4a12de151f5$var$cn);
            return "number" != typeof i || Date.now() - i > t;
        }
        qd() {
            return !!this.Cd() && (this.ud || this.sd || (this.ud = !0, this.$.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
        }
        jd() {
            const t = this.Rr.evaluationContexts;
            return (null == t ? void 0 : t.length) ? t.filter((t)=>{
                const i = t && "string" == typeof t && t.trim().length > 0;
                return i || this.$.error("Invalid evaluation context found:", t, "Expected non-empty string"), i;
            }) : [];
        }
        Bd() {
            const t = this.Rr.flagKeys;
            if (!$9ae5e4a12de151f5$var$R(t)) return t.filter((t)=>{
                const i = t && "string" == typeof t && t.trim().length > 0;
                return i || this.$.error("Invalid flag key found:", t, "Expected non-empty string"), i;
            });
        }
        initialize() {
            var t, i;
            const e = this.Rr, s = null !== (t = null === (i = e.bootstrap) || void 0 === i ? void 0 : i.featureFlags) && void 0 !== t ? t : {};
            if (Object.keys(s).length) {
                var n, r;
                const t = null !== (n = null === (r = e.bootstrap) || void 0 === r ? void 0 : r.featureFlagPayloads) && void 0 !== n ? n : {}, i = Object.keys(s).filter((t)=>!$9ae5e4a12de151f5$var$R(s[t])).reduce((t, i)=>(t[i] = s[i], t), {}), o = Object.keys(t).filter((t)=>i[t]).reduce((i, e)=>(i[e] = t[e], i), {});
                return this.Hd({
                    featureFlags: i,
                    featureFlagPayloads: o
                }, void 0, {
                    persist: !1
                });
            }
        }
        updateFlags(t, i, e) {
            var s, n;
            const r = (null == e ? void 0 : e.merge) && null !== (s = this.Fd("$enabled_feature_flags")) && void 0 !== s ? s : {}, o = (null == e ? void 0 : e.merge) && null !== (n = this.Fd("$feature_flag_payloads")) && void 0 !== n ? n : {}, l = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, r), t), a = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, o), i), u = {};
            for (const [t, i] of Object.entries(l))u[t] = {
                key: t,
                enabled: $9ae5e4a12de151f5$var$ce(i),
                variant: $9ae5e4a12de151f5$var$ve(i),
                reason: void 0,
                metadata: $9ae5e4a12de151f5$var$R(null == a ? void 0 : a[t]) ? void 0 : {
                    id: 0,
                    version: void 0,
                    description: void 0,
                    payload: a[t]
                }
            };
            this.Hd({
                flags: u
            });
        }
        get hasLoadedFlags() {
            return this.nd;
        }
        getFlags() {
            return Object.keys(this.getFlagVariants());
        }
        getFlagsWithDetails() {
            const t = this.Fd($9ae5e4a12de151f5$var$Us), i = this.Fd($9ae5e4a12de151f5$var$Vs), e = this.Fd($9ae5e4a12de151f5$var$Ws);
            if (!e && !i) return t || {};
            const s = $9ae5e4a12de151f5$var$Wn({}, t || {}), n = [
                ...new Set([
                    ...Object.keys(e || {}),
                    ...Object.keys(i || {})
                ])
            ];
            for (const t of n){
                var r;
                const n = s[t], l = null == i ? void 0 : i[t], a = $9ae5e4a12de151f5$var$R(l) ? null !== (r = null == n ? void 0 : n.enabled) && void 0 !== r && r : !!l, u = $9ae5e4a12de151f5$var$R(l) ? null == n ? void 0 : n.variant : "string" == typeof l ? l : void 0, h = null == e ? void 0 : e[t], d = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, n), {}, {
                    enabled: a,
                    variant: a ? null != u ? u : null == n ? void 0 : n.variant : void 0
                });
                var o;
                a !== (null == n ? void 0 : n.enabled) && (d.original_enabled = null == n ? void 0 : n.enabled), u !== (null == n ? void 0 : n.variant) && (d.original_variant = null == n ? void 0 : n.variant), h && (d.metadata = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, null == n ? void 0 : n.metadata), {}, {
                    payload: h,
                    original_payload: null == n || null === (o = n.metadata) || void 0 === o ? void 0 : o.payload
                })), s[t] = d;
            }
            return this.Xc || (this.$.warn(" Overriding feature flag details!", {
                flagDetails: t,
                overriddenPayloads: e,
                finalDetails: s
            }), this.Xc = !0), s;
        }
        getAllFeatureFlags() {
            const t = this.getFlagVariants(), i = this.getFlagPayloads();
            return Object.keys(t).map((e)=>{
                const s = t[e];
                return {
                    key: e,
                    enabled: $9ae5e4a12de151f5$var$ce(s),
                    variant: $9ae5e4a12de151f5$var$ve(s),
                    payload: $9ae5e4a12de151f5$var$de(i[e])
                };
            });
        }
        getFlagVariants() {
            const t = this.Fd($9ae5e4a12de151f5$var$js), i = this.Fd($9ae5e4a12de151f5$var$Vs);
            if (!i) return t || {};
            const e = $9ae5e4a12de151f5$var$Wn({}, t || {}), s = Object.keys(i);
            for(let t = 0; s.length > t; t++)e[s[t]] = i[s[t]];
            return this.Xc || (this.$.warn(" Overriding feature flags!", {
                enabledFlags: t,
                overriddenFlags: i,
                finalFlags: e
            }), this.Xc = !0), e;
        }
        getFlagPayloads() {
            const t = this.Fd($9ae5e4a12de151f5$var$zs), i = this.Fd($9ae5e4a12de151f5$var$Ws);
            if (!i) return t || {};
            const e = $9ae5e4a12de151f5$var$Wn({}, t || {}), s = Object.keys(i);
            for(let t = 0; s.length > t; t++)e[s[t]] = i[s[t]];
            return this.Xc || (this.$.warn(" Overriding feature flag payloads!", {
                flagPayloads: t,
                overriddenPayloads: i,
                finalPayloads: e
            }), this.Xc = !0), e;
        }
        reloadFeatureFlags() {
            this.od || this.Rr.featureFlagsDisabled || this.vd() || (this.sd && (this.ad = !0), this.zd || (this.ed.slice().forEach((t)=>{
                try {
                    t();
                } catch (t) {
                    this.$.error("Error while running feature flags reloading callback", t);
                }
            }), this.zd = setTimeout(()=>{
                this.Ud();
            }, 5)));
        }
        Ad() {
            clearTimeout(this.zd), this.zd = void 0;
        }
        onReloading(t) {
            return this.ed.push(t), ()=>{
                this.ed = this.ed.filter((i)=>i !== t);
            };
        }
        ensureFlagsLoaded() {
            this.nd || this.sd || this.zd || this.reloadFeatureFlags();
        }
        setAnonymousDistinctId(t) {
            this.$anon_distinct_id = t;
        }
        setReloadingPaused(t) {
            this.od = t;
        }
        resetFlagCallReported() {
            this.Lt($9ae5e4a12de151f5$var$un);
        }
        Ud(t) {
            this.Ad();
            const i = this.wo;
            if (!i || this.Rr.remoteRequestsDisabled || this.vd()) return;
            if (this.sd) return void (this.ad = !0);
            const e = {
                token: i.projectToken,
                distinct_id: i.distinctId,
                groups: i.groups,
                $anon_distinct_id: this.$anon_distinct_id,
                person_properties: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i.initialPersonProperties), this.Fd("$stored_person_properties") || {}), {}, {
                    $lib: i.library.name,
                    $lib_version: i.library.version
                }),
                group_properties: this.Fd($9ae5e4a12de151f5$var$Ks),
                timezone: $9ae5e4a12de151f5$var$Yo()
            };
            $9ae5e4a12de151f5$var$R(i.deviceId) || (e.$device_id = i.deviceId), ((null == t ? void 0 : t.disableFlags) || this.Rr.featureFlagsDisabled) && (e.disable_flags = !0);
            const s = this.jd();
            s.length && (e.evaluation_contexts = s);
            const n = this.Bd();
            $9ae5e4a12de151f5$var$R(n) || (e.flag_keys = n);
            const r = this.Rr.onlyEvaluateSurveyFeatureFlags, o = "/flags/?v=2" + (r ? "&only_evaluate_survey_feature_flags=true" : ""), l = this.rd;
            this.sd = !0;
            const a = ()=>{
                this.ad && (this.ad = !1, this.Ud());
            }, u = (t)=>{
                var i, s;
                const n = null !== (i = t.json) && void 0 !== i ? i : {}, o = 200 !== t.statusCode;
                if (this.sd = !1, l !== this.rd) return void a();
                if (this.Wd(t.statusCode), o || this.ad || (this.$anon_distinct_id = void 0), e.disable_flags && !this.ad) return;
                this.ld = !o;
                const u = [];
                t.error ? u.push(t.error instanceof Error && "AbortError" === t.error.name ? "timeout" : t.error instanceof Error ? $9ae5e4a12de151f5$var$Eh : "unknown_error") : 200 !== t.statusCode && u.push(`api_error_${t.statusCode}`), n.errorsWhileComputingFlags && u.push("errors_while_computing_flags");
                const h = !!(null === (s = n.quotaLimited) || void 0 === s ? void 0 : s.includes("feature_flags"));
                h && u.push("quota_limited"), this.At({
                    [$9ae5e4a12de151f5$var$dn]: u
                }), h ? this.$.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.") : e.disable_flags || this.Hd(n, o, {
                    partialResponse: r
                }), a();
            }, h = (t)=>{
                this.sd = !1, l === this.rd ? (this.At({
                    [$9ae5e4a12de151f5$var$dn]: [
                        $9ae5e4a12de151f5$var$Eh
                    ]
                }), this.$.error("Feature flag request failed", t), this.Dd() && this.Md(!0), a()) : a();
            };
            let d = this.Rr.requestMaxRetries;
            const c = ()=>d > 0 && l === this.rd, v = ()=>{
                if (l !== this.rd || !this.wo || this.Rr.remoteRequestsDisabled) return this.sd = !1, void a();
                try {
                    i.sendRequest(o, {
                        target: "flags",
                        method: "POST",
                        body: e,
                        compression: this.Rr.compression,
                        sentAt: "body",
                        timeoutMs: this.Rr.requestTimeoutMs
                    }).then((t)=>{
                        if (((t)=>$9ae5e4a12de151f5$var$Sh.includes(t.statusCode) || ((t)=>0 === t.statusCode && t.error instanceof Error && "AbortError" === t.error.name)(t))(t) && c()) return d--, void setTimeout(v, 500);
                        u(t);
                    }).catch(h);
                } catch (t) {
                    h(t);
                }
            };
            v();
        }
        vd() {
            return $9ae5e4a12de151f5$var$Fo(this.hd, 3);
        }
        Wd(t) {
            this.hd = $9ae5e4a12de151f5$var$Do(t, this.hd, 3, ()=>this.$.warn("Feature flag requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped refreshing feature flags; will try again when connectivity changes."));
        }
        getFeatureFlag(t, i = {}) {
            var e;
            if (i.fresh && !this.ld) return;
            if (!(this.nd || this.getFlags() && this.getFlags().length > 0)) return void this.$.warn('getFeatureFlag for key "' + t + $9ae5e4a12de151f5$var$$h);
            if (this.qd()) return;
            const s = this.getFeatureFlagResult(t, i);
            return null !== (e = null == s ? void 0 : s.variant) && void 0 !== e ? e : null == s ? void 0 : s.enabled;
        }
        getFeatureFlagDetails(t) {
            return this.getFlagsWithDetails()[t];
        }
        getFeatureFlagPayload(t) {
            const i = this.getFeatureFlagResult(t, {
                send_event: !1
            });
            return null == i ? void 0 : i.payload;
        }
        getFeatureFlagResult(t, i = {}) {
            if (i.fresh && !this.ld) return;
            if (!(this.nd || this.getFlags() && this.getFlags().length > 0)) return void this.$.warn('getFeatureFlagResult for key "' + t + $9ae5e4a12de151f5$var$$h);
            if (this.qd()) return;
            const e = this.getFlagVariants(), s = t in e, n = e[t], r = this.getFlagPayloads()[t], o = String(n), l = this.Fd("$feature_flag_request_id") || void 0, a = this.Fd("$feature_flag_evaluated_at") || void 0;
            let u, h = this.Fd("$flag_call_reported") || {};
            if (this.Rr.deduplicateCallsPerSession) {
                var d;
                const t = null === (d = this.wo) || void 0 === d ? void 0 : d.session.sessionId, i = this.Fd($9ae5e4a12de151f5$var$hn);
                t && t !== i && (h = {}, u = t);
            }
            if (i.send_event || !("send_event" in i)) {
                if (t in h && h[t].includes(o)) u && this.At({
                    [$9ae5e4a12de151f5$var$un]: h,
                    [$9ae5e4a12de151f5$var$hn]: u
                });
                else {
                    var c, v, f, p, _, g, m, b, y, w, S, x;
                    $9ae5e4a12de151f5$var$T(h[t]) ? h[t].push(o) : h[t] = [
                        o
                    ], this.At($9ae5e4a12de151f5$var$Ei({
                        [$9ae5e4a12de151f5$var$un]: h
                    }, u ? {
                        [$9ae5e4a12de151f5$var$hn]: u
                    } : {}));
                    const i = this.getFeatureFlagDetails(t), e = [
                        ...null !== (c = this.Fd("$feature_flag_errors")) && void 0 !== c ? c : []
                    ];
                    $9ae5e4a12de151f5$var$R(n) && e.push("flag_missing");
                    const s = {
                        $feature_flag: t,
                        $feature_flag_response: n,
                        $feature_flag_payload: null != r ? r : null,
                        $feature_flag_request_id: l,
                        $feature_flag_evaluated_at: a,
                        $feature_flag_bootstrapped_response: null !== (v = null === (f = this.Rr.bootstrap) || void 0 === f || null === (f = f.featureFlags) || void 0 === f ? void 0 : f[t]) && void 0 !== v ? v : null,
                        $feature_flag_bootstrapped_payload: null !== (p = null === (_ = this.Rr.bootstrap) || void 0 === _ || null === (_ = _.featureFlagPayloads) || void 0 === _ ? void 0 : _[t]) && void 0 !== p ? p : null,
                        $used_bootstrap_value: !this.ld
                    };
                    $9ae5e4a12de151f5$var$R(null == i || null === (g = i.metadata) || void 0 === g ? void 0 : g.has_experiment) || (s.$feature_flag_has_experiment = i.metadata.has_experiment), $9ae5e4a12de151f5$var$R(null == i || null === (m = i.metadata) || void 0 === m ? void 0 : m.version) || (s.$feature_flag_version = i.metadata.version);
                    const d = null !== (b = null == i || null === (y = i.reason) || void 0 === y ? void 0 : y.description) && void 0 !== b ? b : null == i || null === (w = i.reason) || void 0 === w ? void 0 : w.code;
                    var E;
                    d && (s.$feature_flag_reason = d), (null == i || null === (S = i.metadata) || void 0 === S ? void 0 : S.id) && (s.$feature_flag_id = i.metadata.id), $9ae5e4a12de151f5$var$R(null == i ? void 0 : i.original_variant) && $9ae5e4a12de151f5$var$R(null == i ? void 0 : i.original_enabled) || (s.$feature_flag_original_response = $9ae5e4a12de151f5$var$R(i.original_variant) ? i.original_enabled : i.original_variant), (null == i || null === (x = i.metadata) || void 0 === x ? void 0 : x.original_payload) && (s.$feature_flag_original_payload = null == i || null === (E = i.metadata) || void 0 === E ? void 0 : E.original_payload), e.length && (s.$feature_flag_error = e.join(",")), this.Vd(s);
                }
            } else u && this.At({
                [$9ae5e4a12de151f5$var$un]: h,
                [$9ae5e4a12de151f5$var$hn]: u
            });
            return s ? {
                key: t,
                enabled: !!n,
                variant: "string" == typeof n ? n : void 0,
                payload: $9ae5e4a12de151f5$var$de(r)
            } : void 0;
        }
        Vd(t) {
            try {
                var i;
                null === (i = this.wo) || void 0 === i || i.capture("$feature_flag_called", t);
            } catch (t) {
                this.$.error("Failed to capture feature flag call", t);
            }
        }
        getRemoteConfigPayload(t, i) {
            this.Gd(t, i);
        }
        Gd(t, i) {
            var e = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                const s = e.wo;
                if (!s) return;
                const n = {
                    distinct_id: s.distinctId,
                    token: s.projectToken,
                    person_properties: {
                        $lib: s.library.name,
                        $lib_version: s.library.version
                    }
                }, r = e.jd();
                r.length && (n.evaluation_contexts = r);
                const o = e.Bd();
                let l;
                $9ae5e4a12de151f5$var$R(o) || (n.flag_keys = o);
                try {
                    var a;
                    const i = null === (a = (yield s.sendRequest("/flags/?v=2", {
                        target: "flags",
                        method: "POST",
                        body: n,
                        compression: e.Rr.compression,
                        sentAt: "body",
                        timeoutMs: e.Rr.requestTimeoutMs
                    })).json) || void 0 === a ? void 0 : a.featureFlagPayloads;
                    l = (null == i ? void 0 : i[t]) || void 0;
                } catch (t) {
                    return void e.$.error("Remote config feature flag request failed", t);
                }
                try {
                    i(l);
                } catch (t) {
                    e.$.error("Remote config feature flag callback failed", t);
                }
            })();
        }
        isFeatureEnabled(t, i = {}) {
            if (i.fresh && !this.ld) return i.defaultValue;
            if (!(this.nd || this.getFlags() && this.getFlags().length > 0)) return this.$.warn('isFeatureEnabled for key "' + t + $9ae5e4a12de151f5$var$$h), i.defaultValue;
            const e = this.getFeatureFlag(t, i);
            return $9ae5e4a12de151f5$var$R(e) ? i.defaultValue : !!e;
        }
        addFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers.push(t);
        }
        removeFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
        }
        receivedFeatureFlags(t, i, e) {
            this.Hd(t, i, e);
        }
        Hd(t, i, e) {
            if (!this.wo) return;
            this.nd = !0;
            const s = ((t, i = {}, e = {}, s = {}, n, r = $9ae5e4a12de151f5$var$yh)=>{
                const o = ((t, i)=>{
                    const e = t.flags;
                    if (e) {
                        const i = Object.fromEntries(Object.keys(e).map((t)=>{
                            var i;
                            return [
                                t,
                                null !== (i = e[t].variant) && void 0 !== i ? i : e[t].enabled
                            ];
                        })), s = Object.fromEntries(Object.keys(e).filter((t)=>e[t].enabled).filter((t)=>{
                            var i;
                            return !$9ae5e4a12de151f5$var$R(null === (i = e[t].metadata) || void 0 === i ? void 0 : i.payload);
                        }).map((t)=>{
                            var i;
                            return [
                                t,
                                null === (i = e[t].metadata) || void 0 === i ? void 0 : i.payload
                            ];
                        }));
                        return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                            featureFlags: i,
                            featureFlagPayloads: s
                        });
                    }
                    return t.featureFlags && i.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
                })(t, r), l = o.flags, a = o.featureFlags, u = o.featureFlagPayloads;
                if (!a) return;
                const h = t.requestId, d = t.evaluatedAt;
                if ($9ae5e4a12de151f5$var$T(a)) {
                    r.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                    const t = {};
                    if (a) for(let i = 0; a.length > i; i++)t[a[i]] = !0;
                    return {
                        [$9ae5e4a12de151f5$var$Ls]: a,
                        [$9ae5e4a12de151f5$var$js]: t,
                        [$9ae5e4a12de151f5$var$qs]: !1
                    };
                }
                let c = a, v = u, f = l;
                if (null == n ? void 0 : n.partialResponse) {
                    const t = Object.keys(c), n = v || {};
                    c = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), c), v = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e), n), t.forEach((t)=>{
                        t in n || null == v || delete v[t];
                    }), f = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), f);
                } else if (t.errorsWhileComputingFlags) {
                    if (l) {
                        const t = new Set(Object.keys(l).filter((t)=>{
                            var i;
                            return !(null === (i = l[t]) || void 0 === i ? void 0 : i.failed);
                        }));
                        c = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), Object.fromEntries(Object.entries(c).filter(([i])=>t.has(i))));
                        const n = Object.fromEntries(Object.entries(v || {}).filter(([i])=>t.has(i)));
                        v = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e), n), t.forEach((t)=>{
                            t in n || null == v || delete v[t];
                        }), f = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), Object.fromEntries(Object.entries(f || {}).filter(([i])=>t.has(i))));
                    } else c = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), c), v = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e), v), f = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), f);
                }
                return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({
                    [$9ae5e4a12de151f5$var$Ls]: Object.keys($9ae5e4a12de151f5$var$Th(c)),
                    [$9ae5e4a12de151f5$var$js]: c || {},
                    [$9ae5e4a12de151f5$var$zs]: v || {},
                    [$9ae5e4a12de151f5$var$Us]: f || {},
                    [$9ae5e4a12de151f5$var$qs]: !0 === t.minimalFlagCalledEvents
                }, h ? {
                    [$9ae5e4a12de151f5$var$Hs]: h
                } : {}), d ? {
                    [$9ae5e4a12de151f5$var$cn]: d
                } : {});
            })(t, this.getFlagVariants(), this.getFlagPayloads(), this.getFlagsWithDetails(), e, this.$);
            if (s) {
                if (!1 === (null == e ? void 0 : e.persist)) {
                    const t = !$9ae5e4a12de151f5$var$R(this.wo.kv.get($9ae5e4a12de151f5$var$js));
                    this.Od = s, t || this.At(s);
                } else this.Td(), this.Nd(s, t, !!(null == e ? void 0 : e.partialResponse)), this.At(s);
            } else i && this.Dd();
            i || (this.ud = !1), this.Md(i);
        }
        override(t, i = !1) {
            this.$.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
                flags: t,
                suppressWarning: i
            });
        }
        overrideFeatureFlags(t) {
            this.Zd(t);
        }
        Zd(t) {
            if (this.wo) {
                if (!1 === t) return this.Lt([
                    $9ae5e4a12de151f5$var$Vs,
                    $9ae5e4a12de151f5$var$Ws
                ]), this.Md(), void $9ae5e4a12de151f5$var$wh.info("All overrides cleared");
                if ($9ae5e4a12de151f5$var$T(t)) return this.At({
                    [$9ae5e4a12de151f5$var$Vs]: $9ae5e4a12de151f5$var$kh(t)
                }), this.Md(), void $9ae5e4a12de151f5$var$wh.info("Flag overrides set", {
                    flags: t
                });
                if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
                    var i;
                    const e = t;
                    this.Xc = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i);
                    const s = {}, n = e.flags, r = e.payloads;
                    return n && (s[$9ae5e4a12de151f5$var$Vs] = $9ae5e4a12de151f5$var$T(n) ? $9ae5e4a12de151f5$var$kh(n) : n), r && (s[$9ae5e4a12de151f5$var$Ws] = r), Object.keys(s).length && this.At(s), !1 === n && !1 === r ? this.Lt([
                        $9ae5e4a12de151f5$var$Vs,
                        $9ae5e4a12de151f5$var$Ws
                    ]) : !1 === n ? this.Lt($9ae5e4a12de151f5$var$Vs) : !1 === r && this.Lt($9ae5e4a12de151f5$var$Ws), this.Md(), !1 === n ? $9ae5e4a12de151f5$var$wh.info("Flag overrides cleared") : n && $9ae5e4a12de151f5$var$wh.info("Flag overrides set", {
                        flags: n
                    }), void (!1 === r ? $9ae5e4a12de151f5$var$wh.info("Payload overrides cleared") : r && $9ae5e4a12de151f5$var$wh.info("Payload overrides set", {
                        payloads: r
                    }));
                }
                if (t && "object" == typeof t) return this.At({
                    [$9ae5e4a12de151f5$var$Vs]: t
                }), this.Md(), void $9ae5e4a12de151f5$var$wh.info("Flag overrides set", {
                    flags: t
                });
                this.$.warn("Invalid overrideOptions provided to overrideFeatureFlags", {
                    overrideOptions: t
                });
            } else this.$.warn("posthog.featureFlags.overrideFeatureFlags called before feature flags were ready");
        }
        onFeatureFlags(t) {
            if (this.addFeatureFlagsHandler(t), this.nd) {
                const { flags: i, flagVariants: e } = this.Qd();
                try {
                    t(i, e);
                } catch (t) {
                    this.$.error("Error while running feature flags callback", t);
                }
            }
            return ()=>this.removeFeatureFlagsHandler(t);
        }
        updateEarlyAccessFeatureEnrollment(t, i, e) {
            var s;
            const n = (this.Fd("$early_access_features") || []).find((i)=>i.flagKey === t), r = {
                [`$feature_enrollment/${t}`]: i
            }, o = {
                $feature_flag: t,
                $feature_enrollment: i,
                $set: r
            };
            n && (o.$early_access_feature_name = n.name), e && (o.$feature_enrollment_stage = e);
            const l = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, this.getFlagVariants()), {}, {
                [t]: i
            });
            null === (s = this._instance) || void 0 === s || null === (s = s.persistence) || void 0 === s || s.markCrossTabFeatureFlagChanges({
                $active_feature_flags: [
                    t
                ],
                $enabled_feature_flags: [
                    t
                ],
                $stored_person_properties: Object.keys(r)
            }), this.At({
                [$9ae5e4a12de151f5$var$Ls]: Object.keys($9ae5e4a12de151f5$var$Th(l)),
                [$9ae5e4a12de151f5$var$js]: l,
                [$9ae5e4a12de151f5$var$Gs]: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, this.Fd("$stored_person_properties") || {}), r)
            }), this.Md();
            try {
                var a;
                null === (a = this.wo) || void 0 === a || a.capture("$feature_enrollment_update", o);
            } catch (t) {
                this.$.error("Failed to capture early access feature enrollment", t);
            }
        }
        getEarlyAccessFeatures(t, i = !1, e) {
            const s = this.Fd($9ae5e4a12de151f5$var$Bs);
            !s || i ? this.Jd(t, e) : t(s);
        }
        Jd(t, i) {
            var e = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                const s = e.wo;
                if (!s) return;
                const n = i ? `&${i.map((t)=>`stage=${t}`).join("&")}` : "";
                let r;
                try {
                    const t = yield s.sendRequest(`/api/early_access_features/?token=${s.projectToken}${n}`, {
                        target: "api",
                        method: "GET",
                        sentAt: "query"
                    });
                    if (!t.json) return;
                    r = t.json.earlyAccessFeatures, e.At({
                        [$9ae5e4a12de151f5$var$Bs]: r
                    });
                } catch (t) {
                    return void e.$.error("Early access feature request failed", t);
                }
                try {
                    t(r);
                } catch (t) {
                    e.$.error("Early access feature callback failed", t);
                }
            })();
        }
        Qd() {
            const t = this.getFlags(), i = this.getFlagVariants();
            return {
                flags: t.filter((t)=>i[t]),
                flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
            };
        }
        Md(t) {
            this.Id();
            const { flags: i, flagVariants: e } = this.Qd();
            this.featureFlagEventHandlers.forEach((s)=>{
                try {
                    s(i, e, {
                        errorsLoading: t
                    });
                } catch (t) {
                    this.$.error("Error while running feature flags callback", t);
                }
            });
        }
        setPersonPropertiesForFlags(t, i = !0) {
            this.Kd(t, i);
        }
        Kd(t, i = !0) {
            const e = this.Fd("$stored_person_properties") || {}, s = (null == t ? void 0 : t.$set) || ((null == t ? void 0 : t.$set_once) ? {} : t), n = null == t ? void 0 : t.$set_once, r = {};
            if (n) for(const t in n)({}).hasOwnProperty.call(n, t) && (t in e || (r[t] = n[t]));
            this.At({
                [$9ae5e4a12de151f5$var$Gs]: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e), r), s)
            }), i && this.reloadFeatureFlags();
        }
        unsetPersonPropertiesForFlags(t, i = !0) {
            const e = $9ae5e4a12de151f5$var$Ei({}, this.Fd("$stored_person_properties") || {});
            t.forEach((t)=>{
                delete e[t];
            }), this.At({
                [$9ae5e4a12de151f5$var$Gs]: e
            }), i && this.reloadFeatureFlags();
        }
        resetPersonPropertiesForFlags(t = !0) {
            this.Lt($9ae5e4a12de151f5$var$Gs), t && this.reloadFeatureFlags();
        }
        setGroupPropertiesForFlags(t, i = !0) {
            const e = this.Fd("$stored_group_properties") || {}, s = $9ae5e4a12de151f5$var$Ei({}, e);
            for (const i of Object.keys(t))s[i] = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, e[i]), t[i]);
            this.At({
                [$9ae5e4a12de151f5$var$Ks]: s
            }), i && this.reloadFeatureFlags();
        }
        resetGroupPropertiesForFlags(t) {
            if (t) {
                const i = this.Fd("$stored_group_properties") || {};
                this.At({
                    [$9ae5e4a12de151f5$var$Ks]: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), {}, {
                        [t]: {}
                    })
                });
            } else this.Lt($9ae5e4a12de151f5$var$Ks);
        }
        reset() {
            this.rd++, this.ad = !1, this.Yc = {}, this.td = {}, this.Od = void 0, this.nd = !1, this.od = !1, this.ld = !1, this.$anon_distinct_id = void 0, this.Ad(), this.Xc = !1, this.hd = 0;
        }
    }
}, $9ae5e4a12de151f5$var$id = {
    sessionRecording: class {
        get Rr() {
            return this._instance.config;
        }
        get Ml() {
            return this._instance.persistence;
        }
        get started() {
            var t;
            return !!(null === (t = this.Xd) || void 0 === t ? void 0 : t.isStarted);
        }
        get status() {
            var t, i;
            return "awaiting_config" === this.Yd || "missing_config" === this.Yd ? this.Yd : null !== (t = null === (i = this.Xd) || void 0 === i ? void 0 : i.status) && void 0 !== t ? t : this.Yd;
        }
        constructor(i){
            if (this._instance = i, this._forceAllowLocalhostNetworkCapture = !1, this.Yd = $9ae5e4a12de151f5$var$Ju, this.tv = void 0, this.ev = !1, this.Xe = (()=>{
                var i, e;
                if (!(null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.visibilityState) || "visible" === $9ae5e4a12de151f5$var$s.visibilityState) return !0;
                const n = null == $9ae5e4a12de151f5$var$t || null === (i = $9ae5e4a12de151f5$var$t.performance) || void 0 === i || null === (e = i.getEntriesByType) || void 0 === e ? void 0 : e.call(i, "visibility-state");
                return !(null == n ? void 0 : n.length) || n.some((t)=>"visible" === t.name);
            })(), this.ln = ()=>{
                var t, i;
                "visible" === (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.visibilityState) && (this.Xe = !0, null === (t = this.Xd) || void 0 === t || null === (i = t.setDocumentWasEverVisible) || void 0 === i || i.call(t, !0));
            }, !this._instance.sessionManager) throw $9ae5e4a12de151f5$var$Xu.error("started without valid sessionManager"), new Error("[SessionRecording] started without valid sessionManager. This is a bug.");
            if ("always" === this.Rr.cookieless_mode) throw new Error('[SessionRecording] cannot be used with cookieless_mode="always"');
            (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.addEventListener) && $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "visibilitychange", this.ln);
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        dispose({ discardBufferedEvents: t = !1 } = {}) {
            var i;
            this.ev = !0, null == $9ae5e4a12de151f5$var$s || null === (i = $9ae5e4a12de151f5$var$s.removeEventListener) || void 0 === i || i.call($9ae5e4a12de151f5$var$s, "visibilitychange", this.ln), t ? this.iv(!0) : this.stopRecording();
        }
        get nv() {
            var i;
            const e = !!(null === (i = this._instance.get_property("$session_recording_remote_config")) || void 0 === i ? void 0 : i.enabled), s = !this.Rr.disable_session_recording, n = this.Rr.disable_session_recording || this._instance.consent.isOptedOut();
            return $9ae5e4a12de151f5$var$t && e && s && !n;
        }
        startIfEnabledOrStop(t) {
            var i;
            if (this.ev) return;
            if (this.nv && (null === (i = this.Xd) || void 0 === i ? void 0 : i.isStarted)) return;
            const e = !$9ae5e4a12de151f5$var$R(Object.assign) && !$9ae5e4a12de151f5$var$R(Array.from);
            this.nv && e ? (this.sv(t), $9ae5e4a12de151f5$var$Xu.info("starting")) : (this.Yd = $9ae5e4a12de151f5$var$Ju, this.stopRecording());
        }
        sv(t) {
            var i, e;
            if (this.nv) {
                if ("awaiting_config" !== this.Yd && "missing_config" !== this.Yd && (this.Yd = $9ae5e4a12de151f5$var$Yu), (null == $9ae5e4a12de151f5$var$c || null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i || null === (i = i.rrweb) || void 0 === i ? void 0 : i.record) && (null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e ? void 0 : e.initSessionRecording)) this.rv(t);
                else {
                    var s, n;
                    const i = this._instance.sessionManager;
                    null === (s = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === s || null === (n = s.loadExternalDependency) || void 0 === n || n.call(s, this._instance, this.ov, (e)=>{
                        if (!this.ev && this.nv && this._instance.sessionManager === i) return e ? (this._instance.register_for_session({
                            $sdk_debug_recording_script_not_loaded: !0
                        }), $9ae5e4a12de151f5$var$Xu.error("could not load recorder", e)) : void this.rv(t);
                        this.Yd = "disabled";
                    });
                }
            }
        }
        stopRecording() {
            var t, i;
            null === (t = this.tv) || void 0 === t || t.call(this), this.tv = void 0, null === (i = this.Xd) || void 0 === i || i.stop();
        }
        iv(t = !1) {
            var i, e;
            null === (i = this.tv) || void 0 === i || i.call(this), this.tv = void 0, null === (e = this.Xd) || void 0 === e || e.discard({
                discardProducerEvents: t
            });
        }
        av() {
            var t, i;
            null === (t = this.Ml) || void 0 === t || t.unregister("$session_is_sampled"), null === (i = this.Ml) || void 0 === i || i.unregister("$replay_sample_rate");
        }
        lv(t, i) {
            if ($9ae5e4a12de151f5$var$F(t)) return null;
            const e = $9ae5e4a12de151f5$var$D(t) ? t : parseFloat(t);
            var s;
            return "number" != typeof (s = e) || !Number.isFinite(s) || 0 > s || s > 1 ? ($9ae5e4a12de151f5$var$Xu.warn(`${i} must be between 0 and 1. Ignoring invalid value:`, t), null) : e;
        }
        uv(t) {
            if (this.Ml) {
                var i, e;
                const s = this.Ml, n = ()=>{
                    var i;
                    const e = !1 === t.sessionRecording ? void 0 : t.sessionRecording, n = this.lv(null === (i = this.Rr.session_recording) || void 0 === i ? void 0 : i.sampleRate, "session_recording.sampleRate"), r = this.lv(null == e ? void 0 : e.sampleRate, "remote config sampleRate"), o = null != n ? n : r;
                    $9ae5e4a12de151f5$var$F(o) && this.av();
                    const l = null == e ? void 0 : e.minimumDurationMilliseconds;
                    s.register({
                        [$9ae5e4a12de151f5$var$xs]: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({
                            cache_timestamp: Date.now(),
                            enabled: !!e
                        }, e), {}, {
                            networkPayloadCapture: $9ae5e4a12de151f5$var$Ei({
                                capturePerformance: t.capturePerformance
                            }, null == e ? void 0 : e.networkPayloadCapture),
                            canvasRecording: {
                                enabled: null == e ? void 0 : e.recordCanvas,
                                fps: null == e ? void 0 : e.canvasFps,
                                quality: null == e ? void 0 : e.canvasQuality
                            },
                            sampleRate: o,
                            minimumDurationMilliseconds: $9ae5e4a12de151f5$var$R(l) ? null : l,
                            endpoint: null == e ? void 0 : e.endpoint,
                            triggerMatchType: null == e ? void 0 : e.triggerMatchType,
                            masking: null == e ? void 0 : e.masking,
                            urlTriggers: null == e ? void 0 : e.urlTriggers,
                            version: null == e ? void 0 : e.version,
                            triggerGroups: null == e ? void 0 : e.triggerGroups
                        })
                    });
                };
                n(), null === (i = this.tv) || void 0 === i || i.call(this), this.tv = null === (e = this._instance.sessionManager) || void 0 === e ? void 0 : e.onSessionId(n);
            }
        }
        onRemoteConfig(t) {
            const i = t.ok ? t.config : void 0;
            return i && "sessionRecording" in i ? !1 === i.sessionRecording ? (this.uv(i), void this.iv()) : (this.uv(i), void this.startIfEnabledOrStop()) : ("awaiting_config" === this.Yd && (this.Yd = "missing_config", this._instance.register_for_session({
                [$9ae5e4a12de151f5$var$En]: !0
            }), $9ae5e4a12de151f5$var$Xu.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
        }
        log(t, i = "log") {
            var e;
            (null === (e = this.Xd) || void 0 === e ? void 0 : e.log) ? this.Xd.log(t, i) : $9ae5e4a12de151f5$var$Xu.warn("log called before recorder was ready");
        }
        get ov() {
            var t, i;
            const e = null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t ? void 0 : t.get_property($9ae5e4a12de151f5$var$xs);
            return (null == e || null === (i = e.scriptConfig) || void 0 === i ? void 0 : i.script) || "lazy-recorder";
        }
        hv() {
            const t = this._instance.get_property($9ae5e4a12de151f5$var$xs);
            if (!t) return !1;
            let i;
            try {
                i = "object" == typeof t ? t : JSON.parse(t);
            } catch (t) {
                return $9ae5e4a12de151f5$var$Xu.warn("persisted remote config for session recording is invalid and will be ignored", t), !1;
            }
            return !$9ae5e4a12de151f5$var$F(i.cache_timestamp) && 36e5 >= Date.now() - i.cache_timestamp;
        }
        rv(t) {
            var i, e, s;
            if (!this.ev && this.nv && this._instance.sessionManager) {
                if (!(null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.initSessionRecording)) return $9ae5e4a12de151f5$var$Xu.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({
                    [$9ae5e4a12de151f5$var$xn]: !0
                });
                var n;
                if (this.Xd || (this.Xd = null === (n = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === n ? void 0 : n.initSessionRecording(this._instance, this.Xe), this.Xd._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.hv()) {
                    if ("missing_config" === this.Yd || "awaiting_config" === this.Yd) return;
                    return this.Yd = "awaiting_config", $9ae5e4a12de151f5$var$Xu.info("persisted remote config is stale, requesting fresh config before starting"), void new $9ae5e4a12de151f5$var$Ol(this._instance).load();
                }
                this.Yd = $9ae5e4a12de151f5$var$Yu, null === (e = (s = this.Xd).setDocumentWasEverVisible) || void 0 === e || e.call(s, this.Xe), this.Xd.start(t);
            } else this.Yd = $9ae5e4a12de151f5$var$Ju;
        }
        onRRwebEmit(t) {
            var i, e;
            null === (i = this.Xd) || void 0 === i || null === (e = i.onRRwebEmit) || void 0 === e || e.call(i, t);
        }
        overrideLinkedFlag() {
            var t, i;
            this.Xd || null === (i = this.Ml) || void 0 === i || i.register({
                $replay_override_linked_flag: !0
            }), null === (t = this.Xd) || void 0 === t || t.overrideLinkedFlag();
        }
        overrideSampling() {
            var t, i;
            this.Xd || null === (i = this.Ml) || void 0 === i || i.register({
                $replay_override_sampling: !0
            }), null === (t = this.Xd) || void 0 === t || t.overrideSampling();
        }
        overrideTrigger(t) {
            var i, e;
            this.Xd || null === (e = this.Ml) || void 0 === e || e.register({
                ["url" === t ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0
            }), null === (i = this.Xd) || void 0 === i || i.overrideTrigger(t);
        }
        get sdkDebugProperties() {
            var t;
            return (null === (t = this.Xd) || void 0 === t ? void 0 : t.sdkDebugProperties) || {
                $recording_status: this.status
            };
        }
        tryAddCustomEvent(t, i) {
            var e;
            return !!(null === (e = this.Xd) || void 0 === e ? void 0 : e.tryAddCustomEvent(t, i));
        }
        flushBeforeIdentityReset() {
            var t, i;
            null === (t = this.Xd) || void 0 === t || null === (i = t.flushBeforeIdentityReset) || void 0 === i || i.call(t);
        }
    }
}, $9ae5e4a12de151f5$var$ed = {
    autocapture: class extends $9ae5e4a12de151f5$var$Nu {
        constructor(t){
            super(new $9ae5e4a12de151f5$var$ju(t)), this.instance = t;
        }
    },
    historyAutocapture: class {
        constructor(t){
            this._instance = t, this.dv = this.vv();
        }
        initialize() {
            this.startIfEnabled();
        }
        get isEnabled() {
            const t = this.fv();
            return !!(t.path || t.search || this.pv(t));
        }
        startIfEnabled() {
            this.isEnabled && ($9ae5e4a12de151f5$var$Je.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
        }
        startIfEnabledOrStop() {
            this.stop(), this.dv = this.vv(), this.startIfEnabled();
        }
        stop() {
            this.gv && this.gv(), this.gv = void 0, this.mv && this.mv(), this.mv = void 0, $9ae5e4a12de151f5$var$Je.info("History API monitoring stopped");
        }
        monitorHistoryChanges() {
            $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$t.history && (this.yv("pushState"), this.yv("replaceState"), this.bv(), this.pv() && this._v());
        }
        yv(i) {
            var e;
            if (!$9ae5e4a12de151f5$var$t || (null === (e = $9ae5e4a12de151f5$var$t.history[i]) || void 0 === e ? void 0 : e.__posthog_wrapped__)) return;
            const s = this;
            $9ae5e4a12de151f5$var$zu($9ae5e4a12de151f5$var$t.history, i, (t)=>function(e, n, r) {
                    t.call(this, e, n, r), s.wv(i);
                });
        }
        vv() {
            const i = null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.location;
            if (null == i ? void 0 : i.pathname) return {
                pathname: i.pathname,
                search: i.search,
                hash: i.hash
            };
        }
        fv() {
            const t = this._instance.config.capture_pageview;
            return "history_change" === t ? {
                path: !0
            } : $9ae5e4a12de151f5$var$C(t) ? t : {};
        }
        pv(t = this.fv()) {
            return !!t.hash && !this._instance.config.disable_capture_url_hashes;
        }
        Sv(t) {
            const i = this.fv(), e = this.dv;
            return !(!e || !(i.path && t.pathname !== e.pathname || i.search && t.search !== e.search || this.pv(i) && t.hash !== e.hash));
        }
        wv(t) {
            try {
                const i = this.vv();
                if (!i) return;
                this.Sv(i) && this._instance.capture($9ae5e4a12de151f5$var$Bn, {
                    navigation_type: t
                }), this.dv = i;
            } catch (i) {
                $9ae5e4a12de151f5$var$Je.error(`Error capturing ${t} pageview`, i);
            }
        }
        bv() {
            if (this.gv) return;
            const i = ()=>{
                this.wv("popstate");
            };
            $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "popstate", i), this.gv = ()=>{
                $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$t.removeEventListener("popstate", i);
            };
        }
        _v() {
            if (this.mv) return;
            const i = ()=>{
                this.wv("hashchange");
            };
            $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "hashchange", i), this.mv = ()=>{
                $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$t.removeEventListener("hashchange", i);
            };
        }
    },
    heatmaps: class {
        get Rr() {
            return this.instance.config;
        }
        constructor(t){
            var i;
            this.xv = !1, this.xo = !1, this.Cv = null, this.instance = t, this.xv = !!(null === (i = this.instance.persistence) || void 0 === i ? void 0 : i.props[$9ae5e4a12de151f5$var$ps]), this.rageclicks = new $9ae5e4a12de151f5$var$Ru(t.config.rageclick);
        }
        initialize() {
            this.startIfEnabled();
        }
        get flushIntervalMilliseconds() {
            let t = 5e3;
            return $9ae5e4a12de151f5$var$C(this.Rr.capture_heatmaps) && this.Rr.capture_heatmaps.flush_interval_milliseconds && (t = this.Rr.capture_heatmaps.flush_interval_milliseconds), t;
        }
        get isEnabled() {
            return $9ae5e4a12de151f5$var$F(this.Rr.capture_heatmaps) ? $9ae5e4a12de151f5$var$F(this.Rr.enable_heatmaps) ? this.xv : this.Rr.enable_heatmaps : !1 !== this.Rr.capture_heatmaps;
        }
        startIfEnabled() {
            if (this.isEnabled) {
                if (this.xo) return;
                $9ae5e4a12de151f5$var$Qu.info("starting..."), this.$v(), this.ln();
            } else {
                var t;
                clearInterval(null !== (t = this.Cv) && void 0 !== t ? t : void 0), this.Tv(), this.getAndClearBuffer();
            }
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            if (!("heatmaps" in i)) return;
            const e = !!i.heatmaps;
            this.instance.persistence && this.instance.persistence.register({
                [$9ae5e4a12de151f5$var$ps]: e
            }), this.xv = e, this.startIfEnabled();
        }
        getAndClearBuffer() {
            const t = this.Rt;
            return this.Rt = void 0, t;
        }
        Iv(t) {
            $9ae5e4a12de151f5$var$Zu(t.originalEvent) && this.Tr(t.originalEvent, "deadclick");
        }
        ln() {
            this.Cv && clearInterval(this.Cv), this.Cv = "visible" === (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.visibilityState) ? setInterval(this.bl.bind(this), this.flushIntervalMilliseconds) : null;
        }
        $v() {
            $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$s && (this.Mv = this.bl.bind(this), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, $9ae5e4a12de151f5$var$Ln, this.Mv), this.Ev = (i)=>this.Tr(i || (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.event)), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "click", this.Ev, {
                capture: !0
            }), this.Pv = (i)=>this.Rv(i || (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.event)), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "mousemove", this.Pv, {
                capture: !0
            }), this.Av = new $9ae5e4a12de151f5$var$bo(this.instance, $9ae5e4a12de151f5$var$go, this.Iv.bind(this)), this.Av.startIfEnabledOrStop(), this.Fv = this.ln.bind(this), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, $9ae5e4a12de151f5$var$jn, this.Fv), this.xo = !0);
        }
        Tv() {
            var i;
            $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$s && (this.Mv && $9ae5e4a12de151f5$var$t.removeEventListener($9ae5e4a12de151f5$var$Ln, this.Mv), this.Ev && $9ae5e4a12de151f5$var$s.removeEventListener("click", this.Ev, {
                capture: !0
            }), this.Pv && $9ae5e4a12de151f5$var$s.removeEventListener("mousemove", this.Pv, {
                capture: !0
            }), this.Fv && $9ae5e4a12de151f5$var$s.removeEventListener($9ae5e4a12de151f5$var$jn, this.Fv), clearTimeout(this.Ov), null === (i = this.Av) || void 0 === i || i.stop(), this.xo = !1);
        }
        Dv(i, e) {
            const s = this.instance.scrollManager.scrollY(), n = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), o = function(i, e, s) {
                let n = i;
                for(; n && $9ae5e4a12de151f5$var$Ir(n) && !$9ae5e4a12de151f5$var$Ar(n, "body");){
                    if (n === s) return !1;
                    let i;
                    try {
                        var r, o, l;
                        i = null === (r = null !== (o = null === (l = n.ownerDocument) || void 0 === l ? void 0 : l.defaultView) && void 0 !== o ? o : $9ae5e4a12de151f5$var$t) || void 0 === r ? void 0 : r.getComputedStyle(n).position;
                    } catch (t) {
                        return !1;
                    }
                    if ($9ae5e4a12de151f5$var$b(e, i)) return !0;
                    n = $9ae5e4a12de151f5$var$Vr(n);
                }
                return !1;
            }($9ae5e4a12de151f5$var$Ur(i), [
                "fixed",
                "sticky"
            ], r);
            return {
                x: i.clientX + (o ? 0 : n),
                y: i.clientY + (o ? 0 : s),
                target_fixed: o,
                type: e
            };
        }
        Tr(t, i = "click") {
            var e;
            if ($9ae5e4a12de151f5$var$Rr(t.target) || !$9ae5e4a12de151f5$var$Zu(t)) return;
            const s = this.Dv(t, i);
            (null === (e = this.rageclicks) || void 0 === e ? void 0 : e.isRageClick(t.clientX, t.clientY, (new Date).getTime())) && $9ae5e4a12de151f5$var$Qr($9ae5e4a12de151f5$var$Ur(t), this.instance.config.rageclick) && this.Zs($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, s), {}, {
                type: "rageclick"
            })), this.Zs(s);
        }
        Rv(t) {
            !$9ae5e4a12de151f5$var$Rr(t.target) && $9ae5e4a12de151f5$var$Zu(t) && (clearTimeout(this.Ov), this.Ov = setTimeout(()=>{
                this.Zs(this.Dv(t, "mousemove"));
            }, 500));
        }
        Zs(i) {
            if (!$9ae5e4a12de151f5$var$t) return;
            const e = this.Rr.disable_capture_url_hashes ? $9ae5e4a12de151f5$var$vi($9ae5e4a12de151f5$var$t.location.href) : $9ae5e4a12de151f5$var$t.location.href, s = this.Rr.custom_personal_data_properties, n = this.Rr.mask_personal_data_properties ? [
                ...$9ae5e4a12de151f5$var$No,
                ...s || []
            ] : [], r = $9ae5e4a12de151f5$var$Ao(e, n, $9ae5e4a12de151f5$var$Lo);
            this.Rt = this.Rt || {}, this.Rt[r] || (this.Rt[r] = []), this.Rt[r].push(i);
        }
        bl() {
            this.Rt && !$9ae5e4a12de151f5$var$O(this.Rt) && this.instance.capture("$$heatmap", {
                $heatmap_data: this.getAndClearBuffer()
            });
        }
    },
    deadClicksAutocapture: $9ae5e4a12de151f5$var$bo,
    webVitalsAutocapture: class {
        constructor(t){
            var i;
            this._instance = t, this.xv = !1, this.xo = !1, this.Rt = {
                navigationKey: void 0,
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            }, this.Lv = ()=>{
                clearTimeout(this.Nv), this.Nv = void 0, 0 !== this.Rt.metrics.length && (this._instance.capture("$web_vitals", $9ae5e4a12de151f5$var$Ei({
                    $current_url: this.Rt.url
                }, this.Rt.metrics.reduce((t, i)=>$9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                        [`$web_vitals_${i.name}_event`]: $9ae5e4a12de151f5$var$Ei({}, i),
                        [`$web_vitals_${i.name}_value`]: i.value
                    }), {}))), this.Rt = {
                    navigationKey: void 0,
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                });
            }, this.qv = (t)=>{
                var i;
                if (this.Rt = this.Rt || {
                    navigationKey: void 0,
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                }, $9ae5e4a12de151f5$var$F(null == t ? void 0 : t.name) || $9ae5e4a12de151f5$var$F(null == t ? void 0 : t.value)) return void $9ae5e4a12de151f5$var$qu.error("Invalid metric received", t);
                const e = "string" == typeof t.navigationURL ? t.navigationURL : void 0, s = this.jv(e);
                if ($9ae5e4a12de151f5$var$R(s)) return;
                const n = $9ae5e4a12de151f5$var$D(t.navigationId) || "string" == typeof t.navigationId ? `navigation:${t.navigationId}` : `url:${s}`;
                if (this.Bv && t.value >= this.Bv) return void $9ae5e4a12de151f5$var$qu.error("Ignoring metric with value >= " + this.Bv, t);
                this.Rt.navigationKey !== n && (this.Lv(), this.Nv = setTimeout(this.Lv, this.flushToCaptureTimeoutMs)), $9ae5e4a12de151f5$var$R(this.Rt.navigationKey) && (this.Rt.navigationKey = n, this.Rt.url = s), this.Rt.firstMetricTimestamp = $9ae5e4a12de151f5$var$R(this.Rt.firstMetricTimestamp) ? Date.now() : this.Rt.firstMetricTimestamp;
                const r = null === (i = this._instance.sessionManager) || void 0 === i ? void 0 : i.checkAndGetSessionAndWindowId(!0), o = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), e ? {
                    navigationURL: s
                } : {}), {}, {
                    $current_url: s,
                    timestamp: Date.now()
                });
                if (delete o.entries, $9ae5e4a12de151f5$var$C(t.attribution) && this.attributionMetrics.indexOf(t.name) > -1) {
                    const i = {};
                    for (const e of $9ae5e4a12de151f5$var$Ku){
                        const s = "url" === e && "string" == typeof t.attribution[e] ? this.jv(t.attribution[e]) : t.attribution[e];
                        $9ae5e4a12de151f5$var$R(s) || (i[e] = s);
                    }
                    o.attribution = i;
                } else delete o.attribution;
                $9ae5e4a12de151f5$var$R(r) || (o.$session_id = r.sessionId, o.$window_id = r.windowId), this.Rt.metrics.push(o), this.Rt.metrics.length === this.allowedMetrics.length && this.Lv();
            }, this.Hv = ()=>{
                if (this.xo) return;
                let t, i, e, s, n = !1;
                const r = $9ae5e4a12de151f5$var$c.__PosthogExtensions__, o = null == r ? void 0 : r.postHogWebVitalsCallbacksByFlavor, l = (null == o ? void 0 : o[this.zv]) || ("web-vitals" === this.zv && $9ae5e4a12de151f5$var$R(o) ? null == r ? void 0 : r.postHogWebVitalsCallbacks : void 0);
                if (!$9ae5e4a12de151f5$var$R(l)) {
                    const r = l.withoutAttribution, o = this.attributionMetrics;
                    n = !$9ae5e4a12de151f5$var$R(r), t = o.indexOf("LCP") > -1 ? l.onLCP : (null == r ? void 0 : r.onLCP) || l.onLCP, i = o.indexOf("CLS") > -1 ? l.onCLS : (null == r ? void 0 : r.onCLS) || l.onCLS, e = o.indexOf("FCP") > -1 ? l.onFCP : (null == r ? void 0 : r.onFCP) || l.onFCP, s = o.indexOf("INP") > -1 ? l.onINP : (null == r ? void 0 : r.onINP) || l.onINP;
                }
                if (!(t && i && e && s)) return void $9ae5e4a12de151f5$var$qu.error("web vitals callbacks not loaded - not starting");
                const a = {
                    reportSoftNavs: this.useSoftNavs
                }, u = n && this.attributionMetrics.indexOf("INP") > -1 ? $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, a), {}, {
                    includeProcessedEventEntries: !1
                }) : a;
                this.allowedMetrics.indexOf("LCP") > -1 && t(this.qv.bind(this), a), this.allowedMetrics.indexOf("CLS") > -1 && i(this.qv.bind(this), a), this.allowedMetrics.indexOf("FCP") > -1 && e(this.qv.bind(this), a), this.allowedMetrics.indexOf("INP") > -1 && s(this.qv.bind(this), u), this.xo = !0;
            }, this.xv = !!(null === (i = this._instance.persistence) || void 0 === i ? void 0 : i.props[$9ae5e4a12de151f5$var$bs]), this.startIfEnabled();
        }
        get Uv() {
            return this._instance.config.capture_performance;
        }
        get allowedMetrics() {
            var t, i;
            const e = $9ae5e4a12de151f5$var$C(this.Uv) ? null === (t = this.Uv) || void 0 === t ? void 0 : t.web_vitals_allowed_metrics : void 0;
            return $9ae5e4a12de151f5$var$F(e) ? (null === (i = this._instance.persistence) || void 0 === i ? void 0 : i.props.$web_vitals_allowed_metrics) || $9ae5e4a12de151f5$var$Wu : e;
        }
        get flushToCaptureTimeoutMs() {
            return ($9ae5e4a12de151f5$var$C(this.Uv) ? this.Uv.web_vitals_delayed_flush_ms : void 0) || 5e3;
        }
        get attributionMetrics() {
            const t = $9ae5e4a12de151f5$var$C(this.Uv) ? this.Uv.web_vitals_attribution : void 0;
            return $9ae5e4a12de151f5$var$j(t) ? t ? $9ae5e4a12de151f5$var$Wu : [] : $9ae5e4a12de151f5$var$T(t) ? t : $9ae5e4a12de151f5$var$Gu;
        }
        get useAttribution() {
            return this.attributionMetrics.length > 0;
        }
        get useSoftNavs() {
            const t = $9ae5e4a12de151f5$var$C(this.Uv) ? this.Uv.__preview_web_vitals_soft_navs : void 0;
            return null != t && t;
        }
        get Bv() {
            const t = $9ae5e4a12de151f5$var$C(this.Uv) && $9ae5e4a12de151f5$var$D(this.Uv.__web_vitals_max_value) ? this.Uv.__web_vitals_max_value : $9ae5e4a12de151f5$var$Vu;
            return t > 0 && 6e4 >= t ? $9ae5e4a12de151f5$var$Vu : t;
        }
        get isEnabled() {
            const t = null == $9ae5e4a12de151f5$var$n ? void 0 : $9ae5e4a12de151f5$var$n.protocol;
            if ("http:" !== t && "https:" !== t) return $9ae5e4a12de151f5$var$qu.info("Web Vitals are disabled on non-http/https protocols"), !1;
            const i = $9ae5e4a12de151f5$var$C(this.Uv) ? this.Uv.web_vitals : $9ae5e4a12de151f5$var$j(this.Uv) ? this.Uv : void 0;
            return $9ae5e4a12de151f5$var$j(i) ? i : this.xv;
        }
        startIfEnabled() {
            this.isEnabled && !this.xo && ($9ae5e4a12de151f5$var$qu.info("enabled, starting..."), this.zo(this.Hv));
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            if (!("capturePerformance" in i)) return;
            const e = $9ae5e4a12de151f5$var$C(i.capturePerformance) && !!i.capturePerformance.web_vitals, s = $9ae5e4a12de151f5$var$C(i.capturePerformance) ? i.capturePerformance.web_vitals_allowed_metrics : void 0;
            this._instance.persistence && (this._instance.persistence.register({
                [$9ae5e4a12de151f5$var$bs]: e
            }), this._instance.persistence.register({
                [$9ae5e4a12de151f5$var$Ss]: s
            })), this.xv = e, this.startIfEnabled();
        }
        get zv() {
            return this.useSoftNavs ? this.useAttribution ? "web-vitals-with-attribution-soft-navs" : "web-vitals-soft-navs" : this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
        }
        zo(t) {
            var i;
            const e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__, s = this.zv, n = null == e ? void 0 : e.postHogWebVitalsCallbacksByFlavor;
            (null == n ? void 0 : n[s]) || "web-vitals" === s && $9ae5e4a12de151f5$var$R(n) && (null == e ? void 0 : e.postHogWebVitalsCallbacks) ? t() : null == e || null === (i = e.loadExternalDependency) || void 0 === i || i.call(e, this._instance, s, (i)=>{
                i ? $9ae5e4a12de151f5$var$qu.error("failed to load script", i) : t();
            });
        }
        jv(i) {
            const e = i || (null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.location.href);
            if (!e) return void $9ae5e4a12de151f5$var$qu.error("Could not determine current URL");
            const s = this._instance.config.disable_capture_url_hashes ? $9ae5e4a12de151f5$var$vi(e) : e, n = this._instance.config.custom_personal_data_properties, r = this._instance.config.mask_personal_data_properties ? [
                ...$9ae5e4a12de151f5$var$No,
                ...n || []
            ] : [];
            return $9ae5e4a12de151f5$var$Ao(s, r, $9ae5e4a12de151f5$var$Lo);
        }
    }
}, $9ae5e4a12de151f5$var$sd = {
    exceptionObserver: class {
        constructor(i){
            var e;
            this.Hv = ()=>{
                var i;
                if (!$9ae5e4a12de151f5$var$t || !this.isEnabled || !(null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.errorWrappingFunctions)) return;
                const e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, s = $9ae5e4a12de151f5$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, n = $9ae5e4a12de151f5$var$c.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.Wv && this.Rr.capture_unhandled_errors && (this.Wv = e(this.captureException.bind(this))), !this.Vv && this.Rr.capture_unhandled_rejections && (this.Vv = s(this.captureException.bind(this))), !this.Gv && this.Rr.capture_console_errors && (this.Gv = n(this.captureException.bind(this)));
                } catch (t) {
                    $9ae5e4a12de151f5$var$Lu.error("failed to start", t), this.Zv();
                }
            }, this._instance = i, this.Qv = !!(null === (e = this._instance.persistence) || void 0 === e ? void 0 : e.props[$9ae5e4a12de151f5$var$_s]), this.wt = new $9ae5e4a12de151f5$var$tt($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, function(t = {}) {
                var i, e, s, n;
                return {
                    refillRate: null !== (i = null !== (e = t.exceptionRateLimiterRefillRate) && void 0 !== e ? e : t.__exceptionRateLimiterRefillRate) && void 0 !== i ? i : 1,
                    bucketSize: null !== (s = null !== (n = t.exceptionRateLimiterBucketSize) && void 0 !== n ? n : t.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10
                };
            }(this._instance.config.error_tracking)), {}, {
                refillInterval: 1e4,
                $: $9ae5e4a12de151f5$var$Lu
            })), this.Rr = this.Jv(), this.startIfEnabledOrStop();
        }
        Jv() {
            const t = this._instance.config.capture_exceptions;
            let i = {
                capture_unhandled_errors: !1,
                capture_unhandled_rejections: !1,
                capture_console_errors: !1
            };
            return $9ae5e4a12de151f5$var$C(t) ? i = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), t) : ($9ae5e4a12de151f5$var$R(t) ? this.Qv : t) && (i = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, i), {}, {
                capture_unhandled_errors: !0,
                capture_unhandled_rejections: !0
            })), i;
        }
        get isEnabled() {
            return this.Rr.capture_console_errors || this.Rr.capture_unhandled_errors || this.Rr.capture_unhandled_rejections;
        }
        startIfEnabledOrStop() {
            this.isEnabled ? ($9ae5e4a12de151f5$var$Lu.info("enabled"), this.Zv(), this.zo(this.Hv)) : this.Zv();
        }
        zo(t) {
            var i, e, s;
            (null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.errorWrappingFunctions) ? t() : null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "exception-autocapture", (i)=>{
                if (i) return $9ae5e4a12de151f5$var$Lu.error("failed to load script", i);
                t();
            });
        }
        Zv() {
            var t, i, e;
            null === (t = this.Wv) || void 0 === t || t.call(this), this.Wv = void 0, null === (i = this.Vv) || void 0 === i || i.call(this), this.Vv = void 0, null === (e = this.Gv) || void 0 === e || e.call(this), this.Gv = void 0;
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            "autocaptureExceptions" in i && (this.Qv = !!i.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({
                [$9ae5e4a12de151f5$var$_s]: this.Qv
            }), this.Rr = this.Jv(), this.startIfEnabledOrStop());
        }
        onConfigChange() {
            this.Rr = this.Jv();
        }
        captureException(t) {
            try {
                var i, e, s;
                const n = null !== (i = null == t || null === (e = t.$exception_list) || void 0 === e || null === (e = e[0]) || void 0 === e ? void 0 : e.type) && void 0 !== i ? i : "Exception";
                if (this.wt.consumeRateLimit(n)) return void $9ae5e4a12de151f5$var$Lu.info("Skipping exception capture because of client rate limiting.", {
                    exception: n
                });
                null === (s = this._instance.exceptions) || void 0 === s || s.sendExceptionEvent(t);
            } catch (t) {}
        }
    },
    exceptions: class {
        constructor(t){
            var i, e;
            this.Kv = [], this.Xv = new $9ae5e4a12de151f5$var$ki([
                new $9ae5e4a12de151f5$var$Gi,
                new $9ae5e4a12de151f5$var$se,
                new $9ae5e4a12de151f5$var$Ji,
                new $9ae5e4a12de151f5$var$Ki,
                new $9ae5e4a12de151f5$var$ie,
                new $9ae5e4a12de151f5$var$te,
                new $9ae5e4a12de151f5$var$Xi,
                new $9ae5e4a12de151f5$var$ee
            ], function(t, ...i) {
                return (e, s = 0)=>{
                    const n = [], r = e.split("\n"), o = Math.min(r.length, s + 1e3), l = [];
                    for(let e = s; o > e; e++){
                        const s = r[e];
                        if (s.length > 1024) continue;
                        const o = $9ae5e4a12de151f5$var$Li.test(s) ? s.replace($9ae5e4a12de151f5$var$Li, "$1") : s;
                        if (!o.match(/\S*Error: /)) {
                            for (const e of i){
                                const i = e(o, t);
                                if (i) {
                                    n.push(i);
                                    const t = $9ae5e4a12de151f5$var$Ui(n);
                                    if (t) {
                                        for(let i = l.length - 1; i >= 0; i--){
                                            const e = l[i];
                                            if (t.start >= e.start + e.length) break;
                                            l.pop();
                                        }
                                        l.push(t);
                                    }
                                    break;
                                }
                            }
                            if ($9ae5e4a12de151f5$var$Vi(n, l) >= 50) break;
                        }
                    }
                    const a = [
                        ...l
                    ].sort((t, i)=>i.start - t.start), u = a[a.length - 1];
                    if (u) {
                        const t = $9ae5e4a12de151f5$var$Hi(n, u);
                        n.splice(u.start - t, t);
                        for (const i of a)i.start -= t;
                    }
                    for (const t of a)$9ae5e4a12de151f5$var$zi(n, t);
                    return l.some((t)=>0 === t.start && n.length === t.length) && function(t) {
                        const i = t.map((t)=>`${t.function}|${t.filename}|${t.lineno}|${t.colno}|${t.module}`);
                        let e = 0;
                        for(let t = 1; i.length > t; t++)$9ae5e4a12de151f5$var$Wi(i, t, e) && (e = t);
                        t.push(...t.splice(0, e));
                    }(n), function(t) {
                        if (!t.length) return [];
                        const i = Array.from(t);
                        return i.reverse(), i.slice(0, 50).map((t)=>{
                            var e;
                            return $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                                filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                                function: t.function || "?"
                            });
                        });
                    }(n);
                };
            }("web:javascript", $9ae5e4a12de151f5$var$Fi, $9ae5e4a12de151f5$var$ji)), this._instance = t, this.Kv = null !== (i = null === (e = this._instance.persistence) || void 0 === e ? void 0 : e.get_property("$error_tracking_suppression_rules")) && void 0 !== i ? i : [], this.Yv = $9ae5e4a12de151f5$var$ae(this.tf()), this.ef = new $9ae5e4a12de151f5$var$ue(this.Yv);
        }
        onConfigChange() {
            this.Yv = $9ae5e4a12de151f5$var$ae(this.tf()), this.ef.setConfig(this.Yv);
        }
        onRemoteConfig(t) {
            var i, e, s;
            if (!t.ok) return;
            const n = t.config;
            if (!("errorTracking" in n)) return;
            const r = null !== (i = null === (e = n.errorTracking) || void 0 === e ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], o = null === (s = n.errorTracking) || void 0 === s ? void 0 : s.captureExtensionExceptions;
            this.Kv = r, this._instance.persistence && this._instance.persistence.register({
                [$9ae5e4a12de151f5$var$gs]: this.Kv,
                [$9ae5e4a12de151f5$var$ms]: o
            });
        }
        get if() {
            var t;
            const i = !!this._instance.get_property($9ae5e4a12de151f5$var$ms), e = this._instance.config.error_tracking.captureExtensionExceptions;
            return null !== (t = null != e ? e : i) && void 0 !== t && t;
        }
        buildProperties(t, i) {
            return this.Xv.buildFromUnknown(t, {
                syntheticException: null == i ? void 0 : i.syntheticException,
                mechanism: {
                    handled: null == i ? void 0 : i.handled
                }
            });
        }
        addExceptionStep(t, i) {
            if (this.Yv.enabled) try {
                if (!$9ae5e4a12de151f5$var$I(t) || 0 === t.trim().length) return void $9ae5e4a12de151f5$var$Ch.warn("Ignoring exception step because message must be a non-empty string");
                const { sanitizedProperties: e, droppedKeys: s } = function(t) {
                    if (!t) return {
                        sanitizedProperties: {},
                        droppedKeys: []
                    };
                    const i = [];
                    return {
                        sanitizedProperties: Object.keys(t).reduce((e, s)=>$9ae5e4a12de151f5$var$oe.has(s) ? (i.push(s), e) : (e[s] = t[s], e), {}),
                        droppedKeys: i
                    };
                }(this.nf(i));
                s.length > 0 && $9ae5e4a12de151f5$var$Ch.warn("Ignoring reserved exception step fields", {
                    droppedKeys: s
                }), this.ef.add($9ae5e4a12de151f5$var$Ei({
                    [$9ae5e4a12de151f5$var$ne]: t,
                    [$9ae5e4a12de151f5$var$re]: (new Date).toISOString()
                }, e));
            } catch (t) {
                $9ae5e4a12de151f5$var$Ch.error("Failed to add exception step. Ignoring breadcrumb.", t);
            }
        }
        sendExceptionEvent(t) {
            try {
                const i = t.$exception_list;
                if (this.sf(i)) {
                    if (this.rf(i)) return this.af("Exception dropped: matched a suppression rule"), void $9ae5e4a12de151f5$var$Ch.info("Skipping exception capture because a suppression rule matched");
                    if (!this.if && this.lf(i)) return this.af("Exception dropped: thrown by a browser extension"), void $9ae5e4a12de151f5$var$Ch.info("Skipping exception capture because it was thrown by an extension");
                    if (!this.if && this.uf(i)) return this.af("Exception dropped: thrown by an injected browser script"), void $9ae5e4a12de151f5$var$Ch.info("Skipping exception capture because it was thrown by an injected browser script");
                    if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.hf(i)) return this.af("Exception dropped: thrown by the PostHog SDK"), void $9ae5e4a12de151f5$var$Ch.info("Skipping exception capture because it was thrown by the PostHog SDK");
                }
                const e = this.Yv.enabled && $9ae5e4a12de151f5$var$F(t.$exception_steps) ? this.cf(t) : t, s = function() {
                    const t = globalThis._posthogReleaseId;
                    return "string" == typeof t && t.length > 0 ? t : void 0;
                }();
                s && (e.$release_id = s);
                try {
                    const t = this._instance.capture("$exception", e, {
                        _noTruncate: !0,
                        _batchKey: "exceptionEvent",
                        fh: !0
                    });
                    return t && this.ef.clear(), t;
                } catch (t) {
                    return $9ae5e4a12de151f5$var$Ph(t) || $9ae5e4a12de151f5$var$Ch.error("Failed to capture exception event. Dropping this exception.", t), void this.ef.clear();
                }
            } catch (t) {
                return void ($9ae5e4a12de151f5$var$Ph(t) || $9ae5e4a12de151f5$var$Ch.error("Failed to process exception event. Ignoring this exception.", t));
            }
        }
        cf(t) {
            try {
                const i = this.ef.getAttachable();
                return 0 === i.length ? t : $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t), {}, {
                    $exception_steps: i
                });
            } catch (i) {
                return $9ae5e4a12de151f5$var$Ch.error("Failed to read buffered exception steps. Capturing exception without steps.", i), t;
            }
        }
        af(t) {
            this.Yv.enabled && this.ef.add({
                [$9ae5e4a12de151f5$var$ne]: t,
                [$9ae5e4a12de151f5$var$re]: (new Date).toISOString()
            });
        }
        nf(t) {
            return $9ae5e4a12de151f5$var$C(t) ? $9ae5e4a12de151f5$var$Ei({}, t) : {};
        }
        tf() {
            var t, i;
            return null !== (t = null === (i = this._instance.config.error_tracking) || void 0 === i ? void 0 : i.exception_steps) && void 0 !== t ? t : {};
        }
        rf(t) {
            if (0 === t.length) return !1;
            try {
                const i = t.reduce((t, { type: i, value: e })=>($9ae5e4a12de151f5$var$I(i) && i.length > 0 && t.$exception_types.push(i), $9ae5e4a12de151f5$var$I(e) && e.length > 0 && t.$exception_values.push(e), t), {
                    $exception_types: [],
                    $exception_values: []
                });
                return this.Kv.some((t)=>{
                    const e = t.values.map((t)=>{
                        const e = $9ae5e4a12de151f5$var$Ka[t.operator], s = i[t.key];
                        if (!e || !s) return !1;
                        const n = $9ae5e4a12de151f5$var$T(t.value) ? t.value : [
                            t.value
                        ];
                        return n.length > 0 && e(n, s);
                    });
                    return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
                });
            } catch (t) {
                return $9ae5e4a12de151f5$var$Ch.warn("Failed to evaluate suppression rules. Capturing the exception.", t), !1;
            }
        }
        lf(t) {
            const i = t.flatMap((t)=>{
                var i, e;
                return null !== (i = null === (e = t.stacktrace) || void 0 === e ? void 0 : e.frames) && void 0 !== i ? i : [];
            }), e = i.filter(({ filename: t })=>!!t && $9ae5e4a12de151f5$var$Ih.some((i)=>t.startsWith(i)));
            return 0 !== e.length && (!e.every(({ filename: t })=>!!t && t.startsWith($9ae5e4a12de151f5$var$Oh)) || t.some(({ type: t, value: i })=>"NoResponse" === t || $9ae5e4a12de151f5$var$I(i) && $9ae5e4a12de151f5$var$Rh.some(({ value: t, exact: e })=>e ? i === t : i.includes(t))) && !i.some(({ in_app: t, filename: i })=>t && !(null == i ? void 0 : i.startsWith($9ae5e4a12de151f5$var$Oh))));
        }
        uf(t) {
            return t.some(({ value: t })=>$9ae5e4a12de151f5$var$I(t) && $9ae5e4a12de151f5$var$Ah.some((i)=>t.includes(i)));
        }
        hf(t) {
            if (t.length > 0) {
                var i, e, s, n;
                const r = null !== (i = null === (e = t[0].stacktrace) || void 0 === e ? void 0 : e.frames) && void 0 !== i ? i : [], o = r[r.length - 1];
                return null !== (s = null == o || null === (n = o.filename) || void 0 === n ? void 0 : n.includes("posthog.com/static")) && void 0 !== s && s;
            }
            return !1;
        }
        sf(t) {
            return !$9ae5e4a12de151f5$var$F(t) && $9ae5e4a12de151f5$var$T(t);
        }
    }
}, $9ae5e4a12de151f5$var$nd = $9ae5e4a12de151f5$var$Ei({
    productTours: class {
        get Ml() {
            return this._instance.persistence;
        }
        constructor(t){
            this.df = null, this.vf = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!t.ok) return;
            const i = t.config;
            if ("productTours" in i) {
                var e, s;
                if (this.Ml && this.Ml.register({
                    [$9ae5e4a12de151f5$var$ws]: !!i.productTours
                }), !$9ae5e4a12de151f5$var$ih(this._instance)) return !this.df && $9ae5e4a12de151f5$var$F(null === (e = this.Ml) || void 0 === e ? void 0 : e.props.ph_product_tours) || $9ae5e4a12de151f5$var$th.info("product tours disabled; stopping and clearing cached tours"), null === (s = this.df) || void 0 === s || s.stop(), this.df = null, void this.clearCache();
                this.loadIfEnabled();
            }
        }
        loadIfEnabled() {
            !this.df && $9ae5e4a12de151f5$var$ih(this._instance) && this.zo(()=>this.ff());
        }
        zo(t) {
            var i, e, s;
            (null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.generateProductTours) ? t() : null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "product-tours", (i)=>{
                i ? $9ae5e4a12de151f5$var$th.error("Could not load product tours script", i) : t();
            });
        }
        ff() {
            var t;
            !this.df && (null === (t = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === t ? void 0 : t.generateProductTours) && (this.df = $9ae5e4a12de151f5$var$c.__PosthogExtensions__.generateProductTours(this._instance, !0));
        }
        getProductTours(t, i = !1) {
            if ($9ae5e4a12de151f5$var$T(this.vf) && !i) return void t(this.vf, {
                isLoaded: !0
            });
            const e = this.Ml;
            if (e) {
                const s = e.props[$9ae5e4a12de151f5$var$en];
                if ($9ae5e4a12de151f5$var$T(s) && !i) return this.vf = s, void t(s, {
                    isLoaded: !0
                });
            }
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", `/api/product_tours/?token=${this._instance.config.token}`),
                method: "GET",
                timestampMode: "query",
                callback: (i)=>{
                    if (!$9ae5e4a12de151f5$var$ih(this._instance)) return void t([], {
                        isLoaded: !0
                    });
                    const s = i.statusCode;
                    if (200 !== s || !i.json) {
                        const e = `Product Tours API could not be loaded, status: ${s}`;
                        return 0 === s ? i.error || $9ae5e4a12de151f5$var$th.warn(e) : $9ae5e4a12de151f5$var$th.error(e), void t([], {
                            isLoaded: !1,
                            error: e
                        });
                    }
                    const n = $9ae5e4a12de151f5$var$T(i.json.product_tours) ? i.json.product_tours : [];
                    this.vf = n, e && e.register({
                        [$9ae5e4a12de151f5$var$en]: n
                    }), t(n, {
                        isLoaded: !0
                    });
                }
            });
        }
        getActiveProductTours(t) {
            $9ae5e4a12de151f5$var$F(this.df) ? t([], {
                isLoaded: !1,
                error: "Product tours not loaded"
            }) : this.df.getActiveProductTours(t);
        }
        showProductTour(t) {
            var i;
            null === (i = this.df) || void 0 === i || i.showTourById(t);
        }
        previewTour(t) {
            this.df ? this.df.previewTour(t) : this.zo(()=>{
                var i;
                this.ff(), null === (i = this.df) || void 0 === i || i.previewTour(t);
            });
        }
        dismissProductTour() {
            var t;
            null === (t = this.df) || void 0 === t || t.dismissTour("user_clicked_skip");
        }
        nextStep() {
            var t;
            null === (t = this.df) || void 0 === t || t.nextStep();
        }
        previousStep() {
            var t;
            null === (t = this.df) || void 0 === t || t.previousStep();
        }
        clearCache() {
            var t;
            this.vf = null, null === (t = this.Ml) || void 0 === t || t.unregister("ph_product_tours");
        }
        resetTour(t) {
            var i;
            null === (i = this.df) || void 0 === i || i.resetTour(t);
        }
        resetAllTours() {
            var t;
            null === (t = this.df) || void 0 === t || t.resetAllTours();
        }
        cancelPendingTour(t) {
            var i;
            null === (i = this.df) || void 0 === i || i.cancelPendingTour(t);
        }
    }
}, $9ae5e4a12de151f5$var$td), $9ae5e4a12de151f5$var$rd = {
    siteApps: class {
        constructor(t){
            this._instance = t, this.pf = 0, this.gf = [], this.apps = {};
        }
        get isEnabled() {
            return !!this._instance.config.opt_in_site_apps;
        }
        mf(t, i) {
            if (!i) return;
            const e = this.globalsForEvent(i);
            this.gf.push(e), this.gf.length > 1e3 && (this.gf = this.gf.slice(10));
        }
        get siteAppLoaders() {
            var t;
            return null === (t = $9ae5e4a12de151f5$var$c._POSTHOG_REMOTE_CONFIG) || void 0 === t || null === (t = t[this._instance.config.token]) || void 0 === t ? void 0 : t.siteApps;
        }
        initialize() {
            if (this.isEnabled) {
                const t = this._instance._addCaptureHook(this.mf.bind(this));
                this.yf = ()=>{
                    t(), this.gf = [], this.yf = void 0;
                };
            }
        }
        globalsForEvent(t) {
            var i, e, s, n, r, o, l;
            if (!t) throw new Error("Event payload is required");
            const a = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
            for (const [t, i] of Object.entries(h))a[t] = {
                id: u[t],
                type: t,
                properties: i
            };
            const { $set_once: d, $set: c } = t;
            return {
                event: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$xe(t, $9ae5e4a12de151f5$var$eh)), {}, {
                    properties: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, t.properties), c ? {
                        $set: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, null !== (i = null === (e = t.properties) || void 0 === e ? void 0 : e.$set) && void 0 !== i ? i : {}), c)
                    } : {}), d ? {
                        $set_once: $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, null !== (s = null === (n = t.properties) || void 0 === n ? void 0 : n.$set_once) && void 0 !== s ? s : {}), d)
                    } : {}),
                    elements_chain: null !== (r = null === (o = t.properties) || void 0 === o ? void 0 : o.$elements_chain) && void 0 !== r ? r : "",
                    distinct_id: null === (l = t.properties) || void 0 === l ? void 0 : l.distinct_id
                }),
                person: {
                    properties: this._instance.get_property("$stored_person_properties")
                },
                groups: a
            };
        }
        bf(t) {
            var i;
            const e = null === (i = t.tagName) || void 0 === i ? void 0 : i.toLowerCase();
            if ("style" === e && this._instance.config.prepare_external_dependency_stylesheet) return this._instance.config.prepare_external_dependency_stylesheet(t) || ($9ae5e4a12de151f5$var$sh.error("prepare_external_dependency_stylesheet returned null"), null);
            if ("script" === e && this._instance.config.prepare_external_dependency_script) return this._instance.config.prepare_external_dependency_script(t) || ($9ae5e4a12de151f5$var$sh.error("prepare_external_dependency_script returned null"), null);
            return t;
        }
        _f() {
            var t, i, e, n, r, o, l, a;
            if (!this._instance.config.prepare_external_dependency_stylesheet && !this._instance.config.prepare_external_dependency_script) return ()=>{};
            const u = null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.defaultView, h = null == u || null === (t = u.Node) || void 0 === t ? void 0 : t.prototype;
            if (!u || !h) return ()=>{};
            if (this.pf++, this.wf) return this.kf();
            const d = [], c = this, v = new WeakSet, f = (t, i, e)=>{
                if (!(null == t ? void 0 : t[i])) return;
                const s = t[i];
                t[i] = e(s), d.push(()=>{
                    t[i] = s;
                });
            }, p = (t)=>{
                if (v.has(t)) return t;
                const i = c.bf(t);
                return i && v.add(i), i;
            }, _ = (t)=>t.map((t)=>"string" == typeof t ? t : p(t)).filter((t)=>!$9ae5e4a12de151f5$var$M(t));
            return f(h, "appendChild", (t)=>function(i) {
                    const e = p(i);
                    return e ? t.call(this, e) : i;
                }), f(h, "insertBefore", (t)=>function(i, e) {
                    const s = p(i);
                    return s ? t.call(this, s, e) : i;
                }), f(h, "replaceChild", (t)=>function(i, e) {
                    const s = p(i);
                    return s ? t.call(this, s, e) : e;
                }), [
                null === (i = u.Element) || void 0 === i ? void 0 : i.prototype,
                null === (e = u.Document) || void 0 === e ? void 0 : e.prototype,
                null === (n = u.DocumentFragment) || void 0 === n ? void 0 : n.prototype
            ].forEach((t)=>{
                f(t, "append", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    }), f(t, "prepend", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    });
            }), [
                null === (r = u.Element) || void 0 === r ? void 0 : r.prototype,
                null === (o = u.CharacterData) || void 0 === o ? void 0 : o.prototype,
                null === (l = u.DocumentType) || void 0 === l ? void 0 : l.prototype
            ].forEach((t)=>{
                f(t, "before", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    }), f(t, "after", (t)=>function(...i) {
                        return t.apply(this, _(i));
                    }), f(t, "replaceWith", (t)=>function(...i) {
                        const e = _(i);
                        return i.length && !e.length ? void 0 : t.apply(this, e);
                    });
            }), f(null === (a = u.Element) || void 0 === a ? void 0 : a.prototype, "insertAdjacentElement", (t)=>function(i, e) {
                    const s = p(e);
                    return s ? t.call(this, i, s) : null;
                }), this.wf = ()=>{
                d.forEach((t)=>t()), this.wf = void 0;
            }, this.kf();
        }
        kf() {
            let t = !1;
            return ()=>{
                var i;
                t || (t = !0, this.pf--, 0 === this.pf && (null === (i = this.wf) || void 0 === i || i.call(this)));
            };
        }
        Sf(t, i = !0) {
            const e = this._f();
            try {
                const s = t(e);
                return i && e(), s;
            } catch (t) {
                throw e(), t;
            }
        }
        setupSiteApp(t) {
            const i = this.apps[t.id], e = ()=>{
                var e;
                !i.errored && this.gf.length && ($9ae5e4a12de151f5$var$sh.info(`Processing ${this.gf.length} events for site app with id ${t.id}`), this.gf.forEach((t)=>this.Sf(()=>{
                        var e;
                        return null === (e = i.processEvent) || void 0 === e ? void 0 : e.call(i, t);
                    })), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored) && (null === (e = this.yf) || void 0 === e || e.call(this));
            };
            let s = !1;
            const n = (n)=>{
                i.errored = !n, i.loaded = !0, $9ae5e4a12de151f5$var$sh.info(`Site app with id ${t.id} ${n ? "loaded" : "errored"}`), s && e();
            };
            try {
                const { processEvent: e } = this.Sf((i)=>t.init({
                        posthog: this._instance,
                        callback (t) {
                            i(), n(t);
                        }
                    }), !1);
                e && (i.processEvent = e), s = !0;
            } catch (i) {
                $9ae5e4a12de151f5$var$sh.error($9ae5e4a12de151f5$var$nh + t.id, i), n(!1);
            }
            if (s && i.loaded) try {
                e();
            } catch (e) {
                $9ae5e4a12de151f5$var$sh.error(`Error while processing buffered events PostHog app with config id ${t.id}`, e), i.errored = !0;
            }
        }
        xf() {
            const t = this.siteAppLoaders || [];
            for (const i of t)this.apps[i.id] = {
                id: i.id,
                loaded: !1,
                errored: !1,
                processedBuffer: !1
            };
            for (const i of t)this.setupSiteApp(i);
        }
        Cf(t) {
            if (0 === Object.keys(this.apps).length) return;
            const i = this.globalsForEvent(t);
            for (const e of Object.values(this.apps))try {
                this.Sf(()=>{
                    var t;
                    return null === (t = e.processEvent) || void 0 === t ? void 0 : t.call(e, i);
                });
            } catch (i) {
                $9ae5e4a12de151f5$var$sh.error(`Error while processing event ${t.event} for site app ${e.id}`, i);
            }
        }
        onRemoteConfig(t) {
            var i, e, s;
            if (null === (i = this.siteAppLoaders) || void 0 === i ? void 0 : i.length) return this.isEnabled ? (this.xf(), void this._instance.on("eventCaptured", (t)=>this.Cf(t))) : void $9ae5e4a12de151f5$var$sh.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            if (null === (e = this.yf) || void 0 === e || e.call(this), !t.ok) return;
            const n = t.config;
            if (null === (s = n.siteApps) || void 0 === s ? void 0 : s.length) {
                if (this.isEnabled) for (const { id: t, url: i } of n.siteApps){
                    var r, o;
                    $9ae5e4a12de151f5$var$c[`__$$ph_site_app_${t}`] = this._instance, null === (r = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === r || null === (o = r.loadSiteApp) || void 0 === o || o.call(r, this._instance, i, (i)=>{
                        if (i) return $9ae5e4a12de151f5$var$sh.error($9ae5e4a12de151f5$var$nh + t, i);
                    });
                }
                else $9ae5e4a12de151f5$var$sh.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            }
        }
    }
}, $9ae5e4a12de151f5$var$od = {
    tracingHeaders: class {
        constructor(t){
            this._instance = t, this.$f = void 0, this.Tf = void 0, this.If = void 0, this.Hv = ()=>{
                const t = this.Mf();
                var i, e;
                t ? ($9ae5e4a12de151f5$var$R(this.$f) && (this.$f = null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i || null === (i = i.tracingHeadersPatchFns) || void 0 === i ? void 0 : i._patchXHR(t, ()=>this._instance.get_distinct_id(), this._instance.sessionManager)), $9ae5e4a12de151f5$var$R(this.Tf) && (this.Tf = null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (e = e.tracingHeadersPatchFns) || void 0 === e ? void 0 : e._patchFetch(t, ()=>this._instance.get_distinct_id(), this._instance.sessionManager))) : this.Zv();
            };
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        zo(t) {
            var i, e, s;
            (null === (i = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === i ? void 0 : i.tracingHeadersPatchFns) ? t() : null === (e = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === e || null === (s = e.loadExternalDependency) || void 0 === s || s.call(e, this._instance, "tracing-headers", (i)=>{
                if (i) return $9ae5e4a12de151f5$var$Hu.error("failed to load script", i);
                t();
            });
        }
        Ef() {
            var t, i;
            return null !== (t = null !== (i = this._instance.config.tracing_headers) && void 0 !== i ? i : this._instance.config.addTracingHeaders) && void 0 !== t ? t : this._instance.config.__add_tracing_headers;
        }
        Mf() {
            const t = this.Ef();
            return $9ae5e4a12de151f5$var$T(t) ? ($9ae5e4a12de151f5$var$T(this.If) ? this.If.splice(0, this.If.length, ...t) : this.If = [
                ...t
            ], t.length > 0 ? this.If : void 0) : ($9ae5e4a12de151f5$var$T(this.If) && this.If.splice(0), this.If = t || void 0, this.If);
        }
        Zv() {
            var t, i;
            null === (t = this.$f) || void 0 === t || t.call(this), null === (i = this.Tf) || void 0 === i || i.call(this), this.$f = void 0, this.Tf = void 0;
        }
        startIfEnabledOrStop() {
            this.Mf() ? this.zo(this.Hv) : this.Zv();
        }
    }
}, $9ae5e4a12de151f5$var$ld = $9ae5e4a12de151f5$var$Ei({
    surveys: class extends $9ae5e4a12de151f5$var$ah {
        constructor(t){
            var i;
            super(new $9ae5e4a12de151f5$var$fh(t), (i = t, {
                get projectToken () {
                    return i.config.token;
                },
                kv: new $9ae5e4a12de151f5$var$vh(i)
            })), this._instance = t;
        }
        qh(t, i) {
            const e = i.query ? $9ae5e4a12de151f5$var$ga(t, i.query) : t;
            return new Promise((t)=>{
                var s;
                this._instance._send_request({
                    method: i.method,
                    url: this._instance.requestRouter.endpointFor(null !== (s = i.target) && void 0 !== s ? s : "api", e),
                    data: i.body,
                    headers: i.headers,
                    timeout: i.timeoutMs,
                    fireCallbackOnDrop: !0,
                    transport: i.transport,
                    compression: i.compression,
                    timestampMode: i.sentAt,
                    callback: t
                });
            });
        }
    }
}, $9ae5e4a12de151f5$var$td), $9ae5e4a12de151f5$var$ad = {
    toolbar: class {
        constructor(t){
            this.instance = t;
        }
        Pf(t) {
            $9ae5e4a12de151f5$var$c.ph_toolbar_state = t;
        }
        Rf() {
            var t;
            return null !== (t = $9ae5e4a12de151f5$var$c.ph_toolbar_state) && void 0 !== t ? t : 0;
        }
        initialize() {
            return this.maybeLoadToolbar();
        }
        maybeLoadToolbar(i, e, n) {
            var r, o;
            if ($9ae5e4a12de151f5$var$tr(this.instance.config)) return !1;
            if (!$9ae5e4a12de151f5$var$t || !$9ae5e4a12de151f5$var$s) return !1;
            i = null !== (r = i) && void 0 !== r ? r : $9ae5e4a12de151f5$var$t.location, n = null !== (o = n) && void 0 !== o ? o : $9ae5e4a12de151f5$var$t.history;
            try {
                if (!e) {
                    try {
                        $9ae5e4a12de151f5$var$t.localStorage.setItem("test", "test"), $9ae5e4a12de151f5$var$t.localStorage.removeItem("test");
                    } catch (t) {
                        return !1;
                    }
                    e = null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.localStorage;
                }
                const s = $9ae5e4a12de151f5$var$ph || $9ae5e4a12de151f5$var$Mo(i.hash, "__posthog") || $9ae5e4a12de151f5$var$Mo(i.hash, "state");
                let r;
                const o = s ? $9ae5e4a12de151f5$var$fi(()=>JSON.parse(atob(decodeURIComponent(s)))) || $9ae5e4a12de151f5$var$fi(()=>JSON.parse(decodeURIComponent(s))) : null;
                return o && "ph_authorize" === o.action ? (r = o, r.source = "url", r && Object.keys(r).length > 0 && (o.desiredHash ? i.hash = o.desiredHash : n ? n.replaceState(n.state, "", i.pathname + i.search) : i.hash = "")) : (r = JSON.parse(e.getItem($9ae5e4a12de151f5$var$_h) || "{}"), r.source = "localstorage", delete r.userIntent), !(!r.token || this.instance.config.token !== r.token || (this.loadToolbar(r), 0));
            } catch (t) {
                return !1;
            }
        }
        Af(t) {
            const i = $9ae5e4a12de151f5$var$c.ph_load_toolbar || $9ae5e4a12de151f5$var$c.ph_load_editor;
            !$9ae5e4a12de151f5$var$F(i) && $9ae5e4a12de151f5$var$P(i) ? i(t, this.instance) : $9ae5e4a12de151f5$var$gh.warn("No toolbar load function found");
        }
        loadToolbar(i) {
            const e = !!(null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.getElementById("__POSTHOG_TOOLBAR__"));
            if (!$9ae5e4a12de151f5$var$t || e) return !1;
            const n = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, r = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({
                token: this.instance.config.token
            }, i), {}, {
                apiURL: this.instance.requestRouter.endpointFor("ui")
            }, n ? {
                instrument: !1
            } : {});
            if ($9ae5e4a12de151f5$var$t.localStorage.setItem($9ae5e4a12de151f5$var$_h, JSON.stringify($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, r), {}, {
                source: void 0
            }))), 2 === this.Rf()) this.Af(r);
            else if (0 === this.Rf()) {
                var o, l;
                this.Pf(1), null === (o = $9ae5e4a12de151f5$var$c.__PosthogExtensions__) || void 0 === o || null === (l = o.loadExternalDependency) || void 0 === l || l.call(o, this.instance, "toolbar", (t)=>{
                    if (t) return $9ae5e4a12de151f5$var$gh.error("[Toolbar] Failed to load", t), void this.Pf(0);
                    this.Pf(2), this.Af(r);
                }), $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "turbolinks:load", ()=>{
                    this.Pf(0), this.loadToolbar(r);
                });
            }
            return !0;
        }
        Ff(t) {
            return this.loadToolbar(t);
        }
        maybeLoadEditor(t, i, e) {
            return this.maybeLoadToolbar(t, i, e);
        }
    }
}, $9ae5e4a12de151f5$var$ud = $9ae5e4a12de151f5$var$Ei({
    experiments: class i {
        get Rr() {
            return this._instance.config;
        }
        constructor(t){
            this._instance = t, this.getWebExperimentsAndEvaluateDisplayLogic = (t = !1)=>{
                this.getWebExperiments((t)=>{
                    i.Of("retrieved web experiments from the server"), this.Df = new Map, t.forEach((t)=>{
                        if (t.feature_flag_key) {
                            var e;
                            this.Df && (i.Of("setting flag key ", t.feature_flag_key, " to web experiment ", t), null === (e = this.Df) || void 0 === e || e.set(t.feature_flag_key, t));
                            const s = this._instance.getFeatureFlag(t.feature_flag_key);
                            $9ae5e4a12de151f5$var$I(s) && t.variants[s] && this.Lf(t.name, s, t.variants[s].transforms);
                        } else if (t.variants) for(const e in t.variants){
                            const s = t.variants[e];
                            i.Nf(s, this._instance) && this.Lf(t.name, e, s.transforms);
                        }
                    });
                }, t);
            }, this._instance.onFeatureFlags((t)=>{
                this.onFeatureFlags(t);
            });
        }
        initialize() {}
        onFeatureFlags(t) {
            if (this._is_bot()) i.Of($9ae5e4a12de151f5$var$Mh);
            else if (!this.Rr.disable_web_experiments) {
                if ($9ae5e4a12de151f5$var$F(this.Df)) return this.Df = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
                i.Of("applying feature flags", t), t.forEach((t)=>{
                    var i;
                    if (this.Df && (null === (i = this.Df) || void 0 === i ? void 0 : i.has(t))) {
                        var e;
                        const i = this._instance.getFeatureFlag(t), s = null === (e = this.Df) || void 0 === e ? void 0 : e.get(t);
                        i && (null == s ? void 0 : s.variants[i]) && this.Lf(s.name, i, s.variants[i].transforms);
                    }
                });
            }
        }
        previewWebExperiment() {
            const t = i.getWindowLocation();
            if (null == t ? void 0 : t.search) {
                const e = $9ae5e4a12de151f5$var$Io(null == t ? void 0 : t.search, "__experiment_id"), s = $9ae5e4a12de151f5$var$Io(null == t ? void 0 : t.search, "__experiment_variant");
                e && s && (i.Of(`previewing web experiments ${e} && ${s}`), this.getWebExperiments((t)=>{
                    this.qf(parseInt(e), s, t);
                }, !1, !0));
            }
        }
        loadIfEnabled() {
            this.Rr.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
        }
        getWebExperiments(t, i, e) {
            if (this.Rr.disable_web_experiments && !e) return t([]);
            const s = this._instance.get_property("$web_experiments");
            if (s && !i) return t(s);
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", `/api/web_experiments/?token=${this.Rr.token}`),
                method: "GET",
                timestampMode: "query",
                callback: (i)=>t(200 === i.statusCode && i.json && i.json.experiments || [])
            });
        }
        qf(t, e, s) {
            const n = s.filter((i)=>i.id === t);
            n && n.length > 0 && (i.Of(`Previewing web experiment [${n[0].name}] with variant [${e}]`), this.Lf(n[0].name, e, n[0].variants[e].transforms));
        }
        static Nf(t, e) {
            return !$9ae5e4a12de151f5$var$F(t.conditions) && i.jf(t, e) && i.Bf(t);
        }
        static jf(t, e) {
            var s;
            if ($9ae5e4a12de151f5$var$F(t.conditions) || $9ae5e4a12de151f5$var$F(null === (s = t.conditions) || void 0 === s ? void 0 : s.url)) return !0;
            const n = i.getWindowLocation();
            if (n) {
                var r, o, l;
                const i = $9ae5e4a12de151f5$var$Or(e, n.href);
                return !(null === (r = t.conditions) || void 0 === r ? void 0 : r.url) || $9ae5e4a12de151f5$var$Fh[null !== (o = null === (l = t.conditions) || void 0 === l ? void 0 : l.urlMatchType) && void 0 !== o ? o : "icontains"](t.conditions.url, i);
            }
            return !1;
        }
        static getWindowLocation() {
            return null == $9ae5e4a12de151f5$var$t ? void 0 : $9ae5e4a12de151f5$var$t.location;
        }
        static Bf(t) {
            var i;
            if ($9ae5e4a12de151f5$var$F(t.conditions) || $9ae5e4a12de151f5$var$F(null === (i = t.conditions) || void 0 === i ? void 0 : i.utm)) return !0;
            const e = $9ae5e4a12de151f5$var$Uo();
            if (e.utm_source) {
                var s, n, r, o, l, a, u, h;
                const i = !(null === (s = t.conditions) || void 0 === s || null === (s = s.utm) || void 0 === s ? void 0 : s.utm_campaign) || (null === (n = t.conditions) || void 0 === n || null === (n = n.utm) || void 0 === n ? void 0 : n.utm_campaign) == e.utm_campaign, d = !(null === (r = t.conditions) || void 0 === r || null === (r = r.utm) || void 0 === r ? void 0 : r.utm_source) || (null === (o = t.conditions) || void 0 === o || null === (o = o.utm) || void 0 === o ? void 0 : o.utm_source) == e.utm_source, c = !(null === (l = t.conditions) || void 0 === l || null === (l = l.utm) || void 0 === l ? void 0 : l.utm_medium) || (null === (a = t.conditions) || void 0 === a || null === (a = a.utm) || void 0 === a ? void 0 : a.utm_medium) == e.utm_medium, v = !(null === (u = t.conditions) || void 0 === u || null === (u = u.utm) || void 0 === u ? void 0 : u.utm_term) || (null === (h = t.conditions) || void 0 === h || null === (h = h.utm) || void 0 === h ? void 0 : h.utm_term) == e.utm_term;
                return i && c && v && d;
            }
            return !1;
        }
        static Of(t, ...i) {
            $9ae5e4a12de151f5$var$Je.info(`[WebExperiments] ${t}`, i);
        }
        Lf(t, e, s) {
            this._is_bot() ? i.Of($9ae5e4a12de151f5$var$Mh) : "control" !== e ? s.forEach((s)=>{
                if (s.selector) {
                    var n;
                    i.Of(`applying transform of variant ${e} for experiment ${t} `, s);
                    const r = null === (n = document) || void 0 === n ? void 0 : n.querySelectorAll(s.selector);
                    null == r || r.forEach((t)=>{
                        const i = t;
                        s.html && (i.innerHTML = s.html), s.css && i.setAttribute("style", s.css);
                    });
                }
            }) : i.Of("Control variants leave the page unmodified.");
        }
        _is_bot() {
            return $9ae5e4a12de151f5$var$e && this._instance ? $9ae5e4a12de151f5$var$za($9ae5e4a12de151f5$var$e, this.Rr.custom_blocked_useragents) : void 0;
        }
    }
}, $9ae5e4a12de151f5$var$td), $9ae5e4a12de151f5$var$hd = {
    conversations: class {
        constructor(t){
            this._instance = t, this.Hf = void 0, this._conversationsManager = null, this.zf = !1, this.ne = null, this.Uf = !1;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (this._instance.config.disable_conversations) return;
            if (this.Wf = t.ok, !t.ok) return;
            const i = t.config.conversations;
            $9ae5e4a12de151f5$var$F(i) || ($9ae5e4a12de151f5$var$j(i) ? this.Hf = i : (this.Hf = i.enabled, this.ne = i), this.loadIfEnabled());
        }
        reset() {
            var t;
            null === (t = this._conversationsManager) || void 0 === t || t.reset(), this._conversationsManager = null, this.Hf = void 0, this.ne = null, this.Wf = void 0, this.Uf = !1;
        }
        loadIfEnabled() {
            if (this._conversationsManager) return;
            if (this.zf) return;
            if (this._instance.config.disable_conversations) return;
            if ($9ae5e4a12de151f5$var$tr(this._instance.config)) return;
            if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) return;
            const t = null == $9ae5e4a12de151f5$var$c ? void 0 : $9ae5e4a12de151f5$var$c.__PosthogExtensions__;
            if (t && !$9ae5e4a12de151f5$var$R(this.Hf) && this.Hf) {
                if (this.ne && this.ne.token) {
                    this.zf = !0;
                    try {
                        const i = t.initConversations;
                        if (i) return this.Vf(i), void (this.zf = !1);
                        const e = t.loadExternalDependency;
                        if (!e) return void this.Gf($9ae5e4a12de151f5$var$Mn);
                        e(this._instance, "conversations", (i)=>{
                            i || !t.initConversations ? this.Gf("Could not load conversations script", i) : this.Vf(t.initConversations), this.zf = !1;
                        });
                    } catch (t) {
                        this.Gf("Error initializing conversations", t), this.zf = !1;
                    }
                } else $9ae5e4a12de151f5$var$Dh.error("Conversations enabled but missing token in remote config.");
            }
        }
        Vf(t) {
            if (this.ne) try {
                this._conversationsManager = t(this.ne, this._instance), this.Uf = !1, $9ae5e4a12de151f5$var$Dh.info("Conversations loaded successfully");
            } catch (t) {
                this.Gf("Error completing conversations initialization", t);
            }
            else $9ae5e4a12de151f5$var$Dh.error("Cannot complete initialization: remote config is null");
        }
        Gf(t, i) {
            $9ae5e4a12de151f5$var$Dh.error(t, i), this._conversationsManager = null, this.zf = !1, this.Uf = !0;
        }
        show() {
            this._conversationsManager ? this._conversationsManager.show() : $9ae5e4a12de151f5$var$Dh.warn("Conversations not loaded yet.");
        }
        hide() {
            this._conversationsManager && this._conversationsManager.hide();
        }
        isAvailable() {
            return !0 === this.Hf && !$9ae5e4a12de151f5$var$M(this._conversationsManager);
        }
        getUnavailableReason() {
            return this.isAvailable() ? null : this._instance.config.disable_conversations ? "disabled_by_config" : $9ae5e4a12de151f5$var$tr(this._instance.config) ? "disabled_for_toolbar" : this._instance.config.cookieless_mode && this._instance.consent.isOptedOut() ? "consent_opted_out" : !1 === this.Wf ? "remote_config_failed" : $9ae5e4a12de151f5$var$R(this.Hf) ? this.Wf ? "disabled_in_project" : "remote_config_pending" : this.Hf ? $9ae5e4a12de151f5$var$F(this.ne) || !this.ne.token ? "missing_token" : (null == $9ae5e4a12de151f5$var$c ? void 0 : $9ae5e4a12de151f5$var$c.__PosthogExtensions__) ? this.zf ? "initializing" : this.Uf ? "load_failed" : "not_loaded" : "extensions_unavailable" : "disabled_in_project";
        }
        isVisible() {
            var t, i;
            return null !== (t = null === (i = this._conversationsManager) || void 0 === i ? void 0 : i.isVisible()) && void 0 !== t && t;
        }
        sendMessage(t, i, e) {
            var s = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return s._conversationsManager ? s._conversationsManager.sendMessage(t, i, e) : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        getMessages(t, i) {
            var e = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return e._conversationsManager ? e._conversationsManager.getMessages(t, i) : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        markAsRead(t) {
            var i = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.markAsRead(t) : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        getTickets(t) {
            var i = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.getTickets(t) : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        requestRestoreLink(t) {
            var i = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.requestRestoreLink(t) : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        restoreFromToken(t) {
            var i = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return i._conversationsManager ? i._conversationsManager.restoreFromToken(t) : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        restoreFromUrlToken() {
            var t = this;
            return $9ae5e4a12de151f5$var$Y(function*() {
                return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : ($9ae5e4a12de151f5$var$Dh.warn($9ae5e4a12de151f5$var$Nh), null);
            })();
        }
        getCurrentTicketId() {
            var t, i;
            return null !== (t = null === (i = this._conversationsManager) || void 0 === i ? void 0 : i.getCurrentTicketId()) && void 0 !== t ? t : null;
        }
        getWidgetSessionId() {
            var t, i;
            return null !== (t = null === (i = this._conversationsManager) || void 0 === i ? void 0 : i.getWidgetSessionId()) && void 0 !== t ? t : null;
        }
        Sh() {
            var t;
            null === (t = this._conversationsManager) || void 0 === t || t.setIdentity();
        }
        xh() {
            var t;
            null === (t = this._conversationsManager) || void 0 === t || t.clearIdentity();
        }
    }
}, $9ae5e4a12de151f5$var$dd = {
    logs: class {
        constructor(i){
            var e;
            this._instance = i, this.name = "logs", this.Zf = !1, this.Qf = !1, this.Jf = !1, this.$ = $9ae5e4a12de151f5$var$Ye("[logs]"), this.Kf = $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, this.$), {}, {
                error: (...t)=>{
                    t.some($9ae5e4a12de151f5$var$qh) || this.$.error(...t);
                }
            }), this.al = [], this.Xf = [], this.hd = 0, this.Io = !1, this.Yf = [], this.tp = [], this.ep = !1, this.np = !1, this.sp = ()=>{
                var t, i;
                this.Io || (this.hd = 0, null === (t = this.rp) || void 0 === t || t.onReconnect(), null === (i = this.op) || void 0 === i || i.onReconnect());
            }, this._instance && (null === (e = this._instance.config.logs) || void 0 === e ? void 0 : e.captureConsoleLogs) && (this.Zf = !0), $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$t, "online", this.sp);
        }
        ap(t, i, e, s) {
            var n;
            const r = $9ae5e4a12de151f5$var$jh(null === (n = this._instance) || void 0 === n || null === (n = n.config) || void 0 === n ? void 0 : n.logs, e);
            return [
                new $9ae5e4a12de151f5$var$He(this.lp(t, i), r, this.Kf, ()=>this.up(), (t)=>t(), void 0, s),
                r
            ];
        }
        hp() {
            var t;
            const i = null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.logs;
            var e;
            return this.rp && this.cp === i || (null === (e = this.rp) || void 0 === e || e.reset(), this.cp = i, [this.rp, this.dp] = this.ap(()=>this.al, (t)=>{
                this.al = t;
            })), this.rp;
        }
        vp() {
            var t;
            const i = null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.logs;
            var e;
            return this.op && this.fp === i || (null === (e = this.op) || void 0 === e || e.reset(), this.fp = i, [this.op, this.pp] = this.ap(()=>this.Xf, (t)=>{
                this.Xf = t;
            }, {
                serviceNameDefault: "posthog-browser-logs",
                consoleCapture: !0
            }, $9ae5e4a12de151f5$var$Uh)), this.op;
        }
        setup(t) {
            var i;
            if (this.Io) return;
            this.wo = t, (null === (i = this._instance) || void 0 === i || null === (i = i.config) || void 0 === i || null === (i = i.logs) || void 0 === i ? void 0 : i.captureConsoleLogs) && (this.Zf = !0), (this.Zf || this.gp() && this.mp()) && this.yp();
            let e = !1;
            const s = t.onRemoteConfig((t)=>{
                var i;
                e = t.ok && !0 === (null === (i = t.config.logs) || void 0 === i ? void 0 : i.captureConsoleLogs), this.onRemoteConfig(t);
            });
            this.Io ? s.dispose() : (this.Po = s, e || this.loadIfEnabled());
        }
        dispose() {
            var i, e, s, n;
            this.Io || (this.Io = !0, this.bp(), null === (i = this.Po) || void 0 === i || i.dispose(), this.Po = void 0, this.wo = void 0, this.Jf = !1, null == $9ae5e4a12de151f5$var$t || $9ae5e4a12de151f5$var$t.removeEventListener("online", this.sp), null === (e = this._p) || void 0 === e || e.call(this), this._p = void 0, null === (s = this.rp) || void 0 === s || s.reset(), null === (n = this.op) || void 0 === n || n.reset());
        }
        onRemoteConfig(t) {
            var i, e;
            if (this.Io) return;
            const s = t.ok ? null === (i = t.config.logs) || void 0 === i ? void 0 : i.captureConsoleLogs : void 0;
            $9ae5e4a12de151f5$var$F(s) ? this.wp() : (null === (e = this._instance) || void 0 === e || null === (e = e.persistence) || void 0 === e || e.register({
                $logs_capture_enabled_server_side: !!s
            }), s ? (this.Zf = !0, this.Qf || this.yp(), this.loadIfEnabled()) : this.wp());
        }
        reset() {
            var t, i, e, s;
            this.bp(), null === (t = this.rp) || void 0 === t || t.clearQueue(), this.al = [], null === (i = this.rp) || void 0 === i || i.reset(), null === (e = this.op) || void 0 === e || e.clearQueue(), this.Xf = [], null === (s = this.op) || void 0 === s || s.reset(), this.hd = 0;
        }
        captureLog(t) {
            this.Io || this.hp().captureLog(t);
        }
        captureConsoleLog(t) {
            this.Io || this.vp().captureLog(t);
        }
        captureBufferedConsoleLog(t, i, e) {
            this.Io || this.vp().captureLog(t, {
                context: i,
                occurredAtMs: e
            });
        }
        mp() {
            var t;
            return !!(null === (t = this._instance) || void 0 === t || null === (t = t.persistence) || void 0 === t || null === (t = t.props) || void 0 === t ? void 0 : t[$9ae5e4a12de151f5$var$$s]);
        }
        gp() {
            var t, i, e;
            return !(null === (t = this._instance) || void 0 === t || null === (i = t.nl) || void 0 === i ? void 0 : i.call(t)) || !!(null === (e = $9ae5e4a12de151f5$var$c._POSTHOG_REMOTE_CONFIG) || void 0 === e || null === (e = e[this._instance.config.token]) || void 0 === e ? void 0 : e.config);
        }
        $h() {
            var t;
            this.bp(), null === (t = this.op) || void 0 === t || t.clearQueue(), this.Xf = [];
        }
        wp() {
            this.Zf || this.bp();
        }
        yp() {
            var t;
            if (this.ep || !(null == $9ae5e4a12de151f5$var$c ? void 0 : $9ae5e4a12de151f5$var$c.console)) return;
            const i = $9ae5e4a12de151f5$var$jh(null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.logs).maxBufferSize;
            let e = !0;
            this.tp.push(()=>{
                e = !1;
            });
            for (const t of $9ae5e4a12de151f5$var$Lh){
                let s;
                try {
                    s = $9ae5e4a12de151f5$var$Bh($9ae5e4a12de151f5$var$c.console[t]);
                } catch (t) {
                    continue;
                }
                s && this.tp.push($9ae5e4a12de151f5$var$zu($9ae5e4a12de151f5$var$c.console, t, (n)=>{
                    const r = (...s)=>{
                        try {
                            e && this.kp(t, s, i);
                        } catch (t) {}
                        return n.apply($9ae5e4a12de151f5$var$c.console, s);
                    };
                    return r.__rrweb_original__ = s, r;
                }));
            }
            this.ep = !0, this.Sp = setTimeout(()=>{
                this.bp();
            }, 3e4);
        }
        kp(t, i, e) {
            var s;
            if (this.ep && !this.np && 0 !== i.length) {
                if (null === (s = this._instance) || void 0 === s ? void 0 : s.is_capturing()) {
                    if (e > this.Yf.length) {
                        this.np = !0;
                        try {
                            this.Yf.push({
                                level: t,
                                args: i,
                                occurredAtMs: Date.now(),
                                context: this.up()
                            });
                        } finally{
                            this.np = !1;
                        }
                    }
                } else this.bp();
            }
        }
        bp() {
            if (this.Yf = [], this.ep) {
                this.ep = !1, this.Sp && (clearTimeout(this.Sp), this.Sp = void 0);
                for (const t of this.tp)t();
                this.tp = [];
            }
        }
        xp() {
            const t = this.Yf;
            return this.bp(), t;
        }
        get logger() {
            return this.Cp || (this.Cp = {
                trace: (t, i)=>this.captureLog({
                        body: t,
                        level: "trace",
                        attributes: i
                    }),
                debug: (t, i)=>this.captureLog({
                        body: t,
                        level: "debug",
                        attributes: i
                    }),
                info: (t, i)=>this.captureLog({
                        body: t,
                        level: "info",
                        attributes: i
                    }),
                warn: (t, i)=>this.captureLog({
                        body: t,
                        level: "warn",
                        attributes: i
                    }),
                error: (t, i)=>this.captureLog({
                        body: t,
                        level: "error",
                        attributes: i
                    }),
                fatal: (t, i)=>this.captureLog({
                        body: t,
                        level: "fatal",
                        attributes: i
                    })
            }), this.Cp;
        }
        flushLogs(t) {
            t ? this.$p(t) : (this.rp && this.rp.flush().catch((t)=>this.Tp(t)), this.op && this.op.flush().catch((t)=>this.Tp(t)));
        }
        Tp(t) {
            $9ae5e4a12de151f5$var$qh(t) || this.$.error("PostHog logs flush failed:", t);
        }
        loadIfEnabled() {
            if (this.Io || !this.Zf || this.Qf || this.Jf) return;
            const t = null == $9ae5e4a12de151f5$var$c ? void 0 : $9ae5e4a12de151f5$var$c.__PosthogExtensions__;
            if (!t) return this.$.error("PostHog Extensions not found."), void this.bp();
            const i = t.loadExternalDependency;
            if (!i) return this.$.error($9ae5e4a12de151f5$var$Mn), void this.bp();
            this.Jf = !0;
            try {
                i(this._instance, "logs", (i)=>{
                    if (this.Jf = !1, this.Io || !this.Zf) return;
                    const e = t.logs;
                    if (i || !(null == e ? void 0 : e.initializeLogs)) this.$.error("Could not load logs script", i), this.bp();
                    else {
                        var s;
                        const t = this.xp();
                        var n, r;
                        this._p = e.initializeLogs(null !== (s = this.wo) && void 0 !== s ? s : this._instance), this.Qf = !0, t.length > 0 && (null === (n = e.replayConsoleBuffer) || void 0 === n || n.call(e, null !== (r = this.wo) && void 0 !== r ? r : this._instance, t));
                    }
                });
            } catch (t) {
                throw this.Jf = !1, t;
            }
        }
        lp(t, i) {
            const e = this._instance;
            return {
                get isDisabled () {
                    return !1;
                },
                get optedOut () {
                    return !e.is_capturing();
                },
                getPersistedProperty: (i)=>i === $9ae5e4a12de151f5$var$p.LogsQueue ? t() : void 0,
                setPersistedProperty (t, e) {
                    var s;
                    t === $9ae5e4a12de151f5$var$p.LogsQueue && i(null !== (s = e) && void 0 !== s ? s : []);
                },
                js: (t)=>this.js(t),
                getLibraryId: ()=>$9ae5e4a12de151f5$var$es.LIB_NAME,
                getLibraryVersion: ()=>$9ae5e4a12de151f5$var$es.LIB_VERSION
            };
        }
        js(t) {
            return new Promise((i)=>{
                if ($9ae5e4a12de151f5$var$Fo(this.hd, 3)) return void i({
                    kind: "fatal",
                    error: $9ae5e4a12de151f5$var$Hh(void 0, "logs endpoint is unreachable, dropping batch")
                });
                let e = !1;
                const s = (t)=>{
                    e || (e = !0, clearTimeout(n), i(t));
                }, n = setTimeout(()=>{
                    this.$.warn("Logs request timed out before receiving a response"), s({
                        kind: "retry-later",
                        error: $9ae5e4a12de151f5$var$Hh(void 0, "logs request timed out")
                    });
                }, 9e4);
                this._instance._send_request({
                    method: "POST",
                    url: this.Ip(),
                    data: t,
                    compression: "best-available",
                    batchKey: "logs",
                    fireCallbackOnDrop: !0,
                    callback: (t)=>{
                        const i = t.statusCode;
                        if (this.Mp(i), i >= 200 && 300 > i) s({
                            kind: "ok"
                        });
                        else if (413 === i) s({
                            kind: "too-large"
                        });
                        else if (0 !== i && 408 !== i && 429 !== i && 500 > i) s({
                            kind: "fatal",
                            error: new Error(`logs request failed with status ${i}`)
                        });
                        else {
                            var e;
                            0 === i ? (t.error || this.$.warn("Logs request failed before receiving an HTTP response"), s({
                                kind: "retry-later",
                                error: $9ae5e4a12de151f5$var$Hh(t.error, "logs request failed before receiving an HTTP response")
                            })) : s({
                                kind: "retry-later",
                                error: null !== (e = t.error) && void 0 !== e ? e : new Error(`logs request failed with status ${i}`)
                            });
                        }
                    }
                });
            });
        }
        Mp(t) {
            (0 !== t || this._instance.__loaded) && (this.hd = $9ae5e4a12de151f5$var$Do(t, this.hd, 3, ()=>this.$.warn("Log requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped sending logs; will try again when connectivity changes.")));
        }
        $p(t) {
            this.al.length > 0 && this.Ep(t, this.al, this.dp, $9ae5e4a12de151f5$var$es.LIB_NAME, (t)=>{
                this.al = t;
            }), this.Xf.length > 0 && this.Ep(t, this.Xf, this.pp, $9ae5e4a12de151f5$var$Uh, (t)=>{
                this.Xf = t;
            });
        }
        Ep(t, i, e, s, n) {
            if (0 === i.length) return;
            const r = i.map((t)=>t.record);
            n([]);
            const o = $9ae5e4a12de151f5$var$Le(r, $9ae5e4a12de151f5$var$je(e, $9ae5e4a12de151f5$var$es.LIB_NAME, $9ae5e4a12de151f5$var$es.LIB_VERSION), s, $9ae5e4a12de151f5$var$es.LIB_VERSION);
            this._instance._send_request({
                method: "POST",
                url: this.Ip(),
                data: o,
                compression: "best-available",
                batchKey: "logs",
                transport: t
            });
        }
        Ip() {
            return this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
        }
        up() {
            var t;
            const i = {};
            if (i.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
                const { sessionId: t, windowId: e, sessionStartTimestamp: s, lastActivityTimestamp: n } = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0);
                i.sessionId = t, i.windowId = e, $9ae5e4a12de151f5$var$F(s) || (i.sessionStartTimestamp = s), $9ae5e4a12de151f5$var$F(n) || (i.lastActivityTimestamp = n);
            }
            if ((null == $9ae5e4a12de151f5$var$c || null === (t = $9ae5e4a12de151f5$var$c.location) || void 0 === t ? void 0 : t.href) && (i.currentUrl = this._instance.config.disable_capture_url_hashes ? $9ae5e4a12de151f5$var$vi($9ae5e4a12de151f5$var$c.location.href) : $9ae5e4a12de151f5$var$c.location.href), this._instance.featureFlags) {
                const t = this._instance.featureFlags.getFlags();
                t && t.length > 0 && (i.activeFeatureFlags = t);
            }
            return i;
        }
    }
}, $9ae5e4a12de151f5$var$cd = {
    metrics: class {
        constructor(t){
            this._instance = t, this.$ = $9ae5e4a12de151f5$var$Ye("[metrics]"), this.Io = !1;
        }
        initialize() {
            this.onConfigChange();
        }
        onConfigChange() {
            var t;
            if (this.Io) return;
            const i = !!(null === (t = this._instance.config.metrics) || void 0 === t ? void 0 : t.network);
            i && !this.Pp ? this.Pp = ((t)=>{
                let i = !0;
                const e = ()=>i ? ((t)=>{
                        var i;
                        const e = null === (i = t.config.metrics) || void 0 === i ? void 0 : i.network;
                        return !0 === e ? {} : e || void 0;
                    })(t) : void 0, s = $9ae5e4a12de151f5$var$Qh(t, e), n = $9ae5e4a12de151f5$var$Zh(t, e);
                return ()=>{
                    i = !1, s(), n();
                };
            })(this._instance) : !i && this.Pp && (this.Pp(), this.Pp = void 0);
        }
        hp() {
            var t;
            const i = null === (t = this._instance) || void 0 === t || null === (t = t.config) || void 0 === t ? void 0 : t.metrics;
            var e;
            return this.rp && this.cp === i || (null === (e = this.rp) || void 0 === e || e.reset(), this.cp = i, this.rp = new $9ae5e4a12de151f5$var$Ge(this.lp(), function(t) {
                var i, e, s, n, r;
                const o = null == t ? void 0 : t.resourceAttributes;
                return {
                    serviceName: null !== (i = null == o ? void 0 : o["service.name"]) && void 0 !== i ? i : null == t ? void 0 : t.serviceName,
                    serviceVersion: null !== (e = null == o ? void 0 : o["service.version"]) && void 0 !== e ? e : null == t ? void 0 : t.serviceVersion,
                    environment: null !== (s = null == o ? void 0 : o["deployment.environment"]) && void 0 !== s ? s : null == t ? void 0 : t.environment,
                    resourceAttributes: o,
                    beforeSend: null == t ? void 0 : t.beforeSend,
                    flushIntervalMs: null !== (n = null == t ? void 0 : t.flushIntervalMs) && void 0 !== n ? n : 1e4,
                    maxSeriesPerFlush: null !== (r = null == t ? void 0 : t.maxSeriesPerFlush) && void 0 !== r ? r : 1e3
                };
            }(i), this.$)), this.rp;
        }
        count(t, i = 1, e) {
            this.hp().count(t, i, e);
        }
        gauge(t, i, e) {
            this.hp().gauge(t, i, e);
        }
        histogram(t, i, e) {
            this.hp().histogram(t, i, e);
        }
        flush(t) {
            if (!this.rp) return Promise.resolve();
            if (t) {
                const i = this.rp.drainWindow();
                return i && this.Ys(i, t), Promise.resolve();
            }
            return this.rp.flush().catch((t)=>this.$.error("PostHog metrics flush failed:", t));
        }
        reset() {
            var t;
            null === (t = this.rp) || void 0 === t || t.reset();
        }
        dispose() {
            var t, i;
            this.Io = !0, null === (t = this.Pp) || void 0 === t || t.call(this), this.Pp = void 0, null === (i = this.rp) || void 0 === i || i.reset();
        }
        lp() {
            const t = this._instance, i = this;
            return {
                get isDisabled () {
                    return !1;
                },
                get optedOut () {
                    return !t.is_capturing();
                },
                Ys: (t)=>i.Ys(t),
                getLibraryId: ()=>$9ae5e4a12de151f5$var$es.LIB_NAME,
                getLibraryVersion: ()=>$9ae5e4a12de151f5$var$es.LIB_VERSION
            };
        }
        Ys(t, i) {
            return new Promise((e)=>{
                let s = !1;
                const n = (t)=>{
                    s || (s = !0, clearTimeout(r), e(t));
                }, r = setTimeout(()=>n({
                        kind: "retry-later",
                        error: new Error("metrics request timed out")
                    }), 9e4);
                this._instance._send_request($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({
                    method: "POST",
                    url: this.Rp(),
                    data: t,
                    compression: "best-available",
                    batchKey: "metrics"
                }, i && {
                    transport: i
                }), {}, {
                    fireCallbackOnDrop: !0,
                    callback (t) {
                        const i = t.statusCode;
                        if (i >= 200 && 300 > i) n({
                            kind: "ok"
                        });
                        else if (413 === i) n({
                            kind: "too-large"
                        });
                        else if (0 !== i && 408 !== i && 429 !== i && 500 > i) n({
                            kind: "fatal",
                            error: new Error(`metrics request failed with status ${i}`)
                        });
                        else {
                            var e;
                            n({
                                kind: "retry-later",
                                error: null !== (e = t.error) && void 0 !== e ? e : new Error(`metrics request failed with status ${i}`)
                            });
                        }
                    }
                }));
            });
        }
        Rp() {
            return this._instance.requestRouter.endpointFor("api", "/i/v1/metrics") + "?token=" + encodeURIComponent(this._instance.config.token);
        }
    }
};
$9ae5e4a12de151f5$export$a9d6b9cbf49b8241.__defaultExtensionClasses = $9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei($9ae5e4a12de151f5$var$Ei({}, $9ae5e4a12de151f5$var$td), $9ae5e4a12de151f5$var$id), $9ae5e4a12de151f5$var$ed), $9ae5e4a12de151f5$var$sd), $9ae5e4a12de151f5$var$nd), $9ae5e4a12de151f5$var$rd), $9ae5e4a12de151f5$var$ld), $9ae5e4a12de151f5$var$od), $9ae5e4a12de151f5$var$ad), $9ae5e4a12de151f5$var$ud), $9ae5e4a12de151f5$var$hd), $9ae5e4a12de151f5$var$dd), $9ae5e4a12de151f5$var$cd));
const $9ae5e4a12de151f5$export$6a8fcb530589c217 = function() {
    $9ae5e4a12de151f5$var$es.SDK_DIST_CHANNEL = "npm";
    const i = $9ae5e4a12de151f5$var$vu[$9ae5e4a12de151f5$var$xu] = new $9ae5e4a12de151f5$export$a9d6b9cbf49b8241;
    return function() {
        function i() {
            i.done || (i.done = !0, $9ae5e4a12de151f5$var$Oa = !1, $9ae5e4a12de151f5$var$Vn($9ae5e4a12de151f5$var$vu, function(t) {
                t._dom_loaded();
            }));
        }
        (null == $9ae5e4a12de151f5$var$s ? void 0 : $9ae5e4a12de151f5$var$s.addEventListener) ? "complete" === $9ae5e4a12de151f5$var$s.readyState ? i() : $9ae5e4a12de151f5$var$Zn($9ae5e4a12de151f5$var$s, "DOMContentLoaded", i, {
            capture: !1
        }) : $9ae5e4a12de151f5$var$t && $9ae5e4a12de151f5$var$Je.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
    }(), i;
}();
var $9ae5e4a12de151f5$export$2e2bcd8739ae039 = $9ae5e4a12de151f5$export$6a8fcb530589c217;

});


parcelRegister("5lcXX", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $3e38f8b30e4a2ada$export$ae55be85d98224ed, (v) => $3e38f8b30e4a2ada$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $3e38f8b30e4a2ada$export$d39a5bbd09211389, (v) => $3e38f8b30e4a2ada$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $3e38f8b30e4a2ada$export$882461b6382ed46c, (v) => $3e38f8b30e4a2ada$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $3e38f8b30e4a2ada$export$466bfc07425424d5, (v) => $3e38f8b30e4a2ada$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $3e38f8b30e4a2ada$export$cd75ccfd720a3cd4, (v) => $3e38f8b30e4a2ada$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $3e38f8b30e4a2ada$export$fa8d919ba61d84db, (v) => $3e38f8b30e4a2ada$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $3e38f8b30e4a2ada$export$757ceba2d55c277e, (v) => $3e38f8b30e4a2ada$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $3e38f8b30e4a2ada$export$b3890eb0ae9dca99, (v) => $3e38f8b30e4a2ada$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $3e38f8b30e4a2ada$export$502457920280e6be, (v) => $3e38f8b30e4a2ada$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $3e38f8b30e4a2ada$export$c78a37762a8d58e1, (v) => $3e38f8b30e4a2ada$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $3e38f8b30e4a2ada$export$dc54d992c10e8a18, (v) => $3e38f8b30e4a2ada$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $3e38f8b30e4a2ada$export$83d89fbfd8236492, (v) => $3e38f8b30e4a2ada$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3e38f8b30e4a2ada$export$ae55be85d98224ed;
var $3e38f8b30e4a2ada$export$d39a5bbd09211389;
var $3e38f8b30e4a2ada$export$882461b6382ed46c;
var $3e38f8b30e4a2ada$export$466bfc07425424d5;
var $3e38f8b30e4a2ada$export$cd75ccfd720a3cd4;
var $3e38f8b30e4a2ada$export$fa8d919ba61d84db;
var $3e38f8b30e4a2ada$export$757ceba2d55c277e;
var $3e38f8b30e4a2ada$export$b3890eb0ae9dca99;
var $3e38f8b30e4a2ada$export$502457920280e6be;
var $3e38f8b30e4a2ada$export$c78a37762a8d58e1;
var $3e38f8b30e4a2ada$export$dc54d992c10e8a18;
var $3e38f8b30e4a2ada$export$83d89fbfd8236492;
'use strict';

var $2NacA = parcelRequire("2NacA");

var $9A2Xm = parcelRequire("9A2Xm");
function $3e38f8b30e4a2ada$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3e38f8b30e4a2ada$var$da = new Set, $3e38f8b30e4a2ada$var$ea = {};
function $3e38f8b30e4a2ada$var$fa(a, b) {
    $3e38f8b30e4a2ada$var$ha(a, b);
    $3e38f8b30e4a2ada$var$ha(a + "Capture", b);
}
function $3e38f8b30e4a2ada$var$ha(a, b) {
    $3e38f8b30e4a2ada$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3e38f8b30e4a2ada$var$da.add(b[a]);
}
var $3e38f8b30e4a2ada$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3e38f8b30e4a2ada$var$ja = Object.prototype.hasOwnProperty, $3e38f8b30e4a2ada$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3e38f8b30e4a2ada$var$la = {}, $3e38f8b30e4a2ada$var$ma = {};
function $3e38f8b30e4a2ada$var$oa(a) {
    if ($3e38f8b30e4a2ada$var$ja.call($3e38f8b30e4a2ada$var$ma, a)) return !0;
    if ($3e38f8b30e4a2ada$var$ja.call($3e38f8b30e4a2ada$var$la, a)) return !1;
    if ($3e38f8b30e4a2ada$var$ka.test(a)) return $3e38f8b30e4a2ada$var$ma[a] = !0;
    $3e38f8b30e4a2ada$var$la[a] = !0;
    return !1;
}
function $3e38f8b30e4a2ada$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3e38f8b30e4a2ada$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3e38f8b30e4a2ada$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3e38f8b30e4a2ada$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3e38f8b30e4a2ada$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3e38f8b30e4a2ada$var$z[b] = new $3e38f8b30e4a2ada$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3e38f8b30e4a2ada$var$ra = /[\-:]([a-z])/g;
function $3e38f8b30e4a2ada$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3e38f8b30e4a2ada$var$ra, $3e38f8b30e4a2ada$var$sa);
    $3e38f8b30e4a2ada$var$z[b] = new $3e38f8b30e4a2ada$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3e38f8b30e4a2ada$var$ra, $3e38f8b30e4a2ada$var$sa);
    $3e38f8b30e4a2ada$var$z[b] = new $3e38f8b30e4a2ada$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3e38f8b30e4a2ada$var$ra, $3e38f8b30e4a2ada$var$sa);
    $3e38f8b30e4a2ada$var$z[b] = new $3e38f8b30e4a2ada$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3e38f8b30e4a2ada$var$z.xlinkHref = new $3e38f8b30e4a2ada$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3e38f8b30e4a2ada$var$z[a] = new $3e38f8b30e4a2ada$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3e38f8b30e4a2ada$var$ta(a, b, c, d) {
    var e = $3e38f8b30e4a2ada$var$z.hasOwnProperty(b) ? $3e38f8b30e4a2ada$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3e38f8b30e4a2ada$var$qa(b, c, e, d) && (c = null), d || null === e ? $3e38f8b30e4a2ada$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3e38f8b30e4a2ada$var$ua = $2NacA.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3e38f8b30e4a2ada$var$va = Symbol.for("react.element"), $3e38f8b30e4a2ada$var$wa = Symbol.for("react.portal"), $3e38f8b30e4a2ada$var$ya = Symbol.for("react.fragment"), $3e38f8b30e4a2ada$var$za = Symbol.for("react.strict_mode"), $3e38f8b30e4a2ada$var$Aa = Symbol.for("react.profiler"), $3e38f8b30e4a2ada$var$Ba = Symbol.for("react.provider"), $3e38f8b30e4a2ada$var$Ca = Symbol.for("react.context"), $3e38f8b30e4a2ada$var$Da = Symbol.for("react.forward_ref"), $3e38f8b30e4a2ada$var$Ea = Symbol.for("react.suspense"), $3e38f8b30e4a2ada$var$Fa = Symbol.for("react.suspense_list"), $3e38f8b30e4a2ada$var$Ga = Symbol.for("react.memo"), $3e38f8b30e4a2ada$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3e38f8b30e4a2ada$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3e38f8b30e4a2ada$var$Ja = Symbol.iterator;
function $3e38f8b30e4a2ada$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3e38f8b30e4a2ada$var$Ja && a[$3e38f8b30e4a2ada$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3e38f8b30e4a2ada$var$A = Object.assign, $3e38f8b30e4a2ada$var$La;
function $3e38f8b30e4a2ada$var$Ma(a) {
    if (void 0 === $3e38f8b30e4a2ada$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3e38f8b30e4a2ada$var$La = b && b[1] || "";
    }
    return "\n" + $3e38f8b30e4a2ada$var$La + a;
}
var $3e38f8b30e4a2ada$var$Na = !1;
function $3e38f8b30e4a2ada$var$Oa(a, b) {
    if (!a || $3e38f8b30e4a2ada$var$Na) return "";
    $3e38f8b30e4a2ada$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3e38f8b30e4a2ada$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3e38f8b30e4a2ada$var$Ma(a) : "";
}
function $3e38f8b30e4a2ada$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3e38f8b30e4a2ada$var$Ma(a.type);
        case 16:
            return $3e38f8b30e4a2ada$var$Ma("Lazy");
        case 13:
            return $3e38f8b30e4a2ada$var$Ma("Suspense");
        case 19:
            return $3e38f8b30e4a2ada$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3e38f8b30e4a2ada$var$Oa(a.type, !1), a;
        case 11:
            return a = $3e38f8b30e4a2ada$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3e38f8b30e4a2ada$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3e38f8b30e4a2ada$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3e38f8b30e4a2ada$var$ya:
            return "Fragment";
        case $3e38f8b30e4a2ada$var$wa:
            return "Portal";
        case $3e38f8b30e4a2ada$var$Aa:
            return "Profiler";
        case $3e38f8b30e4a2ada$var$za:
            return "StrictMode";
        case $3e38f8b30e4a2ada$var$Ea:
            return "Suspense";
        case $3e38f8b30e4a2ada$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3e38f8b30e4a2ada$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3e38f8b30e4a2ada$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3e38f8b30e4a2ada$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3e38f8b30e4a2ada$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3e38f8b30e4a2ada$var$Qa(a.type) || "Memo";
        case $3e38f8b30e4a2ada$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3e38f8b30e4a2ada$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3e38f8b30e4a2ada$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3e38f8b30e4a2ada$var$Qa(b);
        case 8:
            return b === $3e38f8b30e4a2ada$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3e38f8b30e4a2ada$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3e38f8b30e4a2ada$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3e38f8b30e4a2ada$var$Ua(a) {
    var b = $3e38f8b30e4a2ada$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3e38f8b30e4a2ada$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3e38f8b30e4a2ada$var$Ua(a));
}
function $3e38f8b30e4a2ada$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3e38f8b30e4a2ada$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3e38f8b30e4a2ada$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3e38f8b30e4a2ada$var$Ya(a, b) {
    var c = b.checked;
    return $3e38f8b30e4a2ada$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3e38f8b30e4a2ada$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3e38f8b30e4a2ada$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3e38f8b30e4a2ada$var$ab(a, b) {
    b = b.checked;
    null != b && $3e38f8b30e4a2ada$var$ta(a, "checked", b, !1);
}
function $3e38f8b30e4a2ada$var$bb(a, b) {
    $3e38f8b30e4a2ada$var$ab(a, b);
    var c = $3e38f8b30e4a2ada$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3e38f8b30e4a2ada$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3e38f8b30e4a2ada$var$cb(a, b.type, $3e38f8b30e4a2ada$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3e38f8b30e4a2ada$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3e38f8b30e4a2ada$var$cb(a, b, c) {
    if ("number" !== b || $3e38f8b30e4a2ada$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3e38f8b30e4a2ada$var$eb = Array.isArray;
function $3e38f8b30e4a2ada$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3e38f8b30e4a2ada$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3e38f8b30e4a2ada$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3e38f8b30e4a2ada$var$p(91));
    return $3e38f8b30e4a2ada$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3e38f8b30e4a2ada$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3e38f8b30e4a2ada$var$p(92));
            if ($3e38f8b30e4a2ada$var$eb(c)) {
                if (1 < c.length) throw Error($3e38f8b30e4a2ada$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3e38f8b30e4a2ada$var$Sa(c)
    };
}
function $3e38f8b30e4a2ada$var$ib(a, b) {
    var c = $3e38f8b30e4a2ada$var$Sa(b.value), d = $3e38f8b30e4a2ada$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3e38f8b30e4a2ada$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3e38f8b30e4a2ada$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3e38f8b30e4a2ada$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3e38f8b30e4a2ada$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3e38f8b30e4a2ada$var$mb, $3e38f8b30e4a2ada$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3e38f8b30e4a2ada$var$mb = $3e38f8b30e4a2ada$var$mb || document.createElement("div");
        $3e38f8b30e4a2ada$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3e38f8b30e4a2ada$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3e38f8b30e4a2ada$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3e38f8b30e4a2ada$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3e38f8b30e4a2ada$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3e38f8b30e4a2ada$var$pb).forEach(function(a) {
    $3e38f8b30e4a2ada$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3e38f8b30e4a2ada$var$pb[b] = $3e38f8b30e4a2ada$var$pb[a];
    });
});
function $3e38f8b30e4a2ada$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3e38f8b30e4a2ada$var$pb.hasOwnProperty(a) && $3e38f8b30e4a2ada$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3e38f8b30e4a2ada$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3e38f8b30e4a2ada$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3e38f8b30e4a2ada$var$tb = $3e38f8b30e4a2ada$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3e38f8b30e4a2ada$var$ub(a, b) {
    if (b) {
        if ($3e38f8b30e4a2ada$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3e38f8b30e4a2ada$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3e38f8b30e4a2ada$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3e38f8b30e4a2ada$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3e38f8b30e4a2ada$var$p(62));
    }
}
function $3e38f8b30e4a2ada$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3e38f8b30e4a2ada$var$wb = null;
function $3e38f8b30e4a2ada$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3e38f8b30e4a2ada$var$yb = null, $3e38f8b30e4a2ada$var$zb = null, $3e38f8b30e4a2ada$var$Ab = null;
function $3e38f8b30e4a2ada$var$Bb(a) {
    if (a = $3e38f8b30e4a2ada$var$Cb(a)) {
        if ("function" !== typeof $3e38f8b30e4a2ada$var$yb) throw Error($3e38f8b30e4a2ada$var$p(280));
        var b = a.stateNode;
        b && (b = $3e38f8b30e4a2ada$var$Db(b), $3e38f8b30e4a2ada$var$yb(a.stateNode, a.type, b));
    }
}
function $3e38f8b30e4a2ada$var$Eb(a) {
    $3e38f8b30e4a2ada$var$zb ? $3e38f8b30e4a2ada$var$Ab ? $3e38f8b30e4a2ada$var$Ab.push(a) : $3e38f8b30e4a2ada$var$Ab = [
        a
    ] : $3e38f8b30e4a2ada$var$zb = a;
}
function $3e38f8b30e4a2ada$var$Fb() {
    if ($3e38f8b30e4a2ada$var$zb) {
        var a = $3e38f8b30e4a2ada$var$zb, b = $3e38f8b30e4a2ada$var$Ab;
        $3e38f8b30e4a2ada$var$Ab = $3e38f8b30e4a2ada$var$zb = null;
        $3e38f8b30e4a2ada$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3e38f8b30e4a2ada$var$Bb(b[a]);
    }
}
function $3e38f8b30e4a2ada$var$Gb(a, b) {
    return a(b);
}
function $3e38f8b30e4a2ada$var$Hb() {}
var $3e38f8b30e4a2ada$var$Ib = !1;
function $3e38f8b30e4a2ada$var$Jb(a, b, c) {
    if ($3e38f8b30e4a2ada$var$Ib) return a(b, c);
    $3e38f8b30e4a2ada$var$Ib = !0;
    try {
        return $3e38f8b30e4a2ada$var$Gb(a, b, c);
    } finally{
        if ($3e38f8b30e4a2ada$var$Ib = !1, null !== $3e38f8b30e4a2ada$var$zb || null !== $3e38f8b30e4a2ada$var$Ab) $3e38f8b30e4a2ada$var$Hb(), $3e38f8b30e4a2ada$var$Fb();
    }
}
function $3e38f8b30e4a2ada$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3e38f8b30e4a2ada$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3e38f8b30e4a2ada$var$p(231, b, typeof c));
    return c;
}
var $3e38f8b30e4a2ada$var$Lb = !1;
if ($3e38f8b30e4a2ada$var$ia) try {
    var $3e38f8b30e4a2ada$var$Mb = {};
    Object.defineProperty($3e38f8b30e4a2ada$var$Mb, "passive", {
        get: function() {
            $3e38f8b30e4a2ada$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3e38f8b30e4a2ada$var$Mb, $3e38f8b30e4a2ada$var$Mb);
    window.removeEventListener("test", $3e38f8b30e4a2ada$var$Mb, $3e38f8b30e4a2ada$var$Mb);
} catch (a) {
    $3e38f8b30e4a2ada$var$Lb = !1;
}
function $3e38f8b30e4a2ada$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3e38f8b30e4a2ada$var$Ob = !1, $3e38f8b30e4a2ada$var$Pb = null, $3e38f8b30e4a2ada$var$Qb = !1, $3e38f8b30e4a2ada$var$Rb = null, $3e38f8b30e4a2ada$var$Sb = {
    onError: function(a) {
        $3e38f8b30e4a2ada$var$Ob = !0;
        $3e38f8b30e4a2ada$var$Pb = a;
    }
};
function $3e38f8b30e4a2ada$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3e38f8b30e4a2ada$var$Ob = !1;
    $3e38f8b30e4a2ada$var$Pb = null;
    $3e38f8b30e4a2ada$var$Nb.apply($3e38f8b30e4a2ada$var$Sb, arguments);
}
function $3e38f8b30e4a2ada$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3e38f8b30e4a2ada$var$Tb.apply(this, arguments);
    if ($3e38f8b30e4a2ada$var$Ob) {
        if ($3e38f8b30e4a2ada$var$Ob) {
            var l = $3e38f8b30e4a2ada$var$Pb;
            $3e38f8b30e4a2ada$var$Ob = !1;
            $3e38f8b30e4a2ada$var$Pb = null;
        } else throw Error($3e38f8b30e4a2ada$var$p(198));
        $3e38f8b30e4a2ada$var$Qb || ($3e38f8b30e4a2ada$var$Qb = !0, $3e38f8b30e4a2ada$var$Rb = l);
    }
}
function $3e38f8b30e4a2ada$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3e38f8b30e4a2ada$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3e38f8b30e4a2ada$var$Xb(a) {
    if ($3e38f8b30e4a2ada$var$Vb(a) !== a) throw Error($3e38f8b30e4a2ada$var$p(188));
}
function $3e38f8b30e4a2ada$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3e38f8b30e4a2ada$var$Vb(a);
        if (null === b) throw Error($3e38f8b30e4a2ada$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3e38f8b30e4a2ada$var$Xb(e), a;
                if (f === d) return $3e38f8b30e4a2ada$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3e38f8b30e4a2ada$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3e38f8b30e4a2ada$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3e38f8b30e4a2ada$var$p(190));
    }
    if (3 !== c.tag) throw Error($3e38f8b30e4a2ada$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3e38f8b30e4a2ada$var$Zb(a) {
    a = $3e38f8b30e4a2ada$var$Yb(a);
    return null !== a ? $3e38f8b30e4a2ada$var$$b(a) : null;
}
function $3e38f8b30e4a2ada$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3e38f8b30e4a2ada$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3e38f8b30e4a2ada$var$ac = $9A2Xm.unstable_scheduleCallback, $3e38f8b30e4a2ada$var$bc = $9A2Xm.unstable_cancelCallback, $3e38f8b30e4a2ada$var$cc = $9A2Xm.unstable_shouldYield, $3e38f8b30e4a2ada$var$dc = $9A2Xm.unstable_requestPaint, $3e38f8b30e4a2ada$var$B = $9A2Xm.unstable_now, $3e38f8b30e4a2ada$var$ec = $9A2Xm.unstable_getCurrentPriorityLevel, $3e38f8b30e4a2ada$var$fc = $9A2Xm.unstable_ImmediatePriority, $3e38f8b30e4a2ada$var$gc = $9A2Xm.unstable_UserBlockingPriority, $3e38f8b30e4a2ada$var$hc = $9A2Xm.unstable_NormalPriority, $3e38f8b30e4a2ada$var$ic = $9A2Xm.unstable_LowPriority, $3e38f8b30e4a2ada$var$jc = $9A2Xm.unstable_IdlePriority, $3e38f8b30e4a2ada$var$kc = null, $3e38f8b30e4a2ada$var$lc = null;
function $3e38f8b30e4a2ada$var$mc(a) {
    if ($3e38f8b30e4a2ada$var$lc && "function" === typeof $3e38f8b30e4a2ada$var$lc.onCommitFiberRoot) try {
        $3e38f8b30e4a2ada$var$lc.onCommitFiberRoot($3e38f8b30e4a2ada$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3e38f8b30e4a2ada$var$oc = Math.clz32 ? Math.clz32 : $3e38f8b30e4a2ada$var$nc, $3e38f8b30e4a2ada$var$pc = Math.log, $3e38f8b30e4a2ada$var$qc = Math.LN2;
function $3e38f8b30e4a2ada$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3e38f8b30e4a2ada$var$pc(a) / $3e38f8b30e4a2ada$var$qc | 0) | 0;
}
var $3e38f8b30e4a2ada$var$rc = 64, $3e38f8b30e4a2ada$var$sc = 4194304;
function $3e38f8b30e4a2ada$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3e38f8b30e4a2ada$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3e38f8b30e4a2ada$var$tc(h) : (f &= g, 0 !== f && (d = $3e38f8b30e4a2ada$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3e38f8b30e4a2ada$var$tc(g) : 0 !== f && (d = $3e38f8b30e4a2ada$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3e38f8b30e4a2ada$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3e38f8b30e4a2ada$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3e38f8b30e4a2ada$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3e38f8b30e4a2ada$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3e38f8b30e4a2ada$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3e38f8b30e4a2ada$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3e38f8b30e4a2ada$var$yc() {
    var a = $3e38f8b30e4a2ada$var$rc;
    $3e38f8b30e4a2ada$var$rc <<= 1;
    0 === ($3e38f8b30e4a2ada$var$rc & 4194240) && ($3e38f8b30e4a2ada$var$rc = 64);
    return a;
}
function $3e38f8b30e4a2ada$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3e38f8b30e4a2ada$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3e38f8b30e4a2ada$var$oc(b);
    a[b] = c;
}
function $3e38f8b30e4a2ada$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3e38f8b30e4a2ada$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3e38f8b30e4a2ada$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3e38f8b30e4a2ada$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3e38f8b30e4a2ada$var$C = 0;
function $3e38f8b30e4a2ada$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3e38f8b30e4a2ada$var$Ec, $3e38f8b30e4a2ada$var$Fc, $3e38f8b30e4a2ada$var$Gc, $3e38f8b30e4a2ada$var$Hc, $3e38f8b30e4a2ada$var$Ic, $3e38f8b30e4a2ada$var$Jc = !1, $3e38f8b30e4a2ada$var$Kc = [], $3e38f8b30e4a2ada$var$Lc = null, $3e38f8b30e4a2ada$var$Mc = null, $3e38f8b30e4a2ada$var$Nc = null, $3e38f8b30e4a2ada$var$Oc = new Map, $3e38f8b30e4a2ada$var$Pc = new Map, $3e38f8b30e4a2ada$var$Qc = [], $3e38f8b30e4a2ada$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3e38f8b30e4a2ada$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3e38f8b30e4a2ada$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3e38f8b30e4a2ada$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3e38f8b30e4a2ada$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3e38f8b30e4a2ada$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3e38f8b30e4a2ada$var$Pc.delete(b.pointerId);
    }
}
function $3e38f8b30e4a2ada$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3e38f8b30e4a2ada$var$Cb(b), null !== b && $3e38f8b30e4a2ada$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3e38f8b30e4a2ada$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3e38f8b30e4a2ada$var$Lc = $3e38f8b30e4a2ada$var$Tc($3e38f8b30e4a2ada$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3e38f8b30e4a2ada$var$Mc = $3e38f8b30e4a2ada$var$Tc($3e38f8b30e4a2ada$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3e38f8b30e4a2ada$var$Nc = $3e38f8b30e4a2ada$var$Tc($3e38f8b30e4a2ada$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3e38f8b30e4a2ada$var$Oc.set(f, $3e38f8b30e4a2ada$var$Tc($3e38f8b30e4a2ada$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3e38f8b30e4a2ada$var$Pc.set(f, $3e38f8b30e4a2ada$var$Tc($3e38f8b30e4a2ada$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3e38f8b30e4a2ada$var$Vc(a) {
    var b = $3e38f8b30e4a2ada$var$Wc(a.target);
    if (null !== b) {
        var c = $3e38f8b30e4a2ada$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3e38f8b30e4a2ada$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3e38f8b30e4a2ada$var$Ic(a.priority, function() {
                        $3e38f8b30e4a2ada$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3e38f8b30e4a2ada$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3e38f8b30e4a2ada$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3e38f8b30e4a2ada$var$wb = d;
            c.target.dispatchEvent(d);
            $3e38f8b30e4a2ada$var$wb = null;
        } else return b = $3e38f8b30e4a2ada$var$Cb(c), null !== b && $3e38f8b30e4a2ada$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3e38f8b30e4a2ada$var$Zc(a, b, c) {
    $3e38f8b30e4a2ada$var$Xc(a) && c.delete(b);
}
function $3e38f8b30e4a2ada$var$$c() {
    $3e38f8b30e4a2ada$var$Jc = !1;
    null !== $3e38f8b30e4a2ada$var$Lc && $3e38f8b30e4a2ada$var$Xc($3e38f8b30e4a2ada$var$Lc) && ($3e38f8b30e4a2ada$var$Lc = null);
    null !== $3e38f8b30e4a2ada$var$Mc && $3e38f8b30e4a2ada$var$Xc($3e38f8b30e4a2ada$var$Mc) && ($3e38f8b30e4a2ada$var$Mc = null);
    null !== $3e38f8b30e4a2ada$var$Nc && $3e38f8b30e4a2ada$var$Xc($3e38f8b30e4a2ada$var$Nc) && ($3e38f8b30e4a2ada$var$Nc = null);
    $3e38f8b30e4a2ada$var$Oc.forEach($3e38f8b30e4a2ada$var$Zc);
    $3e38f8b30e4a2ada$var$Pc.forEach($3e38f8b30e4a2ada$var$Zc);
}
function $3e38f8b30e4a2ada$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3e38f8b30e4a2ada$var$Jc || ($3e38f8b30e4a2ada$var$Jc = !0, $9A2Xm.unstable_scheduleCallback($9A2Xm.unstable_NormalPriority, $3e38f8b30e4a2ada$var$$c)));
}
function $3e38f8b30e4a2ada$var$bd(a) {
    function b(b) {
        return $3e38f8b30e4a2ada$var$ad(b, a);
    }
    if (0 < $3e38f8b30e4a2ada$var$Kc.length) {
        $3e38f8b30e4a2ada$var$ad($3e38f8b30e4a2ada$var$Kc[0], a);
        for(var c = 1; c < $3e38f8b30e4a2ada$var$Kc.length; c++){
            var d = $3e38f8b30e4a2ada$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3e38f8b30e4a2ada$var$Lc && $3e38f8b30e4a2ada$var$ad($3e38f8b30e4a2ada$var$Lc, a);
    null !== $3e38f8b30e4a2ada$var$Mc && $3e38f8b30e4a2ada$var$ad($3e38f8b30e4a2ada$var$Mc, a);
    null !== $3e38f8b30e4a2ada$var$Nc && $3e38f8b30e4a2ada$var$ad($3e38f8b30e4a2ada$var$Nc, a);
    $3e38f8b30e4a2ada$var$Oc.forEach(b);
    $3e38f8b30e4a2ada$var$Pc.forEach(b);
    for(c = 0; c < $3e38f8b30e4a2ada$var$Qc.length; c++)d = $3e38f8b30e4a2ada$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3e38f8b30e4a2ada$var$Qc.length && (c = $3e38f8b30e4a2ada$var$Qc[0], null === c.blockedOn);)$3e38f8b30e4a2ada$var$Vc(c), null === c.blockedOn && $3e38f8b30e4a2ada$var$Qc.shift();
}
var $3e38f8b30e4a2ada$var$cd = $3e38f8b30e4a2ada$var$ua.ReactCurrentBatchConfig, $3e38f8b30e4a2ada$var$dd = !0;
function $3e38f8b30e4a2ada$var$ed(a, b, c, d) {
    var e = $3e38f8b30e4a2ada$var$C, f = $3e38f8b30e4a2ada$var$cd.transition;
    $3e38f8b30e4a2ada$var$cd.transition = null;
    try {
        $3e38f8b30e4a2ada$var$C = 1, $3e38f8b30e4a2ada$var$fd(a, b, c, d);
    } finally{
        $3e38f8b30e4a2ada$var$C = e, $3e38f8b30e4a2ada$var$cd.transition = f;
    }
}
function $3e38f8b30e4a2ada$var$gd(a, b, c, d) {
    var e = $3e38f8b30e4a2ada$var$C, f = $3e38f8b30e4a2ada$var$cd.transition;
    $3e38f8b30e4a2ada$var$cd.transition = null;
    try {
        $3e38f8b30e4a2ada$var$C = 4, $3e38f8b30e4a2ada$var$fd(a, b, c, d);
    } finally{
        $3e38f8b30e4a2ada$var$C = e, $3e38f8b30e4a2ada$var$cd.transition = f;
    }
}
function $3e38f8b30e4a2ada$var$fd(a, b, c, d) {
    if ($3e38f8b30e4a2ada$var$dd) {
        var e = $3e38f8b30e4a2ada$var$Yc(a, b, c, d);
        if (null === e) $3e38f8b30e4a2ada$var$hd(a, b, d, $3e38f8b30e4a2ada$var$id, c), $3e38f8b30e4a2ada$var$Sc(a, d);
        else if ($3e38f8b30e4a2ada$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3e38f8b30e4a2ada$var$Sc(a, d), b & 4 && -1 < $3e38f8b30e4a2ada$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3e38f8b30e4a2ada$var$Cb(e);
                null !== f && $3e38f8b30e4a2ada$var$Ec(f);
                f = $3e38f8b30e4a2ada$var$Yc(a, b, c, d);
                null === f && $3e38f8b30e4a2ada$var$hd(a, b, d, $3e38f8b30e4a2ada$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3e38f8b30e4a2ada$var$hd(a, b, d, null, c);
    }
}
var $3e38f8b30e4a2ada$var$id = null;
function $3e38f8b30e4a2ada$var$Yc(a, b, c, d) {
    $3e38f8b30e4a2ada$var$id = null;
    a = $3e38f8b30e4a2ada$var$xb(d);
    a = $3e38f8b30e4a2ada$var$Wc(a);
    if (null !== a) {
        if (b = $3e38f8b30e4a2ada$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3e38f8b30e4a2ada$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3e38f8b30e4a2ada$var$id = a;
    return null;
}
function $3e38f8b30e4a2ada$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3e38f8b30e4a2ada$var$ec()){
                case $3e38f8b30e4a2ada$var$fc:
                    return 1;
                case $3e38f8b30e4a2ada$var$gc:
                    return 4;
                case $3e38f8b30e4a2ada$var$hc:
                case $3e38f8b30e4a2ada$var$ic:
                    return 16;
                case $3e38f8b30e4a2ada$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3e38f8b30e4a2ada$var$kd = null, $3e38f8b30e4a2ada$var$ld = null, $3e38f8b30e4a2ada$var$md = null;
function $3e38f8b30e4a2ada$var$nd() {
    if ($3e38f8b30e4a2ada$var$md) return $3e38f8b30e4a2ada$var$md;
    var a, b = $3e38f8b30e4a2ada$var$ld, c = b.length, d, e = "value" in $3e38f8b30e4a2ada$var$kd ? $3e38f8b30e4a2ada$var$kd.value : $3e38f8b30e4a2ada$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3e38f8b30e4a2ada$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3e38f8b30e4a2ada$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3e38f8b30e4a2ada$var$pd() {
    return !0;
}
function $3e38f8b30e4a2ada$var$qd() {
    return !1;
}
function $3e38f8b30e4a2ada$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3e38f8b30e4a2ada$var$pd : $3e38f8b30e4a2ada$var$qd;
        this.isPropagationStopped = $3e38f8b30e4a2ada$var$qd;
        return this;
    }
    $3e38f8b30e4a2ada$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3e38f8b30e4a2ada$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3e38f8b30e4a2ada$var$pd);
        },
        persist: function() {},
        isPersistent: $3e38f8b30e4a2ada$var$pd
    });
    return b;
}
var $3e38f8b30e4a2ada$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3e38f8b30e4a2ada$var$td = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$sd), $3e38f8b30e4a2ada$var$ud = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$sd, {
    view: 0,
    detail: 0
}), $3e38f8b30e4a2ada$var$vd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$ud), $3e38f8b30e4a2ada$var$wd, $3e38f8b30e4a2ada$var$xd, $3e38f8b30e4a2ada$var$yd, $3e38f8b30e4a2ada$var$Ad = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3e38f8b30e4a2ada$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3e38f8b30e4a2ada$var$yd && ($3e38f8b30e4a2ada$var$yd && "mousemove" === a.type ? ($3e38f8b30e4a2ada$var$wd = a.screenX - $3e38f8b30e4a2ada$var$yd.screenX, $3e38f8b30e4a2ada$var$xd = a.screenY - $3e38f8b30e4a2ada$var$yd.screenY) : $3e38f8b30e4a2ada$var$xd = $3e38f8b30e4a2ada$var$wd = 0, $3e38f8b30e4a2ada$var$yd = a);
        return $3e38f8b30e4a2ada$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3e38f8b30e4a2ada$var$xd;
    }
}), $3e38f8b30e4a2ada$var$Bd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Ad), $3e38f8b30e4a2ada$var$Cd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$Ad, {
    dataTransfer: 0
}), $3e38f8b30e4a2ada$var$Dd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Cd), $3e38f8b30e4a2ada$var$Ed = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$ud, {
    relatedTarget: 0
}), $3e38f8b30e4a2ada$var$Fd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Ed), $3e38f8b30e4a2ada$var$Gd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3e38f8b30e4a2ada$var$Hd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Gd), $3e38f8b30e4a2ada$var$Id = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3e38f8b30e4a2ada$var$Jd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Id), $3e38f8b30e4a2ada$var$Kd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$sd, {
    data: 0
}), $3e38f8b30e4a2ada$var$Ld = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Kd), $3e38f8b30e4a2ada$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3e38f8b30e4a2ada$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3e38f8b30e4a2ada$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3e38f8b30e4a2ada$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3e38f8b30e4a2ada$var$Od[a]) ? !!b[a] : !1;
}
function $3e38f8b30e4a2ada$var$zd() {
    return $3e38f8b30e4a2ada$var$Pd;
}
var $3e38f8b30e4a2ada$var$Qd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $3e38f8b30e4a2ada$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3e38f8b30e4a2ada$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3e38f8b30e4a2ada$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3e38f8b30e4a2ada$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $3e38f8b30e4a2ada$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3e38f8b30e4a2ada$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3e38f8b30e4a2ada$var$Rd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Qd), $3e38f8b30e4a2ada$var$Sd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3e38f8b30e4a2ada$var$Td = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Sd), $3e38f8b30e4a2ada$var$Ud = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3e38f8b30e4a2ada$var$zd
}), $3e38f8b30e4a2ada$var$Vd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Ud), $3e38f8b30e4a2ada$var$Wd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3e38f8b30e4a2ada$var$Xd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Wd), $3e38f8b30e4a2ada$var$Yd = $3e38f8b30e4a2ada$var$A({}, $3e38f8b30e4a2ada$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3e38f8b30e4a2ada$var$Zd = $3e38f8b30e4a2ada$var$rd($3e38f8b30e4a2ada$var$Yd), $3e38f8b30e4a2ada$var$$d = [
    9,
    13,
    27,
    32
], $3e38f8b30e4a2ada$var$ae = $3e38f8b30e4a2ada$var$ia && "CompositionEvent" in window, $3e38f8b30e4a2ada$var$be = null;
$3e38f8b30e4a2ada$var$ia && "documentMode" in document && ($3e38f8b30e4a2ada$var$be = document.documentMode);
var $3e38f8b30e4a2ada$var$ce = $3e38f8b30e4a2ada$var$ia && "TextEvent" in window && !$3e38f8b30e4a2ada$var$be, $3e38f8b30e4a2ada$var$de = $3e38f8b30e4a2ada$var$ia && (!$3e38f8b30e4a2ada$var$ae || $3e38f8b30e4a2ada$var$be && 8 < $3e38f8b30e4a2ada$var$be && 11 >= $3e38f8b30e4a2ada$var$be), $3e38f8b30e4a2ada$var$ee = String.fromCharCode(32), $3e38f8b30e4a2ada$var$fe = !1;
function $3e38f8b30e4a2ada$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3e38f8b30e4a2ada$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3e38f8b30e4a2ada$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3e38f8b30e4a2ada$var$ie = !1;
function $3e38f8b30e4a2ada$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3e38f8b30e4a2ada$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3e38f8b30e4a2ada$var$fe = !0;
            return $3e38f8b30e4a2ada$var$ee;
        case "textInput":
            return a = b.data, a === $3e38f8b30e4a2ada$var$ee && $3e38f8b30e4a2ada$var$fe ? null : a;
        default:
            return null;
    }
}
function $3e38f8b30e4a2ada$var$ke(a, b) {
    if ($3e38f8b30e4a2ada$var$ie) return "compositionend" === a || !$3e38f8b30e4a2ada$var$ae && $3e38f8b30e4a2ada$var$ge(a, b) ? (a = $3e38f8b30e4a2ada$var$nd(), $3e38f8b30e4a2ada$var$md = $3e38f8b30e4a2ada$var$ld = $3e38f8b30e4a2ada$var$kd = null, $3e38f8b30e4a2ada$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3e38f8b30e4a2ada$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3e38f8b30e4a2ada$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3e38f8b30e4a2ada$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3e38f8b30e4a2ada$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3e38f8b30e4a2ada$var$ne(a, b, c, d) {
    $3e38f8b30e4a2ada$var$Eb(d);
    b = $3e38f8b30e4a2ada$var$oe(b, "onChange");
    0 < b.length && (c = new $3e38f8b30e4a2ada$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3e38f8b30e4a2ada$var$pe = null, $3e38f8b30e4a2ada$var$qe = null;
function $3e38f8b30e4a2ada$var$re(a) {
    $3e38f8b30e4a2ada$var$se(a, 0);
}
function $3e38f8b30e4a2ada$var$te(a) {
    var b = $3e38f8b30e4a2ada$var$ue(a);
    if ($3e38f8b30e4a2ada$var$Wa(b)) return a;
}
function $3e38f8b30e4a2ada$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3e38f8b30e4a2ada$var$we = !1;
if ($3e38f8b30e4a2ada$var$ia) {
    var $3e38f8b30e4a2ada$var$xe;
    if ($3e38f8b30e4a2ada$var$ia) {
        var $3e38f8b30e4a2ada$var$ye = "oninput" in document;
        if (!$3e38f8b30e4a2ada$var$ye) {
            var $3e38f8b30e4a2ada$var$ze = document.createElement("div");
            $3e38f8b30e4a2ada$var$ze.setAttribute("oninput", "return;");
            $3e38f8b30e4a2ada$var$ye = "function" === typeof $3e38f8b30e4a2ada$var$ze.oninput;
        }
        $3e38f8b30e4a2ada$var$xe = $3e38f8b30e4a2ada$var$ye;
    } else $3e38f8b30e4a2ada$var$xe = !1;
    $3e38f8b30e4a2ada$var$we = $3e38f8b30e4a2ada$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3e38f8b30e4a2ada$var$Ae() {
    $3e38f8b30e4a2ada$var$pe && ($3e38f8b30e4a2ada$var$pe.detachEvent("onpropertychange", $3e38f8b30e4a2ada$var$Be), $3e38f8b30e4a2ada$var$qe = $3e38f8b30e4a2ada$var$pe = null);
}
function $3e38f8b30e4a2ada$var$Be(a) {
    if ("value" === a.propertyName && $3e38f8b30e4a2ada$var$te($3e38f8b30e4a2ada$var$qe)) {
        var b = [];
        $3e38f8b30e4a2ada$var$ne(b, $3e38f8b30e4a2ada$var$qe, a, $3e38f8b30e4a2ada$var$xb(a));
        $3e38f8b30e4a2ada$var$Jb($3e38f8b30e4a2ada$var$re, b);
    }
}
function $3e38f8b30e4a2ada$var$Ce(a, b, c) {
    "focusin" === a ? ($3e38f8b30e4a2ada$var$Ae(), $3e38f8b30e4a2ada$var$pe = b, $3e38f8b30e4a2ada$var$qe = c, $3e38f8b30e4a2ada$var$pe.attachEvent("onpropertychange", $3e38f8b30e4a2ada$var$Be)) : "focusout" === a && $3e38f8b30e4a2ada$var$Ae();
}
function $3e38f8b30e4a2ada$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3e38f8b30e4a2ada$var$te($3e38f8b30e4a2ada$var$qe);
}
function $3e38f8b30e4a2ada$var$Ee(a, b) {
    if ("click" === a) return $3e38f8b30e4a2ada$var$te(b);
}
function $3e38f8b30e4a2ada$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3e38f8b30e4a2ada$var$te(b);
}
function $3e38f8b30e4a2ada$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3e38f8b30e4a2ada$var$He = "function" === typeof Object.is ? Object.is : $3e38f8b30e4a2ada$var$Ge;
function $3e38f8b30e4a2ada$var$Ie(a, b) {
    if ($3e38f8b30e4a2ada$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3e38f8b30e4a2ada$var$ja.call(b, e) || !$3e38f8b30e4a2ada$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3e38f8b30e4a2ada$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3e38f8b30e4a2ada$var$Ke(a, b) {
    var c = $3e38f8b30e4a2ada$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3e38f8b30e4a2ada$var$Je(c);
    }
}
function $3e38f8b30e4a2ada$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3e38f8b30e4a2ada$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3e38f8b30e4a2ada$var$Me() {
    for(var a = window, b = $3e38f8b30e4a2ada$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3e38f8b30e4a2ada$var$Xa(a.document);
    }
    return b;
}
function $3e38f8b30e4a2ada$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3e38f8b30e4a2ada$var$Oe(a) {
    var b = $3e38f8b30e4a2ada$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3e38f8b30e4a2ada$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3e38f8b30e4a2ada$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3e38f8b30e4a2ada$var$Ke(c, f);
                var g = $3e38f8b30e4a2ada$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3e38f8b30e4a2ada$var$Pe = $3e38f8b30e4a2ada$var$ia && "documentMode" in document && 11 >= document.documentMode, $3e38f8b30e4a2ada$var$Qe = null, $3e38f8b30e4a2ada$var$Re = null, $3e38f8b30e4a2ada$var$Se = null, $3e38f8b30e4a2ada$var$Te = !1;
function $3e38f8b30e4a2ada$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3e38f8b30e4a2ada$var$Te || null == $3e38f8b30e4a2ada$var$Qe || $3e38f8b30e4a2ada$var$Qe !== $3e38f8b30e4a2ada$var$Xa(d) || (d = $3e38f8b30e4a2ada$var$Qe, "selectionStart" in d && $3e38f8b30e4a2ada$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3e38f8b30e4a2ada$var$Se && $3e38f8b30e4a2ada$var$Ie($3e38f8b30e4a2ada$var$Se, d) || ($3e38f8b30e4a2ada$var$Se = d, d = $3e38f8b30e4a2ada$var$oe($3e38f8b30e4a2ada$var$Re, "onSelect"), 0 < d.length && (b = new $3e38f8b30e4a2ada$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3e38f8b30e4a2ada$var$Qe)));
}
function $3e38f8b30e4a2ada$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3e38f8b30e4a2ada$var$We = {
    animationend: $3e38f8b30e4a2ada$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3e38f8b30e4a2ada$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3e38f8b30e4a2ada$var$Ve("Animation", "AnimationStart"),
    transitionend: $3e38f8b30e4a2ada$var$Ve("Transition", "TransitionEnd")
}, $3e38f8b30e4a2ada$var$Xe = {}, $3e38f8b30e4a2ada$var$Ye = {};
$3e38f8b30e4a2ada$var$ia && ($3e38f8b30e4a2ada$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3e38f8b30e4a2ada$var$We.animationend.animation, delete $3e38f8b30e4a2ada$var$We.animationiteration.animation, delete $3e38f8b30e4a2ada$var$We.animationstart.animation), "TransitionEvent" in window || delete $3e38f8b30e4a2ada$var$We.transitionend.transition);
function $3e38f8b30e4a2ada$var$Ze(a) {
    if ($3e38f8b30e4a2ada$var$Xe[a]) return $3e38f8b30e4a2ada$var$Xe[a];
    if (!$3e38f8b30e4a2ada$var$We[a]) return a;
    var b = $3e38f8b30e4a2ada$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3e38f8b30e4a2ada$var$Ye) return $3e38f8b30e4a2ada$var$Xe[a] = b[c];
    return a;
}
var $3e38f8b30e4a2ada$var$$e = $3e38f8b30e4a2ada$var$Ze("animationend"), $3e38f8b30e4a2ada$var$af = $3e38f8b30e4a2ada$var$Ze("animationiteration"), $3e38f8b30e4a2ada$var$bf = $3e38f8b30e4a2ada$var$Ze("animationstart"), $3e38f8b30e4a2ada$var$cf = $3e38f8b30e4a2ada$var$Ze("transitionend"), $3e38f8b30e4a2ada$var$df = new Map, $3e38f8b30e4a2ada$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3e38f8b30e4a2ada$var$ff(a, b) {
    $3e38f8b30e4a2ada$var$df.set(a, b);
    $3e38f8b30e4a2ada$var$fa(b, [
        a
    ]);
}
for(var $3e38f8b30e4a2ada$var$gf = 0; $3e38f8b30e4a2ada$var$gf < $3e38f8b30e4a2ada$var$ef.length; $3e38f8b30e4a2ada$var$gf++){
    var $3e38f8b30e4a2ada$var$hf = $3e38f8b30e4a2ada$var$ef[$3e38f8b30e4a2ada$var$gf], $3e38f8b30e4a2ada$var$jf = $3e38f8b30e4a2ada$var$hf.toLowerCase(), $3e38f8b30e4a2ada$var$kf = $3e38f8b30e4a2ada$var$hf[0].toUpperCase() + $3e38f8b30e4a2ada$var$hf.slice(1);
    $3e38f8b30e4a2ada$var$ff($3e38f8b30e4a2ada$var$jf, "on" + $3e38f8b30e4a2ada$var$kf);
}
$3e38f8b30e4a2ada$var$ff($3e38f8b30e4a2ada$var$$e, "onAnimationEnd");
$3e38f8b30e4a2ada$var$ff($3e38f8b30e4a2ada$var$af, "onAnimationIteration");
$3e38f8b30e4a2ada$var$ff($3e38f8b30e4a2ada$var$bf, "onAnimationStart");
$3e38f8b30e4a2ada$var$ff("dblclick", "onDoubleClick");
$3e38f8b30e4a2ada$var$ff("focusin", "onFocus");
$3e38f8b30e4a2ada$var$ff("focusout", "onBlur");
$3e38f8b30e4a2ada$var$ff($3e38f8b30e4a2ada$var$cf, "onTransitionEnd");
$3e38f8b30e4a2ada$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3e38f8b30e4a2ada$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3e38f8b30e4a2ada$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3e38f8b30e4a2ada$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3e38f8b30e4a2ada$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3e38f8b30e4a2ada$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3e38f8b30e4a2ada$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3e38f8b30e4a2ada$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3e38f8b30e4a2ada$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3e38f8b30e4a2ada$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3e38f8b30e4a2ada$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3e38f8b30e4a2ada$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3e38f8b30e4a2ada$var$lf));
function $3e38f8b30e4a2ada$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3e38f8b30e4a2ada$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3e38f8b30e4a2ada$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3e38f8b30e4a2ada$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3e38f8b30e4a2ada$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3e38f8b30e4a2ada$var$Qb) throw a = $3e38f8b30e4a2ada$var$Rb, $3e38f8b30e4a2ada$var$Qb = !1, $3e38f8b30e4a2ada$var$Rb = null, a;
}
function $3e38f8b30e4a2ada$var$D(a, b) {
    var c = b[$3e38f8b30e4a2ada$var$of];
    void 0 === c && (c = b[$3e38f8b30e4a2ada$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3e38f8b30e4a2ada$var$pf(b, a, 2, !1), c.add(d));
}
function $3e38f8b30e4a2ada$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3e38f8b30e4a2ada$var$pf(c, a, d, b);
}
var $3e38f8b30e4a2ada$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3e38f8b30e4a2ada$var$sf(a) {
    if (!a[$3e38f8b30e4a2ada$var$rf]) {
        a[$3e38f8b30e4a2ada$var$rf] = !0;
        $3e38f8b30e4a2ada$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3e38f8b30e4a2ada$var$mf.has(b) || $3e38f8b30e4a2ada$var$qf(b, !1, a), $3e38f8b30e4a2ada$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3e38f8b30e4a2ada$var$rf] || (b[$3e38f8b30e4a2ada$var$rf] = !0, $3e38f8b30e4a2ada$var$qf("selectionchange", !1, b));
    }
}
function $3e38f8b30e4a2ada$var$pf(a, b, c, d) {
    switch($3e38f8b30e4a2ada$var$jd(b)){
        case 1:
            var e = $3e38f8b30e4a2ada$var$ed;
            break;
        case 4:
            e = $3e38f8b30e4a2ada$var$gd;
            break;
        default:
            e = $3e38f8b30e4a2ada$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3e38f8b30e4a2ada$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3e38f8b30e4a2ada$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3e38f8b30e4a2ada$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3e38f8b30e4a2ada$var$Jb(function() {
        var d = f, e = $3e38f8b30e4a2ada$var$xb(c), g = [];
        a: {
            var h = $3e38f8b30e4a2ada$var$df.get(a);
            if (void 0 !== h) {
                var k = $3e38f8b30e4a2ada$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3e38f8b30e4a2ada$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3e38f8b30e4a2ada$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3e38f8b30e4a2ada$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3e38f8b30e4a2ada$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3e38f8b30e4a2ada$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3e38f8b30e4a2ada$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3e38f8b30e4a2ada$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3e38f8b30e4a2ada$var$Vd;
                        break;
                    case $3e38f8b30e4a2ada$var$$e:
                    case $3e38f8b30e4a2ada$var$af:
                    case $3e38f8b30e4a2ada$var$bf:
                        k = $3e38f8b30e4a2ada$var$Hd;
                        break;
                    case $3e38f8b30e4a2ada$var$cf:
                        k = $3e38f8b30e4a2ada$var$Xd;
                        break;
                    case "scroll":
                        k = $3e38f8b30e4a2ada$var$vd;
                        break;
                    case "wheel":
                        k = $3e38f8b30e4a2ada$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3e38f8b30e4a2ada$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3e38f8b30e4a2ada$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3e38f8b30e4a2ada$var$Kb(w, x), null != F && t.push($3e38f8b30e4a2ada$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3e38f8b30e4a2ada$var$wb && (n = c.relatedTarget || c.fromElement) && ($3e38f8b30e4a2ada$var$Wc(n) || n[$3e38f8b30e4a2ada$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $3e38f8b30e4a2ada$var$Wc(n) : null, null !== n && (J = $3e38f8b30e4a2ada$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $3e38f8b30e4a2ada$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3e38f8b30e4a2ada$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3e38f8b30e4a2ada$var$ue(k);
                        u = null == n ? h : $3e38f8b30e4a2ada$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3e38f8b30e4a2ada$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3e38f8b30e4a2ada$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3e38f8b30e4a2ada$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3e38f8b30e4a2ada$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3e38f8b30e4a2ada$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3e38f8b30e4a2ada$var$vf(t);
                                x = $3e38f8b30e4a2ada$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3e38f8b30e4a2ada$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3e38f8b30e4a2ada$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $3e38f8b30e4a2ada$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3e38f8b30e4a2ada$var$ve;
                else if ($3e38f8b30e4a2ada$var$me(h)) {
                    if ($3e38f8b30e4a2ada$var$we) na = $3e38f8b30e4a2ada$var$Fe;
                    else {
                        na = $3e38f8b30e4a2ada$var$De;
                        var xa = $3e38f8b30e4a2ada$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3e38f8b30e4a2ada$var$Ee);
                if (na && (na = na(a, d))) {
                    $3e38f8b30e4a2ada$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3e38f8b30e4a2ada$var$cb(h, "number", h.value);
            }
            xa = d ? $3e38f8b30e4a2ada$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($3e38f8b30e4a2ada$var$me(xa) || "true" === xa.contentEditable) $3e38f8b30e4a2ada$var$Qe = xa, $3e38f8b30e4a2ada$var$Re = d, $3e38f8b30e4a2ada$var$Se = null;
                    break;
                case "focusout":
                    $3e38f8b30e4a2ada$var$Se = $3e38f8b30e4a2ada$var$Re = $3e38f8b30e4a2ada$var$Qe = null;
                    break;
                case "mousedown":
                    $3e38f8b30e4a2ada$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3e38f8b30e4a2ada$var$Te = !1;
                    $3e38f8b30e4a2ada$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($3e38f8b30e4a2ada$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3e38f8b30e4a2ada$var$Ue(g, c, e);
            }
            var $a;
            if ($3e38f8b30e4a2ada$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3e38f8b30e4a2ada$var$ie ? $3e38f8b30e4a2ada$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3e38f8b30e4a2ada$var$de && "ko" !== c.locale && ($3e38f8b30e4a2ada$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3e38f8b30e4a2ada$var$ie && ($a = $3e38f8b30e4a2ada$var$nd()) : ($3e38f8b30e4a2ada$var$kd = e, $3e38f8b30e4a2ada$var$ld = "value" in $3e38f8b30e4a2ada$var$kd ? $3e38f8b30e4a2ada$var$kd.value : $3e38f8b30e4a2ada$var$kd.textContent, $3e38f8b30e4a2ada$var$ie = !0)), xa = $3e38f8b30e4a2ada$var$oe(d, ba), 0 < xa.length && (ba = new $3e38f8b30e4a2ada$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3e38f8b30e4a2ada$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3e38f8b30e4a2ada$var$ce ? $3e38f8b30e4a2ada$var$je(a, c) : $3e38f8b30e4a2ada$var$ke(a, c)) d = $3e38f8b30e4a2ada$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $3e38f8b30e4a2ada$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $3e38f8b30e4a2ada$var$se(g, b);
    });
}
function $3e38f8b30e4a2ada$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3e38f8b30e4a2ada$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3e38f8b30e4a2ada$var$Kb(a, c), null != f && d.unshift($3e38f8b30e4a2ada$var$tf(a, f, e)), f = $3e38f8b30e4a2ada$var$Kb(a, b), null != f && d.push($3e38f8b30e4a2ada$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3e38f8b30e4a2ada$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3e38f8b30e4a2ada$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3e38f8b30e4a2ada$var$Kb(c, f), null != k && g.unshift($3e38f8b30e4a2ada$var$tf(c, k, h))) : e || (k = $3e38f8b30e4a2ada$var$Kb(c, f), null != k && g.push($3e38f8b30e4a2ada$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3e38f8b30e4a2ada$var$xf = /\r\n?/g, $3e38f8b30e4a2ada$var$yf = /\u0000|\uFFFD/g;
function $3e38f8b30e4a2ada$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3e38f8b30e4a2ada$var$xf, "\n").replace($3e38f8b30e4a2ada$var$yf, "");
}
function $3e38f8b30e4a2ada$var$Af(a, b, c) {
    b = $3e38f8b30e4a2ada$var$zf(b);
    if ($3e38f8b30e4a2ada$var$zf(a) !== b && c) throw Error($3e38f8b30e4a2ada$var$p(425));
}
function $3e38f8b30e4a2ada$var$Bf() {}
var $3e38f8b30e4a2ada$var$Cf = null, $3e38f8b30e4a2ada$var$Df = null;
function $3e38f8b30e4a2ada$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3e38f8b30e4a2ada$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3e38f8b30e4a2ada$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3e38f8b30e4a2ada$var$Hf = "function" === typeof Promise ? Promise : void 0, $3e38f8b30e4a2ada$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3e38f8b30e4a2ada$var$Hf ? function(a) {
    return $3e38f8b30e4a2ada$var$Hf.resolve(null).then(a).catch($3e38f8b30e4a2ada$var$If);
} : $3e38f8b30e4a2ada$var$Ff;
function $3e38f8b30e4a2ada$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3e38f8b30e4a2ada$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3e38f8b30e4a2ada$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3e38f8b30e4a2ada$var$bd(b);
}
function $3e38f8b30e4a2ada$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3e38f8b30e4a2ada$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3e38f8b30e4a2ada$var$Nf = Math.random().toString(36).slice(2), $3e38f8b30e4a2ada$var$Of = "__reactFiber$" + $3e38f8b30e4a2ada$var$Nf, $3e38f8b30e4a2ada$var$Pf = "__reactProps$" + $3e38f8b30e4a2ada$var$Nf, $3e38f8b30e4a2ada$var$uf = "__reactContainer$" + $3e38f8b30e4a2ada$var$Nf, $3e38f8b30e4a2ada$var$of = "__reactEvents$" + $3e38f8b30e4a2ada$var$Nf, $3e38f8b30e4a2ada$var$Qf = "__reactListeners$" + $3e38f8b30e4a2ada$var$Nf, $3e38f8b30e4a2ada$var$Rf = "__reactHandles$" + $3e38f8b30e4a2ada$var$Nf;
function $3e38f8b30e4a2ada$var$Wc(a) {
    var b = a[$3e38f8b30e4a2ada$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3e38f8b30e4a2ada$var$uf] || c[$3e38f8b30e4a2ada$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3e38f8b30e4a2ada$var$Mf(a); null !== a;){
                if (c = a[$3e38f8b30e4a2ada$var$Of]) return c;
                a = $3e38f8b30e4a2ada$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3e38f8b30e4a2ada$var$Cb(a) {
    a = a[$3e38f8b30e4a2ada$var$Of] || a[$3e38f8b30e4a2ada$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3e38f8b30e4a2ada$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3e38f8b30e4a2ada$var$p(33));
}
function $3e38f8b30e4a2ada$var$Db(a) {
    return a[$3e38f8b30e4a2ada$var$Pf] || null;
}
var $3e38f8b30e4a2ada$var$Sf = [], $3e38f8b30e4a2ada$var$Tf = -1;
function $3e38f8b30e4a2ada$var$Uf(a) {
    return {
        current: a
    };
}
function $3e38f8b30e4a2ada$var$E(a) {
    0 > $3e38f8b30e4a2ada$var$Tf || (a.current = $3e38f8b30e4a2ada$var$Sf[$3e38f8b30e4a2ada$var$Tf], $3e38f8b30e4a2ada$var$Sf[$3e38f8b30e4a2ada$var$Tf] = null, $3e38f8b30e4a2ada$var$Tf--);
}
function $3e38f8b30e4a2ada$var$G(a, b) {
    $3e38f8b30e4a2ada$var$Tf++;
    $3e38f8b30e4a2ada$var$Sf[$3e38f8b30e4a2ada$var$Tf] = a.current;
    a.current = b;
}
var $3e38f8b30e4a2ada$var$Vf = {}, $3e38f8b30e4a2ada$var$H = $3e38f8b30e4a2ada$var$Uf($3e38f8b30e4a2ada$var$Vf), $3e38f8b30e4a2ada$var$Wf = $3e38f8b30e4a2ada$var$Uf(!1), $3e38f8b30e4a2ada$var$Xf = $3e38f8b30e4a2ada$var$Vf;
function $3e38f8b30e4a2ada$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3e38f8b30e4a2ada$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3e38f8b30e4a2ada$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3e38f8b30e4a2ada$var$$f() {
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wf);
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$H);
}
function $3e38f8b30e4a2ada$var$ag(a, b, c) {
    if ($3e38f8b30e4a2ada$var$H.current !== $3e38f8b30e4a2ada$var$Vf) throw Error($3e38f8b30e4a2ada$var$p(168));
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$H, b);
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$Wf, c);
}
function $3e38f8b30e4a2ada$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3e38f8b30e4a2ada$var$p(108, $3e38f8b30e4a2ada$var$Ra(a) || "Unknown", e));
    return $3e38f8b30e4a2ada$var$A({}, c, d);
}
function $3e38f8b30e4a2ada$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3e38f8b30e4a2ada$var$Vf;
    $3e38f8b30e4a2ada$var$Xf = $3e38f8b30e4a2ada$var$H.current;
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$H, a);
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$Wf, $3e38f8b30e4a2ada$var$Wf.current);
    return !0;
}
function $3e38f8b30e4a2ada$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3e38f8b30e4a2ada$var$p(169));
    c ? (a = $3e38f8b30e4a2ada$var$bg(a, b, $3e38f8b30e4a2ada$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wf), $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$H), $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$H, a)) : $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wf);
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$Wf, c);
}
var $3e38f8b30e4a2ada$var$eg = null, $3e38f8b30e4a2ada$var$fg = !1, $3e38f8b30e4a2ada$var$gg = !1;
function $3e38f8b30e4a2ada$var$hg(a) {
    null === $3e38f8b30e4a2ada$var$eg ? $3e38f8b30e4a2ada$var$eg = [
        a
    ] : $3e38f8b30e4a2ada$var$eg.push(a);
}
function $3e38f8b30e4a2ada$var$ig(a) {
    $3e38f8b30e4a2ada$var$fg = !0;
    $3e38f8b30e4a2ada$var$hg(a);
}
function $3e38f8b30e4a2ada$var$jg() {
    if (!$3e38f8b30e4a2ada$var$gg && null !== $3e38f8b30e4a2ada$var$eg) {
        $3e38f8b30e4a2ada$var$gg = !0;
        var a = 0, b = $3e38f8b30e4a2ada$var$C;
        try {
            var c = $3e38f8b30e4a2ada$var$eg;
            for($3e38f8b30e4a2ada$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3e38f8b30e4a2ada$var$eg = null;
            $3e38f8b30e4a2ada$var$fg = !1;
        } catch (e) {
            throw null !== $3e38f8b30e4a2ada$var$eg && ($3e38f8b30e4a2ada$var$eg = $3e38f8b30e4a2ada$var$eg.slice(a + 1)), $3e38f8b30e4a2ada$var$ac($3e38f8b30e4a2ada$var$fc, $3e38f8b30e4a2ada$var$jg), e;
        } finally{
            $3e38f8b30e4a2ada$var$C = b, $3e38f8b30e4a2ada$var$gg = !1;
        }
    }
    return null;
}
var $3e38f8b30e4a2ada$var$kg = [], $3e38f8b30e4a2ada$var$lg = 0, $3e38f8b30e4a2ada$var$mg = null, $3e38f8b30e4a2ada$var$ng = 0, $3e38f8b30e4a2ada$var$og = [], $3e38f8b30e4a2ada$var$pg = 0, $3e38f8b30e4a2ada$var$qg = null, $3e38f8b30e4a2ada$var$rg = 1, $3e38f8b30e4a2ada$var$sg = "";
function $3e38f8b30e4a2ada$var$tg(a, b) {
    $3e38f8b30e4a2ada$var$kg[$3e38f8b30e4a2ada$var$lg++] = $3e38f8b30e4a2ada$var$ng;
    $3e38f8b30e4a2ada$var$kg[$3e38f8b30e4a2ada$var$lg++] = $3e38f8b30e4a2ada$var$mg;
    $3e38f8b30e4a2ada$var$mg = a;
    $3e38f8b30e4a2ada$var$ng = b;
}
function $3e38f8b30e4a2ada$var$ug(a, b, c) {
    $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg++] = $3e38f8b30e4a2ada$var$rg;
    $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg++] = $3e38f8b30e4a2ada$var$sg;
    $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg++] = $3e38f8b30e4a2ada$var$qg;
    $3e38f8b30e4a2ada$var$qg = a;
    var d = $3e38f8b30e4a2ada$var$rg;
    a = $3e38f8b30e4a2ada$var$sg;
    var e = 32 - $3e38f8b30e4a2ada$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3e38f8b30e4a2ada$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3e38f8b30e4a2ada$var$rg = 1 << 32 - $3e38f8b30e4a2ada$var$oc(b) + e | c << e | d;
        $3e38f8b30e4a2ada$var$sg = f + a;
    } else $3e38f8b30e4a2ada$var$rg = 1 << f | c << e | d, $3e38f8b30e4a2ada$var$sg = a;
}
function $3e38f8b30e4a2ada$var$vg(a) {
    null !== a.return && ($3e38f8b30e4a2ada$var$tg(a, 1), $3e38f8b30e4a2ada$var$ug(a, 1, 0));
}
function $3e38f8b30e4a2ada$var$wg(a) {
    for(; a === $3e38f8b30e4a2ada$var$mg;)$3e38f8b30e4a2ada$var$mg = $3e38f8b30e4a2ada$var$kg[--$3e38f8b30e4a2ada$var$lg], $3e38f8b30e4a2ada$var$kg[$3e38f8b30e4a2ada$var$lg] = null, $3e38f8b30e4a2ada$var$ng = $3e38f8b30e4a2ada$var$kg[--$3e38f8b30e4a2ada$var$lg], $3e38f8b30e4a2ada$var$kg[$3e38f8b30e4a2ada$var$lg] = null;
    for(; a === $3e38f8b30e4a2ada$var$qg;)$3e38f8b30e4a2ada$var$qg = $3e38f8b30e4a2ada$var$og[--$3e38f8b30e4a2ada$var$pg], $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg] = null, $3e38f8b30e4a2ada$var$sg = $3e38f8b30e4a2ada$var$og[--$3e38f8b30e4a2ada$var$pg], $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg] = null, $3e38f8b30e4a2ada$var$rg = $3e38f8b30e4a2ada$var$og[--$3e38f8b30e4a2ada$var$pg], $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg] = null;
}
var $3e38f8b30e4a2ada$var$xg = null, $3e38f8b30e4a2ada$var$yg = null, $3e38f8b30e4a2ada$var$I = !1, $3e38f8b30e4a2ada$var$zg = null;
function $3e38f8b30e4a2ada$var$Ag(a, b) {
    var c = $3e38f8b30e4a2ada$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3e38f8b30e4a2ada$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3e38f8b30e4a2ada$var$xg = a, $3e38f8b30e4a2ada$var$yg = $3e38f8b30e4a2ada$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3e38f8b30e4a2ada$var$xg = a, $3e38f8b30e4a2ada$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3e38f8b30e4a2ada$var$qg ? {
                id: $3e38f8b30e4a2ada$var$rg,
                overflow: $3e38f8b30e4a2ada$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3e38f8b30e4a2ada$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3e38f8b30e4a2ada$var$xg = a, $3e38f8b30e4a2ada$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3e38f8b30e4a2ada$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3e38f8b30e4a2ada$var$Eg(a) {
    if ($3e38f8b30e4a2ada$var$I) {
        var b = $3e38f8b30e4a2ada$var$yg;
        if (b) {
            var c = b;
            if (!$3e38f8b30e4a2ada$var$Cg(a, b)) {
                if ($3e38f8b30e4a2ada$var$Dg(a)) throw Error($3e38f8b30e4a2ada$var$p(418));
                b = $3e38f8b30e4a2ada$var$Lf(c.nextSibling);
                var d = $3e38f8b30e4a2ada$var$xg;
                b && $3e38f8b30e4a2ada$var$Cg(a, b) ? $3e38f8b30e4a2ada$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3e38f8b30e4a2ada$var$I = !1, $3e38f8b30e4a2ada$var$xg = a);
            }
        } else {
            if ($3e38f8b30e4a2ada$var$Dg(a)) throw Error($3e38f8b30e4a2ada$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3e38f8b30e4a2ada$var$I = !1;
            $3e38f8b30e4a2ada$var$xg = a;
        }
    }
}
function $3e38f8b30e4a2ada$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3e38f8b30e4a2ada$var$xg = a;
}
function $3e38f8b30e4a2ada$var$Gg(a) {
    if (a !== $3e38f8b30e4a2ada$var$xg) return !1;
    if (!$3e38f8b30e4a2ada$var$I) return $3e38f8b30e4a2ada$var$Fg(a), $3e38f8b30e4a2ada$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3e38f8b30e4a2ada$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3e38f8b30e4a2ada$var$yg)) {
        if ($3e38f8b30e4a2ada$var$Dg(a)) throw $3e38f8b30e4a2ada$var$Hg(), Error($3e38f8b30e4a2ada$var$p(418));
        for(; b;)$3e38f8b30e4a2ada$var$Ag(a, b), b = $3e38f8b30e4a2ada$var$Lf(b.nextSibling);
    }
    $3e38f8b30e4a2ada$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3e38f8b30e4a2ada$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3e38f8b30e4a2ada$var$yg = $3e38f8b30e4a2ada$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3e38f8b30e4a2ada$var$yg = null;
        }
    } else $3e38f8b30e4a2ada$var$yg = $3e38f8b30e4a2ada$var$xg ? $3e38f8b30e4a2ada$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3e38f8b30e4a2ada$var$Hg() {
    for(var a = $3e38f8b30e4a2ada$var$yg; a;)a = $3e38f8b30e4a2ada$var$Lf(a.nextSibling);
}
function $3e38f8b30e4a2ada$var$Ig() {
    $3e38f8b30e4a2ada$var$yg = $3e38f8b30e4a2ada$var$xg = null;
    $3e38f8b30e4a2ada$var$I = !1;
}
function $3e38f8b30e4a2ada$var$Jg(a) {
    null === $3e38f8b30e4a2ada$var$zg ? $3e38f8b30e4a2ada$var$zg = [
        a
    ] : $3e38f8b30e4a2ada$var$zg.push(a);
}
var $3e38f8b30e4a2ada$var$Kg = $3e38f8b30e4a2ada$var$ua.ReactCurrentBatchConfig;
function $3e38f8b30e4a2ada$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3e38f8b30e4a2ada$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3e38f8b30e4a2ada$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3e38f8b30e4a2ada$var$p(284));
        if (!c._owner) throw Error($3e38f8b30e4a2ada$var$p(290, a));
    }
    return a;
}
function $3e38f8b30e4a2ada$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3e38f8b30e4a2ada$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3e38f8b30e4a2ada$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $3e38f8b30e4a2ada$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3e38f8b30e4a2ada$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3e38f8b30e4a2ada$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3e38f8b30e4a2ada$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3e38f8b30e4a2ada$var$Ha && $3e38f8b30e4a2ada$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $3e38f8b30e4a2ada$var$Lg(a, b, c), d.return = a, d;
        d = $3e38f8b30e4a2ada$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3e38f8b30e4a2ada$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3e38f8b30e4a2ada$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3e38f8b30e4a2ada$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3e38f8b30e4a2ada$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3e38f8b30e4a2ada$var$va:
                    return c = $3e38f8b30e4a2ada$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $3e38f8b30e4a2ada$var$Lg(a, null, b), c.return = a, c;
                case $3e38f8b30e4a2ada$var$wa:
                    return b = $3e38f8b30e4a2ada$var$Sg(b, a.mode, c), b.return = a, b;
                case $3e38f8b30e4a2ada$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3e38f8b30e4a2ada$var$eb(b) || $3e38f8b30e4a2ada$var$Ka(b)) return b = $3e38f8b30e4a2ada$var$Tg(b, a.mode, c, null), b.return = a, b;
            $3e38f8b30e4a2ada$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3e38f8b30e4a2ada$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3e38f8b30e4a2ada$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3e38f8b30e4a2ada$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3e38f8b30e4a2ada$var$eb(c) || $3e38f8b30e4a2ada$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3e38f8b30e4a2ada$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3e38f8b30e4a2ada$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3e38f8b30e4a2ada$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3e38f8b30e4a2ada$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3e38f8b30e4a2ada$var$eb(d) || $3e38f8b30e4a2ada$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3e38f8b30e4a2ada$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3e38f8b30e4a2ada$var$I && $3e38f8b30e4a2ada$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3e38f8b30e4a2ada$var$I && $3e38f8b30e4a2ada$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3e38f8b30e4a2ada$var$I && $3e38f8b30e4a2ada$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3e38f8b30e4a2ada$var$Ka(h);
        if ("function" !== typeof l) throw Error($3e38f8b30e4a2ada$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3e38f8b30e4a2ada$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3e38f8b30e4a2ada$var$I && $3e38f8b30e4a2ada$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3e38f8b30e4a2ada$var$I && $3e38f8b30e4a2ada$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3e38f8b30e4a2ada$var$I && $3e38f8b30e4a2ada$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3e38f8b30e4a2ada$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3e38f8b30e4a2ada$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3e38f8b30e4a2ada$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3e38f8b30e4a2ada$var$Ha && $3e38f8b30e4a2ada$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3e38f8b30e4a2ada$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3e38f8b30e4a2ada$var$ya ? (d = $3e38f8b30e4a2ada$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3e38f8b30e4a2ada$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $3e38f8b30e4a2ada$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3e38f8b30e4a2ada$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3e38f8b30e4a2ada$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3e38f8b30e4a2ada$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3e38f8b30e4a2ada$var$eb(f)) return n(a, d, f, h);
            if ($3e38f8b30e4a2ada$var$Ka(f)) return t(a, d, f, h);
            $3e38f8b30e4a2ada$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3e38f8b30e4a2ada$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3e38f8b30e4a2ada$var$Ug = $3e38f8b30e4a2ada$var$Og(!0), $3e38f8b30e4a2ada$var$Vg = $3e38f8b30e4a2ada$var$Og(!1), $3e38f8b30e4a2ada$var$Wg = $3e38f8b30e4a2ada$var$Uf(null), $3e38f8b30e4a2ada$var$Xg = null, $3e38f8b30e4a2ada$var$Yg = null, $3e38f8b30e4a2ada$var$Zg = null;
function $3e38f8b30e4a2ada$var$$g() {
    $3e38f8b30e4a2ada$var$Zg = $3e38f8b30e4a2ada$var$Yg = $3e38f8b30e4a2ada$var$Xg = null;
}
function $3e38f8b30e4a2ada$var$ah(a) {
    var b = $3e38f8b30e4a2ada$var$Wg.current;
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wg);
    a._currentValue = b;
}
function $3e38f8b30e4a2ada$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3e38f8b30e4a2ada$var$ch(a, b) {
    $3e38f8b30e4a2ada$var$Xg = a;
    $3e38f8b30e4a2ada$var$Zg = $3e38f8b30e4a2ada$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3e38f8b30e4a2ada$var$dh = !0), a.firstContext = null);
}
function $3e38f8b30e4a2ada$var$eh(a) {
    var b = a._currentValue;
    if ($3e38f8b30e4a2ada$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3e38f8b30e4a2ada$var$Yg) {
            if (null === $3e38f8b30e4a2ada$var$Xg) throw Error($3e38f8b30e4a2ada$var$p(308));
            $3e38f8b30e4a2ada$var$Yg = a;
            $3e38f8b30e4a2ada$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3e38f8b30e4a2ada$var$Yg = $3e38f8b30e4a2ada$var$Yg.next = a;
    }
    return b;
}
var $3e38f8b30e4a2ada$var$fh = null;
function $3e38f8b30e4a2ada$var$gh(a) {
    null === $3e38f8b30e4a2ada$var$fh ? $3e38f8b30e4a2ada$var$fh = [
        a
    ] : $3e38f8b30e4a2ada$var$fh.push(a);
}
function $3e38f8b30e4a2ada$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3e38f8b30e4a2ada$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3e38f8b30e4a2ada$var$ih(a, d);
}
function $3e38f8b30e4a2ada$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3e38f8b30e4a2ada$var$jh = !1;
function $3e38f8b30e4a2ada$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3e38f8b30e4a2ada$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3e38f8b30e4a2ada$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3e38f8b30e4a2ada$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3e38f8b30e4a2ada$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3e38f8b30e4a2ada$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3e38f8b30e4a2ada$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3e38f8b30e4a2ada$var$ih(a, c);
}
function $3e38f8b30e4a2ada$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3e38f8b30e4a2ada$var$Cc(a, c);
    }
}
function $3e38f8b30e4a2ada$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3e38f8b30e4a2ada$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $3e38f8b30e4a2ada$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3e38f8b30e4a2ada$var$A({}, q, r);
                            break a;
                        case 2:
                            $3e38f8b30e4a2ada$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3e38f8b30e4a2ada$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3e38f8b30e4a2ada$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3e38f8b30e4a2ada$var$p(191, e));
            e.call(d);
        }
    }
}
var $3e38f8b30e4a2ada$var$th = {}, $3e38f8b30e4a2ada$var$uh = $3e38f8b30e4a2ada$var$Uf($3e38f8b30e4a2ada$var$th), $3e38f8b30e4a2ada$var$vh = $3e38f8b30e4a2ada$var$Uf($3e38f8b30e4a2ada$var$th), $3e38f8b30e4a2ada$var$wh = $3e38f8b30e4a2ada$var$Uf($3e38f8b30e4a2ada$var$th);
function $3e38f8b30e4a2ada$var$xh(a) {
    if (a === $3e38f8b30e4a2ada$var$th) throw Error($3e38f8b30e4a2ada$var$p(174));
    return a;
}
function $3e38f8b30e4a2ada$var$yh(a, b) {
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$wh, b);
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$vh, a);
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$uh, $3e38f8b30e4a2ada$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3e38f8b30e4a2ada$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3e38f8b30e4a2ada$var$lb(b, a);
    }
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$uh);
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$uh, b);
}
function $3e38f8b30e4a2ada$var$zh() {
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$uh);
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$vh);
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$wh);
}
function $3e38f8b30e4a2ada$var$Ah(a) {
    $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$wh.current);
    var b = $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$uh.current);
    var c = $3e38f8b30e4a2ada$var$lb(b, a.type);
    b !== c && ($3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$vh, a), $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$uh, c));
}
function $3e38f8b30e4a2ada$var$Bh(a) {
    $3e38f8b30e4a2ada$var$vh.current === a && ($3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$uh), $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$vh));
}
var $3e38f8b30e4a2ada$var$L = $3e38f8b30e4a2ada$var$Uf(0);
function $3e38f8b30e4a2ada$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3e38f8b30e4a2ada$var$Dh = [];
function $3e38f8b30e4a2ada$var$Eh() {
    for(var a = 0; a < $3e38f8b30e4a2ada$var$Dh.length; a++)$3e38f8b30e4a2ada$var$Dh[a]._workInProgressVersionPrimary = null;
    $3e38f8b30e4a2ada$var$Dh.length = 0;
}
var $3e38f8b30e4a2ada$var$Fh = $3e38f8b30e4a2ada$var$ua.ReactCurrentDispatcher, $3e38f8b30e4a2ada$var$Gh = $3e38f8b30e4a2ada$var$ua.ReactCurrentBatchConfig, $3e38f8b30e4a2ada$var$Hh = 0, $3e38f8b30e4a2ada$var$M = null, $3e38f8b30e4a2ada$var$N = null, $3e38f8b30e4a2ada$var$O = null, $3e38f8b30e4a2ada$var$Ih = !1, $3e38f8b30e4a2ada$var$Jh = !1, $3e38f8b30e4a2ada$var$Kh = 0, $3e38f8b30e4a2ada$var$Lh = 0;
function $3e38f8b30e4a2ada$var$P() {
    throw Error($3e38f8b30e4a2ada$var$p(321));
}
function $3e38f8b30e4a2ada$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3e38f8b30e4a2ada$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3e38f8b30e4a2ada$var$Nh(a, b, c, d, e, f) {
    $3e38f8b30e4a2ada$var$Hh = f;
    $3e38f8b30e4a2ada$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3e38f8b30e4a2ada$var$Fh.current = null === a || null === a.memoizedState ? $3e38f8b30e4a2ada$var$Oh : $3e38f8b30e4a2ada$var$Ph;
    a = c(d, e);
    if ($3e38f8b30e4a2ada$var$Jh) {
        f = 0;
        do {
            $3e38f8b30e4a2ada$var$Jh = !1;
            $3e38f8b30e4a2ada$var$Kh = 0;
            if (25 <= f) throw Error($3e38f8b30e4a2ada$var$p(301));
            f += 1;
            $3e38f8b30e4a2ada$var$O = $3e38f8b30e4a2ada$var$N = null;
            b.updateQueue = null;
            $3e38f8b30e4a2ada$var$Fh.current = $3e38f8b30e4a2ada$var$Qh;
            a = c(d, e);
        }while ($3e38f8b30e4a2ada$var$Jh);
    }
    $3e38f8b30e4a2ada$var$Fh.current = $3e38f8b30e4a2ada$var$Rh;
    b = null !== $3e38f8b30e4a2ada$var$N && null !== $3e38f8b30e4a2ada$var$N.next;
    $3e38f8b30e4a2ada$var$Hh = 0;
    $3e38f8b30e4a2ada$var$O = $3e38f8b30e4a2ada$var$N = $3e38f8b30e4a2ada$var$M = null;
    $3e38f8b30e4a2ada$var$Ih = !1;
    if (b) throw Error($3e38f8b30e4a2ada$var$p(300));
    return a;
}
function $3e38f8b30e4a2ada$var$Sh() {
    var a = 0 !== $3e38f8b30e4a2ada$var$Kh;
    $3e38f8b30e4a2ada$var$Kh = 0;
    return a;
}
function $3e38f8b30e4a2ada$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3e38f8b30e4a2ada$var$O ? $3e38f8b30e4a2ada$var$M.memoizedState = $3e38f8b30e4a2ada$var$O = a : $3e38f8b30e4a2ada$var$O = $3e38f8b30e4a2ada$var$O.next = a;
    return $3e38f8b30e4a2ada$var$O;
}
function $3e38f8b30e4a2ada$var$Uh() {
    if (null === $3e38f8b30e4a2ada$var$N) {
        var a = $3e38f8b30e4a2ada$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3e38f8b30e4a2ada$var$N.next;
    var b = null === $3e38f8b30e4a2ada$var$O ? $3e38f8b30e4a2ada$var$M.memoizedState : $3e38f8b30e4a2ada$var$O.next;
    if (null !== b) $3e38f8b30e4a2ada$var$O = b, $3e38f8b30e4a2ada$var$N = a;
    else {
        if (null === a) throw Error($3e38f8b30e4a2ada$var$p(310));
        $3e38f8b30e4a2ada$var$N = a;
        a = {
            memoizedState: $3e38f8b30e4a2ada$var$N.memoizedState,
            baseState: $3e38f8b30e4a2ada$var$N.baseState,
            baseQueue: $3e38f8b30e4a2ada$var$N.baseQueue,
            queue: $3e38f8b30e4a2ada$var$N.queue,
            next: null
        };
        null === $3e38f8b30e4a2ada$var$O ? $3e38f8b30e4a2ada$var$M.memoizedState = $3e38f8b30e4a2ada$var$O = a : $3e38f8b30e4a2ada$var$O = $3e38f8b30e4a2ada$var$O.next = a;
    }
    return $3e38f8b30e4a2ada$var$O;
}
function $3e38f8b30e4a2ada$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3e38f8b30e4a2ada$var$Wh(a) {
    var b = $3e38f8b30e4a2ada$var$Uh(), c = b.queue;
    if (null === c) throw Error($3e38f8b30e4a2ada$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3e38f8b30e4a2ada$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3e38f8b30e4a2ada$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3e38f8b30e4a2ada$var$M.lanes |= m;
                $3e38f8b30e4a2ada$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3e38f8b30e4a2ada$var$He(d, b.memoizedState) || ($3e38f8b30e4a2ada$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3e38f8b30e4a2ada$var$M.lanes |= f, $3e38f8b30e4a2ada$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3e38f8b30e4a2ada$var$Xh(a) {
    var b = $3e38f8b30e4a2ada$var$Uh(), c = b.queue;
    if (null === c) throw Error($3e38f8b30e4a2ada$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3e38f8b30e4a2ada$var$He(f, b.memoizedState) || ($3e38f8b30e4a2ada$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3e38f8b30e4a2ada$var$Yh() {}
function $3e38f8b30e4a2ada$var$Zh(a, b) {
    var c = $3e38f8b30e4a2ada$var$M, d = $3e38f8b30e4a2ada$var$Uh(), e = b(), f = !$3e38f8b30e4a2ada$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3e38f8b30e4a2ada$var$dh = !0);
    d = d.queue;
    $3e38f8b30e4a2ada$var$$h($3e38f8b30e4a2ada$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3e38f8b30e4a2ada$var$O && $3e38f8b30e4a2ada$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3e38f8b30e4a2ada$var$bi(9, $3e38f8b30e4a2ada$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $3e38f8b30e4a2ada$var$Q) throw Error($3e38f8b30e4a2ada$var$p(349));
        0 !== ($3e38f8b30e4a2ada$var$Hh & 30) || $3e38f8b30e4a2ada$var$di(c, b, e);
    }
    return e;
}
function $3e38f8b30e4a2ada$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3e38f8b30e4a2ada$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3e38f8b30e4a2ada$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3e38f8b30e4a2ada$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3e38f8b30e4a2ada$var$ei(b) && $3e38f8b30e4a2ada$var$fi(a);
}
function $3e38f8b30e4a2ada$var$ai(a, b, c) {
    return c(function() {
        $3e38f8b30e4a2ada$var$ei(b) && $3e38f8b30e4a2ada$var$fi(a);
    });
}
function $3e38f8b30e4a2ada$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3e38f8b30e4a2ada$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3e38f8b30e4a2ada$var$fi(a) {
    var b = $3e38f8b30e4a2ada$var$ih(a, 1);
    null !== b && $3e38f8b30e4a2ada$var$gi(b, a, 1, -1);
}
function $3e38f8b30e4a2ada$var$hi(a) {
    var b = $3e38f8b30e4a2ada$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3e38f8b30e4a2ada$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3e38f8b30e4a2ada$var$ii.bind(null, $3e38f8b30e4a2ada$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3e38f8b30e4a2ada$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3e38f8b30e4a2ada$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3e38f8b30e4a2ada$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3e38f8b30e4a2ada$var$ji() {
    return $3e38f8b30e4a2ada$var$Uh().memoizedState;
}
function $3e38f8b30e4a2ada$var$ki(a, b, c, d) {
    var e = $3e38f8b30e4a2ada$var$Th();
    $3e38f8b30e4a2ada$var$M.flags |= a;
    e.memoizedState = $3e38f8b30e4a2ada$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3e38f8b30e4a2ada$var$li(a, b, c, d) {
    var e = $3e38f8b30e4a2ada$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3e38f8b30e4a2ada$var$N) {
        var g = $3e38f8b30e4a2ada$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3e38f8b30e4a2ada$var$Mh(d, g.deps)) {
            e.memoizedState = $3e38f8b30e4a2ada$var$bi(b, c, f, d);
            return;
        }
    }
    $3e38f8b30e4a2ada$var$M.flags |= a;
    e.memoizedState = $3e38f8b30e4a2ada$var$bi(1 | b, c, f, d);
}
function $3e38f8b30e4a2ada$var$mi(a, b) {
    return $3e38f8b30e4a2ada$var$ki(8390656, 8, a, b);
}
function $3e38f8b30e4a2ada$var$$h(a, b) {
    return $3e38f8b30e4a2ada$var$li(2048, 8, a, b);
}
function $3e38f8b30e4a2ada$var$ni(a, b) {
    return $3e38f8b30e4a2ada$var$li(4, 2, a, b);
}
function $3e38f8b30e4a2ada$var$oi(a, b) {
    return $3e38f8b30e4a2ada$var$li(4, 4, a, b);
}
function $3e38f8b30e4a2ada$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3e38f8b30e4a2ada$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3e38f8b30e4a2ada$var$li(4, 4, $3e38f8b30e4a2ada$var$pi.bind(null, b, a), c);
}
function $3e38f8b30e4a2ada$var$ri() {}
function $3e38f8b30e4a2ada$var$si(a, b) {
    var c = $3e38f8b30e4a2ada$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3e38f8b30e4a2ada$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3e38f8b30e4a2ada$var$ti(a, b) {
    var c = $3e38f8b30e4a2ada$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3e38f8b30e4a2ada$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3e38f8b30e4a2ada$var$ui(a, b, c) {
    if (0 === ($3e38f8b30e4a2ada$var$Hh & 21)) return a.baseState && (a.baseState = !1, $3e38f8b30e4a2ada$var$dh = !0), a.memoizedState = c;
    $3e38f8b30e4a2ada$var$He(c, b) || (c = $3e38f8b30e4a2ada$var$yc(), $3e38f8b30e4a2ada$var$M.lanes |= c, $3e38f8b30e4a2ada$var$rh |= c, a.baseState = !0);
    return b;
}
function $3e38f8b30e4a2ada$var$vi(a, b) {
    var c = $3e38f8b30e4a2ada$var$C;
    $3e38f8b30e4a2ada$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3e38f8b30e4a2ada$var$Gh.transition;
    $3e38f8b30e4a2ada$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3e38f8b30e4a2ada$var$C = c, $3e38f8b30e4a2ada$var$Gh.transition = d;
    }
}
function $3e38f8b30e4a2ada$var$wi() {
    return $3e38f8b30e4a2ada$var$Uh().memoizedState;
}
function $3e38f8b30e4a2ada$var$xi(a, b, c) {
    var d = $3e38f8b30e4a2ada$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3e38f8b30e4a2ada$var$zi(a)) $3e38f8b30e4a2ada$var$Ai(b, c);
    else if (c = $3e38f8b30e4a2ada$var$hh(a, b, c, d), null !== c) {
        var e = $3e38f8b30e4a2ada$var$R();
        $3e38f8b30e4a2ada$var$gi(c, a, d, e);
        $3e38f8b30e4a2ada$var$Bi(c, b, d);
    }
}
function $3e38f8b30e4a2ada$var$ii(a, b, c) {
    var d = $3e38f8b30e4a2ada$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3e38f8b30e4a2ada$var$zi(a)) $3e38f8b30e4a2ada$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3e38f8b30e4a2ada$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3e38f8b30e4a2ada$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3e38f8b30e4a2ada$var$hh(a, b, e, d);
        null !== c && (e = $3e38f8b30e4a2ada$var$R(), $3e38f8b30e4a2ada$var$gi(c, a, d, e), $3e38f8b30e4a2ada$var$Bi(c, b, d));
    }
}
function $3e38f8b30e4a2ada$var$zi(a) {
    var b = a.alternate;
    return a === $3e38f8b30e4a2ada$var$M || null !== b && b === $3e38f8b30e4a2ada$var$M;
}
function $3e38f8b30e4a2ada$var$Ai(a, b) {
    $3e38f8b30e4a2ada$var$Jh = $3e38f8b30e4a2ada$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3e38f8b30e4a2ada$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3e38f8b30e4a2ada$var$Cc(a, c);
    }
}
var $3e38f8b30e4a2ada$var$Rh = {
    readContext: $3e38f8b30e4a2ada$var$eh,
    useCallback: $3e38f8b30e4a2ada$var$P,
    useContext: $3e38f8b30e4a2ada$var$P,
    useEffect: $3e38f8b30e4a2ada$var$P,
    useImperativeHandle: $3e38f8b30e4a2ada$var$P,
    useInsertionEffect: $3e38f8b30e4a2ada$var$P,
    useLayoutEffect: $3e38f8b30e4a2ada$var$P,
    useMemo: $3e38f8b30e4a2ada$var$P,
    useReducer: $3e38f8b30e4a2ada$var$P,
    useRef: $3e38f8b30e4a2ada$var$P,
    useState: $3e38f8b30e4a2ada$var$P,
    useDebugValue: $3e38f8b30e4a2ada$var$P,
    useDeferredValue: $3e38f8b30e4a2ada$var$P,
    useTransition: $3e38f8b30e4a2ada$var$P,
    useMutableSource: $3e38f8b30e4a2ada$var$P,
    useSyncExternalStore: $3e38f8b30e4a2ada$var$P,
    useId: $3e38f8b30e4a2ada$var$P,
    unstable_isNewReconciler: !1
}, $3e38f8b30e4a2ada$var$Oh = {
    readContext: $3e38f8b30e4a2ada$var$eh,
    useCallback: function(a, b) {
        $3e38f8b30e4a2ada$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3e38f8b30e4a2ada$var$eh,
    useEffect: $3e38f8b30e4a2ada$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3e38f8b30e4a2ada$var$ki(4194308, 4, $3e38f8b30e4a2ada$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3e38f8b30e4a2ada$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3e38f8b30e4a2ada$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3e38f8b30e4a2ada$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3e38f8b30e4a2ada$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3e38f8b30e4a2ada$var$xi.bind(null, $3e38f8b30e4a2ada$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3e38f8b30e4a2ada$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3e38f8b30e4a2ada$var$hi,
    useDebugValue: $3e38f8b30e4a2ada$var$ri,
    useDeferredValue: function(a) {
        return $3e38f8b30e4a2ada$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $3e38f8b30e4a2ada$var$hi(!1), b = a[0];
        a = $3e38f8b30e4a2ada$var$vi.bind(null, a[1]);
        $3e38f8b30e4a2ada$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3e38f8b30e4a2ada$var$M, e = $3e38f8b30e4a2ada$var$Th();
        if ($3e38f8b30e4a2ada$var$I) {
            if (void 0 === c) throw Error($3e38f8b30e4a2ada$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3e38f8b30e4a2ada$var$Q) throw Error($3e38f8b30e4a2ada$var$p(349));
            0 !== ($3e38f8b30e4a2ada$var$Hh & 30) || $3e38f8b30e4a2ada$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3e38f8b30e4a2ada$var$mi($3e38f8b30e4a2ada$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3e38f8b30e4a2ada$var$bi(9, $3e38f8b30e4a2ada$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3e38f8b30e4a2ada$var$Th(), b = $3e38f8b30e4a2ada$var$Q.identifierPrefix;
        if ($3e38f8b30e4a2ada$var$I) {
            var c = $3e38f8b30e4a2ada$var$sg;
            var d = $3e38f8b30e4a2ada$var$rg;
            c = (d & ~(1 << 32 - $3e38f8b30e4a2ada$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3e38f8b30e4a2ada$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3e38f8b30e4a2ada$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3e38f8b30e4a2ada$var$Ph = {
    readContext: $3e38f8b30e4a2ada$var$eh,
    useCallback: $3e38f8b30e4a2ada$var$si,
    useContext: $3e38f8b30e4a2ada$var$eh,
    useEffect: $3e38f8b30e4a2ada$var$$h,
    useImperativeHandle: $3e38f8b30e4a2ada$var$qi,
    useInsertionEffect: $3e38f8b30e4a2ada$var$ni,
    useLayoutEffect: $3e38f8b30e4a2ada$var$oi,
    useMemo: $3e38f8b30e4a2ada$var$ti,
    useReducer: $3e38f8b30e4a2ada$var$Wh,
    useRef: $3e38f8b30e4a2ada$var$ji,
    useState: function() {
        return $3e38f8b30e4a2ada$var$Wh($3e38f8b30e4a2ada$var$Vh);
    },
    useDebugValue: $3e38f8b30e4a2ada$var$ri,
    useDeferredValue: function(a) {
        var b = $3e38f8b30e4a2ada$var$Uh();
        return $3e38f8b30e4a2ada$var$ui(b, $3e38f8b30e4a2ada$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3e38f8b30e4a2ada$var$Wh($3e38f8b30e4a2ada$var$Vh)[0], b = $3e38f8b30e4a2ada$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3e38f8b30e4a2ada$var$Yh,
    useSyncExternalStore: $3e38f8b30e4a2ada$var$Zh,
    useId: $3e38f8b30e4a2ada$var$wi,
    unstable_isNewReconciler: !1
}, $3e38f8b30e4a2ada$var$Qh = {
    readContext: $3e38f8b30e4a2ada$var$eh,
    useCallback: $3e38f8b30e4a2ada$var$si,
    useContext: $3e38f8b30e4a2ada$var$eh,
    useEffect: $3e38f8b30e4a2ada$var$$h,
    useImperativeHandle: $3e38f8b30e4a2ada$var$qi,
    useInsertionEffect: $3e38f8b30e4a2ada$var$ni,
    useLayoutEffect: $3e38f8b30e4a2ada$var$oi,
    useMemo: $3e38f8b30e4a2ada$var$ti,
    useReducer: $3e38f8b30e4a2ada$var$Xh,
    useRef: $3e38f8b30e4a2ada$var$ji,
    useState: function() {
        return $3e38f8b30e4a2ada$var$Xh($3e38f8b30e4a2ada$var$Vh);
    },
    useDebugValue: $3e38f8b30e4a2ada$var$ri,
    useDeferredValue: function(a) {
        var b = $3e38f8b30e4a2ada$var$Uh();
        return null === $3e38f8b30e4a2ada$var$N ? b.memoizedState = a : $3e38f8b30e4a2ada$var$ui(b, $3e38f8b30e4a2ada$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3e38f8b30e4a2ada$var$Xh($3e38f8b30e4a2ada$var$Vh)[0], b = $3e38f8b30e4a2ada$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3e38f8b30e4a2ada$var$Yh,
    useSyncExternalStore: $3e38f8b30e4a2ada$var$Zh,
    useId: $3e38f8b30e4a2ada$var$wi,
    unstable_isNewReconciler: !1
};
function $3e38f8b30e4a2ada$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $3e38f8b30e4a2ada$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3e38f8b30e4a2ada$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3e38f8b30e4a2ada$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3e38f8b30e4a2ada$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3e38f8b30e4a2ada$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3e38f8b30e4a2ada$var$R(), e = $3e38f8b30e4a2ada$var$yi(a), f = $3e38f8b30e4a2ada$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3e38f8b30e4a2ada$var$nh(a, f, e);
        null !== b && ($3e38f8b30e4a2ada$var$gi(b, a, e, d), $3e38f8b30e4a2ada$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3e38f8b30e4a2ada$var$R(), e = $3e38f8b30e4a2ada$var$yi(a), f = $3e38f8b30e4a2ada$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3e38f8b30e4a2ada$var$nh(a, f, e);
        null !== b && ($3e38f8b30e4a2ada$var$gi(b, a, e, d), $3e38f8b30e4a2ada$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3e38f8b30e4a2ada$var$R(), d = $3e38f8b30e4a2ada$var$yi(a), e = $3e38f8b30e4a2ada$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3e38f8b30e4a2ada$var$nh(a, e, d);
        null !== b && ($3e38f8b30e4a2ada$var$gi(b, a, d, c), $3e38f8b30e4a2ada$var$oh(b, a, d));
    }
};
function $3e38f8b30e4a2ada$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3e38f8b30e4a2ada$var$Ie(c, d) || !$3e38f8b30e4a2ada$var$Ie(e, f) : !0;
}
function $3e38f8b30e4a2ada$var$Gi(a, b, c) {
    var d = !1, e = $3e38f8b30e4a2ada$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3e38f8b30e4a2ada$var$eh(f) : (e = $3e38f8b30e4a2ada$var$Zf(b) ? $3e38f8b30e4a2ada$var$Xf : $3e38f8b30e4a2ada$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3e38f8b30e4a2ada$var$Yf(a, e) : $3e38f8b30e4a2ada$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3e38f8b30e4a2ada$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3e38f8b30e4a2ada$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3e38f8b30e4a2ada$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $3e38f8b30e4a2ada$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3e38f8b30e4a2ada$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3e38f8b30e4a2ada$var$eh(f) : (f = $3e38f8b30e4a2ada$var$Zf(b) ? $3e38f8b30e4a2ada$var$Xf : $3e38f8b30e4a2ada$var$H.current, e.context = $3e38f8b30e4a2ada$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3e38f8b30e4a2ada$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3e38f8b30e4a2ada$var$Ei.enqueueReplaceState(e, e.state, null), $3e38f8b30e4a2ada$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3e38f8b30e4a2ada$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $3e38f8b30e4a2ada$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3e38f8b30e4a2ada$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3e38f8b30e4a2ada$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3e38f8b30e4a2ada$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $3e38f8b30e4a2ada$var$Ni(a, b, c) {
    c = $3e38f8b30e4a2ada$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3e38f8b30e4a2ada$var$Oi || ($3e38f8b30e4a2ada$var$Oi = !0, $3e38f8b30e4a2ada$var$Pi = d);
        $3e38f8b30e4a2ada$var$Li(a, b);
    };
    return c;
}
function $3e38f8b30e4a2ada$var$Qi(a, b, c) {
    c = $3e38f8b30e4a2ada$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3e38f8b30e4a2ada$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3e38f8b30e4a2ada$var$Li(a, b);
        "function" !== typeof d && (null === $3e38f8b30e4a2ada$var$Ri ? $3e38f8b30e4a2ada$var$Ri = new Set([
            this
        ]) : $3e38f8b30e4a2ada$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3e38f8b30e4a2ada$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3e38f8b30e4a2ada$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3e38f8b30e4a2ada$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $3e38f8b30e4a2ada$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3e38f8b30e4a2ada$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3e38f8b30e4a2ada$var$mh(-1, 1), b.tag = 2, $3e38f8b30e4a2ada$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3e38f8b30e4a2ada$var$Wi = $3e38f8b30e4a2ada$var$ua.ReactCurrentOwner, $3e38f8b30e4a2ada$var$dh = !1;
function $3e38f8b30e4a2ada$var$Xi(a, b, c, d) {
    b.child = null === a ? $3e38f8b30e4a2ada$var$Vg(b, null, c, d) : $3e38f8b30e4a2ada$var$Ug(b, a.child, c, d);
}
function $3e38f8b30e4a2ada$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3e38f8b30e4a2ada$var$ch(b, e);
    d = $3e38f8b30e4a2ada$var$Nh(a, b, c, d, f, e);
    c = $3e38f8b30e4a2ada$var$Sh();
    if (null !== a && !$3e38f8b30e4a2ada$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3e38f8b30e4a2ada$var$Zi(a, b, e);
    $3e38f8b30e4a2ada$var$I && c && $3e38f8b30e4a2ada$var$vg(b);
    b.flags |= 1;
    $3e38f8b30e4a2ada$var$Xi(a, b, d, e);
    return b.child;
}
function $3e38f8b30e4a2ada$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3e38f8b30e4a2ada$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3e38f8b30e4a2ada$var$bj(a, b, f, d, e);
        a = $3e38f8b30e4a2ada$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3e38f8b30e4a2ada$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3e38f8b30e4a2ada$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $3e38f8b30e4a2ada$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3e38f8b30e4a2ada$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3e38f8b30e4a2ada$var$Ie(f, d) && a.ref === b.ref) {
            if ($3e38f8b30e4a2ada$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3e38f8b30e4a2ada$var$dh = !0);
            else return b.lanes = a.lanes, $3e38f8b30e4a2ada$var$Zi(a, b, e);
        }
    }
    return $3e38f8b30e4a2ada$var$cj(a, b, c, d, e);
}
function $3e38f8b30e4a2ada$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$ej, $3e38f8b30e4a2ada$var$fj), $3e38f8b30e4a2ada$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$ej, $3e38f8b30e4a2ada$var$fj), $3e38f8b30e4a2ada$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$ej, $3e38f8b30e4a2ada$var$fj);
            $3e38f8b30e4a2ada$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$ej, $3e38f8b30e4a2ada$var$fj), $3e38f8b30e4a2ada$var$fj |= d;
    $3e38f8b30e4a2ada$var$Xi(a, b, e, c);
    return b.child;
}
function $3e38f8b30e4a2ada$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3e38f8b30e4a2ada$var$cj(a, b, c, d, e) {
    var f = $3e38f8b30e4a2ada$var$Zf(c) ? $3e38f8b30e4a2ada$var$Xf : $3e38f8b30e4a2ada$var$H.current;
    f = $3e38f8b30e4a2ada$var$Yf(b, f);
    $3e38f8b30e4a2ada$var$ch(b, e);
    c = $3e38f8b30e4a2ada$var$Nh(a, b, c, d, f, e);
    d = $3e38f8b30e4a2ada$var$Sh();
    if (null !== a && !$3e38f8b30e4a2ada$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3e38f8b30e4a2ada$var$Zi(a, b, e);
    $3e38f8b30e4a2ada$var$I && d && $3e38f8b30e4a2ada$var$vg(b);
    b.flags |= 1;
    $3e38f8b30e4a2ada$var$Xi(a, b, c, e);
    return b.child;
}
function $3e38f8b30e4a2ada$var$hj(a, b, c, d, e) {
    if ($3e38f8b30e4a2ada$var$Zf(c)) {
        var f = !0;
        $3e38f8b30e4a2ada$var$cg(b);
    } else f = !1;
    $3e38f8b30e4a2ada$var$ch(b, e);
    if (null === b.stateNode) $3e38f8b30e4a2ada$var$ij(a, b), $3e38f8b30e4a2ada$var$Gi(b, c, d), $3e38f8b30e4a2ada$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3e38f8b30e4a2ada$var$eh(l) : (l = $3e38f8b30e4a2ada$var$Zf(c) ? $3e38f8b30e4a2ada$var$Xf : $3e38f8b30e4a2ada$var$H.current, l = $3e38f8b30e4a2ada$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3e38f8b30e4a2ada$var$Hi(b, g, d, l);
        $3e38f8b30e4a2ada$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3e38f8b30e4a2ada$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3e38f8b30e4a2ada$var$Wf.current || $3e38f8b30e4a2ada$var$jh ? ("function" === typeof m && ($3e38f8b30e4a2ada$var$Di(b, c, m, d), k = b.memoizedState), (h = $3e38f8b30e4a2ada$var$jh || $3e38f8b30e4a2ada$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3e38f8b30e4a2ada$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3e38f8b30e4a2ada$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3e38f8b30e4a2ada$var$eh(k) : (k = $3e38f8b30e4a2ada$var$Zf(c) ? $3e38f8b30e4a2ada$var$Xf : $3e38f8b30e4a2ada$var$H.current, k = $3e38f8b30e4a2ada$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3e38f8b30e4a2ada$var$Hi(b, g, d, k);
        $3e38f8b30e4a2ada$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $3e38f8b30e4a2ada$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3e38f8b30e4a2ada$var$Wf.current || $3e38f8b30e4a2ada$var$jh ? ("function" === typeof y && ($3e38f8b30e4a2ada$var$Di(b, c, y, d), n = b.memoizedState), (l = $3e38f8b30e4a2ada$var$jh || $3e38f8b30e4a2ada$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3e38f8b30e4a2ada$var$jj(a, b, c, d, f, e);
}
function $3e38f8b30e4a2ada$var$jj(a, b, c, d, e, f) {
    $3e38f8b30e4a2ada$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3e38f8b30e4a2ada$var$dg(b, c, !1), $3e38f8b30e4a2ada$var$Zi(a, b, f);
    d = b.stateNode;
    $3e38f8b30e4a2ada$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3e38f8b30e4a2ada$var$Ug(b, a.child, null, f), b.child = $3e38f8b30e4a2ada$var$Ug(b, null, h, f)) : $3e38f8b30e4a2ada$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3e38f8b30e4a2ada$var$dg(b, c, !0);
    return b.child;
}
function $3e38f8b30e4a2ada$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3e38f8b30e4a2ada$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3e38f8b30e4a2ada$var$ag(a, b.context, !1);
    $3e38f8b30e4a2ada$var$yh(a, b.containerInfo);
}
function $3e38f8b30e4a2ada$var$lj(a, b, c, d, e) {
    $3e38f8b30e4a2ada$var$Ig();
    $3e38f8b30e4a2ada$var$Jg(e);
    b.flags |= 256;
    $3e38f8b30e4a2ada$var$Xi(a, b, c, d);
    return b.child;
}
var $3e38f8b30e4a2ada$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3e38f8b30e4a2ada$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3e38f8b30e4a2ada$var$oj(a, b, c) {
    var d = b.pendingProps, e = $3e38f8b30e4a2ada$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, e & 1);
    if (null === a) {
        $3e38f8b30e4a2ada$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3e38f8b30e4a2ada$var$pj(g, d, 0, null), a = $3e38f8b30e4a2ada$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3e38f8b30e4a2ada$var$nj(c), b.memoizedState = $3e38f8b30e4a2ada$var$mj, a) : $3e38f8b30e4a2ada$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3e38f8b30e4a2ada$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3e38f8b30e4a2ada$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3e38f8b30e4a2ada$var$Pg(h, f) : (f = $3e38f8b30e4a2ada$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3e38f8b30e4a2ada$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3e38f8b30e4a2ada$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3e38f8b30e4a2ada$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3e38f8b30e4a2ada$var$qj(a, b) {
    b = $3e38f8b30e4a2ada$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3e38f8b30e4a2ada$var$sj(a, b, c, d) {
    null !== d && $3e38f8b30e4a2ada$var$Jg(d);
    $3e38f8b30e4a2ada$var$Ug(b, a.child, null, c);
    a = $3e38f8b30e4a2ada$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3e38f8b30e4a2ada$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3e38f8b30e4a2ada$var$Ki(Error($3e38f8b30e4a2ada$var$p(422))), $3e38f8b30e4a2ada$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3e38f8b30e4a2ada$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3e38f8b30e4a2ada$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3e38f8b30e4a2ada$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $3e38f8b30e4a2ada$var$nj(g);
        b.memoizedState = $3e38f8b30e4a2ada$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3e38f8b30e4a2ada$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3e38f8b30e4a2ada$var$p(419));
        d = $3e38f8b30e4a2ada$var$Ki(f, d, void 0);
        return $3e38f8b30e4a2ada$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3e38f8b30e4a2ada$var$dh || h) {
        d = $3e38f8b30e4a2ada$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3e38f8b30e4a2ada$var$ih(a, e), $3e38f8b30e4a2ada$var$gi(d, a, e, -1));
        }
        $3e38f8b30e4a2ada$var$tj();
        d = $3e38f8b30e4a2ada$var$Ki(Error($3e38f8b30e4a2ada$var$p(421)));
        return $3e38f8b30e4a2ada$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3e38f8b30e4a2ada$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3e38f8b30e4a2ada$var$yg = $3e38f8b30e4a2ada$var$Lf(e.nextSibling);
    $3e38f8b30e4a2ada$var$xg = b;
    $3e38f8b30e4a2ada$var$I = !0;
    $3e38f8b30e4a2ada$var$zg = null;
    null !== a && ($3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg++] = $3e38f8b30e4a2ada$var$rg, $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg++] = $3e38f8b30e4a2ada$var$sg, $3e38f8b30e4a2ada$var$og[$3e38f8b30e4a2ada$var$pg++] = $3e38f8b30e4a2ada$var$qg, $3e38f8b30e4a2ada$var$rg = a.id, $3e38f8b30e4a2ada$var$sg = a.overflow, $3e38f8b30e4a2ada$var$qg = b);
    b = $3e38f8b30e4a2ada$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3e38f8b30e4a2ada$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3e38f8b30e4a2ada$var$bh(a.return, b, c);
}
function $3e38f8b30e4a2ada$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3e38f8b30e4a2ada$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3e38f8b30e4a2ada$var$Xi(a, b, d.children, c);
    d = $3e38f8b30e4a2ada$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3e38f8b30e4a2ada$var$vj(a, c, b);
            else if (19 === a.tag) $3e38f8b30e4a2ada$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3e38f8b30e4a2ada$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3e38f8b30e4a2ada$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3e38f8b30e4a2ada$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3e38f8b30e4a2ada$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $3e38f8b30e4a2ada$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3e38f8b30e4a2ada$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3e38f8b30e4a2ada$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3e38f8b30e4a2ada$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3e38f8b30e4a2ada$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3e38f8b30e4a2ada$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3e38f8b30e4a2ada$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3e38f8b30e4a2ada$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $3e38f8b30e4a2ada$var$kj(b);
            $3e38f8b30e4a2ada$var$Ig();
            break;
        case 5:
            $3e38f8b30e4a2ada$var$Ah(b);
            break;
        case 1:
            $3e38f8b30e4a2ada$var$Zf(b.type) && $3e38f8b30e4a2ada$var$cg(b);
            break;
        case 4:
            $3e38f8b30e4a2ada$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, $3e38f8b30e4a2ada$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3e38f8b30e4a2ada$var$oj(a, b, c);
                $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, $3e38f8b30e4a2ada$var$L.current & 1);
                a = $3e38f8b30e4a2ada$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, $3e38f8b30e4a2ada$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3e38f8b30e4a2ada$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, $3e38f8b30e4a2ada$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3e38f8b30e4a2ada$var$dj(a, b, c);
    }
    return $3e38f8b30e4a2ada$var$Zi(a, b, c);
}
var $3e38f8b30e4a2ada$var$zj, $3e38f8b30e4a2ada$var$Aj, $3e38f8b30e4a2ada$var$Bj, $3e38f8b30e4a2ada$var$Cj;
$3e38f8b30e4a2ada$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3e38f8b30e4a2ada$var$Aj = function() {};
$3e38f8b30e4a2ada$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3e38f8b30e4a2ada$var$Ya(a, e);
                d = $3e38f8b30e4a2ada$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3e38f8b30e4a2ada$var$A({}, e, {
                    value: void 0
                });
                d = $3e38f8b30e4a2ada$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3e38f8b30e4a2ada$var$gb(a, e);
                d = $3e38f8b30e4a2ada$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3e38f8b30e4a2ada$var$Bf);
        }
        $3e38f8b30e4a2ada$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3e38f8b30e4a2ada$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3e38f8b30e4a2ada$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3e38f8b30e4a2ada$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3e38f8b30e4a2ada$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3e38f8b30e4a2ada$var$Dj(a, b) {
    if (!$3e38f8b30e4a2ada$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3e38f8b30e4a2ada$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3e38f8b30e4a2ada$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $3e38f8b30e4a2ada$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3e38f8b30e4a2ada$var$S(b), null;
        case 1:
            return $3e38f8b30e4a2ada$var$Zf(b.type) && $3e38f8b30e4a2ada$var$$f(), $3e38f8b30e4a2ada$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3e38f8b30e4a2ada$var$zh();
            $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wf);
            $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$H);
            $3e38f8b30e4a2ada$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3e38f8b30e4a2ada$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3e38f8b30e4a2ada$var$zg && ($3e38f8b30e4a2ada$var$Fj($3e38f8b30e4a2ada$var$zg), $3e38f8b30e4a2ada$var$zg = null));
            $3e38f8b30e4a2ada$var$Aj(a, b);
            $3e38f8b30e4a2ada$var$S(b);
            return null;
        case 5:
            $3e38f8b30e4a2ada$var$Bh(b);
            var e = $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3e38f8b30e4a2ada$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3e38f8b30e4a2ada$var$p(166));
                    $3e38f8b30e4a2ada$var$S(b);
                    return null;
                }
                a = $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$uh.current);
                if ($3e38f8b30e4a2ada$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3e38f8b30e4a2ada$var$Of] = b;
                    d[$3e38f8b30e4a2ada$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3e38f8b30e4a2ada$var$D("cancel", d);
                            $3e38f8b30e4a2ada$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3e38f8b30e4a2ada$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3e38f8b30e4a2ada$var$lf.length; e++)$3e38f8b30e4a2ada$var$D($3e38f8b30e4a2ada$var$lf[e], d);
                            break;
                        case "source":
                            $3e38f8b30e4a2ada$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3e38f8b30e4a2ada$var$D("error", d);
                            $3e38f8b30e4a2ada$var$D("load", d);
                            break;
                        case "details":
                            $3e38f8b30e4a2ada$var$D("toggle", d);
                            break;
                        case "input":
                            $3e38f8b30e4a2ada$var$Za(d, f);
                            $3e38f8b30e4a2ada$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3e38f8b30e4a2ada$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3e38f8b30e4a2ada$var$hb(d, f), $3e38f8b30e4a2ada$var$D("invalid", d);
                    }
                    $3e38f8b30e4a2ada$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3e38f8b30e4a2ada$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3e38f8b30e4a2ada$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3e38f8b30e4a2ada$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3e38f8b30e4a2ada$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3e38f8b30e4a2ada$var$Va(d);
                            $3e38f8b30e4a2ada$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3e38f8b30e4a2ada$var$Va(d);
                            $3e38f8b30e4a2ada$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3e38f8b30e4a2ada$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3e38f8b30e4a2ada$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3e38f8b30e4a2ada$var$Of] = b;
                    a[$3e38f8b30e4a2ada$var$Pf] = d;
                    $3e38f8b30e4a2ada$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3e38f8b30e4a2ada$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3e38f8b30e4a2ada$var$D("cancel", a);
                                $3e38f8b30e4a2ada$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3e38f8b30e4a2ada$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3e38f8b30e4a2ada$var$lf.length; e++)$3e38f8b30e4a2ada$var$D($3e38f8b30e4a2ada$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3e38f8b30e4a2ada$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3e38f8b30e4a2ada$var$D("error", a);
                                $3e38f8b30e4a2ada$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3e38f8b30e4a2ada$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3e38f8b30e4a2ada$var$Za(a, d);
                                e = $3e38f8b30e4a2ada$var$Ya(a, d);
                                $3e38f8b30e4a2ada$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3e38f8b30e4a2ada$var$A({}, d, {
                                    value: void 0
                                });
                                $3e38f8b30e4a2ada$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3e38f8b30e4a2ada$var$hb(a, d);
                                e = $3e38f8b30e4a2ada$var$gb(a, d);
                                $3e38f8b30e4a2ada$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3e38f8b30e4a2ada$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3e38f8b30e4a2ada$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3e38f8b30e4a2ada$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3e38f8b30e4a2ada$var$ob(a, k) : "number" === typeof k && $3e38f8b30e4a2ada$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3e38f8b30e4a2ada$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3e38f8b30e4a2ada$var$D("scroll", a) : null != k && $3e38f8b30e4a2ada$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3e38f8b30e4a2ada$var$Va(a);
                                $3e38f8b30e4a2ada$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3e38f8b30e4a2ada$var$Va(a);
                                $3e38f8b30e4a2ada$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3e38f8b30e4a2ada$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3e38f8b30e4a2ada$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3e38f8b30e4a2ada$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3e38f8b30e4a2ada$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3e38f8b30e4a2ada$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3e38f8b30e4a2ada$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3e38f8b30e4a2ada$var$p(166));
                c = $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$wh.current);
                $3e38f8b30e4a2ada$var$xh($3e38f8b30e4a2ada$var$uh.current);
                if ($3e38f8b30e4a2ada$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3e38f8b30e4a2ada$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3e38f8b30e4a2ada$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3e38f8b30e4a2ada$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3e38f8b30e4a2ada$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3e38f8b30e4a2ada$var$Of] = b, b.stateNode = d;
            }
            $3e38f8b30e4a2ada$var$S(b);
            return null;
        case 13:
            $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3e38f8b30e4a2ada$var$I && null !== $3e38f8b30e4a2ada$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3e38f8b30e4a2ada$var$Hg(), $3e38f8b30e4a2ada$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3e38f8b30e4a2ada$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3e38f8b30e4a2ada$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3e38f8b30e4a2ada$var$p(317));
                        f[$3e38f8b30e4a2ada$var$Of] = b;
                    } else $3e38f8b30e4a2ada$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3e38f8b30e4a2ada$var$S(b);
                    f = !1;
                } else null !== $3e38f8b30e4a2ada$var$zg && ($3e38f8b30e4a2ada$var$Fj($3e38f8b30e4a2ada$var$zg), $3e38f8b30e4a2ada$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3e38f8b30e4a2ada$var$L.current & 1) ? 0 === $3e38f8b30e4a2ada$var$T && ($3e38f8b30e4a2ada$var$T = 3) : $3e38f8b30e4a2ada$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3e38f8b30e4a2ada$var$S(b);
            return null;
        case 4:
            return $3e38f8b30e4a2ada$var$zh(), $3e38f8b30e4a2ada$var$Aj(a, b), null === a && $3e38f8b30e4a2ada$var$sf(b.stateNode.containerInfo), $3e38f8b30e4a2ada$var$S(b), null;
        case 10:
            return $3e38f8b30e4a2ada$var$ah(b.type._context), $3e38f8b30e4a2ada$var$S(b), null;
        case 17:
            return $3e38f8b30e4a2ada$var$Zf(b.type) && $3e38f8b30e4a2ada$var$$f(), $3e38f8b30e4a2ada$var$S(b), null;
        case 19:
            $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$L);
            f = b.memoizedState;
            if (null === f) return $3e38f8b30e4a2ada$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3e38f8b30e4a2ada$var$Dj(f, !1);
                else {
                    if (0 !== $3e38f8b30e4a2ada$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3e38f8b30e4a2ada$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3e38f8b30e4a2ada$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, $3e38f8b30e4a2ada$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3e38f8b30e4a2ada$var$B() > $3e38f8b30e4a2ada$var$Gj && (b.flags |= 128, d = !0, $3e38f8b30e4a2ada$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3e38f8b30e4a2ada$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3e38f8b30e4a2ada$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3e38f8b30e4a2ada$var$I) return $3e38f8b30e4a2ada$var$S(b), null;
                    } else 2 * $3e38f8b30e4a2ada$var$B() - f.renderingStartTime > $3e38f8b30e4a2ada$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $3e38f8b30e4a2ada$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3e38f8b30e4a2ada$var$B(), b.sibling = null, c = $3e38f8b30e4a2ada$var$L.current, $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$L, d ? c & 1 | 2 : c & 1), b;
            $3e38f8b30e4a2ada$var$S(b);
            return null;
        case 22:
        case 23:
            return $3e38f8b30e4a2ada$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3e38f8b30e4a2ada$var$fj & 1073741824) && ($3e38f8b30e4a2ada$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3e38f8b30e4a2ada$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3e38f8b30e4a2ada$var$p(156, b.tag));
}
function $3e38f8b30e4a2ada$var$Ij(a, b) {
    $3e38f8b30e4a2ada$var$wg(b);
    switch(b.tag){
        case 1:
            return $3e38f8b30e4a2ada$var$Zf(b.type) && $3e38f8b30e4a2ada$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3e38f8b30e4a2ada$var$zh(), $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wf), $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$H), $3e38f8b30e4a2ada$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3e38f8b30e4a2ada$var$Bh(b), null;
        case 13:
            $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3e38f8b30e4a2ada$var$p(340));
                $3e38f8b30e4a2ada$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$L), null;
        case 4:
            return $3e38f8b30e4a2ada$var$zh(), null;
        case 10:
            return $3e38f8b30e4a2ada$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $3e38f8b30e4a2ada$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3e38f8b30e4a2ada$var$Jj = !1, $3e38f8b30e4a2ada$var$U = !1, $3e38f8b30e4a2ada$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $3e38f8b30e4a2ada$var$V = null;
function $3e38f8b30e4a2ada$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3e38f8b30e4a2ada$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3e38f8b30e4a2ada$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3e38f8b30e4a2ada$var$W(a, b, d);
    }
}
var $3e38f8b30e4a2ada$var$Nj = !1;
function $3e38f8b30e4a2ada$var$Oj(a, b) {
    $3e38f8b30e4a2ada$var$Cf = $3e38f8b30e4a2ada$var$dd;
    a = $3e38f8b30e4a2ada$var$Me();
    if ($3e38f8b30e4a2ada$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3e38f8b30e4a2ada$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3e38f8b30e4a2ada$var$dd = !1;
    for($3e38f8b30e4a2ada$var$V = b; null !== $3e38f8b30e4a2ada$var$V;)if (b = $3e38f8b30e4a2ada$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3e38f8b30e4a2ada$var$V = a;
    else for(; null !== $3e38f8b30e4a2ada$var$V;){
        b = $3e38f8b30e4a2ada$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3e38f8b30e4a2ada$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3e38f8b30e4a2ada$var$p(163));
            }
        } catch (F) {
            $3e38f8b30e4a2ada$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3e38f8b30e4a2ada$var$V = a;
            break;
        }
        $3e38f8b30e4a2ada$var$V = b.return;
    }
    n = $3e38f8b30e4a2ada$var$Nj;
    $3e38f8b30e4a2ada$var$Nj = !1;
    return n;
}
function $3e38f8b30e4a2ada$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3e38f8b30e4a2ada$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3e38f8b30e4a2ada$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3e38f8b30e4a2ada$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3e38f8b30e4a2ada$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3e38f8b30e4a2ada$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3e38f8b30e4a2ada$var$Of], delete b[$3e38f8b30e4a2ada$var$Pf], delete b[$3e38f8b30e4a2ada$var$of], delete b[$3e38f8b30e4a2ada$var$Qf], delete b[$3e38f8b30e4a2ada$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3e38f8b30e4a2ada$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3e38f8b30e4a2ada$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3e38f8b30e4a2ada$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3e38f8b30e4a2ada$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3e38f8b30e4a2ada$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3e38f8b30e4a2ada$var$Vj(a, b, c), a = a.sibling; null !== a;)$3e38f8b30e4a2ada$var$Vj(a, b, c), a = a.sibling;
}
function $3e38f8b30e4a2ada$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3e38f8b30e4a2ada$var$Wj(a, b, c), a = a.sibling; null !== a;)$3e38f8b30e4a2ada$var$Wj(a, b, c), a = a.sibling;
}
var $3e38f8b30e4a2ada$var$X = null, $3e38f8b30e4a2ada$var$Xj = !1;
function $3e38f8b30e4a2ada$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$3e38f8b30e4a2ada$var$Zj(a, b, c), c = c.sibling;
}
function $3e38f8b30e4a2ada$var$Zj(a, b, c) {
    if ($3e38f8b30e4a2ada$var$lc && "function" === typeof $3e38f8b30e4a2ada$var$lc.onCommitFiberUnmount) try {
        $3e38f8b30e4a2ada$var$lc.onCommitFiberUnmount($3e38f8b30e4a2ada$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3e38f8b30e4a2ada$var$U || $3e38f8b30e4a2ada$var$Lj(c, b);
        case 6:
            var d = $3e38f8b30e4a2ada$var$X, e = $3e38f8b30e4a2ada$var$Xj;
            $3e38f8b30e4a2ada$var$X = null;
            $3e38f8b30e4a2ada$var$Yj(a, b, c);
            $3e38f8b30e4a2ada$var$X = d;
            $3e38f8b30e4a2ada$var$Xj = e;
            null !== $3e38f8b30e4a2ada$var$X && ($3e38f8b30e4a2ada$var$Xj ? (a = $3e38f8b30e4a2ada$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3e38f8b30e4a2ada$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3e38f8b30e4a2ada$var$X && ($3e38f8b30e4a2ada$var$Xj ? (a = $3e38f8b30e4a2ada$var$X, c = c.stateNode, 8 === a.nodeType ? $3e38f8b30e4a2ada$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3e38f8b30e4a2ada$var$Kf(a, c), $3e38f8b30e4a2ada$var$bd(a)) : $3e38f8b30e4a2ada$var$Kf($3e38f8b30e4a2ada$var$X, c.stateNode));
            break;
        case 4:
            d = $3e38f8b30e4a2ada$var$X;
            e = $3e38f8b30e4a2ada$var$Xj;
            $3e38f8b30e4a2ada$var$X = c.stateNode.containerInfo;
            $3e38f8b30e4a2ada$var$Xj = !0;
            $3e38f8b30e4a2ada$var$Yj(a, b, c);
            $3e38f8b30e4a2ada$var$X = d;
            $3e38f8b30e4a2ada$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3e38f8b30e4a2ada$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3e38f8b30e4a2ada$var$Mj(c, b, g) : 0 !== (f & 4) && $3e38f8b30e4a2ada$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3e38f8b30e4a2ada$var$Yj(a, b, c);
            break;
        case 1:
            if (!$3e38f8b30e4a2ada$var$U && ($3e38f8b30e4a2ada$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3e38f8b30e4a2ada$var$W(c, b, h);
            }
            $3e38f8b30e4a2ada$var$Yj(a, b, c);
            break;
        case 21:
            $3e38f8b30e4a2ada$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3e38f8b30e4a2ada$var$U = (d = $3e38f8b30e4a2ada$var$U) || null !== c.memoizedState, $3e38f8b30e4a2ada$var$Yj(a, b, c), $3e38f8b30e4a2ada$var$U = d) : $3e38f8b30e4a2ada$var$Yj(a, b, c);
            break;
        default:
            $3e38f8b30e4a2ada$var$Yj(a, b, c);
    }
}
function $3e38f8b30e4a2ada$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3e38f8b30e4a2ada$var$Kj);
        b.forEach(function(b) {
            var d = $3e38f8b30e4a2ada$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3e38f8b30e4a2ada$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3e38f8b30e4a2ada$var$X = h.stateNode;
                        $3e38f8b30e4a2ada$var$Xj = !1;
                        break a;
                    case 3:
                        $3e38f8b30e4a2ada$var$X = h.stateNode.containerInfo;
                        $3e38f8b30e4a2ada$var$Xj = !0;
                        break a;
                    case 4:
                        $3e38f8b30e4a2ada$var$X = h.stateNode.containerInfo;
                        $3e38f8b30e4a2ada$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3e38f8b30e4a2ada$var$X) throw Error($3e38f8b30e4a2ada$var$p(160));
            $3e38f8b30e4a2ada$var$Zj(f, g, e);
            $3e38f8b30e4a2ada$var$X = null;
            $3e38f8b30e4a2ada$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3e38f8b30e4a2ada$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3e38f8b30e4a2ada$var$dk(b, a), b = b.sibling;
}
function $3e38f8b30e4a2ada$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            if (d & 4) {
                try {
                    $3e38f8b30e4a2ada$var$Pj(3, a, a.return), $3e38f8b30e4a2ada$var$Qj(3, a);
                } catch (t) {
                    $3e38f8b30e4a2ada$var$W(a, a.return, t);
                }
                try {
                    $3e38f8b30e4a2ada$var$Pj(5, a, a.return);
                } catch (t) {
                    $3e38f8b30e4a2ada$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            d & 512 && null !== c && $3e38f8b30e4a2ada$var$Lj(c, c.return);
            break;
        case 5:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            d & 512 && null !== c && $3e38f8b30e4a2ada$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3e38f8b30e4a2ada$var$ob(e, "");
                } catch (t) {
                    $3e38f8b30e4a2ada$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3e38f8b30e4a2ada$var$ab(e, f);
                    $3e38f8b30e4a2ada$var$vb(h, g);
                    var l = $3e38f8b30e4a2ada$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3e38f8b30e4a2ada$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3e38f8b30e4a2ada$var$nb(e, q) : "children" === m ? $3e38f8b30e4a2ada$var$ob(e, q) : $3e38f8b30e4a2ada$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3e38f8b30e4a2ada$var$bb(e, f);
                            break;
                        case "textarea":
                            $3e38f8b30e4a2ada$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3e38f8b30e4a2ada$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3e38f8b30e4a2ada$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3e38f8b30e4a2ada$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3e38f8b30e4a2ada$var$Pf] = f;
                } catch (t) {
                    $3e38f8b30e4a2ada$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3e38f8b30e4a2ada$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3e38f8b30e4a2ada$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3e38f8b30e4a2ada$var$bd(b.containerInfo);
            } catch (t) {
                $3e38f8b30e4a2ada$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            break;
        case 13:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3e38f8b30e4a2ada$var$fk = $3e38f8b30e4a2ada$var$B()));
            d & 4 && $3e38f8b30e4a2ada$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3e38f8b30e4a2ada$var$U = (l = $3e38f8b30e4a2ada$var$U) || m, $3e38f8b30e4a2ada$var$ck(b, a), $3e38f8b30e4a2ada$var$U = l) : $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3e38f8b30e4a2ada$var$V = a, m = a.child; null !== m;){
                    for(q = $3e38f8b30e4a2ada$var$V = m; null !== $3e38f8b30e4a2ada$var$V;){
                        r = $3e38f8b30e4a2ada$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3e38f8b30e4a2ada$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $3e38f8b30e4a2ada$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3e38f8b30e4a2ada$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3e38f8b30e4a2ada$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3e38f8b30e4a2ada$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3e38f8b30e4a2ada$var$V = y) : $3e38f8b30e4a2ada$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3e38f8b30e4a2ada$var$rb("display", g));
                            } catch (t) {
                                $3e38f8b30e4a2ada$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3e38f8b30e4a2ada$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3e38f8b30e4a2ada$var$ck(b, a);
            $3e38f8b30e4a2ada$var$ek(a);
            d & 4 && $3e38f8b30e4a2ada$var$ak(a);
            break;
        case 21:
            break;
        default:
            $3e38f8b30e4a2ada$var$ck(b, a), $3e38f8b30e4a2ada$var$ek(a);
    }
}
function $3e38f8b30e4a2ada$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3e38f8b30e4a2ada$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3e38f8b30e4a2ada$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3e38f8b30e4a2ada$var$ob(e, ""), d.flags &= -33);
                    var f = $3e38f8b30e4a2ada$var$Uj(a);
                    $3e38f8b30e4a2ada$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3e38f8b30e4a2ada$var$Uj(a);
                    $3e38f8b30e4a2ada$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($3e38f8b30e4a2ada$var$p(161));
            }
        } catch (k) {
            $3e38f8b30e4a2ada$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3e38f8b30e4a2ada$var$hk(a, b, c) {
    $3e38f8b30e4a2ada$var$V = a;
    $3e38f8b30e4a2ada$var$ik(a, b, c);
}
function $3e38f8b30e4a2ada$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3e38f8b30e4a2ada$var$V;){
        var e = $3e38f8b30e4a2ada$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3e38f8b30e4a2ada$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3e38f8b30e4a2ada$var$U;
                h = $3e38f8b30e4a2ada$var$Jj;
                var l = $3e38f8b30e4a2ada$var$U;
                $3e38f8b30e4a2ada$var$Jj = g;
                if (($3e38f8b30e4a2ada$var$U = k) && !l) for($3e38f8b30e4a2ada$var$V = e; null !== $3e38f8b30e4a2ada$var$V;)g = $3e38f8b30e4a2ada$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3e38f8b30e4a2ada$var$jk(e) : null !== k ? (k.return = g, $3e38f8b30e4a2ada$var$V = k) : $3e38f8b30e4a2ada$var$jk(e);
                for(; null !== f;)$3e38f8b30e4a2ada$var$V = f, $3e38f8b30e4a2ada$var$ik(f, b, c), f = f.sibling;
                $3e38f8b30e4a2ada$var$V = e;
                $3e38f8b30e4a2ada$var$Jj = h;
                $3e38f8b30e4a2ada$var$U = l;
            }
            $3e38f8b30e4a2ada$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3e38f8b30e4a2ada$var$V = f) : $3e38f8b30e4a2ada$var$kk(a, b, c);
    }
}
function $3e38f8b30e4a2ada$var$kk(a) {
    for(; null !== $3e38f8b30e4a2ada$var$V;){
        var b = $3e38f8b30e4a2ada$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3e38f8b30e4a2ada$var$U || $3e38f8b30e4a2ada$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3e38f8b30e4a2ada$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3e38f8b30e4a2ada$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3e38f8b30e4a2ada$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3e38f8b30e4a2ada$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3e38f8b30e4a2ada$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3e38f8b30e4a2ada$var$p(163));
                }
                $3e38f8b30e4a2ada$var$U || b.flags & 512 && $3e38f8b30e4a2ada$var$Rj(b);
            } catch (r) {
                $3e38f8b30e4a2ada$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3e38f8b30e4a2ada$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3e38f8b30e4a2ada$var$V = c;
            break;
        }
        $3e38f8b30e4a2ada$var$V = b.return;
    }
}
function $3e38f8b30e4a2ada$var$gk(a) {
    for(; null !== $3e38f8b30e4a2ada$var$V;){
        var b = $3e38f8b30e4a2ada$var$V;
        if (b === a) {
            $3e38f8b30e4a2ada$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3e38f8b30e4a2ada$var$V = c;
            break;
        }
        $3e38f8b30e4a2ada$var$V = b.return;
    }
}
function $3e38f8b30e4a2ada$var$jk(a) {
    for(; null !== $3e38f8b30e4a2ada$var$V;){
        var b = $3e38f8b30e4a2ada$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3e38f8b30e4a2ada$var$Qj(4, b);
                    } catch (k) {
                        $3e38f8b30e4a2ada$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3e38f8b30e4a2ada$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3e38f8b30e4a2ada$var$Rj(b);
                    } catch (k) {
                        $3e38f8b30e4a2ada$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3e38f8b30e4a2ada$var$Rj(b);
                    } catch (k) {
                        $3e38f8b30e4a2ada$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3e38f8b30e4a2ada$var$W(b, b.return, k);
        }
        if (b === a) {
            $3e38f8b30e4a2ada$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3e38f8b30e4a2ada$var$V = h;
            break;
        }
        $3e38f8b30e4a2ada$var$V = b.return;
    }
}
var $3e38f8b30e4a2ada$var$lk = Math.ceil, $3e38f8b30e4a2ada$var$mk = $3e38f8b30e4a2ada$var$ua.ReactCurrentDispatcher, $3e38f8b30e4a2ada$var$nk = $3e38f8b30e4a2ada$var$ua.ReactCurrentOwner, $3e38f8b30e4a2ada$var$ok = $3e38f8b30e4a2ada$var$ua.ReactCurrentBatchConfig, $3e38f8b30e4a2ada$var$K = 0, $3e38f8b30e4a2ada$var$Q = null, $3e38f8b30e4a2ada$var$Y = null, $3e38f8b30e4a2ada$var$Z = 0, $3e38f8b30e4a2ada$var$fj = 0, $3e38f8b30e4a2ada$var$ej = $3e38f8b30e4a2ada$var$Uf(0), $3e38f8b30e4a2ada$var$T = 0, $3e38f8b30e4a2ada$var$pk = null, $3e38f8b30e4a2ada$var$rh = 0, $3e38f8b30e4a2ada$var$qk = 0, $3e38f8b30e4a2ada$var$rk = 0, $3e38f8b30e4a2ada$var$sk = null, $3e38f8b30e4a2ada$var$tk = null, $3e38f8b30e4a2ada$var$fk = 0, $3e38f8b30e4a2ada$var$Gj = Infinity, $3e38f8b30e4a2ada$var$uk = null, $3e38f8b30e4a2ada$var$Oi = !1, $3e38f8b30e4a2ada$var$Pi = null, $3e38f8b30e4a2ada$var$Ri = null, $3e38f8b30e4a2ada$var$vk = !1, $3e38f8b30e4a2ada$var$wk = null, $3e38f8b30e4a2ada$var$xk = 0, $3e38f8b30e4a2ada$var$yk = 0, $3e38f8b30e4a2ada$var$zk = null, $3e38f8b30e4a2ada$var$Ak = -1, $3e38f8b30e4a2ada$var$Bk = 0;
function $3e38f8b30e4a2ada$var$R() {
    return 0 !== ($3e38f8b30e4a2ada$var$K & 6) ? $3e38f8b30e4a2ada$var$B() : -1 !== $3e38f8b30e4a2ada$var$Ak ? $3e38f8b30e4a2ada$var$Ak : $3e38f8b30e4a2ada$var$Ak = $3e38f8b30e4a2ada$var$B();
}
function $3e38f8b30e4a2ada$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3e38f8b30e4a2ada$var$K & 2) && 0 !== $3e38f8b30e4a2ada$var$Z) return $3e38f8b30e4a2ada$var$Z & -$3e38f8b30e4a2ada$var$Z;
    if (null !== $3e38f8b30e4a2ada$var$Kg.transition) return 0 === $3e38f8b30e4a2ada$var$Bk && ($3e38f8b30e4a2ada$var$Bk = $3e38f8b30e4a2ada$var$yc()), $3e38f8b30e4a2ada$var$Bk;
    a = $3e38f8b30e4a2ada$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3e38f8b30e4a2ada$var$jd(a.type);
    return a;
}
function $3e38f8b30e4a2ada$var$gi(a, b, c, d) {
    if (50 < $3e38f8b30e4a2ada$var$yk) throw $3e38f8b30e4a2ada$var$yk = 0, $3e38f8b30e4a2ada$var$zk = null, Error($3e38f8b30e4a2ada$var$p(185));
    $3e38f8b30e4a2ada$var$Ac(a, c, d);
    if (0 === ($3e38f8b30e4a2ada$var$K & 2) || a !== $3e38f8b30e4a2ada$var$Q) a === $3e38f8b30e4a2ada$var$Q && (0 === ($3e38f8b30e4a2ada$var$K & 2) && ($3e38f8b30e4a2ada$var$qk |= c), 4 === $3e38f8b30e4a2ada$var$T && $3e38f8b30e4a2ada$var$Ck(a, $3e38f8b30e4a2ada$var$Z)), $3e38f8b30e4a2ada$var$Dk(a, d), 1 === c && 0 === $3e38f8b30e4a2ada$var$K && 0 === (b.mode & 1) && ($3e38f8b30e4a2ada$var$Gj = $3e38f8b30e4a2ada$var$B() + 500, $3e38f8b30e4a2ada$var$fg && $3e38f8b30e4a2ada$var$jg());
}
function $3e38f8b30e4a2ada$var$Dk(a, b) {
    var c = a.callbackNode;
    $3e38f8b30e4a2ada$var$wc(a, b);
    var d = $3e38f8b30e4a2ada$var$uc(a, a === $3e38f8b30e4a2ada$var$Q ? $3e38f8b30e4a2ada$var$Z : 0);
    if (0 === d) null !== c && $3e38f8b30e4a2ada$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3e38f8b30e4a2ada$var$bc(c);
        if (1 === b) 0 === a.tag ? $3e38f8b30e4a2ada$var$ig($3e38f8b30e4a2ada$var$Ek.bind(null, a)) : $3e38f8b30e4a2ada$var$hg($3e38f8b30e4a2ada$var$Ek.bind(null, a)), $3e38f8b30e4a2ada$var$Jf(function() {
            0 === ($3e38f8b30e4a2ada$var$K & 6) && $3e38f8b30e4a2ada$var$jg();
        }), c = null;
        else {
            switch($3e38f8b30e4a2ada$var$Dc(d)){
                case 1:
                    c = $3e38f8b30e4a2ada$var$fc;
                    break;
                case 4:
                    c = $3e38f8b30e4a2ada$var$gc;
                    break;
                case 16:
                    c = $3e38f8b30e4a2ada$var$hc;
                    break;
                case 536870912:
                    c = $3e38f8b30e4a2ada$var$jc;
                    break;
                default:
                    c = $3e38f8b30e4a2ada$var$hc;
            }
            c = $3e38f8b30e4a2ada$var$Fk(c, $3e38f8b30e4a2ada$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3e38f8b30e4a2ada$var$Gk(a, b) {
    $3e38f8b30e4a2ada$var$Ak = -1;
    $3e38f8b30e4a2ada$var$Bk = 0;
    if (0 !== ($3e38f8b30e4a2ada$var$K & 6)) throw Error($3e38f8b30e4a2ada$var$p(327));
    var c = a.callbackNode;
    if ($3e38f8b30e4a2ada$var$Hk() && a.callbackNode !== c) return null;
    var d = $3e38f8b30e4a2ada$var$uc(a, a === $3e38f8b30e4a2ada$var$Q ? $3e38f8b30e4a2ada$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3e38f8b30e4a2ada$var$Ik(a, d);
    else {
        b = d;
        var e = $3e38f8b30e4a2ada$var$K;
        $3e38f8b30e4a2ada$var$K |= 2;
        var f = $3e38f8b30e4a2ada$var$Jk();
        if ($3e38f8b30e4a2ada$var$Q !== a || $3e38f8b30e4a2ada$var$Z !== b) $3e38f8b30e4a2ada$var$uk = null, $3e38f8b30e4a2ada$var$Gj = $3e38f8b30e4a2ada$var$B() + 500, $3e38f8b30e4a2ada$var$Kk(a, b);
        for(;;)try {
            $3e38f8b30e4a2ada$var$Lk();
            break;
        } catch (h) {
            $3e38f8b30e4a2ada$var$Mk(a, h);
        }
        $3e38f8b30e4a2ada$var$$g();
        $3e38f8b30e4a2ada$var$mk.current = f;
        $3e38f8b30e4a2ada$var$K = e;
        null !== $3e38f8b30e4a2ada$var$Y ? b = 0 : ($3e38f8b30e4a2ada$var$Q = null, $3e38f8b30e4a2ada$var$Z = 0, b = $3e38f8b30e4a2ada$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3e38f8b30e4a2ada$var$xc(a), 0 !== e && (d = e, b = $3e38f8b30e4a2ada$var$Nk(a, e)));
        if (1 === b) throw c = $3e38f8b30e4a2ada$var$pk, $3e38f8b30e4a2ada$var$Kk(a, 0), $3e38f8b30e4a2ada$var$Ck(a, d), $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B()), c;
        if (6 === b) $3e38f8b30e4a2ada$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3e38f8b30e4a2ada$var$Ok(e) && (b = $3e38f8b30e4a2ada$var$Ik(a, d), 2 === b && (f = $3e38f8b30e4a2ada$var$xc(a), 0 !== f && (d = f, b = $3e38f8b30e4a2ada$var$Nk(a, f))), 1 === b)) throw c = $3e38f8b30e4a2ada$var$pk, $3e38f8b30e4a2ada$var$Kk(a, 0), $3e38f8b30e4a2ada$var$Ck(a, d), $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3e38f8b30e4a2ada$var$p(345));
                case 2:
                    $3e38f8b30e4a2ada$var$Pk(a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk);
                    break;
                case 3:
                    $3e38f8b30e4a2ada$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $3e38f8b30e4a2ada$var$fk + 500 - $3e38f8b30e4a2ada$var$B(), 10 < b)) {
                        if (0 !== $3e38f8b30e4a2ada$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3e38f8b30e4a2ada$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3e38f8b30e4a2ada$var$Ff($3e38f8b30e4a2ada$var$Pk.bind(null, a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk), b);
                        break;
                    }
                    $3e38f8b30e4a2ada$var$Pk(a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk);
                    break;
                case 4:
                    $3e38f8b30e4a2ada$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3e38f8b30e4a2ada$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3e38f8b30e4a2ada$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3e38f8b30e4a2ada$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3e38f8b30e4a2ada$var$Ff($3e38f8b30e4a2ada$var$Pk.bind(null, a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk), d);
                        break;
                    }
                    $3e38f8b30e4a2ada$var$Pk(a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk);
                    break;
                case 5:
                    $3e38f8b30e4a2ada$var$Pk(a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk);
                    break;
                default:
                    throw Error($3e38f8b30e4a2ada$var$p(329));
            }
        }
    }
    $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B());
    return a.callbackNode === c ? $3e38f8b30e4a2ada$var$Gk.bind(null, a) : null;
}
function $3e38f8b30e4a2ada$var$Nk(a, b) {
    var c = $3e38f8b30e4a2ada$var$sk;
    a.current.memoizedState.isDehydrated && ($3e38f8b30e4a2ada$var$Kk(a, b).flags |= 256);
    a = $3e38f8b30e4a2ada$var$Ik(a, b);
    2 !== a && (b = $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$tk = c, null !== b && $3e38f8b30e4a2ada$var$Fj(b));
    return a;
}
function $3e38f8b30e4a2ada$var$Fj(a) {
    null === $3e38f8b30e4a2ada$var$tk ? $3e38f8b30e4a2ada$var$tk = a : $3e38f8b30e4a2ada$var$tk.push.apply($3e38f8b30e4a2ada$var$tk, a);
}
function $3e38f8b30e4a2ada$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3e38f8b30e4a2ada$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3e38f8b30e4a2ada$var$Ck(a, b) {
    b &= ~$3e38f8b30e4a2ada$var$rk;
    b &= ~$3e38f8b30e4a2ada$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3e38f8b30e4a2ada$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3e38f8b30e4a2ada$var$Ek(a) {
    if (0 !== ($3e38f8b30e4a2ada$var$K & 6)) throw Error($3e38f8b30e4a2ada$var$p(327));
    $3e38f8b30e4a2ada$var$Hk();
    var b = $3e38f8b30e4a2ada$var$uc(a, 0);
    if (0 === (b & 1)) return $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B()), null;
    var c = $3e38f8b30e4a2ada$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3e38f8b30e4a2ada$var$xc(a);
        0 !== d && (b = d, c = $3e38f8b30e4a2ada$var$Nk(a, d));
    }
    if (1 === c) throw c = $3e38f8b30e4a2ada$var$pk, $3e38f8b30e4a2ada$var$Kk(a, 0), $3e38f8b30e4a2ada$var$Ck(a, b), $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B()), c;
    if (6 === c) throw Error($3e38f8b30e4a2ada$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3e38f8b30e4a2ada$var$Pk(a, $3e38f8b30e4a2ada$var$tk, $3e38f8b30e4a2ada$var$uk);
    $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B());
    return null;
}
function $3e38f8b30e4a2ada$var$Qk(a, b) {
    var c = $3e38f8b30e4a2ada$var$K;
    $3e38f8b30e4a2ada$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3e38f8b30e4a2ada$var$K = c, 0 === $3e38f8b30e4a2ada$var$K && ($3e38f8b30e4a2ada$var$Gj = $3e38f8b30e4a2ada$var$B() + 500, $3e38f8b30e4a2ada$var$fg && $3e38f8b30e4a2ada$var$jg());
    }
}
function $3e38f8b30e4a2ada$var$Rk(a) {
    null !== $3e38f8b30e4a2ada$var$wk && 0 === $3e38f8b30e4a2ada$var$wk.tag && 0 === ($3e38f8b30e4a2ada$var$K & 6) && $3e38f8b30e4a2ada$var$Hk();
    var b = $3e38f8b30e4a2ada$var$K;
    $3e38f8b30e4a2ada$var$K |= 1;
    var c = $3e38f8b30e4a2ada$var$ok.transition, d = $3e38f8b30e4a2ada$var$C;
    try {
        if ($3e38f8b30e4a2ada$var$ok.transition = null, $3e38f8b30e4a2ada$var$C = 1, a) return a();
    } finally{
        $3e38f8b30e4a2ada$var$C = d, $3e38f8b30e4a2ada$var$ok.transition = c, $3e38f8b30e4a2ada$var$K = b, 0 === ($3e38f8b30e4a2ada$var$K & 6) && $3e38f8b30e4a2ada$var$jg();
    }
}
function $3e38f8b30e4a2ada$var$Hj() {
    $3e38f8b30e4a2ada$var$fj = $3e38f8b30e4a2ada$var$ej.current;
    $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$ej);
}
function $3e38f8b30e4a2ada$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3e38f8b30e4a2ada$var$Gf(c));
    if (null !== $3e38f8b30e4a2ada$var$Y) for(c = $3e38f8b30e4a2ada$var$Y.return; null !== c;){
        var d = c;
        $3e38f8b30e4a2ada$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3e38f8b30e4a2ada$var$$f();
                break;
            case 3:
                $3e38f8b30e4a2ada$var$zh();
                $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$Wf);
                $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$H);
                $3e38f8b30e4a2ada$var$Eh();
                break;
            case 5:
                $3e38f8b30e4a2ada$var$Bh(d);
                break;
            case 4:
                $3e38f8b30e4a2ada$var$zh();
                break;
            case 13:
                $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$L);
                break;
            case 19:
                $3e38f8b30e4a2ada$var$E($3e38f8b30e4a2ada$var$L);
                break;
            case 10:
                $3e38f8b30e4a2ada$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $3e38f8b30e4a2ada$var$Hj();
        }
        c = c.return;
    }
    $3e38f8b30e4a2ada$var$Q = a;
    $3e38f8b30e4a2ada$var$Y = a = $3e38f8b30e4a2ada$var$Pg(a.current, null);
    $3e38f8b30e4a2ada$var$Z = $3e38f8b30e4a2ada$var$fj = b;
    $3e38f8b30e4a2ada$var$T = 0;
    $3e38f8b30e4a2ada$var$pk = null;
    $3e38f8b30e4a2ada$var$rk = $3e38f8b30e4a2ada$var$qk = $3e38f8b30e4a2ada$var$rh = 0;
    $3e38f8b30e4a2ada$var$tk = $3e38f8b30e4a2ada$var$sk = null;
    if (null !== $3e38f8b30e4a2ada$var$fh) {
        for(b = 0; b < $3e38f8b30e4a2ada$var$fh.length; b++)if (c = $3e38f8b30e4a2ada$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3e38f8b30e4a2ada$var$fh = null;
    }
    return a;
}
function $3e38f8b30e4a2ada$var$Mk(a, b) {
    do {
        var c = $3e38f8b30e4a2ada$var$Y;
        try {
            $3e38f8b30e4a2ada$var$$g();
            $3e38f8b30e4a2ada$var$Fh.current = $3e38f8b30e4a2ada$var$Rh;
            if ($3e38f8b30e4a2ada$var$Ih) {
                for(var d = $3e38f8b30e4a2ada$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3e38f8b30e4a2ada$var$Ih = !1;
            }
            $3e38f8b30e4a2ada$var$Hh = 0;
            $3e38f8b30e4a2ada$var$O = $3e38f8b30e4a2ada$var$N = $3e38f8b30e4a2ada$var$M = null;
            $3e38f8b30e4a2ada$var$Jh = !1;
            $3e38f8b30e4a2ada$var$Kh = 0;
            $3e38f8b30e4a2ada$var$nk.current = null;
            if (null === c || null === c.return) {
                $3e38f8b30e4a2ada$var$T = 1;
                $3e38f8b30e4a2ada$var$pk = b;
                $3e38f8b30e4a2ada$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3e38f8b30e4a2ada$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3e38f8b30e4a2ada$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3e38f8b30e4a2ada$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $3e38f8b30e4a2ada$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3e38f8b30e4a2ada$var$Si(f, l, b);
                            $3e38f8b30e4a2ada$var$tj();
                            break a;
                        }
                        k = Error($3e38f8b30e4a2ada$var$p(426));
                    }
                } else if ($3e38f8b30e4a2ada$var$I && h.mode & 1) {
                    var J = $3e38f8b30e4a2ada$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3e38f8b30e4a2ada$var$Vi(J, g, h, f, b);
                        $3e38f8b30e4a2ada$var$Jg($3e38f8b30e4a2ada$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $3e38f8b30e4a2ada$var$Ji(k, h);
                4 !== $3e38f8b30e4a2ada$var$T && ($3e38f8b30e4a2ada$var$T = 2);
                null === $3e38f8b30e4a2ada$var$sk ? $3e38f8b30e4a2ada$var$sk = [
                    f
                ] : $3e38f8b30e4a2ada$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3e38f8b30e4a2ada$var$Ni(f, k, b);
                            $3e38f8b30e4a2ada$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3e38f8b30e4a2ada$var$Ri || !$3e38f8b30e4a2ada$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3e38f8b30e4a2ada$var$Qi(f, h, b);
                                $3e38f8b30e4a2ada$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3e38f8b30e4a2ada$var$Sk(c);
        } catch (na) {
            b = na;
            $3e38f8b30e4a2ada$var$Y === c && null !== c && ($3e38f8b30e4a2ada$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3e38f8b30e4a2ada$var$Jk() {
    var a = $3e38f8b30e4a2ada$var$mk.current;
    $3e38f8b30e4a2ada$var$mk.current = $3e38f8b30e4a2ada$var$Rh;
    return null === a ? $3e38f8b30e4a2ada$var$Rh : a;
}
function $3e38f8b30e4a2ada$var$tj() {
    if (0 === $3e38f8b30e4a2ada$var$T || 3 === $3e38f8b30e4a2ada$var$T || 2 === $3e38f8b30e4a2ada$var$T) $3e38f8b30e4a2ada$var$T = 4;
    null === $3e38f8b30e4a2ada$var$Q || 0 === ($3e38f8b30e4a2ada$var$rh & 268435455) && 0 === ($3e38f8b30e4a2ada$var$qk & 268435455) || $3e38f8b30e4a2ada$var$Ck($3e38f8b30e4a2ada$var$Q, $3e38f8b30e4a2ada$var$Z);
}
function $3e38f8b30e4a2ada$var$Ik(a, b) {
    var c = $3e38f8b30e4a2ada$var$K;
    $3e38f8b30e4a2ada$var$K |= 2;
    var d = $3e38f8b30e4a2ada$var$Jk();
    if ($3e38f8b30e4a2ada$var$Q !== a || $3e38f8b30e4a2ada$var$Z !== b) $3e38f8b30e4a2ada$var$uk = null, $3e38f8b30e4a2ada$var$Kk(a, b);
    for(;;)try {
        $3e38f8b30e4a2ada$var$Tk();
        break;
    } catch (e) {
        $3e38f8b30e4a2ada$var$Mk(a, e);
    }
    $3e38f8b30e4a2ada$var$$g();
    $3e38f8b30e4a2ada$var$K = c;
    $3e38f8b30e4a2ada$var$mk.current = d;
    if (null !== $3e38f8b30e4a2ada$var$Y) throw Error($3e38f8b30e4a2ada$var$p(261));
    $3e38f8b30e4a2ada$var$Q = null;
    $3e38f8b30e4a2ada$var$Z = 0;
    return $3e38f8b30e4a2ada$var$T;
}
function $3e38f8b30e4a2ada$var$Tk() {
    for(; null !== $3e38f8b30e4a2ada$var$Y;)$3e38f8b30e4a2ada$var$Uk($3e38f8b30e4a2ada$var$Y);
}
function $3e38f8b30e4a2ada$var$Lk() {
    for(; null !== $3e38f8b30e4a2ada$var$Y && !$3e38f8b30e4a2ada$var$cc();)$3e38f8b30e4a2ada$var$Uk($3e38f8b30e4a2ada$var$Y);
}
function $3e38f8b30e4a2ada$var$Uk(a) {
    var b = $3e38f8b30e4a2ada$var$Vk(a.alternate, a, $3e38f8b30e4a2ada$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3e38f8b30e4a2ada$var$Sk(a) : $3e38f8b30e4a2ada$var$Y = b;
    $3e38f8b30e4a2ada$var$nk.current = null;
}
function $3e38f8b30e4a2ada$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3e38f8b30e4a2ada$var$Ej(c, b, $3e38f8b30e4a2ada$var$fj), null !== c) {
                $3e38f8b30e4a2ada$var$Y = c;
                return;
            }
        } else {
            c = $3e38f8b30e4a2ada$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3e38f8b30e4a2ada$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3e38f8b30e4a2ada$var$T = 6;
                $3e38f8b30e4a2ada$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3e38f8b30e4a2ada$var$Y = b;
            return;
        }
        $3e38f8b30e4a2ada$var$Y = b = a;
    }while (null !== b);
    0 === $3e38f8b30e4a2ada$var$T && ($3e38f8b30e4a2ada$var$T = 5);
}
function $3e38f8b30e4a2ada$var$Pk(a, b, c) {
    var d = $3e38f8b30e4a2ada$var$C, e = $3e38f8b30e4a2ada$var$ok.transition;
    try {
        $3e38f8b30e4a2ada$var$ok.transition = null, $3e38f8b30e4a2ada$var$C = 1, $3e38f8b30e4a2ada$var$Wk(a, b, c, d);
    } finally{
        $3e38f8b30e4a2ada$var$ok.transition = e, $3e38f8b30e4a2ada$var$C = d;
    }
    return null;
}
function $3e38f8b30e4a2ada$var$Wk(a, b, c, d) {
    do $3e38f8b30e4a2ada$var$Hk();
    while (null !== $3e38f8b30e4a2ada$var$wk);
    if (0 !== ($3e38f8b30e4a2ada$var$K & 6)) throw Error($3e38f8b30e4a2ada$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3e38f8b30e4a2ada$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3e38f8b30e4a2ada$var$Bc(a, f);
    a === $3e38f8b30e4a2ada$var$Q && ($3e38f8b30e4a2ada$var$Y = $3e38f8b30e4a2ada$var$Q = null, $3e38f8b30e4a2ada$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3e38f8b30e4a2ada$var$vk || ($3e38f8b30e4a2ada$var$vk = !0, $3e38f8b30e4a2ada$var$Fk($3e38f8b30e4a2ada$var$hc, function() {
        $3e38f8b30e4a2ada$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3e38f8b30e4a2ada$var$ok.transition;
        $3e38f8b30e4a2ada$var$ok.transition = null;
        var g = $3e38f8b30e4a2ada$var$C;
        $3e38f8b30e4a2ada$var$C = 1;
        var h = $3e38f8b30e4a2ada$var$K;
        $3e38f8b30e4a2ada$var$K |= 4;
        $3e38f8b30e4a2ada$var$nk.current = null;
        $3e38f8b30e4a2ada$var$Oj(a, c);
        $3e38f8b30e4a2ada$var$dk(c, a);
        $3e38f8b30e4a2ada$var$Oe($3e38f8b30e4a2ada$var$Df);
        $3e38f8b30e4a2ada$var$dd = !!$3e38f8b30e4a2ada$var$Cf;
        $3e38f8b30e4a2ada$var$Df = $3e38f8b30e4a2ada$var$Cf = null;
        a.current = c;
        $3e38f8b30e4a2ada$var$hk(c, a, e);
        $3e38f8b30e4a2ada$var$dc();
        $3e38f8b30e4a2ada$var$K = h;
        $3e38f8b30e4a2ada$var$C = g;
        $3e38f8b30e4a2ada$var$ok.transition = f;
    } else a.current = c;
    $3e38f8b30e4a2ada$var$vk && ($3e38f8b30e4a2ada$var$vk = !1, $3e38f8b30e4a2ada$var$wk = a, $3e38f8b30e4a2ada$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($3e38f8b30e4a2ada$var$Ri = null);
    $3e38f8b30e4a2ada$var$mc(c.stateNode, d);
    $3e38f8b30e4a2ada$var$Dk(a, $3e38f8b30e4a2ada$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3e38f8b30e4a2ada$var$Oi) throw $3e38f8b30e4a2ada$var$Oi = !1, a = $3e38f8b30e4a2ada$var$Pi, $3e38f8b30e4a2ada$var$Pi = null, a;
    0 !== ($3e38f8b30e4a2ada$var$xk & 1) && 0 !== a.tag && $3e38f8b30e4a2ada$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3e38f8b30e4a2ada$var$zk ? $3e38f8b30e4a2ada$var$yk++ : ($3e38f8b30e4a2ada$var$yk = 0, $3e38f8b30e4a2ada$var$zk = a) : $3e38f8b30e4a2ada$var$yk = 0;
    $3e38f8b30e4a2ada$var$jg();
    return null;
}
function $3e38f8b30e4a2ada$var$Hk() {
    if (null !== $3e38f8b30e4a2ada$var$wk) {
        var a = $3e38f8b30e4a2ada$var$Dc($3e38f8b30e4a2ada$var$xk), b = $3e38f8b30e4a2ada$var$ok.transition, c = $3e38f8b30e4a2ada$var$C;
        try {
            $3e38f8b30e4a2ada$var$ok.transition = null;
            $3e38f8b30e4a2ada$var$C = 16 > a ? 16 : a;
            if (null === $3e38f8b30e4a2ada$var$wk) var d = !1;
            else {
                a = $3e38f8b30e4a2ada$var$wk;
                $3e38f8b30e4a2ada$var$wk = null;
                $3e38f8b30e4a2ada$var$xk = 0;
                if (0 !== ($3e38f8b30e4a2ada$var$K & 6)) throw Error($3e38f8b30e4a2ada$var$p(331));
                var e = $3e38f8b30e4a2ada$var$K;
                $3e38f8b30e4a2ada$var$K |= 4;
                for($3e38f8b30e4a2ada$var$V = a.current; null !== $3e38f8b30e4a2ada$var$V;){
                    var f = $3e38f8b30e4a2ada$var$V, g = f.child;
                    if (0 !== ($3e38f8b30e4a2ada$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3e38f8b30e4a2ada$var$V = l; null !== $3e38f8b30e4a2ada$var$V;){
                                    var m = $3e38f8b30e4a2ada$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3e38f8b30e4a2ada$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3e38f8b30e4a2ada$var$V = q;
                                    else for(; null !== $3e38f8b30e4a2ada$var$V;){
                                        m = $3e38f8b30e4a2ada$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3e38f8b30e4a2ada$var$Sj(m);
                                        if (m === l) {
                                            $3e38f8b30e4a2ada$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3e38f8b30e4a2ada$var$V = r;
                                            break;
                                        }
                                        $3e38f8b30e4a2ada$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3e38f8b30e4a2ada$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3e38f8b30e4a2ada$var$V = g;
                    else b: for(; null !== $3e38f8b30e4a2ada$var$V;){
                        f = $3e38f8b30e4a2ada$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3e38f8b30e4a2ada$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3e38f8b30e4a2ada$var$V = x;
                            break b;
                        }
                        $3e38f8b30e4a2ada$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3e38f8b30e4a2ada$var$V = w; null !== $3e38f8b30e4a2ada$var$V;){
                    g = $3e38f8b30e4a2ada$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3e38f8b30e4a2ada$var$V = u;
                    else b: for(g = w; null !== $3e38f8b30e4a2ada$var$V;){
                        h = $3e38f8b30e4a2ada$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3e38f8b30e4a2ada$var$Qj(9, h);
                            }
                        } catch (na) {
                            $3e38f8b30e4a2ada$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3e38f8b30e4a2ada$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3e38f8b30e4a2ada$var$V = F;
                            break b;
                        }
                        $3e38f8b30e4a2ada$var$V = h.return;
                    }
                }
                $3e38f8b30e4a2ada$var$K = e;
                $3e38f8b30e4a2ada$var$jg();
                if ($3e38f8b30e4a2ada$var$lc && "function" === typeof $3e38f8b30e4a2ada$var$lc.onPostCommitFiberRoot) try {
                    $3e38f8b30e4a2ada$var$lc.onPostCommitFiberRoot($3e38f8b30e4a2ada$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3e38f8b30e4a2ada$var$C = c, $3e38f8b30e4a2ada$var$ok.transition = b;
        }
    }
    return !1;
}
function $3e38f8b30e4a2ada$var$Xk(a, b, c) {
    b = $3e38f8b30e4a2ada$var$Ji(c, b);
    b = $3e38f8b30e4a2ada$var$Ni(a, b, 1);
    a = $3e38f8b30e4a2ada$var$nh(a, b, 1);
    b = $3e38f8b30e4a2ada$var$R();
    null !== a && ($3e38f8b30e4a2ada$var$Ac(a, 1, b), $3e38f8b30e4a2ada$var$Dk(a, b));
}
function $3e38f8b30e4a2ada$var$W(a, b, c) {
    if (3 === a.tag) $3e38f8b30e4a2ada$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3e38f8b30e4a2ada$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3e38f8b30e4a2ada$var$Ri || !$3e38f8b30e4a2ada$var$Ri.has(d))) {
                a = $3e38f8b30e4a2ada$var$Ji(c, a);
                a = $3e38f8b30e4a2ada$var$Qi(b, a, 1);
                b = $3e38f8b30e4a2ada$var$nh(b, a, 1);
                a = $3e38f8b30e4a2ada$var$R();
                null !== b && ($3e38f8b30e4a2ada$var$Ac(b, 1, a), $3e38f8b30e4a2ada$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3e38f8b30e4a2ada$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3e38f8b30e4a2ada$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $3e38f8b30e4a2ada$var$Q === a && ($3e38f8b30e4a2ada$var$Z & c) === c && (4 === $3e38f8b30e4a2ada$var$T || 3 === $3e38f8b30e4a2ada$var$T && ($3e38f8b30e4a2ada$var$Z & 130023424) === $3e38f8b30e4a2ada$var$Z && 500 > $3e38f8b30e4a2ada$var$B() - $3e38f8b30e4a2ada$var$fk ? $3e38f8b30e4a2ada$var$Kk(a, 0) : $3e38f8b30e4a2ada$var$rk |= c);
    $3e38f8b30e4a2ada$var$Dk(a, b);
}
function $3e38f8b30e4a2ada$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3e38f8b30e4a2ada$var$sc, $3e38f8b30e4a2ada$var$sc <<= 1, 0 === ($3e38f8b30e4a2ada$var$sc & 130023424) && ($3e38f8b30e4a2ada$var$sc = 4194304)));
    var c = $3e38f8b30e4a2ada$var$R();
    a = $3e38f8b30e4a2ada$var$ih(a, b);
    null !== a && ($3e38f8b30e4a2ada$var$Ac(a, b, c), $3e38f8b30e4a2ada$var$Dk(a, c));
}
function $3e38f8b30e4a2ada$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3e38f8b30e4a2ada$var$Yk(a, c);
}
function $3e38f8b30e4a2ada$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3e38f8b30e4a2ada$var$p(314));
    }
    null !== d && d.delete(b);
    $3e38f8b30e4a2ada$var$Yk(a, c);
}
var $3e38f8b30e4a2ada$var$Vk;
$3e38f8b30e4a2ada$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3e38f8b30e4a2ada$var$Wf.current) $3e38f8b30e4a2ada$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3e38f8b30e4a2ada$var$dh = !1, $3e38f8b30e4a2ada$var$yj(a, b, c);
            $3e38f8b30e4a2ada$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3e38f8b30e4a2ada$var$dh = !1, $3e38f8b30e4a2ada$var$I && 0 !== (b.flags & 1048576) && $3e38f8b30e4a2ada$var$ug(b, $3e38f8b30e4a2ada$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3e38f8b30e4a2ada$var$ij(a, b);
            a = b.pendingProps;
            var e = $3e38f8b30e4a2ada$var$Yf(b, $3e38f8b30e4a2ada$var$H.current);
            $3e38f8b30e4a2ada$var$ch(b, c);
            e = $3e38f8b30e4a2ada$var$Nh(null, b, d, a, e, c);
            var f = $3e38f8b30e4a2ada$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3e38f8b30e4a2ada$var$Zf(d) ? (f = !0, $3e38f8b30e4a2ada$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3e38f8b30e4a2ada$var$kh(b), e.updater = $3e38f8b30e4a2ada$var$Ei, b.stateNode = e, e._reactInternals = b, $3e38f8b30e4a2ada$var$Ii(b, d, a, c), b = $3e38f8b30e4a2ada$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $3e38f8b30e4a2ada$var$I && f && $3e38f8b30e4a2ada$var$vg(b), $3e38f8b30e4a2ada$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3e38f8b30e4a2ada$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3e38f8b30e4a2ada$var$Zk(d);
                a = $3e38f8b30e4a2ada$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $3e38f8b30e4a2ada$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3e38f8b30e4a2ada$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3e38f8b30e4a2ada$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3e38f8b30e4a2ada$var$$i(null, b, d, $3e38f8b30e4a2ada$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($3e38f8b30e4a2ada$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3e38f8b30e4a2ada$var$Ci(d, e), $3e38f8b30e4a2ada$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3e38f8b30e4a2ada$var$Ci(d, e), $3e38f8b30e4a2ada$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $3e38f8b30e4a2ada$var$kj(b);
                if (null === a) throw Error($3e38f8b30e4a2ada$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3e38f8b30e4a2ada$var$lh(a, b);
                $3e38f8b30e4a2ada$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3e38f8b30e4a2ada$var$Ji(Error($3e38f8b30e4a2ada$var$p(423)), b);
                        b = $3e38f8b30e4a2ada$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3e38f8b30e4a2ada$var$Ji(Error($3e38f8b30e4a2ada$var$p(424)), b);
                        b = $3e38f8b30e4a2ada$var$lj(a, b, d, c, e);
                        break a;
                    } else for($3e38f8b30e4a2ada$var$yg = $3e38f8b30e4a2ada$var$Lf(b.stateNode.containerInfo.firstChild), $3e38f8b30e4a2ada$var$xg = b, $3e38f8b30e4a2ada$var$I = !0, $3e38f8b30e4a2ada$var$zg = null, c = $3e38f8b30e4a2ada$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3e38f8b30e4a2ada$var$Ig();
                    if (d === e) {
                        b = $3e38f8b30e4a2ada$var$Zi(a, b, c);
                        break a;
                    }
                    $3e38f8b30e4a2ada$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3e38f8b30e4a2ada$var$Ah(b), null === a && $3e38f8b30e4a2ada$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3e38f8b30e4a2ada$var$Ef(d, e) ? g = null : null !== f && $3e38f8b30e4a2ada$var$Ef(d, f) && (b.flags |= 32), $3e38f8b30e4a2ada$var$gj(a, b), $3e38f8b30e4a2ada$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $3e38f8b30e4a2ada$var$Eg(b), null;
        case 13:
            return $3e38f8b30e4a2ada$var$oj(a, b, c);
        case 4:
            return $3e38f8b30e4a2ada$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3e38f8b30e4a2ada$var$Ug(b, null, d, c) : $3e38f8b30e4a2ada$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3e38f8b30e4a2ada$var$Ci(d, e), $3e38f8b30e4a2ada$var$Yi(a, b, d, e, c);
        case 7:
            return $3e38f8b30e4a2ada$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3e38f8b30e4a2ada$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3e38f8b30e4a2ada$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3e38f8b30e4a2ada$var$G($3e38f8b30e4a2ada$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3e38f8b30e4a2ada$var$He(f.value, g)) {
                        if (f.children === e.children && !$3e38f8b30e4a2ada$var$Wf.current) {
                            b = $3e38f8b30e4a2ada$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3e38f8b30e4a2ada$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3e38f8b30e4a2ada$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3e38f8b30e4a2ada$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3e38f8b30e4a2ada$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3e38f8b30e4a2ada$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3e38f8b30e4a2ada$var$ch(b, c), e = $3e38f8b30e4a2ada$var$eh(e), d = d(e), b.flags |= 1, $3e38f8b30e4a2ada$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3e38f8b30e4a2ada$var$Ci(d, b.pendingProps), e = $3e38f8b30e4a2ada$var$Ci(d.type, e), $3e38f8b30e4a2ada$var$$i(a, b, d, e, c);
        case 15:
            return $3e38f8b30e4a2ada$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3e38f8b30e4a2ada$var$Ci(d, e), $3e38f8b30e4a2ada$var$ij(a, b), b.tag = 1, $3e38f8b30e4a2ada$var$Zf(d) ? (a = !0, $3e38f8b30e4a2ada$var$cg(b)) : a = !1, $3e38f8b30e4a2ada$var$ch(b, c), $3e38f8b30e4a2ada$var$Gi(b, d, e), $3e38f8b30e4a2ada$var$Ii(b, d, e, c), $3e38f8b30e4a2ada$var$jj(null, b, d, !0, a, c);
        case 19:
            return $3e38f8b30e4a2ada$var$xj(a, b, c);
        case 22:
            return $3e38f8b30e4a2ada$var$dj(a, b, c);
    }
    throw Error($3e38f8b30e4a2ada$var$p(156, b.tag));
};
function $3e38f8b30e4a2ada$var$Fk(a, b) {
    return $3e38f8b30e4a2ada$var$ac(a, b);
}
function $3e38f8b30e4a2ada$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3e38f8b30e4a2ada$var$Bg(a, b, c, d) {
    return new $3e38f8b30e4a2ada$var$$k(a, b, c, d);
}
function $3e38f8b30e4a2ada$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3e38f8b30e4a2ada$var$Zk(a) {
    if ("function" === typeof a) return $3e38f8b30e4a2ada$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3e38f8b30e4a2ada$var$Da) return 11;
        if (a === $3e38f8b30e4a2ada$var$Ga) return 14;
    }
    return 2;
}
function $3e38f8b30e4a2ada$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $3e38f8b30e4a2ada$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3e38f8b30e4a2ada$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3e38f8b30e4a2ada$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3e38f8b30e4a2ada$var$ya:
            return $3e38f8b30e4a2ada$var$Tg(c.children, e, f, b);
        case $3e38f8b30e4a2ada$var$za:
            g = 8;
            e |= 8;
            break;
        case $3e38f8b30e4a2ada$var$Aa:
            return a = $3e38f8b30e4a2ada$var$Bg(12, c, b, e | 2), a.elementType = $3e38f8b30e4a2ada$var$Aa, a.lanes = f, a;
        case $3e38f8b30e4a2ada$var$Ea:
            return a = $3e38f8b30e4a2ada$var$Bg(13, c, b, e), a.elementType = $3e38f8b30e4a2ada$var$Ea, a.lanes = f, a;
        case $3e38f8b30e4a2ada$var$Fa:
            return a = $3e38f8b30e4a2ada$var$Bg(19, c, b, e), a.elementType = $3e38f8b30e4a2ada$var$Fa, a.lanes = f, a;
        case $3e38f8b30e4a2ada$var$Ia:
            return $3e38f8b30e4a2ada$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3e38f8b30e4a2ada$var$Ba:
                    g = 10;
                    break a;
                case $3e38f8b30e4a2ada$var$Ca:
                    g = 9;
                    break a;
                case $3e38f8b30e4a2ada$var$Da:
                    g = 11;
                    break a;
                case $3e38f8b30e4a2ada$var$Ga:
                    g = 14;
                    break a;
                case $3e38f8b30e4a2ada$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3e38f8b30e4a2ada$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3e38f8b30e4a2ada$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3e38f8b30e4a2ada$var$Tg(a, b, c, d) {
    a = $3e38f8b30e4a2ada$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3e38f8b30e4a2ada$var$pj(a, b, c, d) {
    a = $3e38f8b30e4a2ada$var$Bg(22, a, d, b);
    a.elementType = $3e38f8b30e4a2ada$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3e38f8b30e4a2ada$var$Qg(a, b, c) {
    a = $3e38f8b30e4a2ada$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3e38f8b30e4a2ada$var$Sg(a, b, c) {
    b = $3e38f8b30e4a2ada$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3e38f8b30e4a2ada$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3e38f8b30e4a2ada$var$zc(0);
    this.expirationTimes = $3e38f8b30e4a2ada$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3e38f8b30e4a2ada$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3e38f8b30e4a2ada$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $3e38f8b30e4a2ada$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3e38f8b30e4a2ada$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3e38f8b30e4a2ada$var$kh(f);
    return a;
}
function $3e38f8b30e4a2ada$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3e38f8b30e4a2ada$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3e38f8b30e4a2ada$var$dl(a) {
    if (!a) return $3e38f8b30e4a2ada$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3e38f8b30e4a2ada$var$Vb(a) !== a || 1 !== a.tag) throw Error($3e38f8b30e4a2ada$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3e38f8b30e4a2ada$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3e38f8b30e4a2ada$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3e38f8b30e4a2ada$var$Zf(c)) return $3e38f8b30e4a2ada$var$bg(a, c, b);
    }
    return b;
}
function $3e38f8b30e4a2ada$var$el(a, b, c, d, e, f, g, h, k) {
    a = $3e38f8b30e4a2ada$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $3e38f8b30e4a2ada$var$dl(null);
    c = a.current;
    d = $3e38f8b30e4a2ada$var$R();
    e = $3e38f8b30e4a2ada$var$yi(c);
    f = $3e38f8b30e4a2ada$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3e38f8b30e4a2ada$var$nh(c, f, e);
    a.current.lanes = e;
    $3e38f8b30e4a2ada$var$Ac(a, e, d);
    $3e38f8b30e4a2ada$var$Dk(a, d);
    return a;
}
function $3e38f8b30e4a2ada$var$fl(a, b, c, d) {
    var e = b.current, f = $3e38f8b30e4a2ada$var$R(), g = $3e38f8b30e4a2ada$var$yi(e);
    c = $3e38f8b30e4a2ada$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3e38f8b30e4a2ada$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3e38f8b30e4a2ada$var$nh(e, b, g);
    null !== a && ($3e38f8b30e4a2ada$var$gi(a, e, g, f), $3e38f8b30e4a2ada$var$oh(a, e, g));
    return g;
}
function $3e38f8b30e4a2ada$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3e38f8b30e4a2ada$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3e38f8b30e4a2ada$var$il(a, b) {
    $3e38f8b30e4a2ada$var$hl(a, b);
    (a = a.alternate) && $3e38f8b30e4a2ada$var$hl(a, b);
}
function $3e38f8b30e4a2ada$var$jl() {
    return null;
}
var $3e38f8b30e4a2ada$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3e38f8b30e4a2ada$var$ll(a) {
    this._internalRoot = a;
}
$3e38f8b30e4a2ada$var$ml.prototype.render = $3e38f8b30e4a2ada$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3e38f8b30e4a2ada$var$p(409));
    $3e38f8b30e4a2ada$var$fl(a, b, null, null);
};
$3e38f8b30e4a2ada$var$ml.prototype.unmount = $3e38f8b30e4a2ada$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3e38f8b30e4a2ada$var$Rk(function() {
            $3e38f8b30e4a2ada$var$fl(null, a, null, null);
        });
        b[$3e38f8b30e4a2ada$var$uf] = null;
    }
};
function $3e38f8b30e4a2ada$var$ml(a) {
    this._internalRoot = a;
}
$3e38f8b30e4a2ada$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3e38f8b30e4a2ada$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3e38f8b30e4a2ada$var$Qc.length && 0 !== b && b < $3e38f8b30e4a2ada$var$Qc[c].priority; c++);
        $3e38f8b30e4a2ada$var$Qc.splice(c, 0, a);
        0 === c && $3e38f8b30e4a2ada$var$Vc(a);
    }
};
function $3e38f8b30e4a2ada$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3e38f8b30e4a2ada$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3e38f8b30e4a2ada$var$pl() {}
function $3e38f8b30e4a2ada$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3e38f8b30e4a2ada$var$gl(g);
                f.call(a);
            };
        }
        var g = $3e38f8b30e4a2ada$var$el(b, d, a, 0, null, !1, !1, "", $3e38f8b30e4a2ada$var$pl);
        a._reactRootContainer = g;
        a[$3e38f8b30e4a2ada$var$uf] = g.current;
        $3e38f8b30e4a2ada$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3e38f8b30e4a2ada$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3e38f8b30e4a2ada$var$gl(k);
            h.call(a);
        };
    }
    var k = $3e38f8b30e4a2ada$var$bl(a, 0, !1, null, null, !1, !1, "", $3e38f8b30e4a2ada$var$pl);
    a._reactRootContainer = k;
    a[$3e38f8b30e4a2ada$var$uf] = k.current;
    $3e38f8b30e4a2ada$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3e38f8b30e4a2ada$var$Rk(function() {
        $3e38f8b30e4a2ada$var$fl(b, k, c, d);
    });
    return k;
}
function $3e38f8b30e4a2ada$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3e38f8b30e4a2ada$var$gl(g);
                h.call(a);
            };
        }
        $3e38f8b30e4a2ada$var$fl(b, g, a, e);
    } else g = $3e38f8b30e4a2ada$var$ql(c, b, a, e, d);
    return $3e38f8b30e4a2ada$var$gl(g);
}
$3e38f8b30e4a2ada$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3e38f8b30e4a2ada$var$tc(b.pendingLanes);
                0 !== c && ($3e38f8b30e4a2ada$var$Cc(b, c | 1), $3e38f8b30e4a2ada$var$Dk(b, $3e38f8b30e4a2ada$var$B()), 0 === ($3e38f8b30e4a2ada$var$K & 6) && ($3e38f8b30e4a2ada$var$Gj = $3e38f8b30e4a2ada$var$B() + 500, $3e38f8b30e4a2ada$var$jg()));
            }
            break;
        case 13:
            $3e38f8b30e4a2ada$var$Rk(function() {
                var b = $3e38f8b30e4a2ada$var$ih(a, 1);
                if (null !== b) {
                    var c = $3e38f8b30e4a2ada$var$R();
                    $3e38f8b30e4a2ada$var$gi(b, a, 1, c);
                }
            }), $3e38f8b30e4a2ada$var$il(a, 1);
    }
};
$3e38f8b30e4a2ada$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $3e38f8b30e4a2ada$var$ih(a, 134217728);
        if (null !== b) {
            var c = $3e38f8b30e4a2ada$var$R();
            $3e38f8b30e4a2ada$var$gi(b, a, 134217728, c);
        }
        $3e38f8b30e4a2ada$var$il(a, 134217728);
    }
};
$3e38f8b30e4a2ada$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $3e38f8b30e4a2ada$var$yi(a), c = $3e38f8b30e4a2ada$var$ih(a, b);
        if (null !== c) {
            var d = $3e38f8b30e4a2ada$var$R();
            $3e38f8b30e4a2ada$var$gi(c, a, b, d);
        }
        $3e38f8b30e4a2ada$var$il(a, b);
    }
};
$3e38f8b30e4a2ada$var$Hc = function() {
    return $3e38f8b30e4a2ada$var$C;
};
$3e38f8b30e4a2ada$var$Ic = function(a, b) {
    var c = $3e38f8b30e4a2ada$var$C;
    try {
        return $3e38f8b30e4a2ada$var$C = a, b();
    } finally{
        $3e38f8b30e4a2ada$var$C = c;
    }
};
$3e38f8b30e4a2ada$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3e38f8b30e4a2ada$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3e38f8b30e4a2ada$var$Db(d);
                        if (!e) throw Error($3e38f8b30e4a2ada$var$p(90));
                        $3e38f8b30e4a2ada$var$Wa(d);
                        $3e38f8b30e4a2ada$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3e38f8b30e4a2ada$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3e38f8b30e4a2ada$var$fb(a, !!c.multiple, b, !1);
    }
};
$3e38f8b30e4a2ada$var$Gb = $3e38f8b30e4a2ada$var$Qk;
$3e38f8b30e4a2ada$var$Hb = $3e38f8b30e4a2ada$var$Rk;
var $3e38f8b30e4a2ada$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $3e38f8b30e4a2ada$var$Cb,
        $3e38f8b30e4a2ada$var$ue,
        $3e38f8b30e4a2ada$var$Db,
        $3e38f8b30e4a2ada$var$Eb,
        $3e38f8b30e4a2ada$var$Fb,
        $3e38f8b30e4a2ada$var$Qk
    ]
}, $3e38f8b30e4a2ada$var$tl = {
    findFiberByHostInstance: $3e38f8b30e4a2ada$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $3e38f8b30e4a2ada$var$ul = {
    bundleType: $3e38f8b30e4a2ada$var$tl.bundleType,
    version: $3e38f8b30e4a2ada$var$tl.version,
    rendererPackageName: $3e38f8b30e4a2ada$var$tl.rendererPackageName,
    rendererConfig: $3e38f8b30e4a2ada$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3e38f8b30e4a2ada$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3e38f8b30e4a2ada$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3e38f8b30e4a2ada$var$tl.findFiberByHostInstance || $3e38f8b30e4a2ada$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3e38f8b30e4a2ada$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3e38f8b30e4a2ada$var$vl.isDisabled && $3e38f8b30e4a2ada$var$vl.supportsFiber) try {
        $3e38f8b30e4a2ada$var$kc = $3e38f8b30e4a2ada$var$vl.inject($3e38f8b30e4a2ada$var$ul), $3e38f8b30e4a2ada$var$lc = $3e38f8b30e4a2ada$var$vl;
    } catch (a) {}
}
$3e38f8b30e4a2ada$export$ae55be85d98224ed = $3e38f8b30e4a2ada$var$sl;
$3e38f8b30e4a2ada$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3e38f8b30e4a2ada$var$nl(b)) throw Error($3e38f8b30e4a2ada$var$p(200));
    return $3e38f8b30e4a2ada$var$cl(a, b, null, c);
};
$3e38f8b30e4a2ada$export$882461b6382ed46c = function(a, b) {
    if (!$3e38f8b30e4a2ada$var$nl(a)) throw Error($3e38f8b30e4a2ada$var$p(299));
    var c = !1, d = "", e = $3e38f8b30e4a2ada$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3e38f8b30e4a2ada$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$3e38f8b30e4a2ada$var$uf] = b.current;
    $3e38f8b30e4a2ada$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3e38f8b30e4a2ada$var$ll(b);
};
$3e38f8b30e4a2ada$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3e38f8b30e4a2ada$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3e38f8b30e4a2ada$var$p(268, a));
    }
    a = $3e38f8b30e4a2ada$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3e38f8b30e4a2ada$export$cd75ccfd720a3cd4 = function(a) {
    return $3e38f8b30e4a2ada$var$Rk(a);
};
$3e38f8b30e4a2ada$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3e38f8b30e4a2ada$var$ol(b)) throw Error($3e38f8b30e4a2ada$var$p(200));
    return $3e38f8b30e4a2ada$var$rl(null, a, b, !0, c);
};
$3e38f8b30e4a2ada$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3e38f8b30e4a2ada$var$nl(a)) throw Error($3e38f8b30e4a2ada$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3e38f8b30e4a2ada$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3e38f8b30e4a2ada$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3e38f8b30e4a2ada$var$uf] = b.current;
    $3e38f8b30e4a2ada$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3e38f8b30e4a2ada$var$ml(b);
};
$3e38f8b30e4a2ada$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3e38f8b30e4a2ada$var$ol(b)) throw Error($3e38f8b30e4a2ada$var$p(200));
    return $3e38f8b30e4a2ada$var$rl(null, a, b, !1, c);
};
$3e38f8b30e4a2ada$export$502457920280e6be = function(a) {
    if (!$3e38f8b30e4a2ada$var$ol(a)) throw Error($3e38f8b30e4a2ada$var$p(40));
    return a._reactRootContainer ? ($3e38f8b30e4a2ada$var$Rk(function() {
        $3e38f8b30e4a2ada$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3e38f8b30e4a2ada$var$uf] = null;
        });
    }), !0) : !1;
};
$3e38f8b30e4a2ada$export$c78a37762a8d58e1 = $3e38f8b30e4a2ada$var$Qk;
$3e38f8b30e4a2ada$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3e38f8b30e4a2ada$var$ol(c)) throw Error($3e38f8b30e4a2ada$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3e38f8b30e4a2ada$var$p(38));
    return $3e38f8b30e4a2ada$var$rl(a, b, c, !1, d);
};
$3e38f8b30e4a2ada$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9A2Xm", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dskwp"));

});
parcelRegister("dskwp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $9cbdcf0d1a6b6931$export$c4744153514ff05d, (v) => $9cbdcf0d1a6b6931$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $9cbdcf0d1a6b6931$export$3e506c1ccc9cc1a7, (v) => $9cbdcf0d1a6b6931$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $9cbdcf0d1a6b6931$export$e26fe2ed2fa76875, (v) => $9cbdcf0d1a6b6931$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $9cbdcf0d1a6b6931$export$502329bbf4b505b1, (v) => $9cbdcf0d1a6b6931$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $9cbdcf0d1a6b6931$export$6e3807111c4874c4, (v) => $9cbdcf0d1a6b6931$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $9cbdcf0d1a6b6931$export$c27134553091fb3a, (v) => $9cbdcf0d1a6b6931$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $9cbdcf0d1a6b6931$export$33ee1acdc04fd2a2, (v) => $9cbdcf0d1a6b6931$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $9cbdcf0d1a6b6931$export$b00a404bbd5edef2, (v) => $9cbdcf0d1a6b6931$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $9cbdcf0d1a6b6931$export$8352ce38b91d0c62, (v) => $9cbdcf0d1a6b6931$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $9cbdcf0d1a6b6931$export$d66a1c1c77bd778b, (v) => $9cbdcf0d1a6b6931$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $9cbdcf0d1a6b6931$export$d3dfb8e4810cb555, (v) => $9cbdcf0d1a6b6931$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $9cbdcf0d1a6b6931$export$839f9183b0465a69, (v) => $9cbdcf0d1a6b6931$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $9cbdcf0d1a6b6931$export$72fdf0e06517287b, (v) => $9cbdcf0d1a6b6931$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $9cbdcf0d1a6b6931$export$4b844e58a3e414b4, (v) => $9cbdcf0d1a6b6931$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $9cbdcf0d1a6b6931$export$816d2913ae6b83b1, (v) => $9cbdcf0d1a6b6931$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $9cbdcf0d1a6b6931$export$61bcfe829111a1d0, (v) => $9cbdcf0d1a6b6931$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $9cbdcf0d1a6b6931$export$7ee8c9beb337bc3f, (v) => $9cbdcf0d1a6b6931$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $9cbdcf0d1a6b6931$export$b5836b71941fa3ed, (v) => $9cbdcf0d1a6b6931$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $9cbdcf0d1a6b6931$export$cf845f2c119da08a, (v) => $9cbdcf0d1a6b6931$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9cbdcf0d1a6b6931$export$c4744153514ff05d;
var $9cbdcf0d1a6b6931$export$3e506c1ccc9cc1a7;
var $9cbdcf0d1a6b6931$export$e26fe2ed2fa76875;
var $9cbdcf0d1a6b6931$export$502329bbf4b505b1;
var $9cbdcf0d1a6b6931$export$6e3807111c4874c4;
var $9cbdcf0d1a6b6931$export$c27134553091fb3a;
var $9cbdcf0d1a6b6931$export$33ee1acdc04fd2a2;
var $9cbdcf0d1a6b6931$export$b00a404bbd5edef2;
var $9cbdcf0d1a6b6931$export$8352ce38b91d0c62;
var $9cbdcf0d1a6b6931$export$d66a1c1c77bd778b;
var $9cbdcf0d1a6b6931$export$d3dfb8e4810cb555;
var $9cbdcf0d1a6b6931$export$839f9183b0465a69;
var $9cbdcf0d1a6b6931$export$72fdf0e06517287b;
var $9cbdcf0d1a6b6931$export$4b844e58a3e414b4;
var $9cbdcf0d1a6b6931$export$816d2913ae6b83b1;
var $9cbdcf0d1a6b6931$export$61bcfe829111a1d0;
var $9cbdcf0d1a6b6931$export$7ee8c9beb337bc3f;
var $9cbdcf0d1a6b6931$export$b5836b71941fa3ed;
var $9cbdcf0d1a6b6931$export$cf845f2c119da08a;
'use strict';
function $9cbdcf0d1a6b6931$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9cbdcf0d1a6b6931$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9cbdcf0d1a6b6931$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9cbdcf0d1a6b6931$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9cbdcf0d1a6b6931$var$g(C, c)) n < e && 0 > $9cbdcf0d1a6b6931$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9cbdcf0d1a6b6931$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9cbdcf0d1a6b6931$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9cbdcf0d1a6b6931$var$l = performance;
    $9cbdcf0d1a6b6931$export$c4744153514ff05d = function() {
        return $9cbdcf0d1a6b6931$var$l.now();
    };
} else {
    var $9cbdcf0d1a6b6931$var$p = Date, $9cbdcf0d1a6b6931$var$q = $9cbdcf0d1a6b6931$var$p.now();
    $9cbdcf0d1a6b6931$export$c4744153514ff05d = function() {
        return $9cbdcf0d1a6b6931$var$p.now() - $9cbdcf0d1a6b6931$var$q;
    };
}
var $9cbdcf0d1a6b6931$var$r = [], $9cbdcf0d1a6b6931$var$t = [], $9cbdcf0d1a6b6931$var$u = 1, $9cbdcf0d1a6b6931$var$v = null, $9cbdcf0d1a6b6931$var$y = 3, $9cbdcf0d1a6b6931$var$z = !1, $9cbdcf0d1a6b6931$var$A = !1, $9cbdcf0d1a6b6931$var$B = !1, $9cbdcf0d1a6b6931$var$D = "function" === typeof setTimeout ? setTimeout : null, $9cbdcf0d1a6b6931$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9cbdcf0d1a6b6931$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9cbdcf0d1a6b6931$var$G(a) {
    for(var b = $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$t); null !== b;){
        if (null === b.callback) $9cbdcf0d1a6b6931$var$k($9cbdcf0d1a6b6931$var$t);
        else if (b.startTime <= a) $9cbdcf0d1a6b6931$var$k($9cbdcf0d1a6b6931$var$t), b.sortIndex = b.expirationTime, $9cbdcf0d1a6b6931$var$f($9cbdcf0d1a6b6931$var$r, b);
        else break;
        b = $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$t);
    }
}
function $9cbdcf0d1a6b6931$var$H(a) {
    $9cbdcf0d1a6b6931$var$B = !1;
    $9cbdcf0d1a6b6931$var$G(a);
    if (!$9cbdcf0d1a6b6931$var$A) {
        if (null !== $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$r)) $9cbdcf0d1a6b6931$var$A = !0, $9cbdcf0d1a6b6931$var$I($9cbdcf0d1a6b6931$var$J);
        else {
            var b = $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$t);
            null !== b && $9cbdcf0d1a6b6931$var$K($9cbdcf0d1a6b6931$var$H, b.startTime - a);
        }
    }
}
function $9cbdcf0d1a6b6931$var$J(a, b) {
    $9cbdcf0d1a6b6931$var$A = !1;
    $9cbdcf0d1a6b6931$var$B && ($9cbdcf0d1a6b6931$var$B = !1, $9cbdcf0d1a6b6931$var$E($9cbdcf0d1a6b6931$var$L), $9cbdcf0d1a6b6931$var$L = -1);
    $9cbdcf0d1a6b6931$var$z = !0;
    var c = $9cbdcf0d1a6b6931$var$y;
    try {
        $9cbdcf0d1a6b6931$var$G(b);
        for($9cbdcf0d1a6b6931$var$v = $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$r); null !== $9cbdcf0d1a6b6931$var$v && (!($9cbdcf0d1a6b6931$var$v.expirationTime > b) || a && !$9cbdcf0d1a6b6931$var$M());){
            var d = $9cbdcf0d1a6b6931$var$v.callback;
            if ("function" === typeof d) {
                $9cbdcf0d1a6b6931$var$v.callback = null;
                $9cbdcf0d1a6b6931$var$y = $9cbdcf0d1a6b6931$var$v.priorityLevel;
                var e = d($9cbdcf0d1a6b6931$var$v.expirationTime <= b);
                b = $9cbdcf0d1a6b6931$export$c4744153514ff05d();
                "function" === typeof e ? $9cbdcf0d1a6b6931$var$v.callback = e : $9cbdcf0d1a6b6931$var$v === $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$r) && $9cbdcf0d1a6b6931$var$k($9cbdcf0d1a6b6931$var$r);
                $9cbdcf0d1a6b6931$var$G(b);
            } else $9cbdcf0d1a6b6931$var$k($9cbdcf0d1a6b6931$var$r);
            $9cbdcf0d1a6b6931$var$v = $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$r);
        }
        if (null !== $9cbdcf0d1a6b6931$var$v) var w = !0;
        else {
            var m = $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$t);
            null !== m && $9cbdcf0d1a6b6931$var$K($9cbdcf0d1a6b6931$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9cbdcf0d1a6b6931$var$v = null, $9cbdcf0d1a6b6931$var$y = c, $9cbdcf0d1a6b6931$var$z = !1;
    }
}
var $9cbdcf0d1a6b6931$var$N = !1, $9cbdcf0d1a6b6931$var$O = null, $9cbdcf0d1a6b6931$var$L = -1, $9cbdcf0d1a6b6931$var$P = 5, $9cbdcf0d1a6b6931$var$Q = -1;
function $9cbdcf0d1a6b6931$var$M() {
    return $9cbdcf0d1a6b6931$export$c4744153514ff05d() - $9cbdcf0d1a6b6931$var$Q < $9cbdcf0d1a6b6931$var$P ? !1 : !0;
}
function $9cbdcf0d1a6b6931$var$R() {
    if (null !== $9cbdcf0d1a6b6931$var$O) {
        var a = $9cbdcf0d1a6b6931$export$c4744153514ff05d();
        $9cbdcf0d1a6b6931$var$Q = a;
        var b = !0;
        try {
            b = $9cbdcf0d1a6b6931$var$O(!0, a);
        } finally{
            b ? $9cbdcf0d1a6b6931$var$S() : ($9cbdcf0d1a6b6931$var$N = !1, $9cbdcf0d1a6b6931$var$O = null);
        }
    } else $9cbdcf0d1a6b6931$var$N = !1;
}
var $9cbdcf0d1a6b6931$var$S;
if ("function" === typeof $9cbdcf0d1a6b6931$var$F) $9cbdcf0d1a6b6931$var$S = function() {
    $9cbdcf0d1a6b6931$var$F($9cbdcf0d1a6b6931$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9cbdcf0d1a6b6931$var$T = new MessageChannel, $9cbdcf0d1a6b6931$var$U = $9cbdcf0d1a6b6931$var$T.port2;
    $9cbdcf0d1a6b6931$var$T.port1.onmessage = $9cbdcf0d1a6b6931$var$R;
    $9cbdcf0d1a6b6931$var$S = function() {
        $9cbdcf0d1a6b6931$var$U.postMessage(null);
    };
} else $9cbdcf0d1a6b6931$var$S = function() {
    $9cbdcf0d1a6b6931$var$D($9cbdcf0d1a6b6931$var$R, 0);
};
function $9cbdcf0d1a6b6931$var$I(a) {
    $9cbdcf0d1a6b6931$var$O = a;
    $9cbdcf0d1a6b6931$var$N || ($9cbdcf0d1a6b6931$var$N = !0, $9cbdcf0d1a6b6931$var$S());
}
function $9cbdcf0d1a6b6931$var$K(a, b) {
    $9cbdcf0d1a6b6931$var$L = $9cbdcf0d1a6b6931$var$D(function() {
        a($9cbdcf0d1a6b6931$export$c4744153514ff05d());
    }, b);
}
$9cbdcf0d1a6b6931$export$3e506c1ccc9cc1a7 = 5;
$9cbdcf0d1a6b6931$export$e26fe2ed2fa76875 = 1;
$9cbdcf0d1a6b6931$export$502329bbf4b505b1 = 4;
$9cbdcf0d1a6b6931$export$6e3807111c4874c4 = 3;
$9cbdcf0d1a6b6931$export$c27134553091fb3a = null;
$9cbdcf0d1a6b6931$export$33ee1acdc04fd2a2 = 2;
$9cbdcf0d1a6b6931$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9cbdcf0d1a6b6931$export$8352ce38b91d0c62 = function() {
    $9cbdcf0d1a6b6931$var$A || $9cbdcf0d1a6b6931$var$z || ($9cbdcf0d1a6b6931$var$A = !0, $9cbdcf0d1a6b6931$var$I($9cbdcf0d1a6b6931$var$J));
};
$9cbdcf0d1a6b6931$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9cbdcf0d1a6b6931$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9cbdcf0d1a6b6931$export$d3dfb8e4810cb555 = function() {
    return $9cbdcf0d1a6b6931$var$y;
};
$9cbdcf0d1a6b6931$export$839f9183b0465a69 = function() {
    return $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$r);
};
$9cbdcf0d1a6b6931$export$72fdf0e06517287b = function(a) {
    switch($9cbdcf0d1a6b6931$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9cbdcf0d1a6b6931$var$y;
    }
    var c = $9cbdcf0d1a6b6931$var$y;
    $9cbdcf0d1a6b6931$var$y = b;
    try {
        return a();
    } finally{
        $9cbdcf0d1a6b6931$var$y = c;
    }
};
$9cbdcf0d1a6b6931$export$4b844e58a3e414b4 = function() {};
$9cbdcf0d1a6b6931$export$816d2913ae6b83b1 = function() {};
$9cbdcf0d1a6b6931$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9cbdcf0d1a6b6931$var$y;
    $9cbdcf0d1a6b6931$var$y = a;
    try {
        return b();
    } finally{
        $9cbdcf0d1a6b6931$var$y = c;
    }
};
$9cbdcf0d1a6b6931$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9cbdcf0d1a6b6931$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9cbdcf0d1a6b6931$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9cbdcf0d1a6b6931$var$f($9cbdcf0d1a6b6931$var$t, a), null === $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$r) && a === $9cbdcf0d1a6b6931$var$h($9cbdcf0d1a6b6931$var$t) && ($9cbdcf0d1a6b6931$var$B ? ($9cbdcf0d1a6b6931$var$E($9cbdcf0d1a6b6931$var$L), $9cbdcf0d1a6b6931$var$L = -1) : $9cbdcf0d1a6b6931$var$B = !0, $9cbdcf0d1a6b6931$var$K($9cbdcf0d1a6b6931$var$H, c - d))) : (a.sortIndex = e, $9cbdcf0d1a6b6931$var$f($9cbdcf0d1a6b6931$var$r, a), $9cbdcf0d1a6b6931$var$A || $9cbdcf0d1a6b6931$var$z || ($9cbdcf0d1a6b6931$var$A = !0, $9cbdcf0d1a6b6931$var$I($9cbdcf0d1a6b6931$var$J)));
    return a;
};
$9cbdcf0d1a6b6931$export$b5836b71941fa3ed = $9cbdcf0d1a6b6931$var$M;
$9cbdcf0d1a6b6931$export$cf845f2c119da08a = function(a) {
    var b = $9cbdcf0d1a6b6931$var$y;
    return function() {
        var c = $9cbdcf0d1a6b6931$var$y;
        $9cbdcf0d1a6b6931$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9cbdcf0d1a6b6931$var$y = c;
        }
    };
};

});



parcelRegister("19GAm", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $023d0873dab70047$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $023d0873dab70047$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $023d0873dab70047$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "Navigate", () => $023d0873dab70047$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $023d0873dab70047$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $023d0873dab70047$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "BrowserRouter", () => $023d0873dab70047$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $023d0873dab70047$export$a6c7ac8248d6e38a);
/**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2NacA = parcelRequire("2NacA");
var $023d0873dab70047$import_meta = Object.assign(Object.create(null), {
    url: "file:///../../node_modules/react-router/dist/development/chunk-OB3PAWPO.mjs"
});
var $023d0873dab70047$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $023d0873dab70047$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $023d0873dab70047$var$__typeError("Cannot " + msg);
var $023d0873dab70047$var$__privateGet = (obj, member, getter)=>($023d0873dab70047$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $023d0873dab70047$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $023d0873dab70047$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $023d0873dab70047$var$__privateSet = (obj, member, value, setter)=>($023d0873dab70047$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $023d0873dab70047$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $023d0873dab70047$export$825a82322d91916e = /^[\\/]{2}/;
function $023d0873dab70047$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $023d0873dab70047$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($023d0873dab70047$export$e19cd5f9376f8cee || {});
var $023d0873dab70047$var$PopStateEventType = "popstate";
function $023d0873dab70047$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $023d0873dab70047$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $023d0873dab70047$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $023d0873dab70047$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $023d0873dab70047$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $023d0873dab70047$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $023d0873dab70047$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $023d0873dab70047$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to);
    }
    return $023d0873dab70047$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $023d0873dab70047$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $023d0873dab70047$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $023d0873dab70047$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $023d0873dab70047$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $023d0873dab70047$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $023d0873dab70047$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $023d0873dab70047$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $023d0873dab70047$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $023d0873dab70047$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $023d0873dab70047$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $023d0873dab70047$var$createKey(),
        mask: mask
    };
    return location;
}
function $023d0873dab70047$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $023d0873dab70047$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $023d0873dab70047$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $023d0873dab70047$var$isLocation(to) ? to : $023d0873dab70047$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $023d0873dab70047$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $023d0873dab70047$var$isLocation(to) ? to : $023d0873dab70047$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $023d0873dab70047$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $023d0873dab70047$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($023d0873dab70047$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($023d0873dab70047$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $023d0873dab70047$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $023d0873dab70047$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $023d0873dab70047$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $023d0873dab70047$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $023d0873dab70047$var$_map;
var $023d0873dab70047$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $023d0873dab70047$var$__privateAdd(this, $023d0873dab70047$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_map).has(context)) return $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_map).set(context, value);
    }
};
$023d0873dab70047$var$_map = new WeakMap();
var $023d0873dab70047$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $023d0873dab70047$var$isUnsupportedLazyRouteObjectKey(key) {
    return $023d0873dab70047$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $023d0873dab70047$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $023d0873dab70047$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $023d0873dab70047$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $023d0873dab70047$var$isIndexRoute(route) {
    return route.index === true;
}
function $023d0873dab70047$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $023d0873dab70047$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $023d0873dab70047$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($023d0873dab70047$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $023d0873dab70047$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $023d0873dab70047$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $023d0873dab70047$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $023d0873dab70047$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $023d0873dab70047$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $023d0873dab70047$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $023d0873dab70047$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $023d0873dab70047$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $023d0873dab70047$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $023d0873dab70047$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $023d0873dab70047$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $023d0873dab70047$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $023d0873dab70047$var$flattenAndRankRoutes(routes) {
    let branches = $023d0873dab70047$var$flattenRoutes(routes);
    $023d0873dab70047$var$rankRouteBranches(branches);
    return branches;
}
function $023d0873dab70047$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $023d0873dab70047$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $023d0873dab70047$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $023d0873dab70047$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $023d0873dab70047$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $023d0873dab70047$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $023d0873dab70047$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $023d0873dab70047$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $023d0873dab70047$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $023d0873dab70047$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $023d0873dab70047$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $023d0873dab70047$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $023d0873dab70047$var$paramRe = /^:[\w-]+$/;
var $023d0873dab70047$var$dynamicSegmentValue = 3;
var $023d0873dab70047$var$indexRouteValue = 2;
var $023d0873dab70047$var$emptySegmentValue = 1;
var $023d0873dab70047$var$staticSegmentValue = 10;
var $023d0873dab70047$var$splatPenalty = -2;
var $023d0873dab70047$var$isSplat = (s)=>s === "*";
function $023d0873dab70047$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($023d0873dab70047$var$isSplat)) initialScore += $023d0873dab70047$var$splatPenalty;
    if (index) initialScore += $023d0873dab70047$var$indexRouteValue;
    return segments.filter((s)=>!$023d0873dab70047$var$isSplat(s)).reduce((score, segment)=>score + ($023d0873dab70047$var$paramRe.test(segment) ? $023d0873dab70047$var$dynamicSegmentValue : segment === "" ? $023d0873dab70047$var$emptySegmentValue : $023d0873dab70047$var$staticSegmentValue), initialScore);
}
function $023d0873dab70047$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $023d0873dab70047$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $023d0873dab70047$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $023d0873dab70047$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $023d0873dab70047$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $023d0873dab70047$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $023d0873dab70047$var$normalizePathname($023d0873dab70047$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $023d0873dab70047$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $023d0873dab70047$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $023d0873dab70047$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $023d0873dab70047$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $023d0873dab70047$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $023d0873dab70047$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $023d0873dab70047$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $023d0873dab70047$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $023d0873dab70047$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $023d0873dab70047$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $023d0873dab70047$var$compilePath(path, caseSensitive = false, end = true) {
    $023d0873dab70047$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $023d0873dab70047$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $023d0873dab70047$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $023d0873dab70047$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $023d0873dab70047$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $023d0873dab70047$var$joinPaths([
        basename,
        pathname
    ]);
}
var $023d0873dab70047$var$isAbsoluteUrl = (url)=>$023d0873dab70047$var$ABSOLUTE_URL_REGEX.test(url);
function $023d0873dab70047$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $023d0873dab70047$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $023d0873dab70047$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $023d0873dab70047$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $023d0873dab70047$var$normalizeSearch(search),
        hash: $023d0873dab70047$var$normalizeHash(hash)
    };
}
function $023d0873dab70047$var$resolvePathname(relativePath, fromPathname) {
    let segments = $023d0873dab70047$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $023d0873dab70047$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $023d0873dab70047$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $023d0873dab70047$var$getResolveToMatches(matches) {
    let pathMatches = $023d0873dab70047$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $023d0873dab70047$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $023d0873dab70047$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $023d0873dab70047$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $023d0873dab70047$var$getInvalidPathError("?", "pathname", "search", to));
        $023d0873dab70047$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $023d0873dab70047$var$getInvalidPathError("#", "pathname", "hash", to));
        $023d0873dab70047$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $023d0873dab70047$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $023d0873dab70047$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $023d0873dab70047$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $023d0873dab70047$var$joinPaths = (paths)=>$023d0873dab70047$var$removeDoubleSlashes(paths.join("/"));
function $023d0873dab70047$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $023d0873dab70047$var$normalizePathname = (pathname)=>$023d0873dab70047$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $023d0873dab70047$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $023d0873dab70047$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $023d0873dab70047$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $023d0873dab70047$export$4051a07651545597(data2, init) {
    return new $023d0873dab70047$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $023d0873dab70047$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $023d0873dab70047$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $023d0873dab70047$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $023d0873dab70047$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $023d0873dab70047$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $023d0873dab70047$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $023d0873dab70047$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $023d0873dab70047$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $023d0873dab70047$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $023d0873dab70047$var$joinPaths(parts) || "/";
}
var $023d0873dab70047$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $023d0873dab70047$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$023d0873dab70047$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($023d0873dab70047$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $023d0873dab70047$export$825a82322d91916e.test(to) ? new URL($023d0873dab70047$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $023d0873dab70047$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $023d0873dab70047$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $023d0873dab70047$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $023d0873dab70047$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $023d0873dab70047$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $023d0873dab70047$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$023d0873dab70047$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $023d0873dab70047$var$wrapImpl(aggregated[key], original, (...args)=>$023d0873dab70047$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$023d0873dab70047$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$023d0873dab70047$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $023d0873dab70047$var$wrapImpl(aggregated.middleware, original, (...args)=>$023d0873dab70047$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$023d0873dab70047$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $023d0873dab70047$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$023d0873dab70047$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $023d0873dab70047$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $023d0873dab70047$export$fe53371bee54353d(to) : ".",
                ...$023d0873dab70047$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$023d0873dab70047$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$023d0873dab70047$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $023d0873dab70047$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$023d0873dab70047$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$023d0873dab70047$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $023d0873dab70047$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $023d0873dab70047$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $023d0873dab70047$var$getReadonlyRequest(request),
            context: context != null ? $023d0873dab70047$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $023d0873dab70047$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $023d0873dab70047$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $023d0873dab70047$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $023d0873dab70047$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $023d0873dab70047$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $023d0873dab70047$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $023d0873dab70047$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $023d0873dab70047$var$getReadonlyContext(context)
    };
}
function $023d0873dab70047$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $023d0873dab70047$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $023d0873dab70047$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $023d0873dab70047$var$getReadonlyContext(context) {
    if ($023d0873dab70047$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $023d0873dab70047$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $023d0873dab70047$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $023d0873dab70047$var$objectProtoNames;
}
// lib/router/navigation.ts
var $023d0873dab70047$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $023d0873dab70047$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $023d0873dab70047$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $023d0873dab70047$var$DEFAULT_NAVIGATION_URL;
    }
}
function $023d0873dab70047$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $023d0873dab70047$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $023d0873dab70047$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$023d0873dab70047$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$023d0873dab70047$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$023d0873dab70047$var$isExplicitUrl(original, originalUrl) || !$023d0873dab70047$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $023d0873dab70047$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $023d0873dab70047$var$validMutationMethods = new Set($023d0873dab70047$var$validMutationMethodsArr);
var $023d0873dab70047$var$validRequestMethodsArr = [
    "GET",
    ...$023d0873dab70047$var$validMutationMethodsArr
];
var $023d0873dab70047$var$validRequestMethods = new Set($023d0873dab70047$var$validRequestMethodsArr);
var $023d0873dab70047$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $023d0873dab70047$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $023d0873dab70047$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $023d0873dab70047$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $023d0873dab70047$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $023d0873dab70047$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $023d0873dab70047$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $023d0873dab70047$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $023d0873dab70047$var$_routes, $023d0873dab70047$var$_branches, $023d0873dab70047$var$_hmrRoutes, $023d0873dab70047$var$_hmrBranches;
var $023d0873dab70047$var$DataRoutes = class {
    constructor(routes){
        $023d0873dab70047$var$__privateAdd(this, $023d0873dab70047$var$_routes);
        $023d0873dab70047$var$__privateAdd(this, $023d0873dab70047$var$_branches);
        $023d0873dab70047$var$__privateAdd(this, $023d0873dab70047$var$_hmrRoutes);
        $023d0873dab70047$var$__privateAdd(this, $023d0873dab70047$var$_hmrBranches);
        $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_routes, routes);
        $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_branches, $023d0873dab70047$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_hmrRoutes) ?? $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_hmrBranches) ?? $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_branches);
    }
    get hasHMRRoutes() {
        return $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_routes, routes);
        $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_branches, $023d0873dab70047$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_hmrRoutes, routes);
        $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_hmrBranches, $023d0873dab70047$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_hmrRoutes)) {
            $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_routes, $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_hmrRoutes));
            $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_branches, $023d0873dab70047$var$__privateGet(this, $023d0873dab70047$var$_hmrBranches));
            $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_hmrRoutes, void 0);
            $023d0873dab70047$var$__privateSet(this, $023d0873dab70047$var$_hmrBranches, void 0);
        }
    }
};
$023d0873dab70047$var$_routes = new WeakMap();
$023d0873dab70047$var$_branches = new WeakMap();
$023d0873dab70047$var$_hmrRoutes = new WeakMap();
$023d0873dab70047$var$_hmrBranches = new WeakMap();
function $023d0873dab70047$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $023d0873dab70047$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $023d0873dab70047$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$023d0873dab70047$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $023d0873dab70047$var$DataRoutes($023d0873dab70047$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $023d0873dab70047$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $023d0873dab70047$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $023d0873dab70047$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $023d0873dab70047$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$023d0873dab70047$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $023d0873dab70047$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $023d0873dab70047$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $023d0873dab70047$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $023d0873dab70047$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $023d0873dab70047$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$023d0873dab70047$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $023d0873dab70047$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $023d0873dab70047$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $023d0873dab70047$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $023d0873dab70047$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $023d0873dab70047$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $023d0873dab70047$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $023d0873dab70047$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $023d0873dab70047$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($023d0873dab70047$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $023d0873dab70047$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $023d0873dab70047$export$fe53371bee54353d(opts.mask), $023d0873dab70047$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $023d0873dab70047$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $023d0873dab70047$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $023d0873dab70047$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $023d0873dab70047$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $023d0873dab70047$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $023d0873dab70047$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $023d0873dab70047$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $023d0873dab70047$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $023d0873dab70047$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $023d0873dab70047$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $023d0873dab70047$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $023d0873dab70047$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($023d0873dab70047$var$isErrorResult(result) && $023d0873dab70047$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $023d0873dab70047$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $023d0873dab70047$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$023d0873dab70047$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $023d0873dab70047$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $023d0873dab70047$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $023d0873dab70047$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $023d0873dab70047$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $023d0873dab70047$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($023d0873dab70047$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $023d0873dab70047$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($023d0873dab70047$var$isErrorResult(result)) {
            let boundaryMatch = $023d0873dab70047$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $023d0873dab70047$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $023d0873dab70047$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $023d0873dab70047$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $023d0873dab70047$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $023d0873dab70047$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $023d0873dab70047$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$023d0873dab70047$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $023d0873dab70047$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $023d0873dab70047$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $023d0873dab70047$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$023d0873dab70047$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $023d0873dab70047$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $023d0873dab70047$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $023d0873dab70047$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $023d0873dab70047$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $023d0873dab70047$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $023d0873dab70047$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $023d0873dab70047$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $023d0873dab70047$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $023d0873dab70047$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $023d0873dab70047$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $023d0873dab70047$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $023d0873dab70047$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($023d0873dab70047$var$isRedirectResult(actionResult) || $023d0873dab70047$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $023d0873dab70047$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($023d0873dab70047$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $023d0873dab70047$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $023d0873dab70047$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($023d0873dab70047$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $023d0873dab70047$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $023d0873dab70047$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $023d0873dab70047$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $023d0873dab70047$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $023d0873dab70047$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $023d0873dab70047$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $023d0873dab70047$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $023d0873dab70047$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $023d0873dab70047$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $023d0873dab70047$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $023d0873dab70047$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $023d0873dab70047$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $023d0873dab70047$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $023d0873dab70047$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $023d0873dab70047$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $023d0873dab70047$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $023d0873dab70047$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $023d0873dab70047$var$getDoneFetcher(void 0));
            return;
        }
        if ($023d0873dab70047$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $023d0873dab70047$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($023d0873dab70047$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $023d0873dab70047$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $023d0873dab70047$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $023d0873dab70047$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $023d0873dab70047$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $023d0873dab70047$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($023d0873dab70047$var$isAbsoluteUrl(location)) {
                const url = $023d0873dab70047$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $023d0873dab70047$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $023d0873dab70047$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($023d0873dab70047$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $023d0873dab70047$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $023d0873dab70047$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $023d0873dab70047$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$023d0873dab70047$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($023d0873dab70047$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $023d0873dab70047$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $023d0873dab70047$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $023d0873dab70047$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $023d0873dab70047$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $023d0873dab70047$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $023d0873dab70047$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $023d0873dab70047$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $023d0873dab70047$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $023d0873dab70047$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $023d0873dab70047$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $023d0873dab70047$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $023d0873dab70047$export$386d57f03f0b2883;
        $023d0873dab70047$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $023d0873dab70047$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $023d0873dab70047$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $023d0873dab70047$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $023d0873dab70047$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$023d0873dab70047$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $023d0873dab70047$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $023d0873dab70047$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $023d0873dab70047$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $023d0873dab70047$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $023d0873dab70047$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $023d0873dab70047$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($023d0873dab70047$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $023d0873dab70047$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $023d0873dab70047$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $023d0873dab70047$export$3336b097a6fbc59a(routes, opts) {
    $023d0873dab70047$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $023d0873dab70047$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$023d0873dab70047$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $023d0873dab70047$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $023d0873dab70047$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $023d0873dab70047$var$defaultNormalizePath;
        let method = request.method;
        let location = $023d0873dab70047$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $023d0873dab70047$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $023d0873dab70047$export$b8d3e69d4b3eff04();
        if (!$023d0873dab70047$var$isValidMethod(method) && method !== "HEAD") {
            let error = $023d0873dab70047$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $023d0873dab70047$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $023d0873dab70047$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $023d0873dab70047$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $023d0873dab70047$export$f5708dca728d7177(requestContext instanceof $023d0873dab70047$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $023d0873dab70047$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $023d0873dab70047$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $023d0873dab70047$var$createDataFunctionUrl(request, location),
                    pattern: $023d0873dab70047$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($023d0873dab70047$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($023d0873dab70047$export$6e80290866a84dd4(error)) return error;
                    if ($023d0873dab70047$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $023d0873dab70047$export$f2680fa305b734ca(error.status, error.statusText, await $023d0873dab70047$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($023d0873dab70047$export$e0163cfdf7bc9cfa(error)) error = $023d0873dab70047$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $023d0873dab70047$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $023d0873dab70047$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $023d0873dab70047$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $023d0873dab70047$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($023d0873dab70047$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($023d0873dab70047$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $023d0873dab70047$var$defaultNormalizePath;
        let method = request.method;
        let location = $023d0873dab70047$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $023d0873dab70047$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $023d0873dab70047$export$b8d3e69d4b3eff04();
        if (!$023d0873dab70047$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $023d0873dab70047$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $023d0873dab70047$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $023d0873dab70047$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $023d0873dab70047$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $023d0873dab70047$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $023d0873dab70047$export$f5708dca728d7177(requestContext instanceof $023d0873dab70047$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $023d0873dab70047$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $023d0873dab70047$var$runServerMiddlewarePipeline({
                request: request,
                url: $023d0873dab70047$var$createDataFunctionUrl(request, location),
                pattern: $023d0873dab70047$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $023d0873dab70047$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($023d0873dab70047$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($023d0873dab70047$var$dataWithResponseInitToResponse(error));
                if ($023d0873dab70047$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($023d0873dab70047$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $023d0873dab70047$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($023d0873dab70047$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $023d0873dab70047$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $023d0873dab70047$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($023d0873dab70047$var$isDataStrategyResult(e) && $023d0873dab70047$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($023d0873dab70047$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $023d0873dab70047$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $023d0873dab70047$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($023d0873dab70047$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($023d0873dab70047$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($023d0873dab70047$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $023d0873dab70047$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $023d0873dab70047$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($023d0873dab70047$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $023d0873dab70047$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $023d0873dab70047$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $023d0873dab70047$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $023d0873dab70047$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $023d0873dab70047$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $023d0873dab70047$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $023d0873dab70047$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $023d0873dab70047$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $023d0873dab70047$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $023d0873dab70047$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $023d0873dab70047$var$callDataStrategyImpl(dataStrategy || $023d0873dab70047$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($023d0873dab70047$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $023d0873dab70047$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($023d0873dab70047$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($023d0873dab70047$export$e0163cfdf7bc9cfa(result.result)) throw $023d0873dab70047$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $023d0873dab70047$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $023d0873dab70047$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $023d0873dab70047$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $023d0873dab70047$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $023d0873dab70047$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $023d0873dab70047$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $023d0873dab70047$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $023d0873dab70047$var$resolveTo(to ? to : ".", $023d0873dab70047$var$getResolveToMatches(contextualMatches), $023d0873dab70047$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $023d0873dab70047$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $023d0873dab70047$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $023d0873dab70047$export$fe53371bee54353d(path);
}
function $023d0873dab70047$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$023d0873dab70047$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$023d0873dab70047$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $023d0873dab70047$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $023d0873dab70047$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $023d0873dab70047$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$023d0873dab70047$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$023d0873dab70047$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $023d0873dab70047$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $023d0873dab70047$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $023d0873dab70047$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $023d0873dab70047$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $023d0873dab70047$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($023d0873dab70047$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $023d0873dab70047$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $023d0873dab70047$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $023d0873dab70047$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $023d0873dab70047$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $023d0873dab70047$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $023d0873dab70047$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $023d0873dab70047$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$023d0873dab70047$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $023d0873dab70047$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($023d0873dab70047$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $023d0873dab70047$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($023d0873dab70047$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $023d0873dab70047$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $023d0873dab70047$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $023d0873dab70047$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $023d0873dab70047$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $023d0873dab70047$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($023d0873dab70047$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $023d0873dab70047$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $023d0873dab70047$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$023d0873dab70047$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $023d0873dab70047$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $023d0873dab70047$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $023d0873dab70047$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $023d0873dab70047$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $023d0873dab70047$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$023d0873dab70047$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $023d0873dab70047$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $023d0873dab70047$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $023d0873dab70047$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$023d0873dab70047$var$isSameRoute(aChild, bChild))) ?? false;
}
var $023d0873dab70047$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $023d0873dab70047$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $023d0873dab70047$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $023d0873dab70047$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $023d0873dab70047$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $023d0873dab70047$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $023d0873dab70047$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $023d0873dab70047$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $023d0873dab70047$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $023d0873dab70047$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $023d0873dab70047$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $023d0873dab70047$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $023d0873dab70047$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $023d0873dab70047$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $023d0873dab70047$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $023d0873dab70047$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $023d0873dab70047$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $023d0873dab70047$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $023d0873dab70047$var$isNonNullable(value) {
    return value !== void 0;
}
function $023d0873dab70047$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $023d0873dab70047$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($023d0873dab70047$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $023d0873dab70047$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $023d0873dab70047$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $023d0873dab70047$var$defaultDataStrategy(args);
    return $023d0873dab70047$var$runClientMiddlewarePipeline(args, ()=>$023d0873dab70047$var$defaultDataStrategy(args));
}
function $023d0873dab70047$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $023d0873dab70047$var$runMiddlewarePipeline(args, handler, processResult, $023d0873dab70047$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $023d0873dab70047$export$e0163cfdf7bc9cfa(result) ? $023d0873dab70047$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $023d0873dab70047$var$runClientMiddlewarePipeline(args, handler) {
    return $023d0873dab70047$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($023d0873dab70047$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $023d0873dab70047$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $023d0873dab70047$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $023d0873dab70047$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $023d0873dab70047$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $023d0873dab70047$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $023d0873dab70047$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $023d0873dab70047$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $023d0873dab70047$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $023d0873dab70047$var$loadLazyRoute(match.route, $023d0873dab70047$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $023d0873dab70047$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $023d0873dab70047$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $023d0873dab70047$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $023d0873dab70047$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $023d0873dab70047$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$023d0873dab70047$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($023d0873dab70047$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $023d0873dab70047$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $023d0873dab70047$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $023d0873dab70047$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $023d0873dab70047$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $023d0873dab70047$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $023d0873dab70047$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $023d0873dab70047$var$createDataFunctionUrl(request, path),
        pattern: $023d0873dab70047$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $023d0873dab70047$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $023d0873dab70047$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $023d0873dab70047$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $023d0873dab70047$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $023d0873dab70047$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $023d0873dab70047$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $023d0873dab70047$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $023d0873dab70047$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($023d0873dab70047$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $023d0873dab70047$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $023d0873dab70047$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($023d0873dab70047$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $023d0873dab70047$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $023d0873dab70047$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $023d0873dab70047$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($023d0873dab70047$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $023d0873dab70047$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $023d0873dab70047$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$023d0873dab70047$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $023d0873dab70047$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $023d0873dab70047$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $023d0873dab70047$export$961a3ef7a4da3a39(location) {
    try {
        return $023d0873dab70047$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $023d0873dab70047$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($023d0873dab70047$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $023d0873dab70047$export$825a82322d91916e.test(normalizedLocation) ? new URL($023d0873dab70047$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($023d0873dab70047$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $023d0873dab70047$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $023d0873dab70047$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($023d0873dab70047$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $023d0873dab70047$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($023d0873dab70047$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $023d0873dab70047$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $023d0873dab70047$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $023d0873dab70047$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $023d0873dab70047$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $023d0873dab70047$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $023d0873dab70047$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $023d0873dab70047$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $023d0873dab70047$export$f5708dca728d7177(!$023d0873dab70047$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($023d0873dab70047$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $023d0873dab70047$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $023d0873dab70047$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $023d0873dab70047$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $023d0873dab70047$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $023d0873dab70047$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $023d0873dab70047$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($023d0873dab70047$var$isErrorResult(result)) {
            let boundaryMatch = $023d0873dab70047$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($023d0873dab70047$var$isRedirectResult(result)) $023d0873dab70047$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $023d0873dab70047$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $023d0873dab70047$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $023d0873dab70047$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $023d0873dab70047$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $023d0873dab70047$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $023d0873dab70047$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $023d0873dab70047$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $023d0873dab70047$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $023d0873dab70047$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $023d0873dab70047$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($023d0873dab70047$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $023d0873dab70047$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(path) : path;
    return $023d0873dab70047$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $023d0873dab70047$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $023d0873dab70047$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $023d0873dab70047$var$dataWithResponseInitToErrorResponse(data2) {
    return new $023d0873dab70047$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $023d0873dab70047$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $023d0873dab70047$var$isDataStrategyResult(value));
}
function $023d0873dab70047$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $023d0873dab70047$var$isRedirectDataStrategyResult(result) {
    return $023d0873dab70047$export$3f1eb41d9a6a6a27(result.result) && $023d0873dab70047$var$redirectStatusCodes.has(result.result.status);
}
function $023d0873dab70047$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $023d0873dab70047$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $023d0873dab70047$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $023d0873dab70047$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $023d0873dab70047$export$794b2760043cf8cd(statusCode) {
    return $023d0873dab70047$var$redirectStatusCodes.has(statusCode);
}
function $023d0873dab70047$export$6e80290866a84dd4(result) {
    return $023d0873dab70047$export$3f1eb41d9a6a6a27(result) && $023d0873dab70047$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $023d0873dab70047$var$isValidMethod(method) {
    return $023d0873dab70047$var$validRequestMethods.has(method.toUpperCase());
}
function $023d0873dab70047$export$cbae47800eb95bc3(method) {
    return $023d0873dab70047$var$validMutationMethods.has(method.toUpperCase());
}
function $023d0873dab70047$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $023d0873dab70047$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $023d0873dab70047$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $023d0873dab70047$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $023d0873dab70047$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $023d0873dab70047$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $023d0873dab70047$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $023d0873dab70047$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $023d0873dab70047$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $023d0873dab70047$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $023d0873dab70047$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($023d0873dab70047$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $023d0873dab70047$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($023d0873dab70047$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $023d0873dab70047$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $023d0873dab70047$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $023d0873dab70047$export$2eeee58951ff3c1c = $2NacA.createContext(null);
$023d0873dab70047$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $023d0873dab70047$export$315e3ffb01f217 = $2NacA.createContext(null);
$023d0873dab70047$export$315e3ffb01f217.displayName = "DataRouterState";
var $023d0873dab70047$export$717f757c655223f1 = $2NacA.createContext(false);
function $023d0873dab70047$var$useIsRSCRouterContext() {
    return $2NacA.useContext($023d0873dab70047$export$717f757c655223f1);
}
var $023d0873dab70047$export$3681f408decb40d1 = $2NacA.createContext({
    isTransitioning: false
});
$023d0873dab70047$export$3681f408decb40d1.displayName = "ViewTransition";
var $023d0873dab70047$export$cb3f1df1bef00a39 = $2NacA.createContext(/* @__PURE__ */ new Map());
$023d0873dab70047$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $023d0873dab70047$var$AwaitContext = $2NacA.createContext(null);
$023d0873dab70047$var$AwaitContext.displayName = "Await";
var $023d0873dab70047$export$2666c20e15407622 = (props)=>$2NacA.createElement($023d0873dab70047$var$AwaitContext.Provider, props);
var $023d0873dab70047$export$3044ab7fdabeaee6 = $2NacA.createContext(null);
$023d0873dab70047$export$3044ab7fdabeaee6.displayName = "Navigation";
var $023d0873dab70047$export$e6a44b110a0c44d3 = $2NacA.createContext(null);
$023d0873dab70047$export$e6a44b110a0c44d3.displayName = "Location";
var $023d0873dab70047$export$aac280ed165a4397 = $2NacA.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$023d0873dab70047$export$aac280ed165a4397.displayName = "Route";
var $023d0873dab70047$var$RouteErrorContext = $2NacA.createContext(null);
$023d0873dab70047$var$RouteErrorContext.displayName = "RouteError";
var $023d0873dab70047$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $023d0873dab70047$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $023d0873dab70047$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $023d0873dab70047$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $023d0873dab70047$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$023d0873dab70047$var$ERROR_DIGEST_BASE}:${$023d0873dab70047$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $023d0873dab70047$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$023d0873dab70047$var$ERROR_DIGEST_BASE}:${$023d0873dab70047$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $023d0873dab70047$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $023d0873dab70047$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $023d0873dab70047$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $023d0873dab70047$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $023d0873dab70047$export$9c954a9d03d32f4a() {
    return $2NacA.useContext($023d0873dab70047$export$e6a44b110a0c44d3) != null;
}
function $023d0873dab70047$export$45d76561a5302f2b() {
    $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $2NacA.useContext($023d0873dab70047$export$e6a44b110a0c44d3).location;
}
function $023d0873dab70047$export$1b3f31771c5d07c() {
    return $2NacA.useContext($023d0873dab70047$export$e6a44b110a0c44d3).navigationType;
}
function $023d0873dab70047$export$6c330e8992e8a295(pattern) {
    $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $023d0873dab70047$export$45d76561a5302f2b();
    return $2NacA.useMemo(()=>$023d0873dab70047$export$81336c211d5ff295(pattern, $023d0873dab70047$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $023d0873dab70047$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $023d0873dab70047$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6).static;
    if (!isStatic) $2NacA.useLayoutEffect(cb);
}
function $023d0873dab70047$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    return isDataRoute ? $023d0873dab70047$var$useNavigateStable() : $023d0873dab70047$var$useNavigateUnstable();
}
function $023d0873dab70047$var$useNavigateUnstable() {
    $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $2NacA.useContext($023d0873dab70047$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let { matches: matches } = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    let { pathname: locationPathname } = $023d0873dab70047$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($023d0873dab70047$var$getResolveToMatches(matches));
    let activeRef = $2NacA.useRef(false);
    $023d0873dab70047$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2NacA.useCallback((to, options = {})=>{
        $023d0873dab70047$var$warning(activeRef.current, $023d0873dab70047$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $023d0873dab70047$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $023d0873dab70047$var$joinPaths([
            basename,
            path.pathname
        ]);
        $023d0873dab70047$export$6c8e41f66e7aa990(typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to), navigator.createHref(path), $023d0873dab70047$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $023d0873dab70047$var$OutletContext = $2NacA.createContext(null);
function $023d0873dab70047$export$4138103a3ae699cc() {
    return $2NacA.useContext($023d0873dab70047$var$OutletContext);
}
function $023d0873dab70047$export$a3be3530d8e40d0b(context) {
    let outlet = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397).outlet;
    return $2NacA.useMemo(()=>outlet && /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $023d0873dab70047$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $023d0873dab70047$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    let { pathname: locationPathname } = $023d0873dab70047$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($023d0873dab70047$var$getResolveToMatches(matches));
    return $2NacA.useMemo(()=>$023d0873dab70047$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $023d0873dab70047$export$5d3fca4a98652595(routes, locationArg) {
    return $023d0873dab70047$var$useRoutesImpl(routes, locationArg);
}
function $023d0873dab70047$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($023d0873dab70047$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $023d0873dab70047$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $023d0873dab70047$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $023d0873dab70047$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $023d0873dab70047$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $023d0873dab70047$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($023d0873dab70047$export$945fecf35a8ef089) {
        $023d0873dab70047$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $023d0873dab70047$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $023d0873dab70047$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $023d0873dab70047$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $023d0873dab70047$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $023d0873dab70047$var$DefaultErrorComponent() {
    let error = $023d0873dab70047$export$ed527bf60f6e05f2();
    let message = $023d0873dab70047$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($023d0873dab70047$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, /* @__PURE__ */ $2NacA.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $2NacA.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $2NacA.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $2NacA.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, /* @__PURE__ */ $2NacA.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $2NacA.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $2NacA.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $023d0873dab70047$var$defaultErrorElement = /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$DefaultErrorComponent, null);
var $023d0873dab70047$var$RenderErrorBoundary = class extends $2NacA.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $023d0873dab70047$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$023d0873dab70047$var$RenderErrorBoundary.contextType = $023d0873dab70047$export$717f757c655223f1;
var $023d0873dab70047$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $023d0873dab70047$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $023d0873dab70047$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $023d0873dab70047$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $023d0873dab70047$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $023d0873dab70047$export$6c8e41f66e7aa990(redirect2.location, target, $023d0873dab70047$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($023d0873dab70047$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($023d0873dab70047$var$isBrowser && !$023d0873dab70047$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $023d0873dab70047$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $2NacA.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $023d0873dab70047$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $2NacA.useContext($023d0873dab70047$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $023d0873dab70047$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $023d0873dab70047$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $023d0873dab70047$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $023d0873dab70047$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $023d0873dab70047$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $2NacA.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $023d0873dab70047$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $023d0873dab70047$var$useDataRouterContext(hookName) {
    let ctx = $2NacA.useContext($023d0873dab70047$export$2eeee58951ff3c1c);
    $023d0873dab70047$export$f5708dca728d7177(ctx, $023d0873dab70047$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $023d0873dab70047$var$useDataRouterState(hookName) {
    let state = $2NacA.useContext($023d0873dab70047$export$315e3ffb01f217);
    $023d0873dab70047$export$f5708dca728d7177(state, $023d0873dab70047$var$getDataRouterConsoleError(hookName));
    return state;
}
function $023d0873dab70047$var$useRouteContext(hookName) {
    let route = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    $023d0873dab70047$export$f5708dca728d7177(route, $023d0873dab70047$var$getDataRouterConsoleError(hookName));
    return route;
}
function $023d0873dab70047$var$useCurrentRouteId(hookName) {
    let route = $023d0873dab70047$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $023d0873dab70047$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $023d0873dab70047$var$useRouteId() {
    return $023d0873dab70047$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $023d0873dab70047$export$d0fd4b7106de2769() {
    let state = $023d0873dab70047$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $2NacA.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $023d0873dab70047$export$600dc272ed516c15() {
    let dataRouterContext = $023d0873dab70047$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $023d0873dab70047$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $2NacA.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $2NacA.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $023d0873dab70047$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $023d0873dab70047$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $2NacA.useMemo(()=>matches.map((m)=>$023d0873dab70047$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $023d0873dab70047$export$1448a5050d252c4d() {
    let state = $023d0873dab70047$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $023d0873dab70047$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $023d0873dab70047$export$fd5d37484eab868d(routeId) {
    let state = $023d0873dab70047$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $023d0873dab70047$export$fdc00f3f26066d5e() {
    let state = $023d0873dab70047$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $023d0873dab70047$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $023d0873dab70047$export$ed527bf60f6e05f2() {
    let error = $2NacA.useContext($023d0873dab70047$var$RouteErrorContext);
    let state = $023d0873dab70047$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $023d0873dab70047$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $023d0873dab70047$export$78a72ddb39bdd145() {
    let value = $2NacA.useContext($023d0873dab70047$var$AwaitContext);
    return value?._data;
}
function $023d0873dab70047$export$17f53340677d5831() {
    let value = $2NacA.useContext($023d0873dab70047$var$AwaitContext);
    return value?._error;
}
var $023d0873dab70047$var$blockerId = 0;
function $023d0873dab70047$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $023d0873dab70047$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $023d0873dab70047$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $2NacA.useState("");
    let blockerFunction = $2NacA.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $023d0873dab70047$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $023d0873dab70047$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $2NacA.useEffect(()=>{
        let key = String(++$023d0873dab70047$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $2NacA.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $023d0873dab70047$export$386d57f03f0b2883;
}
function $023d0873dab70047$var$useNavigateStable() {
    let { router: router } = $023d0873dab70047$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $023d0873dab70047$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $2NacA.useRef(false);
    $023d0873dab70047$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2NacA.useCallback(async (to, options = {})=>{
        $023d0873dab70047$var$warning(activeRef.current, $023d0873dab70047$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $023d0873dab70047$var$alreadyWarned = {};
function $023d0873dab70047$var$warningOnce(key, cond, message) {
    if (!cond && !$023d0873dab70047$var$alreadyWarned[key]) {
        $023d0873dab70047$var$alreadyWarned[key] = true;
        $023d0873dab70047$var$warning(false, message);
    }
}
function $023d0873dab70047$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $023d0873dab70047$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $023d0873dab70047$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $023d0873dab70047$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $023d0873dab70047$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $023d0873dab70047$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $2NacA.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$023d0873dab70047$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $2NacA.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$023d0873dab70047$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $2NacA.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $023d0873dab70047$var$alreadyWarned2 = {};
function $023d0873dab70047$export$5b28268982f175ba(condition, message) {
    if (!condition && !$023d0873dab70047$var$alreadyWarned2[message]) {
        $023d0873dab70047$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $023d0873dab70047$var$USE_OPTIMISTIC = "useOptimistic";
var $023d0873dab70047$var$useOptimisticImpl = $2NacA[$023d0873dab70047$var$USE_OPTIMISTIC];
var $023d0873dab70047$var$stableUseOptimisticSetter = ()=>void 0;
function $023d0873dab70047$var$useOptimisticSafe(val) {
    if ($023d0873dab70047$var$useOptimisticImpl) return $023d0873dab70047$var$useOptimisticImpl(val);
    else return [
        val,
        $023d0873dab70047$var$stableUseOptimisticSetter
    ];
}
function $023d0873dab70047$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($023d0873dab70047$export$945fecf35a8ef089) {
            if (route.element) $023d0873dab70047$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $2NacA.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($023d0873dab70047$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $023d0873dab70047$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $2NacA.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($023d0873dab70047$export$945fecf35a8ef089) {
            if (route.errorElement) $023d0873dab70047$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $2NacA.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $023d0873dab70047$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $023d0873dab70047$export$f30f7e456d254e83(routes, opts) {
    return $023d0873dab70047$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $023d0873dab70047$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $023d0873dab70047$export$e2fd2c03906469db,
        mapRouteProperties: $023d0873dab70047$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $023d0873dab70047$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $023d0873dab70047$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $023d0873dab70047$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $2NacA.useState(router.state);
    let [state, setOptimisticState] = $023d0873dab70047$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $2NacA.useState();
    let [vtContext, setVtContext] = $2NacA.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $2NacA.useState();
    let [transition, setTransition] = $2NacA.useState();
    let [interruption, setInterruption] = $2NacA.useState();
    let fetcherData = $2NacA.useRef(/* @__PURE__ */ new Map());
    let setState = $2NacA.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $023d0873dab70047$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $023d0873dab70047$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $023d0873dab70047$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $2NacA.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$023d0873dab70047$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $2NacA.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $2NacA.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $023d0873dab70047$var$Deferred());
    }, [
        vtContext
    ]);
    $2NacA.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $2NacA.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$023d0873dab70047$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $2NacA.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $2NacA.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $2NacA.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2NacA.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $023d0873dab70047$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $023d0873dab70047$var$MemoizedDataRoutes = $2NacA.memo($023d0873dab70047$var$DataRoutes2);
function $023d0873dab70047$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $023d0873dab70047$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $023d0873dab70047$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $2NacA.useRef();
    if (historyRef.current == null) historyRef.current = $023d0873dab70047$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2NacA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $2NacA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $2NacA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $2NacA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $023d0873dab70047$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $023d0873dab70047$export$f5708dca728d7177($023d0873dab70047$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    $023d0873dab70047$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    let { pathname: locationPathname } = $023d0873dab70047$export$45d76561a5302f2b();
    let navigate = $023d0873dab70047$export$9770f232ac06a008();
    let path = $023d0873dab70047$var$resolveTo(to, $023d0873dab70047$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $023d0873dab70047$export$6c8e41f66e7aa990(typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to), navigator.createHref(path), $023d0873dab70047$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $2NacA.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $023d0873dab70047$export$910ae8079b2c2852(props) {
    return $023d0873dab70047$export$a3be3530d8e40d0b(props.context);
}
function $023d0873dab70047$export$e7b0ac011bb776c6(props) {
    $023d0873dab70047$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $023d0873dab70047$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $023d0873dab70047$export$f5708dca728d7177(!$023d0873dab70047$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $2NacA.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $023d0873dab70047$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $2NacA.useMemo(()=>{
        let trailingPathname = $023d0873dab70047$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $023d0873dab70047$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $023d0873dab70047$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $023d0873dab70047$export$5d3fca4a98652595($023d0873dab70047$export$16da398f5434bdec(children), location);
}
function $023d0873dab70047$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $2NacA.useContext($023d0873dab70047$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $2NacA.useContext($023d0873dab70047$export$315e3ffb01f217);
    let onError = $2NacA.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $023d0873dab70047$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$ResolveAwait, null, children));
}
var $023d0873dab70047$var$AwaitErrorBoundary = class extends $2NacA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $023d0873dab70047$var$ResolveAwait({ children: children }) {
    let data2 = $023d0873dab70047$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, toRender);
}
function $023d0873dab70047$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $2NacA.Children.forEach(children, (element, index)=>{
        if (!$2NacA.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $2NacA.Fragment) {
            routes.push.apply(routes, $023d0873dab70047$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $023d0873dab70047$export$f5708dca728d7177(element.type === $023d0873dab70047$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $023d0873dab70047$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $023d0873dab70047$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $023d0873dab70047$export$9b5b6d122dea0c88 = $023d0873dab70047$export$16da398f5434bdec;
function $023d0873dab70047$export$daf73786167a7f72(matches) {
    return $023d0873dab70047$var$_renderMatches(matches);
}
function $023d0873dab70047$var$useRouteComponentProps() {
    return {
        params: $023d0873dab70047$export$99eaa27ddbbb95ef(),
        loaderData: $023d0873dab70047$export$1448a5050d252c4d(),
        actionData: $023d0873dab70047$export$fdc00f3f26066d5e(),
        matches: $023d0873dab70047$export$2378eb7f5ff86053()
    };
}
function $023d0873dab70047$export$6c4f3826290c37af({ children: children }) {
    const props = $023d0873dab70047$var$useRouteComponentProps();
    return $2NacA.cloneElement(children, props);
}
function $023d0873dab70047$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $023d0873dab70047$var$useRouteComponentProps();
        return $2NacA.createElement(Component4, props);
    };
}
function $023d0873dab70047$var$useHydrateFallbackProps() {
    return {
        params: $023d0873dab70047$export$99eaa27ddbbb95ef(),
        loaderData: $023d0873dab70047$export$1448a5050d252c4d(),
        actionData: $023d0873dab70047$export$fdc00f3f26066d5e()
    };
}
function $023d0873dab70047$export$f8cff34f39c1932a({ children: children }) {
    const props = $023d0873dab70047$var$useHydrateFallbackProps();
    return $2NacA.cloneElement(children, props);
}
function $023d0873dab70047$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $023d0873dab70047$var$useHydrateFallbackProps();
        return $2NacA.createElement(HydrateFallback, props);
    };
}
function $023d0873dab70047$var$useErrorBoundaryProps() {
    return {
        params: $023d0873dab70047$export$99eaa27ddbbb95ef(),
        loaderData: $023d0873dab70047$export$1448a5050d252c4d(),
        actionData: $023d0873dab70047$export$fdc00f3f26066d5e(),
        error: $023d0873dab70047$export$ed527bf60f6e05f2()
    };
}
function $023d0873dab70047$export$e5afde5c4b6d747b({ children: children }) {
    const props = $023d0873dab70047$var$useErrorBoundaryProps();
    return $2NacA.cloneElement(children, props);
}
function $023d0873dab70047$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $023d0873dab70047$var$useErrorBoundaryProps();
        return $2NacA.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $023d0873dab70047$var$defaultMethod = "get";
var $023d0873dab70047$var$defaultEncType = "application/x-www-form-urlencoded";
function $023d0873dab70047$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $023d0873dab70047$var$isButtonElement(object) {
    return $023d0873dab70047$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $023d0873dab70047$var$isFormElement(object) {
    return $023d0873dab70047$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $023d0873dab70047$var$isInputElement(object) {
    return $023d0873dab70047$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $023d0873dab70047$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $023d0873dab70047$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$023d0873dab70047$var$isModifiedEvent(event);
}
function $023d0873dab70047$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $023d0873dab70047$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $023d0873dab70047$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $023d0873dab70047$var$_formDataSupportsSubmitter = null;
function $023d0873dab70047$var$isFormDataSubmitterSupported() {
    if ($023d0873dab70047$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $023d0873dab70047$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $023d0873dab70047$var$_formDataSupportsSubmitter = true;
    }
    return $023d0873dab70047$var$_formDataSupportsSubmitter;
}
var $023d0873dab70047$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $023d0873dab70047$var$getFormEncType(encType) {
    if (encType != null && !$023d0873dab70047$var$supportedFormEncTypes.has(encType)) {
        $023d0873dab70047$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$023d0873dab70047$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $023d0873dab70047$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($023d0873dab70047$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $023d0873dab70047$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $023d0873dab70047$var$defaultMethod;
        encType = $023d0873dab70047$var$getFormEncType(target.getAttribute("enctype")) || $023d0873dab70047$var$defaultEncType;
        formData = new FormData(target);
    } else if ($023d0873dab70047$var$isButtonElement(target) || $023d0873dab70047$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $023d0873dab70047$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $023d0873dab70047$var$defaultMethod;
        encType = $023d0873dab70047$var$getFormEncType(target.getAttribute("formenctype")) || $023d0873dab70047$var$getFormEncType(form.getAttribute("enctype")) || $023d0873dab70047$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$023d0873dab70047$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($023d0873dab70047$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $023d0873dab70047$var$defaultMethod;
        action = null;
        encType = $023d0873dab70047$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $023d0873dab70047$var$HOLE = -1;
var $023d0873dab70047$var$NAN = -2;
var $023d0873dab70047$var$NEGATIVE_INFINITY = -3;
var $023d0873dab70047$var$NEGATIVE_ZERO = -4;
var $023d0873dab70047$var$NULL = -5;
var $023d0873dab70047$var$POSITIVE_INFINITY = -6;
var $023d0873dab70047$var$UNDEFINED = -7;
var $023d0873dab70047$var$TYPE_BIGINT = "B";
var $023d0873dab70047$var$TYPE_DATE = "D";
var $023d0873dab70047$var$TYPE_ERROR = "E";
var $023d0873dab70047$var$TYPE_MAP = "M";
var $023d0873dab70047$var$TYPE_NULL_OBJECT = "N";
var $023d0873dab70047$var$TYPE_PROMISE = "P";
var $023d0873dab70047$var$TYPE_REGEXP = "R";
var $023d0873dab70047$var$TYPE_SET = "S";
var $023d0873dab70047$var$TYPE_SYMBOL = "Y";
var $023d0873dab70047$var$TYPE_URL = "U";
var $023d0873dab70047$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $023d0873dab70047$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $023d0873dab70047$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $023d0873dab70047$var$TIME_LIMIT_MS = 1;
var $023d0873dab70047$var$getNow = ()=>Date.now();
var $023d0873dab70047$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $023d0873dab70047$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $023d0873dab70047$var$UNDEFINED;
    if (input === null) return $023d0873dab70047$var$NULL;
    if (Number.isNaN(input)) return $023d0873dab70047$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $023d0873dab70047$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $023d0873dab70047$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $023d0873dab70047$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $023d0873dab70047$var$stringify.call(this, stack);
    return index;
}
async function $023d0873dab70047$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $023d0873dab70047$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $023d0873dab70047$var$UNDEFINED;
        if (value === null) return $023d0873dab70047$var$NULL;
        if (Number.isNaN(value)) return $023d0873dab70047$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $023d0873dab70047$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $023d0873dab70047$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $023d0873dab70047$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $023d0873dab70047$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $023d0873dab70047$var$TIME_LIMIT_MS) {
            await $023d0873dab70047$var$yieldToMain();
            lastYieldTime = $023d0873dab70047$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$023d0873dab70047$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$023d0873dab70047$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$023d0873dab70047$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $023d0873dab70047$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$023d0873dab70047$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$023d0873dab70047$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$023d0873dab70047$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$023d0873dab70047$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$023d0873dab70047$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$023d0873dab70047$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$023d0873dab70047$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$023d0873dab70047$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$023d0873dab70047$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$023d0873dab70047$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($023d0873dab70047$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $023d0873dab70047$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $023d0873dab70047$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $023d0873dab70047$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $023d0873dab70047$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $023d0873dab70047$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $023d0873dab70047$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $023d0873dab70047$var$hydrate.call(this, startIndex);
}
function $023d0873dab70047$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $023d0873dab70047$var$UNDEFINED:
                set(void 0);
                continue;
            case $023d0873dab70047$var$NULL:
                set(null);
                continue;
            case $023d0873dab70047$var$NAN:
                set(NaN);
                continue;
            case $023d0873dab70047$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $023d0873dab70047$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $023d0873dab70047$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $023d0873dab70047$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $023d0873dab70047$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $023d0873dab70047$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $023d0873dab70047$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $023d0873dab70047$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $023d0873dab70047$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $023d0873dab70047$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $023d0873dab70047$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $023d0873dab70047$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $023d0873dab70047$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $023d0873dab70047$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $023d0873dab70047$var$globalObj && $023d0873dab70047$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $023d0873dab70047$var$globalObj && typeof $023d0873dab70047$var$globalObj[errorType] === "function" ? new $023d0873dab70047$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $023d0873dab70047$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $023d0873dab70047$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $023d0873dab70047$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $023d0873dab70047$var$Deferred2();
    const reader = readable.pipeThrough($023d0873dab70047$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $023d0873dab70047$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $023d0873dab70047$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $023d0873dab70047$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $023d0873dab70047$var$unflatten.call(this, line)
    };
}
async function $023d0873dab70047$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $023d0873dab70047$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $023d0873dab70047$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $023d0873dab70047$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $023d0873dab70047$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $023d0873dab70047$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $023d0873dab70047$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $023d0873dab70047$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$023d0873dab70047$var$TYPE_PROMISE}${deferredId}:[["${$023d0873dab70047$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$023d0873dab70047$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$023d0873dab70047$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $023d0873dab70047$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$023d0873dab70047$var$TYPE_ERROR}${deferredId}:[["${$023d0873dab70047$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$023d0873dab70047$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$023d0873dab70047$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $023d0873dab70047$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $023d0873dab70047$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $023d0873dab70047$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $023d0873dab70047$export$4cf11838cdc2a8a8(html) {
    return html.replace($023d0873dab70047$var$ESCAPE_REGEX, (match)=>$023d0873dab70047$var$ESCAPE_LOOKUP[match]);
}
function $023d0873dab70047$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $023d0873dab70047$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $023d0873dab70047$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $023d0873dab70047$var$SingleFetchNoResultError = class extends Error {
};
var $023d0873dab70047$export$ae9272e641ead836 = 202;
var $023d0873dab70047$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $023d0873dab70047$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $2NacA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$023d0873dab70047$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, scriptTag, /* @__PURE__ */ $2NacA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, scriptTag, /* @__PURE__ */ $2NacA.createElement($2NacA.Suspense, null, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $023d0873dab70047$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $023d0873dab70047$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $023d0873dab70047$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $023d0873dab70047$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $023d0873dab70047$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $023d0873dab70047$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $023d0873dab70047$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $023d0873dab70047$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $023d0873dab70047$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $023d0873dab70047$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $023d0873dab70047$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $023d0873dab70047$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($023d0873dab70047$export$3f1eb41d9a6a6a27(result.result) || $023d0873dab70047$export$972111febbeef05b(result.result) || $023d0873dab70047$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $023d0873dab70047$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $023d0873dab70047$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $023d0873dab70047$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $023d0873dab70047$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$023d0873dab70047$var$createDeferred2());
    let singleFetchDfd = $023d0873dab70047$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $023d0873dab70047$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $023d0873dab70047$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $023d0873dab70047$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $023d0873dab70047$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $023d0873dab70047$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $023d0873dab70047$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $023d0873dab70047$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $023d0873dab70047$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $023d0873dab70047$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $023d0873dab70047$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $023d0873dab70047$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$023d0873dab70047$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$023d0873dab70047$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $023d0873dab70047$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $023d0873dab70047$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $023d0873dab70047$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $023d0873dab70047$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $023d0873dab70047$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $023d0873dab70047$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($023d0873dab70047$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $023d0873dab70047$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $023d0873dab70047$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($023d0873dab70047$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$023d0873dab70047$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $023d0873dab70047$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $023d0873dab70047$export$4023ad4ecd4126a2(body, global) {
    return $023d0873dab70047$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $023d0873dab70047$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $023d0873dab70047$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$023d0873dab70047$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $023d0873dab70047$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $023d0873dab70047$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $023d0873dab70047$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $023d0873dab70047$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $023d0873dab70047$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $023d0873dab70047$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $023d0873dab70047$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $023d0873dab70047$var$getModuleLinkHrefs(matches, manifest);
    return $023d0873dab70047$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $023d0873dab70047$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $023d0873dab70047$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $023d0873dab70047$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($023d0873dab70047$var$prefetchStyleLink));
}
async function $023d0873dab70047$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$023d0873dab70047$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$023d0873dab70047$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$023d0873dab70047$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($023d0873dab70047$var$prefetchStyleLink));
}
async function $023d0873dab70047$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $023d0873dab70047$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $023d0873dab70047$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $023d0873dab70047$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $023d0873dab70047$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $023d0873dab70047$var$dedupeLinkDescriptors(links.flat(1).filter($023d0873dab70047$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $023d0873dab70047$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $023d0873dab70047$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $023d0873dab70047$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $023d0873dab70047$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $023d0873dab70047$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $023d0873dab70047$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$023d0873dab70047$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($023d0873dab70047$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $023d0873dab70047$var$_isPreloadSupported;
function $023d0873dab70047$var$isPreloadSupported() {
    if ($023d0873dab70047$var$_isPreloadSupported !== void 0) return $023d0873dab70047$var$_isPreloadSupported;
    let el = document.createElement("link");
    $023d0873dab70047$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $023d0873dab70047$var$_isPreloadSupported;
}
function $023d0873dab70047$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $023d0873dab70047$var$useFrameworkContext();
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $023d0873dab70047$export$945fecf35a8ef089 ? /* @__PURE__ */ $2NacA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $023d0873dab70047$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $023d0873dab70047$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $023d0873dab70047$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $023d0873dab70047$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RemixRootDefaultErrorBoundary, {
            error: $023d0873dab70047$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $2NacA.createElement(routeModule.Layout, null, /* @__PURE__ */ $2NacA.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $2NacA.createElement(routeModule.Layout, null, /* @__PURE__ */ $2NacA.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $2NacA.createElement(routeModule.Layout, null, /* @__PURE__ */ $2NacA.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $023d0873dab70047$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $023d0873dab70047$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $023d0873dab70047$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$023d0873dab70047$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $023d0873dab70047$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $023d0873dab70047$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $023d0873dab70047$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $023d0873dab70047$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $023d0873dab70047$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $023d0873dab70047$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $023d0873dab70047$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $023d0873dab70047$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $023d0873dab70047$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $023d0873dab70047$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $023d0873dab70047$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $023d0873dab70047$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $023d0873dab70047$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$023d0873dab70047$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $023d0873dab70047$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $023d0873dab70047$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $023d0873dab70047$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $023d0873dab70047$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $023d0873dab70047$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $023d0873dab70047$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $023d0873dab70047$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $023d0873dab70047$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $023d0873dab70047$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $023d0873dab70047$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $023d0873dab70047$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $023d0873dab70047$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $023d0873dab70047$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $023d0873dab70047$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $023d0873dab70047$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $023d0873dab70047$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $023d0873dab70047$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $023d0873dab70047$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $023d0873dab70047$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $023d0873dab70047$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $023d0873dab70047$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $023d0873dab70047$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $023d0873dab70047$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $023d0873dab70047$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $023d0873dab70047$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $023d0873dab70047$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $023d0873dab70047$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $023d0873dab70047$var$nextPaths = /* @__PURE__ */ new Set();
var $023d0873dab70047$var$discoveredPathsMaxSize = 1e3;
var $023d0873dab70047$var$discoveredPaths = /* @__PURE__ */ new Set();
var $023d0873dab70047$export$b5915cf27fa06b9f = 7680;
function $023d0873dab70047$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $023d0873dab70047$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $023d0873dab70047$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $023d0873dab70047$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $023d0873dab70047$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$023d0873dab70047$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($023d0873dab70047$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $023d0873dab70047$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $023d0873dab70047$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $023d0873dab70047$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $2NacA.useEffect(()=>{
        if (!$023d0873dab70047$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$023d0873dab70047$var$discoveredPaths.has(pathname)) $023d0873dab70047$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($023d0873dab70047$var$nextPaths.keys()).filter((path)=>{
                if ($023d0873dab70047$var$discoveredPaths.has(path)) {
                    $023d0873dab70047$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $023d0873dab70047$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $023d0873dab70047$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $023d0873dab70047$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $023d0873dab70047$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $023d0873dab70047$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $023d0873dab70047$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $023d0873dab70047$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($023d0873dab70047$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $023d0873dab70047$export$b5915cf27fa06b9f) {
        $023d0873dab70047$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($023d0873dab70047$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($023d0873dab70047$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($023d0873dab70047$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$023d0873dab70047$var$addToFifoQueue(p, $023d0873dab70047$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $023d0873dab70047$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $023d0873dab70047$var$addToFifoQueue(path, queue) {
    if (queue.size >= $023d0873dab70047$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $023d0873dab70047$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $023d0873dab70047$var$useDataRouterContext2() {
    let context = $2NacA.useContext($023d0873dab70047$export$2eeee58951ff3c1c);
    $023d0873dab70047$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $023d0873dab70047$var$useDataRouterStateContext() {
    let context = $2NacA.useContext($023d0873dab70047$export$315e3ffb01f217);
    $023d0873dab70047$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $023d0873dab70047$export$208d6a3bc3aa62bd = $2NacA.createContext(void 0);
$023d0873dab70047$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $023d0873dab70047$var$useFrameworkContext() {
    let context = $2NacA.useContext($023d0873dab70047$export$208d6a3bc3aa62bd);
    $023d0873dab70047$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $023d0873dab70047$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $2NacA.useContext($023d0873dab70047$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $2NacA.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $2NacA.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $2NacA.useRef(null);
    $2NacA.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $2NacA.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $023d0873dab70047$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $023d0873dab70047$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $023d0873dab70047$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $023d0873dab70047$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $023d0873dab70047$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $023d0873dab70047$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $023d0873dab70047$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$023d0873dab70047$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $023d0873dab70047$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $023d0873dab70047$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $023d0873dab70047$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $023d0873dab70047$var$useDataRouterStateContext();
    let matches = $023d0873dab70047$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $2NacA.useMemo(()=>$023d0873dab70047$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $2NacA.createElement("style", {
        [$023d0873dab70047$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $2NacA.createElement("link", {
        [$023d0873dab70047$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$023d0873dab70047$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $2NacA.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $023d0873dab70047$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $023d0873dab70047$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $023d0873dab70047$var$useFrameworkContext();
    let { router: router } = $023d0873dab70047$var$useDataRouterContext2();
    let matches = $2NacA.useMemo(()=>$023d0873dab70047$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $023d0873dab70047$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $023d0873dab70047$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $2NacA.useState([]);
    $2NacA.useEffect(()=>{
        let interrupted = false;
        $023d0873dab70047$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $023d0873dab70047$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let { future: future } = $023d0873dab70047$var$useFrameworkContext();
    let { basename: basename } = $023d0873dab70047$var$useDataRouterContext2();
    let dataHrefs = $2NacA.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $023d0873dab70047$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $2NacA.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $023d0873dab70047$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $023d0873dab70047$var$useFrameworkContext();
    let { basename: basename } = $023d0873dab70047$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $023d0873dab70047$var$useDataRouterStateContext();
    let newMatchesForData = $2NacA.useMemo(()=>$023d0873dab70047$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $2NacA.useMemo(()=>$023d0873dab70047$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $2NacA.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $023d0873dab70047$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $2NacA.useMemo(()=>$023d0873dab70047$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $023d0873dab70047$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $2NacA.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $2NacA.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $2NacA.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $023d0873dab70047$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $023d0873dab70047$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $023d0873dab70047$var$useDataRouterStateContext();
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let _matches = $023d0873dab70047$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$023d0873dab70047$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $2NacA.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $2NacA.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $2NacA.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $2NacA.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $023d0873dab70047$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $2NacA.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $023d0873dab70047$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $023d0873dab70047$var$isHydrated = false;
function $023d0873dab70047$export$3be068dde909e563() {
    $023d0873dab70047$var$isHydrated = true;
}
function $023d0873dab70047$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $023d0873dab70047$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $023d0873dab70047$var$useDataRouterContext2();
    let { matches: routerMatches } = $023d0873dab70047$var$useDataRouterStateContext();
    let isRSCRouterContext = $023d0873dab70047$var$useIsRSCRouterContext();
    let enableFogOfWar = $023d0873dab70047$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $023d0873dab70047$var$getActiveMatches(routerMatches, null, isSpaMode);
    $2NacA.useEffect(()=>{
        $023d0873dab70047$export$3be068dde909e563();
    }, []);
    let initialScripts = $2NacA.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $023d0873dab70047$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($023d0873dab70047$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, /* @__PURE__ */ $2NacA.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $2NacA.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $023d0873dab70047$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($023d0873dab70047$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $023d0873dab70047$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $023d0873dab70047$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $2NacA.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $2NacA.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $2NacA.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $2NacA.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $023d0873dab70047$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $023d0873dab70047$export$32e57f52df4b6e34 = class extends $2NacA.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $023d0873dab70047$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $023d0873dab70047$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $2NacA.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($023d0873dab70047$export$972111febbeef05b(error)) return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $2NacA.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $023d0873dab70047$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $2NacA.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $2NacA.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $023d0873dab70047$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $023d0873dab70047$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $2NacA.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $2NacA.createElement("head", null, /* @__PURE__ */ $2NacA.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $2NacA.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $2NacA.createElement("title", null, title)), /* @__PURE__ */ $2NacA.createElement("body", null, /* @__PURE__ */ $2NacA.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$ff0bf87698939488, null) : null)));
}
var $023d0873dab70047$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($023d0873dab70047$var$isBrowser2) window.__reactRouterVersion = "7.18.4";
} catch (e) {}
function $023d0873dab70047$export$1f3f55432a00e06d(routes, opts) {
    return $023d0873dab70047$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $023d0873dab70047$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $023d0873dab70047$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $023d0873dab70047$export$9269a41d8c4635e,
        hydrationRouteProperties: $023d0873dab70047$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $023d0873dab70047$export$1ba7ed8a3a7b3765(routes, opts) {
    return $023d0873dab70047$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $023d0873dab70047$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $023d0873dab70047$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $023d0873dab70047$export$9269a41d8c4635e,
        hydrationRouteProperties: $023d0873dab70047$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $023d0873dab70047$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $023d0873dab70047$var$deserializeErrors(state.errors)
    };
    return state;
}
function $023d0873dab70047$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $023d0873dab70047$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $023d0873dab70047$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $023d0873dab70047$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $2NacA.useRef();
    if (historyRef.current == null) historyRef.current = $023d0873dab70047$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2NacA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $2NacA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $2NacA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $2NacA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $023d0873dab70047$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $2NacA.useRef();
    if (historyRef.current == null) historyRef.current = $023d0873dab70047$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $2NacA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $2NacA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $2NacA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $2NacA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $023d0873dab70047$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $2NacA.useState({
        action: history.action,
        location: history.location
    });
    let setState = $2NacA.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $2NacA.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $2NacA.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$023d0873dab70047$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $023d0873dab70047$export$a6c7ac8248d6e38a = $2NacA.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $023d0873dab70047$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $023d0873dab70047$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $023d0873dab70047$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $023d0873dab70047$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $023d0873dab70047$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $023d0873dab70047$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $023d0873dab70047$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $2NacA.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $023d0873dab70047$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, link, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$023d0873dab70047$export$a6c7ac8248d6e38a.displayName = "Link";
var $023d0873dab70047$export$b0d92dbee9b5b60d = $2NacA.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $023d0873dab70047$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let routerState = $2NacA.useContext($023d0873dab70047$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $023d0873dab70047$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $023d0873dab70047$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$023d0873dab70047$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $023d0873dab70047$export$a7fed597f4b8afd8 = $2NacA.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $023d0873dab70047$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let submit = $023d0873dab70047$export$47c85c6e3a081d3();
    let formAction = $023d0873dab70047$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $023d0873dab70047$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $2NacA.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $2NacA.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$023d0873dab70047$export$a7fed597f4b8afd8.displayName = "Form";
function $023d0873dab70047$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $2NacA.useContext($023d0873dab70047$export$208d6a3bc3aa62bd);
    let { basename: basename } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let matches = $023d0873dab70047$export$2378eb7f5ff86053();
    $023d0873dab70047$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $2NacA.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $023d0873dab70047$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $2NacA.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$023d0873dab70047$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $023d0873dab70047$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$023d0873dab70047$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$023d0873dab70047$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $023d0873dab70047$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $023d0873dab70047$var$useDataRouterContext3(hookName) {
    let ctx = $2NacA.useContext($023d0873dab70047$export$2eeee58951ff3c1c);
    $023d0873dab70047$export$f5708dca728d7177(ctx, $023d0873dab70047$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $023d0873dab70047$var$useDataRouterState2(hookName) {
    let state = $2NacA.useContext($023d0873dab70047$export$315e3ffb01f217);
    $023d0873dab70047$export$f5708dca728d7177(state, $023d0873dab70047$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $023d0873dab70047$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $023d0873dab70047$export$9770f232ac06a008();
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let path = $023d0873dab70047$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $2NacA.useCallback((event)=>{
        if ($023d0873dab70047$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $023d0873dab70047$export$fe53371bee54353d(location) === $023d0873dab70047$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $2NacA.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $023d0873dab70047$export$f1a78c17382fe22a(defaultInit) {
    $023d0873dab70047$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $2NacA.useRef($023d0873dab70047$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $2NacA.useRef(false);
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let searchParams = $2NacA.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $023d0873dab70047$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $023d0873dab70047$export$9770f232ac06a008();
    let setSearchParams = $2NacA.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $023d0873dab70047$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $023d0873dab70047$var$fetcherId = 0;
var $023d0873dab70047$var$getUniqueFetcherId = ()=>`__${String(++$023d0873dab70047$var$fetcherId)}__`;
function $023d0873dab70047$export$47c85c6e3a081d3() {
    let { router: router } = $023d0873dab70047$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let currentRouteId = $023d0873dab70047$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $2NacA.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $023d0873dab70047$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $023d0873dab70047$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $023d0873dab70047$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let routeContext = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    $023d0873dab70047$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$023d0873dab70047$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $023d0873dab70047$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $023d0873dab70047$export$fe53371bee54353d(path);
}
function $023d0873dab70047$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $023d0873dab70047$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $023d0873dab70047$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $2NacA.useContext($023d0873dab70047$export$cb3f1df1bef00a39);
    let route = $2NacA.useContext($023d0873dab70047$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $023d0873dab70047$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $023d0873dab70047$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $023d0873dab70047$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $2NacA.useId();
    let [fetcherKey, setFetcherKey] = $2NacA.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $2NacA.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $2NacA.useCallback(async (href, opts)=>{
        $023d0873dab70047$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $023d0873dab70047$export$47c85c6e3a081d3();
    let submit = $2NacA.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $2NacA.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $2NacA.useMemo(()=>{
        let FetcherForm2 = $2NacA.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $023d0873dab70047$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $2NacA.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $023d0873dab70047$export$fa996778a3a31087() {
    let state = $023d0873dab70047$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $2NacA.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $023d0873dab70047$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $023d0873dab70047$var$savedScrollPositions = {};
function $023d0873dab70047$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $023d0873dab70047$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $023d0873dab70047$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $023d0873dab70047$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $023d0873dab70047$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $2NacA.useContext($023d0873dab70047$export$3044ab7fdabeaee6);
    let location = $023d0873dab70047$export$45d76561a5302f2b();
    let matches = $023d0873dab70047$export$2378eb7f5ff86053();
    let navigation = $023d0873dab70047$export$d0fd4b7106de2769();
    $2NacA.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $023d0873dab70047$var$usePageHide($2NacA.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $023d0873dab70047$var$getScrollRestorationKey(location, matches, basename, getKey);
            $023d0873dab70047$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $023d0873dab70047$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($023d0873dab70047$var$savedScrollPositions));
        } catch (error) {
            $023d0873dab70047$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $2NacA.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $023d0873dab70047$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $023d0873dab70047$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $2NacA.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($023d0873dab70047$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$023d0873dab70047$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $2NacA.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $023d0873dab70047$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $023d0873dab70047$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $2NacA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $023d0873dab70047$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $2NacA.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $023d0873dab70047$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $023d0873dab70047$export$b273b3273281a049(when);
    $2NacA.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $2NacA.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $023d0873dab70047$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $2NacA.useContext($023d0873dab70047$export$3681f408decb40d1);
    $023d0873dab70047$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $023d0873dab70047$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $023d0873dab70047$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $023d0873dab70047$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $023d0873dab70047$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $023d0873dab70047$export$81336c211d5ff295(path.pathname, nextPath) != null || $023d0873dab70047$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $023d0873dab70047$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $023d0873dab70047$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $023d0873dab70047$var$getStatelessNavigator();
    return /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $023d0873dab70047$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $023d0873dab70047$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $023d0873dab70047$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $023d0873dab70047$var$serializeErrors(context.errors)
        };
        let json = $023d0873dab70047$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $2NacA.createElement($2NacA.Fragment, null, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $2NacA.createElement($023d0873dab70047$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $2NacA.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $023d0873dab70047$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($023d0873dab70047$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $023d0873dab70047$var$getStatelessNavigator() {
    return {
        createHref: $023d0873dab70047$var$createHref,
        encodeLocation: $023d0873dab70047$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $023d0873dab70047$export$69163f0b72ec60d9(routes, opts) {
    return $023d0873dab70047$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $023d0873dab70047$export$9269a41d8c4635e
    });
}
function $023d0873dab70047$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $023d0873dab70047$export$87cb1a9238dc3fba(routes, $023d0873dab70047$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $023d0873dab70047$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $023d0873dab70047$var$createHref,
        encodeLocation: $023d0873dab70047$var$encodeLocation,
        getFetcher () {
            return $023d0873dab70047$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $023d0873dab70047$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $023d0873dab70047$var$createHref(to) {
    return typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to);
}
function $023d0873dab70047$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $023d0873dab70047$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $023d0873dab70047$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("bsB3E", function(module, exports) {

$parcel$export(module.exports, "ToastContainer", () => $cd0f01057b726a05$export$f2815235e76a62b9);
$parcel$export(module.exports, "toast", () => $cd0f01057b726a05$export$b410431fab84fa58);

var $2NacA = parcelRequire("2NacA");

var $Poraq = parcelRequire("Poraq");
'use client';
const $cd0f01057b726a05$var$u = (t)=>"number" == typeof t && !isNaN(t), $cd0f01057b726a05$var$d = (t)=>"string" == typeof t, $cd0f01057b726a05$var$p = (t)=>"function" == typeof t, $cd0f01057b726a05$var$m = (t)=>$cd0f01057b726a05$var$d(t) || $cd0f01057b726a05$var$p(t) ? t : null, $cd0f01057b726a05$var$f = (t)=>(0, $2NacA.isValidElement)(t) || $cd0f01057b726a05$var$d(t) || $cd0f01057b726a05$var$p(t) || $cd0f01057b726a05$var$u(t);
function $cd0f01057b726a05$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $cd0f01057b726a05$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $2NacA.useRef)(0);
        return (0, $2NacA.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $2NacA.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $cd0f01057b726a05$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, u);
    };
}
function $cd0f01057b726a05$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $cd0f01057b726a05$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $cd0f01057b726a05$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $cd0f01057b726a05$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($cd0f01057b726a05$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($cd0f01057b726a05$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($cd0f01057b726a05$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($cd0f01057b726a05$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $cd0f01057b726a05$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $2NacA.useReducer)((t)=>t + 1, 0), [l, c] = (0, $2NacA.useState)([]), g = (0, $2NacA.useRef)(null), h = (0, $2NacA.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $2NacA.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$cd0f01057b726a05$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $cd0f01057b726a05$var$m(i.className || b.toastClassName),
            bodyClassName: $cd0f01057b726a05$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $cd0f01057b726a05$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $cd0f01057b726a05$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $cd0f01057b726a05$var$y(h.get(l), "removed");
                h.delete(l), $cd0f01057b726a05$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($cd0f01057b726a05$var$p(r) ? i = r(l) : (0, $2NacA.isValidElement)(r) ? i = (0, $2NacA.cloneElement)(r, l) : $cd0f01057b726a05$var$d(r) || $cd0f01057b726a05$var$u(r) ? i = r : s ? i = $cd0f01057b726a05$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $cd0f01057b726a05$export$4f13f83fd8bb1dac)(o) && (i = $cd0f01057b726a05$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $cd0f01057b726a05$var$p(i.onOpen) && (M.onOpen = i.onOpen), $cd0f01057b726a05$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $cd0f01057b726a05$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$cd0f01057b726a05$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $2NacA.isValidElement)(t) && !$cd0f01057b726a05$var$d(t.type) ? x = (0, $2NacA.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $cd0f01057b726a05$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $cd0f01057b726a05$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $cd0f01057b726a05$var$v.emit(4, $cd0f01057b726a05$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $2NacA.useEffect)(()=>(C.containerId = t.containerId, $cd0f01057b726a05$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $cd0f01057b726a05$var$v.emit(3, C);
        }), []), (0, $2NacA.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $cd0f01057b726a05$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $cd0f01057b726a05$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $cd0f01057b726a05$export$a407b657d3044108(t) {
    const [o, a] = (0, $2NacA.useState)(!1), [r, l] = (0, $2NacA.useState)(!1), c = (0, $2NacA.useRef)(null), u = (0, $2NacA.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $2NacA.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $cd0f01057b726a05$var$b(e.nativeEvent), u.y = $cd0f01057b726a05$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $cd0f01057b726a05$var$b(e), u.y = $cd0f01057b726a05$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $2NacA.useEffect)(()=>{
        d.current = t;
    }), (0, $2NacA.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $cd0f01057b726a05$var$p(t.onOpen) && t.onOpen((0, $2NacA.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $cd0f01057b726a05$var$p(t.onClose) && t.onClose((0, $2NacA.isValidElement)(t.children) && t.children.props);
        }), []), (0, $2NacA.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $cd0f01057b726a05$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $cd0f01057b726a05$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $Poraq.default)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $cd0f01057b726a05$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $Poraq.default)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $cd0f01057b726a05$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $cd0f01057b726a05$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $Poraq.default)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $cd0f01057b726a05$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $Poraq.default)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $cd0f01057b726a05$var$p(l) ? l(q) : (0, $2NacA.isValidElement)(l) ? (0, $2NacA.cloneElement)(l, q) : $cd0f01057b726a05$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        ...P && {
            role: R
        },
        className: $cd0f01057b726a05$var$p(C) ? C({
            type: f
        }) : (0, $Poraq.default)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        className: (0, $Poraq.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($cd0f01057b726a05$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $cd0f01057b726a05$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $cd0f01057b726a05$export$d20e79fdc3899e95 = $cd0f01057b726a05$export$3ff7dc44d332d222($cd0f01057b726a05$var$M("bounce", !0)), $cd0f01057b726a05$export$d8dc01b5c85a37b9 = $cd0f01057b726a05$export$3ff7dc44d332d222($cd0f01057b726a05$var$M("slide", !0)), $cd0f01057b726a05$export$65cfd44a2050f99 = $cd0f01057b726a05$export$3ff7dc44d332d222($cd0f01057b726a05$var$M("zoom")), $cd0f01057b726a05$export$4d2fae537bd90431 = $cd0f01057b726a05$export$3ff7dc44d332d222($cd0f01057b726a05$var$M("flip")), $cd0f01057b726a05$export$f2815235e76a62b9 = (0, $2NacA.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $cd0f01057b726a05$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $Poraq.default)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $cd0f01057b726a05$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $Poraq.default)(e, $cd0f01057b726a05$var$m(i));
    }
    return (0, $2NacA.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($cd0f01057b726a05$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$cd0f01057b726a05$export$f2815235e76a62b9.displayName = "ToastContainer", $cd0f01057b726a05$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $cd0f01057b726a05$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $cd0f01057b726a05$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $cd0f01057b726a05$var$P, $cd0f01057b726a05$var$B = new Map, $cd0f01057b726a05$var$D = [], $cd0f01057b726a05$var$A = 1;
function $cd0f01057b726a05$var$z() {
    return "" + $cd0f01057b726a05$var$A++;
}
function $cd0f01057b726a05$var$F(t) {
    return t && ($cd0f01057b726a05$var$d(t.toastId) || $cd0f01057b726a05$var$u(t.toastId)) ? t.toastId : $cd0f01057b726a05$var$z();
}
function $cd0f01057b726a05$var$H(t, e) {
    return $cd0f01057b726a05$var$B.size > 0 ? $cd0f01057b726a05$var$v.emit(0, t, e) : $cd0f01057b726a05$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $cd0f01057b726a05$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $cd0f01057b726a05$var$F(e)
    };
}
function $cd0f01057b726a05$var$q(t) {
    return (e, n)=>$cd0f01057b726a05$var$H(e, $cd0f01057b726a05$var$S(t, n));
}
function $cd0f01057b726a05$export$b410431fab84fa58(t, e) {
    return $cd0f01057b726a05$var$H(t, $cd0f01057b726a05$var$S("default", e));
}
$cd0f01057b726a05$export$b410431fab84fa58.loading = (t, e)=>$cd0f01057b726a05$var$H(t, $cd0f01057b726a05$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $cd0f01057b726a05$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $cd0f01057b726a05$var$d(s) ? $cd0f01057b726a05$export$b410431fab84fa58.loading(s, n) : $cd0f01057b726a05$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $cd0f01057b726a05$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $cd0f01057b726a05$var$d(e) ? {
            render: e
        } : e;
        return o ? $cd0f01057b726a05$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $cd0f01057b726a05$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $cd0f01057b726a05$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $cd0f01057b726a05$export$b410431fab84fa58.success = $cd0f01057b726a05$var$q("success"), $cd0f01057b726a05$export$b410431fab84fa58.info = $cd0f01057b726a05$var$q("info"), $cd0f01057b726a05$export$b410431fab84fa58.error = $cd0f01057b726a05$var$q("error"), $cd0f01057b726a05$export$b410431fab84fa58.warning = $cd0f01057b726a05$var$q("warning"), $cd0f01057b726a05$export$b410431fab84fa58.warn = $cd0f01057b726a05$export$b410431fab84fa58.warning, $cd0f01057b726a05$export$b410431fab84fa58.dark = (t, e)=>$cd0f01057b726a05$var$H(t, $cd0f01057b726a05$var$S("default", {
        theme: "dark",
        ...e
    })), $cd0f01057b726a05$export$b410431fab84fa58.dismiss = (t)=>{
    $cd0f01057b726a05$var$B.size > 0 ? $cd0f01057b726a05$var$v.emit(1, t) : $cd0f01057b726a05$var$D = $cd0f01057b726a05$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $cd0f01057b726a05$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $cd0f01057b726a05$var$v.emit(5, t);
}, $cd0f01057b726a05$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $cd0f01057b726a05$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $cd0f01057b726a05$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $cd0f01057b726a05$var$B.get(n || $cd0f01057b726a05$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $cd0f01057b726a05$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $cd0f01057b726a05$var$H(r, a);
        }
    }, 0);
}, $cd0f01057b726a05$export$b410431fab84fa58.done = (t)=>{
    $cd0f01057b726a05$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $cd0f01057b726a05$export$b410431fab84fa58.onChange = (t)=>($cd0f01057b726a05$var$v.on(4, t), ()=>{
        $cd0f01057b726a05$var$v.off(4, t);
    }), $cd0f01057b726a05$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $cd0f01057b726a05$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $cd0f01057b726a05$var$v.on(2, (t)=>{
    $cd0f01057b726a05$var$P = t.containerId || t, $cd0f01057b726a05$var$B.set($cd0f01057b726a05$var$P, t), $cd0f01057b726a05$var$D.forEach((t)=>{
        $cd0f01057b726a05$var$v.emit(0, t.content, t.options);
    }), $cd0f01057b726a05$var$D = [];
}).on(3, (t)=>{
    $cd0f01057b726a05$var$B.delete(t.containerId || t), 0 === $cd0f01057b726a05$var$B.size && $cd0f01057b726a05$var$v.off(0).off(1).off(5);
});

});
parcelRegister("Poraq", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a7b83fda28b309$export$2e2bcd8739ae039);
function $09a7b83fda28b309$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $09a7b83fda28b309$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $09a7b83fda28b309$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $09a7b83fda28b309$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $09a7b83fda28b309$export$2e2bcd8739ae039 = $09a7b83fda28b309$export$4f5d2d50c9deca37;

});


parcelRegister("bRT7J", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => (parcelRequire("jvR7E")).ErrorFallback);
$parcel$export(module.exports, "AdminLayout", () => (parcelRequire("3goov")).AdminLayout);
$parcel$export(module.exports, "Layout", () => (parcelRequire("jDV21")).Layout);
$parcel$export(module.exports, "ProjectRoute", () => (parcelRequire("jhzFH")).ProjectRoute);
$parcel$export(module.exports, "RequireAuth", () => (parcelRequire("l2NlU")).RequireAuth);
$parcel$export(module.exports, "AddNewButton", () => (parcelRequire("gdNyE")).AddNewButton);
$parcel$export(module.exports, "AssetCloudImportButtons", () => (parcelRequire("107Qa")).AssetCloudImportButtons);
$parcel$export(module.exports, "AssetSelectorModal", () => (parcelRequire("3npYU")).AssetSelectorModal);
$parcel$export(module.exports, "ChatWidget", () => (parcelRequire("45q4c")).ChatWidget);
$parcel$export(module.exports, "CommercialEditReviewModal", () => (parcelRequire("lpy8P")).CommercialEditReviewModal);
$parcel$export(module.exports, "CommercialsPanel", () => (parcelRequire("81cmi")).CommercialsPanel);
$parcel$export(module.exports, "ConfirmModal", () => (parcelRequire("3W9FZ")).ConfirmModal);
$parcel$export(module.exports, "CreateCommercialModal", () => (parcelRequire("bSmn2")).CreateCommercialModal);
$parcel$export(module.exports, "CurrentEstimate", () => (parcelRequire("8fFyF")).CurrentEstimate);
$parcel$export(module.exports, "Delete", () => (parcelRequire("hF8pi")).Delete);
$parcel$export(module.exports, "DeleteModal", () => (parcelRequire("7r0kC")).DeleteModal);
$parcel$export(module.exports, "Divider", () => (parcelRequire("jGT7M")).Divider);
$parcel$export(module.exports, "DocumentsPanel", () => (parcelRequire("agggX")).DocumentsPanel);
$parcel$export(module.exports, "EditableText", () => (parcelRequire("1Ofsp")).EditableText);
$parcel$export(module.exports, "EditReviewModal", () => (parcelRequire("aYiXW")).EditReviewModal);
$parcel$export(module.exports, "EstimateList", () => (parcelRequire("iopSL")).EstimateList);
$parcel$export(module.exports, "LicensingRightsHeader", () => (parcelRequire("iq83q")).LicensingRightsHeader);
$parcel$export(module.exports, "Loader", () => (parcelRequire("4mDQA")).Loader);
$parcel$export(module.exports, "LocationPanel", () => (parcelRequire("cRsVF")).LocationPanel);
$parcel$export(module.exports, "NotificationsTable", () => (parcelRequire("lbkqm")).NotificationsTable);
$parcel$export(module.exports, "ProjectRolesPanel", () => (parcelRequire("gNjNn")).ProjectRolesPanel);
$parcel$export(module.exports, "RightDetailsModal", () => (parcelRequire("hkYJ0")).RightDetailsModal);
$parcel$export(module.exports, "RightPanel", () => (parcelRequire("i13h4")).RightPanel);
$parcel$export(module.exports, "SaveStatus", () => (parcelRequire("lFfFS")).SaveStatus);
$parcel$export(module.exports, "SaveStatusIndicator", () => (parcelRequire("lFfFS")).SaveStatusIndicator);
$parcel$export(module.exports, "SelectableText", () => (parcelRequire("6q7qM")).SelectableText);
$parcel$export(module.exports, "SessionEstimatorHeader", () => (parcelRequire("3bJi5")).SessionEstimatorHeader);
$parcel$export(module.exports, "SessionRow", () => (parcelRequire("kaLe2")).SessionRow);
$parcel$export(module.exports, "SessionsPanel", () => (parcelRequire("cBCf2")).SessionsPanel);
$parcel$export(module.exports, "TalentManagerPanel", () => (parcelRequire("21teh")).TalentManagerPanel);
$parcel$export(module.exports, "TalonCard", () => (parcelRequire("7wM4T")).TalonCard);
$parcel$export(module.exports, "TalonInput", () => (parcelRequire("bIzid")).TalonInput);
$parcel$export(module.exports, "TalonTip", () => (parcelRequire("d2VmQ")).TalonTip);
$parcel$export(module.exports, "TalonVideoPlayer", () => (parcelRequire("9OMpO")).TalonVideoPlayer);
$parcel$export(module.exports, "UsagePanel", () => (parcelRequire("d8S1C")).UsagePanel);
$parcel$export(module.exports, "UsageRow", () => (parcelRequire("6useT")).UsageRow);
$parcel$export(module.exports, "UsageTypeSelect", () => (parcelRequire("b9Fv4")).UsageTypeSelect);
$parcel$export(module.exports, "WatchVideoModal", () => (parcelRequire("5avy4")).WatchVideoModal);
parcelRequire("jvR7E");
parcelRequire("88a4H");
parcelRequire("6Si8o");
parcelRequire("jhzFH");
parcelRequire("l2NlU");
parcelRequire("ibR9R");

});
parcelRegister("jvR7E", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", () => $e3ca3f5e1802bbd9$export$8a7ad05c3ee0c78a);

var $6ir3O = parcelRequire("6ir3O");
function $e3ca3f5e1802bbd9$export$8a7ad05c3ee0c78a({ error: error }) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.
    return /*#__PURE__*/ (0, $6ir3O.jsxs)("div", {
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)("p", {
                children: "Something went wrong:"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)("pre", {
                style: {
                    color: 'red'
                },
                children: error.message
            })
        ]
    });
}

});

parcelRegister("88a4H", function(module, exports) {
$parcel$export(module.exports, "AdminLayout", () => (parcelRequire("3goov")).AdminLayout);
$parcel$export(module.exports, "Layout", () => (parcelRequire("jDV21")).Layout);
parcelRequire("3goov");
parcelRequire("jDV21");

});
parcelRegister("3goov", function(module, exports) {

$parcel$export(module.exports, "AdminLayout", () => $fce3de6375fee809$export$5d146e06dd3b3225);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $cpdVK = parcelRequire("cpdVK");
var $g1XKJ = parcelRequire("g1XKJ");
var $5ebSC = parcelRequire("5ebSC");
var $kS7Ii = parcelRequire("kS7Ii");

var $7XZ9N = parcelRequire("7XZ9N");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $19GAm = parcelRequire("19GAm");

var $1KFDr = parcelRequire("1KFDr");

var $dvy4k = parcelRequire("dvy4k");
parcelRequire("ibR9R");
var $eHq6M = parcelRequire("eHq6M");
const $fce3de6375fee809$export$5d146e06dd3b3225 = (0, $j8yBr.observer)(({ children: children })=>{
    const userStore = (0, $8DltC.useUserStore)();
    const navigate = (0, $19GAm.useNavigate)();
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $g1XKJ.Grid), {
        height: {
            min: '100vh',
            max: '100vh'
        },
        rows: [
            'auto',
            'auto',
            'flex',
            'auto'
        ],
        columns: [
            'auto',
            'flex'
        ],
        areas: [
            {
                name: 'header',
                start: [
                    0,
                    0
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                name: 'banner',
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    1
                ]
            },
            {
                name: 'main',
                start: [
                    0,
                    2
                ],
                end: [
                    1,
                    2
                ]
            },
            {
                name: 'footer',
                start: [
                    0,
                    3
                ],
                end: [
                    1,
                    3
                ]
            }
        ],
        gap: "none",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5ebSC.Header), {
                gridArea: "header",
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)'
                },
                pad: {
                    horizontal: 'medium'
                },
                height: "72px",
                direction: "row",
                justify: "between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                        as: (0, $a26J5.Button),
                        onClick: ()=>navigate('/admin'),
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7XZ9N.default), {
                                    width: "32",
                                    height: "32"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    weight: 600,
                                    color: "accent-1",
                                    style: {
                                        letterSpacing: '0.1rem'
                                    },
                                    children: "ADMIN"
                                })
                            ]
                        })
                    }),
                    userStore.user?.id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dvy4k.UserMenu), {})
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                gridArea: "banner",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eHq6M.ImpersonationBanner), {})
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                gridArea: "main",
                background: "background-back",
                overflow: "auto",
                pad: {
                    bottom: '110px'
                },
                children: children
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cpdVK.Footer), {
                gridArea: "footer",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1KFDr.FooterNav), {})
            })
        ]
    });
});

});
parcelRegister("8DltC", function(module, exports) {

$parcel$export(module.exports, "useAccountStore", () => $70f35e466a07ad2f$export$17d4feea532c39aa);
$parcel$export(module.exports, "useAdminStore", () => $70f35e466a07ad2f$export$29078ebdd3793843);
$parcel$export(module.exports, "useChatStore", () => $70f35e466a07ad2f$export$5ca9bbfceeb3b458);
$parcel$export(module.exports, "useCommercialStore", () => $70f35e466a07ad2f$export$f64513ae02b1fc12);
$parcel$export(module.exports, "useEstimateStore", () => $70f35e466a07ad2f$export$8bd1f4eec60a7b4b);
$parcel$export(module.exports, "useHoldingFeeStore", () => $70f35e466a07ad2f$export$45b67fc23bdc5ebd);
$parcel$export(module.exports, "useUsageStore", () => $70f35e466a07ad2f$export$bef40e0f53470143);
$parcel$export(module.exports, "useUserStore", () => $70f35e466a07ad2f$export$cc885caaa8b7ab4e);
$parcel$export(module.exports, "useProjectStore", () => $70f35e466a07ad2f$export$feca747fffc3bba5);
$parcel$export(module.exports, "useSessionActivityStore", () => $70f35e466a07ad2f$export$6266187e57cefce9);
$parcel$export(module.exports, "useCostumeStore", () => $70f35e466a07ad2f$export$cf4905158fa53d58);
$parcel$export(module.exports, "useNotificationStore", () => $70f35e466a07ad2f$export$aa94277a9804d2bd);
$parcel$export(module.exports, "usePropStore", () => $70f35e466a07ad2f$export$28c0a70e6c1d590);
$parcel$export(module.exports, "usePerformerStore", () => $70f35e466a07ad2f$export$9972ee3b92b22659);
$parcel$export(module.exports, "useRightStore", () => $70f35e466a07ad2f$export$3b4050a432569a80);
$parcel$export(module.exports, "useRoleStore", () => $70f35e466a07ad2f$export$8e34dfdfd35e292b);
$parcel$export(module.exports, "useSessionStore", () => $70f35e466a07ad2f$export$7a766792c90fc45f);
$parcel$export(module.exports, "useTalentManagerStore", () => $70f35e466a07ad2f$export$451134111d1bf077);
$parcel$export(module.exports, "RootContextProvider", () => $70f35e466a07ad2f$export$773ef8ccef99e88a);

var $6ir3O = parcelRequire("6ir3O");

var $2NacA = parcelRequire("2NacA");
parcelRequire("7Wm5d");
var $fOh1O = parcelRequire("fOh1O");
const $70f35e466a07ad2f$var$RootContext = /*#__PURE__*/ (0, $2NacA.createContext)(undefined);
function $70f35e466a07ad2f$export$5bc58655df8395ab() {
    const context = (0, $2NacA.useContext)($70f35e466a07ad2f$var$RootContext);
    if (context === undefined) throw new Error('useRootStore must be used within RootContextProvider');
    return context;
}
function $70f35e466a07ad2f$export$17d4feea532c39aa() {
    const { accountStore: accountStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (accountStore === undefined) throw new Error('useAccountStore must be used within RootContextProvider');
    return accountStore;
}
function $70f35e466a07ad2f$export$29078ebdd3793843() {
    const { adminStore: adminStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (adminStore === undefined) throw new Error('useAdminStore must be used within RootContextProvider');
    return adminStore;
}
function $70f35e466a07ad2f$export$5ca9bbfceeb3b458() {
    const { chatStore: chatStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (chatStore === undefined) throw new Error('useChatStore must be used within RootContextProvider');
    return chatStore;
}
function $70f35e466a07ad2f$export$f64513ae02b1fc12() {
    const { commercialStore: commercialStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (commercialStore === undefined) throw new Error('useCommercialStore must be used within RootContextProvider');
    return commercialStore;
}
function $70f35e466a07ad2f$export$8bd1f4eec60a7b4b() {
    const { estimateStore: estimateStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (estimateStore === undefined) throw new Error('useEstimateStore must be used within RootContextProvider');
    return estimateStore;
}
function $70f35e466a07ad2f$export$45b67fc23bdc5ebd() {
    const { holdingFeeStore: holdingFeeStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (holdingFeeStore === undefined) throw new Error('useHoldingFeeStore must be used within RootContextProvider');
    return holdingFeeStore;
}
function $70f35e466a07ad2f$export$bef40e0f53470143() {
    const { usageStore: usageStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (usageStore === undefined) throw new Error('useUsageStore must be used within RootContextProvider');
    return usageStore;
}
function $70f35e466a07ad2f$export$cc885caaa8b7ab4e() {
    const { userStore: userStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (userStore === undefined) throw new Error('useUserStore must be used within RootContextProvider');
    return userStore;
}
function $70f35e466a07ad2f$export$feca747fffc3bba5() {
    const { projectStore: projectStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (projectStore === undefined) throw new Error('useProjectStore must be used within RootContextProvider');
    return projectStore;
}
function $70f35e466a07ad2f$export$6266187e57cefce9() {
    const { sessionActivityStore: sessionActivityStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (sessionActivityStore === undefined) throw new Error('useSessionActivityStore must be used within RootContextProvider');
    return sessionActivityStore;
}
function $70f35e466a07ad2f$export$cf4905158fa53d58() {
    const { costumeStore: costumeStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (costumeStore === undefined) throw new Error('useCostumeStore must be used within RootContextProvider');
    return costumeStore;
}
function $70f35e466a07ad2f$export$aa94277a9804d2bd() {
    const { notificationStore: notificationStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (notificationStore === undefined) throw new Error('useNotificationStore must be used within RootContextProvider');
    return notificationStore;
}
function $70f35e466a07ad2f$export$28c0a70e6c1d590() {
    const { propStore: propStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (propStore === undefined) throw new Error('usePropStore must be used within RootContextProvider');
    return propStore;
}
function $70f35e466a07ad2f$export$9972ee3b92b22659() {
    const { performerStore: performerStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (performerStore === undefined) throw new Error('useRoleStore must be used within RootContextProvider');
    return performerStore;
}
function $70f35e466a07ad2f$export$3b4050a432569a80() {
    const { rightStore: rightStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (rightStore === undefined) throw new Error('useRightStore must be used within RootContextProvider');
    return rightStore;
}
function $70f35e466a07ad2f$export$8e34dfdfd35e292b() {
    const { roleStore: roleStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (roleStore === undefined) throw new Error('useRoleStore must be used within RootContextProvider');
    return roleStore;
}
function $70f35e466a07ad2f$export$7a766792c90fc45f() {
    const { sessionStore: sessionStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (sessionStore === undefined) throw new Error('useSessionStore must be used within RootContextProvider');
    return sessionStore;
}
function $70f35e466a07ad2f$export$451134111d1bf077() {
    const { talentManagerStore: talentManagerStore } = $70f35e466a07ad2f$export$5bc58655df8395ab();
    if (talentManagerStore === undefined) throw new Error('useTalentManagerStore must be used within RootContextProvider');
    return talentManagerStore;
}
function $70f35e466a07ad2f$export$773ef8ccef99e88a({ children: children }) {
    const [store] = (0, $2NacA.useState)(()=>new (0, $fOh1O.RootStore)());
    return /*#__PURE__*/ (0, $6ir3O.jsx)($70f35e466a07ad2f$var$RootContext.Provider, {
        value: store,
        children: children
    });
}

});
parcelRegister("7Wm5d", function(module, exports) {
$parcel$export(module.exports, "AccountStore", () => (parcelRequire("7PmFI")).AccountStore);
$parcel$export(module.exports, "AdminStore", () => (parcelRequire("iRK83")).AdminStore);
$parcel$export(module.exports, "ChatStore", () => (parcelRequire("lF2uX")).ChatStore);
$parcel$export(module.exports, "CommercialStore", () => (parcelRequire("dV3a5")).CommercialStore);
$parcel$export(module.exports, "CostumeStore", () => (parcelRequire("77JSJ")).CostumeStore);
$parcel$export(module.exports, "EstimateStore", () => (parcelRequire("kQLpc")).EstimateStore);
$parcel$export(module.exports, "HoldingFeeStore", () => (parcelRequire("d3B3x")).HoldingFeeStore);
$parcel$export(module.exports, "NotificationStore", () => (parcelRequire("lEt3y")).NotificationStore);
$parcel$export(module.exports, "PerformerStore", () => (parcelRequire("e4I9p")).PerformerStore);
$parcel$export(module.exports, "ProjectStore", () => (parcelRequire("5AeDc")).ProjectStore);
$parcel$export(module.exports, "PropStore", () => (parcelRequire("cW2yD")).PropStore);
$parcel$export(module.exports, "RightStore", () => (parcelRequire("a3xGU")).RightStore);
$parcel$export(module.exports, "RoleStore", () => (parcelRequire("jXBXN")).RoleStore);
$parcel$export(module.exports, "RootStore", () => (parcelRequire("fOh1O")).RootStore);
$parcel$export(module.exports, "SessionActivityStore", () => (parcelRequire("2NYgb")).SessionActivityStore);
$parcel$export(module.exports, "SessionStore", () => (parcelRequire("jPINK")).SessionStore);
$parcel$export(module.exports, "TalentManagerStore", () => (parcelRequire("1WQz8")).TalentManagerStore);
$parcel$export(module.exports, "UsageStore", () => (parcelRequire("9dnGJ")).UsageStore);
$parcel$export(module.exports, "UserStore", () => (parcelRequire("22Wl1")).UserStore);
parcelRequire("7PmFI");
parcelRequire("iRK83");
parcelRequire("3kkid");
parcelRequire("lF2uX");
parcelRequire("dV3a5");
parcelRequire("77JSJ");
parcelRequire("kQLpc");
parcelRequire("d3B3x");
parcelRequire("lEt3y");
parcelRequire("e4I9p");
parcelRequire("5AeDc");
parcelRequire("cW2yD");
parcelRequire("a3xGU");
parcelRequire("jXBXN");
parcelRequire("fOh1O");
parcelRequire("2NYgb");
parcelRequire("jPINK");
parcelRequire("1WQz8");
parcelRequire("9dnGJ");
parcelRequire("22Wl1");

});
parcelRegister("7PmFI", function(module, exports) {

$parcel$export(module.exports, "AccountStore", () => $685ea470e9dc199e$export$5b1ba45d47672b60);
parcelRequire("hcQWc");
var $aBFJh = parcelRequire("aBFJh");
var $9JOk8 = parcelRequire("9JOk8");
var $bepzN = parcelRequire("bepzN");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $685ea470e9dc199e$export$5b1ba45d47672b60 extends (0, $3kkid.BaseStore) {
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {});
    }
    // GROUPS
    fetchGroups = async ()=>{
        try {
            const { groups: groups } = await this.q((0, $aBFJh.GroupService).listGroups());
            return groups;
        } catch (e) {
            this.handleError(e);
        }
    };
    getGroup = async (id)=>{
        try {
            const { group: group } = await this.q((0, $aBFJh.GroupService).getGroup(id, 'owner,users,active_users,subscription_plan'));
            return group;
        } catch (e) {
            this.handleError(e);
        }
    };
    createGroup = async ({ name: name, subscription_plan: subscription_plan, users: users })=>{
        if (!name || !subscription_plan) throw new Error('Name, subscription plan, and owner are required');
        const request = {
            name: name,
            subscription_plan_id: subscription_plan.id,
            user_ids: users?.map((u)=>u.id)
        };
        try {
            const { group: group } = await this.q((0, $aBFJh.GroupService).createGroup(request));
            return group;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateGroup = async (id, { name: name, subscription_plan: subscription_plan, users: users, projects: projects, owner: owner, invited_emails: invited_emails, is_jpc_authorizer: is_jpc_authorizer, is_sag_signatory: is_sag_signatory, address: address })=>{
        if (!name || !subscription_plan) throw new Error('Name and subscription plan are required');
        const request = {
            name: name,
            subscription_plan_id: subscription_plan.id,
            user_ids: users?.map((u)=>u.id),
            project_ids: projects?.map((p)=>p.id),
            owner_id: owner?.id,
            invited_emails: invited_emails,
            is_jpc_authorizer: is_jpc_authorizer,
            is_sag_signatory: is_sag_signatory,
            address: address
        };
        try {
            const { group: group } = await this.q((0, $aBFJh.GroupService).updateGroup(id, request));
            return group;
        } catch (e) {
            this.handleError(e);
        }
    };
    acceptGroupInvite = async (t)=>{
        try {
            const { group: group, email: email, token: token, userId: userId } = await this.q((0, $aBFJh.GroupService).acceptInvitation({
                token: t
            }));
            return {
                group: group,
                email: email,
                token: token,
                userId: userId
            };
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteGroupInvite = async ({ email: email, group_id: group_id })=>{
        try {
            return await this.q((0, $aBFJh.GroupService).deleteInvitation(email, group_id));
        } catch (e) {
            this.handleError(e);
        }
    };
    resendInvite = async (req)=>{
        try {
            await this.q((0, $aBFJh.GroupService).resendInvitation(req));
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteGroup = async (id)=>{
        try {
            await this.q((0, $aBFJh.GroupService).deleteGroup(id));
        } catch (e) {
            this.handleError(e);
        }
    };
    fetchPublicSubscriptionPlans = async ()=>{
        try {
            const { subscriptionPlans: subscriptionPlans } = await this.q((0, $bepzN.SubscriptionPlanService).listSubscriptionPlans(undefined, undefined, undefined, 'pricing_tier'));
            return subscriptionPlans?.filter((p)=>p.is_public) ?? [];
        } catch (e) {
            this.handleError(e);
            return [];
        }
    };
    createCheckoutSession = async (pricingTierStripeId)=>{
        try {
            const { url: url } = await this.q((0, $9JOk8.StripeService).createCheckoutSession({
                pricing_tier_stripe_id: pricingTierStripeId,
                return_to: 'account'
            }));
            return url;
        } catch (e) {
            this.handleError(e);
        }
    };
}

});
parcelRegister("hcQWc", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => (parcelRequire("kvCbJ")).ApiError);
$parcel$export(module.exports, "OpenAPI", () => (parcelRequire("cS8Vf")).OpenAPI);
$parcel$export(module.exports, "AssetType", () => (parcelRequire("asThd")).AssetType);
$parcel$export(module.exports, "AudioMadeMove", () => (parcelRequire("4AdaL")).AudioMadeMove);
$parcel$export(module.exports, "AuditLogAction", () => (parcelRequire("7BLyQ")).AuditLogAction);
$parcel$export(module.exports, "CommercialType", () => (parcelRequire("3qs6L")).CommercialType);
$parcel$export(module.exports, "ConversationStatus", () => (parcelRequire("3byqD")).ConversationStatus);
$parcel$export(module.exports, "ConversationType", () => (parcelRequire("1H2Fg")).ConversationType);
$parcel$export(module.exports, "CostumeType", () => (parcelRequire("8PeUS")).CostumeType);
$parcel$export(module.exports, "DocumentType", () => (parcelRequire("6yFNt")).DocumentType);
$parcel$export(module.exports, "EditReviewStatus", () => (parcelRequire("7FCbb")).EditReviewStatus);
$parcel$export(module.exports, "EditType", () => (parcelRequire("w4qgw")).EditType);
$parcel$export(module.exports, "EstimateStatus", () => (parcelRequire("djcqs")).EstimateStatus);
$parcel$export(module.exports, "GroupSubscriptionStatus", () => (parcelRequire("jAKcc")).GroupSubscriptionStatus);
$parcel$export(module.exports, "GroupType", () => (parcelRequire("iSjIF")).GroupType);
$parcel$export(module.exports, "HoldingFeeCycleStatus", () => (parcelRequire("7nm6N")).HoldingFeeCycleStatus);
$parcel$export(module.exports, "LocationType", () => (parcelRequire("gGAG2")).LocationType);
$parcel$export(module.exports, "MarketSpecification", () => (parcelRequire("1KFVI")).MarketSpecification);
$parcel$export(module.exports, "MessageType", () => (parcelRequire("d18Ah")).MessageType);
$parcel$export(module.exports, "PaymentType", () => (parcelRequire("l8JXt")).PaymentType);
$parcel$export(module.exports, "PerformerContractStatus", () => (parcelRequire("l56av")).PerformerContractStatus);
$parcel$export(module.exports, "PerformerContractType", () => (parcelRequire("fj6A2")).PerformerContractType);
$parcel$export(module.exports, "PerformerOnboardingStatus", () => (parcelRequire("fqLMT")).PerformerOnboardingStatus);
$parcel$export(module.exports, "PerformerRelationship", () => (parcelRequire("3vCIk")).PerformerRelationship);
$parcel$export(module.exports, "ProcessingStatus", () => (parcelRequire("4qvRz")).ProcessingStatus);
$parcel$export(module.exports, "PropType", () => (parcelRequire("i8q6u")).PropType);
$parcel$export(module.exports, "RightStatus", () => (parcelRequire("cVyZf")).RightStatus);
$parcel$export(module.exports, "RightType", () => (parcelRequire("kO7OK")).RightType);
$parcel$export(module.exports, "RolePerformerType", () => (parcelRequire("8kKyn")).RolePerformerType);
$parcel$export(module.exports, "RoleType", () => (parcelRequire("lUAc5")).RoleType);
$parcel$export(module.exports, "SessionActivityType", () => (parcelRequire("9C19V")).SessionActivityType);
$parcel$export(module.exports, "SessionEstimateItemUnitType", () => (parcelRequire("7dV2j")).SessionEstimateItemUnitType);
$parcel$export(module.exports, "StudioZone", () => (parcelRequire("eJ3Q3")).StudioZone);
$parcel$export(module.exports, "TalentManagerApprovalStatus", () => (parcelRequire("6BDfZ")).TalentManagerApprovalStatus);
$parcel$export(module.exports, "TContractSignatureRequest", () => (parcelRequire("hX2Cj")).TContractSignatureRequest);
$parcel$export(module.exports, "TOAuthProvider", () => (parcelRequire("fxTdv")).TOAuthProvider);
$parcel$export(module.exports, "UsageCycleNumber", () => (parcelRequire("8wESq")).UsageCycleNumber);
$parcel$export(module.exports, "UsageCycleUnit", () => (parcelRequire("RoqvF")).UsageCycleUnit);
$parcel$export(module.exports, "UsagePlatform", () => (parcelRequire("1bvuP")).UsagePlatform);
$parcel$export(module.exports, "UsageType", () => (parcelRequire("4bBQG")).UsageType);
$parcel$export(module.exports, "UsageTypeCategory", () => (parcelRequire("69JXC")).UsageTypeCategory);
$parcel$export(module.exports, "UsageUnitType", () => (parcelRequire("i2YYW")).UsageUnitType);
$parcel$export(module.exports, "UsesType", () => (parcelRequire("etRr4")).UsesType);
$parcel$export(module.exports, "AdvertiserService", () => (parcelRequire("hafFH")).AdvertiserService);
$parcel$export(module.exports, "AssetService", () => (parcelRequire("gYVLq")).AssetService);
$parcel$export(module.exports, "AuditService", () => (parcelRequire("leCVP")).AuditService);
$parcel$export(module.exports, "AuthenticationService", () => (parcelRequire("5VwGg")).AuthenticationService);
$parcel$export(module.exports, "ChatService", () => (parcelRequire("lQtnN")).ChatService);
$parcel$export(module.exports, "CommercialService", () => (parcelRequire("leMeY")).CommercialService);
$parcel$export(module.exports, "ConversationService", () => (parcelRequire("dlTVI")).ConversationService);
$parcel$export(module.exports, "CostumeService", () => (parcelRequire("bG9RN")).CostumeService);
$parcel$export(module.exports, "CreditsService", () => (parcelRequire("8zK2X")).CreditsService);
$parcel$export(module.exports, "DocumentService", () => (parcelRequire("1XZc5")).DocumentService);
$parcel$export(module.exports, "EditService", () => (parcelRequire("2R8LL")).EditService);
$parcel$export(module.exports, "EditReviewService", () => (parcelRequire("emlIu")).EditReviewService);
$parcel$export(module.exports, "EstimateService", () => (parcelRequire("NcqgP")).EstimateService);
$parcel$export(module.exports, "FeatureService", () => (parcelRequire("bUwq7")).FeatureService);
$parcel$export(module.exports, "GroupService", () => (parcelRequire("aBFJh")).GroupService);
$parcel$export(module.exports, "HealthCheckService", () => (parcelRequire("cY3qa")).HealthCheckService);
$parcel$export(module.exports, "HoldingFeeService", () => (parcelRequire("lU3Ny")).HoldingFeeService);
$parcel$export(module.exports, "LocationService", () => (parcelRequire("kQx3f")).LocationService);
$parcel$export(module.exports, "NotificationService", () => (parcelRequire("iE4UJ")).NotificationService);
$parcel$export(module.exports, "PerformerService", () => (parcelRequire("1KlRo")).PerformerService);
$parcel$export(module.exports, "PerformerContractService", () => (parcelRequire("g87cD")).PerformerContractService);
$parcel$export(module.exports, "PricingTierService", () => (parcelRequire("lhiX6")).PricingTierService);
$parcel$export(module.exports, "ProjectService", () => (parcelRequire("dvSQf")).ProjectService);
$parcel$export(module.exports, "PropService", () => (parcelRequire("3bCvT")).PropService);
$parcel$export(module.exports, "RightService", () => (parcelRequire("1b5lS")).RightService);
$parcel$export(module.exports, "RoleService", () => (parcelRequire("f9fOF")).RoleService);
$parcel$export(module.exports, "RoleActivityService", () => (parcelRequire("gR3wM")).RoleActivityService);
$parcel$export(module.exports, "RoleGroupService", () => (parcelRequire("khgRv")).RoleGroupService);
$parcel$export(module.exports, "ScriptService", () => (parcelRequire("iKpUE")).ScriptService);
$parcel$export(module.exports, "SecretService", () => (parcelRequire("jBzsC")).SecretService);
$parcel$export(module.exports, "SessionService", () => (parcelRequire("bHCgu")).SessionService);
$parcel$export(module.exports, "SessionActivityService", () => (parcelRequire("apSGY")).SessionActivityService);
$parcel$export(module.exports, "SessionEstimateService", () => (parcelRequire("ieh93")).SessionEstimateService);
$parcel$export(module.exports, "SessionEstimateItemService", () => (parcelRequire("lEuQR")).SessionEstimateItemService);
$parcel$export(module.exports, "StripeService", () => (parcelRequire("9JOk8")).StripeService);
$parcel$export(module.exports, "StripeConnectService", () => (parcelRequire("9Bndg")).StripeConnectService);
$parcel$export(module.exports, "SubscriptionPlanService", () => (parcelRequire("bepzN")).SubscriptionPlanService);
$parcel$export(module.exports, "TalentManagerService", () => (parcelRequire("6g3QY")).TalentManagerService);
$parcel$export(module.exports, "TalentManagerEngagementService", () => (parcelRequire("03jfi")).TalentManagerEngagementService);
$parcel$export(module.exports, "TalentManagerTimeService", () => (parcelRequire("iC8zV")).TalentManagerTimeService);
$parcel$export(module.exports, "UsageService", () => (parcelRequire("f7GXT")).UsageService);
$parcel$export(module.exports, "UsageEstimateService", () => (parcelRequire("aFNng")).UsageEstimateService);
$parcel$export(module.exports, "UsageEstimateItemService", () => (parcelRequire("5yg4I")).UsageEstimateItemService);
$parcel$export(module.exports, "UserService", () => (parcelRequire("ai2Ek")).UserService);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $kvCbJ = parcelRequire("kvCbJ");

var $b8TSx = parcelRequire("b8TSx");

var $cS8Vf = parcelRequire("cS8Vf");

var $lncFI = parcelRequire("lncFI");

var $asThd = parcelRequire("asThd");

var $4AdaL = parcelRequire("4AdaL");

var $7BLyQ = parcelRequire("7BLyQ");

var $ehT8l = parcelRequire("ehT8l");

var $3qs6L = parcelRequire("3qs6L");

var $dcC4P = parcelRequire("dcC4P");

var $3byqD = parcelRequire("3byqD");

var $1H2Fg = parcelRequire("1H2Fg");

var $8PeUS = parcelRequire("8PeUS");

var $gYP3U = parcelRequire("gYP3U");

var $6yFNt = parcelRequire("6yFNt");

var $7FCbb = parcelRequire("7FCbb");

var $w4qgw = parcelRequire("w4qgw");

var $djcqs = parcelRequire("djcqs");

var $a5Y8b = parcelRequire("a5Y8b");

var $cVwYS = parcelRequire("cVwYS");

var $jAKcc = parcelRequire("jAKcc");

var $iSjIF = parcelRequire("iSjIF");

var $7nm6N = parcelRequire("7nm6N");

var $gGAG2 = parcelRequire("gGAG2");

var $1KFVI = parcelRequire("1KFVI");

var $95ttx = parcelRequire("95ttx");

var $poNgP = parcelRequire("poNgP");

var $d18Ah = parcelRequire("d18Ah");

var $R2IDo = parcelRequire("R2IDo");

var $l8JXt = parcelRequire("l8JXt");

var $l56av = parcelRequire("l56av");

var $fj6A2 = parcelRequire("fj6A2");

var $fqLMT = parcelRequire("fqLMT");

var $3vCIk = parcelRequire("3vCIk");

var $4qvRz = parcelRequire("4qvRz");

var $i8q6u = parcelRequire("i8q6u");

var $cVyZf = parcelRequire("cVyZf");

var $kO7OK = parcelRequire("kO7OK");

var $8kKyn = parcelRequire("8kKyn");

var $iGNlr = parcelRequire("iGNlr");

var $ggknl = parcelRequire("ggknl");

var $lUAc5 = parcelRequire("lUAc5");

var $9C19V = parcelRequire("9C19V");

var $7dV2j = parcelRequire("7dV2j");

var $eJ3Q3 = parcelRequire("eJ3Q3");

var $6BDfZ = parcelRequire("6BDfZ");

var $6weww = parcelRequire("6weww");

var $hX2Cj = parcelRequire("hX2Cj");

var $dxpnu = parcelRequire("dxpnu");

var $7PLVa = parcelRequire("7PLVa");

var $fxTdv = parcelRequire("fxTdv");

var $3xgsY = parcelRequire("3xgsY");

var $8wESq = parcelRequire("8wESq");

var $RoqvF = parcelRequire("RoqvF");

var $iPDTI = parcelRequire("iPDTI");

var $1bvuP = parcelRequire("1bvuP");

var $4bBQG = parcelRequire("4bBQG");

var $69JXC = parcelRequire("69JXC");

var $i2YYW = parcelRequire("i2YYW");

var $etRr4 = parcelRequire("etRr4");

var $5fP8A = parcelRequire("5fP8A");

var $hafFH = parcelRequire("hafFH");

var $bd4rl = parcelRequire("bd4rl");

var $gYVLq = parcelRequire("gYVLq");

var $leCVP = parcelRequire("leCVP");

var $5VwGg = parcelRequire("5VwGg");

var $lQtnN = parcelRequire("lQtnN");

var $leMeY = parcelRequire("leMeY");

var $dlTVI = parcelRequire("dlTVI");

var $bG9RN = parcelRequire("bG9RN");

var $8zK2X = parcelRequire("8zK2X");

var $1XZc5 = parcelRequire("1XZc5");

var $2R8LL = parcelRequire("2R8LL");

var $emlIu = parcelRequire("emlIu");

var $NcqgP = parcelRequire("NcqgP");

var $bUwq7 = parcelRequire("bUwq7");

var $cGwx1 = parcelRequire("cGwx1");

var $aBFJh = parcelRequire("aBFJh");

var $cY3qa = parcelRequire("cY3qa");

var $lU3Ny = parcelRequire("lU3Ny");

var $i9Nmr = parcelRequire("i9Nmr");

var $kQx3f = parcelRequire("kQx3f");

var $iE4UJ = parcelRequire("iE4UJ");

var $1KlRo = parcelRequire("1KlRo");

var $g87cD = parcelRequire("g87cD");

var $lhiX6 = parcelRequire("lhiX6");

var $dvSQf = parcelRequire("dvSQf");

var $3bCvT = parcelRequire("3bCvT");

var $1b5lS = parcelRequire("1b5lS");

var $f9fOF = parcelRequire("f9fOF");

var $gR3wM = parcelRequire("gR3wM");

var $khgRv = parcelRequire("khgRv");

var $iKpUE = parcelRequire("iKpUE");

var $jBzsC = parcelRequire("jBzsC");

var $bHCgu = parcelRequire("bHCgu");

var $apSGY = parcelRequire("apSGY");

var $ieh93 = parcelRequire("ieh93");

var $lEuQR = parcelRequire("lEuQR");

var $9JOk8 = parcelRequire("9JOk8");

var $9Bndg = parcelRequire("9Bndg");

var $bepzN = parcelRequire("bepzN");

var $4iQ82 = parcelRequire("4iQ82");

var $6g3QY = parcelRequire("6g3QY");

var $03jfi = parcelRequire("03jfi");

var $iC8zV = parcelRequire("iC8zV");

var $f7GXT = parcelRequire("f7GXT");

var $aFNng = parcelRequire("aFNng");

var $5yg4I = parcelRequire("5yg4I");

var $ai2Ek = parcelRequire("ai2Ek");

});
parcelRegister("kvCbJ", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $a6314ff349dd7f79$export$f2e832acab1bdd79);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $a6314ff349dd7f79$export$f2e832acab1bdd79 extends Error {
    url;
    status;
    statusText;
    body;
    request;
    constructor(request, response, message){
        super(message);
        this.name = 'ApiError';
        this.url = response.url;
        this.status = response.status;
        this.statusText = response.statusText;
        this.body = response.body;
        this.request = request;
    }
}

});

parcelRegister("b8TSx", function(module, exports) {

$parcel$export(module.exports, "CancelablePromise", () => $c048ae679cef3e05$export$551a058e9626aa5a);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $c048ae679cef3e05$export$d7f5e52d091a66db extends Error {
    constructor(message){
        super(message);
        this.name = 'CancelError';
    }
    get isCancelled() {
        return true;
    }
}
class $c048ae679cef3e05$export$551a058e9626aa5a {
    #isResolved;
    #isRejected;
    #isCancelled;
    #cancelHandlers;
    #promise;
    #resolve;
    #reject;
    constructor(executor){
        this.#isResolved = false;
        this.#isRejected = false;
        this.#isCancelled = false;
        this.#cancelHandlers = [];
        this.#promise = new Promise((resolve, reject)=>{
            this.#resolve = resolve;
            this.#reject = reject;
            const onResolve = (value)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isResolved = true;
                if (this.#resolve) this.#resolve(value);
            };
            const onReject = (reason)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isRejected = true;
                if (this.#reject) this.#reject(reason);
            };
            const onCancel = (cancelHandler)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#cancelHandlers.push(cancelHandler);
            };
            Object.defineProperty(onCancel, 'isResolved', {
                get: ()=>this.#isResolved
            });
            Object.defineProperty(onCancel, 'isRejected', {
                get: ()=>this.#isRejected
            });
            Object.defineProperty(onCancel, 'isCancelled', {
                get: ()=>this.#isCancelled
            });
            return executor(onResolve, onReject, onCancel);
        });
    }
    get [Symbol.toStringTag]() {
        return "Cancellable Promise";
    }
    then(onFulfilled, onRejected) {
        return this.#promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this.#promise.catch(onRejected);
    }
    finally(onFinally) {
        return this.#promise.finally(onFinally);
    }
    cancel() {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
        this.#isCancelled = true;
        if (this.#cancelHandlers.length) try {
            for (const cancelHandler of this.#cancelHandlers)cancelHandler();
        } catch (error) {
            console.warn('Cancellation threw an error', error);
            return;
        }
        this.#cancelHandlers.length = 0;
        if (this.#reject) this.#reject(new $c048ae679cef3e05$export$d7f5e52d091a66db('Request aborted'));
    }
    get isCancelled() {
        return this.#isCancelled;
    }
}

});

parcelRegister("cS8Vf", function(module, exports) {

$parcel$export(module.exports, "OpenAPI", () => $185ea76495790c51$export$3bbbb17165d6e0ef);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ const $185ea76495790c51$export$3bbbb17165d6e0ef = {
    BASE: '/api/v1',
    VERSION: '0.3.0',
    WITH_CREDENTIALS: false,
    CREDENTIALS: 'include',
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
    ENCODE_PATH: undefined
};

});

parcelRegister("lncFI", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Allowance
 */ var $381f4e930c3ea0b0$export$11a17db1639c2f55 = /*#__PURE__*/ function(AllowanceType) {
    AllowanceType["Wardrobe_Fee"] = "Wardrobe Fee";
    AllowanceType["Wardrobe_FeeEvePeriod"] = "Wardrobe Fee - Eve/Period";
    AllowanceType["LocationMeal_Breakfast"] = "Breakfast";
    AllowanceType["LocationMeal_Lunch"] = "Lunch";
    AllowanceType["LocationMeal_Dinnner"] = "Dinnner";
    AllowanceType["Travel_ExtrasRoundTrip"] = "Extras - Round Trip";
    AllowanceType["Travel_PerMileOutsideStudioZone"] = "Per mile (outside studio zone)";
    AllowanceType["Travel_OCPPerDiem"] = "OCP travel per diem";
    AllowanceType["Props_AutomobileTrailerMotorcycle"] = "Automobile, Trailer or Motorcycle";
    AllowanceType["Props_SkatesSkateBoards"] = "Skates and Skate Boards";
    AllowanceType["Props_Bicycle"] = "Bicycle";
    AllowanceType["Props_Moped"] = "Moped";
    AllowanceType["Props_Camera"] = "Camera";
    AllowanceType["Props_Pet"] = "Pet";
    AllowanceType["Props_LuggageEachPiece"] = "Luggage (each piece)";
    AllowanceType["Props_GolfClubsAndBag"] = "Golf Clubs & Bag";
    AllowanceType["Props_TennisRacquet"] = "Tennis Racquet";
    AllowanceType["Props_Skis"] = "Skis";
    AllowanceType["Props_BinocularsOperaGlasses"] = "Binoculars or Opera Glasses";
    AllowanceType["Props_LargePortableRadios"] = "Large Portable Radios";
    AllowanceType["Props_BooksEach"] = "Books (each)";
    AllowanceType["Props_LaptopCellPhonePDAiPodMP3Player"] = "Laptop, Cell Phone/PDA, iPod/MP3 Player";
    AllowanceType["Props_StandardOpeningOrClosing"] = "Standard Opening or Closing";
    AllowanceType["Props_WetSnowmokeDustWork"] = "Wet, Snow, Smoke, & Dust Work";
    AllowanceType["Props_BodyMUSkullCapHairGoodsHaircuts"] = "Body MU, Skull Cap, Hair Goods, Haircuts";
    return AllowanceType;
}({});

});

parcelRegister("asThd", function(module, exports) {

$parcel$export(module.exports, "AssetType", () => $72fd0f028e688a72$export$e57062a38354425e);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Enums
 */ var $72fd0f028e688a72$export$e57062a38354425e = /*#__PURE__*/ function(AssetType) {
    AssetType["Video"] = "Video";
    AssetType["Image"] = "Image";
    AssetType["Audio"] = "Audio";
    AssetType["Document"] = "Document";
    return AssetType;
}({});

});

parcelRegister("4AdaL", function(module, exports) {

$parcel$export(module.exports, "AudioMadeMove", () => $8604ea8691734a30$export$a15c75067d344f85);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $8604ea8691734a30$export$a15c75067d344f85 = /*#__PURE__*/ function(AudioMadeMove) {
    AudioMadeMove["MoveOver"] = "Move Over";
    AudioMadeMove["MadeFor"] = "Made For";
    return AudioMadeMove;
}({});

});

parcelRegister("7BLyQ", function(module, exports) {

$parcel$export(module.exports, "AuditLogAction", () => $d5136ad75848dc08$export$c6df803af6dda639);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $d5136ad75848dc08$export$c6df803af6dda639 = /*#__PURE__*/ function(AuditLogAction) {
    AuditLogAction["INSERT"] = "insert";
    AuditLogAction["UPDATE"] = "update";
    AuditLogAction["DELETE"] = "delete";
    AuditLogAction["IMPERSONATION_START"] = "impersonation_start";
    return AuditLogAction;
}({});

});

parcelRegister("ehT8l", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $039ecbf967af208c$export$785de5377743f4d9 = /*#__PURE__*/ function(CableMarket) {
    CableMarket["NationalCable"] = "National Cable";
    CableMarket["LocalCableUpTo1MSubscribers"] = "Local Cable (Up To 1M Subscribers)";
    CableMarket["LocalCable1MTo2MSubscribers"] = "Local Cable (1M To 2M Subscribers)";
    CableMarket["LocalCable2MPlusSubscribers"] = "Local Cable (2M Plus Subscribers)";
    return CableMarket;
}({});

});

parcelRegister("3qs6L", function(module, exports) {

$parcel$export(module.exports, "CommercialType", () => $b40d6d52e6791d88$export$5d4650a49bf64f57);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Type
 */ var $b40d6d52e6791d88$export$5d4650a49bf64f57 = /*#__PURE__*/ function(CommercialType) {
    CommercialType["TV"] = "TV";
    CommercialType["Radio"] = "Radio";
    CommercialType["Digital"] = "Digital";
    CommercialType["Print"] = "Print";
    CommercialType["OOH"] = "OOH";
    CommercialType["Social"] = "Social";
    CommercialType["BTS"] = "BTS";
    CommercialType["Other"] = "Other";
    return CommercialType;
}({});

});

parcelRegister("dcC4P", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $331575a331245b94$export$c0549d1afec05d13 = /*#__PURE__*/ function(ConversationParticipantRole) {
    ConversationParticipantRole["AGENCY"] = "agency";
    ConversationParticipantRole["TALENT_MANAGER"] = "talentManager";
    ConversationParticipantRole["SUPPORT"] = "support";
    ConversationParticipantRole["ADMIN_OBSERVER"] = "adminObserver";
    return ConversationParticipantRole;
}({});

});

parcelRegister("3byqD", function(module, exports) {

$parcel$export(module.exports, "ConversationStatus", () => $5103829ab6e73beb$export$3a941682f82314e9);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $5103829ab6e73beb$export$3a941682f82314e9 = /*#__PURE__*/ function(ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["CLOSED"] = "closed";
    return ConversationStatus;
}({});

});

parcelRegister("1H2Fg", function(module, exports) {

$parcel$export(module.exports, "ConversationType", () => $63d31b856b958fe3$export$e5064b6186a4d6a9);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $63d31b856b958fe3$export$e5064b6186a4d6a9 = /*#__PURE__*/ function(ConversationType) {
    ConversationType["SUPPORT"] = "support";
    ConversationType["TALENT_MANAGER"] = "talentManager";
    ConversationType["PROJECT"] = "project";
    return ConversationType;
}({});

});

parcelRegister("8PeUS", function(module, exports) {

$parcel$export(module.exports, "CostumeType", () => $b6ae62fd4b3bfa99$export$ff76eb2ffa7a3c6f);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Costume Type
 */ var $b6ae62fd4b3bfa99$export$ff76eb2ffa7a3c6f = /*#__PURE__*/ function(CostumeType) {
    CostumeType["Standard"] = "Standard";
    CostumeType["EveningWear"] = "Evening Wear";
    CostumeType["PeriodWear"] = "Period Wear";
    return CostumeType;
}({});

});

parcelRegister("gYP3U", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $51ee25e50a14af85$export$5a6834789aa380ac = /*#__PURE__*/ function(CreditPurchaseStatus) {
    CreditPurchaseStatus["PENDING"] = "pending";
    CreditPurchaseStatus["COMPLETED"] = "completed";
    CreditPurchaseStatus["REFUNDED"] = "refunded";
    return CreditPurchaseStatus;
}({});

});

parcelRegister("6yFNt", function(module, exports) {

$parcel$export(module.exports, "DocumentType", () => $dfaebb0620302d8a$export$d1d99cf900472499);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Enums
 */ var $dfaebb0620302d8a$export$d1d99cf900472499 = /*#__PURE__*/ function(DocumentType) {
    DocumentType["Script"] = "Script";
    DocumentType["Storyboard"] = "Storyboard";
    DocumentType["ShootingSchedule"] = "Shoot Schedule";
    DocumentType["MediaPlan"] = "Media Plan";
    DocumentType["Contract"] = "Contract";
    DocumentType["License"] = "License";
    DocumentType["Generic"] = "Generic";
    return DocumentType;
}({});

});

parcelRegister("7FCbb", function(module, exports) {

$parcel$export(module.exports, "EditReviewStatus", () => $5377e5495894dac6$export$d019d4ae00763f3);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Edit Review Status
 */ var $5377e5495894dac6$export$d019d4ae00763f3 = /*#__PURE__*/ function(EditReviewStatus) {
    EditReviewStatus["PENDING"] = "pending";
    EditReviewStatus["PROCESSING"] = "processing";
    EditReviewStatus["COMPLETED"] = "completed";
    EditReviewStatus["FAILED"] = "failed";
    return EditReviewStatus;
}({});

});

parcelRegister("w4qgw", function(module, exports) {

$parcel$export(module.exports, "EditType", () => $7cebcf297f71f88c$export$5292a05d12e7ab31);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Edit Types
 *
 * Part I, Section 26
 */ var $7cebcf297f71f88c$export$5292a05d12e7ab31 = /*#__PURE__*/ function(EditType) {
    EditType["MainAsset"] = "Main Asset";
    EditType["ShorterOrLongerVersion"] = "Shorter Or Longer Version";
    EditType["PermittedChanges"] = "Permitted Changes";
    EditType["PaidEdits"] = "Paid Edits";
    EditType["AddressableEdits"] = "Addressable Edits";
    return EditType;
}({});

});

parcelRegister("djcqs", function(module, exports) {

$parcel$export(module.exports, "EstimateStatus", () => $231d90e679336d97$export$9ded2f8358be1890);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $231d90e679336d97$export$9ded2f8358be1890 = /*#__PURE__*/ function(EstimateStatus) {
    EstimateStatus["Draft"] = "Draft";
    EstimateStatus["Final"] = "Final";
    return EstimateStatus;
}({});

});

parcelRegister("a5Y8b", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Fee Types
 */ var $3244e66f7e7a47ef$export$dbe2689247f3f973 = /*#__PURE__*/ function(FeeType) {
    FeeType["MealPeriodViolation"] = "Meal Period Violation";
    FeeType["LatePayDamagesPerDayLT25"] = "Up to 25 Days (Per Day)";
    FeeType["LatePayDamagesMaximum"] = "Maximum";
    FeeType["LatePayDamagesOnNonPaymentNotice"] = "On Non-Nayment Notice";
    FeeType["LatePayDamagesPerDayAfterNonPaymentNoticeGTE25"] = "Each Day After Non-Payment Notice \u2267 25 days";
    return FeeType;
}({});

});

parcelRegister("cVwYS", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $76008d66199e4729$export$1b897e40c12e1f34 = /*#__PURE__*/ function(GlobalMarket) {
    GlobalMarket["Americas"] = "Americas";
    GlobalMarket["Caribbean"] = "Caribbean";
    GlobalMarket["AmericasAndCaribbean"] = "Americas And Caribbean";
    GlobalMarket["UK"] = "United Kingdom";
    GlobalMarket["Europe"] = "Europe";
    GlobalMarket["AsiaPacific"] = "Asia Pacific";
    GlobalMarket["Japan"] = "Japan";
    GlobalMarket["RestOfWorld"] = "Rest Of World";
    GlobalMarket["Worldwide"] = "Worldwide";
    return GlobalMarket;
}({});

});

parcelRegister("jAKcc", function(module, exports) {

$parcel$export(module.exports, "GroupSubscriptionStatus", () => $3479fec7be578850$export$f4d1e047cdac8dab);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $3479fec7be578850$export$f4d1e047cdac8dab = /*#__PURE__*/ function(GroupSubscriptionStatus) {
    GroupSubscriptionStatus["PENDING_PAYMENT"] = "pending_payment";
    GroupSubscriptionStatus["TRIALING"] = "trialing";
    GroupSubscriptionStatus["ACTIVE"] = "active";
    GroupSubscriptionStatus["PAST_DUE"] = "past_due";
    GroupSubscriptionStatus["CANCELED"] = "canceled";
    return GroupSubscriptionStatus;
}({});

});

parcelRegister("iSjIF", function(module, exports) {

$parcel$export(module.exports, "GroupType", () => $2d15fdb41b2a0153$export$d460f747b73abb10);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $2d15fdb41b2a0153$export$d460f747b73abb10 = /*#__PURE__*/ function(GroupType) {
    GroupType["ADVERTISER"] = "advertiser";
    GroupType["AD_AGENCY"] = "ad_agency";
    GroupType["PRODUCTION_COMPANY"] = "production_company";
    GroupType["TALENT"] = "talent";
    GroupType["TALENT_AGENCY"] = "talent_agency";
    return GroupType;
}({});

});

parcelRegister("7nm6N", function(module, exports) {

$parcel$export(module.exports, "HoldingFeeCycleStatus", () => $a8ae019fec5d51ca$export$6bf7a712bebc413);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $a8ae019fec5d51ca$export$6bf7a712bebc413 = /*#__PURE__*/ function(HoldingFeeCycleStatus) {
    HoldingFeeCycleStatus["PAID"] = "Paid";
    HoldingFeeCycleStatus["WAIVED"] = "Waived";
    return HoldingFeeCycleStatus;
}({});

});

parcelRegister("gGAG2", function(module, exports) {

$parcel$export(module.exports, "LocationType", () => $9d5ad62fd707ca52$export$ec50e3f346457d89);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Location Type
 *
 * "Nearby" is a location where you return to the reporting site at EOD
 * "Distant" is a location that requires an overnight stay
 */ var $9d5ad62fd707ca52$export$ec50e3f346457d89 = /*#__PURE__*/ function(LocationType) {
    LocationType["Studio"] = "Studio";
    LocationType["Nearby"] = "Nearby";
    LocationType["Distant"] = "Distant";
    LocationType["Airport"] = "Airport";
    return LocationType;
}({});

});

parcelRegister("1KFVI", function(module, exports) {

$parcel$export(module.exports, "MarketSpecification", () => $257e0f1bd0a2b227$export$2520daae526a6943);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $257e0f1bd0a2b227$export$2520daae526a6943 = /*#__PURE__*/ function(MarketSpecification) {
    MarketSpecification["All"] = "All Markets";
    MarketSpecification["NoNYChiLA"] = "All Markets (No NY/CHI/LA)";
    MarketSpecification["NoMajor"] = "No Major Markets";
    MarketSpecification["NYOnly"] = "NY Only";
    MarketSpecification["LAOrChicago"] = "LA Or Chicago Only";
    MarketSpecification["TwoOfLANYChicago"] = "2 Of LA, NY, Chicago";
    MarketSpecification["LANYAndChicago"] = "LA, NY, And Chicago";
    MarketSpecification["WithNY"] = "With NY";
    MarketSpecification["WithoutNY"] = "Without NY";
    return MarketSpecification;
}({});

});

parcelRegister("95ttx", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $c64680208d1d663e$export$739b0676f5728098 = /*#__PURE__*/ function(MediaCategory) {
    MediaCategory["TV"] = "TV";
    MediaCategory["Digital"] = "Digital";
    MediaCategory["Social"] = "Social Media";
    MediaCategory["OOH"] = "Out-of-home";
    MediaCategory["Radio"] = "Radio";
    return MediaCategory;
}({});

});

parcelRegister("poNgP", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $51518b22d6a67dd6$export$737491f7ec0a1fed = /*#__PURE__*/ function(MentionTargetType) {
    MentionTargetType["USER"] = "user";
    MentionTargetType["BOT"] = "bot";
    MentionTargetType["SUPPORT"] = "support";
    return MentionTargetType;
}({});

});

parcelRegister("d18Ah", function(module, exports) {

$parcel$export(module.exports, "MessageType", () => $08c76d075f851b17$export$80edbf15fa61a4db);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $08c76d075f851b17$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["AI_MESSAGE"] = "aiMessage";
    MessageType["CHARACTER_PHOTOS_UPLOADED"] = "characterPhotosUploaded";
    MessageType["ERROR_MESSAGE"] = "errorMessage";
    MessageType["NEW_CONVERSATION"] = "newConversation";
    MessageType["NOTIFICATION"] = "notification";
    MessageType["PERFORMER_CONTRACT_DECLINED"] = "performerContractDeclined";
    MessageType["SUPPORT_MESSAGE"] = "supportMessage";
    MessageType["SYSTEM_MESSAGE"] = "systemMessage";
    MessageType["TYPING"] = "typing";
    MessageType["UPDATED_CONVERSATION"] = "updatedConversation";
    MessageType["USER_MESSAGE"] = "userMessage";
    return MessageType;
}({});

});

parcelRegister("R2IDo", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ (function(Partial_Omit_TCreatePerformerContractRequest_performerId_or_projectId_or_contractType__) {
    (function(classification) {
        classification["ON_CAMERA"] = "on_camera";
        classification["OFF_CAMERA"] = "off_camera";
    })(Partial_Omit_TCreatePerformerContractRequest_performerId_or_projectId_or_contractType__.classification || (Partial_Omit_TCreatePerformerContractRequest_performerId_or_projectId_or_contractType__.classification = {}));
})($dcf365b2fdb5fcd8$export$64c4d061305d7900 || ($dcf365b2fdb5fcd8$export$64c4d061305d7900 = {}));
var $dcf365b2fdb5fcd8$export$64c4d061305d7900;

});

parcelRegister("l8JXt", function(module, exports) {

$parcel$export(module.exports, "PaymentType", () => $f861b4aa0c587502$export$439d2d6c03747598);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $f861b4aa0c587502$export$439d2d6c03747598 = /*#__PURE__*/ function(PaymentType) {
    PaymentType["SessionFee"] = "Session Fee";
    PaymentType["Reuse"] = "Reuse";
    PaymentType["HoldingFee"] = "Holding Fee";
    PaymentType["Other"] = "Other";
    return PaymentType;
}({});

});

parcelRegister("l56av", function(module, exports) {

$parcel$export(module.exports, "PerformerContractStatus", () => $343dec853022f81e$export$e1e7dea5d3c4ac5c);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $343dec853022f81e$export$e1e7dea5d3c4ac5c = /*#__PURE__*/ function(PerformerContractStatus) {
    PerformerContractStatus["Draft"] = "draft";
    PerformerContractStatus["Pending"] = "pending";
    PerformerContractStatus["Sent"] = "sent";
    PerformerContractStatus["PerformerSigned"] = "performer_signed";
    PerformerContractStatus["ProducerSigned"] = "producer_signed";
    PerformerContractStatus["Completed"] = "completed";
    PerformerContractStatus["TimeLogApproved"] = "time_log_approved";
    PerformerContractStatus["Cancelled"] = "cancelled";
    PerformerContractStatus["Declined"] = "declined";
    return PerformerContractStatus;
}({});

});

parcelRegister("fj6A2", function(module, exports) {

$parcel$export(module.exports, "PerformerContractType", () => $96520f515a343379$export$be12697bd0984da1);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $96520f515a343379$export$be12697bd0984da1 = /*#__PURE__*/ function(PerformerContractType) {
    PerformerContractType["Exhibit1"] = "Exhibit1";
    PerformerContractType["Exhibit2"] = "Exhibit2";
    return PerformerContractType;
}({});

});

parcelRegister("fqLMT", function(module, exports) {

$parcel$export(module.exports, "PerformerOnboardingStatus", () => $85f63931d9b91a85$export$878a09ba6f334862);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $85f63931d9b91a85$export$878a09ba6f334862 = /*#__PURE__*/ function(PerformerOnboardingStatus) {
    PerformerOnboardingStatus["Cancelled"] = "cancelled";
    PerformerOnboardingStatus["NotStarted"] = "not_started";
    PerformerOnboardingStatus["Invited"] = "invited";
    PerformerOnboardingStatus["InvitationAccepted"] = "invitation_accepted";
    PerformerOnboardingStatus["Completed"] = "completed";
    return PerformerOnboardingStatus;
}({});

});

parcelRegister("3vCIk", function(module, exports) {

$parcel$export(module.exports, "PerformerRelationship", () => $95e51481471e11d4$export$9be7b1c8cd04d6fe);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $95e51481471e11d4$export$9be7b1c8cd04d6fe = /*#__PURE__*/ function(PerformerRelationship) {
    PerformerRelationship["employee"] = "Employee";
    PerformerRelationship["contractor"] = "Contractor";
    return PerformerRelationship;
}({});

});

parcelRegister("4qvRz", function(module, exports) {

$parcel$export(module.exports, "ProcessingStatus", () => $8ab89c6e09d3999c$export$855c4df14b7264c);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $8ab89c6e09d3999c$export$855c4df14b7264c = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus["Pending"] = "Pending";
    ProcessingStatus["Processing"] = "Processing";
    ProcessingStatus["Complete"] = "Complete";
    ProcessingStatus["Failed"] = "Failed";
    return ProcessingStatus;
}({});

});

parcelRegister("i8q6u", function(module, exports) {

$parcel$export(module.exports, "PropType", () => $1177de8af60cdc30$export$fa229f1561ec4e96);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Prop Type
 */ var $1177de8af60cdc30$export$fa229f1561ec4e96 = /*#__PURE__*/ function(PropType) {
    PropType["Automobile"] = "Automobile";
    PropType["Trailer"] = "Trailer";
    PropType["Motorcycle"] = "Motorcycle";
    PropType["Skates"] = "Skates";
    PropType["Skateboard"] = "Skateboard";
    PropType["Bicycle"] = "Bicycle";
    PropType["Moped"] = "Moped";
    PropType["Camera"] = "Camera";
    PropType["Pet"] = "Pet";
    PropType["Footwear"] = "Footwear";
    PropType["Luggage"] = "Luggage";
    PropType["GolfClubs"] = "Golf Clubs";
    PropType["GolfBag"] = "GolfBag";
    PropType["TennisRacquet"] = "Tennis Racquet";
    PropType["Skis"] = "Skis";
    PropType["Binoculars"] = "Binoculars";
    PropType["OperaGlasses"] = "Opera Glasses";
    PropType["LargePortableRadio"] = "Large Portable Radio";
    PropType["Book"] = "Book";
    PropType["Laptop"] = "Laptop";
    PropType["CellPhone"] = "CellPhone";
    PropType["Tablet"] = "Tablet";
    PropType["PDA"] = "PDA";
    PropType["MP3Player"] = "MP3 Player";
    PropType["Other"] = "Other";
    return PropType;
}({});

});

parcelRegister("cVyZf", function(module, exports) {

$parcel$export(module.exports, "RightStatus", () => $1bc63363e826ffff$export$4bac2cbffae9ef93);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $1bc63363e826ffff$export$4bac2cbffae9ef93 = /*#__PURE__*/ function(RightStatus) {
    RightStatus["ACTIVE"] = "Active";
    RightStatus["RELEASED"] = "Released";
    RightStatus["EXPIRED"] = "Expired";
    return RightStatus;
}({});

});

parcelRegister("kO7OK", function(module, exports) {

$parcel$export(module.exports, "RightType", () => $67a0ea92527e90df$export$7f9cec1d06ef6304);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $67a0ea92527e90df$export$7f9cec1d06ef6304 = /*#__PURE__*/ function(RightType) {
    RightType["TWO_D_ARTWORK"] = "2D Artwork";
    RightType["CELEBRITY_GUARANTEE"] = "Celebrity Guarantee";
    RightType["CHARACTER_LICENSE"] = "Character License";
    RightType["CLEARANCE_LIMITATION"] = "Clearance Limitation";
    RightType["CUSTOMER_PROVIDED_MATERIALS"] = "Customer Provided Materials";
    RightType["DORMANCY_FEES"] = "Dormancy Fees";
    RightType["FILM_FOOTAGE_LICENSE"] = "Film Footage License";
    RightType["FONT_LICENSE"] = "Font License";
    RightType["ILLUSTRATOR"] = "Illustrator";
    RightType["INFLUENCER"] = "Influencer";
    RightType["MUSIC_DEMO_FEE"] = "Music Demo Fee";
    RightType["MUSIC_MASTER_LICENSE"] = "Music Master License";
    RightType["MUSIC_PUBLISHING_LICENSE"] = "Music Publishing License";
    RightType["MUSIC_MASTER_AND_PUBLISHING_LICENSE"] = "Music Master and Publishing License";
    RightType["NON_UNION_BACKGROUND_EXTRA"] = "Non-Union Background Extra";
    RightType["NON_UNION_CHARACTER_VOICE"] = "Non-Union Character Voice";
    RightType["NON_UNION_DRIVER"] = "Non-Union Driver";
    RightType["NON_UNION_FEATURED_EXTRA"] = "Non-Union Featured Extra";
    RightType["NON_UNION_INFLUENCER"] = "Non-Union Influencer";
    RightType["NON_UNION_ON_CAMERA_PRINCIPAL"] = "Non-Union On-Camera Principal";
    RightType["NON_UNION_OTHER"] = "Non-Union Other";
    RightType["NON_UNION_VOICEOVER"] = "Non-Union Voiceover";
    RightType["NON_UNION_AGREEMENT"] = "Non-Union Agreement";
    RightType["ORIGINAL_MUSIC_LICENSE"] = "Original Music License";
    RightType["ORIGINAL_MUSIC_NON_AFM"] = "Original Music (Non-AFM)";
    RightType["OTHER"] = "Other";
    RightType["PHOTOGRAPHER"] = "Photographer";
    RightType["PRINCIPAL_MODEL"] = "Principal Model";
    RightType["PROMOTIONAL_LICENSE"] = "Promotional License";
    RightType["RIGHT_OF_PUBLICITY"] = "Right of Publicity";
    RightType["SPORTING_EVENT_FOOTAGE_LICENSE"] = "Sporting Event Footage License";
    RightType["STOCK_ARTWORK_2D"] = "Stock Artwork (2D)";
    RightType["STOCK_FILM_FOOTAGE"] = "Stock Film Footage";
    RightType["STOCK_MUSIC"] = "Stock Music";
    RightType["STOCK_PHOTO"] = "Stock Photo";
    RightType["TERM_GUARANTEE"] = "Term Guarantee";
    RightType["UNION_TALENT"] = "Union Talent";
    return RightType;
}({});

});

parcelRegister("8kKyn", function(module, exports) {

$parcel$export(module.exports, "RolePerformerType", () => $7ec18427c825a1c2$export$ea660ae8d9311cfb);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Role Performer Types - Subset needed for ClassifierService
 */ var $7ec18427c825a1c2$export$ea660ae8d9311cfb = /*#__PURE__*/ function(RolePerformerType) {
    RolePerformerType["OnCameraPrincipal"] = "On Camera Principal";
    RolePerformerType["OffCameraPrincipal"] = "Off Camera Principal";
    RolePerformerType["Extra"] = "Extra";
    RolePerformerType["Radio"] = "Radio";
    RolePerformerType["AFM"] = "American Federation Of Musicians";
    RolePerformerType["OnCameraGroup"] = "On Camera Group";
    RolePerformerType["OnCameraGroupContractor"] = "On Camera Group Contractor (1-2)";
    RolePerformerType["OnCameraGroupContractor3To5"] = "On Camera Group Contractor (3-5)";
    RolePerformerType["OnCameraGroupContractor6To8"] = "On Camera Group Contractor (6-8)";
    RolePerformerType["OnCameraGroupContractor9Plus"] = "On Camera Group Contractor (9+)";
    RolePerformerType["OffCameraGroup"] = "Off Camera Group";
    RolePerformerType["OffCameraGroupContractor"] = "Off Camera Group Contractor (1-2)";
    RolePerformerType["OffCameraGroupContractor3To5"] = "Off Camera Group Contractor (3-5)";
    RolePerformerType["OffCameraGroupContractor6To8"] = "Off Camera Group Contractor (6-8)";
    RolePerformerType["OffCameraGroupContractor9Plus"] = "Off Camera Group Contractor (9+)";
    return RolePerformerType;
}({});

});

parcelRegister("iGNlr", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $d8ab27facd0d83a9$export$8eb12e2b6485885b = /*#__PURE__*/ function(RolePerformerType_Extra) {
    RolePerformerType_Extra["Extra"] = "Extra";
    return RolePerformerType_Extra;
}({});

});

parcelRegister("ggknl", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $c1230d5c1eb272b2$export$b143fb8d2352d836 = /*#__PURE__*/ function(RolePerformerType_OnCameraPrincipal) {
    RolePerformerType_OnCameraPrincipal["OnCameraPrincipal"] = "On Camera Principal";
    return RolePerformerType_OnCameraPrincipal;
}({});

});

parcelRegister("lUAc5", function(module, exports) {

$parcel$export(module.exports, "RoleType", () => $d4b7f3e741bf8d0a$export$e57c3ccf0ca02b45);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Role Type
 */ var $d4b7f3e741bf8d0a$export$e57c3ccf0ca02b45 = /*#__PURE__*/ function(RoleType) {
    RoleType["Actor"] = "Actor";
    RoleType["Speaker"] = "Speaker";
    RoleType["Narrator"] = "Narrator";
    RoleType["Announcer"] = "Announcer";
    RoleType["Singer"] = "Singer";
    RoleType["SpecialtyDancer"] = "Specialty Dancer";
    RoleType["SpecialtyAct"] = "Specialty Act";
    RoleType["Puppeteer"] = "Puppeteer";
    RoleType["StuntPerformer"] = "Stunt Performer";
    RoleType["StuntCoordinator"] = "Stunt Coordinator";
    RoleType["Pilot"] = "Pilot";
    RoleType["Clown"] = "Clown";
    RoleType["StandIn"] = "Stand In";
    RoleType["HandModel"] = "Hand Model";
    RoleType["HandModelDoubleScale"] = "Hand Model Double Scale";
    RoleType["Other"] = "Other";
    RoleType["LeaderArrangerComposer"] = "Leader Arranger Composer";
    RoleType["CopyistSideMusician"] = "Copyist Side Musician";
    RoleType["CopyistSideMusician1Double"] = "Copyist Side Musician 1 Double";
    RoleType["CopyistSideMusician2Doubles"] = "Copyist Side Musician 2 Doubles";
    RoleType["CopyistSideMusician3Doubles"] = "Copyist Side Musician 3 Doubles";
    RoleType["CopyistSideMusician4Doubles"] = "Copyist Side Musician 4 Doubles";
    return RoleType;
}({});

});

parcelRegister("9C19V", function(module, exports) {

$parcel$export(module.exports, "SessionActivityType", () => $674574d070d63103$export$69901d8e29a73d0d);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $674574d070d63103$export$69901d8e29a73d0d = /*#__PURE__*/ function(SessionActivityType) {
    SessionActivityType["AFMRecordingSession"] = "AFM Recording Session";
    SessionActivityType["WorkTime"] = "Work Time";
    SessionActivityType["WorkTimeNight"] = "Work Time - Night (+10%)";
    SessionActivityType["WorkTimeLateNight"] = "Work Time - Late Night (+20%)";
    SessionActivityType["WorkTimeSaturday"] = "Work Time - Saturday";
    SessionActivityType["WorkTimeSunday"] = "Work Time - Sunday";
    SessionActivityType["WorkTimeHoliday"] = "Work Time - Holiday";
    SessionActivityType["MealBreakfast"] = "Meal - Breakfast";
    SessionActivityType["MealLunch"] = "Meal - Lunch";
    SessionActivityType["MealDinner"] = "Meal - Dinner";
    SessionActivityType["Fitting"] = "Fitting";
    SessionActivityType["WardrobeChange"] = "Wardrobe Change";
    SessionActivityType["HairAndMakeup"] = "Hair And Makeup";
    SessionActivityType["TravelToLocation"] = "Travel To Location";
    SessionActivityType["TravelToLocationAfterMidnight"] = "Travel To Location (After Midnight)";
    SessionActivityType["TravelFromLocation"] = "Travel From Location";
    SessionActivityType["TravelFromLocationAfterMidnight"] = "Travel From Location (After Midnight)";
    SessionActivityType["Audition"] = "Audition";
    SessionActivityType["Rehearsal"] = "Rehearsal";
    SessionActivityType["LineMemorization"] = "Line Memorization";
    SessionActivityType["AuditionScratchTrack"] = "Audition Scratch Track";
    SessionActivityType["RecordingSession"] = "Recording Session";
    SessionActivityType["VoiceOver"] = "Voice Over";
    SessionActivityType["Demo"] = "Demo";
    SessionActivityType["CreativeSession"] = "Creative Session";
    SessionActivityType["CreativeAudition"] = "Creative Audition";
    return SessionActivityType;
}({});

});

parcelRegister("7dV2j", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateItemUnitType", () => $de8ece4137609def$export$52bb89a13fb5b79f);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Estimate Unit Types
 */ var $de8ece4137609def$export$52bb89a13fb5b79f = /*#__PURE__*/ function(SessionEstimateItemUnitType) {
    SessionEstimateItemUnitType["Hours"] = "hours";
    SessionEstimateItemUnitType["Miles"] = "miles";
    SessionEstimateItemUnitType["Days"] = "days";
    SessionEstimateItemUnitType["Count"] = "count";
    SessionEstimateItemUnitType["CostumeChanges"] = "costume changes";
    SessionEstimateItemUnitType["Tags"] = "tags";
    SessionEstimateItemUnitType["Doubles"] = "doubles";
    return SessionEstimateItemUnitType;
}({});

});

parcelRegister("eJ3Q3", function(module, exports) {

$parcel$export(module.exports, "StudioZone", () => $99eb8af5c92694eb$export$57d2d62126b64b77);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Studio Zones
 */ var $99eb8af5c92694eb$export$57d2d62126b64b77 = /*#__PURE__*/ function(StudioZone) {
    StudioZone["NewYork"] = "New York";
    StudioZone["NewYorkCity"] = "New York City";
    StudioZone["LosAngeles"] = "Los Angeles";
    return StudioZone;
}({});

});

parcelRegister("6BDfZ", function(module, exports) {

$parcel$export(module.exports, "TalentManagerApprovalStatus", () => $e3cf71a73d0946d6$export$50121fe0666760e6);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $e3cf71a73d0946d6$export$50121fe0666760e6 = /*#__PURE__*/ function(TalentManagerApprovalStatus) {
    TalentManagerApprovalStatus["PENDING"] = "pending";
    TalentManagerApprovalStatus["APPROVED"] = "approved";
    TalentManagerApprovalStatus["SUSPENDED"] = "suspended";
    return TalentManagerApprovalStatus;
}({});

});

parcelRegister("6weww", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $faead2b162a20779$export$d0aff9dd6196597a = /*#__PURE__*/ function(TalentManagerEngagementStatus) {
    TalentManagerEngagementStatus["ACTIVE"] = "active";
    TalentManagerEngagementStatus["PAUSED"] = "paused";
    TalentManagerEngagementStatus["COMPLETED"] = "completed";
    TalentManagerEngagementStatus["CANCELLED"] = "cancelled";
    return TalentManagerEngagementStatus;
}({});

});

parcelRegister("hX2Cj", function(module, exports) {

$parcel$export(module.exports, "TContractSignatureRequest", () => $ad431d5439b3c464$export$419341aee52ba179);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Contract Signature Request Type
 */ (function(TContractSignatureRequest) {
    (function(field) {
        field["PERFORMER_SIGNATURE"] = "performerSignature";
        field["PRODUCER_SIGNATURE"] = "producerSignature";
        field["PERFORMER_SPECIAL_PROVISIONS_SIGNATURE"] = "performerSpecialProvisionsSignature";
    })(TContractSignatureRequest.field || (TContractSignatureRequest.field = {}));
})($ad431d5439b3c464$export$419341aee52ba179 || ($ad431d5439b3c464$export$419341aee52ba179 = {}));
var $ad431d5439b3c464$export$419341aee52ba179;

});

parcelRegister("dxpnu", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ (function(THealthCheckResponse) {
    (function(status) {
        status["OK"] = "ok";
    })(THealthCheckResponse.status || (THealthCheckResponse.status = {}));
})($70d0ab601f6594a0$export$e9c6bba013f012e4 || ($70d0ab601f6594a0$export$e9c6bba013f012e4 = {}));
var $70d0ab601f6594a0$export$e9c6bba013f012e4;

});

parcelRegister("7PLVa", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $2528d8a0087012a7$export$6f5b54e252ca6d9d = /*#__PURE__*/ function(TimeEntryType) {
    TimeEntryType["CHAT_AUTO"] = "chatAuto";
    TimeEntryType["MANUAL"] = "manual";
    return TimeEntryType;
}({});

});

parcelRegister("fxTdv", function(module, exports) {

$parcel$export(module.exports, "TOAuthProvider", () => $7357da13f7456e47$export$a16eeec8ad71a301);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $7357da13f7456e47$export$a16eeec8ad71a301 = /*#__PURE__*/ function(TOAuthProvider) {
    TOAuthProvider["GOOGLE"] = "google";
    return TOAuthProvider;
}({});

});

parcelRegister("3xgsY", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Project-wide upcoming/overdue holding fees
 */ (function(TProjectHoldingFeeDueItem) {
    (function(status) {
        status["DUE"] = "Due";
        status["OVERDUE"] = "Overdue";
    })(TProjectHoldingFeeDueItem.status || (TProjectHoldingFeeDueItem.status = {}));
})($1c6f45f33a22ac81$export$9f63417e757f0a0a || ($1c6f45f33a22ac81$export$9f63417e757f0a0a = {}));
var $1c6f45f33a22ac81$export$9f63417e757f0a0a;

});

parcelRegister("8wESq", function(module, exports) {

$parcel$export(module.exports, "UsageCycleNumber", () => $0f13310ce80c15e2$export$8fcbcc7d534fdaac);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $0f13310ce80c15e2$export$8fcbcc7d534fdaac = /*#__PURE__*/ function(UsageCycleNumber) {
    UsageCycleNumber[UsageCycleNumber["one"] = 1] = "one";
    UsageCycleNumber[UsageCycleNumber["four"] = 4] = "four";
    UsageCycleNumber[UsageCycleNumber["six"] = 6] = "six";
    UsageCycleNumber[UsageCycleNumber["eight"] = 8] = "eight";
    UsageCycleNumber[UsageCycleNumber["thirteen"] = 13] = "thirteen";
    UsageCycleNumber[UsageCycleNumber["twentySix"] = 26] = "twentySix";
    UsageCycleNumber[UsageCycleNumber["thirty"] = 30] = "thirty";
    UsageCycleNumber[UsageCycleNumber["thirtyOne"] = 31] = "thirtyOne";
    UsageCycleNumber[UsageCycleNumber["fiftyTwo"] = 52] = "fiftyTwo";
    return UsageCycleNumber;
}({});

});

parcelRegister("RoqvF", function(module, exports) {

$parcel$export(module.exports, "UsageCycleUnit", () => $0f07817e2c361987$export$72d597b22c8c24ed);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $0f07817e2c361987$export$72d597b22c8c24ed = /*#__PURE__*/ function(UsageCycleUnit) {
    UsageCycleUnit["Day"] = "Day";
    UsageCycleUnit["Week"] = "Week";
    UsageCycleUnit["Month"] = "Month";
    UsageCycleUnit["Year"] = "Year";
    return UsageCycleUnit;
}({});

});

parcelRegister("iPDTI", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $642d84c5add94422$export$7b2681bc9a8ae9c3 = /*#__PURE__*/ function(UsageLanguage) {
    UsageLanguage["English"] = "English";
    UsageLanguage["Spanish"] = "Spanish";
    UsageLanguage["Japanese"] = "Japanese";
    UsageLanguage["Other"] = "Other";
    return UsageLanguage;
}({});

});

parcelRegister("1bvuP", function(module, exports) {

$parcel$export(module.exports, "UsagePlatform", () => $d1de05335d9f1877$export$cc8dd4235b976426);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $d1de05335d9f1877$export$cc8dd4235b976426 = /*#__PURE__*/ function(UsagePlatform) {
    UsagePlatform["Linear"] = "Linear";
    UsagePlatform["Digital"] = "Digital";
    UsagePlatform["SocialWaiver"] = "Social Media Waiver";
    UsagePlatform["TheatricalIndustrial"] = "Theatrical/Industrial";
    UsagePlatform["Foreign"] = "Foreign";
    UsagePlatform["AFM"] = "AFM";
    UsagePlatform["Traditional"] = "Traditional";
    UsagePlatform["Internet"] = "Internet";
    UsagePlatform["Network"] = "Network";
    UsagePlatform["WildSpot"] = "WildSpot";
    UsagePlatform["Dealer"] = "Dealer";
    return UsagePlatform;
}({});

});

parcelRegister("4bBQG", function(module, exports) {

$parcel$export(module.exports, "UsageType", () => $87e25c5e73bf495c$export$653653f5082d2d6b);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $87e25c5e73bf495c$export$653653f5082d2d6b = /*#__PURE__*/ function(UsageType) {
    UsageType["TV_LinearDomestic_Network_ClassA_Per_Use"] = "TV Linear Domestic Network Class A (Per Use)";
    UsageType["TV_LinearDomestic_Network_ClassA_13_Week_Maximum"] = "TV Linear Domestic Network Class A (13 Weeks Maximum)";
    UsageType["TV_LinearDomestic_IONAndDiginet_Per_Use"] = "TV Linear Domestic ION And Diginet Per Use";
    UsageType["TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use"] = "TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_4_Week"] = "TV Spanish Language Program (4 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_13_Week"] = "TV Spanish Language Program (13 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_52_Week"] = "TV Spanish Language Program (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_4_Week"] = "TV Linear Domestic Wild Spot All Markets (4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_13_Week"] = "TV Linear Domestic Wild Spot All Markets (13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_52_Week"] = "TV Linear Domestic Wild Spot All Markets (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_4_Week"] = "TV Linear Domestic National Cable (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_13_Week"] = "TV Linear Domestic National Cable (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_52_Week"] = "TV Linear Domestic National Cable (52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_4_Week"] = "TV Linear Domestic National Cable Single Network (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_13_Week"] = "TV Linear Domestic National Cable Single Network (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_52_Week"] = "TV Linear Domestic National Cable Single Network (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_4_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_13_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_52_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_Dealer_4_Week"] = "TV Linear Domestic Dealer (4 Week)";
    UsageType["TV_LinearDomestic_Dealer_13_Week"] = "TV Linear Domestic Dealer (13 Week)";
    UsageType["TV_LinearDomestic_Dealer_52_Week"] = "TV Linear Domestic Dealer (52 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_4_Week"] = "TV Linear Domestic All Other NA Linear (4 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_13_Week"] = "TV Linear Domestic All Other NA Linear (13 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_52_Week"] = "TV Linear Domestic All Other NA Linear (52 Week)";
    UsageType["TV_TheatricalIndustrial_Up_To_30_Days"] = "TV Theatrical Industrial (Up To 30 Days)";
    UsageType["TV_TheatricalIndustrial_Use_Through_MPU"] = "TV Theatrical Industrial (Use Through MPU)";
    UsageType["TV_TheatricalIndustrial_Dist_On_Physical_Media"] = "TV Theatrical Industrial (Dist On Physical Media)";
    UsageType["TV_Digital_StreamingPlatforms_4_Week"] = "TV Digital Streaming Platforms (4 Week)";
    UsageType["TV_Digital_StreamingPlatforms_13_Week"] = "TV Digital Streaming Platforms (13 Week)";
    UsageType["TV_Digital_StreamingPlatforms_52_Week"] = "TV Digital Streaming Platforms (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_4_Week"] = "TV Digital Traditional Digital (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_13_Week"] = "TV Digital Traditional Digital (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_52_Week"] = "TV Digital Traditional Digital (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_4_Week"] = "TV Digital Traditional Digital w/YouTube (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_13_Week"] = "TV Digital Traditional Digital w/YouTube (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_52_Week"] = "TV Digital Traditional Digital w/YouTube (52 Week)";
    UsageType["TV_Digital_SocialMedia_30_Day_Cycle"] = "Social Media Waiver - Social Media (30 Day Cycle)";
    UsageType["TV_Digital_SocialMedia_YouTube"] = "Social Media Waiver - YouTube";
    UsageType["TV_Digital_GamingVRAREmergingPlatforms"] = "TV Digital Gaming VR/AR, Emerging Platforms";
    UsageType["TV_ForeignUse_UK"] = "TV Foreign Use - U.K.";
    UsageType["TV_ForeignUse_Europe"] = "TV Foreign Use - Europe";
    UsageType["TV_ForeignUse_AsiaPacific"] = "TV Foreign Use - Asia/Pacific";
    UsageType["TV_ForeignUse_Japan"] = "TV Foreign Use - Japan";
    UsageType["TV_ForeignUse_RestOfWorld"] = "TV Foreign Use - Rest-of-World";
    UsageType["TV_ForeignUse_Worldwide"] = "TV Foreign Use - Worldwide";
    UsageType["TV_ForeignUse_SpanishLanguage_Americas"] = "TV Foreign Use - Spanish Language (Americas)";
    UsageType["TV_ForeignUse_SpanishLanguage_Caribbean"] = "TV Foreign Use - Spanish Language (Caribbean)";
    UsageType["TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean"] = "TV Foreign Use - Spanish Language (Americas And Caribbean)";
    UsageType["TV_ForeignUse_Other_UK"] = "TV Foreign Use - Other (UK)";
    UsageType["TV_ForeignUse_Other_Japan"] = "TV Foreign Use - Other (Japan)";
    UsageType["TV_ForeignUse_Other_Europe"] = "TV Foreign Use - Other (Europe)";
    UsageType["TV_ForeignUse_Other_RestOfWorld"] = "TV Foreign Use - Other (Rest Of World)";
    UsageType["TV_ForeignUse_Other_AsiaPacific"] = "TV Foreign Use - Other (Asia Pacific)";
    UsageType["TV_ForeignUse_Other_Worldwide"] = "TV Foreign Use - Other (Worldwide)";
    UsageType["TV_AFM_FirstUse_InternetOnlyOrUS"] = "TV AFM First Use (Internet Only Or US)";
    UsageType["TV_AFM_Foreign_1_Year_Europe_NoEurope"] = "TV AFM Foreign - 1 Year (Europe/No Europe)";
    UsageType["TV_AFM_Foreign_Worldwide"] = "TV AFM Foreign (Worldwide)";
    UsageType["Radio_AFM_RadioSpot_Internet_8_Week"] = "Radio AFM Radio Spot - Internet (8 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_26_Week"] = "Radio AFM Radio Spot - Internet (26 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_52_Week"] = "Radio AFM Radio Spot - Internet (52 Week)";
    UsageType["Radio_Network_1_Week_Unlimited_Use"] = "Radio Network - 1 Week Unlimited Use";
    UsageType["Radio_Network_4_Weeks_Unlimited_Use"] = "Radio Network - 4 Week Unlimited Use";
    UsageType["Radio_Network_8_Weeks_Unlimited_Use"] = "Radio Network - 8 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_Unlimited_Use"] = "Radio Network - 13 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_26_Uses"] = "Radio Network - 13 Weeks 26 Uses";
    UsageType["Radio_Network_13_Week_39_Uses"] = "Radio Network - 13 Weeks 39 Uses";
    UsageType["Radio_Network_13_Week_Across_The_Board_Use"] = "Radio Network - 13 Weeks Across The Board Use";
    UsageType["Radio_WildSpot_8_Week_No_Major_Markets"] = "Radio Wild Spot - 8 Week (No Major Markets)";
    UsageType["Radio_WildSpot_8_Week_NY_Only"] = "Radio Wild Spot - 8 Week (NY Only)";
    UsageType["Radio_WildSpot_8_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 8 Week (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_8_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 8 Week (LA, NY, And Chicago)";
    UsageType["Radio_WildSpot_13_Week_No_Major_Markets"] = "Radio Wild Spot - 13 Weeks (No Major Markets)";
    UsageType["Radio_WildSpot_13_Week_NY_Only"] = "Radio Wild Spot - 13 Weeks (NY Only)";
    UsageType["Radio_WildSpot_13_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 13 Weeks (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_13_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 13 Weeks (LA, NY, And Chicago)";
    UsageType["Radio_Internet_4_Week"] = "Radio Internet - 4 Week";
    UsageType["Radio_Internet_8_Week_Move_Over"] = "Radio Internet - 8 Week Move Over";
    UsageType["Radio_Internet_8_Week_Made_For"] = "Radio Internet - 8 Week Made For";
    UsageType["Radio_Internet_1_Year_Move_Over"] = "Radio Internet - 1 Year Move Over";
    UsageType["Radio_Internet_1_Year_Made_For"] = "Radio Internet - 1 Year Made For";
    UsageType["Radio_Dealer_8_Week"] = "Radio Dealer - 8 Week";
    UsageType["Radio_Dealer_6_Months"] = "Radio Dealer - 6 Months";
    return UsageType;
}({});

});

parcelRegister("69JXC", function(module, exports) {

$parcel$export(module.exports, "UsageTypeCategory", () => $e5243c90876a1448$export$dd6a661c806250b8);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $e5243c90876a1448$export$dd6a661c806250b8 = /*#__PURE__*/ function(UsageTypeCategory) {
    UsageTypeCategory["NationalNetworks"] = "National Networks (Class A)";
    UsageTypeCategory["Cable"] = "Cable";
    UsageTypeCategory["NationalCable"] = "National Cable";
    UsageTypeCategory["SingleNetwork"] = "National Cable Single Network";
    UsageTypeCategory["LocalCable"] = "Local Cable";
    UsageTypeCategory["Wildspot"] = "Wildspot";
    UsageTypeCategory["Dealer"] = "Dealer";
    UsageTypeCategory["AllOtherNA"] = "All Other North American Use";
    UsageTypeCategory["SpanishLanguageProgramUse"] = "Spanish-Language Program Use";
    UsageTypeCategory["IONAndDiginet"] = "ION & Diginet";
    UsageTypeCategory["ForeignUse"] = "Foreign Use";
    UsageTypeCategory["TraditionalDigital"] = "Traditional Digital";
    UsageTypeCategory["TraditionalDigitalWithYouTube"] = "Traditional Digital w/YouTube";
    UsageTypeCategory["StreamingPlatforms"] = "Streaming Platforms";
    UsageTypeCategory["SocialMedia"] = "Social Media";
    UsageTypeCategory["YouTube"] = "YouTube";
    UsageTypeCategory["OtherPlatforms"] = "Gaming Platforms, VR/AR, Emerging Platforms";
    UsageTypeCategory["Print"] = "Print Use";
    UsageTypeCategory["OOH"] = "Out of Home Use";
    UsageTypeCategory["BTS"] = "B-roll & Behind the Scenes Use";
    UsageTypeCategory["TheatricalIndustrial"] = "Theatrical & Industrial Use";
    UsageTypeCategory["AFMSession"] = "AFM Session (1 hour)";
    UsageTypeCategory["AFMFirstUse"] = "AFM First Use";
    UsageTypeCategory["AFMForeign"] = "AFM Foreign Use";
    UsageTypeCategory["AFMInternetRadio"] = "AFM Internet Radio Spot";
    UsageTypeCategory["RadioNetwork"] = "Radio Network";
    UsageTypeCategory["RadioWildspot"] = "Radio Wildspot";
    UsageTypeCategory["InternetRadio"] = "Internet Radio";
    UsageTypeCategory["RadioDealer"] = "Radio Dealer";
    return UsageTypeCategory;
}({});

});

parcelRegister("i2YYW", function(module, exports) {

$parcel$export(module.exports, "UsageUnitType", () => $91e6d5c15f3bf9af$export$244f6e23904fead6);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Usage Unit Type
 */ var $91e6d5c15f3bf9af$export$244f6e23904fead6 = /*#__PURE__*/ function(UsageUnitType) {
    UsageUnitType["Uses"] = "Uses";
    UsageUnitType["Cities"] = "Cities";
    return UsageUnitType;
}({});

});

parcelRegister("etRr4", function(module, exports) {

$parcel$export(module.exports, "UsesType", () => $f59c71a268afaa99$export$4c217c54571f9a0);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ var $f59c71a268afaa99$export$4c217c54571f9a0 = /*#__PURE__*/ function(UsesType) {
    UsesType["Unlimited"] = "Unlimited Use";
    UsesType["PerUse"] = "Per Use";
    UsesType["AcrossTheBoard"] = "Across The Board";
    return UsesType;
}({});

});

parcelRegister("5fP8A", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ /**
 * Validation Token Types
 */ var $8a9ab4efbb70fb8e$export$21d7833832799426 = /*#__PURE__*/ function(ValidationTokenType) {
    ValidationTokenType["Confirmation"] = "confirmation";
    ValidationTokenType["ResetPassword"] = "reset-password";
    ValidationTokenType["GroupInvitation"] = "group-invitation";
    ValidationTokenType["PerformerOnboarding"] = "performer-onboarding";
    ValidationTokenType["CharacterPhotoCapture"] = "character-photo-capture";
    return ValidationTokenType;
}({});

});

parcelRegister("hafFH", function(module, exports) {

$parcel$export(module.exports, "AdvertiserService", () => $ce425881dc18e64f$export$67437b9d7a2a62f1);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $ce425881dc18e64f$export$67437b9d7a2a62f1 {
    /**
     * Get Advertiser
     * @param id
     * @param relations
     * @returns TGetAdvertiserResponse TGetAdvertiserResponse
     * @throws ApiError
     */ static getAdvertiser(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/advertisers/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Advertiser
     * @param id
     * @param requestBody
     * @returns TUpdateAdvertiserResponse TUpdateAdvertiserResponse
     * @throws ApiError
     */ static updateAdvertiser(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/advertisers/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Advertiser
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteAdvertiser(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/advertisers/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Advertisers
     * @param name
     * @param isSagSignatory
     * @param isJpcAuthorizer
     * @param groupId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListAdvertisersResponse TListAdvertisersResponse
     * @throws ApiError
     */ static listAdvertisers(name, isSagSignatory, isJpcAuthorizer, groupId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/advertisers',
            query: {
                'name': name,
                'isSagSignatory': isSagSignatory,
                'isJpcAuthorizer': isJpcAuthorizer,
                'groupId': groupId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Advertiser
     * @param requestBody
     * @returns TCreateAdvertiserResponse TCreateAdvertiserResponse
     * @throws ApiError
     */ static createAdvertiser(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/advertisers',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});
parcelRegister("ahNn6", function(module, exports) {

$parcel$export(module.exports, "request", () => $8447e1e20ff2b9ea$export$b5fe3f66a567bec0);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $kvCbJ = parcelRequire("kvCbJ");

var $b8TSx = parcelRequire("b8TSx");

var $dOfWq = parcelRequire("dOfWq");
var $8447e1e20ff2b9ea$require$Buffer = $dOfWq.Buffer;
const $8447e1e20ff2b9ea$export$4e62c701997796c1 = (value)=>{
    return value !== undefined && value !== null;
};
const $8447e1e20ff2b9ea$export$844ec244b1367d54 = (value)=>{
    return typeof value === 'string';
};
const $8447e1e20ff2b9ea$export$991095b57f274a5f = (value)=>{
    return $8447e1e20ff2b9ea$export$844ec244b1367d54(value) && value !== '';
};
const $8447e1e20ff2b9ea$export$5bcd6e94ed871c88 = (value)=>{
    return typeof value === 'object' && typeof value.type === 'string' && typeof value.stream === 'function' && typeof value.arrayBuffer === 'function' && typeof value.constructor === 'function' && typeof value.constructor.name === 'string' && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
const $8447e1e20ff2b9ea$export$67a42df2b7ab73bc = (value)=>{
    return value instanceof FormData;
};
const $8447e1e20ff2b9ea$export$b3b2de96497acc47 = (str)=>{
    try {
        return btoa(str);
    } catch (err) {
        // @ts-ignore
        return $8447e1e20ff2b9ea$require$Buffer.from(str).toString('base64');
    }
};
const $8447e1e20ff2b9ea$export$18380b9f669996bd = (params)=>{
    const qs = [];
    const append = (key, value)=>{
        qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    };
    const process = (key, value)=>{
        if ($8447e1e20ff2b9ea$export$4e62c701997796c1(value)) {
            if (Array.isArray(value)) value.forEach((v)=>{
                process(key, v);
            });
            else if (typeof value === 'object') Object.entries(value).forEach(([k, v])=>{
                process(`${key}[${k}]`, v);
            });
            else append(key, value);
        }
    };
    Object.entries(params).forEach(([key, value])=>{
        process(key, value);
    });
    if (qs.length > 0) return `?${qs.join('&')}`;
    return '';
};
const $8447e1e20ff2b9ea$var$getUrl = (config, options)=>{
    const encoder = config.ENCODE_PATH || encodeURI;
    const path = options.url.replace('{api-version}', config.VERSION).replace(/{(.*?)}/g, (substring, group)=>{
        if (options.path?.hasOwnProperty(group)) return encoder(String(options.path[group]));
        return substring;
    });
    const url = `${config.BASE}${path}`;
    if (options.query) return `${url}${$8447e1e20ff2b9ea$export$18380b9f669996bd(options.query)}`;
    return url;
};
const $8447e1e20ff2b9ea$export$9643fd7297feaaf5 = (options)=>{
    if (options.formData) {
        const formData = new FormData();
        const process = (key, value)=>{
            if ($8447e1e20ff2b9ea$export$844ec244b1367d54(value) || $8447e1e20ff2b9ea$export$5bcd6e94ed871c88(value)) formData.append(key, value);
            else formData.append(key, JSON.stringify(value));
        };
        Object.entries(options.formData).filter(([_, value])=>$8447e1e20ff2b9ea$export$4e62c701997796c1(value)).forEach(([key, value])=>{
            if (Array.isArray(value)) value.forEach((v)=>process(key, v));
            else process(key, value);
        });
        return formData;
    }
    return undefined;
};
const $8447e1e20ff2b9ea$export$f7ad0328861e2f03 = async (options, resolver)=>{
    if (typeof resolver === 'function') return resolver(options);
    return resolver;
};
const $8447e1e20ff2b9ea$export$6a9b8dd1339b1a17 = async (config, options)=>{
    const [token, username, password, additionalHeaders] = await Promise.all([
        $8447e1e20ff2b9ea$export$f7ad0328861e2f03(options, config.TOKEN),
        $8447e1e20ff2b9ea$export$f7ad0328861e2f03(options, config.USERNAME),
        $8447e1e20ff2b9ea$export$f7ad0328861e2f03(options, config.PASSWORD),
        $8447e1e20ff2b9ea$export$f7ad0328861e2f03(options, config.HEADERS)
    ]);
    const headers = Object.entries({
        Accept: 'application/json',
        ...additionalHeaders,
        ...options.headers
    }).filter(([_, value])=>$8447e1e20ff2b9ea$export$4e62c701997796c1(value)).reduce((headers, [key, value])=>({
            ...headers,
            [key]: String(value)
        }), {});
    if ($8447e1e20ff2b9ea$export$991095b57f274a5f(token)) headers['Authorization'] = `Bearer ${token}`;
    if ($8447e1e20ff2b9ea$export$991095b57f274a5f(username) && $8447e1e20ff2b9ea$export$991095b57f274a5f(password)) {
        const credentials = $8447e1e20ff2b9ea$export$b3b2de96497acc47(`${username}:${password}`);
        headers['Authorization'] = `Basic ${credentials}`;
    }
    if (options.body !== undefined) {
        if (options.mediaType) headers['Content-Type'] = options.mediaType;
        else if ($8447e1e20ff2b9ea$export$5bcd6e94ed871c88(options.body)) headers['Content-Type'] = options.body.type || 'application/octet-stream';
        else if ($8447e1e20ff2b9ea$export$844ec244b1367d54(options.body)) headers['Content-Type'] = 'text/plain';
        else if (!$8447e1e20ff2b9ea$export$67a42df2b7ab73bc(options.body)) headers['Content-Type'] = 'application/json';
    }
    return new Headers(headers);
};
const $8447e1e20ff2b9ea$export$55bce18df99af758 = (options)=>{
    if (options.body !== undefined) {
        if (options.mediaType?.includes('/json')) return JSON.stringify(options.body);
        else if ($8447e1e20ff2b9ea$export$844ec244b1367d54(options.body) || $8447e1e20ff2b9ea$export$5bcd6e94ed871c88(options.body) || $8447e1e20ff2b9ea$export$67a42df2b7ab73bc(options.body)) return options.body;
        else return JSON.stringify(options.body);
    }
    return undefined;
};
const $8447e1e20ff2b9ea$export$d5a1e65f8aa21b51 = async (config, options, url, body, formData, headers, onCancel)=>{
    const controller = new AbortController();
    const request = {
        headers: headers,
        body: body ?? formData,
        method: options.method,
        signal: controller.signal
    };
    if (config.WITH_CREDENTIALS) request.credentials = config.CREDENTIALS;
    onCancel(()=>controller.abort());
    return await fetch(url, request);
};
const $8447e1e20ff2b9ea$export$67c14f05e310b1da = (response, responseHeader)=>{
    if (responseHeader) {
        const content = response.headers.get(responseHeader);
        if ($8447e1e20ff2b9ea$export$844ec244b1367d54(content)) return content;
    }
    return undefined;
};
const $8447e1e20ff2b9ea$export$c852f9270b343ec4 = async (response)=>{
    if (response.status !== 204) try {
        const contentType = response.headers.get('Content-Type');
        if (contentType) {
            const jsonTypes = [
                'application/json',
                'application/problem+json'
            ];
            const isJSON = jsonTypes.some((type)=>contentType.toLowerCase().startsWith(type));
            if (isJSON) return await response.json();
            else return await response.text();
        }
    } catch (error) {
        console.error(error);
    }
    return undefined;
};
const $8447e1e20ff2b9ea$export$31bf08a141e671fd = (options, result)=>{
    const errors = {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        500: 'Internal Server Error',
        502: 'Bad Gateway',
        503: 'Service Unavailable',
        ...options.errors
    };
    const error = errors[result.status];
    if (error) throw new (0, $kvCbJ.ApiError)(options, result, error);
    if (!result.ok) {
        const errorStatus = result.status ?? 'unknown';
        const errorStatusText = result.statusText ?? 'unknown';
        const errorBody = (()=>{
            try {
                return JSON.stringify(result.body, null, 2);
            } catch (e) {
                return undefined;
            }
        })();
        throw new (0, $kvCbJ.ApiError)(options, result, `Generic Error: status: ${errorStatus}; status text: ${errorStatusText}; body: ${errorBody}`);
    }
};
const $8447e1e20ff2b9ea$export$b5fe3f66a567bec0 = (config, options)=>{
    return new (0, $b8TSx.CancelablePromise)(async (resolve, reject, onCancel)=>{
        try {
            const url = $8447e1e20ff2b9ea$var$getUrl(config, options);
            const formData = $8447e1e20ff2b9ea$export$9643fd7297feaaf5(options);
            const body = $8447e1e20ff2b9ea$export$55bce18df99af758(options);
            const headers = await $8447e1e20ff2b9ea$export$6a9b8dd1339b1a17(config, options);
            if (!onCancel.isCancelled) {
                const response = await $8447e1e20ff2b9ea$export$d5a1e65f8aa21b51(config, options, url, body, formData, headers, onCancel);
                const responseBody = await $8447e1e20ff2b9ea$export$c852f9270b343ec4(response);
                const responseHeader = $8447e1e20ff2b9ea$export$67c14f05e310b1da(response, options.responseHeader);
                const result = {
                    url: url,
                    ok: response.ok,
                    status: response.status,
                    statusText: response.statusText,
                    body: responseHeader ?? responseBody
                };
                $8447e1e20ff2b9ea$export$31bf08a141e671fd(options, result);
                resolve(result.body);
            }
        } catch (error) {
            reject(error);
        }
    });
};

});
parcelRegister("dOfWq", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $a0dc4f7a89ff0774$export$a143d493d941bafc, (v) => $a0dc4f7a89ff0774$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $a0dc4f7a89ff0774$export$e4cf37d7f6fb9e0a, (v) => $a0dc4f7a89ff0774$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $a0dc4f7a89ff0774$export$f99ded8fe4b79145, (v) => $a0dc4f7a89ff0774$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $a0dc4f7a89ff0774$export$599f31c3813fae4d, (v) => $a0dc4f7a89ff0774$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a0dc4f7a89ff0774$export$a143d493d941bafc;
var $a0dc4f7a89ff0774$export$e4cf37d7f6fb9e0a;
var $a0dc4f7a89ff0774$export$f99ded8fe4b79145;
var $a0dc4f7a89ff0774$export$599f31c3813fae4d;
'use strict';

var $jxbQz = parcelRequire("jxbQz");

var $8cWpg = parcelRequire("8cWpg");
var $a0dc4f7a89ff0774$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a0dc4f7a89ff0774$export$a143d493d941bafc = $a0dc4f7a89ff0774$var$Buffer;
$a0dc4f7a89ff0774$export$e4cf37d7f6fb9e0a = $a0dc4f7a89ff0774$var$SlowBuffer;
$a0dc4f7a89ff0774$export$f99ded8fe4b79145 = 50;
var $a0dc4f7a89ff0774$var$K_MAX_LENGTH = 0x7fffffff;
$a0dc4f7a89ff0774$export$599f31c3813fae4d = $a0dc4f7a89ff0774$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a0dc4f7a89ff0774$var$Buffer.TYPED_ARRAY_SUPPORT = $a0dc4f7a89ff0774$var$typedArraySupport();
if (!$a0dc4f7a89ff0774$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a0dc4f7a89ff0774$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a0dc4f7a89ff0774$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a0dc4f7a89ff0774$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a0dc4f7a89ff0774$var$createBuffer(length) {
    if (length > $a0dc4f7a89ff0774$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a0dc4f7a89ff0774$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a0dc4f7a89ff0774$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a0dc4f7a89ff0774$var$allocUnsafe(arg);
    }
    return $a0dc4f7a89ff0774$var$from(arg, encodingOrOffset, length);
}
$a0dc4f7a89ff0774$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a0dc4f7a89ff0774$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a0dc4f7a89ff0774$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a0dc4f7a89ff0774$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a0dc4f7a89ff0774$var$isInstance(value, ArrayBuffer) || value && $a0dc4f7a89ff0774$var$isInstance(value.buffer, ArrayBuffer)) return $a0dc4f7a89ff0774$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a0dc4f7a89ff0774$var$isInstance(value, SharedArrayBuffer) || value && $a0dc4f7a89ff0774$var$isInstance(value.buffer, SharedArrayBuffer))) return $a0dc4f7a89ff0774$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a0dc4f7a89ff0774$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $a0dc4f7a89ff0774$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a0dc4f7a89ff0774$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a0dc4f7a89ff0774$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a0dc4f7a89ff0774$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a0dc4f7a89ff0774$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a0dc4f7a89ff0774$var$Buffer, Uint8Array);
function $a0dc4f7a89ff0774$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a0dc4f7a89ff0774$var$alloc(size, fill, encoding) {
    $a0dc4f7a89ff0774$var$assertSize(size);
    if (size <= 0) return $a0dc4f7a89ff0774$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a0dc4f7a89ff0774$var$createBuffer(size).fill(fill, encoding) : $a0dc4f7a89ff0774$var$createBuffer(size).fill(fill);
    return $a0dc4f7a89ff0774$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a0dc4f7a89ff0774$var$Buffer.alloc = function(size, fill, encoding) {
    return $a0dc4f7a89ff0774$var$alloc(size, fill, encoding);
};
function $a0dc4f7a89ff0774$var$allocUnsafe(size) {
    $a0dc4f7a89ff0774$var$assertSize(size);
    return $a0dc4f7a89ff0774$var$createBuffer(size < 0 ? 0 : $a0dc4f7a89ff0774$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a0dc4f7a89ff0774$var$Buffer.allocUnsafe = function(size) {
    return $a0dc4f7a89ff0774$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a0dc4f7a89ff0774$var$Buffer.allocUnsafeSlow = function(size) {
    return $a0dc4f7a89ff0774$var$allocUnsafe(size);
};
function $a0dc4f7a89ff0774$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a0dc4f7a89ff0774$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $a0dc4f7a89ff0774$var$byteLength(string, encoding) | 0;
    var buf = $a0dc4f7a89ff0774$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a0dc4f7a89ff0774$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $a0dc4f7a89ff0774$var$checked(array.length) | 0;
    var buf = $a0dc4f7a89ff0774$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a0dc4f7a89ff0774$var$fromArrayView(arrayView) {
    if ($a0dc4f7a89ff0774$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $a0dc4f7a89ff0774$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a0dc4f7a89ff0774$var$fromArrayLike(arrayView);
}
function $a0dc4f7a89ff0774$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a0dc4f7a89ff0774$var$Buffer.prototype);
    return buf;
}
function $a0dc4f7a89ff0774$var$fromObject(obj) {
    if ($a0dc4f7a89ff0774$var$Buffer.isBuffer(obj)) {
        var len = $a0dc4f7a89ff0774$var$checked(obj.length) | 0;
        var buf = $a0dc4f7a89ff0774$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a0dc4f7a89ff0774$var$numberIsNaN(obj.length)) return $a0dc4f7a89ff0774$var$createBuffer(0);
        return $a0dc4f7a89ff0774$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a0dc4f7a89ff0774$var$fromArrayLike(obj.data);
}
function $a0dc4f7a89ff0774$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a0dc4f7a89ff0774$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a0dc4f7a89ff0774$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a0dc4f7a89ff0774$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a0dc4f7a89ff0774$var$Buffer.alloc(+length);
}
$a0dc4f7a89ff0774$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a0dc4f7a89ff0774$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a0dc4f7a89ff0774$var$Buffer.compare = function compare(a, b) {
    if ($a0dc4f7a89ff0774$var$isInstance(a, Uint8Array)) a = $a0dc4f7a89ff0774$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a0dc4f7a89ff0774$var$isInstance(b, Uint8Array)) b = $a0dc4f7a89ff0774$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(a) || !$a0dc4f7a89ff0774$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a0dc4f7a89ff0774$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a0dc4f7a89ff0774$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a0dc4f7a89ff0774$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $a0dc4f7a89ff0774$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($a0dc4f7a89ff0774$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $a0dc4f7a89ff0774$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a0dc4f7a89ff0774$var$byteLength(string, encoding) {
    if ($a0dc4f7a89ff0774$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a0dc4f7a89ff0774$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a0dc4f7a89ff0774$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a0dc4f7a89ff0774$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a0dc4f7a89ff0774$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a0dc4f7a89ff0774$var$Buffer.byteLength = $a0dc4f7a89ff0774$var$byteLength;
function $a0dc4f7a89ff0774$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a0dc4f7a89ff0774$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a0dc4f7a89ff0774$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a0dc4f7a89ff0774$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a0dc4f7a89ff0774$var$latin1Slice(this, start, end);
        case 'base64':
            return $a0dc4f7a89ff0774$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a0dc4f7a89ff0774$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a0dc4f7a89ff0774$var$Buffer.prototype._isBuffer = true;
function $a0dc4f7a89ff0774$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a0dc4f7a89ff0774$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$a0dc4f7a89ff0774$var$swap(this, i, i + 1);
    return this;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $a0dc4f7a89ff0774$var$swap(this, i, i + 3);
        $a0dc4f7a89ff0774$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $a0dc4f7a89ff0774$var$swap(this, i, i + 7);
        $a0dc4f7a89ff0774$var$swap(this, i + 1, i + 6);
        $a0dc4f7a89ff0774$var$swap(this, i + 2, i + 5);
        $a0dc4f7a89ff0774$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a0dc4f7a89ff0774$var$utf8Slice(this, 0, length);
    return $a0dc4f7a89ff0774$var$slowToString.apply(this, arguments);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.toLocaleString = $a0dc4f7a89ff0774$var$Buffer.prototype.toString;
$a0dc4f7a89ff0774$var$Buffer.prototype.equals = function equals(b) {
    if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a0dc4f7a89ff0774$var$Buffer.compare(this, b) === 0;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $a0dc4f7a89ff0774$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a0dc4f7a89ff0774$var$customInspectSymbol) $a0dc4f7a89ff0774$var$Buffer.prototype[$a0dc4f7a89ff0774$var$customInspectSymbol] = $a0dc4f7a89ff0774$var$Buffer.prototype.inspect;
$a0dc4f7a89ff0774$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a0dc4f7a89ff0774$var$isInstance(target, Uint8Array)) target = $a0dc4f7a89ff0774$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a0dc4f7a89ff0774$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a0dc4f7a89ff0774$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a0dc4f7a89ff0774$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a0dc4f7a89ff0774$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a0dc4f7a89ff0774$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a0dc4f7a89ff0774$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a0dc4f7a89ff0774$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a0dc4f7a89ff0774$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a0dc4f7a89ff0774$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a0dc4f7a89ff0774$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a0dc4f7a89ff0774$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a0dc4f7a89ff0774$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a0dc4f7a89ff0774$var$utf8Write(buf, string, offset, length) {
    return $a0dc4f7a89ff0774$var$blitBuffer($a0dc4f7a89ff0774$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a0dc4f7a89ff0774$var$asciiWrite(buf, string, offset, length) {
    return $a0dc4f7a89ff0774$var$blitBuffer($a0dc4f7a89ff0774$var$asciiToBytes(string), buf, offset, length);
}
function $a0dc4f7a89ff0774$var$base64Write(buf, string, offset, length) {
    return $a0dc4f7a89ff0774$var$blitBuffer($a0dc4f7a89ff0774$var$base64ToBytes(string), buf, offset, length);
}
function $a0dc4f7a89ff0774$var$ucs2Write(buf, string, offset, length) {
    return $a0dc4f7a89ff0774$var$blitBuffer($a0dc4f7a89ff0774$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a0dc4f7a89ff0774$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a0dc4f7a89ff0774$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a0dc4f7a89ff0774$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a0dc4f7a89ff0774$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a0dc4f7a89ff0774$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a0dc4f7a89ff0774$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a0dc4f7a89ff0774$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a0dc4f7a89ff0774$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jxbQz.fromByteArray(buf);
    else return $jxbQz.fromByteArray(buf.slice(start, end));
}
function $a0dc4f7a89ff0774$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a0dc4f7a89ff0774$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $a0dc4f7a89ff0774$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a0dc4f7a89ff0774$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $a0dc4f7a89ff0774$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a0dc4f7a89ff0774$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a0dc4f7a89ff0774$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a0dc4f7a89ff0774$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a0dc4f7a89ff0774$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $a0dc4f7a89ff0774$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a0dc4f7a89ff0774$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a0dc4f7a89ff0774$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a0dc4f7a89ff0774$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a0dc4f7a89ff0774$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a0dc4f7a89ff0774$var$Buffer.prototype.readUintLE = $a0dc4f7a89ff0774$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readUintBE = $a0dc4f7a89ff0774$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readUint8 = $a0dc4f7a89ff0774$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readUint16LE = $a0dc4f7a89ff0774$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readUint16BE = $a0dc4f7a89ff0774$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readUint32LE = $a0dc4f7a89ff0774$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readUint32BE = $a0dc4f7a89ff0774$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 4, this.length);
    return $8cWpg.read(this, offset, true, 23, 4);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 4, this.length);
    return $8cWpg.read(this, offset, false, 23, 4);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 8, this.length);
    return $8cWpg.read(this, offset, true, 52, 8);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkOffset(offset, 8, this.length);
    return $8cWpg.read(this, offset, false, 52, 8);
};
function $a0dc4f7a89ff0774$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUintLE = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a0dc4f7a89ff0774$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUintBE = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a0dc4f7a89ff0774$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUint8 = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUint16LE = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUint16BE = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUint32LE = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeUint32BE = $a0dc4f7a89ff0774$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a0dc4f7a89ff0774$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a0dc4f7a89ff0774$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a0dc4f7a89ff0774$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a0dc4f7a89ff0774$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8cWpg.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a0dc4f7a89ff0774$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a0dc4f7a89ff0774$var$writeFloat(this, value, offset, true, noAssert);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a0dc4f7a89ff0774$var$writeFloat(this, value, offset, false, noAssert);
};
function $a0dc4f7a89ff0774$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a0dc4f7a89ff0774$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8cWpg.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a0dc4f7a89ff0774$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a0dc4f7a89ff0774$var$writeDouble(this, value, offset, true, noAssert);
};
$a0dc4f7a89ff0774$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a0dc4f7a89ff0774$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a0dc4f7a89ff0774$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a0dc4f7a89ff0774$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a0dc4f7a89ff0774$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a0dc4f7a89ff0774$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $a0dc4f7a89ff0774$var$Buffer.isBuffer(val) ? val : $a0dc4f7a89ff0774$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $a0dc4f7a89ff0774$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a0dc4f7a89ff0774$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a0dc4f7a89ff0774$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a0dc4f7a89ff0774$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a0dc4f7a89ff0774$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a0dc4f7a89ff0774$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a0dc4f7a89ff0774$var$base64ToBytes(str) {
    return $jxbQz.toByteArray($a0dc4f7a89ff0774$var$base64clean(str));
}
function $a0dc4f7a89ff0774$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a0dc4f7a89ff0774$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a0dc4f7a89ff0774$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $a0dc4f7a89ff0774$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("jxbQz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $e38a49f6575c0acf$export$d622b2ad8d90c771, (v) => $e38a49f6575c0acf$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e38a49f6575c0acf$export$6100ba28696e12de, (v) => $e38a49f6575c0acf$export$6100ba28696e12de = v);
var $e38a49f6575c0acf$export$a48f0734ac7c2329;
var $e38a49f6575c0acf$export$d622b2ad8d90c771;
var $e38a49f6575c0acf$export$6100ba28696e12de;
'use strict';
$e38a49f6575c0acf$export$a48f0734ac7c2329 = $e38a49f6575c0acf$var$byteLength;
$e38a49f6575c0acf$export$d622b2ad8d90c771 = $e38a49f6575c0acf$var$toByteArray;
$e38a49f6575c0acf$export$6100ba28696e12de = $e38a49f6575c0acf$var$fromByteArray;
var $e38a49f6575c0acf$var$lookup = [];
var $e38a49f6575c0acf$var$revLookup = [];
var $e38a49f6575c0acf$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e38a49f6575c0acf$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e38a49f6575c0acf$var$i = 0, $e38a49f6575c0acf$var$len = $e38a49f6575c0acf$var$code.length; $e38a49f6575c0acf$var$i < $e38a49f6575c0acf$var$len; ++$e38a49f6575c0acf$var$i){
    $e38a49f6575c0acf$var$lookup[$e38a49f6575c0acf$var$i] = $e38a49f6575c0acf$var$code[$e38a49f6575c0acf$var$i];
    $e38a49f6575c0acf$var$revLookup[$e38a49f6575c0acf$var$code.charCodeAt($e38a49f6575c0acf$var$i)] = $e38a49f6575c0acf$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e38a49f6575c0acf$var$revLookup['-'.charCodeAt(0)] = 62;
$e38a49f6575c0acf$var$revLookup['_'.charCodeAt(0)] = 63;
function $e38a49f6575c0acf$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e38a49f6575c0acf$var$byteLength(b64) {
    var lens = $e38a49f6575c0acf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e38a49f6575c0acf$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e38a49f6575c0acf$var$toByteArray(b64) {
    var tmp;
    var lens = $e38a49f6575c0acf$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e38a49f6575c0acf$var$Arr($e38a49f6575c0acf$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i)] << 18 | $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i)] << 2 | $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i)] << 10 | $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e38a49f6575c0acf$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e38a49f6575c0acf$var$tripletToBase64(num) {
    return $e38a49f6575c0acf$var$lookup[num >> 18 & 0x3F] + $e38a49f6575c0acf$var$lookup[num >> 12 & 0x3F] + $e38a49f6575c0acf$var$lookup[num >> 6 & 0x3F] + $e38a49f6575c0acf$var$lookup[num & 0x3F];
}
function $e38a49f6575c0acf$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e38a49f6575c0acf$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e38a49f6575c0acf$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e38a49f6575c0acf$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e38a49f6575c0acf$var$lookup[tmp >> 2] + $e38a49f6575c0acf$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e38a49f6575c0acf$var$lookup[tmp >> 10] + $e38a49f6575c0acf$var$lookup[tmp >> 4 & 0x3F] + $e38a49f6575c0acf$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8cWpg", function(module, exports) {

$parcel$export(module.exports, "read", () => $5f9cc00db92eb84a$export$aafa59e2e03f2942, (v) => $5f9cc00db92eb84a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $5f9cc00db92eb84a$export$68d8715fc104d294, (v) => $5f9cc00db92eb84a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5f9cc00db92eb84a$export$aafa59e2e03f2942;
var $5f9cc00db92eb84a$export$68d8715fc104d294;
$5f9cc00db92eb84a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5f9cc00db92eb84a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("bd4rl", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $dcbd7180d45157c9$export$3e45e182e00a92c1 {
    /**
     * Get Allowance
     * @param id
     * @param relations
     * @returns TGetAllowanceResponse TGetAllowanceResponse
     * @throws ApiError
     */ static getAllowance(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/allowances/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Allowance
     * @param id
     * @param requestBody
     * @returns TUpdateAllowanceResponse TUpdateAllowanceResponse
     * @throws ApiError
     */ static updateAllowance(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/allowances/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Allowance
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteAllowance(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/allowances/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Allowances
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListAllowancesResponse TListAllowancesResponse
     * @throws ApiError
     */ static listAllowances(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/allowances',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Allowance
     * @param requestBody
     * @returns TCreateAllowanceResponse TCreateAllowanceResponse
     * @throws ApiError
     */ static createAllowance(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/allowances',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("gYVLq", function(module, exports) {

$parcel$export(module.exports, "AssetService", () => $b39a45c6a26adeda$export$29ef22b941ad5ba0);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $b39a45c6a26adeda$export$29ef22b941ad5ba0 {
    /**
     * Get Asset
     * @param id
     * @param relations
     * @returns TGetAssetResponse TGetAssetResponse
     * @throws ApiError
     */ static getAsset(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/assets/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Asset
     * @param id
     * @param requestBody
     * @returns TUpdateAssetResponse TUpdateAssetResponse
     * @throws ApiError
     */ static updateAsset(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/assets/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Asset
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteAsset(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/assets/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Assets
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @param projectId
     * @param type
     * @returns TListAssetsResponse TListAssetsResponse
     * @throws ApiError
     */ static listAssets(limit, page, orderAsJsonString, relations, projectId, type) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/assets',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
                'project_id': projectId,
                'type': type
            }
        });
    }
    /**
     * Create Asset
     * @param formData
     * @returns TCreateAssetResponse TCreateAssetResponse
     * @throws ApiError
     */ static createAsset(formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/assets',
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Create Asset from Google Drive
     * @param requestBody
     * @returns TCreateAssetResponse TCreateAssetResponse
     * @throws ApiError
     */ static createAssetFromCloud(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/assets/from-cloud',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * @deprecated
     * Create Asset from Google Drive
     * @param requestBody
     * @returns TCreateAssetResponse TCreateAssetResponse
     * @throws ApiError
     */ static createAssetFromDrive(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/assets/from-drive',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Get Signed Url for Asset File
     * @param id
     * @returns string Ok
     * @throws ApiError
     */ static getSignedUrl(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/assets/signed-url/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get Signed Url for Asset Thumbnail
     * @param id
     * @returns string Ok
     * @throws ApiError
     */ static getThumbnailUrl(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/assets/thumbnail-url/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get Storage Usage for Group
     * @param groupId
     * @returns TGetStorageUsageResponse Ok
     * @throws ApiError
     */ static getStorageUsage(groupId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/assets/storage-usage/{group_id}',
            path: {
                'group_id': groupId
            }
        });
    }
}

});

parcelRegister("leCVP", function(module, exports) {

$parcel$export(module.exports, "AuditService", () => $fa7201b72b7db276$export$6a8654e02dd758fc);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $fa7201b72b7db276$export$6a8654e02dd758fc {
    /**
     * List Audit Log
     * @param entityName
     * @param actorUserId
     * @param action
     * @param fromDate
     * @param toDate
     * @param limit
     * @param page
     * @returns TListAuditLogResponse TListAuditLogResponse
     * @throws ApiError
     */ static listAuditLog(entityName, actorUserId, action, fromDate, toDate, limit, page) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/audit-log',
            query: {
                'entityName': entityName,
                'actorUserId': actorUserId,
                'action': action,
                'fromDate': fromDate,
                'toDate': toDate,
                'limit': limit,
                'page': page
            }
        });
    }
}

});

parcelRegister("5VwGg", function(module, exports) {

$parcel$export(module.exports, "AuthenticationService", () => $d8b63ec92b73500c$export$a15b8b4ccae62017);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $d8b63ec92b73500c$export$a15b8b4ccae62017 {
    /**
     * Login
     * @param requestBody
     * @returns TLoginResponse TLoginResponse
     * @throws ApiError
     */ static login(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/login',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("lQtnN", function(module, exports) {

$parcel$export(module.exports, "ChatService", () => $de5c298c22a1e5f6$export$446e355f79c9563c);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $de5c298c22a1e5f6$export$446e355f79c9563c {
    /**
     * Chat
     * @param requestBody
     * @returns ChatMessage TChatResponse
     * @throws ApiError
     */ static chat(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/chat',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * List the requesting user's own channels (TM engagement channels + their group's Support channel).
     * Declared before the `{id}` routes below so `/chat/channels` isn't swallowed by `/chat/{id}`.
     * @returns TListMyChannelsResponse TListMyChannelsResponse
     * @throws ApiError
     */ static listMyChannels() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/chat/channels'
        });
    }
    /**
     * Mark a channel as read for the requesting user
     * @param id
     * @returns void
     * @throws ApiError
     */ static markChannelRead(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/chat/channels/{id}/read',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("leMeY", function(module, exports) {

$parcel$export(module.exports, "CommercialService", () => $43442fd3b34194cb$export$5cb45a43ad743eb2);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $43442fd3b34194cb$export$5cb45a43ad743eb2 {
    /**
     * Get Commercial
     * @param id
     * @param relations
     * @returns TGetCommercialResponse TGetCommercialResponse
     * @throws ApiError
     */ static getCommercial(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/commercials/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Commercial
     * @param id
     * @param requestBody
     * @returns TUpdateCommercialResponse TUpdateCommercialResponse
     * @throws ApiError
     */ static updateCommercial(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/commercials/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Commercial
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteCommercial(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/commercials/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Commercials
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListCommercialsResponse TListCommercialsResponse
     * @throws ApiError
     */ static listCommercials(projectId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/commercials',
            query: {
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Commercial
     * @param requestBody
     * @returns TCreateCommercialResponse TCreateCommercialResponse
     * @throws ApiError
     */ static createCommercial(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/commercials',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Generate Completion Report (Final Cast)
     * @param id Commercial ID
     * @returns string PDF as base64 string
     * @throws ApiError
     */ static generateCompletionReport(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/commercials/{id}/completion-report',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("dlTVI", function(module, exports) {

$parcel$export(module.exports, "ConversationService", () => $c3bfd4b00d302001$export$4097a1a257609c41);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $c3bfd4b00d302001$export$4097a1a257609c41 {
    /**
     * List Conversations
     * @param status
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListConversationsResponse TListConversationsResponse
     * @throws ApiError
     */ static listConversations(status, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/chat',
            query: {
                'status': status,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Get Conversation
     * @param id
     * @param relations
     * @returns TGetConversationResponse TGetConversationResponse
     * @throws ApiError
     */ static getConversation(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/chat/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Conversation
     * @param id
     * @param requestBody
     * @returns TUpdateConversationResponse TUpdateConversationResponse
     * @throws ApiError
     */ static updateConversation(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/chat/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Paginated message history for a conversation, newest page first. Replaces requesting the
     * unbounded `chatMessages` relation via `getConversation` for long-running channels.
     * @param id
     * @param limit
     * @param page
     * @returns TListChatMessagesResponse TListChatMessagesResponse
     * @throws ApiError
     */ static listChatMessages(id, limit, page) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/chat/{id}/messages',
            path: {
                'id': id
            },
            query: {
                'limit': limit,
                'page': page
            }
        });
    }
    /**
     * Delete Conversation
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteConversation(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/chat/{id}/delete',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("bG9RN", function(module, exports) {

$parcel$export(module.exports, "CostumeService", () => $5302c6f4b54d82bd$export$9de1f47af5db3cf8);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $5302c6f4b54d82bd$export$9de1f47af5db3cf8 {
    /**
     * Get Costume
     * @param id
     * @param relations
     * @returns TGetCostumeResponse TGetCostumeResponse
     * @throws ApiError
     */ static getCostume(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/costumes/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Costume
     * @param id
     * @param requestBody
     * @returns TUpdateCostumeResponse TUpdateCostumeResponse
     * @throws ApiError
     */ static updateCostume(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/costumes/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Costume
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteCostume(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/costumes/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Costumes
     * @param roleId
     * @param scriptId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListCostumesResponse TListCostumesResponse
     * @throws ApiError
     */ static listCostumes(roleId, scriptId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/costumes',
            query: {
                'roleId': roleId,
                'scriptId': scriptId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Costume
     * @param requestBody
     * @returns TCreateCostumeResponse TCreateCostumeResponse
     * @throws ApiError
     */ static createCostume(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/costumes',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("8zK2X", function(module, exports) {

$parcel$export(module.exports, "CreditsService", () => $1644cff7ebdc99cb$export$77f9bbaa869101e9);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $1644cff7ebdc99cb$export$77f9bbaa869101e9 {
    /**
     * List available credit packages
     * @returns TListCreditPackagesResponse Ok
     * @throws ApiError
     */ static listCreditPackages() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/credits/packages'
        });
    }
    /**
     * Create a credit package (admin only)
     * @param requestBody
     * @returns TCreditPackageResponse Ok
     * @throws ApiError
     */ static createCreditPackage(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/credits/packages',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * List all credit packages, including inactive ones (admin only)
     * @returns TListCreditPackagesResponse Ok
     * @throws ApiError
     */ static listAllCreditPackages() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/credits/packages/admin/all'
        });
    }
    /**
     * Update a credit package (admin only)
     * @param id
     * @param requestBody
     * @returns TCreditPackageResponse Ok
     * @throws ApiError
     */ static updateCreditPackage(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/credits/packages/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete a credit package (admin only)
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteCreditPackage(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/credits/packages/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Create a Stripe Checkout session for purchasing credits
     * @param requestBody
     * @returns TCreateCreditCheckoutResponse Ok
     * @throws ApiError
     */ static createCreditCheckout(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/credits/checkout',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * List credit purchases for an engagement
     * @param engagementId
     * @returns TListCreditPurchasesResponse Ok
     * @throws ApiError
     */ static listCreditPurchases(engagementId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/credits/purchases',
            query: {
                'engagementId': engagementId
            }
        });
    }
}

});

parcelRegister("1XZc5", function(module, exports) {

$parcel$export(module.exports, "DocumentService", () => $2fa2dac7076c59ea$export$136703b96b9b8f33);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $2fa2dac7076c59ea$export$136703b96b9b8f33 {
    /**
     * Get Document
     * @param id
     * @param relations
     * @returns TGetDocumentResponse TGetDocumentResponse
     * @throws ApiError
     */ static getDocument(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/documents/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Document
     * @param id
     * @param requestBody
     * @returns TUpdateDocumentResponse TUpdateDocumentResponse
     * @throws ApiError
     */ static updateDocument(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/documents/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Document
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteDocument(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/documents/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Documents
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListDocumentsResponse TListDocumentsResponse
     * @throws ApiError
     */ static listDocuments(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/documents',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Document
     * @param formData
     * @returns TCreateDocumentResponse TCreateDocumentResponse
     * @throws ApiError
     */ static createDocument(formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/documents',
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Get Signed Url for Document File
     * @param id
     * @returns string Ok
     * @throws ApiError
     */ static getSignedUrl(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/documents/signed-url/{id}',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("2R8LL", function(module, exports) {

$parcel$export(module.exports, "EditService", () => $655a61269d9308e4$export$b0e376ce73e1f619);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $655a61269d9308e4$export$b0e376ce73e1f619 {
    /**
     * Get Edit
     * @param id
     * @param relations
     * @returns TGetEditResponse TGetEditResponse
     * @throws ApiError
     */ static getEdit(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/edits/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Edit
     * @param id
     * @param requestBody
     * @returns TUpdateEditResponse TUpdateEditResponse
     * @throws ApiError
     */ static updateEdit(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/edits/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Edit
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteEdit(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/edits/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Edits
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListEditsResponse TListEditsResponse
     * @throws ApiError
     */ static listEdits(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/edits',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Edit
     * @param requestBody
     * @returns TCreateEditResponse TCreateEditResponse
     * @throws ApiError
     */ static createEdit(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/edits',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("emlIu", function(module, exports) {

$parcel$export(module.exports, "EditReviewService", () => $027e9816e60d45cd$export$a049d35120652b75);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $027e9816e60d45cd$export$a049d35120652b75 {
    /**
     * Get EditReview
     * @param editId
     * @param relations
     * @returns TGetEditReviewResponse TGetEditReviewResponse
     * @throws ApiError
     */ static getEditReviewByEditId(editId, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/edit-reviews/{editId}',
            path: {
                'editId': editId
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Create EditReview
     * @param requestBody
     * @returns TCreateEditReviewResponse TCreateEditReviewResponse
     * @throws ApiError
     */ static createEditReview(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/edit-reviews',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Reclassify performer (upgrade/downgrade)
     * @param editId
     * @param requestBody
     * @returns TReclassifyPerformerResponse TReclassifyPerformerResponse
     * @throws ApiError
     */ static reclassifyPerformer(editId, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PATCH',
            url: '/edit-reviews/{editId}/reclassify',
            path: {
                'editId': editId
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Mark performer as invalid detection (false positive)
     * @param editId
     * @param requestBody
     * @returns TMarkPerformerInvalidResponse TMarkPerformerInvalidResponse
     * @throws ApiError
     */ static markPerformerInvalid(editId, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PATCH',
            url: '/edit-reviews/{editId}/mark-invalid',
            path: {
                'editId': editId
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Outgrade performer (contracted performer not in edit)
     * @param editId
     * @param requestBody
     * @returns TOutgradePerformerResponse TOutgradePerformerResponse
     * @throws ApiError
     */ static outgradePerformer(editId, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PATCH',
            url: '/edit-reviews/{editId}/outgrade',
            path: {
                'editId': editId
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Merge multiple performers into one (Phase 3)
     * @param editId
     * @param requestBody
     * @returns TMergePerformersResponse TMergePerformersResponse
     * @throws ApiError
     */ static mergePerformers(editId, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/edit-reviews/{editId}/merge-performers',
            path: {
                'editId': editId
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Identify unknown performer as contracted performer (Phase 3)
     * @param editId
     * @param requestBody
     * @returns TIdentifyPerformerResponse TIdentifyPerformerResponse
     * @throws ApiError
     */ static identifyPerformer(editId, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/edit-reviews/{editId}/identify-performer',
            path: {
                'editId': editId
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("NcqgP", function(module, exports) {

$parcel$export(module.exports, "EstimateService", () => $bee0cd8cba3bcca7$export$4f017824eefa6c54);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $bee0cd8cba3bcca7$export$4f017824eefa6c54 {
    /**
     * Get Session Estimate Subtotals
     * @param id
     * @returns TGetSessionEstimateSubtotalsResponse TGetSessionEstimateSubtotalsResponse
     * @throws ApiError
     */ static getSessionEstimateSubtotals(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-estimates/{id}/subtotals',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get Estimate
     * @param id
     * @param relations
     * @returns TGetEstimateResponse TGetEstimateResponse
     * @throws ApiError
     */ static getEstimate(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/estimates/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Estimate
     * @param id
     * @param requestBody
     * @returns TUpdateEstimateResponse TUpdateEstimateResponse
     * @throws ApiError
     */ static updateEstimate(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/estimates/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Estimate
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteEstimate(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/estimates/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get Estimate Totals
     * @param title
     * @param relations
     * @param isHidden
     * @returns TGetEstimateByTitleResponse TGetEstimateTotalsResponse
     * @throws ApiError
     */ static getEstimateByTitle(title, relations, isHidden) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/estimates/title/{title}',
            path: {
                'title': title
            },
            query: {
                'relations': relations,
                'isHidden': isHidden
            }
        });
    }
    /**
     * Get Estimate Totals
     * @param id
     * @returns TGetEstimateTotalsResponse TGetEstimateTotalsResponse
     * @throws ApiError
     */ static getEstimateTotals(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/estimates/{id}/totals',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Estimates
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListEstimatesResponse TListEstimatesResponse
     * @throws ApiError
     */ static listEstimates(projectId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/estimates',
            query: {
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Estimate
     * @param requestBody
     * @returns TCreateEstimateResponse TCreateEstimateResponse
     * @throws ApiError
     */ static createEstimate(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/estimates',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Recalculate Estimate
     * @param id
     * @returns TRecalculateEstimateResponse TRecalculateEstimateResponse
     * @throws ApiError
     */ static recalculateEstimate(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/estimates/{id}/recalculate',
            path: {
                'id': id
            }
        });
    }
    /**
     * Update Estimate Status
     * @param id
     * @param requestBody
     * @returns TUpdateEstimateStatusResponse TUpdateEstimateResponse
     * @throws ApiError
     */ static updateEstimateStatus(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/estimates/{id}/status',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("bUwq7", function(module, exports) {

$parcel$export(module.exports, "FeatureService", () => $f567864088ff3cb3$export$15c20eda9b2cb49a);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $f567864088ff3cb3$export$15c20eda9b2cb49a {
    /**
     * Get Feature
     * @param id
     * @param relations
     * @returns TGetFeatureResponse TGetFeatureResponse
     * @throws ApiError
     */ static getFeature(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/features/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Feature
     * @param id
     * @param requestBody
     * @returns TUpdateFeatureResponse TUpdateFeatureResponse
     * @throws ApiError
     */ static updateFeature(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/features/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Feature
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteFeature(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/features/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Features
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListFeaturesResponse TListFeaturesResponse
     * @throws ApiError
     */ static listFeatures(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/features',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Feature
     * @param requestBody
     * @returns TCreateFeatureResponse TCreateFeatureResponse
     * @throws ApiError
     */ static createFeature(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/features',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("cGwx1", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $861e96c936db8cbd$export$fcf8deb966fe7bd8 {
    /**
     * Get Fee
     * @param id
     * @param relations
     * @returns TGetFeeResponse TGetFeeResponse
     * @throws ApiError
     */ static getFee(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/fees/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Fee
     * @param id
     * @param requestBody
     * @returns TUpdateFeeResponse TUpdateFeeResponse
     * @throws ApiError
     */ static updateFee(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/fees/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Fee
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteFee(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/fees/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Fees
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListFeesResponse TListFeesResponse
     * @throws ApiError
     */ static listFees(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/fees',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Fee
     * @param requestBody
     * @returns TCreateFeeResponse TCreateFeeResponse
     * @throws ApiError
     */ static createFee(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/fees',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("aBFJh", function(module, exports) {

$parcel$export(module.exports, "GroupService", () => $0d8736e646041d5c$export$fb317d4325fc811d);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $0d8736e646041d5c$export$fb317d4325fc811d {
    /**
     * Get Group
     * @param id
     * @param relations
     * @returns TGetGroupResponse TGetGroupResponse
     * @throws ApiError
     */ static getGroup(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/groups/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Group
     * @param id
     * @param requestBody
     * @returns TUpdateGroupResponse TUpdateGroupResponse
     * @throws ApiError
     */ static updateGroup(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/groups/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Group
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteGroup(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/groups/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Groups
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListGroupsResponse TListGroupsResponse
     * @throws ApiError
     */ static listGroups(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/groups',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Group
     * @param requestBody
     * @returns TCreateGroupResponse TCreateGroupResponse
     * @throws ApiError
     */ static createGroup(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/groups',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Accept a group invitation
     * @param requestBody
     * @returns TAcceptGroupInviteResponse TAcceptGroupInviteResponse
     * @throws ApiError
     */ static acceptInvitation(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/groups/accept-invitation',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Resend a group invitation
     * @param requestBody
     * @returns void
     * @throws ApiError
     */ static resendInvitation(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/groups/resend-invitation',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete a group invitation
     * @param email
     * @param groupId
     * @returns Group void
     * @throws ApiError
     */ static deleteInvitation(email, groupId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/groups/invitation',
            query: {
                'email': email,
                'group_id': groupId
            }
        });
    }
}

});

parcelRegister("cY3qa", function(module, exports) {

$parcel$export(module.exports, "HealthCheckService", () => $48b05eff9bcca6c8$export$561f1f99946e2a7);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $48b05eff9bcca6c8$export$561f1f99946e2a7 {
    /**
     * Health Check
     * @returns THealthCheckResponse Ok
     * @throws ApiError
     */ static healthCheck() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/healthz'
        });
    }
}

});

parcelRegister("lU3Ny", function(module, exports) {

$parcel$export(module.exports, "HoldingFeeService", () => $f76b1e3dc029cafe$export$bb29de57888ab781);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $f76b1e3dc029cafe$export$bb29de57888ab781 {
    /**
     * List holding fees coming due (or overdue) across a project
     * @param projectId
     * @param withinDays
     * @returns TListProjectHoldingFeesDueResponse TListProjectHoldingFeesDueResponse
     * @throws ApiError
     */ static listProjectHoldingFeesDue(projectId, withinDays) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/holding-fees',
            query: {
                'projectId': projectId,
                'withinDays': withinDays
            }
        });
    }
}

});

parcelRegister("i9Nmr", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $25de9f12137be18f$export$326db03cbd28b27 {
    /**
     * Send notification to user via WebSocket
     * Called by workers to notify users of job completion
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */ static sendNotification(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/internal/notifications/send',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("kQx3f", function(module, exports) {

$parcel$export(module.exports, "LocationService", () => $bf89505184b56e74$export$57f591496575d3cf);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $bf89505184b56e74$export$57f591496575d3cf {
    /**
     * Get Location
     * @param id
     * @param relations
     * @returns TGetLocationResponse TGetLocationResponse
     * @throws ApiError
     */ static getLocation(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/locations/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Location
     * @param id
     * @param requestBody
     * @returns TUpdateLocationResponse TUpdateLocationResponse
     * @throws ApiError
     */ static updateLocation(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/locations/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Location
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteLocation(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/locations/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Locations
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListLocationsResponse TListLocationsResponse
     * @throws ApiError
     */ static listLocations(projectId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/locations',
            query: {
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Location
     * @param requestBody
     * @returns TCreateLocationResponse TCreateLocationResponse
     * @throws ApiError
     */ static createLocation(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/locations',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("iE4UJ", function(module, exports) {

$parcel$export(module.exports, "NotificationService", () => $a6cfd1f8585f791e$export$cfe57eeafcf44ca0);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $a6cfd1f8585f791e$export$cfe57eeafcf44ca0 {
    /**
     * List Notifications
     * @param unread
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListNotificationsResponse TListNotificationsResponse
     * @throws ApiError
     */ static listNotifications(unread, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/notifications',
            query: {
                'unread': unread,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Get Unread Notifications Count
     * @returns TGetUnreadNotificationsCountResponse TGetUnreadNotificationsCountResponse
     * @throws ApiError
     */ static getUnreadCount() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/notifications/unread-count'
        });
    }
    /**
     * Get Notification
     * @param id
     * @param relations
     * @returns TGetNotificationResponse TGetNotificationResponse
     * @throws ApiError
     */ static getNotification(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/notifications/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Notification
     * @param id
     * @param requestBody
     * @returns TUpdateNotificationResponse TUpdateNotificationResponse
     * @throws ApiError
     */ static updateNotification(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/notifications/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Notification
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteNotification(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/notifications/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Bulk Update Notifications
     * @param requestBody
     * @returns TBulkUpdateNotificationsResponse void
     * @throws ApiError
     */ static bulkUpdate(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/notifications/bulk-update',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("1KlRo", function(module, exports) {

$parcel$export(module.exports, "PerformerService", () => $6131a2b9f83dc9db$export$46e6940d17135fb);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $6131a2b9f83dc9db$export$46e6940d17135fb {
    /**
     * Lookup Performer by email
     * @param email
     * @returns TLookupPerformerResponse TLookupPerformerResponse
     * @throws ApiError
     */ static lookupPerformerByEmail(email) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/performers/lookup',
            query: {
                'email': email
            }
        });
    }
    /**
     * Get Performer
     * @param id
     * @param relations
     * @returns TGetPerformerResponse TGetPerformerResponse
     * @throws ApiError
     */ static getPerformer(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/performers/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Performer
     * @param id
     * @param requestBody
     * @returns TUpdatePerformerResponse TUpdatePerformerResponse
     * @throws ApiError
     */ static updatePerformer(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/performers/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Performer
     * @param id
     * @returns void
     * @throws ApiError
     */ static deletePerformer(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/performers/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Performers
     * @param projectId
     * @param search
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListPerformersResponse TListPerformersResponse
     * @throws ApiError
     */ static listPerformers(projectId, search, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/performers',
            query: {
                'projectId': projectId,
                'search': search,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Performer
     * @param requestBody
     * @returns TCreatePerformerResponse TCreatePerformerResponse
     * @throws ApiError
     */ static createPerformer(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/performers',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Hire existing performer
     * @param requestBody
     * @returns THireExistingPerformerResponse THireExistingPerformerResponse
     * @throws ApiError
     */ static hireExistingPerformer(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/performers/hire',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Invite performer to complete onboarding
     * @param requestBody
     * @returns void
     * @throws ApiError
     */ static invitePerformer(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/performers/{id}/invite',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Validate Performer Invite Token
     * @param token
     * @returns any Ok
     * @throws ApiError
     */ static validatePerformerOnboardingToken(token) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/performers/onboarding/validate/{token}',
            path: {
                'token': token
            }
        });
    }
    /**
     * Upload Performer selfie
     * @param formData
     * @returns void
     * @throws ApiError
     */ static uploadPerformerSelfie(formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/performers/onboarding/selfie',
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Get Performer selfie URL
     * @param performerId
     * @returns any Signed URL for accessing the selfie
     * @throws ApiError
     */ static getPerformerSelfieUrl(performerId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/performers/{performerId}/selfie-url',
            path: {
                'performerId': performerId
            }
        });
    }
}

});

parcelRegister("g87cD", function(module, exports) {

$parcel$export(module.exports, "PerformerContractService", () => $8f1c74d50ac91c06$export$831dc787250a39cd);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $8f1c74d50ac91c06$export$831dc787250a39cd {
    /**
     * Get PerformerContract by ID
     * @param id
     * @param relations
     * @returns TGetPerformerContractResponse TGetPerformerContractResponse
     * @throws ApiError
     */ static getPerformerContract(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/contracts/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update PerformerContract
     * @param id
     * @param requestBody
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */ static updatePerformerContract(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/contracts/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * List PerformerContracts with optional filtering
     * @param performerId
     * @param commercialId
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListPerformerContractsResponse TListPerformerContractsResponse
     * @throws ApiError
     */ static listPerformerContracts(performerId, commercialId, projectId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/contracts',
            query: {
                'performerId': performerId,
                'commercialId': commercialId,
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Update Character Photos
     * @param id
     * @param formData
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */ static updateCharacterPhotos(id, formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/contracts/{id}/photos',
            path: {
                'id': id
            },
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Get signed character photo URLs
     * @param id
     * @returns TCharacterPhotoUrl TCharacterPhotoUrl[]
     * @throws ApiError
     */ static getCharacterPhotos(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/contracts/{id}/photos',
            path: {
                'id': id
            }
        });
    }
    /**
     * Finalize a contract (mark as finalized and generate PDF)
     * @param id
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */ static finalizeContract(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/finalize',
            path: {
                'id': id
            }
        });
    }
    /**
     * Cancel a contract
     * @param id
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */ static cancelContract(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/cancel',
            path: {
                'id': id
            }
        });
    }
    /**
     * Add a time log entry to a contract
     * @param id
     * @param requestBody
     * @returns TTimeLogEntryResponse TTimeLogEntryResponse
     * @throws ApiError
     */ static addTimeLog(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/timelogs',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Get the holding fee schedule for a contract
     * @param id
     * @returns TGetHoldingFeeScheduleResponse TGetHoldingFeeScheduleResponse
     * @throws ApiError
     */ static getHoldingFeeSchedule(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/contracts/{id}/holding-fees',
            path: {
                'id': id
            }
        });
    }
    /**
     * Record a Paid/Waived override for one holding fee cycle
     * @param id
     * @param cycleNumber
     * @param requestBody
     * @returns TUpdateHoldingFeeCycleResponse TUpdateHoldingFeeCycleResponse
     * @throws ApiError
     */ static updateHoldingFeeCycle(id, cycleNumber, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/contracts/{id}/holding-fees/{cycleNumber}',
            path: {
                'id': id,
                'cycleNumber': cycleNumber
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Send contract via email
     * @param id
     * @param requestBody
     * @returns TSendContractEmailResponse TSendContractEmailResponse
     * @throws ApiError
     */ static sendContractEmail(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/send',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Download contract PDF
     * @param id
     * @returns string PDF buffer
     * @throws ApiError
     */ static downloadContractPdf(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/contracts/{id}/download',
            path: {
                'id': id
            }
        });
    }
    /**
     * Sign a contract with performer's signature
     * @param id
     * @param requestBody
     * @returns TContractSignatureResponse TContractSignatureResponse
     * @throws ApiError
     */ static signContract(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/sign',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Time Log
     * @param id Contract ID
     * @param timeLogId Time Log ID to delete
     * @returns TDeleteTimeLogResponse Success response
     * @throws ApiError
     */ static deleteTimeLog(id, timeLogId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/contracts/{id}/timelogs/{timeLogId}',
            path: {
                'id': id,
                'timeLogId': timeLogId
            }
        });
    }
    /**
     * Approve time log — performer submits initials confirming logged hours are accurate.
     * Transitions contract status to TIME_LOG_APPROVED and writes initials to Text Field28 in the PDF.
     * @param id Contract ID
     * @param requestBody TApproveTimeLogRequest
     * @returns TUpdatePerformerContractResponse Updated contract
     * @throws ApiError
     */ static approveTimeLog(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/approve-time-log',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Generate a mobile capture token for a contract (authenticated producer).
     * The returned token can be embedded in a QR code so a mobile device can
     * upload character photos without requiring the producer's session.
     * @param id Contract ID
     * @returns any : string }
     * @throws ApiError
     */ static generateCaptureToken(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/{id}/capture-token',
            path: {
                'id': id
            }
        });
    }
    /**
     * Validate a capture token and return contract/performer info.
     * Public endpoint — no auth required. Used by the mobile capture page on load.
     * @param token The capture token
     * @returns any : string; performerName: string }
     * @throws ApiError
     */ static validateCaptureToken(token) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/contracts/capture/{token}',
            path: {
                'token': token
            }
        });
    }
    /**
     * Upload character photos via capture token (mobile / QR-code flow).
     * Public endpoint — authenticated via the capture token, not a user JWT.
     * @param token The capture token
     * @param formData
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */ static uploadPhotosWithCaptureToken(token, formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/contracts/capture/{token}/photos',
            path: {
                'token': token
            },
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
}

});

parcelRegister("lhiX6", function(module, exports) {

$parcel$export(module.exports, "PricingTierService", () => $2c8519d83dc29b62$export$f5878f35afa93abf);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $2c8519d83dc29b62$export$f5878f35afa93abf {
    /**
     * Get Pricing Tier
     * @param id
     * @param relations
     * @returns TGetPricingTierResponse TGetPricingTierResponse
     * @throws ApiError
     */ static getPricingTier(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/pricing-tiers/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Pricing Tier
     * @param id
     * @param requestBody
     * @returns TUpdatePricingTierResponse TUpdatePricingTierResponse
     * @throws ApiError
     */ static updatePricingTier(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/pricing-tiers/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Pricing Tier
     * @param id
     * @returns void
     * @throws ApiError
     */ static deletePricingTier(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/pricing-tiers/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Pricing Tiers
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListPricingTiersResponse TListPricingTiersResponse
     * @throws ApiError
     */ static listPricingTiers(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/pricing-tiers',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Pricing Tier
     * @param requestBody
     * @returns TCreatePricingTierResponse TCreatePricingTierResponse
     * @throws ApiError
     */ static createPricingTier(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/pricing-tiers',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("dvSQf", function(module, exports) {

$parcel$export(module.exports, "ProjectService", () => $676f0c23befdff15$export$9616f8c54d4f56aa);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $676f0c23befdff15$export$9616f8c54d4f56aa {
    /**
     * Get Project
     * @param id
     * @param relations
     * @returns TGetProjectResponse TGetProjectResponse
     * @throws ApiError
     */ static getProject(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/projects/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Project
     * @param id
     * @param requestBody
     * @returns TUpdateProjectResponse TUpdateProjectResponse
     * @throws ApiError
     */ static updateProject(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/projects/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Project
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteProject(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/projects/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Projects
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListProjectsResponse TListProjectsResponse
     * @throws ApiError
     */ static listProjects(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/projects',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Project
     * @param requestBody
     * @returns TCreateProjectResponse TCreateProjectResponse
     * @throws ApiError
     */ static createProject(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/projects',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("3bCvT", function(module, exports) {

$parcel$export(module.exports, "PropService", () => $beff0f576e2fcac9$export$fa4e67f39f9f761d);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $beff0f576e2fcac9$export$fa4e67f39f9f761d {
    /**
     * Get Prop
     * @param id
     * @param relations
     * @returns TGetPropResponse TGetPropResponse
     * @throws ApiError
     */ static getProp(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/props/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Prop
     * @param id
     * @param requestBody
     * @returns TUpdatePropResponse TUpdatePropResponse
     * @throws ApiError
     */ static updateProp(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/props/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Prop
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteProp(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/props/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Props
     * @param roleId
     * @param scriptId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListPropsResponse TListPropsResponse
     * @throws ApiError
     */ static listProps(roleId, scriptId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/props',
            query: {
                'roleId': roleId,
                'scriptId': scriptId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Prop
     * @param requestBody
     * @returns TCreatePropResponse TCreatePropResponse
     * @throws ApiError
     */ static createProp(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/props',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("1b5lS", function(module, exports) {

$parcel$export(module.exports, "RightService", () => $4efc59dcd2b67f06$export$4b37ec24927d2ba7);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $4efc59dcd2b67f06$export$4b37ec24927d2ba7 {
    /**
     * Get Right
     * @param id
     * @param relations
     * @returns TGetRightResponse TGetRightResponse
     * @throws ApiError
     */ static getRight(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/rights/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Right
     * @param id
     * @param requestBody
     * @returns TUpdateRightResponse TUpdateRightResponse
     * @throws ApiError
     */ static updateRight(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/rights/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Right
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteRight(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/rights/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Rights
     * @param advertiserId
     * @param commercialId
     * @param status
     * @param rightType
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListRightsResponse TListRightsResponse
     * @throws ApiError
     */ static listRights(advertiserId, commercialId, status, rightType, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/rights',
            query: {
                'advertiserId': advertiserId,
                'commercialId': commercialId,
                'status': status,
                'rightType': rightType,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Right
     * @param requestBody
     * @returns TCreateRightResponse TCreateRightResponse
     * @throws ApiError
     */ static createRight(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/rights',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("f9fOF", function(module, exports) {

$parcel$export(module.exports, "RoleService", () => $af536ae1d4281411$export$bb170c807acfe5f);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $af536ae1d4281411$export$bb170c807acfe5f {
    /**
     * Get Role
     * @param id
     * @param relations
     * @returns TGetRoleResponse TGetRoleResponse
     * @throws ApiError
     */ static getRole(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/roles/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Role
     * @param id
     * @param requestBody
     * @returns TUpdateRoleResponse TUpdateRoleResponse
     * @throws ApiError
     */ static updateRole(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/roles/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Role
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteRole(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/roles/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Roles
     * @param projectId
     * @param scriptId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListRolesResponse TListRolesResponse
     * @throws ApiError
     */ static listRoles(projectId, scriptId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/roles',
            query: {
                'projectId': projectId,
                'scriptId': scriptId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Role
     * @param requestBody
     * @returns TCreateRoleResponse TCreateRoleResponse
     * @throws ApiError
     */ static createRole(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/roles',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("gR3wM", function(module, exports) {

$parcel$export(module.exports, "RoleActivityService", () => $8fd2b39dbcc019ba$export$b8e52ff97dff7d6d);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $8fd2b39dbcc019ba$export$b8e52ff97dff7d6d {
    /**
     * Get RoleActivity
     * @param id
     * @param relations
     * @returns TGetRoleActivityResponse TGetRoleActivityResponse
     * @throws ApiError
     */ static getRoleActivity(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/role-activities/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update RoleActivity
     * @param id
     * @param requestBody
     * @returns TUpdateRoleActivityResponse TUpdateRoleActivityResponse
     * @throws ApiError
     */ static updateRoleActivity(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/role-activities/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete RoleActivity
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteRoleActivity(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/role-activities/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List RoleActivities
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListRoleActivitiesResponse TListRoleActivitiesResponse
     * @throws ApiError
     */ static listRoleActivities(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/role-activities',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create RoleActivity
     * @param requestBody
     * @returns TCreateRoleActivityResponse TCreateRoleActivityResponse
     * @throws ApiError
     */ static createRoleActivity(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/role-activities',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("khgRv", function(module, exports) {

$parcel$export(module.exports, "RoleGroupService", () => $c84dc4a99fd3191b$export$a48cd6c9d2f84e43);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $c84dc4a99fd3191b$export$a48cd6c9d2f84e43 {
    /**
     * Get RoleGroup
     * @param id
     * @param relations
     * @returns TGetRoleGroupResponse TGetRoleGroupResponse
     * @throws ApiError
     */ static getRoleGroup(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/role-groups/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update RoleGroup
     * @param id
     * @param requestBody
     * @returns TUpdateRoleGroupResponse TUpdateRoleGroupResponse
     * @throws ApiError
     */ static updateRoleGroup(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/role-groups/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete RoleGroup
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteRoleGroup(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/role-groups/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List RoleGroups
     * @param projectId
     * @param scriptId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListRoleGroupsResponse TListRoleGroupsResponse
     * @throws ApiError
     */ static listRoleGroups(projectId, scriptId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/role-groups',
            query: {
                'projectId': projectId,
                'scriptId': scriptId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create RoleGroup
     * @param requestBody
     * @returns TCreateRoleGroupResponse TCreateRoleGroupResponse
     * @throws ApiError
     */ static createRoleGroup(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/role-groups',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("iKpUE", function(module, exports) {

$parcel$export(module.exports, "ScriptService", () => $410a56473e7de533$export$b8b9943bdb438a12);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $410a56473e7de533$export$b8b9943bdb438a12 {
    /**
     * Get Script
     * @param id
     * @param relations
     * @returns TGetScriptResponse TGetScriptResponse
     * @throws ApiError
     */ static getScript(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/scripts/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Script
     * @param id
     * @param requestBody
     * @returns TUpdateScriptResponse TUpdateScriptResponse
     * @throws ApiError
     */ static updateScript(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/scripts/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Script
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteScript(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/scripts/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get Script by Document ID
     * @param docId
     * @param relations
     * @returns TGetScriptResponse TGetScriptResponse
     * @throws ApiError
     */ static getScriptByDocId(docId, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/scripts/doc/{docId}',
            path: {
                'docId': docId
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * List Scripts
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListScriptsResponse TListScriptsResponse
     * @throws ApiError
     */ static listScripts(projectId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/scripts',
            query: {
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Script
     * @param requestBody
     * @returns TCreateScriptResponse TCreateScriptResponse
     * @throws ApiError
     */ static createScript(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/scripts',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("jBzsC", function(module, exports) {

$parcel$export(module.exports, "SecretService", () => $917460fcff434f36$export$680addaea0ddf18b);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $917460fcff434f36$export$680addaea0ddf18b {
    /**
     * Secret Key
     * @param requestBody
     * @returns TSecretKeyResponse TSecretKeyResponse
     * @throws ApiError
     */ static getSecretKey(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/secrets',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("bHCgu", function(module, exports) {

$parcel$export(module.exports, "SessionService", () => $a9e2c2e5c98c5103$export$9fb9e5e400f7ae6e);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $a9e2c2e5c98c5103$export$9fb9e5e400f7ae6e {
    /**
     * Get Session
     * @param id
     * @param relations
     * @returns TGetSessionResponse TGetSessionResponse
     * @throws ApiError
     */ static getSession(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/sessions/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Session
     * @param id
     * @param requestBody
     * @returns TUpdateSessionResponse TUpdateSessionResponse
     * @throws ApiError
     */ static updateSession(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/sessions/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Session
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteSession(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/sessions/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Sessions
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListSessionsResponse TListSessionsResponse
     * @throws ApiError
     */ static listSessions(projectId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/sessions',
            query: {
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Session
     * @param requestBody
     * @returns TCreateSessionResponse TCreateSessionResponse
     * @throws ApiError
     */ static createSession(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/sessions',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Generate Session Report PDF
     * @param id Session ID
     * @returns string PDF buffer as base64 string
     * @throws ApiError
     */ static generateSessionReport(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/sessions/{id}/report',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("apSGY", function(module, exports) {

$parcel$export(module.exports, "SessionActivityService", () => $e0aa21e96bbc2837$export$b9e206204217d5cc);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $e0aa21e96bbc2837$export$b9e206204217d5cc {
    /**
     * Get SessionActivity
     * @param id
     * @param relations
     * @returns TGetSessionActivityResponse TGetSessionActivityResponse
     * @throws ApiError
     */ static getSessionActivity(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-activities/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update SessionActivity
     * @param id
     * @param requestBody
     * @returns TUpdateSessionActivityResponse TUpdateSessionActivityResponse
     * @throws ApiError
     */ static updateSessionActivity(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/session-activities/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete SessionActivity
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteSessionActivity(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/session-activities/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List SessionActivity s
     * @param sessionId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListSessionActivitiesResponse TListSessionActivitiesResponse
     * @throws ApiError
     */ static listSessionActivities(sessionId, limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-activities',
            query: {
                'sessionId': sessionId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create SessionActivity
     * @param requestBody
     * @returns TCreateSessionActivityResponse TCreateSessionActivityResponse
     * @throws ApiError
     */ static createSessionActivity(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/session-activities',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("ieh93", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateService", () => $65a9fcff7ed4d49d$export$71de75f4a37ec2b5);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $65a9fcff7ed4d49d$export$71de75f4a37ec2b5 {
    /**
     * Get Session Estimate
     * @param id
     * @param relations
     * @returns TGetSessionEstimateResponse TGetSessionEstimateResponse
     * @throws ApiError
     */ static getSessionEstimate(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-estimates/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Session Estimate
     * @param id
     * @param requestBody
     * @returns TUpdateSessionEstimateResponse TUpdateSessionEstimateResponse
     * @throws ApiError
     */ static updateSessionEstimate(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/session-estimates/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Session Estimate
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteSessionEstimate(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/session-estimates/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get Session Estimate by Session ID
     * @param sessionId
     * @param relations
     * @returns TGetSessionEstimateResponse TGetSessionEstimateBySessionIdResponse
     * @throws ApiError
     */ static getBySessionId(sessionId, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-estimates/sessions/{session_id}',
            path: {
                'session_id': sessionId
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * List Session Estimates
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListSessionEstimatesResponse TListSessionEstimatesResponse
     * @throws ApiError
     */ static listSessionEstimates(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-estimates',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Session Estimate
     * @param requestBody
     * @returns TCreateSessionEstimateResponse TCreateSessionEstimateResponse
     * @throws ApiError
     */ static createSessionEstimate(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/session-estimates',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Quick Session Estimate
     * @param requestBody
     * @returns TQuickSessionEstimateResponse TQuickSessionEstimateResponse
     * @throws ApiError
     */ static quickSessionEstimate(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/session-estimates/quick',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Refresh Session Estimate
     * @param id
     * @returns TRefreshSessionEstimateResponse TRefreshSessionEstimateResponse
     * @throws ApiError
     */ static refreshSessionEstimate(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/session-estimates/{id}/refresh',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("lEuQR", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateItemService", () => $91c2020270f837e3$export$35b8f29a5b3e4990);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $91c2020270f837e3$export$35b8f29a5b3e4990 {
    /**
     * Get Session Estimate Item
     * @param id
     * @param relations
     * @returns TGetSessionEstimateItemResponse TGetSessionEstimateItemResponse
     * @throws ApiError
     */ static getSessionEstimateItem(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-estimate-items/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Session Estimate Item
     * @param id
     * @param requestBody
     * @returns TUpdateSessionEstimateItemResponse TUpdateSessionEstimateItemResponse
     * @throws ApiError
     */ static updateSessionEstimateItem(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/session-estimate-items/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Session Estimate Item
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteSessionEstimateItem(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/session-estimate-items/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Session Estimate Items
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListSessionEstimateItemsResponse TListSessionEstimateItemsResponse
     * @throws ApiError
     */ static listSessionEstimateItems(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/session-estimate-items',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Session Estimate Item
     * @param requestBody
     * @returns TCreateSessionEstimateItemResponse TCreateSessionEstimateItemResponse
     * @throws ApiError
     */ static createSessionEstimateItem(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/session-estimate-items',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("9JOk8", function(module, exports) {

$parcel$export(module.exports, "StripeService", () => $005345ad2ee03ae9$export$b2a8e2961a29e8bc);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $005345ad2ee03ae9$export$b2a8e2961a29e8bc {
    /**
     * Create a Stripe Checkout Session for the current user's active group.
     * Returns the hosted Checkout URL to redirect the user to.
     * @param requestBody
     * @returns TCreateCheckoutSessionResponse Ok
     * @throws ApiError
     */ static createCheckoutSession(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/stripe/checkout-session',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("9Bndg", function(module, exports) {

$parcel$export(module.exports, "StripeConnectService", () => $7e322c21fca74751$export$2ad8cb2a35facaa5);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $7e322c21fca74751$export$2ad8cb2a35facaa5 {
    /**
     * Create a Stripe Connect Express account for the authenticated TM
     * @returns TStripeConnectAccountResponse Ok
     * @throws ApiError
     */ static createConnectAccount() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/stripe-connect/account'
        });
    }
    /**
     * Get an onboarding link for the authenticated TM's Connect account
     * @param requestBody
     * @returns TStripeConnectOnboardingResponse Ok
     * @throws ApiError
     */ static getOnboardingLink(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/stripe-connect/onboarding-link',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Get Connect account status for the authenticated TM
     * @returns TStripeConnectStatusResponse Ok
     * @throws ApiError
     */ static getConnectStatus() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/stripe-connect/status'
        });
    }
}

});

parcelRegister("bepzN", function(module, exports) {

$parcel$export(module.exports, "SubscriptionPlanService", () => $37447bf2e7d3b9ab$export$cf20148cfe369050);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $37447bf2e7d3b9ab$export$cf20148cfe369050 {
    /**
     * Get Subscription Plan
     * @param id
     * @param relations
     * @returns TGetSubscriptionPlanResponse TGetSubscriptionPlanResponse
     * @throws ApiError
     */ static getSubscriptionPlan(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/subscription-plans/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Subscription Plan
     * @param id
     * @param requestBody
     * @returns TUpdateSubscriptionPlanResponse TUpdateSubscriptionPlanResponse
     * @throws ApiError
     */ static updateSubscriptionPlan(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/subscription-plans/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Subscription Plan
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteSubscriptionPlan(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/subscription-plans/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Subscription Plans
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListSubscriptionPlansResponse TListSubscriptionPlansResponse
     * @throws ApiError
     */ static listSubscriptionPlans(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/subscription-plans',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Subscription Plan
     * @param requestBody
     * @returns TCreateSubscriptionPlanResponse TCreateSubscriptionPlanResponse
     * @throws ApiError
     */ static createSubscriptionPlan(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/subscription-plans',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("4iQ82", function(module, exports) {
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $a7e4472af7e76db2$export$1a97080462d35105 {
    /**
     * Get Tags
     * @param id
     * @param relations
     * @returns TGetTagsResponse TGetTagsResponse
     * @throws ApiError
     */ static getTags(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/tags/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Tags
     * @param id
     * @param requestBody
     * @returns TUpdateTagsResponse TUpdateTagsResponse
     * @throws ApiError
     */ static updateTags(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/tags/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Tags
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteTags(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/tags/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Tags
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListTagsResponse TListTagsResponse
     * @throws ApiError
     */ static listTags(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/tags',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Tags
     * @param requestBody
     * @returns TCreateTagsResponse TCreateTagsResponse
     * @throws ApiError
     */ static createTags(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/tags',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("6g3QY", function(module, exports) {

$parcel$export(module.exports, "TalentManagerService", () => $ccc1f0dab38ce432$export$78d3507ba171628b);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $ccc1f0dab38ce432$export$78d3507ba171628b {
    /**
     * List approved Talent Manager profiles
     * @returns TListTalentManagerProfilesResponse Ok
     * @throws ApiError
     */ static listTalentManagers() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers'
        });
    }
    /**
     * Get the authenticated user's own Talent Manager profile
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static getMyTalentManager() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers/my'
        });
    }
    /**
     * Upload or replace the authenticated Talent Manager's profile photo
     * @param formData
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static uploadMyProfilePhoto(formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/my/photo',
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Delete the authenticated Talent Manager's profile photo
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static deleteMyProfilePhoto() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/talent-managers/my/photo'
        });
    }
    /**
     * Parse an uploaded resume and generate a suggested bio (does not require an existing profile)
     * @param formData
     * @returns TParseResumeResponse Ok
     * @throws ApiError
     */ static parseResume(formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/parse-resume',
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Upload or replace the authenticated Talent Manager's resume
     * @param formData
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static uploadMyResume(formData) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/my/resume',
            formData: formData,
            mediaType: 'multipart/form-data'
        });
    }
    /**
     * Delete the authenticated Talent Manager's resume
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static deleteMyResume() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/talent-managers/my/resume'
        });
    }
    /**
     * Get a fresh signed URL for a Talent Manager's resume
     * @param id
     * @returns any Ok
     * @throws ApiError
     */ static getTalentManagerResumeUrl(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers/{id}/resume-url',
            path: {
                'id': id
            }
        });
    }
    /**
     * List all Talent Manager profiles regardless of status (admin only)
     * @returns TListTalentManagerProfilesResponse Ok
     * @throws ApiError
     */ static listAllTalentManagers() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers/admin/all'
        });
    }
    /**
     * Get a single Talent Manager profile by ID
     * @param id
     * @param projectId
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static getTalentManager(id, projectId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers/{id}',
            path: {
                'id': id
            },
            query: {
                'project_id': projectId
            }
        });
    }
    /**
     * Update own Talent Manager profile
     * @param id
     * @param requestBody
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static updateTalentManager(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/talent-managers/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Get a fresh signed URL for a Talent Manager's profile photo
     * @param id
     * @returns any Ok
     * @throws ApiError
     */ static getTalentManagerPhotoUrl(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers/{id}/photo-url',
            path: {
                'id': id
            }
        });
    }
    /**
     * Register current user as a Talent Manager
     * @param requestBody
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static registerTalentManager(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/register',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Approve a Talent Manager (admin only)
     * @param id
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static approveTalentManager(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/{id}/approve',
            path: {
                'id': id
            }
        });
    }
    /**
     * Suspend a Talent Manager (admin only)
     * @param id
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */ static suspendTalentManager(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/{id}/suspend',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get reviews for a Talent Manager
     * @param id
     * @returns TListTalentManagerReviewsResponse Ok
     * @throws ApiError
     */ static getTalentManagerReviews(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-managers/{id}/reviews',
            path: {
                'id': id
            }
        });
    }
    /**
     * Submit a review for a Talent Manager
     * @param id
     * @param requestBody
     * @returns TListTalentManagerReviewsResponse Ok
     * @throws ApiError
     */ static createTalentManagerReview(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-managers/{id}/reviews',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("03jfi", function(module, exports) {

$parcel$export(module.exports, "TalentManagerEngagementService", () => $06419d4af375a6e9$export$8eea6f9277e5c527);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $06419d4af375a6e9$export$8eea6f9277e5c527 {
    /**
     * Create a new engagement between a group and a talent manager
     * @param requestBody
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */ static createEngagement(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-manager-engagements',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * List engagements for the authenticated TM
     * @returns TListTalentManagerEngagementsResponse Ok
     * @throws ApiError
     */ static listMyEngagements() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-manager-engagements/my'
        });
    }
    /**
     * List engagements for the authenticated user's group
     * @returns TListTalentManagerEngagementsResponse Ok
     * @throws ApiError
     */ static listGroupEngagements() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-manager-engagements/group'
        });
    }
    /**
     * Get a single engagement by ID
     * @param id
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */ static getEngagement(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-manager-engagements/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Update an engagement — currently used to grant/revoke the TM's `can_edit_project` permission.
     * Agency User (group member) or admin only.
     * @param id
     * @param requestBody
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */ static updateEngagement(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/talent-manager-engagements/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Get credit balance for an engagement
     * @param id
     * @returns TEngagementCreditBalanceResponse Ok
     * @throws ApiError
     */ static getCreditBalance(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-manager-engagements/{id}/balance',
            path: {
                'id': id
            }
        });
    }
    /**
     * Complete an engagement
     * @param id
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */ static completeEngagement(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-manager-engagements/{id}/complete',
            path: {
                'id': id
            }
        });
    }
    /**
     * Cancel an engagement
     * @param id
     * @returns TGetTalentManagerEngagementResponse Ok
     * @throws ApiError
     */ static cancelEngagement(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-manager-engagements/{id}/cancel',
            path: {
                'id': id
            }
        });
    }
}

});

parcelRegister("iC8zV", function(module, exports) {

$parcel$export(module.exports, "TalentManagerTimeService", () => $2b5675a56f234ccf$export$e546e43d4c8ed4ba);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $2b5675a56f234ccf$export$e546e43d4c8ed4ba {
    /**
     * List time entries for an engagement
     * @param engagementId
     * @returns TListTimeEntriesResponse Ok
     * @throws ApiError
     */ static listTimeEntries(engagementId) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/talent-manager-time',
            query: {
                'engagementId': engagementId
            }
        });
    }
    /**
     * Log manual time for an engagement
     * @param requestBody
     * @returns TGetTimeEntryResponse Ok
     * @throws ApiError
     */ static logManualTime(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-manager-time/manual',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Update a time entry
     * @param id
     * @param requestBody
     * @returns TGetTimeEntryResponse Ok
     * @throws ApiError
     */ static updateTimeEntry(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/talent-manager-time/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Approve or unapprove a pending time entry for billing
     * @param id
     * @param requestBody
     * @returns TGetTimeEntryResponse Ok
     * @throws ApiError
     */ static approveTimeEntry(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/talent-manager-time/{id}/approve',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("f7GXT", function(module, exports) {

$parcel$export(module.exports, "UsageService", () => $fa186d19183033bc$export$7e57aeee865169ef);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $fa186d19183033bc$export$7e57aeee865169ef {
    /**
     * Get Usage Type Data
     * @returns Record_UsageType_UsageTypeInfo_ usageTypeData
     * @throws ApiError
     */ static getUsageTypeData() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usages/type-data'
        });
    }
    /**
     * Get Usage
     * @param id
     * @param relations
     * @returns TGetUsageResponse TGetUsageResponse
     * @throws ApiError
     */ static getUsage(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usages/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update Usage
     * @param id
     * @param requestBody
     * @returns TUpdateUsageResponse TUpdateUsageResponse
     * @throws ApiError
     */ static updateUsage(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/usages/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete Usage
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteUsage(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/usages/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Usages
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListUsagesResponse TListUsagesResponse
     * @throws ApiError
     */ static listUsages(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usages',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create Usage
     * @param requestBody
     * @returns TCreateUsageResponse TCreateUsageResponse
     * @throws ApiError
     */ static createUsage(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/usages',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("aFNng", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateService", () => $387c95ceb33db14c$export$3c643aaf1f645b8c);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $387c95ceb33db14c$export$3c643aaf1f645b8c {
    /**
     * Get UsageEstimate
     * @param id
     * @param relations
     * @returns TGetUsageEstimateResponse TGetUsageEstimateResponse
     * @throws ApiError
     */ static getUsageEstimate(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usage-estimates/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update UsageEstimate
     * @param id
     * @param requestBody
     * @returns TUpdateUsageEstimateResponse TUpdateUsageEstimateResponse
     * @throws ApiError
     */ static updateUsageEstimate(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/usage-estimates/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete UsageEstimate
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteUsageEstimate(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/usage-estimates/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List UsageEstimates
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListUsageEstimatesResponse TListUsageEstimatesResponse
     * @throws ApiError
     */ static listUsageEstimates(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usage-estimates',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create UsageEstimate
     * @param requestBody
     * @returns TCreateUsageEstimateResponse TCreateUsageEstimateResponse
     * @throws ApiError
     */ static createUsageEstimate(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/usage-estimates',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("5yg4I", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateItemService", () => $3005d10ba749a051$export$a31065a4d1565a5b);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $3005d10ba749a051$export$a31065a4d1565a5b {
    /**
     * Get UsageEstimateItem
     * @param id
     * @param relations
     * @returns TGetUsageEstimateItemResponse TGetUsageEstimateItemResponse
     * @throws ApiError
     */ static getUsageEstimateItem(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usage-estimate-items/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update UsageEstimateItem
     * @param id
     * @param requestBody
     * @returns TUpdateUsageEstimateItemResponse TUpdateUsageEstimateItemResponse
     * @throws ApiError
     */ static updateUsageEstimateItem(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/usage-estimate-items/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete UsageEstimateItem
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteUsageEstimateItem(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/usage-estimate-items/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * List UsageEstimateItems
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListUsageEstimateItemsResponse TListUsageEstimateItemsResponse
     * @throws ApiError
     */ static listUsageEstimateItems(limit, page, orderAsJsonString, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/usage-estimate-items',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations
            }
        });
    }
    /**
     * Create UsageEstimateItem
     * @param requestBody
     * @returns TCreateUsageEstimateItemResponse TCreateUsageEstimateItemResponse
     * @throws ApiError
     */ static createUsageEstimateItem(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/usage-estimate-items',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
}

});

parcelRegister("ai2Ek", function(module, exports) {

$parcel$export(module.exports, "UserService", () => $27391c59ce44925f$export$a81c579a392aa9d2);
/* generated using openapi-typescript-codegen -- do not edit */ /* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $ahNn6 = parcelRequire("ahNn6");
class $27391c59ce44925f$export$a81c579a392aa9d2 {
    /**
     * Get Current User
     * @param relations
     * @returns TGetUserResponse Ok
     * @throws ApiError
     */ static currentUser(relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/current',
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Get User
     * @param id
     * @param relations
     * @returns TGetUserResponse TGetUserResponse
     * @throws ApiError
     */ static getUser(id, relations) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/{id}',
            path: {
                'id': id
            },
            query: {
                'relations': relations
            }
        });
    }
    /**
     * Update User
     * @param id
     * @param requestBody
     * @returns TUpdateUserResponse TUpdateUserResponse
     * @throws ApiError
     */ static updateUser(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/users/{id}',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Delete User
     * @param id
     * @returns void
     * @throws ApiError
     */ static deleteUser(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/users/{id}',
            path: {
                'id': id
            }
        });
    }
    /**
     * Get User OAuth Profile
     * @param userId
     * @param provider
     * @returns TGetOAuthProfileResponse TGetOAuthProfileResponse
     * @throws ApiError
     */ static getUserOAuthProfile(userId, provider) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/{userId}/oauth-profile/{provider}',
            path: {
                'userId': userId,
                'provider': provider
            }
        });
    }
    /**
     * Disconnect An OAuth Account
     * @param userId
     * @param provider
     * @returns void
     * @throws ApiError
     */ static disconnectOAuthProfile(userId, provider) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'DELETE',
            url: '/users/{userId}/oauth-profile/{provider}',
            path: {
                'userId': userId,
                'provider': provider
            }
        });
    }
    /**
     * Get OAuth Access Token (with automatic refresh if expired)
     * @param userId
     * @param provider
     * @returns TGetOAuthAccessTokenResponse TGetOAuthAccessTokenResponse
     * @throws ApiError
     */ static getOAuthAccessToken(userId, provider) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/{userId}/oauth-token/{provider}',
            path: {
                'userId': userId,
                'provider': provider
            }
        });
    }
    /**
     * List Allowed Features
     * @param id
     * @returns TListUserAllowedFeaturesResponse TGetUserResponse
     * @throws ApiError
     */ static getAllowedFeatures(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/{id}/features',
            path: {
                'id': id
            }
        });
    }
    /**
     * List Users
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @param search
     * @returns TListUsersResponse TListUsersResponse
     * @throws ApiError
     */ static listUsers(limit, page, orderAsJsonString, relations, search) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users',
            query: {
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
                'search': search
            }
        });
    }
    /**
     * Create User
     * @param requestBody
     * @returns TCreateUserResponse TCreateUserResponse
     * @throws ApiError
     */ static createUser(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Impersonate a user — mints a session for `id` that the caller (an admin) can switch to.
     * @param id The user to impersonate
     * @returns TImpersonateUserResponse TImpersonateUserResponse
     * @throws ApiError
     */ static impersonateUser(id) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users/{id}/impersonate',
            path: {
                'id': id
            }
        });
    }
    /**
     * Create a Group and a User
     * @param requestBody
     * @returns TSignUpResponse TSignUpResponse
     * @throws ApiError
     */ static signUp(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users/signup',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Update User
     * @param id
     * @param requestBody
     * @returns TChangeUserActiveGroupResponse TUpdateUserResponse
     * @throws ApiError
     */ static changeActiveGroup(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/users/{id}/active-group',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Change Password
     * @param id TUserId
     * @param requestBody TChangeUserPasswordRequest
     * @returns void
     * @throws ApiError
     */ static changePassword(id, requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'PUT',
            url: '/users/{id}/password',
            path: {
                'id': id
            },
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Confirm Email
     * @param requestBody
     * @returns TAccessToken Ok
     * @throws ApiError
     */ static confirmEmail(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users/confirm-email',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Resend Confirmation Email
     * @returns void
     * @throws ApiError
     */ static resendConfirmationEmail() {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users/resend-confirmation-email'
        });
    }
    /**
     * Forgot Password
     * @param requestBody
     * @returns void
     * @throws ApiError
     */ static forgotPassword(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users/forgot-password',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Reset Password
     * @param requestBody
     * @returns TAccessToken Ok
     * @throws ApiError
     */ static resetPassword(requestBody) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'POST',
            url: '/users/reset-password',
            body: requestBody,
            mediaType: 'application/json'
        });
    }
    /**
     * Validate Password Reset Token
     * @param token
     * @returns TValidatePasswordResetTokenResponse Ok
     * @throws ApiError
     */ static validatePasswordResetToken(token) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/validate-password-reset/{token}',
            path: {
                'token': token
            }
        });
    }
    /**
     * Get Email Availability
     * @param params
     * @returns boolean Ok
     * @throws ApiError
     */ static isEmailAvailable(params) {
        return (0, $ahNn6.request)((0, $cS8Vf.OpenAPI), {
            method: 'GET',
            url: '/users/email/availability/{params}',
            path: {
                'params': params
            }
        });
    }
}

});


parcelRegister("hK1qT", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "getDependencyTree", () => getDependencyTree);
$parcel$export(module.exports, "Reaction", () => Reaction);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
$parcel$export(module.exports, "makeObservable", () => makeObservable);
$parcel$export(module.exports, "runInAction", () => runInAction);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    var computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        var options = _extends({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        return new ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        var adm = asObservableObject(this)[$mobx];
        var target = this;
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) adm.values_["delete"](key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, function() {
            return createComputedValue(target, adm);
        });
    });
    return function() {
        var adm = this[$mobx];
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) {
            var _computedValues;
            var computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        var adm = asObservableObject(target)[$mobx];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, function() {
            var _ann$options_$enhance, _ann$options_;
            return new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        });
        return adm;
    }
    return {
        get: function get() {
            var _this$$mobx;
            var adm = (_this$$mobx = this[$mobx]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set: function set(value) {
            var _this$$mobx2;
            var adm = (_this$$mobx2 = this[$mobx]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init: function init(value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    var adm = value[$mobx];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            var adm = value[$mobx];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.getOrInsert = function getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    };
    _proto.getOrInsertComputed = function getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        var observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    };
    _proto.materializeLazyComputed_ = function materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        var factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_["delete"](key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        var computed = factory();
        this.values_.set(key, computed);
        return computed;
    };
    _proto.materializeLazyObservable_ = function materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        var factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_["delete"](key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        var observable = factory();
        this.values_.set(key, observable);
        return observable;
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        var observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return die(26);
            var adm = thing[$mobx];
            var _observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _global$Iterator;
// safely get iterator prototype if available
var global$1 = /*#__PURE__*/ getGlobal();
var maybeIteratorPrototype = ((_global$Iterator = global$1.Iterator) == null ? void 0 : _global$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("3kkid", function(module, exports) {

$parcel$export(module.exports, "BaseStore", () => $64d22275dcf0eaf0$export$f6772e87ca157ef);
/* eslint-disable @typescript-eslint/no-explicit-any */ class $64d22275dcf0eaf0$export$f6772e87ca157ef {
    rootStore;
    q;
    handleError;
    constructor(rootStore){
        this.rootStore = rootStore;
        this.q = this.rootStore.addRequest;
        this.handleError = this.rootStore.handleError;
    }
}

});


parcelRegister("iRK83", function(module, exports) {

$parcel$export(module.exports, "AdminStore", () => $3ae56d050f429c7a$export$5377ac623cbacd19);
parcelRequire("hcQWc");
var $leCVP = parcelRequire("leCVP");
var $8zK2X = parcelRequire("8zK2X");
var $bUwq7 = parcelRequire("bUwq7");
var $aBFJh = parcelRequire("aBFJh");
var $lhiX6 = parcelRequire("lhiX6");
var $bepzN = parcelRequire("bepzN");
var $ai2Ek = parcelRequire("ai2Ek");

var $hK1qT = parcelRequire("hK1qT");

var $aIAdV = parcelRequire("aIAdV");
parcelRequire("1Jz7s");
var $5wL0X = parcelRequire("5wL0X");

var $3kkid = parcelRequire("3kkid");
class $3ae56d050f429c7a$export$5377ac623cbacd19 extends (0, $3kkid.BaseStore) {
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {});
    }
    // SUBSCRIPTION PLANS
    fetchSubscriptionPlans = async ()=>{
        try {
            const { subscriptionPlans: subscriptionPlans } = await this.q((0, $bepzN.SubscriptionPlanService).listSubscriptionPlans(undefined, undefined, undefined, 'groups,pricing_tier,features'));
            return subscriptionPlans;
        } catch (e) {
            this.handleError(e);
        }
    };
    createSubscriptionPlan = async ({ name: name = 'New Subscription Plan', pricing_tier: pricing_tier, groups: groups, stripe_id: stripe_id, features: features })=>{
        if (!name || !pricing_tier) throw new Error('Name and price are required');
        try {
            const { subscriptionPlan: subscriptionPlan } = await this.q((0, $bepzN.SubscriptionPlanService).createSubscriptionPlan({
                name: name,
                pricing_tier_id: pricing_tier.id,
                group_ids: groups?.map((g)=>g.id),
                stripe_id: stripe_id,
                feature_ids: features?.map((f)=>f.id)
            }));
            return subscriptionPlan;
        } catch (e) {
            this.handleError(e);
        }
    };
    getSubscriptionPlan = async (id)=>{
        try {
            const { subscriptionPlan: subscriptionPlan } = await this.q((0, $bepzN.SubscriptionPlanService).getSubscriptionPlan(id, 'groups,pricing_tier,features'));
            return subscriptionPlan;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateSubscriptionPlan = async (request)=>{
        if (!request.name || !request.pricing_tier) throw new Error('Name and price are required');
        try {
            const { subscriptionPlan: subscriptionPlan } = await this.q((0, $bepzN.SubscriptionPlanService).updateSubscriptionPlan(request.id, {
                name: request.name,
                pricing_tier_id: request.pricing_tier.id,
                group_ids: request.groups?.map((g)=>g.id),
                feature_ids: request.features?.map((f)=>f.id),
                stripe_id: request.stripe_id,
                is_public: request.is_public
            }));
            if (!subscriptionPlan) throw new Error('Failed to update Subscription Plan');
            const updatedPlan = await this.getSubscriptionPlan(subscriptionPlan.id);
            return updatedPlan;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteSubscriptionPlan = async (id)=>{
        try {
            await this.q((0, $bepzN.SubscriptionPlanService).deleteSubscriptionPlan(id));
        } catch (e) {
            this.handleError(e);
        }
    };
    // PRICING TIERS
    fetchPricingTiers = async ()=>{
        try {
            const { pricingTiers: pricingTiers } = await this.q((0, $lhiX6.PricingTierService).listPricingTiers(undefined, undefined, undefined, 'subscription_plans'));
            return pricingTiers;
        } catch (e) {
            this.handleError(e);
        }
    };
    createPricingTier = async ({ name: name = 'New Pricing Tier', price: price = 0, stripe_id: stripe_id })=>{
        if (isNaN(price)) throw new Error('Price is required');
        try {
            const { pricingTier: pricingTier } = await this.q((0, $lhiX6.PricingTierService).createPricingTier({
                name: name,
                price: price,
                stripe_id: stripe_id
            }));
            return pricingTier;
        } catch (e) {
            this.handleError(e);
        }
    };
    getPricingTier = async (id)=>{
        try {
            const { pricingTier: pricingTier } = await this.q((0, $lhiX6.PricingTierService).getPricingTier(id, 'subscription_plans'));
            return pricingTier;
        } catch (e) {
            this.handleError(e);
        }
    };
    updatePricingTier = async ({ id: id, name: name, price: price, subscription_plans: subscription_plans, stripe_id: stripe_id })=>{
        if (!id || !name || price && isNaN(price)) throw new Error('Name and price are required');
        const request = {
            name: name,
            price: price,
            subscription_plan_ids: subscription_plans?.map((p)=>p.id),
            stripe_id: stripe_id
        };
        try {
            await this.q((0, $lhiX6.PricingTierService).updatePricingTier(id, request));
            const { pricingTier: pricingTier } = await this.q((0, $lhiX6.PricingTierService).getPricingTier(id, 'subscription_plans'));
            return pricingTier;
        } catch (e) {
            this.handleError(e);
        }
    };
    deletePricingTier = async (id)=>{
        try {
            await this.q((0, $lhiX6.PricingTierService).deletePricingTier(id));
        } catch (e) {
            this.handleError(e);
        }
    };
    // CREDIT PACKAGES
    fetchCreditPackages = async ()=>{
        try {
            const { creditPackages: creditPackages } = await this.q((0, $8zK2X.CreditsService).listAllCreditPackages());
            return creditPackages;
        } catch (e) {
            this.handleError(e);
        }
    };
    createCreditPackage = async ({ name: name = 'New Credit Pack', hours: hours = 0, is_active: is_active = true })=>{
        if (!name || !hours) throw new Error('Name and hours are required');
        try {
            const { creditPackage: creditPackage } = await this.q((0, $8zK2X.CreditsService).createCreditPackage({
                name: name,
                hours: hours,
                is_active: is_active
            }));
            return creditPackage;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateCreditPackage = async ({ id: id, name: name, hours: hours, is_active: is_active })=>{
        if (!id) throw new Error('Id is required');
        try {
            const { creditPackage: creditPackage } = await this.q((0, $8zK2X.CreditsService).updateCreditPackage(id, {
                name: name,
                hours: hours,
                is_active: is_active
            }));
            return creditPackage;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteCreditPackage = async (id)=>{
        try {
            await this.q((0, $8zK2X.CreditsService).deleteCreditPackage(id));
        } catch (e) {
            this.handleError(e);
        }
    };
    // FEATURES
    fetchFeatures = async ()=>{
        try {
            const { features: features } = await this.q((0, $bUwq7.FeatureService).listFeatures());
            return features;
        } catch (e) {
            this.handleError(e);
        }
    };
    createFeature = async ({ name: name = 'New Feature' })=>{
        try {
            const { feature: feature } = await this.q((0, $bUwq7.FeatureService).createFeature({
                name: name
            }));
            return feature;
        } catch (e) {
            this.handleError(e);
        }
    };
    getFeature = async (id)=>{
        try {
            const { feature: feature } = await this.q((0, $bUwq7.FeatureService).getFeature(id));
            return feature;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateFeature = async ({ id: id, name: name })=>{
        if (!id || !name) throw new Error('Feature name is required');
        try {
            const { feature: feature } = await this.q((0, $bUwq7.FeatureService).updateFeature(id, {
                name: name
            }));
            return feature;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteFeature = async (id)=>{
        try {
            await this.q((0, $bUwq7.FeatureService).deleteFeature(id));
        } catch (e) {
            this.handleError(e);
        }
    };
    // USERS
    createUser = async ({ email: email, first_name: first_name, last_name: last_name, is_admin: is_admin, is_registered: is_registered, groups: groups })=>{
        if (!email || !first_name || !last_name) throw new Error('Email, first name, and last name are required');
        try {
            const { user: newUser } = await this.q((0, $ai2Ek.UserService).createUser({
                email: email,
                first_name: first_name,
                last_name: last_name,
                send_verification_email: false,
                is_admin: is_admin,
                is_registered: is_registered,
                group_ids: groups?.map((g)=>g.id),
                active_group_id: groups?.[0]?.id
            }));
            return newUser;
        } catch (e) {
            this.handleError(e);
        }
    };
    /** Sets another user's password (an admin doesn't need to know their current one) */ setUserPassword = async (id, newPassword)=>{
        try {
            await this.q((0, $ai2Ek.UserService).changePassword(id, {
                new_password: newPassword
            }));
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        }
    };
    fetchUsers = async ({ page: page = 1, limit: limit, search: search } = {})=>{
        try {
            const { users: users, total: total } = await this.q((0, $ai2Ek.UserService).listUsers(limit, page, undefined, 'groups', search));
            return {
                items: users,
                total: total
            };
        } catch (e) {
            this.handleError(e);
        }
    };
    // Unbounded fetch for use in option pickers (e.g. group owner/members selects), not the paginated admin list
    fetchAllUsers = async ()=>{
        try {
            const { users: users } = await this.q((0, $ai2Ek.UserService).listUsers(undefined, undefined, undefined, 'groups'));
            return users;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateUser = async (user)=>{
        if (!user.id) throw new Error('User ID is required');
        try {
            const { user: updatedUser } = await this.q((0, $ai2Ek.UserService).updateUser(user.id, {
                ...user,
                group_ids: user.groups?.map((g)=>g.id)
            }));
            return updatedUser;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteUser = async (id)=>{
        try {
            await this.q((0, $ai2Ek.UserService).deleteUser(id));
        } catch (e) {
            this.handleError(e);
        }
    };
    // IMPERSONATION
    /**
   * Mints a session for `id` and switches the app to it. Stashes the admin's own current token
   * first so exitImpersonation() can restore it — only on success, so a failed call leaves the
   * admin's own session untouched.
   */ impersonateUser = async (id)=>{
        try {
            const currentToken = this.rootStore.userStore.token;
            const { jwt: jwt, user: user } = await this.q((0, $ai2Ek.UserService).impersonateUser(id));
            (0, $aIAdV.default).set((0, $5wL0X.StorageProperties).ImpersonatorJwt, currentToken);
            this.rootStore.userStore.applySession(jwt, user);
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        }
    };
    // AUDIT LOG
    fetchAuditLog = async ({ page: page = 1, limit: limit, entityName: entityName, actorUserId: actorUserId, action: action, fromDate: fromDate, toDate: toDate } = {})=>{
        try {
            const { entries: entries, total: total } = await this.q((0, $leCVP.AuditService).listAuditLog(entityName, actorUserId, action, fromDate, toDate, limit, page));
            return {
                items: entries,
                total: total
            };
        } catch (e) {
            this.handleError(e);
        }
    };
    // GROUPS
    fetchGroups = async ({ page: page = 1, limit: limit } = {})=>{
        try {
            const { groups: groups, total: total } = await this.q((0, $aBFJh.GroupService).listGroups(limit, page, undefined, 'subscription_plan,owner,users'));
            return {
                items: groups,
                total: total
            };
        } catch (e) {
            this.handleError(e);
        }
    };
    createGroup = async ({ name: name, stripe_id: stripe_id, invited_emails: invited_emails, subscription_plan: subscription_plan, users: users, projects: projects, is_jpc_authorizer: is_jpc_authorizer, type: type })=>{
        if (!name || !subscription_plan) throw new Error('Name and subscription plan are required');
        const request = {
            name: name,
            subscription_plan_id: subscription_plan.id,
            user_ids: users?.map((u)=>u.id),
            project_ids: projects?.map((p)=>p.id),
            stripe_id: stripe_id,
            invited_emails: invited_emails,
            is_jpc_authorizer: is_jpc_authorizer,
            type: type
        };
        try {
            const { group: newGroup } = await this.q((0, $aBFJh.GroupService).createGroup(request));
            return newGroup;
        } catch (e) {
            this.handleError(e);
        }
    };
    getGroup = async (id, relations)=>{
        try {
            const { group: group } = await this.q((0, $aBFJh.GroupService).getGroup(id, relations));
            return group;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateGroup = async (group)=>{
        try {
            await this.q((0, $aBFJh.GroupService).updateGroup(group.id, {
                ...group,
                subscription_plan_id: group.subscription_plan.id,
                owner_id: group.owner?.id,
                user_ids: group.users?.map((u)=>u.id)
            }));
            const updatedGroup = await this.getGroup(group.id, 'subscription_plan,owner,users');
            return updatedGroup;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteGroup = async (id)=>{
        try {
            await this.q((0, $aBFJh.GroupService).deleteGroup(id));
        } catch (e) {
            this.handleError(e);
        }
    };
}

});
parcelRegister("aIAdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5985d21f9a0f4b60$export$2e2bcd8739ae039);
parcelRequire("1Jz7s");
var $5wL0X = parcelRequire("5wL0X");
class $5985d21f9a0f4b60$var$Storage {
    get(key, defaultValue = '') {
        if (typeof window !== 'undefined') {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
            return defaultValue;
        }
        return false;
    }
    set(key, value) {
        if (typeof window !== 'undefined') {
            const valueToStr = JSON.stringify(value || '');
            localStorage.setItem(key, valueToStr);
        }
    }
    remove(key) {
        if (typeof window !== 'undefined') localStorage.removeItem(key);
    }
    removeAll() {
        if (typeof window !== 'undefined') localStorage.clear();
    }
    /* set token */ setToken(value) {
        this.set((0, $5wL0X.StorageProperties).SessionJwt, value);
    }
    /* get token */ getToken() {
        return this.get((0, $5wL0X.StorageProperties).SessionJwt);
    }
    /* set theme */ setTheme(value) {
        this.set((0, $5wL0X.StorageProperties).Theme, value);
    }
    /* get theme */ getTheme() {
        return this.get((0, $5wL0X.StorageProperties).Theme, 'light');
    }
    /* remove sign in info */ removeLogInInfo() {
        this.remove((0, $5wL0X.StorageProperties).SessionJwt);
        this.remove((0, $5wL0X.StorageProperties).SessionUser);
    }
}
const $5985d21f9a0f4b60$var$storage = new $5985d21f9a0f4b60$var$Storage();
var $5985d21f9a0f4b60$export$2e2bcd8739ae039 = $5985d21f9a0f4b60$var$storage;

});
parcelRegister("1Jz7s", function(module, exports) {
$parcel$export(module.exports, "DateTimeType", () => (parcelRequire("bQiIR")).DateTimeType);
$parcel$export(module.exports, "StorageProperties", () => (parcelRequire("5wL0X")).StorageProperties);
parcelRequire("bQiIR");
parcelRequire("8JrOF");
parcelRequire("5wL0X");
parcelRequire("hcMcV");

});
parcelRegister("bQiIR", function(module, exports) {

$parcel$export(module.exports, "DateTimeType", () => $56f21409bf179dcc$export$c739b6394262ac12);
var $56f21409bf179dcc$export$c739b6394262ac12 = /*#__PURE__*/ function(DateTimeType) {
    DateTimeType["StartTime"] = "start_time";
    DateTimeType["EndTime"] = "end_time";
    return DateTimeType;
}({});

});

parcelRegister("8JrOF", function(module, exports) {

});

parcelRegister("5wL0X", function(module, exports) {

$parcel$export(module.exports, "StorageProperties", () => $e925aae30a13f7fe$export$8cebf6e16acf2e44);
var $e925aae30a13f7fe$export$8cebf6e16acf2e44 = /*#__PURE__*/ function(StorageProperties) {
    StorageProperties["Session"] = "session";
    StorageProperties["SessionJwt"] = "session_jwt";
    StorageProperties["SessionUser"] = "session_user";
    StorageProperties["Theme"] = "theme";
    StorageProperties["CurrentProjectId"] = "current_project_id";
    StorageProperties["SaveQueue"] = "save_queue";
    /** The admin's own session JWT, stashed here while impersonating another user so "Exit" can
   *  restore it. Presence of this key is also what ImpersonationBanner checks to know whether
   *  the current session is an impersonated one. */ StorageProperties["ImpersonatorJwt"] = "impersonator_jwt";
    return StorageProperties;
}({});

});

parcelRegister("hcMcV", function(module, exports) {

});




parcelRegister("lF2uX", function(module, exports) {

$parcel$export(module.exports, "ChatStore", () => $9ecc02afcaadc2c0$export$4a6daf4c5c8d609);

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $9ecc02afcaadc2c0$export$4a6daf4c5c8d609 extends (0, $3kkid.BaseStore) {
    pendingChannelId = null;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            pendingChannelId: (0, $hK1qT.observable)
        });
    }
    openChannel = (conversationId)=>{
        (0, $hK1qT.runInAction)(()=>{
            this.pendingChannelId = conversationId;
        });
    };
    clearPendingChannel = ()=>{
        (0, $hK1qT.runInAction)(()=>{
            this.pendingChannelId = null;
        });
    };
}

});

parcelRegister("dV3a5", function(module, exports) {

$parcel$export(module.exports, "CommercialStore", () => $0441f4cb1198d0fb$export$d656f8e2c6c57793);
parcelRequire("hcQWc");
var $leMeY = parcelRequire("leMeY");
var $emlIu = parcelRequire("emlIu");
var $2R8LL = parcelRequire("2R8LL");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $0441f4cb1198d0fb$export$d656f8e2c6c57793 extends (0, $3kkid.BaseStore) {
    isSaving = false;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            isSaving: (0, $hK1qT.observable)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    /** Commercials **/ getCommercial = async (commercialId)=>{
        try {
            const { commercial: commercial } = await (0, $leMeY.CommercialService).getCommercial(commercialId, 'sessions,usages,edits,edits.asset,tags,project,usage_estimates,contracts.performer,contracts.role');
            return commercial;
        } catch (e) {
            this.handleError(e);
        }
    };
    listCommercialsByProjectId = async (projectId)=>{
        try {
            const { commercials: commercials } = await (0, $leMeY.CommercialService).listCommercials(projectId, undefined, undefined, undefined, 'edits,edits.asset');
            return commercials;
        } catch (e) {
            this.handleError(e);
        }
    };
    createCommercial = async (newCommercial)=>{
        try {
            this.setIsSaving(true);
            const { commercial: commercial } = await (0, $leMeY.CommercialService).createCommercial(newCommercial);
            return commercial ? await this.getCommercial(commercial.id) : undefined;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateCommercial = async (commercialId, updatedCommercial)=>{
        try {
            this.setIsSaving(true);
            const { commercial: commercial } = await (0, $leMeY.CommercialService).updateCommercial(commercialId, updatedCommercial);
            return commercial ? await this.getCommercial(commercial.id) : undefined;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteCommercial = async (commercialId)=>{
        try {
            this.setIsSaving(true);
            await (0, $leMeY.CommercialService).deleteCommercial(commercialId);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /** Edits **/ getEdit = async (editId)=>{
        try {
            const { edit: edit } = await (0, $2R8LL.EditService).getEdit(editId);
            return edit;
        } catch (e) {
            this.handleError(e);
        }
    };
    createEdit = async (edit)=>{
        try {
            this.setIsSaving(true);
            const { edit: newEdit } = await (0, $2R8LL.EditService).createEdit(edit);
            return newEdit;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateEdit = async (editId, edit)=>{
        try {
            this.setIsSaving(true);
            const { edit: updatedEdit } = await (0, $2R8LL.EditService).updateEdit(editId, edit);
            return updatedEdit;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteEdit = async (editId)=>{
        try {
            this.setIsSaving(true);
            await (0, $2R8LL.EditService).deleteEdit(editId);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /**
   * Edit Reviews
   */ createEditReview = async (editId)=>{
        try {
            const response = await (0, $emlIu.EditReviewService).createEditReview({
                editId: editId
            });
            return response;
        } catch (e) {
            this.handleError(e);
        }
    };
    getEditReviewByEditId = async (editId, relations)=>{
        try {
            const response = await (0, $emlIu.EditReviewService).getEditReviewByEditId(editId, relations);
            return response;
        } catch (e) {
            if (e?.status === 404) return {
                editReview: undefined
            };
            this.handleError(e);
        }
    };
}

});

parcelRegister("77JSJ", function(module, exports) {

$parcel$export(module.exports, "CostumeStore", () => $734251acc0e144aa$export$ff2353271ee11166);

var $3kkid = parcelRequire("3kkid");
parcelRequire("hcQWc");
var $bG9RN = parcelRequire("bG9RN");
class $734251acc0e144aa$export$ff2353271ee11166 extends (0, $3kkid.BaseStore) {
    constructor(rootStore){
        super(rootStore);
    }
    getCostumesByRoleId = async (roleId)=>{
        try {
            const { costumes: costumes } = await (0, $bG9RN.CostumeService).listCostumes(roleId, undefined, undefined, undefined, undefined, 'owner');
            return costumes;
        } catch (e) {
            this.handleError(e);
        }
    };
    getCostumesByScriptId = async (scriptId)=>{
        try {
            const { costumes: costumes } = await (0, $bG9RN.CostumeService).listCostumes(undefined, scriptId, undefined, undefined, undefined, 'owner');
            return costumes;
        } catch (e) {
            this.handleError(e);
        }
    };
    createCostume = async ({ name: name, type: type, scriptIds: scriptIds, projectId: projectId, ownerId: ownerId })=>{
        try {
            const { costume: costume } = await (0, $bG9RN.CostumeService).createCostume({
                name: name,
                type: type,
                scriptIds: scriptIds,
                projectId: projectId,
                ownerId: ownerId
            });
            return costume;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateCostume = async (costume)=>{
        const updateRequest = {
            ...costume,
            ownerId: costume.owner?.id,
            scriptIds: costume.scripts?.map((s)=>s.id),
            sessionActivityIds: costume.session_activities?.map((sa)=>sa.id)
        };
        try {
            const { costume: updatedCostume } = await (0, $bG9RN.CostumeService).updateCostume(costume.id, updateRequest);
            return updatedCostume;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteCostume = async (costumeId)=>{
        try {
            await (0, $bG9RN.CostumeService).deleteCostume(costumeId);
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("kQLpc", function(module, exports) {

$parcel$export(module.exports, "EstimateStore", () => $4544b2fd157c8995$export$64369a03ac5acef5);

var $fjut3 = parcelRequire("fjut3");

var $dErKY = parcelRequire("dErKY");
parcelRequire("hcQWc");
var $NcqgP = parcelRequire("NcqgP");
var $djcqs = parcelRequire("djcqs");
var $lEuQR = parcelRequire("lEuQR");
var $7dV2j = parcelRequire("7dV2j");
var $ieh93 = parcelRequire("ieh93");
var $5yg4I = parcelRequire("5yg4I");
var $aFNng = parcelRequire("aFNng");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");

var $4kZY9 = parcelRequire("4kZY9");
const $4544b2fd157c8995$var$estimateRelations = 'session_estimates,usage_estimates,project';
class $4544b2fd157c8995$export$64369a03ac5acef5 extends (0, $3kkid.BaseStore) {
    currentEstimate = undefined;
    estimateList = [];
    isLoading = false;
    isSaving = false;
    // Temp Estimates (used by Session and Usage Estimators for live estimates)
    tempEstimate = undefined;
    tempSessionEstimates = {};
    tempSessionEstimateItems = {};
    tempUsageEstimates = {};
    tempUsageEstimateItems = {};
    // Quick Estimate
    quickEstimateTotal = 0;
    quickEstimateTotalPlusFringe = 0;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            currentEstimate: (0, $hK1qT.observable),
            estimateList: (0, $hK1qT.observable),
            isLoading: (0, $hK1qT.observable),
            isSaving: (0, $hK1qT.observable),
            tempEstimate: (0, $hK1qT.observable),
            tempSessionEstimates: (0, $hK1qT.observable),
            tempSessionEstimateItems: (0, $hK1qT.observable),
            tempUsageEstimates: (0, $hK1qT.observable),
            tempUsageEstimateItems: (0, $hK1qT.observable),
            quickEstimateTotal: (0, $hK1qT.observable),
            quickEstimateTotalPlusFringe: (0, $hK1qT.observable),
            canEditCurrent: (0, $hK1qT.computed),
            lastSessionEstimateDate: (0, $hK1qT.computed),
            setCurrentEstimate: (0, $hK1qT.action),
            setTempEstimate: (0, $hK1qT.action),
            setEstimateList: (0, $hK1qT.action)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    /**
   * Estimates
   */ get canEditCurrent() {
        return !!this.currentEstimate?.project_id && this.currentEstimate?.status === (0, $djcqs.EstimateStatus).Draft;
    }
    setCurrentEstimate(estimate) {
        this.currentEstimate = estimate;
    }
    setEstimateList(estimateList) {
        this.estimateList = estimateList;
    }
    listEstimates = async (projectId, relations)=>{
        if (!projectId) return;
        // TODO implement pagination
        try {
            (0, $hK1qT.runInAction)(()=>this.isLoading = true);
            const { estimates: estimates } = await this.q((0, $NcqgP.EstimateService).listEstimates(projectId, undefined, undefined, undefined, relations));
            (0, $hK1qT.runInAction)(()=>{
                this.setEstimateList([
                    ...estimates
                ].sort((a, b)=>a.created_at < b.created_at ? 1 : -1));
                this.isLoading = false;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    getEstimate = async (estimateId, relations)=>{
        if (!estimateId) return;
        try {
            const { estimate: estimate } = await this.q((0, $NcqgP.EstimateService).getEstimate(estimateId, relations));
            return estimate;
        } catch (e) {
            this.handleError(e);
        }
    };
    getEstimateByTitle = async (title, relations, isHidden)=>{
        if (!title) return;
        try {
            const { estimate: estimate } = await this.q((0, $NcqgP.EstimateService).getEstimateByTitle(title, relations, isHidden ? 'true' : 'false'));
            return estimate;
        } catch (e) {
            this.handleError(e);
        }
    };
    getEstimateTotals = async (estimateId)=>{
        if (!estimateId) return;
        try {
            const totals = await this.q((0, $NcqgP.EstimateService).getEstimateTotals(estimateId));
            return totals;
        } catch (e) {
            this.handleError(e);
        }
    };
    refreshEstimateTotals = async (estimateId)=>{
        if (!estimateId) return;
        try {
            const totals = await this.getEstimateTotals(estimateId);
            if (totals) {
                const estimateIndex = this.estimateList.findIndex((e)=>e.id === estimateId);
                if (estimateIndex > -1) {
                    const list = this.estimateList;
                    list[estimateIndex] = {
                        ...list[estimateIndex],
                        total: totals.total,
                        total_plus_fringe: totals.total_plus_fringe
                    };
                    this.setEstimateList(list);
                }
                if (this.currentEstimate?.id === estimateId) (0, $hK1qT.runInAction)(()=>{
                    this.setCurrentEstimate({
                        ...this.currentEstimate,
                        total: totals.total,
                        total_plus_fringe: totals.total_plus_fringe
                    });
                });
            }
        } catch (e) {
            this.handleError(e);
        }
    };
    refreshEstimate = async (estimateId)=>{
        if (!estimateId) return;
        try {
            const { estimate: updatedEstimate } = await this.q((0, $NcqgP.EstimateService).getEstimate(estimateId, $4544b2fd157c8995$var$estimateRelations));
            if (!updatedEstimate) return;
            const estimateIndex = this.estimateList.findIndex((e)=>e.id === estimateId);
            if (estimateIndex > -1) {
                const list = [
                    ...this.estimateList
                ];
                list[estimateIndex] = updatedEstimate;
                this.setEstimateList(list);
            }
            if (this.currentEstimate?.id === estimateId) (0, $hK1qT.runInAction)(()=>{
                this.setCurrentEstimate(updatedEstimate);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    createEstimate = async (projectId, title, isHidden)=>{
        if (!projectId) return;
        try {
            this.setIsSaving(true);
            const { estimate: newEstimate } = await this.q((0, $NcqgP.EstimateService).createEstimate({
                projectId: projectId,
                title: title,
                isHidden: isHidden
            }));
            const estimate = await this.getEstimate(newEstimate?.id, $4544b2fd157c8995$var$estimateRelations);
            if (estimate) (0, $hK1qT.runInAction)(()=>{
                this.estimateList.unshift(estimate);
            });
            return estimate;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    recalculateEstimate = async (e)=>{
        const i = this.estimateList?.findIndex((p)=>p.id === e.id);
        if (i === undefined || i === -1) return;
        try {
            const { estimate: estimate } = await this.q((0, $NcqgP.EstimateService).recalculateEstimate(e.id));
            const updatedEstimate = await this.getEstimate(estimate?.id, $4544b2fd157c8995$var$estimateRelations);
            if (updatedEstimate) (0, $hK1qT.runInAction)(()=>{
                this.estimateList.splice(i, 1, updatedEstimate);
                this.setCurrentEstimate(updatedEstimate);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    updateEstimate = async (e)=>{
        const i = this.estimateList?.findIndex((p)=>p.id === e.id);
        if (i === undefined || i === -1) return;
        const updateRequest = {
            status: e.status,
            title: e.title
        };
        try {
            this.setIsSaving(true);
            const { estimate: estimate } = await this.q((0, $NcqgP.EstimateService).updateEstimate(e.id, updateRequest));
            const updatedEstimate = await this.getEstimate(estimate?.id, $4544b2fd157c8995$var$estimateRelations);
            if (updatedEstimate) (0, $hK1qT.runInAction)(()=>{
                this.estimateList.splice(i, 1, updatedEstimate);
                this.setCurrentEstimate(updatedEstimate);
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteEstimate = async (estimateId)=>{
        try {
            this.setIsSaving(true);
            await this.q((0, $NcqgP.EstimateService).deleteEstimate(estimateId));
            if (estimateId === this.currentEstimate?.id) this.setCurrentEstimate(undefined);
            (0, $hK1qT.runInAction)(()=>{
                this.estimateList = this.estimateList?.filter((p)=>p.id !== estimateId);
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    quickEstimate = async (performerCounts, workHours, hasPriorDayFitting, isVoiceOver)=>{
        try {
            const hasPerformerCounts = Object.values(performerCounts).findIndex((count)=>count > 0) > -1;
            let total = 0;
            let totalPlusFringe = 0;
            if (hasPerformerCounts && workHours) {
                const res = await this.q((0, $ieh93.SessionEstimateService).quickSessionEstimate({
                    performerCounts: JSON.stringify(performerCounts),
                    workHours: workHours,
                    hasPriorDayFitting: hasPriorDayFitting,
                    isVoiceOver: isVoiceOver
                }));
                total = res.total;
                totalPlusFringe = res.totalPlusFringe;
            }
            (0, $hK1qT.runInAction)(()=>{
                this.quickEstimateTotal = total;
                this.quickEstimateTotalPlusFringe = totalPlusFringe;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    /**
   * Temp Estimates
   *
   * - Hidden Estimates for each Project
   * - Used for live estimation on the Session & Usage Estimators
   * - Created when the Estimators are used for the first time
   */ setTempEstimate = (estimate)=>this.tempEstimate = estimate;
    getTempSessionEstimate = (sessionId)=>sessionId ? this.tempSessionEstimates[sessionId] : undefined;
    getTempSessionEstimateItems = (sessionId, activityId)=>sessionId && activityId ? this.tempSessionEstimateItems[sessionId]?.[activityId] : undefined;
    getTempUsageEstimate = (commercialId)=>commercialId ? this.tempUsageEstimates[commercialId] : undefined;
    getTempUsageEstimateItems = (commercialId, usageId)=>commercialId && usageId ? this.tempUsageEstimateItems[commercialId]?.[usageId] : undefined;
    refreshTempEstimate = async (skipSessions = false, skipUsages = false)=>{
        if (!this.tempEstimate || this.isLoading) return;
        try {
            (0, $hK1qT.runInAction)(()=>this.isLoading = true);
            const estimateId = this.tempEstimate.id;
            const { estimate: updatedEstimate } = await this.q((0, $NcqgP.EstimateService).getEstimate(estimateId, $4544b2fd157c8995$var$estimateRelations));
            if (!updatedEstimate) return;
            if (!skipSessions) for (const sessionEstimate of updatedEstimate.session_estimates){
                const session = sessionEstimate.session;
                if (!session) continue;
                const timestep = 0.25;
                let processedBaseFee = false;
                const estimateItems = {};
                const activitiesByRole = {};
                session?.activities.forEach((activity)=>{
                    activity.roles.forEach((role)=>{
                        activitiesByRole[role.id] ??= [];
                        activitiesByRole[role.id].push(activity);
                    });
                });
                for (const roleId of Object.keys(activitiesByRole)){
                    const activities = activitiesByRole[roleId].sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(a.start_time ?? 0).diff(b.start_time ?? 0));
                    const items = sessionEstimate?.items.filter((i)=>i.role_id === roleId);
                    const workTimeItems = {
                        [(0, $fjut3.WorkTimeType).StraightTime]: items?.find((i)=>i.title.toLocaleLowerCase().includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).StraightTime].toLocaleLowerCase())),
                        [(0, $fjut3.WorkTimeType).TimeAndOneHalf]: items?.find((i)=>i.title.toLocaleLowerCase().includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).TimeAndOneHalf].toLocaleLowerCase())),
                        [(0, $fjut3.WorkTimeType).DoubleTime]: items?.find((i)=>i.title.toLocaleLowerCase().includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).DoubleTime].toLocaleLowerCase()))
                    };
                    let totalHours = 0;
                    for (const a of activities){
                        estimateItems[a.id] ??= [];
                        if (!a.hours) continue;
                        // Get work time
                        if ((0, $fjut3.WorkActivityTypes).has(a.type)) {
                            const h = a.hours ?? 0;
                            const estimates = {
                                [(0, $fjut3.WorkTimeType).StraightTime]: undefined,
                                [(0, $fjut3.WorkTimeType).TimeAndOneHalf]: undefined,
                                [(0, $fjut3.WorkTimeType).DoubleTime]: undefined
                            };
                            for(let i = 0; i < h; i += timestep){
                                totalHours += timestep;
                                const workTimeType = (0, $dErKY.getWorkTimeType)(totalHours);
                                const workTimeItem = workTimeItems[workTimeType];
                                if (workTimeItem) {
                                    let estimate = estimates[workTimeType];
                                    if (!estimate || typeof estimate.units !== 'number') {
                                        estimate = {
                                            ...workTimeItem,
                                            units: 0
                                        };
                                        estimates[workTimeType] = estimate;
                                    }
                                    estimate.units = (estimate.units ?? 0) + timestep;
                                    const currentUnits = estimate.units ?? 0;
                                    const originalUnits = workTimeItem.units ?? 0;
                                    if (originalUnits) {
                                        const multiplier = currentUnits / originalUnits;
                                        estimate.subtotal = workTimeItem.subtotal * multiplier;
                                        estimate.subtotal_plus_fringe = workTimeItem.subtotal_plus_fringe * multiplier;
                                    }
                                }
                            }
                            estimateItems[a.id].push(...Object.values(estimates).filter((e)=>!!e));
                        } else {
                            const matches = sessionEstimate?.items.filter((item)=>item.unit_type === (0, $7dV2j.SessionEstimateItemUnitType).Hours && item.role_id === roleId && (item.session_activity?.type === a.type || item.title.toLocaleLowerCase().includes(a.type.toLocaleLowerCase()))) ?? [];
                            const totalUnits = (!matches[1] ? matches[0]?.units : matches.map((item)=>item.units ?? 0).reduce((acc, hours)=>(acc ?? 0) + hours)) ?? 0;
                            for (const match of matches){
                                const auditionEstimateItem = {
                                    ...match
                                };
                                const currentValue = a.hours ?? 0;
                                const originalValue = totalUnits ?? 0;
                                if (currentValue) {
                                    const multiplier = currentValue / originalValue;
                                    auditionEstimateItem.units = currentValue;
                                    auditionEstimateItem.subtotal *= multiplier;
                                    auditionEstimateItem.subtotal_plus_fringe *= multiplier;
                                }
                                estimateItems[a.id].push(auditionEstimateItem);
                            }
                        }
                        // Look for any Base Session Fee estimate items and add them
                        if (!processedBaseFee) {
                            const baseFeeTitle = 'Base Session Fee'.toLocaleLowerCase();
                            const matches = sessionEstimate?.items.filter((item)=>item.role_id === roleId && item.title.toLocaleLowerCase().includes(baseFeeTitle)) ?? [];
                            if (matches.length) estimateItems[a.id].push(...matches);
                            processedBaseFee = true;
                        }
                        // If it's a travel day, check for No Service Day items
                        if ((0, $fjut3.TravelActivityTypes).has(a.type)) {
                            const matches = sessionEstimate?.items.filter((item)=>{
                                if (item.role_id !== roleId) return false;
                                const title = item.title.toLocaleLowerCase();
                                if (title.includes('No Service Day'.toLocaleLowerCase())) return true;
                                else if (title.includes((0, $fjut3.EstimateFeeType).StudioZoneTravelFee.toLocaleLowerCase())) return true;
                                else return false;
                            }) ?? [];
                            if (matches.length) estimateItems[a.id].push(...matches);
                        }
                        // Add any associated premiums
                        const premiums = sessionEstimate?.items.filter((item)=>item.role_id === roleId && item.title.toLocaleLowerCase().includes(((0, $fjut3.sessionEstimateItemTitles)[a.type] ?? a.type).toLocaleLowerCase())) ?? [];
                        if (premiums.length) estimateItems[a.id].push(...premiums);
                    }
                    // Non-Activity fees
                    for (const item of sessionEstimate.items)if (item.unit_type === (0, $7dV2j.SessionEstimateItemUnitType).Count) {
                        let totalHours = 0;
                        const itemActivities = activities.filter((activity)=>{
                            if (activity.roles?.find((role)=>role.id === roleId) && (activity.type === item.session_activity?.type || item.title.toLocaleLowerCase().includes(((0, $fjut3.sessionEstimateItemTitles)[activity.type] || activity.type)?.toLocaleLowerCase()))) {
                                totalHours += activity.hours ?? 0;
                                return true;
                            }
                        }) ?? [];
                        for (const activity of itemActivities){
                            const sessionEstimateItem = {
                                ...item,
                                session_activity: activity,
                                session_activity_id: activity.id
                            };
                            if (totalHours) {
                                const multiplier = (activity.hours ?? 0) / totalHours;
                                sessionEstimateItem.units = activity.hours ?? 0;
                                sessionEstimateItem.subtotal *= multiplier;
                                sessionEstimateItem.subtotal_plus_fringe *= multiplier;
                            }
                            estimateItems[activity.id].push(sessionEstimateItem);
                        }
                    }
                }
                (0, $hK1qT.runInAction)(()=>{
                    this.tempSessionEstimates[session.id] = sessionEstimate;
                    this.tempSessionEstimateItems[session.id] = estimateItems;
                });
            }
            if (!skipUsages) {
                const estimateItems = {};
                for (const usageEstimate of updatedEstimate.usage_estimates){
                    if (!usageEstimate.commercial) continue;
                    estimateItems[usageEstimate.commercial.id] ??= {};
                    for (const item of usageEstimate.items){
                        estimateItems[usageEstimate.commercial.id][item.usage.id] ??= [];
                        estimateItems[usageEstimate.commercial.id][item.usage.id].push(item);
                    }
                    (0, $hK1qT.runInAction)(()=>{
                        if (usageEstimate.commercial) this.tempUsageEstimates[usageEstimate.commercial.id] = usageEstimate;
                    });
                }
                (0, $hK1qT.runInAction)(()=>{
                    this.tempUsageEstimateItems = estimateItems;
                });
            }
            (0, $hK1qT.runInAction)(()=>{
                this.tempEstimate = updatedEstimate;
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            (0, $hK1qT.runInAction)(()=>this.isLoading = false);
        }
    };
    /**
   * SessionEstimates
   */ get lastSessionEstimateDate() {
        return this.currentEstimate?.session_estimates.slice().sort((a, b)=>(a.date ?? '') > (b.date ?? '') ? -1 : 1)[0]?.date ?? '';
    }
    getSessionEstimate = async (estimateId, relations)=>{
        if (!estimateId) return;
        try {
            const { estimate: estimate } = await this.q((0, $NcqgP.EstimateService).getEstimate(estimateId, relations));
            return estimate;
        } catch (e) {
            this.handleError(e);
        }
    };
    getSessionEstimateDates = (sessionEstimateId)=>{
        return this.currentEstimate?.session_estimates.filter((se)=>se.id !== sessionEstimateId).slice().sort((a, b)=>(a.date ?? '') > (b.date ?? '') ? -1 : 1).map((se)=>se.date ?? '') ?? [];
    };
    createSessionEstimate = async (title = 'New SessionEstimate', date = new Date().toUTCString(), sessionId, // estimateId?: TEstimateId
    isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot create SessionEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await this.q((0, $ieh93.SessionEstimateService).createSessionEstimate({
                estimateId: estimate.id,
                title: title,
                date: date,
                sessionId: sessionId
            }));
            await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateSessionEstimate = async (sessionEstimateId, title, date, sessionId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot update SessionEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await this.q((0, $ieh93.SessionEstimateService).updateSessionEstimate(sessionEstimateId, {
                title: title,
                date: date ?? undefined,
                sessionId: sessionId
            }));
            isTempEstimate ? await this.refreshTempEstimate() : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteSessionEstimate = async (sessionEstimateId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot create SessionEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await this.q((0, $ieh93.SessionEstimateService).deleteSessionEstimate(sessionEstimateId));
            isTempEstimate ? await this.refreshTempEstimate() : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /**
   * SessionEstimateItems
   */ createSessionEstimateItem = async (sessionEstimateId, title = 'New Estimate Item', units = 1, unitType = (0, $7dV2j.SessionEstimateItemUnitType).Count, rate = 0, sessionActivityId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot create SessionEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await (0, $lEuQR.SessionEstimateItemService).createSessionEstimateItem({
                sessionEstimateId: sessionEstimateId,
                sessionActivityId: sessionActivityId,
                title: title,
                units: units,
                unitType: unitType,
                rate: rate
            });
            await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateSessionEstimateItem = async (sessionEstimateItemId, title, units, unitType, rate, taxesMultiplier, handlingMultiplier, pAndHMultiplier, sessionActivityId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot create SessionEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await (0, $lEuQR.SessionEstimateItemService).updateSessionEstimateItem(sessionEstimateItemId, {
                title: title,
                units: units,
                unitType: unitType,
                rate: rate,
                taxesMultiplier: taxesMultiplier,
                handlingMultiplier: handlingMultiplier,
                pAndHMultiplier: pAndHMultiplier,
                sessionActivityId: sessionActivityId
            });
            await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteSessionEstimateItem = async (sessionEstimateItemId, isTempEstimate)=>{
        try {
            this.setIsSaving(true);
            const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
            if (!estimate) {
                console.error('No saved Estimate - cannot create SessionEstimate');
                return;
            }
            await (0, $lEuQR.SessionEstimateItemService).deleteSessionEstimateItem(sessionEstimateItemId);
            await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /**
   * UsageEstimates
   */ get usageEstimateList() {
        return this.currentEstimate?.usage_estimates;
    }
    createUsageEstimate = async (title = 'New UsageEstimate', commercialId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot create UsageEstimate');
            return;
        }
        try {
            await this.q((0, $aFNng.UsageEstimateService).createUsageEstimate({
                estimateId: estimate.id,
                title: title,
                commercialId: commercialId
            }));
            isTempEstimate ? await this.refreshTempEstimate(true) : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        }
    };
    updateUsageEstimate = async (usageEstimateId, title, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot update UsageEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await this.q((0, $aFNng.UsageEstimateService).updateUsageEstimate(usageEstimateId, {
                title: title
            }));
            isTempEstimate ? await this.refreshTempEstimate(true) : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteUsageEstimate = async (usageEstimateId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot delete UsageEstimate');
            return;
        }
        try {
            this.setIsSaving(true);
            await this.q((0, $aFNng.UsageEstimateService).deleteUsageEstimate(usageEstimateId));
            isTempEstimate ? await this.refreshTempEstimate(true) : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /**
   * Usage Estimate Items
   */ createUsageEstimateItem = async (newUsageEstimateItem, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot create UsageEstimateItem');
            return;
        }
        try {
            this.setIsSaving(true);
            await (0, $5yg4I.UsageEstimateItemService).createUsageEstimateItem(newUsageEstimateItem);
            isTempEstimate ? await this.refreshTempEstimate(true) : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateUsageEstimateItem = async (usageEstimateItemId, updatedUsageEstimateItem, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot update UsageEstimateItem');
            return;
        }
        try {
            this.setIsSaving(true);
            const { usageEstimateItem: usageEstimateItem } = await this.q((0, $5yg4I.UsageEstimateItemService).updateUsageEstimateItem(usageEstimateItemId, updatedUsageEstimateItem));
            isTempEstimate ? await this.refreshTempEstimate(true) : await this.refreshEstimate(estimate.id);
            return usageEstimateItem;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteUsageEstimateItem = async (usageEstimateItemId, isTempEstimate)=>{
        const estimate = isTempEstimate ? this.tempEstimate : this.currentEstimate;
        if (!estimate) {
            console.error('No saved Estimate - cannot delete UsageEstimateItem');
            return;
        }
        try {
            this.setIsSaving(true);
            await (0, $5yg4I.UsageEstimateItemService).deleteUsageEstimateItem(usageEstimateItemId);
            isTempEstimate ? await this.refreshTempEstimate(true) : await this.refreshEstimate(estimate.id);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
}

});
parcelRegister("fjut3", function(module, exports) {
"use strict";
var $b260439c38d3e904$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b260439c38d3e904$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b260439c38d3e904$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b260439c38d3e904$var$__exportStar((parcelRequire("ktoXk")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("e19Z5")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("6C9ob")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("lAQjl")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("3gfx2")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("lEK2B")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("h1cYB")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("44Jty")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("aibfv")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("bPeuo")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("8IRZr")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("dGvVu")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("4FVeo")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("5DU5Q")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("iOnLV")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("cwedk")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("44dve")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("fZjBI")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("29bED")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("gT3P6")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("26j5B")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("1EySh")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("b8BS9")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("b9FdQ")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("7Qz5t")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("bof2l")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("b9FdQ")), module.exports);

$b260439c38d3e904$var$__exportStar((parcelRequire("14DFf")), module.exports);

});
parcelRegister("ktoXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AllowanceType = void 0;
/**
 * Allowance
 */ var $ee79dfca928c2a22$var$AllowanceType;
(function(AllowanceType) {
    AllowanceType["Wardrobe_Fee"] = "Wardrobe Fee";
    AllowanceType["Wardrobe_FeeEvePeriod"] = "Wardrobe Fee - Eve/Period";
    AllowanceType["LocationMeal_Breakfast"] = "Breakfast";
    AllowanceType["LocationMeal_Lunch"] = "Lunch";
    AllowanceType["LocationMeal_Dinnner"] = "Dinnner";
    AllowanceType["Travel_ExtrasRoundTrip"] = "Extras - Round Trip";
    AllowanceType["Travel_PerMileOutsideStudioZone"] = "Per mile (outside studio zone)";
    AllowanceType["Travel_OCPPerDiem"] = "OCP travel per diem";
    AllowanceType["Props_AutomobileTrailerMotorcycle"] = "Automobile, Trailer or Motorcycle";
    AllowanceType["Props_SkatesSkateBoards"] = "Skates and Skate Boards";
    AllowanceType["Props_Bicycle"] = "Bicycle";
    AllowanceType["Props_Moped"] = "Moped";
    AllowanceType["Props_Camera"] = "Camera";
    AllowanceType["Props_Pet"] = "Pet";
    AllowanceType["Props_LuggageEachPiece"] = "Luggage (each piece)";
    AllowanceType["Props_GolfClubsAndBag"] = "Golf Clubs & Bag";
    AllowanceType["Props_TennisRacquet"] = "Tennis Racquet";
    AllowanceType["Props_Skis"] = "Skis";
    AllowanceType["Props_BinocularsOperaGlasses"] = "Binoculars or Opera Glasses";
    AllowanceType["Props_LargePortableRadios"] = "Large Portable Radios";
    AllowanceType["Props_BooksEach"] = "Books (each)";
    AllowanceType["Props_LaptopCellPhonePDAiPodMP3Player"] = "Laptop, Cell Phone/PDA, iPod/MP3 Player";
    AllowanceType["Props_StandardOpeningOrClosing"] = "Standard Opening or Closing";
    AllowanceType["Props_WetSnowmokeDustWork"] = "Wet, Snow, Smoke, & Dust Work";
    AllowanceType["Props_BodyMUSkullCapHairGoodsHaircuts"] = "Body MU, Skull Cap, Hair Goods, Haircuts";
})($ee79dfca928c2a22$var$AllowanceType || (module.exports.AllowanceType = $ee79dfca928c2a22$var$AllowanceType = {}));

});

parcelRegister("e19Z5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProcessingStatus = module.exports.AssetType = void 0;
/**
 * Enums
 */ var $a348e757442568ad$var$AssetType;
(function(AssetType) {
    AssetType["Video"] = "Video";
    AssetType["Image"] = "Image";
    AssetType["Audio"] = "Audio";
    AssetType["Document"] = "Document";
})($a348e757442568ad$var$AssetType || (module.exports.AssetType = $a348e757442568ad$var$AssetType = {}));
var $a348e757442568ad$var$ProcessingStatus;
(function(ProcessingStatus) {
    ProcessingStatus["Pending"] = "Pending";
    ProcessingStatus["Processing"] = "Processing";
    ProcessingStatus["Complete"] = "Complete";
    ProcessingStatus["Failed"] = "Failed";
})($a348e757442568ad$var$ProcessingStatus || (module.exports.ProcessingStatus = $a348e757442568ad$var$ProcessingStatus = {}));

});

parcelRegister("6C9ob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MentionTargetType = module.exports.ConversationParticipantRole = module.exports.ConversationType = module.exports.ConversationStatus = module.exports.MessageType = void 0;
var $4d0d932e23c0d89d$var$MessageType;
(function(MessageType) {
    MessageType["AI_MESSAGE"] = "aiMessage";
    MessageType["CHARACTER_PHOTOS_UPLOADED"] = "characterPhotosUploaded";
    MessageType["ERROR_MESSAGE"] = "errorMessage";
    MessageType["NEW_CONVERSATION"] = "newConversation";
    MessageType["NOTIFICATION"] = "notification";
    MessageType["PERFORMER_CONTRACT_DECLINED"] = "performerContractDeclined";
    MessageType["SUPPORT_MESSAGE"] = "supportMessage";
    MessageType["SYSTEM_MESSAGE"] = "systemMessage";
    /** Ephemeral typing-indicator ping — never persisted as a ChatMessage row. */ MessageType["TYPING"] = "typing";
    MessageType["UPDATED_CONVERSATION"] = "updatedConversation";
    MessageType["USER_MESSAGE"] = "userMessage";
})($4d0d932e23c0d89d$var$MessageType || (module.exports.MessageType = $4d0d932e23c0d89d$var$MessageType = {}));
var $4d0d932e23c0d89d$var$ConversationStatus;
(function(ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["CLOSED"] = "closed";
})($4d0d932e23c0d89d$var$ConversationStatus || (module.exports.ConversationStatus = $4d0d932e23c0d89d$var$ConversationStatus = {}));
var $4d0d932e23c0d89d$var$ConversationType;
(function(ConversationType) {
    ConversationType["SUPPORT"] = "support";
    ConversationType["TALENT_MANAGER"] = "talentManager";
    ConversationType["PROJECT"] = "project";
})($4d0d932e23c0d89d$var$ConversationType || (module.exports.ConversationType = $4d0d932e23c0d89d$var$ConversationType = {}));
var $4d0d932e23c0d89d$var$ConversationParticipantRole;
(function(ConversationParticipantRole) {
    ConversationParticipantRole["AGENCY"] = "agency";
    ConversationParticipantRole["TALENT_MANAGER"] = "talentManager";
    ConversationParticipantRole["SUPPORT"] = "support";
    ConversationParticipantRole["ADMIN_OBSERVER"] = "adminObserver";
})($4d0d932e23c0d89d$var$ConversationParticipantRole || (module.exports.ConversationParticipantRole = $4d0d932e23c0d89d$var$ConversationParticipantRole = {}));
var $4d0d932e23c0d89d$var$MentionTargetType;
(function(MentionTargetType) {
    MentionTargetType["USER"] = "user";
    MentionTargetType["BOT"] = "bot";
    MentionTargetType["SUPPORT"] = "support";
})($4d0d932e23c0d89d$var$MentionTargetType || (module.exports.MentionTargetType = $4d0d932e23c0d89d$var$MentionTargetType = {}));

});

parcelRegister("lAQjl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommercialType = void 0;
/**
 * Type
 */ var $fb8589a326b8777b$var$CommercialType;
(function(CommercialType) {
    CommercialType["TV"] = "TV";
    CommercialType["Radio"] = "Radio";
    CommercialType["Digital"] = "Digital";
    CommercialType["Print"] = "Print";
    CommercialType["OOH"] = "OOH";
    CommercialType["Social"] = "Social";
    CommercialType["BTS"] = "BTS";
    CommercialType["Other"] = "Other";
})($fb8589a326b8777b$var$CommercialType || (module.exports.CommercialType = $fb8589a326b8777b$var$CommercialType = {}));

});

parcelRegister("3gfx2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CostumeType = void 0;
/**
 * Costume Type
 */ var $25feea085a95b3d6$var$CostumeType;
(function(CostumeType) {
    CostumeType["Standard"] = "Standard";
    CostumeType["EveningWear"] = "Evening Wear";
    CostumeType["PeriodWear"] = "Period Wear";
})($25feea085a95b3d6$var$CostumeType || (module.exports.CostumeType = $25feea085a95b3d6$var$CostumeType = {}));

});

parcelRegister("lEK2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DocumentType = void 0;
/**
 * Enums
 */ var $fc410c27e2234c5b$var$DocumentType;
(function(DocumentType) {
    DocumentType["Script"] = "Script";
    DocumentType["Storyboard"] = "Storyboard";
    DocumentType["ShootingSchedule"] = "Shoot Schedule";
    DocumentType["MediaPlan"] = "Media Plan";
    DocumentType["Contract"] = "Contract";
    DocumentType["License"] = "License";
    DocumentType["Generic"] = "Generic";
})($fc410c27e2234c5b$var$DocumentType || (module.exports.DocumentType = $fc410c27e2234c5b$var$DocumentType = {}));

});

parcelRegister("h1cYB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditReviewStatus = void 0;
/**
 * Edit Review Status
 */ var $c63c98835d54a132$var$EditReviewStatus;
(function(EditReviewStatus) {
    EditReviewStatus["PENDING"] = "pending";
    EditReviewStatus["PROCESSING"] = "processing";
    EditReviewStatus["COMPLETED"] = "completed";
    EditReviewStatus["FAILED"] = "failed";
})($c63c98835d54a132$var$EditReviewStatus || (module.exports.EditReviewStatus = $c63c98835d54a132$var$EditReviewStatus = {}));

});

parcelRegister("44Jty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditType = void 0;
/**
 * Edit Types
 *
 * Part I, Section 26
 */ var $2f7acfa48d99d9ad$var$EditType;
(function(EditType) {
    EditType["MainAsset"] = "Main Asset";
    EditType["ShorterOrLongerVersion"] = "Shorter Or Longer Version";
    EditType["PermittedChanges"] = "Permitted Changes";
    EditType["PaidEdits"] = "Paid Edits";
    EditType["AddressableEdits"] = "Addressable Edits";
})($2f7acfa48d99d9ad$var$EditType || (module.exports.EditType = $2f7acfa48d99d9ad$var$EditType = {}));

});

parcelRegister("aibfv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EstimateStatus = void 0;
parcelRequire("gT3P6");
parcelRequire("26j5B");
parcelRequire("b8BS9");
var $77e44fa2474d3dcb$var$EstimateStatus;
(function(EstimateStatus) {
    EstimateStatus["Draft"] = "Draft";
    EstimateStatus["Final"] = "Final";
})($77e44fa2474d3dcb$var$EstimateStatus || (module.exports.EstimateStatus = $77e44fa2474d3dcb$var$EstimateStatus = {}));

});
parcelRegister("gT3P6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RoleFilter = module.exports.RadioTypes = module.exports.TVTypes = module.exports.AFMTypes = module.exports.ExtraTypes = module.exports.OffCameraPrincipalTypes = module.exports.OnCameraPrincipalTypes = module.exports.RoleScale = module.exports.RoleType = void 0;

var $29bED = parcelRequire("29bED");
/**
 * Role Type
 */ var $c4b4bf9ee6cacb23$var$RoleType;
(function(RoleType) {
    RoleType["Actor"] = "Actor";
    RoleType["Speaker"] = "Speaker";
    RoleType["Narrator"] = "Narrator";
    RoleType["Announcer"] = "Announcer";
    RoleType["Singer"] = "Singer";
    RoleType["SpecialtyDancer"] = "Specialty Dancer";
    RoleType["SpecialtyAct"] = "Specialty Act";
    RoleType["Puppeteer"] = "Puppeteer";
    RoleType["StuntPerformer"] = "Stunt Performer";
    RoleType["StuntCoordinator"] = "Stunt Coordinator";
    RoleType["Pilot"] = "Pilot";
    RoleType["Clown"] = "Clown";
    RoleType["StandIn"] = "Stand In";
    RoleType["HandModel"] = "Hand Model";
    RoleType["HandModelDoubleScale"] = "Hand Model Double Scale";
    RoleType["Other"] = "Other";
    RoleType["LeaderArrangerComposer"] = "Leader Arranger Composer";
    RoleType["CopyistSideMusician"] = "Copyist Side Musician";
    RoleType["CopyistSideMusician1Double"] = "Copyist Side Musician 1 Double";
    RoleType["CopyistSideMusician2Doubles"] = "Copyist Side Musician 2 Doubles";
    RoleType["CopyistSideMusician3Doubles"] = "Copyist Side Musician 3 Doubles";
    RoleType["CopyistSideMusician4Doubles"] = "Copyist Side Musician 4 Doubles";
})($c4b4bf9ee6cacb23$var$RoleType || (module.exports.RoleType = $c4b4bf9ee6cacb23$var$RoleType = {}));
var $c4b4bf9ee6cacb23$var$RoleScale;
(function(RoleScale) {
    RoleScale["SessionScale"] = "Session Scale";
    RoleScale["AboveScale"] = "Above Scale";
})($c4b4bf9ee6cacb23$var$RoleScale || (module.exports.RoleScale = $c4b4bf9ee6cacb23$var$RoleScale = {}));
/**
 * Type Lists
 */ module.exports.OnCameraPrincipalTypes = [
    $c4b4bf9ee6cacb23$var$RoleType.Actor,
    $c4b4bf9ee6cacb23$var$RoleType.Singer,
    $c4b4bf9ee6cacb23$var$RoleType.SpecialtyDancer,
    $c4b4bf9ee6cacb23$var$RoleType.SpecialtyAct,
    $c4b4bf9ee6cacb23$var$RoleType.StuntPerformer,
    $c4b4bf9ee6cacb23$var$RoleType.Pilot,
    $c4b4bf9ee6cacb23$var$RoleType.Clown
];
module.exports.OffCameraPrincipalTypes = [
    $c4b4bf9ee6cacb23$var$RoleType.Narrator,
    $c4b4bf9ee6cacb23$var$RoleType.Announcer,
    $c4b4bf9ee6cacb23$var$RoleType.Puppeteer,
    $c4b4bf9ee6cacb23$var$RoleType.StuntCoordinator
];
module.exports.ExtraTypes = [
    $29bED.RolePerformerType.Extra,
    $c4b4bf9ee6cacb23$var$RoleType.Actor,
    $c4b4bf9ee6cacb23$var$RoleType.StandIn,
    $c4b4bf9ee6cacb23$var$RoleType.Singer,
    $c4b4bf9ee6cacb23$var$RoleType.HandModel,
    $c4b4bf9ee6cacb23$var$RoleType.HandModelDoubleScale,
    $c4b4bf9ee6cacb23$var$RoleType.SpecialtyDancer,
    $c4b4bf9ee6cacb23$var$RoleType.SpecialtyAct,
    $c4b4bf9ee6cacb23$var$RoleType.StuntPerformer,
    $c4b4bf9ee6cacb23$var$RoleType.Pilot,
    $c4b4bf9ee6cacb23$var$RoleType.Clown
];
module.exports.AFMTypes = [
    $c4b4bf9ee6cacb23$var$RoleType.LeaderArrangerComposer,
    $c4b4bf9ee6cacb23$var$RoleType.CopyistSideMusician,
    $c4b4bf9ee6cacb23$var$RoleType.CopyistSideMusician1Double,
    $c4b4bf9ee6cacb23$var$RoleType.CopyistSideMusician2Doubles,
    $c4b4bf9ee6cacb23$var$RoleType.CopyistSideMusician3Doubles,
    $c4b4bf9ee6cacb23$var$RoleType.CopyistSideMusician4Doubles
];
module.exports.TVTypes = [
    ...module.exports.OnCameraPrincipalTypes,
    ...module.exports.OffCameraPrincipalTypes,
    ...module.exports.ExtraTypes,
    ...module.exports.AFMTypes
];
module.exports.RadioTypes = [
    $c4b4bf9ee6cacb23$var$RoleType.Announcer
];
/**
 * All Role/Performer Types
 */ module.exports.RoleFilter = {
    [$29bED.RolePerformerType.OnCameraPrincipal]: module.exports.OnCameraPrincipalTypes,
    [$29bED.RolePerformerType.OnCameraGroup]: module.exports.OnCameraPrincipalTypes,
    [$29bED.RolePerformerType.OffCameraPrincipal]: module.exports.OffCameraPrincipalTypes,
    [$29bED.RolePerformerType.OffCameraGroup]: module.exports.OffCameraPrincipalTypes,
    [$29bED.RolePerformerType.Extra]: module.exports.ExtraTypes,
    [$29bED.RolePerformerType.Radio]: module.exports.RadioTypes,
    [$29bED.RolePerformerType.AFM]: module.exports.AFMTypes
};

});
parcelRegister("29bED", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommercialPerformerTypes = module.exports.GroupPerformerTypeFilter = module.exports.GroupPerformerTypes = module.exports.RolePerformerClassification = module.exports.RolePerformerType = void 0;

var $lAQjl = parcelRequire("lAQjl");
/**
 * Role Performer Types - Subset needed for ClassifierService
 */ var $1905765fcda28d42$var$RolePerformerType;
(function(RolePerformerType) {
    RolePerformerType["OnCameraPrincipal"] = "On Camera Principal";
    RolePerformerType["OffCameraPrincipal"] = "Off Camera Principal";
    RolePerformerType["Extra"] = "Extra";
    RolePerformerType["Radio"] = "Radio";
    RolePerformerType["AFM"] = "American Federation Of Musicians";
    RolePerformerType["OnCameraGroup"] = "On Camera Group";
    RolePerformerType["OnCameraGroupContractor"] = "On Camera Group Contractor (1-2)";
    RolePerformerType["OnCameraGroupContractor3To5"] = "On Camera Group Contractor (3-5)";
    RolePerformerType["OnCameraGroupContractor6To8"] = "On Camera Group Contractor (6-8)";
    RolePerformerType["OnCameraGroupContractor9Plus"] = "On Camera Group Contractor (9+)";
    RolePerformerType["OffCameraGroup"] = "Off Camera Group";
    RolePerformerType["OffCameraGroupContractor"] = "Off Camera Group Contractor (1-2)";
    RolePerformerType["OffCameraGroupContractor3To5"] = "Off Camera Group Contractor (3-5)";
    RolePerformerType["OffCameraGroupContractor6To8"] = "Off Camera Group Contractor (6-8)";
    RolePerformerType["OffCameraGroupContractor9Plus"] = "Off Camera Group Contractor (9+)";
})($1905765fcda28d42$var$RolePerformerType || (module.exports.RolePerformerType = $1905765fcda28d42$var$RolePerformerType = {}));
var $1905765fcda28d42$var$RolePerformerClassification;
(function(RolePerformerClassification) {
    RolePerformerClassification["OnCamera"] = "on_camera";
    RolePerformerClassification["OffCamera"] = "off_camera";
})($1905765fcda28d42$var$RolePerformerClassification || (module.exports.RolePerformerClassification = $1905765fcda28d42$var$RolePerformerClassification = {}));
// from web/roleTypes - only one being used
module.exports.GroupPerformerTypes = [
    $1905765fcda28d42$var$RolePerformerType.OnCameraGroup,
    $1905765fcda28d42$var$RolePerformerType.OffCameraGroup
];
module.exports.GroupPerformerTypeFilter = [
    $1905765fcda28d42$var$RolePerformerType.OnCameraGroupContractor,
    $1905765fcda28d42$var$RolePerformerType.OnCameraGroupContractor3To5,
    $1905765fcda28d42$var$RolePerformerType.OnCameraGroupContractor6To8,
    $1905765fcda28d42$var$RolePerformerType.OnCameraGroupContractor9Plus,
    $1905765fcda28d42$var$RolePerformerType.OffCameraGroupContractor,
    $1905765fcda28d42$var$RolePerformerType.OffCameraGroupContractor3To5,
    $1905765fcda28d42$var$RolePerformerType.OffCameraGroupContractor6To8,
    $1905765fcda28d42$var$RolePerformerType.OffCameraGroupContractor9Plus
];
/**
 * Role Performer Types by Commercial
 */ module.exports.CommercialPerformerTypes = {
    [$lAQjl.CommercialType.TV]: [
        $1905765fcda28d42$var$RolePerformerType.OnCameraPrincipal,
        $1905765fcda28d42$var$RolePerformerType.OnCameraGroup,
        $1905765fcda28d42$var$RolePerformerType.OffCameraPrincipal,
        $1905765fcda28d42$var$RolePerformerType.OffCameraGroup,
        $1905765fcda28d42$var$RolePerformerType.Extra,
        $1905765fcda28d42$var$RolePerformerType.AFM
    ],
    [$lAQjl.CommercialType.Radio]: [
        $1905765fcda28d42$var$RolePerformerType.Radio,
        $1905765fcda28d42$var$RolePerformerType.AFM
    ]
};

});


parcelRegister("26j5B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WorkTimeType = module.exports.SessionActivityTimeOfDay = module.exports.AuditionActivityTypes = module.exports.WorkActivityTypes = module.exports.MealActivityTypes = module.exports.TravelActivityTypes = module.exports.sessionActivityTypeTitles = module.exports.SessionActivityType = void 0;
var $187af3156ffebd71$var$SessionActivityType;
(function(SessionActivityType) {
    SessionActivityType["AFMRecordingSession"] = "AFM Recording Session";
    SessionActivityType["WorkTime"] = "Work Time";
    SessionActivityType["WorkTimeNight"] = "Work Time - Night (+10%)";
    SessionActivityType["WorkTimeLateNight"] = "Work Time - Late Night (+20%)";
    SessionActivityType["WorkTimeSaturday"] = "Work Time - Saturday";
    SessionActivityType["WorkTimeSunday"] = "Work Time - Sunday";
    SessionActivityType["WorkTimeHoliday"] = "Work Time - Holiday";
    SessionActivityType["MealBreakfast"] = "Meal - Breakfast";
    SessionActivityType["MealLunch"] = "Meal - Lunch";
    SessionActivityType["MealDinner"] = "Meal - Dinner";
    SessionActivityType["Fitting"] = "Fitting";
    SessionActivityType["WardrobeChange"] = "Wardrobe Change";
    SessionActivityType["HairAndMakeup"] = "Hair And Makeup";
    SessionActivityType["TravelToLocation"] = "Travel To Location";
    SessionActivityType["TravelToLocationAfterMidnight"] = "Travel To Location (After Midnight)";
    SessionActivityType["TravelFromLocation"] = "Travel From Location";
    SessionActivityType["TravelFromLocationAfterMidnight"] = "Travel From Location (After Midnight)";
    SessionActivityType["Audition"] = "Audition";
    SessionActivityType["Rehearsal"] = "Rehearsal";
    SessionActivityType["LineMemorization"] = "Line Memorization";
    SessionActivityType["AuditionScratchTrack"] = "Audition Scratch Track";
    SessionActivityType["RecordingSession"] = "Recording Session";
    SessionActivityType["VoiceOver"] = "Voice Over";
    SessionActivityType["Demo"] = "Demo";
    SessionActivityType["CreativeSession"] = "Creative Session";
    SessionActivityType["CreativeAudition"] = "Creative Audition";
})($187af3156ffebd71$var$SessionActivityType || (module.exports.SessionActivityType = $187af3156ffebd71$var$SessionActivityType = {}));
module.exports.sessionActivityTypeTitles = {
    [$187af3156ffebd71$var$SessionActivityType.WorkTime]: 'Work Session',
    [$187af3156ffebd71$var$SessionActivityType.Fitting]: 'Fitting Session',
    [$187af3156ffebd71$var$SessionActivityType.TravelToLocation]: 'Travel Session - To Location',
    [$187af3156ffebd71$var$SessionActivityType.TravelFromLocation]: 'Travel Session - From Location',
    [$187af3156ffebd71$var$SessionActivityType.MealBreakfast]: 'Breakfast',
    [$187af3156ffebd71$var$SessionActivityType.MealLunch]: 'Lunch',
    [$187af3156ffebd71$var$SessionActivityType.MealDinner]: 'Dinner',
    [$187af3156ffebd71$var$SessionActivityType.Audition]: 'Audition',
    [$187af3156ffebd71$var$SessionActivityType.LineMemorization]: 'Line Memorization',
    [$187af3156ffebd71$var$SessionActivityType.AuditionScratchTrack]: 'Audition Scratch Track',
    [$187af3156ffebd71$var$SessionActivityType.Demo]: 'Demo',
    [$187af3156ffebd71$var$SessionActivityType.VoiceOver]: 'Voice Over',
    [$187af3156ffebd71$var$SessionActivityType.CreativeSession]: 'Creative Session',
    [$187af3156ffebd71$var$SessionActivityType.CreativeAudition]: 'Creative Audition'
};
module.exports.TravelActivityTypes = new Set([
    $187af3156ffebd71$var$SessionActivityType.TravelToLocation,
    $187af3156ffebd71$var$SessionActivityType.TravelToLocationAfterMidnight,
    $187af3156ffebd71$var$SessionActivityType.TravelFromLocation,
    $187af3156ffebd71$var$SessionActivityType.TravelFromLocationAfterMidnight
]);
module.exports.MealActivityTypes = new Set([
    $187af3156ffebd71$var$SessionActivityType.MealBreakfast,
    $187af3156ffebd71$var$SessionActivityType.MealLunch,
    $187af3156ffebd71$var$SessionActivityType.MealDinner
]);
module.exports.WorkActivityTypes = new Set([
    $187af3156ffebd71$var$SessionActivityType.WorkTime,
    $187af3156ffebd71$var$SessionActivityType.WorkTimeNight,
    $187af3156ffebd71$var$SessionActivityType.WorkTimeLateNight,
    $187af3156ffebd71$var$SessionActivityType.WorkTimeSaturday,
    $187af3156ffebd71$var$SessionActivityType.WorkTimeSunday,
    $187af3156ffebd71$var$SessionActivityType.WorkTimeHoliday,
    $187af3156ffebd71$var$SessionActivityType.Fitting,
    $187af3156ffebd71$var$SessionActivityType.HairAndMakeup,
    $187af3156ffebd71$var$SessionActivityType.Audition,
    $187af3156ffebd71$var$SessionActivityType.Rehearsal,
    $187af3156ffebd71$var$SessionActivityType.RecordingSession,
    $187af3156ffebd71$var$SessionActivityType.VoiceOver,
    $187af3156ffebd71$var$SessionActivityType.AuditionScratchTrack,
    $187af3156ffebd71$var$SessionActivityType.Demo,
    $187af3156ffebd71$var$SessionActivityType.CreativeSession,
    $187af3156ffebd71$var$SessionActivityType.CreativeAudition
]);
module.exports.AuditionActivityTypes = new Set([
    $187af3156ffebd71$var$SessionActivityType.Audition,
    $187af3156ffebd71$var$SessionActivityType.AuditionScratchTrack,
    $187af3156ffebd71$var$SessionActivityType.CreativeAudition
]);
/**
 * Session Activity Time of Day
 */ var $187af3156ffebd71$var$SessionActivityTimeOfDay;
(function(SessionActivityTimeOfDay) {
    SessionActivityTimeOfDay["Night"] = "night";
    SessionActivityTimeOfDay["LateNight"] = "late-night";
    SessionActivityTimeOfDay["AfterMidnight"] = "after-midnight";
})($187af3156ffebd71$var$SessionActivityTimeOfDay || (module.exports.SessionActivityTimeOfDay = $187af3156ffebd71$var$SessionActivityTimeOfDay = {}));
/**
 * Work Time Types
 */ var $187af3156ffebd71$var$WorkTimeType;
(function(WorkTimeType) {
    // OnCamera = 'On Camera',
    // OffCamera = 'Off Camera',
    // Overtime = 'Overtime',
    WorkTimeType["StraightTime"] = "Straight Time";
    WorkTimeType["TimeAndOneHalf"] = "Time And One Half";
    WorkTimeType["DoubleTime"] = "Double Time";
    WorkTimeType["NoServiceDay"] = "No Service Day";
    WorkTimeType["NoServiceDayWeekendHoliday"] = "No Service Day (Weekend/Holiday)";
})($187af3156ffebd71$var$WorkTimeType || (module.exports.WorkTimeType = $187af3156ffebd71$var$WorkTimeType = {}));

});

parcelRegister("b8BS9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.holidayDates = module.exports.HolidayType = module.exports.SessionDayType = void 0;
/**
 * Session Day Types
 */ var $81bdd1c017dd5a94$var$SessionDayType;
(function(SessionDayType) {
    SessionDayType["First"] = "1st day";
    SessionDayType["Consecutive"] = "consecutive";
    SessionDayType["NonConsecutive"] = "non-consecutive";
    SessionDayType["Saturday"] = "Saturday";
    SessionDayType["Sunday"] = "Sunday";
    SessionDayType["Holiday"] = "Holiday";
})($81bdd1c017dd5a94$var$SessionDayType || (module.exports.SessionDayType = $81bdd1c017dd5a94$var$SessionDayType = {}));
/**
 * Holiday Types
 */ var $81bdd1c017dd5a94$var$HolidayType;
(function(HolidayType) {
    HolidayType["NewYearsDay"] = "New Year's Day";
    HolidayType["MLKJrBirthday"] = "Martin Luther King Jr's Birthday";
    HolidayType["PresidentsDay"] = "President's Day";
    HolidayType["MemorialDay"] = "Memorial Day";
    HolidayType["Juneteenth"] = "Juneteenth";
    HolidayType["IndependenceDay"] = "Independence Day";
    HolidayType["LaborDay"] = "Labor Day";
    HolidayType["VeteransDay"] = "Veteran's Day";
    HolidayType["ThanksgivingDay"] = "Thanksgiving Day";
    HolidayType["ChristmasDay"] = "Christmas Day";
})($81bdd1c017dd5a94$var$HolidayType || (module.exports.HolidayType = $81bdd1c017dd5a94$var$HolidayType = {}));
module.exports.holidayDates = {
    1: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.NewYearsDay,
            day: 1
        },
        {
            name: $81bdd1c017dd5a94$var$HolidayType.MLKJrBirthday,
            weekday: 1,
            days: [
                15,
                21
            ]
        }
    ],
    2: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.PresidentsDay,
            weekday: 1,
            days: [
                15,
                21
            ]
        }
    ],
    5: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.MemorialDay,
            weekday: 1,
            days: [
                25,
                31
            ]
        }
    ],
    7: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.IndependenceDay,
            day: 4
        }
    ],
    9: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.LaborDay,
            weekday: 1,
            days: [
                1,
                7
            ]
        }
    ],
    11: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.VeteransDay,
            day: 11
        },
        {
            name: $81bdd1c017dd5a94$var$HolidayType.ThanksgivingDay,
            weekday: 4,
            days: [
                22,
                28
            ]
        }
    ],
    12: [
        {
            name: $81bdd1c017dd5a94$var$HolidayType.ChristmasDay,
            day: 25
        }
    ]
};

});


parcelRegister("bPeuo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EstimateFeeType = module.exports.FeeType = void 0;
/**
 * Fee Types
 */ var $89bfb263437d71f4$var$FeeType;
(function(FeeType) {
    FeeType["MealPeriodViolation"] = "Meal Period Violation";
    FeeType["LatePayDamagesPerDayLT25"] = "Up to 25 Days (Per Day)";
    FeeType["LatePayDamagesMaximum"] = "Maximum";
    FeeType["LatePayDamagesOnNonPaymentNotice"] = "On Non-Nayment Notice";
    FeeType["LatePayDamagesPerDayAfterNonPaymentNoticeGTE25"] = "Each Day After Non-Payment Notice \u2267 25 days";
})($89bfb263437d71f4$var$FeeType || (module.exports.FeeType = $89bfb263437d71f4$var$FeeType = {}));
/**
 * Estimate Fee Types
 */ var $89bfb263437d71f4$var$EstimateFeeType;
(function(EstimateFeeType) {
    EstimateFeeType["WardrobeFee"] = "Wardrobe Fee";
    EstimateFeeType["WardrobeFeeEveningWear"] = "Wardrobe - Fee Evening Wear";
    EstimateFeeType["WardrobeFeePeriodWear"] = "Wardrobe - Fee PeriodWear";
    EstimateFeeType["StudioZoneTravelFee"] = "Studio Zone Travel Fee";
    EstimateFeeType["AuditionScratchTrackFee"] = "Audition Scratch Track Fee";
    EstimateFeeType["LineMemorizationFee"] = "Line Memorization Fee";
    EstimateFeeType["DancersHazardFee1stDay"] = "Dancers Hazard Fee - 1st Day";
    EstimateFeeType["DancersHazardFeeAdditionalDays"] = "Dancers Hazard Fee - Additional Days";
    EstimateFeeType["DancersFootwearFee"] = "Dancers Footwear Fee";
    EstimateFeeType["StuntAdjustmentFee"] = "Stunt Adjustment Fee";
    EstimateFeeType["FlightInsuranceFee"] = "Flight Insurance Fee";
    EstimateFeeType["GroupContractorFee"] = "Group Contractor Fee";
    EstimateFeeType["GroupContractorFee3To5"] = "Group Contractor Fee - 3 To 5";
    EstimateFeeType["GroupContractorFee6To8"] = "Group Contractor Fee - 6 To 8";
    EstimateFeeType["GroupContractorFee9Plus"] = "Group Contractor Fee - 9 Plus";
    EstimateFeeType["PilotSessionFeeStudio"] = "Pilot Session Fee - Studio";
    EstimateFeeType["PilotSessionFeeOnLocation"] = "Pilot Session Fee - On Location";
    EstimateFeeType["WetSnowSmokeDustWorkAllowance"] = "Wet/Snow/Smoke/Dust Work Allowance";
})($89bfb263437d71f4$var$EstimateFeeType || (module.exports.EstimateFeeType = $89bfb263437d71f4$var$EstimateFeeType = {}));

});

parcelRegister("8IRZr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GroupSubscriptionStatus = module.exports.GroupType = void 0;
var $659c501a31a4f010$var$GroupType;
(function(GroupType) {
    GroupType["ADVERTISER"] = "advertiser";
    GroupType["AD_AGENCY"] = "ad_agency";
    GroupType["PRODUCTION_COMPANY"] = "production_company";
    GroupType["TALENT"] = "talent";
    GroupType["TALENT_AGENCY"] = "talent_agency";
})($659c501a31a4f010$var$GroupType || (module.exports.GroupType = $659c501a31a4f010$var$GroupType = {}));
var $659c501a31a4f010$var$GroupSubscriptionStatus;
(function(GroupSubscriptionStatus) {
    GroupSubscriptionStatus["PENDING_PAYMENT"] = "pending_payment";
    GroupSubscriptionStatus["TRIALING"] = "trialing";
    GroupSubscriptionStatus["ACTIVE"] = "active";
    GroupSubscriptionStatus["PAST_DUE"] = "past_due";
    GroupSubscriptionStatus["CANCELED"] = "canceled";
})($659c501a31a4f010$var$GroupSubscriptionStatus || (module.exports.GroupSubscriptionStatus = $659c501a31a4f010$var$GroupSubscriptionStatus = {}));

});

parcelRegister("dGvVu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HoldingFeeCycleStatus = void 0;
var $9f67f6830a3a22d4$var$HoldingFeeCycleStatus;
(function(HoldingFeeCycleStatus) {
    HoldingFeeCycleStatus["PAID"] = "Paid";
    HoldingFeeCycleStatus["WAIVED"] = "Waived";
})($9f67f6830a3a22d4$var$HoldingFeeCycleStatus || (module.exports.HoldingFeeCycleStatus = $9f67f6830a3a22d4$var$HoldingFeeCycleStatus = {}));

});

parcelRegister("4FVeo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5DU5Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StudioZone = module.exports.Airport = module.exports.LocationType = void 0;
/**
 * Location Type
 *
 * "Nearby" is a location where you return to the reporting site at EOD
 * "Distant" is a location that requires an overnight stay
 */ var $41bc1b352bc6b1e9$var$LocationType;
(function(LocationType) {
    LocationType["Studio"] = "Studio";
    LocationType["Nearby"] = "Nearby";
    LocationType["Distant"] = "Distant";
    LocationType["Airport"] = "Airport";
})($41bc1b352bc6b1e9$var$LocationType || (module.exports.LocationType = $41bc1b352bc6b1e9$var$LocationType = {}));
/**
 * Airports
 */ var $41bc1b352bc6b1e9$var$Airport;
(function(Airport) {
    Airport["LaGuardia"] = "LaGuardia";
    Airport["JFK"] = "JFK";
    Airport["Newark"] = "Newark";
    Airport["LAX"] = "LAX";
})($41bc1b352bc6b1e9$var$Airport || (module.exports.Airport = $41bc1b352bc6b1e9$var$Airport = {}));
/**
 * Studio Zones
 */ var $41bc1b352bc6b1e9$var$StudioZone;
(function(StudioZone) {
    StudioZone["NewYork"] = "New York";
    StudioZone["NewYorkCity"] = "New York City";
    StudioZone["LosAngeles"] = "Los Angeles";
})($41bc1b352bc6b1e9$var$StudioZone || (module.exports.StudioZone = $41bc1b352bc6b1e9$var$StudioZone = {}));

});

parcelRegister("iOnLV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cwedk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PerformerContractType = module.exports.PerformerOnboardingStatus = module.exports.PerformerContractStatus = module.exports.PaymentType = void 0;
var $91d37fcf20c6a580$var$PaymentType;
(function(PaymentType) {
    PaymentType["SessionFee"] = "Session Fee";
    PaymentType["Reuse"] = "Reuse";
    PaymentType["HoldingFee"] = "Holding Fee";
    PaymentType["Other"] = "Other";
})($91d37fcf20c6a580$var$PaymentType || (module.exports.PaymentType = $91d37fcf20c6a580$var$PaymentType = {}));
var $91d37fcf20c6a580$var$PerformerContractStatus;
(function(PerformerContractStatus) {
    PerformerContractStatus["Draft"] = "draft";
    PerformerContractStatus["Pending"] = "pending";
    PerformerContractStatus["Sent"] = "sent";
    PerformerContractStatus["PerformerSigned"] = "performer_signed";
    PerformerContractStatus["ProducerSigned"] = "producer_signed";
    PerformerContractStatus["Completed"] = "completed";
    PerformerContractStatus["TimeLogApproved"] = "time_log_approved";
    PerformerContractStatus["Cancelled"] = "cancelled";
    PerformerContractStatus["Declined"] = "declined";
})($91d37fcf20c6a580$var$PerformerContractStatus || (module.exports.PerformerContractStatus = $91d37fcf20c6a580$var$PerformerContractStatus = {}));
var $91d37fcf20c6a580$var$PerformerOnboardingStatus;
(function(PerformerOnboardingStatus) {
    PerformerOnboardingStatus["Cancelled"] = "cancelled";
    PerformerOnboardingStatus["NotStarted"] = "not_started";
    PerformerOnboardingStatus["Invited"] = "invited";
    PerformerOnboardingStatus["InvitationAccepted"] = "invitation_accepted";
    PerformerOnboardingStatus["Completed"] = "completed";
})($91d37fcf20c6a580$var$PerformerOnboardingStatus || (module.exports.PerformerOnboardingStatus = $91d37fcf20c6a580$var$PerformerOnboardingStatus = {}));
var $91d37fcf20c6a580$var$PerformerContractType;
(function(PerformerContractType) {
    PerformerContractType["Exhibit1"] = "Exhibit1";
    PerformerContractType["Exhibit2"] = "Exhibit2";
})($91d37fcf20c6a580$var$PerformerContractType || (module.exports.PerformerContractType = $91d37fcf20c6a580$var$PerformerContractType = {}));

});

parcelRegister("44dve", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropType = void 0;
/**
 * Prop Type
 */ var $2f62028725190b11$var$PropType;
(function(PropType) {
    PropType["Automobile"] = "Automobile";
    PropType["Trailer"] = "Trailer";
    PropType["Motorcycle"] = "Motorcycle";
    PropType["Skates"] = "Skates";
    PropType["Skateboard"] = "Skateboard";
    PropType["Bicycle"] = "Bicycle";
    PropType["Moped"] = "Moped";
    PropType["Camera"] = "Camera";
    PropType["Pet"] = "Pet";
    PropType["Footwear"] = "Footwear";
    PropType["Luggage"] = "Luggage";
    PropType["GolfClubs"] = "Golf Clubs";
    PropType["GolfBag"] = "GolfBag";
    PropType["TennisRacquet"] = "Tennis Racquet";
    PropType["Skis"] = "Skis";
    PropType["Binoculars"] = "Binoculars";
    PropType["OperaGlasses"] = "Opera Glasses";
    PropType["LargePortableRadio"] = "Large Portable Radio";
    PropType["Book"] = "Book";
    PropType["Laptop"] = "Laptop";
    PropType["CellPhone"] = "CellPhone";
    PropType["Tablet"] = "Tablet";
    PropType["PDA"] = "PDA";
    PropType["MP3Player"] = "MP3 Player";
    PropType["Other"] = "Other";
})($2f62028725190b11$var$PropType || (module.exports.PropType = $2f62028725190b11$var$PropType = {}));

});

parcelRegister("fZjBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RightType = module.exports.RightStatus = void 0;
var $ba3bc31c6f582de0$var$RightStatus;
(function(RightStatus) {
    RightStatus["ACTIVE"] = "Active";
    RightStatus["RELEASED"] = "Released";
    RightStatus["EXPIRED"] = "Expired";
})($ba3bc31c6f582de0$var$RightStatus || (module.exports.RightStatus = $ba3bc31c6f582de0$var$RightStatus = {}));
var $ba3bc31c6f582de0$var$RightType;
(function(RightType) {
    RightType["TWO_D_ARTWORK"] = "2D Artwork";
    RightType["CELEBRITY_GUARANTEE"] = "Celebrity Guarantee";
    RightType["CHARACTER_LICENSE"] = "Character License";
    RightType["CLEARANCE_LIMITATION"] = "Clearance Limitation";
    RightType["CUSTOMER_PROVIDED_MATERIALS"] = "Customer Provided Materials";
    RightType["DORMANCY_FEES"] = "Dormancy Fees";
    RightType["FILM_FOOTAGE_LICENSE"] = "Film Footage License";
    RightType["FONT_LICENSE"] = "Font License";
    RightType["ILLUSTRATOR"] = "Illustrator";
    RightType["INFLUENCER"] = "Influencer";
    RightType["MUSIC_DEMO_FEE"] = "Music Demo Fee";
    RightType["MUSIC_MASTER_LICENSE"] = "Music Master License";
    RightType["MUSIC_PUBLISHING_LICENSE"] = "Music Publishing License";
    RightType["MUSIC_MASTER_AND_PUBLISHING_LICENSE"] = "Music Master and Publishing License";
    RightType["NON_UNION_BACKGROUND_EXTRA"] = "Non-Union Background Extra";
    RightType["NON_UNION_CHARACTER_VOICE"] = "Non-Union Character Voice";
    RightType["NON_UNION_DRIVER"] = "Non-Union Driver";
    RightType["NON_UNION_FEATURED_EXTRA"] = "Non-Union Featured Extra";
    RightType["NON_UNION_INFLUENCER"] = "Non-Union Influencer";
    RightType["NON_UNION_ON_CAMERA_PRINCIPAL"] = "Non-Union On-Camera Principal";
    RightType["NON_UNION_OTHER"] = "Non-Union Other";
    RightType["NON_UNION_VOICEOVER"] = "Non-Union Voiceover";
    RightType["NON_UNION_AGREEMENT"] = "Non-Union Agreement";
    RightType["ORIGINAL_MUSIC_LICENSE"] = "Original Music License";
    RightType["ORIGINAL_MUSIC_NON_AFM"] = "Original Music (Non-AFM)";
    RightType["OTHER"] = "Other";
    RightType["PHOTOGRAPHER"] = "Photographer";
    RightType["PRINCIPAL_MODEL"] = "Principal Model";
    RightType["PROMOTIONAL_LICENSE"] = "Promotional License";
    RightType["RIGHT_OF_PUBLICITY"] = "Right of Publicity";
    RightType["SPORTING_EVENT_FOOTAGE_LICENSE"] = "Sporting Event Footage License";
    RightType["STOCK_ARTWORK_2D"] = "Stock Artwork (2D)";
    RightType["STOCK_FILM_FOOTAGE"] = "Stock Film Footage";
    RightType["STOCK_MUSIC"] = "Stock Music";
    RightType["STOCK_PHOTO"] = "Stock Photo";
    RightType["TERM_GUARANTEE"] = "Term Guarantee";
    RightType["UNION_TALENT"] = "Union Talent";
})($ba3bc31c6f582de0$var$RightType || (module.exports.RightType = $ba3bc31c6f582de0$var$RightType = {}));

});

parcelRegister("1EySh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sessionEstimateItemTitles = module.exports.SessionEstimateItemUnitType = void 0;

var $26j5B = parcelRequire("26j5B");

var $b8BS9 = parcelRequire("b8BS9");
/**
 * Estimate Unit Types
 */ var $1344943489aa71a8$var$SessionEstimateItemUnitType;
(function(SessionEstimateItemUnitType) {
    SessionEstimateItemUnitType["Hours"] = "hours";
    SessionEstimateItemUnitType["Miles"] = "miles";
    SessionEstimateItemUnitType["Days"] = "days";
    SessionEstimateItemUnitType["Count"] = "count";
    SessionEstimateItemUnitType["CostumeChanges"] = "costume changes";
    SessionEstimateItemUnitType["Tags"] = "tags";
    SessionEstimateItemUnitType["Doubles"] = "doubles";
})($1344943489aa71a8$var$SessionEstimateItemUnitType || (module.exports.SessionEstimateItemUnitType = $1344943489aa71a8$var$SessionEstimateItemUnitType = {}));
/**
 * Titles
 */ // Web version
module.exports.sessionEstimateItemTitles = {
    [$26j5B.WorkTimeType.StraightTime]: 'Straight Time',
    [$26j5B.WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
    [$26j5B.WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
    [$26j5B.WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
    [$26j5B.SessionActivityType.WorkTimeSaturday]: '(Saturday Premium)',
    [$26j5B.SessionActivityType.WorkTimeSunday]: '(Sunday Premium)',
    [$26j5B.SessionActivityType.WorkTimeHoliday]: '(Holiday Premium)',
    [$b8BS9.SessionDayType.Saturday]: '(Saturday Premium)',
    [$b8BS9.SessionDayType.Sunday]: '(Sunday Premium)',
    [$b8BS9.SessionDayType.Holiday]: '(Holiday Premium)',
    Weekend: '(Weekend Premium)',
    [$26j5B.SessionActivityType.WorkTimeNight]: '(Night Premium)',
    [$26j5B.SessionActivityType.WorkTimeLateNight]: '(Late Night Premium)',
    [$26j5B.SessionActivityType.TravelToLocationAfterMidnight]: '(Travel After Midnight)',
    [$26j5B.SessionActivityType.TravelFromLocationAfterMidnight]: '(Travel After Midnight)',
    [$26j5B.SessionActivityTimeOfDay.Night]: '(Night Premium)',
    [$26j5B.SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)',
    [$26j5B.SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)'
}; // API version
 // export const sessionEstimateItemTitles: Record<string, string> = {
 //   [WorkTimeType.StraightTime]: 'Straight Time',
 //   [WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
 //   [WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
 //   [WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
 //   [SessionDayType.Saturday]: '(Saturday Premium)',
 //   [SessionDayType.Sunday]: '(Sunday Premium)',
 //   [SessionDayType.Holiday]: '(Holiday Premium)',
 //   Weekend: '(Weekend Premium)',
 //   [SessionActivityTimeOfDay.Night]: '(Night Premium)',
 //   [SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)',
 //   [SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)',
 // };

});

parcelRegister("b9FdQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CreditPurchaseStatus = module.exports.TimeEntryType = module.exports.TalentManagerEngagementStatus = module.exports.TalentManagerApprovalStatus = void 0;
var $81f082db8c90b4c6$var$TalentManagerApprovalStatus;
(function(TalentManagerApprovalStatus) {
    TalentManagerApprovalStatus["PENDING"] = "pending";
    TalentManagerApprovalStatus["APPROVED"] = "approved";
    TalentManagerApprovalStatus["SUSPENDED"] = "suspended";
})($81f082db8c90b4c6$var$TalentManagerApprovalStatus || (module.exports.TalentManagerApprovalStatus = $81f082db8c90b4c6$var$TalentManagerApprovalStatus = {}));
var $81f082db8c90b4c6$var$TalentManagerEngagementStatus;
(function(TalentManagerEngagementStatus) {
    TalentManagerEngagementStatus["ACTIVE"] = "active";
    TalentManagerEngagementStatus["PAUSED"] = "paused";
    TalentManagerEngagementStatus["COMPLETED"] = "completed";
    TalentManagerEngagementStatus["CANCELLED"] = "cancelled";
})($81f082db8c90b4c6$var$TalentManagerEngagementStatus || (module.exports.TalentManagerEngagementStatus = $81f082db8c90b4c6$var$TalentManagerEngagementStatus = {}));
var $81f082db8c90b4c6$var$TimeEntryType;
(function(TimeEntryType) {
    TimeEntryType["CHAT_AUTO"] = "chatAuto";
    TimeEntryType["MANUAL"] = "manual";
})($81f082db8c90b4c6$var$TimeEntryType || (module.exports.TimeEntryType = $81f082db8c90b4c6$var$TimeEntryType = {}));
var $81f082db8c90b4c6$var$CreditPurchaseStatus;
(function(CreditPurchaseStatus) {
    CreditPurchaseStatus["PENDING"] = "pending";
    CreditPurchaseStatus["COMPLETED"] = "completed";
    CreditPurchaseStatus["REFUNDED"] = "refunded";
})($81f082db8c90b4c6$var$CreditPurchaseStatus || (module.exports.CreditPurchaseStatus = $81f082db8c90b4c6$var$CreditPurchaseStatus = {}));

});

parcelRegister("7Qz5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UsageEstimateItemUnitType = void 0;
/**
 * Estimate Unit Types
 */ var $5b689b5615addf7a$var$UsageEstimateItemUnitType;
(function(UsageEstimateItemUnitType) {
    UsageEstimateItemUnitType["Hours"] = "Hours";
    UsageEstimateItemUnitType["Days"] = "Days";
    UsageEstimateItemUnitType["Count"] = "Count";
})($5b689b5615addf7a$var$UsageEstimateItemUnitType || (module.exports.UsageEstimateItemUnitType = $5b689b5615addf7a$var$UsageEstimateItemUnitType = {}));

});

parcelRegister("bof2l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.usageTypeData = module.exports.commercialUsageTypes = module.exports.UsageType = module.exports.UsageTypeCategory = module.exports.AudioMadeMove = module.exports.CableMarket = module.exports.GlobalMarket = module.exports.UsesType = module.exports.UsageLanguage = module.exports.MarketSpecification = module.exports.UsagePlatform = module.exports.MediaCategory = module.exports.UsageCycleUnit = module.exports.UsageCycleNumber = module.exports.UsageCities = module.exports.UsageUnitType = void 0;

var $lAQjl = parcelRequire("lAQjl");
/**
 * Usage Unit Type
 */ var $84ad999612a77d51$var$UsageUnitType;
(function(UsageUnitType) {
    UsageUnitType["Uses"] = "Uses";
    UsageUnitType["Cities"] = "Cities";
})($84ad999612a77d51$var$UsageUnitType || (module.exports.UsageUnitType = $84ad999612a77d51$var$UsageUnitType = {}));
var $84ad999612a77d51$var$UsageCities;
(function(UsageCities) {
    UsageCities["NY"] = "New York";
    UsageCities["LA"] = "Los Angeles";
    UsageCities["Chicago"] = "Chicago";
    UsageCities["Minor"] = "Minor Markets";
})($84ad999612a77d51$var$UsageCities || (module.exports.UsageCities = $84ad999612a77d51$var$UsageCities = {}));
var $84ad999612a77d51$var$UsageCycleNumber;
(function(UsageCycleNumber) {
    UsageCycleNumber[UsageCycleNumber["one"] = 1] = "one";
    UsageCycleNumber[UsageCycleNumber["four"] = 4] = "four";
    UsageCycleNumber[UsageCycleNumber["six"] = 6] = "six";
    UsageCycleNumber[UsageCycleNumber["eight"] = 8] = "eight";
    UsageCycleNumber[UsageCycleNumber["thirteen"] = 13] = "thirteen";
    UsageCycleNumber[UsageCycleNumber["twentySix"] = 26] = "twentySix";
    UsageCycleNumber[UsageCycleNumber["thirty"] = 30] = "thirty";
    UsageCycleNumber[UsageCycleNumber["thirtyOne"] = 31] = "thirtyOne";
    UsageCycleNumber[UsageCycleNumber["fiftyTwo"] = 52] = "fiftyTwo";
})($84ad999612a77d51$var$UsageCycleNumber || (module.exports.UsageCycleNumber = $84ad999612a77d51$var$UsageCycleNumber = {}));
var $84ad999612a77d51$var$UsageCycleUnit;
(function(UsageCycleUnit) {
    UsageCycleUnit["Day"] = "Day";
    UsageCycleUnit["Week"] = "Week";
    UsageCycleUnit["Month"] = "Month";
    UsageCycleUnit["Year"] = "Year";
})($84ad999612a77d51$var$UsageCycleUnit || (module.exports.UsageCycleUnit = $84ad999612a77d51$var$UsageCycleUnit = {}));
// Create base types for media category and platform
var $84ad999612a77d51$var$MediaCategory;
(function(MediaCategory) {
    MediaCategory["TV"] = "TV";
    MediaCategory["Digital"] = "Digital";
    MediaCategory["Social"] = "Social Media";
    MediaCategory["OOH"] = "Out-of-home";
    MediaCategory["Radio"] = "Radio";
})($84ad999612a77d51$var$MediaCategory || (module.exports.MediaCategory = $84ad999612a77d51$var$MediaCategory = {}));
var $84ad999612a77d51$var$UsagePlatform;
(function(UsagePlatform) {
    UsagePlatform["Linear"] = "Linear";
    UsagePlatform["Digital"] = "Digital";
    UsagePlatform["SocialWaiver"] = "Social Media Waiver";
    UsagePlatform["TheatricalIndustrial"] = "Theatrical/Industrial";
    UsagePlatform["Foreign"] = "Foreign";
    UsagePlatform["AFM"] = "AFM";
    UsagePlatform["Traditional"] = "Traditional";
    UsagePlatform["Internet"] = "Internet";
    UsagePlatform["Network"] = "Network";
    UsagePlatform["WildSpot"] = "WildSpot";
    UsagePlatform["Dealer"] = "Dealer";
})($84ad999612a77d51$var$UsagePlatform || (module.exports.UsagePlatform = $84ad999612a77d51$var$UsagePlatform = {}));
// Create a type for market specifications
var $84ad999612a77d51$var$MarketSpecification;
(function(MarketSpecification) {
    MarketSpecification["All"] = "All Markets";
    MarketSpecification["NoNYChiLA"] = "All Markets (No NY/CHI/LA)";
    MarketSpecification["NoMajor"] = "No Major Markets";
    MarketSpecification["NYOnly"] = "NY Only";
    MarketSpecification["LAOrChicago"] = "LA Or Chicago Only";
    MarketSpecification["TwoOfLANYChicago"] = "2 Of LA, NY, Chicago";
    MarketSpecification["LANYAndChicago"] = "LA, NY, And Chicago";
    MarketSpecification["WithNY"] = "With NY";
    MarketSpecification["WithoutNY"] = "Without NY";
})($84ad999612a77d51$var$MarketSpecification || (module.exports.MarketSpecification = $84ad999612a77d51$var$MarketSpecification = {}));
var $84ad999612a77d51$var$UsageLanguage;
(function(UsageLanguage) {
    UsageLanguage["English"] = "English";
    UsageLanguage["Spanish"] = "Spanish";
    UsageLanguage["Japanese"] = "Japanese";
    UsageLanguage["Other"] = "Other";
})($84ad999612a77d51$var$UsageLanguage || (module.exports.UsageLanguage = $84ad999612a77d51$var$UsageLanguage = {}));
var $84ad999612a77d51$var$UsesType;
(function(UsesType) {
    UsesType["Unlimited"] = "Unlimited Use";
    UsesType["PerUse"] = "Per Use";
    UsesType["AcrossTheBoard"] = "Across The Board";
})($84ad999612a77d51$var$UsesType || (module.exports.UsesType = $84ad999612a77d51$var$UsesType = {}));
var $84ad999612a77d51$var$GlobalMarket;
(function(GlobalMarket) {
    GlobalMarket["Americas"] = "Americas";
    GlobalMarket["Caribbean"] = "Caribbean";
    GlobalMarket["AmericasAndCaribbean"] = "Americas And Caribbean";
    GlobalMarket["UK"] = "United Kingdom";
    GlobalMarket["Europe"] = "Europe";
    GlobalMarket["AsiaPacific"] = "Asia Pacific";
    GlobalMarket["Japan"] = "Japan";
    GlobalMarket["RestOfWorld"] = "Rest Of World";
    GlobalMarket["Worldwide"] = "Worldwide";
})($84ad999612a77d51$var$GlobalMarket || (module.exports.GlobalMarket = $84ad999612a77d51$var$GlobalMarket = {}));
var $84ad999612a77d51$var$CableMarket;
(function(CableMarket) {
    CableMarket["NationalCable"] = "National Cable";
    CableMarket["LocalCableUpTo1MSubscribers"] = "Local Cable (Up To 1M Subscribers)";
    CableMarket["LocalCable1MTo2MSubscribers"] = "Local Cable (1M To 2M Subscribers)";
    CableMarket["LocalCable2MPlusSubscribers"] = "Local Cable (2M Plus Subscribers)";
})($84ad999612a77d51$var$CableMarket || (module.exports.CableMarket = $84ad999612a77d51$var$CableMarket = {}));
var $84ad999612a77d51$var$AudioMadeMove;
(function(AudioMadeMove) {
    AudioMadeMove["MoveOver"] = "Move Over";
    AudioMadeMove["MadeFor"] = "Made For";
})($84ad999612a77d51$var$AudioMadeMove || (module.exports.AudioMadeMove = $84ad999612a77d51$var$AudioMadeMove = {}));
var $84ad999612a77d51$var$UsageTypeCategory;
(function(UsageTypeCategory) {
    UsageTypeCategory["NationalNetworks"] = "National Networks (Class A)";
    UsageTypeCategory["Cable"] = "Cable";
    UsageTypeCategory["NationalCable"] = "National Cable";
    UsageTypeCategory["SingleNetwork"] = "National Cable Single Network";
    UsageTypeCategory["LocalCable"] = "Local Cable";
    UsageTypeCategory["Wildspot"] = "Wildspot";
    UsageTypeCategory["Dealer"] = "Dealer";
    UsageTypeCategory["AllOtherNA"] = "All Other North American Use";
    UsageTypeCategory["SpanishLanguageProgramUse"] = "Spanish-Language Program Use";
    UsageTypeCategory["IONAndDiginet"] = "ION & Diginet";
    UsageTypeCategory["ForeignUse"] = "Foreign Use";
    UsageTypeCategory["TraditionalDigital"] = "Traditional Digital";
    UsageTypeCategory["TraditionalDigitalWithYouTube"] = "Traditional Digital w/YouTube";
    UsageTypeCategory["StreamingPlatforms"] = "Streaming Platforms";
    UsageTypeCategory["SocialMedia"] = "Social Media";
    UsageTypeCategory["YouTube"] = "YouTube";
    UsageTypeCategory["OtherPlatforms"] = "Gaming Platforms, VR/AR, Emerging Platforms";
    UsageTypeCategory["Print"] = "Print Use";
    UsageTypeCategory["OOH"] = "Out of Home Use";
    UsageTypeCategory["BTS"] = "B-roll & Behind the Scenes Use";
    UsageTypeCategory["TheatricalIndustrial"] = "Theatrical & Industrial Use";
    UsageTypeCategory["AFMSession"] = "AFM Session (1 hour)";
    UsageTypeCategory["AFMFirstUse"] = "AFM First Use";
    UsageTypeCategory["AFMForeign"] = "AFM Foreign Use";
    UsageTypeCategory["AFMInternetRadio"] = "AFM Internet Radio Spot";
    UsageTypeCategory["RadioNetwork"] = "Radio Network";
    UsageTypeCategory["RadioWildspot"] = "Radio Wildspot";
    UsageTypeCategory["InternetRadio"] = "Internet Radio";
    UsageTypeCategory["RadioDealer"] = "Radio Dealer";
})($84ad999612a77d51$var$UsageTypeCategory || (module.exports.UsageTypeCategory = $84ad999612a77d51$var$UsageTypeCategory = {}));
// Very large enum - includes all usage types
// NOTE: The full UsageType enum is defined in apps/api/src/types/usage-types.ts
// and re-exported from there. We only include the enum declaration here for entity types.
var $84ad999612a77d51$var$UsageType;
(function(UsageType) {
    UsageType["TV_LinearDomestic_Network_ClassA_Per_Use"] = "TV Linear Domestic Network Class A (Per Use)";
    UsageType["TV_LinearDomestic_Network_ClassA_13_Week_Maximum"] = "TV Linear Domestic Network Class A (13 Weeks Maximum)";
    UsageType["TV_LinearDomestic_IONAndDiginet_Per_Use"] = "TV Linear Domestic ION And Diginet Per Use";
    UsageType["TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use"] = "TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_4_Week"] = "TV Spanish Language Program (4 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_13_Week"] = "TV Spanish Language Program (13 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_52_Week"] = "TV Spanish Language Program (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_4_Week"] = "TV Linear Domestic Wild Spot All Markets (4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_13_Week"] = "TV Linear Domestic Wild Spot All Markets (13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_52_Week"] = "TV Linear Domestic Wild Spot All Markets (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_4_Week"] = "TV Linear Domestic National Cable (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_13_Week"] = "TV Linear Domestic National Cable (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_52_Week"] = "TV Linear Domestic National Cable (52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_4_Week"] = "TV Linear Domestic National Cable Single Network (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_13_Week"] = "TV Linear Domestic National Cable Single Network (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_52_Week"] = "TV Linear Domestic National Cable Single Network (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_4_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_13_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_52_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_Dealer_4_Week"] = "TV Linear Domestic Dealer (4 Week)";
    UsageType["TV_LinearDomestic_Dealer_13_Week"] = "TV Linear Domestic Dealer (13 Week)";
    UsageType["TV_LinearDomestic_Dealer_52_Week"] = "TV Linear Domestic Dealer (52 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_4_Week"] = "TV Linear Domestic All Other NA Linear (4 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_13_Week"] = "TV Linear Domestic All Other NA Linear (13 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_52_Week"] = "TV Linear Domestic All Other NA Linear (52 Week)";
    UsageType["TV_TheatricalIndustrial_Up_To_30_Days"] = "TV Theatrical Industrial (Up To 30 Days)";
    UsageType["TV_TheatricalIndustrial_Use_Through_MPU"] = "TV Theatrical Industrial (Use Through MPU)";
    UsageType["TV_TheatricalIndustrial_Dist_On_Physical_Media"] = "TV Theatrical Industrial (Dist On Physical Media)";
    UsageType["TV_Digital_StreamingPlatforms_4_Week"] = "TV Digital Streaming Platforms (4 Week)";
    UsageType["TV_Digital_StreamingPlatforms_13_Week"] = "TV Digital Streaming Platforms (13 Week)";
    UsageType["TV_Digital_StreamingPlatforms_52_Week"] = "TV Digital Streaming Platforms (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_4_Week"] = "TV Digital Traditional Digital (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_13_Week"] = "TV Digital Traditional Digital (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_52_Week"] = "TV Digital Traditional Digital (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_4_Week"] = "TV Digital Traditional Digital w/YouTube (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_13_Week"] = "TV Digital Traditional Digital w/YouTube (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_52_Week"] = "TV Digital Traditional Digital w/YouTube (52 Week)";
    UsageType["TV_Digital_SocialMedia_30_Day_Cycle"] = "Social Media Waiver - Social Media (30 Day Cycle)";
    UsageType["TV_Digital_SocialMedia_YouTube"] = "Social Media Waiver - YouTube";
    UsageType["TV_Digital_GamingVRAREmergingPlatforms"] = "TV Digital Gaming VR/AR, Emerging Platforms";
    UsageType["TV_ForeignUse_UK"] = "TV Foreign Use - U.K.";
    UsageType["TV_ForeignUse_Europe"] = "TV Foreign Use - Europe";
    UsageType["TV_ForeignUse_AsiaPacific"] = "TV Foreign Use - Asia/Pacific";
    UsageType["TV_ForeignUse_Japan"] = "TV Foreign Use - Japan";
    UsageType["TV_ForeignUse_RestOfWorld"] = "TV Foreign Use - Rest-of-World";
    UsageType["TV_ForeignUse_Worldwide"] = "TV Foreign Use - Worldwide";
    UsageType["TV_ForeignUse_SpanishLanguage_Americas"] = "TV Foreign Use - Spanish Language (Americas)";
    UsageType["TV_ForeignUse_SpanishLanguage_Caribbean"] = "TV Foreign Use - Spanish Language (Caribbean)";
    UsageType["TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean"] = "TV Foreign Use - Spanish Language (Americas And Caribbean)";
    UsageType["TV_ForeignUse_Other_UK"] = "TV Foreign Use - Other (UK)";
    UsageType["TV_ForeignUse_Other_Japan"] = "TV Foreign Use - Other (Japan)";
    UsageType["TV_ForeignUse_Other_Europe"] = "TV Foreign Use - Other (Europe)";
    UsageType["TV_ForeignUse_Other_RestOfWorld"] = "TV Foreign Use - Other (Rest Of World)";
    UsageType["TV_ForeignUse_Other_AsiaPacific"] = "TV Foreign Use - Other (Asia Pacific)";
    UsageType["TV_ForeignUse_Other_Worldwide"] = "TV Foreign Use - Other (Worldwide)";
    UsageType["TV_AFM_FirstUse_InternetOnlyOrUS"] = "TV AFM First Use (Internet Only Or US)";
    UsageType["TV_AFM_Foreign_1_Year_Europe_NoEurope"] = "TV AFM Foreign - 1 Year (Europe/No Europe)";
    UsageType["TV_AFM_Foreign_Worldwide"] = "TV AFM Foreign (Worldwide)";
    UsageType["Radio_AFM_RadioSpot_Internet_8_Week"] = "Radio AFM Radio Spot - Internet (8 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_26_Week"] = "Radio AFM Radio Spot - Internet (26 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_52_Week"] = "Radio AFM Radio Spot - Internet (52 Week)";
    UsageType["Radio_Network_1_Week_Unlimited_Use"] = "Radio Network - 1 Week Unlimited Use";
    UsageType["Radio_Network_4_Weeks_Unlimited_Use"] = "Radio Network - 4 Week Unlimited Use";
    UsageType["Radio_Network_8_Weeks_Unlimited_Use"] = "Radio Network - 8 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_Unlimited_Use"] = "Radio Network - 13 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_26_Uses"] = "Radio Network - 13 Weeks 26 Uses";
    UsageType["Radio_Network_13_Week_39_Uses"] = "Radio Network - 13 Weeks 39 Uses";
    UsageType["Radio_Network_13_Week_Across_The_Board_Use"] = "Radio Network - 13 Weeks Across The Board Use";
    UsageType["Radio_WildSpot_8_Week_No_Major_Markets"] = "Radio Wild Spot - 8 Week (No Major Markets)";
    UsageType["Radio_WildSpot_8_Week_NY_Only"] = "Radio Wild Spot - 8 Week (NY Only)";
    UsageType["Radio_WildSpot_8_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 8 Week (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_8_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 8 Week (LA, NY, And Chicago)";
    UsageType["Radio_WildSpot_13_Week_No_Major_Markets"] = "Radio Wild Spot - 13 Weeks (No Major Markets)";
    UsageType["Radio_WildSpot_13_Week_NY_Only"] = "Radio Wild Spot - 13 Weeks (NY Only)";
    UsageType["Radio_WildSpot_13_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 13 Weeks (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_13_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 13 Weeks (LA, NY, And Chicago)";
    UsageType["Radio_Internet_4_Week"] = "Radio Internet - 4 Week";
    UsageType["Radio_Internet_8_Week_Move_Over"] = "Radio Internet - 8 Week Move Over";
    UsageType["Radio_Internet_8_Week_Made_For"] = "Radio Internet - 8 Week Made For";
    UsageType["Radio_Internet_1_Year_Move_Over"] = "Radio Internet - 1 Year Move Over";
    UsageType["Radio_Internet_1_Year_Made_For"] = "Radio Internet - 1 Year Made For";
    UsageType["Radio_Dealer_8_Week"] = "Radio Dealer - 8 Week";
    UsageType["Radio_Dealer_6_Months"] = "Radio Dealer - 6 Months";
})($84ad999612a77d51$var$UsageType || (module.exports.UsageType = $84ad999612a77d51$var$UsageType = {}));
module.exports.commercialUsageTypes = {
    [$lAQjl.CommercialType.TV]: [
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Network_ClassA_Per_Use,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_52_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week,
        $84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week,
        $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Up_To_30_Days,
        $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Use_Through_MPU,
        $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media,
        $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_4_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_13_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_52_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_4_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_13_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_52_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_30_Day_Cycle,
        $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_YouTube,
        $84ad999612a77d51$var$UsageType.TV_Digital_GamingVRAREmergingPlatforms,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_UK,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Europe,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_AsiaPacific,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Japan,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_RestOfWorld,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Worldwide,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_Americas,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_Caribbean,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_UK,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Japan,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Europe,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_RestOfWorld,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_AsiaPacific,
        $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Worldwide,
        $84ad999612a77d51$var$UsageType.TV_AFM_FirstUse_InternetOnlyOrUS,
        $84ad999612a77d51$var$UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope,
        $84ad999612a77d51$var$UsageType.TV_AFM_Foreign_Worldwide
    ],
    [$lAQjl.CommercialType.Digital]: [
        $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_4_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_13_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_52_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_4_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_13_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_52_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week,
        $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_30_Day_Cycle,
        $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_YouTube,
        $84ad999612a77d51$var$UsageType.TV_Digital_GamingVRAREmergingPlatforms
    ],
    [$lAQjl.CommercialType.Social]: [
        $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_30_Day_Cycle,
        $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_YouTube
    ],
    [$lAQjl.CommercialType.OOH]: [
        $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Up_To_30_Days,
        $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Use_Through_MPU,
        $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media
    ],
    [$lAQjl.CommercialType.Radio]: [
        $84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_8_Week,
        $84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_26_Week,
        $84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_52_Week,
        $84ad999612a77d51$var$UsageType.Radio_Network_1_Week_Unlimited_Use,
        $84ad999612a77d51$var$UsageType.Radio_Network_4_Weeks_Unlimited_Use,
        $84ad999612a77d51$var$UsageType.Radio_Network_8_Weeks_Unlimited_Use,
        $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_Unlimited_Use,
        $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_26_Uses,
        $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_39_Uses,
        $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_Across_The_Board_Use,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_No_Major_Markets,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_NY_Only,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_No_Major_Markets,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_NY_Only,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago,
        $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago,
        $84ad999612a77d51$var$UsageType.Radio_Internet_4_Week,
        $84ad999612a77d51$var$UsageType.Radio_Internet_8_Week_Move_Over,
        $84ad999612a77d51$var$UsageType.Radio_Internet_8_Week_Made_For,
        $84ad999612a77d51$var$UsageType.Radio_Internet_1_Year_Move_Over,
        $84ad999612a77d51$var$UsageType.Radio_Internet_1_Year_Made_For,
        $84ad999612a77d51$var$UsageType.Radio_Dealer_8_Week,
        $84ad999612a77d51$var$UsageType.Radio_Dealer_6_Months
    ],
    [$lAQjl.CommercialType.BTS]: [],
    [$lAQjl.CommercialType.Other]: [],
    [$lAQjl.CommercialType.Print]: []
};
module.exports.usageTypeData = {
    /**
     * TV - Network Class A
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_Network_ClassA_Per_Use]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Network_ClassA_Per_Use,
        label: 'Domestic Network Class A',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalNetworks,
        usesType: $84ad999612a77d51$var$UsesType.PerUse,
        perUse: true,
        specialAttributes: [
            'Domestic',
            'Network',
            'Class A'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Network_ClassA_13_Week_Maximum,
        label: 'Network Class A (13 Weeks Maximum)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalNetworks,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Network',
            'Class A'
        ]
    },
    /**
     * TV - ION & DigiNet
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_IONAndDiginet_Per_Use,
        label: 'ION And Diginet Per Use',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.IONAndDiginet,
        usesType: $84ad999612a77d51$var$UsesType.PerUse,
        perUse: true,
        specialAttributes: [
            'Domestic',
            'ION And Diginet'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use,
        label: 'ION And Diginet (13 Weeks Unlimited Use)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.IONAndDiginet,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'ION And Diginet'
        ]
    },
    /**
     * TV - Spanish Language Program
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_4_Week,
        label: 'Spanish Language Program (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.SpanishLanguageProgramUse,
        language: $84ad999612a77d51$var$UsageLanguage.Spanish,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Spanish Language Program'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_13_Week,
        label: 'Spanish Language Program (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.SpanishLanguageProgramUse,
        language: $84ad999612a77d51$var$UsageLanguage.Spanish,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Spanish Language Program'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_SpanishLanguageProgram_52_Week,
        label: 'Spanish Language Program (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.SpanishLanguageProgramUse,
        language: $84ad999612a77d51$var$UsageLanguage.Spanish,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Spanish Language Program'
        ]
    },
    /**
     * TV - WildSpot
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_4_Week,
        label: 'Wild Spot All Markets (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Wildspot,
        marketSpec: $84ad999612a77d51$var$MarketSpecification.All,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_13_Week,
        label: 'Wild Spot All Markets (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Wildspot,
        marketSpec: $84ad999612a77d51$var$MarketSpecification.All,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarkets_52_Week,
        label: 'Wild Spot All Markets (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Wildspot,
        marketSpec: $84ad999612a77d51$var$MarketSpecification.All,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week,
        label: 'Wild Spot All Markets (No NY/LA - 4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Wildspot,
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NoNYChiLA,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets',
            'No NY/LA'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week,
        label: 'Wild Spot All Markets (No NY/LA - 13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Wildspot,
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NoNYChiLA,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets',
            'No NY/LA'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week,
        label: 'Wild Spot All Markets (No NY/LA - 52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Wildspot,
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NoNYChiLA,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets',
            'No NY/LA'
        ]
    },
    /**
     * TV - National Cable
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_4_Week,
        label: 'National Cable (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.NationalCable,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_13_Week,
        label: 'National Cable (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.NationalCable,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_52_Week,
        label: 'National Cable (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.NationalCable,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable'
        ]
    },
    /**
     * TV - National Cable Single Network
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_4_Week,
        label: 'National Cable - Single Network (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.NationalCable,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable',
            'Single Network'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_13_Week,
        label: 'National Cable - Single Network (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.NationalCable,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable',
            'Single Network'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_NationalCable_SingleNetwork_52_Week,
        label: 'National Cable - Single Network (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.NationalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.NationalCable,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable',
            'Single Network'
        ]
    },
    /**
     * TV - Local Cable (Up to 1M Subs)
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_4_Week,
        label: 'Local Cable (Up to 1M Subscribers) (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCableUpTo1MSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            'Up To 1M Subscribers'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_13_Week,
        label: 'Local Cable (Up to 1M Subscribers) (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCableUpTo1MSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            'Up To 1M Subscribers'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_52_Week,
        label: 'Local Cable (Up to 1M Subscribers) (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCableUpTo1MSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            'Up To 1M Subscribers'
        ]
    },
    /**
     * TV - Local Cable (1M - 2M Subs)
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week,
        label: 'Local Cable (1M To 2M Subscribers) (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCable1MTo2MSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '1M To 2M Subscribers'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week,
        label: 'Local Cable (1M To 2M Subscribers) (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCable1MTo2MSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '1M To 2M Subscribers'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week,
        label: 'Local Cable (1M To 2M Subscribers) (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCable1MTo2MSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '1M To 2M Subscribers'
        ]
    },
    /**
     * TV - Local Cable (2M - 3M Subs)
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week,
        label: 'Local Cable (2M To 3M Subscribers) (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCable2MPlusSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '2M To 3M Subscribers'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week,
        label: 'Local Cable (2M To 3M Subscribers) (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCable2MPlusSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '2M To 3M Subscribers'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week,
        label: 'Local Cable (2M To 3M Subscribers) (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.LocalCable,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        cableMarket: $84ad999612a77d51$var$CableMarket.LocalCable2MPlusSubscribers,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '2M To 3M Subscribers'
        ]
    },
    /**
     * TV - Dealer
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_4_Week,
        label: 'Dealer (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Dealer,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Dealer'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_13_Week,
        label: 'Dealer (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Dealer,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Dealer'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_Dealer_52_Week,
        label: 'Dealer (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.Dealer,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Dealer'
        ]
    },
    /**
     * TV - All Other NA Use
     */ [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_4_Week,
        label: 'All Other NA Linear (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.AllOtherNA,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'All Other NA Linear'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_13_Week,
        label: 'All Other NA Linear (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.AllOtherNA,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'All Other NA Linear'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_LinearDomestic_AllOtherNALinear_52_Week,
        label: 'All Other NA Linear (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Linear,
        category: $84ad999612a77d51$var$UsageTypeCategory.AllOtherNA,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'All Other NA Linear'
        ]
    },
    /**
     * TV - Foreign Use
     */ [$84ad999612a77d51$var$UsageType.TV_ForeignUse_UK]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_UK,
        label: 'Foreign Use - U.K.',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.UK,
        specialAttributes: [
            'Foreign Use',
            'UK'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Japan]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Japan,
        label: 'Foreign Use - Japan',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Japan,
        specialAttributes: [
            'Foreign Use',
            'Japan'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Europe]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Europe,
        label: 'Foreign Use - Europe',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Europe,
        specialAttributes: [
            'Foreign Use',
            'Europe'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_RestOfWorld]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_RestOfWorld,
        label: 'Foreign Use - Rest-of-World',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.RestOfWorld,
        specialAttributes: [
            'Foreign Use',
            'Rest Of World'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_AsiaPacific]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_AsiaPacific,
        label: 'Foreign Use - Asia Pacific',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.AsiaPacific,
        specialAttributes: [
            'Foreign Use',
            'Asia Pacific'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Worldwide]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Worldwide,
        label: 'Foreign Use - Worldwide',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        unlimitedUse: true,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Worldwide,
        specialAttributes: [
            'Foreign Use',
            'Worldwide'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_Americas]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_Americas,
        label: 'Foreign Use - Spanish Language (Americas)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Spanish,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Americas,
        specialAttributes: [
            'Foreign Use',
            'Spanish Language'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_Caribbean]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_Caribbean,
        label: 'Foreign Use - Spanish Language (Caribbean)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Spanish,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Caribbean,
        specialAttributes: [
            'Foreign Use',
            'Spanish Language'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean,
        label: 'Foreign Use - Spanish Language (Americas And Caribbean)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Spanish,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.AmericasAndCaribbean,
        specialAttributes: [
            'Foreign Use',
            'Spanish Language'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_UK]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_UK,
        label: 'Foreign Use - Other (UK)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Other,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.UK,
        specialAttributes: [
            'Foreign Use',
            'Other',
            'UK'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Japan]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Japan,
        label: 'Foreign Use - Other (Japan)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Other,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Japan,
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Japan'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Europe]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Europe,
        label: 'Foreign Use - Other (Europe)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Other,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Europe,
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Europe'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_RestOfWorld]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_RestOfWorld,
        label: 'Foreign Use - Other (Rest Of World)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Other,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.RestOfWorld,
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Rest Of World'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_AsiaPacific]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_AsiaPacific,
        label: 'Foreign Use - Other (Asia Pacific)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Other,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.AsiaPacific,
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Asia Pacific'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Worldwide]: {
        id: $84ad999612a77d51$var$UsageType.TV_ForeignUse_Other_Worldwide,
        label: 'Foreign Use - Other (Worldwide)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.Foreign,
        category: $84ad999612a77d51$var$UsageTypeCategory.ForeignUse,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        language: $84ad999612a77d51$var$UsageLanguage.Other,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Worldwide,
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Worldwide'
        ]
    },
    /**
     * TV - AFM
     */ [$84ad999612a77d51$var$UsageType.TV_AFM_FirstUse_InternetOnlyOrUS]: {
        id: $84ad999612a77d51$var$UsageType.TV_AFM_FirstUse_InternetOnlyOrUS,
        label: 'AFM First Use (Internet Only Or US)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.AFM,
        category: $84ad999612a77d51$var$UsageTypeCategory.AFMFirstUse,
        usesType: $84ad999612a77d51$var$UsesType.PerUse,
        perUse: true,
        useLimit: {
            minimum: 1,
            maximum: 1
        },
        specialAttributes: [
            'AFM',
            'First Use'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope]: {
        id: $84ad999612a77d51$var$UsageType.TV_AFM_Foreign_1_Year_Europe_NoEurope,
        label: 'AFM Foreign - 1 Year (Europe/No Europe)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.AFM,
        category: $84ad999612a77d51$var$UsageTypeCategory.AFMForeign,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Foreign',
            '1 Year',
            'Europe/No Europe'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_AFM_Foreign_Worldwide]: {
        id: $84ad999612a77d51$var$UsageType.TV_AFM_Foreign_Worldwide,
        label: 'AFM Foreign (Worldwide)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.AFM,
        category: $84ad999612a77d51$var$UsageTypeCategory.AFMForeign,
        globalMarket: $84ad999612a77d51$var$GlobalMarket.Worldwide,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Foreign',
            'Worldwide'
        ]
    },
    /**
     * Digital - Streaming Platforms
     */ [$84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_4_Week,
        label: 'Digital Streaming Platforms (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.StreamingPlatforms,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Streaming Platforms'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_13_Week,
        label: 'Digital Streaming Platforms (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.StreamingPlatforms,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Streaming Platforms'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_StreamingPlatforms_52_Week,
        label: 'Digital Streaming Platforms (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.StreamingPlatforms,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Streaming Platforms'
        ]
    },
    /**
     * Digital - Traditional Digital (no YouTube)
     */ [$84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_4_Week,
        label: 'Digital Traditional Digital (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.TraditionalDigital,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Traditional Digital'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_13_Week,
        label: 'Digital Traditional Digital (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.TraditionalDigital,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Traditional Digital'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_52_Week,
        label: 'Digital Traditional Digital (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.TraditionalDigital,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Traditional Digital'
        ]
    },
    /**
     * Digital - Traditional Digital w/YouTube
     */ [$84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_4_Week,
        label: 'Digital Traditional Digital w/YouTube (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.TraditionalDigitalWithYouTube,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Traditional Digital',
            'YouTube'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_13_Week,
        label: 'Digital Traditional Digital w/YouTube (13 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.TraditionalDigitalWithYouTube,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Traditional Digital',
            'YouTube'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_TraditionalDigital_WithYouTube_52_Week,
        label: 'Digital Traditional Digital w/YouTube (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.TraditionalDigitalWithYouTube,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Digital',
            'Traditional Digital',
            'YouTube'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_GamingVRAREmergingPlatforms]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_GamingVRAREmergingPlatforms,
        label: 'Digital Gaming VR/AR, Emerging Platforms',
        media: $84ad999612a77d51$var$MediaCategory.Digital,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.OtherPlatforms,
        specialAttributes: [
            'Digital',
            'Gaming VR/AR',
            'Emerging Platforms'
        ]
    },
    /**
     * Social Media Waiver
     */ [$84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_30_Day_Cycle]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_30_Day_Cycle,
        label: 'Social Media (30 Day Cycle)',
        media: $84ad999612a77d51$var$MediaCategory.Social,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.SocialMedia,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirty,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Day,
        specialAttributes: [
            'Digital',
            'Social Media'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_YouTube]: {
        id: $84ad999612a77d51$var$UsageType.TV_Digital_SocialMedia_YouTube,
        label: 'YouTube',
        media: $84ad999612a77d51$var$MediaCategory.Social,
        platform: $84ad999612a77d51$var$UsagePlatform.Digital,
        category: $84ad999612a77d51$var$UsageTypeCategory.SocialMedia,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Digital',
            'Social Media',
            'YouTube'
        ]
    },
    /**
     * Theatrical/Industrial
     */ [$84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Up_To_30_Days]: {
        id: $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Up_To_30_Days,
        label: 'Theatrical Industrial (Up To 30 Days)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.TheatricalIndustrial,
        category: $84ad999612a77d51$var$UsageTypeCategory.TheatricalIndustrial,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirty,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Day,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Up To 30 Days'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Use_Through_MPU]: {
        id: $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Use_Through_MPU,
        label: 'Theatrical Industrial (Use Through MPU)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.TheatricalIndustrial,
        category: $84ad999612a77d51$var$UsageTypeCategory.TheatricalIndustrial,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Use Through MPU'
        ]
    },
    [$84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media]: {
        id: $84ad999612a77d51$var$UsageType.TV_TheatricalIndustrial_Dist_On_Physical_Media,
        label: 'Theatrical Industrial (Dist On Physical Media)',
        media: $84ad999612a77d51$var$MediaCategory.TV,
        platform: $84ad999612a77d51$var$UsagePlatform.TheatricalIndustrial,
        category: $84ad999612a77d51$var$UsageTypeCategory.TheatricalIndustrial,
        specialAttributes: [
            'Dist On Physical Media'
        ]
    },
    /**
     * Radio
     */ [$84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_8_Week]: {
        id: $84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_8_Week,
        label: 'AFM Radio Spot - Internet (8 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.AFM,
        category: $84ad999612a77d51$var$UsageTypeCategory.AFMInternetRadio,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Radio Spot',
            'Internet'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_26_Week]: {
        id: $84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_26_Week,
        label: 'AFM Radio Spot - Internet (26 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.AFM,
        category: $84ad999612a77d51$var$UsageTypeCategory.AFMInternetRadio,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.twentySix,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Radio Spot',
            'Internet'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_52_Week]: {
        id: $84ad999612a77d51$var$UsageType.Radio_AFM_RadioSpot_Internet_52_Week,
        label: 'AFM Radio Spot - Internet (52 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.AFM,
        category: $84ad999612a77d51$var$UsageTypeCategory.AFMInternetRadio,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Radio Spot',
            'Internet'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_1_Week_Unlimited_Use]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_1_Week_Unlimited_Use,
        label: 'Radio Network (1 Week Unlimited Use)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.one,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '1 Week',
            'Unlimited Use'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_4_Weeks_Unlimited_Use]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_4_Weeks_Unlimited_Use,
        label: 'Radio Network (4 Weeks Unlimited Use)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '4 Weeks',
            'Unlimited Use'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_8_Weeks_Unlimited_Use]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_8_Weeks_Unlimited_Use,
        label: 'Radio Network (8 Weeks Unlimited Use)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '8 Weeks',
            'Unlimited Use'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_13_Week_Unlimited_Use]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_Unlimited_Use,
        label: 'Radio Network (13 Weeks Unlimited Use)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            'Unlimited Use'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_13_Week_26_Uses]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_26_Uses,
        label: 'Radio Network (13 Weeks, 26 Uses)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.PerUse,
        perUse: true,
        useLimit: {
            maximum: 26
        },
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            '26 Uses'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_13_Week_39_Uses]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_39_Uses,
        label: 'Radio Network (13 Weeks, 39 Uses)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        usesType: $84ad999612a77d51$var$UsesType.PerUse,
        perUse: true,
        useLimit: {
            maximum: 39
        },
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            '39 Uses'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Network_13_Week_Across_The_Board_Use]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Network_13_Week_Across_The_Board_Use,
        label: 'Radio Network (13 Weeks, Across The Board Use)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Network,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioNetwork,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            'Across The Board Use'
        ]
    },
    /**
     * Radio - WildSpot
     */ [$84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_No_Major_Markets]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_No_Major_Markets,
        label: 'Radio Wild Spot (8 Week, No Major Markets)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'No Major Markets'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NoMajor
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_NY_Only]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_NY_Only,
        label: 'Radio Wild Spot (8 Week, NY Only)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'NY Only'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NYOnly
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_LA_Or_Chicago_Only,
        label: 'Radio Wild Spot (8 Week, LA Or Chicago Only)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'LA Or Chicago Only'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.LAOrChicago
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago,
        label: 'Radio Wild Spot (8 Week, 2 Of LA, NY, Chicago)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            '2 Of LA, NY, Chicago'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.TwoOfLANYChicago
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_8_Week_LA_NY_And_Chicago,
        label: 'Radio Wild Spot (8 Week, LA, NY, And Chicago)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'LA, NY, And Chicago'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.LANYAndChicago
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_No_Major_Markets]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_No_Major_Markets,
        label: 'Radio Wild Spot (13 Weeks, No Major Markets)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'No Major Markets'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NoMajor
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_NY_Only]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_NY_Only,
        label: 'Radio Wild Spot (13 Weeks, NY Only)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'NY Only'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.NYOnly
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_LA_Or_Chicago_Only,
        label: 'Radio Wild Spot (13 Weeks, LA Or Chicago Only)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'LA Or Chicago Only'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.LAOrChicago
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago,
        label: 'Radio Wild Spot (13 Weeks, 2 Of LA, NY, Chicago)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            '2 Of LA, NY, Chicago'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.TwoOfLANYChicago
    },
    [$84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago]: {
        id: $84ad999612a77d51$var$UsageType.Radio_WildSpot_13_Week_LA_NY_And_Chicago,
        label: 'Radio Wild Spot (13 Weeks, LA, NY, And Chicago)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.WildSpot,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioWildspot,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.thirteen,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'LA, NY, And Chicago'
        ],
        marketSpec: $84ad999612a77d51$var$MarketSpecification.LANYAndChicago
    },
    /**
     * Radio - Internet
     */ [$84ad999612a77d51$var$UsageType.Radio_Internet_4_Week]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Internet_4_Week,
        label: 'Radio Internet (4 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Internet,
        category: $84ad999612a77d51$var$UsageTypeCategory.InternetRadio,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.four,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Internet',
            '4 Week'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Internet_8_Week_Move_Over]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Internet_8_Week_Move_Over,
        label: 'Radio Internet (8 Week Move Over)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Internet,
        category: $84ad999612a77d51$var$UsageTypeCategory.InternetRadio,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Internet',
            '8 Week Move Over'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Internet_8_Week_Made_For]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Internet_8_Week_Made_For,
        label: 'Radio Internet (8 Week Made For)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Internet,
        category: $84ad999612a77d51$var$UsageTypeCategory.InternetRadio,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Internet',
            '8 Week Made For'
        ],
        audioMadeMove: $84ad999612a77d51$var$AudioMadeMove.MadeFor
    },
    [$84ad999612a77d51$var$UsageType.Radio_Internet_1_Year_Move_Over]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Internet_1_Year_Move_Over,
        label: 'Radio Internet (1 Year Move Over)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Internet,
        category: $84ad999612a77d51$var$UsageTypeCategory.InternetRadio,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Internet',
            '1 Year Move Over'
        ],
        audioMadeMove: $84ad999612a77d51$var$AudioMadeMove.MoveOver
    },
    [$84ad999612a77d51$var$UsageType.Radio_Internet_1_Year_Made_For]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Internet_1_Year_Made_For,
        label: 'Radio Internet (1 Year Made For)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Internet,
        category: $84ad999612a77d51$var$UsageTypeCategory.InternetRadio,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.fiftyTwo,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Internet',
            '1 Year Made For'
        ],
        audioMadeMove: $84ad999612a77d51$var$AudioMadeMove.MadeFor
    },
    /**
     * Radio - Dealer
     */ [$84ad999612a77d51$var$UsageType.Radio_Dealer_8_Week]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Dealer_8_Week,
        label: 'Radio Dealer (8 Week)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Dealer,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioDealer,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.eight,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Week,
        specialAttributes: [
            'Radio',
            'Dealer',
            '8 Week'
        ]
    },
    [$84ad999612a77d51$var$UsageType.Radio_Dealer_6_Months]: {
        id: $84ad999612a77d51$var$UsageType.Radio_Dealer_6_Months,
        label: 'Radio Dealer (6 Months)',
        media: $84ad999612a77d51$var$MediaCategory.Radio,
        platform: $84ad999612a77d51$var$UsagePlatform.Dealer,
        category: $84ad999612a77d51$var$UsageTypeCategory.RadioDealer,
        usesType: $84ad999612a77d51$var$UsesType.Unlimited,
        unlimitedUse: true,
        cycle_number: $84ad999612a77d51$var$UsageCycleNumber.six,
        cycle_unit: $84ad999612a77d51$var$UsageCycleUnit.Month,
        specialAttributes: [
            'Radio',
            'Dealer',
            '6 Months'
        ]
    }
};

});

parcelRegister("14DFf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValidationTokenType = void 0;
/**
 * Validation Token Types
 */ var $0c84eea9ab739550$var$ValidationTokenType;
(function(ValidationTokenType) {
    ValidationTokenType["Confirmation"] = "confirmation";
    ValidationTokenType["ResetPassword"] = "reset-password";
    ValidationTokenType["GroupInvitation"] = "group-invitation";
    ValidationTokenType["PerformerOnboarding"] = "performer-onboarding";
    ValidationTokenType["CharacterPhotoCapture"] = "character-photo-capture";
})($0c84eea9ab739550$var$ValidationTokenType || (module.exports.ValidationTokenType = $0c84eea9ab739550$var$ValidationTokenType = {}));

});


parcelRegister("dErKY", function(module, exports) {
"use strict";
var $9f048ab296daea4e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9f048ab296daea4e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9f048ab296daea4e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9f048ab296daea4e$var$__exportStar((parcelRequire("FNpL1")), module.exports);

$9f048ab296daea4e$var$__exportStar((parcelRequire("fdS3m")), module.exports);

$9f048ab296daea4e$var$__exportStar((parcelRequire("bPbwt")), module.exports);

$9f048ab296daea4e$var$__exportStar((parcelRequire("5vW6j")), module.exports);

});
parcelRegister("FNpL1", function(module, exports) {

var $hqs54 = parcelRequire("hqs54");
var $07da2920eb0d87bd$require$Buffer = $hqs54.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.databaseSsl = void 0;
/**
 * The `ssl` option for a Postgres connection (TypeORM / node-postgres).
 *
 * `caBase64` is the database server's CA certificate (for Cloud SQL, the instance's server CA),
 * PEM encoded and then base64 encoded onto one line so it survives the Cloud Run YAML templates.
 * With it, the connection is encrypted and the server's certificate must chain to that CA. The
 * hostname isn't checked: services connect to the instance's private IP, while its certificate
 * names the instance, so it could never match. Without it, `enabled` keeps the driver's default
 * verification.
 */ const $07da2920eb0d87bd$var$databaseSsl = (enabled, caBase64 = '')=>{
    if (!enabled) return false;
    if (!caBase64.trim()) return true;
    return {
        ca: $07da2920eb0d87bd$require$Buffer.from(caBase64.trim(), 'base64').toString('utf8'),
        checkServerIdentity: ()=>undefined
    };
};
module.exports.databaseSsl = $07da2920eb0d87bd$var$databaseSsl;

});
parcelRegister("hqs54", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $cafaa59f6914db25$export$a143d493d941bafc, (v) => $cafaa59f6914db25$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $cafaa59f6914db25$export$f99ded8fe4b79145, (v) => $cafaa59f6914db25$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $cafaa59f6914db25$export$a143d493d941bafc;
var $cafaa59f6914db25$export$e4cf37d7f6fb9e0a;
var $cafaa59f6914db25$export$f99ded8fe4b79145;
var $cafaa59f6914db25$export$599f31c3813fae4d;
'use strict';

var $jvG0V = parcelRequire("jvG0V");

var $9eRRV = parcelRequire("9eRRV");
var $cafaa59f6914db25$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$cafaa59f6914db25$export$a143d493d941bafc = $cafaa59f6914db25$var$Buffer;
$cafaa59f6914db25$export$e4cf37d7f6fb9e0a = $cafaa59f6914db25$var$SlowBuffer;
$cafaa59f6914db25$export$f99ded8fe4b79145 = 50;
var $cafaa59f6914db25$var$K_MAX_LENGTH = 0x7fffffff;
$cafaa59f6914db25$export$599f31c3813fae4d = $cafaa59f6914db25$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $cafaa59f6914db25$var$Buffer.TYPED_ARRAY_SUPPORT = $cafaa59f6914db25$var$typedArraySupport();
if (!$cafaa59f6914db25$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $cafaa59f6914db25$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($cafaa59f6914db25$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$cafaa59f6914db25$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($cafaa59f6914db25$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$cafaa59f6914db25$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $cafaa59f6914db25$var$createBuffer(length) {
    if (length > $cafaa59f6914db25$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $cafaa59f6914db25$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $cafaa59f6914db25$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $cafaa59f6914db25$var$allocUnsafe(arg);
    }
    return $cafaa59f6914db25$var$from(arg, encodingOrOffset, length);
}
$cafaa59f6914db25$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $cafaa59f6914db25$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $cafaa59f6914db25$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $cafaa59f6914db25$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($cafaa59f6914db25$var$isInstance(value, ArrayBuffer) || value && $cafaa59f6914db25$var$isInstance(value.buffer, ArrayBuffer)) return $cafaa59f6914db25$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($cafaa59f6914db25$var$isInstance(value, SharedArrayBuffer) || value && $cafaa59f6914db25$var$isInstance(value.buffer, SharedArrayBuffer))) return $cafaa59f6914db25$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $cafaa59f6914db25$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $cafaa59f6914db25$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $cafaa59f6914db25$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $cafaa59f6914db25$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $cafaa59f6914db25$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($cafaa59f6914db25$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($cafaa59f6914db25$var$Buffer, Uint8Array);
function $cafaa59f6914db25$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $cafaa59f6914db25$var$alloc(size, fill, encoding) {
    $cafaa59f6914db25$var$assertSize(size);
    if (size <= 0) return $cafaa59f6914db25$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $cafaa59f6914db25$var$createBuffer(size).fill(fill, encoding) : $cafaa59f6914db25$var$createBuffer(size).fill(fill);
    return $cafaa59f6914db25$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $cafaa59f6914db25$var$Buffer.alloc = function(size, fill, encoding) {
    return $cafaa59f6914db25$var$alloc(size, fill, encoding);
};
function $cafaa59f6914db25$var$allocUnsafe(size) {
    $cafaa59f6914db25$var$assertSize(size);
    return $cafaa59f6914db25$var$createBuffer(size < 0 ? 0 : $cafaa59f6914db25$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $cafaa59f6914db25$var$Buffer.allocUnsafe = function(size) {
    return $cafaa59f6914db25$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $cafaa59f6914db25$var$Buffer.allocUnsafeSlow = function(size) {
    return $cafaa59f6914db25$var$allocUnsafe(size);
};
function $cafaa59f6914db25$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$cafaa59f6914db25$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $cafaa59f6914db25$var$byteLength(string, encoding) | 0;
    var buf = $cafaa59f6914db25$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $cafaa59f6914db25$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $cafaa59f6914db25$var$checked(array.length) | 0;
    var buf = $cafaa59f6914db25$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $cafaa59f6914db25$var$fromArrayView(arrayView) {
    if ($cafaa59f6914db25$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $cafaa59f6914db25$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $cafaa59f6914db25$var$fromArrayLike(arrayView);
}
function $cafaa59f6914db25$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $cafaa59f6914db25$var$Buffer.prototype);
    return buf;
}
function $cafaa59f6914db25$var$fromObject(obj) {
    if ($cafaa59f6914db25$var$Buffer.isBuffer(obj)) {
        var len = $cafaa59f6914db25$var$checked(obj.length) | 0;
        var buf = $cafaa59f6914db25$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $cafaa59f6914db25$var$numberIsNaN(obj.length)) return $cafaa59f6914db25$var$createBuffer(0);
        return $cafaa59f6914db25$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $cafaa59f6914db25$var$fromArrayLike(obj.data);
}
function $cafaa59f6914db25$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $cafaa59f6914db25$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $cafaa59f6914db25$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $cafaa59f6914db25$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $cafaa59f6914db25$var$Buffer.alloc(+length);
}
$cafaa59f6914db25$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $cafaa59f6914db25$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$cafaa59f6914db25$var$Buffer.compare = function compare(a, b) {
    if ($cafaa59f6914db25$var$isInstance(a, Uint8Array)) a = $cafaa59f6914db25$var$Buffer.from(a, a.offset, a.byteLength);
    if ($cafaa59f6914db25$var$isInstance(b, Uint8Array)) b = $cafaa59f6914db25$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$cafaa59f6914db25$var$Buffer.isBuffer(a) || !$cafaa59f6914db25$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$cafaa59f6914db25$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$cafaa59f6914db25$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $cafaa59f6914db25$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $cafaa59f6914db25$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($cafaa59f6914db25$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $cafaa59f6914db25$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$cafaa59f6914db25$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $cafaa59f6914db25$var$byteLength(string, encoding) {
    if ($cafaa59f6914db25$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $cafaa59f6914db25$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $cafaa59f6914db25$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $cafaa59f6914db25$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $cafaa59f6914db25$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$cafaa59f6914db25$var$Buffer.byteLength = $cafaa59f6914db25$var$byteLength;
function $cafaa59f6914db25$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $cafaa59f6914db25$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $cafaa59f6914db25$var$utf8Slice(this, start, end);
        case 'ascii':
            return $cafaa59f6914db25$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $cafaa59f6914db25$var$latin1Slice(this, start, end);
        case 'base64':
            return $cafaa59f6914db25$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $cafaa59f6914db25$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$cafaa59f6914db25$var$Buffer.prototype._isBuffer = true;
function $cafaa59f6914db25$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$cafaa59f6914db25$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$cafaa59f6914db25$var$swap(this, i, i + 1);
    return this;
};
$cafaa59f6914db25$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $cafaa59f6914db25$var$swap(this, i, i + 3);
        $cafaa59f6914db25$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$cafaa59f6914db25$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $cafaa59f6914db25$var$swap(this, i, i + 7);
        $cafaa59f6914db25$var$swap(this, i + 1, i + 6);
        $cafaa59f6914db25$var$swap(this, i + 2, i + 5);
        $cafaa59f6914db25$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$cafaa59f6914db25$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $cafaa59f6914db25$var$utf8Slice(this, 0, length);
    return $cafaa59f6914db25$var$slowToString.apply(this, arguments);
};
$cafaa59f6914db25$var$Buffer.prototype.toLocaleString = $cafaa59f6914db25$var$Buffer.prototype.toString;
$cafaa59f6914db25$var$Buffer.prototype.equals = function equals(b) {
    if (!$cafaa59f6914db25$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $cafaa59f6914db25$var$Buffer.compare(this, b) === 0;
};
$cafaa59f6914db25$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $cafaa59f6914db25$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($cafaa59f6914db25$var$customInspectSymbol) $cafaa59f6914db25$var$Buffer.prototype[$cafaa59f6914db25$var$customInspectSymbol] = $cafaa59f6914db25$var$Buffer.prototype.inspect;
$cafaa59f6914db25$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($cafaa59f6914db25$var$isInstance(target, Uint8Array)) target = $cafaa59f6914db25$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$cafaa59f6914db25$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $cafaa59f6914db25$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($cafaa59f6914db25$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $cafaa59f6914db25$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($cafaa59f6914db25$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $cafaa59f6914db25$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $cafaa59f6914db25$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $cafaa59f6914db25$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$cafaa59f6914db25$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$cafaa59f6914db25$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $cafaa59f6914db25$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$cafaa59f6914db25$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $cafaa59f6914db25$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $cafaa59f6914db25$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($cafaa59f6914db25$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $cafaa59f6914db25$var$utf8Write(buf, string, offset, length) {
    return $cafaa59f6914db25$var$blitBuffer($cafaa59f6914db25$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $cafaa59f6914db25$var$asciiWrite(buf, string, offset, length) {
    return $cafaa59f6914db25$var$blitBuffer($cafaa59f6914db25$var$asciiToBytes(string), buf, offset, length);
}
function $cafaa59f6914db25$var$base64Write(buf, string, offset, length) {
    return $cafaa59f6914db25$var$blitBuffer($cafaa59f6914db25$var$base64ToBytes(string), buf, offset, length);
}
function $cafaa59f6914db25$var$ucs2Write(buf, string, offset, length) {
    return $cafaa59f6914db25$var$blitBuffer($cafaa59f6914db25$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$cafaa59f6914db25$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $cafaa59f6914db25$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $cafaa59f6914db25$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $cafaa59f6914db25$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $cafaa59f6914db25$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $cafaa59f6914db25$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$cafaa59f6914db25$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $cafaa59f6914db25$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jvG0V.fromByteArray(buf);
    else return $jvG0V.fromByteArray(buf.slice(start, end));
}
function $cafaa59f6914db25$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $cafaa59f6914db25$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $cafaa59f6914db25$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $cafaa59f6914db25$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $cafaa59f6914db25$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $cafaa59f6914db25$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $cafaa59f6914db25$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $cafaa59f6914db25$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $cafaa59f6914db25$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $cafaa59f6914db25$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $cafaa59f6914db25$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$cafaa59f6914db25$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $cafaa59f6914db25$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $cafaa59f6914db25$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$cafaa59f6914db25$var$Buffer.prototype.readUintLE = $cafaa59f6914db25$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$cafaa59f6914db25$var$Buffer.prototype.readUintBE = $cafaa59f6914db25$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$cafaa59f6914db25$var$Buffer.prototype.readUint8 = $cafaa59f6914db25$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$cafaa59f6914db25$var$Buffer.prototype.readUint16LE = $cafaa59f6914db25$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$cafaa59f6914db25$var$Buffer.prototype.readUint16BE = $cafaa59f6914db25$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$cafaa59f6914db25$var$Buffer.prototype.readUint32LE = $cafaa59f6914db25$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$cafaa59f6914db25$var$Buffer.prototype.readUint32BE = $cafaa59f6914db25$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$cafaa59f6914db25$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$cafaa59f6914db25$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$cafaa59f6914db25$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$cafaa59f6914db25$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$cafaa59f6914db25$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$cafaa59f6914db25$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$cafaa59f6914db25$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$cafaa59f6914db25$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 4, this.length);
    return $9eRRV.read(this, offset, true, 23, 4);
};
$cafaa59f6914db25$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 4, this.length);
    return $9eRRV.read(this, offset, false, 23, 4);
};
$cafaa59f6914db25$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 8, this.length);
    return $9eRRV.read(this, offset, true, 52, 8);
};
$cafaa59f6914db25$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkOffset(offset, 8, this.length);
    return $9eRRV.read(this, offset, false, 52, 8);
};
function $cafaa59f6914db25$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$cafaa59f6914db25$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$cafaa59f6914db25$var$Buffer.prototype.writeUintLE = $cafaa59f6914db25$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $cafaa59f6914db25$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$cafaa59f6914db25$var$Buffer.prototype.writeUintBE = $cafaa59f6914db25$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $cafaa59f6914db25$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$cafaa59f6914db25$var$Buffer.prototype.writeUint8 = $cafaa59f6914db25$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$cafaa59f6914db25$var$Buffer.prototype.writeUint16LE = $cafaa59f6914db25$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$cafaa59f6914db25$var$Buffer.prototype.writeUint16BE = $cafaa59f6914db25$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$cafaa59f6914db25$var$Buffer.prototype.writeUint32LE = $cafaa59f6914db25$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$cafaa59f6914db25$var$Buffer.prototype.writeUint32BE = $cafaa59f6914db25$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$cafaa59f6914db25$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $cafaa59f6914db25$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$cafaa59f6914db25$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $cafaa59f6914db25$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$cafaa59f6914db25$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$cafaa59f6914db25$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$cafaa59f6914db25$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$cafaa59f6914db25$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$cafaa59f6914db25$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $cafaa59f6914db25$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $cafaa59f6914db25$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9eRRV.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$cafaa59f6914db25$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $cafaa59f6914db25$var$writeFloat(this, value, offset, true, noAssert);
};
$cafaa59f6914db25$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $cafaa59f6914db25$var$writeFloat(this, value, offset, false, noAssert);
};
function $cafaa59f6914db25$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $cafaa59f6914db25$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9eRRV.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$cafaa59f6914db25$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $cafaa59f6914db25$var$writeDouble(this, value, offset, true, noAssert);
};
$cafaa59f6914db25$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $cafaa59f6914db25$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$cafaa59f6914db25$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$cafaa59f6914db25$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$cafaa59f6914db25$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$cafaa59f6914db25$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $cafaa59f6914db25$var$Buffer.isBuffer(val) ? val : $cafaa59f6914db25$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $cafaa59f6914db25$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $cafaa59f6914db25$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($cafaa59f6914db25$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $cafaa59f6914db25$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $cafaa59f6914db25$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $cafaa59f6914db25$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $cafaa59f6914db25$var$base64ToBytes(str) {
    return $jvG0V.toByteArray($cafaa59f6914db25$var$base64clean(str));
}
function $cafaa59f6914db25$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $cafaa59f6914db25$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $cafaa59f6914db25$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $cafaa59f6914db25$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("jvG0V", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $e34180a4f1cb5fd5$export$d622b2ad8d90c771, (v) => $e34180a4f1cb5fd5$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $e34180a4f1cb5fd5$export$6100ba28696e12de, (v) => $e34180a4f1cb5fd5$export$6100ba28696e12de = v);
var $e34180a4f1cb5fd5$export$a48f0734ac7c2329;
var $e34180a4f1cb5fd5$export$d622b2ad8d90c771;
var $e34180a4f1cb5fd5$export$6100ba28696e12de;
'use strict';
$e34180a4f1cb5fd5$export$a48f0734ac7c2329 = $e34180a4f1cb5fd5$var$byteLength;
$e34180a4f1cb5fd5$export$d622b2ad8d90c771 = $e34180a4f1cb5fd5$var$toByteArray;
$e34180a4f1cb5fd5$export$6100ba28696e12de = $e34180a4f1cb5fd5$var$fromByteArray;
var $e34180a4f1cb5fd5$var$lookup = [];
var $e34180a4f1cb5fd5$var$revLookup = [];
var $e34180a4f1cb5fd5$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e34180a4f1cb5fd5$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e34180a4f1cb5fd5$var$i = 0, $e34180a4f1cb5fd5$var$len = $e34180a4f1cb5fd5$var$code.length; $e34180a4f1cb5fd5$var$i < $e34180a4f1cb5fd5$var$len; ++$e34180a4f1cb5fd5$var$i){
    $e34180a4f1cb5fd5$var$lookup[$e34180a4f1cb5fd5$var$i] = $e34180a4f1cb5fd5$var$code[$e34180a4f1cb5fd5$var$i];
    $e34180a4f1cb5fd5$var$revLookup[$e34180a4f1cb5fd5$var$code.charCodeAt($e34180a4f1cb5fd5$var$i)] = $e34180a4f1cb5fd5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e34180a4f1cb5fd5$var$revLookup['-'.charCodeAt(0)] = 62;
$e34180a4f1cb5fd5$var$revLookup['_'.charCodeAt(0)] = 63;
function $e34180a4f1cb5fd5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e34180a4f1cb5fd5$var$byteLength(b64) {
    var lens = $e34180a4f1cb5fd5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e34180a4f1cb5fd5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e34180a4f1cb5fd5$var$toByteArray(b64) {
    var tmp;
    var lens = $e34180a4f1cb5fd5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e34180a4f1cb5fd5$var$Arr($e34180a4f1cb5fd5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i)] << 18 | $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i)] << 2 | $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i)] << 10 | $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e34180a4f1cb5fd5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e34180a4f1cb5fd5$var$tripletToBase64(num) {
    return $e34180a4f1cb5fd5$var$lookup[num >> 18 & 0x3F] + $e34180a4f1cb5fd5$var$lookup[num >> 12 & 0x3F] + $e34180a4f1cb5fd5$var$lookup[num >> 6 & 0x3F] + $e34180a4f1cb5fd5$var$lookup[num & 0x3F];
}
function $e34180a4f1cb5fd5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e34180a4f1cb5fd5$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e34180a4f1cb5fd5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e34180a4f1cb5fd5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e34180a4f1cb5fd5$var$lookup[tmp >> 2] + $e34180a4f1cb5fd5$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e34180a4f1cb5fd5$var$lookup[tmp >> 10] + $e34180a4f1cb5fd5$var$lookup[tmp >> 4 & 0x3F] + $e34180a4f1cb5fd5$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9eRRV", function(module, exports) {

$parcel$export(module.exports, "read", () => $6b9f350e3413a12a$export$aafa59e2e03f2942, (v) => $6b9f350e3413a12a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $6b9f350e3413a12a$export$68d8715fc104d294, (v) => $6b9f350e3413a12a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $6b9f350e3413a12a$export$aafa59e2e03f2942;
var $6b9f350e3413a12a$export$68d8715fc104d294;
$6b9f350e3413a12a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$6b9f350e3413a12a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("fdS3m", function(module, exports) {
"use strict";
var $b151ffbe9cb766a6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getIsHoliday = module.exports.getNightHours = module.exports.getIsLateNight = module.exports.getIsNight = module.exports.getIsWeekend = module.exports.getIsSunday = module.exports.getIsSaturday = module.exports.getWorkTimeType = module.exports.getIsOvertime = module.exports.getIsDoubleTime = module.exports.getIsTimeAndOneHalf = module.exports.getIsStraightTime = void 0;
parcelRequire("57Ofe");
var $dHiNv = parcelRequire("dHiNv");
var $8NtQN = parcelRequire("8NtQN");

const $b151ffbe9cb766a6$var$dayjs_1 = $b151ffbe9cb766a6$var$__importDefault((parcelRequire("03pLZ")));

var $5vW6j = parcelRequire("5vW6j");
const $b151ffbe9cb766a6$var$MS_PER_HOUR = 3600000;
/**
 * Work Time Types by Hours
 */ const $b151ffbe9cb766a6$var$getIsStraightTime = (hours)=>hours > 0 && hours <= 8;
module.exports.getIsStraightTime = $b151ffbe9cb766a6$var$getIsStraightTime;
const $b151ffbe9cb766a6$var$getIsTimeAndOneHalf = (hours)=>hours > 8 && hours <= 10;
module.exports.getIsTimeAndOneHalf = $b151ffbe9cb766a6$var$getIsTimeAndOneHalf;
const $b151ffbe9cb766a6$var$getIsDoubleTime = (hours)=>hours > 10;
module.exports.getIsDoubleTime = $b151ffbe9cb766a6$var$getIsDoubleTime;
const $b151ffbe9cb766a6$var$getIsOvertime = (hours)=>(0, module.exports.getIsTimeAndOneHalf)(hours) || (0, module.exports.getIsDoubleTime)(hours);
module.exports.getIsOvertime = $b151ffbe9cb766a6$var$getIsOvertime;
const $b151ffbe9cb766a6$var$getWorkTimeType = (hours, totalMultiplier)=>{
    if ((0, module.exports.getIsTimeAndOneHalf)(hours)) return $8NtQN.WorkTimeType.TimeAndOneHalf;
    else if ((0, module.exports.getIsDoubleTime)(hours)) return totalMultiplier && totalMultiplier + 1 > 2 ? $8NtQN.WorkTimeType.TimeAndOneHalf : $8NtQN.WorkTimeType.DoubleTime;
    else return $8NtQN.WorkTimeType.StraightTime;
};
module.exports.getWorkTimeType = $b151ffbe9cb766a6$var$getWorkTimeType;
/**
 * Day of Week
 *
 * Note: moment's `.weekday()` is locale-aware; dayjs's `.day()` is not. Since neither
 * moment nor dayjs ever has a non-default locale set anywhere in this codebase, moment's
 * default `'en'` locale (week starts Sunday) makes `.weekday()` numerically identical to
 * `.day()` here (Sunday=0…Saturday=6), so this is a literal substitution, not an
 * approximation.
 */ const $b151ffbe9cb766a6$var$getIsSaturday = (date)=>($b151ffbe9cb766a6$var$dayjs_1.default.isDayjs(date) ? date : (0, $b151ffbe9cb766a6$var$dayjs_1.default)(date)).day() === 6;
module.exports.getIsSaturday = $b151ffbe9cb766a6$var$getIsSaturday;
const $b151ffbe9cb766a6$var$getIsSunday = (date)=>($b151ffbe9cb766a6$var$dayjs_1.default.isDayjs(date) ? date : (0, $b151ffbe9cb766a6$var$dayjs_1.default)(date)).day() === 0;
module.exports.getIsSunday = $b151ffbe9cb766a6$var$getIsSunday;
const $b151ffbe9cb766a6$var$getIsWeekend = (date)=>(0, module.exports.getIsSaturday)(date) || (0, module.exports.getIsSunday)(date);
module.exports.getIsWeekend = $b151ffbe9cb766a6$var$getIsWeekend;
/**
 * Time of Day
 */ const $b151ffbe9cb766a6$var$getIsNight = (role, date)=>{
    const currentHour = ($b151ffbe9cb766a6$var$dayjs_1.default.isDayjs(date) ? date : (0, $b151ffbe9cb766a6$var$dayjs_1.default)(date)).hour();
    return currentHour >= 20 && currentHour < 24 || currentHour >= 0 && currentHour < ((0, $5vW6j.getIsExtra)(role.performer_type) ? 1 : 6);
};
module.exports.getIsNight = $b151ffbe9cb766a6$var$getIsNight;
const $b151ffbe9cb766a6$var$getIsLateNight = (role, date)=>{
    const currentHour = ($b151ffbe9cb766a6$var$dayjs_1.default.isDayjs(date) ? date : (0, $b151ffbe9cb766a6$var$dayjs_1.default)(date)).hour();
    return (0, $5vW6j.getIsExtra)(role.performer_type) ? currentHour >= 1 && currentHour < 6 : false;
};
module.exports.getIsLateNight = $b151ffbe9cb766a6$var$getIsLateNight;
const $b151ffbe9cb766a6$var$getNightHours = (activity)=>{
    const nightStart = (0, $b151ffbe9cb766a6$var$dayjs_1.default)(activity.start_time).hour(20).minute(0).second(0).millisecond(0);
    return (0, $b151ffbe9cb766a6$var$dayjs_1.default)(activity.end_time).diff(nightStart) / $b151ffbe9cb766a6$var$MS_PER_HOUR;
};
module.exports.getNightHours = $b151ffbe9cb766a6$var$getNightHours;
/**
 * Holidays
 */ const $b151ffbe9cb766a6$var$getIsHoliday = (date)=>{
    date = $b151ffbe9cb766a6$var$dayjs_1.default.isDayjs(date) ? date : (0, $b151ffbe9cb766a6$var$dayjs_1.default)(date);
    let isHoliday = false;
    const month = date.month();
    const day = date.day();
    // See the Day of Week note above - `.day()` is the correct dayjs equivalent of moment's
    // locale-aware `.weekday()` given this codebase never customizes locale.
    const weekday = date.day();
    if ($dHiNv.holidayDates[month]) $dHiNv.holidayDates[month].forEach((holiday)=>{
        if (holiday.day && holiday.day === day) isHoliday = true;
        else if (holiday.days) {
            if (day >= holiday.days[0] && day <= holiday.days[1] && holiday.weekday === weekday) isHoliday = true;
        }
    });
    return isHoliday;
};
module.exports.getIsHoliday = $b151ffbe9cb766a6$var$getIsHoliday;

});
parcelRegister("57Ofe", function(module, exports) {
$parcel$export(module.exports, "RolePerformerType", () => (parcelRequire("l2vXU")).RolePerformerType);
$parcel$export(module.exports, "RoleType", () => (parcelRequire("ehX4i")).RoleType);
$parcel$export(module.exports, "MealActivityTypes", () => (parcelRequire("8NtQN")).MealActivityTypes);
$parcel$export(module.exports, "SessionActivityType", () => (parcelRequire("8NtQN")).SessionActivityType);
$parcel$export(module.exports, "TravelActivityTypes", () => (parcelRequire("8NtQN")).TravelActivityTypes);
$parcel$export(module.exports, "WorkActivityTypes", () => (parcelRequire("8NtQN")).WorkActivityTypes);
$parcel$export(module.exports, "WorkTimeType", () => (parcelRequire("8NtQN")).WorkTimeType);
$parcel$export(module.exports, "holidayDates", () => (parcelRequire("dHiNv")).holidayDates);
parcelRequire("gr84G");
parcelRequire("ev9Gi");
parcelRequire("lPsBT");
parcelRequire("2kgHq");
parcelRequire("5L7qK");
parcelRequire("lSQhx");
parcelRequire("lQ3lC");
parcelRequire("cyNfS");
parcelRequire("6x9w1");
parcelRequire("hdTCs");
parcelRequire("gGtvI");
parcelRequire("aqWke");
parcelRequire("kevMM");
parcelRequire("hX6X1");
parcelRequire("82WDR");
parcelRequire("2YBb3");
parcelRequire("epAp6");
parcelRequire("2Vhyb");
parcelRequire("l2vXU");
parcelRequire("ehX4i");
parcelRequire("8NtQN");
parcelRequire("hL94C");
parcelRequire("dHiNv");
parcelRequire("6ISrk");
parcelRequire("h9GyM");
parcelRequire("c9BaB");
parcelRequire("dKesY");

});
parcelRegister("gr84G", function(module, exports) {
/**
 * Allowance
 */ var $2edc56226cd6e10c$export$11a17db1639c2f55 = /*#__PURE__*/ function(AllowanceType) {
    AllowanceType["Wardrobe_Fee"] = "Wardrobe Fee";
    AllowanceType["Wardrobe_FeeEvePeriod"] = "Wardrobe Fee - Eve/Period";
    AllowanceType["LocationMeal_Breakfast"] = "Breakfast";
    AllowanceType["LocationMeal_Lunch"] = "Lunch";
    AllowanceType["LocationMeal_Dinnner"] = "Dinnner";
    AllowanceType["Travel_ExtrasRoundTrip"] = "Extras - Round Trip";
    AllowanceType["Travel_PerMileOutsideStudioZone"] = "Per mile (outside studio zone)";
    AllowanceType["Travel_OCPPerDiem"] = "OCP travel per diem";
    AllowanceType["Props_AutomobileTrailerMotorcycle"] = "Automobile, Trailer or Motorcycle";
    AllowanceType["Props_SkatesSkateBoards"] = "Skates and Skate Boards";
    AllowanceType["Props_Bicycle"] = "Bicycle";
    AllowanceType["Props_Moped"] = "Moped";
    AllowanceType["Props_Camera"] = "Camera";
    AllowanceType["Props_Pet"] = "Pet";
    AllowanceType["Props_LuggageEachPiece"] = "Luggage (each piece)";
    AllowanceType["Props_GolfClubsAndBag"] = "Golf Clubs & Bag";
    AllowanceType["Props_TennisRacquet"] = "Tennis Racquet";
    AllowanceType["Props_Skis"] = "Skis";
    AllowanceType["Props_BinocularsOperaGlasses"] = "Binoculars or Opera Glasses";
    AllowanceType["Props_LargePortableRadios"] = "Large Portable Radios";
    AllowanceType["Props_BooksEach"] = "Books (each)";
    AllowanceType["Props_LaptopCellPhonePDAiPodMP3Player"] = "Laptop, Cell Phone/PDA, iPod/MP3 Player";
    AllowanceType["Props_StandardOpeningOrClosing"] = "Standard Opening or Closing";
    AllowanceType["Props_WetSnowmokeDustWork"] = "Wet, Snow, Smoke, & Dust Work";
    AllowanceType["Props_BodyMUSkullCapHairGoodsHaircuts"] = "Body MU, Skull Cap, Hair Goods, Haircuts";
    return AllowanceType;
}({});

});

parcelRegister("ev9Gi", function(module, exports) {
/**
 * Enums
 */ var $f15272e268ab3bf7$export$e57062a38354425e = /*#__PURE__*/ function(AssetType) {
    AssetType["Video"] = "Video";
    AssetType["Image"] = "Image";
    AssetType["Audio"] = "Audio";
    AssetType["Document"] = "Document";
    return AssetType;
}({});
var $f15272e268ab3bf7$export$855c4df14b7264c = /*#__PURE__*/ function(ProcessingStatus) {
    ProcessingStatus["Pending"] = "Pending";
    ProcessingStatus["Processing"] = "Processing";
    ProcessingStatus["Complete"] = "Complete";
    ProcessingStatus["Failed"] = "Failed";
    return ProcessingStatus;
}({});

});

parcelRegister("lPsBT", function(module, exports) {
var $e1c452a58c951bb5$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["AI_MESSAGE"] = "aiMessage";
    MessageType["CHARACTER_PHOTOS_UPLOADED"] = "characterPhotosUploaded";
    MessageType["ERROR_MESSAGE"] = "errorMessage";
    MessageType["NEW_CONVERSATION"] = "newConversation";
    MessageType["NOTIFICATION"] = "notification";
    MessageType["PERFORMER_CONTRACT_DECLINED"] = "performerContractDeclined";
    MessageType["SUPPORT_MESSAGE"] = "supportMessage";
    MessageType["SYSTEM_MESSAGE"] = "systemMessage";
    /** Ephemeral typing-indicator ping — never persisted as a ChatMessage row. */ MessageType["TYPING"] = "typing";
    MessageType["UPDATED_CONVERSATION"] = "updatedConversation";
    MessageType["USER_MESSAGE"] = "userMessage";
    return MessageType;
}({});
var $e1c452a58c951bb5$export$3a941682f82314e9 = /*#__PURE__*/ function(ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["CLOSED"] = "closed";
    return ConversationStatus;
}({});
var $e1c452a58c951bb5$export$e5064b6186a4d6a9 = /*#__PURE__*/ function(ConversationType) {
    ConversationType["SUPPORT"] = "support";
    ConversationType["TALENT_MANAGER"] = "talentManager";
    ConversationType["PROJECT"] = "project";
    return ConversationType;
}({});
var $e1c452a58c951bb5$export$c0549d1afec05d13 = /*#__PURE__*/ function(ConversationParticipantRole) {
    ConversationParticipantRole["AGENCY"] = "agency";
    ConversationParticipantRole["TALENT_MANAGER"] = "talentManager";
    ConversationParticipantRole["SUPPORT"] = "support";
    ConversationParticipantRole["ADMIN_OBSERVER"] = "adminObserver";
    return ConversationParticipantRole;
}({});
var $e1c452a58c951bb5$export$737491f7ec0a1fed = /*#__PURE__*/ function(MentionTargetType) {
    MentionTargetType["USER"] = "user";
    MentionTargetType["BOT"] = "bot";
    MentionTargetType["SUPPORT"] = "support";
    return MentionTargetType;
}({});

});

parcelRegister("2kgHq", function(module, exports) {

$parcel$export(module.exports, "CommercialType", () => $4376c8f2243307dd$export$5d4650a49bf64f57);
/**
 * Type
 */ var $4376c8f2243307dd$export$5d4650a49bf64f57 = /*#__PURE__*/ function(CommercialType) {
    CommercialType["TV"] = "TV";
    CommercialType["Radio"] = "Radio";
    CommercialType["Digital"] = "Digital";
    CommercialType["Print"] = "Print";
    CommercialType["OOH"] = "OOH";
    CommercialType["Social"] = "Social";
    CommercialType["BTS"] = "BTS";
    CommercialType["Other"] = "Other";
    return CommercialType;
}({});

});

parcelRegister("5L7qK", function(module, exports) {
/**
 * Costume Type
 */ var $066b6408571e7ea5$export$ff76eb2ffa7a3c6f = /*#__PURE__*/ function(CostumeType) {
    CostumeType["Standard"] = "Standard";
    CostumeType["EveningWear"] = "Evening Wear";
    CostumeType["PeriodWear"] = "Period Wear";
    return CostumeType;
}({});

});

parcelRegister("lSQhx", function(module, exports) {
/**
 * Enums
 */ var $93dd922a85fdace2$export$d1d99cf900472499 = /*#__PURE__*/ function(DocumentType) {
    DocumentType["Script"] = "Script";
    DocumentType["Storyboard"] = "Storyboard";
    DocumentType["ShootingSchedule"] = "Shoot Schedule";
    DocumentType["MediaPlan"] = "Media Plan";
    DocumentType["Contract"] = "Contract";
    DocumentType["License"] = "License";
    DocumentType["Generic"] = "Generic";
    return DocumentType;
}({});

});

parcelRegister("lQ3lC", function(module, exports) {
/**
 * Edit Review Status
 */ var $294303f307036c7f$export$d019d4ae00763f3 = /*#__PURE__*/ function(EditReviewStatus) {
    EditReviewStatus["PENDING"] = "pending";
    EditReviewStatus["PROCESSING"] = "processing";
    EditReviewStatus["COMPLETED"] = "completed";
    EditReviewStatus["FAILED"] = "failed";
    return EditReviewStatus;
}({});

});

parcelRegister("cyNfS", function(module, exports) {
/**
 * Edit Types
 *
 * Part I, Section 26
 */ var $ef074fe67d8bb9bf$export$5292a05d12e7ab31 = /*#__PURE__*/ function(EditType) {
    EditType["MainAsset"] = "Main Asset";
    EditType["ShorterOrLongerVersion"] = "Shorter Or Longer Version";
    EditType["PermittedChanges"] = "Permitted Changes";
    EditType["PaidEdits"] = "Paid Edits";
    EditType["AddressableEdits"] = "Addressable Edits";
    return EditType;
}({});

});

parcelRegister("6x9w1", function(module, exports) {
var $29d93d283c2c41c0$export$9ded2f8358be1890 = /*#__PURE__*/ function(EstimateStatus) {
    EstimateStatus["Draft"] = "Draft";
    EstimateStatus["Final"] = "Final";
    return EstimateStatus;
}({});

});

parcelRegister("hdTCs", function(module, exports) {
/**
 * Fee Types
 */ var $1efb3d0a370302cd$export$dbe2689247f3f973 = /*#__PURE__*/ function(FeeType) {
    FeeType["MealPeriodViolation"] = "Meal Period Violation";
    FeeType["LatePayDamagesPerDayLT25"] = "Up to 25 Days (Per Day)";
    FeeType["LatePayDamagesMaximum"] = "Maximum";
    FeeType["LatePayDamagesOnNonPaymentNotice"] = "On Non-Nayment Notice";
    FeeType["LatePayDamagesPerDayAfterNonPaymentNoticeGTE25"] = "Each Day After Non-Payment Notice \u2267 25 days";
    return FeeType;
}({});
var $1efb3d0a370302cd$export$cda2f4921a3acb03 = /*#__PURE__*/ function(EstimateFeeType) {
    EstimateFeeType["WardrobeFee"] = "Wardrobe Fee";
    EstimateFeeType["WardrobeFeeEveningWear"] = "Wardrobe - Fee Evening Wear";
    EstimateFeeType["WardrobeFeePeriodWear"] = "Wardrobe - Fee PeriodWear";
    EstimateFeeType["StudioZoneTravelFee"] = "Studio Zone Travel Fee";
    EstimateFeeType["AuditionScratchTrackFee"] = "Audition Scratch Track Fee";
    EstimateFeeType["LineMemorizationFee"] = "Line Memorization Fee";
    EstimateFeeType["DancersHazardFee1stDay"] = "Dancers Hazard Fee - 1st Day";
    EstimateFeeType["DancersHazardFeeAdditionalDays"] = "Dancers Hazard Fee - Additional Days";
    EstimateFeeType["DancersFootwearFee"] = "Dancers Footwear Fee";
    EstimateFeeType["StuntAdjustmentFee"] = "Stunt Adjustment Fee";
    EstimateFeeType["FlightInsuranceFee"] = "Flight Insurance Fee";
    EstimateFeeType["GroupContractorFee"] = "Group Contractor Fee";
    EstimateFeeType["GroupContractorFee3To5"] = "Group Contractor Fee - 3 To 5";
    EstimateFeeType["GroupContractorFee6To8"] = "Group Contractor Fee - 6 To 8";
    EstimateFeeType["GroupContractorFee9Plus"] = "Group Contractor Fee - 9 Plus";
    EstimateFeeType["PilotSessionFeeStudio"] = "Pilot Session Fee - Studio";
    EstimateFeeType["PilotSessionFeeOnLocation"] = "Pilot Session Fee - On Location";
    EstimateFeeType["WetSnowSmokeDustWorkAllowance"] = "Wet/Snow/Smoke/Dust Work Allowance";
    return EstimateFeeType;
}({});

});

parcelRegister("gGtvI", function(module, exports) {
var $d7577df2b85b3ebf$export$d460f747b73abb10 = /*#__PURE__*/ function(GroupType) {
    GroupType["ADVERTISER"] = "advertiser";
    GroupType["AD_AGENCY"] = "ad_agency";
    GroupType["PRODUCTION_COMPANY"] = "production_company";
    GroupType["TALENT"] = "talent";
    GroupType["TALENT_AGENCY"] = "talent_agency";
    return GroupType;
}({});
var $d7577df2b85b3ebf$export$f4d1e047cdac8dab = /*#__PURE__*/ function(GroupSubscriptionStatus) {
    GroupSubscriptionStatus["PENDING_PAYMENT"] = "pending_payment";
    GroupSubscriptionStatus["TRIALING"] = "trialing";
    GroupSubscriptionStatus["ACTIVE"] = "active";
    GroupSubscriptionStatus["PAST_DUE"] = "past_due";
    GroupSubscriptionStatus["CANCELED"] = "canceled";
    return GroupSubscriptionStatus;
}({});

});

parcelRegister("aqWke", function(module, exports) {
var $81e2afd78f519b3f$export$6bf7a712bebc413 = /*#__PURE__*/ function(HoldingFeeCycleStatus) {
    HoldingFeeCycleStatus["PAID"] = "Paid";
    HoldingFeeCycleStatus["WAIVED"] = "Waived";
    return HoldingFeeCycleStatus;
}({});

});

parcelRegister("kevMM", function(module, exports) {
// Types needed by shared entities

});

parcelRegister("hX6X1", function(module, exports) {
/**
 * Location Type
 *
 * "Nearby" is a location where you return to the reporting site at EOD
 * "Distant" is a location that requires an overnight stay
 */ var $7ef4150ee6187f0d$export$ec50e3f346457d89 = /*#__PURE__*/ function(LocationType) {
    LocationType["Studio"] = "Studio";
    LocationType["Nearby"] = "Nearby";
    LocationType["Distant"] = "Distant";
    LocationType["Airport"] = "Airport";
    return LocationType;
}({});
var $7ef4150ee6187f0d$export$9a038e04323693f = /*#__PURE__*/ function(Airport) {
    Airport["LaGuardia"] = "LaGuardia";
    Airport["JFK"] = "JFK";
    Airport["Newark"] = "Newark";
    Airport["LAX"] = "LAX";
    return Airport;
}({});
var $7ef4150ee6187f0d$export$57d2d62126b64b77 = /*#__PURE__*/ function(StudioZone) {
    StudioZone["NewYork"] = "New York";
    StudioZone["NewYorkCity"] = "New York City";
    StudioZone["LosAngeles"] = "Los Angeles";
    return StudioZone;
}({});

});

parcelRegister("82WDR", function(module, exports) {

});

parcelRegister("2YBb3", function(module, exports) {
var $1bc450ffb58e304b$export$439d2d6c03747598 = /*#__PURE__*/ function(PaymentType) {
    PaymentType["SessionFee"] = "Session Fee";
    PaymentType["Reuse"] = "Reuse";
    PaymentType["HoldingFee"] = "Holding Fee";
    PaymentType["Other"] = "Other";
    return PaymentType;
}({});
var $1bc450ffb58e304b$export$e1e7dea5d3c4ac5c = /*#__PURE__*/ function(PerformerContractStatus) {
    PerformerContractStatus["Draft"] = "draft";
    PerformerContractStatus["Pending"] = "pending";
    PerformerContractStatus["Sent"] = "sent";
    PerformerContractStatus["PerformerSigned"] = "performer_signed";
    PerformerContractStatus["ProducerSigned"] = "producer_signed";
    PerformerContractStatus["Completed"] = "completed";
    PerformerContractStatus["TimeLogApproved"] = "time_log_approved";
    PerformerContractStatus["Cancelled"] = "cancelled";
    PerformerContractStatus["Declined"] = "declined";
    return PerformerContractStatus;
}({});
var $1bc450ffb58e304b$export$878a09ba6f334862 = /*#__PURE__*/ function(PerformerOnboardingStatus) {
    PerformerOnboardingStatus["Cancelled"] = "cancelled";
    PerformerOnboardingStatus["NotStarted"] = "not_started";
    PerformerOnboardingStatus["Invited"] = "invited";
    PerformerOnboardingStatus["InvitationAccepted"] = "invitation_accepted";
    PerformerOnboardingStatus["Completed"] = "completed";
    return PerformerOnboardingStatus;
}({});
var $1bc450ffb58e304b$export$be12697bd0984da1 = /*#__PURE__*/ function(PerformerContractType) {
    PerformerContractType["Exhibit1"] = "Exhibit1";
    PerformerContractType["Exhibit2"] = "Exhibit2";
    return PerformerContractType;
}({});

});

parcelRegister("epAp6", function(module, exports) {
/**
 * Prop Type
 */ var $64d3d32887236d4b$export$fa229f1561ec4e96 = /*#__PURE__*/ function(PropType) {
    PropType["Automobile"] = "Automobile";
    PropType["Trailer"] = "Trailer";
    PropType["Motorcycle"] = "Motorcycle";
    PropType["Skates"] = "Skates";
    PropType["Skateboard"] = "Skateboard";
    PropType["Bicycle"] = "Bicycle";
    PropType["Moped"] = "Moped";
    PropType["Camera"] = "Camera";
    PropType["Pet"] = "Pet";
    PropType["Footwear"] = "Footwear";
    PropType["Luggage"] = "Luggage";
    PropType["GolfClubs"] = "Golf Clubs";
    PropType["GolfBag"] = "GolfBag";
    PropType["TennisRacquet"] = "Tennis Racquet";
    PropType["Skis"] = "Skis";
    PropType["Binoculars"] = "Binoculars";
    PropType["OperaGlasses"] = "Opera Glasses";
    PropType["LargePortableRadio"] = "Large Portable Radio";
    PropType["Book"] = "Book";
    PropType["Laptop"] = "Laptop";
    PropType["CellPhone"] = "CellPhone";
    PropType["Tablet"] = "Tablet";
    PropType["PDA"] = "PDA";
    PropType["MP3Player"] = "MP3 Player";
    PropType["Other"] = "Other";
    return PropType;
}({});

});

parcelRegister("2Vhyb", function(module, exports) {
var $85fa9d0b49a022ff$export$4bac2cbffae9ef93 = /*#__PURE__*/ function(RightStatus) {
    RightStatus["ACTIVE"] = "Active";
    RightStatus["RELEASED"] = "Released";
    RightStatus["EXPIRED"] = "Expired";
    return RightStatus;
}({});
var $85fa9d0b49a022ff$export$7f9cec1d06ef6304 = /*#__PURE__*/ function(RightType) {
    RightType["TWO_D_ARTWORK"] = "2D Artwork";
    RightType["CELEBRITY_GUARANTEE"] = "Celebrity Guarantee";
    RightType["CHARACTER_LICENSE"] = "Character License";
    RightType["CLEARANCE_LIMITATION"] = "Clearance Limitation";
    RightType["CUSTOMER_PROVIDED_MATERIALS"] = "Customer Provided Materials";
    RightType["DORMANCY_FEES"] = "Dormancy Fees";
    RightType["FILM_FOOTAGE_LICENSE"] = "Film Footage License";
    RightType["FONT_LICENSE"] = "Font License";
    RightType["ILLUSTRATOR"] = "Illustrator";
    RightType["INFLUENCER"] = "Influencer";
    RightType["MUSIC_DEMO_FEE"] = "Music Demo Fee";
    RightType["MUSIC_MASTER_LICENSE"] = "Music Master License";
    RightType["MUSIC_PUBLISHING_LICENSE"] = "Music Publishing License";
    RightType["MUSIC_MASTER_AND_PUBLISHING_LICENSE"] = "Music Master and Publishing License";
    RightType["NON_UNION_BACKGROUND_EXTRA"] = "Non-Union Background Extra";
    RightType["NON_UNION_CHARACTER_VOICE"] = "Non-Union Character Voice";
    RightType["NON_UNION_DRIVER"] = "Non-Union Driver";
    RightType["NON_UNION_FEATURED_EXTRA"] = "Non-Union Featured Extra";
    RightType["NON_UNION_INFLUENCER"] = "Non-Union Influencer";
    RightType["NON_UNION_ON_CAMERA_PRINCIPAL"] = "Non-Union On-Camera Principal";
    RightType["NON_UNION_OTHER"] = "Non-Union Other";
    RightType["NON_UNION_VOICEOVER"] = "Non-Union Voiceover";
    RightType["NON_UNION_AGREEMENT"] = "Non-Union Agreement";
    RightType["ORIGINAL_MUSIC_LICENSE"] = "Original Music License";
    RightType["ORIGINAL_MUSIC_NON_AFM"] = "Original Music (Non-AFM)";
    RightType["OTHER"] = "Other";
    RightType["PHOTOGRAPHER"] = "Photographer";
    RightType["PRINCIPAL_MODEL"] = "Principal Model";
    RightType["PROMOTIONAL_LICENSE"] = "Promotional License";
    RightType["RIGHT_OF_PUBLICITY"] = "Right of Publicity";
    RightType["SPORTING_EVENT_FOOTAGE_LICENSE"] = "Sporting Event Footage License";
    RightType["STOCK_ARTWORK_2D"] = "Stock Artwork (2D)";
    RightType["STOCK_FILM_FOOTAGE"] = "Stock Film Footage";
    RightType["STOCK_MUSIC"] = "Stock Music";
    RightType["STOCK_PHOTO"] = "Stock Photo";
    RightType["TERM_GUARANTEE"] = "Term Guarantee";
    RightType["UNION_TALENT"] = "Union Talent";
    return RightType;
}({});

});

parcelRegister("l2vXU", function(module, exports) {

$parcel$export(module.exports, "RolePerformerType", () => $a695b955fd45306b$export$ea660ae8d9311cfb);

var $2kgHq = parcelRequire("2kgHq");
var $a695b955fd45306b$export$ea660ae8d9311cfb = /*#__PURE__*/ function(RolePerformerType) {
    RolePerformerType["OnCameraPrincipal"] = "On Camera Principal";
    RolePerformerType["OffCameraPrincipal"] = "Off Camera Principal";
    RolePerformerType["Extra"] = "Extra";
    RolePerformerType["Radio"] = "Radio";
    RolePerformerType["AFM"] = "American Federation Of Musicians";
    RolePerformerType["OnCameraGroup"] = "On Camera Group";
    RolePerformerType["OnCameraGroupContractor"] = "On Camera Group Contractor (1-2)";
    RolePerformerType["OnCameraGroupContractor3To5"] = "On Camera Group Contractor (3-5)";
    RolePerformerType["OnCameraGroupContractor6To8"] = "On Camera Group Contractor (6-8)";
    RolePerformerType["OnCameraGroupContractor9Plus"] = "On Camera Group Contractor (9+)";
    RolePerformerType["OffCameraGroup"] = "Off Camera Group";
    RolePerformerType["OffCameraGroupContractor"] = "Off Camera Group Contractor (1-2)";
    RolePerformerType["OffCameraGroupContractor3To5"] = "Off Camera Group Contractor (3-5)";
    RolePerformerType["OffCameraGroupContractor6To8"] = "Off Camera Group Contractor (6-8)";
    RolePerformerType["OffCameraGroupContractor9Plus"] = "Off Camera Group Contractor (9+)";
    return RolePerformerType;
}({});
var $a695b955fd45306b$export$5cddc92c0dc3acf5 = /*#__PURE__*/ function(RolePerformerClassification) {
    RolePerformerClassification["OnCamera"] = "on_camera";
    RolePerformerClassification["OffCamera"] = "off_camera";
    return RolePerformerClassification;
}({});
const $a695b955fd45306b$export$4b24e13f8e5ea2c6 = [
    "On Camera Group",
    "Off Camera Group"
];
const $a695b955fd45306b$export$7bd2af6d59a6b3ff = [
    "On Camera Group Contractor (1-2)",
    "On Camera Group Contractor (3-5)",
    "On Camera Group Contractor (6-8)",
    "On Camera Group Contractor (9+)",
    "Off Camera Group Contractor (1-2)",
    "Off Camera Group Contractor (3-5)",
    "Off Camera Group Contractor (6-8)",
    "Off Camera Group Contractor (9+)"
];
const $a695b955fd45306b$export$f839502a50e739b3 = {
    [(0, $2kgHq.CommercialType).TV]: [
        "On Camera Principal",
        "On Camera Group",
        "Off Camera Principal",
        "Off Camera Group",
        "Extra",
        "American Federation Of Musicians"
    ],
    [(0, $2kgHq.CommercialType).Radio]: [
        "Radio",
        "American Federation Of Musicians"
    ]
};

});

parcelRegister("ehX4i", function(module, exports) {

$parcel$export(module.exports, "RoleType", () => $dadc6f3e8ee3126d$export$e57c3ccf0ca02b45);

var $l2vXU = parcelRequire("l2vXU");
var $dadc6f3e8ee3126d$export$e57c3ccf0ca02b45 = /*#__PURE__*/ function(RoleType) {
    RoleType["Actor"] = "Actor";
    RoleType["Speaker"] = "Speaker";
    RoleType["Narrator"] = "Narrator";
    RoleType["Announcer"] = "Announcer";
    RoleType["Singer"] = "Singer";
    RoleType["SpecialtyDancer"] = "Specialty Dancer";
    RoleType["SpecialtyAct"] = "Specialty Act";
    RoleType["Puppeteer"] = "Puppeteer";
    RoleType["StuntPerformer"] = "Stunt Performer";
    RoleType["StuntCoordinator"] = "Stunt Coordinator";
    RoleType["Pilot"] = "Pilot";
    RoleType["Clown"] = "Clown";
    RoleType["StandIn"] = "Stand In";
    RoleType["HandModel"] = "Hand Model";
    RoleType["HandModelDoubleScale"] = "Hand Model Double Scale";
    RoleType["Other"] = "Other";
    RoleType["LeaderArrangerComposer"] = "Leader Arranger Composer";
    RoleType["CopyistSideMusician"] = "Copyist Side Musician";
    RoleType["CopyistSideMusician1Double"] = "Copyist Side Musician 1 Double";
    RoleType["CopyistSideMusician2Doubles"] = "Copyist Side Musician 2 Doubles";
    RoleType["CopyistSideMusician3Doubles"] = "Copyist Side Musician 3 Doubles";
    RoleType["CopyistSideMusician4Doubles"] = "Copyist Side Musician 4 Doubles";
    return RoleType;
}({});
var $dadc6f3e8ee3126d$export$687ef5289f2d9cc3 = /*#__PURE__*/ function(RoleScale) {
    RoleScale["SessionScale"] = "Session Scale";
    RoleScale["AboveScale"] = "Above Scale";
    return RoleScale;
}({});
const $dadc6f3e8ee3126d$export$5cd5b84c36d9cdb = [
    "Actor",
    "Singer",
    "Specialty Dancer",
    "Specialty Act",
    "Stunt Performer",
    "Pilot",
    "Clown"
];
const $dadc6f3e8ee3126d$export$33de541485aa3b70 = [
    "Narrator",
    "Announcer",
    "Puppeteer",
    "Stunt Coordinator"
];
const $dadc6f3e8ee3126d$export$c4e8d3aae5e5f6a7 = [
    (0, $l2vXU.RolePerformerType).Extra,
    "Actor",
    "Stand In",
    "Singer",
    "Hand Model",
    "Hand Model Double Scale",
    "Specialty Dancer",
    "Specialty Act",
    "Stunt Performer",
    "Pilot",
    "Clown"
];
const $dadc6f3e8ee3126d$export$683eb27afbb045b7 = [
    "Leader Arranger Composer",
    "Copyist Side Musician",
    "Copyist Side Musician 1 Double",
    "Copyist Side Musician 2 Doubles",
    "Copyist Side Musician 3 Doubles",
    "Copyist Side Musician 4 Doubles"
];
const $dadc6f3e8ee3126d$export$36a36140e628dd32 = [
    ...$dadc6f3e8ee3126d$export$5cd5b84c36d9cdb,
    ...$dadc6f3e8ee3126d$export$33de541485aa3b70,
    ...$dadc6f3e8ee3126d$export$c4e8d3aae5e5f6a7,
    ...$dadc6f3e8ee3126d$export$683eb27afbb045b7
];
const $dadc6f3e8ee3126d$export$34eef019a3f647f9 = [
    "Announcer"
];
const $dadc6f3e8ee3126d$export$b16956d0f94f6f5f = {
    [(0, $l2vXU.RolePerformerType).OnCameraPrincipal]: $dadc6f3e8ee3126d$export$5cd5b84c36d9cdb,
    [(0, $l2vXU.RolePerformerType).OnCameraGroup]: $dadc6f3e8ee3126d$export$5cd5b84c36d9cdb,
    [(0, $l2vXU.RolePerformerType).OffCameraPrincipal]: $dadc6f3e8ee3126d$export$33de541485aa3b70,
    [(0, $l2vXU.RolePerformerType).OffCameraGroup]: $dadc6f3e8ee3126d$export$33de541485aa3b70,
    [(0, $l2vXU.RolePerformerType).Extra]: $dadc6f3e8ee3126d$export$c4e8d3aae5e5f6a7,
    [(0, $l2vXU.RolePerformerType).Radio]: $dadc6f3e8ee3126d$export$34eef019a3f647f9,
    [(0, $l2vXU.RolePerformerType).AFM]: $dadc6f3e8ee3126d$export$683eb27afbb045b7
};

});

parcelRegister("8NtQN", function(module, exports) {

$parcel$export(module.exports, "SessionActivityType", () => $053ffd4bba4ce881$export$69901d8e29a73d0d);
$parcel$export(module.exports, "TravelActivityTypes", () => $053ffd4bba4ce881$export$e6b926252e8d7e9a);
$parcel$export(module.exports, "MealActivityTypes", () => $053ffd4bba4ce881$export$5d3adf98206cbf56);
$parcel$export(module.exports, "WorkActivityTypes", () => $053ffd4bba4ce881$export$c5879813cce06908);
$parcel$export(module.exports, "SessionActivityTimeOfDay", () => $053ffd4bba4ce881$export$b39ec8168d5df870);
$parcel$export(module.exports, "WorkTimeType", () => $053ffd4bba4ce881$export$fc7f4262501dfd8e);
/**
 * Session Activity Types
 */ var $053ffd4bba4ce881$export$69901d8e29a73d0d = /*#__PURE__*/ function(SessionActivityType) {
    SessionActivityType["AFMRecordingSession"] = "AFM Recording Session";
    SessionActivityType["WorkTime"] = "Work Time";
    SessionActivityType["WorkTimeNight"] = "Work Time - Night (+10%)";
    SessionActivityType["WorkTimeLateNight"] = "Work Time - Late Night (+20%)";
    SessionActivityType["WorkTimeSaturday"] = "Work Time - Saturday";
    SessionActivityType["WorkTimeSunday"] = "Work Time - Sunday";
    SessionActivityType["WorkTimeHoliday"] = "Work Time - Holiday";
    SessionActivityType["MealBreakfast"] = "Meal - Breakfast";
    SessionActivityType["MealLunch"] = "Meal - Lunch";
    SessionActivityType["MealDinner"] = "Meal - Dinner";
    SessionActivityType["Fitting"] = "Fitting";
    SessionActivityType["WardrobeChange"] = "Wardrobe Change";
    SessionActivityType["HairAndMakeup"] = "Hair And Makeup";
    SessionActivityType["TravelToLocation"] = "Travel To Location";
    SessionActivityType["TravelToLocationAfterMidnight"] = "Travel To Location (After Midnight)";
    SessionActivityType["TravelFromLocation"] = "Travel From Location";
    SessionActivityType["TravelFromLocationAfterMidnight"] = "Travel From Location (After Midnight)";
    SessionActivityType["Audition"] = "Audition";
    SessionActivityType["Rehearsal"] = "Rehearsal";
    SessionActivityType["LineMemorization"] = "Line Memorization";
    SessionActivityType["AuditionScratchTrack"] = "Audition Scratch Track";
    SessionActivityType["RecordingSession"] = "Recording Session";
    SessionActivityType["VoiceOver"] = "Voice Over";
    SessionActivityType["Demo"] = "Demo";
    SessionActivityType["CreativeSession"] = "Creative Session";
    SessionActivityType["CreativeAudition"] = "Creative Audition";
    return SessionActivityType;
}({});
const $053ffd4bba4ce881$export$54713d5ced816d20 = {
    ["Work Time"]: 'Work Session',
    ["Fitting"]: 'Fitting Session',
    ["Travel To Location"]: 'Travel Session - To Location',
    ["Travel From Location"]: 'Travel Session - From Location',
    ["Meal - Breakfast"]: 'Breakfast',
    ["Meal - Lunch"]: 'Lunch',
    ["Meal - Dinner"]: 'Dinner',
    ["Audition"]: 'Audition',
    ["Line Memorization"]: 'Line Memorization',
    ["Audition Scratch Track"]: 'Audition Scratch Track',
    ["Demo"]: 'Demo',
    ["Voice Over"]: 'Voice Over',
    ["Creative Session"]: 'Creative Session',
    ["Creative Audition"]: 'Creative Audition'
};
const $053ffd4bba4ce881$export$e6b926252e8d7e9a = new Set([
    "Travel To Location",
    "Travel To Location (After Midnight)",
    "Travel From Location",
    "Travel From Location (After Midnight)"
]);
const $053ffd4bba4ce881$export$5d3adf98206cbf56 = new Set([
    "Meal - Breakfast",
    "Meal - Lunch",
    "Meal - Dinner"
]);
const $053ffd4bba4ce881$export$c5879813cce06908 = new Set([
    "Work Time",
    "Work Time - Night (+10%)",
    "Work Time - Late Night (+20%)",
    "Work Time - Saturday",
    "Work Time - Sunday",
    "Work Time - Holiday",
    "Fitting",
    "Hair And Makeup",
    "Audition",
    "Rehearsal",
    "Recording Session",
    "Voice Over",
    "Audition Scratch Track",
    "Demo",
    "Creative Session",
    "Creative Audition"
]);
const $053ffd4bba4ce881$export$5796594ff01d507 = new Set([
    "Audition",
    "Audition Scratch Track",
    "Creative Audition"
]);
var $053ffd4bba4ce881$export$b39ec8168d5df870 = /*#__PURE__*/ function(SessionActivityTimeOfDay) {
    SessionActivityTimeOfDay["Night"] = "night";
    SessionActivityTimeOfDay["LateNight"] = "late-night";
    SessionActivityTimeOfDay["AfterMidnight"] = "after-midnight";
    return SessionActivityTimeOfDay;
}({});
var $053ffd4bba4ce881$export$fc7f4262501dfd8e = /*#__PURE__*/ function(WorkTimeType) {
    // OnCamera = 'On Camera',
    // OffCamera = 'Off Camera',
    // Overtime = 'Overtime',
    WorkTimeType["StraightTime"] = "Straight Time";
    WorkTimeType["TimeAndOneHalf"] = "Time And One Half";
    WorkTimeType["DoubleTime"] = "Double Time";
    WorkTimeType["NoServiceDay"] = "No Service Day";
    WorkTimeType["NoServiceDayWeekendHoliday"] = "No Service Day (Weekend/Holiday)";
    return WorkTimeType;
}({});

});

parcelRegister("hL94C", function(module, exports) {

var $8NtQN = parcelRequire("8NtQN");

var $dHiNv = parcelRequire("dHiNv");
var $43f2e6937ee5840e$export$52bb89a13fb5b79f = /*#__PURE__*/ function(SessionEstimateItemUnitType) {
    SessionEstimateItemUnitType["Hours"] = "hours";
    SessionEstimateItemUnitType["Miles"] = "miles";
    SessionEstimateItemUnitType["Days"] = "days";
    SessionEstimateItemUnitType["Count"] = "count";
    SessionEstimateItemUnitType["CostumeChanges"] = "costume changes";
    SessionEstimateItemUnitType["Tags"] = "tags";
    SessionEstimateItemUnitType["Doubles"] = "doubles";
    return SessionEstimateItemUnitType;
}({});
const $43f2e6937ee5840e$export$fa5002f3054a7f30 = {
    [(0, $8NtQN.WorkTimeType).StraightTime]: 'Straight Time',
    [(0, $8NtQN.WorkTimeType).TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
    [(0, $8NtQN.WorkTimeType).DoubleTime]: 'Overtime (Double Time)',
    [(0, $8NtQN.WorkTimeType).NoServiceDay]: 'Travel (No Service Day)',
    [(0, $8NtQN.SessionActivityType).WorkTimeSaturday]: '(Saturday Premium)',
    [(0, $8NtQN.SessionActivityType).WorkTimeSunday]: '(Sunday Premium)',
    [(0, $8NtQN.SessionActivityType).WorkTimeHoliday]: '(Holiday Premium)',
    [(0, $dHiNv.SessionDayType).Saturday]: '(Saturday Premium)',
    [(0, $dHiNv.SessionDayType).Sunday]: '(Sunday Premium)',
    [(0, $dHiNv.SessionDayType).Holiday]: '(Holiday Premium)',
    Weekend: '(Weekend Premium)',
    [(0, $8NtQN.SessionActivityType).WorkTimeNight]: '(Night Premium)',
    [(0, $8NtQN.SessionActivityType).WorkTimeLateNight]: '(Late Night Premium)',
    [(0, $8NtQN.SessionActivityType).TravelToLocationAfterMidnight]: '(Travel After Midnight)',
    [(0, $8NtQN.SessionActivityType).TravelFromLocationAfterMidnight]: '(Travel After Midnight)',
    [(0, $8NtQN.SessionActivityTimeOfDay).Night]: '(Night Premium)',
    [(0, $8NtQN.SessionActivityTimeOfDay).LateNight]: '(Late Night Premium)',
    [(0, $8NtQN.SessionActivityTimeOfDay).AfterMidnight]: '(Travel After Midnight)'
}; // API version
 // export const sessionEstimateItemTitles: Record<string, string> = {
 //   [WorkTimeType.StraightTime]: 'Straight Time',
 //   [WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
 //   [WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
 //   [WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
 //   [SessionDayType.Saturday]: '(Saturday Premium)',
 //   [SessionDayType.Sunday]: '(Sunday Premium)',
 //   [SessionDayType.Holiday]: '(Holiday Premium)',
 //   Weekend: '(Weekend Premium)',
 //   [SessionActivityTimeOfDay.Night]: '(Night Premium)',
 //   [SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)',
 //   [SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)',
 // };

});
parcelRegister("dHiNv", function(module, exports) {

$parcel$export(module.exports, "SessionDayType", () => $3efaf90a90e095ae$export$ed39c998fde292db);
$parcel$export(module.exports, "holidayDates", () => $3efaf90a90e095ae$export$5dd7627594a3207);
/**
 * Session Day Types
 */ var $3efaf90a90e095ae$export$ed39c998fde292db = /*#__PURE__*/ function(SessionDayType) {
    SessionDayType["First"] = "1st day";
    SessionDayType["Consecutive"] = "consecutive";
    SessionDayType["NonConsecutive"] = "non-consecutive";
    SessionDayType["Saturday"] = "Saturday";
    SessionDayType["Sunday"] = "Sunday";
    SessionDayType["Holiday"] = "Holiday";
    return SessionDayType;
}({});
var $3efaf90a90e095ae$export$ae22a29c9480263a = /*#__PURE__*/ function(HolidayType) {
    HolidayType["NewYearsDay"] = "New Year's Day";
    HolidayType["MLKJrBirthday"] = "Martin Luther King Jr's Birthday";
    HolidayType["PresidentsDay"] = "President's Day";
    HolidayType["MemorialDay"] = "Memorial Day";
    HolidayType["Juneteenth"] = "Juneteenth";
    HolidayType["IndependenceDay"] = "Independence Day";
    HolidayType["LaborDay"] = "Labor Day";
    HolidayType["VeteransDay"] = "Veteran's Day";
    HolidayType["ThanksgivingDay"] = "Thanksgiving Day";
    HolidayType["ChristmasDay"] = "Christmas Day";
    return HolidayType;
}({});
const $3efaf90a90e095ae$export$5dd7627594a3207 = {
    1: [
        {
            name: "New Year's Day",
            day: 1
        },
        {
            name: "Martin Luther King Jr's Birthday",
            weekday: 1,
            days: [
                15,
                21
            ]
        }
    ],
    2: [
        {
            name: "President's Day",
            weekday: 1,
            days: [
                15,
                21
            ]
        }
    ],
    5: [
        {
            name: "Memorial Day",
            weekday: 1,
            days: [
                25,
                31
            ]
        }
    ],
    7: [
        {
            name: "Independence Day",
            day: 4
        }
    ],
    9: [
        {
            name: "Labor Day",
            weekday: 1,
            days: [
                1,
                7
            ]
        }
    ],
    11: [
        {
            name: "Veteran's Day",
            day: 11
        },
        {
            name: "Thanksgiving Day",
            weekday: 4,
            days: [
                22,
                28
            ]
        }
    ],
    12: [
        {
            name: "Christmas Day",
            day: 25
        }
    ]
};

});


parcelRegister("6ISrk", function(module, exports) {
var $1d7ec78491628496$export$50121fe0666760e6 = /*#__PURE__*/ function(TalentManagerApprovalStatus) {
    TalentManagerApprovalStatus["PENDING"] = "pending";
    TalentManagerApprovalStatus["APPROVED"] = "approved";
    TalentManagerApprovalStatus["SUSPENDED"] = "suspended";
    return TalentManagerApprovalStatus;
}({});
var $1d7ec78491628496$export$d0aff9dd6196597a = /*#__PURE__*/ function(TalentManagerEngagementStatus) {
    TalentManagerEngagementStatus["ACTIVE"] = "active";
    TalentManagerEngagementStatus["PAUSED"] = "paused";
    TalentManagerEngagementStatus["COMPLETED"] = "completed";
    TalentManagerEngagementStatus["CANCELLED"] = "cancelled";
    return TalentManagerEngagementStatus;
}({});
var $1d7ec78491628496$export$6f5b54e252ca6d9d = /*#__PURE__*/ function(TimeEntryType) {
    TimeEntryType["CHAT_AUTO"] = "chatAuto";
    TimeEntryType["MANUAL"] = "manual";
    return TimeEntryType;
}({});
var $1d7ec78491628496$export$5a6834789aa380ac = /*#__PURE__*/ function(CreditPurchaseStatus) {
    CreditPurchaseStatus["PENDING"] = "pending";
    CreditPurchaseStatus["COMPLETED"] = "completed";
    CreditPurchaseStatus["REFUNDED"] = "refunded";
    return CreditPurchaseStatus;
}({});

});

parcelRegister("h9GyM", function(module, exports) {
/**
 * Estimate Unit Types
 */ var $19da649a84e181b9$export$14dc1a387b15a44a = /*#__PURE__*/ function(UsageEstimateItemUnitType) {
    UsageEstimateItemUnitType["Hours"] = "Hours";
    UsageEstimateItemUnitType["Days"] = "Days";
    UsageEstimateItemUnitType["Count"] = "Count";
    return UsageEstimateItemUnitType;
}({});

});

parcelRegister("c9BaB", function(module, exports) {

var $2kgHq = parcelRequire("2kgHq");
var $9e759b4b5a45f96b$export$244f6e23904fead6 = /*#__PURE__*/ function(UsageUnitType) {
    UsageUnitType["Uses"] = "Uses";
    UsageUnitType["Cities"] = "Cities";
    return UsageUnitType;
}({});
var $9e759b4b5a45f96b$export$ac35d2cafd9675a9 = /*#__PURE__*/ function(UsageCities) {
    UsageCities["NY"] = "New York";
    UsageCities["LA"] = "Los Angeles";
    UsageCities["Chicago"] = "Chicago";
    UsageCities["Minor"] = "Minor Markets";
    return UsageCities;
}({});
var $9e759b4b5a45f96b$export$8fcbcc7d534fdaac = /*#__PURE__*/ function(UsageCycleNumber) {
    UsageCycleNumber[UsageCycleNumber["one"] = 1] = "one";
    UsageCycleNumber[UsageCycleNumber["four"] = 4] = "four";
    UsageCycleNumber[UsageCycleNumber["six"] = 6] = "six";
    UsageCycleNumber[UsageCycleNumber["eight"] = 8] = "eight";
    UsageCycleNumber[UsageCycleNumber["thirteen"] = 13] = "thirteen";
    UsageCycleNumber[UsageCycleNumber["twentySix"] = 26] = "twentySix";
    UsageCycleNumber[UsageCycleNumber["thirty"] = 30] = "thirty";
    UsageCycleNumber[UsageCycleNumber["thirtyOne"] = 31] = "thirtyOne";
    UsageCycleNumber[UsageCycleNumber["fiftyTwo"] = 52] = "fiftyTwo";
    return UsageCycleNumber;
}({});
var $9e759b4b5a45f96b$export$72d597b22c8c24ed = /*#__PURE__*/ function(UsageCycleUnit) {
    UsageCycleUnit["Day"] = "Day";
    UsageCycleUnit["Week"] = "Week";
    UsageCycleUnit["Month"] = "Month";
    UsageCycleUnit["Year"] = "Year";
    return UsageCycleUnit;
}({});
var $9e759b4b5a45f96b$export$739b0676f5728098 = /*#__PURE__*/ function(MediaCategory) {
    MediaCategory["TV"] = "TV";
    MediaCategory["Digital"] = "Digital";
    MediaCategory["Social"] = "Social Media";
    MediaCategory["OOH"] = "Out-of-home";
    MediaCategory["Radio"] = "Radio";
    return MediaCategory;
}({});
var $9e759b4b5a45f96b$export$cc8dd4235b976426 = /*#__PURE__*/ function(UsagePlatform) {
    UsagePlatform["Linear"] = "Linear";
    UsagePlatform["Digital"] = "Digital";
    UsagePlatform["SocialWaiver"] = "Social Media Waiver";
    UsagePlatform["TheatricalIndustrial"] = "Theatrical/Industrial";
    UsagePlatform["Foreign"] = "Foreign";
    UsagePlatform["AFM"] = "AFM";
    UsagePlatform["Traditional"] = "Traditional";
    UsagePlatform["Internet"] = "Internet";
    UsagePlatform["Network"] = "Network";
    UsagePlatform["WildSpot"] = "WildSpot";
    UsagePlatform["Dealer"] = "Dealer";
    return UsagePlatform;
}({});
var $9e759b4b5a45f96b$export$2520daae526a6943 = /*#__PURE__*/ function(MarketSpecification) {
    MarketSpecification["All"] = "All Markets";
    MarketSpecification["NoNYChiLA"] = "All Markets (No NY/CHI/LA)";
    MarketSpecification["NoMajor"] = "No Major Markets";
    MarketSpecification["NYOnly"] = "NY Only";
    MarketSpecification["LAOrChicago"] = "LA Or Chicago Only";
    MarketSpecification["TwoOfLANYChicago"] = "2 Of LA, NY, Chicago";
    MarketSpecification["LANYAndChicago"] = "LA, NY, And Chicago";
    MarketSpecification["WithNY"] = "With NY";
    MarketSpecification["WithoutNY"] = "Without NY";
    return MarketSpecification;
}({});
var $9e759b4b5a45f96b$export$7b2681bc9a8ae9c3 = /*#__PURE__*/ function(UsageLanguage) {
    UsageLanguage["English"] = "English";
    UsageLanguage["Spanish"] = "Spanish";
    UsageLanguage["Japanese"] = "Japanese";
    UsageLanguage["Other"] = "Other";
    return UsageLanguage;
}({});
var $9e759b4b5a45f96b$export$4c217c54571f9a0 = /*#__PURE__*/ function(UsesType) {
    UsesType["Unlimited"] = "Unlimited Use";
    UsesType["PerUse"] = "Per Use";
    UsesType["AcrossTheBoard"] = "Across The Board";
    return UsesType;
}({});
var $9e759b4b5a45f96b$export$1b897e40c12e1f34 = /*#__PURE__*/ function(GlobalMarket) {
    GlobalMarket["Americas"] = "Americas";
    GlobalMarket["Caribbean"] = "Caribbean";
    GlobalMarket["AmericasAndCaribbean"] = "Americas And Caribbean";
    GlobalMarket["UK"] = "United Kingdom";
    GlobalMarket["Europe"] = "Europe";
    GlobalMarket["AsiaPacific"] = "Asia Pacific";
    GlobalMarket["Japan"] = "Japan";
    GlobalMarket["RestOfWorld"] = "Rest Of World";
    GlobalMarket["Worldwide"] = "Worldwide";
    return GlobalMarket;
}({});
var $9e759b4b5a45f96b$export$785de5377743f4d9 = /*#__PURE__*/ function(CableMarket) {
    CableMarket["NationalCable"] = "National Cable";
    CableMarket["LocalCableUpTo1MSubscribers"] = "Local Cable (Up To 1M Subscribers)";
    CableMarket["LocalCable1MTo2MSubscribers"] = "Local Cable (1M To 2M Subscribers)";
    CableMarket["LocalCable2MPlusSubscribers"] = "Local Cable (2M Plus Subscribers)";
    return CableMarket;
}({});
var $9e759b4b5a45f96b$export$a15c75067d344f85 = /*#__PURE__*/ function(AudioMadeMove) {
    AudioMadeMove["MoveOver"] = "Move Over";
    AudioMadeMove["MadeFor"] = "Made For";
    return AudioMadeMove;
}({});
var $9e759b4b5a45f96b$export$dd6a661c806250b8 = /*#__PURE__*/ function(UsageTypeCategory) {
    UsageTypeCategory["NationalNetworks"] = "National Networks (Class A)";
    UsageTypeCategory["Cable"] = "Cable";
    UsageTypeCategory["NationalCable"] = "National Cable";
    UsageTypeCategory["SingleNetwork"] = "National Cable Single Network";
    UsageTypeCategory["LocalCable"] = "Local Cable";
    UsageTypeCategory["Wildspot"] = "Wildspot";
    UsageTypeCategory["Dealer"] = "Dealer";
    UsageTypeCategory["AllOtherNA"] = "All Other North American Use";
    UsageTypeCategory["SpanishLanguageProgramUse"] = "Spanish-Language Program Use";
    UsageTypeCategory["IONAndDiginet"] = "ION & Diginet";
    UsageTypeCategory["ForeignUse"] = "Foreign Use";
    UsageTypeCategory["TraditionalDigital"] = "Traditional Digital";
    UsageTypeCategory["TraditionalDigitalWithYouTube"] = "Traditional Digital w/YouTube";
    UsageTypeCategory["StreamingPlatforms"] = "Streaming Platforms";
    UsageTypeCategory["SocialMedia"] = "Social Media";
    UsageTypeCategory["YouTube"] = "YouTube";
    UsageTypeCategory["OtherPlatforms"] = "Gaming Platforms, VR/AR, Emerging Platforms";
    UsageTypeCategory["Print"] = "Print Use";
    UsageTypeCategory["OOH"] = "Out of Home Use";
    UsageTypeCategory["BTS"] = "B-roll & Behind the Scenes Use";
    UsageTypeCategory["TheatricalIndustrial"] = "Theatrical & Industrial Use";
    UsageTypeCategory["AFMSession"] = "AFM Session (1 hour)";
    UsageTypeCategory["AFMFirstUse"] = "AFM First Use";
    UsageTypeCategory["AFMForeign"] = "AFM Foreign Use";
    UsageTypeCategory["AFMInternetRadio"] = "AFM Internet Radio Spot";
    UsageTypeCategory["RadioNetwork"] = "Radio Network";
    UsageTypeCategory["RadioWildspot"] = "Radio Wildspot";
    UsageTypeCategory["InternetRadio"] = "Internet Radio";
    UsageTypeCategory["RadioDealer"] = "Radio Dealer";
    return UsageTypeCategory;
}({});
var $9e759b4b5a45f96b$export$653653f5082d2d6b = /*#__PURE__*/ function(UsageType) {
    UsageType["TV_LinearDomestic_Network_ClassA_Per_Use"] = "TV Linear Domestic Network Class A (Per Use)";
    UsageType["TV_LinearDomestic_Network_ClassA_13_Week_Maximum"] = "TV Linear Domestic Network Class A (13 Weeks Maximum)";
    UsageType["TV_LinearDomestic_IONAndDiginet_Per_Use"] = "TV Linear Domestic ION And Diginet Per Use";
    UsageType["TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use"] = "TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_4_Week"] = "TV Spanish Language Program (4 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_13_Week"] = "TV Spanish Language Program (13 Week)";
    UsageType["TV_LinearDomestic_SpanishLanguageProgram_52_Week"] = "TV Spanish Language Program (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_4_Week"] = "TV Linear Domestic Wild Spot All Markets (4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_13_Week"] = "TV Linear Domestic Wild Spot All Markets (13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarkets_52_Week"] = "TV Linear Domestic Wild Spot All Markets (52 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)";
    UsageType["TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week"] = "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_4_Week"] = "TV Linear Domestic National Cable (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_13_Week"] = "TV Linear Domestic National Cable (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_52_Week"] = "TV Linear Domestic National Cable (52 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_4_Week"] = "TV Linear Domestic National Cable Single Network (4 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_13_Week"] = "TV Linear Domestic National Cable Single Network (13 Week)";
    UsageType["TV_LinearDomestic_NationalCable_SingleNetwork_52_Week"] = "TV Linear Domestic National Cable Single Network (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_4_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_13_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_52_Week"] = "TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week"] = "TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)";
    UsageType["TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week"] = "TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)";
    UsageType["TV_LinearDomestic_Dealer_4_Week"] = "TV Linear Domestic Dealer (4 Week)";
    UsageType["TV_LinearDomestic_Dealer_13_Week"] = "TV Linear Domestic Dealer (13 Week)";
    UsageType["TV_LinearDomestic_Dealer_52_Week"] = "TV Linear Domestic Dealer (52 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_4_Week"] = "TV Linear Domestic All Other NA Linear (4 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_13_Week"] = "TV Linear Domestic All Other NA Linear (13 Week)";
    UsageType["TV_LinearDomestic_AllOtherNALinear_52_Week"] = "TV Linear Domestic All Other NA Linear (52 Week)";
    UsageType["TV_TheatricalIndustrial_Up_To_30_Days"] = "TV Theatrical Industrial (Up To 30 Days)";
    UsageType["TV_TheatricalIndustrial_Use_Through_MPU"] = "TV Theatrical Industrial (Use Through MPU)";
    UsageType["TV_TheatricalIndustrial_Dist_On_Physical_Media"] = "TV Theatrical Industrial (Dist On Physical Media)";
    UsageType["TV_Digital_StreamingPlatforms_4_Week"] = "TV Digital Streaming Platforms (4 Week)";
    UsageType["TV_Digital_StreamingPlatforms_13_Week"] = "TV Digital Streaming Platforms (13 Week)";
    UsageType["TV_Digital_StreamingPlatforms_52_Week"] = "TV Digital Streaming Platforms (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_4_Week"] = "TV Digital Traditional Digital (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_13_Week"] = "TV Digital Traditional Digital (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_52_Week"] = "TV Digital Traditional Digital (52 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_4_Week"] = "TV Digital Traditional Digital w/YouTube (4 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_13_Week"] = "TV Digital Traditional Digital w/YouTube (13 Week)";
    UsageType["TV_Digital_TraditionalDigital_WithYouTube_52_Week"] = "TV Digital Traditional Digital w/YouTube (52 Week)";
    UsageType["TV_Digital_SocialMedia_30_Day_Cycle"] = "Social Media Waiver - Social Media (30 Day Cycle)";
    UsageType["TV_Digital_SocialMedia_YouTube"] = "Social Media Waiver - YouTube";
    UsageType["TV_Digital_GamingVRAREmergingPlatforms"] = "TV Digital Gaming VR/AR, Emerging Platforms";
    UsageType["TV_ForeignUse_UK"] = "TV Foreign Use - U.K.";
    UsageType["TV_ForeignUse_Europe"] = "TV Foreign Use - Europe";
    UsageType["TV_ForeignUse_AsiaPacific"] = "TV Foreign Use - Asia/Pacific";
    UsageType["TV_ForeignUse_Japan"] = "TV Foreign Use - Japan";
    UsageType["TV_ForeignUse_RestOfWorld"] = "TV Foreign Use - Rest-of-World";
    UsageType["TV_ForeignUse_Worldwide"] = "TV Foreign Use - Worldwide";
    UsageType["TV_ForeignUse_SpanishLanguage_Americas"] = "TV Foreign Use - Spanish Language (Americas)";
    UsageType["TV_ForeignUse_SpanishLanguage_Caribbean"] = "TV Foreign Use - Spanish Language (Caribbean)";
    UsageType["TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean"] = "TV Foreign Use - Spanish Language (Americas And Caribbean)";
    UsageType["TV_ForeignUse_Other_UK"] = "TV Foreign Use - Other (UK)";
    UsageType["TV_ForeignUse_Other_Japan"] = "TV Foreign Use - Other (Japan)";
    UsageType["TV_ForeignUse_Other_Europe"] = "TV Foreign Use - Other (Europe)";
    UsageType["TV_ForeignUse_Other_RestOfWorld"] = "TV Foreign Use - Other (Rest Of World)";
    UsageType["TV_ForeignUse_Other_AsiaPacific"] = "TV Foreign Use - Other (Asia Pacific)";
    UsageType["TV_ForeignUse_Other_Worldwide"] = "TV Foreign Use - Other (Worldwide)";
    UsageType["TV_AFM_FirstUse_InternetOnlyOrUS"] = "TV AFM First Use (Internet Only Or US)";
    UsageType["TV_AFM_Foreign_1_Year_Europe_NoEurope"] = "TV AFM Foreign - 1 Year (Europe/No Europe)";
    UsageType["TV_AFM_Foreign_Worldwide"] = "TV AFM Foreign (Worldwide)";
    UsageType["Radio_AFM_RadioSpot_Internet_8_Week"] = "Radio AFM Radio Spot - Internet (8 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_26_Week"] = "Radio AFM Radio Spot - Internet (26 Week)";
    UsageType["Radio_AFM_RadioSpot_Internet_52_Week"] = "Radio AFM Radio Spot - Internet (52 Week)";
    UsageType["Radio_Network_1_Week_Unlimited_Use"] = "Radio Network - 1 Week Unlimited Use";
    UsageType["Radio_Network_4_Weeks_Unlimited_Use"] = "Radio Network - 4 Week Unlimited Use";
    UsageType["Radio_Network_8_Weeks_Unlimited_Use"] = "Radio Network - 8 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_Unlimited_Use"] = "Radio Network - 13 Week Unlimited Use";
    UsageType["Radio_Network_13_Week_26_Uses"] = "Radio Network - 13 Weeks 26 Uses";
    UsageType["Radio_Network_13_Week_39_Uses"] = "Radio Network - 13 Weeks 39 Uses";
    UsageType["Radio_Network_13_Week_Across_The_Board_Use"] = "Radio Network - 13 Weeks Across The Board Use";
    UsageType["Radio_WildSpot_8_Week_No_Major_Markets"] = "Radio Wild Spot - 8 Week (No Major Markets)";
    UsageType["Radio_WildSpot_8_Week_NY_Only"] = "Radio Wild Spot - 8 Week (NY Only)";
    UsageType["Radio_WildSpot_8_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 8 Week (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_8_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 8 Week (LA, NY, And Chicago)";
    UsageType["Radio_WildSpot_13_Week_No_Major_Markets"] = "Radio Wild Spot - 13 Weeks (No Major Markets)";
    UsageType["Radio_WildSpot_13_Week_NY_Only"] = "Radio Wild Spot - 13 Weeks (NY Only)";
    UsageType["Radio_WildSpot_13_Week_LA_Or_Chicago_Only"] = "Radio Wild Spot - 13 Weeks (LA Or Chicago Only)";
    UsageType["Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago"] = "Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)";
    UsageType["Radio_WildSpot_13_Week_LA_NY_And_Chicago"] = "Radio WildSpot - 13 Weeks (LA, NY, And Chicago)";
    UsageType["Radio_Internet_4_Week"] = "Radio Internet - 4 Week";
    UsageType["Radio_Internet_8_Week_Move_Over"] = "Radio Internet - 8 Week Move Over";
    UsageType["Radio_Internet_8_Week_Made_For"] = "Radio Internet - 8 Week Made For";
    UsageType["Radio_Internet_1_Year_Move_Over"] = "Radio Internet - 1 Year Move Over";
    UsageType["Radio_Internet_1_Year_Made_For"] = "Radio Internet - 1 Year Made For";
    UsageType["Radio_Dealer_8_Week"] = "Radio Dealer - 8 Week";
    UsageType["Radio_Dealer_6_Months"] = "Radio Dealer - 6 Months";
    return UsageType;
}({});
const $9e759b4b5a45f96b$export$9f758fda596a8dc6 = {
    [(0, $2kgHq.CommercialType).TV]: [
        "TV Linear Domestic Network Class A (Per Use)",
        "TV Linear Domestic Network Class A (13 Weeks Maximum)",
        "TV Linear Domestic ION And Diginet Per Use",
        "TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)",
        "TV Spanish Language Program (4 Week)",
        "TV Spanish Language Program (13 Week)",
        "TV Spanish Language Program (52 Week)",
        "TV Linear Domestic Wild Spot All Markets (4 Week)",
        "TV Linear Domestic Wild Spot All Markets (13 Week)",
        "TV Linear Domestic Wild Spot All Markets (52 Week)",
        "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)",
        "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)",
        "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)",
        "TV Linear Domestic National Cable (4 Week)",
        "TV Linear Domestic National Cable (13 Week)",
        "TV Linear Domestic National Cable (52 Week)",
        "TV Linear Domestic National Cable Single Network (4 Week)",
        "TV Linear Domestic National Cable Single Network (13 Week)",
        "TV Linear Domestic National Cable Single Network (52 Week)",
        "TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)",
        "TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)",
        "TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)",
        "TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)",
        "TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)",
        "TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)",
        "TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)",
        "TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)",
        "TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)",
        "TV Linear Domestic Dealer (4 Week)",
        "TV Linear Domestic Dealer (13 Week)",
        "TV Linear Domestic Dealer (52 Week)",
        "TV Linear Domestic All Other NA Linear (4 Week)",
        "TV Linear Domestic All Other NA Linear (13 Week)",
        "TV Linear Domestic All Other NA Linear (52 Week)",
        "TV Theatrical Industrial (Up To 30 Days)",
        "TV Theatrical Industrial (Use Through MPU)",
        "TV Theatrical Industrial (Dist On Physical Media)",
        "TV Digital Streaming Platforms (4 Week)",
        "TV Digital Streaming Platforms (13 Week)",
        "TV Digital Streaming Platforms (52 Week)",
        "TV Digital Traditional Digital (4 Week)",
        "TV Digital Traditional Digital (13 Week)",
        "TV Digital Traditional Digital (52 Week)",
        "TV Digital Traditional Digital w/YouTube (4 Week)",
        "TV Digital Traditional Digital w/YouTube (13 Week)",
        "TV Digital Traditional Digital w/YouTube (52 Week)",
        "Social Media Waiver - Social Media (30 Day Cycle)",
        "Social Media Waiver - YouTube",
        "TV Digital Gaming VR/AR, Emerging Platforms",
        "TV Foreign Use - U.K.",
        "TV Foreign Use - Europe",
        "TV Foreign Use - Asia/Pacific",
        "TV Foreign Use - Japan",
        "TV Foreign Use - Rest-of-World",
        "TV Foreign Use - Worldwide",
        "TV Foreign Use - Spanish Language (Americas)",
        "TV Foreign Use - Spanish Language (Caribbean)",
        "TV Foreign Use - Spanish Language (Americas And Caribbean)",
        "TV Foreign Use - Other (UK)",
        "TV Foreign Use - Other (Japan)",
        "TV Foreign Use - Other (Europe)",
        "TV Foreign Use - Other (Rest Of World)",
        "TV Foreign Use - Other (Asia Pacific)",
        "TV Foreign Use - Other (Worldwide)",
        "TV AFM First Use (Internet Only Or US)",
        "TV AFM Foreign - 1 Year (Europe/No Europe)",
        "TV AFM Foreign (Worldwide)"
    ],
    [(0, $2kgHq.CommercialType).Digital]: [
        "TV Digital Streaming Platforms (4 Week)",
        "TV Digital Streaming Platforms (13 Week)",
        "TV Digital Streaming Platforms (52 Week)",
        "TV Digital Traditional Digital (4 Week)",
        "TV Digital Traditional Digital (13 Week)",
        "TV Digital Traditional Digital (52 Week)",
        "TV Digital Traditional Digital w/YouTube (4 Week)",
        "TV Digital Traditional Digital w/YouTube (13 Week)",
        "TV Digital Traditional Digital w/YouTube (52 Week)",
        "Social Media Waiver - Social Media (30 Day Cycle)",
        "Social Media Waiver - YouTube",
        "TV Digital Gaming VR/AR, Emerging Platforms"
    ],
    [(0, $2kgHq.CommercialType).Social]: [
        "Social Media Waiver - Social Media (30 Day Cycle)",
        "Social Media Waiver - YouTube"
    ],
    [(0, $2kgHq.CommercialType).OOH]: [
        "TV Theatrical Industrial (Up To 30 Days)",
        "TV Theatrical Industrial (Use Through MPU)",
        "TV Theatrical Industrial (Dist On Physical Media)"
    ],
    [(0, $2kgHq.CommercialType).Radio]: [
        "Radio AFM Radio Spot - Internet (8 Week)",
        "Radio AFM Radio Spot - Internet (26 Week)",
        "Radio AFM Radio Spot - Internet (52 Week)",
        "Radio Network - 1 Week Unlimited Use",
        "Radio Network - 4 Week Unlimited Use",
        "Radio Network - 8 Week Unlimited Use",
        "Radio Network - 13 Week Unlimited Use",
        "Radio Network - 13 Weeks 26 Uses",
        "Radio Network - 13 Weeks 39 Uses",
        "Radio Network - 13 Weeks Across The Board Use",
        "Radio Wild Spot - 8 Week (No Major Markets)",
        "Radio Wild Spot - 8 Week (NY Only)",
        "Radio Wild Spot - 8 Week (LA Or Chicago Only)",
        "Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)",
        "Radio WildSpot - 8 Week (LA, NY, And Chicago)",
        "Radio Wild Spot - 13 Weeks (No Major Markets)",
        "Radio Wild Spot - 13 Weeks (NY Only)",
        "Radio Wild Spot - 13 Weeks (LA Or Chicago Only)",
        "Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)",
        "Radio WildSpot - 13 Weeks (LA, NY, And Chicago)",
        "Radio Internet - 4 Week",
        "Radio Internet - 8 Week Move Over",
        "Radio Internet - 8 Week Made For",
        "Radio Internet - 1 Year Move Over",
        "Radio Internet - 1 Year Made For",
        "Radio Dealer - 8 Week",
        "Radio Dealer - 6 Months"
    ],
    [(0, $2kgHq.CommercialType).BTS]: [],
    [(0, $2kgHq.CommercialType).Other]: [],
    [(0, $2kgHq.CommercialType).Print]: []
};
const $9e759b4b5a45f96b$export$5ea3b64a9a18410d = {
    /**
   * TV - Network Class A
   */ ["TV Linear Domestic Network Class A (Per Use)"]: {
        id: "TV Linear Domestic Network Class A (Per Use)",
        label: 'Domestic Network Class A',
        media: "TV",
        platform: "Linear",
        category: "National Networks (Class A)",
        usesType: "Per Use",
        perUse: true,
        specialAttributes: [
            'Domestic',
            'Network',
            'Class A'
        ]
    },
    ["TV Linear Domestic Network Class A (13 Weeks Maximum)"]: {
        id: "TV Linear Domestic Network Class A (13 Weeks Maximum)",
        label: 'Network Class A (13 Weeks Maximum)',
        media: "TV",
        platform: "Linear",
        category: "National Networks (Class A)",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Network',
            'Class A'
        ]
    },
    /**
   * TV - ION & DigiNet
   */ ["TV Linear Domestic ION And Diginet Per Use"]: {
        id: "TV Linear Domestic ION And Diginet Per Use",
        label: 'ION And Diginet Per Use',
        media: "TV",
        platform: "Linear",
        category: "ION & Diginet",
        usesType: "Per Use",
        perUse: true,
        specialAttributes: [
            'Domestic',
            'ION And Diginet'
        ]
    },
    ["TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)"]: {
        id: "TV Linear Domestic ION And Diginet (13 Weeks Unlimited Use)",
        label: 'ION And Diginet (13 Weeks Unlimited Use)',
        media: "TV",
        platform: "Linear",
        category: "ION & Diginet",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'ION And Diginet'
        ]
    },
    /**
   * TV - Spanish Language Program
   */ ["TV Spanish Language Program (4 Week)"]: {
        id: "TV Spanish Language Program (4 Week)",
        label: 'Spanish Language Program (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Spanish-Language Program Use",
        language: "Spanish",
        cycle_number: 4,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Spanish Language Program'
        ]
    },
    ["TV Spanish Language Program (13 Week)"]: {
        id: "TV Spanish Language Program (13 Week)",
        label: 'Spanish Language Program (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Spanish-Language Program Use",
        language: "Spanish",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Spanish Language Program'
        ]
    },
    ["TV Spanish Language Program (52 Week)"]: {
        id: "TV Spanish Language Program (52 Week)",
        label: 'Spanish Language Program (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Spanish-Language Program Use",
        language: "Spanish",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Spanish Language Program'
        ]
    },
    /**
   * TV - WildSpot
   */ ["TV Linear Domestic Wild Spot All Markets (4 Week)"]: {
        id: "TV Linear Domestic Wild Spot All Markets (4 Week)",
        label: 'Wild Spot All Markets (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Wildspot",
        marketSpec: "All Markets",
        cycle_number: 4,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets'
        ]
    },
    ["TV Linear Domestic Wild Spot All Markets (13 Week)"]: {
        id: "TV Linear Domestic Wild Spot All Markets (13 Week)",
        label: 'Wild Spot All Markets (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Wildspot",
        marketSpec: "All Markets",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets'
        ]
    },
    ["TV Linear Domestic Wild Spot All Markets (52 Week)"]: {
        id: "TV Linear Domestic Wild Spot All Markets (52 Week)",
        label: 'Wild Spot All Markets (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Wildspot",
        marketSpec: "All Markets",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets'
        ]
    },
    ["TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)"]: {
        id: "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 4 Week)",
        label: 'Wild Spot All Markets (No NY/LA - 4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Wildspot",
        marketSpec: "All Markets (No NY/CHI/LA)",
        cycle_number: 4,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets',
            'No NY/LA'
        ]
    },
    ["TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)"]: {
        id: "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 13 Week)",
        label: 'Wild Spot All Markets (No NY/LA - 13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Wildspot",
        marketSpec: "All Markets (No NY/CHI/LA)",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets',
            'No NY/LA'
        ]
    },
    ["TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)"]: {
        id: "TV Linear Domestic WildSpot All Markets (No NY/CHI/LA, 52 Week)",
        label: 'Wild Spot All Markets (No NY/LA - 52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Wildspot",
        marketSpec: "All Markets (No NY/CHI/LA)",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Wild Spot',
            'All Markets',
            'No NY/LA'
        ]
    },
    /**
   * TV - National Cable
   */ ["TV Linear Domestic National Cable (4 Week)"]: {
        id: "TV Linear Domestic National Cable (4 Week)",
        label: 'National Cable (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "National Cable",
        cycle_number: 4,
        cycle_unit: "Week",
        cableMarket: "National Cable",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable'
        ]
    },
    ["TV Linear Domestic National Cable (13 Week)"]: {
        id: "TV Linear Domestic National Cable (13 Week)",
        label: 'National Cable (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "National Cable",
        cycle_number: 13,
        cycle_unit: "Week",
        cableMarket: "National Cable",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable'
        ]
    },
    ["TV Linear Domestic National Cable (52 Week)"]: {
        id: "TV Linear Domestic National Cable (52 Week)",
        label: 'National Cable (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "National Cable",
        cycle_number: 52,
        cycle_unit: "Week",
        cableMarket: "National Cable",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable'
        ]
    },
    /**
   * TV - National Cable Single Network
   */ ["TV Linear Domestic National Cable Single Network (4 Week)"]: {
        id: "TV Linear Domestic National Cable Single Network (4 Week)",
        label: 'National Cable - Single Network (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "National Cable",
        cycle_number: 4,
        cycle_unit: "Week",
        cableMarket: "National Cable",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable',
            'Single Network'
        ]
    },
    ["TV Linear Domestic National Cable Single Network (13 Week)"]: {
        id: "TV Linear Domestic National Cable Single Network (13 Week)",
        label: 'National Cable - Single Network (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "National Cable",
        cycle_number: 13,
        cycle_unit: "Week",
        cableMarket: "National Cable",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable',
            'Single Network'
        ]
    },
    ["TV Linear Domestic National Cable Single Network (52 Week)"]: {
        id: "TV Linear Domestic National Cable Single Network (52 Week)",
        label: 'National Cable - Single Network (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "National Cable",
        cycle_number: 52,
        cycle_unit: "Week",
        cableMarket: "National Cable",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'National Cable',
            'Single Network'
        ]
    },
    /**
   * TV - Local Cable (Up to 1M Subs)
   */ ["TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)"]: {
        id: "TV Linear Domestic Local Cable (Up To 1M Subscribers) (4 Week)",
        label: 'Local Cable (Up to 1M Subscribers) (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 4,
        cycle_unit: "Week",
        cableMarket: "Local Cable (Up To 1M Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            'Up To 1M Subscribers'
        ]
    },
    ["TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)"]: {
        id: "TV Linear Domestic Local Cable (Up To 1M Subscribers) (13 Week)",
        label: 'Local Cable (Up to 1M Subscribers) (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 13,
        cycle_unit: "Week",
        cableMarket: "Local Cable (Up To 1M Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            'Up To 1M Subscribers'
        ]
    },
    ["TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)"]: {
        id: "TV Linear Domestic Local Cable (Up To 1M Subscribers) (52 Week)",
        label: 'Local Cable (Up to 1M Subscribers) (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 52,
        cycle_unit: "Week",
        cableMarket: "Local Cable (Up To 1M Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            'Up To 1M Subscribers'
        ]
    },
    /**
   * TV - Local Cable (1M - 2M Subs)
   */ ["TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)"]: {
        id: "TV Linear Domestic Local Cable (1M To 2M Subscribers) (4 Week)",
        label: 'Local Cable (1M To 2M Subscribers) (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 4,
        cycle_unit: "Week",
        cableMarket: "Local Cable (1M To 2M Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '1M To 2M Subscribers'
        ]
    },
    ["TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)"]: {
        id: "TV Linear Domestic Local Cable (1M To 2M Subscribers) (13 Week)",
        label: 'Local Cable (1M To 2M Subscribers) (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 13,
        cycle_unit: "Week",
        cableMarket: "Local Cable (1M To 2M Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '1M To 2M Subscribers'
        ]
    },
    ["TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)"]: {
        id: "TV Linear Domestic Local Cable (1M To 2M Subscribers) (52 Week)",
        label: 'Local Cable (1M To 2M Subscribers) (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 52,
        cycle_unit: "Week",
        cableMarket: "Local Cable (1M To 2M Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '1M To 2M Subscribers'
        ]
    },
    /**
   * TV - Local Cable (2M - 3M Subs)
   */ ["TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)"]: {
        id: "TV Linear Domestic Local Cable (2M To 3M Subscribers) (4 Week)",
        label: 'Local Cable (2M To 3M Subscribers) (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 4,
        cycle_unit: "Week",
        cableMarket: "Local Cable (2M Plus Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '2M To 3M Subscribers'
        ]
    },
    ["TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)"]: {
        id: "TV Linear Domestic Local Cable (2M To 3M Subscribers) (13 Week)",
        label: 'Local Cable (2M To 3M Subscribers) (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 13,
        cycle_unit: "Week",
        cableMarket: "Local Cable (2M Plus Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '2M To 3M Subscribers'
        ]
    },
    ["TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)"]: {
        id: "TV Linear Domestic Local Cable (2M To 3M Subscribers) (52 Week)",
        label: 'Local Cable (2M To 3M Subscribers) (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Local Cable",
        cycle_number: 52,
        cycle_unit: "Week",
        cableMarket: "Local Cable (2M Plus Subscribers)",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Local Cable',
            '2M To 3M Subscribers'
        ]
    },
    /**
   * TV - Dealer
   */ ["TV Linear Domestic Dealer (4 Week)"]: {
        id: "TV Linear Domestic Dealer (4 Week)",
        label: 'Dealer (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "Dealer",
        cycle_number: 4,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Dealer'
        ]
    },
    ["TV Linear Domestic Dealer (13 Week)"]: {
        id: "TV Linear Domestic Dealer (13 Week)",
        label: 'Dealer (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "Dealer",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Dealer'
        ]
    },
    ["TV Linear Domestic Dealer (52 Week)"]: {
        id: "TV Linear Domestic Dealer (52 Week)",
        label: 'Dealer (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "Dealer",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'Dealer'
        ]
    },
    /**
   * TV - All Other NA Use
   */ ["TV Linear Domestic All Other NA Linear (4 Week)"]: {
        id: "TV Linear Domestic All Other NA Linear (4 Week)",
        label: 'All Other NA Linear (4 Week)',
        media: "TV",
        platform: "Linear",
        category: "All Other North American Use",
        cycle_number: 4,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'All Other NA Linear'
        ]
    },
    ["TV Linear Domestic All Other NA Linear (13 Week)"]: {
        id: "TV Linear Domestic All Other NA Linear (13 Week)",
        label: 'All Other NA Linear (13 Week)',
        media: "TV",
        platform: "Linear",
        category: "All Other North American Use",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'All Other NA Linear'
        ]
    },
    ["TV Linear Domestic All Other NA Linear (52 Week)"]: {
        id: "TV Linear Domestic All Other NA Linear (52 Week)",
        label: 'All Other NA Linear (52 Week)',
        media: "TV",
        platform: "Linear",
        category: "All Other North American Use",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Domestic',
            'All Other NA Linear'
        ]
    },
    /**
   * TV - Foreign Use
   */ ["TV Foreign Use - U.K."]: {
        id: "TV Foreign Use - U.K.",
        label: 'Foreign Use - U.K.',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        globalMarket: "United Kingdom",
        specialAttributes: [
            'Foreign Use',
            'UK'
        ]
    },
    ["TV Foreign Use - Japan"]: {
        id: "TV Foreign Use - Japan",
        label: 'Foreign Use - Japan',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        globalMarket: "Japan",
        specialAttributes: [
            'Foreign Use',
            'Japan'
        ]
    },
    ["TV Foreign Use - Europe"]: {
        id: "TV Foreign Use - Europe",
        label: 'Foreign Use - Europe',
        media: "TV",
        platform: "Foreign",
        globalMarket: "Europe",
        specialAttributes: [
            'Foreign Use',
            'Europe'
        ]
    },
    ["TV Foreign Use - Rest-of-World"]: {
        id: "TV Foreign Use - Rest-of-World",
        label: 'Foreign Use - Rest-of-World',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        globalMarket: "Rest Of World",
        specialAttributes: [
            'Foreign Use',
            'Rest Of World'
        ]
    },
    ["TV Foreign Use - Asia/Pacific"]: {
        id: "TV Foreign Use - Asia/Pacific",
        label: 'Foreign Use - Asia Pacific',
        media: "TV",
        platform: "Foreign",
        usesType: "Unlimited Use",
        globalMarket: "Asia Pacific",
        specialAttributes: [
            'Foreign Use',
            'Asia Pacific'
        ]
    },
    ["TV Foreign Use - Worldwide"]: {
        id: "TV Foreign Use - Worldwide",
        label: 'Foreign Use - Worldwide',
        media: "TV",
        platform: "Foreign",
        unlimitedUse: true,
        globalMarket: "Worldwide",
        specialAttributes: [
            'Foreign Use',
            'Worldwide'
        ]
    },
    ["TV Foreign Use - Spanish Language (Americas)"]: {
        id: "TV Foreign Use - Spanish Language (Americas)",
        label: 'Foreign Use - Spanish Language (Americas)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Spanish",
        globalMarket: "Americas",
        specialAttributes: [
            'Foreign Use',
            'Spanish Language'
        ]
    },
    ["TV Foreign Use - Spanish Language (Caribbean)"]: {
        id: "TV Foreign Use - Spanish Language (Caribbean)",
        label: 'Foreign Use - Spanish Language (Caribbean)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Spanish",
        globalMarket: "Caribbean",
        specialAttributes: [
            'Foreign Use',
            'Spanish Language'
        ]
    },
    ["TV Foreign Use - Spanish Language (Americas And Caribbean)"]: {
        id: "TV Foreign Use - Spanish Language (Americas And Caribbean)",
        label: 'Foreign Use - Spanish Language (Americas And Caribbean)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Spanish",
        globalMarket: "Americas And Caribbean",
        specialAttributes: [
            'Foreign Use',
            'Spanish Language'
        ]
    },
    ["TV Foreign Use - Other (UK)"]: {
        id: "TV Foreign Use - Other (UK)",
        label: 'Foreign Use - Other (UK)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Other",
        globalMarket: "United Kingdom",
        specialAttributes: [
            'Foreign Use',
            'Other',
            'UK'
        ]
    },
    ["TV Foreign Use - Other (Japan)"]: {
        id: "TV Foreign Use - Other (Japan)",
        label: 'Foreign Use - Other (Japan)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Other",
        globalMarket: "Japan",
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Japan'
        ]
    },
    ["TV Foreign Use - Other (Europe)"]: {
        id: "TV Foreign Use - Other (Europe)",
        label: 'Foreign Use - Other (Europe)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Other",
        globalMarket: "Europe",
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Europe'
        ]
    },
    ["TV Foreign Use - Other (Rest Of World)"]: {
        id: "TV Foreign Use - Other (Rest Of World)",
        label: 'Foreign Use - Other (Rest Of World)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Other",
        globalMarket: "Rest Of World",
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Rest Of World'
        ]
    },
    ["TV Foreign Use - Other (Asia Pacific)"]: {
        id: "TV Foreign Use - Other (Asia Pacific)",
        label: 'Foreign Use - Other (Asia Pacific)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Other",
        globalMarket: "Asia Pacific",
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Asia Pacific'
        ]
    },
    ["TV Foreign Use - Other (Worldwide)"]: {
        id: "TV Foreign Use - Other (Worldwide)",
        label: 'Foreign Use - Other (Worldwide)',
        media: "TV",
        platform: "Foreign",
        category: "Foreign Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        language: "Other",
        globalMarket: "Worldwide",
        specialAttributes: [
            'Foreign Use',
            'Other',
            'Worldwide'
        ]
    },
    /**
   * TV - AFM
   */ ["TV AFM First Use (Internet Only Or US)"]: {
        id: "TV AFM First Use (Internet Only Or US)",
        label: 'AFM First Use (Internet Only Or US)',
        media: "TV",
        platform: "AFM",
        category: "AFM First Use",
        usesType: "Per Use",
        perUse: true,
        useLimit: {
            minimum: 1,
            maximum: 1
        },
        specialAttributes: [
            'AFM',
            'First Use'
        ]
    },
    ["TV AFM Foreign - 1 Year (Europe/No Europe)"]: {
        id: "TV AFM Foreign - 1 Year (Europe/No Europe)",
        label: 'AFM Foreign - 1 Year (Europe/No Europe)',
        media: "TV",
        platform: "AFM",
        category: "AFM Foreign Use",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Foreign',
            '1 Year',
            'Europe/No Europe'
        ]
    },
    ["TV AFM Foreign (Worldwide)"]: {
        id: "TV AFM Foreign (Worldwide)",
        label: 'AFM Foreign (Worldwide)',
        media: "TV",
        platform: "AFM",
        category: "AFM Foreign Use",
        globalMarket: "Worldwide",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Foreign',
            'Worldwide'
        ]
    },
    /**
   * Digital - Streaming Platforms
   */ ["TV Digital Streaming Platforms (4 Week)"]: {
        id: "TV Digital Streaming Platforms (4 Week)",
        label: 'Digital Streaming Platforms (4 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Streaming Platforms",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 4,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Streaming Platforms'
        ]
    },
    ["TV Digital Streaming Platforms (13 Week)"]: {
        id: "TV Digital Streaming Platforms (13 Week)",
        label: 'Digital Streaming Platforms (13 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Streaming Platforms",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Streaming Platforms'
        ]
    },
    ["TV Digital Streaming Platforms (52 Week)"]: {
        id: "TV Digital Streaming Platforms (52 Week)",
        label: 'Digital Streaming Platforms (52 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Streaming Platforms",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 52,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Streaming Platforms'
        ]
    },
    /**
   * Digital - Traditional Digital (no YouTube)
   */ ["TV Digital Traditional Digital (4 Week)"]: {
        id: "TV Digital Traditional Digital (4 Week)",
        label: 'Digital Traditional Digital (4 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Traditional Digital",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 4,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Traditional Digital'
        ]
    },
    ["TV Digital Traditional Digital (13 Week)"]: {
        id: "TV Digital Traditional Digital (13 Week)",
        label: 'Digital Traditional Digital (13 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Traditional Digital",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Traditional Digital'
        ]
    },
    ["TV Digital Traditional Digital (52 Week)"]: {
        id: "TV Digital Traditional Digital (52 Week)",
        label: 'Digital Traditional Digital (52 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Traditional Digital",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 52,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Traditional Digital'
        ]
    },
    /**
   * Digital - Traditional Digital w/YouTube
   */ ["TV Digital Traditional Digital w/YouTube (4 Week)"]: {
        id: "TV Digital Traditional Digital w/YouTube (4 Week)",
        label: 'Digital Traditional Digital w/YouTube (4 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Traditional Digital w/YouTube",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 4,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Traditional Digital',
            'YouTube'
        ]
    },
    ["TV Digital Traditional Digital w/YouTube (13 Week)"]: {
        id: "TV Digital Traditional Digital w/YouTube (13 Week)",
        label: 'Digital Traditional Digital w/YouTube (13 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Traditional Digital w/YouTube",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Traditional Digital',
            'YouTube'
        ]
    },
    ["TV Digital Traditional Digital w/YouTube (52 Week)"]: {
        id: "TV Digital Traditional Digital w/YouTube (52 Week)",
        label: 'Digital Traditional Digital w/YouTube (52 Week)',
        media: "Digital",
        platform: "Digital",
        category: "Traditional Digital w/YouTube",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 52,
        cycle_unit: "Week",
        specialAttributes: [
            'Digital',
            'Traditional Digital',
            'YouTube'
        ]
    },
    ["TV Digital Gaming VR/AR, Emerging Platforms"]: {
        id: "TV Digital Gaming VR/AR, Emerging Platforms",
        label: 'Digital Gaming VR/AR, Emerging Platforms',
        media: "Digital",
        platform: "Digital",
        category: "Gaming Platforms, VR/AR, Emerging Platforms",
        specialAttributes: [
            'Digital',
            'Gaming VR/AR',
            'Emerging Platforms'
        ]
    },
    /**
   * Social Media Waiver
   */ ["Social Media Waiver - Social Media (30 Day Cycle)"]: {
        id: "Social Media Waiver - Social Media (30 Day Cycle)",
        label: 'Social Media (30 Day Cycle)',
        media: "Social Media",
        platform: "Digital",
        category: "Social Media",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 30,
        cycle_unit: "Day",
        specialAttributes: [
            'Digital',
            'Social Media'
        ]
    },
    ["Social Media Waiver - YouTube"]: {
        id: "Social Media Waiver - YouTube",
        label: 'YouTube',
        media: "Social Media",
        platform: "Digital",
        category: "Social Media",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Digital',
            'Social Media',
            'YouTube'
        ]
    },
    /**
   * Theatrical/Industrial
   */ ["TV Theatrical Industrial (Up To 30 Days)"]: {
        id: "TV Theatrical Industrial (Up To 30 Days)",
        label: 'Theatrical Industrial (Up To 30 Days)',
        media: "TV",
        platform: "Theatrical/Industrial",
        category: "Theatrical & Industrial Use",
        cycle_number: 30,
        cycle_unit: "Day",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Up To 30 Days'
        ]
    },
    ["TV Theatrical Industrial (Use Through MPU)"]: {
        id: "TV Theatrical Industrial (Use Through MPU)",
        label: 'Theatrical Industrial (Use Through MPU)',
        media: "TV",
        platform: "Theatrical/Industrial",
        category: "Theatrical & Industrial Use",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Use Through MPU'
        ]
    },
    ["TV Theatrical Industrial (Dist On Physical Media)"]: {
        id: "TV Theatrical Industrial (Dist On Physical Media)",
        label: 'Theatrical Industrial (Dist On Physical Media)',
        media: "TV",
        platform: "Theatrical/Industrial",
        category: "Theatrical & Industrial Use",
        specialAttributes: [
            'Dist On Physical Media'
        ]
    },
    /**
   * Radio
   */ ["Radio AFM Radio Spot - Internet (8 Week)"]: {
        id: "Radio AFM Radio Spot - Internet (8 Week)",
        label: 'AFM Radio Spot - Internet (8 Week)',
        media: "Radio",
        platform: "AFM",
        category: "AFM Internet Radio Spot",
        cycle_number: 8,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Radio Spot',
            'Internet'
        ]
    },
    ["Radio AFM Radio Spot - Internet (26 Week)"]: {
        id: "Radio AFM Radio Spot - Internet (26 Week)",
        label: 'AFM Radio Spot - Internet (26 Week)',
        media: "Radio",
        platform: "AFM",
        category: "AFM Internet Radio Spot",
        cycle_number: 26,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Radio Spot',
            'Internet'
        ]
    },
    ["Radio AFM Radio Spot - Internet (52 Week)"]: {
        id: "Radio AFM Radio Spot - Internet (52 Week)",
        label: 'AFM Radio Spot - Internet (52 Week)',
        media: "Radio",
        platform: "AFM",
        category: "AFM Internet Radio Spot",
        cycle_number: 52,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'AFM',
            'Radio Spot',
            'Internet'
        ]
    },
    ["Radio Network - 1 Week Unlimited Use"]: {
        id: "Radio Network - 1 Week Unlimited Use",
        label: 'Radio Network (1 Week Unlimited Use)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 1,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '1 Week',
            'Unlimited Use'
        ]
    },
    ["Radio Network - 4 Week Unlimited Use"]: {
        id: "Radio Network - 4 Week Unlimited Use",
        label: 'Radio Network (4 Weeks Unlimited Use)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 4,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '4 Weeks',
            'Unlimited Use'
        ]
    },
    ["Radio Network - 8 Week Unlimited Use"]: {
        id: "Radio Network - 8 Week Unlimited Use",
        label: 'Radio Network (8 Weeks Unlimited Use)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 8,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '8 Weeks',
            'Unlimited Use'
        ]
    },
    ["Radio Network - 13 Week Unlimited Use"]: {
        id: "Radio Network - 13 Week Unlimited Use",
        label: 'Radio Network (13 Weeks Unlimited Use)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            'Unlimited Use'
        ]
    },
    ["Radio Network - 13 Weeks 26 Uses"]: {
        id: "Radio Network - 13 Weeks 26 Uses",
        label: 'Radio Network (13 Weeks, 26 Uses)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Per Use",
        perUse: true,
        useLimit: {
            maximum: 26
        },
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            '26 Uses'
        ]
    },
    ["Radio Network - 13 Weeks 39 Uses"]: {
        id: "Radio Network - 13 Weeks 39 Uses",
        label: 'Radio Network (13 Weeks, 39 Uses)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 13,
        cycle_unit: "Week",
        usesType: "Per Use",
        perUse: true,
        useLimit: {
            maximum: 39
        },
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            '39 Uses'
        ]
    },
    ["Radio Network - 13 Weeks Across The Board Use"]: {
        id: "Radio Network - 13 Weeks Across The Board Use",
        label: 'Radio Network (13 Weeks, Across The Board Use)',
        media: "Radio",
        platform: "Network",
        category: "Radio Network",
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Network',
            '13 Weeks',
            'Across The Board Use'
        ]
    },
    /**
   * Radio - WildSpot
   */ ["Radio Wild Spot - 8 Week (No Major Markets)"]: {
        id: "Radio Wild Spot - 8 Week (No Major Markets)",
        label: 'Radio Wild Spot (8 Week, No Major Markets)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'No Major Markets'
        ],
        marketSpec: "No Major Markets"
    },
    ["Radio Wild Spot - 8 Week (NY Only)"]: {
        id: "Radio Wild Spot - 8 Week (NY Only)",
        label: 'Radio Wild Spot (8 Week, NY Only)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'NY Only'
        ],
        marketSpec: "NY Only"
    },
    ["Radio Wild Spot - 8 Week (LA Or Chicago Only)"]: {
        id: "Radio Wild Spot - 8 Week (LA Or Chicago Only)",
        label: 'Radio Wild Spot (8 Week, LA Or Chicago Only)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'LA Or Chicago Only'
        ],
        marketSpec: "LA Or Chicago Only"
    },
    ["Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)"]: {
        id: "Radio Wild Spot - 8 Week (2 Of LA, NY, Chicago)",
        label: 'Radio Wild Spot (8 Week, 2 Of LA, NY, Chicago)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            '2 Of LA, NY, Chicago'
        ],
        marketSpec: "2 Of LA, NY, Chicago"
    },
    ["Radio WildSpot - 8 Week (LA, NY, And Chicago)"]: {
        id: "Radio WildSpot - 8 Week (LA, NY, And Chicago)",
        label: 'Radio Wild Spot (8 Week, LA, NY, And Chicago)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '8 Week',
            'LA, NY, And Chicago'
        ],
        marketSpec: "LA, NY, And Chicago"
    },
    ["Radio Wild Spot - 13 Weeks (No Major Markets)"]: {
        id: "Radio Wild Spot - 13 Weeks (No Major Markets)",
        label: 'Radio Wild Spot (13 Weeks, No Major Markets)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'No Major Markets'
        ],
        marketSpec: "No Major Markets"
    },
    ["Radio Wild Spot - 13 Weeks (NY Only)"]: {
        id: "Radio Wild Spot - 13 Weeks (NY Only)",
        label: 'Radio Wild Spot (13 Weeks, NY Only)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'NY Only'
        ],
        marketSpec: "NY Only"
    },
    ["Radio Wild Spot - 13 Weeks (LA Or Chicago Only)"]: {
        id: "Radio Wild Spot - 13 Weeks (LA Or Chicago Only)",
        label: 'Radio Wild Spot (13 Weeks, LA Or Chicago Only)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'LA Or Chicago Only'
        ],
        marketSpec: "LA Or Chicago Only"
    },
    ["Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)"]: {
        id: "Radio Wild Spot - 13 Weeks (2 Of LA, NY, Chicago)",
        label: 'Radio Wild Spot (13 Weeks, 2 Of LA, NY, Chicago)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            '2 Of LA, NY, Chicago'
        ],
        marketSpec: "2 Of LA, NY, Chicago"
    },
    ["Radio WildSpot - 13 Weeks (LA, NY, And Chicago)"]: {
        id: "Radio WildSpot - 13 Weeks (LA, NY, And Chicago)",
        label: 'Radio Wild Spot (13 Weeks, LA, NY, And Chicago)',
        media: "Radio",
        platform: "WildSpot",
        category: "Radio Wildspot",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 13,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Wild Spot',
            '13 Weeks',
            'LA, NY, And Chicago'
        ],
        marketSpec: "LA, NY, And Chicago"
    },
    /**
   * Radio - Internet
   */ ["Radio Internet - 4 Week"]: {
        id: "Radio Internet - 4 Week",
        label: 'Radio Internet (4 Week)',
        media: "Radio",
        platform: "Internet",
        category: "Internet Radio",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 4,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Internet',
            '4 Week'
        ]
    },
    ["Radio Internet - 8 Week Move Over"]: {
        id: "Radio Internet - 8 Week Move Over",
        label: 'Radio Internet (8 Week Move Over)',
        media: "Radio",
        platform: "Internet",
        category: "Internet Radio",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Internet',
            '8 Week Move Over'
        ]
    },
    ["Radio Internet - 8 Week Made For"]: {
        id: "Radio Internet - 8 Week Made For",
        label: 'Radio Internet (8 Week Made For)',
        media: "Radio",
        platform: "Internet",
        category: "Internet Radio",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Internet',
            '8 Week Made For'
        ],
        audioMadeMove: "Made For"
    },
    ["Radio Internet - 1 Year Move Over"]: {
        id: "Radio Internet - 1 Year Move Over",
        label: 'Radio Internet (1 Year Move Over)',
        media: "Radio",
        platform: "Internet",
        category: "Internet Radio",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 52,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Internet',
            '1 Year Move Over'
        ],
        audioMadeMove: "Move Over"
    },
    ["Radio Internet - 1 Year Made For"]: {
        id: "Radio Internet - 1 Year Made For",
        label: 'Radio Internet (1 Year Made For)',
        media: "Radio",
        platform: "Internet",
        category: "Internet Radio",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 52,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Internet',
            '1 Year Made For'
        ],
        audioMadeMove: "Made For"
    },
    /**
   * Radio - Dealer
   */ ["Radio Dealer - 8 Week"]: {
        id: "Radio Dealer - 8 Week",
        label: 'Radio Dealer (8 Week)',
        media: "Radio",
        platform: "Dealer",
        category: "Radio Dealer",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 8,
        cycle_unit: "Week",
        specialAttributes: [
            'Radio',
            'Dealer',
            '8 Week'
        ]
    },
    ["Radio Dealer - 6 Months"]: {
        id: "Radio Dealer - 6 Months",
        label: 'Radio Dealer (6 Months)',
        media: "Radio",
        platform: "Dealer",
        category: "Radio Dealer",
        usesType: "Unlimited Use",
        unlimitedUse: true,
        cycle_number: 6,
        cycle_unit: "Month",
        specialAttributes: [
            'Radio',
            'Dealer',
            '6 Months'
        ]
    }
};

});

parcelRegister("dKesY", function(module, exports) {
/**
 * Validation Token Types
 */ var $ea53f55611b6f0ad$export$21d7833832799426 = /*#__PURE__*/ function(ValidationTokenType) {
    ValidationTokenType["Confirmation"] = "confirmation";
    ValidationTokenType["ResetPassword"] = "reset-password";
    ValidationTokenType["GroupInvitation"] = "group-invitation";
    ValidationTokenType["PerformerOnboarding"] = "performer-onboarding";
    ValidationTokenType["CharacterPhotoCapture"] = "character-photo-capture";
    return ValidationTokenType;
}({});

});


parcelRegister("03pLZ", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("5vW6j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getActivityByTime = module.exports.getIsSpeaker = module.exports.getIsSinger = module.exports.getIsStuntPerformer = module.exports.getIsPilot = module.exports.getIsDancer = module.exports.getIsAFMPerformer = module.exports.getIsExtra = module.exports.getIsPrincipal = module.exports.getIsOffCameraGroup = module.exports.getIsOffScreenPrincipal = module.exports.getIsOnCameraGroup = module.exports.getIsOnScreenPrincipal = module.exports.getIsHolidayWorkTime = module.exports.getIsSundayWorkTime = module.exports.getIsSaturdayWorkTime = module.exports.getIsLateNightWorkTime = module.exports.getIsNightWorkTime = module.exports.getIsAFMRecordingSession = module.exports.getIsRecordingSession = module.exports.getIsFitting = module.exports.getIsWardrobeChange = module.exports.getIsMeal = module.exports.getIsTravelFromAfterMidnight = module.exports.getIsTravelFrom = module.exports.getIsTravelToAfterMidnight = module.exports.getIsTravelTo = module.exports.getIsTravel = module.exports.getIsWork = void 0;
parcelRequire("57Ofe");
var $8NtQN = parcelRequire("8NtQN");
var $l2vXU = parcelRequire("l2vXU");
var $ehX4i = parcelRequire("ehX4i");
/**
 * Activity Types
 */ const $403cea9efa055834$var$getIsWork = (activityType)=>$8NtQN.WorkActivityTypes.has(activityType);
module.exports.getIsWork = $403cea9efa055834$var$getIsWork;
const $403cea9efa055834$var$getIsTravel = (activityType)=>$8NtQN.TravelActivityTypes.has(activityType);
module.exports.getIsTravel = $403cea9efa055834$var$getIsTravel;
const $403cea9efa055834$var$getIsTravelTo = (activityType)=>activityType === $8NtQN.SessionActivityType.TravelToLocation;
module.exports.getIsTravelTo = $403cea9efa055834$var$getIsTravelTo;
const $403cea9efa055834$var$getIsTravelToAfterMidnight = (activityType)=>activityType === $8NtQN.SessionActivityType.TravelToLocationAfterMidnight;
module.exports.getIsTravelToAfterMidnight = $403cea9efa055834$var$getIsTravelToAfterMidnight;
const $403cea9efa055834$var$getIsTravelFrom = (activityType)=>activityType === $8NtQN.SessionActivityType.TravelFromLocation;
module.exports.getIsTravelFrom = $403cea9efa055834$var$getIsTravelFrom;
const $403cea9efa055834$var$getIsTravelFromAfterMidnight = (activityType)=>activityType === $8NtQN.SessionActivityType.TravelFromLocationAfterMidnight;
module.exports.getIsTravelFromAfterMidnight = $403cea9efa055834$var$getIsTravelFromAfterMidnight;
const $403cea9efa055834$var$getIsMeal = (activityType)=>$8NtQN.MealActivityTypes.has(activityType);
module.exports.getIsMeal = $403cea9efa055834$var$getIsMeal;
const $403cea9efa055834$var$getIsWardrobeChange = (activityType)=>activityType === $8NtQN.SessionActivityType.WardrobeChange;
module.exports.getIsWardrobeChange = $403cea9efa055834$var$getIsWardrobeChange;
const $403cea9efa055834$var$getIsFitting = (activityType)=>activityType === $8NtQN.SessionActivityType.Fitting;
module.exports.getIsFitting = $403cea9efa055834$var$getIsFitting;
const $403cea9efa055834$var$getIsRecordingSession = (activityType)=>activityType === ($8NtQN.SessionActivityType.VoiceOver || $8NtQN.SessionActivityType.RecordingSession);
module.exports.getIsRecordingSession = $403cea9efa055834$var$getIsRecordingSession;
const $403cea9efa055834$var$getIsAFMRecordingSession = (activityType)=>activityType === $8NtQN.SessionActivityType.AFMRecordingSession;
module.exports.getIsAFMRecordingSession = $403cea9efa055834$var$getIsAFMRecordingSession;
/**
 * Work Time Types
 */ const $403cea9efa055834$var$getIsNightWorkTime = (activityType)=>activityType === $8NtQN.SessionActivityType.WorkTimeNight;
module.exports.getIsNightWorkTime = $403cea9efa055834$var$getIsNightWorkTime;
const $403cea9efa055834$var$getIsLateNightWorkTime = (activityType)=>activityType === $8NtQN.SessionActivityType.WorkTimeLateNight;
module.exports.getIsLateNightWorkTime = $403cea9efa055834$var$getIsLateNightWorkTime;
const $403cea9efa055834$var$getIsSaturdayWorkTime = (activityType)=>activityType === $8NtQN.SessionActivityType.WorkTimeSaturday;
module.exports.getIsSaturdayWorkTime = $403cea9efa055834$var$getIsSaturdayWorkTime;
const $403cea9efa055834$var$getIsSundayWorkTime = (activityType)=>activityType === $8NtQN.SessionActivityType.WorkTimeSunday;
module.exports.getIsSundayWorkTime = $403cea9efa055834$var$getIsSundayWorkTime;
const $403cea9efa055834$var$getIsHolidayWorkTime = (activityType)=>activityType === $8NtQN.SessionActivityType.WorkTimeHoliday;
module.exports.getIsHolidayWorkTime = $403cea9efa055834$var$getIsHolidayWorkTime;
/**
 * Role Types
 */ const $403cea9efa055834$var$getIsOnScreenPrincipal = (rolePerformerType)=>rolePerformerType === $l2vXU.RolePerformerType.OnCameraPrincipal;
module.exports.getIsOnScreenPrincipal = $403cea9efa055834$var$getIsOnScreenPrincipal;
const $403cea9efa055834$var$getIsOnCameraGroup = (rolePerformerType)=>rolePerformerType === $l2vXU.RolePerformerType.OnCameraGroup;
module.exports.getIsOnCameraGroup = $403cea9efa055834$var$getIsOnCameraGroup;
const $403cea9efa055834$var$getIsOffScreenPrincipal = (rolePerformerType)=>rolePerformerType === $l2vXU.RolePerformerType.OffCameraPrincipal;
module.exports.getIsOffScreenPrincipal = $403cea9efa055834$var$getIsOffScreenPrincipal;
const $403cea9efa055834$var$getIsOffCameraGroup = (rolePerformerType)=>rolePerformerType === $l2vXU.RolePerformerType.OffCameraGroup;
module.exports.getIsOffCameraGroup = $403cea9efa055834$var$getIsOffCameraGroup;
const $403cea9efa055834$var$getIsPrincipal = (rolePerformerType)=>(0, module.exports.getIsOnScreenPrincipal)(rolePerformerType) || (0, module.exports.getIsOffScreenPrincipal)(rolePerformerType);
module.exports.getIsPrincipal = $403cea9efa055834$var$getIsPrincipal;
const $403cea9efa055834$var$getIsExtra = (rolePerformerType)=>rolePerformerType === $l2vXU.RolePerformerType.Extra;
module.exports.getIsExtra = $403cea9efa055834$var$getIsExtra;
const $403cea9efa055834$var$getIsAFMPerformer = (rolePerformerType)=>rolePerformerType === $l2vXU.RolePerformerType.AFM;
module.exports.getIsAFMPerformer = $403cea9efa055834$var$getIsAFMPerformer;
const $403cea9efa055834$var$getIsDancer = (roleType)=>roleType === $ehX4i.RoleType.SpecialtyDancer;
module.exports.getIsDancer = $403cea9efa055834$var$getIsDancer;
const $403cea9efa055834$var$getIsPilot = (roleType)=>roleType === $ehX4i.RoleType.Pilot;
module.exports.getIsPilot = $403cea9efa055834$var$getIsPilot;
const $403cea9efa055834$var$getIsStuntPerformer = (roleType)=>roleType === $ehX4i.RoleType.StuntPerformer;
module.exports.getIsStuntPerformer = $403cea9efa055834$var$getIsStuntPerformer;
const $403cea9efa055834$var$getIsSinger = (roleType)=>roleType === $ehX4i.RoleType.Singer;
module.exports.getIsSinger = $403cea9efa055834$var$getIsSinger;
const $403cea9efa055834$var$getIsSpeaker = (roleType)=>roleType === ($ehX4i.RoleType.Narrator || $ehX4i.RoleType.Announcer || $ehX4i.RoleType.Speaker);
module.exports.getIsSpeaker = $403cea9efa055834$var$getIsSpeaker;
/**
 * Looks up Session Activity by time.
 * @param sessionActivities
 * @param timePointer
 * @returns SessionActivity
 */ const $403cea9efa055834$var$getActivityByTime = (sessionActivities, timePointer)=>{
    return sessionActivities[sessionActivities.findIndex((sessionActivity)=>{
        // Equivalent to moment's `.isBetween(start, end, undefined, '[)')` - start-inclusive,
        // end-exclusive. dayjs has no isBetween of its own; matches apps/web/src/utils/time.ts's
        // existing hand-rolled convention for this rather than adding a dayjs plugin.
        const start = timePointer.isSame(sessionActivity.start_time) || timePointer.isAfter(sessionActivity.start_time);
        const end = timePointer.isBefore(sessionActivity.end_time);
        return start && end;
    })];
};
module.exports.getActivityByTime = $403cea9efa055834$var$getActivityByTime;

});


parcelRegister("bPbwt", function(module, exports) {
"use strict";
/**
 * Simple logger function for shared package
 * For full logger, use the one from apps/api
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logger = void 0;
const $89bd654daa73b3f2$var$logger = (namespace)=>{
    return (...args)=>{};
};
module.exports.logger = $89bd654daa73b3f2$var$logger;

});


parcelRegister("4kZY9", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});


parcelRegister("d3B3x", function(module, exports) {

$parcel$export(module.exports, "HoldingFeeStore", () => $4b69679627b4d07a$export$ae5640037daaaa4b);
parcelRequire("hcQWc");
var $lU3Ny = parcelRequire("lU3Ny");
var $g87cD = parcelRequire("g87cD");

var $3kkid = parcelRequire("3kkid");
class $4b69679627b4d07a$export$ae5640037daaaa4b extends (0, $3kkid.BaseStore) {
    getSchedule = async (contractId)=>{
        try {
            return await (0, $g87cD.PerformerContractService).getHoldingFeeSchedule(contractId);
        } catch (e) {
            this.handleError(e);
        }
    };
    updateCycle = async (contractId, cycleNumber, status, notes)=>{
        try {
            const { cycle: cycle } = await (0, $g87cD.PerformerContractService).updateHoldingFeeCycle(contractId, cycleNumber, {
                status: status,
                notes: notes
            });
            return cycle;
        } catch (e) {
            this.handleError(e);
        }
    };
    getProjectDueSoon = async (projectId, withinDays)=>{
        try {
            const { items: items } = await (0, $lU3Ny.HoldingFeeService).listProjectHoldingFeesDue(projectId, withinDays);
            return items;
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("lEt3y", function(module, exports) {

$parcel$export(module.exports, "NotificationStore", () => $8af46b2b02aa7272$export$a44716f177cf9e90);
parcelRequire("hcQWc");
var $d18Ah = parcelRequire("d18Ah");
var $iE4UJ = parcelRequire("iE4UJ");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $8af46b2b02aa7272$export$a44716f177cf9e90 extends (0, $3kkid.BaseStore) {
    currentNotification = undefined;
    notifications = [];
    page = 1;
    limit = 10;
    total = 0;
    unreadCount = 0;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            currentNotification: (0, $hK1qT.observable),
            notifications: (0, $hK1qT.observable),
            page: (0, $hK1qT.observable),
            limit: (0, $hK1qT.observable),
            total: (0, $hK1qT.observable),
            unreadCount: (0, $hK1qT.observable)
        });
    }
    setPage = (page)=>{
        (0, $hK1qT.runInAction)(()=>this.page = page);
    };
    handleMessage = (msg)=>{
        const NOTIFICATION_TYPES = [
            (0, $d18Ah.MessageType).NOTIFICATION,
            (0, $d18Ah.MessageType).PERFORMER_CONTRACT_DECLINED
        ];
        if (msg && NOTIFICATION_TYPES.includes(msg.type)) {
            // List is first-in, last-out
            const updatedMsgs = [
                msg
            ].concat(this.notifications.length + 1 > this.limit ? this.notifications.slice(0, -1) : this.notifications);
            (0, $hK1qT.runInAction)(()=>{
                this.notifications = updatedMsgs;
                if (msg.unread) this.unreadCount += 1;
            });
            return msg;
        }
    };
    markAsRead = async ()=>{
        await (0, $iE4UJ.NotificationService).bulkUpdate({
            ids: this.notifications.map((n)=>n.id),
            unread: false
        });
        const { count: count } = await (0, $iE4UJ.NotificationService).getUnreadCount();
        (0, $hK1qT.runInAction)(()=>{
            this.unreadCount = count;
        });
    };
    list = async ()=>{
        try {
            const [{ notifications: notifications, page: page, total: total }, { count: count }] = await Promise.all([
                (0, $iE4UJ.NotificationService).listNotifications(undefined, this.limit, this.page),
                (0, $iE4UJ.NotificationService).getUnreadCount()
            ]);
            (0, $hK1qT.runInAction)(()=>{
                this.notifications = notifications;
                this.page = page;
                this.total = total;
                this.unreadCount = count;
            });
            return notifications;
        } catch (e) {
            this.handleError(e);
        }
    };
    get = async (notificationId)=>{
        try {
            const { notification: notification } = await (0, $iE4UJ.NotificationService).getNotification(notificationId, 'user');
            (0, $hK1qT.runInAction)(()=>{
                this.currentNotification = notification;
            });
            return notification;
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("e4I9p", function(module, exports) {

$parcel$export(module.exports, "PerformerStore", () => $fbc73f0d483e0d60$export$6134d282cc8214b9);
parcelRequire("hcQWc");
var $g87cD = parcelRequire("g87cD");
var $1KlRo = parcelRequire("1KlRo");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");

var $dOfWq = parcelRequire("dOfWq");
var $fbc73f0d483e0d60$require$Buffer = $dOfWq.Buffer;
class $fbc73f0d483e0d60$export$6134d282cc8214b9 extends (0, $3kkid.BaseStore) {
    _performers;
    _loading;
    _error;
    isSaving = false;
    constructor(rootStore){
        super(rootStore);
        this._performers = [];
        this._loading = false;
        this._error = null;
        (0, $hK1qT.makeObservable)(this, {
            _performers: (0, $hK1qT.observable),
            _loading: (0, $hK1qT.observable),
            _error: (0, $hK1qT.observable),
            isSaving: (0, $hK1qT.observable),
            setLoading: (0, $hK1qT.action),
            setError: (0, $hK1qT.action),
            setPerformers: (0, $hK1qT.action),
            loadPerformersByProject: (0, $hK1qT.action),
            createPerformer: (0, $hK1qT.action),
            updatePerformer: (0, $hK1qT.action),
            deletePerformer: (0, $hK1qT.action),
            // createContract: action,
            updateContract: (0, $hK1qT.action),
            declineContract: (0, $hK1qT.action),
            getContract: (0, $hK1qT.action),
            sendContract: (0, $hK1qT.action),
            logTime: (0, $hK1qT.action),
            deleteTimeLog: (0, $hK1qT.action),
            approveTimeLog: (0, $hK1qT.action)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    setLoading = (loading)=>{
        this._loading = loading;
    };
    setError = (error)=>{
        this._error = error;
    };
    setPerformers = (performers)=>{
        this._performers = performers;
    };
    get performers() {
        return (0, $hK1qT.toJS)(this._performers);
    }
    get loading() {
        return this._loading;
    }
    get error() {
        return this._error;
    }
    /**
   * Performers
   */ createPerformer = async ({ projectId: projectId, ...req })=>{
        try {
            this.setLoading(true);
            this.setIsSaving(true);
            const { performer: performer } = await (0, $1KlRo.PerformerService).createPerformer({
                projectId: projectId,
                ...req
            });
            // If creating a performer for the current project, add it to the performers list
            if (this._performers.length && this._performers[0]?.contracts.find((contract)=>contract.project.id === projectId)) (0, $hK1qT.runInAction)(()=>{
                this._performers.push(performer);
            });
            return performer;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
            this.setIsSaving(false);
        }
    };
    /**
   * Hire existing performer
   * @param performerId
   * @param projectId
   * @returns
   */ hireExistingPerformer = async (req)=>{
        try {
            this.setLoading(true);
            this.setIsSaving(true);
            const { performer: performer } = await (0, $1KlRo.PerformerService).hireExistingPerformer(req);
            // If hiring a performer for the current project, add it to the performers list
            if (this._performers.length && this._performers[0]?.contracts.find((contract)=>contract.project.id === req.projectId)) (0, $hK1qT.runInAction)(()=>{
                //update this performer in the list
                const index = this._performers.findIndex((p)=>p.id === performer.id);
                if (index !== -1) this._performers[index] = performer;
                else this._performers.push(performer);
            });
            return performer;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
            this.setIsSaving(false);
        }
    };
    resendInvite = async (performer, projectId)=>{
        if (!performer || !projectId) {
            this.handleError('Performer data or Project ID missing. Cannot invite performer.');
            return;
        }
        try {
            this.setLoading(true);
            await (0, $1KlRo.PerformerService).invitePerformer({
                performerId: performer.id,
                email: performer.email,
                projectId: projectId
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
        }
    };
    updatePerformer = async (performer)=>{
        if (!performer.id) throw new Error('Performer ID is required for update');
        const updateRequest = {
            ...performer,
            roleIds: performer.roles?.map((role)=>role.id),
            lastName: performer.last_name ? performer.last_name : undefined,
            firstName: performer.first_name ? performer.first_name : undefined
        };
        try {
            this.setLoading(true);
            this.setIsSaving(true);
            const { performer: updatedPerformer } = await (0, $1KlRo.PerformerService).updatePerformer(performer.id, updateRequest);
            // Update the performer in the list if it exists
            (0, $hK1qT.runInAction)(()=>{
                const index = this._performers.findIndex((p)=>p.id === performer.id);
                if (index !== -1 && updatedPerformer) this._performers[index] = updatedPerformer;
            });
            return updatedPerformer;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
            this.setIsSaving(false);
        }
    };
    deletePerformer = async (performerId)=>{
        try {
            this.setLoading(true);
            this.setIsSaving(true);
            await (0, $1KlRo.PerformerService).deletePerformer(performerId);
            // Remove the performer from the list
            (0, $hK1qT.runInAction)(()=>{
                this._performers = this._performers.filter((p)=>p.id !== performerId);
            });
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        } finally{
            this.setLoading(false);
            this.setIsSaving(false);
        }
    };
    getPerformer = async (performerId, relations)=>{
        try {
            this.setLoading(true);
            const { performer: performer } = await (0, $1KlRo.PerformerService).getPerformer(performerId, relations);
            return performer;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
        }
    };
    lookupByEmail = async (email)=>{
        try {
            this.setLoading(true);
            const { performer: performer } = await (0, $1KlRo.PerformerService).lookupPerformerByEmail(email);
            return performer;
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
        }
    };
    searchPerformers = async (search, projectId)=>{
        try {
            const { performers: performers } = await (0, $1KlRo.PerformerService).listPerformers(projectId, search);
            return performers;
        } catch (e) {
            this.handleError(e);
            return [];
        }
    };
    loadPerformersByProject = async (projectId)=>{
        try {
            this.setLoading(true);
            this.setError(null);
            const { performers: performers } = await (0, $1KlRo.PerformerService).listPerformers(projectId, undefined, undefined, undefined, 'contracts,roles');
            (0, $hK1qT.runInAction)(()=>{
                this._performers = performers || [];
            });
            return performers;
        } catch (e) {
            this.handleError(e);
            this.setError(e instanceof Error ? e.message : 'Failed to load performers');
            return [];
        } finally{
            this.setLoading(false);
        }
    };
    uploadSelfie = async (selfie)=>{
        try {
            this.setLoading(true);
            await (0, $1KlRo.PerformerService).uploadPerformerSelfie({
                selfie: selfie
            });
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
        }
    };
    getSelfieUrl = async (performerId)=>{
        try {
            this.setLoading(true);
            const { url: url } = await (0, $1KlRo.PerformerService).getPerformerSelfieUrl(performerId);
            return url;
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
        }
    };
    /**
	 * Create the everee embed session for onboarding
	//  */ // createEvereeEmbedSession = async (experience: EvereeEmbedExperience) => {
    //   try {
    //     this.setLoading(true);
    //     const response = await PerformerService.createEmbedSession({experience});
    //     return response;
    //   } catch (e) {
    //     this.handleError(e);
    //   } finally {
    //     this.setLoading(false);
    //   }
    // };
    /**
   * Validate Onboarding Token
   */ validateOnboardingToken = async (token)=>{
        try {
            this.setLoading(true);
            const response = await (0, $1KlRo.PerformerService).validatePerformerOnboardingToken(token);
            return response;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
        }
    };
    /**
   * Contract Management
   */ listPerformerContracts = async ({ projectId: projectId, performerId: performerId, commercialId: commercialId, relations: relations })=>{
        if (!(projectId || performerId || commercialId)) return [];
        try {
            this.setLoading(true);
            this.setError(null);
            const { contracts: contracts } = await (0, $g87cD.PerformerContractService).listPerformerContracts(performerId, commercialId, projectId, undefined, undefined, undefined, relations);
            return contracts;
        } catch (e) {
            this.handleError(e);
            this.setError(e instanceof Error ? e.message : 'Failed to load contracts');
            return [];
        } finally{
            this.setLoading(false);
        }
    };
    updateUsageGuaranteeAmount = async (contractId, usageGuaranteeAmount)=>{
        try {
            const { contract: contract } = await (0, $g87cD.PerformerContractService).updatePerformerContract(contractId, {
                usage_guarantee_amount: usageGuaranteeAmount
            });
            return contract;
        } catch (e) {
            this.handleError(e);
        }
    };
    cancelContract = async (contractId)=>{
        try {
            this.setLoading(true);
            const { contract: contract } = await (0, $g87cD.PerformerContractService).cancelContract(contractId);
            return contract;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
        }
    };
    updateContract = async (contractId, contractData)=>{
        try {
            this.setLoading(true);
            this.setIsSaving(true);
            // Type cast to any since the TUpdatePerformerContractRequest type seems outdated
            // and doesn't include all the fields that the actual API accepts
            const response = await (0, $g87cD.PerformerContractService).updatePerformerContract(contractId, {
                // Contract date fields (matching actual model)
                contractDayAndMonth: contractData.contractDayAndMonth,
                contractTwoDigitYear: contractData.contractTwoDigitYear,
                // Producer and agency info
                producerName: contractData.producerName,
                agencyName: contractData.agencyName,
                agencyAddress: contractData.agencyAddress,
                producerAddress: contractData.producerAddress,
                // Advertiser and product (combined field)
                advertiserAndProduct: contractData.advertiserAndProduct,
                // Commercial details
                commercialTitlesAndAdIds: contractData.commercialTitlesAndAdIds,
                numberOfCommercials: contractData.numberOfCommercials,
                numberOfTags: contractData.numberOfTags,
                // Role and performance details
                classification: contractData.classification,
                partToBePlayed: contractData.partToBePlayed,
                cityAndState: contractData.cityAndState,
                placeOfEngagement: contractData.placeOfEngagement,
                dateAndHoursOfEmployment: contractData.dateAndHoursOfEmployment,
                // Compensation
                compensation: contractData.compensation,
                // Performance type boolean flags
                isOnCamera: contractData.isOnCamera,
                isOffCamera: contractData.isOffCamera,
                isPrincipalPerformer: contractData.isPrincipalPerformer,
                isStuntPerformer: contractData.isStuntPerformer,
                isSpecialtyAct: contractData.isSpecialtyAct,
                isPilot: contractData.isPilot,
                isStuntCoordinator: contractData.isStuntCoordinator,
                isDancerSoloOrDuo: contractData.isDancerSoloOrDuo,
                isDancer3Plus: contractData.isDancer3Plus,
                isSingerSoloOrDuo: contractData.isSingerSoloOrDuo,
                isGroupSinger3To5: contractData.isGroupSinger3To5,
                isGroupSinger6To8: contractData.isGroupSinger6To8,
                isGroupSinger9Plus: contractData.isGroupSinger9Plus,
                isContractor: contractData.isContractor,
                // Usage type boolean flags
                isSeasonal: contractData.isSeasonal,
                isTestOrTestMarket: contractData.isTestOrTestMarket,
                isNonAir: contractData.isNonAir,
                isTraditionalDigital: contractData.isTraditionalDigital,
                isTheatricalIndustrial: contractData.isTheatricalIndustrial,
                isForeignLanguageTranslation: contractData.isForeignLanguageTranslation,
                isMultipleTrackingOrSweetening: contractData.isMultipleTrackingOrSweetening,
                // Payment flags
                isPaymentToPerformer: contractData.isPaymentToPerformer,
                isPaymentToAgent: contractData.isPaymentToAgent,
                isJpcAuthorizerAgencyOrAdvertiser: contractData.isJpcAuthorizerAgencyOrAdvertiser,
                // Wardrobe
                isWardrobeFurnishedByPerformer: contractData.isWardrobeFurnishedByPerformer,
                isWardrobeFurnishedByProducer: contractData.isWardrobeFurnishedByProducer,
                wardrobeCounts: contractData.wardrobeCounts,
                wardrobeFeeTotal: contractData.wardrobeFeeTotal,
                // Additional compensation and adjustments
                hazardAdjustment: contractData.hazardAdjustment,
                travelZoneAllowance: contractData.travelZoneAllowance,
                tolls: contractData.tolls,
                mileage: contractData.mileage,
                parking: contractData.parking,
                vehicleType: contractData.vehicleType,
                flightInsuranceOptIn: contractData.flightInsuranceOptIn,
                nightPremium: contractData.nightPremium,
                // Employer and legal
                employerOfRecordNameAndAddress: contractData.employerOfRecordNameAndAddress,
                specialProvisions: contractData.specialProvisions,
                // Props and adjustments
                propsUsed: contractData.propsUsed,
                otherProp: contractData.otherProp,
                adjustments: contractData.adjustments,
                // Guardian info
                parentOrGuardian: contractData.parentOrGuardian,
                // Payment and notices
                paymentInstructions: contractData.paymentInstructions,
                // Time logs
                timeLogs: contractData.timeLogs,
                // Contract status fields
                signature: contractData.signature,
                status: contractData.status
            });
            return response.contract;
        } catch (e) {
            this.handleError(e);
            return undefined;
        } finally{
            this.setLoading(false);
            this.setIsSaving(false);
        }
    };
    declineContract = async (contractId, declineReason)=>{
        try {
            this.setLoading(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const response = await (0, $g87cD.PerformerContractService).updatePerformerContract(contractId, {
                declineReason: declineReason
            });
            return response.contract;
        } catch (e) {
            this.handleError(e);
            return undefined;
        } finally{
            this.setLoading(false);
        }
    };
    uploadCharacterPhotos = async (contractId, characterPhotos)=>{
        try {
            this.setLoading(true);
            this.setIsSaving(true);
            const response = await (0, $g87cD.PerformerContractService).updateCharacterPhotos(contractId, {
                characterPhotos: characterPhotos
            });
            return response.contract;
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
            this.setIsSaving(false);
        }
    };
    /**
   * Generate a short-lived QR capture token for a contract.
   * Invalidates any previously issued token for this producer.
   */ generateCaptureToken = async (contractId)=>{
        try {
            this.setLoading(true);
            const response = await (0, $g87cD.PerformerContractService).generateCaptureToken(contractId);
            return response.token;
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
        }
    };
    /**
   * Validate a capture token and return contract/performer info.
   * Used by the mobile capture page on load to confirm the link is still valid.
   */ validateCaptureToken = async (token)=>{
        try {
            this.setLoading(true);
            return await (0, $g87cD.PerformerContractService).validateCaptureToken(token);
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
        }
    };
    getCharacterPhotoUrls = async (contractId)=>{
        try {
            this.setLoading(true);
            const response = await (0, $g87cD.PerformerContractService).getCharacterPhotos(contractId);
            return response;
        } catch (e) {
            this.handleError(e);
            return [];
        } finally{
            this.setLoading(false);
        }
    };
    downloadContractPdf = async (contractId)=>{
        try {
            this.setLoading(true);
            const response = await (0, $g87cD.PerformerContractService).downloadContractPdf(contractId);
            if (response) {
                // convert response from base64 string to blob
                const byteArray = Uint8Array.from($fbc73f0d483e0d60$require$Buffer.from(response, 'base64'));
                const blob = new Blob([
                    byteArray
                ], {
                    type: 'application/pdf'
                });
                // const url = window.URL.createObjectURL(blob);
                // const a = document.createElement('a');
                // a.href = url;
                // a.target = '_blank';
                // document.body.appendChild(a);
                // a.click();
                // a.remove();
                // window.URL.revokeObjectURL(url);
                return blob;
            }
        // return response;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
        }
    };
    getContract = async (contractId, relations)=>{
        try {
            this.setLoading(true);
            const response = await (0, $g87cD.PerformerContractService).getPerformerContract(contractId, relations);
            return response.contract;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setLoading(false);
        }
    };
    sendContract = async (contractId, emailData)=>{
        try {
            this.setLoading(true);
            await (0, $g87cD.PerformerContractService).sendContractEmail(contractId, {
                email: emailData.to,
                message: emailData.message
            });
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        } finally{
            this.setLoading(false);
        }
    };
    signContract = async (contractId, request)=>{
        try {
            this.setLoading(true);
            const { contract: contract } = await (0, $g87cD.PerformerContractService).signContract(contractId, request);
            return contract;
        } catch (e) {
            this.handleError(e);
            return undefined;
        } finally{
            this.setLoading(false);
        }
    };
    /**
   * Time Tracking
   */ logTime = async (contractId, performerId, timeData)=>{
        try {
            this.setLoading(true);
            await (0, $g87cD.PerformerContractService).addTimeLog(contractId, {
                date: timeData.date,
                workFrom: timeData.workFrom,
                workTo: timeData.workTo,
                mealsFrom: timeData.mealsFrom,
                mealsTo: timeData.mealsTo,
                travelToLocationFrom: timeData.travelToLocationFrom,
                travelToLocationTo: timeData.travelToLocationTo,
                travelFromLocationFrom: timeData.travelFromLocationFrom,
                travelFromLocationTo: timeData.travelFromLocationTo,
                fittingsMakeupTestFrom: timeData.fittingsMakeupTestFrom,
                fittingsMakeupTestTo: timeData.fittingsMakeupTestTo
            });
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        } finally{
            this.setLoading(false);
        }
    };
    deleteTimeLog = async (contractId, timeLogId)=>{
        try {
            this.setLoading(true);
            await (0, $g87cD.PerformerContractService).deleteTimeLog(contractId, timeLogId);
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        } finally{
            this.setLoading(false);
        }
    };
    approveTimeLog = async (contractId, initials)=>{
        try {
            this.setLoading(true);
            const response = await (0, $g87cD.PerformerContractService).approveTimeLog(contractId, {
                initials: initials
            });
            return response.contract;
        } catch (e) {
            this.handleError(e);
            return null;
        } finally{
            this.setLoading(false);
        }
    };
    markArrival = async (_contractId, _performerId, _arrivalData)=>{
        try {
            this.setLoading(true);
            // await PerformerContractService.markArrival(contractId, {
            //   performerId,
            //   arrivalTime: arrivalData.arrivalTime,
            //   notes: arrivalData.notes,
            //   startTimeTracking: arrivalData.startTimeTracking,
            // });
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        } finally{
            this.setLoading(false);
        }
    };
    /**
   * Helper methods
   */ refreshPerformerInfo = async (performerId)=>{
        try {
            const performer = await this.getPerformer(performerId);
            if (performer) (0, $hK1qT.runInAction)(()=>{
                const index = this._performers.findIndex((p)=>p.id === performerId);
                if (index !== -1) this._performers[index] = performer;
            });
        } catch (e) {
            console.error('Failed to refresh performer info:', e);
        }
    };
}

});

parcelRegister("5AeDc", function(module, exports) {

$parcel$export(module.exports, "ProjectStore", () => $840f0f28c3eeb5be$export$93d91060b9af7e2a);
parcelRequire("hcQWc");
var $hafFH = parcelRequire("hafFH");
var $gYVLq = parcelRequire("gYVLq");
var $1XZc5 = parcelRequire("1XZc5");
var $kQx3f = parcelRequire("kQx3f");
var $dvSQf = parcelRequire("dvSQf");
var $iKpUE = parcelRequire("iKpUE");
var $jBzsC = parcelRequire("jBzsC");

var $5wL0X = parcelRequire("5wL0X");

var $aIAdV = parcelRequire("aIAdV");

var $9Rhqc = parcelRequire("9Rhqc");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $840f0f28c3eeb5be$export$93d91060b9af7e2a extends (0, $3kkid.BaseStore) {
    isLoadingList = true;
    isSaving = false;
    // True once fetchProjectList() has completed at least one full attempt, and never reset to
    // false again afterward — unlike isLoadingList, which legitimately flips back to true on any
    // later background refresh. UI that gates "children vs. loading spinner" (ProjectRoute, Home)
    // must key off this instead of isLoadingList: gating on isLoadingList unmounted the page on
    // every refresh, which unmounted ProjectSelector, which re-triggered fetchProjectList() on
    // remount, which flipped isLoadingList again — a self-sustaining infinite loop.
    hasLoadedList = false;
    // Tracks an in-flight fetchProjectList() call so concurrent callers (Home's mount effect,
    // ProjectSelector's mount effect, and any remount of either during the post-login render
    // churn) share one request instead of each firing their own — this list carries a heavy
    // relation set and was observed firing 3x in a row on a single login.
    _fetchProjectListPromise = null;
    currentProject = undefined;
    projectList = [];
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            isLoadingList: (0, $hK1qT.observable),
            hasLoadedList: (0, $hK1qT.observable),
            isSaving: (0, $hK1qT.observable),
            currentProject: (0, $hK1qT.observable),
            projectList: (0, $hK1qT.observable),
            setCurrentProjectId: (0, $hK1qT.action),
            setCurrentProjectName: (0, $hK1qT.action),
            openProjectByName: (0, $hK1qT.action),
            clientList: (0, $hK1qT.computed)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    /**     PROJECTS      */ fetchProjectList = async ()=>{
        // Join an already-in-flight request rather than firing a redundant duplicate.
        if (this._fetchProjectListPromise) return this._fetchProjectListPromise;
        const run = async ()=>{
            try {
                if (!this.isLoadingList) (0, $hK1qT.runInAction)(()=>this.isLoadingList = true);
                // TODO implement pagination
                // Deliberately lighter than a single project's full detail relations (no
                // documents/scripts/assets) - this list backs the home page cards and project
                // switcher, which don't use those. The currently-opened project gets enriched
                // with the full relation set separately, see enrichCurrentProject below.
                const { projects: projects } = await this.q((0, $dvSQf.ProjectService).listProjects(undefined, undefined, undefined, 'client,roles,contracts,estimates,sessions'));
                (0, $hK1qT.runInAction)(()=>{
                    this.projectList = projects;
                    const storedProjectId = (0, $aIAdV.default).get((0, $5wL0X.StorageProperties).CurrentProjectId);
                    const targetProjectId = storedProjectId || (projects.length > 0 ? projects[0].id : undefined);
                    // fetchProjectList is called independently by multiple mounted components (e.g. the
                    // Home page and the nav's ProjectSelector) - without this guard, each call would
                    // redundantly re-run setCurrentProjectId's full project enrichment fetch even though
                    // the current project hasn't actually changed.
                    if (targetProjectId && targetProjectId !== this.currentProject?.id) this.setCurrentProjectId(targetProjectId);
                });
            } catch (e) {
                this.handleError(e);
            } finally{
                (0, $hK1qT.runInAction)(()=>{
                    this.isLoadingList = false;
                    this.hasLoadedList = true;
                });
                this._fetchProjectListPromise = null;
            }
        };
        this._fetchProjectListPromise = run();
        return this._fetchProjectListPromise;
    };
    createProject = async ({ name: name, groupId: groupId, clientId: clientId, product: product, jobCode: jobCode, talentBudgetInPennies: talentBudgetInPennies, is_union: is_union })=>{
        try {
            this.setIsSaving(true);
            const { project: project } = await this.q((0, $dvSQf.ProjectService).createProject({
                name: name,
                groupId: groupId,
                clientId: clientId,
                product: product,
                jobCode: jobCode,
                talentBudgetInPennies: talentBudgetInPennies,
                is_union: is_union
            }));
            if (project) {
                // Await the refreshed list: callers (e.g. the Project Wizard) immediately create child
                // records via stores that look the new project up in projectList.
                await this.fetchProjectList();
                (0, $hK1qT.runInAction)(()=>{
                    this.currentProject = project;
                });
            }
            return project;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    findProjectByName = (projectName)=>this.projectList?.find((project)=>(0, $9Rhqc.kebabCase)(project.name) === (0, $9Rhqc.kebabCase)(projectName));
    setCurrentProjectId = (projectId)=>{
        this.currentProject = this.projectList?.find((project)=>project.id === projectId);
        (0, $aIAdV.default).set((0, $5wL0X.StorageProperties).CurrentProjectId, projectId);
        this.enrichCurrentProject(projectId);
        return this.currentProject;
    };
    /**
   * Makes the project a URL names (/project/<name>) the current one. Pages render currentProject,
   * so without this a shared link or bookmark showed whichever project was last selected instead.
   * Returns false when no project has that name.
   */ openProjectByName = (projectName)=>{
        const project = this.findProjectByName(projectName);
        if (!project) return false;
        if (project.id !== this.currentProject?.id) this.setCurrentProjectId(project.id);
        return true;
    };
    setCurrentProjectName = (projectName)=>{
        this.currentProject = this.findProjectByName(projectName);
        if (!this.currentProject) {
            console.error('Project with name "%s" not found', projectName);
            return;
        }
        (0, $aIAdV.default).set((0, $5wL0X.StorageProperties).CurrentProjectId, this.currentProject.id);
        this.enrichCurrentProject(this.currentProject.id);
    };
    /**
   * The project list is fetched with a light relation set (see fetchProjectList).
   * Once a project is actually opened, fetch it again with the full relation set
   * every project-scoped page needs (documents, scripts, assets, etc.) and merge
   * the result into both currentProject and projectList.
   */ enrichCurrentProject = async (projectId)=>{
        try {
            const { project: project } = await this.q((0, $dvSQf.ProjectService).getProject(projectId, 'documents,estimates,roles,contracts,sessions,scripts,client,assets'));
            if (!project) return;
            (0, $hK1qT.runInAction)(()=>{
                this.projectList = this.projectList?.map((p)=>p.id === project.id ? project : p);
                // Only overwrite currentProject if the user hasn't since switched to a
                // different project while this fetch was in flight
                if (this.currentProject?.id === project.id) this.currentProject = project;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteProject = async (projectId)=>{
        try {
            this.setIsSaving(true);
            await this.q((0, $dvSQf.ProjectService).deleteProject(projectId));
            (0, $hK1qT.runInAction)(()=>{
                this.projectList = this.projectList?.filter((p)=>p.id !== projectId);
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateProject = async (projectId, req)=>{
        try {
            this.setIsSaving(true);
            const { project: project } = await this.q((0, $dvSQf.ProjectService).updateProject(projectId, req));
            if (!project) throw new Error('No project returned from update');
            // retrieve documents and estimates
            const { project: fullProject } = await this.q((0, $dvSQf.ProjectService).getProject(projectId, 'documents,estimates,sessions,locations,client,contracts,roles,scripts'));
            if (!fullProject) throw new Error('Could not retrieve updated project details');
            (0, $hK1qT.runInAction)(()=>{
                this.projectList = this.projectList?.map((p)=>p.id === projectId ? fullProject : p);
                if (this.currentProject?.id === projectId) this.currentProject = fullProject;
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /**         SCRIPTS       */ createScript = async (projectId, name)=>{
        try {
            this.setIsSaving(true);
            const { script: script } = await this.q((0, $iKpUE.ScriptService).createScript({
                name: name,
                projectId: projectId
            }));
            return script;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    getScriptsByProject = async (projectId)=>{
        try {
            const { scripts: scripts } = await this.q((0, $iKpUE.ScriptService).listScripts(projectId));
            return scripts;
        } catch (e) {
            this.handleError(e);
        }
    };
    getScriptByDocId = async (documentId)=>{
        try {
            const { script: script } = await this.q((0, $iKpUE.ScriptService).getScriptByDocId(documentId));
            return script;
        } catch (e) {
            this.handleError(e);
        }
    };
    /**         DOCUMENTS     */ createDocument = async (file, documentType, useAi)=>{
        if (!this.currentProject) throw new Error('No current project');
        try {
            this.setIsSaving(true);
            const { document: document } = await this.q((0, $1XZc5.DocumentService).createDocument({
                file: file,
                name: file.name,
                type: documentType,
                project_id: this.currentProject.id,
                useAi: useAi
            }));
            if (document) (0, $hK1qT.runInAction)(()=>{
                this.currentProject?.documents?.push(document);
            });
            return document;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    getSignedDownloadLink = async (documentId)=>{
        try {
            const url = await this.q((0, $1XZc5.DocumentService).getSignedUrl(documentId));
            return url;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateDocument = async (documentId, updatedDocument)=>{
        const request = {
            ...updatedDocument,
            project_id: this.currentProject?.id
        };
        try {
            this.setIsSaving(true);
            const { document: document } = await this.q((0, $1XZc5.DocumentService).updateDocument(documentId, request));
            return document;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteDocument = async (documentId)=>{
        try {
            this.setIsSaving(true);
            await this.q((0, $1XZc5.DocumentService).deleteDocument(documentId));
            (0, $hK1qT.runInAction)(()=>{
                if (this.currentProject) this.currentProject.documents = this.currentProject?.documents?.filter((d)=>d.id !== documentId);
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    /**         ASSETS        */ createAsset = async (file, assetType, description)=>{
        if (!this.currentProject) throw new Error('No current project');
        try {
            this.setIsSaving(true);
            const { asset: asset } = await this.q((0, $gYVLq.AssetService).createAsset({
                file: file,
                name: file.name,
                type: assetType,
                project_id: this.currentProject.id,
                description: description || ''
            }));
            if (asset) (0, $hK1qT.runInAction)(()=>{
                if (!this.currentProject) return;
                if (!this.currentProject.assets) this.currentProject.assets = [];
                // Create new array reference so React detects the change
                this.currentProject.assets = [
                    ...this.currentProject.assets,
                    asset
                ];
            });
            return asset;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    createAssetFromDrive = async (driveFileId, fileName, assetType, description)=>{
        if (!this.currentProject) throw new Error('No current project');
        try {
            this.setIsSaving(true);
            const { asset: asset } = await this.q((0, $gYVLq.AssetService).createAssetFromDrive({
                drive_file_id: driveFileId,
                name: fileName,
                type: assetType,
                project_id: this.currentProject.id,
                description: description || ''
            }));
            if (asset) (0, $hK1qT.runInAction)(()=>{
                if (!this.currentProject) return;
                if (!this.currentProject.assets) this.currentProject.assets = [];
                // Create new array reference so React detects the change
                this.currentProject.assets = [
                    ...this.currentProject.assets,
                    asset
                ];
            });
            return asset;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    createAssetFromCloudStorage = async (provider, fileId, fileName, assetType, description)=>{
        if (!this.currentProject) throw new Error('No current project');
        try {
            this.setIsSaving(true);
            const { asset: asset } = await this.q((0, $gYVLq.AssetService).createAssetFromCloud({
                provider: provider,
                file_id: fileId,
                name: fileName,
                type: assetType,
                project_id: this.currentProject.id,
                description: description || ''
            }));
            if (asset) (0, $hK1qT.runInAction)(()=>{
                if (!this.currentProject) return;
                if (!this.currentProject.assets) this.currentProject.assets = [];
                // Create new array reference so React detects the change
                this.currentProject.assets = [
                    ...this.currentProject.assets,
                    asset
                ];
            });
            return asset;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    getAsset = async (assetId, relations)=>{
        try {
            const { asset: asset } = await this.q((0, $gYVLq.AssetService).getAsset(assetId, relations));
            return asset ?? undefined;
        } catch (e) {
            this.handleError(e);
        }
    };
    getSignedAssetUrl = async (assetId)=>{
        try {
            const url = await this.q((0, $gYVLq.AssetService).getSignedUrl(assetId));
            return url;
        } catch (e) {
            this.handleError(e);
        }
    };
    getAssetThumbnailUrl = async (assetId)=>{
        try {
            const url = await this.q((0, $gYVLq.AssetService).getThumbnailUrl(assetId));
            return url;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateAsset = async (assetId, updatedAsset)=>{
        const request = {
            name: updatedAsset.name,
            description: updatedAsset.description,
            processing_status: updatedAsset.processing_status
        };
        try {
            this.setIsSaving(true);
            const { asset: asset } = await this.q((0, $gYVLq.AssetService).updateAsset(assetId, request));
            if (!asset) throw new Error('No asset returned from update');
            const newAssets = this.currentProject?.assets?.map((a)=>a.id === asset.id ? asset : a);
            (0, $hK1qT.runInAction)(()=>{
                if (this.currentProject) this.currentProject.assets = newAssets || [];
            });
            return asset;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteAsset = async (assetId)=>{
        try {
            this.setIsSaving(true);
            await this.q((0, $gYVLq.AssetService).deleteAsset(assetId));
            (0, $hK1qT.runInAction)(()=>{
                if (this.currentProject) this.currentProject.assets = this.currentProject?.assets?.filter((a)=>a.id !== assetId);
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    getStorageUsage = async (groupId)=>{
        try {
            const usage = await this.q((0, $gYVLq.AssetService).getStorageUsage(groupId));
            return usage;
        } catch (e) {
            this.handleError(e);
        }
    };
    get clientList() {
        if (!this.projectList) return [];
        return this.projectList.reduce((list, p)=>{
            if (!p.client) return list;
            return list.find((c)=>c.id === p.client.id) ? list : list.concat(p.client);
        }, []);
    }
    createClient = async (clientData)=>{
        try {
            this.setIsSaving(true);
            if (!clientData.name) throw new Error('Client name is required');
            const request = {
                name: clientData.name,
                isSagSignatory: clientData.isSagSignatory || false,
                isJpcAuthorizer: clientData.isJpcAuthorizer || false
            };
            // create the client
            const { advertiser: advertiser } = await this.q((0, $hafFH.AdvertiserService).createAdvertiser(request));
            if (advertiser) (0, $hK1qT.runInAction)(()=>{
                // add to client list in project store
                if (this.projectList && !this.clientList.find((c)=>c.id === advertiser.id)) this.projectList = this.projectList.map((p)=>p.client?.id === 'NEW' ? {
                        ...p,
                        client: advertiser
                    } : p);
            });
            return advertiser;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateClient = async (clientId, updatedClient)=>{
        try {
            this.setIsSaving(true);
            const { advertiser: advertiser } = await this.q((0, $hafFH.AdvertiserService).updateAdvertiser(clientId, updatedClient));
            if (!advertiser) throw new Error('No Client returned from update');
            (0, $hK1qT.runInAction)(()=>{
                if (this.currentProject) this.currentProject.client = {
                    ...this.currentProject.client,
                    ...advertiser
                };
            });
            return advertiser;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    getMapApiKey = async ()=>{
        try {
            const { key: key } = await this.q((0, $jBzsC.SecretService).getSecretKey({
                key: 'mapApiKey'
            }));
            return key;
        } catch (e) {
            this.handleError(e);
        }
    };
    getPickerApiKey = async ()=>{
        try {
            const { key: key } = await this.q((0, $jBzsC.SecretService).getSecretKey({
                key: 'pickerApiKey'
            }));
            return key;
        } catch (e) {
            this.handleError(e);
        }
    };
    /**        LOCATIONS      */ getLocationsByProjectId = async (projectId)=>{
        try {
            const { locations: locations } = await this.q((0, $kQx3f.LocationService).listLocations(projectId));
            return locations;
        } catch (e) {
            this.handleError(e);
        }
    };
    createLocation = async (location)=>{
        try {
            this.setIsSaving(true);
            const { location: createdLocation } = await this.q((0, $kQx3f.LocationService).createLocation(location));
            return createdLocation;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteLocation = async (locationId)=>{
        try {
            this.setIsSaving(true);
            await this.q((0, $kQx3f.LocationService).deleteLocation(locationId));
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateLocation = async (updatedLocation)=>{
        const request = {
            ...updatedLocation,
            sessionActivityIds: updatedLocation.session_activities?.map((sa)=>sa.id)
        };
        try {
            this.setIsSaving(true);
            const { location: location } = await this.q((0, $kQx3f.LocationService).updateLocation(updatedLocation.id, request));
            return location;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
}

});
parcelRegister("9Rhqc", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


parcelRegister("cW2yD", function(module, exports) {

$parcel$export(module.exports, "PropStore", () => $e0308de0aabda81a$export$b0b84c3764fa8a7b);

var $3kkid = parcelRequire("3kkid");
parcelRequire("hcQWc");
var $3bCvT = parcelRequire("3bCvT");
class $e0308de0aabda81a$export$b0b84c3764fa8a7b extends (0, $3kkid.BaseStore) {
    constructor(rootStore){
        super(rootStore);
    }
    getPropsByRoleId = async (roleId)=>{
        try {
            const { props: props } = await (0, $3bCvT.PropService).listProps(roleId);
            return props;
        } catch (e) {
            this.handleError(e);
        }
    };
    getPropsByScriptId = async (scriptId)=>{
        try {
            const { props: props } = await (0, $3bCvT.PropService).listProps(undefined, scriptId);
            return props;
        } catch (e) {
            this.handleError(e);
        }
    };
    createProp = async ({ name: name, type: type, scriptIds: scriptIds, projectId: projectId, ownerId: ownerId })=>{
        try {
            const { prop: prop } = await (0, $3bCvT.PropService).createProp({
                name: name,
                type: type,
                scriptIds: scriptIds,
                projectId: projectId,
                ownerId: ownerId
            });
            return prop;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateProp = async (prop)=>{
        const updateRequest = {
            ...prop,
            ownerId: prop.owner?.id,
            scriptIds: prop.scripts?.map((s)=>s.id),
            sessionActivityIds: prop.session_activities?.map((sa)=>sa.id)
        };
        try {
            const { prop: updatedProp } = await (0, $3bCvT.PropService).updateProp(prop.id, updateRequest);
            return updatedProp;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteProp = async (propId)=>{
        try {
            await (0, $3bCvT.PropService).deleteProp(propId);
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("a3xGU", function(module, exports) {

$parcel$export(module.exports, "RightStore", () => $d1537fecc2a83048$export$2088445b2d52901e);
parcelRequire("hcQWc");
var $1b5lS = parcelRequire("1b5lS");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $d1537fecc2a83048$export$2088445b2d52901e extends (0, $3kkid.BaseStore) {
    isSaving = false;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            isSaving: (0, $hK1qT.observable)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    getRight = async (rightId, relations)=>{
        try {
            const { right: right } = await (0, $1b5lS.RightService).getRight(rightId, relations);
            return right;
        } catch (e) {
            this.handleError(e);
        }
    };
    getRightsByAdvertiserId = async (advertiserId)=>{
        try {
            const { rights: rights } = await (0, $1b5lS.RightService).listRights(advertiserId);
            return rights;
        } catch (e) {
            this.handleError(e);
        }
    };
    getRightsByCommercialId = async (commercialId)=>{
        try {
            const { rights: rights } = await (0, $1b5lS.RightService).listRights(undefined, commercialId);
            return rights;
        } catch (e) {
            this.handleError(e);
        }
    };
    listRights = async (options)=>{
        try {
            const { rights: rights } = await (0, $1b5lS.RightService).listRights(options?.advertiserId, options?.commercialId, options?.status, options?.rightType, options?.limit, options?.page, options?.orderAsJsonString, options?.relations);
            return rights;
        } catch (e) {
            this.handleError(e);
        }
    };
    createRight = async (rightData)=>{
        try {
            this.setIsSaving(true);
            const { right: right } = await (0, $1b5lS.RightService).createRight(rightData);
            return right;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateRight = async (right, documentId)=>{
        const updateRequest = {
            ...right,
            advertiserId: right.advertiser?.id,
            commercialIds: right.commercials?.map((c)=>c.id),
            documentId: documentId
        };
        try {
            this.setIsSaving(true);
            const { right: updatedRight } = await (0, $1b5lS.RightService).updateRight(right.id, updateRequest);
            return updatedRight;
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteRight = async (rightId)=>{
        try {
            this.setIsSaving(true);
            await (0, $1b5lS.RightService).deleteRight(rightId);
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
}

});

parcelRegister("jXBXN", function(module, exports) {

$parcel$export(module.exports, "RoleStore", () => $567ef87cb00fad1e$export$c7c2048478da5c49);

var $3kkid = parcelRequire("3kkid");
parcelRequire("hcQWc");
var $khgRv = parcelRequire("khgRv");
var $f9fOF = parcelRequire("f9fOF");
class $567ef87cb00fad1e$export$c7c2048478da5c49 extends (0, $3kkid.BaseStore) {
    constructor(rootStore){
        super(rootStore);
    }
    /**
   * Roles
   */ getRoleById = async (roleId)=>{
        try {
            const { role: role } = await (0, $f9fOF.RoleService).getRole(roleId, 'costumes,props,performer');
            return role;
        } catch (e) {
            this.handleError(e);
        }
    };
    getRolesByScriptId = async (scriptId)=>{
        try {
            const { roles: roles } = await (0, $f9fOF.RoleService).listRoles(undefined, scriptId, undefined, undefined, undefined, 'role_group');
            return roles;
        } catch (e) {
            this.handleError(e);
        }
    };
    getRolesByProjectId = async (projectId)=>{
        try {
            const { roles: roles } = await (0, $f9fOF.RoleService).listRoles(projectId, undefined, undefined, undefined, undefined, 'role_group,props,costumes,performer');
            return roles;
        } catch (e) {
            this.handleError(e);
        }
    };
    createRole = async ({ name: name, type: type, performerType: performerType, projectId: projectId })=>{
        try {
            const { role: role } = await (0, $f9fOF.RoleService).createRole({
                name: name,
                type: type,
                performerType: performerType,
                projectId: projectId
            });
            return role;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateRole = async (role, groupId)=>{
        const updateRequest = {
            ...role,
            performerType: role.performer_type,
            scriptId: role.script?.id,
            roleGroupId: groupId || role.role_group?.id,
            sessionActivityIds: role.session_activities?.map((sa)=>sa.id),
            allowanceIds: role.allowances?.map((a)=>a.id),
            costumeIds: role.costumes?.map((c)=>c.id),
            propIds: role.props?.map((p)=>p.id),
            feeIds: role.fees?.map((f)=>f.id),
            tagsIds: role.tags?.map((t)=>t.id),
            usageIds: role.usages?.map((u)=>u.id),
            roleActivityIds: role.role_activities?.map((ra)=>ra.id)
        };
        if (!role.id) return;
        try {
            const { role: updatedRole } = await (0, $f9fOF.RoleService).updateRole(role.id, updateRequest);
            return updatedRole;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteRole = async (roleId)=>{
        try {
            await (0, $f9fOF.RoleService).deleteRole(roleId);
        } catch (e) {
            this.handleError(e);
        }
    };
    /**
   * Role Groups
   */ getRoleGroupsByScriptId = async (scriptId)=>{
        try {
            const { roleGroups: roleGroups } = await (0, $khgRv.RoleGroupService).listRoleGroups(undefined, scriptId, undefined, undefined, undefined, 'roles');
            return roleGroups;
        } catch (e) {
            this.handleError(e);
        }
    };
    getRoleGroupsByProjectId = async (projectId)=>{
        try {
            const { roleGroups: roleGroups } = await (0, $khgRv.RoleGroupService).listRoleGroups(projectId, undefined, undefined, undefined, undefined, 'roles');
            return roleGroups;
        } catch (e) {
            this.handleError(e);
        }
    };
    createRoleGroup = async ({ name: name, roleIds: roleIds, scriptId: scriptId, projectId: projectId, sessionActivityIds: sessionActivityIds })=>{
        try {
            const { roleGroup: roleGroup } = await (0, $khgRv.RoleGroupService).createRoleGroup({
                name: name,
                scriptId: scriptId,
                roleIds: roleIds,
                projectId: projectId,
                sessionActivityIds: sessionActivityIds
            });
            return roleGroup;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateRoleGroup = async (roleGroup)=>{
        const updateRequest = {
            ...roleGroup,
            scriptId: roleGroup.script?.id,
            roleIds: roleGroup.roles?.map((r)=>r.id),
            sessionActivityIds: roleGroup.session_activities?.map((sa)=>sa.id)
        };
        try {
            const { roleGroup: updatedRoleGroup } = await (0, $khgRv.RoleGroupService).updateRoleGroup(roleGroup.id, updateRequest);
            return updatedRoleGroup;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteRoleGroup = async (roleGroupId)=>{
        try {
            await (0, $khgRv.RoleGroupService).deleteRoleGroup(roleGroupId);
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("fOh1O", function(module, exports) {

$parcel$export(module.exports, "RootStore", () => $4a0652aaede5234b$export$5b19c597f1926e87);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $cS8Vf = parcelRequire("cS8Vf");

var $1xNcM = parcelRequire("1xNcM");

var $hK1qT = parcelRequire("hK1qT");

var $bsB3E = parcelRequire("bsB3E");

var $kEU9h = parcelRequire("kEU9h");
parcelRequire("7Wm5d");
var $7PmFI = parcelRequire("7PmFI");
var $iRK83 = parcelRequire("iRK83");
var $lF2uX = parcelRequire("lF2uX");
var $dV3a5 = parcelRequire("dV3a5");
var $77JSJ = parcelRequire("77JSJ");
var $kQLpc = parcelRequire("kQLpc");
var $d3B3x = parcelRequire("d3B3x");
var $lEt3y = parcelRequire("lEt3y");
var $e4I9p = parcelRequire("e4I9p");
var $5AeDc = parcelRequire("5AeDc");
var $cW2yD = parcelRequire("cW2yD");
var $a3xGU = parcelRequire("a3xGU");
var $jXBXN = parcelRequire("jXBXN");
var $2NYgb = parcelRequire("2NYgb");
var $jPINK = parcelRequire("jPINK");
var $1WQz8 = parcelRequire("1WQz8");
var $9dnGJ = parcelRequire("9dnGJ");
var $22Wl1 = parcelRequire("22Wl1");
class $4a0652aaede5234b$export$5b19c597f1926e87 {
    accountStore;
    adminStore;
    chatStore;
    commercialStore;
    costumeStore;
    estimateStore;
    holdingFeeStore;
    notificationStore;
    performerStore;
    projectStore;
    propStore;
    rightStore;
    roleStore;
    sessionActivityStore;
    sessionStore;
    talentManagerStore;
    usageStore;
    userStore;
    requests = [];
    constructor(){
        (0, $cS8Vf.OpenAPI).BASE = `${(0, $1xNcM.config).env.apiHost}:${(0, $1xNcM.config).env.apiPort}/${(0, $1xNcM.config).env.apiBase}/${(0, $1xNcM.config).env.apiVersion}`;
        this.accountStore = new (0, $7PmFI.AccountStore)(this);
        this.adminStore = new (0, $iRK83.AdminStore)(this);
        this.chatStore = new (0, $lF2uX.ChatStore)(this);
        this.commercialStore = new (0, $dV3a5.CommercialStore)(this);
        this.costumeStore = new (0, $77JSJ.CostumeStore)(this);
        this.estimateStore = new (0, $kQLpc.EstimateStore)(this);
        this.holdingFeeStore = new (0, $d3B3x.HoldingFeeStore)(this);
        this.notificationStore = new (0, $lEt3y.NotificationStore)(this);
        this.performerStore = new (0, $e4I9p.PerformerStore)(this);
        this.projectStore = new (0, $5AeDc.ProjectStore)(this);
        this.propStore = new (0, $cW2yD.PropStore)(this);
        this.rightStore = new (0, $a3xGU.RightStore)(this);
        this.roleStore = new (0, $jXBXN.RoleStore)(this);
        this.sessionActivityStore = new (0, $2NYgb.SessionActivityStore)(this);
        this.sessionStore = new (0, $jPINK.SessionStore)(this);
        this.talentManagerStore = new (0, $1WQz8.TalentManagerStore)(this);
        this.usageStore = new (0, $9dnGJ.UsageStore)(this);
        this.userStore = new (0, $22Wl1.UserStore)(this);
        (0, $hK1qT.makeObservable)(this, {
            accountStore: (0, $hK1qT.observable),
            adminStore: (0, $hK1qT.observable),
            chatStore: (0, $hK1qT.observable),
            commercialStore: (0, $hK1qT.observable),
            costumeStore: (0, $hK1qT.observable),
            estimateStore: (0, $hK1qT.observable),
            holdingFeeStore: (0, $hK1qT.observable),
            notificationStore: (0, $hK1qT.observable),
            performerStore: (0, $hK1qT.observable),
            projectStore: (0, $hK1qT.observable),
            propStore: (0, $hK1qT.observable),
            rightStore: (0, $hK1qT.observable),
            roleStore: (0, $hK1qT.observable),
            sessionActivityStore: (0, $hK1qT.observable),
            sessionStore: (0, $hK1qT.observable),
            talentManagerStore: (0, $hK1qT.observable),
            usageStore: (0, $hK1qT.observable),
            userStore: (0, $hK1qT.observable)
        });
    }
    handleError = (error, customMsg)=>{
        // console.log('error: ', JSON.stringify(error, null, 2));
        // `error` here is the generated client's `ApiError` (`.status`/`.message`), not an axios
        // error — there is no `.response`, so this branch never matched and every 401 fell through
        // to the generic path below, showing the raw "Unauthorized" status text once per failed
        // request. A fixed `toastId` collapses repeats (e.g. several components' calls all 401ing
        // in the same burst) into a single toast instead of stacking one per call.
        if (error?.status === 401) {
            this.cancelRequests();
            this.clearRequests();
            (0, $bsB3E.toast).error(customMsg || 'Your session has expired. Please log in again', {
                toastId: 'session-expired'
            });
            return;
        }
        console.error(error);
        const ref = (0, $kEU9h.reportError)(error);
        const message = customMsg || error.response?.data?.message || error.message || 'An error occurred';
        // A server-error reference lets whoever sees the toast point us at the exact API log line
        (0, $bsB3E.toast).error(ref ? `${message} (ref: ${ref})` : message);
    };
    cancelRequests = ()=>{
        this.requests.forEach((request)=>request.cancel());
        this.clearRequests();
    };
    cancelRequest = (request)=>{
        request.cancel();
        this.removeRequest(request);
    };
    addRequest = async (request)=>{
        this.requests.push(request);
        return await request.then((res)=>{
            this.removeRequest(request);
            return res;
        }).catch((e)=>{
            this.removeRequest(request);
            throw e;
        });
    };
    removeRequest = (request)=>{
        this.requests = this.requests.filter((req)=>req !== request);
    };
    clearRequests = ()=>{
        this.requests = [];
    };
    get isRequesting() {
        return this.requests.length > 0;
    }
    get hasRequests() {
        return this.requests.length > 0;
    }
    get hasNoRequests() {
        return this.requests.length === 0;
    }
}

});
parcelRegister("1xNcM", function(module, exports) {
$parcel$export(module.exports, "SESSION_ESTIMATOR_TEMP_ESTIMATE_TITLE", () => (parcelRequire("8YJFZ")).SESSION_ESTIMATOR_TEMP_ESTIMATE_TITLE);

$parcel$export(module.exports, "config", () => $bc8beea5b4cede8b$export$e506a1d27d1eaa20);

var $eLUFj = parcelRequire("eLUFj");

var $5CLcf = parcelRequire("5CLcf");
parcelRequire("8YJFZ");
const $bc8beea5b4cede8b$export$e506a1d27d1eaa20 = {
    env: $eLUFj.env,
    toast: $5CLcf.toast
};

});
parcelRegister("eLUFj", function(module, exports) {

$parcel$export(module.exports, "env", () => $82818e2fd3f056a5$export$a7b6bc01c63cdfc3);

var $fsUjP = parcelRequire("fsUjP");

var $bwmZF = parcelRequire("bwmZF");
const $82818e2fd3f056a5$var$getEnvironmentVariable = (unvalidatedEnvironmentVariable)=>{
    if (!unvalidatedEnvironmentVariable) throw new Error(`Couldn't find environment variable: ${unvalidatedEnvironmentVariable}`);
    else return unvalidatedEnvironmentVariable;
};
const $82818e2fd3f056a5$export$a7b6bc01c63cdfc3 = {
    nodeEnv: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).NODE_ENV ?? "production"),
    apiHost: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).API_HOST ?? undefined),
    apiWsHost: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).API_HOST ?? undefined).replace(/^https?/, (s)=>s === 'https' ? 'wss' : 'ws'),
    apiPort: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).API_PORT ?? undefined),
    apiBase: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).API_BASE ?? undefined),
    apiVersion: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).API_VERSION ?? undefined),
    clientUrl: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).CLIENT_URL ?? undefined),
    posthog: {
        options: {
            api_host: $82818e2fd3f056a5$var$getEnvironmentVariable((0, $bwmZF.runtimeConfig).POSTHOG_HOST ?? undefined),
            // Uncaught errors and unhandled rejections go to PostHog error tracking
            capture_exceptions: true,
            // Tag every event (including exceptions) with the build that produced it
            loaded: (ph)=>ph.register({
                    release: (0, $fsUjP.WEB_RELEASE)
                })
        },
        api_key: (0, $bwmZF.runtimeConfig).POSTHOG_KEY ?? undefined
    }
};

});
parcelRegister("fsUjP", function(module, exports) {

$parcel$export(module.exports, "WEB_RELEASE", () => $7ee754a1cf8dcd90$export$e4a40f9f344732ce);
$parcel$export(module.exports, "formatBuildLabel", () => $7ee754a1cf8dcd90$export$9e70706b0071ecbc);
$parcel$export(module.exports, "fetchApiRelease", () => $7ee754a1cf8dcd90$export$28ad907352c8269a);
parcelRequire("hcQWc");
var $cY3qa = parcelRequire("cY3qa");

var $bwmZF = parcelRequire("bwmZF");
const $7ee754a1cf8dcd90$export$e4a40f9f344732ce = (0, $bwmZF.runtimeConfig).RELEASE || 'dev';
const $7ee754a1cf8dcd90$export$97aa76da0b9517d = (release)=>release === 'dev' ? release : release.slice(0, 7);
const $7ee754a1cf8dcd90$export$9e70706b0071ecbc = (webRelease, apiRelease)=>`Web ${$7ee754a1cf8dcd90$export$97aa76da0b9517d(webRelease)} \xb7 API ${apiRelease ? $7ee754a1cf8dcd90$export$97aa76da0b9517d(apiRelease) : 'unknown'}`;
const $7ee754a1cf8dcd90$export$28ad907352c8269a = async ()=>{
    try {
        const { release: release } = await (0, $cY3qa.HealthCheckService).healthCheck();
        return release || null;
    } catch  {
        return null;
    }
};

});
parcelRegister("bwmZF", function(module, exports) {

$parcel$export(module.exports, "runtimeConfig", () => $cb3c1cb274513857$export$ef526668baf27eac);
/**
 * Runtime configuration for a deployed web build.
 *
 * The production image is built once and promoted unchanged from development to staging to
 * production, so nothing environment-specific can be inlined at build time. Instead index.html
 * carries `<meta name="talon-config" content="__TALON_CONFIG__">`, and the container fills it in at
 * startup with base64-encoded JSON of these values (apps/web/deploy/40-talon-config.sh).
 *
 * Locally (`yarn start`, Vitest) the placeholder is left as-is, and callers fall back to the
 * build-time process.env values.
 */ const $cb3c1cb274513857$export$c2251c945e4c2bc3 = 'talon-config';
const $cb3c1cb274513857$export$3a0e2d7c1a826786 = '__TALON_CONFIG__';
const $cb3c1cb274513857$export$c68dd1d2a3621d29 = (doc = globalThis.document)=>{
    const content = doc?.querySelector(`meta[name="${$cb3c1cb274513857$export$c2251c945e4c2bc3}"]`)?.getAttribute('content');
    if (!content || content === $cb3c1cb274513857$export$3a0e2d7c1a826786) return {};
    try {
        return JSON.parse(atob(content));
    } catch  {
        console.error('Ignoring malformed runtime config in <meta name="talon-config">');
        return {};
    }
};
const $cb3c1cb274513857$export$ef526668baf27eac = $cb3c1cb274513857$export$c68dd1d2a3621d29();

});



parcelRegister("5CLcf", function(module, exports) {

$parcel$export(module.exports, "toast", () => $2311cbea2660eeff$export$b410431fab84fa58);
const $2311cbea2660eeff$export$b410431fab84fa58 = {
    login: {
        loading: 'Logging in...',
        success: 'Successfully logged in.',
        error: (err)=>`An issue occurred logging in: ${err.body.message}`
    },
    logout: {
        loading: 'Logging out...',
        success: 'Successfully logged out.',
        error: (err)=>`An issue occurred logging out: ${err.body.message}`
    },
    requestPasswordReset: {
        loading: 'Processing...',
        success: 'If an account with that email exists, a password reset link will be sent.',
        error: (err)=>`An issue occurred resetting password: ${err.body.message}`
    },
    passwordReset: {
        success: 'Password successfully reset.',
        error: (err)=>`An issue occurred resetting password: ${err.body.message}`
    },
    signup: {
        loading: 'Processing...',
        success: 'Successfully signed up.  Please login.',
        error: (err)=>`An issue occurred signing up: ${err.body.message}`
    }
};

});

parcelRegister("8YJFZ", function(module, exports) {

$parcel$export(module.exports, "SESSION_ESTIMATOR_TEMP_ESTIMATE_TITLE", () => $157df6d30f5220f4$export$c2dffb96bb66518b);
const $157df6d30f5220f4$export$c2dffb96bb66518b = 'SessionEstimator_Project_';

});


parcelRegister("kEU9h", function(module, exports) {

$parcel$export(module.exports, "reportError", () => $d028da38b9954da9$export$b33b857ad1d9900e);
parcelRequire("hcQWc");
var $kvCbJ = parcelRequire("kvCbJ");

var $7C6ui = parcelRequire("7C6ui");
const $d028da38b9954da9$export$b33b857ad1d9900e = (error)=>{
    const apiError = error instanceof (0, $kvCbJ.ApiError) ? error : undefined;
    const requestId = apiError?.body?.requestId;
    try {
        (0, $7C6ui.default).captureException(error, {
            requestId: requestId,
            status: apiError?.status,
            method: apiError?.request.method,
            url: apiError?.url
        });
    } catch  {
    // Never let error reporting turn into a second failure
    }
    return apiError && apiError.status >= 500 && requestId ? requestId.slice(0, 8) : undefined;
};

});


parcelRegister("2NYgb", function(module, exports) {

$parcel$export(module.exports, "SessionActivityStore", () => $7d039343396df3b3$export$8de81113bd776e58);

var $3kkid = parcelRequire("3kkid");
parcelRequire("hcQWc");
var $gR3wM = parcelRequire("gR3wM");
var $apSGY = parcelRequire("apSGY");
class $7d039343396df3b3$export$8de81113bd776e58 extends (0, $3kkid.BaseStore) {
    constructor(rootStore){
        super(rootStore);
    }
    /**
   * Session Activities
   */ listSessionActivities = async (sessionId)=>{
        try {
            const { sessionActivities: sessionActivities } = await (0, $apSGY.SessionActivityService).listSessionActivities(sessionId, undefined, undefined, undefined, 'roles,role_groups,props,costumes,location,from_location,to_location,role_activities,script');
            return sessionActivities;
        } catch (e) {
            this.handleError(e);
        }
    };
    getSessionActivity = async (sessionActivityId)=>{
        try {
            const { sessionActivity: sessionActivity } = await (0, $apSGY.SessionActivityService).getSessionActivity(sessionActivityId, 'roles,role_groups,props,costumes,location,from_location,to_location,role_activities,script');
            return sessionActivity;
        } catch (e) {
            this.handleError(e);
        }
    };
    createSessionActivity = async (sessionId, type, startTime, endTime, scriptId, hours)=>{
        if (!sessionId || !type || !startTime && !endTime && (hours === undefined || hours === null)) {
            console.warn('createSessionActivity call is missing required argument');
            return;
        }
        try {
            const { sessionActivity: sessionActivity } = await (0, $apSGY.SessionActivityService).createSessionActivity({
                sessionId: sessionId,
                type: type,
                startTime: startTime,
                endTime: endTime,
                hours: hours,
                scriptId: scriptId
            });
            return sessionActivity;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateSessionActivity = async (sessionActivity)=>{
        if (!sessionActivity.id) return;
        try {
            const updateRequest = {
                scriptId: sessionActivity.script?.id,
                sessionId: sessionActivity.session?.id,
                startTime: sessionActivity.start_time,
                endTime: sessionActivity.end_time,
                hours: sessionActivity.hours,
                type: sessionActivity.type,
                roleIds: sessionActivity.roles?.map((r)=>r.id),
                roleGroupIds: sessionActivity.role_groups?.map((rg)=>rg.id),
                propIds: sessionActivity.props?.map((p)=>p.id),
                costumeIds: sessionActivity.costumes?.map((c)=>c.id),
                locationId: sessionActivity.location?.id,
                fromLocationId: sessionActivity.from_location?.id,
                toLocationId: sessionActivity.to_location?.id,
                roleActivityIds: sessionActivity.role_activities?.map((ra)=>ra.id),
                isCreativeSession: sessionActivity.is_creative_session,
                isScratchTrack: sessionActivity.is_scratch_track,
                isNightSession: sessionActivity.is_night_session,
                isLateNightSession: sessionActivity.is_late_night_session,
                isWeekendSession: sessionActivity.is_weekend_session,
                isHolidaySession: sessionActivity.is_holiday_session,
                isTravelAfterMidnight: sessionActivity.is_travel_after_midnight
            };
            await (0, $apSGY.SessionActivityService).updateSessionActivity(sessionActivity.id, updateRequest);
            const fullUpdatedSessionActivity = await this.getSessionActivity(sessionActivity.id);
            // update displayed estimate values
            const est = await this.rootStore.estimateStore.getEstimate(this.rootStore.estimateStore.currentEstimate?.id, 'usage_estimates,session_estimates');
            est && this.rootStore.estimateStore.setCurrentEstimate(est);
            return fullUpdatedSessionActivity;
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteSessionActivity = async (sessionActivityId)=>{
        try {
            await (0, $apSGY.SessionActivityService).deleteSessionActivity(sessionActivityId);
        } catch (e) {
            this.handleError(e);
        }
    };
    /**
   * Role Activities
   */ createRoleActivity = async (newActivity)=>{
        if (!newActivity.role?.id || !newActivity.session_activity?.id || !newActivity.project?.id) return;
        const request = {
            roleId: newActivity.role?.id,
            sessionActivityId: newActivity.session_activity?.id,
            projectId: newActivity.project?.id,
            isHazardousWork: newActivity.is_hazardous_work,
            isOwnStuntPerformer: newActivity.is_own_stunt_performer,
            isWetSnowSmokeDustWork: newActivity.is_wet_snow_smoke_dust_work
        };
        try {
            const { roleActivity: roleActivity } = await (0, $gR3wM.RoleActivityService).createRoleActivity(request);
            return roleActivity;
        } catch (e) {
            this.handleError(e);
        }
    };
    updateRoleActivity = async (updatedActivity)=>{
        if (!updatedActivity.id) return;
        const request = {
            isHazardousWork: updatedActivity.is_hazardous_work,
            isOwnStuntPerformer: updatedActivity.is_own_stunt_performer,
            isWetSnowSmokeDustWork: updatedActivity.is_wet_snow_smoke_dust_work
        };
        try {
            const { roleActivity: roleActivity } = await (0, $gR3wM.RoleActivityService).updateRoleActivity(updatedActivity.id, request);
            // update displayed estimate values
            const est = await this.rootStore.estimateStore.getEstimate(this.rootStore.estimateStore.currentEstimate?.id, 'session_estimates,usage_estimates');
            est && this.rootStore.estimateStore.setCurrentEstimate(est);
            return roleActivity;
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("jPINK", function(module, exports) {

$parcel$export(module.exports, "SessionStore", () => $a0c90162195fbb86$export$90b8cff65c105172);
parcelRequire("hcQWc");
var $bHCgu = parcelRequire("bHCgu");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");

var $dOfWq = parcelRequire("dOfWq");
var $a0c90162195fbb86$require$Buffer = $dOfWq.Buffer;
class $a0c90162195fbb86$export$90b8cff65c105172 extends (0, $3kkid.BaseStore) {
    currentSession = undefined;
    sessionList;
    isSaving = false;
    constructor(rootStore){
        super(rootStore);
        this.sessionList = [];
        (0, $hK1qT.makeObservable)(this, {
            currentSession: (0, $hK1qT.observable),
            sessionList: (0, $hK1qT.observable),
            isSaving: (0, $hK1qT.observable)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    getLastSessionDate() {
        return [
            ...this.sessionList
        ].sort((a, b)=>(a.date ?? '') > (b.date ?? '') ? -1 : 1)[0]?.date ?? '';
    }
    getSessionDates = (sessionId)=>{
        return this.sessionList?.filter((se)=>se.id !== sessionId).sort((a, b)=>(a.date ?? '') > (b.date ?? '') ? -1 : 1).map((se)=>se.date ?? '') ?? [];
    };
    setCurrentSession(session) {
        (0, $hK1qT.runInAction)(()=>this.currentSession = session);
    }
    setSessionList(sessionList) {
        (0, $hK1qT.runInAction)(()=>this.sessionList = sessionList);
    }
    listSessions = async (projectId)=>{
        try {
            const { sessions: sessions } = await (0, $bHCgu.SessionService).listSessions(projectId, undefined, undefined, undefined, 'activities,session_estimate,commercial');
            console.log('setting sessionList', sessions);
            this.setSessionList(sessions);
            return sessions;
        } catch (e) {
            this.handleError(e);
        }
    };
    getSession = async (sessionId, relations = 'activities,session_estimate,commercial')=>{
        try {
            const { session: session } = await (0, $bHCgu.SessionService).getSession(sessionId, relations);
            const a = await this.rootStore.sessionActivityStore.listSessionActivities(sessionId);
            if (session) {
                if (a) session.activities = a;
                return session;
            }
        } catch (e) {
            this.handleError(e);
        }
    };
    createSession = async (date, projectId, scriptId)=>{
        if (!projectId || !date) return;
        try {
            this.setIsSaving(true);
            const project = this.rootStore.projectStore.projectList?.find((p)=>p.id == projectId);
            if (!project) return;
            const { session: session } = await (0, $bHCgu.SessionService).createSession({
                date: date,
                projectId: projectId,
                scriptId: scriptId,
                isUnion: project.is_union
            });
            const newSession = await this.getSession(session?.id);
            if (newSession) {
                (0, $hK1qT.runInAction)(()=>{
                    this.sessionList.unshift(newSession);
                });
                return newSession;
            }
        } catch (e) {
            this.handleError(e);
            this.setIsSaving(false);
        }
    };
    updateSession = async (sessionId, update)=>{
        const i = this.sessionList?.findIndex(({ id: id })=>id === sessionId);
        console.log(sessionId, (0, $hK1qT.toJS)(this.sessionList));
        if (i === undefined || i === -1) return;
        try {
            this.setIsSaving(true);
            const { session: session } = await (0, $bHCgu.SessionService).updateSession(sessionId, update);
            const updatedSession = await this.getSession(session.id);
            if (updatedSession) {
                (0, $hK1qT.runInAction)(()=>{
                    this.sessionList.splice(i, 1, updatedSession);
                });
                return updatedSession;
            }
        } catch (e) {
            this.handleError(e);
            this.setIsSaving(false);
        }
    };
    deleteSession = async (sessionId)=>{
        try {
            this.setIsSaving(true);
            await (0, $bHCgu.SessionService).deleteSession(sessionId);
            if (sessionId === this.currentSession?.id) this.setCurrentSession(undefined);
            (0, $hK1qT.runInAction)(()=>{
                this.sessionList = this.sessionList?.filter((p)=>p.id !== sessionId);
            });
        } catch (e) {
            this.handleError(e);
            this.setIsSaving(false);
        }
    };
    generateSessionReport = async (sessionId)=>{
        try {
            // Type assertion since the API client will be regenerated
            const response = await (0, $bHCgu.SessionService).generateSessionReport(sessionId);
            if (response) {
                // Convert base64 to blob
                const byteArray = Uint8Array.from($a0c90162195fbb86$require$Buffer.from(response, 'base64'));
                const blob = new Blob([
                    byteArray
                ], {
                    type: 'application/pdf'
                });
                // Open PDF in new window
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Clean up the URL after a delay
                setTimeout(()=>window.URL.revokeObjectURL(url), 5000);
                return blob;
            }
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("1WQz8", function(module, exports) {

$parcel$export(module.exports, "TalentManagerStore", () => $2a899c4c7d0dcad7$export$af49a65f6071aeb9);
parcelRequire("hcQWc");
var $8zK2X = parcelRequire("8zK2X");
var $9Bndg = parcelRequire("9Bndg");
var $03jfi = parcelRequire("03jfi");
var $6g3QY = parcelRequire("6g3QY");
var $iC8zV = parcelRequire("iC8zV");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $2a899c4c7d0dcad7$export$af49a65f6071aeb9 extends (0, $3kkid.BaseStore) {
    profiles = [];
    myProfile = null;
    groupEngagements = [];
    myEngagements = [];
    creditPackages = [];
    isLoading = false;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            profiles: (0, $hK1qT.observable),
            myProfile: (0, $hK1qT.observable),
            groupEngagements: (0, $hK1qT.observable),
            myEngagements: (0, $hK1qT.observable),
            creditPackages: (0, $hK1qT.observable),
            isLoading: (0, $hK1qT.observable),
            reset: (0, $hK1qT.action)
        });
    }
    reset = ()=>{
        this.profiles = [];
        this.myProfile = null;
        this.groupEngagements = [];
        this.myEngagements = [];
        this.creditPackages = [];
        this.isLoading = false;
    };
    fetchMarketplace = async ()=>{
        try {
            const { talentManagerProfiles: talentManagerProfiles } = await this.q((0, $6g3QY.TalentManagerService).listTalentManagers());
            (0, $hK1qT.runInAction)(()=>{
                this.profiles = talentManagerProfiles;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    fetchAllProfiles = async ()=>{
        try {
            const { talentManagerProfiles: talentManagerProfiles } = await this.q((0, $6g3QY.TalentManagerService).listAllTalentManagers());
            (0, $hK1qT.runInAction)(()=>{
                this.profiles = talentManagerProfiles;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    fetchMyProfile = async ()=>{
        try {
            const [profileResult, engagementsResult] = await Promise.allSettled([
                this.q((0, $6g3QY.TalentManagerService).getMyTalentManager()),
                this.q((0, $03jfi.TalentManagerEngagementService).listMyEngagements())
            ]);
            (0, $hK1qT.runInAction)(()=>{
                if (profileResult.status === 'fulfilled') this.myProfile = profileResult.value.talentManagerProfile;
                else this.myProfile = null;
                if (engagementsResult.status === 'fulfilled') this.myEngagements = engagementsResult.value.engagements;
                else this.myEngagements = [];
            });
        } catch (e) {
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = null;
                this.myEngagements = [];
            });
            this.handleError(e);
        }
    };
    fetchGroupEngagements = async ()=>{
        try {
            const { engagements: engagements } = await this.q((0, $03jfi.TalentManagerEngagementService).listGroupEngagements());
            (0, $hK1qT.runInAction)(()=>{
                this.groupEngagements = engagements;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    fetchMyEngagements = async ()=>{
        try {
            const { engagements: engagements } = await this.q((0, $03jfi.TalentManagerEngagementService).listMyEngagements());
            (0, $hK1qT.runInAction)(()=>{
                this.myEngagements = engagements;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    fetchCreditPackages = async ()=>{
        try {
            const { creditPackages: creditPackages } = await this.q((0, $8zK2X.CreditsService).listCreditPackages());
            (0, $hK1qT.runInAction)(()=>{
                this.creditPackages = creditPackages;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    fetchCreditBalance = async (engagementId)=>{
        try {
            return await this.q((0, $03jfi.TalentManagerEngagementService).getCreditBalance(engagementId));
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    getProfile = async (id, projectId)=>{
        try {
            const { talentManagerProfile: talentManagerProfile, has_worked_with: has_worked_with } = await this.q((0, $6g3QY.TalentManagerService).getTalentManager(id, projectId));
            if (!talentManagerProfile) return null;
            return {
                profile: talentManagerProfile,
                hasWorkedWith: Boolean(has_worked_with)
            };
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    submitReview = async (profileId, rating, reviewText, projectId)=>{
        try {
            await this.q((0, $6g3QY.TalentManagerService).createTalentManagerReview(profileId, {
                rating: rating,
                review_text: reviewText,
                project_id: projectId
            }));
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        }
    };
    createEngagement = async (profileId, projectId)=>{
        try {
            const { engagement: engagement } = await this.q((0, $03jfi.TalentManagerEngagementService).createEngagement({
                talent_manager_profile_id: profileId,
                project_id: projectId
            }));
            if (!engagement) return null;
            (0, $hK1qT.runInAction)(()=>{
                this.groupEngagements = [
                    ...this.groupEngagements,
                    engagement
                ];
            });
            return engagement;
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    updateEngagement = async (id, canEditProject)=>{
        try {
            const { engagement: engagement } = await this.q((0, $03jfi.TalentManagerEngagementService).updateEngagement(id, {
                can_edit_project: canEditProject
            }));
            if (!engagement) return;
            (0, $hK1qT.runInAction)(()=>{
                this.groupEngagements = this.groupEngagements.map((e)=>e.id === id ? engagement : e);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    createCheckout = async (packageId, engagementId, returnUrl)=>{
        try {
            const { checkout_url: checkout_url } = await this.q((0, $8zK2X.CreditsService).createCreditCheckout({
                credit_package_id: packageId,
                engagement_id: engagementId,
                return_url: returnUrl
            }));
            return checkout_url;
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    registerTM = async (data)=>{
        try {
            const { talentManagerProfile: talentManagerProfile } = await this.q((0, $6g3QY.TalentManagerService).registerTalentManager(data));
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = talentManagerProfile;
            });
            return talentManagerProfile;
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    updateMyProfile = async (id, data)=>{
        try {
            const { talentManagerProfile: talentManagerProfile } = await this.q((0, $6g3QY.TalentManagerService).updateTalentManager(id, data));
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = talentManagerProfile;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    approveTM = async (id)=>{
        try {
            await this.q((0, $6g3QY.TalentManagerService).approveTalentManager(id));
            (0, $hK1qT.runInAction)(()=>{
                this.profiles = this.profiles.map((p)=>p.id === id ? {
                        ...p,
                        approval_status: 'approved'
                    } : p);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    suspendTM = async (id)=>{
        try {
            await this.q((0, $6g3QY.TalentManagerService).suspendTalentManager(id));
            (0, $hK1qT.runInAction)(()=>{
                this.profiles = this.profiles.map((p)=>p.id === id ? {
                        ...p,
                        approval_status: 'suspended'
                    } : p);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    logManualTime = async (data)=>{
        try {
            await this.q((0, $iC8zV.TalentManagerTimeService).logManualTime(data));
            await this.fetchMyEngagements();
        } catch (e) {
            this.handleError(e);
        }
    };
    approveTimeEntry = async (id, isBilled)=>{
        try {
            await this.q((0, $iC8zV.TalentManagerTimeService).approveTimeEntry(id, {
                is_billed: isBilled
            }));
            await this.fetchGroupEngagements();
            return true;
        } catch (e) {
            this.handleError(e);
            return false;
        }
    };
    getConnectOnboardingLink = async (returnUrl)=>{
        try {
            const { onboarding_url: onboarding_url } = await this.q((0, $9Bndg.StripeConnectService).getOnboardingLink({
                return_url: returnUrl
            }));
            return onboarding_url;
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    createConnectAccount = async ()=>{
        try {
            await this.q((0, $9Bndg.StripeConnectService).createConnectAccount());
        } catch (e) {
            this.handleError(e);
        }
    };
    uploadProfilePhoto = async (photo)=>{
        try {
            const { talentManagerProfile: talentManagerProfile } = await this.q((0, $6g3QY.TalentManagerService).uploadMyProfilePhoto({
                photo: photo
            }));
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = talentManagerProfile;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteProfilePhoto = async ()=>{
        try {
            const { talentManagerProfile: talentManagerProfile } = await this.q((0, $6g3QY.TalentManagerService).deleteMyProfilePhoto());
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = talentManagerProfile;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    getProfilePhotoUrl = async (profileId)=>{
        try {
            const { url: url } = await this.q((0, $6g3QY.TalentManagerService).getTalentManagerPhotoUrl(profileId));
            return url;
        } catch (e) {
            return null;
        }
    };
    parseResume = async (resume)=>{
        try {
            return await this.q((0, $6g3QY.TalentManagerService).parseResume({
                resume: resume
            }));
        } catch (e) {
            this.handleError(e);
            return null;
        }
    };
    uploadResume = async (resume)=>{
        try {
            const { talentManagerProfile: talentManagerProfile } = await this.q((0, $6g3QY.TalentManagerService).uploadMyResume({
                resume: resume
            }));
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = talentManagerProfile;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    deleteResume = async ()=>{
        try {
            const { talentManagerProfile: talentManagerProfile } = await this.q((0, $6g3QY.TalentManagerService).deleteMyResume());
            (0, $hK1qT.runInAction)(()=>{
                this.myProfile = talentManagerProfile;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    getResumeUrl = async (profileId)=>{
        try {
            const { url: url } = await this.q((0, $6g3QY.TalentManagerService).getTalentManagerResumeUrl(profileId));
            return url;
        } catch (e) {
            return null;
        }
    };
}

});

parcelRegister("9dnGJ", function(module, exports) {

$parcel$export(module.exports, "UsageStore", () => $74eb83c6fd943d9f$export$53165dda77818b34);
parcelRequire("hcQWc");
var $f7GXT = parcelRequire("f7GXT");

var $hK1qT = parcelRequire("hK1qT");

var $3kkid = parcelRequire("3kkid");
class $74eb83c6fd943d9f$export$53165dda77818b34 extends (0, $3kkid.BaseStore) {
    currentUsage = undefined;
    usageList = [];
    usageTypeInfo = {};
    isSaving = false;
    constructor(rootStore){
        super(rootStore);
        (0, $hK1qT.makeObservable)(this, {
            currentUsage: (0, $hK1qT.observable),
            usageList: (0, $hK1qT.observable),
            usageTypeInfo: (0, $hK1qT.observable),
            isSaving: (0, $hK1qT.observable)
        });
    }
    setIsSaving(isSaving) {
        (0, $hK1qT.runInAction)(()=>this.isSaving = isSaving);
    }
    setCurrentUsage(usage) {
        (0, $hK1qT.runInAction)(()=>this.currentUsage = usage);
    }
    setUsageList(usageList) {
        (0, $hK1qT.runInAction)(()=>this.usageList = usageList);
    }
    listUsages = async (relations = 'usage_estimate')=>{
        try {
            const { usages: usages } = await (0, $f7GXT.UsageService).listUsages(undefined, undefined, undefined, relations);
            this.setUsageList(usages);
            return usages;
        } catch (e) {
            this.handleError(e);
        }
    };
    getUsage = async (usageId, relations = 'usage_estimate')=>{
        try {
            const { usage: usage } = await (0, $f7GXT.UsageService).getUsage(usageId, relations);
            return usage;
        } catch (e) {
            this.handleError(e);
        }
    };
    createUsage = async (usageData)=>{
        try {
            this.setIsSaving(true);
            const { usage: usage } = await (0, $f7GXT.UsageService).createUsage(usageData);
            if (usage) {
                (0, $hK1qT.runInAction)(()=>{
                    this.usageList.push(usage);
                });
                return usage;
            }
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    updateUsage = async (usageId, updateRequest, isTempEstimate)=>{
        if (!usageId) return;
        try {
            this.setIsSaving(true);
            await (0, $f7GXT.UsageService).updateUsage(usageId, updateRequest);
            const fullUpdatedUsage = await this.getUsage(usageId);
            if (fullUpdatedUsage) {
                (0, $hK1qT.runInAction)(()=>{
                    const i = this.usageList?.findIndex(({ id: id })=>id === usageId) ?? -1;
                    if (i > -1) this.usageList.splice(i, 1, fullUpdatedUsage);
                    else this.usageList.push(fullUpdatedUsage);
                });
                // update displayed estimate values
                const est = await this.rootStore.estimateStore.getEstimate(isTempEstimate ? this.rootStore.estimateStore.tempEstimate?.id : this.rootStore.estimateStore.currentEstimate?.id, 'usage_estimates,session_estimates');
                est && isTempEstimate ? this.rootStore.estimateStore.setTempEstimate(est) : this.rootStore.estimateStore.setCurrentEstimate(est);
                return fullUpdatedUsage;
            }
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    deleteUsage = async (usageId)=>{
        try {
            this.setIsSaving(true);
            await (0, $f7GXT.UsageService).deleteUsage(usageId);
            if (usageId === this.currentUsage?.id) this.setCurrentUsage(undefined);
            (0, $hK1qT.runInAction)(()=>{
                this.usageList = this.usageList?.filter((p)=>p.id !== usageId);
            });
        } catch (e) {
            this.handleError(e);
        } finally{
            this.setIsSaving(false);
        }
    };
    getUsageTypeData = async ()=>{
        try {
            if (Object.keys(this.usageTypeInfo).length > 0) return this.usageTypeInfo;
            else (0, $hK1qT.runInAction)(async ()=>{
                const usage_types = await (0, $f7GXT.UsageService).getUsageTypeData();
                this.usageTypeInfo = usage_types;
                return usage_types;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
}

});

parcelRegister("22Wl1", function(module, exports) {

$parcel$export(module.exports, "UserStore", () => $616338c784f46876$export$1b645105c1ac05e1);
parcelRequire("hcQWc");
var $5VwGg = parcelRequire("5VwGg");
var $cS8Vf = parcelRequire("cS8Vf");
var $ai2Ek = parcelRequire("ai2Ek");

var $aIAdV = parcelRequire("aIAdV");

var $cyrqa = parcelRequire("cyrqa");

var $hK1qT = parcelRequire("hK1qT");

var $1xNcM = parcelRequire("1xNcM");

var $3kkid = parcelRequire("3kkid");
class $616338c784f46876$export$1b645105c1ac05e1 extends (0, $3kkid.BaseStore) {
    _user;
    _jwt;
    _restoring;
    // Explicit signal for "the initial token/user restore from storage hasn't resolved yet" —
    // distinct from "there's genuinely no session." Starts true only if a token is actually in
    // storage (there's something to wait for); consumers like RequireAuth gate on this instead of
    // inferring loading-vs-logged-out from `token`/`user`'s transient empty-placeholder values,
    // which caused a race (see specs/unified-chat.md BUG-4): `_user` starts as `{}` (truthy) and
    // `_jwt` starts as `''` (falsy) regardless of whether a real session exists, so on a fresh page
    // load there was no reliable way to tell "still loading" apart from "actually logged out."
    _bootstrapping;
    constructor(root){
        super(root);
        this._user = {};
        this._jwt = '';
        this._restoring = false;
        this._bootstrapping = Boolean((0, $aIAdV.default).getToken());
        if (this.token) (0, $cS8Vf.OpenAPI).TOKEN = this.token;
        (0, $hK1qT.makeObservable)(this, {
            _user: (0, $hK1qT.observable),
            _jwt: (0, $hK1qT.observable),
            _bootstrapping: (0, $hK1qT.observable),
            token: (0, $hK1qT.computed),
            user: (0, $hK1qT.computed),
            isBootstrapping: (0, $hK1qT.computed),
            restoreFromStorage: (0, $hK1qT.action),
            logout: (0, $hK1qT.action),
            confirmEmail: (0, $hK1qT.action),
            applySession: (0, $hK1qT.action)
        });
    }
    restoreFromStorage = async ()=>{
        if (this._restoring) return;
        const token = (0, $aIAdV.default).getToken();
        if (!token) {
            // Guard the write: this branch is reached on every read of `token`/`user` while logged
            // out (their getters call `restoreFromStorage()` on every access as long as `_jwt`/`_user`
            // stay empty), which is every render of every observer component that reads them. Writing
            // to an observable unconditionally here — even to the same value — re-enters a MobX action
            // from inside a computed's evaluation on every single one of those renders, which was
            // causing "Maximum update depth exceeded" (RootContextProvider) once anything also observed
            // `isBootstrapping`. Only actually write when there's a real transition to make.
            if (this._bootstrapping) (0, $hK1qT.runInAction)(()=>{
                this._bootstrapping = false;
            });
            return;
        }
        this._restoring = true;
        console.log('**Restoring JWT from storage**');
        this._jwt = (0, $cS8Vf.OpenAPI).TOKEN = token;
        const JwtUser = $cyrqa.decode(token || '', {
            json: true
        })?.data;
        try {
            const { user: user } = await this.q((0, $ai2Ek.UserService).getUser(JwtUser.id, 'groups,active_group'));
            if (!user) throw new Error('User not found');
            (0, $hK1qT.runInAction)(()=>{
                this._user = user;
            });
        } catch (e) {
            this.handleError(e);
            console.log('**JWT is invalid or user not found, logging out**');
            this.logout();
        } finally{
            this._restoring = false;
            (0, $hK1qT.runInAction)(()=>{
                this._bootstrapping = false;
            });
        }
    };
    get token() {
        if (!this._jwt) // the user has refreshed the page
        // get the jwt token from storage
        // and set the jwt token
        this.restoreFromStorage();
        return this._jwt;
    }
    get user() {
        if (!this._user?.id) // the user has refreshed the page
        this.restoreFromStorage();
        return (0, $hK1qT.toJS)(this._user);
    }
    /** True only while a stored token's restore is still in flight — see the field comment above. */ get isBootstrapping() {
        return this._bootstrapping;
    }
    signup = async ({ user: user, group: group, token: token })=>{
        const req = {
            user: user,
            group: group,
            token: token
        };
        try {
            return await this.q((0, $ai2Ek.UserService).signUp(req));
        } catch (e) {
            this.handleError(e, (0, $1xNcM.config).toast.signup.error(e));
        }
    };
    resendConfirmationEmail = async ()=>{
        try {
            await this.q((0, $ai2Ek.UserService).resendConfirmationEmail());
        } catch (e) {
            this.handleError(e);
        }
    };
    confirmEmail = async (t)=>{
        try {
            const { jwt: jwt, user: user } = await this.q((0, $ai2Ek.UserService).confirmEmail({
                token: t
            }));
            (0, $hK1qT.runInAction)(()=>{
                this._user = user;
                this._jwt = (0, $cS8Vf.OpenAPI).TOKEN = jwt;
                (0, $aIAdV.default).setToken(jwt);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    login = async (req)=>{
        try {
            const res = await this.q((0, $5VwGg.AuthenticationService).login(req));
            (0, $hK1qT.runInAction)(()=>{
                this._user = res.user;
                this._jwt = (0, $cS8Vf.OpenAPI).TOKEN = res.jwt;
                (0, $aIAdV.default).setToken(res.jwt);
            });
            return true;
        } catch (e) {
            this.handleError(e, (0, $1xNcM.config).toast.login.error(e));
            return false;
        }
    };
    /**
   * Switches the active session to an already-minted `{ jwt, user }` pair without making a
   * login request — the same assignment `login()` does inline above, factored out so
   * impersonation (adminStore.impersonateUser / exitImpersonation) can reuse it instead of
   * duplicating it.
   */ applySession = (jwt, user)=>{
        (0, $hK1qT.runInAction)(()=>{
            this._user = user;
            this._jwt = (0, $cS8Vf.OpenAPI).TOKEN = jwt;
            (0, $aIAdV.default).setToken(jwt);
        });
    };
    logout = ()=>{
        // If there's genuinely nothing to clear, don't touch `_user`/`_jwt` — reassigning `_user` to a
        // fresh `{}` every call (even when it's already empty) creates a new object reference each
        // time, which defeats MobX's memoization of the `user` computed. Consumers like RequireAuth
        // call `logout()` from an effect that has `user` in its dependency array specifically to
        // handle "no valid session," so an unguarded reassignment here caused that effect to see
        // `user` "change" on every run and re-fire itself forever — an infinite render loop for any
        // genuinely-unauthenticated visit to a protected route.
        if (!this._jwt && !this._user?.id) {
            (0, $aIAdV.default).removeLogInInfo();
            (0, $cS8Vf.OpenAPI).TOKEN = '';
            return;
        }
        this._user = {};
        this._jwt = '';
        this._bootstrapping = false;
        this.rootStore.talentManagerStore.reset();
        (0, $aIAdV.default).removeLogInInfo();
        (0, $cS8Vf.OpenAPI).TOKEN = '';
    };
    updateProfile = async (profile)=>{
        try {
            const { user: user } = await this.q((0, $ai2Ek.UserService).updateUser(profile.id, profile));
            (0, $hK1qT.runInAction)(()=>{
                this._user = {
                    ...this._user,
                    ...user
                };
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    changeActiveGroup = async (groupId)=>{
        try {
            const { group: group } = await this.q((0, $ai2Ek.UserService).changeActiveGroup(this.user.id, {
                group_id: groupId
            }));
            (0, $hK1qT.runInAction)(()=>{
                this._user = {
                    ...this._user,
                    active_group: group
                };
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    changePassword = async (oldPassword, newPassword)=>{
        try {
            await this.q((0, $ai2Ek.UserService).changePassword(this.user.id, {
                old_password: oldPassword,
                new_password: newPassword
            }));
            return true;
        } catch (e) {
            this.handleError(e);
        }
    };
    // forgot password
    forgotPassword = async (email)=>{
        try {
            await this.q((0, $ai2Ek.UserService).forgotPassword({
                email: email
            }));
            return true;
        } catch (e) {
            this.handleError(e);
        }
        return false;
    };
    validateResetPasswordToken = async (token)=>{
        try {
            const { user: user } = await this.q((0, $ai2Ek.UserService).validatePasswordResetToken(token));
            return user.id;
        } catch (e) {
            this.handleError(e);
        }
    };
    resetPassword = async (user_id, token, password)=>{
        try {
            return await this.q((0, $ai2Ek.UserService).resetPassword({
                user_id: user_id,
                token: token,
                password: password
            }));
        } catch (e) {
            this.handleError(e);
        }
    };
    isEmailAvailable = async (email)=>{
        if (!email) return true;
        try {
            const res = await this.q((0, $ai2Ek.UserService).isEmailAvailable(email));
            return res;
        } catch (e) {
            this.handleError(e);
            return false;
        }
    };
    refreshUser = async ()=>{
        try {
            const { user: user } = await this.q((0, $ai2Ek.UserService).getUser(this._user.id, 'groups,active_group'));
            (0, $hK1qT.runInAction)(()=>{
                if (user) this._user = user;
            });
        } catch (e) {
            this.handleError(e);
        }
    };
    getOAuthProfile = async (userId, provider)=>{
        // Initialize oauth_profiles if undefined
        if (!this._user.oauth_profiles) this._user.oauth_profiles = [];
        if (!this._user.oauth_profiles.find((p)=>p.provider === provider)) try {
            const res = await this.q((0, $ai2Ek.UserService).getUserOAuthProfile(userId, provider));
            (0, $hK1qT.runInAction)(()=>{
                console.log(`Fetched OAuth profile for ${provider}:`, res);
                this._user.oauth_profiles.push({
                    ...res.profile
                });
            });
        } catch (e) {
            // Show user-friendly message if token expired
            if (e.status === 401 || e.status === 404) // Use handleError which will show the toast
            this.handleError(new Error('OAuth connection expired or not found. Please reconnect.'));
            else this.handleError(e);
        }
    };
    disconnectOAuthProfile = async (userId, provider)=>{
        try {
            await this.q((0, $ai2Ek.UserService).disconnectOAuthProfile(userId, provider));
            (0, $hK1qT.runInAction)(()=>{
                this._user.oauth_profiles = this._user.oauth_profiles.filter((p)=>p.provider !== provider);
            });
        } catch (e) {
            this.handleError(e);
        }
    };
}

});
parcelRegister("cyrqa", function(module, exports) {






module.exports = {
    decode: (parcelRequire("gW33N")),
    verify: (parcelRequire("65yQz")),
    sign: (parcelRequire("EvRMc")),
    JsonWebTokenError: (parcelRequire("gxjpB")),
    NotBeforeError: (parcelRequire("318Pk")),
    TokenExpiredError: (parcelRequire("04KOf"))
};

});
parcelRegister("gW33N", function(module, exports) {

var $3iamx = parcelRequire("3iamx");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $3iamx.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === 'string') try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === 'object') payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("3iamx", function(module, exports) {

$parcel$export(module.exports, "sign", () => $265b17522a9b3410$export$c5552dfdbc7cec71, (v) => $265b17522a9b3410$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "verify", () => $265b17522a9b3410$export$532244b5b8b0b4b6, (v) => $265b17522a9b3410$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "decode", () => $265b17522a9b3410$export$2f872c0f2117be69, (v) => $265b17522a9b3410$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "createSign", () => $265b17522a9b3410$export$45df7cae684751af, (v) => $265b17522a9b3410$export$45df7cae684751af = v);
/*global exports*/ var $265b17522a9b3410$export$6f6fa4628974a579;
var $265b17522a9b3410$export$c5552dfdbc7cec71;
var $265b17522a9b3410$export$532244b5b8b0b4b6;
var $265b17522a9b3410$export$2f872c0f2117be69;
var $265b17522a9b3410$export$1ea939691cdc45b8;
var $265b17522a9b3410$export$45df7cae684751af;
var $265b17522a9b3410$export$6f65485f87568e37;

var $12W2p = parcelRequire("12W2p");

var $b5Fjh = parcelRequire("b5Fjh");
var $265b17522a9b3410$var$ALGORITHMS = [
    'HS256',
    'HS384',
    'HS512',
    'RS256',
    'RS384',
    'RS512',
    'PS256',
    'PS384',
    'PS512',
    'ES256',
    'ES384',
    'ES512'
];
$265b17522a9b3410$export$6f6fa4628974a579 = $265b17522a9b3410$var$ALGORITHMS;
$265b17522a9b3410$export$c5552dfdbc7cec71 = $12W2p.sign;
$265b17522a9b3410$export$532244b5b8b0b4b6 = $b5Fjh.verify;
$265b17522a9b3410$export$2f872c0f2117be69 = $b5Fjh.decode;
$265b17522a9b3410$export$1ea939691cdc45b8 = $b5Fjh.isValid;
$265b17522a9b3410$export$45df7cae684751af = function createSign(opts) {
    return new $12W2p(opts);
};
$265b17522a9b3410$export$6f65485f87568e37 = function createVerify(opts) {
    return new $b5Fjh(opts);
};

});
parcelRegister("12W2p", function(module, exports) {
/*global module*/ 
var $h9jRt = parcelRequire("h9jRt");
var $0c32ff78cb97df09$require$Buffer = $h9jRt.Buffer;

var $ahiF8 = parcelRequire("ahiF8");

var $bOSsC = parcelRequire("bOSsC");

var $9Bpih = parcelRequire("9Bpih");

var $3nxH7 = parcelRequire("3nxH7");

var $en6bb = parcelRequire("en6bb");
function $0c32ff78cb97df09$var$base64url(string, encoding) {
    return $0c32ff78cb97df09$require$Buffer.from(string, encoding).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $0c32ff78cb97df09$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || 'utf8';
    var encodedHeader = $0c32ff78cb97df09$var$base64url($3nxH7(header), 'binary');
    var encodedPayload = $0c32ff78cb97df09$var$base64url($3nxH7(payload), encoding);
    return $en6bb.format('%s.%s', encodedHeader, encodedPayload);
}
function $0c32ff78cb97df09$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $bOSsC(header.alg);
    var securedInput = $0c32ff78cb97df09$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $en6bb.format('%s.%s', securedInput, signature);
}
function $0c32ff78cb97df09$var$SignStream(opts) {
    var secret = opts.secret;
    secret = secret == null ? opts.privateKey : secret;
    secret = secret == null ? opts.key : secret;
    if (/^hs/i.test(opts.header.alg) === true && secret == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $ahiF8(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $ahiF8(opts.payload);
    this.secret.once('close', (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once('close', (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$en6bb.inherits($0c32ff78cb97df09$var$SignStream, $9Bpih);
$0c32ff78cb97df09$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $0c32ff78cb97df09$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit('done', signature);
        this.emit('data', signature);
        this.emit('end');
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$0c32ff78cb97df09$var$SignStream.sign = $0c32ff78cb97df09$var$jwsSign;
module.exports = $0c32ff78cb97df09$var$SignStream;

});
parcelRegister("h9jRt", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $dOfWq = parcelRequire("dOfWq");
var $c7c2af04cc245021$var$Buffer = $dOfWq.Buffer;
// alternative to using Object.keys for old browsers
function $c7c2af04cc245021$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c7c2af04cc245021$var$Buffer.from && $c7c2af04cc245021$var$Buffer.alloc && $c7c2af04cc245021$var$Buffer.allocUnsafe && $c7c2af04cc245021$var$Buffer.allocUnsafeSlow) module.exports = $dOfWq;
else {
    // Copy properties from require('buffer')
    $c7c2af04cc245021$var$copyProps($dOfWq, module.exports);
    module.exports.Buffer = $c7c2af04cc245021$var$SafeBuffer;
}
function $c7c2af04cc245021$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c7c2af04cc245021$var$Buffer(arg, encodingOrOffset, length);
}
$c7c2af04cc245021$var$SafeBuffer.prototype = Object.create($c7c2af04cc245021$var$Buffer.prototype);
// Copy static methods from Buffer
$c7c2af04cc245021$var$copyProps($c7c2af04cc245021$var$Buffer, $c7c2af04cc245021$var$SafeBuffer);
$c7c2af04cc245021$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $c7c2af04cc245021$var$Buffer(arg, encodingOrOffset, length);
};
$c7c2af04cc245021$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $c7c2af04cc245021$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c7c2af04cc245021$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $c7c2af04cc245021$var$Buffer(size);
};
$c7c2af04cc245021$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $dOfWq.SlowBuffer(size);
};

});

parcelRegister("ahiF8", function(module, exports) {
/*global module, process*/ 
var $1g1jb = parcelRequire("1g1jb");

var $h9jRt = parcelRequire("h9jRt");
var $77b9f7e1eefaa0f9$require$Buffer = $h9jRt.Buffer;

var $9Bpih = parcelRequire("9Bpih");

var $en6bb = parcelRequire("en6bb");
function $77b9f7e1eefaa0f9$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $77b9f7e1eefaa0f9$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === 'function') {
        this.buffer = $77b9f7e1eefaa0f9$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === 'object') {
        this.buffer = data;
        this.writable = false;
        $1g1jb.nextTick((function() {
            this.emit('end', data);
            this.readable = false;
            this.emit('close');
        }).bind(this));
        return this;
    }
    throw new TypeError('Unexpected data type (' + typeof data + ')');
}
$en6bb.inherits($77b9f7e1eefaa0f9$var$DataStream, $9Bpih);
$77b9f7e1eefaa0f9$var$DataStream.prototype.write = function write(data) {
    this.buffer = $77b9f7e1eefaa0f9$require$Buffer.concat([
        this.buffer,
        $77b9f7e1eefaa0f9$require$Buffer.from(data)
    ]);
    this.emit('data', data);
};
$77b9f7e1eefaa0f9$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit('end', data);
    this.emit('close');
    this.writable = false;
    this.readable = false;
};
module.exports = $77b9f7e1eefaa0f9$var$DataStream;

});
parcelRegister("1g1jb", function(module, exports) {
// shim for using process in browser
var $0ea84ce8492cc593$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0ea84ce8492cc593$var$cachedSetTimeout;
var $0ea84ce8492cc593$var$cachedClearTimeout;
function $0ea84ce8492cc593$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $0ea84ce8492cc593$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $0ea84ce8492cc593$var$cachedSetTimeout = setTimeout;
        else $0ea84ce8492cc593$var$cachedSetTimeout = $0ea84ce8492cc593$var$defaultSetTimout;
    } catch (e) {
        $0ea84ce8492cc593$var$cachedSetTimeout = $0ea84ce8492cc593$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $0ea84ce8492cc593$var$cachedClearTimeout = clearTimeout;
        else $0ea84ce8492cc593$var$cachedClearTimeout = $0ea84ce8492cc593$var$defaultClearTimeout;
    } catch (e) {
        $0ea84ce8492cc593$var$cachedClearTimeout = $0ea84ce8492cc593$var$defaultClearTimeout;
    }
})();
function $0ea84ce8492cc593$var$runTimeout(fun) {
    if ($0ea84ce8492cc593$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0ea84ce8492cc593$var$cachedSetTimeout === $0ea84ce8492cc593$var$defaultSetTimout || !$0ea84ce8492cc593$var$cachedSetTimeout) && setTimeout) {
        $0ea84ce8492cc593$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0ea84ce8492cc593$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0ea84ce8492cc593$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0ea84ce8492cc593$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0ea84ce8492cc593$var$runClearTimeout(marker) {
    if ($0ea84ce8492cc593$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0ea84ce8492cc593$var$cachedClearTimeout === $0ea84ce8492cc593$var$defaultClearTimeout || !$0ea84ce8492cc593$var$cachedClearTimeout) && clearTimeout) {
        $0ea84ce8492cc593$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0ea84ce8492cc593$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0ea84ce8492cc593$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0ea84ce8492cc593$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0ea84ce8492cc593$var$queue = [];
var $0ea84ce8492cc593$var$draining = false;
var $0ea84ce8492cc593$var$currentQueue;
var $0ea84ce8492cc593$var$queueIndex = -1;
function $0ea84ce8492cc593$var$cleanUpNextTick() {
    if (!$0ea84ce8492cc593$var$draining || !$0ea84ce8492cc593$var$currentQueue) return;
    $0ea84ce8492cc593$var$draining = false;
    if ($0ea84ce8492cc593$var$currentQueue.length) $0ea84ce8492cc593$var$queue = $0ea84ce8492cc593$var$currentQueue.concat($0ea84ce8492cc593$var$queue);
    else $0ea84ce8492cc593$var$queueIndex = -1;
    if ($0ea84ce8492cc593$var$queue.length) $0ea84ce8492cc593$var$drainQueue();
}
function $0ea84ce8492cc593$var$drainQueue() {
    if ($0ea84ce8492cc593$var$draining) return;
    var timeout = $0ea84ce8492cc593$var$runTimeout($0ea84ce8492cc593$var$cleanUpNextTick);
    $0ea84ce8492cc593$var$draining = true;
    var len = $0ea84ce8492cc593$var$queue.length;
    while(len){
        $0ea84ce8492cc593$var$currentQueue = $0ea84ce8492cc593$var$queue;
        $0ea84ce8492cc593$var$queue = [];
        while(++$0ea84ce8492cc593$var$queueIndex < len)if ($0ea84ce8492cc593$var$currentQueue) $0ea84ce8492cc593$var$currentQueue[$0ea84ce8492cc593$var$queueIndex].run();
        $0ea84ce8492cc593$var$queueIndex = -1;
        len = $0ea84ce8492cc593$var$queue.length;
    }
    $0ea84ce8492cc593$var$currentQueue = null;
    $0ea84ce8492cc593$var$draining = false;
    $0ea84ce8492cc593$var$runClearTimeout(timeout);
}
$0ea84ce8492cc593$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0ea84ce8492cc593$var$queue.push(new $0ea84ce8492cc593$var$Item(fun, args));
    if ($0ea84ce8492cc593$var$queue.length === 1 && !$0ea84ce8492cc593$var$draining) $0ea84ce8492cc593$var$runTimeout($0ea84ce8492cc593$var$drainQueue);
};
// v8 likes predictible objects
function $0ea84ce8492cc593$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0ea84ce8492cc593$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0ea84ce8492cc593$var$process.title = 'browser';
$0ea84ce8492cc593$var$process.browser = true;
$0ea84ce8492cc593$var$process.env = {};
$0ea84ce8492cc593$var$process.argv = [];
$0ea84ce8492cc593$var$process.version = ''; // empty string to avoid regexp issues
$0ea84ce8492cc593$var$process.versions = {};
function $0ea84ce8492cc593$var$noop() {}
$0ea84ce8492cc593$var$process.on = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.addListener = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.once = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.off = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.removeListener = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.removeAllListeners = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.emit = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.prependListener = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.prependOnceListener = $0ea84ce8492cc593$var$noop;
$0ea84ce8492cc593$var$process.listeners = function(name) {
    return [];
};
$0ea84ce8492cc593$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$0ea84ce8492cc593$var$process.cwd = function() {
    return '/';
};
$0ea84ce8492cc593$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$0ea84ce8492cc593$var$process.umask = function() {
    return 0;
};

});

parcelRegister("9Bpih", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $6fdb309577c475f5$var$Stream;

var $6UvgR = parcelRequire("6UvgR");
var $6fdb309577c475f5$require$EE = $6UvgR.EventEmitter;

var $aAKqs = parcelRequire("aAKqs");
$aAKqs($6fdb309577c475f5$var$Stream, $6fdb309577c475f5$require$EE);

$6fdb309577c475f5$var$Stream.Readable = (parcelRequire("7VF86"));

$6fdb309577c475f5$var$Stream.Writable = (parcelRequire("cejI1"));

$6fdb309577c475f5$var$Stream.Duplex = (parcelRequire("aHpQk"));

$6fdb309577c475f5$var$Stream.Transform = (parcelRequire("gvMjh"));

$6fdb309577c475f5$var$Stream.PassThrough = (parcelRequire("1T7DK"));

$6fdb309577c475f5$var$Stream.finished = (parcelRequire("bugji"));

$6fdb309577c475f5$var$Stream.pipeline = (parcelRequire("lKM4x"));
// Backwards-compat with node 0.4.x
$6fdb309577c475f5$var$Stream.Stream = $6fdb309577c475f5$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $6fdb309577c475f5$var$Stream() {
    $6fdb309577c475f5$require$EE.call(this);
}
$6fdb309577c475f5$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($6fdb309577c475f5$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("6UvgR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $50803acb3de354af$var$R = typeof Reflect === 'object' ? Reflect : null;
var $50803acb3de354af$var$ReflectApply = $50803acb3de354af$var$R && typeof $50803acb3de354af$var$R.apply === 'function' ? $50803acb3de354af$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $50803acb3de354af$var$ReflectOwnKeys;
if ($50803acb3de354af$var$R && typeof $50803acb3de354af$var$R.ownKeys === 'function') $50803acb3de354af$var$ReflectOwnKeys = $50803acb3de354af$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $50803acb3de354af$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $50803acb3de354af$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $50803acb3de354af$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $50803acb3de354af$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $50803acb3de354af$var$EventEmitter() {
    $50803acb3de354af$var$EventEmitter.init.call(this);
}
module.exports = $50803acb3de354af$var$EventEmitter;
module.exports.once = $50803acb3de354af$var$once;
// Backwards-compat with node 0.10.x
$50803acb3de354af$var$EventEmitter.EventEmitter = $50803acb3de354af$var$EventEmitter;
$50803acb3de354af$var$EventEmitter.prototype._events = undefined;
$50803acb3de354af$var$EventEmitter.prototype._eventsCount = 0;
$50803acb3de354af$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $50803acb3de354af$var$defaultMaxListeners = 10;
function $50803acb3de354af$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($50803acb3de354af$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $50803acb3de354af$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $50803acb3de354af$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $50803acb3de354af$var$defaultMaxListeners = arg;
    }
});
$50803acb3de354af$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$50803acb3de354af$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $50803acb3de354af$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $50803acb3de354af$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $50803acb3de354af$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$50803acb3de354af$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $50803acb3de354af$var$_getMaxListeners(this);
};
$50803acb3de354af$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $50803acb3de354af$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $50803acb3de354af$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$50803acb3de354af$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $50803acb3de354af$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $50803acb3de354af$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $50803acb3de354af$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $50803acb3de354af$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$50803acb3de354af$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $50803acb3de354af$var$_addListener(this, type, listener, false);
};
$50803acb3de354af$var$EventEmitter.prototype.on = $50803acb3de354af$var$EventEmitter.prototype.addListener;
$50803acb3de354af$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $50803acb3de354af$var$_addListener(this, type, listener, true);
};
function $50803acb3de354af$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $50803acb3de354af$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $50803acb3de354af$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$50803acb3de354af$var$EventEmitter.prototype.once = function once(type, listener) {
    $50803acb3de354af$var$checkListener(listener);
    this.on(type, $50803acb3de354af$var$_onceWrap(this, type, listener));
    return this;
};
$50803acb3de354af$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $50803acb3de354af$var$checkListener(listener);
    this.prependListener(type, $50803acb3de354af$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$50803acb3de354af$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $50803acb3de354af$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $50803acb3de354af$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$50803acb3de354af$var$EventEmitter.prototype.off = $50803acb3de354af$var$EventEmitter.prototype.removeListener;
$50803acb3de354af$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $50803acb3de354af$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $50803acb3de354af$var$unwrapListeners(evlistener) : $50803acb3de354af$var$arrayClone(evlistener, evlistener.length);
}
$50803acb3de354af$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $50803acb3de354af$var$_listeners(this, type, true);
};
$50803acb3de354af$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $50803acb3de354af$var$_listeners(this, type, false);
};
$50803acb3de354af$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $50803acb3de354af$var$listenerCount.call(emitter, type);
};
$50803acb3de354af$var$EventEmitter.prototype.listenerCount = $50803acb3de354af$var$listenerCount;
function $50803acb3de354af$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$50803acb3de354af$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $50803acb3de354af$var$ReflectOwnKeys(this._events) : [];
};
function $50803acb3de354af$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $50803acb3de354af$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $50803acb3de354af$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $50803acb3de354af$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $50803acb3de354af$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $50803acb3de354af$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $50803acb3de354af$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $50803acb3de354af$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $50803acb3de354af$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("aAKqs", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("7VF86", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1g1jb = parcelRequire("1g1jb");
'use strict';
module.exports = $5c5dc2c54b67972b$var$Readable;
/*<replacement>*/ var $5c5dc2c54b67972b$var$Duplex;
/*</replacement>*/ $5c5dc2c54b67972b$var$Readable.ReadableState = $5c5dc2c54b67972b$var$ReadableState;

var $6UvgR = parcelRequire("6UvgR");
var $5c5dc2c54b67972b$require$EE = $6UvgR.EventEmitter;
var $5c5dc2c54b67972b$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $fE5vx = parcelRequire("fE5vx");

var $dOfWq = parcelRequire("dOfWq");
var $5c5dc2c54b67972b$require$Buffer = $dOfWq.Buffer;
var $5c5dc2c54b67972b$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5c5dc2c54b67972b$var$_uint8ArrayToBuffer(chunk) {
    return $5c5dc2c54b67972b$require$Buffer.from(chunk);
}
function $5c5dc2c54b67972b$var$_isUint8Array(obj) {
    return $5c5dc2c54b67972b$require$Buffer.isBuffer(obj) || obj instanceof $5c5dc2c54b67972b$var$OurUint8Array;
}

var $f8f1G = parcelRequire("f8f1G");
var $5c5dc2c54b67972b$var$debug;
if ($f8f1G && $f8f1G.debuglog) $5c5dc2c54b67972b$var$debug = $f8f1G.debuglog('stream');
else $5c5dc2c54b67972b$var$debug = function debug() {};

var $4BFEN = parcelRequire("4BFEN");

var $cYKty = parcelRequire("cYKty");

var $2JnLq = parcelRequire("2JnLq");
var $5c5dc2c54b67972b$var$getHighWaterMark = $2JnLq.getHighWaterMark;

var $77rHX = parcelRequire("77rHX");
var $5c5dc2c54b67972b$require$_require$codes = $77rHX.codes;
var $5c5dc2c54b67972b$var$ERR_INVALID_ARG_TYPE = $5c5dc2c54b67972b$require$_require$codes.ERR_INVALID_ARG_TYPE, $5c5dc2c54b67972b$var$ERR_STREAM_PUSH_AFTER_EOF = $5c5dc2c54b67972b$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $5c5dc2c54b67972b$var$ERR_METHOD_NOT_IMPLEMENTED = $5c5dc2c54b67972b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5c5dc2c54b67972b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $5c5dc2c54b67972b$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $5c5dc2c54b67972b$var$StringDecoder;
var $5c5dc2c54b67972b$var$createReadableStreamAsyncIterator;
var $5c5dc2c54b67972b$var$from;

(parcelRequire("aAKqs"))($5c5dc2c54b67972b$var$Readable, $fE5vx);
var $5c5dc2c54b67972b$var$errorOrDestroy = $cYKty.errorOrDestroy;
var $5c5dc2c54b67972b$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $5c5dc2c54b67972b$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $5c5dc2c54b67972b$var$ReadableState(options, stream, isDuplex) {
    $5c5dc2c54b67972b$var$Duplex = $5c5dc2c54b67972b$var$Duplex || (parcelRequire("aHpQk"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5c5dc2c54b67972b$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $5c5dc2c54b67972b$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $4BFEN();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$5c5dc2c54b67972b$var$StringDecoder) $5c5dc2c54b67972b$var$StringDecoder = (parcelRequire("gwpIL")).StringDecoder;
        this.decoder = new $5c5dc2c54b67972b$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $5c5dc2c54b67972b$var$Readable(options) {
    $5c5dc2c54b67972b$var$Duplex = $5c5dc2c54b67972b$var$Duplex || (parcelRequire("aHpQk"));
    if (!(this instanceof $5c5dc2c54b67972b$var$Readable)) return new $5c5dc2c54b67972b$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5c5dc2c54b67972b$var$Duplex;
    this._readableState = new $5c5dc2c54b67972b$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $fE5vx.call(this);
}
Object.defineProperty($5c5dc2c54b67972b$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$5c5dc2c54b67972b$var$Readable.prototype.destroy = $cYKty.destroy;
$5c5dc2c54b67972b$var$Readable.prototype._undestroy = $cYKty.undestroy;
$5c5dc2c54b67972b$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$5c5dc2c54b67972b$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $5c5dc2c54b67972b$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $5c5dc2c54b67972b$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$5c5dc2c54b67972b$var$Readable.prototype.unshift = function(chunk) {
    return $5c5dc2c54b67972b$var$readableAddChunk(this, chunk, null, true, false);
};
function $5c5dc2c54b67972b$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $5c5dc2c54b67972b$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $5c5dc2c54b67972b$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $5c5dc2c54b67972b$var$chunkInvalid(state, chunk);
        if (er) $5c5dc2c54b67972b$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $5c5dc2c54b67972b$require$Buffer.prototype) chunk = $5c5dc2c54b67972b$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $5c5dc2c54b67972b$var$errorOrDestroy(stream, new $5c5dc2c54b67972b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $5c5dc2c54b67972b$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $5c5dc2c54b67972b$var$errorOrDestroy(stream, new $5c5dc2c54b67972b$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $5c5dc2c54b67972b$var$addChunk(stream, state, chunk, false);
                    else $5c5dc2c54b67972b$var$maybeReadMore(stream, state);
                } else $5c5dc2c54b67972b$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $5c5dc2c54b67972b$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $5c5dc2c54b67972b$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $5c5dc2c54b67972b$var$emitReadable(stream);
    }
    $5c5dc2c54b67972b$var$maybeReadMore(stream, state);
}
function $5c5dc2c54b67972b$var$chunkInvalid(state, chunk) {
    var er;
    if (!$5c5dc2c54b67972b$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $5c5dc2c54b67972b$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$5c5dc2c54b67972b$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$5c5dc2c54b67972b$var$Readable.prototype.setEncoding = function(enc) {
    if (!$5c5dc2c54b67972b$var$StringDecoder) $5c5dc2c54b67972b$var$StringDecoder = (parcelRequire("gwpIL")).StringDecoder;
    var decoder = new $5c5dc2c54b67972b$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $5c5dc2c54b67972b$var$MAX_HWM = 0x40000000;
function $5c5dc2c54b67972b$var$computeNewHighWaterMark(n) {
    if (n >= $5c5dc2c54b67972b$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $5c5dc2c54b67972b$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5c5dc2c54b67972b$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $5c5dc2c54b67972b$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$5c5dc2c54b67972b$var$Readable.prototype.read = function(n) {
    $5c5dc2c54b67972b$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $5c5dc2c54b67972b$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $5c5dc2c54b67972b$var$endReadable(this);
        else $5c5dc2c54b67972b$var$emitReadable(this);
        return null;
    }
    n = $5c5dc2c54b67972b$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $5c5dc2c54b67972b$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $5c5dc2c54b67972b$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $5c5dc2c54b67972b$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $5c5dc2c54b67972b$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $5c5dc2c54b67972b$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $5c5dc2c54b67972b$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $5c5dc2c54b67972b$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $5c5dc2c54b67972b$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $5c5dc2c54b67972b$var$onEofChunk(stream, state) {
    $5c5dc2c54b67972b$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $5c5dc2c54b67972b$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $5c5dc2c54b67972b$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $5c5dc2c54b67972b$var$emitReadable(stream) {
    var state = stream._readableState;
    $5c5dc2c54b67972b$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $5c5dc2c54b67972b$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $1g1jb.nextTick($5c5dc2c54b67972b$var$emitReadable_, stream);
    }
}
function $5c5dc2c54b67972b$var$emitReadable_(stream) {
    var state = stream._readableState;
    $5c5dc2c54b67972b$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $5c5dc2c54b67972b$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $5c5dc2c54b67972b$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $1g1jb.nextTick($5c5dc2c54b67972b$var$maybeReadMore_, stream, state);
    }
}
function $5c5dc2c54b67972b$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $5c5dc2c54b67972b$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$5c5dc2c54b67972b$var$Readable.prototype._read = function(n) {
    $5c5dc2c54b67972b$var$errorOrDestroy(this, new $5c5dc2c54b67972b$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$5c5dc2c54b67972b$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $5c5dc2c54b67972b$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $1g1jb.stdout && dest !== $1g1jb.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $1g1jb.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $5c5dc2c54b67972b$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $5c5dc2c54b67972b$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $5c5dc2c54b67972b$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $5c5dc2c54b67972b$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $5c5dc2c54b67972b$var$debug('ondata');
        var ret = dest.write(chunk);
        $5c5dc2c54b67972b$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $5c5dc2c54b67972b$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $5c5dc2c54b67972b$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $5c5dc2c54b67972b$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($5c5dc2c54b67972b$var$EElistenerCount(dest, 'error') === 0) $5c5dc2c54b67972b$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $5c5dc2c54b67972b$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $5c5dc2c54b67972b$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $5c5dc2c54b67972b$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $5c5dc2c54b67972b$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $5c5dc2c54b67972b$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $5c5dc2c54b67972b$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $5c5dc2c54b67972b$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $5c5dc2c54b67972b$var$flow(src);
        }
    };
}
$5c5dc2c54b67972b$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $5c5dc2c54b67972b$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$5c5dc2c54b67972b$var$Readable.prototype.on = function(ev, fn) {
    var res = $fE5vx.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $5c5dc2c54b67972b$var$debug('on readable', state.length, state.reading);
            if (state.length) $5c5dc2c54b67972b$var$emitReadable(this);
            else if (!state.reading) $1g1jb.nextTick($5c5dc2c54b67972b$var$nReadingNextTick, this);
        }
    }
    return res;
};
$5c5dc2c54b67972b$var$Readable.prototype.addListener = $5c5dc2c54b67972b$var$Readable.prototype.on;
$5c5dc2c54b67972b$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $fE5vx.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $1g1jb.nextTick($5c5dc2c54b67972b$var$updateReadableListening, this);
    return res;
};
$5c5dc2c54b67972b$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $fE5vx.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $1g1jb.nextTick($5c5dc2c54b67972b$var$updateReadableListening, this);
    return res;
};
function $5c5dc2c54b67972b$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $5c5dc2c54b67972b$var$nReadingNextTick(self1) {
    $5c5dc2c54b67972b$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$5c5dc2c54b67972b$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $5c5dc2c54b67972b$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $5c5dc2c54b67972b$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $5c5dc2c54b67972b$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $1g1jb.nextTick($5c5dc2c54b67972b$var$resume_, stream, state);
    }
}
function $5c5dc2c54b67972b$var$resume_(stream, state) {
    $5c5dc2c54b67972b$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $5c5dc2c54b67972b$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$5c5dc2c54b67972b$var$Readable.prototype.pause = function() {
    $5c5dc2c54b67972b$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $5c5dc2c54b67972b$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $5c5dc2c54b67972b$var$flow(stream) {
    var state = stream._readableState;
    $5c5dc2c54b67972b$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$5c5dc2c54b67972b$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $5c5dc2c54b67972b$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $5c5dc2c54b67972b$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $5c5dc2c54b67972b$var$kProxyEvents.length; n++)stream.on($5c5dc2c54b67972b$var$kProxyEvents[n], this.emit.bind(this, $5c5dc2c54b67972b$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $5c5dc2c54b67972b$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $5c5dc2c54b67972b$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($5c5dc2c54b67972b$var$createReadableStreamAsyncIterator === undefined) $5c5dc2c54b67972b$var$createReadableStreamAsyncIterator = (parcelRequire("2OjVK"));
    return $5c5dc2c54b67972b$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($5c5dc2c54b67972b$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($5c5dc2c54b67972b$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($5c5dc2c54b67972b$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$5c5dc2c54b67972b$var$Readable._fromList = $5c5dc2c54b67972b$var$fromList;
Object.defineProperty($5c5dc2c54b67972b$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $5c5dc2c54b67972b$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $5c5dc2c54b67972b$var$endReadable(stream) {
    var state = stream._readableState;
    $5c5dc2c54b67972b$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $1g1jb.nextTick($5c5dc2c54b67972b$var$endReadableNT, state, stream);
    }
}
function $5c5dc2c54b67972b$var$endReadableNT(state, stream) {
    $5c5dc2c54b67972b$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $5c5dc2c54b67972b$var$Readable.from = function(iterable, opts) {
    if ($5c5dc2c54b67972b$var$from === undefined) $5c5dc2c54b67972b$var$from = (parcelRequire("5Td3P"));
    return $5c5dc2c54b67972b$var$from($5c5dc2c54b67972b$var$Readable, iterable, opts);
};
function $5c5dc2c54b67972b$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("fE5vx", function(module, exports) {

module.exports = (parcelRequire("6UvgR")).EventEmitter;

});

parcelRegister("f8f1G", function(module, exports) {
"use strict";

});

parcelRegister("4BFEN", function(module, exports) {
'use strict';
function $35aaee5437debbb5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $35aaee5437debbb5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $35aaee5437debbb5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $35aaee5437debbb5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $35aaee5437debbb5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $35aaee5437debbb5$var$_defineProperty(obj, key, value) {
    key = $35aaee5437debbb5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $35aaee5437debbb5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $35aaee5437debbb5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $35aaee5437debbb5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $35aaee5437debbb5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $35aaee5437debbb5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $35aaee5437debbb5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $35aaee5437debbb5$var$_toPropertyKey(arg) {
    var key = $35aaee5437debbb5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $35aaee5437debbb5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $dOfWq = parcelRequire("dOfWq");
var $35aaee5437debbb5$var$Buffer = $dOfWq.Buffer;

var $f8f1G = parcelRequire("f8f1G");
var $35aaee5437debbb5$var$inspect = $f8f1G.inspect;
var $35aaee5437debbb5$var$custom = $35aaee5437debbb5$var$inspect && $35aaee5437debbb5$var$inspect.custom || 'inspect';
function $35aaee5437debbb5$var$copyBuffer(src, target, offset) {
    $35aaee5437debbb5$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $35aaee5437debbb5$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $35aaee5437debbb5$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $35aaee5437debbb5$var$Buffer.alloc(0);
                var ret = $35aaee5437debbb5$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $35aaee5437debbb5$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $35aaee5437debbb5$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $35aaee5437debbb5$var$custom,
            value: function value(_, options) {
                return $35aaee5437debbb5$var$inspect(this, $35aaee5437debbb5$var$_objectSpread($35aaee5437debbb5$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cYKty", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $972f23b8cb1f94e8$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $1g1jb.nextTick($972f23b8cb1f94e8$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $1g1jb.nextTick($972f23b8cb1f94e8$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $1g1jb.nextTick($972f23b8cb1f94e8$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $1g1jb.nextTick($972f23b8cb1f94e8$var$emitErrorAndCloseNT, _this, err);
            } else $1g1jb.nextTick($972f23b8cb1f94e8$var$emitCloseNT, _this);
        } else if (cb) {
            $1g1jb.nextTick($972f23b8cb1f94e8$var$emitCloseNT, _this);
            cb(err);
        } else $1g1jb.nextTick($972f23b8cb1f94e8$var$emitCloseNT, _this);
    });
    return this;
}
function $972f23b8cb1f94e8$var$emitErrorAndCloseNT(self, err) {
    $972f23b8cb1f94e8$var$emitErrorNT(self, err);
    $972f23b8cb1f94e8$var$emitCloseNT(self);
}
function $972f23b8cb1f94e8$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $972f23b8cb1f94e8$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $972f23b8cb1f94e8$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $972f23b8cb1f94e8$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $972f23b8cb1f94e8$var$destroy,
    undestroy: $972f23b8cb1f94e8$var$undestroy,
    errorOrDestroy: $972f23b8cb1f94e8$var$errorOrDestroy
};

});

parcelRegister("2JnLq", function(module, exports) {
'use strict';

var $1fd237c6206c24f0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("77rHX")).codes.ERR_INVALID_OPT_VALUE;
function $1fd237c6206c24f0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1fd237c6206c24f0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $1fd237c6206c24f0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $1fd237c6206c24f0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $1fd237c6206c24f0$var$getHighWaterMark
};

});
parcelRegister("77rHX", function(module, exports) {

$parcel$export(module.exports, "codes", () => $52eeae115e220a13$export$e45cb6485273080e, (v) => $52eeae115e220a13$export$e45cb6485273080e = v);
var $52eeae115e220a13$export$e45cb6485273080e;
'use strict';
function $52eeae115e220a13$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $52eeae115e220a13$var$codes = {};
function $52eeae115e220a13$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $52eeae115e220a13$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $52eeae115e220a13$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $52eeae115e220a13$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $52eeae115e220a13$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $52eeae115e220a13$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $52eeae115e220a13$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$52eeae115e220a13$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$52eeae115e220a13$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $52eeae115e220a13$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($52eeae115e220a13$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($52eeae115e220a13$var$oneOf(expected, 'type'));
    else {
        var type = $52eeae115e220a13$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($52eeae115e220a13$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$52eeae115e220a13$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$52eeae115e220a13$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$52eeae115e220a13$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$52eeae115e220a13$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$52eeae115e220a13$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$52eeae115e220a13$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$52eeae115e220a13$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$52eeae115e220a13$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$52eeae115e220a13$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$52eeae115e220a13$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$52eeae115e220a13$export$e45cb6485273080e = $52eeae115e220a13$var$codes;

});


parcelRegister("aHpQk", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $1g1jb = parcelRequire("1g1jb");
'use strict';
/*<replacement>*/ var $7ca1f771a9708155$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $7ca1f771a9708155$var$Duplex;

var $7VF86 = parcelRequire("7VF86");

var $cejI1 = parcelRequire("cejI1");

(parcelRequire("aAKqs"))($7ca1f771a9708155$var$Duplex, $7VF86);
// Allow the keys array to be GC'ed.
var $7ca1f771a9708155$var$keys = $7ca1f771a9708155$var$objectKeys($cejI1.prototype);
for(var $7ca1f771a9708155$var$v = 0; $7ca1f771a9708155$var$v < $7ca1f771a9708155$var$keys.length; $7ca1f771a9708155$var$v++){
    var $7ca1f771a9708155$var$method = $7ca1f771a9708155$var$keys[$7ca1f771a9708155$var$v];
    if (!$7ca1f771a9708155$var$Duplex.prototype[$7ca1f771a9708155$var$method]) $7ca1f771a9708155$var$Duplex.prototype[$7ca1f771a9708155$var$method] = $cejI1.prototype[$7ca1f771a9708155$var$method];
}
function $7ca1f771a9708155$var$Duplex(options) {
    if (!(this instanceof $7ca1f771a9708155$var$Duplex)) return new $7ca1f771a9708155$var$Duplex(options);
    $7VF86.call(this, options);
    $cejI1.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $7ca1f771a9708155$var$onend);
        }
    }
}
Object.defineProperty($7ca1f771a9708155$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($7ca1f771a9708155$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($7ca1f771a9708155$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $7ca1f771a9708155$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $1g1jb.nextTick($7ca1f771a9708155$var$onEndNT, this);
}
function $7ca1f771a9708155$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($7ca1f771a9708155$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("cejI1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $1g1jb = parcelRequire("1g1jb");
'use strict';
module.exports = $8e7614a9cad3d149$var$Writable;
/* <replacement> */ function $8e7614a9cad3d149$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8e7614a9cad3d149$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8e7614a9cad3d149$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8e7614a9cad3d149$var$Duplex;
/*</replacement>*/ $8e7614a9cad3d149$var$Writable.WritableState = $8e7614a9cad3d149$var$WritableState;

/*<replacement>*/ var $8e7614a9cad3d149$var$internalUtil = {
    deprecate: (parcelRequire("9QIIF"))
};

var $fE5vx = parcelRequire("fE5vx");

var $dOfWq = parcelRequire("dOfWq");
var $8e7614a9cad3d149$require$Buffer = $dOfWq.Buffer;
var $8e7614a9cad3d149$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $8e7614a9cad3d149$var$_uint8ArrayToBuffer(chunk) {
    return $8e7614a9cad3d149$require$Buffer.from(chunk);
}
function $8e7614a9cad3d149$var$_isUint8Array(obj) {
    return $8e7614a9cad3d149$require$Buffer.isBuffer(obj) || obj instanceof $8e7614a9cad3d149$var$OurUint8Array;
}

var $cYKty = parcelRequire("cYKty");

var $2JnLq = parcelRequire("2JnLq");
var $8e7614a9cad3d149$var$getHighWaterMark = $2JnLq.getHighWaterMark;

var $77rHX = parcelRequire("77rHX");
var $8e7614a9cad3d149$require$_require$codes = $77rHX.codes;
var $8e7614a9cad3d149$var$ERR_INVALID_ARG_TYPE = $8e7614a9cad3d149$require$_require$codes.ERR_INVALID_ARG_TYPE, $8e7614a9cad3d149$var$ERR_METHOD_NOT_IMPLEMENTED = $8e7614a9cad3d149$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8e7614a9cad3d149$var$ERR_MULTIPLE_CALLBACK = $8e7614a9cad3d149$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8e7614a9cad3d149$var$ERR_STREAM_CANNOT_PIPE = $8e7614a9cad3d149$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $8e7614a9cad3d149$var$ERR_STREAM_DESTROYED = $8e7614a9cad3d149$require$_require$codes.ERR_STREAM_DESTROYED, $8e7614a9cad3d149$var$ERR_STREAM_NULL_VALUES = $8e7614a9cad3d149$require$_require$codes.ERR_STREAM_NULL_VALUES, $8e7614a9cad3d149$var$ERR_STREAM_WRITE_AFTER_END = $8e7614a9cad3d149$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $8e7614a9cad3d149$var$ERR_UNKNOWN_ENCODING = $8e7614a9cad3d149$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $8e7614a9cad3d149$var$errorOrDestroy = $cYKty.errorOrDestroy;

(parcelRequire("aAKqs"))($8e7614a9cad3d149$var$Writable, $fE5vx);
function $8e7614a9cad3d149$var$nop() {}

function $8e7614a9cad3d149$var$WritableState(options, stream, isDuplex) {
    $8e7614a9cad3d149$var$Duplex = $8e7614a9cad3d149$var$Duplex || (parcelRequire("aHpQk"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $8e7614a9cad3d149$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $8e7614a9cad3d149$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8e7614a9cad3d149$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8e7614a9cad3d149$var$CorkedRequest(this);
}
$8e7614a9cad3d149$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8e7614a9cad3d149$var$WritableState.prototype, 'buffer', {
            get: $8e7614a9cad3d149$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8e7614a9cad3d149$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $8e7614a9cad3d149$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8e7614a9cad3d149$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($8e7614a9cad3d149$var$realHasInstance.call(this, object)) return true;
            if (this !== $8e7614a9cad3d149$var$Writable) return false;
            return object && object._writableState instanceof $8e7614a9cad3d149$var$WritableState;
        }
    });
} else $8e7614a9cad3d149$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $8e7614a9cad3d149$var$Writable(options) {
    $8e7614a9cad3d149$var$Duplex = $8e7614a9cad3d149$var$Duplex || (parcelRequire("aHpQk"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8e7614a9cad3d149$var$Duplex;
    if (!isDuplex && !$8e7614a9cad3d149$var$realHasInstance.call($8e7614a9cad3d149$var$Writable, this)) return new $8e7614a9cad3d149$var$Writable(options);
    this._writableState = new $8e7614a9cad3d149$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $fE5vx.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8e7614a9cad3d149$var$Writable.prototype.pipe = function() {
    $8e7614a9cad3d149$var$errorOrDestroy(this, new $8e7614a9cad3d149$var$ERR_STREAM_CANNOT_PIPE());
};
function $8e7614a9cad3d149$var$writeAfterEnd(stream, cb) {
    var er = new $8e7614a9cad3d149$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $8e7614a9cad3d149$var$errorOrDestroy(stream, er);
    $1g1jb.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8e7614a9cad3d149$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $8e7614a9cad3d149$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $8e7614a9cad3d149$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $8e7614a9cad3d149$var$errorOrDestroy(stream, er);
        $1g1jb.nextTick(cb, er);
        return false;
    }
    return true;
}
$8e7614a9cad3d149$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8e7614a9cad3d149$var$_isUint8Array(chunk);
    if (isBuf && !$8e7614a9cad3d149$require$Buffer.isBuffer(chunk)) chunk = $8e7614a9cad3d149$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $8e7614a9cad3d149$var$nop;
    if (state.ending) $8e7614a9cad3d149$var$writeAfterEnd(this, cb);
    else if (isBuf || $8e7614a9cad3d149$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8e7614a9cad3d149$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8e7614a9cad3d149$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$8e7614a9cad3d149$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8e7614a9cad3d149$var$clearBuffer(this, state);
    }
};
$8e7614a9cad3d149$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $8e7614a9cad3d149$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($8e7614a9cad3d149$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $8e7614a9cad3d149$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $8e7614a9cad3d149$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8e7614a9cad3d149$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8e7614a9cad3d149$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8e7614a9cad3d149$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8e7614a9cad3d149$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8e7614a9cad3d149$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $8e7614a9cad3d149$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8e7614a9cad3d149$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $1g1jb.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $1g1jb.nextTick($8e7614a9cad3d149$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $8e7614a9cad3d149$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $8e7614a9cad3d149$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $8e7614a9cad3d149$var$finishMaybe(stream, state);
    }
}
function $8e7614a9cad3d149$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8e7614a9cad3d149$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $8e7614a9cad3d149$var$ERR_MULTIPLE_CALLBACK();
    $8e7614a9cad3d149$var$onwriteStateUpdate(state);
    if (er) $8e7614a9cad3d149$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8e7614a9cad3d149$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8e7614a9cad3d149$var$clearBuffer(stream, state);
        if (sync) $1g1jb.nextTick($8e7614a9cad3d149$var$afterWrite, stream, state, finished, cb);
        else $8e7614a9cad3d149$var$afterWrite(stream, state, finished, cb);
    }
}
function $8e7614a9cad3d149$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8e7614a9cad3d149$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8e7614a9cad3d149$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8e7614a9cad3d149$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $8e7614a9cad3d149$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8e7614a9cad3d149$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8e7614a9cad3d149$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8e7614a9cad3d149$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8e7614a9cad3d149$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $8e7614a9cad3d149$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$8e7614a9cad3d149$var$Writable.prototype._writev = null;
$8e7614a9cad3d149$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $8e7614a9cad3d149$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($8e7614a9cad3d149$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $8e7614a9cad3d149$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8e7614a9cad3d149$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $8e7614a9cad3d149$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $8e7614a9cad3d149$var$finishMaybe(stream, state);
    });
}
function $8e7614a9cad3d149$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $1g1jb.nextTick($8e7614a9cad3d149$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $8e7614a9cad3d149$var$finishMaybe(stream, state) {
    var need = $8e7614a9cad3d149$var$needFinish(state);
    if (need) {
        $8e7614a9cad3d149$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $8e7614a9cad3d149$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8e7614a9cad3d149$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $1g1jb.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8e7614a9cad3d149$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8e7614a9cad3d149$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8e7614a9cad3d149$var$Writable.prototype.destroy = $cYKty.destroy;
$8e7614a9cad3d149$var$Writable.prototype._undestroy = $cYKty.undestroy;
$8e7614a9cad3d149$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("9QIIF", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $72bba8bd254c478e$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $72bba8bd254c478e$var$deprecate(fn, msg) {
    if ($72bba8bd254c478e$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($72bba8bd254c478e$var$config('throwDeprecation')) throw new Error(msg);
            else if ($72bba8bd254c478e$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $72bba8bd254c478e$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("gwpIL", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $c0739623748fa589$export$63a7aa211a91ed69, (v) => $c0739623748fa589$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $c0739623748fa589$export$63a7aa211a91ed69;
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $c0739623748fa589$require$Buffer = $h9jRt.Buffer;
/*</replacement>*/ var $c0739623748fa589$var$isEncoding = $c0739623748fa589$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $c0739623748fa589$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $c0739623748fa589$var$normalizeEncoding(enc) {
    var nenc = $c0739623748fa589$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($c0739623748fa589$require$Buffer.isEncoding === $c0739623748fa589$var$isEncoding || !$c0739623748fa589$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$c0739623748fa589$export$63a7aa211a91ed69 = $c0739623748fa589$var$StringDecoder;
function $c0739623748fa589$var$StringDecoder(encoding) {
    this.encoding = $c0739623748fa589$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $c0739623748fa589$var$utf16Text;
            this.end = $c0739623748fa589$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $c0739623748fa589$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $c0739623748fa589$var$base64Text;
            this.end = $c0739623748fa589$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $c0739623748fa589$var$simpleWrite;
            this.end = $c0739623748fa589$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $c0739623748fa589$require$Buffer.allocUnsafe(nb);
}
$c0739623748fa589$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$c0739623748fa589$var$StringDecoder.prototype.end = $c0739623748fa589$var$utf8End;
// Returns only complete characters in a Buffer
$c0739623748fa589$var$StringDecoder.prototype.text = $c0739623748fa589$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$c0739623748fa589$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $c0739623748fa589$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $c0739623748fa589$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $c0739623748fa589$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $c0739623748fa589$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $c0739623748fa589$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $c0739623748fa589$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $c0739623748fa589$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $c0739623748fa589$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $c0739623748fa589$var$utf8Text(buf, i) {
    var total = $c0739623748fa589$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $c0739623748fa589$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $c0739623748fa589$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $c0739623748fa589$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $c0739623748fa589$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $c0739623748fa589$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $c0739623748fa589$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $c0739623748fa589$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("2OjVK", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");
'use strict';
var $20bfb60fd269ce6d$var$_Object$setPrototypeO;
function $20bfb60fd269ce6d$var$_defineProperty(obj, key, value) {
    key = $20bfb60fd269ce6d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20bfb60fd269ce6d$var$_toPropertyKey(arg) {
    var key = $20bfb60fd269ce6d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $20bfb60fd269ce6d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bugji = parcelRequire("bugji");
var $20bfb60fd269ce6d$var$kLastResolve = Symbol('lastResolve');
var $20bfb60fd269ce6d$var$kLastReject = Symbol('lastReject');
var $20bfb60fd269ce6d$var$kError = Symbol('error');
var $20bfb60fd269ce6d$var$kEnded = Symbol('ended');
var $20bfb60fd269ce6d$var$kLastPromise = Symbol('lastPromise');
var $20bfb60fd269ce6d$var$kHandlePromise = Symbol('handlePromise');
var $20bfb60fd269ce6d$var$kStream = Symbol('stream');
function $20bfb60fd269ce6d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $20bfb60fd269ce6d$var$readAndResolve(iter) {
    var resolve = iter[$20bfb60fd269ce6d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$20bfb60fd269ce6d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$20bfb60fd269ce6d$var$kLastPromise] = null;
            iter[$20bfb60fd269ce6d$var$kLastResolve] = null;
            iter[$20bfb60fd269ce6d$var$kLastReject] = null;
            resolve($20bfb60fd269ce6d$var$createIterResult(data, false));
        }
    }
}
function $20bfb60fd269ce6d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $1g1jb.nextTick($20bfb60fd269ce6d$var$readAndResolve, iter);
}
function $20bfb60fd269ce6d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$20bfb60fd269ce6d$var$kEnded]) {
                resolve($20bfb60fd269ce6d$var$createIterResult(undefined, true));
                return;
            }
            iter[$20bfb60fd269ce6d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $20bfb60fd269ce6d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $20bfb60fd269ce6d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($20bfb60fd269ce6d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$20bfb60fd269ce6d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$20bfb60fd269ce6d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$20bfb60fd269ce6d$var$kEnded]) return Promise.resolve($20bfb60fd269ce6d$var$createIterResult(undefined, true));
        if (this[$20bfb60fd269ce6d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $1g1jb.nextTick(function() {
                if (_this[$20bfb60fd269ce6d$var$kError]) reject(_this[$20bfb60fd269ce6d$var$kError]);
                else resolve($20bfb60fd269ce6d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$20bfb60fd269ce6d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($20bfb60fd269ce6d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$20bfb60fd269ce6d$var$kStream].read();
            if (data !== null) return Promise.resolve($20bfb60fd269ce6d$var$createIterResult(data, false));
            promise = new Promise(this[$20bfb60fd269ce6d$var$kHandlePromise]);
        }
        this[$20bfb60fd269ce6d$var$kLastPromise] = promise;
        return promise;
    }
}, $20bfb60fd269ce6d$var$_defineProperty($20bfb60fd269ce6d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $20bfb60fd269ce6d$var$_defineProperty($20bfb60fd269ce6d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$20bfb60fd269ce6d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($20bfb60fd269ce6d$var$createIterResult(undefined, true));
        });
    });
}), $20bfb60fd269ce6d$var$_Object$setPrototypeO), $20bfb60fd269ce6d$var$AsyncIteratorPrototype);
var $20bfb60fd269ce6d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($20bfb60fd269ce6d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $20bfb60fd269ce6d$var$_defineProperty(_Object$create, $20bfb60fd269ce6d$var$kStream, {
        value: stream,
        writable: true
    }), $20bfb60fd269ce6d$var$_defineProperty(_Object$create, $20bfb60fd269ce6d$var$kLastResolve, {
        value: null,
        writable: true
    }), $20bfb60fd269ce6d$var$_defineProperty(_Object$create, $20bfb60fd269ce6d$var$kLastReject, {
        value: null,
        writable: true
    }), $20bfb60fd269ce6d$var$_defineProperty(_Object$create, $20bfb60fd269ce6d$var$kError, {
        value: null,
        writable: true
    }), $20bfb60fd269ce6d$var$_defineProperty(_Object$create, $20bfb60fd269ce6d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $20bfb60fd269ce6d$var$_defineProperty(_Object$create, $20bfb60fd269ce6d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$20bfb60fd269ce6d$var$kStream].read();
            if (data) {
                iterator[$20bfb60fd269ce6d$var$kLastPromise] = null;
                iterator[$20bfb60fd269ce6d$var$kLastResolve] = null;
                iterator[$20bfb60fd269ce6d$var$kLastReject] = null;
                resolve($20bfb60fd269ce6d$var$createIterResult(data, false));
            } else {
                iterator[$20bfb60fd269ce6d$var$kLastResolve] = resolve;
                iterator[$20bfb60fd269ce6d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$20bfb60fd269ce6d$var$kLastPromise] = null;
    $bugji(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$20bfb60fd269ce6d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$20bfb60fd269ce6d$var$kLastPromise] = null;
                iterator[$20bfb60fd269ce6d$var$kLastResolve] = null;
                iterator[$20bfb60fd269ce6d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$20bfb60fd269ce6d$var$kError] = err;
            return;
        }
        var resolve = iterator[$20bfb60fd269ce6d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$20bfb60fd269ce6d$var$kLastPromise] = null;
            iterator[$20bfb60fd269ce6d$var$kLastResolve] = null;
            iterator[$20bfb60fd269ce6d$var$kLastReject] = null;
            resolve($20bfb60fd269ce6d$var$createIterResult(undefined, true));
        }
        iterator[$20bfb60fd269ce6d$var$kEnded] = true;
    });
    stream.on('readable', $20bfb60fd269ce6d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $20bfb60fd269ce6d$var$createReadableStreamAsyncIterator;

});
parcelRegister("bugji", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $85cf25e88fdefd30$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("77rHX")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $85cf25e88fdefd30$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $85cf25e88fdefd30$var$noop() {}
function $85cf25e88fdefd30$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $85cf25e88fdefd30$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $85cf25e88fdefd30$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $85cf25e88fdefd30$var$once(callback || $85cf25e88fdefd30$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $85cf25e88fdefd30$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $85cf25e88fdefd30$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($85cf25e88fdefd30$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $85cf25e88fdefd30$var$eos;

});


parcelRegister("5Td3P", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("gvMjh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $c05503f6eec448c4$var$Transform;

var $77rHX = parcelRequire("77rHX");
var $c05503f6eec448c4$require$_require$codes = $77rHX.codes;
var $c05503f6eec448c4$var$ERR_METHOD_NOT_IMPLEMENTED = $c05503f6eec448c4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c05503f6eec448c4$var$ERR_MULTIPLE_CALLBACK = $c05503f6eec448c4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $c05503f6eec448c4$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $c05503f6eec448c4$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $c05503f6eec448c4$var$ERR_TRANSFORM_WITH_LENGTH_0 = $c05503f6eec448c4$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $aHpQk = parcelRequire("aHpQk");

(parcelRequire("aAKqs"))($c05503f6eec448c4$var$Transform, $aHpQk);
function $c05503f6eec448c4$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $c05503f6eec448c4$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $c05503f6eec448c4$var$Transform(options) {
    if (!(this instanceof $c05503f6eec448c4$var$Transform)) return new $c05503f6eec448c4$var$Transform(options);
    $aHpQk.call(this, options);
    this._transformState = {
        afterTransform: $c05503f6eec448c4$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $c05503f6eec448c4$var$prefinish);
}
function $c05503f6eec448c4$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $c05503f6eec448c4$var$done(_this, er, data);
    });
    else $c05503f6eec448c4$var$done(this, null, null);
}
$c05503f6eec448c4$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $aHpQk.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$c05503f6eec448c4$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $c05503f6eec448c4$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$c05503f6eec448c4$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$c05503f6eec448c4$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$c05503f6eec448c4$var$Transform.prototype._destroy = function(err, cb) {
    $aHpQk.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $c05503f6eec448c4$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $c05503f6eec448c4$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $c05503f6eec448c4$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("1T7DK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $1600daa3986bb244$var$PassThrough;

var $gvMjh = parcelRequire("gvMjh");

(parcelRequire("aAKqs"))($1600daa3986bb244$var$PassThrough, $gvMjh);
function $1600daa3986bb244$var$PassThrough(options) {
    if (!(this instanceof $1600daa3986bb244$var$PassThrough)) return new $1600daa3986bb244$var$PassThrough(options);
    $gvMjh.call(this, options);
}
$1600daa3986bb244$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("lKM4x", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $04163eb17155611a$var$eos;
function $04163eb17155611a$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $77rHX = parcelRequire("77rHX");
var $04163eb17155611a$require$_require$codes = $77rHX.codes;
var $04163eb17155611a$var$ERR_MISSING_ARGS = $04163eb17155611a$require$_require$codes.ERR_MISSING_ARGS, $04163eb17155611a$var$ERR_STREAM_DESTROYED = $04163eb17155611a$require$_require$codes.ERR_STREAM_DESTROYED;
function $04163eb17155611a$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $04163eb17155611a$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $04163eb17155611a$var$destroyer(stream, reading, writing, callback) {
    callback = $04163eb17155611a$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($04163eb17155611a$var$eos === undefined) $04163eb17155611a$var$eos = (parcelRequire("bugji"));
    $04163eb17155611a$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($04163eb17155611a$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $04163eb17155611a$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $04163eb17155611a$var$call(fn) {
    fn();
}
function $04163eb17155611a$var$pipe(from, to) {
    return from.pipe(to);
}
function $04163eb17155611a$var$popCallback(streams) {
    if (!streams.length) return $04163eb17155611a$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $04163eb17155611a$var$noop;
    return streams.pop();
}
function $04163eb17155611a$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $04163eb17155611a$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $04163eb17155611a$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $04163eb17155611a$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($04163eb17155611a$var$call);
            if (reading) return;
            destroys.forEach($04163eb17155611a$var$call);
            callback(error);
        });
    });
    return streams.reduce($04163eb17155611a$var$pipe);
}
module.exports = $04163eb17155611a$var$pipeline;

});


parcelRegister("en6bb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1g1jb = parcelRequire("1g1jb");
var $a76801ca967ce713$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $a76801ca967ce713$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$a76801ca967ce713$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($a76801ca967ce713$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($a76801ca967ce713$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($a76801ca967ce713$var$isNull(x) || !$a76801ca967ce713$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $a76801ca967ce713$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($1g1jb.throwDeprecation) throw new Error(msg);
            else if ($1g1jb.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $a76801ca967ce713$var$debugs = {};
var $a76801ca967ce713$var$debugEnvRegex = /^$/;
var $a76801ca967ce713$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$a76801ca967ce713$var$debugs[set]) {
        if ($a76801ca967ce713$var$debugEnvRegex.test(set)) {
            var pid = $1g1jb.pid;
            $a76801ca967ce713$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $a76801ca967ce713$var$debugs[set] = function() {};
    }
    return $a76801ca967ce713$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $a76801ca967ce713$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $a76801ca967ce713$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($a76801ca967ce713$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($a76801ca967ce713$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($a76801ca967ce713$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($a76801ca967ce713$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($a76801ca967ce713$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $a76801ca967ce713$var$stylizeWithColor;
    return $a76801ca967ce713$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $a76801ca967ce713$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$a76801ca967ce713$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$a76801ca967ce713$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $a76801ca967ce713$var$stylizeWithColor(str, styleType) {
    var style = $a76801ca967ce713$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $a76801ca967ce713$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $a76801ca967ce713$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $a76801ca967ce713$var$stylizeNoColor(str, styleType) {
    return str;
}
function $a76801ca967ce713$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $a76801ca967ce713$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $a76801ca967ce713$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$a76801ca967ce713$var$isString(ret)) ret = $a76801ca967ce713$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $a76801ca967ce713$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $a76801ca967ce713$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($a76801ca967ce713$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $a76801ca967ce713$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($a76801ca967ce713$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($a76801ca967ce713$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($a76801ca967ce713$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($a76801ca967ce713$var$isError(value)) return $a76801ca967ce713$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($a76801ca967ce713$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($a76801ca967ce713$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($a76801ca967ce713$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($a76801ca967ce713$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($a76801ca967ce713$var$isError(value)) base = ' ' + $a76801ca967ce713$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($a76801ca967ce713$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $a76801ca967ce713$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $a76801ca967ce713$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $a76801ca967ce713$var$reduceToSingleString(output, base, braces);
}
function $a76801ca967ce713$var$formatPrimitive(ctx, value) {
    if ($a76801ca967ce713$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($a76801ca967ce713$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($a76801ca967ce713$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($a76801ca967ce713$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($a76801ca967ce713$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $a76801ca967ce713$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $a76801ca967ce713$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($a76801ca967ce713$var$hasOwnProperty(value, String(i))) output.push($a76801ca967ce713$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($a76801ca967ce713$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $a76801ca967ce713$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$a76801ca967ce713$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($a76801ca967ce713$var$isNull(recurseTimes)) str = $a76801ca967ce713$var$formatValue(ctx, desc.value, null);
            else str = $a76801ca967ce713$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($a76801ca967ce713$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $a76801ca967ce713$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("lyIfQ"));
function $a76801ca967ce713$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $a76801ca967ce713$var$isArray;
function $a76801ca967ce713$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $a76801ca967ce713$var$isBoolean;
function $a76801ca967ce713$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $a76801ca967ce713$var$isNull;
function $a76801ca967ce713$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $a76801ca967ce713$var$isNullOrUndefined;
function $a76801ca967ce713$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $a76801ca967ce713$var$isNumber;
function $a76801ca967ce713$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $a76801ca967ce713$var$isString;
function $a76801ca967ce713$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $a76801ca967ce713$var$isSymbol;
function $a76801ca967ce713$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $a76801ca967ce713$var$isUndefined;
function $a76801ca967ce713$var$isRegExp(re) {
    return $a76801ca967ce713$var$isObject(re) && $a76801ca967ce713$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $a76801ca967ce713$var$isRegExp;
module.exports.types.isRegExp = $a76801ca967ce713$var$isRegExp;
function $a76801ca967ce713$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $a76801ca967ce713$var$isObject;
function $a76801ca967ce713$var$isDate(d) {
    return $a76801ca967ce713$var$isObject(d) && $a76801ca967ce713$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $a76801ca967ce713$var$isDate;
module.exports.types.isDate = $a76801ca967ce713$var$isDate;
function $a76801ca967ce713$var$isError(e) {
    return $a76801ca967ce713$var$isObject(e) && ($a76801ca967ce713$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $a76801ca967ce713$var$isError;
module.exports.types.isNativeError = $a76801ca967ce713$var$isError;
function $a76801ca967ce713$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $a76801ca967ce713$var$isFunction;
function $a76801ca967ce713$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $a76801ca967ce713$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("6rnsG"));
function $a76801ca967ce713$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $a76801ca967ce713$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $a76801ca967ce713$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $a76801ca967ce713$var$timestamp() {
    var d = new Date();
    var time = [
        $a76801ca967ce713$var$pad(d.getHours()),
        $a76801ca967ce713$var$pad(d.getMinutes()),
        $a76801ca967ce713$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $a76801ca967ce713$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $a76801ca967ce713$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("aAKqs"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$a76801ca967ce713$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $a76801ca967ce713$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $a76801ca967ce713$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($a76801ca967ce713$var$kCustomPromisifiedSymbol && original[$a76801ca967ce713$var$kCustomPromisifiedSymbol]) {
        var fn = original[$a76801ca967ce713$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $a76801ca967ce713$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($a76801ca967ce713$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $a76801ca967ce713$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $a76801ca967ce713$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $a76801ca967ce713$var$kCustomPromisifiedSymbol;
function $a76801ca967ce713$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $a76801ca967ce713$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $1g1jb.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $1g1jb.nextTick($a76801ca967ce713$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $a76801ca967ce713$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $a76801ca967ce713$var$callbackify;

});
parcelRegister("lyIfQ", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $dc6rG = parcelRequire("dc6rG");

var $9bF3O = parcelRequire("9bF3O");

var $3UAGv = parcelRequire("3UAGv");

var $4LtyX = parcelRequire("4LtyX");
function $fb1f19fde9e7400a$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $fb1f19fde9e7400a$var$BigIntSupported = typeof BigInt !== 'undefined';
var $fb1f19fde9e7400a$var$SymbolSupported = typeof Symbol !== 'undefined';
var $fb1f19fde9e7400a$var$ObjectToString = $fb1f19fde9e7400a$var$uncurryThis(Object.prototype.toString);
var $fb1f19fde9e7400a$var$numberValue = $fb1f19fde9e7400a$var$uncurryThis(Number.prototype.valueOf);
var $fb1f19fde9e7400a$var$stringValue = $fb1f19fde9e7400a$var$uncurryThis(String.prototype.valueOf);
var $fb1f19fde9e7400a$var$booleanValue = $fb1f19fde9e7400a$var$uncurryThis(Boolean.prototype.valueOf);
if ($fb1f19fde9e7400a$var$BigIntSupported) var $fb1f19fde9e7400a$var$bigIntValue = $fb1f19fde9e7400a$var$uncurryThis(BigInt.prototype.valueOf);
if ($fb1f19fde9e7400a$var$SymbolSupported) var $fb1f19fde9e7400a$var$symbolValue = $fb1f19fde9e7400a$var$uncurryThis(Symbol.prototype.valueOf);
function $fb1f19fde9e7400a$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $dc6rG;
module.exports.isGeneratorFunction = $9bF3O;
module.exports.isTypedArray = $4LtyX;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $fb1f19fde9e7400a$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $fb1f19fde9e7400a$var$isPromise;
function $fb1f19fde9e7400a$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4LtyX(value) || $fb1f19fde9e7400a$var$isDataView(value);
}
module.exports.isArrayBufferView = $fb1f19fde9e7400a$var$isArrayBufferView;
function $fb1f19fde9e7400a$var$isUint8Array(value) {
    return $3UAGv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $fb1f19fde9e7400a$var$isUint8Array;
function $fb1f19fde9e7400a$var$isUint8ClampedArray(value) {
    return $3UAGv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $fb1f19fde9e7400a$var$isUint8ClampedArray;
function $fb1f19fde9e7400a$var$isUint16Array(value) {
    return $3UAGv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $fb1f19fde9e7400a$var$isUint16Array;
function $fb1f19fde9e7400a$var$isUint32Array(value) {
    return $3UAGv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $fb1f19fde9e7400a$var$isUint32Array;
function $fb1f19fde9e7400a$var$isInt8Array(value) {
    return $3UAGv(value) === 'Int8Array';
}
module.exports.isInt8Array = $fb1f19fde9e7400a$var$isInt8Array;
function $fb1f19fde9e7400a$var$isInt16Array(value) {
    return $3UAGv(value) === 'Int16Array';
}
module.exports.isInt16Array = $fb1f19fde9e7400a$var$isInt16Array;
function $fb1f19fde9e7400a$var$isInt32Array(value) {
    return $3UAGv(value) === 'Int32Array';
}
module.exports.isInt32Array = $fb1f19fde9e7400a$var$isInt32Array;
function $fb1f19fde9e7400a$var$isFloat32Array(value) {
    return $3UAGv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $fb1f19fde9e7400a$var$isFloat32Array;
function $fb1f19fde9e7400a$var$isFloat64Array(value) {
    return $3UAGv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $fb1f19fde9e7400a$var$isFloat64Array;
function $fb1f19fde9e7400a$var$isBigInt64Array(value) {
    return $3UAGv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $fb1f19fde9e7400a$var$isBigInt64Array;
function $fb1f19fde9e7400a$var$isBigUint64Array(value) {
    return $3UAGv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $fb1f19fde9e7400a$var$isBigUint64Array;
function $fb1f19fde9e7400a$var$isMapToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object Map]';
}
$fb1f19fde9e7400a$var$isMapToString.working = typeof Map !== 'undefined' && $fb1f19fde9e7400a$var$isMapToString(new Map());
function $fb1f19fde9e7400a$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $fb1f19fde9e7400a$var$isMapToString.working ? $fb1f19fde9e7400a$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $fb1f19fde9e7400a$var$isMap;
function $fb1f19fde9e7400a$var$isSetToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object Set]';
}
$fb1f19fde9e7400a$var$isSetToString.working = typeof Set !== 'undefined' && $fb1f19fde9e7400a$var$isSetToString(new Set());
function $fb1f19fde9e7400a$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $fb1f19fde9e7400a$var$isSetToString.working ? $fb1f19fde9e7400a$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $fb1f19fde9e7400a$var$isSet;
function $fb1f19fde9e7400a$var$isWeakMapToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object WeakMap]';
}
$fb1f19fde9e7400a$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $fb1f19fde9e7400a$var$isWeakMapToString(new WeakMap());
function $fb1f19fde9e7400a$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $fb1f19fde9e7400a$var$isWeakMapToString.working ? $fb1f19fde9e7400a$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $fb1f19fde9e7400a$var$isWeakMap;
function $fb1f19fde9e7400a$var$isWeakSetToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object WeakSet]';
}
$fb1f19fde9e7400a$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $fb1f19fde9e7400a$var$isWeakSetToString(new WeakSet());
function $fb1f19fde9e7400a$var$isWeakSet(value) {
    return $fb1f19fde9e7400a$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $fb1f19fde9e7400a$var$isWeakSet;
function $fb1f19fde9e7400a$var$isArrayBufferToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$fb1f19fde9e7400a$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $fb1f19fde9e7400a$var$isArrayBufferToString(new ArrayBuffer());
function $fb1f19fde9e7400a$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $fb1f19fde9e7400a$var$isArrayBufferToString.working ? $fb1f19fde9e7400a$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $fb1f19fde9e7400a$var$isArrayBuffer;
function $fb1f19fde9e7400a$var$isDataViewToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object DataView]';
}
$fb1f19fde9e7400a$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $fb1f19fde9e7400a$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $fb1f19fde9e7400a$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $fb1f19fde9e7400a$var$isDataViewToString.working ? $fb1f19fde9e7400a$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $fb1f19fde9e7400a$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $fb1f19fde9e7400a$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $fb1f19fde9e7400a$var$isSharedArrayBufferToString(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $fb1f19fde9e7400a$var$isSharedArrayBuffer(value) {
    if (typeof $fb1f19fde9e7400a$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $fb1f19fde9e7400a$var$isSharedArrayBufferToString.working === 'undefined') $fb1f19fde9e7400a$var$isSharedArrayBufferToString.working = $fb1f19fde9e7400a$var$isSharedArrayBufferToString(new $fb1f19fde9e7400a$var$SharedArrayBufferCopy());
    return $fb1f19fde9e7400a$var$isSharedArrayBufferToString.working ? $fb1f19fde9e7400a$var$isSharedArrayBufferToString(value) : value instanceof $fb1f19fde9e7400a$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $fb1f19fde9e7400a$var$isSharedArrayBuffer;
function $fb1f19fde9e7400a$var$isAsyncFunction(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $fb1f19fde9e7400a$var$isAsyncFunction;
function $fb1f19fde9e7400a$var$isMapIterator(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $fb1f19fde9e7400a$var$isMapIterator;
function $fb1f19fde9e7400a$var$isSetIterator(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $fb1f19fde9e7400a$var$isSetIterator;
function $fb1f19fde9e7400a$var$isGeneratorObject(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $fb1f19fde9e7400a$var$isGeneratorObject;
function $fb1f19fde9e7400a$var$isWebAssemblyCompiledModule(value) {
    return $fb1f19fde9e7400a$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $fb1f19fde9e7400a$var$isWebAssemblyCompiledModule;
function $fb1f19fde9e7400a$var$isNumberObject(value) {
    return $fb1f19fde9e7400a$var$checkBoxedPrimitive(value, $fb1f19fde9e7400a$var$numberValue);
}
module.exports.isNumberObject = $fb1f19fde9e7400a$var$isNumberObject;
function $fb1f19fde9e7400a$var$isStringObject(value) {
    return $fb1f19fde9e7400a$var$checkBoxedPrimitive(value, $fb1f19fde9e7400a$var$stringValue);
}
module.exports.isStringObject = $fb1f19fde9e7400a$var$isStringObject;
function $fb1f19fde9e7400a$var$isBooleanObject(value) {
    return $fb1f19fde9e7400a$var$checkBoxedPrimitive(value, $fb1f19fde9e7400a$var$booleanValue);
}
module.exports.isBooleanObject = $fb1f19fde9e7400a$var$isBooleanObject;
function $fb1f19fde9e7400a$var$isBigIntObject(value) {
    return $fb1f19fde9e7400a$var$BigIntSupported && $fb1f19fde9e7400a$var$checkBoxedPrimitive(value, $fb1f19fde9e7400a$var$bigIntValue);
}
module.exports.isBigIntObject = $fb1f19fde9e7400a$var$isBigIntObject;
function $fb1f19fde9e7400a$var$isSymbolObject(value) {
    return $fb1f19fde9e7400a$var$SymbolSupported && $fb1f19fde9e7400a$var$checkBoxedPrimitive(value, $fb1f19fde9e7400a$var$symbolValue);
}
module.exports.isSymbolObject = $fb1f19fde9e7400a$var$isSymbolObject;
function $fb1f19fde9e7400a$var$isBoxedPrimitive(value) {
    return $fb1f19fde9e7400a$var$isNumberObject(value) || $fb1f19fde9e7400a$var$isStringObject(value) || $fb1f19fde9e7400a$var$isBooleanObject(value) || $fb1f19fde9e7400a$var$isBigIntObject(value) || $fb1f19fde9e7400a$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $fb1f19fde9e7400a$var$isBoxedPrimitive;
function $fb1f19fde9e7400a$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($fb1f19fde9e7400a$var$isArrayBuffer(value) || $fb1f19fde9e7400a$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $fb1f19fde9e7400a$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("dc6rG", function(module, exports) {
'use strict';

var $99b1654eab776fa8$var$hasToStringTag = (parcelRequire("5EP00"))();

var $1szG5 = parcelRequire("1szG5");
var $99b1654eab776fa8$var$$toString = $1szG5('Object.prototype.toString');
/** @type {import('.')} */ var $99b1654eab776fa8$var$isStandardArguments = function isArguments(value) {
    if ($99b1654eab776fa8$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $99b1654eab776fa8$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $99b1654eab776fa8$var$isLegacyArguments = function isArguments(value) {
    if ($99b1654eab776fa8$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $99b1654eab776fa8$var$$toString(value) !== '[object Array]' && 'callee' in value && $99b1654eab776fa8$var$$toString(value.callee) === '[object Function]';
};
var $99b1654eab776fa8$var$supportsStandardArguments = function() {
    return $99b1654eab776fa8$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$99b1654eab776fa8$var$isStandardArguments.isLegacyArguments = $99b1654eab776fa8$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $99b1654eab776fa8$var$supportsStandardArguments ? $99b1654eab776fa8$var$isStandardArguments : $99b1654eab776fa8$var$isLegacyArguments;

});
parcelRegister("5EP00", function(module, exports) {
'use strict';

var $cxciU = parcelRequire("cxciU");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $cxciU() && !!Symbol.toStringTag;
};

});
parcelRegister("cxciU", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("1szG5", function(module, exports) {
'use strict';

var $hGNfs = parcelRequire("hGNfs");

var $a3MXc = parcelRequire("a3MXc");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $110414db6db33885$var$$indexOf = $a3MXc([
    $hGNfs('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $hGNfs(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $110414db6db33885$var$$indexOf(name, '.prototype.') > -1) return $a3MXc(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("hGNfs", function(module, exports) {
'use strict';
var $ce0c8f9678ab313e$var$undefined1;

var $4aBIR = parcelRequire("4aBIR");

var $8PxYm = parcelRequire("8PxYm");

var $7GQEw = parcelRequire("7GQEw");

var $cRJgU = parcelRequire("cRJgU");

var $5BqUO = parcelRequire("5BqUO");

var $lv30f = parcelRequire("lv30f");

var $3ihcq = parcelRequire("3ihcq");

var $8Fzev = parcelRequire("8Fzev");

var $lI6fH = parcelRequire("lI6fH");

var $53b9U = parcelRequire("53b9U");

var $kLF5P = parcelRequire("kLF5P");

var $age2k = parcelRequire("age2k");

var $lBWfG = parcelRequire("lBWfG");

var $59CU8 = parcelRequire("59CU8");

var $kyeKW = parcelRequire("kyeKW");

var $9DkKg = parcelRequire("9DkKg");

var $gR5fH = parcelRequire("gR5fH");
var $ce0c8f9678ab313e$var$throwTypeError = function() {
    throw new $3ihcq();
};
var $ce0c8f9678ab313e$var$ThrowTypeError = $9DkKg ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $ce0c8f9678ab313e$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $9DkKg(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $ce0c8f9678ab313e$var$throwTypeError;
        }
    }
}() : $ce0c8f9678ab313e$var$throwTypeError;

var $ce0c8f9678ab313e$var$hasSymbols = (parcelRequire("c25N1"))();

var $iwXio = parcelRequire("iwXio");

var $dk8jL = parcelRequire("dk8jL");

var $lrOHZ = parcelRequire("lrOHZ");

var $4ynCz = parcelRequire("4ynCz");

var $hzgir = parcelRequire("hzgir");
var $ce0c8f9678ab313e$var$needsEval = {};
var $ce0c8f9678ab313e$var$TypedArray = typeof Uint8Array === 'undefined' || !$iwXio ? undefined : $iwXio(Uint8Array);
var $ce0c8f9678ab313e$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $ce0c8f9678ab313e$var$hasSymbols && $iwXio ? $iwXio([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $ce0c8f9678ab313e$var$needsEval,
    '%AsyncGenerator%': $ce0c8f9678ab313e$var$needsEval,
    '%AsyncGeneratorFunction%': $ce0c8f9678ab313e$var$needsEval,
    '%AsyncIteratorPrototype%': $ce0c8f9678ab313e$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $8PxYm,
    '%eval%': eval,
    '%EvalError%': $7GQEw,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': Function,
    '%GeneratorFunction%': $ce0c8f9678ab313e$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $ce0c8f9678ab313e$var$hasSymbols && $iwXio ? $iwXio($iwXio([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$ce0c8f9678ab313e$var$hasSymbols || !$iwXio ? undefined : $iwXio(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $4aBIR,
    '%Object.getOwnPropertyDescriptor%': $9DkKg,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $cRJgU,
    '%ReferenceError%': $5BqUO,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$ce0c8f9678ab313e$var$hasSymbols || !$iwXio ? undefined : $iwXio(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $ce0c8f9678ab313e$var$hasSymbols && $iwXio ? $iwXio(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $ce0c8f9678ab313e$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $lv30f,
    '%ThrowTypeError%': $ce0c8f9678ab313e$var$ThrowTypeError,
    '%TypedArray%': $ce0c8f9678ab313e$var$TypedArray,
    '%TypeError%': $3ihcq,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $8Fzev,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $hzgir,
    '%Function.prototype.apply%': $4ynCz,
    '%Object.defineProperty%': $gR5fH,
    '%Object.getPrototypeOf%': $dk8jL,
    '%Math.abs%': $lI6fH,
    '%Math.floor%': $53b9U,
    '%Math.max%': $kLF5P,
    '%Math.min%': $age2k,
    '%Math.pow%': $lBWfG,
    '%Math.round%': $59CU8,
    '%Math.sign%': $kyeKW,
    '%Reflect.getPrototypeOf%': $lrOHZ
};
if ($iwXio) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $ce0c8f9678ab313e$var$errorProto = $iwXio($iwXio(e));
    $ce0c8f9678ab313e$var$INTRINSICS['%Error.prototype%'] = $ce0c8f9678ab313e$var$errorProto;
}

var $46Yhr = parcelRequire("46Yhr");

var $1Wbkm = parcelRequire("1Wbkm");

var $kRBJv = parcelRequire("kRBJv");
var $ce0c8f9678ab313e$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $46Yhr() || void 0;
    else if (name === '%GeneratorFunction%') value = $1Wbkm() || void 0;
    else if (name === '%AsyncGeneratorFunction%') value = $kRBJv() || void 0;
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $iwXio) value = $iwXio(gen.prototype);
    }
    $ce0c8f9678ab313e$var$INTRINSICS[name] = value;
    return value;
};
var $ce0c8f9678ab313e$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $fOrhD = parcelRequire("fOrhD");

var $aiMBQ = parcelRequire("aiMBQ");
var $ce0c8f9678ab313e$var$$concat = $fOrhD.call($hzgir, Array.prototype.concat);
var $ce0c8f9678ab313e$var$$spliceApply = $fOrhD.call($4ynCz, Array.prototype.splice);
var $ce0c8f9678ab313e$var$$replace = $fOrhD.call($hzgir, String.prototype.replace);
var $ce0c8f9678ab313e$var$$strSlice = $fOrhD.call($hzgir, String.prototype.slice);
var $ce0c8f9678ab313e$var$$exec = $fOrhD.call($hzgir, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $ce0c8f9678ab313e$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $ce0c8f9678ab313e$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $ce0c8f9678ab313e$var$stringToPath = function stringToPath(string) {
    var first = $ce0c8f9678ab313e$var$$strSlice(string, 0, 1);
    var last = $ce0c8f9678ab313e$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $lv30f('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $lv30f('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $ce0c8f9678ab313e$var$$replace(string, $ce0c8f9678ab313e$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $ce0c8f9678ab313e$var$$replace(subString, $ce0c8f9678ab313e$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $ce0c8f9678ab313e$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aiMBQ($ce0c8f9678ab313e$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $ce0c8f9678ab313e$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($aiMBQ($ce0c8f9678ab313e$var$INTRINSICS, intrinsicName)) {
        var value = $ce0c8f9678ab313e$var$INTRINSICS[intrinsicName];
        if (value === $ce0c8f9678ab313e$var$needsEval) value = $ce0c8f9678ab313e$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $3ihcq('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $lv30f('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $3ihcq('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $3ihcq('"allowMissing" argument must be a boolean');
    if ($ce0c8f9678ab313e$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $lv30f('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $ce0c8f9678ab313e$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $ce0c8f9678ab313e$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $ce0c8f9678ab313e$var$$spliceApply(parts, $ce0c8f9678ab313e$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $ce0c8f9678ab313e$var$$strSlice(part, 0, 1);
        var last = $ce0c8f9678ab313e$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $lv30f('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($aiMBQ($ce0c8f9678ab313e$var$INTRINSICS, intrinsicRealName)) value = $ce0c8f9678ab313e$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $3ihcq('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($9DkKg && i + 1 >= parts.length) {
                var desc = $9DkKg(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aiMBQ(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $ce0c8f9678ab313e$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("4aBIR", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("8PxYm", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("7GQEw", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("cRJgU", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("5BqUO", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("lv30f", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("3ihcq", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("8Fzev", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lI6fH", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("53b9U", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("kLF5P", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("age2k", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("lBWfG", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("59CU8", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("kyeKW", function(module, exports) {
'use strict';

var $jK86w = parcelRequire("jK86w");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jK86w(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jK86w", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("9DkKg", function(module, exports) {
'use strict';

var $fbJeg = parcelRequire("fbJeg");
var $7037d924a79a8c17$require$$gOPD = $fbJeg;
if ($7037d924a79a8c17$require$$gOPD) try {
    $7037d924a79a8c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $7037d924a79a8c17$require$$gOPD = null;
}
module.exports = $7037d924a79a8c17$require$$gOPD;

});
parcelRegister("fbJeg", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("gR5fH", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $c455ab90910b5d20$var$$defineProperty = Object.defineProperty || false;
if ($c455ab90910b5d20$var$$defineProperty) try {
    $c455ab90910b5d20$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $c455ab90910b5d20$var$$defineProperty = false;
}
module.exports = $c455ab90910b5d20$var$$defineProperty;

});

parcelRegister("c25N1", function(module, exports) {
'use strict';
var $8c2a29a38aae0e96$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $cxciU = parcelRequire("cxciU");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $8c2a29a38aae0e96$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $8c2a29a38aae0e96$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $cxciU();
};

});

parcelRegister("iwXio", function(module, exports) {
'use strict';

var $lrOHZ = parcelRequire("lrOHZ");

var $dk8jL = parcelRequire("dk8jL");

var $efxHo = parcelRequire("efxHo");
/** @type {import('.')} */ module.exports = $lrOHZ ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lrOHZ(O);
} : $dk8jL ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dk8jL(O);
} : $efxHo ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $efxHo(O);
} : null;

});
parcelRegister("lrOHZ", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("dk8jL", function(module, exports) {
'use strict';

var $4aBIR = parcelRequire("4aBIR");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $4aBIR.getPrototypeOf || null;

});

parcelRegister("efxHo", function(module, exports) {
'use strict';

var $a3MXc = parcelRequire("a3MXc");

var $9DkKg = parcelRequire("9DkKg");
var $a5fc9b514ebf714a$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $a5fc9b514ebf714a$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $a5fc9b514ebf714a$var$desc = !!$a5fc9b514ebf714a$var$hasProtoAccessor && $9DkKg && $9DkKg(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $a5fc9b514ebf714a$var$$Object = Object;
var $a5fc9b514ebf714a$var$$getPrototypeOf = $a5fc9b514ebf714a$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $a5fc9b514ebf714a$var$desc && typeof $a5fc9b514ebf714a$var$desc.get === 'function' ? $a3MXc([
    $a5fc9b514ebf714a$var$desc.get
]) : typeof $a5fc9b514ebf714a$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $a5fc9b514ebf714a$var$$getPrototypeOf(value == null ? value : $a5fc9b514ebf714a$var$$Object(value));
} : false;

});
parcelRegister("a3MXc", function(module, exports) {
'use strict';

var $fOrhD = parcelRequire("fOrhD");

var $3ihcq = parcelRequire("3ihcq");

var $hzgir = parcelRequire("hzgir");

var $lWOGh = parcelRequire("lWOGh");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $3ihcq('a function is required');
    return $lWOGh($fOrhD, $hzgir, args);
};

});
parcelRegister("fOrhD", function(module, exports) {
'use strict';

var $4dp9i = parcelRequire("4dp9i");
module.exports = Function.prototype.bind || $4dp9i;

});
parcelRegister("4dp9i", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $311be25f4a531994$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $311be25f4a531994$var$toStr = Object.prototype.toString;
var $311be25f4a531994$var$max = Math.max;
var $311be25f4a531994$var$funcType = '[object Function]';
var $311be25f4a531994$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $311be25f4a531994$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $311be25f4a531994$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $311be25f4a531994$var$toStr.apply(target) !== $311be25f4a531994$var$funcType) throw new TypeError($311be25f4a531994$var$ERROR_MESSAGE + target);
    var args = $311be25f4a531994$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $311be25f4a531994$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $311be25f4a531994$var$concatty(args, arguments));
    };
    var boundLength = $311be25f4a531994$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $311be25f4a531994$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("hzgir", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("lWOGh", function(module, exports) {
'use strict';

var $fOrhD = parcelRequire("fOrhD");

var $4ynCz = parcelRequire("4ynCz");

var $hzgir = parcelRequire("hzgir");

var $iLDRh = parcelRequire("iLDRh");
/** @type {import('./actualApply')} */ module.exports = $iLDRh || $fOrhD.call($hzgir, $4ynCz);

});
parcelRegister("4ynCz", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("iLDRh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("46Yhr", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $2fe67b60d37852cd$var$cached = /** @type {import('.').AsyncFunctionConstructor} */ (async function() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$2fe67b60d37852cd$var$cached;

});

parcelRegister("1Wbkm", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $1693fea2853e5e7a$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$1693fea2853e5e7a$var$cached;

});

parcelRegister("kRBJv", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $f30606df1fb4a2d1$var$cached = /** @type {import('.').AsyncGeneratorFunctionConstructor} */ (async function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$f30606df1fb4a2d1$var$cached;

});

parcelRegister("aiMBQ", function(module, exports) {
'use strict';
var $78014aa897477de5$var$call = Function.prototype.call;
var $78014aa897477de5$var$$hasOwn = Object.prototype.hasOwnProperty;

var $fOrhD = parcelRequire("fOrhD");
/** @type {import('.')} */ module.exports = $fOrhD.call($78014aa897477de5$var$call, $78014aa897477de5$var$$hasOwn);

});




parcelRegister("9bF3O", function(module, exports) {
'use strict';

var $1szG5 = parcelRequire("1szG5");

var $iTdGO = parcelRequire("iTdGO");
var $6b04fde74c704f0f$var$isFnRegex = $iTdGO(/^\s*(?:function)?\*/);

var $6b04fde74c704f0f$var$hasToStringTag = (parcelRequire("5EP00"))();

var $iwXio = parcelRequire("iwXio");
var $6b04fde74c704f0f$var$toStr = $1szG5('Object.prototype.toString');
var $6b04fde74c704f0f$var$fnToStr = $1szG5('Function.prototype.toString');

var $1Wbkm = parcelRequire("1Wbkm");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($6b04fde74c704f0f$var$isFnRegex($6b04fde74c704f0f$var$fnToStr(fn))) return true;
    if (!$6b04fde74c704f0f$var$hasToStringTag) {
        var str = $6b04fde74c704f0f$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$iwXio) return false;
    var GeneratorFunction = $1Wbkm();
    return GeneratorFunction && $iwXio(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("iTdGO", function(module, exports) {
'use strict';

var $1szG5 = parcelRequire("1szG5");

var $5gKil = parcelRequire("5gKil");
var $dc07fb7e3f1872bd$var$$exec = $1szG5('RegExp.prototype.exec');

var $3ihcq = parcelRequire("3ihcq");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$5gKil(regex)) throw new $3ihcq('`regex` must be a RegExp');
    return function test(s) {
        return $dc07fb7e3f1872bd$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("5gKil", function(module, exports) {
'use strict';

var $1szG5 = parcelRequire("1szG5");

var $3d625b956174b7e5$var$hasToStringTag = (parcelRequire("5EP00"))();

var $aiMBQ = parcelRequire("aiMBQ");

var $9DkKg = parcelRequire("9DkKg");
/** @type {import('.')} */ var $3d625b956174b7e5$var$fn;
if ($3d625b956174b7e5$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $3d625b956174b7e5$var$$exec = $1szG5('RegExp.prototype.exec');
    /** @type {object} */ var $3d625b956174b7e5$var$isRegexMarker = {};
    var $3d625b956174b7e5$var$throwRegexMarker = function() {
        throw $3d625b956174b7e5$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $3d625b956174b7e5$var$badStringifier = {
        toString: $3d625b956174b7e5$var$throwRegexMarker,
        valueOf: $3d625b956174b7e5$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $3d625b956174b7e5$var$badStringifier[Symbol.toPrimitive] = $3d625b956174b7e5$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $3d625b956174b7e5$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $9DkKg(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $aiMBQ(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $3d625b956174b7e5$var$$exec(value, /** @type {unknown} */ $3d625b956174b7e5$var$badStringifier);
        } catch (e) {
            return e === $3d625b956174b7e5$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $3d625b956174b7e5$var$$toString = $1szG5('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $3d625b956174b7e5$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $3d625b956174b7e5$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $3d625b956174b7e5$var$$toString(value) === $3d625b956174b7e5$var$regexClass;
    };
}
module.exports = $3d625b956174b7e5$var$fn;

});



parcelRegister("3UAGv", function(module, exports) {
'use strict';

var $7cFRg = parcelRequire("7cFRg");

var $iLrnN = parcelRequire("iLrnN");

var $k8FlT = parcelRequire("k8FlT");

var $1szG5 = parcelRequire("1szG5");

var $9DkKg = parcelRequire("9DkKg");

var $iwXio = parcelRequire("iwXio");
var $2d930ed4e9b96b7a$var$$toString = $1szG5('Object.prototype.toString');

var $2d930ed4e9b96b7a$var$hasToStringTag = (parcelRequire("5EP00"))();
var $2d930ed4e9b96b7a$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $2d930ed4e9b96b7a$var$typedArrays = $iLrnN();
var $2d930ed4e9b96b7a$var$$slice = $1szG5('String.prototype.slice');
/** @import { BoundSet, BoundSlice, Cache, Getter } from './types' */ /** @import { TypedArrayName } from '.' */ /** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $2d930ed4e9b96b7a$var$$indexOf = $1szG5('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @type {Cache} */ var $2d930ed4e9b96b7a$var$cache = {
    __proto__: null
};
if ($2d930ed4e9b96b7a$var$hasToStringTag && $9DkKg && $iwXio) $7cFRg($2d930ed4e9b96b7a$var$typedArrays, function(typedArray) {
    var arr = new $2d930ed4e9b96b7a$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $iwXio) {
        var proto = $iwXio(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $9DkKg(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $iwXio(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $9DkKg(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $k8FlT(descriptor.get);
            $2d930ed4e9b96b7a$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $7cFRg($2d930ed4e9b96b7a$var$typedArrays, function(typedArray) {
    var arr = new $2d930ed4e9b96b7a$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {BoundSlice | BoundSet} */ // @ts-expect-error TODO FIXME
        $k8FlT(fn);
        $2d930ed4e9b96b7a$var$cache[/** @type {`$${TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | TypedArrayName} */ function $2d930ed4e9b96b7a$var$tryTypedArrays(value) {
    /** @type {ReturnType<typeof tryTypedArrays>} */ var found = false;
    $7cFRg(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $2d930ed4e9b96b7a$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} typedArray */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {TypedArrayName} */ $2d930ed4e9b96b7a$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(value: object) => false | TypedArrayName} */ function $2d930ed4e9b96b7a$var$trySlices(value) {
    /** @type {ReturnType<typeof trySlices>} */ var found = false;
    $7cFRg(/** @type {Record<`$${TypedArrayName}`, Getter>} */ $2d930ed4e9b96b7a$var$cache, /** @param {Getter} getter @param {`$${TypedArrayName}`} name */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {TypedArrayName} */ $2d930ed4e9b96b7a$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
}
/** @type {(tag: unknown) => tag is typeof typedArrays[number]} */ function $2d930ed4e9b96b7a$var$isTATag(tag) {
    return $2d930ed4e9b96b7a$var$$indexOf($2d930ed4e9b96b7a$var$typedArrays, tag) > -1;
}
/**
 * @type {import('.')}
 * @param {unknown} value
 */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$2d930ed4e9b96b7a$var$hasToStringTag) {
        var tag = $2d930ed4e9b96b7a$var$$slice($2d930ed4e9b96b7a$var$$toString(value), 8, -1);
        if ($2d930ed4e9b96b7a$var$isTATag(tag)) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $2d930ed4e9b96b7a$var$trySlices(value);
    }
    if (!$9DkKg) return null;
     // unknown engine
    return $2d930ed4e9b96b7a$var$tryTypedArrays(value);
};

});
parcelRegister("7cFRg", function(module, exports) {
'use strict';

var $a56Gr = parcelRequire("a56Gr");
var $53ea1f896a1ed694$var$toStr = Object.prototype.toString;
var $53ea1f896a1ed694$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $53ea1f896a1ed694$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($53ea1f896a1ed694$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $53ea1f896a1ed694$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $53ea1f896a1ed694$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($53ea1f896a1ed694$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $53ea1f896a1ed694$var$isArray(x) {
    return $53ea1f896a1ed694$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$a56Gr(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($53ea1f896a1ed694$var$isArray(list)) $53ea1f896a1ed694$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $53ea1f896a1ed694$var$forEachString(list, iterator, receiver);
    else $53ea1f896a1ed694$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("a56Gr", function(module, exports) {
'use strict';
var $756f8e3bb9871dc3$var$fnToStr = Function.prototype.toString;
var $756f8e3bb9871dc3$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $756f8e3bb9871dc3$var$badArrayLike;
var $756f8e3bb9871dc3$var$isCallableMarker;
if (typeof $756f8e3bb9871dc3$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $756f8e3bb9871dc3$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $756f8e3bb9871dc3$var$isCallableMarker;
        }
    });
    $756f8e3bb9871dc3$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $756f8e3bb9871dc3$var$reflectApply(function() {
        throw 42;
    }, null, $756f8e3bb9871dc3$var$badArrayLike);
} catch (_) {
    if (_ !== $756f8e3bb9871dc3$var$isCallableMarker) $756f8e3bb9871dc3$var$reflectApply = null;
}
else $756f8e3bb9871dc3$var$reflectApply = null;
var $756f8e3bb9871dc3$var$constructorRegex = /^\s*class\b/;
var $756f8e3bb9871dc3$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $756f8e3bb9871dc3$var$fnToStr.call(value);
        return $756f8e3bb9871dc3$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $756f8e3bb9871dc3$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($756f8e3bb9871dc3$var$isES6ClassFn(value)) return false;
        $756f8e3bb9871dc3$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $756f8e3bb9871dc3$var$toStr = Object.prototype.toString;
var $756f8e3bb9871dc3$var$objectClass = '[object Object]';
var $756f8e3bb9871dc3$var$fnClass = '[object Function]';
var $756f8e3bb9871dc3$var$genClass = '[object GeneratorFunction]';
var $756f8e3bb9871dc3$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $756f8e3bb9871dc3$var$ddaClass2 = '[object HTML document.all class]';
var $756f8e3bb9871dc3$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $756f8e3bb9871dc3$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $756f8e3bb9871dc3$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $756f8e3bb9871dc3$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $756f8e3bb9871dc3$var$all = document.all;
    if ($756f8e3bb9871dc3$var$toStr.call($756f8e3bb9871dc3$var$all) === $756f8e3bb9871dc3$var$toStr.call(document.all)) $756f8e3bb9871dc3$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($756f8e3bb9871dc3$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $756f8e3bb9871dc3$var$toStr.call(value);
            return (str === $756f8e3bb9871dc3$var$ddaClass || str === $756f8e3bb9871dc3$var$ddaClass2 || str === $756f8e3bb9871dc3$var$ddaClass3 // opera 12.16
             || str === $756f8e3bb9871dc3$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $756f8e3bb9871dc3$var$reflectApply ? function isCallable(value) {
    if ($756f8e3bb9871dc3$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $756f8e3bb9871dc3$var$reflectApply(value, null, $756f8e3bb9871dc3$var$badArrayLike);
    } catch (e) {
        if (e !== $756f8e3bb9871dc3$var$isCallableMarker) return false;
    }
    return !$756f8e3bb9871dc3$var$isES6ClassFn(value) && $756f8e3bb9871dc3$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($756f8e3bb9871dc3$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($756f8e3bb9871dc3$var$hasToStringTag) return $756f8e3bb9871dc3$var$tryFunctionObject(value);
    if ($756f8e3bb9871dc3$var$isES6ClassFn(value)) return false;
    var strClass = $756f8e3bb9871dc3$var$toStr.call(value);
    if (strClass !== $756f8e3bb9871dc3$var$fnClass && strClass !== $756f8e3bb9871dc3$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $756f8e3bb9871dc3$var$tryFunctionObject(value);
};

});


parcelRegister("iLrnN", function(module, exports) {
'use strict';

var $hIdam = parcelRequire("hIdam");
var $da91db739df2a791$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $hIdam.length; i++)if (typeof $da91db739df2a791$var$g[$hIdam[i]] === 'function') // @ts-expect-error
    out[out.length] = $hIdam[i];
    return out;
};

});
parcelRegister("hIdam", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("k8FlT", function(module, exports) {
'use strict';

var $fU2ZR = parcelRequire("fU2ZR");

var $gR5fH = parcelRequire("gR5fH");

var $a3MXc = parcelRequire("a3MXc");

var $WYcKg = parcelRequire("WYcKg");
module.exports = function callBind(originalFunction) {
    var func = $a3MXc(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $fU2ZR(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($gR5fH) $gR5fH(module.exports, 'apply', {
    value: $WYcKg
});
else module.exports.apply = $WYcKg;

});
parcelRegister("fU2ZR", function(module, exports) {
'use strict';

var $hGNfs = parcelRequire("hGNfs");

var $g8hkB = parcelRequire("g8hkB");

var $b93e69165891a408$var$hasDescriptors = (parcelRequire("cCaVv"))();

var $9DkKg = parcelRequire("9DkKg");

var $3ihcq = parcelRequire("3ihcq");
var $b93e69165891a408$var$$floor = $hGNfs('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $3ihcq('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $b93e69165891a408$var$$floor(length) !== length) throw new $3ihcq('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $9DkKg) {
        var desc = $9DkKg(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b93e69165891a408$var$hasDescriptors) $g8hkB(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $g8hkB(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("g8hkB", function(module, exports) {
'use strict';

var $gR5fH = parcelRequire("gR5fH");

var $lv30f = parcelRequire("lv30f");

var $3ihcq = parcelRequire("3ihcq");

var $9DkKg = parcelRequire("9DkKg");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $3ihcq('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $3ihcq('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $3ihcq('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $3ihcq('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $3ihcq('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $3ihcq('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$9DkKg && $9DkKg(obj, property);
    if ($gR5fH) $gR5fH(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $lv30f('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("cCaVv", function(module, exports) {
'use strict';

var $gR5fH = parcelRequire("gR5fH");
var $92f18272d270372d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$gR5fH;
};
$92f18272d270372d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$gR5fH) return null;
    try {
        return $gR5fH([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $92f18272d270372d$var$hasPropertyDescriptors;

});


parcelRegister("WYcKg", function(module, exports) {
'use strict';

var $fOrhD = parcelRequire("fOrhD");

var $4ynCz = parcelRequire("4ynCz");

var $lWOGh = parcelRequire("lWOGh");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $lWOGh($fOrhD, $4ynCz, arguments);
};

});



parcelRegister("4LtyX", function(module, exports) {
'use strict';

var $3UAGv = parcelRequire("3UAGv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3UAGv(value);
};

});


parcelRegister("6rnsG", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("bOSsC", function(module, exports) {

var $h9jRt = parcelRequire("h9jRt");
var $89ae9bfbaecd6a90$require$Buffer = $h9jRt.Buffer;

var $lRcAu = parcelRequire("lRcAu");

var $2RUWx = parcelRequire("2RUWx");

var $en6bb = parcelRequire("en6bb");
var $89ae9bfbaecd6a90$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $89ae9bfbaecd6a90$var$MSG_INVALID_SECRET = 'secret must be a string or buffer';
var $89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var $89ae9bfbaecd6a90$var$MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
var $89ae9bfbaecd6a90$var$supportsKeyObjects = typeof $lRcAu.createPublicKey === 'function';
if ($89ae9bfbaecd6a90$var$supportsKeyObjects) {
    $89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
    $89ae9bfbaecd6a90$var$MSG_INVALID_SECRET += 'or a KeyObject';
}
function $89ae9bfbaecd6a90$var$checkIsPublicKey(key) {
    if ($89ae9bfbaecd6a90$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (!$89ae9bfbaecd6a90$var$supportsKeyObjects) throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== 'object') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== 'string') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== 'string') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== 'function') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_VERIFIER_KEY);
}
function $89ae9bfbaecd6a90$var$checkIsPrivateKey(key) {
    if ($89ae9bfbaecd6a90$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (typeof key === 'object') return;
    throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_SIGNER_KEY);
}
function $89ae9bfbaecd6a90$var$checkIsSecretKey(key) {
    if ($89ae9bfbaecd6a90$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return key;
    if (!$89ae9bfbaecd6a90$var$supportsKeyObjects) throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_SECRET);
    if (typeof key !== 'object') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_SECRET);
    if (key.type !== 'secret') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_SECRET);
    if (typeof key.export !== 'function') throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_SECRET);
}
function $89ae9bfbaecd6a90$var$fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $89ae9bfbaecd6a90$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += '=';
    return base64url.replace(/\-/g, '+').replace(/_/g, '/');
}
function $89ae9bfbaecd6a90$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $en6bb.format.bind($en6bb, template).apply(null, args);
    return new TypeError(errMsg);
}
function $89ae9bfbaecd6a90$var$bufferOrString(obj) {
    return $89ae9bfbaecd6a90$require$Buffer.isBuffer(obj) || typeof obj === 'string';
}
function $89ae9bfbaecd6a90$var$normalizeInput(thing) {
    if (!$89ae9bfbaecd6a90$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $89ae9bfbaecd6a90$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $89ae9bfbaecd6a90$var$checkIsSecretKey(secret);
        thing = $89ae9bfbaecd6a90$var$normalizeInput(thing);
        var hmac = $lRcAu.createHmac('sha' + bits, secret);
        var sig = (hmac.update(thing), hmac.digest('base64'));
        return $89ae9bfbaecd6a90$var$fromBase64(sig);
    };
}
var $89ae9bfbaecd6a90$var$bufferEqual;

var $89ae9bfbaecd6a90$var$timingSafeEqual = 'timingSafeEqual' in $lRcAu ? function timingSafeEqual(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $lRcAu.timingSafeEqual(a, b);
} : function timingSafeEqual(a, b) {
    if (!$89ae9bfbaecd6a90$var$bufferEqual) $89ae9bfbaecd6a90$var$bufferEqual = (parcelRequire("2Nmqw"));
    return $89ae9bfbaecd6a90$var$bufferEqual(a, b);
};
function $89ae9bfbaecd6a90$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $89ae9bfbaecd6a90$var$createHmacSigner(bits)(thing, secret);
        return $89ae9bfbaecd6a90$var$timingSafeEqual($89ae9bfbaecd6a90$require$Buffer.from(signature), $89ae9bfbaecd6a90$require$Buffer.from(computedSig));
    };
}
function $89ae9bfbaecd6a90$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $89ae9bfbaecd6a90$var$checkIsPrivateKey(privateKey);
        thing = $89ae9bfbaecd6a90$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $lRcAu.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
        return $89ae9bfbaecd6a90$var$fromBase64(sig);
    };
}
function $89ae9bfbaecd6a90$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $89ae9bfbaecd6a90$var$checkIsPublicKey(publicKey);
        thing = $89ae9bfbaecd6a90$var$normalizeInput(thing);
        signature = $89ae9bfbaecd6a90$var$toBase64(signature);
        var verifier = $lRcAu.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, 'base64');
    };
}
function $89ae9bfbaecd6a90$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $89ae9bfbaecd6a90$var$checkIsPrivateKey(privateKey);
        thing = $89ae9bfbaecd6a90$var$normalizeInput(thing);
        var signer = $lRcAu.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $lRcAu.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $lRcAu.constants.RSA_PSS_SALTLEN_DIGEST
        }, 'base64'));
        return $89ae9bfbaecd6a90$var$fromBase64(sig);
    };
}
function $89ae9bfbaecd6a90$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $89ae9bfbaecd6a90$var$checkIsPublicKey(publicKey);
        thing = $89ae9bfbaecd6a90$var$normalizeInput(thing);
        signature = $89ae9bfbaecd6a90$var$toBase64(signature);
        var verifier = $lRcAu.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $lRcAu.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $lRcAu.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, 'base64');
    };
}
function $89ae9bfbaecd6a90$var$createECDSASigner(bits) {
    var inner = $89ae9bfbaecd6a90$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $2RUWx.derToJose(signature, 'ES' + bits);
        return signature;
    };
}
function $89ae9bfbaecd6a90$var$createECDSAVerifer(bits) {
    var inner = $89ae9bfbaecd6a90$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $2RUWx.joseToDer(signature, 'ES' + bits).toString('base64');
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $89ae9bfbaecd6a90$var$createNoneSigner() {
    return function sign() {
        return '';
    };
}
function $89ae9bfbaecd6a90$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === '';
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $89ae9bfbaecd6a90$var$createHmacSigner,
        rs: $89ae9bfbaecd6a90$var$createKeySigner,
        ps: $89ae9bfbaecd6a90$var$createPSSKeySigner,
        es: $89ae9bfbaecd6a90$var$createECDSASigner,
        none: $89ae9bfbaecd6a90$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $89ae9bfbaecd6a90$var$createHmacVerifier,
        rs: $89ae9bfbaecd6a90$var$createKeyVerifier,
        ps: $89ae9bfbaecd6a90$var$createPSSKeyVerifier,
        es: $89ae9bfbaecd6a90$var$createECDSAVerifer,
        none: $89ae9bfbaecd6a90$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/);
    if (!match) throw $89ae9bfbaecd6a90$var$typeError($89ae9bfbaecd6a90$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("lRcAu", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $fe984fd52eb5f8cd$export$5f828d93ff035aa8, (v) => $fe984fd52eb5f8cd$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $fe984fd52eb5f8cd$export$cd94982b18c6332c, (v) => $fe984fd52eb5f8cd$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $fe984fd52eb5f8cd$export$1d518568e4f529b0, (v) => $fe984fd52eb5f8cd$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $fe984fd52eb5f8cd$export$5285b6d41c912b41, (v) => $fe984fd52eb5f8cd$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $fe984fd52eb5f8cd$export$2fb37efbf6ae0c0e, (v) => $fe984fd52eb5f8cd$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $fe984fd52eb5f8cd$export$ab85ecd77ce6a5cd, (v) => $fe984fd52eb5f8cd$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $fe984fd52eb5f8cd$export$da39cf97e1eb7c91, (v) => $fe984fd52eb5f8cd$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $fe984fd52eb5f8cd$export$52a9039d7177394f, (v) => $fe984fd52eb5f8cd$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $fe984fd52eb5f8cd$export$f7201db400317331, (v) => $fe984fd52eb5f8cd$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $fe984fd52eb5f8cd$export$448fa22aedc9dbca, (v) => $fe984fd52eb5f8cd$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe984fd52eb5f8cd$export$b80c7ba289c8fa56, (v) => $fe984fd52eb5f8cd$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $fe984fd52eb5f8cd$export$26e5786e8ac8e530, (v) => $fe984fd52eb5f8cd$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $fe984fd52eb5f8cd$export$bdd223f16383713e, (v) => $fe984fd52eb5f8cd$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $fe984fd52eb5f8cd$export$20533d26f07f1ee0, (v) => $fe984fd52eb5f8cd$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $fe984fd52eb5f8cd$export$2f64596b8cbf08b4, (v) => $fe984fd52eb5f8cd$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $fe984fd52eb5f8cd$export$2ce6d8d0e8b04e1a, (v) => $fe984fd52eb5f8cd$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $fe984fd52eb5f8cd$export$12ada9414fbc594c, (v) => $fe984fd52eb5f8cd$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $fe984fd52eb5f8cd$export$f5e7e39d57cd9700, (v) => $fe984fd52eb5f8cd$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $fe984fd52eb5f8cd$export$36b6d6ef312eab39, (v) => $fe984fd52eb5f8cd$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $fe984fd52eb5f8cd$export$58a258485f1e49f6, (v) => $fe984fd52eb5f8cd$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $fe984fd52eb5f8cd$export$dedd8dc3dc62b370, (v) => $fe984fd52eb5f8cd$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $fe984fd52eb5f8cd$export$971862a2fcb1bb40, (v) => $fe984fd52eb5f8cd$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $fe984fd52eb5f8cd$export$c6ff6a88acbeaf40, (v) => $fe984fd52eb5f8cd$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $fe984fd52eb5f8cd$export$fdc27893e98845cc, (v) => $fe984fd52eb5f8cd$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $fe984fd52eb5f8cd$export$6671fb9a1323bed, (v) => $fe984fd52eb5f8cd$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $fe984fd52eb5f8cd$export$d74daf141a551db, (v) => $fe984fd52eb5f8cd$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $fe984fd52eb5f8cd$export$45df7cae684751af, (v) => $fe984fd52eb5f8cd$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $fe984fd52eb5f8cd$export$1db683ad541682f6, (v) => $fe984fd52eb5f8cd$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $fe984fd52eb5f8cd$export$6f65485f87568e37, (v) => $fe984fd52eb5f8cd$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $fe984fd52eb5f8cd$export$91a8e56769aeb334, (v) => $fe984fd52eb5f8cd$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $fe984fd52eb5f8cd$export$2d4117e99c2179e4, (v) => $fe984fd52eb5f8cd$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $fe984fd52eb5f8cd$export$512823e338ddb1b7, (v) => $fe984fd52eb5f8cd$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $fe984fd52eb5f8cd$export$9d0e0c0c4a8d30f3, (v) => $fe984fd52eb5f8cd$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $fe984fd52eb5f8cd$export$b9d55ff329113abd, (v) => $fe984fd52eb5f8cd$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $fe984fd52eb5f8cd$export$7efb24e2fddf99b9, (v) => $fe984fd52eb5f8cd$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $fe984fd52eb5f8cd$export$bb1abf2ce84fc7e8, (v) => $fe984fd52eb5f8cd$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $fe984fd52eb5f8cd$export$2f7171e78e524d5e, (v) => $fe984fd52eb5f8cd$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $fe984fd52eb5f8cd$export$e1d879b482f37d98, (v) => $fe984fd52eb5f8cd$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $fe984fd52eb5f8cd$export$1a988e7317c65621, (v) => $fe984fd52eb5f8cd$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $fe984fd52eb5f8cd$export$5f828d93ff035aa8;
var $fe984fd52eb5f8cd$export$cd94982b18c6332c;
var $fe984fd52eb5f8cd$export$1d518568e4f529b0;
var $fe984fd52eb5f8cd$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $fe984fd52eb5f8cd$export$2fb37efbf6ae0c0e;
var $fe984fd52eb5f8cd$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $fe984fd52eb5f8cd$export$da39cf97e1eb7c91;
var $fe984fd52eb5f8cd$export$52a9039d7177394f;
var $fe984fd52eb5f8cd$export$f7201db400317331;
var $fe984fd52eb5f8cd$export$448fa22aedc9dbca;
var $fe984fd52eb5f8cd$export$b80c7ba289c8fa56;
var $fe984fd52eb5f8cd$export$26e5786e8ac8e530;
var $fe984fd52eb5f8cd$export$bdd223f16383713e;
var $fe984fd52eb5f8cd$export$20533d26f07f1ee0;
var $fe984fd52eb5f8cd$export$2f64596b8cbf08b4;
var $fe984fd52eb5f8cd$export$2ce6d8d0e8b04e1a;
var $fe984fd52eb5f8cd$export$12ada9414fbc594c;
var $fe984fd52eb5f8cd$export$f5e7e39d57cd9700;
var $fe984fd52eb5f8cd$export$36b6d6ef312eab39;
var $fe984fd52eb5f8cd$export$58a258485f1e49f6;
var $fe984fd52eb5f8cd$export$dedd8dc3dc62b370;
var $fe984fd52eb5f8cd$export$971862a2fcb1bb40;
var $fe984fd52eb5f8cd$export$c6ff6a88acbeaf40;
var $fe984fd52eb5f8cd$export$fdc27893e98845cc;
var $fe984fd52eb5f8cd$export$6671fb9a1323bed;
var $fe984fd52eb5f8cd$export$d74daf141a551db;
var $fe984fd52eb5f8cd$export$45df7cae684751af;
var $fe984fd52eb5f8cd$export$1db683ad541682f6;
var $fe984fd52eb5f8cd$export$6f65485f87568e37;
var $fe984fd52eb5f8cd$export$91a8e56769aeb334;
var $fe984fd52eb5f8cd$export$2d4117e99c2179e4;
var $fe984fd52eb5f8cd$export$512823e338ddb1b7;
var $fe984fd52eb5f8cd$export$9d0e0c0c4a8d30f3;
var $fe984fd52eb5f8cd$export$b9d55ff329113abd;
var $fe984fd52eb5f8cd$export$7efb24e2fddf99b9;
var $fe984fd52eb5f8cd$export$bb1abf2ce84fc7e8;
var $fe984fd52eb5f8cd$export$2f7171e78e524d5e;
var $fe984fd52eb5f8cd$export$e1d879b482f37d98;
var $fe984fd52eb5f8cd$export$1a988e7317c65621;
'use strict';

$fe984fd52eb5f8cd$export$5f828d93ff035aa8 = $fe984fd52eb5f8cd$export$cd94982b18c6332c = $fe984fd52eb5f8cd$export$1d518568e4f529b0 = $fe984fd52eb5f8cd$export$5285b6d41c912b41 = (parcelRequire("dURpS"));

$fe984fd52eb5f8cd$export$2fb37efbf6ae0c0e = $fe984fd52eb5f8cd$export$ab85ecd77ce6a5cd = (parcelRequire("fsXMV"));

$fe984fd52eb5f8cd$export$da39cf97e1eb7c91 = $fe984fd52eb5f8cd$export$52a9039d7177394f = (parcelRequire("fRs08"));

var $6ego3 = parcelRequire("6ego3");
var $fe984fd52eb5f8cd$var$algoKeys = Object.keys($6ego3);
var $fe984fd52eb5f8cd$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($fe984fd52eb5f8cd$var$algoKeys);
$fe984fd52eb5f8cd$export$f7201db400317331 = function() {
    return $fe984fd52eb5f8cd$var$hashes;
};

var $aAf6x = parcelRequire("aAf6x");
$fe984fd52eb5f8cd$export$448fa22aedc9dbca = $aAf6x.pbkdf2;
$fe984fd52eb5f8cd$export$b80c7ba289c8fa56 = $aAf6x.pbkdf2Sync;

var $kcq7Q = parcelRequire("kcq7Q");
$fe984fd52eb5f8cd$export$26e5786e8ac8e530 = $kcq7Q.Cipher;
$fe984fd52eb5f8cd$export$bdd223f16383713e = $kcq7Q.createCipher;
$fe984fd52eb5f8cd$export$20533d26f07f1ee0 = $kcq7Q.Cipheriv;
$fe984fd52eb5f8cd$export$2f64596b8cbf08b4 = $kcq7Q.createCipheriv;
$fe984fd52eb5f8cd$export$2ce6d8d0e8b04e1a = $kcq7Q.Decipher;
$fe984fd52eb5f8cd$export$12ada9414fbc594c = $kcq7Q.createDecipher;
$fe984fd52eb5f8cd$export$f5e7e39d57cd9700 = $kcq7Q.Decipheriv;
$fe984fd52eb5f8cd$export$36b6d6ef312eab39 = $kcq7Q.createDecipheriv;
$fe984fd52eb5f8cd$export$58a258485f1e49f6 = $kcq7Q.getCiphers;
$fe984fd52eb5f8cd$export$dedd8dc3dc62b370 = $kcq7Q.listCiphers;

var $mDhOn = parcelRequire("mDhOn");
$fe984fd52eb5f8cd$export$971862a2fcb1bb40 = $mDhOn.DiffieHellmanGroup;
$fe984fd52eb5f8cd$export$c6ff6a88acbeaf40 = $mDhOn.createDiffieHellmanGroup;
$fe984fd52eb5f8cd$export$fdc27893e98845cc = $mDhOn.getDiffieHellman;
$fe984fd52eb5f8cd$export$6671fb9a1323bed = $mDhOn.createDiffieHellman;
$fe984fd52eb5f8cd$export$d74daf141a551db = $mDhOn.DiffieHellman;

var $fv3p0 = parcelRequire("fv3p0");
$fe984fd52eb5f8cd$export$45df7cae684751af = $fv3p0.createSign;
$fe984fd52eb5f8cd$export$1db683ad541682f6 = $fv3p0.Sign;
$fe984fd52eb5f8cd$export$6f65485f87568e37 = $fv3p0.createVerify;
$fe984fd52eb5f8cd$export$91a8e56769aeb334 = $fv3p0.Verify;

$fe984fd52eb5f8cd$export$2d4117e99c2179e4 = (parcelRequire("5SLVS"));

var $3pyBJ = parcelRequire("3pyBJ");
$fe984fd52eb5f8cd$export$512823e338ddb1b7 = $3pyBJ.publicEncrypt;
$fe984fd52eb5f8cd$export$9d0e0c0c4a8d30f3 = $3pyBJ.privateEncrypt;
$fe984fd52eb5f8cd$export$b9d55ff329113abd = $3pyBJ.publicDecrypt;
$fe984fd52eb5f8cd$export$7efb24e2fddf99b9 = $3pyBJ.privateDecrypt;

var $1SYIx = parcelRequire("1SYIx");
$fe984fd52eb5f8cd$export$bb1abf2ce84fc7e8 = $1SYIx.randomFill;
$fe984fd52eb5f8cd$export$2f7171e78e524d5e = $1SYIx.randomFillSync;
$fe984fd52eb5f8cd$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$fe984fd52eb5f8cd$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("dURpS", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $a219f0b1bbc89759$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $a219f0b1bbc89759$var$MAX_UINT32 = 4294967295;
function $a219f0b1bbc89759$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $h9jRt = parcelRequire("h9jRt");
var $a219f0b1bbc89759$require$Buffer = $h9jRt.Buffer;
var $a219f0b1bbc89759$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($a219f0b1bbc89759$var$crypto && $a219f0b1bbc89759$var$crypto.getRandomValues) module.exports = $a219f0b1bbc89759$var$randomBytes;
else module.exports = $a219f0b1bbc89759$var$oldBrowser;
function $a219f0b1bbc89759$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $a219f0b1bbc89759$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $a219f0b1bbc89759$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $a219f0b1bbc89759$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $a219f0b1bbc89759$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $a219f0b1bbc89759$var$crypto.getRandomValues(bytes.slice(generated, generated + $a219f0b1bbc89759$var$MAX_BYTES));
        else $a219f0b1bbc89759$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $1g1jb.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("fsXMV", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $ix9Mi = parcelRequire("ix9Mi");

var $6Ymfg = parcelRequire("6Ymfg");

var $418D0 = parcelRequire("418D0");

var $dXkiA = parcelRequire("dXkiA");
function $b427d93a4ad99caf$var$Hash(hash) {
    $dXkiA.call(this, 'digest');
    this._hash = hash;
}
$aAKqs($b427d93a4ad99caf$var$Hash, $dXkiA);
$b427d93a4ad99caf$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$b427d93a4ad99caf$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $ix9Mi();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $6Ymfg();
    return new $b427d93a4ad99caf$var$Hash($418D0(alg));
};

});
parcelRegister("ix9Mi", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $5V3ah = parcelRequire("5V3ah");

var $h9jRt = parcelRequire("h9jRt");
var $d7e2e4c138759bbf$require$Buffer = $h9jRt.Buffer;
var $d7e2e4c138759bbf$var$ARRAY16 = new Array(16);
function $d7e2e4c138759bbf$var$MD5() {
    $5V3ah.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$aAKqs($d7e2e4c138759bbf$var$MD5, $5V3ah);
$d7e2e4c138759bbf$var$MD5.prototype._update = function() {
    var M = $d7e2e4c138759bbf$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $d7e2e4c138759bbf$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $d7e2e4c138759bbf$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $d7e2e4c138759bbf$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $d7e2e4c138759bbf$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $d7e2e4c138759bbf$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $d7e2e4c138759bbf$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $d7e2e4c138759bbf$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $d7e2e4c138759bbf$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $d7e2e4c138759bbf$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $d7e2e4c138759bbf$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $d7e2e4c138759bbf$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $d7e2e4c138759bbf$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $d7e2e4c138759bbf$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $d7e2e4c138759bbf$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $d7e2e4c138759bbf$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $d7e2e4c138759bbf$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $d7e2e4c138759bbf$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $d7e2e4c138759bbf$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $d7e2e4c138759bbf$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $d7e2e4c138759bbf$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $d7e2e4c138759bbf$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $d7e2e4c138759bbf$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $d7e2e4c138759bbf$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $d7e2e4c138759bbf$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $d7e2e4c138759bbf$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $d7e2e4c138759bbf$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $d7e2e4c138759bbf$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $d7e2e4c138759bbf$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $d7e2e4c138759bbf$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $d7e2e4c138759bbf$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $d7e2e4c138759bbf$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $d7e2e4c138759bbf$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $d7e2e4c138759bbf$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $d7e2e4c138759bbf$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $d7e2e4c138759bbf$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $d7e2e4c138759bbf$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $d7e2e4c138759bbf$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $d7e2e4c138759bbf$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $d7e2e4c138759bbf$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $d7e2e4c138759bbf$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $d7e2e4c138759bbf$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $d7e2e4c138759bbf$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $d7e2e4c138759bbf$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $d7e2e4c138759bbf$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $d7e2e4c138759bbf$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $d7e2e4c138759bbf$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $d7e2e4c138759bbf$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $d7e2e4c138759bbf$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $d7e2e4c138759bbf$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $d7e2e4c138759bbf$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $d7e2e4c138759bbf$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $d7e2e4c138759bbf$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $d7e2e4c138759bbf$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $d7e2e4c138759bbf$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $d7e2e4c138759bbf$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $d7e2e4c138759bbf$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $d7e2e4c138759bbf$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $d7e2e4c138759bbf$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $d7e2e4c138759bbf$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $d7e2e4c138759bbf$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $d7e2e4c138759bbf$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $d7e2e4c138759bbf$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $d7e2e4c138759bbf$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $d7e2e4c138759bbf$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$d7e2e4c138759bbf$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $d7e2e4c138759bbf$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $d7e2e4c138759bbf$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $d7e2e4c138759bbf$var$fnF(a, b, c, d, m, k, s) {
    return $d7e2e4c138759bbf$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $d7e2e4c138759bbf$var$fnG(a, b, c, d, m, k, s) {
    return $d7e2e4c138759bbf$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $d7e2e4c138759bbf$var$fnH(a, b, c, d, m, k, s) {
    return $d7e2e4c138759bbf$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $d7e2e4c138759bbf$var$fnI(a, b, c, d, m, k, s) {
    return $d7e2e4c138759bbf$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $d7e2e4c138759bbf$var$MD5;

});
parcelRegister("5V3ah", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $44f4bb10f3df53b9$require$Buffer = $h9jRt.Buffer;

var $7Tngd = parcelRequire("7Tngd");

var $ku6az = parcelRequire("ku6az");
var $44f4bb10f3df53b9$require$Transform = $ku6az.Transform;

var $aAKqs = parcelRequire("aAKqs");
function $44f4bb10f3df53b9$var$HashBase(blockSize) {
    $44f4bb10f3df53b9$require$Transform.call(this);
    this._block = $44f4bb10f3df53b9$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$aAKqs($44f4bb10f3df53b9$var$HashBase, $44f4bb10f3df53b9$require$Transform);
$44f4bb10f3df53b9$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$44f4bb10f3df53b9$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$44f4bb10f3df53b9$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $7Tngd(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$44f4bb10f3df53b9$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$44f4bb10f3df53b9$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$44f4bb10f3df53b9$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $44f4bb10f3df53b9$var$HashBase;

});
parcelRegister("7Tngd", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $5befb680debe4424$require$Buffer = $h9jRt.Buffer;

var $4nTqM = parcelRequire("4nTqM");
var $5befb680debe4424$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $5befb680debe4424$var$useArrayBuffer = $5befb680debe4424$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $5befb680debe4424$var$isView = $5befb680debe4424$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $5befb680debe4424$require$Buffer.isBuffer(thing) || $5befb680debe4424$var$useUint8Array && thing instanceof Uint8Array || $5befb680debe4424$var$isView && $5befb680debe4424$var$isView(thing)) return $4nTqM(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("4nTqM", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $33144ed1986270cd$require$Buffer = $h9jRt.Buffer;

var $4dDD4 = parcelRequire("4dDD4");

var $aP8oS = parcelRequire("aP8oS");
var $33144ed1986270cd$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $aP8oS(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $33144ed1986270cd$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $33144ed1986270cd$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $33144ed1986270cd$var$useFromArrayBuffer = $33144ed1986270cd$var$useArrayBuffer && ($33144ed1986270cd$require$Buffer.prototype instanceof Uint8Array || $33144ed1986270cd$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($33144ed1986270cd$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $33144ed1986270cd$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $33144ed1986270cd$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($33144ed1986270cd$var$useArrayBuffer && $33144ed1986270cd$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $33144ed1986270cd$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($33144ed1986270cd$var$useFromArrayBuffer) {
            var res = $33144ed1986270cd$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $33144ed1986270cd$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($33144ed1986270cd$var$useUint8Array && data instanceof Uint8Array) return $33144ed1986270cd$require$Buffer.from(data);
    var isArr = $4dDD4(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $33144ed1986270cd$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $33144ed1986270cd$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("4dDD4", function(module, exports) {
var $31271ddb4467cd34$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $31271ddb4467cd34$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("aP8oS", function(module, exports) {
'use strict';

var $3ihcq = parcelRequire("3ihcq");

var $1szG5 = parcelRequire("1szG5");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7e152ee7d3f71c98$var$$typedArrayBuffer = $1szG5('TypedArray.prototype.buffer', true);

var $4LtyX = parcelRequire("4LtyX");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7e152ee7d3f71c98$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$4LtyX(x)) throw new $3ihcq('Not a Typed Array');
    return x.buffer;
};

});



parcelRegister("ku6az", function(module, exports) {

exports = module.exports = (parcelRequire("jCj7j"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("ffkn8"));

exports.Duplex = (parcelRequire("eK6SV"));

exports.Transform = (parcelRequire("8ezhs"));

exports.PassThrough = (parcelRequire("kPzjF"));

});
parcelRegister("jCj7j", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1g1jb = parcelRequire("1g1jb");
'use strict';

var $k86Vd = parcelRequire("k86Vd");
/*</replacement>*/ module.exports = $e4806527631fec39$var$Readable;

var $8cEmQ = parcelRequire("8cEmQ");
/*</replacement>*/ /*<replacement>*/ var $e4806527631fec39$var$Duplex;
/*</replacement>*/ $e4806527631fec39$var$Readable.ReadableState = $e4806527631fec39$var$ReadableState;

var $6UvgR = parcelRequire("6UvgR");
var $e4806527631fec39$require$EE = $6UvgR.EventEmitter;
var $e4806527631fec39$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $kn46R = parcelRequire("kn46R");

var $961E7 = parcelRequire("961E7");
var $e4806527631fec39$require$Buffer = $961E7.Buffer;
var $e4806527631fec39$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $e4806527631fec39$var$_uint8ArrayToBuffer(chunk) {
    return $e4806527631fec39$require$Buffer.from(chunk);
}
function $e4806527631fec39$var$_isUint8Array(obj) {
    return $e4806527631fec39$require$Buffer.isBuffer(obj) || obj instanceof $e4806527631fec39$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $e4806527631fec39$var$util = Object.create((parcelRequire("cLTx3")));

$e4806527631fec39$var$util.inherits = (parcelRequire("aAKqs"));

var $f8f1G = parcelRequire("f8f1G");
var $e4806527631fec39$var$debug = void 0;
if ($f8f1G && $f8f1G.debuglog) $e4806527631fec39$var$debug = $f8f1G.debuglog('stream');
else $e4806527631fec39$var$debug = function() {};

var $jt3tT = parcelRequire("jt3tT");

var $fsBtr = parcelRequire("fsBtr");
var $e4806527631fec39$var$StringDecoder;
$e4806527631fec39$var$util.inherits($e4806527631fec39$var$Readable, $kn46R);
var $e4806527631fec39$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $e4806527631fec39$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($8cEmQ(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $e4806527631fec39$var$ReadableState(options, stream) {
    $e4806527631fec39$var$Duplex = $e4806527631fec39$var$Duplex || (parcelRequire("eK6SV"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $e4806527631fec39$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jt3tT();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$e4806527631fec39$var$StringDecoder) $e4806527631fec39$var$StringDecoder = (parcelRequire("KfonS")).StringDecoder;
        this.decoder = new $e4806527631fec39$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $e4806527631fec39$var$Readable(options) {
    $e4806527631fec39$var$Duplex = $e4806527631fec39$var$Duplex || (parcelRequire("eK6SV"));
    if (!(this instanceof $e4806527631fec39$var$Readable)) return new $e4806527631fec39$var$Readable(options);
    this._readableState = new $e4806527631fec39$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $kn46R.call(this);
}
Object.defineProperty($e4806527631fec39$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$e4806527631fec39$var$Readable.prototype.destroy = $fsBtr.destroy;
$e4806527631fec39$var$Readable.prototype._undestroy = $fsBtr.undestroy;
$e4806527631fec39$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$e4806527631fec39$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $e4806527631fec39$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $e4806527631fec39$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$e4806527631fec39$var$Readable.prototype.unshift = function(chunk) {
    return $e4806527631fec39$var$readableAddChunk(this, chunk, null, true, false);
};
function $e4806527631fec39$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $e4806527631fec39$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $e4806527631fec39$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $e4806527631fec39$require$Buffer.prototype) chunk = $e4806527631fec39$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $e4806527631fec39$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $e4806527631fec39$var$addChunk(stream, state, chunk, false);
                    else $e4806527631fec39$var$maybeReadMore(stream, state);
                } else $e4806527631fec39$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $e4806527631fec39$var$needMoreData(state);
}
function $e4806527631fec39$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $e4806527631fec39$var$emitReadable(stream);
    }
    $e4806527631fec39$var$maybeReadMore(stream, state);
}
function $e4806527631fec39$var$chunkInvalid(state, chunk) {
    var er;
    if (!$e4806527631fec39$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $e4806527631fec39$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$e4806527631fec39$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$e4806527631fec39$var$Readable.prototype.setEncoding = function(enc) {
    if (!$e4806527631fec39$var$StringDecoder) $e4806527631fec39$var$StringDecoder = (parcelRequire("KfonS")).StringDecoder;
    this._readableState.decoder = new $e4806527631fec39$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $e4806527631fec39$var$MAX_HWM = 0x800000;
function $e4806527631fec39$var$computeNewHighWaterMark(n) {
    if (n >= $e4806527631fec39$var$MAX_HWM) n = $e4806527631fec39$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e4806527631fec39$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $e4806527631fec39$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$e4806527631fec39$var$Readable.prototype.read = function(n) {
    $e4806527631fec39$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $e4806527631fec39$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $e4806527631fec39$var$endReadable(this);
        else $e4806527631fec39$var$emitReadable(this);
        return null;
    }
    n = $e4806527631fec39$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $e4806527631fec39$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $e4806527631fec39$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $e4806527631fec39$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $e4806527631fec39$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $e4806527631fec39$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $e4806527631fec39$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $e4806527631fec39$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $e4806527631fec39$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $e4806527631fec39$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $e4806527631fec39$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $e4806527631fec39$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $e4806527631fec39$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $k86Vd.nextTick($e4806527631fec39$var$emitReadable_, stream);
        else $e4806527631fec39$var$emitReadable_(stream);
    }
}
function $e4806527631fec39$var$emitReadable_(stream) {
    $e4806527631fec39$var$debug('emit readable');
    stream.emit('readable');
    $e4806527631fec39$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $e4806527631fec39$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $k86Vd.nextTick($e4806527631fec39$var$maybeReadMore_, stream, state);
    }
}
function $e4806527631fec39$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $e4806527631fec39$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$e4806527631fec39$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$e4806527631fec39$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $e4806527631fec39$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $1g1jb.stdout && dest !== $1g1jb.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $k86Vd.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $e4806527631fec39$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $e4806527631fec39$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $e4806527631fec39$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $e4806527631fec39$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $e4806527631fec39$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $e4806527631fec39$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $e4806527631fec39$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $e4806527631fec39$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($e4806527631fec39$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $e4806527631fec39$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $e4806527631fec39$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $e4806527631fec39$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $e4806527631fec39$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $e4806527631fec39$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $e4806527631fec39$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $e4806527631fec39$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $e4806527631fec39$var$flow(src);
        }
    };
}
$e4806527631fec39$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $e4806527631fec39$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$e4806527631fec39$var$Readable.prototype.on = function(ev, fn) {
    var res = $kn46R.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $k86Vd.nextTick($e4806527631fec39$var$nReadingNextTick, this);
            else if (state.length) $e4806527631fec39$var$emitReadable(this);
        }
    }
    return res;
};
$e4806527631fec39$var$Readable.prototype.addListener = $e4806527631fec39$var$Readable.prototype.on;
function $e4806527631fec39$var$nReadingNextTick(self1) {
    $e4806527631fec39$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$e4806527631fec39$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $e4806527631fec39$var$debug('resume');
        state.flowing = true;
        $e4806527631fec39$var$resume(this, state);
    }
    return this;
};
function $e4806527631fec39$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $k86Vd.nextTick($e4806527631fec39$var$resume_, stream, state);
    }
}
function $e4806527631fec39$var$resume_(stream, state) {
    if (!state.reading) {
        $e4806527631fec39$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $e4806527631fec39$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$e4806527631fec39$var$Readable.prototype.pause = function() {
    $e4806527631fec39$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $e4806527631fec39$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $e4806527631fec39$var$flow(stream) {
    var state = stream._readableState;
    $e4806527631fec39$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$e4806527631fec39$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $e4806527631fec39$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $e4806527631fec39$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $e4806527631fec39$var$kProxyEvents.length; n++)stream.on($e4806527631fec39$var$kProxyEvents[n], this.emit.bind(this, $e4806527631fec39$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $e4806527631fec39$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($e4806527631fec39$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$e4806527631fec39$var$Readable._fromList = $e4806527631fec39$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e4806527631fec39$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $e4806527631fec39$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e4806527631fec39$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $e4806527631fec39$var$copyFromBufferString(n, list) : $e4806527631fec39$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e4806527631fec39$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $e4806527631fec39$var$copyFromBuffer(n, list) {
    var ret = $e4806527631fec39$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $e4806527631fec39$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $k86Vd.nextTick($e4806527631fec39$var$endReadableNT, state, stream);
    }
}
function $e4806527631fec39$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $e4806527631fec39$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("k86Vd", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");
'use strict';
module.exports = {
    nextTick: $ea79ec8ea1ced2bb$var$nextTick
};
function $ea79ec8ea1ced2bb$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $1g1jb.nextTick(fn);
        case 2:
            return $1g1jb.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $1g1jb.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $1g1jb.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $1g1jb.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("8cEmQ", function(module, exports) {
var $5f8ec1d8088133f5$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $5f8ec1d8088133f5$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("kn46R", function(module, exports) {

module.exports = (parcelRequire("6UvgR")).EventEmitter;

});

parcelRegister("961E7", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $dOfWq = parcelRequire("dOfWq");
var $69f5f376923e36a5$var$Buffer = $dOfWq.Buffer;
// alternative to using Object.keys for old browsers
function $69f5f376923e36a5$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($69f5f376923e36a5$var$Buffer.from && $69f5f376923e36a5$var$Buffer.alloc && $69f5f376923e36a5$var$Buffer.allocUnsafe && $69f5f376923e36a5$var$Buffer.allocUnsafeSlow) module.exports = $dOfWq;
else {
    // Copy properties from require('buffer')
    $69f5f376923e36a5$var$copyProps($dOfWq, module.exports);
    module.exports.Buffer = $69f5f376923e36a5$var$SafeBuffer;
}
function $69f5f376923e36a5$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $69f5f376923e36a5$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$69f5f376923e36a5$var$copyProps($69f5f376923e36a5$var$Buffer, $69f5f376923e36a5$var$SafeBuffer);
$69f5f376923e36a5$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $69f5f376923e36a5$var$Buffer(arg, encodingOrOffset, length);
};
$69f5f376923e36a5$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $69f5f376923e36a5$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$69f5f376923e36a5$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $69f5f376923e36a5$var$Buffer(size);
};
$69f5f376923e36a5$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $dOfWq.SlowBuffer(size);
};

});

parcelRegister("cLTx3", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $94c4f35a1323d308$export$43bee75e5e14138e, (v) => $94c4f35a1323d308$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $94c4f35a1323d308$export$f9ce7b637dfbe238, (v) => $94c4f35a1323d308$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $94c4f35a1323d308$export$630801d484da15df, (v) => $94c4f35a1323d308$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $94c4f35a1323d308$export$bedb7023a7733221, (v) => $94c4f35a1323d308$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $94c4f35a1323d308$export$7e4aa119212bc614, (v) => $94c4f35a1323d308$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $94c4f35a1323d308$export$844ec244b1367d54, (v) => $94c4f35a1323d308$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $94c4f35a1323d308$export$a244864fd9645c7f, (v) => $94c4f35a1323d308$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $94c4f35a1323d308$export$fce6876652108ab, (v) => $94c4f35a1323d308$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $94c4f35a1323d308$export$49841c62b9eff15, (v) => $94c4f35a1323d308$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $94c4f35a1323d308$export$a6cdc56e425d0d0a, (v) => $94c4f35a1323d308$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $94c4f35a1323d308$export$871608497c498473, (v) => $94c4f35a1323d308$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $94c4f35a1323d308$export$e6127cc7fe7395c3, (v) => $94c4f35a1323d308$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $94c4f35a1323d308$export$f6e2535fb5126e54, (v) => $94c4f35a1323d308$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $94c4f35a1323d308$export$c3825b437cbdea5c, (v) => $94c4f35a1323d308$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $94c4f35a1323d308$export$a7884ebc965f8f54, (v) => $94c4f35a1323d308$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $94c4f35a1323d308$export$43bee75e5e14138e;
var $94c4f35a1323d308$export$f9ce7b637dfbe238;
var $94c4f35a1323d308$export$630801d484da15df;
var $94c4f35a1323d308$export$bedb7023a7733221;
var $94c4f35a1323d308$export$7e4aa119212bc614;
var $94c4f35a1323d308$export$844ec244b1367d54;
var $94c4f35a1323d308$export$a244864fd9645c7f;
var $94c4f35a1323d308$export$fce6876652108ab;
var $94c4f35a1323d308$export$49841c62b9eff15;
var $94c4f35a1323d308$export$a6cdc56e425d0d0a;
var $94c4f35a1323d308$export$871608497c498473;
var $94c4f35a1323d308$export$e6127cc7fe7395c3;
var $94c4f35a1323d308$export$f6e2535fb5126e54;
var $94c4f35a1323d308$export$c3825b437cbdea5c;
var $94c4f35a1323d308$export$a7884ebc965f8f54;
function $94c4f35a1323d308$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $94c4f35a1323d308$var$objectToString(arg) === '[object Array]';
}
$94c4f35a1323d308$export$43bee75e5e14138e = $94c4f35a1323d308$var$isArray;
function $94c4f35a1323d308$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$94c4f35a1323d308$export$f9ce7b637dfbe238 = $94c4f35a1323d308$var$isBoolean;
function $94c4f35a1323d308$var$isNull(arg) {
    return arg === null;
}
$94c4f35a1323d308$export$630801d484da15df = $94c4f35a1323d308$var$isNull;
function $94c4f35a1323d308$var$isNullOrUndefined(arg) {
    return arg == null;
}
$94c4f35a1323d308$export$bedb7023a7733221 = $94c4f35a1323d308$var$isNullOrUndefined;
function $94c4f35a1323d308$var$isNumber(arg) {
    return typeof arg === 'number';
}
$94c4f35a1323d308$export$7e4aa119212bc614 = $94c4f35a1323d308$var$isNumber;
function $94c4f35a1323d308$var$isString(arg) {
    return typeof arg === 'string';
}
$94c4f35a1323d308$export$844ec244b1367d54 = $94c4f35a1323d308$var$isString;
function $94c4f35a1323d308$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$94c4f35a1323d308$export$a244864fd9645c7f = $94c4f35a1323d308$var$isSymbol;
function $94c4f35a1323d308$var$isUndefined(arg) {
    return arg === void 0;
}
$94c4f35a1323d308$export$fce6876652108ab = $94c4f35a1323d308$var$isUndefined;
function $94c4f35a1323d308$var$isRegExp(re) {
    return $94c4f35a1323d308$var$objectToString(re) === '[object RegExp]';
}
$94c4f35a1323d308$export$49841c62b9eff15 = $94c4f35a1323d308$var$isRegExp;
function $94c4f35a1323d308$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$94c4f35a1323d308$export$a6cdc56e425d0d0a = $94c4f35a1323d308$var$isObject;
function $94c4f35a1323d308$var$isDate(d) {
    return $94c4f35a1323d308$var$objectToString(d) === '[object Date]';
}
$94c4f35a1323d308$export$871608497c498473 = $94c4f35a1323d308$var$isDate;
function $94c4f35a1323d308$var$isError(e) {
    return $94c4f35a1323d308$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$94c4f35a1323d308$export$e6127cc7fe7395c3 = $94c4f35a1323d308$var$isError;
function $94c4f35a1323d308$var$isFunction(arg) {
    return typeof arg === 'function';
}
$94c4f35a1323d308$export$f6e2535fb5126e54 = $94c4f35a1323d308$var$isFunction;
function $94c4f35a1323d308$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$94c4f35a1323d308$export$c3825b437cbdea5c = $94c4f35a1323d308$var$isPrimitive;

$94c4f35a1323d308$export$a7884ebc965f8f54 = (parcelRequire("dOfWq")).Buffer.isBuffer;
function $94c4f35a1323d308$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("jt3tT", function(module, exports) {
'use strict';
function $e2c36d0eaa556221$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $961E7 = parcelRequire("961E7");
var $e2c36d0eaa556221$require$Buffer = $961E7.Buffer;

var $f8f1G = parcelRequire("f8f1G");
function $e2c36d0eaa556221$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $e2c36d0eaa556221$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $e2c36d0eaa556221$require$Buffer.alloc(0);
        var ret = $e2c36d0eaa556221$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $e2c36d0eaa556221$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($f8f1G && $f8f1G.inspect && $f8f1G.inspect.custom) module.exports.prototype[$f8f1G.inspect.custom] = function() {
    var obj = $f8f1G.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fsBtr", function(module, exports) {
'use strict';

var $k86Vd = parcelRequire("k86Vd");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b4168a0dada9b5bc$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $k86Vd.nextTick($b4168a0dada9b5bc$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $k86Vd.nextTick($b4168a0dada9b5bc$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $k86Vd.nextTick($b4168a0dada9b5bc$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $k86Vd.nextTick($b4168a0dada9b5bc$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b4168a0dada9b5bc$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b4168a0dada9b5bc$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b4168a0dada9b5bc$var$destroy,
    undestroy: $b4168a0dada9b5bc$var$undestroy
};

});

parcelRegister("eK6SV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $k86Vd = parcelRequire("k86Vd");
/*</replacement>*/ /*<replacement>*/ var $abbab3c43eef2efa$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $abbab3c43eef2efa$var$Duplex;

/*<replacement>*/ var $abbab3c43eef2efa$var$util = Object.create((parcelRequire("cLTx3")));

$abbab3c43eef2efa$var$util.inherits = (parcelRequire("aAKqs"));

var $jCj7j = parcelRequire("jCj7j");

var $ffkn8 = parcelRequire("ffkn8");
$abbab3c43eef2efa$var$util.inherits($abbab3c43eef2efa$var$Duplex, $jCj7j);
// avoid scope creep, the keys array can then be collected
var $abbab3c43eef2efa$var$keys = $abbab3c43eef2efa$var$objectKeys($ffkn8.prototype);
for(var $abbab3c43eef2efa$var$v = 0; $abbab3c43eef2efa$var$v < $abbab3c43eef2efa$var$keys.length; $abbab3c43eef2efa$var$v++){
    var $abbab3c43eef2efa$var$method = $abbab3c43eef2efa$var$keys[$abbab3c43eef2efa$var$v];
    if (!$abbab3c43eef2efa$var$Duplex.prototype[$abbab3c43eef2efa$var$method]) $abbab3c43eef2efa$var$Duplex.prototype[$abbab3c43eef2efa$var$method] = $ffkn8.prototype[$abbab3c43eef2efa$var$method];
}
function $abbab3c43eef2efa$var$Duplex(options) {
    if (!(this instanceof $abbab3c43eef2efa$var$Duplex)) return new $abbab3c43eef2efa$var$Duplex(options);
    $jCj7j.call(this, options);
    $ffkn8.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $abbab3c43eef2efa$var$onend);
}
Object.defineProperty($abbab3c43eef2efa$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $abbab3c43eef2efa$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $k86Vd.nextTick($abbab3c43eef2efa$var$onEndNT, this);
}
function $abbab3c43eef2efa$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($abbab3c43eef2efa$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$abbab3c43eef2efa$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $k86Vd.nextTick(cb, err);
};

});
parcelRegister("ffkn8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $k86Vd = parcelRequire("k86Vd");
/*</replacement>*/ module.exports = $b1980f31da8527d4$var$Writable;
/* <replacement> */ function $b1980f31da8527d4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $b1980f31da8527d4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $b1980f31da8527d4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $b1980f31da8527d4$var$asyncWrite = (0, $k86Vd.nextTick);
/*</replacement>*/ /*<replacement>*/ var $b1980f31da8527d4$var$Duplex;
/*</replacement>*/ $b1980f31da8527d4$var$Writable.WritableState = $b1980f31da8527d4$var$WritableState;

/*<replacement>*/ var $b1980f31da8527d4$var$util = Object.create((parcelRequire("cLTx3")));

$b1980f31da8527d4$var$util.inherits = (parcelRequire("aAKqs"));

/*</replacement>*/ /*<replacement>*/ var $b1980f31da8527d4$var$internalUtil = {
    deprecate: (parcelRequire("9QIIF"))
};

var $kn46R = parcelRequire("kn46R");

var $961E7 = parcelRequire("961E7");
var $b1980f31da8527d4$require$Buffer = $961E7.Buffer;
var $b1980f31da8527d4$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $b1980f31da8527d4$var$_uint8ArrayToBuffer(chunk) {
    return $b1980f31da8527d4$require$Buffer.from(chunk);
}
function $b1980f31da8527d4$var$_isUint8Array(obj) {
    return $b1980f31da8527d4$require$Buffer.isBuffer(obj) || obj instanceof $b1980f31da8527d4$var$OurUint8Array;
}

var $fsBtr = parcelRequire("fsBtr");
$b1980f31da8527d4$var$util.inherits($b1980f31da8527d4$var$Writable, $kn46R);
function $b1980f31da8527d4$var$nop() {}

function $b1980f31da8527d4$var$WritableState(options, stream) {
    $b1980f31da8527d4$var$Duplex = $b1980f31da8527d4$var$Duplex || (parcelRequire("eK6SV"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $b1980f31da8527d4$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $b1980f31da8527d4$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $b1980f31da8527d4$var$CorkedRequest(this);
}
$b1980f31da8527d4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($b1980f31da8527d4$var$WritableState.prototype, 'buffer', {
            get: $b1980f31da8527d4$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $b1980f31da8527d4$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $b1980f31da8527d4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($b1980f31da8527d4$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($b1980f31da8527d4$var$realHasInstance.call(this, object)) return true;
            if (this !== $b1980f31da8527d4$var$Writable) return false;
            return object && object._writableState instanceof $b1980f31da8527d4$var$WritableState;
        }
    });
} else $b1980f31da8527d4$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $b1980f31da8527d4$var$Writable(options) {
    $b1980f31da8527d4$var$Duplex = $b1980f31da8527d4$var$Duplex || (parcelRequire("eK6SV"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$b1980f31da8527d4$var$realHasInstance.call($b1980f31da8527d4$var$Writable, this) && !(this instanceof $b1980f31da8527d4$var$Duplex)) return new $b1980f31da8527d4$var$Writable(options);
    this._writableState = new $b1980f31da8527d4$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $kn46R.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$b1980f31da8527d4$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $b1980f31da8527d4$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $k86Vd.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $b1980f31da8527d4$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $k86Vd.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$b1980f31da8527d4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $b1980f31da8527d4$var$_isUint8Array(chunk);
    if (isBuf && !$b1980f31da8527d4$require$Buffer.isBuffer(chunk)) chunk = $b1980f31da8527d4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $b1980f31da8527d4$var$nop;
    if (state.ended) $b1980f31da8527d4$var$writeAfterEnd(this, cb);
    else if (isBuf || $b1980f31da8527d4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $b1980f31da8527d4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$b1980f31da8527d4$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$b1980f31da8527d4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b1980f31da8527d4$var$clearBuffer(this, state);
    }
};
$b1980f31da8527d4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $b1980f31da8527d4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $b1980f31da8527d4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($b1980f31da8527d4$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b1980f31da8527d4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $b1980f31da8527d4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $b1980f31da8527d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $b1980f31da8527d4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b1980f31da8527d4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $k86Vd.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $k86Vd.nextTick($b1980f31da8527d4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $b1980f31da8527d4$var$finishMaybe(stream, state);
    }
}
function $b1980f31da8527d4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $b1980f31da8527d4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $b1980f31da8527d4$var$onwriteStateUpdate(state);
    if (er) $b1980f31da8527d4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $b1980f31da8527d4$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b1980f31da8527d4$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $b1980f31da8527d4$var$asyncWrite($b1980f31da8527d4$var$afterWrite, stream, state, finished, cb);
        else $b1980f31da8527d4$var$afterWrite(stream, state, finished, cb);
    }
}
function $b1980f31da8527d4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $b1980f31da8527d4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $b1980f31da8527d4$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $b1980f31da8527d4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $b1980f31da8527d4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $b1980f31da8527d4$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $b1980f31da8527d4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $b1980f31da8527d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$b1980f31da8527d4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$b1980f31da8527d4$var$Writable.prototype._writev = null;
$b1980f31da8527d4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $b1980f31da8527d4$var$endWritable(this, state, cb);
};
function $b1980f31da8527d4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $b1980f31da8527d4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $b1980f31da8527d4$var$finishMaybe(stream, state);
    });
}
function $b1980f31da8527d4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $k86Vd.nextTick($b1980f31da8527d4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b1980f31da8527d4$var$finishMaybe(stream, state) {
    var need = $b1980f31da8527d4$var$needFinish(state);
    if (need) {
        $b1980f31da8527d4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $b1980f31da8527d4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $b1980f31da8527d4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $k86Vd.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $b1980f31da8527d4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($b1980f31da8527d4$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$b1980f31da8527d4$var$Writable.prototype.destroy = $fsBtr.destroy;
$b1980f31da8527d4$var$Writable.prototype._undestroy = $fsBtr.undestroy;
$b1980f31da8527d4$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("KfonS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $08b03c94afa1b045$export$63a7aa211a91ed69, (v) => $08b03c94afa1b045$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $08b03c94afa1b045$export$63a7aa211a91ed69;
'use strict';

var $961E7 = parcelRequire("961E7");
var $08b03c94afa1b045$require$Buffer = $961E7.Buffer;
/*</replacement>*/ var $08b03c94afa1b045$var$isEncoding = $08b03c94afa1b045$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $08b03c94afa1b045$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $08b03c94afa1b045$var$normalizeEncoding(enc) {
    var nenc = $08b03c94afa1b045$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($08b03c94afa1b045$require$Buffer.isEncoding === $08b03c94afa1b045$var$isEncoding || !$08b03c94afa1b045$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$08b03c94afa1b045$export$63a7aa211a91ed69 = $08b03c94afa1b045$var$StringDecoder;
function $08b03c94afa1b045$var$StringDecoder(encoding) {
    this.encoding = $08b03c94afa1b045$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $08b03c94afa1b045$var$utf16Text;
            this.end = $08b03c94afa1b045$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $08b03c94afa1b045$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $08b03c94afa1b045$var$base64Text;
            this.end = $08b03c94afa1b045$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $08b03c94afa1b045$var$simpleWrite;
            this.end = $08b03c94afa1b045$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $08b03c94afa1b045$require$Buffer.allocUnsafe(nb);
}
$08b03c94afa1b045$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$08b03c94afa1b045$var$StringDecoder.prototype.end = $08b03c94afa1b045$var$utf8End;
// Returns only complete characters in a Buffer
$08b03c94afa1b045$var$StringDecoder.prototype.text = $08b03c94afa1b045$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$08b03c94afa1b045$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $08b03c94afa1b045$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $08b03c94afa1b045$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $08b03c94afa1b045$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $08b03c94afa1b045$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $08b03c94afa1b045$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $08b03c94afa1b045$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $08b03c94afa1b045$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $08b03c94afa1b045$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $08b03c94afa1b045$var$utf8Text(buf, i) {
    var total = $08b03c94afa1b045$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $08b03c94afa1b045$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $08b03c94afa1b045$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $08b03c94afa1b045$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $08b03c94afa1b045$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $08b03c94afa1b045$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $08b03c94afa1b045$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $08b03c94afa1b045$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("8ezhs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $5feaff80dd9a3fa2$var$Transform;

var $eK6SV = parcelRequire("eK6SV");

/*<replacement>*/ var $5feaff80dd9a3fa2$var$util = Object.create((parcelRequire("cLTx3")));

$5feaff80dd9a3fa2$var$util.inherits = (parcelRequire("aAKqs"));
/*</replacement>*/ $5feaff80dd9a3fa2$var$util.inherits($5feaff80dd9a3fa2$var$Transform, $eK6SV);
function $5feaff80dd9a3fa2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $5feaff80dd9a3fa2$var$Transform(options) {
    if (!(this instanceof $5feaff80dd9a3fa2$var$Transform)) return new $5feaff80dd9a3fa2$var$Transform(options);
    $eK6SV.call(this, options);
    this._transformState = {
        afterTransform: $5feaff80dd9a3fa2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $5feaff80dd9a3fa2$var$prefinish);
}
function $5feaff80dd9a3fa2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $5feaff80dd9a3fa2$var$done(_this, er, data);
    });
    else $5feaff80dd9a3fa2$var$done(this, null, null);
}
$5feaff80dd9a3fa2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $eK6SV.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$5feaff80dd9a3fa2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$5feaff80dd9a3fa2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$5feaff80dd9a3fa2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$5feaff80dd9a3fa2$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $eK6SV.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $5feaff80dd9a3fa2$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("kPzjF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $f2a3f723eeed24c3$var$PassThrough;

var $8ezhs = parcelRequire("8ezhs");

/*<replacement>*/ var $f2a3f723eeed24c3$var$util = Object.create((parcelRequire("cLTx3")));

$f2a3f723eeed24c3$var$util.inherits = (parcelRequire("aAKqs"));
/*</replacement>*/ $f2a3f723eeed24c3$var$util.inherits($f2a3f723eeed24c3$var$PassThrough, $8ezhs);
function $f2a3f723eeed24c3$var$PassThrough(options) {
    if (!(this instanceof $f2a3f723eeed24c3$var$PassThrough)) return new $f2a3f723eeed24c3$var$PassThrough(options);
    $8ezhs.call(this, options);
}
$f2a3f723eeed24c3$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("6Ymfg", function(module, exports) {
'use strict';

var $dOfWq = parcelRequire("dOfWq");
var $51399a1a50aaa4af$require$Buffer = $dOfWq.Buffer;

var $aAKqs = parcelRequire("aAKqs");

var $5V3ah = parcelRequire("5V3ah");
var $51399a1a50aaa4af$var$ARRAY16 = new Array(16);
var $51399a1a50aaa4af$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $51399a1a50aaa4af$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $51399a1a50aaa4af$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $51399a1a50aaa4af$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $51399a1a50aaa4af$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $51399a1a50aaa4af$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $51399a1a50aaa4af$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $51399a1a50aaa4af$var$fn1(a, b, c, d, e, m, k, s) {
    return $51399a1a50aaa4af$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $51399a1a50aaa4af$var$fn2(a, b, c, d, e, m, k, s) {
    return $51399a1a50aaa4af$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $51399a1a50aaa4af$var$fn3(a, b, c, d, e, m, k, s) {
    return $51399a1a50aaa4af$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $51399a1a50aaa4af$var$fn4(a, b, c, d, e, m, k, s) {
    return $51399a1a50aaa4af$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $51399a1a50aaa4af$var$fn5(a, b, c, d, e, m, k, s) {
    return $51399a1a50aaa4af$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $51399a1a50aaa4af$var$RIPEMD160() {
    $5V3ah.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$aAKqs($51399a1a50aaa4af$var$RIPEMD160, $5V3ah);
$51399a1a50aaa4af$var$RIPEMD160.prototype._update = function() {
    var words = $51399a1a50aaa4af$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $51399a1a50aaa4af$var$fn1(al, bl, cl, dl, el, words[$51399a1a50aaa4af$var$zl[i]], $51399a1a50aaa4af$var$hl[0], $51399a1a50aaa4af$var$sl[i]);
            tr = $51399a1a50aaa4af$var$fn5(ar, br, cr, dr, er, words[$51399a1a50aaa4af$var$zr[i]], $51399a1a50aaa4af$var$hr[0], $51399a1a50aaa4af$var$sr[i]);
        } else if (i < 32) {
            tl = $51399a1a50aaa4af$var$fn2(al, bl, cl, dl, el, words[$51399a1a50aaa4af$var$zl[i]], $51399a1a50aaa4af$var$hl[1], $51399a1a50aaa4af$var$sl[i]);
            tr = $51399a1a50aaa4af$var$fn4(ar, br, cr, dr, er, words[$51399a1a50aaa4af$var$zr[i]], $51399a1a50aaa4af$var$hr[1], $51399a1a50aaa4af$var$sr[i]);
        } else if (i < 48) {
            tl = $51399a1a50aaa4af$var$fn3(al, bl, cl, dl, el, words[$51399a1a50aaa4af$var$zl[i]], $51399a1a50aaa4af$var$hl[2], $51399a1a50aaa4af$var$sl[i]);
            tr = $51399a1a50aaa4af$var$fn3(ar, br, cr, dr, er, words[$51399a1a50aaa4af$var$zr[i]], $51399a1a50aaa4af$var$hr[2], $51399a1a50aaa4af$var$sr[i]);
        } else if (i < 64) {
            tl = $51399a1a50aaa4af$var$fn4(al, bl, cl, dl, el, words[$51399a1a50aaa4af$var$zl[i]], $51399a1a50aaa4af$var$hl[3], $51399a1a50aaa4af$var$sl[i]);
            tr = $51399a1a50aaa4af$var$fn2(ar, br, cr, dr, er, words[$51399a1a50aaa4af$var$zr[i]], $51399a1a50aaa4af$var$hr[3], $51399a1a50aaa4af$var$sr[i]);
        } else {
            tl = $51399a1a50aaa4af$var$fn5(al, bl, cl, dl, el, words[$51399a1a50aaa4af$var$zl[i]], $51399a1a50aaa4af$var$hl[4], $51399a1a50aaa4af$var$sl[i]);
            tr = $51399a1a50aaa4af$var$fn1(ar, br, cr, dr, er, words[$51399a1a50aaa4af$var$zr[i]], $51399a1a50aaa4af$var$hr[4], $51399a1a50aaa4af$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $51399a1a50aaa4af$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $51399a1a50aaa4af$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$51399a1a50aaa4af$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $51399a1a50aaa4af$require$Buffer.alloc ? $51399a1a50aaa4af$require$Buffer.alloc(20) : new $51399a1a50aaa4af$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $51399a1a50aaa4af$var$RIPEMD160;

});

parcelRegister("418D0", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("iKbr1"));

module.exports.sha1 = (parcelRequire("eMITu"));

module.exports.sha224 = (parcelRequire("lBPpN"));

module.exports.sha256 = (parcelRequire("byvQk"));

module.exports.sha384 = (parcelRequire("9QMsT"));

module.exports.sha512 = (parcelRequire("4dgvU"));

});
parcelRegister("iKbr1", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $rXzls = parcelRequire("rXzls");

var $h9jRt = parcelRequire("h9jRt");
var $da5564918351ff44$require$Buffer = $h9jRt.Buffer;
var $da5564918351ff44$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $da5564918351ff44$var$W = new Array(80);
function $da5564918351ff44$var$Sha() {
    this.init();
    this._w = $da5564918351ff44$var$W;
    $rXzls.call(this, 64, 56);
}
$aAKqs($da5564918351ff44$var$Sha, $rXzls);
$da5564918351ff44$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $da5564918351ff44$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $da5564918351ff44$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $da5564918351ff44$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$da5564918351ff44$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $da5564918351ff44$var$rotl5(a) + $da5564918351ff44$var$ft(s, b, c, d) + e + w[j] + $da5564918351ff44$var$K[s] | 0;
        e = d;
        d = c;
        c = $da5564918351ff44$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$da5564918351ff44$var$Sha.prototype._hash = function() {
    var H = $da5564918351ff44$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $da5564918351ff44$var$Sha;

});
parcelRegister("rXzls", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $0540bae8daebbebc$require$Buffer = $h9jRt.Buffer;

var $4nTqM = parcelRequire("4nTqM");
// prototype class for hash functions
function $0540bae8daebbebc$var$Hash(blockSize, finalSize) {
    this._block = $0540bae8daebbebc$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0540bae8daebbebc$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $4nTqM(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0540bae8daebbebc$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0540bae8daebbebc$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0540bae8daebbebc$var$Hash;

});


parcelRegister("eMITu", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $rXzls = parcelRequire("rXzls");

var $h9jRt = parcelRequire("h9jRt");
var $ac385f5f28d55e80$require$Buffer = $h9jRt.Buffer;
var $ac385f5f28d55e80$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $ac385f5f28d55e80$var$W = new Array(80);
function $ac385f5f28d55e80$var$Sha1() {
    this.init();
    this._w = $ac385f5f28d55e80$var$W;
    $rXzls.call(this, 64, 56);
}
$aAKqs($ac385f5f28d55e80$var$Sha1, $rXzls);
$ac385f5f28d55e80$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $ac385f5f28d55e80$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $ac385f5f28d55e80$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $ac385f5f28d55e80$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $ac385f5f28d55e80$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$ac385f5f28d55e80$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $ac385f5f28d55e80$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $ac385f5f28d55e80$var$rotl5(a) + $ac385f5f28d55e80$var$ft(s, b, c, d) + e + w[j] + $ac385f5f28d55e80$var$K[s] | 0;
        e = d;
        d = c;
        c = $ac385f5f28d55e80$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$ac385f5f28d55e80$var$Sha1.prototype._hash = function() {
    var H = $ac385f5f28d55e80$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $ac385f5f28d55e80$var$Sha1;

});

parcelRegister("lBPpN", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $byvQk = parcelRequire("byvQk");

var $rXzls = parcelRequire("rXzls");

var $h9jRt = parcelRequire("h9jRt");
var $fbb4efa8e9b733ea$require$Buffer = $h9jRt.Buffer;
var $fbb4efa8e9b733ea$var$W = new Array(64);
function $fbb4efa8e9b733ea$var$Sha224() {
    this.init();
    this._w = $fbb4efa8e9b733ea$var$W; // new Array(64)
    $rXzls.call(this, 64, 56);
}
$aAKqs($fbb4efa8e9b733ea$var$Sha224, $byvQk);
$fbb4efa8e9b733ea$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$fbb4efa8e9b733ea$var$Sha224.prototype._hash = function() {
    var H = $fbb4efa8e9b733ea$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $fbb4efa8e9b733ea$var$Sha224;

});
parcelRegister("byvQk", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $rXzls = parcelRequire("rXzls");

var $h9jRt = parcelRequire("h9jRt");
var $869b920a05376b89$require$Buffer = $h9jRt.Buffer;
var $869b920a05376b89$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $869b920a05376b89$var$W = new Array(64);
function $869b920a05376b89$var$Sha256() {
    this.init();
    this._w = $869b920a05376b89$var$W; // new Array(64)
    $rXzls.call(this, 64, 56);
}
$aAKqs($869b920a05376b89$var$Sha256, $rXzls);
$869b920a05376b89$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $869b920a05376b89$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $869b920a05376b89$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $869b920a05376b89$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $869b920a05376b89$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $869b920a05376b89$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $869b920a05376b89$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$869b920a05376b89$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $869b920a05376b89$var$gamma1(w[i - 2]) + w[i - 7] + $869b920a05376b89$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $869b920a05376b89$var$sigma1(e) + $869b920a05376b89$var$ch(e, f, g) + $869b920a05376b89$var$K[j] + w[j] | 0;
        var T2 = $869b920a05376b89$var$sigma0(a) + $869b920a05376b89$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$869b920a05376b89$var$Sha256.prototype._hash = function() {
    var H = $869b920a05376b89$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $869b920a05376b89$var$Sha256;

});


parcelRegister("9QMsT", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $4dgvU = parcelRequire("4dgvU");

var $rXzls = parcelRequire("rXzls");

var $h9jRt = parcelRequire("h9jRt");
var $72be90846b9e67c0$require$Buffer = $h9jRt.Buffer;
var $72be90846b9e67c0$var$W = new Array(160);
function $72be90846b9e67c0$var$Sha384() {
    this.init();
    this._w = $72be90846b9e67c0$var$W;
    $rXzls.call(this, 128, 112);
}
$aAKqs($72be90846b9e67c0$var$Sha384, $4dgvU);
$72be90846b9e67c0$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$72be90846b9e67c0$var$Sha384.prototype._hash = function() {
    var H = $72be90846b9e67c0$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $72be90846b9e67c0$var$Sha384;

});
parcelRegister("4dgvU", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $rXzls = parcelRequire("rXzls");

var $h9jRt = parcelRequire("h9jRt");
var $31152f95a823884b$require$Buffer = $h9jRt.Buffer;
var $31152f95a823884b$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $31152f95a823884b$var$W = new Array(160);
function $31152f95a823884b$var$Sha512() {
    this.init();
    this._w = $31152f95a823884b$var$W;
    $rXzls.call(this, 128, 112);
}
$aAKqs($31152f95a823884b$var$Sha512, $rXzls);
$31152f95a823884b$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $31152f95a823884b$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $31152f95a823884b$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $31152f95a823884b$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $31152f95a823884b$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $31152f95a823884b$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $31152f95a823884b$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $31152f95a823884b$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $31152f95a823884b$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $31152f95a823884b$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$31152f95a823884b$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $31152f95a823884b$var$Gamma0(xh, xl);
        var gamma0l = $31152f95a823884b$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $31152f95a823884b$var$Gamma1(xh, xl);
        var gamma1l = $31152f95a823884b$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $31152f95a823884b$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $31152f95a823884b$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $31152f95a823884b$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $31152f95a823884b$var$maj(ah, bh, ch);
        var majl = $31152f95a823884b$var$maj(al, bl, cl);
        var sigma0h = $31152f95a823884b$var$sigma0(ah, al);
        var sigma0l = $31152f95a823884b$var$sigma0(al, ah);
        var sigma1h = $31152f95a823884b$var$sigma1(eh, el);
        var sigma1l = $31152f95a823884b$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $31152f95a823884b$var$K[j];
        var Kil = $31152f95a823884b$var$K[j + 1];
        var chh = $31152f95a823884b$var$Ch(eh, fh, gh);
        var chl = $31152f95a823884b$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $31152f95a823884b$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $31152f95a823884b$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $31152f95a823884b$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $31152f95a823884b$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $31152f95a823884b$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $31152f95a823884b$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $31152f95a823884b$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $31152f95a823884b$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $31152f95a823884b$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $31152f95a823884b$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $31152f95a823884b$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $31152f95a823884b$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $31152f95a823884b$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $31152f95a823884b$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $31152f95a823884b$var$getCarry(this._hl, hl) | 0;
};
$31152f95a823884b$var$Sha512.prototype._hash = function() {
    var H = $31152f95a823884b$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $31152f95a823884b$var$Sha512;

});



parcelRegister("dXkiA", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $a29087f207c7c7ea$require$Buffer = $h9jRt.Buffer;

var $9Bpih = parcelRequire("9Bpih");
var $a29087f207c7c7ea$require$Transform = $9Bpih.Transform;

var $gwpIL = parcelRequire("gwpIL");
var $a29087f207c7c7ea$require$StringDecoder = $gwpIL.StringDecoder;

var $aAKqs = parcelRequire("aAKqs");

var $4nTqM = parcelRequire("4nTqM");
function $a29087f207c7c7ea$var$CipherBase(hashMode) {
    $a29087f207c7c7ea$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$aAKqs($a29087f207c7c7ea$var$CipherBase, $a29087f207c7c7ea$require$Transform);
$a29087f207c7c7ea$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $4nTqM(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$a29087f207c7c7ea$var$CipherBase.prototype.setAutoPadding = function() {};
$a29087f207c7c7ea$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$a29087f207c7c7ea$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$a29087f207c7c7ea$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$a29087f207c7c7ea$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$a29087f207c7c7ea$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$a29087f207c7c7ea$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $a29087f207c7c7ea$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$a29087f207c7c7ea$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $a29087f207c7c7ea$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $a29087f207c7c7ea$var$CipherBase;

});


parcelRegister("fRs08", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $7d81l = parcelRequire("7d81l");

var $dXkiA = parcelRequire("dXkiA");

var $h9jRt = parcelRequire("h9jRt");
var $b8c186ae841d2466$require$Buffer = $h9jRt.Buffer;

var $a2vfX = parcelRequire("a2vfX");

var $6Ymfg = parcelRequire("6Ymfg");

var $418D0 = parcelRequire("418D0");
var $b8c186ae841d2466$var$ZEROS = $b8c186ae841d2466$require$Buffer.alloc(128);
function $b8c186ae841d2466$var$Hmac(alg, key) {
    $dXkiA.call(this, 'digest');
    if (typeof key === 'string') key = $b8c186ae841d2466$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $6Ymfg() : $418D0(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $b8c186ae841d2466$require$Buffer.concat([
        key,
        $b8c186ae841d2466$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $b8c186ae841d2466$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $b8c186ae841d2466$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $6Ymfg() : $418D0(alg);
    this._hash.update(ipad);
}
$aAKqs($b8c186ae841d2466$var$Hmac, $dXkiA);
$b8c186ae841d2466$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$b8c186ae841d2466$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $6Ymfg() : $418D0(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $b8c186ae841d2466$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $7d81l($a2vfX, key);
    return new $b8c186ae841d2466$var$Hmac(alg, key);
};

});
parcelRegister("7d81l", function(module, exports) {
'use strict';

var $aAKqs = parcelRequire("aAKqs");

var $h9jRt = parcelRequire("h9jRt");
var $53fff80922605591$require$Buffer = $h9jRt.Buffer;

var $dXkiA = parcelRequire("dXkiA");
var $53fff80922605591$var$ZEROS = $53fff80922605591$require$Buffer.alloc(128);
var $53fff80922605591$var$blocksize = 64;
function $53fff80922605591$var$Hmac(alg, key) {
    $dXkiA.call(this, 'digest');
    if (typeof key === 'string') key = $53fff80922605591$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $53fff80922605591$var$blocksize) key = alg(key);
    else if (key.length < $53fff80922605591$var$blocksize) key = $53fff80922605591$require$Buffer.concat([
        key,
        $53fff80922605591$var$ZEROS
    ], $53fff80922605591$var$blocksize);
    var ipad = this._ipad = $53fff80922605591$require$Buffer.allocUnsafe($53fff80922605591$var$blocksize);
    var opad = this._opad = $53fff80922605591$require$Buffer.allocUnsafe($53fff80922605591$var$blocksize);
    for(var i = 0; i < $53fff80922605591$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$aAKqs($53fff80922605591$var$Hmac, $dXkiA);
$53fff80922605591$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$53fff80922605591$var$Hmac.prototype._final = function() {
    var h = this._alg($53fff80922605591$require$Buffer.concat(this._hash));
    return this._alg($53fff80922605591$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $53fff80922605591$var$Hmac;

});

parcelRegister("a2vfX", function(module, exports) {

var $ix9Mi = parcelRequire("ix9Mi");
module.exports = function(buffer) {
    return new $ix9Mi().update(buffer).digest();
};

});


parcelRegister("6ego3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5oTjV"));

});
parcelRegister("5oTjV", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("aAf6x", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $7b48fb9d7cdf5d56$export$448fa22aedc9dbca, (v) => $7b48fb9d7cdf5d56$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $7b48fb9d7cdf5d56$export$b80c7ba289c8fa56, (v) => $7b48fb9d7cdf5d56$export$b80c7ba289c8fa56 = v);
var $7b48fb9d7cdf5d56$export$448fa22aedc9dbca;
var $7b48fb9d7cdf5d56$export$b80c7ba289c8fa56;
'use strict';

$7b48fb9d7cdf5d56$export$448fa22aedc9dbca = (parcelRequire("4ezq2"));

$7b48fb9d7cdf5d56$export$b80c7ba289c8fa56 = (parcelRequire("4xvvQ"));

});
parcelRegister("4ezq2", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $3153f1b1b364e586$require$Buffer = $h9jRt.Buffer;

var $dsDd3 = parcelRequire("dsDd3");

var $3aAbC = parcelRequire("3aAbC");

var $4xvvQ = parcelRequire("4xvvQ");

var $1Crlv = parcelRequire("1Crlv");
var $3153f1b1b364e586$var$ZERO_BUF;
var $3153f1b1b364e586$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3153f1b1b364e586$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $3153f1b1b364e586$var$checks = [];
var $3153f1b1b364e586$var$nextTick;
function $3153f1b1b364e586$var$getNextTick() {
    if ($3153f1b1b364e586$var$nextTick) return $3153f1b1b364e586$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3153f1b1b364e586$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3153f1b1b364e586$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3153f1b1b364e586$var$nextTick = $parcel$global.setImmediate;
    else $3153f1b1b364e586$var$nextTick = $parcel$global.setTimeout;
    return $3153f1b1b364e586$var$nextTick;
}
function $3153f1b1b364e586$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3153f1b1b364e586$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $3153f1b1b364e586$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3153f1b1b364e586$require$Buffer.from(res);
    });
}
function $3153f1b1b364e586$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3153f1b1b364e586$var$subtle || !$3153f1b1b364e586$var$subtle.importKey || !$3153f1b1b364e586$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3153f1b1b364e586$var$checks[algo] !== undefined) return $3153f1b1b364e586$var$checks[algo];
    $3153f1b1b364e586$var$ZERO_BUF = $3153f1b1b364e586$var$ZERO_BUF || $3153f1b1b364e586$require$Buffer.alloc(8);
    var prom = $3153f1b1b364e586$var$browserPbkdf2($3153f1b1b364e586$var$ZERO_BUF, $3153f1b1b364e586$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $3153f1b1b364e586$var$checks[algo] = prom;
    return prom;
}
function $3153f1b1b364e586$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3153f1b1b364e586$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3153f1b1b364e586$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    keylen = $dsDd3(iterations, keylen);
    password = $1Crlv(password, $3aAbC, 'Password');
    salt = $1Crlv(salt, $3aAbC, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $3153f1b1b364e586$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $3153f1b1b364e586$var$getNextTick()(function() {
            var out;
            try {
                out = $4xvvQ(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $3153f1b1b364e586$var$resolvePromise($3153f1b1b364e586$var$checkNative(algo).then(function(resp) {
        if (resp) return $3153f1b1b364e586$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $4xvvQ(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("dsDd3", function(module, exports) {
'use strict';
var $9ccc4e178e0c54a1$var$$isFinite = isFinite;
var $9ccc4e178e0c54a1$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$9ccc4e178e0c54a1$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $9ccc4e178e0c54a1$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    // `-0` passes the `keylen < 0` guard above (since `-0 < 0` is `false`), but
    // the native binding requires a true Int32; `-0` is held as a double and
    // aborts the process (SIGABRT) on Node.js 15+. Coerce it to `+0`.
    return keylen + 0;
};

});

parcelRegister("3aAbC", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");
'use strict';
var $24ee6023acc7c037$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $24ee6023acc7c037$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $24ee6023acc7c037$var$pVersionMajor = parseInt($1g1jb.version.split('.')[0].slice(1), 10);
    $24ee6023acc7c037$var$defaultEncoding = $24ee6023acc7c037$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $24ee6023acc7c037$var$defaultEncoding = 'utf-8';
module.exports = $24ee6023acc7c037$var$defaultEncoding;

});

parcelRegister("4xvvQ", function(module, exports) {
'use strict';

var $a2vfX = parcelRequire("a2vfX");

var $6Ymfg = parcelRequire("6Ymfg");

var $418D0 = parcelRequire("418D0");

var $h9jRt = parcelRequire("h9jRt");
var $34e2b04210dcede3$require$Buffer = $h9jRt.Buffer;

var $dsDd3 = parcelRequire("dsDd3");

var $3aAbC = parcelRequire("3aAbC");

var $1Crlv = parcelRequire("1Crlv");
var $34e2b04210dcede3$var$ZEROS = $34e2b04210dcede3$require$Buffer.alloc(128);
var $34e2b04210dcede3$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $34e2b04210dcede3$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $34e2b04210dcede3$var$rmd160Func(data) {
    return new $6Ymfg().update(data).digest();
}
function $34e2b04210dcede3$var$getDigest(alg) {
    function shaFunc(data) {
        return $418D0(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $34e2b04210dcede3$var$rmd160Func;
    if (alg === 'md5') return $a2vfX;
    return shaFunc;
}
function $34e2b04210dcede3$var$Hmac(alg, key, saltLen) {
    var hash = $34e2b04210dcede3$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $34e2b04210dcede3$require$Buffer.concat([
        key,
        $34e2b04210dcede3$var$ZEROS
    ], blocksize);
    var ipad = $34e2b04210dcede3$require$Buffer.allocUnsafe(blocksize + $34e2b04210dcede3$var$sizes[alg]);
    var opad = $34e2b04210dcede3$require$Buffer.allocUnsafe(blocksize + $34e2b04210dcede3$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $34e2b04210dcede3$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $34e2b04210dcede3$var$sizes[alg];
}
$34e2b04210dcede3$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $34e2b04210dcede3$var$pbkdf2(password, salt, iterations, keylen, digest) {
    keylen = $dsDd3(iterations, keylen);
    password = $1Crlv(password, $3aAbC, 'Password');
    salt = $1Crlv(salt, $3aAbC, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $34e2b04210dcede3$var$mapping[lowerDigest] || lowerDigest;
    var size = $34e2b04210dcede3$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $34e2b04210dcede3$var$Hmac(mappedDigest, password, salt.length);
    var DK = $34e2b04210dcede3$require$Buffer.allocUnsafe(keylen);
    var block1 = $34e2b04210dcede3$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $34e2b04210dcede3$var$pbkdf2;

});
parcelRegister("1Crlv", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $12de8d59f822ac86$require$Buffer = $h9jRt.Buffer;

var $4nTqM = parcelRequire("4nTqM");
var $12de8d59f822ac86$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $12de8d59f822ac86$var$useArrayBuffer = $12de8d59f822ac86$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $12de8d59f822ac86$var$isView = $12de8d59f822ac86$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $12de8d59f822ac86$require$Buffer.isBuffer(thing) || $12de8d59f822ac86$var$useUint8Array && thing instanceof Uint8Array || $12de8d59f822ac86$var$isView && $12de8d59f822ac86$var$isView(thing)) return $4nTqM(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("kcq7Q", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $eb493199f3c38dd2$export$bdd223f16383713e, (v) => $eb493199f3c38dd2$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $eb493199f3c38dd2$export$26e5786e8ac8e530, (v) => $eb493199f3c38dd2$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $eb493199f3c38dd2$export$2f64596b8cbf08b4, (v) => $eb493199f3c38dd2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $eb493199f3c38dd2$export$20533d26f07f1ee0, (v) => $eb493199f3c38dd2$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $eb493199f3c38dd2$export$12ada9414fbc594c, (v) => $eb493199f3c38dd2$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $eb493199f3c38dd2$export$2ce6d8d0e8b04e1a, (v) => $eb493199f3c38dd2$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $eb493199f3c38dd2$export$36b6d6ef312eab39, (v) => $eb493199f3c38dd2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $eb493199f3c38dd2$export$f5e7e39d57cd9700, (v) => $eb493199f3c38dd2$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $eb493199f3c38dd2$export$dedd8dc3dc62b370, (v) => $eb493199f3c38dd2$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $eb493199f3c38dd2$export$58a258485f1e49f6, (v) => $eb493199f3c38dd2$export$58a258485f1e49f6 = v);
var $eb493199f3c38dd2$export$bdd223f16383713e;
var $eb493199f3c38dd2$export$26e5786e8ac8e530;
var $eb493199f3c38dd2$export$2f64596b8cbf08b4;
var $eb493199f3c38dd2$export$20533d26f07f1ee0;
var $eb493199f3c38dd2$export$12ada9414fbc594c;
var $eb493199f3c38dd2$export$2ce6d8d0e8b04e1a;
var $eb493199f3c38dd2$export$36b6d6ef312eab39;
var $eb493199f3c38dd2$export$f5e7e39d57cd9700;
var $eb493199f3c38dd2$export$dedd8dc3dc62b370;
var $eb493199f3c38dd2$export$58a258485f1e49f6;

var $bAxe6 = parcelRequire("bAxe6");

var $9bOof = parcelRequire("9bOof");

var $kKD6q = parcelRequire("kKD6q");

var $ahfUu = parcelRequire("ahfUu");

var $dIH6y = parcelRequire("dIH6y");
function $eb493199f3c38dd2$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($kKD6q[suite]) {
        keyLen = $kKD6q[suite].key;
        ivLen = $kKD6q[suite].iv;
    } else if ($ahfUu[suite]) {
        keyLen = $ahfUu[suite].key * 8;
        ivLen = $ahfUu[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $dIH6y(password, false, keyLen, ivLen);
    return $eb493199f3c38dd2$var$createCipheriv(suite, keys.key, keys.iv);
}
function $eb493199f3c38dd2$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($kKD6q[suite]) {
        keyLen = $kKD6q[suite].key;
        ivLen = $kKD6q[suite].iv;
    } else if ($ahfUu[suite]) {
        keyLen = $ahfUu[suite].key * 8;
        ivLen = $ahfUu[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $dIH6y(password, false, keyLen, ivLen);
    return $eb493199f3c38dd2$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $eb493199f3c38dd2$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($kKD6q[suite]) return $9bOof.createCipheriv(suite, key, iv);
    if ($ahfUu[suite]) return new $bAxe6({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $eb493199f3c38dd2$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($kKD6q[suite]) return $9bOof.createDecipheriv(suite, key, iv);
    if ($ahfUu[suite]) return new $bAxe6({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $eb493199f3c38dd2$var$getCiphers() {
    return Object.keys($ahfUu).concat($9bOof.getCiphers());
}
$eb493199f3c38dd2$export$bdd223f16383713e = $eb493199f3c38dd2$export$26e5786e8ac8e530 = $eb493199f3c38dd2$var$createCipher;
$eb493199f3c38dd2$export$2f64596b8cbf08b4 = $eb493199f3c38dd2$export$20533d26f07f1ee0 = $eb493199f3c38dd2$var$createCipheriv;
$eb493199f3c38dd2$export$12ada9414fbc594c = $eb493199f3c38dd2$export$2ce6d8d0e8b04e1a = $eb493199f3c38dd2$var$createDecipher;
$eb493199f3c38dd2$export$36b6d6ef312eab39 = $eb493199f3c38dd2$export$f5e7e39d57cd9700 = $eb493199f3c38dd2$var$createDecipheriv;
$eb493199f3c38dd2$export$dedd8dc3dc62b370 = $eb493199f3c38dd2$export$58a258485f1e49f6 = $eb493199f3c38dd2$var$getCiphers;

});
parcelRegister("bAxe6", function(module, exports) {

var $dXkiA = parcelRequire("dXkiA");

var $lPlS0 = parcelRequire("lPlS0");

var $aAKqs = parcelRequire("aAKqs");

var $h9jRt = parcelRequire("h9jRt");
var $86fcd4938b08467b$require$Buffer = $h9jRt.Buffer;
var $86fcd4938b08467b$var$modes = {
    'des-ede3-cbc': $lPlS0.CBC.instantiate($lPlS0.EDE),
    'des-ede3': $lPlS0.EDE,
    'des-ede-cbc': $lPlS0.CBC.instantiate($lPlS0.EDE),
    'des-ede': $lPlS0.EDE,
    'des-cbc': $lPlS0.CBC.instantiate($lPlS0.DES),
    'des-ecb': $lPlS0.DES
};
$86fcd4938b08467b$var$modes.des = $86fcd4938b08467b$var$modes['des-cbc'];
$86fcd4938b08467b$var$modes.des3 = $86fcd4938b08467b$var$modes['des-ede3-cbc'];
module.exports = $86fcd4938b08467b$var$DES;
$aAKqs($86fcd4938b08467b$var$DES, $dXkiA);
function $86fcd4938b08467b$var$DES(opts) {
    $dXkiA.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $86fcd4938b08467b$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$86fcd4938b08467b$require$Buffer.isBuffer(key)) key = $86fcd4938b08467b$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $86fcd4938b08467b$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$86fcd4938b08467b$require$Buffer.isBuffer(iv)) iv = $86fcd4938b08467b$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$86fcd4938b08467b$var$DES.prototype._update = function(data) {
    return $86fcd4938b08467b$require$Buffer.from(this._des.update(data));
};
$86fcd4938b08467b$var$DES.prototype._final = function() {
    return $86fcd4938b08467b$require$Buffer.from(this._des.final());
};

});
parcelRegister("lPlS0", function(module, exports) {

$parcel$export(module.exports, "DES", () => $fe3f535be3fc915d$export$cc8859615686b300, (v) => $fe3f535be3fc915d$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $fe3f535be3fc915d$export$8ad3f227af08fcc5, (v) => $fe3f535be3fc915d$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $fe3f535be3fc915d$export$947646e34766044f, (v) => $fe3f535be3fc915d$export$947646e34766044f = v);
var $fe3f535be3fc915d$export$eab97d15b1788b8d;
var $fe3f535be3fc915d$export$26e5786e8ac8e530;
var $fe3f535be3fc915d$export$cc8859615686b300;
var $fe3f535be3fc915d$export$8ad3f227af08fcc5;
var $fe3f535be3fc915d$export$947646e34766044f;
'use strict';

$fe3f535be3fc915d$export$eab97d15b1788b8d = (parcelRequire("1Hr71"));

$fe3f535be3fc915d$export$26e5786e8ac8e530 = (parcelRequire("6anJN"));

$fe3f535be3fc915d$export$cc8859615686b300 = (parcelRequire("e9gUr"));

$fe3f535be3fc915d$export$8ad3f227af08fcc5 = (parcelRequire("03nbN"));

$fe3f535be3fc915d$export$947646e34766044f = (parcelRequire("1qPgX"));

});
parcelRegister("1Hr71", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $13ced68b217bd270$export$cfaef8ed399428b0, (v) => $13ced68b217bd270$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $13ced68b217bd270$export$a80c7deaea7cbd80, (v) => $13ced68b217bd270$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $13ced68b217bd270$export$ed7577ae6e1cd0ef, (v) => $13ced68b217bd270$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $13ced68b217bd270$export$5dcbef3aa594f567, (v) => $13ced68b217bd270$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $13ced68b217bd270$export$5bc8001ca71ed9c5, (v) => $13ced68b217bd270$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $13ced68b217bd270$export$3e714e2c5d5d8cb2, (v) => $13ced68b217bd270$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $13ced68b217bd270$export$94c3e544fd062b7f, (v) => $13ced68b217bd270$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $13ced68b217bd270$export$9f77e0932fb78f72, (v) => $13ced68b217bd270$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $13ced68b217bd270$export$d865ce2836f5927f, (v) => $13ced68b217bd270$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $13ced68b217bd270$export$95e62ad65da8b7d2, (v) => $13ced68b217bd270$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $13ced68b217bd270$export$209139ff098c441a, (v) => $13ced68b217bd270$export$209139ff098c441a = v);
var $13ced68b217bd270$export$cfaef8ed399428b0;
var $13ced68b217bd270$export$a80c7deaea7cbd80;
var $13ced68b217bd270$export$ed7577ae6e1cd0ef;
var $13ced68b217bd270$export$5dcbef3aa594f567;
var $13ced68b217bd270$export$5bc8001ca71ed9c5;
var $13ced68b217bd270$export$3e714e2c5d5d8cb2;
var $13ced68b217bd270$export$94c3e544fd062b7f;
var $13ced68b217bd270$export$9f77e0932fb78f72;
var $13ced68b217bd270$export$d865ce2836f5927f;
var $13ced68b217bd270$export$95e62ad65da8b7d2;
var $13ced68b217bd270$export$209139ff098c441a;
'use strict';
$13ced68b217bd270$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$13ced68b217bd270$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$13ced68b217bd270$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$13ced68b217bd270$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$13ced68b217bd270$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$13ced68b217bd270$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $13ced68b217bd270$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$13ced68b217bd270$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $13ced68b217bd270$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $13ced68b217bd270$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $13ced68b217bd270$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $13ced68b217bd270$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$13ced68b217bd270$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $13ced68b217bd270$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$13ced68b217bd270$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $13ced68b217bd270$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $13ced68b217bd270$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $13ced68b217bd270$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$13ced68b217bd270$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $13ced68b217bd270$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $13ced68b217bd270$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$13ced68b217bd270$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("6anJN", function(module, exports) {
'use strict';

var $dEucY = parcelRequire("dEucY");
function $47d617099fc6bd78$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $47d617099fc6bd78$var$Cipher;
$47d617099fc6bd78$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$47d617099fc6bd78$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$47d617099fc6bd78$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$47d617099fc6bd78$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$47d617099fc6bd78$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$47d617099fc6bd78$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$47d617099fc6bd78$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$47d617099fc6bd78$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$47d617099fc6bd78$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$47d617099fc6bd78$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$47d617099fc6bd78$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $dEucY.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("dEucY", function(module, exports) {
module.exports = $9f06718617ea8664$var$assert;
function $9f06718617ea8664$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$9f06718617ea8664$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("e9gUr", function(module, exports) {
'use strict';

var $dEucY = parcelRequire("dEucY");

var $aAKqs = parcelRequire("aAKqs");

var $1Hr71 = parcelRequire("1Hr71");

var $6anJN = parcelRequire("6anJN");
function $a4cf05cbc811b64e$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $a4cf05cbc811b64e$var$DES(options) {
    $6anJN.call(this, options);
    var state = new $a4cf05cbc811b64e$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$aAKqs($a4cf05cbc811b64e$var$DES, $6anJN);
module.exports = $a4cf05cbc811b64e$var$DES;
$a4cf05cbc811b64e$var$DES.create = function create(options) {
    return new $a4cf05cbc811b64e$var$DES(options);
};
var $a4cf05cbc811b64e$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$a4cf05cbc811b64e$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $dEucY.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $1Hr71.readUInt32BE(key, 0);
    var kR = $1Hr71.readUInt32BE(key, 4);
    $1Hr71.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $a4cf05cbc811b64e$var$shiftTable[i >>> 1];
        kL = $1Hr71.r28shl(kL, shift);
        kR = $1Hr71.r28shl(kR, shift);
        $1Hr71.pc2(kL, kR, state.keys, i);
    }
};
$a4cf05cbc811b64e$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $1Hr71.readUInt32BE(inp, inOff);
    var r = $1Hr71.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $1Hr71.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $1Hr71.writeUInt32BE(out, l, outOff);
    $1Hr71.writeUInt32BE(out, r, outOff + 4);
};
$a4cf05cbc811b64e$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$a4cf05cbc811b64e$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$dEucY.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$a4cf05cbc811b64e$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $1Hr71.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $1Hr71.substitute(keyL, keyR);
        var f = $1Hr71.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $1Hr71.rip(r, l, out, off);
};
$a4cf05cbc811b64e$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $1Hr71.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $1Hr71.substitute(keyL, keyR);
        var f = $1Hr71.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $1Hr71.rip(l, r, out, off);
};

});

parcelRegister("03nbN", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $00a244dc51865d22$export$f9bb8d20ccc7477a, (v) => $00a244dc51865d22$export$f9bb8d20ccc7477a = v);
var $00a244dc51865d22$export$f9bb8d20ccc7477a;
'use strict';

var $dEucY = parcelRequire("dEucY");

var $aAKqs = parcelRequire("aAKqs");
var $00a244dc51865d22$var$proto = {};
function $00a244dc51865d22$var$CBCState(iv) {
    $dEucY.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $00a244dc51865d22$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $aAKqs(CBC, Base);
    var keys = Object.keys($00a244dc51865d22$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $00a244dc51865d22$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$00a244dc51865d22$export$f9bb8d20ccc7477a = $00a244dc51865d22$var$instantiate;
$00a244dc51865d22$var$proto._cbcInit = function _cbcInit() {
    var state = new $00a244dc51865d22$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$00a244dc51865d22$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("1qPgX", function(module, exports) {
'use strict';

var $dEucY = parcelRequire("dEucY");

var $aAKqs = parcelRequire("aAKqs");

var $6anJN = parcelRequire("6anJN");

var $e9gUr = parcelRequire("e9gUr");
function $10affdce245f59bd$var$EDEState(type, key) {
    $dEucY.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $e9gUr.create({
            type: 'encrypt',
            key: k1
        }),
        $e9gUr.create({
            type: 'decrypt',
            key: k2
        }),
        $e9gUr.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $e9gUr.create({
            type: 'decrypt',
            key: k3
        }),
        $e9gUr.create({
            type: 'encrypt',
            key: k2
        }),
        $e9gUr.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $10affdce245f59bd$var$EDE(options) {
    $6anJN.call(this, options);
    var state = new $10affdce245f59bd$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$aAKqs($10affdce245f59bd$var$EDE, $6anJN);
module.exports = $10affdce245f59bd$var$EDE;
$10affdce245f59bd$var$EDE.create = function create(options) {
    return new $10affdce245f59bd$var$EDE(options);
};
$10affdce245f59bd$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$10affdce245f59bd$var$EDE.prototype._pad = $e9gUr.prototype._pad;
$10affdce245f59bd$var$EDE.prototype._unpad = $e9gUr.prototype._unpad;

});



parcelRegister("9bOof", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $6b0c3a9587f856d7$export$2f64596b8cbf08b4, (v) => $6b0c3a9587f856d7$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $6b0c3a9587f856d7$export$36b6d6ef312eab39, (v) => $6b0c3a9587f856d7$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $6b0c3a9587f856d7$export$58a258485f1e49f6, (v) => $6b0c3a9587f856d7$export$58a258485f1e49f6 = v);
var $6b0c3a9587f856d7$export$bdd223f16383713e;
var $6b0c3a9587f856d7$export$26e5786e8ac8e530;
var $6b0c3a9587f856d7$export$2f64596b8cbf08b4;
var $6b0c3a9587f856d7$export$20533d26f07f1ee0;
var $6b0c3a9587f856d7$export$12ada9414fbc594c;
var $6b0c3a9587f856d7$export$2ce6d8d0e8b04e1a;
var $6b0c3a9587f856d7$export$36b6d6ef312eab39;
var $6b0c3a9587f856d7$export$f5e7e39d57cd9700;
var $6b0c3a9587f856d7$export$dedd8dc3dc62b370;
var $6b0c3a9587f856d7$export$58a258485f1e49f6;

var $7VKW7 = parcelRequire("7VKW7");

var $3onc7 = parcelRequire("3onc7");

var $4vkp9 = parcelRequire("4vkp9");
function $6b0c3a9587f856d7$var$getCiphers() {
    return Object.keys($4vkp9);
}
$6b0c3a9587f856d7$export$bdd223f16383713e = $6b0c3a9587f856d7$export$26e5786e8ac8e530 = $7VKW7.createCipher;
$6b0c3a9587f856d7$export$2f64596b8cbf08b4 = $6b0c3a9587f856d7$export$20533d26f07f1ee0 = $7VKW7.createCipheriv;
$6b0c3a9587f856d7$export$12ada9414fbc594c = $6b0c3a9587f856d7$export$2ce6d8d0e8b04e1a = $3onc7.createDecipher;
$6b0c3a9587f856d7$export$36b6d6ef312eab39 = $6b0c3a9587f856d7$export$f5e7e39d57cd9700 = $3onc7.createDecipheriv;
$6b0c3a9587f856d7$export$dedd8dc3dc62b370 = $6b0c3a9587f856d7$export$58a258485f1e49f6 = $6b0c3a9587f856d7$var$getCiphers;

});
parcelRegister("7VKW7", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5c6243dfdbdac085$export$2f64596b8cbf08b4, (v) => $5c6243dfdbdac085$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $5c6243dfdbdac085$export$bdd223f16383713e, (v) => $5c6243dfdbdac085$export$bdd223f16383713e = v);
var $5c6243dfdbdac085$export$2f64596b8cbf08b4;
var $5c6243dfdbdac085$export$bdd223f16383713e;

var $kKD6q = parcelRequire("kKD6q");

var $ft1yw = parcelRequire("ft1yw");

var $h9jRt = parcelRequire("h9jRt");
var $5c6243dfdbdac085$require$Buffer = $h9jRt.Buffer;

var $ll4Yn = parcelRequire("ll4Yn");

var $dXkiA = parcelRequire("dXkiA");

var $3h1Wg = parcelRequire("3h1Wg");

var $dIH6y = parcelRequire("dIH6y");

var $aAKqs = parcelRequire("aAKqs");
function $5c6243dfdbdac085$var$Cipher(mode, key, iv) {
    $dXkiA.call(this);
    this._cache = new $5c6243dfdbdac085$var$Splitter();
    this._cipher = new $3h1Wg.AES(key);
    this._prev = $5c6243dfdbdac085$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$aAKqs($5c6243dfdbdac085$var$Cipher, $dXkiA);
$5c6243dfdbdac085$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $5c6243dfdbdac085$require$Buffer.concat(out);
};
var $5c6243dfdbdac085$var$PADDING = $5c6243dfdbdac085$require$Buffer.alloc(16, 0x10);
$5c6243dfdbdac085$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($5c6243dfdbdac085$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$5c6243dfdbdac085$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $5c6243dfdbdac085$var$Splitter() {
    this.cache = $5c6243dfdbdac085$require$Buffer.allocUnsafe(0);
}
$5c6243dfdbdac085$var$Splitter.prototype.add = function(data) {
    this.cache = $5c6243dfdbdac085$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$5c6243dfdbdac085$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$5c6243dfdbdac085$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $5c6243dfdbdac085$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $5c6243dfdbdac085$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $5c6243dfdbdac085$var$createCipheriv(suite, password, iv) {
    var config = $kKD6q[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $5c6243dfdbdac085$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $5c6243dfdbdac085$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $ll4Yn(config.module, password, iv);
    else if (config.type === 'auth') return new $ft1yw(config.module, password, iv);
    return new $5c6243dfdbdac085$var$Cipher(config.module, password, iv);
}
function $5c6243dfdbdac085$var$createCipher(suite, password) {
    var config = $kKD6q[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $dIH6y(password, false, config.key, config.iv);
    return $5c6243dfdbdac085$var$createCipheriv(suite, keys.key, keys.iv);
}
$5c6243dfdbdac085$export$2f64596b8cbf08b4 = $5c6243dfdbdac085$var$createCipheriv;
$5c6243dfdbdac085$export$bdd223f16383713e = $5c6243dfdbdac085$var$createCipher;

});
parcelRegister("kKD6q", function(module, exports) {








var $f1b66f7d84726b42$var$modeModules = {
    ECB: (parcelRequire("1mZHm")),
    CBC: (parcelRequire("eAnTz")),
    CFB: (parcelRequire("g5QcU")),
    CFB8: (parcelRequire("31zXI")),
    CFB1: (parcelRequire("7OGPj")),
    OFB: (parcelRequire("fIB7S")),
    CTR: (parcelRequire("iiv0O")),
    GCM: (parcelRequire("iiv0O"))
};

var $4vkp9 = parcelRequire("4vkp9");
for(var $f1b66f7d84726b42$var$key in $4vkp9)$4vkp9[$f1b66f7d84726b42$var$key].module = $f1b66f7d84726b42$var$modeModules[$4vkp9[$f1b66f7d84726b42$var$key].mode];
module.exports = $4vkp9;

});
parcelRegister("1mZHm", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $0ff7b4864d508954$export$5b0f6292f11d1d18, (v) => $0ff7b4864d508954$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $0ff7b4864d508954$export$e85a0c9a1067c5d3, (v) => $0ff7b4864d508954$export$e85a0c9a1067c5d3 = v);
var $0ff7b4864d508954$export$5b0f6292f11d1d18;
var $0ff7b4864d508954$export$e85a0c9a1067c5d3;
$0ff7b4864d508954$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$0ff7b4864d508954$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("eAnTz", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a9e6f6938c3cfaa9$export$5b0f6292f11d1d18, (v) => $a9e6f6938c3cfaa9$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $a9e6f6938c3cfaa9$export$e85a0c9a1067c5d3, (v) => $a9e6f6938c3cfaa9$export$e85a0c9a1067c5d3 = v);
var $a9e6f6938c3cfaa9$export$5b0f6292f11d1d18;
var $a9e6f6938c3cfaa9$export$e85a0c9a1067c5d3;

var $8KQ6Q = parcelRequire("8KQ6Q");
$a9e6f6938c3cfaa9$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $8KQ6Q(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$a9e6f6938c3cfaa9$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $8KQ6Q(out, pad);
};

});
parcelRegister("8KQ6Q", function(module, exports) {

var $dOfWq = parcelRequire("dOfWq");
var $65fb0a72ddb7b594$require$Buffer = $dOfWq.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $65fb0a72ddb7b594$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("g5QcU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $bb759c39f79ed6e2$export$5b0f6292f11d1d18, (v) => $bb759c39f79ed6e2$export$5b0f6292f11d1d18 = v);
var $bb759c39f79ed6e2$export$5b0f6292f11d1d18;

var $h9jRt = parcelRequire("h9jRt");
var $bb759c39f79ed6e2$require$Buffer = $h9jRt.Buffer;

var $8KQ6Q = parcelRequire("8KQ6Q");
function $bb759c39f79ed6e2$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $8KQ6Q(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $bb759c39f79ed6e2$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$bb759c39f79ed6e2$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $bb759c39f79ed6e2$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $bb759c39f79ed6e2$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $bb759c39f79ed6e2$require$Buffer.concat([
                out,
                $bb759c39f79ed6e2$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $bb759c39f79ed6e2$require$Buffer.concat([
                out,
                $bb759c39f79ed6e2$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("31zXI", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $233d5c6f79ea276d$export$5b0f6292f11d1d18, (v) => $233d5c6f79ea276d$export$5b0f6292f11d1d18 = v);
var $233d5c6f79ea276d$export$5b0f6292f11d1d18;

var $h9jRt = parcelRequire("h9jRt");
var $233d5c6f79ea276d$require$Buffer = $h9jRt.Buffer;
function $233d5c6f79ea276d$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $233d5c6f79ea276d$require$Buffer.concat([
        self._prev.slice(1),
        $233d5c6f79ea276d$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$233d5c6f79ea276d$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $233d5c6f79ea276d$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $233d5c6f79ea276d$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("7OGPj", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $5b0e6c5e02a51c69$export$5b0f6292f11d1d18, (v) => $5b0e6c5e02a51c69$export$5b0f6292f11d1d18 = v);
var $5b0e6c5e02a51c69$export$5b0f6292f11d1d18;

var $h9jRt = parcelRequire("h9jRt");
var $5b0e6c5e02a51c69$require$Buffer = $h9jRt.Buffer;
function $5b0e6c5e02a51c69$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $5b0e6c5e02a51c69$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $5b0e6c5e02a51c69$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $5b0e6c5e02a51c69$require$Buffer.allocUnsafe(buffer.length);
    buffer = $5b0e6c5e02a51c69$require$Buffer.concat([
        buffer,
        $5b0e6c5e02a51c69$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$5b0e6c5e02a51c69$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $5b0e6c5e02a51c69$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $5b0e6c5e02a51c69$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fIB7S", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b717c3896c09425a$export$5b0f6292f11d1d18, (v) => $b717c3896c09425a$export$5b0f6292f11d1d18 = v);
var $b717c3896c09425a$export$5b0f6292f11d1d18;

var $dOfWq = parcelRequire("dOfWq");
var $b717c3896c09425a$require$Buffer = $dOfWq.Buffer;

var $8KQ6Q = parcelRequire("8KQ6Q");
function $b717c3896c09425a$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b717c3896c09425a$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b717c3896c09425a$require$Buffer.concat([
        self._cache,
        $b717c3896c09425a$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $8KQ6Q(chunk, pad);
};

});

parcelRegister("iiv0O", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $d521f6c91a7d5f99$export$5b0f6292f11d1d18, (v) => $d521f6c91a7d5f99$export$5b0f6292f11d1d18 = v);
var $d521f6c91a7d5f99$export$5b0f6292f11d1d18;

var $8KQ6Q = parcelRequire("8KQ6Q");

var $h9jRt = parcelRequire("h9jRt");
var $d521f6c91a7d5f99$require$Buffer = $h9jRt.Buffer;

var $1YSHo = parcelRequire("1YSHo");
function $d521f6c91a7d5f99$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $1YSHo(self._prev);
    return out;
}
var $d521f6c91a7d5f99$var$blockSize = 16;
$d521f6c91a7d5f99$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $d521f6c91a7d5f99$var$blockSize);
    var start = self._cache.length;
    self._cache = $d521f6c91a7d5f99$require$Buffer.concat([
        self._cache,
        $d521f6c91a7d5f99$require$Buffer.allocUnsafe(chunkNum * $d521f6c91a7d5f99$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $d521f6c91a7d5f99$var$getBlock(self);
        var offset = start + i * $d521f6c91a7d5f99$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $8KQ6Q(chunk, pad);
};

});
parcelRegister("1YSHo", function(module, exports) {
function $1715d31e40e35f2a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $1715d31e40e35f2a$var$incr32;

});


parcelRegister("4vkp9", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("ft1yw", function(module, exports) {

var $3h1Wg = parcelRequire("3h1Wg");

var $h9jRt = parcelRequire("h9jRt");
var $b42ac566c97a3e6f$require$Buffer = $h9jRt.Buffer;

var $dXkiA = parcelRequire("dXkiA");

var $aAKqs = parcelRequire("aAKqs");

var $eENQx = parcelRequire("eENQx");

var $8KQ6Q = parcelRequire("8KQ6Q");

var $1YSHo = parcelRequire("1YSHo");
function $b42ac566c97a3e6f$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $b42ac566c97a3e6f$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $b42ac566c97a3e6f$require$Buffer.concat([
            iv,
            $b42ac566c97a3e6f$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $b42ac566c97a3e6f$require$Buffer.concat([
            iv,
            $b42ac566c97a3e6f$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $eENQx(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($b42ac566c97a3e6f$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($b42ac566c97a3e6f$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $b42ac566c97a3e6f$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $b42ac566c97a3e6f$require$Buffer.from(self._finID);
    $1YSHo(out);
    return out;
}
function $b42ac566c97a3e6f$var$StreamCipher(mode, key, iv, decrypt) {
    $dXkiA.call(this);
    var h = $b42ac566c97a3e6f$require$Buffer.alloc(4, 0);
    this._cipher = new $3h1Wg.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $eENQx(ck);
    iv = $b42ac566c97a3e6f$var$calcIv(this, iv, ck);
    this._prev = $b42ac566c97a3e6f$require$Buffer.from(iv);
    this._cache = $b42ac566c97a3e6f$require$Buffer.allocUnsafe(0);
    this._secCache = $b42ac566c97a3e6f$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$aAKqs($b42ac566c97a3e6f$var$StreamCipher, $dXkiA);
$b42ac566c97a3e6f$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $b42ac566c97a3e6f$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$b42ac566c97a3e6f$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $8KQ6Q(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $b42ac566c97a3e6f$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$b42ac566c97a3e6f$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$b42ac566c97a3e6f$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$b42ac566c97a3e6f$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$b42ac566c97a3e6f$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $b42ac566c97a3e6f$var$StreamCipher;

});
parcelRegister("3h1Wg", function(module, exports) {

$parcel$export(module.exports, "AES", () => $2624769d7a5b539e$export$b80fbe1c3a2b92b5, (v) => $2624769d7a5b539e$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $2624769d7a5b539e$export$b80fbe1c3a2b92b5;

var $h9jRt = parcelRequire("h9jRt");
var $2624769d7a5b539e$require$Buffer = $h9jRt.Buffer;
function $2624769d7a5b539e$var$asUInt32Array(buf) {
    if (!$2624769d7a5b539e$require$Buffer.isBuffer(buf)) buf = $2624769d7a5b539e$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $2624769d7a5b539e$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $2624769d7a5b539e$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $2624769d7a5b539e$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $2624769d7a5b539e$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $2624769d7a5b539e$var$AES(key) {
    this._key = $2624769d7a5b539e$var$asUInt32Array(key);
    this._reset();
}
$2624769d7a5b539e$var$AES.blockSize = 16;
$2624769d7a5b539e$var$AES.keySize = 32;
$2624769d7a5b539e$var$AES.prototype.blockSize = $2624769d7a5b539e$var$AES.blockSize;
$2624769d7a5b539e$var$AES.prototype.keySize = $2624769d7a5b539e$var$AES.keySize;
$2624769d7a5b539e$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $2624769d7a5b539e$var$G.SBOX[t >>> 24] << 24 | $2624769d7a5b539e$var$G.SBOX[t >>> 16 & 0xff] << 16 | $2624769d7a5b539e$var$G.SBOX[t >>> 8 & 0xff] << 8 | $2624769d7a5b539e$var$G.SBOX[t & 0xff];
            t ^= $2624769d7a5b539e$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $2624769d7a5b539e$var$G.SBOX[t >>> 24] << 24 | $2624769d7a5b539e$var$G.SBOX[t >>> 16 & 0xff] << 16 | $2624769d7a5b539e$var$G.SBOX[t >>> 8 & 0xff] << 8 | $2624769d7a5b539e$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $2624769d7a5b539e$var$G.INV_SUB_MIX[0][$2624769d7a5b539e$var$G.SBOX[tt >>> 24]] ^ $2624769d7a5b539e$var$G.INV_SUB_MIX[1][$2624769d7a5b539e$var$G.SBOX[tt >>> 16 & 0xff]] ^ $2624769d7a5b539e$var$G.INV_SUB_MIX[2][$2624769d7a5b539e$var$G.SBOX[tt >>> 8 & 0xff]] ^ $2624769d7a5b539e$var$G.INV_SUB_MIX[3][$2624769d7a5b539e$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$2624769d7a5b539e$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $2624769d7a5b539e$var$asUInt32Array(M);
    return $2624769d7a5b539e$var$cryptBlock(M, this._keySchedule, $2624769d7a5b539e$var$G.SUB_MIX, $2624769d7a5b539e$var$G.SBOX, this._nRounds);
};
$2624769d7a5b539e$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $2624769d7a5b539e$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$2624769d7a5b539e$var$AES.prototype.decryptBlock = function(M) {
    M = $2624769d7a5b539e$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $2624769d7a5b539e$var$cryptBlock(M, this._invKeySchedule, $2624769d7a5b539e$var$G.INV_SUB_MIX, $2624769d7a5b539e$var$G.INV_SBOX, this._nRounds);
    var buf = $2624769d7a5b539e$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$2624769d7a5b539e$var$AES.prototype.scrub = function() {
    $2624769d7a5b539e$var$scrubVec(this._keySchedule);
    $2624769d7a5b539e$var$scrubVec(this._invKeySchedule);
    $2624769d7a5b539e$var$scrubVec(this._key);
};
$2624769d7a5b539e$export$b80fbe1c3a2b92b5 = $2624769d7a5b539e$var$AES;

});

parcelRegister("eENQx", function(module, exports) {

var $h9jRt = parcelRequire("h9jRt");
var $aabb778e68daf957$require$Buffer = $h9jRt.Buffer;
var $aabb778e68daf957$var$ZEROES = $aabb778e68daf957$require$Buffer.alloc(16, 0);
function $aabb778e68daf957$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $aabb778e68daf957$var$fromArray(out) {
    var buf = $aabb778e68daf957$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $aabb778e68daf957$var$GHASH(key) {
    this.h = key;
    this.state = $aabb778e68daf957$require$Buffer.alloc(16, 0);
    this.cache = $aabb778e68daf957$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$aabb778e68daf957$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$aabb778e68daf957$var$GHASH.prototype._multiply = function() {
    var Vi = $aabb778e68daf957$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $aabb778e68daf957$var$fromArray(Zi);
};
$aabb778e68daf957$var$GHASH.prototype.update = function(buf) {
    this.cache = $aabb778e68daf957$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$aabb778e68daf957$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($aabb778e68daf957$require$Buffer.concat([
        this.cache,
        $aabb778e68daf957$var$ZEROES
    ], 16));
    this.ghash($aabb778e68daf957$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $aabb778e68daf957$var$GHASH;

});


parcelRegister("ll4Yn", function(module, exports) {

var $3h1Wg = parcelRequire("3h1Wg");

var $h9jRt = parcelRequire("h9jRt");
var $f88f6a9e683d70b0$require$Buffer = $h9jRt.Buffer;

var $dXkiA = parcelRequire("dXkiA");

var $aAKqs = parcelRequire("aAKqs");
function $f88f6a9e683d70b0$var$StreamCipher(mode, key, iv, decrypt) {
    $dXkiA.call(this);
    this._cipher = new $3h1Wg.AES(key);
    this._prev = $f88f6a9e683d70b0$require$Buffer.from(iv);
    this._cache = $f88f6a9e683d70b0$require$Buffer.allocUnsafe(0);
    this._secCache = $f88f6a9e683d70b0$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$aAKqs($f88f6a9e683d70b0$var$StreamCipher, $dXkiA);
$f88f6a9e683d70b0$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$f88f6a9e683d70b0$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $f88f6a9e683d70b0$var$StreamCipher;

});

parcelRegister("dIH6y", function(module, exports) {

var $h9jRt = parcelRequire("h9jRt");
var $9fd0d219f4224444$require$Buffer = $h9jRt.Buffer;

var $ix9Mi = parcelRequire("ix9Mi");
/* eslint-disable camelcase */ function $9fd0d219f4224444$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$9fd0d219f4224444$require$Buffer.isBuffer(password)) password = $9fd0d219f4224444$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$9fd0d219f4224444$require$Buffer.isBuffer(salt)) salt = $9fd0d219f4224444$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $9fd0d219f4224444$require$Buffer.alloc(keyLen);
    var iv = $9fd0d219f4224444$require$Buffer.alloc(ivLen || 0);
    var tmp = $9fd0d219f4224444$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $ix9Mi();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $9fd0d219f4224444$var$EVP_BytesToKey;

});


parcelRegister("3onc7", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $27859af23fa37284$export$12ada9414fbc594c, (v) => $27859af23fa37284$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $27859af23fa37284$export$36b6d6ef312eab39, (v) => $27859af23fa37284$export$36b6d6ef312eab39 = v);
var $27859af23fa37284$export$12ada9414fbc594c;
var $27859af23fa37284$export$36b6d6ef312eab39;

var $ft1yw = parcelRequire("ft1yw");

var $h9jRt = parcelRequire("h9jRt");
var $27859af23fa37284$require$Buffer = $h9jRt.Buffer;

var $kKD6q = parcelRequire("kKD6q");

var $ll4Yn = parcelRequire("ll4Yn");

var $dXkiA = parcelRequire("dXkiA");

var $3h1Wg = parcelRequire("3h1Wg");

var $dIH6y = parcelRequire("dIH6y");

var $aAKqs = parcelRequire("aAKqs");
function $27859af23fa37284$var$Decipher(mode, key, iv) {
    $dXkiA.call(this);
    this._cache = new $27859af23fa37284$var$Splitter();
    this._last = void 0;
    this._cipher = new $3h1Wg.AES(key);
    this._prev = $27859af23fa37284$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$aAKqs($27859af23fa37284$var$Decipher, $dXkiA);
$27859af23fa37284$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $27859af23fa37284$require$Buffer.concat(out);
};
$27859af23fa37284$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $27859af23fa37284$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$27859af23fa37284$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $27859af23fa37284$var$Splitter() {
    this.cache = $27859af23fa37284$require$Buffer.allocUnsafe(0);
}
$27859af23fa37284$var$Splitter.prototype.add = function(data) {
    this.cache = $27859af23fa37284$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$27859af23fa37284$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$27859af23fa37284$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $27859af23fa37284$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $27859af23fa37284$var$createDecipheriv(suite, password, iv) {
    var config = $kKD6q[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $27859af23fa37284$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $27859af23fa37284$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $ll4Yn(config.module, password, iv, true);
    else if (config.type === 'auth') return new $ft1yw(config.module, password, iv, true);
    return new $27859af23fa37284$var$Decipher(config.module, password, iv);
}
function $27859af23fa37284$var$createDecipher(suite, password) {
    var config = $kKD6q[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $dIH6y(password, false, config.key, config.iv);
    return $27859af23fa37284$var$createDecipheriv(suite, keys.key, keys.iv);
}
$27859af23fa37284$export$12ada9414fbc594c = $27859af23fa37284$var$createDecipher;
$27859af23fa37284$export$36b6d6ef312eab39 = $27859af23fa37284$var$createDecipheriv;

});


parcelRegister("ahfUu", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $77b7d55ad5445474$export$116f8a5cee447347, (v) => $77b7d55ad5445474$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $77b7d55ad5445474$export$7483c4066bfb7ae9, (v) => $77b7d55ad5445474$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $77b7d55ad5445474$export$e7a565d2e588bb06, (v) => $77b7d55ad5445474$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $77b7d55ad5445474$export$aaa2f54a426f3eb8, (v) => $77b7d55ad5445474$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $77b7d55ad5445474$export$eba20568dde4ada, (v) => $77b7d55ad5445474$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $77b7d55ad5445474$export$d3b5e5996938f5ae, (v) => $77b7d55ad5445474$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $77b7d55ad5445474$export$57c08356130bc99b, (v) => $77b7d55ad5445474$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $77b7d55ad5445474$export$c7169791d5c1e65d, (v) => $77b7d55ad5445474$export$c7169791d5c1e65d = v);
var $77b7d55ad5445474$export$116f8a5cee447347;
var $77b7d55ad5445474$export$7483c4066bfb7ae9;
var $77b7d55ad5445474$export$e7a565d2e588bb06;
var $77b7d55ad5445474$export$aaa2f54a426f3eb8;
var $77b7d55ad5445474$export$eba20568dde4ada;
var $77b7d55ad5445474$export$d3b5e5996938f5ae;
var $77b7d55ad5445474$export$57c08356130bc99b;
var $77b7d55ad5445474$export$c7169791d5c1e65d;
$77b7d55ad5445474$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$77b7d55ad5445474$export$7483c4066bfb7ae9 = $77b7d55ad5445474$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$77b7d55ad5445474$export$aaa2f54a426f3eb8 = $77b7d55ad5445474$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$77b7d55ad5445474$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$77b7d55ad5445474$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$77b7d55ad5445474$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("mDhOn", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $044087a035fdbda4$export$971862a2fcb1bb40, (v) => $044087a035fdbda4$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $044087a035fdbda4$export$c6ff6a88acbeaf40, (v) => $044087a035fdbda4$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $044087a035fdbda4$export$fdc27893e98845cc, (v) => $044087a035fdbda4$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $044087a035fdbda4$export$6671fb9a1323bed, (v) => $044087a035fdbda4$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $044087a035fdbda4$export$d74daf141a551db, (v) => $044087a035fdbda4$export$d74daf141a551db = v);
var $044087a035fdbda4$export$971862a2fcb1bb40;
var $044087a035fdbda4$export$c6ff6a88acbeaf40;
var $044087a035fdbda4$export$fdc27893e98845cc;
var $044087a035fdbda4$export$6671fb9a1323bed;
var $044087a035fdbda4$export$d74daf141a551db;

var $dOfWq = parcelRequire("dOfWq");
var $044087a035fdbda4$require$Buffer = $dOfWq.Buffer;

var $24RSa = parcelRequire("24RSa");

var $dsze4 = parcelRequire("dsze4");

var $Hey3m = parcelRequire("Hey3m");
function $044087a035fdbda4$var$getDiffieHellman(mod) {
    var prime = new $044087a035fdbda4$require$Buffer($dsze4[mod].prime, 'hex');
    var gen = new $044087a035fdbda4$require$Buffer($dsze4[mod].gen, 'hex');
    return new $Hey3m(prime, gen);
}
var $044087a035fdbda4$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $044087a035fdbda4$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($044087a035fdbda4$require$Buffer.isBuffer(enc) || $044087a035fdbda4$var$ENCODINGS[enc] === undefined) return $044087a035fdbda4$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $044087a035fdbda4$require$Buffer([
        2
    ]);
    if (!$044087a035fdbda4$require$Buffer.isBuffer(generator)) generator = new $044087a035fdbda4$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $Hey3m($24RSa(prime, generator), generator, true);
    if (!$044087a035fdbda4$require$Buffer.isBuffer(prime)) prime = new $044087a035fdbda4$require$Buffer(prime, enc);
    return new $Hey3m(prime, generator, true);
}
$044087a035fdbda4$export$971862a2fcb1bb40 = $044087a035fdbda4$export$c6ff6a88acbeaf40 = $044087a035fdbda4$export$fdc27893e98845cc = $044087a035fdbda4$var$getDiffieHellman;
$044087a035fdbda4$export$6671fb9a1323bed = $044087a035fdbda4$export$d74daf141a551db = $044087a035fdbda4$var$createDiffieHellman;

});
parcelRegister("24RSa", function(module, exports) {

var $dURpS = parcelRequire("dURpS");
module.exports = $1835be818639eba0$var$findPrime;
$1835be818639eba0$var$findPrime.simpleSieve = $1835be818639eba0$var$simpleSieve;
$1835be818639eba0$var$findPrime.fermatTest = $1835be818639eba0$var$fermatTest;

var $kdjxm = parcelRequire("kdjxm");
var $1835be818639eba0$var$TWENTYFOUR = new $kdjxm(24);

var $enj0w = parcelRequire("enj0w");
var $1835be818639eba0$var$millerRabin = new $enj0w();
var $1835be818639eba0$var$ONE = new $kdjxm(1);
var $1835be818639eba0$var$TWO = new $kdjxm(2);
var $1835be818639eba0$var$FIVE = new $kdjxm(5);
var $1835be818639eba0$var$SIXTEEN = new $kdjxm(16);
var $1835be818639eba0$var$EIGHT = new $kdjxm(8);
var $1835be818639eba0$var$TEN = new $kdjxm(10);
var $1835be818639eba0$var$THREE = new $kdjxm(3);
var $1835be818639eba0$var$SEVEN = new $kdjxm(7);
var $1835be818639eba0$var$ELEVEN = new $kdjxm(11);
var $1835be818639eba0$var$FOUR = new $kdjxm(4);
var $1835be818639eba0$var$TWELVE = new $kdjxm(12);
var $1835be818639eba0$var$primes = null;
function $1835be818639eba0$var$_getPrimes() {
    if ($1835be818639eba0$var$primes !== null) return $1835be818639eba0$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $1835be818639eba0$var$primes = res;
    return res;
}
function $1835be818639eba0$var$simpleSieve(p) {
    var primes = $1835be818639eba0$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $1835be818639eba0$var$fermatTest(p) {
    var red = $kdjxm.mont(p);
    return $1835be818639eba0$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $1835be818639eba0$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $kdjxm([
            0x8c,
            0x7b
        ]);
        else return new $kdjxm([
            0x8c,
            0x27
        ]);
    }
    gen = new $kdjxm(gen);
    var num, n2;
    while(true){
        num = new $kdjxm($dURpS(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($1835be818639eba0$var$ONE);
        if (!num.testn(1)) num.iadd($1835be818639eba0$var$TWO);
        if (!gen.cmp($1835be818639eba0$var$TWO)) while(num.mod($1835be818639eba0$var$TWENTYFOUR).cmp($1835be818639eba0$var$ELEVEN))num.iadd($1835be818639eba0$var$FOUR);
        else if (!gen.cmp($1835be818639eba0$var$FIVE)) while(num.mod($1835be818639eba0$var$TEN).cmp($1835be818639eba0$var$THREE))num.iadd($1835be818639eba0$var$FOUR);
        n2 = num.shrn(1);
        if ($1835be818639eba0$var$simpleSieve(n2) && $1835be818639eba0$var$simpleSieve(num) && $1835be818639eba0$var$fermatTest(n2) && $1835be818639eba0$var$fermatTest(num) && $1835be818639eba0$var$millerRabin.test(n2) && $1835be818639eba0$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("kdjxm", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("f8f1G")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("enj0w", function(module, exports) {

var $kdjxm = parcelRequire("kdjxm");

var $d6KgX = parcelRequire("d6KgX");
function $02b362ec01822ab9$var$MillerRabin(rand) {
    this.rand = rand || new $d6KgX.Rand();
}
module.exports = $02b362ec01822ab9$var$MillerRabin;
$02b362ec01822ab9$var$MillerRabin.create = function create(rand) {
    return new $02b362ec01822ab9$var$MillerRabin(rand);
};
$02b362ec01822ab9$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $kdjxm(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$02b362ec01822ab9$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$02b362ec01822ab9$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $kdjxm.mont(n);
    var rone = new $kdjxm(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $kdjxm(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$02b362ec01822ab9$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $kdjxm.mont(n);
    var rone = new $kdjxm(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $kdjxm(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("d6KgX", function(module, exports) {
var $98afbaab9e415c09$var$r;
module.exports = function rand(len) {
    if (!$98afbaab9e415c09$var$r) $98afbaab9e415c09$var$r = new $98afbaab9e415c09$var$Rand(null);
    return $98afbaab9e415c09$var$r.generate(len);
};
function $98afbaab9e415c09$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $98afbaab9e415c09$var$Rand;
$98afbaab9e415c09$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$98afbaab9e415c09$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $98afbaab9e415c09$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $98afbaab9e415c09$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $98afbaab9e415c09$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $98afbaab9e415c09$var$crypto = (parcelRequire("f8f1G"));
    if (typeof $98afbaab9e415c09$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $98afbaab9e415c09$var$Rand.prototype._rand = function _rand(n) {
        return $98afbaab9e415c09$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("dsze4", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("Hey3m", function(module, exports) {

var $dOfWq = parcelRequire("dOfWq");
var $081f4d3ec83fc63f$require$Buffer = $dOfWq.Buffer;

var $kdjxm = parcelRequire("kdjxm");

var $enj0w = parcelRequire("enj0w");
var $081f4d3ec83fc63f$var$millerRabin = new $enj0w();
var $081f4d3ec83fc63f$var$TWENTYFOUR = new $kdjxm(24);
var $081f4d3ec83fc63f$var$ELEVEN = new $kdjxm(11);
var $081f4d3ec83fc63f$var$TEN = new $kdjxm(10);
var $081f4d3ec83fc63f$var$THREE = new $kdjxm(3);
var $081f4d3ec83fc63f$var$SEVEN = new $kdjxm(7);

var $24RSa = parcelRequire("24RSa");

var $dURpS = parcelRequire("dURpS");
module.exports = $081f4d3ec83fc63f$var$DH;
function $081f4d3ec83fc63f$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$081f4d3ec83fc63f$require$Buffer.isBuffer(pub)) pub = new $081f4d3ec83fc63f$require$Buffer(pub, enc);
    this._pub = new $kdjxm(pub);
    return this;
}
function $081f4d3ec83fc63f$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$081f4d3ec83fc63f$require$Buffer.isBuffer(priv)) priv = new $081f4d3ec83fc63f$require$Buffer(priv, enc);
    this._priv = new $kdjxm(priv);
    return this;
}
var $081f4d3ec83fc63f$var$primeCache = {};
function $081f4d3ec83fc63f$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $081f4d3ec83fc63f$var$primeCache) return $081f4d3ec83fc63f$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$24RSa.simpleSieve || !$24RSa.fermatTest(prime) || !$081f4d3ec83fc63f$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $081f4d3ec83fc63f$var$primeCache[hex] = error;
        return error;
    }
    if (!$081f4d3ec83fc63f$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($081f4d3ec83fc63f$var$TWENTYFOUR).cmp($081f4d3ec83fc63f$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($081f4d3ec83fc63f$var$TEN);
            if (rem.cmp($081f4d3ec83fc63f$var$THREE) && rem.cmp($081f4d3ec83fc63f$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $081f4d3ec83fc63f$var$primeCache[hex] = error;
    return error;
}
function $081f4d3ec83fc63f$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $kdjxm(prime);
    this._prime = $kdjxm.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $081f4d3ec83fc63f$var$setPublicKey;
        this.setPrivateKey = $081f4d3ec83fc63f$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($081f4d3ec83fc63f$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $081f4d3ec83fc63f$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$081f4d3ec83fc63f$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $kdjxm($dURpS(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$081f4d3ec83fc63f$var$DH.prototype.computeSecret = function(other) {
    other = new $kdjxm(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $081f4d3ec83fc63f$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $081f4d3ec83fc63f$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $081f4d3ec83fc63f$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$081f4d3ec83fc63f$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $081f4d3ec83fc63f$var$formatReturnValue(this._pub, enc);
};
$081f4d3ec83fc63f$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $081f4d3ec83fc63f$var$formatReturnValue(this._priv, enc);
};
$081f4d3ec83fc63f$var$DH.prototype.getPrime = function(enc) {
    return $081f4d3ec83fc63f$var$formatReturnValue(this.__prime, enc);
};
$081f4d3ec83fc63f$var$DH.prototype.getGenerator = function(enc) {
    return $081f4d3ec83fc63f$var$formatReturnValue(this._gen, enc);
};
$081f4d3ec83fc63f$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$081f4d3ec83fc63f$require$Buffer.isBuffer(gen)) gen = new $081f4d3ec83fc63f$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $kdjxm(gen);
    return this;
};
function $081f4d3ec83fc63f$var$formatReturnValue(bn, enc) {
    var buf = new $081f4d3ec83fc63f$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("fv3p0", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $b48c63e90d79cc2c$require$Buffer = $h9jRt.Buffer;

var $fsXMV = parcelRequire("fsXMV");

var $ku6az = parcelRequire("ku6az");

var $aAKqs = parcelRequire("aAKqs");

var $7UoX8 = parcelRequire("7UoX8");

var $5hZOO = parcelRequire("5hZOO");

var $5oTjV = parcelRequire("5oTjV");
Object.keys($5oTjV).forEach(function(key) {
    $5oTjV[key].id = $b48c63e90d79cc2c$require$Buffer.from($5oTjV[key].id, 'hex');
    $5oTjV[key.toLowerCase()] = $5oTjV[key];
});
function $b48c63e90d79cc2c$var$Sign(algorithm) {
    $ku6az.Writable.call(this);
    var data = $5oTjV[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $fsXMV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$aAKqs($b48c63e90d79cc2c$var$Sign, $ku6az.Writable);
$b48c63e90d79cc2c$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$b48c63e90d79cc2c$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $b48c63e90d79cc2c$require$Buffer.from(data, enc) : data);
    return this;
};
$b48c63e90d79cc2c$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $7UoX8(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $b48c63e90d79cc2c$var$Verify(algorithm) {
    $ku6az.Writable.call(this);
    var data = $5oTjV[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $fsXMV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$aAKqs($b48c63e90d79cc2c$var$Verify, $ku6az.Writable);
$b48c63e90d79cc2c$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$b48c63e90d79cc2c$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $b48c63e90d79cc2c$require$Buffer.from(data, enc) : data);
    return this;
};
$b48c63e90d79cc2c$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $b48c63e90d79cc2c$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $5hZOO(sigBuffer, hash, key, this._signType, this._tag);
};
function $b48c63e90d79cc2c$var$createSign(algorithm) {
    return new $b48c63e90d79cc2c$var$Sign(algorithm);
}
function $b48c63e90d79cc2c$var$createVerify(algorithm) {
    return new $b48c63e90d79cc2c$var$Verify(algorithm);
}
module.exports = {
    Sign: $b48c63e90d79cc2c$var$createSign,
    Verify: $b48c63e90d79cc2c$var$createVerify,
    createSign: $b48c63e90d79cc2c$var$createSign,
    createVerify: $b48c63e90d79cc2c$var$createVerify
};

});
parcelRegister("7UoX8", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $5c211e7e92b1785d$require$Buffer = $h9jRt.Buffer;

var $fRs08 = parcelRequire("fRs08");

var $foGXy = parcelRequire("foGXy");

var $iTT5q = parcelRequire("iTT5q");
var $5c211e7e92b1785d$require$EC = $iTT5q.ec;

var $dwHZ9 = parcelRequire("dwHZ9");

var $3PDZy = parcelRequire("3PDZy");

var $4qrU8 = parcelRequire("4qrU8");
var $5c211e7e92b1785d$var$RSA_PKCS1_PADDING = 1;
function $5c211e7e92b1785d$var$sign(hash, key, hashType, signType, tag) {
    var priv = $3PDZy(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $5c211e7e92b1785d$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $5c211e7e92b1785d$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $5c211e7e92b1785d$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $5c211e7e92b1785d$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $foGXy(pad, priv);
    return out;
}
function $5c211e7e92b1785d$var$ecSign(hash, priv) {
    var curveId = $4qrU8[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $5c211e7e92b1785d$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $5c211e7e92b1785d$require$Buffer.from(out.toDER());
}
function $5c211e7e92b1785d$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dwHZ9(0);
    var k;
    var H = $5c211e7e92b1785d$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $5c211e7e92b1785d$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $5c211e7e92b1785d$var$makeKey(q, kv, algo);
        r = $5c211e7e92b1785d$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dwHZ9(0);
        }
    }
    return $5c211e7e92b1785d$var$toDER(r, s);
}
function $5c211e7e92b1785d$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $5c211e7e92b1785d$require$Buffer.from(res);
}
function $5c211e7e92b1785d$var$getKey(x, q, hash, algo) {
    x = $5c211e7e92b1785d$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $5c211e7e92b1785d$require$Buffer.alloc(q.byteLength() - x.length);
        x = $5c211e7e92b1785d$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $5c211e7e92b1785d$var$bits2octets(hash, q);
    var v = $5c211e7e92b1785d$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $5c211e7e92b1785d$require$Buffer.alloc(hlen);
    k = $fRs08(algo, k).update(v).update($5c211e7e92b1785d$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $fRs08(algo, k).update(v).digest();
    k = $fRs08(algo, k).update(v).update($5c211e7e92b1785d$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $fRs08(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $5c211e7e92b1785d$var$bits2int(obits, q) {
    var bits = new $dwHZ9(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $5c211e7e92b1785d$var$bits2octets(bits, q) {
    bits = $5c211e7e92b1785d$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $5c211e7e92b1785d$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $5c211e7e92b1785d$require$Buffer.alloc(q.byteLength() - out.length);
        out = $5c211e7e92b1785d$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $5c211e7e92b1785d$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $5c211e7e92b1785d$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $fRs08(algo, kv.k).update(kv.v).digest();
            t = $5c211e7e92b1785d$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $5c211e7e92b1785d$var$bits2int(t, q);
        kv.k = $fRs08(algo, kv.k).update(kv.v).update($5c211e7e92b1785d$require$Buffer.from([
            0
        ])).digest();
        kv.v = $fRs08(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $5c211e7e92b1785d$var$makeR(g, k, p, q) {
    return g.toRed($dwHZ9.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $5c211e7e92b1785d$var$sign;
module.exports.getKey = $5c211e7e92b1785d$var$getKey;
module.exports.makeKey = $5c211e7e92b1785d$var$makeKey;

});
parcelRegister("foGXy", function(module, exports) {
'use strict';

var $3KFH2 = parcelRequire("3KFH2");

var $dURpS = parcelRequire("dURpS");

var $h9jRt = parcelRequire("h9jRt");
var $b35a6bcb7f95c60b$require$Buffer = $h9jRt.Buffer;
function $b35a6bcb7f95c60b$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $3KFH2($dURpS(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $b35a6bcb7f95c60b$var$blind(priv) {
    var r = $b35a6bcb7f95c60b$var$getr(priv);
    var blinder = r.toRed($3KFH2.mont(priv.modulus)).redPow(new $3KFH2(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $b35a6bcb7f95c60b$var$crt(msg, priv) {
    var blinds = $b35a6bcb7f95c60b$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $3KFH2(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($3KFH2.mont(priv.prime1));
    var c2 = blinded.toRed($3KFH2.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($b35a6bcb7f95c60b$require$Buffer, 'be', len);
}
$b35a6bcb7f95c60b$var$crt.getr = $b35a6bcb7f95c60b$var$getr;
module.exports = $b35a6bcb7f95c60b$var$crt;

});
parcelRegister("3KFH2", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("f8f1G")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("iTT5q", function(module, exports) {
'use strict';
var $dc2818181cfedc60$var$elliptic = module.exports;

$dc2818181cfedc60$var$elliptic.version = (parcelRequire("IqZZd")).version;

$dc2818181cfedc60$var$elliptic.utils = (parcelRequire("cyfvl"));

$dc2818181cfedc60$var$elliptic.rand = (parcelRequire("d6KgX"));

$dc2818181cfedc60$var$elliptic.curve = (parcelRequire("4Ncqt"));

$dc2818181cfedc60$var$elliptic.curves = (parcelRequire("8hVoE"));

// Protocols
$dc2818181cfedc60$var$elliptic.ec = (parcelRequire("aVb8k"));

$dc2818181cfedc60$var$elliptic.eddsa = (parcelRequire("8Yrev"));

});
parcelRegister("IqZZd", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("cyfvl", function(module, exports) {
'use strict';
var $9234afe743d229c8$var$utils = module.exports;

var $kdjxm = parcelRequire("kdjxm");

var $dEucY = parcelRequire("dEucY");

var $9Fy2H = parcelRequire("9Fy2H");
$9234afe743d229c8$var$utils.assert = $dEucY;
$9234afe743d229c8$var$utils.toArray = $9Fy2H.toArray;
$9234afe743d229c8$var$utils.zero2 = $9Fy2H.zero2;
$9234afe743d229c8$var$utils.toHex = $9Fy2H.toHex;
$9234afe743d229c8$var$utils.encode = $9Fy2H.encode;
// Represent num in a w-NAF form
function $9234afe743d229c8$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$9234afe743d229c8$var$utils.getNAF = $9234afe743d229c8$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $9234afe743d229c8$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$9234afe743d229c8$var$utils.getJSF = $9234afe743d229c8$var$getJSF;
function $9234afe743d229c8$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$9234afe743d229c8$var$utils.cachedProperty = $9234afe743d229c8$var$cachedProperty;
function $9234afe743d229c8$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $9234afe743d229c8$var$utils.toArray(bytes, 'hex') : bytes;
}
$9234afe743d229c8$var$utils.parseBytes = $9234afe743d229c8$var$parseBytes;
function $9234afe743d229c8$var$intFromLE(bytes) {
    return new $kdjxm(bytes, 'hex', 'le');
}
$9234afe743d229c8$var$utils.intFromLE = $9234afe743d229c8$var$intFromLE;

});
parcelRegister("9Fy2H", function(module, exports) {
'use strict';
var $70a25983f7deb312$var$utils = module.exports;
function $70a25983f7deb312$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$70a25983f7deb312$var$utils.toArray = $70a25983f7deb312$var$toArray;
function $70a25983f7deb312$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$70a25983f7deb312$var$utils.zero2 = $70a25983f7deb312$var$zero2;
function $70a25983f7deb312$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $70a25983f7deb312$var$zero2(msg[i].toString(16));
    return res;
}
$70a25983f7deb312$var$utils.toHex = $70a25983f7deb312$var$toHex;
$70a25983f7deb312$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $70a25983f7deb312$var$toHex(arr);
    else return arr;
};

});


parcelRegister("4Ncqt", function(module, exports) {
'use strict';
var $37d56097a0573fc4$var$curve = module.exports;

$37d56097a0573fc4$var$curve.base = (parcelRequire("6xVJj"));

$37d56097a0573fc4$var$curve.short = (parcelRequire("6V4QZ"));

$37d56097a0573fc4$var$curve.mont = (parcelRequire("iqPAI"));

$37d56097a0573fc4$var$curve.edwards = (parcelRequire("gxoTX"));

});
parcelRegister("6xVJj", function(module, exports) {
'use strict';

var $kdjxm = parcelRequire("kdjxm");

var $cyfvl = parcelRequire("cyfvl");
var $4c429b18b8f98a27$var$getNAF = $cyfvl.getNAF;
var $4c429b18b8f98a27$var$getJSF = $cyfvl.getJSF;
var $4c429b18b8f98a27$var$assert = $cyfvl.assert;
function $4c429b18b8f98a27$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $kdjxm(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $kdjxm.red(conf.prime) : $kdjxm.mont(this.p);
    // Useful for many curves
    this.zero = new $kdjxm(0).toRed(this.red);
    this.one = new $kdjxm(1).toRed(this.red);
    this.two = new $kdjxm(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $kdjxm(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $4c429b18b8f98a27$var$BaseCurve;
$4c429b18b8f98a27$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$4c429b18b8f98a27$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$4c429b18b8f98a27$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $4c429b18b8f98a27$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $4c429b18b8f98a27$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$4c429b18b8f98a27$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $4c429b18b8f98a27$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $4c429b18b8f98a27$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$4c429b18b8f98a27$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $4c429b18b8f98a27$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $4c429b18b8f98a27$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $4c429b18b8f98a27$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $4c429b18b8f98a27$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$4c429b18b8f98a27$var$BaseCurve.BasePoint = $4c429b18b8f98a27$var$BasePoint;
$4c429b18b8f98a27$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$4c429b18b8f98a27$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$4c429b18b8f98a27$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $cyfvl.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $4c429b18b8f98a27$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $4c429b18b8f98a27$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$4c429b18b8f98a27$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$4c429b18b8f98a27$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$4c429b18b8f98a27$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $cyfvl.encode(this._encode(compact), enc);
};
$4c429b18b8f98a27$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$4c429b18b8f98a27$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$4c429b18b8f98a27$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$4c429b18b8f98a27$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$4c429b18b8f98a27$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$4c429b18b8f98a27$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("6V4QZ", function(module, exports) {
'use strict';

var $cyfvl = parcelRequire("cyfvl");

var $kdjxm = parcelRequire("kdjxm");

var $aAKqs = parcelRequire("aAKqs");

var $6xVJj = parcelRequire("6xVJj");
var $509bd4c8a2317c16$var$assert = $cyfvl.assert;
function $509bd4c8a2317c16$var$ShortCurve(conf) {
    $6xVJj.call(this, 'short', conf);
    this.a = new $kdjxm(conf.a, 16).toRed(this.red);
    this.b = new $kdjxm(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$aAKqs($509bd4c8a2317c16$var$ShortCurve, $6xVJj);
module.exports = $509bd4c8a2317c16$var$ShortCurve;
$509bd4c8a2317c16$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $kdjxm(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $kdjxm(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $509bd4c8a2317c16$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $kdjxm(vec.a, 16),
            b: new $kdjxm(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$509bd4c8a2317c16$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $kdjxm.mont(num);
    var tinv = new $kdjxm(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $kdjxm(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$509bd4c8a2317c16$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $kdjxm(1);
    var y1 = new $kdjxm(0);
    var x2 = new $kdjxm(0);
    var y2 = new $kdjxm(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$509bd4c8a2317c16$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$509bd4c8a2317c16$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $kdjxm(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$509bd4c8a2317c16$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$509bd4c8a2317c16$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $509bd4c8a2317c16$var$Point(curve, x, y, isRed) {
    $6xVJj.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $kdjxm(x, 16);
        this.y = new $kdjxm(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$aAKqs($509bd4c8a2317c16$var$Point, $6xVJj.BasePoint);
$509bd4c8a2317c16$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $509bd4c8a2317c16$var$Point(this, x, y, isRed);
};
$509bd4c8a2317c16$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $509bd4c8a2317c16$var$Point.fromJSON(this, obj, red);
};
$509bd4c8a2317c16$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$509bd4c8a2317c16$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$509bd4c8a2317c16$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$509bd4c8a2317c16$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$509bd4c8a2317c16$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$509bd4c8a2317c16$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$509bd4c8a2317c16$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$509bd4c8a2317c16$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$509bd4c8a2317c16$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$509bd4c8a2317c16$var$Point.prototype.mul = function mul(k) {
    k = new $kdjxm(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$509bd4c8a2317c16$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$509bd4c8a2317c16$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$509bd4c8a2317c16$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$509bd4c8a2317c16$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$509bd4c8a2317c16$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $509bd4c8a2317c16$var$JPoint(curve, x, y, z) {
    $6xVJj.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $kdjxm(0);
    } else {
        this.x = new $kdjxm(x, 16);
        this.y = new $kdjxm(y, 16);
        this.z = new $kdjxm(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$aAKqs($509bd4c8a2317c16$var$JPoint, $6xVJj.BasePoint);
$509bd4c8a2317c16$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $509bd4c8a2317c16$var$JPoint(this, x, y, z);
};
$509bd4c8a2317c16$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$509bd4c8a2317c16$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$509bd4c8a2317c16$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$509bd4c8a2317c16$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$509bd4c8a2317c16$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$509bd4c8a2317c16$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$509bd4c8a2317c16$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$509bd4c8a2317c16$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$509bd4c8a2317c16$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$509bd4c8a2317c16$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$509bd4c8a2317c16$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $kdjxm(k, kbase);
    return this.curve._wnafMul(this, k);
};
$509bd4c8a2317c16$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$509bd4c8a2317c16$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$509bd4c8a2317c16$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$509bd4c8a2317c16$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("iqPAI", function(module, exports) {
'use strict';

var $kdjxm = parcelRequire("kdjxm");

var $aAKqs = parcelRequire("aAKqs");

var $6xVJj = parcelRequire("6xVJj");

var $cyfvl = parcelRequire("cyfvl");
function $d6b2aca9a4b5539f$var$MontCurve(conf) {
    $6xVJj.call(this, 'mont', conf);
    this.a = new $kdjxm(conf.a, 16).toRed(this.red);
    this.b = new $kdjxm(conf.b, 16).toRed(this.red);
    this.i4 = new $kdjxm(4).toRed(this.red).redInvm();
    this.two = new $kdjxm(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$aAKqs($d6b2aca9a4b5539f$var$MontCurve, $6xVJj);
module.exports = $d6b2aca9a4b5539f$var$MontCurve;
$d6b2aca9a4b5539f$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $d6b2aca9a4b5539f$var$Point(curve, x, z) {
    $6xVJj.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $kdjxm(x, 16);
        this.z = new $kdjxm(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$aAKqs($d6b2aca9a4b5539f$var$Point, $6xVJj.BasePoint);
$d6b2aca9a4b5539f$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($cyfvl.toArray(bytes, enc), 1);
};
$d6b2aca9a4b5539f$var$MontCurve.prototype.point = function point(x, z) {
    return new $d6b2aca9a4b5539f$var$Point(this, x, z);
};
$d6b2aca9a4b5539f$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $d6b2aca9a4b5539f$var$Point.fromJSON(this, obj);
};
$d6b2aca9a4b5539f$var$Point.prototype.precompute = function precompute() {
// No-op
};
$d6b2aca9a4b5539f$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$d6b2aca9a4b5539f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $d6b2aca9a4b5539f$var$Point(curve, obj[0], obj[1] || curve.one);
};
$d6b2aca9a4b5539f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$d6b2aca9a4b5539f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$d6b2aca9a4b5539f$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$d6b2aca9a4b5539f$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$d6b2aca9a4b5539f$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$d6b2aca9a4b5539f$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$d6b2aca9a4b5539f$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$d6b2aca9a4b5539f$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$d6b2aca9a4b5539f$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$d6b2aca9a4b5539f$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$d6b2aca9a4b5539f$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("gxoTX", function(module, exports) {
'use strict';

var $cyfvl = parcelRequire("cyfvl");

var $kdjxm = parcelRequire("kdjxm");

var $aAKqs = parcelRequire("aAKqs");

var $6xVJj = parcelRequire("6xVJj");
var $c0a30b52c02a4564$var$assert = $cyfvl.assert;
function $c0a30b52c02a4564$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $6xVJj.call(this, 'edwards', conf);
    this.a = new $kdjxm(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $kdjxm(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $kdjxm(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $c0a30b52c02a4564$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$aAKqs($c0a30b52c02a4564$var$EdwardsCurve, $6xVJj);
module.exports = $c0a30b52c02a4564$var$EdwardsCurve;
$c0a30b52c02a4564$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$c0a30b52c02a4564$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$c0a30b52c02a4564$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$c0a30b52c02a4564$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $kdjxm(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$c0a30b52c02a4564$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $kdjxm(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$c0a30b52c02a4564$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $c0a30b52c02a4564$var$Point(curve, x, y, z, t) {
    $6xVJj.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $kdjxm(x, 16);
        this.y = new $kdjxm(y, 16);
        this.z = z ? new $kdjxm(z, 16) : this.curve.one;
        this.t = t && new $kdjxm(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$aAKqs($c0a30b52c02a4564$var$Point, $6xVJj.BasePoint);
$c0a30b52c02a4564$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $c0a30b52c02a4564$var$Point.fromJSON(this, obj);
};
$c0a30b52c02a4564$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $c0a30b52c02a4564$var$Point(this, x, y, z, t);
};
$c0a30b52c02a4564$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $c0a30b52c02a4564$var$Point(curve, obj[0], obj[1], obj[2]);
};
$c0a30b52c02a4564$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$c0a30b52c02a4564$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$c0a30b52c02a4564$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$c0a30b52c02a4564$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$c0a30b52c02a4564$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$c0a30b52c02a4564$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$c0a30b52c02a4564$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$c0a30b52c02a4564$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$c0a30b52c02a4564$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$c0a30b52c02a4564$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$c0a30b52c02a4564$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$c0a30b52c02a4564$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$c0a30b52c02a4564$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$c0a30b52c02a4564$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$c0a30b52c02a4564$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$c0a30b52c02a4564$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$c0a30b52c02a4564$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$c0a30b52c02a4564$var$Point.prototype.toP = $c0a30b52c02a4564$var$Point.prototype.normalize;
$c0a30b52c02a4564$var$Point.prototype.mixedAdd = $c0a30b52c02a4564$var$Point.prototype.add;

});


parcelRegister("8hVoE", function(module, exports) {
'use strict';
var $608c6f03be1f5573$var$curves = module.exports;

var $noTgJ = parcelRequire("noTgJ");

var $4Ncqt = parcelRequire("4Ncqt");

var $cyfvl = parcelRequire("cyfvl");
var $608c6f03be1f5573$var$assert = $cyfvl.assert;
function $608c6f03be1f5573$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $4Ncqt.short(options);
    else if (options.type === 'edwards') this.curve = new $4Ncqt.edwards(options);
    else this.curve = new $4Ncqt.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $608c6f03be1f5573$var$assert(this.g.validate(), 'Invalid curve');
    $608c6f03be1f5573$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$608c6f03be1f5573$var$curves.PresetCurve = $608c6f03be1f5573$var$PresetCurve;
function $608c6f03be1f5573$var$defineCurve(name, options) {
    Object.defineProperty($608c6f03be1f5573$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $608c6f03be1f5573$var$PresetCurve(options);
            Object.defineProperty($608c6f03be1f5573$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$608c6f03be1f5573$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $noTgJ.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$608c6f03be1f5573$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $noTgJ.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$608c6f03be1f5573$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $noTgJ.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$608c6f03be1f5573$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $noTgJ.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$608c6f03be1f5573$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $noTgJ.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$608c6f03be1f5573$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $noTgJ.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$608c6f03be1f5573$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $noTgJ.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $608c6f03be1f5573$var$pre;

try {
    $608c6f03be1f5573$var$pre = (parcelRequire("3eHX3"));
} catch (e) {
    $608c6f03be1f5573$var$pre = undefined;
}
$608c6f03be1f5573$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $noTgJ.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $608c6f03be1f5573$var$pre
    ]
});

});
parcelRegister("noTgJ", function(module, exports) {
var $046574d18a346980$var$hash = module.exports;

$046574d18a346980$var$hash.utils = (parcelRequire("1eUk6"));

$046574d18a346980$var$hash.common = (parcelRequire("eNhCM"));

$046574d18a346980$var$hash.sha = (parcelRequire("5sj5b"));

$046574d18a346980$var$hash.ripemd = (parcelRequire("8h454"));

$046574d18a346980$var$hash.hmac = (parcelRequire("hVvmf"));
// Proxy hash functions to the main object
$046574d18a346980$var$hash.sha1 = $046574d18a346980$var$hash.sha.sha1;
$046574d18a346980$var$hash.sha256 = $046574d18a346980$var$hash.sha.sha256;
$046574d18a346980$var$hash.sha224 = $046574d18a346980$var$hash.sha.sha224;
$046574d18a346980$var$hash.sha384 = $046574d18a346980$var$hash.sha.sha384;
$046574d18a346980$var$hash.sha512 = $046574d18a346980$var$hash.sha.sha512;
$046574d18a346980$var$hash.ripemd160 = $046574d18a346980$var$hash.ripemd.ripemd160;

});
parcelRegister("1eUk6", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $0e72c9da4bf587df$export$69f1b2dcda23c5f8, (v) => $0e72c9da4bf587df$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $0e72c9da4bf587df$export$45b10814cc054894, (v) => $0e72c9da4bf587df$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $0e72c9da4bf587df$export$7ea66e3774a60b67, (v) => $0e72c9da4bf587df$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $0e72c9da4bf587df$export$34a52f00f601f6f1, (v) => $0e72c9da4bf587df$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $0e72c9da4bf587df$export$812b0cbd5e8a72ab, (v) => $0e72c9da4bf587df$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $0e72c9da4bf587df$export$f24f9e11d63bb314, (v) => $0e72c9da4bf587df$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $0e72c9da4bf587df$export$b71357c7e07ca1f1, (v) => $0e72c9da4bf587df$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $0e72c9da4bf587df$export$2e58a4b541fdcbe8, (v) => $0e72c9da4bf587df$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $0e72c9da4bf587df$export$183b950bde9faab8, (v) => $0e72c9da4bf587df$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $0e72c9da4bf587df$export$4785c77169fea59e, (v) => $0e72c9da4bf587df$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $0e72c9da4bf587df$export$242a185dfcffac5b, (v) => $0e72c9da4bf587df$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $0e72c9da4bf587df$export$58c04ae0ae31877d, (v) => $0e72c9da4bf587df$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $0e72c9da4bf587df$export$d058ca695f8c6f11, (v) => $0e72c9da4bf587df$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $0e72c9da4bf587df$export$a1efd7fc3e986367, (v) => $0e72c9da4bf587df$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $0e72c9da4bf587df$export$bbfea4a2b5abaab4, (v) => $0e72c9da4bf587df$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $0e72c9da4bf587df$export$97ad4afc7de86152, (v) => $0e72c9da4bf587df$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $0e72c9da4bf587df$export$ce4673d9a79f6a4b, (v) => $0e72c9da4bf587df$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $0e72c9da4bf587df$export$786cc99fc6eedc0b, (v) => $0e72c9da4bf587df$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $0e72c9da4bf587df$export$45c59b9a1848dd0, (v) => $0e72c9da4bf587df$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $0e72c9da4bf587df$export$50d8f613e76d3034, (v) => $0e72c9da4bf587df$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $0e72c9da4bf587df$export$b8e83683c60ee162, (v) => $0e72c9da4bf587df$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $0e72c9da4bf587df$export$aeeb51790d1bcc4a, (v) => $0e72c9da4bf587df$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $0e72c9da4bf587df$export$bb7c616f719ad9c, (v) => $0e72c9da4bf587df$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $0e72c9da4bf587df$export$4d63290824f9d7df, (v) => $0e72c9da4bf587df$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $0e72c9da4bf587df$export$2f64ceb90ef28ea1, (v) => $0e72c9da4bf587df$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $0e72c9da4bf587df$export$8d2089d465f6d10d, (v) => $0e72c9da4bf587df$export$8d2089d465f6d10d = v);
var $0e72c9da4bf587df$export$69f1b2dcda23c5f8;
var $0e72c9da4bf587df$export$45b10814cc054894;
var $0e72c9da4bf587df$export$7ea66e3774a60b67;
var $0e72c9da4bf587df$export$34a52f00f601f6f1;
var $0e72c9da4bf587df$export$812b0cbd5e8a72ab;
var $0e72c9da4bf587df$export$f24f9e11d63bb314;
var $0e72c9da4bf587df$export$b71357c7e07ca1f1;
var $0e72c9da4bf587df$export$2e58a4b541fdcbe8;
var $0e72c9da4bf587df$export$183b950bde9faab8;
var $0e72c9da4bf587df$export$4785c77169fea59e;
var $0e72c9da4bf587df$export$242a185dfcffac5b;
var $0e72c9da4bf587df$export$58c04ae0ae31877d;
var $0e72c9da4bf587df$export$d058ca695f8c6f11;
var $0e72c9da4bf587df$export$a1efd7fc3e986367;
var $0e72c9da4bf587df$export$bbfea4a2b5abaab4;
var $0e72c9da4bf587df$export$97ad4afc7de86152;
var $0e72c9da4bf587df$export$ce4673d9a79f6a4b;
var $0e72c9da4bf587df$export$786cc99fc6eedc0b;
var $0e72c9da4bf587df$export$45c59b9a1848dd0;
var $0e72c9da4bf587df$export$50d8f613e76d3034;
var $0e72c9da4bf587df$export$b8e83683c60ee162;
var $0e72c9da4bf587df$export$aeeb51790d1bcc4a;
var $0e72c9da4bf587df$export$bb7c616f719ad9c;
var $0e72c9da4bf587df$export$4d63290824f9d7df;
var $0e72c9da4bf587df$export$2f64ceb90ef28ea1;
var $0e72c9da4bf587df$export$8d2089d465f6d10d;
'use strict';

var $dEucY = parcelRequire("dEucY");

var $aAKqs = parcelRequire("aAKqs");
$0e72c9da4bf587df$export$69f1b2dcda23c5f8 = $aAKqs;
function $0e72c9da4bf587df$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $0e72c9da4bf587df$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($0e72c9da4bf587df$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$0e72c9da4bf587df$export$45b10814cc054894 = $0e72c9da4bf587df$var$toArray;
function $0e72c9da4bf587df$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $0e72c9da4bf587df$var$zero2(msg[i].toString(16));
    return res;
}
$0e72c9da4bf587df$export$7ea66e3774a60b67 = $0e72c9da4bf587df$var$toHex;
function $0e72c9da4bf587df$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$0e72c9da4bf587df$export$34a52f00f601f6f1 = $0e72c9da4bf587df$var$htonl;
function $0e72c9da4bf587df$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $0e72c9da4bf587df$var$htonl(w);
        res += $0e72c9da4bf587df$var$zero8(w.toString(16));
    }
    return res;
}
$0e72c9da4bf587df$export$812b0cbd5e8a72ab = $0e72c9da4bf587df$var$toHex32;
function $0e72c9da4bf587df$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$0e72c9da4bf587df$export$f24f9e11d63bb314 = $0e72c9da4bf587df$var$zero2;
function $0e72c9da4bf587df$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$0e72c9da4bf587df$export$b71357c7e07ca1f1 = $0e72c9da4bf587df$var$zero8;
function $0e72c9da4bf587df$var$join32(msg, start, end, endian) {
    var len = end - start;
    $dEucY(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$0e72c9da4bf587df$export$2e58a4b541fdcbe8 = $0e72c9da4bf587df$var$join32;
function $0e72c9da4bf587df$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$0e72c9da4bf587df$export$183b950bde9faab8 = $0e72c9da4bf587df$var$split32;
function $0e72c9da4bf587df$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$0e72c9da4bf587df$export$4785c77169fea59e = $0e72c9da4bf587df$var$rotr32;
function $0e72c9da4bf587df$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$0e72c9da4bf587df$export$242a185dfcffac5b = $0e72c9da4bf587df$var$rotl32;
function $0e72c9da4bf587df$var$sum32(a, b) {
    return a + b >>> 0;
}
$0e72c9da4bf587df$export$58c04ae0ae31877d = $0e72c9da4bf587df$var$sum32;
function $0e72c9da4bf587df$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$0e72c9da4bf587df$export$d058ca695f8c6f11 = $0e72c9da4bf587df$var$sum32_3;
function $0e72c9da4bf587df$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$0e72c9da4bf587df$export$a1efd7fc3e986367 = $0e72c9da4bf587df$var$sum32_4;
function $0e72c9da4bf587df$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$0e72c9da4bf587df$export$bbfea4a2b5abaab4 = $0e72c9da4bf587df$var$sum32_5;
function $0e72c9da4bf587df$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$0e72c9da4bf587df$export$97ad4afc7de86152 = $0e72c9da4bf587df$var$sum64;
function $0e72c9da4bf587df$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$0e72c9da4bf587df$export$ce4673d9a79f6a4b = $0e72c9da4bf587df$var$sum64_hi;
function $0e72c9da4bf587df$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$0e72c9da4bf587df$export$786cc99fc6eedc0b = $0e72c9da4bf587df$var$sum64_lo;
function $0e72c9da4bf587df$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$0e72c9da4bf587df$export$45c59b9a1848dd0 = $0e72c9da4bf587df$var$sum64_4_hi;
function $0e72c9da4bf587df$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$0e72c9da4bf587df$export$50d8f613e76d3034 = $0e72c9da4bf587df$var$sum64_4_lo;
function $0e72c9da4bf587df$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$0e72c9da4bf587df$export$b8e83683c60ee162 = $0e72c9da4bf587df$var$sum64_5_hi;
function $0e72c9da4bf587df$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$0e72c9da4bf587df$export$aeeb51790d1bcc4a = $0e72c9da4bf587df$var$sum64_5_lo;
function $0e72c9da4bf587df$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$0e72c9da4bf587df$export$bb7c616f719ad9c = $0e72c9da4bf587df$var$rotr64_hi;
function $0e72c9da4bf587df$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$0e72c9da4bf587df$export$4d63290824f9d7df = $0e72c9da4bf587df$var$rotr64_lo;
function $0e72c9da4bf587df$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$0e72c9da4bf587df$export$2f64ceb90ef28ea1 = $0e72c9da4bf587df$var$shr64_hi;
function $0e72c9da4bf587df$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$0e72c9da4bf587df$export$8d2089d465f6d10d = $0e72c9da4bf587df$var$shr64_lo;

});

parcelRegister("eNhCM", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $ac53501f3c2f408c$export$8687658379b577e6, (v) => $ac53501f3c2f408c$export$8687658379b577e6 = v);
var $ac53501f3c2f408c$export$8687658379b577e6;
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $dEucY = parcelRequire("dEucY");
function $ac53501f3c2f408c$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$ac53501f3c2f408c$export$8687658379b577e6 = $ac53501f3c2f408c$var$BlockHash;
$ac53501f3c2f408c$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $1eUk6.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $1eUk6.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$ac53501f3c2f408c$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $dEucY(this.pending === null);
    return this._digest(enc);
};
$ac53501f3c2f408c$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("5sj5b", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $3f8e5eaaa06cda52$export$5091bdda49ba90f5, (v) => $3f8e5eaaa06cda52$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $3f8e5eaaa06cda52$export$97b70509d4e397ea, (v) => $3f8e5eaaa06cda52$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $3f8e5eaaa06cda52$export$bced8d2aada2d1c9, (v) => $3f8e5eaaa06cda52$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $3f8e5eaaa06cda52$export$612d47d55dedde45, (v) => $3f8e5eaaa06cda52$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $3f8e5eaaa06cda52$export$a888d2532e6dc7bb, (v) => $3f8e5eaaa06cda52$export$a888d2532e6dc7bb = v);
var $3f8e5eaaa06cda52$export$5091bdda49ba90f5;
var $3f8e5eaaa06cda52$export$97b70509d4e397ea;
var $3f8e5eaaa06cda52$export$bced8d2aada2d1c9;
var $3f8e5eaaa06cda52$export$612d47d55dedde45;
var $3f8e5eaaa06cda52$export$a888d2532e6dc7bb;
'use strict';

$3f8e5eaaa06cda52$export$5091bdda49ba90f5 = (parcelRequire("6iiM9"));

$3f8e5eaaa06cda52$export$97b70509d4e397ea = (parcelRequire("fO8K3"));

$3f8e5eaaa06cda52$export$bced8d2aada2d1c9 = (parcelRequire("cMp0S"));

$3f8e5eaaa06cda52$export$612d47d55dedde45 = (parcelRequire("3VGAi"));

$3f8e5eaaa06cda52$export$a888d2532e6dc7bb = (parcelRequire("5lIIb"));

});
parcelRegister("6iiM9", function(module, exports) {
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $eNhCM = parcelRequire("eNhCM");

var $2eXub = parcelRequire("2eXub");
var $4952fcf26284c1fd$var$rotl32 = $1eUk6.rotl32;
var $4952fcf26284c1fd$var$sum32 = $1eUk6.sum32;
var $4952fcf26284c1fd$var$sum32_5 = $1eUk6.sum32_5;
var $4952fcf26284c1fd$var$ft_1 = $2eXub.ft_1;
var $4952fcf26284c1fd$var$BlockHash = $eNhCM.BlockHash;
var $4952fcf26284c1fd$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $4952fcf26284c1fd$var$SHA1() {
    if (!(this instanceof $4952fcf26284c1fd$var$SHA1)) return new $4952fcf26284c1fd$var$SHA1();
    $4952fcf26284c1fd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$1eUk6.inherits($4952fcf26284c1fd$var$SHA1, $4952fcf26284c1fd$var$BlockHash);
module.exports = $4952fcf26284c1fd$var$SHA1;
$4952fcf26284c1fd$var$SHA1.blockSize = 512;
$4952fcf26284c1fd$var$SHA1.outSize = 160;
$4952fcf26284c1fd$var$SHA1.hmacStrength = 80;
$4952fcf26284c1fd$var$SHA1.padLength = 64;
$4952fcf26284c1fd$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4952fcf26284c1fd$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $4952fcf26284c1fd$var$sum32_5($4952fcf26284c1fd$var$rotl32(a, 5), $4952fcf26284c1fd$var$ft_1(s, b, c, d), e, W[i], $4952fcf26284c1fd$var$sha1_K[s]);
        e = d;
        d = c;
        c = $4952fcf26284c1fd$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $4952fcf26284c1fd$var$sum32(this.h[0], a);
    this.h[1] = $4952fcf26284c1fd$var$sum32(this.h[1], b);
    this.h[2] = $4952fcf26284c1fd$var$sum32(this.h[2], c);
    this.h[3] = $4952fcf26284c1fd$var$sum32(this.h[3], d);
    this.h[4] = $4952fcf26284c1fd$var$sum32(this.h[4], e);
};
$4952fcf26284c1fd$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1eUk6.toHex32(this.h, 'big');
    else return $1eUk6.split32(this.h, 'big');
};

});
parcelRegister("2eXub", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $1a1b083e6ccfc2e6$export$5a92649d7ddb9f63, (v) => $1a1b083e6ccfc2e6$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $1a1b083e6ccfc2e6$export$c6d0d020c3a6269, (v) => $1a1b083e6ccfc2e6$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $1a1b083e6ccfc2e6$export$eb90c27fca05f956, (v) => $1a1b083e6ccfc2e6$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $1a1b083e6ccfc2e6$export$14a4a98e063b1999, (v) => $1a1b083e6ccfc2e6$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $1a1b083e6ccfc2e6$export$d20cecfa1564c686, (v) => $1a1b083e6ccfc2e6$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $1a1b083e6ccfc2e6$export$44fd472a12fc6db, (v) => $1a1b083e6ccfc2e6$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $1a1b083e6ccfc2e6$export$1ed238bb6ea1dd47, (v) => $1a1b083e6ccfc2e6$export$1ed238bb6ea1dd47 = v);
var $1a1b083e6ccfc2e6$export$5a92649d7ddb9f63;
var $1a1b083e6ccfc2e6$export$c6d0d020c3a6269;
var $1a1b083e6ccfc2e6$export$eb90c27fca05f956;
var $1a1b083e6ccfc2e6$export$cc992891a14496a1;
var $1a1b083e6ccfc2e6$export$14a4a98e063b1999;
var $1a1b083e6ccfc2e6$export$d20cecfa1564c686;
var $1a1b083e6ccfc2e6$export$44fd472a12fc6db;
var $1a1b083e6ccfc2e6$export$1ed238bb6ea1dd47;
'use strict';

var $1eUk6 = parcelRequire("1eUk6");
var $1a1b083e6ccfc2e6$var$rotr32 = $1eUk6.rotr32;
function $1a1b083e6ccfc2e6$var$ft_1(s, x, y, z) {
    if (s === 0) return $1a1b083e6ccfc2e6$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $1a1b083e6ccfc2e6$var$p32(x, y, z);
    if (s === 2) return $1a1b083e6ccfc2e6$var$maj32(x, y, z);
}
$1a1b083e6ccfc2e6$export$5a92649d7ddb9f63 = $1a1b083e6ccfc2e6$var$ft_1;
function $1a1b083e6ccfc2e6$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$1a1b083e6ccfc2e6$export$c6d0d020c3a6269 = $1a1b083e6ccfc2e6$var$ch32;
function $1a1b083e6ccfc2e6$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$1a1b083e6ccfc2e6$export$eb90c27fca05f956 = $1a1b083e6ccfc2e6$var$maj32;
function $1a1b083e6ccfc2e6$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$1a1b083e6ccfc2e6$export$cc992891a14496a1 = $1a1b083e6ccfc2e6$var$p32;
function $1a1b083e6ccfc2e6$var$s0_256(x) {
    return $1a1b083e6ccfc2e6$var$rotr32(x, 2) ^ $1a1b083e6ccfc2e6$var$rotr32(x, 13) ^ $1a1b083e6ccfc2e6$var$rotr32(x, 22);
}
$1a1b083e6ccfc2e6$export$14a4a98e063b1999 = $1a1b083e6ccfc2e6$var$s0_256;
function $1a1b083e6ccfc2e6$var$s1_256(x) {
    return $1a1b083e6ccfc2e6$var$rotr32(x, 6) ^ $1a1b083e6ccfc2e6$var$rotr32(x, 11) ^ $1a1b083e6ccfc2e6$var$rotr32(x, 25);
}
$1a1b083e6ccfc2e6$export$d20cecfa1564c686 = $1a1b083e6ccfc2e6$var$s1_256;
function $1a1b083e6ccfc2e6$var$g0_256(x) {
    return $1a1b083e6ccfc2e6$var$rotr32(x, 7) ^ $1a1b083e6ccfc2e6$var$rotr32(x, 18) ^ x >>> 3;
}
$1a1b083e6ccfc2e6$export$44fd472a12fc6db = $1a1b083e6ccfc2e6$var$g0_256;
function $1a1b083e6ccfc2e6$var$g1_256(x) {
    return $1a1b083e6ccfc2e6$var$rotr32(x, 17) ^ $1a1b083e6ccfc2e6$var$rotr32(x, 19) ^ x >>> 10;
}
$1a1b083e6ccfc2e6$export$1ed238bb6ea1dd47 = $1a1b083e6ccfc2e6$var$g1_256;

});


parcelRegister("fO8K3", function(module, exports) {
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $cMp0S = parcelRequire("cMp0S");
function $b8224e795f9da85c$var$SHA224() {
    if (!(this instanceof $b8224e795f9da85c$var$SHA224)) return new $b8224e795f9da85c$var$SHA224();
    $cMp0S.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$1eUk6.inherits($b8224e795f9da85c$var$SHA224, $cMp0S);
module.exports = $b8224e795f9da85c$var$SHA224;
$b8224e795f9da85c$var$SHA224.blockSize = 512;
$b8224e795f9da85c$var$SHA224.outSize = 224;
$b8224e795f9da85c$var$SHA224.hmacStrength = 192;
$b8224e795f9da85c$var$SHA224.padLength = 64;
$b8224e795f9da85c$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $1eUk6.toHex32(this.h.slice(0, 7), 'big');
    else return $1eUk6.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("cMp0S", function(module, exports) {
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $eNhCM = parcelRequire("eNhCM");

var $2eXub = parcelRequire("2eXub");

var $dEucY = parcelRequire("dEucY");
var $94dd5ecf4918d0c3$var$sum32 = $1eUk6.sum32;
var $94dd5ecf4918d0c3$var$sum32_4 = $1eUk6.sum32_4;
var $94dd5ecf4918d0c3$var$sum32_5 = $1eUk6.sum32_5;
var $94dd5ecf4918d0c3$var$ch32 = $2eXub.ch32;
var $94dd5ecf4918d0c3$var$maj32 = $2eXub.maj32;
var $94dd5ecf4918d0c3$var$s0_256 = $2eXub.s0_256;
var $94dd5ecf4918d0c3$var$s1_256 = $2eXub.s1_256;
var $94dd5ecf4918d0c3$var$g0_256 = $2eXub.g0_256;
var $94dd5ecf4918d0c3$var$g1_256 = $2eXub.g1_256;
var $94dd5ecf4918d0c3$var$BlockHash = $eNhCM.BlockHash;
var $94dd5ecf4918d0c3$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $94dd5ecf4918d0c3$var$SHA256() {
    if (!(this instanceof $94dd5ecf4918d0c3$var$SHA256)) return new $94dd5ecf4918d0c3$var$SHA256();
    $94dd5ecf4918d0c3$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $94dd5ecf4918d0c3$var$sha256_K;
    this.W = new Array(64);
}
$1eUk6.inherits($94dd5ecf4918d0c3$var$SHA256, $94dd5ecf4918d0c3$var$BlockHash);
module.exports = $94dd5ecf4918d0c3$var$SHA256;
$94dd5ecf4918d0c3$var$SHA256.blockSize = 512;
$94dd5ecf4918d0c3$var$SHA256.outSize = 256;
$94dd5ecf4918d0c3$var$SHA256.hmacStrength = 192;
$94dd5ecf4918d0c3$var$SHA256.padLength = 64;
$94dd5ecf4918d0c3$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $94dd5ecf4918d0c3$var$sum32_4($94dd5ecf4918d0c3$var$g1_256(W[i - 2]), W[i - 7], $94dd5ecf4918d0c3$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $dEucY(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $94dd5ecf4918d0c3$var$sum32_5(h, $94dd5ecf4918d0c3$var$s1_256(e), $94dd5ecf4918d0c3$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $94dd5ecf4918d0c3$var$sum32($94dd5ecf4918d0c3$var$s0_256(a), $94dd5ecf4918d0c3$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $94dd5ecf4918d0c3$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $94dd5ecf4918d0c3$var$sum32(T1, T2);
    }
    this.h[0] = $94dd5ecf4918d0c3$var$sum32(this.h[0], a);
    this.h[1] = $94dd5ecf4918d0c3$var$sum32(this.h[1], b);
    this.h[2] = $94dd5ecf4918d0c3$var$sum32(this.h[2], c);
    this.h[3] = $94dd5ecf4918d0c3$var$sum32(this.h[3], d);
    this.h[4] = $94dd5ecf4918d0c3$var$sum32(this.h[4], e);
    this.h[5] = $94dd5ecf4918d0c3$var$sum32(this.h[5], f);
    this.h[6] = $94dd5ecf4918d0c3$var$sum32(this.h[6], g);
    this.h[7] = $94dd5ecf4918d0c3$var$sum32(this.h[7], h);
};
$94dd5ecf4918d0c3$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1eUk6.toHex32(this.h, 'big');
    else return $1eUk6.split32(this.h, 'big');
};

});


parcelRegister("3VGAi", function(module, exports) {
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $5lIIb = parcelRequire("5lIIb");
function $2dc7ba55c6a846d3$var$SHA384() {
    if (!(this instanceof $2dc7ba55c6a846d3$var$SHA384)) return new $2dc7ba55c6a846d3$var$SHA384();
    $5lIIb.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$1eUk6.inherits($2dc7ba55c6a846d3$var$SHA384, $5lIIb);
module.exports = $2dc7ba55c6a846d3$var$SHA384;
$2dc7ba55c6a846d3$var$SHA384.blockSize = 1024;
$2dc7ba55c6a846d3$var$SHA384.outSize = 384;
$2dc7ba55c6a846d3$var$SHA384.hmacStrength = 192;
$2dc7ba55c6a846d3$var$SHA384.padLength = 128;
$2dc7ba55c6a846d3$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1eUk6.toHex32(this.h.slice(0, 12), 'big');
    else return $1eUk6.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("5lIIb", function(module, exports) {
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $eNhCM = parcelRequire("eNhCM");

var $dEucY = parcelRequire("dEucY");
var $3e5198bc1f187447$var$rotr64_hi = $1eUk6.rotr64_hi;
var $3e5198bc1f187447$var$rotr64_lo = $1eUk6.rotr64_lo;
var $3e5198bc1f187447$var$shr64_hi = $1eUk6.shr64_hi;
var $3e5198bc1f187447$var$shr64_lo = $1eUk6.shr64_lo;
var $3e5198bc1f187447$var$sum64 = $1eUk6.sum64;
var $3e5198bc1f187447$var$sum64_hi = $1eUk6.sum64_hi;
var $3e5198bc1f187447$var$sum64_lo = $1eUk6.sum64_lo;
var $3e5198bc1f187447$var$sum64_4_hi = $1eUk6.sum64_4_hi;
var $3e5198bc1f187447$var$sum64_4_lo = $1eUk6.sum64_4_lo;
var $3e5198bc1f187447$var$sum64_5_hi = $1eUk6.sum64_5_hi;
var $3e5198bc1f187447$var$sum64_5_lo = $1eUk6.sum64_5_lo;
var $3e5198bc1f187447$var$BlockHash = $eNhCM.BlockHash;
var $3e5198bc1f187447$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $3e5198bc1f187447$var$SHA512() {
    if (!(this instanceof $3e5198bc1f187447$var$SHA512)) return new $3e5198bc1f187447$var$SHA512();
    $3e5198bc1f187447$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $3e5198bc1f187447$var$sha512_K;
    this.W = new Array(160);
}
$1eUk6.inherits($3e5198bc1f187447$var$SHA512, $3e5198bc1f187447$var$BlockHash);
module.exports = $3e5198bc1f187447$var$SHA512;
$3e5198bc1f187447$var$SHA512.blockSize = 1024;
$3e5198bc1f187447$var$SHA512.outSize = 512;
$3e5198bc1f187447$var$SHA512.hmacStrength = 192;
$3e5198bc1f187447$var$SHA512.padLength = 128;
$3e5198bc1f187447$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $3e5198bc1f187447$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $3e5198bc1f187447$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $3e5198bc1f187447$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $3e5198bc1f187447$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $3e5198bc1f187447$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $3e5198bc1f187447$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$3e5198bc1f187447$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $dEucY(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $3e5198bc1f187447$var$s1_512_hi(eh, el);
        var c1_lo = $3e5198bc1f187447$var$s1_512_lo(eh, el);
        var c2_hi = $3e5198bc1f187447$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $3e5198bc1f187447$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $3e5198bc1f187447$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $3e5198bc1f187447$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $3e5198bc1f187447$var$s0_512_hi(ah, al);
        c0_lo = $3e5198bc1f187447$var$s0_512_lo(ah, al);
        c1_hi = $3e5198bc1f187447$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $3e5198bc1f187447$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $3e5198bc1f187447$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $3e5198bc1f187447$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $3e5198bc1f187447$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $3e5198bc1f187447$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $3e5198bc1f187447$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $3e5198bc1f187447$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $3e5198bc1f187447$var$sum64(this.h, 0, ah, al);
    $3e5198bc1f187447$var$sum64(this.h, 2, bh, bl);
    $3e5198bc1f187447$var$sum64(this.h, 4, ch, cl);
    $3e5198bc1f187447$var$sum64(this.h, 6, dh, dl);
    $3e5198bc1f187447$var$sum64(this.h, 8, eh, el);
    $3e5198bc1f187447$var$sum64(this.h, 10, fh, fl);
    $3e5198bc1f187447$var$sum64(this.h, 12, gh, gl);
    $3e5198bc1f187447$var$sum64(this.h, 14, hh, hl);
};
$3e5198bc1f187447$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1eUk6.toHex32(this.h, 'big');
    else return $1eUk6.split32(this.h, 'big');
};
function $3e5198bc1f187447$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$s0_512_hi(xh, xl) {
    var c0_hi = $3e5198bc1f187447$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $3e5198bc1f187447$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $3e5198bc1f187447$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$s0_512_lo(xh, xl) {
    var c0_lo = $3e5198bc1f187447$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $3e5198bc1f187447$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $3e5198bc1f187447$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$s1_512_hi(xh, xl) {
    var c0_hi = $3e5198bc1f187447$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $3e5198bc1f187447$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $3e5198bc1f187447$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$s1_512_lo(xh, xl) {
    var c0_lo = $3e5198bc1f187447$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $3e5198bc1f187447$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $3e5198bc1f187447$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$g0_512_hi(xh, xl) {
    var c0_hi = $3e5198bc1f187447$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $3e5198bc1f187447$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $3e5198bc1f187447$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$g0_512_lo(xh, xl) {
    var c0_lo = $3e5198bc1f187447$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $3e5198bc1f187447$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $3e5198bc1f187447$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$g1_512_hi(xh, xl) {
    var c0_hi = $3e5198bc1f187447$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $3e5198bc1f187447$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $3e5198bc1f187447$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3e5198bc1f187447$var$g1_512_lo(xh, xl) {
    var c0_lo = $3e5198bc1f187447$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $3e5198bc1f187447$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $3e5198bc1f187447$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("8h454", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $606313a2f3303171$export$d1cea0ee4e3f0d3e, (v) => $606313a2f3303171$export$d1cea0ee4e3f0d3e = v);
var $606313a2f3303171$export$d1cea0ee4e3f0d3e;
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $eNhCM = parcelRequire("eNhCM");
var $606313a2f3303171$var$rotl32 = $1eUk6.rotl32;
var $606313a2f3303171$var$sum32 = $1eUk6.sum32;
var $606313a2f3303171$var$sum32_3 = $1eUk6.sum32_3;
var $606313a2f3303171$var$sum32_4 = $1eUk6.sum32_4;
var $606313a2f3303171$var$BlockHash = $eNhCM.BlockHash;
function $606313a2f3303171$var$RIPEMD160() {
    if (!(this instanceof $606313a2f3303171$var$RIPEMD160)) return new $606313a2f3303171$var$RIPEMD160();
    $606313a2f3303171$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$1eUk6.inherits($606313a2f3303171$var$RIPEMD160, $606313a2f3303171$var$BlockHash);
$606313a2f3303171$export$d1cea0ee4e3f0d3e = $606313a2f3303171$var$RIPEMD160;
$606313a2f3303171$var$RIPEMD160.blockSize = 512;
$606313a2f3303171$var$RIPEMD160.outSize = 160;
$606313a2f3303171$var$RIPEMD160.hmacStrength = 192;
$606313a2f3303171$var$RIPEMD160.padLength = 64;
$606313a2f3303171$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $606313a2f3303171$var$sum32($606313a2f3303171$var$rotl32($606313a2f3303171$var$sum32_4(A, $606313a2f3303171$var$f(j, B, C, D), msg[$606313a2f3303171$var$r[j] + start], $606313a2f3303171$var$K(j)), $606313a2f3303171$var$s[j]), E);
        A = E;
        E = D;
        D = $606313a2f3303171$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $606313a2f3303171$var$sum32($606313a2f3303171$var$rotl32($606313a2f3303171$var$sum32_4(Ah, $606313a2f3303171$var$f(79 - j, Bh, Ch, Dh), msg[$606313a2f3303171$var$rh[j] + start], $606313a2f3303171$var$Kh(j)), $606313a2f3303171$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $606313a2f3303171$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $606313a2f3303171$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $606313a2f3303171$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $606313a2f3303171$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $606313a2f3303171$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $606313a2f3303171$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$606313a2f3303171$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1eUk6.toHex32(this.h, 'little');
    else return $1eUk6.split32(this.h, 'little');
};
function $606313a2f3303171$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $606313a2f3303171$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $606313a2f3303171$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $606313a2f3303171$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $606313a2f3303171$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $606313a2f3303171$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $606313a2f3303171$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("hVvmf", function(module, exports) {
'use strict';

var $1eUk6 = parcelRequire("1eUk6");

var $dEucY = parcelRequire("dEucY");
function $d0d01590855c0d14$var$Hmac(hash, key, enc) {
    if (!(this instanceof $d0d01590855c0d14$var$Hmac)) return new $d0d01590855c0d14$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($1eUk6.toArray(key, enc));
}
module.exports = $d0d01590855c0d14$var$Hmac;
$d0d01590855c0d14$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $dEucY(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$d0d01590855c0d14$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$d0d01590855c0d14$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("3eHX3", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("aVb8k", function(module, exports) {
'use strict';

var $kdjxm = parcelRequire("kdjxm");

var $58QqE = parcelRequire("58QqE");

var $cyfvl = parcelRequire("cyfvl");

var $8hVoE = parcelRequire("8hVoE");

var $d6KgX = parcelRequire("d6KgX");
var $7f37dd1eec38b153$var$assert = $cyfvl.assert;

var $mpbey = parcelRequire("mpbey");

var $27yDi = parcelRequire("27yDi");
function $7f37dd1eec38b153$var$EC(options) {
    if (!(this instanceof $7f37dd1eec38b153$var$EC)) return new $7f37dd1eec38b153$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $7f37dd1eec38b153$var$assert(Object.prototype.hasOwnProperty.call($8hVoE, options), 'Unknown curve ' + options);
        options = $8hVoE[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $8hVoE.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $7f37dd1eec38b153$var$EC;
$7f37dd1eec38b153$var$EC.prototype.keyPair = function keyPair(options) {
    return new $mpbey(this, options);
};
$7f37dd1eec38b153$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $mpbey.fromPrivate(this, priv, enc);
};
$7f37dd1eec38b153$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $mpbey.fromPublic(this, pub, enc);
};
$7f37dd1eec38b153$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $58QqE({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $d6KgX(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $kdjxm(2));
    for(;;){
        var priv = new $kdjxm(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$7f37dd1eec38b153$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($kdjxm.isBN(msg) || typeof msg === 'number') {
        msg = new $kdjxm(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $kdjxm(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $kdjxm(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$7f37dd1eec38b153$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$kdjxm.isBN(msg)) {
        $7f37dd1eec38b153$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $7f37dd1eec38b153$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$7f37dd1eec38b153$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $7f37dd1eec38b153$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $7f37dd1eec38b153$var$assert(new $kdjxm(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $58QqE({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $kdjxm(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $kdjxm(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $27yDi({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$7f37dd1eec38b153$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $27yDi(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$7f37dd1eec38b153$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $7f37dd1eec38b153$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $27yDi(signature, enc);
    var n = this.n;
    var e = new $kdjxm(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$7f37dd1eec38b153$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $27yDi(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("58QqE", function(module, exports) {
'use strict';

var $noTgJ = parcelRequire("noTgJ");

var $9Fy2H = parcelRequire("9Fy2H");

var $dEucY = parcelRequire("dEucY");
function $3be65e5dff53b78f$var$HmacDRBG(options) {
    if (!(this instanceof $3be65e5dff53b78f$var$HmacDRBG)) return new $3be65e5dff53b78f$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $9Fy2H.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $9Fy2H.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $9Fy2H.toArray(options.pers, options.persEnc || 'hex');
    $dEucY(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $3be65e5dff53b78f$var$HmacDRBG;
$3be65e5dff53b78f$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$3be65e5dff53b78f$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $noTgJ.hmac(this.hash, this.K);
};
$3be65e5dff53b78f$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$3be65e5dff53b78f$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $9Fy2H.toArray(entropy, entropyEnc);
    add = $9Fy2H.toArray(add, addEnc);
    $dEucY(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$3be65e5dff53b78f$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $9Fy2H.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $9Fy2H.encode(res, enc);
};

});

parcelRegister("mpbey", function(module, exports) {
'use strict';

var $kdjxm = parcelRequire("kdjxm");

var $cyfvl = parcelRequire("cyfvl");
var $043596733a685441$var$assert = $cyfvl.assert;
function $043596733a685441$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $043596733a685441$var$KeyPair;
$043596733a685441$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $043596733a685441$var$KeyPair) return pub;
    return new $043596733a685441$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$043596733a685441$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $043596733a685441$var$KeyPair) return priv;
    return new $043596733a685441$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$043596733a685441$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$043596733a685441$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$043596733a685441$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$043596733a685441$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $kdjxm(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$043596733a685441$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $043596733a685441$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $043596733a685441$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$043596733a685441$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $043596733a685441$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$043596733a685441$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$043596733a685441$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$043596733a685441$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("27yDi", function(module, exports) {
'use strict';

var $kdjxm = parcelRequire("kdjxm");

var $cyfvl = parcelRequire("cyfvl");
var $18b7198c00ab77b7$var$assert = $cyfvl.assert;
function $18b7198c00ab77b7$var$Signature(options, enc) {
    if (options instanceof $18b7198c00ab77b7$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $18b7198c00ab77b7$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $kdjxm(options.r, 16);
    this.s = new $kdjxm(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $18b7198c00ab77b7$var$Signature;
function $18b7198c00ab77b7$var$Position() {
    this.place = 0;
}
function $18b7198c00ab77b7$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $18b7198c00ab77b7$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$18b7198c00ab77b7$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $cyfvl.toArray(data, enc);
    var p = new $18b7198c00ab77b7$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $18b7198c00ab77b7$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $18b7198c00ab77b7$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $18b7198c00ab77b7$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $kdjxm(r);
    this.s = new $kdjxm(s);
    this.recoveryParam = null;
    return true;
};
function $18b7198c00ab77b7$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$18b7198c00ab77b7$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $18b7198c00ab77b7$var$rmPadding(r);
    s = $18b7198c00ab77b7$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $18b7198c00ab77b7$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $18b7198c00ab77b7$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $18b7198c00ab77b7$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $cyfvl.encode(res, enc);
};

});


parcelRegister("8Yrev", function(module, exports) {
'use strict';

var $noTgJ = parcelRequire("noTgJ");

var $8hVoE = parcelRequire("8hVoE");

var $cyfvl = parcelRequire("cyfvl");
var $68890d38aec53f66$var$assert = $cyfvl.assert;
var $68890d38aec53f66$var$parseBytes = $cyfvl.parseBytes;

var $1rtyd = parcelRequire("1rtyd");

var $b99oc = parcelRequire("b99oc");
function $68890d38aec53f66$var$EDDSA(curve) {
    $68890d38aec53f66$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $68890d38aec53f66$var$EDDSA)) return new $68890d38aec53f66$var$EDDSA(curve);
    curve = $8hVoE[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $noTgJ.sha512;
}
module.exports = $68890d38aec53f66$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $68890d38aec53f66$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $68890d38aec53f66$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $68890d38aec53f66$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $68890d38aec53f66$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$68890d38aec53f66$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $cyfvl.intFromLE(hash.digest()).umod(this.curve.n);
};
$68890d38aec53f66$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1rtyd.fromPublic(this, pub);
};
$68890d38aec53f66$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1rtyd.fromSecret(this, secret);
};
$68890d38aec53f66$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $b99oc) return sig;
    return new $b99oc(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $68890d38aec53f66$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$68890d38aec53f66$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $cyfvl.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $cyfvl.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$68890d38aec53f66$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$68890d38aec53f66$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $cyfvl.intFromLE(bytes);
};
$68890d38aec53f66$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1rtyd", function(module, exports) {
'use strict';

var $cyfvl = parcelRequire("cyfvl");
var $10cf3c3d1b543651$var$assert = $cyfvl.assert;
var $10cf3c3d1b543651$var$parseBytes = $cyfvl.parseBytes;
var $10cf3c3d1b543651$var$cachedProperty = $cyfvl.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $10cf3c3d1b543651$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $10cf3c3d1b543651$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $10cf3c3d1b543651$var$parseBytes(params.pub);
}
$10cf3c3d1b543651$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $10cf3c3d1b543651$var$KeyPair) return pub;
    return new $10cf3c3d1b543651$var$KeyPair(eddsa, {
        pub: pub
    });
};
$10cf3c3d1b543651$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $10cf3c3d1b543651$var$KeyPair) return secret;
    return new $10cf3c3d1b543651$var$KeyPair(eddsa, {
        secret: secret
    });
};
$10cf3c3d1b543651$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$10cf3c3d1b543651$var$cachedProperty($10cf3c3d1b543651$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$10cf3c3d1b543651$var$cachedProperty($10cf3c3d1b543651$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$10cf3c3d1b543651$var$cachedProperty($10cf3c3d1b543651$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$10cf3c3d1b543651$var$cachedProperty($10cf3c3d1b543651$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$10cf3c3d1b543651$var$cachedProperty($10cf3c3d1b543651$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$10cf3c3d1b543651$var$cachedProperty($10cf3c3d1b543651$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$10cf3c3d1b543651$var$KeyPair.prototype.sign = function sign(message) {
    $10cf3c3d1b543651$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$10cf3c3d1b543651$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$10cf3c3d1b543651$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $10cf3c3d1b543651$var$assert(this._secret, 'KeyPair is public only');
    return $cyfvl.encode(this.secret(), enc);
};
$10cf3c3d1b543651$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $cyfvl.encode(this.pubBytes(), enc);
};
module.exports = $10cf3c3d1b543651$var$KeyPair;

});

parcelRegister("b99oc", function(module, exports) {
'use strict';

var $kdjxm = parcelRequire("kdjxm");

var $cyfvl = parcelRequire("cyfvl");
var $81d7d17d9c856a5d$var$assert = $cyfvl.assert;
var $81d7d17d9c856a5d$var$cachedProperty = $cyfvl.cachedProperty;
var $81d7d17d9c856a5d$var$parseBytes = $cyfvl.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $81d7d17d9c856a5d$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $81d7d17d9c856a5d$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $81d7d17d9c856a5d$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $81d7d17d9c856a5d$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $kdjxm) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$81d7d17d9c856a5d$var$cachedProperty($81d7d17d9c856a5d$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$81d7d17d9c856a5d$var$cachedProperty($81d7d17d9c856a5d$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$81d7d17d9c856a5d$var$cachedProperty($81d7d17d9c856a5d$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$81d7d17d9c856a5d$var$cachedProperty($81d7d17d9c856a5d$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$81d7d17d9c856a5d$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$81d7d17d9c856a5d$var$Signature.prototype.toHex = function toHex() {
    return $cyfvl.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $81d7d17d9c856a5d$var$Signature;

});



parcelRegister("dwHZ9", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("f8f1G")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        if (num === 0) {
            this.length = 1;
            this._normSign();
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.mod.abs();
        var half = num.abs().iushrn(1);
        var r2 = num.words[0] & 1;
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up, away from zero
        var up = new BN(1);
        up.negative = this.negative ^ num.negative;
        return dm.div.iadd(up);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3PDZy", function(module, exports) {
'use strict';

var $i6eJP = parcelRequire("i6eJP");

var $5cXis = parcelRequire("5cXis");

var $i8kbm = parcelRequire("i8kbm");

var $9bOof = parcelRequire("9bOof");

var $aAf6x = parcelRequire("aAf6x");
var $2ca52810fa803a5c$require$pbkdf2Sync = $aAf6x.pbkdf2Sync;

var $h9jRt = parcelRequire("h9jRt");
var $2ca52810fa803a5c$require$Buffer = $h9jRt.Buffer;
function $2ca52810fa803a5c$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5cXis[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $2ca52810fa803a5c$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $9bOof.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $2ca52810fa803a5c$require$Buffer.concat(out);
}
function $2ca52810fa803a5c$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$2ca52810fa803a5c$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $2ca52810fa803a5c$require$Buffer.from(buffer);
    var stripped = $i8kbm(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $i6eJP.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $i6eJP.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $i6eJP.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $i6eJP.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $i6eJP.EncryptedPrivateKey.decode(data, 'der');
            data = $2ca52810fa803a5c$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $i6eJP.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $i6eJP.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $i6eJP.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $i6eJP.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $i6eJP.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $i6eJP.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $i6eJP.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $i6eJP.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$2ca52810fa803a5c$var$parseKeys.signature = $i6eJP.signature;
module.exports = $2ca52810fa803a5c$var$parseKeys;

});
parcelRegister("i6eJP", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $d2d43836266cc275$export$c98397a6eb8d0678, (v) => $d2d43836266cc275$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $d2d43836266cc275$export$f4aab6816f64fa6b, (v) => $d2d43836266cc275$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $d2d43836266cc275$export$4471f5c65d097c11, (v) => $d2d43836266cc275$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $d2d43836266cc275$export$ca8b6604d6ce14de, (v) => $d2d43836266cc275$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $d2d43836266cc275$export$8f54525b330fd87b, (v) => $d2d43836266cc275$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $d2d43836266cc275$export$23cd2842b44ca3e7, (v) => $d2d43836266cc275$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $d2d43836266cc275$export$245c9aaa9f5ce4ce, (v) => $d2d43836266cc275$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $d2d43836266cc275$export$8ad762e3e6399afe, (v) => $d2d43836266cc275$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $d2d43836266cc275$export$32ef6f92e22c6ab0, (v) => $d2d43836266cc275$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $d2d43836266cc275$export$c9cd164b539ebb63, (v) => $d2d43836266cc275$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $d2d43836266cc275$export$c98397a6eb8d0678;
var $d2d43836266cc275$export$f4aab6816f64fa6b;
var $d2d43836266cc275$export$4471f5c65d097c11;
var $d2d43836266cc275$export$ca8b6604d6ce14de;
var $d2d43836266cc275$export$8f54525b330fd87b;
var $d2d43836266cc275$export$23cd2842b44ca3e7;
var $d2d43836266cc275$export$245c9aaa9f5ce4ce;
var $d2d43836266cc275$export$8ad762e3e6399afe;
var $d2d43836266cc275$export$32ef6f92e22c6ab0;
var $d2d43836266cc275$export$c9cd164b539ebb63;
'use strict';

var $hvHsf = parcelRequire("hvHsf");

$d2d43836266cc275$export$c98397a6eb8d0678 = (parcelRequire("cZVWb"));
var $d2d43836266cc275$var$RSAPrivateKey = $hvHsf.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$d2d43836266cc275$export$f4aab6816f64fa6b = $d2d43836266cc275$var$RSAPrivateKey;
var $d2d43836266cc275$var$RSAPublicKey = $hvHsf.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$d2d43836266cc275$export$4471f5c65d097c11 = $d2d43836266cc275$var$RSAPublicKey;
var $d2d43836266cc275$var$AlgorithmIdentifier = $hvHsf.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $d2d43836266cc275$var$PublicKey = $hvHsf.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($d2d43836266cc275$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$d2d43836266cc275$export$ca8b6604d6ce14de = $d2d43836266cc275$var$PublicKey;
var $d2d43836266cc275$var$PrivateKeyInfo = $hvHsf.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($d2d43836266cc275$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$d2d43836266cc275$export$8f54525b330fd87b = $d2d43836266cc275$var$PrivateKeyInfo;
var $d2d43836266cc275$var$EncryptedPrivateKeyInfo = $hvHsf.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$d2d43836266cc275$export$23cd2842b44ca3e7 = $d2d43836266cc275$var$EncryptedPrivateKeyInfo;
var $d2d43836266cc275$var$DSAPrivateKey = $hvHsf.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$d2d43836266cc275$export$245c9aaa9f5ce4ce = $d2d43836266cc275$var$DSAPrivateKey;
$d2d43836266cc275$export$8ad762e3e6399afe = $hvHsf.define('DSAparam', function() {
    this['int']();
});
var $d2d43836266cc275$var$ECParameters = $hvHsf.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $d2d43836266cc275$var$ECPrivateKey = $hvHsf.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($d2d43836266cc275$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$d2d43836266cc275$export$32ef6f92e22c6ab0 = $d2d43836266cc275$var$ECPrivateKey;
$d2d43836266cc275$export$c9cd164b539ebb63 = $hvHsf.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("hvHsf", function(module, exports) {
var $cbf70a1d8231f1b8$var$asn1 = module.exports;

$cbf70a1d8231f1b8$var$asn1.bignum = (parcelRequire("kdjxm"));

$cbf70a1d8231f1b8$var$asn1.define = (parcelRequire("xmEJk")).define;

$cbf70a1d8231f1b8$var$asn1.base = (parcelRequire("keYmQ"));

$cbf70a1d8231f1b8$var$asn1.constants = (parcelRequire("ZW7jd"));

$cbf70a1d8231f1b8$var$asn1.decoders = (parcelRequire("2xpq5"));

$cbf70a1d8231f1b8$var$asn1.encoders = (parcelRequire("kFZrD"));

});
parcelRegister("xmEJk", function(module, exports) {

var $hvHsf = parcelRequire("hvHsf");

var $aAKqs = parcelRequire("aAKqs");
var $0644a82df2f01cc2$var$api = module.exports;
$0644a82df2f01cc2$var$api.define = function define(name, body) {
    return new $0644a82df2f01cc2$var$Entity(name, body);
};
function $0644a82df2f01cc2$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$0644a82df2f01cc2$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("dIxLd")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $aAKqs(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$0644a82df2f01cc2$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($hvHsf.decoders[enc]);
    return this.decoders[enc];
};
$0644a82df2f01cc2$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$0644a82df2f01cc2$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($hvHsf.encoders[enc]);
    return this.encoders[enc];
};
$0644a82df2f01cc2$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("dIxLd", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("keYmQ", function(module, exports) {
var $ebc3f12f5fa398bd$var$base = module.exports;

$ebc3f12f5fa398bd$var$base.Reporter = (parcelRequire("TZIVx")).Reporter;

$ebc3f12f5fa398bd$var$base.DecoderBuffer = (parcelRequire("1vjal")).DecoderBuffer;

$ebc3f12f5fa398bd$var$base.EncoderBuffer = (parcelRequire("1vjal")).EncoderBuffer;

$ebc3f12f5fa398bd$var$base.Node = (parcelRequire("gR9Yp"));

});
parcelRegister("TZIVx", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $0a850432177ab306$export$957313a2f485e5ed, (v) => $0a850432177ab306$export$957313a2f485e5ed = v);
var $0a850432177ab306$export$957313a2f485e5ed;

var $aAKqs = parcelRequire("aAKqs");
function $0a850432177ab306$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$0a850432177ab306$export$957313a2f485e5ed = $0a850432177ab306$var$Reporter;
$0a850432177ab306$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $0a850432177ab306$var$ReporterError;
};
$0a850432177ab306$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$0a850432177ab306$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$0a850432177ab306$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$0a850432177ab306$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$0a850432177ab306$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$0a850432177ab306$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$0a850432177ab306$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$0a850432177ab306$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$0a850432177ab306$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $0a850432177ab306$var$ReporterError;
    if (inherited) err = msg;
    else err = new $0a850432177ab306$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$0a850432177ab306$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $0a850432177ab306$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$aAKqs($0a850432177ab306$var$ReporterError, Error);
$0a850432177ab306$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0a850432177ab306$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("1vjal", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $11878da30e3280fb$export$bf9f79cdc4a49163, (v) => $11878da30e3280fb$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $11878da30e3280fb$export$8ff24f7760c7a78e, (v) => $11878da30e3280fb$export$8ff24f7760c7a78e = v);
var $11878da30e3280fb$export$bf9f79cdc4a49163;
var $11878da30e3280fb$export$8ff24f7760c7a78e;

var $aAKqs = parcelRequire("aAKqs");

var $keYmQ = parcelRequire("keYmQ");
var $11878da30e3280fb$require$Reporter = $keYmQ.Reporter;

var $dOfWq = parcelRequire("dOfWq");
var $11878da30e3280fb$require$Buffer = $dOfWq.Buffer;
function $11878da30e3280fb$var$DecoderBuffer(base, options) {
    $11878da30e3280fb$require$Reporter.call(this, options);
    if (!$11878da30e3280fb$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$aAKqs($11878da30e3280fb$var$DecoderBuffer, $11878da30e3280fb$require$Reporter);
$11878da30e3280fb$export$bf9f79cdc4a49163 = $11878da30e3280fb$var$DecoderBuffer;
$11878da30e3280fb$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $11878da30e3280fb$require$Reporter.prototype.save.call(this)
    };
};
$11878da30e3280fb$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $11878da30e3280fb$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $11878da30e3280fb$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$11878da30e3280fb$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$11878da30e3280fb$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$11878da30e3280fb$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $11878da30e3280fb$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$11878da30e3280fb$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $11878da30e3280fb$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $11878da30e3280fb$var$EncoderBuffer)) item = new $11878da30e3280fb$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $11878da30e3280fb$require$Buffer.byteLength(value);
    } else if ($11878da30e3280fb$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$11878da30e3280fb$export$8ff24f7760c7a78e = $11878da30e3280fb$var$EncoderBuffer;
$11878da30e3280fb$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $11878da30e3280fb$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($11878da30e3280fb$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("gR9Yp", function(module, exports) {

var $keYmQ = parcelRequire("keYmQ");
var $c4595519c812a4c2$require$Reporter = $keYmQ.Reporter;

var $keYmQ = parcelRequire("keYmQ");
var $c4595519c812a4c2$require$EncoderBuffer = $keYmQ.EncoderBuffer;

var $keYmQ = parcelRequire("keYmQ");
var $c4595519c812a4c2$require$DecoderBuffer = $keYmQ.DecoderBuffer;

var $dEucY = parcelRequire("dEucY");
// Supported tags
var $c4595519c812a4c2$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $c4595519c812a4c2$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($c4595519c812a4c2$var$tags);
// Overrided methods list
var $c4595519c812a4c2$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $c4595519c812a4c2$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c4595519c812a4c2$var$Node;
var $c4595519c812a4c2$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$c4595519c812a4c2$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c4595519c812a4c2$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c4595519c812a4c2$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c4595519c812a4c2$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c4595519c812a4c2$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $dEucY(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $dEucY.equal(state.children.length, 1, 'Root node can have only one child');
};
$c4595519c812a4c2$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $dEucY(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $dEucY(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c4595519c812a4c2$var$overrided.forEach(function(method) {
    $c4595519c812a4c2$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$c4595519c812a4c2$var$tags.forEach(function(tag) {
    $c4595519c812a4c2$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $dEucY(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c4595519c812a4c2$var$Node.prototype.use = function use(item) {
    $dEucY(item);
    var state = this._baseState;
    $dEucY(state.use === null);
    state.use = item;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $dEucY(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $dEucY(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $dEucY(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c4595519c812a4c2$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $dEucY(state.key === null);
    state.key = newKey;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c4595519c812a4c2$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $dEucY(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c4595519c812a4c2$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $dEucY(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c4595519c812a4c2$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $c4595519c812a4c2$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c4595519c812a4c2$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$c4595519c812a4c2$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $dEucY(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c4595519c812a4c2$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$c4595519c812a4c2$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c4595519c812a4c2$require$EncoderBuffer(data, this.reporter);
};
$c4595519c812a4c2$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c4595519c812a4c2$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c4595519c812a4c2$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$c4595519c812a4c2$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $dEucY(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c4595519c812a4c2$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$c4595519c812a4c2$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c4595519c812a4c2$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("ZW7jd", function(module, exports) {
var $0ba2c76c3c2749b5$var$constants = module.exports;
// Helper
$0ba2c76c3c2749b5$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$0ba2c76c3c2749b5$var$constants.der = (parcelRequire("61V6R"));

});
parcelRegister("61V6R", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $463f22dc14ffff1f$export$3584c46ed60baee8, (v) => $463f22dc14ffff1f$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $463f22dc14ffff1f$export$f18596ef8d632e49, (v) => $463f22dc14ffff1f$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $463f22dc14ffff1f$export$2b067c6666111485, (v) => $463f22dc14ffff1f$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $463f22dc14ffff1f$export$f17df38a421ab9e3, (v) => $463f22dc14ffff1f$export$f17df38a421ab9e3 = v);
var $463f22dc14ffff1f$export$3584c46ed60baee8;
var $463f22dc14ffff1f$export$f18596ef8d632e49;
var $463f22dc14ffff1f$export$2b067c6666111485;
var $463f22dc14ffff1f$export$f17df38a421ab9e3;

var $ZW7jd = parcelRequire("ZW7jd");
$463f22dc14ffff1f$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$463f22dc14ffff1f$export$f18596ef8d632e49 = $ZW7jd._reverse($463f22dc14ffff1f$export$3584c46ed60baee8);
$463f22dc14ffff1f$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$463f22dc14ffff1f$export$f17df38a421ab9e3 = $ZW7jd._reverse($463f22dc14ffff1f$export$2b067c6666111485);

});


parcelRegister("2xpq5", function(module, exports) {
var $1d9261b0196d2e6f$var$decoders = module.exports;

$1d9261b0196d2e6f$var$decoders.der = (parcelRequire("6VQBH"));

$1d9261b0196d2e6f$var$decoders.pem = (parcelRequire("kojYO"));

});
parcelRegister("6VQBH", function(module, exports) {

var $aAKqs = parcelRequire("aAKqs");

var $hvHsf = parcelRequire("hvHsf");
var $50c0df9e17d43acf$var$base = $hvHsf.base;
var $50c0df9e17d43acf$var$bignum = $hvHsf.bignum;
// Import DER constants
var $50c0df9e17d43acf$var$der = $hvHsf.constants.der;
function $50c0df9e17d43acf$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $50c0df9e17d43acf$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $50c0df9e17d43acf$var$DERDecoder;
$50c0df9e17d43acf$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $50c0df9e17d43acf$var$base.DecoderBuffer)) data = new $50c0df9e17d43acf$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $50c0df9e17d43acf$var$DERNode(parent) {
    $50c0df9e17d43acf$var$base.Node.call(this, 'der', parent);
}
$aAKqs($50c0df9e17d43acf$var$DERNode, $50c0df9e17d43acf$var$base.Node);
$50c0df9e17d43acf$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $50c0df9e17d43acf$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $50c0df9e17d43acf$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $50c0df9e17d43acf$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$50c0df9e17d43acf$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $50c0df9e17d43acf$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $50c0df9e17d43acf$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$50c0df9e17d43acf$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $50c0df9e17d43acf$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$50c0df9e17d43acf$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $50c0df9e17d43acf$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $50c0df9e17d43acf$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $50c0df9e17d43acf$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $50c0df9e17d43acf$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("kojYO", function(module, exports) {

var $aAKqs = parcelRequire("aAKqs");

var $dOfWq = parcelRequire("dOfWq");
var $ed858c192656b31a$require$Buffer = $dOfWq.Buffer;

var $6VQBH = parcelRequire("6VQBH");
function $ed858c192656b31a$var$PEMDecoder(entity) {
    $6VQBH.call(this, entity);
    this.enc = 'pem';
}
$aAKqs($ed858c192656b31a$var$PEMDecoder, $6VQBH);
module.exports = $ed858c192656b31a$var$PEMDecoder;
$ed858c192656b31a$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $ed858c192656b31a$require$Buffer(base64, 'base64');
    return $6VQBH.prototype.decode.call(this, input, options);
};

});


parcelRegister("kFZrD", function(module, exports) {
var $f0d74c9c0e9d68db$var$encoders = module.exports;

$f0d74c9c0e9d68db$var$encoders.der = (parcelRequire("2aWBT"));

$f0d74c9c0e9d68db$var$encoders.pem = (parcelRequire("cmOQx"));

});
parcelRegister("2aWBT", function(module, exports) {

var $aAKqs = parcelRequire("aAKqs");

var $dOfWq = parcelRequire("dOfWq");
var $1959faaf13a84838$require$Buffer = $dOfWq.Buffer;

var $hvHsf = parcelRequire("hvHsf");
var $1959faaf13a84838$var$base = $hvHsf.base;
// Import DER constants
var $1959faaf13a84838$var$der = $hvHsf.constants.der;
function $1959faaf13a84838$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1959faaf13a84838$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1959faaf13a84838$var$DEREncoder;
$1959faaf13a84838$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1959faaf13a84838$var$DERNode(parent) {
    $1959faaf13a84838$var$base.Node.call(this, 'der', parent);
}
$aAKqs($1959faaf13a84838$var$DERNode, $1959faaf13a84838$var$base.Node);
$1959faaf13a84838$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1959faaf13a84838$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1959faaf13a84838$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1959faaf13a84838$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1959faaf13a84838$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $1959faaf13a84838$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$1959faaf13a84838$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1959faaf13a84838$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1959faaf13a84838$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$1959faaf13a84838$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $1959faaf13a84838$var$two(date.getFullYear()),
        $1959faaf13a84838$var$two(date.getUTCMonth() + 1),
        $1959faaf13a84838$var$two(date.getUTCDate()),
        $1959faaf13a84838$var$two(date.getUTCHours()),
        $1959faaf13a84838$var$two(date.getUTCMinutes()),
        $1959faaf13a84838$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $1959faaf13a84838$var$two(date.getFullYear() % 100),
        $1959faaf13a84838$var$two(date.getUTCMonth() + 1),
        $1959faaf13a84838$var$two(date.getUTCDate()),
        $1959faaf13a84838$var$two(date.getUTCHours()),
        $1959faaf13a84838$var$two(date.getUTCMinutes()),
        $1959faaf13a84838$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$1959faaf13a84838$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$1959faaf13a84838$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$1959faaf13a84838$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1959faaf13a84838$require$Buffer(numArray);
    }
    if ($1959faaf13a84838$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1959faaf13a84838$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1959faaf13a84838$require$Buffer(out));
};
$1959faaf13a84838$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1959faaf13a84838$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$1959faaf13a84838$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1959faaf13a84838$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($1959faaf13a84838$var$der.tagByName.hasOwnProperty(tag)) res = $1959faaf13a84838$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $1959faaf13a84838$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("cmOQx", function(module, exports) {

var $aAKqs = parcelRequire("aAKqs");

var $2aWBT = parcelRequire("2aWBT");
function $900efb2a54698f63$var$PEMEncoder(entity) {
    $2aWBT.call(this, entity);
    this.enc = 'pem';
}
$aAKqs($900efb2a54698f63$var$PEMEncoder, $2aWBT);
module.exports = $900efb2a54698f63$var$PEMEncoder;
$900efb2a54698f63$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2aWBT.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("cZVWb", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $hvHsf = parcelRequire("hvHsf");
var $97681fba338c2dd9$var$Time = $hvHsf.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $97681fba338c2dd9$var$AttributeTypeValue = $hvHsf.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $97681fba338c2dd9$var$AlgorithmIdentifier = $hvHsf.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $97681fba338c2dd9$var$SubjectPublicKeyInfo = $hvHsf.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($97681fba338c2dd9$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $97681fba338c2dd9$var$RelativeDistinguishedName = $hvHsf.define('RelativeDistinguishedName', function() {
    this.setof($97681fba338c2dd9$var$AttributeTypeValue);
});
var $97681fba338c2dd9$var$RDNSequence = $hvHsf.define('RDNSequence', function() {
    this.seqof($97681fba338c2dd9$var$RelativeDistinguishedName);
});
var $97681fba338c2dd9$var$Name = $hvHsf.define('Name', function() {
    this.choice({
        rdnSequence: this.use($97681fba338c2dd9$var$RDNSequence)
    });
});
var $97681fba338c2dd9$var$Validity = $hvHsf.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($97681fba338c2dd9$var$Time), this.key('notAfter').use($97681fba338c2dd9$var$Time));
});
var $97681fba338c2dd9$var$Extension = $hvHsf.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $97681fba338c2dd9$var$TBSCertificate = $hvHsf.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($97681fba338c2dd9$var$AlgorithmIdentifier), this.key('issuer').use($97681fba338c2dd9$var$Name), this.key('validity').use($97681fba338c2dd9$var$Validity), this.key('subject').use($97681fba338c2dd9$var$Name), this.key('subjectPublicKeyInfo').use($97681fba338c2dd9$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($97681fba338c2dd9$var$Extension).optional());
});
var $97681fba338c2dd9$var$X509Certificate = $hvHsf.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($97681fba338c2dd9$var$TBSCertificate), this.key('signatureAlgorithm').use($97681fba338c2dd9$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $97681fba338c2dd9$var$X509Certificate;

});


parcelRegister("5cXis", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("i8kbm", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $d338a1203655c2fa$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $d338a1203655c2fa$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $d338a1203655c2fa$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $dIH6y = parcelRequire("dIH6y");

var $9bOof = parcelRequire("9bOof");

var $h9jRt = parcelRequire("h9jRt");
var $d338a1203655c2fa$require$Buffer = $h9jRt.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($d338a1203655c2fa$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($d338a1203655c2fa$var$fullRegex);
        decrypted = $d338a1203655c2fa$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $d338a1203655c2fa$require$Buffer.from(match[2], 'hex');
        var cipherText = $d338a1203655c2fa$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $dIH6y(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $9bOof.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $d338a1203655c2fa$require$Buffer.concat(out);
    }
    var tag = key.match($d338a1203655c2fa$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("4qrU8", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("5hZOO", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $3d9e7e2535b31e0e$require$Buffer = $h9jRt.Buffer;

var $dwHZ9 = parcelRequire("dwHZ9");

var $iTT5q = parcelRequire("iTT5q");
var $3d9e7e2535b31e0e$require$EC = $iTT5q.ec;

var $3PDZy = parcelRequire("3PDZy");

var $4qrU8 = parcelRequire("4qrU8");
function $3d9e7e2535b31e0e$var$verify(sig, hash, key, signType, tag) {
    var pub = $3PDZy(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $3d9e7e2535b31e0e$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $3d9e7e2535b31e0e$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $3d9e7e2535b31e0e$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $3d9e7e2535b31e0e$require$Buffer.from(pad);
    var red = $dwHZ9.mont(pub.modulus);
    sig = new $dwHZ9(sig).toRed(red);
    sig = sig.redPow(new $dwHZ9(pub.publicExponent));
    sig = $3d9e7e2535b31e0e$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $3d9e7e2535b31e0e$var$ecVerify(sig, hash, pub) {
    var curveId = $4qrU8[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $3d9e7e2535b31e0e$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $3d9e7e2535b31e0e$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $3PDZy.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $3d9e7e2535b31e0e$var$checkValue(s, q);
    $3d9e7e2535b31e0e$var$checkValue(r, q);
    var montp = $dwHZ9.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dwHZ9(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $3d9e7e2535b31e0e$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $3d9e7e2535b31e0e$var$verify;

});


parcelRegister("5SLVS", function(module, exports) {

var $dOfWq = parcelRequire("dOfWq");
var $44872d4c1862e73b$require$Buffer = $dOfWq.Buffer;

var $iTT5q = parcelRequire("iTT5q");

var $kdjxm = parcelRequire("kdjxm");
module.exports = function createECDH(curve) {
    return new $44872d4c1862e73b$var$ECDH(curve);
};
var $44872d4c1862e73b$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$44872d4c1862e73b$var$aliases.p224 = $44872d4c1862e73b$var$aliases.secp224r1;
$44872d4c1862e73b$var$aliases.p256 = $44872d4c1862e73b$var$aliases.secp256r1 = $44872d4c1862e73b$var$aliases.prime256v1;
$44872d4c1862e73b$var$aliases.p192 = $44872d4c1862e73b$var$aliases.secp192r1 = $44872d4c1862e73b$var$aliases.prime192v1;
$44872d4c1862e73b$var$aliases.p384 = $44872d4c1862e73b$var$aliases.secp384r1;
$44872d4c1862e73b$var$aliases.p521 = $44872d4c1862e73b$var$aliases.secp521r1;
function $44872d4c1862e73b$var$ECDH(curve) {
    this.curveType = $44872d4c1862e73b$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $iTT5q.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$44872d4c1862e73b$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$44872d4c1862e73b$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$44872d4c1862e73b$require$Buffer.isBuffer(other)) other = new $44872d4c1862e73b$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $44872d4c1862e73b$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$44872d4c1862e73b$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $44872d4c1862e73b$var$formatReturnValue(key, enc);
};
$44872d4c1862e73b$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $44872d4c1862e73b$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$44872d4c1862e73b$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$44872d4c1862e73b$require$Buffer.isBuffer(pub)) pub = new $44872d4c1862e73b$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$44872d4c1862e73b$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$44872d4c1862e73b$require$Buffer.isBuffer(priv)) priv = new $44872d4c1862e73b$require$Buffer(priv, enc);
    var _priv = new $kdjxm(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $44872d4c1862e73b$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $44872d4c1862e73b$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $44872d4c1862e73b$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $44872d4c1862e73b$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("3pyBJ", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $27be8d370da485e9$export$512823e338ddb1b7, (v) => $27be8d370da485e9$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $27be8d370da485e9$export$7efb24e2fddf99b9, (v) => $27be8d370da485e9$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $27be8d370da485e9$export$9d0e0c0c4a8d30f3, (v) => $27be8d370da485e9$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $27be8d370da485e9$export$b9d55ff329113abd, (v) => $27be8d370da485e9$export$b9d55ff329113abd = v);
var $27be8d370da485e9$export$512823e338ddb1b7;
var $27be8d370da485e9$export$7efb24e2fddf99b9;
var $27be8d370da485e9$export$9d0e0c0c4a8d30f3;
var $27be8d370da485e9$export$b9d55ff329113abd;

$27be8d370da485e9$export$512823e338ddb1b7 = (parcelRequire("aXTcn"));

$27be8d370da485e9$export$7efb24e2fddf99b9 = (parcelRequire("4ixex"));
$27be8d370da485e9$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $27be8d370da485e9$export$512823e338ddb1b7(key, buf, true);
};
$27be8d370da485e9$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $27be8d370da485e9$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("aXTcn", function(module, exports) {

var $3PDZy = parcelRequire("3PDZy");

var $dURpS = parcelRequire("dURpS");

var $fsXMV = parcelRequire("fsXMV");

var $5q9Xh = parcelRequire("5q9Xh");

var $iIb9U = parcelRequire("iIb9U");

var $kdjxm = parcelRequire("kdjxm");

var $dopAm = parcelRequire("dopAm");

var $foGXy = parcelRequire("foGXy");

var $h9jRt = parcelRequire("h9jRt");
var $7fba3b6141fbe689$require$Buffer = $h9jRt.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $3PDZy(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $7fba3b6141fbe689$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $7fba3b6141fbe689$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $kdjxm(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $foGXy(paddedMsg, key);
    else return $dopAm(paddedMsg, key);
};
function $7fba3b6141fbe689$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $fsXMV('sha1').update($7fba3b6141fbe689$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $7fba3b6141fbe689$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $dURpS(hLen);
    var maskedDb = $iIb9U($7fba3b6141fbe689$require$Buffer.concat([
        iHash,
        ps,
        $7fba3b6141fbe689$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5q9Xh(seed, dblen));
    var maskedSeed = $iIb9U(seed, $5q9Xh(maskedDb, hLen));
    return new $kdjxm($7fba3b6141fbe689$require$Buffer.concat([
        $7fba3b6141fbe689$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $7fba3b6141fbe689$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $7fba3b6141fbe689$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $7fba3b6141fbe689$var$nonZero(k - mLen - 3);
    return new $kdjxm($7fba3b6141fbe689$require$Buffer.concat([
        $7fba3b6141fbe689$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $7fba3b6141fbe689$require$Buffer.alloc(1),
        msg
    ], k));
}
function $7fba3b6141fbe689$var$nonZero(len) {
    var out = $7fba3b6141fbe689$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $dURpS(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $dURpS(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5q9Xh", function(module, exports) {

var $fsXMV = parcelRequire("fsXMV");

var $h9jRt = parcelRequire("h9jRt");
var $3f271a5938e36053$require$Buffer = $h9jRt.Buffer;
module.exports = function(seed, len) {
    var t = $3f271a5938e36053$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $3f271a5938e36053$var$i2ops(i++);
        t = $3f271a5938e36053$require$Buffer.concat([
            t,
            $fsXMV('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $3f271a5938e36053$var$i2ops(c) {
    var out = $3f271a5938e36053$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("iIb9U", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("dopAm", function(module, exports) {

var $kdjxm = parcelRequire("kdjxm");

var $h9jRt = parcelRequire("h9jRt");
var $9c015d01d1264b4d$require$Buffer = $h9jRt.Buffer;
function $9c015d01d1264b4d$var$withPublic(paddedMsg, key) {
    return $9c015d01d1264b4d$require$Buffer.from(paddedMsg.toRed($kdjxm.mont(key.modulus)).redPow(new $kdjxm(key.publicExponent)).fromRed().toArray());
}
module.exports = $9c015d01d1264b4d$var$withPublic;

});


parcelRegister("4ixex", function(module, exports) {

var $3PDZy = parcelRequire("3PDZy");

var $5q9Xh = parcelRequire("5q9Xh");

var $iIb9U = parcelRequire("iIb9U");

var $kdjxm = parcelRequire("kdjxm");

var $foGXy = parcelRequire("foGXy");

var $fsXMV = parcelRequire("fsXMV");

var $dopAm = parcelRequire("dopAm");

var $h9jRt = parcelRequire("h9jRt");
var $32129f5e17396ca1$require$Buffer = $h9jRt.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $3PDZy(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $kdjxm(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $dopAm(new $kdjxm(enc), key);
    else msg = $foGXy(enc, key);
    var zBuffer = $32129f5e17396ca1$require$Buffer.alloc(k - msg.length);
    msg = $32129f5e17396ca1$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $32129f5e17396ca1$var$oaep(key, msg);
    else if (padding === 1) return $32129f5e17396ca1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $32129f5e17396ca1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $fsXMV('sha1').update($32129f5e17396ca1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $iIb9U(maskedSeed, $5q9Xh(maskedDb, hLen));
    var db = $iIb9U(maskedDb, $5q9Xh(seed, k - hLen - 1));
    if ($32129f5e17396ca1$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $32129f5e17396ca1$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $32129f5e17396ca1$var$compare(a, b) {
    a = $32129f5e17396ca1$require$Buffer.from(a);
    b = $32129f5e17396ca1$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("1SYIx", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $15f9eec9982dde19$export$bb1abf2ce84fc7e8, (v) => $15f9eec9982dde19$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $15f9eec9982dde19$export$2f7171e78e524d5e, (v) => $15f9eec9982dde19$export$2f7171e78e524d5e = v);
var $15f9eec9982dde19$export$bb1abf2ce84fc7e8;
var $15f9eec9982dde19$export$2f7171e78e524d5e;

var $1g1jb = parcelRequire("1g1jb");
'use strict';
function $15f9eec9982dde19$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $h9jRt = parcelRequire("h9jRt");

var $dURpS = parcelRequire("dURpS");
var $15f9eec9982dde19$var$Buffer = $h9jRt.Buffer;
var $15f9eec9982dde19$var$kBufferMaxLength = $h9jRt.kMaxLength;
var $15f9eec9982dde19$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $15f9eec9982dde19$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $15f9eec9982dde19$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $15f9eec9982dde19$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $15f9eec9982dde19$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $15f9eec9982dde19$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $15f9eec9982dde19$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $15f9eec9982dde19$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($15f9eec9982dde19$var$crypto && $15f9eec9982dde19$var$crypto.getRandomValues || false) {
    $15f9eec9982dde19$export$bb1abf2ce84fc7e8 = $15f9eec9982dde19$var$randomFill;
    $15f9eec9982dde19$export$2f7171e78e524d5e = $15f9eec9982dde19$var$randomFillSync;
} else {
    $15f9eec9982dde19$export$bb1abf2ce84fc7e8 = $15f9eec9982dde19$var$oldBrowser;
    $15f9eec9982dde19$export$2f7171e78e524d5e = $15f9eec9982dde19$var$oldBrowser;
}
function $15f9eec9982dde19$var$randomFill(buf, offset, size, cb) {
    if (!$15f9eec9982dde19$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $15f9eec9982dde19$var$assertOffset(offset, buf.length);
    $15f9eec9982dde19$var$assertSize(size, offset, buf.length);
    return $15f9eec9982dde19$var$actualFill(buf, offset, size, cb);
}
function $15f9eec9982dde19$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $15f9eec9982dde19$var$crypto.getRandomValues(uint);
    if (cb) {
        $1g1jb.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $dURpS(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $dURpS(size);
    bytes.copy(buf, offset);
    return buf;
}
function $15f9eec9982dde19$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$15f9eec9982dde19$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $15f9eec9982dde19$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $15f9eec9982dde19$var$assertSize(size, offset, buf.length);
    return $15f9eec9982dde19$var$actualFill(buf, offset, size);
}

});


parcelRegister("2RUWx", function(module, exports) {
'use strict';

var $h9jRt = parcelRequire("h9jRt");
var $216cb3be96830cc1$require$Buffer = $h9jRt.Buffer;

var $eOu4x = parcelRequire("eOu4x");
var $216cb3be96830cc1$var$MAX_OCTET = 0x80, $216cb3be96830cc1$var$CLASS_UNIVERSAL = 0, $216cb3be96830cc1$var$PRIMITIVE_BIT = 0x20, $216cb3be96830cc1$var$TAG_SEQ = 0x10, $216cb3be96830cc1$var$TAG_INT = 0x02, $216cb3be96830cc1$var$ENCODED_TAG_SEQ = $216cb3be96830cc1$var$TAG_SEQ | $216cb3be96830cc1$var$PRIMITIVE_BIT | $216cb3be96830cc1$var$CLASS_UNIVERSAL << 6, $216cb3be96830cc1$var$ENCODED_TAG_INT = $216cb3be96830cc1$var$TAG_INT | $216cb3be96830cc1$var$CLASS_UNIVERSAL << 6;
function $216cb3be96830cc1$var$base64Url(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $216cb3be96830cc1$var$signatureAsBuffer(signature) {
    if ($216cb3be96830cc1$require$Buffer.isBuffer(signature)) return signature;
    else if ('string' === typeof signature) return $216cb3be96830cc1$require$Buffer.from(signature, 'base64');
    throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}
function $216cb3be96830cc1$var$derToJose(signature, alg) {
    signature = $216cb3be96830cc1$var$signatureAsBuffer(signature);
    var paramBytes = $eOu4x(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $216cb3be96830cc1$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($216cb3be96830cc1$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $216cb3be96830cc1$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $216cb3be96830cc1$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $216cb3be96830cc1$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString('base64');
    dst = $216cb3be96830cc1$var$base64Url(dst);
    return dst;
}
function $216cb3be96830cc1$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $216cb3be96830cc1$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $216cb3be96830cc1$var$joseToDer(signature, alg) {
    signature = $216cb3be96830cc1$var$signatureAsBuffer(signature);
    var paramBytes = $eOu4x(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $216cb3be96830cc1$var$countPadding(signature, 0, paramBytes);
    var sPadding = $216cb3be96830cc1$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $216cb3be96830cc1$var$MAX_OCTET;
    var dst = $216cb3be96830cc1$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $216cb3be96830cc1$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $216cb3be96830cc1$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $216cb3be96830cc1$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $216cb3be96830cc1$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $216cb3be96830cc1$var$derToJose,
    joseToDer: $216cb3be96830cc1$var$joseToDer
};

});
parcelRegister("eOu4x", function(module, exports) {
'use strict';
function $ac8d0fe9349f71e9$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $ac8d0fe9349f71e9$var$paramBytesForAlg = {
    ES256: $ac8d0fe9349f71e9$var$getParamSize(256),
    ES384: $ac8d0fe9349f71e9$var$getParamSize(384),
    ES512: $ac8d0fe9349f71e9$var$getParamSize(521)
};
function $ac8d0fe9349f71e9$var$getParamBytesForAlg(alg) {
    var paramBytes = $ac8d0fe9349f71e9$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $ac8d0fe9349f71e9$var$getParamBytesForAlg;

});


parcelRegister("2Nmqw", function(module, exports) {
/*jshint node:true */ 'use strict';

var $dOfWq = parcelRequire("dOfWq");
var $20918ddc2c266179$require$Buffer = $dOfWq.Buffer;

var $dOfWq = parcelRequire("dOfWq");
var $20918ddc2c266179$require$SlowBuffer = $dOfWq.SlowBuffer;
module.exports = $20918ddc2c266179$var$bufferEq;
function $20918ddc2c266179$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$20918ddc2c266179$require$Buffer.isBuffer(a) || !$20918ddc2c266179$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$20918ddc2c266179$var$bufferEq.install = function() {
    $20918ddc2c266179$require$Buffer.prototype.equal = $20918ddc2c266179$require$SlowBuffer.prototype.equal = function equal(that) {
        return $20918ddc2c266179$var$bufferEq(this, that);
    };
};
var $20918ddc2c266179$var$origBufEqual = $20918ddc2c266179$require$Buffer.prototype.equal;
var $20918ddc2c266179$var$origSlowBufEqual = $20918ddc2c266179$require$SlowBuffer.prototype.equal;
$20918ddc2c266179$var$bufferEq.restore = function() {
    $20918ddc2c266179$require$Buffer.prototype.equal = $20918ddc2c266179$var$origBufEqual;
    $20918ddc2c266179$require$SlowBuffer.prototype.equal = $20918ddc2c266179$var$origSlowBufEqual;
};

});


parcelRegister("3nxH7", function(module, exports) {
/*global module*/ 
var $dOfWq = parcelRequire("dOfWq");
var $275da81d274e2300$require$Buffer = $dOfWq.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number' || $275da81d274e2300$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("b5Fjh", function(module, exports) {
/*global module*/ 
var $h9jRt = parcelRequire("h9jRt");
var $8130349d200fd305$require$Buffer = $h9jRt.Buffer;

var $ahiF8 = parcelRequire("ahiF8");

var $bOSsC = parcelRequire("bOSsC");

var $9Bpih = parcelRequire("9Bpih");

var $3nxH7 = parcelRequire("3nxH7");

var $en6bb = parcelRequire("en6bb");
var $8130349d200fd305$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $8130349d200fd305$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === '[object Object]';
}
function $8130349d200fd305$var$safeJsonParse(thing) {
    if ($8130349d200fd305$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $8130349d200fd305$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split('.', 1)[0];
    return $8130349d200fd305$var$safeJsonParse($8130349d200fd305$require$Buffer.from(encodedHeader, 'base64').toString('binary'));
}
function $8130349d200fd305$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split('.', 2).join('.');
}
function $8130349d200fd305$var$signatureFromJWS(jwsSig) {
    return jwsSig.split('.')[2];
}
function $8130349d200fd305$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || 'utf8';
    var payload = jwsSig.split('.')[1];
    return $8130349d200fd305$require$Buffer.from(payload, 'base64').toString(encoding);
}
function $8130349d200fd305$var$isValidJws(string) {
    return $8130349d200fd305$var$JWS_REGEX.test(string) && !!$8130349d200fd305$var$headerFromJWS(string);
}
function $8130349d200fd305$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $3nxH7(jwsSig);
    var signature = $8130349d200fd305$var$signatureFromJWS(jwsSig);
    var securedInput = $8130349d200fd305$var$securedInputFromJWS(jwsSig);
    var algo = $bOSsC(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $8130349d200fd305$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $3nxH7(jwsSig);
    if (!$8130349d200fd305$var$isValidJws(jwsSig)) return null;
    var header = $8130349d200fd305$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $8130349d200fd305$var$payloadFromJWS(jwsSig);
    if (header.typ === 'JWT' || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $8130349d200fd305$var$signatureFromJWS(jwsSig)
    };
}
function $8130349d200fd305$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret;
    secretOrKey = secretOrKey == null ? opts.publicKey : secretOrKey;
    secretOrKey = secretOrKey == null ? opts.key : secretOrKey;
    if (/^hs/i.test(opts.algorithm) === true && secretOrKey == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $ahiF8(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $ahiF8(opts.signature);
    this.secret.once('close', (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once('close', (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$en6bb.inherits($8130349d200fd305$var$VerifyStream, $9Bpih);
$8130349d200fd305$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $8130349d200fd305$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $8130349d200fd305$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit('done', valid, obj);
        this.emit('data', valid);
        this.emit('end');
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$8130349d200fd305$var$VerifyStream.decode = $8130349d200fd305$var$jwsDecode;
$8130349d200fd305$var$VerifyStream.isValid = $8130349d200fd305$var$isValidJws;
$8130349d200fd305$var$VerifyStream.verify = $8130349d200fd305$var$jwsVerify;
module.exports = $8130349d200fd305$var$VerifyStream;

});



parcelRegister("65yQz", function(module, exports) {

var $dOfWq = parcelRequire("dOfWq");
var $46ee3d93358ddc16$require$Buffer = $dOfWq.Buffer;

var $gxjpB = parcelRequire("gxjpB");

var $318Pk = parcelRequire("318Pk");

var $04KOf = parcelRequire("04KOf");

var $gW33N = parcelRequire("gW33N");

var $1ihuL = parcelRequire("1ihuL");

var $90dQl = parcelRequire("90dQl");

var $9ntuM = parcelRequire("9ntuM");

var $3iamx = parcelRequire("3iamx");

var $lRcAu = parcelRequire("lRcAu");
var $46ee3d93358ddc16$require$KeyObject = $lRcAu.KeyObject;
var $46ee3d93358ddc16$require$createSecretKey = $lRcAu.createSecretKey;
var $46ee3d93358ddc16$require$createPublicKey = $lRcAu.createPublicKey;
const $46ee3d93358ddc16$var$PUB_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
const $46ee3d93358ddc16$var$EC_KEY_ALGS = [
    'ES256',
    'ES384',
    'ES512'
];
const $46ee3d93358ddc16$var$RSA_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
const $46ee3d93358ddc16$var$HS_ALGS = [
    'HS256',
    'HS384',
    'HS512'
];
if ($9ntuM) {
    $46ee3d93358ddc16$var$PUB_KEY_ALGS.splice($46ee3d93358ddc16$var$PUB_KEY_ALGS.length, 0, 'PS256', 'PS384', 'PS512');
    $46ee3d93358ddc16$var$RSA_KEY_ALGS.splice($46ee3d93358ddc16$var$RSA_KEY_ALGS.length, 0, 'PS256', 'PS384', 'PS512');
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === 'function' && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    let done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') return done(new $gxjpB('clockTimestamp must be a number'));
    if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) return done(new $gxjpB('nonce must be a non-empty string'));
    if (options.allowInvalidAsymmetricKeyTypes !== undefined && typeof options.allowInvalidAsymmetricKeyTypes !== 'boolean') return done(new $gxjpB('allowInvalidAsymmetricKeyTypes must be a boolean'));
    const clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $gxjpB('jwt must be provided'));
    if (typeof jwtString !== 'string') return done(new $gxjpB('jwt must be a string'));
    const parts = jwtString.split('.');
    if (parts.length !== 3) return done(new $gxjpB('jwt malformed'));
    let decodedToken;
    try {
        decodedToken = $gW33N(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $gxjpB('invalid token'));
    const header = decodedToken.header;
    let getSecret;
    if (typeof secretOrPublicKey === 'function') {
        if (!callback) return done(new $gxjpB('verify must be called asynchronous if secret or public key is provided as a callback'));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $gxjpB('error in secret or public key callback: ' + err.message));
        const hasSignature = parts[2].trim() !== '';
        if (!hasSignature && secretOrPublicKey) return done(new $gxjpB('jwt signature is required'));
        if (hasSignature && !secretOrPublicKey) return done(new $gxjpB('secret or public key must be provided'));
        if (!hasSignature && !options.algorithms) return done(new $gxjpB('please specify "none" in "algorithms" to verify unsigned tokens'));
        if (secretOrPublicKey != null && !(secretOrPublicKey instanceof $46ee3d93358ddc16$require$KeyObject)) try {
            secretOrPublicKey = $46ee3d93358ddc16$require$createPublicKey(secretOrPublicKey);
        } catch (_) {
            try {
                secretOrPublicKey = $46ee3d93358ddc16$require$createSecretKey(typeof secretOrPublicKey === 'string' ? $46ee3d93358ddc16$require$Buffer.from(secretOrPublicKey) : secretOrPublicKey);
            } catch (_) {
                return done(new $gxjpB('secretOrPublicKey is not valid key material'));
            }
        }
        if (!options.algorithms) {
            if (secretOrPublicKey.type === 'secret') options.algorithms = $46ee3d93358ddc16$var$HS_ALGS;
            else if ([
                'rsa',
                'rsa-pss'
            ].includes(secretOrPublicKey.asymmetricKeyType)) options.algorithms = $46ee3d93358ddc16$var$RSA_KEY_ALGS;
            else if (secretOrPublicKey.asymmetricKeyType === 'ec') options.algorithms = $46ee3d93358ddc16$var$EC_KEY_ALGS;
            else options.algorithms = $46ee3d93358ddc16$var$PUB_KEY_ALGS;
        }
        if (options.algorithms.indexOf(decodedToken.header.alg) === -1) return done(new $gxjpB('invalid algorithm'));
        if (header.alg.startsWith('HS') && secretOrPublicKey.type !== 'secret') return done(new $gxjpB(`secretOrPublicKey must be a symmetric key when using ${header.alg}`));
        else if (/^(?:RS|PS|ES)/.test(header.alg) && secretOrPublicKey.type !== 'public') return done(new $gxjpB(`secretOrPublicKey must be an asymmetric key when using ${header.alg}`));
        if (!options.allowInvalidAsymmetricKeyTypes) try {
            $90dQl(header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        let valid;
        try {
            valid = $3iamx.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $gxjpB('invalid signature'));
        const payload = decodedToken.payload;
        if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== 'number') return done(new $gxjpB('invalid nbf value'));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $318Pk('jwt not active', new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
            if (typeof payload.exp !== 'number') return done(new $gxjpB('invalid exp value'));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $04KOf('jwt expired', new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            const audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            const target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            const match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $gxjpB('jwt audience invalid. expected: ' + audiences.join(' or ')));
        }
        if (options.issuer) {
            const invalid_issuer = typeof options.issuer === 'string' && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $gxjpB('jwt issuer invalid. expected: ' + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $gxjpB('jwt subject invalid. expected: ' + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $gxjpB('jwt jwtid invalid. expected: ' + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $gxjpB('jwt nonce invalid. expected: ' + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== 'number') return done(new $gxjpB('iat required when maxAge is specified'));
            const maxAgeTimestamp = $1ihuL(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === 'undefined') return done(new $gxjpB('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $04KOf('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            const signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("gxjpB", function(module, exports) {
var $c09ec93d8946fc56$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = 'JsonWebTokenError';
    this.message = message;
    if (error) this.inner = error;
};
$c09ec93d8946fc56$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$c09ec93d8946fc56$var$JsonWebTokenError.prototype.constructor = $c09ec93d8946fc56$var$JsonWebTokenError;
module.exports = $c09ec93d8946fc56$var$JsonWebTokenError;

});

parcelRegister("318Pk", function(module, exports) {

var $gxjpB = parcelRequire("gxjpB");
var $23284fea08440d30$var$NotBeforeError = function(message, date) {
    $gxjpB.call(this, message);
    this.name = 'NotBeforeError';
    this.date = date;
};
$23284fea08440d30$var$NotBeforeError.prototype = Object.create($gxjpB.prototype);
$23284fea08440d30$var$NotBeforeError.prototype.constructor = $23284fea08440d30$var$NotBeforeError;
module.exports = $23284fea08440d30$var$NotBeforeError;

});

parcelRegister("04KOf", function(module, exports) {

var $gxjpB = parcelRequire("gxjpB");
var $00e4af3ed198e504$var$TokenExpiredError = function(message, expiredAt) {
    $gxjpB.call(this, message);
    this.name = 'TokenExpiredError';
    this.expiredAt = expiredAt;
};
$00e4af3ed198e504$var$TokenExpiredError.prototype = Object.create($gxjpB.prototype);
$00e4af3ed198e504$var$TokenExpiredError.prototype.constructor = $00e4af3ed198e504$var$TokenExpiredError;
module.exports = $00e4af3ed198e504$var$TokenExpiredError;

});

parcelRegister("1ihuL", function(module, exports) {

var $8YQFQ = parcelRequire("8YQFQ");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === 'string') {
        var milliseconds = $8YQFQ(time);
        if (typeof milliseconds === 'undefined') return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === 'number') return timestamp + time;
    else return;
};

});
parcelRegister("8YQFQ", function(module, exports) {
/**
 * Helpers.
 */ var $689cc94442fd616b$var$s = 1000;
var $689cc94442fd616b$var$m = $689cc94442fd616b$var$s * 60;
var $689cc94442fd616b$var$h = $689cc94442fd616b$var$m * 60;
var $689cc94442fd616b$var$d = $689cc94442fd616b$var$h * 24;
var $689cc94442fd616b$var$w = $689cc94442fd616b$var$d * 7;
var $689cc94442fd616b$var$y = $689cc94442fd616b$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $689cc94442fd616b$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $689cc94442fd616b$var$fmtLong(val) : $689cc94442fd616b$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $689cc94442fd616b$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $689cc94442fd616b$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $689cc94442fd616b$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $689cc94442fd616b$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $689cc94442fd616b$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $689cc94442fd616b$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $689cc94442fd616b$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $689cc94442fd616b$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $689cc94442fd616b$var$d) return Math.round(ms / $689cc94442fd616b$var$d) + 'd';
    if (msAbs >= $689cc94442fd616b$var$h) return Math.round(ms / $689cc94442fd616b$var$h) + 'h';
    if (msAbs >= $689cc94442fd616b$var$m) return Math.round(ms / $689cc94442fd616b$var$m) + 'm';
    if (msAbs >= $689cc94442fd616b$var$s) return Math.round(ms / $689cc94442fd616b$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $689cc94442fd616b$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $689cc94442fd616b$var$d) return $689cc94442fd616b$var$plural(ms, msAbs, $689cc94442fd616b$var$d, 'day');
    if (msAbs >= $689cc94442fd616b$var$h) return $689cc94442fd616b$var$plural(ms, msAbs, $689cc94442fd616b$var$h, 'hour');
    if (msAbs >= $689cc94442fd616b$var$m) return $689cc94442fd616b$var$plural(ms, msAbs, $689cc94442fd616b$var$m, 'minute');
    if (msAbs >= $689cc94442fd616b$var$s) return $689cc94442fd616b$var$plural(ms, msAbs, $689cc94442fd616b$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $689cc94442fd616b$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});


parcelRegister("90dQl", function(module, exports) {

var $dHn8f = parcelRequire("dHn8f");

var $aKvUz = parcelRequire("aKvUz");
const $68deda1c87b2825a$var$allowedAlgorithmsForKeys = {
    'ec': [
        'ES256',
        'ES384',
        'ES512'
    ],
    'rsa': [
        'RS256',
        'PS256',
        'RS384',
        'PS384',
        'RS512',
        'PS512'
    ],
    'rsa-pss': [
        'PS256',
        'PS384',
        'PS512'
    ]
};
const $68deda1c87b2825a$var$allowedCurves = {
    ES256: 'prime256v1',
    ES384: 'secp384r1',
    ES512: 'secp521r1'
};
module.exports = function(algorithm, key) {
    if (!algorithm || !key) return;
    const keyType = key.asymmetricKeyType;
    if (!keyType) return;
    const allowedAlgorithms = $68deda1c87b2825a$var$allowedAlgorithmsForKeys[keyType];
    if (!allowedAlgorithms) throw new Error(`Unknown key type "${keyType}".`);
    if (!allowedAlgorithms.includes(algorithm)) throw new Error(`"alg" parameter for "${keyType}" key type must be one of: ${allowedAlgorithms.join(', ')}.`);
    /*
   * Ignore the next block from test coverage because it gets executed
   * conditionally depending on the Node version. Not ignoring it would
   * prevent us from reaching the target % of coverage for versions of
   * Node under 15.7.0.
   */ /* istanbul ignore next */ if ($dHn8f) switch(keyType){
        case 'ec':
            const keyCurve = key.asymmetricKeyDetails.namedCurve;
            const allowedCurve = $68deda1c87b2825a$var$allowedCurves[algorithm];
            if (keyCurve !== allowedCurve) throw new Error(`"alg" parameter "${algorithm}" requires curve "${allowedCurve}".`);
            break;
        case 'rsa-pss':
            if ($aKvUz) {
                const length = parseInt(algorithm.slice(-3), 10);
                const { hashAlgorithm: hashAlgorithm, mgf1HashAlgorithm: mgf1HashAlgorithm, saltLength: saltLength } = key.asymmetricKeyDetails;
                if (hashAlgorithm !== `sha${length}` || mgf1HashAlgorithm !== hashAlgorithm) throw new Error(`Invalid key for this operation, its RSA-PSS parameters do not meet the requirements of "alg" ${algorithm}.`);
                if (saltLength !== undefined && saltLength > length >> 3) throw new Error(`Invalid key for this operation, its RSA-PSS parameter saltLength does not meet the requirements of "alg" ${algorithm}.`);
            }
            break;
    }
};

});
parcelRegister("dHn8f", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");

var $dOyS4 = parcelRequire("dOyS4");
module.exports = $dOyS4.satisfies($1g1jb.version, '>=15.7.0');

});
parcelRegister("dOyS4", function(module, exports) {
'use strict';

var $ZcBBp = parcelRequire("ZcBBp");

var $ktfCW = parcelRequire("ktfCW");

var $3z49e = parcelRequire("3z49e");

var $6mfvV = parcelRequire("6mfvV");

var $c94P3 = parcelRequire("c94P3");

var $1cAsV = parcelRequire("1cAsV");

var $2vf3b = parcelRequire("2vf3b");

var $2DeLf = parcelRequire("2DeLf");

var $1DcWL = parcelRequire("1DcWL");

var $hMyQy = parcelRequire("hMyQy");

var $krYaS = parcelRequire("krYaS");

var $9wGKh = parcelRequire("9wGKh");

var $d205C = parcelRequire("d205C");

var $h2zGw = parcelRequire("h2zGw");

var $fJsiA = parcelRequire("fJsiA");

var $jyLd5 = parcelRequire("jyLd5");

var $c7XKu = parcelRequire("c7XKu");

var $eYVvM = parcelRequire("eYVvM");

var $3bgI9 = parcelRequire("3bgI9");

var $3HST1 = parcelRequire("3HST1");

var $gRrFx = parcelRequire("gRrFx");

var $1yZ6D = parcelRequire("1yZ6D");

var $27Nj4 = parcelRequire("27Nj4");

var $89biI = parcelRequire("89biI");

var $jE8gs = parcelRequire("jE8gs");

var $d7upZ = parcelRequire("d7upZ");

var $2bapw = parcelRequire("2bapw");

var $cXKvr = parcelRequire("cXKvr");

var $34UP3 = parcelRequire("34UP3");

var $iK8LJ = parcelRequire("iK8LJ");

var $1Dw6N = parcelRequire("1Dw6N");

var $j60KK = parcelRequire("j60KK");

var $6sDoi = parcelRequire("6sDoi");

var $e37PC = parcelRequire("e37PC");

var $ddfSj = parcelRequire("ddfSj");

var $2eMV5 = parcelRequire("2eMV5");

var $1JcM7 = parcelRequire("1JcM7");

var $jFJG3 = parcelRequire("jFJG3");

var $b756H = parcelRequire("b756H");

var $grqMG = parcelRequire("grqMG");

var $yH1VW = parcelRequire("yH1VW");

var $3eqcP = parcelRequire("3eqcP");
module.exports = {
    parse: $c94P3,
    valid: $1cAsV,
    clean: $2vf3b,
    inc: $2DeLf,
    diff: $1DcWL,
    major: $hMyQy,
    minor: $krYaS,
    patch: $9wGKh,
    prerelease: $d205C,
    compare: $h2zGw,
    rcompare: $fJsiA,
    compareLoose: $jyLd5,
    compareBuild: $c7XKu,
    sort: $eYVvM,
    rsort: $3bgI9,
    gt: $3HST1,
    lt: $gRrFx,
    eq: $1yZ6D,
    neq: $27Nj4,
    gte: $89biI,
    lte: $jE8gs,
    cmp: $d7upZ,
    coerce: $2bapw,
    truncate: $cXKvr,
    Comparator: $34UP3,
    Range: $iK8LJ,
    satisfies: $1Dw6N,
    toComparators: $j60KK,
    maxSatisfying: $6sDoi,
    minSatisfying: $e37PC,
    minVersion: $ddfSj,
    validRange: $2eMV5,
    outside: $1JcM7,
    gtr: $jFJG3,
    ltr: $b756H,
    intersects: $grqMG,
    simplifyRange: $yH1VW,
    subset: $3eqcP,
    SemVer: $3z49e,
    re: $ZcBBp.re,
    src: $ZcBBp.src,
    tokens: $ZcBBp.t,
    SEMVER_SPEC_VERSION: $ktfCW.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $ktfCW.RELEASE_TYPES,
    compareIdentifiers: $6mfvV.compareIdentifiers,
    rcompareIdentifiers: $6mfvV.rcompareIdentifiers
};

});
parcelRegister("ZcBBp", function(module, exports) {
'use strict';

var $ktfCW = parcelRequire("ktfCW");
var $0b7f79ced623f1e4$require$MAX_SAFE_COMPONENT_LENGTH = $ktfCW.MAX_SAFE_COMPONENT_LENGTH;
var $0b7f79ced623f1e4$require$MAX_SAFE_BUILD_LENGTH = $ktfCW.MAX_SAFE_BUILD_LENGTH;
var $0b7f79ced623f1e4$require$MAX_LENGTH = $ktfCW.MAX_LENGTH;

var $kCwKi = parcelRequire("kCwKi");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const safeSrc = exports.safeSrc = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        $0b7f79ced623f1e4$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $0b7f79ced623f1e4$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $kCwKi(name, index, value);
    t[name] = index;
    src[index] = value;
    safeSrc[index] = safe;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
// Non-numeric identifiers include numeric identifiers but can be longer.
// Therefore non-numeric identifiers must go first.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NONNUMERICIDENTIFIER]}|${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifier, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCEPLAIN', `${"(^|[^\\d])(\\d{1,"}${$0b7f79ced623f1e4$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$0b7f79ced623f1e4$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$0b7f79ced623f1e4$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken('COERCE', `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken('COERCEFULL', src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
createToken('COERCERTLFULL', src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

});
parcelRegister("ktfCW", function(module, exports) {
'use strict';
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $ee72a3454b0c69e6$var$SEMVER_SPEC_VERSION = '2.0.0';
const $ee72a3454b0c69e6$var$MAX_LENGTH = 256;
const $ee72a3454b0c69e6$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $ee72a3454b0c69e6$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $ee72a3454b0c69e6$var$MAX_SAFE_BUILD_LENGTH = $ee72a3454b0c69e6$var$MAX_LENGTH - 6;
const $ee72a3454b0c69e6$var$RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH: $ee72a3454b0c69e6$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $ee72a3454b0c69e6$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $ee72a3454b0c69e6$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $ee72a3454b0c69e6$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $ee72a3454b0c69e6$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $ee72a3454b0c69e6$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("kCwKi", function(module, exports) {
'use strict';
const $f030c1d9eaed8d73$var$debug = ()=>{};
module.exports = $f030c1d9eaed8d73$var$debug;

});


parcelRegister("3z49e", function(module, exports) {
'use strict';

var $kCwKi = parcelRequire("kCwKi");

var $ktfCW = parcelRequire("ktfCW");
var $2987dbaef44d7811$require$MAX_LENGTH = $ktfCW.MAX_LENGTH;
var $2987dbaef44d7811$require$MAX_SAFE_INTEGER = $ktfCW.MAX_SAFE_INTEGER;

var $ZcBBp = parcelRequire("ZcBBp");
var $2987dbaef44d7811$require$re = $ZcBBp.safeRe;
var $2987dbaef44d7811$require$t = $ZcBBp.t;

var $aiTsb = parcelRequire("aiTsb");

var $6mfvV = parcelRequire("6mfvV");
var $2987dbaef44d7811$require$compareIdentifiers = $6mfvV.compareIdentifiers;
const $2987dbaef44d7811$var$isPrereleaseIdentifier = (prerelease, identifier)=>{
    const identifiers = identifier.split('.');
    if (identifiers.length > prerelease.length) return false;
    for(let i = 0; i < identifiers.length; i++){
        if ($2987dbaef44d7811$require$compareIdentifiers(prerelease[i], identifiers[i]) !== 0) return false;
    }
    return true;
};
class $2987dbaef44d7811$var$SemVer {
    constructor(version, options){
        options = $aiTsb(options);
        if (version instanceof $2987dbaef44d7811$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $2987dbaef44d7811$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$2987dbaef44d7811$require$MAX_LENGTH} characters`);
        $kCwKi('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $2987dbaef44d7811$require$re[$2987dbaef44d7811$require$t.LOOSE] : $2987dbaef44d7811$require$re[$2987dbaef44d7811$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $2987dbaef44d7811$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > $2987dbaef44d7811$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > $2987dbaef44d7811$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $2987dbaef44d7811$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $kCwKi('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof $2987dbaef44d7811$var$SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new $2987dbaef44d7811$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $2987dbaef44d7811$var$SemVer)) other = new $2987dbaef44d7811$var$SemVer(other, this.options);
        if (this.major < other.major) return -1;
        if (this.major > other.major) return 1;
        if (this.minor < other.minor) return -1;
        if (this.minor > other.minor) return 1;
        if (this.patch < other.patch) return -1;
        if (this.patch > other.patch) return 1;
        return 0;
    }
    comparePre(other) {
        if (!(other instanceof $2987dbaef44d7811$var$SemVer)) other = new $2987dbaef44d7811$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $kCwKi('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $2987dbaef44d7811$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $2987dbaef44d7811$var$SemVer)) other = new $2987dbaef44d7811$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $kCwKi('build compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $2987dbaef44d7811$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        if (release.startsWith('pre')) {
            if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
            // Avoid an invalid semver results
            if (identifier) {
                const match = `-${identifier}`.match(this.options.loose ? $2987dbaef44d7811$require$re[$2987dbaef44d7811$require$t.PRERELEASELOOSE] : $2987dbaef44d7811$require$re[$2987dbaef44d7811$require$t.PRERELEASE]);
                if (!match || match[1] !== identifier) throw new Error(`invalid identifier: ${identifier}`);
            }
        }
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'release':
                if (this.prerelease.length === 0) throw new Error(`version ${this.raw} is not a prerelease`);
                this.prerelease.length = 0;
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($2987dbaef44d7811$var$isPrereleaseIdentifier(this.prerelease, identifier)) {
                            const prereleaseBase = this.prerelease[identifier.split('.').length];
                            if (isNaN(prereleaseBase)) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = $2987dbaef44d7811$var$SemVer;

});
parcelRegister("aiTsb", function(module, exports) {
'use strict';
// parse out just the options we care about
const $780699bc48afb68b$var$looseOption = Object.freeze({
    loose: true
});
const $780699bc48afb68b$var$emptyOpts = Object.freeze({});
const $780699bc48afb68b$var$parseOptions = (options)=>{
    if (!options) return $780699bc48afb68b$var$emptyOpts;
    if (typeof options !== 'object') return $780699bc48afb68b$var$looseOption;
    return options;
};
module.exports = $780699bc48afb68b$var$parseOptions;

});

parcelRegister("6mfvV", function(module, exports) {
'use strict';
const $4a10d4e99df34e66$var$numeric = /^[0-9]+$/;
const $4a10d4e99df34e66$var$compareIdentifiers = (a, b)=>{
    if (typeof a === 'number' && typeof b === 'number') return a === b ? 0 : a < b ? -1 : 1;
    const anum = $4a10d4e99df34e66$var$numeric.test(a);
    const bnum = $4a10d4e99df34e66$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $4a10d4e99df34e66$var$rcompareIdentifiers = (a, b)=>$4a10d4e99df34e66$var$compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers: $4a10d4e99df34e66$var$compareIdentifiers,
    rcompareIdentifiers: $4a10d4e99df34e66$var$rcompareIdentifiers
};

});


parcelRegister("c94P3", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $8d7a10ee26ae8124$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $3z49e) return version;
    try {
        return new $3z49e(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = $8d7a10ee26ae8124$var$parse;

});

parcelRegister("1cAsV", function(module, exports) {
'use strict';

var $c94P3 = parcelRequire("c94P3");
const $0e0332b7376c922e$var$valid = (version, options)=>{
    const v = $c94P3(version, options);
    return v ? v.version : null;
};
module.exports = $0e0332b7376c922e$var$valid;

});

parcelRegister("2vf3b", function(module, exports) {
'use strict';

var $c94P3 = parcelRequire("c94P3");
const $1d2a26b3946c1e90$var$clean = (version, options)=>{
    const s = $c94P3(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = $1d2a26b3946c1e90$var$clean;

});

parcelRegister("2DeLf", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $1eaaac8d18a41e3f$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $3z49e(version instanceof $3z49e ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = $1eaaac8d18a41e3f$var$inc;

});

parcelRegister("1DcWL", function(module, exports) {
'use strict';

var $c94P3 = parcelRequire("c94P3");
const $130379eeecb9c164$var$diff = (version1, version2)=>{
    const v1 = $c94P3(version1, null, true);
    const v2 = $c94P3(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // If the main part has no difference
        if (lowVersion.compareMain(highVersion) === 0) {
            if (lowVersion.minor && !lowVersion.patch) return 'minor';
            return 'patch';
        }
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are prereleases
    return 'prerelease';
};
module.exports = $130379eeecb9c164$var$diff;

});

parcelRegister("hMyQy", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $cf21f32847ab6053$var$major = (a, loose)=>new $3z49e(a, loose).major;
module.exports = $cf21f32847ab6053$var$major;

});

parcelRegister("krYaS", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $ee3501a985ad67a5$var$minor = (a, loose)=>new $3z49e(a, loose).minor;
module.exports = $ee3501a985ad67a5$var$minor;

});

parcelRegister("9wGKh", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $6ef84296368ad001$var$patch = (a, loose)=>new $3z49e(a, loose).patch;
module.exports = $6ef84296368ad001$var$patch;

});

parcelRegister("d205C", function(module, exports) {
'use strict';

var $c94P3 = parcelRequire("c94P3");
const $97cb88118297539d$var$prerelease = (version, options)=>{
    const parsed = $c94P3(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $97cb88118297539d$var$prerelease;

});

parcelRegister("h2zGw", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $c67e4dd03fc479d4$var$compare = (a, b, loose)=>new $3z49e(a, loose).compare(new $3z49e(b, loose));
module.exports = $c67e4dd03fc479d4$var$compare;

});

parcelRegister("fJsiA", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $b741028b708a5187$var$rcompare = (a, b, loose)=>$h2zGw(b, a, loose);
module.exports = $b741028b708a5187$var$rcompare;

});

parcelRegister("jyLd5", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $e3d5d0357718d422$var$compareLoose = (a, b)=>$h2zGw(a, b, true);
module.exports = $e3d5d0357718d422$var$compareLoose;

});

parcelRegister("c7XKu", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");
const $8d447c60e843260d$var$compareBuild = (a, b, loose)=>{
    const versionA = new $3z49e(a, loose);
    const versionB = new $3z49e(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $8d447c60e843260d$var$compareBuild;

});

parcelRegister("eYVvM", function(module, exports) {
'use strict';

var $c7XKu = parcelRequire("c7XKu");
const $ae8347e8dabdab74$var$sort = (list, loose)=>list.sort((a, b)=>$c7XKu(a, b, loose));
module.exports = $ae8347e8dabdab74$var$sort;

});

parcelRegister("3bgI9", function(module, exports) {
'use strict';

var $c7XKu = parcelRequire("c7XKu");
const $250f5cae7f4aedad$var$rsort = (list, loose)=>list.sort((a, b)=>$c7XKu(b, a, loose));
module.exports = $250f5cae7f4aedad$var$rsort;

});

parcelRegister("3HST1", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $2b2ff68b2421c048$var$gt = (a, b, loose)=>$h2zGw(a, b, loose) > 0;
module.exports = $2b2ff68b2421c048$var$gt;

});

parcelRegister("gRrFx", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $c4670f13f89d9148$var$lt = (a, b, loose)=>$h2zGw(a, b, loose) < 0;
module.exports = $c4670f13f89d9148$var$lt;

});

parcelRegister("1yZ6D", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $12385dd378fb85b8$var$eq = (a, b, loose)=>$h2zGw(a, b, loose) === 0;
module.exports = $12385dd378fb85b8$var$eq;

});

parcelRegister("27Nj4", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $18c27b7fcb1e0242$var$neq = (a, b, loose)=>$h2zGw(a, b, loose) !== 0;
module.exports = $18c27b7fcb1e0242$var$neq;

});

parcelRegister("89biI", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $5ee7ee211a0f0ffc$var$gte = (a, b, loose)=>$h2zGw(a, b, loose) >= 0;
module.exports = $5ee7ee211a0f0ffc$var$gte;

});

parcelRegister("jE8gs", function(module, exports) {
'use strict';

var $h2zGw = parcelRequire("h2zGw");
const $e4d829eb5c048787$var$lte = (a, b, loose)=>$h2zGw(a, b, loose) <= 0;
module.exports = $e4d829eb5c048787$var$lte;

});

parcelRegister("d7upZ", function(module, exports) {
'use strict';

var $1yZ6D = parcelRequire("1yZ6D");

var $27Nj4 = parcelRequire("27Nj4");

var $3HST1 = parcelRequire("3HST1");

var $89biI = parcelRequire("89biI");

var $gRrFx = parcelRequire("gRrFx");

var $jE8gs = parcelRequire("jE8gs");
const $98d38638865240c5$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return $1yZ6D(a, b, loose);
        case '!=':
            return $27Nj4(a, b, loose);
        case '>':
            return $3HST1(a, b, loose);
        case '>=':
            return $89biI(a, b, loose);
        case '<':
            return $gRrFx(a, b, loose);
        case '<=':
            return $jE8gs(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = $98d38638865240c5$var$cmp;

});

parcelRegister("2bapw", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");

var $c94P3 = parcelRequire("c94P3");

var $ZcBBp = parcelRequire("ZcBBp");
var $1964af2e6a5bdcfc$require$re = $ZcBBp.safeRe;
var $1964af2e6a5bdcfc$require$t = $ZcBBp.t;
const $1964af2e6a5bdcfc$var$coerce = (version, options)=>{
    if (version instanceof $3z49e) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $1964af2e6a5bdcfc$require$re[$1964af2e6a5bdcfc$require$t.COERCEFULL] : $1964af2e6a5bdcfc$require$re[$1964af2e6a5bdcfc$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $1964af2e6a5bdcfc$require$re[$1964af2e6a5bdcfc$require$t.COERCERTLFULL] : $1964af2e6a5bdcfc$require$re[$1964af2e6a5bdcfc$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || '0';
    const patch = match[4] || '0';
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : '';
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : '';
    return $c94P3(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
module.exports = $1964af2e6a5bdcfc$var$coerce;

});

parcelRegister("cXKvr", function(module, exports) {
'use strict';

var $c94P3 = parcelRequire("c94P3");

var $ktfCW = parcelRequire("ktfCW");

var $3z49e = parcelRequire("3z49e");
const $96ff11e4cdbee034$var$truncate = (version, truncation, options)=>{
    if (!$ktfCW.RELEASE_TYPES.includes(truncation)) return null;
    const clonedVersion = $96ff11e4cdbee034$var$cloneInputVersion(version, options);
    return clonedVersion && $96ff11e4cdbee034$var$doTruncation(clonedVersion, truncation);
};
const $96ff11e4cdbee034$var$cloneInputVersion = (version, options)=>{
    const versionStringToParse = version instanceof $3z49e ? version.version : version;
    return $c94P3(versionStringToParse, options);
};
const $96ff11e4cdbee034$var$doTruncation = (version, truncation)=>{
    if ($96ff11e4cdbee034$var$isPrerelease(truncation)) return version.version;
    version.prerelease = [];
    switch(truncation){
        case 'major':
            version.minor = 0;
            version.patch = 0;
            break;
        case 'minor':
            version.patch = 0;
            break;
    }
    return version.format();
};
const $96ff11e4cdbee034$var$isPrerelease = (type)=>{
    return type.startsWith('pre');
};
module.exports = $96ff11e4cdbee034$var$truncate;

});

parcelRegister("34UP3", function(module, exports) {
'use strict';
const $23ddd2931d17bd07$var$ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class $23ddd2931d17bd07$var$Comparator {
    static get ANY() {
        return $23ddd2931d17bd07$var$ANY;
    }
    constructor(comp, options){
        options = $aiTsb(options);
        if (comp instanceof $23ddd2931d17bd07$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        $kCwKi('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $23ddd2931d17bd07$var$ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        $kCwKi('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? $23ddd2931d17bd07$require$re[$23ddd2931d17bd07$require$t.COMPARATORLOOSE] : $23ddd2931d17bd07$require$re[$23ddd2931d17bd07$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $23ddd2931d17bd07$var$ANY;
        else this.semver = new $3z49e(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $kCwKi('Comparator.test', version, this.options.loose);
        if (this.semver === $23ddd2931d17bd07$var$ANY || version === $23ddd2931d17bd07$var$ANY) return true;
        if (typeof version === 'string') try {
            version = new $3z49e(version, this.options);
        } catch (er) {
            return false;
        }
        return $d7upZ(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $23ddd2931d17bd07$var$Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new $iK8LJ(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new $iK8LJ(this.value, options).test(comp.semver);
        }
        options = $aiTsb(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if ($d7upZ(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if ($d7upZ(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = $23ddd2931d17bd07$var$Comparator;

var $aiTsb = parcelRequire("aiTsb");

var $ZcBBp = parcelRequire("ZcBBp");
var $23ddd2931d17bd07$require$re = $ZcBBp.safeRe;
var $23ddd2931d17bd07$require$t = $ZcBBp.t;

var $d7upZ = parcelRequire("d7upZ");

var $kCwKi = parcelRequire("kCwKi");

var $3z49e = parcelRequire("3z49e");

var $iK8LJ = parcelRequire("iK8LJ");

});
parcelRegister("iK8LJ", function(module, exports) {
'use strict';
const $da535334381ca24e$var$SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class $da535334381ca24e$var$Range {
    constructor(range, options){
        options = $aiTsb(options);
        if (range instanceof $da535334381ca24e$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $da535334381ca24e$var$Range(range.raw, options);
        }
        if (range instanceof $34UP3) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace($da535334381ca24e$var$SPACE_CHARACTERS, ' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$da535334381ca24e$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $da535334381ca24e$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = '';
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += '||';
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += ' ';
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // strip build metadata so it can't bleed into the version
        range = range.replace($da535334381ca24e$var$BUILDSTRIPRE, '');
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $da535334381ca24e$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $da535334381ca24e$require$FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = $da535334381ca24e$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $da535334381ca24e$require$re[$da535334381ca24e$require$t.HYPHENRANGELOOSE] : $da535334381ca24e$require$re[$da535334381ca24e$require$t.HYPHENRANGE];
        range = range.replace(hr, $da535334381ca24e$var$hyphenReplace(this.options.includePrerelease));
        $kCwKi('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($da535334381ca24e$require$re[$da535334381ca24e$require$t.COMPARATORTRIM], $da535334381ca24e$require$comparatorTrimReplace);
        $kCwKi('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($da535334381ca24e$require$re[$da535334381ca24e$require$t.TILDETRIM], $da535334381ca24e$require$tildeTrimReplace);
        $kCwKi('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($da535334381ca24e$require$re[$da535334381ca24e$require$t.CARETTRIM], $da535334381ca24e$require$caretTrimReplace);
        $kCwKi('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>$da535334381ca24e$var$parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$da535334381ca24e$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $kCwKi('loose invalid filter', comp, this.options);
            return !!comp.match($da535334381ca24e$require$re[$da535334381ca24e$require$t.COMPARATORLOOSE]);
        });
        $kCwKi('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $34UP3(comp, this.options));
        for (const comp of comparators){
            if ($da535334381ca24e$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        $da535334381ca24e$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $da535334381ca24e$var$Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return $da535334381ca24e$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $da535334381ca24e$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new $3z49e(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($da535334381ca24e$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = $da535334381ca24e$var$Range;

var $edARr = parcelRequire("edARr");
const $da535334381ca24e$var$cache = new $edARr();

var $aiTsb = parcelRequire("aiTsb");

var $34UP3 = parcelRequire("34UP3");

var $kCwKi = parcelRequire("kCwKi");

var $3z49e = parcelRequire("3z49e");

var $ZcBBp = parcelRequire("ZcBBp");
var $da535334381ca24e$require$re = $ZcBBp.safeRe;
var $da535334381ca24e$require$src = $ZcBBp.src;
var $da535334381ca24e$require$t = $ZcBBp.t;
var $da535334381ca24e$require$comparatorTrimReplace = $ZcBBp.comparatorTrimReplace;
var $da535334381ca24e$require$tildeTrimReplace = $ZcBBp.tildeTrimReplace;
var $da535334381ca24e$require$caretTrimReplace = $ZcBBp.caretTrimReplace;

var $ktfCW = parcelRequire("ktfCW");
var $da535334381ca24e$require$FLAG_INCLUDE_PRERELEASE = $ktfCW.FLAG_INCLUDE_PRERELEASE;
var $da535334381ca24e$require$FLAG_LOOSE = $ktfCW.FLAG_LOOSE;
// unbounded global build-metadata stripper used by parseRange
const $da535334381ca24e$var$BUILDSTRIPRE = new RegExp($da535334381ca24e$require$src[$da535334381ca24e$require$t.BUILD], 'g');
const $da535334381ca24e$var$isNullSet = (c)=>c.value === '<0.0.0-0';
const $da535334381ca24e$var$isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $da535334381ca24e$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $da535334381ca24e$var$parseComparator = (comp, options)=>{
    comp = comp.replace($da535334381ca24e$require$re[$da535334381ca24e$require$t.BUILD], '');
    $kCwKi('comp', comp, options);
    comp = $da535334381ca24e$var$replaceCarets(comp, options);
    $kCwKi('caret', comp);
    comp = $da535334381ca24e$var$replaceTildes(comp, options);
    $kCwKi('tildes', comp);
    comp = $da535334381ca24e$var$replaceXRanges(comp, options);
    $kCwKi('xrange', comp);
    comp = $da535334381ca24e$var$replaceStars(comp, options);
    $kCwKi('stars', comp);
    return comp;
};
const $da535334381ca24e$var$isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
const $da535334381ca24e$var$invalidXRangeOrder = (M, m, p)=>$da535334381ca24e$var$isX(M) && !$da535334381ca24e$var$isX(m) || $da535334381ca24e$var$isX(m) && p && !$da535334381ca24e$var$isX(p);
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $da535334381ca24e$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$da535334381ca24e$var$replaceTilde(c, options)).join(' ');
};
const $da535334381ca24e$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $da535334381ca24e$require$re[$da535334381ca24e$require$t.TILDELOOSE] : $da535334381ca24e$require$re[$da535334381ca24e$require$t.TILDE];
    // if we're including prereleases in the match, then the lower bound is
    // -0, the lowest possible prerelease value, just like x-ranges and carets.
    // this keeps `~1.2` equivalent to the `1.2.x` x-range it's documented as.
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        $kCwKi('tilde', comp, _, M, m, p, pr);
        let ret;
        if ($da535334381ca24e$var$isX(M)) ret = '';
        else if ($da535334381ca24e$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($da535334381ca24e$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $kCwKi('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $kCwKi('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $da535334381ca24e$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$da535334381ca24e$var$replaceCaret(c, options)).join(' ');
};
const $da535334381ca24e$var$replaceCaret = (comp, options)=>{
    $kCwKi('caret', comp, options);
    const r = options.loose ? $da535334381ca24e$require$re[$da535334381ca24e$require$t.CARETLOOSE] : $da535334381ca24e$require$re[$da535334381ca24e$require$t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        $kCwKi('caret', comp, _, M, m, p, pr);
        let ret;
        if ($da535334381ca24e$var$isX(M)) ret = '';
        else if ($da535334381ca24e$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($da535334381ca24e$var$isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $kCwKi('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $kCwKi('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $kCwKi('caret return', ret);
        return ret;
    });
};
const $da535334381ca24e$var$replaceXRanges = (comp, options)=>{
    $kCwKi('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>$da535334381ca24e$var$replaceXRange(c, options)).join(' ');
};
const $da535334381ca24e$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $da535334381ca24e$require$re[$da535334381ca24e$require$t.XRANGELOOSE] : $da535334381ca24e$require$re[$da535334381ca24e$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $kCwKi('xRange', comp, ret, gtlt, M, m, p, pr);
        if ($da535334381ca24e$var$invalidXRangeOrder(M, m, p)) return comp;
        const xM = $da535334381ca24e$var$isX(M);
        const xm = xM || $da535334381ca24e$var$isX(m);
        const xp = xm || $da535334381ca24e$var$isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $kCwKi('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $da535334381ca24e$var$replaceStars = (comp, options)=>{
    $kCwKi('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($da535334381ca24e$require$re[$da535334381ca24e$require$t.STAR], '');
};
const $da535334381ca24e$var$replaceGTE0 = (comp, options)=>{
    $kCwKi('replaceGTE0', comp, options);
    return comp.trim().replace($da535334381ca24e$require$re[options.includePrerelease ? $da535334381ca24e$require$t.GTE0PRE : $da535334381ca24e$require$t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $da535334381ca24e$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($da535334381ca24e$var$isX(fM)) from = '';
        else if ($da535334381ca24e$var$isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if ($da535334381ca24e$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if ($da535334381ca24e$var$isX(tM)) to = '';
        else if ($da535334381ca24e$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($da535334381ca24e$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $da535334381ca24e$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $kCwKi(set[i].semver);
            if (set[i].semver === $34UP3.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});
parcelRegister("edARr", function(module, exports) {
'use strict';
class $a59edf6645386e0c$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
module.exports = $a59edf6645386e0c$var$LRUCache;

});



parcelRegister("1Dw6N", function(module, exports) {
'use strict';

var $iK8LJ = parcelRequire("iK8LJ");
const $1312570b8fbf7333$var$satisfies = (version, range, options)=>{
    try {
        range = new $iK8LJ(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $1312570b8fbf7333$var$satisfies;

});

parcelRegister("j60KK", function(module, exports) {
'use strict';

var $iK8LJ = parcelRequire("iK8LJ");
// Mostly just for testing and legacy API reasons
const $de6f295f66679cfa$var$toComparators = (range, options)=>new $iK8LJ(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = $de6f295f66679cfa$var$toComparators;

});

parcelRegister("6sDoi", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");

var $iK8LJ = parcelRequire("iK8LJ");
const $4b43e9d5652c5f9a$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $iK8LJ(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $3z49e(max, options);
            }
        }
    });
    return max;
};
module.exports = $4b43e9d5652c5f9a$var$maxSatisfying;

});

parcelRegister("e37PC", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");

var $iK8LJ = parcelRequire("iK8LJ");
const $a3a76bac9e4255a1$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $iK8LJ(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $3z49e(min, options);
            }
        }
    });
    return min;
};
module.exports = $a3a76bac9e4255a1$var$minSatisfying;

});

parcelRegister("ddfSj", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");

var $iK8LJ = parcelRequire("iK8LJ");

var $3HST1 = parcelRequire("3HST1");
const $99e8cdafe4fc4aac$var$minVersion = (range, loose)=>{
    range = new $iK8LJ(range, loose);
    let minver = new $3z49e('0.0.0');
    if (range.test(minver)) return minver;
    minver = new $3z49e('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $3z49e(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || $3HST1(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $3HST1(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $99e8cdafe4fc4aac$var$minVersion;

});

parcelRegister("2eMV5", function(module, exports) {
'use strict';

var $iK8LJ = parcelRequire("iK8LJ");
const $1a12d60575e4f1f7$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $iK8LJ(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = $1a12d60575e4f1f7$var$validRange;

});

parcelRegister("1JcM7", function(module, exports) {
'use strict';

var $3z49e = parcelRequire("3z49e");

var $34UP3 = parcelRequire("34UP3");
const { ANY: $1423e7432e250e6a$var$ANY } = $34UP3;

var $iK8LJ = parcelRequire("iK8LJ");

var $1Dw6N = parcelRequire("1Dw6N");

var $3HST1 = parcelRequire("3HST1");

var $gRrFx = parcelRequire("gRrFx");

var $jE8gs = parcelRequire("jE8gs");

var $89biI = parcelRequire("89biI");
const $1423e7432e250e6a$var$outside = (version, range, hilo, options)=>{
    version = new $3z49e(version, options);
    range = new $iK8LJ(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = $3HST1;
            ltefn = $jE8gs;
            ltfn = $gRrFx;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = $gRrFx;
            ltefn = $89biI;
            ltfn = $3HST1;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($1Dw6N(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $1423e7432e250e6a$var$ANY) comparator = new $34UP3('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = $1423e7432e250e6a$var$outside;

});

parcelRegister("jFJG3", function(module, exports) {
'use strict';

var $1JcM7 = parcelRequire("1JcM7");
const $e525473332f744d2$var$gtr = (version, range, options)=>$1JcM7(version, range, '>', options);
module.exports = $e525473332f744d2$var$gtr;

});

parcelRegister("b756H", function(module, exports) {
'use strict';

var $1JcM7 = parcelRequire("1JcM7");
// Determine if version is less than all the versions possible in the range
const $81744f49a61fffb4$var$ltr = (version, range, options)=>$1JcM7(version, range, '<', options);
module.exports = $81744f49a61fffb4$var$ltr;

});

parcelRegister("grqMG", function(module, exports) {
'use strict';

var $iK8LJ = parcelRequire("iK8LJ");
const $bf83f1bc674b50c6$var$intersects = (r1, r2, options)=>{
    r1 = new $iK8LJ(r1, options);
    r2 = new $iK8LJ(r2, options);
    return r1.intersects(r2, options);
};
module.exports = $bf83f1bc674b50c6$var$intersects;

});

parcelRegister("yH1VW", function(module, exports) {
'use strict';

var $1Dw6N = parcelRequire("1Dw6N");

var $h2zGw = parcelRequire("h2zGw");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$h2zGw(a, b, options));
    for (const version of v){
        const included = $1Dw6N(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("3eqcP", function(module, exports) {
'use strict';

var $iK8LJ = parcelRequire("iK8LJ");

var $34UP3 = parcelRequire("34UP3");
const { ANY: $25a701d87b7506cf$var$ANY } = $34UP3;

var $1Dw6N = parcelRequire("1Dw6N");

var $h2zGw = parcelRequire("h2zGw");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If LT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $25a701d87b7506cf$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $iK8LJ(sub, options);
    dom = new $iK8LJ(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $25a701d87b7506cf$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $25a701d87b7506cf$var$minimumVersionWithPreRelease = [
    new $34UP3('>=0.0.0-0')
];
const $25a701d87b7506cf$var$minimumVersion = [
    new $34UP3('>=0.0.0')
];
const $25a701d87b7506cf$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $25a701d87b7506cf$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $25a701d87b7506cf$var$ANY) return true;
        else if (options.includePrerelease) sub = $25a701d87b7506cf$var$minimumVersionWithPreRelease;
        else sub = $25a701d87b7506cf$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $25a701d87b7506cf$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $25a701d87b7506cf$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = $25a701d87b7506cf$var$higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = $25a701d87b7506cf$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $h2zGw(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$1Dw6N(eq, String(gt), options)) return null;
        if (lt && !$1Dw6N(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$1Dw6N(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = $25a701d87b7506cf$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !c.test(gt.semver)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = $25a701d87b7506cf$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !c.test(lt.semver)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $25a701d87b7506cf$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $h2zGw(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $25a701d87b7506cf$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $h2zGw(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = $25a701d87b7506cf$var$subset;

});



parcelRegister("aKvUz", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");

var $dOyS4 = parcelRequire("dOyS4");
module.exports = $dOyS4.satisfies($1g1jb.version, '>=16.9.0');

});


parcelRegister("9ntuM", function(module, exports) {

var $1g1jb = parcelRequire("1g1jb");

var $dOyS4 = parcelRequire("dOyS4");
module.exports = $dOyS4.satisfies($1g1jb.version, '^6.12.0 || >=8.0.0');

});


parcelRegister("EvRMc", function(module, exports) {

var $dOfWq = parcelRequire("dOfWq");
var $079c74898442e587$require$Buffer = $dOfWq.Buffer;

var $1ihuL = parcelRequire("1ihuL");

var $9ntuM = parcelRequire("9ntuM");

var $90dQl = parcelRequire("90dQl");

var $3iamx = parcelRequire("3iamx");

var $gdmEx = parcelRequire("gdmEx");

var $kGu90 = parcelRequire("kGu90");

var $9zkM8 = parcelRequire("9zkM8");

var $3w90S = parcelRequire("3w90S");

var $kVdLP = parcelRequire("kVdLP");

var $bSre0 = parcelRequire("bSre0");

var $hpg58 = parcelRequire("hpg58");

var $lRcAu = parcelRequire("lRcAu");
var $079c74898442e587$require$KeyObject = $lRcAu.KeyObject;
var $079c74898442e587$require$createSecretKey = $lRcAu.createSecretKey;
var $079c74898442e587$require$createPrivateKey = $lRcAu.createPrivateKey;
const $079c74898442e587$var$SUPPORTED_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512',
    'HS256',
    'HS384',
    'HS512',
    'none'
];
if ($9ntuM) $079c74898442e587$var$SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
const $079c74898442e587$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $9zkM8(value) || $bSre0(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $9zkM8(value) || $bSre0(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $bSre0(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $gdmEx.bind(null, $079c74898442e587$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $kVdLP,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $bSre0,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $bSre0,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $bSre0,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $bSre0,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $kGu90,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $bSre0,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $kGu90,
        message: '"mutatePayload" must be a boolean'
    },
    allowInsecureKeySizes: {
        isValid: $kGu90,
        message: '"allowInsecureKeySizes" must be a boolean'
    },
    allowInvalidAsymmetricKeyTypes: {
        isValid: $kGu90,
        message: '"allowInvalidAsymmetricKeyTypes" must be a boolean'
    }
};
const $079c74898442e587$var$registered_claims_schema = {
    iat: {
        isValid: $3w90S,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $3w90S,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $3w90S,
        message: '"nbf" should be a number of seconds'
    }
};
function $079c74898442e587$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$kVdLP(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        const validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $079c74898442e587$var$validateOptions(options) {
    return $079c74898442e587$var$validate($079c74898442e587$var$sign_options_schema, false, options, 'options');
}
function $079c74898442e587$var$validatePayload(payload) {
    return $079c74898442e587$var$validate($079c74898442e587$var$registered_claims_schema, true, payload, 'payload');
}
const $079c74898442e587$var$options_to_payload = {
    'audience': 'aud',
    'issuer': 'iss',
    'subject': 'sub',
    'jwtid': 'jti'
};
const $079c74898442e587$var$options_for_objects = [
    'expiresIn',
    'notBefore',
    'noTimestamp',
    'audience',
    'issuer',
    'subject',
    'jwtid'
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    } else options = options || {};
    const isObjectPayload = typeof payload === 'object' && !$079c74898442e587$require$Buffer.isBuffer(payload);
    const header = Object.assign({
        alg: options.algorithm || 'HS256',
        typ: isObjectPayload ? 'JWT' : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== 'none') return failure(new Error('secretOrPrivateKey must have a value'));
    if (secretOrPrivateKey != null && !(secretOrPrivateKey instanceof $079c74898442e587$require$KeyObject)) try {
        secretOrPrivateKey = $079c74898442e587$require$createPrivateKey(secretOrPrivateKey);
    } catch (_) {
        try {
            secretOrPrivateKey = $079c74898442e587$require$createSecretKey(typeof secretOrPrivateKey === 'string' ? $079c74898442e587$require$Buffer.from(secretOrPrivateKey) : secretOrPrivateKey);
        } catch (_) {
            return failure(new Error('secretOrPrivateKey is not valid key material'));
        }
    }
    if (header.alg.startsWith('HS') && secretOrPrivateKey.type !== 'secret') return failure(new Error(`secretOrPrivateKey must be a symmetric key when using ${header.alg}`));
    else if (/^(?:RS|PS|ES)/.test(header.alg)) {
        if (secretOrPrivateKey.type !== 'private') return failure(new Error(`secretOrPrivateKey must be an asymmetric key when using ${header.alg}`));
        if (!options.allowInsecureKeySizes && !header.alg.startsWith('ES') && secretOrPrivateKey.asymmetricKeyDetails !== undefined && //KeyObject.asymmetricKeyDetails is supported in Node 15+
        secretOrPrivateKey.asymmetricKeyDetails.modulusLength < 2048) return failure(new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`));
    }
    if (typeof payload === 'undefined') return failure(new Error('payload is required'));
    else if (isObjectPayload) {
        try {
            $079c74898442e587$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        const invalid_options = $079c74898442e587$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== 'undefined';
        });
        if (invalid_options.length > 0) return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + typeof payload + ' payload'));
    }
    if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $079c74898442e587$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    if (!options.allowInvalidAsymmetricKeyTypes) try {
        $90dQl(header.alg, secretOrPrivateKey);
    } catch (error) {
        return failure(error);
    }
    const timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== 'undefined') {
        try {
            payload.nbf = $1ihuL(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === 'undefined') return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
        try {
            payload.exp = $1ihuL(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === 'undefined') return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($079c74898442e587$var$options_to_payload).forEach(function(key) {
        const claim = $079c74898442e587$var$options_to_payload[key];
        if (typeof options[key] !== 'undefined') {
            if (typeof payload[claim] !== 'undefined') return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    const encoding = options.encoding || 'utf8';
    if (typeof callback === 'function') {
        callback = callback && $hpg58(callback);
        $3iamx.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once('error', callback).once('done', function(signature) {
            // TODO: Remove in favor of the modulus length check before signing once node 15+ is the minimum supported version
            if (!options.allowInsecureKeySizes && /^(?:RS|PS)/.test(header.alg) && signature.length < 256) return callback(new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`));
            callback(null, signature);
        });
    } else {
        let signature = $3iamx.sign({
            header: header,
            payload: payload,
            secret: secretOrPrivateKey,
            encoding: encoding
        });
        // TODO: Remove in favor of the modulus length check before signing once node 15+ is the minimum supported version
        if (!options.allowInsecureKeySizes && /^(?:RS|PS)/.test(header.alg) && signature.length < 256) throw new Error(`secretOrPrivateKey has a minimum key size of 2048 bits for ${header.alg}`);
        return signature;
    }
};

});
parcelRegister("gdmEx", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $bcdf6ea497865995$var$INFINITY = 1 / 0, $bcdf6ea497865995$var$MAX_SAFE_INTEGER = 9007199254740991, $bcdf6ea497865995$var$MAX_INTEGER = 1.7976931348623157e+308, $bcdf6ea497865995$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $bcdf6ea497865995$var$argsTag = '[object Arguments]', $bcdf6ea497865995$var$funcTag = '[object Function]', $bcdf6ea497865995$var$genTag = '[object GeneratorFunction]', $bcdf6ea497865995$var$stringTag = '[object String]', $bcdf6ea497865995$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $bcdf6ea497865995$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $bcdf6ea497865995$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $bcdf6ea497865995$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $bcdf6ea497865995$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $bcdf6ea497865995$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $bcdf6ea497865995$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $bcdf6ea497865995$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bcdf6ea497865995$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bcdf6ea497865995$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $bcdf6ea497865995$var$baseFindIndex(array, $bcdf6ea497865995$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $bcdf6ea497865995$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $bcdf6ea497865995$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $bcdf6ea497865995$var$baseValues(object, props) {
    return $bcdf6ea497865995$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $bcdf6ea497865995$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $bcdf6ea497865995$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bcdf6ea497865995$var$hasOwnProperty = $bcdf6ea497865995$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bcdf6ea497865995$var$objectToString = $bcdf6ea497865995$var$objectProto.toString;
/** Built-in value references. */ var $bcdf6ea497865995$var$propertyIsEnumerable = $bcdf6ea497865995$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bcdf6ea497865995$var$nativeKeys = $bcdf6ea497865995$var$overArg(Object.keys, Object), $bcdf6ea497865995$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $bcdf6ea497865995$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $bcdf6ea497865995$var$isArray(value) || $bcdf6ea497865995$var$isArguments(value) ? $bcdf6ea497865995$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $bcdf6ea497865995$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $bcdf6ea497865995$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bcdf6ea497865995$var$baseKeys(object) {
    if (!$bcdf6ea497865995$var$isPrototype(object)) return $bcdf6ea497865995$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($bcdf6ea497865995$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $bcdf6ea497865995$var$isIndex(value, length) {
    length = length == null ? $bcdf6ea497865995$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $bcdf6ea497865995$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $bcdf6ea497865995$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $bcdf6ea497865995$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $bcdf6ea497865995$var$includes(collection, value, fromIndex, guard) {
    collection = $bcdf6ea497865995$var$isArrayLike(collection) ? collection : $bcdf6ea497865995$var$values(collection);
    fromIndex = fromIndex && !guard ? $bcdf6ea497865995$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $bcdf6ea497865995$var$nativeMax(length + fromIndex, 0);
    return $bcdf6ea497865995$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $bcdf6ea497865995$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $bcdf6ea497865995$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $bcdf6ea497865995$var$isArrayLikeObject(value) && $bcdf6ea497865995$var$hasOwnProperty.call(value, 'callee') && (!$bcdf6ea497865995$var$propertyIsEnumerable.call(value, 'callee') || $bcdf6ea497865995$var$objectToString.call(value) == $bcdf6ea497865995$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $bcdf6ea497865995$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $bcdf6ea497865995$var$isArrayLike(value) {
    return value != null && $bcdf6ea497865995$var$isLength(value.length) && !$bcdf6ea497865995$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $bcdf6ea497865995$var$isArrayLikeObject(value) {
    return $bcdf6ea497865995$var$isObjectLike(value) && $bcdf6ea497865995$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $bcdf6ea497865995$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $bcdf6ea497865995$var$isObject(value) ? $bcdf6ea497865995$var$objectToString.call(value) : '';
    return tag == $bcdf6ea497865995$var$funcTag || tag == $bcdf6ea497865995$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $bcdf6ea497865995$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $bcdf6ea497865995$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bcdf6ea497865995$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $bcdf6ea497865995$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $bcdf6ea497865995$var$isString(value) {
    return typeof value == 'string' || !$bcdf6ea497865995$var$isArray(value) && $bcdf6ea497865995$var$isObjectLike(value) && $bcdf6ea497865995$var$objectToString.call(value) == $bcdf6ea497865995$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $bcdf6ea497865995$var$isSymbol(value) {
    return typeof value == 'symbol' || $bcdf6ea497865995$var$isObjectLike(value) && $bcdf6ea497865995$var$objectToString.call(value) == $bcdf6ea497865995$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $bcdf6ea497865995$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $bcdf6ea497865995$var$toNumber(value);
    if (value === $bcdf6ea497865995$var$INFINITY || value === -$bcdf6ea497865995$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $bcdf6ea497865995$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $bcdf6ea497865995$var$toInteger(value) {
    var result = $bcdf6ea497865995$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $bcdf6ea497865995$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($bcdf6ea497865995$var$isSymbol(value)) return $bcdf6ea497865995$var$NAN;
    if ($bcdf6ea497865995$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $bcdf6ea497865995$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($bcdf6ea497865995$var$reTrim, '');
    var isBinary = $bcdf6ea497865995$var$reIsBinary.test(value);
    return isBinary || $bcdf6ea497865995$var$reIsOctal.test(value) ? $bcdf6ea497865995$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $bcdf6ea497865995$var$reIsBadHex.test(value) ? $bcdf6ea497865995$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $bcdf6ea497865995$var$keys(object) {
    return $bcdf6ea497865995$var$isArrayLike(object) ? $bcdf6ea497865995$var$arrayLikeKeys(object) : $bcdf6ea497865995$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $bcdf6ea497865995$var$values(object) {
    return object ? $bcdf6ea497865995$var$baseValues(object, $bcdf6ea497865995$var$keys(object)) : [];
}
module.exports = $bcdf6ea497865995$var$includes;

});

parcelRegister("kGu90", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $f0ef1ce4e467066f$var$boolTag = '[object Boolean]';
/** Used for built-in method references. */ var $f0ef1ce4e467066f$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f0ef1ce4e467066f$var$objectToString = $f0ef1ce4e467066f$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $f0ef1ce4e467066f$var$isBoolean(value) {
    return value === true || value === false || $f0ef1ce4e467066f$var$isObjectLike(value) && $f0ef1ce4e467066f$var$objectToString.call(value) == $f0ef1ce4e467066f$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f0ef1ce4e467066f$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = $f0ef1ce4e467066f$var$isBoolean;

});

parcelRegister("9zkM8", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $6f777f7a31029784$var$INFINITY = 1 / 0, $6f777f7a31029784$var$MAX_INTEGER = 1.7976931348623157e+308, $6f777f7a31029784$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $6f777f7a31029784$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $6f777f7a31029784$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6f777f7a31029784$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6f777f7a31029784$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6f777f7a31029784$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6f777f7a31029784$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $6f777f7a31029784$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6f777f7a31029784$var$objectToString = $6f777f7a31029784$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $6f777f7a31029784$var$isInteger(value) {
    return typeof value == 'number' && value == $6f777f7a31029784$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6f777f7a31029784$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6f777f7a31029784$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6f777f7a31029784$var$isSymbol(value) {
    return typeof value == 'symbol' || $6f777f7a31029784$var$isObjectLike(value) && $6f777f7a31029784$var$objectToString.call(value) == $6f777f7a31029784$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6f777f7a31029784$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $6f777f7a31029784$var$toNumber(value);
    if (value === $6f777f7a31029784$var$INFINITY || value === -$6f777f7a31029784$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6f777f7a31029784$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6f777f7a31029784$var$toInteger(value) {
    var result = $6f777f7a31029784$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6f777f7a31029784$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6f777f7a31029784$var$isSymbol(value)) return $6f777f7a31029784$var$NAN;
    if ($6f777f7a31029784$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $6f777f7a31029784$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($6f777f7a31029784$var$reTrim, '');
    var isBinary = $6f777f7a31029784$var$reIsBinary.test(value);
    return isBinary || $6f777f7a31029784$var$reIsOctal.test(value) ? $6f777f7a31029784$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6f777f7a31029784$var$reIsBadHex.test(value) ? $6f777f7a31029784$var$NAN : +value;
}
module.exports = $6f777f7a31029784$var$isInteger;

});

parcelRegister("3w90S", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $28fb5a19a558d4c5$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $28fb5a19a558d4c5$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $28fb5a19a558d4c5$var$objectToString = $28fb5a19a558d4c5$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $28fb5a19a558d4c5$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $28fb5a19a558d4c5$var$isNumber(value) {
    return typeof value == 'number' || $28fb5a19a558d4c5$var$isObjectLike(value) && $28fb5a19a558d4c5$var$objectToString.call(value) == $28fb5a19a558d4c5$var$numberTag;
}
module.exports = $28fb5a19a558d4c5$var$isNumber;

});

parcelRegister("kVdLP", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $f3b3d00e471dcffe$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $f3b3d00e471dcffe$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $f3b3d00e471dcffe$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $f3b3d00e471dcffe$var$funcProto = Function.prototype, $f3b3d00e471dcffe$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f3b3d00e471dcffe$var$funcToString = $f3b3d00e471dcffe$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f3b3d00e471dcffe$var$hasOwnProperty = $f3b3d00e471dcffe$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f3b3d00e471dcffe$var$objectCtorString = $f3b3d00e471dcffe$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f3b3d00e471dcffe$var$objectToString = $f3b3d00e471dcffe$var$objectProto.toString;
/** Built-in value references. */ var $f3b3d00e471dcffe$var$getPrototype = $f3b3d00e471dcffe$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f3b3d00e471dcffe$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f3b3d00e471dcffe$var$isPlainObject(value) {
    if (!$f3b3d00e471dcffe$var$isObjectLike(value) || $f3b3d00e471dcffe$var$objectToString.call(value) != $f3b3d00e471dcffe$var$objectTag || $f3b3d00e471dcffe$var$isHostObject(value)) return false;
    var proto = $f3b3d00e471dcffe$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $f3b3d00e471dcffe$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $f3b3d00e471dcffe$var$funcToString.call(Ctor) == $f3b3d00e471dcffe$var$objectCtorString;
}
module.exports = $f3b3d00e471dcffe$var$isPlainObject;

});

parcelRegister("bSre0", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $8a59db2511473b8d$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $8a59db2511473b8d$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8a59db2511473b8d$var$objectToString = $8a59db2511473b8d$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8a59db2511473b8d$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8a59db2511473b8d$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $8a59db2511473b8d$var$isString(value) {
    return typeof value == 'string' || !$8a59db2511473b8d$var$isArray(value) && $8a59db2511473b8d$var$isObjectLike(value) && $8a59db2511473b8d$var$objectToString.call(value) == $8a59db2511473b8d$var$stringTag;
}
module.exports = $8a59db2511473b8d$var$isString;

});

parcelRegister("hpg58", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $cac13ef9348fff36$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $cac13ef9348fff36$var$INFINITY = 1 / 0, $cac13ef9348fff36$var$MAX_INTEGER = 1.7976931348623157e+308, $cac13ef9348fff36$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $cac13ef9348fff36$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $cac13ef9348fff36$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $cac13ef9348fff36$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $cac13ef9348fff36$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $cac13ef9348fff36$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $cac13ef9348fff36$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $cac13ef9348fff36$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cac13ef9348fff36$var$objectToString = $cac13ef9348fff36$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $cac13ef9348fff36$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($cac13ef9348fff36$var$FUNC_ERROR_TEXT);
    n = $cac13ef9348fff36$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $cac13ef9348fff36$var$once(func) {
    return $cac13ef9348fff36$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cac13ef9348fff36$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cac13ef9348fff36$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $cac13ef9348fff36$var$isSymbol(value) {
    return typeof value == 'symbol' || $cac13ef9348fff36$var$isObjectLike(value) && $cac13ef9348fff36$var$objectToString.call(value) == $cac13ef9348fff36$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $cac13ef9348fff36$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $cac13ef9348fff36$var$toNumber(value);
    if (value === $cac13ef9348fff36$var$INFINITY || value === -$cac13ef9348fff36$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $cac13ef9348fff36$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $cac13ef9348fff36$var$toInteger(value) {
    var result = $cac13ef9348fff36$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $cac13ef9348fff36$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($cac13ef9348fff36$var$isSymbol(value)) return $cac13ef9348fff36$var$NAN;
    if ($cac13ef9348fff36$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $cac13ef9348fff36$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($cac13ef9348fff36$var$reTrim, '');
    var isBinary = $cac13ef9348fff36$var$reIsBinary.test(value);
    return isBinary || $cac13ef9348fff36$var$reIsOctal.test(value) ? $cac13ef9348fff36$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $cac13ef9348fff36$var$reIsBadHex.test(value) ? $cac13ef9348fff36$var$NAN : +value;
}
module.exports = $cac13ef9348fff36$var$once;

});






parcelRegister("j0B9N", function(module, exports) {

$parcel$export(module.exports, "Anchor", () => $dd6ad7029e0d5c85$export$b688253958b8dfe7);

var $2NacA = parcelRequire("2NacA");

var $cDMMY = parcelRequire("cDMMY");
var $d2fh4 = parcelRequire("d2fh4");
var $1PECa = parcelRequire("1PECa");

var $5xcHk = parcelRequire("5xcHk");

var $1rxx7 = parcelRequire("1rxx7");

var $6YCHN = parcelRequire("6YCHN");

var $hbZKz = parcelRequire("hbZKz");

var $8QB4u = parcelRequire("8QB4u");

var $eL6w3 = parcelRequire("eL6w3");
var $dd6ad7029e0d5c85$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "color",
    "disabled",
    "gap",
    "href",
    "icon",
    "label",
    "onBlur",
    "onClick",
    "onFocus",
    "reverse",
    "size"
];
function $dd6ad7029e0d5c85$var$_extends() {
    return $dd6ad7029e0d5c85$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dd6ad7029e0d5c85$var$_extends.apply(null, arguments);
}
function $dd6ad7029e0d5c85$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $dd6ad7029e0d5c85$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$anchor3, _theme$anchor4;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], children = _ref.children, color = _ref.color, disabled = _ref.disabled, gap = _ref.gap, href = _ref.href, icon = _ref.icon, label = _ref.label, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, onFocus = _ref.onFocus, reverse = _ref.reverse, sizeProp = _ref.size, rest = $dd6ad7029e0d5c85$var$_objectWithoutPropertiesLoose(_ref, $dd6ad7029e0d5c85$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2NacA.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useContext = (0, $2NacA.useContext)((0, $8QB4u.TextContext)), size = _useContext.size;
    var sendAnalytics = (0, $hbZKz.useAnalytics)();
    var onClick = (0, $2NacA.useCallback)(function(event) {
        sendAnalytics({
            type: 'anchorClick',
            element: (0, $cDMMY.findButtonParent)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        label,
        href
    ]);
    (0, $2NacA.useEffect)(function() {
        if ((icon || label) && children) console.warn('Anchor should not have children if icon or label is provided');
    }, [
        children,
        icon,
        label
    ]);
    var coloredIcon = icon;
    if (icon && !icon.props.color) {
        var _theme$anchor, _theme$anchor2;
        coloredIcon = /*#__PURE__*/ (0, $2NacA.cloneElement)(icon, {
            color: (0, $d2fh4.normalizeColor)(color || ((_theme$anchor = theme.anchor) == null || (_theme$anchor = _theme$anchor.icon) == null ? void 0 : _theme$anchor.color) || ((_theme$anchor2 = theme.anchor) == null || (_theme$anchor2 = _theme$anchor2.size) == null || (_theme$anchor2 = _theme$anchor2[sizeProp || size]) == null ? void 0 : _theme$anchor2.color) || theme.anchor.color, theme)
        });
    }
    var anchorIcon = (0, $1PECa.useSizedIcon)(coloredIcon, sizeProp || size, theme);
    var first = reverse ? label : anchorIcon;
    var second = reverse ? anchorIcon : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1rxx7.StyledAnchor), $dd6ad7029e0d5c85$var$_extends({}, rest, {
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        colorProp: color,
        disabled: disabled,
        hasIcon: !!icon,
        focus: focus,
        hasLabel: label,
        reverse: reverse,
        href: !disabled ? href : undefined,
        onClick: !disabled ? onClick : undefined,
        onFocus: !disabled ? function(event) {
            setFocus(true);
            if (onFocus) onFocus(event);
        } : undefined,
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        size: sizeProp || size
    }, passThemeFlag), first && second ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        as: "span",
        direction: "row",
        align: "center",
        gap: gap || ((_theme$anchor3 = theme.anchor) == null || (_theme$anchor3 = _theme$anchor3.size) == null || (_theme$anchor3 = _theme$anchor3[sizeProp]) == null ? void 0 : _theme$anchor3.gap) || ((_theme$anchor4 = theme.anchor) == null ? void 0 : _theme$anchor4.gap),
        responsive: false
    }, first, second) : first || second || children);
});
$dd6ad7029e0d5c85$export$b688253958b8dfe7.displayName = 'Anchor';
$dd6ad7029e0d5c85$export$b688253958b8dfe7.propTypes = (0, $6YCHN.AnchorPropTypes);

});
parcelRegister("cDMMY", function(module, exports) {

$parcel$export(module.exports, "findScrollParent", () => $933ef8ff605ab451$export$6a1689aaa66d814c);
$parcel$export(module.exports, "findScrollParents", () => $933ef8ff605ab451$export$14e46d92eb0648e);
$parcel$export(module.exports, "containsFocus", () => $933ef8ff605ab451$export$b03135936dd040ba);
$parcel$export(module.exports, "withinDropPortal", () => $933ef8ff605ab451$export$357c244c06d83dec);
$parcel$export(module.exports, "shouldKeepFocus", () => $933ef8ff605ab451$export$19f1b4b3dc25c57);
$parcel$export(module.exports, "getNewContainer", () => $933ef8ff605ab451$export$1cad4a11c7ad1375);
$parcel$export(module.exports, "setFocusWithoutScroll", () => $933ef8ff605ab451$export$99137e580254b26a);
$parcel$export(module.exports, "makeNodeFocusable", () => $933ef8ff605ab451$export$d25257a562ca003b);
$parcel$export(module.exports, "makeNodeUnfocusable", () => $933ef8ff605ab451$export$f17a564c864b60a0);
$parcel$export(module.exports, "findVisibleParent", () => $933ef8ff605ab451$export$4fe2c44731a76aa0);
$parcel$export(module.exports, "isNodeAfterScroll", () => $933ef8ff605ab451$export$27af05f039e10378);
$parcel$export(module.exports, "isNodeBeforeScroll", () => $933ef8ff605ab451$export$54c9800883215719);
$parcel$export(module.exports, "findButtonParent", () => $933ef8ff605ab451$export$37a8984127440e55);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $933ef8ff605ab451$export$6a1689aaa66d814c = function findScrollParent(element, horizontal) {
    var result;
    if (element) {
        var parent = element.parentNode;
        while(!result && parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result = parent;
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result = parent;
            parent = parent.parentNode;
        }
        // last scrollable element will be the document
        // if nothing else is scrollable in the page
        if (!result) result = document;
        else if (result.tagName.toLowerCase() === 'body') result = document;
    }
    return result;
};
var $933ef8ff605ab451$var$documentTags = [
    'html',
    'body'
];
var $933ef8ff605ab451$export$14e46d92eb0648e = function findScrollParents(element, horizontal) {
    var result = [];
    if (element) {
        var parent = element.parentNode;
        while(parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result.push(parent);
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result.push(parent);
            parent = parent.parentNode;
        }
        if (result.length && $933ef8ff605ab451$var$documentTags.includes(result[0].tagName.toLowerCase())) result.length = 0;
        // last scrollable element will be the document
        result.push(document);
    }
    return result;
};
var $933ef8ff605ab451$export$b03135936dd040ba = function containsFocus(node) {
    var root = node.getRootNode();
    var element = root.activeElement;
    while(element){
        if (element === node) break;
        element = element.parentElement;
    }
    return !!element;
};
var $933ef8ff605ab451$export$357c244c06d83dec = function withinDropPortal(node, portalContext) {
    var root = node == null ? void 0 : node.getRootNode();
    var element = node;
    var portalId;
    while(element && element !== root)if (element.hasAttribute('data-g-portal-id')) {
        portalId = element.getAttribute('data-g-portal-id');
        element = root;
    } else element = element.parentElement;
    // if portalContext doesn't contain the portalId then the
    // portal is new and node is within a drop that just opened
    if (portalId === undefined || portalContext.indexOf(parseInt(portalId, 10)) !== -1) return false;
    return true;
};
var $933ef8ff605ab451$export$4c063cf1350e6fed = function isFocusable(element) {
    if (!element || element.disabled) return false;
    var tagName = element.tagName.toLowerCase();
    if (tagName === 'input' || tagName === 'select' || tagName === 'textarea') return true;
    // Only non-native-interactive elements with an explicit tabindex attribute
    var isNativeInteractive = tagName === 'button' || tagName === 'a';
    return !isNativeInteractive && element.tabIndex >= 0 && element.hasAttribute('tabindex');
};
var $933ef8ff605ab451$export$e957a3ef02119493 = function getFirstFocusableDescendant(element) {
    var children = element.getElementsByTagName('*');
    for(var i = 0; i < children.length; i += 1){
        var child = children[i];
        if ($933ef8ff605ab451$export$4c063cf1350e6fed(child)) return child;
    }
    return undefined;
};
var $933ef8ff605ab451$export$19f1b4b3dc25c57 = function shouldKeepFocus(root) {
    var element = root.activeElement;
    if ($933ef8ff605ab451$export$4c063cf1350e6fed(element)) return true;
    return !!$933ef8ff605ab451$export$e957a3ef02119493(element);
};
var $933ef8ff605ab451$export$1cad4a11c7ad1375 = function getNewContainer(target, targetChildPosition) {
    if (target === void 0) target = document.body;
    // setup DOM
    var container = document.createElement('div');
    if (targetChildPosition === 'first') // for SkipLinks
    target.prepend(container);
    else target.appendChild(container);
    return container;
};
var $933ef8ff605ab451$export$99137e580254b26a = function setFocusWithoutScroll(element) {
    var x = window.scrollX;
    var y = window.scrollY;
    element.focus();
    window.scrollTo(x, y);
};
var $933ef8ff605ab451$var$TABINDEX = 'tabindex';
var $933ef8ff605ab451$var$TABINDEX_STATE = 'data-g-tabindex';
var $933ef8ff605ab451$export$d25257a562ca003b = function makeNodeFocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.removeAttribute('aria-hidden');
        // allow children to receive focus again
        var elements = node.getElementsByTagName('*');
        // only reset elements we've changed in makeNodeUnfocusable()
        Array.prototype.filter.call(elements || [], function(element) {
            return element.hasAttribute($933ef8ff605ab451$var$TABINDEX_STATE);
        }).forEach(function(element) {
            var prior = element.getAttribute($933ef8ff605ab451$var$TABINDEX_STATE);
            if (prior >= 0) element.setAttribute($933ef8ff605ab451$var$TABINDEX, element.getAttribute($933ef8ff605ab451$var$TABINDEX_STATE));
            else if (prior === 'none') element.removeAttribute($933ef8ff605ab451$var$TABINDEX);
            element.removeAttribute($933ef8ff605ab451$var$TABINDEX_STATE);
        });
    }
};
// Using ^ and $ to match the whole tagName, and not e.g. <meta> and <data>.
var $933ef8ff605ab451$var$autoFocusingTags = /^(a|area|input|select|textarea|button|iframe)$/;
var $933ef8ff605ab451$export$f17a564c864b60a0 = function makeNodeUnfocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.setAttribute('aria-hidden', true);
        // prevent children to receive focus
        var elements = node.getElementsByTagName('*');
        // first, save off the tabIndex of any element with one
        Array.prototype.filter.call(elements || [], function(element) {
            return element.getAttribute($933ef8ff605ab451$var$TABINDEX) !== null;
        }).forEach(function(element) {
            // if TABINDEX_STATE already exists, it's holding the original value
            if (!element.getAttribute($933ef8ff605ab451$var$TABINDEX_STATE)) element.setAttribute($933ef8ff605ab451$var$TABINDEX_STATE, element.getAttribute($933ef8ff605ab451$var$TABINDEX));
            element.setAttribute($933ef8ff605ab451$var$TABINDEX, -1);
        });
        // then, if any element is inherently focusable and not handled above,
        // give it a tabIndex of -1 so it can't receive focus
        Array.prototype.filter.call(elements || [], function(element) {
            var currentTag = element.tagName.toLowerCase();
            return currentTag.match($933ef8ff605ab451$var$autoFocusingTags) && element.focus && element.getAttribute($933ef8ff605ab451$var$TABINDEX_STATE) === null;
        }).forEach(function(element) {
            element.setAttribute($933ef8ff605ab451$var$TABINDEX_STATE, 'none');
            element.setAttribute($933ef8ff605ab451$var$TABINDEX, -1);
        });
    }
};
var $933ef8ff605ab451$export$4fe2c44731a76aa0 = function findVisibleParent(element) {
    if (element) // Get the closest ancestor element that is positioned.
    return element.offsetParent ? element : $933ef8ff605ab451$export$4fe2c44731a76aa0(element.parentElement) || element;
    return undefined;
};
var $933ef8ff605ab451$export$27af05f039e10378 = function isNodeAfterScroll(node, target) {
    var _node$getBoundingClie = node.getBoundingClientRect(), bottom = _node$getBoundingClie.bottom;
    // target will be the document from findScrollParent()
    var _ref = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        height: 0,
        top: 0
    }, height = _ref.height, top = _ref.top;
    return bottom >= top + height;
};
var $933ef8ff605ab451$export$54c9800883215719 = function isNodeBeforeScroll(node, target) {
    var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top;
    // target will be the document from findScrollParent()
    var _ref2 = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        top: 0
    }, targetTop = _ref2.top;
    return top <= targetTop;
};
var $933ef8ff605ab451$export$37a8984127440e55 = function findButtonParent(element) {
    if (element && element.nodeName !== 'BUTTON' && element.nodeName !== 'A') return $933ef8ff605ab451$export$37a8984127440e55(element.parentElement);
    return element;
};

});

parcelRegister("1PECa", function(module, exports) {

$parcel$export(module.exports, "useSizedIcon", () => $155a0f17886cfc90$export$a123f939253731a8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $155a0f17886cfc90$export$a123f939253731a8 = function useSizedIcon(icon, size, theme) {
    var _theme$icon;
    return icon && theme != null && (_theme$icon = theme.icon) != null && _theme$icon.matchSize && !icon.props.size ? /*#__PURE__*/ (0, $2NacA.cloneElement)(icon, {
        size: size
    }) : icon;
};

});

parcelRegister("5xcHk", function(module, exports) {

$parcel$export(module.exports, "Box", () => $4079e25c773f06ce$export$e71c4d32a2263218);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");
var $dOlbm = parcelRequire("dOlbm");

var $czDw5 = parcelRequire("czDw5");

var $eBd4p = parcelRequire("eBd4p");

var $5Oely = parcelRequire("5Oely");

var $4ZVSM = parcelRequire("4ZVSM");

var $7oNsG = parcelRequire("7oNsG");

var $aHKsU = parcelRequire("aHKsU");

var $7wfCm = parcelRequire("7wfCm");

var $5LTQm = parcelRequire("5LTQm");

var $eL6w3 = parcelRequire("eL6w3");

var $hRaYF = parcelRequire("hRaYF");
var $4079e25c773f06ce$var$_excluded = [
    "a11yTitle",
    "background",
    "border",
    "children",
    "cssGap",
    "direction",
    "elevation",
    "fill",
    "gap",
    "kind",
    "onBlur",
    "onClick",
    "onFocus",
    "overflow",
    "responsive",
    "tag",
    "as",
    "wrap",
    "width",
    "height",
    "tabIndex",
    "skeleton"
], $4079e25c773f06ce$var$_excluded2 = [
    "colors",
    "size"
];
function $4079e25c773f06ce$var$_extends() {
    return $4079e25c773f06ce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4079e25c773f06ce$var$_extends.apply(null, arguments);
}
function $4079e25c773f06ce$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4079e25c773f06ce$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, refProp) {
    var _theme$global$depreca2;
    var a11yTitle = _ref.a11yTitle, backgroundProp = _ref.background, border = _ref.border, children = _ref.children, cssGap = _ref.cssGap, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'column' : _ref$direction, elevation = _ref.elevation, fill = _ref.fill, gap = _ref.gap, kind = _ref.kind, _onBlur = _ref.onBlur, onClick = _ref.onClick, _onFocus = _ref.onFocus, overflow = _ref.overflow, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, tag = _ref.tag, as = _ref.as, wrap = _ref.wrap, width = _ref.width, height = _ref.height, tabIndex = _ref.tabIndex, skeletonProp = _ref.skeleton, rest = $4079e25c773f06ce$var$_objectWithoutPropertiesLoose(_ref, $4079e25c773f06ce$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // boxOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, $2NacA.useContext)((0, $aHKsU.OptionsContext)), boxOptions = _useContext.box;
    var skeleton = (0, $4ZVSM.useSkeleton)();
    var _useState = (0, $2NacA.useState)(undefined), containerElement = _useState[0], setContainerElement = _useState[1];
    var responsiveContainer = (0, $2NacA.useContext)((0, $7wfCm.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var background = backgroundProp;
    (0, $2NacA.useEffect)(function() {
        var _theme$global$depreca;
        var deprecatedBackground;
    }, [
        backgroundProp,
        (_theme$global$depreca2 = theme.global.deprecated) == null ? void 0 : _theme$global$depreca2.backgrounds
    ]);
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    var containerRef = (0, $dOlbm.useForwardedRef)(refProp);
    // Save the ref as a state if we're in a responsive container.
    // We only need it in the responsive container case and it
    // needs to be in a state to cause a re-render.
    (0, $2NacA.useEffect)(function() {
        if (responsiveProp === 'container' && containerRef.current) setContainerElement(containerRef.current);
    }, [
        containerRef,
        responsiveProp
    ]);
    (0, $2NacA.useEffect)(function() {
        if (typeof as === 'function') {
            if (refProp) console.warn('ref and as={function} are incompatible. The ref will not get set.');
            if (responsiveProp === 'container') console.warn(// eslint-disable-next-line max-len
            'responsive="container" and as={function} are incompatible. Use one or the other.');
        }
    }, [
        refProp,
        as,
        responsiveProp
    ]);
    (0, $2NacA.useEffect)(function() {
        var _skeletonProp$message;
        if (skeletonProp != null && (_skeletonProp$message = skeletonProp.message) != null && _skeletonProp$message.start) announce(skeletonProp.message.start);
        else if (typeof (skeletonProp == null ? void 0 : skeletonProp.message) === 'string') announce(skeletonProp.message);
        return function() {
            var _skeletonProp$message2;
            return (skeletonProp == null || (_skeletonProp$message2 = skeletonProp.message) == null ? void 0 : _skeletonProp$message2.end) && announce(skeletonProp.message.end);
        };
    }, [
        announce,
        skeletonProp
    ]);
    var focusable = (0, $2NacA.useMemo)(function() {
        return onClick && !(tabIndex < 0);
    }, [
        onClick,
        tabIndex
    ]);
    var _useState2 = (0, $2NacA.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var clickProps = (0, $2NacA.useMemo)(function() {
        if (focusable) return {
            onClick: onClick,
            onFocus: function onFocus(event) {
                setFocus(true);
                if (_onFocus) _onFocus(event);
            },
            onBlur: function onBlur(event) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        };
        var result = {};
        if (_onBlur) result.onBlur = _onBlur;
        if (onClick) result.onClick = onClick;
        if (_onFocus) result.onFocus = _onFocus;
        return result;
    }, [
        focusable,
        onClick,
        _onFocus,
        _onBlur
    ]);
    var adjustedTabIndex = (0, $2NacA.useMemo)(function() {
        if (tabIndex !== undefined) return tabIndex;
        if (focusable) return 0;
        return undefined;
    }, [
        focusable,
        tabIndex
    ]);
    if ((border === 'between' || border && border.side === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    })) && !gap) console.warn('Box must have a gap to use border between');
    var contents = children;
    if (gap && gap !== 'none' && (!(boxOptions != null && boxOptions.cssGap || cssGap || typeof gap === 'object') || // need this approach to show border between
    border === 'between' || (border == null ? void 0 : border.side) === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    }))) {
        // if border is an array, we need to extract the border between object
        var styledBoxGapBorder = Array.isArray(border) ? border.find(function(b) {
            return b.side === 'between';
        }) : border;
        var boxAs = !as && tag ? tag : as;
        contents = [];
        var firstIndex;
        (0, $2NacA.Children).forEach(children, function(child, index) {
            if (child) {
                if (firstIndex === undefined) firstIndex = index;
                else contents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $eBd4p.StyledBoxGap), $4079e25c773f06ce$var$_extends({
                    key: "gap-" + index,
                    as: boxAs === 'span' ? boxAs : 'div',
                    gap: gap,
                    directionProp: direction,
                    responsive: responsive,
                    border: styledBoxGapBorder
                }, passThemeFlag)));
            }
            contents.push(child);
        });
    }
    var nextSkeleton = (0, $2NacA.useMemo)(function() {
        // Decide if we need to add a new SkeletonContext. We need one if:
        //   1. skeleton info was set in a property OR
        //   2. there already is a SkeletonContext but this box has a
        //      background or border. This means the box probably is more
        //      distinguishable from the area around it.
        // We keep track of a depth so we know how to alternate backgrounds.
        if (skeletonProp || (background || border) && skeleton) {
            var depth = skeleton ? skeleton.depth + 1 : 0;
            return $4079e25c773f06ce$var$_extends({}, skeleton, {
                depth: depth
            }, typeof skeletonProp === 'object' ? skeletonProp : {});
        }
        return undefined;
    }, [
        background,
        border,
        skeleton,
        skeletonProp
    ]);
    var skeletonProps = {};
    if (nextSkeleton) {
        var _theme$skeleton = theme.skeleton, skeletonThemeColors = _theme$skeleton.colors, skeletonThemeSize = _theme$skeleton.size, skeletonThemeProps = $4079e25c773f06ce$var$_objectWithoutPropertiesLoose(_theme$skeleton, $4079e25c773f06ce$var$_excluded2);
        var skeletonColors = nextSkeleton.colors ? nextSkeleton.colors[theme.dark ? 'dark' : 'light'] : skeletonThemeColors == null ? void 0 : skeletonThemeColors[theme.dark ? 'dark' : 'light'];
        skeletonProps = $4079e25c773f06ce$var$_extends({}, skeletonThemeProps);
        background = skeletonColors[nextSkeleton.depth % skeletonColors.length];
        if (skeletonProp != null && skeletonProp.animation) skeletonProps.animation = skeletonProp.animation;
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $4ZVSM.SkeletonContext).Provider, {
            value: nextSkeleton
        }, contents);
    }
    // construct a new theme object in case we have a background that wants
    // to change the background color context
    var nextTheme = (0, $2NacA.useMemo)(function() {
        var result;
        if (background || theme.darkChanged) {
            var dark = (0, $jQHd2.backgroundIsDark)(background, theme);
            var darkChanged = dark !== undefined && dark !== theme.dark;
            if (darkChanged || theme.darkChanged) {
                result = $4079e25c773f06ce$var$_extends({}, theme);
                result.dark = dark === undefined ? theme.dark : dark;
                result.background = background;
            } else if (background) {
                // This allows DataTable to intelligently set the background
                // of a pinned header or footer.
                result = $4079e25c773f06ce$var$_extends({}, theme);
                result.background = background;
            }
        }
        return result || theme;
    }, [
        background,
        theme
    ]);
    // Only pass along the ref if the as prop is not a function.
    // The styled component will throw a warning if we try to pass
    // a ref when the as prop is a function. We do a console.warn
    // about this above in this case.
    var ref = typeof as === 'function' ? undefined : containerRef;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $eBd4p.StyledBox), $4079e25c773f06ce$var$_extends({
        as: !as && tag ? tag : as,
        "aria-label": a11yTitle,
        background: background,
        border: border,
        ref: ref,
        directionProp: direction,
        elevationProp: elevation,
        fillProp: fill,
        focus: focus,
        gap: ((boxOptions == null ? void 0 : boxOptions.cssGap) || cssGap || typeof gap === 'object') && gap && gap !== 'none' && border !== 'between' && (border == null ? void 0 : border.side) !== 'between' && (!Array.isArray(border) || !border.find(function(b) {
            return b.side === 'between';
        })) && gap,
        kindProp: kind,
        overflowProp: overflow,
        wrapProp: wrap,
        widthProp: width,
        heightProp: height,
        responsive: responsive,
        responsiveContainer: responsiveProp === 'container',
        tabIndex: adjustedTabIndex
    }, clickProps, passThemeFlag, rest, skeletonProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f5efw.ThemeContext).Provider, {
        value: nextTheme
    }, contents));
    if (responsiveProp === 'container') {
        if ((0, $hRaYF.supportsContainerQueries)()) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5LTQm.ResponsiveContainerProvider), {
            container: containerElement,
            theme: theme
        }, content);
        else console.warn('<Box responsive="container"> requires styled-components v6 or later');
    }
    if (onClick) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEnter: onClick,
        onSpace: function onSpace(e) {
            e.preventDefault(); // prevent page scroll
            onClick(e);
        }
    }, content);
    return content;
});
$4079e25c773f06ce$export$e71c4d32a2263218.displayName = 'Box';
$4079e25c773f06ce$export$e71c4d32a2263218.propTypes = (0, $5Oely.BoxPropTypes);

});
parcelRegister("czDw5", function(module, exports) {

$parcel$export(module.exports, "Keyboard", () => $9277681102fd6fca$export$16e4d70cc375e707);

var $2NacA = parcelRequire("2NacA");

var $fs0JC = parcelRequire("fs0JC");
var $9277681102fd6fca$var$_excluded = [
    "capture",
    "target",
    "children",
    "onKeyDown"
];
function $9277681102fd6fca$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9277681102fd6fca$var$KEYS = {
    8: 'onBackspace',
    9: 'onTab',
    13: 'onEnter',
    27: 'onEsc',
    32: 'onSpace',
    37: 'onLeft',
    38: 'onUp',
    39: 'onRight',
    40: 'onDown',
    188: 'onComma',
    16: 'onShift'
};
var $9277681102fd6fca$export$16e4d70cc375e707 = function Keyboard(_ref) {
    var capture = _ref.capture, target = _ref.target, children = _ref.children, onKeyDown = _ref.onKeyDown, restProps = $9277681102fd6fca$var$_objectWithoutPropertiesLoose(_ref, $9277681102fd6fca$var$_excluded);
    var onKeyDownHandler = (0, $2NacA.useCallback)(function(event) {
        var key = event.keyCode ? event.keyCode : event.which;
        var callbackName = $9277681102fd6fca$var$KEYS[key];
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (callbackName && restProps[callbackName]) restProps[callbackName].apply(restProps, [
            event
        ].concat(rest));
        if (onKeyDown) onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    }, [
        onKeyDown,
        restProps
    ]);
    (0, $2NacA.useEffect)(function() {
        if (target === 'document') document.addEventListener('keydown', onKeyDownHandler, capture);
        return function() {
            if (target === 'document') document.removeEventListener('keydown', onKeyDownHandler, capture);
        };
    }, [
        capture,
        onKeyDownHandler,
        target
    ]);
    return target === 'document' ? children : /*#__PURE__*/ (0, $2NacA.cloneElement)((0, $2NacA.Children).only(children), {
        onKeyDown: onKeyDownHandler
    });
};
$9277681102fd6fca$export$16e4d70cc375e707.propTypes = (0, $fs0JC.KeyboardPropTypes);

});
parcelRegister("fs0JC", function(module, exports) {

$parcel$export(module.exports, "KeyboardPropTypes", () => $b3fa0a705ec569b3$export$52e12bf50c10ce6a);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $b3fa0a705ec569b3$var$PropType = {};
var $b3fa0a705ec569b3$export$52e12bf50c10ce6a = $b3fa0a705ec569b3$var$PropType;

});


parcelRegister("eBd4p", function(module, exports) {

$parcel$export(module.exports, "StyledBox", () => $aa0ea8d5368250a3$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledBoxGap", () => $aa0ea8d5368250a3$export$a800d5caa1dbbca6);

var $f5efw = parcelRequire("f5efw");

var $5h15o = parcelRequire("5h15o");

var $2O6LY = parcelRequire("2O6LY");
var $jQHd2 = parcelRequire("jQHd2");
var $2lgTr = parcelRequire("2lgTr");
var $fzxBh = parcelRequire("fzxBh");
var $hRaYF = parcelRequire("hRaYF");

var $2O6LY = parcelRequire("2O6LY");

var $4Tb4S = parcelRequire("4Tb4S");
var $aa0ea8d5368250a3$var$_FLEX_MAP;
function $aa0ea8d5368250a3$var$_extends() {
    return $aa0ea8d5368250a3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aa0ea8d5368250a3$var$_extends.apply(null, arguments);
}
var $aa0ea8d5368250a3$var$BASIS_MAP = {
    auto: 'auto',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $aa0ea8d5368250a3$var$basisStyle = (0, $f5efw.css)([
    "flex-basis:",
    ";"
], function(props) {
    return $aa0ea8d5368250a3$var$BASIS_MAP[props.basis] || props.theme.global.size[props.basis] || props.basis;
});
// min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
// we assume we are in the context of a Box going the other direction
// TODO: revisit this
var $aa0ea8d5368250a3$var$directionStyle = function directionStyle(direction, responsive, theme) {
    var styles = [
        (0, $f5efw.css)([
            "min-width:0;min-height:0;flex-direction:",
            ";"
        ], direction === 'row-responsive' ? 'row' : direction)
    ];
    if (direction === 'row-responsive' && theme.box.responsiveBreakpoint) {
        var breakpoint = (0, $hRaYF.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
        if (breakpoint) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n        flex-direction: column;\n        flex-basis: auto;\n        justify-content: flex-start;\n        align-items: stretch;\n      ", responsive));
    }
    return styles;
};
var $aa0ea8d5368250a3$var$FLEX_MAP = ($aa0ea8d5368250a3$var$_FLEX_MAP = {}, $aa0ea8d5368250a3$var$_FLEX_MAP[true] = '1 1', $aa0ea8d5368250a3$var$_FLEX_MAP[false] = '0 0', $aa0ea8d5368250a3$var$_FLEX_MAP.grow = '1 0', $aa0ea8d5368250a3$var$_FLEX_MAP.shrink = '0 1', $aa0ea8d5368250a3$var$_FLEX_MAP);
var $aa0ea8d5368250a3$var$flexGrowShrinkProp = function flexGrowShrinkProp(flex) {
    if (typeof flex === 'boolean' || typeof flex === 'string') return $aa0ea8d5368250a3$var$FLEX_MAP[flex];
    return (flex.grow ? flex.grow : 0) + " " + (flex.shrink ? flex.shrink : 0);
};
var $aa0ea8d5368250a3$var$flexStyle = (0, $f5efw.css)([
    "flex:",
    ";"
], function(props) {
    return "" + $aa0ea8d5368250a3$var$flexGrowShrinkProp(props.flex) + (props.flex !== true && !props.basis ? ' auto' : '');
});
var $aa0ea8d5368250a3$var$JUSTIFY_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    evenly: 'space-evenly',
    start: 'flex-start'
};
var $aa0ea8d5368250a3$var$justifyStyle = (0, $f5efw.css)([
    "justify-content:",
    ";"
], function(props) {
    return $aa0ea8d5368250a3$var$JUSTIFY_MAP[props.justify];
});
var $aa0ea8d5368250a3$var$WRAP_MAP = {
    "true": 'wrap',
    reverse: 'wrap-reverse'
};
var $aa0ea8d5368250a3$var$wrapStyle = (0, $f5efw.css)([
    "flex-wrap:",
    ";"
], function(props) {
    return $aa0ea8d5368250a3$var$WRAP_MAP[props.wrapProp];
});
var $aa0ea8d5368250a3$var$_animationItemStyle = function animationItemStyle(item, theme) {
    if (typeof item === 'string') return (0, $4Tb4S.animationObjectStyle)({
        type: item
    }, theme);
    if (Array.isArray(item)) return item.reduce(function(style, a, index) {
        return (0, $f5efw.css)([
            "",
            "",
            " ",
            ""
        ], style, index > 0 ? ',' : '', $aa0ea8d5368250a3$var$_animationItemStyle(a, theme));
    }, '');
    if (typeof item === 'object') return (0, $4Tb4S.animationObjectStyle)(item, theme);
    return '';
};
var $aa0ea8d5368250a3$var$animationAncilaries = function animationAncilaries(animation) {
    if (animation.type === 'flipIn' || animation.type === 'flipOut') return 'perspective: 1000px; transform-style: preserve-3d;';
    return '';
};
var $aa0ea8d5368250a3$var$animationObjectInitialStyle = function animationObjectInitialStyle(animation) {
    var bounds = (0, $4Tb4S.animationBounds)(animation.type, animation.size);
    if (bounds) return bounds[0] + " " + $aa0ea8d5368250a3$var$animationAncilaries(animation);
    return '';
};
var $aa0ea8d5368250a3$var$animationInitialStyle = function animationInitialStyle(item) {
    if (typeof item === 'string') return $aa0ea8d5368250a3$var$animationObjectInitialStyle({
        type: item
    });
    if (Array.isArray(item)) return item.map(function(a) {
        return typeof a === 'string' ? $aa0ea8d5368250a3$var$animationObjectInitialStyle({
            type: a
        }) : $aa0ea8d5368250a3$var$animationObjectInitialStyle(a);
    }).join('');
    if (typeof item === 'object') return $aa0ea8d5368250a3$var$animationObjectInitialStyle(item);
    return '';
};
var $aa0ea8d5368250a3$var$animationStyle = (0, $f5efw.css)([
    "",
    ";"
], function(props) {
    return (0, $f5efw.css)([
        "",
        " animation:",
        ";"
    ], $aa0ea8d5368250a3$var$animationInitialStyle(props.animation), $aa0ea8d5368250a3$var$_animationItemStyle(props.animation, props.theme));
});
var $aa0ea8d5368250a3$var$interactiveStyle = (0, $f5efw.css)([
    "cursor:pointer;&:hover{",
    " ",
    "}"
], function(props) {
    var _props$kindProp;
    return ((_props$kindProp = props.kindProp) == null ? void 0 : _props$kindProp.hover) && (0, $jQHd2.getHoverIndicatorStyle)(props.kindProp.hover, props.theme);
}, function(props) {
    return props.hoverIndicator && (0, $jQHd2.getHoverIndicatorStyle)(props.hoverIndicator, props.theme);
});
var $aa0ea8d5368250a3$var$gapStyle = function gapStyle(directionProp, gap, responsive, wrap, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, $hRaYF.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (typeof gap === 'object') {
        var responsiveColumnMetric = responsive && breakpoint && breakpoint.edgeSize[gap.column];
        var responsiveRowMetric = responsive && breakpoint && breakpoint.edgeSize[gap.row];
        if (gap.row !== undefined && gap.column !== undefined) {
            styles.push("gap: " + (theme.global.edgeSize[gap.row] || gap.row) + " " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveRowMetric || responsiveColumnMetric) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "gap: " + (responsiveRowMetric || gap.row) + " " + (responsiveColumnMetric || gap.column) + ";", responsive));
        } else if (gap.row !== undefined) {
            styles.push("row-gap: " + (theme.global.edgeSize[gap.row] || gap.row) + ";");
            if (responsiveRowMetric) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "row-gap: " + responsiveRowMetric + ";", responsive));
        } else if (gap.column !== undefined) {
            styles.push("column-gap: " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveColumnMetric) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "column-gap: " + responsiveColumnMetric + ";", responsive));
        }
    } else if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("column-gap: " + metric + ";");
        if (wrap) styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "column-gap: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
        }
    }
    return styles;
};
var $aa0ea8d5368250a3$var$responsiveContainerStyle = (0, $f5efw.css)([
    "container-type:inline-size;"
]);
// NOTE: basis must be after flex! Otherwise, flex overrides basis
// After upgrading to react 19 the 'selected' prop is leaking through
// to the DOM, added a check to prevent this.
var $aa0ea8d5368250a3$export$d675f139b342d51a = (0, $f5efw.default).div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $5h15o.default)(prop) && ![
            'selected'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledBox",
    componentId: "sc-13pk1d4-0"
})([
    "display:flex;box-sizing:border-box;",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.basis && 'max-width: 100%;';
}, (0, $2O6LY.genericStyles), function(props) {
    return props.align && (0, $2O6LY.alignStyle);
}, function(props) {
    return props.alignContent && (0, $2O6LY.alignContentStyle);
}, function(props) {
    return props.background && (0, $jQHd2.backgroundStyle)(props.background, props.theme);
}, function(props) {
    return props.border && (0, $2lgTr.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return props.directionProp && $aa0ea8d5368250a3$var$directionStyle(props.directionProp, props.responsive, props.theme);
}, function(props) {
    return props.heightProp && (0, $2O6LY.heightStyle)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, $2O6LY.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.flex !== undefined && $aa0ea8d5368250a3$var$flexStyle;
}, function(props) {
    return props.basis && $aa0ea8d5368250a3$var$basisStyle;
}, function(props) {
    return props.fillProp && (0, $2O6LY.fillStyle)(props.fillProp);
}, function(props) {
    return props.justify && $aa0ea8d5368250a3$var$justifyStyle;
}, function(props) {
    return props.pad && (0, $2O6LY.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, $2O6LY.roundStyle)(props.round, props.responsive, props.theme);
}, function(props) {
    return props.wrapProp && $aa0ea8d5368250a3$var$wrapStyle;
}, function(props) {
    return props.overflowProp && (0, $2O6LY.overflowStyle)(props.overflowProp);
}, function(props) {
    return props.elevationProp && (0, $2O6LY.elevationStyle)(props.elevationProp);
}, function(props) {
    return props.gap && $aa0ea8d5368250a3$var$gapStyle(props.directionProp, props.gap, props.responsive, props.wrapProp, props.theme);
}, function(props) {
    return props.animation && $aa0ea8d5368250a3$var$animationStyle;
}, function(props) {
    return props.onClick && $aa0ea8d5368250a3$var$interactiveStyle;
}, function(props) {
    return props.onClick && props.focus && props.focusIndicator !== false && // only show focus styles when using keyboard navigation
    // but not with mouse
    (0, $f5efw.css)([
        "",
        " &:focus:not(:focus-visible){",
        "}"
    ], (0, $2O6LY.focusStyle)(), (0, $2O6LY.unfocusStyle)());
}, function(props) {
    return props.theme.box && props.theme.box.extend;
}, function(props) {
    return props.kindProp && props.kindProp.extend;
}, function(props) {
    return props.responsiveContainer ? $aa0ea8d5368250a3$var$responsiveContainerStyle : '';
});
var $aa0ea8d5368250a3$var$gapGapStyle = function gapGapStyle(directionProp, gap, responsive, border, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, $hRaYF.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("height: " + metric + ";");
        if (responsiveMetric) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "height: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("width: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "width: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n          width: auto;\n          height: " + responsiveMetric + ";\n        ", responsive));
        }
    }
    if (border === 'between' || border && border.side === 'between') {
        var borderSize = border.size || theme.box.border.offset;
        var borderMetric = theme.global.borderSize[borderSize] || borderSize;
        var borderOffset = (0, $fzxBh.parseMetricToNum)(metric) / 2 - (0, $fzxBh.parseMetricToNum)(borderMetric) / 2 + "px";
        var responsiveBorderMetric = responsive && breakpoint && (breakpoint.borderSize[borderSize] || borderSize);
        var responsiveBorderOffset = responsiveBorderMetric && (0, $fzxBh.parseMetricToNum)(responsiveMetric || metric) / 2 - (0, $fzxBh.parseMetricToNum)(responsiveBorderMetric) / 2 + "px";
        if (directionProp === 'column' || directionProp === 'column-reverse') {
            var adjustedBorder = typeof border === 'string' ? 'top' : $aa0ea8d5368250a3$var$_extends({}, border, {
                side: 'top'
            });
            styles.push((0, $f5efw.css)([
                "position:relative;&:after{content:'';position:absolute;width:100%;top:",
                ";",
                "}"
            ], borderOffset, (0, $2lgTr.borderStyle)(adjustedBorder, responsive, theme)));
            if (responsiveBorderOffset) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n            &:after {\n              content: '';\n              top: " + responsiveBorderOffset + ";\n            }", responsive));
        } else {
            var _adjustedBorder = typeof border === 'string' ? 'left' : $aa0ea8d5368250a3$var$_extends({}, border, {
                side: 'left'
            });
            styles.push((0, $f5efw.css)([
                "position:relative;&:after{content:'';position:absolute;height:100%;left:",
                ";",
                "}"
            ], borderOffset, (0, $2lgTr.borderStyle)(_adjustedBorder, directionProp !== 'row-responsive' && responsive, theme)));
            if (responsiveBorderOffset) {
                if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n              &:after {\n                content: '';\n                left: " + responsiveBorderOffset + ";\n              }", responsive));
                else if (directionProp === 'row-responsive') {
                    var adjustedBorder2 = typeof border === 'string' ? 'top' : $aa0ea8d5368250a3$var$_extends({}, border, {
                        side: 'top'
                    });
                    styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n              &:after {\n                content: '';\n                height: auto;\n                left: unset;\n                width: 100%;\n                top: " + responsiveBorderOffset + ";\n                border-left: none;\n                " + (0, $2lgTr.responsiveBorderStyle)(adjustedBorder2, theme) + "\n              }", responsive));
                }
            }
        }
    }
    return styles;
};
var $aa0ea8d5368250a3$export$a800d5caa1dbbca6 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledBox__StyledBoxGap",
    componentId: "sc-13pk1d4-1"
})([
    "flex:0 0 auto;align-self:stretch;",
    ";"
], function(props) {
    return props.gap && $aa0ea8d5368250a3$var$gapGapStyle(props.directionProp, props.gap, props.responsive, props.border, props.theme);
});

});
parcelRegister("2lgTr", function(module, exports) {

$parcel$export(module.exports, "responsiveBorderStyle", () => $1b4aa5916309c45e$export$e6d7d76967e857a7);
$parcel$export(module.exports, "borderStyle", () => $1b4aa5916309c45e$export$4d0a7f76ad443516);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $d2fh4 = parcelRequire("d2fh4");

var $fzxBh = parcelRequire("fzxBh");
var $1b4aa5916309c45e$export$e6d7d76967e857a7 = function responsiveBorderStyle(data, theme) {
    var color = (0, $d2fh4.normalizeColor)(data.color || 'border', theme);
    var borderSize = data.size || 'xsmall';
    var style = data.style || 'solid';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    var value = breakpoint && (breakpoint.borderSize[borderSize] || borderSize) && style + " " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;
    if (!value) return undefined;
    if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') return "border-" + side + ": " + value + ";";
    if (side === 'end' || side === 'start') return "border-inline-" + side + ": " + value + ";";
    if (side === 'vertical') return "\n      border-left: " + value + ";\n      border-right: " + value + ";\n    ";
    if (side === 'horizontal') return "\n      border-top: " + value + ";\n      border-bottom: " + value + ";\n    ";
    if (side === 'between') return undefined; // no-op
    return "border: " + value + ";";
};
var $1b4aa5916309c45e$export$4d0a7f76ad443516 = function borderStyle(borderData, responsive, theme) {
    var borderStyles = [];
    (Array.isArray(borderData) ? borderData : [
        borderData
    ]).forEach(function(data) {
        var styles = [];
        var color = (0, $d2fh4.normalizeColor)(data.color || 'border', theme);
        var borderSize = data.size || 'xsmall';
        var style = data.style || 'solid';
        var side = typeof data === 'string' ? data : data.side || 'all';
        var value = style + " " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
        var responsiveStyle = responsive && $1b4aa5916309c45e$export$e6d7d76967e857a7(data, theme);
        var breakpoint = responsiveStyle && theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
        if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
            styles.push("border-" + side + ": " + value + ";");
            if (responsiveStyle) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'end' || side === 'start') {
            styles.push((0, $f5efw.css)([
                "border-inline-",
                ":",
                ";"
            ], side, value));
            if (responsiveStyle) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'vertical') {
            styles.push((0, $f5efw.css)([
                "border-left:",
                ";border-right:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'horizontal') {
            styles.push((0, $f5efw.css)([
                "border-top:",
                ";border-bottom:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'between') ;
        else {
            styles.push((0, $f5efw.css)([
                "border:",
                ";"
            ], value));
            if (responsiveStyle) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        }
        borderStyles.push(styles);
    });
    return borderStyles;
};

});

parcelRegister("4Tb4S", function(module, exports) {

$parcel$export(module.exports, "animationBounds", () => $38f4e43f64c141c1$export$106a9d8bc0bca92a);
$parcel$export(module.exports, "animationObjectStyle", () => $38f4e43f64c141c1$export$1d0c30b40b07398);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");
var $38f4e43f64c141c1$var$PULSE_SIZES = {
    xsmall: 1.001,
    small: 1.01,
    medium: 1.1,
    large: 1.5,
    xlarge: 2
};
var $38f4e43f64c141c1$var$SLIDE_SIZES = {
    xsmall: 1,
    small: 5,
    medium: 10,
    large: 50,
    xlarge: 200
};
var $38f4e43f64c141c1$var$JIGGLE_SIZES = {
    xsmall: 0.1,
    small: 1,
    medium: 5,
    large: 400,
    xlarge: 1000
};
var $38f4e43f64c141c1$var$ZOOM_SIZES = {
    xsmall: 0.001,
    small: 0.01,
    medium: 0.05,
    large: 0.1,
    xlarge: 0.5
};
var $38f4e43f64c141c1$export$106a9d8bc0bca92a = function animationBounds(type, size) {
    if (size === void 0) size = 'medium';
    if (type === 'draw') return [
        '',
        "stroke-dashoffset: 0"
    ];
    if (type === 'fadeIn') return [
        'opacity: 0;',
        'opacity: 1;'
    ];
    if (type === 'fadeOut') return [
        'opacity: 1;',
        'opacity: 0;'
    ];
    if (type === 'jiggle') {
        var deg = $38f4e43f64c141c1$var$JIGGLE_SIZES[size];
        return [
            "transform: rotate(-" + deg + "deg);",
            "transform: rotate(" + deg + "deg);"
        ];
    }
    if (type === 'pulse') return [
        'transform: scale(1);',
        "transform: scale(" + $38f4e43f64c141c1$var$PULSE_SIZES[size] + ")"
    ];
    if (type === 'rotateRight') return [
        "transform: rotate(0deg);",
        "transform: rotate(359deg);"
    ];
    if (type === 'rotateLeft') return [
        "transform: rotate(0deg);",
        "transform: rotate(-359deg);"
    ];
    if (type === 'flipIn') return [
        'transform: rotateY(90deg);',
        'transform: rotateY(0);'
    ];
    if (type === 'flipOut') return [
        'transform: rotateY(0);',
        'transform: rotateY(90deg);'
    ];
    if (type === 'slideDown') return [
        "transform: translateY(-" + $38f4e43f64c141c1$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideLeft') return [
        "transform: translateX(" + $38f4e43f64c141c1$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideRight') return [
        "transform: translateX(-" + $38f4e43f64c141c1$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideUp') return [
        "transform: translateY(" + $38f4e43f64c141c1$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'zoomIn') return [
        "transform: scale(" + (1 - $38f4e43f64c141c1$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    if (type === 'zoomOut') return [
        "transform: scale(" + (1 + $38f4e43f64c141c1$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    return [];
};
var $38f4e43f64c141c1$export$9eb47d7051add002 = function normalizeTiming(time, defaultTiming) {
    return typeof time === 'number' ? time / 1000.0 + "s" : time || defaultTiming;
};
var $38f4e43f64c141c1$export$cc25916ed0a5fe3a = function animationEnding(type) {
    if (type === 'draw') return 'linear forwards';
    if (type === 'jiggle') return 'alternate infinite';
    if (type === 'pulse') return 'alternate infinite';
    if (type === 'rotateRight' || type === 'rotateLeft') return 'infinite linear';
    return 'forwards';
};
var $38f4e43f64c141c1$export$1d0c30b40b07398 = function animationObjectStyle(animation, theme, themeObj) {
    var bounds = $38f4e43f64c141c1$export$106a9d8bc0bca92a(animation.type, animation.size);
    var animationTheme = themeObj && themeObj.animation || theme.global.animation;
    if (bounds) {
        var animationTransition = (0, $f5efw.css)([
            "from{",
            ";}to{",
            ";}"
        ], bounds[0], bounds[1]);
        var defaultDuration = function defaultDuration() {
            return $38f4e43f64c141c1$export$9eb47d7051add002(animationTheme[animation.type] ? animationTheme[animation.type].duration : animation.duration, animationTheme.duration);
        };
        return (0, $f5efw.css)([
            "",
            " ",
            " ",
            " ",
            ""
        ], (0, $f5efw.keyframes)([
            "",
            ""
        ], animationTransition), $38f4e43f64c141c1$export$9eb47d7051add002(animation.duration, defaultDuration()), $38f4e43f64c141c1$export$9eb47d7051add002(animation.delay, '0s'), $38f4e43f64c141c1$export$cc25916ed0a5fe3a(animation.type));
    }
    return '';
};

});


parcelRegister("5Oely", function(module, exports) {

$parcel$export(module.exports, "BoxPropTypes", () => $43acc03958326523$export$39ef5a49fe6b4917);

var $lwlwr = parcelRequire("lwlwr");

function $43acc03958326523$var$_extends() {
    return $43acc03958326523$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $43acc03958326523$var$_extends.apply(null, arguments);
}
var $43acc03958326523$var$OVERFLOW_VALUES = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];
var $43acc03958326523$var$BORDER_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
    color: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        })
    ]),
    side: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
// if you update values here, make sure to update in Drop/doc too.
var $43acc03958326523$var$overflowPropType = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($43acc03958326523$var$OVERFLOW_VALUES),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($43acc03958326523$var$OVERFLOW_VALUES),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf($43acc03958326523$var$OVERFLOW_VALUES)
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
]);
var $43acc03958326523$var$PropType = {};
var $43acc03958326523$export$39ef5a49fe6b4917 = $43acc03958326523$var$PropType;

});

parcelRegister("4ZVSM", function(module, exports) {

$parcel$export(module.exports, "SkeletonContext", () => $3a39c237d9331cf6$export$74e166679b1f49ee);
$parcel$export(module.exports, "useSkeleton", () => $3a39c237d9331cf6$export$9489db5f14593d18);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $3a39c237d9331cf6$export$74e166679b1f49ee = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext();
var $3a39c237d9331cf6$export$9489db5f14593d18 = function useSkeleton() {
    return (0, $2NacA.useContext)($3a39c237d9331cf6$export$74e166679b1f49ee);
};

});

parcelRegister("7oNsG", function(module, exports) {

$parcel$export(module.exports, "AnnounceContext", () => $563124576b96bcf9$export$dcc8f4bff0d51f50);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $8gUoO = parcelRequire("8gUoO");
var $563124576b96bcf9$var$DEFAULT_MODE = 'polite';
var $563124576b96bcf9$var$invisibleChars = [
    "\u200B",
    "\uFEFF",
    "\u200C",
    "\u200D"
];
var $563124576b96bcf9$var$createAnnouncer = function createAnnouncer() {
    var announcer = document.createElement('div');
    announcer.id = 'grommet-announcer';
    announcer.setAttribute('aria-live', $563124576b96bcf9$var$DEFAULT_MODE);
    announcer.setAttribute('aria-atomic', 'true');
    announcer.style.left = '-100%';
    announcer.style.right = '100%';
    announcer.style.position = 'fixed';
    announcer.style['z-index'] = '-1';
    document.body.insertBefore(announcer, document.body.firstChild);
    return announcer;
};
var $563124576b96bcf9$var$announceCounter = 0; // Counter to ensure unique announcements
var $563124576b96bcf9$var$clearTimeoutId; // Variable to hold the timeout ID for clearing
var $563124576b96bcf9$export$dcc8f4bff0d51f50 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(function(message, mode, timeout) {
    if (mode === void 0) mode = $563124576b96bcf9$var$DEFAULT_MODE;
    if (timeout === void 0) timeout = 500;
    // we only create a new container if we don't have one already
    // we create a separate node so that grommet does not set aria-hidden to it
    var announcer = document.body.querySelector("#grommet-announcer[aria-live]") || $563124576b96bcf9$var$createAnnouncer();
    announcer.setAttribute('aria-live', mode);
    // Clear any existing timeout before setting a new one
    if ($563124576b96bcf9$var$clearTimeoutId) clearTimeout($563124576b96bcf9$var$clearTimeoutId);
    if (mode === 'polite') // using setTimeout for polite mode pushes to next event loop tick,
    // giving time for the browser to process the change
    setTimeout(function() {
        var uniqueChar = $563124576b96bcf9$var$invisibleChars[$563124576b96bcf9$var$announceCounter % $563124576b96bcf9$var$invisibleChars.length];
        $563124576b96bcf9$var$announceCounter += 1; // Increment the counter for the next call
        // set the message with a unique invisible character to ensure
        // it is registered as different by screen readers
        announcer.textContent = "" + message + uniqueChar;
    }, 0);
    else announcer.textContent = message;
    // clear the message after the specified timeout
    $563124576b96bcf9$var$clearTimeoutId = setTimeout(function() {
        announcer.textContent = '';
    }, timeout);
});
$563124576b96bcf9$export$dcc8f4bff0d51f50.propTypes = (0, $8gUoO.AnnounceContextPropTypes);

});
parcelRegister("8gUoO", function(module, exports) {

$parcel$export(module.exports, "AnnounceContextPropTypes", () => $605b911498e9b4b6$export$33f2254b5dbf828a);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $605b911498e9b4b6$var$PropType = {};
var $605b911498e9b4b6$export$33f2254b5dbf828a = $605b911498e9b4b6$var$PropType;

});


parcelRegister("aHKsU", function(module, exports) {

$parcel$export(module.exports, "OptionsContext", () => $7cb1f68e2faf9e3c$export$b709306b005c3ef);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $7cb1f68e2faf9e3c$export$b709306b005c3ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext({});

});

parcelRegister("7wfCm", function(module, exports) {

$parcel$export(module.exports, "ResponsiveContainerContext", () => $5797a2ee02bc183b$export$505da1fc32900905);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $5797a2ee02bc183b$export$505da1fc32900905 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(false);

});

parcelRegister("5LTQm", function(module, exports) {

$parcel$export(module.exports, "ResponsiveContainerProvider", () => $433ca8e8c623e7e2$export$cc532883f3610b88);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $7wfCm = parcelRequire("7wfCm");
var $4zRSZ = parcelRequire("4zRSZ");

var $hRaYF = parcelRequire("hRaYF");
// The value of ResponsiveContainerContext
// when we're within a responsive container
var $433ca8e8c623e7e2$var$responsiveContainerValue = true;
var $433ca8e8c623e7e2$export$cc532883f3610b88 = function ResponsiveContainerProvider(_ref) {
    var container = _ref.container, theme = _ref.theme, children = _ref.children;
    var _useState = (0, $2NacA.useState)(function() {
        var _theme$global;
        return (0, $hRaYF.deviceResponsive)(navigator.userAgent, theme) || (theme == null || (_theme$global = theme.global) == null ? void 0 : _theme$global.deviceBreakpoints.tablet);
    }), value = _useState[0], setValue = _useState[1];
    (0, $2NacA.useEffect)(function() {
        if (!container) return undefined;
        // Track what breakpoint width of the container is at
        // and update the ResponsiveContext value accordingly.
        var resizeObserver;
        if (typeof window !== 'undefined' && window.ResizeObserver) {
            resizeObserver = new window.ResizeObserver(function(entries) {
                window.requestAnimationFrame(function() {
                    var _entries$;
                    if (!Array.isArray(entries) || !entries.length) return;
                    var size = (_entries$ = entries[0]) == null || (_entries$ = _entries$.borderBoxSize) == null || (_entries$ = _entries$[0]) == null ? void 0 : _entries$.inlineSize;
                    if (size) setValue((0, $hRaYF.getBreakpoint)(size, theme));
                });
            });
            resizeObserver.observe(container);
        }
        // Initial size for ResponsiveContext in responsive container mode.
        // Also is a fallback for server side rendering
        var containerWidth = container.getBoundingClientRect().width;
        setValue((0, $hRaYF.getBreakpoint)(containerWidth, theme));
        return function() {
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        container,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7wfCm.ResponsiveContainerContext).Provider, {
        value: $433ca8e8c623e7e2$var$responsiveContainerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $4zRSZ.ResponsiveContext).Provider, {
        value: value
    }, children));
};

});

parcelRegister("eL6w3", function(module, exports) {

$parcel$export(module.exports, "useThemeValue", () => $abea8268ca65cf13$export$b86e7a765e389e8f);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $cKZsv = parcelRequire("cKZsv");
function $abea8268ca65cf13$var$_extends() {
    return $abea8268ca65cf13$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $abea8268ca65cf13$var$_extends.apply(null, arguments);
}
/*
  Hook that returns theme value along with a flag to determine if we are 
  outside of a theme context provider, if so pass the base theme.
  If used outside of `<Grommet>` wrapper, falls back to base theme.
*/ var $abea8268ca65cf13$export$b86e7a765e389e8f = function useThemeValue() {
    var context = (0, $2NacA.useContext)((0, $f5efw.ThemeContext));
    var theme = context || (0, $cKZsv.defaultProps).theme;
    return {
        theme: theme,
        passThemeFlag: $abea8268ca65cf13$var$_extends({}, context === undefined ? {
            theme: theme
        } : {})
    };
};

});
parcelRegister("cKZsv", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $94997452ec350f08$export$9c21a3269931e1e6);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $7rlLx = parcelRequire("7rlLx");

var $EOOZq = parcelRequire("EOOZq");
var $94997452ec350f08$export$9c21a3269931e1e6 = {
    theme: (0, $EOOZq.base)
};
var $94997452ec350f08$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $94997452ec350f08$export$9c21a3269931e1e6.theme = (0, $7rlLx.deepMerge)((0, $EOOZq.base), theme);
};
var $94997452ec350f08$export$e8748c6a27b910dc = function withTheme(props) {
    return {
        theme: (0, $7rlLx.deepMerge)($94997452ec350f08$export$9c21a3269931e1e6.theme, props.theme)
    };
};

});
parcelRegister("7rlLx", function(module, exports) {

$parcel$export(module.exports, "deepFreeze", () => $56abf038518b83e0$export$7e32b29e1cb162e1);
$parcel$export(module.exports, "deepMerge", () => $56abf038518b83e0$export$6969335ea1e4e77c);
$parcel$export(module.exports, "removeUndefined", () => $56abf038518b83e0$export$c499305a875a8ee9);
function $56abf038518b83e0$var$_extends() {
    return $56abf038518b83e0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $56abf038518b83e0$var$_extends.apply(null, arguments);
}
var $56abf038518b83e0$export$a6cdc56e425d0d0a = function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
var $56abf038518b83e0$export$7e32b29e1cb162e1 = function deepFreeze(obj) {
    Object.keys(obj).forEach(function(key) {
        return key && $56abf038518b83e0$export$a6cdc56e425d0d0a(obj[key]) && Object.freeze(obj[key]);
    });
    return Object.freeze(obj);
};
var $56abf038518b83e0$export$6969335ea1e4e77c = function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $56abf038518b83e0$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($56abf038518b83e0$export$a6cdc56e425d0d0a(source)) Object.keys(source).forEach(function(key) {
            if ($56abf038518b83e0$export$a6cdc56e425d0d0a(source[key])) {
                if (!output[key]) output[key] = $56abf038518b83e0$var$_extends({}, source[key]);
                else output[key] = $56abf038518b83e0$export$6969335ea1e4e77c(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
};
var $56abf038518b83e0$export$c499305a875a8ee9 = function removeUndefined(obj) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (obj[key] !== undefined) result[key] = obj[key];
    });
    return result;
};

});

parcelRegister("EOOZq", function(module, exports) {

$parcel$export(module.exports, "base", () => $07ab289dafa0c866$export$e2253033e6e1df16);

var $eHBma = parcelRequire("eHBma");

var $jta6y = parcelRequire("jta6y");

var $h8SsP = parcelRequire("h8SsP");

var $9B1ut = parcelRequire("9B1ut");

var $7aiQi = parcelRequire("7aiQi");

var $emMxY = parcelRequire("emMxY");

var $gpz6W = parcelRequire("gpz6W");

var $8OmD4 = parcelRequire("8OmD4");

var $hwSTn = parcelRequire("hwSTn");

var $6Xlgn = parcelRequire("6Xlgn");

var $l4F8H = parcelRequire("l4F8H");

var $9AmjO = parcelRequire("9AmjO");

var $4wHe0 = parcelRequire("4wHe0");

var $52RYE = parcelRequire("52RYE");

var $9HTuS = parcelRequire("9HTuS");

var $b0HeC = parcelRequire("b0HeC");

var $iDbKq = parcelRequire("iDbKq");

var $7euNT = parcelRequire("7euNT");

var $5lYUK = parcelRequire("5lYUK");

var $ehCpZ = parcelRequire("ehCpZ");

var $3mta4 = parcelRequire("3mta4");

var $054Ni = parcelRequire("054Ni");

var $irJMV = parcelRequire("irJMV");

var $K1r2I = parcelRequire("K1r2I");

var $lwtww = parcelRequire("lwtww");

var $aSiTx = parcelRequire("aSiTx");

var $7rlLx = parcelRequire("7rlLx");

var $fzxBh = parcelRequire("fzxBh");
function $07ab289dafa0c866$var$_extends() {
    return $07ab289dafa0c866$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07ab289dafa0c866$var$_extends.apply(null, arguments);
}
var $07ab289dafa0c866$var$brandColor = '#7D4CDB';
var $07ab289dafa0c866$var$accentColors = [
    '#6FFFB0',
    '#FD6FFF',
    '#81FCED',
    '#FFCA58'
];
var $07ab289dafa0c866$var$neutralColors = [
    '#00873D',
    '#3D138D',
    '#00739D',
    '#A2423D'
];
var $07ab289dafa0c866$var$statusColors = {
    critical: '#EB0000',
    error: '#B30000',
    warning: '#C27B00',
    ok: '#009E67',
    unknown: '#919191',
    disabled: '#CCCCCC'
};
var $07ab289dafa0c866$var$darkColors = [
    '#333333',
    '#555555',
    '#777777',
    '#999999',
    '#999999',
    '#999999'
];
var $07ab289dafa0c866$var$lightColors = [
    '#F8F8F8',
    '#F2F2F2',
    '#EDEDED',
    '#DADADA',
    '#DADADA',
    '#DADADA'
];
var $07ab289dafa0c866$var$focusColor = $07ab289dafa0c866$var$accentColors[0];
var $07ab289dafa0c866$var$colors = {
    active: 'rgba(221, 221, 221, 0.5)',
    'background-back': {
        dark: '#33333308',
        light: '#EDEDED'
    },
    'background-front': {
        dark: '#444444',
        light: '#FFFFFF'
    },
    'background-contrast': {
        light: '#33333310',
        dark: '#FFFFFF18'
    },
    'active-background': 'background-contrast',
    'active-text': 'text-strong',
    black: '#000000',
    border: {
        dark: 'rgba(255, 255, 255, 0.33)',
        light: 'rgba(0, 0, 0, 0.33)'
    },
    brand: $07ab289dafa0c866$var$brandColor,
    control: {
        dark: 'accent-1',
        light: 'brand'
    },
    focus: $07ab289dafa0c866$var$focusColor,
    'graph-0': 'accent-1',
    'graph-1': 'neutral-1',
    'graph-2': 'neutral-2',
    'graph-3': 'neutral-3',
    'graph-4': 'neutral-4',
    placeholder: '#AAAAAA',
    selected: 'brand',
    text: {
        dark: '#f8f8f8',
        light: '#444444'
    },
    'text-strong': {
        dark: '#FFFFFF',
        light: '#000000'
    },
    'text-weak': {
        dark: '#CCCCCC',
        light: '#555555'
    },
    'text-xweak': {
        dark: '#BBBBBB',
        light: '#666666'
    },
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    'selected-background': 'brand',
    'selected-text': 'text-strong',
    white: '#FFFFFF'
};
var $07ab289dafa0c866$var$colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        $07ab289dafa0c866$var$colors[prefix + "-" + (index + 1)] = color;
    });
};
$07ab289dafa0c866$var$colorArray($07ab289dafa0c866$var$accentColors, 'accent');
$07ab289dafa0c866$var$colorArray($07ab289dafa0c866$var$darkColors, 'dark');
$07ab289dafa0c866$var$colorArray($07ab289dafa0c866$var$lightColors, 'light');
$07ab289dafa0c866$var$colorArray($07ab289dafa0c866$var$neutralColors, 'neutral');
Object.keys($07ab289dafa0c866$var$statusColors).forEach(function(color) {
    $07ab289dafa0c866$var$colors["status-" + color] = $07ab289dafa0c866$var$statusColors[color];
});
var $07ab289dafa0c866$export$80d376111cc09ad7 = function generate(baseSpacing, scale) {
    if (baseSpacing === void 0) baseSpacing = 24;
    if (scale === void 0) scale = 6;
    // 24
    var baseFontSize = baseSpacing * 0.75; // 18
    var fontScale = baseSpacing / scale; // 4
    var fontSizing = function fontSizing(factor) {
        return {
            size: baseFontSize + factor * fontScale + "px",
            height: baseSpacing + factor * fontScale + "px",
            // maxWidth chosen to be ~50 characters wide
            // see: https://ux.stackexchange.com/a/34125
            maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
        };
    };
    var borderWidth = 2;
    var controlBorderWidth = 1;
    var result = (0, $7rlLx.deepMerge)((0, $aSiTx.base), {
        global: {
            active: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            animation: {
                duration: '1s',
                jiggle: {
                    duration: '0.1s'
                }
            },
            // backgrounds: undefined,
            borderSize: {
                xsmall: '1px',
                small: '2px',
                medium: baseSpacing / 6 + "px",
                // 4
                large: baseSpacing / 2 + "px",
                // 12
                xlarge: baseSpacing + "px" // 24
            },
            breakpoints: {
                small: {
                    value: baseSpacing * 32,
                    // 768
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        // 4
                        large: baseSpacing / 4 + "px",
                        // 6
                        xlarge: baseSpacing / 2 + "px" // 12
                    },
                    edgeSize: {
                        none: '0px',
                        hair: '1px',
                        // for Chart
                        xxsmall: '2px',
                        xsmall: baseSpacing / 8 + "px",
                        // 3
                        small: baseSpacing / 4 + "px",
                        // 6
                        medium: baseSpacing / 2 + "px",
                        // 12
                        large: baseSpacing + "px",
                        // 24
                        xlarge: baseSpacing * 2 + "px" // 48
                    },
                    // radius: {},
                    size: {
                        xxsmall: baseSpacing + "px",
                        // 24
                        xsmall: baseSpacing * 2 + "px",
                        // 48
                        small: baseSpacing * 4 + "px",
                        // 96
                        medium: baseSpacing * 8 + "px",
                        // 192
                        large: baseSpacing * 16 + "px",
                        // 384
                        xlarge: baseSpacing * 32 + "px",
                        // 768
                        full: '100%'
                    }
                },
                medium: {
                    value: baseSpacing * 64 // 1536
                },
                large: {} // anything above 'medium'
            },
            // Breakpoints used at Server Side Rendering for the initial rendering
            // These values correspond to the theme breakpoints
            deviceBreakpoints: {
                phone: 'small',
                tablet: 'medium',
                computer: 'large'
            },
            colors: $07ab289dafa0c866$var$colors,
            control: {
                border: {
                    width: controlBorderWidth + "px",
                    radius: '4px',
                    color: 'border'
                },
                disabled: {
                    opacity: 0.3
                }
            },
            // The time to wait after the user stopped typing, measured in ms.
            // A half second (500ms) debounce can be a helpful starting point.
            // You want to give the user time to fill out a field, but capture
            // their attention before they move on past it. 2 second (2000ms)
            // might be too long depending on how fast people type, and 200ms
            // would be an eye blink
            debounceDelay: 500,
            // deprecated: {
            //   backgrounds: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   colors: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   button: {
            //     kind: [
            //       {
            //         name: string,
            //         message: string,
            //       },
            //     ],
            //   },
            // },
            drop: {
                // intelligentMargin: undefined,
                background: {
                    dark: 'black',
                    light: 'white'
                },
                border: {
                    radius: '0px'
                },
                // margin: undefined
                shadowSize: 'small',
                // shadowSize is deprecated, use 'elevation'
                zIndex: '20'
            },
            edgeSize: {
                none: '0px',
                hair: '1px',
                // for Chart
                xxsmall: baseSpacing / 8 + "px",
                // 3
                xsmall: baseSpacing / 4 + "px",
                // 6
                small: baseSpacing / 2 + "px",
                // 12
                medium: baseSpacing + "px",
                // 24
                large: baseSpacing * 2 + "px",
                // 48
                xlarge: baseSpacing * 4 + "px",
                // 96
                responsiveBreakpoint: 'small'
            },
            elevation: {
                light: {
                    none: 'none',
                    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
                    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
                    medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
                    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
                    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
                },
                dark: {
                    none: 'none',
                    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
                    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
                    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
                    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
                    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
                }
            },
            focus: {
                // shadow or outline are required for accessibility
                border: {
                    // remove to only have shadow
                    color: 'focus'
                },
                // outline: { color: undefined, size: undefined },
                shadow: {
                    color: 'focus',
                    size: '2px'
                },
                twoColor: undefined,
                inset: {
                    border: {
                        // remove to only have shadow
                        color: 'focus'
                    },
                    outline: {
                        color: 'focus',
                        size: '2px',
                        offset: '-2px'
                    },
                    shadow: undefined,
                    twoColor: undefined
                }
            },
            font: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
            hover: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            input: {
                padding: {
                    horizontal: (0, $fzxBh.parseMetricToNum)(baseSpacing / 2 + "px") - (0, $fzxBh.parseMetricToNum)(controlBorderWidth + "px") + "px",
                    vertical: (0, $fzxBh.parseMetricToNum)(baseSpacing / 2 + "px") - (0, $fzxBh.parseMetricToNum)(controlBorderWidth + "px") + "px"
                },
                font: {
                    // size: undefined,
                    // height: undefined,
                    weight: 600
                },
                // deprecate in v3
                // weight: undefined,
                readOnly: {
                }
            },
            opacity: {
                strong: 0.8,
                medium: 0.4,
                weak: 0.1
            },
            // radius: {},
            selected: {
                background: 'selected',
                color: 'white'
            },
            spacing: baseSpacing + "px",
            size: {
                xxsmall: baseSpacing * 2 + "px",
                // 48
                xsmall: baseSpacing * 4 + "px",
                // 96
                small: baseSpacing * 8 + "px",
                // 192
                medium: baseSpacing * 16 + "px",
                // 384
                large: baseSpacing * 32 + "px",
                // 768
                xlarge: baseSpacing * 48 + "px",
                // 1152
                xxlarge: baseSpacing * 64 + "px",
                // 1536
                full: '100%'
            }
        },
        // icon: {
        //   extend: undefined,
        //   matchSize: undefined,
        //   size: undefined,
        // },
        accordion: {
            icon: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            label: {
                container: {
                    pad: {
                        horizontal: 'xsmall'
                    }
                }
            },
            panel: {
            },
            border: {
                side: 'bottom',
                color: 'border'
            },
            heading: {
                level: '4' // level ranges from 1-6
            },
            hover: {
                // background: undefined,
                color: {
                    dark: 'light-4',
                    light: 'dark-3'
                },
                // deprecated
                heading: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    }
                }
            },
            icons: {
                collapse: (0, $l4F8H.FormUp),
                expand: (0, $8OmD4.FormDown)
            }
        },
        anchor: {
            color: {
                dark: 'accent-1',
                light: 'brand'
            },
            gap: 'small',
            hover: {
                textDecoration: 'underline'
            },
            // icon: {
            //   color: undefined
            // },
            iconOnly: {
                pad: 'small'
            },
            textDecoration: 'none',
            fontWeight: 600
        },
        avatar: {
            // extend: undefined,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                // 18px
                small: baseSpacing + "px",
                // 24px
                medium: baseSpacing * 2 + "px",
                // default 48px
                large: baseSpacing * 3 + "px",
                // 72px
                xlarge: baseSpacing * 4 + "px",
                // 96px
                '2xl': baseSpacing * 5 + "px",
                // 120px
                '3xl': baseSpacing * 6 + "px",
                // 144px
                '4xl': baseSpacing * 7 + "px",
                // 168px
                '5xl': baseSpacing * 8 + "px" // 192px
            },
            text: {
                size: {
                    xsmall: 'small',
                    // 14px
                    small: 'medium',
                    // 18px
                    medium: 'large',
                    // 22px
                    large: 'xlarge',
                    // 26px
                    xlarge: 'xxlarge',
                    // 34px
                    '2xl': '3xl',
                    // 42px
                    '3xl': '4xl',
                    // 54px
                    '4xl': '5xl',
                    // 70px
                    '5xl': '6xl' // 90px
                }
            }
        },
        box: {
            border: {
                offset: 'xsmall'
            },
            responsiveBreakpoint: 'small' // when we switch rows to columns
        },
        button: {
            intelligentPad: true,
            // background: undefined,
            badge: {
                // align: undefined,,
                container: {
                    background: 'brand'
                },
                size: {
                    medium: baseSpacing + "px" // 24px
                },
                text: {
                    size: {
                        medium: 'small' // 14px
                    }
                }
            },
            busy: {
                gap: 'small'
            },
            gap: 'small',
            size: {
                small: {
                    border: {
                        radius: baseSpacing * 0.75 + "px"
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth * 2 + "px" // 20px,
                    }
                },
                medium: {
                    border: {
                        radius: baseSpacing * 0.75 + "px" // 18px
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth + "px" // 22px
                    }
                },
                large: {
                    border: {
                        radius: baseSpacing + "px" // 24px
                    },
                    pad: {
                        vertical: baseSpacing / 4 + borderWidth + "px",
                        // 8px
                        horizontal: baseSpacing + borderWidth * 4 + "px" // 32px,
                    }
                }
            },
            border: {
                // color: { dark: undefined, light: undefined }
                width: borderWidth + "px",
                radius: baseSpacing * 0.75 + "px"
            },
            // color: { dark: undefined, light: undefined },
            // elevation: undefined,
            // default: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // primary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // secondary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // option: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            active: {
                background: 'active-background',
                //   border: undefined,
                color: 'active-text'
            },
            disabled: {
                //   background: undefined,
                //   border: undefined,
                //   color: undefined,
                opacity: 0.3
            },
            // hover: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   extend: undefined,
            //   default: {},
            //   primary: {},
            //   secondary: {},
            // },
            padding: {
                vertical: baseSpacing / 4 - borderWidth + "px",
                horizontal: baseSpacing - borderWidth + "px"
            },
            transition: {
                timing: 'ease-in-out',
                duration: 0.1,
                properties: [
                    'color',
                    'background-color',
                    'border-color',
                    'box-shadow'
                ]
            },
            skeleton: {
                width: {
                    min: '100px'
                }
            }
        },
        calendar: {
            day: {
                // adjacent: {
                //   color: undefined,
                // },
                hover: {
                    background: 'active-background'
                },
                selected: {
                    // background: undefined,
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                },
                inRange: {
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                }
            },
            // range: {
            //   background: undefined,
            // },
            // daySize must align with global.size
            small: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize - fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'xsmall'
                        }
                    }
                },
                lineHeight: 1.375,
                daySize: baseSpacing * 8 / 7 + "px",
                slideDuration: '0.2s'
            },
            medium: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'small'
                        }
                    }
                },
                lineHeight: 1.45,
                daySize: baseSpacing * 16 / 7 + "px",
                slideDuration: '0.5s'
            },
            large: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + 3 * fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'medium'
                        }
                    }
                },
                lineHeight: 1.11,
                daySize: baseSpacing * 32 / 7 + "px",
                slideDuration: '0.8s'
            },
            icons: {
                previous: (0, $b0HeC.Previous),
                next: (0, $9AmjO.Next),
                small: {
                    previous: (0, $6Xlgn.FormPrevious),
                    next: (0, $hwSTn.FormNext)
                }
            },
            heading: {
                level: '4'
            } // level ranges from 1-6
        },
        card: {
            container: {
                round: 'small',
                elevation: 'small'
            },
            // hover: {
            //   container: {
            //     elevation: undefined,
            //   },
            // },
            header: {},
            body: {},
            footer: {}
        },
        cards: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            grid: {
                columns: 'small',
                gap: 'medium'
            }
        },
        carousel: {
            icons: {
                current: (0, $054Ni.Subtract),
                next: (0, $9AmjO.Next),
                previous: (0, $b0HeC.Previous)
            },
            animation: {
                duration: 1000
            },
            disabled: {
                icons: {
                }
            }
        },
        chart: {
            color: 'graph-0',
            height: 'small',
            thickness: 'medium',
            width: 'medium'
        },
        checkBox: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            check: {
                // extend: undefined,
                radius: '4px',
                thickness: '4px'
            },
            label: {
                align: 'center'
            },
            // color: { dark: undefined, light: undefined },
            // extend: undefined,
            gap: 'small',
            hover: {
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            // pad: undefined,
            size: baseSpacing + "px",
            toggle: {
                // background: undefined
                color: {
                    dark: '#d9d9d9',
                    light: '#d9d9d9'
                },
                knob: {
                },
                radius: baseSpacing + "px",
                size: baseSpacing * 2 + "px"
            }
        },
        checkBoxGroup: {
            container: {
                //   // any box props
                //   extend: undefined,
                gap: 'small'
            }
        },
        clock: {
            analog: {
                // extend: undefined,
                hour: {
                    color: {
                        dark: 'light-2',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 3 + "px",
                    size: baseSpacing + "px",
                    shape: 'round'
                },
                minute: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 6 + "px",
                    size: Math.round(baseSpacing / 2) + "px",
                    shape: 'round'
                },
                second: {
                    color: {
                        dark: 'accent-1',
                        light: 'accent-1'
                    },
                    width: baseSpacing / 8 + "px",
                    size: Math.round(baseSpacing / 2.666) + "px",
                    shape: 'round'
                },
                size: {
                    xsmall: baseSpacing * 2 + "px",
                    small: baseSpacing * 3 + "px",
                    medium: baseSpacing * 4 + "px",
                    large: baseSpacing * 6 + "px",
                    xlarge: baseSpacing * 9 + "px",
                    xxlarge: baseSpacing * 12 + "px",
                    huge: baseSpacing * 12 + "px" // kept for backwards compatibility
                }
            },
            digital: {
                text: {
                    xsmall: {
                        size: baseFontSize - 2 * fontScale + "px",
                        height: 1.5
                    },
                    small: {
                        size: baseFontSize - fontScale + "px",
                        height: 1.43
                    },
                    medium: {
                        size: baseFontSize + "px",
                        height: 1.375
                    },
                    large: {
                        size: baseFontSize + fontScale + "px",
                        height: 1.167
                    },
                    xlarge: {
                        size: baseFontSize + 2 * fontScale + "px",
                        height: 1.1875
                    },
                    xxlarge: {
                        size: baseFontSize + 4 * fontScale + "px",
                        height: 1.125
                    }
                }
            }
        },
        collapsible: {
            minSpeed: 200,
            baseline: 500
        },
        data: {
            // button: {
            //   kind: undefined,
            // },
            drop: {
                pad: 'small'
            },
            toolbar: {
                gap: 'medium'
            }
        },
        dataChart: {
            // colors: [],
            gap: 'small',
            // granularity: {
            //   y: {},
            // },
            detail: {
                gap: 'xsmall',
                pad: 'small'
            },
            halfPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            },
            legend: {
                margin: {
                    top: 'small'
                },
                gap: 'small',
                item: {
                    gap: 'xsmall',
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            // orderedSizes: undefined,
            size: {
                height: 'small'
            },
            thickness: {
                veryDense: 'hair',
                dense: 'xsmall',
                heavy: 'small',
                moderate: 'medium',
                light: 'large',
                sparse: 'xlarge'
            },
            thicknessPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            }
        },
        dataFilter: {
            rangeSelector: {
                size: 'full',
                round: 'small'
            },
            selectMultiple: {
                dropHeight: 'medium'
            }
        },
        dataFilters: {
            // icons: {
            //   close: undefined,
            //   filter: undefined,
            // }
            footer: {
                actions: {
                    margin: {
                        top: 'medium'
                    },
                    gap: 'small'
                }
            },
            clearControl: {
                margin: {
                    start: 'small'
                }
            },
            pad: 'medium',
            width: {
                min: 'medium'
            }
        },
        dateInput: {
            button: {
                margin: 'small'
            },
            container: {
                round: 'xxsmall'
            },
            icon: {
                // calendar: undefined,
                size: 'medium'
            }
        },
        dateTimeInput: {
            button: {
                margin: {
                    right: 'small'
                }
            },
            container: {
                round: 'xxsmall'
            },
            active: {
                background: 'active-background',
                pad: 'xxsmall',
                indicator: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    },
                    size: 'small'
                }
            },
            drop: {
                pad: 'small',
                gap: 'small',
                border: {
                    color: 'border',
                    size: 'xsmall'
                }
            },
            calendar: {
                day: {
                    selected: {
                        background: 'selected'
                    }
                }
            },
            icon: {
                calendar: undefined
            },
            separator: {
                pad: 'xxsmall'
            }
        },
        dataSearch: {
        },
        dataSort: {
        },
        dataSummary: {
            margin: {
                vertical: 'xsmall'
            },
            separator: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        dataTable: {
            // body: {
            //   extend: undefined,
            //   row: {
            //     extend: undefined,
            //   }
            //   selected: undefined,
            // },
            expand: {
                size: 'xxsmall'
            },
            pinned: {
                // body: {
                //    background: undefined,
                //    extend: undefined,
                // },
                header: {
                    background: {
                        opacity: 'strong'
                    }
                },
                footer: {
                    background: {
                        opacity: 'strong'
                    }
                }
            },
            container: {
                // any box props
                gap: 'xsmall'
            },
            groupHeader: {
            },
            groupEnd: {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                }
            },
            header: {
                // background: undefined,
                // border: undefined,
                // color: undefined,
                // extend: undefined,
                // font: {
                //   weight: undefined,
                //   size: undefined,
                // },
                gap: 'small',
                // hover: {
                //   background: undefined,
                // },
                // pad: undefined,
                units: {
                    color: 'text-xweak',
                    margin: {
                        left: 'xsmall'
                    },
                    alignSelf: 'end'
                }
            },
            icons: {
                ascending: (0, $8OmD4.FormDown),
                contract: (0, $l4F8H.FormUp),
                descending: (0, $l4F8H.FormUp),
                expand: (0, $8OmD4.FormDown)
            },
            primary: {
                weight: 'bold'
            },
            resize: {
                border: {
                    color: 'border',
                    side: 'end'
                },
                // hover: {
                //   border: {
                //     color: undefined,
                //     side: undefined,
                //     size: undefined,
                //   },
                // },
                padding: {
                    vertical: 'xsmall'
                }
            },
            search: {
                pad: {
                    left: 'small'
                },
                text: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            sort: {
                gap: 'xsmall'
            }
        },
        dataTableColumns: {
            // icons: {
            //   control: undefined,
            //   pinned: undefined,
            //   search: undefined,
            // }
            tabs: {
                pad: 'small'
            },
            selectColumns: {
                pad: {
                    vertical: 'small'
                },
                gap: 'xsmall'
            },
            orderColumns: {
                pad: {
                    top: 'small'
                }
            }
        },
        diagram: {
            // extend: undefined,
            line: {
                color: 'graph-0'
            }
        },
        distribution: {
            gap: 'xsmall'
        },
        // drop: {
        //   extend: undefined,
        //   maxHeight: undefined,
        // },
        fileInput: {
            anchor: {
                margin: 'small'
            },
            // background: {},
            border: {
                // color: undefined,
                side: 'all',
                size: 'small',
                style: 'dashed'
            },
            dragOver: {
                border: {
                    color: 'control'
                }
            },
            hover: {
                border: {
                    color: 'brand'
                }
            },
            icons: {
                // error: undefined,
                remove: (0, $gpz6W.FormClose)
            },
            // pad: {},
            label: {
                gap: 'xsmall',
                margin: 'small'
            },
            message: {
                margin: 'small'
            }
        },
        footer: {
            gap: 'medium'
        },
        formField: {
            // [inputname]: {
            //  container: {
            //    extend: undefined,
            //   },
            //   hover: {
            //     background: {
            //       color: undefined,
            //     },
            //     border: {
            //       color: undefined,
            //     },
            //   },
            // }
            border: {
                color: 'border',
                error: {
                    color: {
                        dark: 'white',
                        light: 'status-critical'
                    }
                },
                position: 'inner',
                side: 'bottom'
            },
            // checkBox: {
            //   pad: undefined,
            // },
            content: {
                // margin: undefined,
                pad: 'small'
            },
            disabled: {
                background: {
                    color: 'status-disabled',
                    opacity: 'medium'
                }
            },
            focus: {
                containerFocus: true
            },
            error: {
                color: 'status-critical',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            // hover: {
            //   background: {
            //     color: undefined,
            //   },
            //   border: {
            //     color: undefined,
            //   },
            // },
            // extend: undefined,
            help: {
                color: 'dark-2',
                margin: {
                    start: 'small'
                }
            },
            info: {
                color: 'text-xweak',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            label: {
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            margin: {
                bottom: 'small'
            },
            // round: undefined,
            survey: {
                label: {
                    margin: {
                        bottom: 'xsmall'
                    },
                    size: 'medium',
                    weight: 400
                }
            }
        },
        grommet: {
        },
        header: {
            sticky: {
                zIndex: '20'
            },
            gap: 'medium'
        },
        heading: {
            // color: undefined,
            font: {
            },
            level: {
                1: {
                    font: {
                    },
                    small: $07ab289dafa0c866$var$_extends({}, fontSizing(4)),
                    medium: $07ab289dafa0c866$var$_extends({}, fontSizing(8)),
                    large: $07ab289dafa0c866$var$_extends({}, fontSizing(16)),
                    xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(24))
                },
                2: {
                    font: {
                    },
                    small: $07ab289dafa0c866$var$_extends({}, fontSizing(2)),
                    medium: $07ab289dafa0c866$var$_extends({}, fontSizing(4)),
                    large: $07ab289dafa0c866$var$_extends({}, fontSizing(8)),
                    xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(12))
                },
                3: {
                    font: {
                    },
                    small: $07ab289dafa0c866$var$_extends({}, fontSizing(1)),
                    medium: $07ab289dafa0c866$var$_extends({}, fontSizing(2)),
                    large: $07ab289dafa0c866$var$_extends({}, fontSizing(4)),
                    xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(6))
                },
                4: {
                    font: {
                    },
                    small: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
                    medium: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
                    large: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
                    xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(0))
                },
                5: {
                    font: {
                    },
                    small: $07ab289dafa0c866$var$_extends({}, fontSizing(-0.5)),
                    medium: $07ab289dafa0c866$var$_extends({}, fontSizing(-0.5)),
                    large: $07ab289dafa0c866$var$_extends({}, fontSizing(-0.5)),
                    xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(-0.5))
                },
                6: {
                    font: {
                    },
                    small: $07ab289dafa0c866$var$_extends({}, fontSizing(-1)),
                    medium: $07ab289dafa0c866$var$_extends({}, fontSizing(-1)),
                    large: $07ab289dafa0c866$var$_extends({}, fontSizing(-1)),
                    xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(-1))
                }
            },
            responsiveBreakpoint: 'small',
            // when we scale the font size down
            weight: 600,
            skeleton: {
                width: {
                    min: '150px',
                    max: '200px'
                }
            }
        },
        layer: {
            background: {
                dark: 'black',
                light: 'white'
            },
            border: {
                radius: '4px'
            },
            container: {
                // elevation: undefined,
                zIndex: '20',
                height: {
                    min: 'xxsmall'
                }
            },
            // extend: undefined,
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)'
            },
            responsiveBreakpoint: 'small',
            // when Layer takes over the full screen
            zIndex: '20'
        },
        list: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            item: {
                // background: undefined,
                border: 'horizontal',
                disabled: {
                    color: 'status-disabled',
                    cursor: 'default'
                },
                gap: 'medium',
                pinned: {
                    background: 'background-contrast',
                    icon: {
                        size: 'medium',
                        pad: 'small'
                    }
                },
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                }
            },
            primaryKey: {
                // any text props
                weight: 'bold'
            },
            icons: {
                down: (0, $8OmD4.FormDown),
                up: (0, $l4F8H.FormUp),
                pin: (0, $9HTuS.FormPin)
            }
        },
        maskedInput: {
        },
        menu: {
            // background: undefined,
            // extend: undefined,
            // item: undefined,
            drop: {
                align: {
                    top: 'top',
                    left: 'left'
                }
            },
            // container: {
            //   // any box props
            // },
            group: {
                container: {
                    pad: {
                        vertical: 'xsmall'
                    }
                },
                separator: {
                    color: 'border',
                    size: 'xsmall',
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            icons: {
                down: (0, $8OmD4.FormDown)
            }
        },
        meter: {
            background: {
                color: 'light-2',
                opacity: 'medium'
            },
            color: 'graph-0'
        },
        nameValueList: {
            gap: {
                column: 'large',
                row: 'small'
            },
            pair: {
                column: {
                    gap: {
                        column: 'large',
                        row: 'medium'
                    }
                }
            },
            name: {
                width: 'small'
            },
            value: {
                width: 'medium'
            }
        },
        nameValuePair: {
            column: {
                gap: 'xxsmall'
            },
            name: {
                // any text props
                color: 'text',
                weight: 'bold'
            },
            value: {
                // any text props
                color: 'text'
            }
        },
        nav: {
            gap: 'medium'
        },
        notification: {
            actions: {
                // any anchor props
                margin: {
                    right: 'xsmall'
                }
            },
            direction: 'column',
            container: {
                // any box props
                round: 'xsmall',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                background: {
                    color: 'background-front'
                }
            },
            gap: 'small',
            global: {
                direction: 'row',
                container: {
                    // any box props
                    round: 'none',
                    pad: {
                        horizontal: 'large',
                        vertical: 'xsmall'
                    }
                }
            },
            toast: {
                // direction: undefined,
                container: {
                    // any box props
                    elevation: 'medium',
                    width: 'medium'
                },
                layer: {
                    position: 'top',
                    margin: 'medium'
                },
                time: 8000
            },
            iconContainer: {
                // any box props
                pad: {
                    right: 'small'
                },
                flex: false
            },
            textContainer: {
                // any box props
                gap: 'medium'
            },
            title: {
                // any text props
                weight: 'bold'
            },
            message: {
                // any text props
                margin: 'none',
                // fill: undefined,
                text: {
                    margin: {
                        right: 'xsmall'
                    }
                }
            },
            close: {
                icon: (0, $gpz6W.FormClose)
            },
            critical: {
                icon: (0, $7euNT.StatusCriticalSmall),
                background: {
                    color: 'status-critical',
                    opacity: 'weak'
                },
                color: 'status-critical',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            warning: {
                icon: (0, $ehCpZ.StatusWarningSmall),
                background: {
                    color: 'status-warning',
                    opacity: 'weak'
                },
                color: 'status-warning',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            normal: {
                icon: (0, $5lYUK.StatusGoodSmall),
                background: {
                    color: 'status-ok',
                    opacity: 'weak'
                },
                color: 'status-ok',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            info: {
                icon: (0, $h8SsP.CircleInformation),
                background: 'background-contrast',
                color: 'text-strong',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            unknown: {
                icon: (0, $3mta4.StatusUnknownSmall),
                background: {
                    color: 'status-unknown',
                    opacity: 'weak'
                },
                color: 'status-unknown',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            // deprecate "undefined" in v3
            // and if undefined, no icon
            undefined: {
                icon: (0, $3mta4.StatusUnknownSmall),
                // background: undefined,
                color: 'status-unknown'
            }
        },
        page: {
            wide: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'xxlarge'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            narrow: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'large'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            full: {
                alignSelf: 'start',
                width: {
                    min: 'medium',
                    max: '100%'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            }
        },
        pageHeader: {
            actions: {
                // any box props
                align: 'end'
            },
            pad: {
                top: 'large',
                bottom: 'medium'
            },
            parent: {
                // any box props
                align: 'start'
            },
            responsive: {
                actions: {
                    // any box props
                    align: 'start',
                    pad: {
                        top: 'small'
                    }
                },
                areas: [
                    [
                        'parent'
                    ],
                    [
                        'title'
                    ],
                    [
                        'subtitle'
                    ],
                    [
                        'actions'
                    ]
                ],
                breakpoints: [
                    'small'
                ],
                columns: [
                    'auto'
                ],
                rows: [
                    'auto'
                ]
            },
            subtitle: {
                // any paragraph props
                margin: 'none'
            },
            title: {
                // any heading props
                margin: 'none',
                fill: true
            },
            size: {
                small: {
                    pad: {
                        top: 'medium',
                        bottom: 'small'
                    },
                    subtitle: {
                        size: 'small'
                    },
                    title: {
                        size: 'small'
                    }
                },
                // medium: {
                //   // pad: undefined,
                //   // subtitle: {},
                //   // title: {},
                // },
                large: {
                    pad: {
                        top: 'xlarge',
                        bottom: 'large'
                    },
                    subtitle: {
                        size: 'large'
                    },
                    title: {
                        size: 'large'
                    }
                }
            },
            small: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'small',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            },
            medium: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'medium'
                }
            },
            large: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            }
        },
        pagination: {
            button: {
                active: {
                    background: {
                        color: 'active-background'
                    }
                },
                color: 'text-strong',
                hover: {
                    background: {
                        color: 'background-contrast'
                    },
                    color: undefined
                },
                size: {
                    small: {
                        border: {
                            radius: baseSpacing / 8 + "px",
                            // 3
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $07ab289dafa0c866$var$_extends({}, fontSizing(-1)),
                        height: baseSpacing * 1.25 + "px",
                        width: baseSpacing * 1.25 + "px"
                    },
                    medium: {
                        border: {
                            radius: baseSpacing / 6 + "px",
                            // 4
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
                        height: baseSpacing * 1.5 + "px",
                        width: baseSpacing * 1.5 + "px"
                    },
                    large: {
                        border: {
                            radius: baseSpacing / 4 + "px",
                            // 6
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $07ab289dafa0c866$var$_extends({}, fontSizing(1)),
                        height: baseSpacing * 2 + "px",
                        width: baseSpacing * 2 + "px"
                    }
                }
            },
            container: {
                gap: {
                    column: 'xsmall',
                    row: 'small'
                }
            },
            controls: {
                align: 'center',
                direction: 'row',
                gap: 'xxsmall',
                margin: 'none',
                pad: 'none'
            },
            icons: {
                // color: undefined,
                next: (0, $9AmjO.Next),
                previous: (0, $b0HeC.Previous)
            },
            step: {
                container: {
                    gap: 'xsmall'
                }
            }
        },
        paragraph: {
            font: {
            },
            small: $07ab289dafa0c866$var$_extends({}, fontSizing(-1)),
            medium: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
            large: $07ab289dafa0c866$var$_extends({}, fontSizing(1)),
            xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(2)),
            xxlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(4)),
            skeleton: {
                gap: 'xsmall'
            }
        },
        thumbsRating: {
        },
        spinner: {
            container: {
                animation: 'rotateRight',
                color: 'brand',
                pad: 'small',
                round: 'full',
                size: 'small'
            },
            // icon: undefined
            responsive: true,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                small: baseSpacing + "px",
                // default 24
                medium: baseSpacing * 2 + "px",
                large: baseSpacing * 3 + "px",
                xlarge: baseSpacing * 4 + "px"
            }
        },
        radioButton: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            // background: {
            //   color: undefined,
            // },
            check: {
                radius: '100%'
            },
            // color: undefined,
            hover: {
                // background: {
                //   color: undefined,
                // },
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            gap: 'small',
            size: baseSpacing + "px",
            font: {
            },
            container: {
            }
        },
        radioButtonGroup: {
            // any box props
            container: {
                gap: 'small'
            }
        },
        rangeInput: {
            disabled: {
                opacity: 0.3
            },
            // extend: undefined
            track: {
                height: '4px',
                color: 'border'
            },
            thumb: {
            }
        },
        rangeSelector: {
            background: {
                invert: {
                    color: 'light-4'
                }
            },
            edge: {
            },
            label: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        select: {
            // background: undefined,
            clear: {
                container: {
                    pad: 'small',
                    background: 'background-contrast'
                },
                // any box props
                text: {
                    color: 'text-weak'
                } // any text props
            },
            container: {
            },
            control: {
            },
            // emptySearchMessage: {
            //   container: {}, // any box props
            //   text: {}, // any text props
            // },
            icons: {
                // color: { dark: undefined, light: undefined },
                margin: {
                    horizontal: 'small'
                },
                down: (0, $8OmD4.FormDown)
            },
            // listbox: {
            //   extend: undefined,
            // },
            options: {
                container: {
                    align: 'start',
                    pad: 'small'
                },
                text: {
                    margin: 'none'
                }
            },
            search: {
                pad: 'xsmall'
            },
            // searchInput: undefined,
            step: 20
        },
        selectMultiple: {
            help: {
                container: {
                    pad: 'xsmall'
                }
            },
            maxInline: 5,
            // listbox: {
            //   extend: () => undefined,
            // },
            option: {
                pad: 'xsmall'
            },
            search: {
                pad: 'xsmall'
            },
            showMore: {
                pad: {
                    horizontal: 'small',
                    bottom: 'small',
                    top: 'xsmall'
                }
            },
            summary: {
                gap: 'small',
                height: {
                    min: 'xxsmall'
                },
                pad: 'xsmall',
                showSelectedInline: {
                    pad: {
                        left: 'xsmall',
                        vertical: 'xsmall'
                    }
                }
            }
        },
        sidebar: {
            gap: 'large',
            pad: 'small'
        },
        skeleton: {
            border: false,
            colors: {
                dark: [
                    'background',
                    'background-front'
                ],
                light: [
                    'background',
                    'background-back'
                ]
            }
        },
        skipLinks: {
            position: 'top',
            container: {
                elevation: 'large',
                round: 'small',
                pad: 'medium'
            },
            label: {
                margin: {
                    bottom: 'medium'
                },
                size: 'medium'
            }
        },
        starRating: {
        },
        tab: {
            active: {
                color: 'text'
            },
            // background: undefined,
            border: {
                side: 'bottom',
                size: 'small',
                color: {
                    dark: 'accent-1',
                    light: 'brand'
                },
                active: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                },
                disabled: {
                },
                hover: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            color: 'control',
            // disabled: {
            //   color: undefined,
            // },
            // extend: undefined,
            gap: 'small',
            hover: {
                // background: undefined,
                // extend: undefined,
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            margin: {
                vertical: 'xxsmall',
                horizontal: 'small'
            },
            pad: {
                bottom: 'xsmall'
            }
        },
        tabs: {
            // background: undefined,
            // extend: undefined,
            // gap: undefined,
            header: {
                // alignSelf: undefined,
                // background: undefined,
                // border: {
                //   side: undefined,
                //   size: undefined,
                //   style: undefined,
                //   color: undefined,
                // },
                // extend: undefined,
                nextButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                },
                previousButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            panel: {
            },
            step: {
                small: 1,
                medium: 3,
                large: 3
            }
        },
        stepper: {
            indicator: {
                size: 'medium',
                // 'small' | 'medium' | 'large'
                border: {
                    width: '2px'
                }
            },
            label: {
                size: 'medium',
                substep: {
                    size: 'small'
                }
            },
            connector: {
                stroke: {
                    width: 'small'
                }
            },
            description: {
                size: 'small',
                color: 'text-weak'
            },
            helperText: {
                size: 'xsmall',
                color: 'text-weak'
            },
            button: {
                pad: 'xxsmall'
            },
            horizontal: {
                connector: {
                    margin: 'xxsmall'
                },
                button: {
                    gap: 'xsmall'
                }
            },
            vertical: {
                button: {
                    gap: 'small'
                }
            },
            // States: [component].[state].[element].[property]
            pending: {
                indicator: {
                    background: 'background-front',
                    color: 'text-strong',
                    border: 'text-xweak',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front',
                        border: 'text-strong'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'border'
                }
            },
            current: {
                indicator: {
                    icon: (0, $5lYUK.StatusGoodSmall),
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            currentCompleted: {
                indicator: {
                    icon: (0, $emMxY.FormCheckmark),
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            completed: {
                indicator: {
                    icon: (0, $emMxY.FormCheckmark),
                    iconSize: 'medium',
                    background: 'background-front',
                    color: 'brand',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'brand'
                }
            },
            error: {
                indicator: {
                    icon: (0, $7euNT.StatusCriticalSmall),
                    background: 'background-front',
                    color: 'status-critical',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'status-critical'
                },
                helperText: {
                    color: 'status-critical'
                }
            },
            currentError: {
                indicator: {
                    icon: (0, $7euNT.StatusCriticalSmall),
                    background: 'status-critical',
                    color: 'white',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: 'status-critical'
                }
            },
            disabled: {
                indicator: {
                    background: 'background-contrast',
                    color: 'text-weak',
                    border: 'border',
                    substep: {
                        iconSize: 'small'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'border'
                }
            }
        },
        table: {
            caption: {
                margin: {
                    bottom: 'xxsmall'
                }
            },
            header: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'bottom'
            },
            body: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                }
            },
            // row: {
            //   hover: {
            //     background: undefined,
            //     color: undefined,
            //   },
            // },
            footer: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'top'
            }
        },
        tag: {
            // background: undefined,
            border: true,
            // hover: {
            //   background: undefined,
            //   border: undefined,
            // },
            round: 'large',
            // name: undefined,
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            },
            remove: {
                margin: {
                    right: 'xsmall'
                }
            },
            separator: ' : ',
            size: {
                xsmall: {
                    pad: {
                        horizontal: baseSpacing / 3 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                small: {
                    pad: {
                        horizontal: baseSpacing * 0.4 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                large: {
                    pad: {
                        horizontal: baseSpacing / 3 * 2 + "px",
                        vertical: "xsmall"
                    },
                    icon: {
                        size: baseSpacing * 1.25 + "px"
                    }
                },
                xlarge: {
                    pad: {
                        horizontal: baseSpacing * 0.75 + "px",
                        vertical: 'xsmall'
                    },
                    icon: {
                        size: baseSpacing * 1.5 + "px"
                    }
                }
            },
            value: {
                weight: 600
            },
            icons: {
                remove: (0, $gpz6W.FormClose)
            }
        },
        text: {
            font: {
            },
            xsmall: $07ab289dafa0c866$var$_extends({}, fontSizing(-1.5)),
            small: $07ab289dafa0c866$var$_extends({}, fontSizing(-1)),
            medium: $07ab289dafa0c866$var$_extends({}, fontSizing(0)),
            // 18px
            large: $07ab289dafa0c866$var$_extends({}, fontSizing(1)),
            // 22px
            xlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(2)),
            xxlarge: $07ab289dafa0c866$var$_extends({}, fontSizing(4)),
            '2xl': $07ab289dafa0c866$var$_extends({}, fontSizing(4)),
            '3xl': $07ab289dafa0c866$var$_extends({}, fontSizing(6)),
            '4xl': $07ab289dafa0c866$var$_extends({}, fontSizing(9)),
            '5xl': $07ab289dafa0c866$var$_extends({}, fontSizing(13)),
            '6xl': $07ab289dafa0c866$var$_extends({}, fontSizing(18)),
            skeleton: {
                width: {
                    width: '100px',
                    min: '100px'
                },
                margin: {
                    vertical: 'xsmall'
                },
                colors: {
                    dark: [
                        'border',
                        'border'
                    ],
                    light: [
                        'background-front',
                        'background-back'
                    ]
                }
            }
        },
        textArea: {
        },
        textInput: {
            // extend: undefined,
            // disabled: { opacity: undefined },
            icons: {
                // copy: undefined,
                hidePassword: (0, $iDbKq.Hide),
                showPassword: (0, $irJMV.View)
            }
        },
        timeInput: {
            button: {
                margin: {
                    right: 'small'
                }
            },
            container: {
                round: 'xxsmall'
            },
            active: {
                background: 'active-background',
                pad: 'xxsmall',
                indicator: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    },
                    size: 'small'
                }
            },
            drop: {
                // gap: undefined,
                option: {
                    // background: undefined,
                    // gap: undefined,
                    // size: undefined,
                    pad: {
                        vertical: 'xxsmall',
                        horizontal: 'xsmall'
                    },
                    // round: undefined,
                    hover: {
                        background: 'active-background'
                    },
                    selected: {
                        background: 'selected',
                        color: 'white',
                        text: {
                            weight: 500
                        },
                        hover: {
                        }
                    }
                }
            },
            icon: {
            }
        },
        tip: {
            content: {
                // any Box props
                background: 'background-contrast',
                elevation: 'small',
                margin: 'xsmall',
                pad: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                },
                round: 'small'
            },
            drop: {
                // any props for the drop
                align: {
                    top: 'bottom'
                },
                // most common use case is Header with Buttons
                background: 'none',
                elevation: 'none',
                margin: 'none'
            }
        },
        toggleGroup: {
            button: {
                // border: {
                //   radius: undefined,
                // }
                // iconOnly: {
                //   pad: undefined,
                // },
                // kind: undefined,
                pad: {
                    horizontal: '11px',
                    vertical: '11px'
                }
            },
            container: {
                round: 'xsmall',
                border: true
            },
            divider: {
                color: 'border'
            }
        },
        toolbar: {
            small: {
                gap: 'small'
            },
            gap: 'small'
        },
        video: {
            captions: {
                background: 'rgba(0, 0, 0, 0.7)'
            },
            // controls: { background: undefined },
            icons: {
                closedCaption: (0, $9B1ut.ClosedCaption),
                configure: (0, $eHBma.Actions),
                fullScreen: (0, $7aiQi.Expand),
                pause: (0, $4wHe0.Pause),
                play: (0, $52RYE.Play),
                reduceVolume: (0, $lwtww.VolumeLow),
                volume: (0, $K1r2I.Volume),
                description: (0, $jta6y.AssistListening)
            },
            scrubber: {
                color: 'light-4',
                interval: 10,
                // track: { color: undefined }
                thickness: 'small'
            },
            time: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            }
        },
        wizard: {
            container: {
                gap: 'none',
                background: 'background-back'
            },
            body: {
                pad: {
                    horizontal: 'large',
                    vertical: 'large'
                },
                gap: {
                    row: 'none',
                    column: 'medium'
                }
            },
            header: {
                pad: {
                    horizontal: 'large',
                    vertical: 'small'
                },
                background: 'background-front',
                title: {
                    size: 'small'
                },
                close: {
                    icon: (0, $gpz6W.FormClose)
                }
            },
            progress: {
                horizontal: {
                    pad: {
                        horizontal: 'none',
                        vertical: 'none'
                    }
                },
                vertical: {
                    // Fixed rail width so the column doesn't collapse to label text.
                    width: 'small'
                }
            },
            stepHeader: {
                pad: {
                    horizontal: 'none',
                    vertical: 'none'
                },
                counter: {
                    size: 'small',
                    color: 'text'
                },
                title: {
                    size: 'large',
                    margin: 'none'
                },
                description: {
                    size: 'medium',
                    color: 'text-weak',
                    margin: {
                        top: 'xsmall',
                        bottom: 'none'
                    }
                }
            },
            content: {
                pad: 'medium',
                gap: 'medium',
                background: 'background-front',
                round: 'small',
                margin: {
                    top: 'medium'
                }
            },
            footer: {
                pad: {
                    horizontal: 'large',
                    vertical: 'small'
                },
                gap: {
                    row: 'xsmall',
                    column: 'small'
                },
                background: 'background-front',
                justify: 'end',
                button: {
                    next: {
                        icon: (0, $hwSTn.FormNext)
                    },
                    complete: {
                        icon: undefined
                    },
                    previous: {
                        icon: (0, $6Xlgn.FormPrevious)
                    },
                    cancel: {
                        icon: undefined
                    },
                    skip: {
                        icon: (0, $hwSTn.FormNext)
                    }
                }
            }
        },
        worldMap: {
            color: 'light-3',
            continent: {
                active: '8px',
                base: '6px'
            },
            hover: {
                color: 'light-4'
            },
            place: {
                active: '20px',
                base: '8px'
            }
        }
    });
    return (0, $7rlLx.deepFreeze)(result);
};
var $07ab289dafa0c866$export$e2253033e6e1df16 = $07ab289dafa0c866$export$80d376111cc09ad7(24);

});
parcelRegister("eHBma", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $ab420f14357919ad$export$b52183d5cfb26dc9, (v) => $ab420f14357919ad$export$b52183d5cfb26dc9 = v);
var $ab420f14357919ad$export$1e511d4a378977f5;
var $ab420f14357919ad$export$b52183d5cfb26dc9;
"use strict";
$ab420f14357919ad$export$1e511d4a378977f5 = true;
$ab420f14357919ad$export$b52183d5cfb26dc9 = void 0;

var $ab420f14357919ad$var$_react = $ab420f14357919ad$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $ab420f14357919ad$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ab420f14357919ad$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $ab420f14357919ad$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $ab420f14357919ad$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $ab420f14357919ad$var$_extends() {
    return $ab420f14357919ad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ab420f14357919ad$var$_extends.apply(null, arguments);
}
var $ab420f14357919ad$var$Actions = $ab420f14357919ad$export$b52183d5cfb26dc9 = /*#__PURE__*/ (0, $ab420f14357919ad$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $ab420f14357919ad$var$_react["default"].createElement($xazbe.StyledIcon, $ab420f14357919ad$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Actions"
    }, props), /*#__PURE__*/ $ab420f14357919ad$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0-11V1m0 22v-5.5M1 12h5.5m11 0H23M4.437 4.437l4.125 4.125m6.876 6.876 4.124 4.124m0-15.125-4.125 4.125m-6.874 6.876-4.126 4.124"
    }));
});
$ab420f14357919ad$var$Actions.displayName = 'Actions';

});

parcelRegister("jta6y", function(module, exports) {

$parcel$export(module.exports, "AssistListening", () => $e2c8905acb448ca4$export$c92b43e49fa6c65b, (v) => $e2c8905acb448ca4$export$c92b43e49fa6c65b = v);
var $e2c8905acb448ca4$export$1e511d4a378977f5;
var $e2c8905acb448ca4$export$c92b43e49fa6c65b;
"use strict";
$e2c8905acb448ca4$export$1e511d4a378977f5 = true;
$e2c8905acb448ca4$export$c92b43e49fa6c65b = void 0;

var $e2c8905acb448ca4$var$_react = $e2c8905acb448ca4$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $e2c8905acb448ca4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e2c8905acb448ca4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $e2c8905acb448ca4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $e2c8905acb448ca4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $e2c8905acb448ca4$var$_extends() {
    return $e2c8905acb448ca4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e2c8905acb448ca4$var$_extends.apply(null, arguments);
}
var $e2c8905acb448ca4$var$AssistListening = $e2c8905acb448ca4$export$c92b43e49fa6c65b = /*#__PURE__*/ (0, $e2c8905acb448ca4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $e2c8905acb448ca4$var$_react["default"].createElement($xazbe.StyledIcon, $e2c8905acb448ca4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AssistListening"
    }, props), /*#__PURE__*/ $e2c8905acb448ca4$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M11 21c.757.667 1.424 1 2 1 2 0 3-1 3-3 0-1.333.667-2.667 2-4 1.267-1.267 2-3.067 2-5a7 7 0 0 0-14 0m11 0a4 4 0 1 0-8 0M3 20l5-6 1 4 5-6"
    }));
});
$e2c8905acb448ca4$var$AssistListening.displayName = 'AssistListening';

});

parcelRegister("h8SsP", function(module, exports) {

$parcel$export(module.exports, "CircleInformation", () => $c7ad6e714cbd362f$export$7036cd8426a1245b, (v) => $c7ad6e714cbd362f$export$7036cd8426a1245b = v);
var $c7ad6e714cbd362f$export$1e511d4a378977f5;
var $c7ad6e714cbd362f$export$7036cd8426a1245b;
"use strict";
$c7ad6e714cbd362f$export$1e511d4a378977f5 = true;
$c7ad6e714cbd362f$export$7036cd8426a1245b = void 0;

var $c7ad6e714cbd362f$var$_react = $c7ad6e714cbd362f$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $c7ad6e714cbd362f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c7ad6e714cbd362f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $c7ad6e714cbd362f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $c7ad6e714cbd362f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $c7ad6e714cbd362f$var$_extends() {
    return $c7ad6e714cbd362f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c7ad6e714cbd362f$var$_extends.apply(null, arguments);
}
var $c7ad6e714cbd362f$var$CircleInformation = $c7ad6e714cbd362f$export$7036cd8426a1245b = /*#__PURE__*/ (0, $c7ad6e714cbd362f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $c7ad6e714cbd362f$var$_react["default"].createElement($xazbe.StyledIcon, $c7ad6e714cbd362f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleInformation"
    }, props), /*#__PURE__*/ $c7ad6e714cbd362f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-12v8m0-12v2"
    }));
});
$c7ad6e714cbd362f$var$CircleInformation.displayName = 'CircleInformation';

});

parcelRegister("9B1ut", function(module, exports) {

$parcel$export(module.exports, "ClosedCaption", () => $6fc8b9bb2af43fd0$export$237eddafb41f13f6, (v) => $6fc8b9bb2af43fd0$export$237eddafb41f13f6 = v);
var $6fc8b9bb2af43fd0$export$1e511d4a378977f5;
var $6fc8b9bb2af43fd0$export$237eddafb41f13f6;
"use strict";
$6fc8b9bb2af43fd0$export$1e511d4a378977f5 = true;
$6fc8b9bb2af43fd0$export$237eddafb41f13f6 = void 0;

var $6fc8b9bb2af43fd0$var$_react = $6fc8b9bb2af43fd0$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $6fc8b9bb2af43fd0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6fc8b9bb2af43fd0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6fc8b9bb2af43fd0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6fc8b9bb2af43fd0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6fc8b9bb2af43fd0$var$_extends() {
    return $6fc8b9bb2af43fd0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6fc8b9bb2af43fd0$var$_extends.apply(null, arguments);
}
var $6fc8b9bb2af43fd0$var$ClosedCaption = $6fc8b9bb2af43fd0$export$237eddafb41f13f6 = /*#__PURE__*/ (0, $6fc8b9bb2af43fd0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $6fc8b9bb2af43fd0$var$_react["default"].createElement($xazbe.StyledIcon, $6fc8b9bb2af43fd0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ClosedCaption"
    }, props), /*#__PURE__*/ $6fc8b9bb2af43fd0$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 12c0-7 1.5-8 11-8s11 1 11 8-1.5 8-11 8-11-1-11-8zm4.25 2c0 1.5.75 2 2.5 2s2.5-.5 2.5-2h-.271c0 1.25-1 2-2.229 2-1.23 0-2.229-.75-2.229-2v-4C5.5 8.75 6.5 8 7.75 8s2.25.75 2.229 2h.271c0-1.25-1.021-2-2.5-2s-2.5.75-2.5 2v4zm8 0c0 1.5.75 2 2.5 2s2.5-.5 2.5-2h-.271c0 1.25-1 2-2.229 2-1.23 0-2.229-.75-2.229-2v-4c-.021-1.25.979-2 2.229-2s2.25.75 2.229 2h.271c0-1.25-1.021-2-2.5-2s-2.5.75-2.5 2v4z"
    }));
});
$6fc8b9bb2af43fd0$var$ClosedCaption.displayName = 'ClosedCaption';

});

parcelRegister("7aiQi", function(module, exports) {

$parcel$export(module.exports, "Expand", () => $53781549b6e8816d$export$49bd1dfb0ad29c40, (v) => $53781549b6e8816d$export$49bd1dfb0ad29c40 = v);
var $53781549b6e8816d$export$1e511d4a378977f5;
var $53781549b6e8816d$export$49bd1dfb0ad29c40;
"use strict";
$53781549b6e8816d$export$1e511d4a378977f5 = true;
$53781549b6e8816d$export$49bd1dfb0ad29c40 = void 0;

var $53781549b6e8816d$var$_react = $53781549b6e8816d$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $53781549b6e8816d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($53781549b6e8816d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $53781549b6e8816d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $53781549b6e8816d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $53781549b6e8816d$var$_extends() {
    return $53781549b6e8816d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $53781549b6e8816d$var$_extends.apply(null, arguments);
}
var $53781549b6e8816d$var$Expand = $53781549b6e8816d$export$49bd1dfb0ad29c40 = /*#__PURE__*/ (0, $53781549b6e8816d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $53781549b6e8816d$var$_react["default"].createElement($xazbe.StyledIcon, $53781549b6e8816d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Expand"
    }, props), /*#__PURE__*/ $53781549b6e8816d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m10 14-8 8m-1-7v8h8M22 2l-8 8m1-9h8v8"
    }));
});
$53781549b6e8816d$var$Expand.displayName = 'Expand';

});

parcelRegister("emMxY", function(module, exports) {

$parcel$export(module.exports, "FormCheckmark", () => $a758c731515e0dd3$export$dec84e69d20720b4, (v) => $a758c731515e0dd3$export$dec84e69d20720b4 = v);
var $a758c731515e0dd3$export$1e511d4a378977f5;
var $a758c731515e0dd3$export$dec84e69d20720b4;
"use strict";
$a758c731515e0dd3$export$1e511d4a378977f5 = true;
$a758c731515e0dd3$export$dec84e69d20720b4 = void 0;

var $a758c731515e0dd3$var$_react = $a758c731515e0dd3$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $a758c731515e0dd3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a758c731515e0dd3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a758c731515e0dd3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a758c731515e0dd3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a758c731515e0dd3$var$_extends() {
    return $a758c731515e0dd3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a758c731515e0dd3$var$_extends.apply(null, arguments);
}
var $a758c731515e0dd3$var$FormCheckmark = $a758c731515e0dd3$export$dec84e69d20720b4 = /*#__PURE__*/ (0, $a758c731515e0dd3$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a758c731515e0dd3$var$_react["default"].createElement($xazbe.StyledIcon, $a758c731515e0dd3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormCheckmark"
    }, props), /*#__PURE__*/ $a758c731515e0dd3$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m6 13 4.2 3.6L18 7"
    }));
});
$a758c731515e0dd3$var$FormCheckmark.displayName = 'FormCheckmark';

});

parcelRegister("8OmD4", function(module, exports) {

$parcel$export(module.exports, "FormDown", () => $66a48be60e400cd9$export$cd1a8f5a55d5e9d3, (v) => $66a48be60e400cd9$export$cd1a8f5a55d5e9d3 = v);
var $66a48be60e400cd9$export$1e511d4a378977f5;
var $66a48be60e400cd9$export$cd1a8f5a55d5e9d3;
"use strict";
$66a48be60e400cd9$export$1e511d4a378977f5 = true;
$66a48be60e400cd9$export$cd1a8f5a55d5e9d3 = void 0;

var $66a48be60e400cd9$var$_react = $66a48be60e400cd9$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $66a48be60e400cd9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($66a48be60e400cd9$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $66a48be60e400cd9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $66a48be60e400cd9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $66a48be60e400cd9$var$_extends() {
    return $66a48be60e400cd9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $66a48be60e400cd9$var$_extends.apply(null, arguments);
}
var $66a48be60e400cd9$var$FormDown = $66a48be60e400cd9$export$cd1a8f5a55d5e9d3 = /*#__PURE__*/ (0, $66a48be60e400cd9$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $66a48be60e400cd9$var$_react["default"].createElement($xazbe.StyledIcon, $66a48be60e400cd9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormDown"
    }, props), /*#__PURE__*/ $66a48be60e400cd9$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 9-6 6-6-6"
    }));
});
$66a48be60e400cd9$var$FormDown.displayName = 'FormDown';

});

parcelRegister("hwSTn", function(module, exports) {

$parcel$export(module.exports, "FormNext", () => $cc300148e3f25534$export$a8d2f61b02c7b95f, (v) => $cc300148e3f25534$export$a8d2f61b02c7b95f = v);
var $cc300148e3f25534$export$1e511d4a378977f5;
var $cc300148e3f25534$export$a8d2f61b02c7b95f;
"use strict";
$cc300148e3f25534$export$1e511d4a378977f5 = true;
$cc300148e3f25534$export$a8d2f61b02c7b95f = void 0;

var $cc300148e3f25534$var$_react = $cc300148e3f25534$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $cc300148e3f25534$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cc300148e3f25534$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cc300148e3f25534$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $cc300148e3f25534$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cc300148e3f25534$var$_extends() {
    return $cc300148e3f25534$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cc300148e3f25534$var$_extends.apply(null, arguments);
}
var $cc300148e3f25534$var$FormNext = $cc300148e3f25534$export$a8d2f61b02c7b95f = /*#__PURE__*/ (0, $cc300148e3f25534$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $cc300148e3f25534$var$_react["default"].createElement($xazbe.StyledIcon, $cc300148e3f25534$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNext"
    }, props), /*#__PURE__*/ $cc300148e3f25534$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 6 6 6-6 6"
    }));
});
$cc300148e3f25534$var$FormNext.displayName = 'FormNext';

});

parcelRegister("6Xlgn", function(module, exports) {

$parcel$export(module.exports, "FormPrevious", () => $5108bf286d63e439$export$a14ca6bc44f029a6, (v) => $5108bf286d63e439$export$a14ca6bc44f029a6 = v);
var $5108bf286d63e439$export$1e511d4a378977f5;
var $5108bf286d63e439$export$a14ca6bc44f029a6;
"use strict";
$5108bf286d63e439$export$1e511d4a378977f5 = true;
$5108bf286d63e439$export$a14ca6bc44f029a6 = void 0;

var $5108bf286d63e439$var$_react = $5108bf286d63e439$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $5108bf286d63e439$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5108bf286d63e439$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5108bf286d63e439$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5108bf286d63e439$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5108bf286d63e439$var$_extends() {
    return $5108bf286d63e439$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5108bf286d63e439$var$_extends.apply(null, arguments);
}
var $5108bf286d63e439$var$FormPrevious = $5108bf286d63e439$export$a14ca6bc44f029a6 = /*#__PURE__*/ (0, $5108bf286d63e439$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5108bf286d63e439$var$_react["default"].createElement($xazbe.StyledIcon, $5108bf286d63e439$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPrevious"
    }, props), /*#__PURE__*/ $5108bf286d63e439$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 6-6 6 6 6"
    }));
});
$5108bf286d63e439$var$FormPrevious.displayName = 'FormPrevious';

});

parcelRegister("l4F8H", function(module, exports) {

$parcel$export(module.exports, "FormUp", () => $f579e2160034a7df$export$7dd0724a362def6d, (v) => $f579e2160034a7df$export$7dd0724a362def6d = v);
var $f579e2160034a7df$export$1e511d4a378977f5;
var $f579e2160034a7df$export$7dd0724a362def6d;
"use strict";
$f579e2160034a7df$export$1e511d4a378977f5 = true;
$f579e2160034a7df$export$7dd0724a362def6d = void 0;

var $f579e2160034a7df$var$_react = $f579e2160034a7df$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $f579e2160034a7df$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f579e2160034a7df$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f579e2160034a7df$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f579e2160034a7df$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f579e2160034a7df$var$_extends() {
    return $f579e2160034a7df$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f579e2160034a7df$var$_extends.apply(null, arguments);
}
var $f579e2160034a7df$var$FormUp = $f579e2160034a7df$export$7dd0724a362def6d = /*#__PURE__*/ (0, $f579e2160034a7df$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f579e2160034a7df$var$_react["default"].createElement($xazbe.StyledIcon, $f579e2160034a7df$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormUp"
    }, props), /*#__PURE__*/ $f579e2160034a7df$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 15-6-6-6 6"
    }));
});
$f579e2160034a7df$var$FormUp.displayName = 'FormUp';

});

parcelRegister("9AmjO", function(module, exports) {

$parcel$export(module.exports, "Next", () => $6fa8c9d969f8a30b$export$b820fc49f2736e85, (v) => $6fa8c9d969f8a30b$export$b820fc49f2736e85 = v);
var $6fa8c9d969f8a30b$export$1e511d4a378977f5;
var $6fa8c9d969f8a30b$export$b820fc49f2736e85;
"use strict";
$6fa8c9d969f8a30b$export$1e511d4a378977f5 = true;
$6fa8c9d969f8a30b$export$b820fc49f2736e85 = void 0;

var $6fa8c9d969f8a30b$var$_react = $6fa8c9d969f8a30b$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");

var $jvU3m = parcelRequire("jvU3m");
function $6fa8c9d969f8a30b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6fa8c9d969f8a30b$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $6fa8c9d969f8a30b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $6fa8c9d969f8a30b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $6fa8c9d969f8a30b$var$_extends() {
    return $6fa8c9d969f8a30b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6fa8c9d969f8a30b$var$_extends.apply(null, arguments);
}
var $6fa8c9d969f8a30b$var$Next = $6fa8c9d969f8a30b$export$b820fc49f2736e85 = /*#__PURE__*/ (0, $6fa8c9d969f8a30b$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $jvU3m.useScaleProps)(props);
    return /*#__PURE__*/ $6fa8c9d969f8a30b$var$_react["default"].createElement($xazbe.StyledIcon, $6fa8c9d969f8a30b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Next"
    }, props), /*#__PURE__*/ $6fa8c9d969f8a30b$var$_react["default"].createElement("path", $6fa8c9d969f8a30b$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 2 10 10L7 22"
    }, scaleProps)));
});
$6fa8c9d969f8a30b$var$Next.displayName = 'Next';

});

parcelRegister("4wHe0", function(module, exports) {

$parcel$export(module.exports, "Pause", () => $34bbae21b6ebc958$export$59704c468e1a1527, (v) => $34bbae21b6ebc958$export$59704c468e1a1527 = v);
var $34bbae21b6ebc958$export$1e511d4a378977f5;
var $34bbae21b6ebc958$export$59704c468e1a1527;
"use strict";
$34bbae21b6ebc958$export$1e511d4a378977f5 = true;
$34bbae21b6ebc958$export$59704c468e1a1527 = void 0;

var $34bbae21b6ebc958$var$_react = $34bbae21b6ebc958$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $34bbae21b6ebc958$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($34bbae21b6ebc958$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $34bbae21b6ebc958$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $34bbae21b6ebc958$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $34bbae21b6ebc958$var$_extends() {
    return $34bbae21b6ebc958$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $34bbae21b6ebc958$var$_extends.apply(null, arguments);
}
var $34bbae21b6ebc958$var$Pause = $34bbae21b6ebc958$export$59704c468e1a1527 = /*#__PURE__*/ (0, $34bbae21b6ebc958$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $34bbae21b6ebc958$var$_react["default"].createElement($xazbe.StyledIcon, $34bbae21b6ebc958$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pause"
    }, props), /*#__PURE__*/ $34bbae21b6ebc958$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 21h6V3H3v18zm12 0h6V3h-6v18z"
    }));
});
$34bbae21b6ebc958$var$Pause.displayName = 'Pause';

});

parcelRegister("52RYE", function(module, exports) {

$parcel$export(module.exports, "Play", () => $3ac70268b072d1db$export$480db61f4dcd7727, (v) => $3ac70268b072d1db$export$480db61f4dcd7727 = v);
var $3ac70268b072d1db$export$1e511d4a378977f5;
var $3ac70268b072d1db$export$480db61f4dcd7727;
"use strict";
$3ac70268b072d1db$export$1e511d4a378977f5 = true;
$3ac70268b072d1db$export$480db61f4dcd7727 = void 0;

var $3ac70268b072d1db$var$_react = $3ac70268b072d1db$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $3ac70268b072d1db$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3ac70268b072d1db$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3ac70268b072d1db$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3ac70268b072d1db$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3ac70268b072d1db$var$_extends() {
    return $3ac70268b072d1db$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3ac70268b072d1db$var$_extends.apply(null, arguments);
}
var $3ac70268b072d1db$var$Play = $3ac70268b072d1db$export$480db61f4dcd7727 = /*#__PURE__*/ (0, $3ac70268b072d1db$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3ac70268b072d1db$var$_react["default"].createElement($xazbe.StyledIcon, $3ac70268b072d1db$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Play"
    }, props), /*#__PURE__*/ $3ac70268b072d1db$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 22 18-10L3 2z"
    }));
});
$3ac70268b072d1db$var$Play.displayName = 'Play';

});

parcelRegister("9HTuS", function(module, exports) {

$parcel$export(module.exports, "FormPin", () => $71132dc2a128ecab$export$5423378d28f4447c, (v) => $71132dc2a128ecab$export$5423378d28f4447c = v);
var $71132dc2a128ecab$export$1e511d4a378977f5;
var $71132dc2a128ecab$export$5423378d28f4447c;
"use strict";
$71132dc2a128ecab$export$1e511d4a378977f5 = true;
$71132dc2a128ecab$export$5423378d28f4447c = void 0;

var $71132dc2a128ecab$var$_react = $71132dc2a128ecab$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $71132dc2a128ecab$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($71132dc2a128ecab$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $71132dc2a128ecab$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $71132dc2a128ecab$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $71132dc2a128ecab$var$_extends() {
    return $71132dc2a128ecab$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $71132dc2a128ecab$var$_extends.apply(null, arguments);
}
var $71132dc2a128ecab$var$FormPin = $71132dc2a128ecab$export$5423378d28f4447c = /*#__PURE__*/ (0, $71132dc2a128ecab$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $71132dc2a128ecab$var$_react["default"].createElement($xazbe.StyledIcon, $71132dc2a128ecab$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPin"
    }, props), /*#__PURE__*/ $71132dc2a128ecab$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m4 19 4.455-4.454M12.273 5 18 10.727m-4.454-4.454L9.727 10.09s-2.545-.636-4.454 1.273l6.363 6.363c1.91-1.909 1.273-4.454 1.273-4.454l3.818-3.818-3.181-3.182Z"
    }));
});
$71132dc2a128ecab$var$FormPin.displayName = 'FormPin';

});

parcelRegister("b0HeC", function(module, exports) {

$parcel$export(module.exports, "Previous", () => $80413b53f580bbb3$export$a499fb457891d86e, (v) => $80413b53f580bbb3$export$a499fb457891d86e = v);
var $80413b53f580bbb3$export$1e511d4a378977f5;
var $80413b53f580bbb3$export$a499fb457891d86e;
"use strict";
$80413b53f580bbb3$export$1e511d4a378977f5 = true;
$80413b53f580bbb3$export$a499fb457891d86e = void 0;

var $80413b53f580bbb3$var$_react = $80413b53f580bbb3$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");

var $jvU3m = parcelRequire("jvU3m");
function $80413b53f580bbb3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($80413b53f580bbb3$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $80413b53f580bbb3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $80413b53f580bbb3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $80413b53f580bbb3$var$_extends() {
    return $80413b53f580bbb3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $80413b53f580bbb3$var$_extends.apply(null, arguments);
}
var $80413b53f580bbb3$var$Previous = $80413b53f580bbb3$export$a499fb457891d86e = /*#__PURE__*/ (0, $80413b53f580bbb3$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $jvU3m.useScaleProps)(props);
    return /*#__PURE__*/ $80413b53f580bbb3$var$_react["default"].createElement($xazbe.StyledIcon, $80413b53f580bbb3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Previous"
    }, props), /*#__PURE__*/ $80413b53f580bbb3$var$_react["default"].createElement("path", $80413b53f580bbb3$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 2 7 12l10 10"
    }, scaleProps)));
});
$80413b53f580bbb3$var$Previous.displayName = 'Previous';

});

parcelRegister("iDbKq", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $d904fb61576911e6$export$bed28288a051538, (v) => $d904fb61576911e6$export$bed28288a051538 = v);
var $d904fb61576911e6$export$1e511d4a378977f5;
var $d904fb61576911e6$export$bed28288a051538;
"use strict";
$d904fb61576911e6$export$1e511d4a378977f5 = true;
$d904fb61576911e6$export$bed28288a051538 = void 0;

var $d904fb61576911e6$var$_react = $d904fb61576911e6$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $d904fb61576911e6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d904fb61576911e6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d904fb61576911e6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d904fb61576911e6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d904fb61576911e6$var$_extends() {
    return $d904fb61576911e6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d904fb61576911e6$var$_extends.apply(null, arguments);
}
var $d904fb61576911e6$var$Hide = $d904fb61576911e6$export$bed28288a051538 = /*#__PURE__*/ (0, $d904fb61576911e6$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d904fb61576911e6$var$_react["default"].createElement($xazbe.StyledIcon, $d904fb61576911e6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hide"
    }, props), /*#__PURE__*/ $d904fb61576911e6$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17c-2.727 0-6-2.778-6-5s3.273-5 6-5 6 2.778 6 5-3.273 5-6 5zm-1-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm9-7L4 19"
    }));
});
$d904fb61576911e6$var$Hide.displayName = 'Hide';

});

parcelRegister("7euNT", function(module, exports) {

$parcel$export(module.exports, "StatusCriticalSmall", () => $5441bc2b0b75d840$export$32f199c975b240fb, (v) => $5441bc2b0b75d840$export$32f199c975b240fb = v);
var $5441bc2b0b75d840$export$1e511d4a378977f5;
var $5441bc2b0b75d840$export$32f199c975b240fb;
"use strict";
$5441bc2b0b75d840$export$1e511d4a378977f5 = true;
$5441bc2b0b75d840$export$32f199c975b240fb = void 0;

var $5441bc2b0b75d840$var$_react = $5441bc2b0b75d840$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $5441bc2b0b75d840$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5441bc2b0b75d840$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5441bc2b0b75d840$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $5441bc2b0b75d840$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $5441bc2b0b75d840$var$_extends() {
    return $5441bc2b0b75d840$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5441bc2b0b75d840$var$_extends.apply(null, arguments);
}
var $5441bc2b0b75d840$var$StatusCriticalSmall = $5441bc2b0b75d840$export$32f199c975b240fb = /*#__PURE__*/ (0, $5441bc2b0b75d840$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $5441bc2b0b75d840$var$_react["default"].createElement($xazbe.StyledIcon, $5441bc2b0b75d840$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is critical"
    }, props), /*#__PURE__*/ $5441bc2b0b75d840$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        d: "M6.712 1.263a1.005 1.005 0 0 0-1.424 0L1.263 5.288a1.005 1.005 0 0 0 0 1.424l4.025 4.025a1.005 1.005 0 0 0 1.424 0l4.025-4.025a1.005 1.005 0 0 0 0-1.424L6.712 1.263z"
    }));
});
$5441bc2b0b75d840$var$StatusCriticalSmall.displayName = 'StatusCriticalSmall';

});

parcelRegister("5lYUK", function(module, exports) {

$parcel$export(module.exports, "StatusGoodSmall", () => $3e5e2a34e92480f0$export$a09254dff7a942de, (v) => $3e5e2a34e92480f0$export$a09254dff7a942de = v);
var $3e5e2a34e92480f0$export$1e511d4a378977f5;
var $3e5e2a34e92480f0$export$a09254dff7a942de;
"use strict";
$3e5e2a34e92480f0$export$1e511d4a378977f5 = true;
$3e5e2a34e92480f0$export$a09254dff7a942de = void 0;

var $3e5e2a34e92480f0$var$_react = $3e5e2a34e92480f0$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $3e5e2a34e92480f0$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3e5e2a34e92480f0$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3e5e2a34e92480f0$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $3e5e2a34e92480f0$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3e5e2a34e92480f0$var$_extends() {
    return $3e5e2a34e92480f0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3e5e2a34e92480f0$var$_extends.apply(null, arguments);
}
var $3e5e2a34e92480f0$var$StatusGoodSmall = $3e5e2a34e92480f0$export$a09254dff7a942de = /*#__PURE__*/ (0, $3e5e2a34e92480f0$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $3e5e2a34e92480f0$var$_react["default"].createElement($xazbe.StyledIcon, $3e5e2a34e92480f0$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ $3e5e2a34e92480f0$var$_react["default"].createElement("circle", {
        cx: "6",
        cy: "6",
        r: "5",
        fillRule: "evenodd",
        stroke: "#000"
    }));
});
$3e5e2a34e92480f0$var$StatusGoodSmall.displayName = 'StatusGoodSmall';

});

parcelRegister("ehCpZ", function(module, exports) {

$parcel$export(module.exports, "StatusWarningSmall", () => $a66074484574bd9c$export$ead8eef644cb6ffc, (v) => $a66074484574bd9c$export$ead8eef644cb6ffc = v);
var $a66074484574bd9c$export$1e511d4a378977f5;
var $a66074484574bd9c$export$ead8eef644cb6ffc;
"use strict";
$a66074484574bd9c$export$1e511d4a378977f5 = true;
$a66074484574bd9c$export$ead8eef644cb6ffc = void 0;

var $a66074484574bd9c$var$_react = $a66074484574bd9c$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $a66074484574bd9c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a66074484574bd9c$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $a66074484574bd9c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $a66074484574bd9c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $a66074484574bd9c$var$_extends() {
    return $a66074484574bd9c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a66074484574bd9c$var$_extends.apply(null, arguments);
}
var $a66074484574bd9c$var$StatusWarningSmall = $a66074484574bd9c$export$ead8eef644cb6ffc = /*#__PURE__*/ (0, $a66074484574bd9c$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $a66074484574bd9c$var$_react["default"].createElement($xazbe.StyledIcon, $a66074484574bd9c$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is warning"
    }, props), /*#__PURE__*/ $a66074484574bd9c$var$_react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        strokeLinejoin: "round",
        d: "m6 1 5 9H1z"
    }));
});
$a66074484574bd9c$var$StatusWarningSmall.displayName = 'StatusWarningSmall';

});

parcelRegister("3mta4", function(module, exports) {

$parcel$export(module.exports, "StatusUnknownSmall", () => $272a0c0a2c42b3b4$export$525b879776bb0ada, (v) => $272a0c0a2c42b3b4$export$525b879776bb0ada = v);
var $272a0c0a2c42b3b4$export$1e511d4a378977f5;
var $272a0c0a2c42b3b4$export$525b879776bb0ada;
"use strict";
$272a0c0a2c42b3b4$export$1e511d4a378977f5 = true;
$272a0c0a2c42b3b4$export$525b879776bb0ada = void 0;

var $272a0c0a2c42b3b4$var$_react = $272a0c0a2c42b3b4$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $272a0c0a2c42b3b4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($272a0c0a2c42b3b4$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $272a0c0a2c42b3b4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $272a0c0a2c42b3b4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $272a0c0a2c42b3b4$var$_extends() {
    return $272a0c0a2c42b3b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $272a0c0a2c42b3b4$var$_extends.apply(null, arguments);
}
var $272a0c0a2c42b3b4$var$StatusUnknownSmall = $272a0c0a2c42b3b4$export$525b879776bb0ada = /*#__PURE__*/ (0, $272a0c0a2c42b3b4$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $272a0c0a2c42b3b4$var$_react["default"].createElement($xazbe.StyledIcon, $272a0c0a2c42b3b4$var$_extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is unknown"
    }, props), /*#__PURE__*/ $272a0c0a2c42b3b4$var$_react["default"].createElement("rect", {
        width: "10",
        height: "10",
        x: "1",
        y: "1",
        fillRule: "evenodd",
        stroke: "#000",
        rx: "1"
    }));
});
$272a0c0a2c42b3b4$var$StatusUnknownSmall.displayName = 'StatusUnknownSmall';

});

parcelRegister("irJMV", function(module, exports) {

$parcel$export(module.exports, "View", () => $d6de442766dda06f$export$27a5bd065ad55220, (v) => $d6de442766dda06f$export$27a5bd065ad55220 = v);
var $d6de442766dda06f$export$1e511d4a378977f5;
var $d6de442766dda06f$export$27a5bd065ad55220;
"use strict";
$d6de442766dda06f$export$1e511d4a378977f5 = true;
$d6de442766dda06f$export$27a5bd065ad55220 = void 0;

var $d6de442766dda06f$var$_react = $d6de442766dda06f$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $d6de442766dda06f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d6de442766dda06f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $d6de442766dda06f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $d6de442766dda06f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $d6de442766dda06f$var$_extends() {
    return $d6de442766dda06f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d6de442766dda06f$var$_extends.apply(null, arguments);
}
var $d6de442766dda06f$var$View = $d6de442766dda06f$export$27a5bd065ad55220 = /*#__PURE__*/ (0, $d6de442766dda06f$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $d6de442766dda06f$var$_react["default"].createElement($xazbe.StyledIcon, $d6de442766dda06f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "View"
    }, props), /*#__PURE__*/ $d6de442766dda06f$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21c-5 0-11-5-11-9s6-9 11-9 11 5 11 9-6 9-11 9zm0-14a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
    }));
});
$d6de442766dda06f$var$View.displayName = 'View';

});

parcelRegister("K1r2I", function(module, exports) {

$parcel$export(module.exports, "Volume", () => $08a568fcf19a3753$export$dde279e52d625429, (v) => $08a568fcf19a3753$export$dde279e52d625429 = v);
var $08a568fcf19a3753$export$1e511d4a378977f5;
var $08a568fcf19a3753$export$dde279e52d625429;
"use strict";
$08a568fcf19a3753$export$1e511d4a378977f5 = true;
$08a568fcf19a3753$export$dde279e52d625429 = void 0;

var $08a568fcf19a3753$var$_react = $08a568fcf19a3753$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $08a568fcf19a3753$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($08a568fcf19a3753$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $08a568fcf19a3753$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $08a568fcf19a3753$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $08a568fcf19a3753$var$_extends() {
    return $08a568fcf19a3753$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $08a568fcf19a3753$var$_extends.apply(null, arguments);
}
var $08a568fcf19a3753$var$Volume = $08a568fcf19a3753$export$dde279e52d625429 = /*#__PURE__*/ (0, $08a568fcf19a3753$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $08a568fcf19a3753$var$_react["default"].createElement($xazbe.StyledIcon, $08a568fcf19a3753$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Volume"
    }, props), /*#__PURE__*/ $08a568fcf19a3753$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 16a4 4 0 0 0 0-8m0 12c5 0 8-3.589 8-8s-3.589-8-8-8M1 12V8h5l6-5v18l-6-5H1v-4"
    }));
});
$08a568fcf19a3753$var$Volume.displayName = 'Volume';

});

parcelRegister("lwtww", function(module, exports) {

$parcel$export(module.exports, "VolumeLow", () => $fab37ce6c5ed0b0d$export$679a525edce53a0a, (v) => $fab37ce6c5ed0b0d$export$679a525edce53a0a = v);
var $fab37ce6c5ed0b0d$export$1e511d4a378977f5;
var $fab37ce6c5ed0b0d$export$679a525edce53a0a;
"use strict";
$fab37ce6c5ed0b0d$export$1e511d4a378977f5 = true;
$fab37ce6c5ed0b0d$export$679a525edce53a0a = void 0;

var $fab37ce6c5ed0b0d$var$_react = $fab37ce6c5ed0b0d$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $fab37ce6c5ed0b0d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fab37ce6c5ed0b0d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fab37ce6c5ed0b0d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $fab37ce6c5ed0b0d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fab37ce6c5ed0b0d$var$_extends() {
    return $fab37ce6c5ed0b0d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fab37ce6c5ed0b0d$var$_extends.apply(null, arguments);
}
var $fab37ce6c5ed0b0d$var$VolumeLow = $fab37ce6c5ed0b0d$export$679a525edce53a0a = /*#__PURE__*/ (0, $fab37ce6c5ed0b0d$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $fab37ce6c5ed0b0d$var$_react["default"].createElement($xazbe.StyledIcon, $fab37ce6c5ed0b0d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VolumeLow"
    }, props), /*#__PURE__*/ $fab37ce6c5ed0b0d$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8v8h5.099L12 21V3L6 8H1zm14 8a4 4 0 1 0 0-8"
    }));
});
$fab37ce6c5ed0b0d$var$VolumeLow.displayName = 'VolumeLow';

});





parcelRegister("1rxx7", function(module, exports) {

$parcel$export(module.exports, "StyledAnchor", () => $10d2530aae205c35$export$ec39d0bf2d6d1efb);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");
var $10d2530aae205c35$var$disabledStyle = "\n  opacity: 0.3;\n  cursor: default;\n  text-decoration: none;\n";
var $10d2530aae205c35$var$sizeStyle = function sizeStyle(props) {
    if (props.size) {
        var size = props.size || 'medium';
        var data = props.theme.text[size];
        return (0, $f5efw.css)([
            "font-size:",
            ";line-height:",
            ";"
        ], data ? data.size : size, data ? data.height : 'normal');
    }
    return (0, $f5efw.css)([
        "font-size:inherit;line-height:inherit;"
    ]);
};
var $10d2530aae205c35$export$ec39d0bf2d6d1efb = (0, $f5efw.default).a.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledAnchor",
    componentId: "sc-1rp7lwl-0"
})([
    "box-sizing:border-box;display:inline-flex;",
    " color:",
    ";",
    " text-decoration:",
    ";cursor:pointer;",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return $10d2530aae205c35$var$sizeStyle(props);
}, function(props) {
    var _props$theme$anchor;
    return (0, $d2fh4.normalizeColor)(props.colorProp || ((_props$theme$anchor = props.theme.anchor) == null || (_props$theme$anchor = _props$theme$anchor.size) == null || (_props$theme$anchor = _props$theme$anchor[props.size]) == null ? void 0 : _props$theme$anchor.color) || props.theme.anchor.color, props.theme);
}, function(props) {
    var _props$theme$anchor2, _props$theme$anchor3;
    return props.weight ? "font-weight: " + props.weight + ";" : (((_props$theme$anchor2 = props.theme.anchor) == null || (_props$theme$anchor2 = _props$theme$anchor2.size) == null || (_props$theme$anchor2 = _props$theme$anchor2[props.size]) == null ? void 0 : _props$theme$anchor2.fontWeight) || props.theme.anchor.fontWeight) && "font-weight: " + (((_props$theme$anchor3 = props.theme.anchor) == null || (_props$theme$anchor3 = _props$theme$anchor3.size) == null || (_props$theme$anchor3 = _props$theme$anchor3[props.size]) == null ? void 0 : _props$theme$anchor3.fontWeight) || props.theme.anchor.fontWeight) + ";";
}, function(props) {
    var _props$theme$anchor4;
    return props.hasIcon ? 'none' : ((_props$theme$anchor4 = props.theme.anchor) == null || (_props$theme$anchor4 = _props$theme$anchor4.size) == null || (_props$theme$anchor4 = _props$theme$anchor4[props.size]) == null ? void 0 : _props$theme$anchor4.textDecoration) || props.theme.anchor.textDecoration;
}, (0, $2O6LY.genericStyles), function(props) {
    return !props.disabled && props.theme.anchor.hover && (0, $f5efw.css)([
        "&:hover{",
        " ",
        " ",
        "}"
    ], props.theme.anchor.hover.textDecoration && "text-decoration: " + props.theme.anchor.hover.textDecoration + ";", props.theme.anchor.hover.fontWeight && "font-weight: " + props.theme.anchor.hover.fontWeight + ";", props.theme.anchor.hover.extend);
}, function(props) {
    return props.hasIcon && !props.hasLabel && (0, $2O6LY.edgeStyle)('padding', props.theme.anchor.iconOnly.pad, false, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && $10d2530aae205c35$var$disabledStyle;
}, function(props) {
    return props.focus && (0, $2O6LY.focusStyle)();
}, function(props) {
    return props.theme.anchor.extend;
});

});

parcelRegister("6YCHN", function(module, exports) {

$parcel$export(module.exports, "AnchorPropTypes", () => $51465ec08d710828$export$503a586efc7a7ea1);


function $51465ec08d710828$var$_extends() {
    return $51465ec08d710828$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $51465ec08d710828$var$_extends.apply(null, arguments);
}
var $51465ec08d710828$var$PropType = {};
var $51465ec08d710828$export$503a586efc7a7ea1 = $51465ec08d710828$var$PropType;

});

parcelRegister("hbZKz", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $c8435d0bca07d1b2$export$e955abb82869dc84);
$parcel$export(module.exports, "AnalyticsProvider", () => $c8435d0bca07d1b2$export$1b581a2ec13e37f1);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $c8435d0bca07d1b2$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(function() {});
var $c8435d0bca07d1b2$export$e955abb82869dc84 = function useAnalytics() {
    return (0, $2NacA.useContext)($c8435d0bca07d1b2$export$83cd6c3eba7d8d9e);
};
var $c8435d0bca07d1b2$export$1b581a2ec13e37f1 = function AnalyticsProvider(_ref) {
    var onAnalytics = _ref.onAnalytics, children = _ref.children;
    var lastUrlRef = (0, $2NacA.useRef)();
    var sendAnalytics = (0, $2NacA.useCallback)(function(data) {
        return onAnalytics && onAnalytics(data);
    }, [
        onAnalytics
    ]);
    (0, $2NacA.useEffect)(function() {
        var observer;
        if (onAnalytics) {
            observer = new window.MutationObserver(function() {
                var _window;
                var url = (_window = window) == null || (_window = _window.location) == null ? void 0 : _window.href;
                var previousUrl = lastUrlRef.current;
                if (url !== previousUrl) {
                    lastUrlRef.current = url;
                    sendAnalytics({
                        type: 'pageView',
                        url: url,
                        previousUrl: previousUrl
                    });
                }
            });
            observer.observe(document, {
                subtree: true,
                childList: true
            });
        }
        return function() {
            var _observer;
            return (_observer = observer) == null ? void 0 : _observer.disconnect();
        };
    }, [
        sendAnalytics,
        onAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($c8435d0bca07d1b2$export$83cd6c3eba7d8d9e.Provider, {
        value: sendAnalytics
    }, children);
};

});

parcelRegister("8QB4u", function(module, exports) {

$parcel$export(module.exports, "TextContext", () => $670fefacf9d31e83$export$9afb8bc826b033ea);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $670fefacf9d31e83$export$9afb8bc826b033ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext({});

});


parcelRegister("a26J5", function(module, exports) {

$parcel$export(module.exports, "Button", () => $74df4ef50f6db38b$export$353f5b6fc5456de1);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");
var $d2fh4 = parcelRequire("d2fh4");
var $cDMMY = parcelRequire("cDMMY");
var $1PECa = parcelRequire("1PECa");

var $9txp6 = parcelRequire("9txp6");

var $7oNsG = parcelRequire("7oNsG");

var $2M0UK = parcelRequire("2M0UK");

var $aHKsU = parcelRequire("aHKsU");

var $5xcHk = parcelRequire("5xcHk");

var $79HTA = parcelRequire("79HTA");

var $ls1zK = parcelRequire("ls1zK");

var $jvf4K = parcelRequire("jvf4K");

var $7w0rz = parcelRequire("7w0rz");

var $hbZKz = parcelRequire("hbZKz");

var $7bBqH = parcelRequire("7bBqH");
var $4ZVSM = parcelRequire("4ZVSM");

var $hZkM5 = parcelRequire("hZkM5");

var $eL6w3 = parcelRequire("eL6w3");
var $74df4ef50f6db38b$var$_excluded = [
    "active",
    "align",
    "aria-label",
    "badge",
    "busy",
    "color",
    "children",
    "disabled",
    "icon",
    "focusIndicator",
    "gap",
    "fill",
    "href",
    "justify",
    "kind",
    "label",
    "messages",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "plain",
    "primary",
    "reverse",
    "secondary",
    "selected",
    "size",
    "success",
    "tip",
    "type",
    "a11yTitle",
    "as"
];
function $74df4ef50f6db38b$var$_extends() {
    return $74df4ef50f6db38b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $74df4ef50f6db38b$var$_extends.apply(null, arguments);
}
function $74df4ef50f6db38b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $74df4ef50f6db38b$var$RelativeBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "Button__RelativeBox",
    componentId: "sc-zuqsuw-0"
})([
    "position:relative;"
]);
// We have two Styled* components to separate
// the newer default|primary|secondary approach,
// which we use the term "kind" to refer to,
// from the previous approach. Hopefully, when we get to grommet v3,
// we can drop the old way and just use kind.
//
// In the kind approach, we rely on the basic structure of the theme
// being repeated. For example: button.default, button.active,
// button.active.default all refer to a similar object containing
// { background, border, color, padding }.
// This allows us to use the same code to evaluate color and generate CSS.
// We just need to build up CSS, since selectors override previous ones.
// See StyledButtonKind.kindStyles() for this.
// And we build down to determine icon color, once we have a color from
// the latest applicable state, we can stop. See Button.getIconColor() for this.
// backgroundAndTextColor() is used in both cases to ensure we are determining
// color in the same way, so the icon and label align.
// only when default is in the theme
// Used to get the color for the icon to match what StyledButtonKind
// and backgroundStyle() will do for the label.
// The paths are ordered from basic to specific. Go through them
// specific to base until we find one that has a color and use that.
var $74df4ef50f6db38b$var$getIconColor = function getIconColor(paths, theme, colorProp, kind) {
    if (paths === void 0) paths = [];
    var result = [];
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result[1]){
        var baseObj = typeof kind === 'object' && kind || theme.button;
        var obj = baseObj;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) {
            var _obj;
            // use passed in color for background if the theme has a background color
            var background = colorProp && obj.background && obj.background.color ? colorProp : obj.background;
            // if theme object explicitly sets the color to undefined, pass false
            // to indicate that the theme doesn't want any text color
            var objColor = obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined);
            var color = void 0;
            if ((_obj = obj) != null && (_obj = _obj.icon) != null && (_obj = _obj.props) != null && _obj.color) color = obj.icon.props.color;
            else if (paths[index + 1]) {
                var _obj2;
                var _parts = paths[index + 1].split('.');
                while(baseObj && _parts.length)obj = baseObj[_parts.shift()];
                if ((_obj2 = obj) != null && (_obj2 = _obj2.icon) != null && (_obj2 = _obj2.props) != null && _obj2.color) color = obj.icon.props.color;
            }
            // use passed in color for text if the theme doesn't have
            // background or border color
            if (!color) color = colorProp && (!obj.background || !obj.background.color) && (!obj.border || !obj.border.color) ? colorProp : objColor;
            result = (0, $jQHd2.backgroundAndTextColors)(background, color, theme);
        }
        index -= 1;
    }
    return result[1] || undefined;
};
// get the icon for the current button state
var $74df4ef50f6db38b$var$getKindIcon = function getKindIcon(paths, theme, kind) {
    if (paths === void 0) paths = [];
    var result;
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result){
        var _obj3;
        var obj = typeof kind === 'object' && kind || theme.button;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if ((_obj3 = obj) != null && _obj3.icon) result = obj.icon;
        index -= 1;
    }
    return result || undefined;
};
var $74df4ef50f6db38b$var$getPropertyColor = function getPropertyColor(property, paths, theme, kind, primary) {
    if (paths === void 0) paths = [];
    var result;
    if (kind) {
        var obj = typeof kind === 'object' && kind || theme.button;
        // index 0 is default state
        if (paths[0]) {
            var parts = paths[0].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) result = obj[property] || obj[property] && obj[property].color;
    } else if (primary && theme && theme.button && theme.button.primary) result = theme.button.primary[property] || theme.button.primary[property] && theme.button.primary[property].color;
    else result = theme && theme.button && theme.button[property] || theme && theme.button && theme.button[property] && theme.button[property].color;
    return result;
};
var $74df4ef50f6db38b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$global$depreca2, _theme$button$kind, _theme$button2;
    var active = _ref.active, _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, ariaLabel = _ref['aria-label'], badgeProp = _ref.badge, busy = _ref.busy, color = _ref.color, children = _ref.children, disabled = _ref.disabled, icon = _ref.icon, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, fill = _ref.fill, href = _ref.href, justify = _ref.justify, kindArg = _ref.kind, label = _ref.label, messages = _ref.messages, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, _onFocus = _ref.onFocus, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, pad = _ref.pad, plain = _ref.plain, primary = _ref.primary, reverseProp = _ref.reverse, secondary = _ref.secondary, selected = _ref.selected, sizeProp = _ref.size, success = _ref.success, tip = _ref.tip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tip === 'string' ? tip : undefined : _ref$a11yTitle, as = _ref.as, rest = $74df4ef50f6db38b$var$_objectWithoutPropertiesLoose(_ref, $74df4ef50f6db38b$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2NacA.useContext)((0, $aHKsU.OptionsContext)), buttonOptions = _useContext.button;
    var _useState = (0, $2NacA.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, $2NacA.useState)(false), hover = _useState2[0], setHover = _useState2[1];
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    var _useContext2 = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext2.format;
    if (busy && success) console.warn('Button cannot have both busy and success set to true.');
    (0, $2NacA.useEffect)(function() {
        if (busy) announce(format({
            id: 'button.busy',
            messages: messages
        }));
        else if (success) announce(format({
            id: 'button.success',
            messages: messages
        }));
    }, [
        announce,
        busy,
        format,
        messages,
        success
    ]);
    if ((icon || label) && children) console.warn('Button should not have children if icon or label is provided');
    (0, $2NacA.useEffect)(function() {
        var _theme$global$depreca;
        var deprecatedKind;
    }, [
        kindArg,
        (_theme$global$depreca2 = theme.global.deprecated) == null || (_theme$global$depreca2 = _theme$global$depreca2.button) == null ? void 0 : _theme$global$depreca2.kind
    ]);
    var skeleton = (0, $4ZVSM.useSkeleton)();
    var sendAnalytics = (0, $hbZKz.useAnalytics)();
    var onClick = (0, $2NacA.useCallback)(function(event) {
        sendAnalytics({
            type: 'buttonClick',
            element: (0, $cDMMY.findButtonParent)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        href,
        label
    ]);
    // kindArg is object if we are referencing a theme object
    // outside of theme.button
    var kindObj = (0, $2NacA.useMemo)(function() {
        return typeof kindArg === 'object';
    }, [
        kindArg
    ]);
    // if the theme has button.default, what kind of Button is this
    var kind = (0, $2NacA.useMemo)(function() {
        if (theme.button["default"] || kindObj) {
            if (kindArg) return kindArg;
            if (primary) return 'primary';
            if (secondary) return 'secondary';
            return 'default';
        }
        return undefined; // pre-default, no kind
    }, [
        kindArg,
        kindObj,
        primary,
        secondary,
        theme
    ]);
    // for backwards compatibility, no-kind button theme did not
    // default to size "medium" on buttons with no size prop
    var size = sizeProp || kind && 'medium' || undefined;
    // When we have a kind and are not plain, themePaths stores the relative
    // paths within the theme for the current kind and state of the button.
    // These paths are used with getIconColor() above and kindStyle() within
    // StyledButtonKind.
    var themePaths = (0, $2NacA.useMemo)(function() {
        if (!kind || plain) return undefined;
        var result = {
            base: [],
            hover: []
        };
        if (!kindObj) result.base.push(kind);
        if (selected) {
            result.base.push('selected');
            if (!kindObj) result.base.push("selected." + kind);
        }
        if (disabled) {
            result.base.push('disabled');
            if (!kindObj) result.base.push("disabled." + kind);
        } else {
            if (active) {
                result.base.push('active');
                if (!kindObj) result.base.push("active." + kind);
            }
            result.hover.push('hover');
            if (!kindObj) result.hover.push("hover." + kind);
            if (active) {
                result.hover.push("hover.active");
                if (!kindObj) result.hover.push("hover.active." + kind);
            }
        }
        return result;
    }, [
        active,
        disabled,
        kind,
        kindObj,
        plain,
        selected
    ]);
    // only used when theme does not have button.default
    var isDarkBackground = function isDarkBackground() {
        var backgroundColor = (0, $jQHd2.normalizeBackground)((0, $d2fh4.normalizeColor)(color || theme.button.primary && theme.button.primary.color || theme.global.colors.control || 'brand', theme), theme);
        return (0, $d2fh4.colorIsDark)(backgroundColor, theme);
    };
    var onMouseOverButton = function onMouseOverButton(event) {
        setHover(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutButton = function onMouseOutButton(event) {
        setHover(false);
        if (onMouseOut) onMouseOut(event);
    };
    var kindIcon = hover && $74df4ef50f6db38b$var$getKindIcon(themePaths == null ? void 0 : themePaths.hover, theme, kind) || $74df4ef50f6db38b$var$getKindIcon(themePaths == null ? void 0 : themePaths.base, theme, kind);
    var buttonIcon = icon || kindIcon;
    // only change color if user did not specify the color themselves...
    if (icon && !icon.props.color) {
        if (kind) {
            if (!plain) {
                // match what the label will use
                var iconColor = hover && $74df4ef50f6db38b$var$getIconColor(themePaths.hover, theme) || $74df4ef50f6db38b$var$getIconColor(themePaths.base, theme, color, kind);
                if (iconColor) buttonIcon = /*#__PURE__*/ (0, $2NacA.cloneElement)(icon, {
                    color: iconColor
                });
            }
        } else if (primary) buttonIcon = /*#__PURE__*/ (0, $2NacA.cloneElement)(icon, {
            color: theme.global.colors.text[isDarkBackground() ? 'dark' : 'light']
        });
    } else if (kindIcon && !plain) {
        var _iconColor = hover && $74df4ef50f6db38b$var$getIconColor(themePaths.hover, theme) || $74df4ef50f6db38b$var$getIconColor(themePaths.base, theme, color, kind);
        if (_iconColor) buttonIcon = /*#__PURE__*/ (0, $2NacA.cloneElement)(kindIcon, {
            color: _iconColor
        });
    }
    buttonIcon = (0, $1PECa.useSizedIcon)(buttonIcon, size, theme);
    if (skeleton) {
        var _theme$text, _theme$button$size;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7bBqH.Skeleton), $74df4ef50f6db38b$var$_extends({
            ref: ref,
            height: ((_theme$text = theme.text[size || 'medium']) == null ? void 0 : _theme$text.height) || size,
            a11yTitle: a11yTitle
        }, rest, (_theme$button$size = theme.button.size) == null ? void 0 : _theme$button$size[size || 'medium'], theme.button.skeleton));
    }
    var reverse = reverseProp != null ? reverseProp : (_theme$button$kind = theme.button[kind]) == null ? void 0 : _theme$button$kind.reverse;
    var domTag = !as && href ? 'a' : as;
    var first = reverse ? label : buttonIcon;
    var second = reverse ? buttonIcon : label;
    var contents;
    if (first && second) {
        var _theme$button;
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            direction: ((_theme$button = theme.button) == null || (_theme$button = _theme$button[kind]) == null ? void 0 : _theme$button.direction) || 'row',
            align: "center",
            justify: justify || (align === 'center' ? 'center' : 'between'),
            gap: gap || theme.button.gap,
            responsive: false
        }, first, second);
    } else if (typeof children === 'function') contents = children({
        active: active,
        disabled: disabled,
        hover: hover,
        focus: focus
    });
    else contents = first || second || children;
    var background = $74df4ef50f6db38b$var$getPropertyColor('background', themePaths && themePaths.base, theme, kind, primary);
    var border = $74df4ef50f6db38b$var$getPropertyColor('border', themePaths && themePaths.base, theme, kind, primary);
    // set the badge relative to the button content
    // when the button doesn't have background or border
    // (!kind && icon && !label) is necessary because for old button logic,
    // if button has icon but not label, it will be considered "plain",
    // so no border or background will be applied
    var innerBadge = ((_theme$button2 = theme.button) == null || (_theme$button2 = _theme$button2.badge) == null ? void 0 : _theme$button2.align) !== 'container' && (!background && !border || !kind && icon && !label);
    if (badgeProp && innerBadge) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ls1zK.Badge), {
        content: badgeProp
    }, contents);
    if (busy || success) {
        var _theme$button3;
        // match what the label will use
        var animationColor;
        if (kind) {
            if (!plain) animationColor = hover && $74df4ef50f6db38b$var$getIconColor(themePaths.hover, theme) || $74df4ef50f6db38b$var$getIconColor(themePaths.base, theme, color, kind);
        } else if (primary) animationColor = theme.global.colors.text[isDarkBackground() ? 'dark' : 'light'];
        contents = /*#__PURE__*/ // position relative is necessary to have the animation
        // display over the button content
        (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($74df4ef50f6db38b$var$RelativeBox, {
            flex: false
        }, busy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hZkM5.EllipsisAnimation), null), success && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            style: {
                position: 'absolute'
            },
            fill: true,
            alignContent: "center",
            justify: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hZkM5.GrowCheckmark), {
            color: animationColor,
            "aria-hidden": true,
            as: (_theme$button3 = theme.button) == null || (_theme$button3 = _theme$button3.busy) == null || (_theme$button3 = _theme$button3.icons) == null ? void 0 : _theme$button3.success
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hZkM5.StyledBusyContents), {
            animating: busy || success
        }, contents));
    }
    var styledButtonResult;
    if (kind) styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7w0rz.StyledButtonKind), $74df4ef50f6db38b$var$_extends({}, rest, {
        as: domTag,
        ref: ref,
        active: active,
        align: align,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        badge: badgeProp,
        colorValue: color,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        icon: icon,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad,
        plain: plain || (buttonOptions == null ? void 0 : buttonOptions.childrenPlain) !== false && (0, $2NacA.Children).count(children) > 0,
        primary: primary,
        selected: selected,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    else styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jvf4K.StyledButton), $74df4ef50f6db38b$var$_extends({}, rest, {
        as: domTag,
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        colorValue: color,
        active: active,
        selected: selected,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad || !plain,
        plain: typeof plain !== 'undefined' ? plain : (buttonOptions == null ? void 0 : buttonOptions.childrenPlain) !== false && (0, $2NacA.Children).count(children) > 0 || icon && !label,
        primary: primary,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    if (tip) {
        if (typeof tip === 'string') styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $79HTA.Tip), {
            content: tip
        }, styledButtonResult);
        else styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $79HTA.Tip), tip, styledButtonResult);
    }
    // if button has background or border, place badge relative
    // to outer edge of button
    if (badgeProp && !innerBadge) styledButtonResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ls1zK.Badge), {
        content: badgeProp
    }, styledButtonResult);
    return styledButtonResult;
});
$74df4ef50f6db38b$export$353f5b6fc5456de1.displayName = 'Button';
$74df4ef50f6db38b$export$353f5b6fc5456de1.propTypes = (0, $9txp6.ButtonPropTypes);

});
parcelRegister("9txp6", function(module, exports) {

$parcel$export(module.exports, "ButtonPropTypes", () => $6e60bbd02e0fdea1$export$932f054f6b4bba8d);


function $6e60bbd02e0fdea1$var$_extends() {
    return $6e60bbd02e0fdea1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6e60bbd02e0fdea1$var$_extends.apply(null, arguments);
}
var $6e60bbd02e0fdea1$var$PropType = {};
var $6e60bbd02e0fdea1$export$932f054f6b4bba8d = $6e60bbd02e0fdea1$var$PropType;

});

parcelRegister("79HTA", function(module, exports) {

$parcel$export(module.exports, "Tip", () => $535b6c6f031b66d7$export$c92c6401b52a9298);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $isD1Z = parcelRequire("isD1Z");

var $czDw5 = parcelRequire("czDw5");

var $dOlbm = parcelRequire("dOlbm");
var $hp4MM = parcelRequire("hp4MM");

var $gOUAw = parcelRequire("gOUAw");

var $eL6w3 = parcelRequire("eL6w3");
function $535b6c6f031b66d7$var$_extends() {
    return $535b6c6f031b66d7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $535b6c6f031b66d7$var$_extends.apply(null, arguments);
}
/*
 * This function getReactNodeRef is adapted from
 * [Material UI] (https://github.com/mui/material-ui)
 * Licensed under the MIT License (c) 2024 aarongarciah
 * The function has been modified from its original version.
 */ var $535b6c6f031b66d7$var$getReactNodeRef = function getReactNodeRef(element) {
    if (!element || !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).isValidElement(element)) return null;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to
    // children in older versions
    return ({}).propertyIsEnumerable.call(element.props, 'ref') ? element.props.ref : element.ref;
};
var $535b6c6f031b66d7$export$c92c6401b52a9298 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, tipRef) {
    var children = _ref.children, content = _ref.content, _ref$defaultVisible = _ref.defaultVisible, defaultVisible = _ref$defaultVisible === void 0 ? false : _ref$defaultVisible, dropProps = _ref.dropProps, plain = _ref.plain;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var _useState = (0, $2NacA.useState)(false), over = _useState[0], setOver = _useState[1];
    var _useState2 = (0, $2NacA.useState)(false), tooltipOver = _useState2[0], setTooltipOver = _useState2[1];
    var usingKeyboard = (0, $hp4MM.useKeyboard)();
    var componentRef = (0, $dOlbm.useForwardedRef)(tipRef);
    // Three use case for children
    // 1. Tip has a single child + it is a React Element => Great!
    // 2. Tip has a single child +  not React Element =>
    // span will wrap the child so we can use ref and events.
    // 3. Tip has more than one child => Abort, display Children.only error
    var child = (0, $2NacA.Children).count(children) <= 1 && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).isValidElement(children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("span", null, children) || (0, $2NacA.Children).only(children);
    var clonedChild = /*#__PURE__*/ (0, $2NacA.cloneElement)(child, {
        onMouseEnter: function onMouseEnter(event) {
            var _child$props;
            setOver(true);
            if ((_child$props = child.props) != null && _child$props.onMouseEnter) child.props.onMouseEnter(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            var _child$props2;
            setOver(false);
            if ((_child$props2 = child.props) != null && _child$props2.onMouseLeave) child.props.onMouseLeave(event);
        },
        onFocus: function onFocus(event) {
            var _child$props3;
            if (usingKeyboard) setOver(true);
            if ((_child$props3 = child.props) != null && _child$props3.onFocus) child.props.onFocus(event);
        },
        onBlur: function onBlur(event) {
            var _child$props4;
            if (usingKeyboard) setOver(false);
            if ((_child$props4 = child.props) != null && _child$props4.onBlur) child.props.onBlur(event);
        },
        key: 'tip-child',
        ref: function ref(node) {
            // https://github.com/facebook/react/issues/8873#issuecomment-287873307
            if (typeof componentRef === 'function') componentRef(node);
            else if (componentRef) componentRef.current = node;
            // Call the original ref, if any
            var callerRef = $535b6c6f031b66d7$var$getReactNodeRef(child);
            if (typeof callerRef === 'function') callerRef(node);
            else if (callerRef) callerRef.current = node;
        }
    });
    (0, $2NacA.useEffect)(function() {
        setOver(defaultVisible);
    }, [
        defaultVisible
    ]);
    return [
        clonedChild,
        (over || tooltipOver) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
            key: "tip-keyboard",
            onEsc: function onEsc() {
                setOver(false);
                setTooltipOver(false);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $isD1Z.Drop), $535b6c6f031b66d7$var$_extends({
            target: componentRef.current,
            trapFocus: false,
            key: "tip-drop"
        }, theme.tip.drop, dropProps, {
            onMouseEnter: function onMouseEnter() {
                return setTooltipOver(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setTooltipOver(false);
            }
        }), plain ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), theme.tip.content, content)))
    ];
});
$535b6c6f031b66d7$export$c92c6401b52a9298.displayName = 'Tip';
$535b6c6f031b66d7$export$c92c6401b52a9298.propTypes = (0, $gOUAw.TipPropTypes);

});
parcelRegister("isD1Z", function(module, exports) {

$parcel$export(module.exports, "Drop", () => $d7091e46057652bf$export$aaa698cd7aa517d6);

var $2NacA = parcelRequire("2NacA");

var $l6sdi = parcelRequire("l6sdi");

var $cDMMY = parcelRequire("cDMMY");

var $k6x4E = parcelRequire("k6x4E");

var $cBNWv = parcelRequire("cBNWv");

var $3OZRo = parcelRequire("3OZRo");

var $eL6w3 = parcelRequire("eL6w3");
var $d7091e46057652bf$var$_excluded = [
    "inline",
    "restrictFocus",
    "target",
    "trapFocus"
];
function $d7091e46057652bf$var$_extends() {
    return $d7091e46057652bf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7091e46057652bf$var$_extends.apply(null, arguments);
}
function $d7091e46057652bf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d7091e46057652bf$export$aaa698cd7aa517d6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var inline = _ref.inline, restrictFocus = _ref.restrictFocus, dropTarget = _ref.target, _ref$trapFocus = _ref.trapFocus, trapFocus = _ref$trapFocus === void 0 ? true : _ref$trapFocus, rest = $d7091e46057652bf$var$_objectWithoutPropertiesLoose(_ref, $d7091e46057652bf$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var _useState = (0, $2NacA.useState)(), originalFocusedElement = _useState[0], setOriginalFocusedElement = _useState[1];
    (0, $2NacA.useEffect)(function() {
        return setOriginalFocusedElement(document.activeElement);
    }, []);
    var _useState2 = (0, $2NacA.useState)(), dropContainer = _useState2[0], setDropContainer = _useState2[1];
    var containerTarget = (0, $2NacA.useContext)((0, $cBNWv.ContainerTargetContext));
    var containerChildNodesLength = (0, $2NacA.useRef)(null);
    (0, $2NacA.useEffect)(function() {
        // we need this condition to prevent getNewContainer to run multiple times
        // in the event that the component gets created, destroyed, and recreated.
        // see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state
        if (!(containerChildNodesLength != null && containerChildNodesLength.current)) {
            containerChildNodesLength.current = containerTarget.childNodes.length;
            setDropContainer(!inline ? (0, $cDMMY.getNewContainer)(containerTarget) : undefined);
        }
    }, [
        containerTarget,
        inline
    ]);
    // just a few things to clean up when the Drop is unmounted
    (0, $2NacA.useEffect)(function() {
        return function() {
            if (restrictFocus && originalFocusedElement) {
                if (originalFocusedElement.focus) (0, $cDMMY.setFocusWithoutScroll)(originalFocusedElement);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                (0, $cDMMY.setFocusWithoutScroll)(originalFocusedElement.parentNode);
            }
            if (dropContainer) containerTarget.removeChild(dropContainer);
        };
    }, [
        containerTarget,
        dropContainer,
        originalFocusedElement,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $k6x4E.DropContainer), $d7091e46057652bf$var$_extends({
        ref: ref,
        dir: theme && theme.dir,
        dropTarget: dropTarget,
        restrictFocus: restrictFocus,
        trapFocus: trapFocus
    }, rest));
    if (inline) return content;
    if (dropContainer) return /*#__PURE__*/ (0, $l6sdi.createPortal)(content, dropContainer);
    return null;
});
$d7091e46057652bf$export$aaa698cd7aa517d6.displayName = 'Drop';
$d7091e46057652bf$export$aaa698cd7aa517d6.propTypes = (0, $3OZRo.DropPropTypes);

});
parcelRegister("l6sdi", function(module, exports) {
'use strict';
function $f5d00b210bd4f63f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f5d00b210bd4f63f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f5d00b210bd4f63f$var$checkDCE();

module.exports = (parcelRequire("5lcXX"));

});

parcelRegister("k6x4E", function(module, exports) {

$parcel$export(module.exports, "DropContainer", () => $ea2e0604c60011d3$export$aabdb120602c28c3);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $cBNWv = parcelRequire("cBNWv");

var $hKfeK = parcelRequire("hKfeK");

var $jQHd2 = parcelRequire("jQHd2");
var $cDMMY = parcelRequire("cDMMY");
var $fzxBh = parcelRequire("fzxBh");
var $3ZGpZ = parcelRequire("3ZGpZ");
var $dOlbm = parcelRequire("dOlbm");

var $czDw5 = parcelRequire("czDw5");

var $2Etgl = parcelRequire("2Etgl");

var $aHKsU = parcelRequire("aHKsU");

var $eL6w3 = parcelRequire("eL6w3");
var $ea2e0604c60011d3$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "background",
    "onAlign",
    "children",
    "dropTarget",
    "elevation",
    "onClickOutside",
    "onEsc",
    "onKeyDown",
    "overflow",
    "plain",
    "responsive",
    "restrictFocus",
    "stretch",
    "trapFocus"
];
function $ea2e0604c60011d3$var$_extends() {
    return $ea2e0604c60011d3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea2e0604c60011d3$var$_extends.apply(null, arguments);
}
function $ea2e0604c60011d3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// using react synthetic event to be able to stop propagation that
// would otherwise close the layer on ESC.
var $ea2e0604c60011d3$var$preventLayerClose = function preventLayerClose(event) {
    var key = event.keyCode ? event.keyCode : event.which;
    if (key === 27) event.stopPropagation();
};
// Gets the closest ancestor positioned element
var $ea2e0604c60011d3$var$getParentNode = function getParentNode(element) {
    var _element$offsetParent;
    return (_element$offsetParent = element.offsetParent) != null ? _element$offsetParent : element.parentNode;
};
// return the containing block
var $ea2e0604c60011d3$var$getContainingBlock = function getContainingBlock(element) {
    var currentNode = $ea2e0604c60011d3$var$getParentNode(element);
    while(currentNode instanceof window.HTMLElement && ![
        'html',
        'body'
    ].includes(currentNode.nodeName.toLowerCase())){
        var _currentNode;
        var css = window.getComputedStyle(currentNode);
        // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if ((css.transform ? css.transform !== 'none' : false) || (css.perspective ? css.perspective !== 'none' : false) || (css.backdropFilter ? css.backdropFilter !== 'none' : false) || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].includes(css.willChange) || css.willChange === 'filter' || (css.filter ? css.filter !== 'none' : false)) return currentNode;
        currentNode = (_currentNode = currentNode) == null ? void 0 : _currentNode.parentNode;
    }
    return null;
};
var $ea2e0604c60011d3$var$defaultAlign = {
    top: 'top',
    left: 'left'
};
var $ea2e0604c60011d3$export$aabdb120602c28c3 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? $ea2e0604c60011d3$var$defaultAlign : _ref$align, background = _ref.background, onAlign = _ref.onAlign, children = _ref.children, dropTarget = _ref.dropTarget, elevation = _ref.elevation, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, onKeyDown = _ref.onKeyDown, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow, plain = _ref.plain, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, restrictFocus = _ref.restrictFocus, _ref$stretch = _ref.stretch, stretch = _ref$stretch === void 0 ? 'width' : _ref$stretch, trapFocus = _ref.trapFocus, rest = $ea2e0604c60011d3$var$_objectWithoutPropertiesLoose(_ref, $ea2e0604c60011d3$var$_excluded);
    var containerTarget = (0, $2NacA.useContext)((0, $cBNWv.ContainerTargetContext));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // dropOptions was created to preserve backwards compatibility
    var _useContext = (0, $2NacA.useContext)((0, $aHKsU.OptionsContext)), dropOptions = _useContext.drop;
    var portalContext = (0, $2NacA.useContext)((0, $3ZGpZ.PortalContext));
    var portalId = (0, $2NacA.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, $2NacA.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var dropRef = (0, $dOlbm.useForwardedRef)(ref);
    (0, $2NacA.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null) clickedPortalId = parseInt(attr, 10);
                node = node.parentNode;
            }
            // Check if the click happened within the dropTarget
            var clickInsideDropTarget = (dropTarget == null ? void 0 : dropTarget.current) && dropTarget.current.contains(event.target) || dropTarget && typeof dropTarget.contains === 'function' && dropTarget.contains(event.target);
            if (!clickInsideDropTarget && clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) onClickOutside(event);
        };
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        onClickOutside,
        containerTarget,
        portalContext,
        dropTarget
    ]);
    (0, $2NacA.useEffect)(function() {
        var target = (dropTarget == null ? void 0 : dropTarget.current) || dropTarget;
        var notifyAlign = function notifyAlign() {
            var _dropRef$current;
            var styleCurrent = dropRef == null || (_dropRef$current = dropRef.current) == null ? void 0 : _dropRef$current.style;
            var alignControl = (styleCurrent == null ? void 0 : styleCurrent.top) !== '' ? 'top' : 'bottom';
            onAlign(alignControl);
        };
        // We try to preserve the maxHeight as changing it causes any scroll
        // position to be lost. We set the maxHeight on mount and if the window
        // is resized.
        var place = function place(preserveHeight) {
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var container = dropRef.current;
            if (container && target) {
                var _containingBlockRect$, _containingBlockRect, _containingBlockRect$2, _containingBlockRect2, _containingBlockRect$3, _containingBlockRect3, _containingBlock$scro, _containingBlock2, _containingBlock$scro2, _containingBlock3;
                // clear prior styling
                container.style.left = '';
                container.style.top = '';
                container.style.bottom = '';
                container.style.width = '';
                if (!preserveHeight) container.style.maxHeight = '';
                // get bounds
                var targetRect = target.getBoundingClientRect();
                var containerRect = container.getBoundingClientRect();
                // determine width
                var width;
                if (stretch) width = Math.min(stretch === 'align' ? Math.min(targetRect.width, containerRect.width) : Math.max(targetRect.width, containerRect.width), windowWidth);
                else width = Math.min(containerRect.width, windowWidth);
                // set left position
                var left;
                if (align.left) {
                    if (align.left === 'left') left = targetRect.left;
                    else if (align.left === 'right') left = targetRect.left + targetRect.width;
                } else if (align.right) {
                    if (align.right === 'left') left = targetRect.left - width;
                    else if (align.right === 'right') left = targetRect.left + targetRect.width - width;
                } else left = targetRect.left + targetRect.width / 2 - width / 2;
                if (left + width > windowWidth) left -= left + width - windowWidth;
                else if (left < 0) left = 0;
                // set top or bottom position
                var top;
                var bottom;
                var maxHeight = containerRect.height;
                /* If responsive is true and the Drop doesn't have enough room
          to be fully visible and there is more room in the other
          direction, change the Drop to display above/below. If neither
          direction has enough room for the full Drop, prefer the side
          with more available space rather than clamping to the side
          originally requested. */ if (responsive && // drop is above target
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // there is room to display the drop below the target
                targetRect.bottom + containerRect.height < windowHeight) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to top of target
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target.
                targetRect.top + containerRect.height > targetRect.bottom && // there is room to display the drop above the target
                targetRect.bottom - containerRect.height > 0) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to bottom of target
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // there is room to display the drop above the target
                targetRect.top - containerRect.height > 0) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to bottom of target
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target.
                targetRect.bottom - containerRect.height > targetRect.top && // there is room to display the drop below the target
                targetRect.top + containerRect.height > 0) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // top of drop is aligned to bottom of target (open below)
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // the flip anchor (target's top) is on-screen — otherwise
                // flipping pins the drop's bottom off-screen
                targetRect.top > 0 && // there is more room above the target than below it — neither
                // side fits the full drop, so prefer the larger side rather
                // than clamping to the smaller requested side.
                targetRect.top > windowHeight - targetRect.bottom) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // top of drop is aligned to top of target (open below)
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target — otherwise the
                // drop already fits inside the target's vertical span and a
                // flip would pin its bottom to a potentially off-screen
                // target.bottom (mirrors the safety in branch #2 above).
                targetRect.top + containerRect.height > targetRect.bottom && // there is more room above the target than below it
                targetRect.bottom > windowHeight - targetRect.top) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to top of target (open above)
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // the flip anchor (target's bottom) is on-screen
                targetRect.bottom < windowHeight && // there is more room below the target than above it
                windowHeight - targetRect.bottom > targetRect.top) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (responsive && // bottom of drop is aligned to bottom of target (open above)
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target (mirrors the
                // safety in branch #4 above)
                targetRect.bottom - containerRect.height < targetRect.top && // there is more room below the target than above it
                windowHeight - targetRect.top > targetRect.bottom) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'top') {
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'bottom') {
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (align.bottom === 'top') {
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (align.bottom === 'bottom') {
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else top = targetRect.top + targetRect.height / 2 - containerRect.height / 2;
                var containingBlock;
                var containingBlockRect;
                // dropOptions was created to preserve backwards compatibility
                if (dropOptions != null && dropOptions.checkContainingBlock) {
                    var _containingBlock;
                    // return the containing block for absolute elements or `null`
                    // for fixed elements
                    containingBlock = $ea2e0604c60011d3$var$getContainingBlock(container);
                    containingBlockRect = (_containingBlock = containingBlock) == null ? void 0 : _containingBlock.getBoundingClientRect();
                }
                // compute viewport offsets
                var viewportOffsetLeft = (_containingBlockRect$ = (_containingBlockRect = containingBlockRect) == null ? void 0 : _containingBlockRect.left) != null ? _containingBlockRect$ : 0;
                var viewportOffsetTop = (_containingBlockRect$2 = (_containingBlockRect2 = containingBlockRect) == null ? void 0 : _containingBlockRect2.top) != null ? _containingBlockRect$2 : 0;
                var viewportOffsetBottom = (_containingBlockRect$3 = (_containingBlockRect3 = containingBlockRect) == null ? void 0 : _containingBlockRect3.bottom) != null ? _containingBlockRect$3 : windowHeight;
                var containerOffsetLeft = (_containingBlock$scro = (_containingBlock2 = containingBlock) == null ? void 0 : _containingBlock2.scrollLeft) != null ? _containingBlock$scro : 0;
                var containerOffsetTop = (_containingBlock$scro2 = (_containingBlock3 = containingBlock) == null ? void 0 : _containingBlock3.scrollTop) != null ? _containingBlock$scro2 : 0;
                container.style.left = left - viewportOffsetLeft + containerOffsetLeft + "px";
                if (stretch) // offset width by 0.1 to avoid a bug in ie11 that
                // unnecessarily wraps the text if width is the same
                // NOTE: turned off for now
                container.style.width = width + 0.1 + "px";
                // the (position:absolute + scrollTop)
                // is presenting issues with desktop scroll flickering
                if (top !== '') container.style.top = top - viewportOffsetTop + containerOffsetTop + "px";
                if (bottom !== '') container.style.bottom = viewportOffsetBottom - bottom - containerOffsetTop + "px";
                if (!preserveHeight) {
                    if (theme.drop && theme.drop.maxHeight) maxHeight = Math.min(maxHeight, (0, $fzxBh.parseMetricToNum)(theme.drop.maxHeight));
                    container.style.maxHeight = maxHeight + "px";
                }
            }
            if (onAlign) notifyAlign();
        };
        var scrollParents;
        var addScrollListeners = function addScrollListeners() {
            scrollParents = (0, $cDMMY.findScrollParents)(target);
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.addEventListener('scroll', place);
            });
        };
        var removeScrollListeners = function removeScrollListeners() {
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.removeEventListener('scroll', place);
            });
            scrollParents = [];
        };
        var onResize = function onResize() {
            removeScrollListeners();
            addScrollListeners();
            place(false);
        };
        addScrollListeners();
        window.addEventListener('resize', onResize);
        place(false);
        return function() {
            removeScrollListeners();
            window.removeEventListener('resize', onResize);
        };
    }, [
        align,
        containerTarget,
        onAlign,
        dropTarget,
        portalContext,
        portalId,
        responsive,
        restrictFocus,
        stretch,
        theme.drop,
        dropRef,
        dropOptions
    ]);
    // Once drop is open the focus will be put on the drop container
    // if restrictFocus is true. If the caller put focus
    // on an element already, we honor that. Otherwise, we put
    // the focus on the drop container.
    (0, $2NacA.useEffect)(function() {
        if (restrictFocus) {
            var dropContainer = dropRef.current;
            if (dropContainer) {
                if (!dropContainer.contains(document.activeElement)) dropContainer.focus();
            }
        }
    }, [
        dropRef,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2Etgl.StyledDrop), $ea2e0604c60011d3$var$_extends({
        "aria-label": a11yTitle || ariaLabel,
        ref: dropRef,
        background: background,
        plain: plain,
        elevation: !plain ? elevation || theme.global.drop.elevation || theme.global.drop.shadowSize || // backward compatibility
        'small' : undefined,
        tabIndex: "-1",
        alignProp: align,
        overflow: overflow,
        "data-g-portal-id": portalId
    }, passThemeFlag, rest), children);
    var themeContextValue = (0, $2NacA.useMemo)(function() {
        var dark;
        if (background || theme.global.drop.background) dark = (0, $jQHd2.backgroundIsDark)(background || theme.global.drop.background, theme);
        return $ea2e0604c60011d3$var$_extends({}, theme, {
            dark: dark
        });
    }, [
        background,
        theme
    ]);
    var dark = themeContextValue.dark;
    if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f5efw.ThemeContext).Provider, {
        value: themeContextValue
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $3ZGpZ.PortalContext).Provider, {
        value: nextPortalContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hKfeK.FocusedContainer), {
        onKeyDown: onEsc && $ea2e0604c60011d3$var$preventLayerClose,
        trapFocus: trapFocus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        capture: true,
        onEsc: onEsc ? function(event) {
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        onKeyDown: onKeyDown,
        target: "document"
    }, content)));
});

});
parcelRegister("cBNWv", function(module, exports) {

$parcel$export(module.exports, "ContainerTargetContext", () => $025e724b9adbbdba$export$64a849364cd772b4);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $025e724b9adbbdba$export$64a849364cd772b4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(typeof document === 'object' ? document.body : undefined);

});

parcelRegister("hKfeK", function(module, exports) {

$parcel$export(module.exports, "FocusedContainer", () => $ceb28d45f65290dd$export$b0cd6833c93fb94d);

var $2NacA = parcelRequire("2NacA");

var $cDMMY = parcelRequire("cDMMY");

var $3ta7b = parcelRequire("3ta7b");
var $ceb28d45f65290dd$var$_excluded = [
    "hidden",
    "restrictScroll",
    "children",
    "trapFocus"
];
function $ceb28d45f65290dd$var$_extends() {
    return $ceb28d45f65290dd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ceb28d45f65290dd$var$_extends.apply(null, arguments);
}
function $ceb28d45f65290dd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ceb28d45f65290dd$var$isFocusable = function isFocusable(element) {
    if ((element == null ? void 0 : element.tabIndex) < 0 || element != null && element.disabled) return false;
    switch(element == null ? void 0 : element.nodeName){
        case 'A':
            return !!element.href && element.rel !== 'ignore';
        case 'INPUT':
            return element.type !== 'hidden';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        case 'DIV':
            return element.tabIndex >= 0;
        default:
            return false;
    }
};
var $ceb28d45f65290dd$export$b0cd6833c93fb94d = function FocusedContainer(_ref) {
    var _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, _ref$restrictScroll = _ref.restrictScroll, restrictScroll = _ref$restrictScroll === void 0 ? false : _ref$restrictScroll, children = _ref.children, trapFocus = _ref.trapFocus, rest = $ceb28d45f65290dd$var$_objectWithoutPropertiesLoose(_ref, $ceb28d45f65290dd$var$_excluded);
    var _useState = (0, $2NacA.useState)(''), bodyOverflowStyle = _useState[0], setBodyOverflowStyle = _useState[1];
    var ref = (0, $2NacA.useRef)(null);
    var preNodeRef = (0, $2NacA.useRef)(null);
    var postNodeRef = (0, $2NacA.useRef)(null);
    var _useRoots = (0, $3ta7b.useRoots)(), contextValue = _useRoots.contextValue, hasRoots = _useRoots.hasRoots;
    var contextRoots = contextValue.roots;
    // When attemptFocus moves focus around to find the focusable element,
    // set this to true so handleTrapFocus doesn't focus the element.
    var ignoreUtilFocusRef = (0, $2NacA.useRef)(false);
    var lastFocusRef = (0, $2NacA.useRef)(null);
    (0, $2NacA.useEffect)(function() {
        var container = ref.current;
        var roots = contextRoots.current;
        var attemptFocus = function attemptFocus(element) {
            // Check if the element is focusable; if not, return false
            if (!$ceb28d45f65290dd$var$isFocusable(element)) return false;
            ignoreUtilFocusRef.current = true;
            try {
                element.focus();
            } catch (_unused) {
            // continue regardless of error
            }
            ignoreUtilFocusRef.current = false;
            // Return true if the element is currently the active element or has focus
            return document.activeElement === element;
        };
        var _focusFirstDescendant = function focusFirstDescendant(element) {
            // Iterate through all child nodes of the provided element
            for(var i = 0; i < element.childNodes.length; i += 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusFirstDescendant(child)) return true;
            }
            // If no focusable child or descendant was found, return false
            return false;
        };
        var _focusLastDescendant = function focusLastDescendant(element) {
            for(var i = element.childNodes.length - 1; i >= 0; i -= 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusLastDescendant(child)) return true;
            }
            return false;
        };
        var handleTrapFocus = function handleTrapFocus(e) {
            if (!hidden && trapFocus && ignoreUtilFocusRef.current === false && container && // only perform focus if this is the most recently opened drop
            roots[roots.length - 1] === container) {
                if (container.contains(e.target)) lastFocusRef.current = e.target;
                else {
                    _focusFirstDescendant(container);
                    if (lastFocusRef.current === document.activeElement) _focusLastDescendant(container);
                    lastFocusRef.current = document.activeElement;
                }
            }
        };
        // add container to the global roots
        if (container) roots.push(container);
        // Create and insert focusable nodes to help track when focus
        // has left this container but without letting focus be noticeably
        // placed on anything outside the container
        if (!hidden && trapFocus) {
            var preDiv = document.createElement('div');
            var postDiv = document.createElement('div');
            var commonStyles = {
                position: 'absolute',
                height: '1px',
                left: '0',
                right: '0'
            };
            Object.assign(preDiv.style, $ceb28d45f65290dd$var$_extends({}, commonStyles, {
                top: '0'
            }));
            Object.assign(postDiv.style, $ceb28d45f65290dd$var$_extends({}, commonStyles, {
                bottom: '0'
            }));
            preNodeRef.current = container.parentNode.insertBefore(preDiv, container);
            postNodeRef.current = container.parentNode.insertBefore(postDiv, container.nextSibling);
            preNodeRef.current.tabIndex = 0;
            postNodeRef.current.tabIndex = 0;
        }
        document.addEventListener('focus', handleTrapFocus, true);
        return function() {
            var _preNodeRef$current, _postNodeRef$current;
            // remove from global roots array
            if (roots.includes(container)) roots.splice(roots.indexOf(container), 1);
            document.removeEventListener('focus', handleTrapFocus, true);
            if (roots != null && roots[roots.length - 1]) (0, $cDMMY.makeNodeFocusable)(roots[roots.length - 1]);
            preNodeRef == null || (_preNodeRef$current = preNodeRef.current) == null || _preNodeRef$current.remove();
            postNodeRef == null || (_postNodeRef$current = postNodeRef.current) == null || _postNodeRef$current.remove();
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    (0, $2NacA.useEffect)(function() {
        if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) {
            setBodyOverflowStyle(document.body.style.overflow);
            document.body.style.overflow = 'hidden';
        }
        return function() {
            if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) document.body.style.overflow = bodyOverflowStyle;
        };
    }, [
        bodyOverflowStyle,
        hidden,
        trapFocus,
        restrictScroll
    ]);
    (0, $2NacA.useEffect)(function() {
        var roots = contextRoots.current;
        var timer = setTimeout(function() {
            if (!hidden && trapFocus) // make every root before this one unfocusable
            roots == null || roots.forEach(function(root, index) {
                if (index < roots.length - 1) (0, $cDMMY.makeNodeUnfocusable)(root);
            });
        }, 0);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    var focusedContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", $ceb28d45f65290dd$var$_extends({
        ref: ref,
        "aria-hidden": hidden
    }, rest), children);
    if (hasRoots) return focusedContainer;
    return(/*#__PURE__*/ // for cases outside of Grommet React tree, manage trapFocus when
    // Drop/Layer opens another Drop/Layer
    (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $3ta7b.RootsContext).Provider, {
        value: contextValue
    }, focusedContainer));
};

});
parcelRegister("3ta7b", function(module, exports) {

$parcel$export(module.exports, "RootsContext", () => $286bed1ff13fd4d6$export$1eeeeda725eeeda);
$parcel$export(module.exports, "useRoots", () => $286bed1ff13fd4d6$export$79ef40724920756d);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $286bed1ff13fd4d6$export$1eeeeda725eeeda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(undefined);
var $286bed1ff13fd4d6$export$79ef40724920756d = function useRoots() {
    // If FocusedContainer is within Grommet React tree, there will be a value
    // from RootsContext. If not, set up a default value that can be passed
    // to drops that might open from within a drop.
    var defaultRoots = (0, $2NacA.useRef)([]);
    var defaultValue = (0, $2NacA.useMemo)(function() {
        return {
            roots: defaultRoots
        };
    }, []);
    var existingRoots = (0, $2NacA.useContext)($286bed1ff13fd4d6$export$1eeeeda725eeeda);
    return {
        contextValue: existingRoots || defaultValue,
        hasRoots: (existingRoots == null ? void 0 : existingRoots.roots) !== undefined
    };
};

});


parcelRegister("3ZGpZ", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $2e87f8f3b43f2bf1$export$60d741e20e0aa309);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $2e87f8f3b43f2bf1$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext([]);

});

parcelRegister("2Etgl", function(module, exports) {

$parcel$export(module.exports, "StyledDrop", () => $1ee604214111972c$export$b726e6b8eaa2acc7);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $2O6LY = parcelRequire("2O6LY");

var $jQHd2 = parcelRequire("jQHd2");
function $1ee604214111972c$var$getTransformOriginStyle(align) {
    var vertical = 'top';
    if (align.bottom) vertical = 'bottom';
    var horizontal = 'left';
    if (align.right) horizontal = 'right';
    return vertical + " " + horizontal;
}
var $1ee604214111972c$var$dropKeyFrames = (0, $f5efw.keyframes)([
    "0%{opacity:0.5;transform:scale(0.8);}100%{opacity:1;transform:scale(1);}"
]);
// The desired margin may be adjusted depending on drops alignment
var $1ee604214111972c$var$marginStyle = function marginStyle(theme, align, data, responsive, marginProp) {
    // NOTE: If marginProp is passed, it overrides the alignment-aware
    //  margin logic and uses the provided value instead.
    var margin = theme.global.edgeSize[data] || data;
    var adjustedMargin = {};
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = typeof margin === 'string' && margin.split(' ').length > 1;
    if (theme.global.drop.intelligentMargin === true && !customCSS && typeof margin === 'string') {
        if (align.top === 'bottom') adjustedMargin.top = margin;
        else if (align.bottom === 'top') adjustedMargin.bottom = margin;
        if (align.right === 'left') adjustedMargin.left = "-" + margin;
        else if (align.left === 'right') adjustedMargin.left = margin;
        if (!Object.keys(adjustedMargin)) adjustedMargin = 'none';
    } else return (0, $2O6LY.edgeStyle)('margin', marginProp || theme.global.drop.margin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
    return (0, $2O6LY.edgeStyle)('margin', marginProp || adjustedMargin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
};
var $1ee604214111972c$export$b726e6b8eaa2acc7 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledDrop",
    componentId: "sc-16s5rx8-0"
})([
    "",
    " ",
    " position:fixed;z-index:",
    ";outline:none;",
    " ",
    " opacity:0;transform-origin:",
    ";animation:",
    " 0.1s forwards;animation-delay:0.01s;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){display:flex;align-items:stretch;}",
    ""
], (0, $2O6LY.baseStyle), function(props) {
    return !props.plain && (props.round && (0, $2O6LY.roundStyle)(props.round, props.responsive || true, props.theme) || "border-radius: " + props.theme.global.drop.border.radius + ";");
}, function(props) {
    return props.theme.global.drop.zIndex;
}, function(props) {
    return !props.plain && (0, $jQHd2.backgroundStyle)(props.background || props.theme.global.drop.background, props.theme);
}, function(props) {
    return !props.plain && (props.margin || props.theme.global.drop.margin) && props.theme.global && $1ee604214111972c$var$marginStyle(props.theme, props.alignProp, props.theme.global.drop.margin, props.responsive, props.margin);
}, function(props) {
    return $1ee604214111972c$var$getTransformOriginStyle(props.alignProp);
}, $1ee604214111972c$var$dropKeyFrames, function(props) {
    return props.theme.global.drop && props.theme.global.drop.extend;
});

});


parcelRegister("3OZRo", function(module, exports) {

$parcel$export(module.exports, "DropPropTypes", () => $2c8606be7ccfc8b8$export$9863f458227ea225);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $lwlwr = parcelRequire("lwlwr");

var $2p9yA = parcelRequire("2p9yA");
// if you update values here, make sure to update in Box too.
var $2c8606be7ccfc8b8$var$dropOverflowPropTypes = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf((0, $2p9yA.OVERFLOW_VALUES)),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf((0, $2p9yA.OVERFLOW_VALUES)),
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf((0, $2p9yA.OVERFLOW_VALUES))
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
]);
var $2c8606be7ccfc8b8$var$PropType = {};
var $2c8606be7ccfc8b8$export$9863f458227ea225 = $2c8606be7ccfc8b8$var$PropType;

});


parcelRegister("hp4MM", function(module, exports) {

$parcel$export(module.exports, "useKeyboard", () => $cab87bd630015b45$export$8f71654801c2f7cd);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $cab87bd630015b45$export$8f71654801c2f7cd = function useKeyboard() {
    var _useState = (0, $2NacA.useState)(), usingKeyboard = _useState[0], setUsingKeyboard = _useState[1];
    (0, $2NacA.useEffect)(function() {
        var onMouseDown = function onMouseDown() {
            return setUsingKeyboard(false);
        };
        var onKeyDown = function onKeyDown() {
            return setUsingKeyboard(true);
        };
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown', onKeyDown);
        return function() {
            document.removeEventListener('mousedown', onMouseDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return usingKeyboard;
};
var $cab87bd630015b45$export$2e2bcd8739ae039 = $cab87bd630015b45$export$8f71654801c2f7cd;

});

parcelRegister("gOUAw", function(module, exports) {

$parcel$export(module.exports, "TipPropTypes", () => $c3ed361504eb10d1$export$475ce0081ee75899);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $c3ed361504eb10d1$var$PropType = {};
var $c3ed361504eb10d1$export$475ce0081ee75899 = $c3ed361504eb10d1$var$PropType;

});


parcelRegister("ls1zK", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $f9dd6f616ff8bec4$export$37acb3580601e69a);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $fzxBh = parcelRequire("fzxBh");

var $hHZ58 = parcelRequire("hHZ58");

var $5xcHk = parcelRequire("5xcHk");

var $1h240 = parcelRequire("1h240");

var $kS7Ii = parcelRequire("kS7Ii");

var $eL6w3 = parcelRequire("eL6w3");
function $f9dd6f616ff8bec4$var$_extends() {
    return $f9dd6f616ff8bec4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f9dd6f616ff8bec4$var$_extends.apply(null, arguments);
}
var $f9dd6f616ff8bec4$var$StyledBadgeContainer = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "Badge__StyledBadgeContainer",
    componentId: "sc-1es4ws1-0"
})([
    "",
    ""
], function(props) {
    return props.theme.button.badge.container.extend;
});
var $f9dd6f616ff8bec4$export$37acb3580601e69a = function Badge(_ref) {
    var children = _ref.children, content = _ref.content;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var containerRef = (0, $2NacA.useRef)();
    var contentRef = (0, $2NacA.useRef)();
    var stackRef = (0, $2NacA.useRef)();
    var defaultBadgeDimension = typeof content === 'boolean' || content && content.value && typeof content.value === 'boolean' ? // after experimenting with various values
    (0, $fzxBh.parseMetricToNum)(theme.button.badge.size.medium) / 2 + "px" : theme.button.badge.size.medium;
    // scale badge to fit its contents, leaving space horizontally
    // that is proportional to vertical space
    (0, $hHZ58.useLayoutEffect)(function() {
        // when window resizes and hits a responsive breakpoint, width of the badge
        // can change (because pad is responsive, etc.). we want to recalculate
        // width since badge offset is reliant on its dimensions.
        var onResize = function onResize() {
            if (containerRef != null && containerRef.current) {
                containerRef.current.style.minHeight = '';
                containerRef.current.style.minWidth = '';
                if (contentRef != null && contentRef.current) {
                    if (typeof content === 'number' || typeof content === 'object' && content.value) {
                        containerRef.current.style.minHeight = defaultBadgeDimension;
                        containerRef.current.style.minWidth = defaultBadgeDimension;
                        var _contentRef$current$g = contentRef.current.getBoundingClientRect(), contentHeight = _contentRef$current$g.height, contentWidth = _contentRef$current$g.width;
                        // only adjust the width if contentHeight > 0
                        // jest returns 0 for all getBoundingClientRect values,
                        // so this ensures snapshots are closer to correct values
                        if (contentHeight) {
                            // height of content includes extra space around font from
                            // line-height. account for this extra space with 2.5 multiplier
                            // to add proportional horizontal space
                            var height = defaultBadgeDimension;
                            var width = defaultBadgeDimension;
                            var verticalSpace = ((0, $fzxBh.parseMetricToNum)(height) - contentHeight) * 2.5;
                            containerRef.current.style.minHeight = height;
                            containerRef.current.style.minWidth = Math.max((0, $fzxBh.parseMetricToNum)(width), Math.ceil(contentWidth + verticalSpace)) + "px";
                        }
                    } else {
                        // caller has provided custom JSX
                        containerRef.current.style.minHeight = contentRef.current.getBoundingClientRect().width;
                        containerRef.current.style.minWidth = contentRef.current.getBoundingClientRect().height;
                    }
                } else {
                    containerRef.current.style.minHeight = defaultBadgeDimension;
                    containerRef.current.style.minWidth = defaultBadgeDimension;
                }
            }
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        content,
        defaultBadgeDimension
    ]);
    // offset the badge so it overlaps content
    (0, $hHZ58.useLayoutEffect)(function() {
        if (stackRef != null && stackRef.current) {
            // when badge has content, offset should be 50%.
            // when badge is empty, offset by a smaller amount to keep the badge
            // closer to the content. this value was chosen as a reasonable default
            // after testing with various grommet icons.
            var offset = typeof content === 'boolean' || content && content.value === true ? '25%' : '50%';
            // second child of Stack is the div that receives absolute positioning
            // and contains our badge content
            stackRef.current.children[1].style.top = 0;
            stackRef.current.children[1].style.right = 0;
            // eslint-disable-next-line max-len
            stackRef.current.children[1].style.transform = "translate(" + offset + ", -" + offset + ")";
            stackRef.current.children[1].style.transformOrigin = '100% 0%';
        }
    }, [
        content
    ]);
    var value;
    if (typeof content === 'number') value = content;
    else if (typeof content === 'object') value = content.value;
    var badge;
    if (typeof value === 'number' || typeof value === 'boolean' || typeof content === 'boolean') {
        if (typeof value === 'number') {
            var max = content.max || 9;
            badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), {
                color: "text-strong",
                size: theme.button.badge.text.size.medium,
                weight: "normal",
                ref: contentRef
            }, value > max ? max + "+" : value);
        }
        badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($f9dd6f616ff8bec4$var$StyledBadgeContainer, $f9dd6f616ff8bec4$var$_extends({
            ref: containerRef,
            align: "center",
            background: content.background || theme.button.badge.container.background,
            flex: false,
            justify: "center",
            round: true,
            pad: !(typeof value === 'boolean' || typeof content === 'boolean') ? theme.button.badge.container.pad : undefined
        }, passThemeFlag), badge);
    // caller has provided their own JSX and we will just render that
    } else badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        ref: contentRef
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1h240.Stack), {
        ref: stackRef,
        anchor: "top-right"
    }, children, badge);
};

});
parcelRegister("hHZ58", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $ce45d565693a0b40$export$e5c5a5f917a5871c);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
/* eslint-disable no-restricted-imports */ 
var $2NacA = parcelRequire("2NacA");
var $ce45d565693a0b40$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $2NacA.useLayoutEffect) : (0, $2NacA.useEffect);
var $ce45d565693a0b40$export$2e2bcd8739ae039 = $ce45d565693a0b40$export$e5c5a5f917a5871c;

});

parcelRegister("1h240", function(module, exports) {

$parcel$export(module.exports, "Stack", () => $0ed8fac22b01e354$export$694e0d28c7ffc90c);

var $2NacA = parcelRequire("2NacA");

var $f6cri = parcelRequire("f6cri");

var $dw5m0 = parcelRequire("dw5m0");

var $eL6w3 = parcelRequire("eL6w3");
var $0ed8fac22b01e354$var$_excluded = [
    "anchor",
    "children",
    "fill",
    "guidingChild",
    "interactiveChild"
];
function $0ed8fac22b01e354$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0ed8fac22b01e354$var$_extends() {
    return $0ed8fac22b01e354$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0ed8fac22b01e354$var$_extends.apply(null, arguments);
}
var $0ed8fac22b01e354$var$buildStyledChildren = function buildStyledChildren(_ref) {
    var anchor = _ref.anchor, fill = _ref.fill, guidingIndex = _ref.guidingIndex, interactiveChild = _ref.interactiveChild, interactiveIndex = _ref.interactiveIndex;
    return function(child, index) {
        var interactive = interactiveChild === undefined || interactiveIndex === index;
        var isGuidingIndex = index === guidingIndex;
        var props = isGuidingIndex ? {
            guiding: true,
            fillContainer: fill
        } : {
            anchor: anchor
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f6cri.StyledStackLayer), $0ed8fac22b01e354$var$_extends({
            key: index,
            interactive: interactive
        }, props), child);
    };
};
var $0ed8fac22b01e354$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref2, ref) {
    var anchor = _ref2.anchor, children = _ref2.children, fill = _ref2.fill, guidingChild = _ref2.guidingChild, interactiveChild = _ref2.interactiveChild, rest = $0ed8fac22b01e354$var$_objectWithoutPropertiesLoose(_ref2, $0ed8fac22b01e354$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var prunedChildren = (0, $2NacA.Children).toArray(children).filter(function(c) {
        return c;
    });
    var toChildIndex = function toChildIndex(child) {
        var index = child;
        if (index === 'first' || !index) index = 0;
        else if (index === 'last') index = prunedChildren.length - 1;
        return index;
    };
    var guidingIndex = toChildIndex(guidingChild);
    var interactiveIndex = interactiveChild && toChildIndex(interactiveChild);
    var styledChildren = prunedChildren.map($0ed8fac22b01e354$var$buildStyledChildren({
        anchor: anchor,
        fill: fill,
        guidingIndex: guidingIndex,
        interactiveChild: interactiveChild,
        interactiveIndex: interactiveIndex
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f6cri.StyledStack), $0ed8fac22b01e354$var$_extends({
        ref: ref,
        fillContainer: fill
    }, passThemeFlag, rest), styledChildren);
});
$0ed8fac22b01e354$export$694e0d28c7ffc90c.displayName = 'Stack';
$0ed8fac22b01e354$export$694e0d28c7ffc90c.propTypes = (0, $dw5m0.StackPropTypes);

});
parcelRegister("f6cri", function(module, exports) {

$parcel$export(module.exports, "StyledStack", () => $afe110c0e466dc08$export$8a7fb03b17c12e52);
$parcel$export(module.exports, "StyledStackLayer", () => $afe110c0e466dc08$export$5946a5a83aaaa916);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $afe110c0e466dc08$var$fillStyle = (0, $f5efw.css)([
    "",
    " ",
    " flex-grow:1;display:flex;"
], function(props) {
    return props.fillContainer === true || props.fillContainer === 'horizontal' ? "\n        width: 100%;\n        max-width: none;\n      " : '';
}, function(props) {
    return props.fillContainer === true || props.fillContainer === 'vertical' ? 'height: 100%;' : '';
});
var $afe110c0e466dc08$export$8a7fb03b17c12e52 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledStack",
    componentId: "sc-ajspsk-0"
})([
    "position:relative;",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return props.fillContainer && $afe110c0e466dc08$var$fillStyle;
}, function(props) {
    return props.theme.stack && props.theme.stack.extend;
});
var $afe110c0e466dc08$var$styleMap = {
    fill: "\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ",
    center: "\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ",
    left: "\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  ",
    right: "\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  ",
    top: "\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    bottom: "\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    'top-left': "\n    top: 0;\n    left: 0;\n  ",
    'bottom-left': "\n    bottom: 0;\n    left: 0;\n  ",
    'top-right': "\n    top: 0;\n    right: 0;\n  ",
    'bottom-right': "\n    bottom: 0;\n    right: 0;\n  "
};
var $afe110c0e466dc08$export$5946a5a83aaaa916 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledStack__StyledStackLayer",
    componentId: "sc-ajspsk-1"
})([
    "position:",
    ";",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.guiding ? 'relative' : 'absolute';
}, function(props) {
    return props.guiding && 'display: block;';
}, function(props) {
    return !props.guiding && $afe110c0e466dc08$var$styleMap[props.anchor || 'fill'] + ";";
}, function(props) {
    return props.fillContainer && "\n    width: 100%;\n    height: 100%;\n  ";
}, function(props) {
    return !props.interactive && "pointer-events: none;";
});

});

parcelRegister("dw5m0", function(module, exports) {

$parcel$export(module.exports, "StackPropTypes", () => $9d726aae55e9284b$export$ae929f3c1850d7bc);


function $9d726aae55e9284b$var$_extends() {
    return $9d726aae55e9284b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9d726aae55e9284b$var$_extends.apply(null, arguments);
}
var $9d726aae55e9284b$var$PropType = {};
var $9d726aae55e9284b$export$ae929f3c1850d7bc = $9d726aae55e9284b$var$PropType;

});


parcelRegister("kS7Ii", function(module, exports) {

$parcel$export(module.exports, "Text", () => $f31ed5805eb6dfea$export$5f1af8db9871e1d6);

var $2NacA = parcelRequire("2NacA");

var $hHZ58 = parcelRequire("hHZ58");

var $9Pgqi = parcelRequire("9Pgqi");

var $79HTA = parcelRequire("79HTA");

var $dOlbm = parcelRequire("dOlbm");

var $69tH4 = parcelRequire("69tH4");

var $4ZVSM = parcelRequire("4ZVSM");

var $3XzNv = parcelRequire("3XzNv");

var $8QB4u = parcelRequire("8QB4u");

var $eL6w3 = parcelRequire("eL6w3");
var $f31ed5805eb6dfea$var$_excluded = [
    "children",
    "color",
    "tag",
    "as",
    "tip",
    "a11yTitle",
    "truncate",
    "size",
    "skeleton",
    "level"
];
function $f31ed5805eb6dfea$var$_extends() {
    return $f31ed5805eb6dfea$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f31ed5805eb6dfea$var$_extends.apply(null, arguments);
}
function $f31ed5805eb6dfea$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f31ed5805eb6dfea$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, tag = _ref.tag, as = _ref.as, tipProp = _ref.tip, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tipProp === 'string' && tipProp || (tipProp == null ? void 0 : tipProp.content) || undefined : _ref$a11yTitle, truncate = _ref.truncate, size = _ref.size, skeletonProp = _ref.skeleton, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, rest = $f31ed5805eb6dfea$var$_objectWithoutPropertiesLoose(_ref, $f31ed5805eb6dfea$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var textRef = (0, $dOlbm.useForwardedRef)(ref);
    var _useState = (0, $2NacA.useState)(false), textTruncated = _useState[0], setTextTruncated = _useState[1];
    var textContextValue = (0, $2NacA.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    var skeleton = (0, $4ZVSM.useSkeleton)();
    (0, $hHZ58.useLayoutEffect)(function() {
        var updateTip = function updateTip() {
            setTextTruncated(false);
            if (truncate === 'tip' && textRef.current && textRef.current.scrollWidth > textRef.current.offsetWidth) setTextTruncated(true);
        };
        window.addEventListener('resize', updateTip);
        window.addEventListener('pagechange', updateTip);
        updateTip();
        return function() {
            window.removeEventListener('resize', updateTip);
            window.removeEventListener('pagechange', updateTip);
        };
    }, [
        textRef,
        truncate
    ]);
    if (skeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $3XzNv.TextSkeleton), $f31ed5805eb6dfea$var$_extends({
        ref: ref,
        as: as,
        level: level,
        size: size
    }, skeletonProp, rest));
    var styledTextResult = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $9Pgqi.StyledText), $f31ed5805eb6dfea$var$_extends({
        as: !as && tag ? tag : as,
        colorProp: color,
        "aria-label": a11yTitle,
        level: level,
        truncate: truncate,
        size: size
    }, passThemeFlag, rest, {
        ref: textRef
    }), children !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $8QB4u.TextContext).Provider, {
        value: textContextValue
    }, children) : undefined);
    var tipProps = tipProp && typeof tipProp === 'object' ? tipProp : {};
    if (tipProp || textTruncated) {
        // place the text content in a tip if truncate === 'tip'
        // and the text has been truncated
        if (textTruncated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $79HTA.Tip), $f31ed5805eb6dfea$var$_extends({
            content: children
        }, tipProps), styledTextResult);
        // place the text content in a tip if truncate !== 'tip'
        // it displays even if the text has not truncated
        if (truncate !== 'tip') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $79HTA.Tip), tipProps, styledTextResult);
    }
    return styledTextResult;
});
$f31ed5805eb6dfea$export$5f1af8db9871e1d6.displayName = 'Text';
$f31ed5805eb6dfea$export$5f1af8db9871e1d6.propTypes = (0, $69tH4.TextPropTypes);

});
parcelRegister("9Pgqi", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $72759dbff9c911d0$export$31ea92f3997410dd);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");
var $72759dbff9c911d0$var$sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.text[size];
    if (data) return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:normal;"
    ], size);
};
var $72759dbff9c911d0$var$truncateStyle = "\n  white-space: nowrap;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var $72759dbff9c911d0$var$colorStyle = (0, $f5efw.css)([
    "color:",
    ";"
], function(props) {
    return (0, $d2fh4.normalizeColor)(props.colorProp, props.theme);
});
var $72759dbff9c911d0$var$weightStyle = (0, $f5efw.css)([
    "font-weight:",
    ";"
], function(props) {
    return props.weight;
});
var $72759dbff9c911d0$var$wordBreakStyle = (0, $f5efw.css)([
    "word-break:",
    ";"
], function(props) {
    return props.wordBreak;
});
var $72759dbff9c911d0$var$fontFamily = (0, $f5efw.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.text.font.family;
});
var $72759dbff9c911d0$export$31ea92f3997410dd = (0, $f5efw.default)('span').withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledText",
    componentId: "sc-1sadyjn-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return $72759dbff9c911d0$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, $2O6LY.textAlignStyle);
}, function(props) {
    return props.truncate && $72759dbff9c911d0$var$truncateStyle;
}, function(props) {
    return props.colorProp && $72759dbff9c911d0$var$colorStyle;
}, function(props) {
    return props.weight && $72759dbff9c911d0$var$weightStyle;
}, function(props) {
    return props.wordBreak && $72759dbff9c911d0$var$wordBreakStyle;
}, function(props) {
    return props.theme.text.font && props.theme.text.font.family && $72759dbff9c911d0$var$fontFamily;
}, function(props) {
    return props.theme.text && props.theme.text.extend;
});

});

parcelRegister("69tH4", function(module, exports) {

$parcel$export(module.exports, "TextPropTypes", () => $47aa9de439477ba5$export$da9fd56aa591dacf);


function $47aa9de439477ba5$var$_extends() {
    return $47aa9de439477ba5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $47aa9de439477ba5$var$_extends.apply(null, arguments);
}
var $47aa9de439477ba5$var$PropType = {};
var $47aa9de439477ba5$export$da9fd56aa591dacf = $47aa9de439477ba5$var$PropType;

});

parcelRegister("3XzNv", function(module, exports) {

$parcel$export(module.exports, "TextSkeleton", () => $2e22a669331fb7dc$export$8334ddaea41520f1);

var $2NacA = parcelRequire("2NacA");

var $7bBqH = parcelRequire("7bBqH");

var $eL6w3 = parcelRequire("eL6w3");
var $2e22a669331fb7dc$var$_excluded = [
    "as",
    "size"
];
function $2e22a669331fb7dc$var$_extends() {
    return $2e22a669331fb7dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2e22a669331fb7dc$var$_extends.apply(null, arguments);
}
function $2e22a669331fb7dc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2e22a669331fb7dc$export$8334ddaea41520f1 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var as = _ref.as, sizeProp = _ref.size, rest = $2e22a669331fb7dc$var$_objectWithoutPropertiesLoose(_ref, $2e22a669331fb7dc$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var size = sizeProp || 'medium';
    var data = theme.text[size];
    var height = data ? data.size : sizeProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7bBqH.Skeleton), $2e22a669331fb7dc$var$_extends({
        ref: ref,
        as: as,
        height: height
    }, theme.text.skeleton, rest));
});
$2e22a669331fb7dc$export$8334ddaea41520f1.displayName = 'TextSkeleton';

});
parcelRegister("7bBqH", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $53b6983d00dedcff$export$8f31e4c4a37b8e9c);

var $2NacA = parcelRequire("2NacA");

var $lt5sv = parcelRequire("lt5sv");

var $4ZVSM = parcelRequire("4ZVSM");

var $a4C1h = parcelRequire("a4C1h");

var $eL6w3 = parcelRequire("eL6w3");

var $7wfCm = parcelRequire("7wfCm");
var $53b6983d00dedcff$var$_excluded = [
    "as",
    "colors",
    "width",
    "height",
    "responsive"
];
function $53b6983d00dedcff$var$_extends() {
    return $53b6983d00dedcff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $53b6983d00dedcff$var$_extends.apply(null, arguments);
}
function $53b6983d00dedcff$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $53b6983d00dedcff$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$skeleton;
    var as = _ref.as, colorsProp = _ref.colors, widthProp = _ref.width, heightProp = _ref.height, responsiveProp = _ref.responsive, rest = $53b6983d00dedcff$var$_objectWithoutPropertiesLoose(_ref, $53b6983d00dedcff$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var skeleton = (0, $4ZVSM.useSkeleton)();
    var depth = (skeleton == null ? void 0 : skeleton.depth) || 0;
    var responsiveContainer = (0, $2NacA.useContext)((0, $7wfCm.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var colors = colorsProp || (theme == null || (_theme$skeleton = theme.skeleton) == null ? void 0 : _theme$skeleton.colors);
    var themeColors = colors[theme.dark ? 'dark' : 'light'];
    var background = themeColors[(depth + 1) % themeColors.length];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a4C1h.StyledSkeleton), $53b6983d00dedcff$var$_extends({
        "aria-hidden": "true",
        ref: ref,
        as: as,
        background: background,
        widthProp: widthProp,
        heightProp: heightProp,
        responsive: responsive
    }, passThemeFlag, rest));
});
$53b6983d00dedcff$export$8f31e4c4a37b8e9c.displayName = 'Skeleton';
$53b6983d00dedcff$export$8f31e4c4a37b8e9c.propTypes = (0, $lt5sv.SkeletonPropTypes);

});
parcelRegister("lt5sv", function(module, exports) {

$parcel$export(module.exports, "SkeletonPropTypes", () => $fa108a66792f2fb1$export$6c09f2c2b39894c);


function $fa108a66792f2fb1$var$_extends() {
    return $fa108a66792f2fb1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fa108a66792f2fb1$var$_extends.apply(null, arguments);
}
var $fa108a66792f2fb1$var$PropType = {};
var $fa108a66792f2fb1$export$6c09f2c2b39894c = $fa108a66792f2fb1$var$PropType;

});

parcelRegister("a4C1h", function(module, exports) {

$parcel$export(module.exports, "StyledSkeleton", () => $7557c5049dce54aa$export$e4ecddc59e33f387);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");
var $2O6LY = parcelRequire("2O6LY");

var $fzxBh = parcelRequire("fzxBh");
var $7557c5049dce54aa$export$e4ecddc59e33f387 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledSkeleton",
    componentId: "sc-1omqm6u-0"
})([
    "display:flex;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return props.background && (0, $jQHd2.backgroundStyle)(props.background, props.theme);
}, function(props) {
    var _props$theme$text;
    return (0, $2O6LY.heightStyle)(props.heightProp || ((_props$theme$text = props.theme.text) == null || (_props$theme$text = _props$theme$text.medium) == null ? void 0 : _props$theme$text.height), props.theme);
}, function(props) {
    return (0, $2O6LY.widthStyle)(props.widthProp || '100%', props.theme);
}, function(props) {
    return props.pad && (0, $2O6LY.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, $2O6LY.roundStyle)(props.round, props.responsive, props.theme);
}, function(props) {
    var _props$theme;
    return (_props$theme = props.theme) == null || (_props$theme = _props$theme.skeleton) == null ? void 0 : _props$theme.extend;
}, function(props) {
    return props.responsiveSize && (0, $fzxBh.breakpointStyle)(props.responsiveSize.breakpoint, (0, $2O6LY.heightStyle)(props.responsiveSize.height, props.theme), props.responsive);
});

});





parcelRegister("jvf4K", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $e32c9b3f844d806e$export$2d5d2ba3c7c8c40b);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");
var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");

var $2O6LY = parcelRequire("2O6LY");
var $e32c9b3f844d806e$var$radiusStyle = function radiusStyle(props) {
    // border.radius shouldn't impact an only-icon rendering.
    var isIconOnly = props.hasIcon && !props.hasLabel;
    var size = props.sizeProp;
    if (!isIconOnly && size && props.theme.button.size && props.theme.button.size[size]) return props.theme.button.size[size].border.radius;
    return props.theme.button.border.radius;
};
var $e32c9b3f844d806e$var$fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $e32c9b3f844d806e$var$padStyle = function padStyle(props) {
    var size = props.sizeProp;
    if (size && props.theme.button.size && props.theme.button.size[size]) return (0, $f5efw.css)([
        "",
        " ",
        ""
    ], props.theme.button.size[size].pad.vertical, props.theme.button.size[size].pad.horizontal);
    return (0, $f5efw.css)([
        "",
        " ",
        ""
    ], props.theme.button.padding.vertical, props.theme.button.padding.horizontal);
};
var $e32c9b3f844d806e$var$basicStyle = function basicStyle(props) {
    return (0, $f5efw.css)([
        "border:",
        " solid ",
        ";border-radius:",
        ";",
        " color:",
        ";padding:",
        ";",
        ""
    ], props.theme.button.border.width, (0, $d2fh4.normalizeColor)(props.colorValue || props.theme.button.border.color || 'control', props.theme), $e32c9b3f844d806e$var$radiusStyle(props), props.theme.button.elevation && (0, $2O6LY.elevationStyle)(props.theme.button.elevation), (0, $d2fh4.normalizeColor)(props.theme.button.color || 'text', props.theme), $e32c9b3f844d806e$var$padStyle(props), $e32c9b3f844d806e$var$fontStyle(props));
};
var $e32c9b3f844d806e$var$primaryStyle = function primaryStyle(props) {
    var _props$theme$button$p, _props$theme$button$p2;
    return (0, $f5efw.css)([
        "",
        " border-radius:",
        ";",
        " ",
        ""
    ], (0, $jQHd2.backgroundStyle)((0, $d2fh4.normalizeColor)(props.colorValue || props.theme.button.primary && props.theme.button.primary.color || 'control', props.theme), props.theme, props.theme.button.color), $e32c9b3f844d806e$var$radiusStyle(props), ((_props$theme$button$p = props.theme.button.primary) == null ? void 0 : _props$theme$button$p.elevation) && (0, $2O6LY.elevationStyle)((_props$theme$button$p2 = props.theme.button.primary) == null ? void 0 : _props$theme$button$p2.elevation), props.theme.button.primary && props.theme.button.primary.extend);
};
function $e32c9b3f844d806e$var$getHoverColor(props) {
    if (props.colorValue) return (0, $d2fh4.normalizeColor)(props.colorValue, props.theme);
    if (props.active && props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color) return (0, $d2fh4.normalizeColor)(props.theme.button.primary.active.border.color, props.theme);
    return (0, $d2fh4.normalizeColor)(props.theme.button.border.color || 'control', props.theme);
}
var $e32c9b3f844d806e$var$hoverStyle = (0, $f5efw.css)([
    "&:hover{",
    " ",
    ";}"
], function(props) {
    return props.hoverIndicator && (0, $jQHd2.getHoverIndicatorStyle)(props.hoverIndicator, props.theme);
}, function(props) {
    return !props.plain && (0, $f5efw.css)([
        "box-shadow:0px 0px 0px 2px ",
        ";"
    ], $e32c9b3f844d806e$var$getHoverColor(props));
});
var $e32c9b3f844d806e$var$fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var $e32c9b3f844d806e$var$plainStyle = function plainStyle(props) {
    return (0, $f5efw.css)([
        "color:",
        ";outline:none;border:none;padding:0;text-align:inherit;"
    ], (0, $d2fh4.normalizeColor)(props.colorValue || 'inherit', props.theme));
};
var $e32c9b3f844d806e$var$activeButtonStyle = function activeButtonStyle(props) {
    return (0, $f5efw.css)([
        "",
        " ",
        " ",
        ""
    ], (0, $jQHd2.activeStyle), props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, $d2fh4.normalizeColor)(props.theme.button.primary.active.border.color, props.theme) + ";\n    ", props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.extend);
};
var $e32c9b3f844d806e$var$disabledButtonStyle = function disabledButtonStyle(props) {
    return (0, $f5efw.css)([
        "",
        " ",
        " ",
        " ",
        ""
    ], (0, $2O6LY.disabledStyle)(props.theme.button.disabled.opacity), !props.plain && props.theme.button.disabled.border && props.theme.button.disabled.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, $d2fh4.normalizeColor)(props.theme.button.disabled.border.color, props.theme) + ";", props.theme.button.disabled.color && // if primary button, apply disabled color to background. otherwise,
    // apply disabled color to the label
    (props.primary ? (0, $jQHd2.backgroundStyle)((0, $d2fh4.normalizeColor)(props.theme.button.disabled.color, props.theme), props.theme, props.theme.button.color) : "color: " + (0, $d2fh4.normalizeColor)(props.theme.button.disabled.color, props.theme) + ";"), props.theme.button.disabled && props.theme.button.disabled.extend);
};
// Deprecate props.theme.button.disabled.opacity in V3
var $e32c9b3f844d806e$export$2d5d2ba3c7c8c40b = (0, $f5efw.default).button.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledButton",
    componentId: "sc-323bzc-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return props.plain && $e32c9b3f844d806e$var$plainStyle(props);
}, function(props) {
    return !props.plain && $e32c9b3f844d806e$var$basicStyle(props);
}, function(props) {
    return props.primary && $e32c9b3f844d806e$var$primaryStyle(props);
}, function(props) {
    return !props.disabled && !props.selected && !props.focus && !props.busy && !props.success && $e32c9b3f844d806e$var$hoverStyle;
}, function(props) {
    return !props.disabled && props.active && $e32c9b3f844d806e$var$activeButtonStyle(props);
}, function(props) {
    return props.disabled && props.theme.button && props.theme.button.disabled && $e32c9b3f844d806e$var$disabledButtonStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, $2O6LY.focusStyle)({
        inset: props.focusIndicator === 'inset'
    });
}, (0, $2O6LY.unfocusStyle)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && $e32c9b3f844d806e$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.hasIcon && !props.hasLabel && "\n    line-height: 0;\n  ";
}, function(props) {
    return props.pad === true && props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function(props) {
    return !props.plain && props.pad && (0, $2O6LY.edgeStyle)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});

});

parcelRegister("7w0rz", function(module, exports) {

$parcel$export(module.exports, "StyledButtonKind", () => $578bddaf48b045ae$export$64e6768d853ca4b8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5h15o = parcelRequire("5h15o");

var $jQHd2 = parcelRequire("jQHd2");
var $2O6LY = parcelRequire("2O6LY");
var $fzxBh = parcelRequire("fzxBh");
var $578bddaf48b045ae$var$radiusStyle = function radiusStyle(props) {
    var size = props.sizeProp;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof props.kind === 'object' ? props.kind : props.theme.button;
    if (size && themeObj.size && themeObj.size[size]) return (0, $f5efw.css)([
        "border-radius:",
        ";"
    ], themeObj.size[size].border.radius);
    if (themeObj.border && themeObj.border.radius) return (0, $f5efw.css)([
        "border-radius:",
        ";"
    ], themeObj.border.radius);
    return '';
};
var $578bddaf48b045ae$var$fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, props.hasIcon && !props.hasLabel ? 0 : data.height);
};
var $578bddaf48b045ae$var$padFromTheme = function padFromTheme(size, theme, themeObj, kind, iconOnly) {
    var _themeObj$size, _themeObj$size3;
    if (size === void 0) size = 'medium';
    if (size && iconOnly && themeObj != null && (_themeObj$size = themeObj.size) != null && (_themeObj$size = _themeObj$size[size]) != null && (_themeObj$size = _themeObj$size.iconOnly) != null && _themeObj$size.pad) {
        var _themeObj$size2;
        var pad = themeObj == null || (_themeObj$size2 = themeObj.size) == null || (_themeObj$size2 = _themeObj$size2[size]) == null || (_themeObj$size2 = _themeObj$size2.iconOnly) == null ? void 0 : _themeObj$size2.pad;
        return {
            vertical: typeof pad === 'string' ? pad : pad.vertical,
            horizontal: typeof pad === 'string' ? pad : pad.horizontal
        };
    }
    if (size && themeObj != null && (_themeObj$size3 = themeObj.size) != null && (_themeObj$size3 = _themeObj$size3[size]) != null && (_themeObj$size3 = _themeObj$size3[kind]) != null && _themeObj$size3.pad) return themeObj.size[size][kind].pad;
    if (size && themeObj.size && themeObj.size[size] && themeObj.size[size].pad) return {
        vertical: themeObj.size[size].pad.vertical,
        horizontal: themeObj.size[size].pad.horizontal
    };
    if (theme.button.padding) return {
        vertical: theme.global.edgeSize[theme.button.padding.vertical] || theme.button.padding.vertical,
        horizontal: theme.global.edgeSize[theme.button.padding.horizontal] || theme.button.padding.horizontal
    };
    return undefined;
};
var $578bddaf48b045ae$var$padStyle = function padStyle(_ref) {
    var hasIcon = _ref.hasIcon, hasLabel = _ref.hasLabel, size = _ref.sizeProp, theme = _ref.theme, kind = _ref.kind;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = $578bddaf48b045ae$var$padFromTheme(size, theme, themeObj, kind, iconOnly);
    return pad ? (0, $f5efw.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal) : '';
};
var $578bddaf48b045ae$var$basicStyle = function basicStyle(props) {
    return (0, $f5efw.css)([
        "border:none;",
        ";",
        " ",
        " ",
        ""
    ], $578bddaf48b045ae$var$radiusStyle(props), $578bddaf48b045ae$var$padStyle(props), $578bddaf48b045ae$var$fontStyle(props), props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ");
};
var $578bddaf48b045ae$var$getPath = function getPath(theme, path) {
    var obj;
    if (path) {
        obj = theme;
        var parts = path.split('.');
        while(obj && parts.length)obj = obj[parts.shift()];
    }
    return obj;
};
var $578bddaf48b045ae$var$adjustPadStyle = function adjustPadStyle(pad, width, theme) {
    var _theme$button;
    var intelligentPad = theme == null || (_theme$button = theme.button) == null ? void 0 : _theme$button.intelligentPad;
    if (intelligentPad === true) {
        var offset = (0, $fzxBh.parseMetricToNum)(width);
        return (0, $f5efw.css)([
            "padding:",
            "px ",
            "px;"
        ], Math.max((0, $fzxBh.parseMetricToNum)(pad.vertical) - offset, 0), Math.max((0, $fzxBh.parseMetricToNum)(pad.horizontal) - offset, 0));
    }
    // If intelligentPad is false return padding without adjustment
    return (0, $f5efw.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal);
};
// build up CSS from basic to specific based on the supplied sub-object paths
var $578bddaf48b045ae$var$kindStyle = function kindStyle(_ref2) {
    var busy = _ref2.busy, colorValue = _ref2.colorValue, hasIcon = _ref2.hasIcon, hasLabel = _ref2.hasLabel, kind = _ref2.kind, size = _ref2.sizeProp, success = _ref2.success, themePaths = _ref2.themePaths, theme = _ref2.theme;
    var styles = [];
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = $578bddaf48b045ae$var$padFromTheme(size, theme, themeObj, kind, iconOnly);
    themePaths.base.forEach(function(themePath) {
        var obj = $578bddaf48b045ae$var$getPath(themeObj, themePath);
        if (obj) {
            styles.push((0, $2O6LY.kindPartStyles)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push($578bddaf48b045ae$var$adjustPadStyle(pad, obj.border.width, theme));
        }
    });
    // do the styling from the root of the object if caller passes one
    if (!themePaths.base.length && typeof kind === 'object') {
        var obj = kind;
        if (obj) {
            styles.push((0, $2O6LY.kindPartStyles)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push($578bddaf48b045ae$var$adjustPadStyle(pad, obj.border.width, theme));
        }
    }
    themePaths.hover.forEach(function(themePath) {
        var obj = $578bddaf48b045ae$var$getPath(themeObj, themePath);
        if (obj) {
            var partStyles = (0, $2O6LY.kindPartStyles)(obj, theme);
            var adjPadStyles = '';
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the hover's border width. But don't override any
            // padding in the hover or hover.kind itself for backward compatibility
            adjPadStyles = $578bddaf48b045ae$var$adjustPadStyle(pad, obj.border.width, theme);
            if (partStyles.length > 0 && !busy && !success) styles.push((0, $f5efw.css)([
                "&:hover{",
                " ",
                "}"
            ], partStyles, adjPadStyles));
        }
    });
    return styles;
};
var $578bddaf48b045ae$var$hoverIndicatorStyle = function hoverIndicatorStyle(_ref3) {
    var hoverIndicator = _ref3.hoverIndicator, theme = _ref3.theme;
    var themishObj = {};
    if (hoverIndicator === true || hoverIndicator === 'background') themishObj.background = theme.global.hover.background;
    else if (hoverIndicator.color || hoverIndicator.background) {
        if (hoverIndicator.background) themishObj.background = hoverIndicator.background;
        if (hoverIndicator.color) themishObj.color = hoverIndicator.color;
    } else themishObj.background = hoverIndicator;
    var styles = (0, $2O6LY.kindPartStyles)(themishObj, theme);
    if (styles.length > 0) return (0, $f5efw.css)([
        "&:hover{",
        "}"
    ], styles);
    return '';
};
var $578bddaf48b045ae$var$fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var $578bddaf48b045ae$var$plainStyle = function plainStyle(props) {
    return (0, $f5efw.css)([
        "outline:none;border:none;padding:0;text-align:inherit;color:inherit;",
        " ",
        ""
    ], props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ", props.hasIcon && !props.hasLabel && "line-height: 0;");
};
var $578bddaf48b045ae$export$64e6768d853ca4b8 = (0, $f5efw.default).button.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $5h15o.default)(prop) && ![
            'kind'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledButtonKind",
    componentId: "sc-1vhfpnt-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return props.plain && $578bddaf48b045ae$var$plainStyle(props);
}, function(props) {
    return !props.disabled && props.active && (0, $jQHd2.activeStyle);
}, function(props) {
    return !props.plain && $578bddaf48b045ae$var$basicStyle(props);
}, function(props) {
    return !props.plain && $578bddaf48b045ae$var$kindStyle(props);
}, function(props) {
    return !props.plain && props.pad && (0, $2O6LY.edgeStyle)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return !props.plain && props.align && "\n    text-align: " + props.align + ";\n    ";
}, function(props) {
    return !props.disabled && props.hoverIndicator && !props.busy && !props.success && $578bddaf48b045ae$var$hoverIndicatorStyle(props);
}, function(props) {
    return props.disabled && (0, $2O6LY.disabledStyle)(props.theme.button.disabled.opacity);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, $2O6LY.focusStyle)({
        inset: props.focusIndicator === 'inset'
    });
}, (0, $2O6LY.unfocusStyle)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && $578bddaf48b045ae$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});

});

parcelRegister("hZkM5", function(module, exports) {

$parcel$export(module.exports, "EllipsisAnimation", () => $d1883f94d95e8675$export$ac1e1252ed898bd3);
$parcel$export(module.exports, "GrowCheckmark", () => $d1883f94d95e8675$export$b9551c1d2e56e841);
$parcel$export(module.exports, "StyledBusyContents", () => $d1883f94d95e8675$export$8bc5e3952d9f3838);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $3Tndo = parcelRequire("3Tndo");

var $5xcHk = parcelRequire("5xcHk");

var $2O6LY = parcelRequire("2O6LY");

var $eL6w3 = parcelRequire("eL6w3");
var $d1883f94d95e8675$var$bounceDelay = (0, $f5efw.keyframes)([
    "0%,80%,100%{transform:scale(0.4);}40%{transform:scale(0.8);}"
]);
var $d1883f94d95e8675$var$bounceDelayRule = (0, $f5efw.css)([
    "animation:",
    " 1.4s infinite ease-in-out both;"
], $d1883f94d95e8675$var$bounceDelay);
var $d1883f94d95e8675$var$Dot = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "BusyAnimation__Dot",
    componentId: "sc-feuivs-0"
})([
    "background-color:currentColor;width:8px;height:8px;border-radius:100%;display:inline-block;",
    " ",
    ""
], $d1883f94d95e8675$var$bounceDelayRule, function(props) {
    return props.delay && "animation-delay: " + props.delay + ";";
});
var $d1883f94d95e8675$export$ac1e1252ed898bd3 = function EllipsisAnimation() {
    var _theme$button;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        style: {
            position: 'absolute'
        },
        fill: true,
        alignContent: "center",
        justify: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        alignSelf: "center",
        direction: "row",
        gap: (_theme$button = theme.button) == null || (_theme$button = _theme$button.busy) == null ? void 0 : _theme$button.gap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($d1883f94d95e8675$var$Dot, {
        delay: "-0.32s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($d1883f94d95e8675$var$Dot, {
        delay: "-0.16s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($d1883f94d95e8675$var$Dot, null)));
};
var $d1883f94d95e8675$var$grow = (0, $f5efw.keyframes)([
    "0%{opacity:0;transform:scale(.3);}20%{opacity:1;transform:scale(1.15);}30%{transform:scale(.9);}45%{transform:scale(1.05);}55%{transform:scale(1);}100%{transform:scale(1);}"
]);
var $d1883f94d95e8675$export$b9551c1d2e56e841 = (0, $f5efw.default)((0, $3Tndo.Checkmark)).withConfig({
    displayName: "BusyAnimation__GrowCheckmark",
    componentId: "sc-feuivs-1"
})([
    "position:absolute;align-self:center;animation:",
    " 0.9s ease-in-out;"
], $d1883f94d95e8675$var$grow);
var $d1883f94d95e8675$export$8bc5e3952d9f3838 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "BusyAnimation__StyledBusyContents",
    componentId: "sc-feuivs-2"
})([
    "opacity:",
    ";}"
], function(props) {
    return props.animating ? 0 : 1;
});

});
parcelRegister("3Tndo", function(module, exports) {

$parcel$export(module.exports, "Checkmark", () => $2d588425403e75a5$export$4f481e0a96cfbed6, (v) => $2d588425403e75a5$export$4f481e0a96cfbed6 = v);
var $2d588425403e75a5$export$1e511d4a378977f5;
var $2d588425403e75a5$export$4f481e0a96cfbed6;
"use strict";
$2d588425403e75a5$export$1e511d4a378977f5 = true;
$2d588425403e75a5$export$4f481e0a96cfbed6 = void 0;

var $2d588425403e75a5$var$_react = $2d588425403e75a5$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");

var $jvU3m = parcelRequire("jvU3m");
function $2d588425403e75a5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2d588425403e75a5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $2d588425403e75a5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $2d588425403e75a5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $2d588425403e75a5$var$_extends() {
    return $2d588425403e75a5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d588425403e75a5$var$_extends.apply(null, arguments);
}
var $2d588425403e75a5$var$Checkmark = $2d588425403e75a5$export$4f481e0a96cfbed6 = /*#__PURE__*/ (0, $2d588425403e75a5$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $jvU3m.useScaleProps)(props);
    return /*#__PURE__*/ $2d588425403e75a5$var$_react["default"].createElement($xazbe.StyledIcon, $2d588425403e75a5$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkmark"
    }, props), /*#__PURE__*/ $2d588425403e75a5$var$_react["default"].createElement("path", $2d588425403e75a5$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 14 7 6L22 4"
    }, scaleProps)));
});
$2d588425403e75a5$var$Checkmark.displayName = 'Checkmark';

});



parcelRegister("cpdVK", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9082a01d2c4b580b$export$a06f1c675e846f6f);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $eL6w3 = parcelRequire("eL6w3");
function $9082a01d2c4b580b$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $9082a01d2c4b580b$var$_extends() {
    return $9082a01d2c4b580b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9082a01d2c4b580b$var$_extends.apply(null, arguments);
}
var $9082a01d2c4b580b$export$a06f1c675e846f6f = function Footer(_ref) {
    var _theme$footer;
    var rest = $9082a01d2c4b580b$var$_extends({}, ($9082a01d2c4b580b$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $9082a01d2c4b580b$var$_extends({
        as: "footer",
        align: "center",
        direction: "row",
        flex: false,
        gap: (_theme$footer = theme.footer) == null ? void 0 : _theme$footer.gap,
        justify: "between"
    }, rest));
};

});

parcelRegister("g1XKJ", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $babb16fc5d210898$export$ef2184bd89960b14);

var $2NacA = parcelRequire("2NacA");

var $bYIDd = parcelRequire("bYIDd");

var $j9cCD = parcelRequire("j9cCD");

var $eL6w3 = parcelRequire("eL6w3");

var $7wfCm = parcelRequire("7wfCm");
var $babb16fc5d210898$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "border",
    "fill",
    "height",
    "responsive",
    "rows",
    "tag",
    "as",
    "width"
];
function $babb16fc5d210898$var$_extends() {
    return $babb16fc5d210898$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $babb16fc5d210898$var$_extends.apply(null, arguments);
}
function $babb16fc5d210898$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $babb16fc5d210898$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], border = props.border, fill = props.fill, height = props.height, _props$responsive = props.responsive, responsiveProp = _props$responsive === void 0 ? true : _props$responsive, rows = props.rows, tag = props.tag, as = props.as, width = props.width, rest = $babb16fc5d210898$var$_objectWithoutPropertiesLoose(props, $babb16fc5d210898$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var responsiveContainer = (0, $2NacA.useContext)((0, $7wfCm.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bYIDd.StyledGrid), $babb16fc5d210898$var$_extends({
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        as: !as && tag ? tag : as,
        border: border,
        fillContainer: fill,
        heightProp: height,
        responsive: responsive,
        rowsProp: rows,
        widthProp: width
    }, passThemeFlag, rest));
});
$babb16fc5d210898$export$ef2184bd89960b14.displayName = 'Grid';
$babb16fc5d210898$export$ef2184bd89960b14.propTypes = (0, $j9cCD.GridPropTypes);
// Defualting to true to support existing code that relies on
// grid.available to create a fallback option
$babb16fc5d210898$export$ef2184bd89960b14.available = true;

});
parcelRegister("bYIDd", function(module, exports) {

$parcel$export(module.exports, "StyledGrid", () => $8b87eb2d41aba174$export$ba6ff269176936c2);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $2lgTr = parcelRequire("2lgTr");
var $8b87eb2d41aba174$var$fillStyle = function fillStyle(fill) {
    if (!fill) return fill;
    if (fill === 'horizontal') return 'width: 100%;';
    if (fill === 'vertical') return 'height: 100%;';
    return "\n      width: 100%;\n      height: 100%;\n    ";
};
var $8b87eb2d41aba174$var$JUSTIFY_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $8b87eb2d41aba174$var$justifyStyle = (0, $f5efw.css)([
    "justify-items:",
    ";"
], function(props) {
    return $8b87eb2d41aba174$var$JUSTIFY_MAP[props.justify];
});
var $8b87eb2d41aba174$var$JUSTIFY_CONTENT_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $8b87eb2d41aba174$var$justifyContentStyle = (0, $f5efw.css)([
    "justify-content:",
    ";"
], function(props) {
    return $8b87eb2d41aba174$var$JUSTIFY_CONTENT_MAP[props.justifyContent];
});
var $8b87eb2d41aba174$var$gapSizes = function gapSizes(props) {
    var result = [];
    if (typeof props.gap === 'string') {
        var size = props.theme.global.edgeSize[props.gap] || props.gap;
        result[0] = size;
        result[1] = size;
    } else if (props.gap) {
        if (props.gap.row) result[0] = props.theme.global.edgeSize[props.gap.row] || props.gap.row;
        if (props.gap.column) result[1] = props.theme.global.edgeSize[props.gap.column] || props.gap.column;
    }
    return result;
};
var $8b87eb2d41aba174$var$gapStyle = function gapStyle(props) {
    var sizes = $8b87eb2d41aba174$var$gapSizes(props);
    if (sizes[0] !== undefined && sizes[1] !== undefined) return "grid-gap: " + sizes[0] + " " + sizes[1] + ";";
    if (sizes[0] !== undefined) return "grid-row-gap: " + sizes[0] + ";";
    if (sizes[1] !== undefined) return "grid-column-gap: " + sizes[1] + ";";
    return '';
};
var $8b87eb2d41aba174$var$SIZE_MAP = {
    flex: '1fr',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var $8b87eb2d41aba174$var$normalizeSize = function normalizeSize(size, props) {
    return $8b87eb2d41aba174$var$SIZE_MAP[size] || props.theme.global.size[size] || size;
};
var $8b87eb2d41aba174$var$getRepeatCount = function getRepeatCount(count) {
    return typeof count === 'number' ? count : "auto-" + (count || 'fit');
};
var $8b87eb2d41aba174$var$getRepeatSize = function getRepeatSize(size, props) {
    if (size === 'flex') return '1fr';
    var gaps = $8b87eb2d41aba174$var$gapSizes(props);
    var min;
    var max;
    var minFill;
    if (Array.isArray(size)) {
        var _size$ = size[0], minSize = _size$ === void 0 ? 'auto' : _size$, _size$2 = size[1], maxSize = _size$2 === void 0 ? 'auto' : _size$2;
        min = $8b87eb2d41aba174$var$normalizeSize(minSize, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = $8b87eb2d41aba174$var$normalizeSize(maxSize, props);
        if (gaps[1] !== undefined) {
            // account for the column gap when using fractional sizes, e.g. 1/3
            if (minSize.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + minSize + ")))";
            if (maxSize.indexOf('/') !== -1) max = "calc(" + max + " - (" + gaps[1] + " * (1 - " + maxSize + ")))";
        }
    } else {
        min = $8b87eb2d41aba174$var$normalizeSize(size, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = '1fr';
        if (gaps[1] !== undefined) // account for column gap with fractional sizes, e.g. 1/3
        {
            if (size.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + size + ")))";
        }
    }
    if (minFill) // ensure we never go beyond the container width,
    // for mobile/narrow situations
    min = "min(" + min + ", 100%)";
    return "minmax(" + min + ", " + max + ")";
};
var $8b87eb2d41aba174$var$columnsStyle = function columnsStyle(props) {
    if (Array.isArray(props.columns)) return (0, $f5efw.css)([
        "grid-template-columns:",
        ";"
    ], props.columns.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + $8b87eb2d41aba174$var$normalizeSize(s[0], props) + ", " + $8b87eb2d41aba174$var$normalizeSize(s[1], props) + ")";
        return $8b87eb2d41aba174$var$normalizeSize(s, props);
    }).join(' '));
    if (typeof props.columns === 'object') return (0, $f5efw.css)([
        "grid-template-columns:repeat( ",
        ",",
        " );"
    ], $8b87eb2d41aba174$var$getRepeatCount(props.columns.count), $8b87eb2d41aba174$var$getRepeatSize(props.columns.size, props));
    return (0, $f5efw.css)([
        "grid-template-columns:repeat( auto-fill,",
        " );"
    ], $8b87eb2d41aba174$var$getRepeatSize(props.columns, props));
};
var $8b87eb2d41aba174$var$rowsStyle = function rowsStyle(props) {
    if (Array.isArray(props.rowsProp)) return (0, $f5efw.css)([
        "grid-template-rows:",
        ";"
    ], props.rowsProp.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + $8b87eb2d41aba174$var$normalizeSize(s[0], props) + ", " + $8b87eb2d41aba174$var$normalizeSize(s[1], props) + ")";
        return $8b87eb2d41aba174$var$normalizeSize(s, props);
    }).join(' '));
    return (0, $f5efw.css)([
        "grid-auto-rows:",
        ";"
    ], props.theme.global.size[props.rowsProp]);
};
var $8b87eb2d41aba174$var$areasStyle = function areasStyle(props) {
    // translate areas objects into grid-template-areas syntax
    if (!Array.isArray(props.rowsProp) || !Array.isArray(props.columns)) console.warn('Grid `areas` requires `rows` and `columns` to be arrays.');
    if (Array.isArray(props.areas) && props.areas.every(function(area) {
        return Array.isArray(area);
    })) return "grid-template-areas: " + props.areas.map(function(area) {
        return "\"" + area.join(' ') + "\"";
    }).join(' ') + ";";
    var cells = props.rowsProp.map(function() {
        return props.columns.map(function() {
            return '.';
        });
    });
    props.areas.forEach(function(area) {
        for(var row = area.start[1]; row <= area.end[1]; row += 1)for(var column = area.start[0]; column <= area.end[0]; column += 1)cells[row][column] = area.name;
    });
    return "grid-template-areas: " + cells.map(function(r) {
        return "\"" + r.join(' ') + "\"";
    }).join(' ') + ";";
};
var $8b87eb2d41aba174$export$ba6ff269176936c2 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledGrid",
    componentId: "sc-1wofa1l-0"
})([
    "display:grid;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return props.border && (0, $2lgTr.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return $8b87eb2d41aba174$var$fillStyle(props.fillContainer);
}, function(props) {
    return props.align && (0, $2O6LY.alignStyle);
}, function(props) {
    return props.alignContent && (0, $2O6LY.alignContentStyle);
}, function(props) {
    return props.areas && $8b87eb2d41aba174$var$areasStyle(props);
}, function(props) {
    return props.columns && $8b87eb2d41aba174$var$columnsStyle(props);
}, function(props) {
    return props.gap && $8b87eb2d41aba174$var$gapStyle(props);
}, function(props) {
    return props.justify && $8b87eb2d41aba174$var$justifyStyle;
}, function(props) {
    return props.justifyContent && $8b87eb2d41aba174$var$justifyContentStyle;
}, function(props) {
    return props.pad && (0, $2O6LY.edgeStyle)('padding', props.pad, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.rowsProp && $8b87eb2d41aba174$var$rowsStyle(props);
}, function(props) {
    return props.heightProp && (0, $2O6LY.heightStyle)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, $2O6LY.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.grid && props.theme.grid.extend;
});

});

parcelRegister("j9cCD", function(module, exports) {

$parcel$export(module.exports, "GridPropTypes", () => $df08a6163ac715a8$export$c3a9d48c57d48e6e);

var $lwlwr = parcelRequire("lwlwr");

function $df08a6163ac715a8$var$_extends() {
    return $df08a6163ac715a8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $df08a6163ac715a8$var$_extends.apply(null, arguments);
}
var $df08a6163ac715a8$var$fixedSizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var $df08a6163ac715a8$var$sizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'full',
    '1/2',
    '1/3',
    '2/3',
    '1/4',
    '2/4',
    '3/4',
    'flex',
    'auto'
];
var $df08a6163ac715a8$var$edgeSizes = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'none'
];
var $df08a6163ac715a8$var$BORDER_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
    color: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
            light: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        })
    ]),
    side: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
var $df08a6163ac715a8$var$PropType = {};
var $df08a6163ac715a8$export$c3a9d48c57d48e6e = $df08a6163ac715a8$var$PropType;

});


parcelRegister("5ebSC", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3ce779a92832e8f1$export$8b251419efc915eb);

var $2NacA = parcelRequire("2NacA");

var $cDMMY = parcelRequire("cDMMY");
var $dOlbm = parcelRequire("dOlbm");

var $5xcHk = parcelRequire("5xcHk");

var $eL6w3 = parcelRequire("eL6w3");
var $3ce779a92832e8f1$var$_excluded = [
    "sticky"
];
function $3ce779a92832e8f1$var$_extends() {
    return $3ce779a92832e8f1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3ce779a92832e8f1$var$_extends.apply(null, arguments);
}
function $3ce779a92832e8f1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3ce779a92832e8f1$export$8b251419efc915eb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).forwardRef(function(_ref, ref) {
    var _theme$header2, _theme$header3;
    var sticky = _ref.sticky, rest = $3ce779a92832e8f1$var$_objectWithoutPropertiesLoose(_ref, $3ce779a92832e8f1$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var headerRef = (0, $dOlbm.useForwardedRef)(ref);
    (0, $2NacA.useEffect)(function() {
        var scrollTop = 0;
        var updateScrollDir = function updateScrollDir() {
            // target is its scroll parent
            var target = (0, $cDMMY.findScrollParent)(headerRef.current);
            var header = headerRef.current;
            if (target && sticky === 'scrollup') {
                var nextScrollTop = target === document ? window.pageYOffset : target.scrollTop;
                if (scrollTop - nextScrollTop <= 0) {
                    header.style.top = "-" + header.getBoundingClientRect().height + "px";
                    header.style.zIndex = '';
                } else if (scrollTop - nextScrollTop > 0) {
                    var _theme$header;
                    // ensure that header moves with the target
                    header.style.position = 'sticky';
                    header.style.top = '0px';
                    header.style.zIndex = "" + ((_theme$header = theme.header) == null || (_theme$header = _theme$header.sticky) == null ? void 0 : _theme$header.zIndex);
                    header.style.transition = 'top 0.6s';
                }
                scrollTop = nextScrollTop;
            }
        };
        if (sticky === 'scrollup') {
            updateScrollDir();
            window.addEventListener('resize', updateScrollDir);
            window.addEventListener('scroll', updateScrollDir, true);
        }
        return function() {
            if (sticky === 'scrollup') {
                window.removeEventListener('resize', updateScrollDir);
                window.removeEventListener('scroll', updateScrollDir, true);
            }
        };
    }, [
        headerRef,
        sticky,
        (_theme$header2 = theme.header) == null || (_theme$header2 = _theme$header2.sticky) == null ? void 0 : _theme$header2.zIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $3ce779a92832e8f1$var$_extends({
        align: "center",
        as: "header",
        direction: "row",
        flex: false,
        justify: "between",
        gap: (_theme$header3 = theme.header) == null ? void 0 : _theme$header3.gap,
        ref: headerRef
    }, rest));
});
$3ce779a92832e8f1$export$8b251419efc915eb.displayName = 'Header';

});

parcelRegister("7XZ9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f2af0db4eeabf2$export$2e2bcd8739ae039);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("2NacA");
const $f3f2af0db4eeabf2$var$SvgTalonAiLogo = (props)=>/*#__PURE__*/ (0, $6ir3O.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 280,
        height: 280,
        viewBox: "0 0 210 210",
        ...props,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M66.852 166.867C25.273 160.887 0 121.594 15.148 83.93S78.57 59.102 91.887 69.703c13.312 10.559 38.148 29.41 118.113 40.45-3.23 9.644-23.441 33.081-61.59 26.663s-57.004-30.328-57.004-30.328 12.875 27.578 63.903 35.828c0 0-19.774 23.91-51.942 12.395 0 0-15.27-6.098-23.562-20.805 0 0 11.601 20.805 27.468 25.387 0 0-18.378 14.707-36.554 3.668-18.14-11.04-19.774-20.684-19.774-20.684s2.352 11.953 15.907 24.59m0 0"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M136.613 49.816s8.809 4.98 11.48 6.934c2.63 1.953 4.223 4.383 4.223 4.383s-4.863.12-7.414-1.594c-2.472-1.715-3.386-5.86-8.289-9.723m-41.46 55.594.84.48c-1.04-1.117-1.555-1.753-1.555-1.753s.238.476.714 1.273m73.39-13.668s17.898-10.043-5.621-30.37c0 0 3.828-11.4-14.711-22.278C116.84 21 101.332 45.55 68.965 57.348c11.16 1.832 20.969 6.097 25.95 10.043 6.976 5.539 17.14 13.351 36.792 21.164a51 51 0 0 1 2.793-3.153c11.398-11.515 31.492-5.457 34.043 6.34m0 0"
            })
        ]
    });
var $f3f2af0db4eeabf2$export$2e2bcd8739ae039 = $f3f2af0db4eeabf2$var$SvgTalonAiLogo;

});

parcelRegister("8CZ1O", function(module, exports) {

$parcel$export(module.exports, "observer", () => (parcelRequire("j8yBr")).observer);
parcelRequire("6Oe0X");
parcelRequire("4uxFz");
var $l6sdi = parcelRequire("l6sdi");

var $hkTkQ = parcelRequire("hkTkQ");
parcelRequire("f2WTr");

var $hURFQ = parcelRequire("hURFQ");

var $5v5ry = parcelRequire("5v5ry");

var $8DWz9 = parcelRequire("8DWz9");

var $j8yBr = parcelRequire("j8yBr");

var $ckU9i = parcelRequire("ckU9i");

var $c8UyG = parcelRequire("c8UyG");

var $1dolK = parcelRequire("1dolK");

var $1bJsd = parcelRequire("1bJsd");
var $64813643a43f9d13$var$_a;
(0, $hkTkQ.observerBatching)((0, $l6sdi.unstable_batchedUpdates));
var $64813643a43f9d13$export$469d51fb8d268227 = ($64813643a43f9d13$var$_a = (0, $8DWz9.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $64813643a43f9d13$var$_a !== void 0 ? $64813643a43f9d13$var$_a : function() {};
function $64813643a43f9d13$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $hURFQ.useObserver)(fn, baseComponentName);
}
function $64813643a43f9d13$export$7613124ee4202834(enable) {
    (0, $5v5ry.enableStaticRendering)(enable);
}

});
parcelRegister("6Oe0X", function(module, exports) {

var $hK1qT = parcelRequire("hK1qT");

var $2NacA = parcelRequire("2NacA");
if (!(0, $2NacA.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $hK1qT.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("4uxFz", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("l6sdi")).unstable_batchedUpdates);

var $l6sdi = parcelRequire("l6sdi");

});

parcelRegister("hkTkQ", function(module, exports) {

$parcel$export(module.exports, "observerBatching", () => $c9ef3a56ceb44e5e$export$294943bbc3c74f4f);

var $hK1qT = parcelRequire("hK1qT");
function $c9ef3a56ceb44e5e$export$fb2daceae6f5097a(callback) {
    callback();
}
function $c9ef3a56ceb44e5e$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $c9ef3a56ceb44e5e$export$fb2daceae6f5097a;
    (0, $hK1qT.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $c9ef3a56ceb44e5e$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("f2WTr", function(module, exports) {
var $af44b9e070fac2a5$var$deprecatedMessages = [];
function $af44b9e070fac2a5$export$be38475be17599d(msg) {
    if (!$af44b9e070fac2a5$var$deprecatedMessages.includes(msg)) {
        $af44b9e070fac2a5$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("hURFQ", function(module, exports) {

$parcel$export(module.exports, "useObserver", () => $d0b14d2709b4c845$export$b9c7ecd090a87b14);

var $hK1qT = parcelRequire("hK1qT");

var $2NacA = parcelRequire("2NacA");

var $eU8oV = parcelRequire("eU8oV");

var $8DWz9 = parcelRequire("8DWz9");

var $5v5ry = parcelRequire("5v5ry");
var $d0b14d2709b4c845$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $d0b14d2709b4c845$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $d0b14d2709b4c845$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $d0b14d2709b4c845$var$objectToBeRetainedByReactFactory() {
    return new $d0b14d2709b4c845$var$ObjectToBeRetainedByReact();
}
function $d0b14d2709b4c845$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $5v5ry.isUsingStaticRendering)()) return fn();
    var _a = $d0b14d2709b4c845$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useState($d0b14d2709b4c845$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $d0b14d2709b4c845$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $hK1qT.Reaction)($d0b14d2709b4c845$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $8DWz9.observerFinalizationRegistry).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useDebugValue(adm.reaction, (0, $eU8oV.printDebugValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useEffect(function() {
        (0, $8DWz9.observerFinalizationRegistry).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $hK1qT.Reaction)($d0b14d2709b4c845$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}

});
parcelRegister("eU8oV", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", () => $ad9ccfec4045123a$export$ef795f1f307682c7);

var $hK1qT = parcelRequire("hK1qT");
function $ad9ccfec4045123a$export$ef795f1f307682c7(v) {
    return (0, $hK1qT.getDependencyTree)(v);
}

});

parcelRegister("8DWz9", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", () => $64af6538150e6f91$export$10e8a12fbfd8583c);

var $9aBDi = parcelRequire("9aBDi");
var $64af6538150e6f91$export$10e8a12fbfd8583c = new (0, $9aBDi.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("9aBDi", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", () => $6ad23d52cae2e834$export$da5d55a244964b51);
var $6ad23d52cae2e834$export$e901ba0ffe10ba41 = 10000;
var $6ad23d52cae2e834$export$1ae22ce5a82f26b6 = 10000;
var $6ad23d52cae2e834$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $6ad23d52cae2e834$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $6ad23d52cae2e834$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $6ad23d52cae2e834$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $6ad23d52cae2e834$export$b7a00d372cedeedd;

});


parcelRegister("5v5ry", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", () => $401411eff9c91bb1$export$5d52eaa7c0f24c9e);
$parcel$export(module.exports, "isUsingStaticRendering", () => $401411eff9c91bb1$export$55979271896d643e);
var $401411eff9c91bb1$var$globalIsUsingStaticRendering = false;
function $401411eff9c91bb1$export$5d52eaa7c0f24c9e(enable) {
    $401411eff9c91bb1$var$globalIsUsingStaticRendering = enable;
}
function $401411eff9c91bb1$export$55979271896d643e() {
    return $401411eff9c91bb1$var$globalIsUsingStaticRendering;
}

});


parcelRegister("j8yBr", function(module, exports) {

$parcel$export(module.exports, "observer", () => $dee99b1d61763fd8$export$b6ae1bc530f4c149);

var $2NacA = parcelRequire("2NacA");

var $5v5ry = parcelRequire("5v5ry");

var $hURFQ = parcelRequire("hURFQ");
var $dee99b1d61763fd8$var$warnObserverOptionsDeprecated = true;
var $dee99b1d61763fd8$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $dee99b1d61763fd8$var$ReactForwardRefSymbol = $dee99b1d61763fd8$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $2NacA.forwardRef) === "function" && (0, $2NacA.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $dee99b1d61763fd8$var$ReactMemoSymbol = $dee99b1d61763fd8$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $2NacA.memo) === "function" && (0, $2NacA.memo)(function(props) {
    return null;
})["$$typeof"];
function $dee99b1d61763fd8$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($dee99b1d61763fd8$var$ReactMemoSymbol && baseComponent["$$typeof"] === $dee99b1d61763fd8$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $5v5ry.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($dee99b1d61763fd8$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $dee99b1d61763fd8$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $hURFQ.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $2NacA.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $2NacA.memo)(observerComponent);
    $dee99b1d61763fd8$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $dee99b1d61763fd8$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $dee99b1d61763fd8$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$dee99b1d61763fd8$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("ckU9i", function(module, exports) {

var $hURFQ = parcelRequire("hURFQ");
function $8fb2e84a040f4e83$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $hURFQ.useObserver)(component);
}
$8fb2e84a040f4e83$export$c1cbdee04e18ea8b.displayName = "Observer";
function $8fb2e84a040f4e83$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("c8UyG", function(module, exports) {

var $hK1qT = parcelRequire("hK1qT");

var $2NacA = parcelRequire("2NacA");
function $8d721abca78955cc$export$aa207039f277c5f(initializer, annotations) {
    return (0, $2NacA.useState)(function() {
        return (0, $hK1qT.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("1dolK", function(module, exports) {

var $hK1qT = parcelRequire("hK1qT");

var $2NacA = parcelRequire("2NacA");
parcelRequire("f2WTr");

var $1bJsd = parcelRequire("1bJsd");
function $0e29e4af81303d38$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $1bJsd.useAsObservableSource)(current);
    return (0, $2NacA.useState)(function() {
        return (0, $hK1qT.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("1bJsd", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", () => $0dda13c29e78f03f$export$e0ded3646391939c);
parcelRequire("f2WTr");

var $hK1qT = parcelRequire("hK1qT");

var $2NacA = parcelRequire("2NacA");
var $0dda13c29e78f03f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $0dda13c29e78f03f$export$e0ded3646391939c(current) {
    var _a = $0dda13c29e78f03f$var$__read((0, $2NacA.useState)(function() {
        return (0, $hK1qT.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $hK1qT.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});



parcelRegister("1KFDr", function(module, exports) {

$parcel$export(module.exports, "FooterNav", () => $c5bec1c5aca9fdcd$export$3210cca7a959581e);

var $6ir3O = parcelRequire("6ir3O");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $hp1AK = parcelRequire("hp1AK");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");
parcelRequire("ibR9R");
var $3AWy1 = parcelRequire("3AWy1");

var $eLUFj = parcelRequire("eLUFj");

var $8DltC = parcelRequire("8DltC");
const $c5bec1c5aca9fdcd$export$3210cca7a959581e = (0, $j8yBr.observer)(()=>{
    const userStore = (0, $8DltC.useUserStore)();
    const year = new Date().getFullYear();
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hp1AK.Nav), {
        direction: "row",
        background: {
            color: 'brand-gradient',
            dark: true
        },
        style: {
            background: 'var(--brand-gradient)'
        },
        justify: "center",
        align: "center",
        fill: "horizontal",
        pad: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "10%"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                width: "80%",
                direction: "row",
                justify: "center",
                gap: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "small",
                        style: {
                            textTransform: 'uppercase'
                        },
                        weight: 300,
                        children: [
                            "Copyright \xa9 ",
                            year
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                        href: "https://www.aktarytech.com",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            children: "AktaryTech"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "10%",
                align: "end",
                children: (0, $eLUFj.env).nodeEnv === 'development' && userStore.user?.id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3AWy1.WebSocketStatus), {})
            })
        ]
    });
});

});
parcelRegister("hp1AK", function(module, exports) {

$parcel$export(module.exports, "Nav", () => $cab6018e1c21d335$export$39140c7d8b0ba7b3);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $eL6w3 = parcelRequire("eL6w3");
function $cab6018e1c21d335$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $cab6018e1c21d335$var$_extends() {
    return $cab6018e1c21d335$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cab6018e1c21d335$var$_extends.apply(null, arguments);
}
var $cab6018e1c21d335$export$39140c7d8b0ba7b3 = function Nav(_ref) {
    var _theme$nav;
    var rest = $cab6018e1c21d335$var$_extends({}, ($cab6018e1c21d335$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $cab6018e1c21d335$var$_extends({
        as: "nav",
        flex: false,
        gap: (_theme$nav = theme.nav) == null ? void 0 : _theme$nav.gap
    }, rest));
};

});

parcelRegister("ibR9R", function(module, exports) {
$parcel$export(module.exports, "AddNewButton", () => (parcelRequire("gdNyE")).AddNewButton);
$parcel$export(module.exports, "AssetCloudImportButtons", () => (parcelRequire("107Qa")).AssetCloudImportButtons);
$parcel$export(module.exports, "ChatWidget", () => (parcelRequire("45q4c")).ChatWidget);
$parcel$export(module.exports, "ConversationList", () => (parcelRequire("eHaQh")).ConversationList);
$parcel$export(module.exports, "MessageList", () => (parcelRequire("fWjzH")).MessageList);
$parcel$export(module.exports, "SupportChat", () => (parcelRequire("f6hJT")).SupportChat);
$parcel$export(module.exports, "UserInput", () => (parcelRequire("c06ph")).UserInput);
$parcel$export(module.exports, "CommercialsPanel", () => (parcelRequire("81cmi")).CommercialsPanel);
$parcel$export(module.exports, "CreateCommercialModal", () => (parcelRequire("bSmn2")).CreateCommercialModal);
$parcel$export(module.exports, "ConfirmModal", () => (parcelRequire("3W9FZ")).ConfirmModal);
$parcel$export(module.exports, "CreditPackageModal", () => (parcelRequire("6kgbt")).CreditPackageModal);
$parcel$export(module.exports, "CreateSelect", () => (parcelRequire("1sflP")).CreateSelect);
$parcel$export(module.exports, "CurrencyInput", () => (parcelRequire("iscco")).CurrencyInput);
$parcel$export(module.exports, "Delete", () => (parcelRequire("hF8pi")).Delete);
$parcel$export(module.exports, "DeleteModal", () => (parcelRequire("7r0kC")).DeleteModal);
$parcel$export(module.exports, "Divider", () => (parcelRequire("jGT7M")).Divider);
$parcel$export(module.exports, "EditableText", () => (parcelRequire("1Ofsp")).EditableText);
$parcel$export(module.exports, "AssetSelectorModal", () => (parcelRequire("3npYU")).AssetSelectorModal);
$parcel$export(module.exports, "CommercialEditReviewModal", () => (parcelRequire("lpy8P")).CommercialEditReviewModal);
$parcel$export(module.exports, "EditReviewModal", () => (parcelRequire("aYiXW")).EditReviewModal);
$parcel$export(module.exports, "WatchVideoModal", () => (parcelRequire("5avy4")).WatchVideoModal);
$parcel$export(module.exports, "ErrorText", () => (parcelRequire("9z6Tf")).ErrorText);
$parcel$export(module.exports, "CreateEstimateModal", () => (parcelRequire("d9fGF")).CreateEstimateModal);
$parcel$export(module.exports, "CurrentEstimate", () => (parcelRequire("8fFyF")).CurrentEstimate);
$parcel$export(module.exports, "EstimateHeader", () => (parcelRequire("37Lsn")).EstimateHeader);
$parcel$export(module.exports, "EstimateList", () => (parcelRequire("iopSL")).EstimateList);
$parcel$export(module.exports, "SessionEstimateList", () => (parcelRequire("byNl8")).SessionEstimateList);
$parcel$export(module.exports, "FavoriteButton", () => (parcelRequire("2Y23d")).FavoriteButton);
$parcel$export(module.exports, "ImpersonationBanner", () => (parcelRequire("eHq6M")).ImpersonationBanner);
$parcel$export(module.exports, "LicensingRightsHeader", () => (parcelRequire("iq83q")).LicensingRightsHeader);
$parcel$export(module.exports, "RightDetailsModal", () => (parcelRequire("hkYJ0")).RightDetailsModal);
$parcel$export(module.exports, "RightPanel", () => (parcelRequire("i13h4")).RightPanel);
$parcel$export(module.exports, "Loader", () => (parcelRequire("4mDQA")).Loader);
$parcel$export(module.exports, "ModalInfoCard", () => (parcelRequire("6qg9k")).ModalInfoCard);
$parcel$export(module.exports, "NotificationsMenu", () => (parcelRequire("aPSJv")).NotificationsMenu);
$parcel$export(module.exports, "NotificationsTable", () => (parcelRequire("lbkqm")).NotificationsTable);
$parcel$export(module.exports, "WebSocketStatus", () => (parcelRequire("3AWy1")).WebSocketStatus);
$parcel$export(module.exports, "Panel", () => (parcelRequire("iPyPY")).Panel);
$parcel$export(module.exports, "DocumentsPanel", () => (parcelRequire("agggX")).DocumentsPanel);
$parcel$export(module.exports, "GoogleMap", () => (parcelRequire("84VT2")).GoogleMap);
$parcel$export(module.exports, "LocationPanel", () => (parcelRequire("cRsVF")).LocationPanel);
$parcel$export(module.exports, "ProjectRolesPanel", () => (parcelRequire("gNjNn")).ProjectRolesPanel);
$parcel$export(module.exports, "TalentManagerPanel", () => (parcelRequire("21teh")).TalentManagerPanel);
$parcel$export(module.exports, "ProjectWizard", () => (parcelRequire("lvlqx")).ProjectWizard);
$parcel$export(module.exports, "ProjectCard", () => (parcelRequire("fWLqP")).ProjectCard);
$parcel$export(module.exports, "SaveStatus", () => (parcelRequire("lFfFS")).SaveStatus);
$parcel$export(module.exports, "SaveStatusIndicator", () => (parcelRequire("lFfFS")).SaveStatusIndicator);
$parcel$export(module.exports, "SelectableText", () => (parcelRequire("6q7qM")).SelectableText);
$parcel$export(module.exports, "Selector", () => (parcelRequire("l3pMM")).Selector);
$parcel$export(module.exports, "SessionEstimatorHeader", () => (parcelRequire("3bJi5")).SessionEstimatorHeader);
$parcel$export(module.exports, "SessionRow", () => (parcelRequire("kaLe2")).SessionRow);
$parcel$export(module.exports, "SessionsPanel", () => (parcelRequire("cBCf2")).SessionsPanel);
$parcel$export(module.exports, "TableHeaderItem", () => (parcelRequire("4omtO")).TableHeaderItem);
$parcel$export(module.exports, "TalonCard", () => (parcelRequire("7wM4T")).TalonCard);
$parcel$export(module.exports, "TalonInput", () => (parcelRequire("bIzid")).TalonInput);
$parcel$export(module.exports, "TalonTip", () => (parcelRequire("d2VmQ")).TalonTip);
$parcel$export(module.exports, "TalonVideoPlayer", () => (parcelRequire("9OMpO")).TalonVideoPlayer);
$parcel$export(module.exports, "TimeInput", () => (parcelRequire("9TVJO")).TimeInput);
$parcel$export(module.exports, "UsagePanel", () => (parcelRequire("d8S1C")).UsagePanel);
$parcel$export(module.exports, "UsageRow", () => (parcelRequire("6useT")).UsageRow);
$parcel$export(module.exports, "UsageTypeSelect", () => (parcelRequire("b9Fv4")).UsageTypeSelect);
parcelRequire("gdNyE");
parcelRequire("107Qa");
parcelRequire("5cDu3");
parcelRequire("edhuX");
parcelRequire("35FKQ");
parcelRequire("3W9FZ");
parcelRequire("6kgbt");
parcelRequire("1sflP");
parcelRequire("iscco");
parcelRequire("2X1oe");
parcelRequire("2ggFG");
parcelRequire("hF8pi");
parcelRequire("7r0kC");
parcelRequire("jGT7M");
parcelRequire("1Ofsp");
parcelRequire("6sdTj");
parcelRequire("9z6Tf");
parcelRequire("gQLGd");
parcelRequire("2Y23d");
parcelRequire("2wNFJ");
parcelRequire("eHq6M");
parcelRequire("4QR02");
parcelRequire("4mDQA");
parcelRequire("iT0qG");
parcelRequire("6qg9k");
parcelRequire("kVJjK");
parcelRequire("iPyPY");
parcelRequire("3Focm");
parcelRequire("iTN0T");
parcelRequire("fWLqP");
parcelRequire("96l5t");
parcelRequire("lFfFS");
parcelRequire("6q7qM");
parcelRequire("l3pMM");
parcelRequire("hH2L6");
parcelRequire("4omtO");
parcelRequire("7wM4T");
parcelRequire("tvnEW");
parcelRequire("bIzid");
parcelRequire("d2VmQ");
parcelRequire("9OMpO");
parcelRequire("9TVJO");
parcelRequire("grjep");

});
parcelRegister("gdNyE", function(module, exports) {

$parcel$export(module.exports, "AddNewButton", () => $3f8a67b96110fc4c$export$f48e59479b265be9);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");

var $5Xkwu = parcelRequire("5Xkwu");
var $3dyXy = parcelRequire("3dyXy");
const $3f8a67b96110fc4c$export$f48e59479b265be9 = ({ onClick: onClick, label: label, icon: icon, tipText: tipText, color: color, ...rest })=>{
    const AddIcon = icon ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        children: [
            icon,
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5Xkwu.Add), {
                size: "small",
                color: color
            })
        ]
    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3dyXy.AddCircle), {
        color: color
    });
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
        hoverIndicator: true,
        onClick: ()=>onClick(),
        label: label,
        ...rest,
        icon: AddIcon,
        tip: tipText ? {
            content: tipText,
            dropProps: {
                background: 'light-2',
                round: 'small',
                pad: 'small',
                margin: 'small',
                border: 'all'
            },
            plain: true
        } : undefined
    });
};

});
parcelRegister("5Xkwu", function(module, exports) {

$parcel$export(module.exports, "Add", () => $456261deb56aceb2$export$d0265b2c425512d6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");

var $6dmSR = parcelRequire("6dmSR");
function $456261deb56aceb2$var$_extends() {
    return $456261deb56aceb2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $456261deb56aceb2$var$_extends.apply(null, arguments);
}
var $456261deb56aceb2$export$d0265b2c425512d6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var scaleProps = (0, $6dmSR.useScaleProps)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $456261deb56aceb2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Add"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $456261deb56aceb2$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22V2M2 12h20"
    }, scaleProps)));
});
$456261deb56aceb2$export$d0265b2c425512d6.displayName = 'Add';

});
parcelRegister("jKsP2", function(module, exports) {

$parcel$export(module.exports, "StyledIcon", () => $e608abad9c513bc3$export$7c8f159da0dc916);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $dWM3g = parcelRequire("dWM3g");

var $6dmSR = parcelRequire("6dmSR");
var $e608abad9c513bc3$var$_excluded = [
    "a11yTitle",
    "color",
    "size",
    "theme"
];
function $e608abad9c513bc3$var$_extends() {
    return $e608abad9c513bc3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e608abad9c513bc3$var$_extends.apply(null, arguments);
}
function $e608abad9c513bc3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $e608abad9c513bc3$var$normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = normalizeColor(result, theme, dark);
    return result;
};
var $e608abad9c513bc3$var$colorStyle = function colorStyle(name, value, theme, required) {
    return (0, $f5efw.css)([
        "",
        ":",
        ";"
    ], name, $e608abad9c513bc3$var$normalizeColor(value, theme, required));
};
var $e608abad9c513bc3$var$colorCss = (0, $f5efw.css)([
    "",
    " ",
    " g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:inherit;stroke:none;}"
], function(props) {
    return $e608abad9c513bc3$var$colorStyle('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function(props) {
    return $e608abad9c513bc3$var$colorStyle('stroke', props.color || props.theme.global.colors.icon, props.theme);
});
var $e608abad9c513bc3$var$IconInner = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, color = _ref.color, size = _ref.size, theme = _ref.theme, rest = $e608abad9c513bc3$var$_objectWithoutPropertiesLoose(_ref, $e608abad9c513bc3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("svg", $e608abad9c513bc3$var$_extends({
        ref: ref,
        "aria-label": a11yTitle
    }, rest));
});
$e608abad9c513bc3$var$IconInner.displayName = 'Icon';
var $e608abad9c513bc3$export$7c8f159da0dc916 = (0, $f5efw.default)($e608abad9c513bc3$var$IconInner).withConfig({
    // don't let height attribute leak to DOM
    // https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function shouldForwardProp(prop) {
        return ![
            'height',
            'width'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-ofa7kd-0"
})([
    "display:inline-block;flex:0 0 auto;",
    " ",
    " ",
    " ",
    ""
], function(_ref2) {
    var _size$match;
    var _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? 'medium' : _ref2$size, theme = _ref2.theme, viewBox = _ref2.viewBox;
    var _split = (viewBox || '0 0 24 24').split(' '), w = _split[2], h = _split[3];
    var scale = w / h;
    var size = theme.icon.size[sizeProp] || sizeProp;
    var dimension = (0, $6dmSR.parseMetricToNum)(size);
    // grab rem, em, px value from resolved size value
    var unit = ((_size$match = size.match(/[a-z]+$/)) == null ? void 0 : _size$match[0]) || 'px';
    if (w < h) return "\n      width: " + dimension + unit + ";\n      height: " + dimension / scale + unit + ";\n    ";
    if (h < w) return "\n      width: " + dimension * scale + unit + ";\n      height: " + dimension + unit + ";\n    ";
    return "\n      width: " + dimension + unit + ";\n      height: " + dimension + unit + ";\n    ";
}, function(_ref3) {
    var color = _ref3.color;
    return color !== 'plain' && $e608abad9c513bc3$var$colorCss;
}, function(props) {
    return (props.height || props.width) && (0, $6dmSR.iconPad)(props);
}, function(_ref4) {
    var theme = _ref4.theme;
    return theme && theme.icon.extend;
});
$e608abad9c513bc3$export$7c8f159da0dc916.defaultProps = {};
Object.setPrototypeOf($e608abad9c513bc3$export$7c8f159da0dc916.defaultProps, (0, $dWM3g.defaultProps));

});
parcelRegister("dWM3g", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $a275f72cc9bda6c0$export$9c21a3269931e1e6);

var $6dmSR = parcelRequire("6dmSR");

var $1Xs9p = parcelRequire("1Xs9p");
var $a275f72cc9bda6c0$export$9c21a3269931e1e6 = {
    theme: (0, $1Xs9p.base)
};
var $a275f72cc9bda6c0$export$582fa4e2a9b13dde = function extendDefaultTheme(theme) {
    $a275f72cc9bda6c0$export$9c21a3269931e1e6.theme = (0, $6dmSR.deepMerge)((0, $1Xs9p.base), theme);
};

});
parcelRegister("6dmSR", function(module, exports) {

$parcel$export(module.exports, "deepMerge", () => $4865b535bcf2bea7$export$6969335ea1e4e77c);
$parcel$export(module.exports, "parseMetricToNum", () => $4865b535bcf2bea7$export$333c2219d71d27ce);
$parcel$export(module.exports, "useScaleProps", () => $4865b535bcf2bea7$export$56a2e46cd4a7c217);
$parcel$export(module.exports, "iconPad", () => $4865b535bcf2bea7$export$bce3b4bc0d2e7a0e);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");
function $4865b535bcf2bea7$var$_extends() {
    return $4865b535bcf2bea7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4865b535bcf2bea7$var$_extends.apply(null, arguments);
}
function $4865b535bcf2bea7$export$a6cdc56e425d0d0a(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $4865b535bcf2bea7$export$6969335ea1e4e77c(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $4865b535bcf2bea7$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($4865b535bcf2bea7$export$a6cdc56e425d0d0a(source)) Object.keys(source).forEach(function(key) {
            if ($4865b535bcf2bea7$export$a6cdc56e425d0d0a(source[key])) {
                if (!output[key]) output[key] = $4865b535bcf2bea7$var$_extends({}, source[key]);
                else output[key] = $4865b535bcf2bea7$export$6969335ea1e4e77c(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
}
var $4865b535bcf2bea7$export$333c2219d71d27ce = function parseMetricToNum(string) {
    if (string === void 0) string = '';
    return parseFloat(string.match(/\d+(\.\d+)?/), 10);
};
function $4865b535bcf2bea7$export$56a2e46cd4a7c217(props) {
    var _theme$icon;
    var theme = (0, $2NacA.useContext)((0, $f5efw.ThemeContext));
    var size = props.size;
    var result = {};
    if (theme != null && (_theme$icon = theme.icon) != null && _theme$icon.disableScaleDown) {
        var dimension = $4865b535bcf2bea7$export$333c2219d71d27ce(theme.icon.size[size] || size);
        if (dimension < 24) result.vectorEffect = 'non-scaling-stroke';
    }
    return result;
}
var $4865b535bcf2bea7$var$calculatePad = function calculatePad(value, iconDimension) {
    return (value - iconDimension) / 2 + "px";
};
function $4865b535bcf2bea7$export$bce3b4bc0d2e7a0e(props) {
    var _theme$icon2, _theme$text, _theme$text2;
    var height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, width = props.width;
    var theme = (0, $2NacA.useContext)((0, $f5efw.ThemeContext));
    var iconDimension = $4865b535bcf2bea7$export$333c2219d71d27ce((theme == null || (_theme$icon2 = theme.icon) == null || (_theme$icon2 = _theme$icon2.size) == null ? void 0 : _theme$icon2[size]) || size);
    var style = '';
    // browser default is 16px, but accommodate if app has modified
    // include fallback in case window is undefined
    var FALLBACK = '16px';
    var rootFontSize = $4865b535bcf2bea7$export$333c2219d71d27ce(FALLBACK);
    if (typeof window !== 'undefined') {
        var _window;
        rootFontSize = $4865b535bcf2bea7$export$333c2219d71d27ce(((_window = window) == null ? void 0 : _window.getComputedStyle(document.body).getPropertyValue('font-size')) || FALLBACK);
    }
    if (height && theme != null && (_theme$text = theme.text) != null && (_theme$text = _theme$text[height]) != null && _theme$text.height) {
        // the unit on theme text
        var _theme$text$height$he = theme.text[height].height.match(/(px|rem)/), unit = _theme$text$height$he[0];
        var lineHeight = $4865b535bcf2bea7$export$333c2219d71d27ce(theme.text[height].height);
        if (unit === 'rem') lineHeight *= rootFontSize;
        if (lineHeight > iconDimension) {
            var pad = $4865b535bcf2bea7$var$calculatePad(lineHeight, iconDimension);
            style += "padding-top: " + pad + "; padding-bottom: " + pad + ";";
        }
    }
    if (width && theme != null && (_theme$text2 = theme.text) != null && (_theme$text2 = _theme$text2[width]) != null && _theme$text2.height) {
        // the unit on theme text
        var _theme$text$width$hei = theme.text[width].height.match(/(px|rem)/), _unit = _theme$text$width$hei[0];
        var desiredWidth = $4865b535bcf2bea7$export$333c2219d71d27ce(theme.text[width].height);
        if (_unit === 'rem') desiredWidth *= rootFontSize;
        if (desiredWidth > iconDimension) {
            var _pad = $4865b535bcf2bea7$var$calculatePad(desiredWidth, iconDimension);
            style += "padding-left: " + _pad + "; padding-right: " + _pad + ";";
        }
    }
    return style;
}
var $4865b535bcf2bea7$export$3794798abb123ff6 = function generatePrefix(name) {
    return "_grommeticons-" + name + "-" + (Date.now() + Math.random());
};
var $4865b535bcf2bea7$export$2e2bcd8739ae039 = {
    deepMerge: $4865b535bcf2bea7$export$6969335ea1e4e77c,
    isObject: $4865b535bcf2bea7$export$a6cdc56e425d0d0a,
    parseMetricToNum: $4865b535bcf2bea7$export$333c2219d71d27ce,
    iconPad: $4865b535bcf2bea7$export$bce3b4bc0d2e7a0e,
    useScaleProps: $4865b535bcf2bea7$export$56a2e46cd4a7c217
};

});

parcelRegister("1Xs9p", function(module, exports) {

$parcel$export(module.exports, "base", () => $16d12343706a5e16$export$e2253033e6e1df16);
var $16d12343706a5e16$export$e2253033e6e1df16 = {
    global: {
        colors: {
            icon: '#666666'
        }
    },
    icon: {
        size: {
            small: '12px',
            medium: '24px',
            large: '48px',
            xlarge: '96px'
        }
    }
};

});




parcelRegister("3dyXy", function(module, exports) {

$parcel$export(module.exports, "AddCircle", () => $257db441874ac557$export$b5797ef40e68a059);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $257db441874ac557$var$_extends() {
    return $257db441874ac557$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $257db441874ac557$var$_extends.apply(null, arguments);
}
var $257db441874ac557$export$b5797ef40e68a059 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $257db441874ac557$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AddCircle"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-4V6m-6 6h12"
    }));
});
$257db441874ac557$export$b5797ef40e68a059.displayName = 'AddCircle';

});


parcelRegister("107Qa", function(module, exports) {

$parcel$export(module.exports, "AssetCloudImportButtons", () => $72e827243ca93ef8$export$c8c842b72735bc0c);

var $6ir3O = parcelRequire("6ir3O");

var $6jhVz = parcelRequire("6jhVz");

var $8DltC = parcelRequire("8DltC");

var $f7fLD = parcelRequire("f7fLD");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $gMi7I = parcelRequire("gMi7I");
parcelRequire("hcQWc");
var $asThd = parcelRequire("asThd");
var $fxTdv = parcelRequire("fxTdv");
var $ai2Ek = parcelRequire("ai2Ek");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $bsB3E = parcelRequire("bsB3E");

var $jGT7M = parcelRequire("jGT7M");
const $72e827243ca93ef8$export$c8c842b72735bc0c = (0, $j8yBr.observer)(({ assetType: assetType, description: description = '', disabled: disabled = false, onImportSuccess: onImportSuccess, onImportStart: onImportStart, onImportEnd: onImportEnd, size: size = 'medium', direction: direction = 'row', showDivider: showDivider = true })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    const userStore = (0, $8DltC.useUserStore)();
    const { openPicker: openGooglePicker, isLoaded: googlePickerLoaded } = (0, $f7fLD.useGoogleDrivePicker)();
    /** Computed **/ const hasGoogleDrive = userStore.user?.oauth_profiles?.some((p)=>p.provider === (0, $fxTdv.TOAuthProvider).GOOGLE);
    const hasAnyAccount = hasGoogleDrive;
    /** Methods **/ // Helper function to get picker title based on asset type
    const getPickerTitle = (type)=>{
        const titles = {
            [(0, $asThd.AssetType).Video]: 'Select video files',
            [(0, $asThd.AssetType).Image]: 'Select image files',
            [(0, $asThd.AssetType).Audio]: 'Select audio files',
            [(0, $asThd.AssetType).Document]: 'Select document files'
        };
        return titles[type];
    };
    // Helper function to detect asset type from MIME type
    const detectAssetTypeFromMime = (mimeType)=>{
        const mime = mimeType.toLowerCase();
        if (mime.startsWith('video/')) return (0, $asThd.AssetType).Video;
        if (mime.startsWith('image/')) return (0, $asThd.AssetType).Image;
        if (mime.startsWith('audio/')) return (0, $asThd.AssetType).Audio;
        if (mime.startsWith('application/pdf') || mime.startsWith('text/') || mime.includes('document') || mime.includes('word')) return (0, $asThd.AssetType).Document;
        return null;
    };
    // Get MIME type filters for the selected asset type
    const getMimeTypeFilters = (type)=>{
        const mimeTypeFilters = {
            [(0, $asThd.AssetType).Video]: [
                'video/mp4',
                'video/quicktime',
                'video/x-msvideo',
                'video/x-matroska',
                'video/webm',
                'video/mpeg',
                'video/x-flv'
            ],
            [(0, $asThd.AssetType).Image]: [
                'image/jpeg',
                'image/png',
                'image/gif',
                'image/webp',
                'image/svg+xml',
                'image/bmp',
                'image/tiff'
            ],
            [(0, $asThd.AssetType).Audio]: [
                'audio/mpeg',
                'audio/mp3',
                'audio/wav',
                'audio/x-wav',
                'audio/aac',
                'audio/x-m4a',
                'audio/flac',
                'audio/ogg',
                'audio/webm'
            ],
            [(0, $asThd.AssetType).Document]: [
                'application/pdf',
                'text/plain',
                'text/csv',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ]
        };
        return mimeTypeFilters[type];
    };
    const handleGoogleDriveImport = async ()=>{
        if (!hasGoogleDrive || !googlePickerLoaded) {
            (0, $bsB3E.toast).error('Please connect your Google Drive account in your profile settings first');
            return;
        }
        const googleProfile = userStore.user?.oauth_profiles?.find((p)=>p.provider === (0, $fxTdv.TOAuthProvider).GOOGLE);
        if (!googleProfile) {
            (0, $bsB3E.toast).error('Google Drive not connected');
            return;
        }
        // Retrieve the access token from the backend (with automatic refresh if stale)
        let accessToken;
        try {
            const tokenResponse = await (0, $ai2Ek.UserService).getOAuthAccessToken(userStore.user.id, (0, $fxTdv.TOAuthProvider).GOOGLE);
            accessToken = tokenResponse.accessToken;
        } catch (error) {
            if (error?.status === 401) (0, $bsB3E.toast).error('Your Google Drive connection has expired. Please disconnect and reconnect in your profile settings.');
            else (0, $bsB3E.toast).error('Failed to retrieve Google Drive access token');
            console.error('Error getting OAuth access token:', error);
            return;
        }
        // Fetch the Google Picker API key from backend
        const pickerApiKey = await projectStore.getPickerApiKey();
        if (!pickerApiKey) {
            (0, $bsB3E.toast).error('Failed to load Google Drive picker');
            return;
        }
        openGooglePicker(pickerApiKey, accessToken, async (files)=>{
            if (files.length === 0) return;
            const file = files[0];
            // Auto-detect asset type from MIME type if not video (video is always explicit)
            const detectedType = detectAssetTypeFromMime(file.mimeType);
            const finalAssetType = detectedType || assetType;
            if (!detectedType) (0, $bsB3E.toast).warning(`Could not auto-detect file type for ${file.mimeType}, using selected type: ${assetType}`);
            else if (detectedType !== assetType && assetType !== (0, $asThd.AssetType).Video) // Only show type change notification for non-video assets
            (0, $bsB3E.toast).info(`Auto-detected file as ${detectedType} (selected: ${assetType})`);
            onImportStart?.();
            try {
                const asset = await projectStore.createAssetFromDrive(file.id, file.name, finalAssetType, description);
                if (!asset) (0, $bsB3E.toast).error('Error importing asset from Google Drive');
                else {
                    (0, $bsB3E.toast).success('Asset imported successfully from Google Drive');
                    await onImportSuccess?.(asset);
                }
            } catch (err) {
                (0, $bsB3E.toast).error(err instanceof Error ? err.message : 'Error importing asset from Google Drive');
            } finally{
                onImportEnd?.();
            }
        }, getMimeTypeFilters(assetType), getPickerTitle(assetType));
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gap: "small",
        children: [
            showDivider && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                    text: "OR IMPORT FROM"
                })
            }),
            !hasAnyAccount ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            textAlign: "center",
                            children: "Connect your cloud storage accounts to import files"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6jhVz.OAuthAccountManager), {
                            compact: true
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: direction,
                    gap: "small",
                    children: hasGoogleDrive ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        label: "Google Drive",
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gMi7I.Google), {}),
                        onClick: handleGoogleDriveImport,
                        disabled: disabled || !googlePickerLoaded,
                        secondary: true,
                        size: size
                    }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                color: "dark-4",
                                margin: {
                                    bottom: 'xsmall'
                                },
                                children: "Google Drive not connected"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6jhVz.OAuthAccountManager), {
                                compact: true,
                                providers: [
                                    (0, $fxTdv.TOAuthProvider).GOOGLE
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
});

});
parcelRegister("6jhVz", function(module, exports) {

$parcel$export(module.exports, "OAuthAccountManager", () => $fea491e63b5d5c6a$export$c78d65bfe0520bfe);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $gXEoI = parcelRequire("gXEoI");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $gMi7I = parcelRequire("gMi7I");
var $eLmdC = parcelRequire("eLmdC");
var $bDFk2 = parcelRequire("bDFk2");
parcelRequire("hcQWc");
var $fxTdv = parcelRequire("fxTdv");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $bsB3E = parcelRequire("bsB3E");
const $fea491e63b5d5c6a$var$providerConfig = {
    [(0, $fxTdv.TOAuthProvider).GOOGLE]: {
        name: 'Google Drive',
        icon: (0, $gMi7I.Google),
        color: '#4285F4'
    }
};
const $fea491e63b5d5c6a$export$c78d65bfe0520bfe = (0, $j8yBr.observer)(({ compact: compact = false, providers: providers, onConnect: onConnect, onDisconnect: onDisconnect })=>{
    /** Context **/ const userStore = (0, $8DltC.useUserStore)();
    const { openOAuthPopup: openOAuthPopup } = (0, $gXEoI.useOAuthPopup)();
    /** Computed **/ const availableProviders = providers || Object.values((0, $fxTdv.TOAuthProvider));
    /** Methods **/ const handleConnect = async (provider)=>{
        try {
            const result = await openOAuthPopup(provider, userStore.token);
            if (result.status === 'success') {
                // Refresh the entire user profile to get updated oauth_profiles
                await userStore.refreshUser();
                (0, $bsB3E.toast).success(`Successfully connected to ${$fea491e63b5d5c6a$var$providerConfig[provider].name}`);
                onConnect?.(provider);
            } else (0, $bsB3E.toast).error(`Failed to connect to ${$fea491e63b5d5c6a$var$providerConfig[provider].name}`);
        } catch (error) {
            console.error(`OAuth connection error for ${provider}:`, error);
            (0, $bsB3E.toast).error(`Error connecting to ${$fea491e63b5d5c6a$var$providerConfig[provider].name}`);
        }
    };
    const handleDisconnect = async (provider)=>{
        try {
            await userStore.disconnectOAuthProfile(userStore.user.id, provider);
            (0, $bsB3E.toast).success(`Disconnected from ${$fea491e63b5d5c6a$var$providerConfig[provider].name}`);
            onDisconnect?.(provider);
        } catch (error) {
            console.error(`OAuth disconnection error for ${provider}:`, error);
            (0, $bsB3E.toast).error(`Error disconnecting from ${$fea491e63b5d5c6a$var$providerConfig[provider].name}`);
        }
    };
    const isConnected = (provider)=>userStore.user.oauth_profiles?.some((profile)=>profile.provider === provider);
    const getConnectedProfile = (provider)=>userStore.user.oauth_profiles?.find((profile)=>profile.provider === provider);
    /** Render **/ if (compact) // Compact inline view for import buttons
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        direction: "row",
        gap: "small",
        justify: "center",
        wrap: true,
        children: availableProviders.map((provider)=>{
            const config = $fea491e63b5d5c6a$var$providerConfig[provider];
            const Icon = config.icon;
            const connected = isConnected(provider);
            const profile = getConnectedProfile(provider);
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                flex: true,
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)(Icon, {}),
                    label: connected ? `${config.name} (Connected)` : `Connect ${config.name}`,
                    onClick: ()=>connected ? handleDisconnect(provider) : handleConnect(provider),
                    primary: !connected,
                    secondary: connected,
                    size: "small",
                    tip: connected && profile ? `Connected as ${profile.name || profile.email || 'Unknown'}` : `Connect your ${config.name} account`
                })
            }, provider);
        })
    });
    // Full profile page view
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        gap: "small",
        children: availableProviders.map((provider)=>{
            const config = $fea491e63b5d5c6a$var$providerConfig[provider];
            const Icon = config.icon;
            const connected = isConnected(provider);
            const profile = getConnectedProfile(provider);
            return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                align: "center",
                justify: "between",
                pad: "small",
                background: connected ? {
                    color: 'light-2'
                } : 'light-1',
                round: "small",
                border: connected ? {
                    color: 'brand',
                    size: 'small'
                } : undefined,
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        align: "center",
                        gap: "medium",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                pad: "small",
                                round: "small",
                                background: {
                                    color: config.color,
                                    opacity: 0.1
                                },
                                style: {
                                    color: config.color
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)(Icon, {
                                    size: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        direction: "row",
                                        align: "center",
                                        gap: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                weight: "bold",
                                                children: config.name
                                            }),
                                            connected && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eLmdC.StatusGood), {
                                                size: "small",
                                                color: "status-ok"
                                            })
                                        ]
                                    }),
                                    connected && profile ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        direction: "column",
                                        gap: "xxsmall",
                                        children: [
                                            profile.name && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                color: "dark-3",
                                                children: profile.name
                                            }),
                                            profile.email && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "xsmall",
                                                color: "dark-4",
                                                children: profile.email
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        color: "dark-4",
                                        children: "Not connected"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        children: connected ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                                size: "small"
                            }),
                            label: "Disconnect",
                            onClick: ()=>handleDisconnect(provider),
                            secondary: true,
                            size: "small"
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Connect",
                            onClick: ()=>handleConnect(provider),
                            primary: true,
                            size: "small"
                        })
                    })
                ]
            }, provider);
        })
    });
});

});
parcelRegister("gXEoI", function(module, exports) {

$parcel$export(module.exports, "useOAuthPopup", () => $6eb7ff33dc58a7ee$export$e4b572274ba897fc);
// useOAuthPopup.ts

var $eLUFj = parcelRequire("eLUFj");

var $2NacA = parcelRequire("2NacA");
function $6eb7ff33dc58a7ee$export$e4b572274ba897fc() {
    const openOAuthPopup = (0, $2NacA.useCallback)((provider, token)=>{
        return new Promise((resolve)=>{
            if (!token) {
                resolve({
                    status: 'error',
                    error: 'User not authenticated'
                });
                return;
            }
            const width = 500;
            const height = 600;
            const left = window.screen.width / 2 - width / 2;
            const top = window.screen.height / 2 - height / 2;
            const host = (0, $eLUFj.env).apiHost;
            const port = (0, $eLUFj.env).apiPort ? `:${(0, $eLUFj.env).apiPort}` : '';
            const popup = window.open(`${host}${port}/connect/${provider}?token=${token}`, `${provider}-oauth`, `width=${width},height=${height},top=${top},left=${left}`);
            if (!popup) {
                resolve({
                    status: 'error',
                    error: 'Popup blocked'
                });
                return;
            }
            let resolved = false;
            const handleMessage = (event)=>{
                // Filter out React DevTools and other non-OAuth messages
                if (event.data?.source === 'react-devtools-bridge' || event.data?.source === 'react-devtools-content-script' || event.data?.source === 'react-devtools-detector') return;
                // Only the popup's final page, which is served by this same web app
                if (event.origin !== window.location.origin) return;
                if (resolved) return;
                const { status: status, provider: provider, error: error } = event.data || {};
                resolved = true;
                clearTimeout(timeoutId);
                clearInterval(checkClosed);
                window.removeEventListener('message', handleMessage);
                resolve({
                    status: status,
                    provider: provider,
                    error: error
                });
            }; // Set up timeout to detect hung popups
            const timeoutId = setTimeout(()=>{
                if (resolved) return;
                resolved = true;
                window.removeEventListener('message', handleMessage);
                if (popup && !popup.closed) popup.close();
                resolve({
                    status: 'error',
                    error: 'OAuth timeout - popup did not respond'
                });
            }, 300000); // 5 minute timeout
            // Check if popup was closed by user
            const checkClosed = setInterval(()=>{
                if (popup.closed) {
                    if (resolved) {
                        clearInterval(checkClosed);
                        return;
                    }
                    resolved = true;
                    clearInterval(checkClosed);
                    clearTimeout(timeoutId);
                    window.removeEventListener('message', handleMessage);
                    resolve({
                        status: 'error',
                        error: 'OAuth cancelled by user'
                    });
                }
            }, 500);
            window.addEventListener('message', handleMessage);
        });
    }, []);
    return {
        openOAuthPopup: openOAuthPopup
    };
}

});

parcelRegister("gMi7I", function(module, exports) {

$parcel$export(module.exports, "Google", () => $c36f2ffe76f43624$export$347eee6e8bf67997);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $c36f2ffe76f43624$var$_extends() {
    return $c36f2ffe76f43624$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c36f2ffe76f43624$var$_extends.apply(null, arguments);
}
var $c36f2ffe76f43624$export$347eee6e8bf67997 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $c36f2ffe76f43624$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Google"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#EA4335",
        d: "M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582L19.91 3C17.782 1.145 15.055 0 12 0 7.27 0 3.198 2.698 1.24 6.65l4.026 3.115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#34A853",
        d: "M16.04 18.013c-1.09.703-2.474 1.078-4.04 1.078a7.077 7.077 0 0 1-6.723-4.823l-4.04 3.067A11.965 11.965 0 0 0 12 24c2.933 0 5.735-1.043 7.834-3l-3.793-2.987z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#4A90E2",
        d: "M19.834 21c2.195-2.048 3.62-5.096 3.62-9 0-.71-.109-1.473-.272-2.182H12v4.637h6.436c-.317 1.559-1.17 2.766-2.395 3.558L19.834 21z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#FBBC05",
        d: "M5.277 14.268A7.12 7.12 0 0 1 4.909 12c0-.782.125-1.533.357-2.235L1.24 6.65A11.934 11.934 0 0 0 0 12c0 1.92.445 3.73 1.237 5.335l4.04-3.067z"
    }));
});
$c36f2ffe76f43624$export$347eee6e8bf67997.displayName = 'Google';

});

parcelRegister("eLmdC", function(module, exports) {

$parcel$export(module.exports, "StatusGood", () => $abf6b09f0f6a17f0$export$2f4a3096121829b3);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $abf6b09f0f6a17f0$var$_extends() {
    return $abf6b09f0f6a17f0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $abf6b09f0f6a17f0$var$_extends.apply(null, arguments);
}
var $abf6b09f0f6a17f0$export$2f4a3096121829b3 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $abf6b09f0f6a17f0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM7 12l4 3 5-7"
    }));
});
$abf6b09f0f6a17f0$export$2f4a3096121829b3.displayName = 'StatusGood';

});

parcelRegister("bDFk2", function(module, exports) {

$parcel$export(module.exports, "Trash", () => $879363f571383f2d$export$99442c433de1441d);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $879363f571383f2d$var$_extends() {
    return $879363f571383f2d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $879363f571383f2d$var$_extends.apply(null, arguments);
}
var $879363f571383f2d$export$99442c433de1441d = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $879363f571383f2d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Trash"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 5h16v18H4V5zM1 5h22M9 1h6v4H9V1zm0 0h6v4H9V1zm6 8v10M9 9v10"
    }));
});
$879363f571383f2d$export$99442c433de1441d.displayName = 'Trash';

});


parcelRegister("f7fLD", function(module, exports) {

$parcel$export(module.exports, "useGoogleDrivePicker", () => $47b347cac1cddebb$export$b2f95c45114a9ebd);

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $93deL = parcelRequire("93deL");
const $47b347cac1cddebb$var$PICKER_BLOCKED_TOAST = 'google-picker-blocked';
function $47b347cac1cddebb$export$b2f95c45114a9ebd() {
    const [isLoaded, setIsLoaded] = (0, $2NacA.useState)(false);
    const [isLoading, setIsLoading] = (0, $2NacA.useState)(false);
    (0, $2NacA.useEffect)(()=>{
        // Load Google API script
        const loadGoogleAPI = ()=>{
            if (window.gapi && window.google) {
                setIsLoaded(true);
                return;
            }
            const script1 = document.createElement('script');
            script1.src = 'https://apis.google.com/js/api.js';
            script1.async = true;
            script1.defer = true;
            script1.onload = ()=>{
                window.gapi.load('picker', ()=>{
                    setIsLoaded(true);
                });
            };
            document.body.appendChild(script1);
        };
        loadGoogleAPI();
    }, []);
    const openPicker = (0, $2NacA.useCallback)(async (apiKey, accessToken, onSelect, mimeTypes, title)=>{
        if (!isLoaded || !window.google || !window.gapi) {
            console.error('Google Picker API not loaded');
            return;
        }
        if (!apiKey) {
            console.error('Google API key not provided');
            return;
        }
        if (!accessToken) {
            console.error('Google OAuth access token not provided');
            return;
        }
        console.log('Opening Google Picker with:', {
            apiKeyPresent: !!apiKey,
            accessTokenPresent: !!accessToken,
            accessTokenPrefix: accessToken.substring(0, 20) + '...',
            mimeTypeFilter: mimeTypes
        });
        setIsLoading(true);
        // No report from the picker means it's stuck on Google's sign-in page (third-party cookies
        // blocked for this site) - say so, instead of leaving the user at a dead end
        const watch = (0, $93deL.watchPickerLoad)(()=>{
            setIsLoading(false);
            (0, $bsB3E.toast).warn((0, $93deL.pickerBlockedMessage)(window.location.host), {
                autoClose: false,
                toastId: $47b347cac1cddebb$var$PICKER_BLOCKED_TOAST
            });
        }, ()=>(0, $bsB3E.toast).dismiss($47b347cac1cddebb$var$PICKER_BLOCKED_TOAST));
        try {
            const view = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS).setIncludeFolders(true);
            // Apply MIME type filter if provided
            if (mimeTypes && mimeTypes.length > 0) view.setMimeTypes(mimeTypes.join(','));
            const picker = new window.google.picker.PickerBuilder().addView(view).setOAuthToken(accessToken).setDeveloperKey(apiKey).setOrigin(window.location.protocol + '//' + window.location.host).enableFeature(window.google.picker.Feature.SUPPORT_DRIVES).setTitle(title || 'Select files from Google Drive').setCallback((data)=>{
                console.log('Picker callback received:', data);
                watch.onAction();
                // Check for errors
                if (data[window.google.picker.Response.ERROR]) {
                    console.error('Picker error:', data[window.google.picker.Response.ERROR]);
                    setIsLoading(false);
                    return;
                }
                if (data.action === window.google.picker.Action.PICKED) {
                    const files = data.docs.map((doc)=>({
                            id: doc.id,
                            name: doc.name,
                            mimeType: doc.mimeType,
                            sizeBytes: doc.sizeBytes
                        }));
                    console.log('Files selected:', files);
                    onSelect(files);
                } else if (data.action === window.google.picker.Action.CANCEL) console.log('Picker cancelled');
                setIsLoading(false);
            }).build();
            picker.setVisible(true);
        } catch (error) {
            console.error('Error opening Google Drive Picker:', error);
            watch.stop();
            setIsLoading(false);
        }
    }, [
        isLoaded
    ]);
    return {
        openPicker: openPicker,
        isLoaded: isLoaded,
        isLoading: isLoading
    };
}

});
parcelRegister("93deL", function(module, exports) {

$parcel$export(module.exports, "pickerBlockedMessage", () => $eb4112822f2df79b$export$410b72febdc5a056);
$parcel$export(module.exports, "watchPickerLoad", () => $eb4112822f2df79b$export$6b38966c854cd1f3);
/**
 * The Google Picker runs in a docs.google.com iframe that also needs the user's Google session.
 * When the browser blocks third-party cookies for this site (Brave Shields, Safari, Firefox's
 * strict mode), the frame shows Google's own "Sign in to your Google Account" page and the picker
 * never reports anything - no callback fires. A successful picker reports `loaded` (undocumented
 * but reliable) within a second or two, so no report after a few seconds means it's stuck there.
 * Short on purpose: a user staring at Google's sign-in page won't wait long, and if a slow picker
 * does report in after the warning, the warning is withdrawn.
 */ const $eb4112822f2df79b$export$f0fc2a7f3c485d34 = 4000;
const $eb4112822f2df79b$export$410b72febdc5a056 = (host)=>'Google Drive didn\'t load. If Google is asking you to sign in although you already are, your browser ' + `is blocking third-party cookies for ${host}. Allow them for this site (in Brave, turn Shields down) ` + 'and try again.';
const $eb4112822f2df79b$export$6b38966c854cd1f3 = (onStuck, onRecovered = ()=>undefined, timeoutMs = $eb4112822f2df79b$export$f0fc2a7f3c485d34)=>{
    let stuck = false;
    let timer = setTimeout(()=>{
        timer = undefined;
        stuck = true;
        onStuck();
    }, timeoutMs);
    const stop = ()=>{
        if (timer) clearTimeout(timer);
        timer = undefined;
    };
    // Any report at all (loaded, picked, cancel, error) proves the picker itself is running
    const onAction = ()=>{
        stop();
        if (stuck) {
            stuck = false;
            onRecovered();
        }
    };
    return {
        onAction: onAction,
        stop: stop
    };
};

});


parcelRegister("jGT7M", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $dda99373a09b1aaa$export$2e0a83ec2e27ecbb);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
const $dda99373a09b1aaa$export$2e0a83ec2e27ecbb = ({ color: color = 'brand-gradient', height: height = '1px', fill: fill = 'horizontal', elevation: elevation = 'xsmall', animation: animation, text: text, textGap: textGap = 'xsmall', textProps: textProps })=>{
    const Divider = ()=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            height: height,
            background: color,
            fill: fill,
            animation: animation,
            elevation: elevation
        });
    return text ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        align: "center",
        gap: textGap,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)(Divider, {}),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                flex: "grow",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "xsmall",
                    color: "dark-2",
                    ...textProps,
                    children: text
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)(Divider, {})
        ]
    }) : /*#__PURE__*/ (0, $6ir3O.jsx)(Divider, {});
};

});


parcelRegister("5cDu3", function(module, exports) {

$parcel$export(module.exports, "Blink", () => $9e7ab2450df62257$export$1a553341cd0b8415);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");

var $2NacA = parcelRequire("2NacA");
const $9e7ab2450df62257$export$1a553341cd0b8415 = ({ children: children, size: size = 'large', enabled: enabled = true, disabled: disabled = false, speed: speed, boxProps: boxProps })=>{
    const [isVisible, setIsVisible] = (0, $2NacA.useState)(true);
    const shouldBlink = enabled === true && disabled === false;
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        animation: shouldBlink ? {
            type: isVisible ? 'fadeOut' : 'fadeIn',
            size: size,
            duration: speed
        } : undefined,
        onAnimationEnd: shouldBlink ? ()=>setIsVisible(!isVisible) : undefined,
        ...boxProps,
        children: children
    });
};

});

parcelRegister("edhuX", function(module, exports) {
$parcel$export(module.exports, "ConversationList", () => (parcelRequire("eHaQh")).ConversationList);
$parcel$export(module.exports, "MessageList", () => (parcelRequire("fWjzH")).MessageList);
$parcel$export(module.exports, "UserInput", () => (parcelRequire("c06ph")).UserInput);
$parcel$export(module.exports, "ChatWidget", () => (parcelRequire("45q4c")).ChatWidget);
$parcel$export(module.exports, "SupportChat", () => (parcelRequire("f6hJT")).SupportChat);
parcelRequire("eHaQh");
parcelRequire("fWjzH");
parcelRequire("e9Lkd");
parcelRequire("c06ph");
parcelRequire("45q4c");
parcelRequire("f6hJT");

});
parcelRegister("eHaQh", function(module, exports) {

$parcel$export(module.exports, "ConversationList", () => $ae0ff72e9bf691c2$export$c84be89e9a4c6ea7);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $1fLUh = parcelRequire("1fLUh");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");
parcelRequire("hcQWc");
var $3byqD = parcelRequire("3byqD");
parcelRequire("ibR9R");
var $l3pMM = parcelRequire("l3pMM");
var $d2VmQ = parcelRequire("d2VmQ");

var $dUDTx = parcelRequire("dUDTx");
const $ae0ff72e9bf691c2$export$c84be89e9a4c6ea7 = (0, $j8yBr.observer)(({ selectConversation: selectConversation, conversations: conversations, updateConversation: updateConversation, setStatus: setStatus, status: status })=>{
    const statusOptions = Object.values((0, $3byqD.ConversationStatus)).map((status)=>({
            name: status,
            id: status
        }));
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1fLUh.Heading), {
                level: "4",
                margin: "medium",
                children: [
                    "Conversations",
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                        options: statusOptions,
                        value: status,
                        onChange: (val)=>setStatus(val),
                        size: "small"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                gap: "small",
                overflow: {
                    vertical: 'scroll'
                },
                pad: {
                    horizontal: 'xsmall'
                },
                children: [
                    conversations.map((c)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            border: {
                                side: 'bottom',
                                size: '1px'
                            },
                            align: "start",
                            justify: "between",
                            flex: "grow",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                    content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: c.name
                                    }),
                                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        direction: "column",
                                        pad: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                                plain: true,
                                                hoverIndicator: true,
                                                onClick: ()=>selectConversation(c.id),
                                                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    weight: c.unread ? 'bold' : 'normal',
                                                    size: "small",
                                                    children: c.name.length > 35 ? `${c.name.slice(0, 34)}...` : c.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "xsmall",
                                                children: (0, $dUDTx.parseIsoDateString)(c.updated_at).date === (0, $dUDTx.parseIsoDateString)(new Date().toISOString()).date ? (0, $dUDTx.parseIsoDateString)(c.updated_at).time : (0, $dUDTx.parseIsoDateString)(c.updated_at).date
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                    content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "xsmall",
                                        children: "Close conversation"
                                    }),
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                        size: "small",
                                        onClick: ()=>updateConversation({
                                                id: c.id,
                                                status: (0, $3byqD.ConversationStatus).CLOSED
                                            })
                                    })
                                })
                            ]
                        }, c.id)),
                    !conversations.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "No conversations found."
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("1fLUh", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $0e9c5a6d99c4f599$export$a8a3e93435678ff9);

var $2NacA = parcelRequire("2NacA");

var $hHZ58 = parcelRequire("hHZ58");

var $5AfxP = parcelRequire("5AfxP");

var $5htSv = parcelRequire("5htSv");

var $dOlbm = parcelRequire("dOlbm");

var $4ZVSM = parcelRequire("4ZVSM");

var $lkP8c = parcelRequire("lkP8c");

var $eL6w3 = parcelRequire("eL6w3");

var $7wfCm = parcelRequire("7wfCm");
var $0e9c5a6d99c4f599$var$_excluded = [
    "children",
    "color",
    "fill",
    "level",
    "overflowWrap",
    "responsive",
    "weight"
];
function $0e9c5a6d99c4f599$var$_extends() {
    return $0e9c5a6d99c4f599$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e9c5a6d99c4f599$var$_extends.apply(null, arguments);
}
function $0e9c5a6d99c4f599$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0e9c5a6d99c4f599$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref // munged to avoid styled-components putting it in the DOM
) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, overflowWrapProp = _ref.overflowWrap, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, weight = _ref.weight, rest = $0e9c5a6d99c4f599$var$_objectWithoutPropertiesLoose(_ref, $0e9c5a6d99c4f599$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var headingRef = (0, $dOlbm.useForwardedRef)(ref);
    var _useState = (0, $2NacA.useState)(overflowWrapProp || 'break-word'), overflowWrap = _useState[0], setOverflowWrap = _useState[1];
    var responsiveContainer = (0, $2NacA.useContext)((0, $7wfCm.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var skeleton = (0, $4ZVSM.useSkeleton)();
    // handle overflowWrap of heading
    (0, $hHZ58.useLayoutEffect)(function() {
        var updateOverflowWrap = function updateOverflowWrap() {
            var wrap;
            if (!overflowWrapProp && headingRef.current) {
                wrap = headingRef.current.scrollWidth > headingRef.current.offsetWidth ? 'anywhere' : 'break-word';
                setOverflowWrap(wrap);
            }
        };
        window.addEventListener('resize', updateOverflowWrap);
        updateOverflowWrap();
        return function() {
            return window.removeEventListener('resize', updateOverflowWrap);
        };
    }, [
        headingRef,
        overflowWrapProp
    ]);
    var content = children;
    if (skeleton) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $lkP8c.HeadingSkeleton), $0e9c5a6d99c4f599$var$_extends({
        level: level,
        fill: fill,
        responsive: responsive
    }, rest));
    return(/*#__PURE__*/ // enforce level to be a number
    (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5AfxP.StyledHeading), $0e9c5a6d99c4f599$var$_extends({
        as: "h" + level,
        colorProp: color,
        fillProp: fill,
        level: +level,
        overflowWrap: overflowWrap,
        responsive: responsive,
        weight: weight
    }, passThemeFlag, rest, {
        ref: headingRef
    }), content));
});
$0e9c5a6d99c4f599$export$a8a3e93435678ff9.displayName = 'Heading';
$0e9c5a6d99c4f599$export$a8a3e93435678ff9.propTypes = (0, $5htSv.HeadingPropTypes);

});
parcelRegister("5AfxP", function(module, exports) {

$parcel$export(module.exports, "StyledHeading", () => $410c5f67155aa6c0$export$8c1dfb3a3dfd5501);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $fzxBh = parcelRequire("fzxBh");
var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");
var $410c5f67155aa6c0$var$sizeStyle = function sizeStyle(props) {
    // size is a combination of the level and size properties
    var size = props.size || 'medium';
    var headingTheme = props.theme.heading;
    var levelStyle = headingTheme.level[props.level];
    if (levelStyle) {
        var data = levelStyle[size];
        var styles = [
            (0, $f5efw.css)([
                "font-size:",
                ";line-height:",
                ";max-width:",
                ";font-weight:",
                ";overflow-wrap:",
                ";"
            ], data ? data.size : size, data ? data.height : 'normal', props.fillProp && 'none' || data && data.maxWidth || levelStyle.medium.maxWidth, props.weight || levelStyle.font.weight || headingTheme.weight, props.overflowWrap)
        ];
        if (props.responsive && headingTheme.responsiveBreakpoint) {
            var breakpoint = props.theme.global.breakpoints[headingTheme.responsiveBreakpoint];
            if (breakpoint) {
                var responsiveData = headingTheme.level[props.level + 1] ? headingTheme.level[props.level + 1][size] : headingTheme.level[props.level][size];
                if (responsiveData) styles.push((0, $fzxBh.breakpointStyle)(breakpoint, "\n            font-size: " + responsiveData.size + ";\n            line-height: " + responsiveData.height + ";\n            max-width: " + (props.fillProp && 'none' || responsiveData.maxWidth) + ";\n          ", props.responsive));
            }
        }
        return styles;
    }
    console.warn("Heading level " + props.level + " is not defined in your theme.");
    return '';
};
var $410c5f67155aa6c0$var$fontFamily = function fontFamily(props) {
    var _ref = props.theme.heading.level[props.level] || {}, font = _ref.font;
    if (font && font.family) return (0, $f5efw.css)([
        "font-family:",
        ";"
    ], font.family);
    return props.theme.heading.font ? (0, $f5efw.css)([
        "font-family:",
        ";"
    ], props.theme.heading.font.family) : '';
};
var $410c5f67155aa6c0$var$truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var $410c5f67155aa6c0$var$colorStyle = (0, $f5efw.css)([
    "color:",
    ";"
], function(props) {
    return (0, $d2fh4.normalizeColor)(props.colorProp || props.theme.heading.color, props.theme);
});
var $410c5f67155aa6c0$export$8c1dfb3a3dfd5501 = (0, $f5efw.default).h1.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledHeading",
    componentId: "sc-1rdh4aw-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return $410c5f67155aa6c0$var$fontFamily(props);
}, function(props) {
    return $410c5f67155aa6c0$var$sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, $2O6LY.textAlignStyle);
}, function(props) {
    return props.truncate && $410c5f67155aa6c0$var$truncateStyle;
}, function(props) {
    return (props.colorProp || props.theme.heading.color) && $410c5f67155aa6c0$var$colorStyle;
}, function(props) {
    return props.theme.heading && props.theme.heading.extend;
});

});

parcelRegister("5htSv", function(module, exports) {

$parcel$export(module.exports, "HeadingPropTypes", () => $3d85b7721434d413$export$c6750152f5d8efcb);


function $3d85b7721434d413$var$_extends() {
    return $3d85b7721434d413$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d85b7721434d413$var$_extends.apply(null, arguments);
}
var $3d85b7721434d413$var$PropType = {};
var $3d85b7721434d413$export$c6750152f5d8efcb = $3d85b7721434d413$var$PropType;

});

parcelRegister("lkP8c", function(module, exports) {

$parcel$export(module.exports, "HeadingSkeleton", () => $f88320dafdd760a9$export$6db3fc939e78ca56);

var $2NacA = parcelRequire("2NacA");

var $7bBqH = parcelRequire("7bBqH");

var $eL6w3 = parcelRequire("eL6w3");
function $f88320dafdd760a9$var$_extends() {
    return $f88320dafdd760a9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f88320dafdd760a9$var$_extends.apply(null, arguments);
}
var $f88320dafdd760a9$export$6db3fc939e78ca56 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$heading$level$;
    var as = _ref.as, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, responsive = _ref.responsive;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var height = ((_theme$heading$level$ = theme.heading.level[level]) == null || (_theme$heading$level$ = _theme$heading$level$[size]) == null ? void 0 : _theme$heading$level$.height) || size;
    var responsiveSize;
    if (responsive && theme.heading.responsiveBreakpoint) {
        var breakpoint = theme.global.breakpoints[theme.heading.responsiveBreakpoint];
        if (breakpoint) {
            var _theme$heading$level$2, _theme$heading$level$3;
            var responsiveHeight = theme.heading.level[level + 1] ? (_theme$heading$level$2 = theme.heading.level[level + 1][size]) == null ? void 0 : _theme$heading$level$2.height : (_theme$heading$level$3 = theme.heading.level[level][size]) == null ? void 0 : _theme$heading$level$3.height;
            responsiveSize = {
                breakpoint: breakpoint,
                height: responsiveHeight || height
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7bBqH.Skeleton), $f88320dafdd760a9$var$_extends({
        as: as,
        ref: ref,
        height: height,
        responsive: responsive,
        responsiveSize: responsiveSize
    }, theme.heading.skeleton));
});
$f88320dafdd760a9$export$6db3fc939e78ca56.displayName = 'HeadingSkeleton';

});


parcelRegister("1QpFO", function(module, exports) {

$parcel$export(module.exports, "Close", () => $157e8ff55f914c8e$export$f39c2d165cd861fe);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");

var $6dmSR = parcelRequire("6dmSR");
function $157e8ff55f914c8e$var$_extends() {
    return $157e8ff55f914c8e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $157e8ff55f914c8e$var$_extends.apply(null, arguments);
}
var $157e8ff55f914c8e$export$f39c2d165cd861fe = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var scaleProps = (0, $6dmSR.useScaleProps)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $157e8ff55f914c8e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Close"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $157e8ff55f914c8e$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 3 18 18M3 21 21 3"
    }, scaleProps)));
});
$157e8ff55f914c8e$export$f39c2d165cd861fe.displayName = 'Close';

});

parcelRegister("dUDTx", function(module, exports) {

$parcel$export(module.exports, "parseIsoDateString", () => $65e03d34de630e5d$export$d5d7fcaa1bbecc79);
$parcel$export(module.exports, "isSameOrAfter", () => $65e03d34de630e5d$export$a663815b3d4a2ed6);
$parcel$export(module.exports, "isSameOrBefore", () => $65e03d34de630e5d$export$1b89dd52850801f3);

var $4kZY9 = parcelRequire("4kZY9");
const $65e03d34de630e5d$export$4c5a967214fbc965 = Array.from({
    length: 12
}, (_, i)=>(!(i % 12) ? 12 : i % 12).toString());
const $65e03d34de630e5d$export$9b2c9feed996c11e = Array.from({
    length: 4
}, (_, i)=>!i ? '00' : (i * 15).toString());
const $65e03d34de630e5d$export$bd57c7482e6cabd7 = [
    'AM',
    'PM'
];
const $65e03d34de630e5d$export$20c9443fddb67652 = ()=>{
    return Array.from({
        length: $65e03d34de630e5d$export$4c5a967214fbc965.length * $65e03d34de630e5d$export$9b2c9feed996c11e.length * $65e03d34de630e5d$export$bd57c7482e6cabd7.length
    }, (_, i)=>{
        const hi = Math.floor(i / $65e03d34de630e5d$export$9b2c9feed996c11e.length);
        const h = $65e03d34de630e5d$export$4c5a967214fbc965[hi % 12];
        const m = $65e03d34de630e5d$export$9b2c9feed996c11e[i % $65e03d34de630e5d$export$9b2c9feed996c11e.length];
        const a = $65e03d34de630e5d$export$bd57c7482e6cabd7[Math.floor(hi / 12)];
        return `${h}:${m} ${a}`;
    });
};
const $65e03d34de630e5d$export$60248f42f43df209 = (input)=>(0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(input).format('YYYY-MM-DD');
const $65e03d34de630e5d$export$da876ebe5870f49a = (input)=>(0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(input).format('h:mm A');
const $65e03d34de630e5d$export$d5d7fcaa1bbecc79 = (input)=>({
        date: $65e03d34de630e5d$export$60248f42f43df209(input),
        time: $65e03d34de630e5d$export$da876ebe5870f49a(input)
    });
const $65e03d34de630e5d$export$a663815b3d4a2ed6 = (time, comparisonTime)=>{
    const t = typeof time === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(time) : time;
    const t2 = typeof comparisonTime === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(comparisonTime) : comparisonTime;
    return t.isSame(t2) || t.isAfter(t2);
};
const $65e03d34de630e5d$export$1b89dd52850801f3 = (time, comparisonTime)=>{
    const t = typeof time === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(time) : time;
    const t2 = typeof comparisonTime === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(comparisonTime) : comparisonTime;
    return t.isSame(t2) || t.isBefore(t2);
};
const $65e03d34de630e5d$export$577c6f732197f9c1 = (time, start, end, checkIsSame = true)=>{
    const t = typeof time === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(time) : time;
    const s = typeof start === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(start) : start;
    const e = typeof end === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(end) : end;
    let isBetween = false;
    if ((checkIsSame ? $65e03d34de630e5d$export$a663815b3d4a2ed6(t, s) : t.isAfter(s)) && (checkIsSame ? $65e03d34de630e5d$export$1b89dd52850801f3(t, e) : t.isBefore(e))) isBetween = true;
    return isBetween;
};
const $65e03d34de630e5d$export$690640bcdde2b01c = (sessionActivities)=>{
    const overlapping = [];
    const activities = sessionActivities;
    while(activities.length){
        const activity = activities.shift();
        if (!activity) break;
        for (const otherActivity of activities){
            if (!activity.start_time || !activity.end_time || !otherActivity.start_time || !otherActivity.end_time) continue;
            const startOverlaps = $65e03d34de630e5d$export$577c6f732197f9c1(activity.start_time, otherActivity.start_time, otherActivity.end_time, false);
            const endOverlaps = $65e03d34de630e5d$export$577c6f732197f9c1(activity.end_time, otherActivity.start_time, otherActivity.end_time, false);
            if (startOverlaps || endOverlaps) overlapping.push(otherActivity);
        }
    }
    console.log('[getOverlapping] Got overlapping Activities: %O', overlapping);
    return overlapping;
};
const $65e03d34de630e5d$export$b20cbb7289b55991 = (sessionActivities)=>!!$65e03d34de630e5d$export$690640bcdde2b01c(sessionActivities).length;
const $65e03d34de630e5d$export$b744abe6c49cb988 = (dateTime, sessionActivities)=>{
    let isOverlapping = false;
    for (const otherActivity of sessionActivities){
        if (!otherActivity.start_time || !otherActivity.end_time) continue;
        if ($65e03d34de630e5d$export$577c6f732197f9c1(dateTime, otherActivity.start_time, otherActivity.end_time, false)) isOverlapping = true;
    }
    return isOverlapping;
};

});


parcelRegister("fWjzH", function(module, exports) {

$parcel$export(module.exports, "MessageList", () => $ae744c52e6c0c58b$export$89085c7857c3f940);

var $6ir3O = parcelRequire("6ir3O");

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $e9Lkd = parcelRequire("e9Lkd");
const $ae744c52e6c0c58b$export$89085c7857c3f940 = ({ messages: messages })=>{
    const messageListRef = (0, $2NacA.useRef)(null);
    (0, $2NacA.useEffect)(()=>{
        if (messageListRef.current) messageListRef.current?.scrollTo(0, messageListRef.current.scrollHeight);
    }, [
        messages
    ]);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        background: "white",
        border: {
            color: '#d9d9e3'
        },
        justify: "start",
        alignContent: "start",
        direction: "column",
        flex: true,
        overflow: {
            vertical: 'auto'
        },
        ref: messageListRef,
        children: messages.map((message, index)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $e9Lkd.ChatMessage), {
                message: message,
                index: index
            }, `chatMessage-${index}`))
    });
};

});
parcelRegister("e9Lkd", function(module, exports) {

$parcel$export(module.exports, "ChatMessage", () => $e501e852110f8ca8$export$423c13fd52bec8ad);

var $6ir3O = parcelRequire("6ir3O");

var $1SpQX = parcelRequire("1SpQX");
var $kOwHr = parcelRequire("kOwHr");
var $5xcHk = parcelRequire("5xcHk");
var $b5MFC = parcelRequire("b5MFC");
var $btRQT = parcelRequire("btRQT");
var $kS7Ii = parcelRequire("kS7Ii");

var $kHJyS = parcelRequire("kHJyS");
var $dmh5A = parcelRequire("dmh5A");
var $9HK6v = parcelRequire("9HK6v");

var $7XZ9N = parcelRequire("7XZ9N");
parcelRequire("hcQWc");
var $d18Ah = parcelRequire("d18Ah");

var $8DltC = parcelRequire("8DltC");

var $d2VmQ = parcelRequire("d2VmQ");

var $2NacA = parcelRequire("2NacA");

var $dUDTx = parcelRequire("dUDTx");
const $e501e852110f8ca8$var$MENTION_TOKEN_PATTERN = /@\[([^\]]+)\]\(([^)]+)\)/g;
const $e501e852110f8ca8$var$renderLineWithMentions = (line)=>{
    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;
    $e501e852110f8ca8$var$MENTION_TOKEN_PATTERN.lastIndex = 0;
    while(match = $e501e852110f8ca8$var$MENTION_TOKEN_PATTERN.exec(line)){
        if (match.index > lastIndex) parts.push(line.slice(lastIndex, match.index));
        parts.push(/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
            weight: "bold",
            color: "brand",
            children: [
                "@",
                match[1]
            ]
        }, `mention-${key++}`));
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < line.length) parts.push(line.slice(lastIndex));
    return parts;
};
const $e501e852110f8ca8$export$423c13fd52bec8ad = ({ message: message, index: index })=>{
    (0, $2NacA.useEffect)(()=>{
        setMyMsg(message.user_id === userStore.user.id);
        switch(message.type){
            case (0, $d18Ah.MessageType).USER_MESSAGE:
                setBg('light-1');
                setIsSystemMsg(false);
                setIcon(/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                    content: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            userStore.user.first_name,
                            " ",
                            userStore.user.last_name
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {})
                }));
                break;
            case (0, $d18Ah.MessageType).AI_MESSAGE:
                setBg('white');
                setIcon(/*#__PURE__*/ (0, $6ir3O.jsx)((0, $7XZ9N.default), {}));
                setIsSystemMsg(false);
                break;
            case (0, $d18Ah.MessageType).SUPPORT_MESSAGE:
                setBg('accent-2');
                setIcon(/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                    content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "BA Expert"
                    }),
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9HK6v.UserExpert), {})
                }));
                setIsSystemMsg(false);
                break;
            case (0, $d18Ah.MessageType).SYSTEM_MESSAGE:
                setIsSystemMsg(true);
                setBg('white');
                setIcon(/*#__PURE__*/ (0, $6ir3O.jsx)((0, $kHJyS.Blank), {}));
                break;
            default:
                console.log('Unknown message type:', message.type);
                setBg('white');
                break;
        }
    }, [
        message
    ]);
    const userStore = (0, $8DltC.useUserStore)();
    const [bg, setBg] = (0, $2NacA.useState)('');
    const [icon, setIcon] = (0, $2NacA.useState)(/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
        content: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
            children: [
                userStore.user.first_name,
                " ",
                userStore.user.last_name
            ]
        }),
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {})
    }));
    const [myMsg, setMyMsg] = (0, $2NacA.useState)(message.user_id === userStore.user.id);
    const [isSystemMsg, setIsSystemMsg] = (0, $2NacA.useState)(false);
    return isSystemMsg ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        margin: "small",
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            size: "xsmall",
            color: "light-5",
            children: message.text
        })
    }, message.id) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: myMsg ? 'row-reverse' : 'row',
        flex: false,
        margin: "small",
        align: "end",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                align: "center",
                justify: "end",
                margin: "xsmall",
                height: "40px",
                width: "40px",
                children: icon
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                background: bg,
                flex: "grow",
                border: {
                    color: '#d9d9e3'
                },
                round: "small",
                width: {
                    max: '90%'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        pad: "small",
                        overflow: "wrap",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: message.text?.split('\n').map((line, index)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        children: [
                                            $e501e852110f8ca8$var$renderLineWithMentions(line),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)("br", {})
                                        ]
                                    }, `${line}-${index}`))
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                align: "start",
                                justify: "start",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    color: "light-5",
                                    children: message.created_at && (0, $dUDTx.parseIsoDateString)(message.created_at).time
                                })
                            })
                        ]
                    }),
                    !!message.sources?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1SpQX.Accordion), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kOwHr.AccordionPanel), {
                            label: "Sources",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $btRQT.Tabs), {
                                alignControls: "start",
                                children: message.sources.map((doc, docIndex)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                        title: docIndex + 1,
                                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "column",
                                            pad: "small",
                                            gap: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                    size: "small",
                                                    children: [
                                                        "(Excerpt from ",
                                                        /*#__PURE__*/ (0, $6ir3O.jsx)("a", {
                                                            href: doc.metadata.url,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: doc.metadata.source
                                                        }),
                                                        ")"
                                                    ]
                                                }),
                                                doc.pageContent && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                    pad: "small",
                                                    children: doc.pageContent.split('\n').map((line, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                            children: [
                                                                line,
                                                                /*#__PURE__*/ (0, $6ir3O.jsx)("br", {})
                                                            ]
                                                        }, i))
                                                })
                                            ]
                                        })
                                    }, docIndex))
                            })
                        })
                    }, `sourceDocsAccordion-${index}`)
                ]
            })
        ]
    }, message.id);
};

});
parcelRegister("1SpQX", function(module, exports) {

$parcel$export(module.exports, "Accordion", () => $15dee37de2e606df$export$a766cd26d0d69044);

var $2NacA = parcelRequire("2NacA");

var $7KkCo = parcelRequire("7KkCo");

var $5xcHk = parcelRequire("5xcHk");

var $1cJB9 = parcelRequire("1cJB9");
var $15dee37de2e606df$var$_excluded = [
    "activeIndex",
    "animate",
    "children",
    "level",
    "multiple",
    "onActive"
];
function $15dee37de2e606df$var$_extends() {
    return $15dee37de2e606df$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $15dee37de2e606df$var$_extends.apply(null, arguments);
}
function $15dee37de2e606df$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $15dee37de2e606df$var$activeAsArray = function activeAsArray(active) {
    return typeof active === 'number' ? [
        active
    ] : active;
};
var $15dee37de2e606df$export$a766cd26d0d69044 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var activeIndex = _ref.activeIndex, _ref$animate = _ref.animate, animate = _ref$animate === void 0 ? true : _ref$animate, children = _ref.children, level = _ref.level, multiple = _ref.multiple, onActive = _ref.onActive, rest = $15dee37de2e606df$var$_objectWithoutPropertiesLoose(_ref, $15dee37de2e606df$var$_excluded);
    var _useState = (0, $2NacA.useState)([]), activeIndexes = _useState[0], setActiveIndexes = _useState[1];
    var _useState2 = (0, $2NacA.useState)(), stateActiveIndex = _useState2[0], setStateActiveIndex = _useState2[1];
    // Derived state from props
    // https://reactjs.org/docs/hooks-faq.html#how-do-i-implement-getderivedstatefromprops
    var derivedActiveIndexes = $15dee37de2e606df$var$activeAsArray(activeIndex) || [];
    if ((typeof activeIndex !== 'undefined' || activeIndex !== stateActiveIndex) && derivedActiveIndexes.join() !== activeIndexes.join()) {
        setActiveIndexes(derivedActiveIndexes);
        setStateActiveIndex(activeIndex);
    }
    var getAccordionContext = (0, $2NacA.useCallback)(function(index) {
        var _onPanelChange = function onPanelChange(nextIndex) {
            var nextActiveIndexes = [].concat(activeIndexes || []);
            var nextActiveIndex = nextActiveIndexes.indexOf(nextIndex);
            if (nextActiveIndex > -1) nextActiveIndexes.splice(nextActiveIndex, 1);
            else if (multiple) nextActiveIndexes.push(nextIndex);
            else nextActiveIndexes = [
                nextIndex
            ];
            setActiveIndexes(nextActiveIndexes);
            if (onActive) onActive(nextActiveIndexes);
        };
        return {
            active: activeIndexes.indexOf(index) > -1,
            animate: animate,
            level: level,
            onPanelChange: function onPanelChange() {
                return _onPanelChange(index);
            }
        };
    }, [
        activeIndexes,
        animate,
        level,
        multiple,
        onActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $15dee37de2e606df$var$_extends({
        ref: ref
    }, rest), (0, $2NacA.Children).toArray(children).filter(function(child) {
        return child;
    }).map(function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1cJB9.AccordionContext).Provider, {
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            value: getAccordionContext(index)
        }, child);
    }));
});
$15dee37de2e606df$export$a766cd26d0d69044.propTypes = (0, $7KkCo.AccordionPropTypes);

});
parcelRegister("7KkCo", function(module, exports) {

$parcel$export(module.exports, "AccordionPropTypes", () => $5a3cd2a31400fb41$export$2e471fbf97c80661);


function $5a3cd2a31400fb41$var$_extends() {
    return $5a3cd2a31400fb41$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a3cd2a31400fb41$var$_extends.apply(null, arguments);
}
var $5a3cd2a31400fb41$var$PropType = {};
var $5a3cd2a31400fb41$export$2e471fbf97c80661 = $5a3cd2a31400fb41$var$PropType;

});

parcelRegister("1cJB9", function(module, exports) {

$parcel$export(module.exports, "AccordionContext", () => $0e0a4844adf91838$export$6bd5bb82c987ab74);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $0e0a4844adf91838$export$6bd5bb82c987ab74 = /*#__PURE__*/ (0, $2NacA.createContext)({});

});


parcelRegister("kOwHr", function(module, exports) {

$parcel$export(module.exports, "AccordionPanel", () => $f271d7a76b2d2db2$export$7cad6f17fd6e117b);

var $2NacA = parcelRequire("2NacA");

var $d2fh4 = parcelRequire("d2fh4");
var $fzxBh = parcelRequire("fzxBh");
var $gtU8v = parcelRequire("gtU8v");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $cdwIe = parcelRequire("cdwIe");

var $1fLUh = parcelRequire("1fLUh");

var $1cJB9 = parcelRequire("1cJB9");

var $jIipe = parcelRequire("jIipe");

var $eL6w3 = parcelRequire("eL6w3");
var $f271d7a76b2d2db2$var$_excluded = [
    "children",
    "header",
    "id",
    "label",
    "onClick",
    "onMouseOut",
    "onMouseOver",
    "onFocus",
    "onBlur"
];
function $f271d7a76b2d2db2$var$_extends() {
    return $f271d7a76b2d2db2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f271d7a76b2d2db2$var$_extends.apply(null, arguments);
}
function $f271d7a76b2d2db2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f271d7a76b2d2db2$export$7cad6f17fd6e117b = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$accordion$labe, _theme$accordion$icon;
    var children = _ref.children, header = _ref.header, id = _ref.id, label = _ref.label, onClick = _ref.onClick, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, _onFocus = _ref.onFocus, _onBlur = _ref.onBlur, rest = $f271d7a76b2d2db2$var$_objectWithoutPropertiesLoose(_ref, $f271d7a76b2d2db2$var$_excluded);
    var panelButtonId = (0, $gtU8v.useId)();
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var _useContext = (0, $2NacA.useContext)((0, $1cJB9.AccordionContext)), active = _useContext.active, animate = _useContext.animate, level = _useContext.level, onPanelChange = _useContext.onPanelChange;
    var _useState = (0, $2NacA.useState)(undefined), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, $2NacA.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var iconColor = (0, $2NacA.useMemo)(function() {
        return (0, $d2fh4.normalizeColor)(theme.accordion.icons.color || 'control', theme);
    }, [
        theme
    ]);
    var AccordionIcon = (0, $2NacA.useMemo)(function() {
        return active ? theme.accordion.icons.collapse : theme.accordion.icons.expand;
    }, [
        active,
        theme.accordion.icons
    ]);
    var defaultHoverColor = JSON.stringify({
        dark: 'light-4',
        light: 'dark-3'
    });
    // accordion.hover.color will be deprecated in v3.
    if (JSON.stringify(theme.accordion.hover.color) !== defaultHoverColor) console.warn("The theme style for accordion.hover.color is deprecated,\n        use accordion.hover.heading.color instead.");
    // accordion.hover.heading.color will trump accordion.hover.color in case
    // the user sets its value to be any other value than the
    // default value (defaultHoverColor).
    // accordion.hover.color will be deprecated in v3.
    var headingColor = theme.accordion.hover && JSON.stringify(theme.accordion.hover.heading.color) !== defaultHoverColor ? theme.accordion.hover.heading.color : theme.accordion.hover.color;
    var contentBorder = theme.accordion.border;
    var panelBorder = theme.accordion.panel.border;
    var abutMargin;
    if (panelBorder) // abutMargin 'bottom' is set to overlap adjacent border panels
    abutMargin = {
        bottom: "-" + (0, $fzxBh.parseMetricToNum)(// in case border.size defined as a t-shirt size
        // or in case border size is a custom size i.e. '5px'
        theme.global.borderSize[panelBorder.size] || panelBorder.size || theme.global.borderSize.xsmall // '-1px'
        ) + "px"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        ref: ref,
        flex: false,
        onClick: onClick,
        border: panelBorder,
        margin: abutMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        id: panelButtonId,
        "aria-expanded": active,
        plain: theme.button["default"] ? true : undefined,
        onClick: onPanelChange,
        hoverIndicator: theme.accordion.hover.background,
        onMouseOver: function onMouseOver(event) {
            setHover(headingColor);
            if (_onMouseOver) _onMouseOver(event);
        },
        onMouseOut: function onMouseOut(event) {
            setHover(undefined);
            if (_onMouseOut) _onMouseOut(event);
        },
        onFocus: function onFocus(event) {
            setHover(headingColor);
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setHover(undefined);
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        style: focus ? {
            zIndex: 1
        } : undefined
    }, header || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $f271d7a76b2d2db2$var$_extends({
        align: "center",
        direction: "row",
        justify: "between",
        id: id
    }, rest), typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: (_theme$accordion$labe = theme.accordion.label) == null || (_theme$accordion$labe = _theme$accordion$labe.container) == null ? void 0 : _theme$accordion$labe.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1fLUh.Heading), {
        level: level || theme.accordion.heading && theme.accordion.heading.level || 4,
        margin: theme.accordion.heading && theme.accordion.heading.margin || undefined,
        color: hover
    }, label)) : label, AccordionIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: (_theme$accordion$icon = theme.accordion.icon) == null || (_theme$accordion$icon = _theme$accordion$icon.container) == null ? void 0 : _theme$accordion$icon.pad,
        width: {
            min: 'fit-content'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(AccordionIcon, {
        color: iconColor
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        role: "region",
        border: contentBorder,
        "aria-labelledby": panelButtonId
    }, animate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cdwIe.Collapsible), {
        open: active
    }, children) : active && children));
});
$f271d7a76b2d2db2$export$7cad6f17fd6e117b.displayName = 'AccordionPanel';
$f271d7a76b2d2db2$export$7cad6f17fd6e117b.propTypes = (0, $jIipe.AccordionPanelPropTypes);

});
parcelRegister("gtU8v", function(module, exports) {

$parcel$export(module.exports, "useId", () => $bffae64073214f0f$export$f680877a34711e37);

var $2NacA = parcelRequire("2NacA");
var $bffae64073214f0f$var$_React$useId;
var $bffae64073214f0f$var$currentId = 0;
var $bffae64073214f0f$var$getId = function getId() {
    // eslint-disable-next-line no-plusplus
    var id = $bffae64073214f0f$var$currentId++;
    return ":r" + id.toString(32) + ":";
};
var $bffae64073214f0f$var$useIdGrommet = function useIdGrommet() {
    var _useState = (0, $2NacA.useState)($bffae64073214f0f$var$getId), id = _useState[0];
    return id;
};
// Polyfill React 18's useId for compatibility with React 16 and 17
var $bffae64073214f0f$export$f680877a34711e37 = ($bffae64073214f0f$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useId) != null ? $bffae64073214f0f$var$_React$useId : $bffae64073214f0f$var$useIdGrommet;

});

parcelRegister("cdwIe", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $8e5012f50f84abb6$export$6eb0f7ddcda6131f);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $hHZ58 = parcelRequire("hHZ58");

var $dOlbm = parcelRequire("dOlbm");

var $5xcHk = parcelRequire("5xcHk");

var $1JNq9 = parcelRequire("1JNq9");

var $eL6w3 = parcelRequire("eL6w3");
var $8e5012f50f84abb6$var$AnimatedBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "Collapsible__AnimatedBox",
    componentId: "sc-15kniua-0"
})([
    "",
    ""
], function(props) {
    return props.shouldOpen ? "visibility: hidden;\n      position: absolute;\n      pointer-events: none;" : "transition: " + ("max-" + props.dimension + " " + props.speedProp + "ms, opacity " + props.speedProp + "ms") + ";\n      opacity: " + (props.open ? 1 : 0) + ";\n      overflow: " + (props.animate || !props.open ? 'hidden' : 'visible') + ";";
});
var $8e5012f50f84abb6$export$6eb0f7ddcda6131f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var children = _ref.children, direction = _ref.direction, openArg = _ref.open;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var _useState = (0, $2NacA.useState)(openArg), open = _useState[0], setOpen = _useState[1];
    var _useState2 = (0, $2NacA.useState)(false), animate = _useState2[0], setAnimate = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(theme.collapsible.minSpeed), speed = _useState3[0], setSpeed = _useState3[1];
    var dimension = (0, $2NacA.useMemo)(function() {
        return direction === 'horizontal' ? 'width' : 'height';
    }, [
        direction
    ]);
    var containerRef = (0, $dOlbm.useForwardedRef)(ref);
    var sizeRef = (0, $2NacA.useRef)(0);
    var shouldOpen = !open && openArg;
    var shouldClose = open && !openArg;
    // when the caller changes openArg, trigger animation
    (0, $2NacA.useEffect)(function() {
        if (openArg !== open) {
            setAnimate(true);
            setOpen(openArg);
        }
    }, [
        open,
        openArg
    ]);
    // prepare to open or close
    (0, $hHZ58.useLayoutEffect)(function() {
        var container = containerRef.current;
        // skip this if animation is in progress
        if (!animate && shouldOpen) {
            var parentPrevPosition = container.parentNode.style.position;
            container.parentNode.style.position = 'relative';
            var _container$getBoundin = container.getBoundingClientRect(), size = _container$getBoundin[dimension];
            container.parentNode.style.position = parentPrevPosition;
            sizeRef.current = size;
        }
        if (shouldOpen) container.style["max-" + dimension] = 0;
        else if (shouldClose) {
            var _container$getBoundin2 = container.getBoundingClientRect(), _size = _container$getBoundin2[dimension];
            container.style["max-" + dimension] = _size + "px";
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        animate
    ]);
    (0, $2NacA.useEffect)(function() {
        if (shouldOpen || shouldClose) {
            var container = containerRef.current;
            var _theme$collapsible = theme.collapsible, minSpeed = _theme$collapsible.minSpeed, baseline = _theme$collapsible.baseline;
            var nextSpeed = Math.max(sizeRef.current / baseline * minSpeed, minSpeed);
            setSpeed(nextSpeed);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    // Change the max to where we want to end up, the transition will
                    // animate to get there. We do this in an animation frame to
                    // give our starter setting a chance to fully render.
                    container.style["max-" + dimension] = shouldOpen ? sizeRef.current + "px" : 0;
                });
            });
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        theme
    ]);
    (0, $2NacA.useEffect)(function() {
        if (animate) {
            var container = containerRef.current;
            var timer = setTimeout(function() {
                setAnimate(false);
                container.removeAttribute('style');
            }, speed);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    // we need open here to cancel the timer and restart it
    }, [
        animate,
        containerRef,
        speed,
        open
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($8e5012f50f84abb6$var$AnimatedBox, {
        "aria-hidden": !open,
        ref: containerRef,
        open: open,
        animate: animate,
        dimension: dimension,
        speedProp: speed,
        shouldOpen: !animate && shouldOpen
    }, shouldOpen || open || animate ? children : null);
});
$8e5012f50f84abb6$export$6eb0f7ddcda6131f.displayName = 'Collapsible';
$8e5012f50f84abb6$export$6eb0f7ddcda6131f.propTypes = (0, $1JNq9.CollapsiblePropTypes);

});
parcelRegister("1JNq9", function(module, exports) {

$parcel$export(module.exports, "CollapsiblePropTypes", () => $14405457967100c4$export$2c6a2ea456400009);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $14405457967100c4$var$PropType = {};
var $14405457967100c4$export$2c6a2ea456400009 = $14405457967100c4$var$PropType;

});


parcelRegister("jIipe", function(module, exports) {

$parcel$export(module.exports, "AccordionPanelPropTypes", () => $e5a0676dcb352cea$export$e0f57d1c561c3ce4);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $e5a0676dcb352cea$var$PropType = {};
var $e5a0676dcb352cea$export$e0f57d1c561c3ce4 = $e5a0676dcb352cea$var$PropType;

});


parcelRegister("b5MFC", function(module, exports) {

$parcel$export(module.exports, "Tab", () => $8135ea40be1d733b$export$3e41faf802a29e71);

var $2NacA = parcelRequire("2NacA");

var $a26J5 = parcelRequire("a26J5");

var $kS7Ii = parcelRequire("kS7Ii");

var $lsplc = parcelRequire("lsplc");

var $d2fh4 = parcelRequire("d2fh4");
var $dOlbm = parcelRequire("dOlbm");

var $5OwOw = parcelRequire("5OwOw");

var $1H0YQ = parcelRequire("1H0YQ");

var $hHZ58 = parcelRequire("hHZ58");

var $eL6w3 = parcelRequire("eL6w3");
var $8135ea40be1d733b$var$_excluded = [
    "active",
    "disabled",
    "children",
    "icon",
    "plain",
    "title",
    "onBlur",
    "onFocus",
    "onMouseOver",
    "onMouseOut",
    "reverse",
    "onClick",
    "onKeyDown"
];
function $8135ea40be1d733b$var$_extends() {
    return $8135ea40be1d733b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8135ea40be1d733b$var$_extends.apply(null, arguments);
}
function $8135ea40be1d733b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8135ea40be1d733b$export$3e41faf802a29e71 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.active, disabled = _ref.disabled, children = _ref.children, icon = _ref.icon, plain = _ref.plain, title = _ref.title, _onBlur = _ref.onBlur, _onFocus = _ref.onFocus, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, reverse = _ref.reverse, onClick = _ref.onClick, onKeyDown = _ref.onKeyDown, rest = $8135ea40be1d733b$var$_objectWithoutPropertiesLoose(_ref, $8135ea40be1d733b$var$_excluded);
    var _useContext = (0, $2NacA.useContext)((0, $lsplc.TabsContext)), active = _useContext.active, activeIndex = _useContext.activeIndex, focusable = _useContext.focusable, index = _useContext.index, panelId = _useContext.panelId, tabsContextRef = _useContext.ref, onActivate = _useContext.onActivate, onTabsKeyDown = _useContext.onKeyDown, setActiveContent = _useContext.setActiveContent, setActiveTitle = _useContext.setActiveTitle, setFocusIndex = _useContext.setFocusIndex;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2NacA.useState)(undefined), over = _useState[0], setOver = _useState[1];
    var normalizedTitle = title;
    var tabStyles = {};
    var tabRef = (0, $dOlbm.useForwardedRef)(ref);
    (0, $hHZ58.useLayoutEffect)(function() {
        if (tabRef.current && tabsContextRef) tabsContextRef.current = tabRef.current;
    });
    (0, $hHZ58.useLayoutEffect)(function() {
        if (active) {
            setActiveContent(children);
            var activeTitle = typeof title === 'string' ? title : activeIndex + 1;
            setActiveTitle(activeTitle);
        }
    }, [
        active,
        activeIndex,
        children,
        setActiveContent,
        setActiveTitle,
        title
    ]);
    var onMouseOverTab = function onMouseOverTab(event) {
        setOver(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutTab = function onMouseOutTab(event) {
        setOver(undefined);
        if (onMouseOut) onMouseOut(event);
    };
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
    }
    var onClickTab = function onClickTab(event) {
        if (event) event.preventDefault();
        onActivate();
        if (onClick) onClick(event);
    };
    var onKeyDownTab = function onKeyDownTab(event) {
        if (disabled) return;
        onTabsKeyDown(event);
        if (onKeyDown) onKeyDown(event);
    };
    if (active && disabled) console.warn("Warning: Tab props 'active' and 'disabled' have both been set to TRUE on the same Tab resulting in an interesting Tab state. Is this your intent?");
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
        if (theme.tab.border) {
            var borderColor = theme.tab.border.color || theme.global.control.border.color;
            if (active) borderColor = theme.tab.border.active.color || borderColor;
            else if (disabled && theme.tab.border.disabled) borderColor = theme.tab.border.disabled.color || borderColor;
            else if (over) borderColor = theme.tab.border.hover.color || borderColor;
            borderColor = (0, $d2fh4.normalizeColor)(borderColor, theme);
            tabStyles.border = {
                side: theme.tab.border.side,
                size: theme.tab.border.size,
                color: borderColor
            };
        }
        tabStyles.background = active ? theme.tab.active.background || theme.tab.background : theme.tab.background;
        tabStyles.pad = theme.tab.pad;
        tabStyles.margin = theme.tab.margin;
    }
    // needed to apply hover/active styles to the icon
    var renderIcon = function renderIcon(iconProp) {
        if (active) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(iconProp, $8135ea40be1d733b$var$_extends({}, theme.tab.active));
        if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(iconProp, $8135ea40be1d733b$var$_extends({}, theme.tab.disabled));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(iconProp, {
            color: over ? theme.tab.hover.color : theme.tab.color
        });
    };
    var normalizedIcon;
    if (icon) normalizedIcon = renderIcon(icon);
    var first = reverse ? normalizedTitle : normalizedIcon;
    var second = reverse ? normalizedIcon : normalizedTitle;
    var withIconStyles;
    if (first && second) {
        var _theme$tab;
        withIconStyles = {
            direction: 'row',
            align: 'center',
            justify: 'center',
            gap: (_theme$tab = theme.tab) == null ? void 0 : _theme$tab.gap
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), $8135ea40be1d733b$var$_extends({
        ref: tabRef,
        plain: true,
        role: "tab",
        tabIndex: focusable ? 0 : -1,
        "aria-controls": panelId,
        "aria-selected": active,
        disabled: disabled
    }, rest, {
        onClick: onClickTab,
        onKeyDown: onKeyDownTab,
        onMouseOver: onMouseOverTab,
        onMouseOut: onMouseOutTab,
        onFocus: function onFocus(event) {
            if (_onFocus) _onFocus(event);
            setFocusIndex(index);
        },
        onBlur: function onBlur(event) {
            if (_onBlur) _onBlur(event);
            setFocusIndex(-1);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5OwOw.StyledTab), $8135ea40be1d733b$var$_extends({
        disabled: disabled,
        plain: plain
    }, withIconStyles, tabStyles, passThemeFlag), first, second));
});
$8135ea40be1d733b$export$3e41faf802a29e71.displayName = 'Tab';
$8135ea40be1d733b$export$3e41faf802a29e71.propTypes = (0, $1H0YQ.TabPropTypes);

});
parcelRegister("lsplc", function(module, exports) {

$parcel$export(module.exports, "TabsContext", () => $f9efdea76393d1a4$export$cfa7aa87c26e7d1f);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $f9efdea76393d1a4$export$cfa7aa87c26e7d1f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext({});

});

parcelRegister("5OwOw", function(module, exports) {

$parcel$export(module.exports, "StyledTab", () => $43bb136ebe407d90$export$f43fc23d58ee4c2);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");
var $43bb136ebe407d90$var$tabHoverStyle = (0, $f5efw.css)([
    "&:hover{",
    " ",
    " ",
    ";}&:focus{z-index:1;}"
], function(props) {
    return props.theme.tab.hover.background && (0, $f5efw.css)([
        "background:",
        ";"
    ], (0, $d2fh4.normalizeColor)(props.theme.tab.hover.background, props.theme));
}, function(props) {
    return props.theme.tab.hover.color && (0, $f5efw.css)([
        "color:",
        ";"
    ], (0, $d2fh4.normalizeColor)(props.theme.tab.hover.color, props.theme));
}, function(props) {
    return props.theme.tab.hover.extend;
});
var $43bb136ebe407d90$export$f43fc23d58ee4c2 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledTab",
    componentId: "sc-1nnwnsb-0"
})([
    "white-space:nowrap;",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return !props.plain && !props.disabled && props.theme.tab.hover && $43bb136ebe407d90$var$tabHoverStyle;
}, function(props) {
    return props.disabled && props.theme.tab.disabled;
}, function(props) {
    return props.theme.tab.extend;
});

});

parcelRegister("1H0YQ", function(module, exports) {

$parcel$export(module.exports, "TabPropTypes", () => $13ba91443d60b7e5$export$5ced29b443316d9);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $13ba91443d60b7e5$var$PropType = {};
var $13ba91443d60b7e5$export$5ced29b443316d9 = $13ba91443d60b7e5$var$PropType;

});


parcelRegister("btRQT", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $85bc2d0eaddd1bb1$export$b2539bed5023c21c);

var $2NacA = parcelRequire("2NacA");

var $b0HeC = parcelRequire("b0HeC");

var $9AmjO = parcelRequire("9AmjO");

var $hHZ58 = parcelRequire("hHZ58");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $lsplc = parcelRequire("lsplc");

var $4zRSZ = parcelRequire("4zRSZ");

var $9A1Dq = parcelRequire("9A1Dq");

var $d2fh4 = parcelRequire("d2fh4");
var $gtU8v = parcelRequire("gtU8v");

var $2M0UK = parcelRequire("2M0UK");

var $7hN5M = parcelRequire("7hN5M");

var $hbZKz = parcelRequire("hbZKz");

var $eL6w3 = parcelRequire("eL6w3");
var $85bc2d0eaddd1bb1$var$_excluded = [
    "alignControls",
    "children",
    "flex",
    "justify",
    "messages",
    "responsive"
];
function $85bc2d0eaddd1bb1$var$_extends() {
    return $85bc2d0eaddd1bb1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $85bc2d0eaddd1bb1$var$_extends.apply(null, arguments);
}
function $85bc2d0eaddd1bb1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $85bc2d0eaddd1bb1$export$b2539bed5023c21c = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$tabs$header, _theme$tabs$header2, _theme$tabs$header3, _theme$tabs$header4;
    var alignControls = _ref.alignControls, children = _ref.children, flex = _ref.flex, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, messages = _ref.messages, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, rest = $85bc2d0eaddd1bb1$var$_objectWithoutPropertiesLoose(_ref, $85bc2d0eaddd1bb1$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var propsActiveIndex = rest.activeIndex, onActive = rest.onActive;
    var _useState = (0, $2NacA.useState)(rest.activeIndex || 0), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $2NacA.useState)(), activeContent = _useState2[0], setActiveContent = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(), activeTitle = _useState3[0], setActiveTitle = _useState3[1];
    var _useState4 = (0, $2NacA.useState)(), disableLeftArrow = _useState4[0], setDisableLeftArrow = _useState4[1];
    var _useState5 = (0, $2NacA.useState)(), disableRightArrow = _useState5[0], setDisableRightArrow = _useState5[1];
    var _useState6 = (0, $2NacA.useState)(), overflow = _useState6[0], setOverflow = _useState6[1];
    var _useState7 = (0, $2NacA.useState)(-1), focusIndex = _useState7[0], setFocusIndex = _useState7[1];
    var headerRef = (0, $2NacA.useRef)();
    var panelId = (0, $gtU8v.useId)();
    var size = (0, $2NacA.useContext)((0, $4zRSZ.ResponsiveContext));
    var PreviousIcon = ((_theme$tabs$header = theme.tabs.header) == null || (_theme$tabs$header = _theme$tabs$header.previousButton) == null ? void 0 : _theme$tabs$header.icon) || (0, $b0HeC.Previous);
    var NextIcon = ((_theme$tabs$header2 = theme.tabs.header) == null || (_theme$tabs$header2 = _theme$tabs$header2.nextButton) == null ? void 0 : _theme$tabs$header2.icon) || (0, $9AmjO.Next);
    var sendAnalytics = (0, $hbZKz.useAnalytics)();
    if (activeIndex !== propsActiveIndex && propsActiveIndex !== undefined) setActiveIndex(propsActiveIndex);
    // Safari v15.5 has an issue with scrolling when overflow='hidden'
    // and scroll-behavior='smooth'. For now we are detecting if the browser
    // is safari to workaround this issue. The issue should be resolved soon
    // and we can remove this. https://github.com/WebKit/WebKit/pull/1387
    var isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent) : true;
    /* eslint-disable no-param-reassign */ delete rest.activeIndex;
    delete rest.onActive;
    /* eslint-enable no-param-reassign */ var tabRefs = (0, $2NacA.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Children.map(children, function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createRef();
        });
    }, [
        children
    ]);
    var disabledIndexes = (0, $2NacA.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Children.map(children, function(child) {
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).isValidElement(child)) return true;
            return !!child.props.disabled;
        }) || [];
    }, [
        children
    ]);
    var focusTab = (0, $2NacA.useCallback)(function(index) {
        var _tabRefs$index;
        if (index >= 0 && (_tabRefs$index = tabRefs[index]) != null && _tabRefs$index.current) tabRefs[index].current.focus();
    }, [
        tabRefs
    ]);
    var findEnabledIndex = (0, $2NacA.useCallback)(function(startIndex, direction) {
        if (!disabledIndexes.length) return undefined;
        var normalizeIndex = function normalizeIndex(index) {
            if (index < 0) return disabledIndexes.length - 1;
            if (index >= disabledIndexes.length) return 0;
            return index;
        };
        var nextIndex = normalizeIndex(startIndex);
        var attempts = 0;
        while(attempts < disabledIndexes.length){
            if (!disabledIndexes[nextIndex]) return nextIndex;
            nextIndex = normalizeIndex(nextIndex + direction);
            attempts += 1;
        }
        return undefined;
    }, [
        disabledIndexes
    ]);
    var getClosestEnabledIndex = (0, $2NacA.useCallback)(function(preferredIndex) {
        if (!disabledIndexes.length) return undefined;
        var clampedIndex = Math.min(Math.max(preferredIndex, 0), disabledIndexes.length - 1);
        if (!disabledIndexes[clampedIndex]) return clampedIndex;
        for(var offset = 1; offset < disabledIndexes.length; offset += 1){
            var nextIndex = clampedIndex + offset;
            if (nextIndex < disabledIndexes.length && !disabledIndexes[nextIndex]) return nextIndex;
            var previousIndex = clampedIndex - offset;
            if (previousIndex >= 0 && !disabledIndexes[previousIndex]) return previousIndex;
        }
        return undefined;
    }, [
        disabledIndexes
    ]);
    var resolvedActiveIndex = (0, $2NacA.useMemo)(function() {
        if (!disabledIndexes.length) return undefined;
        if (activeIndex < 0 || activeIndex >= disabledIndexes.length) return getClosestEnabledIndex(activeIndex);
        if (disabledIndexes[activeIndex]) return getClosestEnabledIndex(activeIndex);
        return activeIndex;
    }, [
        activeIndex,
        disabledIndexes,
        getClosestEnabledIndex
    ]);
    var activateTab = (0, $2NacA.useCallback)(function(nextIndex) {
        sendAnalytics({
            type: 'activateTab',
            element: tabRefs[nextIndex].current
        });
        if (propsActiveIndex === undefined) setActiveIndex(nextIndex);
        if (onActive) onActive(nextIndex);
    }, [
        onActive,
        propsActiveIndex,
        sendAnalytics,
        tabRefs
    ]);
    var moveFocus = (0, $2NacA.useCallback)(function(targetIndex) {
        if (targetIndex === undefined) return;
        focusTab(targetIndex);
    }, [
        focusTab
    ]);
    var moveFocusByKey = (0, $2NacA.useCallback)(function(currentIndex, direction) {
        moveFocus(findEnabledIndex(currentIndex + direction, direction));
    }, [
        findEnabledIndex,
        moveFocus
    ]);
    var moveFocusToEdge = (0, $2NacA.useCallback)(function(direction) {
        var startIndex = direction > 0 ? 0 : tabRefs.length - 1;
        moveFocus(findEnabledIndex(startIndex, direction));
    }, [
        findEnabledIndex,
        moveFocus,
        tabRefs.length
    ]);
    var handleTabKeyDown = (0, $2NacA.useCallback)(function(index, event) {
        switch(event.key){
            case 'ArrowRight':
                event.preventDefault();
                moveFocusByKey(index, 1);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                moveFocusByKey(index, -1);
                break;
            case 'Home':
                event.preventDefault();
                moveFocusToEdge(1);
                break;
            case 'End':
                event.preventDefault();
                moveFocusToEdge(-1);
                break;
            case 'Enter':
            case ' ':
            case 'Spacebar':
                event.preventDefault();
                activateTab(index);
                break;
            default:
        }
    }, [
        activateTab,
        moveFocusByKey,
        moveFocusToEdge
    ]);
    // check if tab is in view
    var isVisible = (0, $2NacA.useCallback)(function(index) {
        if (tabRefs[index].current) {
            var _headerRef$current;
            var tabRect = tabRefs[index].current.getBoundingClientRect();
            var headerRect = (_headerRef$current = headerRef.current) == null ? void 0 : _headerRef$current.getBoundingClientRect();
            if (tabRect && headerRect) // the -1 and +1 allow a little leniency when calculating if a tab
            // is in view. Without the -1 and +1 a tab could be fully in view
            // but isVisible will return false.
            return tabRect.left >= headerRect.left - 1 && tabRect.right <= headerRect.right + 1;
        }
        return undefined;
    }, [
        headerRef,
        tabRefs
    ]);
    var updateArrowState = (0, $2NacA.useCallback)(function() {
        setDisableLeftArrow(isVisible(0));
        setDisableRightArrow(isVisible(tabRefs.length - 1));
    }, [
        tabRefs,
        isVisible
    ]);
    var scrollTo = (0, $2NacA.useCallback)(function(index, keyboard) {
        var tabRect = tabRefs[index].current.getBoundingClientRect();
        var headerRect = headerRef.current.getBoundingClientRect();
        var amountHidden = 0;
        if (tabRect.left >= headerRect.left && tabRect.left <= headerRect.right) amountHidden = tabRect.width - (headerRect.right - tabRect.left);
        else if (tabRect.right >= headerRect.left && tabRect.right <= headerRect.right) {
            amountHidden = tabRect.width - (tabRect.right - headerRect.left);
            amountHidden = 0 - amountHidden;
        } else if (tabRect.left >= headerRect.right) amountHidden = tabRect.right - headerRect.right;
        else if (tabRect.right <= headerRect.left) {
            amountHidden = headerRect.left - tabRect.left;
            amountHidden = 0 - amountHidden;
        }
        // We are adding or subtracting 2 from amountHidden to
        // ensure the focusIndicator is visible when navigating
        // by keyboard
        if (keyboard) {
            if (amountHidden < 0) amountHidden -= 2;
            if (amountHidden > 0) amountHidden += 2;
        }
        if (isSafari) headerRef.current.scrollBy({
            left: amountHidden
        });
        else headerRef.current.scrollBy({
            left: amountHidden,
            behavior: 'smooth'
        });
        // wait for scroll animation to finish
        // checks every 50 milliseconds for 1000 milliseconds
        // if the scroll animation has finished. Most scroll
        // animations will finish in 1000 milliseconds unless
        // the tab name is very long.
        if (isSafari) updateArrowState();
        else {
            var checkVisible = setInterval(function() {
                if (tabRefs[index].current && isVisible(index)) {
                    updateArrowState();
                    clearInterval(checkVisible);
                }
            }, 50);
            setTimeout(function() {
                updateArrowState();
                clearInterval(checkVisible);
            }, 1000);
        }
    }, [
        tabRefs,
        headerRef,
        isVisible,
        updateArrowState,
        isSafari
    ]);
    var moveByArrowKey = function moveByArrowKey(direction) {
        var previous = direction === 'previous';
        var index = direction === 'previous' ? 0 : tabRefs.length - 1;
        var scrolledToIndex;
        var moveBy = theme.tabs.step[size] - 1 || 0;
        while(scrolledToIndex === undefined && (previous && index < tabRefs.length - 1 || !previous && index > 0)){
            if (!isVisible(index) && (previous && isVisible(index + 1) || !previous && isVisible(index - 1))) {
                if (previous) {
                    if (index - moveBy >= 0) {
                        scrollTo(index - moveBy, false);
                        scrolledToIndex = index - moveBy;
                    } else {
                        scrollTo(0, false);
                        scrolledToIndex = 0;
                    }
                } else if (index + moveBy < tabRefs.length) {
                    scrollTo(index + moveBy, false);
                    scrolledToIndex = index + moveBy;
                } else {
                    scrollTo(tabRefs.length - 1, false);
                    scrolledToIndex = tabRefs.length - 1;
                }
            }
            index = previous ? index + 1 : index - 1;
        }
    };
    (0, $2NacA.useEffect)(function() {
        var _tabRefs$resolvedActi;
        // if the active tab isn't visible scroll to it
        if (overflow && tabRefs && resolvedActiveIndex !== undefined && (_tabRefs$resolvedActi = tabRefs[resolvedActiveIndex]) != null && _tabRefs$resolvedActi.current && !isVisible(resolvedActiveIndex)) scrollTo(resolvedActiveIndex, true);
    }, [
        overflow,
        resolvedActiveIndex,
        tabRefs,
        isVisible,
        scrollTo
    ]);
    (0, $2NacA.useEffect)(function() {
        // scroll focus item into view if it is not already visible
        if (overflow && focusIndex !== -1 && !isVisible(focusIndex)) scrollTo(focusIndex, true);
        else if (overflow && focusIndex !== -1) {
            // If the browser scrolled the focused item into view and
            // the focusedTab is on the edge of the header container
            // scroll slightly further to show the focusIndicator
            var tabRect = tabRefs[focusIndex].current.getBoundingClientRect();
            var headerRect = headerRef.current.getBoundingClientRect();
            var amountHidden = 0;
            if (tabRect.left >= headerRect.left && tabRect.right <= headerRect.right && tabRect.right + 2 >= headerRect.right) amountHidden = 2;
            else if (tabRect.right <= headerRect.right && tabRect.left >= headerRect.left && tabRect.left - 2 <= headerRect.left) amountHidden = -2;
            headerRef.current.scrollBy({
                left: amountHidden
            });
        }
    }, [
        overflow,
        tabRefs,
        focusIndex,
        isVisible,
        scrollTo
    ]);
    (0, $hHZ58.useLayoutEffect)(function() {
        var onResize = function onResize() {
            // check if tabs are overflowing
            if (headerRef.current.scrollWidth > headerRef.current.offsetWidth) setOverflow(true);
            else setOverflow(false);
            updateArrowState();
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function() {
            return window.removeEventListener('resize', onResize);
        };
    }, [
        tabRefs,
        activeIndex,
        headerRef,
        updateArrowState
    ]);
    (0, $hHZ58.useLayoutEffect)(function() {
        if (focusIndex === -1 || !headerRef.current) return;
        var _document = document, activeElement = _document.activeElement;
        if (headerRef.current.contains(activeElement)) return;
        var nextFocusIndex = getClosestEnabledIndex(focusIndex);
        if (nextFocusIndex === undefined) {
            setFocusIndex(-1);
            return;
        }
        setFocusIndex(nextFocusIndex);
        focusTab(nextFocusIndex);
    }, [
        children,
        focusIndex,
        focusTab,
        getClosestEnabledIndex
    ]);
    var getTabsContext = (0, $2NacA.useCallback)(function(index) {
        return {
            activeIndex: resolvedActiveIndex,
            active: resolvedActiveIndex === index,
            focusable: focusIndex === -1 ? resolvedActiveIndex === index : focusIndex === index,
            index: index,
            panelId: panelId,
            ref: tabRefs[index],
            onActivate: function onActivate() {
                return activateTab(index);
            },
            onKeyDown: function onKeyDown(event) {
                return handleTabKeyDown(index, event);
            },
            onNext: function onNext() {
                return moveFocusByKey(index, 1);
            },
            onPrevious: function onPrevious() {
                return moveFocusByKey(index, -1);
            },
            onFirst: function onFirst() {
                return moveFocusToEdge(1);
            },
            onLast: function onLast() {
                return moveFocusToEdge(-1);
            },
            setActiveContent: setActiveContent,
            setActiveTitle: setActiveTitle,
            setFocusIndex: setFocusIndex
        };
    }, [
        focusIndex,
        activateTab,
        handleTabKeyDown,
        moveFocusByKey,
        moveFocusToEdge,
        panelId,
        resolvedActiveIndex,
        tabRefs
    ]);
    var tabs = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Children.map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $lsplc.TabsContext).Provider, {
            value: getTabsContext(index)
        }, child ? /*#__PURE__*/ // cloneElement is needed for backward compatibility with custom
        // styled components that rely on props.active. We should reassess
        // if it is still necessary in our next major release.
        (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(child, {
            active: resolvedActiveIndex === index
        }) : child);
    });
    var tabsHeaderStyles = {};
    if (theme.tabs.header && theme.tabs.header.border) {
        var borderColor = theme.tabs.header.border.color || theme.global.control.border.color;
        borderColor = (0, $d2fh4.normalizeColor)(borderColor, theme);
        tabsHeaderStyles.border = {
            side: theme.tabs.header.border.side,
            size: theme.tabs.header.border.size,
            style: theme.tabs.header.border.style,
            color: borderColor
        };
    }
    var tabContentTitle = (activeTitle || '') + " " + format({
        id: 'tabs.tabContents',
        messages: messages
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $9A1Dq.StyledTabs), $85bc2d0eaddd1bb1$var$_extends({
        ref: ref,
        flex: flex,
        responsive: responsive
    }, passThemeFlag, rest, {
        background: theme.tabs.background
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $85bc2d0eaddd1bb1$var$_extends({
        alignSelf: alignControls || ((_theme$tabs$header3 = theme.tabs.header) == null ? void 0 : _theme$tabs$header3.alignSelf),
        flex: false,
        direction: overflow ? 'row' : 'column'
    }, tabsHeaderStyles), overflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        a11yTitle: format({
            id: 'tabs.previousTab',
            messages: messages
        }),
        disabled: disableLeftArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('previous');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: theme.tabs.header.previousButton.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(PreviousIcon, {
        color: disableLeftArrow ? theme.button.disabled.color : theme.global.colors.text
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $9A1Dq.StyledTabsHeader), $85bc2d0eaddd1bb1$var$_extends({
        role: "tablist",
        ref: headerRef,
        direction: "row",
        justify: overflow ? 'start' : justify,
        flex: !!overflow,
        wrap: false,
        overflow: overflow ? 'hidden' : 'visible',
        background: theme.tabs.header.background,
        gap: theme.tabs.gap,
        pad: overflow ? '2px' : undefined,
        margin: overflow ? '-2px' : undefined
    }, passThemeFlag), tabs), overflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        a11yTitle: format({
            id: 'tabs.nextTab',
            messages: messages
        }),
        disabled: disableRightArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('next');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: (_theme$tabs$header4 = theme.tabs.header) == null || (_theme$tabs$header4 = _theme$tabs$header4.nextButton) == null ? void 0 : _theme$tabs$header4.pad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(NextIcon, {
        color: disableRightArrow ? theme.button.disabled.color : theme.global.colors.text
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $9A1Dq.StyledTabPanel), $85bc2d0eaddd1bb1$var$_extends({
        id: panelId,
        flex: flex,
        "aria-label": tabContentTitle,
        role: "tabpanel"
    }, passThemeFlag), activeContent));
});
$85bc2d0eaddd1bb1$export$b2539bed5023c21c.displayName = 'Tabs';
$85bc2d0eaddd1bb1$export$b2539bed5023c21c.propTypes = (0, $7hN5M.TabsPropTypes);

});
parcelRegister("9A1Dq", function(module, exports) {

$parcel$export(module.exports, "StyledTabsHeader", () => $6f98be80e214b8b4$export$9c5a323fcd5fd5a3);
$parcel$export(module.exports, "StyledTabPanel", () => $6f98be80e214b8b4$export$6dde272a8363b335);
$parcel$export(module.exports, "StyledTabs", () => $6f98be80e214b8b4$export$594ebcebca054019);

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $2O6LY = parcelRequire("2O6LY");
var $6f98be80e214b8b4$var$_FLEX_MAP;
var $6f98be80e214b8b4$export$9c5a323fcd5fd5a3 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledTabs__StyledTabsHeader",
    componentId: "sc-a4fwxl-0"
})([
    "",
    ";"
], function(props) {
    return props.theme.tabs.header.extend;
});
var $6f98be80e214b8b4$var$FLEX_MAP = ($6f98be80e214b8b4$var$_FLEX_MAP = {}, $6f98be80e214b8b4$var$_FLEX_MAP[true] = '1 1', $6f98be80e214b8b4$var$_FLEX_MAP[false] = '0 0', $6f98be80e214b8b4$var$_FLEX_MAP.grow = '1 0', $6f98be80e214b8b4$var$_FLEX_MAP.shrink = '0 1', $6f98be80e214b8b4$var$_FLEX_MAP);
var $6f98be80e214b8b4$var$flexStyle = (0, $f5efw.css)([
    "flex:",
    ";"
], function(props) {
    return "" + $6f98be80e214b8b4$var$FLEX_MAP[props.flex] + (props.flex !== true ? ' auto' : '');
});
var $6f98be80e214b8b4$export$6dde272a8363b335 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTabs__StyledTabPanel",
    componentId: "sc-a4fwxl-1"
})([
    "min-height:0;",
    " ",
    ";"
], function(props) {
    return props.flex && $6f98be80e214b8b4$var$flexStyle;
}, function(props) {
    return props.theme.tabs.panel.extend;
});
var $6f98be80e214b8b4$export$594ebcebca054019 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledTabs",
    componentId: "sc-a4fwxl-2"
})([
    "",
    " ",
    ";"
], (0, $2O6LY.genericStyles), function(props) {
    return props.theme.tabs.extend;
});

});

parcelRegister("7hN5M", function(module, exports) {

$parcel$export(module.exports, "TabsPropTypes", () => $54e033a52972e8a4$export$45ba878828554cde);


function $54e033a52972e8a4$var$_extends() {
    return $54e033a52972e8a4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $54e033a52972e8a4$var$_extends.apply(null, arguments);
}
var $54e033a52972e8a4$var$PropType = {};
var $54e033a52972e8a4$export$45ba878828554cde = $54e033a52972e8a4$var$PropType;

});


parcelRegister("kHJyS", function(module, exports) {

$parcel$export(module.exports, "Blank", () => $f12b2a5b196914f9$export$eb38fb18cfba1d64);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $f12b2a5b196914f9$var$_extends() {
    return $f12b2a5b196914f9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f12b2a5b196914f9$var$_extends.apply(null, arguments);
}
var $f12b2a5b196914f9$export$eb38fb18cfba1d64 = function Blank(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $f12b2a5b196914f9$var$_extends({
        viewBox: "0 0 24 24",
        "aria-hidden": true
    }, props));
};

});

parcelRegister("dmh5A", function(module, exports) {

$parcel$export(module.exports, "User", () => $9b9a95f5799a64c6$export$1f44aaf2ec115b54);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $9b9a95f5799a64c6$var$_extends() {
    return $9b9a95f5799a64c6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9b9a95f5799a64c6$var$_extends.apply(null, arguments);
}
var $9b9a95f5799a64c6$export$1f44aaf2ec115b54 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $9b9a95f5799a64c6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "User"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 24v-5m8 5v-5M3 24v-5c0-4.97 4.03-8 9-8s9 3.03 9 8v5m-9-13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
$9b9a95f5799a64c6$export$1f44aaf2ec115b54.displayName = 'User';

});

parcelRegister("9HK6v", function(module, exports) {

$parcel$export(module.exports, "UserExpert", () => $710be47d5451388d$export$23d4598e3685cc9);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $710be47d5451388d$var$_extends() {
    return $710be47d5451388d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $710be47d5451388d$var$_extends.apply(null, arguments);
}
var $710be47d5451388d$export$23d4598e3685cc9 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $710be47d5451388d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserExpert"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10zm6.643 4.696a6.745 6.745 0 0 0-1.62-2.673C11.772 11.76 10.013 11 8 11c-4 0-7 3-7 7v5h10m1-4.176L16.19 22 23 13"
    }));
});
$710be47d5451388d$export$23d4598e3685cc9.displayName = 'UserExpert';

});

parcelRegister("d2VmQ", function(module, exports) {

$parcel$export(module.exports, "TalonTip", () => $9e5c1b2f17b5e545$export$fdcfe391eac1cac3);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $79HTA = parcelRequire("79HTA");

var $4Oriw = parcelRequire("4Oriw");
const $9e5c1b2f17b5e545$export$fdcfe391eac1cac3 = ({ content: content, children: children })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            ...(0, $4Oriw.tooltipProps),
            children: content
        }),
        plain: true,
        children: children
    });
};

});
parcelRegister("4Oriw", function(module, exports) {

$parcel$export(module.exports, "borderRadiusSize", () => $d34ef44fcd75733a$export$470c17c83a466e3a);
$parcel$export(module.exports, "default", () => $d34ef44fcd75733a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tooltipProps", () => $d34ef44fcd75733a$export$624fdfc9ce3eb3b);
/**
 * Grommet Theme
 *
 * https://v2.grommet.io/globaltheme
 */ 
var $dg8iH = parcelRequire("dg8iH");

var $bIyki = parcelRequire("bIyki");
const $d34ef44fcd75733a$var$talonColors = {
    brand: {
        light: '#0d48a1',
        dark: '#0d48a1'
    },
    'brand-gradient': {
        light: 'var(--brand-gradient)',
        dark: 'var(--brand-gradient)'
    },
    'accent-1': '#fff',
    'accent-2': {
        light: '#0d92a1',
        dark: '#0d92a1'
    },
    'accent-3': {
        light: '#a10d48',
        dark: '#a10d48'
    },
    'accent-4': {
        light: '#660da1',
        dark: '#660da1'
    },
    'accent-5': {
        light: '#1c0da1',
        dark: '#1c0da1'
    },
    'accent-6': {
        light: '#a1660d',
        dark: '#a1660d'
    }
};
const $d34ef44fcd75733a$export$470c17c83a466e3a = '15px';
const $d34ef44fcd75733a$var$grommetTheme = (0, $bIyki.deepMerge)((0, $dg8iH.grommet), {
    global: {
        colors: {
            ...$d34ef44fcd75733a$var$talonColors,
            'hint-background': '#DAB8F7FF',
            focus: $d34ef44fcd75733a$var$talonColors.brand,
            alert: 'red'
        },
        focus: {
            outline: {
                size: '0px'
            }
        }
    },
    accordion: {
        border: undefined
    },
    tip: {
        content: {
            background: {
                color: 'light-1',
                opacity: 1
            },
            round: $d34ef44fcd75733a$export$470c17c83a466e3a,
            border: {
                size: '1px',
                color: 'light-4'
            },
            pad: 'small',
            margin: 'small'
        }
    },
    tab: {
        color: 'text-strong',
        active: {
            background: 'background'
        },
        background: 'background-contrast',
        border: {
            side: 'bottom',
            color: 'border',
            active: {
                color: 'border-strong'
            },
            disabled: {
                color: 'border-weak'
            },
            hover: {
                color: 'border'
            }
        },
        disabled: {
            color: 'text-weak'
        },
        hover: {
            background: 'accent-2',
            color: 'text'
        },
        pad: 'small',
        margin: {
            horizontal: 'none'
        }
    },
    tabs: {
        gap: 'small'
    },
    textArea: {
        extend: ()=>`
    resize: none;
    font-size: 1.1rem;
    padding: 1rem 2rem 1rem 2rem;
    border-radius: 0.5rem;
    border: 1px solid #d9d9e3;
    background: #ffffff;
    color: #000;
    outline: none;  
    `
    },
    text: {
        xsmall: {
            size: '12px',
            height: '18px'
        },
        small: {
            size: '14px',
            height: '20px'
        },
        medium: {
            size: '18px',
            height: '24px'
        },
        large: {
            size: '22px',
            height: '28px'
        },
        xlarge: {
            size: '26px',
            height: '32px'
        },
        xxlarge: {
            size: '34px',
            height: '40px'
        }
    },
    dataTable: {
        header: {
            color: 'white',
            font: {
                size: 'xsmall'
            },
            gap: 'none'
        },
        body: {
            row: {
                extend: 'height: 49px'
            }
        }
    },
    formField: {
        label: {
            requiredIndicator: true
        }
    }
});
var $d34ef44fcd75733a$export$2e2bcd8739ae039 = $d34ef44fcd75733a$var$grommetTheme;
const $d34ef44fcd75733a$export$624fdfc9ce3eb3b = {
    background: 'light-1',
    round: $d34ef44fcd75733a$export$470c17c83a466e3a,
    pad: 'small',
    margin: 'small',
    border: {
        size: '1px',
        color: 'light-4'
    },
    width: {
        max: $d34ef44fcd75733a$var$grommetTheme.global?.size?.medium
    }
};

});
parcelRegister("dg8iH", function(module, exports) {

$parcel$export(module.exports, "grommet", () => $9a733549d27832cb$export$9d812a0de4eabbe3, (v) => $9a733549d27832cb$export$9d812a0de4eabbe3 = v);
var $9a733549d27832cb$export$1e511d4a378977f5;
var $9a733549d27832cb$export$b2f72e3c920710c0;
var $9a733549d27832cb$export$9d812a0de4eabbe3;
var $9a733549d27832cb$export$80d376111cc09ad7;
var $9a733549d27832cb$export$55ce6f3a06c59543;
var $9a733549d27832cb$export$e2253033e6e1df16;
"use strict";
$9a733549d27832cb$export$1e511d4a378977f5 = true;
$9a733549d27832cb$export$b2f72e3c920710c0 = $9a733549d27832cb$export$9d812a0de4eabbe3 = $9a733549d27832cb$export$80d376111cc09ad7 = $9a733549d27832cb$export$55ce6f3a06c59543 = $9a733549d27832cb$export$e2253033e6e1df16 = void 0;

var $5DFJI = parcelRequire("5DFJI");
$9a733549d27832cb$export$e2253033e6e1df16 = $5DFJI.base;
$9a733549d27832cb$export$80d376111cc09ad7 = $5DFJI.generate;

var $fqTZ8 = parcelRequire("fqTZ8");
$9a733549d27832cb$export$9d812a0de4eabbe3 = $fqTZ8.grommet;

var $kNwUk = parcelRequire("kNwUk");
$9a733549d27832cb$export$55ce6f3a06c59543 = $kNwUk.dark;

var $ilKhA = parcelRequire("ilKhA");
$9a733549d27832cb$export$b2f72e3c920710c0 = $ilKhA.hacktoberfest2022;

});
parcelRegister("5DFJI", function(module, exports) {

$parcel$export(module.exports, "generate", () => $41b0f841dc6fffd0$export$80d376111cc09ad7, (v) => $41b0f841dc6fffd0$export$80d376111cc09ad7 = v);
$parcel$export(module.exports, "base", () => $41b0f841dc6fffd0$export$e2253033e6e1df16, (v) => $41b0f841dc6fffd0$export$e2253033e6e1df16 = v);
var $41b0f841dc6fffd0$export$1e511d4a378977f5;
var $41b0f841dc6fffd0$export$80d376111cc09ad7;
var $41b0f841dc6fffd0$export$e2253033e6e1df16;
"use strict";
$41b0f841dc6fffd0$export$1e511d4a378977f5 = true;
$41b0f841dc6fffd0$export$80d376111cc09ad7 = $41b0f841dc6fffd0$export$e2253033e6e1df16 = void 0;

var $eHBma = parcelRequire("eHBma");

var $jta6y = parcelRequire("jta6y");

var $h8SsP = parcelRequire("h8SsP");

var $9B1ut = parcelRequire("9B1ut");

var $7aiQi = parcelRequire("7aiQi");

var $emMxY = parcelRequire("emMxY");

var $gpz6W = parcelRequire("gpz6W");

var $8OmD4 = parcelRequire("8OmD4");

var $hwSTn = parcelRequire("hwSTn");

var $6Xlgn = parcelRequire("6Xlgn");

var $l4F8H = parcelRequire("l4F8H");

var $9AmjO = parcelRequire("9AmjO");

var $4wHe0 = parcelRequire("4wHe0");

var $52RYE = parcelRequire("52RYE");

var $9HTuS = parcelRequire("9HTuS");

var $b0HeC = parcelRequire("b0HeC");

var $iDbKq = parcelRequire("iDbKq");

var $7euNT = parcelRequire("7euNT");

var $5lYUK = parcelRequire("5lYUK");

var $ehCpZ = parcelRequire("ehCpZ");

var $3mta4 = parcelRequire("3mta4");

var $054Ni = parcelRequire("054Ni");

var $irJMV = parcelRequire("irJMV");

var $K1r2I = parcelRequire("K1r2I");

var $lwtww = parcelRequire("lwtww");

var $aSiTx = parcelRequire("aSiTx");

var $7Xne6 = parcelRequire("7Xne6");

var $brba2 = parcelRequire("brba2");
function $41b0f841dc6fffd0$var$_extends() {
    return $41b0f841dc6fffd0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $41b0f841dc6fffd0$var$_extends.apply(null, arguments);
} // SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $41b0f841dc6fffd0$var$brandColor = '#7D4CDB';
var $41b0f841dc6fffd0$var$accentColors = [
    '#6FFFB0',
    '#FD6FFF',
    '#81FCED',
    '#FFCA58'
];
var $41b0f841dc6fffd0$var$neutralColors = [
    '#00873D',
    '#3D138D',
    '#00739D',
    '#A2423D'
];
var $41b0f841dc6fffd0$var$statusColors = {
    critical: '#EB0000',
    error: '#B30000',
    warning: '#C27B00',
    ok: '#009E67',
    unknown: '#919191',
    disabled: '#CCCCCC'
};
var $41b0f841dc6fffd0$var$darkColors = [
    '#333333',
    '#555555',
    '#777777',
    '#999999',
    '#999999',
    '#999999'
];
var $41b0f841dc6fffd0$var$lightColors = [
    '#F8F8F8',
    '#F2F2F2',
    '#EDEDED',
    '#DADADA',
    '#DADADA',
    '#DADADA'
];
var $41b0f841dc6fffd0$var$focusColor = $41b0f841dc6fffd0$var$accentColors[0];
var $41b0f841dc6fffd0$var$colors = {
    active: 'rgba(221, 221, 221, 0.5)',
    'background-back': {
        dark: '#33333308',
        light: '#EDEDED'
    },
    'background-front': {
        dark: '#444444',
        light: '#FFFFFF'
    },
    'background-contrast': {
        light: '#33333310',
        dark: '#FFFFFF18'
    },
    'active-background': 'background-contrast',
    'active-text': 'text-strong',
    black: '#000000',
    border: {
        dark: 'rgba(255, 255, 255, 0.33)',
        light: 'rgba(0, 0, 0, 0.33)'
    },
    brand: $41b0f841dc6fffd0$var$brandColor,
    control: {
        dark: 'accent-1',
        light: 'brand'
    },
    focus: $41b0f841dc6fffd0$var$focusColor,
    'graph-0': 'accent-1',
    'graph-1': 'neutral-1',
    'graph-2': 'neutral-2',
    'graph-3': 'neutral-3',
    'graph-4': 'neutral-4',
    placeholder: '#AAAAAA',
    selected: 'brand',
    text: {
        dark: '#f8f8f8',
        light: '#444444'
    },
    'text-strong': {
        dark: '#FFFFFF',
        light: '#000000'
    },
    'text-weak': {
        dark: '#CCCCCC',
        light: '#555555'
    },
    'text-xweak': {
        dark: '#BBBBBB',
        light: '#666666'
    },
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    'selected-background': 'brand',
    'selected-text': 'text-strong',
    white: '#FFFFFF'
};
var $41b0f841dc6fffd0$var$colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        $41b0f841dc6fffd0$var$colors[prefix + "-" + (index + 1)] = color;
    });
};
$41b0f841dc6fffd0$var$colorArray($41b0f841dc6fffd0$var$accentColors, 'accent');
$41b0f841dc6fffd0$var$colorArray($41b0f841dc6fffd0$var$darkColors, 'dark');
$41b0f841dc6fffd0$var$colorArray($41b0f841dc6fffd0$var$lightColors, 'light');
$41b0f841dc6fffd0$var$colorArray($41b0f841dc6fffd0$var$neutralColors, 'neutral');
Object.keys($41b0f841dc6fffd0$var$statusColors).forEach(function(color) {
    $41b0f841dc6fffd0$var$colors["status-" + color] = $41b0f841dc6fffd0$var$statusColors[color];
});
var $41b0f841dc6fffd0$var$generate = $41b0f841dc6fffd0$export$80d376111cc09ad7 = function generate(baseSpacing, scale) {
    if (baseSpacing === void 0) baseSpacing = 24;
    if (scale === void 0) scale = 6;
    // 24
    var baseFontSize = baseSpacing * 0.75; // 18
    var fontScale = baseSpacing / scale; // 4
    var fontSizing = function fontSizing(factor) {
        return {
            size: baseFontSize + factor * fontScale + "px",
            height: baseSpacing + factor * fontScale + "px",
            // maxWidth chosen to be ~50 characters wide
            // see: https://ux.stackexchange.com/a/34125
            maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
        };
    };
    var borderWidth = 2;
    var controlBorderWidth = 1;
    var result = (0, $7Xne6.deepMerge)($aSiTx.base, {
        global: {
            active: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            animation: {
                duration: '1s',
                jiggle: {
                    duration: '0.1s'
                }
            },
            // backgrounds: undefined,
            borderSize: {
                xsmall: '1px',
                small: '2px',
                medium: baseSpacing / 6 + "px",
                // 4
                large: baseSpacing / 2 + "px",
                // 12
                xlarge: baseSpacing + "px" // 24
            },
            breakpoints: {
                small: {
                    value: baseSpacing * 32,
                    // 768
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        // 4
                        large: baseSpacing / 4 + "px",
                        // 6
                        xlarge: baseSpacing / 2 + "px" // 12
                    },
                    edgeSize: {
                        none: '0px',
                        hair: '1px',
                        // for Chart
                        xxsmall: '2px',
                        xsmall: baseSpacing / 8 + "px",
                        // 3
                        small: baseSpacing / 4 + "px",
                        // 6
                        medium: baseSpacing / 2 + "px",
                        // 12
                        large: baseSpacing + "px",
                        // 24
                        xlarge: baseSpacing * 2 + "px" // 48
                    },
                    // radius: {},
                    size: {
                        xxsmall: baseSpacing + "px",
                        // 24
                        xsmall: baseSpacing * 2 + "px",
                        // 48
                        small: baseSpacing * 4 + "px",
                        // 96
                        medium: baseSpacing * 8 + "px",
                        // 192
                        large: baseSpacing * 16 + "px",
                        // 384
                        xlarge: baseSpacing * 32 + "px",
                        // 768
                        full: '100%'
                    }
                },
                medium: {
                    value: baseSpacing * 64 // 1536
                },
                large: {} // anything above 'medium'
            },
            // Breakpoints used at Server Side Rendering for the initial rendering
            // These values correspond to the theme breakpoints
            deviceBreakpoints: {
                phone: 'small',
                tablet: 'medium',
                computer: 'large'
            },
            colors: $41b0f841dc6fffd0$var$colors,
            control: {
                border: {
                    width: controlBorderWidth + "px",
                    radius: '4px',
                    color: 'border'
                },
                disabled: {
                    opacity: 0.3
                }
            },
            // The time to wait after the user stopped typing, measured in ms.
            // A half second (500ms) debounce can be a helpful starting point.
            // You want to give the user time to fill out a field, but capture
            // their attention before they move on past it. 2 second (2000ms)
            // might be too long depending on how fast people type, and 200ms
            // would be an eye blink
            debounceDelay: 500,
            // deprecated: {
            //   backgrounds: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   colors: [
            //     {
            //       name: string,
            //       message: string,
            //     },
            //   ],
            //   button: {
            //     kind: [
            //       {
            //         name: string,
            //         message: string,
            //       },
            //     ],
            //   },
            // },
            drop: {
                // intelligentMargin: undefined,
                background: {
                    dark: 'black',
                    light: 'white'
                },
                border: {
                    radius: '0px'
                },
                // margin: undefined
                shadowSize: 'small',
                // shadowSize is deprecated, use 'elevation'
                zIndex: '20'
            },
            edgeSize: {
                none: '0px',
                hair: '1px',
                // for Chart
                xxsmall: baseSpacing / 8 + "px",
                // 3
                xsmall: baseSpacing / 4 + "px",
                // 6
                small: baseSpacing / 2 + "px",
                // 12
                medium: baseSpacing + "px",
                // 24
                large: baseSpacing * 2 + "px",
                // 48
                xlarge: baseSpacing * 4 + "px",
                // 96
                responsiveBreakpoint: 'small'
            },
            elevation: {
                light: {
                    none: 'none',
                    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
                    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
                    medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
                    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
                    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
                },
                dark: {
                    none: 'none',
                    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
                    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
                    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
                    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
                    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
                }
            },
            focus: {
                // shadow or outline are required for accessibility
                border: {
                    // remove to only have shadow
                    color: 'focus'
                },
                // outline: { color: undefined, size: undefined },
                shadow: {
                    color: 'focus',
                    size: '2px'
                },
                twoColor: undefined,
                inset: {
                    border: {
                        // remove to only have shadow
                        color: 'focus'
                    },
                    outline: {
                        color: 'focus',
                        size: '2px',
                        offset: '-2px'
                    },
                    shadow: undefined,
                    twoColor: undefined
                }
            },
            font: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
            hover: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            input: {
                padding: {
                    horizontal: (0, $brba2.parseMetricToNum)(baseSpacing / 2 + "px") - (0, $brba2.parseMetricToNum)(controlBorderWidth + "px") + "px",
                    vertical: (0, $brba2.parseMetricToNum)(baseSpacing / 2 + "px") - (0, $brba2.parseMetricToNum)(controlBorderWidth + "px") + "px"
                },
                font: {
                    // size: undefined,
                    // height: undefined,
                    weight: 600
                },
                // deprecate in v3
                // weight: undefined,
                readOnly: {
                }
            },
            opacity: {
                strong: 0.8,
                medium: 0.4,
                weak: 0.1
            },
            // radius: {},
            selected: {
                background: 'selected',
                color: 'white'
            },
            spacing: baseSpacing + "px",
            size: {
                xxsmall: baseSpacing * 2 + "px",
                // 48
                xsmall: baseSpacing * 4 + "px",
                // 96
                small: baseSpacing * 8 + "px",
                // 192
                medium: baseSpacing * 16 + "px",
                // 384
                large: baseSpacing * 32 + "px",
                // 768
                xlarge: baseSpacing * 48 + "px",
                // 1152
                xxlarge: baseSpacing * 64 + "px",
                // 1536
                full: '100%'
            }
        },
        // icon: {
        //   extend: undefined,
        //   matchSize: undefined,
        //   size: undefined,
        // },
        accordion: {
            icon: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            label: {
                container: {
                    pad: {
                        horizontal: 'xsmall'
                    }
                }
            },
            panel: {
            },
            border: {
                side: 'bottom',
                color: 'border'
            },
            heading: {
                level: '4' // level ranges from 1-6
            },
            hover: {
                // background: undefined,
                color: {
                    dark: 'light-4',
                    light: 'dark-3'
                },
                // deprecated
                heading: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    }
                }
            },
            icons: {
                collapse: $l4F8H.FormUp,
                expand: $8OmD4.FormDown
            }
        },
        anchor: {
            color: {
                dark: 'accent-1',
                light: 'brand'
            },
            gap: 'small',
            hover: {
                textDecoration: 'underline'
            },
            // icon: {
            //   color: undefined
            // },
            iconOnly: {
                pad: 'small'
            },
            textDecoration: 'none',
            fontWeight: 600
        },
        avatar: {
            // extend: undefined,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                // 18px
                small: baseSpacing + "px",
                // 24px
                medium: baseSpacing * 2 + "px",
                // default 48px
                large: baseSpacing * 3 + "px",
                // 72px
                xlarge: baseSpacing * 4 + "px",
                // 96px
                '2xl': baseSpacing * 5 + "px",
                // 120px
                '3xl': baseSpacing * 6 + "px",
                // 144px
                '4xl': baseSpacing * 7 + "px",
                // 168px
                '5xl': baseSpacing * 8 + "px" // 192px
            },
            text: {
                size: {
                    xsmall: 'small',
                    // 14px
                    small: 'medium',
                    // 18px
                    medium: 'large',
                    // 22px
                    large: 'xlarge',
                    // 26px
                    xlarge: 'xxlarge',
                    // 34px
                    '2xl': '3xl',
                    // 42px
                    '3xl': '4xl',
                    // 54px
                    '4xl': '5xl',
                    // 70px
                    '5xl': '6xl' // 90px
                }
            }
        },
        box: {
            border: {
                offset: 'xsmall'
            },
            responsiveBreakpoint: 'small' // when we switch rows to columns
        },
        button: {
            intelligentPad: true,
            // background: undefined,
            badge: {
                // align: undefined,,
                container: {
                    background: 'brand'
                },
                size: {
                    medium: baseSpacing + "px" // 24px
                },
                text: {
                    size: {
                        medium: 'small' // 14px
                    }
                }
            },
            busy: {
                gap: 'small'
            },
            gap: 'small',
            size: {
                small: {
                    border: {
                        radius: baseSpacing * 0.75 + "px"
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth * 2 + "px" // 20px,
                    }
                },
                medium: {
                    border: {
                        radius: baseSpacing * 0.75 + "px" // 18px
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth + "px" // 22px
                    }
                },
                large: {
                    border: {
                        radius: baseSpacing + "px" // 24px
                    },
                    pad: {
                        vertical: baseSpacing / 4 + borderWidth + "px",
                        // 8px
                        horizontal: baseSpacing + borderWidth * 4 + "px" // 32px,
                    }
                }
            },
            border: {
                // color: { dark: undefined, light: undefined }
                width: borderWidth + "px",
                radius: baseSpacing * 0.75 + "px"
            },
            // color: { dark: undefined, light: undefined },
            // elevation: undefined,
            // default: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // primary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // secondary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // option: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            active: {
                background: 'active-background',
                //   border: undefined,
                color: 'active-text'
            },
            disabled: {
                //   background: undefined,
                //   border: undefined,
                //   color: undefined,
                opacity: 0.3
            },
            // hover: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   extend: undefined,
            //   default: {},
            //   primary: {},
            //   secondary: {},
            // },
            padding: {
                vertical: baseSpacing / 4 - borderWidth + "px",
                horizontal: baseSpacing - borderWidth + "px"
            },
            transition: {
                timing: 'ease-in-out',
                duration: 0.1,
                properties: [
                    'color',
                    'background-color',
                    'border-color',
                    'box-shadow'
                ]
            },
            skeleton: {
                width: {
                    min: '100px'
                }
            }
        },
        calendar: {
            day: {
                // adjacent: {
                //   color: undefined,
                // },
                hover: {
                    background: 'active-background'
                },
                selected: {
                    // background: undefined,
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                },
                inRange: {
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                }
            },
            // range: {
            //   background: undefined,
            // },
            // daySize must align with global.size
            small: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize - fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'xsmall'
                        }
                    }
                },
                lineHeight: 1.375,
                daySize: baseSpacing * 8 / 7 + "px",
                slideDuration: '0.2s'
            },
            medium: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'small'
                        }
                    }
                },
                lineHeight: 1.45,
                daySize: baseSpacing * 16 / 7 + "px",
                slideDuration: '0.5s'
            },
            large: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + 3 * fontScale + "px",
                title: {
                    container: {
                        pad: {
                            horizontal: 'medium'
                        }
                    }
                },
                lineHeight: 1.11,
                daySize: baseSpacing * 32 / 7 + "px",
                slideDuration: '0.8s'
            },
            icons: {
                previous: $b0HeC.Previous,
                next: $9AmjO.Next,
                small: {
                    previous: $6Xlgn.FormPrevious,
                    next: $hwSTn.FormNext
                }
            },
            heading: {
                level: '4'
            } // level ranges from 1-6
        },
        card: {
            container: {
                round: 'small',
                elevation: 'small'
            },
            // hover: {
            //   container: {
            //     elevation: undefined,
            //   },
            // },
            header: {},
            body: {},
            footer: {}
        },
        cards: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            grid: {
                columns: 'small',
                gap: 'medium'
            }
        },
        carousel: {
            icons: {
                current: $054Ni.Subtract,
                next: $9AmjO.Next,
                previous: $b0HeC.Previous
            },
            animation: {
                duration: 1000
            },
            disabled: {
                icons: {
                }
            }
        },
        chart: {
            color: 'graph-0',
            height: 'small',
            thickness: 'medium',
            width: 'medium'
        },
        checkBox: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            check: {
                // extend: undefined,
                radius: '4px',
                thickness: '4px'
            },
            label: {
                align: 'center'
            },
            // color: { dark: undefined, light: undefined },
            // extend: undefined,
            gap: 'small',
            hover: {
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            // pad: undefined,
            size: baseSpacing + "px",
            toggle: {
                // background: undefined
                color: {
                    dark: '#d9d9d9',
                    light: '#d9d9d9'
                },
                knob: {
                },
                radius: baseSpacing + "px",
                size: baseSpacing * 2 + "px"
            }
        },
        checkBoxGroup: {
            container: {
                //   // any box props
                //   extend: undefined,
                gap: 'small'
            }
        },
        clock: {
            analog: {
                // extend: undefined,
                hour: {
                    color: {
                        dark: 'light-2',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 3 + "px",
                    size: baseSpacing + "px",
                    shape: 'round'
                },
                minute: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 6 + "px",
                    size: Math.round(baseSpacing / 2) + "px",
                    shape: 'round'
                },
                second: {
                    color: {
                        dark: 'accent-1',
                        light: 'accent-1'
                    },
                    width: baseSpacing / 8 + "px",
                    size: Math.round(baseSpacing / 2.666) + "px",
                    shape: 'round'
                },
                size: {
                    xsmall: baseSpacing * 2 + "px",
                    small: baseSpacing * 3 + "px",
                    medium: baseSpacing * 4 + "px",
                    large: baseSpacing * 6 + "px",
                    xlarge: baseSpacing * 9 + "px",
                    xxlarge: baseSpacing * 12 + "px",
                    huge: baseSpacing * 12 + "px" // kept for backwards compatibility
                }
            },
            digital: {
                text: {
                    xsmall: {
                        size: baseFontSize - 2 * fontScale + "px",
                        height: 1.5
                    },
                    small: {
                        size: baseFontSize - fontScale + "px",
                        height: 1.43
                    },
                    medium: {
                        size: baseFontSize + "px",
                        height: 1.375
                    },
                    large: {
                        size: baseFontSize + fontScale + "px",
                        height: 1.167
                    },
                    xlarge: {
                        size: baseFontSize + 2 * fontScale + "px",
                        height: 1.1875
                    },
                    xxlarge: {
                        size: baseFontSize + 4 * fontScale + "px",
                        height: 1.125
                    }
                }
            }
        },
        collapsible: {
            minSpeed: 200,
            baseline: 500
        },
        data: {
            // button: {
            //   kind: undefined,
            // },
            drop: {
                pad: 'small'
            },
            toolbar: {
                gap: 'medium'
            }
        },
        dataChart: {
            // colors: [],
            gap: 'small',
            // granularity: {
            //   y: {},
            // },
            detail: {
                gap: 'xsmall',
                pad: 'small'
            },
            halfPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            },
            legend: {
                margin: {
                    top: 'small'
                },
                gap: 'small',
                item: {
                    gap: 'xsmall',
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            // orderedSizes: undefined,
            size: {
                height: 'small'
            },
            thickness: {
                veryDense: 'hair',
                dense: 'xsmall',
                heavy: 'small',
                moderate: 'medium',
                light: 'large',
                sparse: 'xlarge'
            },
            thicknessPad: {
                xlarge: 'large',
                large: 'medium',
                medium: 'small',
                small: 'xsmall',
                xsmall: 'xxsmall'
            }
        },
        dataFilter: {
            rangeSelector: {
                size: 'full',
                round: 'small'
            },
            selectMultiple: {
                dropHeight: 'medium'
            }
        },
        dataFilters: {
            // icons: {
            //   close: undefined,
            //   filter: undefined,
            // }
            footer: {
                actions: {
                    margin: {
                        top: 'medium'
                    },
                    gap: 'small'
                }
            },
            clearControl: {
                margin: {
                    start: 'small'
                }
            },
            pad: 'medium',
            width: {
                min: 'medium'
            }
        },
        dateInput: {
            button: {
                margin: 'small'
            },
            container: {
                round: 'xxsmall'
            },
            icon: {
                // calendar: undefined,
                size: 'medium'
            }
        },
        dateTimeInput: {
            button: {
                margin: {
                    right: 'small'
                }
            },
            container: {
                round: 'xxsmall'
            },
            active: {
                background: 'active-background',
                pad: 'xxsmall',
                indicator: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    },
                    size: 'small'
                }
            },
            drop: {
                pad: 'small',
                gap: 'small',
                border: {
                    color: 'border',
                    size: 'xsmall'
                }
            },
            calendar: {
                day: {
                    selected: {
                        background: 'selected'
                    }
                }
            },
            icon: {
                calendar: undefined
            },
            separator: {
                pad: 'xxsmall'
            }
        },
        dataSearch: {
        },
        dataSort: {
        },
        dataSummary: {
            margin: {
                vertical: 'xsmall'
            },
            separator: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        dataTable: {
            // body: {
            //   extend: undefined,
            //   row: {
            //     extend: undefined,
            //   }
            //   selected: undefined,
            // },
            expand: {
                size: 'xxsmall'
            },
            pinned: {
                // body: {
                //    background: undefined,
                //    extend: undefined,
                // },
                header: {
                    background: {
                        opacity: 'strong'
                    }
                },
                footer: {
                    background: {
                        opacity: 'strong'
                    }
                }
            },
            container: {
                // any box props
                gap: 'xsmall'
            },
            groupHeader: {
            },
            groupEnd: {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                }
            },
            header: {
                // background: undefined,
                // border: undefined,
                // color: undefined,
                // extend: undefined,
                // font: {
                //   weight: undefined,
                //   size: undefined,
                // },
                gap: 'small',
                // hover: {
                //   background: undefined,
                // },
                // pad: undefined,
                units: {
                    color: 'text-xweak',
                    margin: {
                        left: 'xsmall'
                    },
                    alignSelf: 'end'
                }
            },
            icons: {
                ascending: $8OmD4.FormDown,
                contract: $l4F8H.FormUp,
                descending: $l4F8H.FormUp,
                expand: $8OmD4.FormDown
            },
            primary: {
                weight: 'bold'
            },
            resize: {
                border: {
                    color: 'border',
                    side: 'end'
                },
                // hover: {
                //   border: {
                //     color: undefined,
                //     side: undefined,
                //     size: undefined,
                //   },
                // },
                padding: {
                    vertical: 'xsmall'
                }
            },
            search: {
                pad: {
                    left: 'small'
                },
                text: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            sort: {
                gap: 'xsmall'
            }
        },
        dataTableColumns: {
            // icons: {
            //   control: undefined,
            //   pinned: undefined,
            //   search: undefined,
            // }
            tabs: {
                pad: 'small'
            },
            selectColumns: {
                pad: {
                    vertical: 'small'
                },
                gap: 'xsmall'
            },
            orderColumns: {
                pad: {
                    top: 'small'
                }
            }
        },
        diagram: {
            // extend: undefined,
            line: {
                color: 'graph-0'
            }
        },
        distribution: {
            gap: 'xsmall'
        },
        // drop: {
        //   extend: undefined,
        //   maxHeight: undefined,
        // },
        fileInput: {
            anchor: {
                margin: 'small'
            },
            // background: {},
            border: {
                // color: undefined,
                side: 'all',
                size: 'small',
                style: 'dashed'
            },
            dragOver: {
                border: {
                    color: 'control'
                }
            },
            hover: {
                border: {
                    color: 'brand'
                }
            },
            icons: {
                // error: undefined,
                remove: $gpz6W.FormClose
            },
            // pad: {},
            label: {
                gap: 'xsmall',
                margin: 'small'
            },
            message: {
                margin: 'small'
            }
        },
        footer: {
            gap: 'medium'
        },
        formField: {
            // [inputname]: {
            //  container: {
            //    extend: undefined,
            //   },
            //   hover: {
            //     background: {
            //       color: undefined,
            //     },
            //     border: {
            //       color: undefined,
            //     },
            //   },
            // }
            border: {
                color: 'border',
                error: {
                    color: {
                        dark: 'white',
                        light: 'status-critical'
                    }
                },
                position: 'inner',
                side: 'bottom'
            },
            // checkBox: {
            //   pad: undefined,
            // },
            content: {
                // margin: undefined,
                pad: 'small'
            },
            disabled: {
                background: {
                    color: 'status-disabled',
                    opacity: 'medium'
                }
            },
            focus: {
                containerFocus: true
            },
            error: {
                color: 'status-critical',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            // hover: {
            //   background: {
            //     color: undefined,
            //   },
            //   border: {
            //     color: undefined,
            //   },
            // },
            // extend: undefined,
            help: {
                color: 'dark-2',
                margin: {
                    start: 'small'
                }
            },
            info: {
                color: 'text-xweak',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            label: {
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            margin: {
                bottom: 'small'
            },
            // round: undefined,
            survey: {
                label: {
                    margin: {
                        bottom: 'xsmall'
                    },
                    size: 'medium',
                    weight: 400
                }
            }
        },
        grommet: {
        },
        header: {
            sticky: {
                zIndex: '20'
            },
            gap: 'medium'
        },
        heading: {
            // color: undefined,
            font: {
            },
            level: {
                1: {
                    font: {
                    },
                    small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(4)),
                    medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(8)),
                    large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(16)),
                    xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(24))
                },
                2: {
                    font: {
                    },
                    small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(2)),
                    medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(4)),
                    large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(8)),
                    xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(12))
                },
                3: {
                    font: {
                    },
                    small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(1)),
                    medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(2)),
                    large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(4)),
                    xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(6))
                },
                4: {
                    font: {
                    },
                    small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
                    medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
                    large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
                    xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0))
                },
                5: {
                    font: {
                    },
                    small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-0.5)),
                    medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-0.5)),
                    large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-0.5)),
                    xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-0.5))
                },
                6: {
                    font: {
                    },
                    small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1)),
                    medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1)),
                    large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1)),
                    xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1))
                }
            },
            responsiveBreakpoint: 'small',
            // when we scale the font size down
            weight: 600,
            skeleton: {
                width: {
                    min: '150px',
                    max: '200px'
                }
            }
        },
        layer: {
            background: {
                dark: 'black',
                light: 'white'
            },
            border: {
                radius: '4px'
            },
            container: {
                // elevation: undefined,
                zIndex: '20',
                height: {
                    min: 'xxsmall'
                }
            },
            // extend: undefined,
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)'
            },
            responsiveBreakpoint: 'small',
            // when Layer takes over the full screen
            zIndex: '20'
        },
        list: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            item: {
                // background: undefined,
                border: 'horizontal',
                disabled: {
                    color: 'status-disabled',
                    cursor: 'default'
                },
                gap: 'medium',
                pinned: {
                    background: 'background-contrast',
                    icon: {
                        size: 'medium',
                        pad: 'small'
                    }
                },
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                }
            },
            primaryKey: {
                // any text props
                weight: 'bold'
            },
            icons: {
                down: $8OmD4.FormDown,
                up: $l4F8H.FormUp,
                pin: $9HTuS.FormPin
            }
        },
        maskedInput: {
        },
        menu: {
            // background: undefined,
            // extend: undefined,
            // item: undefined,
            drop: {
                align: {
                    top: 'top',
                    left: 'left'
                }
            },
            // container: {
            //   // any box props
            // },
            group: {
                container: {
                    pad: {
                        vertical: 'xsmall'
                    }
                },
                separator: {
                    color: 'border',
                    size: 'xsmall',
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            icons: {
                down: $8OmD4.FormDown
            }
        },
        meter: {
            background: {
                color: 'light-2',
                opacity: 'medium'
            },
            color: 'graph-0'
        },
        nameValueList: {
            gap: {
                column: 'large',
                row: 'small'
            },
            pair: {
                column: {
                    gap: {
                        column: 'large',
                        row: 'medium'
                    }
                }
            },
            name: {
                width: 'small'
            },
            value: {
                width: 'medium'
            }
        },
        nameValuePair: {
            column: {
                gap: 'xxsmall'
            },
            name: {
                // any text props
                color: 'text',
                weight: 'bold'
            },
            value: {
                // any text props
                color: 'text'
            }
        },
        nav: {
            gap: 'medium'
        },
        notification: {
            actions: {
                // any anchor props
                margin: {
                    right: 'xsmall'
                }
            },
            direction: 'column',
            container: {
                // any box props
                round: 'xsmall',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                background: {
                    color: 'background-front'
                }
            },
            gap: 'small',
            global: {
                direction: 'row',
                container: {
                    // any box props
                    round: 'none',
                    pad: {
                        horizontal: 'large',
                        vertical: 'xsmall'
                    }
                }
            },
            toast: {
                // direction: undefined,
                container: {
                    // any box props
                    elevation: 'medium',
                    width: 'medium'
                },
                layer: {
                    position: 'top',
                    margin: 'medium'
                },
                time: 8000
            },
            iconContainer: {
                // any box props
                pad: {
                    right: 'small'
                },
                flex: false
            },
            textContainer: {
                // any box props
                gap: 'medium'
            },
            title: {
                // any text props
                weight: 'bold'
            },
            message: {
                // any text props
                margin: 'none',
                // fill: undefined,
                text: {
                    margin: {
                        right: 'xsmall'
                    }
                }
            },
            close: {
                icon: $gpz6W.FormClose
            },
            critical: {
                icon: $7euNT.StatusCriticalSmall,
                background: {
                    color: 'status-critical',
                    opacity: 'weak'
                },
                color: 'status-critical',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            warning: {
                icon: $ehCpZ.StatusWarningSmall,
                background: {
                    color: 'status-warning',
                    opacity: 'weak'
                },
                color: 'status-warning',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            normal: {
                icon: $5lYUK.StatusGoodSmall,
                background: {
                    color: 'status-ok',
                    opacity: 'weak'
                },
                color: 'status-ok',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            info: {
                icon: $h8SsP.CircleInformation,
                background: 'background-contrast',
                color: 'text-strong',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            unknown: {
                icon: $3mta4.StatusUnknownSmall,
                background: {
                    color: 'status-unknown',
                    opacity: 'weak'
                },
                color: 'status-unknown',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            // deprecate "undefined" in v3
            // and if undefined, no icon
            undefined: {
                icon: $3mta4.StatusUnknownSmall,
                // background: undefined,
                color: 'status-unknown'
            }
        },
        page: {
            wide: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'xxlarge'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            narrow: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'large'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            full: {
                alignSelf: 'start',
                width: {
                    min: 'medium',
                    max: '100%'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            }
        },
        pageHeader: {
            actions: {
                // any box props
                align: 'end'
            },
            pad: {
                top: 'large',
                bottom: 'medium'
            },
            parent: {
                // any box props
                align: 'start'
            },
            responsive: {
                actions: {
                    // any box props
                    align: 'start',
                    pad: {
                        top: 'small'
                    }
                },
                areas: [
                    [
                        'parent'
                    ],
                    [
                        'title'
                    ],
                    [
                        'subtitle'
                    ],
                    [
                        'actions'
                    ]
                ],
                breakpoints: [
                    'small'
                ],
                columns: [
                    'auto'
                ],
                rows: [
                    'auto'
                ]
            },
            subtitle: {
                // any paragraph props
                margin: 'none'
            },
            title: {
                // any heading props
                margin: 'none',
                fill: true
            },
            size: {
                small: {
                    pad: {
                        top: 'medium',
                        bottom: 'small'
                    },
                    subtitle: {
                        size: 'small'
                    },
                    title: {
                        size: 'small'
                    }
                },
                // medium: {
                //   // pad: undefined,
                //   // subtitle: {},
                //   // title: {},
                // },
                large: {
                    pad: {
                        top: 'xlarge',
                        bottom: 'large'
                    },
                    subtitle: {
                        size: 'large'
                    },
                    title: {
                        size: 'large'
                    }
                }
            },
            small: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'small',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            },
            medium: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'medium'
                }
            },
            large: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            }
        },
        pagination: {
            button: {
                active: {
                    background: {
                        color: 'active-background'
                    }
                },
                color: 'text-strong',
                hover: {
                    background: {
                        color: 'background-contrast'
                    },
                    color: undefined
                },
                size: {
                    small: {
                        border: {
                            radius: baseSpacing / 8 + "px",
                            // 3
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1)),
                        height: baseSpacing * 1.25 + "px",
                        width: baseSpacing * 1.25 + "px"
                    },
                    medium: {
                        border: {
                            radius: baseSpacing / 6 + "px",
                            // 4
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
                        height: baseSpacing * 1.5 + "px",
                        width: baseSpacing * 1.5 + "px"
                    },
                    large: {
                        border: {
                            radius: baseSpacing / 4 + "px",
                            // 6
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: $41b0f841dc6fffd0$var$_extends({}, fontSizing(1)),
                        height: baseSpacing * 2 + "px",
                        width: baseSpacing * 2 + "px"
                    }
                }
            },
            container: {
                gap: {
                    column: 'xsmall',
                    row: 'small'
                }
            },
            controls: {
                align: 'center',
                direction: 'row',
                gap: 'xxsmall',
                margin: 'none',
                pad: 'none'
            },
            icons: {
                // color: undefined,
                next: $9AmjO.Next,
                previous: $b0HeC.Previous
            },
            step: {
                container: {
                    gap: 'xsmall'
                }
            }
        },
        paragraph: {
            font: {
            },
            small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1)),
            medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
            large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(1)),
            xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(2)),
            xxlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(4)),
            skeleton: {
                gap: 'xsmall'
            }
        },
        thumbsRating: {
        },
        spinner: {
            container: {
                animation: 'rotateRight',
                color: 'brand',
                pad: 'small',
                round: 'full',
                size: 'small'
            },
            // icon: undefined
            responsive: true,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                small: baseSpacing + "px",
                // default 24
                medium: baseSpacing * 2 + "px",
                large: baseSpacing * 3 + "px",
                xlarge: baseSpacing * 4 + "px"
            }
        },
        radioButton: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            // background: {
            //   color: undefined,
            // },
            check: {
                radius: '100%'
            },
            // color: undefined,
            hover: {
                // background: {
                //   color: undefined,
                // },
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            gap: 'small',
            size: baseSpacing + "px",
            font: {
            },
            container: {
            }
        },
        radioButtonGroup: {
            // any box props
            container: {
                gap: 'small'
            }
        },
        rangeInput: {
            disabled: {
                opacity: 0.3
            },
            // extend: undefined
            track: {
                height: '4px',
                color: 'border'
            },
            thumb: {
            }
        },
        rangeSelector: {
            background: {
                invert: {
                    color: 'light-4'
                }
            },
            edge: {
            },
            label: {
                margin: {
                    horizontal: 'small'
                }
            }
        },
        select: {
            // background: undefined,
            clear: {
                container: {
                    pad: 'small',
                    background: 'background-contrast'
                },
                // any box props
                text: {
                    color: 'text-weak'
                } // any text props
            },
            container: {
            },
            control: {
            },
            // emptySearchMessage: {
            //   container: {}, // any box props
            //   text: {}, // any text props
            // },
            icons: {
                // color: { dark: undefined, light: undefined },
                margin: {
                    horizontal: 'small'
                },
                down: $8OmD4.FormDown
            },
            // listbox: {
            //   extend: undefined,
            // },
            options: {
                container: {
                    align: 'start',
                    pad: 'small'
                },
                text: {
                    margin: 'none'
                }
            },
            search: {
                pad: 'xsmall'
            },
            // searchInput: undefined,
            step: 20
        },
        selectMultiple: {
            help: {
                container: {
                    pad: 'xsmall'
                }
            },
            maxInline: 5,
            // listbox: {
            //   extend: () => undefined,
            // },
            option: {
                pad: 'xsmall'
            },
            search: {
                pad: 'xsmall'
            },
            showMore: {
                pad: {
                    horizontal: 'small',
                    bottom: 'small',
                    top: 'xsmall'
                }
            },
            summary: {
                gap: 'small',
                height: {
                    min: 'xxsmall'
                },
                pad: 'xsmall',
                showSelectedInline: {
                    pad: {
                        left: 'xsmall',
                        vertical: 'xsmall'
                    }
                }
            }
        },
        sidebar: {
            gap: 'large',
            pad: 'small'
        },
        skeleton: {
            border: false,
            colors: {
                dark: [
                    'background',
                    'background-front'
                ],
                light: [
                    'background',
                    'background-back'
                ]
            }
        },
        skipLinks: {
            position: 'top',
            container: {
                elevation: 'large',
                round: 'small',
                pad: 'medium'
            },
            label: {
                margin: {
                    bottom: 'medium'
                },
                size: 'medium'
            }
        },
        starRating: {
        },
        tab: {
            active: {
                color: 'text'
            },
            // background: undefined,
            border: {
                side: 'bottom',
                size: 'small',
                color: {
                    dark: 'accent-1',
                    light: 'brand'
                },
                active: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                },
                disabled: {
                },
                hover: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            color: 'control',
            // disabled: {
            //   color: undefined,
            // },
            // extend: undefined,
            gap: 'small',
            hover: {
                // background: undefined,
                // extend: undefined,
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            margin: {
                vertical: 'xxsmall',
                horizontal: 'small'
            },
            pad: {
                bottom: 'xsmall'
            }
        },
        tabs: {
            // background: undefined,
            // extend: undefined,
            // gap: undefined,
            header: {
                // alignSelf: undefined,
                // background: undefined,
                // border: {
                //   side: undefined,
                //   size: undefined,
                //   style: undefined,
                //   color: undefined,
                // },
                // extend: undefined,
                nextButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                },
                previousButton: {
                    // icon: undefined,
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    }
                }
            },
            panel: {
            },
            step: {
                small: 1,
                medium: 3,
                large: 3
            }
        },
        stepper: {
            indicator: {
                size: 'medium',
                // 'small' | 'medium' | 'large'
                border: {
                    width: '2px'
                }
            },
            label: {
                size: 'medium',
                substep: {
                    size: 'small'
                }
            },
            connector: {
                stroke: {
                    width: 'small'
                }
            },
            description: {
                size: 'small',
                color: 'text-weak'
            },
            helperText: {
                size: 'xsmall',
                color: 'text-weak'
            },
            button: {
                pad: 'xxsmall'
            },
            horizontal: {
                connector: {
                    margin: 'xxsmall'
                },
                button: {
                    gap: 'xsmall'
                }
            },
            vertical: {
                button: {
                    gap: 'small'
                }
            },
            // States: [component].[state].[element].[property]
            pending: {
                indicator: {
                    background: 'background-front',
                    color: 'text-strong',
                    border: 'text-xweak',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front',
                        border: 'text-strong'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'border'
                }
            },
            current: {
                indicator: {
                    icon: $5lYUK.StatusGoodSmall,
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            currentCompleted: {
                indicator: {
                    icon: $emMxY.FormCheckmark,
                    iconSize: 'medium',
                    background: 'brand',
                    color: 'white',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: {
                        dark: 'text-strong',
                        light: 'brand'
                    }
                }
            },
            completed: {
                indicator: {
                    icon: $emMxY.FormCheckmark,
                    iconSize: 'medium',
                    background: 'background-front',
                    color: 'brand',
                    border: 'brand',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'brand'
                }
            },
            error: {
                indicator: {
                    icon: $7euNT.StatusCriticalSmall,
                    background: 'background-front',
                    color: 'status-critical',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        background: 'background-front'
                    }
                },
                label: {
                    color: 'text'
                },
                connector: {
                    color: 'status-critical'
                },
                helperText: {
                    color: 'status-critical'
                }
            },
            currentError: {
                indicator: {
                    icon: $7euNT.StatusCriticalSmall,
                    background: 'status-critical',
                    color: 'white',
                    border: 'status-critical',
                    substep: {
                        iconSize: 'small'
                    },
                    hover: {
                        color: 'white'
                    }
                },
                label: {
                    color: 'status-critical'
                }
            },
            disabled: {
                indicator: {
                    background: 'background-contrast',
                    color: 'text-weak',
                    border: 'border',
                    substep: {
                        iconSize: 'small'
                    }
                },
                label: {
                    color: 'text-weak'
                },
                connector: {
                    color: 'border'
                }
            }
        },
        table: {
            caption: {
                margin: {
                    bottom: 'xxsmall'
                }
            },
            header: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'bottom'
            },
            body: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                }
            },
            // row: {
            //   hover: {
            //     background: undefined,
            //     color: undefined,
            //   },
            // },
            footer: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'top'
            }
        },
        tag: {
            // background: undefined,
            border: true,
            // hover: {
            //   background: undefined,
            //   border: undefined,
            // },
            round: 'large',
            // name: undefined,
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            },
            remove: {
                margin: {
                    right: 'xsmall'
                }
            },
            separator: ' : ',
            size: {
                xsmall: {
                    pad: {
                        horizontal: baseSpacing / 3 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                small: {
                    pad: {
                        horizontal: baseSpacing * 0.4 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                large: {
                    pad: {
                        horizontal: baseSpacing / 3 * 2 + "px",
                        vertical: "xsmall"
                    },
                    icon: {
                        size: baseSpacing * 1.25 + "px"
                    }
                },
                xlarge: {
                    pad: {
                        horizontal: baseSpacing * 0.75 + "px",
                        vertical: 'xsmall'
                    },
                    icon: {
                        size: baseSpacing * 1.5 + "px"
                    }
                }
            },
            value: {
                weight: 600
            },
            icons: {
                remove: $gpz6W.FormClose
            }
        },
        text: {
            font: {
            },
            xsmall: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1.5)),
            small: $41b0f841dc6fffd0$var$_extends({}, fontSizing(-1)),
            medium: $41b0f841dc6fffd0$var$_extends({}, fontSizing(0)),
            // 18px
            large: $41b0f841dc6fffd0$var$_extends({}, fontSizing(1)),
            // 22px
            xlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(2)),
            xxlarge: $41b0f841dc6fffd0$var$_extends({}, fontSizing(4)),
            '2xl': $41b0f841dc6fffd0$var$_extends({}, fontSizing(4)),
            '3xl': $41b0f841dc6fffd0$var$_extends({}, fontSizing(6)),
            '4xl': $41b0f841dc6fffd0$var$_extends({}, fontSizing(9)),
            '5xl': $41b0f841dc6fffd0$var$_extends({}, fontSizing(13)),
            '6xl': $41b0f841dc6fffd0$var$_extends({}, fontSizing(18)),
            skeleton: {
                width: {
                    width: '100px',
                    min: '100px'
                },
                margin: {
                    vertical: 'xsmall'
                },
                colors: {
                    dark: [
                        'border',
                        'border'
                    ],
                    light: [
                        'background-front',
                        'background-back'
                    ]
                }
            }
        },
        textArea: {
        },
        textInput: {
            // extend: undefined,
            // disabled: { opacity: undefined },
            icons: {
                // copy: undefined,
                hidePassword: $iDbKq.Hide,
                showPassword: $irJMV.View
            }
        },
        timeInput: {
            button: {
                margin: {
                    right: 'small'
                }
            },
            container: {
                round: 'xxsmall'
            },
            active: {
                background: 'active-background',
                pad: 'xxsmall',
                indicator: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    },
                    size: 'small'
                }
            },
            drop: {
                // gap: undefined,
                option: {
                    // background: undefined,
                    // gap: undefined,
                    // size: undefined,
                    pad: {
                        vertical: 'xxsmall',
                        horizontal: 'xsmall'
                    },
                    // round: undefined,
                    hover: {
                        background: 'active-background'
                    },
                    selected: {
                        background: 'selected',
                        color: 'white',
                        text: {
                            weight: 500
                        },
                        hover: {
                        }
                    }
                }
            },
            icon: {
            }
        },
        tip: {
            content: {
                // any Box props
                background: 'background-contrast',
                elevation: 'small',
                margin: 'xsmall',
                pad: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                },
                round: 'small'
            },
            drop: {
                // any props for the drop
                align: {
                    top: 'bottom'
                },
                // most common use case is Header with Buttons
                background: 'none',
                elevation: 'none',
                margin: 'none'
            }
        },
        toggleGroup: {
            button: {
                // border: {
                //   radius: undefined,
                // }
                // iconOnly: {
                //   pad: undefined,
                // },
                // kind: undefined,
                pad: {
                    horizontal: '11px',
                    vertical: '11px'
                }
            },
            container: {
                round: 'xsmall',
                border: true
            },
            divider: {
                color: 'border'
            }
        },
        toolbar: {
            small: {
                gap: 'small'
            },
            gap: 'small'
        },
        video: {
            captions: {
                background: 'rgba(0, 0, 0, 0.7)'
            },
            // controls: { background: undefined },
            icons: {
                closedCaption: $9B1ut.ClosedCaption,
                configure: $eHBma.Actions,
                fullScreen: $7aiQi.Expand,
                pause: $4wHe0.Pause,
                play: $52RYE.Play,
                reduceVolume: $lwtww.VolumeLow,
                volume: $K1r2I.Volume,
                description: $jta6y.AssistListening
            },
            scrubber: {
                color: 'light-4',
                interval: 10,
                // track: { color: undefined }
                thickness: 'small'
            },
            time: {
                container: {
                    pad: {
                        horizontal: 'small'
                    }
                }
            }
        },
        wizard: {
            container: {
                gap: 'none',
                background: 'background-back'
            },
            body: {
                pad: {
                    horizontal: 'large',
                    vertical: 'large'
                },
                gap: {
                    row: 'none',
                    column: 'medium'
                }
            },
            header: {
                pad: {
                    horizontal: 'large',
                    vertical: 'small'
                },
                background: 'background-front',
                title: {
                    size: 'small'
                },
                close: {
                    icon: $gpz6W.FormClose
                }
            },
            progress: {
                horizontal: {
                    pad: {
                        horizontal: 'none',
                        vertical: 'none'
                    }
                },
                vertical: {
                    // Fixed rail width so the column doesn't collapse to label text.
                    width: 'small'
                }
            },
            stepHeader: {
                pad: {
                    horizontal: 'none',
                    vertical: 'none'
                },
                counter: {
                    size: 'small',
                    color: 'text'
                },
                title: {
                    size: 'large',
                    margin: 'none'
                },
                description: {
                    size: 'medium',
                    color: 'text-weak',
                    margin: {
                        top: 'xsmall',
                        bottom: 'none'
                    }
                }
            },
            content: {
                pad: 'medium',
                gap: 'medium',
                background: 'background-front',
                round: 'small',
                margin: {
                    top: 'medium'
                }
            },
            footer: {
                pad: {
                    horizontal: 'large',
                    vertical: 'small'
                },
                gap: {
                    row: 'xsmall',
                    column: 'small'
                },
                background: 'background-front',
                justify: 'end',
                button: {
                    next: {
                        icon: $hwSTn.FormNext
                    },
                    complete: {
                        icon: undefined
                    },
                    previous: {
                        icon: $6Xlgn.FormPrevious
                    },
                    cancel: {
                        icon: undefined
                    },
                    skip: {
                        icon: $hwSTn.FormNext
                    }
                }
            }
        },
        worldMap: {
            color: 'light-3',
            continent: {
                active: '8px',
                base: '6px'
            },
            hover: {
                color: 'light-4'
            },
            place: {
                active: '20px',
                base: '8px'
            }
        }
    });
    return (0, $7Xne6.deepFreeze)(result);
};
var $41b0f841dc6fffd0$var$base = $41b0f841dc6fffd0$export$e2253033e6e1df16 = $41b0f841dc6fffd0$var$generate(24);

});
parcelRegister("7Xne6", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $5cb00f640bed9252$export$1e511d4a378977f5, (v) => $5cb00f640bed9252$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "removeUndefined", () => $5cb00f640bed9252$export$c499305a875a8ee9, (v) => $5cb00f640bed9252$export$c499305a875a8ee9 = v);
$parcel$export(module.exports, "isObject", () => $5cb00f640bed9252$export$a6cdc56e425d0d0a, (v) => $5cb00f640bed9252$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "deepMerge", () => $5cb00f640bed9252$export$6969335ea1e4e77c, (v) => $5cb00f640bed9252$export$6969335ea1e4e77c = v);
$parcel$export(module.exports, "deepFreeze", () => $5cb00f640bed9252$export$7e32b29e1cb162e1, (v) => $5cb00f640bed9252$export$7e32b29e1cb162e1 = v);
var $5cb00f640bed9252$export$1e511d4a378977f5;
var $5cb00f640bed9252$export$c499305a875a8ee9;
var $5cb00f640bed9252$export$a6cdc56e425d0d0a;
var $5cb00f640bed9252$export$6969335ea1e4e77c;
var $5cb00f640bed9252$export$7e32b29e1cb162e1;
"use strict";
$5cb00f640bed9252$export$1e511d4a378977f5 = true;
$5cb00f640bed9252$export$c499305a875a8ee9 = $5cb00f640bed9252$export$a6cdc56e425d0d0a = $5cb00f640bed9252$export$6969335ea1e4e77c = $5cb00f640bed9252$export$7e32b29e1cb162e1 = void 0;
function $5cb00f640bed9252$var$_extends() {
    return $5cb00f640bed9252$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5cb00f640bed9252$var$_extends.apply(null, arguments);
}
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $5cb00f640bed9252$var$isObject = $5cb00f640bed9252$export$a6cdc56e425d0d0a = function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
var $5cb00f640bed9252$var$deepFreeze = $5cb00f640bed9252$export$7e32b29e1cb162e1 = function deepFreeze(obj) {
    Object.keys(obj).forEach(function(key) {
        return key && $5cb00f640bed9252$var$isObject(obj[key]) && Object.freeze(obj[key]);
    });
    return Object.freeze(obj);
};
var $5cb00f640bed9252$var$_deepMerge = $5cb00f640bed9252$export$6969335ea1e4e77c = function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = $5cb00f640bed9252$var$_extends({}, target);
    sources.forEach(function(source) {
        if ($5cb00f640bed9252$var$isObject(source)) Object.keys(source).forEach(function(key) {
            if ($5cb00f640bed9252$var$isObject(source[key])) {
                if (!output[key]) output[key] = $5cb00f640bed9252$var$_extends({}, source[key]);
                else output[key] = $5cb00f640bed9252$var$_deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
};
var $5cb00f640bed9252$var$removeUndefined = $5cb00f640bed9252$export$c499305a875a8ee9 = function removeUndefined(obj) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (obj[key] !== undefined) result[key] = obj[key];
    });
    return result;
};

});

parcelRegister("brba2", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $853adfa6dc734342$export$1e511d4a378977f5, (v) => $853adfa6dc734342$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "parseMetricToNum", () => $853adfa6dc734342$export$333c2219d71d27ce, (v) => $853adfa6dc734342$export$333c2219d71d27ce = v);
$parcel$export(module.exports, "getAvailableAtBadge", () => $853adfa6dc734342$export$319d1f43f7cd3019, (v) => $853adfa6dc734342$export$319d1f43f7cd3019 = v);
$parcel$export(module.exports, "fontSize", () => $853adfa6dc734342$export$85e3c3ca0c6fb93, (v) => $853adfa6dc734342$export$85e3c3ca0c6fb93 = v);
$parcel$export(module.exports, "findAllByType", () => $853adfa6dc734342$export$fdd5e64c0e8495bb, (v) => $853adfa6dc734342$export$fdd5e64c0e8495bb = v);
$parcel$export(module.exports, "edgeToNum", () => $853adfa6dc734342$export$d3510c15440bd3f3, (v) => $853adfa6dc734342$export$d3510c15440bd3f3 = v);
$parcel$export(module.exports, "breakpointStyle", () => $853adfa6dc734342$export$2180d12f0a299a89, (v) => $853adfa6dc734342$export$2180d12f0a299a89 = v);
var $853adfa6dc734342$export$1e511d4a378977f5;
var $853adfa6dc734342$export$333c2219d71d27ce;
var $853adfa6dc734342$export$319d1f43f7cd3019;
var $853adfa6dc734342$export$85e3c3ca0c6fb93;
var $853adfa6dc734342$export$fdd5e64c0e8495bb;
var $853adfa6dc734342$export$d3510c15440bd3f3;
var $853adfa6dc734342$export$2180d12f0a299a89;
"use strict";
$853adfa6dc734342$export$1e511d4a378977f5 = true;
$853adfa6dc734342$export$333c2219d71d27ce = $853adfa6dc734342$export$319d1f43f7cd3019 = $853adfa6dc734342$export$85e3c3ca0c6fb93 = $853adfa6dc734342$export$fdd5e64c0e8495bb = $853adfa6dc734342$export$d3510c15440bd3f3 = $853adfa6dc734342$export$2180d12f0a299a89 = void 0;

var $f5efw = parcelRequire("f5efw");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $853adfa6dc734342$var$parseMetricToNum = $853adfa6dc734342$export$333c2219d71d27ce = function parseMetricToNum(metric) {
    if (typeof metric === 'number') return metric;
    metric.match(/\s/);
    return parseFloat(metric.match(/\d+(\.\d+)?/), 10);
};
var $853adfa6dc734342$var$edgeToNum = $853adfa6dc734342$export$d3510c15440bd3f3 = function edgeToNum(size, theme) {
    return size ? $853adfa6dc734342$var$parseMetricToNum(theme.global.edgeSize[size] || size) : 0;
};
var $853adfa6dc734342$var$fontSize = $853adfa6dc734342$export$85e3c3ca0c6fb93 = function fontSize(size, lineHeight) {
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], function(props) {
        return $853adfa6dc734342$var$parseMetricToNum(size) / $853adfa6dc734342$var$parseMetricToNum(props.theme.global.font.size) * 1 + "rem";
    }, function(props) {
        return lineHeight || Math.ceil($853adfa6dc734342$var$parseMetricToNum(size) / $853adfa6dc734342$var$parseMetricToNum(props.theme.global.lineHeight)) * ($853adfa6dc734342$var$parseMetricToNum(props.theme.global.lineHeight) / $853adfa6dc734342$var$parseMetricToNum(size)) + "px";
    });
};
var $853adfa6dc734342$var$breakpointStyle = $853adfa6dc734342$export$2180d12f0a299a89 = function breakpointStyle(breakpoint, content, responsive) {
    var px = typeof (breakpoint == null ? void 0 : breakpoint.value) === 'string' && breakpoint.value.endsWith('px') ? '' : 'px';
    var st = responsive === 'container' ? (0, $f5efw.css)([
        "@container ",
        "{",
        ";}"
    ], breakpoint.value && "(max-width: " + breakpoint.value + px + ")", content) : (0, $f5efw.css)([
        "@media only screen ",
        "{",
        ";}"
    ], breakpoint.value && "and (max-width: " + breakpoint.value + px + ")", content);
    return st;
};
var $853adfa6dc734342$var$_findAllByType = $853adfa6dc734342$export$fdd5e64c0e8495bb = function findAllByType(component, type) {
    var matches = [];
    if (component.type === type) matches.push(component);
    if (component.children) component.children.forEach(function(child) {
        matches = matches.concat($853adfa6dc734342$var$_findAllByType(child, type));
    });
    return matches;
};
var $853adfa6dc734342$var$getAvailableAtBadge = $853adfa6dc734342$export$319d1f43f7cd3019 = function getAvailableAtBadge(availableAt, componentType) {
    return [
        {
            url: "https://storybook.grommet.io/?selectedKind=" + componentType + "-" + availableAt + "&full=0&stories=1&panelRight=0",
            badge: 'https://cdn-images-1.medium.com/fit/c/120/120/1*TD1P0HtIH9zF0UEH28zYtw.png',
            label: 'Storybook'
        },
        {
            url: "https://codesandbox.io/s/github/grommet/grommet-sandbox?initialpath=/" + availableAt.toLowerCase() + "&module=%2Fsrc%2F" + availableAt + ".js",
            badge: 'https://codesandbox.io/static/img/play-codesandbox.svg',
            label: 'CodeSandbox'
        }
    ];
};

});


parcelRegister("fqTZ8", function(module, exports) {

$parcel$export(module.exports, "grommet", () => $b3c4b6340f91982c$export$9d812a0de4eabbe3, (v) => $b3c4b6340f91982c$export$9d812a0de4eabbe3 = v);
var $b3c4b6340f91982c$export$1e511d4a378977f5;
var $b3c4b6340f91982c$export$9d812a0de4eabbe3;
"use strict";
$b3c4b6340f91982c$export$1e511d4a378977f5 = true;
$b3c4b6340f91982c$export$9d812a0de4eabbe3 = void 0;

var $f5efw = parcelRequire("f5efw");

var $7Xne6 = parcelRequire("7Xne6");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $b3c4b6340f91982c$var$grommet = $b3c4b6340f91982c$export$9d812a0de4eabbe3 = (0, $7Xne6.deepFreeze)({
    global: {
        colors: {
            background: {
                light: '#ffffff',
                dark: '#000000'
            }
        },
        backgrounds: {
            stack: {
                color: 'light-1',
                image: "url(https://v2.grommet.io/img/stak-hurrah.svg)"
            },
            'gradient-purple-blue': {
                color: 'neutral-3',
                image: "linear-gradient(\n          #3D138D 0%, /* neutral-2 */\n          #00739D 100% /* neutral-3 */\n        );",
                rotate: 145
            },
            'gradient-purple-gold': {
                color: 'neutral-2',
                image: "linear-gradient(\n          #3D138D 0%, /* neutral-2 */\n          #EB0F79 75%,\n          #FFCA58 100% /* accent-4 */\n        );"
            }
        },
        font: {
            family: "-apple-system,\n         BlinkMacSystemFont, \n         \"Segoe UI\", \n         Roboto, \n         Oxygen, \n         Ubuntu, \n         Cantarell, \n         \"Fira Sans\", \n         \"Droid Sans\",  \n         \"Helvetica Neue\", \n         Arial, sans-serif,  \n         \"Apple Color Emoji\", \n         \"Segoe UI Emoji\", \n         \"Segoe UI Symbol\""
        }
    },
    button: {
        extend: (0, $f5efw.css)([
            "",
            ""
        ], function(props) {
            return !props.plain && 'font-weight: bold;';
        })
    }
});

});

parcelRegister("kNwUk", function(module, exports) {

$parcel$export(module.exports, "dark", () => $f241e8ffada3cf11$export$55ce6f3a06c59543, (v) => $f241e8ffada3cf11$export$55ce6f3a06c59543 = v);
var $f241e8ffada3cf11$export$1e511d4a378977f5;
var $f241e8ffada3cf11$export$55ce6f3a06c59543;
"use strict";
$f241e8ffada3cf11$export$1e511d4a378977f5 = true;
$f241e8ffada3cf11$export$55ce6f3a06c59543 = void 0;

var $f5efw = parcelRequire("f5efw");

var $7Xne6 = parcelRequire("7Xne6");

var $ccH8g = parcelRequire("ccH8g");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $f241e8ffada3cf11$var$accentColors = [
    '#FD6FFF',
    '#60EB9F',
    '#60EBE1',
    '#FFCA58'
];
var $f241e8ffada3cf11$var$neutralColors = [
    '#EB6060',
    '#01C781',
    '#6095EB',
    '#FFB200'
];
var $f241e8ffada3cf11$var$statusColors = {
    critical: '#FF3333',
    error: '#FF3333',
    warning: '#F7E464',
    ok: '#7DD892',
    unknown: '#a8a8a8',
    disabled: '#a8a8a8'
};
var $f241e8ffada3cf11$var$backgroundColor = '#111111';
var $f241e8ffada3cf11$var$colors = {
    active: 'rgba(102, 102, 102, 0.5)',
    background: $f241e8ffada3cf11$var$backgroundColor,
    black: '#000000',
    brand: '#FD6FFF',
    control: {
        dark: '#FFCA58',
        light: '#403216'
    },
    focus: '#FFCA58',
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    placeholder: '#AAAAAA',
    text: {
        dark: '#eeeeee',
        light: '#444444'
    },
    white: '#FFFFFF'
};
var $f241e8ffada3cf11$var$colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        $f241e8ffada3cf11$var$colors[prefix + "-" + (index + 1)] = color;
    });
};
$f241e8ffada3cf11$var$colorArray($f241e8ffada3cf11$var$accentColors, 'accent');
$f241e8ffada3cf11$var$colorArray($f241e8ffada3cf11$var$neutralColors, 'neutral');
Object.keys($f241e8ffada3cf11$var$statusColors).forEach(function(color) {
    $f241e8ffada3cf11$var$colors["status-" + color] = $f241e8ffada3cf11$var$statusColors[color];
});
var $f241e8ffada3cf11$var$dark = $f241e8ffada3cf11$export$55ce6f3a06c59543 = (0, $7Xne6.deepFreeze)({
    global: {
        colors: $f241e8ffada3cf11$var$colors,
        drop: {
            background: '#333333'
        },
        focus: {
            border: {
                color: (0, $f5efw.css)([
                    "",
                    ";"
                ], function(props) {
                    return (0, $ccH8g.normalizeColor)('focus', props.theme);
                }),
                width: '2px'
            }
        },
        font: {
            family: 'Arial'
        },
        input: {
            weight: 700
        }
    },
    anchor: {
        color: 'control'
    },
    layer: {
        background: $f241e8ffada3cf11$var$backgroundColor,
        overlay: {
            background: 'rgba(48, 48, 48, 0.5)'
        }
    }
});

});
parcelRegister("ccH8g", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $8e2810372a2a79de$export$1e511d4a378977f5, (v) => $8e2810372a2a79de$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "normalizeColor", () => $8e2810372a2a79de$export$4cde5df63f53f473, (v) => $8e2810372a2a79de$export$4cde5df63f53f473 = v);
$parcel$export(module.exports, "getRGBArray", () => $8e2810372a2a79de$export$5bcd173cc9a0dca, (v) => $8e2810372a2a79de$export$5bcd173cc9a0dca = v);
$parcel$export(module.exports, "getRGBA", () => $8e2810372a2a79de$export$c24a0a5c5129b2e1, (v) => $8e2810372a2a79de$export$c24a0a5c5129b2e1 = v);
$parcel$export(module.exports, "colorIsDark", () => $8e2810372a2a79de$export$76249e090d1c76db, (v) => $8e2810372a2a79de$export$76249e090d1c76db = v);
$parcel$export(module.exports, "canExtractRGBArray", () => $8e2810372a2a79de$export$6d62a0650580a0ff, (v) => $8e2810372a2a79de$export$6d62a0650580a0ff = v);
var $8e2810372a2a79de$export$1e511d4a378977f5;
var $8e2810372a2a79de$export$4cde5df63f53f473;
var $8e2810372a2a79de$export$5bcd173cc9a0dca;
var $8e2810372a2a79de$export$c24a0a5c5129b2e1;
var $8e2810372a2a79de$export$76249e090d1c76db;
var $8e2810372a2a79de$export$6d62a0650580a0ff;
"use strict";
$8e2810372a2a79de$export$1e511d4a378977f5 = true;
$8e2810372a2a79de$export$4cde5df63f53f473 = $8e2810372a2a79de$export$5bcd173cc9a0dca = $8e2810372a2a79de$export$c24a0a5c5129b2e1 = $8e2810372a2a79de$export$76249e090d1c76db = $8e2810372a2a79de$export$6d62a0650580a0ff = void 0;
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
// Track which deprecated colors have already been warned about
var $8e2810372a2a79de$var$warnedColors = new Set();
var $8e2810372a2a79de$var$checkColorDeprecation = function checkColorDeprecation(color, theme, dark) {
    var _theme$global$depreca;
    (_theme$global$depreca = theme.global.deprecated) != null && _theme$global$depreca.colors;
    var colorKey, deprecatedColor;
};
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var $8e2810372a2a79de$var$_normalizeColor = $8e2810372a2a79de$export$4cde5df63f53f473 = function normalizeColor(color, theme, dark) {
    $8e2810372a2a79de$var$checkColorDeprecation(color, theme, dark);
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = $8e2810372a2a79de$var$_normalizeColor(result, theme, dark);
    return result;
};
var $8e2810372a2a79de$var$parseHexToRGB = function parseHexToRGB(color) {
    return color.length < 7 // 7 is what's needed for '#RRGGBB'
     ? color.match(/[A-Za-z0-9]{1}/g).map(function(v) {
        return parseInt("" + v + v, 16);
    }) : // https://stackoverflow.com/a/42429333
    color.match(/[A-Za-z0-9]{2}/g).map(function(v) {
        return parseInt(v, 16);
    });
};
// From: https://stackoverflow.com/a/9493060/8513067
// Converts an HSL color value to RGB. Conversion formula
// adapted from http://en.wikipedia.org/wiki/HSL_color_space.
// Assumes h, s, and l are contained in the set [0, 1] and
// returns r, g, and b in the set [0, 255].
var $8e2810372a2a79de$var$hslToRGB = function hslToRGB(h, s, l) {
    var r;
    var g;
    var b;
    if (s === 0 || s === '0') {
        // achromatic
        r = l;
        g = l;
        b = l;
    } else {
        var hue2rgb = function hue2rgb(p, q, inT) {
            var t = inT;
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 0.16666667) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 0.66666667) return p + (q - p) * (0.66666667 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 0.33333333);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 0.33333333);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255)
    ];
};
// allow for alpha: #RGB, #RGBA, #RRGGBB, or #RRGGBBAA
var $8e2810372a2a79de$var$hexExp = /^#[A-Za-z0-9]{3,4}$|^#[A-Za-z0-9]{6,8}$/;
var $8e2810372a2a79de$var$rgbExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?\)/;
var $8e2810372a2a79de$var$rgbaExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([.0-9]*)\s?\)/;
// e.g. hsl(240, 60%, 50%)
var $8e2810372a2a79de$var$hslExp = /^hsla?\(\s?([0-9]*)\s?,\s?([0-9]*)%?\s?,\s?([0-9]*)%?\s?.*?\)/;
var $8e2810372a2a79de$var$canExtractRGBArray = $8e2810372a2a79de$export$6d62a0650580a0ff = function canExtractRGBArray(color) {
    return $8e2810372a2a79de$var$hexExp.test(color) || $8e2810372a2a79de$var$rgbExp.test(color) || $8e2810372a2a79de$var$rgbaExp.test(color) || $8e2810372a2a79de$var$hslExp.test(color);
};
var $8e2810372a2a79de$var$getRGBArray = $8e2810372a2a79de$export$5bcd173cc9a0dca = function getRGBArray(color) {
    if ($8e2810372a2a79de$var$hexExp.test(color)) {
        var _parseHexToRGB = $8e2810372a2a79de$var$parseHexToRGB(color), red = _parseHexToRGB[0], green = _parseHexToRGB[1], blue = _parseHexToRGB[2], alpha = _parseHexToRGB[3];
        return [
            red,
            green,
            blue,
            alpha !== undefined ? alpha / 255.0 : undefined
        ];
    }
    var match = color.match($8e2810372a2a79de$var$rgbExp);
    if (match) return match.splice(1).map(function(v) {
        return parseInt(v, 10);
    });
    match = color.match($8e2810372a2a79de$var$rgbaExp);
    if (match) return match.splice(1).map(function(v) {
        return parseFloat(v, 10);
    });
    match = color.match($8e2810372a2a79de$var$hslExp);
    if (match) {
        var _match$splice$map = match.splice(1).map(function(v) {
            return parseInt(v, 10);
        }), h = _match$splice$map[0], s = _match$splice$map[1], l = _match$splice$map[2];
        return $8e2810372a2a79de$var$hslToRGB(h / 360.0, s / 100.0, l / 100.0);
    }
    return color;
};
var $8e2810372a2a79de$var$colorIsDark = $8e2810372a2a79de$export$76249e090d1c76db = function colorIsDark(color) {
    if (color && $8e2810372a2a79de$var$canExtractRGBArray(color)) {
        var _getRGBArray = $8e2810372a2a79de$var$getRGBArray(color), red = _getRGBArray[0], green = _getRGBArray[1], blue = _getRGBArray[2], alpha = _getRGBArray[3];
        // if there is an alpha and it's greater than 50%, we can't really tell
        if (alpha < 0.5) return undefined;
        var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
        // From: http://www.had2know.com/technology/color-contrast-calculator-web-design.html
        // Above domain is no longer registered.
        return brightness < 125;
    }
    return undefined;
};
var $8e2810372a2a79de$var$getRGBA = $8e2810372a2a79de$export$c24a0a5c5129b2e1 = function getRGBA(color, opacity) {
    if (color && $8e2810372a2a79de$var$canExtractRGBArray(color)) {
        var _getRGBArray2 = $8e2810372a2a79de$var$getRGBArray(color), red = _getRGBArray2[0], green = _getRGBArray2[1], blue = _getRGBArray2[2], alpha = _getRGBArray2[3];
        var normalizedAlpha;
        if (opacity !== undefined) normalizedAlpha = opacity;
        else if (alpha !== undefined) normalizedAlpha = alpha;
        else normalizedAlpha = 1;
        return "rgba(" + red + ", " + green + ", " + blue + ", " + normalizedAlpha + ")";
    }
    return undefined;
};

});


parcelRegister("ilKhA", function(module, exports) {

$parcel$export(module.exports, "hacktoberfest2022", () => $d5be16eceeb983bb$export$b2f72e3c920710c0, (v) => $d5be16eceeb983bb$export$b2f72e3c920710c0 = v);
var $d5be16eceeb983bb$export$1e511d4a378977f5;
var $d5be16eceeb983bb$export$b2f72e3c920710c0;
"use strict";
$d5be16eceeb983bb$export$1e511d4a378977f5 = true;
$d5be16eceeb983bb$export$b2f72e3c920710c0 = void 0;

var $f5efw = parcelRequire("f5efw");

var $7Xne6 = parcelRequire("7Xne6");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $d5be16eceeb983bb$var$hacktoberfest2022 = $d5be16eceeb983bb$export$b2f72e3c920710c0 = (0, $7Xne6.deepFreeze)({
    defaultMode: 'dark',
    global: {
        colors: {
            background: '#160F1D',
            'background-back': '#000000',
            'background-front': '#160F1D',
            'text-strong': '#FFFFFF',
            text: '#E4E1E6',
            'text-weak': '#76717A',
            grey: '#AFACB2',
            lime: '#C6FC60',
            pink: '#D856A7',
            purple: '#7C7EF4',
            teal: '#73DAFB',
            yellow: '#EDD063',
            darkPurple: '#291E40',
            active: 'purple',
            focus: '#233670',
            brand: 'lime',
            control: 'teal',
            'graph-0': 'yellow',
            'graph-1': 'purple',
            'graph-2': 'teal',
            'graph-3': 'pink',
            'graph-4': 'lime',
            // clear unused colors
            icon: undefined,
            'accent-1': undefined,
            'accent-2': undefined,
            'accent-3': undefined,
            'accent-4': undefined,
            'neutral-1': undefined,
            'neutral-2': undefined,
            'neutral-3': undefined,
            'neutral-4': undefined,
            'neutral-5': undefined,
            'light-1': undefined,
            'light-2': undefined,
            'light-3': undefined,
            'light-4': undefined,
            'light-5': undefined,
            'light-6': undefined,
            'dark-1': undefined,
            'dark-2': undefined,
            'dark-3': undefined,
            'dark-4': undefined,
            'dark-5': undefined,
            'dark-6': undefined
        },
        backgrounds: {
            'gradient-purple-teal': {
                image: "linear-gradient(\n          #7C7EF4 0%,\n          #73DAFB 100%\n        );"
            },
            'gradient-teal-purple': {
                image: "linear-gradient(\n          #73DAFB 0%,\n          #7C7EF4 100%\n        );"
            },
            'gradient-yellow-teal-purple': {
                image: "linear-gradient(\n          #EDD063 0%,\n          #73DAFB 50%,\n          #7C7EF4 100%\n        );",
                rotate: 90
            },
            'gradient-yellow-teal': {
                image: "linear-gradient(\n          #EDD063 0%,\n          #73DAFB 100%\n        );",
                rotate: 90
            }
        },
        focus: {
            shadow: {
                color: 'focus',
                size: '3px'
            }
        },
        font: {
            family: '"JetBrains Mono", monospace',
            face: "/* latin */\n@font-face {\n  font-family: 'JetBrains Mono';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/jetbrainsmono/v13/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yKxTOlOTk6OThhvA.woff) format('woff');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}"
        }
    },
    grommet: {
        extend: (0, $f5efw.css)([
            "text-transform:uppercase;"
        ])
    },
    anchor: {
        color: 'text',
        hover: {
            color: 'text-strong'
        }
    },
    button: {
        border: {
            width: '0px',
            radius: '0px'
        },
        padding: {
            horizontal: '20px',
            vertical: '10px'
        },
        color: 'text-strong',
        size: {
            small: {
                pad: {
                    horizontal: '16px',
                    vertical: '8px'
                }
            },
            medium: {
                pad: {
                    horizontal: '20px',
                    vertical: '10px'
                }
            }
        },
        "default": {
            color: 'text-strong'
        },
        primary: {
            border: false,
            background: 'gradient-yellow-teal-purple',
            color: 'text'
        },
        hover: {
            border: false
        },
        extend: (0, $f5efw.css)([
            "clip-path:polygon( 12px 0px,100% 0px,100% 72%,calc(100% - 12px) 100%,0px 100%,0px 12px );text-transform:uppercase;&:focus{clip-path:none;}"
        ])
    },
    heading: {
        extend: (0, $f5efw.css)([
            "text-shadow:rgba(255,215,77,0.6) -1px -1px 6px,rgba(124,127,255,0.6) 1px 1px 6px;"
        ])
    }
});

});


parcelRegister("bIyki", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $czlZq = parcelRequire("czlZq");
Object.keys($czlZq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $czlZq[key]) return;
    module.exports[key] = $czlZq[key];
});

var $brba2 = parcelRequire("brba2");
Object.keys($brba2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $brba2[key]) return;
    module.exports[key] = $brba2[key];
});

var $fRffU = parcelRequire("fRffU");
Object.keys($fRffU).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fRffU[key]) return;
    module.exports[key] = $fRffU[key];
});

var $lenrl = parcelRequire("lenrl");
Object.keys($lenrl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lenrl[key]) return;
    module.exports[key] = $lenrl[key];
});

var $ccH8g = parcelRequire("ccH8g");
Object.keys($ccH8g).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ccH8g[key]) return;
    module.exports[key] = $ccH8g[key];
});

var $NF4SN = parcelRequire("NF4SN");
Object.keys($NF4SN).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $NF4SN[key]) return;
    module.exports[key] = $NF4SN[key];
});

var $khIFs = parcelRequire("khIFs");
Object.keys($khIFs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $khIFs[key]) return;
    module.exports[key] = $khIFs[key];
});

var $ec5Qt = parcelRequire("ec5Qt");
Object.keys($ec5Qt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ec5Qt[key]) return;
    module.exports[key] = $ec5Qt[key];
});

var $4e30Z = parcelRequire("4e30Z");
Object.keys($4e30Z).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $4e30Z[key]) return;
    module.exports[key] = $4e30Z[key];
});

var $fB4Oe = parcelRequire("fB4Oe");
Object.keys($fB4Oe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fB4Oe[key]) return;
    module.exports[key] = $fB4Oe[key];
});

var $7Xne6 = parcelRequire("7Xne6");
Object.keys($7Xne6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7Xne6[key]) return;
    module.exports[key] = $7Xne6[key];
});

var $aN9S5 = parcelRequire("aN9S5");
Object.keys($aN9S5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aN9S5[key]) return;
    module.exports[key] = $aN9S5[key];
});

var $63hjX = parcelRequire("63hjX");
Object.keys($63hjX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $63hjX[key]) return;
    module.exports[key] = $63hjX[key];
});

var $66Ae2 = parcelRequire("66Ae2");
Object.keys($66Ae2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $66Ae2[key]) return;
    module.exports[key] = $66Ae2[key];
});

var $d9eMn = parcelRequire("d9eMn");
Object.keys($d9eMn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $d9eMn[key]) return;
    module.exports[key] = $d9eMn[key];
});

var $6tePH = parcelRequire("6tePH");
Object.keys($6tePH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $6tePH[key]) return;
    module.exports[key] = $6tePH[key];
});

var $nKbiW = parcelRequire("nKbiW");
Object.keys($nKbiW).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $nKbiW[key]) return;
    module.exports[key] = $nKbiW[key];
});

var $hT1tp = parcelRequire("hT1tp");
Object.keys($hT1tp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hT1tp[key]) return;
    module.exports[key] = $hT1tp[key];
});

});
parcelRegister("czlZq", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $9269cfa2f7a4ae00$export$1e511d4a378977f5, (v) => $9269cfa2f7a4ae00$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "normalizeTiming", () => $9269cfa2f7a4ae00$export$9eb47d7051add002, (v) => $9269cfa2f7a4ae00$export$9eb47d7051add002 = v);
$parcel$export(module.exports, "animationObjectStyle", () => $9269cfa2f7a4ae00$export$1d0c30b40b07398, (v) => $9269cfa2f7a4ae00$export$1d0c30b40b07398 = v);
$parcel$export(module.exports, "animationEnding", () => $9269cfa2f7a4ae00$export$cc25916ed0a5fe3a, (v) => $9269cfa2f7a4ae00$export$cc25916ed0a5fe3a = v);
$parcel$export(module.exports, "animationBounds", () => $9269cfa2f7a4ae00$export$106a9d8bc0bca92a, (v) => $9269cfa2f7a4ae00$export$106a9d8bc0bca92a = v);
var $9269cfa2f7a4ae00$export$1e511d4a378977f5;
var $9269cfa2f7a4ae00$export$9eb47d7051add002;
var $9269cfa2f7a4ae00$export$1d0c30b40b07398;
var $9269cfa2f7a4ae00$export$cc25916ed0a5fe3a;
var $9269cfa2f7a4ae00$export$106a9d8bc0bca92a;
"use strict";
$9269cfa2f7a4ae00$export$1e511d4a378977f5 = true;
$9269cfa2f7a4ae00$export$9eb47d7051add002 = $9269cfa2f7a4ae00$export$1d0c30b40b07398 = $9269cfa2f7a4ae00$export$cc25916ed0a5fe3a = $9269cfa2f7a4ae00$export$106a9d8bc0bca92a = void 0;

var $f5efw = parcelRequire("f5efw");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $9269cfa2f7a4ae00$var$PULSE_SIZES = {
    xsmall: 1.001,
    small: 1.01,
    medium: 1.1,
    large: 1.5,
    xlarge: 2
};
var $9269cfa2f7a4ae00$var$SLIDE_SIZES = {
    xsmall: 1,
    small: 5,
    medium: 10,
    large: 50,
    xlarge: 200
};
var $9269cfa2f7a4ae00$var$JIGGLE_SIZES = {
    xsmall: 0.1,
    small: 1,
    medium: 5,
    large: 400,
    xlarge: 1000
};
var $9269cfa2f7a4ae00$var$ZOOM_SIZES = {
    xsmall: 0.001,
    small: 0.01,
    medium: 0.05,
    large: 0.1,
    xlarge: 0.5
};
var $9269cfa2f7a4ae00$var$animationBounds = $9269cfa2f7a4ae00$export$106a9d8bc0bca92a = function animationBounds(type, size) {
    if (size === void 0) size = 'medium';
    if (type === 'draw') return [
        '',
        "stroke-dashoffset: 0"
    ];
    if (type === 'fadeIn') return [
        'opacity: 0;',
        'opacity: 1;'
    ];
    if (type === 'fadeOut') return [
        'opacity: 1;',
        'opacity: 0;'
    ];
    if (type === 'jiggle') {
        var deg = $9269cfa2f7a4ae00$var$JIGGLE_SIZES[size];
        return [
            "transform: rotate(-" + deg + "deg);",
            "transform: rotate(" + deg + "deg);"
        ];
    }
    if (type === 'pulse') return [
        'transform: scale(1);',
        "transform: scale(" + $9269cfa2f7a4ae00$var$PULSE_SIZES[size] + ")"
    ];
    if (type === 'rotateRight') return [
        "transform: rotate(0deg);",
        "transform: rotate(359deg);"
    ];
    if (type === 'rotateLeft') return [
        "transform: rotate(0deg);",
        "transform: rotate(-359deg);"
    ];
    if (type === 'flipIn') return [
        'transform: rotateY(90deg);',
        'transform: rotateY(0);'
    ];
    if (type === 'flipOut') return [
        'transform: rotateY(0);',
        'transform: rotateY(90deg);'
    ];
    if (type === 'slideDown') return [
        "transform: translateY(-" + $9269cfa2f7a4ae00$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideLeft') return [
        "transform: translateX(" + $9269cfa2f7a4ae00$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideRight') return [
        "transform: translateX(-" + $9269cfa2f7a4ae00$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideUp') return [
        "transform: translateY(" + $9269cfa2f7a4ae00$var$SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'zoomIn') return [
        "transform: scale(" + (1 - $9269cfa2f7a4ae00$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    if (type === 'zoomOut') return [
        "transform: scale(" + (1 + $9269cfa2f7a4ae00$var$ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    return [];
};
var $9269cfa2f7a4ae00$var$normalizeTiming = $9269cfa2f7a4ae00$export$9eb47d7051add002 = function normalizeTiming(time, defaultTiming) {
    return typeof time === 'number' ? time / 1000.0 + "s" : time || defaultTiming;
};
var $9269cfa2f7a4ae00$var$animationEnding = $9269cfa2f7a4ae00$export$cc25916ed0a5fe3a = function animationEnding(type) {
    if (type === 'draw') return 'linear forwards';
    if (type === 'jiggle') return 'alternate infinite';
    if (type === 'pulse') return 'alternate infinite';
    if (type === 'rotateRight' || type === 'rotateLeft') return 'infinite linear';
    return 'forwards';
};
var $9269cfa2f7a4ae00$var$animationObjectStyle = $9269cfa2f7a4ae00$export$1d0c30b40b07398 = function animationObjectStyle(animation, theme, themeObj) {
    var bounds = $9269cfa2f7a4ae00$var$animationBounds(animation.type, animation.size);
    var animationTheme = themeObj && themeObj.animation || theme.global.animation;
    if (bounds) {
        var animationTransition = (0, $f5efw.css)([
            "from{",
            ";}to{",
            ";}"
        ], bounds[0], bounds[1]);
        var defaultDuration = function defaultDuration() {
            return $9269cfa2f7a4ae00$var$normalizeTiming(animationTheme[animation.type] ? animationTheme[animation.type].duration : animation.duration, animationTheme.duration);
        };
        return (0, $f5efw.css)([
            "",
            " ",
            " ",
            " ",
            ""
        ], (0, $f5efw.keyframes)([
            "",
            ""
        ], animationTransition), $9269cfa2f7a4ae00$var$normalizeTiming(animation.duration, defaultDuration()), $9269cfa2f7a4ae00$var$normalizeTiming(animation.delay, '0s'), $9269cfa2f7a4ae00$var$animationEnding(animation.type));
    }
    return '';
};

});

parcelRegister("fRffU", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $b8b7a3b38bd50f5e$export$1e511d4a378977f5, (v) => $b8b7a3b38bd50f5e$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "selectedStyle", () => $b8b7a3b38bd50f5e$export$a7abb1b3dc25813f, (v) => $b8b7a3b38bd50f5e$export$a7abb1b3dc25813f = v);
$parcel$export(module.exports, "normalizeBackground", () => $b8b7a3b38bd50f5e$export$7b802385d70a5af9, (v) => $b8b7a3b38bd50f5e$export$7b802385d70a5af9 = v);
$parcel$export(module.exports, "getHoverIndicatorStyle", () => $b8b7a3b38bd50f5e$export$172ca055ee2bcc62, (v) => $b8b7a3b38bd50f5e$export$172ca055ee2bcc62 = v);
$parcel$export(module.exports, "backgroundStyle", () => $b8b7a3b38bd50f5e$export$e43a4f0de05cb7e9, (v) => $b8b7a3b38bd50f5e$export$e43a4f0de05cb7e9 = v);
$parcel$export(module.exports, "backgroundIsDark", () => $b8b7a3b38bd50f5e$export$d285dc898c6a4d11, (v) => $b8b7a3b38bd50f5e$export$d285dc898c6a4d11 = v);
$parcel$export(module.exports, "backgroundAndTextColors", () => $b8b7a3b38bd50f5e$export$51f19bd17c18b682, (v) => $b8b7a3b38bd50f5e$export$51f19bd17c18b682 = v);
$parcel$export(module.exports, "activeStyle", () => $b8b7a3b38bd50f5e$export$d51670144e8c59cf, (v) => $b8b7a3b38bd50f5e$export$d51670144e8c59cf = v);
var $b8b7a3b38bd50f5e$export$1e511d4a378977f5;
var $b8b7a3b38bd50f5e$export$a7abb1b3dc25813f;
var $b8b7a3b38bd50f5e$export$7b802385d70a5af9;
var $b8b7a3b38bd50f5e$export$172ca055ee2bcc62;
var $b8b7a3b38bd50f5e$export$e43a4f0de05cb7e9;
var $b8b7a3b38bd50f5e$export$d285dc898c6a4d11;
var $b8b7a3b38bd50f5e$export$51f19bd17c18b682;
var $b8b7a3b38bd50f5e$export$d51670144e8c59cf;
"use strict";
$b8b7a3b38bd50f5e$export$1e511d4a378977f5 = true;
$b8b7a3b38bd50f5e$export$a7abb1b3dc25813f = $b8b7a3b38bd50f5e$export$7b802385d70a5af9 = $b8b7a3b38bd50f5e$export$172ca055ee2bcc62 = $b8b7a3b38bd50f5e$export$e43a4f0de05cb7e9 = $b8b7a3b38bd50f5e$export$d285dc898c6a4d11 = $b8b7a3b38bd50f5e$export$51f19bd17c18b682 = $b8b7a3b38bd50f5e$export$d51670144e8c59cf = void 0;

var $f5efw = parcelRequire("f5efw");

var $ccH8g = parcelRequire("ccH8g");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
// evalStyle() converts a styled-components item into a string
var $b8b7a3b38bd50f5e$var$evalStyle = function evalStyle(arg, theme) {
    if (arg && Array.isArray(arg) && typeof arg[0] === 'function') return arg[0]({
        theme: theme
    });
    return arg;
};
var $b8b7a3b38bd50f5e$var$normalizeBackground = $b8b7a3b38bd50f5e$export$7b802385d70a5af9 = function normalizeBackground(backgroundArg, theme) {
    var _theme$global$backgro;
    var background = ((_theme$global$backgro = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro[backgroundArg]) || backgroundArg;
    var result = background;
    // If the background has a light or dark object, use that
    if (background) {
        if (theme.dark && background.dark && typeof background.dark !== 'boolean') result = background.dark;
        else if (!theme.dark && background.light && typeof background.light !== 'boolean') result = background.light;
        result = $b8b7a3b38bd50f5e$var$evalStyle(result, theme);
    }
    return result;
};
var $b8b7a3b38bd50f5e$var$normalizeBackgroundColor = function normalizeBackgroundColor(backgroundArg, theme) {
    var _theme$global$backgro2;
    var background = backgroundArg.color || backgroundArg;
    var result = (0, $ccH8g.normalizeColor)(// Background color may be defined by theme.global.backgrounds or
    // theme.global.colors.
    ((_theme$global$backgro2 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro2[background]) || background, theme, backgroundArg.dark);
    return result;
};
var $b8b7a3b38bd50f5e$var$_normalizeBackgroundImage = function normalizeBackgroundImage(background, theme) {
    var result;
    if (background.image) {
        var _theme$global$backgro3, _theme$global$backgro4;
        result = $b8b7a3b38bd50f5e$var$normalizeBackground(background.dark ? (_theme$global$backgro3 = theme.global.backgrounds) == null || (_theme$global$backgro3 = _theme$global$backgro3[background.image]) == null ? void 0 : _theme$global$backgro3.dark : (_theme$global$backgro4 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro4[background.image], theme) || background.image;
    } else {
        var _theme$global$backgro5;
        var normalized = $b8b7a3b38bd50f5e$var$normalizeBackground((_theme$global$backgro5 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro5[background], theme);
        result = typeof normalized === 'object' ? $b8b7a3b38bd50f5e$var$_normalizeBackgroundImage(normalized, theme) : normalized;
    }
    return result;
};
var $b8b7a3b38bd50f5e$var$rotateBackground = function rotateBackground(background, theme) {
    var backgroundImage = $b8b7a3b38bd50f5e$var$_normalizeBackgroundImage(background, theme);
    var result = backgroundImage;
    if (backgroundImage.lastIndexOf('linear-gradient', 0) === 0) {
        var regex = /\d{1,}deg\b,/gm; // Contains rotation specified in degrees. Only targets 'deg' string with a trailing comma. Do not match 'deg' string for hsl, etc..
        result = backgroundImage.lastIndexOf('deg,') >= 0 ? backgroundImage.replace(regex, background.rotate + "deg,") : backgroundImage.replace('linear-gradient(', "linear-gradient(" + background.rotate + "deg, ");
    } else console.warn("'background.rotate' property only supports 'background.image' containing a linear-gradient string.");
    return result;
};
var $b8b7a3b38bd50f5e$var$backgroundIsDark = $b8b7a3b38bd50f5e$export$d285dc898c6a4d11 = function backgroundIsDark(backgroundArg, theme) {
    var background = $b8b7a3b38bd50f5e$var$normalizeBackground(backgroundArg, theme);
    var result;
    if (background) {
        if (typeof background === 'object') {
            var color = background.color, dark = background.dark, opacity = background.opacity;
            if (typeof dark === 'boolean') result = dark;
            else if (color && // weak opacity means we keep the existing darkness
            (!opacity || opacity !== 'weak')) {
                var backgroundColor = (0, $ccH8g.normalizeColor)(background.color, theme);
                if (backgroundColor) result = (0, $ccH8g.colorIsDark)(backgroundColor);
            }
        } else {
            var _color = (0, $ccH8g.normalizeColor)(background, theme);
            if (_color) result = (0, $ccH8g.colorIsDark)(_color);
        }
    }
    return result;
};
var $b8b7a3b38bd50f5e$var$darkContext = function darkContext(backgroundColor) {
    var isDark = (0, $ccH8g.colorIsDark)(backgroundColor);
    if (isDark === undefined) return undefined;
    return isDark ? 'dark' : 'light';
};
// Returns an array of two CSS colors: [background, color]
// Either could be undefined.
// background could be a CSS gradient, like "linear-gradient(...)"
var $b8b7a3b38bd50f5e$var$backgroundAndTextColors = $b8b7a3b38bd50f5e$export$51f19bd17c18b682 = function backgroundAndTextColors(backgroundArg, textArg, theme) {
    if (!backgroundArg) return [
        undefined,
        textArg
    ];
    var global = theme.global;
    var background = $b8b7a3b38bd50f5e$var$normalizeBackground(backgroundArg, theme);
    var text = textArg || global.colors.text;
    var backgroundColor;
    var textColor;
    if (typeof background === 'object') {
        if (background.dark === false) textColor = text.light || text;
        else if (background.dark) textColor = text.dark || text;
        if (background.color) {
            var color = $b8b7a3b38bd50f5e$var$normalizeBackgroundColor(background, theme);
            var opacity = background.opacity === true ? global.opacity.medium : global.opacity[background.opacity] || background.opacity;
            backgroundColor = (0, $ccH8g.getRGBA)(color, opacity) || color;
            // If we don't have a textColor already, and we aren't too translucent,
            // set the textColor to have the best contrast against the background
            // color.
            if (!textColor && (opacity === undefined || opacity > 0.3)) {
                var shade = $b8b7a3b38bd50f5e$var$darkContext(backgroundColor, theme);
                textColor = (0, $ccH8g.normalizeColor)(shade && text[shade] || text, theme);
            }
        }
    } else {
        backgroundColor = $b8b7a3b38bd50f5e$var$normalizeBackgroundColor(background, theme);
        var _shade = $b8b7a3b38bd50f5e$var$darkContext(backgroundColor, theme);
        var transparent;
        if (backgroundColor && (0, $ccH8g.canExtractRGBArray)(backgroundColor)) {
            var colorArray = (0, $ccH8g.getRGBArray)(backgroundColor);
            // check if the alpha value is less than 0.5
            if (colorArray[3] < 0.5) transparent = true;
        }
        if (_shade) textColor = (0, $ccH8g.normalizeColor)(text[_shade] || text, theme, _shade === 'dark');
        else if (transparent && text) textColor = (0, $ccH8g.normalizeColor)(text, theme);
        else {
            // If we can't determine the shade, we assume this isn't a simple color.
            // It could be a gradient. backgroundStyle() will take care of that case.
            if (backgroundColor !== 'transparent') backgroundColor = undefined;
            if (text) textColor = (0, $ccH8g.normalizeColor)(text, theme);
        }
    }
    // if textArg is false, we don't want the textColor, used for Button hover
    if (textArg === false) textColor = undefined;
    return [
        backgroundColor,
        textColor
    ];
};
var $b8b7a3b38bd50f5e$var$backgroundStyle = $b8b7a3b38bd50f5e$export$e43a4f0de05cb7e9 = function backgroundStyle(backgroundArg, theme, textColorArg) {
    // for Grommet component, if the background isn't defined, don't set it
    if (backgroundArg === undefined) return undefined;
    var background = $b8b7a3b38bd50f5e$var$normalizeBackground(backgroundArg, theme);
    var _backgroundAndTextCol = $b8b7a3b38bd50f5e$var$backgroundAndTextColors(background, textColorArg, theme), backgroundColor = _backgroundAndTextCol[0], textColor = _backgroundAndTextCol[1];
    var backgroundImage = background.rotate ? $b8b7a3b38bd50f5e$var$rotateBackground(background, theme) : $b8b7a3b38bd50f5e$var$_normalizeBackgroundImage(background, theme);
    var backgroundClipStyle = '';
    if (background.clip) backgroundClipStyle = background.clip === 'text' ? "-webkit-text-fill-color: transparent; \n           -webkit-background-clip: text; \n           background-clip: text;" : "background-clip: " + background.clip + ";";
    if (typeof background === 'string' && background.lastIndexOf('url', 0) === 0) return (0, $f5efw.css)([
        "background:",
        " no-repeat center center;background-size:cover;"
    ], background);
    if (backgroundImage) {
        var backgroundStyles = "\n      " + (backgroundColor ? "background-color: " + backgroundColor + ";" : '') + "\n      background-image: " + backgroundImage + ";\n      background-repeat: " + (typeof background === 'object' && background.repeat || 'no-repeat') + ";\n      background-position: " + (background.position || 'center center') + ";\n      background-size: " + (background.size || 'cover') + ";\n      " + backgroundClipStyle + "\n    ";
        // allow both background color and image, in case the image doesn't fill
        // when image and opacity are used together, we need to use pseudo :before
        // to ensure that only image and background color are affected by opacity
        // but not the container contents
        return (0, $f5efw.css)([
            "",
            " ",
            ""
        ], textColor ? "color: " + textColor + ";" : '', !background.opacity ? backgroundStyles : "position: relative;\n        z-index: 0;\n        &:before {\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          left: 0;\n          bottom: 0;\n          z-index: -1;\n          border-radius: inherit;\n          " + backgroundStyles + "\n          opacity: " + (background.opacity === true ? theme.global.opacity.medium : theme.global.opacity[background.opacity] || background.opacity) + ";\n        }");
    }
    if (backgroundColor) return (0, $f5efw.css)([
        "background-color:",
        ";",
        ""
    ], backgroundColor, textColor ? "color: " + textColor + ";" : '');
    if (typeof background === 'string') // This case takes care of gradients
    // or theme colors that use CSS names like 'crimson' that we don't parse
    return (0, $f5efw.css)([
        "background:",
        ";"
    ], (0, $ccH8g.normalizeColor)(background, theme));
    return undefined;
};
var $b8b7a3b38bd50f5e$var$activeStyle = $b8b7a3b38bd50f5e$export$d51670144e8c59cf = (0, $f5efw.css)([
    "",
    ""
], function(props) {
    return $b8b7a3b38bd50f5e$var$backgroundStyle((0, $ccH8g.normalizeColor)(props.theme.global.active.background, props.theme), props.theme, props.theme.global.active.color);
});
var $b8b7a3b38bd50f5e$var$selectedStyle = $b8b7a3b38bd50f5e$export$a7abb1b3dc25813f = (0, $f5efw.css)([
    "",
    ""
], function(props) {
    return $b8b7a3b38bd50f5e$var$backgroundStyle((0, $ccH8g.normalizeColor)(props.theme.global.selected.background, props.theme), props.theme, props.theme.global.selected.color);
});
var $b8b7a3b38bd50f5e$var$getHoverIndicatorStyle = $b8b7a3b38bd50f5e$export$172ca055ee2bcc62 = function getHoverIndicatorStyle(hoverIndicator, theme) {
    var background;
    var elevation;
    if (hoverIndicator === true || hoverIndicator === 'background') background = theme.global.hover.background;
    else if (typeof hoverIndicator === 'object') {
        if (hoverIndicator.elevation || hoverIndicator.background) {
            elevation = hoverIndicator.elevation;
            background = hoverIndicator.background;
        } else background = hoverIndicator;
    } else background = hoverIndicator;
    return (0, $f5efw.css)([
        "",
        " ",
        ""
    ], $b8b7a3b38bd50f5e$var$backgroundStyle(background, theme, theme.global.hover.color), elevation && "box-shadow: " + theme.global.elevation[theme.dark ? 'dark' : 'light'][elevation] + ";");
};

});

parcelRegister("lenrl", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $f74d167caac4bc09$export$1e511d4a378977f5, (v) => $f74d167caac4bc09$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "responsiveBorderStyle", () => $f74d167caac4bc09$export$e6d7d76967e857a7, (v) => $f74d167caac4bc09$export$e6d7d76967e857a7 = v);
$parcel$export(module.exports, "borderStyle", () => $f74d167caac4bc09$export$4d0a7f76ad443516, (v) => $f74d167caac4bc09$export$4d0a7f76ad443516 = v);
var $f74d167caac4bc09$export$1e511d4a378977f5;
var $f74d167caac4bc09$export$e6d7d76967e857a7;
var $f74d167caac4bc09$export$4d0a7f76ad443516;
"use strict";
$f74d167caac4bc09$export$1e511d4a378977f5 = true;
$f74d167caac4bc09$export$e6d7d76967e857a7 = $f74d167caac4bc09$export$4d0a7f76ad443516 = void 0;

var $f5efw = parcelRequire("f5efw");

var $ccH8g = parcelRequire("ccH8g");

var $brba2 = parcelRequire("brba2");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $f74d167caac4bc09$var$responsiveBorderStyle = $f74d167caac4bc09$export$e6d7d76967e857a7 = function responsiveBorderStyle(data, theme) {
    var color = (0, $ccH8g.normalizeColor)(data.color || 'border', theme);
    var borderSize = data.size || 'xsmall';
    var style = data.style || 'solid';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    var value = breakpoint && (breakpoint.borderSize[borderSize] || borderSize) && style + " " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;
    if (!value) return undefined;
    if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') return "border-" + side + ": " + value + ";";
    if (side === 'end' || side === 'start') return "border-inline-" + side + ": " + value + ";";
    if (side === 'vertical') return "\n      border-left: " + value + ";\n      border-right: " + value + ";\n    ";
    if (side === 'horizontal') return "\n      border-top: " + value + ";\n      border-bottom: " + value + ";\n    ";
    if (side === 'between') return undefined; // no-op
    return "border: " + value + ";";
};
var $f74d167caac4bc09$var$borderStyle = $f74d167caac4bc09$export$4d0a7f76ad443516 = function borderStyle(borderData, responsive, theme) {
    var borderStyles = [];
    (Array.isArray(borderData) ? borderData : [
        borderData
    ]).forEach(function(data) {
        var styles = [];
        var color = (0, $ccH8g.normalizeColor)(data.color || 'border', theme);
        var borderSize = data.size || 'xsmall';
        var style = data.style || 'solid';
        var side = typeof data === 'string' ? data : data.side || 'all';
        var value = style + " " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
        var responsiveStyle = responsive && $f74d167caac4bc09$var$responsiveBorderStyle(data, theme);
        var breakpoint = responsiveStyle && theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
        if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
            styles.push("border-" + side + ": " + value + ";");
            if (responsiveStyle) styles.push((0, $brba2.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'end' || side === 'start') {
            styles.push((0, $f5efw.css)([
                "border-inline-",
                ":",
                ";"
            ], side, value));
            if (responsiveStyle) styles.push((0, $brba2.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'vertical') {
            styles.push((0, $f5efw.css)([
                "border-left:",
                ";border-right:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $brba2.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'horizontal') {
            styles.push((0, $f5efw.css)([
                "border-top:",
                ";border-bottom:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, $brba2.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'between') ;
        else {
            styles.push((0, $f5efw.css)([
                "border:",
                ";"
            ], value));
            if (responsiveStyle) styles.push((0, $brba2.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        }
        borderStyles.push(styles);
    });
    return borderStyles;
};

});

parcelRegister("NF4SN", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $095470e786d77d94$export$1e511d4a378977f5, (v) => $095470e786d77d94$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "setHoursWithOffset", () => $095470e786d77d94$export$c739ab4d3d4926aa, (v) => $095470e786d77d94$export$c739ab4d3d4926aa = v);
$parcel$export(module.exports, "pad", () => $095470e786d77d94$export$5d04458e2a6c373e, (v) => $095470e786d77d94$export$5d04458e2a6c373e = v);
$parcel$export(module.exports, "normalizeStep", () => $095470e786d77d94$export$ef0994ae32443424, (v) => $095470e786d77d94$export$ef0994ae32443424 = v);
var $095470e786d77d94$export$1e511d4a378977f5;
var $095470e786d77d94$export$c739ab4d3d4926aa;
var $095470e786d77d94$export$5d04458e2a6c373e;
var $095470e786d77d94$export$ef0994ae32443424;
"use strict";
$095470e786d77d94$export$1e511d4a378977f5 = true;
$095470e786d77d94$export$c739ab4d3d4926aa = $095470e786d77d94$export$5d04458e2a6c373e = $095470e786d77d94$export$ef0994ae32443424 = void 0;
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $095470e786d77d94$var$setHoursWithOffset = $095470e786d77d94$export$c739ab4d3d4926aa = function setHoursWithOffset(date) {
    var newDate = new Date(date);
    if ((date == null ? void 0 : date.indexOf('T')) === -1) {
        var offset = newDate.getTimezoneOffset();
        var hour = newDate.getHours();
        newDate.setHours(hour, offset < 0 ? -offset : offset);
    }
    return newDate;
};
var $095470e786d77d94$var$pad = $095470e786d77d94$export$5d04458e2a6c373e = function pad(value) {
    return String(value).padStart(2, '0');
};
var $095470e786d77d94$var$normalizeStep = $095470e786d77d94$export$ef0994ae32443424 = function normalizeStep(step) {
    var parsed = Number(step);
    if (!Number.isFinite(parsed) || parsed <= 0) return 1;
    return Math.max(1, Math.floor(parsed));
};

});

parcelRegister("khIFs", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $ec480b44eb94511f$export$1e511d4a378977f5, (v) => $ec480b44eb94511f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "withinDropPortal", () => $ec480b44eb94511f$export$357c244c06d83dec, (v) => $ec480b44eb94511f$export$357c244c06d83dec = v);
$parcel$export(module.exports, "shouldKeepFocus", () => $ec480b44eb94511f$export$19f1b4b3dc25c57, (v) => $ec480b44eb94511f$export$19f1b4b3dc25c57 = v);
$parcel$export(module.exports, "setFocusWithoutScroll", () => $ec480b44eb94511f$export$99137e580254b26a, (v) => $ec480b44eb94511f$export$99137e580254b26a = v);
$parcel$export(module.exports, "makeNodeUnfocusable", () => $ec480b44eb94511f$export$f17a564c864b60a0, (v) => $ec480b44eb94511f$export$f17a564c864b60a0 = v);
$parcel$export(module.exports, "makeNodeFocusable", () => $ec480b44eb94511f$export$d25257a562ca003b, (v) => $ec480b44eb94511f$export$d25257a562ca003b = v);
$parcel$export(module.exports, "isNodeBeforeScroll", () => $ec480b44eb94511f$export$54c9800883215719, (v) => $ec480b44eb94511f$export$54c9800883215719 = v);
$parcel$export(module.exports, "isNodeAfterScroll", () => $ec480b44eb94511f$export$27af05f039e10378, (v) => $ec480b44eb94511f$export$27af05f039e10378 = v);
$parcel$export(module.exports, "isFocusable", () => $ec480b44eb94511f$export$4c063cf1350e6fed, (v) => $ec480b44eb94511f$export$4c063cf1350e6fed = v);
$parcel$export(module.exports, "getNewContainer", () => $ec480b44eb94511f$export$1cad4a11c7ad1375, (v) => $ec480b44eb94511f$export$1cad4a11c7ad1375 = v);
$parcel$export(module.exports, "getFirstFocusableDescendant", () => $ec480b44eb94511f$export$e957a3ef02119493, (v) => $ec480b44eb94511f$export$e957a3ef02119493 = v);
$parcel$export(module.exports, "findVisibleParent", () => $ec480b44eb94511f$export$4fe2c44731a76aa0, (v) => $ec480b44eb94511f$export$4fe2c44731a76aa0 = v);
$parcel$export(module.exports, "findScrollParents", () => $ec480b44eb94511f$export$14e46d92eb0648e, (v) => $ec480b44eb94511f$export$14e46d92eb0648e = v);
$parcel$export(module.exports, "findScrollParent", () => $ec480b44eb94511f$export$6a1689aaa66d814c, (v) => $ec480b44eb94511f$export$6a1689aaa66d814c = v);
$parcel$export(module.exports, "findButtonParent", () => $ec480b44eb94511f$export$37a8984127440e55, (v) => $ec480b44eb94511f$export$37a8984127440e55 = v);
$parcel$export(module.exports, "containsFocus", () => $ec480b44eb94511f$export$b03135936dd040ba, (v) => $ec480b44eb94511f$export$b03135936dd040ba = v);
var $ec480b44eb94511f$export$1e511d4a378977f5;
var $ec480b44eb94511f$export$357c244c06d83dec;
var $ec480b44eb94511f$export$19f1b4b3dc25c57;
var $ec480b44eb94511f$export$99137e580254b26a;
var $ec480b44eb94511f$export$f17a564c864b60a0;
var $ec480b44eb94511f$export$d25257a562ca003b;
var $ec480b44eb94511f$export$54c9800883215719;
var $ec480b44eb94511f$export$27af05f039e10378;
var $ec480b44eb94511f$export$4c063cf1350e6fed;
var $ec480b44eb94511f$export$1cad4a11c7ad1375;
var $ec480b44eb94511f$export$e957a3ef02119493;
var $ec480b44eb94511f$export$4fe2c44731a76aa0;
var $ec480b44eb94511f$export$14e46d92eb0648e;
var $ec480b44eb94511f$export$6a1689aaa66d814c;
var $ec480b44eb94511f$export$37a8984127440e55;
var $ec480b44eb94511f$export$b03135936dd040ba;
"use strict";
$ec480b44eb94511f$export$1e511d4a378977f5 = true;
$ec480b44eb94511f$export$357c244c06d83dec = $ec480b44eb94511f$export$19f1b4b3dc25c57 = $ec480b44eb94511f$export$99137e580254b26a = $ec480b44eb94511f$export$f17a564c864b60a0 = $ec480b44eb94511f$export$d25257a562ca003b = $ec480b44eb94511f$export$54c9800883215719 = $ec480b44eb94511f$export$27af05f039e10378 = $ec480b44eb94511f$export$4c063cf1350e6fed = $ec480b44eb94511f$export$1cad4a11c7ad1375 = $ec480b44eb94511f$export$e957a3ef02119493 = $ec480b44eb94511f$export$4fe2c44731a76aa0 = $ec480b44eb94511f$export$14e46d92eb0648e = $ec480b44eb94511f$export$6a1689aaa66d814c = $ec480b44eb94511f$export$37a8984127440e55 = $ec480b44eb94511f$export$b03135936dd040ba = void 0;
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $ec480b44eb94511f$var$findScrollParent = $ec480b44eb94511f$export$6a1689aaa66d814c = function findScrollParent(element, horizontal) {
    var result;
    if (element) {
        var parent = element.parentNode;
        while(!result && parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result = parent;
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result = parent;
            parent = parent.parentNode;
        }
        // last scrollable element will be the document
        // if nothing else is scrollable in the page
        if (!result) result = document;
        else if (result.tagName.toLowerCase() === 'body') result = document;
    }
    return result;
};
var $ec480b44eb94511f$var$documentTags = [
    'html',
    'body'
];
var $ec480b44eb94511f$var$findScrollParents = $ec480b44eb94511f$export$14e46d92eb0648e = function findScrollParents(element, horizontal) {
    var result = [];
    if (element) {
        var parent = element.parentNode;
        while(parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result.push(parent);
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result.push(parent);
            parent = parent.parentNode;
        }
        if (result.length && $ec480b44eb94511f$var$documentTags.includes(result[0].tagName.toLowerCase())) result.length = 0;
        // last scrollable element will be the document
        result.push(document);
    }
    return result;
};
var $ec480b44eb94511f$var$containsFocus = $ec480b44eb94511f$export$b03135936dd040ba = function containsFocus(node) {
    var root = node.getRootNode();
    var element = root.activeElement;
    while(element){
        if (element === node) break;
        element = element.parentElement;
    }
    return !!element;
};
var $ec480b44eb94511f$var$withinDropPortal = $ec480b44eb94511f$export$357c244c06d83dec = function withinDropPortal(node, portalContext) {
    var root = node == null ? void 0 : node.getRootNode();
    var element = node;
    var portalId;
    while(element && element !== root)if (element.hasAttribute('data-g-portal-id')) {
        portalId = element.getAttribute('data-g-portal-id');
        element = root;
    } else element = element.parentElement;
    // if portalContext doesn't contain the portalId then the
    // portal is new and node is within a drop that just opened
    if (portalId === undefined || portalContext.indexOf(parseInt(portalId, 10)) !== -1) return false;
    return true;
};
// Check if an element can receive focus: native form inputs, or non-native
// interactive elements with an explicit tabIndex attribute
// (e.g. span[role="spinbutton"]). Excludes native interactive elements
// (button, a) so they don't trigger FormField focus state.
var $ec480b44eb94511f$var$isFocusable = $ec480b44eb94511f$export$4c063cf1350e6fed = function isFocusable(element) {
    if (!element || element.disabled) return false;
    var tagName = element.tagName.toLowerCase();
    if (tagName === 'input' || tagName === 'select' || tagName === 'textarea') return true;
    // Only non-native-interactive elements with an explicit tabindex attribute
    var isNativeInteractive = tagName === 'button' || tagName === 'a';
    return !isNativeInteractive && element.tabIndex >= 0 && element.hasAttribute('tabindex');
};
// Get the first element that can receive focus
var $ec480b44eb94511f$var$getFirstFocusableDescendant = $ec480b44eb94511f$export$e957a3ef02119493 = function getFirstFocusableDescendant(element) {
    var children = element.getElementsByTagName('*');
    for(var i = 0; i < children.length; i += 1){
        var child = children[i];
        if ($ec480b44eb94511f$var$isFocusable(child)) return child;
    }
    return undefined;
};
var $ec480b44eb94511f$var$shouldKeepFocus = $ec480b44eb94511f$export$19f1b4b3dc25c57 = function shouldKeepFocus(root) {
    var element = root.activeElement;
    if ($ec480b44eb94511f$var$isFocusable(element)) return true;
    return !!$ec480b44eb94511f$var$getFirstFocusableDescendant(element);
};
var $ec480b44eb94511f$var$getNewContainer = $ec480b44eb94511f$export$1cad4a11c7ad1375 = function getNewContainer(target, targetChildPosition) {
    if (target === void 0) target = document.body;
    // setup DOM
    var container = document.createElement('div');
    if (targetChildPosition === 'first') // for SkipLinks
    target.prepend(container);
    else target.appendChild(container);
    return container;
};
var $ec480b44eb94511f$var$setFocusWithoutScroll = $ec480b44eb94511f$export$99137e580254b26a = function setFocusWithoutScroll(element) {
    var x = window.scrollX;
    var y = window.scrollY;
    element.focus();
    window.scrollTo(x, y);
};
var $ec480b44eb94511f$var$TABINDEX = 'tabindex';
var $ec480b44eb94511f$var$TABINDEX_STATE = 'data-g-tabindex';
var $ec480b44eb94511f$var$makeNodeFocusable = $ec480b44eb94511f$export$d25257a562ca003b = function makeNodeFocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.removeAttribute('aria-hidden');
        // allow children to receive focus again
        var elements = node.getElementsByTagName('*');
        // only reset elements we've changed in makeNodeUnfocusable()
        Array.prototype.filter.call(elements || [], function(element) {
            return element.hasAttribute($ec480b44eb94511f$var$TABINDEX_STATE);
        }).forEach(function(element) {
            var prior = element.getAttribute($ec480b44eb94511f$var$TABINDEX_STATE);
            if (prior >= 0) element.setAttribute($ec480b44eb94511f$var$TABINDEX, element.getAttribute($ec480b44eb94511f$var$TABINDEX_STATE));
            else if (prior === 'none') element.removeAttribute($ec480b44eb94511f$var$TABINDEX);
            element.removeAttribute($ec480b44eb94511f$var$TABINDEX_STATE);
        });
    }
};
// Using ^ and $ to match the whole tagName, and not e.g. <meta> and <data>.
var $ec480b44eb94511f$var$autoFocusingTags = /^(a|area|input|select|textarea|button|iframe)$/;
var $ec480b44eb94511f$var$makeNodeUnfocusable = $ec480b44eb94511f$export$f17a564c864b60a0 = function makeNodeUnfocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.setAttribute('aria-hidden', true);
        // prevent children to receive focus
        var elements = node.getElementsByTagName('*');
        // first, save off the tabIndex of any element with one
        Array.prototype.filter.call(elements || [], function(element) {
            return element.getAttribute($ec480b44eb94511f$var$TABINDEX) !== null;
        }).forEach(function(element) {
            // if TABINDEX_STATE already exists, it's holding the original value
            if (!element.getAttribute($ec480b44eb94511f$var$TABINDEX_STATE)) element.setAttribute($ec480b44eb94511f$var$TABINDEX_STATE, element.getAttribute($ec480b44eb94511f$var$TABINDEX));
            element.setAttribute($ec480b44eb94511f$var$TABINDEX, -1);
        });
        // then, if any element is inherently focusable and not handled above,
        // give it a tabIndex of -1 so it can't receive focus
        Array.prototype.filter.call(elements || [], function(element) {
            var currentTag = element.tagName.toLowerCase();
            return currentTag.match($ec480b44eb94511f$var$autoFocusingTags) && element.focus && element.getAttribute($ec480b44eb94511f$var$TABINDEX_STATE) === null;
        }).forEach(function(element) {
            element.setAttribute($ec480b44eb94511f$var$TABINDEX_STATE, 'none');
            element.setAttribute($ec480b44eb94511f$var$TABINDEX, -1);
        });
    }
};
var $ec480b44eb94511f$var$_findVisibleParent = $ec480b44eb94511f$export$4fe2c44731a76aa0 = function findVisibleParent(element) {
    if (element) // Get the closest ancestor element that is positioned.
    return element.offsetParent ? element : $ec480b44eb94511f$var$_findVisibleParent(element.parentElement) || element;
    return undefined;
};
var $ec480b44eb94511f$var$isNodeAfterScroll = $ec480b44eb94511f$export$27af05f039e10378 = function isNodeAfterScroll(node, target) {
    var _node$getBoundingClie = node.getBoundingClientRect(), bottom = _node$getBoundingClie.bottom;
    // target will be the document from findScrollParent()
    var _ref = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        height: 0,
        top: 0
    }, height = _ref.height, top = _ref.top;
    return bottom >= top + height;
};
var $ec480b44eb94511f$var$isNodeBeforeScroll = $ec480b44eb94511f$export$54c9800883215719 = function isNodeBeforeScroll(node, target) {
    var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top;
    // target will be the document from findScrollParent()
    var _ref2 = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        top: 0
    }, targetTop = _ref2.top;
    return top <= targetTop;
};
var $ec480b44eb94511f$var$_findButtonParent = $ec480b44eb94511f$export$37a8984127440e55 = function findButtonParent(element) {
    if (element && element.nodeName !== 'BUTTON' && element.nodeName !== 'A') return $ec480b44eb94511f$var$_findButtonParent(element.parentElement);
    return element;
};

});

parcelRegister("ec5Qt", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $a556b8766296e4f9$export$1e511d4a378977f5, (v) => $a556b8766296e4f9$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "wedgeCommands", () => $a556b8766296e4f9$export$9928994028c6cb9b, (v) => $a556b8766296e4f9$export$9928994028c6cb9b = v);
$parcel$export(module.exports, "translateEndAngle", () => $a556b8766296e4f9$export$bd97579b57102dc8, (v) => $a556b8766296e4f9$export$bd97579b57102dc8 = v);
$parcel$export(module.exports, "polarToCartesian", () => $a556b8766296e4f9$export$5c9a959bb3fc7749, (v) => $a556b8766296e4f9$export$5c9a959bb3fc7749 = v);
$parcel$export(module.exports, "lineCommands", () => $a556b8766296e4f9$export$3bbb56266409c57, (v) => $a556b8766296e4f9$export$3bbb56266409c57 = v);
$parcel$export(module.exports, "calcAngle", () => $a556b8766296e4f9$export$11a7b5abbf8340a, (v) => $a556b8766296e4f9$export$11a7b5abbf8340a = v);
$parcel$export(module.exports, "baseUnit", () => $a556b8766296e4f9$export$4738d597a47e577d, (v) => $a556b8766296e4f9$export$4738d597a47e577d = v);
$parcel$export(module.exports, "arcCommands", () => $a556b8766296e4f9$export$42585d8f3d81ad44, (v) => $a556b8766296e4f9$export$42585d8f3d81ad44 = v);
var $a556b8766296e4f9$export$1e511d4a378977f5;
var $a556b8766296e4f9$export$9928994028c6cb9b;
var $a556b8766296e4f9$export$bd97579b57102dc8;
var $a556b8766296e4f9$export$5c9a959bb3fc7749;
var $a556b8766296e4f9$export$3bbb56266409c57;
var $a556b8766296e4f9$export$11a7b5abbf8340a;
var $a556b8766296e4f9$export$4738d597a47e577d;
var $a556b8766296e4f9$export$42585d8f3d81ad44;
"use strict";
$a556b8766296e4f9$export$1e511d4a378977f5 = true;
$a556b8766296e4f9$export$9928994028c6cb9b = $a556b8766296e4f9$export$bd97579b57102dc8 = $a556b8766296e4f9$export$5c9a959bb3fc7749 = $a556b8766296e4f9$export$3bbb56266409c57 = $a556b8766296e4f9$export$11a7b5abbf8340a = $a556b8766296e4f9$export$4738d597a47e577d = $a556b8766296e4f9$export$42585d8f3d81ad44 = void 0;
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $a556b8766296e4f9$var$POST_DECIMAL_DIGITS = 10;
var $a556b8766296e4f9$var$baseUnit = $a556b8766296e4f9$export$4738d597a47e577d = 24;
var $a556b8766296e4f9$var$polarToCartesian = $a556b8766296e4f9$export$5c9a959bb3fc7749 = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
};
var $a556b8766296e4f9$var$intersection = function intersection(line1Point1, line1Point2, line2Point1, line2Point2) {
    var x1 = line1Point1.x, y1 = line1Point1.y;
    var x2 = line1Point2.x, y2 = line1Point2.y;
    var x3 = line2Point1.x, y3 = line2Point1.y;
    var x4 = line2Point2.x, y4 = line2Point2.y;
    // Calculate the denominator
    var denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    // Check if lines are parallel (denominator is 0)
    if (Math.abs(denominator) < 1e-10) return null; // Lines are parallel or coincident
    // Calculate the intersection point
    var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denominator;
    var u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denominator;
    // Calculate intersection coordinates
    var intersectionX = x1 + t * (x2 - x1);
    var intersectionY = y1 + t * (y2 - y1);
    return {
        x: intersectionX,
        y: intersectionY,
        // Optional: check if intersection is within line segments
        withinSegment1: t >= 0 && t <= 1,
        withinSegment2: u >= 0 && u <= 1
    };
};
var $a556b8766296e4f9$var$lineCommands = $a556b8766296e4f9$export$3bbb56266409c57 = function lineCommands(centerX, centerY, radius, angle) {
    var start = $a556b8766296e4f9$var$polarToCartesian(centerX, centerY, radius, angle);
    var d = [
        'M',
        centerX.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        centerY.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        'L',
        start.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $a556b8766296e4f9$var$arcCommands = $a556b8766296e4f9$export$42585d8f3d81ad44 = function arcCommands(centerX, centerY, radius, startAngle, endAngle) {
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 360) normalizedEndAngle = startAngle + 359.99;
    var start = $a556b8766296e4f9$var$polarToCartesian(centerX, centerY, radius, normalizedEndAngle);
    var end = $a556b8766296e4f9$var$polarToCartesian(centerX, centerY, radius, startAngle);
    var arcSweep = normalizedEndAngle - startAngle <= 180 ? '0' : '1';
    var d = [
        'M',
        start.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        'A',
        radius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        radius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        0,
        end.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        end.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $a556b8766296e4f9$var$calcAngle = $a556b8766296e4f9$export$11a7b5abbf8340a = function calcAngle(radius, angle, midAngle, gap) {
    if (gap === 0) return angle;
    var gapAngleRadians = Math.asin(Math.abs(gap) / radius);
    var gapAngle = gapAngleRadians * 180 / Math.PI;
    return gap > 0 ? Math.min(angle + gapAngle, midAngle) : Math.max(angle - gapAngle, midAngle);
};
var $a556b8766296e4f9$var$gapPoints = function gapPoints(centerX, centerY, outerRadius, innerRadius, angle, midAngle, gap) {
    var outerAngle = $a556b8766296e4f9$var$calcAngle(outerRadius, angle, midAngle, gap);
    var outer = $a556b8766296e4f9$var$polarToCartesian(centerX, centerY, outerRadius, outerAngle);
    var inner;
    if (innerRadius > 0) {
        var innerAngle = $a556b8766296e4f9$var$calcAngle(innerRadius, angle, midAngle, gap);
        inner = $a556b8766296e4f9$var$polarToCartesian(centerX, centerY, innerRadius, innerAngle);
    } else inner = $a556b8766296e4f9$var$polarToCartesian(centerX, centerY, Math.abs(gap), gap < 0 ? angle - 90 : angle + 90);
    return {
        outer: outer,
        inner: inner
    };
};
var $a556b8766296e4f9$var$wedgeCommands = $a556b8766296e4f9$export$9928994028c6cb9b = function wedgeCommands(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, endRound, startRoundDirection) {
    if (startRoundDirection === void 0) startRoundDirection = 0;
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 359.99) normalizedEndAngle = startAngle + 359.99;
    // if we're rounded we need to ajust the start points to
    // account for a bigger cap radius
    // add a little bit extra to start to allow for larger rounded inset cap
    // The extra needed can be calculated by the Pythagorean theorem
    var thickness = outerRadius - innerRadius;
    var extraGap = startRound ? Math.sqrt(Math.pow(thickness / 2 + startGap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
    // define the angle at the center of the wedge. We can't let the gap
    // go past this angle.
    // calculate the angle span between start and end
    var angleSpan = (endAngle < startAngle ? endAngle + 360 : endAngle) - startAngle;
    var midAngle = startAngle + angleSpan / 2;
    var start = $a556b8766296e4f9$var$gapPoints(centerX, centerY, outerRadius, innerRadius, startAngle, midAngle < startAngle ? midAngle + 360 : midAngle, startGap + extraGap, startRound);
    var end = $a556b8766296e4f9$var$gapPoints(centerX, centerY, outerRadius, innerRadius, normalizedEndAngle, midAngle > endAngle ? midAngle - 360 : midAngle, endGap, endRound);
    var largeAngle = normalizedEndAngle - startAngle > 180;
    var arcSweep = largeAngle ? '1' : '0';
    var innerCapRadius = innerRadius;
    var innerArcSweep = arcSweep;
    var middle;
    if (innerRadius <= 0) {
        // we're doing a pie wedge
        innerArcSweep = arcSweep === '0' ? '1' : '0';
        if (largeAngle) // for a large pie wedge it has an inner corner rather
        // than a point. We need to round the inner corner
        innerCapRadius = startGap || endGap || 0;
        else // for a small pie wedge we'll make a point in the center
        middle = $a556b8766296e4f9$var$intersection(start.outer, start.inner, end.outer, end.inner);
    }
    var capRadius = (outerRadius - innerRadius) / 2;
    var startCapRadius = capRadius + (startRoundDirection === 0 ? startGap / 2 : 0);
    var startPoint = middle || start.inner;
    var endPoint = middle || end.inner;
    var startCap = startRound ? [
        'A',
        startCapRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        startCapRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        0,
        0,
        startRoundDirection,
        start.outer.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        start.outer.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ];
    var endCap = endRound ? [
        'A',
        capRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        capRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        0,
        0,
        1,
        endPoint.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        endPoint.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ];
    var d = [
        'M',
        startPoint.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        startPoint.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ].concat(startCap, [
        'A',
        outerRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        outerRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        1,
        end.outer.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS),
        end.outer.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS)
    ], endCap);
    if (innerRadius > 0 || largeAngle) // for a donut or a large pie wedge, draw the inner arc
    d.push('A', innerCapRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS), innerCapRadius.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS), 0, innerArcSweep, 0, start.inner.x.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS), start.inner.y.toFixed($a556b8766296e4f9$var$POST_DECIMAL_DIGITS), 'Z' // close the path
    );
    return d.join(' ');
};
/* TranslatedEngAngle will now take the value of the
startAngle + anglePer * value and mod by 360. This was added
to take account the startAngle not being 0. So no matter the
value it will be % 360 to get the correct angle. 
*/ var $a556b8766296e4f9$var$translateEndAngle = $a556b8766296e4f9$export$bd97579b57102dc8 = function translateEndAngle(startAngle, anglePer, value) {
    return Math.max(0, startAngle + anglePer * value) % 360;
};

});

parcelRegister("4e30Z", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $313aceece816cecc$export$1e511d4a378977f5, (v) => $313aceece816cecc$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "useSizedIcon", () => $313aceece816cecc$export$a123f939253731a8, (v) => $313aceece816cecc$export$a123f939253731a8 = v);
var $313aceece816cecc$export$1e511d4a378977f5;
var $313aceece816cecc$export$a123f939253731a8;
"use strict";
$313aceece816cecc$export$1e511d4a378977f5 = true;
$313aceece816cecc$export$a123f939253731a8 = void 0;

var $2NacA = parcelRequire("2NacA");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $313aceece816cecc$var$useSizedIcon = $313aceece816cecc$export$a123f939253731a8 = function useSizedIcon(icon, size, theme) {
    var _theme$icon;
    return icon && theme != null && (_theme$icon = theme.icon) != null && _theme$icon.matchSize && !icon.props.size ? /*#__PURE__*/ (0, $2NacA.cloneElement)(icon, {
        size: size
    }) : icon;
};

});

parcelRegister("fB4Oe", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $b5ae0ab635b22e82$export$1e511d4a378977f5, (v) => $b5ae0ab635b22e82$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "widthStyle", () => $b5ae0ab635b22e82$export$c12f8e3e33f3bef7, (v) => $b5ae0ab635b22e82$export$c12f8e3e33f3bef7 = v);
$parcel$export(module.exports, "unfocusStyle", () => $b5ae0ab635b22e82$export$525440aaa2c64805, (v) => $b5ae0ab635b22e82$export$525440aaa2c64805 = v);
$parcel$export(module.exports, "textAlignStyle", () => $b5ae0ab635b22e82$export$4fc8e4871b69e1d6, (v) => $b5ae0ab635b22e82$export$4fc8e4871b69e1d6 = v);
$parcel$export(module.exports, "styledComponentsConfig", () => $b5ae0ab635b22e82$export$373e75d802fd707, (v) => $b5ae0ab635b22e82$export$373e75d802fd707 = v);
$parcel$export(module.exports, "sizeStyle", () => $b5ae0ab635b22e82$export$cb60038e9cf9f581, (v) => $b5ae0ab635b22e82$export$cb60038e9cf9f581 = v);
$parcel$export(module.exports, "roundStyle", () => $b5ae0ab635b22e82$export$98483643daf52539, (v) => $b5ae0ab635b22e82$export$98483643daf52539 = v);
$parcel$export(module.exports, "plainInputStyle", () => $b5ae0ab635b22e82$export$f9510e7ca63c26e5, (v) => $b5ae0ab635b22e82$export$f9510e7ca63c26e5 = v);
$parcel$export(module.exports, "overflowStyle", () => $b5ae0ab635b22e82$export$5938e7adc3ab8d08, (v) => $b5ae0ab635b22e82$export$5938e7adc3ab8d08 = v);
$parcel$export(module.exports, "kindPartStyles", () => $b5ae0ab635b22e82$export$73d7bd5e5b0271ce, (v) => $b5ae0ab635b22e82$export$73d7bd5e5b0271ce = v);
$parcel$export(module.exports, "inputStyle", () => $b5ae0ab635b22e82$export$533edcdef9a0af13, (v) => $b5ae0ab635b22e82$export$533edcdef9a0af13 = v);
$parcel$export(module.exports, "inputPadForIcon", () => $b5ae0ab635b22e82$export$cd595fd57f72dbc4, (v) => $b5ae0ab635b22e82$export$cd595fd57f72dbc4 = v);
$parcel$export(module.exports, "heightStyle", () => $b5ae0ab635b22e82$export$9f8046d1e2885811, (v) => $b5ae0ab635b22e82$export$9f8046d1e2885811 = v);
$parcel$export(module.exports, "getInputPadBySide", () => $b5ae0ab635b22e82$export$c98305b6d8dc560, (v) => $b5ae0ab635b22e82$export$c98305b6d8dc560 = v);
$parcel$export(module.exports, "getInputIconPad", () => $b5ae0ab635b22e82$export$633dd676a1e7a50a, (v) => $b5ae0ab635b22e82$export$633dd676a1e7a50a = v);
$parcel$export(module.exports, "genericStyles", () => $b5ae0ab635b22e82$export$a157b298d219a801, (v) => $b5ae0ab635b22e82$export$a157b298d219a801 = v);
$parcel$export(module.exports, "focusStyle", () => $b5ae0ab635b22e82$export$efbff472cb39d8b, (v) => $b5ae0ab635b22e82$export$efbff472cb39d8b = v);
$parcel$export(module.exports, "fillStyle", () => $b5ae0ab635b22e82$export$7d12e60b29024244, (v) => $b5ae0ab635b22e82$export$7d12e60b29024244 = v);
$parcel$export(module.exports, "elevationStyle", () => $b5ae0ab635b22e82$export$b4ff7c828301ce9f, (v) => $b5ae0ab635b22e82$export$b4ff7c828301ce9f = v);
$parcel$export(module.exports, "edgeStyle", () => $b5ae0ab635b22e82$export$944a9710f9445eee, (v) => $b5ae0ab635b22e82$export$944a9710f9445eee = v);
$parcel$export(module.exports, "disabledStyle", () => $b5ae0ab635b22e82$export$adf3fcef8e5e1347, (v) => $b5ae0ab635b22e82$export$adf3fcef8e5e1347 = v);
$parcel$export(module.exports, "controlBorderStyle", () => $b5ae0ab635b22e82$export$717407de81592eca, (v) => $b5ae0ab635b22e82$export$717407de81592eca = v);
$parcel$export(module.exports, "baseStyle", () => $b5ae0ab635b22e82$export$360b744af11007ac, (v) => $b5ae0ab635b22e82$export$360b744af11007ac = v);
$parcel$export(module.exports, "alignStyle", () => $b5ae0ab635b22e82$export$f530b7ab00e4c68d, (v) => $b5ae0ab635b22e82$export$f530b7ab00e4c68d = v);
$parcel$export(module.exports, "alignContentStyle", () => $b5ae0ab635b22e82$export$93b5fb4351939c1c, (v) => $b5ae0ab635b22e82$export$93b5fb4351939c1c = v);
var $b5ae0ab635b22e82$export$1e511d4a378977f5;
var $b5ae0ab635b22e82$export$c12f8e3e33f3bef7;
var $b5ae0ab635b22e82$export$525440aaa2c64805;
var $b5ae0ab635b22e82$export$4fc8e4871b69e1d6;
var $b5ae0ab635b22e82$export$373e75d802fd707;
var $b5ae0ab635b22e82$export$cb60038e9cf9f581;
var $b5ae0ab635b22e82$export$98483643daf52539;
var $b5ae0ab635b22e82$export$f9510e7ca63c26e5;
var $b5ae0ab635b22e82$export$5938e7adc3ab8d08;
var $b5ae0ab635b22e82$export$73d7bd5e5b0271ce;
var $b5ae0ab635b22e82$export$533edcdef9a0af13;
var $b5ae0ab635b22e82$export$cd595fd57f72dbc4;
var $b5ae0ab635b22e82$export$9f8046d1e2885811;
var $b5ae0ab635b22e82$export$c98305b6d8dc560;
var $b5ae0ab635b22e82$export$633dd676a1e7a50a;
var $b5ae0ab635b22e82$export$a157b298d219a801;
var $b5ae0ab635b22e82$export$efbff472cb39d8b;
var $b5ae0ab635b22e82$export$7d12e60b29024244;
var $b5ae0ab635b22e82$export$b4ff7c828301ce9f;
var $b5ae0ab635b22e82$export$944a9710f9445eee;
var $b5ae0ab635b22e82$export$adf3fcef8e5e1347;
var $b5ae0ab635b22e82$export$717407de81592eca;
var $b5ae0ab635b22e82$export$360b744af11007ac;
var $b5ae0ab635b22e82$export$f530b7ab00e4c68d;
var $b5ae0ab635b22e82$export$93b5fb4351939c1c;
"use strict";
$b5ae0ab635b22e82$export$1e511d4a378977f5 = true;
$b5ae0ab635b22e82$export$c12f8e3e33f3bef7 = $b5ae0ab635b22e82$export$525440aaa2c64805 = $b5ae0ab635b22e82$export$4fc8e4871b69e1d6 = $b5ae0ab635b22e82$export$373e75d802fd707 = $b5ae0ab635b22e82$export$cb60038e9cf9f581 = $b5ae0ab635b22e82$export$98483643daf52539 = $b5ae0ab635b22e82$export$f9510e7ca63c26e5 = $b5ae0ab635b22e82$export$5938e7adc3ab8d08 = $b5ae0ab635b22e82$export$73d7bd5e5b0271ce = $b5ae0ab635b22e82$export$533edcdef9a0af13 = $b5ae0ab635b22e82$export$cd595fd57f72dbc4 = $b5ae0ab635b22e82$export$9f8046d1e2885811 = $b5ae0ab635b22e82$export$c98305b6d8dc560 = $b5ae0ab635b22e82$export$633dd676a1e7a50a = $b5ae0ab635b22e82$export$a157b298d219a801 = $b5ae0ab635b22e82$export$efbff472cb39d8b = $b5ae0ab635b22e82$export$7d12e60b29024244 = $b5ae0ab635b22e82$export$b4ff7c828301ce9f = $b5ae0ab635b22e82$export$944a9710f9445eee = $b5ae0ab635b22e82$export$adf3fcef8e5e1347 = $b5ae0ab635b22e82$export$717407de81592eca = $b5ae0ab635b22e82$export$360b744af11007ac = $b5ae0ab635b22e82$export$f530b7ab00e4c68d = $b5ae0ab635b22e82$export$93b5fb4351939c1c = void 0;

var $f5efw = parcelRequire("f5efw");

var $b5ae0ab635b22e82$var$_isPropValid = $b5ae0ab635b22e82$var$_interopRequireDefault((parcelRequire("5h15o")));

var $fRffU = parcelRequire("fRffU");

var $ccH8g = parcelRequire("ccH8g");

var $6tePH = parcelRequire("6tePH");

var $brba2 = parcelRequire("brba2");
function $b5ae0ab635b22e82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
// ensure only valid DOM attributes are forwarded onto DOM
var $b5ae0ab635b22e82$var$styledComponentsConfig = $b5ae0ab635b22e82$export$373e75d802fd707 = {
    shouldForwardProp: $b5ae0ab635b22e82$var$_isPropValid["default"]
};
var $b5ae0ab635b22e82$var$baseStyle = $b5ae0ab635b22e82$export$360b744af11007ac = (0, $f5efw.css)([
    "font-family:",
    ";font-size:",
    ";line-height:",
    ";font-weight:",
    ";",
    " ",
    " box-sizing:border-box;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"
], function(props) {
    return props.theme.global.font.family;
}, function(props) {
    return props.theme.global.font.size;
}, function(props) {
    return props.theme.global.font.height;
}, function(props) {
    return props.theme.global.font.weight;
}, function(props) {
    return props.theme.global.font.variant && "\n    font-variant:" + props.theme.global.font.variant + ";\n  ";
}, function(props) {
    return !props.plain && (0, $fRffU.backgroundStyle)(props.theme.baseBackground, props.theme);
});
var $b5ae0ab635b22e82$var$controlBorderStyle = $b5ae0ab635b22e82$export$717407de81592eca = (0, $f5efw.css)([
    "border:",
    " solid ",
    ";border-radius:",
    ";"
], function(props) {
    return props.theme.global.control.border.width;
}, function(props) {
    return (0, $ccH8g.normalizeColor)(props.theme.global.control.border.color || 'border', props.theme);
}, function(props) {
    return props.theme.global.control.border.radius;
});
var $b5ae0ab635b22e82$var$getInputIconPad = $b5ae0ab635b22e82$export$633dd676a1e7a50a = function getInputIconPad(props) {
    var _props$theme, _props$theme2;
    var matchedIconSize = (_props$theme = props.theme) == null || (_props$theme = _props$theme.icon) == null || (_props$theme = _props$theme.size) == null ? void 0 : _props$theme[(props == null ? void 0 : props.size) || 'medium'];
    if ((_props$theme2 = props.theme) != null && (_props$theme2 = _props$theme2.icon) != null && _props$theme2.matchSize && matchedIconSize) return (0, $brba2.parseMetricToNum)(matchedIconSize) + (0, $brba2.parseMetricToNum)(props.theme.global.edgeSize.medium) + "px";
    return props.theme.global.edgeSize.large;
};
var $b5ae0ab635b22e82$var$edgeStyle = $b5ae0ab635b22e82$export$944a9710f9445eee = function edgeStyle(kind, data, responsive, responsiveBreakpoint, theme) {
    var breakpoint = (0, $6tePH.getBreakpointStyle)(theme, responsiveBreakpoint);
    if (typeof data === 'string') {
        var value = theme.global.edgeSize[data] || data;
        var responsiveValue = responsive && breakpoint && breakpoint.edgeSize[data];
        return (0, $f5efw.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, value, responsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n        " + kind + ": " + responsiveValue + ";\n      ", responsive) : '');
    }
    var result = [];
    var horizontal = data.horizontal, vertical = data.vertical, top = data.top, bottom = data.bottom, left = data.left, right = data.right;
    // if horizontal and vertical are equal OR all sides are equal,
    // we can just return a single css value such as padding: 12px
    // instead of breaking out by sides.
    var horizontalVerticalEqual = horizontal && vertical && horizontal === vertical;
    var allSidesEqual = top && bottom && left && right && top === bottom === left === right;
    if (horizontalVerticalEqual || allSidesEqual) {
        // since the values will be the same between vertical & horizontal OR
        // left, right, top, & bottom, we can just choose one
        var allSidesValue = horizontalVerticalEqual ? horizontal : top;
        var allSidesResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[allSidesValue];
        return (0, $f5efw.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, theme.global.edgeSize[allSidesValue] || allSidesValue, allSidesResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n        " + kind + ": " + allSidesResponsiveValue + ";\n      ", responsive) : '');
    }
    if (horizontal) {
        var horizontalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[horizontal];
        result.push((0, $f5efw.css)([
            "",
            "-left:",
            ";",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[horizontal] || horizontal, kind, theme.global.edgeSize[horizontal] || horizontal, horizontalResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-left: " + horizontalResponsiveValue + ";\n          " + kind + "-right: " + horizontalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (vertical) {
        var verticalResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[vertical];
        result.push((0, $f5efw.css)([
            "",
            "-top:",
            ";",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[vertical] || vertical, kind, theme.global.edgeSize[vertical] || vertical, verticalResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-top: " + verticalResponsiveValue + ";\n          " + kind + "-bottom: " + verticalResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (top) {
        var topResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[top];
        result.push((0, $f5efw.css)([
            "",
            "-top:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[top] || top, topResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-top: " + topResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (bottom) {
        var bottomResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[bottom];
        result.push((0, $f5efw.css)([
            "",
            "-bottom:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[bottom] || bottom, bottomResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-bottom: " + bottomResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (left) {
        var leftResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[left];
        result.push((0, $f5efw.css)([
            "",
            "-left:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[left] || left, leftResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-left: " + leftResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (right) {
        var rightResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[right];
        result.push((0, $f5efw.css)([
            "",
            "-right:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[right] || right, rightResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-right: " + rightResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.start) {
        var startResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.start];
        result.push((0, $f5efw.css)([
            "",
            "-inline-start:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.start] || data.start, startResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-inline-start: " + startResponsiveValue + ";\n        ", responsive) : ''));
    }
    if (data.end) {
        var endResponsiveValue = responsive && breakpoint && breakpoint.edgeSize[data.end];
        result.push((0, $f5efw.css)([
            "",
            "-inline-end:",
            ";",
            ";"
        ], kind, theme.global.edgeSize[data.end] || data.end, endResponsiveValue ? (0, $brba2.breakpointStyle)(breakpoint, "\n          " + kind + "-inline-end: " + endResponsiveValue + ";\n        ", responsive) : ''));
    }
    return result;
};
var $b5ae0ab635b22e82$var$fillStyle = $b5ae0ab635b22e82$export$7d12e60b29024244 = function fillStyle(fillProp) {
    if (fillProp === 'horizontal') return 'width: 100%;';
    if (fillProp === 'vertical') return 'height: 100%;';
    if (fillProp) return "\n      width: 100%;\n      height: 100%;\n    ";
    return undefined;
};
var $b5ae0ab635b22e82$var$focusStyles = function focusStyles(props, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, forceOutline = _ref.forceOutline, justBorder = _ref.justBorder, insetFocus = _ref.inset;
    var generateFocusStyle = function generateFocusStyle(focus) {
        var compoundFocusStyle = '';
        if (!focus || forceOutline && !focus.outline) {
            var color = (0, $ccH8g.normalizeColor)('focus', props.theme);
            if (color) return "outline: 2px solid " + color + ";";
            return ''; // native
        }
        if (focus.outline && (!focus.border || !justBorder)) {
            if (typeof focus.outline === 'object') {
                var _color = (0, $ccH8g.normalizeColor)(focus.outline.color || 'focus', props.theme);
                var size = focus.outline.size || '2px';
                var offset = focus.outline.offset || '0px';
                var outlineStyle = "\n        outline-offset: " + offset + ";\n        outline: " + size + " solid " + _color + ";\n      ";
                compoundFocusStyle += outlineStyle;
                if (!focus.twoColor) return outlineStyle;
            } else {
                var _outlineStyle = "outline: " + focus.outline + ";";
                compoundFocusStyle += _outlineStyle;
                if (!focus.twoColor) return _outlineStyle;
            }
        }
        if (focus.shadow && (!focus.border || !justBorder)) {
            if (typeof focus.shadow === 'object') {
                var _color2 = (0, $ccH8g.normalizeColor)(// If there is a focus.border.color, use that for shadow too.
                // This is for backwards compatibility in v2.
                focus.border && focus.border.color || focus.shadow.color || 'focus', props.theme);
                var _size = focus.shadow.size || '2px'; // backwards compatible default
                var blur = focus.shadow.blur || _size; // backwards compatible default
                var inset = focus.shadow.inset ? 'inset ' : '';
                var shadowStyle = "box-shadow: 0 0 " + blur + " " + _size + " " + _color2 + (inset ? " " + inset : '') + ";";
                compoundFocusStyle += shadowStyle;
                if (!focus.twoColor) return "\n        outline: none;\n      " + shadowStyle;
            } else {
                var _shadowStyle = "box-shadow: " + focus.shadow + ";";
                compoundFocusStyle += _shadowStyle;
                if (!focus.twoColor) return "outline: none; " + _shadowStyle;
            }
        }
        if (focus.border) {
            var _color3 = (0, $ccH8g.normalizeColor)(focus.border.color || 'focus', props.theme);
            var borderStyle = "border-color: " + _color3 + ";";
            compoundFocusStyle += borderStyle;
            if (!focus.twoColor) return "outline: none; " + borderStyle;
        }
        if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
        return ''; // defensive
    };
    if (insetFocus && props.theme.global.focus.inset) return generateFocusStyle(props.theme.global.focus.inset);
    return generateFocusStyle(props.theme.global.focus);
};
var $b5ae0ab635b22e82$var$unfocusStyles = function unfocusStyles(props, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, forceOutline = _ref2.forceOutline, justBorder = _ref2.justBorder;
    var focus = props.theme.global.focus;
    var compoundFocusStyle = '';
    if (!focus || forceOutline && !focus.outline) {
        var color = (0, $ccH8g.normalizeColor)('focus', props.theme);
        if (color) return "outline: none;";
        return ''; // native
    }
    if (focus.outline && (!focus.border || !justBorder)) {
        if (typeof focus.outline === 'object') {
            var outlineStyle = "\n        outline-offset: 0px;\n        outline: none;\n      ";
            compoundFocusStyle += outlineStyle;
            if (!focus.twoColor) return "\n        outline-offset: 0px;\n        outline: none;\n      ";
        } else {
            var _outlineStyle2 = "outline: none;";
            compoundFocusStyle += _outlineStyle2;
            if (!focus.twoColor) return _outlineStyle2;
        }
    }
    if (focus.shadow && (!focus.border || !justBorder)) {
        if (typeof focus.shadow === 'object') {
            var shadowStyle = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += shadowStyle;
            if (!focus.twoColor) return shadowStyle;
        } else {
            var _shadowStyle2 = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += _shadowStyle2;
            if (!focus.twoColor) return _shadowStyle2;
        }
    }
    if (focus.border) {
        var borderStyle = "\n      outline: none;\n      border-color: none;\n    ";
        compoundFocusStyle += borderStyle;
        if (!focus.twoColor) return borderStyle;
    }
    if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
    return ''; // defensive
};
// focus also supports clickable elements inside svg
var $b5ae0ab635b22e82$var$focusStyle = $b5ae0ab635b22e82$export$efbff472cb39d8b = function focusStyle(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, forceOutline = _ref3.forceOutline, inset = _ref3.inset, justBorder = _ref3.justBorder, skipSvgChildren = _ref3.skipSvgChildren;
    return (0, $f5efw.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $b5ae0ab635b22e82$var$focusStyles(props) + "\n  }";
    }, function(props) {
        return $b5ae0ab635b22e82$var$focusStyles(props, {
            forceOutline: forceOutline,
            inset: inset,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// This is placed next to focusStyle for easy maintainability
// of code since changes to focusStyle should be reflected in
// unfocusStyle as well.
// this function can be used to reset focus styles which is
// applicable when turning the focus ring off when using the mouse
// see https://nelo.is/writing/styling-better-focus-states/
var $b5ae0ab635b22e82$var$unfocusStyle = $b5ae0ab635b22e82$export$525440aaa2c64805 = function unfocusStyle(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4, forceOutline = _ref4.forceOutline, justBorder = _ref4.justBorder, skipSvgChildren = _ref4.skipSvgChildren;
    return (0, $f5efw.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + $b5ae0ab635b22e82$var$unfocusStyles(props) + "\n  }";
    }, function(props) {
        return $b5ae0ab635b22e82$var$unfocusStyles(props, {
            forceOutline: forceOutline,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// For backwards compatibility we need to add back the control border width.
// Based on how grommet was functioning prior to https://github.com/grommet/grommet/pull/3939,
// the padding was subtracting the border width from the theme value, but the
// placeholder was not. Because we're now placing the subtraction into the
// theme itself, we have to add back in the border width here.
// This is used for placeholder/icon in TextInput and MaskedInput.
var $b5ae0ab635b22e82$var$adjustPad = function adjustPad(props, value) {
    return (0, $brba2.parseMetricToNum)((props.theme.global.edgeSize[value] || value) + "px") + (0, $brba2.parseMetricToNum)(props.theme.global.control.border.width + "px") + "px";
};
var $b5ae0ab635b22e82$var$getInputPadBySide = $b5ae0ab635b22e82$export$c98305b6d8dc560 = function getInputPadBySide(props, side) {
    if (typeof props.theme.global.input.padding !== 'object') {
        var _adjustedPad = $b5ae0ab635b22e82$var$adjustPad(props, props.theme.global.input.padding);
        return _adjustedPad;
    }
    var orientation;
    if (side === 'left' || side === 'right') orientation = 'horizontal';
    else if (side === 'top' || side === 'bottom') orientation = 'vertical';
    else orientation = undefined;
    // if individual side isn't available, fallback to the
    // orientation if possible
    var pad = props.theme.global.input.padding[side] || props.theme.global.input.padding[orientation];
    var adjustedPad = $b5ae0ab635b22e82$var$adjustPad(props, pad);
    return adjustedPad;
};
var $b5ae0ab635b22e82$var$placeholderColor = (0, $f5efw.css)([
    "color:",
    ";"
], function(props) {
    return (0, $ccH8g.normalizeColor)(props.theme.global.colors.placeholder, props.theme);
});
var $b5ae0ab635b22e82$var$placeholderStyle = (0, $f5efw.css)([
    "&::-webkit-input-placeholder{",
    ";}&::-moz-placeholder{",
    ";}&:-ms-input-placeholder{",
    ";}"
], $b5ae0ab635b22e82$var$placeholderColor, $b5ae0ab635b22e82$var$placeholderColor, $b5ae0ab635b22e82$var$placeholderColor);
var $b5ae0ab635b22e82$var$inputSizeStyle = function inputSizeStyle(props) {
    var data = props.theme.text[props.size];
    if (!data) return (0, $f5efw.css)([
        "font-size:",
        ";"
    ], props.size);
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var $b5ae0ab635b22e82$var$inputStyle = $b5ae0ab635b22e82$export$533edcdef9a0af13 = (0, $f5efw.css)([
    "box-sizing:border-box;",
    " font-family:inherit;border:none;-webkit-appearance:none;background:transparent;color:inherit;width:100%;",
    " ",
    " ",
    " margin:0;",
    " &:focus{",
    ";}",
    " ",
    " ::-webkit-search-decoration{-webkit-appearance:none;}&::-moz-focus-inner{border:none;outline:none;}&:-moz-placeholder,&::-moz-placeholder{opacity:1;}",
    ""
], function(props) {
    var _props$theme$text$pro;
    return "font-size: " + (props.theme.global.input.font.size ? ((_props$theme$text$pro = props.theme.text[props.theme.global.input.font.size]) == null ? void 0 : _props$theme$text$pro.size) || props.theme.global.input.font.size : 'inherit') + ";";
}, function(props) {
    return props.theme.global.input.font.height && "line-height: " + props.theme.global.input.font.height + ";";
}, function(props) {
    return props.theme.global.input.padding && typeof props.theme.global.input.padding !== 'object' ? // just the edgeStyle could remain. Currently, this is needed for
    // backwards compatibility since we are placing the calculation in
    // base.js
    "padding: " + ((0, $brba2.parseMetricToNum)(props.theme.global.edgeSize[props.theme.global.input.padding] || props.theme.global.input.padding) - (0, $brba2.parseMetricToNum)(props.theme.global.control.border.width)) + "px;" : $b5ae0ab635b22e82$var$edgeStyle('padding', props.theme.global.input.padding, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return(// for backwards compatibility, check if props.theme.global.input.weight
    (props.theme.global.input.weight || props.theme.global.input.font.weight) && (0, $f5efw.css)([
        "font-weight:",
        ";"
    ], props.theme.global.input.weight || props.theme.global.input.font.weight));
}, function(props) {
    return props.size && $b5ae0ab635b22e82$var$inputSizeStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && $b5ae0ab635b22e82$var$focusStyle();
}, $b5ae0ab635b22e82$var$controlBorderStyle, $b5ae0ab635b22e82$var$placeholderStyle, function(props) {
    return props.theme.global.input.extend;
});
// Apply padding on input to create space for icon.
// When theme.icon.matchSize is true, the space for the
// icon should equal the icon dimension + 12px (edgeSize.medium)
// to ensure there is reasonable space between the icon and value or placeholder
var $b5ae0ab635b22e82$var$inputPadForIcon = $b5ae0ab635b22e82$export$cd595fd57f72dbc4 = (0, $f5efw.css)([
    "",
    ""
], function(props) {
    var pad = $b5ae0ab635b22e82$var$getInputIconPad(props);
    return props.reverse ? "padding-right: " + pad + ";" : "padding-left: " + pad + ";";
});
var $b5ae0ab635b22e82$var$overflowStyle = $b5ae0ab635b22e82$export$5938e7adc3ab8d08 = function overflowStyle(overflowProp) {
    if (typeof overflowProp === 'string') return (0, $f5efw.css)([
        "overflow:",
        ";"
    ], overflowProp);
    return (0, $f5efw.css)([
        "",
        " ",
        ";"
    ], overflowProp.horizontal && "overflow-x: " + overflowProp.horizontal + ";", overflowProp.vertical && "overflow-y: " + overflowProp.vertical + ";");
};
var $b5ae0ab635b22e82$var$ALIGN_SELF_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
    baseline: 'baseline'
};
var $b5ae0ab635b22e82$var$genericStyles = $b5ae0ab635b22e82$export$a157b298d219a801 = (0, $f5efw.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.alignSelf && "align-self: " + $b5ae0ab635b22e82$var$ALIGN_SELF_MAP[props.alignSelf] + ";";
}, function(props) {
    return props.gridArea && "grid-area: " + props.gridArea + ";";
}, function(props) {
    return props.margin && props.theme.global && $b5ae0ab635b22e82$var$edgeStyle('margin', props.margin, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var $b5ae0ab635b22e82$var$disabledStyle = $b5ae0ab635b22e82$export$adf3fcef8e5e1347 = function disabledStyle(componentStyle) {
    return (0, $f5efw.css)([
        "opacity:",
        ";cursor:default;"
    ], function(props) {
        return componentStyle || props.theme.global.control.disabled.opacity;
    });
};
var $b5ae0ab635b22e82$var$sizeStyle = $b5ae0ab635b22e82$export$cb60038e9cf9f581 = function sizeStyle(name, value, theme) {
    return (0, $f5efw.css)([
        "",
        ":",
        ";"
    ], name, theme.global.size[value] || value);
};
var $b5ae0ab635b22e82$var$plainInputStyle = $b5ae0ab635b22e82$export$f9510e7ca63c26e5 = (0, $f5efw.css)([
    "outline:none;border:none;"
]);
var $b5ae0ab635b22e82$var$elevationStyle = $b5ae0ab635b22e82$export$b4ff7c828301ce9f = function elevationStyle(elevation) {
    return (0, $f5efw.css)([
        "box-shadow:",
        ";"
    ], function(props) {
        return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][elevation];
    });
};
// CSS for this sub-object in the theme
var $b5ae0ab635b22e82$var$kindPartStyles = $b5ae0ab635b22e82$export$73d7bd5e5b0271ce = function kindPartStyles(obj, theme, colorValue) {
    var styles = [];
    if (obj.padding || obj.pad) {
        // button uses `padding` but other components use Grommet `pad`
        var pad = obj.padding || obj.pad;
        if (pad.vertical || pad.horizontal) styles.push("padding: " + (theme.global.edgeSize[pad.vertical] || pad.vertical || 0) + " " + (theme.global.edgeSize[pad.horizontal] || pad.horizontal || 0) + ";");
        else styles.push("padding: " + (theme.global.edgeSize[pad] || pad || 0) + ";");
    }
    if (obj.background) styles.push((0, $fRffU.backgroundStyle)(colorValue || obj.background, theme, obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined)));
    else if (obj.color) styles.push("color: " + (0, $ccH8g.normalizeColor)(obj.color, theme) + ";");
    if (obj.border) {
        if (obj.border.width) styles.push((0, $f5efw.css)([
            "border-style:solid;border-width:",
            ";"
        ], obj.border.width));
        if (obj.border.color) styles.push((0, $f5efw.css)([
            "border-color:",
            ";"
        ], (0, $ccH8g.normalizeColor)(!obj.background && colorValue || obj.border.color || 'border', theme)));
        if (obj.border.radius) styles.push((0, $f5efw.css)([
            "border-radius:",
            ";"
        ], obj.border.radius));
    } else if (obj.border === false) styles.push('border: none;');
    if (colorValue && !obj.border && !obj.background) styles.push("color: " + (0, $ccH8g.normalizeColor)(colorValue, theme) + ";");
    if (obj.font) {
        if (obj.font.size) styles.push("font-size: " + (theme.text[obj.font.size].size || obj.font.size) + ";");
        if (obj.font.height) styles.push("line-height: " + obj.font.height + ";");
        if (obj.font.weight) styles.push("font-weight: " + obj.font.weight + ";");
    }
    if (obj.opacity) {
        var opacity = obj.opacity === true ? theme.global.opacity.medium : theme.global.opacity[obj.opacity] || obj.opacity;
        styles.push("opacity: " + opacity + ";");
    }
    if (obj.elevation) styles.push($b5ae0ab635b22e82$var$elevationStyle(obj.elevation));
    if (obj.extend) styles.push(obj.extend);
    return styles;
};
var $b5ae0ab635b22e82$var$ROUND_MAP = {
    full: '100%'
};
var $b5ae0ab635b22e82$var$roundStyle = $b5ae0ab635b22e82$export$98483643daf52539 = function roundStyle(data, responsive, theme) {
    var breakpoint = (0, $6tePH.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    // fallback to edgeSize for backwards compatibility
    var radius = theme.global.radius ? 'radius' : 'edgeSize';
    var styles = [];
    if (typeof data === 'object') {
        var _breakpoint$radius;
        var size = $b5ae0ab635b22e82$var$ROUND_MAP[data.size] || theme.global[radius][data.size || 'medium'] || data.size;
        var responsiveSize = responsive && breakpoint && ((_breakpoint$radius = breakpoint[radius]) == null ? void 0 : _breakpoint$radius[data.size]) && (breakpoint[radius][data.size] || data.size);
        if (data.corner === 'top') {
            styles.push((0, $f5efw.css)([
                "border-top-left-radius:",
                ";border-top-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-top-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'bottom') {
            styles.push((0, $f5efw.css)([
                "border-bottom-left-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n          border-bottom-left-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'left') {
            styles.push((0, $f5efw.css)([
                "border-top-left-radius:",
                ";border-bottom-left-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-bottom-left-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'right') {
            styles.push((0, $f5efw.css)([
                "border-top-right-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n          border-top-right-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner) {
            styles.push((0, $f5efw.css)([
                "border-",
                "-radius:",
                ";"
            ], data.corner, size));
            if (responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n          border-" + data.corner + "-radius: " + responsiveSize + ";\n        ", responsive));
        } else {
            styles.push((0, $f5efw.css)([
                "border-radius:",
                ";"
            ], size));
            if (responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n          border-radius: " + responsiveSize + ";\n        ", responsive));
        }
    } else {
        var _theme$global$radius, _breakpoint$radius2;
        var _size2 = data === true ? 'medium' : data;
        styles.push((0, $f5efw.css)([
            "border-radius:",
            ";"
        ], $b5ae0ab635b22e82$var$ROUND_MAP[_size2] || ((_theme$global$radius = theme.global[radius]) == null ? void 0 : _theme$global$radius[_size2]) || _size2));
        var _responsiveSize = responsive && breakpoint && ((_breakpoint$radius2 = breakpoint[radius]) == null ? void 0 : _breakpoint$radius2[_size2]);
        if (_responsiveSize) styles.push((0, $brba2.breakpointStyle)(breakpoint, "\n        border-radius: " + _responsiveSize + ";\n      ", responsive));
    }
    return styles;
};
var $b5ae0ab635b22e82$var$TEXT_ALIGN_MAP = {
    center: 'center',
    end: 'right',
    justify: 'justify',
    start: 'left'
};
var $b5ae0ab635b22e82$var$textAlignStyle = $b5ae0ab635b22e82$export$4fc8e4871b69e1d6 = (0, $f5efw.css)([
    "text-align:",
    ";"
], function(props) {
    return $b5ae0ab635b22e82$var$TEXT_ALIGN_MAP[props.textAlign];
});
var $b5ae0ab635b22e82$var$ALIGN_ITEMS_MAP = {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $b5ae0ab635b22e82$var$alignStyle = $b5ae0ab635b22e82$export$f530b7ab00e4c68d = (0, $f5efw.css)([
    "align-items:",
    ";"
], function(props) {
    var _ALIGN_ITEMS_MAP$prop;
    return (_ALIGN_ITEMS_MAP$prop = $b5ae0ab635b22e82$var$ALIGN_ITEMS_MAP[props.align]) != null ? _ALIGN_ITEMS_MAP$prop : props.align;
});
var $b5ae0ab635b22e82$var$ALIGN_CONTENT_MAP = {
    around: 'space-around',
    baseline: 'baseline',
    between: 'space-between',
    center: 'center',
    evenly: 'space-evenly',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var $b5ae0ab635b22e82$var$alignContentStyle = $b5ae0ab635b22e82$export$93b5fb4351939c1c = (0, $f5efw.css)([
    "align-content:",
    ";"
], function(props) {
    var _ALIGN_CONTENT_MAP$pr;
    return (_ALIGN_CONTENT_MAP$pr = $b5ae0ab635b22e82$var$ALIGN_CONTENT_MAP[props.alignContent]) != null ? _ALIGN_CONTENT_MAP$pr : props.alignContent;
});
var $b5ae0ab635b22e82$var$getSize = function getSize(theme, size) {
    return theme.global.size[size] || size;
};
var $b5ae0ab635b22e82$var$widthObjectStyle = function widthObjectStyle(width, theme) {
    var result = [];
    if (width.max) result.push((0, $f5efw.css)([
        "max-width:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, width.max)));
    if (width.min) result.push((0, $f5efw.css)([
        "min-width:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, width.min)));
    if (width.width) result.push((0, $f5efw.css)([
        "width:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, width.width)));
    return result;
};
var $b5ae0ab635b22e82$var$widthStringStyle = function widthStringStyle(width, theme) {
    return (0, $f5efw.css)([
        "width:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, width));
};
var $b5ae0ab635b22e82$var$widthStyle = $b5ae0ab635b22e82$export$c12f8e3e33f3bef7 = function widthStyle(width, theme) {
    return typeof width === 'object' ? $b5ae0ab635b22e82$var$widthObjectStyle(width, theme) : $b5ae0ab635b22e82$var$widthStringStyle(width, theme);
};
var $b5ae0ab635b22e82$var$heightObjectStyle = function heightObjectStyle(height, theme) {
    var result = [];
    if (height.max) result.push((0, $f5efw.css)([
        "max-height:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, height.max)));
    if (height.min) result.push((0, $f5efw.css)([
        "min-height:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, height.min)));
    // backwards compatibile
    if (height.width) result.push((0, $f5efw.css)([
        "height:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, height.height)));
    if (height.height) result.push((0, $f5efw.css)([
        "height:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, height.height)));
    return result;
};
var $b5ae0ab635b22e82$var$heightStringStyle = function heightStringStyle(height, theme) {
    return (0, $f5efw.css)([
        "height:",
        ";"
    ], $b5ae0ab635b22e82$var$getSize(theme, height));
};
var $b5ae0ab635b22e82$var$heightStyle = $b5ae0ab635b22e82$export$9f8046d1e2885811 = function heightStyle(height, theme) {
    return typeof height === 'object' ? $b5ae0ab635b22e82$var$heightObjectStyle(height, theme) : $b5ae0ab635b22e82$var$heightStringStyle(height, theme);
};

});
parcelRegister("6tePH", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $4b60f5063c621ed7$export$1e511d4a378977f5, (v) => $4b60f5063c621ed7$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "supportsContainerQueries", () => $4b60f5063c621ed7$export$6fa2a3092624a8f5, (v) => $4b60f5063c621ed7$export$6fa2a3092624a8f5 = v);
$parcel$export(module.exports, "isSmall", () => $4b60f5063c621ed7$export$813595e92b2e7a6f, (v) => $4b60f5063c621ed7$export$813595e92b2e7a6f = v);
$parcel$export(module.exports, "getDeviceBreakpoint", () => $4b60f5063c621ed7$export$4244a62ea87934e9, (v) => $4b60f5063c621ed7$export$4244a62ea87934e9 = v);
$parcel$export(module.exports, "getBreakpointStyle", () => $4b60f5063c621ed7$export$56780e7bbaff61f9, (v) => $4b60f5063c621ed7$export$56780e7bbaff61f9 = v);
$parcel$export(module.exports, "getBreakpoint", () => $4b60f5063c621ed7$export$1eb095b00b926404, (v) => $4b60f5063c621ed7$export$1eb095b00b926404 = v);
$parcel$export(module.exports, "deviceResponsive", () => $4b60f5063c621ed7$export$f207ad4bd0549009, (v) => $4b60f5063c621ed7$export$f207ad4bd0549009 = v);
var $4b60f5063c621ed7$export$1e511d4a378977f5;
var $4b60f5063c621ed7$export$6fa2a3092624a8f5;
var $4b60f5063c621ed7$export$813595e92b2e7a6f;
var $4b60f5063c621ed7$export$4244a62ea87934e9;
var $4b60f5063c621ed7$export$56780e7bbaff61f9;
var $4b60f5063c621ed7$export$1eb095b00b926404;
var $4b60f5063c621ed7$export$f207ad4bd0549009;
"use strict";
$4b60f5063c621ed7$export$1e511d4a378977f5 = true;
$4b60f5063c621ed7$export$6fa2a3092624a8f5 = $4b60f5063c621ed7$export$813595e92b2e7a6f = $4b60f5063c621ed7$export$4244a62ea87934e9 = $4b60f5063c621ed7$export$56780e7bbaff61f9 = $4b60f5063c621ed7$export$1eb095b00b926404 = $4b60f5063c621ed7$export$f207ad4bd0549009 = void 0;

var $4b60f5063c621ed7$var$_styledComponents = $4b60f5063c621ed7$var$_interopRequireDefault((parcelRequire("f5efw")));
function $4b60f5063c621ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $4b60f5063c621ed7$var$getBreakpoint = $4b60f5063c621ed7$export$1eb095b00b926404 = function getBreakpoint(viewportWidth, theme) {
    var sortedBreakpoints = Object.keys(theme.global.breakpoints).sort(function(a, b) {
        var first = theme.global.breakpoints[a];
        var second = theme.global.breakpoints[b];
        if (!first) return 1;
        if (!second) return -1;
        if (!first.value) return 1;
        if (!second.value) return -1;
        return first.value - second.value;
    });
    // the last breakpoint on the sorted array should have
    // no windowWidth boundaries
    var lastBreakpoint = sortedBreakpoints[sortedBreakpoints.length - 1];
    var result = sortedBreakpoints.find(function(name) {
        var breakpoint = theme.global.breakpoints[name];
        return !breakpoint.value || breakpoint.value >= viewportWidth ? name : false;
    });
    return result || lastBreakpoint;
};
var $4b60f5063c621ed7$var$getDeviceBreakpoint = $4b60f5063c621ed7$export$4244a62ea87934e9 = function getDeviceBreakpoint(type, theme) {
    return theme.global.deviceBreakpoints[type];
};
var $4b60f5063c621ed7$var$getBreakpointStyle = $4b60f5063c621ed7$export$56780e7bbaff61f9 = function getBreakpointStyle(theme, breakpointSize) {
    var breakpoint = breakpointSize && theme.global.breakpoints[breakpointSize] || {};
    if (!breakpoint.edgeSize) breakpoint.edgeSize = theme.global.edgeSize;
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    if (!breakpoint.radius) breakpoint.radius = theme.global.radius;
    if (!breakpoint.size) breakpoint.size = theme.global.size;
    return breakpoint;
};
// for checks that look for a small screen size, flag for xsmall
// as well since we use xsmall in the hpe theme
var $4b60f5063c621ed7$var$isSmall = $4b60f5063c621ed7$export$813595e92b2e7a6f = function isSmall(size) {
    return [
        'xsmall',
        'small'
    ].includes(size);
};
var $4b60f5063c621ed7$var$deviceResponsive = $4b60f5063c621ed7$export$f207ad4bd0549009 = function deviceResponsive(userAgent, theme) {
    // log('--deviceResponsive', userAgent, theme);
    /*
   * Regexes provided for mobile and tablet detection are meant to replace
   * a full-featured specific library due to contributing a considerable size
   * into the bundle.
   *
   * User agents found https://deviceatlas.com/blog/list-of-user-agent-strings
   */ if (userAgent) {
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent)) return $4b60f5063c621ed7$var$getDeviceBreakpoint('tablet', theme);
        if (/Mobile|iPhone|Android/.test(userAgent)) return $4b60f5063c621ed7$var$getDeviceBreakpoint('phone', theme);
        return $4b60f5063c621ed7$var$getDeviceBreakpoint('computer', theme);
    }
    return undefined;
};
// styled-components v6 and later do not have a withComponent
// method. We need v6 or later to support container queries.
var $4b60f5063c621ed7$var$testComp = $4b60f5063c621ed7$var$_styledComponents["default"].div.withConfig({
    displayName: "responsive__testComp",
    componentId: "sc-336m7y-0"
})([
    "display:flex;"
]);
var $4b60f5063c621ed7$var$supportsContainerQueries = $4b60f5063c621ed7$export$6fa2a3092624a8f5 = function supportsContainerQueries() {
    var isPreV6 = typeof $4b60f5063c621ed7$var$testComp.withComponent === 'function';
    return !isPreV6;
};

});


parcelRegister("aN9S5", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $7db6233ba92553a8$export$1e511d4a378977f5, (v) => $7db6233ba92553a8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "usePagination", () => $7db6233ba92553a8$export$f80c710216eae131, (v) => $7db6233ba92553a8$export$f80c710216eae131 = v);
$parcel$export(module.exports, "normalizeShow", () => $7db6233ba92553a8$export$4bb2737d7e3380a3, (v) => $7db6233ba92553a8$export$4bb2737d7e3380a3 = v);
var $7db6233ba92553a8$export$1e511d4a378977f5;
var $7db6233ba92553a8$export$f80c710216eae131;
var $7db6233ba92553a8$export$4bb2737d7e3380a3;
"use strict";
$7db6233ba92553a8$export$1e511d4a378977f5 = true;
$7db6233ba92553a8$export$f80c710216eae131 = $7db6233ba92553a8$export$4bb2737d7e3380a3 = void 0;

var $2NacA = parcelRequire("2NacA");
var $7db6233ba92553a8$var$_excluded = [
    "data",
    "page",
    "step"
]; // SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
function $7db6233ba92553a8$var$_extends() {
    return $7db6233ba92553a8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7db6233ba92553a8$var$_extends.apply(null, arguments);
}
function $7db6233ba92553a8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7db6233ba92553a8$var$normalizeShow = $7db6233ba92553a8$export$4bb2737d7e3380a3 = function normalizeShow(showProp, step) {
    var page;
    // by default, show refers to the index of an item,
    // but if using pagination, show can take the form of { page: # },
    // where page refers to the page # to show
    if (typeof showProp === 'number') page = Math.ceil((showProp + 1) / step);
    else if (typeof showProp === 'object' && 'page' in showProp) page = showProp.page;
    return page;
};
var $7db6233ba92553a8$var$usePagination = $7db6233ba92553a8$export$f80c710216eae131 = function usePagination(_ref) {
    var data = _ref.data, page = _ref.page, step = _ref.step, rest = $7db6233ba92553a8$var$_objectWithoutPropertiesLoose(_ref, $7db6233ba92553a8$var$_excluded);
    var totalPages = data ? Math.ceil(data.length / step) : 0;
    var _useState = (0, $2NacA.useState)(Math.min(page, totalPages) || 1), activePage = _useState[0], setActivePage = _useState[1];
    // ensure activePage is never lower than 1 to ensure that itemsBeginIndex
    // and itemsEndIndex aren't negative
    if (activePage > totalPages && (data == null ? void 0 : data.length) > 0) setActivePage(Math.max(totalPages, 1));
    var itemsBeginIndex = step * (activePage - 1);
    var itemsEndIndex = itemsBeginIndex + step;
    var currentItems = (0, $2NacA.useMemo)(function() {
        if (Array.isArray(data)) return data.slice(itemsBeginIndex, itemsEndIndex);
        return [];
    }, [
        data,
        itemsBeginIndex,
        itemsEndIndex
    ]);
    var paginationProps = $7db6233ba92553a8$var$_extends({
        numberItems: data && data.length,
        onChange: function onChange(event) {
            return setActivePage(event.page);
        },
        page: activePage,
        step: step
    }, rest);
    return [
        currentItems,
        paginationProps
    ];
};

});

parcelRegister("63hjX", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $46807575cb93e98c$export$1e511d4a378977f5, (v) => $46807575cb93e98c$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "PortalContext", () => $46807575cb93e98c$export$60d741e20e0aa309, (v) => $46807575cb93e98c$export$60d741e20e0aa309 = v);
var $46807575cb93e98c$export$1e511d4a378977f5;
var $46807575cb93e98c$export$60d741e20e0aa309;
"use strict";
$46807575cb93e98c$export$1e511d4a378977f5 = true;
$46807575cb93e98c$export$60d741e20e0aa309 = void 0;

var $46807575cb93e98c$var$_react = $46807575cb93e98c$var$_interopRequireDefault((parcelRequire("2NacA")));
function $46807575cb93e98c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $46807575cb93e98c$var$PortalContext = $46807575cb93e98c$export$60d741e20e0aa309 = /*#__PURE__*/ $46807575cb93e98c$var$_react["default"].createContext([]);

});

parcelRegister("66Ae2", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $471f6740a0702657$export$1e511d4a378977f5, (v) => $471f6740a0702657$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "readOnlyStyle", () => $471f6740a0702657$export$28ff5f3fef0ffa78, (v) => $471f6740a0702657$export$28ff5f3fef0ffa78 = v);
var $471f6740a0702657$export$1e511d4a378977f5;
var $471f6740a0702657$export$28ff5f3fef0ffa78;
"use strict";
$471f6740a0702657$export$1e511d4a378977f5 = true;
$471f6740a0702657$export$28ff5f3fef0ffa78 = void 0;

var $f5efw = parcelRequire("f5efw");

var $fRffU = parcelRequire("fRffU");

var $ccH8g = parcelRequire("ccH8g");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $471f6740a0702657$var$readOnlyStyle = $471f6740a0702657$export$28ff5f3fef0ffa78 = function readOnlyStyle(theme) {
    var _theme$global$input$r, _theme$global$input$r2, _theme$global$input$r3;
    var styles = [];
    if (theme != null && (_theme$global$input$r = theme.global.input.readOnly) != null && (_theme$global$input$r = _theme$global$input$r.border) != null && _theme$global$input$r.color) styles.push((0, $f5efw.css)([
        "border-color:",
        ";"
    ], (0, $ccH8g.normalizeColor)(theme.global.input.readOnly.border.color, theme)));
    if (theme != null && (_theme$global$input$r2 = theme.global.input.readOnly) != null && _theme$global$input$r2.background) styles.push((0, $fRffU.backgroundStyle)((_theme$global$input$r3 = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r3.background, theme));
    return styles;
};

});

parcelRegister("d9eMn", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $99279478d3e77e76$export$1e511d4a378977f5, (v) => $99279478d3e77e76$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "useForwardedRef", () => $99279478d3e77e76$export$61dc559f8a0b9bcf, (v) => $99279478d3e77e76$export$61dc559f8a0b9bcf = v);
var $99279478d3e77e76$export$1e511d4a378977f5;
var $99279478d3e77e76$export$61dc559f8a0b9bcf;
"use strict";
$99279478d3e77e76$export$1e511d4a378977f5 = true;
$99279478d3e77e76$export$61dc559f8a0b9bcf = void 0;

var $2NacA = parcelRequire("2NacA");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $99279478d3e77e76$var$useForwardedRef = $99279478d3e77e76$export$61dc559f8a0b9bcf = function useForwardedRef(ref) {
    var innerRef = (0, $2NacA.useRef)(null);
    (0, $2NacA.useImperativeHandle)(ref, function() {
        return innerRef.current;
    }, [
        innerRef
    ]);
    return innerRef;
};

});

parcelRegister("nKbiW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0475f8bf6719c0a4$export$1e511d4a378977f5, (v) => $0475f8bf6719c0a4$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "useKeyboard", () => $0475f8bf6719c0a4$export$8f71654801c2f7cd, (v) => $0475f8bf6719c0a4$export$8f71654801c2f7cd = v);
$parcel$export(module.exports, "default", () => $0475f8bf6719c0a4$export$2e2bcd8739ae039, (v) => $0475f8bf6719c0a4$export$2e2bcd8739ae039 = v);
var $0475f8bf6719c0a4$export$1e511d4a378977f5;
var $0475f8bf6719c0a4$export$8f71654801c2f7cd;
var $0475f8bf6719c0a4$export$2e2bcd8739ae039;
"use strict";
$0475f8bf6719c0a4$export$1e511d4a378977f5 = true;
$0475f8bf6719c0a4$export$8f71654801c2f7cd = $0475f8bf6719c0a4$export$2e2bcd8739ae039 = void 0;

var $2NacA = parcelRequire("2NacA");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $0475f8bf6719c0a4$var$useKeyboard = $0475f8bf6719c0a4$export$8f71654801c2f7cd = function useKeyboard() {
    var _useState = (0, $2NacA.useState)(), usingKeyboard = _useState[0], setUsingKeyboard = _useState[1];
    (0, $2NacA.useEffect)(function() {
        var onMouseDown = function onMouseDown() {
            return setUsingKeyboard(false);
        };
        var onKeyDown = function onKeyDown() {
            return setUsingKeyboard(true);
        };
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown', onKeyDown);
        return function() {
            document.removeEventListener('mousedown', onMouseDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return usingKeyboard;
};
var $0475f8bf6719c0a4$var$_default = $0475f8bf6719c0a4$export$2e2bcd8739ae039 = $0475f8bf6719c0a4$var$useKeyboard;

});

parcelRegister("hT1tp", function(module, exports) {

$parcel$export(module.exports, "__esModule", () => $d058b750152eaf0f$export$1e511d4a378977f5, (v) => $d058b750152eaf0f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "useId", () => $d058b750152eaf0f$export$f680877a34711e37, (v) => $d058b750152eaf0f$export$f680877a34711e37 = v);
var $d058b750152eaf0f$export$1e511d4a378977f5;
var $d058b750152eaf0f$export$f680877a34711e37;
"use strict";
$d058b750152eaf0f$export$1e511d4a378977f5 = true;
$d058b750152eaf0f$export$f680877a34711e37 = void 0;

var $d058b750152eaf0f$var$_react = $d058b750152eaf0f$var$_interopRequireWildcard((parcelRequire("2NacA")));
var $d058b750152eaf0f$var$_React$useId; // SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
function $d058b750152eaf0f$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d058b750152eaf0f$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
var $d058b750152eaf0f$var$currentId = 0;
var $d058b750152eaf0f$var$getId = function getId() {
    // eslint-disable-next-line no-plusplus
    var id = $d058b750152eaf0f$var$currentId++;
    return ":r" + id.toString(32) + ":";
};
var $d058b750152eaf0f$var$useIdGrommet = function useIdGrommet() {
    var _useState = (0, $d058b750152eaf0f$var$_react.useState)($d058b750152eaf0f$var$getId), id = _useState[0];
    return id;
};
// Polyfill React 18's useId for compatibility with React 16 and 17
var $d058b750152eaf0f$var$useId = $d058b750152eaf0f$export$f680877a34711e37 = ($d058b750152eaf0f$var$_React$useId = $d058b750152eaf0f$var$_react["default"].useId) != null ? $d058b750152eaf0f$var$_React$useId : $d058b750152eaf0f$var$useIdGrommet;

});






parcelRegister("c06ph", function(module, exports) {

$parcel$export(module.exports, "UserInput", () => $f42577df1269e670$export$3ac5e585cf392ee0);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $uBb61 = parcelRequire("uBb61");
var $1h240 = parcelRequire("1h240");
var $kS7Ii = parcelRequire("kS7Ii");
var $k5B6T = parcelRequire("k5B6T");

var $aUxMn = parcelRequire("aUxMn");

var $iT0qG = parcelRequire("iT0qG");
// Only recognizes an @-mention actively being typed at the end of the current text —
// a deliberate simplification over full caret-position tracking (not needed for a
// single-line-ish chat composer).
const $f42577df1269e670$var$MENTION_PATTERN = /(?:^|\s)@([a-zA-Z0-9._-]*)$/;
const $f42577df1269e670$export$3ac5e585cf392ee0 = ({ handleSubmit: handleSubmit, loading: loading, handleEnter: handleEnter, textAreaRef: textAreaRef, query: query, setQuery: setQuery, gridArea: gridArea, mentionCandidates: mentionCandidates = [] })=>{
    const mentionMatch = $f42577df1269e670$var$MENTION_PATTERN.exec(query);
    const activeQuery = mentionMatch?.[1];
    const suggestions = activeQuery !== undefined && mentionCandidates.length ? mentionCandidates.filter((c)=>c.label.toLowerCase().startsWith(activeQuery.toLowerCase())).slice(0, 6) : [];
    const selectMention = (candidate)=>{
        const match = $f42577df1269e670$var$MENTION_PATTERN.exec(query);
        if (!match) return;
        const leadingChar = match[0][0] === '@' ? '' : match[0][0];
        const prefix = query.slice(0, match.index) + leadingChar;
        setQuery(`${prefix}@[${candidate.label}](${candidate.id}) `);
        textAreaRef.current?.focus();
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter' && suggestions.length > 0) {
            e.preventDefault();
            selectMention(suggestions[0]);
            return;
        }
        handleEnter(e);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gridArea: gridArea,
        fill: "horizontal",
        pad: "small",
        style: {
            position: 'relative'
        },
        children: [
            suggestions.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                background: "white",
                border: {
                    color: '#d9d9e3'
                },
                round: "small",
                elevation: "small",
                style: {
                    position: 'absolute',
                    bottom: '100%',
                    left: '12px',
                    right: '12px',
                    zIndex: 20
                },
                children: suggestions.map((s)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        pad: {
                            vertical: 'xsmall',
                            horizontal: 'small'
                        },
                        hoverIndicator: true,
                        style: {
                            cursor: 'pointer'
                        },
                        onClick: ()=>selectMention(s),
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            size: "small",
                            children: [
                                "@",
                                s.label
                            ]
                        })
                    }, s.id))
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $uBb61.Form), {
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    style: {
                        position: 'relative'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1h240.Stack), {
                        anchor: "right",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $k5B6T.TextArea), {
                                disabled: loading,
                                onKeyDown: onKeyDown,
                                ref: textAreaRef,
                                autoFocus: false,
                                focusIndicator: false,
                                rows: 1,
                                maxLength: 512,
                                id: "userInput",
                                name: "userInput",
                                placeholder: loading ? 'Waiting for response...' : 'Enter your question here...',
                                value: query,
                                onChange: (e)=>setQuery(e.target.value),
                                fill: true
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                pad: {
                                    horizontal: 'small'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                    type: "submit",
                                    disabled: loading || !query,
                                    children: loading ? /*#__PURE__*/ (0, $6ir3O.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iT0qG.LoadingDots), {
                                            color: "#000"
                                        })
                                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aUxMn.Send), {})
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};

});
parcelRegister("uBb61", function(module, exports) {

$parcel$export(module.exports, "Form", () => $05bfa43a01bd8f66$export$a7fed597f4b8afd8);

var $2NacA = parcelRequire("2NacA");

var $hbZKz = parcelRequire("hbZKz");

var $2M0UK = parcelRequire("2M0UK");

var $dOlbm = parcelRequire("dOlbm");

var $7wKkw = parcelRequire("7wKkw");

var $3nlLr = parcelRequire("3nlLr");
var $05bfa43a01bd8f66$var$_excluded = [
    "children",
    "errors",
    "infos",
    "messages",
    "kind",
    "onChange",
    "onReset",
    "onSubmit",
    "onValidate",
    "validate",
    "value"
];
function $05bfa43a01bd8f66$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $05bfa43a01bd8f66$var$_extends() {
    return $05bfa43a01bd8f66$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $05bfa43a01bd8f66$var$_extends.apply(null, arguments);
}
var $05bfa43a01bd8f66$var$defaultValue = {};
var $05bfa43a01bd8f66$var$defaultTouched = {};
var $05bfa43a01bd8f66$var$defaultValidationResults = {
    errors: {},
    infos: {}
};
var $05bfa43a01bd8f66$var$defaultThreshold = 0.5;
var $05bfa43a01bd8f66$var$stringToArray = function stringToArray(string) {
    var match = string == null ? void 0 : string.match(/^(.+)\[([0-9]+)\]\.(.*)$/);
    if (match) {
        var arrayName = match[1], indexOfArray = match[2], arrayObjName = match[3];
        return {
            indexOfArray: indexOfArray,
            arrayName: arrayName,
            arrayObjName: arrayObjName
        };
    }
    return undefined;
};
var $05bfa43a01bd8f66$var$_getValueAt = function getValueAt(valueObject, pathArg) {
    if (valueObject === undefined) return undefined;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) return valueObject[path];
    return $05bfa43a01bd8f66$var$_getValueAt(valueObject[path.shift()], path);
};
var $05bfa43a01bd8f66$var$_setValueAt = function setValueAt(valueObject, pathArg, value) {
    var object = valueObject;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) object[path] = value;
    else {
        var key = path.shift();
        if (!object[key]) object[key] = {};
        $05bfa43a01bd8f66$var$_setValueAt(object[key], path, value);
    }
};
var $05bfa43a01bd8f66$var$getFieldValue = function getFieldValue(name, value) {
    var isArrayField = $05bfa43a01bd8f66$var$stringToArray(name);
    if (isArrayField) {
        var _value$arrayName;
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        var obj = (_value$arrayName = value[arrayName]) == null ? void 0 : _value$arrayName[indexOfArray];
        return arrayObjName ? obj == null ? void 0 : obj[arrayObjName] : obj;
    }
    return $05bfa43a01bd8f66$var$_getValueAt(value, name);
};
var $05bfa43a01bd8f66$var$setFieldValue = function setFieldValue(name, componentValue, prevValue) {
    var nextValue = $05bfa43a01bd8f66$var$_extends({}, prevValue);
    var isArrayField = $05bfa43a01bd8f66$var$stringToArray(name);
    if (isArrayField) {
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        if (!nextValue[arrayName]) nextValue[arrayName] = [];
        if (arrayObjName) {
            var _nextValue$arrayName$;
            if (!nextValue[arrayName][indexOfArray]) nextValue[arrayName][indexOfArray] = (_nextValue$arrayName$ = {}, _nextValue$arrayName$[arrayObjName] = componentValue, _nextValue$arrayName$);
            nextValue[arrayName][indexOfArray][arrayObjName] = componentValue;
        } else nextValue[arrayName][indexOfArray] = componentValue;
    } else $05bfa43a01bd8f66$var$_setValueAt(nextValue, name, componentValue);
    return nextValue;
};
var $05bfa43a01bd8f66$var$validateCharacterCount = function validateCharacterCount(format, rule, value) {
    var max = rule.max, threshold = rule.threshold;
    var getMessage = function getMessage() {
        var charactersRemaining = function charactersRemaining(plural) {
            return {
                id: "formField.maxCharacters.remaining." + (plural ? 'plural' : 'singular'),
                values: {
                    number: max - value.length
                }
            };
        };
        var charactersOverLimit = function charactersOverLimit(plural) {
            return {
                id: "formField.maxCharacters.overLimit." + (plural ? 'plural' : 'singular'),
                values: {
                    number: value.length - max
                }
            };
        };
        if (max - value.length >= 0) return format(charactersRemaining(max - value.length > 1));
        return format(charactersOverLimit(value.length - max > 1));
    };
    return value.length / max > (threshold != null ? threshold : $05bfa43a01bd8f66$var$defaultThreshold) ? {
        status: max - value.length >= 0 ? 'info' : 'error',
        message: getMessage()
    } : undefined;
};
// Apply validation rule to field value and send correct messaging.
var $05bfa43a01bd8f66$var$validate = function validate(rule, fieldValue, formValue, format, messages) {
    var result;
    if (typeof rule === 'function') result = rule(fieldValue, formValue);
    else if (rule.regexp) {
        if (!rule.regexp.test(fieldValue)) {
            result = rule.message || format({
                id: 'form.invalid',
                messages: messages
            });
            if (rule.status) result = {
                message: result,
                status: rule.status
            };
        }
    } else if (rule.max) result = $05bfa43a01bd8f66$var$validateCharacterCount(format, rule, fieldValue);
    return result;
};
// Validates particular key in formValue
var $05bfa43a01bd8f66$var$validateName = function validateName(validationRules, required) {
    return function(name, formValue, format, messages) {
        var fieldValue = $05bfa43a01bd8f66$var$getFieldValue(name, formValue);
        var validationResult;
        if (required && // false is for CheckBox
        (fieldValue === undefined || fieldValue === '' || fieldValue === false || Array.isArray(fieldValue) && !fieldValue.length)) validationResult = format({
            id: 'form.required',
            messages: messages
        });
        else if (validationRules) {
            if (Array.isArray(validationRules)) validationRules.some(function(rule) {
                validationResult = $05bfa43a01bd8f66$var$validate(rule, fieldValue, formValue, format, messages);
                return !!validationResult;
            });
            else validationResult = $05bfa43a01bd8f66$var$validate(validationRules, fieldValue, formValue, format, messages);
        }
        return validationResult;
    };
};
// Validates all keys in formValue
var $05bfa43a01bd8f66$var$validateForm = function validateForm(validationRules, formValue, format, messages, omitValid) {
    var nextErrors = {};
    var nextInfos = {};
    validationRules.forEach(function(_ref) {
        var name = _ref[0], _ref$ = _ref[1], field = _ref$.field, input = _ref$.input, validateOn = _ref$.validateOn;
        if (!omitValid) {
            nextErrors[name] = undefined;
            nextInfos[name] = undefined;
        }
        if (!validateOn) return;
        var result;
        if (input) // input() a validation function supplied through useFormInput()
        result = input(name, formValue, format, messages);
        if (field && !result) // field() a validation function supplied through useFormField()
        result = field(name, formValue, format, messages);
        // typeof error === 'object' is implied for both cases of error with
        // a status message and for an error object that is a react node
        if (typeof result === 'object') {
            if (result.status === 'info') nextInfos[name] = result.message;
            else nextErrors[name] = result.message || result; // could be a node
        } else if (typeof result === 'string') nextErrors[name] = result;
    });
    return [
        nextErrors,
        nextInfos
    ];
};
var $05bfa43a01bd8f66$var$isInstantValidate = function isInstantValidate(validateOn) {
    return [
        'blur',
        'change'
    ].includes(validateOn);
};
var $05bfa43a01bd8f66$export$a7fed597f4b8afd8 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, _ref2$errors = _ref2.errors, errorsProp = _ref2$errors === void 0 ? $05bfa43a01bd8f66$var$defaultValidationResults.errors : _ref2$errors, _ref2$infos = _ref2.infos, infosProp = _ref2$infos === void 0 ? $05bfa43a01bd8f66$var$defaultValidationResults.infos : _ref2$infos, messages = _ref2.messages, kind = _ref2.kind, onChange = _ref2.onChange, _onReset = _ref2.onReset, _onSubmit = _ref2.onSubmit, onValidate = _ref2.onValidate, _ref2$validate = _ref2.validate, validateOnProp = _ref2$validate === void 0 ? 'submit' : _ref2$validate, valueProp = _ref2.value, rest = $05bfa43a01bd8f66$var$_objectWithoutPropertiesLoose(_ref2, $05bfa43a01bd8f66$var$_excluded);
    var formRef = (0, $dOlbm.useForwardedRef)(ref);
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var _useState = (0, $2NacA.useState)(valueProp || $05bfa43a01bd8f66$var$defaultValue), valueState = _useState[0], setValueState = _useState[1];
    var value = (0, $2NacA.useMemo)(function() {
        return valueProp || valueState;
    }, [
        valueProp,
        valueState
    ]);
    var _useState2 = (0, $2NacA.useState)($05bfa43a01bd8f66$var$defaultTouched), touched = _useState2[0], setTouched = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(validateOnProp), validateOn = _useState3[0], setValidateOn = _useState3[1];
    var _useState4 = (0, $2NacA.useState)({
        errors: errorsProp,
        infos: infosProp
    }), validationResults = _useState4[0], setValidationResults = _useState4[1];
    // maintain a copy of validationResults in a ref for useEffects
    // which can't depend on validationResults directly without
    // causing infinite renders.
    var validationResultsRef = (0, $2NacA.useRef)({});
    // Simulated onMount state. Consider Form to be mounted once it has
    // accounted for values originating from controlled inputs (available
    // at second rendering).
    var _useState5 = (0, $2NacA.useState)('unmounted'), mounted = _useState5[0], setMounted = _useState5[1];
    (0, $2NacA.useEffect)(function() {
        if (!mounted) setMounted('mounting');
        else if (mounted === 'mounting') setMounted('mounted');
    }, [
        mounted
    ]);
    // `pendingValidation` is the name of the FormField awaiting validation.
    var _useState6 = (0, $2NacA.useState)(undefined), pendingValidation = _useState6[0], setPendingValidation = _useState6[1];
    var validationRulesRef = (0, $2NacA.useRef)({});
    var requiredFields = (0, $2NacA.useRef)([]);
    var analyticsRef = (0, $2NacA.useRef)({
        start: new Date(),
        errors: {}
    });
    var sendAnalytics = (0, $hbZKz.useAnalytics)();
    var buildValid = (0, $2NacA.useCallback)(function(nextErrors) {
        var valid = false;
        valid = requiredFields.current.filter(function(n) {
            return Object.keys(validationRulesRef.current).includes(n);
        }).every(function(field) {
            return value[field] && (value[field] !== '' || value[field] !== false);
        });
        if (Object.keys(nextErrors).length > 0) valid = false;
        return valid;
    }, [
        value
    ]);
    // Only keep validation results for current form fields. In the case of a
    // dynamic form, a field possessing an error may have been removed from the
    // form; need to clean up any previous related validation results.
    var filterRemovedFields = function filterRemovedFields(prevValidations) {
        var nextValidations = prevValidations;
        return Object.keys(nextValidations).filter(function(n) {
            return !validationRulesRef.current[n] || nextValidations[n] === undefined;
        }).forEach(function(n) {
            return delete nextValidations[n];
        });
    };
    var updateAnalytics = function updateAnalytics() {
        var _validationResultsRef;
        var errorFields = Object.keys((_validationResultsRef = validationResultsRef.current) == null ? void 0 : _validationResultsRef.errors);
        var errorCounts = analyticsRef.current.errors;
        if (errorFields.length > 0) errorFields.forEach(function(key) {
            errorCounts[key] = (errorCounts[key] || 0) + 1;
        });
    };
    var applyValidationRules = (0, $2NacA.useCallback)(function(validationRules) {
        var _validateForm = $05bfa43a01bd8f66$var$validateForm(validationRules, value, format, messages), validatedErrors = _validateForm[0], validatedInfos = _validateForm[1];
        setValidationResults(function(prevValidationResults) {
            // Keep any previous errors and infos for untouched keys,
            // these may have come from a Submit.
            var nextErrors = $05bfa43a01bd8f66$var$_extends({}, prevValidationResults.errors, validatedErrors);
            var nextInfos = $05bfa43a01bd8f66$var$_extends({}, prevValidationResults.infos, validatedInfos);
            // Remove previous errors and infos for keys no longer in the
            // form, these may have been fields removed from a dynamic form.
            filterRemovedFields(nextErrors);
            filterRemovedFields(nextInfos);
            var nextValidationResults = {
                errors: nextErrors,
                infos: nextInfos
            };
            if (onValidate) onValidate($05bfa43a01bd8f66$var$_extends({}, nextValidationResults, {
                valid: buildValid(nextErrors)
            }));
            validationResultsRef.current = nextValidationResults;
            updateAnalytics();
            return nextValidationResults;
        });
    }, [
        buildValid,
        format,
        messages,
        onValidate,
        value
    ]);
    // Validate all fields holding values onMount if set to
    // validate when blur or change.
    (0, $2NacA.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        // Use simulated onMount state to account for values provided by
        // controlled inputs.
        if (mounted !== 'mounted' && ($05bfa43a01bd8f66$var$isInstantValidate(validateOn) || validationRules.some(function(_ref3) {
            var v = _ref3[1];
            return $05bfa43a01bd8f66$var$isInstantValidate(v.validateOn);
        })) && Object.keys(value).length > 0 && Object.keys(touched).length === 0) applyValidationRules(validationRules.filter(function(_ref4) {
            var n = _ref4[0], v = _ref4[1];
            return $05bfa43a01bd8f66$var$getFieldValue(n, value) && v.validateOn;
        })// Exlude empty arrays which may be initial values in
        // an input such as DateInput.
        .filter(function(_ref5) {
            var n = _ref5[0];
            return !(Array.isArray($05bfa43a01bd8f66$var$getFieldValue(n, value)) && $05bfa43a01bd8f66$var$getFieldValue(n, value).length === 0);
        }));
    }, [
        applyValidationRules,
        mounted,
        touched,
        validateOn,
        value
    ]);
    // Run validation against fields with pendingValidations from onBlur
    // and/or onChange.
    (0, $2NacA.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        var timer = setTimeout(function() {
            if (pendingValidation && ($05bfa43a01bd8f66$var$isInstantValidate(validateOn) || validationRules.some(function(_ref6) {
                var v = _ref6[1];
                return $05bfa43a01bd8f66$var$isInstantValidate(v.validateOn);
            }))) {
                applyValidationRules(validationRules.filter(function(_ref7) {
                    var n = _ref7[0], v = _ref7[1];
                    return (touched[n] || pendingValidation.includes(n)) && v.validateOn;
                }));
                setPendingValidation(undefined);
            }
        // Complete any potential click events before running onBlur validation.
        // Otherwise, click events like reset, etc. may not be registered. For a
        // detailed scenario/discussion, see: https://github.com/grommet/grommet/issues/4863
        // Values empirically tested; 120 was selected because it is the largest
        // Chrome: 100, Safari: 120, Firefox: 80
        }, 120);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        applyValidationRules,
        pendingValidation,
        touched,
        validateOn
    ]);
    // Re-run validation rules for all fields with prior errors.
    // if validate=blur this helps re-validate if there are errors
    // as the user fixes them (basically act like validate=change for that)
    (0, $2NacA.useEffect)(function() {
        var _validationResultsRef2;
        var validationRules = Object.entries(validationRulesRef.current);
        if ((_validationResultsRef2 = validationResultsRef.current) != null && _validationResultsRef2.errors && Object.keys(validationResultsRef.current.errors).length > 0) applyValidationRules(validationRules.filter(function(_ref8) {
            var n = _ref8[0];
            return touched[n] && validationResultsRef.current.errors[n];
        }));
    }, [
        applyValidationRules,
        touched
    ]);
    (0, $2NacA.useEffect)(function() {
        var element = formRef.current;
        analyticsRef.current = {
            start: new Date(),
            errors: {}
        };
        sendAnalytics({
            type: 'formOpen',
            element: element
        });
        return function() {
            if (!analyticsRef.current.submitted) sendAnalytics({
                type: 'formClose',
                element: element,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
        };
    }, [
        sendAnalytics,
        formRef
    ]);
    // There are three basic patterns of handling form input value state:
    //
    // 1 - form controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the Form component to supply the values used by the input fields.
    // In useFormContext(), componentValue would be undefined and formValue
    // is be set to whatever the form state has. Whenever the form state
    // changes, we update the contextValue so the input component will use
    // that. When the input component changes, we will call update() to
    // update the form state.
    //
    // 2 - input controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the input components, like TextInput, to supply the value for it.
    // In useFormContext(), componentValue is this value and we ensure to
    // update the form state, via update(), and set the contextValue from
    // the componentValue. When the input component changes, we will
    // call update() to update the form state.
    //
    // 3 - uncontrolled
    //
    // In this model, the caller doesn't set a `value` or `onChange` property
    // at either the form or input component levels.
    // In useFormContext(), componentValue is undefined and valueProp is
    // undefined and nothing much happens here. That is, unless the
    // calling component needs to know the state in order to work, such
    // as CheckBox or Select. In this case, those components supply
    // an initialValue, which will trigger updating the contextValue so
    // they can have access to it.
    //
    var formContextValue = (0, $2NacA.useMemo)(function() {
        var useFormInput = function useFormInput(_ref9) {
            var name = _ref9.name, componentValue = _ref9.value, initialValue = _ref9.initialValue, validateArg = _ref9.validate;
            var _useState7 = (0, $2NacA.useState)(initialValue), inputValue = _useState7[0], setInputValue = _useState7[1];
            var formValue = name ? $05bfa43a01bd8f66$var$getFieldValue(name, value) : undefined;
            // for dynamic forms, we need to track when an input has been added to
            // the form value. if the input is unmounted, we will delete its
            // key/value from the form value.
            var keyCreated = (0, $2NacA.useRef)(false);
            // This effect is for pattern #2, where the controlled input
            // component is driving the value via componentValue.
            (0, $2NacA.useEffect)(function() {
                if (name && // we have somewhere to put this
                componentValue !== undefined && // input driving
                (Array.isArray(componentValue) && Array.isArray(formValue) ? componentValue.toString() !== formValue.toString() : componentValue !== formValue // don't already have it
                )) setValueState(function(prevValue) {
                    return $05bfa43a01bd8f66$var$setFieldValue(name, componentValue, prevValue);
                });
            }, [
                componentValue,
                formValue,
                name
            ]);
            // on unmount, if the form is uncontrolled, remove the key/value
            // from the form value
            (0, $2NacA.useEffect)(function() {
                return function() {
                    if (keyCreated.current) {
                        keyCreated.current = false;
                        setValueState(function(prevValue) {
                            var nextValue = $05bfa43a01bd8f66$var$_extends({}, prevValue);
                            var isArrayField = $05bfa43a01bd8f66$var$stringToArray(name);
                            if (isArrayField) {
                                var arrayName = isArrayField.arrayName;
                                delete nextValue[arrayName];
                            } else delete nextValue[name];
                            return nextValue;
                        });
                    }
                };
            }, // eslint-disable-next-line react-hooks/exhaustive-deps
            [] // only run onmount and unmount
            );
            // Create validation rules for fields
            (0, $2NacA.useEffect)(function() {
                if (validateArg) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].input = $05bfa43a01bd8f66$var$validateName(validateArg);
                    return function() {
                        return delete validationRulesRef.current[name].input;
                    };
                }
                return undefined;
            }, [
                validateArg,
                name
            ]);
            var useValue;
            if (componentValue !== undefined) // input component drives, pattern #2
            useValue = componentValue;
            else if (valueProp && name && formValue !== undefined) // form drives, pattern #1
            useValue = formValue;
            else if (formValue === undefined && name) // controlled form: keep input controlled; uncontrolled: reset
            useValue = valueProp !== undefined ? initialValue != null ? initialValue : '' : initialValue;
            else useValue = inputValue;
            return [
                useValue,
                function(nextComponentValue) {
                    if (name) {
                        // we have somewhere to put this
                        var nextTouched = $05bfa43a01bd8f66$var$_extends({}, touched);
                        nextTouched[name] = true;
                        if (!touched[name]) // don't update if not needed
                        setTouched(nextTouched);
                        // if nextValue doesn't have a key for name, this must be
                        // uncontrolled form. we will flag this field was added so
                        // we know to remove its value from the form if it is dynamically
                        // removed
                        if (!(name in value)) keyCreated.current = true;
                        var nextValue = $05bfa43a01bd8f66$var$setFieldValue(name, nextComponentValue, value);
                        setValueState(nextValue);
                        if (onChange) onChange(nextValue, {
                            touched: nextTouched
                        });
                    }
                    if (initialValue !== undefined) setInputValue(nextComponentValue);
                }
            ];
        };
        var useFormField = function useFormField(_ref0) {
            var errorArg = _ref0.error, infoArg = _ref0.info, name = _ref0.name, required = _ref0.required, disabled = _ref0.disabled, validateArg = _ref0.validate, validateOnArg = _ref0.validateOn;
            var error = disabled ? undefined : errorArg || validationResults.errors[name];
            var info = infoArg || validationResults.infos[name];
            (0, $2NacA.useEffect)(function() {
                setValidateOn(function(prevValues) {
                    var _extends2;
                    if (typeof prevValues === 'string') {
                        var _ref1;
                        return _ref1 = {}, _ref1[name] = validateOnArg || validateOnProp, _ref1;
                    }
                    return $05bfa43a01bd8f66$var$_extends({}, prevValues, (_extends2 = {}, _extends2[name] = validateOnArg || validateOnProp, _extends2));
                });
            }, [
                validateOnArg,
                name
            ]);
            // Create validation rules for field
            (0, $2NacA.useEffect)(function() {
                var index = requiredFields.current.indexOf(name);
                if (required) {
                    if (index === -1) requiredFields.current.push(name);
                } else if (index !== -1) requiredFields.current.splice(index, 1);
                if (validateArg || required) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].field = $05bfa43a01bd8f66$var$validateName(validateArg, required);
                    // priority is given to validateOn prop on formField, if it is
                    // undefined, then we will use the validate prop value of Form.
                    // The reason we don't want to add validateOn = "submit" here is
                    // because we don't want to trigger validation of "submit" field
                    // when the user is typing in the instant (blur, change)
                    // validation fields.
                    if (validateOnArg && validateOnArg !== 'submit') validationRulesRef.current[name].validateOn = validateOnArg;
                    else if (!validateOnArg && validateOnProp !== 'submit') validationRulesRef.current[name].validateOn = validateOnProp;
                    return function() {
                        delete validationRulesRef.current[name].field;
                        delete validationRulesRef.current[name].validateOn;
                        var requiredFieldIndex = requiredFields.current.indexOf(name);
                        if (requiredFieldIndex !== -1) requiredFields.current.splice(requiredFieldIndex, 1);
                    };
                }
                return undefined;
            }, [
                error,
                name,
                required,
                validateArg,
                disabled,
                validateOnArg
            ]);
            return {
                error: error,
                info: info,
                inForm: true,
                onBlur: validateOnArg === 'blur' || validateOn[name] === 'blur' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined,
                onChange: validateOnArg === 'change' || validateOn[name] === 'change' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined
            };
        };
        return {
            useFormField: useFormField,
            useFormInput: useFormInput,
            kind: kind
        };
    }, [
        onChange,
        kind,
        pendingValidation,
        touched,
        validateOn,
        validationResults.errors,
        validationResults.infos,
        value,
        valueProp,
        validateOnProp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("form", $05bfa43a01bd8f66$var$_extends({
        ref: formRef
    }, rest, {
        onReset: function onReset(event) {
            sendAnalytics({
                type: 'formReset',
                element: formRef.current,
                data: event,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
            setPendingValidation(undefined);
            if (!valueProp) {
                setValueState($05bfa43a01bd8f66$var$defaultValue);
                if (onChange) onChange($05bfa43a01bd8f66$var$defaultValue, {
                    touched: $05bfa43a01bd8f66$var$defaultTouched
                });
            }
            setTouched($05bfa43a01bd8f66$var$defaultTouched);
            setValidationResults($05bfa43a01bd8f66$var$defaultValidationResults);
            analyticsRef.current = {
                start: new Date(),
                errors: {}
            };
            if (_onReset) {
                event.persist(); // extract from React's synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = $05bfa43a01bd8f66$var$defaultValue;
                _onReset(adjustedEvent);
            }
        },
        onSubmit: function onSubmit(event) {
            // Don't submit the form via browser form action. We don't want it
            // if the validation fails. And, we assume a javascript action handler
            // otherwise.
            event.preventDefault();
            // Prevent any "outer" forms from performing `onSubmit`.
            // Nesting forms is not recommended in HTML. However, with React
            // portals, if the portal (such as Grommet's Layer) contains a form
            // and is nested within another form in the React tree, the event
            // bubbles up to the "outer" form even though in the DOM the portal
            // doesn't render as child of the "outer" form.
            // https://legacy.reactjs.org/docs/portals.html#event-bubbling-through-portals
            if (formRef.current && (event.target === formRef.current || event.target.form === formRef.current)) {
                setPendingValidation(undefined);
                // adding validateOn: "submit" prop to the undefined validateOn
                // fields as we want to trigger "submit" validation once form
                // is submitted
                var newValidationRulesRef = Object.keys(validationRulesRef.current).reduce(function(acc, key) {
                    acc[key] = validationRulesRef.current[key];
                    if (!acc[key].validateOn) acc[key] = $05bfa43a01bd8f66$var$_extends({}, validationRulesRef.current[key], {
                        validateOn: 'submit'
                    });
                    return acc;
                }, {});
                var _validateForm2 = $05bfa43a01bd8f66$var$validateForm(Object.entries(newValidationRulesRef), value, format, messages, true), nextErrors = _validateForm2[0], nextInfos = _validateForm2[1];
                setValidationResults(function() {
                    var nextValidationResults = {
                        errors: nextErrors,
                        infos: nextInfos,
                        // Show form's validity when clicking on Submit
                        valid: buildValid(nextErrors)
                    };
                    if (onValidate) onValidate($05bfa43a01bd8f66$var$_extends({
                        submitting: true
                    }, nextValidationResults));
                    validationResultsRef.current = nextValidationResults;
                    updateAnalytics();
                    return nextValidationResults;
                });
                if (Object.keys(nextErrors).length === 0 && _onSubmit) {
                    event.persist(); // extract from React's synthetic event pool
                    var adjustedEvent = event;
                    adjustedEvent.value = value;
                    adjustedEvent.touched = touched;
                    _onSubmit(adjustedEvent);
                    sendAnalytics({
                        type: 'formSubmit',
                        element: formRef.current,
                        data: adjustedEvent,
                        errors: analyticsRef.current.errors,
                        elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
                    });
                    analyticsRef.current.errors = {};
                    analyticsRef.current.submitted = true;
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7wKkw.FormContext).Provider, {
        value: formContextValue
    }, children));
});
$05bfa43a01bd8f66$export$a7fed597f4b8afd8.displayName = 'Form';
$05bfa43a01bd8f66$export$a7fed597f4b8afd8.propTypes = (0, $3nlLr.FormPropTypes);

});
parcelRegister("7wKkw", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $57af75b5ccab1819$export$c24727297075ec6a);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
// When not a descendant of a Form, FormContext still provides a basic
// useFormInput. It doesn't do anything for components like TextInput.
// But, it does store the value for components like CheckBox or Select
// where the grommet component needs to know the value in order to
// render custom visuals.
var $57af75b5ccab1819$var$useFormInput = function useFormInput(_ref) {
    var valueProp = _ref.value, initialValue = _ref.initialValue;
    var _useState = (0, $2NacA.useState)(valueProp !== undefined ? valueProp : initialValue), value = _useState[0], setValue = _useState[1];
    // Returns an array [value and function to set the value]
    return [
        valueProp !== undefined ? valueProp : value,
        function(nextValue) {
            if (initialValue !== undefined) setValue(nextValue);
        }
    ];
};
var $57af75b5ccab1819$var$useFormField = function useFormField(_ref2) {
    var error = _ref2.error, info = _ref2.info, disabled = _ref2.disabled;
    return {
        error: error,
        info: info,
        disabled: disabled
    };
};
var $57af75b5ccab1819$export$c24727297075ec6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext({
    useFormField: $57af75b5ccab1819$var$useFormField,
    useFormInput: $57af75b5ccab1819$var$useFormInput
});

});

parcelRegister("3nlLr", function(module, exports) {

$parcel$export(module.exports, "FormPropTypes", () => $27546702029fa5a5$export$87387e52a99daa8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $27546702029fa5a5$var$PropType = {};
var $27546702029fa5a5$export$87387e52a99daa8 = $27546702029fa5a5$var$PropType;

});


parcelRegister("k5B6T", function(module, exports) {

$parcel$export(module.exports, "TextArea", () => $ea010f9a718f4155$export$f5c9f3c2c4054eec);

var $2NacA = parcelRequire("2NacA");

var $7wKkw = parcelRequire("7wKkw");

var $czDw5 = parcelRequire("czDw5");

var $kiiNK = parcelRequire("kiiNK");

var $hABYZ = parcelRequire("hABYZ");

var $eL6w3 = parcelRequire("eL6w3");
var $ea010f9a718f4155$var$_excluded = [
    "a11yTitle",
    "fill",
    "focusIndicator",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "value"
];
function $ea010f9a718f4155$var$_extends() {
    return $ea010f9a718f4155$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ea010f9a718f4155$var$_extends.apply(null, arguments);
}
function $ea010f9a718f4155$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ea010f9a718f4155$export$f5c9f3c2c4054eec = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fill = _ref.fill, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, valueProp = _ref.value, rest = $ea010f9a718f4155$var$_objectWithoutPropertiesLoose(_ref, $ea010f9a718f4155$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $2NacA.useState)(), focus = _useState[0], setFocus = _useState[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEsc: function onEsc(event) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        },
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kiiNK.StyledTextArea), $ea010f9a718f4155$var$_extends({
        "aria-label": a11yTitle,
        ref: ref,
        name: name,
        fillArg: fill,
        focus: focus,
        value: value,
        focusIndicator: focusIndicator
    }, passThemeFlag, rest, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setValue(event.target.value);
            if (_onChange) _onChange(event);
        }
    })));
});
$ea010f9a718f4155$export$f5c9f3c2c4054eec.displayName = 'TextArea';
$ea010f9a718f4155$export$f5c9f3c2c4054eec.propTypes = (0, $hABYZ.TextAreaPropTypes);

});
parcelRegister("kiiNK", function(module, exports) {

$parcel$export(module.exports, "StyledTextArea", () => $ec6412a702452b29$export$e93364aaaa97e46f);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $ec6412a702452b29$var$plainStyle = (0, $f5efw.css)([
    "outline:none;border:none;width:100%;-webkit-appearance:none;"
]);
var $ec6412a702452b29$var$resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal') return 'resize: horizontal;';
    if (resize === 'vertical') return 'resize: vertical;';
    if (resize) return 'resize: both;';
    return 'resize: none;';
};
var $ec6412a702452b29$export$e93364aaaa97e46f = (0, $f5efw.default).textarea.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextArea",
    componentId: "sc-17i3mwp-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";max-width:100%;"
], (0, $2O6LY.inputStyle), function(props) {
    return props.resize !== undefined && $ec6412a702452b29$var$resizeStyle(props.resize);
}, function(props) {
    return props.fillArg && 'height: 100%;';
}, function(props) {
    return props.plain && $ec6412a702452b29$var$plainStyle;
}, function(props) {
    return props.disabled && (0, $2O6LY.disabledStyle)(props.theme.textArea.disabled && props.theme.textArea.disabled.opacity);
}, function(props) {
    return props.theme.textArea && props.theme.textArea.extend;
});

});

parcelRegister("hABYZ", function(module, exports) {

$parcel$export(module.exports, "TextAreaPropTypes", () => $cce34307d38cdf19$export$84f313a0fe939ad2);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $cce34307d38cdf19$var$PropType = {};
var $cce34307d38cdf19$export$84f313a0fe939ad2 = $cce34307d38cdf19$var$PropType;

});


parcelRegister("aUxMn", function(module, exports) {

$parcel$export(module.exports, "Send", () => $7f1956381f4bd4da$export$8689cbce9c2c90e9);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $7f1956381f4bd4da$var$_extends() {
    return $7f1956381f4bd4da$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7f1956381f4bd4da$var$_extends.apply(null, arguments);
}
var $7f1956381f4bd4da$export$8689cbce9c2c90e9 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $7f1956381f4bd4da$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Send"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 3 2 11l18.5 8L22 3zM10 20.5l3-4.5m2.5-6.5L9 14l.859 6.012c.078.546.216.537.306-.003L11 15l4.5-5.5z"
    }));
});
$7f1956381f4bd4da$export$8689cbce9c2c90e9.displayName = 'Send';

});

parcelRegister("iT0qG", function(module, exports) {

$parcel$export(module.exports, "LoadingDots", () => $bc247669cf93c8d5$export$1fb09f5f46e2840d);

var $6ir3O = parcelRequire("6ir3O");

var $ceXCV = parcelRequire("ceXCV");
const $bc247669cf93c8d5$export$1fb09f5f46e2840d = ({ color: color = '#000', style: style = 'small' })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsxs)("span", {
        className: style == 'small' ? $ceXCV.loading2 : $ceXCV.loading,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)("span", {
                style: {
                    backgroundColor: color
                }
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)("span", {
                style: {
                    backgroundColor: color
                }
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)("span", {
                style: {
                    backgroundColor: color
                }
            })
        ]
    });
};
$bc247669cf93c8d5$export$1fb09f5f46e2840d.defaultProps = {
    style: 'small'
};

});
parcelRegister("ceXCV", function(module, exports) {

$parcel$export(module.exports, "blink", () => $8e950b8080da4158$export$a0f5ee27be08228f, (v) => $8e950b8080da4158$export$a0f5ee27be08228f = v);
$parcel$export(module.exports, "loading", () => $8e950b8080da4158$export$46c1c92549715335, (v) => $8e950b8080da4158$export$46c1c92549715335 = v);
$parcel$export(module.exports, "loading2", () => $8e950b8080da4158$export$546459c704cf50a3, (v) => $8e950b8080da4158$export$546459c704cf50a3 = v);
var $8e950b8080da4158$export$a0f5ee27be08228f;
var $8e950b8080da4158$export$46c1c92549715335;
var $8e950b8080da4158$export$546459c704cf50a3;
var $8e950b8080da4158$export$8cc075c801fd6817;
$8e950b8080da4158$export$a0f5ee27be08228f = `_2qyOMa_blink`;
$8e950b8080da4158$export$a0f5ee27be08228f;
$8e950b8080da4158$export$46c1c92549715335 = `_2qyOMa_loading`;
$8e950b8080da4158$export$546459c704cf50a3 = `_2qyOMa_loading2`;
$8e950b8080da4158$export$8cc075c801fd6817 = `_2qyOMa_spacer`;

});



parcelRegister("45q4c", function(module, exports) {

$parcel$export(module.exports, "ChatWidget", () => $3eb4362f41ce6cf9$export$6f80868419f85c8b);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $lQtnN = parcelRequire("lQtnN");
var $dlTVI = parcelRequire("dlTVI");
var $1H2Fg = parcelRequire("1H2Fg");
var $d18Ah = parcelRequire("d18Ah");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $hIlrL = parcelRequire("hIlrL");
var $2bcjL = parcelRequire("2bcjL");
var $cdwIe = parcelRequire("cdwIe");
var $kS7Ii = parcelRequire("kS7Ii");
var $kQZ06 = parcelRequire("kQZ06");

var $cVvES = parcelRequire("cVvES");
var $1QpFO = parcelRequire("1QpFO");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $2YS9S = parcelRequire("2YS9S");

var $19GAm = parcelRequire("19GAm");

var $bsB3E = parcelRequire("bsB3E");

var $f5efw = parcelRequire("f5efw");
parcelRequire("edhuX");
var $f6hJT = parcelRequire("f6hJT");
parcelRequire("ibR9R");
var $fWjzH = parcelRequire("fWjzH");
var $c06ph = parcelRequire("c06ph");

var $8DltC = parcelRequire("8DltC");
const $3eb4362f41ce6cf9$var$RESERVED_MENTION_HANDLES = [
    {
        id: 'bot',
        label: 'talonBot'
    },
    {
        id: 'support',
        label: 'talonSupport'
    }
];
const $3eb4362f41ce6cf9$var$MESSAGE_PAGE_SIZE = 30;
const $3eb4362f41ce6cf9$var$TYPING_PING_THROTTLE_MS = 2500;
const $3eb4362f41ce6cf9$var$TYPING_INDICATOR_TTL_MS = 4000;
const $3eb4362f41ce6cf9$export$6f80868419f85c8b = (0, $j8yBr.observer)(()=>{
    const [query, setQuery] = (0, $2NacA.useState)('');
    const [loading, setLoading] = (0, $2NacA.useState)(false);
    const [channels, setChannels] = (0, $2NacA.useState)([]);
    const [activeChannelId, setActiveChannelId] = (0, $2NacA.useState)();
    const [participants, setParticipants] = (0, $2NacA.useState)([]);
    const [messageState, setMessageState] = (0, $2NacA.useState)({
        messages: []
    });
    const [messageToSend, setMessageToSend] = (0, $2NacA.useState)();
    const [showChat, setShowChat] = (0, $2NacA.useState)(false);
    const [dragStartPos, setDragStartPos] = (0, $2NacA.useState)({
        x: 0,
        y: 0
    });
    const [position, setPosition] = (0, $2NacA.useState)({
        x: 0,
        y: 0
    });
    const [startingY, setStartingY] = (0, $2NacA.useState)(0);
    const [timerStartedAt, setTimerStartedAt] = (0, $2NacA.useState)(null);
    const [timerNote, setTimerNote] = (0, $2NacA.useState)('');
    const [timerElapsedMs, setTimerElapsedMs] = (0, $2NacA.useState)(0);
    const [loggingTime, setLoggingTime] = (0, $2NacA.useState)(false);
    const [messagePage, setMessagePage] = (0, $2NacA.useState)(1);
    const [messageTotal, setMessageTotal] = (0, $2NacA.useState)(0);
    const [loadingMore, setLoadingMore] = (0, $2NacA.useState)(false);
    const [typingUsers, setTypingUsers] = (0, $2NacA.useState)({});
    const userStore = (0, $8DltC.useUserStore)();
    const tmStore = (0, $8DltC.useTalentManagerStore)();
    const chatStore = (0, $8DltC.useChatStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const textAreaRef = (0, $2NacA.useRef)(null);
    const dragRef = (0, $2NacA.useRef)(null);
    const lastTypingSentAtRef = (0, $2NacA.useRef)(0);
    const lastSubmitRef = (0, $2NacA.useRef)(null);
    const typingTimeoutsRef = (0, $2NacA.useRef)({});
    const location = (0, $19GAm.useLocation)();
    const navigate = (0, $19GAm.useNavigate)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- styled-components ships its own @types/react, causing a Context type mismatch
    const theme = (0, $2NacA.useContext)((0, $f5efw.ThemeContext));
    const activeChannel = channels.find((c)=>c.conversationId === activeChannelId);
    const activeEngagement = activeChannel?.engagementId ? tmStore.groupEngagements.find((e)=>e.id === activeChannel.engagementId) : null;
    const creditBalance = activeEngagement ? activeEngagement.credit_minutes_purchased - activeEngagement.credit_minutes_used : null;
    const isCreditWarning = creditBalance !== null && creditBalance > 0 && creditBalance < 30;
    const totalUnread = channels.reduce((sum, c)=>sum + c.unreadCount, 0);
    const mentionCandidates = [
        ...participants.filter((p)=>p.user_id !== userStore.user?.id).map((p)=>({
                id: p.user_id,
                label: `${p.user.first_name} ${p.user.last_name}`.trim()
            })),
        ...$3eb4362f41ce6cf9$var$RESERVED_MENTION_HANDLES
    ];
    const fetchChannels = async ()=>{
        try {
            const { channels: myChannels } = await (0, $lQtnN.ChatService).listMyChannels();
            setChannels(myChannels);
        } catch (error) {
            console.log('error fetching channels', error);
        }
    };
    (0, $2NacA.useEffect)(()=>{
        if (userStore.user?.id) {
            tmStore.fetchGroupEngagements();
            fetchChannels();
        }
    }, [
        userStore.user?.id
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (showChat) fetchChannels();
    }, [
        showChat
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (dragRef.current) setStartingY(dragRef.current.getBoundingClientRect().top);
    }, [
        dragRef.current
    ]);
    const sortMessagesAscending = (messages)=>messages.slice().sort((a, b)=>{
            if (a.created_at && b.created_at) return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
            return 0;
        });
    const selectChannel = async (channelId)=>{
        setActiveChannelId(channelId);
        setMessagePage(1);
        setMessageTotal(0);
        setTypingUsers({});
        try {
            const [{ conversation: conversation }, { messages: messages, total: total }] = await Promise.all([
                (0, $dlTVI.ConversationService).getConversation(channelId, 'participants'),
                (0, $dlTVI.ConversationService).listChatMessages(channelId, $3eb4362f41ce6cf9$var$MESSAGE_PAGE_SIZE, 1)
            ]);
            setMessageState({
                conversationId: channelId,
                messages: sortMessagesAscending(messages)
            });
            setMessageTotal(total);
            setParticipants(conversation.participants || []);
        } catch (error) {
            console.log('error loading channel history', error);
            setMessageState({
                conversationId: channelId,
                messages: []
            });
            setParticipants([]);
        }
        setChannels((prev)=>prev.map((c)=>c.conversationId === channelId ? {
                    ...c,
                    unreadCount: 0
                } : c));
        (0, $lQtnN.ChatService).markChannelRead(channelId).catch((error)=>console.log('error marking channel read', error));
    };
    const loadOlderMessages = async ()=>{
        if (!activeChannelId) return;
        setLoadingMore(true);
        try {
            const nextPage = messagePage + 1;
            const { messages: older } = await (0, $dlTVI.ConversationService).listChatMessages(activeChannelId, $3eb4362f41ce6cf9$var$MESSAGE_PAGE_SIZE, nextPage);
            setMessageState((state)=>({
                    ...state,
                    messages: [
                        ...sortMessagesAscending(older),
                        ...state.messages
                    ]
                }));
            setMessagePage(nextPage);
        } catch (error) {
            console.log('error loading older messages', error);
        } finally{
            setLoadingMore(false);
        }
    };
    (0, $2NacA.useEffect)(()=>{
        if (!timerStartedAt) return;
        const interval = setInterval(()=>setTimerElapsedMs(Date.now() - timerStartedAt.getTime()), 1000);
        return ()=>clearInterval(interval);
    }, [
        timerStartedAt
    ]);
    const startTimer = ()=>{
        setTimerStartedAt(new Date());
        setTimerElapsedMs(0);
    };
    const stopAndLogTime = async ()=>{
        if (!timerStartedAt || !activeChannel?.engagementId) return;
        setLoggingTime(true);
        await tmStore.logManualTime({
            engagement_id: activeChannel.engagementId,
            category: 'Consultation',
            description: timerNote || 'Chat session',
            started_at: timerStartedAt.toISOString(),
            ended_at: new Date().toISOString()
        });
        setLoggingTime(false);
        setTimerStartedAt(null);
        setTimerNote('');
        (0, $bsB3E.toast).success('Time logged.');
    };
    const sendTypingPing = ()=>{
        if (!activeChannelId) return;
        const now = Date.now();
        if (now - lastTypingSentAtRef.current < $3eb4362f41ce6cf9$var$TYPING_PING_THROTTLE_MS) return;
        lastTypingSentAtRef.current = now;
        setMessageToSend({
            type: (0, $d18Ah.MessageType).TYPING,
            conversation_id: activeChannelId
        });
    };
    const handleQueryChange = (value)=>{
        setQuery(value);
        sendTypingPing();
    };
    const handleTyping = (payload)=>{
        if (payload.user_id === userStore.user?.id) return;
        if (typingTimeoutsRef.current[payload.user_id]) clearTimeout(typingTimeoutsRef.current[payload.user_id]);
        typingTimeoutsRef.current[payload.user_id] = setTimeout(()=>{
            setTypingUsers((prev)=>{
                const next = {
                    ...prev
                };
                delete next[payload.user_id];
                return next;
            });
        }, $3eb4362f41ce6cf9$var$TYPING_INDICATOR_TTL_MS);
        setTypingUsers((prev)=>({
                ...prev,
                [payload.user_id]: payload.first_name
            }));
    };
    const formatElapsed = (ms)=>{
        const totalSeconds = Math.floor(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };
    // Deep-link: a "you were mentioned" email links to `?openChat=<conversationId>` since chat has no
    // page route of its own; pick it up once on load and strip it from the URL.
    (0, $2NacA.useEffect)(()=>{
        const openChatId = new URLSearchParams(location.search).get('openChat');
        if (openChatId) {
            chatStore.openChannel(openChatId);
            navigate(location.pathname, {
                replace: true
            });
        }
    }, []);
    // Same mechanism drives notification clicks (NotificationsMenu calls chatStore.openChannel directly).
    (0, $2NacA.useEffect)(()=>{
        if (!chatStore.pendingChannelId) return;
        const channelId = chatStore.pendingChannelId;
        chatStore.clearPendingChannel();
        setShowChat(true);
        (async ()=>{
            if (!channels.length) await fetchChannels();
            await selectChannel(channelId);
        })();
    }, [
        chatStore.pendingChannelId
    ]);
    // Side-rail default: the first time the widget is opened with nothing already selected, land
    // on the current project's General channel instead of an empty right-hand panel. Never
    // overrides a channel the user (or one of the mechanisms above) already selected.
    (0, $2NacA.useEffect)(()=>{
        if (!showChat || activeChannelId || !channels.length) return;
        const currentProjectChannel = channels.find((c)=>c.conversationType === (0, $1H2Fg.ConversationType).PROJECT && c.projectId === projectStore.currentProject?.id);
        if (currentProjectChannel) selectChannel(currentProjectChannel.conversationId);
    }, [
        showChat,
        channels,
        activeChannelId,
        projectStore.currentProject?.id
    ]);
    //handle form submission
    async function handleSubmit(e) {
        e.preventDefault();
        if (!activeChannelId) return;
        const text = query.trim();
        if (!text) return;
        // Guards against a message getting persisted twice from a single logical send (observed in
        // QA: two identical ChatMessage rows, same conversation, milliseconds apart — the exact
        // client-side trigger wasn't reproducible, but no legitimate flow sends identical text twice
        // within a second, so this is a safe, cheap backstop regardless of root cause).
        const now = Date.now();
        if (lastSubmitRef.current?.text === text && now - lastSubmitRef.current.at < 1000) return;
        lastSubmitRef.current = {
            text: text,
            at: now
        };
        setLoading(true);
        setQuery('');
        setMessageToSend({
            type: (0, $d18Ah.MessageType).USER_MESSAGE,
            text: text,
            conversation_id: activeChannelId
        });
        setLoading(false);
    }
    //prevent empty submissions
    const handleEnter = (e)=>{
        if (e.key === 'Enter' && query) handleSubmit(e);
        else if (e.key == 'Enter') e.preventDefault();
    };
    if (!userStore.user?.id) return null;
    const onStart = (e, data)=>{
        setDragStartPos({
            x: data.x,
            y: data.y
        });
    };
    const onStop = (e, data)=>{
        const deltaX = Math.abs(data.x - dragStartPos.x);
        const deltaY = Math.abs(data.y - dragStartPos.y);
        if (deltaX < 5 || deltaY < 5) {
            const height = Number(theme?.global?.size?.large?.substring(0, theme?.global?.size?.large?.length - 2));
            // click
            if (!showChat) {
                if (Math.abs(startingY + data.y) - height < 0) {
                    setShowChat(true);
                    setPosition({
                        x: data.x,
                        y: height - startingY
                    });
                } else setShowChat(true);
            }
        }
    };
    const projectChannels = channels.filter((c)=>c.conversationType === (0, $1H2Fg.ConversationType).PROJECT);
    const tmChannels = channels.filter((c)=>c.conversationType === (0, $1H2Fg.ConversationType).TALENT_MANAGER);
    // A TM can have more than one Support channel (one per agency group they're engaged by), so this
    // must render all of them, not just the first.
    const supportChannels = channels.filter((c)=>c.conversationType === (0, $1H2Fg.ConversationType).SUPPORT);
    // Project channels first so each project's bucket lists its "General" channel above that
    // project's per-engagement TM channels.
    const channelsByProject = [
        ...projectChannels,
        ...tmChannels
    ].reduce((acc, c)=>{
        const key = c.projectName ?? 'Other';
        acc[key] = acc[key] ? [
            ...acc[key],
            c
        ] : [
            c
        ];
        return acc;
    }, {});
    const renderChannelRow = (channel)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            align: "center",
            justify: "between",
            pad: {
                vertical: 'xsmall',
                horizontal: 'small'
            },
            background: channel.conversationId === activeChannelId ? 'light-3' : undefined,
            hoverIndicator: true,
            onClick: ()=>selectChannel(channel.conversationId),
            style: {
                cursor: 'pointer'
            },
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    weight: channel.unreadCount > 0 ? 'bold' : 'normal',
                    children: channel.name
                }),
                channel.unreadCount > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    background: "status-critical",
                    round: true,
                    pad: {
                        horizontal: 'xsmall'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "white",
                        children: channel.unreadCount
                    })
                })
            ]
        }, channel.conversationId);
    // Support agents already have a dedicated inbox for these conversations — a launcher to start
    // a new chat with support has no purpose on the page built for support to answer them.
    return !(location.pathname.includes('/admin') || location.pathname.includes('/onboarding') || location.pathname.includes('/support-inbox')) ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2YS9S.default), {
        bounds: "parent",
        handle: ".handle",
        nodeRef: dragRef,
        onStart: onStart,
        onStop: onStop,
        position: position,
        onDrag: (e, data)=>setPosition({
                x: data.x,
                y: data.y
            }),
        axis: "both",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            pad: "small",
            round: true,
            style: {
                position: 'fixed',
                bottom: '10%',
                right: '5%',
                zIndex: '10'
            },
            ref: dragRef,
            children: [
                !showChat && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    background: {
                        color: 'brand-gradient',
                        dark: true
                    },
                    style: {
                        background: 'var(--brand-gradient)',
                        cursor: 'move',
                        position: 'relative'
                    },
                    round: true,
                    height: "xxsmall",
                    width: "small",
                    align: "center",
                    justify: "center",
                    elevation: "medium",
                    direction: "row",
                    gap: "small",
                    border: {
                        color: 'accent-1',
                        size: 'small'
                    },
                    className: "handle",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            style: {
                                cursor: 'pointer'
                            },
                            children: "Chat"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cVvES.Chat), {
                            size: "20px",
                            enableBackground: "true",
                            style: {
                                cursor: 'pointer'
                            }
                        }),
                        totalUnread > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            background: "status-critical",
                            round: true,
                            pad: {
                                horizontal: 'xsmall'
                            },
                            style: {
                                position: 'absolute',
                                top: '-6px',
                                right: '-6px'
                            },
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                color: "white",
                                children: totalUnread
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cdwIe.Collapsible), {
                    direction: "vertical",
                    open: showChat,
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $ir1aK.Card), {
                        height: "large",
                        width: "820px",
                        background: "light-1",
                        border: "all",
                        elevation: "medium",
                        round: {
                            corner: 'top'
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "column",
                            height: "100%",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                                    pad: "small",
                                    background: {
                                        color: 'brand-gradient',
                                        dark: true
                                    },
                                    style: {
                                        background: 'var(--brand-gradient)',
                                        cursor: 'move'
                                    },
                                    justify: "between",
                                    className: "handle",
                                    gap: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: "Chat"
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                            onClick: ()=>setShowChat(false),
                                            cursor: "pointer"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    flex: true,
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            width: "160px",
                                            flex: false,
                                            overflow: {
                                                vertical: 'auto'
                                            },
                                            background: "light-2",
                                            border: {
                                                side: 'right',
                                                color: '#d9d9e3'
                                            },
                                            children: [
                                                Object.entries(channelsByProject).map(([projectName, channelsInBucket])=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                        margin: {
                                                            top: 'xsmall'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                                size: "xsmall",
                                                                weight: "bold",
                                                                color: "dark-4",
                                                                margin: {
                                                                    horizontal: 'small'
                                                                },
                                                                children: projectName
                                                            }),
                                                            channelsInBucket.map(renderChannelRow)
                                                        ]
                                                    }, projectName)),
                                                supportChannels.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                    margin: {
                                                        top: 'small'
                                                    },
                                                    children: supportChannels.map(renderChannelRow)
                                                }),
                                                !channels.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    margin: "small",
                                                    size: "small",
                                                    children: "No conversations yet."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            flex: true,
                                            direction: "column",
                                            children: !activeChannel ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                flex: true,
                                                align: "center",
                                                justify: "center",
                                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    size: "small",
                                                    color: "dark-4",
                                                    children: "Select a conversation"
                                                })
                                            }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                        pad: {
                                                            horizontal: 'small',
                                                            vertical: 'xsmall'
                                                        },
                                                        border: {
                                                            side: 'bottom',
                                                            color: '#d9d9e3'
                                                        },
                                                        background: activeChannel.conversationType === (0, $1H2Fg.ConversationType).SUPPORT ? 'accent-3' : 'accent-2',
                                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                            weight: "bold",
                                                            size: "small",
                                                            children: activeChannel.name
                                                        })
                                                    }),
                                                    isCreditWarning && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                        background: "status-warning",
                                                        pad: {
                                                            horizontal: 'small',
                                                            vertical: 'xxsmall'
                                                        },
                                                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                            size: "xsmall",
                                                            children: [
                                                                "Low credits: ",
                                                                creditBalance,
                                                                "m remaining.",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $6ir3O.jsx)("a", {
                                                                    href: `/project/${(0, $9Rhqc.kebabCase)(activeChannel.projectName ?? '')}/talent-manager`,
                                                                    children: "Buy more"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    messagePage * $3eb4362f41ce6cf9$var$MESSAGE_PAGE_SIZE < messageTotal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                        align: "center",
                                                        pad: {
                                                            vertical: 'xsmall'
                                                        },
                                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                                            size: "small",
                                                            label: loadingMore ? "Loading\u2026" : 'Load earlier messages',
                                                            disabled: loadingMore,
                                                            onClick: loadOlderMessages
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fWjzH.MessageList), {
                                                        messages: messageState.messages
                                                    }),
                                                    Object.keys(typingUsers).length > 0 && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                        size: "xsmall",
                                                        color: "dark-4",
                                                        margin: {
                                                            horizontal: 'small',
                                                            vertical: 'xsmall'
                                                        },
                                                        children: [
                                                            Object.values(typingUsers).join(', '),
                                                            ' ',
                                                            Object.keys(typingUsers).length === 1 ? 'is' : 'are',
                                                            " typing\u2026"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hIlrL.CardFooter), {
                                                        direction: "column",
                                                        align: "center",
                                                        gap: "none",
                                                        children: [
                                                            activeChannel.showLogTime && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                                direction: "row",
                                                                align: "center",
                                                                gap: "small",
                                                                width: "100%",
                                                                pad: {
                                                                    horizontal: 'small',
                                                                    vertical: 'xsmall'
                                                                },
                                                                background: "light-2",
                                                                children: !timerStartedAt ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                                                    size: "small",
                                                                    label: "Log Time",
                                                                    onClick: startTimer
                                                                }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                                            size: "small",
                                                                            weight: "bold",
                                                                            children: formatElapsed(timerElapsedMs)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                                            size: "small",
                                                                            placeholder: "What did you work on? (optional)",
                                                                            value: timerNote,
                                                                            onChange: (e)=>setTimerNote(e.target.value)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                                                            size: "small",
                                                                            primary: true,
                                                                            label: loggingTime ? "Saving\u2026" : 'Stop & Log',
                                                                            disabled: loggingTime,
                                                                            onClick: stopAndLogTime
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $f6hJT.SupportChat), {
                                                                setMessageState: setMessageState,
                                                                messageToSend: messageToSend,
                                                                conversationId: activeChannelId || '',
                                                                onTyping: handleTyping
                                                            }),
                                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                                direction: "row",
                                                                width: "100%",
                                                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $c06ph.UserInput), {
                                                                    handleSubmit: handleSubmit,
                                                                    loading: loading,
                                                                    handleEnter: handleEnter,
                                                                    textAreaRef: textAreaRef,
                                                                    query: query,
                                                                    setQuery: handleQueryChange,
                                                                    mentionCandidates: mentionCandidates
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
});

});
parcelRegister("ir1aK", function(module, exports) {

$parcel$export(module.exports, "Card", () => $d6bba86e08f6f9d8$export$60332b2344f7fe41);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $eL6w3 = parcelRequire("eL6w3");
function $d6bba86e08f6f9d8$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $d6bba86e08f6f9d8$var$_extends() {
    return $d6bba86e08f6f9d8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d6bba86e08f6f9d8$var$_extends.apply(null, arguments);
}
var $d6bba86e08f6f9d8$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$card$hover;
    var rest = $d6bba86e08f6f9d8$var$_extends({}, ($d6bba86e08f6f9d8$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $d6bba86e08f6f9d8$var$_extends({
        overflow: "hidden",
        kind: $d6bba86e08f6f9d8$var$_extends({
            hover: (_theme$card$hover = theme.card.hover) == null ? void 0 : _theme$card$hover.container
        }, theme.card.container),
        ref: ref
    }, theme.card.container, rest));
});
$d6bba86e08f6f9d8$export$60332b2344f7fe41.displayName = 'Card';

});

parcelRegister("hIlrL", function(module, exports) {

$parcel$export(module.exports, "CardFooter", () => $ce572ea4122152a9$export$e9897d434e0741ee);

var $2NacA = parcelRequire("2NacA");

var $cpdVK = parcelRequire("cpdVK");

var $eL6w3 = parcelRequire("eL6w3");
function $ce572ea4122152a9$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $ce572ea4122152a9$var$_extends() {
    return $ce572ea4122152a9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ce572ea4122152a9$var$_extends.apply(null, arguments);
}
// Needs to have a CardBody or a flex container when Card uses a fixed height.
var $ce572ea4122152a9$export$e9897d434e0741ee = function CardFooter(_ref) {
    var rest = $ce572ea4122152a9$var$_extends({}, ($ce572ea4122152a9$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cpdVK.Footer), $ce572ea4122152a9$var$_extends({}, theme.card.footer, rest));
};

});

parcelRegister("2bcjL", function(module, exports) {

$parcel$export(module.exports, "CardHeader", () => $196629e727b5b8b3$export$5665775b26e26c5d);

var $2NacA = parcelRequire("2NacA");

var $5ebSC = parcelRequire("5ebSC");

var $eL6w3 = parcelRequire("eL6w3");
function $196629e727b5b8b3$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $196629e727b5b8b3$var$_extends() {
    return $196629e727b5b8b3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $196629e727b5b8b3$var$_extends.apply(null, arguments);
}
var $196629e727b5b8b3$export$5665775b26e26c5d = function CardHeader(_ref) {
    var rest = $196629e727b5b8b3$var$_extends({}, ($196629e727b5b8b3$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5ebSC.Header), $196629e727b5b8b3$var$_extends({}, theme.card.header, rest));
};

});

parcelRegister("kQZ06", function(module, exports) {

$parcel$export(module.exports, "TextInput", () => $f2e7fb6d2feabb26$export$c86715117507e8e5);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $isD1Z = parcelRequire("isD1Z");

var $cy6cI = parcelRequire("cy6cI");

var $czDw5 = parcelRequire("czDw5");

var $7wKkw = parcelRequire("7wKkw");

var $7oNsG = parcelRequire("7oNsG");

var $cDMMY = parcelRequire("cDMMY");
var $2O6LY = parcelRequire("2O6LY");
var $dOlbm = parcelRequire("dOlbm");
var $1PECa = parcelRequire("1PECa");

var $hCrFl = parcelRequire("hCrFl");

var $2M0UK = parcelRequire("2M0UK");

var $kWc9K = parcelRequire("kWc9K");

var $eblDL = parcelRequire("eblDL");

var $eL6w3 = parcelRequire("eL6w3");
var $f2e7fb6d2feabb26$var$_excluded = [
    "a11yTitle",
    "defaultSuggestion",
    "defaultValue",
    "disabled",
    "dropAlign",
    "dropHeight",
    "dropTarget",
    "dropProps",
    "focusIndicator",
    "icon",
    "id",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "onSelect",
    "onSuggestionSelect",
    "onSuggestionsClose",
    "onSuggestionsOpen",
    "password",
    "placeholder",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "suggestions",
    "textAlign",
    "type",
    "value",
    "width"
];
function $f2e7fb6d2feabb26$var$_extends() {
    return $f2e7fb6d2feabb26$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f2e7fb6d2feabb26$var$_extends.apply(null, arguments);
}
function $f2e7fb6d2feabb26$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f2e7fb6d2feabb26$var$renderLabel = function renderLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') return suggestion.label || suggestion.value;
    return suggestion;
};
var $f2e7fb6d2feabb26$var$stringLabel = function stringLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') {
        if (suggestion.label && typeof suggestion.label === 'string') return suggestion.label;
        return suggestion.value;
    }
    return suggestion;
};
var $f2e7fb6d2feabb26$var$renderIcon = function renderIcon(iconValue, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).isValidElement(iconValue)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(iconValue, props);
    var IconComponent = iconValue;
    return IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(IconComponent, props) : undefined;
};
var $f2e7fb6d2feabb26$var$ContainerBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "TextInput__ContainerBox",
    componentId: "sc-1ai0c08-0"
})([
    "",
    ";@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}"
], function(props) {
    return props.dropHeight ? (0, $2O6LY.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var $f2e7fb6d2feabb26$var$defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var $f2e7fb6d2feabb26$export$c86715117507e8e5 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _inputRef$current, _inputRef$current2, _theme$textInput, _theme$textInput2;
    var a11yTitle = _ref.a11yTitle, defaultSuggestion = _ref.defaultSuggestion, defaultValue = _ref.defaultValue, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $f2e7fb6d2feabb26$var$defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropTarget = _ref.dropTarget, dropProps = _ref.dropProps, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, messages = _ref.messages, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onSelect = _ref.onSelect, onSuggestionSelect = _ref.onSuggestionSelect, onSuggestionsClose = _ref.onSuggestionsClose, onSuggestionsOpen = _ref.onSuggestionsOpen, password = _ref.password, placeholder = _ref.placeholder, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, reverse = _ref.reverse, suggestions = _ref.suggestions, textAlign = _ref.textAlign, typeProp = _ref.type, valueProp = _ref.value, widthProp = _ref.width, rest = $f2e7fb6d2feabb26$var$_objectWithoutPropertiesLoose(_ref, $f2e7fb6d2feabb26$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var inputRef = (0, $dOlbm.useForwardedRef)(ref);
    var dropRef = (0, $2NacA.useRef)();
    var suggestionsRef = (0, $2NacA.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    // if this is a readOnly property, don't set a name with the form context
    // this allows Select to control the form context for the name.
    var _formContext$useFormI = formContext.useFormInput({
        name: readOnly ? undefined : name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $2NacA.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, $2NacA.useState)(false), showDrop = _useState2[0], setShowDrop = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(false), passwordRevealed = _useState3[0], setPasswordRevealed = _useState3[1];
    var handleSuggestionSelect = (0, $2NacA.useMemo)(function() {
        return onSelect && !onSuggestionSelect ? onSelect : onSuggestionSelect;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var handleTextSelect = (0, $2NacA.useMemo)(function() {
        return onSelect && onSuggestionSelect ? onSelect : undefined;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var _useState4 = (0, $2NacA.useState)(), suggestionsAtClose = _useState4[0], setSuggestionsAtClose = _useState4[1];
    var readOnlyCopyValidation = format({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = format({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState5 = (0, $2NacA.useState)(readOnlyCopyPrompt), tip = _useState5[0], setTip = _useState5[1];
    var showPasswordMessage = format({
        id: 'textInput.showPassword',
        messages: messages
    });
    var hidePasswordMessage = format({
        id: 'textInput.hidePassword',
        messages: messages
    });
    var onClickCopy = function onClickCopy() {
        navigator.clipboard.writeText(value);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var authoredType = typeProp || (password ? 'password' : undefined);
    var passwordToggle = password && authoredType === 'password' && !readOnlyCopy;
    (0, $2NacA.useEffect)(function() {
        // When the toggle stops applying, return the input to its authored type.
        if (!passwordToggle) setPasswordRevealed(false);
    }, [
        passwordToggle
    ]);
    var openDrop = (0, $2NacA.useCallback)(function() {
        setShowDrop(true);
        announce(format({
            id: 'textInput.suggestionIsOpen',
            messages: messages
        }));
        announce(suggestions.length + " " + format({
            id: 'textInput.suggestionsCount',
            messages: messages
        }));
        if (onSuggestionsOpen) onSuggestionsOpen();
    }, [
        announce,
        messages,
        format,
        onSuggestionsOpen,
        suggestions
    ]);
    var closeDrop = (0, $2NacA.useCallback)(function() {
        setSuggestionsAtClose(suggestions); // must be before closing drop
        setShowDrop(false);
        if (onSuggestionsClose) onSuggestionsClose();
    }, [
        onSuggestionsClose,
        suggestions
    ]);
    var clickOutside = (0, $2NacA.useCallback)(function(event) {
        if (event.target !== inputRef.current) closeDrop();
    }, [
        inputRef,
        closeDrop
    ]);
    // Handle scenarios where we have focus, the drop isn't showing,
    // and the suggestions change. We don't want to open the drop if
    // the drop has been closed by onEsc and the suggestions haven't
    // changed. So, we remember the suggestions we are showing when
    // the drop was closed and only re-open it when the suggestions
    // subsequently change.
    (0, $2NacA.useEffect)(function() {
        if (focus && !showDrop && suggestions && suggestions.length && (!suggestionsAtClose || suggestionsAtClose.length !== suggestions.length)) openDrop();
    }, [
        focus,
        openDrop,
        showDrop,
        suggestions,
        suggestionsAtClose
    ]);
    // if we have no suggestions, close drop if it's open
    (0, $2NacA.useEffect)(function() {
        if (showDrop && (!suggestions || !suggestions.length)) closeDrop();
    }, [
        closeDrop,
        showDrop,
        suggestions
    ]);
    var valueSuggestionIndex = (0, $2NacA.useMemo)(function() {
        return suggestions ? suggestions.map(function(suggestion) {
            return typeof suggestion === 'object' ? suggestion.value : suggestion;
        }).indexOf(value) : -1;
    }, [
        suggestions,
        value
    ]);
    // choose the best suggestion, either the explicit default or the one
    // that matches the current value
    var resetSuggestionIndex = (0, $2NacA.useMemo)(function() {
        if (valueSuggestionIndex === -1 && typeof defaultSuggestion === 'number') return defaultSuggestion;
        return valueSuggestionIndex;
    }, [
        defaultSuggestion,
        valueSuggestionIndex
    ]);
    // activeSuggestionIndex unifies mouse and keyboard interaction of
    // the suggestions
    var _useState6 = (0, $2NacA.useState)(resetSuggestionIndex), activeSuggestionIndex = _useState6[0], setActiveSuggestionIndex = _useState6[1];
    // Only update active suggestion index when the mouse actually moves,
    // not when suggestions are moving under the mouse.
    var _useState7 = (0, $2NacA.useState)(), mouseMovedSinceLastKey = _useState7[0], setMouseMovedSinceLastKey = _useState7[1];
    // set activeSuggestionIndex when value changes
    (0, $2NacA.useEffect)(function() {
        return setActiveSuggestionIndex(valueSuggestionIndex);
    }, [
        valueSuggestionIndex
    ]);
    // reset activeSuggestionIndex when the drop is closed
    (0, $2NacA.useEffect)(function() {
        if (!showDrop) setActiveSuggestionIndex(resetSuggestionIndex);
    }, [
        resetSuggestionIndex,
        showDrop
    ]);
    // announce active suggestion
    (0, $2NacA.useEffect)(function() {
        if (activeSuggestionIndex >= 0) {
            var label = $f2e7fb6d2feabb26$var$stringLabel(suggestions[activeSuggestionIndex]);
            announce(label + " " + format({
                id: 'textInput.enterSelect',
                messages: messages
            }));
        }
    }, [
        activeSuggestionIndex,
        announce,
        messages,
        format,
        suggestions
    ]);
    // make sure activeSuggestion is visible in scroll
    (0, $2NacA.useEffect)(function() {
        var timer = setTimeout(function() {
            var list = suggestionsRef.current;
            if (showDrop && activeSuggestionIndex !== -1 && list) {
                var container = list.parentNode;
                var item = list.children[activeSuggestionIndex];
                if (container.scrollTo) {
                    if ((0, $cDMMY.isNodeAfterScroll)(item, container)) container.scrollTo(0, item.offsetTop - (container.getBoundingClientRect().height - item.getBoundingClientRect().height));
                    else if ((0, $cDMMY.isNodeBeforeScroll)(item, container)) container.scrollTo(0, item.offsetTop);
                }
            }
        }, 50); // delay to allow Drop to animate in
        return function() {
            return clearTimeout(timer);
        };
    }, [
        activeSuggestionIndex,
        showDrop
    ]);
    (0, $2NacA.useEffect)(function() {
        if (readOnly && inputRef != null && inputRef.current && inputRef.current.scrollLeft > 0) inputRef.current.scrollLeft = 0;
    }, [
        readOnly,
        inputRef,
        inputRef == null || (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.scrollLeft
    ]);
    var setValueFromSuggestion = function setValueFromSuggestion(event, suggestion) {
        // if we stole the focus in the drop, perhaps by interacting with
        // a suggestion button or the scrollbar, give it back
        inputRef.current.focus();
        inputRef.current.value = suggestion; // needed for uncontrolled cases
        closeDrop();
        if (handleSuggestionSelect) {
            if (event.persist) event.persist();
            var adjustedEvent = event;
            adjustedEvent.suggestion = suggestion;
            handleSuggestionSelect(adjustedEvent);
        }
        setValue(suggestion);
    };
    var onNextSuggestion = (0, $2NacA.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex,
        suggestions
    ]);
    var onPreviousSuggestion = (0, $2NacA.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.max(activeSuggestionIndex - 1, 0);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex
    ]);
    // account for input value in both controlled and uncontrolled scenarios
    var hasValue = value || ((_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.value);
    var showStyledPlaceholder = (0, $2NacA.useMemo)(function() {
        return placeholder && typeof placeholder !== 'string' && !hasValue;
    }, [
        hasValue,
        placeholder
    ]);
    var drop;
    var extraProps = {
        onSelect: handleTextSelect
    };
    if (showDrop) drop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $isD1Z.Drop), $f2e7fb6d2feabb26$var$_extends({
        ref: dropRef,
        id: id ? "text-input-drop__" + id : undefined,
        align: dropAlign,
        responsive: false,
        target: dropTarget || inputRef.current,
        onClickOutside: clickOutside,
        onEsc: closeDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($f2e7fb6d2feabb26$var$ContainerBox, $f2e7fb6d2feabb26$var$_extends({
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        overflow: "auto",
        dropHeight: dropHeight,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledSuggestions), $f2e7fb6d2feabb26$var$_extends({
        ref: suggestionsRef
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cy6cI.InfiniteScroll), {
        items: suggestions,
        step: theme.select.step,
        show: activeSuggestionIndex !== -1 ? activeSuggestionIndex : undefined
    }, function(suggestion, index, itemRef) {
        var active = activeSuggestionIndex === index;
        var selected = suggestion === value;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var renderedLabel = $f2e7fb6d2feabb26$var$renderLabel(suggestion);
        var child;
        if (typeof renderedLabel !== 'string') // must be an element rendered by suggestions.label
        child = renderedLabel;
        else if (!theme.button.option) // don't have theme support, need to layout here
        /*
        Not adding a theme object now because this code path
        is not used in the HPE theme, but we may add theme
        support here in the future.
        */ child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            align: "start",
            pad: "small"
        }, renderedLabel);
        // if we have a child, turn on plain
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("li", {
            key: $f2e7fb6d2feabb26$var$stringLabel(suggestion) + "-" + index,
            ref: itemRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            role: "option",
            "aria-selected": selected ? 'true' : 'false',
            active: active,
            fill: "horizontal",
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? renderedLabel : undefined,
            onClick: function onClick(event) {
                return setValueFromSuggestion(event, suggestion);
            },
            onMouseMove: mouseMovedSinceLastKey && activeSuggestionIndex !== index ? function() {
                return setActiveSuggestionIndex(index);
            } : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
    var keyboardProps = {
        onKeyDown: onKeyDown
    };
    if (showDrop) {
        keyboardProps.onEnter = function(event) {
            // prevent submitting forms via Enter when the drop is open
            event.preventDefault();
            if (activeSuggestionIndex >= 0) setValueFromSuggestion(event, suggestions[activeSuggestionIndex]);
            else closeDrop();
        };
        if (activeSuggestionIndex > 0) keyboardProps.onUp = onPreviousSuggestion;
        if (activeSuggestionIndex < suggestions.length - 1) keyboardProps.onDown = onNextSuggestion;
        keyboardProps.onTab = closeDrop;
    } else if (suggestions && suggestions.length > 0) keyboardProps.onDown = openDrop;
    /*
  If the text input has a list of suggestions, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    if (id && (suggestions == null ? void 0 : suggestions.length) > -1) {
        if (showDrop && activeSuggestionIndex > -1) activeOptionID = "listbox-option-" + activeSuggestionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    // For the Keyboard target below, if we have focus,
    // either on the input element or within the drop,
    // then we set the target to the document,
    // otherwise we only listen to onDown on the input element itself,
    // primarily for tests.
    var textInputIcon = (0, $1PECa.useSizedIcon)(icon, rest.size, theme);
    var showPasswordIcon = (_theme$textInput = theme.textInput) == null || (_theme$textInput = _theme$textInput.icons) == null ? void 0 : _theme$textInput.showPassword;
    var hidePasswordIcon = (_theme$textInput2 = theme.textInput) == null || (_theme$textInput2 = _theme$textInput2.icons) == null ? void 0 : _theme$textInput2.hidePassword;
    var inputType = authoredType;
    if (passwordToggle) inputType = passwordRevealed ? 'text' : 'password';
    var showTextInputIcon = !!textInputIcon && !readOnlyCopy;
    var showLeadingIcon = showTextInputIcon && !reverse;
    var showTrailingIcon = showTextInputIcon && reverse;
    var ReadOnlyCopyButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $eblDL.CopyButton), {
        disabled: disabled,
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    });
    var PasswordToggleButton = passwordToggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        disabled: disabled,
        kind: "toolbar",
        icon: passwordRevealed ? $f2e7fb6d2feabb26$var$renderIcon(hidePasswordIcon, {
            'aria-hidden': true
        }) : $f2e7fb6d2feabb26$var$renderIcon(showPasswordIcon, {
            'aria-hidden': true
        }),
        onClick: function onClick() {
            return setPasswordRevealed(function(current) {
                return !current;
            });
        },
        "aria-label": passwordRevealed ? hidePasswordMessage : showPasswordMessage
    }) : undefined;
    var textInputButton = readOnlyCopy ? ReadOnlyCopyButton : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledTextInputContainer), $f2e7fb6d2feabb26$var$_extends({
        hasButton: !!textInputButton,
        readOnlyProp: readOnly // readOnlyProp to avoid passing to DOM
        ,
        readOnlyCopy: readOnlyCopy,
        plain: plain,
        border: !plain,
        widthProp: widthProp,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), reverse && textInputButton, showStyledPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledPlaceholder), passThemeFlag, placeholder), showLeadingIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledIcon), {
        reverse: reverse,
        theme: theme
    }, textInputIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), $f2e7fb6d2feabb26$var$_extends({
        target: focus ? 'document' : undefined
    }, keyboardProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledTextInput), $f2e7fb6d2feabb26$var$_extends({
        "aria-label": a11yTitle,
        ref: inputRef,
        id: id,
        name: name,
        autoComplete: "off",
        disabled: disabled,
        plain: plain,
        placeholder: typeof placeholder === 'string' ? placeholder : undefined,
        icon: showTextInputIcon ? icon : undefined,
        reverse: reverse,
        focus: focus,
        hasButton: !!textInputButton,
        hasInlineButton: passwordToggle,
        hasTrailingIcon: showTrailingIcon,
        focusIndicator: focusIndicator,
        textAlign: textAlign,
        type: inputType,
        widthProp: widthProp
    }, passThemeFlag, rest, extraProps, comboboxProps, {
        defaultValue: $f2e7fb6d2feabb26$var$renderLabel(defaultValue),
        value: $f2e7fb6d2feabb26$var$renderLabel(value),
        readOnly: readOnly,
        readOnlyCopy: readOnlyCopy,
        onFocus: function onFocus(event) {
            // Don't do anything if we are acting like we already have
            // focus. This can happen when this input loses focus temporarily
            // to our drop, see onBlur() handler below.
            if (!focus) {
                setFocus(true);
                if (suggestions && suggestions.length > 0) {
                    announce(format({
                        id: 'textInput.suggestionsExist',
                        messages: messages
                    }));
                    openDrop();
                }
                if (_onFocus) _onFocus(event);
            }
        },
        onBlur: function onBlur(event) {
            // Only treat it as a blur if the element receiving focus
            // isn't in our drop. The relatedTarget will be our drop
            // when the user clicks on a suggestion or interacts with the
            // scrollbar in the drop.
            if (!event.relatedTarget || event.relatedTarget !== dropRef.current) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        },
        onChange: readOnly ? undefined : function(event) {
            // when TextInput is not contained in a Form, no re-render
            // will come from this onChange and remove the placeholder
            // so we need to update state to ensure the styled
            // placeholder only appears when there is no value
            if (suggestions && focus && !showDrop) openDrop();
            setValue(event.target.value);
            setActiveSuggestionIndex(resetSuggestionIndex);
            if (onChange) onChange(event);
        }
    }))), PasswordToggleButton && !readOnlyCopy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledInlineButton), passThemeFlag, showTrailingIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledInlineIcon), passThemeFlag, textInputIcon), PasswordToggleButton), showTrailingIcon && !PasswordToggleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hCrFl.StyledIcon), {
        reverse: reverse,
        theme: theme
    }, textInputIcon), !reverse && textInputButton, !readOnly && drop);
});
$f2e7fb6d2feabb26$export$c86715117507e8e5.displayName = 'TextInput';
$f2e7fb6d2feabb26$export$c86715117507e8e5.propTypes = (0, $kWc9K.TextInputPropTypes);

});
parcelRegister("cy6cI", function(module, exports) {

$parcel$export(module.exports, "InfiniteScroll", () => $922d78ff03a4ea4f$export$c5295390d6167a3e);

var $2NacA = parcelRequire("2NacA");

var $hHZ58 = parcelRequire("hHZ58");

var $cDMMY = parcelRequire("cDMMY");

var $5xcHk = parcelRequire("5xcHk");

var $iA5Cc = parcelRequire("iA5Cc");
function $922d78ff03a4ea4f$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
var $922d78ff03a4ea4f$var$calculateLastPageBound = function calculateLastPageBound(show, step) {
    return show ? Math.floor((show + step) / step) - 1 : 0;
};
var $922d78ff03a4ea4f$export$c5295390d6167a3e = function InfiniteScroll(_ref) {
    var children = _ref.children, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, onMore = _ref.onMore, renderMarker = _ref.renderMarker, replace = _ref.replace, show = _ref.show, _ref$step = _ref.step, step = _ref$step === void 0 ? 50 : _ref$step;
    // item index to be made visible initially
    var _useState = (0, $2NacA.useState)(), scrollShow = _useState[0], setScrollShow = _useState[1];
    // the last page we have items for
    var lastPage = (0, $2NacA.useMemo)(function() {
        return Math.max(0, Math.ceil(items.length / step) - 1);
    }, [
        items.length,
        step
    ]);
    // the pages we are rendering
    var _useState2 = (0, $2NacA.useState)([
        0,
        $922d78ff03a4ea4f$var$calculateLastPageBound(show, step)
    ]), renderPageBounds = _useState2[0], setRenderPageBounds = _useState2[1];
    // the heights of the pages, approximated after we render the first page
    // and then updated for pages that have rendered
    var _useState3 = (0, $2NacA.useState)([]), pageHeights = _useState3[0], setPageHeights = _useState3[1];
    // what we're waiting for onMore to give us
    var _useState4 = (0, $2NacA.useState)(0), pendingLength = _useState4[0], setPendingLength = _useState4[1];
    var aboveMarkerRef = (0, $2NacA.useRef)(); // only when replacing
    var belowMarkerRef = (0, $2NacA.useRef)();
    // scroll and resize handling
    (0, $2NacA.useEffect)(function() {
        var scrollParents;
        var evaluate = function evaluate() {
            if (!scrollParents) return;
            var scrollParent = scrollParents[0];
            // Determine the scroll position of the scroll container
            var top;
            var height;
            if (scrollParent === document) {
                top = document.documentElement.scrollTop || document.body.scrollTop;
                height = window.innerHeight;
            } else {
                top = scrollParent.scrollTop;
                var rect = scrollParent.getBoundingClientRect();
                height = rect.height;
            }
            var offset = height / 4; // so we pre-load when the user scrolls slowly
            // Use the pageHeights to determine what pages we should render based
            // on the current scroll window.
            var nextBeginPage = 0;
            var index = 0;
            var pagesHeight = pageHeights[index] || 0;
            while(pageHeights[index + 1] && pagesHeight < top - offset){
                index += 1;
                nextBeginPage += 1;
                pagesHeight += pageHeights[index];
            }
            var nextEndPage = nextBeginPage;
            while(pageHeights[index] !== undefined && pagesHeight < top + height + offset){
                index += 1;
                nextEndPage += 1;
                // when we haven't rendered the nextEndPage and we aren't replacing,
                // we might not have a height for it yet
                pagesHeight += pageHeights[index] || 0;
            }
            if (!replace) {
                // when not replacing, never shrink bounds
                nextBeginPage = 0;
                nextEndPage = Math.max(renderPageBounds[1], nextEndPage);
            }
            if (show) {
                // ensure we try to render any show page
                var showPage = $922d78ff03a4ea4f$var$calculateLastPageBound(show, step);
                nextBeginPage = Math.min(showPage, nextBeginPage);
                nextEndPage = Math.max(showPage, nextEndPage);
            }
            if (nextBeginPage !== renderPageBounds[0] || nextEndPage !== renderPageBounds[1]) setRenderPageBounds([
                nextBeginPage,
                nextEndPage
            ]);
        };
        var timer;
        var debounce = function debounce() {
            clearTimeout(timer);
            timer = setTimeout(evaluate, 10);
        };
        // might not be there yet or might have already rendered everything
        if (belowMarkerRef.current) {
            scrollParents = (0, $cDMMY.findScrollParents)(belowMarkerRef.current);
            scrollParents.forEach(function(sp) {
                return sp.addEventListener('scroll', debounce);
            });
        }
        window.addEventListener('resize', debounce);
        evaluate();
        return function() {
            if (scrollParents) scrollParents.forEach(function(sp) {
                return sp.removeEventListener('scroll', debounce);
            });
            window.removeEventListener('resize', debounce);
            clearTimeout(timer);
        };
    }, [
        pageHeights,
        renderPageBounds,
        replace,
        show,
        step
    ]);
    // check if we need to ask for more
    (0, $2NacA.useEffect)(function() {
        if (onMore && renderPageBounds[1] === lastPage && items.length >= pendingLength && items.length > 0) {
            // remember we've asked for more, so we don't keep asking if it takes
            // a while
            setPendingLength(items.length + 1);
            onMore();
        }
    }, [
        items.length,
        lastPage,
        onMore,
        pendingLength,
        renderPageBounds,
        step
    ]);
    (0, $2NacA.useEffect)(function() {
        if (items.length === 0 && lastPage === 0 && pendingLength !== 0) {
            setPageHeights([]);
            setPendingLength(0);
            setRenderPageBounds([
                0,
                $922d78ff03a4ea4f$var$calculateLastPageBound(show, step)
            ]);
        }
    }, [
        lastPage,
        pendingLength,
        show,
        step,
        items.length
    ]);
    // scroll to any 'show'
    (0, $hHZ58.useLayoutEffect)(function() {
        // ride out any animation delays, 100ms empirically measured
        var timer = setTimeout(function() {
            if (show && belowMarkerRef.current && show !== scrollShow) {
                // calculate show index based on beginPage
                var showIndex = show - renderPageBounds[0] * step + (renderPageBounds[0] ? 1 : 0);
                var showNode = belowMarkerRef.current.parentNode.children.item(showIndex);
                if (showNode) {
                    var scrollParent = (0, $cDMMY.findScrollParent)(showNode);
                    if ((0, $cDMMY.isNodeBeforeScroll)(showNode, scrollParent)) showNode.scrollIntoView(true);
                    else if ((0, $cDMMY.isNodeAfterScroll)(showNode, scrollParent)) showNode.scrollIntoView(false);
                    // clean up after having shown
                    setScrollShow(show);
                }
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    // Omitting scrollShow as a dependency due to concern that setScrollShow
    // is being called within the timer. If left included, re-renders and other
    // dependency values could change in an unpredictable manner during timer
    // and potentially result in an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        renderPageBounds,
        show,
        step
    ]);
    // calculate and keep track of page heights
    (0, $hHZ58.useLayoutEffect)(function() {
        // if don't have a belowMarker, we must have rendered everything already
        if (!belowMarkerRef.current) return;
        // calculate page heights for rendered pages
        var rendered = belowMarkerRef.current.parentNode.children;
        // ensure we've rendered the state we have
        // above? + items in rendered pages + below === rendered DOM elements length
        if ((aboveMarkerRef.current ? 1 : 0) + (renderPageBounds[1] - renderPageBounds[0] + 1) * step + 1 === rendered.length) {
            var nextPageHeights;
            // step through each page
            var i = renderPageBounds[0];
            var lastBottom;
            while(i <= renderPageBounds[1]){
                var topIndex = (aboveMarkerRef.current ? 1 : 0) + (i - renderPageBounds[0]) * step;
                var bottomIndex = Math.min(topIndex + step - 1, rendered.length - 1);
                // we use lastBottom for top to ensure grid layouts work
                var top = lastBottom !== undefined ? lastBottom : rendered.item(topIndex).getBoundingClientRect().top;
                var _rendered$item$getBou = rendered.item(bottomIndex).getBoundingClientRect(), bottom = _rendered$item$getBou.bottom;
                var height = bottom - top;
                if (bottom && (!pageHeights || pageHeights[i] !== height)) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    nextPageHeights[i] = height;
                }
                lastBottom = bottom;
                i += 1;
            }
            // estimate page heights for pages we haven't rendered yet
            while(replace && i <= lastPage){
                if (!pageHeights[i] && pageHeights[i] !== pageHeights[0]) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    // set to first page height
                    var _nextPageHeights = nextPageHeights;
                    nextPageHeights[i] = _nextPageHeights[0];
                }
                i += 1;
            }
            if (nextPageHeights) setPageHeights(nextPageHeights);
        }
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace,
        step
    ]);
    // calculate the height above the first rendered page using the pageHeights
    var aboveHeight = (0, $2NacA.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = 0;
        while(i < renderPageBounds[0]){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        pageHeights,
        renderPageBounds,
        replace
    ]);
    // calculate the height below the last rendered page using the pageHeights
    var belowHeight = (0, $2NacA.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = renderPageBounds[1] + 1;
        while(i <= lastPage){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace
    ]);
    var firstIndex = renderPageBounds[0] * step;
    var lastIndex = Math.min((renderPageBounds[1] + 1) * step, items.length) - 1;
    var result = [];
    if (aboveHeight) {
        var marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            key: "above",
            ref: aboveMarkerRef,
            flex: false,
            height: aboveHeight + "px"
        });
        if (renderMarker) // need to give it a key
        marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(renderMarker(marker), {
            key: 'above'
        });
        result.push(marker);
    }
    items.slice(firstIndex, lastIndex + 1).forEach(function(item, index) {
        var itemsIndex = firstIndex + index;
        var child = children(item, itemsIndex);
        result.push(child);
    });
    if (replace || renderPageBounds[1] < lastPage || onMore) {
        var _marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            key: "below",
            ref: !renderMarker && belowMarkerRef || undefined,
            flex: false,
            height: (belowHeight || 0) + "px"
        });
        if (renderMarker) {
            // need to give it a key
            var renderedMarker = renderMarker(_marker);
            _marker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement(renderedMarker, {
                key: 'below',
                // We need to make sure our belowMarkerRef is tied to a component
                // that has the same parent as the items being rendered. This is so
                // we can use belowMarkerRef.current.parentNode.children to
                // get a reference to the items in the DOM for calculating pageHeights.
                //
                // Since the caller might have included a ref in what their
                // renderMarker returns, we have to take care of both refs.
                // https://github.com/facebook/react/issues/8873#issuecomment-489579878
                ref: function ref(node) {
                    // Keep your own reference
                    belowMarkerRef.current = node;
                    // Call the original ref, if any
                    var ref = renderedMarker.ref;
                    if (typeof ref === 'function') ref(node);
                    else if (ref !== null) ref.current = node;
                }
            });
        }
        result.push(_marker);
    }
    return result;
};
$922d78ff03a4ea4f$export$c5295390d6167a3e.propTypes = (0, $iA5Cc.InfiniteScrollPropTypes);

});
parcelRegister("iA5Cc", function(module, exports) {

$parcel$export(module.exports, "InfiniteScrollPropTypes", () => $d86ff1cf129e8f22$export$2cd935ea72beacbd);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $d86ff1cf129e8f22$var$PropType = {};
var $d86ff1cf129e8f22$export$2cd935ea72beacbd = $d86ff1cf129e8f22$var$PropType;

});


parcelRegister("hCrFl", function(module, exports) {

$parcel$export(module.exports, "StyledTextInput", () => $cd3b721d8a2d1f47$export$46d060c4400937ed);
$parcel$export(module.exports, "StyledTextInputContainer", () => $cd3b721d8a2d1f47$export$4aa9d16f7efe0fb6);
$parcel$export(module.exports, "StyledPlaceholder", () => $cd3b721d8a2d1f47$export$333ccef64da8eec4);
$parcel$export(module.exports, "StyledIcon", () => $cd3b721d8a2d1f47$export$7c8f159da0dc916);
$parcel$export(module.exports, "StyledInlineButton", () => $cd3b721d8a2d1f47$export$d8ca40f1f9499879);
$parcel$export(module.exports, "StyledInlineIcon", () => $cd3b721d8a2d1f47$export$c33bc55abcf53e74);
$parcel$export(module.exports, "StyledSuggestions", () => $cd3b721d8a2d1f47$export$2f5b00b01ab6676b);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $fzxBh = parcelRequire("fzxBh");

var $2O6LY = parcelRequire("2O6LY");

var $9Kkdp = parcelRequire("9Kkdp");
var $cd3b721d8a2d1f47$var$getInlineButtonPad = function getInlineButtonPad(props) {
    var rightInset = Number.parseFloat((0, $2O6LY.getInputPadBySide)(props, 'right'));
    var iconPad = Number.parseFloat((0, $2O6LY.getInputIconPad)(props));
    var trailingIconPad = props.hasTrailingIcon ? iconPad : 0;
    // Reserve both the icon space and the control's edge inset so text clears
    // the flush-right password toggle, and the reversed icon when both coexist.
    return iconPad + trailingIconPad + rightInset + "px";
};
var $cd3b721d8a2d1f47$var$getPlainStyle = function getPlainStyle(plain) {
    if (plain === 'full') return (0, $f5efw.css)([
        "",
        " padding:0;"
    ], (0, $2O6LY.plainInputStyle));
    return plain && (0, $2O6LY.plainInputStyle);
};
var $cd3b721d8a2d1f47$export$46d060c4400937ed = (0, $f5efw.default).input.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput",
    componentId: "sc-1x30a0s-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], (0, $2O6LY.inputStyle), function(props) {
    return (props.hasButton || props.readOnlyCopy) && 'flex: 1 1 auto;';
}, function(props) {
    return (props.hasButton || props.readOnlyCopy) && 'min-width: 0;';
}, function(props) {
    return props.readOnlyCopy || props.hasButton ? "padding-" + (props.reverse ? 'left' : 'right') + ": 0px;" : '';
}, function(props) {
    return props.readOnly && "border: none;";
}, function(props) {
    return $cd3b721d8a2d1f47$var$getPlainStyle(props.plain);
}, function(props) {
    return props.icon && (0, $2O6LY.inputPadForIcon);
}, function(props) {
    return props.hasInlineButton && "padding-right: " + $cd3b721d8a2d1f47$var$getInlineButtonPad(props) + ";";
}, function(props) {
    return props.disabled && (0, $2O6LY.disabledStyle)(props.theme.textInput.disabled && props.theme.textInput.disabled.opacity);
}, function(props) {
    return props.textAlign && (0, $2O6LY.textAlignStyle);
}, function(props) {
    return props.widthProp && !props.readOnly && (0, $2O6LY.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.extend;
});
var $cd3b721d8a2d1f47$export$4aa9d16f7efe0fb6 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledTextInputContainer",
    componentId: "sc-1x30a0s-1"
})([
    "position:relative;width:100%;",
    " ",
    ";",
    ";",
    " ",
    ";"
], function(props) {
    return props.widthProp && props.readOnlyProp && (0, $2O6LY.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.readOnlyProp && !props.plain && (0, $2O6LY.controlBorderStyle);
}, function(props) {
    return (props.readOnlyCopy || props.hasButton) && "\n    box-sizing: border-box;\n    flex-direction: row;\n    display: flex;\n    align-items: stretch;\n  ";
}, function(props) {
    return props.readOnlyProp && !props.plain && (0, $9Kkdp.readOnlyStyle)(props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.container && props.theme.textInput.container.extend;
});
var $cd3b721d8a2d1f47$export$333ccef64da8eec4 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledPlaceholder",
    componentId: "sc-1x30a0s-2"
})([
    "position:absolute;left:",
    "px;top:50%;transform:translateY(-50%);display:flex;justify-content:center;pointer-events:none;",
    ";"
], function(props) {
    return (0, $fzxBh.parseMetricToNum)((0, $2O6LY.getInputPadBySide)(props, 'left')) - (0, $fzxBh.parseMetricToNum)(props.theme.global.control.border.width);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.placeholder && props.theme.textInput.placeholder.extend;
});
var $cd3b721d8a2d1f47$export$7c8f159da0dc916 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledIcon",
    componentId: "sc-1x30a0s-3"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, $2O6LY.getInputPadBySide)(props, 'right') + ";" : "left: " + (0, $2O6LY.getInputPadBySide)(props, 'left') + ";";
});
var $cd3b721d8a2d1f47$export$d8ca40f1f9499879 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledInlineButton",
    componentId: "sc-1x30a0s-4"
})([
    "position:absolute;display:flex;align-items:stretch;top:0;right:0;bottom:0;z-index:1;"
]);
var $cd3b721d8a2d1f47$export$c33bc55abcf53e74 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledInlineIcon",
    componentId: "sc-1x30a0s-5"
})([
    "display:flex;align-items:center;justify-content:center;pointer-events:none;"
]);
var $cd3b721d8a2d1f47$export$2f5b00b01ab6676b = (0, $f5efw.default).ol.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledSuggestions",
    componentId: "sc-1x30a0s-6"
})([
    "border-top-left-radius:0;border-top-right-radius:0;margin:0;padding:0;list-style-type:none;",
    ";"
], function(props) {
    return props.theme.textInput && props.theme.textInput.suggestions && props.theme.textInput.suggestions.extend;
});

});
parcelRegister("9Kkdp", function(module, exports) {

$parcel$export(module.exports, "readOnlyStyle", () => $71881742dcfa1e55$export$28ff5f3fef0ffa78);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");

var $d2fh4 = parcelRequire("d2fh4");
var $71881742dcfa1e55$export$28ff5f3fef0ffa78 = function readOnlyStyle(theme) {
    var _theme$global$input$r, _theme$global$input$r2, _theme$global$input$r3;
    var styles = [];
    if (theme != null && (_theme$global$input$r = theme.global.input.readOnly) != null && (_theme$global$input$r = _theme$global$input$r.border) != null && _theme$global$input$r.color) styles.push((0, $f5efw.css)([
        "border-color:",
        ";"
    ], (0, $d2fh4.normalizeColor)(theme.global.input.readOnly.border.color, theme)));
    if (theme != null && (_theme$global$input$r2 = theme.global.input.readOnly) != null && _theme$global$input$r2.background) styles.push((0, $jQHd2.backgroundStyle)((_theme$global$input$r3 = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r3.background, theme));
    return styles;
};

});


parcelRegister("kWc9K", function(module, exports) {

$parcel$export(module.exports, "TextInputPropTypes", () => $f3e2a76484c6e3de$export$2cabbaef9a75cbd2);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0


var $f3e2a76484c6e3de$var$PropType = {};
var $f3e2a76484c6e3de$export$2cabbaef9a75cbd2 = $f3e2a76484c6e3de$var$PropType;

});

parcelRegister("eblDL", function(module, exports) {

$parcel$export(module.exports, "CopyButton", () => $a532e1154c460457$export$4f2558dd25106ae2);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $lfATC = parcelRequire("lfATC");

var $a26J5 = parcelRequire("a26J5");

var $79HTA = parcelRequire("79HTA");

var $2O6LY = parcelRequire("2O6LY");

var $eL6w3 = parcelRequire("eL6w3");
function $a532e1154c460457$var$_extends() {
    return $a532e1154c460457$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a532e1154c460457$var$_extends.apply(null, arguments);
}
// to overcome `plain` styling due to (icon && !label) condition
// in buttons without theme.button.default, apply the padding here
var $a532e1154c460457$var$StyledButton = (0, $f5efw.default)((0, $a26J5.Button)).withConfig({
    displayName: "CopyButton__StyledButton",
    componentId: "sc-1bp1m18-0"
})([
    "border-radius:",
    ";",
    ""
], function(props) {
    return props.theme.global.control.border.radius;
}, function(props) {
    return !props.theme.button["default"] ? (0, $2O6LY.edgeStyle)('padding', props.pad, false, undefined, props.theme) : '';
});
var $a532e1154c460457$export$4f2558dd25106ae2 = function CopyButton(_ref) {
    var _theme$textInput, _theme$global$input$p, _theme$global$input$p2, _theme$global$input$p3;
    var disabled = _ref.disabled, onClickCopy = _ref.onClickCopy, onBlurCopy = _ref.onBlurCopy, readOnlyCopyPrompt = _ref.readOnlyCopyPrompt, tip = _ref.tip, value = _ref.value;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var CopyIcon = ((_theme$textInput = theme.textInput) == null || (_theme$textInput = _theme$textInput.icons) == null ? void 0 : _theme$textInput.copy) || (0, $lfATC.Copy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $79HTA.Tip), {
        dropProps: {
            align: {
                bottom: 'top'
            }
        },
        content: tip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($a532e1154c460457$var$StyledButton, $a532e1154c460457$var$_extends({
        disabled: disabled,
        onClick: onClickCopy,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(CopyIcon, null),
        pad: {
            horizontal: (_theme$global$input$p = theme.global.input.padding) == null ? void 0 : _theme$global$input$p.horizontal,
            left: (_theme$global$input$p2 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p2.left,
            right: (_theme$global$input$p3 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p3.right,
            // only apply horizontal padding since button will
            // fill height of input
            top: '0',
            bottom: '0'
        },
        onBlur: onBlurCopy,
        onMouseOut: onBlurCopy,
        "aria-label": readOnlyCopyPrompt + " " + value
    }, passThemeFlag)));
};

});
parcelRegister("lfATC", function(module, exports) {

$parcel$export(module.exports, "Copy", () => $f7879e7e004bd2c1$export$92ce62e1201c4fc0, (v) => $f7879e7e004bd2c1$export$92ce62e1201c4fc0 = v);
var $f7879e7e004bd2c1$export$1e511d4a378977f5;
var $f7879e7e004bd2c1$export$92ce62e1201c4fc0;
"use strict";
$f7879e7e004bd2c1$export$1e511d4a378977f5 = true;
$f7879e7e004bd2c1$export$92ce62e1201c4fc0 = void 0;

var $f7879e7e004bd2c1$var$_react = $f7879e7e004bd2c1$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $f7879e7e004bd2c1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f7879e7e004bd2c1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $f7879e7e004bd2c1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $f7879e7e004bd2c1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $f7879e7e004bd2c1$var$_extends() {
    return $f7879e7e004bd2c1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f7879e7e004bd2c1$var$_extends.apply(null, arguments);
}
var $f7879e7e004bd2c1$var$Copy = $f7879e7e004bd2c1$export$92ce62e1201c4fc0 = /*#__PURE__*/ (0, $f7879e7e004bd2c1$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $f7879e7e004bd2c1$var$_react["default"].createElement($xazbe.StyledIcon, $f7879e7e004bd2c1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Copy"
    }, props), /*#__PURE__*/ $f7879e7e004bd2c1$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15h8-8zm0-4h10H9zm0-4h4-4zm7-6v6h6M6 5H2v18h16v-4m4 0H6V1h11l5 5v13z"
    }));
});
$f7879e7e004bd2c1$var$Copy.displayName = 'Copy';

});



parcelRegister("cVvES", function(module, exports) {

$parcel$export(module.exports, "Chat", () => $026dbb50def7ce6c$export$d49dffca20dba6f7);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $026dbb50def7ce6c$var$_extends() {
    return $026dbb50def7ce6c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $026dbb50def7ce6c$var$_extends.apply(null, arguments);
}
var $026dbb50def7ce6c$export$d49dffca20dba6f7 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $026dbb50def7ce6c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Chat"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 1H5a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12l6 5V5a4 4 0 0 0-4-4zm0 6H6m13 4h-9"
    }));
});
$026dbb50def7ce6c$export$d49dffca20dba6f7.displayName = 'Chat';

});

parcelRegister("2YS9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $b835fe37f395370e$export$2e2bcd8739ae039);

var $bs9Uo = parcelRequire("bs9Uo");
// lib/cjs.ts
var $b835fe37f395370e$export$2e2bcd8739ae039 = (0, $bs9Uo.Draggable);

});
parcelRegister("bs9Uo", function(module, exports) {

$parcel$export(module.exports, "Draggable", () => $a4737381b5222d9f$export$f2a139e5d18b9882);
// lib/Draggable.tsx

var $2NacA = parcelRequire("2NacA");

var $lwlwr = parcelRequire("lwlwr");

var $l6sdi = parcelRequire("l6sdi");

var $i9lKE = parcelRequire("i9lKE");
// lib/utils/shims.ts
function $a4737381b5222d9f$var$findInArray(array, callback) {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $a4737381b5222d9f$var$isFunction(func) {
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $a4737381b5222d9f$var$isNum(num) {
    return typeof num === "number" && !isNaN(num);
}
function $a4737381b5222d9f$var$int(a) {
    return parseInt(a, 10);
}
function $a4737381b5222d9f$var$dontSetMe(props, propName, componentName) {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}
// lib/utils/getPrefix.ts
var $a4737381b5222d9f$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $a4737381b5222d9f$var$getPrefix(prop = "transform") {
    var _a, _b;
    if (typeof window === "undefined") return "";
    const style = (_b = (_a = window.document) == null ? void 0 : _a.documentElement) == null ? void 0 : _b.style;
    if (!style) return "";
    if (prop in style) return "";
    for(let i = 0; i < $a4737381b5222d9f$var$prefixes.length; i++){
        if ($a4737381b5222d9f$var$browserPrefixToKey(prop, $a4737381b5222d9f$var$prefixes[i]) in style) return $a4737381b5222d9f$var$prefixes[i];
    }
    return "";
}
function $a4737381b5222d9f$var$browserPrefixToKey(prop, prefix) {
    return prefix ? `${prefix}${$a4737381b5222d9f$var$kebabToTitleCase(prop)}` : prop;
}
function $a4737381b5222d9f$var$kebabToTitleCase(str) {
    let out = "";
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
var $a4737381b5222d9f$var$getPrefix_default = $a4737381b5222d9f$var$getPrefix();
// lib/utils/domFns.ts
var $a4737381b5222d9f$var$matchesSelectorFunc = "";
function $a4737381b5222d9f$var$matchesSelector(el, selector) {
    var _a;
    if (!$a4737381b5222d9f$var$matchesSelectorFunc) $a4737381b5222d9f$var$matchesSelectorFunc = (_a = $a4737381b5222d9f$var$findInArray([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        return $a4737381b5222d9f$var$isFunction(el[method]);
    })) != null ? _a : "";
    const matchFn = el[$a4737381b5222d9f$var$matchesSelectorFunc];
    if (!$a4737381b5222d9f$var$isFunction(matchFn)) return false;
    return Boolean(matchFn.call(el, selector));
}
function $a4737381b5222d9f$var$matchesSelectorAndParentsTo(el, selector, baseNode) {
    let node = el;
    do {
        if ($a4737381b5222d9f$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $a4737381b5222d9f$var$addEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.addEventListener) el.addEventListener(event, listener, options);
    else if (el.attachEvent) el.attachEvent("on" + event, listener);
    else el["on" + event] = listener;
}
function $a4737381b5222d9f$var$removeEvent(el, event, handler, inputOptions) {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    const listener = handler;
    if (el.removeEventListener) el.removeEventListener(event, listener, options);
    else if (el.detachEvent) el.detachEvent("on" + event, listener);
    else el["on" + event] = null;
}
function $a4737381b5222d9f$var$outerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += $a4737381b5222d9f$var$int(computedStyle.borderTopWidth);
    height += $a4737381b5222d9f$var$int(computedStyle.borderBottomWidth);
    return height;
}
function $a4737381b5222d9f$var$outerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += $a4737381b5222d9f$var$int(computedStyle.borderLeftWidth);
    width += $a4737381b5222d9f$var$int(computedStyle.borderRightWidth);
    return width;
}
function $a4737381b5222d9f$var$innerHeight(node) {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= $a4737381b5222d9f$var$int(computedStyle.paddingTop);
    height -= $a4737381b5222d9f$var$int(computedStyle.paddingBottom);
    return height;
}
function $a4737381b5222d9f$var$innerWidth(node) {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= $a4737381b5222d9f$var$int(computedStyle.paddingLeft);
    width -= $a4737381b5222d9f$var$int(computedStyle.paddingRight);
    return width;
}
function $a4737381b5222d9f$var$offsetXYFromParent(evt, offsetParent, scale) {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $a4737381b5222d9f$var$createCSSTransform(controlPos, positionOffset) {
    const translation = $a4737381b5222d9f$var$getTranslation(controlPos, positionOffset, "px");
    return {
        [$a4737381b5222d9f$var$browserPrefixToKey("transform", $a4737381b5222d9f$var$getPrefix_default)]: translation
    };
}
function $a4737381b5222d9f$var$createSVGTransform(controlPos, positionOffset) {
    const translation = $a4737381b5222d9f$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $a4737381b5222d9f$var$getTranslation({ x: x, y: y }, positionOffset, unitSuffix) {
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $a4737381b5222d9f$var$getTouch(e, identifier) {
    return e.targetTouches && $a4737381b5222d9f$var$findInArray(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && $a4737381b5222d9f$var$findInArray(e.changedTouches, (t)=>identifier === t.identifier);
}
function $a4737381b5222d9f$var$getTouchIdentifier(e) {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
function $a4737381b5222d9f$var$getDefaultNonce() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : void 0;
}
function $a4737381b5222d9f$var$addUserSelectStyles(doc, nonce) {
    if (!doc) return;
    let styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        const resolvedNonce = nonce != null ? nonce : $a4737381b5222d9f$var$getDefaultNonce();
        if (resolvedNonce) styleEl.setAttribute("nonce", resolvedNonce);
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $a4737381b5222d9f$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $a4737381b5222d9f$var$scheduleRemoveUserSelectStyles(doc) {
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $a4737381b5222d9f$var$removeUserSelectStyles(doc);
    });
    else $a4737381b5222d9f$var$removeUserSelectStyles(doc);
}
function $a4737381b5222d9f$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $a4737381b5222d9f$var$removeClassName(doc.body, "react-draggable-transparent-selection");
        const ieSelection = doc.selection;
        if (ieSelection) ieSelection.empty();
        else {
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch  {}
}
function $a4737381b5222d9f$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $a4737381b5222d9f$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, "g"), "");
}
// lib/utils/positionFns.ts
function $a4737381b5222d9f$var$getBoundPosition(draggable, x, y) {
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === "string" ? bounds : $a4737381b5222d9f$var$cloneBounds(bounds);
    const node = $a4737381b5222d9f$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        if (!ownerWindow) throw new Error("Cannot resolve the owner window of the draggable node.");
        let boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else {
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl = boundNode;
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        bounds = {
            left: -node.offsetLeft + $a4737381b5222d9f$var$int(boundNodeStyle.paddingLeft) + $a4737381b5222d9f$var$int(nodeStyle.marginLeft),
            top: -node.offsetTop + $a4737381b5222d9f$var$int(boundNodeStyle.paddingTop) + $a4737381b5222d9f$var$int(nodeStyle.marginTop),
            right: $a4737381b5222d9f$var$innerWidth(boundNodeEl) - $a4737381b5222d9f$var$outerWidth(node) - node.offsetLeft + $a4737381b5222d9f$var$int(boundNodeStyle.paddingRight) - $a4737381b5222d9f$var$int(nodeStyle.marginRight),
            bottom: $a4737381b5222d9f$var$innerHeight(boundNodeEl) - $a4737381b5222d9f$var$outerHeight(node) - node.offsetTop + $a4737381b5222d9f$var$int(boundNodeStyle.paddingBottom) - $a4737381b5222d9f$var$int(nodeStyle.marginBottom)
        };
    }
    if ($a4737381b5222d9f$var$isNum(bounds.right)) x = Math.min(x, bounds.right);
    if ($a4737381b5222d9f$var$isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
    if ($a4737381b5222d9f$var$isNum(bounds.left)) x = Math.max(x, bounds.left);
    if ($a4737381b5222d9f$var$isNum(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $a4737381b5222d9f$var$snapToGrid(grid, pendingX, pendingY) {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $a4737381b5222d9f$var$canDragX(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $a4737381b5222d9f$var$canDragY(draggable) {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function $a4737381b5222d9f$var$getControlPosition(e, touchIdentifier, draggableCore) {
    const touchObj = typeof touchIdentifier === "number" ? $a4737381b5222d9f$var$getTouch(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null;
    const node = $a4737381b5222d9f$var$findDOMNode(draggableCore);
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return $a4737381b5222d9f$var$offsetXYFromParent(touchObj || e, offsetParent, draggableCore.props.scale);
}
function $a4737381b5222d9f$var$createCoreData(draggable, x, y) {
    const isStart = !$a4737381b5222d9f$var$isNum(draggable.lastX);
    const node = $a4737381b5222d9f$var$findDOMNode(draggable);
    if (isStart) return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
function $a4737381b5222d9f$var$createDraggableData(draggable, coreData) {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
function $a4737381b5222d9f$var$cloneBounds(bounds) {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $a4737381b5222d9f$var$findDOMNode(draggable) {
    const node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
    return node;
}
// lib/utils/log.ts
var $a4737381b5222d9f$var$log = function noop() {};
var $a4737381b5222d9f$var$log_default = $a4737381b5222d9f$var$log;
// lib/DraggableCore.tsx
var $a4737381b5222d9f$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
};
var $a4737381b5222d9f$var$dragEventFor = $a4737381b5222d9f$var$eventsFor.mouse;
var $a4737381b5222d9f$export$512ffe43e525b6fc = class extends $2NacA.Component {
    constructor(){
        super(...arguments);
        this.dragging = false;
        // Used while dragging to determine deltas.
        this.lastX = NaN;
        this.lastY = NaN;
        this.touchIdentifier = null;
        this.mounted = false;
        this.handleDragStart = (e)=>{
            this.props.onMouseDown(e);
            if (!this.props.allowAnyClick && (typeof e.button === "number" && e.button !== 0 || e.ctrlKey)) return false;
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            const { ownerDocument: ownerDocument } = thisNode;
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !$a4737381b5222d9f$var$matchesSelectorAndParentsTo(e.target, this.props.handle, thisNode) || this.props.cancel && $a4737381b5222d9f$var$matchesSelectorAndParentsTo(e.target, this.props.cancel, thisNode)) return;
            if (e.type === "touchstart" && !this.props.allowMobileScroll) e.preventDefault();
            const touchIdentifier = $a4737381b5222d9f$var$getTouchIdentifier(e);
            this.touchIdentifier = touchIdentifier;
            const position = $a4737381b5222d9f$var$getControlPosition(e, touchIdentifier, this);
            if (position == null) return;
            const { x: x, y: y } = position;
            const coreEvent = $a4737381b5222d9f$var$createCoreData(this, x, y);
            $a4737381b5222d9f$var$log_default("DraggableCore: handleDragStart: %j", coreEvent);
            $a4737381b5222d9f$var$log_default("calling", this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            if (this.props.enableUserSelectHack) $a4737381b5222d9f$var$addUserSelectStyles(ownerDocument, this.props.nonce);
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            $a4737381b5222d9f$var$addEvent(ownerDocument, $a4737381b5222d9f$var$dragEventFor.move, this.handleDrag);
            $a4737381b5222d9f$var$addEvent(ownerDocument, $a4737381b5222d9f$var$dragEventFor.stop, this.handleDragStop);
        };
        this.handleDrag = (e)=>{
            const position = $a4737381b5222d9f$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = $a4737381b5222d9f$var$snapToGrid(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return;
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $a4737381b5222d9f$var$createCoreData(this, x, y);
            $a4737381b5222d9f$var$log_default("DraggableCore: handleDrag: %j", coreEvent);
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    this.handleDragStop(new MouseEvent("mouseup"));
                } catch  {
                    const event = document.createEvent("MouseEvents");
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        };
        this.handleDragStop = (e)=>{
            if (!this.dragging) return;
            const position = $a4737381b5222d9f$var$getControlPosition(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = $a4737381b5222d9f$var$snapToGrid(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX;
                y = this.lastY + deltaY;
            }
            const coreEvent = $a4737381b5222d9f$var$createCoreData(this, x, y);
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) {
                if (this.props.enableUserSelectHack) $a4737381b5222d9f$var$scheduleRemoveUserSelectStyles(thisNode.ownerDocument);
            }
            $a4737381b5222d9f$var$log_default("DraggableCore: handleDragStop: %j", coreEvent);
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                $a4737381b5222d9f$var$log_default("DraggableCore: Removing handlers");
                $a4737381b5222d9f$var$removeEvent(thisNode.ownerDocument, $a4737381b5222d9f$var$dragEventFor.move, this.handleDrag);
                $a4737381b5222d9f$var$removeEvent(thisNode.ownerDocument, $a4737381b5222d9f$var$dragEventFor.stop, this.handleDragStop);
            }
        };
        this.onMouseDown = (e)=>{
            $a4737381b5222d9f$var$dragEventFor = $a4737381b5222d9f$var$eventsFor.mouse;
            return this.handleDragStart(e);
        };
        this.onMouseUp = (e)=>{
            $a4737381b5222d9f$var$dragEventFor = $a4737381b5222d9f$var$eventsFor.mouse;
            return this.handleDragStop(e);
        };
        // Same as onMouseDown (start drag), but now consider this a touch device.
        this.onTouchStart = (e)=>{
            $a4737381b5222d9f$var$dragEventFor = $a4737381b5222d9f$var$eventsFor.touch;
            return this.handleDragStart(e);
        };
        this.onTouchEnd = (e)=>{
            $a4737381b5222d9f$var$dragEventFor = $a4737381b5222d9f$var$eventsFor.touch;
            return this.handleDragStop(e);
        };
    }
    componentDidMount() {
        this.mounted = true;
        const thisNode = this.findDOMNode();
        if (thisNode) $a4737381b5222d9f$var$addEvent(thisNode, $a4737381b5222d9f$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            $a4737381b5222d9f$var$removeEvent(ownerDocument, $a4737381b5222d9f$var$eventsFor.mouse.move, this.handleDrag);
            $a4737381b5222d9f$var$removeEvent(ownerDocument, $a4737381b5222d9f$var$eventsFor.touch.move, this.handleDrag);
            $a4737381b5222d9f$var$removeEvent(ownerDocument, $a4737381b5222d9f$var$eventsFor.mouse.stop, this.handleDragStop);
            $a4737381b5222d9f$var$removeEvent(ownerDocument, $a4737381b5222d9f$var$eventsFor.touch.stop, this.handleDragStop);
            $a4737381b5222d9f$var$removeEvent(thisNode, $a4737381b5222d9f$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) $a4737381b5222d9f$var$scheduleRemoveUserSelectStyles(ownerDocument);
        }
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($l6sdi)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        $a4737381b5222d9f$var$log_default("react-draggable: ReactDOM.findDOMNode is not available in React 19+. You must provide a nodeRef prop. See: https://github.com/react-grid-layout/react-draggable#noderef");
        return null;
    }
    render() {
        return $2NacA.cloneElement($2NacA.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
};
$a4737381b5222d9f$export$512ffe43e525b6fc.displayName = "DraggableCore";
// Both the annotation and the `?` are load-bearing:
//  - The index-signature annotation stops tsc from inferring the
//    PropTypes.Requireable<...> types and emitting `import PropTypes from
//    'prop-types'` into the generated public .d.ts, which would force consumers
//    to install @types/prop-types (the v4.5.0 hand-written typings had none).
//  - The `?` keeps `propTypes` from being a *required* member of the public
//    type. React <= 18's JSX LibraryManagedAttributes only consults a
//    component's `propTypes` when it is required (`C extends {propTypes: ...}`);
//    when it does, this index-signature `propTypes` makes `defaultProps` stop
//    marking props optional, so consumers are forced to pass every prop.
//    Optional dodges that branch; React 19 ignores `propTypes` entirely. The
//    typings/tsconfig.react18.json check guards against a regression here.
// Do not remove. See lib/Draggable.tsx for the same guard.
$a4737381b5222d9f$export$512ffe43e525b6fc.propTypes = {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).object,
    /**
   * `nonce` is applied to the dynamically-injected <style> element used by the
   * user-select hack, so it isn't blocked under a strict Content Security
   * Policy (`style-src` without `'unsafe-inline'`). If omitted, webpack's
   * `__webpack_nonce__` global is used when available.
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $a4737381b5222d9f$var$dontSetMe,
    style: $a4737381b5222d9f$var$dontSetMe,
    transform: $a4737381b5222d9f$var$dontSetMe
};
// Typed as the full `DraggableCoreProps` (not just the default-provided subset)
// so React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$a4737381b5222d9f$export$512ffe43e525b6fc.defaultProps = {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
};
// lib/Draggable.tsx
var $a4737381b5222d9f$export$f2a139e5d18b9882 = class extends $2NacA.Component {
    constructor(props){
        super(props);
        this.onDragStart = (e, coreData)=>{
            $a4737381b5222d9f$var$log_default("Draggable: onDragStart: %j", coreData);
            const shouldStart = this.props.onStart(e, $a4737381b5222d9f$var$createDraggableData(this, coreData));
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        };
        this.onDrag = (e, coreData)=>{
            if (!this.state.dragging) return false;
            $a4737381b5222d9f$var$log_default("Draggable: onDrag: %j", coreData);
            const uiData = $a4737381b5222d9f$var$createDraggableData(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            if (this.props.bounds) {
                const { x: x, y: y } = newState;
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                const [newStateX, newStateY] = $a4737381b5222d9f$var$getBoundPosition(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        };
        this.onDragStop = (e, coreData)=>{
            if (!this.state.dragging) return false;
            const shouldContinue = this.props.onStop(e, $a4737381b5222d9f$var$createDraggableData(this, coreData));
            if (shouldContinue === false) return false;
            $a4737381b5222d9f$var$log_default("Draggable: onDragStop: %j", coreData);
            const newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        };
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps({ position: position }, { prevPropsPosition: prevPropsPosition }) {
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            $a4737381b5222d9f$var$log_default("Draggable: getDerivedStateFromProps %j", {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        });
    }
    // React 19 removed ReactDOM.findDOMNode, so nodeRef is now required.
    // For backward compatibility with React 18 and earlier, we still support findDOMNode if available.
    findDOMNode() {
        var _a;
        if ((_a = this.props) == null ? void 0 : _a.nodeRef) return this.props.nodeRef.current;
        const legacyReactDOM = (0, (/*@__PURE__*/$parcel$interopDefault($l6sdi)));
        if (typeof legacyReactDOM.findDOMNode === "function") return legacyReactDOM.findDOMNode(this);
        return null;
    }
    render() {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: $a4737381b5222d9f$var$canDragX(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: $a4737381b5222d9f$var$canDragY(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) svgTransform = $a4737381b5222d9f$var$createSVGTransform(transformOpts, positionOffset);
        else style = $a4737381b5222d9f$var$createCSSTransform(transformOpts, positionOffset);
        const onlyChild = $2NacA.Children.only(children);
        const className = (0, $i9lKE.clsx)(onlyChild.props.className || "", defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        return /* @__PURE__ */ $2NacA.createElement($a4737381b5222d9f$export$512ffe43e525b6fc, {
            ...draggableCoreProps,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }, $2NacA.cloneElement(onlyChild, {
            className: className,
            style: {
                ...onlyChild.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
};
$a4737381b5222d9f$export$f2a139e5d18b9882.displayName = "Draggable";
// Both the annotation and the `?` are load-bearing:
//  - The index-signature annotation stops tsc from inferring the
//    PropTypes.Requireable<...> types and emitting `import PropTypes from
//    'prop-types'` into the generated public .d.ts, which would force consumers
//    to install @types/prop-types (the v4.5.0 hand-written typings had none).
//  - The `?` keeps `propTypes` from being a *required* member of the public
//    type. React <= 18's JSX LibraryManagedAttributes only consults a
//    component's `propTypes` when it is required (`C extends {propTypes: ...}`);
//    when it does, this index-signature `propTypes` makes `defaultProps` stop
//    marking props optional, so consumers are forced to pass every prop.
//    Optional dodges that branch; React 19 ignores `propTypes` entirely. The
//    typings/tsconfig.react18.json check guards against a regression here.
// Do not remove. See lib/DraggableCore.tsx for the same guard.
$a4737381b5222d9f$export$f2a139e5d18b9882.propTypes = {
    // Accepts all props <DraggableCore> accepts.
    ...$a4737381b5222d9f$export$512ffe43e525b6fc.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
            left: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            right: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            top: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            bottom: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            false
        ])
    ]),
    defaultClassName: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    defaultClassNameDragging: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    defaultClassNameDragged: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number
    }),
    positionOffset: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $a4737381b5222d9f$var$dontSetMe,
    style: $a4737381b5222d9f$var$dontSetMe,
    transform: $a4737381b5222d9f$var$dontSetMe
};
// Typed as the full `DraggableProps` (not just the default-provided subset) so
// React's JSX LibraryManagedAttributes treats EVERY prop as optional for
// consumers, matching the historical hand-written typings. At runtime only the
// default-able props are actually populated.
$a4737381b5222d9f$export$f2a139e5d18b9882.defaultProps = {
    ...$a4737381b5222d9f$export$512ffe43e525b6fc.defaultProps,
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
};

});
parcelRegister("i9lKE", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $69242642a625b4d1$export$4f5d2d50c9deca37);
function $69242642a625b4d1$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $69242642a625b4d1$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $69242642a625b4d1$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $69242642a625b4d1$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $69242642a625b4d1$export$2e2bcd8739ae039 = $69242642a625b4d1$export$4f5d2d50c9deca37;

});




parcelRegister("f6hJT", function(module, exports) {

$parcel$export(module.exports, "SupportChat", () => $98471fa0f5ddde6c$export$616b2c96b9b691e);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $kS7Ii = parcelRequire("kS7Ii");

var $2NacA = parcelRequire("2NacA");

var $1Dexz = parcelRequire("1Dexz");
parcelRequire("hcQWc");
var $d18Ah = parcelRequire("d18Ah");

var $eLUFj = parcelRequire("eLUFj");
const $98471fa0f5ddde6c$export$616b2c96b9b691e = ({ setMessageState: setMessageState, messageToSend: messageToSend, conversationId: conversationId, updateConversations: updateConversations, addConversation: addConversation, onTyping: onTyping })=>{
    const userStore = (0, $8DltC.useUserStore)();
    const queryParams = {
        c: conversationId
    };
    const { sendJsonMessage: sendJsonMessage, lastMessage: lastMessage, readyState: readyState } = (0, (/*@__PURE__*/$parcel$interopDefault($1Dexz)))(`${(0, $eLUFj.env).apiWsHost}:${(0, $eLUFj.env).apiPort}`, {
        queryParams: queryParams,
        protocols: [
            'Authorization',
            userStore.token
        ],
        onError: (e)=>{
            console.log('error', e);
        },
        share: true
    });
    (0, $2NacA.useEffect)(()=>{
        if (lastMessage !== null) {
            const data = lastMessage.data;
            const msgJson = JSON.parse(data);
            if (msgJson.type === (0, $d18Ah.MessageType).NOTIFICATION) return;
            switch(msgJson.type){
                case (0, $d18Ah.MessageType).NEW_CONVERSATION:
                    addConversation && addConversation(msgJson.conversation);
                    break;
                case (0, $d18Ah.MessageType).UPDATED_CONVERSATION:
                    updateConversations && updateConversations(msgJson.conversation);
                    break;
                case (0, $d18Ah.MessageType).TYPING:
                    onTyping && onTyping(msgJson);
                    break;
                default:
                    setMessageState((state)=>({
                            ...state,
                            messages: [
                                ...state.messages,
                                {
                                    ...msgJson
                                }
                            ],
                            conversationId: msgJson.conversation_id
                        }));
            }
        }
    }, [
        lastMessage
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (messageToSend) sendJsonMessage(messageToSend);
    }, [
        messageToSend
    ]);
    const connectionStatus = {
        [(0, $1Dexz.ReadyState).CONNECTING]: 'Connecting',
        [(0, $1Dexz.ReadyState).OPEN]: 'Open',
        [(0, $1Dexz.ReadyState).CLOSING]: 'Closing',
        [(0, $1Dexz.ReadyState).CLOSED]: 'Closed',
        [(0, $1Dexz.ReadyState).UNINSTANTIATED]: 'Uninstantiated'
    }[readyState];
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
        margin: {
            horizontal: 'small'
        },
        size: "xsmall",
        alignSelf: "start",
        children: [
            ' ',
            "Support chat is: ",
            connectionStatus,
            ". Channel: ",
            conversationId,
            ".",
            ' '
        ]
    });
};

});
parcelRegister("1Dexz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetGlobalState = module.exports.useEventSource = module.exports.ReadyState = module.exports.useSocketIO = module.exports.default = void 0;

var $ffecW = parcelRequire("ffecW");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ffecW.useWebSocket;
    }
});

var $hyR8g = parcelRequire("hyR8g");
Object.defineProperty(module.exports, "useSocketIO", {
    enumerable: true,
    get: function() {
        return $hyR8g.useSocketIO;
    }
});

var $8rWRG = parcelRequire("8rWRG");
Object.defineProperty(module.exports, "ReadyState", {
    enumerable: true,
    get: function() {
        return $8rWRG.ReadyState;
    }
});

var $fRj9l = parcelRequire("fRj9l");
Object.defineProperty(module.exports, "useEventSource", {
    enumerable: true,
    get: function() {
        return $fRj9l.useEventSource;
    }
});

var $5U2i0 = parcelRequire("5U2i0");
Object.defineProperty(module.exports, "resetGlobalState", {
    enumerable: true,
    get: function() {
        return $5U2i0.resetGlobalState;
    }
});

});
parcelRegister("ffecW", function(module, exports) {
"use strict";
var $b1934714922177b1$var$__assign = module.exports && module.exports.__assign || function() {
    $b1934714922177b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b1934714922177b1$var$__assign.apply(this, arguments);
};
var $b1934714922177b1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b1934714922177b1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b1934714922177b1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useWebSocket = void 0;

var $2NacA = parcelRequire("2NacA");

var $l6sdi = parcelRequire("l6sdi");

var $8rWRG = parcelRequire("8rWRG");

var $h9opH = parcelRequire("h9opH");

var $aP3Hy = parcelRequire("aP3Hy");

var $b1934714922177b1$var$proxy_1 = $b1934714922177b1$var$__importDefault((parcelRequire("fCeHZ")));

var $5U2i0 = parcelRequire("5U2i0");
var $b1934714922177b1$var$useWebSocket = function(url, options, connect) {
    if (options === void 0) options = $8rWRG.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = (0, $2NacA.useState)(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = (0, $2NacA.useState)({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = (0, $2NacA.useMemo)(function() {
        if (!options.disableJson && lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return $8rWRG.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage,
        options.disableJson
    ]);
    var convertedUrl = (0, $2NacA.useRef)(null);
    var webSocketRef = (0, $2NacA.useRef)(null);
    var startRef = (0, $2NacA.useRef)(function() {
        return void 0;
    });
    var reconnectCount = (0, $2NacA.useRef)(0);
    var lastMessageTime = (0, $2NacA.useRef)(Date.now());
    var messageQueue = (0, $2NacA.useRef)([]);
    var webSocketProxy = (0, $2NacA.useRef)(null);
    var optionsCache = (0, $2NacA.useRef)(options);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? $8rWRG.ReadyState.CONNECTING : $8rWRG.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = (0, $2NacA.useCallback)(function(message, keep) {
        var _a;
        if (keep === void 0) keep = true;
        if ($8rWRG.isEventSourceSupported && webSocketRef.current instanceof EventSource) {
            console.warn('Unable to send a message from an eventSource');
            return;
        }
        if (((_a = webSocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) === $8rWRG.ReadyState.OPEN) {
            (0, $5U2i0.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketRef.current.send(message);
        } else if (keep) messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = (0, $2NacA.useCallback)(function(message, keep) {
        if (keep === void 0) keep = true;
        sendMessage(JSON.stringify(message), keep);
    }, [
        sendMessage
    ]);
    var getWebSocket = (0, $2NacA.useCallback)(function() {
        if (optionsCache.current.share !== true || $8rWRG.isEventSourceSupported && webSocketRef.current instanceof EventSource) return webSocketRef.current;
        if (webSocketProxy.current === null && webSocketRef.current) {
            (0, $5U2i0.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketProxy.current = (0, $b1934714922177b1$var$proxy_1.default)(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, []);
    (0, $2NacA.useEffect)(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var createOrJoin_1 = true;
            var start_1 = function() {
                return $b1934714922177b1$var$__awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return $b1934714922177b1$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    (0, $aP3Hy.getUrl)(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                if (convertedUrl.current === null) {
                                    console.error('Failed to get a valid URL. WebSocket connection aborted.');
                                    convertedUrl.current = 'ABORTED';
                                    (0, $l6sdi.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            return $b1934714922177b1$var$__assign($b1934714922177b1$var$__assign({}, prev), {
                                                ABORTED: $8rWRG.ReadyState.CLOSED
                                            });
                                        });
                                    });
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) (0, $l6sdi.flushSync)(function() {
                                        return setLastMessage(message);
                                    });
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) (0, $l6sdi.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            var _a;
                                            return $b1934714922177b1$var$__assign($b1934714922177b1$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = state, _a));
                                        });
                                    });
                                };
                                if (createOrJoin_1) removeListeners_1 = (0, $h9opH.createOrJoinSocket)(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount, lastMessageTime, sendMessage);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                    start_1();
                }
            };
            start_1();
            return function() {
                expectClose_1 = true;
                createOrJoin_1 = false;
                if (webSocketProxy.current) webSocketProxy.current = null;
                removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                setLastMessage(null);
            };
        } else if (url === null || connect === false) {
            reconnectCount.current = 0; // reset reconnection attempts
            setReadyState(function(prev) {
                var _a;
                return $b1934714922177b1$var$__assign($b1934714922177b1$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = $8rWRG.ReadyState.CLOSED, _a));
            });
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        sendMessage
    ]);
    (0, $2NacA.useEffect)(function() {
        if (readyStateFromUrl === $8rWRG.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};
module.exports.useWebSocket = $b1934714922177b1$var$useWebSocket;

});
parcelRegister("8rWRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEventSourceSupported = module.exports.isReactNative = module.exports.ReadyState = module.exports.DEFAULT_HEARTBEAT = module.exports.UNPARSABLE_JSON_OBJECT = module.exports.DEFAULT_RECONNECT_INTERVAL_MS = module.exports.DEFAULT_RECONNECT_LIMIT = module.exports.SOCKET_IO_PING_CODE = module.exports.SOCKET_IO_PATH = module.exports.SOCKET_IO_PING_INTERVAL = module.exports.DEFAULT_EVENT_SOURCE_OPTIONS = module.exports.EMPTY_EVENT_HANDLERS = module.exports.DEFAULT_OPTIONS = void 0;
var $626e81a859fa6654$var$MILLISECONDS = 1;
var $626e81a859fa6654$var$SECONDS = 1000 * $626e81a859fa6654$var$MILLISECONDS;
module.exports.DEFAULT_OPTIONS = {};
module.exports.EMPTY_EVENT_HANDLERS = {};
module.exports.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: false,
    events: module.exports.EMPTY_EVENT_HANDLERS
};
module.exports.SOCKET_IO_PING_INTERVAL = 25 * $626e81a859fa6654$var$SECONDS;
module.exports.SOCKET_IO_PATH = '/socket.io/?EIO=3&transport=websocket';
module.exports.SOCKET_IO_PING_CODE = '2';
module.exports.DEFAULT_RECONNECT_LIMIT = 20;
module.exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
module.exports.UNPARSABLE_JSON_OBJECT = {};
module.exports.DEFAULT_HEARTBEAT = {
    message: 'ping',
    timeout: 60000,
    interval: 25000
};
var $626e81a859fa6654$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})($626e81a859fa6654$var$ReadyState || (module.exports.ReadyState = $626e81a859fa6654$var$ReadyState = {}));
var $626e81a859fa6654$var$eventSourceSupported = function() {
    try {
        return 'EventSource' in globalThis;
    } catch (e) {
        return false;
    }
};
module.exports.isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
module.exports.isEventSourceSupported = !module.exports.isReactNative && $626e81a859fa6654$var$eventSourceSupported();

});

parcelRegister("h9opH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createOrJoinSocket = void 0;

var $9Izbx = parcelRequire("9Izbx");

var $8rWRG = parcelRequire("8rWRG");

var $1bTdE = parcelRequire("1bTdE");

var $5S1HI = parcelRequire("5S1HI");

var $aiFfc = parcelRequire("aiFfc");
//TODO ensure that all onClose callbacks are called
var $c7c636f7ffa60107$var$cleanSubscribers = function(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval) {
    return function() {
        (0, $aiFfc.removeSubscriber)(url, subscriber);
        if (!(0, $aiFfc.hasSubscribers)(url)) {
            try {
                var socketLike = $9Izbx.sharedWebSockets[url];
                if (socketLike instanceof WebSocket) socketLike.onclose = function(event) {
                    if (optionsRef.current.onClose) optionsRef.current.onClose(event);
                    setReadyState($8rWRG.ReadyState.CLOSED);
                };
                socketLike.close();
            } catch (e) {}
            if (clearSocketIoPingInterval) clearSocketIoPingInterval();
            delete $9Izbx.sharedWebSockets[url];
        }
    };
};
var $c7c636f7ffa60107$var$createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount, lastMessageTime, sendMessage) {
    if (!$8rWRG.isEventSourceSupported && optionsRef.current.eventSourceOptions) {
        if ($8rWRG.isReactNative) throw new Error('EventSource is not supported in ReactNative');
        else throw new Error('EventSource is not supported');
    }
    if (optionsRef.current.share) {
        var clearSocketIoPingInterval = null;
        if ($9Izbx.sharedWebSockets[url] === undefined) {
            $9Izbx.sharedWebSockets[url] = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
            webSocketRef.current = $9Izbx.sharedWebSockets[url];
            setReadyState($8rWRG.ReadyState.CONNECTING);
            clearSocketIoPingInterval = (0, $5S1HI.attachSharedListeners)($9Izbx.sharedWebSockets[url], url, optionsRef, sendMessage);
        } else {
            webSocketRef.current = $9Izbx.sharedWebSockets[url];
            setReadyState($9Izbx.sharedWebSockets[url].readyState);
        }
        var subscriber = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            lastMessageTime: lastMessageTime,
            reconnect: startRef
        };
        (0, $aiFfc.addSubscriber)(url, subscriber);
        return $c7c636f7ffa60107$var$cleanSubscribers(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval);
    } else {
        webSocketRef.current = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
        setReadyState($8rWRG.ReadyState.CONNECTING);
        if (!webSocketRef.current) throw new Error('WebSocket failed to be created');
        return (0, $1bTdE.attachListeners)(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount, lastMessageTime, sendMessage);
    }
};
module.exports.createOrJoinSocket = $c7c636f7ffa60107$var$createOrJoinSocket;

});
parcelRegister("9Izbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetWebSockets = module.exports.sharedWebSockets = void 0;
module.exports.sharedWebSockets = {};
var $713384200b24a780$var$resetWebSockets = function(url) {
    if (url && module.exports.sharedWebSockets.hasOwnProperty(url)) delete module.exports.sharedWebSockets[url];
    else {
        for(var url_1 in module.exports.sharedWebSockets)if (module.exports.sharedWebSockets.hasOwnProperty(url_1)) delete module.exports.sharedWebSockets[url_1];
    }
};
module.exports.resetWebSockets = $713384200b24a780$var$resetWebSockets;

});

parcelRegister("1bTdE", function(module, exports) {
"use strict";
var $0de1a6ec1172592c$var$__assign = module.exports && module.exports.__assign || function() {
    $0de1a6ec1172592c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0de1a6ec1172592c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attachListeners = void 0;

var $8GAab = parcelRequire("8GAab");

var $l0YEI = parcelRequire("l0YEI");

var $8rWRG = parcelRequire("8rWRG");

var $5U2i0 = parcelRequire("5U2i0");
var $0de1a6ec1172592c$var$bindMessageHandler = function(webSocketInstance, optionsRef, setLastMessage, lastMessageTime) {
    webSocketInstance.onmessage = function(message) {
        var _a;
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof (lastMessageTime === null || lastMessageTime === void 0 ? void 0 : lastMessageTime.current) === 'number') lastMessageTime.current = Date.now();
        if (typeof optionsRef.current.filter === 'function' && optionsRef.current.filter(message) !== true) return;
        if (optionsRef.current.heartbeat && typeof optionsRef.current.heartbeat !== "boolean" && ((_a = optionsRef.current.heartbeat) === null || _a === void 0 ? void 0 : _a.returnMessage) === message.data) return;
        setLastMessage(message);
    };
};
var $0de1a6ec1172592c$var$bindOpenHandler = function(webSocketInstance, optionsRef, setReadyState, reconnectCount, lastMessageTime) {
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState($8rWRG.ReadyState.OPEN);
        //start heart beat here
        if (optionsRef.current.heartbeat && webSocketInstance instanceof WebSocket) {
            var heartbeatOptions = typeof optionsRef.current.heartbeat === "boolean" ? undefined : optionsRef.current.heartbeat;
            lastMessageTime.current = Date.now();
            (0, $l0YEI.heartbeat)(webSocketInstance, lastMessageTime, heartbeatOptions);
        }
    };
};
var $0de1a6ec1172592c$var$bindCloseHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    if ($8rWRG.isEventSourceSupported && webSocketInstance instanceof EventSource) return function() {};
    (0, $5U2i0.assertIsWebSocket)(webSocketInstance, optionsRef.current.skipAssert);
    var reconnectTimeout;
    webSocketInstance.onclose = function(event) {
        var _a;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState($8rWRG.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $8rWRG.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === 'function' ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $8rWRG.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $0de1a6ec1172592c$var$bindErrorHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    var reconnectTimeout;
    webSocketInstance.onerror = function(error) {
        var _a;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if ($8rWRG.isEventSourceSupported && webSocketInstance instanceof EventSource) {
            optionsRef.current.onClose && optionsRef.current.onClose($0de1a6ec1172592c$var$__assign($0de1a6ec1172592c$var$__assign({}, error), {
                code: 1006,
                reason: "An error occurred with the EventSource: ".concat(error),
                wasClean: false
            }));
            setReadyState($8rWRG.ReadyState.CLOSED);
            webSocketInstance.close();
        }
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $8rWRG.DEFAULT_RECONNECT_LIMIT)) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === 'function' ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $8rWRG.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(optionsRef.current.reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(optionsRef.current.reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $0de1a6ec1172592c$var$attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount, lastMessageTime, sendMessage) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var cancelReconnectOnClose;
    var cancelReconnectOnError;
    if (optionsRef.current.fromSocketIO) interval = (0, $8GAab.setUpSocketIOPing)(sendMessage);
    $0de1a6ec1172592c$var$bindMessageHandler(webSocketInstance, optionsRef, setLastMessage, lastMessageTime);
    $0de1a6ec1172592c$var$bindOpenHandler(webSocketInstance, optionsRef, setReadyState, reconnectCount, lastMessageTime);
    cancelReconnectOnClose = $0de1a6ec1172592c$var$bindCloseHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    cancelReconnectOnError = $0de1a6ec1172592c$var$bindErrorHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    return function() {
        setReadyState($8rWRG.ReadyState.CLOSING);
        cancelReconnectOnClose();
        cancelReconnectOnError();
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};
module.exports.attachListeners = $0de1a6ec1172592c$var$attachListeners;

});
parcelRegister("8GAab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setUpSocketIOPing = module.exports.appendQueryParams = module.exports.parseSocketIOUrl = void 0;

var $8rWRG = parcelRequire("8rWRG");
var $652e4c3ffa37f1b0$var$parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, '');
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, '');
        var protocol = isSecure ? 'wss' : 'ws';
        return "".concat(protocol, "://").concat(removedFinalBackSlack).concat($8rWRG.SOCKET_IO_PATH);
    } else if (url === '') {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? 'wss' : 'ws';
        var port = window.location.port ? ":".concat(window.location.port) : '';
        return "".concat(protocol, "://").concat(window.location.hostname).concat(port).concat($8rWRG.SOCKET_IO_PATH);
    }
    return url;
};
module.exports.parseSocketIOUrl = $652e4c3ffa37f1b0$var$parseSocketIOUrl;
var $652e4c3ffa37f1b0$var$appendQueryParams = function(url, params) {
    if (params === void 0) params = {};
    var hasParamsRegex = /\?([\w]+=[\w]+)/;
    var alreadyHasParams = hasParamsRegex.test(url);
    var stringified = "".concat(Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + "".concat(key, "=").concat(value, "&");
    }, '').slice(0, -1));
    return "".concat(url).concat(alreadyHasParams ? '&' : '?').concat(stringified);
};
module.exports.appendQueryParams = $652e4c3ffa37f1b0$var$appendQueryParams;
var $652e4c3ffa37f1b0$var$setUpSocketIOPing = function(sendMessage, interval) {
    if (interval === void 0) interval = $8rWRG.SOCKET_IO_PING_INTERVAL;
    var ping = function() {
        return sendMessage($8rWRG.SOCKET_IO_PING_CODE);
    };
    return window.setInterval(ping, interval);
};
module.exports.setUpSocketIOPing = $652e4c3ffa37f1b0$var$setUpSocketIOPing;

});

parcelRegister("l0YEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.heartbeat = $f4c8a6061f29ef54$var$heartbeat;

var $8rWRG = parcelRequire("8rWRG");
function $f4c8a6061f29ef54$var$getLastMessageTime(lastMessageTime) {
    if (Array.isArray(lastMessageTime)) return lastMessageTime.reduce(function(p, c) {
        return p.current > c.current ? p : c;
    }).current;
    return lastMessageTime.current;
}
function $f4c8a6061f29ef54$var$heartbeat(ws, lastMessageTime, options) {
    var _a = options || {}, _b = _a.interval, interval = _b === void 0 ? $8rWRG.DEFAULT_HEARTBEAT.interval : _b, _c = _a.timeout, timeout = _c === void 0 ? $8rWRG.DEFAULT_HEARTBEAT.timeout : _c, _d = _a.message, message = _d === void 0 ? $8rWRG.DEFAULT_HEARTBEAT.message : _d;
    // how often check interval between ping messages
    // minimum is 100ms
    // maximum is ${interval / 10}ms
    var intervalCheck = Math.max(100, interval / 10);
    var lastPingSentAt = Date.now();
    var heartbeatInterval = setInterval(function() {
        var timeNow = Date.now();
        var lastMessageReceivedAt = $f4c8a6061f29ef54$var$getLastMessageTime(lastMessageTime);
        if (lastMessageReceivedAt + timeout <= timeNow) {
            console.warn("Heartbeat timed out, closing connection, last message received ".concat(timeNow - lastMessageReceivedAt, "ms ago, last ping sent ").concat(timeNow - lastPingSentAt, "ms ago"));
            ws.close();
        } else {
            if (lastMessageReceivedAt + interval <= timeNow && lastPingSentAt + interval <= timeNow) try {
                if (typeof message === 'function') ws.send(message());
                else ws.send(message);
                lastPingSentAt = timeNow;
            } catch (err) {
                console.error("Heartbeat failed, closing connection", err instanceof Error ? err.message : err);
                ws.close();
            }
        }
    }, intervalCheck);
    ws.addEventListener("close", function() {
        clearInterval(heartbeatInterval);
    });
    return function() {};
}

});

parcelRegister("5U2i0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertIsWebSocket = $44c3f55b746b4576$var$assertIsWebSocket;
module.exports.resetGlobalState = $44c3f55b746b4576$var$resetGlobalState;

var $9Izbx = parcelRequire("9Izbx");

var $aiFfc = parcelRequire("aiFfc");
function $44c3f55b746b4576$var$assertIsWebSocket(webSocketInstance, skip) {
    if (!skip && webSocketInstance instanceof WebSocket === false) throw new Error('');
}
function $44c3f55b746b4576$var$resetGlobalState(url) {
    (0, $aiFfc.resetSubscribers)(url);
    (0, $9Izbx.resetWebSockets)(url);
}

});
parcelRegister("aiFfc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetSubscribers = module.exports.removeSubscriber = module.exports.addSubscriber = module.exports.hasSubscribers = module.exports.getSubscribers = void 0;
var $77fb94090e29398c$var$subscribers = {};
var $77fb94090e29398c$var$EMPTY_LIST = [];
var $77fb94090e29398c$var$getSubscribers = function(url) {
    if ((0, module.exports.hasSubscribers)(url)) return Array.from($77fb94090e29398c$var$subscribers[url]);
    return $77fb94090e29398c$var$EMPTY_LIST;
};
module.exports.getSubscribers = $77fb94090e29398c$var$getSubscribers;
var $77fb94090e29398c$var$hasSubscribers = function(url) {
    var _a;
    return ((_a = $77fb94090e29398c$var$subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
module.exports.hasSubscribers = $77fb94090e29398c$var$hasSubscribers;
var $77fb94090e29398c$var$addSubscriber = function(url, subscriber) {
    $77fb94090e29398c$var$subscribers[url] = $77fb94090e29398c$var$subscribers[url] || new Set();
    $77fb94090e29398c$var$subscribers[url].add(subscriber);
};
module.exports.addSubscriber = $77fb94090e29398c$var$addSubscriber;
var $77fb94090e29398c$var$removeSubscriber = function(url, subscriber) {
    $77fb94090e29398c$var$subscribers[url].delete(subscriber);
};
module.exports.removeSubscriber = $77fb94090e29398c$var$removeSubscriber;
var $77fb94090e29398c$var$resetSubscribers = function(url) {
    if (url && $77fb94090e29398c$var$subscribers.hasOwnProperty(url)) delete $77fb94090e29398c$var$subscribers[url];
    else {
        for(var url_1 in $77fb94090e29398c$var$subscribers)if ($77fb94090e29398c$var$subscribers.hasOwnProperty(url_1)) delete $77fb94090e29398c$var$subscribers[url_1];
    }
};
module.exports.resetSubscribers = $77fb94090e29398c$var$resetSubscribers;

});



parcelRegister("5S1HI", function(module, exports) {
"use strict";
var $44635150727ed0d3$var$__assign = module.exports && module.exports.__assign || function() {
    $44635150727ed0d3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44635150727ed0d3$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attachSharedListeners = void 0;

var $9Izbx = parcelRequire("9Izbx");

var $8rWRG = parcelRequire("8rWRG");

var $aiFfc = parcelRequire("aiFfc");

var $8GAab = parcelRequire("8GAab");

var $l0YEI = parcelRequire("l0YEI");
var $44635150727ed0d3$var$bindMessageHandler = function(webSocketInstance, url, heartbeatOptions) {
    webSocketInstance.onmessage = function(message) {
        (0, $aiFfc.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof ((_a = subscriber === null || subscriber === void 0 ? void 0 : subscriber.lastMessageTime) === null || _a === void 0 ? void 0 : _a.current) === 'number') subscriber.lastMessageTime.current = Date.now();
            if (typeof subscriber.optionsRef.current.filter === 'function' && subscriber.optionsRef.current.filter(message) !== true) return;
            if (heartbeatOptions && typeof heartbeatOptions !== "boolean" && (heartbeatOptions === null || heartbeatOptions === void 0 ? void 0 : heartbeatOptions.returnMessage) === message.data) return;
            subscriber.setLastMessage(message);
        });
    };
};
var $44635150727ed0d3$var$bindOpenHandler = function(webSocketInstance, url, heartbeatOptions) {
    webSocketInstance.onopen = function(event) {
        var subscribers = (0, $aiFfc.getSubscribers)(url);
        subscribers.forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState($8rWRG.ReadyState.OPEN);
            var onMessageCb;
            if (heartbeatOptions && webSocketInstance instanceof WebSocket) subscriber.lastMessageTime.current = Date.now();
        });
        if (heartbeatOptions && webSocketInstance instanceof WebSocket) (0, $l0YEI.heartbeat)(webSocketInstance, subscribers.map(function(subscriber) {
            return subscriber.lastMessageTime;
        }), typeof heartbeatOptions === 'boolean' ? undefined : heartbeatOptions);
    };
};
var $44635150727ed0d3$var$bindCloseHandler = function(webSocketInstance, url) {
    if (webSocketInstance instanceof WebSocket) webSocketInstance.onclose = function(event) {
        (0, $aiFfc.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState($8rWRG.ReadyState.CLOSED);
        });
        delete $9Izbx.sharedWebSockets[url];
        (0, $aiFfc.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $8rWRG.DEFAULT_RECONNECT_LIMIT;
                if (subscriber.reconnectCount.current < reconnectAttempts) {
                    var nextReconnectInterval = typeof subscriber.optionsRef.current.reconnectInterval === 'function' ? subscriber.optionsRef.current.reconnectInterval(subscriber.reconnectCount.current) : subscriber.optionsRef.current.reconnectInterval;
                    setTimeout(function() {
                        subscriber.reconnectCount.current++;
                        subscriber.reconnect.current();
                    }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $8rWRG.DEFAULT_RECONNECT_INTERVAL_MS);
                } else {
                    subscriber.optionsRef.current.onReconnectStop && subscriber.optionsRef.current.onReconnectStop(subscriber.optionsRef.current.reconnectAttempts);
                    console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
                }
            }
        });
    };
};
var $44635150727ed0d3$var$bindErrorHandler = function(webSocketInstance, url) {
    webSocketInstance.onerror = function(error) {
        (0, $aiFfc.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
            if ($8rWRG.isEventSourceSupported && webSocketInstance instanceof EventSource) {
                subscriber.optionsRef.current.onClose && subscriber.optionsRef.current.onClose($44635150727ed0d3$var$__assign($44635150727ed0d3$var$__assign({}, error), {
                    code: 1006,
                    reason: "An error occurred with the EventSource: ".concat(error),
                    wasClean: false
                }));
                subscriber.setReadyState($8rWRG.ReadyState.CLOSED);
            }
        });
        if ($8rWRG.isEventSourceSupported && webSocketInstance instanceof EventSource) webSocketInstance.close();
    };
};
var $44635150727ed0d3$var$attachSharedListeners = function(webSocketInstance, url, optionsRef, sendMessage) {
    var interval;
    if (optionsRef.current.fromSocketIO) interval = (0, $8GAab.setUpSocketIOPing)(sendMessage);
    $44635150727ed0d3$var$bindMessageHandler(webSocketInstance, url, optionsRef.current.heartbeat);
    $44635150727ed0d3$var$bindCloseHandler(webSocketInstance, url);
    $44635150727ed0d3$var$bindOpenHandler(webSocketInstance, url, optionsRef.current.heartbeat);
    $44635150727ed0d3$var$bindErrorHandler(webSocketInstance, url);
    return function() {
        if (interval) clearInterval(interval);
    };
};
module.exports.attachSharedListeners = $44635150727ed0d3$var$attachSharedListeners;

});


parcelRegister("aP3Hy", function(module, exports) {
"use strict";
var $7e1189d4fbccabb8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7e1189d4fbccabb8$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7e1189d4fbccabb8$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUrl = void 0;

var $8GAab = parcelRequire("8GAab");

var $8rWRG = parcelRequire("8rWRG");
var $7e1189d4fbccabb8$var$waitFor = function(duration) {
    return new Promise(function(resolve) {
        return window.setTimeout(resolve, duration);
    });
};
var $7e1189d4fbccabb8$var$getUrl = function(url_1, optionsRef_1) {
    var args_1 = [];
    for(var _i = 2; _i < arguments.length; _i++)args_1[_i - 2] = arguments[_i];
    return $7e1189d4fbccabb8$var$__awaiter(void 0, $7e1189d4fbccabb8$var$__spreadArray([
        url_1,
        optionsRef_1
    ], args_1, true), void 0, function(url, optionsRef, retriedAttempts) {
        var convertedUrl, e_1, reconnectLimit, nextReconnectInterval, parsedUrl, parsedWithQueryParams;
        var _a, _b, _c;
        if (retriedAttempts === void 0) retriedAttempts = 0;
        return $7e1189d4fbccabb8$var$__generator(this, function(_d) {
            switch(_d.label){
                case 0:
                    if (!(typeof url === 'function')) return [
                        3 /*break*/ ,
                        10
                    ];
                    _d.label = 1;
                case 1:
                    _d.trys.push([
                        1,
                        3,
                        ,
                        9
                    ]);
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 2:
                    convertedUrl = _d.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 3:
                    e_1 = _d.sent();
                    if (!optionsRef.current.retryOnError) return [
                        3 /*break*/ ,
                        7
                    ];
                    reconnectLimit = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $8rWRG.DEFAULT_RECONNECT_LIMIT;
                    if (!(retriedAttempts < reconnectLimit)) return [
                        3 /*break*/ ,
                        5
                    ];
                    nextReconnectInterval = typeof optionsRef.current.reconnectInterval === 'function' ? optionsRef.current.reconnectInterval(retriedAttempts) : optionsRef.current.reconnectInterval;
                    return [
                        4 /*yield*/ ,
                        $7e1189d4fbccabb8$var$waitFor(nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $8rWRG.DEFAULT_RECONNECT_INTERVAL_MS)
                    ];
                case 4:
                    _d.sent();
                    return [
                        2 /*return*/ ,
                        (0, module.exports.getUrl)(url, optionsRef, retriedAttempts + 1)
                    ];
                case 5:
                    (_c = (_b = optionsRef.current).onReconnectStop) === null || _c === void 0 || _c.call(_b, retriedAttempts);
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        null
                    ];
                case 8:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 9:
                    return [
                        3 /*break*/ ,
                        11
                    ];
                case 10:
                    convertedUrl = url;
                    _d.label = 11;
                case 11:
                    parsedUrl = optionsRef.current.fromSocketIO ? (0, $8GAab.parseSocketIOUrl)(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? (0, $8GAab.appendQueryParams)(parsedUrl, optionsRef.current.queryParams) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};
module.exports.getUrl = $7e1189d4fbccabb8$var$getUrl;

});

parcelRegister("fCeHZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.websocketWrapper = void 0;
var $b5e5d06f980476d1$var$websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === 'reconnect') return start;
            if (typeof val === 'function') {
                console.error('Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.');
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn('The websocket\'s event handlers should be defined through the options object passed into useWebSocket.');
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
module.exports.websocketWrapper = $b5e5d06f980476d1$var$websocketWrapper;
module.exports.default = module.exports.websocketWrapper;

});


parcelRegister("hyR8g", function(module, exports) {
"use strict";
var $cc8ed399c9ed2470$var$__assign = module.exports && module.exports.__assign || function() {
    $cc8ed399c9ed2470$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc8ed399c9ed2470$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useSocketIO = void 0;

var $2NacA = parcelRequire("2NacA");

var $ffecW = parcelRequire("ffecW");

var $8rWRG = parcelRequire("8rWRG");
var $cc8ed399c9ed2470$var$emptyEvent = {
    type: 'empty',
    payload: null
};
var $cc8ed399c9ed2470$var$getSocketData = function(event) {
    if (!event || !event.data) return $cc8ed399c9ed2470$var$emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return $cc8ed399c9ed2470$var$emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return $cc8ed399c9ed2470$var$emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
var $cc8ed399c9ed2470$var$useSocketIO = function(url, options, connect) {
    if (options === void 0) options = $8rWRG.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = (0, $2NacA.useMemo)(function() {
        return $cc8ed399c9ed2470$var$__assign($cc8ed399c9ed2470$var$__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = (0, $ffecW.useWebSocket)(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = (0, $2NacA.useMemo)(function() {
        return $cc8ed399c9ed2470$var$getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};
module.exports.useSocketIO = $cc8ed399c9ed2470$var$useSocketIO;

});

parcelRegister("fRj9l", function(module, exports) {
"use strict";
var $b8baa8fba6a0841c$var$__assign = module.exports && module.exports.__assign || function() {
    $b8baa8fba6a0841c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8baa8fba6a0841c$var$__assign.apply(this, arguments);
};
var $b8baa8fba6a0841c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useEventSource = void 0;

var $2NacA = parcelRequire("2NacA");

var $ffecW = parcelRequire("ffecW");

var $8rWRG = parcelRequire("8rWRG");
var $b8baa8fba6a0841c$var$useEventSource = function(url, _a, connect) {
    if (_a === void 0) _a = $8rWRG.DEFAULT_EVENT_SOURCE_OPTIONS;
    var withCredentials = _a.withCredentials, events = _a.events, options = $b8baa8fba6a0841c$var$__rest(_a, [
        "withCredentials",
        "events"
    ]);
    if (connect === void 0) connect = true;
    var optionsWithEventSource = $b8baa8fba6a0841c$var$__assign($b8baa8fba6a0841c$var$__assign({}, options), {
        eventSourceOptions: {
            withCredentials: withCredentials
        }
    });
    var eventsRef = (0, $2NacA.useRef)($8rWRG.EMPTY_EVENT_HANDLERS);
    if (events) eventsRef.current = events;
    var _b = (0, $ffecW.useWebSocket)(url, optionsWithEventSource, connect), lastMessage = _b.lastMessage, readyState = _b.readyState, getWebSocket = _b.getWebSocket;
    (0, $2NacA.useEffect)(function() {
        if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) Object.entries(eventsRef.current).forEach(function(_a) {
            var type = _a[0], handler = _a[1];
            if (type === lastMessage.type) handler(lastMessage);
        });
    }, [
        lastMessage
    ]);
    return {
        lastEvent: lastMessage,
        readyState: readyState,
        getEventSource: getWebSocket
    };
};
module.exports.useEventSource = $b8baa8fba6a0841c$var$useEventSource;

});




parcelRegister("35FKQ", function(module, exports) {
$parcel$export(module.exports, "CommercialsPanel", () => (parcelRequire("81cmi")).CommercialsPanel);
$parcel$export(module.exports, "CreateCommercialModal", () => (parcelRequire("bSmn2")).CreateCommercialModal);
parcelRequire("6KWAU");
parcelRequire("81cmi");
parcelRequire("bSmn2");

});
parcelRegister("6KWAU", function(module, exports) {

$parcel$export(module.exports, "CommercialRow", () => $d9e1856d667d49ed$export$7ca0410f65fdf1bf);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("bRT7J");
var $1Ofsp = parcelRequire("1Ofsp");
var $6q7qM = parcelRequire("6q7qM");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");
const $d9e1856d667d49ed$export$7ca0410f65fdf1bf = (0, $j8yBr.observer)(({ commercial: listedCommercial, onChecked: onChecked, checked: checked })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    const commercialStore = (0, $8DltC.useCommercialStore)();
    /** State **/ // Rendered straight from the panel's list. Each row used to refetch its commercial with nine
    // relations it never displays, and showed a blank row until that returned
    const [commercial, setCommercial] = (0, $2NacA.useState)(listedCommercial);
    const [wages, setWages] = (0, $2NacA.useState)(0);
    const [total, setTotal] = (0, $2NacA.useState)(0);
    /** Computed **/ const usageEstimate = estimateStore.getTempUsageEstimate(commercial?.id);
    /** Methods **/ // Reads estimateStore.tempEstimate directly (rather than a value captured during
    // render) so this isn't tracked as a render-time MobX dependency - otherwise every
    // row re-renders whenever *any* commercial's usage estimate is recalculated.
    const recalculateUsageEstimate = async ()=>{
        if (!commercial) return;
        const usageEstimate = estimateStore.tempEstimate?.usage_estimates.find((usageEstimate)=>usageEstimate.commercial?.id === commercial.id);
        if (usageEstimate) await estimateStore.updateUsageEstimate(usageEstimate.id, undefined, true);
    };
    /**
   * Update Commercial
   */ const updateCommercial = async (update)=>{
        if (!commercial) return;
        const updatedCommercial = await commercialStore.updateCommercial(commercial.id, update);
        if (updatedCommercial) {
            setCommercial(updatedCommercial);
            // Only the commercial's type affects usage fee calculations (see the
            // usage-reset warning in CommercialEditRow) - title/duration edits don't,
            // so skip the costly whole-project estimate refresh for those.
            if (update.type !== undefined) await recalculateUsageEstimate();
        }
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (usageEstimate) {
            let wages = 0;
            let total = 0;
            for (const item of usageEstimate.items){
                wages += item.subtotal;
                total += item.subtotal_plus_fringe;
            }
            setWages(wages);
            setTotal(total);
        }
    }, [
        usageEstimate
    ]);
    (0, $2NacA.useEffect)(()=>{
        setCommercial(listedCommercial);
    }, [
        listedCommercial
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        justify: "center",
        pad: {
            vertical: 'xxsmall',
            horizontal: 'small'
        },
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    pad: "small",
                    align: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                        onChange: onChecked,
                        checked: checked
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    pad: "small",
                    align: "center",
                    width: "20%",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                        val: commercial?.title ?? '',
                        onChange: (title)=>updateCommercial({
                                title: title
                            })
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    pad: "small",
                    align: "center",
                    width: "30%",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "Type:"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                            options: Object.values((0, $3qs6L.CommercialType)).map((t)=>({
                                    label: t,
                                    value: t
                                })),
                            val: commercial?.type,
                            onChange: (val)=>updateCommercial({
                                    type: val
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    flex: true
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    justify: "end",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "xsmall",
                            justify: "end",
                            align: "center",
                            width: "",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 700,
                                    children: "WAGES:"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    weight: "bold",
                                    children: (0, $b1rqt.USD)(wages)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "xsmall",
                            justify: "end",
                            align: "center",
                            width: "10rem",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 700,
                                    children: "TOTAL:"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    weight: "bold",
                                    children: (0, $b1rqt.USD)(total)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    width: "48px",
                    height: "48px"
                })
            ]
        })
    });
});

});
parcelRegister("gpKeH", function(module, exports) {

$parcel$export(module.exports, "CheckBox", () => $bf32d8af58dd94e7$export$ea5f704b89d806f6);

var $2NacA = parcelRequire("2NacA");

var $7rlLx = parcelRequire("7rlLx");

var $7wKkw = parcelRequire("7wKkw");

var $9hDnv = parcelRequire("9hDnv");

var $kJPJj = parcelRequire("kJPJj");

var $d2fh4 = parcelRequire("d2fh4");

var $eL6w3 = parcelRequire("eL6w3");
var $bf32d8af58dd94e7$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "checked",
    "children",
    "containerProps",
    "defaultChecked",
    "disabled",
    "fill",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "reverse",
    "toggle",
    "indeterminate"
];
function $bf32d8af58dd94e7$var$_extends() {
    return $bf32d8af58dd94e7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bf32d8af58dd94e7$var$_extends.apply(null, arguments);
}
function $bf32d8af58dd94e7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bf32d8af58dd94e7$var$stopLabelClick = function stopLabelClick(event) {
    // prevents clicking on the label trigging the event twice
    // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
    if (event.target.type !== 'checkbox') event.stopPropagation();
};
var $bf32d8af58dd94e7$export$ea5f704b89d806f6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _ref2;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], checkedProp = _ref.checked, children = _ref.children, containerProps = _ref.containerProps, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, disabled = _ref.disabled, fill = _ref.fill, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, _onMouseEnter = _ref.onMouseEnter, _onMouseLeave = _ref.onMouseLeave, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, pad = _ref.pad, reverse = _ref.reverse, toggle = _ref.toggle, indeterminate = _ref.indeterminate, rest = $bf32d8af58dd94e7$var$_objectWithoutPropertiesLoose(_ref, $bf32d8af58dd94e7$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: checkedProp,
        initialValue: defaultChecked
    }), checked = _formContext$useFormI[0], setChecked = _formContext$useFormI[1];
    var _useState = (0, $2NacA.useState)(focusProp), focus = _useState[0], setFocus = _useState[1];
    (0, $2NacA.useEffect)(function() {
        // don't allow checkbox to have focus when disabled
        if (disabled && focusProp) setFocus(false);
        else setFocus(focusProp);
    }, [
        disabled,
        focusProp
    ]);
    (0, $2NacA.useEffect)(function() {
        if (checkedProp && indeterminate) console.warn('Checkbox cannot be "checked" and "indeterminate" at the same time.');
        if (toggle && indeterminate) console.warn('Checkbox of type toggle does not have "indeterminate" state.');
    }, [
        checkedProp,
        toggle,
        indeterminate
    ]);
    var themeableProps = {
        checked: checked,
        disabled: disabled,
        focus: focus,
        // when contained in a FormField, focusIndicator = false,
        // so that the FormField has focus style. However, we still
        // need to visually indicate when a CheckBox is active.
        // If focus = true but focusIndicator = false,
        // we will apply the hover treament.
        focusIndicator: focusIndicator,
        reverse: reverse,
        toggle: toggle,
        indeterminate: indeterminate
    };
    var hidden;
    if (disabled && checked) hidden = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("input", {
        name: name,
        type: "hidden",
        value: "true"
    });
    var _theme$checkBox$icons = theme.checkBox.icons, CheckedIcon = _theme$checkBox$icons.checked, IndeterminateIcon = _theme$checkBox$icons.indeterminate;
    var borderColor = (0, $d2fh4.normalizeColor)(theme.checkBox.border.color, theme);
    if (checked) borderColor = (0, $d2fh4.normalizeColor)(theme.checkBox.color || 'control', theme);
    var visual = toggle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxToggle), $bf32d8af58dd94e7$var$_extends({}, passThemeFlag, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxKnob), $bf32d8af58dd94e7$var$_extends({}, passThemeFlag, themeableProps))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxBox), $bf32d8af58dd94e7$var$_extends({
        align: "center",
        justify: "center",
        width: theme.checkBox.size,
        height: theme.checkBox.size,
        border: {
            size: theme.checkBox.border.width,
            color: borderColor
        },
        round: theme.checkBox.check.radius
    }, passThemeFlag, themeableProps), !indeterminate && checked && (CheckedIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(CheckedIcon, {
        theme: theme,
        as: (0, $kJPJj.StyledCheckBoxIcon)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxIcon), $bf32d8af58dd94e7$var$_extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        d: "M6,11.3 L10.3,16 L18,6.2"
    }))), !checked && indeterminate && (IndeterminateIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(IndeterminateIcon, {
        theme: theme,
        as: (0, $kJPJj.StyledCheckBoxIcon)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxIcon), $bf32d8af58dd94e7$var$_extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        d: "M6,12 L18,12"
    }))));
    var side = !reverse !== !theme.dir ? 'left' : 'right';
    var checkBoxNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBox), $bf32d8af58dd94e7$var$_extends({
        align: "center",
        justify: "center",
        margin: label && (_ref2 = {}, _ref2[side] = theme.checkBox.gap, _ref2)
    }, themeableProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxInput), $bf32d8af58dd94e7$var$_extends({
        "aria-label": ariaLabel || a11yTitle
    }, passThemeFlag, rest, {
        ref: ref,
        type: "checkbox"
    }, (0, $7rlLx.removeUndefined)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled
    }), themeableProps, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setChecked(event.target.checked);
            if (_onChange) _onChange(event);
        }
    })), children ? children({
        checked: checked,
        indeterminate: indeterminate
    }) : visual, hidden);
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("span", null, label) : label;
    var first = reverse ? normalizedLabel : checkBoxNode;
    var second = reverse ? checkBoxNode : normalizedLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kJPJj.StyledCheckBoxContainer), $bf32d8af58dd94e7$var$_extends({
        fillProp: fill,
        reverse: reverse
    }, (0, $7rlLx.removeUndefined)({
        htmlFor: id,
        disabled: disabled
    }), {
        checked: checked,
        labelProp: label,
        onClick: $bf32d8af58dd94e7$var$stopLabelClick,
        pad: pad,
        onMouseEnter: function onMouseEnter(event) {
            return _onMouseEnter == null ? void 0 : _onMouseEnter(event);
        },
        onMouseOver: function onMouseOver(event) {
            return _onMouseOver == null ? void 0 : _onMouseOver(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            return _onMouseLeave == null ? void 0 : _onMouseLeave(event);
        },
        onMouseOut: function onMouseOut(event) {
            return _onMouseOut == null ? void 0 : _onMouseOut(event);
        }
    }, passThemeFlag, themeableProps, containerProps), first, second);
});
$bf32d8af58dd94e7$export$ea5f704b89d806f6.displayName = 'CheckBox';
$bf32d8af58dd94e7$export$ea5f704b89d806f6.propTypes = (0, $9hDnv.CheckBoxPropTypes);

});
parcelRegister("9hDnv", function(module, exports) {

$parcel$export(module.exports, "CheckBoxPropTypes", () => $6c243f44b88d8790$export$7aa8af94cfcf92cd);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0


var $6c243f44b88d8790$var$PropType = {};
var $6c243f44b88d8790$export$7aa8af94cfcf92cd = $6c243f44b88d8790$var$PropType;

});

parcelRegister("kJPJj", function(module, exports) {

$parcel$export(module.exports, "StyledCheckBoxIcon", () => $f1902316c0e4cb80$export$59aa90b6aef14a9a);
$parcel$export(module.exports, "StyledCheckBoxContainer", () => $f1902316c0e4cb80$export$644eb5002e1279aa);
$parcel$export(module.exports, "StyledCheckBoxInput", () => $f1902316c0e4cb80$export$cfaa8b267e569e86);
$parcel$export(module.exports, "StyledCheckBoxBox", () => $f1902316c0e4cb80$export$85d649873caec356);
$parcel$export(module.exports, "StyledCheckBoxToggle", () => $f1902316c0e4cb80$export$3bdb76e4c33903d5);
$parcel$export(module.exports, "StyledCheckBoxKnob", () => $f1902316c0e4cb80$export$848dcdc388a1c52f);
$parcel$export(module.exports, "StyledCheckBox", () => $f1902316c0e4cb80$export$150f188f805089fa);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");

var $5xcHk = parcelRequire("5xcHk");
// Note: since `fillStyle` is only used in one place, `justify-content` was
// added to it to simplify its logic. If this is ever reused somewhere else,
// consider the need of separating those once again.
var $f1902316c0e4cb80$var$fillStyle = function fillStyle() {
    return "\n      width: auto;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n      justify-content: space-between;\n    ";
};
var $f1902316c0e4cb80$var$disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var $f1902316c0e4cb80$var$hoverStyle = (0, $f5efw.css)([
    "&:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";",
    "}&:hover{background-color:",
    ";}"
], function(props) {
    var _props$theme$checkBox;
    return (0, $d2fh4.normalizeColor)((_props$theme$checkBox = props.theme.checkBox.hover) == null || (_props$theme$checkBox = _props$theme$checkBox.border) == null ? void 0 : _props$theme$checkBox.color, props.theme);
}, function(props) {
    var _props$theme$checkBox2;
    return (_props$theme$checkBox2 = props.theme.checkBox.hover) == null ? void 0 : _props$theme$checkBox2.extend;
}, function(props) {
    var _props$theme$checkBox3;
    return (0, $d2fh4.normalizeColor)(!props.disabled && ((_props$theme$checkBox3 = props.theme.checkBox.hover) == null || (_props$theme$checkBox3 = _props$theme$checkBox3.background) == null ? void 0 : _props$theme$checkBox3.color), props.theme);
});
var $f1902316c0e4cb80$export$59aa90b6aef14a9a = (0, $f5efw.default).svg.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxIcon",
    componentId: "sc-1dbk5ju-0"
})([
    "box-sizing:border-box;stroke-width:",
    ";stroke:",
    ";width:",
    ";height:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.check.thickness;
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.checkBox.color || 'control', props.theme);
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.extend;
});
var $f1902316c0e4cb80$export$644eb5002e1279aa = (0, $f5efw.default).label.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxContainer",
    componentId: "sc-1dbk5ju-1"
})([
    "display:flex;flex-direction:row;align-items:",
    ";user-select:none;-webkit-user-select:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return typeof props.labelProp === 'string' ? props.theme.checkBox.label.align : undefined;
}, function(props) {
    return props.fillProp ? $f1902316c0e4cb80$var$fillStyle() : 'width: fit-content;';
}, function(props) {
    return (props.pad || props.theme.checkBox.pad) && (0, $2O6LY.edgeStyle)('padding', props.pad || props.theme.checkBox.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && $f1902316c0e4cb80$var$disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, $f1902316c0e4cb80$var$hoverStyle, function(props) {
    var _props$theme$checkBox4, _props$theme$checkBox5;
    return props.focus && !props.focusIndicator && "\n    input:not([disabled]) + div,\n    input:not([disabled]) + span {\n      border-color: " + (0, $d2fh4.normalizeColor)((_props$theme$checkBox4 = props.theme.checkBox.hover) == null || (_props$theme$checkBox4 = _props$theme$checkBox4.border) == null ? void 0 : _props$theme$checkBox4.color, props.theme) + ";\n    }\n\n    background-color: " + (0, $d2fh4.normalizeColor)(!props.disabled && ((_props$theme$checkBox5 = props.theme.checkBox.hover) == null || (_props$theme$checkBox5 = _props$theme$checkBox5.background) == null ? void 0 : _props$theme$checkBox5.color), props.theme) + ";";
}, function(props) {
    return props.theme.checkBox.extend;
});
var $f1902316c0e4cb80$export$cfaa8b267e569e86 = (0, $f5efw.default).input.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxInput",
    componentId: "sc-1dbk5ju-2"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    " &:checked + span > span{",
    ":calc( ",
    " - ",
    " );background:",
    ";}"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.checkBox.color || 'control', props.theme);
});
var $f1902316c0e4cb80$export$85d649873caec356 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxBox",
    componentId: "sc-1dbk5ju-3"
})([
    "",
    ";",
    ";"
], function(props) {
    return props.focus && props.focusIndicator && (0, $2O6LY.focusStyle)();
}, function(props) {
    return props.theme.checkBox.check.extend;
});
var $f1902316c0e4cb80$export$3bdb76e4c33903d5 = (0, $f5efw.default).span.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxToggle",
    componentId: "sc-1dbk5ju-4"
})([
    "box-sizing:border-box;vertical-align:middle;display:inline-block;width:",
    ";height:",
    ";border:",
    " solid;border-color:",
    ";border-radius:",
    ";background-color:",
    ";",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.checkBox.border.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.background ? (0, $d2fh4.normalizeColor)(props.theme.checkBox.toggle.background, props.theme) : 'transparent';
}, function(props) {
    return props.focus && props.focusIndicator && (0, $2O6LY.focusStyle)();
}, function(props) {
    return props.theme.checkBox.toggle.extend;
});
var $f1902316c0e4cb80$export$848dcdc388a1c52f = (0, $f5efw.default).span.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxKnob",
    componentId: "sc-1dbk5ju-5"
})([
    "box-sizing:border-box;position:relative;display:inherit;top:-",
    ";",
    ":-",
    ";transition:all 0.3s;width:",
    ";height:",
    ";background:",
    ";border-radius:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.checkBox.toggle.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.knob.extend;
});
var $f1902316c0e4cb80$export$150f188f805089fa = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledCheckBox",
    componentId: "sc-1dbk5ju-6"
})([
    "flex-shrink:0;"
]);

});


parcelRegister("b1rqt", function(module, exports) {

$parcel$export(module.exports, "USD", () => $f94e45ac645ae232$export$21abe75bbf5aa63c);
$parcel$export(module.exports, "shortenCurrency", () => $f94e45ac645ae232$export$53cec945e7986f42);
$parcel$export(module.exports, "formatCurrency", () => $f94e45ac645ae232$export$3dc27271f5d5c629);
$parcel$export(module.exports, "parseCurrency", () => $f94e45ac645ae232$export$dc5333890dfc7d0);
$parcel$export(module.exports, "sanitizeNumeric", () => $f94e45ac645ae232$export$4a3450f3ea3c95db);
$parcel$export(module.exports, "countSig", () => $f94e45ac645ae232$export$9294cb0de30d67e6);
$parcel$export(module.exports, "indexOfSig", () => $f94e45ac645ae232$export$1b084d99f3919391);
const $f94e45ac645ae232$export$21abe75bbf5aa63c = (amt)=>{
    let val;
    if (!amt) val = 0;
    else if (typeof amt === 'string') val = parseFloat(amt);
    else val = amt;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(val);
};
const $f94e45ac645ae232$export$53cec945e7986f42 = (val, opts)=>{
    const { shortenThousands: shortenThousands = false, hideZeroDecimals: hideZeroDecimals = false } = opts ?? {};
    let num;
    if (!val) num = 0;
    else if (typeof val === 'string') num = parseFloat(val);
    else num = Number(val);
    let suffix = '';
    if (num >= 1000000000) {
        num = num / 1000000000;
        suffix = 'B';
    // output = `${USD(num / 1_000_000_000)}B`;
    } else if (num >= 1000000) {
        num = num / 1000000;
        suffix = 'M';
    // output = `${USD(num / 1_000_000)}M`;
    } else if (shortenThousands && num >= 1000) {
        num = num / 1000;
        suffix = 'K';
    // output = `${USD(num / 1_000)}K`;
    }
    //  else {
    //   output = USD(num);
    // }
    let output = $f94e45ac645ae232$export$21abe75bbf5aa63c(num);
    if (hideZeroDecimals) {
        const o = output.split('.');
        if (o[1] === '00') output = o[0];
    }
    return `${output}${suffix}`;
};
const $f94e45ac645ae232$export$3dc27271f5d5c629 = (n, decimals = true)=>{
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimals ? 2 : 0,
        maximumFractionDigits: decimals ? 2 : 0
    }).format(n);
};
const $f94e45ac645ae232$export$dc5333890dfc7d0 = (s)=>{
    return parseFloat(s.replace(/[^0-9.]/g, ''));
};
const $f94e45ac645ae232$export$4a3450f3ea3c95db = (s)=>{
    const cleaned = s.replace(/[^0-9.]/g, '');
    const dot = cleaned.indexOf('.');
    if (dot === -1) return cleaned;
    return cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
};
const $f94e45ac645ae232$export$9294cb0de30d67e6 = (s)=>(s.match(/[0-9.]/g) || []).length;
const $f94e45ac645ae232$export$1b084d99f3919391 = (s, n)=>{
    let count = 0;
    for(let i = 0; i < s.length; i++)if (/[0-9.]/.test(s[i])) {
        count++;
        if (count === n) return i + 1;
    }
    return s.length;
};

});


parcelRegister("81cmi", function(module, exports) {

$parcel$export(module.exports, "CommercialsPanel", () => $7eed3a8f61a50176$export$73d1ec489b93dc37);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");

var $bhoi7 = parcelRequire("bhoi7");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("1xNcM");
var $8YJFZ = parcelRequire("8YJFZ");

var $8DltC = parcelRequire("8DltC");

var $7wM4T = parcelRequire("7wM4T");

var $6KWAU = parcelRequire("6KWAU");

var $bSmn2 = parcelRequire("bSmn2");
const $7eed3a8f61a50176$export$73d1ec489b93dc37 = (0, $j8yBr.observer)(({ cardProps: cardProps })=>{
    /** Context **/ const commercialStore = (0, $8DltC.useCommercialStore)();
    const estimateStore = (0, $8DltC.useEstimateStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const currentProjectId = projectStore.currentProject?.id;
    /** State **/ const [showAddModal, setShowAddModal] = (0, $2NacA.useState)(false);
    const [commercials, setCommercials] = (0, $2NacA.useState)([]);
    const [isLoadingCommercials, setIsLoadingCommercials] = (0, $2NacA.useState)(true);
    const [selected, setSelected] = (0, $2NacA.useState)([]);
    /** Computed **/ const tempEstimate = estimateStore.tempEstimate;
    /** Methods **/ const selectedNames = ()=>{
        const titles = selected.map((s)=>commercials.find((item)=>item.id === s)?.title).join(', ');
        return titles;
    };
    const chooseCommercial = (id)=>{
        if (selected.includes(id)) setSelected(selected.filter((s)=>s !== id));
        else setSelected([
            ...selected,
            id
        ]);
    };
    const createCommercial = async (type, durationInSeconds, title)=>{
        if (!type || typeof durationInSeconds !== 'number') return;
        if (!currentProjectId) {
            console.error('No current project ID');
            return;
        }
        const jobCode = projectStore.currentProject?.job_code ?? '';
        const commercial = await commercialStore.createCommercial({
            projectId: currentProjectId || '',
            jobCode: jobCode,
            durationInSeconds: durationInSeconds,
            type: type,
            title: title || 'New Commercial'
        });
        if (commercial) {
            setCommercials([
                ...commercials,
                commercial
            ]);
            await estimateStore.createUsageEstimate(`TempEstimate_Usage_${commercial.id}`, commercial.id, true);
            await estimateStore.refreshTempEstimate(true);
        }
    };
    const deleteCommercials = async ()=>{
        if (!tempEstimate) {
            console.warn('Could not delete Sessions - Temp Estimate is undefined');
            return;
        }
        // delete the selected commercials (usage_estimates are cascade-deleted automatically)
        await Promise.all(selected.map((s)=>commercialStore.deleteCommercial(s)));
        // remove the deleted commercials from the list
        setCommercials(commercials.filter((commercial)=>!selected.includes(commercial.id)));
        setSelected([]);
        // Refresh the estimate totals after deletion
        await estimateStore.refreshEstimateTotals(estimateStore.tempEstimate?.id);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const getCommercials = async ()=>{
            const projectId = projectStore.currentProject?.id;
            if (!projectId) {
                setCommercials([]);
                setIsLoadingCommercials(false);
                return;
            }
            setIsLoadingCommercials(true);
            // The commercials don't depend on the estimate, so list them alongside it rather than after
            // its chain of requests; each row fills in its costs once the estimate arrives
            const listCommercials = async ()=>{
                const s = await commercialStore.listCommercialsByProjectId(projectId);
                setCommercials(s || []);
                setIsLoadingCommercials(false);
            };
            const loadEstimate = async ()=>{
                // Get or create hidden Estimate for Usage Estimator page
                const tempTitle = `${(0, $8YJFZ.SESSION_ESTIMATOR_TEMP_ESTIMATE_TITLE)}${projectId}`;
                let estimate = await estimateStore.getEstimateByTitle(tempTitle, 'usage_estimates', true);
                if (!estimate) {
                    await estimateStore.createEstimate(projectId, tempTitle, true);
                    estimate = await estimateStore.getEstimateByTitle(tempTitle, 'usage_estimates', true);
                }
                if (estimate?.is_hidden) estimateStore.setTempEstimate(estimate);
                await estimateStore.refreshTempEstimate();
            };
            try {
                await Promise.all([
                    listCommercials(),
                    loadEstimate()
                ]);
            } catch (err) {
                if (err.status !== 400) console.error(err);
                setIsLoadingCommercials(false);
            }
        };
        getCommercials();
    }, [
        projectStore.currentProject?.id
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $7wM4T.TalonCard), {
        label: "Commercial",
        labelPlural: 'Commercials',
        newItem: ()=>setShowAddModal(true),
        deleteItems: ()=>deleteCommercials(),
        selectedNames: selectedNames(),
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bhoi7.Video), {}),
        cardProps: cardProps,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                children: isLoadingCommercials ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    pad: "medium",
                    align: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        color: "dark-3",
                        children: "Loading commercials\u2026"
                    })
                }) : commercials.length > 0 ? commercials.map((commercial)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $6KWAU.CommercialRow), {
                        commercial: commercial,
                        onChecked: ()=>chooseCommercial(commercial.id),
                        checked: selected.includes(commercial.id)
                    }, commercial.id)) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    pad: "medium",
                    align: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        color: "dark-3",
                        children: [
                            "No Commercials found.",
                            ' ',
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                onClick: ()=>setShowAddModal(true),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    weight: 300,
                                    color: "accent-5",
                                    children: "Click here to create one"
                                })
                            }),
                            "."
                        ]
                    })
                })
            }),
            showAddModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bSmn2.CreateCommercialModal), {
                addCommercial: createCommercial,
                setShowModal: setShowAddModal
            })
        ]
    });
});

});
parcelRegister("bhoi7", function(module, exports) {

$parcel$export(module.exports, "Video", () => $83641ffaa2a6363a$export$ae01dedf5c052bb);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $83641ffaa2a6363a$var$_extends() {
    return $83641ffaa2a6363a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $83641ffaa2a6363a$var$_extends.apply(null, arguments);
}
var $83641ffaa2a6363a$export$ae01dedf5c052bb = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $83641ffaa2a6363a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Video"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 9 8-4v14l-8-4V9zM1 5h14v14H1V5z"
    }));
});
$83641ffaa2a6363a$export$ae01dedf5c052bb.displayName = 'Video';

});

parcelRegister("7wM4T", function(module, exports) {

$parcel$export(module.exports, "TalonCard", () => $171ccaf9d9e7e9bb$export$b8f275d95ac44834);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $hIlrL = parcelRequire("hIlrL");
var $2bcjL = parcelRequire("2bcjL");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("bRT7J");
var $gdNyE = parcelRequire("gdNyE");
var $hF8pi = parcelRequire("hF8pi");
var $lFfFS = parcelRequire("lFfFS");
const $171ccaf9d9e7e9bb$export$b8f275d95ac44834 = ({ newItem: newItem, deleteItems: deleteItems, disableAdd: disableAdd, label: label, labelPlural: labelPlural, addIcon: addIcon, buttons: buttons, children: children, headerChildren: headerChildren, selectedNames: selectedNames, saveStatus: saveStatus, cardProps: cardProps, titleTextProps: titleTextProps, margin: margin = 'small', headerHeight: headerHeight, headerBackground: headerBackground, bodyBackground: bodyBackground, footerBackground: footerBackground, color: color = 'accent-1', hideFooter: hideFooter = false, animate: animate = false, isLoading: isLoading = false, onHeaderClick: onHeaderClick, headerCardProps: headerCardProps, addButtonLabel: addButtonLabel = 'Add New' })=>{
    /** Context **/ /** State **/ /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        margin: margin,
        ...cardProps,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                gap: "small",
                background: headerBackground || {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)',
                    zIndex: 2
                },
                height: headerHeight || '60px',
                pad: {
                    horizontal: 'small'
                },
                // onClick={onHeaderClick}
                elevation: "xsmall",
                ...headerCardProps,
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        flex: "grow",
                        align: "center",
                        style: {
                            zIndex: 2,
                            cursor: onHeaderClick ? 'pointer' : undefined
                        },
                        onClick: onHeaderClick,
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: 600,
                                ...titleTextProps,
                                color: color,
                                children: labelPlural || label
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lFfFS.SaveStatusIndicator), {
                                saveStatus: saveStatus
                            })
                        ]
                    }),
                    headerChildren
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                flex: "grow",
                align: isLoading ? 'center' : undefined,
                pad: isLoading ? 'medium' : undefined,
                background: bodyBackground || 'accent-1',
                elevation: "xsmall",
                style: {
                    zIndex: 1
                },
                children: [
                    isLoading && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {}),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        className: animate ? `animate-height ${isLoading ? 'collapsed' : 'expanded'}` : '',
                        children: !isLoading && children
                    })
                ]
            }),
            !hideFooter && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hIlrL.CardFooter), {
                gap: "xxsmall",
                background: footerBackground || 'light-1',
                justify: "end",
                pad: "xsmall",
                children: [
                    buttons,
                    newItem && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        onClick: newItem,
                        tipText: typeof label === 'string' ? `New ${label}` : addButtonLabel,
                        icon: addIcon,
                        disabled: disableAdd
                    }),
                    deleteItems && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                        onClick: ()=>deleteItems(),
                        name: selectedNames || 'these items',
                        disabled: !selectedNames,
                        hoverIndicator: true
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jJ6uA", function(module, exports) {

$parcel$export(module.exports, "CardBody", () => $e5c74184a97fcd5c$export$851de33184ecdac4);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $eL6w3 = parcelRequire("eL6w3");
function $e5c74184a97fcd5c$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function $e5c74184a97fcd5c$var$_extends() {
    return $e5c74184a97fcd5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e5c74184a97fcd5c$var$_extends.apply(null, arguments);
}
var $e5c74184a97fcd5c$export$851de33184ecdac4 = function CardBody(_ref) {
    var rest = $e5c74184a97fcd5c$var$_extends({}, ($e5c74184a97fcd5c$var$_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $e5c74184a97fcd5c$var$_extends({
        flex: true
    }, theme.card.body, rest));
};

});

parcelRegister("kqZxg", function(module, exports) {

$parcel$export(module.exports, "Spinner", () => $ee05f8054622b1f7$export$7f7cbe89f1eacd2);

var $2NacA = parcelRequire("2NacA");

var $7oNsG = parcelRequire("7oNsG");

var $5xcHk = parcelRequire("5xcHk");

var $vGz6C = parcelRequire("vGz6C");

var $eL6w3 = parcelRequire("eL6w3");
var $ee05f8054622b1f7$var$_excluded = [
    "ref",
    "size"
], $ee05f8054622b1f7$var$_excluded2 = [
    "children",
    "color",
    "size",
    "message"
], $ee05f8054622b1f7$var$_excluded3 = [
    "size",
    "color",
    "border"
];
function $ee05f8054622b1f7$var$_extends() {
    return $ee05f8054622b1f7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ee05f8054622b1f7$var$_extends.apply(null, arguments);
}
function $ee05f8054622b1f7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ee05f8054622b1f7$var$BasicSpinner = function BasicSpinner(_ref) {
    var ref = _ref.ref, size = _ref.size, rest = $ee05f8054622b1f7$var$_objectWithoutPropertiesLoose(_ref, $ee05f8054622b1f7$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $ee05f8054622b1f7$var$_extends({
        flex: false,
        height: size,
        width: size,
        ref: ref,
        responsive: theme.spinner.responsive
    }, rest));
};
/**
 * If the user is calling <Spinner>…</Spinner> with children, it will take
 * precedence over theme styling. Yet, it will still inherit the
 * default animation and size of the spinner, and of course any additional
 * given props.
 *
 * If the user is providing an icon/svg via the theme.spinner.icon,
 * the Spinner will use it as a child and will include all its relevant
 * theme props (size/color/pad…) as well,
 * user will only need to type <Spinner />.
 * If the icon has its own animation, user can turn it off via the theme.
 *
 * If none of the above is provider, <Spinner /> will provide its default
 * border, size and friends, all configurable via theme or props.
 */ var $ee05f8054622b1f7$export$7f7cbe89f1eacd2 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, colorProp = _ref2.color, size = _ref2.size, message = _ref2.message, rest = $ee05f8054622b1f7$var$_objectWithoutPropertiesLoose(_ref2, $ee05f8054622b1f7$var$_excluded2);
    var _useThemeValue2 = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue2.theme;
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    (0, $2NacA.useEffect)(function() {
        if (message != null && message.start) announce(message.start);
        else if (typeof message === 'string') announce(message);
        return function() {
            return (message == null ? void 0 : message.end) && announce(message.end);
        };
    }, [
        announce,
        message
    ]);
    // Avoid color and size leaking into the DOM
    var _theme$spinner$contai = theme.spinner.container, sizeThemeProp = _theme$spinner$contai.size, colorThemeProp = _theme$spinner$contai.color, borderThemeProp = _theme$spinner$contai.border, themeProps = $ee05f8054622b1f7$var$_objectWithoutPropertiesLoose(_theme$spinner$contai, $ee05f8054622b1f7$var$_excluded3);
    var normalizedSize = size || sizeThemeProp;
    var spinnerSize = theme.spinner.size[normalizedSize] || normalizedSize;
    var color = colorProp || colorThemeProp;
    var Icon = theme.spinner.icon;
    var defaultBorder = [
        {
            side: 'all',
            color: 'background-contrast',
            size: size
        },
        {
            side: 'top',
            color: color,
            size: size
        }
    ];
    var spinnerBorder = Array.isArray(borderThemeProp) ? borderThemeProp.map(function(borderSide) {
        return $ee05f8054622b1f7$var$_extends({}, borderSide, {
            color: borderSide.side === 'all' ? borderSide.color || 'background-contrast' : color
        });
    }) : borderThemeProp;
    // children will take precedence over theme attributes
    if (children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($ee05f8054622b1f7$var$BasicSpinner, $ee05f8054622b1f7$var$_extends({
        size: spinnerSize,
        ref: ref
    }, rest), children);
    // In case icon is provided by the theme
    if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($ee05f8054622b1f7$var$BasicSpinner, $ee05f8054622b1f7$var$_extends({
        size: spinnerSize,
        ref: ref
    }, themeProps, rest), /*#__PURE__*/ (0, $2NacA.isValidElement)(Icon) ? Icon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(Icon, {
        size: spinnerSize,
        color: color
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($ee05f8054622b1f7$var$BasicSpinner, $ee05f8054622b1f7$var$_extends({
        size: spinnerSize,
        ref: ref,
        border: typeof borderThemeProp === 'undefined' ? defaultBorder : spinnerBorder
    }, themeProps, rest));
});
$ee05f8054622b1f7$export$7f7cbe89f1eacd2.displayName = 'Spinner';
$ee05f8054622b1f7$export$7f7cbe89f1eacd2.propTypes = (0, $vGz6C.SpinnerPropTypes);

});
parcelRegister("vGz6C", function(module, exports) {

$parcel$export(module.exports, "SpinnerPropTypes", () => $05f3e9ee756de3ca$export$a41ccd36cbb5b95e);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $05f3e9ee756de3ca$var$PropType = {};
var $05f3e9ee756de3ca$export$a41ccd36cbb5b95e = $05f3e9ee756de3ca$var$PropType;

});



parcelRegister("bSmn2", function(module, exports) {

$parcel$export(module.exports, "CreateCommercialModal", () => $e1735b27a86b7fa9$export$32b07002b5285a9c);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $aFsfQ = parcelRequire("aFsfQ");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $az33k = parcelRequire("az33k");
parcelRequire("ibR9R");
var $bIzid = parcelRequire("bIzid");
const $e1735b27a86b7fa9$export$32b07002b5285a9c = (0, $j8yBr.observer)(({ addCommercial: addCommercial, setShowModal: setShowModal })=>{
    /** State **/ const [title, setTitle] = (0, $2NacA.useState)('');
    const [type, setType] = (0, $2NacA.useState)();
    const [durationInSeconds, setDurationInSeconds] = (0, $2NacA.useState)(0);
    /** Methods **/ const createCommercial = ()=>{
        if (!type) return;
        addCommercial(type, durationInSeconds, title);
        setShowModal(false);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $az33k.ModalCard), {
        onClose: ()=>setShowModal(false),
        title: "Create Commercial",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            gap: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            pad: "small",
                            align: "center",
                            fill: "horizontal",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    width: "28%",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Title:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    fill: "horizontal",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        id: "title",
                                        name: "title",
                                        htmlFor: "title",
                                        placeholder: "New Commercial",
                                        val: title || '',
                                        onChange: (val)=>setTitle(val)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            pad: "small",
                            align: "center",
                            fill: "horizontal",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    width: "28%",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Type:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    fill: "horizontal",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                        id: "commercial-type",
                                        name: "commercial-type",
                                        placeholder: "Choose...",
                                        value: type,
                                        options: Object.values((0, $3qs6L.CommercialType)),
                                        onChange: ({ value: value })=>setType(value),
                                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aFsfQ.Multimedia), {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            pad: "small",
                            align: "center",
                            fill: "horizontal",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    width: "28%",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Duration:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    fill: "horizontal",
                                    direction: "row",
                                    align: "center",
                                    gap: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                            id: "duration-in-seconds",
                                            name: "duration-in-seconds",
                                            val: durationInSeconds,
                                            inputType: "number",
                                            onChange: (val)=>setDurationInSeconds(Number.isFinite(parseInt(val)) ? parseInt(val) : 0)
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: "seconds"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    justify: "end",
                    align: "center",
                    margin: {
                        vertical: 'small'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        primary: true,
                        label: "Add Commercial",
                        disabled: !type || typeof durationInSeconds !== 'number',
                        onClick: ()=>createCommercial()
                    })
                })
            ]
        })
    });
});

});
parcelRegister("fdtj0", function(module, exports) {

$parcel$export(module.exports, "Select", () => $b13ecd61f362640a$export$ef9b1a59e592288f);

var $2NacA = parcelRequire("2NacA");

var $hp4MM = parcelRequire("hp4MM");

var $5xcHk = parcelRequire("5xcHk");

var $czDw5 = parcelRequire("czDw5");

var $7wKkw = parcelRequire("7wKkw");

var $8Y0Cy = parcelRequire("8Y0Cy");

var $7y130 = parcelRequire("7y130");

var $4oskf = parcelRequire("4oskf");

var $jVcXh = parcelRequire("jVcXh");

var $2M0UK = parcelRequire("2M0UK");

var $mgsBP = parcelRequire("mgsBP");

var $eL6w3 = parcelRequire("eL6w3");
var $b13ecd61f362640a$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "aria-labelledby",
    "alignSelf",
    "children",
    "clear",
    "closeOnChange",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "id",
    "icon",
    "labelKey",
    "margin",
    "messages",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "selected",
    "size",
    "value",
    "valueKey",
    "valueLabel"
];
function $b13ecd61f362640a$var$_extends() {
    return $b13ecd61f362640a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b13ecd61f362640a$var$_extends.apply(null, arguments);
}
function $b13ecd61f362640a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b13ecd61f362640a$var$defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var $b13ecd61f362640a$export$ef9b1a59e592288f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], alignSelf = _ref.alignSelf, children = _ref.children, _ref$clear = _ref.clear, clear = _ref$clear === void 0 ? false : _ref$clear, _ref$closeOnChange = _ref.closeOnChange, closeOnChange = _ref$closeOnChange === void 0 ? true : _ref$closeOnChange, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $b13ecd61f362640a$var$defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, id = _ref.id, icon = _ref.icon, labelKeyProp = _ref.labelKey, margin = _ref.margin, messages = _ref.messages, multiple = _ref.multiple, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, propOpen = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, selected = _ref.selected, size = _ref.size, valueProp = _ref.value, valueKeyProp = _ref.valueKey, valueLabel = _ref.valueLabel, rest = $b13ecd61f362640a$var$_objectWithoutPropertiesLoose(_ref, $b13ecd61f362640a$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var inputRef = (0, $2NacA.useRef)();
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    // For greater resilience, use labelKey if valueKey isn't provided and
    // vice versa. https://github.com/grommet/grommet/pull/6299
    var valueKey = valueKeyProp || labelKeyProp;
    var labelKey = labelKeyProp || valueKeyProp;
    var formFieldData = formContext == null ? void 0 : formContext.useFormField({});
    // Determine if the Select is opened with the keyboard. If so,
    // focus should be set on the first option when the drop opens
    // see set initial focus code in SelectContainer.js
    var usingKeyboard = (0, $hp4MM.useKeyboard)();
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, $2NacA.useMemo)(function() {
        return (0, $4oskf.getNormalizedValue)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState = (0, $2NacA.useState)(), search = _useState[0], setSearch = _useState[1];
    // All select option indices and values
    var _useState2 = (0, $2NacA.useState)(optionsProp), allOptions = _useState2[0], setAllOptions = _useState2[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, $2NacA.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, $2NacA.useMemo)(function() {
        var result = [];
        if (selected !== undefined) {
            if (Array.isArray(selected)) {
                var validSelections = selected.filter(function(i) {
                    return i in allOptions;
                });
                result.push.apply(result, validSelections);
            } else if (selected in allOptions) result.push(selected);
        } else if (Array.isArray(normalizedValue)) normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, $4oskf.applyKey)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        else {
            var index = allOptions.map(function(option) {
                return (0, $4oskf.applyKey)(option, valueKey);
            }).indexOf(normalizedValue);
            if (index !== -1) result.push(index);
        }
        return result;
    }, [
        allOptions,
        selected,
        valueKey,
        normalizedValue
    ]);
    var _useState3 = (0, $2NacA.useState)(propOpen), open = _useState3[0], setOpen = _useState3[1];
    (0, $2NacA.useEffect)(function() {
        return setOpen(propOpen);
    }, [
        propOpen
    ]);
    var onRequestOpen = (0, $2NacA.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    var onRequestClose = (0, $2NacA.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, $2NacA.useCallback)(function(nextValue) {
        return (0, $4oskf.changeEvent)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, $2NacA.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value, nextSelected = _ref2.selected;
        if (closeOnChange) onRequestClose();
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if ((typeof nextValue !== 'object' || multiple) && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    },
                    selected: {
                        value: nextSelected
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
                adjustedEvent.selected = nextSelected;
            }
            onChange(adjustedEvent);
        }
    }, [
        closeOnChange,
        multiple,
        onChange,
        onRequestClose,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, $4oskf.getSelectIcon)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, $2NacA.useMemo)(function() {
        if (valueLabel instanceof Function) {
            if (value || value === 0 || value === false) return valueLabel(value);
        } else if (valueLabel) return valueLabel;
        else if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).isValidElement(value)) return value; // deprecated
        return undefined;
    }, [
        value,
        valueLabel
    ]);
    var displayLabelKey = (0, $2NacA.useMemo)(function() {
        return (0, $4oskf.getDisplayLabelKey)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, $2NacA.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, $4oskf.applyKey)(allOptions[optionIndexesInValue[0]], labelKey);
            return format({
                id: 'select.multiple',
                messages: messages
            });
        }
        return undefined;
    }, [
        labelKey,
        messages,
        format,
        optionIndexesInValue,
        allOptions,
        selectValue
    ]);
    var iconColor = (0, $4oskf.getIconColor)(theme);
    var _useState4 = (0, $2NacA.useState)(), ariaLabelledBy = _useState4[0], setAriaLabelledBy = _useState4[1];
    (0, $2NacA.useEffect)(function() {
        if (formFieldData != null && formFieldData.inForm && id && !ariaLabel && !placeholder && typeof document !== 'undefined') {
            var labelElement = document.getElementById("grommet-" + id + "__input__label");
            if (labelElement) setAriaLabelledBy("grommet-" + id + "__input__label " + id);
        }
    }, [
        formFieldData == null ? void 0 : formFieldData.inForm,
        id,
        ariaLabel,
        placeholder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.StyledSelectDropButton), {
        ref: ref,
        a11yTitle: "" + (ariaLabel || a11yTitle || placeholder || 'Open Drop') + (value ? format({
            id: 'select.selected',
            messages: messages,
            values: {
                currentSelectedValue: (0, $4oskf.formatValueForA11y)(value, labelKey)
            }
        }) : ''),
        "aria-expanded": Boolean(open),
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        "aria-haspopup": "listbox",
        id: id,
        disabled: disabled === true || undefined,
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        open: open,
        alignSelf: alignSelf,
        focusIndicator: plain ? focusIndicator : true,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        dropContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $8Y0Cy.SelectContainer), {
            clear: clear,
            disabled: disabled,
            disabledKey: disabledKey,
            dropHeight: dropHeight,
            emptySearchMessage: emptySearchMessage,
            id: id,
            labelKey: labelKey,
            messages: messages,
            multiple: multiple,
            name: name,
            onChange: onSelectChange,
            onKeyDown: onKeyDown,
            onMore: onMore,
            onSearch: onSearch,
            options: optionsProp,
            allOptions: allOptions,
            optionIndexesInValue: optionIndexesInValue,
            replace: replace,
            searchPlaceholder: searchPlaceholder,
            search: search,
            setSearch: setSearch,
            selected: selected,
            usingKeyboard: usingKeyboard,
            value: value,
            valueKey: valueKey
        }, children),
        plainSelect: plain,
        plain: true // Button should be plain
        ,
        dropProps: dropProps,
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.HiddenInput), {
        type: "text",
        name: name,
        id: id ? (0, $4oskf.selectInputId)(id) : undefined,
        inert: (0, $4oskf.inertTrueValue),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jVcXh.DefaultSelectTextInput), $b13ecd61f362640a$var$_extends({
        a11yTitle: (ariaLabel || a11yTitle) && "" + (ariaLabel || a11yTitle) + (value && typeof value === 'string' ? ", " + value : ''),
        disabled: disabled,
        id: id,
        inert: (0, $4oskf.inertTrueValue),
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), SelectIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        margin: theme.select.icons.margin,
        flex: false,
        style: {
            minWidth: 'auto'
        }
    }, /*#__PURE__*/ (0, $2NacA.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(SelectIcon, {
        color: iconColor,
        size: size
    })))));
});
$b13ecd61f362640a$export$ef9b1a59e592288f.displayName = 'Select';
$b13ecd61f362640a$export$ef9b1a59e592288f.propTypes = (0, $mgsBP.SelectPropTypes);

});
parcelRegister("8Y0Cy", function(module, exports) {

$parcel$export(module.exports, "SelectContainer", () => $6874689fa123501d$export$446eebadefe1123b);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $eH2U4 = parcelRequire("eH2U4");

var $cDMMY = parcelRequire("cDMMY");
var $jQHd2 = parcelRequire("jQHd2");

var $2M0UK = parcelRequire("2M0UK");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $cy6cI = parcelRequire("cy6cI");

var $czDw5 = parcelRequire("czDw5");

var $kS7Ii = parcelRequire("kS7Ii");

var $kQZ06 = parcelRequire("kQZ06");

var $7y130 = parcelRequire("7y130");

var $4oskf = parcelRequire("4oskf");

var $bev11 = parcelRequire("bev11");

var $eL6w3 = parcelRequire("eL6w3");
var $6874689fa123501d$var$_excluded = [
    "clear",
    "onClear",
    "name",
    "theme"
];
function $6874689fa123501d$var$_extends() {
    return $6874689fa123501d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6874689fa123501d$var$_extends.apply(null, arguments);
}
function $6874689fa123501d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ensure ClearButton receives visual indication of keyboard
var $6874689fa123501d$var$StyledButton = (0, $f5efw.default)((0, $a26J5.Button)).withConfig({
    displayName: "SelectContainer__StyledButton",
    componentId: "sc-1wi0ul8-0"
})([
    "&:focus{",
    "}"
], function(props) {
    return (0, $jQHd2.getHoverIndicatorStyle)('background', props.theme);
});
var $6874689fa123501d$var$ClearButton = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$select$clear, _theme$select$clear2, _theme$select$clear3;
    var clear = _ref.clear, onClear = _ref.onClear, name = _ref.name, theme = _ref.theme, rest = $6874689fa123501d$var$_objectWithoutPropertiesLoose(_ref, $6874689fa123501d$var$_excluded);
    var label = clear.label, position = clear.position;
    var align = position !== 'bottom' ? 'start' : 'center';
    var buttonLabel = label || "Clear " + (name || 'selection');
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var buttonKind = (_theme$select$clear = theme.select.clear) == null ? void 0 : _theme$select$clear.button;
    var containerProps = ((_theme$select$clear2 = theme.select.clear) == null ? void 0 : _theme$select$clear2.container) || {};
    var textProps = ((_theme$select$clear3 = theme.select.clear) == null ? void 0 : _theme$select$clear3.text) || {};
    var buttonProps = $6874689fa123501d$var$_extends({
        a11yTitle: buttonLabel + ". Or, press " + (position === 'bottom' ? 'shift tab' : 'down arrow') + " to move to select options",
        align: align,
        fill: 'horizontal',
        onClick: onClear,
        ref: ref
    }, passThemeFlag, rest);
    if (buttonKind) // new structure when `theme.select.clear.button` is defined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $6874689fa123501d$var$_extends({
        flex: "grow"
    }, containerProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), $6874689fa123501d$var$_extends({
        kind: buttonKind,
        label: textProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), textProps, buttonLabel) : buttonLabel
    }, buttonProps)));
    // default structure when `theme.select.clear.button` is not defined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($6874689fa123501d$var$StyledButton, $6874689fa123501d$var$_extends({
        focusIndicator: false,
        plain: true
    }, buttonProps), function(_ref2) {
        var _theme$select$clear4;
        var hover = _ref2.hover;
        var boxProps = $6874689fa123501d$var$_extends({}, theme.select.clear.container);
        delete boxProps.hover; // avoid passing hover object to Box
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $6874689fa123501d$var$_extends({}, boxProps, hover ? (_theme$select$clear4 = theme.select.clear) == null || (_theme$select$clear4 = _theme$select$clear4.container) == null ? void 0 : _theme$select$clear4.hover : {}, {
            align: align
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.select.clear.text, buttonLabel));
    });
});
var $6874689fa123501d$export$446eebadefe1123b = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref3, ref) {
    var _theme$select$icons, _theme$select;
    var clear = _ref3.clear, _ref3$children = _ref3.children, children = _ref3$children === void 0 ? null : _ref3$children, disabled = _ref3.disabled, disabledKey = _ref3.disabledKey, dropHeight = _ref3.dropHeight, _ref3$emptySearchMess = _ref3.emptySearchMessage, emptySearchMessage = _ref3$emptySearchMess === void 0 ? 'No matches found' : _ref3$emptySearchMess, id = _ref3.id, labelKey = _ref3.labelKey, messages = _ref3.messages, multiple = _ref3.multiple, name = _ref3.name, onChange = _ref3.onChange, onKeyDown = _ref3.onKeyDown, onMore = _ref3.onMore, onSearch = _ref3.onSearch, optionIndexesInValue = _ref3.optionIndexesInValue, options = _ref3.options, allOptions = _ref3.allOptions, searchPlaceholder = _ref3.searchPlaceholder, search = _ref3.search, setSearch = _ref3.setSearch, selected = _ref3.selected, usingKeyboard = _ref3.usingKeyboard, _ref3$value = _ref3.value, value = _ref3$value === void 0 ? '' : _ref3$value, valueKey = _ref3.valueKey, _ref3$replace = _ref3.replace, replace = _ref3$replace === void 0 ? true : _ref3$replace;
    var _useThemeValue2 = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var shouldShowClearButton = (0, $2NacA.useCallback)(function(position) {
        var hasValue = Boolean(multiple && value ? value.length : value);
        var showAtPosition = position === 'bottom' ? (clear == null ? void 0 : clear.position) === 'bottom' : (clear == null ? void 0 : clear.position) !== 'bottom';
        return clear && hasValue && showAtPosition;
    }, [
        clear,
        multiple,
        value
    ]);
    var isDisabled = (0, $4oskf.useDisabled)(disabled, disabledKey, options, valueKey || labelKey);
    var _useState = (0, $2NacA.useState)(usingKeyboard && !shouldShowClearButton('top') && !onSearch ? 0 : -1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $2NacA.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var searchRef = (0, $2NacA.useRef)();
    var optionsRef = (0, $2NacA.useRef)();
    var clearRef = (0, $2NacA.useRef)();
    var activeRef = (0, $2NacA.useRef)();
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var searchIcon = ((_theme$select$icons = theme.select.icons) == null ? void 0 : _theme$select$icons.search) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $eH2U4.Search), {
        "aria-hidden": true
    });
    // for keyboard/screenreader, keep the active option in focus
    (0, $2NacA.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex >= 0) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, $2NacA.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var optionsNode = optionsRef.current;
            var clearButton = clearRef.current;
            if (onSearch) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus && !activeRef.current) (0, $cDMMY.setFocusWithoutScroll)(searchInput);
            } else if (clear && clearButton && clearButton.focus && clear.position !== 'bottom') (0, $cDMMY.setFocusWithoutScroll)(clearButton);
            else if (usingKeyboard && activeRef.current) (0, $cDMMY.setFocusWithoutScroll)(activeRef.current);
            else if (optionsNode) (0, $cDMMY.setFocusWithoutScroll)(optionsNode);
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        onSearch,
        usingKeyboard,
        clear
    ]);
    var isSelected = (0, $2NacA.useCallback)(function(index) {
        var result;
        if (selected) // deprecated in favor of value
        result = selected.indexOf(index) !== -1;
        else {
            var optionVal = (0, $4oskf.getOptionValue)(index, options, valueKey);
            if (Array.isArray(value)) {
                if (value.length === 0) result = false;
                else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
                else if (valueKey) result = value.some(function(valueItem) {
                    var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey] || valueItem[valueKey.key];
                    return valueValue === optionVal;
                });
            } else if (valueKey && value !== null && typeof value === 'object') {
                var valueValue = typeof valueKey === 'function' ? valueKey(value) : value[valueKey];
                result = valueValue === optionVal;
            } else result = value === optionVal;
        }
        return result;
    }, [
        selected,
        value,
        valueKey,
        options
    ]);
    var selectOption = (0, $2NacA.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextValue;
                var nextSelected;
                if (multiple) {
                    var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                    var allOptionsIndex = allOptions.indexOf(options[index]);
                    var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                    if (valueIndex === -1) nextOptionIndexesInValue.push(allOptionsIndex);
                    else nextOptionIndexesInValue.splice(valueIndex, 1);
                    nextValue = nextOptionIndexesInValue.map(function(i) {
                        return valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(allOptions[i], valueKey) : allOptions[i];
                    });
                    nextSelected = nextOptionIndexesInValue;
                } else {
                    nextValue = valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(options[index], valueKey) : options[index];
                    nextSelected = index;
                }
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        multiple,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey
    ]);
    var onClear = (0, $2NacA.useCallback)(function(event) {
        onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
    }, [
        onChange
    ]);
    var onNextOption = (0, $2NacA.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        while(nextActiveIndex < options.length && isDisabled(nextActiveIndex))nextActiveIndex += 1;
        if (nextActiveIndex !== options.length) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options,
        isDisabled
    ]);
    var onPreviousOption = (0, $2NacA.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        if (nextActiveIndex === -1) {
            var searchInput = searchRef.current;
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus && shouldShowClearButton('top')) {
                setActiveIndex(nextActiveIndex);
                (0, $cDMMY.setFocusWithoutScroll)(clearButton);
            } else if (searchInput && searchInput.focus) {
                setActiveIndex(nextActiveIndex);
                (0, $cDMMY.setFocusWithoutScroll)(searchInput);
            }
        }
        while(nextActiveIndex >= 0 && isDisabled(nextActiveIndex))nextActiveIndex -= 1;
        if (nextActiveIndex >= 0) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        isDisabled,
        shouldShowClearButton
    ]);
    var onKeyDownOption = (0, $2NacA.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e, index) {
                var label;
                if (typeof e === 'object') label = e.label || (0, $4oskf.applyKey)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase() && !isDisabled(index);
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        isDisabled,
        labelKey,
        onKeyDown,
        options,
        onSearch
    ]);
    var onActiveOption = (0, $2NacA.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, $2NacA.useCallback)(function(event) {
        if ((shouldShowClearButton('bottom') || shouldShowClearButton('top')) && (0, $cDMMY.containsFocus)(clearRef.current)) onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
        else if (activeIndex >= 0 && activeIndex < options.length) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        onChange,
        shouldShowClearButton
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || (0, $kQZ06.TextInput);
    var selectOptionsStyle = theme.select.options ? $6874689fa123501d$var$_extends({}, theme.select.options.box, theme.select.options.container) : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.StyledContainer), $6874689fa123501d$var$_extends({
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight
    }, passThemeFlag), onSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: !customSearchInput ? (_theme$select = theme.select) == null || (_theme$select = _theme$select.search) == null ? void 0 : _theme$select.pad : undefined,
        flex: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(SelectTextInput, {
        "aria-label": format({
            id: 'select.searchA11y',
            messages: messages
        }),
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        icon: searchIcon
    })), shouldShowClearButton('top') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($6874689fa123501d$var$ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    }), options.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.OptionsContainer), {
        "aria-label": format({
            id: 'select.optionsA11y',
            messages: messages
        }),
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": multiple,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cy6cI.InfiniteScroll), {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = isSelected(index);
        var optionActive = activeIndex === index;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else if (theme.select.options) {
            child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), selectOptionsStyle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.select.options.text, (0, $4oskf.getOptionLabel)(index, options, labelKey)));
            textComponent = true;
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.SelectOption), $6874689fa123501d$var$_extends({
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected || activeIndex === index || // when nothing is selected and entering listbox
            // first option should be focused
            (!value || Array.isArray(value) && value.length === 0) && activeIndex === -1 && index === 0 ? '0' : '-1',
            role: "option",
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? (0, $4oskf.getOptionLabel)(index, options, labelKey || valueKey) : undefined,
            disabled: optionDisabled || undefined,
            active: optionActive,
            selected: optionSelected,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onMouseOut: !optionDisabled ? onActiveOption(-1) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            textComponent: textComponent
        }, passThemeFlag), child);
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bev11.EmptySearchOption), {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), shouldShowClearButton('bottom') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($6874689fa123501d$var$ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    })));
});

});
parcelRegister("eH2U4", function(module, exports) {

$parcel$export(module.exports, "Search", () => $02c2b2ed0f5cd642$export$4b85d3515bd863a5, (v) => $02c2b2ed0f5cd642$export$4b85d3515bd863a5 = v);
var $02c2b2ed0f5cd642$export$1e511d4a378977f5;
var $02c2b2ed0f5cd642$export$4b85d3515bd863a5;
"use strict";
$02c2b2ed0f5cd642$export$1e511d4a378977f5 = true;
$02c2b2ed0f5cd642$export$4b85d3515bd863a5 = void 0;

var $02c2b2ed0f5cd642$var$_react = $02c2b2ed0f5cd642$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");

var $jvU3m = parcelRequire("jvU3m");
function $02c2b2ed0f5cd642$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($02c2b2ed0f5cd642$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $02c2b2ed0f5cd642$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $02c2b2ed0f5cd642$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $02c2b2ed0f5cd642$var$_extends() {
    return $02c2b2ed0f5cd642$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $02c2b2ed0f5cd642$var$_extends.apply(null, arguments);
}
var $02c2b2ed0f5cd642$var$Search = $02c2b2ed0f5cd642$export$4b85d3515bd863a5 = /*#__PURE__*/ (0, $02c2b2ed0f5cd642$var$_react.forwardRef)(function(props, ref) {
    var scaleProps = (0, $jvU3m.useScaleProps)(props);
    return /*#__PURE__*/ $02c2b2ed0f5cd642$var$_react["default"].createElement($xazbe.StyledIcon, $02c2b2ed0f5cd642$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Search"
    }, props), /*#__PURE__*/ $02c2b2ed0f5cd642$var$_react["default"].createElement("path", $02c2b2ed0f5cd642$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 15 7 7-7-7zm-5.5 2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z"
    }, scaleProps)));
});
$02c2b2ed0f5cd642$var$Search.displayName = 'Search';

});

parcelRegister("7y130", function(module, exports) {

$parcel$export(module.exports, "StyledContainer", () => $57ec855e5bed70a5$export$1d41361302b577a1);
$parcel$export(module.exports, "OptionsContainer", () => $57ec855e5bed70a5$export$1a780bb4ae54ddec);
$parcel$export(module.exports, "HiddenInput", () => $57ec855e5bed70a5$export$7196851310a3d0bf);
$parcel$export(module.exports, "SelectOption", () => $57ec855e5bed70a5$export$11a8a1ea41bf55d8);
$parcel$export(module.exports, "SelectTextInput", () => $57ec855e5bed70a5$export$b34b5c37a9633c78);
$parcel$export(module.exports, "StyledSelectDropButton", () => $57ec855e5bed70a5$export$923536af422910c8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $b5k5v = parcelRequire("b5k5v");

var $kQZ06 = parcelRequire("kQZ06");

var $2O6LY = parcelRequire("2O6LY");
var $jQHd2 = parcelRequire("jQHd2");
var $57ec855e5bed70a5$export$1d41361302b577a1 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledSelect__StyledContainer",
    componentId: "sc-znp66n-0"
})([
    "@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}",
    ";",
    ";"
], function(props) {
    return props.dropHeight ? (0, $2O6LY.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
}, function(props) {
    return props.theme.select.container && props.theme.select.container.extend;
});
var $57ec855e5bed70a5$export$1a780bb4ae54ddec = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledSelect__OptionsContainer",
    componentId: "sc-znp66n-1"
})([
    "position:relative;scroll-behavior:smooth;overflow:auto;outline:none;",
    ";"
], function(props) {
    if (props.selectMultiple) return props.theme.selectMultiple.listbox && props.theme.selectMultiple.listbox.extend;
    return props.theme.select.listbox && props.theme.select.listbox.extend;
});
var $57ec855e5bed70a5$export$7196851310a3d0bf = (0, $f5efw.default).input.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledSelect__HiddenInput",
    componentId: "sc-znp66n-2"
})([
    "display:none;"
]);
var $57ec855e5bed70a5$export$11a8a1ea41bf55d8 = (0, $f5efw.default)((0, $a26J5.Button)).withConfig({
    displayName: "StyledSelect__SelectOption",
    componentId: "sc-znp66n-3"
})([
    "",
    " ",
    " &:focus{",
    "}display:block;width:100%;",
    ";"
], function(props) {
    return props.selected && props.textComponent && (0, $jQHd2.selectedStyle);
}, function(props) {
    return props.active && (0, $jQHd2.getHoverIndicatorStyle)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props.active && (0, $jQHd2.getHoverIndicatorStyle)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props["aria-disabled"] && "cursor: default";
});
var $57ec855e5bed70a5$export$b34b5c37a9633c78 = (0, $f5efw.default)((0, $kQZ06.TextInput)).withConfig({
    displayName: "StyledSelect__SelectTextInput",
    componentId: "sc-znp66n-4"
})([
    "cursor:",
    ";"
], function(props) {
    return props.defaultCursor ? 'default' : 'pointer';
});
var $57ec855e5bed70a5$export$923536af422910c8 = (0, $f5efw.default)((0, $b5k5v.DropButton)).withConfig({
    displayName: "StyledSelect__StyledSelectDropButton",
    componentId: "sc-znp66n-5"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && (0, $2O6LY.controlBorderStyle);
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select2;
    return props.open && ((_props$theme$select2 = props.theme.select) == null || (_props$theme$select2 = _props$theme$select2.control) == null ? void 0 : _props$theme$select2.open);
});

});
parcelRegister("b5k5v", function(module, exports) {

$parcel$export(module.exports, "DropButton", () => $811fbe5d184e5fd0$export$64fff40e709e8b2e);

var $2NacA = parcelRequire("2NacA");

var $a26J5 = parcelRequire("a26J5");

var $isD1Z = parcelRequire("isD1Z");

var $dOlbm = parcelRequire("dOlbm");

var $eS5UQ = parcelRequire("eS5UQ");
var $811fbe5d184e5fd0$var$_excluded = [
    "a11yTitle",
    "onAlign",
    "disabled",
    "dropAlign",
    "dropProps",
    "dropContent",
    "dropTarget",
    "id",
    "open",
    "onClick",
    "onClose",
    "onOpen"
];
function $811fbe5d184e5fd0$var$_extends() {
    return $811fbe5d184e5fd0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $811fbe5d184e5fd0$var$_extends.apply(null, arguments);
}
function $811fbe5d184e5fd0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $811fbe5d184e5fd0$var$defaultDropAlign = {
    top: 'top',
    left: 'left'
};
var $811fbe5d184e5fd0$export$64fff40e709e8b2e = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? 'Open Drop' : _ref$a11yTitle, onAlign = _ref.onAlign, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? $811fbe5d184e5fd0$var$defaultDropAlign : _ref$dropAlign, dropProps = _ref.dropProps, dropContent = _ref.dropContent, dropTarget = _ref.dropTarget, id = _ref.id, open = _ref.open, onClick = _ref.onClick, onClose = _ref.onClose, onOpen = _ref.onOpen, rest = $811fbe5d184e5fd0$var$_objectWithoutPropertiesLoose(_ref, $811fbe5d184e5fd0$var$_excluded);
    var buttonRef = (0, $dOlbm.useForwardedRef)(ref);
    var _useState = (0, $2NacA.useState)(), show = _useState[0], setShow = _useState[1];
    (0, $2NacA.useEffect)(function() {
        if (open !== undefined && open !== show) setShow(open);
    }, [
        open,
        show
    ]);
    var onDropClose = (0, $2NacA.useCallback)(function(event) {
        // if the user has clicked on our Button, don't do anything here,
        // handle that in onClickInternal() below.
        var node = event.composed && event.composedPath()[0] || event.target;
        while(node && node !== document && !(node instanceof ShadowRoot) && node !== buttonRef.current)node = node.parentNode;
        if (node !== buttonRef.current) {
            // don't change internal state if caller is driving
            if (open === undefined) setShow(false);
            if (onClose) onClose(event);
        }
    }, [
        buttonRef,
        onClose,
        open
    ]);
    var onClickInternal = (0, $2NacA.useCallback)(function(event) {
        if (!show) {
            setShow(true);
            if (onOpen) onOpen(event);
        } else {
            setShow(false);
            if (onClose) onClose(event);
        }
        if (onClick) onClick(event);
    }, [
        onClick,
        onClose,
        onOpen,
        show
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), $811fbe5d184e5fd0$var$_extends({
        id: id,
        ref: buttonRef,
        a11yTitle: a11yTitle,
        disabled: disabled
    }, rest, {
        onClick: onClickInternal
    })), show && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $isD1Z.Drop), $811fbe5d184e5fd0$var$_extends({
        id: id ? id + "__drop" : undefined,
        onAlign: onAlign,
        restrictFocus: true,
        align: dropAlign,
        target: dropTarget || buttonRef,
        onClickOutside: onDropClose,
        onEsc: onDropClose
    }, dropProps), dropContent));
});
$811fbe5d184e5fd0$export$64fff40e709e8b2e.displayName = 'DropButton';
$811fbe5d184e5fd0$export$64fff40e709e8b2e.propTypes = (0, $eS5UQ.DropButtonPropTypes);

});
parcelRegister("eS5UQ", function(module, exports) {

$parcel$export(module.exports, "DropButtonPropTypes", () => $ad3ab29e6fbb8795$export$4962ab15dba8ac7);


function $ad3ab29e6fbb8795$var$_extends() {
    return $ad3ab29e6fbb8795$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad3ab29e6fbb8795$var$_extends.apply(null, arguments);
}
var $ad3ab29e6fbb8795$var$PropType = {};
var $ad3ab29e6fbb8795$export$4962ab15dba8ac7 = $ad3ab29e6fbb8795$var$PropType;

});



parcelRegister("4oskf", function(module, exports) {

$parcel$export(module.exports, "applyKey", () => $332f603074986d60$export$f9e47df77939ed56);
$parcel$export(module.exports, "getOptionLabel", () => $332f603074986d60$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $332f603074986d60$export$40be908210c5a79c);
$parcel$export(module.exports, "getOptionIndex", () => $332f603074986d60$export$2921b90f3ed1b63a);
$parcel$export(module.exports, "arrayIncludes", () => $332f603074986d60$export$22012a5c726bef55);
$parcel$export(module.exports, "useDisabled", () => $332f603074986d60$export$c763bb7a184a0f11);
$parcel$export(module.exports, "getNormalizedValue", () => $332f603074986d60$export$49df40d5c24cf7e3);
$parcel$export(module.exports, "changeEvent", () => $332f603074986d60$export$922aead9cd650d86);
$parcel$export(module.exports, "getSelectIcon", () => $332f603074986d60$export$ea6782b1ec892245);
$parcel$export(module.exports, "getDisplayLabelKey", () => $332f603074986d60$export$7e4915d842d2c2e);
$parcel$export(module.exports, "getIconColor", () => $332f603074986d60$export$bb417e0702eb86b5);
$parcel$export(module.exports, "formatValueForA11y", () => $332f603074986d60$export$fe7dc70cd4404dea);
$parcel$export(module.exports, "inertTrueValue", () => $332f603074986d60$export$6f8d7bb3dad10aa1);
$parcel$export(module.exports, "selectInputId", () => $332f603074986d60$export$abfa4f6a3fb2b741);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $d2fh4 = parcelRequire("d2fh4");
var $332f603074986d60$export$f9e47df77939ed56 = function applyKey(option, key) {
    if (/*#__PURE__*/ (0, $2NacA.isValidElement)(option)) return option;
    if (option === undefined || option === null) return undefined;
    if (typeof key === 'object') return $332f603074986d60$export$f9e47df77939ed56(option, key.key);
    if (typeof key === 'function') return key(option);
    if (key !== undefined && typeof option === 'object') return option[key];
    if (typeof option === 'object' && Object.keys(option).length > 0) return option[Object.keys(option)[0]];
    return option;
};
var $332f603074986d60$export$dac6ace3020563ca = function getOptionLabel(index, options, labelKey) {
    return $332f603074986d60$export$f9e47df77939ed56(options[index], labelKey);
};
var $332f603074986d60$export$40be908210c5a79c = function getOptionValue(index, options, valueKey) {
    return $332f603074986d60$export$f9e47df77939ed56(options[index], valueKey);
};
var $332f603074986d60$export$2921b90f3ed1b63a = function getOptionIndex(options, i, valueKey) {
    if (options) {
        if (typeof i === 'object') return options.findIndex(function(x) {
            return $332f603074986d60$export$f9e47df77939ed56(x, valueKey) === $332f603074986d60$export$f9e47df77939ed56(i, valueKey);
        });
        return options.indexOf(i);
    }
    return undefined;
};
var $332f603074986d60$export$22012a5c726bef55 = function arrayIncludes(arr, i, valueKey) {
    if (arr) {
        if (typeof i === 'object') return arr.some(function(x) {
            return $332f603074986d60$export$f9e47df77939ed56(x, valueKey) === $332f603074986d60$export$f9e47df77939ed56(i, valueKey);
        });
        return arr.includes(i);
    }
    return undefined;
};
var $332f603074986d60$export$c763bb7a184a0f11 = function useDisabled(disabled, disabledKey, options, valueKey) {
    return (0, $2NacA.useCallback)(function(index) {
        var option = options[index];
        var result;
        if (disabledKey) result = $332f603074986d60$export$f9e47df77939ed56(option, disabledKey);
        else if (Array.isArray(disabled)) {
            if (typeof disabled[0] === 'number') result = disabled.indexOf(index) !== -1;
            else {
                var optionVal = $332f603074986d60$export$40be908210c5a79c(index, options, valueKey);
                result = $332f603074986d60$export$2921b90f3ed1b63a(disabled, options[index], valueKey) !== -1 || $332f603074986d60$export$2921b90f3ed1b63a(disabled, optionVal, valueKey) !== -1;
            }
        }
        return result;
    }, [
        disabled,
        disabledKey,
        options,
        valueKey
    ]);
};
var $332f603074986d60$export$49df40d5c24cf7e3 = function getNormalizedValue(value, valueKey) {
    if (Array.isArray(value)) return value.map(function(v) {
        return valueKey && valueKey.reduce ? v : $332f603074986d60$export$f9e47df77939ed56(v, valueKey);
    });
    return valueKey && valueKey.reduce ? value : $332f603074986d60$export$f9e47df77939ed56(value, valueKey);
};
var $332f603074986d60$export$922aead9cd650d86 = function changeEvent(inputRef, nextValue) {
    // Calling set value function directly on input because React library
    // overrides setter `event.target.value =` and loses original event
    // target fidelity.
    // https://stackoverflow.com/a/46012210
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(inputRef.current, nextValue);
    var event = new Event('input', {
        bubbles: true
    });
    inputRef.current.dispatchEvent(event);
};
var $332f603074986d60$export$ea6782b1ec892245 = function getSelectIcon(icon, theme, open) {
    var SelectIcon;
    switch(icon){
        case false:
            break;
        case true:
        case undefined:
            SelectIcon = open && theme.select.icons.up ? theme.select.icons.up : theme.select.icons.down;
            break;
        default:
            SelectIcon = icon;
    }
    return SelectIcon;
};
var $332f603074986d60$export$7e4915d842d2c2e = function getDisplayLabelKey(labelKey, allOptions, optionIndexesInValue, selectValue) {
    var optionLabelKey = $332f603074986d60$export$f9e47df77939ed56(allOptions[optionIndexesInValue[0]], labelKey);
    if (!selectValue && optionIndexesInValue.length === 1 && typeof optionLabelKey === 'object') return optionLabelKey;
    return undefined;
};
var $332f603074986d60$export$bb417e0702eb86b5 = function getIconColor(theme) {
    return (0, $d2fh4.normalizeColor)(theme.select.icons.color || 'control', theme);
};
var $332f603074986d60$export$fe7dc70cd4404dea = function formatValueForA11y(value, labelKey) {
    if (typeof value === 'string') return value;
    if (/*#__PURE__*/ (0, $2NacA.isValidElement)(value)) return value.toString();
    if (Array.isArray(value)) return value.map(function(item) {
        return $332f603074986d60$export$fe7dc70cd4404dea(item, labelKey);
    }).join(', ');
    return $332f603074986d60$export$f9e47df77939ed56(value, labelKey);
};
var $332f603074986d60$export$6f8d7bb3dad10aa1 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).use ? true : '';
var $332f603074986d60$export$abfa4f6a3fb2b741 = function selectInputId(id) {
    return id + "__input";
};

});

parcelRegister("bev11", function(module, exports) {

$parcel$export(module.exports, "EmptySearchOption", () => $82d90f8c0f7c1764$export$e87a5b03dc8a6193);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $kS7Ii = parcelRequire("kS7Ii");
function $82d90f8c0f7c1764$var$_extends() {
    return $82d90f8c0f7c1764$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $82d90f8c0f7c1764$var$_extends.apply(null, arguments);
}
var $82d90f8c0f7c1764$export$e87a5b03dc8a6193 = function EmptySearchOption(_ref) {
    var _theme$select, _theme$select2, _theme$select3;
    var emptySearchMessage = _ref.emptySearchMessage, selectOptionsStyle = _ref.selectOptionsStyle, theme = _ref.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), (theme == null || (_theme$select = theme.select) == null || (_theme$select = _theme$select.emptySearchMessage) == null ? void 0 : _theme$select.container) || selectOptionsStyle, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), $82d90f8c0f7c1764$var$_extends({
        "aria-live": "polite",
        role: "alert"
    }, (theme == null || (_theme$select2 = theme.select) == null || (_theme$select2 = _theme$select2.emptySearchMessage) == null ? void 0 : _theme$select2.text) || ((_theme$select3 = theme.select) == null || (_theme$select3 = _theme$select3.options) == null ? void 0 : _theme$select3.text)), emptySearchMessage));
};

});


parcelRegister("jVcXh", function(module, exports) {

$parcel$export(module.exports, "DefaultSelectTextInput", () => $e80d63d4325ba798$export$2307ecc6c2fea308);

var $2NacA = parcelRequire("2NacA");

var $7y130 = parcelRequire("7y130");
var $e80d63d4325ba798$var$_excluded = [
    "disabled",
    "id"
];
function $e80d63d4325ba798$var$_extends() {
    return $e80d63d4325ba798$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e80d63d4325ba798$var$_extends.apply(null, arguments);
}
function $e80d63d4325ba798$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e80d63d4325ba798$export$2307ecc6c2fea308 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var disabled = _ref.disabled, id = _ref.id, rest = $e80d63d4325ba798$var$_objectWithoutPropertiesLoose(_ref, $e80d63d4325ba798$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.SelectTextInput), $e80d63d4325ba798$var$_extends({
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? id + "__input" : undefined,
        ref: ref
    }, rest, {
        tabIndex: "-1",
        type: "text",
        plain: true,
        readOnly: true
    }));
});

});

parcelRegister("mgsBP", function(module, exports) {

$parcel$export(module.exports, "SelectPropTypes", () => $042ed2e397ce3d01$export$e340aafd6bd05c16);

var $lwlwr = parcelRequire("lwlwr");

var $2p9yA = parcelRequire("2p9yA");
function $042ed2e397ce3d01$var$_extends() {
    return $042ed2e397ce3d01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $042ed2e397ce3d01$var$_extends.apply(null, arguments);
}
var $042ed2e397ce3d01$export$257cf46788f4f52b = $042ed2e397ce3d01$var$_extends({}, (0, $2p9yA.genericProps), {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).object
        ]))
    ]),
    disabledKey: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func
    ]),
    dropAlign: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'top',
            'bottom'
        ]),
        bottom: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'top',
            'bottom'
        ]),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'left',
            'right'
        ]),
        left: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'left',
            'right'
        ])
    }),
    dropHeight: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    ]),
    dropTarget: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).object,
    dropProps: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).object,
    emptySearchMessage: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node
    ]),
    focusIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).elementType
    ]),
    labelKey: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func
    ]),
    messages: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
        optionsA11y: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        multiple: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        searchA11y: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        selected: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    }),
    name: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    onMore: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).object
    ])).isRequired,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node
    ]),
    plain: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool,
    searchPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string
    ]),
    valueLabel: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func
    ]),
    valueKey: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({
            key: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).string,
            reduce: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).bool
        })
    ])
});
var $042ed2e397ce3d01$var$PropType = {};
var $042ed2e397ce3d01$export$e340aafd6bd05c16 = $042ed2e397ce3d01$var$PropType;

});


parcelRegister("aFsfQ", function(module, exports) {

$parcel$export(module.exports, "Multimedia", () => $7c43a67ac3ddf520$export$1ab8637ce7e4d8f2);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $7c43a67ac3ddf520$var$_extends() {
    return $7c43a67ac3ddf520$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c43a67ac3ddf520$var$_extends.apply(null, arguments);
}
var $7c43a67ac3ddf520$export$1ab8637ce7e4d8f2 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $7c43a67ac3ddf520$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Multimedia"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M2 8v14h20V9M11 4 7 8M2 4v4h15l4-4H2zm14 0-4 4"
    }));
});
$7c43a67ac3ddf520$export$1ab8637ce7e4d8f2.displayName = 'Multimedia';

});

parcelRegister("az33k", function(module, exports) {

$parcel$export(module.exports, "ModalCard", () => $2c3dc86ba32503e8$export$265e2dc45c2d5635);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $5erKi = parcelRequire("5erKi");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");

var $4Oriw = parcelRequire("4Oriw");

var $1G16z = parcelRequire("1G16z");

var $jGT7M = parcelRequire("jGT7M");
const $2c3dc86ba32503e8$export$265e2dc45c2d5635 = ({ onClose: onClose, loading: loading = false, title: title, icon: icon, saveMessage: saveMessage, textColor: textColor = 'accent-1', iconColor: iconColor, cardProps: cardProps, headerProps: headerProps, headerSubtext: headerSubtext, headerSubtextProps: headerSubtextProps, bodyProps: bodyProps, loadingProps: loadingProps, noLayerComponent: noLayerComponent, children: children })=>{
    /** Render **/ const renderCard = ()=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
            round: (0, $4Oriw.borderRadiusSize),
            background: "light-1",
            width: {
                min: '600px',
                max: '800px'
            },
            height: {
                max: '80vh'
            },
            ...cardProps,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    background: "light-3",
                    direction: "row",
                    align: "center",
                    justify: "between",
                    height: "92px",
                    gap: "medium",
                    style: {
                        zIndex: 1,
                        minHeight: '92px'
                    },
                    elevation: "small",
                    pad: {
                        right: 'medium'
                    },
                    ...headerProps,
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "column",
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    margin: {
                                        left: 'medium'
                                    },
                                    animation: (0, $1G16z.getAnimProps)(0, 'slideUp'),
                                    justify: "start",
                                    align: "center",
                                    direction: "row",
                                    gap: "small",
                                    pad: {
                                        right: 'none'
                                    },
                                    children: [
                                        icon,
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            truncate: true,
                                            size: "xlarge",
                                            children: title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                    height: "2px",
                                    animation: {
                                        type: 'slideRight',
                                        size: 'xlarge'
                                    }
                                }),
                                headerSubtext && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    alignSelf: "end",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        ...headerSubtextProps,
                                        children: headerSubtext
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                size: "medium",
                                color: iconColor
                            }),
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    overflow: {
                        vertical: 'scroll'
                    },
                    pad: "medium",
                    ...bodyProps,
                    children: children
                }),
                loading && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    align: "center",
                    justify: "center",
                    height: "small",
                    ...loadingProps,
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                            color: iconColor
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            margin: {
                                top: 'small'
                            },
                            color: textColor,
                            children: saveMessage || 'Saving changes...'
                        })
                    ]
                })
            ]
        });
    return noLayerComponent ? renderCard() : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: onClose,
        onClickOutside: onClose,
        position: "center",
        modal: true,
        background: "transparent",
        children: renderCard()
    });
};

});
parcelRegister("5erKi", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $3cf3c84a3884408d$export$936d0764594b6eb3);

var $2NacA = parcelRequire("2NacA");

var $l6sdi = parcelRequire("l6sdi");

var $hHZ58 = parcelRequire("hHZ58");

var $cDMMY = parcelRequire("cDMMY");

var $kzTxE = parcelRequire("kzTxE");

var $bv1tZ = parcelRequire("bv1tZ");

var $cBNWv = parcelRequire("cBNWv");

var $2TtMz = parcelRequire("2TtMz");
function $3cf3c84a3884408d$var$_extends() {
    return $3cf3c84a3884408d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3cf3c84a3884408d$var$_extends.apply(null, arguments);
}
var $3cf3c84a3884408d$export$936d0764594b6eb3 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var animate = props.animate, animation = props.animation, _props$modal = props.modal, modal = _props$modal === void 0 ? true : _props$modal, targetChildPosition = props.targetChildPosition;
    var _useState = (0, $2NacA.useState)(), layerContainer = _useState[0], setLayerContainer = _useState[1];
    var containerTarget = (0, $2NacA.useContext)((0, $cBNWv.ContainerTargetContext));
    var originalFocusedElementRef = (0, $2NacA.useRef)(null);
    var focusWithinLayerRef = (0, $2NacA.useRef)(false);
    (0, $2NacA.useEffect)(function() {
        originalFocusedElementRef.current = document.activeElement;
    }, []);
    (0, $2NacA.useEffect)(function() {
        var handleFocusIn = function handleFocusIn(event) {
            if (layerContainer != null && layerContainer.contains != null && layerContainer.contains(event.target)) focusWithinLayerRef.current = true;
        };
        var handleFocusOut = function handleFocusOut(event) {
            if (layerContainer != null && layerContainer.contains != null && layerContainer.contains(event.target) && !layerContainer.contains(event.relatedTarget)) focusWithinLayerRef.current = false;
        };
        document.addEventListener('focusin', handleFocusIn);
        document.addEventListener('focusout', handleFocusOut);
        return function() {
            document.removeEventListener('focusin', handleFocusIn);
            document.removeEventListener('focusout', handleFocusOut);
        };
    }, [
        layerContainer
    ]);
    (0, $2NacA.useEffect)(function() {
        return setLayerContainer((0, $cDMMY.getNewContainer)(containerTarget, targetChildPosition));
    }, [
        containerTarget,
        targetChildPosition
    ]);
    // just a few things to clean up when the Layer is unmounted
    (0, $hHZ58.useLayoutEffect)(function() {
        return function() {
            var originalFocusedElement = originalFocusedElementRef.current;
            if (originalFocusedElement) {
                // Restore focus if:
                // - modal layer (always restore), or
                // - non-modal layer that had focus when it closed
                var shouldRestoreFocus = modal || !modal && focusWithinLayerRef.current;
                if (shouldRestoreFocus && originalFocusedElement.focus) // wait for the fixed positioning to come back to normal
                // see layer styling for reference
                setTimeout(function() {
                    return originalFocusedElement.focus();
                }, 0);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                originalFocusedElement.parentNode.focus();
            }
            if (layerContainer) {
                var activeAnimation = animation !== undefined ? animation : animate;
                if (activeAnimation !== false) {
                    // undefined uses 'slide' as the default
                    // animate out and remove later
                    var layerClone = layerContainer.cloneNode(true);
                    layerClone.id = 'layerClone';
                    containerTarget.appendChild(layerClone);
                    var clonedContainer = layerClone.querySelector('[class*="StyledLayer__StyledContainer"]');
                    if (clonedContainer && clonedContainer.style) clonedContainer.style.animationDirection = 'reverse';
                    setTimeout(function() {
                        // we add the id and query here so the unit tests work
                        var rootNode = containerTarget.getRootNode();
                        // Not all root nodes (ShadowRoot, DocumentFragment)
                        //  have getElementById.
                        if (rootNode && typeof rootNode.getElementById === 'function') {
                            var clone = rootNode.getElementById('layerClone');
                            if (clone) {
                                if (containerTarget.contains(clone)) containerTarget.removeChild(clone);
                                layerContainer.remove();
                            }
                        }
                    }, (0, $bv1tZ.animationDuration));
                } else if (containerTarget.contains(layerContainer)) containerTarget.removeChild(layerContainer);
            }
        };
    }, [
        animate,
        animation,
        containerTarget,
        layerContainer,
        modal
    ]);
    return layerContainer ? /*#__PURE__*/ (0, $l6sdi.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kzTxE.LayerContainer), $3cf3c84a3884408d$var$_extends({
        ref: ref
    }, props, {
        modal: modal
    })), layerContainer) : null;
});
$3cf3c84a3884408d$export$936d0764594b6eb3.displayName = 'Layer';
$3cf3c84a3884408d$export$936d0764594b6eb3.propTypes = (0, $2TtMz.LayerPropTypes);

});
parcelRegister("kzTxE", function(module, exports) {

$parcel$export(module.exports, "LayerContainer", () => $efb228fa5b2e5121$export$802ffc1493ab0ff7);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $hKfeK = parcelRequire("hKfeK");

var $czDw5 = parcelRequire("czDw5");

var $4zRSZ = parcelRequire("4zRSZ");

var $aHKsU = parcelRequire("aHKsU");

var $cBNWv = parcelRequire("cBNWv");

var $hbZKz = parcelRequire("hbZKz");

var $jQHd2 = parcelRequire("jQHd2");
var $cDMMY = parcelRequire("cDMMY");
var $3ZGpZ = parcelRequire("3ZGpZ");
var $2O6LY = parcelRequire("2O6LY");

var $bv1tZ = parcelRequire("bv1tZ");

var $eL6w3 = parcelRequire("eL6w3");
var $efb228fa5b2e5121$var$_excluded = [
    "background",
    "children",
    "full",
    "id",
    "margin",
    "modal",
    "onClickOutside",
    "onEsc",
    "plain",
    "position",
    "responsive",
    "target"
];
function $efb228fa5b2e5121$var$_extends() {
    return $efb228fa5b2e5121$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $efb228fa5b2e5121$var$_extends.apply(null, arguments);
}
function $efb228fa5b2e5121$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// The FocusSpan ensures the LayerContainer has focus when
// it is opened for user to start tabbing inside it.
// It helps for escaping the LayerContainer using the keyboard.
// It is hidden visually but still part of the accessibility tree.
var $efb228fa5b2e5121$var$FocusSpan = (0, $f5efw.default).span.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "LayerContainer__FocusSpan",
    componentId: "sc-1srj14c-0"
})([
    "width:0;height:0;overflow:hidden;position:absolute;clip-path:inset(50%);white-space:nowrap;border:0;&:focus{outline:none;}"
]);
var $efb228fa5b2e5121$export$802ffc1493ab0ff7 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var background = _ref.background, children = _ref.children, _ref$full = _ref.full, full = _ref$full === void 0 ? false : _ref$full, id = _ref.id, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 'none' : _ref$margin, modal = _ref.modal, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, plain = _ref.plain, _ref$position = _ref.position, position = _ref$position === void 0 ? 'center' : _ref$position, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, layerTarget = _ref.target, rest = $efb228fa5b2e5121$var$_objectWithoutPropertiesLoose(_ref, $efb228fa5b2e5121$var$_excluded);
    var containerTarget = (0, $2NacA.useContext)((0, $cBNWv.ContainerTargetContext));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var size = (0, $2NacA.useContext)((0, $4zRSZ.ResponsiveContext));
    // layerOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, $2NacA.useContext)((0, $aHKsU.OptionsContext)), layerOptions = _useContext.layer;
    var focusSpanRef = (0, $2NacA.useRef)();
    var containerRef = (0, $2NacA.useRef)();
    var layerRef = (0, $2NacA.useRef)();
    var portalContext = (0, $2NacA.useContext)((0, $3ZGpZ.PortalContext));
    var portalId = (0, $2NacA.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, $2NacA.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var sendAnalytics = (0, $hbZKz.useAnalytics)();
    (0, $2NacA.useEffect)(function() {
        var start = new Date();
        var element = layerRef.current;
        var isHidden = position === 'hidden';
        if (!isHidden) sendAnalytics({
            type: 'layerOpen',
            element: element
        });
        return function() {
            if (!isHidden) sendAnalytics({
                type: 'layerClose',
                element: element,
                elapsed: new Date().getTime() - start.getTime()
            });
        };
    }, [
        sendAnalytics,
        layerRef,
        position
    ]);
    (0, $2NacA.useEffect)(function() {
        if (position !== 'hidden') {
            var node = layerRef.current || containerRef.current || ref.current;
            if (node && node.scrollIntoView) node.scrollIntoView();
            // Once layer is open we make sure it has focus so that you
            // can start tabbing inside the layer. If the caller put focus
            // on an element already, we honor that. Otherwise, we put
            // the focus on the hidden span.
            var element = document.activeElement;
            while(element){
                if (element === containerRef.current) break;
                element = element.parentElement;
            }
            if (modal && !element && focusSpanRef.current) focusSpanRef.current.focus();
        }
    }, [
        modal,
        position,
        ref
    ]);
    (0, $2NacA.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                // check if user click occurred within the layer
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null && attr !== '') clickedPortalId = parseInt(attr, 10);
                else node = node.parentNode;
            }
            if ((clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) && node !== null) // if the click occurred outside of the Layer portal, call
            // the user's onClickOutside function
            onClickOutside(event);
        };
        // if user provides an onClickOutside function, listen for mousedown event
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        if (layerTarget) {
            var updateBounds = function updateBounds() {
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var target = (0, $cDMMY.findVisibleParent)(layerTarget);
                // affects StyledLayer
                var layer = layerRef.current;
                if (layer && target) {
                    // clear prior styling
                    layer.style.left = '';
                    layer.style.top = '';
                    layer.style.bottom = '';
                    layer.style.width = '';
                    // get bounds
                    var targetRect = target.getBoundingClientRect();
                    var layerRect = layer.getBoundingClientRect();
                    // ensure that layer moves with the target
                    layer.style.left = targetRect.left + "px";
                    layer.style.right = windowWidth - targetRect.right + "px";
                    layer.style.top = targetRect.top + "px";
                    layer.style.bottom = windowHeight - targetRect.bottom + "px";
                    layer.style.maxHeight = targetRect.height;
                    layer.style.maxWidth = Math.min(layerRect.width, windowWidth);
                }
            };
            updateBounds();
            window.addEventListener('resize', updateBounds);
            window.addEventListener('scroll', updateBounds, true);
            return function() {
                window.removeEventListener('resize', updateBounds);
                window.removeEventListener('scroll', updateBounds, true);
                if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
            };
        }
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        containerTarget,
        layerTarget,
        onClickOutside,
        portalContext,
        portalId
    ]);
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bv1tZ.StyledContainer), $efb228fa5b2e5121$var$_extends({
        ref: ref || containerRef,
        background: background,
        elevation: theme.layer.container.elevation,
        id: layerOptions && layerOptions.singleId ? id + "__container" : id,
        full: full,
        margin: margin,
        modal: modal
    }, passThemeFlag, rest, {
        position: position,
        plain: plain,
        responsive: responsive,
        layerTarget: layerTarget,
        dir: theme.dir,
        "data-g-portal-id": portalId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($efb228fa5b2e5121$var$FocusSpan, {
        ref: focusSpanRef,
        tabIndex: "-1"
    }), children);
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bv1tZ.StyledLayer), $efb228fa5b2e5121$var$_extends({
        ref: layerRef,
        id: id,
        plain: plain,
        position: position,
        responsive: responsive,
        layerTarget: layerTarget,
        tabIndex: "-1",
        dir: theme.dir
    }, passThemeFlag), modal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bv1tZ.StyledOverlay), $efb228fa5b2e5121$var$_extends({
        plain: plain,
        responsive: responsive,
        onMouseDown: onClickOutside
    }, passThemeFlag)), content);
    if (onEsc) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEsc: onEsc ? function(event) {
            // prevent further capturing or bubbling of event to other
            // child or parent elements
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        target: modal === false ? 'document' : undefined
    }, content);
    var themeContextValue = (0, $2NacA.useMemo)(function() {
        var dark = (0, $jQHd2.backgroundIsDark)(theme.layer.background, theme);
        return $efb228fa5b2e5121$var$_extends({}, theme, {
            dark: dark
        });
    }, [
        theme
    ]);
    if (theme.layer.background) {
        var dark = themeContextValue.dark;
        if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f5efw.ThemeContext).Provider, {
            value: themeContextValue
        }, content);
    }
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $3ZGpZ.PortalContext).Provider, {
        value: nextPortalContext
    }, content);
    var hitResponsiveBreakpoint = responsive && size === theme.layer.responsiveBreakpoint;
    // if layer is responsive and we've hit the breakpoint,
    // the layer will be filling the viewport, so we want to
    // restrict the scroll to the layer and not allow the
    // body to scroll
    if (modal || hitResponsiveBreakpoint) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hKfeK.FocusedContainer), {
        hidden: position === 'hidden',
        restrictScroll: !layerTarget && (modal || hitResponsiveBreakpoint) ? true : undefined,
        trapFocus: true
    }, content);
    return content;
});

});
parcelRegister("bv1tZ", function(module, exports) {

$parcel$export(module.exports, "StyledLayer", () => $85f3bd624fd14217$export$465e4e6abe6afeb6);
$parcel$export(module.exports, "StyledOverlay", () => $85f3bd624fd14217$export$47f426cc93e497b4);
$parcel$export(module.exports, "animationDuration", () => $85f3bd624fd14217$export$82f5c257a11c5515);
$parcel$export(module.exports, "StyledContainer", () => $85f3bd624fd14217$export$1d41361302b577a1);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5h15o = parcelRequire("5h15o");

var $jQHd2 = parcelRequire("jQHd2");
var $2O6LY = parcelRequire("2O6LY");
var $fzxBh = parcelRequire("fzxBh");
var $85f3bd624fd14217$var$hiddenPositionStyle = (0, $f5efw.css)([
    "left:-100%;right:100%;z-index:-1;position:fixed;"
]);
var $85f3bd624fd14217$var$desktopLayerStyle = "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n";
var $85f3bd624fd14217$var$responsiveLayerStyle = "\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n";
var $85f3bd624fd14217$export$465e4e6abe6afeb6 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledLayer",
    componentId: "sc-rmtehz-0"
})([
    "",
    " background:transparent;position:relative;z-index:",
    ";pointer-events:none;outline:none;",
    " ",
    ";"
], (0, $2O6LY.baseStyle), function(props) {
    return props.theme.layer.zIndex;
}, function(props) {
    if (props.position === 'hidden') return $85f3bd624fd14217$var$hiddenPositionStyle;
    var styles = [];
    styles.push($85f3bd624fd14217$var$desktopLayerStyle);
    if (props.responsive && props.theme.layer.responsiveBreakpoint && !props.layerTarget) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        styles.push((0, $fzxBh.breakpointStyle)(breakpoint, $85f3bd624fd14217$var$responsiveLayerStyle));
    }
    return styles;
}, function(props) {
    return props.theme.layer && props.theme.layer.extend;
});
var $85f3bd624fd14217$export$47f426cc93e497b4 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledLayer__StyledOverlay",
    componentId: "sc-rmtehz-1"
})([
    "position:absolute;",
    " top:0px;left:0px;right:0px;bottom:0px;",
    " ",
    " pointer-events:all;will-change:transform;"
], function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        return (0, $fzxBh.breakpointStyle)(breakpoint, 'position: relative;');
    }
    return '';
}, function(props) {
    return props.theme.layer.overlay.backdropFilter && "backdrop-filter: " + props.theme.layer.overlay.backdropFilter + ";";
}, function(props) {
    return !props.plain && props.theme.layer.overlay.background && (0, $jQHd2.backgroundStyle)(props.theme.layer.overlay.background, props.theme);
});
var $85f3bd624fd14217$var$getMargin = function getMargin(margin, theme, position) {
    var axis = position.indexOf('top') !== -1 || position.indexOf('bottom') !== -1 ? 'vertical' : 'horizontal';
    var marginValue = margin[position] || margin[axis] || margin;
    var marginApplied = theme.global.edgeSize[marginValue] || marginValue;
    var marginInTheme = !!theme.global.edgeSize[marginValue];
    return !marginInTheme && typeof marginValue !== 'string' ? 0 : (0, $fzxBh.parseMetricToNum)(marginApplied);
};
var $85f3bd624fd14217$var$getBounds = function getBounds(bounds, margin, theme, position) {
    if (position === void 0) position = undefined;
    if (position) return bounds[position] + $85f3bd624fd14217$var$getMargin(margin, theme, position);
    return {
        bottom: bounds.bottom + $85f3bd624fd14217$var$getMargin(margin, theme, 'bottom'),
        // 'bottom-left': getMargin(margin, theme, 'bottom-left'),
        // 'bottom-right': getMargin(margin, theme, 'bottom-right'),
        end: bounds.right + $85f3bd624fd14217$var$getMargin(margin, theme, 'end'),
        left: bounds.left + $85f3bd624fd14217$var$getMargin(margin, theme, 'left'),
        right: bounds.right + $85f3bd624fd14217$var$getMargin(margin, theme, 'right'),
        start: bounds.left + $85f3bd624fd14217$var$getMargin(margin, theme, 'start'),
        top: bounds.top + $85f3bd624fd14217$var$getMargin(margin, theme, 'top')
    };
};
var $85f3bd624fd14217$var$KEYFRAMES = {
    center: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translateX(-50%) scale(0.8);}100%{transform:translateX(-50%) scale(1);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translateY(-50%) scale(0.8);}100%{transform:translateY(-50) scale(1);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:scale(0.8);}100%{transform:scale(1);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(-50%,-50%) scale(0.8);}100%{transform:translate(-50%,-50%) scale(1);}"
        ])
    },
    top: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    bottom: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    left: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    right: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    start: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    end: {
        vertical: (0, $f5efw.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, $f5efw.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, $f5efw.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, $f5efw.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    }
};
var $85f3bd624fd14217$export$82f5c257a11c5515 = 200;
var $85f3bd624fd14217$var$getAnimationStyle = function getAnimationStyle(props, position, full) {
    var animation = props.animation !== undefined ? props.animation : props.animate;
    if (animation === undefined) animation = 'slide';
    var keys;
    if (animation === 'slide' || animation === true) keys = $85f3bd624fd14217$var$KEYFRAMES[position][full];
    else if (animation === 'fadeIn') keys = (0, $f5efw.keyframes)([
        "0%{opacity:0}100%{opacity:1}"
    ]);
    return keys ? (0, $f5efw.css)([
        "animation:",
        " ",
        "s ease-in-out forwards;"
    ], keys, $85f3bd624fd14217$export$82f5c257a11c5515 / 1000.0) : '';
};
// POSITIONS combines 'position', 'full', and 'margin' properties, since
// they are all interdependent.
// Basically, non-full axes combine 50% position with -50% translation.
// full axes pin to the window edges offset by any margin.
// The keyframe animations are included as they are done via translations
// as well so they must take into account the non-animated positioning.
var $85f3bd624fd14217$var$POSITIONS = {
    center: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translateX(-50%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'center', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translateY(-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'center', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'center', 'true');
            });
        },
        "false": function _false() {
            return (0, $f5efw.css)([
                "top:50%;left:50%;transform:translate(-50%,-50%);",
                ""
            ], function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'center', 'false');
            });
        }
    },
    top: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;top:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.top, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'false');
            });
        }
    },
    bottom: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.top, bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'false');
            });
        }
    },
    left: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'left', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'left', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'left', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'left', 'false');
            });
        }
    },
    right: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'right', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'right', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'right', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'right', 'false');
            });
        }
    },
    start: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'start', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'start', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'start', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "inset-inline-start:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'start', 'false');
            });
        }
    },
    end: {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.end, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'end', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'end', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'end', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.end, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'end', 'false');
            });
        }
    },
    'top-right': {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ";"
            ], bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;right:",
                "px;transform:translateY(0);",
                ";"
            ], bounds.top, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'top-left': {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.left, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'bottom-right': {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "bottom:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        }
    },
    'bottom-left': {
        vertical: function vertical(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, $f5efw.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, $f5efw.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, $f5efw.css)([
                "bottom:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.left, function(props) {
                return $85f3bd624fd14217$var$getAnimationStyle(props, 'bottom', 'true');
            });
        }
    }
};
var $85f3bd624fd14217$var$roundStyle = function roundStyle(data, theme, position, margin) {
    var styles = [];
    var size = data === true ? 'medium' : data;
    // fallback to edgeSize for backwards compatibility
    var round = theme.global[theme.global.radius ? 'radius' : 'edgeSize'][size] || size;
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = round.split(' ').length > 1;
    if (margin === 'none' && !customCSS && theme.layer.border.intelligentRounding === true) {
        if (position === 'bottom') styles.push((0, $f5efw.css)([
            "border-radius:",
            " ",
            " 0 0;"
        ], round, round));
        else if (position === 'bottom-left') styles.push((0, $f5efw.css)([
            "border-radius:0 ",
            " 0 0;"
        ], round));
        else if (position === 'bottom-right') styles.push((0, $f5efw.css)([
            "border-radius:",
            " 0 0 0;"
        ], round));
        else if (position === 'end') // only works on Firefox, what should be fallback?
        styles.push((0, $f5efw.css)([
            "border-start-start-radius:",
            ";border-end-start-radius:",
            ";"
        ], round, round));
        else if (position === 'left') styles.push((0, $f5efw.css)([
            "border-radius:0 ",
            " ",
            " 0;"
        ], round, round));
        else if (position === 'right') styles.push((0, $f5efw.css)([
            "border-radius:",
            " 0 0 ",
            ";"
        ], round, round));
        else if (position === 'start') // only works on Firefox, what should be fallback?
        styles.push((0, $f5efw.css)([
            "border-end-end-radius:",
            ";border-start-end-radius:",
            ";"
        ], round, round));
        else if (position === 'top') styles.push((0, $f5efw.css)([
            "border-radius:0 0 ",
            " ",
            ";"
        ], round, round));
        else if (position === 'top-left') styles.push((0, $f5efw.css)([
            "border-radius:0 0 ",
            " 0;"
        ], round));
        else if (position === 'top-right') styles.push((0, $f5efw.css)([
            "border-radius:0 0 0 ",
            ";"
        ], round));
        else // position is center, apply uniform border-radius
        styles.push((0, $f5efw.css)([
            "border-radius:",
            ";"
        ], round));
    } else // if there's a margin apply uniform border-radius, or if user has supplied
    // a complex CSS string such as "50px 20px" apply this
    styles.push((0, $f5efw.css)([
        "border-radius:",
        ";"
    ], round));
    return styles;
};
var $85f3bd624fd14217$var$bounds = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $85f3bd624fd14217$var$desktopContainerStyle = (0, $f5efw.css)([
    "",
    " max-height:",
    ";max-width:",
    ";",
    ";",
    ";"
], function(props) {
    if (!props.modal && props.position === 'hidden') return $85f3bd624fd14217$var$hiddenPositionStyle;
    return (0, $f5efw.css)([
        "position:",
        ";"
    ], props.modal || props.layerTarget ? 'absolute' : 'fixed');
}, function(props) {
    return "calc(100% - " + $85f3bd624fd14217$var$getBounds($85f3bd624fd14217$var$bounds, props.margin, props.theme, 'top') + "px - " + $85f3bd624fd14217$var$getBounds($85f3bd624fd14217$var$bounds, props.margin, props.theme, 'bottom') + "px)";
}, function(props) {
    return "calc(100% - " + $85f3bd624fd14217$var$getBounds($85f3bd624fd14217$var$bounds, props.margin, props.theme, 'left') + "px - " + $85f3bd624fd14217$var$getBounds($85f3bd624fd14217$var$bounds, props.margin, props.theme, 'right') + "px)";
}, function(props) {
    return props.plain || props.full && props.margin === 'none' ? "border-radius: 0;" : $85f3bd624fd14217$var$roundStyle(props.theme.layer.border.radius, props.theme, props.position, props.margin);
}, function(props) {
    return props.position !== 'hidden' && $85f3bd624fd14217$var$POSITIONS[props.position][props.full]($85f3bd624fd14217$var$getBounds($85f3bd624fd14217$var$bounds, props.margin, props.theme), $85f3bd624fd14217$var$bounds) || '';
});
var $85f3bd624fd14217$var$responsiveContainerStyle = function responsiveContainerStyle(props) {
    return (0, $f5efw.css)([
        "position:relative;max-height:none;max-width:none;border-radius:0;height:",
        ";width:",
        ";"
    ], !props.layerTarget ? '100vh' : '100%', !props.layerTarget ? '100vw' : '100%');
};
var $85f3bd624fd14217$var$elevationStyle = (0, $f5efw.css)([
    "box-shadow:",
    ";"
], function(props) {
    return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][props.theme.layer.container.elevation];
});
var $85f3bd624fd14217$export$1d41361302b577a1 = (0, $f5efw.default).div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, $5h15o.default)(prop) && ![
            'elevation'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledLayer__StyledContainer",
    componentId: "sc-rmtehz-2"
})([
    "",
    " display:flex;flex-direction:column;",
    " ",
    " outline:none;pointer-events:all;z-index:",
    ";",
    " ",
    " ",
    ";",
    ";"
], function(props) {
    return !props.modal ? (0, $2O6LY.baseStyle) : '';
}, function(props) {
    return (0, $2O6LY.heightStyle)(props.theme.layer.container.height, props.theme);
}, function(props) {
    return !props.plain && (props.background || props.theme.layer.background) && (0, $jQHd2.backgroundStyle)(props.background || props.theme.layer.background, props.theme);
}, function(props) {
    return props.theme.layer.container.zIndex;
}, function(props) {
    return !props.plain && props.theme.layer.container.elevation && $85f3bd624fd14217$var$elevationStyle;
}, $85f3bd624fd14217$var$desktopContainerStyle, function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        if (breakpoint) return (0, $fzxBh.breakpointStyle)(breakpoint, $85f3bd624fd14217$var$responsiveContainerStyle);
    }
    return '';
}, function(props) {
    return props.theme.layer.container && props.theme.layer.container.extend;
});

});


parcelRegister("2TtMz", function(module, exports) {

$parcel$export(module.exports, "LayerPropTypes", () => $21b7d1f675f97a90$export$413e9102c6e92d1b);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0


var $21b7d1f675f97a90$var$PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large'
];
var $21b7d1f675f97a90$var$PropType = {};
var $21b7d1f675f97a90$export$413e9102c6e92d1b = $21b7d1f675f97a90$var$PropType;

});


parcelRegister("1G16z", function(module, exports) {

$parcel$export(module.exports, "getAnimProps", () => $b8b1b715712a0f42$export$2b676560d47a3067);
$parcel$export(module.exports, "getRightStatusColor", () => $b8b1b715712a0f42$export$d01b9dd2724a438e);
parcelRequire("hcQWc");
var $cVyZf = parcelRequire("cVyZf");
const $b8b1b715712a0f42$export$2b676560d47a3067 = (delay = 0, type, duration = 300, withFadeIn = true)=>withFadeIn ? [
        {
            type: 'fadeIn'
        },
        {
            type: type || 'slideDown',
            size: 'large',
            duration: 300,
            delay: delay
        }
    ] : {
        type: type || 'slideDown',
        size: 'large',
        duration: duration,
        delay: delay
    };
const $b8b1b715712a0f42$export$d01b9dd2724a438e = (status)=>{
    switch(status){
        case (0, $cVyZf.RightStatus).ACTIVE:
            return 'status-ok';
        case (0, $cVyZf.RightStatus).EXPIRED:
            return 'status-critical';
        case (0, $cVyZf.RightStatus).RELEASED:
            return 'dark-3';
        default:
            return '';
    }
};

});





parcelRegister("3W9FZ", function(module, exports) {

$parcel$export(module.exports, "ConfirmModal", () => $60d8cf739bdf0b09$export$8eec1a3a911975a4);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");
const $60d8cf739bdf0b09$export$8eec1a3a911975a4 = ({ content: content, confirmLabel: confirmLabel, cancelLabel: cancelLabel, onConfirm: onConfirm, onCancel: onCancel })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: onCancel,
        onClickOutside: onCancel,
        position: "center",
        margin: "large",
        modal: true,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            pad: "medium",
            gap: "medium",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: content
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    align: "center",
                    justify: "end",
                    gap: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: confirmLabel || 'Confirm',
                            onClick: onConfirm,
                            primary: true
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: cancelLabel || 'Cancel',
                            onClick: onCancel
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("6kgbt", function(module, exports) {

$parcel$export(module.exports, "CreditPackageModal", () => $b0d8d21493f9b678$export$c4dbf64c088eda0);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $hIlrL = parcelRequire("hIlrL");
var $2bcjL = parcelRequire("2bcjL");
var $5erKi = parcelRequire("5erKi");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");
const $b0d8d21493f9b678$var$PackageCard = ({ pkg: pkg, hourlyRateInPennies: hourlyRateInPennies, selected: selected, onSelect: onSelect })=>{
    const totalCents = pkg.hours * hourlyRateInPennies;
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        background: selected ? 'accent-1' : 'light-2',
        pad: "medium",
        round: "small",
        border: {
            color: selected ? 'brand' : 'light-4',
            size: 'small'
        },
        onClick: onSelect,
        hoverIndicator: true,
        focusIndicator: false,
        margin: {
            bottom: 'xsmall'
        },
        direction: "row",
        justify: "between",
        align: "center",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        weight: "bold",
                        children: pkg.name
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "small",
                        children: [
                            pkg.hours,
                            " hours of Talent Manager time"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                align: "end",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "large",
                        weight: "bold",
                        children: [
                            "$",
                            (totalCents / 100).toFixed(0)
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "dark-4",
                        children: [
                            "$",
                            (hourlyRateInPennies / 100).toFixed(0),
                            "/hr"
                        ]
                    })
                ]
            })
        ]
    });
};
const $b0d8d21493f9b678$export$c4dbf64c088eda0 = (0, $j8yBr.observer)(({ engagementId: engagementId, hourlyRateInPennies: hourlyRateInPennies, onClose: onClose })=>{
    const tmStore = (0, $8DltC.useTalentManagerStore)();
    const [selectedId, setSelectedId] = (0, $2NacA.useState)(null);
    const [redirecting, setRedirecting] = (0, $2NacA.useState)(false);
    (0, $2NacA.useEffect)(()=>{
        tmStore.fetchCreditPackages();
    }, []);
    const handleCheckout = async ()=>{
        if (!selectedId) return;
        setRedirecting(true);
        const url = await tmStore.createCheckout(selectedId, engagementId, `${window.location.origin}${window.location.pathname}`);
        if (url) window.location.href = url;
        else setRedirecting(false);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: onClose,
        onClickOutside: onClose,
        modal: true,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
            width: "medium",
            background: "light-1",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                    pad: "medium",
                    justify: "between",
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            weight: "bold",
                            size: "large",
                            children: "Buy Credits"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                            onClick: onClose,
                            cursor: "pointer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                    pad: "medium",
                    children: [
                        tmStore.creditPackages.length === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            align: "center",
                            pad: "medium",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {})
                        }) : tmStore.creditPackages.map((pkg)=>/*#__PURE__*/ (0, $6ir3O.jsx)($b0d8d21493f9b678$var$PackageCard, {
                                pkg: pkg,
                                hourlyRateInPennies: hourlyRateInPennies,
                                selected: selectedId === pkg.id,
                                onSelect: ()=>setSelectedId(pkg.id)
                            }, pkg.id)),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "xsmall",
                            color: "dark-4",
                            margin: {
                                top: 'small'
                            },
                            children: "Credits are billed weekly. Unused minutes carry forward."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hIlrL.CardFooter), {
                    pad: "medium",
                    justify: "end",
                    gap: "small",
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Cancel",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            primary: true,
                            label: redirecting ? "Redirecting\u2026" : 'Proceed to Checkout',
                            onClick: handleCheckout,
                            disabled: !selectedId || redirecting
                        })
                    ]
                })
            ]
        })
    });
});

});

parcelRegister("1sflP", function(module, exports) {

$parcel$export(module.exports, "CreateSelect", () => $e3783919090fef1e$export$1bb31a07c14c5f43);

var $6ir3O = parcelRequire("6ir3O");

var $2NacA = parcelRequire("2NacA");

var $fdtj0 = parcelRequire("fdtj0");
const $e3783919090fef1e$export$1bb31a07c14c5f43 = ({ defaultOptions: defaultOptions, defaultValue: defaultValue = '', placeholder: placeholder, id: id, required: required, name: name, onChange: onChange })=>{
    // the prefix name of the Create option entry
    const prefix = ' Create ';
    const updateCreateOption = (text)=>{
        const len = defaultOptions.length;
        if (len && defaultOptions[len - 1].includes(prefix)) // remove Create option before adding an updated one
        defaultOptions.pop();
        defaultOptions.push(`${prefix}'${text}'`);
    };
    // improving Search support of special characters
    const getRegExp = (text)=>{
        // The line below escapes regular expression special characters:
        // [ \ ^ $ . | ? * + ( )
        const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
        // Create the regular expression with modified value which
        // handles escaping special characters. Without escaping special
        // characters, errors will appear in the console
        return new RegExp(escapedText, 'i');
    };
    const [options, setOptions] = (0, $2NacA.useState)(defaultOptions);
    const [value, setValue] = (0, $2NacA.useState)(defaultValue);
    const [searchValue, setSearchValue] = (0, $2NacA.useState)('');
    (0, $2NacA.useEffect)(()=>{
        setOptions(defaultOptions);
        setValue(defaultValue);
    }, [
        defaultOptions,
        defaultValue
    ]);
    const handleSearch = (text)=>{
        updateCreateOption(text);
        const exp = getRegExp(text);
        setOptions(defaultOptions.filter((o)=>exp.test(o)));
        setSearchValue(text);
    };
    const handleSelection = (option)=>{
        if (option.includes(prefix)) {
            defaultOptions.pop(); // remove Create option
            defaultOptions.push(searchValue);
            setValue(searchValue);
            onChange && onChange(searchValue);
        } else {
            setValue(option);
            onChange && onChange(option);
        }
        setSearchValue('');
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
        id: id,
        placeholder: placeholder || 'Select',
        value: value,
        options: options,
        onChange: ({ option: option })=>handleSelection(option),
        onClose: ()=>setOptions(defaultOptions.filter((o)=>!o.includes(prefix))),
        onSearch: (text)=>handleSearch(text),
        required: required,
        plain: true,
        name: name
    });
};

});

parcelRegister("iscco", function(module, exports) {

$parcel$export(module.exports, "CurrencyInput", () => $6be87416fe1722b6$export$498b61b4b30ac8a7);

var $6ir3O = parcelRequire("6ir3O");

var $kQZ06 = parcelRequire("kQZ06");

var $2NacA = parcelRequire("2NacA");

var $b1rqt = parcelRequire("b1rqt");
const $6be87416fe1722b6$export$498b61b4b30ac8a7 = ({ currencyDecimals: currencyDecimals = true, value: val, onChange: onChange, ...textInputProps })=>{
    /** State **/ const [value, setValue] = (0, $2NacA.useState)(val !== undefined && val !== null ? (0, $b1rqt.formatCurrency)(Number(val), currencyDecimals) : '');
    // Caret position to restore after currency reformatting (currency edit mode only).
    const [selection, setSelection] = (0, $2NacA.useState)(null);
    /** Refs **/ const inputRef = (0, $2NacA.useRef)(null);
    /** Methods **/ const numericOnChange = onChange;
    const handleChange = (e)=>{
        if (currencyDecimals) {
            // ATM-style fixed-decimal entry: digits shift in from the right of the fixed decimal.
            const prevDisplay = String(value);
            const oldCents = Math.round(((0, $b1rqt.parseCurrency)(prevDisplay) || 0) * 100);
            const oldDigits = prevDisplay.replace(/[^0-9]/g, '');
            const newStr = e.target.value;
            const newDigits = newStr.replace(/[^0-9]/g, '');
            let cents;
            if (newDigits.length === oldDigits.length + 1 && newDigits.startsWith(oldDigits)) {
                // A digit was appended at the end -> shift left by one decimal place.
                const d = parseInt(newDigits.slice(-1), 10);
                cents = oldCents * 10 + d;
            } else if (oldDigits.length === newDigits.length + 1 && oldDigits.startsWith(newDigits)) // A digit was removed (backspace) -> shift right by one decimal place.
            cents = Math.floor(oldCents / 10);
            else // Paste / select-replace / clear -> reparse the whole string, defaulting to 0.
            cents = Math.round(((0, $b1rqt.parseCurrency)(newStr) || 0) * 100);
            const formatted = (0, $b1rqt.formatCurrency)(cents / 100, true);
            setValue(formatted);
            setSelection([
                formatted.length,
                formatted.length
            ]);
            numericOnChange?.(cents / 100);
            return;
        }
        // Whole-dollar mode: live comma formatting with caret preservation.
        const caret = e.target.selectionStart ?? e.target.value.length;
        const sigBefore = (0, $b1rqt.countSig)(e.target.value.slice(0, caret));
        const raw = (0, $b1rqt.sanitizeNumeric)(e.target.value);
        const formatted = (0, $b1rqt.formatCurrency)((0, $b1rqt.parseCurrency)(raw) || 0, false);
        const newCaret = (0, $b1rqt.indexOfSig)(formatted, sigBefore);
        setValue(formatted);
        setSelection([
            newCaret,
            newCaret
        ]);
        numericOnChange?.((0, $b1rqt.parseCurrency)(raw) || 0);
        return;
    };
    /** Effects **/ // Restore caret after currency reformatting renders the new value.
    (0, $2NacA.useLayoutEffect)(()=>{
        if (selection && inputRef.current) {
            inputRef.current.selectionStart = selection[0];
            inputRef.current.selectionEnd = selection[1];
        }
    }, [
        selection,
        value
    ]);
    // Re-sync the displayed value when the controlled `value` prop changes from outside.
    (0, $2NacA.useEffect)(()=>{
        if (val === undefined || val === null) return;
        setValue((0, $b1rqt.formatCurrency)(Number(val), currencyDecimals));
    }, [
        val,
        currencyDecimals
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
        ref: inputRef,
        value: value,
        onChange: handleChange,
        type: "text",
        plain: true,
        ...textInputProps
    });
};

});

parcelRegister("2X1oe", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $cooA3 = parcelRequire("cooA3");
var $b5k5v = parcelRequire("b5k5v");
var $czDw5 = parcelRequire("czDw5");
var $2fsW3 = parcelRequire("2fsW3");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbE4G = parcelRequire("kbE4G");
parcelRequire("ibR9R");
var $d2VmQ = parcelRequire("d2VmQ");
const $4566122255b2ad2d$var$DropContent = ({ date: initialDate, time: initialTime, onClose: onClose, bounds: bounds, disabled: disabled })=>{
    const [date, setDate] = (0, $2NacA.useState)();
    const [time, setTime] = (0, $2NacA.useState)();
    const [isTimeValid, setIsTimeValid] = (0, $2NacA.useState)(false);
    const close = ()=>onClose(date || initialDate, time || initialTime);
    const validateAndSetTime = (t)=>{
        const h = parseInt(t.split(':')[0], 10);
        const m = parseInt(t.split(':')[1], 10);
        const ampm = t.split(' ')[1];
        setIsTimeValid(h >= 1 && h <= 12 && m >= 0 && m <= 59 && (ampm === 'am' || ampm === 'pm'));
        setTime(t);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cooA3.Calendar), {
                animate: false,
                date: date || initialDate,
                onSelect: (d)=>!Array.isArray(d) ? setDate(new Date(d).toISOString()) : undefined,
                showAdjacentDays: false,
                locale: "en-US",
                size: "small",
                bounds: bounds,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                flex: false,
                pad: "small",
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $czDw5.Keyboard), {
                        onEnter: (event)=>{
                            event.preventDefault(); // so drop doesn't re-open
                            close();
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2fsW3.MaskedInput), {
                            mask: [
                                {
                                    length: [
                                        1,
                                        2
                                    ],
                                    options: [
                                        '1',
                                        '2',
                                        '3',
                                        '4',
                                        '5',
                                        '6',
                                        '7',
                                        '8',
                                        '9',
                                        '10',
                                        '11',
                                        '12'
                                    ],
                                    regexp: /^1[1-2]$|^[0-9]$/,
                                    placeholder: 'hh',
                                    restrictToOptions: true
                                },
                                {
                                    fixed: ':'
                                },
                                {
                                    length: 2,
                                    options: [
                                        '00',
                                        '15',
                                        '30',
                                        '45'
                                    ],
                                    regexp: /^[0-5][0-9]$|^[0-9]$/,
                                    placeholder: 'mm'
                                },
                                {
                                    fixed: ' '
                                },
                                {
                                    length: 2,
                                    options: [
                                        'am',
                                        'pm'
                                    ],
                                    regexp: /^[ap]m$|^[AP]M$|^[aApP]$/,
                                    placeholder: 'am/pm'
                                }
                            ],
                            value: time || initialTime,
                            name: "maskedInput",
                            onChange: (event)=>validateAndSetTime(event.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        flex: false,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Done",
                            onClick: close,
                            disabled: !isTimeValid
                        })
                    })
                ]
            })
        ]
    });
};
const $4566122255b2ad2d$export$bb6b51d0644c34ac = ({ placeholder: placeholder, date: initialDate, time: initialTime, onChange: onChange, bounds: bounds, disabled: disabled })=>{
    const [date, setDate] = (0, $2NacA.useState)(initialDate || '');
    const [time, setTime] = (0, $2NacA.useState)(initialTime || '');
    const [open, setOpen] = (0, $2NacA.useState)(false);
    const [label, setLabel] = (0, $2NacA.useState)(placeholder || 'Select date & time');
    const onClose = (nextDate, nextTime)=>{
        setDate(nextDate);
        setTime(nextTime);
        setOpen(false);
        setTimeout(()=>setOpen(false), 1);
        const d = new Date(nextDate);
        const h = parseInt(nextTime.split(':')[0], 10);
        const m = parseInt(nextTime.split(':')[1], 10);
        const ampm = nextTime.split(' ')[1];
        if (ampm === 'pm' && h < 12) d.setHours(h + 12);
        else if (ampm === 'am' && h === 12) d.setHours(0);
        else d.setHours(h);
        d.setMinutes(m);
        onChange(d);
    };
    (0, $2NacA.useEffect)(()=>{
        if (date && time) {
            if (date === initialDate) setLabel(time);
            else setLabel(`${new Date(date).toLocaleDateString()} ${time}`);
        } else setLabel(placeholder || 'Select date & time');
    }, [
        date,
        time,
        initialDate,
        placeholder
    ]);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        align: "center",
        pad: "small",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5k5v.DropButton), {
            open: open,
            onClose: ()=>setOpen(false),
            onOpen: ()=>setOpen(true),
            dropContent: /*#__PURE__*/ (0, $6ir3O.jsx)($4566122255b2ad2d$var$DropContent, {
                date: date,
                time: time,
                onClose: onClose,
                bounds: bounds,
                disabled: disabled
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "medium",
                align: "center",
                pad: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        color: date ? undefined : 'dark-2',
                        children: label
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: placeholder
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbE4G.Schedule), {})
                    })
                ]
            })
        })
    });
};

});
parcelRegister("cooA3", function(module, exports) {

$parcel$export(module.exports, "getOutputFormat", () => $905acb1ecf697942$export$c0c99f9031a45b3);
$parcel$export(module.exports, "Calendar", () => $905acb1ecf697942$export$e1aef45b828286de);

var $2NacA = parcelRequire("2NacA");

var $7oNsG = parcelRequire("7oNsG");

var $2M0UK = parcelRequire("2M0UK");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $5ebSC = parcelRequire("5ebSC");

var $1fLUh = parcelRequire("1fLUh");

var $czDw5 = parcelRequire("czDw5");

var $kS7Ii = parcelRequire("kS7Ii");

var $llAEj = parcelRequire("llAEj");

var $7Yc9w = parcelRequire("7Yc9w");

var $iDJvK = parcelRequire("iDJvK");

var $3XT4P = parcelRequire("3XT4P");

var $eL6w3 = parcelRequire("eL6w3");
var $905acb1ecf697942$var$_excluded = [
    "activeDate",
    "animate",
    "bounds",
    "children",
    "date",
    "dates",
    "daysOfWeek",
    "disabled",
    "initialFocus",
    "fill",
    "firstDayOfWeek",
    "header",
    "level",
    "locale",
    "messages",
    "onReference",
    "onSelect",
    "range",
    "reference",
    "responsive",
    "showAdjacentDays",
    "size",
    "timestamp"
], $905acb1ecf697942$var$_excluded2 = [
    "container"
];
function $905acb1ecf697942$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $905acb1ecf697942$var$_extends() {
    return $905acb1ecf697942$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $905acb1ecf697942$var$_extends.apply(null, arguments);
}
var $905acb1ecf697942$var$getLocaleString = function getLocaleString(value, locale) {
    return value == null ? void 0 : value.toLocaleDateString(locale, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};
var $905acb1ecf697942$var$currentlySelectedString = function currentlySelectedString(value, locale) {
    var selected;
    if (value instanceof Date) selected = "Currently selected " + $905acb1ecf697942$var$getLocaleString(value, locale) + ";";
    else if (value != null && value.length) selected = "Currently selected " + value.map(function(item) {
        var dates;
        if (!Array.isArray(item)) dates = "" + $905acb1ecf697942$var$getLocaleString(item, locale);
        else {
            var start = item[0] !== undefined ? $905acb1ecf697942$var$getLocaleString(item[0], locale) : 'none';
            var end = item[1] !== undefined ? $905acb1ecf697942$var$getLocaleString(item[1], locale) : 'none';
            dates = start + " through " + end;
        }
        return dates;
    });
    else selected = 'No date selected';
    return selected;
};
// calendar value may be a single date, multiple dates, a range of dates
// supplied as ISOstrings.
var $905acb1ecf697942$var$_normalizeInput = function normalizeInput(dateValue) {
    var result;
    if (dateValue instanceof Date) result = dateValue;
    else if (typeof dateValue === 'string' && dateValue.length) result = (0, $3XT4P.setHoursWithOffset)(dateValue);
    else if (Array.isArray(dateValue)) result = dateValue.map(function(d) {
        return $905acb1ecf697942$var$_normalizeInput(d);
    });
    return result;
};
var $905acb1ecf697942$var$_normalizeOutput = function normalizeOutput(dateValue, outputFormat) {
    var result;
    var normalize = function normalize(value) {
        var normalizedValue = value.toISOString();
        if (normalizedValue && outputFormat === 'no timezone') {
            var _handleOffset$toISOSt = (0, $iDJvK.handleOffset)(normalizedValue).toISOString().split('T');
            normalizedValue = _handleOffset$toISOSt[0];
        }
        return normalizedValue;
    };
    if (dateValue instanceof Date) result = normalize(dateValue);
    else if (typeof dateValue === 'undefined') result = undefined;
    else result = dateValue.map(function(d) {
        return $905acb1ecf697942$var$_normalizeOutput(d, outputFormat);
    });
    return result;
};
// format value to [[]] for internal functions
var $905acb1ecf697942$var$normalizeRange = function normalizeRange(value, activeDate) {
    var range = value;
    if (range instanceof Date) range = activeDate === 'start' ? [
        [
            undefined,
            range
        ]
    ] : [
        [
            range,
            undefined
        ]
    ];
    else if (Array.isArray(range) && !Array.isArray(range[0])) range = [
        range
    ];
    return range;
};
var $905acb1ecf697942$var$getReference = function getReference(reference, onReference, value, activeDate) {
    var nextReference;
    if (reference && onReference) // controlled component, so use the reference provided
    nextReference = reference;
    else if (value) {
        if (Array.isArray(value)) {
            if (value[0] instanceof Date) {
                // if we just selected an end date, active date will be 'start'
                // and we should set the reference to the end date
                if (activeDate === 'start' && value[1] instanceof Date) nextReference = value[1];
                else nextReference = value[0];
            } else if (Array.isArray(value[0])) {
                // if we just selected an end date, active date will be 'start'
                // and we should set the reference to the end date
                if (activeDate === 'start' && value[0][1]) // eslint-disable-next-line prefer-destructuring
                nextReference = value[0][1];
                else nextReference = value[0][0] ? value[0][0] : value[0][1];
            } else {
                nextReference = new Date();
                nextReference.setHours(0, 0, 0, 0);
            }
        } else nextReference = value;
    } else if (reference) nextReference = reference;
    else {
        nextReference = new Date();
        nextReference.setHours(0, 0, 0, 0);
    }
    return nextReference;
};
var $905acb1ecf697942$var$buildDisplayBounds = function buildDisplayBounds(reference, firstDayOfWeek) {
    var start = new Date(reference);
    start.setDate(1); // first of month
    // In case Sunday is the first day of the month, and the user asked for Monday
    // to be the first day of the week, then we need to include Sunday and six
    // days prior.
    start = start.getDay() === 0 && firstDayOfWeek === 1 ? start = (0, $iDJvK.subtractDays)(start, 6) : // beginning of week
    start = (0, $iDJvK.subtractDays)(start, start.getDay() - firstDayOfWeek);
    var end = (0, $iDJvK.addDays)(start, 42); // 5 weeks to end of week
    return [
        start,
        end
    ];
};
var $905acb1ecf697942$var$monthBounds = function monthBounds(reference) {
    var start = new Date(reference);
    start.setDate(1); // first of month
    var end = (0, $iDJvK.endOfMonth)(start);
    return [
        start,
        end
    ];
};
var $905acb1ecf697942$var$disabledCalendarPreviousMonthButton = function disabledCalendarPreviousMonthButton(date, reference, bounds) {
    if (!bounds) return false;
    var lastBound = new Date(bounds[1]);
    return !(0, $iDJvK.sameDayOrBefore)(lastBound, reference) && !(0, $iDJvK.betweenDates)(date, bounds);
};
var $905acb1ecf697942$var$disabledCalendarNextMonthButton = function disabledCalendarNextMonthButton(date, reference, bounds) {
    if (!bounds) return false;
    var firstBound = new Date(bounds[0]);
    return !(0, $iDJvK.sameDayOrAfter)(firstBound, reference) && !(0, $iDJvK.betweenDates)(date, bounds);
};
var $905acb1ecf697942$export$c0c99f9031a45b3 = function getOutputFormat(dates) {
    if (typeof dates === 'string' && (dates == null ? void 0 : dates.indexOf('T')) === -1) return 'no timezone';
    if (Array.isArray(dates)) return $905acb1ecf697942$export$c0c99f9031a45b3(dates[0]);
    return 'date timezone';
};
var $905acb1ecf697942$var$millisecondsPerYear = 31557600000;
var $905acb1ecf697942$var$CalendarDay = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.activeProp, children = _ref.children, day = _ref.day, disabledProp = _ref.disabledProp, fill = _ref.fill, size = _ref.size, isInRange = _ref.isInRange, isSelected = _ref.isSelected, otherMonth = _ref.otherMonth, rangePosition = _ref.rangePosition, _ref$buttonProps = _ref.buttonProps, buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps, responsive = _ref.responsive;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayContainer), {
        role: "gridcell",
        "aria-selected": isSelected,
        inRange: isInRange,
        isSelected: isSelected,
        rangePosition: rangePosition,
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayButton), $905acb1ecf697942$var$_extends({
        "aria-disabled": disabledProp,
        disabledProp: disabledProp,
        fill: fill,
        plain: true,
        tabIndex: (activeProp == null ? void 0 : activeProp.getTime()) === (day == null ? void 0 : day.getTime()) ? 0 : -1,
        responsive: responsive
    }, buttonProps, {
        ref: (activeProp == null ? void 0 : activeProp.getTime()) === (day == null ? void 0 : day.getTime()) ? ref : undefined
    }), function(_ref2) {
        var hover = _ref2.hover;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDay), $905acb1ecf697942$var$_extends({
            disabledProp: disabledProp,
            hover: hover,
            inRange: isInRange,
            isSelected: isSelected,
            otherMonth: otherMonth,
            sizeProp: size,
            fillContainer: fill,
            responsive: responsive
        }, passThemeFlag), children);
    }));
});
var $905acb1ecf697942$var$CalendarCustomDay = function CalendarCustomDay(_ref3) {
    var ariaSelected = _ref3['aria-selected'], children = _ref3.children, fill = _ref3.fill, size = _ref3.size, buttonProps = _ref3.buttonProps, responsive = _ref3.responsive;
    if (!buttonProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayContainer), {
        "aria-selected": ariaSelected,
        role: "gridcell",
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayContainer), {
        "aria-selected": ariaSelected,
        role: "gridcell",
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayButton), $905acb1ecf697942$var$_extends({
        fill: fill,
        responsive: responsive
    }, buttonProps), children));
};
var $905acb1ecf697942$export$e1aef45b828286de = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref4, ref) {
    var activeDateProp = _ref4.activeDate, _ref4$animate = _ref4.animate, animate = _ref4$animate === void 0 ? true : _ref4$animate, boundsProp = _ref4.bounds, children = _ref4.children, dateProp = _ref4.date, datesProp = _ref4.dates, daysOfWeek = _ref4.daysOfWeek, disabled = _ref4.disabled, initialFocus = _ref4.initialFocus, fill = _ref4.fill, _ref4$firstDayOfWeek = _ref4.firstDayOfWeek, firstDayOfWeek = _ref4$firstDayOfWeek === void 0 ? 0 : _ref4$firstDayOfWeek, header = _ref4.header, level = _ref4.level, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? 'en-US' : _ref4$locale, messages = _ref4.messages, onReference = _ref4.onReference, onSelect = _ref4.onSelect, range = _ref4.range, referenceProp = _ref4.reference, _ref4$responsive = _ref4.responsive, responsiveProp = _ref4$responsive === void 0 ? true : _ref4$responsive, _ref4$showAdjacentDay = _ref4.showAdjacentDays, showAdjacentDays = _ref4$showAdjacentDay === void 0 ? true : _ref4$showAdjacentDay, _ref4$size = _ref4.size, size = _ref4$size === void 0 ? 'medium' : _ref4$size, timestampProp = _ref4.timestamp, rest = $905acb1ecf697942$var$_objectWithoutPropertiesLoose(_ref4, $905acb1ecf697942$var$_excluded);
    var _useThemeValue2 = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    // If fill is true the responsive behavior isn't needed.
    var responsive = responsiveProp && !fill;
    // set activeDate when caller changes it, allows us to change
    // it internally too
    var _useState = (0, $2NacA.useState)(dateProp && typeof dateProp === 'string' && range ? 'end' : 'start'), activeDate = _useState[0], setActiveDate = _useState[1];
    (0, $2NacA.useEffect)(function() {
        if (activeDateProp) setActiveDate(activeDateProp);
    }, [
        activeDateProp
    ]);
    var _useState2 = (0, $2NacA.useState)($905acb1ecf697942$var$_normalizeInput(dateProp || datesProp)), value = _useState2[0], setValue = _useState2[1];
    (0, $2NacA.useEffect)(function() {
        var val = dateProp || datesProp;
        setValue($905acb1ecf697942$var$_normalizeInput(val));
    }, [
        dateProp,
        datesProp
    ]);
    var _useState3 = (0, $2NacA.useState)($905acb1ecf697942$var$getReference($905acb1ecf697942$var$_normalizeInput(referenceProp), onReference, value, activeDate)), reference = _useState3[0], setReference = _useState3[1];
    (0, $2NacA.useEffect)(function() {
        setReference($905acb1ecf697942$var$getReference($905acb1ecf697942$var$_normalizeInput(referenceProp), onReference, value, activeDate));
    }, [
        referenceProp,
        onReference,
        value,
        activeDate
    ]);
    var _useState4 = (0, $2NacA.useState)($905acb1ecf697942$export$c0c99f9031a45b3(dateProp || datesProp)), outputFormat = _useState4[0], setOutputFormat = _useState4[1];
    (0, $2NacA.useEffect)(function() {
        setOutputFormat($905acb1ecf697942$export$c0c99f9031a45b3(dateProp || datesProp));
    }, [
        dateProp,
        datesProp
    ]);
    // normalize bounds
    var _useState5 = (0, $2NacA.useState)(boundsProp), bounds = _useState5[0], setBounds = _useState5[1];
    (0, $2NacA.useEffect)(function() {
        if (boundsProp) setBounds(boundsProp);
        else setBounds(undefined);
    }, [
        boundsProp
    ]);
    // calculate the bounds we display based on the reference
    var _useState6 = (0, $2NacA.useState)($905acb1ecf697942$var$buildDisplayBounds(reference, firstDayOfWeek)), displayBounds = _useState6[0], setDisplayBounds = _useState6[1];
    var _useState7 = (0, $2NacA.useState)(), targetDisplayBounds = _useState7[0], setTargetDisplayBounds = _useState7[1];
    var _useState8 = (0, $2NacA.useState)(), slide = _useState8[0], setSlide = _useState8[1];
    var _useState9 = (0, $2NacA.useState)(), animating = _useState9[0], setAnimating = _useState9[1];
    // When the reference changes, we need to update the displayBounds.
    // This is easy when we aren't animating. If we are animating,
    // we temporarily increase the displayBounds to be the union of the old
    // and new ones and set slide to drive the animation. We keep track
    // of where we are heading via targetDisplayBounds. When the animation
    // finishes, we prune displayBounds down to where we are headed and
    // clear the slide and targetDisplayBounds.
    (0, $2NacA.useEffect)(function() {
        var nextDisplayBounds = $905acb1ecf697942$var$buildDisplayBounds(reference, firstDayOfWeek);
        // Checks if the difference between the current and next DisplayBounds is
        // greater than a year. If that's the case, calendar should update without
        // animation.
        if (nextDisplayBounds[0].getTime() !== displayBounds[0].getTime() && nextDisplayBounds[1].getTime() !== displayBounds[1].getTime()) {
            var diffBoundsAboveYear = false;
            if (nextDisplayBounds[0].getTime() < displayBounds[0].getTime()) {
                if (displayBounds[0].getTime() - nextDisplayBounds[0].getTime() > $905acb1ecf697942$var$millisecondsPerYear) diffBoundsAboveYear = true;
            } else if (nextDisplayBounds[1].getTime() > displayBounds[1].getTime()) {
                if (nextDisplayBounds[1].getTime() - displayBounds[1].getTime() > $905acb1ecf697942$var$millisecondsPerYear) diffBoundsAboveYear = true;
            }
            if (!animate || diffBoundsAboveYear) setDisplayBounds(nextDisplayBounds);
            else setTargetDisplayBounds(nextDisplayBounds);
        }
    }, [
        animate,
        firstDayOfWeek,
        reference,
        displayBounds
    ]);
    (0, $2NacA.useEffect)(function() {
        // if the reference timezone has changed (e.g., controlled component),
        // both ends of the displayBounds should inherit that new timestamp
        if (targetDisplayBounds) {
            if (targetDisplayBounds[0].getTime() < displayBounds[0].getTime() || targetDisplayBounds[1].getTime() > displayBounds[1].getTime()) setDisplayBounds([
                targetDisplayBounds[0],
                targetDisplayBounds[1]
            ]);
            if (targetDisplayBounds[0].getTime() < displayBounds[0].getTime()) // only animate if the duration is within a year
            {
                if (displayBounds[0].getTime() - targetDisplayBounds[0].getTime() < $905acb1ecf697942$var$millisecondsPerYear && (0, $iDJvK.daysApart)(displayBounds[0], targetDisplayBounds[0])) {
                    setSlide({
                        direction: 'down',
                        weeks: (0, $iDJvK.daysApart)(displayBounds[0], targetDisplayBounds[0]) / 7
                    });
                    setAnimating(true);
                }
            } else if (targetDisplayBounds[1].getTime() > displayBounds[1].getTime()) {
                if (targetDisplayBounds[1].getTime() - displayBounds[1].getTime() < $905acb1ecf697942$var$millisecondsPerYear && (0, $iDJvK.daysApart)(targetDisplayBounds[1], displayBounds[1])) {
                    setSlide({
                        direction: 'up',
                        weeks: (0, $iDJvK.daysApart)(targetDisplayBounds[1], displayBounds[1]) / 7
                    });
                    setAnimating(true);
                }
            }
            return undefined;
        }
        setSlide(undefined);
        return undefined;
    }, [
        animating,
        displayBounds,
        targetDisplayBounds
    ]);
    // Last step in updating the displayBounds. Allows for pruning
    // displayBounds and cleaning up states to occur after animation.
    (0, $2NacA.useEffect)(function() {
        if (animating && targetDisplayBounds) {
            // Wait for animation to finish before cleaning up.
            var timer = setTimeout(function() {
                setDisplayBounds(targetDisplayBounds);
                setTargetDisplayBounds(undefined);
                setSlide(undefined);
                setAnimating(false);
            }, 400 // Empirically determined.
            );
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        animating,
        targetDisplayBounds
    ]);
    // We have to deal with reference being the end of a month with more
    // days than the month we are changing to. So, we always set reference
    // to the first of the month before changing the month.
    var previousMonth = (0, $2NacA.useMemo)(function() {
        return (0, $iDJvK.endOfMonth)((0, $iDJvK.subtractMonths)((0, $iDJvK.startOfMonth)(reference), 1));
    }, [
        reference
    ]);
    var nextMonth = (0, $2NacA.useMemo)(function() {
        return (0, $iDJvK.startOfMonth)((0, $iDJvK.addMonths)((0, $iDJvK.startOfMonth)(reference), 1));
    }, [
        reference
    ]);
    var initialFocusDate = showAdjacentDays ? new Date(displayBounds[0]) : (0, $iDJvK.startOfMonth)(reference);
    var _useState0 = (0, $2NacA.useState)(), focus = _useState0[0], setFocus = _useState0[1];
    var _useState1 = (0, $2NacA.useState)(initialFocusDate), active = _useState1[0], setActive = _useState1[1];
    var focusableDateRef = (0, $2NacA.useRef)(undefined);
    (0, $2NacA.useEffect)(function() {
        if (focusableDateRef != null && focusableDateRef.current && initialFocus === 'days') focusableDateRef.current.focus();
    }, [
        initialFocus,
        focusableDateRef
    ]);
    var handleReference = (0, $2NacA.useCallback)(function(nextReference) {
        setReference(nextReference);
        if (onReference) onReference(nextReference.toISOString());
    }, [
        onReference
    ]);
    var changeReference = (0, $2NacA.useCallback)(function(nextReference) {
        if ((0, $iDJvK.betweenDates)(nextReference, bounds)) handleReference(nextReference);
    }, [
        handleReference,
        bounds
    ]);
    var changeCalendarMonth = function changeCalendarMonth(messageId, newMonth) {
        handleReference(newMonth);
        var referenceStartOfMonth = (0, $iDJvK.startOfMonth)(reference);
        var firstOfMonth = new Date(newMonth.getFullYear(), newMonth.getMonth(), 1, referenceStartOfMonth.getHours(), referenceStartOfMonth.getMinutes(), referenceStartOfMonth.getSeconds());
        setActive(firstOfMonth);
        announce(format({
            id: messageId,
            messages: messages,
            values: {
                date: newMonth.toLocaleDateString(locale, {
                    month: 'long',
                    year: 'numeric'
                })
            }
        }));
    };
    var handleRange = (0, $2NacA.useCallback)(function(selectedDate) {
        var _priorRange$, _priorRange$2;
        var result;
        var nextActiveDate = activeDate;
        var priorRange = $905acb1ecf697942$var$normalizeRange(value, activeDate);
        // deselect when date clicked was the start/end of the range
        if (selectedDate.getTime() === (priorRange == null || (_priorRange$ = priorRange[0]) == null || (_priorRange$ = _priorRange$[0]) == null ? void 0 : _priorRange$.getTime())) {
            result = [
                [
                    undefined,
                    priorRange[0][1]
                ]
            ];
            nextActiveDate = 'start';
        } else if (selectedDate.getTime() === (priorRange == null || (_priorRange$2 = priorRange[0]) == null || (_priorRange$2 = _priorRange$2[1]) == null ? void 0 : _priorRange$2.getTime())) {
            result = [
                [
                    priorRange[0][0],
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (activeDate === 'start') {
            if (!priorRange) result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            else if (!priorRange[0][1]) result = [
                [
                    selectedDate,
                    priorRange[0][1]
                ]
            ];
            else if (selectedDate.getTime() < priorRange[0][1].getTime()) result = [
                [
                    selectedDate,
                    priorRange[0][1]
                ]
            ];
            else if (selectedDate.getTime() > priorRange[0][1].getTime()) result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (!priorRange) {
            result = [
                [
                    undefined,
                    selectedDate
                ]
            ];
            nextActiveDate = 'start';
        } else if (selectedDate.getTime() < priorRange[0][0].getTime()) {
            result = [
                [
                    selectedDate,
                    undefined
                ]
            ];
            nextActiveDate = 'end';
        } else if (selectedDate.getTime() > priorRange[0][0].getTime()) {
            result = [
                [
                    priorRange[0][0],
                    selectedDate
                ]
            ];
            nextActiveDate = 'start';
        }
        // If no dates selected, always return undefined; else format
        // result according to specified range value.
        if (result[0].includes(undefined)) {
            if (range === 'array') result = !result[0][0] && !result[0][1] ? undefined : result;
            else result = result[0].find(function(d) {
                return d !== undefined;
            });
        }
        setActiveDate(nextActiveDate);
        setValue(result);
        return [
            result,
            nextActiveDate
        ];
    }, [
        activeDate,
        value,
        range
    ]);
    var selectDate = (0, $2NacA.useCallback)(function(selectedDate) {
        // If no onSelect prop is provided, the calendar should be read-only
        if (!onSelect) return;
        var nextValue;
        var nextActiveDate;
        var details = {};
        if (range || Array.isArray(value == null ? void 0 : value[0])) {
            var _handleRange = handleRange(selectedDate);
            nextValue = _handleRange[0];
            nextActiveDate = _handleRange[1];
            details.activeDate = nextActiveDate;
        } else nextValue = selectedDate;
        if (onSelect) {
            nextValue = $905acb1ecf697942$var$_normalizeOutput(nextValue, outputFormat);
            onSelect(nextValue, details);
        }
    }, [
        handleRange,
        onSelect,
        outputFormat,
        range,
        value
    ]);
    var onClick = function onClick(selectedDate) {
        selectDate(selectedDate);
        announce("Selected " + $905acb1ecf697942$var$getLocaleString(selectedDate, locale), 'assertive');
        setActive(selectedDate);
    };
    var renderCalendarHeader = function renderCalendarHeader() {
        var _theme$calendar$size;
        var PreviousIcon = size === 'small' ? theme.calendar.icons.small.previous : theme.calendar.icons.previous;
        var NextIcon = size === 'small' ? theme.calendar.icons.small.next : theme.calendar.icons.next;
        var monthAndYear = reference.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric'
        });
        // theme.calendar.heading.level should be removed in v3 of grommet
        // theme.calendar[size].title should be used instead
        var headingLevel;
        if (level !== undefined) headingLevel = level;
        else if (size === 'small') headingLevel = theme.calendar.heading && theme.calendar.heading.level || 4;
        else headingLevel = (theme.calendar.heading && theme.calendar.heading.level || 4) - 1;
        var _ref5 = ((_theme$calendar$size = theme.calendar[size]) == null ? void 0 : _theme$calendar$size.title) || undefined, containerTheme = _ref5.container, textTheme = $905acb1ecf697942$var$_objectWithoutPropertiesLoose(_ref5, $905acb1ecf697942$var$_excluded2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            direction: "row",
            justify: "between",
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5ebSC.Header), {
            flex: true,
            pad: containerTheme.pad
        }, Object.keys(textTheme).length !== 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), textTheme, monthAndYear) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1fLUh.Heading), {
            level: headingLevel,
            size: size,
            margin: "none",
            overflowWrap: "normal"
        }, monthAndYear)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            flex: false,
            direction: "row",
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            a11yTitle: format({
                id: 'calendar.previous',
                messages: messages,
                values: {
                    date: previousMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(PreviousIcon, {
                size: size !== 'small' ? size : undefined
            }),
            disabled: $905acb1ecf697942$var$disabledCalendarPreviousMonthButton(previousMonth, reference, bounds),
            onClick: function onClick() {
                return changeCalendarMonth('calendar.previousMove', previousMonth);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            a11yTitle: format({
                id: 'calendar.next',
                messages: messages,
                values: {
                    date: nextMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(NextIcon, {
                size: size !== 'small' ? size : undefined
            }),
            disabled: $905acb1ecf697942$var$disabledCalendarNextMonthButton(nextMonth, reference, bounds),
            onClick: function onClick() {
                return changeCalendarMonth('calendar.nextMove', nextMonth);
            }
        })));
    };
    var renderDaysOfWeek = function renderDaysOfWeek() {
        var day = new Date(displayBounds[0]);
        var days = [];
        while(days.length < 7){
            days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayContainer), {
                role: "gridcell",
                key: days.length,
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDay), {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, day.toLocaleDateString(locale, {
                weekday: 'narrow'
            }))));
            day = (0, $iDJvK.addDays)(day, 1);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledWeek), {
            role: "row"
        }, days);
    };
    var weeks = [];
    var day = new Date(displayBounds[0]);
    var days;
    var firstDayInMonth;
    var blankWeek = false;
    var _loop = function _loop() {
        if (day.getDay() === firstDayOfWeek) {
            if (days) weeks.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledWeek), {
                role: "row",
                key: day.getTime(),
                fillContainer: fill
            }, days));
            days = [];
        }
        var otherMonth = day.getMonth() !== reference.getMonth();
        if (!showAdjacentDays && otherMonth) {
            days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayContainer), {
                key: day.getTime(),
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDay), {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            })));
            if (weeks.length === 5 && /* If the length days array is less than the current getDate()
      we know that all days in the array are from the next month. */ days.length < day.getDate()) blankWeek = true;
        } else if (/* Do not show adjacent days in 6th row if all days
    fall in the next month */ showAdjacentDays === 'trim' && otherMonth && weeks.length === 5 && /* If the length days array is less than the current getDate()
    we know that all days in the array are from the next month. */ days.length < day.getDate()) {
            blankWeek = true;
            days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDayContainer), {
                key: day.getTime(),
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledDay), {
                sizeProp: size,
                fillContainer: fill,
                responsive: responsive
            })));
        } else {
            var dateObject = day;
            // this.dayRefs[dateObject] = React.createRef();
            var selected = false;
            var inRange = false;
            var rangePosition;
            var _withinDates = (0, $iDJvK.withinDates)(day, range ? $905acb1ecf697942$var$normalizeRange(value, activeDate) : value), selectedState = _withinDates[0];
            if (selectedState === 2) {
                selected = true;
                var _withinDates2 = (0, $iDJvK.withinDates)(day, range ? $905acb1ecf697942$var$normalizeRange(value, activeDate) : value);
                rangePosition = _withinDates2[1];
            } else if (selectedState === 1) inRange = true;
            var dayDisabled = !!((0, $iDJvK.withinDates)(day, $905acb1ecf697942$var$_normalizeInput(disabled))[0] || bounds && !(0, $iDJvK.betweenDates)(day, $905acb1ecf697942$var$_normalizeInput(bounds)));
            if (!firstDayInMonth && !dayDisabled && day.getMonth() === reference.getMonth()) firstDayInMonth = dateObject;
            if (!children) days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($905acb1ecf697942$var$CalendarDay, {
                activeProp: active,
                day: day,
                key: day.getTime(),
                disabledProp: dayDisabled,
                buttonProps: {
                    a11yTitle: day.toDateString(),
                    onClick: !dayDisabled && !!onSelect ? function() {
                        return onClick(dateObject);
                    } : function() {}
                },
                isInRange: inRange,
                isSelected: selected,
                otherMonth: day.getMonth() !== reference.getMonth(),
                rangePosition: rangePosition,
                size: size,
                fill: fill,
                ref: focusableDateRef,
                responsive: responsive
            }, day.getDate()));
            else days.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($905acb1ecf697942$var$CalendarCustomDay, {
                key: day.getTime(),
                "aria-selected": selected,
                buttonProps: $905acb1ecf697942$var$_extends({
                    a11yTitle: day.toDateString()
                }, onSelect ? {
                    active: active && active.getTime() === day.getTime(),
                    disabled: dayDisabled,
                    onClick: dayDisabled ? function() {} : function() {
                        return onClick(dateObject);
                    }
                } : {}),
                size: size,
                fill: fill,
                responsive: responsive
            }, children({
                date: day,
                day: day.getDate(),
                isInRange: inRange,
                isSelected: selected
            })));
        }
        day = (0, $iDJvK.addDays)(day, 1);
    };
    while(day.getTime() < displayBounds[1].getTime())_loop();
    weeks.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledWeek), {
        role: !blankWeek ? 'row' : undefined,
        key: day.getTime(),
        fillContainer: fill
    }, days));
    // track if we need to focus when element becomes available
    var _useState10 = (0, $2NacA.useState)(false), needsFocus = _useState10[0], setNeedsFocus = _useState10[1];
    // while the calendar contains focus, and is not animating, set
    // the focus to the active date
    // Focus management effect
    (0, $2NacA.useEffect)(function() {
        if (!animating && active && focus) setNeedsFocus(true);
    }, [
        animating,
        active,
        focus
    ]);
    (0, $2NacA.useEffect)(function() {
        if (needsFocus && focusableDateRef != null && focusableDateRef.current) {
            focusableDateRef.current.focus();
            setNeedsFocus(false); // Reset flag after focus
        }
    }, [
        active,
        reference,
        displayBounds,
        needsFocus,
        focusableDateRef
    ]);
    (0, $2NacA.useEffect)(function() {
        if (bounds && active) {
            var normalizedBounds = $905acb1ecf697942$var$_normalizeInput(bounds);
            if (!(0, $iDJvK.betweenDates)(active, normalizedBounds)) {
                var diff1 = Math.abs(active.getTime() - normalizedBounds[0].getTime());
                var diff2 = Math.abs(active.getTime() - normalizedBounds[1].getTime());
                var closerDate = diff1 < diff2 ? 0 : 1;
                setActive(normalizedBounds[closerDate]);
            }
        }
    }, [
        active,
        bounds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledCalendar), $905acb1ecf697942$var$_extends({
        ref: ref,
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive
    }, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        fill: fill
    }, header ? header({
        date: reference,
        locale: locale,
        onPreviousMonth: function onPreviousMonth() {
            changeReference(previousMonth);
            setActive(previousMonth);
            announce(format({
                id: 'calendar.previous',
                messages: messages,
                values: {
                    date: previousMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }));
        },
        onNextMonth: function onNextMonth() {
            changeReference(nextMonth);
            setActive(nextMonth);
            announce(format({
                id: 'calendar.next',
                messages: messages,
                values: {
                    date: nextMonth.toLocaleDateString(locale, {
                        month: 'long',
                        year: 'numeric'
                    })
                }
            }));
        },
        previousInBound: (0, $iDJvK.betweenDates)(previousMonth, bounds),
        nextInBound: (0, $iDJvK.betweenDates)(nextMonth, bounds)
    }) : renderCalendarHeader(previousMonth, nextMonth), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        fill: true,
        role: "grid"
    }, daysOfWeek && renderDaysOfWeek(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onUp: function onUp(event) {
            var nextActive = (0, $iDJvK.addDays)(active, -7);
            event.preventDefault();
            event.stopPropagation(); // so the page doesn't scroll
            if (!!(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $iDJvK.betweenDates)(nextActive, displayBounds) || !showAdjacentDays && !(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onDown: function onDown(event) {
            var nextActive = (0, $iDJvK.addDays)(active, 7);
            event.preventDefault();
            event.stopPropagation(); // so the page doesn't scroll
            if (!!(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $iDJvK.betweenDates)(nextActive, displayBounds) || !showAdjacentDays && !(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onLeft: function onLeft() {
            var nextActive = (0, $iDJvK.addDays)(active, -1);
            if (!!(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $iDJvK.betweenDates)(nextActive, displayBounds) || !showAdjacentDays && !(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$monthBounds(reference))) changeReference(nextActive);
            }
        },
        onRight: function onRight() {
            var nextActive = (0, $iDJvK.addDays)(active, 1);
            if (!!(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$_normalizeInput(bounds)) || !bounds) {
                setActive(nextActive);
                if (!(0, $iDJvK.betweenDates)(nextActive, displayBounds) || !showAdjacentDays && !(0, $iDJvK.betweenDates)(nextActive, $905acb1ecf697942$var$monthBounds(reference))) changeReference(nextActive);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledWeeksContainer), $905acb1ecf697942$var$_extends({
        role: "rowgroup",
        "aria-label": reference.toLocaleDateString(locale, {
            month: 'long',
            year: 'numeric'
        }) + "; " + $905acb1ecf697942$var$currentlySelectedString(value, locale),
        sizeProp: size,
        fillContainer: fill,
        responsive: responsive,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: function onBlur() {
            setFocus(false);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7Yc9w.StyledWeeks), $905acb1ecf697942$var$_extends({
        slide: slide,
        sizeProp: size,
        fillContainer: fill
    }, passThemeFlag), weeks))))));
});
$905acb1ecf697942$export$e1aef45b828286de.displayName = 'Calendar';
$905acb1ecf697942$export$e1aef45b828286de.propTypes = (0, $llAEj.CalendarPropTypes);

});
parcelRegister("llAEj", function(module, exports) {

$parcel$export(module.exports, "CalendarPropTypes", () => $f8a7fce82a7d6143$export$91040927b1d7b4d1);


function $f8a7fce82a7d6143$var$_extends() {
    return $f8a7fce82a7d6143$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8a7fce82a7d6143$var$_extends.apply(null, arguments);
}
var $f8a7fce82a7d6143$var$PropType = {};
var $f8a7fce82a7d6143$export$91040927b1d7b4d1 = $f8a7fce82a7d6143$var$PropType;

});

parcelRegister("7Yc9w", function(module, exports) {

$parcel$export(module.exports, "StyledCalendar", () => $5cd79041482f3286$export$2185b0041ed383);
$parcel$export(module.exports, "StyledWeeksContainer", () => $5cd79041482f3286$export$cc9ae1676f4ee80a);
$parcel$export(module.exports, "StyledWeeks", () => $5cd79041482f3286$export$3d055278a61c3939);
$parcel$export(module.exports, "StyledWeek", () => $5cd79041482f3286$export$5db4823d38c0569f);
$parcel$export(module.exports, "StyledDayContainer", () => $5cd79041482f3286$export$ffce625ce693a981);
$parcel$export(module.exports, "StyledDayButton", () => $5cd79041482f3286$export$2be68822f46d2c34);
$parcel$export(module.exports, "StyledDay", () => $5cd79041482f3286$export$4fe9184bd47dbe20);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $a26J5 = parcelRequire("a26J5");

var $jQHd2 = parcelRequire("jQHd2");
var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");
var $fzxBh = parcelRequire("fzxBh");

var $fzxBh = parcelRequire("fzxBh");
var $5cd79041482f3286$var$responsiveSizeStyle = function responsiveSizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $fzxBh.breakpointStyle)({
        value: breakpoint
    }, "\n    width: 100vw;\n    max-width: " + breakpoint + ";\n  ", true);
};
var $5cd79041482f3286$var$sizeStyle = function sizeStyle(props) {
    var data = props.theme.calendar[props.sizeProp];
    var width = props.fillContainer ? '100%' : props.theme.global.size[props.sizeProp];
    return (0, $f5efw.css)([
        "font-size:",
        ";line-height:",
        ";width:",
        ";",
        ""
    ], data.fontSize, data.lineHeight, width, function(p) {
        return p.fillContainer && 'height: 100%;';
    });
};
var $5cd79041482f3286$export$2185b0041ed383 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCalendar",
    componentId: "sc-1y4xhmp-0"
})([
    "",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return $5cd79041482f3286$var$sizeStyle(props);
}, function(props) {
    return props.responsive && $5cd79041482f3286$var$responsiveSizeStyle(props);
}, function(props) {
    return props.theme.calendar && props.theme.calendar.extend;
});
var $5cd79041482f3286$var$weeksContainerSizeStyle = function weeksContainerSizeStyle(props) {
    var height = props.fillContainer ? '100%' : (0, $fzxBh.parseMetricToNum)(props.theme.calendar[props.sizeProp].daySize) * 6 + "px";
    return "\n    height: " + height + ";\n\n  ";
};
var $5cd79041482f3286$var$weeksContainerResponsiveSizeStyle = function weeksContainerResponsiveSizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    // set aspect-ratio to 7 days by 6 weeks
    return (0, $fzxBh.breakpointStyle)({
        value: breakpoint
    }, "\n    height: auto;\n    aspect-ratio: 7/6;\n    ", true);
};
var $5cd79041482f3286$export$cc9ae1676f4ee80a = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCalendar__StyledWeeksContainer",
    componentId: "sc-1y4xhmp-1"
})([
    "overflow:hidden;",
    " ",
    " ",
    ";"
], function(props) {
    return $5cd79041482f3286$var$weeksContainerSizeStyle(props);
}, function(props) {
    return props.responsive && $5cd79041482f3286$var$weeksContainerResponsiveSizeStyle(props);
}, function(props) {
    return props.focus && !props.plain && (0, $2O6LY.focusStyle)();
});
var $5cd79041482f3286$var$slideStyle = function slideStyle(props) {
    var _props$slide = props.slide, direction = _props$slide.direction, weeks = _props$slide.weeks, sizeProp = props.sizeProp, theme = props.theme;
    var _theme$calendar$sizeP = theme.calendar[sizeProp], daySize = _theme$calendar$sizeP.daySize, slideDuration = _theme$calendar$sizeP.slideDuration;
    var amount = (0, $fzxBh.parseMetricToNum)(daySize) * weeks;
    var translateYFrom = direction === 'down' ? "-" + amount + "px" : '0';
    var translateYTo = direction === 'up' ? "-" + amount + "px" : '0';
    var slideTransition = (0, $f5efw.css)([
        "0%{transform:translateY(",
        ");}100%{transform:translateY(",
        ");}"
    ], translateYFrom, translateYTo);
    return (0, $f5efw.css)([
        "animation:",
        " ",
        " forwards;"
    ], (0, $f5efw.keyframes)([
        "",
        ""
    ], slideTransition), slideDuration);
};
var $5cd79041482f3286$var$weeksSizeStyle = function weeksSizeStyle() {
    return (0, $f5efw.css)([
        "display:flex;flex-direction:column;height:100%;"
    ]);
};
// fallback to medium if no size-specific styles
var $5cd79041482f3286$var$rangeRoundStyle = function rangeRoundStyle(props) {
    var _props$theme$calendar5, _props$theme$calendar6;
    var themeObj;
    if (props.isSelected) {
        var _props$theme$calendar, _props$theme$calendar2, _props$theme$calendar3, _props$theme$calendar4;
        var rangeStart = ((_props$theme$calendar = props.theme.calendar) == null || (_props$theme$calendar = _props$theme$calendar[props.sizeProp]) == null || (_props$theme$calendar = _props$theme$calendar.range) == null || (_props$theme$calendar = _props$theme$calendar.start) == null ? void 0 : _props$theme$calendar.round) || ((_props$theme$calendar2 = props.theme.calendar) == null || (_props$theme$calendar2 = _props$theme$calendar2.medium) == null || (_props$theme$calendar2 = _props$theme$calendar2.range) == null || (_props$theme$calendar2 = _props$theme$calendar2.start) == null ? void 0 : _props$theme$calendar2.round);
        var rangeEnd = ((_props$theme$calendar3 = props.theme.calendar) == null || (_props$theme$calendar3 = _props$theme$calendar3[props.sizeProp]) == null || (_props$theme$calendar3 = _props$theme$calendar3.range) == null || (_props$theme$calendar3 = _props$theme$calendar3.end) == null ? void 0 : _props$theme$calendar3.round) || ((_props$theme$calendar4 = props.theme.calendar) == null || (_props$theme$calendar4 = _props$theme$calendar4.medium) == null || (_props$theme$calendar4 = _props$theme$calendar4.range) == null || (_props$theme$calendar4 = _props$theme$calendar4.end) == null ? void 0 : _props$theme$calendar4.round);
        if (props.rangePosition === 'start' && rangeStart) themeObj = rangeStart;
        else if (props.rangePosition === 'end' && rangeEnd) themeObj = rangeEnd;
    } else themeObj = ((_props$theme$calendar5 = props.theme.calendar) == null || (_props$theme$calendar5 = _props$theme$calendar5[props.sizeProp]) == null || (_props$theme$calendar5 = _props$theme$calendar5.range) == null ? void 0 : _props$theme$calendar5.round) || ((_props$theme$calendar6 = props.theme.calendar) == null || (_props$theme$calendar6 = _props$theme$calendar6.medium) == null || (_props$theme$calendar6 = _props$theme$calendar6.range) == null ? void 0 : _props$theme$calendar6.round);
    return themeObj && [
        (0, $2O6LY.roundStyle)(themeObj, props.responsive, props.theme)
    ];
};
var $5cd79041482f3286$export$3d055278a61c3939 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCalendar__StyledWeeks",
    componentId: "sc-1y4xhmp-2"
})([
    "position:relative;",
    " ",
    ";"
], function(props) {
    return props.fillContainer && $5cd79041482f3286$var$weeksSizeStyle();
}, function(props) {
    return props.slide && $5cd79041482f3286$var$slideStyle(props);
});
var $5cd79041482f3286$export$5db4823d38c0569f = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCalendar__StyledWeek",
    componentId: "sc-1y4xhmp-3"
})([
    "display:flex;justify-content:space-between;",
    ""
], function(props) {
    return props.fillContainer && 'flex: 1;';
});
var $5cd79041482f3286$var$responsiveDayContainerStyle = function responsiveDayContainerStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $fzxBh.breakpointStyle)({
        value: breakpoint
    }, "\n    width: 14.3%;\n  ", true);
};
// The width of 14.3% is derived from dividing 100/7. We want the
// widths of 7 days to equally fill 100% of the row.
var $5cd79041482f3286$export$ffce625ce693a981 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCalendar__StyledDayContainer",
    componentId: "sc-1y4xhmp-4"
})([
    "flex:0 1 auto;",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.fillContainer && 'width: 14.3%;';
}, function(props) {
    var _props$theme$calendar7;
    return (props.inRange || props.isSelected && props.rangePosition) && ((_props$theme$calendar7 = props.theme.calendar) == null || (_props$theme$calendar7 = _props$theme$calendar7.range) == null ? void 0 : _props$theme$calendar7.background) && (0, $jQHd2.backgroundStyle)(props.theme.calendar.range.background, props.theme);
}, function(props) {
    return $5cd79041482f3286$var$rangeRoundStyle(props);
}, function(props) {
    return props.responsive && $5cd79041482f3286$var$responsiveDayContainerStyle(props);
});
var $5cd79041482f3286$var$responsiveDayButtonStyle = function responsiveDayButtonStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    return (0, $fzxBh.breakpointStyle)({
        value: breakpoint
    }, "\n    width: 100%;\n  ", true);
};
// when caller opts in to day hover styling, apply all state styles
// on CalendarDay instead of active state on CalendarDayButton
// position relative and z-index are added to prevent the focus
// indicator from getting cut off
var $5cd79041482f3286$export$2be68822f46d2c34 = (0, $f5efw.default)((0, $a26J5.Button)).withConfig({
    displayName: "StyledCalendar__StyledDayButton",
    componentId: "sc-1y4xhmp-5"
})([
    "&:focus{position:relative;z-index:1;}",
    " ",
    ""
], function(props) {
    return props.disabledProp && (0, $2O6LY.disabledStyle)(props.theme.button.disabled.opacity);
}, function(props) {
    return props.responsive && $5cd79041482f3286$var$responsiveDayButtonStyle(props);
});
var $5cd79041482f3286$var$daySizeStyle = function daySizeStyle(props) {
    var data = props.theme.calendar[props.sizeProp];
    return (0, $f5efw.css)([
        "width:",
        ";height:",
        ";"
    ], props.fillContainer ? '100%' : data.daySize, props.fillContainer ? '100%' : data.daySize);
};
var $5cd79041482f3286$var$responsiveDaySizeStyle = function responsiveDaySizeStyle(props) {
    var breakpoint = props.theme.global.size[props.sizeProp];
    var data = props.theme.calendar[props.sizeProp];
    return (0, $fzxBh.breakpointStyle)({
        value: breakpoint
    }, "\n      width: 100%;\n      max-width: " + data.daySize + ";\n      height: auto;\n      aspect-ratio: 1;\n    ", true);
};
var $5cd79041482f3286$var$dayStyle = function dayStyle(props) {
    var backgroundObj;
    var colorObj;
    if (props.isSelected) {
        var _props$theme$calendar8, _props$theme$calendar9;
        backgroundObj = ((_props$theme$calendar8 = props.theme.calendar.day) == null || (_props$theme$calendar8 = _props$theme$calendar8.selected) == null ? void 0 : _props$theme$calendar8.background) || 'control';
        colorObj = (_props$theme$calendar9 = props.theme.calendar.day) == null || (_props$theme$calendar9 = _props$theme$calendar9.selected) == null ? void 0 : _props$theme$calendar9.color;
    } else if (props.inRange) {
        var _props$theme$calendar0, _props$theme$calendar1, _props$theme$calendar10, _props$theme$calendar11;
        // for backwards compatability, only apply this if caller hasn't specified
        // range specific rounding
        // if they have, background will be applied to StyledDayContainer
        backgroundObj = !((_props$theme$calendar0 = props.theme.calendar) != null && (_props$theme$calendar0 = _props$theme$calendar0[props.sizeProp]) != null && (_props$theme$calendar0 = _props$theme$calendar0.range) != null && _props$theme$calendar0.round) && !((_props$theme$calendar1 = props.theme.calendar) != null && (_props$theme$calendar1 = _props$theme$calendar1.medium.range) != null && _props$theme$calendar1.round) && (((_props$theme$calendar10 = props.theme.calendar.day) == null || (_props$theme$calendar10 = _props$theme$calendar10.inRange) == null ? void 0 : _props$theme$calendar10.background) || {
            color: 'control',
            opacity: 'weak'
        });
        colorObj = (_props$theme$calendar11 = props.theme.calendar.day) == null || (_props$theme$calendar11 = _props$theme$calendar11.inRange) == null ? void 0 : _props$theme$calendar11.color;
    } else {
        var _props$theme$calendar12, _props$theme$calendar13;
        backgroundObj = (_props$theme$calendar12 = props.theme.calendar.day) == null ? void 0 : _props$theme$calendar12.background;
        colorObj = (_props$theme$calendar13 = props.theme.calendar.day) == null ? void 0 : _props$theme$calendar13.color;
    }
    if (colorObj && !backgroundObj) return "color: " + (0, $d2fh4.normalizeColor)(colorObj, props.theme) + ";";
    return (0, $jQHd2.backgroundStyle)(backgroundObj, props.theme, colorObj);
};
var $5cd79041482f3286$var$dayHoverStyle = function dayHoverStyle(props) {
    var backgroundObj;
    var colorObj;
    if (props.isSelected) {
        var _props$theme$calendar14, _props$theme$calendar15;
        backgroundObj = (_props$theme$calendar14 = props.theme.calendar.day) == null || (_props$theme$calendar14 = _props$theme$calendar14.selected) == null || (_props$theme$calendar14 = _props$theme$calendar14.hover) == null ? void 0 : _props$theme$calendar14.background;
        colorObj = (_props$theme$calendar15 = props.theme.calendar.day) == null || (_props$theme$calendar15 = _props$theme$calendar15.selected) == null || (_props$theme$calendar15 = _props$theme$calendar15.hover) == null ? void 0 : _props$theme$calendar15.color;
    } else if (props.inRange) {
        var _props$theme$calendar16, _props$theme$calendar17;
        backgroundObj = (_props$theme$calendar16 = props.theme.calendar.day) == null || (_props$theme$calendar16 = _props$theme$calendar16.inRange) == null || (_props$theme$calendar16 = _props$theme$calendar16.hover) == null ? void 0 : _props$theme$calendar16.background;
        colorObj = (_props$theme$calendar17 = props.theme.calendar.day) == null || (_props$theme$calendar17 = _props$theme$calendar17.inRange) == null || (_props$theme$calendar17 = _props$theme$calendar17.hover) == null ? void 0 : _props$theme$calendar17.color;
    } else {
        var _props$theme$calendar18, _props$theme$calendar19;
        backgroundObj = (_props$theme$calendar18 = props.theme.calendar.day) == null || (_props$theme$calendar18 = _props$theme$calendar18.hover) == null ? void 0 : _props$theme$calendar18.background;
        colorObj = (_props$theme$calendar19 = props.theme.calendar.day) == null || (_props$theme$calendar19 = _props$theme$calendar19.hover) == null ? void 0 : _props$theme$calendar19.color;
    }
    if (colorObj && !backgroundObj) return "color: " + (0, $d2fh4.normalizeColor)(colorObj, props.theme) + ";";
    return (0, $jQHd2.backgroundStyle)(backgroundObj, props.theme, colorObj);
};
var $5cd79041482f3286$var$dayFontStyle = function dayFontStyle(props) {
    var fontWeight;
    if (props.isSelected) {
        var _props$theme$calendar20;
        fontWeight = (_props$theme$calendar20 = props.theme.calendar.day) == null || (_props$theme$calendar20 = _props$theme$calendar20.selected) == null || (_props$theme$calendar20 = _props$theme$calendar20.font) == null ? void 0 : _props$theme$calendar20.weight;
    } else if (props.inRange) {
        var _props$theme$calendar21;
        fontWeight = (_props$theme$calendar21 = props.theme.calendar.day) == null || (_props$theme$calendar21 = _props$theme$calendar21.inRange) == null || (_props$theme$calendar21 = _props$theme$calendar21.font) == null ? void 0 : _props$theme$calendar21.weight;
    }
    return fontWeight && "font-weight: " + fontWeight + ";";
};
var $5cd79041482f3286$export$4fe9184bd47dbe20 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledCalendar__StyledDay",
    componentId: "sc-1y4xhmp-6"
})([
    "display:flex;justify-content:center;align-items:center;color:",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    var _props$theme$calendar22;
    return (0, $d2fh4.normalizeColor)(props.otherMonth ? ((_props$theme$calendar22 = props.theme.calendar) == null || (_props$theme$calendar22 = _props$theme$calendar22.day) == null || (_props$theme$calendar22 = _props$theme$calendar22.adjacent) == null ? void 0 : _props$theme$calendar22.color) || 'text-xweak' : 'text-strong', props.theme);
}, function(props) {
    return $5cd79041482f3286$var$daySizeStyle(props);
}, function(props) {
    return props.responsive && $5cd79041482f3286$var$responsiveDaySizeStyle(props);
}, function(props) {
    return $5cd79041482f3286$var$dayStyle(props);
}, function(props) {
    return $5cd79041482f3286$var$dayFontStyle(props);
}, function(props) {
    var _props$theme$calendar23, _props$theme$calendar24;
    // fallback to medium if no size-specific styles
    var round = ((_props$theme$calendar23 = props.theme.calendar) == null || (_props$theme$calendar23 = _props$theme$calendar23[props.sizeProp]) == null || (_props$theme$calendar23 = _props$theme$calendar23.day) == null ? void 0 : _props$theme$calendar23.round) || ((_props$theme$calendar24 = props.theme.calendar) == null || (_props$theme$calendar24 = _props$theme$calendar24.medium) == null || (_props$theme$calendar24 = _props$theme$calendar24.day) == null ? void 0 : _props$theme$calendar24.round);
    return round && (0, $2O6LY.roundStyle)(round, props.responsive, props.theme);
}, function(props) {
    return props.hover && !props.disabledProp && $5cd79041482f3286$var$dayHoverStyle(props);
}, function(props) {
    return(// when theme uses kind Buttons, since we use children for Button,
    // we have to special case how we handle disabled days here
    props.disabledProp && props.theme.button["default"] && (0, $2O6LY.kindPartStyles)(props.theme.button.disabled, props.theme));
}, function(props) {
    return props.theme.calendar && props.theme.calendar.day && props.theme.calendar.day.extend;
});

});

parcelRegister("iDJvK", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $038080b5fc9bc903$export$dd412b56f1e4d8aa);
$parcel$export(module.exports, "subtractDays", () => $038080b5fc9bc903$export$8f6ba218ec818063);
$parcel$export(module.exports, "addMonths", () => $038080b5fc9bc903$export$17c93e242b2d3a22);
$parcel$export(module.exports, "subtractMonths", () => $038080b5fc9bc903$export$cde1cfadc1403459);
$parcel$export(module.exports, "startOfMonth", () => $038080b5fc9bc903$export$a5a3b454ada2268e);
$parcel$export(module.exports, "endOfMonth", () => $038080b5fc9bc903$export$a2258d9c4118825c);
$parcel$export(module.exports, "sameDayOrAfter", () => $038080b5fc9bc903$export$b43b14f05e74d2a6);
$parcel$export(module.exports, "sameDayOrBefore", () => $038080b5fc9bc903$export$fc01259e21cb1793);
$parcel$export(module.exports, "daysApart", () => $038080b5fc9bc903$export$564c235164ed6ce8);
$parcel$export(module.exports, "betweenDates", () => $038080b5fc9bc903$export$5e6ff6e7b7b4e53b);
$parcel$export(module.exports, "withinDates", () => $038080b5fc9bc903$export$509e5b8f8eb27f5c);
$parcel$export(module.exports, "handleOffset", () => $038080b5fc9bc903$export$440bcced20c33405);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
// Utility functions for the Calendar.
// Just what's needed to avoid having to include a dependency like momentjs.
var $038080b5fc9bc903$var$DAY_MILLISECONDS = 86400000;
var $038080b5fc9bc903$export$dd412b56f1e4d8aa = function addDays(date, days) {
    var result = new Date(date.getTime() + $038080b5fc9bc903$var$DAY_MILLISECONDS * days);
    // Deal with crossing the daylight savings time boundary,
    // where adding a day's worth when the time is midnight results in
    // being a day off.
    var hourDelta = result.getHours() - date.getHours();
    // At this point, hourDelta is typically 0 (normal day),
    // +23 (November daylight saving), or -23 (March Daylight saving)
    // depending on which side of the switch we are on.
    // Convert so that hourDelta is either +1 or -1.
    if (hourDelta === 23) hourDelta -= 24;
    else if (hourDelta === -23) hourDelta += 24;
    result.setHours(result.getHours() - hourDelta);
    return result;
};
var $038080b5fc9bc903$export$8f6ba218ec818063 = function subtractDays(date, days) {
    return $038080b5fc9bc903$export$dd412b56f1e4d8aa(date, -days);
};
var $038080b5fc9bc903$export$17c93e242b2d3a22 = function addMonths(date, months) {
    var result = new Date(date);
    var years = Math.floor((date.getMonth() + months) / 12);
    result.setFullYear(date.getFullYear() + years);
    var targetMonth = (date.getMonth() + months) % 12;
    result.setMonth(targetMonth < 0 ? 12 + targetMonth : targetMonth);
    return result;
};
var $038080b5fc9bc903$export$cde1cfadc1403459 = function subtractMonths(date, months) {
    return $038080b5fc9bc903$export$17c93e242b2d3a22(date, -months);
};
var $038080b5fc9bc903$export$a5a3b454ada2268e = function startOfMonth(date) {
    var result = new Date(date);
    result.setDate(1);
    return result;
};
var $038080b5fc9bc903$export$a2258d9c4118825c = function endOfMonth(date) {
    var result = $038080b5fc9bc903$export$17c93e242b2d3a22(date, 1);
    result.setDate(0);
    return result;
};
var $038080b5fc9bc903$export$803c6c0e435ba32b = function sameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
var $038080b5fc9bc903$export$b43b14f05e74d2a6 = function sameDayOrAfter(date1, date2) {
    return date1.getFullYear() > date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() > date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() >= date2.getDate());
};
var $038080b5fc9bc903$export$fc01259e21cb1793 = function sameDayOrBefore(date1, date2) {
    return date1.getFullYear() < date2.getFullYear() || date1.getFullYear() === date2.getFullYear() && (date1.getMonth() < date2.getMonth() || date1.getMonth() === date2.getMonth() && date1.getDate() <= date2.getDate());
};
var $038080b5fc9bc903$export$564c235164ed6ce8 = function daysApart(date1, date2) {
    return Math.floor((date1.getTime() - date2.getTime()) / $038080b5fc9bc903$var$DAY_MILLISECONDS);
};
var $038080b5fc9bc903$export$5e6ff6e7b7b4e53b = function betweenDates(date, dates) {
    var result;
    if (dates) {
        var _ref = Array.isArray(dates) ? dates.map(function(d) {
            return d ? new Date(d) : undefined;
        }) : [
            dates,
            undefined
        ], from = _ref[0], to = _ref[1];
        if (from && $038080b5fc9bc903$export$803c6c0e435ba32b(date, from) || to && $038080b5fc9bc903$export$803c6c0e435ba32b(date, to)) result = 2;
        else if (from && $038080b5fc9bc903$export$b43b14f05e74d2a6(date, from) && to && $038080b5fc9bc903$export$fc01259e21cb1793(date, to)) result = 1;
    } else result = 1;
    return result;
};
var $038080b5fc9bc903$export$b4a32babffa865e6 = function getRangePosition(date, dates) {
    var rangePosition;
    if (dates) {
        var _ref2 = Array.isArray(dates) ? dates.map(function(d) {
            return d ? new Date(d) : undefined;
        }) : [
            dates,
            undefined
        ], from = _ref2[0], to = _ref2[1];
        if (from && $038080b5fc9bc903$export$803c6c0e435ba32b(date, from)) rangePosition = 'start';
        else if (to && $038080b5fc9bc903$export$803c6c0e435ba32b(date, to)) rangePosition = 'end';
    }
    return rangePosition;
};
var $038080b5fc9bc903$export$509e5b8f8eb27f5c = function withinDates(date, dates) {
    var result;
    var rangePosition;
    if (dates) {
        if (Array.isArray(dates)) dates.some(function(d) {
            if (d instanceof Date) {
                if ($038080b5fc9bc903$export$803c6c0e435ba32b(date, d)) result = 2;
            } else {
                result = $038080b5fc9bc903$export$5e6ff6e7b7b4e53b(date, d);
                rangePosition = $038080b5fc9bc903$export$b4a32babffa865e6(date, d);
            }
            return result;
        });
        else if ($038080b5fc9bc903$export$803c6c0e435ba32b(date, dates)) result = 2;
    }
    return [
        result,
        rangePosition
    ];
};
var $038080b5fc9bc903$export$440bcced20c33405 = function handleOffset(date) {
    var normalizedDate = new Date(date);
    var offset = normalizedDate.getTimezoneOffset();
    var hour = normalizedDate.getHours();
    // add back offset
    normalizedDate.setHours(hour, offset < 0 ? -offset : offset);
    return normalizedDate;
};

});

parcelRegister("3XT4P", function(module, exports) {

$parcel$export(module.exports, "setHoursWithOffset", () => $2e319ae7bcd8fd59$export$c739ab4d3d4926aa);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $2e319ae7bcd8fd59$export$c739ab4d3d4926aa = function setHoursWithOffset(date) {
    var newDate = new Date(date);
    if ((date == null ? void 0 : date.indexOf('T')) === -1) {
        var offset = newDate.getTimezoneOffset();
        var hour = newDate.getHours();
        newDate.setHours(hour, offset < 0 ? -offset : offset);
    }
    return newDate;
};
var $2e319ae7bcd8fd59$export$5d04458e2a6c373e = function pad(value) {
    return String(value).padStart(2, '0');
};
var $2e319ae7bcd8fd59$export$ef0994ae32443424 = function normalizeStep(step) {
    var parsed = Number(step);
    if (!Number.isFinite(parsed) || parsed <= 0) return 1;
    return Math.max(1, Math.floor(parsed));
};

});


parcelRegister("2fsW3", function(module, exports) {

$parcel$export(module.exports, "MaskedInput", () => $1a336d7526635f64$export$dec03dc0f3ef8025);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $isD1Z = parcelRequire("isD1Z");

var $7wKkw = parcelRequire("7wKkw");

var $czDw5 = parcelRequire("czDw5");

var $2O6LY = parcelRequire("2O6LY");
var $dOlbm = parcelRequire("dOlbm");
var $1PECa = parcelRequire("1PECa");

var $2k3j1 = parcelRequire("2k3j1");

var $hVJuc = parcelRequire("hVJuc");

var $eL6w3 = parcelRequire("eL6w3");
var $1a336d7526635f64$var$_excluded = [
    "a11yTitle",
    "dropHeight",
    "dropProps",
    "focus",
    "focusIndicator",
    "icon",
    "id",
    "mask",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "placeholder",
    "plain",
    "reverse",
    "textAlign",
    "value"
];
function $1a336d7526635f64$var$_extends() {
    return $1a336d7526635f64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1a336d7526635f64$var$_extends.apply(null, arguments);
}
function $1a336d7526635f64$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1a336d7526635f64$var$parseValue = function parseValue(mask, value) {
    // break the value up into mask parts
    var valueParts = []; // { part, beginIndex, endIndex }
    var valueIndex = 0;
    var maskIndex = 0;
    while(value !== undefined && valueIndex < value.length && maskIndex < mask.length){
        var item = mask[maskIndex];
        var found = void 0;
        if (item.fixed) {
            var length = item.fixed.length;
            // grab however much of value (starting at valueIndex) matches
            // item.fixed. If none matches it and there is more in value
            // add in the fixed item.
            var matching = 0;
            while(matching < length && value[valueIndex + matching] === item.fixed[matching])matching += 1;
            if (matching > 0) {
                var part = value.slice(valueIndex, valueIndex + matching);
                if (valueIndex + matching < value.length) // matched part of the fixed portion but there's more stuff
                // after it. Go ahead and fill in the entire fixed chunk
                part = item.fixed;
                valueParts.push({
                    part: part,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + matching - 1
                });
                valueIndex += matching;
            } else valueParts.push({
                part: item.fixed,
                beginIndex: valueIndex,
                endIndex: valueIndex + length - 1
            });
            maskIndex += 1;
            found = true;
        } else if (item.options && item.restrictToOptions !== false) // reverse assuming larger is later
        found = item.options.slice(0).reverse()// eslint-disable-next-line no-loop-func
        .some(function(option) {
            var length = option.length;
            var part = value.slice(valueIndex, valueIndex + length);
            if (part === option) {
                valueParts.push({
                    part: part,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + length - 1
                });
                valueIndex += length;
                maskIndex += 1;
                return true;
            }
            return false;
        });
        if (!found) {
            if (item.regexp) {
                var minLength = Array.isArray(item.length) && item.length[0] || item.length || 1;
                var maxLength = Array.isArray(item.length) && item.length[1] || item.length || value.length - valueIndex;
                var _length = maxLength;
                while(!found && _length >= minLength){
                    var _part = value.slice(valueIndex, valueIndex + _length);
                    if (item.regexp.test(_part)) {
                        valueParts.push({
                            part: _part,
                            beginIndex: valueIndex,
                            endIndex: valueIndex + _length - 1
                        });
                        valueIndex += _length;
                        maskIndex += 1;
                        found = true;
                    }
                    _length -= 1;
                }
                if (!found) valueIndex = value.length;
            } else {
                var _length2 = Array.isArray(item.length) ? item.length[1] : item.length || value.length - valueIndex;
                var _part2 = value.slice(valueIndex, valueIndex + _length2);
                valueParts.push({
                    part: _part2,
                    beginIndex: valueIndex,
                    endIndex: valueIndex + _length2 - 1
                });
                valueIndex += _length2;
                maskIndex += 1;
            }
        }
    }
    return valueParts;
};
var $1a336d7526635f64$var$defaultMask = [
    {
        regexp: /[^]*/
    }
];
var $1a336d7526635f64$var$ContainerBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "MaskedInput__ContainerBox",
    componentId: "sc-af8hzu-0"
})([
    "",
    ";"
], function(props) {
    return props.dropHeight ? (0, $2O6LY.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var $1a336d7526635f64$var$dropAlign = {
    top: 'bottom',
    left: 'left'
};
var $1a336d7526635f64$export$dec03dc0f3ef8025 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, _ref$mask = _ref.mask, mask = _ref$mask === void 0 ? $1a336d7526635f64$var$defaultMask : _ref$mask, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, placeholder = _ref.placeholder, plain = _ref.plain, reverse = _ref.reverse, textAlign = _ref.textAlign, valueProp = _ref.value, rest = $1a336d7526635f64$var$_objectWithoutPropertiesLoose(_ref, $1a336d7526635f64$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var valueParts = (0, $2NacA.useMemo)(function() {
        return $1a336d7526635f64$var$parseValue(mask, value);
    }, [
        mask,
        value
    ]);
    var inputRef = (0, $dOlbm.useForwardedRef)(ref);
    var dropRef = (0, $2NacA.useRef)();
    // Caller's ref, if provided
    var _useState = (0, $2NacA.useState)(), dropPropsTarget = _useState[0], setDropPropsTarget = _useState[1];
    (0, $2NacA.useEffect)(function() {
        var nextDropPropsTarget;
        // If caller provided a ref, set to 'pending' until ref.current is defined
        if (dropProps && 'target' in dropProps) {
            nextDropPropsTarget = dropProps.target || 'pending';
            setDropPropsTarget(nextDropPropsTarget);
        }
    }, [
        dropProps
    ]);
    var _useState2 = (0, $2NacA.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(), activeMaskIndex = _useState3[0], setActiveMaskIndex = _useState3[1];
    var _useState4 = (0, $2NacA.useState)(), activeOptionIndex = _useState4[0], setActiveOptionIndex = _useState4[1];
    var _useState5 = (0, $2NacA.useState)(), showDrop = _useState5[0], setShowDrop = _useState5[1];
    (0, $2NacA.useEffect)(function() {
        if (focus) {
            var timer = setTimeout(function() {
                // determine which mask element the caret is at
                var caretIndex = inputRef.current.selectionStart;
                var maskIndex;
                valueParts.some(function(part, index) {
                    if (part.beginIndex <= caretIndex && part.endIndex >= caretIndex) {
                        maskIndex = index;
                        return true;
                    }
                    return false;
                });
                if (maskIndex === undefined && valueParts.length < mask.length) maskIndex = valueParts.length; // first unused one
                if (maskIndex && mask[maskIndex].fixed) maskIndex -= 1; // fixed mask parts are never "active"
                if (maskIndex !== activeMaskIndex) {
                    setActiveMaskIndex(maskIndex);
                    setActiveOptionIndex(-1);
                    setShowDrop(maskIndex >= 0 && mask[maskIndex].options && true);
                }
            }, 10); // 10ms empirically chosen
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        activeMaskIndex,
        focus,
        inputRef,
        mask,
        valueParts
    ]);
    var setInputValue = (0, $2NacA.useCallback)(function(nextValue) {
        // Calling set value function directly on input because React library
        // overrides setter `event.target.value =` and loses original event
        // target fidelity.
        // https://stackoverflow.com/a/46012210 &&
        // https://github.com/grommet/grommet/pull/3171#discussion_r296415239
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, nextValue);
        var event = new Event('input', {
            bubbles: true
        });
        inputRef.current.dispatchEvent(event);
    }, [
        inputRef
    ]);
    var _useState6 = (0, $2NacA.useState)(), mouseMovedSinceLastKey = _useState6[0], setMouseMovedSinceLastKey = _useState6[1];
    // This could be due to a paste or as the user is typing.
    var onChangeInput = (0, $2NacA.useCallback)(function(event) {
        var eventValue = event.target.value;
        // Align with the mask.
        var nextValueParts = $1a336d7526635f64$var$parseValue(mask, eventValue);
        var nextValue = nextValueParts.map(function(part) {
            return part.part;
        }).join('');
        if (nextValue !== eventValue) {
            // The mask adjusted the next value. If something was added,
            // the value must be valid. Change the actual input value
            // to correspond.
            // This will re-trigger this callback with the next value.
            if (nextValue.length > eventValue.length) setInputValue(nextValue);
            else if (value && eventValue.length < value.length) {
                // If the user is removing characters, preserve what the
                // user is working on.
                setValue(eventValue);
                if (onChange) onChange(event);
            } else // If the user is adding invalid characters, don't allow it.
            // Revert to the prior value.
            setInputValue(value);
        } else if (value !== nextValue) {
            setValue(nextValue);
            if (onChange) onChange(event);
        }
    }, [
        mask,
        onChange,
        setInputValue,
        setValue,
        value
    ]);
    var onOption = (0, $2NacA.useCallback)(function(option) {
        return function() {
            var nextValueParts = [].concat(valueParts);
            nextValueParts[activeMaskIndex] = {
                part: option
            };
            // add any fixed parts that follow
            var index = activeMaskIndex + 1;
            while(index < mask.length && !nextValueParts[index] && mask[index].fixed){
                nextValueParts[index] = {
                    part: mask[index].fixed
                };
                index += 1;
            }
            var nextValue = nextValueParts.map(function(part) {
                return part.part;
            }).join('');
            setInputValue(nextValue);
            // restore focus to input
            inputRef.current.focus();
        };
    }, [
        activeMaskIndex,
        inputRef,
        mask,
        setInputValue,
        valueParts
    ]);
    var onNextOption = (0, $2NacA.useCallback)(function(event) {
        var item = mask[activeMaskIndex];
        if (item && item.options) {
            event.preventDefault();
            var index = Math.min(activeOptionIndex + 1, item.options.length - 1);
            setMouseMovedSinceLastKey(false);
            setActiveOptionIndex(index);
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask
    ]);
    var onPreviousOption = (0, $2NacA.useCallback)(function(event) {
        if (activeMaskIndex >= 0 && mask[activeMaskIndex].options) {
            event.preventDefault();
            var index = Math.max(activeOptionIndex - 1, 0);
            setMouseMovedSinceLastKey(false);
            setActiveOptionIndex(index);
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask
    ]);
    var onSelectOption = (0, $2NacA.useCallback)(function(event) {
        if (activeMaskIndex >= 0 && activeOptionIndex >= 0) {
            event.preventDefault();
            var option = mask[activeMaskIndex].options[activeOptionIndex];
            onOption(option)();
        }
    }, [
        activeMaskIndex,
        activeOptionIndex,
        mask,
        onOption
    ]);
    var onEsc = (0, $2NacA.useCallback)(function(event) {
        if (showDrop) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            setShowDrop(false);
        }
    }, [
        showDrop
    ]);
    var onHideDrop = (0, $2NacA.useCallback)(function() {
        return setShowDrop(false);
    }, []);
    var renderPlaceholder = function renderPlaceholder() {
        return mask.map(function(item) {
            return item.placeholder || item.fixed;
        }).join('');
    };
    var maskedInputIcon = (0, $1PECa.useSizedIcon)(icon, rest.size, theme);
    /*
  If the masked input has a list of options, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    var options = (0, $2NacA.useMemo)(function() {
        var _mask$find, _mask$activeMaskIndex;
        var res;
        if (!activeMaskIndex) // ensures that comboboxProps gets set on input initially
        res = (_mask$find = mask.find(function(item) {
            var _item$options;
            return (item == null || (_item$options = item.options) == null ? void 0 : _item$options.length) > 0;
        })) == null ? void 0 : _mask$find.options;
        else res = (_mask$activeMaskIndex = mask[activeMaskIndex]) == null ? void 0 : _mask$activeMaskIndex.options;
        return res;
    }, [
        mask,
        activeMaskIndex
    ]);
    if (id && (options == null ? void 0 : options.length) > 0) {
        if (showDrop && options) activeOptionID = "listbox-option-" + activeOptionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2k3j1.StyledMaskedInputContainer), $1a336d7526635f64$var$_extends({
        plain: plain,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), maskedInputIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2k3j1.StyledIcon), {
        reverse: reverse,
        theme: theme
    }, maskedInputIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEsc: onEsc,
        onTab: showDrop ? function() {
            return setShowDrop(false);
        } : undefined,
        onLeft: undefined,
        onRight: undefined,
        onUp: onPreviousOption,
        onDown: showDrop ? onNextOption : function() {
            return setShowDrop(true);
        },
        onEnter: onSelectOption,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2k3j1.StyledMaskedInput), $1a336d7526635f64$var$_extends({
        ref: inputRef,
        "aria-label": a11yTitle,
        id: id,
        name: name,
        autoComplete: "off",
        focusIndicator: focusIndicator,
        plain: plain,
        placeholder: placeholder || renderPlaceholder(),
        icon: icon,
        reverse: reverse,
        focus: focus,
        textAlign: textAlign
    }, comboboxProps, rest, {
        value: value,
        theme: theme,
        onFocus: function onFocus(event) {
            setFocus(true);
            setShowDrop(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            // This will be called when the user clicks on a suggestion,
            // check for that and don't remove the drop in that case.
            // Drop will already have removed itself if the user has focused
            // outside of the Drop.
            if (!dropRef.current) setShowDrop(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: onChangeInput
    }))), showDrop && mask[activeMaskIndex] && mask[activeMaskIndex].options && // If caller has specified dropProps.target, ensure target is defined
    dropPropsTarget !== 'pending' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $isD1Z.Drop), $1a336d7526635f64$var$_extends({
        id: id ? "masked-input-drop__" + id : undefined,
        align: $1a336d7526635f64$var$dropAlign,
        responsive: false,
        target: inputRef.current,
        onClickOutside: onHideDrop,
        onEsc: onHideDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($1a336d7526635f64$var$ContainerBox, $1a336d7526635f64$var$_extends({
        ref: dropRef,
        overflow: "auto",
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        dropHeight: dropHeight,
        onMouseOver: function onMouseOver() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), mask[activeMaskIndex].options.map(function(option, index) {
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ // Not adding a theme object now because this code path
        // is not used in the HPE theme, but we may add theme
        // support here in the future.
        (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            }
        }, option) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            key: option,
            flex: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            tabIndex: "-1",
            onClick: onOption(option),
            onMouseOver: function onMouseOver() {
                return setActiveOptionIndex(index);
            },
            onFocus: function onFocus() {},
            active: index === activeOptionIndex,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background',
            label: !child ? option : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
});
$1a336d7526635f64$export$dec03dc0f3ef8025.displayName = 'MaskedInput';
$1a336d7526635f64$export$dec03dc0f3ef8025.propTypes = (0, $hVJuc.MaskedInputPropTypes);

});
parcelRegister("2k3j1", function(module, exports) {

$parcel$export(module.exports, "StyledMaskedInput", () => $1b100382badb25d4$export$3b982a63cbad39fd);
$parcel$export(module.exports, "StyledMaskedInputContainer", () => $1b100382badb25d4$export$a3c8b952c846e4b1);
$parcel$export(module.exports, "StyledIcon", () => $1b100382badb25d4$export$7c8f159da0dc916);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");

var $2O6LY = parcelRequire("2O6LY");
var $1b100382badb25d4$export$3b982a63cbad39fd = (0, $f5efw.default).input.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledMaskedInput",
    componentId: "sc-99vkfa-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], (0, $2O6LY.inputStyle), function(props) {
    return props.plain && (0, $2O6LY.plainInputStyle);
}, function(props) {
    return props.icon && (0, $2O6LY.inputPadForIcon);
}, function(props) {
    return props.disabled && (0, $2O6LY.disabledStyle)(props.theme.maskedInput.disabled && props.theme.maskedInput.disabled.opacity);
}, function(props) {
    return props.textAlign && (0, $2O6LY.textAlignStyle);
}, function(props) {
    return props.theme.maskedInput && props.theme.maskedInput.extend;
});
var $1b100382badb25d4$export$a3c8b952c846e4b1 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledMaskedInput__StyledMaskedInputContainer",
    componentId: "sc-99vkfa-1"
})([
    "position:relative;width:100%;",
    ";"
], function(props) {
    return props.theme.maskedInput && props.theme.maskedInput.container && props.theme.maskedInput.container.extend;
});
var $1b100382badb25d4$export$7c8f159da0dc916 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledMaskedInput__StyledIcon",
    componentId: "sc-99vkfa-2"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, $2O6LY.getInputPadBySide)(props, 'right') + ";" : "left: " + (0, $2O6LY.getInputPadBySide)(props, 'left') + ";";
});

});

parcelRegister("hVJuc", function(module, exports) {

$parcel$export(module.exports, "MaskedInputPropTypes", () => $d0db0b21615cc98e$export$2bbcb24fb0cd855c);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $d0db0b21615cc98e$var$PropType = {};
var $d0db0b21615cc98e$export$2bbcb24fb0cd855c = $d0db0b21615cc98e$var$PropType;

});


parcelRegister("kbE4G", function(module, exports) {

$parcel$export(module.exports, "Schedule", () => $eb23ebb3c5edf810$export$a74e4df6c6355a42);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $eb23ebb3c5edf810$var$_extends() {
    return $eb23ebb3c5edf810$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eb23ebb3c5edf810$var$_extends.apply(null, arguments);
}
var $eb23ebb3c5edf810$export$a74e4df6c6355a42 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $eb23ebb3c5edf810$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Schedule"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 23h22V4H1v19zM18 4V0v4zM6 4V0v4zM1 8.5h22H1zM6 14c.556-1.333 1.39-2 2.5-2 1.3 0 2 1 2 2s-1 2-2 3l-2 2v.5h5.405m5.08 1L17 12h-.5c-.5 1.5-2 2-2.743 2"
    }));
});
$eb23ebb3c5edf810$export$a74e4df6c6355a42.displayName = 'Schedule';

});


parcelRegister("2ggFG", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("1Jz7s");
var $bQiIR = parcelRequire("bQiIR");

var $bgcVc = parcelRequire("bgcVc");

var $dUDTx = parcelRequire("dUDTx");

var $4kZY9 = parcelRequire("4kZY9");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $cooA3 = parcelRequire("cooA3");
var $b5k5v = parcelRequire("b5k5v");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbE4G = parcelRequire("kbE4G");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $9z6Tf = parcelRequire("9z6Tf");
var $d2VmQ = parcelRequire("d2VmQ");
var $9TVJO = parcelRequire("9TVJO");
const $d435edc462244579$export$72083132d17deb40 = (0, $j8yBr.observer)(({ dateTime: dateTime, onChange: onChange, initialDate: initialDate, session: session, activity: activity, bounds: bounds, type: type, placeholder: placeholder })=>{
    /** State **/ const [open, setOpen] = (0, $2NacA.useState)(false);
    const [date, setDate] = (0, $2NacA.useState)('');
    const [time, setTime] = (0, $2NacA.useState)('');
    const [dateLabel, setDateLabel] = (0, $2NacA.useState)('');
    const [timeLabel, setTimeLabel] = (0, $2NacA.useState)(placeholder || 'Select date & time');
    const [disabledDates, setDisabledDates] = (0, $2NacA.useState)([]);
    const [formErrors, setFormErrors] = (0, $2NacA.useState)({});
    /** Methods **/ const setDateValue = (date)=>{
        setDate(date);
        formErrors.date = '';
    };
    const setTimeValue = (time)=>{
        setTime(time);
        formErrors.time = '';
    };
    const getDisabledDates = (date, session)=>{
        if (!date || !session) return [];
        const firstDayOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(date).set('date', 1);
        const sessionDateOnly = (0, $bgcVc.toDateOnly)(session.date);
        const dayBeforeSession = (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(sessionDateOnly).subtract(1, 'day');
        const displayedMonth = firstDayOfMonth.format('YYYY-MM');
        const sessionMonth = (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(sessionDateOnly).format('YYYY-MM');
        const dates = (0, $dUDTx.isSameOrBefore)(displayedMonth, sessionMonth) ? [
            [
                firstDayOfMonth.format('YYYY-MM-DD'),
                dayBeforeSession.format('YYYY-MM-DD')
            ]
        ] : [];
        return dates;
    };
    const isDateTimeValid = (isoDateTime)=>{
        if (!activity) return false;
        if (type === (0, $bQiIR.DateTimeType).StartTime) {
            if (activity.end_time && (0, $dUDTx.isSameOrAfter)(isoDateTime, activity.end_time)) {
                setFormErrors({
                    ...formErrors,
                    time: 'Start time must be before end time.'
                });
                return false;
            }
        } else if (type === (0, $bQiIR.DateTimeType).EndTime) {
            if (activity.start_time && (0, $dUDTx.isSameOrBefore)(isoDateTime, activity.start_time)) {
                setFormErrors({
                    ...formErrors,
                    time: 'End time must be after start time.'
                });
                return false;
            }
        }
        return true;
    };
    const resetDateTime = ()=>{
        const { date: initialDate, time: initialTime } = (0, $dUDTx.parseIsoDateString)(dateTime);
        setDate(initialDate);
        setTime(initialTime);
    };
    const onOpen = ()=>{
        setOpen(true);
    };
    const onClose = (nextDate, nextTime, validateAndSave = true)=>{
        if (validateAndSave) {
            const isoDateTime = new Date(`${nextDate} ${nextTime}`).toISOString();
            if (isDateTimeValid(isoDateTime)) onChange(isoDateTime);
            else return;
        } else resetDateTime();
        setOpen(false);
        setTimeout(()=>setOpen(false), 1);
        setFormErrors({});
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (dateTime) resetDateTime();
    }, [
        dateTime
    ]);
    (0, $2NacA.useEffect)(()=>{
        setTimeLabel(time || placeholder || 'Select date & time');
        if (date) setDateLabel(date !== initialDate ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(date).format('MM/DD/YYYY') : '');
    }, [
        time,
        placeholder,
        date,
        initialDate
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (date && session) {
            const dates = getDisabledDates(date, session);
            setDisabledDates(dates);
        }
    }, [
        date,
        session
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        align: "center",
        pad: "small",
        flex: "grow",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5k5v.DropButton), {
            open: open,
            onClose: ()=>onClose(date, time),
            onOpen: onOpen,
            dropProps: {
                onClickOutside: ()=>onClose(date, time, false),
                onEsc: ()=>onClose(date, time, false)
            },
            dropContent: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cooA3.Calendar), {
                        fill: true,
                        animate: false,
                        date: date,
                        onSelect: (d)=>setDateValue(!Array.isArray(d) ? d : ''),
                        showAdjacentDays: false,
                        locale: "en-US",
                        bounds: bounds,
                        disabled: disabledDates
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        flex: false,
                        pad: "small",
                        gap: "medium",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        direction: "row",
                                        border: {
                                            side: 'bottom'
                                        },
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9TVJO.TimeInput), {
                                            time: time,
                                            setTime: setTimeValue,
                                            boxProps: {
                                                flex: 'grow'
                                            }
                                        })
                                    }),
                                    formErrors.time && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9z6Tf.ErrorText), {
                                        children: formErrors.time
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                    label: "Done",
                                    onClick: ()=>onClose(date, time)
                                })
                            })
                        ]
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "medium",
                align: "center",
                pad: {
                    vertical: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        align: "center",
                        gap: "xsmall",
                        children: [
                            dateLabel && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                color: date ? undefined : 'dark-2',
                                children: dateLabel
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                color: date ? undefined : 'dark-2',
                                children: timeLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: placeholder
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbE4G.Schedule), {})
                    })
                ]
            })
        })
    });
});

});
parcelRegister("bgcVc", function(module, exports) {

$parcel$export(module.exports, "toDateOnly", () => $404c8a5ce8be9ad7$export$b0961ad8aee63b8b);
$parcel$export(module.exports, "formatDateOnly", () => $404c8a5ce8be9ad7$export$75477e21c4edfb09);
$parcel$export(module.exports, "fromDateInputChange", () => $404c8a5ce8be9ad7$export$3a93a9a6ce3eeb56);

var $4kZY9 = parcelRequire("4kZY9");
const $404c8a5ce8be9ad7$export$b0961ad8aee63b8b = (value)=>{
    if (!value) return '';
    const str = value instanceof Date ? value.toISOString() : value;
    return str.slice(0, 10);
};
const $404c8a5ce8be9ad7$export$75477e21c4edfb09 = (value, format = 'MM/DD/YYYY')=>{
    const dateOnly = $404c8a5ce8be9ad7$export$b0961ad8aee63b8b(value);
    return dateOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(dateOnly).format(format) : '';
};
const $404c8a5ce8be9ad7$export$3a93a9a6ce3eeb56 = (value)=>{
    const raw = Array.isArray(value) ? value[0] : value;
    return typeof raw === 'string' ? $404c8a5ce8be9ad7$export$b0961ad8aee63b8b(raw) : '';
};

});


parcelRegister("hF8pi", function(module, exports) {

$parcel$export(module.exports, "Delete", () => $08171174f8fb0fc9$export$bfadae053a633538);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $bDFk2 = parcelRequire("bDFk2");

var $2NacA = parcelRequire("2NacA");
const $08171174f8fb0fc9$export$bfadae053a633538 = ({ onClick: onClick, name: name, size: size, ...rest })=>{
    const [open, setOpen] = (0, $2NacA.useState)(false);
    const [deleting, setDeleting] = (0, $2NacA.useState)(false);
    (0, $2NacA.useEffect)(()=>{
        const doDelete = async ()=>{
            await onClick();
            setDeleting(false);
            setOpen(false);
        };
        if (open && deleting) doDelete();
    }, [
        deleting
    ]);
    const onCancel = ()=>setOpen(false);
    const acceptFocus = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setOpen(true);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                hoverIndicator: true,
                onClick: (e)=>acceptFocus(e),
                style: {
                    cursor: 'pointer'
                },
                ...rest,
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                    color: "red",
                    size: size
                })
            }),
            open && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
                onClickOutside: onCancel,
                onEsc: onCancel,
                children: deleting ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    align: "center",
                    justify: "center",
                    pad: "medium",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                        size: "large"
                    })
                }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    pad: "medium",
                    gap: "medium",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            children: [
                                "Are you sure you want to delete ",
                                name,
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            align: "center",
                            justify: "end",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                    label: "Cancel",
                                    onClick: onCancel
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                    label: "Delete",
                                    onClick: ()=>setDeleting(true),
                                    primary: true
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("7r0kC", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $a677a686d36aafe6$export$73392e09138fecd6);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");
const $a677a686d36aafe6$export$73392e09138fecd6 = ({ name: name, onDelete: onDelete, onCancel: onCancel })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: onCancel,
        onClickOutside: onCancel,
        position: "center",
        margin: "large",
        modal: true,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            pad: "medium",
            gap: "medium",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    children: [
                        "Are you sure you want to delete ",
                        name,
                        "?"
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    align: "center",
                    justify: "end",
                    gap: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Cancel",
                            onClick: onCancel
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Delete",
                            onClick: onDelete,
                            primary: true
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("1Ofsp", function(module, exports) {

$parcel$export(module.exports, "EditableText", () => $e7a77d40d8fa0ca4$export$a0dcf0ef8dc3ae26);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $czDw5 = parcelRequire("czDw5");
var $kS7Ii = parcelRequire("kS7Ii");
var $kQZ06 = parcelRequire("kQZ06");

var $2NacA = parcelRequire("2NacA");

var $4Oriw = parcelRequire("4Oriw");
parcelRequire("ibR9R");
var $d2VmQ = parcelRequire("d2VmQ");
const $e7a77d40d8fa0ca4$export$a0dcf0ef8dc3ae26 = ({ val: val, onChange: onChange, onBlur: onBlur, onSubmit: onSubmit, id: id, name: name, minValue: minValue, maxValue: maxValue, minLength: minLength, maxLength: maxLength, required: required, width: width, textSize: textSize, textMargin: textMargin, textColor: textColor, inputType: inputType, shortenTo: shortenTo, isCurrency: isCurrency, isPercent: isPercent, saveDelay: saveDelay = 500 })=>{
    /** State **/ const [edit, setEdit] = (0, $2NacA.useState)(false);
    const [value, setValue] = (0, $2NacA.useState)(val);
    /** Refs **/ const inputRef = (0, $2NacA.useRef)(null);
    const timerRef = (0, $2NacA.useRef)(null);
    const onChangeRef = (0, $2NacA.useRef)(onChange);
    const prevValRef = (0, $2NacA.useRef)(val);
    /** Computed **/ const displayVal = value && inputType === 'number' && isCurrency && !Number.isNaN(parseFloat(value)) ? parseFloat(value).toFixed(2) : value;
    /** Methods - Debouncing **/ // Fire any pending debounced onChanges immediately
    const flush = (0, $2NacA.useCallback)(()=>{
        if (timerRef.current !== null) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (inputRef.current) onChangeRef.current(inputRef.current.value);
    }, []);
    // Schedules a debounced onChange
    const scheduleChange = (0, $2NacA.useCallback)(()=>{
        if (saveDelay === undefined || saveDelay === 0) {
            // No debounce requested — fire immediately.
            if (inputRef.current) onChangeRef.current(inputRef.current.value);
            return;
        }
        if (timerRef.current !== null) // Reset the timer each keystroke
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            if (inputRef.current) onChangeRef.current(inputRef.current.value);
        }, saveDelay);
    }, [
        saveDelay
    ]);
    /** Methods - Event Handlers **/ const handleChange = (e)=>{
        if (e.target.value) {
            const v = typeof e.target.value === 'number' ? e.target.value.toString() : e.target.value;
            if (minLength && v.length < minLength) return;
            if (maxLength && v.length > maxLength) return;
        }
        setValue(e.target.value || '');
        scheduleChange();
    };
    const handleSubmit = ()=>{
        flush();
        setEdit(false);
        onSubmit && onSubmit();
    };
    const handleBlur = ()=>{
        flush();
        setEdit(false);
        onBlur && onBlur();
    };
    const takeFocus = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setEdit(true);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        return ()=>{
            if (timerRef.current !== null) clearTimeout(timerRef.current);
        };
    }, []);
    (0, $2NacA.useEffect)(()=>{
        if (val !== prevValRef.current) {
            setValue(val);
            prevValRef.current = val;
        }
    }, [
        val,
        edit
    ]);
    (0, $2NacA.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    /** Render **/ const renderInput = ()=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            width: width,
            margin: textMargin,
            alignSelf: "start",
            gap: "xxsmall",
            direction: "row",
            align: "center",
            children: [
                isCurrency && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: "$"
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    border: {
                        side: 'bottom',
                        color: textColor || 'text'
                    },
                    onBlur: handleBlur,
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $czDw5.Keyboard), {
                        onEnter: handleSubmit,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                            id: id,
                            ref: inputRef,
                            name: name || id,
                            value: value || '',
                            autoFocus: edit,
                            onChange: handleChange,
                            onBlur: handleBlur,
                            type: inputType,
                            required: required,
                            min: minValue,
                            max: maxValue,
                            minLength: minLength,
                            maxLength: maxLength,
                            plain: "full",
                            size: textSize,
                            width: width
                        })
                    })
                }),
                isPercent && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    color: textColor,
                    children: "%"
                })
            ]
        });
    const renderText = ()=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            width: width,
            margin: textMargin,
            border: {
                side: 'bottom',
                color: textColor || 'text'
            },
            alignSelf: "start",
            onClick: takeFocus,
            style: {
                minHeight: !displayVal ? (0, $4Oriw.default).text?.medium?.height : undefined,
                cursor: 'text'
            },
            fill: !displayVal,
            children: shortenTo ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    color: textColor,
                    children: displayVal
                }),
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: textSize,
                    color: textColor,
                    children: displayVal.length > shortenTo ? `${displayVal.slice(0, shortenTo - 1)}...` : displayVal
                })
            }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
                children: [
                    isCurrency && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        color: textColor,
                        children: "$"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: textSize,
                        color: textColor,
                        children: displayVal
                    }),
                    isPercent && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        color: textColor,
                        children: "%"
                    })
                ]
            })
        });
    return edit ? renderInput() : renderText();
};

});

parcelRegister("6sdTj", function(module, exports) {
$parcel$export(module.exports, "AssetSelectorModal", () => (parcelRequire("3npYU")).AssetSelectorModal);
$parcel$export(module.exports, "CommercialEditReviewModal", () => (parcelRequire("lpy8P")).CommercialEditReviewModal);
$parcel$export(module.exports, "EditReviewModal", () => (parcelRequire("aYiXW")).EditReviewModal);
$parcel$export(module.exports, "EditsHeader", () => (parcelRequire("9nbE2")).EditsHeader);
$parcel$export(module.exports, "EditsPanel", () => (parcelRequire("24vti")).EditsPanel);
$parcel$export(module.exports, "WatchVideoModal", () => (parcelRequire("5avy4")).WatchVideoModal);
parcelRequire("3npYU");
parcelRequire("eOVbw");
parcelRequire("1BLyu");
parcelRequire("drlit");
parcelRequire("4CYCG");
parcelRequire("h5O0B");
parcelRequire("9nbE2");
parcelRequire("24vti");
parcelRequire("kDwcB");
parcelRequire("5avy4");

});
parcelRegister("3npYU", function(module, exports) {

$parcel$export(module.exports, "AssetSelectorModal", () => $fa03a90b93cb95bf$export$391ae5a2d6e6e26e);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $jmzyn = parcelRequire("jmzyn");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $dXvwP = parcelRequire("dXvwP");
parcelRequire("hcQWc");
var $asThd = parcelRequire("asThd");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $8DltC = parcelRequire("8DltC");

var $4Oriw = parcelRequire("4Oriw");

var $107Qa = parcelRequire("107Qa");

var $jGT7M = parcelRequire("jGT7M");

var $2wNFJ = parcelRequire("2wNFJ");

var $az33k = parcelRequire("az33k");

var $6qg9k = parcelRequire("6qg9k");
const $fa03a90b93cb95bf$export$391ae5a2d6e6e26e = ({ setShowModal: setShowModal, selectedAssetId: selectedAssetId, handleAssetSelect: handleAssetSelect })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ const [assetThumbnails, setAssetThumbnails] = (0, $2NacA.useState)(new Map());
    const [uploading, setUploading] = (0, $2NacA.useState)(false);
    /** Computed **/ const videoAssets = (0, $2NacA.useMemo)(()=>(projectStore.currentProject?.assets || []).filter((asset)=>asset.type === (0, $asThd.AssetType).Video), [
        projectStore.currentProject?.assets
    ]);
    /** Methods **/ const handleFileUpload = async (e)=>{
        const files = e?.target?.files;
        if (!files?.[0]) return;
        const file = files[0];
        const maxSize = 2147483648; // 2GB limit
        if (file.size > maxSize) {
            (0, $bsB3E.toast).error('File size exceeds 2GB limit');
            return;
        }
        setUploading(true);
        try {
            const asset = await projectStore.createAsset(file, (0, $asThd.AssetType).Video, '');
            if (!asset) (0, $bsB3E.toast).error('Error uploading video');
            else {
                (0, $bsB3E.toast).success('Video uploaded successfully');
                await handleAssetSelect(asset);
            }
        } catch (err) {
            (0, $bsB3E.toast).error(err instanceof Error ? err.message : 'Error uploading video');
        } finally{
            setUploading(false);
        }
    };
    /** Effects **/ // Load thumbnails for video assets when selector opens
    (0, $2NacA.useEffect)(()=>{
        if (videoAssets.length > 0) {
            const loadThumbnails = async ()=>{
                const thumbnailMap = new Map();
                for (const asset of videoAssets)if (asset.thumbnail_path) {
                    const url = await projectStore.getAssetThumbnailUrl(asset.id);
                    if (url) thumbnailMap.set(asset.id, url);
                }
                setAssetThumbnails(thumbnailMap);
            };
            loadThumbnails();
        }
    }, [
        projectStore,
        videoAssets
    ]);
    var asset;
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $az33k.ModalCard), {
        onClose: ()=>setShowModal(false),
        title: "Select or Upload Video",
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dXvwP.Upload), {
            size: "24px",
            color: "text"
        }),
        cardProps: {
            width: 'large'
        },
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            gap: "medium",
            flex: "grow",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6qg9k.ModalInfoCard), {
                    title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        weight: 500,
                        size: "small",
                        children: "Upload New Video"
                    }),
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        gap: "medium",
                        margin: {
                            vertical: 'xsmall'
                        },
                        pad: {
                            horizontal: 'small'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2wNFJ.FileUploader), {
                                handleFileUpload: handleFileUpload,
                                uploading: uploading,
                                maxFileSize: "2GB",
                                acceptedFormats: [
                                    '.mp4',
                                    '.mov',
                                    '.avi',
                                    '.mkv',
                                    '.webm'
                                ],
                                uploadType: "video"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                    text: "OR IMPORT FROM"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $107Qa.AssetCloudImportButtons), {
                                assetType: (0, $asThd.AssetType).Video,
                                disabled: uploading,
                                onImportSuccess: handleAssetSelect,
                                onImportStart: ()=>setUploading(true),
                                onImportEnd: ()=>setUploading(false),
                                size: "small",
                                direction: "row",
                                showDivider: false
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6qg9k.ModalInfoCard), {
                    title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        weight: 500,
                        size: "small",
                        children: "Or Select from Asset Library"
                    }),
                    children: uploading ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        align: "center",
                        pad: "large",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {}),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "Uploading video..."
                            })
                        ]
                    }) : videoAssets.length === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "center",
                        pad: "large",
                        gap: "small",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            color: "dark-2",
                            children: "No video assets in library yet"
                        })
                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        gap: "small",
                        overflow: "auto",
                        height: "medium",
                        children: videoAssets.map((asset)=>{
                            const thumbnailUrl = assetThumbnails.get(asset.id);
                            const duration = /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
                                children: [
                                    Math.floor((asset.duration_seconds ?? 0) / 60),
                                    ":",
                                    String(Math.floor((asset.duration_seconds ?? 0) % 60)).padStart(2, '0')
                                ]
                            });
                            return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                align: "center",
                                gap: "medium",
                                pad: "small",
                                border: {
                                    color: selectedAssetId === asset.id ? 'brand' : 'light-4'
                                },
                                round: (0, $4Oriw.borderRadiusSize),
                                background: selectedAssetId === asset.id ? 'light-1' : 'white',
                                hoverIndicator: "light-2",
                                onClick: ()=>handleAssetSelect(asset),
                                style: {
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        background: "light-3",
                                        round: "xsmall",
                                        overflow: "auto",
                                        children: thumbnailUrl ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                                            src: thumbnailUrl,
                                            alt: asset.name,
                                            width: "120px",
                                            height: "68px"
                                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            fill: true,
                                            justify: "center",
                                            align: "center",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "xsmall",
                                                color: "dark-2",
                                                children: "No preview"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        flex: true,
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                weight: "bold",
                                                children: asset.name
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                color: "dark-2",
                                                children: asset.file_name
                                            }),
                                            asset.duration_seconds && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                size: "xsmall",
                                                color: "dark-2",
                                                children: [
                                                    "Duration: ",
                                                    duration
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, asset.id);
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("jmzyn", function(module, exports) {

$parcel$export(module.exports, "Image", () => $e18ba694c059e954$export$3e431a229df88919);

var $2NacA = parcelRequire("2NacA");

var $2bDvA = parcelRequire("2bDvA");

var $gxxSz = parcelRequire("gxxSz");

var $eL6w3 = parcelRequire("eL6w3");
var $e18ba694c059e954$var$_excluded = [
    "a11yTitle",
    "fallback",
    "onError",
    "onLoad",
    "opacity",
    "fill",
    "src"
];
function $e18ba694c059e954$var$_extends() {
    return $e18ba694c059e954$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e18ba694c059e954$var$_extends.apply(null, arguments);
}
function $e18ba694c059e954$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e18ba694c059e954$export$3e431a229df88919 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fallback = _ref.fallback, onError = _ref.onError, onLoad = _ref.onLoad, opacity = _ref.opacity, fill = _ref.fill, src = _ref.src, rest = $e18ba694c059e954$var$_objectWithoutPropertiesLoose(_ref, $e18ba694c059e954$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2NacA.useState)(false), isFallbackInUse = _useState[0], setFallbackInUse = _useState[1];
    var handleError = function handleError(event) {
        if (onError) onError(event);
        if (!isFallbackInUse && fallback && fallback !== '') {
            // eslint-disable-next-line no-param-reassign
            event.target.src = fallback;
            setFallbackInUse(true);
        }
    };
    var handleOnLoad = function handleOnLoad(event) {
        if (onLoad) onLoad(event);
        setFallbackInUse(false);
    };
    var extraProps = {
        onError: (onError || fallback) && handleError,
        onLoad: handleOnLoad
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2bDvA.StyledImage), $e18ba694c059e954$var$_extends({
        "aria-label": a11yTitle
    }, passThemeFlag, rest, extraProps, {
        ref: ref,
        opacityProp: opacity,
        fillProp: fill,
        src: src === undefined ? '' : src
    }));
});
$e18ba694c059e954$export$3e431a229df88919.displayName = 'Image';
$e18ba694c059e954$export$3e431a229df88919.propTypes = (0, $gxxSz.ImagePropTypes);

});
parcelRegister("2bDvA", function(module, exports) {

$parcel$export(module.exports, "StyledImage", () => $197b41638d41b3e7$export$7722b1870d9eec03);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $197b41638d41b3e7$var$FIT_MAP = {
    cover: 'cover',
    contain: 'contain'
};
var $197b41638d41b3e7$var$fitStyle = (0, $f5efw.css)([
    "flex:1 1;overflow:hidden;object-fit:",
    ";"
], function(props) {
    return $197b41638d41b3e7$var$FIT_MAP[props.fit];
});
var $197b41638d41b3e7$export$7722b1870d9eec03 = (0, $f5efw.default).img.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledImage",
    componentId: "sc-ey4zx9-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, $2O6LY.genericStyles), function(props) {
    return props.fit && $197b41638d41b3e7$var$fitStyle;
}, function(props) {
    return props.fillProp && (0, $2O6LY.fillStyle)(props.fillProp);
}, function(props) {
    return props.theme.image && props.theme.image.extend;
}, function(props) {
    return props.opacityProp && "opacity: " + (props.opacityProp === true ? props.theme.global.opacity.medium : props.theme.global.opacity[props.opacityProp] || props.opacityProp) + ";\n  ";
});

});

parcelRegister("gxxSz", function(module, exports) {

$parcel$export(module.exports, "ImagePropTypes", () => $c0aa021cf212b09a$export$c3be8f1cc0265a9c);


function $c0aa021cf212b09a$var$_extends() {
    return $c0aa021cf212b09a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c0aa021cf212b09a$var$_extends.apply(null, arguments);
}
var $c0aa021cf212b09a$var$PropType = {};
var $c0aa021cf212b09a$export$c3be8f1cc0265a9c = $c0aa021cf212b09a$var$PropType;

});


parcelRegister("dXvwP", function(module, exports) {

$parcel$export(module.exports, "Upload", () => $a2993df4428bb5c7$export$c58532f0fb5faa97);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $a2993df4428bb5c7$var$_extends() {
    return $a2993df4428bb5c7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a2993df4428bb5c7$var$_extends.apply(null, arguments);
}
var $a2993df4428bb5c7$export$c58532f0fb5faa97 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $a2993df4428bb5c7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Upload"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 17v6h22v-6M12 2v17M5 9l7-7 7 7"
    }));
});
$a2993df4428bb5c7$export$c58532f0fb5faa97.displayName = 'Upload';

});

parcelRegister("2wNFJ", function(module, exports) {

$parcel$export(module.exports, "FileUploader", () => $cd8dc46dd5843f57$export$1a5cb5295a7d2749);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $17uuk = parcelRequire("17uuk");
var $kS7Ii = parcelRequire("kS7Ii");
const $cd8dc46dd5843f57$export$1a5cb5295a7d2749 = ({ handleFileUpload: handleFileUpload, acceptedFormats: acceptedFormats, uploading: uploading, maxFileSize: maxFileSize, dropPrompt: dropPrompt, uploadType: uploadType = 'file' })=>{
    const accepted = acceptedFormats.map((format)=>format[0] === '.' ? format : `.${format}`);
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gap: "xsmall",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $17uuk.FileInput), {
                name: "file",
                onChange: handleFileUpload,
                disabled: uploading,
                multiple: false,
                accept: accepted.join(','),
                messages: {
                    dropPrompt: dropPrompt || `Drop ${uploadType.toLocaleLowerCase()} here or click to browse`,
                    browse: 'Browse'
                }
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "xsmall",
                children: [
                    maxFileSize && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        children: [
                            "Max file size: ",
                            /*#__PURE__*/ (0, $6ir3O.jsx)("span", {
                                style: {
                                    fontWeight: 600
                                },
                                children: maxFileSize
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xxsmall",
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            size: "xsmall",
                            children: [
                                "Accepted formats: ",
                                /*#__PURE__*/ (0, $6ir3O.jsx)("span", {
                                    style: {
                                        fontWeight: 600
                                    },
                                    children: accepted.join(', ')
                                }),
                                "."
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("17uuk", function(module, exports) {

$parcel$export(module.exports, "FileInput", () => $0d0e18331bb47b74$export$b57af79a4ab2a1c6);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $2YwM2 = parcelRequire("2YwM2");

var $2M0UK = parcelRequire("2M0UK");

var $2O6LY = parcelRequire("2O6LY");
var $dOlbm = parcelRequire("dOlbm");
var $hp4MM = parcelRequire("hp4MM");

var $j0B9N = parcelRequire("j0B9N");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $7wKkw = parcelRequire("7wKkw");

var $czDw5 = parcelRequire("czDw5");

var $kS7Ii = parcelRequire("kS7Ii");

var $aSkTl = parcelRequire("aSkTl");

var $8NDBC = parcelRequire("8NDBC");

var $7rwbZ = parcelRequire("7rwbZ");

var $eL6w3 = parcelRequire("eL6w3");
var $0d0e18331bb47b74$var$_excluded = [
    "a11yTitle",
    "background",
    "border",
    "confirmRemove",
    "disabled",
    "id",
    "plain",
    "renderFile",
    "maxSize",
    "messages",
    "margin",
    "multiple",
    "name",
    "onChange",
    "pad",
    "value"
];
function $0d0e18331bb47b74$var$_extends() {
    return $0d0e18331bb47b74$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0d0e18331bb47b74$var$_extends.apply(null, arguments);
}
function $0d0e18331bb47b74$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// We want the interaction of <input type="file" /> but none of its styling.
// So, we put what we want to show underneath and
// position the <input /> on top with an opacity of zero.
// If there are any files selected, we need to show the buttons to remove them.
// So, we offset the <input /> from the right by the appropriate width.
// We don't use Stack because of how we need to control the positioning.
var $0d0e18331bb47b74$var$ContentsBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "FileInput__ContentsBox",
    componentId: "sc-1jzq7im-0"
})([
    "cursor:pointer;position:relative;",
    " ",
    ";",
    ";",
    ";",
    ";",
    ";"
], function(props) {
    return props.disabled && (0, $2O6LY.disabledStyle)();
}, function(props) {
    return props.theme.fileInput && props.theme.fileInput.extend;
}, function(props) {
    return props.hover && props.theme.fileInput && props.theme.fileInput.hover && props.theme.fileInput.hover.extend;
}, function(props) {
    return props.dragOver && props.theme.fileInput && props.theme.fileInput.dragOver && props.theme.fileInput.dragOver.extend;
}, function(props) {
    return props.focus && (0, $2O6LY.focusStyle)();
}, function(props) {
    return !props.focus && (0, $2O6LY.unfocusStyle)();
});
var $0d0e18331bb47b74$var$Label = (0, $f5efw.default)((0, $kS7Ii.Text)).withConfig({
    displayName: "FileInput__Label",
    componentId: "sc-1jzq7im-1"
})([
    "",
    ";"
], function(props) {
    return props.theme.fileInput && props.theme.fileInput.label && props.theme.fileInput.label.extend;
});
var $0d0e18331bb47b74$var$Message = (0, $f5efw.default)((0, $kS7Ii.Text)).withConfig({
    displayName: "FileInput__Message",
    componentId: "sc-1jzq7im-2"
})([
    "",
    ";"
], function(props) {
    return props.theme.fileInput && props.theme.fileInput.message && props.theme.fileInput.message.extend;
});
var $0d0e18331bb47b74$var$defaultPendingRemoval = {
    event: undefined,
    index: undefined
};
var $0d0e18331bb47b74$export$b57af79a4ab2a1c6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$fileInput, _theme$fileInput$anch;
    var a11yTitle = _ref.a11yTitle, background = _ref.background, border = _ref.border, confirmRemove = _ref.confirmRemove, disabled = _ref.disabled, id = _ref.id, plain = _ref.plain, renderFile = _ref.renderFile, maxSize = _ref.maxSize, messages = _ref.messages, margin = _ref.margin, multiple = _ref.multiple, name = _ref.name, _onChange = _ref.onChange, pad = _ref.pad, valueProp = _ref.value, rest = $0d0e18331bb47b74$var$_objectWithoutPropertiesLoose(_ref, $0d0e18331bb47b74$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useState(), hover = _React$useState[0], setHover = _React$useState[1];
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useState(), dragOver = _React$useState2[0], setDragOver = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useState(), focus = _React$useState3[0], setFocus = _React$useState3[1];
    var _useState = (0, $2NacA.useState)(false), showRemoveConfirmation = _useState[0], setShowRemoveConfirmation = _useState[1];
    var _useState2 = (0, $2NacA.useState)($0d0e18331bb47b74$var$defaultPendingRemoval), pendingRemoval = _useState2[0], setPendingRemoval = _useState2[1];
    var aggregateThreshold = multiple && multiple.aggregateThreshold || 10;
    var max = multiple == null ? void 0 : multiple.max;
    var inputRef = (0, $dOlbm.useForwardedRef)(ref);
    var controlRef = (0, $2NacA.useRef)();
    var removeRef = (0, $2NacA.useRef)();
    var ConfirmRemove = confirmRemove;
    var RemoveIcon = theme.fileInput.icons.remove;
    var ErrorIcon = ((_theme$fileInput = theme.fileInput) == null || (_theme$fileInput = _theme$fileInput.icons) == null ? void 0 : _theme$fileInput.error) || (0, $2YwM2.CircleAlert);
    var usingKeyboard = (0, $hp4MM.useKeyboard)();
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: [],
        validate: [
            typeof maxSize === 'number' ? function() {
                var fileList = [].concat(files);
                var message = '';
                var numOfInvalidFiles = fileList.filter(function(_ref2) {
                    var size = _ref2.size;
                    return size > maxSize;
                }).length;
                if (numOfInvalidFiles) {
                    var _fileList$find;
                    var messageId = 'fileInput.maxSizeSingle';
                    if (multiple) messageId = "fileInput.maxSizeMultiple." + (numOfInvalidFiles === 1 ? 'singular' : 'plural');
                    message = format({
                        id: messageId,
                        messages: messages,
                        values: {
                            fileName: (_fileList$find = fileList.find(function(_ref3) {
                                var size = _ref3.size;
                                return size > maxSize;
                            })) == null ? void 0 : _fileList$find.name,
                            maxSize: (0, $7rwbZ.formatBytes)(maxSize),
                            numOfFiles: numOfInvalidFiles
                        }
                    });
                }
                return message;
            } : '',
            max ? function() {
                var fileList = [].concat(files);
                var message = '';
                if (fileList.length > max) message = format({
                    id: 'fileInput.maxFile',
                    messages: messages,
                    values: {
                        max: max
                    }
                });
                return message;
            } : ''
        ]
    }), files = _formContext$useFormI[0], setFiles = _formContext$useFormI[1];
    var mergeTheme = function mergeTheme(propertyName, defaultKey) {
        var result = {};
        var themeProp = theme.fileInput[propertyName];
        if (themeProp) {
            if (typeof themeProp !== 'object') {
                if (defaultKey) result[defaultKey] = themeProp;
                else result = themeProp;
            } else result = $0d0e18331bb47b74$var$_extends({}, themeProp);
        }
        var hoverThemeProp = theme.fileInput.hover[propertyName];
        if (hover && hoverThemeProp) {
            if (typeof hoverThemeProp !== 'object') {
                if (defaultKey) result[defaultKey] = hoverThemeProp;
                else result = hoverThemeProp;
            } else result = $0d0e18331bb47b74$var$_extends({}, result, hoverThemeProp);
        }
        var dragOverThemeProp = theme.fileInput.dragOver[propertyName];
        if (dragOver && dragOverThemeProp) {
            if (typeof dragOverThemeProp !== 'object') {
                if (defaultKey) result[defaultKey] = dragOverThemeProp;
                else result = dragOverThemeProp;
            } else result = $0d0e18331bb47b74$var$_extends({}, result, dragOverThemeProp);
        }
        return typeof result === 'object' && Object.keys(result).length === 0 ? undefined : result;
    };
    // Show the number of files when more than one
    var message;
    if (!files.length) message = format({
        id: multiple ? 'fileInput.dropPromptMultiple' : 'fileInput.dropPrompt',
        messages: messages
    });
    else message = files.length + " items";
    var removeFile = function removeFile(index) {
        var nextFiles;
        if (index === 'all') nextFiles = [];
        else {
            nextFiles = [].concat(files);
            nextFiles.splice(index, 1);
        }
        setFiles(nextFiles);
        // Need to have a way to track the files other than an array
        // since inputRef.current.files is a read-only FileList
        // https://stackoverflow.com/a/64019766
        /* eslint-disable no-undef */ var dt = new DataTransfer();
        var curFiles = inputRef.current.files;
        if (index === 'all' || nextFiles.length === 0) inputRef.current.value = '';
        for(var i = 0; i < curFiles.length; i += 1){
            var curfile = curFiles[i];
            if (index !== i) dt.items.add(curfile);
        }
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'files').set;
        nativeInputValueSetter.call(inputRef.current, dt.files);
        var event = new Event('input', {
            bubbles: true
        });
        inputRef.current.dispatchEvent(event);
        if (_onChange) _onChange(event, {
            files: nextFiles
        });
        inputRef.current.focus();
    };
    // rightPad needs to be included in the rightOffset
    // otherwise input may cover the RemoveButton, making it
    // unreachable by mouse click.
    var rightPad = '0px';
    if (mergeTheme('pad')) {
        var _mergeTheme = mergeTheme('pad'), horizontal = _mergeTheme.horizontal, right = _mergeTheme.right;
        if (right) rightPad = theme.global.edgeSize[right] || right;
        else if (horizontal) rightPad = theme.global.edgeSize[horizontal] || horizontal;
    }
    var removeWidth = removeRef.current ? removeRef.current.getBoundingClientRect().width : 0;
    var controlWidth = controlRef.current ? controlRef.current.getBoundingClientRect().width : 0;
    if (controlRef.current && (_theme$fileInput$anch = theme.fileInput.anchor) != null && _theme$fileInput$anch.margin) {
        if (typeof theme.fileInput.anchor.margin === 'string') controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin] || theme.fileInput.anchor.margin, 10) * 2;
        else if (typeof theme.fileInput.anchor.margin === 'object') {
            var _theme$fileInput$anch2, _theme$fileInput$anch3, _theme$fileInput$anch4;
            if ((_theme$fileInput$anch2 = theme.fileInput.anchor.margin) != null && _theme$fileInput$anch2.horizontal) controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin.horizontal] || theme.fileInput.anchor.margin.horizontal, 10) * 2;
            if ((_theme$fileInput$anch3 = theme.fileInput.anchor.margin) != null && _theme$fileInput$anch3.right) controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin.right] || theme.fileInput.anchor.margin.right, 10);
            if ((_theme$fileInput$anch4 = theme.fileInput.anchor.margin) != null && _theme$fileInput$anch4.left) controlWidth += parseInt(theme.global.edgeSize[theme.fileInput.anchor.margin.left] || theme.fileInput.anchor.margin.left, 10);
        }
    }
    var rightOffset = files.length > 1 ? removeWidth + parseInt(rightPad, 10) : removeWidth + controlWidth + parseInt(rightPad, 10);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($0d0e18331bb47b74$var$ContentsBox, $0d0e18331bb47b74$var$_extends({
        theme: theme,
        flex: false,
        disabled: disabled,
        background: mergeTheme('background', 'color'),
        border: !plain ? mergeTheme('border', 'side') : undefined,
        margin: mergeTheme('margin'),
        pad: mergeTheme('pad'),
        round: mergeTheme('round', 'size'),
        align: files.length ? 'stretch' : 'center',
        justify: "center",
        hover: hover,
        onMouseOver: disabled ? undefined : function() {
            return setHover(true);
        },
        onMouseOut: disabled ? undefined : function() {
            return setHover(false);
        },
        dragOver: dragOver,
        focus: usingKeyboard && focus
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $aSkTl.StyledFileInput), $0d0e18331bb47b74$var$_extends({
        ref: inputRef,
        type: "file",
        id: id,
        name: name,
        maxSize: maxSize,
        multiple: multiple,
        disabled: disabled,
        plain: true,
        "aria-invalid": maxSize && files.some(function(f) {
            return f.size > maxSize;
        }) || max != null && files.length > max,
        rightOffset: rightOffset || undefined
    }, passThemeFlag, rest, {
        onDragOver: function onDragOver() {
            return setDragOver(true);
        },
        onDragLeave: function onDragLeave() {
            return setDragOver(false);
        },
        onChange: function onChange(event) {
            event.persist();
            var fileList = event.target.files;
            // If the user cancelled the file picker, fileList will be empty
            // and we should not clear any previously selected files.
            if (!fileList.length && files.length) return;
            var nextFiles = multiple ? [].concat(files) : [];
            var _loop = function _loop(i) {
                // avoid duplicates
                var existing = nextFiles.filter(function(file) {
                    return file.name === fileList[i].name && file.size === fileList[i].size;
                }).length > 0;
                if (!existing) nextFiles.push(fileList[i]);
            };
            for(var i = 0; i < fileList.length; i += 1)_loop(i);
            setFiles(nextFiles);
            setDragOver(false);
            if (_onChange) _onChange(event, {
                files: nextFiles
            });
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        onFocus: function onFocus() {
            return setFocus(true);
        }
    })), (!files.length || files.length > 1) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        align: "center",
        fill: "horizontal",
        direction: "row",
        justify: "between"
    }, files.length <= aggregateThreshold && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($0d0e18331bb47b74$var$Message, $0d0e18331bb47b74$var$_extends({}, theme.fileInput.message, passThemeFlag), message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onSpace: function onSpace(event) {
            event.preventDefault();
            if (controlRef.current === event.target) inputRef.current.click();
        },
        onEnter: function onEnter(event) {
            if (controlRef.current === event.target) inputRef.current.click();
        }
    }, theme.fileInput.button ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        tabIndex: -1,
        disabled: disabled,
        ref: controlRef,
        kind: theme.fileInput.button,
        label: format({
            id: 'fileInput.browse',
            messages: messages
        }),
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $j0B9N.Anchor), {
        tabIndex: -1,
        alignSelf: "center",
        disabled: disabled,
        ref: controlRef,
        margin: theme.fileInput.anchor.margin,
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        },
        label: format({
            id: 'fileInput.browse',
            messages: messages
        })
    })))), files.length > aggregateThreshold && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        justify: "between",
        direction: "row",
        align: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($0d0e18331bb47b74$var$Label, $0d0e18331bb47b74$var$_extends({}, theme.fileInput.label, passThemeFlag), files.length, ' ', format({
        id: 'fileInput.files',
        messages: messages
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        flex: false,
        direction: "row",
        align: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        ref: removeRef,
        a11yTitle: format({
            id: 'fileInput.removeAll',
            messages: messages
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(RemoveIcon, null),
        hoverIndicator: true,
        disabled: disabled,
        onClick: function onClick(event) {
            if (confirmRemove) {
                event.persist(); // necessary for when React < v17
                setPendingRemoval({
                    event: event,
                    index: 'all'
                });
                setShowRemoveConfirmation(true);
            } else removeFile('all');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onSpace: function onSpace(event) {
            if (controlRef.current === event.target) inputRef.current.click();
        },
        onEnter: function onEnter(event) {
            if (controlRef.current === event.target) inputRef.current.click();
        }
    }, theme.fileInput.button ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        tabIndex: -1,
        disabled: disabled,
        ref: controlRef,
        kind: theme.fileInput.button,
        label: format({
            id: 'fileInput.browse',
            messages: messages
        }),
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $j0B9N.Anchor), {
        tabIndex: -1,
        alignSelf: "center",
        disabled: disabled,
        ref: controlRef,
        margin: theme.fileInput.anchor.margin,
        onClick: function onClick() {
            inputRef.current.click();
            inputRef.current.focus();
        },
        label: format({
            id: 'fileInput.browse',
            messages: messages
        })
    })))), files.length > 0 && files.length <= aggregateThreshold && files.map(function(file, index) {
        var messageId = '';
        if (maxSize && file.size > maxSize) messageId = 'fileInput.alert.maxSize';
        else if (max && index >= max) messageId = 'fileInput.alert.maxFile';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            key: file.name,
            justify: "between",
            direction: "row",
            align: "center"
        }, renderFile ? renderFile(file) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $0d0e18331bb47b74$var$_extends({}, theme.fileInput.label, {
            align: "center",
            direction: "row"
        }), (typeof maxSize === 'number' && file.size > maxSize || typeof max === 'number' && index >= max) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(ErrorIcon, {
            a11yTitle: format({
                id: messageId,
                messages: messages,
                values: {
                    maxFile: max,
                    fileName: file.name,
                    maxSize: (0, $7rwbZ.formatBytes)(maxSize)
                }
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($0d0e18331bb47b74$var$Label, $0d0e18331bb47b74$var$_extends({
            weight: theme.global.input.weight || theme.global.input.font.weight,
            truncate: true
        }, passThemeFlag), file.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            flex: false,
            direction: "row",
            align: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            ref: index ? undefined : removeRef,
            a11yTitle: format({
                id: 'fileInput.remove',
                messages: messages,
                values: {
                    fileName: file.name
                }
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(RemoveIcon, null),
            hoverIndicator: true,
            disabled: disabled,
            onClick: function onClick(event) {
                if (confirmRemove) {
                    event.persist(); // necessary for when React < v17
                    setPendingRemoval({
                        event: event,
                        index: index
                    });
                    setShowRemoveConfirmation(true);
                } else removeFile(index);
            }
        }), files.length === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
            onSpace: function onSpace(event) {
                if (controlRef.current === event.target) inputRef.current.click();
            },
            onEnter: function onEnter(event) {
                if (controlRef.current === event.target) inputRef.current.click();
            }
        }, theme.fileInput.button ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            tabIndex: -1,
            disabled: disabled,
            ref: controlRef,
            kind: theme.fileInput.button,
            label: format({
                id: 'fileInput.browse',
                messages: messages
            }),
            onClick: function onClick() {
                inputRef.current.click();
                inputRef.current.focus();
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $j0B9N.Anchor), {
            tabIndex: -1,
            disabled: disabled,
            ref: controlRef,
            margin: theme.fileInput.anchor.margin,
            onClick: function onClick() {
                inputRef.current.click();
                inputRef.current.focus();
            },
            label: format({
                id: 'fileInput.browse',
                messages: messages
            })
        }))));
    })), showRemoveConfirmation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(ConfirmRemove, {
        onConfirm: function onConfirm() {
            removeFile(pendingRemoval.index);
            setPendingRemoval($0d0e18331bb47b74$var$defaultPendingRemoval);
            setShowRemoveConfirmation(false);
        },
        onCancel: function onCancel() {
            return setShowRemoveConfirmation(false);
        }
    }));
});
$0d0e18331bb47b74$export$b57af79a4ab2a1c6.displayName = 'FileInput';
$0d0e18331bb47b74$export$b57af79a4ab2a1c6.propTypes = (0, $8NDBC.FileInputPropTypes);

});
parcelRegister("2YwM2", function(module, exports) {

$parcel$export(module.exports, "CircleAlert", () => $22aa9b8a788563bd$export$5a89edf87f611fb5, (v) => $22aa9b8a788563bd$export$5a89edf87f611fb5 = v);
var $22aa9b8a788563bd$export$1e511d4a378977f5;
var $22aa9b8a788563bd$export$5a89edf87f611fb5;
"use strict";
$22aa9b8a788563bd$export$1e511d4a378977f5 = true;
$22aa9b8a788563bd$export$5a89edf87f611fb5 = void 0;

var $22aa9b8a788563bd$var$_react = $22aa9b8a788563bd$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $22aa9b8a788563bd$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($22aa9b8a788563bd$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $22aa9b8a788563bd$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $22aa9b8a788563bd$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $22aa9b8a788563bd$var$_extends() {
    return $22aa9b8a788563bd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $22aa9b8a788563bd$var$_extends.apply(null, arguments);
}
var $22aa9b8a788563bd$var$CircleAlert = $22aa9b8a788563bd$export$5a89edf87f611fb5 = /*#__PURE__*/ (0, $22aa9b8a788563bd$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $22aa9b8a788563bd$var$_react["default"].createElement($xazbe.StyledIcon, $22aa9b8a788563bd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleAlert"
    }, props), /*#__PURE__*/ $22aa9b8a788563bd$var$_react["default"].createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M12 14V6m0 12v-2m0-14C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
    }));
});
$22aa9b8a788563bd$var$CircleAlert.displayName = 'CircleAlert';

});

parcelRegister("aSkTl", function(module, exports) {

$parcel$export(module.exports, "StyledFileInput", () => $7eaf27283672e36d$export$f603a3fe6ec80865);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $7eaf27283672e36d$export$f603a3fe6ec80865 = (0, $f5efw.default).input.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledFileInput",
    componentId: "sc-rl7ywv-0"
})([
    "position:absolute;height:100%;width:100%;",
    " font-size:0;opacity:0;border:none;",
    " ",
    " &::-moz-focus-inner{border:none;outline:none;}&::-webkit-file-upload-button{cursor:pointer;}"
], (0, $2O6LY.inputStyle), function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return props.rightOffset && "\n    width: calc(100% - " + props.rightOffset + "px);\n    right: " + props.rightOffset + "px;\n    ";
});

});

parcelRegister("8NDBC", function(module, exports) {

$parcel$export(module.exports, "FileInputPropTypes", () => $66819f37b68d9288$export$659d53017e8cbd51);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $66819f37b68d9288$var$PropType = {};
var $66819f37b68d9288$export$659d53017e8cbd51 = $66819f37b68d9288$var$PropType;

});

parcelRegister("7rwbZ", function(module, exports) {

$parcel$export(module.exports, "formatBytes", () => $56b406c1d5d019d4$export$e1a3971de07c83b5);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $56b406c1d5d019d4$var$SI_CONVERSION_FACTOR = 1000;
var $56b406c1d5d019d4$var$IEC_CONVERSION_FACTOR = 1024;
var $56b406c1d5d019d4$var$getCurrentOS = function getCurrentOS() {
    var currentOS = [
        'Win',
        'Linux',
        'Mac'
    ].find(function(v) {
        var _window;
        if (typeof window !== 'undefined') return ((_window = window) == null || (_window = _window.navigator) == null || (_window = _window.userAgent) == null ? void 0 : _window.indexOf(v)) >= 0;
        return undefined;
    });
    return currentOS;
};
var $56b406c1d5d019d4$var$defaultFormat = function defaultFormat(size) {
    var units = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB'
    ];
    var factor = $56b406c1d5d019d4$var$SI_CONVERSION_FACTOR;
    var index = 0;
    var num = size;
    while(num >= factor && index < units.length - 1){
        num /= factor;
        index += 1;
    }
    return num.toFixed(1) + " " + units[index];
};
var $56b406c1d5d019d4$var$windowsFormat = function windowsFormat(size) {
    var num = Math.ceil(size / $56b406c1d5d019d4$var$IEC_CONVERSION_FACTOR);
    return Intl.NumberFormat().format(num) + " KB";
};
var $56b406c1d5d019d4$var$makeFormatBytes = function makeFormatBytes(OS) {
    return function(size) {
        switch(OS){
            case 'Win':
                return $56b406c1d5d019d4$var$windowsFormat(size);
            default:
                return $56b406c1d5d019d4$var$defaultFormat(size);
        }
    };
};
var $56b406c1d5d019d4$export$e1a3971de07c83b5 = $56b406c1d5d019d4$var$makeFormatBytes($56b406c1d5d019d4$var$getCurrentOS());

});



parcelRegister("6qg9k", function(module, exports) {

$parcel$export(module.exports, "ModalInfoCard", () => $feabbec11b9e3bf9$export$3b4bfc27291cfca6);

var $6ir3O = parcelRequire("6ir3O");

var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $1fLUh = parcelRequire("1fLUh");
const $feabbec11b9e3bf9$export$3b4bfc27291cfca6 = ({ title: title, children: children })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        background: "light-2",
        round: "small",
        elevation: "none",
        border: {
            size: '1px',
            color: 'light-4'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)'
                },
                height: "42px",
                pad: {
                    horizontal: 'medium'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                    level: 4,
                    margin: "none",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
                pad: "small",
                background: "light-2",
                children: children
            })
        ]
    });
};

});


parcelRegister("eOVbw", function(module, exports) {
$parcel$export(module.exports, "CommercialEditReviewModal", () => (parcelRequire("lpy8P")).CommercialEditReviewModal);
parcelRequire("lpy8P");

});
parcelRegister("lpy8P", function(module, exports) {

$parcel$export(module.exports, "CommercialEditReviewModal", () => $4c9bda6953e7d8bb$export$8e1bab2abe9b4f9e);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $leMeY = parcelRequire("leMeY");
var $emlIu = parcelRequire("emlIu");
var $7FCbb = parcelRequire("7FCbb");
var $8kKyn = parcelRequire("8kKyn");

var $eLUFj = parcelRequire("eLUFj");

var $8DltC = parcelRequire("8DltC");

var $1SpQX = parcelRequire("1SpQX");
var $kOwHr = parcelRequire("kOwHr");
var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $1fLUh = parcelRequire("1fLUh");
var $jmzyn = parcelRequire("jmzyn");
var $5erKi = parcelRequire("5erKi");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbInV = parcelRequire("kbInV");
var $hRbKn = parcelRequire("hRbKn");
var $iLsof = parcelRequire("iLsof");
var $5a3jD = parcelRequire("5a3jD");
var $kjGz8 = parcelRequire("kjGz8");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $1Dexz = parcelRequire("1Dexz");

var $az33k = parcelRequire("az33k");

var $dmJzY = parcelRequire("dmJzY");

var $di5Ky = parcelRequire("di5Ky");

var $dasnA = parcelRequire("dasnA");

var $iBocF = parcelRequire("iBocF");

var $dOfWq = parcelRequire("dOfWq");
var $4c9bda6953e7d8bb$require$Buffer = $dOfWq.Buffer;
var $4c9bda6953e7d8bb$var$Verdict = /*#__PURE__*/ function(Verdict) {
    Verdict["upgrade"] = "Upgrade";
    Verdict["downgrade"] = "Downgrade";
    Verdict["noChange"] = "No Change";
    Verdict["outgraded"] = "Manually Outgraded";
    return Verdict;
}($4c9bda6953e7d8bb$var$Verdict || {});
const $4c9bda6953e7d8bb$export$8e1bab2abe9b4f9e = (0, $j8yBr.observer)(({ commercial: commercial, setShowCommercialEditReviewModal: setShowCommercialEditReviewModal, initialEditId: initialEditId })=>{
    /** Context **/ const commercialStore = (0, $8DltC.useCommercialStore)();
    const performerStore = (0, $8DltC.usePerformerStore)();
    const userStore = (0, $8DltC.useUserStore)();
    /** State **/ const [editReviewsData, setEditReviewsData] = (0, $2NacA.useState)(new Map());
    const [batchProgress, setBatchProgress] = (0, $2NacA.useState)(null);
    const [initialLoading, setInitialLoading] = (0, $2NacA.useState)(true);
    const [activeAccordionIndexes, setActiveAccordionIndexes] = (0, $2NacA.useState)([]);
    /** Computed **/ // WebSocket for real-time EditReview completion updates
    const { lastJsonMessage: lastJsonMessage } = (0, (/*@__PURE__*/$parcel$interopDefault($1Dexz)))(`${(0, $eLUFj.env).apiWsHost}:${(0, $eLUFj.env).apiPort}`, {
        protocols: [
            'Authorization',
            userStore.token
        ],
        shouldReconnect: ()=>true,
        reconnectInterval: 3000,
        share: true
    });
    /** Methods **/ // Process analyses for an edit review - memoized to avoid recreating on every render
    const processEditAnalyses = (0, $2NacA.useCallback)((editReview, contracts)=>{
        if (!editReview || contracts.length === 0) return {
            knownAnalyses: [],
            unknownAnalyses: []
        };
        const knownPerformerIds = new Set(contracts.map((c)=>c.performer.id));
        const known = contracts.map((contract)=>{
            const analysis = editReview.analyses?.find((a)=>a.performerId === contract.performer.id);
            if (analysis?.outgraded) return {
                contract: contract,
                analysis: analysis,
                frameUrls: [],
                verdict: "Manually Outgraded"
            };
            if (!analysis || analysis.frameAppears.length === 0) {
                if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).Extra) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: [],
                    verdict: "No Change"
                };
                else if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: [],
                    verdict: "Downgrade"
                };
                else return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: [],
                    verdict: "No Change"
                };
            }
            const frameUrls = editReview.framePaths?.filter((imageLocation)=>analysis.frameAppears.some((frameIndex)=>imageLocation.fileName.includes(`${String(frameIndex).padStart(4, '0')}.jpg`))).map((imageLocation)=>imageLocation.signedUrl);
            if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).Extra) {
                if (analysis.type === (0, $8kKyn.RolePerformerType).Extra) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: frameUrls,
                    verdict: "No Change"
                };
                else if (analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: frameUrls,
                    verdict: "Upgrade"
                };
                else return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: frameUrls,
                    verdict: "No Change"
                };
            } else if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) {
                if (analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: frameUrls,
                    verdict: "No Change"
                };
                else if (analysis.type === (0, $8kKyn.RolePerformerType).Extra) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: frameUrls,
                    verdict: "Downgrade"
                };
                else return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: frameUrls,
                    verdict: "No Change"
                };
            } else return {
                contract: contract,
                analysis: analysis,
                frameUrls: frameUrls,
                verdict: "No Change"
            };
        });
        const unknown = (editReview.analyses || []).filter((analysis)=>!knownPerformerIds.has(analysis.performerId)).map((analysis)=>{
            const frameUrls = editReview.framePaths?.filter((imageLocation)=>analysis.frameAppears.some((frameIndex)=>imageLocation.fileName.includes(`${String(frameIndex).padStart(4, '0')}.jpg`))).map((imageLocation)=>imageLocation.signedUrl);
            return {
                analysis: analysis,
                frameUrls: frameUrls
            };
        });
        return {
            knownAnalyses: known,
            unknownAnalyses: unknown
        };
    }, []);
    const handleRunReview = async (editId)=>{
        const dataMap = new Map(editReviewsData);
        const editData = dataMap.get(editId);
        // Validate that edit has required data
        if (editData && !editData.edit.asset_id) {
            (0, $bsB3E.toast).error('Cannot run review: This edit has no video asset attached');
            return;
        }
        if (editData) {
            dataMap.set(editId, {
                ...editData,
                loading: true
            });
            setEditReviewsData(dataMap);
        }
        try {
            const response = await commercialStore.createEditReview(editId);
            if (response?.editReview) {
                const updatedMap = new Map(editReviewsData);
                const existing = updatedMap.get(editId);
                if (existing) {
                    const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(response.editReview, existing.contracts);
                    updatedMap.set(editId, {
                        ...existing,
                        editReview: response.editReview,
                        loading: false,
                        knownAnalyses: knownAnalyses,
                        unknownAnalyses: unknownAnalyses
                    });
                    setEditReviewsData(updatedMap);
                }
                (0, $bsB3E.toast).success('Edit review started');
            }
        } catch (error) {
            console.error('Error running edit review:', error);
            const errorMessage = error instanceof Error ? error.message : 'Failed to start edit review';
            // Show more specific error messages
            if (errorMessage.includes('missing required data')) (0, $bsB3E.toast).error('Cannot run review: Edit is missing required video asset');
            else (0, $bsB3E.toast).error(errorMessage);
            const updatedMap = new Map(editReviewsData);
            const existing = updatedMap.get(editId);
            if (existing) {
                updatedMap.set(editId, {
                    ...existing,
                    loading: false
                });
                setEditReviewsData(updatedMap);
            }
        }
    };
    const handleRunAllReviews = async ()=>{
        // Filter edits that need review and have assets
        const editsToRun = Array.from(editReviewsData.values()).filter((data)=>data.edit.asset_id && // Only include edits with assets
            (!data.editReview || data.editReview.status === (0, $7FCbb.EditReviewStatus).FAILED));
        const editsWithoutAssets = Array.from(editReviewsData.values()).filter((data)=>!data.edit.asset_id);
        if (editsToRun.length === 0) {
            if (editsWithoutAssets.length > 0) (0, $bsB3E.toast).info(`No edits ready to review. ${editsWithoutAssets.length} edit(s) missing video assets.`);
            else (0, $bsB3E.toast).info('All edit reviews are already complete');
            return;
        }
        if (editsWithoutAssets.length > 0) (0, $bsB3E.toast).info(`Running ${editsToRun.length} review(s). Skipping ${editsWithoutAssets.length} edit(s) without assets.`);
        setBatchProgress({
            current: 0,
            total: editsToRun.length
        });
        const promises = editsToRun.map(async (data, index)=>{
            try {
                const response = await commercialStore.createEditReview(data.edit.id);
                setBatchProgress({
                    current: index + 1,
                    total: editsToRun.length
                });
                return {
                    editId: data.edit.id,
                    editReview: response?.editReview || null
                };
            } catch (error) {
                console.error(`Error running edit review for ${data.edit.id}:`, error);
                return {
                    editId: data.edit.id,
                    editReview: null
                };
            }
        });
        const results = await Promise.all(promises);
        const updatedMap = new Map(editReviewsData);
        results.forEach(({ editId: editId, editReview: editReview })=>{
            const existing = updatedMap.get(editId);
            if (existing && editReview) {
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(editReview, existing.contracts);
                updatedMap.set(editId, {
                    ...existing,
                    editReview: editReview,
                    loading: false,
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses
                });
            }
        });
        setEditReviewsData(updatedMap);
        setBatchProgress(null);
        (0, $bsB3E.toast).success(`Started ${editsToRun.length} edit review${editsToRun.length > 1 ? 's' : ''}`);
    };
    // Action handlers for performers
    const handleReclassify = async (editId, performerId, newType, reason)=>{
        const editData = editReviewsData.get(editId);
        if (!editData) return;
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            processingAction: performerId
        }));
        try {
            const response = await (0, $emlIu.EditReviewService).reclassifyPerformer(editId, {
                performerId: performerId,
                newType: newType,
                reason: reason
            });
            if (response?.editReview) {
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(response.editReview, editData.contracts);
                setEditReviewsData(new Map(editReviewsData).set(editId, {
                    ...editData,
                    editReview: response.editReview,
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses,
                    processingAction: null
                }));
                (0, $bsB3E.toast).success(`Successfully reclassified performer as ${newType}`);
            }
        } catch (error) {
            console.error('Error reclassifying performer:', error);
            (0, $bsB3E.toast).error('Failed to reclassify performer');
            setEditReviewsData(new Map(editReviewsData).set(editId, {
                ...editData,
                processingAction: null
            }));
        }
    };
    const handleMarkInvalid = async (editId, performerId, reason)=>{
        const editData = editReviewsData.get(editId);
        if (!editData) return;
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            processingAction: performerId
        }));
        try {
            const response = await (0, $emlIu.EditReviewService).markPerformerInvalid(editId, {
                performerId: performerId,
                reason: reason
            });
            if (response?.editReview) {
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(response.editReview, editData.contracts);
                setEditReviewsData(new Map(editReviewsData).set(editId, {
                    ...editData,
                    editReview: response.editReview,
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses,
                    processingAction: null
                }));
                (0, $bsB3E.toast).success('Successfully marked as invalid detection');
            }
        } catch (error) {
            console.error('Error marking performer invalid:', error);
            (0, $bsB3E.toast).error('Failed to mark as invalid');
            setEditReviewsData(new Map(editReviewsData).set(editId, {
                ...editData,
                processingAction: null
            }));
        }
    };
    const handleOutgrade = async (editId, performerId, contractedType, reason)=>{
        const editData = editReviewsData.get(editId);
        if (!editData) return;
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            processingAction: performerId
        }));
        try {
            const response = await (0, $emlIu.EditReviewService).outgradePerformer(editId, {
                performerId: performerId,
                contractedType: contractedType,
                reason: reason
            });
            if (response?.editReview) {
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(response.editReview, editData.contracts);
                const analysis = response.editReview.analyses?.find((a)=>a.performerId === performerId);
                setEditReviewsData(new Map(editReviewsData).set(editId, {
                    ...editData,
                    editReview: response.editReview,
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses,
                    processingAction: null
                }));
                (0, $bsB3E.toast).success(analysis?.outgraded ? 'Performer outgraded - not in this edit' : 'Outgrade removed');
            }
        } catch (error) {
            console.error('Error outgrading performer:', error);
            (0, $bsB3E.toast).error('Failed to outgrade performer');
            setEditReviewsData(new Map(editReviewsData).set(editId, {
                ...editData,
                processingAction: null
            }));
        }
    };
    const handleMergePerformers = async (editId)=>{
        if (!editId) return;
        const editData = editReviewsData.get(editId);
        if (!editData || editData.selectedPerformers.size < 2) return;
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            processingAction: 'merge'
        }));
        try {
            const response = await (0, $emlIu.EditReviewService).mergePerformers(editId, {
                performerIds: Array.from(editData.selectedPerformers),
                newName: editData.mergeName || undefined
            });
            if (response?.editReview) {
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(response.editReview, editData.contracts);
                setEditReviewsData(new Map(editReviewsData).set(editId, {
                    ...editData,
                    editReview: response.editReview,
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses,
                    processingAction: null,
                    selectedPerformers: new Set(),
                    showMergeDialog: false,
                    mergeName: ''
                }));
                (0, $bsB3E.toast).success(`Successfully merged ${editData.selectedPerformers.size} performers`);
            }
        } catch (error) {
            console.error('Error merging performers:', error);
            (0, $bsB3E.toast).error('Failed to merge performers');
            setEditReviewsData(new Map(editReviewsData).set(editId, {
                ...editData,
                processingAction: null
            }));
        }
    };
    const handleIdentifyPerformer = async (editId, unknownPerformerId, contractedPerformerId)=>{
        const editData = editReviewsData.get(editId);
        if (!editData) return;
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            processingAction: unknownPerformerId
        }));
        try {
            const response = await (0, $emlIu.EditReviewService).identifyPerformer(editId, {
                unknownPerformerId: unknownPerformerId,
                contractedPerformerId: contractedPerformerId
            });
            if (response?.editReview) {
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(response.editReview, editData.contracts);
                setEditReviewsData(new Map(editReviewsData).set(editId, {
                    ...editData,
                    editReview: response.editReview,
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses,
                    processingAction: null
                }));
                (0, $bsB3E.toast).success('Successfully identified performer');
            }
        } catch (error) {
            console.error('Error identifying performer:', error);
            (0, $bsB3E.toast).error('Failed to identify performer');
            setEditReviewsData(new Map(editReviewsData).set(editId, {
                ...editData,
                processingAction: null
            }));
        }
    };
    const togglePerformerSelection = (editId, performerId)=>{
        const editData = editReviewsData.get(editId);
        if (!editData) return;
        const newSelection = new Set(editData.selectedPerformers);
        if (newSelection.has(performerId)) newSelection.delete(performerId);
        else newSelection.add(performerId);
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            selectedPerformers: newSelection
        }));
    };
    const updateEditData = (editId, updates)=>{
        const editData = editReviewsData.get(editId);
        if (!editData) return;
        setEditReviewsData(new Map(editReviewsData).set(editId, {
            ...editData,
            ...updates
        }));
    };
    // Handle generate completion report
    const handleGenerateCompletionReport = async ()=>{
        try {
            const editsArray = Array.from(editReviewsData.values());
            const allCompleted = editsArray.every((d)=>d.editReview && d.editReview.status === (0, $7FCbb.EditReviewStatus).COMPLETED);
            if (!allCompleted || editsArray.length === 0) {
                (0, $bsB3E.toast).error('All edit reviews must be completed before generating the report.');
                return;
            }
            (0, $bsB3E.toast).info('Generating completion report...');
            const base64Pdf = await (0, $leMeY.CommercialService).generateCompletionReport(commercial.id);
            // Convert base64 to blob using Buffer (more robust than atob)
            const byteArray = Uint8Array.from($4c9bda6953e7d8bb$require$Buffer.from(base64Pdf, 'base64'));
            const blob = new Blob([
                byteArray
            ], {
                type: 'application/pdf'
            });
            // Open in new window
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            // Clean up the URL after a delay
            setTimeout(()=>window.URL.revokeObjectURL(url), 5000);
            (0, $bsB3E.toast).success('Completion report generated!');
        } catch (error) {
            console.error('Error generating completion report:', error);
            (0, $bsB3E.toast).error('Failed to generate completion report.');
        }
    };
    // Handle accordion panel expand/collapse with lazy loading
    const handleAccordionChange = (activeIndexes)=>{
        setActiveAccordionIndexes(activeIndexes);
        const editsArray = Array.from(editReviewsData.values());
        // Process analyses for newly expanded panels
        activeIndexes.forEach((index)=>{
            const editId = editsArray[index].edit.id;
            const editData = editReviewsData.get(editId);
            if (editData && editData.editReview && editData.knownAnalyses.length === 0 && editData.unknownAnalyses.length === 0) {
                // First time expanding - process analyses
                const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(editData.editReview, editData.contracts);
                updateEditData(editId, {
                    knownAnalyses: knownAnalyses,
                    unknownAnalyses: unknownAnalyses
                });
            }
        });
    };
    // Helper functions
    const getStatusColor = (status)=>{
        switch(status){
            case (0, $7FCbb.EditReviewStatus).COMPLETED:
                return 'status-ok';
            case (0, $7FCbb.EditReviewStatus).PROCESSING:
            case (0, $7FCbb.EditReviewStatus).PENDING:
                return 'status-warning';
            case (0, $7FCbb.EditReviewStatus).FAILED:
                return 'status-critical';
            default:
                return 'light-4';
        }
    };
    const getStatusLabel = (status)=>{
        if (!status) return 'Not Run';
        switch(status){
            case (0, $7FCbb.EditReviewStatus).COMPLETED:
                return 'Complete';
            case (0, $7FCbb.EditReviewStatus).PROCESSING:
                return 'Processing';
            case (0, $7FCbb.EditReviewStatus).PENDING:
                return 'Pending';
            case (0, $7FCbb.EditReviewStatus).FAILED:
                return 'Error';
            default:
                return 'Unknown';
        }
    };
    const getSummaryStats = (editReview)=>{
        if (!editReview || !editReview.analyses) return {
            principals: 0,
            extras: 0,
            unknown: 0
        };
        const analyses = editReview.analyses.filter((a)=>!a.invalidDetection && !a.outgraded);
        const principals = analyses.filter((a)=>a.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal).length;
        const extras = analyses.filter((a)=>a.type === (0, $8kKyn.RolePerformerType).Extra).length;
        const unknown = analyses.filter((a)=>!a.performerId || a.performerName).length;
        return {
            principals: principals,
            extras: extras,
            unknown: unknown
        };
    };
    const getWarnings = (editReview)=>{
        if (!editReview || !editReview.analyses) return {
            outgraded: 0,
            invalid: 0,
            needsId: 0
        };
        const outgraded = editReview.analyses.filter((a)=>a.outgraded).length;
        const invalid = editReview.analyses.filter((a)=>a.invalidDetection).length;
        const needsId = editReview.analyses.filter((a)=>!a.identifiedAs && a.performerName).length;
        return {
            outgraded: outgraded,
            invalid: invalid,
            needsId: needsId
        };
    };
    const getThumbnails = (editReview)=>{
        if (!editReview || !editReview.analyses || !editReview.framePaths) return [];
        const thumbnails = [];
        const analyses = editReview.analyses.filter((a)=>!a.invalidDetection && a.frameAppears.length > 0);
        for (const analysis of analyses.slice(0, 4)){
            const firstFrame = analysis.frameAppears[0];
            const framePath = editReview.framePaths.find((fp)=>fp.fileName.includes(`${String(firstFrame).padStart(4, '0')}.jpg`));
            if (framePath?.signedUrl) thumbnails.push(framePath.signedUrl);
        }
        return thumbnails;
    };
    const editsArray = Array.from(editReviewsData.values());
    const completedCount = editsArray.filter((d)=>d.editReview && d.editReview.status === (0, $7FCbb.EditReviewStatus).COMPLETED).length;
    const totalCount = editsArray.length;
    /** Effects **/ // Load all edit reviews and contracts on mount
    (0, $2NacA.useEffect)(()=>{
        const loadEditReviews = async ()=>{
            if (!commercial.edits || commercial.edits.length === 0) {
                setInitialLoading(false);
                return;
            }
            // Load contracts once for the commercial
            let contracts = [];
            try {
                const c = await performerStore.listPerformerContracts({
                    commercialId: commercial.id,
                    relations: 'performer,role'
                });
                if (c) contracts = c;
            } catch (error) {
                console.error('Error loading contracts:', error);
            }
            // Initialize map with all edits
            const dataMap = new Map();
            commercial.edits.forEach((edit)=>{
                dataMap.set(edit.id, {
                    edit: edit,
                    editReview: null,
                    loading: true,
                    contracts: contracts,
                    knownAnalyses: [],
                    unknownAnalyses: [],
                    processingAction: null,
                    selectedPerformers: new Set(),
                    showMergeDialog: false,
                    mergeName: '',
                    enlargedFrameUrl: null
                });
            });
            setEditReviewsData(dataMap);
            // Fetch all edit reviews in parallel
            const promises = commercial.edits.map(async (edit)=>{
                try {
                    const response = await commercialStore.getEditReviewByEditId(edit.id);
                    return {
                        editId: edit.id,
                        editReview: response?.editReview || null
                    };
                } catch (error) {
                    console.error(`Error loading edit review for edit ${edit.id}:`, error);
                    return {
                        editId: edit.id,
                        editReview: null
                    };
                }
            });
            const results = await Promise.all(promises);
            // Update map with results (don't process analyses yet - lazy load on expand)
            const updatedMap = new Map(dataMap);
            results.forEach(({ editId: editId, editReview: editReview })=>{
                const existing = updatedMap.get(editId);
                if (existing) updatedMap.set(editId, {
                    ...existing,
                    editReview: editReview,
                    loading: false
                });
            });
            setEditReviewsData(updatedMap);
            setInitialLoading(false);
            // If initialEditId is provided, find its index, set it as active, and process its analyses
            if (initialEditId) {
                const editIndex = commercial.edits?.findIndex((edit)=>edit.id === initialEditId);
                if (editIndex !== undefined && editIndex !== -1) {
                    setActiveAccordionIndexes([
                        editIndex
                    ]);
                    // Manually process analyses for the initial edit
                    const editData = updatedMap.get(initialEditId);
                    if (editData && editData.editReview && editData.knownAnalyses.length === 0 && editData.unknownAnalyses.length === 0) {
                        const { knownAnalyses: knownAnalyses, unknownAnalyses: unknownAnalyses } = processEditAnalyses(editData.editReview, editData.contracts);
                        const finalMap = new Map(updatedMap);
                        finalMap.set(initialEditId, {
                            ...editData,
                            knownAnalyses: knownAnalyses,
                            unknownAnalyses: unknownAnalyses
                        });
                        setEditReviewsData(finalMap);
                    }
                }
            }
        };
        loadEditReviews();
    }, [
        commercial.edits,
        commercialStore,
        performerStore,
        initialEditId
    ]);
    // Listen for WebSocket messages about EditReview completion
    (0, $2NacA.useEffect)(()=>{
        if (!lastJsonMessage) return;
        const message = lastJsonMessage;
        // Check if this is an edit review completion notification
        if (message.source_entity_name === 'edits' && message.source_entity_id) {
            // Parse the entity ID format: "commercialId/editId"
            const parts = message.source_entity_id.split('/');
            if (parts.length === 2) {
                const [notificationCommercialId, notificationEditId] = parts;
                // Check if this notification is for the current commercial
                if (notificationCommercialId === commercial.id) {
                    console.log(`Received EditReview completion notification for edit ${notificationEditId}`);
                    // Fetch the updated EditReview data
                    commercialStore.getEditReviewByEditId(notificationEditId).then((response)=>{
                        if (response?.editReview) {
                            const updatedEditReview = response.editReview; // Extract to const for type safety
                            setEditReviewsData((prevData)=>{
                                const existingData = prevData.get(notificationEditId);
                                if (!existingData) return prevData; // Edit not in current modal
                                const updatedMap = new Map(prevData);
                                // Check if the accordion for this edit is expanded
                                const editIndex = commercial.edits?.findIndex((e)=>e.id === notificationEditId) ?? -1;
                                const isExpanded = activeAccordionIndexes.includes(editIndex);
                                let knownAnalyses = existingData.knownAnalyses;
                                let unknownAnalyses = existingData.unknownAnalyses;
                                // Process analyses if expanded OR if there are no analyses yet
                                if (isExpanded || knownAnalyses.length === 0 && unknownAnalyses.length === 0) {
                                    const processed = processEditAnalyses(updatedEditReview, existingData.contracts);
                                    knownAnalyses = processed.knownAnalyses;
                                    unknownAnalyses = processed.unknownAnalyses;
                                }
                                updatedMap.set(notificationEditId, {
                                    ...existingData,
                                    editReview: updatedEditReview,
                                    loading: false,
                                    knownAnalyses: knownAnalyses,
                                    unknownAnalyses: unknownAnalyses
                                });
                                console.log(`Updated EditReview data for edit ${notificationEditId}, status: ${updatedEditReview.status}`);
                                return updatedMap;
                            });
                        }
                    }).catch((error)=>{
                        console.error(`Error fetching updated EditReview for edit ${notificationEditId}:`, error);
                    });
                }
            }
        }
    }, [
        lastJsonMessage,
        commercial.id,
        commercial.edits,
        activeAccordionIndexes,
        commercialStore,
        processEditAnalyses
    ]);
    /** Render **/ const Loader = ({ spinnerSize: spinnerSize = 'large', ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            align: "center",
            justify: "center",
            pad: "large",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                    size: spinnerSize
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    margin: {
                        top: 'small'
                    },
                    children: "Loading edit reviews..."
                })
            ]
        });
    const CommercialTitle = ({ data: data, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            gap: "small",
            align: "center",
            wrap: false,
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    flex: false,
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                        level: 4,
                        margin: "none",
                        children: data.edit.title
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    flex: false,
                    background: getStatusColor(data.editReview?.status),
                    pad: {
                        horizontal: 'xsmall',
                        vertical: 'xxsmall'
                    },
                    round: "xsmall",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        weight: "bold",
                        children: getStatusLabel(data.editReview?.status)
                    })
                })
            ]
        });
    const CommercialStats = ({ stats: stats, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            gap: "medium",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)("strong", {
                            children: stats.principals
                        }),
                        " principals"
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)("strong", {
                            children: stats.extras
                        }),
                        " extras"
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)("strong", {
                            children: stats.unknown
                        }),
                        " unknown"
                    ]
                })
            ]
        });
    const CommercialThumbnails = ({ thumbnails: thumbnails, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            direction: "row",
            gap: "xsmall",
            ...props,
            children: thumbnails.map((url, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    width: "60px",
                    height: "60px",
                    overflow: "hidden",
                    round: "xsmall",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                        src: url,
                        fit: "cover"
                    })
                }, i))
        });
    const ErrorMessage = ({ data: data, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            ...props,
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                size: "small",
                color: "status-critical",
                children: [
                    "Error: ",
                    data.editReview?.error_message
                ]
            })
        });
    const MissingAssetWarning = (props)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            direction: "row",
            gap: "xxsmall",
            align: "center",
            background: "status-warning",
            pad: {
                horizontal: 'small',
                vertical: 'xxsmall'
            },
            round: "xsmall",
            ...props,
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: "xsmall",
                color: "white",
                children: "\u26A0\uFE0F No video asset - upload required to run review"
            })
        });
    const CommercialWarnings = ({ warnings: warnings, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            gap: "small",
            ...props,
            children: [
                warnings.outgraded > 0 && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "xxsmall",
                    align: "center",
                    background: "status-critical",
                    pad: {
                        horizontal: 'small',
                        vertical: 'xxsmall'
                    },
                    round: "xsmall",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5a3jD.StatusWarning), {
                            size: "small",
                            color: "white"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            size: "xsmall",
                            color: "white",
                            children: [
                                warnings.outgraded,
                                " outgraded"
                            ]
                        })
                    ]
                }),
                warnings.invalid > 0 && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "xxsmall",
                    align: "center",
                    background: "status-warning",
                    pad: {
                        horizontal: 'small',
                        vertical: 'xxsmall'
                    },
                    round: "xsmall",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbInV.Alert), {
                            size: "small",
                            color: "white"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            size: "xsmall",
                            color: "white",
                            children: [
                                warnings.invalid,
                                " invalid"
                            ]
                        })
                    ]
                }),
                warnings.needsId > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "xxsmall",
                    align: "center",
                    background: "accent-1",
                    pad: {
                        horizontal: 'small',
                        vertical: 'xxsmall'
                    },
                    round: "xsmall",
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "white",
                        children: [
                            "\u2753 ",
                            warnings.needsId,
                            " need ID"
                        ]
                    })
                })
            ]
        });
    const ActionButton = ({ data: data, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            flex: false,
            margin: {
                left: 'small'
            },
            onClick: (e)=>{
                e.stopPropagation();
                if (!data.loading && !batchProgress && data.edit.asset_id && data.editReview?.status !== (0, $7FCbb.EditReviewStatus).PENDING && data.editReview?.status !== (0, $7FCbb.EditReviewStatus).PROCESSING) handleRunReview(data.edit.id);
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!data.loading && !batchProgress && data.edit.asset_id && data.editReview?.status !== (0, $7FCbb.EditReviewStatus).PENDING && data.editReview?.status !== (0, $7FCbb.EditReviewStatus).PROCESSING) handleRunReview(data.edit.id);
                }
            },
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            },
            round: "xsmall",
            background: data.loading || !!batchProgress || !data.edit.asset_id || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING ? 'light-3' : 'white',
            border: {
                color: 'brand',
                size: 'small'
            },
            style: {
                cursor: data.loading || !!batchProgress || !data.edit.asset_id || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING ? 'not-allowed' : 'pointer',
                opacity: data.loading || !!batchProgress || !data.edit.asset_id || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING ? 0.5 : 1,
                userSelect: 'none'
            },
            tabIndex: 0,
            role: "button",
            "aria-label": data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING ? 'Processing...' : data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING ? 'Pending...' : data.editReview ? 'Re-run edit review' : 'Run edit review',
            "aria-disabled": data.loading || !!batchProgress || !data.edit.asset_id || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING,
            title: !data.edit.asset_id ? 'Upload a video asset first' : data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING ? 'Review is queued for processing' : data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING ? 'Review is currently being processed' : undefined,
            ...props,
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "xsmall",
                align: "center",
                children: [
                    data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING || data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                        size: "small"
                    }) : data.editReview ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kjGz8.Update), {
                        size: "small"
                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iLsof.Magic), {
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "small",
                        children: data.editReview?.status === (0, $7FCbb.EditReviewStatus).PROCESSING ? 'Processing...' : data.editReview?.status === (0, $7FCbb.EditReviewStatus).PENDING ? 'Pending...' : data.editReview ? 'Re-run' : 'Run Review'
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowCommercialEditReviewModal(false),
        onClickOutside: ()=>setShowCommercialEditReviewModal(false),
        position: "center",
        modal: true,
        background: "transparent",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $az33k.ModalCard), {
            onClose: ()=>setShowCommercialEditReviewModal(false),
            title: `Edit Reviews: ${commercial.title}`,
            noLayerComponent: true,
            cardProps: {
                width: '845px',
                height: '60vh'
            },
            headerSubtext: `${completedCount} of ${totalCount} complete`,
            bodyProps: {
                gap: 'medium'
            },
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                    justify: "end",
                    direction: "row",
                    gap: "small",
                    pad: "small",
                    align: "center",
                    children: [
                        batchProgress && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            align: "center",
                            flex: true,
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: [
                                        "Processing ",
                                        batchProgress.current,
                                        "/",
                                        batchProgress.total
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Generate Final Cast",
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hRbKn.Checkmark), {}),
                            onClick: handleGenerateCompletionReport,
                            disabled: completedCount !== totalCount || totalCount === 0 || initialLoading,
                            primary: true
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Run All Reviews",
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iLsof.Magic), {}),
                            onClick: handleRunAllReviews,
                            disabled: !!batchProgress || initialLoading,
                            primary: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                    gap: "large",
                    children: [
                        initialLoading && /*#__PURE__*/ (0, $6ir3O.jsx)(Loader, {}),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1SpQX.Accordion), {
                            multiple: true,
                            animate: false,
                            onActive: handleAccordionChange,
                            activeIndex: activeAccordionIndexes,
                            children: editsArray.map((data)=>{
                                const stats = getSummaryStats(data.editReview);
                                const warnings = getWarnings(data.editReview);
                                const thumbnails = getThumbnails(data.editReview);
                                return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kOwHr.AccordionPanel), {
                                    label: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        direction: "row",
                                        justify: "between",
                                        align: "start",
                                        fill: "horizontal",
                                        pad: "small",
                                        margin: {
                                            bottom: 'small'
                                        },
                                        background: "light-2",
                                        round: "xsmall",
                                        border: {
                                            color: 'light-4',
                                            size: 'small'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                flex: "grow",
                                                gap: "small",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $6ir3O.jsx)(CommercialTitle, {
                                                        data: data
                                                    }),
                                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                        size: "small",
                                                        color: "text-weak",
                                                        children: [
                                                            data.edit.type,
                                                            " \u2022 ",
                                                            data.edit.duration,
                                                            "s"
                                                        ]
                                                    }),
                                                    data.editReview?.status === (0, $7FCbb.EditReviewStatus).COMPLETED && /*#__PURE__*/ (0, $6ir3O.jsx)(CommercialStats, {
                                                        stats: stats
                                                    }),
                                                    thumbnails.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)(CommercialThumbnails, {
                                                        thumbnails: thumbnails
                                                    }),
                                                    data.editReview?.status === (0, $7FCbb.EditReviewStatus).COMPLETED && (warnings.outgraded > 0 || warnings.invalid > 0 || warnings.needsId > 0) && /*#__PURE__*/ (0, $6ir3O.jsx)(CommercialWarnings, {
                                                        warnings: warnings
                                                    }),
                                                    data.editReview?.status === (0, $7FCbb.EditReviewStatus).FAILED && data.editReview?.error_message && /*#__PURE__*/ (0, $6ir3O.jsx)(ErrorMessage, {
                                                        data: data
                                                    }),
                                                    !data.edit.asset_id && /*#__PURE__*/ (0, $6ir3O.jsx)(MissingAssetWarning, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)(ActionButton, {
                                                data: data
                                            })
                                        ]
                                    }),
                                    children: [
                                        data.loading && !data.editReview && /*#__PURE__*/ (0, $6ir3O.jsx)(Loader, {}),
                                        data.editReview && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            gap: "medium",
                                            margin: {
                                                top: 'small'
                                            },
                                            children: [
                                                data.knownAnalyses.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmJzY.ContractedPerformersPanel), {
                                                    knownAnalyses: data.knownAnalyses,
                                                    editReview: data.editReview,
                                                    processingAction: data.processingAction,
                                                    setEnlargedFrameUrl: (val)=>updateEditData(data.edit.id, {
                                                            enlargedFrameUrl: val ?? null
                                                        }),
                                                    handleOutgrade: handleOutgrade,
                                                    handleReclassify: handleReclassify,
                                                    handleMarkInvalid: handleMarkInvalid
                                                }),
                                                data.unknownAnalyses.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iBocF.UnknownPerformersPanel), {
                                                    unknownAnalyses: data.unknownAnalyses,
                                                    contracts: data.contracts,
                                                    selectedPerformers: data.selectedPerformers,
                                                    processingAction: data.processingAction,
                                                    setEnlargedFrameUrl: (val)=>updateEditData(data.edit.id, {
                                                            enlargedFrameUrl: val ?? null
                                                        }),
                                                    setShowMergeDialog: (val)=>updateEditData(data.edit.id, {
                                                            showMergeDialog: val
                                                        }),
                                                    togglePerformerSelection: togglePerformerSelection,
                                                    handleIdentifyPerformer: handleIdentifyPerformer,
                                                    handleReclassify: handleReclassify,
                                                    handleMarkInvalid: handleMarkInvalid
                                                })
                                            ]
                                        }),
                                        data.enlargedFrameUrl && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $di5Ky.EnlargedFrameModal), {
                                            enlargedFrameUrl: data.enlargedFrameUrl,
                                            setEnlargedFrameUrl: (val)=>updateEditData(data.edit.id, {
                                                    enlargedFrameUrl: val ?? null
                                                })
                                        }),
                                        data.showMergeDialog && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dasnA.MergeDialogModal), {
                                            unknownAnalyses: data.unknownAnalyses,
                                            selectedPerformers: data.selectedPerformers,
                                            processingAction: data.processingAction,
                                            enlargedFrameUrl: data.enlargedFrameUrl ?? undefined,
                                            mergeName: data.mergeName,
                                            setMergeName: (val)=>updateEditData(data.edit.id, {
                                                    mergeName: val || undefined
                                                }),
                                            setShowMergeDialog: (val)=>updateEditData(data.edit.id, {
                                                    showMergeDialog: val
                                                }),
                                            handleMergePerformers: handleMergePerformers
                                        })
                                    ]
                                }, data.edit.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
});

});
parcelRegister("kbInV", function(module, exports) {

$parcel$export(module.exports, "Alert", () => $eb2743a249662016$export$caec2af78bcc877f);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $eb2743a249662016$var$_extends() {
    return $eb2743a249662016$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eb2743a249662016$var$_extends.apply(null, arguments);
}
var $eb2743a249662016$export$caec2af78bcc877f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $eb2743a249662016$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Alert"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17v2m0-9v6m0-13L2 22h20L12 3z"
    }));
});
$eb2743a249662016$export$caec2af78bcc877f.displayName = 'Alert';

});

parcelRegister("hRbKn", function(module, exports) {

$parcel$export(module.exports, "Checkmark", () => $d0007fa02e9d06b7$export$4f481e0a96cfbed6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");

var $6dmSR = parcelRequire("6dmSR");
function $d0007fa02e9d06b7$var$_extends() {
    return $d0007fa02e9d06b7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d0007fa02e9d06b7$var$_extends.apply(null, arguments);
}
var $d0007fa02e9d06b7$export$4f481e0a96cfbed6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var scaleProps = (0, $6dmSR.useScaleProps)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $d0007fa02e9d06b7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkmark"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $d0007fa02e9d06b7$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 14 7 6L22 4"
    }, scaleProps)));
});
$d0007fa02e9d06b7$export$4f481e0a96cfbed6.displayName = 'Checkmark';

});

parcelRegister("iLsof", function(module, exports) {

$parcel$export(module.exports, "Magic", () => $da92a374423c1b7d$export$480e4c19201e4e74);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $da92a374423c1b7d$var$_extends() {
    return $da92a374423c1b7d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $da92a374423c1b7d$var$_extends.apply(null, arguments);
}
var $da92a374423c1b7d$export$480e4c19201e4e74 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $da92a374423c1b7d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Magic"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2.5 19.5 17-17 2 2-17 17-2-2zm.5.5L15 8l1 1L4 21l-1-1zM5.5 3l-.5.5.5.5.5-.5-.5-.5zm6 0-.5.5.5.5.5-.5-.5-.5zm-3 3-.5.5.5.5.5-.5-.5-.5zm12 6-.5.5.5.5.5-.5-.5-.5zm0 5-.5.5.5.5.5-.5-.5-.5z"
    }));
});
$da92a374423c1b7d$export$480e4c19201e4e74.displayName = 'Magic';

});

parcelRegister("5a3jD", function(module, exports) {

$parcel$export(module.exports, "StatusWarning", () => $3c207555c8922adc$export$a2518b5310db22ab);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $3c207555c8922adc$var$_extends() {
    return $3c207555c8922adc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3c207555c8922adc$var$_extends.apply(null, arguments);
}
var $3c207555c8922adc$export$a2518b5310db22ab = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $3c207555c8922adc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is warning"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 3 10 18H2L12 3zm0 6v6m0 1v2"
    }));
});
$3c207555c8922adc$export$a2518b5310db22ab.displayName = 'StatusWarning';

});

parcelRegister("kjGz8", function(module, exports) {

$parcel$export(module.exports, "Update", () => $eca699a8937a6478$export$489a84f048b0ef8);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $eca699a8937a6478$var$_extends() {
    return $eca699a8937a6478$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eca699a8937a6478$var$_extends.apply(null, arguments);
}
var $eca699a8937a6478$export$489a84f048b0ef8 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $eca699a8937a6478$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Update"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1.75 16.002C3.353 20.098 7.338 23 12 23c6.075 0 11-4.925 11-11m-.75-4.002C20.649 3.901 16.663 1 12 1 5.925 1 1 5.925 1 12m8 4H1v8M23 0v8h-8"
    }));
});
$eca699a8937a6478$export$489a84f048b0ef8.displayName = 'Update';

});

parcelRegister("dmJzY", function(module, exports) {

$parcel$export(module.exports, "ContractedPerformersPanel", () => $f6489f5965fc18b5$export$f7206f511c0d1592);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $7gCPR = parcelRequire("7gCPR");
var $gpKeH = parcelRequire("gpKeH");
var $1fLUh = parcelRequire("1fLUh");
var $jmzyn = parcelRequire("jmzyn");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbInV = parcelRequire("kbInV");
var $hRbKn = parcelRequire("hRbKn");
var $1QpFO = parcelRequire("1QpFO");
var $eLmdC = parcelRequire("eLmdC");

var $4Oriw = parcelRequire("4Oriw");

var $jGT7M = parcelRequire("jGT7M");

var $1faEl = parcelRequire("1faEl");

var $aYiXW = parcelRequire("aYiXW");

var $4wQEk = parcelRequire("4wQEk");
const $f6489f5965fc18b5$export$f7206f511c0d1592 = ({ knownAnalyses: knownAnalyses, editReview: editReview, processingAction: processingAction = null, setEnlargedFrameUrl: setEnlargedFrameUrl, handleOutgrade: handleOutgrade, handleReclassify: handleReclassify, handleMarkInvalid: handleMarkInvalid })=>{
    /** Render **/ const PerformerInfo = ({ contract: contract, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            width: "small",
            align: "center",
            gap: "small",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7gCPR.Carousel), {
                    controls: true,
                    height: "small",
                    width: "small",
                    style: {
                        borderRadius: (0, $4Oriw.borderRadiusSize)
                    },
                    children: contract.characterPhotos?.map((photo, index)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                            src: photo.signedUrl,
                            fit: "cover"
                        }, `${contract.performer.id}_${index}`))
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    children: [
                        contract.performer.last_name,
                        ", ",
                        contract.performer.first_name
                    ]
                })
            ]
        });
    const PerformerFrames = ({ analysis: analysis, frameUrls: frameUrls, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            flex: true,
            style: {
                cursor: 'pointer',
                position: 'relative'
            },
            ...props,
            children: [
                analysis && analysis.frameAppears.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7gCPR.Carousel), {
                    height: "medium",
                    controls: true,
                    style: {
                        borderRadius: (0, $4Oriw.borderRadiusSize)
                    },
                    children: frameUrls?.map((frameUrl)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            onClick: ()=>setEnlargedFrameUrl(frameUrl),
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                                    src: frameUrl
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    margin: "auto",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "xsmall",
                                        children: "\uD83D\uDD0D Click image to enlarge"
                                    })
                                })
                            ]
                        }, frameUrl))
                }),
                (!analysis || analysis.frameAppears.length === 0) && !analysis?.outgraded && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    height: "medium",
                    align: "center",
                    justify: "center",
                    background: {
                        color: 'dark-2'
                    },
                    round: (0, $4Oriw.borderRadiusSize),
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        color: "text-weak",
                        children: "Not detected"
                    })
                })
            ]
        });
    const VerdictCard = ({ children: children, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $ir1aK.Card), {
            round: "none",
            flex: true,
            background: "light-3",
            ...props,
            children: children
        });
    const VerdictCardHeader = ({ analysis: analysis, contract: contract, verdict: verdict, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
            direction: "column",
            background: {
                color: verdict === (0, $aYiXW.Verdict).outgraded ? 'light-3' : verdict === (0, $aYiXW.Verdict).noChange ? 'status-ok' : 'status-warning'
            },
            pad: "small",
            gap: "xsmall",
            align: "start",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    children: [
                        "Hired as: ",
                        contract.role.performer_type
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    weight: "bold",
                    children: [
                        "Analysis result: ",
                        verdict
                    ]
                }),
                analysis?.manuallyClassified && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "xsmall",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eLmdC.StatusGood), {
                            size: "small",
                            color: "brand"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            color: "brand",
                            children: "Manually classified"
                        })
                    ]
                }),
                analysis?.outgraded && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "xsmall",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                            size: "small",
                            color: "status-critical"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            color: "status-critical",
                            weight: "bold",
                            children: "Not in this edit"
                        })
                    ]
                })
            ]
        });
    const VerdictCardBody = ({ children: children, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
            border: [
                {
                    side: 'vertical',
                    size: 'small',
                    color: 'light-4'
                },
                {
                    side: 'bottom',
                    size: 'small',
                    color: 'light-4'
                }
            ],
            ...props,
            children: children
        });
    const OutgradedStatus = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            background: {
                color: 'status-critical'
            },
            pad: "small",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    weight: "bold",
                    color: "white",
                    children: "Outgraded - Not in This Edit"
                }),
                analysis.outgradeReason && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    size: "small",
                    color: "white",
                    children: [
                        "Reason: ",
                        analysis.outgradeReason
                    ]
                }),
                analysis.outgradedAt && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "xsmall",
                    color: "white",
                    children: new Date(analysis.outgradedAt).toLocaleString()
                })
            ]
        });
    const OutgradeButton = ({ analysis: analysis, contract: contract, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {}),
            label: analysis?.outgraded ? 'Undo Outgrade' : 'Not in This Edit',
            onClick: ()=>handleOutgrade(editReview?.edit.id ?? '', contract.performer.id, contract.role.performer_type || (0, $8kKyn.RolePerformerType).Extra, 'Performer did not make the final cut for this edit'),
            disabled: processingAction === contract.performer.id,
            color: analysis?.outgraded ? 'status-ok' : 'status-critical',
            ...props
        });
    const UpgradeToPrincipalButton = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hRbKn.Checkmark), {}),
            label: "Upgrade to Principal",
            onClick: ()=>handleReclassify(editReview?.edit.id || '', analysis.performerId, (0, $8kKyn.RolePerformerType).OnCameraPrincipal, 'Manual upgrade from UI'),
            disabled: processingAction === analysis.performerId,
            ...props
        });
    const DowngradeToExtraButton = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {}),
            label: "Downgrade to Extra",
            onClick: ()=>handleReclassify(editReview?.edit.id || '', analysis.performerId, (0, $8kKyn.RolePerformerType).Extra, 'Manual downgrade from UI'),
            disabled: processingAction === analysis.performerId,
            ...props
        });
    const MarkInvalidButton = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbInV.Alert), {}),
            label: "Mark Invalid",
            onClick: ()=>handleMarkInvalid(editReview?.edit.id || '', analysis.performerId, 'Marked as invalid from UI'),
            disabled: processingAction === analysis.performerId,
            secondary: true,
            ...props
        });
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "column",
        gap: "medium",
        flex: "grow",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                gap: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                        level: 3,
                        margin: "none",
                        children: "Contracted Performers"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                        height: "2px"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                children: knownAnalyses.map(({ contract: contract, analysis: analysis, frameUrls: frameUrls, verdict: verdict })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
                        gap: "small",
                        border: {
                            color: 'light-4',
                            size: 'small'
                        },
                        pad: {
                            horizontal: 'medium',
                            bottom: 'medium',
                            top: 'small'
                        },
                        background: "light-1",
                        elevation: "none",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                                pad: {
                                    vertical: 'xxsmall'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {})
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                                direction: "row",
                                gap: "medium",
                                align: "start",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)(PerformerInfo, {
                                        contract: contract
                                    }),
                                    editReview && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        flex: true,
                                        gap: "medium",
                                        children: [
                                            analysis && analysis.frameAppears.length > 0 || !analysis?.outgraded ? /*#__PURE__*/ (0, $6ir3O.jsx)(PerformerFrames, {
                                                analysis: analysis,
                                                frameUrls: frameUrls
                                            }) : null,
                                            /*#__PURE__*/ (0, $6ir3O.jsxs)(VerdictCard, {
                                                children: [
                                                    /*#__PURE__*/ (0, $6ir3O.jsx)(VerdictCardHeader, {
                                                        analysis: analysis,
                                                        contract: contract,
                                                        verdict: verdict,
                                                        pad: "small"
                                                    }),
                                                    analysis?.outgraded || analysis?.manuallyClassified && analysis.manualClassificationReason || analysis?.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal && (analysis.foreground || analysis.interactsWithProduct || analysis.reactsToNarration || analysis.voice) && /*#__PURE__*/ (0, $6ir3O.jsxs)(VerdictCardBody, {
                                                        gap: "xsmall",
                                                        children: [
                                                            analysis?.outgraded && /*#__PURE__*/ (0, $6ir3O.jsx)(OutgradedStatus, {
                                                                analysis: analysis
                                                            }),
                                                            analysis?.manuallyClassified && analysis.manualClassificationReason && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4wQEk.ManualClassification), {
                                                                analysis: analysis
                                                            }),
                                                            analysis?.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal && (analysis.foreground || analysis.interactsWithProduct || analysis.reactsToNarration || analysis.voice) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1faEl.ClassifiersList), {
                                                                pad: "small",
                                                                analysis: analysis
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                gap: "small",
                                                direction: "row",
                                                children: [
                                                    (!analysis || analysis.outgraded || analysis.frameAppears && analysis.frameAppears.length === 0) && /*#__PURE__*/ (0, $6ir3O.jsx)(OutgradeButton, {
                                                        analysis: analysis,
                                                        contract: contract,
                                                        fill: "horizontal"
                                                    }),
                                                    analysis && !analysis.invalidDetection && !analysis.outgraded && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
                                                        children: [
                                                            analysis.type === (0, $8kKyn.RolePerformerType).Extra && /*#__PURE__*/ (0, $6ir3O.jsx)(UpgradeToPrincipalButton, {
                                                                analysis: analysis
                                                            }),
                                                            analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal && /*#__PURE__*/ (0, $6ir3O.jsx)(DowngradeToExtraButton, {
                                                                analysis: analysis,
                                                                fill: "horizontal"
                                                            }),
                                                            /*#__PURE__*/ (0, $6ir3O.jsx)(MarkInvalidButton, {
                                                                analysis: analysis,
                                                                fill: "horizontal"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, contract.id))
            })
        ]
    });
};

});
parcelRegister("7gCPR", function(module, exports) {

$parcel$export(module.exports, "Carousel", () => $015d8d03f88d4fb3$export$144901db2ea8e967);

var $2NacA = parcelRequire("2NacA");

var $d2fh4 = parcelRequire("d2fh4");

var $2M0UK = parcelRequire("2M0UK");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $czDw5 = parcelRequire("czDw5");

var $ctRHQ = parcelRequire("ctRHQ");

var $bQKU9 = parcelRequire("bQKU9");

var $lHJiC = parcelRequire("lHJiC");

var $eL6w3 = parcelRequire("eL6w3");
var $015d8d03f88d4fb3$var$_excluded = [
    "activeChild",
    "initialChild",
    "onChild",
    "play",
    "children",
    "controls",
    "height",
    "fill",
    "width",
    "onFocus",
    "onBlur",
    "wrap"
];
function $015d8d03f88d4fb3$var$_extends() {
    return $015d8d03f88d4fb3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $015d8d03f88d4fb3$var$_extends.apply(null, arguments);
}
function $015d8d03f88d4fb3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $015d8d03f88d4fb3$export$144901db2ea8e967 = function Carousel(_ref) {
    var activeChild = _ref.activeChild, _ref$initialChild = _ref.initialChild, initialChild = _ref$initialChild === void 0 ? 0 : _ref$initialChild, onChild = _ref.onChild, play = _ref.play, children = _ref.children, _ref$controls = _ref.controls, controls = _ref$controls === void 0 ? true : _ref$controls, height = _ref.height, fill = _ref.fill, width = _ref.width, onFocus = _ref.onFocus, onBlur = _ref.onBlur, wrap = _ref.wrap, rest = $015d8d03f88d4fb3$var$_objectWithoutPropertiesLoose(_ref, $015d8d03f88d4fb3$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var timerRef = (0, $2NacA.useRef)();
    var animationDuration = (0, $2NacA.useMemo)(function() {
        return play && play < theme.carousel.animation.duration ? play : theme.carousel.animation.duration;
    }, [
        play,
        theme.carousel.animation.duration
    ]);
    var _useState = (0, $2NacA.useState)({
        activeIndex: activeChild !== undefined ? activeChild : initialChild
    }), indexes = _useState[0], setIndexes = _useState[1];
    var _useState2 = (0, $2NacA.useState)(activeChild), activeChildState = _useState2[0], setActiveChildState = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(), direction = _useState3[0], setDirection = _useState3[1];
    var _useState4 = (0, $2NacA.useState)(false), inTransition = _useState4[0], setInTransition = _useState4[1];
    var activeIndex = indexes.activeIndex, priorActiveIndex = indexes.priorActiveIndex;
    var lastIndex = (0, $2NacA.Children).count(children) - 1;
    var onChildChange = (0, $2NacA.useCallback)(function(index) {
        if (onChild) onChild(index);
    }, [
        onChild
    ]);
    var onRight = (0, $2NacA.useCallback)(function() {
        if (inTransition) return;
        clearInterval(timerRef.current);
        var nextActiveIndex = activeIndex < lastIndex ? activeIndex + 1 : 0;
        setIndexes({
            activeIndex: nextActiveIndex,
            priorActiveIndex: activeIndex
        });
        setInTransition(true);
        setDirection('left');
        onChildChange(nextActiveIndex);
    }, [
        activeIndex,
        inTransition,
        lastIndex,
        onChildChange
    ]);
    var onLeft = (0, $2NacA.useCallback)(function() {
        if (inTransition) return;
        clearInterval(timerRef.current);
        var nextActiveIndex = activeIndex === 0 ? lastIndex : activeIndex - 1;
        setIndexes({
            activeIndex: nextActiveIndex,
            priorActiveIndex: activeIndex
        });
        setInTransition(true);
        setDirection('right');
        onChildChange(nextActiveIndex);
    }, [
        activeIndex,
        inTransition,
        lastIndex,
        onChildChange
    ]);
    var onSelect = (0, $2NacA.useCallback)(function(index) {
        return function() {
            if (!inTransition && activeIndex !== index) {
                clearInterval(timerRef.current);
                setIndexes({
                    activeIndex: index,
                    priorActiveIndex: activeIndex
                });
                setInTransition(true);
                setDirection(index > activeIndex ? 'left' : 'right');
                onChildChange(index);
            }
        };
    }, [
        activeIndex,
        inTransition,
        onChildChange
    ]);
    var onControlledNavigation = (0, $2NacA.useCallback)(function() {
        if (inTransition || activeChild === activeChildState || activeChild === activeIndex || activeChild === undefined || activeChild < 0 || activeChild > lastIndex) return;
        setDirection(activeChild > activeIndex ? 'left' : 'right');
        setInTransition(true);
        setIndexes({
            activeIndex: activeChild,
            priorActiveIndex: activeIndex
        });
        setActiveChildState(activeChild);
        onChildChange(activeChild);
    }, [
        activeChild,
        activeChildState,
        activeIndex,
        inTransition,
        lastIndex,
        onChildChange
    ]);
    /**
   * Delays the transitions between Carousel slides. This is needed to
   * avoid users "spamming" the controls which results in jarring animations
   * and a bad user experience.
   */ (0, $2NacA.useEffect)(function() {
        var transitionTimer;
        if (inTransition) transitionTimer = setTimeout(function() {
            setInTransition(false);
        }, animationDuration);
        return function() {
            return clearTimeout(transitionTimer);
        };
    }, [
        inTransition,
        setInTransition,
        animationDuration
    ]);
    // Handles auto-playing Carousel slides
    (0, $2NacA.useEffect)(function() {
        // stop playing if wrap is explicitly false and we're at the end
        if (play && (wrap !== false || activeIndex < lastIndex)) {
            var timer = setInterval(function() {
                var nextActiveIndex = activeIndex < lastIndex ? activeIndex + 1 : 0;
                setIndexes({
                    activeIndex: nextActiveIndex,
                    priorActiveIndex: activeIndex
                });
                setInTransition(true);
                setDirection('left');
                onChildChange(nextActiveIndex);
            }, play);
            timerRef.current = timer;
            return function() {
                clearTimeout(timer);
            };
        }
        return function() {};
    }, [
        activeIndex,
        play,
        children,
        lastIndex,
        onChildChange,
        wrap
    ]);
    // Allow Carousel slides to be controlled outside the component
    (0, $2NacA.useEffect)(function() {
        onControlledNavigation(activeIndex, activeChild, activeChildState, inTransition);
    }, [
        onControlledNavigation,
        activeIndex,
        activeChild,
        activeChildState,
        inTransition
    ]);
    var showArrows = controls && controls !== 'selectors';
    var showSelectors = controls && controls !== 'arrows';
    var CurrentIcon = theme.carousel.icons.current;
    var iconColor = (0, $d2fh4.normalizeColor)(theme.carousel.icons.color || 'control', theme);
    var selectors = [];
    var wrappedChildren = (0, $2NacA.Children).map(children, function(child, index) {
        selectors.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
            a11yTitle: format({
                id: 'carousel.jump',
                values: {
                    slide: index + 1
                }
            }),
            key: index,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(CurrentIcon, {
                color: activeIndex === index ? iconColor : undefined
            }),
            onClick: onSelect(index)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bQKU9.CarouselChild), {
            animationDuration: animationDuration,
            fill: fill || !!height || !!width,
            index: index,
            activeIndex: activeIndex,
            priorActiveIndex: priorActiveIndex,
            direction: direction
        }, child);
    });
    var NextIcon = theme.carousel.icons.next;
    var PreviousIcon = theme.carousel.icons.previous;
    var nextIconDisabled = !wrap && activeIndex >= lastIndex;
    var previousIconDisabled = !wrap && activeIndex <= 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onLeft: onLeft,
        onRight: onRight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ctRHQ.StyledCarouselContainer), $015d8d03f88d4fb3$var$_extends({
        fill: fill,
        height: height,
        width: width
    }, rest), showArrows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ctRHQ.StyledControl), {
        offsetProp: "left",
        fill: "vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        fill: "vertical",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(PreviousIcon, {
            color: (0, $d2fh4.normalizeColor)(previousIconDisabled ? theme.carousel.disabled.icons.color : theme.carousel.icons.color, theme)
        }),
        a11yTitle: format({
            id: 'carousel.previous',
            values: {
                slide: activeIndex
            }
        }),
        plain: true,
        disabled: previousIconDisabled,
        onClick: onLeft,
        hoverIndicator: true
    })), wrappedChildren, showSelectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ctRHQ.StyledControl), {
        offsetProp: "bottom",
        fill: "horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        justify: "end",
        fill: !showArrows && 'horizontal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row",
        justify: "center"
    }, selectors))), showArrows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ctRHQ.StyledControl), {
        offsetProp: "right",
        fill: "vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        fill: "vertical",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(NextIcon, {
            color: (0, $d2fh4.normalizeColor)(nextIconDisabled ? theme.carousel.disabled.icons.color : theme.carousel.icons.color, theme)
        }),
        a11yTitle: format({
            id: 'carousel.next',
            values: {
                slide: activeIndex + 2
            }
        }),
        plain: true,
        disabled: nextIconDisabled,
        onClick: onRight,
        hoverIndicator: true
    }))));
};
$015d8d03f88d4fb3$export$144901db2ea8e967.displayName = 'Carousel';
$015d8d03f88d4fb3$export$144901db2ea8e967.propTypes = (0, $lHJiC.CarouselPropTypes);

});
parcelRegister("ctRHQ", function(module, exports) {

$parcel$export(module.exports, "StyledCarouselContainer", () => $9161da5fce59efaf$export$115e625c3f67bf98);
$parcel$export(module.exports, "StyledCarouselChild", () => $9161da5fce59efaf$export$be541686e428c2a6);
$parcel$export(module.exports, "StyledControl", () => $9161da5fce59efaf$export$5c7b7f0e517b89f8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");
var $9161da5fce59efaf$export$115e625c3f67bf98 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledCarousel__StyledCarouselContainer",
    componentId: "sc-c2hjel-0"
})([
    "position:relative;overflow:hidden;"
]);
var $9161da5fce59efaf$var$animationKeyframes = {
    // Slide Right = Previous or Backward
    slideRightPrevious: (0, $f5efw.keyframes)([
        "0%{transform:translateX(0%)}100%{transform:translateX(100%)}"
    ]),
    slideRightCurrent: (0, $f5efw.keyframes)([
        "0%{transform:translateX(-100%)}100%{transform:translateX(0%)}"
    ]),
    // Slide Left = Next or Forward
    slideLeftPrevious: (0, $f5efw.keyframes)([
        "0%{transform:translateX(0%)}100%{transform:translateX(-100%)}"
    ]),
    slideLeftCurrent: (0, $f5efw.keyframes)([
        "0%{transform:translateX(100%)}100%{transform:translateX(0%)}"
    ])
};
var $9161da5fce59efaf$export$be541686e428c2a6 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledCarousel__StyledCarouselChild",
    componentId: "sc-c2hjel-1"
})([
    "visibility:",
    ";position:",
    ";width:100%;height:100%;overflow:hidden;",
    ";animation-fill-mode:both;"
], function(props) {
    return props.visibilityProp;
}, function(props) {
    return props.positionProp;
}, function(props) {
    return props.animationType ? (0, $f5efw.css)([
        "animation:",
        " ",
        "s ease-in-out;"
    ], $9161da5fce59efaf$var$animationKeyframes[props.animationType], props.animationDuration / 1000) : "";
});
var $9161da5fce59efaf$export$5c7b7f0e517b89f8 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledCarousel__StyledControl",
    componentId: "sc-c2hjel-2"
})([
    "position:absolute;z-index:1;",
    " align-items:center;justify-content:center;"
], function(props) {
    return props.offsetProp + ": 0;";
});

});

parcelRegister("bQKU9", function(module, exports) {

$parcel$export(module.exports, "CarouselChild", () => $8a08ef4e1b7bf9b6$export$b27165ff157668ed);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $lHJiC = parcelRequire("lHJiC");

var $ctRHQ = parcelRequire("ctRHQ");

var $5xcHk = parcelRequire("5xcHk");
var $8a08ef4e1b7bf9b6$export$b27165ff157668ed = function CarouselChild(_ref) {
    var animationDuration = _ref.animationDuration, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? false : _ref$fill, index = _ref.index, activeIndex = _ref.activeIndex, priorActiveIndex = _ref.priorActiveIndex, direction = _ref.direction, children = _ref.children;
    var _useState = (0, $2NacA.useState)(undefined), animation = _useState[0], setAnimation = _useState[1];
    var _useState2 = (0, $2NacA.useState)(index === activeIndex ? 'visible' : 'hidden'), visibility = _useState2[0], setVisibility = _useState2[1];
    (0, $2NacA.useEffect)(function() {
        var timer;
        if (index === activeIndex) {
            if (priorActiveIndex !== undefined) /**
         * This check will only be false onMount of the component. It ensures
         * the initial active slide of the Carousel renders with no animation.
         */ setAnimation(direction === 'left' ? 'slideLeftCurrent' : 'slideRightCurrent');
            setVisibility('visible');
        } else if (index === priorActiveIndex) {
            setAnimation(direction === 'left' ? 'slideLeftPrevious' : 'slideRightPrevious');
            timer = setTimeout(function() {
                return setVisibility('hidden');
            }, animationDuration);
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        activeIndex,
        priorActiveIndex,
        index,
        direction,
        animationDuration
    ]);
    var position = index === 0 ? 'relative' : 'absolute';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $ctRHQ.StyledCarouselChild), {
        fill: fill,
        visibilityProp: visibility,
        positionProp: position,
        animationType: animation,
        animationDuration: animationDuration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        fill: fill
    }, children));
};
$8a08ef4e1b7bf9b6$export$b27165ff157668ed.propTypes = (0, $lHJiC.CarouselChildPropTypes);

});
parcelRegister("lHJiC", function(module, exports) {

$parcel$export(module.exports, "CarouselPropTypes", () => $fcd0c09fea03d3e3$export$4a1671f1b9579d0f);
$parcel$export(module.exports, "CarouselChildPropTypes", () => $fcd0c09fea03d3e3$export$311ded8387e5ce78);


function $fcd0c09fea03d3e3$var$_extends() {
    return $fcd0c09fea03d3e3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fcd0c09fea03d3e3$var$_extends.apply(null, arguments);
}
var $fcd0c09fea03d3e3$var$CarouselPropType;
var $fcd0c09fea03d3e3$export$4a1671f1b9579d0f = $fcd0c09fea03d3e3$var$CarouselPropType;
var $fcd0c09fea03d3e3$var$CarouselChildPropType;
var $fcd0c09fea03d3e3$export$311ded8387e5ce78 = $fcd0c09fea03d3e3$var$CarouselChildPropType;

});



parcelRegister("1faEl", function(module, exports) {

$parcel$export(module.exports, "ClassifiersList", () => $97a09b7f2d044c29$export$88830eeb9e641a94);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
const $97a09b7f2d044c29$export$88830eeb9e641a94 = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gap: "xsmall",
        ...props,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                weight: "bold",
                children: "Classifiers Detected:"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)("ul", {
                style: {
                    margin: '4px 0'
                },
                children: [
                    analysis.foreground && /*#__PURE__*/ (0, $6ir3O.jsxs)("li", {
                        children: [
                            "Foreground (",
                            analysis.foregroundFrameCount || 0,
                            " frames)"
                        ]
                    }),
                    analysis.interactsWithProduct && /*#__PURE__*/ (0, $6ir3O.jsx)("li", {
                        children: "Interacts with Product"
                    }),
                    analysis.reactsToNarration && /*#__PURE__*/ (0, $6ir3O.jsx)("li", {
                        children: "Reacts to Narration"
                    }),
                    analysis.voice && /*#__PURE__*/ (0, $6ir3O.jsx)("li", {
                        children: "Speaks"
                    })
                ]
            })
        ]
    });

});

parcelRegister("aYiXW", function(module, exports) {

$parcel$export(module.exports, "Verdict", () => $d9ab1c152a1476d6$export$ee90b0e4f96607b2);
$parcel$export(module.exports, "EditReviewModal", () => $d9ab1c152a1476d6$export$1f9f6a616ef399fc);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $emlIu = parcelRequire("emlIu");
var $8kKyn = parcelRequire("8kKyn");

var $a26J5 = parcelRequire("a26J5");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $5erKi = parcelRequire("5erKi");

var $iLsof = parcelRequire("iLsof");
var $kjGz8 = parcelRequire("kjGz8");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $8DltC = parcelRequire("8DltC");

var $4mDQA = parcelRequire("4mDQA");

var $az33k = parcelRequire("az33k");

var $dmJzY = parcelRequire("dmJzY");

var $di5Ky = parcelRequire("di5Ky");

var $dasnA = parcelRequire("dasnA");

var $iBocF = parcelRequire("iBocF");
var $d9ab1c152a1476d6$export$ee90b0e4f96607b2 = /*#__PURE__*/ function(Verdict) {
    Verdict["upgrade"] = "Upgrade";
    Verdict["downgrade"] = "Downgrade";
    Verdict["noChange"] = "No Change";
    Verdict["outgraded"] = "Manually Outgraded";
    return Verdict;
}({});
const $d9ab1c152a1476d6$export$1f9f6a616ef399fc = (0, $j8yBr.observer)(({ commercial: commercial, edit: edit, setShowEditReviewModal: setShowEditReviewModal })=>{
    /** Context **/ const commercialStore = (0, $8DltC.useCommercialStore)();
    const performerStore = (0, $8DltC.usePerformerStore)();
    /** State **/ const [knownAnalyses, setKnownAnalyses] = (0, $2NacA.useState)([]);
    const [unknownAnalyses, setUnknownAnalyses] = (0, $2NacA.useState)([]);
    const [contracts, setContracts] = (0, $2NacA.useState)([]);
    const [editReview, setEditReview] = (0, $2NacA.useState)();
    const [loading, setLoading] = (0, $2NacA.useState)(false);
    const [processingAction, setProcessingAction] = (0, $2NacA.useState)(null);
    const [selectedPerformers, setSelectedPerformers] = (0, $2NacA.useState)(new Set());
    const [showMergeDialog, setShowMergeDialog] = (0, $2NacA.useState)(false);
    const [mergeName, setMergeName] = (0, $2NacA.useState)('');
    const [enlargedFrameUrl, setEnlargedFrameUrl] = (0, $2NacA.useState)('');
    /** Methods **/ const createEditReview = async ()=>{
        if (edit) {
            setLoading(true);
            const response = await commercialStore.createEditReview(edit.id);
            if (response) setEditReview(response.editReview);
            setLoading(false);
        }
    };
    const handleReclassify = async (editId, performerId, newType, reason)=>{
        if (!editId && !edit.id) return;
        setProcessingAction(performerId);
        try {
            const response = await (0, $emlIu.EditReviewService).reclassifyPerformer(editId || edit.id, {
                performerId: performerId,
                newType: newType,
                reason: reason
            });
            if (response?.editReview) {
                setEditReview(response.editReview);
                (0, $bsB3E.toast).success(`Successfully reclassified performer as ${newType}`);
            }
        } catch (error) {
            console.error('Error reclassifying performer:', error);
            (0, $bsB3E.toast).error('Failed to reclassify performer');
        } finally{
            setProcessingAction(null);
        }
    };
    const handleMarkInvalid = async (editId, performerId, reason)=>{
        if (!editId && !edit.id) return;
        setProcessingAction(performerId);
        try {
            const response = await (0, $emlIu.EditReviewService).markPerformerInvalid(editId || edit.id, {
                performerId: performerId,
                reason: reason
            });
            if (response?.editReview) {
                setEditReview(response.editReview);
                (0, $bsB3E.toast).success('Successfully marked as invalid detection');
            }
        } catch (error) {
            console.error('Error marking performer invalid:', error);
            (0, $bsB3E.toast).error('Failed to mark as invalid');
        } finally{
            setProcessingAction(null);
        }
    };
    const handleOutgrade = async (editId, performerId, contractedType, reason)=>{
        if (!editId && !edit.id) return;
        setProcessingAction(performerId);
        try {
            const response = await (0, $emlIu.EditReviewService).outgradePerformer(editId || edit.id, {
                performerId: performerId,
                contractedType: contractedType,
                reason: reason
            });
            if (response?.editReview) {
                setEditReview(response.editReview);
                const analysis = response.editReview.analyses?.find((a)=>a.performerId === performerId);
                (0, $bsB3E.toast).success(analysis?.outgraded ? 'Performer outgraded - not in this edit' : 'Outgrade removed');
            }
        } catch (error) {
            console.error('Error outgrading performer:', error);
            (0, $bsB3E.toast).error('Failed to outgrade performer');
        } finally{
            setProcessingAction(null);
        }
    };
    const togglePerformerSelection = (performerId)=>{
        const newSelection = new Set(selectedPerformers);
        if (newSelection.has(performerId)) newSelection.delete(performerId);
        else newSelection.add(performerId);
        setSelectedPerformers(newSelection);
    };
    const handleMergePerformers = async (editId)=>{
        if (!editId && !edit.id || selectedPerformers.size < 2) return;
        setProcessingAction('merge');
        try {
            const response = await (0, $emlIu.EditReviewService).mergePerformers(editId || edit.id, {
                performerIds: Array.from(selectedPerformers),
                newName: mergeName || undefined
            });
            if (response?.editReview) {
                setEditReview(response.editReview);
                setSelectedPerformers(new Set());
                setShowMergeDialog(false);
                setMergeName('');
                (0, $bsB3E.toast).success(`Successfully merged ${selectedPerformers.size} performers`);
            }
        } catch (error) {
            console.error('Error merging performers:', error);
            (0, $bsB3E.toast).error('Failed to merge performers');
        } finally{
            setProcessingAction(null);
        }
    };
    const handleIdentifyPerformer = async (unknownPerformerId, contractedPerformerId)=>{
        if (!edit.id) return;
        setProcessingAction(unknownPerformerId);
        try {
            const response = await (0, $emlIu.EditReviewService).identifyPerformer(edit.id, {
                unknownPerformerId: unknownPerformerId,
                contractedPerformerId: contractedPerformerId
            });
            if (response?.editReview) {
                setEditReview(response.editReview);
                (0, $bsB3E.toast).success('Successfully identified performer');
            }
        } catch (error) {
            console.error('Error identifying performer:', error);
            (0, $bsB3E.toast).error('Failed to identify performer');
        } finally{
            setProcessingAction(null);
        }
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const loadData = async ()=>{
            if (commercial && edit) {
                setLoading(true);
                const c = await performerStore.listPerformerContracts({
                    commercialId: commercial.id,
                    relations: 'performer,role'
                });
                const e = await commercialStore.getEditReviewByEditId(edit.id);
                if (!c) {
                    (0, $bsB3E.toast).error('Failed to load contracts');
                    setLoading(false);
                    return;
                } else setContracts(c);
                if (!e?.editReview) {
                    // toast.error('Failed to load edit review');
                    // fail silently in case this edit review wasn't generated yet
                    setLoading(false);
                    return;
                } else setEditReview(e.editReview);
            }
            setLoading(false);
        };
        loadData();
    }, [
        commercial,
        edit,
        setShowEditReviewModal
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (contracts.length > 0 && editReview) {
            const knownPerformerIds = new Set(contracts.map((c)=>c.performer.id));
            // Filter analyses into known (contracted) and unknown performers
            const known = contracts.map((contract)=>{
                const analysis = editReview.analyses?.find((a)=>a.performerId === contract.performer.id);
                // Check if performer is outgraded
                if (analysis?.outgraded) return {
                    contract: contract,
                    analysis: analysis,
                    frameUrls: [],
                    verdict: "Manually Outgraded"
                };
                // the performer's face wasn't detected in the analysis (or was outgraded with no actual detections)
                if (!analysis || analysis.frameAppears.length === 0) {
                    if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).Extra) return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: [],
                        verdict: "No Change"
                    };
                    else if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: [],
                        verdict: "Downgrade"
                    };
                    else {
                        console.log('Unexpected performer type:', contract.role.performer_type);
                        return {
                            contract: contract,
                            analysis: analysis,
                            frameUrls: [],
                            verdict: "No Change"
                        };
                    }
                }
                // the performer's face was detected in the analysis
                // Get frames for the analysis
                const frameUrls = editReview.framePaths?.filter((imageLocation)=>analysis.frameAppears.some((frameIndex)=>imageLocation.fileName.includes(`${String(frameIndex).padStart(4, '0')}.jpg`))).map((imageLocation)=>imageLocation.signedUrl);
                // Determine the verdict based on the analysis type
                if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).Extra) {
                    if (analysis.type === (0, $8kKyn.RolePerformerType).Extra) return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: frameUrls,
                        verdict: "No Change"
                    };
                    else if (analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: frameUrls,
                        verdict: "Upgrade"
                    };
                    else {
                        console.log('Unexpected analysis type for EXTRA performer:', analysis.type);
                        return {
                            contract: contract,
                            analysis: analysis,
                            frameUrls: frameUrls,
                            verdict: "No Change"
                        };
                    }
                } else if (contract.role.performer_type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) {
                    if (analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal) return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: frameUrls,
                        verdict: "No Change"
                    };
                    else if (analysis.type === (0, $8kKyn.RolePerformerType).Extra) return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: frameUrls,
                        verdict: "Downgrade"
                    };
                    else {
                        console.log('Unexpected analysis type for ON_CAMERA_PRINCIPAL performer:', analysis.type);
                        return {
                            contract: contract,
                            analysis: analysis,
                            frameUrls: frameUrls,
                            verdict: "No Change"
                        };
                    }
                } else {
                    console.log('Unexpected performer type:', contract.role.performer_type);
                    return {
                        contract: contract,
                        analysis: analysis,
                        frameUrls: frameUrls,
                        verdict: "No Change"
                    };
                }
            });
            // Find unknown performers (not in contracts) - include invalid ones to show them grayed out
            const unknown = (editReview.analyses || []).filter((analysis)=>!knownPerformerIds.has(analysis.performerId)).map((analysis)=>{
                const frameUrls = editReview.framePaths?.filter((imageLocation)=>analysis.frameAppears.some((frameIndex)=>imageLocation.fileName.includes(`${String(frameIndex).padStart(4, '0')}.jpg`))).map((imageLocation)=>imageLocation.signedUrl);
                return {
                    analysis: analysis,
                    frameUrls: frameUrls
                };
            });
            setKnownAnalyses(known);
            setUnknownAnalyses(unknown);
        }
    }, [
        contracts,
        editReview
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5erKi.Layer), {
        onEsc: ()=>setShowEditReviewModal(false),
        onClickOutside: ()=>setShowEditReviewModal(false),
        position: "center",
        modal: true,
        background: "transparent",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $az33k.ModalCard), {
                onClose: ()=>setShowEditReviewModal(false),
                title: "Edit Review",
                noLayerComponent: true,
                cardProps: {
                    width: '845px'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                        justify: "end",
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            icon: editReview ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kjGz8.Update), {
                                size: "20px"
                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iLsof.Magic), {
                                size: "20px"
                            }),
                            hoverIndicator: true,
                            label: editReview ? 'Rerun AI Edit Review' : 'Start AI Edit Review',
                            onClick: ()=>createEditReview(),
                            primary: !editReview,
                            secondary: !!editReview
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                        gap: "large",
                        children: [
                            loading && !editReview && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4mDQA.Loader), {}),
                            knownAnalyses.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmJzY.ContractedPerformersPanel), {
                                knownAnalyses: knownAnalyses,
                                editReview: editReview,
                                processingAction: processingAction,
                                setEnlargedFrameUrl: setEnlargedFrameUrl,
                                handleOutgrade: handleOutgrade,
                                handleReclassify: handleReclassify,
                                handleMarkInvalid: handleMarkInvalid
                            }),
                            unknownAnalyses.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iBocF.UnknownPerformersPanel), {
                                unknownAnalyses: unknownAnalyses,
                                contracts: contracts,
                                selectedPerformers: selectedPerformers,
                                processingAction: processingAction,
                                setEnlargedFrameUrl: setEnlargedFrameUrl,
                                setShowMergeDialog: setShowMergeDialog,
                                togglePerformerSelection: togglePerformerSelection,
                                handleIdentifyPerformer: handleIdentifyPerformer,
                                handleReclassify: handleReclassify,
                                handleMarkInvalid: handleMarkInvalid
                            })
                        ]
                    })
                ]
            }),
            enlargedFrameUrl && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $di5Ky.EnlargedFrameModal), {
                enlargedFrameUrl: enlargedFrameUrl,
                setEnlargedFrameUrl: setEnlargedFrameUrl
            }),
            showMergeDialog && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dasnA.MergeDialogModal), {
                unknownAnalyses: unknownAnalyses,
                selectedPerformers: selectedPerformers,
                processingAction: processingAction,
                enlargedFrameUrl: enlargedFrameUrl,
                mergeName: mergeName,
                setMergeName: setMergeName,
                setShowMergeDialog: setShowMergeDialog,
                handleMergePerformers: handleMergePerformers
            })
        ]
    });
});

});
parcelRegister("4mDQA", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $e665fadf0a1b8f13$export$3b0d6d7590275603);

var $6ir3O = parcelRequire("6ir3O");

var $5erKi = parcelRequire("5erKi");
var $kqZxg = parcelRequire("kqZxg");
const $e665fadf0a1b8f13$export$3b0d6d7590275603 = ({ target: target })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        background: "light-1",
        target: target || undefined,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
            size: "large",
            background: "light-1"
        })
    });
};

});

parcelRegister("di5Ky", function(module, exports) {

$parcel$export(module.exports, "EnlargedFrameModal", () => $fb8f63cd06bf3f06$export$569afe0c72a918af);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $jmzyn = parcelRequire("jmzyn");
var $5erKi = parcelRequire("5erKi");
const $fb8f63cd06bf3f06$export$569afe0c72a918af = ({ enlargedFrameUrl: enlargedFrameUrl, setEnlargedFrameUrl: setEnlargedFrameUrl })=>{
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setEnlargedFrameUrl(''),
        onClickOutside: ()=>setEnlargedFrameUrl(''),
        position: "center",
        modal: true,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
            pad: "small",
            style: {
                maxHeight: '90vh',
                maxWidth: '90vw'
            },
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    width: "xlarge",
                    style: {
                        maxHeight: 'calc(90vh - 80px)'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                        src: enlargedFrameUrl,
                        fit: "contain",
                        style: {
                            maxHeight: 'calc(90vh - 80px)'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    justify: "end",
                    margin: {
                        top: 'small'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        label: "Close",
                        onClick: ()=>setEnlargedFrameUrl(''),
                        size: "small"
                    })
                })
            ]
        })
    });
};

});

parcelRegister("dasnA", function(module, exports) {

$parcel$export(module.exports, "MergeDialogModal", () => $fca3c9d1e440e5e2$export$b76ded819f84bb05);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $1fLUh = parcelRequire("1fLUh");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("ibR9R");
var $bIzid = parcelRequire("bIzid");
const $fca3c9d1e440e5e2$export$b76ded819f84bb05 = ({ unknownAnalyses: unknownAnalyses, selectedPerformers: selectedPerformers, processingAction: processingAction, mergeName: mergeName, setMergeName: setMergeName, setShowMergeDialog: setShowMergeDialog, handleMergePerformers: handleMergePerformers })=>{
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowMergeDialog(false),
        onClickOutside: ()=>setShowMergeDialog(false),
        position: "center",
        modal: true,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
            pad: "medium",
            gap: "small",
            width: "medium",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                    level: 3,
                    margin: "none",
                    children: "Merge Selected Performers"
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    children: [
                        "You are about to merge ",
                        selectedPerformers.size,
                        " performers into one. This will combine all their frame appearances and detected features."
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    margin: {
                        top: 'small'
                    },
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            weight: "bold",
                            children: "Performers to merge:"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)("ul", {
                            children: Array.from(selectedPerformers).map((id)=>{
                                const analysis = unknownAnalyses.find((a)=>a.analysis.performerId === id)?.analysis;
                                return /*#__PURE__*/ (0, $6ir3O.jsxs)("li", {
                                    children: [
                                        analysis?.performerName || id,
                                        " (",
                                        analysis?.frameAppears.length || 0,
                                        " frames)"
                                    ]
                                }, id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                    label: "Optional: Give merged performer a name",
                    placeholder: "e.g., 'Background Extra 1'",
                    val: mergeName || '',
                    onChange: (val)=>setMergeName(val)
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    justify: "end",
                    margin: {
                        top: 'small'
                    },
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Cancel",
                            onClick: ()=>setShowMergeDialog(false)
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            label: "Merge Performers",
                            onClick: ()=>handleMergePerformers(),
                            primary: true,
                            disabled: processingAction === 'merge'
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("iBocF", function(module, exports) {

$parcel$export(module.exports, "UnknownPerformersPanel", () => $360ae7c52e7e8f93$export$c409f6d1431baae7);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $7gCPR = parcelRequire("7gCPR");
var $gpKeH = parcelRequire("gpKeH");
var $8Ao5G = parcelRequire("8Ao5G");
var $1fLUh = parcelRequire("1fLUh");
var $jmzyn = parcelRequire("jmzyn");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbInV = parcelRequire("kbInV");
var $hRbKn = parcelRequire("hRbKn");
var $1QpFO = parcelRequire("1QpFO");
var $eLmdC = parcelRequire("eLmdC");

var $4Oriw = parcelRequire("4Oriw");

var $jGT7M = parcelRequire("jGT7M");

var $1faEl = parcelRequire("1faEl");

var $4wQEk = parcelRequire("4wQEk");
const $360ae7c52e7e8f93$export$c409f6d1431baae7 = ({ unknownAnalyses: unknownAnalyses, editReview: editReview, contracts: contracts, selectedPerformers: selectedPerformers, processingAction: processingAction = null, setEnlargedFrameUrl: setEnlargedFrameUrl, togglePerformerSelection: togglePerformerSelection, handleIdentifyPerformer: handleIdentifyPerformer, handleReclassify: handleReclassify, handleMarkInvalid: handleMarkInvalid })=>{
    /** Render **/ const PerformerInfo = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            align: "center",
            gap: "small",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    height: "small",
                    width: "small",
                    background: {
                        color: 'light-3'
                    },
                    align: "center",
                    border: {
                        size: 'small',
                        color: 'light-4',
                        style: 'dashed'
                    },
                    justify: "center",
                    round: (0, $4Oriw.borderRadiusSize),
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        color: "text-weak",
                        children: "No Photo"
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    gap: "xsmall",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            truncate: true,
                            weight: "bold",
                            children: analysis.performerName || analysis.performerId
                        }),
                        analysis.mergedFrom && analysis.mergedFrom.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            size: "xsmall",
                            color: "text-weak",
                            children: [
                                "Merged from: ",
                                analysis.mergedFrom.join(', ')
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            size: "small",
                            children: [
                                "(",
                                analysis.frameAppears.length,
                                " frames)"
                            ]
                        }),
                        analysis.invalidDetection && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            color: "status-critical",
                            weight: "bold",
                            children: "INVALID"
                        })
                    ]
                })
            ]
        });
    const PerformerFrames = ({ frameUrls: frameUrls, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            height: "medium",
            flex: true,
            style: {
                cursor: 'pointer',
                position: 'relative'
            },
            gap: "xsmall",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7gCPR.Carousel), {
                    controls: true,
                    style: {
                        borderRadius: (0, $4Oriw.borderRadiusSize)
                    },
                    children: frameUrls?.map((frameUrl)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            onClick: ()=>setEnlargedFrameUrl(frameUrl),
                            style: {
                                position: 'relative'
                            },
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                                src: frameUrl
                            })
                        }, frameUrl))
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    alignSelf: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        children: "\uD83D\uDD0D Click image to enlarge"
                    })
                })
            ]
        });
    const AnalysisCard = ({ children: children, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $ir1aK.Card), {
            round: "none",
            elevation: "none",
            flex: true,
            background: "light-3",
            ...props,
            children: children
        });
    const AnalysisCardHeader = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
            background: {
                color: analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal ? 'status-warning' : 'status-ok'
            },
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    weight: "bold",
                    children: [
                        "Classification: ",
                        analysis.type
                    ]
                }),
                analysis.manuallyClassified && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "xsmall",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eLmdC.StatusGood), {
                            size: "small",
                            color: "text"
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            color: "text",
                            weight: 500,
                            children: "Manually classified"
                        })
                    ]
                })
            ]
        });
    const AnalysisCardBody = ({ children: children, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
            border: [
                {
                    side: 'vertical',
                    size: 'small',
                    color: 'light-4'
                },
                {
                    side: 'bottom',
                    size: 'small',
                    color: 'light-4'
                }
            ],
            ...props,
            children: children
        });
    const InvalidDetection = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            background: {
                color: 'status-critical'
            },
            pad: "small",
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    weight: "bold",
                    color: "white",
                    children: "Marked as Invalid Detection"
                }),
                analysis.invalidReason && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    size: "small",
                    color: "white",
                    children: [
                        "Reason: ",
                        analysis.invalidReason
                    ]
                }),
                analysis.markedInvalidAt && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "xsmall",
                    color: "white",
                    children: new Date(analysis.markedInvalidAt).toLocaleString()
                })
            ]
        });
    const IdentifyAsDropdown = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
            label: "Identify As Contracted Performer:",
            margin: "none",
            ...props,
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                size: "small",
                placeholder: "Select performer...",
                options: contracts.map((c)=>({
                        label: `${c.performer.first_name} ${c.performer.last_name} (${c.role.performer_type})`,
                        value: c.performer.id,
                        contract: c
                    })),
                labelKey: "label",
                valueKey: "value",
                onChange: ({ option: option })=>handleIdentifyPerformer(editReview?.edit.id || '', analysis.performerId, option.value),
                disabled: processingAction === analysis.performerId,
                children: (option)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        align: "center",
                        pad: "xsmall",
                        children: [
                            option.contract?.characterPhotos?.[0]?.signedUrl ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "40px",
                                height: "40px",
                                flex: false,
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmzyn.Image), {
                                    src: option.contract.characterPhotos[0].signedUrl,
                                    fit: "cover",
                                    style: {
                                        borderRadius: '4px'
                                    }
                                })
                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "40px",
                                height: "40px",
                                background: "light-3",
                                align: "center",
                                justify: "center",
                                style: {
                                    borderRadius: '4px'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    color: "text-weak",
                                    children: "No Photo"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: option.label
                            })
                        ]
                    })
            })
        });
    const IdentifiedAsInfo = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            background: {
                color: 'status-ok'
            },
            ...props,
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    weight: "bold",
                    color: "white",
                    children: "Identified As Contracted Performer"
                }),
                analysis.identifiedBy && analysis.identifiedAt && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                    size: "xsmall",
                    color: "white",
                    children: [
                        "By: ",
                        analysis.identifiedBy,
                        " on ",
                        new Date(analysis.identifiedAt).toLocaleString()
                    ]
                })
            ]
        });
    const UpgradeToPrincipalButton = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hRbKn.Checkmark), {}),
            label: "Upgrade to Principal",
            onClick: ()=>handleReclassify(editReview?.edit.id || '', analysis.performerId, (0, $8kKyn.RolePerformerType).OnCameraPrincipal, 'Manual upgrade from UI'),
            disabled: processingAction === analysis.performerId,
            ...props
        });
    const DowngradeToExtraButton = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {}),
            label: "Downgrade to Extra",
            onClick: ()=>handleReclassify(editReview?.edit.id || '', analysis.performerId, (0, $8kKyn.RolePerformerType).Extra, 'Manual downgrade from UI'),
            disabled: processingAction === analysis.performerId,
            ...props
        });
    const MarkInvalidButton = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            size: "small",
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbInV.Alert), {}),
            label: "Mark Invalid",
            onClick: ()=>handleMarkInvalid(editReview?.edit.id || '', analysis.performerId, 'False positive - not a face'),
            disabled: processingAction === analysis.performerId,
            secondary: true,
            ...props
        });
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "column",
        flex: "grow",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                gap: "small",
                margin: {
                    bottom: 'medium'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                                level: 3,
                                margin: "none",
                                children: "Unknown Performers"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                color: "text-weak",
                                children: "These performers were detected but don't match any contracted performers."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                        height: "2px"
                    })
                ]
            }),
            unknownAnalyses.map(({ analysis: analysis, frameUrls: frameUrls })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
                    gap: "small",
                    border: {
                        color: analysis.invalidDetection ? 'status-critical' : selectedPerformers.has(analysis.performerId) ? 'brand' : 'light-4',
                        size: 'small'
                    },
                    pad: {
                        horizontal: 'medium',
                        bottom: 'medium',
                        top: 'small'
                    },
                    margin: {
                        bottom: 'medium'
                    },
                    background: {
                        color: analysis.invalidDetection ? 'light-2' : selectedPerformers.has(analysis.performerId) ? 'light-3' : 'light-1'
                    },
                    style: {
                        opacity: analysis.invalidDetection ? 0.6 : 1
                    },
                    elevation: "none",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                            pad: {
                                vertical: 'xxsmall'
                            },
                            children: !analysis.invalidDetection && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                checked: selectedPerformers.has(analysis.performerId),
                                onChange: ()=>togglePerformerSelection(editReview?.edit.id || '', analysis.performerId)
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                            direction: "row",
                            gap: "medium",
                            align: "start",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)(PerformerInfo, {
                                    analysis: analysis
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    flex: true,
                                    gap: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)(PerformerFrames, {
                                            frameUrls: frameUrls
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            flex: true,
                                            gap: "medium",
                                            margin: {
                                                top: 'xsmall'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsxs)(AnalysisCard, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $6ir3O.jsx)(AnalysisCardHeader, {
                                                            analysis: analysis,
                                                            pad: "small"
                                                        }),
                                                        /*#__PURE__*/ (0, $6ir3O.jsxs)(AnalysisCardBody, {
                                                            pad: "small",
                                                            gap: "xsmall",
                                                            children: [
                                                                analysis.invalidDetection && /*#__PURE__*/ (0, $6ir3O.jsx)(InvalidDetection, {
                                                                    analysis: analysis
                                                                }),
                                                                !analysis.invalidDetection && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                                    gap: "small",
                                                                    children: [
                                                                        analysis.manuallyClassified && analysis.manualClassificationReason && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4wQEk.ManualClassification), {
                                                                            analysis: analysis
                                                                        }),
                                                                        analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal && (analysis.foreground || analysis.interactsWithProduct || analysis.reactsToNarration || analysis.voice) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1faEl.ClassifiersList), {
                                                                            analysis: analysis
                                                                        }),
                                                                        !analysis.identifiedAs && /*#__PURE__*/ (0, $6ir3O.jsx)(IdentifyAsDropdown, {
                                                                            analysis: analysis
                                                                        }),
                                                                        analysis.identifiedAs && /*#__PURE__*/ (0, $6ir3O.jsx)(IdentifiedAsInfo, {
                                                                            analysis: analysis
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                    gap: "small",
                                                    direction: "row",
                                                    justify: "between",
                                                    children: [
                                                        analysis.type === (0, $8kKyn.RolePerformerType).Extra && /*#__PURE__*/ (0, $6ir3O.jsx)(UpgradeToPrincipalButton, {
                                                            analysis: analysis,
                                                            fill: "horizontal"
                                                        }),
                                                        analysis.type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal && /*#__PURE__*/ (0, $6ir3O.jsx)(DowngradeToExtraButton, {
                                                            analysis: analysis,
                                                            fill: "horizontal"
                                                        }),
                                                        /*#__PURE__*/ (0, $6ir3O.jsx)(MarkInvalidButton, {
                                                            analysis: analysis,
                                                            fill: "horizontal"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, analysis.performerId))
        ]
    });
};

});
parcelRegister("8Ao5G", function(module, exports) {

$parcel$export(module.exports, "FormField", () => $64045f6ad477bf50$export$56e87bf42978147a);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");
var $cDMMY = parcelRequire("cDMMY");
var $d2fh4 = parcelRequire("d2fh4");
var $3ZGpZ = parcelRequire("3ZGpZ");

var $PvRN2 = parcelRequire("PvRN2");

var $2O6LY = parcelRequire("2O6LY");

var $fzxBh = parcelRequire("fzxBh");

var $dOlbm = parcelRequire("dOlbm");

var $5xcHk = parcelRequire("5xcHk");

var $gpKeH = parcelRequire("gpKeH");

var $gJnoN = parcelRequire("gJnoN");

var $6flum = parcelRequire("6flum");

var $kS7Ii = parcelRequire("kS7Ii");

var $kQZ06 = parcelRequire("kQZ06");

var $7wKkw = parcelRequire("7wKkw");

var $bYy35 = parcelRequire("bYy35");

var $eL6w3 = parcelRequire("eL6w3");

var $7oNsG = parcelRequire("7oNsG");
var $64045f6ad477bf50$var$_excluded = [
    "message",
    "id"
], $64045f6ad477bf50$var$_excluded2 = [
    "error",
    "info",
    "message",
    "type"
], $64045f6ad477bf50$var$_excluded3 = [
    "id"
], $64045f6ad477bf50$var$_excluded4 = [
    "component",
    "disabled",
    "invalid",
    "name",
    "onChange"
], $64045f6ad477bf50$var$_excluded5 = [
    "children",
    "className",
    "component",
    "contentProps",
    "disabled",
    "error",
    "help",
    "htmlFor",
    "info",
    "label",
    "margin",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "pad",
    "required",
    "style",
    "validate",
    "validateOn"
], $64045f6ad477bf50$var$_excluded6 = [
    "aria-describedby"
];
function $64045f6ad477bf50$var$_extends() {
    return $64045f6ad477bf50$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $64045f6ad477bf50$var$_extends.apply(null, arguments);
}
function $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $64045f6ad477bf50$var$grommetInputFocusNames = [
    'CheckBox',
    'CheckBoxGroup',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector',
    'StarRating',
    'ThumbsRating'
];
var $64045f6ad477bf50$var$grommetInputNames = [
    'CheckBox',
    'CheckBoxGroup',
    'TextInput',
    'Select',
    'MaskedInput',
    'SelectMultiple',
    'TextArea',
    'DateInput',
    'DateTimeInput',
    'TimeInput',
    'FileInput',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector',
    'StarRating',
    'ThumbsRating'
];
var $64045f6ad477bf50$var$grommetInputPadNames = [
    'CheckBox',
    'CheckBoxGroup',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector'
];
var $64045f6ad477bf50$var$isGrommetInput = function isGrommetInput(comp) {
    return comp && ($64045f6ad477bf50$var$grommetInputNames.indexOf(comp.displayName) !== -1 || $64045f6ad477bf50$var$grommetInputPadNames.indexOf(comp.displayName) !== -1);
};
var $64045f6ad477bf50$var$getFocusStyle = function getFocusStyle(props) {
    var _props$theme$formFiel;
    if (props.focus && props.containerFocus === false && ((_props$theme$formFiel = props.theme.formField) == null || (_props$theme$formFiel = _props$theme$formFiel.focus) == null ? void 0 : _props$theme$formFiel.containerFocus) === false) return null;
    return props.focus ? (0, $2O6LY.focusStyle)({
        justBorder: true
    }) : undefined;
};
// The border color has to be painted by whichever element owns the border,
// but the background belongs on the content element so it doesn't bleed
// behind the label and messages when the border is positioned 'outer'.
// FormField sets allowHover only when no higher priority state (disabled,
// readOnly, error, focus) applies.
var $64045f6ad477bf50$var$getHoverStyle = function getHoverStyle(role) {
    return function(props) {
        var _formFieldTheme$props, _formFieldTheme$borde, _componentHover$borde, _componentHover$backg;
        var formFieldTheme = props.theme.formField;
        var hover = formFieldTheme == null ? void 0 : formFieldTheme.hover;
        var componentHover = formFieldTheme == null || (_formFieldTheme$props = formFieldTheme[props.componentName]) == null ? void 0 : _formFieldTheme$props.hover;
        if (!props.allowHover || !hover && !componentHover) return undefined;
        var position = formFieldTheme == null || (_formFieldTheme$borde = formFieldTheme.border) == null ? void 0 : _formFieldTheme$borde.position;
        var ownsBorder = role === 'outer' ? position === 'outer' : position === 'inner';
        var componentHoverBorder = (_componentHover$borde = componentHover == null ? void 0 : componentHover.border) != null ? _componentHover$borde : undefined;
        var componentHoverBackground = (_componentHover$backg = componentHover == null ? void 0 : componentHover.background) != null ? _componentHover$backg : undefined;
        var hasComponentBorderOverride = componentHoverBorder !== undefined;
        var hasComponentBackgroundOverride = componentHoverBackground !== undefined;
        var borderColor;
        if (ownsBorder) {
            if (hasComponentBorderOverride) borderColor = componentHoverBorder.color;
            else {
                var _hover$border;
                borderColor = hover == null || (_hover$border = hover.border) == null ? void 0 : _hover$border.color;
            }
        }
        var background;
        if (role === 'content') {
            if (hasComponentBackgroundOverride) background = componentHoverBackground;
            else background = hover == null ? void 0 : hover.background;
        }
        if (!borderColor && background === undefined) return undefined;
        return (0, $f5efw.css)([
            "&:hover{",
            " ",
            "}"
        ], borderColor !== undefined && "border-color: " + (0, $d2fh4.normalizeColor)(borderColor, props.theme) + ";", (0, $jQHd2.backgroundStyle)(background, props.theme, false));
    };
};
var $64045f6ad477bf50$var$FormFieldBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "FormField__FormFieldBox",
    componentId: "sc-m9hood-0"
})([
    "",
    " ",
    " ",
    ""
], function(props) {
    return $64045f6ad477bf50$var$getFocusStyle(props);
}, $64045f6ad477bf50$var$getHoverStyle('outer'), function(props) {
    var _props$theme$formFiel2;
    return (_props$theme$formFiel2 = props.theme.formField) == null ? void 0 : _props$theme$formFiel2.extend;
});
var $64045f6ad477bf50$var$FormFieldContentBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "FormField__FormFieldContentBox",
    componentId: "sc-m9hood-1"
})([
    "",
    " ",
    " ",
    ""
], function(props) {
    return $64045f6ad477bf50$var$getFocusStyle(props);
}, $64045f6ad477bf50$var$getHoverStyle('content'), function(props) {
    var _props$theme$formFiel3;
    return props.theme.formField && ((_props$theme$formFiel3 = props.theme.formField[props == null ? void 0 : props.componentName]) == null || (_props$theme$formFiel3 = _props$theme$formFiel3.container) == null ? void 0 : _props$theme$formFiel3.extend);
});
var $64045f6ad477bf50$var$StyledContentsBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "FormField__StyledContentsBox",
    componentId: "sc-m9hood-2"
})([
    "",
    " ",
    ""
], $64045f6ad477bf50$var$getHoverStyle('content'), function(props) {
    var _props$theme$formFiel4;
    return props.theme.formField && ((_props$theme$formFiel4 = props.theme.formField[props == null ? void 0 : props.componentName]) == null || (_props$theme$formFiel4 = _props$theme$formFiel4.container) == null ? void 0 : _props$theme$formFiel4.extend);
});
var $64045f6ad477bf50$var$StyledMessageContainer = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "FormField__StyledMessageContainer",
    componentId: "sc-m9hood-3"
})([
    "",
    ""
], function(props) {
    return props.messageType && props.theme.formField[props.messageType].container && props.theme.formField[props.messageType].container.extend;
});
var $64045f6ad477bf50$var$RequiredText = (0, $f5efw.default)((0, $kS7Ii.Text)).withConfig({
    displayName: "FormField__RequiredText",
    componentId: "sc-m9hood-4"
})([
    "color:inherit;font-weight:inherit;line-height:inherit;"
]);
var $64045f6ad477bf50$var$ScreenReaderOnly = (0, $f5efw.default)((0, $kS7Ii.Text)).withConfig({
    displayName: "FormField__ScreenReaderOnly",
    componentId: "sc-m9hood-5"
})([
    "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;"
]);
var $64045f6ad477bf50$var$MessageContent = function MessageContent(_ref) {
    var message = _ref.message, id = _ref.id, rest = $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(_ref, $64045f6ad477bf50$var$_excluded);
    return typeof message === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), $64045f6ad477bf50$var$_extends({
        id: id
    }, rest), message) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $64045f6ad477bf50$var$_extends({
        id: id
    }, rest), message);
};
var $64045f6ad477bf50$var$Message = function Message(_ref2) {
    var error = _ref2.error, info = _ref2.info, message = _ref2.message, type = _ref2.type, rest = $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(_ref2, $64045f6ad477bf50$var$_excluded2);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    if (message) {
        var icon;
        var containerProps;
        if (type) {
            icon = theme.formField[type] && theme.formField[type].icon;
            containerProps = theme.formField[type] && theme.formField[type].container;
        }
        // id is in rest; extract it so we can place it on the outermost element
        var id = rest.id, contentRest = $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(rest, $64045f6ad477bf50$var$_excluded3);
        if (icon || containerProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$StyledMessageContainer, $64045f6ad477bf50$var$_extends({
            direction: "row",
            messageType: type
        }, containerProps, passThemeFlag, {
            id: id
        }), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            flex: false
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$MessageContent, $64045f6ad477bf50$var$_extends({
            message: message
        }, contentRest)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$MessageContent, $64045f6ad477bf50$var$_extends({
            message: message,
            id: id
        }, contentRest));
    }
    return null;
};
var $64045f6ad477bf50$var$Input = function Input(_ref3) {
    var component = _ref3.component, disabled = _ref3.disabled, invalid = _ref3.invalid, name = _ref3.name, _onChange = _ref3.onChange, rest = $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(_ref3, $64045f6ad477bf50$var$_excluded4);
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: rest.value
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var InputComponent = component || (0, $kQZ06.TextInput);
    // Grommet input components already check for FormContext
    // and, using their `name`, end up calling the useFormInput.setValue()
    // already. For custom components, we expect they will call
    // this onChange() and we'll call setValue() here, primarily
    // for backwards compatibility.
    var extraProps = $64045f6ad477bf50$var$isGrommetInput(InputComponent) ? {
        focusIndicator: false,
        onChange: _onChange,
        plain: true
    } : {
        value: value,
        onChange: function onChange(event) {
            setValue(event.value !== undefined ? event.value : event.target.value);
            if (_onChange) _onChange(event);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(InputComponent, $64045f6ad477bf50$var$_extends({
        name: name,
        disabled: disabled,
        "aria-invalid": invalid || undefined
    }, rest, extraProps));
};
// Adds aria-describedby (linking to the error Message) and aria-invalid to
// a Grommet input child when the field has an error. Merges with any
// aria-describedby the consumer already put on the child instead of
// overwriting it.
var $64045f6ad477bf50$var$getChildErrorProps = function getChildErrorProps(child, errorId, error) {
    if (!errorId && !error) return {};
    var props = {};
    if (errorId) {
        var existingDescribedBy = child.props['aria-describedby'];
        props['aria-describedby'] = existingDescribedBy ? existingDescribedBy + " " + errorId : errorId;
    }
    if (error) props['aria-invalid'] = true;
    return props;
};
// Backwards compatibility: defaults plain/focusIndicator/pad on a Grommet
// input child, unless the consumer already set plain or focusIndicator.
// This is the same logic FormField has always had; only pulled out into
// its own function so it can be reasoned about independent of the newer
// error-linking logic above.
var $64045f6ad477bf50$var$getChildFocusProps = function getChildFocusProps(child, themeBorder, containerFocus, formFieldTheme) {
    var _formFieldTheme$check;
    return !themeBorder || child.props.plain !== undefined || child.props.focusIndicator !== undefined ? {} : {
        plain: true,
        focusIndicator: !containerFocus,
        pad: child.type.displayName === 'CheckBox' ? formFieldTheme == null || (_formFieldTheme$check = formFieldTheme.checkBox) == null ? void 0 : _formFieldTheme$check.pad : undefined
    };
};
var $64045f6ad477bf50$export$56e87bf42978147a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref4, ref) {
    var _theme$formField2, _theme$global$input, _formFieldTheme$disab, _formFieldTheme$disab2;
    var children = _ref4.children, className = _ref4.className, component = _ref4.component, contentProps = _ref4.contentProps, disabled = _ref4.disabled, errorProp = _ref4.error, help = _ref4.help, htmlFor = _ref4.htmlFor, infoProp = _ref4.info, label = _ref4.label, margin = _ref4.margin, name = _ref4.name, _onBlur = _ref4.onBlur, onChange = _ref4.onChange, _onFocus = _ref4.onFocus, pad = _ref4.pad, required = _ref4.required, style = _ref4.style, validate = _ref4.validate, validateOn = _ref4.validateOn, rest = $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(_ref4, $64045f6ad477bf50$var$_excluded5);
    var _useThemeValue2 = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _formContext$useFormF = formContext.useFormField({
        disabled: disabled,
        error: errorProp,
        info: infoProp,
        name: name,
        required: required,
        validate: validate,
        validateOn: validateOn
    }), error = _formContext$useFormF.error, info = _formContext$useFormF.info, inForm = _formContext$useFormF.inForm, contextOnBlur = _formContext$useFormF.onBlur, contextOnChange = _formContext$useFormF.onChange;
    var formKind = formContext.kind;
    var _useState = (0, $2NacA.useState)(), focus = _useState[0], setFocus = _useState[1];
    var formFieldRef = (0, $dOlbm.useForwardedRef)(ref);
    var formFieldTheme = theme.formField;
    var themeBorder = formFieldTheme.border;
    var debounce = (0, $PvRN2.useDebounce)();
    var portalContext = (0, $2NacA.useContext)((0, $3ZGpZ.PortalContext));
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    (0, $2NacA.useEffect)(function() {
        if (error && validate != null && validate.max) announce(error, 'polite', 5000);
    }, [
        error,
        announce,
        validate == null ? void 0 : validate.max
    ]);
    var readOnlyField = (0, $2NacA.useMemo)(function() {
        var readOnly = false;
        if (children) (0, $2NacA.Children).map(children, function(child) {
            var _child$props, _child$props2;
            if (((child == null || (_child$props = child.props) == null ? void 0 : _child$props.readOnly) === true || (child == null || (_child$props2 = child.props) == null ? void 0 : _child$props2.readOnlyCopy) === true) && child.type && (child.type.displayName === 'TextInput' || child.type.displayName === 'DateInput')) readOnly = true;
        });
        return readOnly;
    }, [
        children
    ]);
    var containerFocus = (0, $2NacA.useMemo)(function() {
        var focusIndicatorFlag = true;
        (0, $2NacA.Children).forEach(children, function(child) {
            var _theme$formField;
            if (child && child.type && $64045f6ad477bf50$var$grommetInputFocusNames.includes(child.type.displayName) && ((_theme$formField = theme.formField) == null || (_theme$formField = _theme$formField.focus) == null ? void 0 : _theme$formField.containerFocus) !== true) focusIndicatorFlag = false;
        });
        return focusIndicatorFlag;
    }, [
        children,
        (_theme$formField2 = theme.formField) == null || (_theme$formField2 = _theme$formField2.focus) == null ? void 0 : _theme$formField2.containerFocus
    ]);
    // Check if child is Select or SelectMultiple and modify htmlFor if needed
    var adjustedHtmlFor = htmlFor;
    if (htmlFor) {
        var isSelectComponent = false;
        // Check if children contain Select or SelectMultiple
        if (children) (0, $2NacA.Children).forEach(children, function(child) {
            if (child && child.type && (child.type.displayName === 'Select' || child.type.displayName === 'SelectMultiple') && child.props.id === htmlFor) isSelectComponent = true;
        });
        // If it's a Select component and htmlFor doesn't end with __input, add it
        if (isSelectComponent && !htmlFor.endsWith('__input')) adjustedHtmlFor = htmlFor + "__input";
    }
    // This is here for backwards compatibility. In case the child is a grommet
    // input component, set plain and focusIndicator props, if they aren't
    // already set.
    var wantContentPad = component && (component === (0, $gpKeH.CheckBox) || component === (0, $gJnoN.CheckBoxGroup) || component === (0, $6flum.RadioButtonGroup));
    // id of the error Message, used to link it to its input via
    // aria-describedby. Always computed when there's an error + htmlFor,
    // regardless of theme border config.
    var errorId = error && htmlFor ? "grommet-" + adjustedHtmlFor + "__error" : undefined;
    // Single Children.map pass applying both the error-linking props
    // (getChildErrorProps) and the plain/focusIndicator/pad backwards-compat
    // defaults (getChildFocusProps) to each Grommet input child. Must run
    // the same way regardless of `error`, or a child's reconciliation key
    // changes between renders - remounting it and losing state (e.g. a
    // typed value) right when the error appears.
    var contents;
    if (children) contents = (0, $2NacA.Children).map(children, function(child) {
        if (!child || !child.type || !$64045f6ad477bf50$var$isGrommetInput(child.type)) return child;
        if (themeBorder && $64045f6ad477bf50$var$grommetInputPadNames.indexOf(child.type.displayName) !== -1) wantContentPad = true;
        var newProps = $64045f6ad477bf50$var$_extends({}, $64045f6ad477bf50$var$getChildErrorProps(child, errorId, error), $64045f6ad477bf50$var$getChildFocusProps(child, themeBorder, containerFocus, formFieldTheme));
        return Object.keys(newProps).length ? /*#__PURE__*/ (0, $2NacA.cloneElement)(child, newProps) : child;
    });
    else contents = children;
    // put rest on container, unless we use internal Input
    var containerRest = rest;
    if (inForm) {
        if (!contents) containerRest = {};
        // Merge aria-describedby with the error id rather than
        // letting either one silently win.
        var ariaDescribedBy = rest['aria-describedby'], restWithoutAria = $64045f6ad477bf50$var$_objectWithoutPropertiesLoose(rest, $64045f6ad477bf50$var$_excluded6);
        var combinedAriaDescribedBy = errorId ? [
            ariaDescribedBy,
            errorId
        ].filter(Boolean).join(' ') : ariaDescribedBy;
        contents = contents || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$Input, $64045f6ad477bf50$var$_extends({
            component: component,
            disabled: disabled,
            invalid: !!error,
            name: name,
            label: component === (0, $gpKeH.CheckBox) ? label : undefined
        }, restWithoutAria, {
            "aria-describedby": combinedAriaDescribedBy || undefined
        }));
    }
    var themeContentProps = $64045f6ad477bf50$var$_extends({}, formFieldTheme.content);
    if (!pad && !wantContentPad) themeContentProps.pad = undefined;
    if (themeBorder && themeBorder.position === 'inner') {
        if (readOnlyField) {
            var _theme$global$input$r;
            themeContentProps.background = (_theme$global$input$r = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r.background;
        } else if (error && formFieldTheme.error) themeContentProps.background = formFieldTheme.error.background;
        else if (disabled && formFieldTheme.disabled) themeContentProps.background = formFieldTheme.disabled.background;
    }
    // fileinput handle
    // use fileinput plain use formfield to drive the border
    var isFileInputComponent;
    if (children) (0, $2NacA.Children).forEach(children, function(child) {
        if (child && child.type && child.type.displayName === 'FileInput') isFileInputComponent = true;
    });
    if (component && component.displayName === 'FileInput' && !isFileInputComponent) isFileInputComponent = true;
    var childName;
    (0, $2NacA.Children).forEach(children, function(child) {
        if (child && child.type) {
            var _childName;
            childName = child.type.displayName;
            // camelCase component name to match theme object key
            if (((_childName = childName) == null ? void 0 : _childName.length) > 0) childName = childName.charAt(0).toLowerCase() + childName.slice(1);
        }
    });
    var allowHover = !disabled && !readOnlyField && !error && !focus;
    if (!themeBorder) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$StyledContentsBox, $64045f6ad477bf50$var$_extends({
        disabledProp: disabled,
        error: error,
        componentName: childName
    }, themeContentProps, contentProps, {
        allowHover: allowHover // internal prop
    }), contents);
    var borderColor;
    if (disabled && formFieldTheme.disabled.border && formFieldTheme.disabled.border.color) borderColor = formFieldTheme.disabled.border.color;
    else if (readOnlyField && (_theme$global$input = theme.global.input) != null && (_theme$global$input = _theme$global$input.readOnly) != null && (_theme$global$input = _theme$global$input.border) != null && _theme$global$input.color) {
        var _theme$global$input2;
        borderColor = (_theme$global$input2 = theme.global.input) == null || (_theme$global$input2 = _theme$global$input2.readOnly) == null || (_theme$global$input2 = _theme$global$input2.border) == null ? void 0 : _theme$global$input2.color;
    } else if (// backward compatibility check
    error && themeBorder && themeBorder.error.color || error && formFieldTheme.error && formFieldTheme.error.border) {
        if (themeBorder.error.color && formFieldTheme.error.border === undefined) borderColor = themeBorder.error.color || 'status-critical';
        else if (formFieldTheme.error.border && formFieldTheme.error.border.color) borderColor = formFieldTheme.error.border.color || 'status-critical';
    } else if (focus && formFieldTheme.focus && formFieldTheme.focus.border && formFieldTheme.focus.border.color) borderColor = formFieldTheme.focus.border.color;
    else borderColor = themeBorder && themeBorder.color || 'border';
    var labelStyle = $64045f6ad477bf50$var$_extends({}, formKind ? formFieldTheme[formKind].label : formFieldTheme.label);
    if (disabled) labelStyle.color = formFieldTheme.disabled && formFieldTheme.disabled.label ? formFieldTheme.disabled.label.color : labelStyle.color;
    var themeHelpProps = $64045f6ad477bf50$var$_extends({}, formFieldTheme.help, disabled && {
        color: formFieldTheme == null || (_formFieldTheme$disab = formFieldTheme.disabled) == null || (_formFieldTheme$disab = _formFieldTheme$disab.help) == null ? void 0 : _formFieldTheme$disab.color
    });
    var themeInfoProps = $64045f6ad477bf50$var$_extends({}, formFieldTheme.info, disabled && {
        color: formFieldTheme == null || (_formFieldTheme$disab2 = formFieldTheme.disabled) == null || (_formFieldTheme$disab2 = _formFieldTheme$disab2.info) == null ? void 0 : _formFieldTheme$disab2.color
    });
    var abut;
    var abutMargin;
    var outerStyle = style;
    // If fileinput is wrapped in a formfield we want to use
    // the border style from the fileInput.theme. We also do not
    // want the foocus around the formfield since the the focus
    // is on the anchor/button inside fileinput
    if (themeBorder) {
        var innerProps = themeBorder.position === 'inner' ? {
            border: $64045f6ad477bf50$var$_extends({}, themeBorder, {
                size: isFileInputComponent ? theme.fileInput.border.size : undefined,
                style: isFileInputComponent ? theme.fileInput.border.style : undefined,
                side: isFileInputComponent ? theme.fileInput.border.side : themeBorder.side || 'bottom',
                color: borderColor
            }),
            round: formFieldTheme.round,
            focus: isFileInputComponent ? undefined : focus
        } : {};
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$FormFieldContentBox, $64045f6ad477bf50$var$_extends({
            disabledProp: disabled,
            error: error,
            componentName: childName
        }, themeContentProps, innerProps, contentProps, {
            containerFocus: containerFocus // internal prop
            ,
            allowHover: allowHover // internal prop
        }, passThemeFlag), contents);
        var mergedMargin = margin || formFieldTheme.margin;
        abut = themeBorder.position === 'outer' && (themeBorder.side === 'all' || themeBorder.side === 'horizontal' || !themeBorder.side) && !(mergedMargin && (typeof mergedMargin === 'string' && mergedMargin !== 'none' || mergedMargin.bottom && mergedMargin.bottom !== 'none' || mergedMargin.horizontal && mergedMargin.horizontal !== 'none'));
        if (abut) {
            // marginBottom is set to overlap adjacent fields
            abutMargin = {
                bottom: '-1px'
            };
            if (margin) abutMargin = margin;
            else if (themeBorder.size) // if the user defines a margin,
            // then the default margin below will be overridden
            abutMargin = {
                bottom: "-" + (0, $fzxBh.parseMetricToNum)(theme.global.borderSize[themeBorder.size] || themeBorder.size) + "px"
            };
            outerStyle = $64045f6ad477bf50$var$_extends({
                position: focus ? 'relative' : undefined,
                zIndex: focus ? 10 : undefined
            }, style);
        }
    }
    var outerBackground;
    if (themeBorder && themeBorder.position === 'outer') {
        if (error && formFieldTheme.error && formFieldTheme.error.background) outerBackground = formFieldTheme.error.background;
        else if (focus && formFieldTheme.focus && formFieldTheme.focus.background && formFieldTheme.focus.background.color) outerBackground = formFieldTheme.focus.background.color;
        else if (disabled && formFieldTheme.disabled && formFieldTheme.disabled.background) outerBackground = formFieldTheme.disabled.background;
    }
    var outerProps = themeBorder && themeBorder.position === 'outer' ? {
        border: $64045f6ad477bf50$var$_extends({}, themeBorder, {
            color: borderColor
        }),
        round: formFieldTheme.round,
        focus: focus
    } : {};
    var requiredIndicator = theme.formField.label.requiredIndicator;
    if (requiredIndicator === true) // accessibility resource: https://www.deque.com/blog/anatomy-of-accessible-forms-required-form-fields/
    // this approach allows the required indicator to be hidden visually,
    // but present for assistive tech.
    // using aria-hidden so screen does not read out "star" and
    // just reads out "required"
    requiredIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$RequiredText, {
        "aria-hidden": "true"
    }, "*"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$ScreenReaderOnly, null, "required"));
    var showRequiredIndicator = required && requiredIndicator;
    if (typeof required === 'object' && required.indicator === false) showRequiredIndicator = false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$FormFieldBox, $64045f6ad477bf50$var$_extends({
        ref: formFieldRef,
        className: className,
        background: outerBackground,
        margin: abut ? abutMargin : margin || $64045f6ad477bf50$var$_extends({}, formFieldTheme.margin)
    }, outerProps, {
        style: outerStyle,
        containerFocus: containerFocus // internal prop
        ,
        allowHover: allowHover // internal prop
        ,
        onFocus: function onFocus(event) {
            var _formFieldRef$current;
            var root = (_formFieldRef$current = formFieldRef.current) == null ? void 0 : _formFieldRef$current.getRootNode();
            if (root) setFocus((0, $cDMMY.containsFocus)(formFieldRef.current) && (0, $cDMMY.shouldKeepFocus)(root));
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            // if input has a drop and focus is within drop
            // prevent onBlur validation from running until
            // focus is no longer within the drop or input
            if (contextOnBlur && !formFieldRef.current.contains(event.relatedTarget) && !(0, $cDMMY.withinDropPortal)(event.relatedTarget, portalContext)) contextOnBlur(event);
            if (_onBlur) _onBlur(event);
        },
        onChange: contextOnChange || onChange ? function(event) {
            event.persist();
            if (onChange) onChange(event);
            if (contextOnChange) debounce(function() {
                return function() {
                    return contextOnChange(event);
                };
            });
        } : undefined
    }, containerRest, passThemeFlag), label && component !== (0, $gpKeH.CheckBox) || help ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, label && component !== (0, $gpKeH.CheckBox) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), $64045f6ad477bf50$var$_extends({
        as: "label",
        id: htmlFor ? "grommet-" + adjustedHtmlFor + "__label" : undefined,
        htmlFor: adjustedHtmlFor
    }, labelStyle), label, showRequiredIndicator ? requiredIndicator : undefined), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$Message, $64045f6ad477bf50$var$_extends({
        message: help
    }, themeHelpProps))) : undefined, contents, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$Message, $64045f6ad477bf50$var$_extends({
        type: "error",
        message: error
    }, formFieldTheme.error, {
        id: errorId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($64045f6ad477bf50$var$Message, $64045f6ad477bf50$var$_extends({
        type: "info",
        message: info
    }, themeInfoProps)));
});
$64045f6ad477bf50$export$56e87bf42978147a.displayName = 'FormField';
$64045f6ad477bf50$export$56e87bf42978147a.propTypes = (0, $bYy35.FormFieldPropTypes);

});
parcelRegister("PvRN2", function(module, exports) {

$parcel$export(module.exports, "useDebounce", () => $09ad7b92fe73bae1$export$21805fee57372823);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $eL6w3 = parcelRequire("eL6w3");
var $09ad7b92fe73bae1$export$21805fee57372823 = function useDebounce(debounceDelay) {
    var _useState = (0, $2NacA.useState)(), func = _useState[0], setFunc = _useState[1];
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var delay = debounceDelay || theme.global.debounceDelay;
    (0, $2NacA.useEffect)(function() {
        var timer;
        if (func) timer = setTimeout(function() {
            return func();
        }, delay);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        func,
        delay
    ]);
    return setFunc;
};
var $09ad7b92fe73bae1$export$2e2bcd8739ae039 = $09ad7b92fe73bae1$export$21805fee57372823;

});

parcelRegister("gJnoN", function(module, exports) {

$parcel$export(module.exports, "CheckBoxGroup", () => $c2e2ffd8b9c9a25d$export$b6a68782c21a95ce);

var $2NacA = parcelRequire("2NacA");

var $gpKeH = parcelRequire("gpKeH");

var $7wKkw = parcelRequire("7wKkw");

var $f9ycQ = parcelRequire("f9ycQ");

var $5iMCI = parcelRequire("5iMCI");

var $eL6w3 = parcelRequire("eL6w3");
var $c2e2ffd8b9c9a25d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "children",
    "defaultValue",
    "value",
    "disabled",
    "focusIndicator",
    "gap",
    "id",
    "labelKey",
    "valueKey",
    "onChange",
    "options",
    "name"
], $c2e2ffd8b9c9a25d$var$_excluded2 = [
    "value"
];
function $c2e2ffd8b9c9a25d$var$_extends() {
    return $c2e2ffd8b9c9a25d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c2e2ffd8b9c9a25d$var$_extends.apply(null, arguments);
}
function $c2e2ffd8b9c9a25d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c2e2ffd8b9c9a25d$export$b6a68782c21a95ce = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _formContext$useFormF, _theme$checkBoxGroup;
    var ariaLabelProp = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], children = _ref.children, defaultValue = _ref.defaultValue, valueProp = _ref.value, disabledProp = _ref.disabled, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, id = _ref.id, labelKey = _ref.labelKey, valueKey = _ref.valueKey, onChange = _ref.onChange, optionsProp = _ref.options, name = _ref.name, rest = $c2e2ffd8b9c9a25d$var$_objectWithoutPropertiesLoose(_ref, $c2e2ffd8b9c9a25d$var$_excluded);
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    // In case option is a string, normalize it to be an object
    var options = optionsProp.map(function(option) {
        return typeof option === 'string' ? {
            disabled: disabledProp,
            value: option,
            label: option
        } : option;
    });
    // 'value' is an array of checked valueKeys
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || []
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // Logic is necessary to maintain a proper data structure for Form logic
    var onCheckBoxChange = function onCheckBoxChange(event, optionValue, option) {
        // deep copy of value
        var nextValue = JSON.parse(JSON.stringify(value)) || [];
        var optionIndex = nextValue.indexOf(optionValue);
        // If the value option isn't in the array, add it.
        // Otherwise, remove it.
        if (optionIndex < 0) nextValue.push(optionValue);
        else nextValue.splice(optionIndex, 1);
        setValue(nextValue);
        // Similar functionality to Select onChange()
        if (onChange) {
            event.persist(); // extract from React synthetic event pool
            var adjustedEvent = event;
            adjustedEvent.value = nextValue;
            adjustedEvent.option = option;
            onChange(adjustedEvent);
        }
    };
    var ariaLabelledBy;
    if (formContext != null && (_formContext$useFormF = formContext.useFormField({})) != null && _formContext$useFormF.inForm && id && !ariaLabelProp) ariaLabelledBy = "grommet-" + id + "__label";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f9ycQ.StyledCheckBoxGroup), $c2e2ffd8b9c9a25d$var$_extends({
        ref: ref,
        "aria-label": ariaLabelProp,
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        role: "group"
    }, theme.checkBoxGroup.container, {
        gap: gap || ((_theme$checkBoxGroup = theme.checkBoxGroup) == null || (_theme$checkBoxGroup = _theme$checkBoxGroup.container) == null ? void 0 : _theme$checkBoxGroup.gap),
        id: id
    }, passThemeFlag, rest), options.map(function(option, index) {
        var optionValue = option.value;
        var label = labelKey ? option[labelKey] : option.label;
        var valueOption = valueKey ? option[valueKey] : optionValue;
        var checked = value.indexOf(valueOption) >= 0;
        var disabled = disabledProp || option.disabled;
        var key = label + "-" + valueOption;
        if (option.checked) console.warn("'checked' prop of an individual CheckBox shouldn't be used in a CheckBoxGroup component. Use the CheckBoxGroup 'value' prop instead.");
        // value shouldn't propagate the input field and the onChange option
        var omit = option.value, optionRest = $c2e2ffd8b9c9a25d$var$_objectWithoutPropertiesLoose(option, $c2e2ffd8b9c9a25d$var$_excluded2);
        var optionProps = $c2e2ffd8b9c9a25d$var$_extends({}, optionRest, {
            label: label,
            disabled: disabled
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $gpKeH.CheckBox), $c2e2ffd8b9c9a25d$var$_extends({
            key: key
        }, optionProps, {
            disabled: disabled,
            checked: checked,
            focusIndicator: focusIndicator,
            label: label,
            onChange: function onChange(event) {
                return onCheckBoxChange(event, valueOption, optionProps);
            }
        }), children ? function(state) {
            return children(options[index], state);
        } : null);
    }));
});
$c2e2ffd8b9c9a25d$export$b6a68782c21a95ce.displayName = 'CheckBoxGroup';
$c2e2ffd8b9c9a25d$export$b6a68782c21a95ce.propTypes = (0, $5iMCI.CheckBoxGroupPropTypes);

});
parcelRegister("f9ycQ", function(module, exports) {

$parcel$export(module.exports, "StyledCheckBoxGroup", () => $b0823ae47f8e6b1b$export$16c1e3500516c0d8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");
var $b0823ae47f8e6b1b$export$16c1e3500516c0d8 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledCheckBoxGroup",
    componentId: "sc-2nhc5d-0"
})([
    "",
    ""
], function(props) {
    return props.theme.checkBoxGroup && props.theme.checkBoxGroup.container && props.theme.checkBoxGroup.container.extend;
});

});

parcelRegister("5iMCI", function(module, exports) {

$parcel$export(module.exports, "CheckBoxGroupPropTypes", () => $3dc459c57f1981da$export$7b69d769ba440e56);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $3dc459c57f1981da$var$PropType = {};
var $3dc459c57f1981da$export$7b69d769ba440e56 = $3dc459c57f1981da$var$PropType;

});


parcelRegister("6flum", function(module, exports) {

$parcel$export(module.exports, "RadioButtonGroup", () => $48c4d00472ee1bfc$export$c062ce1cc79ad58a);

var $2NacA = parcelRequire("2NacA");

var $7wKkw = parcelRequire("7wKkw");

var $czDw5 = parcelRequire("czDw5");

var $5xcHk = parcelRequire("5xcHk");

var $l046S = parcelRequire("l046S");

var $cwoyz = parcelRequire("cwoyz");

var $eL6w3 = parcelRequire("eL6w3");
var $48c4d00472ee1bfc$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "children",
    "defaultValue",
    "disabled",
    "focusIndicator",
    "id",
    "name",
    "onChange",
    "options",
    "value",
    "gap"
], $48c4d00472ee1bfc$var$_excluded2 = [
    "disabled",
    "id",
    "label",
    "value"
];
function $48c4d00472ee1bfc$var$_extends() {
    return $48c4d00472ee1bfc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $48c4d00472ee1bfc$var$_extends.apply(null, arguments);
}
function $48c4d00472ee1bfc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $48c4d00472ee1bfc$export$c062ce1cc79ad58a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _formContext$useFormF, _theme$radioButtonGro;
    var ariaLabelProp = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], children = _ref.children, defaultValue = _ref.defaultValue, disabled = _ref.disabled, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, name = _ref.name, onChange = _ref.onChange, optionsProp = _ref.options, valueProp = _ref.value, gap = _ref.gap, rest = $48c4d00472ee1bfc$var$_objectWithoutPropertiesLoose(_ref, $48c4d00472ee1bfc$var$_excluded);
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    // normalize options to always use an object
    var options = optionsProp.map(function(o) {
        return typeof o !== 'object' ? {
            disabled: disabled,
            id: id ? id + "-" + o : "" + o,
            // force string
            label: typeof o !== 'string' ? JSON.stringify(o) : o,
            value: o
        } : $48c4d00472ee1bfc$var$_extends({
            disabled: disabled
        }, o);
    });
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue != null ? defaultValue : ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // track if focus is on one of the radio buttons
    var _useState = (0, $2NacA.useState)(), focus = _useState[0], setFocus = _useState[1];
    var optionRefs = (0, $2NacA.useRef)([]);
    var valueIndex = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).useMemo(function() {
        var result;
        options.some(function(option, index) {
            if (option.value === value) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }, [
        options,
        value
    ]);
    var onNext = function onNext() {
        if (valueIndex !== undefined && valueIndex < options.length - 1) {
            var nextIndex = valueIndex + 1;
            // ensure change event occurs
            optionRefs.current[nextIndex].click();
        }
    };
    var onPrevious = function onPrevious() {
        if (valueIndex > 0) {
            var nextIndex = valueIndex - 1;
            // ensure change event occurs
            optionRefs.current[nextIndex].click();
        }
    };
    var onFocus = function onFocus() {
        // Delay just a wee bit so Chrome doesn't missing turning the button on.
        // Chrome behaves differently in that focus is given to radio buttons
        // when the user selects one, unlike Safari and Firefox.
        setTimeout(function() {
            setFocus(true);
        }, 1);
    };
    var onRadioButtonChange = function onRadioButtonChange(event, optionValue) {
        setValue(optionValue);
        if (onChange) {
            event.persist(); // extract from React synthetic event pool
            // event.target.value gives value as a string which needs to be
            // manually typecasted according to the type of original option value.
            // return the original option value attached with the event.
            var adjustedEvent = event;
            adjustedEvent.value = optionValue;
            onChange(adjustedEvent);
        }
    };
    var onBlur = function onBlur() {
        return setFocus(false);
    };
    var ariaLabelledBy;
    if (formContext != null && (_formContext$useFormF = formContext.useFormField({})) != null && _formContext$useFormF.inForm && id && !ariaLabelProp) ariaLabelledBy = "grommet-" + id + "__label";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        target: "document",
        onUp: focus ? onPrevious : undefined,
        onDown: focus ? onNext : undefined,
        onLeft: focus ? onPrevious : undefined,
        onRight: focus ? onNext : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $48c4d00472ee1bfc$var$_extends({
        "aria-label": ariaLabelProp,
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy,
        id: id,
        ref: ref,
        role: "radiogroup"
    }, theme.radioButtonGroup.container, {
        gap: gap || ((_theme$radioButtonGro = theme.radioButtonGroup.container) == null ? void 0 : _theme$radioButtonGro.gap)
    }, rest), options.map(function(_ref2, index) {
        var optionDisabled = _ref2.disabled, optionId = _ref2.id, label = _ref2.label, optionValue = _ref2.value, optionRest = $48c4d00472ee1bfc$var$_objectWithoutPropertiesLoose(_ref2, $48c4d00472ee1bfc$var$_excluded2);
        // if focus is within the RadioButtonGroup, determine
        // which radio button should be the active one
        var focusable = optionValue === value || value === undefined && !index || // when nothing has been selected, show focus
        // on the first radiobutton
        value === '' && index === 0;
        if (optionRest.checked) console.warn("'checked' prop of an individual RadioButton shouldn't be used in a RadioButtonGroup component. Use the RadioButtonGroup 'value' prop instead.");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $l046S.RadioButton), $48c4d00472ee1bfc$var$_extends({
            ref: function ref(aRef) {
                optionRefs.current[index] = aRef;
            },
            key: optionValue,
            name: name,
            label: !children ? label : undefined,
            disabled: optionDisabled,
            checked: optionValue === value,
            focus: focus && focusable,
            focusIndicator: focusIndicator,
            id: optionId,
            value: optionValue,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: function onChange(event) {
                return onRadioButtonChange(event, optionValue);
            },
            tabIndex: focusable ? '0' : '-1' // necessary for Firefox
        }, optionRest), children ? function(state) {
            return children(optionsProp[index], state);
        } : null);
    })));
});
$48c4d00472ee1bfc$export$c062ce1cc79ad58a.displayName = 'RadioButtonGroup';
$48c4d00472ee1bfc$export$c062ce1cc79ad58a.propTypes = (0, $cwoyz.RadioButtonGroupPropTypes);

});
parcelRegister("l046S", function(module, exports) {

$parcel$export(module.exports, "RadioButton", () => $f49cc934506ff3cd$export$f4422ae58352e179);

var $2NacA = parcelRequire("2NacA");

var $d2fh4 = parcelRequire("d2fh4");
var $7rlLx = parcelRequire("7rlLx");
var $hp4MM = parcelRequire("hp4MM");

var $i8SeB = parcelRequire("i8SeB");

var $cvz8e = parcelRequire("cvz8e");

var $eL6w3 = parcelRequire("eL6w3");
var $f49cc934506ff3cd$var$_excluded = [
    "a11yTitle",
    "checked",
    "children",
    "disabled",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onChange"
];
function $f49cc934506ff3cd$var$_extends() {
    return $f49cc934506ff3cd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f49cc934506ff3cd$var$_extends.apply(null, arguments);
}
function $f49cc934506ff3cd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f49cc934506ff3cd$export$f4422ae58352e179 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$radioButton$ba;
    var a11yTitle = _ref.a11yTitle, checked = _ref.checked, children = _ref.children, disabled = _ref.disabled, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, onChange = _ref.onChange, rest = $f49cc934506ff3cd$var$_objectWithoutPropertiesLoose(_ref, $f49cc934506ff3cd$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useState = (0, $2NacA.useState)(), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, $2NacA.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var usingKeyboard = (0, $hp4MM.useKeyboard)();
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $i8SeB.StyledRadioButtonLabel), passThemeFlag, label) : label;
    var Icon = theme.radioButton.icons.circle;
    var borderColor = (0, $d2fh4.normalizeColor)(theme.radioButton.border.color, theme);
    var backgroundColor = (0, $d2fh4.normalizeColor)((_theme$radioButton$ba = theme.radioButton.background) == null ? void 0 : _theme$radioButton$ba.color, theme);
    if (checked) {
        var _theme$radioButton$ch;
        borderColor = (0, $d2fh4.normalizeColor)(theme.radioButton.color || 'control', theme);
        if ((_theme$radioButton$ch = theme.radioButton.check) != null && (_theme$radioButton$ch = _theme$radioButton$ch.background) != null && _theme$radioButton$ch.color) backgroundColor = (0, $d2fh4.normalizeColor)(theme.radioButton.check.background.color, theme);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $i8SeB.StyledRadioButtonContainer), $f49cc934506ff3cd$var$_extends({}, (0, $7rlLx.removeUndefined)({
        htmlFor: id,
        disabled: disabled
    }), {
        onClick: function onClick(event) {
            // prevents clicking on the label trigging the event twice
            // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
            if (event.target.type !== 'radio') event.stopPropagation();
        },
        focus: focus,
        focusIndicator: focusIndicator,
        onFocus: function onFocus() {
            return setFocus(true);
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        onMouseEnter: function onMouseEnter() {
            return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setHover(false);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $i8SeB.StyledRadioButton), $f49cc934506ff3cd$var$_extends({
        flex: false,
        margin: label ? {
            right: theme.radioButton.gap
        } : undefined
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $i8SeB.StyledRadioButtonInput), $f49cc934506ff3cd$var$_extends({
        "aria-label": a11yTitle
    }, rest, {
        ref: ref,
        type: "radio"
    }, (0, $7rlLx.removeUndefined)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled,
        onChange: onChange
    }))), children ? children({
        checked: checked,
        focus: focus && focusIndicator,
        hover: hover
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $i8SeB.StyledRadioButtonBox), $f49cc934506ff3cd$var$_extends({
        focus: focus && focusIndicator && usingKeyboard,
        align: "center",
        justify: "center",
        width: theme.radioButton.size,
        height: theme.radioButton.size,
        border: {
            size: theme.radioButton.border.width,
            color: borderColor
        },
        backgroundColor: backgroundColor,
        round: theme.radioButton.check.radius
    }, passThemeFlag), checked && (Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(Icon, {
        theme: theme,
        as: (0, $i8SeB.StyledRadioButtonIcon)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $i8SeB.StyledRadioButtonIcon), $f49cc934506ff3cd$var$_extends({
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("circle", {
        cx: 12,
        cy: 12,
        r: 6
    }))))), normalizedLabel);
});
$f49cc934506ff3cd$export$f4422ae58352e179.displayName = 'RadioButton';
$f49cc934506ff3cd$export$f4422ae58352e179.propTypes = (0, $cvz8e.RadioButtonPropTypes);

});
parcelRegister("i8SeB", function(module, exports) {

$parcel$export(module.exports, "StyledRadioButtonContainer", () => $d3530b308ff5d2c6$export$8acf1677a08924d7);
$parcel$export(module.exports, "StyledRadioButtonInput", () => $d3530b308ff5d2c6$export$e56967134e4288ed);
$parcel$export(module.exports, "StyledRadioButtonLabel", () => $d3530b308ff5d2c6$export$9785e57ddfe69aa);
$parcel$export(module.exports, "StyledRadioButtonIcon", () => $d3530b308ff5d2c6$export$be6e4fdf83e53746);
$parcel$export(module.exports, "StyledRadioButtonBox", () => $d3530b308ff5d2c6$export$634d9fc8954dd28a);
$parcel$export(module.exports, "StyledRadioButton", () => $d3530b308ff5d2c6$export$561b697fc173df1f);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $d2fh4 = parcelRequire("d2fh4");

var $5xcHk = parcelRequire("5xcHk");
var $d3530b308ff5d2c6$var$disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var $d3530b308ff5d2c6$export$8acf1677a08924d7 = (0, $f5efw.default).label.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonContainer",
    componentId: "sc-g1f6ld-0"
})([
    "display:flex;flex-direction:row;align-items:center;user-select:none;width:fit-content;",
    " ",
    " &:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";}&:hover{background-color:",
    ";}",
    " ",
    ";"
], function(props) {
    return props.disabled && $d3530b308ff5d2c6$var$disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.radioButton.hover.border.color, props.theme);
}, function(props) {
    return (0, $d2fh4.normalizeColor)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme);
}, function(props) {
    return props.focus && !props.focusIndicator && "\n      input:not([disabled]) + div,\n      input:not([disabled]) + span {\n      border-color: " + (0, $d2fh4.normalizeColor)(props.theme.radioButton.hover.border.color, props.theme) + ";\n    }\n    background-color: " + (0, $d2fh4.normalizeColor)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme) + ";\n    ";
}, function(props) {
    return props.theme.radioButton.container.extend;
});
var $d3530b308ff5d2c6$export$e56967134e4288ed = (0, $f5efw.default).input.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonInput",
    componentId: "sc-g1f6ld-1"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    ";"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
});
var $d3530b308ff5d2c6$export$9785e57ddfe69aa = (0, $f5efw.default).span.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonLabel",
    componentId: "sc-g1f6ld-2"
})([
    "",
    ""
], function(props) {
    return props.theme.radioButton.font.weight && (0, $f5efw.css)([
        "font-weight:",
        ";"
    ], props.theme.radioButton.font.weight);
});
var $d3530b308ff5d2c6$export$be6e4fdf83e53746 = (0, $f5efw.default).svg.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonIcon",
    componentId: "sc-g1f6ld-3"
})([
    "box-sizing:border-box;width:",
    ";height:",
    ";fill:",
    ";transform:scale(1);",
    ";"
], function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return (0, $d2fh4.normalizeColor)(props.theme.radioButton.check.color || 'control', props.theme);
}, function(props) {
    return props.theme.radioButton.icon.extend;
});
var $d3530b308ff5d2c6$export$634d9fc8954dd28a = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonBox",
    componentId: "sc-g1f6ld-4"
})([
    "background-color:",
    ";transform:scale(1);",
    ";",
    ";"
], function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.focus && (0, $2O6LY.focusStyle)();
}, function(props) {
    return props.theme.radioButton.check.extend;
});
var $d3530b308ff5d2c6$export$561b697fc173df1f = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledRadioButton",
    componentId: "sc-g1f6ld-5"
})([
    "",
    ";"
], function(props) {
    return props.theme.radioButton && props.theme.radioButton.extend;
});

});

parcelRegister("cvz8e", function(module, exports) {

$parcel$export(module.exports, "RadioButtonPropTypes", () => $91b3a1bc7e6329a0$export$9044c49f71780958);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $91b3a1bc7e6329a0$var$PropType = {};
var $91b3a1bc7e6329a0$export$9044c49f71780958 = $91b3a1bc7e6329a0$var$PropType;

});


parcelRegister("cwoyz", function(module, exports) {

$parcel$export(module.exports, "RadioButtonGroupPropTypes", () => $91db85994706993e$export$3412d151ae3be8eb);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $91db85994706993e$var$PropType = {};
var $91db85994706993e$export$3412d151ae3be8eb = $91db85994706993e$var$PropType;

});


parcelRegister("bYy35", function(module, exports) {

$parcel$export(module.exports, "FormFieldPropTypes", () => $8b7fb5ab1815e79a$export$4a795d94b8641430);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0


var $8b7fb5ab1815e79a$var$PropType = {};
var $8b7fb5ab1815e79a$export$4a795d94b8641430 = $8b7fb5ab1815e79a$var$PropType;

});


parcelRegister("4wQEk", function(module, exports) {

$parcel$export(module.exports, "ManualClassification", () => $e5eb8bee6196c226$export$50d7674d27315b6f);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
const $e5eb8bee6196c226$export$50d7674d27315b6f = ({ analysis: analysis, ...props })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        background: {
            color: 'brand'
        },
        pad: "small",
        ...props,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                weight: "bold",
                color: "white",
                children: "Manual Classification"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: "small",
                color: "white",
                children: analysis.manualClassificationReason
            }),
            analysis.manuallyClassifiedAt && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: "xsmall",
                color: "white",
                children: new Date(analysis.manuallyClassifiedAt).toLocaleString()
            })
        ]
    });

});






parcelRegister("1BLyu", function(module, exports) {

$parcel$export(module.exports, "CommercialEditRow", () => $1d4c97a707042d57$export$d80510643e53b610);

var $6ir3O = parcelRequire("6ir3O");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $hIlrL = parcelRequire("hIlrL");
var $2bcjL = parcelRequire("2bcjL");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");

var $5HonF = parcelRequire("5HonF");
var $hAOlB = parcelRequire("hAOlB");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");
parcelRequire("bRT7J");
var $gdNyE = parcelRequire("gdNyE");
var $lpy8P = parcelRequire("lpy8P");
var $3W9FZ = parcelRequire("3W9FZ");
var $hF8pi = parcelRequire("hF8pi");
var $jGT7M = parcelRequire("jGT7M");
var $1Ofsp = parcelRequire("1Ofsp");
var $6q7qM = parcelRequire("6q7qM");
var $d2VmQ = parcelRequire("d2VmQ");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");
var $7nm6N = parcelRequire("7nm6N");

var $8DltC = parcelRequire("8DltC");

var $4Oriw = parcelRequire("4Oriw");

var $b1rqt = parcelRequire("b1rqt");

var $bgcVc = parcelRequire("bgcVc");

var $drlit = parcelRequire("drlit");

var $h5O0B = parcelRequire("h5O0B");
const $1d4c97a707042d57$export$d80510643e53b610 = (0, $j8yBr.observer)(({ commercialId: commercialId, onChecked: onChecked, checked: checked, initialEditId: initialEditId })=>{
    /** Context **/ const navigate = (0, $19GAm.useNavigate)();
    const estimateStore = (0, $8DltC.useEstimateStore)();
    const commercialStore = (0, $8DltC.useCommercialStore)();
    const performerStore = (0, $8DltC.usePerformerStore)();
    const holdingFeeStore = (0, $8DltC.useHoldingFeeStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ const [commercial, setCommercial] = (0, $2NacA.useState)();
    const [showAddEditModal, setShowAddEditModal] = (0, $2NacA.useState)(false);
    const [pendingTypeChange, setPendingTypeChange] = (0, $2NacA.useState)();
    const [selectedEditIds, setSelectedEditIds] = (0, $2NacA.useState)([]);
    const [showCommercialEditReviewModal, setShowCommercialEditReviewModal] = (0, $2NacA.useState)(false);
    const [wages, setWages] = (0, $2NacA.useState)(0);
    const [total, setTotal] = (0, $2NacA.useState)(0);
    const [expandedHoldingFeesContractId, setExpandedHoldingFeesContractId] = (0, $2NacA.useState)(null);
    const [holdingFeeSchedules, setHoldingFeeSchedules] = (0, $2NacA.useState)({});
    /** Refs **/ const columnWidths = [
        '48px',
        '21%',
        '20%',
        '8%',
        '6%',
        '19%',
        '224px',
        '48px'
    ];
    /** Computed **/ const usageEstimate = estimateStore.getTempUsageEstimate(commercial?.id);
    /** Methods **/ // Reads estimateStore.tempEstimate directly (rather than a value captured during
    // render) so this isn't tracked as a render-time MobX dependency - otherwise every
    // commercial's row re-renders whenever any one of them recalculates its estimate.
    const recalculateUsageEstimate = async ()=>{
        if (!commercial) return;
        const usageEstimate = estimateStore.tempEstimate?.usage_estimates.find((usageEstimate)=>usageEstimate.commercial?.id === commercial.id);
        if (usageEstimate) await estimateStore.updateUsageEstimate(usageEstimate.id, undefined, true);
    };
    const chooseEdit = (id)=>{
        if (selectedEditIds.includes(id)) setSelectedEditIds(selectedEditIds.filter((s)=>s !== id));
        else setSelectedEditIds([
            ...selectedEditIds,
            id
        ]);
    };
    const updateCommercial = async (update)=>{
        if (!commercial) return;
        const updatedCommercial = await commercialStore.updateCommercial(commercial.id, update);
        if (updatedCommercial) {
            setCommercial(updatedCommercial);
            // Only the commercial's type affects usage fee calculations (changing it already
            // warns about resetting usages, below) - title/duration edits don't, so skip the
            // costly whole-project estimate refresh for those.
            if (update.type !== undefined) await recalculateUsageEstimate();
        }
    };
    const onChangeCommercialType = async (type)=>type !== commercial?.type && commercial?.usages.length ? setPendingTypeChange(type) : await updateCommercial({
            type: type
        });
    const onConfirmCommercialType = async (type)=>{
        await updateCommercial({
            type: type
        });
        setPendingTypeChange(undefined);
    };
    const addEdit = async (commercialId, editType)=>{
        if (!commercial) return;
        const edit = await commercialStore.createEdit({
            title: `${commercial.title} ${editType} Edit`,
            type: editType,
            commercialId: commercialId,
            durationInSeconds: 0
        });
        if (edit && commercial) {
            const edits = [
                ...commercial.edits,
                edit
            ];
            const updatedCommercial = {
                ...commercial,
                edits: edits
            };
            setCommercial(updatedCommercial);
        }
        setShowAddEditModal(false);
    };
    const updateEdit = (0, $2NacA.useCallback)(async (update)=>{
        if (!commercial) return;
        console.log('Updating edit:', update);
        // Build the update request, explicitly including undefined values as null for the API
        const updateRequest = {};
        if (update.duration !== undefined) updateRequest.durationInSeconds = update.duration;
        if (update.ad_id !== undefined) updateRequest.adId = update.ad_id;
        if ('asset_id' in update) updateRequest.assetId = update.asset_id || null;
        if (update.is_paid !== undefined) updateRequest.isPaid = update.is_paid;
        if (update.title !== undefined) updateRequest.title = update.title;
        if (update.type !== undefined) updateRequest.type = update.type;
        const edit = await commercialStore.updateEdit(update.id, updateRequest);
        if (!edit) return;
        const edits = commercial.edits?.map((e)=>e.id === edit.id ? edit : e);
        const updatedCommercial = {
            ...commercial,
            edits: edits
        };
        setCommercial(updatedCommercial);
    }, [
        commercial,
        commercialStore
    ]);
    const deleteEdits = async ()=>{
        if (!commercial || selectedEditIds.length === 0) return;
        await Promise.all(selectedEditIds.map((editId)=>commercialStore.deleteEdit(editId)));
        const edits = commercial.edits.filter((edit)=>!selectedEditIds.includes(edit.id));
        setCommercial({
            ...commercial,
            edits: edits
        });
        setSelectedEditIds([]);
    };
    const getUsageConsumedForRole = (roleId)=>{
        if (!roleId || !usageEstimate) return 0;
        return usageEstimate.items.filter((item)=>item.role?.id === roleId).reduce((sum, item)=>sum + item.subtotal, 0);
    };
    const guaranteeRollup = (commercial?.contracts ?? []).reduce((acc, contract)=>{
        const guarantee = contract.usage_guarantee_amount;
        if (!guarantee) return acc;
        const overage = getUsageConsumedForRole(contract.role?.id) - guarantee;
        if (overage > 0) {
            acc.performersOverGuarantee += 1;
            acc.totalOverage += overage;
        }
        return acc;
    }, {
        performersOverGuarantee: 0,
        totalOverage: 0
    });
    const toggleHoldingFeeSchedule = async (contractId)=>{
        if (expandedHoldingFeesContractId === contractId) {
            setExpandedHoldingFeesContractId(null);
            return;
        }
        setExpandedHoldingFeesContractId(contractId);
        if (!holdingFeeSchedules[contractId]) {
            const schedule = await holdingFeeStore.getSchedule(contractId);
            if (schedule) setHoldingFeeSchedules((prev)=>({
                    ...prev,
                    [contractId]: schedule.cycles
                }));
        }
    };
    const updateHoldingFeeCycle = async (contractId, cycleNumber, status)=>{
        const updatedCycle = await holdingFeeStore.updateCycle(contractId, cycleNumber, status);
        if (!updatedCycle) return;
        setHoldingFeeSchedules((prev)=>({
                ...prev,
                [contractId]: (prev[contractId] ?? []).map((cycle)=>cycle.cycleNumber === cycleNumber ? updatedCycle : cycle)
            }));
    };
    const updateGuaranteeAmount = async (contractId, amount)=>{
        if (!commercial) return;
        const updatedContract = await performerStore.updateUsageGuaranteeAmount(contractId, amount);
        if (!updatedContract) return;
        const contracts = commercial.contracts?.map((c)=>c.id === contractId ? {
                ...c,
                usage_guarantee_amount: amount
            } : c);
        setCommercial({
            ...commercial,
            contracts: contracts
        });
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const getCommercial = async (id)=>{
            if (!projectStore.currentProject) return;
            const c = await commercialStore.getCommercial(id);
            if (c) setCommercial(c);
        };
        getCommercial(commercialId);
    // Depend on the project id, not the currentProject object itself - that object gets a
    // new reference on every enrichment/update, which would otherwise re-fetch this
    // commercial (and cascade into every row re-rendering) far more often than needed.
    }, [
        commercialId,
        projectStore.currentProject?.id
    ]);
    // Auto-open edit review modal when initialEditId is provided (from notification)
    (0, $2NacA.useEffect)(()=>{
        if (initialEditId && commercial) setShowCommercialEditReviewModal(true);
    }, [
        initialEditId,
        commercial
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (usageEstimate) {
            let wages = 0;
            let total = 0;
            for (const item of usageEstimate.items){
                wages += item.subtotal;
                total += item.subtotal_plus_fringe;
            }
            setWages(wages);
            setTotal(total);
        }
    }, [
        usageEstimate
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        round: (0, $4Oriw.borderRadiusSize),
        background: "light-1",
        animation: {
            type: 'fadeIn',
            duration: 500
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                justify: "start",
                align: "center",
                gap: "small",
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)',
                    zIndex: 1
                },
                height: {
                    max: '80px',
                    min: '80px'
                },
                pad: {
                    horizontal: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                            onChange: onChecked,
                            checked: checked,
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            textColor: "white",
                            val: commercial?.title ?? '',
                            onChange: (title)=>updateCommercial({
                                    title: title
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                color: "white",
                                children: "Type:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                                textColor: "white",
                                options: Object.values((0, $3qs6L.CommercialType)).map((t)=>({
                                        label: t,
                                        value: t
                                    })),
                                val: commercial?.type,
                                onChange: (val)=>onChangeCommercialType(val)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                style: {
                                    whiteSpace: 'nowrap'
                                },
                                color: "white",
                                children: "Duration:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "xxsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                        textColor: "white",
                                        val: commercial?.duration?.toString() ?? '',
                                        onChange: (val)=>updateCommercial({
                                                durationInSeconds: val ? parseInt(val) : 0
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        color: "white",
                                        children: "seconds"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        flex: true
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        justify: "end",
                        pad: "small",
                        gap: "large",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "xsmall",
                                justify: "end",
                                align: "center",
                                width: "",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        weight: 700,
                                        color: "white",
                                        children: "WAGES:"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        weight: "bold",
                                        color: "white",
                                        children: (0, $b1rqt.USD)(wages)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "xsmall",
                                justify: "end",
                                align: "center",
                                width: "10rem",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        weight: 700,
                                        color: "white",
                                        children: "TOTAL:"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        weight: "bold",
                                        color: "white",
                                        children: (0, $b1rqt.USD)(total)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            commercial?.last_shoot_date && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "medium",
                pad: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                },
                background: "light-3",
                border: {
                    side: 'bottom',
                    size: '1px',
                    color: 'light-4'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "dark-4",
                        children: [
                            "Last Shoot Date: ",
                            (0, $bgcVc.formatDateOnly)(commercial.last_shoot_date)
                        ]
                    }),
                    commercial.mpu_start_date && commercial.mpu_end_date && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "dark-4",
                        children: [
                            "MPU Window: ",
                            (0, $bgcVc.formatDateOnly)(commercial.mpu_start_date),
                            " \u2013",
                            ' ',
                            (0, $bgcVc.formatDateOnly)(commercial.mpu_end_date)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                animation: {
                    type: 'slideDown',
                    size: 'medium'
                },
                background: "white",
                elevation: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        justify: "between",
                        align: "center",
                        gap: "medium",
                        pad: {
                            vertical: 'xsmall',
                            horizontal: 'small'
                        },
                        background: "light-2",
                        animation: {
                            type: 'slideDown',
                            size: 'medium',
                            delay: 300
                        },
                        border: {
                            side: 'bottom',
                            size: '1px',
                            color: 'light-4'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                height: "1rem",
                                width: columnWidths[0]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[1],
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "EDIT NAME"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[2],
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "EDIT TYPE"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[3],
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "DURATION (sec)"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[4],
                                align: "center",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "PAID USAGE"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[5],
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "AD ID / ISCI"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[6]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                height: "1rem",
                                width: columnWidths[7]
                            })
                        ]
                    }),
                    (commercial?.edits ?? []).length > 0 ? commercial?.edits?.map((edit, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            children: [
                                i > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                    height: "0.5px",
                                    color: "light-3"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $h5O0B.EditRow), {
                                    edit: edit,
                                    commercial: commercial,
                                    onChecked: ()=>chooseEdit(edit.id),
                                    checked: selectedEditIds.includes(edit.id),
                                    updateEdit: (update)=>updateEdit({
                                            ...edit,
                                            ...update
                                        }),
                                    columnWidths: columnWidths
                                })
                            ]
                        }, edit.id)) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        pad: "medium",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            color: "dark-3",
                            children: [
                                "No Edits found.",
                                ' ',
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                    weight: 300,
                                    onClick: ()=>setShowAddEditModal(true),
                                    color: "accent-5",
                                    children: "Click here to create one"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        align: "center",
                        justify: "between",
                        gap: "medium",
                        pad: {
                            vertical: 'xsmall',
                            horizontal: 'small'
                        },
                        background: "light-2",
                        border: {
                            side: 'bottom',
                            size: '1px',
                            color: 'light-4'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                children: "CAST"
                            }),
                            guaranteeRollup.performersOverGuarantee > 0 && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                color: "status-critical",
                                weight: "bold",
                                children: [
                                    guaranteeRollup.performersOverGuarantee,
                                    " performer",
                                    guaranteeRollup.performersOverGuarantee > 1 ? 's' : '',
                                    " over usage guarantee (",
                                    (0, $b1rqt.USD)(guaranteeRollup.totalOverage),
                                    " total)"
                                ]
                            })
                        ]
                    }),
                    (commercial?.contracts ?? []).length > 0 ? commercial?.contracts?.map((contract, i)=>{
                        const consumed = getUsageConsumedForRole(contract.role?.id);
                        const guarantee = contract.usage_guarantee_amount;
                        const overage = guarantee ? consumed - guarantee : 0;
                        return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            children: [
                                i > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                    height: "0.5px",
                                    color: "light-3"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    align: "center",
                                    gap: "medium",
                                    pad: {
                                        vertical: 'xsmall',
                                        horizontal: 'small'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            width: columnWidths[1],
                                            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $j0B9N.Anchor), {
                                                size: "small",
                                                onClick: ()=>navigate(`/performers/${contract.performer?.id}`),
                                                children: [
                                                    contract.performer?.first_name,
                                                    " ",
                                                    contract.performer?.last_name
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            width: columnWidths[2],
                                            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                size: "small",
                                                color: "dark-3",
                                                children: [
                                                    contract.role?.name,
                                                    contract.role?.performer_type ? ` (${contract.role.performer_type})` : ''
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "row",
                                            gap: "xsmall",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    size: "small",
                                                    children: "Usage Guarantee:"
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                                    val: guarantee?.toString() ?? '',
                                                    onChange: (val)=>updateGuaranteeAmount(contract.id, val ? parseFloat(val) : 0),
                                                    minValue: 0
                                                })
                                            ]
                                        }),
                                        guarantee ? overage > 0 ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                            size: "small",
                                            color: "status-critical",
                                            weight: "bold",
                                            children: [
                                                (0, $b1rqt.USD)(overage),
                                                " OVER guarantee"
                                            ]
                                        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                            size: "small",
                                            color: "dark-3",
                                            children: [
                                                (0, $b1rqt.USD)(Math.abs(overage)),
                                                " remaining of guarantee"
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            flex: true
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                            size: "small",
                                            onClick: ()=>toggleHoldingFeeSchedule(contract.id),
                                            children: "Holding Fees"
                                        })
                                    ]
                                }),
                                expandedHoldingFeesContractId === contract.id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    pad: {
                                        vertical: 'xsmall',
                                        horizontal: 'medium'
                                    },
                                    background: "light-1",
                                    gap: "xxsmall",
                                    border: {
                                        side: 'top',
                                        size: '1px',
                                        color: 'light-4'
                                    },
                                    children: (holdingFeeSchedules[contract.id] ?? []).map((cycle)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "row",
                                            align: "center",
                                            gap: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                    width: "80px",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                        size: "xsmall",
                                                        children: [
                                                            "Cycle ",
                                                            cycle.cycleNumber
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                    width: "120px",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                        size: "xsmall",
                                                        children: (0, $bgcVc.formatDateOnly)(cycle.dueDate)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                    width: "80px",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                        size: "xsmall",
                                                        weight: "bold",
                                                        color: cycle.status === 'Overdue' ? 'status-critical' : cycle.status === 'Paid' ? 'status-ok' : 'dark-3',
                                                        children: cycle.status
                                                    })
                                                }),
                                                (cycle.status === 'Due' || cycle.status === 'Overdue') && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                    direction: "row",
                                                    gap: "xsmall",
                                                    children: [
                                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                                            size: "xsmall",
                                                            onClick: ()=>updateHoldingFeeCycle(contract.id, cycle.cycleNumber, (0, $7nm6N.HoldingFeeCycleStatus).PAID),
                                                            children: "Mark Paid"
                                                        }),
                                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                                            size: "xsmall",
                                                            onClick: ()=>updateHoldingFeeCycle(contract.id, cycle.cycleNumber, (0, $7nm6N.HoldingFeeCycleStatus).WAIVED),
                                                            children: "Waive"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, cycle.cycleNumber))
                                })
                            ]
                        }, contract.id);
                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        pad: "medium",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            color: "dark-3",
                            children: "No cast assigned to this commercial yet."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hIlrL.CardFooter), {
                justify: "end",
                gap: "small",
                background: "light-2",
                pad: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        pad: "none",
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Add Edit Data"
                            }),
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5HonF.Cut), {})
                        }),
                        onClick: ()=>setShowAddEditModal(true)
                    }),
                    commercial && commercial.edits && commercial.edits.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hAOlB.Inspect), {}),
                        size: "small",
                        label: "Edit Reviews",
                        onClick: ()=>setShowCommercialEditReviewModal(true),
                        tip: "View and manage edit reviews for all edits"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                        onClick: ()=>deleteEdits(),
                        name: "the selected Edits",
                        disabled: !selectedEditIds.length,
                        tip: {
                            content: 'Remove Selected Edits',
                            dropProps: {
                                background: 'light-1',
                                round: (0, $4Oriw.borderRadiusSize),
                                pad: 'small',
                                margin: 'small',
                                border: {
                                    size: '1px',
                                    color: 'light-4'
                                }
                            },
                            plain: true
                        }
                    })
                ]
            }),
            commercial && showCommercialEditReviewModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lpy8P.CommercialEditReviewModal), {
                commercial: commercial,
                setShowCommercialEditReviewModal: setShowCommercialEditReviewModal,
                initialEditId: initialEditId
            }),
            commercial && showAddEditModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $drlit.CreateEditModal), {
                commercial: commercial,
                addEdit: addEdit,
                setShowModal: setShowAddEditModal
            }),
            pendingTypeChange && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3W9FZ.ConfirmModal), {
                content: "Warning: changing the Commercial type will reset all existing Usages. Continue?",
                onConfirm: ()=>onConfirmCommercialType(pendingTypeChange),
                onCancel: ()=>setPendingTypeChange(undefined)
            })
        ]
    });
});

});
parcelRegister("5HonF", function(module, exports) {

$parcel$export(module.exports, "Cut", () => $4263e167d4d88804$export$e5934e6b116b2ede);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $4263e167d4d88804$var$_extends() {
    return $4263e167d4d88804$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4263e167d4d88804$var$_extends.apply(null, arguments);
}
var $4263e167d4d88804$export$e5934e6b116b2ede = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $4263e167d4d88804$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cut"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 4 8 16 23 4zm0 16L8 8l15 12zM5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    }));
});
$4263e167d4d88804$export$e5934e6b116b2ede.displayName = 'Cut';

});

parcelRegister("hAOlB", function(module, exports) {

$parcel$export(module.exports, "Inspect", () => $ccecda6f399f3def$export$d1a121333e17a5bb);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $ccecda6f399f3def$var$_extends() {
    return $ccecda6f399f3def$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ccecda6f399f3def$var$_extends.apply(null, arguments);
}
var $ccecda6f399f3def$export$d1a121333e17a5bb = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $ccecda6f399f3def$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Inspect"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5.5 21a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM1 16V6.5A4.5 4.5 0 0 1 5.5 2H6m17 14V6.5A4.5 4.5 0 0 0 18.5 2H18m.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM10 17s0-2 2-2 2 2 2 2"
    }));
});
$ccecda6f399f3def$export$d1a121333e17a5bb.displayName = 'Inspect';

});

parcelRegister("drlit", function(module, exports) {

$parcel$export(module.exports, "CreateEditModal", () => $61fbf926f0dfeca2$export$d705175c71dbff35);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $w4qgw = parcelRequire("w4qgw");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $az33k = parcelRequire("az33k");
const $61fbf926f0dfeca2$export$d705175c71dbff35 = (0, $j8yBr.observer)(({ commercial: commercial, addEdit: addEdit, setShowModal: setShowModal })=>{
    const [type, setType] = (0, $2NacA.useState)();
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $az33k.ModalCard), {
        onClose: ()=>setShowModal(false),
        title: "Add Edit",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            gap: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    gap: "small",
                    pad: "small",
                    justify: "center",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Edit Type:"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                value: type,
                                options: Object.values((0, $w4qgw.EditType)),
                                onChange: ({ value: value })=>setType(value),
                                placeholder: "Select Edit Type"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    justify: "end",
                    align: "center",
                    margin: {
                        vertical: 'small'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        primary: true,
                        label: "Add Edit",
                        disabled: !type,
                        onClick: ()=>type ? addEdit(commercial.id, type) : {}
                    })
                })
            ]
        })
    });
});

});

parcelRegister("h5O0B", function(module, exports) {

$parcel$export(module.exports, "EditRow", () => $4fa22e00eb5a3789$export$4e224c12f7a051d7);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $asThd = parcelRequire("asThd");
var $w4qgw = parcelRequire("w4qgw");
parcelRequire("bRT7J");
var $3npYU = parcelRequire("3npYU");
var $aYiXW = parcelRequire("aYiXW");
var $9OMpO = parcelRequire("9OMpO");
var $5avy4 = parcelRequire("5avy4");

var $8DltC = parcelRequire("8DltC");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $gpKeH = parcelRequire("gpKeH");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");
var $hAOlB = parcelRequire("hAOlB");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $4Oriw = parcelRequire("4Oriw");
parcelRequire("ibR9R");
var $1Ofsp = parcelRequire("1Ofsp");
var $bIzid = parcelRequire("bIzid");
const $4fa22e00eb5a3789$export$4e224c12f7a051d7 = (0, $j8yBr.observer)(({ commercial: commercial, edit: edit, onChecked: onChecked, checked: checked, updateEdit: updateEdit, columnWidths: columnWidths = [] })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ const [showModal, setShowModal] = (0, $2NacA.useState)(false);
    const [showAssetSelector, setShowAssetSelector] = (0, $2NacA.useState)(false);
    const [showEditReviewModal, setShowEditReviewModal] = (0, $2NacA.useState)(false);
    const [videoUrl, setVideoUrl] = (0, $2NacA.useState)(null);
    const [selectedAssetId, setSelectedAssetId] = (0, $2NacA.useState)(edit.asset_id || undefined);
    const [, setAssetThumbnails] = (0, $2NacA.useState)(new Map());
    /** Computed **/ const videoAssets = (0, $2NacA.useMemo)(()=>(projectStore.currentProject?.assets || []).filter((asset)=>asset.type === (0, $asThd.AssetType).Video), [
        projectStore.currentProject?.assets
    ]);
    /** Refs **/ // CommercialEditRow passes a brand-new updateEdit closure on every one of its
    // re-renders. Reading it via ref (instead of putting it in the effect below's
    // dependency array) means an unrelated parent re-render doesn't re-trigger the
    // signed-URL fetch for every edit's asset.
    const updateEditRef = (0, $2NacA.useRef)(updateEdit);
    (0, $2NacA.useEffect)(()=>{
        updateEditRef.current = updateEdit;
    }, [
        updateEdit
    ]);
    /** Methods **/ const handleAssetSelect = async (asset)=>{
        setSelectedAssetId(asset.id);
        const url = await projectStore.getSignedAssetUrl(asset.id);
        setVideoUrl(url || null);
        await updateEdit({
            asset_id: asset.id
        });
        setShowAssetSelector(false);
    };
    const handleClearAsset = async ()=>{
        setSelectedAssetId(undefined);
        setVideoUrl(null);
        await updateEdit({
            asset_id: undefined
        });
    };
    /** Effects **/ // Get video URL from asset when component mounts or asset changes
    (0, $2NacA.useEffect)(()=>{
        const loadVideoUrl = async ()=>{
            if (edit.asset_id) {
                // Only proceed if this edit belongs to the current project
                const editBelongsToCurrentProject = edit.project_id === projectStore.currentProject?.id;
                if (!editBelongsToCurrentProject) // Don't do anything if the edit doesn't belong to current project (e.g., during project switch)
                return;
                // Only check if asset exists if we have assets loaded (not empty array from project change)
                // If project has assets and our asset isn't in the list, it was deleted
                const hasAssetsLoaded = projectStore.currentProject?.assets && projectStore.currentProject.assets.length > 0;
                const assetExists = videoAssets.some((asset)=>asset.id === edit.asset_id);
                if (hasAssetsLoaded && !assetExists) {
                    // Asset was deleted, clear the reference silently
                    console.log('Asset no longer exists, clearing reference');
                    setVideoUrl(null);
                    setSelectedAssetId(undefined);
                    await updateEditRef.current({
                        asset_id: undefined
                    });
                    return;
                }
                // If assets haven't loaded yet, skip loading the URL (will retry when assets load)
                if (!hasAssetsLoaded) return;
                try {
                    const url = await projectStore.getSignedAssetUrl(edit.asset_id);
                    setVideoUrl(url || null);
                } catch (error) {
                    console.error('Error loading asset URL (asset may have been deleted):', error);
                    setVideoUrl(null);
                    setSelectedAssetId(undefined);
                    // Clear the stale asset_id reference
                    await updateEditRef.current({
                        asset_id: undefined
                    });
                }
            } else setVideoUrl(null);
        };
        loadVideoUrl();
    // updateEdit deliberately excluded - see updateEditRef above.
    }, [
        edit.asset_id,
        projectStore,
        videoAssets
    ]);
    // Load thumbnails for video assets when selector opens
    (0, $2NacA.useEffect)(()=>{
        if (showAssetSelector && videoAssets.length > 0) {
            const loadThumbnails = async ()=>{
                const thumbnailMap = new Map();
                for (const asset of videoAssets)if (asset.thumbnail_path) {
                    const url = await projectStore.getAssetThumbnailUrl(asset.id);
                    if (url) thumbnailMap.set(asset.id, url);
                }
                setAssetThumbnails(thumbnailMap);
            };
            loadThumbnails();
        }
    }, [
        showAssetSelector,
        projectStore,
        videoAssets
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                justify: "between",
                align: "center",
                gap: "medium",
                pad: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[0],
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                            onChange: onChecked,
                            checked: checked,
                            disabled: edit.type === (0, $w4qgw.EditType).MainAsset,
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[1],
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: edit.title || '',
                            onChange: (val)=>updateEdit({
                                    title: val
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[2],
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            value: edit.type,
                            onChange: ({ value: value })=>updateEdit({
                                    type: value
                                }),
                            options: Object.values((0, $w4qgw.EditType))
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[3],
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                            val: edit.duration,
                            inputType: "number",
                            placeholder: "Duration",
                            onChange: (val)=>{
                                const n = parseInt(val, 10);
                                if (!Number.isNaN(n)) updateEdit({
                                    duration: n
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[4],
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                            checked: edit.is_paid,
                            onChange: (e)=>updateEdit({
                                    is_paid: e.target.checked
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[5],
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                            val: edit.ad_id || '',
                            placeholder: "AdId/ISCI",
                            onChange: (val)=>updateEdit({
                                    ad_id: val
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[6],
                        direction: "row",
                        gap: "small",
                        align: "center",
                        justify: "center",
                        children: videoUrl ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            style: {
                                position: 'relative'
                            },
                            width: "200px",
                            height: "112px",
                            direction: "row",
                            align: "center",
                            justify: "center",
                            round: (0, $4Oriw.borderRadiusSize),
                            background: "black",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9OMpO.TalonVideoPlayer), {
                                    url: videoUrl,
                                    height: "112px",
                                    thumbnailOnly: true,
                                    controls: false,
                                    onThumbnailClick: ()=>setShowModal(true),
                                    onClearAsset: handleClearAsset,
                                    onError: (error)=>{
                                        console.error('Video player error:', error);
                                    }
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                        size: "10px",
                                        color: "white"
                                    }),
                                    onClick: handleClearAsset,
                                    style: {
                                        position: 'absolute',
                                        top: '10px',
                                        right: '5px',
                                        minWidth: 'auto',
                                        minHeight: 'auto',
                                        borderRadius: '100%',
                                        padding: '2px',
                                        border: '1px solid white',
                                        zIndex: 10
                                    },
                                    pad: "2px",
                                    plain: false,
                                    size: "small",
                                    tip: "Remove asset"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            onClick: ()=>setShowAssetSelector(true),
                            plain: true,
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                margin: "none",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    style: {
                                        position: 'relative'
                                    },
                                    width: "200px",
                                    height: "111px",
                                    direction: "row",
                                    align: "center",
                                    justify: "center",
                                    round: (0, $4Oriw.borderRadiusSize),
                                    background: "light-1",
                                    border: {
                                        size: '2px',
                                        style: 'dashed',
                                        color: 'light-4'
                                    },
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        color: "dark-3",
                                        children: "Select Asset"
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: columnWidths[7],
                        direction: "row",
                        justify: "end",
                        align: "center",
                        gap: "small",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hAOlB.Inspect), {}),
                            hoverIndicator: true,
                            tip: {
                                content: 'Edit Reviews',
                                dropProps: (0, $4Oriw.tooltipProps),
                                plain: true
                            },
                            onClick: ()=>setShowEditReviewModal(true)
                        })
                    })
                ]
            }),
            showModal && videoUrl && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5avy4.WatchVideoModal), {
                commercial: commercial,
                edit: edit,
                videoUrl: videoUrl,
                setShowModal: setShowModal
            }),
            showEditReviewModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aYiXW.EditReviewModal), {
                commercial: commercial,
                edit: edit,
                setShowEditReviewModal: setShowEditReviewModal
            }),
            showAssetSelector && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3npYU.AssetSelectorModal), {
                setShowModal: setShowAssetSelector,
                selectedAssetId: selectedAssetId,
                handleAssetSelect: handleAssetSelect
            })
        ]
    });
});

});


parcelRegister("4CYCG", function(module, exports) {
$parcel$export(module.exports, "EditReviewModal", () => (parcelRequire("aYiXW")).EditReviewModal);
parcelRequire("aYiXW");

});

parcelRegister("9nbE2", function(module, exports) {

$parcel$export(module.exports, "EditsHeader", () => $1cfec802522f15cc$export$86edc720b4681e4a);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $bDFk2 = parcelRequire("bDFk2");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $8DltC = parcelRequire("8DltC");

var $1G16z = parcelRequire("1G16z");

var $jGT7M = parcelRequire("jGT7M");

var $lFfFS = parcelRequire("lFfFS");
const $1cfec802522f15cc$export$86edc720b4681e4a = (0, $j8yBr.observer)(({ onCreateCommercial: onCreateCommercial, onDeleteCommercials: onDeleteCommercials, hasSelectedCommercials: hasSelectedCommercials, height: height = '92px' })=>{
    /** Context **/ const commercialStore = (0, $8DltC.useCommercialStore)();
    /** Computed **/ const saveStatus = commercialStore.isSaving ? (0, $lFfFS.SaveStatus).Saving : (0, $lFfFS.SaveStatus).Saved;
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        background: "light-3",
        flex: "grow",
        direction: "row",
        align: "center",
        justify: "between",
        height: {
            min: height,
            max: height
        },
        gap: "medium",
        style: {
            zIndex: 1
        },
        elevation: "small",
        pad: {
            right: 'medium'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                gap: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        margin: {
                            left: 'medium'
                        },
                        animation: (0, $1G16z.getAnimProps)(0, 'slideUp'),
                        justify: "start",
                        direction: "row",
                        pad: {
                            right: 'none'
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            truncate: true,
                            size: "xlarge",
                            children: "Commercial Edits"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                        height: "2px",
                        animation: {
                            type: 'slideRight',
                            size: 'xlarge'
                        }
                    }),
                    saveStatus && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "end",
                        animation: (0, $1G16z.getAnimProps)(0, 'slideDown'),
                        pad: {
                            right: 'none'
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lFfFS.SaveStatusIndicator), {
                            saveStatus: saveStatus,
                            boxProps: {
                                margin: 'none'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                animation: {
                    type: 'slideLeft',
                    size: 'large',
                    duration: 500
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        onClick: onCreateCommercial,
                        style: {
                            fontSize: '0.9rem',
                            fontWeight: 500
                        },
                        primary: true,
                        label: "New Commercial"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        onClick: onDeleteCommercials,
                        tip: "Delete Selected Commercials",
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                            color: "red"
                        }),
                        disabled: !hasSelectedCommercials
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("lFfFS", function(module, exports) {

$parcel$export(module.exports, "SaveStatus", () => $a6e8af0ba0f952cd$export$90442033ec981c61);
$parcel$export(module.exports, "SaveStatusIndicator", () => $a6e8af0ba0f952cd$export$81a8811ecf7a4222);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbInV = parcelRequire("kbInV");
var $hRbKn = parcelRequire("hRbKn");
var $kjGz8 = parcelRequire("kjGz8");

var $5cDu3 = parcelRequire("5cDu3");
var $a6e8af0ba0f952cd$export$90442033ec981c61 = /*#__PURE__*/ function(SaveStatus) {
    SaveStatus["Saving"] = "saving";
    SaveStatus["Unsaved"] = "unsaved";
    SaveStatus["Saved"] = "saved";
    SaveStatus["Error"] = "error";
    return SaveStatus;
}({});
const $a6e8af0ba0f952cd$export$81a8811ecf7a4222 = ({ saveStatus: saveStatus, boxProps: boxProps })=>{
    if (!saveStatus) return null;
    const Container = ({ children: children })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            direction: "row",
            gap: "xsmall",
            align: "center",
            margin: {
                left: 'medium'
            },
            ...boxProps,
            children: children
        });
    switch(saveStatus){
        case "saved":
            return /*#__PURE__*/ (0, $6ir3O.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hRbKn.Checkmark), {
                        size: "10px",
                        color: "status-ok"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "status-ok",
                        weight: 500,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)("i", {
                            children: "All changes saved"
                        })
                    })
                ]
            });
        case "error":
            return /*#__PURE__*/ (0, $6ir3O.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbInV.Alert), {
                        size: "10px",
                        color: "status-error"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "status-error",
                        weight: 500,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)("i", {
                            children: "Error saving changes"
                        })
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5cDu3.Blink), {
                speed: 750,
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)(Container, {
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            animation: {
                                type: 'rotateRight',
                                size: 'small'
                            },
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kjGz8.Update), {
                                size: "10px",
                                color: "brand"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "xsmall",
                            color: "brand",
                            weight: 500,
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)("i", {
                                children: "Saving changes..."
                            })
                        })
                    ]
                })
            });
    }
};

});


parcelRegister("24vti", function(module, exports) {

$parcel$export(module.exports, "EditsPanel", () => $913a7859bb29a0dc$export$c8bc6c5815ba385b);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $kqZxg = parcelRequire("kqZxg");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $1BLyu = parcelRequire("1BLyu");
const $913a7859bb29a0dc$export$c8bc6c5815ba385b = (0, $j8yBr.observer)(({ commercials: commercials, selected: selected, setSelected: setSelected, commercialId: commercialId, editId: editId })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** Methods **/ const chooseCommercial = (id)=>{
        if (selected.includes(id)) setSelected(selected.filter((s)=>s !== id));
        else setSelected([
            ...selected,
            id
        ]);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        pad: "medium",
        gap: "medium",
        background: "light-1",
        overflow: {
            vertical: 'scroll'
        },
        flex: "grow",
        children: projectStore.currentProject ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            gap: "medium",
            children: commercials.map((commercial)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $1BLyu.CommercialEditRow), {
                    commercialId: commercial.id,
                    onChecked: ()=>chooseCommercial(commercial.id),
                    checked: selected.includes(commercial.id),
                    initialEditId: commercial.id === commercialId ? editId : undefined
                }, commercial.id))
        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            fill: true,
            align: "center",
            justify: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                size: "large"
            })
        })
    });
});

});

parcelRegister("kDwcB", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");
const $4afc348d713faab1$export$c25acd513dcc8062 = ({ icon: icon, onClick: onClick, color: color = 'brand', pad: pad = 'small', text: text, textProps: textProps })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                onClick: onClick,
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    pad: pad,
                    children: icon
                }),
                plain: false,
                style: {
                    borderRadius: '50%',
                    borderWidth: '4px',
                    borderColor: color
                }
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                ...textProps,
                children: text
            })
        ]
    });
};

});

parcelRegister("5avy4", function(module, exports) {

$parcel$export(module.exports, "WatchVideoModal", () => $47f2c6369ab1cde1$export$4c757ecee8702111);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $4Oriw = parcelRequire("4Oriw");

var $jGT7M = parcelRequire("jGT7M");

var $9OMpO = parcelRequire("9OMpO");
const $47f2c6369ab1cde1$export$4c757ecee8702111 = (0, $j8yBr.observer)(({ commercial: commercial, edit: edit, videoUrl: videoUrl, setShowModal: setShowModal })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowModal(false),
        onClickOutside: ()=>setShowModal(false),
        position: "center",
        modal: true,
        margin: "large",
        background: "none",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            width: "888px",
            background: "black",
            round: (0, $4Oriw.borderRadiusSize),
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    justify: "between",
                    align: "center",
                    pad: {
                        vertical: 'xsmall',
                        horizontal: 'small'
                    },
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            weight: 600,
                            children: [
                                commercial.title,
                                " - ",
                                edit.title
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {}),
                            onClick: ()=>setShowModal(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                    height: "1px"
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    height: "500px",
                    justify: "center",
                    overflow: "auto",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9OMpO.TalonVideoPlayer), {
                        url: videoUrl,
                        controls: true
                    })
                })
            ]
        })
    });
});

});
parcelRegister("9OMpO", function(module, exports) {

$parcel$export(module.exports, "TalonVideoPlayer", () => $87133632024567f3$export$df01edca186c6eed);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $1h240 = parcelRequire("1h240");

var $6vxHY = parcelRequire("6vxHY");

var $2NacA = parcelRequire("2NacA");

var $ba6m4 = parcelRequire("ba6m4");

var $4Oriw = parcelRequire("4Oriw");
const $87133632024567f3$export$df01edca186c6eed = ({ url: url, preview: preview = false, controls: controls = true, width: width, height: height, thumbnailOnly: thumbnailOnly = false, onThumbnailClick: onThumbnailClick, onError: onError })=>{
    /** Computed **/ const videoPlayer = (0, $2NacA.useMemo)(()=>{
        if (!url) return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {});
        else if (url.startsWith('https://drive.google.com/')) {
            const videoId = url.split('/d/')[1]?.split('/')[0];
            if (!videoId) {
                onError && onError(new Error('Invalid Google Drive URL'));
                return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {});
            }
            const googleDriveUrl = `https://drive.google.com/file/d/${videoId}/preview`;
            return /*#__PURE__*/ (0, $6ir3O.jsx)("iframe", {
                src: googleDriveUrl,
                width: width || '100%',
                height: height || '100%',
                allow: "autoplay",
                title: "Google Drive Video Player"
            });
        } else if ((0, $ba6m4.default).canPlay && (0, $ba6m4.default).canPlay(url)) return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $ba6m4.default), {
            src: url,
            controls: controls,
            width: width || '100%',
            height: height || '100%',
            light: preview,
            style: {
                maxHeight: '500px',
                maxWidth: '100%',
                borderBottomLeftRadius: (0, $4Oriw.borderRadiusSize),
                borderBottomRightRadius: (0, $4Oriw.borderRadiusSize)
            }
        });
        else {
            onError && onError(new Error('Unsupported video format'));
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {});
        }
    }, [
        url,
        onError,
        width,
        height,
        (0, $ba6m4.default).canPlay,
        controls,
        preview
    ]);
    /** Render **/ const VideoPlayerContainer = ({ children: children })=>thumbnailOnly ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1h240.Stack), {
            children: [
                children,
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    align: "center",
                    justify: "center",
                    fill: true,
                    onClick: onThumbnailClick,
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6vxHY.CirclePlay), {
                        size: "large",
                        color: "white"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            fill: true,
            style: {
                cursor: 'pointer'
            },
            children: children
        });
    return /*#__PURE__*/ (0, $6ir3O.jsx)(VideoPlayerContainer, {
        children: videoPlayer
    });
};

});
parcelRegister("6vxHY", function(module, exports) {

$parcel$export(module.exports, "CirclePlay", () => $4bcfc91456bc89fd$export$e9ed5a053e329c6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $4bcfc91456bc89fd$var$_extends() {
    return $4bcfc91456bc89fd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4bcfc91456bc89fd$var$_extends.apply(null, arguments);
}
var $4bcfc91456bc89fd$export$e9ed5a053e329c6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $4bcfc91456bc89fd$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CirclePlay"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-2.5-6.5 6-3.5-6-3.5v7zm1-2 2-1.5-2-1.5v3z"
    }));
});
$4bcfc91456bc89fd$export$e9ed5a053e329c6.displayName = 'CirclePlay';

});

parcelRegister("ba6m4", function(module, exports) {

$parcel$export(module.exports, "default", () => $82058ed8cddeb73c$export$2e2bcd8739ae039);

var $hievM = parcelRequire("hievM");

var $3MYHU = parcelRequire("3MYHU");
"use client";
const $82058ed8cddeb73c$var$fallback = (0, $hievM.default)[(0, $hievM.default).length - 1];
var $82058ed8cddeb73c$export$2e2bcd8739ae039 = (0, $3MYHU.createReactPlayer)((0, $hievM.default), $82058ed8cddeb73c$var$fallback);

});
parcelRegister("hievM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c96f5fcae23bf109$export$2e2bcd8739ae039);

var $2NacA = parcelRequire("2NacA");

var $bwSug = parcelRequire("bwSug");

var $cYNrQ = parcelRequire("cYNrQ");









const $c96f5fcae23bf109$var$Players = [
    {
        key: "hls",
        name: "hls.js",
        canPlay: (0, $bwSug.canPlay).hls,
        canEnablePIP: ()=>true,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("empNI")))
    },
    {
        key: "dash",
        name: "dash.js",
        canPlay: (0, $bwSug.canPlay).dash,
        canEnablePIP: ()=>true,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("elPAx")))
    },
    {
        key: "mux",
        name: "Mux",
        canPlay: (0, $bwSug.canPlay).mux,
        canEnablePIP: ()=>true,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("dKHUl")))
    },
    {
        key: "youtube",
        name: "YouTube",
        canPlay: (0, $bwSug.canPlay).youtube,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("2oOOI")))
    },
    {
        key: "vimeo",
        name: "Vimeo",
        canPlay: (0, $bwSug.canPlay).vimeo,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("4hBSl")))
    },
    {
        key: "wistia",
        name: "Wistia",
        canPlay: (0, $bwSug.canPlay).wistia,
        canEnablePIP: ()=>true,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("8lSsX")))
    },
    {
        key: "spotify",
        name: "Spotify",
        canPlay: (0, $bwSug.canPlay).spotify,
        canEnablePIP: ()=>false,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("E0lYa")))
    },
    {
        key: "twitch",
        name: "Twitch",
        canPlay: (0, $bwSug.canPlay).twitch,
        canEnablePIP: ()=>false,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("1Bvb1")))
    },
    {
        key: "tiktok",
        name: "TikTok",
        canPlay: (0, $bwSug.canPlay).tiktok,
        canEnablePIP: ()=>false,
        player: (0, $2NacA.lazy)(()=>(parcelRequire("kdp68")))
    },
    {
        key: "html",
        name: "html",
        canPlay: (0, $bwSug.canPlay).html,
        canEnablePIP: ()=>true,
        player: (0, $cYNrQ.default)
    }
];
var $c96f5fcae23bf109$export$2e2bcd8739ae039 = $c96f5fcae23bf109$var$Players;

});
parcelRegister("bwSug", function(module, exports) {

$parcel$export(module.exports, "AUDIO_EXTENSIONS", () => $864cf2e58759abbb$export$6e358387921d60a6);
$parcel$export(module.exports, "canPlay", () => $864cf2e58759abbb$export$c7d09d8f85cc72b1);
const $864cf2e58759abbb$export$6e358387921d60a6 = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
const $864cf2e58759abbb$export$2c10378b315a7748 = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const $864cf2e58759abbb$export$fcba1fce9bdb9c25 = /\.(m3u8)($|\?)/i;
const $864cf2e58759abbb$export$ba36f95fcc83bfe5 = /\.(mpd)($|\?)/i;
const $864cf2e58759abbb$export$63a8d940db35e4c8 = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/;
const $864cf2e58759abbb$export$dfd68ef91bd9b8bb = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
const $864cf2e58759abbb$export$157386debc6eef42 = /vimeo\.com\/(?!progressive_redirect).+/;
const $864cf2e58759abbb$export$20956fa5b62ae38f = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
const $864cf2e58759abbb$export$13fb710261aae01a = /open\.spotify\.com\/(\w+)\/(\w+)/i;
const $864cf2e58759abbb$export$64a0155d0e01ce3b = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+|(videos?\/|\?video=)\d+)($|\?)/;
const $864cf2e58759abbb$export$70eca298bed94dce = /tiktok\.com\/(?:player\/v1\/|share\/video\/|@[^/]+\/video\/)([0-9]+)/;
const $864cf2e58759abbb$var$canPlayFile = (url, test)=>{
    if (Array.isArray(url)) {
        for (const item of url){
            if (typeof item === "string" && $864cf2e58759abbb$var$canPlayFile(item, test)) return true;
            if ($864cf2e58759abbb$var$canPlayFile(item.src, test)) return true;
        }
        return false;
    }
    return test(url);
};
const $864cf2e58759abbb$export$c7d09d8f85cc72b1 = {
    html: (url)=>$864cf2e58759abbb$var$canPlayFile(url, (u)=>$864cf2e58759abbb$export$6e358387921d60a6.test(u) || $864cf2e58759abbb$export$2c10378b315a7748.test(u)),
    hls: (url)=>$864cf2e58759abbb$var$canPlayFile(url, (u)=>$864cf2e58759abbb$export$fcba1fce9bdb9c25.test(u)),
    dash: (url)=>$864cf2e58759abbb$var$canPlayFile(url, (u)=>$864cf2e58759abbb$export$ba36f95fcc83bfe5.test(u)),
    mux: (url)=>$864cf2e58759abbb$export$63a8d940db35e4c8.test(url),
    youtube: (url)=>$864cf2e58759abbb$export$dfd68ef91bd9b8bb.test(url),
    vimeo: (url)=>$864cf2e58759abbb$export$157386debc6eef42.test(url) && !$864cf2e58759abbb$export$2c10378b315a7748.test(url) && !$864cf2e58759abbb$export$fcba1fce9bdb9c25.test(url),
    wistia: (url)=>$864cf2e58759abbb$export$20956fa5b62ae38f.test(url),
    spotify: (url)=>$864cf2e58759abbb$export$13fb710261aae01a.test(url),
    twitch: (url)=>$864cf2e58759abbb$export$64a0155d0e01ce3b.test(url),
    tiktok: (url)=>$864cf2e58759abbb$export$70eca298bed94dce.test(url)
};

});

parcelRegister("cYNrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $97317202cc25b9ae$export$2e2bcd8739ae039);

var $2NacA = parcelRequire("2NacA");

var $bwSug = parcelRequire("bwSug");
const $97317202cc25b9ae$var$HtmlPlayer = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).forwardRef((props, ref)=>{
    const Media = (0, $bwSug.AUDIO_EXTENSIONS).test(`${props.src}`) ? "audio" : "video";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(Media, {
        ...props,
        ref: ref
    }, props.children);
});
var $97317202cc25b9ae$export$2e2bcd8739ae039 = $97317202cc25b9ae$var$HtmlPlayer;

});

parcelRegister("empNI", function(module, exports) {
module.exports = Promise.all([
    import("fnWVu"),
    import("dQtzo")
]).then(()=>parcelRequire('hRYtO'));

});

parcelRegister("elPAx", function(module, exports) {
module.exports = Promise.all([
    import("fnWVu"),
    import("drs0p")
]).then(()=>parcelRequire('nsua5'));

});

parcelRegister("dKHUl", function(module, exports) {
module.exports = Promise.all([
    import("fnWVu"),
    import("3gb9s")
]).then(()=>parcelRequire('5b08w'));

});

parcelRegister("2oOOI", function(module, exports) {
module.exports = import("82Sf7").then(()=>parcelRequire('aplk0'));

});

parcelRegister("4hBSl", function(module, exports) {
module.exports = import("jGsJl").then(()=>parcelRequire('dBPHy'));

});

parcelRegister("8lSsX", function(module, exports) {
module.exports = import("h9d4i").then(()=>parcelRequire('khLnT'));

});

parcelRegister("E0lYa", function(module, exports) {
module.exports = import("bc2FZ").then(()=>parcelRequire('fa9fA'));

});

parcelRegister("1Bvb1", function(module, exports) {
module.exports = import("7sYb5").then(()=>parcelRequire('dt6d8'));

});

parcelRegister("kdp68", function(module, exports) {
module.exports = import("evz5h").then(()=>parcelRequire('9mMc4'));

});


parcelRegister("3MYHU", function(module, exports) {

$parcel$export(module.exports, "createReactPlayer", () => $2c24f1fac9322d80$export$f8bc1e576df9c251);

var $2NacA = parcelRequire("2NacA");

var $brgEg = parcelRequire("brgEg");

var $hMp5l = parcelRequire("hMp5l");

const $2c24f1fac9322d80$var$Preview = (0, $2NacA.lazy)(()=>(parcelRequire("2fcwM")));
const $2c24f1fac9322d80$var$customPlayers = [];
const $2c24f1fac9322d80$export$f8bc1e576df9c251 = (players, playerFallback)=>{
    const getActivePlayer = (src)=>{
        for (const player of [
            ...$2c24f1fac9322d80$var$customPlayers,
            ...players
        ]){
            if (src && player.canPlay(src)) return player;
        }
        if (playerFallback) return playerFallback;
        return null;
    };
    const ReactPlayer = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).forwardRef((_props, ref)=>{
        const props = {
            ...(0, $brgEg.defaultProps),
            ..._props
        };
        const { src: src, slot: slot, className: className, style: style, width: width, height: height, fallback: fallback, wrapper: wrapper } = props;
        const [showPreview, setShowPreview] = (0, $2NacA.useState)(!!props.light);
        (0, $2NacA.useEffect)(()=>{
            if (props.light) setShowPreview(true);
            else setShowPreview(false);
        }, [
            props.light
        ]);
        const handleClickPreview = (e)=>{
            var _a;
            setShowPreview(false);
            (_a = props.onClickPreview) == null || _a.call(props, e);
        };
        const renderPreview = (src2)=>{
            if (!src2) return null;
            const { light: light, playIcon: playIcon, previewTabIndex: previewTabIndex, oEmbedUrl: oEmbedUrl, previewAriaLabel: previewAriaLabel } = props;
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($2c24f1fac9322d80$var$Preview, {
                src: src2,
                light: light,
                playIcon: playIcon,
                previewTabIndex: previewTabIndex,
                previewAriaLabel: previewAriaLabel,
                oEmbedUrl: oEmbedUrl,
                onClickPreview: handleClickPreview
            });
        };
        const renderActivePlayer = (src2)=>{
            var _a, _b;
            const player = getActivePlayer(src2);
            if (!player) return null;
            const { style: style2, width: width2, height: height2, wrapper: wrapper2 } = props;
            const config = (_a = props.config) == null ? void 0 : _a[player.key];
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hMp5l.default), {
                ...props,
                ref: ref,
                activePlayer: (_b = player.player) != null ? _b : player,
                slot: wrapper2 ? void 0 : slot,
                className: wrapper2 ? void 0 : className,
                style: wrapper2 ? {
                    display: "block",
                    width: "100%",
                    height: "100%"
                } : {
                    display: "block",
                    width: width2,
                    height: height2,
                    ...style2
                },
                config: config
            });
        };
        const Wrapper = wrapper == null ? $2c24f1fac9322d80$var$ForwardChildren : wrapper;
        const UniversalSuspense = fallback === false ? $2c24f1fac9322d80$var$ForwardChildren : (0, $2NacA.Suspense);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(Wrapper, {
            slot: slot,
            className: className,
            style: {
                width: width,
                height: height,
                ...style
            }
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(UniversalSuspense, {
            fallback: fallback
        }, showPreview ? renderPreview(src) : renderActivePlayer(src)));
    });
    ReactPlayer.displayName = "ReactPlayer";
    ReactPlayer.addCustomPlayer = (player)=>{
        $2c24f1fac9322d80$var$customPlayers.push(player);
    };
    ReactPlayer.removeCustomPlayers = ()=>{
        $2c24f1fac9322d80$var$customPlayers.length = 0;
    };
    ReactPlayer.canPlay = (src)=>{
        if (src) for (const Player2 of [
            ...$2c24f1fac9322d80$var$customPlayers,
            ...players
        ]){
            if (Player2.canPlay(src)) return true;
        }
        return false;
    };
    ReactPlayer.canEnablePIP = (src)=>{
        var _a;
        if (src) for (const Player2 of [
            ...$2c24f1fac9322d80$var$customPlayers,
            ...players
        ]){
            if (Player2.canPlay(src) && ((_a = Player2.canEnablePIP) == null ? void 0 : _a.call(Player2))) return true;
        }
        return false;
    };
    return ReactPlayer;
};
const $2c24f1fac9322d80$var$ForwardChildren = ({ children: children })=>children;

});
parcelRegister("brgEg", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $853f2155248e6f17$export$9c21a3269931e1e6);
const $853f2155248e6f17$export$9c21a3269931e1e6 = {
    // Falsy values don't need to be defined
    //
    // native video attrs
    // src: undefined,
    // preload: undefined,
    // crossOrigin: undefined,
    // autoPlay: false,
    // muted: false,
    // loop: false,
    // controls: false,
    // playsInline: false,
    // disableRemotePlayback: false,
    width: "320px",
    height: "180px",
    // native video props
    volume: 1,
    playbackRate: 1,
    // custom props
    // playing: undefined,
    // pip: false,
    // light: false,
    // fallback: null,
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}"
};

});

parcelRegister("hMp5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1a60c2f2904ca4$export$2e2bcd8739ae039);

var $2NacA = parcelRequire("2NacA");
const $cf1a60c2f2904ca4$var$Player = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).forwardRef((props, ref)=>{
    const { playing: playing, pip: pip } = props;
    const Player2 = props.activePlayer;
    const playerRef = (0, $2NacA.useRef)(null);
    const startOnPlayRef = (0, $2NacA.useRef)(true);
    (0, $2NacA.useEffect)(()=>{
        var _a, _b;
        if (!playerRef.current) return;
        if (playerRef.current.paused && playing === true) playerRef.current.play();
        if (!playerRef.current.paused && playing === false) playerRef.current.pause();
        playerRef.current.playbackRate = (_a = props.playbackRate) != null ? _a : 1;
        playerRef.current.volume = (_b = props.volume) != null ? _b : 1;
    });
    (0, $2NacA.useEffect)(()=>{
        var _a, _b, _c, _d, _e;
        if (!playerRef.current || !globalThis.document) return;
        if (pip && !document.pictureInPictureElement) try {
            (_b = (_a = playerRef.current).requestPictureInPicture) == null || _b.call(_a);
        } catch (err) {}
        if (!pip && document.pictureInPictureElement) try {
            (_d = (_c = playerRef.current).exitPictureInPicture) == null || _d.call(_c);
            (_e = document.exitPictureInPicture) == null || _e.call(document);
        } catch (err) {}
    }, [
        pip
    ]);
    const handleLoadStart = (event)=>{
        var _a, _b;
        startOnPlayRef.current = true;
        (_a = props.onReady) == null || _a.call(props);
        (_b = props.onLoadStart) == null || _b.call(props, event);
    };
    const handlePlay = (event)=>{
        var _a, _b;
        if (startOnPlayRef.current) {
            startOnPlayRef.current = false;
            (_a = props.onStart) == null || _a.call(props, event);
        }
        (_b = props.onPlay) == null || _b.call(props, event);
    };
    if (!Player2) return null;
    const eventProps = {};
    const reactPlayerEventHandlers = [
        "onReady",
        "onStart"
    ];
    for(const key in props)if (key.startsWith("on") && !reactPlayerEventHandlers.includes(key)) eventProps[key] = props[key];
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(Player2, {
        ...eventProps,
        style: props.style,
        className: props.className,
        slot: props.slot,
        ref: (0, $2NacA.useCallback)((node)=>{
            playerRef.current = node;
            if (typeof ref === "function") ref(node);
            else if (ref !== null) ref.current = node;
        }, [
            ref
        ]),
        src: props.src,
        crossOrigin: props.crossOrigin,
        preload: props.preload,
        controls: props.controls,
        muted: props.muted,
        autoPlay: props.autoPlay,
        loop: props.loop,
        playsInline: props.playsInline,
        disableRemotePlayback: props.disableRemotePlayback,
        config: props.config,
        onLoadStart: handleLoadStart,
        onPlay: handlePlay
    }, props.children);
});
$cf1a60c2f2904ca4$var$Player.displayName = "Player";
var $cf1a60c2f2904ca4$export$2e2bcd8739ae039 = $cf1a60c2f2904ca4$var$Player;

});

parcelRegister("2fcwM", function(module, exports) {
module.exports = import("bRmMc").then(()=>parcelRequire('jarQx'));

});






parcelRegister("9z6Tf", function(module, exports) {

$parcel$export(module.exports, "ErrorText", () => $bbf985293db464ac$export$7f714e6c560938e5);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
const $bbf985293db464ac$export$7f714e6c560938e5 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        direction: "row",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            color: "red",
            size: "small",
            children: children
        })
    });
};

});

parcelRegister("gQLGd", function(module, exports) {
$parcel$export(module.exports, "CreateEstimateModal", () => (parcelRequire("d9fGF")).CreateEstimateModal);
$parcel$export(module.exports, "CreateSessionEstimateModal", () => (parcelRequire("btEIO")).CreateSessionEstimateModal);
$parcel$export(module.exports, "CreateUsageEstimateModal", () => (parcelRequire("83VZo")).CreateUsageEstimateModal);
$parcel$export(module.exports, "CurrentEstimate", () => (parcelRequire("8fFyF")).CurrentEstimate);
$parcel$export(module.exports, "EstimateHeader", () => (parcelRequire("37Lsn")).EstimateHeader);
$parcel$export(module.exports, "EstimateList", () => (parcelRequire("iopSL")).EstimateList);
$parcel$export(module.exports, "SessionEstimateList", () => (parcelRequire("byNl8")).SessionEstimateList);
parcelRequire("d9fGF");
parcelRequire("btEIO");
parcelRequire("83VZo");
parcelRequire("8fFyF");
parcelRequire("37Lsn");
parcelRequire("iopSL");
parcelRequire("6Azq1");

});
parcelRegister("d9fGF", function(module, exports) {

$parcel$export(module.exports, "CreateEstimateModal", () => $e1869c08b95ba254$export$f4322161ba18295b);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");
parcelRequire("ibR9R");
var $bIzid = parcelRequire("bIzid");

var $4mDQA = parcelRequire("4mDQA");
const $e1869c08b95ba254$export$f4322161ba18295b = (0, $j8yBr.observer)(({ creating: creating, setCreating: setCreating, setShowModal: setShowModal })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [title, setTitle] = (0, $2NacA.useState)('New Estimate');
    /** Methods **/ const createEstimate = async (title)=>{
        if (!projectStore.currentProject?.id) {
            (0, $bsB3E.toast).warn('Select a project to create a new Estimate.');
            return;
        }
        setCreating(true);
        try {
            const newEstimate = await estimateStore.createEstimate(projectStore.currentProject.id, title);
            const estimate = await estimateStore.getEstimate(newEstimate?.id, 'session_estimates,usage_estimates');
            if (estimate) {
                estimateStore.setCurrentEstimate(estimate);
                (0, $bsB3E.toast).success('Estimate created');
                setShowModal(false);
            } else (0, $bsB3E.toast).error('There was an error creating the Estimate. Please try again in a moment.');
        } catch (err) {
            (0, $bsB3E.toast).error('There was an error creating the Estimate. Please try again in a moment.');
        } finally{
            setCreating(false);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5erKi.Layer), {
        onEsc: ()=>setShowModal(false),
        onClickOutside: ()=>setShowModal(false),
        position: "center",
        modal: true,
        margin: "large",
        children: [
            creating && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4mDQA.Loader), {}),
            !creating && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                align: "start",
                pad: "small",
                justify: "around",
                width: "medium",
                height: "medium",
                background: "light-1",
                round: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        pad: "small",
                        gap: "small",
                        align: "center",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "20%",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Title:"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                fill: "horizontal",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                    val: title || '',
                                    onChange: (val)=>setTitle(val),
                                    plain: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        pad: "small",
                        margin: "small",
                        hoverIndicator: true,
                        disabled: creating,
                        onClick: ()=>createEstimate(title),
                        label: creating ? 'Creating...' : 'Create Estimate'
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("btEIO", function(module, exports) {

$parcel$export(module.exports, "CreateSessionEstimateModal", () => $00065a1eb2e70fa4$export$be5fdc872b7daba8);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $4kZY9 = parcelRequire("4kZY9");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $94KEY = parcelRequire("94KEY");
var $czDw5 = parcelRequire("czDw5");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $bIzid = parcelRequire("bIzid");
const $00065a1eb2e70fa4$export$be5fdc872b7daba8 = (0, $j8yBr.observer)(({ addSessionEstimate: addSessionEstimate, setShowModal: setShowModal })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ // .toISOString() (not .format(), which converts to local time) keeps this a UTC-safe
    // date-only string - the "date" column round-trips through the API as UTC midnight, so
    // formatting via local time can roll the day back or forward depending on the viewer's
    // timezone offset.
    const [date, setDate] = (0, $2NacA.useState)(estimateStore.lastSessionEstimateDate ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(estimateStore.lastSessionEstimateDate).add(1, 'day').toISOString().slice(0, 10) : '');
    const [title, setTitle] = (0, $2NacA.useState)(`Session #${(estimateStore.currentEstimate?.session_estimates.length ?? 0) + 1}`);
    const [formErrors, setFormErrors] = (0, $2NacA.useState)({});
    /** Methods **/ const createSessionEstimate = ()=>{
        if (estimateStore.getSessionEstimateDates().find((d)=>(0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(d).format('YYYY-MM-DD') === date)) {
            setFormErrors({
                ...formErrors,
                date: 'A Session Estimate already exists for this date.'
            });
            return;
        }
        addSessionEstimate(title, date);
        setShowModal(false);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowModal(false),
        onClickOutside: ()=>setShowModal(false),
        position: "center",
        modal: true,
        margin: "large",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "column",
            align: "start",
            pad: "small",
            justify: "around",
            width: "medium",
            height: "medium",
            background: "light-1",
            round: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    pad: "small",
                    gap: "small",
                    align: "center",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            width: "20%",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Title:"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                val: title || '',
                                onChange: (val)=>setTitle(val),
                                onSubmit: ()=>createSessionEstimate()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        pad: "small",
                        gap: "small",
                        align: "center",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "20%",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Date:"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                fill: "horizontal",
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $czDw5.Keyboard), {
                                        onEnter: createSessionEstimate,
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                            format: "mm/dd/yyyy",
                                            value: date,
                                            calendarProps: {
                                                disabled: estimateStore.getSessionEstimateDates()
                                            },
                                            onChange: ({ value: value })=>setDate(typeof value === 'object' ? value[0] : value)
                                        })
                                    }),
                                    formErrors.date && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        fill: "horizontal",
                                        align: "end",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            color: "red",
                                            children: formErrors.date
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    pad: "small",
                    margin: "small",
                    hoverIndicator: true,
                    onClick: ()=>createSessionEstimate(),
                    label: "Add Session Estimate"
                })
            ]
        })
    });
});

});
parcelRegister("94KEY", function(module, exports) {

$parcel$export(module.exports, "DateInput", () => $69b8ae774c4aba90$export$7edc06cf1783b30f);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $5vjdE = parcelRequire("5vjdE");

var $7oNsG = parcelRequire("7oNsG");

var $2M0UK = parcelRequire("2M0UK");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $cooA3 = parcelRequire("cooA3");

var $isD1Z = parcelRequire("isD1Z");

var $b5k5v = parcelRequire("b5k5v");

var $7wKkw = parcelRequire("7wKkw");

var $czDw5 = parcelRequire("czDw5");

var $2fsW3 = parcelRequire("2fsW3");

var $2O6LY = parcelRequire("2O6LY");
var $3XT4P = parcelRequire("3XT4P");
var $dOlbm = parcelRequire("dOlbm");
var $hp4MM = parcelRequire("hp4MM");

var $9Kkdp = parcelRequire("9Kkdp");

var $aWdzU = parcelRequire("aWdzU");

var $1c8YV = parcelRequire("1c8YV");

var $cooA3 = parcelRequire("cooA3");

var $eblDL = parcelRequire("eblDL");

var $eL6w3 = parcelRequire("eL6w3");
var $69b8ae774c4aba90$var$_excluded = [
    "buttonProps",
    "calendarProps",
    "defaultValue",
    "disabled",
    "dropProps",
    "format",
    "id",
    "icon",
    "inline",
    "inputProps",
    "name",
    "onChange",
    "onFocus",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "value",
    "messages"
], $69b8ae774c4aba90$var$_excluded2 = [
    "icon"
];
function $69b8ae774c4aba90$var$_extends() {
    return $69b8ae774c4aba90$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $69b8ae774c4aba90$var$_extends.apply(null, arguments);
}
function $69b8ae774c4aba90$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $69b8ae774c4aba90$var$StyledDateInputContainer = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    // to not pass props on dom through Box
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'disabled';
    }
}).withConfig({
    displayName: "DateInput__StyledDateInputContainer",
    componentId: "sc-1jfta23-0"
})([
    "",
    " ",
    "}"
], function(props) {
    return props.disabled && (0, $2O6LY.disabledStyle)();
}, function(props) {
    return props.readOnlyProp && (0, $9Kkdp.readOnlyStyle)(props.theme);
});
var $69b8ae774c4aba90$var$getReference = function getReference(value) {
    var adjustedDate;
    var res;
    if (typeof value === 'string') res = value;
    else if (Array.isArray(value) && Array.isArray(value[0])) res = value[0].find(function(date) {
        return date;
    });
    else if (Array.isArray(value) && value.length) res = value[0];
    if (res) adjustedDate = (0, $3XT4P.setHoursWithOffset)(res);
    return adjustedDate;
};
var $69b8ae774c4aba90$export$7edc06cf1783b30f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, refArg) {
    var _theme$icon, _theme$dateInput$icon, _theme$dateInput$icon2, _theme$dateInput$butt, _theme$dateInput$butt2;
    var buttonProps = _ref.buttonProps, calendarProps = _ref.calendarProps, defaultValue = _ref.defaultValue, disabled = _ref.disabled, dropProps = _ref.dropProps, format = _ref.format, id = _ref.id, icon = _ref.icon, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline, inputProps = _ref.inputProps, name = _ref.name, _onChange = _ref.onChange, _onFocus = _ref.onFocus, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, _ref$reverse = _ref.reverse, reverseProp = _ref$reverse === void 0 ? false : _ref$reverse, valueArg = _ref.value, messages = _ref.messages, rest = $69b8ae774c4aba90$var$_objectWithoutPropertiesLoose(_ref, $69b8ae774c4aba90$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var announce = (0, $2NacA.useContext)((0, $7oNsG.AnnounceContext));
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), formatMessage = _useContext.format;
    var iconSize = ((_theme$icon = theme.icon) == null ? void 0 : _theme$icon.matchSize) && rest.size || ((_theme$dateInput$icon = theme.dateInput.icon) == null ? void 0 : _theme$dateInput$icon.size);
    var _useContext2 = (0, $2NacA.useContext)((0, $7wKkw.FormContext)), useFormInput = _useContext2.useFormInput;
    var ref = (0, $dOlbm.useForwardedRef)(refArg);
    var containerRef = (0, $2NacA.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    var bounds = calendarProps == null ? void 0 : calendarProps.bounds;
    var validateBoundsForForm = (0, $2NacA.useCallback)(function(fieldValue) {
        if (!bounds || !fieldValue) return undefined;
        var isValid = (0, $aWdzU.validateBounds)(bounds, fieldValue);
        if (!isValid) {
            var _bounds$map = bounds.map(function(date) {
                return (0, $3XT4P.setHoursWithOffset)(date).toISOString();
            }), startBound = _bounds$map[0], endBound = _bounds$map[1];
            if (startBound && endBound) return formatMessage({
                id: 'dateInput.outOfBounds',
                messages: messages,
                values: {
                    start: new Date(startBound).toLocaleDateString(),
                    end: new Date(endBound).toLocaleDateString()
                }
            });
        }
        return undefined;
    }, [
        bounds,
        formatMessage,
        messages
    ]);
    var _useFormInput = useFormInput({
        name: name,
        value: valueArg,
        initialValue: defaultValue,
        validate: bounds ? validateBoundsForForm : undefined
    }), value = _useFormInput[0], setValue = _useFormInput[1];
    var usingKeyboard = (0, $hp4MM.useKeyboard)();
    var CalendarIcon = ((_theme$dateInput$icon2 = theme.dateInput.icon) == null ? void 0 : _theme$dateInput$icon2.calendar) || (0, $5vjdE.Calendar);
    var _useState = (0, $2NacA.useState)(true), withinBounds = _useState[0], setWithinBounds = _useState[1];
    var _useState2 = (0, $2NacA.useState)((0, $cooA3.getOutputFormat)(value)), outputFormat = _useState2[0], setOutputFormat = _useState2[1];
    (0, $2NacA.useEffect)(function() {
        setOutputFormat(function(previousFormat) {
            var nextFormat = (0, $cooA3.getOutputFormat)(value);
            // when user types, date could become something like 07//2020
            // and value becomes undefined. don't lose the format from the
            // previous valid date
            return previousFormat !== nextFormat ? previousFormat : nextFormat;
        });
    }, [
        value
    ]);
    (0, $2NacA.useEffect)(function() {
        if (value === undefined || bounds === undefined) setWithinBounds(true);
        else {
            var validNextValue = (0, $aWdzU.validateBounds)(bounds, value);
            setWithinBounds(validNextValue);
        }
    }, [
        value,
        bounds
    ]);
    // keep track of timestamp from original date(s)
    var _useState3 = (0, $2NacA.useState)($69b8ae774c4aba90$var$getReference(value)), reference = _useState3[0], setReference = _useState3[1];
    // do we expect multiple dates?
    var range = Array.isArray(value) || format && format.includes('-');
    // parse format and build a formal schema we can use elsewhere
    var schema = (0, $2NacA.useMemo)(function() {
        return (0, $aWdzU.formatToSchema)(format);
    }, [
        format
    ]);
    // mask is only used when a format is provided
    var mask = (0, $2NacA.useMemo)(function() {
        return (0, $aWdzU.schemaToMask)(schema);
    }, [
        schema
    ]);
    // textValue is only used when a format is provided
    var _useState4 = (0, $2NacA.useState)(schema ? (0, $aWdzU.valueToText)(value, schema) : undefined), textValue = _useState4[0], setTextValue = _useState4[1];
    var readOnlyCopyValidation = formatMessage({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = formatMessage({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState5 = (0, $2NacA.useState)(readOnlyCopyPrompt), tip = _useState5[0], setTip = _useState5[1];
    // Setting the icon through `inputProps` is deprecated.
    // The `icon` prop should be used instead.
    var _ref2 = inputProps || {}, MaskedInputIcon = _ref2.icon, restOfInputProps = $69b8ae774c4aba90$var$_objectWithoutPropertiesLoose(_ref2, $69b8ae774c4aba90$var$_excluded2);
    if (MaskedInputIcon) console.warn("Customizing the DateInput icon through inputProps is deprecated.\nUse the icon prop instead.");
    var reverse = reverseProp || restOfInputProps.reverse;
    var calendarDropdownAlign = {
        top: 'bottom',
        left: 'left'
    };
    // We need to distinguish between the caller changing a Form value
    // and the user typing a date that he isn't finished with yet.
    // To handle this, we see if we have a value and the text value
    // associated with it doesn't align to it, then we update the text value.
    // We compare using textToValue to avoid "06/01/2021" not
    // matching "06/1/2021".
    (0, $2NacA.useEffect)(function() {
        if (schema && value !== undefined) {
            var nextTextValue = (0, $aWdzU.valueToText)(value, schema);
            if (!(0, $aWdzU.valuesAreEqual)((0, $aWdzU.textToValue)(textValue, schema, range, reference), (0, $aWdzU.textToValue)(nextTextValue, schema, range, reference)) || textValue === '' && nextTextValue !== '') setTextValue(nextTextValue);
        }
    }, [
        range,
        schema,
        textValue,
        reference,
        value
    ]);
    // textValue of MaskedInput is controlled.
    // for uncontrolled forms, ensure the reset event
    // resets the textValue
    (0, $2NacA.useEffect)(function() {
        var _ref$current;
        var form = ref == null || (_ref$current = ref.current) == null ? void 0 : _ref$current.form;
        var handleFormReset = function handleFormReset(e) {
            if (schema && ref.current && e.target.contains(ref.current)) setTextValue('');
        };
        // place the listener on the form directly. if listener is on window,
        // the event could get blocked if caller has e.stopPropagation(), etc. in
        // their form onReset
        form == null || form.addEventListener('reset', handleFormReset);
        return function() {
            return form == null ? void 0 : form.removeEventListener('reset', handleFormReset);
        };
    }, [
        schema,
        ref
    ]);
    // when format and not inline, whether to show the Calendar in a Drop
    var _useState6 = (0, $2NacA.useState)(), open = _useState6[0], setOpen = _useState6[1];
    var openCalendar = (0, $2NacA.useCallback)(function() {
        setOpen(true);
        announce(formatMessage({
            id: 'dateInput.enterCalendar',
            messages: messages
        }));
    }, [
        announce,
        formatMessage,
        messages
    ]);
    var closeCalendar = (0, $2NacA.useCallback)(function() {
        if (usingKeyboard && !inline && ref != null && ref.current) setTimeout(function() {
            var _ref$current2;
            ref == null || (_ref$current2 = ref.current) == null || _ref$current2.focus();
        }, 0);
        setOpen(false);
        announce(formatMessage({
            id: 'dateInput.exitCalendar',
            messages: messages
        }));
    }, [
        announce,
        formatMessage,
        messages,
        usingKeyboard,
        ref,
        inline
    ]);
    var dates = (0, $2NacA.useMemo)(function() {
        return range && value != null && value.length ? [
            value
        ] : undefined;
    }, [
        range,
        value
    ]);
    var calendar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cooA3.Calendar), $69b8ae774c4aba90$var$_extends({
        ref: inline ? ref : undefined,
        id: inline && !format ? id : undefined,
        range: range,
        date: range ? undefined : value,
        dates: dates,
        initialFocus: open ? 'days' : undefined,
        onSelect: disabled ? undefined : function(nextValue) {
            var normalizedValue;
            if (range && Array.isArray(nextValue)) normalizedValue = nextValue[0];
            else if (range && nextValue) normalizedValue = [
                nextValue,
                nextValue
            ];
            else normalizedValue = nextValue;
            if (schema) setTextValue((0, $aWdzU.valueToText)(normalizedValue, schema));
            setValue(normalizedValue);
            setReference($69b8ae774c4aba90$var$getReference(nextValue));
            if (_onChange) _onChange({
                value: normalizedValue
            });
            if (open && !range) closeCalendar();
        }
    }, calendarProps));
    var formContextValue = (0, $2NacA.useMemo)(function() {
        return {
            useFormInput: function useFormInput(_ref3) {
                var valueProp = _ref3.value;
                return [
                    valueProp,
                    function() {}
                ];
            }
        };
    }, []);
    if (!format) {
        // When no format is specified, we don't give the user a way to type
        if (inline) return calendar;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $b5k5v.DropButton), $69b8ae774c4aba90$var$_extends({
            ref: ref,
            id: id,
            dropProps: $69b8ae774c4aba90$var$_extends({
                align: calendarDropdownAlign
            }, dropProps),
            dropContent: calendar,
            icon: icon || MaskedInputIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(CalendarIcon, {
                size: iconSize
            })
        }, buttonProps));
    }
    var onClickCopy = function onClickCopy() {
        navigator.clipboard.writeText(textValue);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var DateInputButton = readOnlyCopy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $eblDL.CopyButton), {
        disabled: disabled,
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        onClick: open ? closeCalendar : openCalendar,
        disabled: disabled,
        plain: true,
        icon: icon || MaskedInputIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(CalendarIcon, {
            size: iconSize
        }),
        margin: reverse ? {
            left: (_theme$dateInput$butt = theme.dateInput.button) == null ? void 0 : _theme$dateInput$butt.margin
        } : {
            right: (_theme$dateInput$butt2 = theme.dateInput.button) == null ? void 0 : _theme$dateInput$butt2.margin
        }
    });
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7wKkw.FormContext).Provider, {
        key: "input",
        value: formContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEsc: open ? function() {
            return closeCalendar();
        } : undefined,
        onSpace: function onSpace(event) {
            if (!readOnlyCopy) {
                event.preventDefault();
                if (!readOnly) openCalendar();
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($69b8ae774c4aba90$var$StyledDateInputContainer, $69b8ae774c4aba90$var$_extends({
        ref: containerRef,
        border: !plain,
        round: theme.dateInput.container.round,
        direction: "row",
        disabled: disabled,
        readOnlyProp: readOnly,
        fill: true
    }, passThemeFlag), reverse && (!readOnly || readOnlyCopy) && DateInputButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2fsW3.MaskedInput), $69b8ae774c4aba90$var$_extends({
        "aria-invalid": bounds && !withinBounds ? true : undefined,
        readOnly: readOnly,
        ref: ref,
        id: id,
        name: name,
        reverse: true,
        disabled: disabled,
        mask: mask,
        plain: true
    }, restOfInputProps, rest, {
        value: textValue,
        onChange: function onChange(event) {
            var nextTextValue = event.target.value;
            setTextValue(nextTextValue);
            var nextValue = (0, $aWdzU.textToValue)(nextTextValue, schema, range, reference, outputFormat);
            var validNextValue = (0, $aWdzU.validateBounds)(bounds, nextValue);
            setWithinBounds(validNextValue);
            if (nextValue !== undefined) setReference($69b8ae774c4aba90$var$getReference(nextValue));
            // update value even when undefined
            setValue(nextValue);
            if (_onChange) {
                event.persist(); // extract from React synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = nextValue;
                _onChange(adjustedEvent);
            }
        },
        onFocus: function onFocus(event) {
            if (!readOnly) announce(formatMessage({
                id: 'dateInput.openCalendar',
                messages: messages
            }));
            if (_onFocus) _onFocus(event);
        }
    })), !reverse && (!readOnly || readOnlyCopy) && DateInputButton)));
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), null, input, calendar);
    if (open && !readOnly) return [
        input,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $isD1Z.Drop), $69b8ae774c4aba90$var$_extends({
            key: "drop",
            id: id ? id + "__drop" : undefined,
            target: containerRef.current,
            align: $69b8ae774c4aba90$var$_extends({}, calendarDropdownAlign, dropProps),
            onEsc: closeCalendar,
            onClickOutside: function onClickOutside(_ref4) {
                var target = _ref4.target;
                if (target !== containerRef.current && !containerRef.current.contains(target)) closeCalendar();
            }
        }, dropProps), calendar)
    ];
    return input;
});
$69b8ae774c4aba90$export$7edc06cf1783b30f.displayName = 'DateInput';
$69b8ae774c4aba90$export$7edc06cf1783b30f.propTypes = (0, $1c8YV.DateInputPropTypes);

});
parcelRegister("5vjdE", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $401ec187f41275ca$export$e1aef45b828286de, (v) => $401ec187f41275ca$export$e1aef45b828286de = v);
var $401ec187f41275ca$export$1e511d4a378977f5;
var $401ec187f41275ca$export$e1aef45b828286de;
"use strict";
$401ec187f41275ca$export$1e511d4a378977f5 = true;
$401ec187f41275ca$export$e1aef45b828286de = void 0;

var $401ec187f41275ca$var$_react = $401ec187f41275ca$var$_interopRequireWildcard((parcelRequire("2NacA")));

var $xazbe = parcelRequire("xazbe");
function $401ec187f41275ca$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($401ec187f41275ca$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $401ec187f41275ca$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = $401ec187f41275ca$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $401ec187f41275ca$var$_extends() {
    return $401ec187f41275ca$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $401ec187f41275ca$var$_extends.apply(null, arguments);
}
var $401ec187f41275ca$var$Calendar = $401ec187f41275ca$export$e1aef45b828286de = /*#__PURE__*/ (0, $401ec187f41275ca$var$_react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ $401ec187f41275ca$var$_react["default"].createElement($xazbe.StyledIcon, $401ec187f41275ca$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calendar"
    }, props), /*#__PURE__*/ $401ec187f41275ca$var$_react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 5h20v17H2V5zm16 0V1M6 5V1m-4 9h20"
    }));
});
$401ec187f41275ca$var$Calendar.displayName = 'Calendar';

});

parcelRegister("aWdzU", function(module, exports) {

$parcel$export(module.exports, "formatToSchema", () => $7f69da86d0b33284$export$42f432bed9bbfa4a);
$parcel$export(module.exports, "schemaToMask", () => $7f69da86d0b33284$export$9235b47e9363044);
$parcel$export(module.exports, "valueToText", () => $7f69da86d0b33284$export$a1f20cd55d4f0f56);
$parcel$export(module.exports, "validateBounds", () => $7f69da86d0b33284$export$51e58a02740fe411);
$parcel$export(module.exports, "textToValue", () => $7f69da86d0b33284$export$60c3f5dffac76ccb);
$parcel$export(module.exports, "valuesAreEqual", () => $7f69da86d0b33284$export$45491dafa4524293);

var $3XT4P = parcelRequire("3XT4P");

var $iDJvK = parcelRequire("iDJvK");
function $7f69da86d0b33284$var$_construct(t, e, r) {
    if ($7f69da86d0b33284$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $7f69da86d0b33284$var$_setPrototypeOf(p, r.prototype), p;
}
function $7f69da86d0b33284$var$_setPrototypeOf(t, e) {
    return $7f69da86d0b33284$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7f69da86d0b33284$var$_setPrototypeOf(t, e);
}
function $7f69da86d0b33284$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7f69da86d0b33284$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7f69da86d0b33284$var$_extends() {
    return $7f69da86d0b33284$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7f69da86d0b33284$var$_extends.apply(null, arguments);
}
var $7f69da86d0b33284$export$42f432bed9bbfa4a = function formatToSchema(format) {
    if (!format) return undefined;
    var result = [];
    var i = 0;
    var part;
    while(i < format.length){
        if (!part || part[0] !== format[i]) {
            if (part) result.push(part);
            part = format[i];
        } else part += format[i];
        i += 1;
    }
    if (part) result.push(part);
    return result;
};
var $7f69da86d0b33284$var$masks = {
    m: {
        length: [
            1,
            2
        ],
        regexp: /^[1-9]$|^1[0-2]$/
    },
    mm: {
        length: [
            1,
            2
        ],
        regexp: /^[0-1]$|^0[1-9]$|^1[0-2]$/
    },
    d: {
        length: [
            1,
            2
        ],
        regexp: /^[1-9]$|^[1-2][0-9]$|^3[0-1]$/
    },
    dd: {
        length: [
            1,
            2
        ],
        regexp: /^[0-3]$|^0[1-9]$|^[1-2][0-9]$|^3[0-1]$/
    },
    yy: {
        length: [
            1,
            2
        ],
        regexp: /^[0-9]{1,2}$/
    },
    yyyy: {
        length: [
            1,
            4
        ],
        regexp: /^[0-9]{1,4}$/
    }
};
var $7f69da86d0b33284$export$9235b47e9363044 = function schemaToMask(schema) {
    if (!schema) return undefined;
    return schema.map(function(part) {
        var lower = part.toLowerCase();
        var _char = lower[0];
        if (_char === 'm' || _char === 'd' || _char === 'y') return $7f69da86d0b33284$var$_extends({
            placeholder: part
        }, $7f69da86d0b33284$var$masks[lower]);
        return {
            fixed: part
        };
    });
};
var $7f69da86d0b33284$export$a1f20cd55d4f0f56 = function valueToText(value, schema) {
    var text = '';
    // when user initializes dates as empty array, we want to still
    // show the placeholder text
    if (!value || Array.isArray(value) && !value.length) return text;
    var dates = (Array.isArray(value) ? value : [
        value
    ]).map(function(v) {
        return (0, $3XT4P.setHoursWithOffset)(v);
    });
    var dateIndex = 0;
    var parts = {};
    schema.every(function(part) {
        var _char2 = part[0].toLowerCase();
        // advance dateIndex if we already have this part
        while(dateIndex < dates.length && (Number.isNaN(dates[dateIndex].date) || (_char2 === 'm' || _char2 === 'd' || _char2 === 'y') && parts[part])){
            dateIndex += 1;
            parts = {};
        }
        var date = dates[dateIndex];
        if (date && part === 'm') {
            text += date.getMonth() + 1;
            parts[part] = true;
        } else if (date && part === 'mm') {
            text += ("0" + (date.getMonth() + 1)).slice(-2);
            parts[part] = true;
        } else if (date && part === 'd') {
            text += date.getDate();
            parts[part] = true;
        } else if (date && part === 'dd') {
            text += ("0" + date.getDate()).slice(-2);
            parts[part] = true;
        } else if (date && part === 'yy') {
            text += date.getFullYear().toString().slice(-2);
            parts[part] = true;
        } else if (date && part === 'yyyy') {
            text += date.getFullYear();
            parts[part] = true;
        } else if (!date && (part[0] === 'm' || part[0] === 'd' || part[0] === 'y')) return false;
        else text += part;
        return true;
    });
    return text;
};
var $7f69da86d0b33284$var$charCodeZero = '0'.charCodeAt(0);
var $7f69da86d0b33284$var$charCodeNine = '9'.charCodeAt(0);
var $7f69da86d0b33284$var$pullDigits = function pullDigits(text, index) {
    var end = index;
    while(text.charCodeAt(end) >= $7f69da86d0b33284$var$charCodeZero && text.charCodeAt(end) <= $7f69da86d0b33284$var$charCodeNine)end += 1;
    return text.slice(index, end);
};
var $7f69da86d0b33284$export$51e58a02740fe411 = function validateBounds(dateBounds, selectedDate) {
    if (!dateBounds || !selectedDate) return true;
    var _dateBounds$map = dateBounds.map(function(date) {
        return (0, $3XT4P.setHoursWithOffset)(date).toISOString();
    }), startDate = _dateBounds$map[0], endDate = _dateBounds$map[1];
    var isoSelectedDates = (Array.isArray(selectedDate) ? selectedDate : [
        selectedDate
    ]).map(function(date) {
        return (0, $3XT4P.setHoursWithOffset)(date).toISOString();
    });
    var validSelection = isoSelectedDates.every(function(isoSelectedDate) {
        return !endDate && startDate === isoSelectedDate || isoSelectedDate >= startDate && isoSelectedDate <= endDate;
    });
    return validSelection;
};
var $7f69da86d0b33284$export$60c3f5dffac76ccb = function textToValue(text, schema, range, reference, outputFormat) {
    if (!text) return range ? [] : undefined;
    var result;
    var addDate = function addDate(parts) {
        var leapYear = parts.y % 4 === 0 && parts.y % 100 !== 0 || parts.y % 400 === 0;
        // Do a little sanity checking on the parts first.
        // If not valid, leave as is.
        if (!parts.m || !parts.d || !parts.y || parts.y.length < 4 || parts.m.length > 2 || parts.d.length > 2 || parts.m > 12 || parts.d > 31 || (parts.m === "02" || parts.m === "2") && parts.d > (leapYear ? 29 : 28)) return parts;
        // use time info from reference date
        var time = reference ? [
            reference.getHours(),
            reference.getMinutes(),
            reference.getSeconds(),
            reference.getMilliseconds()
        ] : null;
        var date = $7f69da86d0b33284$var$_construct(Date, [
            parts.y,
            parts.m - 1,
            parts.d
        ].concat(time)).toISOString();
        if (date && outputFormat === 'no timezone') {
            var _handleOffset$toISOSt = (0, $iDJvK.handleOffset)(date).toISOString().split('T');
            date = _handleOffset$toISOSt[0];
        }
        if (!range) {
            if (!result) result = date;
        } else {
            if (!result) result = [];
            result.push(date);
        }
        // we've consumed these parts, return an empty object in case we need
        // to start building up another one for a range
        return {};
    };
    var parts = {};
    var index = 0;
    schema.forEach(function(part) {
        if (index < text.length) {
            var lower = part.toLowerCase();
            var _char3 = lower[0];
            if (parts[_char3] !== undefined) parts = addDate(parts);
            if (_char3 === 'm') {
                parts.m = $7f69da86d0b33284$var$pullDigits(text, index);
                index += parts.m.length;
            } else if (_char3 === 'd') {
                var _parts;
                parts.d = $7f69da86d0b33284$var$pullDigits(text, index);
                // when format is something like yyyy/mm/dd,
                // '0' as incomplete day can cause date to be
                // prematurely calculated.
                // ex: 2022/01/0 would reutrn 2021/12/31 in addDate()
                if (parts.d === '0') delete parts.d;
                index += ((_parts = parts) == null || (_parts = _parts.d) == null ? void 0 : _parts.length) || 0;
            } else if (_char3 === 'y') {
                parts.y = $7f69da86d0b33284$var$pullDigits(text, index);
                index += parts.y.length;
                if (lower === 'yy' && parts.y.length === 2) // convert to full year, pivot at 69 based on POSIX strptime()
                parts.y = "" + (parts.y < 69 ? 20 : 19) + parts.y;
            } else if (text.slice(index, index + part.length) === part) index += part.length;
            else {
                // syntax error
                index = text.length;
                result = undefined;
            }
        }
    });
    parts = addDate(parts);
    if (!result) return range ? [] : undefined;
    return result;
};
var $7f69da86d0b33284$export$45491dafa4524293 = function valuesAreEqual(value1, value2) {
    return Array.isArray(value1) && Array.isArray(value2) && value1.every(function(d1, i) {
        return d1 === value2[i];
    }) || value1 === value2;
};

});

parcelRegister("1c8YV", function(module, exports) {

$parcel$export(module.exports, "DateInputPropTypes", () => $0dede0fecb538259$export$22313ae4df6bbc32);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $0dede0fecb538259$var$PropType = {};
var $0dede0fecb538259$export$22313ae4df6bbc32 = $0dede0fecb538259$var$PropType;

});



parcelRegister("83VZo", function(module, exports) {

$parcel$export(module.exports, "CreateUsageEstimateModal", () => $4bdc4539ad381fdc$export$89dd26b268648a3e);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");
parcelRequire("ibR9R");
var $bIzid = parcelRequire("bIzid");
const $4bdc4539ad381fdc$export$89dd26b268648a3e = (0, $j8yBr.observer)(({ addUsageEstimate: addUsageEstimate, setShowModal: setShowModal })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [title, setTitle] = (0, $2NacA.useState)(`Usage Estimate #${(estimateStore.currentEstimate?.usage_estimates?.length ?? 0) + 1}`);
    const [commercialId, setCommercialId] = (0, $2NacA.useState)();
    /** Methods **/ const createUsageEstimate = ()=>{
        addUsageEstimate(title, commercialId);
        setShowModal(false);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowModal(false),
        onClickOutside: ()=>setShowModal(false),
        position: "center",
        modal: true,
        margin: "large",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "column",
            align: "start",
            pad: "small",
            justify: "around",
            width: "medium",
            height: "medium",
            background: "light-1",
            round: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    pad: "small",
                    gap: "small",
                    justify: "center",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Title:"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                val: title || '',
                                onChange: (val)=>setTitle(val),
                                onSubmit: ()=>createUsageEstimate()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    pad: "small",
                    gap: "small",
                    justify: "center",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Commercial:"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                value: commercialId,
                                options: estimateStore.currentEstimate?.project?.commercials ?? [],
                                labelKey: "title",
                                valueKey: "id",
                                onChange: ({ value: value })=>setCommercialId(value?.id),
                                placeholder: "Choose...",
                                emptySearchMessage: "No Commercials found"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    pad: "small",
                    margin: "small",
                    hoverIndicator: true,
                    onClick: ()=>createUsageEstimate(),
                    label: "Add Usage Estimate"
                })
            ]
        })
    });
});

});

parcelRegister("8fFyF", function(module, exports) {

$parcel$export(module.exports, "CurrentEstimate", () => $3ce2b094e23756fe$export$e6fda6be8e794a9d);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");
parcelRequire("ibR9R");
var $37Lsn = parcelRequire("37Lsn");
var $byNl8 = parcelRequire("byNl8");
parcelRequire("frsvk");
var $8Nt19 = parcelRequire("8Nt19");
const $3ce2b094e23756fe$export$e6fda6be8e794a9d = (0, $j8yBr.observer)(({ gridArea: gridArea })=>{
    const estimateStore = (0, $8DltC.useEstimateStore)();
    const hasEstimates = !!estimateStore.estimateList.length;
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        round: "medium",
        background: "white",
        border: {
            color: '#d9d9e3'
        },
        justify: "start",
        alignContent: "start",
        gridArea: gridArea,
        direction: "column",
        flex: "grow",
        children: [
            estimateStore.isLoading && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {}),
            !estimateStore.isLoading && !hasEstimates && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                fill: true,
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: "Create or choose an Estimate to begin."
                })
            }),
            !estimateStore.isLoading && hasEstimates && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $37Lsn.EstimateHeader), {}),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $byNl8.SessionEstimateList), {}),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Nt19.UsageEstimateList), {})
                ]
            })
        ]
    });
});

});
parcelRegister("frsvk", function(module, exports) {
$parcel$export(module.exports, "UsageEstimateList", () => (parcelRequire("8Nt19")).UsageEstimateList);
parcelRequire("8Nt19");

});
parcelRegister("8Nt19", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateList", () => $1f067405b05b1ea5$export$1e99fc12c6064e02);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $5Xkwu = parcelRequire("5Xkwu");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("gQLGd");
var $83VZo = parcelRequire("83VZo");

var $1SqjN = parcelRequire("1SqjN");
parcelRequire("hcQWc");
var $djcqs = parcelRequire("djcqs");

var $8DltC = parcelRequire("8DltC");
const $1f067405b05b1ea5$export$1e99fc12c6064e02 = (0, $j8yBr.observer)(()=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [showAddModal, setShowAddModal] = (0, $2NacA.useState)(false);
    /** Computed **/ const canEdit = estimateStore.canEditCurrent;
    const isDraft = estimateStore.currentEstimate?.status === (0, $djcqs.EstimateStatus).Draft;
    const usageEstimates = (0, $2NacA.useMemo)(()=>{
        const items = estimateStore.currentEstimate?.usage_estimates;
        return items && [
            ...items
        ].sort((a, b)=>a.created_at > b.created_at ? 1 : -1);
    }, [
        estimateStore.currentEstimate?.usage_estimates
    ]);
    /** Methods **/ const addUsageEstimate = async (title, commercialId)=>{
        if (!estimateStore.currentEstimate) return;
        await estimateStore.createUsageEstimate(title, commercialId);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gap: "small",
        margin: {
            horizontal: 'small',
            bottom: 'medium'
        },
        pad: "small",
        children: [
            isDraft && canEdit && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                alignSelf: "end",
                pad: {
                    vertical: 'xsmall'
                },
                margin: {
                    left: 'medium'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    secondary: true,
                    label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "small",
                        weight: "bold",
                        children: "ADD USAGE ESTIMATE"
                    }),
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5Xkwu.Add), {
                        size: "16px"
                    }),
                    tip: "Add estimate item",
                    onClick: ()=>setShowAddModal(true)
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                align: "center",
                children: [
                    !!usageEstimates?.length && usageEstimates.map((usageEstimate)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $1SqjN.UsageEstimatePanel), {
                            usageEstimate: usageEstimate
                        }, usageEstimate.id)),
                    !usageEstimates?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "No Usage Estimates found."
                        })
                    })
                ]
            }),
            isDraft && showAddModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $83VZo.CreateUsageEstimateModal), {
                addUsageEstimate: addUsageEstimate,
                setShowModal: setShowAddModal
            })
        ]
    });
});

});
parcelRegister("1SqjN", function(module, exports) {

$parcel$export(module.exports, "UsageEstimatePanel", () => $ce1de2642c8d0dad$export$29c2342e29535ffd);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $cVlSB = parcelRequire("cVlSB");

var $5TcqJ = parcelRequire("5TcqJ");

var $zaF6E = parcelRequire("zaF6E");

var $12OZq = parcelRequire("12OZq");

var $8DltC = parcelRequire("8DltC");
const $ce1de2642c8d0dad$export$29c2342e29535ffd = (0, $j8yBr.observer)(({ usageEstimate: usageEstimate })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [isUpdatingUsage, setIsUpdatingUsage] = (0, $2NacA.useState)(false);
    /** Computed **/ const usageEstimateItems = usageEstimate.items && [
        ...usageEstimate.items
    ].sort((a, b)=>a.created_at > b.created_at ? 1 : -1);
    /** Methods **/ /**
   * Update this panel's UsageEstimate
   * @param usageEstimate
   * @param usageEstimateIndex
   * @returns
   */ const updateUsageEstimate = async (usageEstimate)=>{
        if (isUpdatingUsage) return;
        else if (!estimateStore.currentEstimate) {
            console.warn('No estimate loaded!');
            return;
        }
        setIsUpdatingUsage(true);
        await estimateStore.updateUsageEstimate(usageEstimate.id, usageEstimate.title);
        setIsUpdatingUsage(false);
    };
    const addEstimateItem = async ()=>{
        // @ts-expect-error - this doesn't yet track which Usage/UsageType a new item belongs to,
        // so it can't supply the required `type`/`usageId` fields. Needs a UI decision before
        // this can be completed; left broken (as it already was) rather than guessed at.
        await estimateStore.createUsageEstimateItem({
            usageEstimateId: usageEstimate.id,
            title: 'New Usage Item'
        });
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        margin: "small",
        fill: "horizontal",
        round: "15px",
        background: "light-3",
        elevation: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $zaF6E.UsageEstimateHeader), {
                usageEstimate: usageEstimate,
                setUsageEstimate: (usageEstimate)=>updateUsageEstimate(usageEstimate)
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $12OZq.UsageEstimateTitleRow), {}),
                    !!usageEstimateItems?.length && usageEstimateItems?.map((item, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $cVlSB.UsageEstimateDataRow), {
                            usageEstimateItem: item,
                            index: i,
                            useColors: true
                        }, item.id)),
                    !usageEstimateItems?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "center",
                        pad: "medium",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "No Usage Estimate Items found."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5TcqJ.UsageEstimateFooter), {
                addEstimateItem: addEstimateItem
            })
        ]
    }, usageEstimate.id);
});

});
parcelRegister("cVlSB", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateDataRow", () => $f2e519c6853ec525$export$238fba7864a942b7);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $bDFk2 = parcelRequire("bDFk2");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $RoqvF = parcelRequire("RoqvF");
var $i2YYW = parcelRequire("i2YYW");
parcelRequire("bRT7J");
var $7r0kC = parcelRequire("7r0kC");
var $1Ofsp = parcelRequire("1Ofsp");
var $6q7qM = parcelRequire("6q7qM");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $fjut3 = parcelRequire("fjut3");
const $f2e519c6853ec525$export$238fba7864a942b7 = (0, $j8yBr.observer)(({ usageEstimateItem: usageEstimateItem, index: index, useColors: useColors })=>{
    /** Refs **/ const defaultFormData = (0, $2NacA.useRef)({
        title: 'New Usage',
        roleId: '',
        units: '1',
        unitType: (0, $i2YYW.UsageUnitType).Uses,
        cycles: '1',
        rate: '0',
        taxesMultiplier: '0',
        handlingMultiplier: '0',
        pAndHMultiplier: '0'
    });
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [isUpdating, setIsUpdating] = (0, $2NacA.useState)(false);
    const [showDeleteModal, setShowDeleteModal] = (0, $2NacA.useState)(false);
    const [title] = (0, $2NacA.useState)(usageEstimateItem.title ?? defaultFormData.current.title);
    const [roleId] = (0, $2NacA.useState)(usageEstimateItem.role_id ?? defaultFormData.current.roleId);
    const [performerType, setRolePerformerType] = (0, $2NacA.useState)(usageEstimateItem.performer_type ?? defaultFormData.current.performerType);
    const [type, setType] = (0, $2NacA.useState)(usageEstimateItem.type ?? defaultFormData.current.type);
    const [units, setUnits] = (0, $2NacA.useState)(usageEstimateItem.units?.toString() ?? defaultFormData.current.units);
    const [unitType, setUnitType] = (0, $2NacA.useState)(usageEstimateItem.unit_type ?? defaultFormData.current.unit_type);
    const [cycles, setCycles] = (0, $2NacA.useState)(usageEstimateItem.cycles?.toString() ?? defaultFormData.current.cycles);
    const [cycleNumber] = (0, $2NacA.useState)(usageEstimateItem.cycle_number);
    const [cycleUnit, setCycleUnit] = (0, $2NacA.useState)(usageEstimateItem.cycle_unit ?? defaultFormData.current.cycleUnit);
    const [rate, setRate] = (0, $2NacA.useState)(usageEstimateItem.rate?.toString() ?? defaultFormData.current.rate);
    const [subtotal, setSubtotal] = (0, $2NacA.useState)(usageEstimateItem.subtotal?.toString() ?? '');
    const [taxesMultiplier, setTaxesMultiplier] = (0, $2NacA.useState)(usageEstimateItem.taxes_multiplier ? (usageEstimateItem.taxes_multiplier * 100).toString() : defaultFormData.current.taxesMultiplier);
    const [handlingMultiplier, setHandlingMultiplier] = (0, $2NacA.useState)(usageEstimateItem.handling_multiplier ? (usageEstimateItem.handling_multiplier * 100).toString() : defaultFormData.current.handlingMultiplier);
    const [pAndHMultiplier, setPAndHMultiplier] = (0, $2NacA.useState)(usageEstimateItem.p_and_h_multiplier ? (usageEstimateItem.p_and_h_multiplier * 100).toString() : defaultFormData.current.pAndHMultiplier);
    const [subtotalPlusFringe, setSubtotalPlusFringe] = (0, $2NacA.useState)(usageEstimateItem.subtotal_plus_fringe?.toString() ?? '');
    /** Computed **/ const canEdit = estimateStore.canEditCurrent;
    const commercialType = usageEstimateItem.usage?.commercial.type;
    /** Methods **/ const updateEstimateItem = async ()=>{
        if (isUpdating) return;
        setIsUpdating(true);
        const updatedItem = await estimateStore.updateUsageEstimateItem(usageEstimateItem.id, {
            title: title,
            roleId: roleId,
            type: type,
            performerType: performerType,
            units: parseInt(units || '1'),
            unitType: unitType,
            cycles: parseFloat(cycles || '1'),
            cycleNumber: cycleNumber,
            cycleUnit: cycleUnit,
            rate: parseFloat(rate || '0'),
            taxesMultiplier: parseFloat(taxesMultiplier || '0') / 100,
            handlingMultiplier: parseFloat(handlingMultiplier || '0') / 100,
            pAndHMultiplier: parseFloat(pAndHMultiplier || '0') / 100
        });
        if (updatedItem?.rate?.toString() !== rate) setRate(updatedItem?.rate?.toString() ?? '');
        if (updatedItem?.subtotal?.toString() !== subtotal) setSubtotal(updatedItem?.subtotal?.toString() ?? '');
        if (updatedItem?.subtotal_plus_fringe?.toString() !== subtotalPlusFringe) setSubtotalPlusFringe(updatedItem?.subtotal_plus_fringe?.toString() ?? '');
        const t = ((updatedItem?.taxes_multiplier || 0) * 100).toString();
        if (t !== taxesMultiplier) setTaxesMultiplier(t);
        const h = ((updatedItem?.handling_multiplier || 0) * 100).toString();
        if (h !== handlingMultiplier) setHandlingMultiplier(h);
        const p = ((updatedItem?.p_and_h_multiplier || 0) * 100).toString();
        if (p !== pAndHMultiplier) setPAndHMultiplier(p);
        setIsUpdating(false);
    };
    const deleteEstimateItem = async ()=>{
        setShowDeleteModal(false);
        await estimateStore.deleteUsageEstimateItem(usageEstimateItem.id);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "medium",
                pad: "medium",
                align: "center",
                background: useColors && !(index % 2) ? 'light-1' : 'white',
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "75%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                            val: performerType,
                            options: Object.values((0, $8kKyn.RolePerformerType)).map((t)=>({
                                    label: t,
                                    value: t
                                })),
                            onChange: (value)=>setRolePerformerType(value),
                            onBlur: ()=>updateEstimateItem()
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: usageEstimateItem.role?.name || '-'
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        fill: "horizontal",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                            val: type,
                            options: (0, $fjut3.commercialUsageTypes)[commercialType]?.map((t)=>({
                                    label: t,
                                    value: t
                                })),
                            onChange: (value)=>setType(value),
                            onBlur: ()=>updateEstimateItem()
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: type
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        width: "75%",
                        direction: "row",
                        gap: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                    val: units,
                                    onChange: (units)=>setUnits(units),
                                    onBlur: ()=>updateEstimateItem(),
                                    onSubmit: ()=>updateEstimateItem(),
                                    minValue: 1,
                                    inputType: "number"
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: units
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                                    val: unitType,
                                    options: Object.values((0, $i2YYW.UsageUnitType)).map((t)=>({
                                            label: t,
                                            value: t
                                        })),
                                    onChange: (value)=>setUnitType(value),
                                    onBlur: ()=>updateEstimateItem()
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: (0, $9Rhqc.capitalize)(unitType)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        width: "75%",
                        direction: "row",
                        gap: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                    val: cycles,
                                    onChange: (cycles)=>setCycles(cycles),
                                    onBlur: ()=>updateEstimateItem(),
                                    onSubmit: ()=>updateEstimateItem(),
                                    minValue: 1,
                                    inputType: "number"
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: cycles
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                                    val: cycleUnit,
                                    options: Object.values((0, $RoqvF.UsageCycleUnit)).map((t)=>({
                                            label: t,
                                            value: t
                                        })),
                                    onChange: (value)=>setCycleUnit(value),
                                    onBlur: ()=>updateEstimateItem()
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: cycleUnit
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "55%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: rate,
                            onChange: (rate)=>setRate(rate),
                            onBlur: ()=>updateEstimateItem(),
                            onSubmit: ()=>updateEstimateItem(),
                            inputType: "number",
                            isCurrency: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: (0, $b1rqt.USD)(rate)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "60%",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            weight: 600,
                            children: (0, $b1rqt.USD)(usageEstimateItem?.subtotal)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "40%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: pAndHMultiplier,
                            onChange: (pAndHMultiplier)=>setPAndHMultiplier(pAndHMultiplier),
                            onBlur: ()=>updateEstimateItem(),
                            onSubmit: ()=>updateEstimateItem(),
                            inputType: "number",
                            isPercent: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            children: [
                                pAndHMultiplier,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "40%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: handlingMultiplier,
                            onChange: (handlingMultiplier)=>setHandlingMultiplier(handlingMultiplier),
                            onBlur: ()=>updateEstimateItem(),
                            onSubmit: ()=>updateEstimateItem(),
                            inputType: "number",
                            isPercent: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            children: [
                                handlingMultiplier,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "40%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: taxesMultiplier,
                            onChange: (taxesMultiplier)=>setTaxesMultiplier(taxesMultiplier),
                            onBlur: ()=>updateEstimateItem(),
                            onSubmit: ()=>updateEstimateItem(),
                            inputType: "number",
                            isPercent: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            children: [
                                taxesMultiplier,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "70%",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            weight: 600,
                            children: (0, $b1rqt.USD)(usageEstimateItem?.subtotal_plus_fringe)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "10%",
                        align: "center",
                        children: canEdit && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            plain: true,
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                                size: "16px",
                                color: "red"
                            }),
                            tip: `Delete ${usageEstimateItem?.title}`,
                            onClick: ()=>setShowDeleteModal(true)
                        })
                    })
                ]
            }),
            canEdit && showDeleteModal && usageEstimateItem && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7r0kC.DeleteModal), {
                name: usageEstimateItem.title,
                onDelete: deleteEstimateItem,
                onCancel: ()=>setShowDeleteModal(false)
            })
        ]
    });
});

});

parcelRegister("5TcqJ", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateFooter", () => $5d2f600b5d6e8f03$export$3095964882152f5c);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $5Xkwu = parcelRequire("5Xkwu");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $8DltC = parcelRequire("8DltC");
const $5d2f600b5d6e8f03$export$3095964882152f5c = (0, $j8yBr.observer)(({ addEstimateItem: addEstimateItem })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** Computed **/ const canEdit = estimateStore.canEditCurrent;
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        gap: "small",
        pad: {
            vertical: 'small',
            horizontal: 'medium'
        },
        background: "white",
        style: {
            borderBottomLeftRadius: '15px',
            borderBottomRightRadius: '15px'
        },
        children: canEdit && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            width: "15%",
            pad: {
                vertical: 'xsmall'
            },
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                secondary: true,
                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    weight: "bold",
                    children: "ADD ITEM"
                }),
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5Xkwu.Add), {
                    size: "16px"
                }),
                tip: "Add estimate item",
                onClick: ()=>addEstimateItem()
            })
        })
    });
});

});

parcelRegister("zaF6E", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateHeader", () => $4f3b7ce87d940698$export$8391c7d79abe0049);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $bDFk2 = parcelRequire("bDFk2");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $7r0kC = parcelRequire("7r0kC");

var $1Ofsp = parcelRequire("1Ofsp");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");
const $4f3b7ce87d940698$export$8391c7d79abe0049 = (0, $j8yBr.observer)(({ usageEstimate: usageEstimate, setUsageEstimate: setUsageEstimate })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [showDeleteModal, setShowDeleteModal] = (0, $2NacA.useState)(false);
    const [title, setTitle] = (0, $2NacA.useState)(usageEstimate.title);
    /** Computed **/ const canEdit = estimateStore.canEditCurrent;
    /** Methods **/ const deleteUsageEstimate = async ()=>{
        await estimateStore.deleteUsageEstimate(usageEstimate.id);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                background: "brand",
                style: {
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px'
                },
                pad: "medium",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        fill: "horizontal",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: title,
                            onChange: setTitle,
                            onSubmit: ()=>setUsageEstimate({
                                    ...usageEstimate,
                                    title: title
                                }),
                            onBlur: ()=>setUsageEstimate({
                                    ...usageEstimate,
                                    title: title
                                })
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        align: "end",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "SUBTOTAL:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: "bold",
                                children: (0, $b1rqt.USD)(usageEstimate.subtotal)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        align: "end",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "SUBTOTAL + FRINGE:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: "bold",
                                children: (0, $b1rqt.USD)(usageEstimate.subtotal_plus_fringe)
                            })
                        ]
                    }),
                    canEdit && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "10%",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            plain: true,
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                                size: "16px",
                                color: "red"
                            }),
                            tip: `Delete ${usageEstimate?.title}`,
                            onClick: ()=>setShowDeleteModal(true)
                        })
                    })
                ]
            }),
            showDeleteModal && usageEstimate && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7r0kC.DeleteModal), {
                name: usageEstimate.title,
                onDelete: deleteUsageEstimate,
                onCancel: ()=>setShowDeleteModal(false)
            })
        ]
    });
});

});

parcelRegister("12OZq", function(module, exports) {

$parcel$export(module.exports, "UsageEstimateTitleRow", () => $28560aa570579402$export$5fbf3e0196d27a2b);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $8DltC = parcelRequire("8DltC");
const $28560aa570579402$export$5fbf3e0196d27a2b = (0, $j8yBr.observer)(()=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        gap: "medium",
        pad: {
            vertical: 'small',
            horizontal: 'medium'
        },
        border: {
            side: 'bottom',
            size: 'xsmall'
        },
        background: "white",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "75%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: estimateStore.canEditCurrent ? 'PERFORMER TYPE' : 'ROLE'
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                fill: "horizontal",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "USAGE TYPE"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "75%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "UNITS"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "75%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "CYCLES"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "55%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "RATE"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "60%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    weight: 600,
                    children: "SUBTOTAL"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "P & H"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "HANDLING"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "TAXES"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "70%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    weight: 600,
                    children: "SUBTOTAL + FRINGE"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "10%"
            })
        ]
    });
});

});





parcelRegister("37Lsn", function(module, exports) {

$parcel$export(module.exports, "EstimateHeader", () => $d77793c8119819a5$export$8cee323211f618e1);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $djcqs = parcelRequire("djcqs");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $gpKeH = parcelRequire("gpKeH");
var $1fLUh = parcelRequire("1fLUh");
var $kS7Ii = parcelRequire("kS7Ii");

var $cYfAm = parcelRequire("cYfAm");
var $iwgRF = parcelRequire("iwgRF");
var $5yWN0 = parcelRequire("5yWN0");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $bsB3E = parcelRequire("bsB3E");

var $eLUFj = parcelRequire("eLUFj");

var $3W9FZ = parcelRequire("3W9FZ");

var $1Ofsp = parcelRequire("1Ofsp");

var $lFfFS = parcelRequire("lFfFS");

var $d2VmQ = parcelRequire("d2VmQ");
const $d77793c8119819a5$export$8cee323211f618e1 = (0, $j8yBr.observer)(()=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    const location = (0, $19GAm.useLocation)();
    /** State **/ const [showRerunModal, setShowRerunModal] = (0, $2NacA.useState)(false);
    /** Computed **/ const saveStatus = estimateStore.isSaving ? (0, $lFfFS.SaveStatus).Saving : (0, $lFfFS.SaveStatus).Saved;
    /** Methods **/ const updateEstimate = async (updatedEstimate)=>{
        await estimateStore.updateEstimate(updatedEstimate);
        const estimate = await estimateStore.getEstimate(updatedEstimate.id, 'session_estimates,usage_estimates');
        if (estimate) estimateStore.setCurrentEstimate(estimate);
    };
    const copyShareLink = async ()=>{
        const link = new URL(location.pathname, (0, $eLUFj.env).clientUrl).href;
        await navigator.clipboard.writeText(link);
        (0, $bsB3E.toast).success('Copied link to clipboard.');
    };
    const recalculateEstimate = async ()=>{
        if (!estimateStore.currentEstimate) return;
        await estimateStore.recalculateEstimate(estimateStore.currentEstimate);
        setShowRerunModal(false);
    };
    /** Render **/ const StatusToggle = ({ width: width })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            width: width,
            flex: "grow",
            direction: "row",
            gap: "small",
            pad: "small",
            align: "center",
            justify: "end",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    onClick: ()=>copyShareLink(),
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5yWN0.ShareOption), {
                        color: "plain"
                    }),
                    hoverIndicator: true,
                    tip: "Share this estimate"
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1fLUh.Heading), {
                    level: "6",
                    weight: "normal",
                    fill: false,
                    children: [
                        "STATUS\xa0",
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: 'Draft estimates are "ballpark" estimates. Final estimates have been approved by the client.'
                            }),
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cYfAm.CircleInformation), {
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                    // pad="medium"
                    label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        justify: "center",
                        width: "xxsmall",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            alignSelf: "center",
                            size: "small",
                            children: estimateStore.currentEstimate?.status?.toUpperCase()
                        })
                    }),
                    checked: estimateStore.currentEstimate?.status === (0, $djcqs.EstimateStatus).Final,
                    onChange: (event)=>estimateStore.currentEstimate?.id && updateEstimate({
                            ...estimateStore.currentEstimate,
                            status: event.target.checked ? (0, $djcqs.EstimateStatus).Final : (0, $djcqs.EstimateStatus).Draft
                        }),
                    toggle: true
                })
            ]
        });
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        pad: "medium",
        background: "light-2",
        margin: "medium",
        round: "medium",
        overflow: "auto",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        justify: "center",
                        margin: {
                            horizontal: 'small'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                flex: true
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                flex: true,
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                                    level: "3",
                                    alignSelf: "center",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                        val: estimateStore.currentEstimate?.title || '',
                                        onChange: (t)=>estimateStore.currentEstimate?.id && updateEstimate({
                                                ...estimateStore.currentEstimate,
                                                title: t
                                            }),
                                        textSize: "xlarge"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                justify: "center",
                                align: "end",
                                flex: true,
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lFfFS.SaveStatusIndicator), {
                                    saveStatus: saveStatus,
                                    boxProps: {
                                        margin: 'none'
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        justify: "between",
                        height: "xxsmall",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "25%",
                                align: "start",
                                justify: "center",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                    secondary: true,
                                    size: "small",
                                    label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        weight: "bold",
                                        children: "RECALCULATE"
                                    }),
                                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iwgRF.Refresh), {
                                        size: "16px"
                                    }),
                                    tip: "Re-run estimate",
                                    onClick: ()=>setShowRerunModal(true)
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                width: "50%",
                                flex: "grow",
                                direction: "row",
                                gap: "large",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        direction: "row",
                                        gap: "xsmall",
                                        align: "end",
                                        fill: "horizontal",
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                children: "TOTAL WAGES:"
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                weight: "bold",
                                                children: (0, $b1rqt.USD)(estimateStore.currentEstimate?.total)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        direction: "row",
                                        gap: "xsmall",
                                        align: "end",
                                        fill: "horizontal",
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                children: "GRAND TOTAL:"
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                weight: "bold",
                                                children: (0, $b1rqt.USD)(estimateStore.currentEstimate?.total_plus_fringe)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)(StatusToggle, {
                                width: "25%"
                            })
                        ]
                    })
                ]
            }),
            showRerunModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3W9FZ.ConfirmModal), {
                content: "NOTE: This will overwrite any edits made to this Estimate.",
                confirmLabel: "OK",
                onConfirm: ()=>recalculateEstimate(),
                onCancel: ()=>setShowRerunModal(false)
            })
        ]
    });
});

});
parcelRegister("cYfAm", function(module, exports) {

$parcel$export(module.exports, "CircleInformation", () => $97172d90eee19345$export$7036cd8426a1245b);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $97172d90eee19345$var$_extends() {
    return $97172d90eee19345$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $97172d90eee19345$var$_extends.apply(null, arguments);
}
var $97172d90eee19345$export$7036cd8426a1245b = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $97172d90eee19345$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleInformation"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-12v8m0-12v2"
    }));
});
$97172d90eee19345$export$7036cd8426a1245b.displayName = 'CircleInformation';

});

parcelRegister("iwgRF", function(module, exports) {

$parcel$export(module.exports, "Refresh", () => $d7b84c196f5dc6be$export$f93ec6528f706bfe);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $d7b84c196f5dc6be$var$_extends() {
    return $d7b84c196f5dc6be$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7b84c196f5dc6be$var$_extends.apply(null, arguments);
}
var $d7b84c196f5dc6be$export$f93ec6528f706bfe = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $d7b84c196f5dc6be$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Refresh"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 8c-1.403-2.96-4.463-5-8-5a9 9 0 1 0 0 18 9 9 0 0 0 9-9m0-9v6h-6"
    }));
});
$d7b84c196f5dc6be$export$f93ec6528f706bfe.displayName = 'Refresh';

});

parcelRegister("5yWN0", function(module, exports) {

$parcel$export(module.exports, "ShareOption", () => $40cdbb0f4d1e0c87$export$955d09dc9b28f767);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $40cdbb0f4d1e0c87$var$_extends() {
    return $40cdbb0f4d1e0c87$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $40cdbb0f4d1e0c87$var$_extends.apply(null, arguments);
}
var $40cdbb0f4d1e0c87$export$955d09dc9b28f767 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $40cdbb0f4d1e0c87$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ShareOption"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm12 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-2-4-8-5m8-7-8 5"
    }));
});
$40cdbb0f4d1e0c87$export$955d09dc9b28f767.displayName = 'ShareOption';

});


parcelRegister("iopSL", function(module, exports) {

$parcel$export(module.exports, "EstimateList", () => $ceec3faaeec3aaa9$export$d449bfc081af6bab);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $1fLUh = parcelRequire("1fLUh");
var $kS7Ii = parcelRequire("kS7Ii");
var $79HTA = parcelRequire("79HTA");

var $lBOUq = parcelRequire("lBOUq");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");
parcelRequire("ibR9R");
var $gdNyE = parcelRequire("gdNyE");
var $d9fGF = parcelRequire("d9fGF");
var $hF8pi = parcelRequire("hF8pi");
const $ceec3faaeec3aaa9$export$d449bfc081af6bab = (0, $j8yBr.observer)(({ gridArea: gridArea })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    const navigate = (0, $19GAm.useNavigate)();
    /** State **/ const [showModal, setShowModal] = (0, $2NacA.useState)(false);
    const [creating, setCreating] = (0, $2NacA.useState)(false);
    /** Methods **/ const deleteEstimate = async (id)=>{
        await estimateStore.deleteEstimate(id);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "column",
        pad: "medium",
        overflow: {
            vertical: 'auto'
        },
        align: "start",
        id: "Estimate-list",
        gridArea: gridArea,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1fLUh.Heading), {
                        level: "3",
                        margin: "medium",
                        children: "Estimates"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        disabled: creating,
                        onClick: ()=>setShowModal(true),
                        tipText: "New Estimate",
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lBOUq.Table), {})
                    })
                ]
            }),
            estimateStore.estimateList?.filter((estimate)=>!estimate.is_hidden).map((e)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
                            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: {
                                    max: 'medium'
                                },
                                background: "light-2",
                                round: "small",
                                pad: "small",
                                margin: "small",
                                border: "all",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: e.title
                                })
                            }),
                            plain: true,
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                pad: "small",
                                margin: "small",
                                hoverIndicator: true,
                                onClick: ()=>navigate(e.id),
                                label: e.title.length > 35 ? `${e.title.slice(0, 34)}...` : e.title,
                                active: e.id === estimateStore.currentEstimate?.id
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                            onClick: ()=>deleteEstimate(e.id),
                            name: e.title
                        })
                    ]
                }, e.id)),
            !estimateStore.estimateList?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "No previous Estimates found for this project."
            }),
            showModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d9fGF.CreateEstimateModal), {
                creating: creating,
                setCreating: setCreating,
                setShowModal: setShowModal
            })
        ]
    });
});

});
parcelRegister("lBOUq", function(module, exports) {

$parcel$export(module.exports, "Table", () => $fbb48b2cd7d9020f$export$54ec01a60f47d33d);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $fbb48b2cd7d9020f$var$_extends() {
    return $fbb48b2cd7d9020f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fbb48b2cd7d9020f$var$_extends.apply(null, arguments);
}
var $fbb48b2cd7d9020f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $fbb48b2cd7d9020f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Table"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 5v18m8-18v18M1 11h22M1 5h22M1 17h22M1 1h22v22H1V1z"
    }));
});
$fbb48b2cd7d9020f$export$54ec01a60f47d33d.displayName = 'Table';

});


parcelRegister("6Azq1", function(module, exports) {
$parcel$export(module.exports, "SessionEstimateList", () => (parcelRequire("byNl8")).SessionEstimateList);
parcelRequire("byNl8");

});
parcelRegister("byNl8", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateList", () => $65a752d9ac73b3c0$export$caf9353118418d6a);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $5Xkwu = parcelRequire("5Xkwu");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("gQLGd");
var $btEIO = parcelRequire("btEIO");

var $k0dWw = parcelRequire("k0dWw");

var $8DltC = parcelRequire("8DltC");
const $65a752d9ac73b3c0$export$caf9353118418d6a = (0, $j8yBr.observer)(()=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [showAddModal, setShowAddModal] = (0, $2NacA.useState)(false);
    /** Computed **/ const sessionEstimates = (0, $2NacA.useMemo)(()=>{
        const items = estimateStore.currentEstimate?.session_estimates;
        return items && [
            ...items
        ].sort((a, b)=>a.created_at > b.created_at ? 1 : -1);
    }, [
        estimateStore.currentEstimate?.session_estimates
    ]);
    /** Methods **/ const addSessionEstimate = async (title, date)=>{
        await estimateStore.createSessionEstimate(title, date);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gap: "small",
        margin: {
            horizontal: 'small',
            bottom: 'medium'
        },
        pad: "small",
        children: [
            estimateStore.canEditCurrent && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                alignSelf: "end",
                pad: {
                    vertical: 'xsmall'
                },
                margin: {
                    left: 'medium'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    secondary: true,
                    label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "small",
                        weight: "bold",
                        children: "ADD SESSION ESTIMATE"
                    }),
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5Xkwu.Add), {
                        size: "16px"
                    }),
                    tip: "Add estimate item",
                    onClick: ()=>setShowAddModal(true)
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                align: "center",
                children: sessionEstimates && !!sessionEstimates?.length ? sessionEstimates.map((sessionEstimate)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $k0dWw.SessionEstimatePanel), {
                        sessionEstimate: sessionEstimate
                    }, sessionEstimate.id)) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    align: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "No Session Estimates found."
                    })
                })
            }),
            estimateStore.canEditCurrent && showAddModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $btEIO.CreateSessionEstimateModal), {
                addSessionEstimate: addSessionEstimate,
                setShowModal: setShowAddModal
            })
        ]
    });
});

});
parcelRegister("k0dWw", function(module, exports) {

$parcel$export(module.exports, "SessionEstimatePanel", () => $d8026490d264b537$export$fe679510627f35b6);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $4BF6F = parcelRequire("4BF6F");

var $5cWXZ = parcelRequire("5cWXZ");

var $fwRkR = parcelRequire("fwRkR");

var $iibCn = parcelRequire("iibCn");
const $d8026490d264b537$export$fe679510627f35b6 = (0, $j8yBr.observer)(({ sessionEstimate: sessionEstimate })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [isUpdatingSession, setIsUpdatingSession] = (0, $2NacA.useState)(false);
    /** Computed **/ const estimateItems = (0, $2NacA.useMemo)(()=>{
        const items = sessionEstimate.items;
        return items && [
            ...items
        ].sort((a, b)=>a.created_at > b.created_at ? 1 : -1);
    }, [
        sessionEstimate.items
    ]);
    /** Methods **/ /**
   * Update this panel's SessionEstimate
   * @param sessionEstimate
   * @param sessionEstimateIndex
   * @returns
   */ const updateSessionEstimate = async (sessionEstimate)=>{
        if (isUpdatingSession) return;
        else if (!estimateStore.currentEstimate) {
            console.warn('No estimate loaded!');
            return;
        }
        setIsUpdatingSession(true);
        // The header puts an edited date on the SessionEstimate itself; sending session.date (as this
        // did) overwrote the edit with the date it already had
        await estimateStore.updateSessionEstimate(sessionEstimate.id, sessionEstimate.title, sessionEstimate.date ?? sessionEstimate.session?.date);
        setIsUpdatingSession(false);
    };
    const addEstimateItem = async ()=>{
        await estimateStore.createSessionEstimateItem(sessionEstimate.id);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        margin: "small",
        fill: "horizontal",
        round: "15px",
        background: "light-3",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fwRkR.SessionEstimateHeader), {
                sessionEstimate: sessionEstimate,
                setSessionEstimate: (sessionEstimate)=>updateSessionEstimate(sessionEstimate)
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iibCn.TitleRow), {
                        isUnion: sessionEstimate.session?.is_union
                    }),
                    estimateItems.map((item, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $4BF6F.SessionEstimateDataRow), {
                            sessionEstimateItem: item,
                            index: i,
                            useColors: true,
                            isUnion: sessionEstimate.session?.is_union
                        }, item.id))
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5cWXZ.SessionEstimateFooter), {
                addEstimateItem: addEstimateItem
            })
        ]
    }, sessionEstimate.id);
});

});
parcelRegister("4BF6F", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateDataRow", () => $91c58a49ec7efc44$export$75d16786e5084d7);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $7dV2j = parcelRequire("7dV2j");
parcelRequire("bRT7J");
var $7r0kC = parcelRequire("7r0kC");
var $1Ofsp = parcelRequire("1Ofsp");
var $6q7qM = parcelRequire("6q7qM");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $bDFk2 = parcelRequire("bDFk2");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
const $91c58a49ec7efc44$export$75d16786e5084d7 = (0, $j8yBr.observer)(({ sessionEstimateItem: sessionEstimateItem, index: index, useColors: useColors, isUnion: isUnion })=>{
    /** Refs **/ const defaultFormData = (0, $2NacA.useRef)({
        title: 'New Estimate Item',
        units: '1',
        unitType: (0, $7dV2j.SessionEstimateItemUnitType).Count,
        rate: '0',
        taxesMultiplier: '0',
        handlingMultiplier: '0',
        pAndHMultiplier: '0'
    });
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [showDeleteModal, setShowDeleteModal] = (0, $2NacA.useState)(false);
    const [formData, setFormData] = (0, $2NacA.useState)({
        title: sessionEstimateItem.title,
        units: sessionEstimateItem.units?.toString() ?? defaultFormData.current.units,
        unitType: sessionEstimateItem.unit_type ?? defaultFormData.current.unit_type,
        rate: sessionEstimateItem.rate?.toString() ?? defaultFormData.current.rate,
        taxesMultiplier: sessionEstimateItem.taxes_multiplier ? (sessionEstimateItem.taxes_multiplier * 100).toString() : defaultFormData.current.taxesMultiplier,
        handlingMultiplier: sessionEstimateItem.handling_multiplier ? (sessionEstimateItem.handling_multiplier * 100).toString() : defaultFormData.current.handlingMultiplier,
        pAndHMultiplier: sessionEstimateItem.p_and_h_multiplier ? (sessionEstimateItem.p_and_h_multiplier * 100).toString() : defaultFormData.current.pAndHMultiplier
    });
    /** Computed **/ const canEdit = estimateStore.canEditCurrent;
    /** Methods **/ const updateEstimateItem = async (data)=>{
        const { title: title, units: units, unitType: unitType, rate: rate, taxesMultiplier: taxesMultiplier, handlingMultiplier: handlingMultiplier, pAndHMultiplier: pAndHMultiplier } = data;
        await estimateStore.updateSessionEstimateItem(sessionEstimateItem.id, title, parseFloat(units || '0'), unitType, parseFloat(rate || '0'), parseFloat(taxesMultiplier || '0') / 100, parseFloat(handlingMultiplier || '0') / 100, parseFloat(pAndHMultiplier || '0') / 100);
    };
    const deleteEstimateItem = async ()=>{
        setShowDeleteModal(false);
        await estimateStore.deleteSessionEstimateItem(sessionEstimateItem.id);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "medium",
                pad: "medium",
                align: "center",
                background: useColors && !(index % 2) ? 'light-1' : 'white',
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        fill: "horizontal",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: formData.title,
                            onChange: (title)=>setFormData({
                                    ...formData,
                                    title: title
                                }),
                            onBlur: ()=>updateEstimateItem(formData),
                            onSubmit: ()=>updateEstimateItem(formData)
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: formData.title
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        width: "75%",
                        direction: "row",
                        gap: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                    val: formData.units,
                                    onChange: (units)=>{
                                        const data = {
                                            ...formData,
                                            units: units
                                        };
                                        setFormData(data);
                                        updateEstimateItem(data);
                                    },
                                    onBlur: ()=>updateEstimateItem(formData),
                                    onSubmit: ()=>updateEstimateItem(formData),
                                    minValue: 1,
                                    inputType: "number"
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: formData.units
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                                    val: formData.unitType,
                                    onChange: (unitType)=>{
                                        const data = {
                                            ...formData,
                                            unitType: unitType
                                        };
                                        setFormData(data);
                                        updateEstimateItem(data);
                                    },
                                    onBlur: ()=>updateEstimateItem(formData),
                                    onSubmit: ()=>updateEstimateItem(formData),
                                    options: Object.values((0, $7dV2j.SessionEstimateItemUnitType)).map((unitType)=>({
                                            label: (0, $9Rhqc.capitalize)(unitType),
                                            value: unitType
                                        })),
                                    capitalize: true
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: (0, $9Rhqc.capitalize)(formData.unitType)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "55%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: formData.rate,
                            onChange: (rate)=>{
                                const data = {
                                    ...formData,
                                    rate: rate
                                };
                                setFormData(data);
                                updateEstimateItem(data);
                            },
                            onBlur: ()=>updateEstimateItem(formData),
                            onSubmit: ()=>updateEstimateItem(formData),
                            inputType: "number",
                            isCurrency: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: (0, $b1rqt.USD)(formData.rate)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "60%",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            weight: 600,
                            children: (0, $b1rqt.USD)(sessionEstimateItem?.subtotal)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        width: "40%",
                        children: [
                            isUnion && (canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                val: formData.pAndHMultiplier,
                                onChange: (pAndHMultiplier)=>{
                                    const data = {
                                        ...formData,
                                        pAndHMultiplier: pAndHMultiplier
                                    };
                                    setFormData(data);
                                    updateEstimateItem(data);
                                },
                                onBlur: ()=>updateEstimateItem(formData),
                                onSubmit: ()=>updateEstimateItem(formData),
                                inputType: "number",
                                isPercent: true
                            }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                children: [
                                    formData.pAndHMultiplier,
                                    "%"
                                ]
                            })),
                            !isUnion && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: 300,
                                children: "\u2014"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "40%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: formData.handlingMultiplier,
                            onChange: (handlingMultiplier)=>{
                                const data = {
                                    ...formData,
                                    handlingMultiplier: handlingMultiplier
                                };
                                setFormData(data);
                                updateEstimateItem(data);
                            },
                            onBlur: ()=>updateEstimateItem(formData),
                            onSubmit: ()=>updateEstimateItem(formData),
                            inputType: "number",
                            isPercent: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            children: [
                                formData.handlingMultiplier,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "40%",
                        children: canEdit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: formData.taxesMultiplier,
                            onChange: (taxesMultiplier)=>{
                                const data = {
                                    ...formData,
                                    taxesMultiplier: taxesMultiplier
                                };
                                setFormData(data);
                                updateEstimateItem(data);
                            },
                            onBlur: ()=>updateEstimateItem(formData),
                            onSubmit: ()=>updateEstimateItem(formData),
                            inputType: "number",
                            isPercent: true
                        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            children: [
                                formData.taxesMultiplier,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "70%",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            weight: 600,
                            children: (0, $b1rqt.USD)(sessionEstimateItem?.subtotal_plus_fringe)
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "10%",
                        align: "center",
                        children: canEdit && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            plain: true,
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                                size: "16px",
                                color: "red"
                            }),
                            tip: `Delete ${sessionEstimateItem?.title}`,
                            onClick: ()=>setShowDeleteModal(true)
                        })
                    })
                ]
            }),
            canEdit && showDeleteModal && sessionEstimateItem && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7r0kC.DeleteModal), {
                name: sessionEstimateItem.title,
                onDelete: deleteEstimateItem,
                onCancel: ()=>setShowDeleteModal(false)
            })
        ]
    });
});

});

parcelRegister("5cWXZ", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateFooter", () => $8aa078fe7faf4f94$export$f3307e03e41dc004);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $5Xkwu = parcelRequire("5Xkwu");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $8DltC = parcelRequire("8DltC");
const $8aa078fe7faf4f94$export$f3307e03e41dc004 = (0, $j8yBr.observer)(({ addEstimateItem: addEstimateItem })=>{
    const estimateStore = (0, $8DltC.useEstimateStore)();
    const AddItemLabel = /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
        size: "small",
        weight: "bold",
        children: "ADD ITEM"
    });
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        gap: "small",
        pad: {
            vertical: 'small',
            horizontal: 'medium'
        },
        background: "white",
        style: {
            borderBottomLeftRadius: '15px',
            borderBottomRightRadius: '15px'
        },
        children: estimateStore.canEditCurrent && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            width: "15%",
            pad: {
                vertical: 'xsmall'
            },
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                secondary: true,
                label: AddItemLabel,
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5Xkwu.Add), {
                    size: "16px"
                }),
                tip: "Add estimate item",
                onClick: addEstimateItem
            })
        })
    });
});

});

parcelRegister("fwRkR", function(module, exports) {

$parcel$export(module.exports, "SessionEstimateHeader", () => $8f8fabd9ac839ffb$export$6df5c5c310ffc0e2);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $bgcVc = parcelRequire("bgcVc");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $94KEY = parcelRequire("94KEY");
var $czDw5 = parcelRequire("czDw5");
var $kS7Ii = parcelRequire("kS7Ii");
var $79HTA = parcelRequire("79HTA");

var $91ZpZ = parcelRequire("91ZpZ");
var $bDFk2 = parcelRequire("bDFk2");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $4Oriw = parcelRequire("4Oriw");

var $7r0kC = parcelRequire("7r0kC");

var $1Ofsp = parcelRequire("1Ofsp");
const $8f8fabd9ac839ffb$export$6df5c5c310ffc0e2 = (0, $j8yBr.observer)(({ sessionEstimate: sessionEstimate, setSessionEstimate: setSessionEstimate })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [showDeleteModal, setShowDeleteModal] = (0, $2NacA.useState)(false);
    const [title, setTitle] = (0, $2NacA.useState)(sessionEstimate.title);
    // Enter saves and then blur fires too, and blur used to save even when nothing changed - each
    // save recalculating the whole estimate. Only save a title that differs from the last one saved
    const lastSavedTitle = (0, $2NacA.useRef)(sessionEstimate.title);
    // The SessionEstimate's own date once one has been set here, otherwise its session's
    const [date, setDate] = (0, $2NacA.useState)(sessionEstimate.date ?? sessionEstimate.session?.date ?? '');
    /** Methods **/ const saveTitle = ()=>{
        if (title === lastSavedTitle.current) return;
        lastSavedTitle.current = title;
        setSessionEstimate({
            ...sessionEstimate,
            title: title
        });
    };
    const deleteSessionEstimate = async ()=>{
        await estimateStore.deleteSessionEstimate(sessionEstimate.id);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)',
                    borderTopLeftRadius: (0, $4Oriw.borderRadiusSize),
                    borderTopRightRadius: (0, $4Oriw.borderRadiusSize)
                },
                pad: "medium",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "xlarge",
                        children: estimateStore.canEditCurrent ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: title,
                            onChange: setTitle,
                            onSubmit: saveTitle,
                            onBlur: saveTitle
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        align: "center",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "DATE:"
                            }),
                            estimateStore.canEditCurrent ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $czDw5.Keyboard), {
                                onEnter: ()=>setSessionEstimate({
                                        ...sessionEstimate,
                                        date: date
                                    }),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                    format: "mm/dd/yyyy",
                                    value: date,
                                    calendarProps: {
                                        disabled: estimateStore.getSessionEstimateDates(sessionEstimate.id)
                                    },
                                    onChange: ({ value: value })=>setDate(typeof value === 'object' ? value[0] : value)
                                })
                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: (0, $bgcVc.formatDateOnly)(date)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "small",
                        children: sessionEstimate.session?.is_union && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
                            content: "Union Session",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $91ZpZ.Star), {
                                size: "1.2rem"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        align: "center",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "SESSION WAGES:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: "bold",
                                children: (0, $b1rqt.USD)(sessionEstimate.subtotal)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        align: "center",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "SESSION TOTAL:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: "bold",
                                children: (0, $b1rqt.USD)(sessionEstimate.subtotal_plus_fringe)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "10%",
                        align: "center",
                        children: estimateStore.canEditCurrent && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            plain: true,
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                                size: "16px",
                                color: "red"
                            }),
                            tip: `Delete ${sessionEstimate?.title}`,
                            onClick: ()=>setShowDeleteModal(true)
                        })
                    })
                ]
            }),
            estimateStore.canEditCurrent && showDeleteModal && sessionEstimate && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7r0kC.DeleteModal), {
                name: sessionEstimate.title,
                onDelete: deleteSessionEstimate,
                onCancel: ()=>setShowDeleteModal(false)
            })
        ]
    });
});

});
parcelRegister("91ZpZ", function(module, exports) {

$parcel$export(module.exports, "Star", () => $6933d966fca973e0$export$1644ba17714857f1);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $6933d966fca973e0$var$_extends() {
    return $6933d966fca973e0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6933d966fca973e0$var$_extends.apply(null, arguments);
}
var $6933d966fca973e0$export$1644ba17714857f1 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $6933d966fca973e0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Star"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#FFC95E",
        fillRule: "evenodd",
        d: "M12 16.667 5 22l3-8-6-4.5h7.5L12 2l2.5 7.5H22L16 14l3 8z"
    }));
});
$6933d966fca973e0$export$1644ba17714857f1.displayName = 'Star';

});


parcelRegister("iibCn", function(module, exports) {

$parcel$export(module.exports, "TitleRow", () => $53f53f783a4f3224$export$e3ee8ef29b7904ef);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
const $53f53f783a4f3224$export$e3ee8ef29b7904ef = (_props)=>{
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        gap: "medium",
        pad: {
            vertical: 'small',
            horizontal: 'medium'
        },
        border: {
            side: 'bottom',
            size: 'xsmall'
        },
        background: "white",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                fill: "horizontal",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "TITLE"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "75%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "UNITS"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "55%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "RATE"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "60%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    weight: 600,
                    children: "WAGES"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "P & H"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "HANDLING"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    children: "TAXES"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "70%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "small",
                    weight: 600,
                    children: "TOTAL"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "10%"
            })
        ]
    });
};

});





parcelRegister("2Y23d", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $4fbe7476652df583$export$8d5dab2ad1e19ea0);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");

var $lhDdJ = parcelRequire("lhDdJ");
const $4fbe7476652df583$export$8d5dab2ad1e19ea0 = (0, $j8yBr.observer)(({ project: project, buttonProps: buttonProps, iconProps: iconProps, size: size = '24px', hoveredSize: hoveredSize = '26px' })=>{
    /** Context **/ const userStore = (0, $8DltC.useUserStore)();
    /** State **/ const [favs, setFavs] = (0, $2NacA.useState)([]);
    const [isHovered, setIsHovered] = (0, $2NacA.useState)(false);
    /** Methods **/ const toggleLike = async (projectId)=>{
        const newfavs = favs.includes(projectId) ? favs.filter((id)=>id !== projectId) : [
            ...favs,
            projectId
        ];
        userStore.updateProfile({
            ...userStore.user,
            favorite_project_ids: newfavs
        });
    };
    /** Effects */ (0, $2NacA.useEffect)(()=>{
        if (!userStore.user.favorite_project_ids) return;
        setFavs(userStore.user.favorite_project_ids);
    }, [
        userStore.user.favorite_project_ids
    ]);
    /** Render */ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        justify: "center",
        align: "center",
        width: hoveredSize,
        height: hoveredSize,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
            plain: true,
            onMouseOver: ()=>setIsHovered(true),
            onMouseOut: ()=>setIsHovered(false),
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lhDdJ.FavoriteFilled), {
                filled: favs.includes(project.id) ? 'true' : undefined,
                size: isHovered ? hoveredSize : size,
                ...iconProps
            }),
            // hoverIndicator
            onClick: ()=>toggleLike(project.id),
            tip: "Favorite this project",
            ...buttonProps
        })
    });
});

});
parcelRegister("lhDdJ", function(module, exports) {

$parcel$export(module.exports, "FavoriteFilled", () => $19029f9330d44602$export$786f1e8e41e27ef7);

var $aFrfO = parcelRequire("aFrfO");
var $eNuJO = parcelRequire("eNuJO");

var $f5efw = parcelRequire("f5efw");
const $19029f9330d44602$var$filledIcon = (0, $f5efw.css)`
  path[fill='none'] {
    fill: rgb(229 36 59) !important;
  }
  polygon[fill='none'] {
    fill: rgb(229 36 59) !important;
  }
`;
const $19029f9330d44602$export$786f1e8e41e27ef7 = (0, $f5efw.default)((0, $aFrfO.Favorite))`
  ${(props)=>props.filled ? $19029f9330d44602$var$filledIcon : ''}
`;
const $19029f9330d44602$export$8248b4ad5e7e58c9 = (0, $f5efw.default)((0, $eNuJO.Filter))`
  ${(props)=>props.filled ? $19029f9330d44602$var$filledIcon : ''}
`;

});
parcelRegister("aFrfO", function(module, exports) {

$parcel$export(module.exports, "Favorite", () => $7c42dfd2fd094ef7$export$d71633542cb09b03);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $7c42dfd2fd094ef7$var$_extends() {
    return $7c42dfd2fd094ef7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7c42dfd2fd094ef7$var$_extends.apply(null, arguments);
}
var $7c42dfd2fd094ef7$export$d71633542cb09b03 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $7c42dfd2fd094ef7$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Favorite"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8.4C1 4 4.5 3 6.5 3 9 3 11 5 12 6.5 13 5 15 3 17.5 3c2 0 5.5 1 5.5 5.4C23 15 12 21 12 21S1 15 1 8.4z"
    }));
});
$7c42dfd2fd094ef7$export$d71633542cb09b03.displayName = 'Favorite';

});

parcelRegister("eNuJO", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $ac5d7c2f010b4d81$export$ec91da630f36d5ea);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $ac5d7c2f010b4d81$var$_extends() {
    return $ac5d7c2f010b4d81$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ac5d7c2f010b4d81$var$_extends.apply(null, arguments);
}
var $ac5d7c2f010b4d81$export$ec91da630f36d5ea = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $ac5d7c2f010b4d81$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Filter"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 6 7 7v8h4v-8l7-7V3H3z"
    }));
});
$ac5d7c2f010b4d81$export$ec91da630f36d5ea.displayName = 'Filter';

});



parcelRegister("eHq6M", function(module, exports) {

$parcel$export(module.exports, "ImpersonationBanner", () => $06dfa1d057c19ea0$export$e42af3bef2f16ed9);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");
parcelRequire("1Jz7s");
var $5wL0X = parcelRequire("5wL0X");

var $aIAdV = parcelRequire("aIAdV");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $9HK6v = parcelRequire("9HK6v");

var $cyrqa = parcelRequire("cyrqa");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
const $06dfa1d057c19ea0$export$e42af3bef2f16ed9 = (0, $j8yBr.observer)(()=>{
    const userStore = (0, $8DltC.useUserStore)();
    const impersonatorToken = (0, $aIAdV.default).get((0, $5wL0X.StorageProperties).ImpersonatorJwt);
    // Decoded only for the admin's name in the banner text — restoring the session on Exit re-uses
    // the raw token itself, not this decoded copy.
    const impersonator = (0, $2NacA.useMemo)(()=>{
        if (!impersonatorToken) return undefined;
        return $cyrqa.decode(impersonatorToken, {
            json: true
        })?.data;
    }, [
        impersonatorToken
    ]);
    if (!impersonatorToken) return null;
    const exitImpersonation = ()=>{
        userStore.applySession(impersonatorToken, impersonator);
        (0, $aIAdV.default).remove((0, $5wL0X.StorageProperties).ImpersonatorJwt);
        // Full reload, not navigate() — the impersonated user's data is still sitting in every other
        // store (projects, notifications, chat channels...); see ImpersonatePanel's startImpersonating
        // for the same reasoning in the other direction.
        window.location.href = '/admin';
    };
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        align: "center",
        justify: "center",
        gap: "small",
        background: "status-warning",
        pad: {
            vertical: 'xsmall',
            horizontal: 'medium'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9HK6v.UserExpert), {
                size: "18px"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                size: "small",
                children: [
                    "Viewing as ",
                    /*#__PURE__*/ (0, $6ir3O.jsx)("strong", {
                        children: `${userStore.user?.first_name} ${userStore.user?.last_name}`
                    }),
                    " (",
                    userStore.user?.email,
                    ")",
                    impersonator ? ` \u{2014} signed in as ${impersonator.first_name} ${impersonator.last_name}` : ''
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                label: "Exit",
                onClick: exitImpersonation,
                size: "small",
                plain: true,
                color: "dark-1"
            })
        ]
    });
});

});

parcelRegister("4QR02", function(module, exports) {
$parcel$export(module.exports, "LicensingRightsHeader", () => (parcelRequire("iq83q")).LicensingRightsHeader);
$parcel$export(module.exports, "RightDetailsModal", () => (parcelRequire("hkYJ0")).RightDetailsModal);
$parcel$export(module.exports, "RightPanel", () => (parcelRequire("i13h4")).RightPanel);
parcelRequire("bsXim");
parcelRequire("16I5H");
parcelRequire("hFSwv");
parcelRequire("i8nzl");
parcelRequire("iq83q");
parcelRequire("hkYJ0");
parcelRequire("4cofJ");
parcelRequire("9blr6");
parcelRequire("67bjB");
parcelRequire("i13h4");
parcelRequire("2JoMm");
parcelRequire("bTLvM");

});
parcelRegister("bsXim", function(module, exports) {

$parcel$export(module.exports, "AdditionalInformation", () => $a6b1834b7b04b5b8$export$98ffa4b418c78117);

var $6ir3O = parcelRequire("6ir3O");

var $4cofJ = parcelRequire("4cofJ");

var $9blr6 = parcelRequire("9blr6");

var $67bjB = parcelRequire("67bjB");
const $a6b1834b7b04b5b8$export$98ffa4b418c78117 = ({ background: background, restrictionsOnUse: restrictionsOnUse, notes: notes })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4cofJ.RightInfoCard), {
        title: "Additional Information",
        background: background,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $67bjB.RightInfoRow), {
            children: [
                restrictionsOnUse && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Restrictions on Use",
                    value: restrictionsOnUse
                }),
                notes && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Notes",
                    value: notes
                })
            ]
        })
    });
};

});
parcelRegister("4cofJ", function(module, exports) {

$parcel$export(module.exports, "RightInfoCard", () => $b73e6240c0a2c895$export$abead1b161772827);

var $6ir3O = parcelRequire("6ir3O");

var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $kS7Ii = parcelRequire("kS7Ii");

var $4Oriw = parcelRequire("4Oriw");
const $b73e6240c0a2c895$export$abead1b161772827 = ({ background: background = 'white', title: title, cardProps: cardProps, children: children })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        background: background,
        round: (0, $4Oriw.borderRadiusSize),
        border: {
            color: 'light-4',
            size: '1px'
        },
        elevation: "none",
        ...cardProps,
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)'
                },
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    weight: "bold",
                    size: "small",
                    children: title.toLocaleUpperCase()
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
                pad: "small",
                children: children
            })
        ]
    });

});

parcelRegister("9blr6", function(module, exports) {

$parcel$export(module.exports, "RightInfoItem", () => $481da160b69dfeb9$export$8e066fb59d063302);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");

var $jGT7M = parcelRequire("jGT7M");
const $481da160b69dfeb9$export$8e066fb59d063302 = ({ title: title, value: value, textSize: textSize = 'medium' })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        gap: "xsmall",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: "small",
                weight: "bold",
                children: title
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                height: "0.5px"
            }),
            typeof value === 'string' ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: textSize,
                children: value
            }) : value
        ]
    });

});

parcelRegister("67bjB", function(module, exports) {

$parcel$export(module.exports, "RightInfoRow", () => $dfc4affc839b5be2$export$59d9865f83e00fc2);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
const $dfc4affc839b5be2$export$59d9865f83e00fc2 = ({ children: children })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        direction: "row-responsive",
        gap: "large",
        wrap: true,
        children: children
    });

});


parcelRegister("16I5H", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");

var $bUuUi = parcelRequire("bUuUi");

var $4cofJ = parcelRequire("4cofJ");
const $8cc8047488c11aac$export$4b9e8925da6abb05 = ({ background: background, document: document })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4cofJ.RightInfoCard), {
        title: "Attached Document",
        background: background,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            pad: "small",
            gap: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bUuUi.DocumentLink), {
                    doc: document
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: document.name
                })
            ]
        })
    });
};

});
parcelRegister("bUuUi", function(module, exports) {

$parcel$export(module.exports, "DocumentLink", () => $062cb143322f3287$export$1b07bddf88ef7a8);

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $8DltC = parcelRequire("8DltC");

var $gJnkF = parcelRequire("gJnkF");
const $062cb143322f3287$export$1b07bddf88ef7a8 = ({ doc: doc, size: size = 'medium', color: color })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** Methods **/ const getSignedDownloadLink = async (id)=>{
        if (!id) return;
        const link = await projectStore.getSignedDownloadLink(id);
        if (link) window.open(link, '_blank');
        else (0, $bsB3E.toast).error('Error getting download link');
    };
    /** Render **/ const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).cloneElement((0, $gJnkF.documentConfig)[doc.type].icon, {
        a11yTitle: doc.type,
        onClick: ()=>getSignedDownloadLink(doc.id),
        size: size,
        color: color,
        style: {
            cursor: 'pointer'
        }
    });
    return icon;
};

});
parcelRegister("gJnkF", function(module, exports) {

$parcel$export(module.exports, "documentConfig", () => $45a159b56edf66a8$export$212bb3ca28d813e0);
$parcel$export(module.exports, "DocumentUploadModal", () => $45a159b56edf66a8$export$ea12f66ae499fa6d);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $6yFNt = parcelRequire("6yFNt");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $17uuk = parcelRequire("17uuk");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $1FJpI = parcelRequire("1FJpI");
var $R77gU = parcelRequire("R77gU");
var $j8ZCg = parcelRequire("j8ZCg");
var $gyf5K = parcelRequire("gyf5K");
var $83Wk3 = parcelRequire("83Wk3");
var $iuXEp = parcelRequire("iuXEp");
var $jK3Kk = parcelRequire("jK3Kk");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $az33k = parcelRequire("az33k");

var $l3pMM = parcelRequire("l3pMM");

var $d2VmQ = parcelRequire("d2VmQ");
const $45a159b56edf66a8$var$EXCEL = '.xls,.xlsx,.csv';
const $45a159b56edf66a8$var$WORD = '.docx';
const $45a159b56edf66a8$var$PDF = '.pdf';
const $45a159b56edf66a8$export$212bb3ca28d813e0 = {
    [(0, $6yFNt.DocumentType).Script]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gyf5K.DocumentText), {}),
        acceptable: [
            $45a159b56edf66a8$var$WORD,
            $45a159b56edf66a8$var$PDF
        ].join(','),
        allowsAi: true
    },
    [(0, $6yFNt.DocumentType).MediaPlan]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j8ZCg.DocumentPerformance), {}),
        acceptable: $45a159b56edf66a8$var$EXCEL,
        allowsAi: false
    },
    [(0, $6yFNt.DocumentType).ShootingSchedule]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $83Wk3.DocumentTime), {}),
        acceptable: $45a159b56edf66a8$var$EXCEL,
        allowsAi: false
    },
    [(0, $6yFNt.DocumentType).Storyboard]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jK3Kk.DocumentVideo), {}),
        acceptable: $45a159b56edf66a8$var$PDF,
        allowsAi: false
    },
    [(0, $6yFNt.DocumentType).License]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1FJpI.Certificate), {}),
        acceptable: [
            $45a159b56edf66a8$var$WORD,
            $45a159b56edf66a8$var$PDF
        ].join(','),
        allowsAi: true
    },
    [(0, $6yFNt.DocumentType).Contract]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gyf5K.DocumentText), {}),
        acceptable: [
            $45a159b56edf66a8$var$WORD,
            $45a159b56edf66a8$var$PDF
        ].join(','),
        allowsAi: false
    },
    [(0, $6yFNt.DocumentType).Generic]: {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gyf5K.DocumentText), {}),
        acceptable: [
            $45a159b56edf66a8$var$WORD,
            $45a159b56edf66a8$var$PDF,
            $45a159b56edf66a8$var$EXCEL
        ].join(','),
        allowsAi: false
    }
};
const $45a159b56edf66a8$export$ea12f66ae499fa6d = ({ documentTypes: documentTypes, setShowUpload: setShowUpload, successCallback: successCallback, allowAi: allowAi })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ const [loading, setLoading] = (0, $2NacA.useState)(false);
    const [acceptable, setAcceptable] = (0, $2NacA.useState)('');
    const [fileType, setFileType] = (0, $2NacA.useState)('');
    const [useAi, setUseAi] = (0, $2NacA.useState)(allowAi || false);
    /** Methods **/ const chooseUploadFileType = (type)=>{
        setAcceptable($45a159b56edf66a8$export$212bb3ca28d813e0[type].acceptable);
        setFileType(type);
    };
    const doUpload = async (e)=>{
        const files = e?.target?.files;
        if (!files?.[0] || !fileType) return;
        setLoading(true);
        const doc = await projectStore.createDocument(files[0], fileType, useAi ? 'true' : 'false');
        if (!doc) (0, $bsB3E.toast).error('Error uploading document');
        setLoading(false);
        setShowUpload(false);
        successCallback?.(doc);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (documentTypes?.length === 1) {
            setFileType(documentTypes[0]);
            setAcceptable($45a159b56edf66a8$export$212bb3ca28d813e0[documentTypes[0]].acceptable);
        }
    }, [
        documentTypes
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $az33k.ModalCard), {
        onClose: ()=>setShowUpload(false),
        title: "Upload Document",
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iuXEp.DocumentUpload), {}),
        children: [
            !loading && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                children: [
                    documentTypes?.length === 1 ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Upload a ",
                            documentTypes[0],
                            " Document"
                        ]
                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                        options: Object.keys($45a159b56edf66a8$export$212bb3ca28d813e0).filter((key)=>documentTypes ? documentTypes.includes(key) : true).map((key)=>({
                                name: key,
                                id: key
                            })),
                        onChange: (value)=>chooseUploadFileType(value),
                        placeholder: "Choose document type...",
                        size: "medium",
                        clear: true
                    }),
                    fileType && $45a159b56edf66a8$export$212bb3ca28d813e0[fileType]?.allowsAi && allowAi && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        align: "center",
                        gap: "small",
                        margin: {
                            top: 'small',
                            bottom: 'small'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                label: "Use AI",
                                checked: useAi,
                                onChange: (e)=>setUseAi(e.target.checked)
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Use AI to extract information from document and automatically populate data in Talon"
                                }),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $R77gU.CircleQuestion), {
                                        color: "brand"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $17uuk.FileInput), {
                        name: "file",
                        onChange: (e)=>doUpload(e),
                        accept: acceptable,
                        disabled: !acceptable,
                        messages: {
                            dropPrompt: 'Drop document here or click to browse',
                            browse: 'Browse'
                        }
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        children: [
                            acceptable && 'Acceptable file types: ',
                            acceptable
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                size: "large",
                background: "light-1",
                alignSelf: "center",
                margin: "small"
            })
        ]
    });
};

});
parcelRegister("1FJpI", function(module, exports) {

$parcel$export(module.exports, "Certificate", () => $137cd900dc3922ee$export$ca20b3ed1788c40a);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $137cd900dc3922ee$var$_extends() {
    return $137cd900dc3922ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $137cd900dc3922ee$var$_extends.apply(null, arguments);
}
var $137cd900dc3922ee$export$ca20b3ed1788c40a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $137cd900dc3922ee$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Certificate"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        stroke: "#000",
        strokeWidth: "2",
        fill: "none",
        d: "M15 19H2V1h16v4m0 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-3 9v8l3-2 3 2v-8M5 8h6m-6 3h5m-5 3h2M5 5h2"
    }));
});
$137cd900dc3922ee$export$ca20b3ed1788c40a.displayName = 'Certificate';

});

parcelRegister("R77gU", function(module, exports) {

$parcel$export(module.exports, "CircleQuestion", () => $09fa787f9bbbb73b$export$59596d9b033ace49);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $09fa787f9bbbb73b$var$_extends() {
    return $09fa787f9bbbb73b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $09fa787f9bbbb73b$var$_extends.apply(null, arguments);
}
var $09fa787f9bbbb73b$export$59596d9b033ace49 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $09fa787f9bbbb73b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleQuestion"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-7v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    }));
});
$09fa787f9bbbb73b$export$59596d9b033ace49.displayName = 'CircleQuestion';

});

parcelRegister("j8ZCg", function(module, exports) {

$parcel$export(module.exports, "DocumentPerformance", () => $defe8f578d6b4bbe$export$79ca5226d76bea73);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $defe8f578d6b4bbe$var$_extends() {
    return $defe8f578d6b4bbe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $defe8f578d6b4bbe$var$_extends.apply(null, arguments);
}
var $defe8f578d6b4bbe$export$79ca5226d76bea73 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $defe8f578d6b4bbe$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentPerformance"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23H4M18 1v5h5M3 19l5-5 4 4 6.5-6.5M19 17v-6h-6"
    }));
});
$defe8f578d6b4bbe$export$79ca5226d76bea73.displayName = 'DocumentPerformance';

});

parcelRegister("gyf5K", function(module, exports) {

$parcel$export(module.exports, "DocumentText", () => $c0cb8739c1006989$export$1b5fea8128845fdf);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $c0cb8739c1006989$var$_extends() {
    return $c0cb8739c1006989$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c0cb8739c1006989$var$_extends.apply(null, arguments);
}
var $c0cb8739c1006989$export$1b5fea8128845fdf = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $c0cb8739c1006989$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentText"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M6 16h10H6zm0-4h12H6zm0-4h5-5zm8-7v7h7M3 23V1h12l6 6v16H3z"
    }));
});
$c0cb8739c1006989$export$1b5fea8128845fdf.displayName = 'DocumentText';

});

parcelRegister("83Wk3", function(module, exports) {

$parcel$export(module.exports, "DocumentTime", () => $5debd8304829aae9$export$cdf4ab476395e3a);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $5debd8304829aae9$var$_extends() {
    return $5debd8304829aae9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5debd8304829aae9$var$_extends.apply(null, arguments);
}
var $5debd8304829aae9$export$cdf4ab476395e3a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $5debd8304829aae9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentTime"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23h-6m1-22v5h5M10 23a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-11v4l3 3"
    }));
});
$5debd8304829aae9$export$cdf4ab476395e3a.displayName = 'DocumentTime';

});

parcelRegister("iuXEp", function(module, exports) {

$parcel$export(module.exports, "DocumentUpload", () => $d7794cbe3f3598ed$export$9141d115599e4e05);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $d7794cbe3f3598ed$var$_extends() {
    return $d7794cbe3f3598ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7794cbe3f3598ed$var$_extends.apply(null, arguments);
}
var $d7794cbe3f3598ed$export$9141d115599e4e05 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $d7794cbe3f3598ed$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentUpload"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2.998 1H17.5L21 4.5V23H3L2.998 1zM16 1v5h5m-9 14v-9m-4 3 4-4 4 4"
    }));
});
$d7794cbe3f3598ed$export$9141d115599e4e05.displayName = 'DocumentUpload';

});

parcelRegister("jK3Kk", function(module, exports) {

$parcel$export(module.exports, "DocumentVideo", () => $e5f5381a38b83e10$export$971a01590c824813);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $e5f5381a38b83e10$var$_extends() {
    return $e5f5381a38b83e10$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e5f5381a38b83e10$var$_extends.apply(null, arguments);
}
var $e5f5381a38b83e10$export$971a01590c824813 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $e5f5381a38b83e10$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentVideo"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 7V1H19.5L23 4.5V23H4M18 1v5h5M3 10h9v9H3v-9zm9 3 5-2.5v8L12 16v-3z"
    }));
});
$e5f5381a38b83e10$export$971a01590c824813.displayName = 'DocumentVideo';

});

parcelRegister("l3pMM", function(module, exports) {

$parcel$export(module.exports, "Selector", () => $d8ce75891330f20e$export$d15f4cd5286f9b1e);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $fdtj0 = parcelRequire("fdtj0");

var $1Dqsr = parcelRequire("1Dqsr");

var $2NacA = parcelRequire("2NacA");
const $d8ce75891330f20e$export$d15f4cd5286f9b1e = ({ options: options = [], value: value = '', onChange: onChange, placeholder: placeholder = 'Select...', size: size = 'medium', clear: clear = false, labelKey: labelKey = 'name', iconColor: iconColor = 'accent-1' })=>{
    const [val, setVal] = (0, $2NacA.useState)(value);
    const [opts, setOpts] = (0, $2NacA.useState)(options);
    (0, $2NacA.useEffect)(()=>{
        setVal(value);
    }, [
        value
    ]);
    (0, $2NacA.useEffect)(()=>{
        setOpts(options);
    }, [
        options
    ]);
    const update = (newVal)=>{
        setVal(newVal);
        onChange(newVal);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
            size: size,
            placeholder: placeholder,
            onClose: ()=>setOpts(options || []),
            onSearch: (text)=>{
                // The line below escapes regular expression special characters:
                // [ \ ^ $ . | ? * + ( )
                const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
                // Create the regular expression with modified value which
                // handles escaping special characters. Without escaping special
                // characters, errors will appear in the console
                const exp = new RegExp(escapedText, 'i');
                setOpts(options.filter((o)=>exp.test(o.name)));
            },
            icon: iconColor ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Dqsr.Down), {
                size: "small",
                color: iconColor
            }) : undefined,
            labelKey: labelKey,
            // valueLabel={(projectId: TProjectId) => {
            //   const project = opts.find((p) => p.id === projectId);
            //   return project ? <Text color={textColor}>{project.name}</Text> : undefined;
            // }}
            valueKey: {
                key: 'id',
                reduce: true
            },
            value: val,
            options: opts,
            onChange: ({ value: nextValue })=>update(nextValue),
            clear: clear,
            plain: true
        })
    });
};

});
parcelRegister("1Dqsr", function(module, exports) {

$parcel$export(module.exports, "Down", () => $130df4f025834689$export$b30b8791dbbface4);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");

var $6dmSR = parcelRequire("6dmSR");
function $130df4f025834689$var$_extends() {
    return $130df4f025834689$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $130df4f025834689$var$_extends.apply(null, arguments);
}
var $130df4f025834689$export$b30b8791dbbface4 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var scaleProps = (0, $6dmSR.useScaleProps)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $130df4f025834689$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Down"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $130df4f025834689$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 8.35 10.173 9.823L21.997 8"
    }, scaleProps)));
});
$130df4f025834689$export$b30b8791dbbface4.displayName = 'Down';

});





parcelRegister("hFSwv", function(module, exports) {

$parcel$export(module.exports, "BasicInformation", () => $93ce4af9a75f1881$export$44786102b86590cb);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");

var $1G16z = parcelRequire("1G16z");

var $4cofJ = parcelRequire("4cofJ");

var $9blr6 = parcelRequire("9blr6");

var $67bjB = parcelRequire("67bjB");
const $93ce4af9a75f1881$export$44786102b86590cb = ({ background: background, right: right })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4cofJ.RightInfoCard), {
        title: "Basic Information",
        background: background,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $67bjB.RightInfoRow), {
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Description",
                    value: right.description || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Type",
                    value: right.rightType || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Status",
                    value: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        align: "center",
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                round: "50%",
                                width: "10px",
                                height: "10px",
                                background: (0, $1G16z.getRightStatusColor)(right.status)
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                truncate: true,
                                color: (0, $1G16z.getRightStatusColor)(right.status),
                                weight: 500,
                                size: "medium",
                                children: right.status || 'Not specified'
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Commercials",
                    value: right.commercials?.length ? right.commercials.map((c)=>c.title).join(', ') : 'All Commercials'
                })
            ]
        })
    });
};

});

parcelRegister("i8nzl", function(module, exports) {

$parcel$export(module.exports, "ContactInformation", () => $a6da441583252710$export$3021208a897d982);

var $6ir3O = parcelRequire("6ir3O");

var $4cofJ = parcelRequire("4cofJ");

var $9blr6 = parcelRequire("9blr6");

var $67bjB = parcelRequire("67bjB");
const $a6da441583252710$export$3021208a897d982 = ({ background: background, right: right })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4cofJ.RightInfoCard), {
        title: "Contact Information",
        background: background,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $67bjB.RightInfoRow), {
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Licensor",
                    value: right.licensor || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Licensee",
                    value: right.licensee || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Rights Admin",
                    value: right.rightsAdmin || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Phone",
                    value: right.phone || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Email",
                    value: right.email || 'Not specified'
                })
            ]
        })
    });
};

});

parcelRegister("iq83q", function(module, exports) {

$parcel$export(module.exports, "LicensingRightsHeader", () => $120cdee30c832e64$export$188a184744feadbe);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $kS7Ii = parcelRequire("kS7Ii");

var $1FJpI = parcelRequire("1FJpI");
var $iuXEp = parcelRequire("iuXEp");
var $bDFk2 = parcelRequire("bDFk2");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $8DltC = parcelRequire("8DltC");

var $1G16z = parcelRequire("1G16z");

var $gdNyE = parcelRequire("gdNyE");

var $jGT7M = parcelRequire("jGT7M");

var $lFfFS = parcelRequire("lFfFS");
const $120cdee30c832e64$export$188a184744feadbe = (0, $j8yBr.observer)(({ onCreate: onCreate, onUpload: onUpload, onDelete: onDelete, selected: selected, height: height = {
    min: '92px',
    max: '92px'
} })=>{
    /** Context **/ const rightStore = (0, $8DltC.useRightStore)();
    /** Computed **/ const saveStatus = rightStore.isSaving ? (0, $lFfFS.SaveStatus).Saving : (0, $lFfFS.SaveStatus).Saved;
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        background: "light-3",
        direction: "row",
        align: "center",
        justify: "between",
        height: height,
        gap: "medium",
        style: {
            zIndex: 1
        },
        elevation: "small",
        pad: {
            right: 'medium'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                gap: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        margin: {
                            left: 'medium'
                        },
                        animation: (0, $1G16z.getAnimProps)(0, 'slideUp'),
                        justify: "start",
                        direction: "row",
                        pad: {
                            right: 'none'
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            truncate: true,
                            size: "xlarge",
                            children: "Licensing & Rights"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                        height: "2px",
                        animation: {
                            type: 'slideRight',
                            size: 'xlarge'
                        }
                    }),
                    saveStatus && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "end",
                        animation: (0, $1G16z.getAnimProps)(0, 'slideDown'),
                        pad: {
                            right: 'none'
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lFfFS.SaveStatusIndicator), {
                            saveStatus: saveStatus,
                            boxProps: {
                                margin: 'none'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        onClick: onUpload,
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iuXEp.DocumentUpload), {}),
                        tipText: "Upload License/Rights Document"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        onClick: onCreate,
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1FJpI.Certificate), {}),
                        tipText: "New Licensing & Rights"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        disabled: selected.length === 0,
                        onClick: onDelete,
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                            color: "status-critical"
                        }),
                        tip: "Remove Right"
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("hkYJ0", function(module, exports) {

$parcel$export(module.exports, "RightDetailsModal", () => $14b1d39836b87b76$export$4c608fad233ad9a5);

var $6ir3O = parcelRequire("6ir3O");

var $5uWb8 = parcelRequire("5uWb8");

var $iCMh0 = parcelRequire("iCMh0");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $94KEY = parcelRequire("94KEY");
var $8Ao5G = parcelRequire("8Ao5G");
var $2fsW3 = parcelRequire("2fsW3");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");
var $k5B6T = parcelRequire("k5B6T");
var $kQZ06 = parcelRequire("kQZ06");

var $1FJpI = parcelRequire("1FJpI");
var $iuXEp = parcelRequire("iuXEp");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $lVeRZ = parcelRequire("lVeRZ");
parcelRequire("ibR9R");
var $gdNyE = parcelRequire("gdNyE");
var $6qg9k = parcelRequire("6qg9k");
parcelRequire("hcQWc");
var $6yFNt = parcelRequire("6yFNt");
var $cVyZf = parcelRequire("cVyZf");
var $kO7OK = parcelRequire("kO7OK");

var $8DltC = parcelRequire("8DltC");

var $bgcVc = parcelRequire("bgcVc");

var $az33k = parcelRequire("az33k");

var $bUuUi = parcelRequire("bUuUi");

var $gJnkF = parcelRequire("gJnkF");
const $14b1d39836b87b76$var$RightSchema = $lVeRZ.object({
    description: $lVeRZ.string().optional(),
    rightType: $lVeRZ.nativeEnum((0, $kO7OK.RightType)),
    status: $lVeRZ.nativeEnum((0, $cVyZf.RightStatus)).optional(),
    termFromDate: $lVeRZ.string().min(1, 'Start date is required'),
    termToDate: $lVeRZ.string().optional(),
    media: $lVeRZ.string().min(1, 'Media is required'),
    territories: $lVeRZ.string().min(1, 'Territories is required'),
    licensor: $lVeRZ.string().min(1, 'Licensor is required'),
    licensee: $lVeRZ.string().min(1, 'Licensee is required'),
    rightsAdmin: $lVeRZ.string().min(1, 'Rights admin is required'),
    phone: $lVeRZ.string().min(1, 'Phone is required'),
    email: $lVeRZ.string().email('Invalid email format').min(1, 'Email is required'),
    restrictionsOnUse: $lVeRZ.string().optional(),
    notes: $lVeRZ.string().optional(),
    document: $lVeRZ.custom().optional().nullable(),
    commercialIds: $lVeRZ.array($lVeRZ.string()).optional()
});
const $14b1d39836b87b76$export$4c608fad233ad9a5 = ({ right: right, onClose: onClose, onSuccess: onSuccess, mode: mode = 'edit', advertiserId: advertiserId, projectId: projectId })=>{
    const rightStore = (0, $8DltC.useRightStore)();
    const commercialStore = (0, $8DltC.useCommercialStore)();
    const [loading, setLoading] = (0, $2NacA.useState)(false);
    const [showUploadModal, setShowUploadModal] = (0, $2NacA.useState)(false);
    const [commercials, setCommercials] = (0, $2NacA.useState)([]);
    (0, $2NacA.useEffect)(()=>{
        const fetchCommercials = async ()=>{
            if (!projectId) return;
            const fetched = await commercialStore.listCommercialsByProjectId(projectId);
            if (fetched) setCommercials(fetched);
        };
        fetchCommercials();
    }, [
        projectId,
        commercialStore
    ]);
    const handleSubmit = async (values)=>{
        if (mode === 'edit' && !right) {
            (0, $bsB3E.toast).error('Right not found');
            return;
        }
        if (loading) return;
        try {
            setLoading(true);
            if (mode === 'create') {
                // Create new right
                const createRequest = {
                    description: values.description,
                    rightType: values.rightType,
                    status: values.status,
                    termFromDate: values.termFromDate,
                    termToDate: values.termToDate,
                    media: values.media,
                    territories: values.territories,
                    licensor: values.licensor,
                    licensee: values.licensee,
                    rightsAdmin: values.rightsAdmin,
                    phone: values.phone,
                    email: values.email,
                    restrictionsOnUse: values.restrictionsOnUse,
                    notes: values.notes,
                    advertiserId: advertiserId,
                    documentId: values.document?.id || undefined,
                    commercialIds: values.commercialIds
                };
                const result = await rightStore.createRight(createRequest);
                if (result) {
                    (0, $bsB3E.toast).success('Right created successfully');
                    onSuccess();
                } else (0, $bsB3E.toast).error('Failed to create right');
            } else {
                // Update existing right
                if (!right || !right.id) {
                    (0, $bsB3E.toast).error('Right data is missing');
                    return;
                }
                const updatedRight = {
                    ...right,
                    id: right.id,
                    description: values.description || '',
                    rightType: values.rightType,
                    status: values.status,
                    termFromDate: values.termFromDate,
                    termToDate: values.termToDate || undefined,
                    media: values.media,
                    territories: values.territories,
                    licensor: values.licensor,
                    licensee: values.licensee,
                    rightsAdmin: values.rightsAdmin,
                    phone: values.phone,
                    email: values.email,
                    restrictionsOnUse: values.restrictionsOnUse || '',
                    notes: values.notes || '',
                    commercials: commercials.filter((c)=>(values.commercialIds || []).includes(c.id))
                };
                const result = await rightStore.updateRight(updatedRight, values.document?.id || undefined);
                if (result) {
                    (0, $bsB3E.toast).success('Right updated successfully');
                    onSuccess();
                } else (0, $bsB3E.toast).error('Failed to update right');
            }
        } catch (error) {
            console.error(`Error ${mode === 'create' ? 'creating' : 'updating'} right:`, error);
            (0, $bsB3E.toast).error(`Failed to ${mode === 'create' ? 'create' : 'update'} right`);
        } finally{
            setLoading(false);
        }
    };
    const initialValues = {
        description: right?.description || '',
        rightType: right?.rightType || (0, $kO7OK.RightType).OTHER,
        status: right?.status || (0, $cVyZf.RightStatus).ACTIVE,
        termFromDate: (0, $bgcVc.toDateOnly)(right?.termFromDate),
        termToDate: (0, $bgcVc.toDateOnly)(right?.termToDate),
        media: right?.media || '',
        territories: right?.territories || '',
        licensor: right?.licensor || '',
        licensee: right?.licensee || '',
        rightsAdmin: right?.rightsAdmin || '',
        phone: right?.phone || '',
        email: right?.email || '',
        restrictionsOnUse: right?.restrictionsOnUse || '',
        notes: right?.notes || '',
        document: right?.document || null,
        commercialIds: right?.commercials?.map((c)=>c.id) || []
    };
    const rightTypeOptions = Object.values((0, $kO7OK.RightType)).map((type)=>({
            label: type,
            value: type
        }));
    const statusOptions = Object.values((0, $cVyZf.RightStatus)).map((status)=>({
            label: status,
            value: status
        }));
    const commercialOptions = commercials.map((c)=>({
            label: c.title,
            value: c.id
        }));
    const documentUploadCallback = (values)=>{
        if (!values.document) return;
        if (mode === 'edit') // save the document to the right immediately
        handleSubmit({
            ...values
        });
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $az33k.ModalCard), {
        onClose: onClose,
        title: mode === 'create' ? 'Create New Right' : 'Edit Right Details',
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1FJpI.Certificate), {
            size: "24px"
        }),
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5uWb8.Formik), {
            initialValues: initialValues,
            validate: (0, $iCMh0.withZodSchema)($14b1d39836b87b76$var$RightSchema),
            onSubmit: handleSubmit,
            enableReinitialize: true,
            children: ({ values: values, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, isSubmitting: isSubmitting, dirty: dirty, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5uWb8.Form), {
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            gap: "medium",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6qg9k.ModalInfoCard), {
                                    title: "Basic Information",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Description",
                                            name: "description",
                                            error: touched.description && errors.description,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                id: "description",
                                                name: "description",
                                                value: values.description,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                placeholder: "Brief description of the right"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            gap: "medium",
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Right Type",
                                                    name: "rightType",
                                                    error: touched.rightType && errors.rightType,
                                                    required: true,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                                        id: "rightType",
                                                        name: "rightType",
                                                        value: values.rightType,
                                                        options: rightTypeOptions,
                                                        onChange: ({ option: option })=>setFieldValue('rightType', option.value),
                                                        onBlur: handleBlur
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Status",
                                                    name: "status",
                                                    error: touched.status && errors.status,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                                        id: "status",
                                                        name: "status",
                                                        value: values.status,
                                                        options: statusOptions,
                                                        onChange: ({ option: option })=>setFieldValue('status', option.value),
                                                        onBlur: handleBlur
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Commercials",
                                            name: "commercialIds",
                                            error: touched.commercialIds && errors.commercialIds,
                                            help: "Leave empty to apply this right to all commercials in this production",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                                id: "commercialIds",
                                                name: "commercialIds",
                                                multiple: true,
                                                closeOnChange: false,
                                                placeholder: "All Commercials",
                                                value: values.commercialIds,
                                                options: commercialOptions,
                                                valueKey: {
                                                    key: 'value',
                                                    reduce: true
                                                },
                                                labelKey: "label",
                                                onChange: ({ value: value })=>setFieldValue('commercialIds', value),
                                                disabled: commercialOptions.length === 0
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6qg9k.ModalInfoCard), {
                                    title: "Term Information",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            gap: "medium",
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Term From Date",
                                                    name: "termFromDate",
                                                    error: touched.termFromDate && errors.termFromDate,
                                                    required: true,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                                        id: "termFromDate",
                                                        name: "termFromDate",
                                                        value: values.termFromDate,
                                                        onChange: ({ value: value })=>setFieldValue('termFromDate', (0, $bgcVc.fromDateInputChange)(value)),
                                                        onBlur: handleBlur,
                                                        // "yyyy-mm-dd" (not "mm/dd/yyyy" like the rest of the app) was
                                                        // misdetected as a range format by Grommet, since its internal
                                                        // `range` check is just `format.includes('-')` - it doesn't
                                                        // distinguish a single date's own separator from an actual
                                                        // "start - end" range format. That silently turned every typed
                                                        // value into a one-element array and corrupted the sibling field.
                                                        format: "mm/dd/yyyy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Term To Date",
                                                    name: "termToDate",
                                                    error: touched.termToDate && errors.termToDate,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                                        id: "termToDate",
                                                        name: "termToDate",
                                                        value: values.termToDate,
                                                        onChange: ({ value: value })=>setFieldValue('termToDate', (0, $bgcVc.fromDateInputChange)(value)),
                                                        onBlur: handleBlur,
                                                        format: "mm/dd/yyyy"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Media",
                                            name: "media",
                                            error: touched.media && errors.media,
                                            required: true,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                id: "media",
                                                name: "media",
                                                value: values.media,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                placeholder: "TV, Radio, Digital, etc."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Territories",
                                            name: "territories",
                                            error: touched.territories && errors.territories,
                                            required: true,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                id: "territories",
                                                name: "territories",
                                                value: values.territories,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                placeholder: "United States, Canada, etc."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6qg9k.ModalInfoCard), {
                                    title: "Contact Information",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            gap: "medium",
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Licensor",
                                                    name: "licensor",
                                                    error: touched.licensor && errors.licensor,
                                                    required: true,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                        id: "licensor",
                                                        name: "licensor",
                                                        value: values.licensor,
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        placeholder: "Licensing company or individual"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Licensee",
                                                    name: "licensee",
                                                    error: touched.licensee && errors.licensee,
                                                    required: true,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                        id: "licensee",
                                                        name: "licensee",
                                                        value: values.licensee,
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        placeholder: "Licensed company or individual"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Rights Administrator",
                                            name: "rightsAdmin",
                                            error: touched.rightsAdmin && errors.rightsAdmin,
                                            required: true,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                id: "rightsAdmin",
                                                name: "rightsAdmin",
                                                value: values.rightsAdmin,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                placeholder: "Person managing this right"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            gap: "medium",
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Phone",
                                                    name: "phone",
                                                    error: touched.phone && errors.phone,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2fsW3.MaskedInput), {
                                                        mask: [
                                                            {
                                                                fixed: '('
                                                            },
                                                            {
                                                                length: 3,
                                                                regexp: /^[0-9]{1,3}$/,
                                                                placeholder: 'xxx'
                                                            },
                                                            {
                                                                fixed: ')'
                                                            },
                                                            {
                                                                fixed: ' '
                                                            },
                                                            {
                                                                length: 3,
                                                                regexp: /^[0-9]{1,3}$/,
                                                                placeholder: 'xxx'
                                                            },
                                                            {
                                                                fixed: '-'
                                                            },
                                                            {
                                                                length: 4,
                                                                regexp: /^[0-9]{1,4}$/,
                                                                placeholder: 'xxxx'
                                                            }
                                                        ],
                                                        id: "phone",
                                                        name: "phone",
                                                        value: values.phone,
                                                        onChange: handleChange,
                                                        onBlur: handleBlur
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                                    label: "Email",
                                                    name: "email",
                                                    error: touched.email && errors.email,
                                                    required: true,
                                                    width: "50%",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                                                        id: "email",
                                                        name: "email",
                                                        value: values.email,
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        type: "email",
                                                        placeholder: "Contact email address"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6qg9k.ModalInfoCard), {
                                    title: "Additional Information",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Restrictions on Use",
                                            name: "restrictionsOnUse",
                                            error: touched.restrictionsOnUse && errors.restrictionsOnUse,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $k5B6T.TextArea), {
                                                id: "restrictionsOnUse",
                                                name: "restrictionsOnUse",
                                                value: values.restrictionsOnUse,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                placeholder: "Any restrictions or limitations on usage",
                                                rows: 3
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Notes",
                                            name: "notes",
                                            error: touched.notes && errors.notes,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $k5B6T.TextArea), {
                                                id: "notes",
                                                name: "notes",
                                                value: values.notes,
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                placeholder: "Additional notes or comments",
                                                rows: 3
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    gap: "medium",
                                    justify: "between",
                                    align: "center",
                                    children: [
                                        values?.document ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "column",
                                            gap: "small",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bUuUi.DocumentLink), {
                                                    doc: values.document
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    size: "small",
                                                    children: values.document.name
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                                            onClick: ()=>setShowUploadModal(true),
                                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iuXEp.DocumentUpload), {}),
                                            tipText: "Upload License/Rights Document"
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "row",
                                            gap: "medium",
                                            justify: "end",
                                            margin: {
                                                vertical: 'small'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                                    label: "Cancel",
                                                    onClick: onClose,
                                                    disabled: loading || isSubmitting
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                                    primary: true,
                                                    type: "submit",
                                                    label: mode === 'create' ? 'Create Right' : 'Save Changes',
                                                    disabled: loading || isSubmitting || !dirty && mode === 'edit'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        showUploadModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gJnkF.DocumentUploadModal), {
                            setShowUpload: setShowUploadModal,
                            allowAi: mode === 'create',
                            documentTypes: [
                                (0, $6yFNt.DocumentType).License
                            ],
                            successCallback: (doc)=>{
                                setFieldValue('document', doc);
                                documentUploadCallback(values);
                            }
                        })
                    ]
                })
        })
    });
};
var $14b1d39836b87b76$export$2e2bcd8739ae039 = $14b1d39836b87b76$export$4c608fad233ad9a5;

});
parcelRegister("5uWb8", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "ErrorMessage", () => ErrorMessage);

var $cxl6v = parcelRequire("cxl6v");

var $2QH3z = parcelRequire("2QH3z");

var $2rCem = parcelRequire("2rCem");

var $2NacA = parcelRequire("2NacA");

var $6QVQ4 = parcelRequire("6QVQ4");

var $aahLx = parcelRequire("aahLx");

var $6Vykm = parcelRequire("6Vykm");

var $5DZk8 = parcelRequire("5DZk8");

var $6906h = parcelRequire("6906h");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $2NacA.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $2NacA.useContext)(FormikContext);
    !!!formik && (0, $aahLx.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $2NacA.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $5DZk8.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $6Vykm.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $5DZk8.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $6Vykm.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $2NacA.useRef)(props.initialValues);
    var initialErrors = (0, $2NacA.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $2NacA.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $2NacA.useRef)(props.initialStatus);
    var isMounted = (0, $2NacA.useRef)(false);
    var fieldRegistry = (0, $2NacA.useRef)({});
    (0, $2NacA.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $2NacA.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $2NacA.useRef)({
        values: (0, $2rCem.default)(props.initialValues),
        errors: (0, $2rCem.default)(props.initialErrors) || emptyErrors,
        touched: (0, $2rCem.default)(props.initialTouched) || emptyTouched,
        status: (0, $2rCem.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $2NacA.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $2NacA.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $2NacA.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $2NacA.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $2NacA.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $2NacA.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cxl6v.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $2NacA.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $2NacA.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $2NacA.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $2NacA.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $2NacA.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $2NacA.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $2NacA.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $2NacA.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $2NacA.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $2NacA.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $2NacA.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $2NacA.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $2NacA.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $2NacA.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $2NacA.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $2NacA.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $2NacA.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $2NacA.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $2NacA.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $2NacA.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $2NacA.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $2NacA.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $2NacA.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $2NacA.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $2QH3z.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $2QH3z.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cxl6v.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cxl6v.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $2NacA.useLayoutEffect) : (0, $2NacA.useEffect);
function useEventCallback(fn) {
    var ref = (0, $2NacA.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $2NacA.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $2NacA.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $aahLx.default)(false);
    var fieldHelpers = (0, $2NacA.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $2NacA.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $2NacA.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $2NacA.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $2NacA.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $2NacA.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $2NacA.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $2NacA.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $2NacA.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $2NacA.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($6906h)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $2NacA.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $aahLx.default)(false);
            return (0, $2NacA.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($6906h)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $2rCem.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($6QVQ4)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $2NacA.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $2NacA.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $2NacA.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $2NacA.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $2NacA.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $aahLx.default)(false);
        !!(component && render) && (0, $aahLx.default)(false);
        !!(is && children && isFunction(children)) && (0, $aahLx.default)(false);
        !!(component && children && isFunction(children)) && (0, $aahLx.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $aahLx.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $2NacA.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $2NacA.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $2NacA.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $2NacA.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $2NacA.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("cxl6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9208efeb418124df$export$2e2bcd8739ae039);
var $9208efeb418124df$var$isMergeableObject = function isMergeableObject(value) {
    return $9208efeb418124df$var$isNonNullObject(value) && !$9208efeb418124df$var$isSpecial(value);
};
function $9208efeb418124df$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $9208efeb418124df$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $9208efeb418124df$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $9208efeb418124df$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $9208efeb418124df$var$REACT_ELEMENT_TYPE = $9208efeb418124df$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $9208efeb418124df$var$isReactElement(value) {
    return value.$$typeof === $9208efeb418124df$var$REACT_ELEMENT_TYPE;
}
function $9208efeb418124df$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $9208efeb418124df$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $9208efeb418124df$var$deepmerge($9208efeb418124df$var$emptyTarget(value), value, options) : value;
}
function $9208efeb418124df$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $9208efeb418124df$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $9208efeb418124df$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $9208efeb418124df$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $9208efeb418124df$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $9208efeb418124df$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $9208efeb418124df$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $9208efeb418124df$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $9208efeb418124df$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $9208efeb418124df$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $9208efeb418124df$var$mergeObject(target, source, options);
}
$9208efeb418124df$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $9208efeb418124df$var$deepmerge(prev, next, options);
    }, {});
};
var $9208efeb418124df$var$deepmerge_1 = $9208efeb418124df$var$deepmerge;
var $9208efeb418124df$export$2e2bcd8739ae039 = $9208efeb418124df$var$deepmerge_1;

});

parcelRegister("2QH3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2131d64445a97a56$export$2e2bcd8739ae039);

var $eiCDW = parcelRequire("eiCDW");

var $j02cG = parcelRequire("j02cG");

var $cgtkx = parcelRequire("cgtkx");
/** `Object#toString` result references. */ var $2131d64445a97a56$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2131d64445a97a56$var$funcProto = Function.prototype, $2131d64445a97a56$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2131d64445a97a56$var$funcToString = $2131d64445a97a56$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2131d64445a97a56$var$hasOwnProperty = $2131d64445a97a56$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $2131d64445a97a56$var$objectCtorString = $2131d64445a97a56$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $2131d64445a97a56$var$isPlainObject(value) {
    if (!(0, $cgtkx.default)(value) || (0, $eiCDW.default)(value) != $2131d64445a97a56$var$objectTag) return false;
    var proto = (0, $j02cG.default)(value);
    if (proto === null) return true;
    var Ctor = $2131d64445a97a56$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $2131d64445a97a56$var$funcToString.call(Ctor) == $2131d64445a97a56$var$objectCtorString;
}
var $2131d64445a97a56$export$2e2bcd8739ae039 = $2131d64445a97a56$var$isPlainObject;

});
parcelRegister("eiCDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a690b8d7f07d95c3$export$2e2bcd8739ae039);

var $cyUto = parcelRequire("cyUto");

var $23ZZJ = parcelRequire("23ZZJ");

var $6BOb6 = parcelRequire("6BOb6");
/** `Object#toString` result references. */ var $a690b8d7f07d95c3$var$nullTag = '[object Null]', $a690b8d7f07d95c3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a690b8d7f07d95c3$var$symToStringTag = (0, $cyUto.default) ? (0, $cyUto.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a690b8d7f07d95c3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a690b8d7f07d95c3$var$undefinedTag : $a690b8d7f07d95c3$var$nullTag;
    return $a690b8d7f07d95c3$var$symToStringTag && $a690b8d7f07d95c3$var$symToStringTag in Object(value) ? (0, $23ZZJ.default)(value) : (0, $6BOb6.default)(value);
}
var $a690b8d7f07d95c3$export$2e2bcd8739ae039 = $a690b8d7f07d95c3$var$baseGetTag;

});
parcelRegister("cyUto", function(module, exports) {

$parcel$export(module.exports, "default", () => $92547766fa0270ef$export$2e2bcd8739ae039);

var $70LQ9 = parcelRequire("70LQ9");
/** Built-in value references. */ var $92547766fa0270ef$var$Symbol = (0, $70LQ9.default).Symbol;
var $92547766fa0270ef$export$2e2bcd8739ae039 = $92547766fa0270ef$var$Symbol;

});
parcelRegister("70LQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $51ada48b001472a5$export$2e2bcd8739ae039);

var $11x18 = parcelRequire("11x18");
/** Detect free variable `self`. */ var $51ada48b001472a5$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $51ada48b001472a5$var$root = (0, $11x18.default) || $51ada48b001472a5$var$freeSelf || Function('return this')();
var $51ada48b001472a5$export$2e2bcd8739ae039 = $51ada48b001472a5$var$root;

});
parcelRegister("11x18", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bef7efa63db6125$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $0bef7efa63db6125$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $0bef7efa63db6125$export$2e2bcd8739ae039 = $0bef7efa63db6125$var$freeGlobal;

});



parcelRegister("23ZZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $180bf369fe19e661$export$2e2bcd8739ae039);

var $cyUto = parcelRequire("cyUto");
/** Used for built-in method references. */ var $180bf369fe19e661$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $180bf369fe19e661$var$hasOwnProperty = $180bf369fe19e661$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $180bf369fe19e661$var$nativeObjectToString = $180bf369fe19e661$var$objectProto.toString;
/** Built-in value references. */ var $180bf369fe19e661$var$symToStringTag = (0, $cyUto.default) ? (0, $cyUto.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $180bf369fe19e661$var$getRawTag(value) {
    var isOwn = $180bf369fe19e661$var$hasOwnProperty.call(value, $180bf369fe19e661$var$symToStringTag), tag = value[$180bf369fe19e661$var$symToStringTag];
    try {
        value[$180bf369fe19e661$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $180bf369fe19e661$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$180bf369fe19e661$var$symToStringTag] = tag;
        else delete value[$180bf369fe19e661$var$symToStringTag];
    }
    return result;
}
var $180bf369fe19e661$export$2e2bcd8739ae039 = $180bf369fe19e661$var$getRawTag;

});

parcelRegister("6BOb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfd1f1d4f7c350e$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $4cfd1f1d4f7c350e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4cfd1f1d4f7c350e$var$nativeObjectToString = $4cfd1f1d4f7c350e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $4cfd1f1d4f7c350e$var$objectToString(value) {
    return $4cfd1f1d4f7c350e$var$nativeObjectToString.call(value);
}
var $4cfd1f1d4f7c350e$export$2e2bcd8739ae039 = $4cfd1f1d4f7c350e$var$objectToString;

});


parcelRegister("j02cG", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd4fb9f73803d60f$export$2e2bcd8739ae039);

var $5tBhB = parcelRequire("5tBhB");
/** Built-in value references. */ var $dd4fb9f73803d60f$var$getPrototype = (0, $5tBhB.default)(Object.getPrototypeOf, Object);
var $dd4fb9f73803d60f$export$2e2bcd8739ae039 = $dd4fb9f73803d60f$var$getPrototype;

});
parcelRegister("5tBhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcc94ca1ea9ee4a$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3fcc94ca1ea9ee4a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $3fcc94ca1ea9ee4a$export$2e2bcd8739ae039 = $3fcc94ca1ea9ee4a$var$overArg;

});


parcelRegister("cgtkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eddbb0594a5b985$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8eddbb0594a5b985$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $8eddbb0594a5b985$export$2e2bcd8739ae039 = $8eddbb0594a5b985$var$isObjectLike;

});


parcelRegister("2rCem", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7bc2315e98b356$export$2e2bcd8739ae039);

var $hB4es = parcelRequire("hB4es");
/** Used to compose bitmasks for cloning. */ var $1c7bc2315e98b356$var$CLONE_DEEP_FLAG = 1, $1c7bc2315e98b356$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $1c7bc2315e98b356$var$cloneDeep(value) {
    return (0, $hB4es.default)(value, $1c7bc2315e98b356$var$CLONE_DEEP_FLAG | $1c7bc2315e98b356$var$CLONE_SYMBOLS_FLAG);
}
var $1c7bc2315e98b356$export$2e2bcd8739ae039 = $1c7bc2315e98b356$var$cloneDeep;

});
parcelRegister("hB4es", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf92cd1ac035db3$export$2e2bcd8739ae039);

var $9sxT4 = parcelRequire("9sxT4");

var $aVcxg = parcelRequire("aVcxg");

var $hmwox = parcelRequire("hmwox");

var $kYZ0O = parcelRequire("kYZ0O");

var $l9Dd5 = parcelRequire("l9Dd5");

var $FXWnt = parcelRequire("FXWnt");

var $2ArVt = parcelRequire("2ArVt");

var $jstNP = parcelRequire("jstNP");

var $6pCRq = parcelRequire("6pCRq");

var $fI8MJ = parcelRequire("fI8MJ");

var $7WhvG = parcelRequire("7WhvG");

var $lB6nA = parcelRequire("lB6nA");

var $3Ttkz = parcelRequire("3Ttkz");

var $glzVc = parcelRequire("glzVc");

var $6Vloe = parcelRequire("6Vloe");

var $jAffT = parcelRequire("jAffT");

var $aNGXk = parcelRequire("aNGXk");

var $kADuo = parcelRequire("kADuo");

var $dDC0W = parcelRequire("dDC0W");

var $lMxci = parcelRequire("lMxci");

var $27tFV = parcelRequire("27tFV");

var $3p62K = parcelRequire("3p62K");
/** Used to compose bitmasks for cloning. */ var $ccf92cd1ac035db3$var$CLONE_DEEP_FLAG = 1, $ccf92cd1ac035db3$var$CLONE_FLAT_FLAG = 2, $ccf92cd1ac035db3$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ccf92cd1ac035db3$var$argsTag = '[object Arguments]', $ccf92cd1ac035db3$var$arrayTag = '[object Array]', $ccf92cd1ac035db3$var$boolTag = '[object Boolean]', $ccf92cd1ac035db3$var$dateTag = '[object Date]', $ccf92cd1ac035db3$var$errorTag = '[object Error]', $ccf92cd1ac035db3$var$funcTag = '[object Function]', $ccf92cd1ac035db3$var$genTag = '[object GeneratorFunction]', $ccf92cd1ac035db3$var$mapTag = '[object Map]', $ccf92cd1ac035db3$var$numberTag = '[object Number]', $ccf92cd1ac035db3$var$objectTag = '[object Object]', $ccf92cd1ac035db3$var$regexpTag = '[object RegExp]', $ccf92cd1ac035db3$var$setTag = '[object Set]', $ccf92cd1ac035db3$var$stringTag = '[object String]', $ccf92cd1ac035db3$var$symbolTag = '[object Symbol]', $ccf92cd1ac035db3$var$weakMapTag = '[object WeakMap]';
var $ccf92cd1ac035db3$var$arrayBufferTag = '[object ArrayBuffer]', $ccf92cd1ac035db3$var$dataViewTag = '[object DataView]', $ccf92cd1ac035db3$var$float32Tag = '[object Float32Array]', $ccf92cd1ac035db3$var$float64Tag = '[object Float64Array]', $ccf92cd1ac035db3$var$int8Tag = '[object Int8Array]', $ccf92cd1ac035db3$var$int16Tag = '[object Int16Array]', $ccf92cd1ac035db3$var$int32Tag = '[object Int32Array]', $ccf92cd1ac035db3$var$uint8Tag = '[object Uint8Array]', $ccf92cd1ac035db3$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ccf92cd1ac035db3$var$uint16Tag = '[object Uint16Array]', $ccf92cd1ac035db3$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ccf92cd1ac035db3$var$cloneableTags = {};
$ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$argsTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$arrayTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$arrayBufferTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$dataViewTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$boolTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$dateTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$float32Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$float64Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$int8Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$int16Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$int32Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$mapTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$numberTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$objectTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$regexpTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$setTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$stringTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$symbolTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$uint8Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$uint8ClampedTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$uint16Tag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$uint32Tag] = true;
$ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$errorTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$funcTag] = $ccf92cd1ac035db3$var$cloneableTags[$ccf92cd1ac035db3$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ccf92cd1ac035db3$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ccf92cd1ac035db3$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ccf92cd1ac035db3$var$CLONE_FLAT_FLAG, isFull = bitmask & $ccf92cd1ac035db3$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $dDC0W.default)(value)) return value;
    var isArr = (0, $jAffT.default)(value);
    if (isArr) {
        result = (0, $3Ttkz.default)(value);
        if (!isDeep) return (0, $2ArVt.default)(value, result);
    } else {
        var tag = (0, $lB6nA.default)(value), isFunc = tag == $ccf92cd1ac035db3$var$funcTag || tag == $ccf92cd1ac035db3$var$genTag;
        if ((0, $aNGXk.default)(value)) return (0, $FXWnt.default)(value, isDeep);
        if (tag == $ccf92cd1ac035db3$var$objectTag || tag == $ccf92cd1ac035db3$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $6Vloe.default)(value);
            if (!isDeep) return isFlat ? (0, $6pCRq.default)(value, (0, $l9Dd5.default)(result, value)) : (0, $jstNP.default)(value, (0, $kYZ0O.default)(result, value));
        } else {
            if (!$ccf92cd1ac035db3$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $glzVc.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9sxT4.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $lMxci.default)(value)) value.forEach(function(subValue) {
        result.add($ccf92cd1ac035db3$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $kADuo.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $ccf92cd1ac035db3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7WhvG.default) : (0, $fI8MJ.default) : isFlat ? (0, $3p62K.default) : (0, $27tFV.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $aVcxg.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $hmwox.default)(result, key, $ccf92cd1ac035db3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $ccf92cd1ac035db3$export$2e2bcd8739ae039 = $ccf92cd1ac035db3$var$baseClone;

});
parcelRegister("9sxT4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3103e5baf446a8$export$2e2bcd8739ae039);

var $lmG8f = parcelRequire("lmG8f");

var $egYJx = parcelRequire("egYJx");

var $5yHVL = parcelRequire("5yHVL");

var $2mwVR = parcelRequire("2mwVR");

var $bpJPg = parcelRequire("bpJPg");

var $6WqBb = parcelRequire("6WqBb");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6e3103e5baf446a8$var$Stack(entries) {
    var data = this.__data__ = new (0, $lmG8f.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$6e3103e5baf446a8$var$Stack.prototype.clear = (0, $egYJx.default);
$6e3103e5baf446a8$var$Stack.prototype['delete'] = (0, $5yHVL.default);
$6e3103e5baf446a8$var$Stack.prototype.get = (0, $2mwVR.default);
$6e3103e5baf446a8$var$Stack.prototype.has = (0, $bpJPg.default);
$6e3103e5baf446a8$var$Stack.prototype.set = (0, $6WqBb.default);
var $6e3103e5baf446a8$export$2e2bcd8739ae039 = $6e3103e5baf446a8$var$Stack;

});
parcelRegister("lmG8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8dc559916d2cfd9$export$2e2bcd8739ae039);

var $ishXR = parcelRequire("ishXR");

var $1PQHa = parcelRequire("1PQHa");

var $b7UdE = parcelRequire("b7UdE");

var $a9oEK = parcelRequire("a9oEK");

var $lhJoX = parcelRequire("lhJoX");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f8dc559916d2cfd9$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f8dc559916d2cfd9$var$ListCache.prototype.clear = (0, $ishXR.default);
$f8dc559916d2cfd9$var$ListCache.prototype['delete'] = (0, $1PQHa.default);
$f8dc559916d2cfd9$var$ListCache.prototype.get = (0, $b7UdE.default);
$f8dc559916d2cfd9$var$ListCache.prototype.has = (0, $a9oEK.default);
$f8dc559916d2cfd9$var$ListCache.prototype.set = (0, $lhJoX.default);
var $f8dc559916d2cfd9$export$2e2bcd8739ae039 = $f8dc559916d2cfd9$var$ListCache;

});
parcelRegister("ishXR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f8c6e546a821af$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d6f8c6e546a821af$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $d6f8c6e546a821af$export$2e2bcd8739ae039 = $d6f8c6e546a821af$var$listCacheClear;

});

parcelRegister("1PQHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $15636e04bfdc5953$export$2e2bcd8739ae039);

var $kpqh4 = parcelRequire("kpqh4");
/** Used for built-in method references. */ var $15636e04bfdc5953$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $15636e04bfdc5953$var$splice = $15636e04bfdc5953$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $15636e04bfdc5953$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $kpqh4.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $15636e04bfdc5953$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $15636e04bfdc5953$export$2e2bcd8739ae039 = $15636e04bfdc5953$var$listCacheDelete;

});
parcelRegister("kpqh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $edba85fe6f1ec304$export$2e2bcd8739ae039);

var $5KAZS = parcelRequire("5KAZS");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $edba85fe6f1ec304$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $5KAZS.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $edba85fe6f1ec304$export$2e2bcd8739ae039 = $edba85fe6f1ec304$var$assocIndexOf;

});
parcelRegister("5KAZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fdf278b423393e$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $42fdf278b423393e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $42fdf278b423393e$export$2e2bcd8739ae039 = $42fdf278b423393e$var$eq;

});



parcelRegister("b7UdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $819bf516eb904904$export$2e2bcd8739ae039);

var $kpqh4 = parcelRequire("kpqh4");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $819bf516eb904904$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $kpqh4.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $819bf516eb904904$export$2e2bcd8739ae039 = $819bf516eb904904$var$listCacheGet;

});

parcelRegister("a9oEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $763dded550a657c6$export$2e2bcd8739ae039);

var $kpqh4 = parcelRequire("kpqh4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $763dded550a657c6$var$listCacheHas(key) {
    return (0, $kpqh4.default)(this.__data__, key) > -1;
}
var $763dded550a657c6$export$2e2bcd8739ae039 = $763dded550a657c6$var$listCacheHas;

});

parcelRegister("lhJoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ee67532374b125$export$2e2bcd8739ae039);

var $kpqh4 = parcelRequire("kpqh4");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $f7ee67532374b125$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $kpqh4.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $f7ee67532374b125$export$2e2bcd8739ae039 = $f7ee67532374b125$var$listCacheSet;

});


parcelRegister("egYJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a641abba997fc0e6$export$2e2bcd8739ae039);

var $lmG8f = parcelRequire("lmG8f");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a641abba997fc0e6$var$stackClear() {
    this.__data__ = new (0, $lmG8f.default);
    this.size = 0;
}
var $a641abba997fc0e6$export$2e2bcd8739ae039 = $a641abba997fc0e6$var$stackClear;

});

parcelRegister("5yHVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c2347730f77c9f$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $40c2347730f77c9f$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $40c2347730f77c9f$export$2e2bcd8739ae039 = $40c2347730f77c9f$var$stackDelete;

});

parcelRegister("2mwVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b872e856c60c9f0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1b872e856c60c9f0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $1b872e856c60c9f0$export$2e2bcd8739ae039 = $1b872e856c60c9f0$var$stackGet;

});

parcelRegister("bpJPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $84f5938d8d9e16e4$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $84f5938d8d9e16e4$var$stackHas(key) {
    return this.__data__.has(key);
}
var $84f5938d8d9e16e4$export$2e2bcd8739ae039 = $84f5938d8d9e16e4$var$stackHas;

});

parcelRegister("6WqBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $50dccad303debd16$export$2e2bcd8739ae039);

var $lmG8f = parcelRequire("lmG8f");

var $3kCJ0 = parcelRequire("3kCJ0");

var $cbDIj = parcelRequire("cbDIj");
/** Used as the size to enable large array optimizations. */ var $50dccad303debd16$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $50dccad303debd16$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $lmG8f.default)) {
        var pairs = data.__data__;
        if (!(0, $3kCJ0.default) || pairs.length < $50dccad303debd16$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $cbDIj.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $50dccad303debd16$export$2e2bcd8739ae039 = $50dccad303debd16$var$stackSet;

});
parcelRegister("3kCJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d147506b1710a3$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");

var $70LQ9 = parcelRequire("70LQ9");
/* Built-in method references that are verified to be native. */ var $26d147506b1710a3$var$Map = (0, $8gS0c.default)((0, $70LQ9.default), 'Map');
var $26d147506b1710a3$export$2e2bcd8739ae039 = $26d147506b1710a3$var$Map;

});
parcelRegister("8gS0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6059b5143088a8e5$export$2e2bcd8739ae039);

var $k9VEq = parcelRequire("k9VEq");

var $6DRuR = parcelRequire("6DRuR");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6059b5143088a8e5$var$getNative(object, key) {
    var value = (0, $6DRuR.default)(object, key);
    return (0, $k9VEq.default)(value) ? value : undefined;
}
var $6059b5143088a8e5$export$2e2bcd8739ae039 = $6059b5143088a8e5$var$getNative;

});
parcelRegister("k9VEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead15e38f4503c68$export$2e2bcd8739ae039);

var $9mi9u = parcelRequire("9mi9u");

var $kHKpi = parcelRequire("kHKpi");

var $dDC0W = parcelRequire("dDC0W");

var $5rLXT = parcelRequire("5rLXT");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ead15e38f4503c68$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ead15e38f4503c68$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ead15e38f4503c68$var$funcProto = Function.prototype, $ead15e38f4503c68$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ead15e38f4503c68$var$funcToString = $ead15e38f4503c68$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ead15e38f4503c68$var$hasOwnProperty = $ead15e38f4503c68$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ead15e38f4503c68$var$reIsNative = RegExp('^' + $ead15e38f4503c68$var$funcToString.call($ead15e38f4503c68$var$hasOwnProperty).replace($ead15e38f4503c68$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ead15e38f4503c68$var$baseIsNative(value) {
    if (!(0, $dDC0W.default)(value) || (0, $kHKpi.default)(value)) return false;
    var pattern = (0, $9mi9u.default)(value) ? $ead15e38f4503c68$var$reIsNative : $ead15e38f4503c68$var$reIsHostCtor;
    return pattern.test((0, $5rLXT.default)(value));
}
var $ead15e38f4503c68$export$2e2bcd8739ae039 = $ead15e38f4503c68$var$baseIsNative;

});
parcelRegister("9mi9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d043fbbbd2b2901$export$2e2bcd8739ae039);

var $eiCDW = parcelRequire("eiCDW");

var $dDC0W = parcelRequire("dDC0W");
/** `Object#toString` result references. */ var $6d043fbbbd2b2901$var$asyncTag = '[object AsyncFunction]', $6d043fbbbd2b2901$var$funcTag = '[object Function]', $6d043fbbbd2b2901$var$genTag = '[object GeneratorFunction]', $6d043fbbbd2b2901$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $6d043fbbbd2b2901$var$isFunction(value) {
    if (!(0, $dDC0W.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $eiCDW.default)(value);
    return tag == $6d043fbbbd2b2901$var$funcTag || tag == $6d043fbbbd2b2901$var$genTag || tag == $6d043fbbbd2b2901$var$asyncTag || tag == $6d043fbbbd2b2901$var$proxyTag;
}
var $6d043fbbbd2b2901$export$2e2bcd8739ae039 = $6d043fbbbd2b2901$var$isFunction;

});
parcelRegister("dDC0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9edc67aee7c7c839$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9edc67aee7c7c839$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $9edc67aee7c7c839$export$2e2bcd8739ae039 = $9edc67aee7c7c839$var$isObject;

});


parcelRegister("kHKpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f12bd2449f68a066$export$2e2bcd8739ae039);

var $1GsIr = parcelRequire("1GsIr");
/** Used to detect methods masquerading as native. */ var $f12bd2449f68a066$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $1GsIr.default) && (0, $1GsIr.default).keys && (0, $1GsIr.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f12bd2449f68a066$var$isMasked(func) {
    return !!$f12bd2449f68a066$var$maskSrcKey && $f12bd2449f68a066$var$maskSrcKey in func;
}
var $f12bd2449f68a066$export$2e2bcd8739ae039 = $f12bd2449f68a066$var$isMasked;

});
parcelRegister("1GsIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $139ffd06fe3c60a3$export$2e2bcd8739ae039);

var $70LQ9 = parcelRequire("70LQ9");
/** Used to detect overreaching core-js shims. */ var $139ffd06fe3c60a3$var$coreJsData = (0, $70LQ9.default)['__core-js_shared__'];
var $139ffd06fe3c60a3$export$2e2bcd8739ae039 = $139ffd06fe3c60a3$var$coreJsData;

});


parcelRegister("5rLXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f74ae3c6bdf4457$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3f74ae3c6bdf4457$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3f74ae3c6bdf4457$var$funcToString = $3f74ae3c6bdf4457$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3f74ae3c6bdf4457$var$toSource(func) {
    if (func != null) {
        try {
            return $3f74ae3c6bdf4457$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $3f74ae3c6bdf4457$export$2e2bcd8739ae039 = $3f74ae3c6bdf4457$var$toSource;

});


parcelRegister("6DRuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d5fe1f04d69ba52$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4d5fe1f04d69ba52$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $4d5fe1f04d69ba52$export$2e2bcd8739ae039 = $4d5fe1f04d69ba52$var$getValue;

});



parcelRegister("cbDIj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df551695ecd7847$export$2e2bcd8739ae039);

var $hMp2o = parcelRequire("hMp2o");

var $2TZan = parcelRequire("2TZan");

var $5vpAZ = parcelRequire("5vpAZ");

var $aOBiv = parcelRequire("aOBiv");

var $l5ltO = parcelRequire("l5ltO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8df551695ecd7847$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$8df551695ecd7847$var$MapCache.prototype.clear = (0, $hMp2o.default);
$8df551695ecd7847$var$MapCache.prototype['delete'] = (0, $2TZan.default);
$8df551695ecd7847$var$MapCache.prototype.get = (0, $5vpAZ.default);
$8df551695ecd7847$var$MapCache.prototype.has = (0, $aOBiv.default);
$8df551695ecd7847$var$MapCache.prototype.set = (0, $l5ltO.default);
var $8df551695ecd7847$export$2e2bcd8739ae039 = $8df551695ecd7847$var$MapCache;

});
parcelRegister("hMp2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1a57538325b7e6$export$2e2bcd8739ae039);

var $dFdk5 = parcelRequire("dFdk5");

var $lmG8f = parcelRequire("lmG8f");

var $3kCJ0 = parcelRequire("3kCJ0");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $cf1a57538325b7e6$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $dFdk5.default),
        'map': new ((0, $3kCJ0.default) || (0, $lmG8f.default)),
        'string': new (0, $dFdk5.default)
    };
}
var $cf1a57538325b7e6$export$2e2bcd8739ae039 = $cf1a57538325b7e6$var$mapCacheClear;

});
parcelRegister("dFdk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f297059d6e9c66d$export$2e2bcd8739ae039);

var $7Yyf3 = parcelRequire("7Yyf3");

var $bRUIE = parcelRequire("bRUIE");

var $haz3N = parcelRequire("haz3N");

var $dyHjW = parcelRequire("dyHjW");

var $8tLd3 = parcelRequire("8tLd3");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9f297059d6e9c66d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9f297059d6e9c66d$var$Hash.prototype.clear = (0, $7Yyf3.default);
$9f297059d6e9c66d$var$Hash.prototype['delete'] = (0, $bRUIE.default);
$9f297059d6e9c66d$var$Hash.prototype.get = (0, $haz3N.default);
$9f297059d6e9c66d$var$Hash.prototype.has = (0, $dyHjW.default);
$9f297059d6e9c66d$var$Hash.prototype.set = (0, $8tLd3.default);
var $9f297059d6e9c66d$export$2e2bcd8739ae039 = $9f297059d6e9c66d$var$Hash;

});
parcelRegister("7Yyf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ce8b2b3452adddb$export$2e2bcd8739ae039);

var $kMwim = parcelRequire("kMwim");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $5ce8b2b3452adddb$var$hashClear() {
    this.__data__ = (0, $kMwim.default) ? (0, $kMwim.default)(null) : {};
    this.size = 0;
}
var $5ce8b2b3452adddb$export$2e2bcd8739ae039 = $5ce8b2b3452adddb$var$hashClear;

});
parcelRegister("kMwim", function(module, exports) {

$parcel$export(module.exports, "default", () => $f211577db0a3fd69$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");
/* Built-in method references that are verified to be native. */ var $f211577db0a3fd69$var$nativeCreate = (0, $8gS0c.default)(Object, 'create');
var $f211577db0a3fd69$export$2e2bcd8739ae039 = $f211577db0a3fd69$var$nativeCreate;

});


parcelRegister("bRUIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a40a42ba09d8c4c$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8a40a42ba09d8c4c$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $8a40a42ba09d8c4c$export$2e2bcd8739ae039 = $8a40a42ba09d8c4c$var$hashDelete;

});

parcelRegister("haz3N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7fe9113336c9bd8$export$2e2bcd8739ae039);

var $kMwim = parcelRequire("kMwim");
/** Used to stand-in for `undefined` hash values. */ var $c7fe9113336c9bd8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $c7fe9113336c9bd8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c7fe9113336c9bd8$var$hasOwnProperty = $c7fe9113336c9bd8$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c7fe9113336c9bd8$var$hashGet(key) {
    var data = this.__data__;
    if (0, $kMwim.default) {
        var result = data[key];
        return result === $c7fe9113336c9bd8$var$HASH_UNDEFINED ? undefined : result;
    }
    return $c7fe9113336c9bd8$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $c7fe9113336c9bd8$export$2e2bcd8739ae039 = $c7fe9113336c9bd8$var$hashGet;

});

parcelRegister("dyHjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df00de80d1a6af5$export$2e2bcd8739ae039);

var $kMwim = parcelRequire("kMwim");
/** Used for built-in method references. */ var $9df00de80d1a6af5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9df00de80d1a6af5$var$hasOwnProperty = $9df00de80d1a6af5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9df00de80d1a6af5$var$hashHas(key) {
    var data = this.__data__;
    return (0, $kMwim.default) ? data[key] !== undefined : $9df00de80d1a6af5$var$hasOwnProperty.call(data, key);
}
var $9df00de80d1a6af5$export$2e2bcd8739ae039 = $9df00de80d1a6af5$var$hashHas;

});

parcelRegister("8tLd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c5a704c07b7327$export$2e2bcd8739ae039);

var $kMwim = parcelRequire("kMwim");
/** Used to stand-in for `undefined` hash values. */ var $62c5a704c07b7327$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $62c5a704c07b7327$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $kMwim.default) && value === undefined ? $62c5a704c07b7327$var$HASH_UNDEFINED : value;
    return this;
}
var $62c5a704c07b7327$export$2e2bcd8739ae039 = $62c5a704c07b7327$var$hashSet;

});



parcelRegister("2TZan", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d02a3006f52742$export$2e2bcd8739ae039);

var $cQxEF = parcelRequire("cQxEF");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $21d02a3006f52742$var$mapCacheDelete(key) {
    var result = (0, $cQxEF.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $21d02a3006f52742$export$2e2bcd8739ae039 = $21d02a3006f52742$var$mapCacheDelete;

});
parcelRegister("cQxEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a47286cbb22118$export$2e2bcd8739ae039);

var $1uEEy = parcelRequire("1uEEy");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $95a47286cbb22118$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $1uEEy.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $95a47286cbb22118$export$2e2bcd8739ae039 = $95a47286cbb22118$var$getMapData;

});
parcelRegister("1uEEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $116820a255bd1d52$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $116820a255bd1d52$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $116820a255bd1d52$export$2e2bcd8739ae039 = $116820a255bd1d52$var$isKeyable;

});



parcelRegister("5vpAZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023b3be2cec5420$export$2e2bcd8739ae039);

var $cQxEF = parcelRequire("cQxEF");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4023b3be2cec5420$var$mapCacheGet(key) {
    return (0, $cQxEF.default)(this, key).get(key);
}
var $4023b3be2cec5420$export$2e2bcd8739ae039 = $4023b3be2cec5420$var$mapCacheGet;

});

parcelRegister("aOBiv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dfb8166fc73eab3$export$2e2bcd8739ae039);

var $cQxEF = parcelRequire("cQxEF");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7dfb8166fc73eab3$var$mapCacheHas(key) {
    return (0, $cQxEF.default)(this, key).has(key);
}
var $7dfb8166fc73eab3$export$2e2bcd8739ae039 = $7dfb8166fc73eab3$var$mapCacheHas;

});

parcelRegister("l5ltO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aba0e01ca0d6f$export$2e2bcd8739ae039);

var $cQxEF = parcelRequire("cQxEF");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $f59aba0e01ca0d6f$var$mapCacheSet(key, value) {
    var data = (0, $cQxEF.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $f59aba0e01ca0d6f$export$2e2bcd8739ae039 = $f59aba0e01ca0d6f$var$mapCacheSet;

});




parcelRegister("aVcxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f38f38ac22d77ef$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $7f38f38ac22d77ef$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $7f38f38ac22d77ef$export$2e2bcd8739ae039 = $7f38f38ac22d77ef$var$arrayEach;

});

parcelRegister("hmwox", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3d9eadc147d58d$export$2e2bcd8739ae039);

var $f7lYJ = parcelRequire("f7lYJ");

var $5KAZS = parcelRequire("5KAZS");
/** Used for built-in method references. */ var $ca3d9eadc147d58d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca3d9eadc147d58d$var$hasOwnProperty = $ca3d9eadc147d58d$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ca3d9eadc147d58d$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($ca3d9eadc147d58d$var$hasOwnProperty.call(object, key) && (0, $5KAZS.default)(objValue, value)) || value === undefined && !(key in object)) (0, $f7lYJ.default)(object, key, value);
}
var $ca3d9eadc147d58d$export$2e2bcd8739ae039 = $ca3d9eadc147d58d$var$assignValue;

});
parcelRegister("f7lYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0188ef2cb23d81a$export$2e2bcd8739ae039);

var $bdVoD = parcelRequire("bdVoD");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b0188ef2cb23d81a$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $bdVoD.default)) (0, $bdVoD.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $b0188ef2cb23d81a$export$2e2bcd8739ae039 = $b0188ef2cb23d81a$var$baseAssignValue;

});
parcelRegister("bdVoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bd6e56a07f24ed$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");
var $82bd6e56a07f24ed$var$defineProperty = function() {
    try {
        var func = (0, $8gS0c.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $82bd6e56a07f24ed$export$2e2bcd8739ae039 = $82bd6e56a07f24ed$var$defineProperty;

});



parcelRegister("kYZ0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f468bcf5921fcc8e$export$2e2bcd8739ae039);

var $8UIBO = parcelRequire("8UIBO");

var $27tFV = parcelRequire("27tFV");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f468bcf5921fcc8e$var$baseAssign(object, source) {
    return object && (0, $8UIBO.default)(source, (0, $27tFV.default)(source), object);
}
var $f468bcf5921fcc8e$export$2e2bcd8739ae039 = $f468bcf5921fcc8e$var$baseAssign;

});
parcelRegister("8UIBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d628116631ca68$export$2e2bcd8739ae039);

var $hmwox = parcelRequire("hmwox");

var $f7lYJ = parcelRequire("f7lYJ");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $67d628116631ca68$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $f7lYJ.default)(object, key, newValue);
        else (0, $hmwox.default)(object, key, newValue);
    }
    return object;
}
var $67d628116631ca68$export$2e2bcd8739ae039 = $67d628116631ca68$var$copyObject;

});

parcelRegister("27tFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b3411e5335f6ac$export$2e2bcd8739ae039);

var $jBX9C = parcelRequire("jBX9C");

var $3GuMQ = parcelRequire("3GuMQ");

var $krTMn = parcelRequire("krTMn");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $18b3411e5335f6ac$var$keys(object) {
    return (0, $krTMn.default)(object) ? (0, $jBX9C.default)(object) : (0, $3GuMQ.default)(object);
}
var $18b3411e5335f6ac$export$2e2bcd8739ae039 = $18b3411e5335f6ac$var$keys;

});
parcelRegister("jBX9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $e46f5bd15c9b6552$export$2e2bcd8739ae039);

var $5tqDA = parcelRequire("5tqDA");

var $lY9KC = parcelRequire("lY9KC");

var $jAffT = parcelRequire("jAffT");

var $aNGXk = parcelRequire("aNGXk");

var $6EQCP = parcelRequire("6EQCP");

var $a3QHG = parcelRequire("a3QHG");
/** Used for built-in method references. */ var $e46f5bd15c9b6552$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e46f5bd15c9b6552$var$hasOwnProperty = $e46f5bd15c9b6552$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $e46f5bd15c9b6552$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $jAffT.default)(value), isArg = !isArr && (0, $lY9KC.default)(value), isBuff = !isArr && !isArg && (0, $aNGXk.default)(value), isType = !isArr && !isArg && !isBuff && (0, $a3QHG.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $5tqDA.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $e46f5bd15c9b6552$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $6EQCP.default)(key, length)))) result.push(key);
    return result;
}
var $e46f5bd15c9b6552$export$2e2bcd8739ae039 = $e46f5bd15c9b6552$var$arrayLikeKeys;

});
parcelRegister("5tqDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc452d4806dc8f1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $3fc452d4806dc8f1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $3fc452d4806dc8f1$export$2e2bcd8739ae039 = $3fc452d4806dc8f1$var$baseTimes;

});

parcelRegister("lY9KC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe6c3e0ba610824$export$2e2bcd8739ae039);

var $5RcQ0 = parcelRequire("5RcQ0");

var $cgtkx = parcelRequire("cgtkx");
/** Used for built-in method references. */ var $ffe6c3e0ba610824$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ffe6c3e0ba610824$var$hasOwnProperty = $ffe6c3e0ba610824$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $ffe6c3e0ba610824$var$propertyIsEnumerable = $ffe6c3e0ba610824$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $ffe6c3e0ba610824$var$isArguments = (0, $5RcQ0.default)(function() {
    return arguments;
}()) ? (0, $5RcQ0.default) : function(value) {
    return (0, $cgtkx.default)(value) && $ffe6c3e0ba610824$var$hasOwnProperty.call(value, 'callee') && !$ffe6c3e0ba610824$var$propertyIsEnumerable.call(value, 'callee');
};
var $ffe6c3e0ba610824$export$2e2bcd8739ae039 = $ffe6c3e0ba610824$var$isArguments;

});
parcelRegister("5RcQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $443bdc55002705c9$export$2e2bcd8739ae039);

var $eiCDW = parcelRequire("eiCDW");

var $cgtkx = parcelRequire("cgtkx");
/** `Object#toString` result references. */ var $443bdc55002705c9$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $443bdc55002705c9$var$baseIsArguments(value) {
    return (0, $cgtkx.default)(value) && (0, $eiCDW.default)(value) == $443bdc55002705c9$var$argsTag;
}
var $443bdc55002705c9$export$2e2bcd8739ae039 = $443bdc55002705c9$var$baseIsArguments;

});


parcelRegister("jAffT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e41d368583121f40$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e41d368583121f40$var$isArray = Array.isArray;
var $e41d368583121f40$export$2e2bcd8739ae039 = $e41d368583121f40$var$isArray;

});

parcelRegister("aNGXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcfcd1d1f4b7837$export$2e2bcd8739ae039);

var $70LQ9 = parcelRequire("70LQ9");

var $kE4rp = parcelRequire("kE4rp");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $70LQ9.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kE4rp.default);
var $7dcfcd1d1f4b7837$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kE4rp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f07afcfd25271bb8$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $f07afcfd25271bb8$var$stubFalse() {
    return false;
}
var $f07afcfd25271bb8$export$2e2bcd8739ae039 = $f07afcfd25271bb8$var$stubFalse;

});


parcelRegister("6EQCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d8f4cc2e741c6a2$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $4d8f4cc2e741c6a2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $4d8f4cc2e741c6a2$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $4d8f4cc2e741c6a2$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $4d8f4cc2e741c6a2$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $4d8f4cc2e741c6a2$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $4d8f4cc2e741c6a2$export$2e2bcd8739ae039 = $4d8f4cc2e741c6a2$var$isIndex;

});

parcelRegister("a3QHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7533110cb39847ad$export$2e2bcd8739ae039);

var $Km3I2 = parcelRequire("Km3I2");

var $buofz = parcelRequire("buofz");

var $faRDV = parcelRequire("faRDV");
/* Node.js helper references. */ var $7533110cb39847ad$var$nodeIsTypedArray = (0, $faRDV.default) && (0, $faRDV.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $7533110cb39847ad$var$isTypedArray = $7533110cb39847ad$var$nodeIsTypedArray ? (0, $buofz.default)($7533110cb39847ad$var$nodeIsTypedArray) : (0, $Km3I2.default);
var $7533110cb39847ad$export$2e2bcd8739ae039 = $7533110cb39847ad$var$isTypedArray;

});
parcelRegister("Km3I2", function(module, exports) {

$parcel$export(module.exports, "default", () => $08b5686a6a5cc5bb$export$2e2bcd8739ae039);

var $eiCDW = parcelRequire("eiCDW");

var $gukt6 = parcelRequire("gukt6");

var $cgtkx = parcelRequire("cgtkx");
/** `Object#toString` result references. */ var $08b5686a6a5cc5bb$var$argsTag = '[object Arguments]', $08b5686a6a5cc5bb$var$arrayTag = '[object Array]', $08b5686a6a5cc5bb$var$boolTag = '[object Boolean]', $08b5686a6a5cc5bb$var$dateTag = '[object Date]', $08b5686a6a5cc5bb$var$errorTag = '[object Error]', $08b5686a6a5cc5bb$var$funcTag = '[object Function]', $08b5686a6a5cc5bb$var$mapTag = '[object Map]', $08b5686a6a5cc5bb$var$numberTag = '[object Number]', $08b5686a6a5cc5bb$var$objectTag = '[object Object]', $08b5686a6a5cc5bb$var$regexpTag = '[object RegExp]', $08b5686a6a5cc5bb$var$setTag = '[object Set]', $08b5686a6a5cc5bb$var$stringTag = '[object String]', $08b5686a6a5cc5bb$var$weakMapTag = '[object WeakMap]';
var $08b5686a6a5cc5bb$var$arrayBufferTag = '[object ArrayBuffer]', $08b5686a6a5cc5bb$var$dataViewTag = '[object DataView]', $08b5686a6a5cc5bb$var$float32Tag = '[object Float32Array]', $08b5686a6a5cc5bb$var$float64Tag = '[object Float64Array]', $08b5686a6a5cc5bb$var$int8Tag = '[object Int8Array]', $08b5686a6a5cc5bb$var$int16Tag = '[object Int16Array]', $08b5686a6a5cc5bb$var$int32Tag = '[object Int32Array]', $08b5686a6a5cc5bb$var$uint8Tag = '[object Uint8Array]', $08b5686a6a5cc5bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $08b5686a6a5cc5bb$var$uint16Tag = '[object Uint16Array]', $08b5686a6a5cc5bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $08b5686a6a5cc5bb$var$typedArrayTags = {};
$08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$float32Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$float64Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$int8Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$int16Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$int32Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$uint8Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$uint8ClampedTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$uint16Tag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$uint32Tag] = true;
$08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$argsTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$arrayTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$arrayBufferTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$boolTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$dataViewTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$dateTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$errorTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$funcTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$mapTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$numberTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$objectTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$regexpTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$setTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$stringTag] = $08b5686a6a5cc5bb$var$typedArrayTags[$08b5686a6a5cc5bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $08b5686a6a5cc5bb$var$baseIsTypedArray(value) {
    return (0, $cgtkx.default)(value) && (0, $gukt6.default)(value.length) && !!$08b5686a6a5cc5bb$var$typedArrayTags[(0, $eiCDW.default)(value)];
}
var $08b5686a6a5cc5bb$export$2e2bcd8739ae039 = $08b5686a6a5cc5bb$var$baseIsTypedArray;

});
parcelRegister("gukt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00f534a2ff7d394$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $c00f534a2ff7d394$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $c00f534a2ff7d394$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $c00f534a2ff7d394$var$MAX_SAFE_INTEGER;
}
var $c00f534a2ff7d394$export$2e2bcd8739ae039 = $c00f534a2ff7d394$var$isLength;

});


parcelRegister("buofz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d54ea0c82db526$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $85d54ea0c82db526$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $85d54ea0c82db526$export$2e2bcd8739ae039 = $85d54ea0c82db526$var$baseUnary;

});

parcelRegister("faRDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c16691ac8b72a5$export$2e2bcd8739ae039);

var $11x18 = parcelRequire("11x18");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $11x18.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $b0c16691ac8b72a5$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("3GuMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aed2cf0cd8a476a$export$2e2bcd8739ae039);

var $lR8dj = parcelRequire("lR8dj");

var $fnWHY = parcelRequire("fnWHY");
/** Used for built-in method references. */ var $2aed2cf0cd8a476a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2aed2cf0cd8a476a$var$hasOwnProperty = $2aed2cf0cd8a476a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2aed2cf0cd8a476a$var$baseKeys(object) {
    if (!(0, $lR8dj.default)(object)) return (0, $fnWHY.default)(object);
    var result = [];
    for(var key in Object(object))if ($2aed2cf0cd8a476a$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $2aed2cf0cd8a476a$export$2e2bcd8739ae039 = $2aed2cf0cd8a476a$var$baseKeys;

});
parcelRegister("lR8dj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe94eb4c9d004d41$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $fe94eb4c9d004d41$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $fe94eb4c9d004d41$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $fe94eb4c9d004d41$var$objectProto;
    return value === proto;
}
var $fe94eb4c9d004d41$export$2e2bcd8739ae039 = $fe94eb4c9d004d41$var$isPrototype;

});

parcelRegister("fnWHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3368b398cabaec8$export$2e2bcd8739ae039);

var $5tBhB = parcelRequire("5tBhB");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b3368b398cabaec8$var$nativeKeys = (0, $5tBhB.default)(Object.keys, Object);
var $b3368b398cabaec8$export$2e2bcd8739ae039 = $b3368b398cabaec8$var$nativeKeys;

});


parcelRegister("krTMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee3198e3103fbf2a$export$2e2bcd8739ae039);

var $9mi9u = parcelRequire("9mi9u");

var $gukt6 = parcelRequire("gukt6");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ee3198e3103fbf2a$var$isArrayLike(value) {
    return value != null && (0, $gukt6.default)(value.length) && !(0, $9mi9u.default)(value);
}
var $ee3198e3103fbf2a$export$2e2bcd8739ae039 = $ee3198e3103fbf2a$var$isArrayLike;

});



parcelRegister("l9Dd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f668da8a147ebec8$export$2e2bcd8739ae039);

var $8UIBO = parcelRequire("8UIBO");

var $3p62K = parcelRequire("3p62K");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $f668da8a147ebec8$var$baseAssignIn(object, source) {
    return object && (0, $8UIBO.default)(source, (0, $3p62K.default)(source), object);
}
var $f668da8a147ebec8$export$2e2bcd8739ae039 = $f668da8a147ebec8$var$baseAssignIn;

});
parcelRegister("3p62K", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a864f6f03464ce$export$2e2bcd8739ae039);

var $jBX9C = parcelRequire("jBX9C");

var $dtCEP = parcelRequire("dtCEP");

var $krTMn = parcelRequire("krTMn");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $27a864f6f03464ce$var$keysIn(object) {
    return (0, $krTMn.default)(object) ? (0, $jBX9C.default)(object, true) : (0, $dtCEP.default)(object);
}
var $27a864f6f03464ce$export$2e2bcd8739ae039 = $27a864f6f03464ce$var$keysIn;

});
parcelRegister("dtCEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cfbf85c097b731c$export$2e2bcd8739ae039);

var $dDC0W = parcelRequire("dDC0W");

var $lR8dj = parcelRequire("lR8dj");

var $hZfcV = parcelRequire("hZfcV");
/** Used for built-in method references. */ var $9cfbf85c097b731c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9cfbf85c097b731c$var$hasOwnProperty = $9cfbf85c097b731c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $9cfbf85c097b731c$var$baseKeysIn(object) {
    if (!(0, $dDC0W.default)(object)) return (0, $hZfcV.default)(object);
    var isProto = (0, $lR8dj.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$9cfbf85c097b731c$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $9cfbf85c097b731c$export$2e2bcd8739ae039 = $9cfbf85c097b731c$var$baseKeysIn;

});
parcelRegister("hZfcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d183ee128eff4c51$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d183ee128eff4c51$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $d183ee128eff4c51$export$2e2bcd8739ae039 = $d183ee128eff4c51$var$nativeKeysIn;

});




parcelRegister("FXWnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e253664524d34d$export$2e2bcd8739ae039);

var $70LQ9 = parcelRequire("70LQ9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $70LQ9.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $07e253664524d34d$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("2ArVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e249b1614e9a891$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $1e249b1614e9a891$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $1e249b1614e9a891$export$2e2bcd8739ae039 = $1e249b1614e9a891$var$copyArray;

});

parcelRegister("jstNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a7c006256da5a3$export$2e2bcd8739ae039);

var $8UIBO = parcelRequire("8UIBO");

var $kaPlw = parcelRequire("kaPlw");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e2a7c006256da5a3$var$copySymbols(source, object) {
    return (0, $8UIBO.default)(source, (0, $kaPlw.default)(source), object);
}
var $e2a7c006256da5a3$export$2e2bcd8739ae039 = $e2a7c006256da5a3$var$copySymbols;

});
parcelRegister("kaPlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafc92119ebe98de$export$2e2bcd8739ae039);

var $geD06 = parcelRequire("geD06");

var $aS3JQ = parcelRequire("aS3JQ");
/** Used for built-in method references. */ var $eafc92119ebe98de$var$objectProto = Object.prototype;
/** Built-in value references. */ var $eafc92119ebe98de$var$propertyIsEnumerable = $eafc92119ebe98de$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $eafc92119ebe98de$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $eafc92119ebe98de$var$getSymbols = !$eafc92119ebe98de$var$nativeGetSymbols ? (0, $aS3JQ.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $geD06.default)($eafc92119ebe98de$var$nativeGetSymbols(object), function(symbol) {
        return $eafc92119ebe98de$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $eafc92119ebe98de$export$2e2bcd8739ae039 = $eafc92119ebe98de$var$getSymbols;

});
parcelRegister("geD06", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1c34e0933fcd9d$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $bd1c34e0933fcd9d$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $bd1c34e0933fcd9d$export$2e2bcd8739ae039 = $bd1c34e0933fcd9d$var$arrayFilter;

});

parcelRegister("aS3JQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea1d8e9a81a6acd$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $7ea1d8e9a81a6acd$var$stubArray() {
    return [];
}
var $7ea1d8e9a81a6acd$export$2e2bcd8739ae039 = $7ea1d8e9a81a6acd$var$stubArray;

});



parcelRegister("6pCRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ab338cad1814cc4$export$2e2bcd8739ae039);

var $8UIBO = parcelRequire("8UIBO");

var $81ZWT = parcelRequire("81ZWT");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4ab338cad1814cc4$var$copySymbolsIn(source, object) {
    return (0, $8UIBO.default)(source, (0, $81ZWT.default)(source), object);
}
var $4ab338cad1814cc4$export$2e2bcd8739ae039 = $4ab338cad1814cc4$var$copySymbolsIn;

});
parcelRegister("81ZWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d8e78799a942916$export$2e2bcd8739ae039);

var $ipJYg = parcelRequire("ipJYg");

var $j02cG = parcelRequire("j02cG");

var $kaPlw = parcelRequire("kaPlw");

var $aS3JQ = parcelRequire("aS3JQ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5d8e78799a942916$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5d8e78799a942916$var$getSymbolsIn = !$5d8e78799a942916$var$nativeGetSymbols ? (0, $aS3JQ.default) : function(object) {
    var result = [];
    while(object){
        (0, $ipJYg.default)(result, (0, $kaPlw.default)(object));
        object = (0, $j02cG.default)(object);
    }
    return result;
};
var $5d8e78799a942916$export$2e2bcd8739ae039 = $5d8e78799a942916$var$getSymbolsIn;

});
parcelRegister("ipJYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e38a6cb48e995$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $d67e38a6cb48e995$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $d67e38a6cb48e995$export$2e2bcd8739ae039 = $d67e38a6cb48e995$var$arrayPush;

});



parcelRegister("fI8MJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b701c799ded68bf6$export$2e2bcd8739ae039);

var $4lSH6 = parcelRequire("4lSH6");

var $kaPlw = parcelRequire("kaPlw");

var $27tFV = parcelRequire("27tFV");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b701c799ded68bf6$var$getAllKeys(object) {
    return (0, $4lSH6.default)(object, (0, $27tFV.default), (0, $kaPlw.default));
}
var $b701c799ded68bf6$export$2e2bcd8739ae039 = $b701c799ded68bf6$var$getAllKeys;

});
parcelRegister("4lSH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b38cb4c46ed0f5$export$2e2bcd8739ae039);

var $ipJYg = parcelRequire("ipJYg");

var $jAffT = parcelRequire("jAffT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $32b38cb4c46ed0f5$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $jAffT.default)(object) ? result : (0, $ipJYg.default)(result, symbolsFunc(object));
}
var $32b38cb4c46ed0f5$export$2e2bcd8739ae039 = $32b38cb4c46ed0f5$var$baseGetAllKeys;

});


parcelRegister("7WhvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7b8851d18f6aa9$export$2e2bcd8739ae039);

var $4lSH6 = parcelRequire("4lSH6");

var $81ZWT = parcelRequire("81ZWT");

var $3p62K = parcelRequire("3p62K");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5c7b8851d18f6aa9$var$getAllKeysIn(object) {
    return (0, $4lSH6.default)(object, (0, $3p62K.default), (0, $81ZWT.default));
}
var $5c7b8851d18f6aa9$export$2e2bcd8739ae039 = $5c7b8851d18f6aa9$var$getAllKeysIn;

});

parcelRegister("lB6nA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb92007acb87b9b8$export$2e2bcd8739ae039);

var $id7nU = parcelRequire("id7nU");

var $3kCJ0 = parcelRequire("3kCJ0");

var $fl19I = parcelRequire("fl19I");

var $icR2S = parcelRequire("icR2S");

var $byiNs = parcelRequire("byiNs");

var $eiCDW = parcelRequire("eiCDW");

var $5rLXT = parcelRequire("5rLXT");
/** `Object#toString` result references. */ var $fb92007acb87b9b8$var$mapTag = '[object Map]', $fb92007acb87b9b8$var$objectTag = '[object Object]', $fb92007acb87b9b8$var$promiseTag = '[object Promise]', $fb92007acb87b9b8$var$setTag = '[object Set]', $fb92007acb87b9b8$var$weakMapTag = '[object WeakMap]';
var $fb92007acb87b9b8$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $fb92007acb87b9b8$var$dataViewCtorString = (0, $5rLXT.default)((0, $id7nU.default)), $fb92007acb87b9b8$var$mapCtorString = (0, $5rLXT.default)((0, $3kCJ0.default)), $fb92007acb87b9b8$var$promiseCtorString = (0, $5rLXT.default)((0, $fl19I.default)), $fb92007acb87b9b8$var$setCtorString = (0, $5rLXT.default)((0, $icR2S.default)), $fb92007acb87b9b8$var$weakMapCtorString = (0, $5rLXT.default)((0, $byiNs.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $fb92007acb87b9b8$var$getTag = (0, $eiCDW.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $id7nU.default) && $fb92007acb87b9b8$var$getTag(new (0, $id7nU.default)(new ArrayBuffer(1))) != $fb92007acb87b9b8$var$dataViewTag || (0, $3kCJ0.default) && $fb92007acb87b9b8$var$getTag(new (0, $3kCJ0.default)) != $fb92007acb87b9b8$var$mapTag || (0, $fl19I.default) && $fb92007acb87b9b8$var$getTag((0, $fl19I.default).resolve()) != $fb92007acb87b9b8$var$promiseTag || (0, $icR2S.default) && $fb92007acb87b9b8$var$getTag(new (0, $icR2S.default)) != $fb92007acb87b9b8$var$setTag || (0, $byiNs.default) && $fb92007acb87b9b8$var$getTag(new (0, $byiNs.default)) != $fb92007acb87b9b8$var$weakMapTag) $fb92007acb87b9b8$var$getTag = function(value) {
    var result = (0, $eiCDW.default)(value), Ctor = result == $fb92007acb87b9b8$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5rLXT.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $fb92007acb87b9b8$var$dataViewCtorString:
            return $fb92007acb87b9b8$var$dataViewTag;
        case $fb92007acb87b9b8$var$mapCtorString:
            return $fb92007acb87b9b8$var$mapTag;
        case $fb92007acb87b9b8$var$promiseCtorString:
            return $fb92007acb87b9b8$var$promiseTag;
        case $fb92007acb87b9b8$var$setCtorString:
            return $fb92007acb87b9b8$var$setTag;
        case $fb92007acb87b9b8$var$weakMapCtorString:
            return $fb92007acb87b9b8$var$weakMapTag;
    }
    return result;
};
var $fb92007acb87b9b8$export$2e2bcd8739ae039 = $fb92007acb87b9b8$var$getTag;

});
parcelRegister("id7nU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41f2b51303ed3f9$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");

var $70LQ9 = parcelRequire("70LQ9");
/* Built-in method references that are verified to be native. */ var $d41f2b51303ed3f9$var$DataView = (0, $8gS0c.default)((0, $70LQ9.default), 'DataView');
var $d41f2b51303ed3f9$export$2e2bcd8739ae039 = $d41f2b51303ed3f9$var$DataView;

});

parcelRegister("fl19I", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2a9b6b449e38c26$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");

var $70LQ9 = parcelRequire("70LQ9");
/* Built-in method references that are verified to be native. */ var $b2a9b6b449e38c26$var$Promise = (0, $8gS0c.default)((0, $70LQ9.default), 'Promise');
var $b2a9b6b449e38c26$export$2e2bcd8739ae039 = $b2a9b6b449e38c26$var$Promise;

});

parcelRegister("icR2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4127eac515e5d8a$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");

var $70LQ9 = parcelRequire("70LQ9");
/* Built-in method references that are verified to be native. */ var $d4127eac515e5d8a$var$Set = (0, $8gS0c.default)((0, $70LQ9.default), 'Set');
var $d4127eac515e5d8a$export$2e2bcd8739ae039 = $d4127eac515e5d8a$var$Set;

});

parcelRegister("byiNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8691734d63ecf680$export$2e2bcd8739ae039);

var $8gS0c = parcelRequire("8gS0c");

var $70LQ9 = parcelRequire("70LQ9");
/* Built-in method references that are verified to be native. */ var $8691734d63ecf680$var$WeakMap = (0, $8gS0c.default)((0, $70LQ9.default), 'WeakMap');
var $8691734d63ecf680$export$2e2bcd8739ae039 = $8691734d63ecf680$var$WeakMap;

});


parcelRegister("3Ttkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d5d42a6cf51c6c5$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $2d5d42a6cf51c6c5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2d5d42a6cf51c6c5$var$hasOwnProperty = $2d5d42a6cf51c6c5$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $2d5d42a6cf51c6c5$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $2d5d42a6cf51c6c5$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $2d5d42a6cf51c6c5$export$2e2bcd8739ae039 = $2d5d42a6cf51c6c5$var$initCloneArray;

});

parcelRegister("glzVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $be6a78c58cb0afde$export$2e2bcd8739ae039);

var $b8Aax = parcelRequire("b8Aax");

var $8Z4Bv = parcelRequire("8Z4Bv");

var $9tSVL = parcelRequire("9tSVL");

var $7Yqo4 = parcelRequire("7Yqo4");

var $8krZI = parcelRequire("8krZI");
/** `Object#toString` result references. */ var $be6a78c58cb0afde$var$boolTag = '[object Boolean]', $be6a78c58cb0afde$var$dateTag = '[object Date]', $be6a78c58cb0afde$var$mapTag = '[object Map]', $be6a78c58cb0afde$var$numberTag = '[object Number]', $be6a78c58cb0afde$var$regexpTag = '[object RegExp]', $be6a78c58cb0afde$var$setTag = '[object Set]', $be6a78c58cb0afde$var$stringTag = '[object String]', $be6a78c58cb0afde$var$symbolTag = '[object Symbol]';
var $be6a78c58cb0afde$var$arrayBufferTag = '[object ArrayBuffer]', $be6a78c58cb0afde$var$dataViewTag = '[object DataView]', $be6a78c58cb0afde$var$float32Tag = '[object Float32Array]', $be6a78c58cb0afde$var$float64Tag = '[object Float64Array]', $be6a78c58cb0afde$var$int8Tag = '[object Int8Array]', $be6a78c58cb0afde$var$int16Tag = '[object Int16Array]', $be6a78c58cb0afde$var$int32Tag = '[object Int32Array]', $be6a78c58cb0afde$var$uint8Tag = '[object Uint8Array]', $be6a78c58cb0afde$var$uint8ClampedTag = '[object Uint8ClampedArray]', $be6a78c58cb0afde$var$uint16Tag = '[object Uint16Array]', $be6a78c58cb0afde$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $be6a78c58cb0afde$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $be6a78c58cb0afde$var$arrayBufferTag:
            return (0, $b8Aax.default)(object);
        case $be6a78c58cb0afde$var$boolTag:
        case $be6a78c58cb0afde$var$dateTag:
            return new Ctor(+object);
        case $be6a78c58cb0afde$var$dataViewTag:
            return (0, $8Z4Bv.default)(object, isDeep);
        case $be6a78c58cb0afde$var$float32Tag:
        case $be6a78c58cb0afde$var$float64Tag:
        case $be6a78c58cb0afde$var$int8Tag:
        case $be6a78c58cb0afde$var$int16Tag:
        case $be6a78c58cb0afde$var$int32Tag:
        case $be6a78c58cb0afde$var$uint8Tag:
        case $be6a78c58cb0afde$var$uint8ClampedTag:
        case $be6a78c58cb0afde$var$uint16Tag:
        case $be6a78c58cb0afde$var$uint32Tag:
            return (0, $8krZI.default)(object, isDeep);
        case $be6a78c58cb0afde$var$mapTag:
            return new Ctor;
        case $be6a78c58cb0afde$var$numberTag:
        case $be6a78c58cb0afde$var$stringTag:
            return new Ctor(object);
        case $be6a78c58cb0afde$var$regexpTag:
            return (0, $9tSVL.default)(object);
        case $be6a78c58cb0afde$var$setTag:
            return new Ctor;
        case $be6a78c58cb0afde$var$symbolTag:
            return (0, $7Yqo4.default)(object);
    }
}
var $be6a78c58cb0afde$export$2e2bcd8739ae039 = $be6a78c58cb0afde$var$initCloneByTag;

});
parcelRegister("b8Aax", function(module, exports) {

$parcel$export(module.exports, "default", () => $81bc7f72dfc198b2$export$2e2bcd8739ae039);

var $3imC5 = parcelRequire("3imC5");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $81bc7f72dfc198b2$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $3imC5.default)(result).set(new (0, $3imC5.default)(arrayBuffer));
    return result;
}
var $81bc7f72dfc198b2$export$2e2bcd8739ae039 = $81bc7f72dfc198b2$var$cloneArrayBuffer;

});
parcelRegister("3imC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2664981798606105$export$2e2bcd8739ae039);

var $70LQ9 = parcelRequire("70LQ9");
/** Built-in value references. */ var $2664981798606105$var$Uint8Array = (0, $70LQ9.default).Uint8Array;
var $2664981798606105$export$2e2bcd8739ae039 = $2664981798606105$var$Uint8Array;

});


parcelRegister("8Z4Bv", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a7977e49573001$export$2e2bcd8739ae039);

var $b8Aax = parcelRequire("b8Aax");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $68a7977e49573001$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $b8Aax.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $68a7977e49573001$export$2e2bcd8739ae039 = $68a7977e49573001$var$cloneDataView;

});

parcelRegister("9tSVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e716e9763e1a898$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $6e716e9763e1a898$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $6e716e9763e1a898$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $6e716e9763e1a898$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $6e716e9763e1a898$export$2e2bcd8739ae039 = $6e716e9763e1a898$var$cloneRegExp;

});

parcelRegister("7Yqo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ce29afa084ee022$export$2e2bcd8739ae039);

var $cyUto = parcelRequire("cyUto");
/** Used to convert symbols to primitives and strings. */ var $5ce29afa084ee022$var$symbolProto = (0, $cyUto.default) ? (0, $cyUto.default).prototype : undefined, $5ce29afa084ee022$var$symbolValueOf = $5ce29afa084ee022$var$symbolProto ? $5ce29afa084ee022$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $5ce29afa084ee022$var$cloneSymbol(symbol) {
    return $5ce29afa084ee022$var$symbolValueOf ? Object($5ce29afa084ee022$var$symbolValueOf.call(symbol)) : {};
}
var $5ce29afa084ee022$export$2e2bcd8739ae039 = $5ce29afa084ee022$var$cloneSymbol;

});

parcelRegister("8krZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105e81649b906e2$export$2e2bcd8739ae039);

var $b8Aax = parcelRequire("b8Aax");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $6105e81649b906e2$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $b8Aax.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $6105e81649b906e2$export$2e2bcd8739ae039 = $6105e81649b906e2$var$cloneTypedArray;

});


parcelRegister("6Vloe", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a8a8896d4cc830$export$2e2bcd8739ae039);

var $jdg7P = parcelRequire("jdg7P");

var $j02cG = parcelRequire("j02cG");

var $lR8dj = parcelRequire("lR8dj");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $50a8a8896d4cc830$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $lR8dj.default)(object) ? (0, $jdg7P.default)((0, $j02cG.default)(object)) : {};
}
var $50a8a8896d4cc830$export$2e2bcd8739ae039 = $50a8a8896d4cc830$var$initCloneObject;

});
parcelRegister("jdg7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcbbd5e9ca40083$export$2e2bcd8739ae039);

var $dDC0W = parcelRequire("dDC0W");
/** Built-in value references. */ var $dfcbbd5e9ca40083$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $dfcbbd5e9ca40083$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $dDC0W.default)(proto)) return {};
        if ($dfcbbd5e9ca40083$var$objectCreate) return $dfcbbd5e9ca40083$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $dfcbbd5e9ca40083$export$2e2bcd8739ae039 = $dfcbbd5e9ca40083$var$baseCreate;

});


parcelRegister("kADuo", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd5cd2f5b9fd46b$export$2e2bcd8739ae039);

var $53sTy = parcelRequire("53sTy");

var $buofz = parcelRequire("buofz");

var $faRDV = parcelRequire("faRDV");
/* Node.js helper references. */ var $efd5cd2f5b9fd46b$var$nodeIsMap = (0, $faRDV.default) && (0, $faRDV.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $efd5cd2f5b9fd46b$var$isMap = $efd5cd2f5b9fd46b$var$nodeIsMap ? (0, $buofz.default)($efd5cd2f5b9fd46b$var$nodeIsMap) : (0, $53sTy.default);
var $efd5cd2f5b9fd46b$export$2e2bcd8739ae039 = $efd5cd2f5b9fd46b$var$isMap;

});
parcelRegister("53sTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae3a5813eeb5b69$export$2e2bcd8739ae039);

var $lB6nA = parcelRequire("lB6nA");

var $cgtkx = parcelRequire("cgtkx");
/** `Object#toString` result references. */ var $3ae3a5813eeb5b69$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $3ae3a5813eeb5b69$var$baseIsMap(value) {
    return (0, $cgtkx.default)(value) && (0, $lB6nA.default)(value) == $3ae3a5813eeb5b69$var$mapTag;
}
var $3ae3a5813eeb5b69$export$2e2bcd8739ae039 = $3ae3a5813eeb5b69$var$baseIsMap;

});


parcelRegister("lMxci", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb7d4f38b4b512e$export$2e2bcd8739ae039);

var $aXosi = parcelRequire("aXosi");

var $buofz = parcelRequire("buofz");

var $faRDV = parcelRequire("faRDV");
/* Node.js helper references. */ var $fdb7d4f38b4b512e$var$nodeIsSet = (0, $faRDV.default) && (0, $faRDV.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $fdb7d4f38b4b512e$var$isSet = $fdb7d4f38b4b512e$var$nodeIsSet ? (0, $buofz.default)($fdb7d4f38b4b512e$var$nodeIsSet) : (0, $aXosi.default);
var $fdb7d4f38b4b512e$export$2e2bcd8739ae039 = $fdb7d4f38b4b512e$var$isSet;

});
parcelRegister("aXosi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa2626822fa1a21$export$2e2bcd8739ae039);

var $lB6nA = parcelRequire("lB6nA");

var $cgtkx = parcelRequire("cgtkx");
/** `Object#toString` result references. */ var $7fa2626822fa1a21$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $7fa2626822fa1a21$var$baseIsSet(value) {
    return (0, $cgtkx.default)(value) && (0, $lB6nA.default)(value) == $7fa2626822fa1a21$var$setTag;
}
var $7fa2626822fa1a21$export$2e2bcd8739ae039 = $7fa2626822fa1a21$var$baseIsSet;

});




parcelRegister("6QVQ4", function(module, exports) {
'use strict';
var $4fd47700e5270a68$var$isArray = Array.isArray;
var $4fd47700e5270a68$var$keyList = Object.keys;
var $4fd47700e5270a68$var$hasProp = Object.prototype.hasOwnProperty;
var $4fd47700e5270a68$var$hasElementType = typeof Element !== 'undefined';
function $4fd47700e5270a68$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $4fd47700e5270a68$var$isArray(a), arrB = $4fd47700e5270a68$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4fd47700e5270a68$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $4fd47700e5270a68$var$keyList(a);
        length = keys.length;
        if (length !== $4fd47700e5270a68$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$4fd47700e5270a68$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($4fd47700e5270a68$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$4fd47700e5270a68$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $4fd47700e5270a68$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("aahLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $76689e71bf270341$export$2e2bcd8739ae039);
var $76689e71bf270341$var$isProduction = true;
function $76689e71bf270341$var$warning(condition, message) {
    if (!$76689e71bf270341$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $76689e71bf270341$export$2e2bcd8739ae039 = $76689e71bf270341$var$warning;

});

parcelRegister("6Vykm", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b2b1a7eadc0e7b$export$2e2bcd8739ae039);

var $hB4es = parcelRequire("hB4es");
/** Used to compose bitmasks for cloning. */ var $50b2b1a7eadc0e7b$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $50b2b1a7eadc0e7b$var$clone(value) {
    return (0, $hB4es.default)(value, $50b2b1a7eadc0e7b$var$CLONE_SYMBOLS_FLAG);
}
var $50b2b1a7eadc0e7b$export$2e2bcd8739ae039 = $50b2b1a7eadc0e7b$var$clone;

});

parcelRegister("5DZk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $41c029e16d3766dd$export$2e2bcd8739ae039);

var $4t8vQ = parcelRequire("4t8vQ");

var $2ArVt = parcelRequire("2ArVt");

var $jAffT = parcelRequire("jAffT");

var $8gHSm = parcelRequire("8gHSm");

var $j2GPQ = parcelRequire("j2GPQ");

var $hgJv9 = parcelRequire("hgJv9");

var $tS2l8 = parcelRequire("tS2l8");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $41c029e16d3766dd$var$toPath(value) {
    if ((0, $jAffT.default)(value)) return (0, $4t8vQ.default)(value, (0, $hgJv9.default));
    return (0, $8gHSm.default)(value) ? [
        value
    ] : (0, $2ArVt.default)((0, $j2GPQ.default)((0, $tS2l8.default)(value)));
}
var $41c029e16d3766dd$export$2e2bcd8739ae039 = $41c029e16d3766dd$var$toPath;

});
parcelRegister("4t8vQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34107943b4598fca$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $34107943b4598fca$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $34107943b4598fca$export$2e2bcd8739ae039 = $34107943b4598fca$var$arrayMap;

});

parcelRegister("8gHSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6051da31f2092fb8$export$2e2bcd8739ae039);

var $eiCDW = parcelRequire("eiCDW");

var $cgtkx = parcelRequire("cgtkx");
/** `Object#toString` result references. */ var $6051da31f2092fb8$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6051da31f2092fb8$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $cgtkx.default)(value) && (0, $eiCDW.default)(value) == $6051da31f2092fb8$var$symbolTag;
}
var $6051da31f2092fb8$export$2e2bcd8739ae039 = $6051da31f2092fb8$var$isSymbol;

});

parcelRegister("j2GPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddcf6e66dc46ee72$export$2e2bcd8739ae039);

var $lNKw3 = parcelRequire("lNKw3");
/** Used to match property names within property paths. */ var $ddcf6e66dc46ee72$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $ddcf6e66dc46ee72$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $ddcf6e66dc46ee72$var$stringToPath = (0, $lNKw3.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($ddcf6e66dc46ee72$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($ddcf6e66dc46ee72$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $ddcf6e66dc46ee72$export$2e2bcd8739ae039 = $ddcf6e66dc46ee72$var$stringToPath;

});
parcelRegister("lNKw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdf241b1d9308f0c$export$2e2bcd8739ae039);

var $1Hs21 = parcelRequire("1Hs21");
/** Used as the maximum memoize cache size. */ var $fdf241b1d9308f0c$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $fdf241b1d9308f0c$var$memoizeCapped(func) {
    var result = (0, $1Hs21.default)(func, function(key) {
        if (cache.size === $fdf241b1d9308f0c$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $fdf241b1d9308f0c$export$2e2bcd8739ae039 = $fdf241b1d9308f0c$var$memoizeCapped;

});
parcelRegister("1Hs21", function(module, exports) {

$parcel$export(module.exports, "default", () => $13cf8d14db860581$export$2e2bcd8739ae039);

var $cbDIj = parcelRequire("cbDIj");
/** Error message constants. */ var $13cf8d14db860581$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $13cf8d14db860581$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($13cf8d14db860581$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($13cf8d14db860581$var$memoize.Cache || (0, $cbDIj.default));
    return memoized;
}
// Expose `MapCache`.
$13cf8d14db860581$var$memoize.Cache = (0, $cbDIj.default);
var $13cf8d14db860581$export$2e2bcd8739ae039 = $13cf8d14db860581$var$memoize;

});



parcelRegister("hgJv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92739f0a75e5fcd$export$2e2bcd8739ae039);

var $8gHSm = parcelRequire("8gHSm");
/** Used as references for various `Number` constants. */ var $c92739f0a75e5fcd$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c92739f0a75e5fcd$var$toKey(value) {
    if (typeof value == 'string' || (0, $8gHSm.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c92739f0a75e5fcd$var$INFINITY ? '-0' : result;
}
var $c92739f0a75e5fcd$export$2e2bcd8739ae039 = $c92739f0a75e5fcd$var$toKey;

});

parcelRegister("tS2l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $059ca01e63a1eb5a$export$2e2bcd8739ae039);

var $e4VAd = parcelRequire("e4VAd");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $059ca01e63a1eb5a$var$toString(value) {
    return value == null ? '' : (0, $e4VAd.default)(value);
}
var $059ca01e63a1eb5a$export$2e2bcd8739ae039 = $059ca01e63a1eb5a$var$toString;

});
parcelRegister("e4VAd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3fe1b37f1798bb2$export$2e2bcd8739ae039);

var $cyUto = parcelRequire("cyUto");

var $4t8vQ = parcelRequire("4t8vQ");

var $jAffT = parcelRequire("jAffT");

var $8gHSm = parcelRequire("8gHSm");
/** Used as references for various `Number` constants. */ var $a3fe1b37f1798bb2$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $a3fe1b37f1798bb2$var$symbolProto = (0, $cyUto.default) ? (0, $cyUto.default).prototype : undefined, $a3fe1b37f1798bb2$var$symbolToString = $a3fe1b37f1798bb2$var$symbolProto ? $a3fe1b37f1798bb2$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $a3fe1b37f1798bb2$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $jAffT.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $4t8vQ.default)(value, $a3fe1b37f1798bb2$var$baseToString) + '';
    if ((0, $8gHSm.default)(value)) return $a3fe1b37f1798bb2$var$symbolToString ? $a3fe1b37f1798bb2$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$a3fe1b37f1798bb2$var$INFINITY ? '-0' : result;
}
var $a3fe1b37f1798bb2$export$2e2bcd8739ae039 = $a3fe1b37f1798bb2$var$baseToString;

});




parcelRegister("iCMh0", function(module, exports) {

$parcel$export(module.exports, "withZodSchema", () => $d8f138a757ebcef7$export$298875f7af13aed);

var $1ISKL = parcelRequire("1ISKL");
const $d8f138a757ebcef7$export$298875f7af13aed = (schema, params)=>(values)=>{
        const result = schema.safeParse(values, params);
        if (result.success) return {};
        return result.error.issues.reduce((acc, curr)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($1ISKL)))(acc, curr.path.reduceRight((errors, pathSegment)=>({
                    [pathSegment]: !Object.keys(errors).length ? curr.message : errors
                }), {}));
        }, {});
    };

});
parcelRegister("1ISKL", function(module, exports) {
'use strict';
var $14145f62e8f6f1a7$var$isMergeableObject = function isMergeableObject(value) {
    return $14145f62e8f6f1a7$var$isNonNullObject(value) && !$14145f62e8f6f1a7$var$isSpecial(value);
};
function $14145f62e8f6f1a7$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $14145f62e8f6f1a7$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $14145f62e8f6f1a7$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $14145f62e8f6f1a7$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $14145f62e8f6f1a7$var$REACT_ELEMENT_TYPE = $14145f62e8f6f1a7$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $14145f62e8f6f1a7$var$isReactElement(value) {
    return value.$$typeof === $14145f62e8f6f1a7$var$REACT_ELEMENT_TYPE;
}
function $14145f62e8f6f1a7$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $14145f62e8f6f1a7$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $14145f62e8f6f1a7$var$deepmerge($14145f62e8f6f1a7$var$emptyTarget(value), value, options) : value;
}
function $14145f62e8f6f1a7$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $14145f62e8f6f1a7$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $14145f62e8f6f1a7$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $14145f62e8f6f1a7$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : $14145f62e8f6f1a7$var$deepmerge;
}
function $14145f62e8f6f1a7$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $14145f62e8f6f1a7$var$getKeys(target) {
    return Object.keys(target).concat($14145f62e8f6f1a7$var$getEnumerableOwnPropertySymbols(target));
}
function $14145f62e8f6f1a7$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $14145f62e8f6f1a7$var$propertyIsUnsafe(target, key) {
    return $14145f62e8f6f1a7$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $14145f62e8f6f1a7$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $14145f62e8f6f1a7$var$getKeys(target).forEach(function(key) {
        destination[key] = $14145f62e8f6f1a7$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $14145f62e8f6f1a7$var$getKeys(source).forEach(function(key) {
        if ($14145f62e8f6f1a7$var$propertyIsUnsafe(target, key)) return;
        if ($14145f62e8f6f1a7$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $14145f62e8f6f1a7$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $14145f62e8f6f1a7$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $14145f62e8f6f1a7$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $14145f62e8f6f1a7$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $14145f62e8f6f1a7$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $14145f62e8f6f1a7$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $14145f62e8f6f1a7$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $14145f62e8f6f1a7$var$mergeObject(target, source, options);
}
$14145f62e8f6f1a7$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $14145f62e8f6f1a7$var$deepmerge(prev, next, options);
    }, {});
};
var $14145f62e8f6f1a7$var$deepmerge_1 = $14145f62e8f6f1a7$var$deepmerge;
module.exports = $14145f62e8f6f1a7$var$deepmerge_1;

});


parcelRegister("lVeRZ", function(module, exports) {

$parcel$export(module.exports, "custom", () => $ff5a74ae866d4b44$export$4c00f665f0d4b443);
$parcel$export(module.exports, "string", () => $ff5a74ae866d4b44$export$22b082955e083ec3);
$parcel$export(module.exports, "number", () => $ff5a74ae866d4b44$export$98e628dec113755e);
$parcel$export(module.exports, "boolean", () => $ff5a74ae866d4b44$export$4a21f16c33752377);
$parcel$export(module.exports, "array", () => $ff5a74ae866d4b44$export$2f23118c22fb2630);
$parcel$export(module.exports, "object", () => $ff5a74ae866d4b44$export$be5493f9613cbbe);
$parcel$export(module.exports, "nativeEnum", () => $ff5a74ae866d4b44$export$6fe7eca19ebe5199);

var $aKRBY = parcelRequire("aKRBY");
parcelRequire("kRHPG");
var $bvdlG = parcelRequire("bvdlG");
var $kRHPG = parcelRequire("kRHPG");

var $jW7TA = parcelRequire("jW7TA");

var $etSSW = parcelRequire("etSSW");

var $164Eb = parcelRequire("164Eb");
class $ff5a74ae866d4b44$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $ff5a74ae866d4b44$var$handleResult = (ctx, result)=>{
    if ((0, $etSSW.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, $aKRBY.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $ff5a74ae866d4b44$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $164Eb.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $164Eb.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, $etSSW.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $164Eb.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $etSSW.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $164Eb.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $ff5a74ae866d4b44$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $164Eb.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return (0, $etSSW.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>(0, $etSSW.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $164Eb.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $etSSW.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $ff5a74ae866d4b44$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, $aKRBY.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $ff5a74ae866d4b44$export$a60af00cc0ce2582({
            schema: this,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $ff5a74ae866d4b44$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $ff5a74ae866d4b44$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $ff5a74ae866d4b44$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $ff5a74ae866d4b44$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $ff5a74ae866d4b44$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $ff5a74ae866d4b44$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $ff5a74ae866d4b44$export$a60af00cc0ce2582({
            ...$ff5a74ae866d4b44$var$processCreateParams(this._def),
            schema: this,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $ff5a74ae866d4b44$export$bb19b37874861e7e({
            ...$ff5a74ae866d4b44$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $ff5a74ae866d4b44$export$66b0c798a395271f({
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$ff5a74ae866d4b44$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $ff5a74ae866d4b44$export$75a44ec6249ac76b({
            ...$ff5a74ae866d4b44$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $ff5a74ae866d4b44$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $ff5a74ae866d4b44$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $ff5a74ae866d4b44$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $ff5a74ae866d4b44$var$cuid2Regex = /^[0-9a-z]+$/;
const $ff5a74ae866d4b44$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $ff5a74ae866d4b44$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $ff5a74ae866d4b44$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $ff5a74ae866d4b44$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $ff5a74ae866d4b44$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $ff5a74ae866d4b44$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $ff5a74ae866d4b44$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $ff5a74ae866d4b44$var$emojiRegex;
// faster, simpler, safer
const $ff5a74ae866d4b44$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $ff5a74ae866d4b44$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $ff5a74ae866d4b44$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $ff5a74ae866d4b44$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $ff5a74ae866d4b44$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $ff5a74ae866d4b44$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $ff5a74ae866d4b44$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $ff5a74ae866d4b44$var$dateRegex = new RegExp(`^${$ff5a74ae866d4b44$var$dateRegexSource}$`);
function $ff5a74ae866d4b44$var$timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function $ff5a74ae866d4b44$var$timeRegex(args) {
    return new RegExp(`^${$ff5a74ae866d4b44$var$timeRegexSource(args)}$`);
}
function $ff5a74ae866d4b44$export$a4b563879add27a(args) {
    let regex = `${$ff5a74ae866d4b44$var$dateRegexSource}T${$ff5a74ae866d4b44$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $ff5a74ae866d4b44$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $ff5a74ae866d4b44$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $ff5a74ae866d4b44$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $ff5a74ae866d4b44$var$isValidJWT(jwt, alg) {
    if (!$ff5a74ae866d4b44$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function $ff5a74ae866d4b44$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $ff5a74ae866d4b44$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $ff5a74ae866d4b44$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $ff5a74ae866d4b44$export$1230eb29b8d3b502 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const status = new (0, $etSSW.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$ff5a74ae866d4b44$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$ff5a74ae866d4b44$var$emojiRegex) $ff5a74ae866d4b44$var$emojiRegex = new RegExp($ff5a74ae866d4b44$var$_emojiRegex, "u");
                if (!$ff5a74ae866d4b44$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$ff5a74ae866d4b44$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$ff5a74ae866d4b44$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$ff5a74ae866d4b44$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$ff5a74ae866d4b44$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$ff5a74ae866d4b44$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $etSSW.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, $aKRBY.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $ff5a74ae866d4b44$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $ff5a74ae866d4b44$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $ff5a74ae866d4b44$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$ff5a74ae866d4b44$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$ff5a74ae866d4b44$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$ff5a74ae866d4b44$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$ff5a74ae866d4b44$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$ff5a74ae866d4b44$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$ff5a74ae866d4b44$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, $aKRBY.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $164Eb.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: (0, $aKRBY.ZodIssueCode).invalid_string,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new $ff5a74ae866d4b44$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, $jW7TA.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, $jW7TA.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, $jW7TA.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, $jW7TA.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, $jW7TA.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, $jW7TA.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, $jW7TA.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, $jW7TA.errorUtil).errToObj(message));
    }
    trim() {
        return new $ff5a74ae866d4b44$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $ff5a74ae866d4b44$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $ff5a74ae866d4b44$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$ff5a74ae866d4b44$export$1230eb29b8d3b502.create = (params)=>{
    return new $ff5a74ae866d4b44$export$1230eb29b8d3b502({
        checks: [],
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodString,
        coerce: params?.coerce ?? false,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $ff5a74ae866d4b44$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class $ff5a74ae866d4b44$export$5b070a55c0c43e09 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        let ctx = undefined;
        const status = new (0, $etSSW.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, $164Eb.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($ff5a74ae866d4b44$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $164Eb.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $jW7TA.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $jW7TA.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $jW7TA.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $jW7TA.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $ff5a74ae866d4b44$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $jW7TA.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $ff5a74ae866d4b44$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, $jW7TA.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, $164Eb.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$ff5a74ae866d4b44$export$5b070a55c0c43e09.create = (params)=>{
    return new $ff5a74ae866d4b44$export$5b070a55c0c43e09({
        checks: [],
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodNumber,
        coerce: params?.coerce || false,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$67d741fd70ff98f4 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, $etSSW.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, $164Eb.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $etSSW.addIssueToContext)(ctx, {
            code: (0, $aKRBY.ZodIssueCode).invalid_type,
            expected: (0, $164Eb.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, $etSSW.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, $jW7TA.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, $jW7TA.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, $jW7TA.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, $jW7TA.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $ff5a74ae866d4b44$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: (0, $jW7TA.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $ff5a74ae866d4b44$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$ff5a74ae866d4b44$export$67d741fd70ff98f4.create = (params)=>{
    return new $ff5a74ae866d4b44$export$67d741fd70ff98f4({
        checks: [],
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$723d146f80596191 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$723d146f80596191.create = (params)=>{
    return new $ff5a74ae866d4b44$export$723d146f80596191({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodBoolean,
        coerce: params?.coerce || false,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$e974be33bdc55521 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_date
            });
            return 0, $etSSW.INVALID;
        }
        const status = new (0, $etSSW.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, $164Eb.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $ff5a74ae866d4b44$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, $jW7TA.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$ff5a74ae866d4b44$export$e974be33bdc55521.create = (params)=>{
    return new $ff5a74ae866d4b44$export$e974be33bdc55521({
        checks: [],
        coerce: params?.coerce || false,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodDate,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$bcc3b40f6b638044 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$bcc3b40f6b638044.create = (params)=>{
    return new $ff5a74ae866d4b44$export$bcc3b40f6b638044({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodSymbol,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$4e780e961c30340d extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$4e780e961c30340d.create = (params)=>{
    return new $ff5a74ae866d4b44$export$4e780e961c30340d({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodUndefined,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$a96281f914484f2d extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$a96281f914484f2d.create = (params)=>{
    return new $ff5a74ae866d4b44$export$a96281f914484f2d({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodNull,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$b9d1edb536b4e4eb extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $ff5a74ae866d4b44$export$b9d1edb536b4e4eb({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodAny,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$ef3b1bb1630977ae extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$ef3b1bb1630977ae.create = (params)=>{
    return new $ff5a74ae866d4b44$export$ef3b1bb1630977ae({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodUnknown,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$1e576a20c3ce9fb5 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $etSSW.addIssueToContext)(ctx, {
            code: (0, $aKRBY.ZodIssueCode).invalid_type,
            expected: (0, $164Eb.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, $etSSW.INVALID;
    }
}
$ff5a74ae866d4b44$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $ff5a74ae866d4b44$export$1e576a20c3ce9fb5({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodNever,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$7d39f5df85f21031 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
}
$ff5a74ae866d4b44$export$7d39f5df85f21031.create = (params)=>{
    return new $ff5a74ae866d4b44$export$7d39f5df85f21031({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodVoid,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$7acfc3e64785411 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).array) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $etSSW.addIssueToContext)(ctx, {
                    code: tooBig ? (0, $aKRBY.ZodIssueCode).too_big : (0, $aKRBY.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $etSSW.addIssueToContext)(ctx, {
                    code: (0, $aKRBY.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $etSSW.addIssueToContext)(ctx, {
                    code: (0, $aKRBY.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, $etSSW.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, $etSSW.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $ff5a74ae866d4b44$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, $jW7TA.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $ff5a74ae866d4b44$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, $jW7TA.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new $ff5a74ae866d4b44$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, $jW7TA.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$ff5a74ae866d4b44$export$7acfc3e64785411.create = (schema, params)=>{
    return new $ff5a74ae866d4b44$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodArray,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
function $ff5a74ae866d4b44$var$deepPartialify(schema) {
    if (schema instanceof $ff5a74ae866d4b44$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $ff5a74ae866d4b44$export$aa56fec1e9d629b8.create($ff5a74ae866d4b44$var$deepPartialify(fieldSchema));
        }
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $ff5a74ae866d4b44$export$7acfc3e64785411) return new $ff5a74ae866d4b44$export$7acfc3e64785411({
        ...schema._def,
        type: $ff5a74ae866d4b44$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $ff5a74ae866d4b44$export$aa56fec1e9d629b8) return $ff5a74ae866d4b44$export$aa56fec1e9d629b8.create($ff5a74ae866d4b44$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $ff5a74ae866d4b44$export$aaac0b8b429cef5) return $ff5a74ae866d4b44$export$aaac0b8b429cef5.create($ff5a74ae866d4b44$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $ff5a74ae866d4b44$export$e2a18bb771d8e6a3) return $ff5a74ae866d4b44$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$ff5a74ae866d4b44$var$deepPartialify(item)));
    else return schema;
}
class $ff5a74ae866d4b44$export$736315c5b55efbad extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, $164Eb.util).objectKeys(shape);
        this._cached = {
            shape: shape,
            keys: keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $ff5a74ae866d4b44$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $ff5a74ae866d4b44$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $etSSW.addIssueToContext)(ctx, {
                        code: (0, $aKRBY.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, $etSSW.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, $etSSW.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, $jW7TA.errorUtil).errToObj;
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, $jW7TA.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $ff5a74ae866d4b44$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, $164Eb.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, $164Eb.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $ff5a74ae866d4b44$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, $164Eb.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, $164Eb.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof $ff5a74ae866d4b44$export$aa56fec1e9d629b8)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new $ff5a74ae866d4b44$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $ff5a74ae866d4b44$var$createZodEnum((0, $164Eb.util).objectKeys(this.shape));
    }
}
$ff5a74ae866d4b44$export$736315c5b55efbad.create = (shape, params)=>{
    return new $ff5a74ae866d4b44$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $ff5a74ae866d4b44$export$1e576a20c3ce9fb5.create(),
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodObject,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
$ff5a74ae866d4b44$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $ff5a74ae866d4b44$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $ff5a74ae866d4b44$export$1e576a20c3ce9fb5.create(),
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodObject,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
$ff5a74ae866d4b44$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $ff5a74ae866d4b44$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $ff5a74ae866d4b44$export$1e576a20c3ce9fb5.create(),
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodObject,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$a8b236cb5070a311 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, $aKRBY.ZodError)(result.ctx.common.issues));
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $etSSW.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, $aKRBY.ZodError)(issues));
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_union,
                unionErrors: unionErrors
            });
            return 0, $etSSW.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
$ff5a74ae866d4b44$export$a8b236cb5070a311.create = (types, params)=>{
    return new $ff5a74ae866d4b44$export$a8b236cb5070a311({
        options: types,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodUnion,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $ff5a74ae866d4b44$var$getDiscriminator = (type)=>{
    if (type instanceof $ff5a74ae866d4b44$export$378d0cfce37406e6) return $ff5a74ae866d4b44$var$getDiscriminator(type.schema);
    else if (type instanceof $ff5a74ae866d4b44$export$a60af00cc0ce2582) return $ff5a74ae866d4b44$var$getDiscriminator(type.innerType());
    else if (type instanceof $ff5a74ae866d4b44$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $ff5a74ae866d4b44$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $ff5a74ae866d4b44$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return (0, $164Eb.util).objectValues(type.enum);
    else if (type instanceof $ff5a74ae866d4b44$export$bb19b37874861e7e) return $ff5a74ae866d4b44$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $ff5a74ae866d4b44$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $ff5a74ae866d4b44$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $ff5a74ae866d4b44$export$aa56fec1e9d629b8) return [
        undefined,
        ...$ff5a74ae866d4b44$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $ff5a74ae866d4b44$export$aaac0b8b429cef5) return [
        null,
        ...$ff5a74ae866d4b44$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $ff5a74ae866d4b44$export$66b0c798a395271f) return $ff5a74ae866d4b44$var$getDiscriminator(type.unwrap());
    else if (type instanceof $ff5a74ae866d4b44$export$5d1f7ef05c4e493a) return $ff5a74ae866d4b44$var$getDiscriminator(type.unwrap());
    else if (type instanceof $ff5a74ae866d4b44$export$75a44ec6249ac76b) return $ff5a74ae866d4b44$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $ff5a74ae866d4b44$export$5ef2424805ac76a3 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).object) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, $etSSW.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $ff5a74ae866d4b44$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $ff5a74ae866d4b44$export$5ef2424805ac76a3({
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$ff5a74ae866d4b44$var$processCreateParams(params)
        });
    }
}
function $ff5a74ae866d4b44$var$mergeValues(a, b) {
    const aType = (0, $164Eb.getParsedType)(a);
    const bType = (0, $164Eb.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, $164Eb.ZodParsedType).object && bType === (0, $164Eb.ZodParsedType).object) {
        const bKeys = (0, $164Eb.util).objectKeys(b);
        const sharedKeys = (0, $164Eb.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $ff5a74ae866d4b44$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, $164Eb.ZodParsedType).array && bType === (0, $164Eb.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $ff5a74ae866d4b44$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, $164Eb.ZodParsedType).date && bType === (0, $164Eb.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $ff5a74ae866d4b44$export$c02deaf0bb5203d4 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $etSSW.isAborted)(parsedLeft) || (0, $etSSW.isAborted)(parsedRight)) return 0, $etSSW.INVALID;
            const merged = $ff5a74ae866d4b44$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $etSSW.addIssueToContext)(ctx, {
                    code: (0, $aKRBY.ZodIssueCode).invalid_intersection_types
                });
                return 0, $etSSW.INVALID;
            }
            if ((0, $etSSW.isDirty)(parsedLeft) || (0, $etSSW.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$ff5a74ae866d4b44$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $ff5a74ae866d4b44$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodIntersection,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$e2a18bb771d8e6a3 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).array) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, $etSSW.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, $etSSW.ParseStatus).mergeArray(status, results);
        });
        else return (0, $etSSW.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $ff5a74ae866d4b44$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$ff5a74ae866d4b44$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $ff5a74ae866d4b44$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$a2acc09968cb4b7f extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).object) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, $etSSW.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, $etSSW.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $ff5a74ae866d4b44$export$2afb8ab49d4b92c0) return new $ff5a74ae866d4b44$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodRecord,
            ...$ff5a74ae866d4b44$var$processCreateParams(third)
        });
        return new $ff5a74ae866d4b44$export$a2acc09968cb4b7f({
            keyType: $ff5a74ae866d4b44$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodRecord,
            ...$ff5a74ae866d4b44$var$processCreateParams(second)
        });
    }
}
class $ff5a74ae866d4b44$export$163b6a2b712d9542 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).map) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, $etSSW.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, $etSSW.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$ff5a74ae866d4b44$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $ff5a74ae866d4b44$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodMap,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$977057706f816712 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).set) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $etSSW.addIssueToContext)(ctx, {
                    code: (0, $aKRBY.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $etSSW.addIssueToContext)(ctx, {
                    code: (0, $aKRBY.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, $etSSW.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $ff5a74ae866d4b44$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $ff5a74ae866d4b44$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, $jW7TA.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $ff5a74ae866d4b44$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, $jW7TA.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$ff5a74ae866d4b44$export$977057706f816712.create = (valueType, params)=>{
    return new $ff5a74ae866d4b44$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodSet,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$d4602ba55673f53c extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).function) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $etSSW.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $kRHPG.getErrorMap)(),
                    (0, $bvdlG.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $aKRBY.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $etSSW.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $kRHPG.getErrorMap)(),
                    (0, $bvdlG.default)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, $aKRBY.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $ff5a74ae866d4b44$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $etSSW.OK)(async function(...args) {
                const error = new (0, $aKRBY.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $etSSW.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, $aKRBY.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, $aKRBY.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $ff5a74ae866d4b44$export$d4602ba55673f53c({
            ...this._def,
            args: $ff5a74ae866d4b44$export$e2a18bb771d8e6a3.create(items).rest($ff5a74ae866d4b44$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $ff5a74ae866d4b44$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $ff5a74ae866d4b44$export$d4602ba55673f53c({
            args: args ? args : $ff5a74ae866d4b44$export$e2a18bb771d8e6a3.create([]).rest($ff5a74ae866d4b44$export$ef3b1bb1630977ae.create()),
            returns: returns || $ff5a74ae866d4b44$export$ef3b1bb1630977ae.create(),
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodFunction,
            ...$ff5a74ae866d4b44$var$processCreateParams(params)
        });
    }
}
class $ff5a74ae866d4b44$export$378d0cfce37406e6 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$ff5a74ae866d4b44$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $ff5a74ae866d4b44$export$378d0cfce37406e6({
        getter: getter,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodLazy,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$7e44096782a165d3 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $aKRBY.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, $etSSW.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$ff5a74ae866d4b44$export$7e44096782a165d3.create = (value, params)=>{
    return new $ff5a74ae866d4b44$export$7e44096782a165d3({
        value: value,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodLiteral,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
function $ff5a74ae866d4b44$var$createZodEnum(values, params) {
    return new $ff5a74ae866d4b44$export$d325d1f0e1c20179({
        values: values,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodEnum,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
}
class $ff5a74ae866d4b44$export$d325d1f0e1c20179 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $etSSW.addIssueToContext)(ctx, {
                expected: (0, $164Eb.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $aKRBY.ZodIssueCode).invalid_type
            });
            return 0, $etSSW.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $etSSW.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $aKRBY.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $ff5a74ae866d4b44$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $ff5a74ae866d4b44$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$ff5a74ae866d4b44$export$d325d1f0e1c20179.create = $ff5a74ae866d4b44$var$createZodEnum;
class $ff5a74ae866d4b44$export$370b2e8d6d6f5c56 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const nativeEnumValues = (0, $164Eb.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).string && ctx.parsedType !== (0, $164Eb.ZodParsedType).number) {
            const expectedValues = (0, $164Eb.util).objectValues(nativeEnumValues);
            (0, $etSSW.addIssueToContext)(ctx, {
                expected: (0, $164Eb.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, $aKRBY.ZodIssueCode).invalid_type
            });
            return 0, $etSSW.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, $164Eb.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, $164Eb.util).objectValues(nativeEnumValues);
            (0, $etSSW.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, $aKRBY.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, $etSSW.INVALID;
        }
        return (0, $etSSW.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$ff5a74ae866d4b44$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $ff5a74ae866d4b44$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodNativeEnum,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$3f196b0127d6e50a extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, $164Eb.ZodParsedType).promise && ctx.common.async === false) {
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        const promisified = ctx.parsedType === (0, $164Eb.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $etSSW.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$ff5a74ae866d4b44$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $ff5a74ae866d4b44$export$3f196b0127d6e50a({
        type: schema,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodPromise,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$a60af00cc0ce2582 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $ff5a74ae866d4b44$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $etSSW.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, $etSSW.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $etSSW.INVALID;
                if (result.status === "dirty") return (0, $etSSW.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $etSSW.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, $etSSW.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, $etSSW.INVALID;
                if (result.status === "dirty") return (0, $etSSW.DIRTY)(result.value);
                if (status.value === "dirty") return (0, $etSSW.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, $etSSW.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, $etSSW.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $etSSW.isValid)(base)) return 0, $etSSW.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $etSSW.isValid)(base)) return 0, $etSSW.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, $164Eb.util).assertNever(effect);
    }
}
$ff5a74ae866d4b44$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $ff5a74ae866d4b44$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
$ff5a74ae866d4b44$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $ff5a74ae866d4b44$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodEffects,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$aa56fec1e9d629b8 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $164Eb.ZodParsedType).undefined) return (0, $etSSW.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$ff5a74ae866d4b44$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $ff5a74ae866d4b44$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodOptional,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$aaac0b8b429cef5 extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, $164Eb.ZodParsedType).null) return (0, $etSSW.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$ff5a74ae866d4b44$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $ff5a74ae866d4b44$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodNullable,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$bb19b37874861e7e extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, $164Eb.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$ff5a74ae866d4b44$export$bb19b37874861e7e.create = (type, params)=>{
    return new $ff5a74ae866d4b44$export$bb19b37874861e7e({
        innerType: type,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$75a44ec6249ac76b extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $etSSW.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, $aKRBY.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, $aKRBY.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$ff5a74ae866d4b44$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $ff5a74ae866d4b44$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
class $ff5a74ae866d4b44$export$26ccfa0145e8511f extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, $164Eb.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $etSSW.addIssueToContext)(ctx, {
                code: (0, $aKRBY.ZodIssueCode).invalid_type,
                expected: (0, $164Eb.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, $etSSW.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$ff5a74ae866d4b44$export$26ccfa0145e8511f.create = (params)=>{
    return new $ff5a74ae866d4b44$export$26ccfa0145e8511f({
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodNaN,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
const $ff5a74ae866d4b44$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $ff5a74ae866d4b44$export$66b0c798a395271f extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $ff5a74ae866d4b44$export$a3c3ef8a0e95c6da extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, $etSSW.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $etSSW.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, $etSSW.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $ff5a74ae866d4b44$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $ff5a74ae866d4b44$export$5d1f7ef05c4e493a extends $ff5a74ae866d4b44$export$2afb8ab49d4b92c0 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, $etSSW.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, $etSSW.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$ff5a74ae866d4b44$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $ff5a74ae866d4b44$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $ff5a74ae866d4b44$export$558106ce543bd011.ZodReadonly,
        ...$ff5a74ae866d4b44$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $ff5a74ae866d4b44$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $ff5a74ae866d4b44$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $ff5a74ae866d4b44$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = $ff5a74ae866d4b44$var$cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $ff5a74ae866d4b44$var$cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $ff5a74ae866d4b44$export$b9d1edb536b4e4eb.create();
}
const $ff5a74ae866d4b44$export$1ee8ee30835eab8b = {
    object: $ff5a74ae866d4b44$export$736315c5b55efbad.lazycreate
};
var $ff5a74ae866d4b44$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($ff5a74ae866d4b44$export$558106ce543bd011 || ($ff5a74ae866d4b44$export$558106ce543bd011 = {}));
// requires TS 4.4+
class $ff5a74ae866d4b44$var$Class {
    constructor(..._){}
}
const $ff5a74ae866d4b44$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$ff5a74ae866d4b44$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $ff5a74ae866d4b44$export$22b082955e083ec3 = $ff5a74ae866d4b44$export$1230eb29b8d3b502.create;
const $ff5a74ae866d4b44$export$98e628dec113755e = $ff5a74ae866d4b44$export$5b070a55c0c43e09.create;
const $ff5a74ae866d4b44$export$9e06de0973666692 = $ff5a74ae866d4b44$export$26ccfa0145e8511f.create;
const $ff5a74ae866d4b44$export$a0f65b52274bcc00 = $ff5a74ae866d4b44$export$67d741fd70ff98f4.create;
const $ff5a74ae866d4b44$export$4a21f16c33752377 = $ff5a74ae866d4b44$export$723d146f80596191.create;
const $ff5a74ae866d4b44$export$324d90190a8b822a = $ff5a74ae866d4b44$export$e974be33bdc55521.create;
const $ff5a74ae866d4b44$export$8f701197936bc2a6 = $ff5a74ae866d4b44$export$bcc3b40f6b638044.create;
const $ff5a74ae866d4b44$export$1db45310990710a5 = $ff5a74ae866d4b44$export$4e780e961c30340d.create;
const $ff5a74ae866d4b44$export$7b1b591b262c240 = $ff5a74ae866d4b44$export$a96281f914484f2d.create;
const $ff5a74ae866d4b44$export$4154a199d7d90455 = $ff5a74ae866d4b44$export$b9d1edb536b4e4eb.create;
const $ff5a74ae866d4b44$export$19282c40b967aec6 = $ff5a74ae866d4b44$export$ef3b1bb1630977ae.create;
const $ff5a74ae866d4b44$export$b3e22bcfd64c1022 = $ff5a74ae866d4b44$export$1e576a20c3ce9fb5.create;
const $ff5a74ae866d4b44$export$490e536ee7389aeb = $ff5a74ae866d4b44$export$7d39f5df85f21031.create;
const $ff5a74ae866d4b44$export$2f23118c22fb2630 = $ff5a74ae866d4b44$export$7acfc3e64785411.create;
const $ff5a74ae866d4b44$export$be5493f9613cbbe = $ff5a74ae866d4b44$export$736315c5b55efbad.create;
const $ff5a74ae866d4b44$export$8fb0df5f40d0b477 = $ff5a74ae866d4b44$export$736315c5b55efbad.strictCreate;
const $ff5a74ae866d4b44$export$971dd5b0dfd021b6 = $ff5a74ae866d4b44$export$a8b236cb5070a311.create;
const $ff5a74ae866d4b44$export$4b888e40c4ee26dd = $ff5a74ae866d4b44$export$5ef2424805ac76a3.create;
const $ff5a74ae866d4b44$export$bc86dfbf7795668c = $ff5a74ae866d4b44$export$c02deaf0bb5203d4.create;
const $ff5a74ae866d4b44$export$65e3907585753458 = $ff5a74ae866d4b44$export$e2a18bb771d8e6a3.create;
const $ff5a74ae866d4b44$export$e5185e241753e543 = $ff5a74ae866d4b44$export$a2acc09968cb4b7f.create;
const $ff5a74ae866d4b44$export$871de8747c9eaa88 = $ff5a74ae866d4b44$export$163b6a2b712d9542.create;
const $ff5a74ae866d4b44$export$adaa4cf7ef1b65be = $ff5a74ae866d4b44$export$977057706f816712.create;
const $ff5a74ae866d4b44$export$44e51c8aac7c2deb = $ff5a74ae866d4b44$export$d4602ba55673f53c.create;
const $ff5a74ae866d4b44$export$488013bae63b21da = $ff5a74ae866d4b44$export$378d0cfce37406e6.create;
const $ff5a74ae866d4b44$export$c8ec6e1ec9fefcb0 = $ff5a74ae866d4b44$export$7e44096782a165d3.create;
const $ff5a74ae866d4b44$export$78a99c8d44d72635 = $ff5a74ae866d4b44$export$d325d1f0e1c20179.create;
const $ff5a74ae866d4b44$export$6fe7eca19ebe5199 = $ff5a74ae866d4b44$export$370b2e8d6d6f5c56.create;
const $ff5a74ae866d4b44$export$c957ef27a0ebfd4 = $ff5a74ae866d4b44$export$3f196b0127d6e50a.create;
const $ff5a74ae866d4b44$export$dc573d8a6576cdb3 = $ff5a74ae866d4b44$export$a60af00cc0ce2582.create;
const $ff5a74ae866d4b44$export$516e28dec6a4b6d4 = $ff5a74ae866d4b44$export$aa56fec1e9d629b8.create;
const $ff5a74ae866d4b44$export$133fc36489ac9add = $ff5a74ae866d4b44$export$aaac0b8b429cef5.create;
const $ff5a74ae866d4b44$export$fc37fe19dfda43ee = $ff5a74ae866d4b44$export$a60af00cc0ce2582.createWithPreprocess;
const $ff5a74ae866d4b44$export$43f28b24e1eb8181 = $ff5a74ae866d4b44$export$a3c3ef8a0e95c6da.create;
const $ff5a74ae866d4b44$export$3b3d07727c5b702c = ()=>$ff5a74ae866d4b44$export$22b082955e083ec3().optional();
const $ff5a74ae866d4b44$export$eb150471a61fced6 = ()=>$ff5a74ae866d4b44$export$98e628dec113755e().optional();
const $ff5a74ae866d4b44$export$269251733cdcbbf1 = ()=>$ff5a74ae866d4b44$export$4a21f16c33752377().optional();
const $ff5a74ae866d4b44$export$8c14e57e778d3873 = {
    string: (arg)=>$ff5a74ae866d4b44$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$ff5a74ae866d4b44$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$ff5a74ae866d4b44$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$ff5a74ae866d4b44$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$ff5a74ae866d4b44$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $ff5a74ae866d4b44$export$96c94437c95d7862 = (0, $etSSW.INVALID);

});
parcelRegister("aKRBY", function(module, exports) {

$parcel$export(module.exports, "ZodIssueCode", () => $7d47c960e12b6133$export$5ba560653e4a1035);
$parcel$export(module.exports, "ZodError", () => $7d47c960e12b6133$export$f98dac4b251ab333);

var $164Eb = parcelRequire("164Eb");
const $7d47c960e12b6133$export$5ba560653e4a1035 = (0, $164Eb.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $7d47c960e12b6133$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $7d47c960e12b6133$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $7d47c960e12b6133$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, $164Eb.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$7d47c960e12b6133$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $7d47c960e12b6133$export$f98dac4b251ab333(issues);
    return error;
};

});
parcelRegister("164Eb", function(module, exports) {

$parcel$export(module.exports, "util", () => $0cc9f4cd798a56b9$export$7debb50ef11d5e0b);
$parcel$export(module.exports, "ZodParsedType", () => $0cc9f4cd798a56b9$export$5716da67bfaa244d);
$parcel$export(module.exports, "getParsedType", () => $0cc9f4cd798a56b9$export$3e9057828ebd5c7a);
var $0cc9f4cd798a56b9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($0cc9f4cd798a56b9$export$7debb50ef11d5e0b || ($0cc9f4cd798a56b9$export$7debb50ef11d5e0b = {}));
var $0cc9f4cd798a56b9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($0cc9f4cd798a56b9$export$4aa2142c225fd5c7 || ($0cc9f4cd798a56b9$export$4aa2142c225fd5c7 = {}));
const $0cc9f4cd798a56b9$export$5716da67bfaa244d = $0cc9f4cd798a56b9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $0cc9f4cd798a56b9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.undefined;
        case "string":
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.string;
        case "number":
            return Number.isNaN(data) ? $0cc9f4cd798a56b9$export$5716da67bfaa244d.nan : $0cc9f4cd798a56b9$export$5716da67bfaa244d.number;
        case "boolean":
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.boolean;
        case "function":
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.function;
        case "bigint":
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $0cc9f4cd798a56b9$export$5716da67bfaa244d.array;
            if (data === null) return $0cc9f4cd798a56b9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $0cc9f4cd798a56b9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $0cc9f4cd798a56b9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $0cc9f4cd798a56b9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $0cc9f4cd798a56b9$export$5716da67bfaa244d.date;
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.object;
        default:
            return $0cc9f4cd798a56b9$export$5716da67bfaa244d.unknown;
    }
};

});


parcelRegister("kRHPG", function(module, exports) {

$parcel$export(module.exports, "getErrorMap", () => $f30ac219dc51df06$export$32f27c719778d4c4);
$parcel$export(module.exports, "defaultErrorMap", () => (parcelRequire("bvdlG")).default);

var $bvdlG = parcelRequire("bvdlG");
let $f30ac219dc51df06$var$overrideErrorMap = (0, $bvdlG.default);
function $f30ac219dc51df06$export$1097a8289cfd22d7(map) {
    $f30ac219dc51df06$var$overrideErrorMap = map;
}
function $f30ac219dc51df06$export$32f27c719778d4c4() {
    return $f30ac219dc51df06$var$overrideErrorMap;
}

});
parcelRegister("bvdlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fcf1bc36370843$export$2e2bcd8739ae039);

var $aKRBY = parcelRequire("aKRBY");

var $164Eb = parcelRequire("164Eb");
const $85fcf1bc36370843$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, $aKRBY.ZodIssueCode).invalid_type:
            if (issue.received === (0, $164Eb.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, $164Eb.util).jsonStringifyReplacer)}`;
            break;
        case (0, $aKRBY.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, $164Eb.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, $164Eb.util).joinValues(issue.options)}`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, $164Eb.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, $164Eb.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, $aKRBY.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, $aKRBY.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, $aKRBY.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, $aKRBY.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, $aKRBY.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, $aKRBY.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, $164Eb.util).assertNever(issue);
    }
    return {
        message: message
    };
};
var $85fcf1bc36370843$export$2e2bcd8739ae039 = $85fcf1bc36370843$var$errorMap;

});


parcelRegister("jW7TA", function(module, exports) {

$parcel$export(module.exports, "errorUtil", () => $e8398f01f101ae55$export$b9faa7f0c32cb80d);
var $e8398f01f101ae55$export$b9faa7f0c32cb80d;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})($e8398f01f101ae55$export$b9faa7f0c32cb80d || ($e8398f01f101ae55$export$b9faa7f0c32cb80d = {}));

});

parcelRegister("etSSW", function(module, exports) {

$parcel$export(module.exports, "makeIssue", () => $a8ae592f16f835d5$export$244a85fde9c419ed);
$parcel$export(module.exports, "addIssueToContext", () => $a8ae592f16f835d5$export$db7caee60e5d514d);
$parcel$export(module.exports, "ParseStatus", () => $a8ae592f16f835d5$export$5b20a5c3d05c1f6f);
$parcel$export(module.exports, "INVALID", () => $a8ae592f16f835d5$export$9a105a556e65c2c0);
$parcel$export(module.exports, "DIRTY", () => $a8ae592f16f835d5$export$325a211da9693fcf);
$parcel$export(module.exports, "OK", () => $a8ae592f16f835d5$export$c6813a8d51f77eaf);
$parcel$export(module.exports, "isAborted", () => $a8ae592f16f835d5$export$afa861e3c5730743);
$parcel$export(module.exports, "isDirty", () => $a8ae592f16f835d5$export$910b6cdd390341b3);
$parcel$export(module.exports, "isValid", () => $a8ae592f16f835d5$export$1ea939691cdc45b8);
$parcel$export(module.exports, "isAsync", () => $a8ae592f16f835d5$export$aefee5ebe1dcfd9e);

var $kRHPG = parcelRequire("kRHPG");

var $bvdlG = parcelRequire("bvdlG");
const $a8ae592f16f835d5$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $a8ae592f16f835d5$export$1526d2e05f74572 = [];
function $a8ae592f16f835d5$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = (0, $kRHPG.getErrorMap)();
    const issue = $a8ae592f16f835d5$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, $bvdlG.default) ? undefined : (0, $bvdlG.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $a8ae592f16f835d5$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $a8ae592f16f835d5$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $a8ae592f16f835d5$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $a8ae592f16f835d5$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $a8ae592f16f835d5$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $a8ae592f16f835d5$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $a8ae592f16f835d5$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $a8ae592f16f835d5$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $a8ae592f16f835d5$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $a8ae592f16f835d5$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $a8ae592f16f835d5$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $a8ae592f16f835d5$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

});



parcelRegister("i13h4", function(module, exports) {

$parcel$export(module.exports, "RightPanel", () => $b9126b9e7ccfc35f$export$364a989a35814102);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("bRT7J");
var $jGT7M = parcelRequire("jGT7M");

var $bgcVc = parcelRequire("bgcVc");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");
var $79HTA = parcelRequire("79HTA");

var $iYbB4 = parcelRequire("iYbB4");
var $1Dqsr = parcelRequire("1Dqsr");
var $8W2W9 = parcelRequire("8W2W9");
var $aFsfQ = parcelRequire("aFsfQ");
var $4VbfW = parcelRequire("4VbfW");

var $2NacA = parcelRequire("2NacA");

var $4Oriw = parcelRequire("4Oriw");

var $bUuUi = parcelRequire("bUuUi");

var $bsXim = parcelRequire("bsXim");

var $hFSwv = parcelRequire("hFSwv");

var $i8nzl = parcelRequire("i8nzl");

var $2JoMm = parcelRequire("2JoMm");

var $bTLvM = parcelRequire("bTLvM");
const $b9126b9e7ccfc35f$export$364a989a35814102 = ({ right: right, onEdit: onEdit, selected: selected, setSelected: setSelected, expanded: expanded = false })=>{
    /** State **/ const [isExpanded, setIsExpanded] = (0, $2NacA.useState)(expanded);
    /** Computed **/ const termFromDate = (0, $2NacA.useMemo)(()=>(0, $bgcVc.formatDateOnly)(right.termFromDate), [
        right
    ]);
    const termToDate = (0, $2NacA.useMemo)(()=>right.termToDate ? (0, $bgcVc.formatDateOnly)(right.termToDate) : 'Ongoing', [
        right
    ]);
    /** Render **/ const Term = ()=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            pad: "xsmall",
            gap: "small",
            align: "end",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    height: "1rem",
                    justify: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
                        content: "Term Dates",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iYbB4.Calendar), {
                            size: "1rem"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    height: "1rem",
                    justify: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "1rem",
                        weight: 400,
                        children: `${termFromDate} - ${termToDate}`
                    })
                })
            ]
        });
    const MediaTypes = ()=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            pad: "xsmall",
            gap: "small",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
                    content: "Media Types",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aFsfQ.Multimedia), {
                        size: "1rem"
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    truncate: true,
                    size: "1rem",
                    weight: 400,
                    children: right.media
                })
            ]
        });
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        round: (0, $4Oriw.borderRadiusSize),
        background: "light-2",
        elevation: "xsmall",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                align: "center",
                gap: "medium",
                pad: {
                    vertical: 'small',
                    horizontal: 'medium'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                            checked: selected,
                            onChange: ()=>{
                                setSelected(right.id ?? '', !selected);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "medium",
                        onClick: ()=>setIsExpanded(!isExpanded),
                        flex: "grow",
                        align: "center",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                icon: isExpanded ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4VbfW.Up), {
                                    size: "24px"
                                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Dqsr.Down), {
                                    size: "24px"
                                }),
                                onClick: ()=>setIsExpanded(!isExpanded),
                                plain: true,
                                size: "32px",
                                tip: isExpanded ? 'Collapse details' : 'Expand details'
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                gap: "xxsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        weight: "bold",
                                        size: "medium",
                                        children: right.description
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {}),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        children: right.rightType
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                align: "center",
                                justify: "around",
                                gap: "medium",
                                wrap: true,
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)(Term, {}),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)(MediaTypes, {}),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2JoMm.RightStatusDisplay), {
                                        right: right
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "medium",
                        justify: "end",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "22px",
                                children: right.document && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bUuUi.DocumentLink), {
                                    size: "22px",
                                    doc: right.document
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8W2W9.Edit), {
                                    size: "22px"
                                }),
                                tip: {
                                    content: 'Edit Right',
                                    dropProps: (0, $4Oriw.tooltipProps),
                                    plain: true
                                },
                                onClick: ()=>onEdit(right),
                                plain: true,
                                hoverIndicator: true
                            })
                        ]
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                pad: {
                    horizontal: 'small',
                    top: 'xsmall',
                    bottom: 'small'
                },
                round: {
                    corner: 'bottom',
                    size: (0, $4Oriw.borderRadiusSize)
                },
                justify: "between",
                gap: "small",
                fill: "horizontal",
                background: "light-2",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hFSwv.BasicInformation), {
                        right: right
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bTLvM.TermInformation), {
                        right: right
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $i8nzl.ContactInformation), {
                        right: right
                    }),
                    (right.restrictionsOnUse || right.notes) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bsXim.AdditionalInformation), {
                        restrictionsOnUse: right.restrictionsOnUse,
                        notes: right.notes
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("iYbB4", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $dcf6d37fdcd07c61$export$e1aef45b828286de);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $dcf6d37fdcd07c61$var$_extends() {
    return $dcf6d37fdcd07c61$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dcf6d37fdcd07c61$var$_extends.apply(null, arguments);
}
var $dcf6d37fdcd07c61$export$e1aef45b828286de = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $dcf6d37fdcd07c61$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calendar"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 5h20v17H2V5zm16 0V1M6 5V1m-4 9h20"
    }));
});
$dcf6d37fdcd07c61$export$e1aef45b828286de.displayName = 'Calendar';

});

parcelRegister("8W2W9", function(module, exports) {

$parcel$export(module.exports, "Edit", () => $681604bebc819b5d$export$6ed0965c9443aaa6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $681604bebc819b5d$var$_extends() {
    return $681604bebc819b5d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $681604bebc819b5d$var$_extends.apply(null, arguments);
}
var $681604bebc819b5d$export$6ed0965c9443aaa6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $681604bebc819b5d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Edit"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m14 4 6 6-6-6zm8.294 1.294c.39.39.387 1.025-.008 1.42L9 20l-7 2 2-7L17.286 1.714a1 1 0 0 1 1.42-.008l3.588 3.588zM3 19l2 2m2-4 8-8"
    }));
});
$681604bebc819b5d$export$6ed0965c9443aaa6.displayName = 'Edit';

});

parcelRegister("4VbfW", function(module, exports) {

$parcel$export(module.exports, "Up", () => $3955378653824142$export$523db0166afee5e8);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");

var $6dmSR = parcelRequire("6dmSR");
function $3955378653824142$var$_extends() {
    return $3955378653824142$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3955378653824142$var$_extends.apply(null, arguments);
}
var $3955378653824142$export$523db0166afee5e8 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var scaleProps = (0, $6dmSR.useScaleProps)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $3955378653824142$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Up"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $3955378653824142$var$_extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 15.999 10.173-9.824 9.824 10.173"
    }, scaleProps)));
});
$3955378653824142$export$523db0166afee5e8.displayName = 'Up';

});

parcelRegister("2JoMm", function(module, exports) {

$parcel$export(module.exports, "RightStatusDisplay", () => $40596e5426ca19ac$export$6e812a7aa2dc6259);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
var $79HTA = parcelRequire("79HTA");

var $bqfBA = parcelRequire("bqfBA");
var $eLmdC = parcelRequire("eLmdC");
var $5a3jD = parcelRequire("5a3jD");
parcelRequire("hcQWc");
var $cVyZf = parcelRequire("cVyZf");

var $9Rhqc = parcelRequire("9Rhqc");

var $1G16z = parcelRequire("1G16z");
const $40596e5426ca19ac$export$6e812a7aa2dc6259 = ({ right: right, textProps: textProps, ...props })=>{
    const statusColor = (0, $1G16z.getRightStatusColor)(right.status);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        ...props,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
            content: `Status: ${(0, $9Rhqc.capitalize)(right.status)}`,
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                align: "center",
                gap: "xsmall",
                children: [
                    right.status === (0, $cVyZf.RightStatus).ACTIVE && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eLmdC.StatusGood), {
                        size: "1rem",
                        color: statusColor
                    }),
                    right.status === (0, $cVyZf.RightStatus).EXPIRED && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5a3jD.StatusWarning), {
                        size: "1rem",
                        color: statusColor
                    }),
                    right.status === (0, $cVyZf.RightStatus).RELEASED && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bqfBA.Logout), {
                        size: "1rem",
                        color: statusColor
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        truncate: true,
                        color: statusColor,
                        weight: 500,
                        size: "small",
                        ...textProps,
                        children: right.status?.toLocaleUpperCase()
                    })
                ]
            })
        })
    });
};

});
parcelRegister("bqfBA", function(module, exports) {

$parcel$export(module.exports, "Logout", () => $850e3a4eb4d88ba4$export$cad1a703886b4e3a);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $850e3a4eb4d88ba4$var$_extends() {
    return $850e3a4eb4d88ba4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $850e3a4eb4d88ba4$var$_extends.apply(null, arguments);
}
var $850e3a4eb4d88ba4$export$cad1a703886b4e3a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $850e3a4eb4d88ba4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Logout"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "M13 9V2H1v20h12v-7m9-3H5m12-5 5 5-5 5"
    }));
});
$850e3a4eb4d88ba4$export$cad1a703886b4e3a.displayName = 'Logout';

});


parcelRegister("bTLvM", function(module, exports) {

$parcel$export(module.exports, "TermInformation", () => $c69dd3ea25d0f674$export$91ffb8c22760ff57);

var $6ir3O = parcelRequire("6ir3O");

var $4cofJ = parcelRequire("4cofJ");

var $9blr6 = parcelRequire("9blr6");

var $67bjB = parcelRequire("67bjB");
const $c69dd3ea25d0f674$export$91ffb8c22760ff57 = ({ background: background, right: right })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4cofJ.RightInfoCard), {
        title: "Term Information",
        background: background,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $67bjB.RightInfoRow), {
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Term From",
                    value: right.termFromDate || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Term To",
                    value: right.termToDate || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Media",
                    value: right.media || 'Not specified'
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9blr6.RightInfoItem), {
                    title: "Territories",
                    value: right.territories || 'Not specified'
                })
            ]
        })
    });
};

});



parcelRegister("kVJjK", function(module, exports) {
$parcel$export(module.exports, "NotificationsMenu", () => (parcelRequire("aPSJv")).NotificationsMenu);
$parcel$export(module.exports, "NotificationsTable", () => (parcelRequire("lbkqm")).NotificationsTable);
$parcel$export(module.exports, "WebSocketStatus", () => (parcelRequire("3AWy1")).WebSocketStatus);
parcelRequire("9D12e");
parcelRequire("aPSJv");
parcelRequire("lbkqm");
parcelRequire("3AWy1");

});
parcelRegister("9D12e", function(module, exports) {

$parcel$export(module.exports, "NotificationIcon", () => $1fd5cbc4b249874c$export$8503ce930eaa5c44);

var $6ir3O = parcelRequire("6ir3O");

var $jkpXg = parcelRequire("jkpXg");
var $cNZ2u = parcelRequire("cNZ2u");
var $iYbB4 = parcelRequire("iYbB4");
var $1FJpI = parcelRequire("1FJpI");
var $cVvES = parcelRequire("cVvES");
var $ccJTu = parcelRequire("ccJTu");
var $cYfAm = parcelRequire("cYfAm");
var $76Aak = parcelRequire("76Aak");
var $6MQRh = parcelRequire("6MQRh");
var $cypeJ = parcelRequire("cypeJ");
var $cD96B = parcelRequire("cD96B");
var $7O2Qo = parcelRequire("7O2Qo");
var $gyf5K = parcelRequire("gyf5K");
var $jK3Kk = parcelRequire("jK3Kk");
var $8W2W9 = parcelRequire("8W2W9");
var $fnXSK = parcelRequire("fnXSK");
var $3WslH = parcelRequire("3WslH");
var $fuAqB = parcelRequire("fuAqB");
var $1jasL = parcelRequire("1jasL");
var $kCm6P = parcelRequire("kCm6P");
var $lBOUq = parcelRequire("lBOUq");
var $dmh5A = parcelRequire("dmh5A");
var $2xT0V = parcelRequire("2xT0V");
var $bhoi7 = parcelRequire("bhoi7");
var $eNYAE = parcelRequire("eNYAE");
const $1fd5cbc4b249874c$export$8503ce930eaa5c44 = ({ notification: notification })=>{
    const { source_entity_name: source_entity_name = '' } = notification;
    const iconMap = {
        Advertiser: /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {}),
        Allowance: /*#__PURE__*/ (0, $6ir3O.jsx)($fuAqB.Money, {}),
        ChatMessage: /*#__PURE__*/ (0, $6ir3O.jsx)($cVvES.Chat, {}),
        Commercial: /*#__PURE__*/ (0, $6ir3O.jsx)($bhoi7.Video, {}),
        Conversation: /*#__PURE__*/ (0, $6ir3O.jsx)($ccJTu.ChatOption, {}),
        Costume: /*#__PURE__*/ (0, $6ir3O.jsx)($2xT0V.UserPolice, {}),
        Document: /*#__PURE__*/ (0, $6ir3O.jsx)($gyf5K.DocumentText, {}),
        DocumentEmbedding: /*#__PURE__*/ (0, $6ir3O.jsx)($7O2Qo.DocumentConfig, {}),
        Edit: /*#__PURE__*/ (0, $6ir3O.jsx)($8W2W9.Edit, {}),
        EditReview: /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {}),
        Estimate: /*#__PURE__*/ (0, $6ir3O.jsx)($lBOUq.Table, {}),
        Feature: /*#__PURE__*/ (0, $6ir3O.jsx)($jkpXg.Actions, {}),
        Fee: /*#__PURE__*/ (0, $6ir3O.jsx)($fuAqB.Money, {}),
        Group: /*#__PURE__*/ (0, $6ir3O.jsx)($fnXSK.Group, {}),
        Location: /*#__PURE__*/ (0, $6ir3O.jsx)($3WslH.MapLocation, {}),
        Performer: /*#__PURE__*/ (0, $6ir3O.jsx)($1jasL.Run, {}),
        PerformerContract: /*#__PURE__*/ (0, $6ir3O.jsx)($6MQRh.Contract, {}),
        PricingTier: /*#__PURE__*/ (0, $6ir3O.jsx)($cD96B.Currency, {}),
        Project: /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {}),
        Prop: /*#__PURE__*/ (0, $6ir3O.jsx)($cNZ2u.Bike, {}),
        Right: /*#__PURE__*/ (0, $6ir3O.jsx)($1FJpI.Certificate, {}),
        Role: /*#__PURE__*/ (0, $6ir3O.jsx)($dmh5A.User, {}),
        RoleActivity: /*#__PURE__*/ (0, $6ir3O.jsx)($dmh5A.User, {}),
        RoleGroup: /*#__PURE__*/ (0, $6ir3O.jsx)($fnXSK.Group, {}),
        Script: /*#__PURE__*/ (0, $6ir3O.jsx)($kCm6P.Script, {}),
        Session: /*#__PURE__*/ (0, $6ir3O.jsx)($iYbB4.Calendar, {}),
        SessionActivity: /*#__PURE__*/ (0, $6ir3O.jsx)($eNYAE.Yoga, {}),
        SessionEstimate: /*#__PURE__*/ (0, $6ir3O.jsx)($lBOUq.Table, {}),
        SessionEstimateItem: /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {}),
        SubscriptionPlan: /*#__PURE__*/ (0, $6ir3O.jsx)($cypeJ.CreditCard, {}),
        Tags: /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {}),
        TimeLog: /*#__PURE__*/ (0, $6ir3O.jsx)($76Aak.Clock, {}),
        Usage: /*#__PURE__*/ (0, $6ir3O.jsx)($jK3Kk.DocumentVideo, {}),
        UsageEstimate: /*#__PURE__*/ (0, $6ir3O.jsx)($lBOUq.Table, {}),
        UsageEstimateItem: /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {}),
        User: /*#__PURE__*/ (0, $6ir3O.jsx)($dmh5A.User, {})
    };
    return iconMap[source_entity_name] ?? /*#__PURE__*/ (0, $6ir3O.jsx)($cYfAm.CircleInformation, {});
};

});
parcelRegister("jkpXg", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $e12404ad32ad540c$export$b52183d5cfb26dc9);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $e12404ad32ad540c$var$_extends() {
    return $e12404ad32ad540c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e12404ad32ad540c$var$_extends.apply(null, arguments);
}
var $e12404ad32ad540c$export$b52183d5cfb26dc9 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $e12404ad32ad540c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Actions"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0-11V1m0 22v-5.5M1 12h5.5m11 0H23M4.437 4.437l4.125 4.125m6.876 6.876 4.124 4.124m0-15.125-4.125 4.125m-6.874 6.876-4.126 4.124"
    }));
});
$e12404ad32ad540c$export$b52183d5cfb26dc9.displayName = 'Actions';

});

parcelRegister("cNZ2u", function(module, exports) {

$parcel$export(module.exports, "Bike", () => $952968beaf3f1dff$export$ce3f2c13b1523463);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $952968beaf3f1dff$var$_extends() {
    return $952968beaf3f1dff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $952968beaf3f1dff$var$_extends.apply(null, arguments);
}
var $952968beaf3f1dff$export$ce3f2c13b1523463 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $952968beaf3f1dff$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Bike"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm14 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 6h5m9 9L16 5h-3M9 9l-4 6h7c0-3 2-6 5-6H9zm0 0L7 6"
    }));
});
$952968beaf3f1dff$export$ce3f2c13b1523463.displayName = 'Bike';

});

parcelRegister("ccJTu", function(module, exports) {

$parcel$export(module.exports, "ChatOption", () => $8e2a34a31a440760$export$7111acc32417a856);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $8e2a34a31a440760$var$_extends() {
    return $8e2a34a31a440760$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e2a34a31a440760$var$_extends.apply(null, arguments);
}
var $8e2a34a31a440760$export$7111acc32417a856 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $8e2a34a31a440760$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ChatOption"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 7V1h14v10h-3v5l-5-4M1 7h14v11H9l-5 4v-4H1V7z"
    }));
});
$8e2a34a31a440760$export$7111acc32417a856.displayName = 'ChatOption';

});

parcelRegister("76Aak", function(module, exports) {

$parcel$export(module.exports, "Clock", () => $52c525b045ce1031$export$9735c82c4bae3302);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $52c525b045ce1031$var$_extends() {
    return $52c525b045ce1031$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $52c525b045ce1031$var$_extends.apply(null, arguments);
}
var $52c525b045ce1031$export$9735c82c4bae3302 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $52c525b045ce1031$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Clock"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#000",
        d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .4.8l4 3a1 1 0 0 0 1.2-1.6L13 11.5V7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z",
        clipRule: "evenodd"
    }));
});
$52c525b045ce1031$export$9735c82c4bae3302.displayName = 'Clock';

});

parcelRegister("6MQRh", function(module, exports) {

$parcel$export(module.exports, "Contract", () => $4f103a5825b34b6c$export$8517d80acf00e19a);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $4f103a5825b34b6c$var$_extends() {
    return $4f103a5825b34b6c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4f103a5825b34b6c$var$_extends.apply(null, arguments);
}
var $4f103a5825b34b6c$export$8517d80acf00e19a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $4f103a5825b34b6c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Contract"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 14h8v8m-9 1 9-9M23 1l-9 9m8 0h-8V2"
    }));
});
$4f103a5825b34b6c$export$8517d80acf00e19a.displayName = 'Contract';

});

parcelRegister("cypeJ", function(module, exports) {

$parcel$export(module.exports, "CreditCard", () => $923c3c7b7c8be1d4$export$769b6865db9774d4);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $923c3c7b7c8be1d4$var$_extends() {
    return $923c3c7b7c8be1d4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $923c3c7b7c8be1d4$var$_extends.apply(null, arguments);
}
var $923c3c7b7c8be1d4$export$769b6865db9774d4 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $923c3c7b7c8be1d4$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CreditCard"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 5c0-.552.44-1 1.002-1h19.996A1 1 0 0 1 23 5v14c0 .552-.44 1-1.002 1H2.002A1 1 0 0 1 1 19V5zm0 3h22v2H1V8zm4 7h2v.5H5V15zm5 0h6v.5h-6V15z"
    }));
});
$923c3c7b7c8be1d4$export$769b6865db9774d4.displayName = 'CreditCard';

});

parcelRegister("cD96B", function(module, exports) {

$parcel$export(module.exports, "Currency", () => $932030b9d7dbd79c$export$b733e092f9f44b2c);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $932030b9d7dbd79c$var$_extends() {
    return $932030b9d7dbd79c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $932030b9d7dbd79c$var$_extends.apply(null, arguments);
}
var $932030b9d7dbd79c$export$b733e092f9f44b2c = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $932030b9d7dbd79c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Currency"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 5h22v14H1V5zm1 4a3 3 0 0 0 3-3m-3 9a3 3 0 0 1 3 3m17-9a3 3 0 0 1-3-3m3 9a3 3 0 0 0-3 3m-7-2c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4z"
    }));
});
$932030b9d7dbd79c$export$b733e092f9f44b2c.displayName = 'Currency';

});

parcelRegister("7O2Qo", function(module, exports) {

$parcel$export(module.exports, "DocumentConfig", () => $5aef68b1d7e6a2fc$export$486aa8a34aa41d70);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $5aef68b1d7e6a2fc$var$_extends() {
    return $5aef68b1d7e6a2fc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5aef68b1d7e6a2fc$var$_extends.apply(null, arguments);
}
var $5aef68b1d7e6a2fc$export$486aa8a34aa41d70 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $5aef68b1d7e6a2fc$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "DocumentConfig"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4.998 9V1H19.5L23 4.5V23h-7m2-22v5h5M9 14v-3m0 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 3v-3m3-3h3M3 17h3m-1-4 2 2m4 4 2 2m0-8-2 2m-4 4-2 2"
    }));
});
$5aef68b1d7e6a2fc$export$486aa8a34aa41d70.displayName = 'DocumentConfig';

});

parcelRegister("fnXSK", function(module, exports) {

$parcel$export(module.exports, "Group", () => $b3377452deed82d0$export$eb2fcfdbd7ba97d4);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $b3377452deed82d0$var$_extends() {
    return $b3377452deed82d0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b3377452deed82d0$var$_extends.apply(null, arguments);
}
var $b3377452deed82d0$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $b3377452deed82d0$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Group"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-6 9v-3a6 6 0 1 1 12 0v3M13 5c.404-1.664 2.015-3 4-3 2.172 0 3.98 1.79 4 4-.02 2.21-1.828 4-4 4h-1 1c3.288 0 6 2.686 6 6v2M11 5c-.404-1.664-2.015-3-4-3-2.172 0-3.98 1.79-4 4 .02 2.21 1.828 4 4 4h1-1c-3.288 0-6 2.686-6 6v2"
    }));
});
$b3377452deed82d0$export$eb2fcfdbd7ba97d4.displayName = 'Group';

});

parcelRegister("3WslH", function(module, exports) {

$parcel$export(module.exports, "MapLocation", () => $2decc763d9259232$export$919cd7230f55bee7);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $2decc763d9259232$var$_extends() {
    return $2decc763d9259232$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2decc763d9259232$var$_extends.apply(null, arguments);
}
var $2decc763d9259232$export$919cd7230f55bee7 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $2decc763d9259232$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "MapLocation"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17.5 6.5 23 9v13l-7-3-8 3-7-3V6l5 2m10 11v-7M8 22V12m4 4.273S6 11.5 6 7c0-3.75 3-6 6-6s6 2.25 6 6c0 4.5-6 9.273-6 9.273zM13 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0z"
    }));
});
$2decc763d9259232$export$919cd7230f55bee7.displayName = 'MapLocation';

});

parcelRegister("fuAqB", function(module, exports) {

$parcel$export(module.exports, "Money", () => $b475ea3bc3d005da$export$d26bcf891bc220f6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $b475ea3bc3d005da$var$_extends() {
    return $b475ea3bc3d005da$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b475ea3bc3d005da$var$_extends.apply(null, arguments);
}
var $b475ea3bc3d005da$export$d26bcf891bc220f6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $b475ea3bc3d005da$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Money"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 16c0-1.105-3.134-2-7-2s-7 .895-7 2 3.134 2 7 2 7-.895 7-2zM2 16v4.937C2 22.077 5.134 23 9 23s7-.924 7-2.063V16M9 5c-4.418 0-8 .895-8 2s3.582 2 8 2M1 7v5c0 1.013 3.582 2 8 2M23 4c0-1.105-3.1-2-6.923-2-3.824 0-6.923.895-6.923 2s3.1 2 6.923 2S23 5.105 23 4zm-7 12c3.824 0 7-.987 7-2V4M9.154 4v10.166M9 9c0 1.013 3.253 2 7.077 2C19.9 11 23 10.013 23 9"
    }));
});
$b475ea3bc3d005da$export$d26bcf891bc220f6.displayName = 'Money';

});

parcelRegister("1jasL", function(module, exports) {

$parcel$export(module.exports, "Run", () => $0f3fae8871410821$export$ddae37e51c7979e2);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $0f3fae8871410821$var$_extends() {
    return $0f3fae8871410821$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0f3fae8871410821$var$_extends.apply(null, arguments);
}
var $0f3fae8871410821$export$ddae37e51c7979e2 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $0f3fae8871410821$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Run"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m15 11 3 2m0-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM9.5 9.5 9.525 6H15L8 17H4m11-9-3 5 .5 1L17 7.5 15 6m-4 7 5 3.5v5"
    }));
});
$0f3fae8871410821$export$ddae37e51c7979e2.displayName = 'Run';

});

parcelRegister("kCm6P", function(module, exports) {

$parcel$export(module.exports, "Script", () => $f02881aa752e2b83$export$2f8b47a141e57afc);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $f02881aa752e2b83$var$_extends() {
    return $f02881aa752e2b83$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f02881aa752e2b83$var$_extends.apply(null, arguments);
}
var $f02881aa752e2b83$export$2f8b47a141e57afc = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $f02881aa752e2b83$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Script"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 1a4 4 0 0 0-4 4v1h5.847L4.01 18.859l-.01.07V19a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-1h-5.847L19.99 5.141l.01-.07V5a4 4 0 0 0-4-4H4zm0 2a2 2 0 0 0-1.732 1h3.464A2 2 0 0 0 4 3zm3.465 0H16a2 2 0 0 1 1.999 1.936L16.133 18H10v1a2 2 0 0 1-3.999.064L7.99 5.141l.01-.07V5c0-.729-.195-1.412-.535-2zM20 21h-8.535a3.97 3.97 0 0 0 .409-1h9.858A2 2 0 0 1 20 21z",
        fill: "#000"
    }));
});
$f02881aa752e2b83$export$2f8b47a141e57afc.displayName = 'Script';

});

parcelRegister("2xT0V", function(module, exports) {

$parcel$export(module.exports, "UserPolice", () => $1da9567163894c49$export$ab40e9606b4e71d8);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $1da9567163894c49$var$_extends() {
    return $1da9567163894c49$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1da9567163894c49$var$_extends.apply(null, arguments);
}
var $1da9567163894c49$export$ab40e9606b4e71d8 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $1da9567163894c49$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserPolice"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 14c2.374 1.183 4 3.65 4 7v2H4v-2c0-3.354 1.631-5.825 4-7m4 1c3.26 0 5.903-2.686 5.903-5.999 0-.702.218-1.375 0-2.001M6.093 7c-.21.615 0 1.313 0 2.001C6.093 12.314 8.738 15 12 15M6 8h12l3-4c-1.912-1.735-5.21-3-9-3-3.836 0-7.168 1.296-9 3l3 4zm6-3a1 1 0 0 0 1-1h-2a1 1 0 0 0 1 1z"
    }));
});
$1da9567163894c49$export$ab40e9606b4e71d8.displayName = 'UserPolice';

});

parcelRegister("eNYAE", function(module, exports) {

$parcel$export(module.exports, "Yoga", () => $ac74a438ee9a0d7f$export$1e507fef8dca0624);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $ac74a438ee9a0d7f$var$_extends() {
    return $ac74a438ee9a0d7f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ac74a438ee9a0d7f$var$_extends.apply(null, arguments);
}
var $ac74a438ee9a0d7f$export$1e507fef8dca0624 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $ac74a438ee9a0d7f$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Yoga"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "m12 11-1 3 1 3h-1.5L9 14l.5-4.5L12 11zm1-9L9 6v8l1 3H6l-3 5m17.5 0-5-3.5L12 17l-1-3 1-3 3.5 2v5.5M14 8.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-3 2L10 17v-3.5l1-3z"
    }));
});
$ac74a438ee9a0d7f$export$1e507fef8dca0624.displayName = 'Yoga';

});


parcelRegister("aPSJv", function(module, exports) {

$parcel$export(module.exports, "NotificationsMenu", () => $ae48a446d41d85a9$export$b08a5e252ace2ba);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $408pd = parcelRequire("408pd");
var $1h240 = parcelRequire("1h240");
var $kS7Ii = parcelRequire("kS7Ii");

var $l5Q6D = parcelRequire("l5Q6D");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $bsB3E = parcelRequire("bsB3E");

var $1Dexz = parcelRequire("1Dexz");

var $eLUFj = parcelRequire("eLUFj");

var $8DltC = parcelRequire("8DltC");

var $9D12e = parcelRequire("9D12e");
const $ae48a446d41d85a9$export$b08a5e252ace2ba = (0, $j8yBr.observer)(()=>{
    /** Context **/ const userStore = (0, $8DltC.useUserStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const notificationStore = (0, $8DltC.useNotificationStore)();
    const chatStore = (0, $8DltC.useChatStore)();
    const navigate = (0, $19GAm.useNavigate)();
    const { lastJsonMessage: lastJsonMessage } = (0, (/*@__PURE__*/$parcel$interopDefault($1Dexz)))(`${(0, $eLUFj.env).apiWsHost}:${(0, $eLUFj.env).apiPort}`, {
        protocols: [
            'Authorization',
            userStore.token
        ],
        shouldReconnect: ()=>true,
        reconnectInterval: 3000,
        onError: console.error,
        retryOnError: true,
        share: true
    });
    /** State **/ const [isLoading, setIsLoading] = (0, $2NacA.useState)(true);
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (isLoading) notificationStore.list().finally(()=>setIsLoading(false));
    }, [
        isLoading
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (lastJsonMessage) {
            const msg = notificationStore.handleMessage(lastJsonMessage);
            if (msg) (0, $bsB3E.toast).info(msg.text);
        }
    }, [
        lastJsonMessage
    ]);
    /** Render **/ const renderMenuItem = (n)=>({
            label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                alignSelf: "center",
                direction: "row",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    truncate: true,
                    children: n.text
                })
            }),
            onClick: ()=>{
                if (!n.source_entity_name || !n.source_entity_id) return;
                if (n.source_entity_name === 'chat') {
                    chatStore.openChannel(n.source_entity_id);
                    return;
                }
                projectStore.currentProject && navigate(`/project/${(0, $9Rhqc.kebabCase)(projectStore.currentProject.name)}/${n.source_entity_name.toLocaleLowerCase()}/${n.source_entity_id}`);
            },
            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9D12e.NotificationIcon), {
                notification: n
            }),
            size: 'small',
            gap: 'small',
            fill: 'horizontal',
            justify: 'start',
            alignSelf: 'center'
        });
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        pad: "small",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $408pd.Menu), {
            tip: "Notifications",
            justifyContent: "center",
            dropAlign: {
                top: 'bottom',
                right: 'right'
            },
            icon: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1h240.Stack), {
                anchor: "top-right",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        margin: {
                            vertical: 'small',
                            horizontal: '8px'
                        },
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l5Q6D.Notification), {
                            size: "22px",
                            color: "white"
                        })
                    }),
                    notificationStore.unreadCount > 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        background: "alert",
                        pad: {
                            horizontal: 'xsmall'
                        },
                        round: true,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "small",
                            color: "white",
                            children: notificationStore.unreadCount
                        })
                    })
                ]
            }),
            items: [
                ...notificationStore.notifications.map(renderMenuItem),
                {
                    label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        fill: "horizontal",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            size: "",
                            children: "See All Notifications"
                        })
                    }),
                    onClick: ()=>navigate('/notifications')
                }
            ],
            onClick: ()=>notificationStore.markAsRead()
        })
    });
});

});
parcelRegister("408pd", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $2e9daeb6193856a5$export$d9b273488cd8ce6f);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $b5k5v = parcelRequire("b5k5v");

var $czDw5 = parcelRequire("czDw5");

var $kS7Ii = parcelRequire("kS7Ii");

var $d2fh4 = parcelRequire("d2fh4");

var $2M0UK = parcelRequire("2M0UK");

var $dWNq0 = parcelRequire("dWNq0");

var $eL6w3 = parcelRequire("eL6w3");
var $2e9daeb6193856a5$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "disabled",
    "dropAlign",
    "dropBackground",
    "dropProps",
    "dropTarget",
    "justifyContent",
    "icon",
    "items",
    "label",
    "messages",
    "onKeyDown",
    "open",
    "plain",
    "size"
], $2e9daeb6193856a5$var$_excluded2 = [
    "align"
];
function $2e9daeb6193856a5$var$_extends() {
    return $2e9daeb6193856a5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2e9daeb6193856a5$var$_extends.apply(null, arguments);
}
function $2e9daeb6193856a5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2e9daeb6193856a5$var$ContainerBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "Menu__ContainerBox",
    componentId: "sc-17fcys9-0"
})([
    "max-height:inherit;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}&:focus{outline:none;}",
    ";"
], function(props) {
    return props.theme.menu.extend;
});
/* Notes on keyboard interactivity (based on W3) // For details reference: https://www.w3.org/TR/wai-aria-practices/#menu

To open menu when menu button is focused:
- Space/Enter/Up arrow/Down arrow will open menu

To navigate within menu:
- Up/down arrow keys can be used and will loop through options
(keeping focus within the Menu)
- Tab can be used, but once the last menu item is reached, Tab will close the
Menu and continue through page content.

To close the menu:
- Tabbing beyond the first or last menu item.
- Esc will close the menu
- Select a menu item

To make a selection:
- Enter key is pressed.
- Space is pressed.
*/ var $2e9daeb6193856a5$var$defaultItems = [];
var $2e9daeb6193856a5$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var _theme$menu$disabled;
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], children = props.children, disabled = props.disabled, dropAlign = props.dropAlign, dropBackground = props.dropBackground, dropProps = props.dropProps, dropTarget = props.dropTarget, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'start' : _props$justifyContent, icon = props.icon, _props$items = props.items, items = _props$items === void 0 ? $2e9daeb6193856a5$var$defaultItems : _props$items, label = props.label, messages = props.messages, onKeyDown = props.onKeyDown, open = props.open, plain = props.plain, size = props.size, rest = $2e9daeb6193856a5$var$_objectWithoutPropertiesLoose(props, $2e9daeb6193856a5$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var iconColor = (0, $d2fh4.normalizeColor)(theme.menu.icons.color || 'control', theme);
    var iconDisabledColor = (0, $d2fh4.normalizeColor)(((_theme$menu$disabled = theme.menu.disabled) == null || (_theme$menu$disabled = _theme$menu$disabled.icons) == null ? void 0 : _theme$menu$disabled.color) || theme.menu.icons.color || 'control', theme);
    // need to destructure the align otherwise it will get passed through
    // to DropButton and override prop values
    var _theme$menu$drop = theme.menu.drop, themeDropAlign = _theme$menu$drop.align, themeDropProps = $2e9daeb6193856a5$var$_objectWithoutPropertiesLoose(_theme$menu$drop, $2e9daeb6193856a5$var$_excluded2);
    var a11y = ariaLabel || a11yTitle;
    // total number of menu items
    var itemCount = (0, $2NacA.useMemo)(function() {
        var count = 0;
        if (items && Array.isArray(items[0])) items.forEach(function(group) {
            count += group.length;
        });
        else count = items.length;
        return count;
    }, [
        items
    ]);
    var align = dropProps && dropProps.align || dropAlign || themeDropAlign;
    var controlButtonIndex = (0, $2NacA.useMemo)(function() {
        if (align.top === 'top') return -1;
        if (align.bottom === 'bottom') return itemCount;
        return undefined;
    }, [
        align,
        itemCount
    ]);
    // Keeps track of whether menu options should be mirrored
    // when there's not enough space below DropButton. This state
    // is modified on /Drop/DropContainer.js.
    var _useState = (0, $2NacA.useState)(), alignControlMirror = _useState[0], setAlignControlMirror = _useState[1];
    var initialAlignTop = alignControlMirror === align.top;
    var dropContainerRef = (0, $2NacA.useRef)();
    var buttonRefs = (0, $2NacA.useRef)([]);
    var constants = (0, $2NacA.useMemo)(function() {
        return {
            none: 'none',
            tab: 9,
            // Menu control button included on top of menu items
            controlTop: align.top === 'top' || undefined,
            // Menu control button included on the bottom of menu items
            controlBottom: align.bottom === 'bottom' || undefined,
            controlButtonIndex: controlButtonIndex
        };
    }, [
        align,
        controlButtonIndex
    ]);
    var _useState2 = (0, $2NacA.useState)(constants.none), activeItemIndex = _useState2[0], setActiveItemIndex = _useState2[1];
    var _useState3 = (0, $2NacA.useState)(open || false), isOpen = _useState3[0], setOpen = _useState3[1];
    var MenuIcon = isOpen && theme.menu.icons.up ? theme.menu.icons.up : theme.menu.icons.down;
    var onDropClose = (0, $2NacA.useCallback)(function() {
        setActiveItemIndex(constants.none);
        setOpen(false);
    }, [
        constants.none
    ]);
    var onDropOpen = (0, $2NacA.useCallback)(function() {
        setOpen(true);
    }, []);
    (0, $2NacA.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            if (isOpen) {
                var optionsNode = dropContainerRef.current;
                if (optionsNode) optionsNode.focus();
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isOpen
    ]);
    var onSelectMenuItem = function onSelectMenuItem(event) {
        if (isOpen) {
            if (activeItemIndex >= 0) {
                event.preventDefault();
                event.stopPropagation();
                buttonRefs.current[activeItemIndex].click();
            }
        } else onDropOpen();
    };
    var isTab = function isTab(event) {
        return event.keyCode === constants.tab || event.which === constants.tab;
    };
    var onNextMenuItem = function onNextMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (!constants.controlBottom && activeItemIndex === itemCount - 1 || constants.controlBottom && activeItemIndex === controlButtonIndex)) // User has reached end of the menu, this tab will close
        // the menu drop because there are no more "next items" to access
        onDropClose();
        else {
            var index;
            if (// This checks if the user has reached the end of the menu.
            // In the case the the menu control button is located at the
            // bottom of the menu, it checks if the user has reached the button.
            // Otherwise, it checks if the user is at the last menu item.
            constants.controlBottom && activeItemIndex === controlButtonIndex || !constants.controlBottom && activeItemIndex === itemCount - 1 || activeItemIndex === constants.none) // place focus on the first menu item
            index = 0;
            else index = activeItemIndex + 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var onPreviousMenuItem = function onPreviousMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (constants.controlTop && activeItemIndex === controlButtonIndex || !constants.controlTop && activeItemIndex - 1 < 0)) // User has reached beginning of the menu, this tab will close
        // the menu drop because there are no more "previous items" to access
        onDropClose();
        else {
            var index;
            if (activeItemIndex === 'none') index = itemCount - 1;
            else if (activeItemIndex - 1 < 0) {
                if (constants.controlTop && activeItemIndex - 1 === controlButtonIndex) index = itemCount;
                else index = itemCount - 1;
            } else index = activeItemIndex - 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var menuIcon = icon !== false ? icon !== true && icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(MenuIcon, {
        color: disabled ? iconDisabledColor : iconColor,
        size: size
    }) : null;
    var buttonProps = {
        plain: plain,
        size: size
    };
    var content;
    if (children) content = children;
    else if (!theme.button["default"]) /*
    Not adding a theme object now because this code path
    is not used in the HPE theme, but we may add theme
    support here in the future.
    */ content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row",
        justify: justifyContent,
        align: "center",
        pad: "small",
        gap: label && icon !== false ? 'small' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), {
        size: size
    }, label), menuIcon);
    else {
        // when a theme has theme.button.default, keep content as
        // undefined so we can rely on Button label & icon props
        buttonProps = {
            icon: menuIcon,
            label: label,
            plain: plain,
            reverse: true,
            size: size
        };
        content = undefined;
    }
    var controlMirror = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        flex: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), $2e9daeb6193856a5$var$_extends({
        ref: function ref(r) {
            // make it accessible at the end of all menu items
            buttonRefs.current[itemCount] = r;
        },
        a11yTitle: a11y || format({
            id: 'menu.closeMenu',
            messages: messages
        }),
        active: activeItemIndex === controlButtonIndex,
        focusIndicator: false,
        hoverIndicator: "background",
        onClick: onDropClose,
        onFocus: function onFocus() {
            return setActiveItemIndex(controlButtonIndex);
        },
        tabIndex: activeItemIndex === constants.none ? '-1' : undefined
    }, theme.menu.item, buttonProps), typeof content === 'function' ? function() {
        return content($2e9daeb6193856a5$var$_extends({}, props, {
            drop: true
        }));
    } : content));
    var menuItem = function menuItem(item, index) {
        var _theme$menu$item, _theme$menu$item2, _theme$menu$item3, _theme$menu$item4;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ /*
    Not adding a theme object now because this code path
    is not used in the HPE theme, but we may add theme
    support here in the future.
    */ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            align: ((_theme$menu$item = theme.menu.item) == null ? void 0 : _theme$menu$item.align) || 'start',
            pad: "small",
            direction: "row",
            gap: item.gap || ((_theme$menu$item2 = theme.menu.item) == null ? void 0 : _theme$menu$item2.gap),
            justify: item.justify || ((_theme$menu$item3 = theme.menu.item) == null ? void 0 : _theme$menu$item3.justify)
        }, item.reverse && item.label, item.icon, !item.reverse && item.label) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return(/*#__PURE__*/ // lint isn't flagging this but we shouldn't use index as a key
        // see no-array-index-key lint rule
        (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            key: index,
            flex: false,
            role: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), $2e9daeb6193856a5$var$_extends({
            ref: function ref(r) {
                buttonRefs.current[index] = r;
            },
            role: "menuitem",
            onFocus: function onFocus() {
                setActiveItemIndex(index);
            },
            active: activeItemIndex === index,
            focusIndicator: false,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background'
        }, theme.menu.item, {
            justify: item.justify || ((_theme$menu$item4 = theme.menu.item) == null ? void 0 : _theme$menu$item4.justify)
        }, !child ? item : $2e9daeb6193856a5$var$_extends({}, item, {
            gap: undefined,
            icon: undefined,
            label: undefined,
            reverse: undefined
        }), {
            onClick: function onClick() {
                if (item.onClick) item.onClick.apply(item, arguments);
                if (item.close !== false) onDropClose();
            }
        }), child)));
    };
    var menuContent;
    var grouped = itemCount && Array.isArray(items[0]);
    if (grouped) {
        var index = 0;
        menuContent = items.map(function(group, groupIndex) {
            var _theme$menu$group, _theme$menu$group2, _theme$menu$group3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
                key: groupIndex,
                flex: false
            }, groupIndex > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
                pad: theme.menu.group.separator.pad
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
                border: {
                    side: 'top',
                    color: (_theme$menu$group = theme.menu.group) == null || (_theme$menu$group = _theme$menu$group.separator) == null ? void 0 : _theme$menu$group.color,
                    size: (_theme$menu$group2 = theme.menu.group) == null || (_theme$menu$group2 = _theme$menu$group2.separator) == null ? void 0 : _theme$menu$group2.size
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $2e9daeb6193856a5$var$_extends({}, theme.menu.container, (_theme$menu$group3 = theme.menu.group) == null ? void 0 : _theme$menu$group3.container), group.map(function(item) {
                // item index needs to be its index in the entire menu as if
                // it were a flat array
                var currentIndex = index;
                index += 1;
                return menuItem(item, currentIndex);
            })));
        });
    } else menuContent = items.map(function(item, index) {
        return menuItem(item, index);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onDown: onDropOpen,
        onUp: onDropOpen,
        onSpace: onSelectMenuItem,
        onEsc: onDropClose,
        onTab: onDropClose,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $b5k5v.DropButton), $2e9daeb6193856a5$var$_extends({
        ref: ref
    }, rest, buttonProps, {
        a11yTitle: a11y || format({
            id: 'menu.openMenu',
            messages: messages
        }),
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        onAlign: setAlignControlMirror,
        disabled: disabled,
        dropAlign: align,
        dropTarget: dropTarget,
        dropProps: dropProps || themeDropProps,
        open: isOpen,
        onOpen: onDropOpen,
        onClose: onDropClose,
        dropContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
            onTab: function onTab(event) {
                return event.shiftKey ? onPreviousMenuItem(event) : onNextMenuItem(event);
            },
            onDown: onNextMenuItem,
            onUp: onPreviousMenuItem,
            onEnter: onSelectMenuItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($2e9daeb6193856a5$var$ContainerBox, $2e9daeb6193856a5$var$_extends({
            ref: dropContainerRef,
            tabIndex: -1,
            background: dropBackground || theme.menu.background
        }, passThemeFlag), alignControlMirror === 'top' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $2e9daeb6193856a5$var$_extends({
            overflow: "auto",
            role: "menu",
            a11yTitle: a11y
        }, !grouped ? theme.menu.container : {}), menuContent), !initialAlignTop && // don't show controlMirror if caller is using
        // align.bottom === 'top'
        alignControlMirror === 'bottom' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined))
    }), content));
});
$2e9daeb6193856a5$export$d9b273488cd8ce6f.displayName = 'Menu';
$2e9daeb6193856a5$export$d9b273488cd8ce6f.propTypes = (0, $dWNq0.MenuPropTypes);

});
parcelRegister("dWNq0", function(module, exports) {

$parcel$export(module.exports, "MenuPropTypes", () => $a277069a055fa1df$export$debf9a822325d3f0);


function $a277069a055fa1df$var$_extends() {
    return $a277069a055fa1df$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a277069a055fa1df$var$_extends.apply(null, arguments);
}
var $a277069a055fa1df$var$VERTICAL_ALIGN_OPTIONS = [
    'top',
    'bottom'
];
var $a277069a055fa1df$var$HORIZONTAL_ALIGN_OPTIONS = [
    'right',
    'left'
];
var $a277069a055fa1df$var$PropType = {};
var $a277069a055fa1df$export$debf9a822325d3f0 = $a277069a055fa1df$var$PropType;

});


parcelRegister("l5Q6D", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $f5b27bc4fc683f03$export$14834abbfce3b8cd);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $f5b27bc4fc683f03$var$_extends() {
    return $f5b27bc4fc683f03$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f5b27bc4fc683f03$var$_extends.apply(null, arguments);
}
var $f5b27bc4fc683f03$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $f5b27bc4fc683f03$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Notification"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 19V9a8 8 0 0 1 16 0v10M1 19h22m-8 0v1a3 3 0 1 1-6 0v-1"
    }));
});
$f5b27bc4fc683f03$export$14834abbfce3b8cd.displayName = 'Notification';

});


parcelRegister("lbkqm", function(module, exports) {

$parcel$export(module.exports, "NotificationsTable", () => $a5120d442c12029b$export$871b0fa98d98e39b);

var $6ir3O = parcelRequire("6ir3O");

var $4kZY9 = parcelRequire("4kZY9");

var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $hIlrL = parcelRequire("hIlrL");
var $2bcjL = parcelRequire("2bcjL");
var $kOPdf = parcelRequire("kOPdf");
var $kS7Ii = parcelRequire("kS7Ii");

var $3Z3SE = parcelRequire("3Z3SE");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $8DltC = parcelRequire("8DltC");

var $4Oriw = parcelRequire("4Oriw");

var $9D12e = parcelRequire("9D12e");
const $a5120d442c12029b$export$871b0fa98d98e39b = (0, $j8yBr.observer)(()=>{
    /** Context **/ const notificationStore = (0, $8DltC.useNotificationStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2NacA.useState)(true);
    /** Refs **/ const columnWidths = [
        '3%',
        '16%',
        '81%'
    ];
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (isLoading) notificationStore.list().finally(()=>setIsLoading(false));
    }, [
        isLoading
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (notificationStore.page) setIsLoading(true);
    }, [
        notificationStore.page
    ]);
    (0, $2NacA.useEffect)(()=>{
        return ()=>{
            notificationStore.markAsRead();
        };
    }, []);
    /** Render */ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        round: (0, $4Oriw.borderRadiusSize),
        background: "light-1",
        animation: {
            type: 'fadeIn',
            duration: 500
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                justify: "start",
                align: "center",
                gap: "small",
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)',
                    zIndex: 1
                },
                height: {
                    max: '80px',
                    min: '80px'
                },
                pad: {
                    horizontal: 'small'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    color: "white",
                    children: "Notifications"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
                background: "white",
                elevation: "xsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        justify: "between",
                        align: "center",
                        gap: "medium",
                        pad: {
                            vertical: 'xsmall',
                            horizontal: 'small'
                        },
                        background: "light-2",
                        animation: {
                            type: 'slideDown',
                            size: 'medium',
                            delay: 300
                        },
                        border: {
                            side: 'bottom',
                            size: '1px',
                            color: 'light-4'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[0],
                                align: "center",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "TYPE"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[1],
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "TIMESTAMP"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: columnWidths[2],
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "DETAILS"
                                })
                            })
                        ]
                    }),
                    notificationStore.notifications.length > 0 ? notificationStore.notifications.map((n, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            border: i < notificationStore.notifications.length - 1 ? {
                                side: 'bottom',
                                size: '1px',
                                color: 'light-3'
                            } : undefined,
                            direction: "row",
                            pad: {
                                horizontal: 'small',
                                vertical: '1.1rem'
                            },
                            gap: "medium",
                            align: "center",
                            justify: "center",
                            fill: "horizontal",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    width: columnWidths[0],
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9D12e.NotificationIcon), {
                                        notification: n
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    width: columnWidths[1],
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(n.created_at).format('MMM D, YYYY @ h:mm:ss A')
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    width: columnWidths[2],
                                    children: projectStore.currentProject && n.source_entity_name && n.source_entity_id ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Link), {
                                        to: `/project/${(0, $9Rhqc.kebabCase)(projectStore.currentProject.name)}/${n.source_entity_name.toLocaleLowerCase()}/${n.source_entity_id}`,
                                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "row",
                                            gap: "xsmall",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    truncate: true,
                                                    children: n.text
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3Z3SE.Share), {
                                                    size: "small"
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        truncate: true,
                                        children: n.text
                                    })
                                })
                            ]
                        }, n.id)) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        pad: "medium",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            color: "dark-3",
                            children: "No notifications found."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hIlrL.CardFooter), {
                justify: "center",
                gap: "small",
                background: "light-2",
                pad: "small",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kOPdf.Pagination), {
                    page: notificationStore.page,
                    step: notificationStore.limit,
                    numberItems: notificationStore.total,
                    onChange: (props)=>notificationStore.setPage(props.page)
                })
            })
        ]
    });
});

});
parcelRegister("kOPdf", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => $f28033e917ca7d73$export$68f5e1453c188a82);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $dwnzz = parcelRequire("dwnzz");

var $5xcHk = parcelRequire("5xcHk");

var $hp1AK = parcelRequire("hp1AK");

var $jwDG4 = parcelRequire("jwDG4");

var $3Ljbo = parcelRequire("3Ljbo");

var $kfSWi = parcelRequire("kfSWi");

var $7ZKNh = parcelRequire("7ZKNh");

var $eL6w3 = parcelRequire("eL6w3");
var $f28033e917ca7d73$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "numberItems",
    "numberEdgePages",
    "numberMiddlePages",
    "onChange",
    "messages",
    "page",
    "size",
    "step",
    "stepOptions",
    "summary"
];
function $f28033e917ca7d73$var$_extends() {
    return $f28033e917ca7d73$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f28033e917ca7d73$var$_extends.apply(null, arguments);
}
function $f28033e917ca7d73$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f28033e917ca7d73$var$StyledPaginationContainer = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "Pagination__StyledPaginationContainer",
    componentId: "sc-rnlw6m-0"
})([
    "",
    ""
], function(props) {
    return props.theme.pagination.container && props.theme.pagination.container.extend;
});
var $f28033e917ca7d73$var$getPageIndices = function getPageIndices(begin, end) {
    var indices = [];
    for(var i = begin; i <= end; i += 1)indices.push(i);
    return indices;
};
var $f28033e917ca7d73$export$68f5e1453c188a82 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _ref2, _theme$pagination$con;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], numberItems = _ref.numberItems, _ref$numberEdgePages = _ref.numberEdgePages, numberEdgePages = _ref$numberEdgePages === void 0 ? 1 : _ref$numberEdgePages, _ref$numberMiddlePage = _ref.numberMiddlePages, numberMiddlePagesProp = _ref$numberMiddlePage === void 0 ? 3 : _ref$numberMiddlePage, onChange = _ref.onChange, messages = _ref.messages, pageProp = _ref.page, size = _ref.size, stepProp = _ref.step, stepOptions = _ref.stepOptions, summary = _ref.summary, rest = $f28033e917ca7d73$var$_objectWithoutPropertiesLoose(_ref, $f28033e917ca7d73$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var _useContext = (0, $2NacA.useContext)((0, $dwnzz.DataContext)), onView = _useContext.onView, filteredTotal = _useContext.filteredTotal, view = _useContext.view;
    var _useState = (0, $2NacA.useState)(stepProp || (view == null ? void 0 : view.step) || 10), step = _useState[0], setStep = _useState[1];
    var total = (_ref2 = numberItems != null ? numberItems : filteredTotal) != null ? _ref2 : 0;
    var page = pageProp || (view == null ? void 0 : view.page) || 1;
    /* Calculate total number pages */ var totalPages = Math.ceil(total / step);
    var _useState2 = (0, $2NacA.useState)(Math.min(page, totalPages) || 1), activePage = _useState2[0], setActivePage = _useState2[1];
    (0, $2NacA.useEffect)(function() {
        if (stepProp) setStep(stepProp);
    }, [
        stepProp
    ]);
    (0, $2NacA.useEffect)(function() {
        setActivePage(page);
        var pageEvent = new Event('pagechange');
        window.dispatchEvent(pageEvent);
    }, [
        page
    ]);
    (0, $2NacA.useEffect)(function() {
        // if we are getting the step or page from outside the view,
        // update the Data's view in case it needs to filter.
        if (onView && ((view == null ? void 0 : view.step) !== step || (view == null ? void 0 : view.page) !== page)) onView($f28033e917ca7d73$var$_extends({}, view, {
            page: page,
            step: step
        }));
    }, [
        onView,
        page,
        step,
        view
    ]);
    /* Define page indices to display */ var beginPages = $f28033e917ca7d73$var$getPageIndices(1, Math.min(numberEdgePages, totalPages));
    var endPages = $f28033e917ca7d73$var$getPageIndices(Math.max(totalPages - numberEdgePages + 1, numberEdgePages + 1), totalPages);
    var numberMiddlePages;
    if (numberMiddlePagesProp < 1) {
        numberMiddlePages = 1;
        console.warn("Property \"numberMiddlePages\" should not be < 1. One middle page button will be shown. Set \"numberMiddlePages\" >= 1 to remove this warning.");
    } else numberMiddlePages = numberMiddlePagesProp;
    var startingMiddlePages;
    // odd
    if (numberMiddlePages % 2) startingMiddlePages = Math.min(activePage - Math.floor(numberMiddlePages / 2), totalPages - numberEdgePages - numberMiddlePages);
    else startingMiddlePages = Math.min(activePage - Math.floor(numberMiddlePages / 2) + 1, totalPages - numberEdgePages - numberMiddlePages);
    var middlePagesBegin = Math.max(startingMiddlePages, numberEdgePages + 2);
    var middlePagesEnd = Math.min(Math.max(activePage + Math.floor(numberMiddlePages / 2), numberEdgePages + numberMiddlePages + 1), endPages.length > 0 ? endPages[0] - 2 : totalPages - 1);
    var middlePages = $f28033e917ca7d73$var$getPageIndices(middlePagesBegin, middlePagesEnd);
    var beginFlex = [];
    if (middlePagesBegin > numberEdgePages + 2) beginFlex = [
        'more-prev'
    ];
    else if (numberEdgePages + 1 < totalPages - numberEdgePages) beginFlex = [
        numberEdgePages + 1
    ];
    var endFlex = [];
    if (middlePagesEnd < totalPages - numberEdgePages - 1) endFlex = [
        'more-next'
    ];
    else if (totalPages - numberEdgePages > numberEdgePages) endFlex = [
        totalPages - numberEdgePages
    ];
    var getItemIndices = function getItemIndices(nextPage) {
        var startIndex = step * (nextPage - 1);
        var endIndex = startIndex + step;
        return {
            startIndex: startIndex,
            endIndex: endIndex
        };
    };
    var handleClick = function handleClick(event, nextPage) {
        setActivePage(nextPage);
        if (onView) onView($f28033e917ca7d73$var$_extends({}, view, {
            page: nextPage
        }));
        if (onChange) {
            event.persist();
            var adjustedEvent = event;
            adjustedEvent.page = nextPage;
            // for controlled use cases, provide user with info on
            // what range of indices should be displayed given the active page
            var _getItemIndices = getItemIndices(nextPage), startIndex = _getItemIndices.startIndex, endIndex = _getItemIndices.endIndex;
            adjustedEvent.startIndex = startIndex;
            adjustedEvent.endIndex = endIndex;
            onChange(adjustedEvent);
        }
    };
    var NextIcon = theme.pagination.icons.next;
    var PreviousIcon = theme.pagination.icons.previous;
    var iconColor = theme.pagination.icons.color;
    var navProps = {
        next: {
            // https://a11y-style-guide.com/style-guide/section-navigation.html#kssref-navigation-pagination
            'aria-disabled': activePage === totalPages ? 'true' : undefined,
            disabled: activePage === totalPages || !total,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(NextIcon, {
                color: iconColor
            }),
            onClick: function onClick(event) {
                var nextPage = activePage + 1;
                handleClick(event, nextPage);
            },
            label: undefined
        },
        previous: {
            'aria-disabled': activePage === 1 ? 'true' : undefined,
            disabled: activePage === 1 || !total,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(PreviousIcon, {
                color: iconColor
            }),
            onClick: function onClick(event) {
                var previousPage = activePage - 1;
                handleClick(event, previousPage);
            },
            label: undefined
        }
    };
    var controls = [
        'previous'
    ].concat(beginPages, beginFlex, middlePages, endFlex, endPages, [
        'next'
    ]);
    /* Set props for each page index. Each page index should display a
   * clickable index, control, or placeholder (e.g. ellipsis) indicating
   * more pages are available.
   */ controls = controls.map(function(control) {
        return $f28033e917ca7d73$var$_extends({
            active: control === activePage,
            a11yTitle: typeof control === 'number' ? "Go to page " + control : "Go to " + control + " page",
            // https://a11y-style-guide.com/style-guide/section-navigation.html#kssref-navigation-pagination
            // https://www.w3.org/TR/wai-aria-1.1/#aria-current
            'aria-current': control === activePage ? 'page' : undefined,
            control: control,
            onClick: function onClick(event) {
                handleClick(event, control);
            },
            separator: control === 'more-prev' || control === 'more-next'
        }, navProps[control]);
    });
    var paginationControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hp1AK.Nav), {
        a11yTitle: ariaLabel || a11yTitle || 'Pagination Navigation',
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $f28033e917ca7d73$var$_extends({
        as: "ul"
    }, theme.pagination.controls, {
        cssGap: true
    }), controls.map(function(control, index) {
        return(/*#__PURE__*/ /* Using index as key (as opposed to a unique id) seems to
       * help React prioritize rendering the updated controls as
       * desired. Whereas, using a unique id resulted in rendering
       * the active control with an undesired lag. */ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jwDG4.PageControl), $f28033e917ca7d73$var$_extends({
            key: index,
            size: size
        }, control)));
    })));
    // for backwards compatibility
    if (!summary && !stepOptions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($f28033e917ca7d73$var$StyledPaginationContainer, $f28033e917ca7d73$var$_extends({
        flex: false
    }, $f28033e917ca7d73$var$_extends({}, theme.pagination.container, {
        gap: undefined
    }), passThemeFlag, rest), paginationControls);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($f28033e917ca7d73$var$StyledPaginationContainer, $f28033e917ca7d73$var$_extends({
        direction: "row",
        align: "center",
        wrap: true,
        flex: false
    }, theme.pagination.container, passThemeFlag, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        flex: "grow"
    }, summary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kfSWi.PaginationSummary), {
        messages: messages,
        page: activePage,
        step: step,
        numberItems: total
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        align: "center",
        direction: "row",
        gap: (_theme$pagination$con = theme.pagination.container) == null ? void 0 : _theme$pagination$con.gap,
        wrap: true
    }, stepOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $3Ljbo.PaginationStep), {
        messages: messages,
        options: Array.isArray(stepOptions) ? stepOptions : undefined,
        step: step,
        onChange: function onChange(_ref3) {
            var value = _ref3.value;
            return setStep(value);
        }
    }), paginationControls));
});
$f28033e917ca7d73$export$68f5e1453c188a82.displayName = 'Pagination';
$f28033e917ca7d73$export$68f5e1453c188a82.propTypes = (0, $7ZKNh.PaginationPropTypes);

});
parcelRegister("dwnzz", function(module, exports) {

$parcel$export(module.exports, "DataContext", () => $9d808c9617712caa$export$58d75f9829cbe158);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");
var $9d808c9617712caa$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext({
    data: [],
    addToolbarKey: function addToolbarKey() {}
});

});

parcelRegister("jwDG4", function(module, exports) {

$parcel$export(module.exports, "PageControl", () => $e36fc89c23b8dc20$export$4109320283c508e);

var $2NacA = parcelRequire("2NacA");

var $hie8O = parcelRequire("hie8O");

var $eL6w3 = parcelRequire("eL6w3");
var $e36fc89c23b8dc20$var$_excluded = [
    "control",
    "separator",
    "size"
];
function $e36fc89c23b8dc20$var$_extends() {
    return $e36fc89c23b8dc20$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e36fc89c23b8dc20$var$_extends.apply(null, arguments);
}
function $e36fc89c23b8dc20$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e36fc89c23b8dc20$export$4109320283c508e = function PageControl(_ref) {
    var control = _ref.control, separator = _ref.separator, sizeProp = _ref.size, rest = $e36fc89c23b8dc20$var$_objectWithoutPropertiesLoose(_ref, $e36fc89c23b8dc20$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var size = sizeProp || 'medium';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hie8O.StyledContainer), $e36fc89c23b8dc20$var$_extends({
        as: "li",
        size: size
    }, passThemeFlag), separator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hie8O.StyledSeparator), $e36fc89c23b8dc20$var$_extends({
        size: size
    }, passThemeFlag), "\u2026") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hie8O.StyledPaginationButton), $e36fc89c23b8dc20$var$_extends({
        a11yTitle: "Go to page " + control,
        fill: true,
        kind: theme.pagination.button,
        label: control,
        size: size
    }, passThemeFlag, rest)));
};

});
parcelRegister("hie8O", function(module, exports) {

$parcel$export(module.exports, "StyledPaginationButton", () => $c96f1641be58742f$export$84e27f887f319440);
$parcel$export(module.exports, "StyledContainer", () => $c96f1641be58742f$export$1d41361302b577a1);
$parcel$export(module.exports, "StyledSeparator", () => $c96f1641be58742f$export$6d7013b439c96bfa);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");

var $a26J5 = parcelRequire("a26J5");

var $kS7Ii = parcelRequire("kS7Ii");
var $c96f1641be58742f$var$sizeStyle = function sizeStyle(props) {
    var style = props.theme.pagination.button && props.theme.pagination.button.size && props.theme.pagination.button.size[props.size || 'medium'];
    return style ? {
        content: {
            fontSize: style.font && style.font.size,
            // fix for safari, apply line-height 0 on next/previous
            // icon-only buttons
            lineHeight: style.font && props.hasLabel ? style.font.height : 0
        },
        container: {
            height: style.height,
            minWidth: style.width
        }
    } : '';
};
var $c96f1641be58742f$export$84e27f887f319440 = (0, $f5efw.default)((0, $a26J5.Button)).withConfig({
    displayName: "StyledPageControl__StyledPaginationButton",
    componentId: "sc-1vlfaez-0"
})([
    "> svg{margin:0 auto;}",
    ";"
], function(props) {
    return $c96f1641be58742f$var$sizeStyle(props).content;
});
var $c96f1641be58742f$export$1d41361302b577a1 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledPageControl__StyledContainer",
    componentId: "sc-1vlfaez-1"
})([
    "display:flex;align-items:center;justify-content:center;max-width:100%;",
    ";",
    ";"
], function(props) {
    return $c96f1641be58742f$var$sizeStyle(props).container;
}, function(props) {
    return props.theme.pagination.control && props.theme.pagination.control.extend;
});
var $c96f1641be58742f$export$6d7013b439c96bfa = (0, $f5efw.default)((0, $kS7Ii.Text)).withConfig({
    displayName: "StyledPageControl__StyledSeparator",
    componentId: "sc-1vlfaez-2"
})([
    "font-weight:bold;",
    ";",
    ";"
], function(props) {
    return "font-size: " + ($c96f1641be58742f$var$sizeStyle(props).content && $c96f1641be58742f$var$sizeStyle(props).content.fontSize);
}, function(props) {
    return "line-height: " + ($c96f1641be58742f$var$sizeStyle(props).content && $c96f1641be58742f$var$sizeStyle(props).content.lineHeight);
});

});


parcelRegister("3Ljbo", function(module, exports) {

$parcel$export(module.exports, "PaginationStep", () => $2bd4a430b9e32a6f$export$5035dc52aa18dae0);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $fdtj0 = parcelRequire("fdtj0");

var $kS7Ii = parcelRequire("kS7Ii");

var $2M0UK = parcelRequire("2M0UK");

var $eL6w3 = parcelRequire("eL6w3");
var $2bd4a430b9e32a6f$var$_excluded = [
    "messages",
    "onChange",
    "options",
    "step"
];
function $2bd4a430b9e32a6f$var$_extends() {
    return $2bd4a430b9e32a6f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2bd4a430b9e32a6f$var$_extends.apply(null, arguments);
}
function $2bd4a430b9e32a6f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2bd4a430b9e32a6f$export$5035dc52aa18dae0 = function PaginationStep(_ref) {
    var _theme$pagination;
    var messages = _ref.messages, onChange = _ref.onChange, _ref$options = _ref.options, options = _ref$options === void 0 ? [
        10,
        25,
        50,
        100
    ] : _ref$options, step = _ref.step, rest = $2bd4a430b9e32a6f$var$_objectWithoutPropertiesLoose(_ref, $2bd4a430b9e32a6f$var$_excluded);
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), formatMessage = _useContext.format;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $2bd4a430b9e32a6f$var$_extends({
        direction: "row",
        align: "center",
        gap: (_theme$pagination = theme.pagination) == null || (_theme$pagination = _theme$pagination.step) == null || (_theme$pagination = _theme$pagination.container) == null ? void 0 : _theme$pagination.gap
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), null, formatMessage({
        id: 'pagination.stepLabel',
        messages: messages
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $fdtj0.Select), {
        options: options,
        value: step,
        "aria-label": formatMessage({
            id: 'pagination.stepLabel',
            messages: messages
        }),
        valueLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), $2bd4a430b9e32a6f$var$_extends({}, theme.global.input, {
            pad: theme.global.input.padding
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), theme.global.input.font, step)),
        onChange: onChange
    }));
};

});

parcelRegister("kfSWi", function(module, exports) {

$parcel$export(module.exports, "PaginationSummary", () => $ebefd3273ad6a30b$export$94528e113b92ad1e);

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $kS7Ii = parcelRequire("kS7Ii");

var $2M0UK = parcelRequire("2M0UK");
var $ebefd3273ad6a30b$var$_excluded = [
    "messages",
    "numberItems",
    "page",
    "step"
];
function $ebefd3273ad6a30b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ebefd3273ad6a30b$export$94528e113b92ad1e = function PaginationSummary(_ref) {
    var messages = _ref.messages, numberItems = _ref.numberItems, page = _ref.page, step = _ref.step, rest = $ebefd3273ad6a30b$var$_objectWithoutPropertiesLoose(_ref, $ebefd3273ad6a30b$var$_excluded);
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), formatMessage = _useContext.format;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), null, numberItems > 0 ? formatMessage({
        id: 'pagination.summary',
        messages: messages,
        values: {
            start: "" + ((page - 1) * step + 1),
            end: "" + Math.min(page * step, numberItems),
            total: numberItems
        }
    }) : formatMessage({
        id: 'pagination.summaryNoItems',
        messages: messages
    })));
};

});

parcelRegister("7ZKNh", function(module, exports) {

$parcel$export(module.exports, "PaginationPropTypes", () => $5d228736e935048e$export$c8661a4aa71cec2a);


function $5d228736e935048e$var$_extends() {
    return $5d228736e935048e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d228736e935048e$var$_extends.apply(null, arguments);
}
var $5d228736e935048e$var$PropType = {};
var $5d228736e935048e$export$c8661a4aa71cec2a = $5d228736e935048e$var$PropType;

});


parcelRegister("3Z3SE", function(module, exports) {

$parcel$export(module.exports, "Share", () => $2e6a142a80d827b1$export$c9915453de10000b);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $2e6a142a80d827b1$var$_extends() {
    return $2e6a142a80d827b1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2e6a142a80d827b1$var$_extends.apply(null, arguments);
}
var $2e6a142a80d827b1$export$c9915453de10000b = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $2e6a142a80d827b1$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Share"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 13v10H1V5h10m3-4h9v9m-13 4L23 1 10 14z"
    }));
});
$2e6a142a80d827b1$export$c9915453de10000b.displayName = 'Share';

});


parcelRegister("3AWy1", function(module, exports) {

$parcel$export(module.exports, "WebSocketStatus", () => $49dad8beaa045793$export$e191a739fded5874);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $79HTA = parcelRequire("79HTA");

var $1Dexz = parcelRequire("1Dexz");

var $eLUFj = parcelRequire("eLUFj");

var $5cDu3 = parcelRequire("5cDu3");

var $8DltC = parcelRequire("8DltC");
const $49dad8beaa045793$export$e191a739fded5874 = ()=>{
    const userStore = (0, $8DltC.useUserStore)();
    const { readyState: readyState } = (0, (/*@__PURE__*/$parcel$interopDefault($1Dexz)))(`${(0, $eLUFj.env).apiWsHost}:${(0, $eLUFj.env).apiPort}`, {
        protocols: [
            'Authorization',
            userStore.token
        ],
        shouldReconnect: ()=>true,
        reconnectInterval: 3000,
        onError: console.error,
        retryOnError: true,
        share: true
    });
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $79HTA.Tip), {
            content: {
                [(0, $1Dexz.ReadyState).CONNECTING]: 'Connecting',
                [(0, $1Dexz.ReadyState).OPEN]: 'Connected',
                [(0, $1Dexz.ReadyState).CLOSING]: 'Closing',
                [(0, $1Dexz.ReadyState).CLOSED]: 'Closed',
                [(0, $1Dexz.ReadyState).UNINSTANTIATED]: 'Uninstantiated'
            }[readyState],
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                children: readyState !== (0, $1Dexz.ReadyState).OPEN ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5cDu3.Blink), {
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        background: "yellow",
                        height: "12px",
                        width: "12px",
                        round: true
                    })
                }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    background: "green",
                    height: "12px",
                    width: "12px",
                    round: true
                })
            })
        })
    });
};

});


parcelRegister("iPyPY", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $009e6a448174e479$export$2ddb90ad54e5f587);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ir3O = parcelRequire("6ir3O");

var $1SpQX = parcelRequire("1SpQX");
var $kOwHr = parcelRequire("kOwHr");
var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $8Ao5G = parcelRequire("8Ao5G");
var $4zRSZ = parcelRequire("4zRSZ");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $1Ofsp = parcelRequire("1Ofsp");
var $l3pMM = parcelRequire("l3pMM");
var $7wM4T = parcelRequire("7wM4T");
const $009e6a448174e479$export$2ddb90ad54e5f587 = (0, $j8yBr.observer)(({ items: items, newItem: newItem, deleteItems: deleteItems, updateItem: updateItem, label: label, labelPlural: labelPlural, addIcon: addIcon, types: types, buttons: buttons, cardProps: cardProps, headerBackground: headerBackground, color: color, children: children })=>{
    /** Context **/ const size = (0, $2NacA.useContext)((0, $4zRSZ.ResponsiveContext));
    /** State **/ const [selected, setSelected] = (0, $2NacA.useState)([]);
    /** Computed **/ const isMobile = size === 'small';
    /** Methods **/ const choose = (e, id)=>{
        e.preventDefault();
        e.stopPropagation();
        if (selected.includes(id)) setSelected(selected.filter((s)=>s !== id));
        else setSelected([
            ...selected,
            id
        ]);
    };
    const deleteSelected = async ()=>{
        await deleteItems(selected);
        setSelected([]);
    };
    const selectedNames = ()=>{
        return selected.map((s)=>items.find((item)=>item.id === s)?.name).join(', ');
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        setSelected([]);
    }, [
        items
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7wM4T.TalonCard), {
        newItem: newItem,
        deleteItems: deleteSelected,
        label: label,
        labelPlural: labelPlural,
        addIcon: addIcon,
        buttons: buttons,
        selectedNames: selectedNames(),
        cardProps: cardProps,
        color: color,
        headerBackground: headerBackground,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1SpQX.Accordion), {
            overflow: "auto",
            height: isMobile ? 'medium' : 'auto',
            children: !!items.length && items.map((item, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kOwHr.AccordionPanel), {
                    label: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        pad: "small",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                id: `choose-${item.id}`,
                                checked: selected.includes(item.id),
                                onChange: (e)=>choose(e, item.id),
                                pad: {
                                    horizontal: 'small'
                                }
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                val: item.name,
                                onChange: (name)=>updateItem({
                                        ...item,
                                        name: name
                                    }, i)
                            })
                        ]
                    }),
                    children: [
                        types.map((t)=>t.readonly ? t.label && item[t.key] && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                margin: "small",
                                children: [
                                    t.label,
                                    ": ",
                                    item[t.key]
                                ]
                            }, t.label) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                direction: "column",
                                justify: "between",
                                pad: "small",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                    label: `${t.label}`,
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                                        placeholder: `${t.label}`,
                                        options: (t.filterFunction && t.filterKey ? t.filterFunction(item[t.filterKey]) : t.values).map((type)=>({
                                                id: type,
                                                name: type
                                            })),
                                        value: item[t.key],
                                        onChange: (type)=>updateItem({
                                                ...item,
                                                [t.key]: type
                                            }, i),
                                        size: "small",
                                        clear: t.clear || false
                                    })
                                })
                            }, t.key)),
                        children && children[i]
                    ]
                }, item.id))
        })
    });
});

});

parcelRegister("3Focm", function(module, exports) {
$parcel$export(module.exports, "DocumentsPanel", () => (parcelRequire("agggX")).DocumentsPanel);
$parcel$export(module.exports, "GoogleMap", () => (parcelRequire("84VT2")).GoogleMap);
$parcel$export(module.exports, "Location", () => (parcelRequire("3qrf8")).Location);
$parcel$export(module.exports, "LocationPanel", () => (parcelRequire("cRsVF")).LocationPanel);
$parcel$export(module.exports, "ProjectCostumePanel", () => (parcelRequire("65HyY")).ProjectCostumePanel);
$parcel$export(module.exports, "ProjectPropPanel", () => (parcelRequire("lkbmC")).ProjectPropPanel);
$parcel$export(module.exports, "ProjectRolesPanel", () => (parcelRequire("gNjNn")).ProjectRolesPanel);
$parcel$export(module.exports, "TalentManagerPanel", () => (parcelRequire("21teh")).TalentManagerPanel);
parcelRequire("bs8mA");
parcelRequire("ktlnN");
parcelRequire("fRK3V");
parcelRequire("agggX");
parcelRequire("84VT2");
parcelRequire("3qrf8");
parcelRequire("cRsVF");
parcelRequire("65HyY");
parcelRequire("925dC");
parcelRequire("lkbmC");
parcelRequire("gNjNn");
parcelRequire("31rER");
parcelRequire("dgOaK");
parcelRequire("1kxSv");
parcelRequire("21teh");

});
parcelRegister("bs8mA", function(module, exports) {

$parcel$export(module.exports, "AutocompleteCustom", () => $4586772f18a8a2d1$export$cb6329834e0f338b);

var $6ir3O = parcelRequire("6ir3O");

var $2NacA = parcelRequire("2NacA");

var $kMVLi = parcelRequire("kMVLi");

var $fdtj0 = parcelRequire("fdtj0");
parcelRequire("4xbxO");
var $ldQFt = parcelRequire("ldQFt");

var $987Mn = parcelRequire("987Mn");
const $4586772f18a8a2d1$export$cb6329834e0f338b = ({ onPlaceSelect: onPlaceSelect, defaultValue: defaultValue })=>{
    const places = (0, $ldQFt.p)('places');
    const [inputValue, setInputValue] = (0, $2NacA.useState)(defaultValue || '');
    const { suggestions: suggestions, resetSession: resetSession } = (0, $987Mn.useAutocompleteSuggestions)(inputValue);
    const handleInput = (0, $2NacA.useCallback)((value)=>{
        setInputValue(value);
    }, []);
    const handleSuggestionClick = (0, $2NacA.useCallback)(async (suggestion)=>{
        if (!places) return;
        if (!suggestion.placePrediction) return;
        const place = suggestion.placePrediction.toPlace();
        await place.fetchFields({
            fields: [
                'location',
                'addressComponents',
                'formattedAddress'
            ]
        });
        setInputValue(suggestion.placePrediction.text.text);
        // calling fetchFields invalidates the session-token, so we now have to call
        // resetSession() so a new one gets created for further search
        resetSession();
        onPlaceSelect(place);
    }, [
        places,
        onPlaceSelect,
        resetSession
    ]);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
        options: suggestions.map((suggestion)=>({
                label: suggestion.placePrediction?.text.text || '',
                value: suggestion
            })),
        onChange: ({ option: option })=>handleSuggestionClick(option.value),
        value: inputValue,
        onSearch: (event)=>handleInput(event),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kMVLi.FormSearch), {}),
        size: "small",
        placeholder: inputValue || 'Search for a location'
    });
};

});
parcelRegister("kMVLi", function(module, exports) {

$parcel$export(module.exports, "FormSearch", () => $f225189d7c4bf58b$export$620e475702cadb1e);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $f225189d7c4bf58b$var$_extends() {
    return $f225189d7c4bf58b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f225189d7c4bf58b$var$_extends.apply(null, arguments);
}
var $f225189d7c4bf58b$export$620e475702cadb1e = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $f225189d7c4bf58b$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormSearch"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M13.8 13.8 18 18l-4.2-4.2zM10.5 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"
    }));
});
$f225189d7c4bf58b$export$620e475702cadb1e.displayName = 'FormSearch';

});

parcelRegister("4xbxO", function(module, exports) {

$parcel$export(module.exports, "Map", () => $97e7634fbedd800e$export$a5c7b93649eaf8f8);
$parcel$export(module.exports, "Marker", () => $97e7634fbedd800e$export$e98856a975cab58e);
$parcel$export(module.exports, "useMapsLibrary", () => (parcelRequire("ldQFt")).p);

var $ldQFt = parcelRequire("ldQFt");

var $2NacA = parcelRequire("2NacA");

var $l6sdi = parcelRequire("l6sdi");

/**
 * Copy of the `google.maps.CollisionBehavior` constants.
 * They have to be duplicated here since we can't wait for the maps API to load
 * to be able to use them.
 */ const $97e7634fbedd800e$export$780450305ded336e = {
    REQUIRED: 'REQUIRED',
    REQUIRED_AND_HIDES_OPTIONAL: 'REQUIRED_AND_HIDES_OPTIONAL',
    OPTIONAL_AND_HIDES_LOWER_PRIORITY: 'OPTIONAL_AND_HIDES_LOWER_PRIORITY'
};
/**
 * AltitudeMode for specifying how altitude is interpreted for 3D elements.
 * This mirrors google.maps.maps3d.AltitudeMode but is available without waiting
 * for the API to load.
 */ const $97e7634fbedd800e$export$daecfdca8d2f39c6 = {
    /** Allows to express objects relative to the average mean sea level. */ ABSOLUTE: 'ABSOLUTE',
    /** Allows to express objects placed on the ground. */ CLAMP_TO_GROUND: 'CLAMP_TO_GROUND',
    /** Allows to express objects relative to the ground surface. */ RELATIVE_TO_GROUND: 'RELATIVE_TO_GROUND',
    /** Allows to express objects relative to the highest of ground+building+water surface. */ RELATIVE_TO_MESH: 'RELATIVE_TO_MESH'
};
/**
 * Sets up effects to bind event-handlers for all event-props in MapEventProps.
 * @internal
 */ function $97e7634fbedd800e$var$useMapEvents(map, props) {
    // note: calling a useEffect hook from within a loop is prohibited by the
    // rules of hooks, but it's ok here since it's unconditional and the number
    // and order of iterations is always strictly the same.
    // (see https://legacy.reactjs.org/docs/hooks-rules.html)
    for (const propName of $97e7634fbedd800e$var$eventPropNames){
        // fixme: this cast is essentially a 'trust me, bro' for typescript, but
        //   a proper solution seems way too complicated right now
        const handler = props[propName];
        const eventType = $97e7634fbedd800e$var$propNameToEventType[propName];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $2NacA.useEffect)(()=>{
            if (!map) return;
            if (!handler) return;
            const listener = google.maps.event.addListener(map, eventType, (ev)=>{
                const mapEvent = $97e7634fbedd800e$var$createMapEvent(eventType, map, ev);
                if (mapEvent) handler(mapEvent);
            });
            return ()=>listener.remove();
        }, [
            map,
            eventType,
            handler
        ]);
    }
}
/**
 * Create the wrapped map-events used for the event-props.
 * @param type the event type as it is specified to the maps api
 * @param map the map instance the event originates from
 * @param srcEvent the source-event if there is one.
 */ function $97e7634fbedd800e$var$createMapEvent(type, map, srcEvent) {
    var _a;
    const ev = {
        type: type,
        map: map,
        detail: {},
        stoppable: false,
        stop: ()=>{}
    };
    if ($97e7634fbedd800e$var$cameraEventTypes.includes(type)) {
        const camEvent = ev;
        const center = map.getCenter();
        const zoom = map.getZoom();
        const heading = map.getHeading() || 0;
        const tilt = map.getTilt() || 0;
        const bounds = map.getBounds();
        if (!center || !bounds || !Number.isFinite(zoom)) {
            console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new");
            return null;
        }
        camEvent.detail = {
            center: center.toJSON(),
            zoom: zoom,
            heading: heading,
            tilt: tilt,
            bounds: bounds.toJSON()
        };
        return camEvent;
    } else if ($97e7634fbedd800e$var$mouseEventTypes.includes(type)) {
        if (!srcEvent) throw new Error('[createEvent] mouse events must provide a srcEvent');
        const mouseEvent = ev;
        mouseEvent.domEvent = srcEvent.domEvent;
        mouseEvent.stoppable = true;
        mouseEvent.stop = ()=>srcEvent.stop();
        mouseEvent.detail = {
            latLng: ((_a = srcEvent.latLng) === null || _a === void 0 ? void 0 : _a.toJSON()) || null,
            placeId: srcEvent.placeId
        };
        return mouseEvent;
    }
    return ev;
}
/**
 * maps the camelCased names of event-props to the corresponding event-types
 * used in the maps API.
 */ const $97e7634fbedd800e$var$propNameToEventType = {
    onBoundsChanged: 'bounds_changed',
    onCenterChanged: 'center_changed',
    onClick: 'click',
    onContextmenu: 'contextmenu',
    onDblclick: 'dblclick',
    onDrag: 'drag',
    onDragend: 'dragend',
    onDragstart: 'dragstart',
    onHeadingChanged: 'heading_changed',
    onIdle: 'idle',
    onIsFractionalZoomEnabledChanged: 'isfractionalzoomenabled_changed',
    onMapCapabilitiesChanged: 'mapcapabilities_changed',
    onMapTypeIdChanged: 'maptypeid_changed',
    onMousemove: 'mousemove',
    onMouseout: 'mouseout',
    onMouseover: 'mouseover',
    onProjectionChanged: 'projection_changed',
    onRenderingTypeChanged: 'renderingtype_changed',
    onTilesLoaded: 'tilesloaded',
    onTiltChanged: 'tilt_changed',
    onZoomChanged: 'zoom_changed',
    // note: onCameraChanged is an alias for the bounds_changed event,
    // since that is going to be fired in every situation where the camera is
    // updated.
    onCameraChanged: 'bounds_changed'
};
const $97e7634fbedd800e$var$cameraEventTypes = [
    'bounds_changed',
    'center_changed',
    'heading_changed',
    'tilt_changed',
    'zoom_changed'
];
const $97e7634fbedd800e$var$mouseEventTypes = [
    'click',
    'contextmenu',
    'dblclick',
    'mousemove',
    'mouseout',
    'mouseover'
];
const $97e7634fbedd800e$var$eventPropNames = Object.keys($97e7634fbedd800e$var$propNameToEventType);
const $97e7634fbedd800e$var$mapOptionKeys = new Set([
    'backgroundColor',
    'clickableIcons',
    'controlSize',
    'disableDefaultUI',
    'disableDoubleClickZoom',
    'draggable',
    'draggableCursor',
    'draggingCursor',
    'fullscreenControl',
    'fullscreenControlOptions',
    'gestureHandling',
    'headingInteractionEnabled',
    'isFractionalZoomEnabled',
    'keyboardShortcuts',
    'mapTypeControl',
    'mapTypeControlOptions',
    'mapTypeId',
    'maxZoom',
    'minZoom',
    'noClear',
    'panControl',
    'panControlOptions',
    'restriction',
    'rotateControl',
    'rotateControlOptions',
    'scaleControl',
    'scaleControlOptions',
    'scrollwheel',
    'streetView',
    'streetViewControl',
    'streetViewControlOptions',
    'styles',
    'tiltInteractionEnabled',
    'zoomControl',
    'zoomControlOptions'
]);
/**
 * Internal hook to update the map-options when props are changed.
 *
 * @param map the map instance
 * @param mapProps the props to update the map-instance with
 * @internal
 */ function $97e7634fbedd800e$var$useMapOptions(map, mapProps) {
    /* eslint-disable react-hooks/exhaustive-deps --
     *
     * The following effects aren't triggered when the map is changed.
     * In that case, the values will be or have been passed to the map
     * constructor via mapOptions.
     */ const mapOptions = {};
    const keys = Object.keys(mapProps);
    for (const key of keys){
        if (!$97e7634fbedd800e$var$mapOptionKeys.has(key)) continue;
        mapOptions[key] = mapProps[key];
    }
    // update the map options when mapOptions is changed
    // Note: due to the destructuring above, mapOptions will be seen as changed
    //   with every re-render, so we're assuming the maps-api will properly
    //   deal with unchanged option-values passed into setOptions.
    (0, $ldQFt.h)(()=>{
        if (!map) return;
        map.setOptions(mapOptions);
    }, [
        mapOptions
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }
/**
 * Internal hook that updates the camera when deck.gl viewState changes.
 * @internal
 */ function $97e7634fbedd800e$var$useDeckGLCameraUpdate(map, props) {
    const { viewport: viewport, viewState: viewState } = props;
    const isDeckGlControlled = !!viewport;
    (0, $2NacA.useLayoutEffect)(()=>{
        if (!map || !viewState) return;
        const { latitude: latitude, longitude: longitude, bearing: heading, pitch: tilt, zoom: zoom } = viewState;
        map.moveCamera({
            center: {
                lat: latitude,
                lng: longitude
            },
            heading: heading,
            tilt: tilt,
            zoom: zoom + 1
        });
    }, [
        map,
        viewState
    ]);
    return isDeckGlControlled;
}
function $97e7634fbedd800e$export$82fba3567e3760d8(obj) {
    if (!obj || typeof obj !== 'object') return false;
    if (!('lat' in obj && 'lng' in obj)) return false;
    return Number.isFinite(obj.lat) && Number.isFinite(obj.lng);
}
function $97e7634fbedd800e$export$e6f27d7c3c3233eb(a, b) {
    if (!a || !b) return false;
    const A = $97e7634fbedd800e$export$988c27a52d63c3b9(a);
    const B = $97e7634fbedd800e$export$988c27a52d63c3b9(b);
    if (A.lat !== B.lat || A.lng !== B.lng) return false;
    return true;
}
function $97e7634fbedd800e$export$988c27a52d63c3b9(obj) {
    if ($97e7634fbedd800e$export$82fba3567e3760d8(obj)) return obj;
    return obj.toJSON();
}
function $97e7634fbedd800e$export$26cbfc0dea0ade67(obj) {
    if ('north' in obj && 'south' in obj && 'east' in obj && 'west' in obj) return obj;
    const ne = obj.getNorthEast().toJSON();
    const sw = obj.getSouthWest().toJSON();
    return {
        north: ne.lat,
        east: ne.lng,
        south: sw.lat,
        west: sw.lng
    };
}
function $97e7634fbedd800e$export$c0cfaae65aded47(a, b) {
    if (!a || !b) return false;
    const A = $97e7634fbedd800e$export$26cbfc0dea0ade67(a);
    const B = $97e7634fbedd800e$export$26cbfc0dea0ade67(b);
    return A.north === B.north && A.south === B.south && A.east === B.east && A.west === B.west;
}
/**
 * Compares two paths (arrays of LatLng points) for equality.
 */ function $97e7634fbedd800e$export$69485f8143efb551(a, b) {
    if (!a || !b) return a === b;
    const arrayB = 'getArray' in b ? b.getArray() : b;
    if (a.length !== arrayB.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$97e7634fbedd800e$export$e6f27d7c3c3233eb(a[i], arrayB[i])) return false;
    }
    return true;
}
/**
 * Compares two arrays of paths (for Polygon) for equality.
 */ function $97e7634fbedd800e$export$81bf7c9065d0b5e1(a, b) {
    if (!a || !b) return a === b;
    const arrayB = 'getArray' in b ? b.getArray().map((inner)=>inner.getArray()) : b;
    if (a.length !== arrayB.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$97e7634fbedd800e$export$69485f8143efb551(a[i], arrayB[i])) return false;
    }
    return true;
}
function $97e7634fbedd800e$var$useMapCameraParams(map, cameraStateRef, mapProps) {
    const center = mapProps.center ? $97e7634fbedd800e$export$988c27a52d63c3b9(mapProps.center) : null;
    let lat = null;
    let lng = null;
    if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        lat = center.lat;
        lng = center.lng;
    }
    const zoom = Number.isFinite(mapProps.zoom) ? mapProps.zoom : null;
    const heading = Number.isFinite(mapProps.heading) ? mapProps.heading : null;
    const tilt = Number.isFinite(mapProps.tilt) ? mapProps.tilt : null;
    // the following effect runs for every render of the map component and checks
    // if there are differences between the known state of the map instance
    // (cameraStateRef, which is updated by all bounds_changed events) and the
    // desired state in the props.
    (0, $2NacA.useLayoutEffect)(()=>{
        if (!map) return;
        const nextCamera = {};
        let needsUpdate = false;
        if (lat !== null && lng !== null && (cameraStateRef.current.center.lat !== lat || cameraStateRef.current.center.lng !== lng)) {
            nextCamera.center = {
                lat: lat,
                lng: lng
            };
            needsUpdate = true;
        }
        if (zoom !== null && cameraStateRef.current.zoom !== zoom) {
            nextCamera.zoom = zoom;
            needsUpdate = true;
        }
        if (heading !== null && cameraStateRef.current.heading !== heading) {
            nextCamera.heading = heading;
            needsUpdate = true;
        }
        if (tilt !== null && cameraStateRef.current.tilt !== tilt) {
            nextCamera.tilt = tilt;
            needsUpdate = true;
        }
        if (needsUpdate) map.moveCamera(nextCamera);
    });
}
const $97e7634fbedd800e$var$AuthFailureMessage = ()=>{
    const style = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        flexFlow: 'column nowrap',
        textAlign: 'center',
        justifyContent: 'center',
        fontSize: '.8rem',
        color: 'rgba(0,0,0,0.6)',
        background: '#dddddd',
        padding: '1rem 1.5rem'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("h2", null, "Error: AuthFailure"), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function $97e7634fbedd800e$var$handleBoundsChange(map, ref) {
    const center = map.getCenter();
    const zoom = map.getZoom();
    const heading = map.getHeading() || 0;
    const tilt = map.getTilt() || 0;
    if (!center || !Number.isFinite(zoom)) {
        console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new");
        return;
    }
    Object.assign(ref.current, {
        center: center.toJSON(),
        zoom: zoom,
        heading: heading,
        tilt: tilt
    });
}
/**
 * Creates a mutable ref object to track the last known state of the map camera.
 * This is used in `useMapCameraParams` to reduce stuttering in normal operation
 * by avoiding updates of the map camera with values that have already been processed.
 */ function $97e7634fbedd800e$var$useTrackedCameraStateRef(map) {
    const forceUpdate = (0, $ldQFt.i)();
    const ref = (0, $2NacA.useRef)({
        center: {
            lat: 0,
            lng: 0
        },
        heading: 0,
        tilt: 0,
        zoom: 0
    });
    // Record camera state with every bounds_changed event dispatched by the map.
    // This data is used to prevent feeding these values back to the
    // map-instance when a typical "controlled component" setup (state variable is
    // fed into and updated by the map).
    (0, $2NacA.useEffect)(()=>{
        if (!map) return;
        const listener = google.maps.event.addListener(map, 'bounds_changed', ()=>{
            $97e7634fbedd800e$var$handleBoundsChange(map, ref);
            // When an event is occured, we have to update during the next cycle.
            // The application could decide to ignore the event and not update any
            // camera props of the map, meaning that in that case we will have to
            // 'undo' the change to the camera.
            forceUpdate();
        });
        return ()=>listener.remove();
    }, [
        map,
        forceUpdate
    ]);
    return ref;
}
/**
 * Stores a stack of map-instances for each mapId. Whenever an
 * instance is used, it is removed from the stack while in use,
 * and returned to the stack when the component unmounts.
 * This allows us to correctly implement caching for multiple
 * maps om the same page, while reusing as much as possible.
 *
 * FIXME: while it should in theory be possible to reuse maps solely
 *   based on mapId/renderingType/colorScheme (as all other parameters can be
 *   changed at runtime), we don't yet have good enough tracking of options to
 *   reliably unset all the options that have been set.
 */ class $97e7634fbedd800e$var$CachedMapStack {
    static has(key) {
        return this.entries[key] && this.entries[key].length > 0;
    }
    static pop(key) {
        if (!this.entries[key]) return null;
        return this.entries[key].pop() || null;
    }
    static push(key, value) {
        if (!this.entries[key]) this.entries[key] = [];
        this.entries[key].push(value);
    }
}
$97e7634fbedd800e$var$CachedMapStack.entries = {};
/**
 * The main hook takes care of creating map-instances and registering them in
 * the api-provider context.
 * @return a tuple of the map-instance created (or null) and the callback
 *   ref that will be used to pass the map-container into this hook.
 * @internal
 */ function $97e7634fbedd800e$var$useMapInstance(props, context) {
    const apiIsLoaded = (0, $ldQFt.j)();
    const [map, setMap] = (0, $2NacA.useState)(null);
    const [container, containerRef] = (0, $ldQFt.k)();
    const cameraStateRef = $97e7634fbedd800e$var$useTrackedCameraStateRef(map);
    const { id: id, defaultBounds: defaultBounds, defaultCenter: defaultCenter, defaultZoom: defaultZoom, defaultHeading: defaultHeading, defaultTilt: defaultTilt, reuseMaps: reuseMaps, renderingType: renderingType, colorScheme: colorScheme } = props, mapOptions = (0, $ldQFt._)(props, [
        "id",
        "defaultBounds",
        "defaultCenter",
        "defaultZoom",
        "defaultHeading",
        "defaultTilt",
        "reuseMaps",
        "renderingType",
        "colorScheme"
    ]);
    const hasZoom = props.zoom !== undefined || props.defaultZoom !== undefined;
    const hasCenter = props.center !== undefined || props.defaultCenter !== undefined;
    if (!defaultBounds && (!hasZoom || !hasCenter)) console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required");
    // apply default camera props if available and not overwritten by controlled props
    if (!mapOptions.center && defaultCenter) mapOptions.center = defaultCenter;
    if (!mapOptions.zoom && Number.isFinite(defaultZoom)) mapOptions.zoom = defaultZoom;
    if (!mapOptions.heading && Number.isFinite(defaultHeading)) mapOptions.heading = defaultHeading;
    if (!mapOptions.tilt && Number.isFinite(defaultTilt)) mapOptions.tilt = defaultTilt;
    // Handle internalUsageAttributionIds
    const customIds = mapOptions.internalUsageAttributionIds;
    if (customIds == null) // Not specified - use context default (which may be null if disabled)
    mapOptions.internalUsageAttributionIds = context.internalUsageAttributionIds;
    else // Merge context defaults with custom IDs
    mapOptions.internalUsageAttributionIds = [
        ...context.internalUsageAttributionIds || [],
        ...customIds
    ];
    for (const key of Object.keys(mapOptions))if (mapOptions[key] === undefined) delete mapOptions[key];
    const savedMapStateRef = (0, $2NacA.useRef)(undefined);
    // kept up to date on every render so the effect below (which intentionally
    // doesn't list reuseMaps as a dependency) always sees the latest value,
    // both when creating a map and in its cleanup function on unmount.
    const reuseMapsRef = (0, $2NacA.useRef)(reuseMaps);
    (0, $2NacA.useEffect)(()=>{
        reuseMapsRef.current = reuseMaps;
    }, [
        reuseMaps
    ]);
    // create the map instance and register it in the context
    (0, $2NacA.useEffect)(()=>{
        if (!container || !apiIsLoaded) return;
        const { addMapInstance: addMapInstance, removeMapInstance: removeMapInstance } = context;
        // note: colorScheme (upcoming feature) isn't yet in the typings, remove once that is fixed:
        const { mapId: mapId } = props;
        const cacheKey = `${mapId || 'default'}:${renderingType || 'default'}:${colorScheme || 'LIGHT'}`;
        let mapDiv;
        let map;
        // a cached map can end up in a broken state (e.g. when the initial
        // map-creation failed because the Maps JavaScript API didn't load
        // correctly). In that case `getDiv()` doesn't return a usable DOM node,
        // so we have to discard the cached instance instead of trying to reuse it.
        const cachedMap = reuseMapsRef.current && $97e7634fbedd800e$var$CachedMapStack.has(cacheKey) ? $97e7634fbedd800e$var$CachedMapStack.pop(cacheKey) : null;
        const cachedMapDiv = cachedMap === null || cachedMap === void 0 ? void 0 : cachedMap.getDiv();
        const reusedMap = cachedMap && cachedMapDiv instanceof Node ? cachedMap : null;
        if (reusedMap) {
            map = reusedMap;
            mapDiv = cachedMapDiv;
            container.appendChild(mapDiv);
            map.setOptions(mapOptions);
            // detaching the element from the DOM sometimes causes the map to collapse
            // and no longer render tiles that should be in view after re-attaching it.
            // Triggering moveCamera after remounting should trigger a re-layout of
            // the map.
            setTimeout(()=>map.moveCamera({}), 0);
        } else {
            // discard a broken cached instance so it doesn't get pushed back
            if (cachedMap) google.maps.event.clearInstanceListeners(cachedMap);
            mapDiv = document.createElement('div');
            mapDiv.style.height = '100%';
            container.appendChild(mapDiv);
            map = new google.maps.Map(mapDiv, Object.assign(Object.assign(Object.assign({}, mapOptions), renderingType ? {
                renderingType: renderingType
            } : {}), colorScheme ? {
                colorScheme: colorScheme
            } : {}));
        }
        setMap(map);
        addMapInstance(map, id);
        if (defaultBounds) {
            const { padding: padding } = defaultBounds, defBounds = (0, $ldQFt._)(defaultBounds, [
                "padding"
            ]);
            map.fitBounds(defBounds, padding);
        } else if (!hasZoom || !hasCenter) map.fitBounds({
            east: 180,
            west: -180,
            south: -90,
            north: 90
        });
        // the savedMapState is used to restore the camera parameters when the mapId is changed
        if (savedMapStateRef.current) {
            const { mapId: savedMapId, cameraState: savedCameraState } = savedMapStateRef.current;
            if (savedMapId !== mapId) map.moveCamera(savedCameraState);
        }
        return ()=>{
            savedMapStateRef.current = {
                mapId: mapId,
                // eslint-disable-next-line react-hooks/exhaustive-deps
                cameraState: cameraStateRef.current
            };
            // detach the map-div from the dom
            mapDiv.remove();
            if (reuseMapsRef.current) // push back on the stack
            $97e7634fbedd800e$var$CachedMapStack.push(cacheKey, map);
            else // remove all event-listeners to minimize the possibility of memory-leaks
            google.maps.event.clearInstanceListeners(map);
            setMap(null);
            removeMapInstance(id);
        };
    }, // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        container,
        apiIsLoaded,
        id,
        // these props can't be changed after initialization and require a new
        // instance to be created
        props.mapId,
        props.renderingType,
        props.colorScheme
    ]);
    return [
        map,
        containerRef,
        cameraStateRef
    ];
}
const $97e7634fbedd800e$export$477ce50570f8b557 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(null);
// ColorScheme and RenderingType are redefined here to make them usable before the
// maps API has been fully loaded.
const $97e7634fbedd800e$export$610a58c777d52843 = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
    FOLLOW_SYSTEM: 'FOLLOW_SYSTEM'
};
const $97e7634fbedd800e$export$245778257f8d6718 = {
    VECTOR: 'VECTOR',
    RASTER: 'RASTER',
    UNINITIALIZED: 'UNINITIALIZED'
};
const $97e7634fbedd800e$export$a5c7b93649eaf8f8 = (props)=>{
    const { children: children, id: id, className: className, style: style } = props;
    const context = (0, $2NacA.useContext)((0, $ldQFt.A));
    const loadingStatus = (0, $ldQFt.l)();
    if (!context) throw new Error('<Map> can only be used inside an <ApiProvider> component.');
    const [map, mapRef, cameraStateRef] = $97e7634fbedd800e$var$useMapInstance(props, context);
    $97e7634fbedd800e$var$useMapCameraParams(map, cameraStateRef, props);
    $97e7634fbedd800e$var$useMapEvents(map, props);
    $97e7634fbedd800e$var$useMapOptions(map, props);
    const isDeckGlControlled = $97e7634fbedd800e$var$useDeckGLCameraUpdate(map, props);
    const isControlledExternally = !!props.controlled;
    // disable interactions with the map for externally controlled maps
    (0, $2NacA.useEffect)(()=>{
        if (!map) return;
        // fixme: this doesn't seem to belong here (and it's mostly there for convenience anyway).
        //   The reasoning is that a deck.gl canvas will be put on top of the map, rendering
        //   any default map controls pretty much useless
        if (isDeckGlControlled) map.setOptions({
            disableDefaultUI: true
        });
        // disable all control-inputs when the map is controlled externally
        if (isDeckGlControlled || isControlledExternally) map.setOptions({
            gestureHandling: 'none',
            keyboardShortcuts: false
        });
        return ()=>{
            map.setOptions({
                gestureHandling: props.gestureHandling,
                keyboardShortcuts: props.keyboardShortcuts
            });
        };
    }, [
        map,
        isDeckGlControlled,
        isControlledExternally,
        props.gestureHandling,
        props.keyboardShortcuts
    ]);
    // setup a stable cameraOptions object that can be used as dependency
    const center = props.center ? $97e7634fbedd800e$export$988c27a52d63c3b9(props.center) : null;
    let lat = null;
    let lng = null;
    if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        lat = center.lat;
        lng = center.lng;
    }
    const cameraOptions = (0, $2NacA.useMemo)(()=>{
        var _a, _b, _c;
        return {
            center: {
                lat: lat !== null && lat !== void 0 ? lat : 0,
                lng: lng !== null && lng !== void 0 ? lng : 0
            },
            zoom: (_a = props.zoom) !== null && _a !== void 0 ? _a : 0,
            heading: (_b = props.heading) !== null && _b !== void 0 ? _b : 0,
            tilt: (_c = props.tilt) !== null && _c !== void 0 ? _c : 0
        };
    }, [
        lat,
        lng,
        props.zoom,
        props.heading,
        props.tilt
    ]);
    // externally controlled mode: reject all camera changes that don't correspond to changes in props
    (0, $2NacA.useLayoutEffect)(()=>{
        if (!map || !isControlledExternally) return;
        map.moveCamera(cameraOptions);
        const listener = map.addListener('bounds_changed', ()=>{
            map.moveCamera(cameraOptions);
        });
        return ()=>listener.remove();
    }, [
        map,
        isControlledExternally,
        cameraOptions
    ]);
    const combinedStyle = (0, $2NacA.useMemo)(()=>Object.assign({
            width: '100%',
            height: '100%',
            position: 'relative',
            // when using deckgl, the map should be sent to the back
            zIndex: isDeckGlControlled ? -1 : 0
        }, style), [
        style,
        isDeckGlControlled
    ]);
    const contextValue = (0, $2NacA.useMemo)(()=>({
            map: map
        }), [
        map
    ]);
    if (loadingStatus === (0, $ldQFt.m).AUTH_FAILURE) return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        style: Object.assign({
            position: 'relative'
        }, className ? {} : combinedStyle),
        className: className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($97e7634fbedd800e$var$AuthFailureMessage, null));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", Object.assign({
        ref: mapRef,
        "data-testid": 'map',
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}), map ? (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($97e7634fbedd800e$export$477ce50570f8b557.Provider, {
        value: contextValue
    }, children) : null);
};
// The deckGLViewProps flag here indicates to deck.gl that the Map component is
// able to handle viewProps from deck.gl when deck.gl is used to control the map.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$97e7634fbedd800e$export$a5c7b93649eaf8f8.deckGLViewProps = true;
/**
 * Retrieves a map-instance from the context. This is either an instance
 * identified by id or the parent map instance if no id is specified.
 * Returns null if neither can be found.
 */ const $97e7634fbedd800e$export$86f8f9f08863e403 = (id = null)=>{
    const ctx = (0, $2NacA.useContext)((0, $ldQFt.A));
    const { map: map } = (0, $2NacA.useContext)($97e7634fbedd800e$export$477ce50570f8b557) || {};
    if (ctx === null) {
        (0, $ldQFt.n)("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>.");
        return null;
    }
    const { mapInstances: mapInstances } = ctx;
    // if an id is specified, the corresponding map or null is returned
    if (id !== null) return mapInstances[id] || null;
    // otherwise, return the closest ancestor
    if (map) return map;
    // finally, return the default map instance
    return mapInstances['default'] || null;
};
/* eslint-disable @typescript-eslint/no-explicit-any */ const $97e7634fbedd800e$var$noop = ()=>{};
/**
 * Internally used to bind events to Maps JavaScript API objects.
 * @internal
 */ function $97e7634fbedd800e$var$useMapsEventListener(target, name, callback) {
    const eventFn = (0, $ldQFt.o)(callback !== null && callback !== void 0 ? callback : $97e7634fbedd800e$var$noop);
    const isCallbackDefined = Boolean(callback);
    (0, $2NacA.useEffect)(()=>{
        if (!target || !name || !isCallbackDefined) return;
        const listener = google.maps.event.addListener(target, name, eventFn);
        return ()=>listener.remove();
    }, [
        target,
        name,
        isCallbackDefined
    ]);
}
// Global style manager to track rendered styles and avoid duplicates
class $97e7634fbedd800e$var$GlobalStyleManager {
    constructor(){
        this.renderedStyles = new Set();
        this.styleElement = null;
    }
    getStyleElement() {
        if (!this.styleElement) {
            this.styleElement = document.createElement('style');
            this.styleElement.setAttribute('data-rgm-anchor-styles', '');
            document.head.appendChild(this.styleElement);
        }
        return this.styleElement;
    }
    addAdvancedMarkerPointerEventsOverwrite() {
        if (this.renderedStyles.has('marker-pointer-events')) return;
        const styleElement = this.getStyleElement();
        styleElement.textContent += `
      gmp-advanced-marker[data-origin='rgm'] {
        pointer-events: none !important;
      }
    `;
        this.renderedStyles.add('marker-pointer-events');
    }
    cleanup() {
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
            this.renderedStyles.clear();
        }
    }
}
const $97e7634fbedd800e$var$globalStyleManager = new $97e7634fbedd800e$var$GlobalStyleManager();
function $97e7634fbedd800e$var$isVersionGreaterEqual(major, minor) {
    var _a;
    if (!((_a = google === null || google === void 0 ? void 0 : google.maps) === null || _a === void 0 ? void 0 : _a.version)) return undefined;
    const version = google.maps.version.split('.');
    const currentMajor = parseInt(version[0], 10);
    const currentMinor = parseInt(version[1], 10);
    return currentMajor > major || currentMajor === major && currentMinor >= minor;
}
const $97e7634fbedd800e$export$14de7bb7593cd5bc = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(null);
// [xPosition, yPosition] when the top left corner is [0, 0]
/**
 * @deprecated Using `anchorPosition` is deprecated.
 *   Use `anchorLeft` and `anchorTop` instead.
 */ const $97e7634fbedd800e$export$5a0544ba0e628ca7 = {
    TOP_LEFT: [
        '0%',
        '0%'
    ],
    TOP_CENTER: [
        '50%',
        '0%'
    ],
    TOP: [
        '50%',
        '0%'
    ],
    TOP_RIGHT: [
        '100%',
        '0%'
    ],
    LEFT_CENTER: [
        '0%',
        '50%'
    ],
    LEFT_TOP: [
        '0%',
        '0%'
    ],
    LEFT: [
        '0%',
        '50%'
    ],
    LEFT_BOTTOM: [
        '0%',
        '100%'
    ],
    RIGHT_TOP: [
        '100%',
        '0%'
    ],
    RIGHT: [
        '100%',
        '50%'
    ],
    RIGHT_CENTER: [
        '100%',
        '50%'
    ],
    RIGHT_BOTTOM: [
        '100%',
        '100%'
    ],
    BOTTOM_LEFT: [
        '0%',
        '100%'
    ],
    BOTTOM_CENTER: [
        '50%',
        '100%'
    ],
    BOTTOM: [
        '50%',
        '100%'
    ],
    BOTTOM_RIGHT: [
        '100%',
        '100%'
    ],
    CENTER: [
        '50%',
        '50%'
    ]
};
const $97e7634fbedd800e$export$5dd2dc1fc7030ab5 = (0, $2NacA.forwardRef)((props, ref)=>{
    const { children: children, style: style, className: className, anchorPoint: anchorPoint } = props;
    const [marker, contentContainer] = $97e7634fbedd800e$var$useAdvancedMarker(props);
    const advancedMarkerContextValue = (0, $2NacA.useMemo)(()=>marker ? {
            marker: marker
        } : null, [
        marker
    ]);
    (0, $2NacA.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    if (!contentContainer) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($97e7634fbedd800e$export$14de7bb7593cd5bc.Provider, {
        value: advancedMarkerContextValue
    }, (0, $l6sdi.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($97e7634fbedd800e$var$MarkerContent, {
        anchorPoint: anchorPoint,
        styles: style,
        className: className
    }, children), contentContainer));
});
$97e7634fbedd800e$export$5dd2dc1fc7030ab5.displayName = 'AdvancedMarker';
function $97e7634fbedd800e$export$ee72183bc46d9ec2() {
    const [marker, setMarker] = (0, $2NacA.useState)(null);
    const refCallback = (0, $2NacA.useCallback)((m)=>{
        setMarker(m);
    }, []);
    return [
        refCallback,
        marker
    ];
}
function $97e7634fbedd800e$export$5f1640ccc146ea2d(marker) {
    return marker.content !== undefined;
}
function $97e7634fbedd800e$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
const $97e7634fbedd800e$var$MarkerContent = ({ children: children, styles: styles, className: className })=>{
    /* AdvancedMarker div that user can give styles and classes */ return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        className: className,
        style: styles
    }, children);
};
function $97e7634fbedd800e$var$useAdvancedMarker(props) {
    const [marker, setMarker] = (0, $2NacA.useState)(null);
    const [contentContainer, setContentContainer] = (0, $2NacA.useState)(null);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    const markerLibrary = (0, $ldQFt.p)('marker');
    const { children: children, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, collisionBehavior: collisionBehavior, clickable: clickable, draggable: draggable, position: position, title: title, zIndex: zIndex, anchorPoint: anchorPoint, anchorLeft: anchorLeft, anchorTop: anchorTop } = props;
    const numChildren = (0, $2NacA.Children).count(children);
    // create an AdvancedMarkerElement instance and add it to the map once available
    (0, $2NacA.useEffect)(()=>{
        if (!map || !markerLibrary) return;
        const newMarker = new markerLibrary.AdvancedMarkerElement();
        newMarker.map = map;
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMarker(newMarker);
        // create the container for marker content if there are children
        let contentElement = null;
        if (numChildren > 0) {
            contentElement = document.createElement('div');
            newMarker.content = contentElement;
            setContentContainer(contentElement);
        }
        return ()=>{
            newMarker.map = null;
            contentElement === null || contentElement === void 0 || contentElement.remove();
            setMarker(null);
            setContentContainer(null);
        };
    }, [
        map,
        markerLibrary,
        numChildren
    ]);
    // When no children are present we don't have our own wrapper div
    // which usually gets the user provided className. In this case
    // we set the className directly on the marker.content element that comes
    // with the AdvancedMarker.
    (0, $2NacA.useEffect)(()=>{
        if (!(marker === null || marker === void 0 ? void 0 : marker.content) || !$97e7634fbedd800e$var$isElementNode(marker.content) || numChildren > 0) return;
        marker.content.className = className !== null && className !== void 0 ? className : '';
    }, [
        marker,
        className,
        numChildren
    ]);
    $97e7634fbedd800e$var$useAdvancedMarkerAnchoring(marker, anchorPoint, anchorLeft, anchorTop, numChildren > 0);
    // copy other props
    (0, $ldQFt.u)(marker, 'position', position);
    (0, $ldQFt.u)(marker, 'title', title !== null && title !== void 0 ? title : '');
    (0, $ldQFt.u)(marker, 'zIndex', zIndex);
    (0, $ldQFt.u)(marker, 'collisionBehavior', collisionBehavior);
    // set gmpDraggable from props (when unspecified, it's true if any drag-event
    // callbacks are specified)
    (0, $2NacA.useEffect)(()=>{
        if (!marker) return;
        if (draggable !== undefined) marker.gmpDraggable = draggable;
        else if (onDrag || onDragStart || onDragEnd) marker.gmpDraggable = true;
        else marker.gmpDraggable = false;
    }, [
        marker,
        draggable,
        onDrag,
        onDragEnd,
        onDragStart
    ]);
    // set gmpClickable from props (when unspecified, it's true if any interactive
    // event callbacks are specified)
    (0, $2NacA.useEffect)(()=>{
        if (!marker) return;
        // when clickable is defined, we will always use its value for gmpClickable.
        // otherwise we auto-detect based on existing event-handlers.
        const gmpClickable = clickable !== undefined ? clickable : Boolean(onClick) || Boolean(onKeyDown) || Boolean(onKeyUp) || Boolean(onMouseEnter) || Boolean(onMouseLeave);
        // gmpClickable is only available in beta version of the
        // maps api (as of 2024-10-10)
        marker.gmpClickable = gmpClickable;
        // keep pointer/cursor styles in sync for markers with custom content.
        // Non-clickable custom HTML must disable pointer targeting explicitly so
        // interactions fall through to the map underneath.
        if ((marker === null || marker === void 0 ? void 0 : marker.content) && $97e7634fbedd800e$var$isElementNode(marker.content)) {
            marker.content.style.pointerEvents = gmpClickable ? 'all' : 'none';
            marker.content.style.cursor = gmpClickable && onClick ? 'pointer' : '';
        }
    }, [
        marker,
        clickable,
        onClick,
        onKeyDown,
        onKeyUp,
        onMouseEnter,
        onMouseLeave
    ]);
    $97e7634fbedd800e$var$useMapsEventListener(marker, 'drag', onDrag);
    $97e7634fbedd800e$var$useMapsEventListener(marker, 'dragstart', onDragStart);
    $97e7634fbedd800e$var$useMapsEventListener(marker, 'dragend', onDragEnd);
    (0, $ldQFt.a)(marker, 'gmp-click', onClick);
    (0, $ldQFt.a)(marker, 'keydown', onKeyDown);
    (0, $ldQFt.a)(marker, 'keyup', onKeyUp);
    (0, $ldQFt.a)(marker, 'mouseenter', onMouseEnter);
    (0, $ldQFt.a)(marker, 'mouseleave', onMouseLeave);
    return [
        marker,
        contentContainer
    ];
}
function $97e7634fbedd800e$var$useAdvancedMarkerAnchoring(marker, anchorPoint, anchorLeft, anchorTop, hasChildren) {
    (0, $2NacA.useEffect)(()=>{
        if (!marker || !hasChildren) return;
        // The anchorLeft and anchorTop options are available since version 3.62.9c
        // With the release of 3.65 (~May 2026) there will no longer be a version
        // that doesn't support it.
        const anchorOptionsSupported = $97e7634fbedd800e$var$isVersionGreaterEqual(3, 62);
        const contentElement = marker.content;
        if (!contentElement || !$97e7634fbedd800e$var$isElementNode(contentElement)) return;
        if (anchorLeft !== undefined || anchorTop !== undefined) {
            if (!anchorOptionsSupported) console.warn("AdvancedMarker: The anchorLeft and anchorTop props are only supported in Google Maps API version 3.62 and above. " + `The current version is ${google.maps.version}.`);
            marker.anchorLeft = anchorLeft;
            marker.anchorTop = anchorTop;
            // when anchorLeft and/or anchorTop are set, we'll ignore the anchorPoint
            if (anchorPoint !== undefined) console.warn("AdvancedMarker: the anchorPoint prop is ignored when anchorLeft and/or anchorTop are set.");
            return;
        }
        if (anchorPoint !== undefined) {
            // TODO: add console.warn in a future version to inform about deprecation
            const [x, y] = anchorPoint !== null && anchorPoint !== void 0 ? anchorPoint : $97e7634fbedd800e$export$5a0544ba0e628ca7['BOTTOM'];
            // NOTE: since x and y can be any valid CSS length-percentage
            //   value, we need to use calc() to negate them.
            const translateX = `calc(-1 * ${x})`;
            const translateY = `calc(-1 * ${y})`;
            if (anchorOptionsSupported) {
                // implement anchorPoint using the new anchorLeft and anchorTop options
                marker.anchorLeft = translateX;
                marker.anchorTop = translateY;
                // reset transform from legacy implementation
                contentElement.style.transform = '';
            } else {
                // The "translate(50%, 100%)" counters and resets the default
                // anchoring of the advanced marker element from the api
                contentElement.style.transform = `translate(50%, 100%) translate(${translateX}, ${translateY})`;
                // data-origin is needed to identify the custom marker content in the
                // InfoWindow component as well as in the global CSS used to disable
                // the pointer event when anchor points are used in older Google Maps
                // versions.
                marker.dataset.origin = 'rgm';
                $97e7634fbedd800e$var$globalStyleManager.addAdvancedMarkerPointerEventsOverwrite();
            }
        }
    }, [
        marker,
        anchorPoint,
        anchorLeft,
        anchorTop,
        hasChildren
    ]);
}
// `Object.hasOwn` is ES2022 and tsc does not downlevel built-ins, so it would
// break the ES2015 target. set-value-for-styles.ts uses the same call.
const $97e7634fbedd800e$var$hasOwn = (object, key)=>Object.prototype.hasOwnProperty.call(object, key);
/**
 * The value written to unset an option that is no longer present.
 *
 * Every property of the maps API option types is declared as `T | null`, so
 * `null` is the value the API sanctions for "back to the default". `undefined`
 * only appears via the optional marker and has no documented meaning.
 *
 * @internal
 */ const $97e7634fbedd800e$var$UNSET = null;
/**
 * Returns the options that have to be written to bring an instance from
 * `trackedOptions` to `nextOptions`, or `null` when nothing changed.
 *
 * `trackedOptions` is what the caller believes is currently applied to the
 * instance, not the previous render's props. That distinction is what makes
 * removal work: a key that was applied earlier and is missing from
 * `nextOptions` is explicitly unset rather than silently left behind.
 *
 * The result is always a fresh object, so the caller's tracked state is never
 * handed on to the maps API.
 *
 * @internal
 */ function $97e7634fbedd800e$var$getChangedOptions(nextOptions, trackedOptions) {
    let changedOptions = null;
    const keys = new Set([
        ...Object.keys(trackedOptions),
        ...Object.keys(nextOptions)
    ]);
    for (const key of keys){
        // a key that disappeared has to be written back to the default, and a key
        // that is present counts as changed even when both values read as
        // undefined, since it may never have been applied
        if (!$97e7634fbedd800e$var$hasOwn(nextOptions, key)) {
            changedOptions !== null && changedOptions !== void 0 ? changedOptions : changedOptions = Object.create(null);
            // null is not assignable to an unconstrained T[keyof T]; see UNSET above
            changedOptions[key] = $97e7634fbedd800e$var$UNSET;
            continue;
        }
        if ($97e7634fbedd800e$var$hasOwn(trackedOptions, key) && (0, $ldQFt.q)(trackedOptions[key], nextOptions[key])) continue;
        changedOptions !== null && changedOptions !== void 0 ? changedOptions : changedOptions = Object.create(null);
        changedOptions[key] = nextOptions[key];
    }
    return changedOptions;
}
/**
 * Copies an options object deeply enough that nested values are not aliased by
 * the caller's.
 *
 * A shallow copy shares nested values with the props, so an `icons` array
 * mutated in place is compared against itself and reported unchanged. That only
 * matters once some other option also changes, since `useMemoized` otherwise
 * masks an in-place mutation before the hook runs at all.
 *
 * Plain objects and arrays are copied; anything else, including maps API
 * instances, is kept by reference.
 *
 * @internal
 */ function $97e7634fbedd800e$var$snapshotOptions(value) {
    if (Array.isArray(value)) return value.map((entry)=>$97e7634fbedd800e$var$snapshotOptions(entry));
    if (value === null || typeof value !== 'object') return value;
    // only plain objects, so class instances are not mangled by copying
    const prototype = Object.getPrototypeOf(value);
    if (prototype !== Object.prototype) return value;
    const copy = {};
    for (const key of Object.keys(value))copy[key] = $97e7634fbedd800e$var$snapshotOptions(value[key]);
    return copy;
}
/**
 * The options believed to be applied to each object, keyed weakly so a
 * torn-down maps object is not kept alive and no cleanup is needed.
 */ const $97e7634fbedd800e$var$appliedOptionsByObject = new WeakMap();
/**
 * A drop-in replacement for `object.setOptions(options)` that writes only the
 * values that changed since the last call.
 *
 * `setOptions` is not a cheap setter. It applies every key it is given without
 * comparing against the current value, and on an editable shape each stroke or
 * fill key costs a redraw of the vertex handles, so re-sending an unchanged
 * option bag is measurably expensive on shapes with many vertices. Sending only
 * the changed subset is equivalent, since the API leaves unspecified options
 * untouched.
 *
 * Pass `alreadyApplied` when the object was just created with these options, so
 * they are recorded without being written a second time. The caller has to say
 * so: parent effects run after child effects, so an option can change in the
 * same commit that creates the object, and inferring that the current options
 * were applied would drop that change permanently.
 *
 * An object with nothing recorded is treated as having no options applied and
 * receives the full set, so a forgotten `alreadyApplied` costs a redundant
 * write rather than a missing one.
 *
 * @internal
 */ function $97e7634fbedd800e$var$setMapObjectOptions(object, options, { alreadyApplied: alreadyApplied = false } = {}) {
    var _a;
    if (alreadyApplied) {
        $97e7634fbedd800e$var$appliedOptionsByObject.set(object, $97e7634fbedd800e$var$snapshotOptions(options));
        return;
    }
    const appliedOptions = (_a = $97e7634fbedd800e$var$appliedOptionsByObject.get(object)) !== null && _a !== void 0 ? _a : {};
    const changedOptions = $97e7634fbedd800e$var$getChangedOptions(options, appliedOptions);
    if (!changedOptions) return;
    object.setOptions(changedOptions);
    $97e7634fbedd800e$var$appliedOptionsByObject.set(object, $97e7634fbedd800e$var$snapshotOptions(options));
}
function $97e7634fbedd800e$var$useCircle(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onRadiusChanged: onRadiusChanged, onCenterChanged: onCenterChanged, center: center, defaultCenter: defaultCenter, radius: radius, defaultRadius: defaultRadius } = props, destructuredOptions = (0, $ldQFt._)(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onRadiusChanged",
        "onCenterChanged",
        "center",
        "defaultCenter",
        "radius",
        "defaultRadius"
    ]);
    const [circle, setCircle] = (0, $2NacA.useState)(null);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    // Memoize options with automatic inference of clickable/draggable/editable
    const circleOptions = (0, $ldQFt.r)(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onCenterChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onRadiusChanged)
    }), (0, $ldQFt.q));
    (0, $2NacA.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Circle> has to be inside a Map component.');
            return;
        }
        const newCircle = new google.maps.Circle(Object.assign(Object.assign({}, circleOptions), {
            center: center !== null && center !== void 0 ? center : defaultCenter,
            radius: radius !== null && radius !== void 0 ? radius : defaultRadius
        }));
        // the options above are applied by now, so record them without writing
        $97e7634fbedd800e$var$setMapObjectOptions(newCircle, circleOptions, {
            alreadyApplied: true
        });
        newCircle.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setCircle(newCircle);
        return ()=>{
            newCircle.setMap(null);
            setCircle(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- circle options are handled separately to avoid recreating the instance
    }, [
        map
    ]);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'click', onClick);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'drag', onDrag);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'dragstart', onDragStart);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'dragend', onDragEnd);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'mouseover', onMouseOver);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'mouseout', onMouseOut);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'radius_changed', onRadiusChanged ? ()=>{
        const newRadius = circle === null || circle === void 0 ? void 0 : circle.getRadius();
        if (newRadius !== undefined) onRadiusChanged(newRadius);
    } : null);
    $97e7634fbedd800e$var$useMapsEventListener(circle, 'center_changed', onCenterChanged ? ()=>{
        onCenterChanged(circle === null || circle === void 0 ? void 0 : circle.getCenter());
    } : null);
    (0, $2NacA.useEffect)(()=>{
        if (!circle) return;
        $97e7634fbedd800e$var$setMapObjectOptions(circle, circleOptions);
    }, [
        circle,
        circleOptions
    ]);
    // Sync controlled center prop with the circle instance
    (0, $2NacA.useEffect)(()=>{
        if (!circle || !center) return;
        if (!$97e7634fbedd800e$export$e6f27d7c3c3233eb(center, circle.getCenter())) circle.setCenter(center);
    }, [
        circle,
        center
    ]);
    // Sync controlled radius prop with the circle instance
    (0, $2NacA.useEffect)(()=>{
        if (!circle || radius === undefined) return;
        if (radius !== circle.getRadius()) circle.setRadius(radius);
    }, [
        circle,
        radius
    ]);
    return circle;
}
const $97e7634fbedd800e$export$c89a927ffc67e6fa = (0, $2NacA.forwardRef)((props, ref)=>{
    const circle = $97e7634fbedd800e$var$useCircle(props);
    (0, $2NacA.useImperativeHandle)(ref, ()=>circle, [
        circle
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null);
});
$97e7634fbedd800e$export$c89a927ffc67e6fa.displayName = 'Circle';
/**
 * Component to render an Info Window with the Maps JavaScript API
 */ const $97e7634fbedd800e$export$6cfec3928ae8881a = (props)=>{
    const { children: // content options
    children, headerContent: headerContent, style: style, className: className, pixelOffset: pixelOffset, anchor: // open options
    anchor, shouldFocus: shouldFocus, onClose: // events
    onClose, onCloseClick: onCloseClick } = props, // other options
    volatileInfoWindowOptions = (0, $ldQFt._)(props, [
        "children",
        "headerContent",
        "style",
        "className",
        "pixelOffset",
        "anchor",
        "shouldFocus",
        "onClose",
        "onCloseClick"
    ]);
    // ## create infowindow instance once the mapsLibrary is available.
    const mapsLibrary = (0, $ldQFt.p)('maps');
    const [infoWindow, setInfoWindow] = (0, $2NacA.useState)(null);
    const contentContainerRef = (0, $2NacA.useRef)(null);
    const headerContainerRef = (0, $2NacA.useRef)(null);
    const infoWindowOptions = (0, $ldQFt.r)(volatileInfoWindowOptions, (0, $ldQFt.q));
    // ---- initial mount: create content- and header container, create and
    // configure the InfoWindow instance
    (0, $2NacA.useEffect)(()=>{
        if (!mapsLibrary) return;
        contentContainerRef.current = document.createElement('div');
        headerContainerRef.current = document.createElement('div');
        const opts = Object.assign({}, infoWindowOptions);
        if (pixelOffset) opts.pixelOffset = new google.maps.Size(pixelOffset[0], pixelOffset[1]);
        if (headerContent) // if headerContent is specified as string we can directly forward it,
        // otherwise we'll pass the element the portal will render into
        opts.headerContent = typeof headerContent === 'string' ? headerContent : headerContainerRef.current;
        // intentionally shadowing the state variables here
        const infoWindow = new google.maps.InfoWindow(opts);
        infoWindow.setContent(contentContainerRef.current);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setInfoWindow(infoWindow);
        // unmount: remove infoWindow and content elements (note: close is called in a different effect-cleanup)
        return ()=>{
            var _a, _b;
            infoWindow.setContent(null);
            (_a = contentContainerRef.current) === null || _a === void 0 || _a.remove();
            (_b = headerContainerRef.current) === null || _b === void 0 || _b.remove();
            contentContainerRef.current = null;
            headerContainerRef.current = null;
            setInfoWindow(null);
        };
    }, // `infoWindowOptions` and other props are missing from dependencies:
    //
    // We don't want to re-create the infowindow instance
    // when the options change.
    // Updating the options is handled in the useEffect below.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mapsLibrary
    ]);
    // ---- update className and styles for `contentContainer`
    // prevStyleRef stores previously applied style properties, so they can be
    // removed when unset
    const prevStyleRef = (0, $2NacA.useRef)(null);
    (0, $2NacA.useLayoutEffect)(()=>{
        if (!infoWindow || !contentContainerRef.current) return;
        (0, $ldQFt.s)(contentContainerRef.current, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
        if (className !== contentContainerRef.current.className) contentContainerRef.current.className = className || '';
    }, [
        infoWindow,
        className,
        style
    ]);
    // ---- update options
    (0, $2NacA.useEffect)(()=>{
        if (!infoWindow) return;
        const opts = Object.assign({}, infoWindowOptions);
        if (!pixelOffset) opts.pixelOffset = null;
        else opts.pixelOffset = new google.maps.Size(pixelOffset[0], pixelOffset[1]);
        if (!headerContent) opts.headerContent = null;
        else opts.headerContent = typeof headerContent === 'string' ? headerContent : headerContainerRef.current;
        infoWindow.setOptions(opts);
    }, // dependency `infoWindow` isn't needed since options are also passed
    // to the constructor when a new infoWindow is created.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        infoWindowOptions,
        pixelOffset,
        headerContent
    ]);
    // ---- bind event handlers
    $97e7634fbedd800e$var$useMapsEventListener(infoWindow, 'close', onClose);
    $97e7634fbedd800e$var$useMapsEventListener(infoWindow, 'closeclick', onCloseClick);
    // ---- open info window when content and map are available
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    (0, $2NacA.useEffect)(()=>{
        var _a;
        // `anchor === null` means an anchor is defined but not ready yet.
        if (!map || !infoWindow || anchor === null) return;
        const isOpenedWithAnchor = !!anchor;
        const openOptions = {
            map: map
        };
        if (anchor) {
            openOptions.anchor = anchor;
            // Only do the infowindow adjusting when dealing with an AdvancedMarker
            if ($97e7634fbedd800e$export$5f1640ccc146ea2d(anchor) && anchor.content instanceof Element) {
                const anchorBcr = anchor === null || anchor === void 0 ? void 0 : anchor.getBoundingClientRect();
                // This checks whether or not the anchor has custom content with our own
                // div wrapper. If not, that means we have a regular AdvancedMarker without
                // children, or an AdvancedMarker that uses the anchorLeft/anchorTop props.
                // In that case we do not want to adjust the infowindow since it is all handled correctly
                // by the Google Maps API.
                if (anchorBcr && anchor.dataset.origin === 'rgm') {
                    // We can safely typecast here since we control that element and we know that
                    // it is a div
                    const anchorDomContent = (_a = anchor.content.firstElementChild) === null || _a === void 0 ? void 0 : _a.firstElementChild;
                    const contentBcr = anchorDomContent === null || anchorDomContent === void 0 ? void 0 : anchorDomContent.getBoundingClientRect();
                    // center infowindow above marker
                    const anchorOffsetX = contentBcr.x - anchorBcr.x + (contentBcr.width - anchorBcr.width) / 2;
                    const anchorOffsetY = contentBcr.y - anchorBcr.y;
                    const opts = Object.assign({}, infoWindowOptions);
                    opts.pixelOffset = new google.maps.Size(pixelOffset ? pixelOffset[0] + anchorOffsetX : anchorOffsetX, pixelOffset ? pixelOffset[1] + anchorOffsetY : anchorOffsetY);
                    infoWindow.setOptions(opts);
                }
            }
        }
        if (shouldFocus !== undefined) openOptions.shouldFocus = shouldFocus;
        infoWindow.open(openOptions);
        return ()=>{
            // Note: when the infowindow has an anchor, it will automatically show up again when the
            // anchor was removed from the map before infoWindow.close() is called but the it gets
            // added back to the map after that.
            // More information here: https://issuetracker.google.com/issues/343750849
            if (isOpenedWithAnchor) infoWindow.set('anchor', null);
            infoWindow.close();
        };
    }, [
        infoWindow,
        anchor,
        map,
        shouldFocus,
        infoWindowOptions,
        pixelOffset
    ]);
    /* eslint-disable react-hooks/refs -- intentional access to refs during render to avoid cascading renders when creating portals */ return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, contentContainerRef.current && (0, $l6sdi.createPortal)(children, contentContainerRef.current), headerContainerRef.current !== null && (0, $l6sdi.createPortal)(headerContent, headerContainerRef.current));
/* eslint-enable react-hooks/refs */ };
/**
 * Extracts paths as a nested array from a Polygon instance.
 */ function $97e7634fbedd800e$var$getPathsArray(polygon) {
    const mvcPaths = polygon.getPaths();
    const result = [];
    for(let i = 0; i < mvcPaths.getLength(); i++)result.push(mvcPaths.getAt(i).getArray());
    return result;
}
function $97e7634fbedd800e$var$usePolygon(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onPathsChanged: onPathsChanged, polygon: externalPolygon, encodedPaths: encodedPaths, paths: paths, defaultPaths: defaultPaths } = props, destructuredOptions = (0, $ldQFt._)(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onPathsChanged",
        "polygon",
        "encodedPaths",
        "paths",
        "defaultPaths"
    ]);
    const [polygon, setPolygon] = (0, $2NacA.useState)(null);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    const geometryLibrary = (0, $ldQFt.p)('geometry');
    // Track if we're programmatically updating to avoid firing onPathsChanged
    const isUpdatingRef = (0, $2NacA.useRef)(false);
    // Memoize options with automatic inference of clickable/draggable/editable
    const polygonOptions = (0, $ldQFt.r)(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onPathsChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onPathsChanged)
    }), (0, $ldQFt.q));
    (0, $2NacA.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Polygon> has to be inside a Map component.');
            return;
        }
        // Use provided instance or create a new one
        let instance;
        if (externalPolygon) {
            instance = externalPolygon;
            // Apply initial paths and options to the existing instance
            const initialPaths = paths !== null && paths !== void 0 ? paths : defaultPaths;
            if (initialPaths && Array.isArray(initialPaths)) instance.setPaths(initialPaths);
            instance.setOptions(polygonOptions);
        } else {
            const initialPaths = paths !== null && paths !== void 0 ? paths : defaultPaths;
            const polygonOptionsWithPaths = Object.assign({}, polygonOptions);
            // Google Maps throws "not an Array" error if paths is undefined
            if (initialPaths && Array.isArray(initialPaths)) polygonOptionsWithPaths.paths = initialPaths;
            instance = new google.maps.Polygon(polygonOptionsWithPaths);
        }
        // the options above are applied by now, so record them without writing
        $97e7634fbedd800e$var$setMapObjectOptions(instance, polygonOptions, {
            alreadyApplied: true
        });
        instance.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setPolygon(instance);
        return ()=>{
            instance.setMap(null);
            setPolygon(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options are handled separately to avoid recreating the instance
    }, [
        map,
        externalPolygon
    ]);
    $97e7634fbedd800e$var$useMapsEventListener(polygon, 'click', onClick);
    $97e7634fbedd800e$var$useMapsEventListener(polygon, 'drag', onDrag);
    $97e7634fbedd800e$var$useMapsEventListener(polygon, 'dragstart', onDragStart);
    $97e7634fbedd800e$var$useMapsEventListener(polygon, 'mouseover', onMouseOver);
    $97e7634fbedd800e$var$useMapsEventListener(polygon, 'mouseout', onMouseOut);
    // Fire onPathsChanged on dragend (when whole polygon is dragged)
    $97e7634fbedd800e$var$useMapsEventListener(polygon, 'dragend', (e)=>{
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(e);
        if (onPathsChanged && polygon && !isUpdatingRef.current) onPathsChanged($97e7634fbedd800e$var$getPathsArray(polygon));
    });
    // Subscribe to MVCArray events for vertex-level edits
    (0, $2NacA.useEffect)(()=>{
        if (!polygon || !onPathsChanged) return;
        const listeners = [];
        const mvcPaths = polygon.getPaths();
        if (typeof mvcPaths.getLength !== 'function' || typeof mvcPaths.getAt !== 'function') return;
        const handlePathsChange = ()=>{
            if (!isUpdatingRef.current) onPathsChanged($97e7634fbedd800e$var$getPathsArray(polygon));
        };
        // Subscribe to each inner path's events
        const subscribeToInnerPath = (innerPath)=>{
            listeners.push(google.maps.event.addListener(innerPath, 'insert_at', handlePathsChange));
            listeners.push(google.maps.event.addListener(innerPath, 'remove_at', handlePathsChange));
            listeners.push(google.maps.event.addListener(innerPath, 'set_at', handlePathsChange));
        };
        // Subscribe to existing inner paths
        for(let i = 0; i < mvcPaths.getLength(); i++)subscribeToInnerPath(mvcPaths.getAt(i));
        // Subscribe to outer array changes (paths added/removed)
        listeners.push(google.maps.event.addListener(mvcPaths, 'insert_at', (index)=>{
            subscribeToInnerPath(mvcPaths.getAt(index));
            handlePathsChange();
        }));
        listeners.push(google.maps.event.addListener(mvcPaths, 'set_at', (index)=>{
            subscribeToInnerPath(mvcPaths.getAt(index));
            handlePathsChange();
        }));
        listeners.push(google.maps.event.addListener(mvcPaths, 'remove_at', handlePathsChange));
        return ()=>{
            listeners.forEach((listener)=>listener.remove());
        };
    }, [
        polygon,
        onPathsChanged,
        paths,
        encodedPaths,
        polygonOptions.editable,
        polygonOptions.draggable
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!polygon) return;
        $97e7634fbedd800e$var$setMapObjectOptions(polygon, polygonOptions);
    }, [
        polygon,
        polygonOptions
    ]);
    // Sync controlled paths prop with the polygon instance
    (0, $2NacA.useEffect)(()=>{
        if (!polygon || !paths) return;
        if (!Array.isArray(paths)) return;
        // Normalize to nested array for comparison
        const firstPath = paths[0];
        const normalizedPaths = Array.isArray(firstPath) ? paths : [
            paths
        ];
        const currentPaths = polygon.getPaths();
        if (!$97e7634fbedd800e$export$81bf7c9065d0b5e1(normalizedPaths, currentPaths)) {
            isUpdatingRef.current = true;
            polygon.setPaths(paths);
            isUpdatingRef.current = false;
        }
    }, [
        polygon,
        paths
    ]);
    // Handle encoded paths
    (0, $2NacA.useEffect)(()=>{
        if (!polygon || !encodedPaths || !geometryLibrary) return;
        isUpdatingRef.current = true;
        const decodedPaths = encodedPaths.map((encodedPath)=>geometryLibrary.encoding.decodePath(encodedPath));
        polygon.setPaths(decodedPaths);
        isUpdatingRef.current = false;
    }, [
        polygon,
        encodedPaths,
        geometryLibrary
    ]);
    return polygon;
}
const $97e7634fbedd800e$export$7d31b617c820d435 = (0, $2NacA.forwardRef)((props, ref)=>{
    const polygon = $97e7634fbedd800e$var$usePolygon(props);
    (0, $2NacA.useImperativeHandle)(ref, ()=>polygon, [
        polygon
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null);
});
$97e7634fbedd800e$export$7d31b617c820d435.displayName = 'Polygon';
function $97e7634fbedd800e$var$usePolyline(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onPathChanged: onPathChanged, polyline: externalPolyline, encodedPath: encodedPath, path: path, defaultPath: defaultPath } = props, destructuredOptions = (0, $ldQFt._)(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onPathChanged",
        "polyline",
        "encodedPath",
        "path",
        "defaultPath"
    ]);
    const [polyline, setPolyline] = (0, $2NacA.useState)(null);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    const geometryLibrary = (0, $ldQFt.p)('geometry');
    // Track if we're programmatically updating to avoid firing onPathChanged
    const isUpdatingRef = (0, $2NacA.useRef)(false);
    // Memoize options with automatic inference of clickable/draggable/editable
    const polylineOptions = (0, $ldQFt.r)(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onPathChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onPathChanged)
    }), (0, $ldQFt.q));
    (0, $2NacA.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Polyline> has to be inside a Map component.');
            return;
        }
        // Use provided instance or create a new one
        let instance;
        if (externalPolyline) {
            instance = externalPolyline;
            // Apply initial path and options to the existing instance
            const initialPath = path !== null && path !== void 0 ? path : defaultPath;
            if (initialPath && Array.isArray(initialPath)) instance.setPath(initialPath);
            instance.setOptions(polylineOptions);
        } else {
            const initialPath = path !== null && path !== void 0 ? path : defaultPath;
            const polylineOptionsWithPath = Object.assign({}, polylineOptions);
            // Google Maps throws "not an Array" error if path is undefined
            if (initialPath && Array.isArray(initialPath)) polylineOptionsWithPath.path = initialPath;
            instance = new google.maps.Polyline(polylineOptionsWithPath);
        }
        // the options above are applied by now, so record them without writing
        $97e7634fbedd800e$var$setMapObjectOptions(instance, polylineOptions, {
            alreadyApplied: true
        });
        instance.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setPolyline(instance);
        return ()=>{
            instance.setMap(null);
            setPolyline(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options are handled separately to avoid recreating the instance
    }, [
        map,
        externalPolyline
    ]);
    $97e7634fbedd800e$var$useMapsEventListener(polyline, 'click', onClick);
    $97e7634fbedd800e$var$useMapsEventListener(polyline, 'drag', onDrag);
    $97e7634fbedd800e$var$useMapsEventListener(polyline, 'dragstart', onDragStart);
    $97e7634fbedd800e$var$useMapsEventListener(polyline, 'mouseover', onMouseOver);
    $97e7634fbedd800e$var$useMapsEventListener(polyline, 'mouseout', onMouseOut);
    // Fire onPathChanged on dragend (when whole polyline is dragged)
    $97e7634fbedd800e$var$useMapsEventListener(polyline, 'dragend', (e)=>{
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(e);
        if (onPathChanged && polyline && !isUpdatingRef.current) onPathChanged(polyline.getPath().getArray());
    });
    // Subscribe to MVCArray events for vertex-level edits
    (0, $2NacA.useEffect)(()=>{
        if (!polyline || !onPathChanged) return;
        const mvcPath = polyline.getPath();
        if (!mvcPath) return;
        const handlePathChange = ()=>{
            if (!isUpdatingRef.current) onPathChanged(mvcPath.getArray());
        };
        const listeners = [
            google.maps.event.addListener(mvcPath, 'insert_at', handlePathChange),
            google.maps.event.addListener(mvcPath, 'remove_at', handlePathChange),
            google.maps.event.addListener(mvcPath, 'set_at', handlePathChange)
        ];
        return ()=>{
            listeners.forEach((listener)=>listener.remove());
        };
    }, [
        polyline,
        onPathChanged,
        path,
        encodedPath,
        polylineOptions.editable,
        polylineOptions.draggable
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!polyline) return;
        $97e7634fbedd800e$var$setMapObjectOptions(polyline, polylineOptions);
    }, [
        polyline,
        polylineOptions
    ]);
    // Sync controlled path prop with the polyline instance
    (0, $2NacA.useEffect)(()=>{
        if (!polyline || !path) return;
        const currentPath = polyline.getPath();
        if (!$97e7634fbedd800e$export$69485f8143efb551(path, currentPath)) {
            isUpdatingRef.current = true;
            polyline.setPath(path);
            isUpdatingRef.current = false;
        }
    }, [
        polyline,
        path
    ]);
    // Handle encoded path
    (0, $2NacA.useEffect)(()=>{
        if (!polyline || !encodedPath || !geometryLibrary) return;
        isUpdatingRef.current = true;
        const decodedPath = geometryLibrary.encoding.decodePath(encodedPath);
        polyline.setPath(decodedPath);
        isUpdatingRef.current = false;
    }, [
        polyline,
        encodedPath,
        geometryLibrary
    ]);
    return polyline;
}
const $97e7634fbedd800e$export$79f3ee03e63e7073 = (0, $2NacA.forwardRef)((props, ref)=>{
    const polyline = $97e7634fbedd800e$var$usePolyline(props);
    (0, $2NacA.useImperativeHandle)(ref, ()=>polyline, [
        polyline
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null);
});
$97e7634fbedd800e$export$79f3ee03e63e7073.displayName = 'Polyline';
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$9ac34b33b94379d1 = (0, $ldQFt.G);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$b4118d11ca82abca = (0, $ldQFt.b);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$e9000d5af15800a8 = (0, $ldQFt.M);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$39cf3280165f92aa = (0, $ldQFt.c);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$9fe96214cc610e48 = (0, $ldQFt.d);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$f2451a5061be5eec = (0, $ldQFt.e);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$77f6962a5c3dbd02 = (0, $ldQFt.g);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$5b6b19405a83ff9d = (0, $ldQFt.P);
/**
 * @deprecated Import from `@vis.gl/react-google-maps/3d` instead.
 */ const $97e7634fbedd800e$export$e9723f028e220f29 = (0, $ldQFt.f);
/**
 * Copy of the `google.maps.ControlPosition` constants.
 * They have to be duplicated here since we can't wait for the maps API to load to be able to use them.
 */ const $97e7634fbedd800e$export$90e210fd0946c45e = {
    TOP_LEFT: 1,
    TOP_CENTER: 2,
    TOP: 2,
    TOP_RIGHT: 3,
    LEFT_CENTER: 4,
    LEFT_TOP: 5,
    LEFT: 5,
    LEFT_BOTTOM: 6,
    RIGHT_TOP: 7,
    RIGHT: 7,
    RIGHT_CENTER: 8,
    RIGHT_BOTTOM: 9,
    BOTTOM_LEFT: 10,
    BOTTOM_CENTER: 11,
    BOTTOM: 11,
    BOTTOM_RIGHT: 12,
    CENTER: 13,
    BLOCK_START_INLINE_START: 14,
    BLOCK_START_INLINE_CENTER: 15,
    BLOCK_START_INLINE_END: 16,
    INLINE_START_BLOCK_CENTER: 17,
    INLINE_START_BLOCK_START: 18,
    INLINE_START_BLOCK_END: 19,
    INLINE_END_BLOCK_START: 20,
    INLINE_END_BLOCK_CENTER: 21,
    INLINE_END_BLOCK_END: 22,
    BLOCK_END_INLINE_START: 23,
    BLOCK_END_INLINE_CENTER: 24,
    BLOCK_END_INLINE_END: 25
};
const $97e7634fbedd800e$export$68000b548d3309a0 = ({ children: children, position: position, className: className, style: style })=>{
    const controlContainer = (0, $2NacA.useMemo)(()=>document.createElement('div'), []);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    // ---- update className and styles for `controlContainer`
    // prevStyleRef stores previously applied style properties, so they can be
    // removed when unset
    const prevStyleRef = (0, $2NacA.useRef)(null);
    // eslint-disable-next-line react-hooks/immutability -- the control container DOM node is intentionally mutated from effects
    (0, $2NacA.useLayoutEffect)(()=>{
        (0, $ldQFt.s)(controlContainer, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
        // eslint-disable-next-line react-hooks/immutability -- see above
        controlContainer.className = className !== null && className !== void 0 ? className : '';
    }, [
        controlContainer,
        className,
        style
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!map) return;
        const controls = map.controls[position];
        controls.push(controlContainer);
        return ()=>{
            const controlsArray = controls.getArray();
            // controlsArray could be undefined if the map is in an undefined state (e.g. invalid API-key, see #276
            if (!controlsArray) return;
            const index = controlsArray.indexOf(controlContainer);
            controls.removeAt(index);
        };
    }, [
        controlContainer,
        map,
        position
    ]);
    return (0, $l6sdi.createPortal)(children, controlContainer);
};
function $97e7634fbedd800e$var$useMarker(props) {
    const [marker, setMarker] = (0, $2NacA.useState)(null);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut } = props, markerOptions = (0, $ldQFt._)(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut"
    ]);
    const { position: position, draggable: draggable } = markerOptions;
    // create marker instance and add to the map once the map is available
    (0, $2NacA.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Marker> has to be inside a Map component.');
            return;
        }
        const newMarker = new google.maps.Marker(markerOptions);
        newMarker.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMarker(newMarker);
        return ()=>{
            newMarker.setMap(null);
            setMarker(null);
        };
    // We do not want to re-render the whole marker when the options change.
    // Marker options update is handled in a useEffect below.
    // Excluding markerOptions from dependency array on purpose here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        map
    ]);
    // attach and re-attach event-handlers when any of the properties change
    (0, $2NacA.useEffect)(()=>{
        if (!marker) return;
        const m = marker;
        // Add event listeners
        const gme = google.maps.event;
        if (onClick) gme.addListener(m, 'click', onClick);
        if (onDrag) gme.addListener(m, 'drag', onDrag);
        if (onDragStart) gme.addListener(m, 'dragstart', onDragStart);
        if (onDragEnd) gme.addListener(m, 'dragend', onDragEnd);
        if (onMouseOver) gme.addListener(m, 'mouseover', onMouseOver);
        if (onMouseOut) gme.addListener(m, 'mouseout', onMouseOut);
        marker.setDraggable(Boolean(draggable));
        return ()=>{
            gme.clearInstanceListeners(m);
        };
    }, [
        marker,
        draggable,
        onClick,
        onDrag,
        onDragStart,
        onDragEnd,
        onMouseOver,
        onMouseOut
    ]);
    // update markerOptions (note the dependencies aren't properly checked
    // here, we just assume that setOptions is smart enough to not waste a
    // lot of time updating values that didn't change)
    (0, $2NacA.useEffect)(()=>{
        if (!marker) return;
        if (markerOptions) marker.setOptions(markerOptions);
    }, [
        marker,
        markerOptions
    ]);
    // update position when changed
    (0, $2NacA.useEffect)(()=>{
        // Should not update position when draggable
        if (draggable || !position || !marker) return;
        marker.setPosition(position);
    }, [
        draggable,
        position,
        marker
    ]);
    return marker;
}
/**
 * Component to render a marker on a map
 */ const $97e7634fbedd800e$export$e98856a975cab58e = (0, $2NacA.forwardRef)((props, ref)=>{
    const marker = $97e7634fbedd800e$var$useMarker(props);
    (0, $2NacA.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null);
});
$97e7634fbedd800e$export$e98856a975cab58e.displayName = 'Marker';
function $97e7634fbedd800e$export$89f3a749231786c6() {
    const [marker, setMarker] = (0, $2NacA.useState)(null);
    const refCallback = (0, $2NacA.useCallback)((m)=>{
        setMarker(m);
    }, []);
    return [
        refCallback,
        marker
    ];
}
/**
 * Legacy implementation of Pin component for Maps API < 3.62
 * Component to configure the appearance of an AdvancedMarker or Marker3D
 */ const $97e7634fbedd800e$var$PinLegacy = (props)=>{
    const advancedMarkerContext = (0, $2NacA.useContext)($97e7634fbedd800e$export$14de7bb7593cd5bc);
    const marker3dContext = (0, $2NacA.useContext)((0, $ldQFt.e));
    const advancedMarker = advancedMarkerContext === null || advancedMarkerContext === void 0 ? void 0 : advancedMarkerContext.marker;
    const marker3d = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.marker;
    const setContentHandledExternally = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.setContentHandledExternally;
    const glyphContainer = (0, $2NacA.useMemo)(()=>document.createElement('div'), []);
    // Load marker library for Marker3D case (AdvancedMarker already has it loaded)
    const markerLibrary = (0, $ldQFt.p)('marker');
    // Signal to Marker3D that we're handling content
    (0, $2NacA.useEffect)(()=>{
        if (marker3d && setContentHandledExternally) {
            setContentHandledExternally(true);
            return ()=>setContentHandledExternally(false);
        }
    }, [
        marker3d,
        setContentHandledExternally
    ]);
    // Handle Marker3D case - append PinElement directly
    (0, $2NacA.useEffect)(()=>{
        if (!marker3d || !markerLibrary) return;
        const pinViewOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinViewOptions);
        // Set glyph to glyph container if children are present
        if (props.children) pinElement.glyph = glyphContainer;
        // Append PinElement directly to Marker3D (not in a template)
        // PinElement is a special element that Marker3D can handle natively
        while(marker3d.firstChild)marker3d.removeChild(marker3d.firstChild);
        marker3d.append(pinElement);
        return ()=>{
        // Cleanup handled by marker3d removal
        };
    }, [
        marker3d,
        markerLibrary,
        glyphContainer,
        props
    ]);
    // Create Pin View instance for AdvancedMarker
    (0, $2NacA.useEffect)(()=>{
        var _a;
        // Skip if we're in Marker3D context
        if (marker3d) return;
        if (!advancedMarker) {
            if (advancedMarker === undefined && marker3d === undefined) console.error('The <Pin> component can only be used inside <AdvancedMarker> or <Marker3D>.');
            return;
        }
        if (props.glyph && props.children) (0, $ldQFt.n)('The <Pin> component only uses children to render the glyph if both the glyph property and children are present.');
        if ((0, $2NacA.Children).count(props.children) > 1) (0, $ldQFt.n)('Passing multiple children to the <Pin> component might lead to unexpected results.');
        const pinViewOptions = Object.assign({}, props);
        const pinElement = new google.maps.marker.PinElement(pinViewOptions);
        // Set glyph to glyph container if children are present (rendered via portal).
        // If both props.glyph and props.children are present, props.children takes priority.
        if (props.children) pinElement.glyph = glyphContainer;
        // Set content of Advanced Marker View to the Pin View element
        // Here we are selecting the anchor container.
        // The hierarchy is as follows:
        // "advancedMarker.content" (from google) -> "anchor container"
        const markerContent = (_a = advancedMarker.content) === null || _a === void 0 ? void 0 : _a.firstChild;
        while(markerContent === null || markerContent === void 0 ? void 0 : markerContent.firstChild)markerContent.removeChild(markerContent.firstChild);
        if (markerContent) markerContent.appendChild(pinElement.element);
    }, [
        advancedMarker,
        glyphContainer,
        marker3d,
        props
    ]);
    return (0, $l6sdi.createPortal)(props.children, glyphContainer);
};
/**
 * Modern implementation of Pin component for Maps API >= 3.62
 * Uses the new custom element API with glyphSrc/glyphText properties
 * Component to configure the appearance of an AdvancedMarker or Marker3D
 */ const $97e7634fbedd800e$var$PinModern = (props)=>{
    const { children: children } = props;
    const advancedMarkerContext = (0, $2NacA.useContext)($97e7634fbedd800e$export$14de7bb7593cd5bc);
    const marker3dContext = (0, $2NacA.useContext)((0, $ldQFt.e));
    const advancedMarker = advancedMarkerContext === null || advancedMarkerContext === void 0 ? void 0 : advancedMarkerContext.marker;
    const marker3d = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.marker;
    const setContentHandledExternally = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.setContentHandledExternally;
    const glyphContainer = (0, $2NacA.useMemo)(()=>document.createElement('div'), []);
    const markerLibrary = (0, $ldQFt.p)('marker');
    // Signal to Marker3D that we're handling content
    (0, $2NacA.useEffect)(()=>{
        if (marker3d && setContentHandledExternally) {
            setContentHandledExternally(true);
            return ()=>setContentHandledExternally(false);
        }
    }, [
        marker3d,
        setContentHandledExternally
    ]);
    // Handle Marker3D case
    (0, $2NacA.useEffect)(()=>{
        if (!marker3d || !markerLibrary) return;
        const pinOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinOptions);
        // Children still rendered via portal into a container
        if (children) // In modern API, DOM children of PinElement serve as glyph
        pinElement.appendChild(glyphContainer);
        // Append PinElement directly (not .element - that's deprecated)
        while(marker3d.firstChild)marker3d.removeChild(marker3d.firstChild);
        marker3d.appendChild(pinElement);
        return ()=>{
        // Cleanup handled by marker3d removal
        };
    }, [
        marker3d,
        markerLibrary,
        glyphContainer,
        children,
        props
    ]);
    // Handle AdvancedMarker case
    (0, $2NacA.useEffect)(()=>{
        var _a;
        if (marker3d) return; // Skip if in Marker3D context
        if (!advancedMarker || !markerLibrary) {
            if (advancedMarker === undefined && marker3d === undefined) console.error('The <Pin> component can only be used inside <AdvancedMarker> or <Marker3D>.');
            return;
        }
        if ((props.glyphSrc || props.glyphText) && children) (0, $ldQFt.n)('The <Pin> component only uses children to render the glyph if both glyphSrc/glyphText and children are present.');
        if ((0, $2NacA.Children).count(children) > 1) (0, $ldQFt.n)('Passing multiple children to the <Pin> component might lead to unexpected results.');
        const pinOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinOptions);
        // Children rendered via portal into container
        if (children) pinElement.appendChild(glyphContainer);
        const markerContent = (_a = advancedMarker.content) === null || _a === void 0 ? void 0 : _a.firstChild;
        while(markerContent === null || markerContent === void 0 ? void 0 : markerContent.firstChild)markerContent.removeChild(markerContent.firstChild);
        if (markerContent) // In modern API, append PinElement directly (not .element)
        markerContent.appendChild(pinElement);
    }, [
        advancedMarker,
        markerLibrary,
        glyphContainer,
        marker3d,
        children,
        props
    ]);
    return (0, $l6sdi.createPortal)(children, glyphContainer);
};
/**
 * Component to configure the appearance of an AdvancedMarker or Marker3D.
 *
 * Automatically detects the Maps API version and uses the appropriate implementation:
 * - Legacy implementation (< 3.62): Uses the original PinElement API with glyph property
 * - Modern implementation (≥ 3.62): Uses the new custom element API with glyphSrc/glyphText
 *
 * @example
 * ```tsx
 * // Basic usage
 * <AdvancedMarker position={{lat: 0, lng: 0}}>
 *   <Pin background="#FF0000" glyphColor="#FFFFFF" />
 * </AdvancedMarker>
 *
 * // With custom glyph (legacy)
 * <Pin glyph="📍" />
 *
 * // With custom glyph (modern, recommended for Maps API 3.62+)
 * <Pin glyphText="📍" />
 * <Pin glyphSrc="https://example.com/icon.png" />
 *
 * // With React children as glyph
 * <Pin>
 *   <CustomIcon />
 * </Pin>
 * ```
 */ const $97e7634fbedd800e$export$656559010049c8e = (props)=>{
    var _a;
    const markerLibrary = (0, $ldQFt.p)('marker');
    // Detect capability after the marker library is loaded
    const isModern = (0, $2NacA.useMemo)(()=>{
        if (!markerLibrary) return false;
        // Check if <gmp-pin> custom element exists
        // This happens while loading the marker library in Maps API 3.62+
        return typeof customElements !== 'undefined' && customElements.get('gmp-pin') !== undefined;
    }, [
        markerLibrary
    ]);
    // Wait for marker library to load before rendering
    if (!markerLibrary) return null;
    // Map props based on which implementation we're using
    if (isModern) {
        // Modern: map old glyph prop to new glyphSrc/glyphText
        const { glyph: glyph, glyphSrc: glyphSrc, glyphText: glyphText } = props, restProps = (0, $ldQFt._)(props, [
            "glyph",
            "glyphSrc",
            "glyphText"
        ]);
        const isUrl = glyph instanceof URL || typeof glyph === 'string' && glyph.startsWith('http');
        const finalGlyphText = glyphText !== null && glyphText !== void 0 ? glyphText : typeof glyph === 'string' && !isUrl ? glyph : undefined;
        const finalGlyphSrc = glyphSrc !== null && glyphSrc !== void 0 ? glyphSrc : isUrl ? String(glyph) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($97e7634fbedd800e$var$PinModern, Object.assign({}, restProps, {
            glyphText: finalGlyphText,
            glyphSrc: finalGlyphSrc
        }));
    } else {
        // Legacy: map new glyphSrc/glyphText to old glyph prop
        const { glyph: glyph, glyphSrc: glyphSrc, glyphText: glyphText } = props, restProps = (0, $ldQFt._)(props, [
            "glyph",
            "glyphSrc",
            "glyphText"
        ]);
        const finalGlyph = (_a = glyph !== null && glyph !== void 0 ? glyph : glyphSrc) !== null && _a !== void 0 ? _a : glyphText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($97e7634fbedd800e$var$PinLegacy, Object.assign({}, restProps, {
            glyph: finalGlyph
        }));
    }
};
function $97e7634fbedd800e$var$useRectangle(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onBoundsChanged: onBoundsChanged, bounds: bounds, defaultBounds: defaultBounds } = props, destructuredOptions = (0, $ldQFt._)(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onBoundsChanged",
        "bounds",
        "defaultBounds"
    ]);
    const [rectangle, setRectangle] = (0, $2NacA.useState)(null);
    const map = $97e7634fbedd800e$export$86f8f9f08863e403();
    // Memoize options with automatic inference of clickable/draggable/editable
    const rectangleOptions = (0, $ldQFt.r)(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onBoundsChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onBoundsChanged)
    }), (0, $ldQFt.q));
    (0, $2NacA.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Rectangle> has to be inside a Map component.');
            return;
        }
        const newRectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, rectangleOptions), {
            bounds: bounds !== null && bounds !== void 0 ? bounds : defaultBounds
        }));
        // the options above are applied by now, so record them without writing
        $97e7634fbedd800e$var$setMapObjectOptions(newRectangle, rectangleOptions, {
            alreadyApplied: true
        });
        newRectangle.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setRectangle(newRectangle);
        return ()=>{
            newRectangle.setMap(null);
            setRectangle(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- rectangle options are handled separately to avoid recreating the instance
    }, [
        map
    ]);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'click', onClick);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'drag', onDrag);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'dragstart', onDragStart);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'dragend', onDragEnd);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'mouseover', onMouseOver);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'mouseout', onMouseOut);
    $97e7634fbedd800e$var$useMapsEventListener(rectangle, 'bounds_changed', onBoundsChanged ? ()=>{
        onBoundsChanged(rectangle === null || rectangle === void 0 ? void 0 : rectangle.getBounds());
    } : null);
    (0, $2NacA.useEffect)(()=>{
        if (!rectangle) return;
        $97e7634fbedd800e$var$setMapObjectOptions(rectangle, rectangleOptions);
    }, [
        rectangle,
        rectangleOptions
    ]);
    // Sync controlled bounds prop with the rectangle instance
    (0, $2NacA.useEffect)(()=>{
        if (!rectangle || !bounds) return;
        if (!$97e7634fbedd800e$export$c0cfaae65aded47(bounds, rectangle.getBounds())) rectangle.setBounds(bounds);
    }, [
        rectangle,
        bounds
    ]);
    return rectangle;
}
const $97e7634fbedd800e$export$4617fb02663045ef = (0, $2NacA.forwardRef)((props, ref)=>{
    const rectangle = $97e7634fbedd800e$var$useRectangle(props);
    (0, $2NacA.useImperativeHandle)(ref, ()=>rectangle, [
        rectangle
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null);
});
$97e7634fbedd800e$export$4617fb02663045ef.displayName = 'Rectangle';
const $97e7634fbedd800e$var$mapLinear = (x, a1, a2, b1, b2)=>b1 + (x - a1) * (b2 - b1) / (a2 - a1);
const $97e7634fbedd800e$var$getMapMaxTilt = (zoom)=>{
    if (zoom <= 10) return 30;
    if (zoom >= 15.5) return 67.5;
    // range [10...14]
    if (zoom <= 14) return $97e7634fbedd800e$var$mapLinear(zoom, 10, 14, 30, 45);
    // range [14...15.5]
    return $97e7634fbedd800e$var$mapLinear(zoom, 14, 15.5, 45, 67.5);
};
/**
 * Function to limit the tilt range of the Google map when updating the view state
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $97e7634fbedd800e$export$2849c0466f0d3b14 = ({ viewState: viewState })=>{
    const pitch = viewState.pitch;
    const gmZoom = viewState.zoom + 1;
    const maxTilt = $97e7634fbedd800e$var$getMapMaxTilt(gmZoom);
    return Object.assign(Object.assign({}, viewState), {
        fovy: 25,
        pitch: Math.min(maxTilt, pitch)
    });
};

});
parcelRegister("ldQFt", function(module, exports) {

$parcel$export(module.exports, "u", () => $c56dee3c9018e2ad$export$3b14a55fb2447963);
$parcel$export(module.exports, "o", () => $c56dee3c9018e2ad$export$ae1af26003f05816);
$parcel$export(module.exports, "a", () => $c56dee3c9018e2ad$export$407448d2b89b1813);
$parcel$export(module.exports, "_", () => $c56dee3c9018e2ad$export$71511d61b312f219);
$parcel$export(module.exports, "m", () => $c56dee3c9018e2ad$export$953cecd6e717a553);
$parcel$export(module.exports, "A", () => $c56dee3c9018e2ad$export$ebd11618f299a286);
$parcel$export(module.exports, "t", () => $c56dee3c9018e2ad$export$625550452a3fa3ec);
$parcel$export(module.exports, "k", () => $c56dee3c9018e2ad$export$342063e11d6c3cad);
$parcel$export(module.exports, "l", () => $c56dee3c9018e2ad$export$882b5998b3b9117c);
$parcel$export(module.exports, "j", () => $c56dee3c9018e2ad$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $c56dee3c9018e2ad$export$ffb5f4729a158638);
$parcel$export(module.exports, "i", () => $c56dee3c9018e2ad$export$23f2a1d2818174ef);
$parcel$export(module.exports, "r", () => $c56dee3c9018e2ad$export$43caf9889c228507);
$parcel$export(module.exports, "q", () => $c56dee3c9018e2ad$export$9e5f44173e64f162);
$parcel$export(module.exports, "h", () => $c56dee3c9018e2ad$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $c56dee3c9018e2ad$export$db3b6bfb95261072);
$parcel$export(module.exports, "G", () => $c56dee3c9018e2ad$export$2329c99376c9d0a4);
$parcel$export(module.exports, "b", () => $c56dee3c9018e2ad$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "M", () => $c56dee3c9018e2ad$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "e", () => $c56dee3c9018e2ad$export$f1e1789686576879);
$parcel$export(module.exports, "g", () => $c56dee3c9018e2ad$export$39b482c5e57630a8);
$parcel$export(module.exports, "d", () => $c56dee3c9018e2ad$export$4368d992c4eafac0);
$parcel$export(module.exports, "s", () => $c56dee3c9018e2ad$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "P", () => $c56dee3c9018e2ad$export$56c0d5a1e737357d);
$parcel$export(module.exports, "n", () => $c56dee3c9018e2ad$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "f", () => $c56dee3c9018e2ad$export$2d1720544b23b823);

var $2NacA = parcelRequire("2NacA");

var $l6sdi = parcelRequire("l6sdi");
/* eslint-disable react-hooks/immutability -- Google Maps API objects are designed to be mutated */ /**
 * Internally used to copy values from props into API-Objects
 * whenever they change.
 *
 * A prop the consumer never provided is not written at all. Assigning
 * `undefined` would clobber the default the Maps API set up on the object
 * (see #867) and, for deprecated or channel-gated properties, log a warning
 * the consumer did not cause. Once a value has been written to an object,
 * a later `undefined` still clears it.
 *
 * @example
 *   usePropBinding(marker, 'position', position);
 *
 * @internal
 */ function $c56dee3c9018e2ad$export$3b14a55fb2447963(object, prop, value) {
    const writtenTo = (0, $2NacA.useRef)(null);
    (0, $2NacA.useEffect)(()=>{
        if (!object) return;
        if (value === undefined && writtenTo.current !== object) return;
        writtenTo.current = object;
        // We use any here because GmpWritableElementProp<T[K]> is a broader type than T[K]
        // and can't be assigned directly without this cast.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        object[prop] = value;
    }, [
        object,
        prop,
        value
    ]);
}
// Copyright (c) 2025 Sanity
// This file is derived from sanity-io/use-effect-event (MIT Licensed)
//
// https://github.com/sanity-io/use-effect-event
/**
 * A clone of the React namespace for reading APIs that may be missing in older
 * supported React versions. Bundlers can rewrite direct React.someNewApi reads
 * into named imports, which breaks React 17. Reading from this cloned object
 * keeps those lookups optional.
 *
 * @see https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
 */ const $c56dee3c9018e2ad$var$SafeReact = Object.assign({}, $2NacA);
const $c56dee3c9018e2ad$var$useInsertionEffect = $c56dee3c9018e2ad$var$SafeReact.useInsertionEffect;
const $c56dee3c9018e2ad$var$useSafeInsertionEffect = // React 17 doesn't have useInsertionEffect.
$c56dee3c9018e2ad$var$useInsertionEffect && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
$c56dee3c9018e2ad$var$useInsertionEffect !== $c56dee3c9018e2ad$var$SafeReact.useLayoutEffect ? $c56dee3c9018e2ad$var$useInsertionEffect : (fn)=>{
    fn();
};
function $c56dee3c9018e2ad$var$forbiddenInRender() {
    throw new Error('useEffectEvent: invalid call during rendering.');
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c56dee3c9018e2ad$var$useEffectEventPolyfill(fn) {
    /**
     * Initialize the ref with `forbiddenInRender`, to catch illegal calls during
     * rendering. After the insertion effect ran, the ref will contain the actual
     * function, so all effects can see the actual value.
     */ const ref = (0, $2NacA.useRef)($c56dee3c9018e2ad$var$forbiddenInRender);
    $c56dee3c9018e2ad$var$useSafeInsertionEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>ref.current(...args);
}
/**
 * Uses a polyfill implementation of `useEffectEvent`. The native useEffectEvent
 * implementation was causing issues that we do not fully understand yet.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c56dee3c9018e2ad$export$ae1af26003f05816 = $c56dee3c9018e2ad$var$useEffectEventPolyfill;
/* eslint-disable @typescript-eslint/no-explicit-any */ const $c56dee3c9018e2ad$var$noop = ()=>{};
/**
 * Internally used to bind events to DOM nodes.
 * @internal
 */ function $c56dee3c9018e2ad$export$407448d2b89b1813(target, name, callback) {
    const eventFn = $c56dee3c9018e2ad$export$ae1af26003f05816(callback !== null && callback !== void 0 ? callback : $c56dee3c9018e2ad$var$noop);
    const isCallbackDefined = Boolean(callback);
    (0, $2NacA.useEffect)(()=>{
        if (!target || !name || !isCallbackDefined) return;
        // Note: eventFn is not guaranteed to be stable across renders, so we need
        // to use a local variable to be sure to remove the very same listener
        // function that has been added
        const listenerCallback = eventFn;
        target.addEventListener(name, listenerCallback);
        return ()=>target.removeEventListener(name, listenerCallback);
    }, [
        target,
        name,
        isCallbackDefined
    ]);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $c56dee3c9018e2ad$export$71511d61b312f219(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c56dee3c9018e2ad$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $c56dee3c9018e2ad$var$MSG_REPEATED_SET_OPTIONS = (options)=>`The setOptions() function should only be called once. The options passed ` + `to the additional call (${JSON.stringify(options)}) will be ignored.`;
const $c56dee3c9018e2ad$var$MSG_IMPORT_LIBRARY_EXISTS = (options)=>`The google.maps.importLibrary() function is already defined, and ` + `@googlemaps/js-api-loader will use the existing function instead of ` + `overwriting it. The options passed to setOptions ` + `(${JSON.stringify(options)}) will be ignored.`;
const $c56dee3c9018e2ad$var$MSG_SET_OPTIONS_NOT_CALLED = "No options were set before calling importLibrary. Make sure to configure the loader using setOptions().";
const $c56dee3c9018e2ad$var$MSG_SCRIPT_ELEMENT_EXISTS = "There already is a script loading the Google Maps JavaScript API, and no google.maps.importLibrary function is defined. @googlemaps/js-api-loader will proceed to bootstrap the API with the specified options, but the existing script might cause problems using the API. Make sure to remove the script loading the API.";
const $c56dee3c9018e2ad$var$MSG_API_KEY_USED = "The 'apiKey' parameter was used in setOptions(), but 'key' is the correct parameter name. Please update your configuration.";
const $c56dee3c9018e2ad$var$MSG_TRUSTED_TYPES_POLICY_FAILED = (policyName, error)=>`Failed to create Trusted Types policy "${policyName}": ${error instanceof Error ? error.message : String(error)}.\n\n` + `If your Content Security Policy uses "require-trusted-types-for 'script'", ` + `allow this policy with "trusted-types ${policyName} google-maps-api-loader google-maps-api#html lit-html". ` + `The "google-maps-api-loader", "lit-html", and "google-maps-api#html" policies are required for full Maps JavaScript API execution. ` + `Falling back to a string script URL.`;
const $c56dee3c9018e2ad$var$__DEV__$1 = false;
const $c56dee3c9018e2ad$var$logDevWarning = $c56dee3c9018e2ad$var$__DEV__$1 ? (message)=>{
    console.warn(`[@googlemaps/js-api-loader] ${message}`);
} : ()=>{};
const $c56dee3c9018e2ad$var$logDevNotice = $c56dee3c9018e2ad$var$__DEV__$1 ? (message)=>{
    console.info(`[@googlemaps/js-api-loader] ${message}`);
} : ()=>{};
/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $c56dee3c9018e2ad$var$TRUSTED_TYPES_POLICY_NAME = "@googlemaps/js-api-loader";
const $c56dee3c9018e2ad$var$fallbackPolicy = {
    createScriptURL: (url)=>url
};
let $c56dee3c9018e2ad$var$policy;
/*
 * Tries to create a Trusted Types policy when supported. Falls back to a string passthrough
 * when Trusted Types is unsupported, blocked by CSP, or already registered.
 */ function $c56dee3c9018e2ad$var$getPolicy() {
    if ($c56dee3c9018e2ad$var$policy) return $c56dee3c9018e2ad$var$policy;
    const trustedTypes = globalThis.trustedTypes;
    if (!trustedTypes) {
        $c56dee3c9018e2ad$var$policy = $c56dee3c9018e2ad$var$fallbackPolicy;
        return $c56dee3c9018e2ad$var$policy;
    }
    try {
        $c56dee3c9018e2ad$var$policy = trustedTypes.createPolicy($c56dee3c9018e2ad$var$TRUSTED_TYPES_POLICY_NAME, {
            createScriptURL: (url)=>url
        });
    } catch (e) {
        $c56dee3c9018e2ad$var$logDevWarning($c56dee3c9018e2ad$var$MSG_TRUSTED_TYPES_POLICY_FAILED($c56dee3c9018e2ad$var$TRUSTED_TYPES_POLICY_NAME, e));
        $c56dee3c9018e2ad$var$policy = $c56dee3c9018e2ad$var$fallbackPolicy;
    }
    return $c56dee3c9018e2ad$var$policy;
}
function $c56dee3c9018e2ad$var$setScriptSrc(script, src) {
    script.src = $c56dee3c9018e2ad$var$getPolicy().createScriptURL(src);
}
/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $c56dee3c9018e2ad$var$bootstrap = (bootstrapParams)=>{
    var bootstrapPromise;
    var script;
    var bootstrapParamsKey;
    var PRODUCT_NAME = "The Google Maps JavaScript API";
    var GOOGLE = "google";
    var IMPORT_API_NAME = "importLibrary";
    var PENDING_BOOTSTRAP_KEY = "__ib__";
    var doc = document;
    var global_ = window;
    var google_ = global_[GOOGLE] || (global_[GOOGLE] = {});
    var namespace = google_.maps || (google_.maps = {});
    var libraries = new Set();
    var searchParams = new URLSearchParams();
    var triggerBootstrap = ()=>bootstrapPromise || (bootstrapPromise = new Promise(async (resolve, reject)=>{
            await (script = doc.createElement("script"));
            searchParams.set("libraries", [
                ...libraries
            ] + "");
            for(bootstrapParamsKey in bootstrapParams)searchParams.set(bootstrapParamsKey.replace(/[A-Z]/g, (g)=>"_" + g[0].toLowerCase()), bootstrapParams[bootstrapParamsKey]);
            searchParams.set("callback", GOOGLE + ".maps." + PENDING_BOOTSTRAP_KEY);
            $c56dee3c9018e2ad$var$setScriptSrc(script, "https://maps.googleapis.com/maps/api/js?" + searchParams);
            namespace[PENDING_BOOTSTRAP_KEY] = resolve;
            script.onerror = ()=>bootstrapPromise = reject(Error(PRODUCT_NAME + " could not load."));
            script.nonce = doc.querySelector("script[nonce]")?.nonce || "";
            doc.head.append(script);
        }));
    namespace[IMPORT_API_NAME] ? console.warn(PRODUCT_NAME + " only loads once. Ignoring:", bootstrapParams) : namespace[IMPORT_API_NAME] = (libraryName, ...args)=>libraries.add(libraryName) && triggerBootstrap().then(()=>namespace[IMPORT_API_NAME](libraryName, ...args));
};
/*
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c56dee3c9018e2ad$var$__DEV__ = false;
let $c56dee3c9018e2ad$var$setOptionsWasCalled_ = false;
/**
 * Sets the options for the Maps JavaScript API.
 *
 * Has to be called before any library is loaded.
 *
 * See https://developers.google.com/maps/documentation/javascript/load-maps-js-api#required_parameters
 * for the full documentation of available options.
 *
 * @param options The options to set.
 */ function $c56dee3c9018e2ad$var$setOptions(options) {
    if ($c56dee3c9018e2ad$var$setOptionsWasCalled_) {
        $c56dee3c9018e2ad$var$logDevWarning($c56dee3c9018e2ad$var$MSG_REPEATED_SET_OPTIONS(options));
        return;
    }
    if (options.apiKey) {
        $c56dee3c9018e2ad$var$logDevWarning($c56dee3c9018e2ad$var$MSG_API_KEY_USED);
        if (!options.key) options.key = options.apiKey;
    }
    $c56dee3c9018e2ad$var$installImportLibrary_(options);
    $c56dee3c9018e2ad$var$setOptionsWasCalled_ = true;
}
async function $c56dee3c9018e2ad$var$importLibrary(libraryName) {
    if (!$c56dee3c9018e2ad$var$setOptionsWasCalled_) $c56dee3c9018e2ad$var$logDevWarning($c56dee3c9018e2ad$var$MSG_SET_OPTIONS_NOT_CALLED);
    if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
    return await google.maps.importLibrary(libraryName);
}
/**
 * The installImportLibrary_ function makes sure that a usable version of the
 * `google.maps.importLibrary` function exists.
 */ function $c56dee3c9018e2ad$var$installImportLibrary_(options) {
    const importLibraryExists = Boolean(window.google?.maps?.importLibrary);
    if (importLibraryExists) $c56dee3c9018e2ad$var$logDevNotice($c56dee3c9018e2ad$var$MSG_IMPORT_LIBRARY_EXISTS(options));
    else if ($c56dee3c9018e2ad$var$__DEV__) {
        const scriptEl = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
        if (scriptEl) $c56dee3c9018e2ad$var$logDevWarning($c56dee3c9018e2ad$var$MSG_SCRIPT_ELEMENT_EXISTS);
    }
    // If the google.maps.importLibrary function already exists, bootstrap()
    // won't do anything, so we won't call it
    if (!importLibraryExists) $c56dee3c9018e2ad$var$bootstrap(options);
}
const $c56dee3c9018e2ad$export$953cecd6e717a553 = {
    NOT_LOADED: 'NOT_LOADED',
    LOADING: 'LOADING',
    LOADED: 'LOADED',
    FAILED: 'FAILED',
    AUTH_FAILURE: 'AUTH_FAILURE'
};
// This file is automatically updated by the build process.
const $c56dee3c9018e2ad$export$e7c866399fa523f5 = '1.10.1';
const $c56dee3c9018e2ad$var$DEFAULT_SOLUTION_CHANNEL = 'GMP_visgl_rgmlibrary_v1_default';
const $c56dee3c9018e2ad$var$DEFAULT_INTERNAL_USAGE_ATTRIBUTION_IDS = [
    `gmp_visgl_reactgooglemaps_v${$c56dee3c9018e2ad$export$e7c866399fa523f5}`
];
const $c56dee3c9018e2ad$export$ebd11618f299a286 = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(null);
// loading the Maps JavaScript API can only happen once in the runtime, so these
// variables are kept at the module level.
let $c56dee3c9018e2ad$var$loadingStatus = $c56dee3c9018e2ad$export$953cecd6e717a553.NOT_LOADED;
let $c56dee3c9018e2ad$var$serializedApiParams;
const $c56dee3c9018e2ad$var$listeners = new Set();
/**
 * Called to update the local status and notify the listeners for any mounted
 * components.
 * @internal
 */ function $c56dee3c9018e2ad$var$updateLoadingStatus(status) {
    if (status === $c56dee3c9018e2ad$var$loadingStatus) return;
    $c56dee3c9018e2ad$var$loadingStatus = status;
    $c56dee3c9018e2ad$var$listeners.forEach((listener)=>listener($c56dee3c9018e2ad$var$loadingStatus));
}
/**
 * Local hook to set up the map-instance management context.
 * @internal
 */ function $c56dee3c9018e2ad$var$useMapInstances() {
    const [mapInstances, setMapInstances] = (0, $2NacA.useState)({});
    const addMapInstance = (mapInstance, id = 'default')=>{
        setMapInstances((instances)=>Object.assign(Object.assign({}, instances), {
                [id]: mapInstance
            }));
    };
    const removeMapInstance = (id = 'default')=>{
        setMapInstances((_a)=>{
            var _b = id;
            _a[_b];
            var remaining = $c56dee3c9018e2ad$export$71511d61b312f219(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return remaining;
        });
    };
    const clearMapInstances = ()=>{
        setMapInstances({});
    };
    return {
        mapInstances: mapInstances,
        addMapInstance: addMapInstance,
        removeMapInstance: removeMapInstance,
        clearMapInstances: clearMapInstances
    };
}
/**
 * local hook to set up the 3D map-instance management context.
 */ function $c56dee3c9018e2ad$var$useMap3DInstances() {
    const [map3dInstances, setMap3DInstances] = (0, $2NacA.useState)({});
    const addMap3DInstance = (map3dInstance, id = 'default')=>{
        setMap3DInstances((instances)=>Object.assign(Object.assign({}, instances), {
                [id]: map3dInstance
            }));
    };
    const removeMap3DInstance = (id = 'default')=>{
        setMap3DInstances((_a)=>{
            var _b = id;
            _a[_b];
            var remaining = $c56dee3c9018e2ad$export$71511d61b312f219(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return remaining;
        });
    };
    const clearMap3DInstances = ()=>{
        setMap3DInstances({});
    };
    return {
        map3dInstances: map3dInstances,
        addMap3DInstance: addMap3DInstance,
        removeMap3DInstance: removeMap3DInstance,
        clearMap3DInstances: clearMap3DInstances
    };
}
/**
 * Local hook to handle the loading of the maps API.
 * @internal
 */ function $c56dee3c9018e2ad$var$useGoogleMapsApiLoader(props) {
    const { onLoad: onLoad, onError: onError, apiKey: apiKey, version: version, libraries: libraries = [], region: region, language: language, authReferrerPolicy: authReferrerPolicy, channel: channel, solutionChannel: solutionChannel, fetchAppCheckToken: fetchAppCheckToken } = props;
    const [status, setStatus] = (0, $2NacA.useState)($c56dee3c9018e2ad$var$loadingStatus);
    const [loadedLibraries, addLoadedLibrary] = (0, $2NacA.useReducer)((loadedLibraries, action)=>{
        return loadedLibraries[action.name] ? loadedLibraries : Object.assign(Object.assign({}, loadedLibraries), {
            [action.name]: action.value
        });
    }, {});
    const currentSerializedParams = (0, $2NacA.useMemo)(()=>{
        const params = {
            apiKey: apiKey,
            version: version,
            libraries: libraries.join(','),
            region: region,
            language: language,
            authReferrerPolicy: authReferrerPolicy,
            channel: channel,
            solutionChannel: solutionChannel
        };
        return JSON.stringify(params);
    }, [
        apiKey,
        version,
        libraries,
        region,
        language,
        authReferrerPolicy,
        channel,
        solutionChannel
    ]);
    const importLibraryCallback = (0, $2NacA.useCallback)((name)=>$c56dee3c9018e2ad$var$__awaiter(this, void 0, void 0, function*() {
            if (loadedLibraries[name]) return loadedLibraries[name];
            const res = yield $c56dee3c9018e2ad$var$importLibrary(name);
            addLoadedLibrary({
                name: name,
                value: res
            });
            return res;
        }), [
        loadedLibraries
    ]);
    // effect: we want to get notified of global loading-status changes
    (0, $2NacA.useEffect)(()=>{
        $c56dee3c9018e2ad$var$listeners.add(setStatus);
        // sync component state on mount (shouldn't be different from the initial state)
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional synchronization of status from singleton
        setStatus($c56dee3c9018e2ad$var$loadingStatus);
        return ()=>{
            $c56dee3c9018e2ad$var$listeners.delete(setStatus);
        };
    }, []);
    // effect: set and store options
    (0, $2NacA.useEffect)(()=>{
        (()=>$c56dee3c9018e2ad$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                try {
                    // This indicates that the API has been loaded with a different set of parameters.
                    // While this is not blocking, it's not recommended and we should warn the user.
                    if ($c56dee3c9018e2ad$var$serializedApiParams && $c56dee3c9018e2ad$var$serializedApiParams !== currentSerializedParams) console.warn(`The Google Maps JavaScript API has already been loaded with different parameters. ` + `The new parameters will be ignored. If you need to use different parameters, ` + `please refresh the page.`);
                    const librariesToLoad = [
                        'core',
                        'maps',
                        ...libraries
                    ];
                    const options = Object.fromEntries(Object.entries({
                        key: apiKey,
                        v: version,
                        libraries: libraries,
                        region: region,
                        language: language,
                        authReferrerPolicy: authReferrerPolicy
                    }).filter(([, value])=>value !== undefined));
                    if (channel !== undefined && channel >= 0 && channel <= 999) options.channel = String(channel);
                    // solution-channel: when undefined, use the default; otherwise use
                    // an explicit value.
                    if (solutionChannel === undefined) options.solutionChannel = $c56dee3c9018e2ad$var$DEFAULT_SOLUTION_CHANNEL;
                    else if (solutionChannel !== '') options.solutionChannel = solutionChannel;
                    // If the google.maps namespace is already available, the API has been loaded externally.
                    if ((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary) {
                        const shouldUpdateLoadingStatus = !$c56dee3c9018e2ad$var$serializedApiParams;
                        if (shouldUpdateLoadingStatus) {
                            $c56dee3c9018e2ad$var$serializedApiParams = currentSerializedParams;
                            $c56dee3c9018e2ad$var$setOptions(options);
                        }
                        yield Promise.all(librariesToLoad.map((name)=>importLibraryCallback(name)));
                        if (shouldUpdateLoadingStatus) $c56dee3c9018e2ad$var$updateLoadingStatus($c56dee3c9018e2ad$export$953cecd6e717a553.LOADED);
                        if (onLoad) onLoad();
                        return;
                    }
                    // Abort if the API is already loading or has been loaded.
                    if ($c56dee3c9018e2ad$var$loadingStatus === $c56dee3c9018e2ad$export$953cecd6e717a553.LOADING || $c56dee3c9018e2ad$var$loadingStatus === $c56dee3c9018e2ad$export$953cecd6e717a553.LOADED) {
                        if ($c56dee3c9018e2ad$var$loadingStatus === $c56dee3c9018e2ad$export$953cecd6e717a553.LOADED && onLoad) onLoad();
                        return;
                    }
                    $c56dee3c9018e2ad$var$serializedApiParams = currentSerializedParams;
                    $c56dee3c9018e2ad$var$updateLoadingStatus($c56dee3c9018e2ad$export$953cecd6e717a553.LOADING);
                    // this will actually trigger loading the maps API
                    $c56dee3c9018e2ad$var$setOptions(options);
                    // wait for all requested libraries (inluding 'core' and 'maps') to
                    // finish loading
                    yield Promise.all(librariesToLoad.map((name)=>importLibraryCallback(name)));
                    $c56dee3c9018e2ad$var$updateLoadingStatus($c56dee3c9018e2ad$export$953cecd6e717a553.LOADED);
                    if (onLoad) onLoad();
                } catch (error) {
                    $c56dee3c9018e2ad$var$updateLoadingStatus($c56dee3c9018e2ad$export$953cecd6e717a553.FAILED);
                    if (onError) onError(error);
                    else console.error('The Google Maps JavaScript API failed to load.', error);
                }
            }))();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentSerializedParams,
        onLoad,
        onError,
        importLibraryCallback,
        libraries
    ]);
    // set the fetchAppCheckToken if provided
    (0, $2NacA.useEffect)(()=>{
        if (status !== $c56dee3c9018e2ad$export$953cecd6e717a553.LOADED) return;
        const settings = google.maps.Settings.getInstance();
        if (fetchAppCheckToken) settings.fetchAppCheckToken = fetchAppCheckToken;
    }, [
        status,
        fetchAppCheckToken
    ]);
    return {
        status: status,
        loadedLibraries: loadedLibraries,
        importLibrary: importLibraryCallback
    };
}
function $c56dee3c9018e2ad$var$useInternalUsageAttributionIds(props) {
    return (0, $2NacA.useMemo)(()=>props.disableUsageAttribution ? null : $c56dee3c9018e2ad$var$DEFAULT_INTERNAL_USAGE_ATTRIBUTION_IDS, [
        props.disableUsageAttribution
    ]);
}
/**
 * Component to wrap the components from this library and load the Google Maps JavaScript API
 */ const $c56dee3c9018e2ad$export$625550452a3fa3ec = (props)=>{
    const { children: children } = props, loaderProps = $c56dee3c9018e2ad$export$71511d61b312f219(props, [
        "children"
    ]);
    const { mapInstances: mapInstances, addMapInstance: addMapInstance, removeMapInstance: removeMapInstance, clearMapInstances: clearMapInstances } = $c56dee3c9018e2ad$var$useMapInstances();
    const { map3dInstances: map3dInstances, addMap3DInstance: addMap3DInstance, removeMap3DInstance: removeMap3DInstance, clearMap3DInstances: clearMap3DInstances } = $c56dee3c9018e2ad$var$useMap3DInstances();
    const { status: status, loadedLibraries: loadedLibraries, importLibrary: importLibrary } = $c56dee3c9018e2ad$var$useGoogleMapsApiLoader(loaderProps);
    const internalUsageAttributionIds = $c56dee3c9018e2ad$var$useInternalUsageAttributionIds(loaderProps);
    const contextValue = (0, $2NacA.useMemo)(()=>({
            mapInstances: mapInstances,
            addMapInstance: addMapInstance,
            removeMapInstance: removeMapInstance,
            clearMapInstances: clearMapInstances,
            map3dInstances: map3dInstances,
            addMap3DInstance: addMap3DInstance,
            removeMap3DInstance: removeMap3DInstance,
            clearMap3DInstances: clearMap3DInstances,
            status: status,
            loadedLibraries: loadedLibraries,
            importLibrary: importLibrary,
            internalUsageAttributionIds: internalUsageAttributionIds
        }), [
        mapInstances,
        addMapInstance,
        removeMapInstance,
        clearMapInstances,
        map3dInstances,
        addMap3DInstance,
        removeMap3DInstance,
        clearMap3DInstances,
        status,
        loadedLibraries,
        importLibrary,
        internalUsageAttributionIds
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($c56dee3c9018e2ad$export$ebd11618f299a286.Provider, {
        value: contextValue
    }, children);
};
/**
 * @internal
 * Resets module-level state for testing purposes only.
 * This should never be used in production code.
 */ function $c56dee3c9018e2ad$export$90a7f3efeed30595() {
    $c56dee3c9018e2ad$var$loadingStatus = $c56dee3c9018e2ad$export$953cecd6e717a553.NOT_LOADED;
    $c56dee3c9018e2ad$var$serializedApiParams = undefined;
    $c56dee3c9018e2ad$var$listeners.clear();
}
function $c56dee3c9018e2ad$export$342063e11d6c3cad() {
    const [el, setEl] = (0, $2NacA.useState)(null);
    const ref = (0, $2NacA.useCallback)((value)=>setEl(value), [
        setEl
    ]);
    return [
        el,
        ref
    ];
}
function $c56dee3c9018e2ad$export$882b5998b3b9117c() {
    var _a;
    return ((_a = (0, $2NacA.useContext)($c56dee3c9018e2ad$export$ebd11618f299a286)) === null || _a === void 0 ? void 0 : _a.status) || $c56dee3c9018e2ad$export$953cecd6e717a553.NOT_LOADED;
}
/**
 * Hook to check if the Maps JavaScript API is loaded
 */ function $c56dee3c9018e2ad$export$35e795649ee09318() {
    const status = $c56dee3c9018e2ad$export$882b5998b3b9117c();
    return status === $c56dee3c9018e2ad$export$953cecd6e717a553.LOADED;
}
function $c56dee3c9018e2ad$export$ffb5f4729a158638(name) {
    var _a;
    const apiIsLoaded = $c56dee3c9018e2ad$export$35e795649ee09318();
    const ctx = (0, $2NacA.useContext)($c56dee3c9018e2ad$export$ebd11618f299a286);
    (0, $2NacA.useEffect)(()=>{
        if (!apiIsLoaded || !ctx) return;
        // Trigger loading the libraries via our proxy-method.
        // The returned promise is ignored, since importLibrary will update loadedLibraries
        // list in the context, triggering a re-render.
        ctx.importLibrary(name);
    }, [
        apiIsLoaded,
        ctx,
        name
    ]);
    return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.loadedLibraries[name]) !== null && _a !== void 0 ? _a : null;
}
function $c56dee3c9018e2ad$export$23f2a1d2818174ef() {
    const [, forceUpdate] = (0, $2NacA.useReducer)((x)=>x + 1, 0);
    return forceUpdate;
}
const $c56dee3c9018e2ad$var$DEFAULT_CAMERA_STATE = {
    center: {
        lat: 0,
        lng: 0,
        altitude: 0
    },
    range: 0,
    heading: 0,
    tilt: 0,
    roll: 0
};
/**
 * Camera property names that correspond to gmp-*change events.
 */ const $c56dee3c9018e2ad$var$CAMERA_PROPS = [
    'center',
    'range',
    'heading',
    'tilt',
    'roll'
];
/**
 * Updates the camera state ref with values from the map element.
 */ function $c56dee3c9018e2ad$var$updateCameraState(map3d, ref, prop) {
    const value = map3d[prop];
    if (value == null) return;
    if (prop === 'center') {
        // The center property returns a LatLngAltitude object, convert to literal
        const center = value;
        ref.current.center = center.toJSON ? center.toJSON() : center;
    } else ref.current[prop] = value;
}
/**
 * Creates a mutable ref object to track the last known state of the 3D map camera.
 * This is used in `useMap3DCameraParams` to reduce stuttering by avoiding updates
 * of the map camera with values that have already been processed.
 *
 * @internal
 */ function $c56dee3c9018e2ad$var$useTrackedCameraStateRef3D(map3d) {
    const forceUpdate = $c56dee3c9018e2ad$export$23f2a1d2818174ef();
    const ref = (0, $2NacA.useRef)(Object.assign({}, $c56dee3c9018e2ad$var$DEFAULT_CAMERA_STATE));
    (0, $2NacA.useEffect)(()=>{
        if (!map3d) return;
        const listeners = [];
        for (const prop of $c56dee3c9018e2ad$var$CAMERA_PROPS){
            const eventName = `gmp-${prop}change`;
            const handler = ()=>{
                $c56dee3c9018e2ad$var$updateCameraState(map3d, ref, prop);
                forceUpdate();
            };
            map3d.addEventListener(eventName, handler);
            listeners.push(()=>map3d.removeEventListener(eventName, handler));
        }
        return ()=>{
            for (const removeListener of listeners)removeListener();
        };
    }, [
        map3d,
        forceUpdate
    ]);
    return ref;
}
/**
 * Hook to manage the Map3DElement instance lifecycle.
 *
 * Handles:
 * - Waiting for the 'maps3d' library to load
 * - Waiting for the 'gmp-map-3d' custom element to be defined
 * - Creating a callback ref for the element
 * - Applying initial options when the element is ready
 * - Tracking camera state
 *
 * @internal
 */ function $c56dee3c9018e2ad$var$useMap3DInstance(props) {
    const maps3dLib = $c56dee3c9018e2ad$export$ffb5f4729a158638('maps3d');
    const [customElementReady, setCustomElementReady] = (0, $2NacA.useState)(false);
    const [, containerRef] = $c56dee3c9018e2ad$export$342063e11d6c3cad();
    const [map3d, map3dRef] = $c56dee3c9018e2ad$export$342063e11d6c3cad();
    const cameraStateRef = $c56dee3c9018e2ad$var$useTrackedCameraStateRef3D(map3d);
    (0, $2NacA.useEffect)(()=>{
        customElements.whenDefined('gmp-map-3d').then(()=>{
            setCustomElementReady(true);
        });
    }, []);
    // Apply initial options once when the element is first available
    (0, $2NacA.useEffect)(()=>{
        if (!map3d) return;
        const { center: center, heading: heading, tilt: tilt, range: range, roll: roll, defaultCenter: defaultCenter, defaultHeading: defaultHeading, defaultTilt: defaultTilt, defaultRange: defaultRange, defaultRoll: defaultRoll, id: // Non-element props to exclude
        id, style: style, className: className, children: children, onCenterChanged: onCenterChanged, onHeadingChanged: onHeadingChanged, onTiltChanged: onTiltChanged, onRangeChanged: onRangeChanged, onRollChanged: onRollChanged, onCameraChanged: onCameraChanged, onClick: onClick, onSteadyChange: onSteadyChange, onAnimationEnd: onAnimationEnd, onError: onError, mode: mode, gestureHandling: gestureHandling } = props, elementOptions = $c56dee3c9018e2ad$export$71511d61b312f219(props, [
            "center",
            "heading",
            "tilt",
            "range",
            "roll",
            "defaultCenter",
            "defaultHeading",
            "defaultTilt",
            "defaultRange",
            "defaultRoll",
            "id",
            "style",
            "className",
            "children",
            "onCenterChanged",
            "onHeadingChanged",
            "onTiltChanged",
            "onRangeChanged",
            "onRollChanged",
            "onCameraChanged",
            "onClick",
            "onSteadyChange",
            "onAnimationEnd",
            "onError",
            "mode",
            "gestureHandling"
        ]);
        const initialCenter = center !== null && center !== void 0 ? center : defaultCenter;
        const initialHeading = heading !== null && heading !== void 0 ? heading : defaultHeading;
        const initialTilt = tilt !== null && tilt !== void 0 ? tilt : defaultTilt;
        const initialRange = range !== null && range !== void 0 ? range : defaultRange;
        const initialRoll = roll !== null && roll !== void 0 ? roll : defaultRoll;
        const initialOptions = Object.assign({}, elementOptions);
        if (initialCenter) initialOptions.center = initialCenter;
        if (initialHeading !== undefined) initialOptions.heading = initialHeading;
        if (initialTilt !== undefined) initialOptions.tilt = initialTilt;
        if (initialRange !== undefined) initialOptions.range = initialRange;
        if (initialRoll !== undefined) initialOptions.roll = initialRoll;
        Object.assign(map3d, initialOptions);
    }, // this effect should only run when the map3d element first becomes
    // available, so we skip re-running it when other props change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        map3d
    ]);
    const isReady = !!maps3dLib && customElementReady;
    return [
        map3d,
        containerRef,
        map3dRef,
        cameraStateRef,
        isReady
    ];
}
/* eslint-disable react-hooks/immutability -- Google Maps API objects are designed to be mutated */ /**
 * Converts a LatLngAltitude or LatLngAltitudeLiteral to a literal object.
 */ function $c56dee3c9018e2ad$var$toLatLngAltitudeLiteral(value) {
    if (!value) return null;
    // Check if it's a LatLngAltitude object with toJSON method
    if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
    return value;
}
/**
 * Hook to update Map3D camera parameters when props change.
 * Compares the current camera state with props and updates only when there are differences.
 *
 * @internal
 */ function $c56dee3c9018e2ad$var$useMap3DCameraParams(map3d, cameraStateRef, props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const centerLiteral = $c56dee3c9018e2ad$var$toLatLngAltitudeLiteral(props.center);
    const lat = (_a = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.lat) !== null && _a !== void 0 ? _a : null;
    const lng = (_b = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.lng) !== null && _b !== void 0 ? _b : null;
    const altitude = (_c = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.altitude) !== null && _c !== void 0 ? _c : null;
    const range = (_d = props.range) !== null && _d !== void 0 ? _d : null;
    const heading = (_e = props.heading) !== null && _e !== void 0 ? _e : null;
    const tilt = (_f = props.tilt) !== null && _f !== void 0 ? _f : null;
    const roll = (_g = props.roll) !== null && _g !== void 0 ? _g : null;
    // Runs on every render to sync controlled camera props with the map element
    (0, $2NacA.useLayoutEffect)(()=>{
        var _a;
        if (!map3d) return;
        const currentState = cameraStateRef.current;
        if (lat !== null && lng !== null && (currentState.center.lat !== lat || currentState.center.lng !== lng || altitude !== null && currentState.center.altitude !== altitude)) map3d.center = {
            lat: lat,
            lng: lng,
            altitude: (_a = altitude !== null && altitude !== void 0 ? altitude : currentState.center.altitude) !== null && _a !== void 0 ? _a : 0
        };
        if (range !== null && currentState.range !== range) map3d.range = range;
        if (heading !== null && currentState.heading !== heading) map3d.heading = heading;
        if (tilt !== null && currentState.tilt !== tilt) map3d.tilt = tilt;
        if (roll !== null && currentState.roll !== roll) map3d.roll = roll;
    });
}
/**
 * Camera-related event types for the aggregated onCameraChanged handler.
 */ const $c56dee3c9018e2ad$var$CAMERA_EVENTS = [
    'gmp-centerchange',
    'gmp-headingchange',
    'gmp-tiltchange',
    'gmp-rangechange',
    'gmp-rollchange'
];
/**
 * Creates a camera changed event with current camera state.
 */ function $c56dee3c9018e2ad$var$createCameraEvent(map3d, type) {
    const center = map3d.center;
    // Normalize center to LatLngAltitudeLiteral
    // If center is a LatLngAltitude class instance, it has a toJSON method
    // Otherwise it's already a literal object
    let centerLiteral;
    if (center && 'toJSON' in center && typeof center.toJSON === 'function') centerLiteral = center.toJSON();
    else if (center) centerLiteral = center;
    else centerLiteral = {
        lat: 0,
        lng: 0,
        altitude: 0
    };
    return {
        type: type,
        map3d: map3d,
        detail: {
            center: centerLiteral,
            range: map3d.range || 0,
            heading: map3d.heading || 0,
            tilt: map3d.tilt || 0,
            roll: map3d.roll || 0
        }
    };
}
/**
 * Creates a click event from a LocationClickEvent or PlaceClickEvent.
 */ function $c56dee3c9018e2ad$var$createClickEvent(map3d, srcEvent) {
    const placeClickEvent = srcEvent;
    return {
        type: 'gmp-click',
        map3d: map3d,
        detail: {
            position: srcEvent.position || null,
            placeId: placeClickEvent.placeId
        }
    };
}
/**
 * Creates a steady change event.
 */ function $c56dee3c9018e2ad$var$createSteadyChangeEvent(map3d, srcEvent) {
    return {
        type: 'gmp-steadychange',
        map3d: map3d,
        detail: {
            isSteady: srcEvent.isSteady
        }
    };
}
/**
 * Hook to set up event handlers for Map3D events.
 *
 * @internal
 */ function $c56dee3c9018e2ad$var$useMap3DEvents(map3d, props) {
    const { onCenterChanged: onCenterChanged, onHeadingChanged: onHeadingChanged, onTiltChanged: onTiltChanged, onRangeChanged: onRangeChanged, onRollChanged: onRollChanged, onCameraChanged: onCameraChanged, onClick: onClick, onSteadyChange: onSteadyChange, onAnimationEnd: onAnimationEnd, onError: onError } = props;
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-centerchange', onCenterChanged, $c56dee3c9018e2ad$var$createCameraEvent);
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-headingchange', onHeadingChanged, $c56dee3c9018e2ad$var$createCameraEvent);
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-tiltchange', onTiltChanged, $c56dee3c9018e2ad$var$createCameraEvent);
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-rangechange', onRangeChanged, $c56dee3c9018e2ad$var$createCameraEvent);
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-rollchange', onRollChanged, $c56dee3c9018e2ad$var$createCameraEvent);
    // onCameraChanged aggregates all camera property change events into one handler
    (0, $2NacA.useEffect)(()=>{
        if (!map3d || !onCameraChanged) return;
        const handler = ()=>{
            onCameraChanged($c56dee3c9018e2ad$var$createCameraEvent(map3d, 'camerachange'));
        };
        for (const eventName of $c56dee3c9018e2ad$var$CAMERA_EVENTS)map3d.addEventListener(eventName, handler);
        return ()=>{
            for (const eventName of $c56dee3c9018e2ad$var$CAMERA_EVENTS)map3d.removeEventListener(eventName, handler);
        };
    }, [
        map3d,
        onCameraChanged
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!map3d || !onClick) return;
        const handler = (ev)=>{
            onClick($c56dee3c9018e2ad$var$createClickEvent(map3d, ev));
        };
        map3d.addEventListener('gmp-click', handler);
        return ()=>map3d.removeEventListener('gmp-click', handler);
    }, [
        map3d,
        onClick
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!map3d || !onSteadyChange) return;
        const handler = (ev)=>{
            onSteadyChange($c56dee3c9018e2ad$var$createSteadyChangeEvent(map3d, ev));
        };
        map3d.addEventListener('gmp-steadychange', handler);
        return ()=>map3d.removeEventListener('gmp-steadychange', handler);
    }, [
        map3d,
        onSteadyChange
    ]);
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-animationend', onAnimationEnd, (map3d, type)=>({
            type: type,
            map3d: map3d
        }));
    $c56dee3c9018e2ad$var$useMap3DEvent(map3d, 'gmp-error', onError, (map3d, type)=>({
            type: type,
            map3d: map3d
        }));
}
/**
 * Helper hook for individual events.
 */ function $c56dee3c9018e2ad$var$useMap3DEvent(map3d, eventName, handler, createEvent) {
    (0, $2NacA.useEffect)(()=>{
        if (!map3d || !handler) return;
        const listener = ()=>{
            handler(createEvent(map3d, eventName));
        };
        map3d.addEventListener(eventName, listener);
        return ()=>map3d.removeEventListener(eventName, listener);
    }, [
        map3d,
        eventName,
        handler,
        createEvent
    ]);
}
/* eslint-disable react-hooks/refs */ // refs should not be used in render because changes to refs won't
// trigger a re-render, making them unreliable for holding state.
// In this case though, that is exactly what we want.
function $c56dee3c9018e2ad$export$43caf9889c228507(value, isEqual) {
    const ref = (0, $2NacA.useRef)(value);
    if (!isEqual(value, ref.current)) ref.current = value;
    return ref.current;
}
function $c56dee3c9018e2ad$var$useCustomCompareEffect(effect, dependencies, isEqual) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $2NacA.useEffect)(effect, [
        $c56dee3c9018e2ad$export$43caf9889c228507(dependencies, isEqual)
    ]);
}
const { getOwnPropertyNames: $c56dee3c9018e2ad$var$getOwnPropertyNames, getOwnPropertySymbols: $c56dee3c9018e2ad$var$getOwnPropertySymbols } = Object;
const { hasOwnProperty: $c56dee3c9018e2ad$var$hasOwnProperty } = Object.prototype;
/**
 * Combine two comparators into a single comparators.
 */ function $c56dee3c9018e2ad$var$combineComparators(comparatorA, comparatorB) {
    return function isEqual(a, b, state) {
        return comparatorA(a, b, state) && comparatorB(a, b, state);
    };
}
/**
 * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
 * for circular references to be safely included in the comparison without creating
 * stack overflows.
 */ function $c56dee3c9018e2ad$var$createIsCircular(areItemsEqual) {
    return function isCircular(a, b, state) {
        if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
        const { cache: cache } = state;
        const cachedA = cache.get(a);
        const cachedB = cache.get(b);
        if (cachedA && cachedB) return cachedA === b && cachedB === a;
        cache.set(a, b);
        cache.set(b, a);
        const result = areItemsEqual(a, b, state);
        cache.delete(a);
        cache.delete(b);
        return result;
    };
}
/**
 * Get the properties to strictly examine, which include both own properties that are
 * not enumerable and symbol properties.
 */ function $c56dee3c9018e2ad$var$getStrictProperties(object) {
    const symbols = $c56dee3c9018e2ad$var$getOwnPropertySymbols(object);
    return symbols.length ? $c56dee3c9018e2ad$var$getOwnPropertyNames(object).concat(symbols) : $c56dee3c9018e2ad$var$getOwnPropertyNames(object);
}
/**
 * Whether the object contains the property passed as an own property.
 */ const $c56dee3c9018e2ad$var$hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.hasOwn || ((object, property)=>$c56dee3c9018e2ad$var$hasOwnProperty.call(object, property));
const $c56dee3c9018e2ad$var$PREACT_VNODE = '__v';
const $c56dee3c9018e2ad$var$PREACT_OWNER = '__o';
const $c56dee3c9018e2ad$var$REACT_OWNER = '_owner';
// `Float16Array` is recent enough that it cannot be referenced unguarded, and capturing its
// availability once keeps that detail out of the comparison itself.
const $c56dee3c9018e2ad$var$HAS_FLOAT_16_ARRAY = typeof Float16Array !== 'undefined';
const { getOwnPropertyDescriptor: $c56dee3c9018e2ad$var$getOwnPropertyDescriptor, keys: $c56dee3c9018e2ad$var$keys } = Object;
/**
 * Whether the values passed are equal based on a [SameValue](https://262.ecma-international.org/7.0/#sec-samevalue) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`) or both are `NaN`.
 *
 * @note
 * When available in the environment, this is just a re-export of the global
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is) method.
 */ const $c56dee3c9018e2ad$var$sameValueEqual = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.is || function sameValueEqual(a, b) {
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
};
/**
 * Whether the values passed are equal based on a
 * [Strict Equality Comparison](https://262.ecma-international.org/7.0/#sec-strict-equality-comparison) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`).
 *
 * @note
 * This is mainly available as a convenience function, such as being a default when a function to determine equality between
 * two objects is used.
 */ function $c56dee3c9018e2ad$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Whether the array buffers are equal in value.
 */ function $c56dee3c9018e2ad$var$areArrayBuffersEqual(a, b) {
    return a.byteLength === b.byteLength && $c56dee3c9018e2ad$var$areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
}
/**
 * Whether the arrays are equal in value.
 */ function $c56dee3c9018e2ad$var$areArraysEqual(a, b, state) {
    let index = a.length;
    if (b.length !== index) return false;
    while(index-- > 0){
        if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
    }
    return true;
}
/**
 * Whether the dataviews are equal in value.
 */ function $c56dee3c9018e2ad$var$areDataViewsEqual(a, b) {
    return a.byteLength === b.byteLength && $c56dee3c9018e2ad$var$areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
}
/**
 * Whether the dates passed are equal in value.
 */ function $c56dee3c9018e2ad$var$areDatesEqual(a, b) {
    return $c56dee3c9018e2ad$var$sameValueEqual(a.getTime(), b.getTime());
}
/**
 * Whether the errors passed are equal in value.
 *
 * @note
 * `name`, `message` and `stack` are own properties but are not enumerable, so they are compared
 * explicitly. `cause` is compared by value rather than by reference, matching how every other
 * nested value in the comparison is treated. Own enumerable properties (which custom `Error`
 * subclasses commonly add) are compared by composing this with the object comparator in the
 * comparator config, so that the strict and circular variants apply to them as well.
 */ function $c56dee3c9018e2ad$var$areErrorsEqual(a, b, state) {
    return a.name === b.name && a.message === b.message && a.stack === b.stack && state.equals(a.cause, b.cause, 'cause', 'cause', a, b, state);
}
/**
 * Whether the `Map`s are equal in value.
 */ function $c56dee3c9018e2ad$var$areMapsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Uint8Array(size);
    const aIterable = a.entries();
    let aResult;
    let bResult;
    let index = 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.entries();
        let hasMatch = 0;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (matchedIndices[matchIndex]) {
                matchIndex++;
                continue;
            }
            const aEntry = aResult.value;
            const bEntry = bResult.value;
            if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = 1;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
        index++;
    }
    return true;
}
/**
 * Whether the objects are equal in value.
 */ function $c56dee3c9018e2ad$var$areObjectsEqual(a, b, state) {
    const properties = $c56dee3c9018e2ad$var$keys(a);
    let index = properties.length;
    if ($c56dee3c9018e2ad$var$keys(b).length !== index) return false;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        if (!$c56dee3c9018e2ad$var$isPropertyEqual(a, b, state, properties[index])) return false;
    }
    return true;
}
/**
 * Whether the objects are equal in value with strict property checking.
 */ function $c56dee3c9018e2ad$var$areObjectsEqualStrict(a, b, state) {
    const properties = $c56dee3c9018e2ad$var$getStrictProperties(a);
    let index = properties.length;
    if ($c56dee3c9018e2ad$var$getStrictProperties(b).length !== index) return false;
    let property;
    let descriptorA;
    let descriptorB;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        property = properties[index];
        if (!$c56dee3c9018e2ad$var$isPropertyEqual(a, b, state, property)) return false;
        descriptorA = $c56dee3c9018e2ad$var$getOwnPropertyDescriptor(a, property);
        descriptorB = $c56dee3c9018e2ad$var$getOwnPropertyDescriptor(b, property);
        if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
    }
    return true;
}
/**
 * Whether the primitive wrappers passed are equal in value.
 */ function $c56dee3c9018e2ad$var$arePrimitiveWrappersEqual(a, b) {
    return $c56dee3c9018e2ad$var$sameValueEqual(a.valueOf(), b.valueOf());
}
/**
 * Whether the regexps passed are equal in value.
 */ function $c56dee3c9018e2ad$var$areRegExpsEqual(a, b) {
    return a.source === b.source && a.flags === b.flags;
}
/**
 * Whether the `Set`s are equal in value.
 */ function $c56dee3c9018e2ad$var$areSetsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Uint8Array(size);
    const aIterable = a.values();
    let aResult;
    let bResult;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.values();
        let hasMatch = 0;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = 1;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
    }
    return true;
}
/**
 * Whether the TypedArray instances are equal in value.
 */ function $c56dee3c9018e2ad$var$areTypedArraysEqual(a, b) {
    let index = a.length;
    if (b.length !== index || a.byteOffset !== b.byteOffset) return false;
    // Only float-backed views can hold `NaN`, and the additional check needed to treat it as equal
    // to itself measurably slows the loop, so integer views keep the plain comparison. This is
    // hoisted out of the loop so the cost is paid once per call rather than once per element.
    if (a instanceof Float64Array || a instanceof Float32Array || $c56dee3c9018e2ad$var$HAS_FLOAT_16_ARRAY && a instanceof Float16Array) {
        while(index-- > 0){
            // `NaN` is the only value not equal to itself, and it is treated as equal here to match
            // the SameValueZero semantics used for every other numeric comparison in the library.
            if (a[index] !== b[index] && (a[index] === a[index] || b[index] === b[index])) return false;
        }
        return true;
    }
    while(index-- > 0){
        if (a[index] !== b[index]) return false;
    }
    return true;
}
/**
 * Whether the URL instances are equal in value.
 */ function $c56dee3c9018e2ad$var$areUrlsEqual(a, b) {
    // `href` is the normalized serialization of every component, so matching hrefs are equal without
    // any further work. Only a difference in query parameter ordering can survive a mismatch here.
    if (a.href === b.href) return true;
    return a.protocol === b.protocol && a.username === b.username && a.password === b.password && a.host === b.host && a.pathname === b.pathname && a.hash === b.hash && $c56dee3c9018e2ad$var$areSearchParamsEqual(a.searchParams, b.searchParams);
}
/**
 * Whether the search params passed are equal in value.
 *
 * @note
 * Order is not significant, matching how the other unordered collections in the library are
 * compared. Repeated keys are, so this is a comparison of multisets rather than of sets:
 * `a=1&a=2` is equal to `a=2&a=1`, but not to `a=1&a=1`.
 */ function $c56dee3c9018e2ad$var$areSearchParamsEqual(a, b) {
    const serializedA = a.toString();
    const serializedB = b.toString();
    // Identical serializations are equal under any ordering, and this is by far the common case, so
    // it is worth checking before sorting anything.
    return serializedA === serializedB || $c56dee3c9018e2ad$var$sortSearchParams(serializedA) === $c56dee3c9018e2ad$var$sortSearchParams(serializedB);
}
/**
 * Reorder a serialized query string so that params holding the same pairs compare as equal
 * regardless of the order they appear in.
 *
 * @note
 * The serializer percent-encodes `&` and `=` wherever they appear inside a name or a value, so
 * splitting on `&` recovers exactly the pairs and nothing else.
 */ function $c56dee3c9018e2ad$var$sortSearchParams(serialized) {
    return serialized.split('&').sort().join('&');
}
function $c56dee3c9018e2ad$var$isPropertyEqual(a, b, state, property) {
    if ((property === $c56dee3c9018e2ad$var$REACT_OWNER || property === $c56dee3c9018e2ad$var$PREACT_OWNER || property === $c56dee3c9018e2ad$var$PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
    return $c56dee3c9018e2ad$var$hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
}
const $c56dee3c9018e2ad$var$toString = Object.prototype.toString;
/**
 * Create a comparator method based on the type-specific equality comparators passed.
 */ function $c56dee3c9018e2ad$var$createEqualityComparator(config) {
    const supportedComparatorMap = $c56dee3c9018e2ad$var$createSupportedComparatorMap(config);
    const { areArraysEqual: areArraysEqual, areDatesEqual: areDatesEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, getUnsupportedCustomComparator: getUnsupportedCustomComparator } = config;
    /**
     * compare the value of the two objects and return true if they are equivalent in values
     */ return function comparator(a, b, state) {
        // If the items are strictly equal, no need to do a value comparison.
        if (a === b) return true;
        // If either of the items are nullish and fail the strictly equal check
        // above, then they must be unequal.
        if (a == null || b == null) return false;
        const type = typeof a;
        if (type !== typeof b) return false;
        if (type !== 'object') {
            if (type === 'number' || type === 'bigint') return areNumbersEqual(a, b, state);
            if (type === 'function') return areFunctionsEqual(a, b, state);
            // If a primitive value that is not strictly equal, it must be unequal.
            return false;
        }
        const constructor = a.constructor;
        // Checks are listed in order of commonality of use-case:
        //   1. Common complex object types (plain object, array)
        //   2. Common data values (date, regexp)
        //   3. Less-common complex object types (map, set)
        //   4. Less-common data values (promise, primitive wrappers)
        // Inherently this is both subjective and assumptive, however
        // when reviewing comparable libraries in the wild this order
        // appears to be generally consistent.
        // Constructors should match, otherwise there is potential for false positives
        // between class and subclass or custom object and POJO.
        if (constructor !== b.constructor) return false;
        // Try to fast-path equality checks for other complex object types in the
        // same realm to avoid capturing the string tag. Strict equality is used
        // instead of `instanceof` because it is more performant for the common
        // use-case. If someone is creating a subclass from a native class, it will be
        // handled with the string tag comparison.
        if (constructor === Object) return areObjectsEqual(a, b, state);
        if (constructor === Array) return areArraysEqual(a, b, state);
        if (constructor === Date) return areDatesEqual(a, b, state);
        if (constructor === RegExp) return areRegExpsEqual(a, b, state);
        if (constructor === Map) return areMapsEqual(a, b, state);
        if (constructor === Set) return areSetsEqual(a, b, state);
        if (constructor === Promise) // Avoid tag checks for promise values, since we know if they are not referentially equal
        // then they are not equal.
        return false;
        // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
        // the string tag or doing an `instanceof` in edge cases.
        if (Array.isArray(a)) return areArraysEqual(a, b, state);
        // Since this is a custom object, capture the string tag to determining its type.
        // This is reasonably performant in modern environments like v8 and SpiderMonkey.
        const tag = $c56dee3c9018e2ad$var$toString.call(a);
        const supportedComparator = supportedComparatorMap[tag];
        if (supportedComparator) return supportedComparator(a, b, state);
        const unsupportedCustomComparator = getUnsupportedCustomComparator && getUnsupportedCustomComparator(a, b, state, tag);
        if (unsupportedCustomComparator) return unsupportedCustomComparator(a, b, state);
        // If not matching any tags that require a specific type of comparison, then we hard-code false because
        // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
        //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
        //     comparison that can be made.
        //   - For types that can be introspected but do not have an objective definition of what
        //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
        // In all cases, these decisions should be reevaluated based on changes to the language and
        // common development practices.
        return false;
    };
}
/**
 * Create the configuration object used for building comparators.
 */ function $c56dee3c9018e2ad$var$createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
    let config = {
        areArrayBuffersEqual: $c56dee3c9018e2ad$var$areArrayBuffersEqual,
        areArraysEqual: strict ? $c56dee3c9018e2ad$var$areObjectsEqualStrict : $c56dee3c9018e2ad$var$areArraysEqual,
        areDataViewsEqual: $c56dee3c9018e2ad$var$areDataViewsEqual,
        areDatesEqual: $c56dee3c9018e2ad$var$areDatesEqual,
        // `Error` subclasses routinely carry their own enumerable properties (`status`, `code`, ...),
        // which the error comparator alone does not see, so it is composed with the object comparator.
        // `name` / `message` / `stack` are own but not enumerable, which is why errors need a
        // comparator of their own rather than being treated as plain objects in the first place.
        areErrorsEqual: strict ? $c56dee3c9018e2ad$var$combineComparators($c56dee3c9018e2ad$var$areErrorsEqual, $c56dee3c9018e2ad$var$areObjectsEqualStrict) : $c56dee3c9018e2ad$var$combineComparators($c56dee3c9018e2ad$var$areErrorsEqual, $c56dee3c9018e2ad$var$areObjectsEqual),
        areFunctionsEqual: $c56dee3c9018e2ad$var$strictEqual,
        areMapsEqual: strict ? $c56dee3c9018e2ad$var$combineComparators($c56dee3c9018e2ad$var$areMapsEqual, $c56dee3c9018e2ad$var$areObjectsEqualStrict) : $c56dee3c9018e2ad$var$areMapsEqual,
        areNumbersEqual: $c56dee3c9018e2ad$var$sameValueEqual,
        areObjectsEqual: strict ? $c56dee3c9018e2ad$var$areObjectsEqualStrict : $c56dee3c9018e2ad$var$areObjectsEqual,
        arePrimitiveWrappersEqual: $c56dee3c9018e2ad$var$arePrimitiveWrappersEqual,
        areRegExpsEqual: $c56dee3c9018e2ad$var$areRegExpsEqual,
        areSetsEqual: strict ? $c56dee3c9018e2ad$var$combineComparators($c56dee3c9018e2ad$var$areSetsEqual, $c56dee3c9018e2ad$var$areObjectsEqualStrict) : $c56dee3c9018e2ad$var$areSetsEqual,
        areTypedArraysEqual: strict ? $c56dee3c9018e2ad$var$combineComparators($c56dee3c9018e2ad$var$areTypedArraysEqual, $c56dee3c9018e2ad$var$areObjectsEqualStrict) : $c56dee3c9018e2ad$var$areTypedArraysEqual,
        areUrlsEqual: $c56dee3c9018e2ad$var$areUrlsEqual,
        getUnsupportedCustomComparator: undefined
    };
    if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
    if (circular) {
        const areArraysEqual = $c56dee3c9018e2ad$var$createIsCircular(config.areArraysEqual);
        // Errors are included because comparing `cause` and own properties by value means an error
        // that references itself would otherwise recurse without bound.
        const areErrorsEqual = $c56dee3c9018e2ad$var$createIsCircular(config.areErrorsEqual);
        const areMapsEqual = $c56dee3c9018e2ad$var$createIsCircular(config.areMapsEqual);
        const areObjectsEqual = $c56dee3c9018e2ad$var$createIsCircular(config.areObjectsEqual);
        const areSetsEqual = $c56dee3c9018e2ad$var$createIsCircular(config.areSetsEqual);
        config = Object.assign({}, config, {
            areArraysEqual: areArraysEqual,
            areErrorsEqual: areErrorsEqual,
            areMapsEqual: areMapsEqual,
            areObjectsEqual: areObjectsEqual,
            areSetsEqual: areSetsEqual
        });
    }
    return config;
}
/**
 * Default equality comparator pass-through, used as the standard `isEqual` creator for
 * use inside the built comparator.
 */ function $c56dee3c9018e2ad$var$createInternalEqualityComparator(compare) {
    return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
        return compare(a, b, state);
    };
}
/**
 * Create the `isEqual` function used by the consuming application.
 */ function $c56dee3c9018e2ad$var$createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
    if (createState) return function isEqual(a, b) {
        const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
        return comparator(a, b, {
            cache: cache,
            equals: equals,
            meta: meta,
            strict: strict
        });
    };
    if (circular) return function isEqual(a, b) {
        return comparator(a, b, {
            cache: new WeakMap(),
            equals: equals,
            meta: undefined,
            strict: strict
        });
    };
    const state = {
        cache: undefined,
        equals: equals,
        meta: undefined,
        strict: strict
    };
    return function isEqual(a, b) {
        return comparator(a, b, state);
    };
}
/**
 * Create a map of `toString()` values to their respective handlers for `tag`-based lookups.
 */ function $c56dee3c9018e2ad$var$createSupportedComparatorMap({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual }) {
    return {
        '[object Arguments]': areObjectsEqual,
        '[object Array]': areArraysEqual,
        '[object ArrayBuffer]': areArrayBuffersEqual,
        '[object AsyncGeneratorFunction]': areFunctionsEqual,
        '[object BigInt]': arePrimitiveWrappersEqual,
        '[object BigInt64Array]': areTypedArraysEqual,
        '[object BigUint64Array]': areTypedArraysEqual,
        '[object Boolean]': arePrimitiveWrappersEqual,
        '[object DataView]': areDataViewsEqual,
        '[object Date]': areDatesEqual,
        // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
        // enumerable, and therefore will give false positives if tested like a standard object.
        '[object Error]': areErrorsEqual,
        '[object Float16Array]': areTypedArraysEqual,
        '[object Float32Array]': areTypedArraysEqual,
        '[object Float64Array]': areTypedArraysEqual,
        '[object Function]': areFunctionsEqual,
        '[object GeneratorFunction]': areFunctionsEqual,
        '[object Int8Array]': areTypedArraysEqual,
        '[object Int16Array]': areTypedArraysEqual,
        '[object Int32Array]': areTypedArraysEqual,
        '[object Map]': areMapsEqual,
        '[object Number]': arePrimitiveWrappersEqual,
        '[object Object]': (a, b, state)=>// The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state),
        // For RegExp, the properties are not enumerable, and therefore will give false positives if
        // tested like a standard object.
        '[object RegExp]': areRegExpsEqual,
        '[object Set]': areSetsEqual,
        '[object String]': arePrimitiveWrappersEqual,
        '[object URL]': areUrlsEqual,
        '[object Uint8Array]': areTypedArraysEqual,
        '[object Uint8ClampedArray]': areTypedArraysEqual,
        '[object Uint16Array]': areTypedArraysEqual,
        '[object Uint32Array]': areTypedArraysEqual
    };
}
/**
 * Whether the items passed are deeply-equal in value.
 */ const $c56dee3c9018e2ad$export$9e5f44173e64f162 = $c56dee3c9018e2ad$var$createCustomEqual();
/**
 * Whether the items passed are deeply-equal in value based on strict comparison.
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    strict: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references.
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    circular: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references,
 * based on strict comparison.
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    circular: true,
    strict: true
});
/**
 * Whether the items passed are shallowly-equal in value.
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    createInternalComparator: ()=>$c56dee3c9018e2ad$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value based on strict comparison
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    strict: true,
    createInternalComparator: ()=>$c56dee3c9018e2ad$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references.
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    circular: true,
    createInternalComparator: ()=>$c56dee3c9018e2ad$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references,
 * based on strict comparison.
 */ $c56dee3c9018e2ad$var$createCustomEqual({
    circular: true,
    createInternalComparator: ()=>$c56dee3c9018e2ad$var$sameValueEqual,
    strict: true
});
/**
 * Create a custom equality comparison method.
 *
 * This can be done to create very targeted comparisons in extreme hot-path scenarios
 * where the standard methods are not performant enough, but can also be used to provide
 * support for legacy environments that do not support expected features like
 * `RegExp.prototype.flags` out of the box.
 */ function $c56dee3c9018e2ad$var$createCustomEqual(options = {}) {
    const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
    const config = $c56dee3c9018e2ad$var$createEqualityComparatorConfig(options);
    const comparator = $c56dee3c9018e2ad$var$createEqualityComparator(config);
    const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : $c56dee3c9018e2ad$var$createInternalEqualityComparator(comparator);
    return $c56dee3c9018e2ad$var$createIsEqual({
        circular: circular,
        comparator: comparator,
        createState: createState,
        equals: equals,
        strict: strict
    });
}
function $c56dee3c9018e2ad$export$dda1d9f60106f0e9(effect, dependencies) {
    $c56dee3c9018e2ad$var$useCustomCompareEffect(effect, dependencies, $c56dee3c9018e2ad$export$9e5f44173e64f162);
}
/**
 * Set of option keys that can be updated on Map3DElement.
 * Camera props (center, heading, tilt, range, roll) are handled separately.
 */ const $c56dee3c9018e2ad$var$MAP_3D_OPTION_KEYS = new Set([
    'bounds',
    'defaultUIHidden',
    'gestureHandling',
    'internalUsageAttributionIds',
    'maxAltitude',
    'maxHeading',
    'maxTilt',
    'minAltitude',
    'minHeading',
    'minTilt',
    'mode'
]);
/**
 * Hook to update Map3D options when props change.
 *
 * @internal
 */ function $c56dee3c9018e2ad$var$useMap3DOptions(map3d, props) {
    // Filter props to only include valid option keys, memoized to avoid
    // creating a new object on every render
    const options = (0, $2NacA.useMemo)(()=>{
        const result = {};
        const keys = Object.keys(props);
        for (const key of keys){
            if (!$c56dee3c9018e2ad$var$MAP_3D_OPTION_KEYS.has(key)) continue;
            const value = props[key];
            if (value === undefined) continue;
            result[key] = value;
        }
        return result;
    }, [
        props
    ]);
    $c56dee3c9018e2ad$export$dda1d9f60106f0e9(()=>{
        if (!map3d) return;
        Object.assign(map3d, options);
    }, [
        map3d,
        options
    ]);
}
/**
 * MapMode for specifying how the 3D map should be rendered.
 * This mirrors google.maps.maps3d.MapMode but is available without waiting for the API to load.
 */ const $c56dee3c9018e2ad$export$db3b6bfb95261072 = {
    /** This map mode displays a transparent layer of major streets on satellite imagery. */ HYBRID: 'HYBRID',
    /** This map mode displays satellite or photorealistic imagery. */ SATELLITE: 'SATELLITE'
};
/**
 * GestureHandling for specifying how gesture events should be handled on the map.
 * This mirrors google.maps.maps3d.GestureHandling but is available without waiting for the API to load.
 */ const $c56dee3c9018e2ad$export$2329c99376c9d0a4 = {
    /**
     * This lets the map choose whether to use cooperative or greedy gesture handling.
     * This is the default behavior if not specified.
     */ AUTO: 'AUTO',
    /**
     * This forces cooperative mode, where modifier keys or two-finger gestures
     * are required to scroll the map.
     */ COOPERATIVE: 'COOPERATIVE',
    /**
     * This forces greedy mode, where the host page cannot be scrolled from user
     * events on the map element.
     */ GREEDY: 'GREEDY'
};
/**
 * React context for accessing the Map3D instance from child components.
 */ const $c56dee3c9018e2ad$export$8b22cf2602fb60ce = (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createContext(null);
/**
 * Default styles for the map container.
 */ const $c56dee3c9018e2ad$var$DEFAULT_CONTAINER_STYLE = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
/**
 * A React component that renders a 3D map using the Google Maps JavaScript API.
 *
 * @example
 * ```tsx
 * <APIProvider apiKey={API_KEY}>
 *   <Map3D
 *     defaultCenter={{ lat: 37.7749, lng: -122.4194, altitude: 1000 }}
 *     defaultRange={5000}
 *     defaultHeading={0}
 *     defaultTilt={45}
 *   />
 * </APIProvider>
 * ```
 */ const $c56dee3c9018e2ad$export$3a1a48c8f6ef640e = (0, $2NacA.forwardRef)((props, ref)=>{
    const { children: children, id: id, className: className, style: style } = props;
    // Verify we're inside an APIProvider
    const context = (0, $2NacA.useContext)($c56dee3c9018e2ad$export$ebd11618f299a286);
    if (!context) throw new Error('<Map3D> can only be used inside an <APIProvider> component.');
    const { addMap3DInstance: addMap3DInstance, removeMap3DInstance: removeMap3DInstance } = context;
    const [map3d, containerRef, map3dRef, cameraStateRef, isReady] = $c56dee3c9018e2ad$var$useMap3DInstance(props);
    $c56dee3c9018e2ad$var$useMap3DCameraParams(map3d, cameraStateRef, props);
    $c56dee3c9018e2ad$var$useMap3DEvents(map3d, props);
    $c56dee3c9018e2ad$var$useMap3DOptions(map3d, props);
    (0, $2NacA.useEffect)(()=>{
        if (!map3d) return;
        const instanceId = id !== null && id !== void 0 ? id : 'default';
        addMap3DInstance(map3d, instanceId);
        return ()=>{
            removeMap3DInstance(instanceId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        map3d,
        id
    ]);
    (0, $2NacA.useImperativeHandle)(ref, ()=>({
            map3d: map3d,
            flyCameraAround: (options)=>{
                map3d === null || map3d === void 0 || map3d.flyCameraAround(options);
            },
            flyCameraTo: (options)=>{
                map3d === null || map3d === void 0 || map3d.flyCameraTo(options);
            },
            stopCameraAnimation: ()=>{
                map3d === null || map3d === void 0 || map3d.stopCameraAnimation();
            }
        }), [
        map3d
    ]);
    const combinedStyle = (0, $2NacA.useMemo)(()=>Object.assign(Object.assign({}, $c56dee3c9018e2ad$var$DEFAULT_CONTAINER_STYLE), style), [
        style
    ]);
    const contextValue = (0, $2NacA.useMemo)(()=>({
            map3d: map3d
        }), [
        map3d
    ]);
    if (!isReady) return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", Object.assign({
        ref: containerRef,
        "data-testid": "map-3d",
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", Object.assign({
        ref: containerRef,
        "data-testid": "map-3d",
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("gmp-map-3d", {
        ref: map3dRef,
        style: {
            width: '100%',
            height: '100%'
        }
    }, map3d && (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($c56dee3c9018e2ad$export$8b22cf2602fb60ce.Provider, {
        value: contextValue
    }, children)));
});
$c56dee3c9018e2ad$export$3a1a48c8f6ef640e.displayName = 'Map3D';
const $c56dee3c9018e2ad$export$f1e1789686576879 = (0, $2NacA.createContext)(null);
/**
 * Hook to access the Marker3D context.
 */ function $c56dee3c9018e2ad$export$39b482c5e57630a8() {
    return (0, $2NacA.useContext)($c56dee3c9018e2ad$export$f1e1789686576879);
}
/**
 * Marker3D component for displaying markers on a Map3D.
 *
 * Automatically uses Marker3DInteractiveElement when onClick is provided,
 * otherwise uses Marker3DElement.
 *
 * Children can include:
 * - `<img>` elements (automatically wrapped in <template>)
 * - `<svg>` elements (automatically wrapped in <template>)
 * - PinElement instances (passed through directly)
 *
 * @example
 * ```tsx
 * // Basic marker
 * <Marker3D position={{ lat: 37.7749, lng: -122.4194 }} label="SF" />
 *
 * // Interactive marker
 * <Marker3D
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   onClick={() => console.log('clicked')}
 *   title="Click me"
 * />
 *
 * // Custom marker with image
 * <Marker3D position={{ lat: 37.7749, lng: -122.4194 }}>
 *   <img src="/icon.png" width={32} height={32} />
 * </Marker3D>
 * ```
 */ const $c56dee3c9018e2ad$export$4368d992c4eafac0 = (0, $2NacA.forwardRef)(function Marker3D(props, ref) {
    const { children: children, onClick: onClick, position: position, altitudeMode: altitudeMode, collisionBehavior: collisionBehavior, drawsWhenOccluded: drawsWhenOccluded, extruded: extruded, label: label, sizePreserved: sizePreserved, zIndex: zIndex, title: title } = props;
    const isInteractive = Boolean(onClick);
    const [marker, setMarker] = (0, $2NacA.useState)(null);
    // Track if a child component (like Pin) is handling its own content
    const [contentHandledExternally, setContentHandledExternally] = (0, $2NacA.useState)(false);
    // Create a container for rendering React children to be wrapped and relocated
    // into the parent gmp-marker-3d element.
    const contentContainer = (0, $2NacA.useMemo)(()=>{
        const container = document.createElement('div');
        container.style.display = 'none';
        document.body.appendChild(container);
        return container;
    }, []);
    // Remove the container on unmount
    (0, $2NacA.useEffect)(()=>{
        return ()=>contentContainer.remove();
    }, [
        contentContainer
    ]);
    // Callback ref that sets both internal state and forwards the ref
    const markerRef = (0, $2NacA.useCallback)((node)=>{
        setMarker(node);
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    }, [
        ref
    ]);
    $c56dee3c9018e2ad$export$407448d2b89b1813(marker, 'gmp-click', onClick);
    // Move React children to marker's slot, wrapping img/svg in <template> as required by the API
    (0, $2NacA.useLayoutEffect)(()=>{
        if (contentHandledExternally) return;
        if (!marker || !contentContainer) return;
        while(marker.firstChild)marker.removeChild(marker.firstChild);
        const childNodes = Array.from(contentContainer.childNodes);
        for (const node of childNodes){
            if (node.nodeType !== Node.ELEMENT_NODE) continue;
            const element = node;
            const tagName = element.tagName.toLowerCase();
            if (tagName === 'img' || tagName === 'svg') {
                const template = document.createElement('template');
                template.content.appendChild(element.cloneNode(true));
                marker.appendChild(template);
            } else marker.appendChild(element.cloneNode(true));
        }
    }, [
        marker,
        contentContainer,
        children,
        contentHandledExternally
    ]);
    const contextValue = (0, $2NacA.useMemo)(()=>({
            marker: marker,
            setContentHandledExternally: setContentHandledExternally
        }), [
        marker
    ]);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'position', position);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'altitudeMode', altitudeMode);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'collisionBehavior', collisionBehavior);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'drawsWhenOccluded', drawsWhenOccluded);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'extruded', extruded);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'label', label);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'sizePreserved', sizePreserved);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'zIndex', zIndex);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(marker, 'title', title !== null && title !== void 0 ? title : '');
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($c56dee3c9018e2ad$export$f1e1789686576879.Provider, {
        value: contextValue
    }, isInteractive ? (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("gmp-marker-3d-interactive", {
        ref: markerRef
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("gmp-marker-3d", {
        ref: markerRef
    }), (0, $l6sdi.createPortal)(children, contentContainer));
});
$c56dee3c9018e2ad$export$4368d992c4eafac0.displayName = 'Marker3D';
function $c56dee3c9018e2ad$export$2408f22a0fab9ae5(element, styles, prevStyles) {
    if (styles != null && typeof styles !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    const elementStyle = element.style;
    // without `prevStyles`, just set all values
    if (prevStyles == null) {
        if (styles == null) return;
        for(const styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            $c56dee3c9018e2ad$var$setValueForStyle(elementStyle, styleName, styles[styleName]);
        }
        return;
    }
    // unset all styles in `prevStyles` that aren't in `styles`
    for(const styleName in prevStyles)if (prevStyles.hasOwnProperty(styleName) && (styles == null || !styles.hasOwnProperty(styleName))) {
        // Clear style
        const isCustomProperty = styleName.indexOf('--') === 0;
        if (isCustomProperty) elementStyle.setProperty(styleName, '');
        else if (styleName === 'float') elementStyle.cssFloat = '';
        else elementStyle[styleName] = '';
    }
    // only assign values from `styles` that are different from `prevStyles`
    if (styles == null) return;
    for(const styleName in styles){
        const value = styles[styleName];
        if (styles.hasOwnProperty(styleName) && prevStyles[styleName] !== value) $c56dee3c9018e2ad$var$setValueForStyle(elementStyle, styleName, value);
    }
}
function $c56dee3c9018e2ad$var$setValueForStyle(elementStyle, styleName, value) {
    const isCustomProperty = styleName.indexOf('--') === 0;
    // falsy values will unset the style property
    if (value == null || typeof value === 'boolean' || value === '') {
        if (isCustomProperty) elementStyle.setProperty(styleName, '');
        else if (styleName === 'float') elementStyle.cssFloat = '';
        else elementStyle[styleName] = '';
    } else if (isCustomProperty) elementStyle.setProperty(styleName, value);
    else if (typeof value === 'number' && value !== 0 && !$c56dee3c9018e2ad$var$isUnitlessNumber(styleName)) elementStyle[styleName] = value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
    else if (styleName === 'float') elementStyle.cssFloat = value;
    else elementStyle[styleName] = ('' + value).trim();
}
// CSS properties which accept numbers but are not in units of "px".
const $c56dee3c9018e2ad$var$unitlessNumbers = new Set([
    'animationIterationCount',
    'aspectRatio',
    'borderImageOutset',
    'borderImageSlice',
    'borderImageWidth',
    'boxFlex',
    'boxFlexGroup',
    'boxOrdinalGroup',
    'columnCount',
    'columns',
    'flex',
    'flexGrow',
    'flexPositive',
    'flexShrink',
    'flexNegative',
    'flexOrder',
    'gridArea',
    'gridRow',
    'gridRowEnd',
    'gridRowSpan',
    'gridRowStart',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnSpan',
    'gridColumnStart',
    'fontWeight',
    'lineClamp',
    'lineHeight',
    'opacity',
    'order',
    'orphans',
    'scale',
    'tabSize',
    'widows',
    'zIndex',
    'zoom',
    'fillOpacity',
    'floodOpacity',
    'stopOpacity',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth'
]);
function $c56dee3c9018e2ad$var$isUnitlessNumber(name) {
    return $c56dee3c9018e2ad$var$unitlessNumbers.has(name);
}
/**
 * Popover component for displaying info windows on a Map3D.
 *
 * Similar to InfoWindow for 2D maps, Popover provides a way to show
 * contextual information at a specific location or attached to a marker
 * on a 3D map.
 *
 * @example
 * ```tsx
 * // Basic popover at position
 * <Popover
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   open={isOpen}
 * >
 *   <div>Hello from San Francisco!</div>
 * </Popover>
 *
 * // Popover anchored to a marker (place as sibling, use anchor prop)
 * <Marker3D
 *   ref={markerRef}
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   onClick={() => setOpen(true)}
 * />
 * <Popover
 *   anchor={markerRef.current}
 *   open={isOpen}
 *   onClose={() => setOpen(false)}
 * >
 *   <div>Marker info</div>
 * </Popover>
 * ```
 */ const $c56dee3c9018e2ad$export$56c0d5a1e737357d = (0, $2NacA.forwardRef)(function Popover(props, ref) {
    var _a;
    const { children: children, headerContent: headerContent, style: style, className: className, open: open = true, position: position, anchor: anchor, anchorId: anchorId, altitudeMode: altitudeMode, lightDismissDisabled: lightDismissDisabled, autoPanDisabled: autoPanDisabled, onClose: onClose } = props;
    const [popover, setPopover] = (0, $2NacA.useState)(null);
    const prevStyleRef = (0, $2NacA.useRef)(null);
    // Forward the ref to the parent
    (0, $2NacA.useImperativeHandle)(ref, ()=>popover, [
        popover
    ]);
    // Observe the open attribute and call onClose when popover is automatically
    // closed by the Maps API (light dismiss)
    $c56dee3c9018e2ad$var$usePopoverCloseObserver(popover, open, onClose);
    // Set properties on the popover element
    $c56dee3c9018e2ad$export$3b14a55fb2447963(popover, 'open', open !== null && open !== void 0 ? open : false);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(popover, 'altitudeMode', altitudeMode);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(popover, 'lightDismissDisabled', lightDismissDisabled);
    $c56dee3c9018e2ad$export$3b14a55fb2447963(popover, 'autoPanDisabled', autoPanDisabled);
    // positionAnchor accepts a position, marker element, or marker ID string
    const positionAnchor = (_a = anchor !== null && anchor !== void 0 ? anchor : anchorId) !== null && _a !== void 0 ? _a : position;
    $c56dee3c9018e2ad$export$3b14a55fb2447963(popover, 'positionAnchor', positionAnchor);
    // Set styles via ref for compatibility with older React versions
    (0, $2NacA.useLayoutEffect)(()=>{
        if (!popover) return;
        $c56dee3c9018e2ad$export$2408f22a0fab9ae5(popover, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
    }, [
        popover,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("gmp-popover", {
        ref: setPopover,
        className: className
    }, headerContent && (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("div", {
        slot: "header"
    }, headerContent), children);
});
$c56dee3c9018e2ad$export$56c0d5a1e737357d.displayName = 'Popover';
/**
 * Custom hook to observe the open attribute of a popover element
 * and call onClose when it transitions from open to closed due to light dismiss.
 * Does not call onClose when the open prop changes programmatically.
 */ function $c56dee3c9018e2ad$var$usePopoverCloseObserver(popover, open, onClose) {
    const previousOpenState = (0, $2NacA.useRef)(undefined);
    const openPropRef = (0, $2NacA.useRef)(open);
    // Track the open prop value
    (0, $2NacA.useEffect)(()=>{
        openPropRef.current = open;
    }, [
        open
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!popover || !onClose) return;
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                const isOpen = popover.hasAttribute('open');
                // Only call onClose when:
                // 1. Transitioning from open to closed
                // 2. The prop hasn't changed to false (meaning this was light dismiss, not programmatic)
                if (previousOpenState.current === true && !isOpen && openPropRef.current !== false) onClose();
                previousOpenState.current = isOpen;
            }
        });
        observer.observe(popover, {
            attributes: true,
            attributeFilter: [
                'open'
            ]
        });
        // Initialize the previous state
        previousOpenState.current = popover.hasAttribute('open');
        return ()=>{
            observer.disconnect();
        };
    }, [
        popover,
        onClose
    ]);
}
const $c56dee3c9018e2ad$var$shownMessages = new Set();
function $c56dee3c9018e2ad$export$7ccc53e8f1e7dfc5(...args) {
    const key = JSON.stringify(args);
    if (!$c56dee3c9018e2ad$var$shownMessages.has(key)) {
        $c56dee3c9018e2ad$var$shownMessages.add(key);
        console.error(...args);
    }
}
/**
 * Hook to retrieve a Map3DElement instance from context.
 *
 * When called without an id, it returns the map from the nearest parent Map3D
 * component. When called with an id, it retrieves the map with that id from
 * the APIProvider context.
 *
 * @param id - Optional id of the map to retrieve. If not specified, returns
 *   the parent map instance or the default map instance.
 *
 * @example
 * ```tsx
 * // Get the parent Map3D instance
 * function MyComponent() {
 *   const map3d = useMap3D();
 *   // ...
 * }
 *
 * // Get a specific Map3D instance by id
 * function ControlPanel() {
 *   const mainMap = useMap3D('main-map');
 *   const miniMap = useMap3D('mini-map');
 *   // ...
 * }
 * ```
 */ function $c56dee3c9018e2ad$export$2d1720544b23b823(id = null) {
    const apiContext = (0, $2NacA.useContext)($c56dee3c9018e2ad$export$ebd11618f299a286);
    const map3dContext = (0, $2NacA.useContext)($c56dee3c9018e2ad$export$8b22cf2602fb60ce);
    if (apiContext === null) {
        $c56dee3c9018e2ad$export$7ccc53e8f1e7dfc5("useMap3D(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap3D()` from is a child of the <APIProvider>.");
        return null;
    }
    const { map3dInstances: map3dInstances } = apiContext;
    // Lookup priority: explicit id > parent context > default instance
    if (id !== null) return map3dInstances[id] || null;
    if (map3dContext === null || map3dContext === void 0 ? void 0 : map3dContext.map3d) return map3dContext.map3d;
    return map3dInstances['default'] || null;
}

});


parcelRegister("987Mn", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteSuggestions", () => $01c5b8293b2e670c$export$b39a9f86c7843060);

var $2NacA = parcelRequire("2NacA");
parcelRequire("4xbxO");
var $ldQFt = parcelRequire("ldQFt");
function $01c5b8293b2e670c$export$b39a9f86c7843060(inputString, requestOptions = {}) {
    const placesLib = (0, $ldQFt.p)('places');
    // stores the current sessionToken
    const sessionTokenRef = (0, $2NacA.useRef)(null);
    // the suggestions based on the specified input
    const [suggestions, setSuggestions] = (0, $2NacA.useState)([]);
    // indicates if there is currently an incomplete request to the places API
    const [isLoading, setIsLoading] = (0, $2NacA.useState)(false);
    // once the PlacesLibrary is loaded and whenever the input changes, a query
    // is sent to the Autocomplete Data API.
    (0, $2NacA.useEffect)(()=>{
        const getData = async ()=>{
            if (!placesLib || !inputString) return;
            const { AutocompleteSessionToken: AutocompleteSessionToken, AutocompleteSuggestion: AutocompleteSuggestion } = placesLib;
            // Create a new session if one doesn't already exist. This has to be reset
            // after `fetchFields` for one of the returned places is called by calling
            // the `resetSession` function returned from this hook.
            if (!sessionTokenRef.current) sessionTokenRef.current = new AutocompleteSessionToken();
            const request = {
                ...requestOptions,
                input: inputString,
                sessionToken: sessionTokenRef.current,
                includedPrimaryTypes: [
                    'premise',
                    'subpremise',
                    'street_address'
                ]
            };
            if (inputString === '') {
                if (suggestions.length > 0) setSuggestions([]);
                return;
            }
            setIsLoading(true);
            try {
                const response = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
                setSuggestions(response.suggestions);
            } catch (error) {
                console.error('Error fetching autocomplete suggestions:', error);
                setIsLoading(false);
                setSuggestions([]);
            }
        };
        getData();
    }, [
        placesLib,
        inputString
    ]);
    return {
        suggestions: suggestions,
        isLoading: isLoading,
        resetSession: ()=>{
            sessionTokenRef.current = null;
            setSuggestions([]);
        }
    };
}

});


parcelRegister("ktlnN", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $8Ao5G = parcelRequire("8Ao5G");

var $2xT0V = parcelRequire("2xT0V");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");
var $l3pMM = parcelRequire("l3pMM");

var $8DltC = parcelRequire("8DltC");
parcelRequire("hcQWc");
var $8PeUS = parcelRequire("8PeUS");
const $67afa1e1d1eb40c2$export$a96c9fe9ed51e686 = (0, $j8yBr.observer)(({ scriptId: scriptId, roles: roles })=>{
    const [costumes, setCostumes] = (0, $2NacA.useState)([]);
    const projectStore = (0, $8DltC.useProjectStore)();
    const costumeStore = (0, $8DltC.useCostumeStore)();
    (0, $2NacA.useEffect)(()=>{
        if (!scriptId) return;
        const getCostumes = async ()=>{
            const costumes = await costumeStore.getCostumesByScriptId(scriptId);
            costumes && setCostumes(costumes);
        };
        getCostumes();
    }, [
        scriptId
    ]);
    const newCostume = async ()=>{
        if (!scriptId || !projectStore.currentProject?.id) return;
        const costumeRequest = {
            name: 'New Costume',
            type: (0, $8PeUS.CostumeType).Standard,
            scriptIds: [
                scriptId
            ],
            projectId: projectStore.currentProject.id
        };
        const costume = await costumeStore.createCostume(costumeRequest);
        costumes && costume && setCostumes([
            ...costumes,
            costume
        ]);
    };
    const deleteCostumes = async (ids)=>{
        ids.forEach(async (id)=>await costumeStore.deleteCostume(id));
        setCostumes(costumes.filter((r)=>!ids.includes(r.id)));
    };
    const updateCostume = async (update, index)=>{
        const costume = await costumeStore.updateCostume(update);
        if (!costume) return;
        const newCostumes = [
            ...costumes
        ];
        newCostumes[index] = costume;
        setCostumes(newCostumes);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: costumes,
        newItem: newCostume,
        deleteItems: deleteCostumes,
        updateItem: updateCostume,
        label: "Costume",
        labelPlural: "Costumes",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2xT0V.UserPolice), {}),
        types: [
            {
                label: 'Costume Type',
                key: 'type',
                values: Object.values((0, $8PeUS.CostumeType))
            }
        ],
        children: costumes.map((costume, index)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                pad: {
                    horizontal: 'small'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                    label: "Role/Owner",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                        value: costume.owner?.id || '',
                        options: roles,
                        onChange: (value)=>updateCostume({
                                ...costumes[index],
                                owner: roles.find((r)=>r.id === value)
                            }, index),
                        size: "small"
                    }, "role")
                })
            }, costume.id))
    });
});

});

parcelRegister("fRK3V", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $6yFNt = parcelRequire("6yFNt");

var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");
var $4sVOM = parcelRequire("4sVOM");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $1Ofsp = parcelRequire("1Ofsp");

var $8DltC = parcelRequire("8DltC");
const $ac7cf14b72027164$export$eb3b16a05ddb223a = (0, $j8yBr.observer)(({ doc: doc, update: update, close: close })=>{
    const [, setCurrentScript] = (0, $2NacA.useState)(undefined);
    const projectStore = (0, $8DltC.useProjectStore)();
    (0, $2NacA.useEffect)(()=>{
        // fetch script
        const getScript = async ()=>{
            if (!doc || doc.type !== (0, $6yFNt.DocumentType).Script) {
                setCurrentScript(undefined);
                return;
            }
            const script = await projectStore.getScriptByDocId(doc.id);
            script && setCurrentScript(script);
        };
        getScript();
    }, [
        doc
    ]);
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        pad: "medium",
        background: "light-2",
        margin: "medium",
        round: "medium",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    width: "100%",
                    direction: "row",
                    justify: "end",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                        onClick: ()=>close(),
                        style: {
                            cursor: 'pointer'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "column",
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                margin: {
                                    right: 'small'
                                },
                                children: [
                                    doc.type,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                val: doc.name,
                                onChange: (name)=>update({
                                        ...doc,
                                        name: name
                                    })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4sVOM.Link), {})
                        ]
                    })
                })
            })
        ]
    });
});

});
parcelRegister("4sVOM", function(module, exports) {

$parcel$export(module.exports, "Link", () => $3406a0691cb5ebc9$export$a6c7ac8248d6e38a);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $3406a0691cb5ebc9$var$_extends() {
    return $3406a0691cb5ebc9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3406a0691cb5ebc9$var$_extends.apply(null, arguments);
}
var $3406a0691cb5ebc9$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $3406a0691cb5ebc9$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Link"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16.125 2.42a2.009 2.009 0 0 1 2.84-.001l2.616 2.617a2 2 0 0 1-.001 2.839l-3.705 3.705a2.009 2.009 0 0 1-2.84.001L12.42 8.964a2 2 0 0 1 .001-2.839l3.705-3.705zm-10 10a2.009 2.009 0 0 1 2.84-.001l2.616 2.617a2 2 0 0 1-.001 2.839L7.875 21.58a2.009 2.009 0 0 1-2.84.001L2.42 18.964a2 2 0 0 1 .001-2.839l3.705-3.705zM7 17 17 7"
    }));
});
$3406a0691cb5ebc9$export$a6c7ac8248d6e38a.displayName = 'Link';

});


parcelRegister("agggX", function(module, exports) {

$parcel$export(module.exports, "DocumentsPanel", () => $adf0510c4fd38df5$export$a79a99b178f02bc4);

var $6ir3O = parcelRequire("6ir3O");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");

var $iuXEp = parcelRequire("iuXEp");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $1Ofsp = parcelRequire("1Ofsp");
var $7wM4T = parcelRequire("7wM4T");

var $8DltC = parcelRequire("8DltC");

var $bUuUi = parcelRequire("bUuUi");

var $gJnkF = parcelRequire("gJnkF");
const $adf0510c4fd38df5$export$a79a99b178f02bc4 = (0, $j8yBr.observer)(({ cardProps: cardProps, headerBackground: headerBackground })=>{
    const projectStore = (0, $8DltC.useProjectStore)();
    const [documents, setDocuments] = (0, $2NacA.useState)(projectStore.currentProject?.documents || []);
    const [, setCurrentDocument] = (0, $2NacA.useState)(undefined);
    const [showUpload, setShowUpload] = (0, $2NacA.useState)(false);
    const [selected, setSelected] = (0, $2NacA.useState)([]);
    (0, $2NacA.useEffect)(()=>{
        const projectId = projectStore.currentProject?.id;
        if (!projectId) return;
        setDocuments(projectStore.currentProject?.documents || []);
    }, [
        projectStore.currentProject?.id,
        projectStore.currentProject?.documents
    ]);
    const deleteDocuments = async ()=>{
        if (!selected.length) return;
        for (const id of selected)await projectStore.deleteDocument(id);
        setDocuments(documents.filter((l)=>!selected.includes(l.id)));
        setCurrentDocument(undefined);
        setSelected([]);
    };
    const updateDocument = async (update)=>{
        const document = await projectStore.updateDocument(update.id, update);
        if (!document) return;
        const newDocuments = documents.map((d)=>d.id === document.id ? document : d);
        setDocuments(newDocuments);
    };
    const newDoc = ()=>{
        setShowUpload(true);
    };
    const choose = (id)=>{
        if (selected.includes(id)) {
            setSelected(selected.filter((s)=>s !== id));
            setCurrentDocument(undefined);
        } else {
            setSelected([
                ...selected,
                id
            ]);
            setCurrentDocument(documents.find((d)=>d.id === id));
        }
    };
    const selectedNames = ()=>{
        return selected.map((s)=>documents.find((item)=>item.id === s)?.name).join(', ');
    };
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $7wM4T.TalonCard), {
        newItem: newDoc,
        deleteItems: deleteDocuments,
        label: "Document",
        labelPlural: "Documents",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iuXEp.DocumentUpload), {}),
        selectedNames: selectedNames(),
        cardProps: cardProps,
        headerBackground: headerBackground,
        children: [
            showUpload && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gJnkF.DocumentUploadModal), {
                setShowUpload: setShowUpload
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                direction: "column",
                overflow: {
                    vertical: 'auto'
                },
                align: "start",
                gap: "small",
                pad: "small",
                children: documents.map((doc)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        align: "center",
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                checked: selected.includes(doc.id),
                                onChange: ()=>choose(doc.id)
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                onClick: ()=>setCurrentDocument(doc),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bUuUi.DocumentLink), {
                                    doc: doc
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                color: "dark-5",
                                children: doc.type
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                val: doc.name,
                                onChange: (name)=>updateDocument({
                                        ...doc,
                                        name: name
                                    })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                color: "dark-5",
                                children: new Date(doc.created_at).toLocaleString()
                            })
                        ]
                    }, doc.id))
            })
        ]
    });
});

});

parcelRegister("84VT2", function(module, exports) {

$parcel$export(module.exports, "GoogleMap", () => $47e06957ad2df213$export$4ad1bae46276c5ce);

var $6ir3O = parcelRequire("6ir3O");

var $4xbxO = parcelRequire("4xbxO");
const $47e06957ad2df213$export$4ad1bae46276c5ce = ({ position: position, zoom: zoom, minHeight: minHeight, id: id })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4xbxO.Map), {
        center: position,
        zoom: zoom,
        style: {
            minHeight: minHeight || '200px'
        },
        id: id,
        disableDefaultUI: true,
        gestureHandling: "none",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4xbxO.Marker), {
            position: position,
            title: 'AdvancedMarker with customized pin.'
        })
    });
};

});

parcelRegister("3qrf8", function(module, exports) {

$parcel$export(module.exports, "Location", () => $94fa0424ea0cf84f$export$18a2be9195644f38);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");

var $2NacA = parcelRequire("2NacA");

var $ldQFt = parcelRequire("ldQFt");
parcelRequire("ibR9R");
var $84VT2 = parcelRequire("84VT2");

var $bs8mA = parcelRequire("bs8mA");

var $8DltC = parcelRequire("8DltC");

var $7nvgV = parcelRequire("7nvgV");

var $bsB3E = parcelRequire("bsB3E");
const $94fa0424ea0cf84f$export$18a2be9195644f38 = (props)=>{
    const { place: place, id: id, updatePlace: updatePlace } = props;
    const { street_address: street_address, city: city, state: state, zip: zip, lat: lat, lng: lng } = place ?? {};
    const projectStore = (0, $8DltC.useProjectStore)();
    const [apiKey, setApiKey] = (0, $2NacA.useState)(undefined);
    (0, $2NacA.useEffect)(()=>{
        const getApiKey = async ()=>{
            const apiKey = await projectStore.getMapApiKey();
            setApiKey(apiKey);
        };
        getApiKey();
    }, []);
    const extractAddress = async (place)=>{
        if (!place.addressComponents) {
            (0, $bsB3E.toast).error('No address components found in the selected place.');
            return;
        }
        const address = (0, $7nvgV.getAddressObject)(place.addressComponents);
        address.lat = place.location?.lat();
        address.lng = place.location?.lng();
        if (!address.state) {
            (0, $bsB3E.toast).error('State is required to update the location.');
            return;
        }
        address.state = (0, $7nvgV.stateAbbreviations)[address.state.toLowerCase()];
        updatePlace(address);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        direction: "column",
        pad: "small",
        children: apiKey && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $ldQFt.t), {
            apiKey: apiKey,
            libraries: [
                'places',
                'marker'
            ],
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                pad: "small",
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row",
                        align: "center",
                        gap: "small",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bs8mA.AutocompleteCustom), {
                            onPlaceSelect: (place)=>{
                                if (place) extractAddress(place);
                            },
                            defaultValue: street_address !== '' ? `${street_address} ${city} ${state} ${zip}` : undefined
                        })
                    }),
                    !!(lat && lng) && apiKey && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $84VT2.GoogleMap), {
                        apiKey: apiKey,
                        position: {
                            lat: lat,
                            lng: lng
                        },
                        zoom: 10,
                        id: id || 'new'
                    })
                ]
            })
        })
    });
};

});
parcelRegister("7nvgV", function(module, exports) {

$parcel$export(module.exports, "getAddressObject", () => $fd9b2434732ac81a$export$61e868231665412f);
$parcel$export(module.exports, "stateAbbreviations", () => $fd9b2434732ac81a$export$777b6d81ad7a4f6a);
const $fd9b2434732ac81a$export$61e868231665412f = (address_components)=>{
    const ShouldBeComponent = {
        number: [
            'street_number'
        ],
        zip: [
            'postal_code'
        ],
        street: [
            'street_address',
            'route'
        ],
        aptOrUnit: [
            'subpremise'
        ],
        state: [
            'administrative_area_level_1',
            'administrative_area_level_2',
            'administrative_area_level_3',
            'administrative_area_level_4',
            'administrative_area_level_5'
        ],
        city: [
            'locality',
            'sublocality',
            'sublocality_level_1',
            'sublocality_level_2',
            'sublocality_level_3',
            'sublocality_level_4',
            'neighborhood'
        ],
        country: [
            'country'
        ]
    };
    const address = {
        street_address: '',
        aptOrUnit: '',
        number: '',
        zip: '',
        street: '',
        state: '',
        city: '',
        country: ''
    };
    address_components.forEach((component)=>{
        for(const shouldBe in ShouldBeComponent)if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
            if (shouldBe === 'country') address[shouldBe] = component.shortText || component.longText || '';
            else address[shouldBe] = component.longText || component.shortText || '';
        }
    });
    address.street_address = `${address.number} ${address.street}`;
    return address;
};
const $fd9b2434732ac81a$export$777b6d81ad7a4f6a = {
    'alabama': 'AL',
    'alaska': 'AK',
    'arizona': 'AZ',
    'arkansas': 'AR',
    'california': 'CA',
    'colorado': 'CO',
    'connecticut': 'CT',
    'delaware': 'DE',
    'florida': 'FL',
    'georgia': 'GA',
    'hawaii': 'HI',
    'idaho': 'ID',
    'illinois': 'IL',
    'indiana': 'IN',
    'iowa': 'IA',
    'kansas': 'KS',
    'kentucky': 'KY',
    'louisiana': 'LA',
    'maine': 'ME',
    'maryland': 'MD',
    'massachusetts': 'MA',
    'michigan': 'MI',
    'minnesota': 'MN',
    'mississippi': 'MS',
    'missouri': 'MO',
    'montana': 'MT',
    'nebraska': 'NE',
    'nevada': 'NV',
    'new hampshire': 'NH',
    'new jersey': 'NJ',
    'new mexico': 'NM',
    'new york': 'NY',
    'north carolina': 'NC',
    'north dakota': 'ND',
    'ohio': 'OH',
    'oklahoma': 'OK',
    'oregon': 'OR',
    'pennsylvania': 'PA',
    'rhode island': 'RI',
    'south carolina': 'SC',
    'south dakota': 'SD',
    'tennessee': 'TN',
    'texas': 'TX',
    'utah': 'UT',
    'vermont': 'VT',
    'virginia': 'VA',
    'washington': 'WA',
    'west virginia': 'WV',
    'wisconsin': 'WI',
    'wyoming': 'WY',
    'district of columbia': 'DC'
};

});


parcelRegister("cRsVF", function(module, exports) {

$parcel$export(module.exports, "LocationPanel", () => $228c1321fba1460e$export$aa4baff5242ea6e1);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $gGAG2 = parcelRequire("gGAG2");
var $eJ3Q3 = parcelRequire("eJ3Q3");

var $3WslH = parcelRequire("3WslH");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("3Focm");
var $3qrf8 = parcelRequire("3qrf8");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");

var $8DltC = parcelRequire("8DltC");
const $228c1321fba1460e$export$aa4baff5242ea6e1 = (0, $j8yBr.observer)(({ cardProps: cardProps, headerBackground: headerBackground })=>{
    const [locations, setLocations] = (0, $2NacA.useState)([]);
    const projectStore = (0, $8DltC.useProjectStore)();
    (0, $2NacA.useEffect)(()=>{
        const projectId = projectStore.currentProject?.id;
        if (!projectId) return;
        const getLocations = async ()=>{
            const locs = await projectStore.getLocationsByProjectId(projectId);
            setLocations(locs || []);
        };
        getLocations();
    }, [
        projectStore.currentProject?.id
    ]);
    const newLocation = async ()=>{
        if (!projectStore.currentProject?.id) return;
        const location = {
            name: 'Location Name',
            type: (0, $gGAG2.LocationType).Nearby,
            street_address: '',
            aptOrUnit: '',
            city: '',
            state: '',
            zip: '',
            projectId: projectStore.currentProject.id,
            id: 'new',
            created_at: '',
            updated_at: '',
            project: projectStore.currentProject,
            session_activities: []
        };
        setLocations([
            ...locations,
            location
        ]);
    };
    const deleteLocations = async (ids)=>{
        for (const id of ids)await projectStore.deleteLocation(id);
        setLocations(locations.filter((l)=>!ids.includes(l.id)));
    };
    const updateLocation = async (update, index)=>{
        if (!projectStore.currentProject?.id || !update) return;
        if (update.id === 'new') {
            if (!update.name || !update.street_address || !update.city || !update.state || !update.zip || !update.type || !update.lat || !update.lng) return;
            const updateRequest = {
                ...update,
                id: undefined,
                created_at: undefined,
                updated_at: undefined
            };
            const location = await projectStore.createLocation({
                ...updateRequest,
                projectId: projectStore.currentProject?.id
            });
            if (!location) return;
            // replace the 'new' location with the created one
            setLocations(locations.map((loc)=>loc.id === 'new' ? location : loc));
            return;
        }
        const location = await projectStore.updateLocation(update);
        if (!location) return;
        const newLocations = [
            ...locations
        ];
        newLocations[index] = location;
        setLocations(newLocations);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: locations,
        newItem: newLocation,
        deleteItems: deleteLocations,
        updateItem: updateLocation,
        label: "Location",
        labelPlural: "Locations",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3WslH.MapLocation), {}),
        types: [
            {
                label: 'Location Type',
                key: 'type',
                values: Object.values((0, $gGAG2.LocationType))
            },
            {
                label: 'Studio Zone',
                key: 'studio_zone',
                values: Object.values((0, $eJ3Q3.StudioZone)),
                readonly: true
            }
        ],
        cardProps: cardProps,
        color: "accent-1",
        headerBackground: headerBackground,
        children: locations.map(({ session_activities: session_activities, project: project, ...location }, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $3qrf8.Location), {
                place: location,
                id: location.id,
                updatePlace: (p)=>updateLocation({
                        ...locations[i],
                        session_activities: session_activities,
                        project: project,
                        ...p
                    }, i)
            }, location.id))
    });
});

});

parcelRegister("65HyY", function(module, exports) {

$parcel$export(module.exports, "ProjectCostumePanel", () => $406e67f86947d690$export$668a960ed12e88e2);

var $6ir3O = parcelRequire("6ir3O");

var $2xT0V = parcelRequire("2xT0V");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");

var $8DltC = parcelRequire("8DltC");
parcelRequire("hcQWc");
var $8PeUS = parcelRequire("8PeUS");
const $406e67f86947d690$export$668a960ed12e88e2 = (0, $j8yBr.observer)(({ scriptId: scriptId, role: role })=>{
    const [costumes, setCostumes] = (0, $2NacA.useState)([]);
    const projectStore = (0, $8DltC.useProjectStore)();
    const costumeStore = (0, $8DltC.useCostumeStore)();
    (0, $2NacA.useEffect)(()=>{
        if (!role) return;
        const getCostumes = async ()=>{
            const costumes = await costumeStore.getCostumesByRoleId(role.id);
            costumes && setCostumes(costumes);
        };
        getCostumes();
    }, [
        role
    ]);
    const newCostume = async ()=>{
        if (!projectStore.currentProject?.id) return;
        const costumeRequest = {
            name: 'New Costume',
            type: (0, $8PeUS.CostumeType).Standard,
            scriptIds: scriptId ? [
                scriptId
            ] : [],
            projectId: projectStore.currentProject.id,
            ownerId: role.id
        };
        const costume = await costumeStore.createCostume(costumeRequest);
        costumes && costume && setCostumes([
            ...costumes,
            costume
        ]);
        costume && role.costumes?.push(costume);
    };
    const deleteCostumes = async (ids)=>{
        ids.forEach(async (id)=>await costumeStore.deleteCostume(id));
        setCostumes(costumes.filter((r)=>!ids.includes(r.id)));
        role.costumes = role.costumes?.filter((r)=>!ids.includes(r.id));
    };
    const updateCostume = async (update, index)=>{
        const costume = await costumeStore.updateCostume(update);
        if (!costume) return;
        const newCostumes = [
            ...costumes
        ];
        newCostumes[index] = costume;
        setCostumes(newCostumes);
        role.costumes = role.costumes?.map((r)=>r.id === costume.id ? costume : r);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: costumes,
        newItem: newCostume,
        deleteItems: deleteCostumes,
        updateItem: updateCostume,
        label: "Costume",
        labelPlural: "Costumes",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2xT0V.UserPolice), {}),
        types: [
            {
                label: 'Costume Type',
                key: 'type',
                values: Object.values((0, $8PeUS.CostumeType))
            }
        ]
    });
});

});

parcelRegister("925dC", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $bsB3E = parcelRequire("bsB3E");

var $1G16z = parcelRequire("1G16z");
parcelRequire("ibR9R");
var $bIzid = parcelRequire("bIzid");

var $8DltC = parcelRequire("8DltC");

var $1Ofsp = parcelRequire("1Ofsp");

var $2Y23d = parcelRequire("2Y23d");
const $746ddd7d55ea1aae$export$a2fe08290dce6b26 = (0, $j8yBr.observer)(({ project: project, headerBackground: headerBackground })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** Methods **/ const updateProject = async (update)=>{
        if (!projectStore.currentProject) {
            (0, $bsB3E.toast).error('An internal error has occurred. Please refresh the page and try again.');
            return;
        }
        await projectStore.updateProject(projectStore.currentProject.id, update);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        margin: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                background: headerBackground || {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)'
                },
                pad: {
                    horizontal: 'small',
                    vertical: 'medium'
                },
                justify: "between",
                align: "center",
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    animation: (0, $1G16z.getAnimProps)(),
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            val: projectStore.currentProject?.name || '',
                            textColor: "accent-1",
                            onChange: (t)=>updateProject({
                                    name: t.target.value
                                })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2Y23d.FavoriteButton), {
                            project: project,
                            iconProps: {
                                width: 'small'
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row-responsive",
                gap: "medium",
                pad: "small",
                background: "light-1",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                direction: "row",
                                animation: (0, $1G16z.getAnimProps)(),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                    label: "Client",
                                    htmlFor: "client-name",
                                    width: "100%",
                                    val: projectStore.currentProject?.client?.name || '',
                                    onChange: (name)=>updateProject({
                                            client: {
                                                name: name
                                            }
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                pad: "xsmall",
                                gap: "small",
                                animation: (0, $1G16z.getAnimProps)(0, 'slideUp'),
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            weight: 300,
                                            children: "SAG Signatory"
                                        }),
                                        checked: projectStore.currentProject?.client?.isSagSignatory,
                                        onChange: (e)=>updateProject({
                                                client: {
                                                    isSagSignatory: e.target.checked
                                                }
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            weight: 300,
                                            children: "JPC Authorizer"
                                        }),
                                        checked: projectStore.currentProject?.client?.isJpcAuthorizer,
                                        onChange: (e)=>updateProject({
                                                client: {
                                                    isJpcAuthorizer: e.target.checked
                                                }
                                            })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row-responsive",
                        animation: (0, $1G16z.getAnimProps)(50),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                            val: (projectStore.currentProject?.talentBudgetInPennies || 0) / 100,
                            label: "Talent Budget",
                            htmlFor: "talent-budget",
                            onChange: (budget)=>updateProject({
                                    talentBudgetInPennies: Math.round(budget * 100)
                                }),
                            width: "100%",
                            format: "currency",
                            currencyDecimals: false
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row-responsive",
                        animation: (0, $1G16z.getAnimProps)(100),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                            label: "Product",
                            htmlFor: "product",
                            width: "100%",
                            val: projectStore.currentProject?.product || '',
                            onChange: (product)=>updateProject({
                                    product: product
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row-responsive",
                        animation: (0, $1G16z.getAnimProps)(150),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                            label: "Job Code",
                            htmlFor: "job-code",
                            width: "100%",
                            val: projectStore.currentProject?.job_code || '',
                            onChange: (jobCode)=>updateProject({
                                    jobCode: jobCode
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row-responsive",
                        animation: (0, $1G16z.getAnimProps)(200),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                            label: "PO Number",
                            htmlFor: "po-number",
                            width: "100%",
                            val: projectStore.currentProject?.poNumber || '',
                            onChange: (poNumber)=>updateProject({
                                    poNumber: poNumber
                                })
                        })
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("lkbmC", function(module, exports) {

$parcel$export(module.exports, "ProjectPropPanel", () => $3f3200e083157531$export$8e6f1b2737874e7b);

var $6ir3O = parcelRequire("6ir3O");

var $cNZ2u = parcelRequire("cNZ2u");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");

var $8DltC = parcelRequire("8DltC");
parcelRequire("hcQWc");
var $i8q6u = parcelRequire("i8q6u");
const $3f3200e083157531$export$8e6f1b2737874e7b = (0, $j8yBr.observer)(({ scriptId: scriptId, role: role })=>{
    const [props, setProps] = (0, $2NacA.useState)([]);
    const propStore = (0, $8DltC.usePropStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    (0, $2NacA.useEffect)(()=>{
        if (!role) return;
        const getProps = async ()=>{
            const props = await propStore.getPropsByRoleId(role.id);
            props && setProps(props);
        };
        getProps();
    }, [
        role
    ]);
    const newProp = async ()=>{
        if (!projectStore.currentProject?.id) return;
        const propRequest = {
            name: 'New Prop',
            type: (0, $i8q6u.PropType).Automobile,
            scriptIds: scriptId ? [
                scriptId
            ] : [],
            ownerId: role.id,
            projectId: projectStore.currentProject.id
        };
        const prop = await propStore.createProp(propRequest);
        props && prop && setProps([
            ...props,
            prop
        ]);
        prop && role.props?.push(prop);
    };
    const deleteProps = async (ids)=>{
        ids.forEach(async (id)=>await propStore.deleteProp(id));
        setProps(props.filter((r)=>!ids.includes(r.id)));
        role.props = role.props?.filter((r)=>!ids.includes(r.id));
    };
    const updateProp = async (update, index)=>{
        const prop = await propStore.updateProp(update);
        if (!prop) return;
        const newProps = [
            ...props
        ];
        newProps[index] = prop;
        setProps(newProps);
        role.props = role.props?.map((r)=>r.id === prop.id ? prop : r);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: props,
        newItem: newProp,
        deleteItems: deleteProps,
        updateItem: updateProp,
        label: "Prop",
        labelPlural: "Props",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cNZ2u.Bike), {}),
        types: [
            {
                label: 'Prop Type',
                key: 'type',
                values: Object.values((0, $i8q6u.PropType))
            }
        ]
    });
});

});

parcelRegister("gNjNn", function(module, exports) {

$parcel$export(module.exports, "ProjectRolesPanel", () => $0f7602fc25dc697e$export$d04a8bd9b167d4ac);

var $6ir3O = parcelRequire("6ir3O");

var $fjut3 = parcelRequire("fjut3");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");

var $4TEHZ = parcelRequire("4TEHZ");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $gpKeH = parcelRequire("gpKeH");
var $8Ao5G = parcelRequire("8Ao5G");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");

var $cNZ2u = parcelRequire("cNZ2u");
var $1QpFO = parcelRequire("1QpFO");
var $dmh5A = parcelRequire("dmh5A");
var $2xT0V = parcelRequire("2xT0V");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("3Focm");
var $65HyY = parcelRequire("65HyY");
var $lkbmC = parcelRequire("lkbmC");
parcelRequire("ibR9R");
var $1Ofsp = parcelRequire("1Ofsp");
var $l3pMM = parcelRequire("l3pMM");
var $7wM4T = parcelRequire("7wM4T");

var $8DltC = parcelRequire("8DltC");
const $0f7602fc25dc697e$export$d04a8bd9b167d4ac = (0, $j8yBr.observer)(({ cardProps: cardProps, headerBackground: headerBackground })=>{
    const roleStore = (0, $8DltC.useRoleStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const [roles, setRoles] = (0, $2NacA.useState)([]);
    const [roleGroups, setRoleGroups] = (0, $2NacA.useState)([]);
    const [selected, setSelected] = (0, $2NacA.useState)([]);
    const [modalRole, setModalRole] = (0, $2NacA.useState)(undefined);
    const rolesAdded = (0, $2NacA.useRef)(0);
    (0, $2NacA.useEffect)(()=>{
        const getRoles = async ()=>{
            if (!projectStore.currentProject?.id) return;
            const roles = await roleStore.getRolesByProjectId(projectStore.currentProject.id);
            if (roles) {
                setRoles(roles);
                if (!rolesAdded.current) rolesAdded.current = roles.length;
            }
        };
        const getRoleGroups = async ()=>{
            const roleGroups = await roleStore.getRoleGroupsByProjectId(projectStore.currentProject?.id || '');
            if (!roleGroups) return;
            setRoleGroups(roleGroups);
        };
        getRoles();
        getRoleGroups();
    }, [
        projectStore.currentProject?.id
    ]);
    const newRole = async ()=>{
        if (!projectStore.currentProject?.id) return;
        const roleRequest = {
            name: `New Role ${rolesAdded.current += 1}`,
            type: (0, $lUAc5.RoleType).Actor,
            performerType: (0, $8kKyn.RolePerformerType).OnCameraPrincipal,
            projectId: projectStore.currentProject?.id
        };
        const role = await roleStore.createRole(roleRequest);
        roles && role && setRoles([
            ...roles,
            role
        ]);
    };
    const deleteRoles = async ()=>{
        selected.forEach(async (id)=>await roleStore.deleteRole(id));
        setRoles(roles.filter((r)=>!selected.includes(r.id)));
        setSelected([]);
    };
    const updateRole = async (update, index, groupId)=>{
        const role = await roleStore.updateRole(update, groupId);
        if (!role) return;
        const newRoles = [
            ...roles
        ];
        newRoles[index] = role;
        setRoles(newRoles);
    };
    const selectedNames = ()=>{
        const names = selected.map((s)=>roles.find((item)=>item.id === s)?.name);
        return names.join(', ');
    };
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $7wM4T.TalonCard), {
        newItem: newRole,
        deleteItems: deleteRoles,
        label: 'Role',
        labelPlural: 'Roles',
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {}),
        selectedNames: selectedNames(),
        cardProps: cardProps,
        color: "accent-1",
        headerBackground: headerBackground,
        children: [
            roles.map((role, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    align: "center",
                    gap: "medium",
                    pad: "xsmall",
                    justify: "between",
                    border: {
                        side: 'bottom',
                        color: 'light-4'
                    },
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            align: "center",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                    checked: selected.includes(role.id),
                                    onChange: (e)=>{
                                        if (e.target.checked) setSelected([
                                            ...selected,
                                            role.id
                                        ]);
                                        else setSelected(selected.filter((id)=>id !== role.id));
                                    },
                                    pad: {
                                        horizontal: 'small'
                                    }
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                    label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "xsmall",
                                        children: "Role"
                                    }),
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                        val: role.name,
                                        onChange: (name)=>updateRole({
                                                ...role,
                                                name: name
                                            }, i)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                            label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                children: "Role Performer Type"
                            }),
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                                placeholder: 'Role Performer Type',
                                options: Object.values((0, $8kKyn.RolePerformerType)).map((type)=>({
                                        id: type,
                                        name: type
                                    })),
                                value: role.performer_type,
                                onChange: (type)=>updateRole({
                                        ...role,
                                        performer_type: type
                                    }, i),
                                size: "small"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                            label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                children: "Role Type"
                            }),
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                                placeholder: 'Role Type',
                                options: Object.values((0, $lUAc5.RoleType)).filter((roleType)=>role.performer_type ? (0, $4TEHZ.filterRoleTypes)(role.performer_type).includes(roleType) : true).map((type)=>({
                                        id: type,
                                        name: type
                                    })),
                                value: role.type,
                                onChange: (type)=>updateRole({
                                        ...role,
                                        type: type
                                    }, i),
                                size: "small"
                            })
                        }),
                        role.performer_type && [
                            ...(0, $fjut3.GroupPerformerTypes),
                            ...(0, $fjut3.GroupPerformerTypeFilter)
                        ].includes(role.performer_type) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                            label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "xsmall",
                                children: "Role Group"
                            }),
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                                placeholder: 'Role Group',
                                options: roleGroups.map((group)=>({
                                        id: group.id,
                                        name: group.name
                                    })),
                                value: role.role_group?.id,
                                onChange: (group)=>updateRole({
                                        ...role
                                    }, i, group),
                                size: "small"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            onClick: ()=>{
                                setModalRole(role);
                            },
                            icon: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2xT0V.UserPolice), {
                                        color: role.costumes?.length ? 'accent-3' : 'light-3'
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cNZ2u.Bike), {
                                        color: role.props?.length ? 'accent-3' : 'light-3'
                                    })
                                ]
                            }),
                            secondary: true,
                            size: "small",
                            margin: {
                                left: 'small'
                            },
                            tip: 'Manage Prop/Costume Reimbursements',
                            hoverIndicator: true
                        })
                    ]
                }, role.id)),
            roles.length === 0 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                pad: "small",
                children: "No roles found"
            }),
            modalRole && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
                onClickOutside: ()=>setModalRole(undefined),
                onEsc: ()=>setModalRole(undefined),
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "column",
                    pad: "small",
                    gap: "small",
                    width: "large",
                    height: "medium",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            pad: "small",
                            justify: "between",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                    alignSelf: "center",
                                    children: [
                                        "Add Prop/Costume Reimbursements for ",
                                        modalRole.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                    onClick: ()=>setModalRole(undefined),
                                    cursor: "pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            pad: "small",
                            direction: "row",
                            gap: "small",
                            justify: "around",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lkbmC.ProjectPropPanel), {
                                    role: modalRole
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $65HyY.ProjectCostumePanel), {
                                    role: modalRole
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});

});
parcelRegister("4TEHZ", function(module, exports) {

$parcel$export(module.exports, "filterRoleTypes", () => $e600adbebcc52b2e$export$1f7240d85fdcb84d);
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");
const $e600adbebcc52b2e$export$1f7240d85fdcb84d = (performer_type)=>{
    switch(performer_type){
        case (0, $8kKyn.RolePerformerType).AFM:
            return [
                (0, $lUAc5.RoleType).LeaderArrangerComposer,
                (0, $lUAc5.RoleType).CopyistSideMusician,
                (0, $lUAc5.RoleType).CopyistSideMusician1Double,
                (0, $lUAc5.RoleType).CopyistSideMusician2Doubles,
                (0, $lUAc5.RoleType).CopyistSideMusician3Doubles,
                (0, $lUAc5.RoleType).CopyistSideMusician4Doubles
            ];
        case (0, $8kKyn.RolePerformerType).OnCameraPrincipal:
            return [
                (0, $lUAc5.RoleType).Actor,
                (0, $lUAc5.RoleType).Singer,
                (0, $lUAc5.RoleType).SpecialtyDancer,
                (0, $lUAc5.RoleType).SpecialtyAct,
                (0, $lUAc5.RoleType).StuntPerformer,
                (0, $lUAc5.RoleType).Pilot,
                (0, $lUAc5.RoleType).Clown
            ];
        case (0, $8kKyn.RolePerformerType).Extra:
            return [
                (0, $lUAc5.RoleType).Actor,
                (0, $lUAc5.RoleType).Singer,
                (0, $lUAc5.RoleType).SpecialtyDancer,
                (0, $lUAc5.RoleType).SpecialtyAct,
                (0, $lUAc5.RoleType).StuntPerformer,
                (0, $lUAc5.RoleType).Pilot,
                (0, $lUAc5.RoleType).Clown,
                (0, $lUAc5.RoleType).StandIn,
                (0, $lUAc5.RoleType).HandModel,
                (0, $lUAc5.RoleType).HandModelDoubleScale
            ];
        case (0, $8kKyn.RolePerformerType).OffCameraPrincipal:
            return [
                (0, $lUAc5.RoleType).Narrator,
                (0, $lUAc5.RoleType).Puppeteer,
                (0, $lUAc5.RoleType).StuntCoordinator
            ];
        case (0, $8kKyn.RolePerformerType).Radio:
            return [
                (0, $lUAc5.RoleType).Announcer
            ];
        default:
            return Object.values((0, $lUAc5.RoleType));
    }
};

});


parcelRegister("31rER", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $8Ao5G = parcelRequire("8Ao5G");

var $cNZ2u = parcelRequire("cNZ2u");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");
var $l3pMM = parcelRequire("l3pMM");

var $8DltC = parcelRequire("8DltC");
parcelRequire("hcQWc");
var $i8q6u = parcelRequire("i8q6u");
const $9293e181aff824a8$export$cc9709258eab0dbb = (0, $j8yBr.observer)(({ scriptId: scriptId, roles: roles })=>{
    const [props, setProps] = (0, $2NacA.useState)([]);
    const propStore = (0, $8DltC.usePropStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    (0, $2NacA.useEffect)(()=>{
        if (!scriptId) return;
        const getProps = async ()=>{
            const props = await propStore.getPropsByScriptId(scriptId);
            props && setProps(props);
        };
        getProps();
    }, [
        scriptId
    ]);
    const newProp = async ()=>{
        if (!scriptId || !projectStore.currentProject?.id) return;
        const propRequest = {
            name: 'New Prop',
            type: (0, $i8q6u.PropType).Automobile,
            scriptIds: [
                scriptId
            ],
            projectId: projectStore.currentProject.id
        };
        const prop = await propStore.createProp(propRequest);
        props && prop && setProps([
            ...props,
            prop
        ]);
    };
    const deleteProps = async (ids)=>{
        ids.forEach(async (id)=>await propStore.deleteProp(id));
        setProps(props.filter((r)=>!ids.includes(r.id)));
    };
    const updateProp = async (update, index)=>{
        const prop = await propStore.updateProp(update);
        if (!prop) return;
        const newProps = [
            ...props
        ];
        newProps[index] = prop;
        setProps(newProps);
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: props,
        newItem: newProp,
        deleteItems: deleteProps,
        updateItem: updateProp,
        label: "Prop",
        labelPlural: "Props",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cNZ2u.Bike), {}),
        types: [
            {
                label: 'Prop Type',
                key: 'type',
                values: Object.values((0, $i8q6u.PropType))
            }
        ],
        children: props.map((prop, index)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                pad: {
                    horizontal: 'small'
                },
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                    label: "Role/Owner",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                        value: prop.owner?.id || '',
                        options: roles,
                        onChange: (value)=>updateProp({
                                ...props[index],
                                owner: roles.find((r)=>r.id === value)
                            }, index),
                        size: "small"
                    }, "role")
                })
            }, prop.id))
    });
});

});

parcelRegister("dgOaK", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $fnXSK = parcelRequire("fnXSK");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");

var $8DltC = parcelRequire("8DltC");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");

var $4TEHZ = parcelRequire("4TEHZ");
const $2d2d6cce1d550f3e$export$5ad73b925b846adc = (0, $j8yBr.observer)(({ scriptId: scriptId })=>{
    const [roleGroups, setRoleGroups] = (0, $2NacA.useState)([]);
    const roleStore = (0, $8DltC.useRoleStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    (0, $2NacA.useEffect)(()=>{
        if (!scriptId) return;
        const getRoleGroups = async ()=>{
            const roleGroups = await roleStore.getRoleGroupsByScriptId(scriptId);
            const extendedRoleGroups = roleGroups?.map((rg)=>({
                    ...rg,
                    members: rg.roles.length.toString(),
                    performer_type: rg.roles[0].performer_type,
                    type: rg.roles[0].type
                }));
            setRoleGroups(extendedRoleGroups || []);
        };
        getRoleGroups();
    }, [
        scriptId
    ]);
    const newRoleGroup = async ()=>{
        if (!scriptId || !projectStore.currentProject?.id) return;
        //first, create 3 new roles, the minimum for a group
        const roles = [];
        for(let i = 0; i < 3; i++){
            const roleRequest = {
                name: `New Group Role ${i + 1}`,
                type: (0, $lUAc5.RoleType).SpecialtyDancer,
                performerType: (0, $8kKyn.RolePerformerType).OnCameraGroup,
                scriptId: scriptId,
                projectId: projectStore.currentProject.id
            };
            const role = await roleStore.createRole(roleRequest);
            roles && role && roles.push(role);
        }
        const roleGroupRequest = {
            name: 'New Group',
            scriptId: scriptId,
            projectId: projectStore.currentProject?.id || '',
            roleIds: roles.map((r)=>r.id)
        };
        const roleGroup = await roleStore.createRoleGroup(roleGroupRequest);
        roleGroups && roleGroup && setRoleGroups([
            ...roleGroups,
            {
                ...roleGroup,
                members: roleGroup.roles.length.toString(),
                performer_type: roleGroup.roles[0].performer_type,
                type: roleGroup.roles[0].type
            }
        ]);
    };
    const deleteRoleGroups = async (ids)=>{
        for (const id of ids)await roleStore.deleteRoleGroup(id);
        setRoleGroups(roleGroups.filter((r)=>!ids.includes(r.id)));
    };
    const updateRoleGroup = async (update, index)=>{
        if (!scriptId) return;
        if (update.performer_type !== roleGroups[index].performer_type) for (const role of update.roles){
            role.performer_type = update.performer_type;
            await roleStore.updateRole(role);
        }
        else if (update.type && update.type !== roleGroups[index].type) for (const role of update.roles){
            role.type = update.type;
            await roleStore.updateRole(role);
        }
        else if (update.members && update.members !== roleGroups[index].members) {
            // we need to add or remove roles from the group
            const members = parseInt(update.members);
            if (members > update.roles.length) {
                // add roles
                const roleRequest = {
                    name: '',
                    roleGroupId: update.id,
                    type: (0, $lUAc5.RoleType).SpecialtyDancer,
                    performerType: (0, $8kKyn.RolePerformerType).OnCameraGroup,
                    scriptId: scriptId,
                    projectId: projectStore.currentProject?.id || ''
                };
                for(let i = 0; i < members - update.roles.length; i++){
                    roleRequest.name = `New Group Role ${update.roles.length + i + 1}`;
                    const role = await roleStore.createRole(roleRequest);
                    role && roleGroups[index].roles.push(role);
                }
            } else if (members < update.roles.length) // remove roles
            for(let i = 0; i < update.roles.length - members; i++){
                const role = update.roles.pop();
                role && await roleStore.deleteRole(role.id);
            }
        } else {
            const roleGroup = await roleStore.updateRoleGroup(update);
            if (!roleGroup) return;
            const newRoleGroups = [
                ...roleGroups
            ];
            newRoleGroups[index] = roleGroup;
            setRoleGroups(newRoleGroups?.map((rg)=>({
                    ...rg,
                    members: rg.roles.length.toString(),
                    performer_type: rg.roles[0].performer_type,
                    type: rg.roles[0].type
                })));
        }
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: roleGroups,
        newItem: newRoleGroup,
        deleteItems: deleteRoleGroups,
        updateItem: updateRoleGroup,
        label: "Role Group",
        labelPlural: "Role Groups",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fnXSK.Group), {}),
        types: [
            {
                label: 'Number Of Members',
                key: 'members',
                values: [
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9'
                ]
            },
            {
                label: 'Performer Type',
                key: 'performer_type',
                values: Object.values((0, $8kKyn.RolePerformerType)).filter((v)=>v.includes('Group'))
            },
            {
                label: 'Role Type',
                key: 'type',
                values: Object.values((0, $lUAc5.RoleType)),
                filterKey: 'performer_type',
                filterFunction: (0, $4TEHZ.filterRoleTypes)
            }
        ]
    });
});

});

parcelRegister("1kxSv", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");

var $dmh5A = parcelRequire("dmh5A");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $4TEHZ = parcelRequire("4TEHZ");
parcelRequire("ibR9R");
var $iPyPY = parcelRequire("iPyPY");

var $8DltC = parcelRequire("8DltC");
const $b79eb85429d3771f$export$5081f4e5066e76c = (0, $j8yBr.observer)(({ scriptId: scriptId, roles: roles, setRoles: setRoles, cardProps: cardProps, headerBackground: headerBackground })=>{
    /** Context **/ const roleStore = (0, $8DltC.useRoleStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    /** Refs **/ const rolesAdded = (0, $2NacA.useRef)(0);
    /** Methods **/ const newRole = async ()=>{
        if (!projectStore.currentProject?.id || !scriptId) return;
        const roleRequest = {
            name: `New Role ${rolesAdded.current += 1}`,
            type: (0, $lUAc5.RoleType).Actor,
            performerType: (0, $8kKyn.RolePerformerType).OnCameraPrincipal,
            scriptId: scriptId,
            projectId: projectStore.currentProject.id
        };
        const role = await roleStore.createRole(roleRequest);
        roles && role && setRoles([
            ...roles,
            role
        ]);
    };
    const deleteRoles = async (ids)=>{
        ids.forEach(async (id)=>await roleStore.deleteRole(id));
        setRoles(roles.filter((r)=>!ids.includes(r.id)));
    };
    const updateRole = async (update, index)=>{
        const role = await roleStore.updateRole(update);
        if (!role) return;
        const newRoles = [
            ...roles
        ];
        newRoles[index] = role;
        setRoles(newRoles);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (!scriptId) return;
        const getRoles = async ()=>{
            const roles = await roleStore.getRolesByScriptId(scriptId);
            if (roles) {
                setRoles(roles);
                if (!rolesAdded.current) rolesAdded.current = roles.length;
            }
        };
        getRoles();
    }, [
        scriptId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPyPY.Panel), {
        items: roles,
        newItem: newRole,
        deleteItems: deleteRoles,
        updateItem: updateRole,
        label: "Role",
        labelPlural: "Roles",
        addIcon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {}),
        types: [
            {
                label: 'Performer Type',
                key: 'performer_type',
                values: Object.values((0, $8kKyn.RolePerformerType)).filter((v)=>!v.includes('Group'))
            },
            {
                label: 'Role Type',
                key: 'type',
                values: Object.values((0, $lUAc5.RoleType)),
                filterKey: 'performer_type',
                filterFunction: (0, $4TEHZ.filterRoleTypes)
            }
        ],
        cardProps: cardProps,
        headerBackground: headerBackground
    });
});

});

parcelRegister("21teh", function(module, exports) {

$parcel$export(module.exports, "TalentManagerPanel", () => $142cd4985811b5ec$export$afe48cd393988886);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $7wM4T = parcelRequire("7wM4T");

var $8DltC = parcelRequire("8DltC");
const $142cd4985811b5ec$export$afe48cd393988886 = (0, $j8yBr.observer)(({ cardProps: cardProps, headerBackground: headerBackground })=>{
    const tmStore = (0, $8DltC.useTalentManagerStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const [loading, setLoading] = (0, $2NacA.useState)(true);
    (0, $2NacA.useEffect)(()=>{
        tmStore.fetchGroupEngagements().then(()=>setLoading(false));
    }, []);
    const engagements = tmStore.groupEngagements.filter((e)=>e.project_id === projectStore.currentProject?.id);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7wM4T.TalonCard), {
        label: "Talent Managers",
        cardProps: cardProps,
        headerBackground: headerBackground,
        hideFooter: true,
        isLoading: loading,
        children: engagements.length === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            size: "small",
            color: "dark-4",
            margin: "small",
            children: "No Talent Manager engaged yet."
        }) : engagements.map((e)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                pad: "small",
                border: {
                    side: 'bottom',
                    color: 'light-3'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        weight: "bold",
                        size: "small",
                        children: [
                            e.talentManagerProfile?.user?.first_name,
                            " ",
                            e.talentManagerProfile?.user?.last_name
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "xsmall",
                        color: "dark-4",
                        children: [
                            "Status: ",
                            e.status
                        ]
                    })
                ]
            }, e.id))
    });
});

});


parcelRegister("iTN0T", function(module, exports) {
$parcel$export(module.exports, "Hint", () => (parcelRequire("8Ih9f")).Hint);
$parcel$export(module.exports, "ProjectWizard", () => (parcelRequire("lvlqx")).ProjectWizard);
$parcel$export(module.exports, "AssetsTab", () => (parcelRequire("cQagT")).AssetsTab);
$parcel$export(module.exports, "defaultRolePerformer", () => (parcelRequire("6te8u")).defaultRolePerformer);
$parcel$export(module.exports, "formatDefaultName", () => (parcelRequire("6te8u")).formatDefaultName);
$parcel$export(module.exports, "MediaTab", () => (parcelRequire("ixFvq")).MediaTab);
$parcel$export(module.exports, "RolePerformersTab", () => (parcelRequire("6te8u")).RolePerformersTab);
$parcel$export(module.exports, "ShootTab", () => (parcelRequire("duQ5T")).ShootTab);
$parcel$export(module.exports, "StartTab", () => (parcelRequire("jmZJk")).StartTab);
$parcel$export(module.exports, "SummaryTab", () => (parcelRequire("gJxCG")).SummaryTab);
parcelRequire("8Ih9f");
parcelRequire("lvlqx");
parcelRequire("9yyoj");
parcelRequire("3JOpe");

});
parcelRegister("8Ih9f", function(module, exports) {

$parcel$export(module.exports, "Hint", () => $40a1939bdca43f7b$export$8d13340382210b65);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");

var $cYfAm = parcelRequire("cYfAm");
const $40a1939bdca43f7b$export$8d13340382210b65 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        pad: "medium",
        gap: "medium",
        background: "hint-background",
        elevation: "small",
        round: "small",
        direction: "column",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            gap: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cYfAm.CircleInformation), {}),
                children
            ]
        })
    });
};

});

parcelRegister("lvlqx", function(module, exports) {

$parcel$export(module.exports, "ProjectWizard", () => $201dee9679d06a75$export$1c27ad072f744774);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $ir1aK = parcelRequire("ir1aK");
var $2bcjL = parcelRequire("2bcjL");
var $5erKi = parcelRequire("5erKi");
var $b5MFC = parcelRequire("b5MFC");
var $btRQT = parcelRequire("btRQT");
var $kS7Ii = parcelRequire("kS7Ii");

var $dij1X = parcelRequire("dij1X");
var $1QpFO = parcelRequire("1QpFO");
var $kc4ri = parcelRequire("kc4ri");
var $cso1N = parcelRequire("cso1N");
var $iLsof = parcelRequire("iLsof");
var $aFsfQ = parcelRequire("aFsfQ");
var $dmh5A = parcelRequire("dmh5A");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");

var $bsB3E = parcelRequire("bsB3E");

var $9yyoj = parcelRequire("9yyoj");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");
var $gGAG2 = parcelRequire("gGAG2");

var $4Oriw = parcelRequire("4Oriw");

var $bgcVc = parcelRequire("bgcVc");
parcelRequire("iTN0T");
var $cQagT = parcelRequire("cQagT");
var $6te8u = parcelRequire("6te8u");
var $ixFvq = parcelRequire("ixFvq");
var $duQ5T = parcelRequire("duQ5T");
var $jmZJk = parcelRequire("jmZJk");
var $gJxCG = parcelRequire("gJxCG");
parcelRequire("ibR9R");
var $4mDQA = parcelRequire("4mDQA");
const $201dee9679d06a75$var$STEPS = 5;
const $201dee9679d06a75$export$1c27ad072f744774 = (0, $j8yBr.observer)(({ close: close })=>{
    /** Context **/ const userStore = (0, $8DltC.useUserStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const sessionStore = (0, $8DltC.useSessionStore)();
    const commercialStore = (0, $8DltC.useCommercialStore)();
    const roleStore = (0, $8DltC.useRoleStore)();
    /** State **/ const [activeSlide, setActiveSlide] = (0, $2NacA.useState)(0);
    const [showNext, setShowNext] = (0, $2NacA.useState)(true);
    const [showPrevious, setShowPrevious] = (0, $2NacA.useState)(false);
    const [union, setUnion] = (0, $2NacA.useState)();
    const [geography, setShoot] = (0, $2NacA.useState)();
    const [place, setPlace] = (0, $2NacA.useState)();
    const [locationType, setLocationType] = (0, $2NacA.useState)();
    const [firstSessionDate, setFirstSessionDate] = (0, $2NacA.useState)((0, $bgcVc.toDateOnly)(new Date()));
    const [code, setCode] = (0, $2NacA.useState)('');
    const [media, setMedia] = (0, $2NacA.useState)();
    const [assetCounts, setAssetCounts] = (0, $2NacA.useState)({});
    const [rolePerformers, setRolePerformers] = (0, $2NacA.useState)([
        (0, $6te8u.defaultRolePerformer)
    ]);
    const [exclusivity, setExclusivity] = (0, $2NacA.useState)();
    const [clientList, setClientList] = (0, $2NacA.useState)([]);
    const [name, setName] = (0, $2NacA.useState)('');
    const [client, setClient] = (0, $2NacA.useState)();
    const [product, setProduct] = (0, $2NacA.useState)('');
    const [budget, setBudget] = (0, $2NacA.useState)(0);
    const [showLoader, setShowLoader] = (0, $2NacA.useState)(false);
    /** Computed **/ const mediaOptions = Object.keys((0, $3qs6L.CommercialType)).map((key)=>(0, $3qs6L.CommercialType)[key]);
    /** Methods **/ const createProject = async ()=>{
        if (!name || !client || !product) {
            (0, $bsB3E.toast).error('Please fill out all fields');
            return;
        }
        if (!userStore.user.active_group) {
            (0, $bsB3E.toast).error('An internal error has occurred. Please refresh the page and try again.');
            return;
        }
        setShowLoader(true);
        let projectClient;
        // if client is new, create the client first
        if (client.id === 'NEW') {
            const newClient = await projectStore.createClient({
                name: client.name || '',
                isSagSignatory: client.isSagSignatory || false,
                isJpcAuthorizer: client.isJpcAuthorizer || false
            });
            if (!newClient) {
                setShowLoader(false);
                (0, $bsB3E.toast).error('An internal error has occurred. Please refresh the page and try again.');
                return;
            }
            projectClient = newClient;
        } else projectClient = client;
        const project = await projectStore.createProject({
            name: name,
            groupId: userStore.user.active_group?.id,
            clientId: projectClient.id,
            product: product,
            jobCode: code,
            is_union: union === 'union',
            talentBudgetInPennies: budget ? budget * 100 : 0
        });
        if (!project) {
            setShowLoader(false);
            (0, $bsB3E.toast).error('Project creation failed. Please refresh the page and try again.');
            return;
        }
        const locationRequest = {
            name: place?.street_address || place?.city || place?.state || `${locationType || (0, $gGAG2.LocationType).Nearby} Location`,
            type: locationType || (0, $gGAG2.LocationType).Nearby,
            street_address: place?.street_address || '',
            aptOrUnit: place?.aptOrUnit || '',
            city: place?.city || '',
            state: place?.state || '',
            zip: place?.zip || '',
            lat: place?.lat || 0,
            lng: place?.lng || 0,
            projectId: project.id
        };
        try {
            place && await projectStore.createLocation(locationRequest);
            firstSessionDate && await sessionStore.createSession(new Date(firstSessionDate).toISOString(), project.id);
            for(const medium in assetCounts)for (const length of assetCounts[medium])await commercialStore.createCommercial({
                projectId: project.id,
                title: `${length} second ${medium} asset`,
                type: medium,
                durationInSeconds: length,
                jobCode: code
            });
            for (const rolePerformer of rolePerformers){
                const roleIds = [];
                for(let i = 1; i <= rolePerformer.groupSize; i++){
                    const role = await roleStore.createRole({
                        name: (0, $6te8u.formatDefaultName)(rolePerformer, i),
                        type: rolePerformer.roleType,
                        performerType: rolePerformer.performerType,
                        projectId: project.id
                    });
                    if (!role) throw new Error('Role creation failed');
                    roleIds.push(role.id);
                }
                if (rolePerformer.groupSize > 1) {
                    const roleGroup = await roleStore.createRoleGroup({
                        name: (0, $6te8u.formatDefaultName)(rolePerformer),
                        roleIds: roleIds,
                        projectId: project.id
                    });
                    if (!roleGroup) throw new Error('Role group creation failed');
                }
            }
        } catch (e) {
            (0, $bsB3E.toast).error(`An internal error has occurred: ${e}`);
        }
        setClient(undefined);
        setName('');
        setProduct('');
        setCode('');
        setUnion(undefined);
        setBudget(0);
        setShoot(undefined);
        setLocationType(undefined);
        setPlace(undefined);
        setFirstSessionDate(new Date().toISOString());
        setExclusivity(undefined);
        setMedia(undefined);
        setAssetCounts({});
        setRolePerformers([
            (0, $6te8u.defaultRolePerformer)
        ]);
        setActiveSlide(0);
        setShowLoader(false);
        close();
    };
    const valid = ()=>{
        return name && client && product ? true : false;
    };
    const onChild = (index)=>{
        if (index < 0 || index > $201dee9679d06a75$var$STEPS) return;
        if (index === 0) setShowPrevious(false);
        else setShowPrevious(true);
        if (index === $201dee9679d06a75$var$STEPS) setShowNext(false);
        else setShowNext(true);
        setActiveSlide(index);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (projectStore.clientList.length === 0) return;
        setClientList(projectStore.clientList);
    }, [
        projectStore.clientList
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: close,
        onClickOutside: close,
        position: "center",
        modal: true,
        background: "transparent",
        children: showLoader ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4mDQA.Loader), {}) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
            width: "large",
            elevation: "medium",
            height: "90vh",
            round: (0, $4Oriw.borderRadiusSize),
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                    gap: "small",
                    background: {
                        color: 'brand-gradient',
                        dark: true
                    },
                    style: {
                        background: 'var(--brand-gradient)',
                        zIndex: 1
                    },
                    height: "60px",
                    justify: "between",
                    pad: {
                        horizontal: 'medium'
                    },
                    elevation: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            align: "center",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                truncate: true,
                                size: "large",
                                color: "white",
                                children: "Pre-Pro Talent Wizard"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                size: "medium",
                                color: "white"
                            }),
                            onClick: close
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    overflow: {
                        horizontal: 'auto',
                        vertical: 'scroll'
                    },
                    height: "large",
                    background: "white",
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $btRQT.Tabs), {
                        activeIndex: activeSlide,
                        onActive: onChild,
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iLsof.Magic), {}),
                                title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 500,
                                    children: "Start"
                                }),
                                style: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jmZJk.StartTab), {
                                    name: name,
                                    code: code,
                                    client: client,
                                    product: product,
                                    budget: budget,
                                    clientList: clientList,
                                    setName: setName,
                                    setCode: setCode,
                                    setClient: setClient,
                                    setClientList: setClientList,
                                    setProduct: setProduct,
                                    setBudget: setBudget
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cso1N.Globe), {}),
                                title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Shoot"
                                }),
                                style: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $duQ5T.ShootTab), {
                                    geography: geography,
                                    place: place,
                                    setPlace: setPlace,
                                    union: union,
                                    firstSessionDate: firstSessionDate,
                                    locationType: locationType,
                                    setFirstSessionDate: setFirstSessionDate,
                                    setShoot: setShoot,
                                    setUnion: setUnion,
                                    setLocationType: setLocationType
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aFsfQ.Multimedia), {}),
                                title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Media"
                                }),
                                style: {
                                    flex: 1
                                },
                                disabled: !valid(),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $ixFvq.MediaTab), {
                                    media: media,
                                    setMedia: setMedia,
                                    mediaOptions: mediaOptions,
                                    exclusivity: exclusivity,
                                    setExclusivity: setExclusivity
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dij1X.Channel), {}),
                                title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Assets"
                                }),
                                style: {
                                    flex: 1
                                },
                                disabled: !valid(),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cQagT.AssetsTab), {
                                    media: media,
                                    setAssetCounts: setAssetCounts,
                                    assetCounts: assetCounts
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {}),
                                title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Roles"
                                }),
                                style: {
                                    flex: 1
                                },
                                disabled: !valid(),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6te8u.RolePerformersTab), {
                                    setRolePerformers: setRolePerformers,
                                    rolePerformers: rolePerformers
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5MFC.Tab), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kc4ri.Deploy), {}),
                                title: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Summary"
                                }),
                                style: {
                                    flex: 1
                                },
                                disabled: !valid(),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gJxCG.SummaryTab), {
                                    name: name,
                                    code: code,
                                    client: client,
                                    product: product,
                                    budget: budget,
                                    union: union,
                                    geography: geography,
                                    place: place,
                                    media: media,
                                    exclusivity: exclusivity,
                                    assetCounts: assetCounts,
                                    rolePerformers: rolePerformers
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "column",
                    justify: "stretch",
                    flex: "grow",
                    background: {
                        color: 'light-4'
                    },
                    pad: {
                        horizontal: 'small',
                        vertical: 'xsmall'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9yyoj.ProjectWizardFooter), {
                        activeSlide: activeSlide,
                        setActiveSlide: onChild,
                        previous: showPrevious,
                        next: showNext,
                        createFn: createProject,
                        valid: valid
                    })
                })
            ]
        })
    });
});

});
parcelRegister("dij1X", function(module, exports) {

$parcel$export(module.exports, "Channel", () => $9adbb7e567c0b147$export$cfdacaa37f9b4dd7);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $9adbb7e567c0b147$var$_extends() {
    return $9adbb7e567c0b147$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9adbb7e567c0b147$var$_extends.apply(null, arguments);
}
var $9adbb7e567c0b147$export$cfdacaa37f9b4dd7 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $9adbb7e567c0b147$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Channel"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 9h20v13H2V9zm19-7-8 7h-2L3 2"
    }));
});
$9adbb7e567c0b147$export$cfdacaa37f9b4dd7.displayName = 'Channel';

});

parcelRegister("kc4ri", function(module, exports) {

$parcel$export(module.exports, "Deploy", () => $eb385f3315c32e52$export$5b4031b3d2835620);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $eb385f3315c32e52$var$_extends() {
    return $eb385f3315c32e52$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eb385f3315c32e52$var$_extends.apply(null, arguments);
}
var $eb385f3315c32e52$export$5b4031b3d2835620 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $eb385f3315c32e52$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Deploy"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 1s-6.528-.458-9 2c-.023.037-4 4-4 4L5 8l-3 2 8 4 4 8 2-3 1-5s3.963-3.977 4-4c2.458-2.472 2-9 2-9zm-6 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 17c-1-1-3-1-4 0s-1 5-1 5 4 0 5-1 1-3 0-4z"
    }));
});
$eb385f3315c32e52$export$5b4031b3d2835620.displayName = 'Deploy';

});

parcelRegister("cso1N", function(module, exports) {

$parcel$export(module.exports, "Globe", () => $911abd0a4a61b376$export$3bc50e457b7f164b);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $911abd0a4a61b376$var$_extends() {
    return $911abd0a4a61b376$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $911abd0a4a61b376$var$_extends.apply(null, arguments);
}
var $911abd0a4a61b376$export$3bc50e457b7f164b = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $911abd0a4a61b376$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Globe"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 8s3.5 1 5 2 .564 2.42 1 3c.436.58 2-1 2 2s3 1 3 4 2.5 2.5 3 1 2.233-3.134 2-5c-.233-1.866-1-3-3-3s-3.5-.5-4-2 3-2 2-5 0-4 0-4m10 11c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11z"
    }));
});
$911abd0a4a61b376$export$3bc50e457b7f164b.displayName = 'Globe';

});

parcelRegister("9yyoj", function(module, exports) {

$parcel$export(module.exports, "ProjectWizardFooter", () => $7e06b8b8669e7780$export$561ae62cd3ff3556);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");

var $5Xkwu = parcelRequire("5Xkwu");
var $7swFI = parcelRequire("7swFI");
var $3uMfm = parcelRequire("3uMfm");
const $7e06b8b8669e7780$export$561ae62cd3ff3556 = ({ activeSlide: activeSlide, setActiveSlide: setActiveSlide, next: next, previous: previous, createFn: createFn, valid: valid })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        justify: "between",
        pad: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                hoverIndicator: true,
                label: "Back",
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3uMfm.FormPrevious), {
                    color: "plain"
                }),
                onClick: ()=>setActiveSlide(activeSlide - 1),
                disabled: !previous
            }),
            next ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                hoverIndicator: true,
                label: "Next",
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7swFI.FormNext), {
                    color: "plain"
                }),
                type: "submit",
                onClick: ()=>valid() ? setActiveSlide(activeSlide + 1) : undefined,
                disabled: !next || !valid()
            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                hoverIndicator: true,
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5Xkwu.Add), {}),
                onClick: createFn,
                type: "submit",
                label: "Create Project"
            })
        ]
    });
};

});
parcelRegister("7swFI", function(module, exports) {

$parcel$export(module.exports, "FormNext", () => $56e47de0f23006ba$export$a8d2f61b02c7b95f);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $56e47de0f23006ba$var$_extends() {
    return $56e47de0f23006ba$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $56e47de0f23006ba$var$_extends.apply(null, arguments);
}
var $56e47de0f23006ba$export$a8d2f61b02c7b95f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $56e47de0f23006ba$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNext"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 6 6 6-6 6"
    }));
});
$56e47de0f23006ba$export$a8d2f61b02c7b95f.displayName = 'FormNext';

});

parcelRegister("3uMfm", function(module, exports) {

$parcel$export(module.exports, "FormPrevious", () => $28b9993fb567cbd3$export$a14ca6bc44f029a6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $28b9993fb567cbd3$var$_extends() {
    return $28b9993fb567cbd3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $28b9993fb567cbd3$var$_extends.apply(null, arguments);
}
var $28b9993fb567cbd3$export$a14ca6bc44f029a6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $28b9993fb567cbd3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPrevious"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 6-6 6 6 6"
    }));
});
$28b9993fb567cbd3$export$a14ca6bc44f029a6.displayName = 'FormPrevious';

});



parcelRegister("3JOpe", function(module, exports) {
$parcel$export(module.exports, "AssetsTab", () => (parcelRequire("cQagT")).AssetsTab);
$parcel$export(module.exports, "MediaTab", () => (parcelRequire("ixFvq")).MediaTab);
$parcel$export(module.exports, "defaultRolePerformer", () => (parcelRequire("6te8u")).defaultRolePerformer);
$parcel$export(module.exports, "formatDefaultName", () => (parcelRequire("6te8u")).formatDefaultName);
$parcel$export(module.exports, "RolePerformersTab", () => (parcelRequire("6te8u")).RolePerformersTab);
$parcel$export(module.exports, "ShootTab", () => (parcelRequire("duQ5T")).ShootTab);
$parcel$export(module.exports, "StartTab", () => (parcelRequire("jmZJk")).StartTab);
$parcel$export(module.exports, "SummaryTab", () => (parcelRequire("gJxCG")).SummaryTab);
parcelRequire("cQagT");
parcelRequire("ixFvq");
parcelRequire("6te8u");
parcelRequire("duQ5T");
parcelRequire("jmZJk");
parcelRequire("gJxCG");

});
parcelRegister("cQagT", function(module, exports) {

$parcel$export(module.exports, "AssetsTab", () => $b400ba2dadf3d073$export$239be1142198c1f4);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $bIzid = parcelRequire("bIzid");
const $b400ba2dadf3d073$export$239be1142198c1f4 = (props)=>{
    const { media: media, setAssetCounts: setAssetCounts, assetCounts: assetCounts } = props;
    const assetCountOptions = Array.from({
        length: 100
    }, (_, index)=>index);
    const updateCounts = (medium, count)=>{
        if (count === 0) {
            setAssetCounts({
                ...assetCounts,
                [medium]: []
            });
            return;
        }
        if (!assetCounts[medium]) {
            const arr = Array.from({
                length: count
            }, ()=>0);
            setAssetCounts({
                ...assetCounts,
                [medium]: arr
            });
            return;
        } else {
            const arr = assetCounts[medium];
            if (arr.length === count) return;
            if (arr.length < count) {
                for(let i = arr.length; i < count; i++)arr.push(0);
                setAssetCounts({
                    ...assetCounts,
                    [medium]: arr
                });
            }
            if (arr.length > count) arr.splice(count, arr.length - count);
            setAssetCounts({
                ...assetCounts,
                [medium]: arr
            });
        }
    };
    const setLength = (medium, index, length)=>{
        console.log(medium, index, length);
        const arr = assetCounts[medium];
        if (!arr) return;
        arr[index] = length;
        setAssetCounts({
            ...assetCounts,
            [medium]: arr
        });
    };
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        pad: "medium",
        gap: "medium",
        overflow: {
            vertical: 'auto'
        },
        height: {
            max: 'large'
        },
        fill: true,
        children: !media || media?.length === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            children: "Please go back one tab and select media types."
        }) : /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            flex: "grow",
            gap: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: "Great! Now let's talk about the media assets. How many of each will we have?"
                }),
                media?.map((medium, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        border: "bottom",
                        height: "small",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "small",
                                width: "50%",
                                align: "start",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                        options: assetCountOptions,
                                        placeholder: "Select",
                                        value: assetCounts[medium]?.length,
                                        onChange: (e)=>updateCounts(medium, e.target.value),
                                        width: "xsmall",
                                        dropHeight: "small"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                        children: [
                                            medium,
                                            " Assets"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                direction: "column",
                                width: "50%",
                                overflow: {
                                    vertical: 'auto'
                                },
                                height: {
                                    max: 'small'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    flex: "grow",
                                    gap: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: "Length in seconds:"
                                        }),
                                        assetCounts[medium]?.map((length, j)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                direction: "row",
                                                gap: "small",
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                        children: [
                                                            j + 1,
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                                        placeholder: "Length",
                                                        val: length,
                                                        width: "xsmall",
                                                        inputType: "number",
                                                        onChange: (length)=>setLength(medium, j, parseInt(length)),
                                                        minValue: 0
                                                    })
                                                ]
                                            }, `${medium}-${j}`))
                                    ]
                                })
                            })
                        ]
                    }, `${medium}-${i}`))
            ]
        })
    });
};

});
parcelRegister("bIzid", function(module, exports) {

$parcel$export(module.exports, "TalonInput", () => $a23de9cd9a130127$export$9402037ca0d9705);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ir3O = parcelRequire("6ir3O");

var $8Ao5G = parcelRequire("8Ao5G");
var $czDw5 = parcelRequire("czDw5");
var $kQZ06 = parcelRequire("kQZ06");

var $2NacA = parcelRequire("2NacA");
/** Formats a number as a USD currency string. decimals=true forces 2 decimals; decimals=false omits them. */ const $a23de9cd9a130127$var$formatCurrency = (n, decimals = true)=>{
    if (isNaN(n)) return '';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: decimals ? 2 : 0,
        maximumFractionDigits: decimals ? 2 : 0
    }).format(n);
};
/** Parses a (possibly formatted) string into a number, stripping anything that isn't a digit or dot. */ const $a23de9cd9a130127$var$parseCurrency = (s)=>{
    return parseFloat(s.replace(/[^0-9.]/g, ''));
};
/** Strips non-numeric chars, keeping only the first dot so "1.2.3" -> "1.23". */ const $a23de9cd9a130127$var$sanitizeNumeric = (s)=>{
    const cleaned = s.replace(/[^0-9.]/g, '');
    const dot = cleaned.indexOf('.');
    if (dot === -1) return cleaned;
    return cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
};
/** Counts significant chars ([0-9.]) in s — commas/$ are ignored for caret mapping. */ const $a23de9cd9a130127$var$countSig = (s)=>(s.match(/[0-9.]/g) || []).length;
/** Index in `s` after the Nth significant char (used to restore caret across comma/$ insertions/removals). */ const $a23de9cd9a130127$var$indexOfSig = (s, n)=>{
    let count = 0;
    for(let i = 0; i < s.length; i++)if (/[0-9.]/.test(s[i])) {
        count++;
        if (count === n) return i + 1;
    }
    return s.length;
};
const $a23de9cd9a130127$export$9402037ca0d9705 = ({ id: id, name: name, label: label, htmlFor: htmlFor, val: // placeholder,
val, onChange: onChange, onBlur: onBlur, onSubmit: onSubmit, minValue: minValue, maxValue: maxValue, minLength: minLength, maxLength: maxLength, width: // required,
width, margin: margin, textSize: textSize, inputType: // autoComplete,
inputType, saveDelay: // disabled,
saveDelay = 500, validate: validate, format: format, currencyDecimals: currencyDecimals = true, error: error, help: help, formFieldBackground: formFieldBackground, hideFormFieldElement: hideFormFieldElement, ...textInputProps })=>{
    const isCurrency = format === 'currency';
    const decimals = currencyDecimals;
    /** State **/ const [edit, setEdit] = (0, $2NacA.useState)(false);
    const [value, setValue] = (0, $2NacA.useState)(isCurrency ? $a23de9cd9a130127$var$formatCurrency(Number(val), decimals) : val);
    // Caret position to restore after currency reformatting (currency edit mode only).
    const [selection, setSelection] = (0, $2NacA.useState)(null);
    /** Refs **/ const inputRef = (0, $2NacA.useRef)(null);
    const timerRef = (0, $2NacA.useRef)(null);
    const onChangeRef = (0, $2NacA.useRef)(onChange);
    /** Methods - Debouncing **/ // Emits the current input value to onChange, parsing to a number in currency mode.
    const fireChange = (0, $2NacA.useCallback)(()=>{
        if (!inputRef.current || textInputProps.readOnly) return;
        const raw = inputRef.current.value;
        onChangeRef.current?.(isCurrency ? $a23de9cd9a130127$var$parseCurrency(raw) || 0 : raw);
    }, [
        textInputProps.readOnly,
        isCurrency
    ]);
    // Fire any pending debounced onChanges immediately
    const flush = (0, $2NacA.useCallback)(()=>{
        if (timerRef.current !== null) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        fireChange();
    }, [
        fireChange
    ]);
    // Schedules a debounced onChange
    const scheduleChange = (0, $2NacA.useCallback)(()=>{
        if (saveDelay === undefined || saveDelay === 0) {
            // No debounce requested — fire immediately.
            fireChange();
            return;
        }
        if (timerRef.current !== null) // Reset the timer each keystroke
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            fireChange();
        }, saveDelay);
    }, [
        saveDelay,
        fireChange
    ]);
    /** Methods - Event Handlers **/ const handleChange = (e)=>{
        if (isCurrency) {
            if (decimals) {
                // ATM-style fixed-decimal entry: digits shift in from the right of the fixed decimal.
                const prevDisplay = String(value);
                const oldCents = Math.round(($a23de9cd9a130127$var$parseCurrency(prevDisplay) || 0) * 100);
                const oldDigits = prevDisplay.replace(/[^0-9]/g, '');
                const newStr = e.target.value;
                const newDigits = newStr.replace(/[^0-9]/g, '');
                let cents;
                if (newDigits.length === oldDigits.length + 1 && newDigits.startsWith(oldDigits)) {
                    // A digit was appended at the end -> shift left by one decimal place.
                    const d = parseInt(newDigits.slice(-1), 10);
                    cents = oldCents * 10 + d;
                } else if (oldDigits.length === newDigits.length + 1 && oldDigits.startsWith(newDigits)) // A digit was removed (backspace) -> shift right by one decimal place.
                cents = Math.floor(oldCents / 10);
                else // Paste / select-replace / clear -> reparse the whole string, defaulting to 0.
                cents = Math.round(($a23de9cd9a130127$var$parseCurrency(newStr) || 0) * 100);
                const formatted = $a23de9cd9a130127$var$formatCurrency(cents / 100, true);
                setValue(formatted);
                setSelection([
                    formatted.length,
                    formatted.length
                ]);
                scheduleChange();
                return;
            }
            // Whole-dollar mode: live comma formatting with caret preservation.
            const caret = e.target.selectionStart ?? e.target.value.length;
            const sigBefore = $a23de9cd9a130127$var$countSig(e.target.value.slice(0, caret));
            const raw = $a23de9cd9a130127$var$sanitizeNumeric(e.target.value);
            const formatted = $a23de9cd9a130127$var$formatCurrency($a23de9cd9a130127$var$parseCurrency(raw) || 0, false);
            const newCaret = $a23de9cd9a130127$var$indexOfSig(formatted, sigBefore);
            setValue(formatted);
            setSelection([
                newCaret,
                newCaret
            ]);
            scheduleChange();
            return;
        }
        if (e.target.value) {
            const v = typeof e.target.value === 'number' ? e.target.value.toString() : e.target.value;
            if (minLength && v.length < minLength) return;
            if (maxLength && v.length > maxLength) return;
        }
        setValue(e.target.value || '');
        scheduleChange();
    };
    const handleSubmit = ()=>{
        flush();
        setEdit(false);
        onSubmit && onSubmit();
    };
    const handleBlur = ()=>{
        flush();
        setEdit(false);
        onBlur && onBlur();
    };
    const takeFocus = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (isCurrency) {
            const formatted = !isNaN(Number(val)) ? $a23de9cd9a130127$var$formatCurrency(Number(val), decimals) : '';
            setValue(formatted);
            // In float (ATM) mode, pin the caret to the end so the first keystroke appends cleanly.
            if (decimals) setSelection([
                formatted.length,
                formatted.length
            ]);
        }
        setEdit(true);
    };
    /** Effects **/ // Restore caret after currency reformatting renders the new value.
    (0, $2NacA.useLayoutEffect)(()=>{
        if (selection && inputRef.current) {
            inputRef.current.selectionStart = selection[0];
            inputRef.current.selectionEnd = selection[1];
        }
    }, [
        selection,
        value
    ]);
    (0, $2NacA.useEffect)(()=>{
        return ()=>{
            if (timerRef.current !== null) clearTimeout(timerRef.current);
        };
    }, []);
    (0, $2NacA.useEffect)(()=>{
        if (edit) return;
        if (isCurrency) setValue($a23de9cd9a130127$var$formatCurrency(Number(val), decimals));
        else setValue(val);
    }, [
        val,
        edit,
        isCurrency,
        decimals
    ]);
    (0, $2NacA.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    /** Render **/ const renderTextInput = ()=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $czDw5.Keyboard), {
            onEnter: handleSubmit,
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kQZ06.TextInput), {
                ref: inputRef,
                id: id || htmlFor || name,
                name: name || htmlFor || id,
                value: value || '',
                autoFocus: edit,
                onClick: takeFocus,
                onChange: handleChange,
                onBlur: handleBlur,
                type: isCurrency ? 'text' : inputType,
                min: minValue,
                max: maxValue,
                minLength: minLength,
                maxLength: maxLength,
                plain: inputType !== 'number',
                size: textSize,
                width: width,
                ...textInputProps
            })
        });
    const showFormFieldElement = !hideFormFieldElement && (label || htmlFor || margin || validate || error || help || formFieldBackground);
    return showFormFieldElement ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
        label: label,
        htmlFor: htmlFor || name || id,
        style: {
            width: width
        },
        margin: margin,
        validate: validate,
        error: error,
        help: help,
        background: formFieldBackground,
        children: renderTextInput()
    }) : renderTextInput();
};

});


parcelRegister("ixFvq", function(module, exports) {

$parcel$export(module.exports, "MediaTab", () => $abd8132515bc7249$export$2d0e2693b57b2bf7);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $6flum = parcelRequire("6flum");
var $hgBnK = parcelRequire("hgBnK");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("iTN0T");
var $8Ih9f = parcelRequire("8Ih9f");
const $abd8132515bc7249$export$2d0e2693b57b2bf7 = (props)=>{
    const { media: media, setMedia: setMedia, mediaOptions: mediaOptions, exclusivity: exclusivity, setExclusivity: setExclusivity } = props;
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        pad: "medium",
        overflow: {
            vertical: 'auto'
        },
        direction: "row",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                flex: "grow",
                gap: "medium",
                width: "60%",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "Does the client want exclusivity?"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6flum.RadioButtonGroup), {
                        direction: "row",
                        name: "exclusivity",
                        options: [
                            {
                                label: 'Yes',
                                value: 'yes'
                            },
                            {
                                label: 'No',
                                value: 'no'
                            }
                        ],
                        value: exclusivity,
                        onChange: (e)=>setExclusivity(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "What media will be produced for this project?"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hgBnK.SelectMultiple), {
                        showSelectedInline: true,
                        placeholder: "Select",
                        value: media,
                        options: mediaOptions,
                        labelKey: "label",
                        valueKey: {
                            key: 'value',
                            reduce: true
                        },
                        onChange: ({ value: value })=>setMedia(value),
                        width: "medium"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "40%",
                children: exclusivity === 'yes' || media?.includes('TV') ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ih9f.Hint), {
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Heads up! This commercial must be shot under the broadcast contract because",
                            ' ',
                            exclusivity === 'yes' ? 'the client wants exclusivity' : 'it will be on TV',
                            "."
                        ]
                    })
                }) : null
            })
        ]
    });
};

});
parcelRegister("hgBnK", function(module, exports) {

$parcel$export(module.exports, "SelectMultiple", () => $c920ed9452b42a38$export$12a18ac91a0d2aeb);

var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $dOlbm = parcelRequire("dOlbm");
var $hp4MM = parcelRequire("hp4MM");

var $5xcHk = parcelRequire("5xcHk");

var $b5k5v = parcelRequire("b5k5v");

var $czDw5 = parcelRequire("czDw5");

var $7wKkw = parcelRequire("7wKkw");

var $hwIeG = parcelRequire("hwIeG");

var $bXgbn = parcelRequire("bXgbn");

var $7y130 = parcelRequire("7y130");

var $4oskf = parcelRequire("4oskf");

var $jVcXh = parcelRequire("jVcXh");

var $2M0UK = parcelRequire("2M0UK");

var $e5Fvk = parcelRequire("e5Fvk");

var $eL6w3 = parcelRequire("eL6w3");
var $c920ed9452b42a38$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "aria-labelledby",
    "alignSelf",
    "children",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "help",
    "id",
    "icon",
    "labelKey",
    "limit",
    "margin",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "size",
    "sortSelectedOnClose",
    "value",
    "valueKey",
    "valueLabel",
    "showSelectedInline",
    "width"
];
function $c920ed9452b42a38$var$_extends() {
    return $c920ed9452b42a38$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c920ed9452b42a38$var$_extends.apply(null, arguments);
}
function $c920ed9452b42a38$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c920ed9452b42a38$var$StyledSelectBox = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "SelectMultiple__StyledSelectBox",
    componentId: "sc-18zwyth-0"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && (0, $2O6LY.controlBorderStyle);
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select$c;
    return props.open && ((_props$theme$select$c = props.theme.select.control) == null ? void 0 : _props$theme$select$c.open);
});
var $c920ed9452b42a38$export$12a18ac91a0d2aeb = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], ariaLabelledByProp = _ref['aria-labelledby'], alignSelf = _ref.alignSelf, children = _ref.children, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, dropAlignProp = _ref.dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, help = _ref.help, id = _ref.id, icon = _ref.icon, labelKey = _ref.labelKey, limit = _ref.limit, margin = _ref.margin, messages = _ref.messages, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, openProp = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, size = _ref.size, _ref$sortSelectedOnCl = _ref.sortSelectedOnClose, sortSelectedOnClose = _ref$sortSelectedOnCl === void 0 ? true : _ref$sortSelectedOnCl, valueProp = _ref.value, valueKey = _ref.valueKey, valueLabel = _ref.valueLabel, _ref$showSelectedInli = _ref.showSelectedInline, showSelectedInline = _ref$showSelectedInli === void 0 ? false : _ref$showSelectedInli, width = _ref.width, rest = $c920ed9452b42a38$var$_objectWithoutPropertiesLoose(_ref, $c920ed9452b42a38$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var inputRef = (0, $2NacA.useRef)();
    var formContext = (0, $2NacA.useContext)((0, $7wKkw.FormContext));
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var selectBoxRef = (0, $2NacA.useRef)();
    var dropButtonRef = (0, $dOlbm.useForwardedRef)(ref);
    var usingKeyboard = (0, $hp4MM.useKeyboard)();
    var formFieldData = formContext == null ? void 0 : formContext.useFormField({});
    var dropAlign = (0, $2NacA.useMemo)(function() {
        return dropAlignProp || (showSelectedInline ? {
            top: 'top',
            right: 'right',
            left: 'left'
        } : {
            top: 'bottom',
            left: 'left'
        });
    }, [
        dropAlignProp,
        showSelectedInline
    ]);
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, $2NacA.useState)(), ariaLabelledBy = _useState[0], setAriaLabelledBy = _useState[1];
    (0, $2NacA.useEffect)(function() {
        if (formFieldData != null && formFieldData.inForm && id && !ariaLabel && !placeholder) {
            var labelElement = document.getElementById("grommet-" + id + "__input__label");
            if (labelElement) setAriaLabelledBy("grommet-" + id + "__input__label " + id);
        }
    }, [
        formFieldData == null ? void 0 : formFieldData.inForm,
        id,
        ariaLabel,
        placeholder
    ]);
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, $2NacA.useMemo)(function() {
        return (0, $4oskf.getNormalizedValue)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState2 = (0, $2NacA.useState)(), search = _useState2[0], setSearch = _useState2[1];
    // All select option indices and values
    var _useState3 = (0, $2NacA.useState)(optionsProp), allOptions = _useState3[0], setAllOptions = _useState3[1];
    var _useState4 = (0, $2NacA.useState)(), orderedOptions = _useState4[0], setOrderedOptions = _useState4[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, $2NacA.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    (0, $2NacA.useEffect)(function() {
        if (search && optionsProp && optionsProp.length > 0) {
            var additionalOptions = [].concat(allOptions);
            optionsProp.forEach(function(i) {
                return !additionalOptions.some(function(j) {
                    return typeof i === 'object' ? (0, $4oskf.applyKey)(i, valueKey) === (0, $4oskf.applyKey)(j, valueKey) : i === j;
                }) && additionalOptions.push(i);
            });
            if (allOptions.length !== additionalOptions.length) setAllOptions(additionalOptions);
        }
    }, [
        allOptions,
        optionsProp,
        search,
        valueKey
    ]);
    (0, $2NacA.useEffect)(function() {
        if (sortSelectedOnClose) setOrderedOptions(optionsProp);
    }, [
        optionsProp,
        sortSelectedOnClose
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, $2NacA.useMemo)(function() {
        var result = [];
        if (!Array.isArray(normalizedValue)) return result;
        normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, $4oskf.applyKey)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        return result;
    }, [
        allOptions,
        valueKey,
        normalizedValue
    ]);
    var _useState5 = (0, $2NacA.useState)(openProp), open = _useState5[0], setOpen = _useState5[1];
    (0, $2NacA.useEffect)(function() {
        return setOpen(openProp);
    }, [
        openProp
    ]);
    var onRequestOpen = (0, $2NacA.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    // On drop close if sortSelectedOnClose is true, sort options so that
    // selected options appear first, followed by unselected options.
    (0, $2NacA.useEffect)(function() {
        if (sortSelectedOnClose && value && !open) {
            var selectedOptions = optionsProp.filter(function(option) {
                return (0, $4oskf.arrayIncludes)(value, valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(option, valueKey) : option, valueKey || labelKey);
            });
            var unselectedOptions = optionsProp.filter(function(i) {
                return !(0, $4oskf.arrayIncludes)(selectedOptions, i, valueKey || labelKey);
            });
            var nextOrderedOptions = selectedOptions.concat(unselectedOptions);
            setOrderedOptions(nextOrderedOptions);
        }
    }, [
        labelKey,
        open,
        sortSelectedOnClose,
        optionsProp,
        value,
        valueKey
    ]);
    var onRequestClose = (0, $2NacA.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, $2NacA.useCallback)(function(nextValue) {
        return (0, $4oskf.changeEvent)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, $2NacA.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value;
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if (typeof nextValue !== 'object' && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
            }
            onChange(adjustedEvent);
        }
    }, [
        onChange,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, $4oskf.getSelectIcon)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, $2NacA.useMemo)(function() {
        var result;
        if (valueLabel) result = value && valueLabel instanceof Function ? valueLabel(value) : valueLabel;
        else if ((value == null ? void 0 : value.length) > 0 && showSelectedInline) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hwIeG.SelectMultipleValue), {
            allOptions: allOptions,
            disabled: disabled,
            disabledKey: disabledKey,
            dropButtonRef: dropButtonRef,
            labelKey: labelKey,
            messages: messages,
            onRequestOpen: onRequestOpen,
            onSelectChange: onSelectChange,
            theme: theme,
            value: value,
            valueKey: valueKey
        }, children);
        return result;
    }, [
        allOptions,
        children,
        disabled,
        disabledKey,
        dropButtonRef,
        labelKey,
        messages,
        onRequestOpen,
        onSelectChange,
        showSelectedInline,
        theme,
        value,
        valueKey,
        valueLabel
    ]);
    var displayLabelKey = (0, $2NacA.useMemo)(function() {
        return (0, $4oskf.getDisplayLabelKey)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, $2NacA.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, $4oskf.applyKey)(allOptions[optionIndexesInValue[0]], labelKey);
            // keeping messages.multiple for backwards compatibility
            if (messages != null && messages.multiple && !messages.summarizedValue) return format({
                id: 'select.multiple',
                messages: messages
            });
            return format({
                id: 'selectMultiple.summarizedValue',
                messages: messages,
                values: {
                    selected: optionIndexesInValue.length,
                    total: allOptions.length
                }
            });
        }
        return undefined;
    }, [
        selectValue,
        optionIndexesInValue,
        allOptions,
        labelKey,
        format,
        messages
    ]);
    var iconColor = (0, $4oskf.getIconColor)(theme);
    var displaySelectIcon = SelectIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        alignSelf: "center",
        margin: theme.select.icons.margin,
        width: {
            min: 'auto'
        }
    }, /*#__PURE__*/ (0, $2NacA.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(SelectIcon, {
        color: iconColor,
        size: size
    }));
    var dropContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bXgbn.SelectMultipleContainer), {
        allOptions: allOptions,
        disabled: disabled,
        disabledKey: disabledKey,
        dropHeight: dropHeight,
        emptySearchMessage: emptySearchMessage,
        help: help,
        icon: displaySelectIcon,
        id: id,
        labelKey: labelKey,
        limit: limit,
        messages: messages,
        onChange: onSelectChange,
        onClose: onRequestClose,
        onKeyDown: onKeyDown,
        onMore: onMore,
        onSearch: onSearch,
        options: orderedOptions || optionsProp,
        optionIndexesInValue: optionIndexesInValue,
        replace: replace,
        searchPlaceholder: searchPlaceholder,
        search: search,
        setSearch: setSearch,
        usingKeyboard: usingKeyboard,
        value: value,
        valueKey: valueKey,
        showSelectedInline: showSelectedInline
    }, children);
    var dropButtonProps = {
        ref: dropButtonRef,
        a11yTitle: (ariaLabel || a11yTitle || placeholder || format({
            id: 'selectMultiple.open',
            messages: messages
        })) + ". " + format({
            id: 'selectMultiple.selected',
            values: {
                selected: (value == null ? void 0 : value.length) || 0,
                total: allOptions.length
            }
        }),
        'aria-expanded': Boolean(open),
        'aria-haspopup': 'listbox',
        id: id,
        disabled: disabled === true || undefined,
        open: open,
        focusIndicator: focusIndicator,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        plainSelect: plain,
        plain: plain,
        // Button should be plain
        dropProps: dropProps,
        dropContent: dropContent,
        theme: theme
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, showSelectedInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($c920ed9452b42a38$var$StyledSelectBox, $c920ed9452b42a38$var$_extends({
        disabled: disabled === true || undefined,
        alignSelf: alignSelf,
        direction: "row",
        alignContent: "start",
        background: theme.select.background,
        ref: selectBoxRef,
        flex: false,
        plainSelect: plain,
        width: width
    }, passThemeFlag), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $b5k5v.DropButton), $c920ed9452b42a38$var$_extends({
        fill: "horizontal",
        alignSelf: "start"
    }, dropButtonProps, {
        dropAlign: dropAlign,
        dropTarget: dropTarget || selectBoxRef.current
    }), selectValue || displayLabelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.SelectTextInput), $c920ed9452b42a38$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? (0, $4oskf.selectInputId)(id) : undefined,
        inert: (0, $4oskf.inertTrueValue),
        name: name,
        width: "100%"
    }, rest, {
        tabIndex: "-1",
        type: "text",
        placeholder: !value || (value == null ? void 0 : value.length) === 0 ? placeholder || selectValue || displayLabelKey : format({
            id: onMore ? 'selectMultiple.selected' : 'selectMultiple.selectedOfTotal',
            messages: messages,
            values: $c920ed9452b42a38$var$_extends({
                selected: (value == null ? void 0 : value.length) || 0
            }, !onMore ? {
                total: allOptions.length
            } : {})
        }),
        plain: true,
        readOnly: true,
        value: "",
        theme: theme
    })), displaySelectIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.HiddenInput), {
        type: "text",
        name: name,
        id: id ? (0, $4oskf.selectInputId)(id) : undefined,
        inert: (0, $4oskf.inertTrueValue),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jVcXh.DefaultSelectTextInput), $c920ed9452b42a38$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        disabled: disabled,
        id: id,
        inert: (0, $4oskf.inertTrueValue),
        name: name,
        ref: inputRef,
        placeholder: placeholder || 'Select',
        value: inputValue,
        size: size,
        theme: theme
    }, rest)), displaySelectIcon)), !open && (value == null ? void 0 : value.length) > 0 && (selectValue || displayLabelKey))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.StyledSelectDropButton), $c920ed9452b42a38$var$_extends({}, dropButtonProps, {
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        alignSelf: alignSelf,
        tabIndex: "0",
        "aria-labelledby": ariaLabelledByProp || ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.HiddenInput), {
        type: "text",
        name: name,
        id: id ? (0, $4oskf.selectInputId)(id) : undefined,
        inert: (0, $4oskf.inertTrueValue),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jVcXh.DefaultSelectTextInput), $c920ed9452b42a38$var$_extends({
        a11yTitle: ariaLabel || a11yTitle,
        disabled: disabled,
        id: id,
        inert: (0, $4oskf.inertTrueValue),
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), displaySelectIcon))));
});
$c920ed9452b42a38$export$12a18ac91a0d2aeb.displayName = 'SelectMultiple';
$c920ed9452b42a38$export$12a18ac91a0d2aeb.propTypes = (0, $e5Fvk.SelectMultiplePropTypes);

});
parcelRegister("hwIeG", function(module, exports) {

$parcel$export(module.exports, "SelectMultipleValue", () => $cc27bd20134e262e$export$65ae1fa19d91e9b3);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $gpKeH = parcelRequire("gpKeH");

var $7y130 = parcelRequire("7y130");

var $4oskf = parcelRequire("4oskf");

var $2M0UK = parcelRequire("2M0UK");
var $cc27bd20134e262e$export$65ae1fa19d91e9b3 = function SelectMultipleValue(_ref) {
    var _theme$selectMultiple2, _theme$selectMultiple3;
    var allOptions = _ref.allOptions, children = _ref.children, disabled = _ref.disabled, disabledKey = _ref.disabledKey, dropButtonRef = _ref.dropButtonRef, labelKey = _ref.labelKey, messages = _ref.messages, onRequestOpen = _ref.onRequestOpen, onSelectChange = _ref.onSelectChange, theme = _ref.theme, value = _ref.value, valueKey = _ref.valueKey;
    var _useState = (0, $2NacA.useState)(false), showA11yDiv = _useState[0], setShowA11yDiv = _useState[1];
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var isDisabled = (0, $4oskf.useDisabled)(disabled, disabledKey, allOptions, valueKey || labelKey);
    var visibleValue = (0, $2NacA.useCallback)(function(i) {
        var optionValue = valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(i, valueKey) : i;
        var optionSelected = (0, $4oskf.arrayIncludes)(value, optionValue, valueKey || labelKey);
        var indexOptions = (0, $4oskf.getOptionIndex)(allOptions, i, valueKey || labelKey);
        var optionLabel = (0, $4oskf.getOptionLabel)(indexOptions, allOptions, labelKey || valueKey);
        var optionDisabled = isDisabled(indexOptions);
        var valueIndex = (0, $4oskf.getOptionIndex)(value, optionValue, valueKey || labelKey);
        if (valueIndex < theme.selectMultiple.maxInline) {
            var _theme$selectMultiple;
            var child;
            if (children) child = children(i, indexOptions, allOptions, {
                active: false,
                disabled: optionDisabled,
                selected: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.SelectOption), {
                role: "option",
                a11yTitle: format({
                    id: optionSelected ? 'selectMultiple.optionSelected' : 'selectMultiple.optionNotSelected',
                    messages: messages,
                    values: {
                        optionLabel: optionLabel
                    }
                }),
                "aria-setsize": value.length,
                "aria-posinset": valueIndex + 1,
                "aria-selected": optionSelected,
                "aria-disabled": optionDisabled,
                plain: true,
                hoverIndicator: !optionDisabled,
                fill: "horizontal",
                tabIndex: "0",
                onClick: function onClick(event) {
                    if (!optionDisabled) {
                        var intermediate = [].concat(value);
                        if ((0, $4oskf.arrayIncludes)(intermediate, optionValue, valueKey || labelKey)) {
                            onSelectChange(event, {
                                option: optionValue,
                                value: intermediate.filter(function(v) {
                                    return typeof v === 'object' ? (0, $4oskf.applyKey)(v, valueKey || labelKey) !== (0, $4oskf.applyKey)(optionValue, valueKey || labelKey) : v !== optionValue;
                                })
                            });
                            if (valueIndex !== intermediate.length - 1) setTimeout(function() {
                                var nextFocus = document.getElementById("selected-" + intermediate[valueIndex + 1]);
                                if (nextFocus) nextFocus.focus();
                                var result = intermediate[valueIndex + 1];
                                setShowA11yDiv("Unselected " + optionLabel + ". \n                        Focus moved to " + (0, $4oskf.getOptionLabel)((0, $4oskf.getOptionIndex)(allOptions, result, valueKey || labelKey), allOptions, labelKey || valueKey));
                            }, 200); // Timeout needed to allow screen reader
                            else if (intermediate.length !== 1) setTimeout(function() {
                                var nextFocus = document.getElementById("selected-" + intermediate[valueIndex - 1]);
                                if (nextFocus) nextFocus.focus();
                                var result = intermediate[valueIndex - 1];
                                setShowA11yDiv("Unselected " + optionLabel + ". Focus moved to \n                          " + (0, $4oskf.getOptionLabel)((0, $4oskf.getOptionIndex)(allOptions, result, valueKey || labelKey), allOptions, labelKey || valueKey));
                            }, 200); // Timeout needed to allow screen reader
                            else if (dropButtonRef.current) dropButtonRef.current.focus();
                        }
                    }
                },
                key: optionLabel,
                id: "selected-" + optionValue
            }, child || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $gpKeH.CheckBox), {
                disabled: optionDisabled,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
                    alignSelf: "center",
                    align: "start"
                }, optionLabel),
                key: optionLabel,
                pad: (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.option) == null ? void 0 : _theme$selectMultiple.pad,
                tabIndex: "-1",
                checked: optionSelected,
                inert: (0, $4oskf.inertTrueValue),
                containerProps: {
                    // in Firefox when we have inert set, the checkbox
                    // click event gets swallowed by the checkbox.
                    // We need the click event to go the the button
                    // around the checkbox so we use pointerEvents =
                    // none. For code clarity we decided an inline
                    // style made sense here.
                    style: {
                        pointerEvents: 'none'
                    }
                }
            }));
        }
        return undefined;
    }, [
        allOptions,
        children,
        dropButtonRef,
        format,
        isDisabled,
        labelKey,
        messages,
        onSelectChange,
        theme.selectMultiple.maxInline,
        (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.option) == null ? void 0 : _theme$selectMultiple2.pad,
        value,
        valueKey
    ]);
    // After announcing set showA11yDiv to undefined so it won't
    // be read out again
    (0, $2NacA.useEffect)(function() {
        if (showA11yDiv !== undefined) setTimeout(function() {
            setShowA11yDiv(undefined);
        }, 1000);
    }, [
        showA11yDiv
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        width: "100%",
        role: "listbox",
        "aria-multiselectable": true,
        a11yTitle: format({
            id: 'selectMultiple.selectedOptions',
            messages: messages
        })
    }, value && allOptions.filter(function(i) {
        return (0, $4oskf.arrayIncludes)(value, valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(i, valueKey) : i, valueKey || labelKey);
    }).map(function(i) {
        return visibleValue(i);
    }), showA11yDiv && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        height: "0px",
        width: "0px",
        overflow: "hidden",
        "aria-live": "assertive",
        role: "alert"
    }, showA11yDiv)), value && value.length > theme.selectMultiple.maxInline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.showMore) == null ? void 0 : _theme$selectMultiple3.pad,
        alignSelf: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        onClick: onRequestOpen,
        size: "small",
        label: format({
            id: 'selectMultiple.showMore',
            messages: messages,
            values: {
                remaining: value.length - theme.selectMultiple.maxInline
            }
        })
    })));
};

});

parcelRegister("bXgbn", function(module, exports) {

$parcel$export(module.exports, "SelectMultipleContainer", () => $8b41c1e76ffd03e2$export$2dd06c00b4faaa63);

var $2NacA = parcelRequire("2NacA");

var $eH2U4 = parcelRequire("eH2U4");

var $cDMMY = parcelRequire("cDMMY");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $gpKeH = parcelRequire("gpKeH");

var $cy6cI = parcelRequire("cy6cI");

var $czDw5 = parcelRequire("czDw5");

var $kS7Ii = parcelRequire("kS7Ii");

var $kQZ06 = parcelRequire("kQZ06");

var $463jD = parcelRequire("463jD");

var $7y130 = parcelRequire("7y130");

var $4oskf = parcelRequire("4oskf");

var $bev11 = parcelRequire("bev11");

var $2M0UK = parcelRequire("2M0UK");

var $eL6w3 = parcelRequire("eL6w3");
function $8b41c1e76ffd03e2$var$_extends() {
    return $8b41c1e76ffd03e2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8b41c1e76ffd03e2$var$_extends.apply(null, arguments);
}
var $8b41c1e76ffd03e2$export$2dd06c00b4faaa63 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$select$icons, _theme$selectMultiple2;
    var allOptions = _ref.allOptions, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, disabledProp = _ref.disabled, disabledKey = _ref.disabledKey, dropHeight = _ref.dropHeight, _ref$emptySearchMessa = _ref.emptySearchMessage, emptySearchMessage = _ref$emptySearchMessa === void 0 ? 'No matches found' : _ref$emptySearchMessa, help = _ref.help, icon = _ref.icon, id = _ref.id, labelKey = _ref.labelKey, limit = _ref.limit, messages = _ref.messages, onChange = _ref.onChange, onClose = _ref.onClose, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onSearch = _ref.onSearch, optionIndexesInValue = _ref.optionIndexesInValue, options = _ref.options, _ref$replace = _ref.replace, replace = _ref$replace === void 0 ? true : _ref$replace, searchPlaceholder = _ref.searchPlaceholder, search = _ref.search, setSearch = _ref.setSearch, usingKeyboard = _ref.usingKeyboard, _ref$value = _ref.value, value = _ref$value === void 0 ? [] : _ref$value, valueKey = _ref.valueKey, showSelectedInline = _ref.showSelectedInline;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    // the currently active option based on keyboard navigation
    // or mouse hover, -1 means no active option
    var _useState = (0, $2NacA.useState)(-1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, $2NacA.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var searchRef = (0, $2NacA.useRef)();
    var optionsRef = (0, $2NacA.useRef)();
    var _useState3 = (0, $2NacA.useState)(disabledProp), disabled = _useState3[0], setDisabled = _useState3[1];
    // the node of the currently active option, as activeIndex changes
    // this is updated too and the useEffect below ensures the
    // active option remains in keyboard focus since we're
    // following roving tab index pattern
    var activeRef = (0, $2NacA.useRef)();
    var _useState4 = (0, $2NacA.useState)(), showA11yLimit = _useState4[0], setShowA11yLimit = _useState4[1];
    var clearRef = (0, $2NacA.useRef)();
    var isDisabled = (0, $4oskf.useDisabled)(disabled, disabledKey, options, valueKey || labelKey);
    var searchIcon = ((_theme$select$icons = theme.select.icons) == null ? void 0 : _theme$select$icons.search) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $eH2U4.Search), {
        "aria-hidden": true
    });
    // for keyboard/screenreader, keep the active option in focus
    (0, $2NacA.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, $2NacA.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus) (0, $cDMMY.setFocusWithoutScroll)(clearButton);
            else if (searchRef && searchRef.current) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus) (0, $cDMMY.setFocusWithoutScroll)(searchInput);
            } else if (activeRef.current) (0, $cDMMY.setFocusWithoutScroll)(activeRef.current);
            else if (optionsRef.current) setActiveIndex(0);
        }, 100); // Drop should be open after 100ms
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0, $2NacA.useEffect)(function() {
        var optionsNode = optionsRef.current;
        if (optionsNode != null && optionsNode.children) {
            var optionNode = optionsNode.children[activeIndex];
            if (optionNode) optionNode.focus();
        }
    }, [
        activeIndex
    ]);
    var isSelected = (0, $2NacA.useCallback)(function(index) {
        var result;
        var optionVal = (0, $4oskf.getOptionValue)(index, options, valueKey || labelKey);
        if (value) {
            if (value.length === 0) result = false;
            else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
            else if (valueKey) result = value.some(function(valueItem) {
                var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey];
                return valueValue === optionVal;
            });
        }
        return result;
    }, [
        value,
        valueKey,
        options,
        labelKey
    ]);
    var selectOption = (0, $2NacA.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                var allOptionsIndex = (0, $4oskf.getOptionIndex)(allOptions, options[index], valueKey || labelKey);
                var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                if (valueIndex === -1 && (!limit || (value == null ? void 0 : value.length) < limit)) nextOptionIndexesInValue.push(allOptionsIndex);
                else nextOptionIndexesInValue.splice(valueIndex, 1);
                var nextValue = nextOptionIndexesInValue.map(function(i) {
                    return valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(allOptions[i], valueKey) : allOptions[i];
                });
                var nextSelected = nextOptionIndexesInValue;
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        labelKey,
        limit,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey,
        value
    ]);
    var onNextOption = (0, $2NacA.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        // checking activeIndex > -1 ensures arrow keys don't
        // move focus when select all/clear all button or search input
        // are focused
        if (nextActiveIndex !== (options == null ? void 0 : options.length) && activeIndex > -1) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options
    ]);
    var onPreviousOption = (0, $2NacA.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        // checking activeIndex > -1 ensures arrow keys don't
        // move focus when select all/clear all button or search input
        // are focused
        if (activeIndex > -1) {
            setActiveIndex(Math.max(nextActiveIndex, 0));
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex
    ]);
    var onKeyDownOption = (0, $2NacA.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e) {
                var label;
                if (typeof e === 'object') label = e.label || (0, $4oskf.applyKey)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase();
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        onKeyDown,
        options,
        onSearch,
        labelKey
    ]);
    var onActiveOption = (0, $2NacA.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, $2NacA.useCallback)(function(event) {
        if (!isDisabled(activeIndex) && activeIndex >= 0 && activeIndex < (options == null ? void 0 : options.length)) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        isDisabled
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || (0, $kQZ06.TextInput);
    var selectOptionsStyle = theme.select.options ? $8b41c1e76ffd03e2$var$_extends({}, theme.select.options.box, theme.select.options.container) : {};
    // handle when limit is reached
    (0, $2NacA.useEffect)(function() {
        var originallyDisabled = function originallyDisabled(index) {
            var option = allOptions[index];
            var result;
            if (disabledKey) result = (0, $4oskf.applyKey)(option, disabledKey);
            else if (Array.isArray(disabledProp)) {
                if (typeof disabledProp[0] === 'number') result = disabledProp.indexOf(index) !== -1;
                else result = (0, $4oskf.getOptionIndex)(disabledProp, (0, $4oskf.getOptionValue)(index, options, valueKey || labelKey), valueKey || labelKey) !== -1;
            }
            return result;
        };
        if (value && limit) {
            if (value.length === limit) {
                var newDisabled = [].concat(disabledProp);
                // disable everything that is not selected
                for(var i = 0; i < (options == null ? void 0 : options.length); i += 1)if (!isSelected(i) && !originallyDisabled(i)) newDisabled.push(options[i]);
                if (usingKeyboard) setShowA11yLimit('Selected. Maximum selection limit reached.');
                setDisabled(newDisabled);
            } else {
                if (usingKeyboard) setShowA11yLimit(undefined);
                setDisabled(disabledProp);
            }
        }
    }, [
        isSelected,
        value,
        limit,
        disabledProp,
        allOptions,
        disabledKey,
        labelKey,
        options,
        usingKeyboard,
        valueKey
    ]);
    // reset showA11yLimit after announcement is read
    (0, $2NacA.useEffect)(function() {
        if (showA11yLimit !== undefined) setTimeout(function() {
            setShowA11yLimit(undefined);
        }, 2000); // value chosen based on length of a11yLimit message
    }, [
        showA11yLimit
    ]);
    var summaryContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $463jD.SelectionSummary), {
        allOptions: allOptions,
        clearRef: clearRef,
        disabled: disabled,
        disabledKey: disabledKey,
        isSelected: isSelected,
        labelKey: labelKey,
        limit: limit,
        messages: messages,
        onChange: onChange,
        onMore: onMore,
        options: options,
        search: search,
        setActiveIndex: setActiveIndex,
        showSelectedInline: showSelectedInline,
        value: value,
        valueKey: valueKey
    });
    var helpContent;
    if (help) {
        var _theme$selectMultiple;
        if (typeof help === 'string') helpContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            flex: false,
            pad: (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.help) == null || (_theme$selectMultiple = _theme$selectMultiple.container) == null ? void 0 : _theme$selectMultiple.pad
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), {
            size: "small"
        }, help));
        else helpContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
            flex: false
        }, help);
    }
    if (showSelectedInline) summaryContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        direction: "row",
        justify: "between",
        flex: false
    }, summaryContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        fill: "vertical",
        onClick: onClose,
        a11yTitle: "Close Select"
    }, icon)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption,
        onEsc: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.StyledContainer), {
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight,
        a11yTitle: format({
            id: 'selectMultiple.selectDrop',
            messages: messages
        })
    }, summaryContent, onSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: !customSearchInput ? (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.search) == null ? void 0 : _theme$selectMultiple2.pad : undefined,
        flex: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $czDw5.Keyboard), {
        onEnter: function onEnter(event) {
            onNextOption(event);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(SelectTextInput, {
        a11yTitle: format({
            id: 'selectMultiple.search',
            messages: messages
        }),
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        icon: searchIcon
    }))), helpContent, (options == null ? void 0 : options.length) > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.OptionsContainer), {
        "aria-label": format({
            id: 'selectMultiple.optionsA11y',
            messages: messages
        }),
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": true,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        },
        selectMultiple: true // internal prop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cy6cI.InfiniteScroll), {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = value ? (0, $4oskf.arrayIncludes)(value, valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(option, valueKey) : option, valueKey || labelKey) : false;
        var optionActive = activeIndex === index;
        var optionLabel = (0, $4oskf.getOptionLabel)(index, options, labelKey || valueKey);
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else {
            var _theme$selectMultiple3;
            child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $gpKeH.CheckBox), {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
                    alignSelf: "center",
                    width: "100%",
                    align: "start"
                }, optionLabel),
                pad: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.option) == null ? void 0 : _theme$selectMultiple3.pad,
                tabIndex: "-1",
                checked: optionSelected,
                disabled: optionDisabled,
                inert: (0, $4oskf.inertTrueValue),
                containerProps: {
                    // in Firefox when we have inert set, the checkbox
                    // click event gets swallowed by the checkbox.
                    // We need the click event to go the the button
                    // around the checkbox so we use pointerEvents =
                    // none. For code clarity we decided an inline
                    // style made sense here.
                    style: {
                        pointerEvents: 'none'
                    }
                }
            });
        }
        if (!children && search) {
            var searchText = search.toLowerCase();
            if (typeof optionLabel === 'string' && optionLabel.toLowerCase().indexOf(searchText) >= 0) {
                var _theme$selectMultiple4;
                // code to bold search term in matching options
                var boldIndex = optionLabel.toLowerCase().indexOf(searchText);
                var childBeginning = optionLabel.substring(0, boldIndex);
                var childBold = optionLabel.substring(boldIndex, boldIndex + searchText.length);
                childBold = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("b", null, childBold);
                var childEnd = optionLabel.substring(boldIndex + searchText.length);
                child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $gpKeH.CheckBox), {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
                        alignSelf: "center",
                        width: "100%",
                        align: "start",
                        direction: "row"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), null, childBeginning, childBold, childEnd)),
                    pad: (_theme$selectMultiple4 = theme.selectMultiple) == null || (_theme$selectMultiple4 = _theme$selectMultiple4.option) == null ? void 0 : _theme$selectMultiple4.pad,
                    tabIndex: "-1",
                    checked: optionSelected,
                    disabled: optionDisabled,
                    inert: (0, $4oskf.inertTrueValue),
                    containerProps: {
                        // in Firefox when we have inert set, the checkbox
                        // click event gets swallowed by the checkbox.
                        // We need the click event to go the the button
                        // around the checkbox so we use pointerEvents =
                        // none. For code clarity we decided an inline
                        // style made sense here.
                        style: {
                            pointerEvents: 'none'
                        }
                    }
                });
            }
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $7y130.SelectOption), {
            a11yTitle: format({
                id: optionSelected ? 'selectMultiple.optionSelected' : 'selectMultiple.optionNotSelected',
                messages: messages,
                values: {
                    optionLabel: optionLabel
                }
            }),
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected || activeIndex === index || // when nothing is selected and entering listbox
            // first option should be focused
            value.length === 0 && activeIndex === -1 && index === 0 ? '0' : '-1',
            role: "option",
            id: "option" + index,
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            focusIndicator: usingKeyboard,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            active: optionActive,
            selected: optionSelected,
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            textComponent: textComponent
        }, child);
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $bev11.EmptySearchOption), {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), usingKeyboard && showA11yLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        height: "0px",
        width: "0px",
        overflow: "hidden",
        "aria-live": "assertive",
        role: "alert"
    }, showA11yLimit)));
});

});
parcelRegister("463jD", function(module, exports) {

$parcel$export(module.exports, "SelectionSummary", () => $2fba4b6356610d47$export$4d281ebdf277250c);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $5xcHk = parcelRequire("5xcHk");

var $a26J5 = parcelRequire("a26J5");

var $kS7Ii = parcelRequire("kS7Ii");

var $4oskf = parcelRequire("4oskf");

var $2M0UK = parcelRequire("2M0UK");

var $eL6w3 = parcelRequire("eL6w3");
var $2fba4b6356610d47$export$4d281ebdf277250c = function SelectionSummary(_ref) {
    var _theme$selectMultiple, _theme$selectMultiple2, _theme$selectMultiple3, _theme$selectMultiple4;
    var allOptions = _ref.allOptions, clearRef = _ref.clearRef, disabled = _ref.disabled, disabledKey = _ref.disabledKey, isSelected = _ref.isSelected, labelKey = _ref.labelKey, limit = _ref.limit, messages = _ref.messages, onChange = _ref.onChange, onMore = _ref.onMore, options = _ref.options, search = _ref.search, setActiveIndex = _ref.setActiveIndex, showSelectedInline = _ref.showSelectedInline, value = _ref.value, valueKey = _ref.valueKey;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var isDisabled = (0, $4oskf.useDisabled)(disabled, disabledKey, options, valueKey || labelKey);
    var selectedValuesDisabled = (0, $2NacA.useCallback)(function() {
        var disabledSelected = 0;
        if (value) {
            for(var i = 0; i < allOptions.length; i += 1)if ((0, $4oskf.arrayIncludes)(value, (0, $4oskf.getOptionValue)(i, options, valueKey || labelKey), valueKey || labelKey) && isDisabled(i)) disabledSelected += 1;
            if (value.length === disabledSelected) return true;
        }
        return false;
    }, [
        value,
        allOptions,
        options,
        valueKey,
        labelKey,
        isDisabled
    ]);
    var selectedInSearch = (0, $2NacA.useCallback)(function() {
        return options == null ? void 0 : options.filter(function(option) {
            return (0, $4oskf.arrayIncludes)(value, option, valueKey || labelKey);
        });
    }, [
        options,
        value,
        valueKey,
        labelKey
    ]);
    var showSelectAll = !!((value == null ? void 0 : value.length) === 0 || selectedValuesDisabled() || !value || selectedInSearch().length === 0);
    var messageId = (value == null ? void 0 : value.length) === 0 || onMore || !value || search !== '' && search !== undefined ? 'selectMultiple.selected' : 'selectMultiple.selectedOfTotal';
    var summaryText = format({
        id: messageId,
        messages: messages,
        values: {
            selected: (value == null ? void 0 : value.length) || 0,
            total: options.length
        }
    });
    var summaryButtonClick = function summaryButtonClick(event) {
        if (onChange) {
            var nextSelected = options.filter(function(i, index) {
                return showSelectAll ? !isDisabled(index) || isSelected(index) : isDisabled(index) && isSelected(index);
            });
            if (search !== '' && search !== undefined && value) {
                if (showSelectAll) nextSelected = nextSelected.concat(value);
                else value.forEach(function(item) {
                    if (!(0, $4oskf.arrayIncludes)(options, item, valueKey || labelKey)) nextSelected.push(item);
                });
            }
            var nextValue = nextSelected.map(function(i) {
                return valueKey && valueKey.reduce ? (0, $4oskf.applyKey)(i, valueKey) : i;
            });
            onChange(event, {
                option: options,
                value: nextValue,
                selected: nextSelected
            });
        }
        if (limit && !showSelectAll) setActiveIndex(0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $5xcHk.Box), {
        pad: showSelectedInline ? (_theme$selectMultiple = theme.selectMultiple) == null || (_theme$selectMultiple = _theme$selectMultiple.summary) == null || (_theme$selectMultiple = _theme$selectMultiple.showSelectedInline) == null ? void 0 : _theme$selectMultiple.pad : (_theme$selectMultiple2 = theme.selectMultiple) == null || (_theme$selectMultiple2 = _theme$selectMultiple2.summary) == null ? void 0 : _theme$selectMultiple2.pad,
        direction: "row",
        justify: "between",
        gap: (_theme$selectMultiple3 = theme.selectMultiple) == null || (_theme$selectMultiple3 = _theme$selectMultiple3.summary) == null ? void 0 : _theme$selectMultiple3.gap,
        fill: "horizontal",
        flex: showSelectedInline,
        align: "center",
        height: (_theme$selectMultiple4 = theme.selectMultiple) == null || (_theme$selectMultiple4 = _theme$selectMultiple4.summary) == null ? void 0 : _theme$selectMultiple4.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $kS7Ii.Text), {
        size: "small"
    }, summaryText), (options.length && (!limit || !(!value || (value == null ? void 0 : value.length) === 0 && selectedValuesDisabled()))) > 0 && (!onMore || onMore && (value == null ? void 0 : value.length) !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $a26J5.Button), {
        a11yTitle: showSelectAll ? format({
            id: 'selectMultiple.selectAllA11y',
            messages: messages,
            values: {
                total: options.length
            }
        }) : format({
            id: 'selectMultiple.clearAllA11y',
            messages: messages,
            values: {
                selected: (value == null ? void 0 : value.length) || 0
            }
        }),
        label: format({
            id: showSelectAll ? 'selectMultiple.selectAll' : 'selectMultiple.clearAll',
            messages: messages
        }),
        onClick: function onClick(event) {
            return summaryButtonClick(event);
        },
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        ref: clearRef
    }));
};

});


parcelRegister("e5Fvk", function(module, exports) {

$parcel$export(module.exports, "SelectMultiplePropTypes", () => $a421ba2eccde38d9$export$81241bedce0a1d47);


function $a421ba2eccde38d9$var$_extends() {
    return $a421ba2eccde38d9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a421ba2eccde38d9$var$_extends.apply(null, arguments);
}
var $a421ba2eccde38d9$var$PropType = {};
var $a421ba2eccde38d9$export$81241bedce0a1d47 = $a421ba2eccde38d9$var$PropType;

});



parcelRegister("6te8u", function(module, exports) {

$parcel$export(module.exports, "defaultRolePerformer", () => $b31fc423576aecb9$export$fb07eaa9b0a2cff2);
$parcel$export(module.exports, "formatDefaultName", () => $b31fc423576aecb9$export$b8b0ab9496299b19);
$parcel$export(module.exports, "RolePerformersTab", () => $b31fc423576aecb9$export$9f3ae039bbe48e64);

var $6ir3O = parcelRequire("6ir3O");

var $fjut3 = parcelRequire("fjut3");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");

var $5xcHk = parcelRequire("5xcHk");
var $8Ao5G = parcelRequire("8Ao5G");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $dmh5A = parcelRequire("dmh5A");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $gdNyE = parcelRequire("gdNyE");
var $hF8pi = parcelRequire("hF8pi");
var $bIzid = parcelRequire("bIzid");
const $b31fc423576aecb9$export$fb07eaa9b0a2cff2 = {
    name: 'New Role',
    roleType: (0, $lUAc5.RoleType).Actor,
    performerType: (0, $8kKyn.RolePerformerType).OnCameraPrincipal,
    groupSize: 1
};
const $b31fc423576aecb9$export$b8b0ab9496299b19 = (performer, i, isDirty)=>{
    let outputName = `${performer.roleType} - ${performer.performerType}`;
    if (performer.name) outputName = performer.name;
    else if (!performer.name && isDirty) outputName = '';
    if (performer.groupSize > 1) {
        const groupTag = i && i >= 1 ? `(${i} of ${performer.groupSize})` : `of ${performer.groupSize}`;
        outputName = `${outputName} ${groupTag}`;
    }
    return outputName;
};
const $b31fc423576aecb9$export$9f3ae039bbe48e64 = ({ rolePerformers: rolePerformers, setRolePerformers: setRolePerformers })=>{
    /** State **/ const [dirtyInputs, setDirtyInputs] = (0, $2NacA.useState)({});
    /** Computed **/ const roleKeys = Object.keys((0, $lUAc5.RoleType));
    const performerKeys = Object.keys((0, $8kKyn.RolePerformerType)).filter((key)=>!(0, $fjut3.GroupPerformerTypeFilter).includes((0, $8kKyn.RolePerformerType)[key]));
    // create an array of IGroupPerformers with values from 3 to "9+"
    const groupSize = [];
    for(let i = 3; i <= 9; i++)groupSize.push({
        label: i.toString(),
        value: i
    });
    groupSize.push({
        label: '9+',
        value: 10
    });
    /** Refs **/ const rolesAdded = (0, $2NacA.useRef)(rolePerformers.length);
    /** Methods **/ const newRole = ()=>{
        const role = {
            name: `New Role ${rolesAdded.current += 1}`,
            performerType: (0, $8kKyn.RolePerformerType).OnCameraPrincipal,
            roleType: (0, $lUAc5.RoleType).Actor,
            groupSize: 1
        };
        setRolePerformers([
            ...rolePerformers,
            role
        ]);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        gap: "medium",
        overflow: {
            vertical: 'auto'
        },
        height: {
            max: 'large'
        },
        fill: true,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            flex: "grow",
            pad: "medium",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: "Almost done! Let's finish up by discussing roles. Who's going to be in this commercial?"
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    pad: {
                        top: 'small',
                        right: 'large'
                    },
                    justify: "end",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        secondary: true,
                        label: "Add Role",
                        tip: "Add Role",
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {}),
                        onClick: ()=>newRole()
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    gap: "small",
                    pad: {
                        left: 'small'
                    },
                    margin: {
                        top: 'small'
                    },
                    children: rolePerformers.map((performer, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            border: "all",
                            round: "small",
                            pad: "small",
                            gap: "small",
                            margin: {
                                bottom: 'small'
                            },
                            background: "light-1",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    direction: "row",
                                    gap: "small",
                                    pad: "xsmall",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        id: `performer-${i}`,
                                        name: `performer-${i}`,
                                        label: i === 0 ? 'Role Name' : undefined,
                                        htmlFor: `performer-${i}`,
                                        placeholder: "Performer Name",
                                        val: $b31fc423576aecb9$export$b8b0ab9496299b19(performer, i, dirtyInputs[i]) || '',
                                        onChange: (val)=>{
                                            const newPerformers = [
                                                ...rolePerformers
                                            ];
                                            newPerformers[i].name = val;
                                            setRolePerformers(newPerformers);
                                            setDirtyInputs((prev)=>({
                                                    ...prev,
                                                    [i]: true
                                                }));
                                        },
                                        width: "large",
                                        textSize: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    gap: "small",
                                    pad: "xsmall",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: i === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                children: "Performer Type"
                                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {}),
                                            htmlFor: `performer-type-${i}`,
                                            width: "medium",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                                id: `performer-type-${i}`,
                                                name: `performer-type-${i}`,
                                                placeholder: "Performer Type",
                                                options: performerKeys.map((key)=>(0, $8kKyn.RolePerformerType)[key]),
                                                value: performer.performerType,
                                                onChange: ({ option: option })=>{
                                                    const newPerformers = [
                                                        ...rolePerformers
                                                    ];
                                                    newPerformers[i].performerType = option;
                                                    !(0, $fjut3.GroupPerformerTypes).includes(option) && (newPerformers[i].groupSize = 1);
                                                    setRolePerformers(newPerformers);
                                                },
                                                size: "small"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: i === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                children: "Role Type"
                                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {}),
                                            htmlFor: `role-type-${i}`,
                                            width: "small",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                                id: `role-type-${i}`,
                                                name: `role-type-${i}`,
                                                options: roleKeys.filter((key)=>(0, $fjut3.RoleFilter)[performer.performerType]?.includes((0, $lUAc5.RoleType)[key])).map((key)=>(0, $lUAc5.RoleType)[key]),
                                                value: performer.roleType,
                                                onChange: ({ option: option })=>{
                                                    const newPerformers = [
                                                        ...rolePerformers
                                                    ];
                                                    newPerformers[i].roleType = option;
                                                    setRolePerformers(newPerformers);
                                                },
                                                size: "small"
                                            })
                                        }),
                                        (0, $fjut3.GroupPerformerTypes).includes(performer.performerType) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: i === 0 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "small",
                                                children: "Group Size"
                                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {}),
                                            htmlFor: `group-size-${i}`,
                                            width: "small",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                                id: `group-size-${i}`,
                                                name: `group-size-${i}`,
                                                options: groupSize,
                                                value: performer.groupSize,
                                                labelKey: "label",
                                                valueKey: {
                                                    key: 'value',
                                                    reduce: true
                                                },
                                                onChange: ({ option: option })=>{
                                                    const newPerformers = [
                                                        ...rolePerformers
                                                    ];
                                                    newPerformers[i].groupSize = option.value;
                                                    setRolePerformers(newPerformers);
                                                },
                                                size: "small"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                                            onClick: ()=>{
                                                const newPerformers = [
                                                    ...rolePerformers
                                                ];
                                                newPerformers.splice(i, 1);
                                                setRolePerformers(newPerformers);
                                                return new Promise((resolve)=>resolve(true));
                                            },
                                            name: performer.name || `${performer.roleType} - ${performer.performerType}`,
                                            size: "small",
                                            tip: "Delete Role",
                                            hoverIndicator: true
                                        })
                                    ]
                                })
                            ]
                        }, i))
                })
            ]
        })
    });
};

});

parcelRegister("duQ5T", function(module, exports) {

$parcel$export(module.exports, "ShootTab", () => $2ef44c31b08d3088$export$62c4e02b94d9d3d7);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $gGAG2 = parcelRequire("gGAG2");

var $5xcHk = parcelRequire("5xcHk");
var $94KEY = parcelRequire("94KEY");
var $6flum = parcelRequire("6flum");
var $kS7Ii = parcelRequire("kS7Ii");

var $2NacA = parcelRequire("2NacA");

var $bgcVc = parcelRequire("bgcVc");
parcelRequire("3Focm");
var $3qrf8 = parcelRequire("3qrf8");
parcelRequire("iTN0T");
var $8Ih9f = parcelRequire("8Ih9f");
const $2ef44c31b08d3088$export$62c4e02b94d9d3d7 = ({ geography: geography, union: union, firstSessionDate: firstSessionDate, place: place, locationType: locationType, setShoot: setShoot, setUnion: setUnion, setFirstSessionDate: setFirstSessionDate, setPlace: setPlace, setLocationType: setLocationType })=>{
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (geography === 'offshore') {
            setUnion('nonunion');
            setPlace(undefined);
            setLocationType(undefined);
        }
    }, [
        geography,
        setUnion,
        setPlace,
        setLocationType
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        pad: "medium",
        gap: "medium",
        overflow: {
            vertical: 'auto'
        },
        direction: "row",
        height: {
            max: 'large'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                width: "50%",
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "Alright! Now, where will the shoot(s) take place?"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6flum.RadioButtonGroup), {
                                direction: "column",
                                name: "geography",
                                options: [
                                    {
                                        label: 'USA',
                                        value: 'usa'
                                    },
                                    {
                                        label: 'Offshore',
                                        value: 'offshore'
                                    }
                                ],
                                value: geography,
                                onChange: (e)=>setShoot(e.target.value)
                            }),
                            geography === 'usa' && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                pad: "small",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Where in the USA will the shoot be? If you don't know, you can leave this field blank."
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3qrf8.Location), {
                                        id: "new",
                                        place: place,
                                        updatePlace: setPlace
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "column",
                width: "50%",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "... and when will the first session be?"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        gap: "small",
                        direction: "row",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: firstSessionDate && (0, $bgcVc.formatDateOnly)(firstSessionDate)
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                value: firstSessionDate,
                                onChange: ({ value: value })=>setFirstSessionDate((0, $bgcVc.fromDateInputChange)(value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "Talent will:"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6flum.RadioButtonGroup), {
                        direction: "column",
                        name: "union",
                        options: [
                            {
                                label: 'Return to the reporting site EOD',
                                value: (0, $gGAG2.LocationType).Nearby
                            },
                            {
                                label: 'Stay overnight',
                                value: (0, $gGAG2.LocationType).Distant
                            }
                        ],
                        value: locationType,
                        onChange: (e)=>setLocationType(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "Will this be a union or non-union shoot?"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6flum.RadioButtonGroup), {
                        direction: "column",
                        name: "union",
                        options: [
                            {
                                label: 'Union',
                                value: 'union'
                            },
                            {
                                label: 'Non-Union',
                                value: 'nonunion'
                            }
                        ],
                        value: union,
                        onChange: (e)=>setUnion(e.target.value)
                    }),
                    geography === 'offshore' && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        pad: "small",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ih9f.Hint), {
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Since this shoot is offshore, it is automatically non-union."
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("jmZJk", function(module, exports) {

$parcel$export(module.exports, "StartTab", () => $b4ad266de030263b$export$61b1111c35189034);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $uBb61 = parcelRequire("uBb61");
var $8Ao5G = parcelRequire("8Ao5G");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("iTN0T");
var $8Ih9f = parcelRequire("8Ih9f");
parcelRequire("ibR9R");
var $1sflP = parcelRequire("1sflP");
var $bIzid = parcelRequire("bIzid");
const $b4ad266de030263b$export$61b1111c35189034 = ({ name: name, code: code, client: client, product: product, budget: budget, clientList: clientList, setName: setName, setCode: setCode, setClient: setClient, setClientList: setClientList, setProduct: setProduct, setBudget: setBudget })=>{
    /** Methods **/ const selectClient = (clientName)=>{
        if (!clientName) return;
        const selectedClient = clientList.find((client)=>client.name?.toLocaleLowerCase() === clientName.toLocaleLowerCase());
        if (selectedClient) setClient(selectedClient);
        else {
            const client = {
                id: 'NEW',
                name: clientName,
                isSagSignatory: false,
                isJpcAuthorizer: false
            };
            setClientList([
                ...clientList,
                client
            ]);
            setClient(client);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        pad: "medium",
        direction: "column",
        width: "100%",
        gap: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    children: "Welcome! Let's get started creating a new project. Fill in as much as you can, and don't worry if you don't know some answers right now. You can always make changes later. (This is the only tab in the wizard with required* fields.)"
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "column",
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $uBb61.Form), {
                            validate: "blur",
                            id: "start",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    direction: "row",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        id: "project-name",
                                        label: "Project Name",
                                        name: "project-name",
                                        required: true,
                                        val: name,
                                        onChange: (name)=>setName(name),
                                        validate: [
                                            (val)=>val.length > 3 ? true : undefined
                                        ],
                                        "aria-required": true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    direction: "row",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        id: "job-code",
                                        label: "Job Code",
                                        name: "job-code",
                                        required: true,
                                        val: code,
                                        onChange: (code)=>setCode(code),
                                        "aria-required": true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    pad: {
                                        vertical: 'medium'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ao5G.FormField), {
                                            label: "Client",
                                            htmlFor: "select-client",
                                            name: "client",
                                            required: true,
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1sflP.CreateSelect), {
                                                id: "select-client",
                                                defaultOptions: clientList.map((client)=>client.name || ''),
                                                onChange: selectClient,
                                                defaultValue: client?.name,
                                                required: true,
                                                placeholder: "Select Client",
                                                name: "client"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "column",
                                            gap: "small",
                                            width: "medium",
                                            pad: {
                                                left: 'medium'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    children: "Client is a:"
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                                    label: "SAG Signatory",
                                                    checked: client?.isSagSignatory,
                                                    onChange: (e)=>setClient({
                                                            ...client,
                                                            isSagSignatory: e.target.checked
                                                        }),
                                                    disabled: !client || client.id !== 'NEW'
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                                    label: "JPC Authorizer",
                                                    checked: client?.isJpcAuthorizer,
                                                    onChange: (e)=>setClient({
                                                            ...client,
                                                            isJpcAuthorizer: e.target.checked
                                                        }),
                                                    disabled: !client || client.id !== 'NEW'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    direction: "row",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        id: "product",
                                        label: "Product",
                                        name: "product",
                                        required: true,
                                        val: product,
                                        onChange: (product)=>setProduct(product),
                                        "aria-required": true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    direction: "column",
                                    gap: "small",
                                    width: "medium",
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        id: "budget",
                                        label: "Talent Budget",
                                        name: "budget",
                                        val: budget,
                                        onChange: (budget)=>setBudget(budget),
                                        "aria-required": true,
                                        format: "currency",
                                        currencyDecimals: false
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "50%",
                        children: budget > 1000000 ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8Ih9f.Hint), {
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Heads up! This budget is over $1,000,000, so the Low Budget Waiver will not apply."
                            })
                        }) : null
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gJxCG", function(module, exports) {

$parcel$export(module.exports, "SummaryTab", () => $a98795a20bdb6ff7$export$2b199a0d580bb664);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");

var $hRbKn = parcelRequire("hRbKn");
parcelRequire("iTN0T");
var $6te8u = parcelRequire("6te8u");
const $a98795a20bdb6ff7$export$2b199a0d580bb664 = (props)=>{
    const { name: name, client: client, code: code, product: product, budget: budget, union: union, geography: geography, place: place, exclusivity: exclusivity, media: media, assetCounts: assetCounts, rolePerformers: rolePerformers } = props;
    const checkmark = (label)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
            size: "small",
            children: [
                "(",
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hRbKn.Checkmark), {
                    color: "status-ok",
                    size: "small"
                }),
                label,
                ")"
            ]
        });
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        pad: "medium",
        gap: "medium",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "Below is a summary of everything you've filled in. Please confirm this is how you want to set the project up."
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                gap: "small",
                children: [
                    name && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Name: ",
                            name
                        ]
                    }),
                    code && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Job Code: ",
                            code
                        ]
                    }),
                    client && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Client: ",
                            client.name,
                            " ",
                            client.isJpcAuthorizer && checkmark('JPC Authorizer'),
                            ' ',
                            client.isSagSignatory && checkmark('SAG Signatory')
                        ]
                    }),
                    product && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Product: ",
                            product
                        ]
                    }),
                    !!budget && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "Budget: ",
                            new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'USD'
                            }).format(budget)
                        ]
                    }),
                    union && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "This ",
                            union === 'union' ? 'is a' : 'is not a',
                            " union job."
                        ]
                    }),
                    geography && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "It will be shot ",
                            geography === 'usa' ? 'onshore' : 'offshore',
                            place && ` at ${place.street_address} ${place.city}, ${place.state} ${place.zip}`,
                            "."
                        ]
                    }),
                    exclusivity && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        children: [
                            "The client ",
                            exclusivity === 'yes' ? 'does' : 'does not',
                            " require exclusivity."
                        ]
                    }),
                    !!media?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "The following media and assets will be produced:"
                    }),
                    media?.map((medium)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            gap: "small",
                            pad: {
                                left: 'large'
                            },
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: medium
                                }),
                                assetCounts[medium]?.map((length)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                        children: [
                                            length,
                                            " sec."
                                        ]
                                    }, `${medium}-${length}`))
                            ]
                        }, medium)),
                    rolePerformers?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        children: "The following roles will be cast:"
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        pad: {
                            left: 'large'
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "small",
                                background: "dark-1",
                                pad: "small",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Performer Type"
                                    })
                                ]
                            }),
                            rolePerformers.map((rolePerformer, i)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    gap: "small",
                                    background: i % 2 === 0 ? 'light-1' : 'light-2',
                                    border: "all",
                                    pad: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: (0, $6te8u.formatDefaultName)(rolePerformer)
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: rolePerformer.roleType
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: rolePerformer.performerType
                                        })
                                    ]
                                }, `${rolePerformer.name}-${i}`))
                        ]
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("fWLqP", function(module, exports) {

$parcel$export(module.exports, "ProjectCard", () => $df3da57f4248cff7$export$bacf8f04493bf68c);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $jJ6uA = parcelRequire("jJ6uA");
var $5qhsy = parcelRequire("5qhsy");
var $1h240 = parcelRequire("1h240");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("hcQWc");
var $djcqs = parcelRequire("djcqs");
var $l56av = parcelRequire("l56av");
parcelRequire("ibR9R");
var $hF8pi = parcelRequire("hF8pi");
var $jGT7M = parcelRequire("jGT7M");
var $2Y23d = parcelRequire("2Y23d");
var $7wM4T = parcelRequire("7wM4T");

var $8DltC = parcelRequire("8DltC");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $bsB3E = parcelRequire("bsB3E");

var $4Oriw = parcelRequire("4Oriw");

var $b1rqt = parcelRequire("b1rqt");

var $bgcVc = parcelRequire("bgcVc");

var $1G16z = parcelRequire("1G16z");
const $df3da57f4248cff7$export$bacf8f04493bf68c = (0, $j8yBr.observer)(({ project: project, onClick: onClick })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    // const userStore = useUserStore();
    /** State **/ // const [favs, setFavs] = useState<string[]>([]);
    const [meterLabel, setMeterLabel] = (0, $2NacA.useState)('');
    const [finalEstimate, setFinalEstimate] = (0, $2NacA.useState)(null);
    const [firstSessionDate, setFirstSessionDate] = (0, $2NacA.useState)(null);
    const [roleCount, setRoleCount] = (0, $2NacA.useState)(0);
    const [castCount, setCastCount] = (0, $2NacA.useState)(0);
    const [, setContractSignedCount] = (0, $2NacA.useState)(0);
    const [castMeterLabel, setCastMeterLabel] = (0, $2NacA.useState)('');
    /** Computed **/ const meterValues = [
        {
            value: finalEstimate ? project.talentBudgetInPennies / 100 - finalEstimate.total_plus_fringe : project.talentBudgetInPennies / 100,
            color: 'brand',
            onHover: (over)=>over && finalEstimate ? setMeterLabel(`Remaining\n ${new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(project.talentBudgetInPennies / 100 - finalEstimate.total_plus_fringe || 0)}`) : setMeterLabel('')
        },
        {
            value: finalEstimate?.total || 0,
            onHover: (over)=>over && finalEstimate ? setMeterLabel(`Estimated Cost\n ${new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(finalEstimate.total)}`) : setMeterLabel('')
        },
        {
            value: finalEstimate ? finalEstimate.total_plus_fringe - finalEstimate.total : 0,
            onHover: (over)=>over && finalEstimate ? setMeterLabel(`Estimated Fringe\n ${new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(finalEstimate.total_plus_fringe - finalEstimate.total || 0)}`) : setMeterLabel('')
        }
    ];
    /** Methods **/ const deleteProject = async ()=>{
        if (!project) {
            (0, $bsB3E.toast).error('An internal error has occurred. Please refresh the page and try again.');
            return;
        }
        projectStore.deleteProject(project.id);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        project.estimates.find((estimate)=>{
            if (estimate.status === (0, $djcqs.EstimateStatus).Final) setFinalEstimate(estimate);
        });
        const session = [
            ...project.sessions
        ];
        if (session.length) {
            session.sort((a, b)=>new Date(a.date).getTime() - new Date(b.date).getTime());
            setFirstSessionDate((0, $bgcVc.formatDateOnly)(session[0]?.date) || null);
        }
        setRoleCount(project.roles.length);
        setCastCount(project.contracts.length);
        setContractSignedCount(project.contracts.filter((c)=>c.status === (0, $l56av.PerformerContractStatus).PerformerSigned).length);
    }, [
        project.id,
        projectStore
    ]);
    // useEffect(() => {
    //   if (!userStore.user.favorite_project_ids) return;
    //   setFavs(userStore.user.favorite_project_ids);
    // }, [userStore.user.favorite_project_ids]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7wM4T.TalonCard), {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            margin: {
                left: 'small'
            },
            children: `${project.name} (${project.job_code})`
        }),
        buttons: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                onClick: ()=>deleteProject(),
                name: project.name,
                hoverIndicator: true
            }, "delete")
        ],
        headerChildren: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2Y23d.FavoriteButton), {
            project: project
        }),
        footerBackground: "light-2",
        cardProps: {
            flex: {
                shrink: 1
            }
        },
        onHeaderClick: onClick,
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jJ6uA.CardBody), {
            background: "light-1",
            pad: "medium",
            gap: "medium",
            animation: (0, $1G16z.getAnimProps)(0, 'fadeIn'),
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "medium",
                    justify: "between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "column",
                            align: "start",
                            justify: "between",
                            gap: "small",
                            width: "50%",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    gap: "xxsmall",
                                    fill: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "ADVERTISER"
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                            animation: (0, $1G16z.getAnimProps)(0, 'slideRight')
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "1rem",
                                            weight: 600,
                                            children: project.client?.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    gap: "xxsmall",
                                    fill: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "PRODUCT"
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                            animation: (0, $1G16z.getAnimProps)(50, 'slideRight')
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "1rem",
                                            weight: 600,
                                            children: project.product
                                        })
                                    ]
                                }),
                                !project.is_union && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    gap: "xxsmall",
                                    fill: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "UNION"
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                            animation: (0, $1G16z.getAnimProps)(100, 'slideRight')
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "1rem",
                                            weight: 600,
                                            children: "SAG-AFTRA"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    gap: "xxsmall",
                                    fill: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "SHOOT DATE"
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                            animation: (0, $1G16z.getAnimProps)(150, 'slideRight')
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            height: "1.2rem",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "1rem",
                                                weight: firstSessionDate ? 600 : 300,
                                                children: firstSessionDate || '-'
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            direction: "column",
                            align: "center",
                            width: "50%",
                            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1h240.Stack), {
                                anchor: "center",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5qhsy.Meter), {
                                        type: "circle",
                                        size: "small",
                                        background: {
                                            color: 'white'
                                        },
                                        values: meterValues,
                                        max: project.talentBudgetInPennies / 100 || 0
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                        align: "center",
                                        pad: "xsmall",
                                        gap: "xsmall",
                                        children: [
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "xsmall",
                                                textAlign: "center",
                                                children: (meterLabel || 'Talent Budget').toLocaleUpperCase()
                                            }),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {}),
                                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                size: "1rem",
                                                textAlign: "center",
                                                weight: 600,
                                                children: (0, $b1rqt.shortenCurrency)(project.talentBudgetInPennies / 100 || 0, {
                                                    hideZeroDecimals: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                roleCount && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    direction: "column",
                    gap: "small",
                    justify: "center",
                    align: "center",
                    margin: {
                        top: 'xsmall'
                    },
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $1h240.Stack), {
                        anchor: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                fill: "horizontal",
                                round: "24px",
                                elevation: "xsmall",
                                animation: (0, $1G16z.getAnimProps)(0, 'slideUp', 400),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5qhsy.Meter), {
                                    type: "bar",
                                    round: true,
                                    size: "medium",
                                    values: [
                                        {
                                            value: castCount || 0,
                                            color: 'status-ok',
                                            onHover: (over)=>{
                                                over && castCount ? setCastMeterLabel(`Cast: ${castCount}`) : setCastMeterLabel('');
                                            }
                                        },
                                        // {
                                        //   value: (castCount - contractSignedCount) || 0,
                                        //   onHover: (over) => {
                                        //     over && contractSignedCount ? setCastMeterLabel(`Contract Signed: ${contractSignedCount}`) : setCastMeterLabel('');
                                        //   },
                                        // },
                                        {
                                            value: roleCount - castCount || 0,
                                            color: 'white',
                                            onHover: (over)=>{
                                                over && roleCount !== castCount ? setCastMeterLabel(`To be cast: ${roleCount - castCount}`) : setCastMeterLabel('');
                                            }
                                        }
                                    ],
                                    max: roleCount || 0,
                                    thickness: "26px",
                                    direction: "horizontal"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                background: {
                                    color: 'brand-gradient',
                                    dark: true
                                },
                                style: {
                                    background: 'var(--brand-gradient)'
                                },
                                justify: "start",
                                align: "center",
                                round: (0, $4Oriw.borderRadiusSize),
                                pad: {
                                    horizontal: 'small',
                                    vertical: '0.6rem'
                                },
                                elevation: "small",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: castMeterLabel || `${roleCount} Roles`
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});

});
parcelRegister("5qhsy", function(module, exports) {

$parcel$export(module.exports, "Meter", () => $3f2cec8ee27a222d$export$62e3ae2a4090b879);

var $2NacA = parcelRequire("2NacA");

var $jmqAn = parcelRequire("jmqAn");

var $47rt1 = parcelRequire("47rt1");

var $aI4cS = parcelRequire("aI4cS");

var $eL6w3 = parcelRequire("eL6w3");

var $2M0UK = parcelRequire("2M0UK");
var $3f2cec8ee27a222d$var$_excluded = [
    "aria-label",
    "background",
    "color",
    "direction",
    "max",
    "messages",
    "size",
    "thickness",
    "type",
    "reverse",
    "value",
    "values"
];
function $3f2cec8ee27a222d$var$_extends() {
    return $3f2cec8ee27a222d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3f2cec8ee27a222d$var$_extends.apply(null, arguments);
}
function $3f2cec8ee27a222d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3f2cec8ee27a222d$export$62e3ae2a4090b879 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(_ref, ref) {
    var _theme$meter, _messages$meter;
    var ariaLabel = _ref['aria-label'], backgroundProp = _ref.background, color = _ref.color, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction, maxProp = _ref.max, messages = _ref.messages, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, _ref$thickness = _ref.thickness, thickness = _ref$thickness === void 0 ? 'medium' : _ref$thickness, _ref$type = _ref.type, type = _ref$type === void 0 ? 'bar' : _ref$type, reverseProp = _ref.reverse, value = _ref.value, valuesProp = _ref.values, rest = $3f2cec8ee27a222d$var$_objectWithoutPropertiesLoose(_ref, $3f2cec8ee27a222d$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme;
    var _useContext = (0, $2NacA.useContext)((0, $2M0UK.MessageContext)), format = _useContext.format;
    var background = backgroundProp || ((_theme$meter = theme.meter) == null ? void 0 : _theme$meter.background);
    // normalize values to an array of objects
    var values = (0, $2NacA.useMemo)(function() {
        if (valuesProp) return valuesProp;
        if (value) return [
            {
                color: color,
                value: value
            }
        ];
        return [];
    }, [
        color,
        value,
        valuesProp
    ]);
    var reverse = direction === 'horizontal' && (theme.dir === 'rtl' || reverseProp) && !(theme.dir === 'rtl' && reverseProp);
    var max = (0, $2NacA.useMemo)(function() {
        var maxValue = 100;
        if ((values == null ? void 0 : values.length) > 1) maxValue = values.reduce(function(total, currentValue) {
            return total + currentValue.value;
        }, 0);
        return maxProp || maxValue || 100;
    }, [
        maxProp,
        values
    ]);
    var messageId = (values == null ? void 0 : values.length) === 1 ? 'singular' : 'plural';
    var meterType = type || 'bar';
    var meterAriaLabel = ariaLabel || format({
        id: "meter." + meterType + "." + messageId,
        messages: messages == null || (_messages$meter = messages.meter) == null ? void 0 : _messages$meter[meterType],
        values: {
            meterValue: value || values.map(function(item) {
                var _item$value;
                return (_item$value = item.value) != null ? _item$value : 0;
            }).join(', ') || 0,
            type: type,
            max: max
        }
    });
    var content;
    if (type === 'bar') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jmqAn.Bar), $3f2cec8ee27a222d$var$_extends({
        ref: ref,
        "aria-label": meterAriaLabel,
        max: max,
        values: values,
        size: size,
        thickness: thickness,
        background: background,
        direction: direction,
        reverse: reverse
    }, rest));
    else if (type === 'circle' || type === 'pie' || type === 'semicircle') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $47rt1.Circle), $3f2cec8ee27a222d$var$_extends({
        "aria-label": meterAriaLabel,
        ref: ref,
        max: max,
        values: values,
        size: size,
        thickness: thickness,
        type: type,
        background: background,
        reverse: reverse
    }, rest));
    return content;
});
$3f2cec8ee27a222d$export$62e3ae2a4090b879.displayName = 'Meter';
$3f2cec8ee27a222d$export$62e3ae2a4090b879.prototype = (0, $aI4cS.MeterPropTypes);

});
parcelRegister("jmqAn", function(module, exports) {

$parcel$export(module.exports, "Bar", () => $e184b1c3a8ff080c$export$bbc6c6369b38e3d1);

var $2NacA = parcelRequire("2NacA");

var $fzxBh = parcelRequire("fzxBh");

var $1Hi05 = parcelRequire("1Hi05");

var $58O53 = parcelRequire("58O53");

var $eL6w3 = parcelRequire("eL6w3");
var $e184b1c3a8ff080c$var$_excluded = [
    "background",
    "max",
    "round",
    "size",
    "thickness",
    "direction",
    "values",
    "reverse"
], $e184b1c3a8ff080c$var$_excluded2 = [
    "color",
    "highlight",
    "label",
    "onHover",
    "value"
];
function $e184b1c3a8ff080c$var$_extends() {
    return $e184b1c3a8ff080c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e184b1c3a8ff080c$var$_extends.apply(null, arguments);
}
function $e184b1c3a8ff080c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e184b1c3a8ff080c$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var _theme$meter$gap, _theme$meter;
    var _props$background = props.background, background = _props$background === void 0 ? 'light-1' : _props$background, max = props.max, round = props.round, size = props.size, thicknessProp = props.thickness, direction = props.direction, values = props.values, reverse = props.reverse, rest = $e184b1c3a8ff080c$var$_objectWithoutPropertiesLoose(props, $e184b1c3a8ff080c$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var length = size === 'full' ? 288 : (0, $fzxBh.parseMetricToNum)(theme.global.size[size] || size);
    var thickness = (0, $fzxBh.parseMetricToNum)(theme.global.edgeSize[thicknessProp] || thicknessProp);
    var gapTheme = (_theme$meter$gap = (_theme$meter = theme.meter) == null ? void 0 : _theme$meter.gap) != null ? _theme$meter$gap : 0;
    var gap = (0, $fzxBh.parseMetricToNum)(theme.global.edgeSize[gapTheme] || gapTheme);
    // account for the round cap, if any
    var capRadius = round ? thickness / 2 : 0;
    var mid = thickness / 2;
    var someHighlight = (values || []).some(function(v) {
        return v.highlight;
    });
    var start = direction === 'horizontal' ? capRadius : length - capRadius;
    // Available space for the bar is the length of the meter minus an end cap
    // on each end, minus the gap between bars.
    var lengthAvailable = length - 2 * capRadius - gap * (values.length - 1);
    var paths = (values || []).reduce(function(acc, valueArg, index) {
        if (valueArg.value > 0) {
            var color = valueArg.color, highlight = valueArg.highlight, label = valueArg.label, onHover = valueArg.onHover, value = valueArg.value, pathRest = $e184b1c3a8ff080c$var$_objectWithoutPropertiesLoose(valueArg, $e184b1c3a8ff080c$var$_excluded2);
            var key = "p-" + index;
            var delta = value * lengthAvailable / max;
            // add a little bit extra to start to allow for larger rounded inset cap
            // The extra needed can be calculated by the Pythagorean theorem
            var extraGap = round && index !== 0 ? Math.sqrt(Math.pow(thickness / 2 + gap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
            var initialStart = direction === 'horizontal' ? start + extraGap : start - extraGap;
            // define the x,y points for the corners of the bar.
            var points = direction === 'horizontal' ? [
                initialStart + "," + thickness,
                initialStart + ",0",
                start + delta + ",0",
                start + delta + "," + thickness
            ] : [
                thickness + "," + initialStart,
                "0," + initialStart,
                "0," + (start - delta),
                thickness + "," + (start - delta)
            ];
            // if rounded, the starting cap is an arc. All but the first bar
            // will have a gap and a slightly larger radius
            var startRadius = index === 0 ? capRadius : capRadius + gap / 2;
            var startCap = round ? "A " + startRadius + "," + startRadius + " 0 0 " + (index === 0 ? 1 : 0) + " " + points[1] : "L " + points[1];
            var endCap = round ? "A " + capRadius + "," + capRadius + " 0 0 1 " + points[3] : "L " + points[3];
            var d = "M " + points[0] + " " + startCap + " L " + points[2] + " " + endCap + " Z";
            var colorName = color || (0, $58O53.defaultColor)(index, theme, values ? values.length : 0);
            var hoverProps;
            if (onHover) hoverProps = {
                onMouseOver: function onMouseOver() {
                    return onHover(true);
                },
                onMouseLeave: function onMouseLeave() {
                    return onHover(false);
                }
            };
            var fill = (0, $58O53.fillProps)(someHighlight && !highlight ? background : colorName, theme);
            acc.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $e184b1c3a8ff080c$var$_extends({
                key: key,
                d: d
            }, fill, {
                strokeWidth: 0,
                stroke: "none"
            }, hoverProps, pathRest)));
            if (direction === 'horizontal') start += delta + gap;
            else start -= delta + gap;
        }
        return acc;
    }, []).reverse(); // reverse so the caps look right
    var width;
    if (direction === 'horizontal') width = size === 'full' ? '100%' : length;
    else width = size === 'full' ? '100%' : thickness;
    var backgroundPath = direction === 'horizontal' ? "M " + capRadius + "," + mid + " L " + (length - capRadius) + "," + mid : "M " + mid + "," + capRadius + " L " + mid + "," + (length - capRadius);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1Hi05.StyledMeter), $e184b1c3a8ff080c$var$_extends({
        ref: ref,
        viewBox: direction === 'horizontal' ? "0 0 " + length + " " + thickness : "0 0 " + thickness + " " + length,
        preserveAspectRatio: "none",
        width: width,
        height: direction === 'horizontal' ? thickness : length,
        round: round ? {
            size: thicknessProp
        } : undefined
    }, passThemeFlag, rest, {
        reverse: reverse
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $e184b1c3a8ff080c$var$_extends({
        d: backgroundPath,
        fill: "none"
    }, (0, $58O53.strokeProps)(background, theme), {
        strokeWidth: thickness,
        strokeLinecap: round ? 'round' : 'square'
    })), paths);
});
$e184b1c3a8ff080c$export$bbc6c6369b38e3d1.displayName = 'Bar';

});
parcelRegister("1Hi05", function(module, exports) {

$parcel$export(module.exports, "StyledMeter", () => $13c7c516d5dba721$export$430a924eee89432c);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
// fallback to edgeSize for backwards compatibility
var $13c7c516d5dba721$var$roundStyle = (0, $f5efw.css)([
    "border-radius:",
    ";"
], function(props) {
    return props.theme.global[props.theme.global.radius ? 'radius' : 'edgeSize'][props.round.size];
});
// overflow: hidden is needed for ie11
var $13c7c516d5dba721$export$430a924eee89432c = (0, $f5efw.default).svg.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledMeter",
    componentId: "sc-nsxarx-0"
})([
    "max-width:100%;overflow:hidden;",
    " ",
    " ",
    " path{transition:stroke 0.3s,stroke-width 0.3s;}",
    ";"
], function(props) {
    return props.reverse && (0, $f5efw.css)([
        "transform:scale(-1,1);"
    ]);
}, (0, $2O6LY.genericStyles), function(props) {
    return props.round && $13c7c516d5dba721$var$roundStyle;
}, function(props) {
    return props.theme.meter && props.theme.meter.extend;
});

});

parcelRegister("58O53", function(module, exports) {

$parcel$export(module.exports, "strokeProps", () => $3be48c0f943dba01$export$c6dfdb238d76e427);
$parcel$export(module.exports, "fillProps", () => $3be48c0f943dba01$export$4ccf064591ccdacd);
$parcel$export(module.exports, "defaultColor", () => $3be48c0f943dba01$export$f705f0fde43a55a);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $d2fh4 = parcelRequire("d2fh4");
var $3be48c0f943dba01$export$c6dfdb238d76e427 = function strokeProps(color, theme) {
    var result = {};
    if (color) {
        if (typeof color === 'object') {
            result.stroke = (0, $d2fh4.normalizeColor)(color.color, theme);
            if (color.opacity) result.strokeOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity] || color.opacity);
        } else result.stroke = (0, $d2fh4.normalizeColor)(color, theme);
    }
    return result;
};
var $3be48c0f943dba01$export$4ccf064591ccdacd = function fillProps(color, theme) {
    var result = {};
    if (color) {
        if (typeof color === 'object') {
            result.fill = (0, $d2fh4.normalizeColor)(color.color, theme);
            if (color.opacity) result.fillOpacity = "" + (color.opacity === true ? theme.global.opacity.medium : theme.global.opacity[color.opacity] || color.opacity);
        } else result.fill = (0, $d2fh4.normalizeColor)(color, theme);
    }
    return result;
};
var $3be48c0f943dba01$var$neutralExp = /^neutral-\d+/;
var $3be48c0f943dba01$export$f705f0fde43a55a = function defaultColor(index, theme, valuesLength) {
    if (index === valuesLength - 1 && theme.meter.color) return theme.meter.color;
    // We want the last value to have the first color
    var colorIndex = valuesLength - index - 1;
    if (theme.meter && theme.meter.colors) {
        var _colors = theme.meter.colors[theme.dark ? 'dark' : 'light'] || theme.meter.colors;
        return _colors[colorIndex % _colors.length];
    }
    var colors = Object.keys(theme.global.colors).filter(function(n) {
        return n.match(/^graph-[0-9]$/);
    });
    if (colors.length > 0) return colors[colorIndex % colors.length];
    // Deprecate using "neutral-*" color names. Remove eventually.
    var neutralColors = Object.keys(theme.global.colors).filter(function(k) {
        return $3be48c0f943dba01$var$neutralExp.test(k);
    });
    return neutralColors[colorIndex % neutralColors.length];
};

});


parcelRegister("47rt1", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $2ffd1f459b0b3803$export$c89a927ffc67e6fa);

var $2NacA = parcelRequire("2NacA");

var $1I60t = parcelRequire("1I60t");
var $fzxBh = parcelRequire("fzxBh");

var $1Hi05 = parcelRequire("1Hi05");

var $58O53 = parcelRequire("58O53");

var $eL6w3 = parcelRequire("eL6w3");
var $2ffd1f459b0b3803$var$_excluded = [
    "background",
    "max",
    "round",
    "size",
    "thickness",
    "type",
    "values"
], $2ffd1f459b0b3803$var$_excluded2 = [
    "color",
    "highlight",
    "label",
    "onHover",
    "value"
];
function $2ffd1f459b0b3803$var$_extends() {
    return $2ffd1f459b0b3803$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ffd1f459b0b3803$var$_extends.apply(null, arguments);
}
function $2ffd1f459b0b3803$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2ffd1f459b0b3803$export$c89a927ffc67e6fa = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var _theme$meter$gap, _theme$meter;
    var background = props.background, max = props.max, round = props.round, size = props.size, thickness = props.thickness, type = props.type, values = props.values, rest = $2ffd1f459b0b3803$var$_objectWithoutPropertiesLoose(props, $2ffd1f459b0b3803$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var width = size === 'full' ? 288 : (0, $fzxBh.parseMetricToNum)(theme.global.size[size] || size);
    var strokeWidth = type === 'pie' ? width / 2 : Math.min(width / 2 - 8, (0, $fzxBh.parseMetricToNum)(theme.global.edgeSize[thickness] || thickness));
    var centerX = width / 2;
    var centerY = width / 2;
    var radius = width / 2 - strokeWidth / 2;
    // truncate to avoid floating point arithmetic errors
    // see: https://github.com/grommet/grommet/issues/6190
    // Choose a scale factor at least 3 orders of magnitude above max
    var scalePower = Math.max(5, Math.ceil(Math.log10(max)) + 3);
    var scale = Math.pow(10, scalePower);
    var anglePer = Math.floor((type === 'semicircle' ? 180 : 360) / max * scale) / scale;
    var someHighlight = (values || []).some(function(v) {
        return v.highlight;
    });
    var gapTheme = (_theme$meter$gap = (_theme$meter = theme.meter) == null ? void 0 : _theme$meter.gap) != null ? _theme$meter$gap : '0';
    var gap = (0, $fzxBh.parseMetricToNum)(theme.global.edgeSize[gapTheme] || gapTheme);
    var isSemi = type === 'semicircle';
    var isFull = values.reduce(function(total, currentValue) {
        return total + currentValue.value;
    }, 0) >= max;
    var startValue = 0;
    var startAngle = isSemi ? 270 : 0;
    var paths = [];
    (values || []).filter(function(v) {
        return v.value > 0;
    }).forEach(function(valueArg, index, _ref) {
        var length = _ref.length;
        var color = valueArg.color, highlight = valueArg.highlight, label = valueArg.label, onHover = valueArg.onHover, value = valueArg.value, pathRest = $2ffd1f459b0b3803$var$_objectWithoutPropertiesLoose(valueArg, $2ffd1f459b0b3803$var$_excluded2);
        var key = "p-" + index;
        var colorName = color || (0, $58O53.defaultColor)(index, theme, values ? values.length : 0);
        var endAngle;
        if (startValue + value >= max) endAngle = isSemi ? 90 : 360;
        else endAngle = (0, $1I60t.translateEndAngle)(startAngle, anglePer, value);
        var hoverProps;
        if (onHover) hoverProps = {
            onMouseOver: function onMouseOver() {
                return onHover(true);
            },
            onMouseLeave: function onMouseLeave() {
                return onHover(false);
            }
        };
        var stroke = (0, $58O53.strokeProps)(someHighlight && !highlight ? background : colorName, theme);
        var fill = (0, $58O53.fillProps)(someHighlight && !highlight ? background : colorName, theme);
        var outerRadius = width / 2;
        var innerRadius = type === 'pie' ? 0 : width / 2 - strokeWidth;
        // We want a start gap if there's another segment before this one.
        // A circle's last segment can bump against the first segment if at max.
        var startGap = index === 0 && (isSemi || length === 1 || length > 1 && !isFull) ? 0 : gap / 2;
        // Similarly, we only need an end gap if there's a segment after this one.
        var endGap = index === length - 1 && (isSemi || length === 1) ? 0 : -gap / 2;
        var startRound = index === 0 && isSemi ? false : round;
        var d = (0, $1I60t.wedgeCommands)(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, round, index === 0 ? 1 : 0);
        paths.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $2ffd1f459b0b3803$var$_extends({
            key: key,
            d: d
        }, fill, stroke, {
            strokeWidth: 0,
            strokeLinecap: "butt"
        }, hoverProps, pathRest)));
        startValue += value;
        startAngle = endAngle;
    });
    var track;
    if (type === 'semicircle') {
        var d1 = (0, $1I60t.arcCommands)(centerX, centerY, radius, 270, 90);
        track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", $2ffd1f459b0b3803$var$_extends({
            d: d1,
            strokeWidth: strokeWidth,
            fill: "none"
        }, (0, $58O53.strokeProps)(background, theme), {
            strokeLinecap: round ? 'round' : 'square'
        }));
    } else track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("circle", $2ffd1f459b0b3803$var$_extends({
        cx: centerX,
        cy: centerY,
        r: radius
    }, (0, $58O53.strokeProps)(background, theme), {
        strokeWidth: strokeWidth,
        strokeLinecap: round ? 'round' : 'square',
        fill: "none"
    }));
    var viewBoxHeight = type === 'semicircle' ? width / 2 : width;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $1Hi05.StyledMeter), $2ffd1f459b0b3803$var$_extends({
        ref: ref,
        viewBox: "0 0 " + width + " " + viewBoxHeight,
        width: size === 'full' ? '100%' : width,
        height: size === 'full' ? '100%' : viewBoxHeight
    }, passThemeFlag, rest), track, paths);
});
$2ffd1f459b0b3803$export$c89a927ffc67e6fa.displayName = 'Circle';

});
parcelRegister("1I60t", function(module, exports) {

$parcel$export(module.exports, "arcCommands", () => $13ee8f48d239a145$export$42585d8f3d81ad44);
$parcel$export(module.exports, "wedgeCommands", () => $13ee8f48d239a145$export$9928994028c6cb9b);
$parcel$export(module.exports, "translateEndAngle", () => $13ee8f48d239a145$export$bd97579b57102dc8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0
var $13ee8f48d239a145$var$POST_DECIMAL_DIGITS = 10;
var $13ee8f48d239a145$export$4738d597a47e577d = 24;
var $13ee8f48d239a145$export$5c9a959bb3fc7749 = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
};
var $13ee8f48d239a145$var$intersection = function intersection(line1Point1, line1Point2, line2Point1, line2Point2) {
    var x1 = line1Point1.x, y1 = line1Point1.y;
    var x2 = line1Point2.x, y2 = line1Point2.y;
    var x3 = line2Point1.x, y3 = line2Point1.y;
    var x4 = line2Point2.x, y4 = line2Point2.y;
    // Calculate the denominator
    var denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    // Check if lines are parallel (denominator is 0)
    if (Math.abs(denominator) < 1e-10) return null; // Lines are parallel or coincident
    // Calculate the intersection point
    var t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denominator;
    var u = -((x1 - x2) * (y1 - y3) - (y1 - y2) * (x1 - x3)) / denominator;
    // Calculate intersection coordinates
    var intersectionX = x1 + t * (x2 - x1);
    var intersectionY = y1 + t * (y2 - y1);
    return {
        x: intersectionX,
        y: intersectionY,
        // Optional: check if intersection is within line segments
        withinSegment1: t >= 0 && t <= 1,
        withinSegment2: u >= 0 && u <= 1
    };
};
var $13ee8f48d239a145$export$3bbb56266409c57 = function lineCommands(centerX, centerY, radius, angle) {
    var start = $13ee8f48d239a145$export$5c9a959bb3fc7749(centerX, centerY, radius, angle);
    var d = [
        'M',
        centerX.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        centerY.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        'L',
        start.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $13ee8f48d239a145$export$42585d8f3d81ad44 = function arcCommands(centerX, centerY, radius, startAngle, endAngle) {
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 360) normalizedEndAngle = startAngle + 359.99;
    var start = $13ee8f48d239a145$export$5c9a959bb3fc7749(centerX, centerY, radius, normalizedEndAngle);
    var end = $13ee8f48d239a145$export$5c9a959bb3fc7749(centerX, centerY, radius, startAngle);
    var arcSweep = normalizedEndAngle - startAngle <= 180 ? '0' : '1';
    var d = [
        'M',
        start.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        start.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        'A',
        radius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        radius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        0,
        end.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        end.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ].join(' ');
    return d;
};
var $13ee8f48d239a145$export$11a7b5abbf8340a = function calcAngle(radius, angle, midAngle, gap) {
    if (gap === 0) return angle;
    var gapAngleRadians = Math.asin(Math.abs(gap) / radius);
    var gapAngle = gapAngleRadians * 180 / Math.PI;
    return gap > 0 ? Math.min(angle + gapAngle, midAngle) : Math.max(angle - gapAngle, midAngle);
};
var $13ee8f48d239a145$var$gapPoints = function gapPoints(centerX, centerY, outerRadius, innerRadius, angle, midAngle, gap) {
    var outerAngle = $13ee8f48d239a145$export$11a7b5abbf8340a(outerRadius, angle, midAngle, gap);
    var outer = $13ee8f48d239a145$export$5c9a959bb3fc7749(centerX, centerY, outerRadius, outerAngle);
    var inner;
    if (innerRadius > 0) {
        var innerAngle = $13ee8f48d239a145$export$11a7b5abbf8340a(innerRadius, angle, midAngle, gap);
        inner = $13ee8f48d239a145$export$5c9a959bb3fc7749(centerX, centerY, innerRadius, innerAngle);
    } else inner = $13ee8f48d239a145$export$5c9a959bb3fc7749(centerX, centerY, Math.abs(gap), gap < 0 ? angle - 90 : angle + 90);
    return {
        outer: outer,
        inner: inner
    };
};
var $13ee8f48d239a145$export$9928994028c6cb9b = function wedgeCommands(centerX, centerY, outerRadius, innerRadius, startAngle, endAngle, startGap, endGap, startRound, endRound, startRoundDirection) {
    if (startRoundDirection === void 0) startRoundDirection = 0;
    // handle that we can't draw a complete circle
    var normalizedEndAngle = endAngle;
    /* 
   added endAngle - startAngle >= 360 
   for SemiCircle the endAngle will never be greater then startAngle 
   since it starts with a startAngle of 270.
  */ if (endAngle > startAngle && endAngle - startAngle >= 359.99) normalizedEndAngle = startAngle + 359.99;
    // if we're rounded we need to ajust the start points to
    // account for a bigger cap radius
    // add a little bit extra to start to allow for larger rounded inset cap
    // The extra needed can be calculated by the Pythagorean theorem
    var thickness = outerRadius - innerRadius;
    var extraGap = startRound ? Math.sqrt(Math.pow(thickness / 2 + startGap / 4, 2) - Math.pow(thickness / 2, 2)) : 0;
    // define the angle at the center of the wedge. We can't let the gap
    // go past this angle.
    // calculate the angle span between start and end
    var angleSpan = (endAngle < startAngle ? endAngle + 360 : endAngle) - startAngle;
    var midAngle = startAngle + angleSpan / 2;
    var start = $13ee8f48d239a145$var$gapPoints(centerX, centerY, outerRadius, innerRadius, startAngle, midAngle < startAngle ? midAngle + 360 : midAngle, startGap + extraGap, startRound);
    var end = $13ee8f48d239a145$var$gapPoints(centerX, centerY, outerRadius, innerRadius, normalizedEndAngle, midAngle > endAngle ? midAngle - 360 : midAngle, endGap, endRound);
    var largeAngle = normalizedEndAngle - startAngle > 180;
    var arcSweep = largeAngle ? '1' : '0';
    var innerCapRadius = innerRadius;
    var innerArcSweep = arcSweep;
    var middle;
    if (innerRadius <= 0) {
        // we're doing a pie wedge
        innerArcSweep = arcSweep === '0' ? '1' : '0';
        if (largeAngle) // for a large pie wedge it has an inner corner rather
        // than a point. We need to round the inner corner
        innerCapRadius = startGap || endGap || 0;
        else // for a small pie wedge we'll make a point in the center
        middle = $13ee8f48d239a145$var$intersection(start.outer, start.inner, end.outer, end.inner);
    }
    var capRadius = (outerRadius - innerRadius) / 2;
    var startCapRadius = capRadius + (startRoundDirection === 0 ? startGap / 2 : 0);
    var startPoint = middle || start.inner;
    var endPoint = middle || end.inner;
    var startCap = startRound ? [
        'A',
        startCapRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        startCapRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        0,
        0,
        startRoundDirection,
        start.outer.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        start.outer.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        start.outer.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ];
    var endCap = endRound ? [
        'A',
        capRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        capRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        0,
        0,
        1,
        endPoint.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ] : [
        'L',
        endPoint.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        endPoint.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ];
    var d = [
        'M',
        startPoint.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        startPoint.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ].concat(startCap, [
        'A',
        outerRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        outerRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        0,
        arcSweep,
        1,
        end.outer.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS),
        end.outer.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS)
    ], endCap);
    if (innerRadius > 0 || largeAngle) // for a donut or a large pie wedge, draw the inner arc
    d.push('A', innerCapRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS), innerCapRadius.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS), 0, innerArcSweep, 0, start.inner.x.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS), start.inner.y.toFixed($13ee8f48d239a145$var$POST_DECIMAL_DIGITS), 'Z' // close the path
    );
    return d.join(' ');
};
var $13ee8f48d239a145$export$bd97579b57102dc8 = function translateEndAngle(startAngle, anglePer, value) {
    return Math.max(0, startAngle + anglePer * value) % 360;
};

});


parcelRegister("aI4cS", function(module, exports) {

$parcel$export(module.exports, "MeterPropTypes", () => $7cc146d18739f2cb$export$1d51da36beba5791);


function $7cc146d18739f2cb$var$_extends() {
    return $7cc146d18739f2cb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7cc146d18739f2cb$var$_extends.apply(null, arguments);
}
var $7cc146d18739f2cb$var$PropType = {};
var $7cc146d18739f2cb$export$1d51da36beba5791 = $7cc146d18739f2cb$var$PropType;

});



parcelRegister("96l5t", function(module, exports) {
parcelRequire("hCRNV");

});
parcelRegister("hCRNV", function(module, exports) {

$parcel$export(module.exports, "QuickEstimatorPanel", () => $4968f72aa6d49b70$export$61752a7ecd583229);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $2bcjL = parcelRequire("2bcjL");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $5cDu3 = parcelRequire("5cDu3");

var $bIzid = parcelRequire("bIzid");
const $4968f72aa6d49b70$export$61752a7ecd583229 = (0, $j8yBr.observer)(()=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [isLoading, setIsLoading] = (0, $2NacA.useState)(false);
    const [performerCounts, setPerformerCounts] = (0, $2NacA.useState)({
        [(0, $8kKyn.RolePerformerType).OnCameraPrincipal]: 0,
        [(0, $8kKyn.RolePerformerType).OffCameraPrincipal]: 0,
        [(0, $8kKyn.RolePerformerType).Extra]: 0,
        [(0, $lUAc5.RoleType).HandModel]: 0
    });
    const [workHours, setWorkHours] = (0, $2NacA.useState)(8);
    const [hasPriorDayFitting, setHasPriorDayFitting] = (0, $2NacA.useState)(false);
    /** Computed **/ const offCameraOnly = !performerCounts[(0, $8kKyn.RolePerformerType).OnCameraPrincipal] && !performerCounts[(0, $8kKyn.RolePerformerType).Extra] && !performerCounts[(0, $lUAc5.RoleType).HandModel] && !!performerCounts[(0, $8kKyn.RolePerformerType).OffCameraPrincipal];
    /** Methods **/ /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const getQuickEstimate = async ()=>{
            setIsLoading(true);
            await estimateStore.quickEstimate(performerCounts, workHours, hasPriorDayFitting, false);
            setIsLoading(false);
        };
        getQuickEstimate();
    }, [
        performerCounts,
        workHours,
        hasPriorDayFitting
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        margin: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2bcjL.CardHeader), {
                pad: "small",
                background: "dark-1",
                children: "Quick Estimator"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    align: "center",
                    justify: "start",
                    gap: "large",
                    pad: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            gap: "small",
                            children: Object.keys(performerCounts).map((typeName)=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    gap: "xsmall",
                                    align: "center",
                                    justify: "start",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            flex: "grow",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                                val: performerCounts[typeName],
                                                onChange: (count)=>setPerformerCounts({
                                                        ...performerCounts,
                                                        [typeName]: (0, $9Rhqc.toNumber)(count)
                                                    }),
                                                inputType: "number",
                                                minValue: 0,
                                                width: "5rem"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            fill: "horizontal",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                                children: [
                                                    typeName,
                                                    "s"
                                                ]
                                            })
                                        })
                                    ]
                                }, typeName))
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            gap: "medium",
                            justify: "center",
                            margin: {
                                horizontal: 'small'
                            },
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                    direction: "row",
                                    gap: "small",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            direction: "row",
                                            gap: "xsmall",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                                    val: workHours,
                                                    onChange: (workHours)=>setWorkHours((0, $9Rhqc.toNumber)(workHours)),
                                                    inputType: "number",
                                                    placeholder: "Work Hours",
                                                    width: "xsmall",
                                                    minValue: 0
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                    fill: "horizontal",
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                        children: "Work Hours"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                            gap: "small",
                                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                                direction: "row",
                                                gap: "xsmall",
                                                onClick: ()=>!offCameraOnly && setHasPriorDayFitting(!hasPriorDayFitting),
                                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                                    label: "Prior Day Fitting",
                                                    placeholder: "Prior Day Fitting",
                                                    checked: hasPriorDayFitting,
                                                    disabled: offCameraOnly
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    align: "center",
                                    justify: "center",
                                    fill: true,
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        justify: "center",
                                        align: "center",
                                        gap: "xsmall",
                                        background: "light-2",
                                        pad: "small",
                                        round: "small",
                                        height: "xsmall",
                                        fill: "horizontal",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                            align: "center",
                                            gap: "xsmall",
                                            children: [
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                    size: "small",
                                                    children: "Grand Total"
                                                }),
                                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5cDu3.Blink), {
                                                    enabled: isLoading,
                                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                        size: "xlarge",
                                                        weight: "bold",
                                                        children: (0, $b1rqt.USD)(estimateStore.quickEstimateTotalPlusFringe)
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});

});


parcelRegister("6q7qM", function(module, exports) {

$parcel$export(module.exports, "SelectableText", () => $148b6b8c2f3c38aa$export$7e34b51a48243725);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $9Rhqc = parcelRequire("9Rhqc");

var $2NacA = parcelRequire("2NacA");
parcelRequire("ibR9R");
var $d2VmQ = parcelRequire("d2VmQ");
const $148b6b8c2f3c38aa$export$7e34b51a48243725 = ({ val: val, options: options, onChange: onChange, onBlur: onBlur, onSubmit: onSubmit, id: id, name: name, required: required, width: width, textSize: textSize, textMargin: textMargin, textColor: textColor, shortenTo: shortenTo, placeholder: placeholder, emptySearchMessage: emptySearchMessage, capitalize: capitalize = false })=>{
    const [edit, setEdit] = (0, $2NacA.useState)(false);
    const shortened = shortenTo && val.length > shortenTo ? `${val.slice(0, shortenTo - 1)}...` : val;
    const doChange = (selectedOption)=>{
        setEdit(false);
        onChange && onChange(selectedOption.value);
    };
    const doSubmit = ()=>{
        setEdit(false);
        onSubmit && onSubmit();
    };
    const doClose = ()=>{
        setEdit(false);
    };
    const doBlur = ()=>{
        onBlur && onBlur();
    };
    const takeFocus = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!edit) setEdit(true);
    };
    return edit ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        width: width,
        margin: textMargin,
        alignSelf: "start",
        gap: "xxsmall",
        direction: "row",
        align: "center",
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            border: {
                side: 'bottom',
                color: textColor || 'accent-3'
            },
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                id: id,
                name: name || id,
                value: val,
                onChange: ({ value: value })=>doChange(value),
                open: true,
                color: textColor,
                onClose: doClose,
                onBlur: doBlur,
                onSubmit: doSubmit,
                labelKey: "label",
                valueKey: "value",
                options: options,
                required: required,
                size: textSize,
                emptySearchMessage: emptySearchMessage,
                plain: true
            })
        })
    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        width: width,
        margin: textMargin,
        border: {
            side: 'bottom',
            color: textColor || 'accent-3'
        },
        alignSelf: "start",
        onClick: takeFocus,
        children: shortenTo ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: val
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                style: {
                    cursor: 'text'
                },
                color: textColor,
                children: capitalize ? (0, $9Rhqc.capitalize)(shortened) : shortened
            })
        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            direction: "row",
            height: {
                min: '1.5rem'
            },
            children: val ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                style: {
                    cursor: 'text'
                },
                color: textColor,
                children: capitalize ? (0, $9Rhqc.capitalize)(val) : val
            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                style: {
                    cursor: 'text'
                },
                color: textColor,
                children: /*#__PURE__*/ (0, $6ir3O.jsx)("i", {
                    children: placeholder || 'Choose...'
                })
            })
        })
    });
};

});

parcelRegister("hH2L6", function(module, exports) {
$parcel$export(module.exports, "RoleActivityRow", () => (parcelRequire("9nDY8")).RoleActivityRow);
$parcel$export(module.exports, "SessionActivityRow", () => (parcelRequire("lLmV5")).SessionActivityRow);
$parcel$export(module.exports, "SessionEstimatorHeader", () => (parcelRequire("3bJi5")).SessionEstimatorHeader);
$parcel$export(module.exports, "SessionRow", () => (parcelRequire("kaLe2")).SessionRow);
$parcel$export(module.exports, "SessionsPanel", () => (parcelRequire("cBCf2")).SessionsPanel);
parcelRequire("9nDY8");
parcelRequire("lLmV5");
parcelRequire("3bJi5");
parcelRequire("kaLe2");
parcelRequire("cBCf2");

});
parcelRegister("9nDY8", function(module, exports) {

$parcel$export(module.exports, "RoleActivityRow", () => $d874573e8eb1a412$export$147c009fa5fa9ad7);

var $6ir3O = parcelRequire("6ir3O");

var $fjut3 = parcelRequire("fjut3");
parcelRequire("hcQWc");
var $8kKyn = parcelRequire("8kKyn");
var $lUAc5 = parcelRequire("lUAc5");
var $9C19V = parcelRequire("9C19V");

var $8DltC = parcelRequire("8DltC");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $gpKeH = parcelRequire("gpKeH");
var $5erKi = parcelRequire("5erKi");
var $hgBnK = parcelRequire("hgBnK");
var $kS7Ii = parcelRequire("kS7Ii");

var $kbInV = parcelRequire("kbInV");
var $cNZ2u = parcelRequire("cNZ2u");
var $1QpFO = parcelRequire("1QpFO");
var $4Eh1T = parcelRequire("4Eh1T");
var $1jasL = parcelRequire("1jasL");
var $eJdPk = parcelRequire("eJdPk");
var $2xT0V = parcelRequire("2xT0V");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");
parcelRequire("ibR9R");
var $d2VmQ = parcelRequire("d2VmQ");
const $d874573e8eb1a412$export$147c009fa5fa9ad7 = ({ roleId: roleId, activity: activity, updateSessionActivity: updateSessionActivity })=>{
    const [role, setRole] = (0, $2NacA.useState)(undefined);
    const [propModalRole, setPropModalRole] = (0, $2NacA.useState)(undefined);
    const [costumeModalRole, setCostumeModalRole] = (0, $2NacA.useState)(undefined);
    const [roleActivity, setRoleActivity] = (0, $2NacA.useState)(undefined);
    const [roleActivityCostumes, setRoleActivityCostumes] = (0, $2NacA.useState)([]);
    const [roleActivityProps, setRoleActivityProps] = (0, $2NacA.useState)([]);
    const sessionActivityStore = (0, $8DltC.useSessionActivityStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const roleStore = (0, $8DltC.useRoleStore)();
    const payScalePercent = role?.performer?.contracts[role.performer.contracts.length - 1].compensation[0].percentOfScale;
    const filterCostumesAndProps = ()=>{
        setRoleActivityCostumes(activity.costumes?.filter((c)=>c.owner?.id === roleId) || []);
        setRoleActivityProps(activity.props?.filter((p)=>p.owner?.id === roleId) || []);
    };
    (0, $2NacA.useEffect)(()=>{
        if (!roleId) return;
        const getRole = async ()=>{
            const roleData = await roleStore.getRoleById(roleId);
            roleData && setRole(roleData);
        };
        getRole();
    }, [
        roleId
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (activity.role_activities) {
            const ra = activity.role_activities.find((ra)=>ra.role?.id === roleId);
            ra && setRoleActivity(ra);
        }
    }, [
        activity
    ]);
    (0, $2NacA.useEffect)(()=>{
        filterCostumesAndProps();
    }, [
        activity.costumes,
        activity.props,
        roleId
    ]);
    const upsertRoleActivity = async (update)=>{
        let ra;
        if (roleActivity) ra = await sessionActivityStore.updateRoleActivity({
            ...roleActivity,
            ...update
        });
        else ra = await sessionActivityStore.createRoleActivity({
            ...update,
            session_activity: activity,
            role: role,
            project: projectStore.currentProject
        });
        ra && setRoleActivity(ra);
    };
    const assignReimbursements = async ({ costumes: costumes, props: props })=>{
        console.log('assignReimbursements', activity, costumes, props);
        const otherRoleCostumes = activity.costumes?.filter((a)=>a.owner?.id != roleId);
        const otherRoleProps = activity.props?.filter((a)=>a.owner?.id != roleId);
        updateSessionActivity({
            ...activity,
            costumes: [
                ...otherRoleCostumes || [],
                ...costumes || []
            ],
            props: [
                ...otherRoleProps || [],
                ...props || []
            ]
        });
    };
    return role ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        align: "center",
        justify: "between",
        pad: {
            horizontal: 'small'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: "small",
                children: role.name
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                align: "center",
                gap: "xxsmall",
                justify: "end",
                children: [
                    (payScalePercent ?? 0) > 100 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: `Performer receives ${payScalePercent}% of scale.`
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eJdPk.Tag), {
                            size: "14"
                        })
                    }),
                    role.costumes?.length > 0 && activity.type === (0, $9C19V.SessionActivityType).WardrobeChange && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        onClick: ()=>{
                            setCostumeModalRole(role);
                        },
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2xT0V.UserPolice), {
                            color: roleActivityCostumes?.length ? 'accent-3' : 'light-3'
                        }),
                        secondary: true,
                        size: "small",
                        tip: roleActivityCostumes.length > 0 ? `${roleActivityCostumes.length} Costume(s) Selected for Reimbursement` : 'Select Costume Reimbursements'
                    }),
                    role.props?.length > 0 && (0, $fjut3.WorkActivityTypes).has(activity.type) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        onClick: ()=>{
                            setPropModalRole(role);
                        },
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cNZ2u.Bike), {
                            color: roleActivityProps?.length ? 'accent-3' : 'light-3'
                        }),
                        secondary: true,
                        size: "small",
                        tip: roleActivityProps.length > 0 ? `${roleActivityProps.length} Prop(s) Selected for Reimbursement` : 'Select Prop Reimbursements'
                    }),
                    role.performer_type === (0, $8kKyn.RolePerformerType).OnCameraPrincipal && (0, $fjut3.WorkActivityTypes).has(activity.type) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                        name: "own-stunts",
                        checked: roleActivity ? roleActivity.is_own_stunt_performer : false,
                        onChange: (event)=>upsertRoleActivity({
                                is_own_stunt_performer: event.target.checked
                            }),
                        children: ({ checked: checked })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Will this OCP do his/her own stunts?"
                                }),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1jasL.Run), {
                                    color: checked ? 'accent-3' : 'light-3'
                                })
                            })
                    }),
                    role.type === (0, $lUAc5.RoleType).SpecialtyDancer && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                        name: "hazardous",
                        checked: roleActivity ? roleActivity.is_hazardous_work : false,
                        onChange: (event)=>upsertRoleActivity({
                                is_hazardous_work: event.target.checked
                            }),
                        children: ({ checked: checked })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Will this dancer work in hazardous conditions?"
                                }),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kbInV.Alert), {
                                    color: checked ? 'accent-3' : 'light-3'
                                })
                            })
                    }),
                    role.performer_type === (0, $8kKyn.RolePerformerType).Extra && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                        name: "wet",
                        checked: roleActivity ? roleActivity.is_wet_snow_smoke_dust_work : false,
                        onChange: (event)=>upsertRoleActivity({
                                is_wet_snow_smoke_dust_work: event.target.checked
                            }),
                        children: ({ checked: checked })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Will this extra work in wet, snowy, smokey, or dusty conditions?"
                                }),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4Eh1T.Cloud), {
                                    color: checked ? 'accent-3' : 'light-3'
                                })
                            })
                    })
                ]
            }),
            costumeModalRole && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
                onClickOutside: ()=>setCostumeModalRole(undefined),
                onEsc: ()=>setCostumeModalRole(undefined),
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "column",
                    pad: "small",
                    gap: "small",
                    width: "large",
                    height: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            pad: "small",
                            justify: "between",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                    alignSelf: "center",
                                    children: [
                                        "Select Costumes for ",
                                        costumeModalRole.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                    onClick: ()=>setCostumeModalRole(undefined),
                                    cursor: "pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            pad: "small",
                            direction: "row",
                            gap: "small",
                            justify: "around",
                            align: "center",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hgBnK.SelectMultiple), {
                                width: 'xlarge',
                                options: costumeModalRole.costumes,
                                value: roleActivityCostumes,
                                valueKey: "id",
                                labelKey: "name",
                                placeholder: `Choose ${costumeModalRole.name}'s costumes for this activity...`,
                                size: "medium",
                                onChange: ({ value: value })=>assignReimbursements({
                                        costumes: value
                                    }),
                                showSelectedInline: true,
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                    content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Choose Costumes"
                                    }),
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2xT0V.UserPolice), {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            alignSelf: "center",
                            children: [
                                "Need to add costumes? Add them ",
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Link), {
                                    to: "/project",
                                    children: "on Project Home."
                                })
                            ]
                        })
                    ]
                })
            }),
            propModalRole && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
                onClickOutside: ()=>setPropModalRole(undefined),
                onEsc: ()=>setPropModalRole(undefined),
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "column",
                    pad: "small",
                    gap: "small",
                    width: "large",
                    height: "small",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            pad: "small",
                            justify: "between",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                    alignSelf: "center",
                                    children: [
                                        "Select Props for ",
                                        propModalRole.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {
                                    onClick: ()=>setPropModalRole(undefined),
                                    cursor: "pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            pad: "small",
                            direction: "row",
                            gap: "small",
                            justify: "around",
                            align: "center",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hgBnK.SelectMultiple), {
                                width: 'xlarge',
                                options: propModalRole.props,
                                value: roleActivityProps,
                                valueKey: "id",
                                labelKey: "name",
                                placeholder: `Choose ${propModalRole.name}'s props for this activity...`,
                                size: "medium",
                                onChange: ({ value: value })=>assignReimbursements({
                                        props: value
                                    }),
                                showSelectedInline: true,
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                    content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Choose Props"
                                    }),
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cNZ2u.Bike), {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                            alignSelf: "center",
                            children: [
                                "Need to add props? Add them ",
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Link), {
                                    to: "/project",
                                    children: "on Project Home."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {});
};

});
parcelRegister("4Eh1T", function(module, exports) {

$parcel$export(module.exports, "Cloud", () => $36281b91cc06d4c8$export$e2767e27b246eae1);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $36281b91cc06d4c8$var$_extends() {
    return $36281b91cc06d4c8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $36281b91cc06d4c8$var$_extends.apply(null, arguments);
}
var $36281b91cc06d4c8$export$e2767e27b246eae1 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $36281b91cc06d4c8$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cloud"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 17v1c0 3-2 4-5 4h-2c-3 0-5-1-5-4v-1A5 5 0 0 1 6 7h6M6 7V6c0-3 2-4 5-4h2c3 0 5 1 5 4v1a5 5 0 0 1 0 10h-6"
    }));
});
$36281b91cc06d4c8$export$e2767e27b246eae1.displayName = 'Cloud';

});

parcelRegister("eJdPk", function(module, exports) {

$parcel$export(module.exports, "Tag", () => $ab8ffe60b7ab375a$export$3288d34c523a1192);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $ab8ffe60b7ab375a$var$_extends() {
    return $ab8ffe60b7ab375a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ab8ffe60b7ab375a$var$_extends.apply(null, arguments);
}
var $ab8ffe60b7ab375a$export$3288d34c523a1192 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $ab8ffe60b7ab375a$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Tag"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M11.706 22.294a.992.992 0 0 1-1.41.003l-8.593-8.594a1 1 0 0 1 .003-1.409L13 1h10v10L11.706 22.294zM6 12l6 6M9 9l6 6m2-9a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
    }));
});
$ab8ffe60b7ab375a$export$3288d34c523a1192.displayName = 'Tag';

});


parcelRegister("lLmV5", function(module, exports) {

$parcel$export(module.exports, "SessionActivityRow", () => $2a729b21f33e8ea8$export$4f4b6f15fc299b50);

var $6ir3O = parcelRequire("6ir3O");

var $fjut3 = parcelRequire("fjut3");

var $dErKY = parcelRequire("dErKY");
parcelRequire("hcQWc");
var $9C19V = parcelRequire("9C19V");
var $7dV2j = parcelRequire("7dV2j");

var $8DltC = parcelRequire("8DltC");

var $6xYJg = parcelRequire("6xYJg");

var $b1rqt = parcelRequire("b1rqt");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $fdtj0 = parcelRequire("fdtj0");
var $hgBnK = parcelRequire("hgBnK");
var $kS7Ii = parcelRequire("kS7Ii");

var $3WslH = parcelRequire("3WslH");
var $dmh5A = parcelRequire("dmh5A");
var $eNYAE = parcelRequire("eNYAE");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("hH2L6");
var $9nDY8 = parcelRequire("9nDY8");
parcelRequire("bRT7J");
var $hF8pi = parcelRequire("hF8pi");
var $bIzid = parcelRequire("bIzid");
var $d2VmQ = parcelRequire("d2VmQ");

var $3f1uY = parcelRequire("3f1uY");
const $2a729b21f33e8ea8$export$4f4b6f15fc299b50 = (0, $j8yBr.observer)(({ session: session, rowIndex: rowIndex, activity: activity, roles: roles, locations: locations, deleteSessionActivity: deleteSessionActivity, updateSessionActivity: updateSessionActivity })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [commercialType, setCommercialType] = (0, $2NacA.useState)();
    const [activityTypes, setActivityTypes] = (0, $2NacA.useState)(Object.values((0, $9C19V.SessionActivityType)));
    const [activityRoles, setActivityRoles] = (0, $2NacA.useState)(roles);
    const [, setDisabledTypes] = (0, $2NacA.useState)([]);
    const [, setDisabledRoles] = (0, $2NacA.useState)([]);
    const [showLocation, setShowLocation] = (0, $2NacA.useState)(false);
    const [straightHours, setStraightHours] = (0, $2NacA.useState)(0);
    const [overtimeHours, setOvertimeHours] = (0, $2NacA.useState)(0);
    const [wages, setWages] = (0, $2NacA.useState)(0);
    const [total, setTotal] = (0, $2NacA.useState)(0);
    /** Computed **/ const sessionEstimateItems = estimateStore.getTempSessionEstimateItems(session.id, activity.id);
    const activityName = `${activity.type}`;
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (activity.roles?.length) {
            const disabled = [];
            let hasPrincipal = false;
            let hasExtra = false;
            let hasAFM = false;
            for (const role of activity.roles){
                if ((0, $dErKY.getIsPrincipal)(role.performer_type)) hasPrincipal = true;
                if ((0, $dErKY.getIsExtra)(role.performer_type)) hasExtra = true;
                if ((0, $dErKY.getIsAFMPerformer)(role.performer_type)) hasAFM = true;
            }
            const types = Object.values((0, $9C19V.SessionActivityType)).filter((type)=>{
                if (type === (0, $9C19V.SessionActivityType).CreativeAudition || type === (0, $9C19V.SessionActivityType).CreativeSession) {
                    if (hasExtra || hasAFM) disabled.push(type);
                } else if (type === (0, $9C19V.SessionActivityType).WardrobeChange) {
                    if (!activity.costumes?.length) disabled.push(type);
                } else if (type === (0, $9C19V.SessionActivityType).WorkTimeLateNight) {
                    if (hasPrincipal || hasAFM) disabled.push(type);
                } else if (type.toLocaleLowerCase().includes('meal')) {
                    if (hasExtra || hasAFM) disabled.push(type);
                } else if (type === (0, $9C19V.SessionActivityType).AFMRecordingSession) {
                    if (hasPrincipal || hasExtra) disabled.push(type);
                }
                return disabled[disabled.length - 1] !== type;
            });
            setActivityTypes(types);
            setDisabledTypes(disabled);
        } else {
            setActivityTypes(Object.values((0, $9C19V.SessionActivityType)));
            setDisabledTypes([]);
        }
    }, [
        activity.costumes,
        activity.location,
        activity.roles
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (activity.type) {
            const disabled = [];
            const r = roles.filter((role)=>{
                const isPrincipal = (0, $dErKY.getIsPrincipal)(role.performer_type);
                const isExtra = (0, $dErKY.getIsExtra)(role.performer_type);
                const isAFM = (0, $dErKY.getIsAFMPerformer)(role.performer_type);
                if (activity.type === (0, $9C19V.SessionActivityType).CreativeAudition || activity.type === (0, $9C19V.SessionActivityType).CreativeSession) {
                    if (!isPrincipal) disabled.push(role);
                } else if (activity.type === (0, $9C19V.SessionActivityType).WorkTimeLateNight) {
                    if (!isExtra) disabled.push(role);
                } else if (activity.type?.toLocaleLowerCase().includes('meal')) {
                    if (!isPrincipal) disabled.push(role);
                } else if (activity.type === (0, $9C19V.SessionActivityType).AFMRecordingSession) {
                    if (!isAFM) disabled.push(role);
                }
                return disabled[disabled.length - 1] !== role;
            }).sort((a, b)=>a.name.localeCompare(b.name));
            setActivityRoles(r);
            setDisabledRoles(disabled);
        }
    }, [
        activity.type,
        roles
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (commercialType !== session.commercial_type) {
            // Only an actual change of the session's commercial type can invalidate roles - never the
            // first render, which just records the type (see shouldClearRolesForCommercialType)
            if ((0, $6xYJg.shouldClearRolesForCommercialType)(commercialType, session.commercial_type, activity.roles)) updateSessionActivity({
                roles: []
            });
            setCommercialType(session.commercial_type);
        }
    }, [
        commercialType,
        session.commercial_type,
        activity.roles
    ]);
    (0, $2NacA.useEffect)(()=>{
        let st = 0;
        let ot = 0;
        let wages = 0;
        let total = 0;
        if (sessionEstimateItems) for (const item of sessionEstimateItems){
            if (item.unit_type === (0, $7dV2j.SessionEstimateItemUnitType).Hours) {
                const title = item.title.toLocaleLowerCase();
                if (title.includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).StraightTime].toLocaleLowerCase())) st += item.units ?? 0;
                if (title.includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).TimeAndOneHalf].toLocaleLowerCase()) || title.includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).DoubleTime].toLocaleLowerCase())) ot += item.units ?? 0;
            }
            wages += item.subtotal;
            total += item.subtotal_plus_fringe;
        }
        setStraightHours(st);
        setOvertimeHours(ot);
        setWages(wages);
        setTotal(total);
    }, [
        sessionEstimateItems
    ]);
    /** Render **/ const renderHoursItem = (hours)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
            content: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "xxsmall",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "small",
                        children: [
                            activity.hours ?? 0,
                            " hr",
                            (activity.hours ?? 0) > 1 && 's',
                            " x ",
                            activity.roles?.length ?? 0,
                            " role",
                            (activity.roles?.length ?? 0) > 1 && 's'
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        size: "small",
                        children: "="
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "small",
                        weight: 600,
                        children: [
                            hours,
                            " hr",
                            (hours ?? 0) > 1 && 's'
                        ]
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                size: "xsmall",
                weight: 600,
                children: [
                    hours,
                    " hr",
                    (hours ?? 0) > 1 && 's'
                ]
            })
        });
    return activity ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        gap: "small",
        align: "center",
        pad: "small",
        border: rowIndex > 0 && {
            side: 'top',
            color: 'light-3'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "6%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                    val: activity.hours ?? 0,
                    inputType: "number",
                    placeholder: "Session length...",
                    onChange: (hours)=>{
                        const h = parseFloat(hours);
                        updateSessionActivity({
                            hours: !Number.isNaN(h) ? h : 0
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "16%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hgBnK.SelectMultiple), {
                    options: activityRoles,
                    value: activity.roles?.reduce((acc, curr)=>curr.role_group ? acc : acc.concat(curr), []),
                    valueKey: "id",
                    labelKey: "name",
                    placeholder: "Choose roles...",
                    size: "medium",
                    onChange: ({ value: value })=>updateSessionActivity({
                            roles: value
                        }),
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "Choose Roles"
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {})
                    }),
                    valueLabel: (values)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            justify: "center",
                            fill: "horizontal",
                            children: values && values.length ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                pad: {
                                    vertical: 'xsmall'
                                },
                                children: values.map((role)=>{
                                    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9nDY8.RoleActivityRow), {
                                        roleId: role.id,
                                        activity: activity,
                                        updateSessionActivity: updateSessionActivity
                                    }, role.id);
                                })
                            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                pad: {
                                    horizontal: 'small',
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Select Roles"
                                })
                            })
                        })
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "20%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3f1uY.ActivityTypeSelect), {
                    options: activityTypes,
                    val: activity.type,
                    placeholder: "Choose activity type...",
                    size: "xsmall",
                    onChange: (type)=>updateSessionActivity({
                            type: type
                        }),
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "Choose Activity Type"
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eNYAE.Yoga), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                justify: "start",
                gap: "small",
                align: "center",
                pad: {
                    vertical: 'xsmall'
                },
                width: "16%",
                children: [
                    activity.type && !(0, $fjut3.TravelActivityTypes).has(activity.type) && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        gap: "small",
                        children: [
                            !showLocation && !activity.location && !(0, $fjut3.MealActivityTypes).has(activity.type) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                plain: true,
                                onClick: ()=>setShowLocation(true),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    children: "Add Location"
                                })
                            }),
                            (showLocation || activity.location || (0, $fjut3.MealActivityTypes).has(activity.type)) && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                options: locations,
                                value: activity.location,
                                valueKey: "id",
                                labelKey: "name",
                                placeholder: "Choose location...",
                                size: "xsmall",
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                    content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Choose Location"
                                    }),
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3WslH.MapLocation), {})
                                }),
                                onChange: ({ value: value })=>updateSessionActivity({
                                        location: value
                                    })
                            })
                        ]
                    }),
                    activity.type && (0, $fjut3.TravelActivityTypes).has(activity.type) && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        gap: "small",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                    options: locations.filter((l)=>l.id !== activity.to_location?.id),
                                    value: activity.from_location,
                                    valueKey: "id",
                                    labelKey: "name",
                                    placeholder: "Choose start location...",
                                    size: "xsmall",
                                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: "Choose From Location"
                                        }),
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3WslH.MapLocation), {})
                                    }),
                                    onChange: ({ value: value })=>updateSessionActivity({
                                            from_location: value
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                    options: locations.filter((l)=>l.id !== activity.from_location?.id),
                                    value: activity.to_location,
                                    valueKey: "id",
                                    labelKey: "name",
                                    placeholder: "Choose destination location...",
                                    size: "xsmall",
                                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            children: "Choose To Location"
                                        }),
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3WslH.MapLocation), {})
                                    }),
                                    onChange: ({ value: value })=>updateSessionActivity({
                                            to_location: value
                                        })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                align: "start",
                flex: "grow",
                children: (0, $fjut3.WorkActivityTypes).has(activity.type) && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    children: [
                        !!straightHours && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            justify: "between",
                            fill: "horizontal",
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "STRAIGHT TIME:"
                                }),
                                renderHoursItem(straightHours)
                            ]
                        }),
                        !!overtimeHours && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            justify: "between",
                            fill: "horizontal",
                            gap: "xsmall",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    children: "OVERTIME:"
                                }),
                                renderHoursItem(overtimeHours)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                align: "end",
                width: "10%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    weight: 500,
                    children: (0, $b1rqt.USD)(wages)
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                align: "end",
                width: "10%",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    weight: 500,
                    children: (0, $b1rqt.USD)(total)
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "48px",
                height: "48px",
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                    onClick: ()=>deleteSessionActivity(activity.id),
                    name: activityName
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {});
});

});
parcelRegister("6xYJg", function(module, exports) {

$parcel$export(module.exports, "shouldClearRolesForCommercialType", () => $11eabf9dfea88e0c$export$13df32acc7b1d865);

var $fjut3 = parcelRequire("fjut3");
const $11eabf9dfea88e0c$export$13df32acc7b1d865 = (previousType, nextType, roles)=>{
    if (previousType === undefined || !nextType || previousType === nextType) return false;
    if (!roles?.length) return false;
    const allowed = (0, $fjut3.CommercialPerformerTypes)[nextType] ?? [];
    return roles.some((role)=>!allowed.includes(role.performer_type));
};

});

parcelRegister("3f1uY", function(module, exports) {

$parcel$export(module.exports, "ActivityTypeSelect", () => $0fd39e896de72210$export$9050ca36fafd6cc4);

var $6ir3O = parcelRequire("6ir3O");

var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $eNYAE = parcelRequire("eNYAE");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $d2VmQ = parcelRequire("d2VmQ");
const $0fd39e896de72210$export$9050ca36fafd6cc4 = (0, $j8yBr.observer)(({ options: options, val: val, onChange: onChange, id: id = 'session-activity-type', name: name = 'session-activity-type', ...selectProps })=>{
    /** State **/ const [filteredOptions, setFilteredOptions] = (0, $2NacA.useState)(options);
    /** Methods **/ const filterTypes = (query)=>{
        if (query === '') {
            setFilteredOptions(options);
            return;
        }
        const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        const filtered = options.filter((t)=>exp.test(t));
        setFilteredOptions(filtered);
    };
    (0, $2NacA.useEffect)(()=>{
        setFilteredOptions(options);
    }, [
        options
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
        value: val,
        size: "xsmall",
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "Choose Activity Type"
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eNYAE.Yoga), {})
        }),
        placeholder: "Choose activity type...",
        searchPlaceholder: "Search types...",
        onSearch: (query)=>filterTypes(query),
        onChange: ({ value: value })=>onChange(value),
        onBlur: ()=>setFilteredOptions(options),
        ...selectProps,
        id: id,
        name: name,
        options: filteredOptions
    });
});

});


parcelRegister("3bJi5", function(module, exports) {

$parcel$export(module.exports, "SessionEstimatorHeader", () => $f716a216218477e4$export$d14a71051966caaa);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $4zRSZ = parcelRequire("4zRSZ");
var $kS7Ii = parcelRequire("kS7Ii");

var $aFsfQ = parcelRequire("aFsfQ");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $b1rqt = parcelRequire("b1rqt");

var $1G16z = parcelRequire("1G16z");

var $gdNyE = parcelRequire("gdNyE");

var $jGT7M = parcelRequire("jGT7M");

var $lFfFS = parcelRequire("lFfFS");
const $f716a216218477e4$export$d14a71051966caaa = (0, $j8yBr.observer)(({ project: project, onCreate: onCreate, saveStatus: saveStatus, totalWages: totalWages, grandTotal: grandTotal, height: height = '92px' })=>{
    /** Context **/ const screenSize = (0, $2NacA.useContext)((0, $4zRSZ.ResponsiveContext));
    /** Computed **/ const isDesktop = screenSize === 'large';
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        background: "light-3",
        flex: "grow",
        direction: "row",
        align: "center",
        justify: "between",
        height: height,
        gap: "medium",
        style: {
            zIndex: 1
        },
        elevation: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                width: "67%",
                gap: "large",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                margin: {
                                    left: 'medium'
                                },
                                animation: (0, $1G16z.getAnimProps)(0, 'slideUp'),
                                justify: "start",
                                direction: "row",
                                pad: {
                                    right: 'none'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                    truncate: true,
                                    size: "xlarge",
                                    children: [
                                        project.name,
                                        " Sessions"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                height: "2px",
                                animation: {
                                    type: 'slideRight',
                                    size: 'xlarge'
                                }
                            }),
                            saveStatus && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                align: "end",
                                animation: (0, $1G16z.getAnimProps)(0, 'slideDown'),
                                pad: {
                                    right: 'none'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lFfFS.SaveStatusIndicator), {
                                    saveStatus: saveStatus,
                                    boxProps: {
                                        margin: 'none'
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                        onClick: onCreate,
                        style: {
                            fontSize: '0.9rem',
                            fontWeight: 500
                        },
                        label: "New Session",
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aFsfQ.Multimedia), {
                            size: "1.2rem"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        flex: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                width: "32%",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        gap: "xsmall",
                        justify: "end",
                        align: "start",
                        width: "50%",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(100, 'slideUp', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 500,
                                    children: "TOTAL WAGES"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                animation: {
                                    type: 'slideLeft',
                                    size: 'xlarge',
                                    duration: 500
                                }
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(100, 'slideDown', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    truncate: true,
                                    size: "large",
                                    weight: 500,
                                    children: (!isDesktop ? (0, $b1rqt.shortenCurrency) : (0, $b1rqt.USD))(totalWages)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        gap: "xsmall",
                        justify: "end",
                        align: "start",
                        width: "50%",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(0, 'slideUp', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 700,
                                    children: "GRAND TOTAL"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                animation: {
                                    type: 'slideLeft',
                                    size: 'xlarge',
                                    duration: 500
                                }
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(0, 'slideDown', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    truncate: true,
                                    size: "large",
                                    weight: 700,
                                    children: (!isDesktop ? (0, $b1rqt.shortenCurrency) : (0, $b1rqt.USD))(grandTotal)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("kaLe2", function(module, exports) {

$parcel$export(module.exports, "SessionRow", () => $b08cb83b2bc92312$export$578b78148f9cf63b);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $94KEY = parcelRequire("94KEY");
var $fdtj0 = parcelRequire("fdtj0");
var $kqZxg = parcelRequire("kqZxg");
var $kS7Ii = parcelRequire("kS7Ii");

var $eNYAE = parcelRequire("eNYAE");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("hH2L6");
var $lLmV5 = parcelRequire("lLmV5");
parcelRequire("bRT7J");
var $gdNyE = parcelRequire("gdNyE");
var $hF8pi = parcelRequire("hF8pi");
var $d2VmQ = parcelRequire("d2VmQ");

var $fjut3 = parcelRequire("fjut3");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");
var $9C19V = parcelRequire("9C19V");
var $7dV2j = parcelRequire("7dV2j");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $4kZY9 = parcelRequire("4kZY9");

var $4Oriw = parcelRequire("4Oriw");
const $b08cb83b2bc92312$export$578b78148f9cf63b = (0, $j8yBr.observer)(({ sessionId: sessionId, locations: locations, onChange: onChange, onSaveComplete: onSaveComplete, onDelete: onDelete })=>{
    /** Refs **/ /** Context **/ const commercialStore = (0, $8DltC.useCommercialStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const sessionStore = (0, $8DltC.useSessionStore)();
    const estimateStore = (0, $8DltC.useEstimateStore)();
    const roleStore = (0, $8DltC.useRoleStore)();
    const sessionActivityStore = (0, $8DltC.useSessionActivityStore)();
    /** State **/ const [session, setSession] = (0, $2NacA.useState)(undefined);
    const [roles, setRoles] = (0, $2NacA.useState)([]);
    const [commercials, setCommercials] = (0, $2NacA.useState)([]);
    const [straightHours, setStraightHours] = (0, $2NacA.useState)(0);
    const [overtimeHours, setOvertimeHours] = (0, $2NacA.useState)(0);
    /** Computed **/ const tempEstimate = estimateStore.tempEstimate;
    const sessionEstimate = estimateStore.getTempSessionEstimate(session?.id);
    /** Methods **/ const recalculateSessionEstimate = async ()=>{
        if (!session) return;
        const sessionEstimate = tempEstimate?.session_estimates.find((sessionEstimate)=>sessionEstimate.session?.id === session.id);
        if (sessionEstimate) await estimateStore.updateSessionEstimate(sessionEstimate.id, undefined, undefined, undefined, true);
        onSaveComplete?.();
    };
    /**
     * Update Session
     */ const updateSession = async (update)=>{
        if (!session) {
            console.log('no session');
            return;
        }
        onChange?.();
        const updatedSession = await sessionStore.updateSession(session.id, update);
        if (updatedSession) {
            setSession(updatedSession);
            // Refresh the temp estimate
            await recalculateSessionEstimate();
        }
    };
    /**
     * Add Session Activity
     */ const addSessionActivity = async ()=>{
        if (!session) return;
        onChange?.();
        const previousActivity = session.activities[session.activities.length - 1];
        const startTime = (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(previousActivity?.end_time ?? `${session.date}T09:00:00`).toISOString();
        const endTime = previousActivity ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(previousActivity.end_time).add(1, 'hour').toISOString() : new Date(`${session.date}T17:00:00`).toISOString();
        const sessionActivity = await sessionActivityStore.createSessionActivity(session.id, (0, $9C19V.SessionActivityType).WorkTime, startTime, endTime, session.script?.id);
        if (sessionActivity) {
            const activities = [
                ...session.activities,
                sessionActivity
            ];
            const updatedSession = {
                ...session,
                activities: activities
            };
            const sessionEstimates = (await sessionStore.getSession(session.id, 'session_estimates'))?.session_estimates;
            if (sessionEstimates) updatedSession.session_estimates = sessionEstimates;
            setSession(updatedSession);
            // Refresh the temp estimate
            await recalculateSessionEstimate();
        }
    };
    /**
     * Update Session Activity
     */ const updateSessionActivity = async (update)=>{
        if (!session) return;
        onChange?.();
        const sa = await sessionActivityStore.updateSessionActivity(update);
        if (!sa) return;
        const activities = session.activities?.map((a)=>a.id === sa.id ? sa : a);
        const updatedSession = {
            ...session,
            activities: activities
        };
        setSession(updatedSession);
        // Refresh the temp estimate
        await recalculateSessionEstimate();
    };
    /**
     * Delete Session Activity
     */ const deleteSessionActivity = async (activityId)=>{
        if (!session) return;
        onChange?.();
        await sessionActivityStore.deleteSessionActivity(activityId);
        const activities = session?.activities?.filter((a)=>a.id !== activityId);
        const updatedSession = {
            ...session,
            activities: activities
        };
        setSession(updatedSession);
        // Refresh the temp estimate
        await recalculateSessionEstimate();
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const getSession = async ()=>{
            const s = await sessionStore.getSession(sessionId);
            s?.activities?.sort((a, b)=>{
                return (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(a.created_at).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(b.created_at)) ? -1 : 1;
            });
            s && setSession(s);
        };
        getSession();
    }, [
        sessionId
    ]);
    (0, $2NacA.useEffect)(()=>{
        const getDropDownOptions = async ()=>{
            if (!projectStore.currentProject) return;
            if (!session) return;
            const [r, c] = await Promise.all([
                roleStore.getRolesByProjectId(projectStore.currentProject.id),
                commercialStore.listCommercialsByProjectId(projectStore.currentProject.id)
            ]);
            setRoles(r?.filter((role)=>session.commercial_type === (0, $3qs6L.CommercialType).Radio ? (0, $fjut3.RadioTypes).includes(role.type) : session.commercial_type === (0, $3qs6L.CommercialType).TV ? !(0, $fjut3.RadioTypes).includes(role.type) : true) || []);
            setCommercials(c || []);
        };
        getDropDownOptions();
    }, [
        projectStore.currentProject?.id,
        session?.activities
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (sessionEstimate) {
            let st = 0;
            let ot = 0;
            for (const item of sessionEstimate.items)if (item.unit_type === (0, $7dV2j.SessionEstimateItemUnitType).Hours) {
                const title = item.title.toLocaleLowerCase();
                if (title.includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).StraightTime].toLocaleLowerCase())) st += item.units ?? 0;
                else if (title.includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).TimeAndOneHalf].toLocaleLowerCase()) || title.includes((0, $fjut3.sessionEstimateItemTitles)[(0, $fjut3.WorkTimeType).DoubleTime].toLocaleLowerCase())) ot += item.units ?? 0;
            }
            setStraightHours(st);
            setOvertimeHours(ot);
        }
    }, [
        sessionEstimate
    ]);
    /** Render **/ const HoursDisplay = ({ hours: hours })=>/*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
            size: "small",
            weight: 600,
            color: "accent-1",
            children: [
                hours,
                " hr",
                (hours ?? 0) > 1 && 's'
            ]
        });
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        round: (0, $4Oriw.borderRadiusSize),
        flex: "grow",
        elevation: "small",
        background: "light-1",
        animation: {
            type: 'fadeIn',
            duration: 500
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)',
                    zIndex: 1
                },
                height: {
                    max: '80px',
                    min: '80px'
                },
                round: {
                    corner: 'top',
                    size: (0, $4Oriw.borderRadiusSize)
                },
                pad: {
                    horizontal: 'small'
                },
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        flex: "grow",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "small",
                                direction: "row",
                                align: "center",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                    color: "accent-1",
                                    value: session && new Date(`${session.date}T00:00:00`).toISOString(),
                                    format: "mm/dd/yyyy",
                                    calendarProps: {
                                        disabled: sessionStore.getSessionDates(sessionId)
                                    },
                                    onChange: (event)=>session && typeof event.value === 'string' && updateSession({
                                            date: event.value
                                        })
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                direction: "row",
                                border: {
                                    side: 'bottom',
                                    size: '0.5px',
                                    color: 'accent-1'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                    value: session?.commercial,
                                    onChange: ({ value: value })=>updateSession({
                                            commercialId: value.id
                                        }),
                                    placeholder: "Choose commercial...",
                                    options: commercials,
                                    plain: true,
                                    width: "small",
                                    valueKey: "id",
                                    labelKey: "title"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                align: "center",
                                gap: "xsmall",
                                onClick: ()=>session && updateSession({
                                        isUnion: !session.is_union
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                                        checked: session?.is_union
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        color: "accent-1",
                                        children: "Union Session"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        flex: "grow",
                        pad: "medium",
                        round: (0, $4Oriw.borderRadiusSize),
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "end",
                                        justify: "end",
                                        flex: "grow",
                                        children: !!straightHours && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            color: "accent-1",
                                            children: "STRAIGHT TIME:"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "end",
                                        justify: "end",
                                        flex: "grow",
                                        children: !!overtimeHours && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            color: "accent-1",
                                            children: "OVERTIME:"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "start",
                                        justify: "end",
                                        flex: "grow",
                                        children: !!straightHours && /*#__PURE__*/ (0, $6ir3O.jsx)(HoursDisplay, {
                                            hours: straightHours
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "start",
                                        justify: "end",
                                        flex: "grow",
                                        children: !!overtimeHours && /*#__PURE__*/ (0, $6ir3O.jsx)(HoursDisplay, {
                                            hours: overtimeHours
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "end",
                        width: "10%",
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "column",
                            gap: "xxsmall",
                            justify: "end",
                            align: "end",
                            flex: "grow",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "xsmall",
                                    weight: 500,
                                    color: "accent-1",
                                    children: "SESSION WAGES"
                                }),
                                sessionEstimate && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "1.15rem",
                                    weight: "bold",
                                    color: "accent-1",
                                    children: (0, $b1rqt.USD)(sessionEstimate?.subtotal)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        align: "end",
                        width: "10%",
                        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "column",
                            gap: "xxsmall",
                            justify: "end",
                            align: "end",
                            flex: "grow",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 500,
                                    color: "accent-1",
                                    children: "SESSION TOTAL"
                                }),
                                sessionEstimate && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "1.15rem",
                                    weight: "bold",
                                    color: "accent-1",
                                    children: (0, $b1rqt.USD)(sessionEstimate?.subtotal_plus_fringe)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "48px",
                        height: "48px",
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                            onClick: ()=>onDelete(),
                            name: (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(session?.date).format('MM/DD/YYYY')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                animation: {
                    type: 'slideDown',
                    size: 'medium'
                },
                flex: "grow",
                align: !session ? 'center' : undefined,
                pad: !session ? 'medium' : undefined,
                background: "accent-1",
                // round={{ corner: 'bottom', size: borderRadiusSize }}
                elevation: "xsmall",
                children: [
                    !session && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                        size: "small"
                    }),
                    session?.activities && session?.activities.length > 0 && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                justify: "start",
                                align: "center",
                                gap: "small",
                                // style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}
                                pad: {
                                    vertical: 'xsmall',
                                    horizontal: 'small'
                                },
                                background: "light-2",
                                animation: {
                                    type: 'slideDown',
                                    size: 'medium',
                                    delay: 300
                                },
                                elevation: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        width: "6%",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "HOURS"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        width: "16%",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "ROLES"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        width: "20%",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "ACTIVITY TYPE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        width: "16%",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "LOCATION"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "start",
                                        flex: "grow",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            children: "HOUR TOTALS"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "end",
                                        width: "10%",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            weight: 600,
                                            children: "WAGES"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        align: "end",
                                        width: "10%",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            weight: 600,
                                            children: "TOTAL"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        width: "48px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                direction: "column",
                                gap: "small",
                                animation: {
                                    type: 'slideDown',
                                    size: 'medium'
                                },
                                children: session.activities.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(a.created_at).isAfter(b.created_at) ? 1 : -1).map((activity, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $lLmV5.SessionActivityRow), {
                                        rowIndex: i,
                                        script: session.script,
                                        session: session,
                                        roles: roles,
                                        locations: locations,
                                        deleteSessionActivity: deleteSessionActivity,
                                        activity: activity,
                                        updateSessionActivity: (update)=>updateSessionActivity({
                                                ...activity,
                                                ...update
                                            })
                                    }, activity.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                gap: "small",
                // flex="grow"
                background: "light-2",
                round: {
                    corner: 'bottom',
                    size: (0, $4Oriw.borderRadiusSize)
                },
                // border={{ side: 'bottom', size: '1px' }}
                direction: "row",
                justify: "end",
                pad: "xsmall",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                    icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "Add An Activity"
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eNYAE.Yoga), {})
                    }),
                    onClick: ()=>addSessionActivity()
                })
            })
        ]
    });
});

});

parcelRegister("cBCf2", function(module, exports) {

$parcel$export(module.exports, "SessionsPanel", () => $4854d5ab5627edd7$export$cf637bdc2413e23c);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("1xNcM");
var $8YJFZ = parcelRequire("8YJFZ");

var $8DltC = parcelRequire("8DltC");

var $4kZY9 = parcelRequire("4kZY9");

var $5xcHk = parcelRequire("5xcHk");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("bRT7J");
var $lFfFS = parcelRequire("lFfFS");
var $3bJi5 = parcelRequire("3bJi5");
var $kaLe2 = parcelRequire("kaLe2");

var $gj4rk = parcelRequire("gj4rk");
const $4854d5ab5627edd7$export$cf637bdc2413e23c = (0, $j8yBr.observer)(()=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    const estimateStore = (0, $8DltC.useEstimateStore)();
    const sessionStore = (0, $8DltC.useSessionStore)();
    /** State **/ const [showAddModal, setShowAddModal] = (0, $2NacA.useState)(false);
    const [sessions, setSessions] = (0, $2NacA.useState)([]);
    const [selected, setSelected] = (0, $2NacA.useState)([]);
    const [locations, setLocations] = (0, $2NacA.useState)([]);
    const [hasUnsavedChanges, setHasUnsavedChanges] = (0, $2NacA.useState)(false);
    /** Computed **/ const tempEstimate = estimateStore.tempEstimate;
    /** Derived **/ const saveStatus = hasUnsavedChanges ? (0, $lFfFS.SaveStatus).Saving : (0, $lFfFS.SaveStatus).Saved;
    const totalWages = (0, $2NacA.useMemo)(()=>{
        const subtotals = tempEstimate?.session_estimates.map((sessionEstimate)=>sessionEstimate.subtotal) ?? [];
        if (subtotals.length) return subtotals.reduce((acc, wage)=>(acc ?? 0) + wage);
    }, [
        tempEstimate?.session_estimates
    ]);
    const grandTotal = (0, $2NacA.useMemo)(()=>{
        const subtotalsPlusFringe = tempEstimate?.session_estimates.map((sessionEstimate)=>sessionEstimate.subtotal_plus_fringe) ?? [];
        if (subtotalsPlusFringe.length) return subtotalsPlusFringe.reduce((acc, wage)=>(acc ?? 0) + wage);
    }, [
        tempEstimate?.session_estimates
    ]);
    /** Methods **/ const chooseSession = (id)=>{
        if (selected.includes(id)) setSelected(selected.filter((s)=>s !== id));
        else setSelected([
            ...selected,
            id
        ]);
    };
    const createSession = async (scriptId)=>{
        if (!tempEstimate) {
            console.warn('Could not create Session - Temp Estimate is undefined');
            return;
        }
        const projectId = projectStore.currentProject?.id;
        if (!projectId) return;
        const sortedSessions = [
            ...sessions
        ].sort((a, b)=>a.date > b.date ? 1 : -1);
        const nextDate = sortedSessions.length ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(`${sortedSessions[sortedSessions.length - 1].date}T00:00:00`).add(1, 'day') : new Date();
        setHasUnsavedChanges(true);
        const session = await sessionStore.createSession(nextDate.toISOString(), projectId, scriptId);
        if (session) {
            setSessions([
                ...sessions,
                session
            ]);
            await estimateStore.createSessionEstimate(`TempSessionEstimate_Session_${session.id}`, session.date, session.id, true);
            await estimateStore.refreshTempEstimate();
            setHasUnsavedChanges(false);
        }
    };
    const deleteSession = async (sessionId)=>{
        if (!tempEstimate) {
            console.warn('Could not delete Sessions - Temp Estimate is undefined');
            return;
        }
        setHasUnsavedChanges(true);
        await sessionStore.deleteSession(sessionId);
        const sessionIndex = sessions.findIndex((session)=>session.id === sessionId);
        if (sessionIndex > -1) {
            sessions.splice(sessionIndex, 1);
            setSessions(sessions);
        }
        const sessionEstimate = tempEstimate.session_estimates.find((se)=>se.session && se.session.id === sessionId);
        if (sessionEstimate) {
            await estimateStore.deleteSessionEstimate(sessionEstimate.id, true);
            await estimateStore.refreshTempEstimate();
        }
        setHasUnsavedChanges(false);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const getSessions = async ()=>{
            if (!projectStore.currentProject?.id) {
                setSessions([]);
                return;
            }
            if (projectStore.currentProject?.id === estimateStore.tempEstimate?.id) return;
            try {
                // Get or create hidden Estimate for Session Estimator page
                const tempTitle = `${(0, $8YJFZ.SESSION_ESTIMATOR_TEMP_ESTIMATE_TITLE)}${projectStore.currentProject.id}`;
                let estimate = await estimateStore.getEstimateByTitle(tempTitle, 'session_estimates', true);
                if (!estimate) {
                    await estimateStore.createEstimate(projectStore.currentProject.id, tempTitle, true);
                    estimate = await estimateStore.getEstimateByTitle(tempTitle, 'session_estimates', true);
                }
                if (estimate?.is_hidden) estimateStore.setTempEstimate(estimate);
                await estimateStore.refreshTempEstimate();
                const s = await sessionStore.listSessions(projectStore.currentProject.id);
                setSessions(s || []);
            } catch (err) {
                if (err.status !== 400) console.error(err);
                setSessions([]);
            }
        };
        getSessions();
    }, [
        projectStore.currentProject?.id
    ]);
    (0, $2NacA.useEffect)(()=>{
        const getLocations = async ()=>{
            if (!projectStore.currentProject) return;
            const l = await projectStore.getLocationsByProjectId(projectStore.currentProject.id);
            setLocations(l || []);
        };
        getLocations();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        children: [
            projectStore.currentProject && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $3bJi5.SessionEstimatorHeader), {
                project: projectStore.currentProject,
                onCreate: createSession,
                saveStatus: saveStatus,
                totalWages: totalWages,
                grandTotal: grandTotal
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                pad: "medium",
                gap: "medium",
                background: "light-1",
                overflow: {
                    vertical: 'scroll'
                },
                flex: "grow",
                children: sessions.map((session, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $kaLe2.SessionRow), {
                        sessionId: session.id,
                        locations: locations,
                        onChecked: ()=>chooseSession(session.id),
                        onDelete: ()=>deleteSession(session.id),
                        checked: selected.includes(session.id),
                        onChange: ()=>setHasUnsavedChanges(true),
                        onSaveComplete: ()=>setHasUnsavedChanges(false),
                        rowIndex: i
                    }, session.id))
            }),
            showAddModal && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gj4rk.CreateSessionModal), {
                addSession: createSession,
                setShowModal: setShowAddModal
            })
        ]
    });
});

});
parcelRegister("gj4rk", function(module, exports) {

$parcel$export(module.exports, "CreateSessionModal", () => $af11c5110c6d5e2a$export$b37957c294117e0b);

var $6ir3O = parcelRequire("6ir3O");

var $4kZY9 = parcelRequire("4kZY9");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $94KEY = parcelRequire("94KEY");
var $czDw5 = parcelRequire("czDw5");
var $5erKi = parcelRequire("5erKi");
var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $49JR0 = parcelRequire("49JR0");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");
const $af11c5110c6d5e2a$export$b37957c294117e0b = (0, $j8yBr.observer)(({ addSession: addSession, setShowModal: setShowModal })=>{
    /** Context **/ const sessionStore = (0, $8DltC.useSessionStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ // .toISOString() (not .format(), which converts to local time) keeps this a UTC-safe
    // date-only string - the "date" column round-trips through the API as UTC midnight, so
    // formatting via local time can roll the day back or forward depending on the viewer's
    // timezone offset.
    const [date, setDate] = (0, $2NacA.useState)(sessionStore.getLastSessionDate() ? (0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(sessionStore.getLastSessionDate()).add(1, 'day').toISOString().slice(0, 10) : '');
    const [scriptId, setScriptId] = (0, $2NacA.useState)('');
    const [formErrors, setFormErrors] = (0, $2NacA.useState)({});
    /** Computed **/ const scripts = projectStore.currentProject?.scripts.map((s)=>({
            name: s.name,
            id: s.id
        })) ?? [];
    /** Methods **/ const createSession = ()=>{
        if (sessionStore.getSessionDates().find((d)=>(0, (/*@__PURE__*/$parcel$interopDefault($4kZY9)))(d).isSame(date))) {
            setFormErrors({
                ...formErrors,
                date: 'A Session already exists for this date.'
            });
            return;
        }
        addSession(date, scriptId);
        setShowModal(false);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowModal(false),
        onClickOutside: ()=>setShowModal(false),
        position: "center",
        modal: true,
        margin: "large",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "column",
            align: "start",
            pad: "small",
            justify: "around",
            width: "medium",
            height: "medium",
            background: "light-1",
            round: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        pad: "small",
                        gap: "small",
                        align: "center",
                        fill: "horizontal",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                width: "20%",
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Date:"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                fill: "horizontal",
                                gap: "xsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $czDw5.Keyboard), {
                                        onEnter: createSession,
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $94KEY.DateInput), {
                                            format: "mm/dd/yyyy",
                                            value: date,
                                            calendarProps: {
                                                disabled: sessionStore.getSessionDates()
                                            },
                                            onChange: ({ value: value })=>setDate(typeof value === 'object' ? value[0] : value)
                                        })
                                    }),
                                    formErrors.date && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                        fill: "horizontal",
                                        align: "end",
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                            size: "xsmall",
                                            color: "red",
                                            children: formErrors.date
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    direction: "row",
                    gap: "small",
                    pad: "small",
                    align: "center",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            width: "20%",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Script:"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                id: "select-script",
                                name: "script",
                                placeholder: "Choose...",
                                options: scripts,
                                labelKey: "name",
                                valueKey: "id",
                                onChange: ({ value: value })=>setScriptId(value.id),
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $49JR0.Book), {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    pad: "small",
                    margin: "small",
                    hoverIndicator: true,
                    onClick: ()=>createSession(),
                    label: "Add Session"
                })
            ]
        })
    });
});

});
parcelRegister("49JR0", function(module, exports) {

$parcel$export(module.exports, "Book", () => $306b924cae236bf6$export$c959ddfb5bf9a14a);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $306b924cae236bf6$var$_extends() {
    return $306b924cae236bf6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $306b924cae236bf6$var$_extends.apply(null, arguments);
}
var $306b924cae236bf6$export$c959ddfb5bf9a14a = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $306b924cae236bf6$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Book"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M10 1v10l3-2 3 2V1M5.5 18a2.5 2.5 0 1 0 0 5H22M3 20.5v-17A2.5 2.5 0 0 1 5.5 1H21v17.007H5.492M20.5 18a2.5 2.5 0 1 0 0 5"
    }));
});
$306b924cae236bf6$export$c959ddfb5bf9a14a.displayName = 'Book';

});




parcelRegister("4omtO", function(module, exports) {

$parcel$export(module.exports, "TableHeaderItem", () => $717c5a2730b5ebcd$export$586a5d185f4d675f);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
const $717c5a2730b5ebcd$export$586a5d185f4d675f = ({ width: width = '20%', animate: animate = false, animation: animation = {
    type: 'fadeIn',
    size: 'large'
}, children: children })=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        width: width,
        animation: animate ? animation : undefined,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            size: "xsmall",
            color: "white",
            children: children
        })
    });

});

parcelRegister("tvnEW", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $iYbB4 = parcelRequire("iYbB4");
var $dij1X = parcelRequire("dij1X");
var $gyf5K = parcelRequire("gyf5K");
var $7kMct = parcelRequire("7kMct");
var $aFsfQ = parcelRequire("aFsfQ");
var $jRjUr = parcelRequire("jRjUr");
var $bhoi7 = parcelRequire("bhoi7");
var $eNYAE = parcelRequire("eNYAE");
const $fcb0aac18932065b$export$c3b5362481df979c = ({ type: type, ...props })=>{
    switch(type){
        case 'media':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aFsfQ.Multimedia), {
                ...props
            });
        case 'post':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7kMct.Home), {
                ...props
            });
        case 'prePro':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bhoi7.Video), {
                ...props
            });
        case 'production':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dij1X.Channel), {
                ...props
            });
        case 'report':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iYbB4.Calendar), {
                ...props
            });
        case 'resources':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eNYAE.Yoga), {
                ...props
            });
        case 'session':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gyf5K.DocumentText), {
                ...props
            });
        case 'sessionActivity':
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jRjUr.Resources), {
                ...props
            });
        default:
            return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {});
    }
};

});
parcelRegister("7kMct", function(module, exports) {

$parcel$export(module.exports, "Home", () => $556fca383c6877ab$export$b94310965bed44e6);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $556fca383c6877ab$var$_extends() {
    return $556fca383c6877ab$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $556fca383c6877ab$var$_extends.apply(null, arguments);
}
var $556fca383c6877ab$export$b94310965bed44e6 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $556fca383c6877ab$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Home"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 11 11-9 11 9m-8 12v-8H9v8m-5 0V9m16 14V9"
    }));
});
$556fca383c6877ab$export$b94310965bed44e6.displayName = 'Home';

});

parcelRegister("jRjUr", function(module, exports) {

$parcel$export(module.exports, "Resources", () => $e752692a0fc5087d$export$e9a269813a6315a4);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $e752692a0fc5087d$var$_extends() {
    return $e752692a0fc5087d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e752692a0fc5087d$var$_extends.apply(null, arguments);
}
var $e752692a0fc5087d$export$e9a269813a6315a4 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $e752692a0fc5087d$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Resources"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m12 3 9 4.5-9 4.5-9-4.5L12 3zm4.5 7.25L21 12.5 12 17l-9-4.5 4.5-2.25m9 5L21 17.5 12 22l-9-4.5 4.5-2.25"
    }));
});
$e752692a0fc5087d$export$e9a269813a6315a4.displayName = 'Resources';

});


parcelRegister("9TVJO", function(module, exports) {

$parcel$export(module.exports, "TimeInput", () => $5b206b610e5bb944$export$a1af6f79df847fac);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $2fsW3 = parcelRequire("2fsW3");
const $5b206b610e5bb944$export$a1af6f79df847fac = ({ time: time, setTime: setTime, boxProps: boxProps })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        ...boxProps,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2fsW3.MaskedInput), {
            mask: [
                {
                    length: [
                        1,
                        2
                    ],
                    options: Array.from({
                        length: 12
                    }, (v, k)=>k + 1),
                    regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
                    placeholder: 'hh'
                },
                {
                    fixed: ':'
                },
                {
                    length: 2,
                    options: [
                        '00',
                        '15',
                        '30',
                        '45'
                    ],
                    regexp: /^[0-5][0-9]$|^[0-9]$/,
                    placeholder: 'mm'
                },
                {
                    fixed: ' '
                },
                {
                    length: 2,
                    options: [
                        'am',
                        'pm'
                    ],
                    regexp: /^[ap]m$|^[AP]M$|^[aApP]$/,
                    placeholder: 'ap'
                }
            ],
            value: time,
            onChange: (event)=>setTime(event.target.value)
        })
    });
};

});

parcelRegister("grjep", function(module, exports) {
$parcel$export(module.exports, "UsagePanel", () => (parcelRequire("d8S1C")).UsagePanel);
$parcel$export(module.exports, "UsageRow", () => (parcelRequire("6useT")).UsageRow);
$parcel$export(module.exports, "UsageTypeSelect", () => (parcelRequire("b9Fv4")).UsageTypeSelect);
parcelRequire("8ZIdW");
parcelRequire("aVZ8G");
parcelRequire("1Cdhu");
parcelRequire("d8S1C");
parcelRequire("6useT");
parcelRequire("b9Fv4");

});
parcelRegister("8ZIdW", function(module, exports) {

$parcel$export(module.exports, "CommercialUsageRow", () => $77a76cbc2cee9d71$export$7924b2b4bda73bb9);

var $6ir3O = parcelRequire("6ir3O");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $ir1aK = parcelRequire("ir1aK");
var $jJ6uA = parcelRequire("jJ6uA");
var $hIlrL = parcelRequire("hIlrL");
var $2bcjL = parcelRequire("2bcjL");
var $gpKeH = parcelRequire("gpKeH");
var $kS7Ii = parcelRequire("kS7Ii");

var $jK3Kk = parcelRequire("jK3Kk");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("bRT7J");
var $gdNyE = parcelRequire("gdNyE");
var $hF8pi = parcelRequire("hF8pi");
var $1Ofsp = parcelRequire("1Ofsp");
var $6q7qM = parcelRequire("6q7qM");
var $d2VmQ = parcelRequire("d2VmQ");
var $6useT = parcelRequire("6useT");

var $fjut3 = parcelRequire("fjut3");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");
var $i2YYW = parcelRequire("i2YYW");

var $8DltC = parcelRequire("8DltC");

var $4Oriw = parcelRequire("4Oriw");

var $b1rqt = parcelRequire("b1rqt");

var $7rIqL = parcelRequire("7rIqL");
const $77a76cbc2cee9d71$export$7924b2b4bda73bb9 = (0, $j8yBr.observer)(({ commercialId: commercialId, onChecked: onChecked, checked: checked })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    const usageStore = (0, $8DltC.useUsageStore)();
    const commercialStore = (0, $8DltC.useCommercialStore)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const roleStore = (0, $8DltC.useRoleStore)();
    /** State **/ const [commercial, setCommercial] = (0, $2NacA.useState)();
    const [selectedUsageIds, setSelectedUsageIds] = (0, $2NacA.useState)([]);
    const [roles, setRoles] = (0, $2NacA.useState)();
    const [wages, setWages] = (0, $2NacA.useState)(0);
    const [total, setTotal] = (0, $2NacA.useState)(0);
    /** Computed **/ const tempEstimate = estimateStore.tempEstimate;
    const usageEstimate = estimateStore.getTempUsageEstimate(commercial?.id);
    /** Methods **/ const recalculateUsageEstimate = async ()=>{
        if (!commercial) return;
        const usageEstimate = tempEstimate?.usage_estimates.find((usageEstimate)=>usageEstimate.commercial?.id === commercial.id);
        if (usageEstimate) await estimateStore.updateUsageEstimate(usageEstimate.id, undefined, true);
    };
    const chooseUsage = (id)=>{
        if (selectedUsageIds.includes(id)) setSelectedUsageIds(selectedUsageIds.filter((s)=>s !== id));
        else setSelectedUsageIds([
            ...selectedUsageIds,
            id
        ]);
    };
    const updateCommercial = async (update)=>{
        if (!commercial) return;
        const updatedCommercial = await commercialStore.updateCommercial(commercial.id, update);
        if (updatedCommercial) {
            setCommercial(updatedCommercial);
            // Refresh the temp estimate
            await recalculateUsageEstimate();
        }
    };
    const addUsage = async (usageType)=>{
        if (!commercial) return;
        const usage = await usageStore.createUsage({
            commercialId: commercialId,
            title: `${usageType} Usage`,
            type: usageType ?? null,
            cycles: 1,
            units: 1,
            unit_type: (0, $i2YYW.UsageUnitType).Uses,
            role_ids: [],
            platform: null,
            category: null,
            uses_type: null,
            cycle_number: null,
            cycle_unit: null,
            language: null,
            market_spec: null,
            global_market: null,
            cable_market: null,
            audio_made_move: null
        });
        if (usage) {
            const usages = [
                ...commercial.usages,
                usage
            ];
            const updatedCommercial = {
                ...commercial,
                usages: usages
            };
            const usageEstimates = (await commercialStore.getCommercial(commercial.id))?.usage_estimates;
            if (usageEstimates) updatedCommercial.usage_estimates = usageEstimates;
            setCommercial(updatedCommercial);
            // Refresh the temp estimate
            await recalculateUsageEstimate();
        }
    };
    const updateUsage = async (usage)=>{
        if (!commercial) return;
        // Match this Usage to UsageTypes
        const matchingTypeInfos = (0, $7rIqL.getMatchingUsageTypeInfos)(usage, commercial);
        const { id: id, roles: roles, units: units, unit_type: unit_type, cycles: cycles, cycle_number: cycle_number, cycle_unit: cycle_unit, platform: platform, category: category, uses_type: uses_type, market_spec: market_spec, language: language, global_market: global_market, cable_market: cable_market, audio_made_move: audio_made_move } = usage;
        let title = 'Untyped Usage';
        let type = null;
        if (usage.type) {
            title = usage.type;
            type = usage.type;
        } else if (matchingTypeInfos.length === 1) {
            title = matchingTypeInfos[0].id;
            type = matchingTypeInfos[0].id;
        }
        const updatedUsage = await usageStore.updateUsage(id, {
            role_ids: roles?.map((r)=>r.id),
            title: title,
            type: type,
            units: units,
            unit_type: unit_type,
            cycles: cycles,
            cycle_number: cycle_number,
            cycle_unit: cycle_unit,
            platform: platform,
            category: category,
            uses_type: uses_type,
            market_spec: market_spec,
            language: language,
            global_market: global_market,
            cable_market: cable_market,
            audio_made_move: audio_made_move
        });
        if (!updatedUsage) return;
        const usages = commercial.usages?.map((u)=>u.id === updatedUsage.id ? updatedUsage : u);
        const updatedCommercial = {
            ...commercial,
            usages: usages
        };
        setCommercial(updatedCommercial);
        // Refresh the temp estimate
        await recalculateUsageEstimate();
    };
    const deleteUsages = async ()=>{
        if (!commercial || selectedUsageIds.length === 0) return;
        await Promise.all(selectedUsageIds.map((usageId)=>usageStore.deleteUsage(usageId)));
        const usages = commercial.usages.filter((usage)=>!selectedUsageIds.includes(usage.id));
        setCommercial({
            ...commercial,
            usages: usages
        });
        setSelectedUsageIds([]);
        // Refresh the temp estimate
        await recalculateUsageEstimate();
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (usageEstimate) {
            let wages = 0;
            let total = 0;
            for (const item of usageEstimate.items){
                wages += item.subtotal;
                total += item.subtotal_plus_fringe;
            }
            setWages(wages);
            setTotal(total);
        }
    }, [
        usageEstimate
    ]);
    (0, $2NacA.useEffect)(()=>{
        const getCommercial = async (id)=>{
            if (!projectStore.currentProject) return;
            const c = await commercialStore.getCommercial(id);
            if (c) setCommercial(c);
        };
        getCommercial(commercialId);
    }, [
        commercialId,
        projectStore.currentProject
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (commercial?.type) {
            const getRoles = async (commercialType)=>{
                if (!projectStore.currentProject) return;
                const r = await roleStore.getRolesByProjectId(projectStore.currentProject.id);
                setRoles(r?.filter((role)=>commercialType === (0, $3qs6L.CommercialType).Radio ? (0, $fjut3.RadioTypes).includes(role.type) : commercialType === (0, $3qs6L.CommercialType).TV || commercialType === (0, $3qs6L.CommercialType).Digital || commercialType === (0, $3qs6L.CommercialType).Social ? (0, $fjut3.TVTypes).includes(role.type) : true) || []);
            };
            getRoles(commercial.type);
        }
    }, [
        commercial?.type,
        projectStore.currentProject
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $ir1aK.Card), {
        round: (0, $4Oriw.borderRadiusSize),
        background: "light-1",
        animation: {
            type: 'fadeIn',
            duration: 500
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $2bcjL.CardHeader), {
                justify: "start",
                align: "center",
                gap: "small",
                background: {
                    color: 'brand-gradient',
                    dark: true
                },
                style: {
                    background: 'var(--brand-gradient)',
                    zIndex: 1
                },
                height: {
                    max: '80px',
                    min: '80px'
                },
                pad: {
                    horizontal: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                            onChange: onChecked,
                            checked: checked,
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                            textColor: "white",
                            val: commercial?.title ?? '',
                            onChange: (title)=>updateCommercial({
                                    title: title
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                color: "white",
                                children: "Type:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6q7qM.SelectableText), {
                                textColor: "white",
                                options: Object.values((0, $3qs6L.CommercialType)).map((t)=>({
                                        label: t,
                                        value: t
                                    })),
                                val: commercial?.type,
                                onChange: (val)=>updateCommercial({
                                        type: val
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "small",
                        pad: "small",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                style: {
                                    whiteSpace: 'nowrap'
                                },
                                color: "white",
                                children: "Duration:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "xxsmall",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1Ofsp.EditableText), {
                                        textColor: "white",
                                        val: commercial?.duration?.toString() ?? '',
                                        onChange: (val)=>updateCommercial({
                                                durationInSeconds: val ? parseInt(val) : 0
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        color: "white",
                                        children: "seconds"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        flex: true
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        justify: "end",
                        pad: "small",
                        gap: "large",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "xsmall",
                                justify: "end",
                                align: "center",
                                width: "",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        weight: 700,
                                        color: "white",
                                        children: "WAGES:"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        weight: "bold",
                                        color: "white",
                                        children: (0, $b1rqt.USD)(wages)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                direction: "row",
                                gap: "xsmall",
                                justify: "end",
                                align: "center",
                                width: "10rem",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        size: "small",
                                        weight: 700,
                                        color: "white",
                                        children: "TOTAL:"
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        weight: "bold",
                                        color: "white",
                                        children: (0, $b1rqt.USD)(total)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jJ6uA.CardBody), {
                background: "white",
                elevation: "xsmall",
                children: (commercial?.usages ?? []).length > 0 ? commercial?.usages?.map((usage, i)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $6useT.UsageRow), {
                        usage: usage,
                        commercial: commercial,
                        roles: roles ?? [],
                        onChecked: ()=>chooseUsage(usage.id),
                        checked: selectedUsageIds.includes(usage.id),
                        updateUsage: (update)=>updateUsage({
                                ...usage,
                                ...update
                            }),
                        rowIndex: i
                    }, usage.id)) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    pad: "medium",
                    align: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        color: "dark-3",
                        children: [
                            "No Usages found.",
                            ' ',
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
                                weight: 300,
                                onClick: ()=>addUsage(),
                                color: "accent-5",
                                children: "Click here to create one"
                            }),
                            "."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hIlrL.CardFooter), {
                justify: "end",
                gap: "small",
                background: "light-2",
                pad: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                            children: "Add Usage Data"
                        }),
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jK3Kk.DocumentVideo), {}),
                                disabled: !commercial,
                                onClick: ()=>commercial && addUsage()
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hF8pi.Delete), {
                        onClick: ()=>deleteUsages(),
                        name: "the selected Usages",
                        disabled: !selectedUsageIds.length,
                        tip: "Remove Selected Usages"
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("7rIqL", function(module, exports) {

$parcel$export(module.exports, "getUsageCycleType", () => $a855298e42aff017$export$2cf8b8d29844ceb9);
$parcel$export(module.exports, "getMatchingUsageTypeInfos", () => $a855298e42aff017$export$1ed2acca90c10979);
$parcel$export(module.exports, "getUsagePlatforms", () => $a855298e42aff017$export$92777371b354851a);
$parcel$export(module.exports, "getUsageCategories", () => $a855298e42aff017$export$45156ca381b661aa);
$parcel$export(module.exports, "getUsageUsesTypes", () => $a855298e42aff017$export$7ae5fb360adb5d09);
$parcel$export(module.exports, "getUsageCycleTypes", () => $a855298e42aff017$export$ee9a5d86afaa4920);

var $fjut3 = parcelRequire("fjut3");
parcelRequire("hcQWc");
var $3qs6L = parcelRequire("3qs6L");
var $8wESq = parcelRequire("8wESq");
var $RoqvF = parcelRequire("RoqvF");
var $1bvuP = parcelRequire("1bvuP");
var $4bBQG = parcelRequire("4bBQG");
var $69JXC = parcelRequire("69JXC");
var $etRr4 = parcelRequire("etRr4");
const $a855298e42aff017$export$b66cb2bdfa3e9bc = {
    [(0, $3qs6L.CommercialType).TV]: {
        [(0, $1bvuP.UsagePlatform).Linear]: {
            [(0, $69JXC.UsageTypeCategory).NationalNetworks]: {
                [(0, $etRr4.UsesType).PerUse]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_Network_ClassA_Per_Use]
                ],
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_Network_ClassA_13_Week_Maximum]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).IONAndDiginet]: {
                [(0, $etRr4.UsesType).PerUse]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_IONAndDiginet_Per_Use]
                ],
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_IONAndDiginet_13_Week_Unlimited_Use]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).SpanishLanguageProgramUse]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_SpanishLanguageProgram_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_SpanishLanguageProgram_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_SpanishLanguageProgram_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).Wildspot]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_WildSpot_AllMarkets_4_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_WildSpot_AllMarkets_13_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_WildSpot_AllMarkets_52_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_WildSpot_AllMarketsNoNYChiLA_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).NationalCable]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_NationalCable_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_NationalCable_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_NationalCable_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).LocalCable]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_4_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_1M_To_2M_Subs_4_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_2M_To_3M_Subs_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_13_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_1M_To_2M_Subs_13_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_2M_To_3M_Subs_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_52_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_1M_To_2M_Subs_52_Week],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_LocalCable_2M_To_3M_Subs_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).Dealer]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_Dealer_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_Dealer_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_Dealer_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).AllOtherNA]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_AllOtherNALinear_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_AllOtherNALinear_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_LinearDomestic_AllOtherNALinear_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).TheatricalIndustrial]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Up_To_30_Days],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Use_Through_MPU],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Dist_On_Physical_Media]
                ]
            }
        },
        [(0, $1bvuP.UsagePlatform).Digital]: {
            [(0, $69JXC.UsageTypeCategory).TraditionalDigital]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_TraditionalDigital_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_TraditionalDigital_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_TraditionalDigital_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).StreamingPlatforms]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_StreamingPlatforms_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_StreamingPlatforms_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_StreamingPlatforms_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).SocialMedia]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).thirty} ${(0, $RoqvF.UsageCycleUnit).Day}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_SocialMedia_30_Day_Cycle]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).YouTube]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_SocialMedia_YouTube]
                ]
            }
        },
        [(0, $1bvuP.UsagePlatform).TheatricalIndustrial]: {
            [(0, $69JXC.UsageTypeCategory).TheatricalIndustrial]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Up_To_30_Days],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Use_Through_MPU],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Dist_On_Physical_Media]
                ]
            }
        },
        [(0, $1bvuP.UsagePlatform).Foreign]: {
            [(0, $69JXC.UsageTypeCategory).ForeignUse]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_SpanishLanguage_Americas],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_SpanishLanguage_Caribbean],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_SpanishLanguage_AmericasAndCaribbean],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_Other_UK],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_Other_Japan],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_Other_Europe],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_Other_RestOfWorld],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_Other_AsiaPacific],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_ForeignUse_Other_Worldwide]
                ]
            }
        },
        [(0, $1bvuP.UsagePlatform).AFM]: {
            [(0, $69JXC.UsageTypeCategory).AFMFirstUse]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_AFM_FirstUse_InternetOnlyOrUS]
                ]
            },
            [(0, $69JXC.UsageTypeCategory).AFMForeign]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_AFM_Foreign_1_Year_Europe_NoEurope],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_AFM_Foreign_Worldwide]
                ]
            }
        }
    },
    /**
   * Digital
   */ [(0, $3qs6L.CommercialType).Digital]: {
        [(0, $1bvuP.UsagePlatform).Digital]: {
            [(0, $69JXC.UsageTypeCategory).TraditionalDigital]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_TraditionalDigital_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_TraditionalDigital_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_TraditionalDigital_52_Week]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).StreamingPlatforms]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_StreamingPlatforms_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_StreamingPlatforms_13_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_StreamingPlatforms_52_Week]
                    ]
                }
            }
        }
    },
    /**
   * Social Media
   */ [(0, $3qs6L.CommercialType).Social]: {
        [(0, $1bvuP.UsagePlatform).Digital]: {
            [(0, $69JXC.UsageTypeCategory).SocialMedia]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).thirty} ${(0, $RoqvF.UsageCycleUnit).Day}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_SocialMedia_30_Day_Cycle]
                    ]
                }
            },
            [(0, $69JXC.UsageTypeCategory).YouTube]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_Digital_SocialMedia_YouTube]
                ]
            }
        }
    },
    /**
   * Out-of-Home Use
   */ [(0, $3qs6L.CommercialType).OOH]: {
        [(0, $1bvuP.UsagePlatform).TheatricalIndustrial]: {
            [(0, $69JXC.UsageTypeCategory).TheatricalIndustrial]: {
                [(0, $etRr4.UsesType).Unlimited]: [
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Up_To_30_Days],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Use_Through_MPU],
                    (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).TV_TheatricalIndustrial_Dist_On_Physical_Media]
                ]
            }
        }
    },
    /**
   * Radio
   */ [(0, $3qs6L.CommercialType).Radio]: {
        [(0, $1bvuP.UsagePlatform).Network]: {
            [(0, $69JXC.UsageTypeCategory).RadioNetwork]: {
                [(0, $etRr4.UsesType).PerUse]: {
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_13_Week_26_Uses],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_13_Week_39_Uses]
                    ]
                },
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).one} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_1_Week_Unlimited_Use]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_4_Weeks_Unlimited_Use]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).eight} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_8_Weeks_Unlimited_Use]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_13_Week_Unlimited_Use]
                    ]
                },
                [(0, $etRr4.UsesType).AcrossTheBoard]: {
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Network_13_Week_Across_The_Board_Use]
                    ]
                }
            }
        },
        [(0, $1bvuP.UsagePlatform).WildSpot]: {
            [(0, $69JXC.UsageTypeCategory).RadioWildspot]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).eight} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_8_Week_No_Major_Markets],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_8_Week_NY_Only],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_8_Week_LA_Or_Chicago_Only],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_8_Week_2_Of_LA_NY_Chicago],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_8_Week_LA_NY_And_Chicago]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).thirteen} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_13_Week_No_Major_Markets],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_13_Week_NY_Only],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_13_Week_LA_Or_Chicago_Only],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_13_Week_2_Of_LA_NY_Chicago],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_WildSpot_13_Week_LA_NY_And_Chicago]
                    ]
                }
            }
        },
        [(0, $1bvuP.UsagePlatform).Internet]: {
            [(0, $69JXC.UsageTypeCategory).InternetRadio]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).four} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Internet_4_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).eight} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Internet_8_Week_Made_For],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Internet_8_Week_Move_Over]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).one} ${(0, $RoqvF.UsageCycleUnit).Year}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Internet_1_Year_Made_For],
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Internet_1_Year_Move_Over]
                    ]
                }
            }
        },
        [(0, $1bvuP.UsagePlatform).Dealer]: {
            [(0, $69JXC.UsageTypeCategory).RadioDealer]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).eight} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Dealer_8_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).six} ${(0, $RoqvF.UsageCycleUnit).Month}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_Dealer_6_Months]
                    ]
                }
            }
        },
        [(0, $1bvuP.UsagePlatform).AFM]: {
            [(0, $69JXC.UsageTypeCategory).AFMInternetRadio]: {
                [(0, $etRr4.UsesType).Unlimited]: {
                    [`${(0, $8wESq.UsageCycleNumber).eight} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_AFM_RadioSpot_Internet_8_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).twentySix} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_AFM_RadioSpot_Internet_26_Week]
                    ],
                    [`${(0, $8wESq.UsageCycleNumber).fiftyTwo} ${(0, $RoqvF.UsageCycleUnit).Week}`]: [
                        (0, $fjut3.usageTypeData)[(0, $4bBQG.UsageType).Radio_AFM_RadioSpot_Internet_52_Week]
                    ]
                }
            }
        }
    }
};
const $a855298e42aff017$export$2cf8b8d29844ceb9 = (cycleNumber, cycleUnit)=>cycleNumber && cycleUnit && `${cycleNumber} ${cycleUnit}`;
const $a855298e42aff017$export$1ed2acca90c10979 = (usage, commercial)=>{
    const usageCycleType = $a855298e42aff017$export$2cf8b8d29844ceb9(usage.cycle_number, usage.cycle_unit);
    let matchingTypeInfos = usage.platform && usage.category && usage.uses_type && Array.isArray($a855298e42aff017$export$b66cb2bdfa3e9bc[commercial.type]?.[usage.platform]?.[usage.category]?.[usage.uses_type]) ? $a855298e42aff017$export$b66cb2bdfa3e9bc[commercial.type]?.[usage.platform]?.[usage.category]?.[usage.uses_type] : usageCycleType ? ($a855298e42aff017$export$b66cb2bdfa3e9bc[commercial.type]?.[usage.platform ?? '']?.[usage.category ?? ''][usage.uses_type ?? ''])[usageCycleType] : [];
    if (usage.market_spec) matchingTypeInfos = matchingTypeInfos.filter((info)=>info.marketSpec === usage.market_spec);
    if (usage.audio_made_move) matchingTypeInfos = matchingTypeInfos.filter((info)=>info.audioMadeMove === usage.audio_made_move);
    return matchingTypeInfos;
};
const $a855298e42aff017$export$92777371b354851a = (commercialType)=>Object.keys($a855298e42aff017$export$b66cb2bdfa3e9bc[commercialType]);
const $a855298e42aff017$export$45156ca381b661aa = (commercialType, platform)=>{
    if (platform) return Object.keys($a855298e42aff017$export$b66cb2bdfa3e9bc[commercialType][platform]);
};
const $a855298e42aff017$export$7ae5fb360adb5d09 = (commercialType, platform, category)=>{
    if (platform && category) return Object.keys($a855298e42aff017$export$b66cb2bdfa3e9bc[commercialType][platform]?.[category] ?? []);
};
const $a855298e42aff017$export$ee9a5d86afaa4920 = (commercialType, platform, category, usesType)=>{
    if (platform && category && usesType) {
        const usesTypeInfos = $a855298e42aff017$export$b66cb2bdfa3e9bc[commercialType][platform]?.[category]?.[usesType];
        return usesTypeInfos && !Array.isArray(usesTypeInfos) ? Object.keys(usesTypeInfos) : undefined;
    }
};

});


parcelRegister("aVZ8G", function(module, exports) {

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("bRT7J");
var $b9Fv4 = parcelRequire("b9Fv4");
const $27b4ec1069405712$export$19a06a09ff66c6ed = (0, $j8yBr.observer)(({ commercial: commercial, addUsage: addUsage, setShowModal: setShowModal })=>{
    const [type, setType] = (0, $2NacA.useState)();
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
        onEsc: ()=>setShowModal(false),
        onClickOutside: ()=>setShowModal(false),
        position: "center",
        modal: true,
        margin: "large",
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "column",
            align: "start",
            pad: "small",
            justify: "around",
            width: "medium",
            height: "medium",
            background: "light-1",
            round: "small",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    gap: "small",
                    pad: "small",
                    justify: "center",
                    fill: "horizontal",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                children: "Usage Type:"
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            fill: "horizontal",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b9Fv4.UsageTypeSelect), {
                                commercialType: commercial.type,
                                val: type,
                                onChange: (val)=>setType(val)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                    pad: "small",
                    margin: "small",
                    hoverIndicator: true,
                    onClick: ()=>type ? addUsage(commercial.id, type) : {},
                    disabled: !type,
                    label: "Add Usage"
                })
            ]
        })
    });
});

});

parcelRegister("1Cdhu", function(module, exports) {

$parcel$export(module.exports, "UsageEstimatorHeader", () => $0284ca186b3621d5$export$9cd2ebde84f67206);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $4zRSZ = parcelRequire("4zRSZ");
var $kS7Ii = parcelRequire("kS7Ii");

var $bDFk2 = parcelRequire("bDFk2");
var $bhoi7 = parcelRequire("bhoi7");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $1G16z = parcelRequire("1G16z");

var $gdNyE = parcelRequire("gdNyE");

var $jGT7M = parcelRequire("jGT7M");

var $lFfFS = parcelRequire("lFfFS");
const $0284ca186b3621d5$export$9cd2ebde84f67206 = (0, $j8yBr.observer)(({ project: project, onCreateCommercial: onCreateCommercial, onDeleteCommercials: onDeleteCommercials, hasSelectedCommercials: hasSelectedCommercials, totalWages: totalWages, grandTotal: grandTotal, height: height = '92px' })=>{
    /** Context **/ const commercialStore = (0, $8DltC.useCommercialStore)();
    const usageStore = (0, $8DltC.useUsageStore)();
    const screenSize = (0, $2NacA.useContext)((0, $4zRSZ.ResponsiveContext));
    const isDesktop = screenSize === 'large';
    /** Computed **/ const saveStatus = usageStore.isSaving || commercialStore.isSaving ? (0, $lFfFS.SaveStatus).Saving : (0, $lFfFS.SaveStatus).Saved;
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        background: "light-3",
        flex: "grow",
        direction: "row",
        align: "center",
        justify: "between",
        height: height,
        gap: "medium",
        style: {
            zIndex: 1
        },
        elevation: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                width: "67%",
                gap: "large",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        gap: "xsmall",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                margin: {
                                    left: 'medium'
                                },
                                animation: (0, $1G16z.getAnimProps)(0, 'slideUp'),
                                justify: "start",
                                direction: "row",
                                pad: {
                                    right: 'none'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    truncate: true,
                                    size: "xlarge",
                                    children: project ? `${project.name} Usages` : 'Usage Estimator'
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                height: "2px",
                                animation: {
                                    type: 'slideRight',
                                    size: 'xlarge',
                                    duration: 500
                                }
                            }),
                            saveStatus && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                align: "end",
                                animation: (0, $1G16z.getAnimProps)(0, 'slideDown'),
                                pad: {
                                    right: 'none'
                                },
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lFfFS.SaveStatusIndicator), {
                                    saveStatus: saveStatus,
                                    boxProps: {
                                        margin: 'none'
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        justify: "center",
                        height: "50px",
                        round: "1.5rem",
                        border: {
                            size: '1px',
                            color: 'light-4'
                        },
                        elevation: "small",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gdNyE.AddNewButton), {
                            onClick: onCreateCommercial,
                            style: {
                                padding: '15px',
                                borderRadius: '1.5rem',
                                fontSize: '0.9rem',
                                fontWeight: 500
                            },
                            label: "New Commercial",
                            plain: true,
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bhoi7.Video), {
                                color: "text",
                                size: "1.2rem"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        onClick: ()=>onDeleteCommercials(),
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bDFk2.Trash), {
                            color: "red"
                        }),
                        disabled: !hasSelectedCommercials,
                        tip: "Delete Selected Commercials"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                width: "32%",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        gap: "xsmall",
                        justify: "end",
                        align: "start",
                        width: "50%",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(100, 'slideUp', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 500,
                                    children: "TOTAL WAGES"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                animation: {
                                    type: 'slideLeft',
                                    size: 'xlarge',
                                    duration: 500
                                }
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(100, 'slideDown', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    truncate: true,
                                    size: "large",
                                    weight: 500,
                                    children: (!isDesktop ? (0, $b1rqt.shortenCurrency) : (0, $b1rqt.USD))(totalWages)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "column",
                        gap: "xsmall",
                        justify: "end",
                        align: "start",
                        width: "50%",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(0, 'slideUp', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    size: "small",
                                    weight: 700,
                                    children: "GRAND TOTAL"
                                })
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jGT7M.Divider), {
                                animation: {
                                    type: 'slideLeft',
                                    size: 'xlarge',
                                    duration: 500
                                }
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                animation: (0, $1G16z.getAnimProps)(0, 'slideDown', 500),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    truncate: true,
                                    size: "large",
                                    weight: 700,
                                    children: (!isDesktop ? (0, $b1rqt.shortenCurrency) : (0, $b1rqt.USD))(grandTotal)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("d8S1C", function(module, exports) {

$parcel$export(module.exports, "UsagePanel", () => $938c83e8e0016837$export$3660c3fa9bf0d23c);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kqZxg = parcelRequire("kqZxg");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $8DltC = parcelRequire("8DltC");

var $8ZIdW = parcelRequire("8ZIdW");
const $938c83e8e0016837$export$3660c3fa9bf0d23c = (0, $j8yBr.observer)(({ commercials: commercials, selected: selected, setSelected: setSelected })=>{
    /** Context **/ const projectStore = (0, $8DltC.useProjectStore)();
    /** Methods **/ const chooseCommercial = (id)=>{
        if (selected.includes(id)) setSelected(selected.filter((s)=>s !== id));
        else setSelected([
            ...selected,
            id
        ]);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        pad: "medium",
        gap: "medium",
        background: "light-1",
        overflow: {
            vertical: 'scroll'
        },
        flex: "grow",
        children: projectStore.currentProject ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            gap: "medium",
            children: commercials.map((commercial)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $8ZIdW.CommercialUsageRow), {
                    commercialId: commercial.id,
                    onChecked: ()=>chooseCommercial(commercial.id),
                    checked: selected.includes(commercial.id)
                }, commercial.id))
        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            fill: true,
            align: "center",
            justify: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kqZxg.Spinner), {
                size: "large"
            })
        })
    });
});

});

parcelRegister("6useT", function(module, exports) {

$parcel$export(module.exports, "UsageRow", () => $01e7cba4af068d21$export$810749b46ecc65eb);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("hcQWc");
var $4AdaL = parcelRequire("4AdaL");
var $1KFVI = parcelRequire("1KFVI");
var $69JXC = parcelRequire("69JXC");
var $i2YYW = parcelRequire("i2YYW");
var $etRr4 = parcelRequire("etRr4");

var $8DltC = parcelRequire("8DltC");

var $b1rqt = parcelRequire("b1rqt");

var $7rIqL = parcelRequire("7rIqL");

var $5xcHk = parcelRequire("5xcHk");
var $gpKeH = parcelRequire("gpKeH");
var $fdtj0 = parcelRequire("fdtj0");
var $hgBnK = parcelRequire("hgBnK");
var $kS7Ii = parcelRequire("kS7Ii");

var $eJdPk = parcelRequire("eJdPk");
var $dmh5A = parcelRequire("dmh5A");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");
parcelRequire("bRT7J");
var $bIzid = parcelRequire("bIzid");
var $d2VmQ = parcelRequire("d2VmQ");
const $01e7cba4af068d21$export$810749b46ecc65eb = (0, $j8yBr.observer)(({ usage: usage, commercial: commercial, roles: roles, checked: checked, onChecked: onChecked, updateUsage: updateUsage, rowIndex: rowIndex = 0 })=>{
    /** Context **/ const estimateStore = (0, $8DltC.useEstimateStore)();
    /** State **/ const [wages, setWages] = (0, $2NacA.useState)(0);
    const [total, setTotal] = (0, $2NacA.useState)(0);
    const [usageMarkets, setUsageMarkets] = (0, $2NacA.useState)();
    /** Computed **/ const usageEstimateItems = estimateStore.getTempUsageEstimateItems(commercial.id, usage.id);
    const usageCycleType = (0, $2NacA.useMemo)(()=>(0, $7rIqL.getUsageCycleType)(usage.cycle_number, usage.cycle_unit), [
        usage
    ]);
    const usagePlatforms = (0, $2NacA.useMemo)(()=>(0, $7rIqL.getUsagePlatforms)(commercial.type), [
        commercial
    ]);
    const usageCategories = (0, $2NacA.useMemo)(()=>(0, $7rIqL.getUsageCategories)(commercial.type, usage.platform), [
        commercial,
        usage
    ]);
    const usageUsesTypes = (0, $2NacA.useMemo)(()=>(0, $7rIqL.getUsageUsesTypes)(commercial.type, usage.platform, usage.category), [
        commercial,
        usage
    ]);
    const usageCycleTypes = (0, $2NacA.useMemo)(()=>(0, $7rIqL.getUsageCycleTypes)(commercial.type, usage.platform, usage.category, usage.uses_type), [
        commercial,
        usage
    ]);
    const matchingTypeInfos = (0, $2NacA.useMemo)(()=>(0, $7rIqL.getMatchingUsageTypeInfos)(usage, commercial), [
        commercial,
        usage
    ]);
    const isRadioNetworkPerUse = usage.category === (0, $69JXC.UsageTypeCategory).RadioNetwork && usage.uses_type === (0, $etRr4.UsesType).PerUse && matchingTypeInfos?.length === 2 && !!matchingTypeInfos[0].useLimit?.maximum;
    const showMarketSelect = (0, $2NacA.useMemo)(()=>matchingTypeInfos && matchingTypeInfos.length > 0 && matchingTypeInfos.length <= Object.values((0, $1KFVI.MarketSpecification)).length && matchingTypeInfos.findIndex((info)=>!!info.marketSpec) > -1, [
        matchingTypeInfos
    ]);
    const showAudioMadeMoveSelect = (0, $2NacA.useMemo)(()=>matchingTypeInfos && matchingTypeInfos.length <= 2 && matchingTypeInfos.length > 0 && (!!matchingTypeInfos[0]?.audioMadeMove || !!matchingTypeInfos[1]?.audioMadeMove), [
        matchingTypeInfos
    ]);
    const showTypeSelect = usage.uses_type === (0, $etRr4.UsesType).Unlimited && (!usageCycleTypes || !usageCycleTypes.length) && !!matchingTypeInfos?.length || isRadioNetworkPerUse;
    const showCyclesInput = (usage.category === (0, $69JXC.UsageTypeCategory).TheatricalIndustrial || usage.category === (0, $69JXC.UsageTypeCategory).YouTube || usage.category === (0, $69JXC.UsageTypeCategory).ForeignUse || usage.category === (0, $69JXC.UsageTypeCategory).AFMFirstUse || usage.category === (0, $69JXC.UsageTypeCategory).AFMForeign || isRadioNetworkPerUse) && usage.type || usageCycleTypes && !!usageCycleType;
    const showUsesInput = usage.uses_type === (0, $etRr4.UsesType).PerUse && !usageCycleTypes;
    /** Methods **/ const handleChangePlatform = async (platform)=>{
        const newUsageCategories = (0, $7rIqL.getUsageCategories)(commercial.type, platform);
        await updateUsage({
            platform: platform,
            category: newUsageCategories?.length === 1 ? newUsageCategories[0] : null,
            cycles: 1,
            cycle_number: null,
            cycle_unit: null,
            units: 1,
            unit_type: (0, $i2YYW.UsageUnitType).Uses,
            uses_type: null,
            language: null,
            market_spec: null,
            global_market: null,
            cable_market: null,
            audio_made_move: null,
            type: null
        });
    };
    const handleChangeCategory = async (category)=>{
        await updateUsage({
            category: category,
            cycles: 1,
            cycle_number: null,
            cycle_unit: null,
            units: 1,
            unit_type: (0, $i2YYW.UsageUnitType).Uses,
            uses_type: null,
            language: null,
            market_spec: null,
            global_market: null,
            cable_market: null,
            audio_made_move: null,
            type: showTypeSelect ? null : undefined
        });
    };
    const handleChangeUsesType = async (usesType)=>{
        await updateUsage({
            uses_type: usesType,
            units: 1,
            cycles: 1,
            cycle_number: null,
            cycle_unit: null,
            type: showTypeSelect ? null : undefined
        });
    };
    const handleChangeCycle = async (cycleLabel)=>{
        const [cycle_number, cycle_unit] = cycleLabel.split(' ');
        await updateUsage({
            cycle_number: cycle_number,
            cycle_unit: cycle_unit,
            type: showTypeSelect ? null : undefined,
            audio_made_move: null,
            market_spec: null
        });
    };
    const handleChangeAudioMadeMove = async (audioMadeMove)=>{
        await updateUsage({
            audio_made_move: audioMadeMove,
            type: null
        });
    };
    const handleChangeMarket = async (market)=>{
        await updateUsage({
            market_spec: market,
            type: null
        });
    };
    const handleChangeType = async (type)=>{
        await updateUsage({
            type: type
        });
    };
    const handleChangeUses = async (unitCount)=>{
        const units = parseInt(unitCount);
        if (units > 0) await updateUsage({
            units: units
        });
    };
    const handleChangeCycles = async (cycleCount)=>{
        const cycles = parseInt(cycleCount);
        if (cycles > 0) await updateUsage({
            cycles: cycles
        });
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        if (usageEstimateItems) {
            let newWages = 0;
            let newTotal = 0;
            if (usage.type) for (const item of usageEstimateItems){
                newWages += item.subtotal;
                newTotal += item.subtotal_plus_fringe;
            }
            if (newWages !== wages) setWages(newWages);
            if (newTotal !== total) setTotal(newTotal);
        }
    }, [
        usage,
        usageEstimateItems
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (matchingTypeInfos?.length > 1) {
            const markets = [];
            for (const info of matchingTypeInfos)if (info.marketSpec) markets.push(info.marketSpec);
            setUsageMarkets(markets);
        }
    }, [
        matchingTypeInfos
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
        direction: "row",
        gap: "small",
        align: "center",
        pad: "small",
        border: rowIndex > 0 && {
            side: 'top',
            color: 'light-3'
        },
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "48px",
                height: "48px",
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gpKeH.CheckBox), {
                    onChange: onChecked,
                    checked: checked
                })
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                width: "75%",
                direction: "row",
                align: "center",
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "14rem",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hgBnK.SelectMultiple), {
                            options: roles ?? [],
                            value: usage.roles?.reduce((acc, curr)=>curr.role_group ? acc : acc.concat(curr), []),
                            valueKey: "id",
                            labelKey: "name",
                            placeholder: "Choose roles...",
                            size: "medium",
                            onChange: ({ value: value })=>updateUsage({
                                    roles: value
                                }),
                            showSelectedInline: true,
                            icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                    children: "Choose Roles"
                                }),
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {})
                            }),
                            valueLabel: (values)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                                    wrap: true,
                                    justify: "center",
                                    pad: {
                                        vertical: 'xxsmall'
                                    },
                                    children: values && values.length ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {
                                        children: values.map((role)=>{
                                            const payScalePercent = role.performer?.contracts[role.performer.contracts.length - 1].compensation[0].percentOfScale;
                                            return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                                direction: "row",
                                                align: "center",
                                                justify: "between",
                                                pad: {
                                                    horizontal: 'small'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                        size: "small",
                                                        children: role.name
                                                    }),
                                                    (payScalePercent ?? 0) > 100 && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
                                                        content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                                            children: `Performer receives ${payScalePercent}% of scale.`
                                                        }),
                                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eJdPk.Tag), {
                                                            size: "14"
                                                        })
                                                    })
                                                ]
                                            }, role.id);
                                        })
                                    }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        color: "text-weak",
                                        children: "Select Roles"
                                    })
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "13rem",
                        children: usagePlatforms && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            options: usagePlatforms,
                            size: "small",
                            value: usage.platform ?? '',
                            onChange: ({ value: value })=>handleChangePlatform(value),
                            placeholder: "Select Platform"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "15rem",
                        children: usage.platform && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            options: usageCategories ?? [],
                            size: "small",
                            value: usage.category ?? '',
                            onChange: ({ value: value })=>handleChangeCategory(value),
                            placeholder: "Select Category"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "13%",
                        children: usage.platform && usage.category && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            options: usageUsesTypes ?? [],
                            value: usage.uses_type ?? '',
                            size: "small",
                            onChange: ({ value: value })=>{
                                handleChangeUsesType(value);
                            },
                            placeholder: "Select Uses"
                        })
                    }),
                    usage.uses_type && usageCycleTypes && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "8.5rem",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            direction: "row",
                            align: "center",
                            gap: "xsmall",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                                options: usageCycleTypes ?? [],
                                value: usageCycleType ?? '',
                                size: "small",
                                onChange: ({ value: value })=>handleChangeCycle(value),
                                placeholder: "Select Cycle"
                            })
                        })
                    }),
                    showTypeSelect && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "15%",
                        direction: "row",
                        align: "center",
                        gap: "xsmall",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            options: matchingTypeInfos?.map((info)=>({
                                    label: info.label,
                                    value: info.id
                                })) ?? [],
                            labelKey: "label",
                            valueKey: "value",
                            value: usage.type ?? '',
                            size: "small",
                            onChange: ({ value: value })=>handleChangeType(value.value),
                            placeholder: "Select Type"
                        })
                    }),
                    showAudioMadeMoveSelect && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "12rem",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            options: Object.values((0, $4AdaL.AudioMadeMove)),
                            size: "small",
                            value: usage.audio_made_move ?? '',
                            onChange: ({ value: value })=>handleChangeAudioMadeMove(value),
                            placeholder: "Select Audio Use"
                        })
                    }),
                    showMarketSelect && !!usageMarkets?.length && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                        width: "12rem",
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
                            options: usageMarkets ?? [],
                            valueKey: "value",
                            labelKey: "label",
                            size: "small",
                            value: usage.market_spec ?? '',
                            onChange: ({ value: value })=>handleChangeMarket(value),
                            placeholder: "Select Market"
                        })
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        children: [
                            showUsesInput && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                width: "8rem",
                                direction: "row",
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        val: usage.units,
                                        inputType: "number",
                                        minValue: 1,
                                        placeholder: "Uses",
                                        onChange: (uses)=>handleChangeUses(uses)
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Uses"
                                    })
                                ]
                            }),
                            showCyclesInput && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                                width: "9rem",
                                direction: "row",
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bIzid.TalonInput), {
                                        val: usage.cycles,
                                        inputType: "number",
                                        minValue: 1,
                                        placeholder: "Cycles",
                                        onChange: (cycles)=>handleChangeCycles(cycles)
                                    }),
                                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                        children: "Cycles"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                flex: true
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                justify: "end",
                pad: {
                    vertical: 'xsmall'
                },
                gap: "large",
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        justify: "end",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "WAGES:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: 500,
                                children: (0, $b1rqt.USD)(wages)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        direction: "row",
                        gap: "xsmall",
                        justify: "end",
                        align: "center",
                        width: "10rem",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                children: "TOTAL:"
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                weight: 500,
                                children: (0, $b1rqt.USD)(total)
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("b9Fv4", function(module, exports) {

$parcel$export(module.exports, "UsageTypeSelect", () => $b238cc9638a898e8$export$8116c54f0cda5e36);

var $6ir3O = parcelRequire("6ir3O");

var $fjut3 = parcelRequire("fjut3");

var $fdtj0 = parcelRequire("fdtj0");
var $kS7Ii = parcelRequire("kS7Ii");

var $jK3Kk = parcelRequire("jK3Kk");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $d2VmQ = parcelRequire("d2VmQ");
const $b238cc9638a898e8$export$8116c54f0cda5e36 = (0, $j8yBr.observer)(({ commercialType: commercialType, val: val, onChange: onChange, id: id = 'usage-type', name: name = 'usage-type', dropAlign: dropAlign })=>{
    const defaultOptions = commercialType ? (0, $fjut3.commercialUsageTypes)[commercialType] : Object.values((0, $fjut3.UsageType));
    /** State **/ const [filteredOptions, setFilteredOptions] = (0, $2NacA.useState)(defaultOptions);
    /** Methods **/ const filterTypes = (query)=>{
        if (query === '') {
            setFilteredOptions(defaultOptions);
            return;
        }
        const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
        const filtered = defaultOptions.filter((t)=>exp.test(t));
        setFilteredOptions(filtered);
    };
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fdtj0.Select), {
        options: filteredOptions,
        value: val,
        size: "small",
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "Choose Activity Type"
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jK3Kk.DocumentVideo), {})
        }),
        placeholder: "Choose...",
        searchPlaceholder: "Search types...",
        onSearch: (query)=>filterTypes(query),
        onChange: ({ value: value })=>onChange(value),
        onBlur: ()=>setFilteredOptions(defaultOptions),
        id: id,
        name: name,
        dropAlign: dropAlign
    });
});

});




parcelRegister("dvy4k", function(module, exports) {

$parcel$export(module.exports, "UserMenu", () => $1e7f5ef742259a3b$export$72d0b49a56703654);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $jcqM0 = parcelRequire("jcqM0");
var $5xcHk = parcelRequire("5xcHk");
var $408pd = parcelRequire("408pd");
var $kS7Ii = parcelRequire("kS7Ii");

var $7kMct = parcelRequire("7kMct");
var $bqfBA = parcelRequire("bqfBA");
var $9LyYE = parcelRequire("9LyYE");
var $dmh5A = parcelRequire("dmh5A");
var $jKSDY = parcelRequire("jKSDY");
var $9HK6v = parcelRequire("9HK6v");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $6yQ9k = parcelRequire("6yQ9k");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $bsB3E = parcelRequire("bsB3E");

var $fsUjP = parcelRequire("fsUjP");
const $1e7f5ef742259a3b$export$72d0b49a56703654 = (0, $j8yBr.observer)(({ textColor: textColor = 'accent-1' })=>{
    const userStore = (0, $8DltC.useUserStore)();
    const navigate = (0, $19GAm.useNavigate)();
    const location = (0, $19GAm.useLocation)();
    const posthog = (0, $6yQ9k.usePostHog)();
    const [apiRelease, setApiRelease] = (0, $2NacA.useState)(null);
    (0, $2NacA.useEffect)(()=>{
        (0, $fsUjP.fetchApiRelease)().then(setApiRelease);
    }, []);
    const doLogout = ()=>{
        userStore.logout();
        posthog.reset();
        navigate('/login');
    };
    const profile = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "Profile"
            })
        }),
        onClick: ()=>navigate('/profile'),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dmh5A.User), {})
        }),
        justify: 'start',
        active: location.pathname === '/profile'
    };
    const account = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: "Account"
        }),
        onClick: ()=>navigate('/account'),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9LyYE.Organization), {})
        }),
        justify: 'start',
        active: location.pathname === '/account'
    };
    const logout = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: "Logout"
        }),
        onClick: ()=>doLogout(),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bqfBA.Logout), {})
        }),
        color: 'accent-1',
        justify: 'start'
    };
    const adminMenu = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: "Admin"
        }),
        onClick: ()=>navigate('/admin'),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jKSDY.UserAdmin), {})
        }),
        color: 'accent-1',
        justify: 'start',
        active: location.pathname === '/admin'
    };
    // The admin area has its own header without the regular app's navigation; this is the way back
    const appMenu = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: "Talon app"
        }),
        onClick: ()=>navigate('/'),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7kMct.Home), {})
        }),
        justify: 'start'
    };
    // const payrollMenu: ButtonExtendedProps = {
    //   label: <Box alignSelf="center">Payroll</Box>,
    //   onClick: () => navigate('/payroll'),
    //   icon: (
    //     <Box pad="small">
    //       <Money />
    //     </Box>
    //   ),
    //   color: 'accent-1',
    //   justify: 'start',
    //   active: location.pathname === '/payroll',
    // };
    const tmProfile = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "My TM Profile"
            })
        }),
        onClick: ()=>navigate('/talent-manager'),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9HK6v.UserExpert), {})
        }),
        justify: 'start',
        active: location.pathname === '/talent-manager'
    };
    const supportInboxMenu = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "Support Inbox"
            })
        }),
        onClick: ()=>navigate('/support-inbox'),
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            pad: "small",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9HK6v.UserExpert), {})
        }),
        justify: 'start',
        active: location.pathname === '/support-inbox'
    };
    // Which web + API builds this user is running, so a bug report can say exactly what was live
    const buildInfo = {
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            alignSelf: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                size: "xsmall",
                color: "light-6",
                children: (0, $fsUjP.formatBuildLabel)((0, $fsUjP.WEB_RELEASE), apiRelease)
            })
        }),
        onClick: ()=>{
            navigator.clipboard?.writeText(`web ${(0, $fsUjP.WEB_RELEASE)} api ${apiRelease ?? 'unknown'}`).then(()=>(0, $bsB3E.toast).info('Build info copied'));
        },
        justify: 'start'
    };
    const menuItems = userStore.user?.is_admin ? [
        adminMenu,
        appMenu,
        profile,
        account,
        logout
    ] // admin
     : userStore.user.performer_id ? [
        profile,
        logout
    ] // performer user
     : userStore.user.is_talent_manager ? [
        tmProfile,
        logout
    ] // talent manager
     : [
        profile,
        account,
        logout
    ]; // agency user
    // Support Inbox is its own route (not a tab under /admin) so both admins and non-admin support
    // agents need a direct link to it, regardless of which role bucket they otherwise fall into above.
    if (userStore.user?.is_admin || userStore.user?.is_support_agent) menuItems.unshift(supportInboxMenu);
    menuItems.push(buildInfo);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $408pd.Menu), {
            justifyContent: "center",
            dropBackground: "dark-1",
            icon: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                align: "center",
                justify: "center",
                wrap: true,
                gap: "xsmall",
                pad: {
                    vertical: '3px'
                },
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $jcqM0.Avatar), {
                        background: "accent-2",
                        size: "42px",
                        children: [
                            userStore.user?.first_name?.substring(0, 1),
                            userStore.user?.last_name?.substring(0, 1)
                        ]
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                color: textColor,
                                children: `${userStore.user?.first_name} ${userStore.user?.last_name}`
                            }),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "small",
                                weight: 300,
                                color: textColor,
                                children: userStore.user?.active_group ? (0, $9Rhqc.capitalize)(userStore.user?.active_group?.name) : ''
                            })
                        ]
                    })
                ]
            }),
            items: menuItems
        })
    });
});

});
parcelRegister("jcqM0", function(module, exports) {

$parcel$export(module.exports, "Avatar", () => $dfa3e7f044ece2d3$export$e2255cf6045e8d47);

var $2NacA = parcelRequire("2NacA");

var $jmzyn = parcelRequire("jmzyn");

var $jcu1M = parcelRequire("jcu1M");

var $90Fwv = parcelRequire("90Fwv");

var $eL6w3 = parcelRequire("eL6w3");
var $dfa3e7f044ece2d3$var$_excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "children",
    "height",
    "imageProps",
    "justify",
    "round",
    "size",
    "src",
    "width"
];
function $dfa3e7f044ece2d3$var$_extends() {
    return $dfa3e7f044ece2d3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dfa3e7f044ece2d3$var$_extends.apply(null, arguments);
}
function $dfa3e7f044ece2d3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $dfa3e7f044ece2d3$export$e2255cf6045e8d47 = function Avatar(_ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, children = _ref.children, height = _ref.height, imageProps = _ref.imageProps, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, _ref$round = _ref.round, round = _ref$round === void 0 ? 'full' : _ref$round, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, src = _ref.src, width = _ref.width, rest = $dfa3e7f044ece2d3$var$_objectWithoutPropertiesLoose(_ref, $dfa3e7f044ece2d3$var$_excluded);
    var _useThemeValue = (0, $eL6w3.useThemeValue)(), theme = _useThemeValue.theme, passThemeFlag = _useThemeValue.passThemeFlag;
    var avatarSize = theme.avatar.size[size] || size;
    var avatarTextSize = theme.avatar.text.size[size] || 'large';
    var avatarProps = (0, $2NacA.useMemo)(function() {
        return {
            align: align,
            height: avatarSize,
            justify: justify,
            overflow: 'hidden',
            round: round,
            width: avatarSize
        };
    }, [
        align,
        avatarSize,
        justify,
        round
    ]);
    var AvatarChildren = (0, $2NacA.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jcu1M.StyledAvatar), $dfa3e7f044ece2d3$var$_extends({}, avatarProps, rest), children);
    }, [
        avatarProps,
        children,
        rest
    ]);
    if (height || width) console.warn('Avatar should use `size` instead of `height` or `width` props');
    var content;
    if (typeof children === 'string') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jcu1M.StyledAvatarText), $dfa3e7f044ece2d3$var$_extends({
        alignSelf: "center",
        size: avatarTextSize
    }, passThemeFlag), children);
    else if (typeof src === 'string') content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jmzyn.Image), $dfa3e7f044ece2d3$var$_extends({
        role: "presentation",
        fit: "contain",
        src: src
    }, imageProps));
    if (typeof children === 'string' || typeof src === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jcu1M.StyledAvatar), $dfa3e7f044ece2d3$var$_extends({
        role: typeof src === 'string' ? 'figure' : undefined,
        a11yTitle: a11yTitle || ariaLabel
    }, avatarProps, passThemeFlag, rest), content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement(AvatarChildren, null);
};
$dfa3e7f044ece2d3$export$e2255cf6045e8d47.propTypes = (0, $90Fwv.AvatarPropTypes);

});
parcelRegister("jcu1M", function(module, exports) {

$parcel$export(module.exports, "StyledAvatarText", () => $dfa66e3327ffbe5e$export$347ff640deb5f69a);
$parcel$export(module.exports, "StyledAvatar", () => $dfa66e3327ffbe5e$export$f9c8934f7fa064f8);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $5xcHk = parcelRequire("5xcHk");

var $kS7Ii = parcelRequire("kS7Ii");
var $dfa66e3327ffbe5e$export$347ff640deb5f69a = (0, $f5efw.default)((0, $kS7Ii.Text)).withConfig({
    displayName: "StyledAvatar__StyledAvatarText",
    componentId: "sc-1suyamb-0"
})([
    "",
    " ",
    ""
], function(props) {
    return props.theme.avatar && props.theme.avatar.text && props.theme.avatar.text.fontWeight && "font-weight: " + props.theme.avatar.text.fontWeight + ";";
}, function(props) {
    return props.theme.avatar.text && props.theme.avatar.text.extend;
});
var $dfa66e3327ffbe5e$export$f9c8934f7fa064f8 = (0, $f5efw.default)((0, $5xcHk.Box)).withConfig({
    displayName: "StyledAvatar",
    componentId: "sc-1suyamb-1"
})([
    "",
    ""
], function(props) {
    return props.theme.avatar && props.theme.avatar.extend;
});

});

parcelRegister("90Fwv", function(module, exports) {

$parcel$export(module.exports, "AvatarPropTypes", () => $68f452d3ed66c9a0$export$d8bb67314afc20d6);
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $68f452d3ed66c9a0$var$PropType = {};
var $68f452d3ed66c9a0$export$d8bb67314afc20d6 = $68f452d3ed66c9a0$var$PropType;

});


parcelRegister("9LyYE", function(module, exports) {

$parcel$export(module.exports, "Organization", () => $71c3a29c18c04d9c$export$f3a6aa388b70f149);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $71c3a29c18c04d9c$var$_extends() {
    return $71c3a29c18c04d9c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $71c3a29c18c04d9c$var$_extends.apply(null, arguments);
}
var $71c3a29c18c04d9c$export$f3a6aa388b70f149 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $71c3a29c18c04d9c$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Organization"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 3v20H4V3h16zM8.042 9h2V7h-2v2zM14 9h2V7h-2v2zm-5.958 6h2v-2h-2v2zm2 8h4v-4h-4v4zM14 15h2v-2h-2v2zM2 3h20V1H2v2z"
    }));
});
$71c3a29c18c04d9c$export$f3a6aa388b70f149.displayName = 'Organization';

});

parcelRegister("jKSDY", function(module, exports) {

$parcel$export(module.exports, "UserAdmin", () => $e61cb3507bc542c3$export$c3e1ca01f11b1d01);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $e61cb3507bc542c3$var$_extends() {
    return $e61cb3507bc542c3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e61cb3507bc542c3$var$_extends.apply(null, arguments);
}
var $e61cb3507bc542c3$export$c3e1ca01f11b1d01 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $e61cb3507bc542c3$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserAdmin"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10zm5.023 2.023C11.772 11.76 10.013 11 8 11c-4 0-7 3-7 7v5h7m2-3.5a2.5 2.5 0 1 0 5.002-.002A2.5 2.5 0 0 0 10 19.5zM23 15l-3-3-6 6m3.5-3.5 3 3-3-3z"
    }));
});
$e61cb3507bc542c3$export$c3e1ca01f11b1d01.displayName = 'UserAdmin';

});



parcelRegister("jDV21", function(module, exports) {

$parcel$export(module.exports, "Layout", () => $5940713e751bebc2$export$c84671f46d6a1ca);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $cpdVK = parcelRequire("cpdVK");
var $g1XKJ = parcelRequire("g1XKJ");
var $5ebSC = parcelRequire("5ebSC");
parcelRequire("ibR9R");
var $eHq6M = parcelRequire("eHq6M");

var $1KFDr = parcelRequire("1KFDr");

var $lhwHv = parcelRequire("lhwHv");
const $5940713e751bebc2$export$c84671f46d6a1ca = ({ children: children })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $g1XKJ.Grid), {
        height: {
            min: '100vh',
            max: '100vh'
        },
        rows: [
            'auto',
            'auto',
            'flex',
            'auto'
        ],
        columns: [
            'auto',
            'flex'
        ],
        areas: [
            {
                name: 'header',
                start: [
                    0,
                    0
                ],
                end: [
                    1,
                    0
                ]
            },
            {
                name: 'banner',
                start: [
                    0,
                    1
                ],
                end: [
                    1,
                    1
                ]
            },
            {
                name: 'main',
                start: [
                    0,
                    2
                ],
                end: [
                    1,
                    2
                ]
            },
            {
                name: 'footer',
                start: [
                    0,
                    3
                ],
                end: [
                    1,
                    3
                ]
            }
        ],
        gap: "none",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5ebSC.Header), {
                gridArea: "header",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lhwHv.HeaderNav), {})
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                gridArea: "banner",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eHq6M.ImpersonationBanner), {})
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                gridArea: "main",
                background: "background-back",
                overflow: "auto",
                pad: {
                    bottom: '110px'
                },
                children: children
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $cpdVK.Footer), {
                gridArea: "footer",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1KFDr.FooterNav), {})
            })
        ]
    });
};

});
parcelRegister("lhwHv", function(module, exports) {

$parcel$export(module.exports, "HeaderNav", () => $58a60cb53eea67e5$export$50d7b5e01df871ca);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $a26J5 = parcelRequire("a26J5");
var $5erKi = parcelRequire("5erKi");
var $hp1AK = parcelRequire("hp1AK");
var $4zRSZ = parcelRequire("4zRSZ");
var $kS7Ii = parcelRequire("kS7Ii");

var $1QpFO = parcelRequire("1QpFO");
var $7kMct = parcelRequire("7kMct");
var $bswlW = parcelRequire("bswlW");
var $9HK6v = parcelRequire("9HK6v");

var $7XZ9N = parcelRequire("7XZ9N");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");
parcelRequire("6Si8o");
var $7Be7l = parcelRequire("7Be7l");
var $53A4k = parcelRequire("53A4k");
var $eNwZA = parcelRequire("eNwZA");
parcelRequire("ibR9R");
var $aPSJv = parcelRequire("aPSJv");

var $2u4SD = parcelRequire("2u4SD");

var $dvy4k = parcelRequire("dvy4k");
const $58a60cb53eea67e5$export$50d7b5e01df871ca = (0, $j8yBr.observer)(()=>{
    /** Context **/ const userStore = (0, $8DltC.useUserStore)();
    const navigate = (0, $19GAm.useNavigate)();
    const size = (0, $2NacA.useContext)((0, $4zRSZ.ResponsiveContext));
    const isSmall = size === 'small';
    /** State **/ const [menuOpen, setMenuOpen] = (0, $2NacA.useState)(false);
    const homeRoute = userStore.user?.performer_id ? '/performer-home' : userStore.user?.is_talent_manager ? '/talent-manager' : '/';
    const logo = /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
        as: (0, $a26J5.Button),
        onClick: ()=>navigate(homeRoute),
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
            direction: "row",
            gap: "xsmall",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    justify: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7XZ9N.default), {
                        width: "40",
                        height: "40"
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                    margin: {
                        bottom: '2px'
                    },
                    direction: "row",
                    align: "center",
                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                        weight: 400,
                        style: {
                            letterSpacing: '0.2rem'
                        },
                        children: "TALON"
                    })
                })
            ]
        })
    });
    // Everything below the logo that isn't a single icon button — the project/agency mega-menu,
    // the performer's and talent manager's own nav links, the quick estimator, and the user menu.
    // On a full-width header these sit in a row; at phone width they'd overlap into an illegible
    // pile (the header used to do exactly that), so on `small` they're stacked in a slide-out
    // drawer instead.
    // accent-1 (white) is meant for the blue header bar — on the drawer's light background it
    // would be invisible, so these get a dark color explicitly when rendered there.
    const linkColor = isSmall ? 'text' : 'accent-1';
    const navLinks = /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
        children: [
            userStore.user?.is_talent_manager && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $53A4k.AnchorLink), {
                to: '/talent-manager',
                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    color: linkColor,
                    children: "My Dashboard"
                }),
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $9HK6v.UserExpert), {
                    size: "20",
                    color: linkColor
                }),
                alignSelf: "center"
            }),
            userStore.user?.id && !userStore.user?.performer_id && /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: isSmall ? 'column' : 'row',
                gap: "medium",
                align: isSmall ? 'start' : 'center',
                children: [
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $eNwZA.ProjectSelector), {
                        textColor: linkColor
                    }),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7Be7l.AgencyMenus), {
                        textColor: linkColor,
                        iconColor: linkColor
                    })
                ]
            }),
            userStore.user?.performer_id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $53A4k.AnchorLink), {
                to: '/performer-home',
                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    color: linkColor,
                    children: "My Commercials"
                }),
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7kMct.Home), {
                    size: "20",
                    color: linkColor
                }),
                alignSelf: "center"
            })
        ]
    });
    if (isSmall) return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hp1AK.Nav), {
        direction: "row",
        background: {
            color: 'brand-gradient',
            dark: true
        },
        style: {
            background: 'var(--brand-gradient)',
            zIndex: 2
        },
        fill: "horizontal",
        height: "72px",
        justify: "between",
        pad: {
            horizontal: 'small'
        },
        align: "center",
        elevation: "small",
        children: [
            logo,
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                align: "center",
                children: [
                    userStore.user?.id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aPSJv.NotificationsMenu), {}),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bswlW.Menu), {
                            color: "white"
                        }),
                        onClick: ()=>setMenuOpen(true),
                        a11yTitle: "Open menu",
                        plain: true
                    })
                ]
            }),
            menuOpen && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5erKi.Layer), {
                position: "right",
                full: "vertical",
                onEsc: ()=>setMenuOpen(false),
                onClickOutside: ()=>setMenuOpen(false),
                children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                    width: "min(85vw, 340px)",
                    height: "100%",
                    background: "light-1",
                    pad: "medium",
                    gap: "medium",
                    overflow: "auto",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            direction: "row",
                            justify: "end",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $a26J5.Button), {
                                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $1QpFO.Close), {}),
                                onClick: ()=>setMenuOpen(false),
                                a11yTitle: "Close menu",
                                plain: true
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            gap: "medium",
                            children: navLinks
                        }),
                        userStore.user?.active_group && // QuickEstimatorMenu's icon is hardcoded white for the blue header bar — give it
                        // a matching chip here instead, rather than reworking a shared component's colors.
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            background: "brand",
                            round: "small",
                            width: "40px",
                            height: "40px",
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2u4SD.QuickEstimatorMenu), {})
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dvy4k.UserMenu), {
                            textColor: "text"
                        })
                    ]
                })
            })
        ]
    });
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $hp1AK.Nav), {
        direction: "row",
        background: {
            color: 'brand-gradient',
            dark: true
        },
        style: {
            background: 'var(--brand-gradient)',
            zIndex: 2
        },
        fill: "horizontal",
        flex: "grow",
        height: "94px",
        justify: "between",
        pad: {
            horizontal: 'medium'
        },
        align: "center",
        elevation: "small",
        children: [
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                width: "10%",
                children: logo
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                flex: true
            }),
            navLinks,
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                flex: true
            }),
            /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                direction: "row",
                gap: "small",
                justify: "end",
                align: "center",
                flex: "grow",
                children: [
                    userStore.user?.active_group && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2u4SD.QuickEstimatorMenu), {}),
                    userStore.user?.id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $aPSJv.NotificationsMenu), {}),
                    /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dvy4k.UserMenu), {})
                ]
            })
        ]
    });
});

});
parcelRegister("bswlW", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $857b67d9275e136e$export$d9b273488cd8ce6f);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $857b67d9275e136e$var$_extends() {
    return $857b67d9275e136e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $857b67d9275e136e$var$_extends.apply(null, arguments);
}
var $857b67d9275e136e$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $857b67d9275e136e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Menu"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 19h20M2 5h20M2 12h20"
    }));
});
$857b67d9275e136e$export$d9b273488cd8ce6f.displayName = 'Menu';

});

parcelRegister("6Si8o", function(module, exports) {
$parcel$export(module.exports, "AgencyMenus", () => (parcelRequire("7Be7l")).AgencyMenus);
$parcel$export(module.exports, "AnchorLink", () => (parcelRequire("53A4k")).AnchorLink);
$parcel$export(module.exports, "ProjectSelector", () => (parcelRequire("eNwZA")).ProjectSelector);
parcelRequire("7Be7l");
parcelRequire("53A4k");
parcelRequire("1KFDr");
parcelRequire("lhwHv");
parcelRequire("dCyoA");
parcelRequire("eNwZA");
parcelRequire("dvy4k");

});
parcelRegister("7Be7l", function(module, exports) {

$parcel$export(module.exports, "AgencyMenus", () => $bc0d4dccd910904a$export$dbb3912da585d824);

var $6ir3O = parcelRequire("6ir3O");

var $8DltC = parcelRequire("8DltC");

var $kS7Ii = parcelRequire("kS7Ii");

var $dij1X = parcelRequire("dij1X");
var $gyf5K = parcelRequire("gyf5K");
var $fnXSK = parcelRequire("fnXSK");
var $7kMct = parcelRequire("7kMct");
var $jRjUr = parcelRequire("jRjUr");
var $dlbdu = parcelRequire("dlbdu");
var $bhoi7 = parcelRequire("bhoi7");

var $9Rhqc = parcelRequire("9Rhqc");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $53A4k = parcelRequire("53A4k");

var $dCyoA = parcelRequire("dCyoA");
const $bc0d4dccd910904a$export$dbb3912da585d824 = (0, $j8yBr.observer)(({ textColor: textColor = 'accent-1', iconColor: iconColor = 'accent-1' })=>{
    /** Context **/ const navigate = (0, $19GAm.useNavigate)();
    const projectStore = (0, $8DltC.useProjectStore)();
    /** State **/ const projectPath = (0, $2NacA.useMemo)(()=>`/project/${(0, $9Rhqc.kebabCase)(projectStore.currentProject?.name)}`, [
        projectStore.currentProject
    ]);
    const iconSize = '22px';
    /** Render **/ const menuItemLinks = {
        'pre-pro': [
            {
                label: 'Project Home',
                onClick: ()=>navigate(projectPath),
                id: '/project'
            },
            {
                label: 'Session Estimator',
                onClick: ()=>navigate(`${projectPath}/session-estimator`),
                id: '/session-estimator'
            },
            {
                label: 'Usage Estimator',
                onClick: ()=>navigate(`${projectPath}/usage-estimator`),
                id: '/usage-estimator'
            },
            {
                label: 'Estimates',
                onClick: ()=>navigate(`${projectPath}/estimate`),
                id: '/estimate'
            }
        ],
        production: [
            {
                label: 'Licensing & Rights',
                onClick: ()=>navigate(`${projectPath}/licensing-rights`),
                id: '/licensing-rights'
            },
            {
                label: 'Hire Talent',
                onClick: ()=>navigate(`${projectPath}/hire-talent`),
                id: '/hire-talent'
            },
            {
                label: 'Time Tracking',
                onClick: ()=>navigate(`${projectPath}/time-tracking`),
                id: '/time-tracking'
            },
            {
                label: 'Pay Sessions',
                onClick: ()=>navigate(`${projectPath}/pay-sessions`),
                id: '/pay-sessions'
            },
            {
                label: 'Talent Manager',
                onClick: ()=>navigate(`${projectPath}/talent-manager`),
                id: '/talent-manager'
            },
            {
                label: 'Holding Fees',
                onClick: ()=>navigate(`${projectPath}/holding-fees`),
                id: '/holding-fees'
            }
        ],
        'post-production': [
            {
                label: 'Edits & Final Cast',
                onClick: ()=>navigate(`${projectPath}/edits`),
                id: '/edits'
            },
            // { label: 'Pay Residuals', onClick: () => navigate(`${projectPath}/pay-residuals`), id: '/pay-residuals' },
            // {
            //   label: 'Commercial History',
            //   onClick: () => navigate(`${projectPath}/commercial-history`),
            //   id: '/commercial-history',
            // },
            {
                label: 'Asset Library',
                onClick: ()=>navigate(`${projectPath}/asset-library`),
                id: '/asset-library'
            }
        ]
    };
    const menuItems = Object.entries(menuItemLinks).map(([key, items])=>({
            label: (0, $9Rhqc.startCase)(key.replaceAll(/-/g, ' ')),
            icon: key === 'pre-pro' ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $7kMct.Home), {
                size: iconSize,
                color: iconColor
            }) : key === 'production' ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bhoi7.Video), {
                size: iconSize,
                color: iconColor
            }) : key === 'post-production' ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dij1X.Channel), {
                size: iconSize,
                color: iconColor
            }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $gyf5K.DocumentText), {
                size: iconSize,
                color: iconColor
            }),
            items: items.map((item)=>({
                    ...item,
                    color: location.pathname === item.id ? 'accent-3' : 'text'
                }))
        }));
    return /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $6ir3O.Fragment), {
        children: [
            projectStore.currentProject?.name && menuItems.map((menu)=>/*#__PURE__*/ (0, $6ir3O.jsx)((0, $dCyoA.MenuWithChildren), {
                    label: menu.label,
                    icon: menu.icon,
                    items: menu.items
                }, menu.label)),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $53A4k.AnchorLink), {
                to: '/performers',
                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "1rem",
                    weight: 500,
                    color: textColor,
                    children: "Performers"
                }),
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $fnXSK.Group), {
                    size: iconSize,
                    color: iconColor
                }),
                alignSelf: "center"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $53A4k.AnchorLink), {
                to: '/marketplace',
                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "1rem",
                    weight: 500,
                    color: textColor,
                    children: "Marketplace"
                }),
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $dlbdu.UserManager), {
                    size: iconSize,
                    color: iconColor
                }),
                alignSelf: "center"
            }),
            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $53A4k.AnchorLink), {
                to: '/resources',
                label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                    size: "1rem",
                    weight: 500,
                    color: textColor,
                    children: "Resources"
                }),
                icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jRjUr.Resources), {
                    size: iconSize,
                    color: iconColor
                }),
                alignSelf: "center"
            })
        ]
    });
});

});
parcelRegister("dlbdu", function(module, exports) {

$parcel$export(module.exports, "UserManager", () => $9b65efe35e72ecd2$export$4c4d82ee86d9366d);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $9b65efe35e72ecd2$var$_extends() {
    return $9b65efe35e72ecd2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9b65efe35e72ecd2$var$_extends.apply(null, arguments);
}
var $9b65efe35e72ecd2$export$4c4d82ee86d9366d = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $9b65efe35e72ecd2$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserManager"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 12c2.374 1.183 4 3.65 4 7v4H4v-4c0-3.354 1.631-5.825 4-7m4 1a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm6-6c-1.5 0-3 .36-5-2-2 2.36-4.5 3-7 2m1 6 5.025 5.257L17 13m-5 5v5"
    }));
});
$9b65efe35e72ecd2$export$4c4d82ee86d9366d.displayName = 'UserManager';

});

parcelRegister("53A4k", function(module, exports) {

$parcel$export(module.exports, "AnchorLink", () => $66cc04ce06fbe548$export$67abef37aa2929b0);

var $6ir3O = parcelRequire("6ir3O");

var $j0B9N = parcelRequire("j0B9N");
var $a26J5 = parcelRequire("a26J5");
parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");
const $66cc04ce06fbe548$export$67abef37aa2929b0 = (props)=>{
    const navigate = (0, $19GAm.useNavigate)();
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
        as: (0, $a26J5.Button),
        ...props,
        onClick: ()=>navigate(props.to)
    });
};

});

parcelRegister("dCyoA", function(module, exports) {

$parcel$export(module.exports, "MenuWithChildren", () => $07b886b74ef12312$export$6a7c0f9d2be0ffa8);

var $6ir3O = parcelRequire("6ir3O");

var $j0B9N = parcelRequire("j0B9N");
var $5xcHk = parcelRequire("5xcHk");
var $408pd = parcelRequire("408pd");
var $kS7Ii = parcelRequire("kS7Ii");
const $07b886b74ef12312$export$6a7c0f9d2be0ffa8 = ({ label: label, items: items, icon: icon, textColor: textColor, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $408pd.Menu), {
        plain: true,
        items: items,
        icon: icon,
        label: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
            color: textColor,
            children: label
        }),
        dropProps: {
            a11yTitle: label,
            gap: 'small',
            pad: 'small',
            background: 'dark-1'
        },
        disabled: disabled,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $j0B9N.Anchor), {
            children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                pad: "medium",
                direction: "row",
                gap: "small",
                align: "center",
                children: [
                    icon,
                    /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                        size: "1rem",
                        weight: 500,
                        color: textColor,
                        children: [
                            ' ',
                            label
                        ]
                    })
                ]
            })
        })
    });
};

});


parcelRegister("eNwZA", function(module, exports) {

$parcel$export(module.exports, "ProjectSelector", () => $dc76ae06f8839e83$export$a764642e4b725728);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $kS7Ii = parcelRequire("kS7Ii");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $8DltC = parcelRequire("8DltC");

var $fMm8B = parcelRequire("fMm8B");
parcelRequire("ibR9R");
var $l3pMM = parcelRequire("l3pMM");
var $d2VmQ = parcelRequire("d2VmQ");

var $lhDdJ = parcelRequire("lhDdJ");
const $dc76ae06f8839e83$export$a764642e4b725728 = (0, $j8yBr.observer)(({ textColor: textColor = 'accent-1' })=>{
    /** Context **/ const navigate = (0, $19GAm.useNavigate)();
    const location = (0, $19GAm.useLocation)();
    const projectStore = (0, $8DltC.useProjectStore)();
    const userStore = (0, $8DltC.useUserStore)();
    /** State **/ const [projectList, setProjectList] = (0, $2NacA.useState)(projectStore.projectList);
    const [favorites, setFavorites] = (0, $2NacA.useState)([]);
    /** Methods **/ // Only the user's choice here navigates, and only to keep a project page's URL naming the
    // project shown (ProjectRoute selects the project a URL names). This used to run whenever the
    // current project changed for any reason, sending the user to the project's home page each time
    const selectProject = (projectId)=>{
        if (projectId === projectStore.currentProject?.id) return;
        const project = projectStore.setCurrentProjectId(projectId);
        const path = project && (0, $fMm8B.pathForProjectSwitch)(location.pathname, project.name);
        if (path) navigate(path);
    };
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        const getProjects = async ()=>{
            await projectStore.fetchProjectList();
        };
        getProjects();
    }, [
        projectStore
    ]);
    (0, $2NacA.useEffect)(()=>{
        const favs = projectStore.projectList?.filter((p)=>userStore.user?.favorite_project_ids?.includes(p.id));
        favs?.sort((a, b)=>a.name.localeCompare(b.name));
        const notFavs = projectStore.projectList?.filter((p)=>!userStore.user?.favorite_project_ids?.includes(p.id));
        notFavs?.sort((a, b)=>a.name.localeCompare(b.name));
        setProjectList([
            ...favs || [],
            ...notFavs || []
        ]);
    }, [
        projectStore.projectList,
        userStore.user?.favorite_project_ids
    ]);
    (0, $2NacA.useEffect)(()=>{
        setFavorites(userStore.user?.favorite_project_ids || []);
    }, [
        userStore.user?.favorite_project_ids
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {
        children: projectStore.currentProject?.id && /*#__PURE__*/ (0, $6ir3O.jsx)((0, $d2VmQ.TalonTip), {
            content: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                children: "Select a project"
            }),
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                alignSelf: "center",
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l3pMM.Selector), {
                    options: projectList,
                    value: projectStore.currentProject.id,
                    onChange: (val)=>selectProject(val),
                    labelKey: (p)=>favorites.includes(p.id) ? /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $5xcHk.Box), {
                            direction: "row",
                            pad: "small",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $lhDdJ.FavoriteFilled), {
                                    filled: "true",
                                    size: "small"
                                }),
                                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $kS7Ii.Text), {
                                    size: "1rem",
                                    weight: 500,
                                    color: textColor,
                                    children: [
                                        "\xa0 ",
                                        p.name
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
                            pad: "small",
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $kS7Ii.Text), {
                                size: "1rem",
                                color: textColor,
                                children: p.name
                            })
                        })
                })
            })
        })
    });
});

});
parcelRegister("fMm8B", function(module, exports) {

$parcel$export(module.exports, "pathForProjectSwitch", () => $281608c27df1bfe7$export$611a0e20a2ea1e5f);

var $9Rhqc = parcelRequire("9Rhqc");
const $281608c27df1bfe7$export$611a0e20a2ea1e5f = (pathname, projectName)=>{
    const match = /^\/project\/[^/]+(?:\/([^/]+))?/.exec(pathname);
    if (!match) return undefined;
    const section = match[1];
    return `/project/${(0, $9Rhqc.kebabCase)(projectName)}${section ? `/${section}` : ''}`;
};

});



parcelRegister("2u4SD", function(module, exports) {

$parcel$export(module.exports, "QuickEstimatorMenu", () => $d2e2e56967b44815$export$2d901c7e08c4d778);

var $6ir3O = parcelRequire("6ir3O");

var $5xcHk = parcelRequire("5xcHk");
var $b5k5v = parcelRequire("b5k5v");

var $iPZh8 = parcelRequire("iPZh8");

var $2NacA = parcelRequire("2NacA");

var $hCRNV = parcelRequire("hCRNV");
const $d2e2e56967b44815$export$2d901c7e08c4d778 = ()=>{
    const [isMouseOver, setIsMouseOver] = (0, $2NacA.useState)(false);
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $b5k5v.DropButton), {
        icon: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $5xcHk.Box), {
            width: "24px",
            height: "24px",
            align: "center",
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $iPZh8.Calculator), {
                size: isMouseOver ? '24' : '20',
                color: "white"
            })
        }),
        onMouseOver: ()=>setIsMouseOver(true),
        onMouseOut: ()=>setIsMouseOver(false),
        tip: "Quick Estimator",
        dropContent: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $hCRNV.QuickEstimatorPanel), {}),
        dropAlign: {
            top: 'bottom',
            right: 'right'
        }
    });
};

});
parcelRegister("iPZh8", function(module, exports) {

$parcel$export(module.exports, "Calculator", () => $db6c8571bf06826e$export$770682f56f7e9e8f);

var $2NacA = parcelRequire("2NacA");

var $jKsP2 = parcelRequire("jKsP2");
function $db6c8571bf06826e$var$_extends() {
    return $db6c8571bf06826e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $db6c8571bf06826e$var$_extends.apply(null, arguments);
}
var $db6c8571bf06826e$export$770682f56f7e9e8f = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $jKsP2.StyledIcon), $db6c8571bf06826e$var$_extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Calculator"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 23H2V1h20v22zm-6-6h2v2h-2v-2zm-5 0h2v2h-2v-2zm5-5h2v2h-2v-2zm-5 0h2v2h-2v-2zm-5 5h2v2H6v-2zm0-5h2v2H6v-2zm12-3H6V5h12v4z"
    }));
});
$db6c8571bf06826e$export$770682f56f7e9e8f.displayName = 'Calculator';

});





parcelRegister("jhzFH", function(module, exports) {

$parcel$export(module.exports, "ProjectRoute", () => $5f2506ffaf057478$export$417c836002da5210);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $8DltC = parcelRequire("8DltC");
parcelRequire("ibR9R");
var $4mDQA = parcelRequire("4mDQA");
const $5f2506ffaf057478$export$417c836002da5210 = (0, $j8yBr.observer)(({ children: children })=>{
    /** Context */ const projectStore = (0, $8DltC.useProjectStore)();
    const params = (0, $19GAm.useParams)();
    const location = (0, $19GAm.useLocation)();
    /** State **/ const [destination, setDestination] = (0, $2NacA.useState)(undefined);
    /** Effects */ // The project list is normally fetched by ProjectSelector, which lives inside the page this
    // route wraps as `children` — but now that we hold off rendering `children` until loading is
    // done (see below), that fetch would never be kicked off on a direct navigation to a project
    // page (a hard refresh, a bookmark, a shared link), deadlocking on the loader forever.
    // fetchProjectList() is deduped against concurrent callers, so calling it here too is safe.
    (0, $2NacA.useEffect)(()=>{
        projectStore.fetchProjectList();
    }, [
        projectStore
    ]);
    (0, $2NacA.useEffect)(()=>{
        if (!projectStore.hasLoadedList) return;
        // Show the project the URL names, not whichever one happened to be current
        if (!params.projectName || !projectStore.openProjectByName(params.projectName)) setDestination('/');
        else setDestination(undefined);
    }, [
        projectStore.hasLoadedList,
        projectStore.projectList,
        params.projectName
    ]);
    /** Render */ // Every project-scoped page (Session Estimator, Edits, Hire Talent, ...) is wrapped in this
    // route — rendering `children` before the project list had loaded even once was why each one
    // showed a fully blank page for 1.5s+ on every navigation, with nothing telling the user it was
    // loading. This must key off hasLoadedList, not isLoadingList: isLoadingList legitimately flips
    // back to true on any later background refresh, which would unmount `children` again — and
    // since `children` is what mounts ProjectSelector, which itself calls fetchProjectList() on
    // mount, that unmount/remount became a self-sustaining infinite loop.
    if (!projectStore.hasLoadedList) return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4mDQA.Loader), {});
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {
        children: destination ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Navigate), {
            to: destination,
            state: {
                from: location
            },
            replace: true
        }) : children
    });
});

});

parcelRegister("l2NlU", function(module, exports) {

$parcel$export(module.exports, "RequireAuth", () => $7e6fede5dbe95511$export$8ef2ed426dede42d);

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("8CZ1O");
var $j8yBr = parcelRequire("j8yBr");

var $cyrqa = parcelRequire("cyrqa");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");

var $8DltC = parcelRequire("8DltC");

var $bsB3E = parcelRequire("bsB3E");
parcelRequire("ibR9R");
var $4mDQA = parcelRequire("4mDQA");
const $7e6fede5dbe95511$export$8ef2ed426dede42d = (0, $j8yBr.observer)(({ children: children, adminOnly: adminOnly, supportAgentOnly: supportAgentOnly })=>{
    /** Context **/ const { token: token, user: user, logout: logout, isBootstrapping: isBootstrapping } = (0, $8DltC.useUserStore)();
    const location = (0, $19GAm.useLocation)();
    /** State **/ const [destination, setDestination] = (0, $2NacA.useState)(undefined);
    /** Effects **/ (0, $2NacA.useEffect)(()=>{
        // The initial token/user restore from storage is still in flight — wait for it instead of
        // guessing from `token`/`user`'s transient placeholder values (see specs/unified-chat.md
        // BUG-4: `_user` starts as `{}` and `_jwt` starts as `''` regardless of whether a real
        // session exists, so those alone can't distinguish "still loading" from "logged out").
        if (isBootstrapping) return;
        const exp = $cyrqa.decode(token || '', {
            json: true
        })?.exp;
        const valid = exp ? exp * 1000 > Date.now() : false;
        if (!token || !valid) {
            setDestination('/login');
            logout();
            // Only claim a session "expired" if one actually existed — a first-time/logged-out
            // visitor with no token was never in a session to begin with.
            if (token) (0, $bsB3E.toast).error('Your session has expired. Please login again.', {
                toastId: 'session-expired'
            });
        } else if (adminOnly && !user.is_admin) setDestination('/');
        else if (supportAgentOnly && !user.is_admin && !user.is_support_agent) setDestination('/');
        else setDestination(undefined);
    }, [
        token,
        user,
        adminOnly,
        supportAgentOnly,
        logout,
        isBootstrapping
    ]);
    /** Render **/ if (isBootstrapping) return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4mDQA.Loader), {});
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6ir3O.Fragment), {
        children: destination ? /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Navigate), {
            to: destination,
            state: {
                from: location
            },
            replace: true
        }) : children
    });
});

});


parcelRegister("946wv", function(module, exports) {
module.exports = import("bKl9n").then(()=>parcelRequire('fCLZg'));

});

parcelRegister("3jWKN", function(module, exports) {
module.exports = Promise.all([
    import("10xXo"),
    import("jE1z7"),
    import("c82om")
]).then(()=>parcelRequire('cBWs6'));

});

parcelRegister("8ERa1", function(module, exports) {
module.exports = import("mkquk").then(()=>parcelRequire('dgQ08'));

});

parcelRegister("5m1jR", function(module, exports) {
module.exports = import("ilPYh").then(()=>parcelRequire('9qzTD'));

});

parcelRegister("6zwna", function(module, exports) {
module.exports = import("5OjJB").then(()=>parcelRequire('l2rfJ'));

});

parcelRegister("iQeEh", function(module, exports) {
module.exports = import("hsX1s").then(()=>parcelRequire('cMyck'));

});

parcelRegister("cDFuO", function(module, exports) {
module.exports = Promise.all([
    import("l6Iqp"),
    import("ilPap"),
    import("10xXo"),
    import("jy3p4")
]).then(()=>parcelRequire('9pKbr'));

});

parcelRegister("fespH", function(module, exports) {
module.exports = Promise.all([
    import("bfFIw"),
    import("jE1z7"),
    import("lWJbD")
]).then(()=>parcelRequire('jlACl'));

});

parcelRegister("6qU4c", function(module, exports) {
module.exports = import("bd0cq").then(()=>parcelRequire('iBWlH'));

});

parcelRegister("fxNwe", function(module, exports) {
module.exports = import("86gCz").then(()=>parcelRequire('3LFxo'));

});

parcelRegister("cQl2p", function(module, exports) {
module.exports = import("1cXTs").then(()=>parcelRequire('aIe6M'));

});

parcelRegister("fqUNa", function(module, exports) {
module.exports = import("8VG5s").then(()=>parcelRequire('9pmm4'));

});

parcelRegister("4EifC", function(module, exports) {
module.exports = import("9BHLm").then(()=>parcelRequire('mGwh7'));

});

parcelRegister("hNkwc", function(module, exports) {
module.exports = import("d7911").then(()=>parcelRequire('kQXbq'));

});

parcelRegister("eWT4Z", function(module, exports) {
module.exports = import("jDw96").then(()=>parcelRequire('7LmNE'));

});

parcelRegister("jrEIA", function(module, exports) {
module.exports = import("9OoD7").then(()=>parcelRequire('aWDFF'));

});

parcelRegister("hJz6y", function(module, exports) {
module.exports = import("3yCS8").then(()=>parcelRequire('gEzw8'));

});

parcelRegister("dfOZt", function(module, exports) {
module.exports = import("v4101").then(()=>parcelRequire('gPMIF'));

});

parcelRegister("1D1Vo", function(module, exports) {
module.exports = Promise.all([
    import("jE1z7"),
    import("l8c0w")
]).then(()=>parcelRequire('1LZe9'));

});

parcelRegister("ctibn", function(module, exports) {
module.exports = import("lM05b").then(()=>parcelRequire('adWhe'));

});

parcelRegister("h3TGg", function(module, exports) {
module.exports = import("kEVHQ").then(()=>parcelRequire('4fa2d'));

});

parcelRegister("295r1", function(module, exports) {
module.exports = Promise.all([
    import("l6Iqp"),
    import("10xXo"),
    import("ekwlW")
]).then(()=>parcelRequire('l4tcZ'));

});

parcelRegister("5LF8A", function(module, exports) {
module.exports = Promise.all([
    import("l6Iqp"),
    import("ilPap"),
    import("cBsd3")
]).then(()=>parcelRequire('4JmAC'));

});

parcelRegister("gxqXL", function(module, exports) {
module.exports = import("63T0M").then(()=>parcelRequire('8XbhX'));

});

parcelRegister("5Yrtl", function(module, exports) {
module.exports = import("gan7N").then(()=>parcelRequire('8Q2Gn'));

});

parcelRegister("60ySN", function(module, exports) {
module.exports = import("jggLh").then(()=>parcelRequire('7QTne'));

});

parcelRegister("4brn5", function(module, exports) {
module.exports = import("3OEfB").then(()=>parcelRequire('gEb2x'));

});

parcelRegister("hMHmi", function(module, exports) {
module.exports = import("g9qdx").then(()=>parcelRequire('bfLT1'));

});

parcelRegister("8f38z", function(module, exports) {
module.exports = import("cmt9w").then(()=>parcelRequire('eOSM8'));

});

parcelRegister("hgoXW", function(module, exports) {
module.exports = import("loi16").then(()=>parcelRequire('3QFQU'));

});

parcelRegister("3iG5C", function(module, exports) {
module.exports = import("b1Q2k").then(()=>parcelRequire('8kz2p'));

});

parcelRegister("5DWto", function(module, exports) {
module.exports = import("kiZ86").then(()=>parcelRequire('7UVkk'));

});

parcelRegister("l4IRN", function(module, exports) {
module.exports = import("3CfJt").then(()=>parcelRequire('2CFhM'));

});

parcelRegister("1phQ9", function(module, exports) {
module.exports = Promise.all([
    import("bfFIw"),
    import("jE1z7"),
    import("eFCtE")
]).then(()=>parcelRequire('6ch2S'));

});

parcelRegister("bUK0j", function(module, exports) {
module.exports = Promise.all([
    import("bfFIw"),
    import("jE1z7"),
    import("2dZvM")
]).then(()=>parcelRequire('kyZIN'));

});

parcelRegister("dMkMY", function(module, exports) {
module.exports = import("kUFZ7").then(()=>parcelRequire('dbgUk'));

});


var $6ir3O = parcelRequire("6ir3O");



var $2NacA = parcelRequire("2NacA");

var $f5efw = parcelRequire("f5efw");

var $cBNWv = parcelRequire("cBNWv");
var $4zRSZ = parcelRequire("4zRSZ");// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2NacA = parcelRequire("2NacA");

var $lwlwr = parcelRequire("lwlwr");

var $f5efw = parcelRequire("f5efw");

var $7rlLx = parcelRequire("7rlLx");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $2942eb878192a501$var$PropType = {};
var $2942eb878192a501$export$b969a6543dfc7938 = $2942eb878192a501$var$PropType;


(0, $f5efw.ThemeContext).Extend = function(_ref) {
    var children = _ref.children, value = _ref.value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f5efw.ThemeContext).Consumer, null, function(theme) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f5efw.ThemeContext).Provider, {
            value: (0, $7rlLx.deepMerge)(theme, value)
        }, children);
    });
};
(0, $f5efw.ThemeContext).Extend.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).node.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($lwlwr))).shape({}).isRequired
};
(0, $f5efw.ThemeContext).propTypes = (0, $2942eb878192a501$export$b969a6543dfc7938);


var $f5efw = parcelRequire("f5efw");

var $jQHd2 = parcelRequire("jQHd2");
var $7rlLx = parcelRequire("7rlLx");
var $hRaYF = parcelRequire("hRaYF");
var $d2fh4 = parcelRequire("d2fh4");
var $dOlbm = parcelRequire("dOlbm");

var $EOOZq = parcelRequire("EOOZq");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0

var $f5efw = parcelRequire("f5efw");

var $2O6LY = parcelRequire("2O6LY");
var $98779f23a21032a9$var$fullStyle = function fullStyle(full) {
    if (full === 'min') return (0, $f5efw.css)([
        "min-height:100vh;"
    ]);
    return (0, $f5efw.css)([
        "width:100vw;height:100vh;overflow:auto;"
    ]);
};
var $98779f23a21032a9$export$455b75b425a04280 = (0, $f5efw.default).div.withConfig((0, $2O6LY.styledComponentsConfig)).withConfig({
    displayName: "StyledGrommet",
    componentId: "sc-19lkkz7-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.plain && (0, $2O6LY.baseStyle);
}, function(props) {
    return props.full && $98779f23a21032a9$var$fullStyle(props.full);
}, function(props) {
    return props.theme.global.font.face;
}, function(props) {
    return props.theme.grommet.extend;
}, function(props) {
    return props.cssVars && Object.keys(props.theme.global.colors).filter(function(k) {
        return typeof props.theme.global.colors[k] === 'string';
    }).map(function(k) {
        return "--" + k + ": " + props.theme.global.colors[k] + ";";
    }).join('\n');
});



var $3ta7b = parcelRequire("3ta7b");

var $aHKsU = parcelRequire("aHKsU");

var $2M0UK = parcelRequire("2M0UK");

var $7JXYc = parcelRequire("7JXYc");
// SPDX-FileCopyrightText: © Hewlett Packard Enterprise Development LP
// SPDX-License-Identifier: Apache-2.0


var $e34da2ee9152ccd0$var$PropType = {};
var $e34da2ee9152ccd0$export$5d086f0c0fa8cc7a = $e34da2ee9152ccd0$var$PropType;



var $hbZKz = parcelRequire("hbZKz");
var $931301dcb7e659d7$var$_excluded = [
    "children",
    "full",
    "containerTarget",
    "theme",
    "options",
    "messages",
    "onAnalytics"
];
function $931301dcb7e659d7$var$_extends() {
    return $931301dcb7e659d7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $931301dcb7e659d7$var$_extends.apply(null, arguments);
}
function $931301dcb7e659d7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $931301dcb7e659d7$var$FullGlobalStyle = (0, $f5efw.createGlobalStyle)([
    "body{margin:0;}"
]);
var $931301dcb7e659d7$var$defaultOptions = {};
var $931301dcb7e659d7$export$efa1b86658154a31 = /*#__PURE__*/ (0, $2NacA.forwardRef)(function(props, ref) {
    var children = props.children, full = props.full, _props$containerTarge = props.containerTarget, containerTarget = _props$containerTarge === void 0 ? typeof document === 'object' ? document.body : undefined : _props$containerTarge, themeProp = props.theme, _props$options = props.options, options = _props$options === void 0 ? $931301dcb7e659d7$var$defaultOptions : _props$options, messagesProp = props.messages, onAnalytics = props.onAnalytics, rest = $931301dcb7e659d7$var$_objectWithoutPropertiesLoose(props, $931301dcb7e659d7$var$_excluded);
    var background = props.background, dir = props.dir, themeMode = props.themeMode, userAgent = props.userAgent;
    var _useState = (0, $2NacA.useState)(), stateResponsive = _useState[0], setResponsive = _useState[1];
    var theme = (0, $2NacA.useMemo)(function() {
        var nextTheme = (0, $7rlLx.deepMerge)((0, $EOOZq.base), themeProp || {});
        // if user provides specific menu alignment, we don't want
        // the defaults to be included at all (can cause issues with controlMirror)
        // override merged value with themeProp value
        if (themeProp && themeProp.menu && themeProp.menu.drop && themeProp.menu.drop.align) {
            delete nextTheme.menu.drop.align;
            nextTheme.menu.drop.align = themeProp.menu.drop.align;
        }
        var themeBackground = nextTheme.global.colors.background;
        nextTheme.dark = (themeMode || nextTheme.defaultMode) === 'dark';
        if (themeMode === 'auto' && typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) nextTheme.dark = true;
        var color = (0, $d2fh4.normalizeColor)(background || themeBackground, nextTheme);
        nextTheme.dark = (0, $jQHd2.backgroundIsDark)(color, nextTheme);
        nextTheme.baseBackground = background || themeBackground;
        // This allows DataTable to intelligently set the background of a pinned
        // header or footer.
        nextTheme.background = nextTheme.baseBackground;
        if (dir) nextTheme.dir = dir;
        return nextTheme;
    }, [
        background,
        dir,
        themeMode,
        themeProp
    ]);
    var messages = (0, $2NacA.useMemo)(function() {
        // combine the passed in messages, if any, with the default
        // messages and format function.
        var nextMessages = (0, $7rlLx.deepMerge)((0, (/*@__PURE__*/$parcel$interopDefault($7JXYc))), (messagesProp == null ? void 0 : messagesProp.messages) || {});
        return {
            messages: nextMessages,
            format: function format(opts) {
                var message = (messagesProp == null ? void 0 : messagesProp.format) && messagesProp.format(opts);
                return typeof message !== 'undefined' ? message : (0, $2M0UK.format)(opts, nextMessages);
            }
        };
    }, [
        messagesProp
    ]);
    (0, $2NacA.useEffect)(function() {
        var onResize = function onResize() {
            var _document$body$client, _document$body;
            setResponsive((0, $hRaYF.getBreakpoint)((_document$body$client = (_document$body = document.body) == null ? void 0 : _document$body.clientWidth) != null ? _document$body$client : window.innerWidth, theme));
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        theme
    ]);
    var responsive = stateResponsive || (0, $hRaYF.deviceResponsive)(userAgent, theme) || theme.global.deviceBreakpoints.tablet;
    var grommetRef = (0, $dOlbm.useForwardedRef)(ref);
    // track open FocusedContainers in a global array to manage
    // focus event listeners for trapFocus
    var roots = (0, $2NacA.useRef)([]);
    (0, $2NacA.useEffect)(function() {
        if (grommetRef.current) roots.current.push(grommetRef.current);
    }, [
        grommetRef
    ]);
    var rootsContextValue = (0, $2NacA.useMemo)(function() {
        return {
            roots: roots
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $f5efw.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $4zRSZ.ResponsiveContext).Provider, {
        value: responsive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $3ta7b.RootsContext).Provider, {
        value: rootsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $cBNWv.ContainerTargetContext).Provider, {
        value: containerTarget
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $aHKsU.OptionsContext).Provider, {
        value: options
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $2M0UK.MessageContext).Provider, {
        value: messages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $hbZKz.AnalyticsProvider), {
        onAnalytics: onAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement((0, $98779f23a21032a9$export$455b75b425a04280), $931301dcb7e659d7$var$_extends({
        full: full
    }, rest, {
        ref: grommetRef
    }), children), full && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).createElement($931301dcb7e659d7$var$FullGlobalStyle, null))))))));
});
$931301dcb7e659d7$export$efa1b86658154a31.displayName = 'Grommet';
$931301dcb7e659d7$export$efa1b86658154a31.propTypes = (0, $e34da2ee9152ccd0$export$5d086f0c0fa8cc7a);



var $6yQ9k = parcelRequire("6yQ9k");

var $2NacA = parcelRequire("2NacA");
var $e1988d2275c706ce$exports = {};

$parcel$export($e1988d2275c706ce$exports, "createRoot", () => $e1988d2275c706ce$export$882461b6382ed46c, (v) => $e1988d2275c706ce$export$882461b6382ed46c = v);
$parcel$export($e1988d2275c706ce$exports, "hydrateRoot", () => $e1988d2275c706ce$export$757ceba2d55c277e, (v) => $e1988d2275c706ce$export$757ceba2d55c277e = v);
var $e1988d2275c706ce$export$882461b6382ed46c;
var $e1988d2275c706ce$export$757ceba2d55c277e;
'use strict';

var $l6sdi = parcelRequire("l6sdi");
var $e1988d2275c706ce$var$i;
$e1988d2275c706ce$export$882461b6382ed46c = $l6sdi.createRoot;
$e1988d2275c706ce$export$757ceba2d55c277e = $l6sdi.hydrateRoot;



var $2NacA = parcelRequire("2NacA");
'use client';
const $12c845199c4ca3c4$export$b16d9fb1a22de840 = (0, $2NacA.createContext)(null);
const $12c845199c4ca3c4$var$initialState = {
    didCatch: false,
    error: null
};
class $12c845199c4ca3c4$export$e926676385687eaf extends (0, $2NacA.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $12c845199c4ca3c4$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($12c845199c4ca3c4$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $12c845199c4ca3c4$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($12c845199c4ca3c4$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $2NacA.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $2NacA.createElement)($12c845199c4ca3c4$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $12c845199c4ca3c4$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $12c845199c4ca3c4$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $12c845199c4ca3c4$export$c052f6604b7d51fe() {
    const context = (0, $2NacA.useContext)($12c845199c4ca3c4$export$b16d9fb1a22de840);
    $12c845199c4ca3c4$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $2NacA.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $2NacA.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $12c845199c4ca3c4$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $2NacA.forwardRef)((props, ref)=>(0, $2NacA.createElement)($12c845199c4ca3c4$export$e926676385687eaf, errorBoundaryProps, (0, $2NacA.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $19GAm = parcelRequire("19GAm");

var $bsB3E = parcelRequire("bsB3E");

parcelRequire("bRT7J");
var $45q4c = parcelRequire("45q4c");
var $jvR7E = parcelRequire("jvR7E");

var $8DltC = parcelRequire("8DltC");

var $1xNcM = parcelRequire("1xNcM");

var $6ir3O = parcelRequire("6ir3O");
parcelRequire("ibR9R");
var $4mDQA = parcelRequire("4mDQA");

var $2NacA = parcelRequire("2NacA");

var $19GAm = parcelRequire("19GAm");
parcelRequire("bRT7J");
var $jhzFH = parcelRequire("jhzFH");
var $l2NlU = parcelRequire("l2NlU");

const $043f87f23fd0da03$var$Home = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("946wv")));

const $043f87f23fd0da03$var$PerformerHome = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("3jWKN")));

const $043f87f23fd0da03$var$Login = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("8ERa1")));

const $043f87f23fd0da03$var$Notifications = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("5m1jR")));

const $043f87f23fd0da03$var$SessionEstimator = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("6zwna")));

const $043f87f23fd0da03$var$UsageEstimator = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("iQeEh")));

const $043f87f23fd0da03$var$HireTalent = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("cDFuO")));

const $043f87f23fd0da03$var$TimeTracking = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("fespH")));

const $043f87f23fd0da03$var$Estimate = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("6qU4c")));

const $043f87f23fd0da03$var$Resources = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("fxNwe")));

const $043f87f23fd0da03$var$Performers = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("cQl2p")));

const $043f87f23fd0da03$var$PerformerDashboard = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("fqUNa")));

const $043f87f23fd0da03$var$Profile = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("4EifC")));

const $043f87f23fd0da03$var$Account = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("hNkwc")));

const $043f87f23fd0da03$var$ProjectHome = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("eWT4Z")));

const $043f87f23fd0da03$var$ResetPassword = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("jrEIA")));

const $043f87f23fd0da03$var$Signup = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("hJz6y")));

const $043f87f23fd0da03$var$SignupReturn = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("dfOZt")));

const $043f87f23fd0da03$var$Admin = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("1D1Vo")));

const $043f87f23fd0da03$var$SupportInboxPage = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("ctibn")));

const $043f87f23fd0da03$var$ConfirmEmail = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("h3TGg")));

const $043f87f23fd0da03$var$OnboardingFlow = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("295r1")));

const $043f87f23fd0da03$var$CharacterCaptureMobile = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("5LF8A")));

const $043f87f23fd0da03$var$Payroll = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("gxqXL")));

const $043f87f23fd0da03$var$Edits = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("5Yrtl")));

const $043f87f23fd0da03$var$OAuthPopupClose = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("60ySN")));

const $043f87f23fd0da03$var$LicensingRights = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("4brn5")));

const $043f87f23fd0da03$var$HoldingFees = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("hMHmi")));

const $043f87f23fd0da03$var$PaySessions = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("8f38z")));

const $043f87f23fd0da03$var$AssetLibrary = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("hgoXW")));

const $043f87f23fd0da03$var$AssetDashboard = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("3iG5C")));

const $043f87f23fd0da03$var$Marketplace = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("5DWto")));

const $043f87f23fd0da03$var$MarketplaceProfile = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("l4IRN")));

const $043f87f23fd0da03$var$TmDashboard = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("1phQ9")));

const $043f87f23fd0da03$var$ProjectTalentManager = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("bUK0j")));

const $043f87f23fd0da03$var$TmSignup = /*#__PURE__*/ (0, $2NacA.lazy)(()=>(parcelRequire("dMkMY")));
const $043f87f23fd0da03$export$37d3279522fbf5e2 = ()=>{
    return /*#__PURE__*/ (0, $6ir3O.jsx)((0, $2NacA.Suspense), {
        fallback: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $4mDQA.Loader), {}),
        children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $19GAm.Routes), {
            children: [
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/login",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Login, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/signup",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Signup, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/tm-signup",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$TmSignup, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/signup/return",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$SignupReturn, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/group-invitation",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Signup, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/confirm",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$ConfirmEmail, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/reset-password",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$ResetPassword, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/onboarding/:token",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$OnboardingFlow, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/character-capture/:token",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$CharacterCaptureMobile, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/oauth-popup-close",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$OAuthPopupClose, {})
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/resources",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Resources, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/performers",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Performers, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/performers/:performerId",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$PerformerDashboard, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/profile",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Profile, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/account",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Account, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/admin",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        adminOnly: true,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Admin, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/support-inbox",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        supportAgentOnly: true,
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$SupportInboxPage, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Home, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $19GAm.Route), {
                    path: "/project/:projectName",
                    children: [
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$ProjectHome, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "estimate",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Estimate, {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                                path: ":estimateId",
                                element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Estimate, {})
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "session-estimator",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$SessionEstimator, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "usage-estimator",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$UsageEstimator, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "licensing-rights",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$LicensingRights, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "holding-fees",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$HoldingFees, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "hire-talent",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$HireTalent, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "hire-talent/:contractId",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$HireTalent, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "time-tracking",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$TimeTracking, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "pay-sessions",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$PaySessions, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "edits",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Edits, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "edits/:commercialId",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Edits, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "edits/:commercialId/:editId",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Edits, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "asset-library",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$AssetLibrary, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "asset-library/:assetId",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$AssetDashboard, {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                            path: "talent-manager",
                            element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $jhzFH.ProjectRoute), {
                                    children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$ProjectTalentManager, {})
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/notifications",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Notifications, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/performer-home",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$PerformerHome, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/payroll",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Payroll, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/marketplace",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$Marketplace, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/marketplace/:id",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$MarketplaceProfile, {})
                    })
                }),
                /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.Route), {
                    path: "/talent-manager",
                    element: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $l2NlU.RequireAuth), {
                        children: /*#__PURE__*/ (0, $6ir3O.jsx)($043f87f23fd0da03$var$TmDashboard, {})
                    })
                })
            ]
        })
    });
};



var $4Oriw = parcelRequire("4Oriw");

var $fsUjP = parcelRequire("fsUjP");
// Visible in devtools and read by the post-deploy smoke tests to confirm which build is live
window.__TALON_RELEASE__ = (0, $fsUjP.WEB_RELEASE);
console.info(`Talon web ${(0, $fsUjP.WEB_RELEASE)}`);
const { posthog: $70fc9a727fa662ae$var$posthog } = (0, $1xNcM.config).env;
const $70fc9a727fa662ae$var$root = document.getElementById('app');
$70fc9a727fa662ae$var$root && (0, (/*@__PURE__*/$parcel$interopDefault($e1988d2275c706ce$exports))).createRoot($70fc9a727fa662ae$var$root).render(/*#__PURE__*/ (0, $6ir3O.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2NacA))).StrictMode, {
    children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $6yQ9k.PostHogProvider), {
        apiKey: $70fc9a727fa662ae$var$posthog.api_key || '',
        options: $70fc9a727fa662ae$var$posthog.options,
        children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $12c845199c4ca3c4$export$e926676385687eaf), {
            FallbackComponent: (0, $jvR7E.ErrorFallback),
            children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $8DltC.RootContextProvider), {
                children: /*#__PURE__*/ (0, $6ir3O.jsx)((0, $19GAm.BrowserRouter), {
                    children: /*#__PURE__*/ (0, $6ir3O.jsxs)((0, $931301dcb7e659d7$export$efa1b86658154a31), {
                        theme: (0, $4Oriw.default),
                        className: "grommet-container",
                        children: [
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $043f87f23fd0da03$export$37d3279522fbf5e2), {}),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $45q4c.ChatWidget), {}),
                            /*#__PURE__*/ (0, $6ir3O.jsx)((0, $bsB3E.ToastContainer), {
                                position: "bottom-right"
                            })
                        ]
                    })
                })
            })
        })
    })
}));


//# sourceMappingURL=web.e68bda2f.js.map
